/******/ (function(modules) { // webpackBootstrap
/******/ 	var parentHotUpdateCallback = this["webpackHotUpdate"];
/******/ 	this["webpackHotUpdate"] = 
/******/ 	function webpackHotUpdateCallback(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		hotAddUpdateChunk(chunkId, moreModules);
/******/ 		if(parentHotUpdateCallback) parentHotUpdateCallback(chunkId, moreModules);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadUpdateChunk(chunkId) { // eslint-disable-line no-unused-vars
/******/ 		var head = document.getElementsByTagName("head")[0];
/******/ 		var script = document.createElement("script");
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = "utf-8";
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "." + hotCurrentHash + ".hot-update.js";
/******/ 		head.appendChild(script);
/******/ 	}
/******/ 	
/******/ 	function hotDownloadManifest(callback) { // eslint-disable-line no-unused-vars
/******/ 		if(typeof XMLHttpRequest === "undefined")
/******/ 			return callback(new Error("No browser support"));
/******/ 		try {
/******/ 			var request = new XMLHttpRequest();
/******/ 			var requestPath = __webpack_require__.p + "" + hotCurrentHash + ".hot-update.json";
/******/ 			request.open("GET", requestPath, true);
/******/ 			request.timeout = 10000;
/******/ 			request.send(null);
/******/ 		} catch(err) {
/******/ 			return callback(err);
/******/ 		}
/******/ 		request.onreadystatechange = function() {
/******/ 			if(request.readyState !== 4) return;
/******/ 			if(request.status === 0) {
/******/ 				// timeout
/******/ 				callback(new Error("Manifest request to " + requestPath + " timed out."));
/******/ 			} else if(request.status === 404) {
/******/ 				// no update available
/******/ 				callback();
/******/ 			} else if(request.status !== 200 && request.status !== 304) {
/******/ 				// other failure
/******/ 				callback(new Error("Manifest request to " + requestPath + " failed."));
/******/ 			} else {
/******/ 				// success
/******/ 				try {
/******/ 					var update = JSON.parse(request.responseText);
/******/ 				} catch(e) {
/******/ 					callback(e);
/******/ 					return;
/******/ 				}
/******/ 				callback(null, update);
/******/ 			}
/******/ 		};
/******/ 	}
/******/
/******/ 	
/******/ 	
/******/ 	// Copied from https://github.com/facebook/react/blob/bef45b0/src/shared/utils/canDefineProperty.js
/******/ 	var canDefineProperty = false;
/******/ 	try {
/******/ 		Object.defineProperty({}, "x", {
/******/ 			get: function() {}
/******/ 		});
/******/ 		canDefineProperty = true;
/******/ 	} catch(x) {
/******/ 		// IE will fail on defineProperty
/******/ 	}
/******/ 	
/******/ 	var hotApplyOnUpdate = true;
/******/ 	var hotCurrentHash = "541672731a5896db073f"; // eslint-disable-line no-unused-vars
/******/ 	var hotCurrentModuleData = {};
/******/ 	var hotCurrentParents = []; // eslint-disable-line no-unused-vars
/******/ 	
/******/ 	function hotCreateRequire(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var me = installedModules[moduleId];
/******/ 		if(!me) return __webpack_require__;
/******/ 		var fn = function(request) {
/******/ 			if(me.hot.active) {
/******/ 				if(installedModules[request]) {
/******/ 					if(installedModules[request].parents.indexOf(moduleId) < 0)
/******/ 						installedModules[request].parents.push(moduleId);
/******/ 					if(me.children.indexOf(request) < 0)
/******/ 						me.children.push(request);
/******/ 				} else hotCurrentParents = [moduleId];
/******/ 			} else {
/******/ 				console.warn("[HMR] unexpected require(" + request + ") from disposed module " + moduleId);
/******/ 				hotCurrentParents = [];
/******/ 			}
/******/ 			return __webpack_require__(request);
/******/ 		};
/******/ 		for(var name in __webpack_require__) {
/******/ 			if(Object.prototype.hasOwnProperty.call(__webpack_require__, name)) {
/******/ 				if(canDefineProperty) {
/******/ 					Object.defineProperty(fn, name, (function(name) {
/******/ 						return {
/******/ 							configurable: true,
/******/ 							enumerable: true,
/******/ 							get: function() {
/******/ 								return __webpack_require__[name];
/******/ 							},
/******/ 							set: function(value) {
/******/ 								__webpack_require__[name] = value;
/******/ 							}
/******/ 						};
/******/ 					}(name)));
/******/ 				} else {
/******/ 					fn[name] = __webpack_require__[name];
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		function ensure(chunkId, callback) {
/******/ 			if(hotStatus === "ready")
/******/ 				hotSetStatus("prepare");
/******/ 			hotChunksLoading++;
/******/ 			__webpack_require__.e(chunkId, function() {
/******/ 				try {
/******/ 					callback.call(null, fn);
/******/ 				} finally {
/******/ 					finishChunkLoading();
/******/ 				}
/******/ 	
/******/ 				function finishChunkLoading() {
/******/ 					hotChunksLoading--;
/******/ 					if(hotStatus === "prepare") {
/******/ 						if(!hotWaitingFilesMap[chunkId]) {
/******/ 							hotEnsureUpdateChunk(chunkId);
/******/ 						}
/******/ 						if(hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 							hotUpdateDownloaded();
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 			});
/******/ 		}
/******/ 		if(canDefineProperty) {
/******/ 			Object.defineProperty(fn, "e", {
/******/ 				enumerable: true,
/******/ 				value: ensure
/******/ 			});
/******/ 		} else {
/******/ 			fn.e = ensure;
/******/ 		}
/******/ 		return fn;
/******/ 	}
/******/ 	
/******/ 	function hotCreateModule(moduleId) { // eslint-disable-line no-unused-vars
/******/ 		var hot = {
/******/ 			// private stuff
/******/ 			_acceptedDependencies: {},
/******/ 			_declinedDependencies: {},
/******/ 			_selfAccepted: false,
/******/ 			_selfDeclined: false,
/******/ 			_disposeHandlers: [],
/******/ 	
/******/ 			// Module API
/******/ 			active: true,
/******/ 			accept: function(dep, callback) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfAccepted = true;
/******/ 				else if(typeof dep === "function")
/******/ 					hot._selfAccepted = dep;
/******/ 				else if(typeof dep === "object")
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._acceptedDependencies[dep[i]] = callback;
/******/ 				else
/******/ 					hot._acceptedDependencies[dep] = callback;
/******/ 			},
/******/ 			decline: function(dep) {
/******/ 				if(typeof dep === "undefined")
/******/ 					hot._selfDeclined = true;
/******/ 				else if(typeof dep === "number")
/******/ 					hot._declinedDependencies[dep] = true;
/******/ 				else
/******/ 					for(var i = 0; i < dep.length; i++)
/******/ 						hot._declinedDependencies[dep[i]] = true;
/******/ 			},
/******/ 			dispose: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			addDisposeHandler: function(callback) {
/******/ 				hot._disposeHandlers.push(callback);
/******/ 			},
/******/ 			removeDisposeHandler: function(callback) {
/******/ 				var idx = hot._disposeHandlers.indexOf(callback);
/******/ 				if(idx >= 0) hot._disposeHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			// Management API
/******/ 			check: hotCheck,
/******/ 			apply: hotApply,
/******/ 			status: function(l) {
/******/ 				if(!l) return hotStatus;
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			addStatusHandler: function(l) {
/******/ 				hotStatusHandlers.push(l);
/******/ 			},
/******/ 			removeStatusHandler: function(l) {
/******/ 				var idx = hotStatusHandlers.indexOf(l);
/******/ 				if(idx >= 0) hotStatusHandlers.splice(idx, 1);
/******/ 			},
/******/ 	
/******/ 			//inherit from previous dispose call
/******/ 			data: hotCurrentModuleData[moduleId]
/******/ 		};
/******/ 		return hot;
/******/ 	}
/******/ 	
/******/ 	var hotStatusHandlers = [];
/******/ 	var hotStatus = "idle";
/******/ 	
/******/ 	function hotSetStatus(newStatus) {
/******/ 		hotStatus = newStatus;
/******/ 		for(var i = 0; i < hotStatusHandlers.length; i++)
/******/ 			hotStatusHandlers[i].call(null, newStatus);
/******/ 	}
/******/ 	
/******/ 	// while downloading
/******/ 	var hotWaitingFiles = 0;
/******/ 	var hotChunksLoading = 0;
/******/ 	var hotWaitingFilesMap = {};
/******/ 	var hotRequestedFilesMap = {};
/******/ 	var hotAvailibleFilesMap = {};
/******/ 	var hotCallback;
/******/ 	
/******/ 	// The update info
/******/ 	var hotUpdate, hotUpdateNewHash;
/******/ 	
/******/ 	function toModuleId(id) {
/******/ 		var isNumber = (+id) + "" === id;
/******/ 		return isNumber ? +id : id;
/******/ 	}
/******/ 	
/******/ 	function hotCheck(apply, callback) {
/******/ 		if(hotStatus !== "idle") throw new Error("check() is only allowed in idle status");
/******/ 		if(typeof apply === "function") {
/******/ 			hotApplyOnUpdate = false;
/******/ 			callback = apply;
/******/ 		} else {
/******/ 			hotApplyOnUpdate = apply;
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 		hotSetStatus("check");
/******/ 		hotDownloadManifest(function(err, update) {
/******/ 			if(err) return callback(err);
/******/ 			if(!update) {
/******/ 				hotSetStatus("idle");
/******/ 				callback(null, null);
/******/ 				return;
/******/ 			}
/******/ 	
/******/ 			hotRequestedFilesMap = {};
/******/ 			hotAvailibleFilesMap = {};
/******/ 			hotWaitingFilesMap = {};
/******/ 			for(var i = 0; i < update.c.length; i++)
/******/ 				hotAvailibleFilesMap[update.c[i]] = true;
/******/ 			hotUpdateNewHash = update.h;
/******/ 	
/******/ 			hotSetStatus("prepare");
/******/ 			hotCallback = callback;
/******/ 			hotUpdate = {};
/******/ 			var chunkId = 0;
/******/ 			{ // eslint-disable-line no-lone-blocks
/******/ 				/*globals chunkId */
/******/ 				hotEnsureUpdateChunk(chunkId);
/******/ 			}
/******/ 			if(hotStatus === "prepare" && hotChunksLoading === 0 && hotWaitingFiles === 0) {
/******/ 				hotUpdateDownloaded();
/******/ 			}
/******/ 		});
/******/ 	}
/******/ 	
/******/ 	function hotAddUpdateChunk(chunkId, moreModules) { // eslint-disable-line no-unused-vars
/******/ 		if(!hotAvailibleFilesMap[chunkId] || !hotRequestedFilesMap[chunkId])
/******/ 			return;
/******/ 		hotRequestedFilesMap[chunkId] = false;
/******/ 		for(var moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				hotUpdate[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(--hotWaitingFiles === 0 && hotChunksLoading === 0) {
/******/ 			hotUpdateDownloaded();
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotEnsureUpdateChunk(chunkId) {
/******/ 		if(!hotAvailibleFilesMap[chunkId]) {
/******/ 			hotWaitingFilesMap[chunkId] = true;
/******/ 		} else {
/******/ 			hotRequestedFilesMap[chunkId] = true;
/******/ 			hotWaitingFiles++;
/******/ 			hotDownloadUpdateChunk(chunkId);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotUpdateDownloaded() {
/******/ 		hotSetStatus("ready");
/******/ 		var callback = hotCallback;
/******/ 		hotCallback = null;
/******/ 		if(!callback) return;
/******/ 		if(hotApplyOnUpdate) {
/******/ 			hotApply(hotApplyOnUpdate, callback);
/******/ 		} else {
/******/ 			var outdatedModules = [];
/******/ 			for(var id in hotUpdate) {
/******/ 				if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 					outdatedModules.push(toModuleId(id));
/******/ 				}
/******/ 			}
/******/ 			callback(null, outdatedModules);
/******/ 		}
/******/ 	}
/******/ 	
/******/ 	function hotApply(options, callback) {
/******/ 		if(hotStatus !== "ready") throw new Error("apply() is only allowed in ready status");
/******/ 		if(typeof options === "function") {
/******/ 			callback = options;
/******/ 			options = {};
/******/ 		} else if(options && typeof options === "object") {
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		} else {
/******/ 			options = {};
/******/ 			callback = callback || function(err) {
/******/ 				if(err) throw err;
/******/ 			};
/******/ 		}
/******/ 	
/******/ 		function getAffectedStuff(module) {
/******/ 			var outdatedModules = [module];
/******/ 			var outdatedDependencies = {};
/******/ 	
/******/ 			var queue = outdatedModules.slice();
/******/ 			while(queue.length > 0) {
/******/ 				var moduleId = queue.pop();
/******/ 				var module = installedModules[moduleId];
/******/ 				if(!module || module.hot._selfAccepted)
/******/ 					continue;
/******/ 				if(module.hot._selfDeclined) {
/******/ 					return new Error("Aborted because of self decline: " + moduleId);
/******/ 				}
/******/ 				if(moduleId === 0) {
/******/ 					return;
/******/ 				}
/******/ 				for(var i = 0; i < module.parents.length; i++) {
/******/ 					var parentId = module.parents[i];
/******/ 					var parent = installedModules[parentId];
/******/ 					if(parent.hot._declinedDependencies[moduleId]) {
/******/ 						return new Error("Aborted because of declined dependency: " + moduleId + " in " + parentId);
/******/ 					}
/******/ 					if(outdatedModules.indexOf(parentId) >= 0) continue;
/******/ 					if(parent.hot._acceptedDependencies[moduleId]) {
/******/ 						if(!outdatedDependencies[parentId])
/******/ 							outdatedDependencies[parentId] = [];
/******/ 						addAllToSet(outdatedDependencies[parentId], [moduleId]);
/******/ 						continue;
/******/ 					}
/******/ 					delete outdatedDependencies[parentId];
/******/ 					outdatedModules.push(parentId);
/******/ 					queue.push(parentId);
/******/ 				}
/******/ 			}
/******/ 	
/******/ 			return [outdatedModules, outdatedDependencies];
/******/ 		}
/******/ 	
/******/ 		function addAllToSet(a, b) {
/******/ 			for(var i = 0; i < b.length; i++) {
/******/ 				var item = b[i];
/******/ 				if(a.indexOf(item) < 0)
/******/ 					a.push(item);
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// at begin all updates modules are outdated
/******/ 		// the "outdated" status can propagate to parents if they don't accept the children
/******/ 		var outdatedDependencies = {};
/******/ 		var outdatedModules = [];
/******/ 		var appliedUpdate = {};
/******/ 		for(var id in hotUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(hotUpdate, id)) {
/******/ 				var moduleId = toModuleId(id);
/******/ 				var result = getAffectedStuff(moduleId);
/******/ 				if(!result) {
/******/ 					if(options.ignoreUnaccepted)
/******/ 						continue;
/******/ 					hotSetStatus("abort");
/******/ 					return callback(new Error("Aborted because " + moduleId + " is not accepted"));
/******/ 				}
/******/ 				if(result instanceof Error) {
/******/ 					hotSetStatus("abort");
/******/ 					return callback(result);
/******/ 				}
/******/ 				appliedUpdate[moduleId] = hotUpdate[moduleId];
/******/ 				addAllToSet(outdatedModules, result[0]);
/******/ 				for(var moduleId in result[1]) {
/******/ 					if(Object.prototype.hasOwnProperty.call(result[1], moduleId)) {
/******/ 						if(!outdatedDependencies[moduleId])
/******/ 							outdatedDependencies[moduleId] = [];
/******/ 						addAllToSet(outdatedDependencies[moduleId], result[1][moduleId]);
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Store self accepted outdated modules to require them later by the module system
/******/ 		var outdatedSelfAcceptedModules = [];
/******/ 		for(var i = 0; i < outdatedModules.length; i++) {
/******/ 			var moduleId = outdatedModules[i];
/******/ 			if(installedModules[moduleId] && installedModules[moduleId].hot._selfAccepted)
/******/ 				outdatedSelfAcceptedModules.push({
/******/ 					module: moduleId,
/******/ 					errorHandler: installedModules[moduleId].hot._selfAccepted
/******/ 				});
/******/ 		}
/******/ 	
/******/ 		// Now in "dispose" phase
/******/ 		hotSetStatus("dispose");
/******/ 		var queue = outdatedModules.slice();
/******/ 		while(queue.length > 0) {
/******/ 			var moduleId = queue.pop();
/******/ 			var module = installedModules[moduleId];
/******/ 			if(!module) continue;
/******/ 	
/******/ 			var data = {};
/******/ 	
/******/ 			// Call dispose handlers
/******/ 			var disposeHandlers = module.hot._disposeHandlers;
/******/ 			for(var j = 0; j < disposeHandlers.length; j++) {
/******/ 				var cb = disposeHandlers[j];
/******/ 				cb(data);
/******/ 			}
/******/ 			hotCurrentModuleData[moduleId] = data;
/******/ 	
/******/ 			// disable module (this disables requires from this module)
/******/ 			module.hot.active = false;
/******/ 	
/******/ 			// remove module from cache
/******/ 			delete installedModules[moduleId];
/******/ 	
/******/ 			// remove "parents" references from all children
/******/ 			for(var j = 0; j < module.children.length; j++) {
/******/ 				var child = installedModules[module.children[j]];
/******/ 				if(!child) continue;
/******/ 				var idx = child.parents.indexOf(moduleId);
/******/ 				if(idx >= 0) {
/******/ 					child.parents.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// remove outdated dependency from module children
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				for(var j = 0; j < moduleOutdatedDependencies.length; j++) {
/******/ 					var dependency = moduleOutdatedDependencies[j];
/******/ 					var idx = module.children.indexOf(dependency);
/******/ 					if(idx >= 0) module.children.splice(idx, 1);
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Not in "apply" phase
/******/ 		hotSetStatus("apply");
/******/ 	
/******/ 		hotCurrentHash = hotUpdateNewHash;
/******/ 	
/******/ 		// insert new code
/******/ 		for(var moduleId in appliedUpdate) {
/******/ 			if(Object.prototype.hasOwnProperty.call(appliedUpdate, moduleId)) {
/******/ 				modules[moduleId] = appliedUpdate[moduleId];
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// call accept handlers
/******/ 		var error = null;
/******/ 		for(var moduleId in outdatedDependencies) {
/******/ 			if(Object.prototype.hasOwnProperty.call(outdatedDependencies, moduleId)) {
/******/ 				var module = installedModules[moduleId];
/******/ 				var moduleOutdatedDependencies = outdatedDependencies[moduleId];
/******/ 				var callbacks = [];
/******/ 				for(var i = 0; i < moduleOutdatedDependencies.length; i++) {
/******/ 					var dependency = moduleOutdatedDependencies[i];
/******/ 					var cb = module.hot._acceptedDependencies[dependency];
/******/ 					if(callbacks.indexOf(cb) >= 0) continue;
/******/ 					callbacks.push(cb);
/******/ 				}
/******/ 				for(var i = 0; i < callbacks.length; i++) {
/******/ 					var cb = callbacks[i];
/******/ 					try {
/******/ 						cb(outdatedDependencies);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// Load self accepted modules
/******/ 		for(var i = 0; i < outdatedSelfAcceptedModules.length; i++) {
/******/ 			var item = outdatedSelfAcceptedModules[i];
/******/ 			var moduleId = item.module;
/******/ 			hotCurrentParents = [moduleId];
/******/ 			try {
/******/ 				__webpack_require__(moduleId);
/******/ 			} catch(err) {
/******/ 				if(typeof item.errorHandler === "function") {
/******/ 					try {
/******/ 						item.errorHandler(err);
/******/ 					} catch(err) {
/******/ 						if(!error)
/******/ 							error = err;
/******/ 					}
/******/ 				} else if(!error)
/******/ 					error = err;
/******/ 			}
/******/ 		}
/******/ 	
/******/ 		// handle errors in accept handlers and self accepted module load
/******/ 		if(error) {
/******/ 			hotSetStatus("fail");
/******/ 			return callback(error);
/******/ 		}
/******/ 	
/******/ 		hotSetStatus("idle");
/******/ 		callback(null, outdatedModules);
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			hot: hotCreateModule(moduleId),
/******/ 			parents: hotCurrentParents,
/******/ 			children: []
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, hotCreateRequire(moduleId));
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// __webpack_hash__
/******/ 	__webpack_require__.h = function() { return hotCurrentHash; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return hotCreateRequire(0)(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    Router = __webpack_require__(19),
	    packageJson = __webpack_require__(312),
	    DashboardModal = __webpack_require__(719),
	    DashboardModalEl = __webpack_require__(180),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Route = Router.Route,
	    RouteHandler = Router.RouteHandler,
	    DefaultRoute = Router.DefaultRoute,
	    NotFoundRoute = Router.NotFoundRoute,
	    Constants = __webpack_require__(2),
	    SessionStore = __webpack_require__(11),
	    UserPermissionStore = __webpack_require__(184),
	    Security = __webpack_require__(13).auth,
	    NumberUtils = __webpack_require__(23),
	    NotificationEl = __webpack_require__(21),
	    CustomDialogEl = __webpack_require__(26),
	    CustomContextMenu = __webpack_require__(708),
	    ContextMenuEl = __webpack_require__(152),
	    Dialog = __webpack_require__(709),
	    ScrollLock = __webpack_require__(715),
	    UIStateStore = __webpack_require__(183),
	    Dashboard = __webpack_require__(758),
	    DashboardSpinnerEl = __webpack_require__(156),
	    DashboardSpinner = __webpack_require__(759),
	    Notification = __webpack_require__(731),
	    NotFound = __webpack_require__(775),
	    ReportByBeerStyle = __webpack_require__(784),
	    ReportByProduct = __webpack_require__(786),
	    ReportOrderByBatchNumber = __webpack_require__(788),
	    ReportByTask = __webpack_require__(787),
	    ReportByItemTransaction = __webpack_require__(785),
	    ReportAdmin = __webpack_require__(783),
	    TankAdmin = __webpack_require__(793),
	    StyleBeer = __webpack_require__(749),
	    ItemsAdmin = __webpack_require__(772),
	    NonInventoryItemsAdmin = __webpack_require__(773),
	    SalesAdmin = __webpack_require__(789),
	    SalesItemsAdmin = __webpack_require__(790),
	    CustomerAdmin = __webpack_require__(755),
	    CustomerAddressAdmin = __webpack_require__(754),
	    UserAccessAdmin = __webpack_require__(794),
	    UserAdmin = __webpack_require__(795),
	    CustomerContactAdmin = __webpack_require__(756),
	    CustomerItemAdmin = __webpack_require__(757),
	    IconsAndSectionsAdmin = __webpack_require__(768),
	    IconsAdmin = __webpack_require__(767),
	    PasswordRecovery = __webpack_require__(776),
	    ProcessAdmin = __webpack_require__(778),
	    ProductsAdmin = __webpack_require__(782),
	    ProductItemsAdditionAdmin = __webpack_require__(780),
	    ProductItemsAdmin = __webpack_require__(781),
	    LocationAdmin = __webpack_require__(774),
	    InventoryAndTransfersAdmin = __webpack_require__(770),
	    VendorAdmin = __webpack_require__(797),
	    VendorAddressAdmin = __webpack_require__(796),
	    VendorContactAdmin = __webpack_require__(798),
	    VendorItemsAdmin = __webpack_require__(799),
	    VendorPurchaseAdmin = __webpack_require__(800),
	    VendorPurchaseItemAdmin = __webpack_require__(801),
	    VendorReceiveItemAdmin = __webpack_require__(802),
	    HistoryAdmin = __webpack_require__(763),
	    ProductIconsAdmin = __webpack_require__(779),
	    CheckEmailResetPassword = __webpack_require__(751),
	    ConfirmationResetPassword = __webpack_require__(752),
	    BeerStyleConfigurationAdmin = __webpack_require__(750),
	    Contact = __webpack_require__(753),
	    Help = __webpack_require__(762),
	    Login = __webpack_require__(791),
	    Welcome = __webpack_require__(803),
	    EmailConfirmed = __webpack_require__(761),
	    PreActivated = __webpack_require__(777),
	    SignUp = __webpack_require__(792),
	    _require2 = __webpack_require__(12),
	    LeftNav = _require2.LeftNav,
	    Styles = _require2.Styles,
	    _require3 = __webpack_require__(404),
	    Header = _require3.Header,
	    HeaderWithBanner = __webpack_require__(728),
	    ThemeManager = Styles.ThemeManager(),
	    Colors = Styles.Colors,
	    ga = __webpack_require__(18);
	
	
	SessionStore.isFullPaidVersion() ? __webpack_require__(1354) : __webpack_require__(1355);
	__webpack_require__(1313);
	__webpack_require__(1352);
	__webpack_require__(1356);
	__webpack_require__(1351);
	__webpack_require__(1353);
	
	//////////////////////////////////////////////////////////////////////////
	// SENTRY START
	/////////////////////////////////////////////////////////////////////////
	try {
	
	    var environment = location.href.includes('localhost') || location.href.includes('127.0.0.1') ? 'dev' : location.href.includes('stage') ? 'stage' : 'prod';
	
	    if (Sentry && environment === 'prod') {
	        // defined via function hoisting
	        var reportingConsoleError = function reportingConsoleError() {
	            var args = Array.prototype.slice.call(arguments);
	            Sentry.captureException(reduceConsoleArgs(args), { level: 'error' });
	            return oldConsoleError.apply(console, args);
	        };
	
	        /*var oldConsoleWarn = console.warn;
	        console.warn = reportingConsoleWarn; // defined via function hoisting
	        function reportingConsoleWarn() {
	          var args = Array.prototype.slice.call(arguments);
	          Sentry.captureMessage(reduceConsoleArgs(args), { level: 'warning' });
	          return oldConsoleWarn.apply(console, args);
	        }*/
	
	        var reduceConsoleArgs = function reduceConsoleArgs(args) {
	            var userInfo = sessionStorage && sessionStorage.getItem ? ' || [' + sessionStorage.getItem('cache_user_name') + ' - ' + sessionStorage.getItem('cache_applicant_id') + ' - ' + sessionStorage.getItem('cache_applicant_license') + ']' : '';
	            var errorMsg = args[0];
	            // Make sure errorMsg is either an error or string.
	            // It's therefore best to pass in new Error('msg') instead of just 'msg' since
	            // that'll give you a stack trace leading up to the creation of that new Error
	            // whereas if you just pass in a plain string 'msg', the stack trace will include
	            // reportingConsoleError and reportingConsoleCall
	            if (!(errorMsg instanceof Error)) {
	                // stringify all args as a new Error (which creates a stack trace)
	                errorMsg = new Error(args.reduce(function (accumulator, currentValue) {
	                    return accumulator.toString() + ' ' + currentValue.toString();
	                }, '') + userInfo);
	            }
	            return errorMsg;
	        };
	
	        Sentry.init({
	            dsn: "https://0ff9ff73324d4596a47d71ef838ea0c5@o284357.ingest.sentry.io/5645076",
	            release: "bp-dashboard@" + packageJson.version,
	            integrations: [new Sentry.Integrations.BrowserTracing()],
	            environment: environment,
	            // We recommend adjusting this value in production, or using tracesSampler
	            // for finer control
	            tracesSampleRate: 1.0
	        });
	
	        var oldConsoleError = console.error;
	        console.error = reportingConsoleError;
	    }
	} catch (err) {
	    console.error('something went wrong when try to load Sentry', err);
	}
	
	//////////////////////////////////////////////////////////////////////////
	// SENTRY END
	/////////////////////////////////////////////////////////////////////////
	
	/*
	 * Initialize Google Analytics
	 */
	ga.initialize(({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).GOOGLE_ANALYTICS, { debug: true });
	
	Object.assign = Object.assign || __webpack_require__(74);
	
	/*
	 * Need Material-UI
	 */
	var injectTapEventPlugin = __webpack_require__(1224);
	injectTapEventPlugin();
	
	ThemeManager.setTheme(ThemeManager.types.LIGHT);
	
	var HeaderSideBar = React.createClass({ displayName: "HeaderSideBar",
	    render: function render() {
	        return React.createElement("div", { className: "nav-bar-header hidden-xs" }, React.createElement("img", { width: "180", height: "60", src: "/assets/images/logo-small.png" }), Security.loggedIn() ? React.createElement("div", null, React.createElement("hr", null), React.createElement("div", null, SessionStore.getApplicantDisplayName())) : null);
	    }
	});
	
	var App = React.createClass({ displayName: "App",
	
	    getInitialState: function getInitialState() {
	        return _extends({}, SessionStore.getSessionData(), { isSidebarOpen: false });
	    },
	
	
	    contextTypes: {
	        router: React.PropTypes.func
	    },
	
	    childContextTypes: {
	        muiTheme: React.PropTypes.object
	    },
	
	    getChildContext: function getChildContext() {
	        return {
	            muiTheme: ThemeManager.getCurrentTheme()
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        SessionStore.addChangeListener(this._onChange);
	        UIStateStore.addChangeListener(this._onChange);
	        ThemeManager.setPalette({
	            coloraccent1Color: Colors.lightBlue900,
	            tableRow: {
	                selected: 'red'
	            }
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this.refs.leftNav.close();
	        NotificationEl.setElement(this.refs.notificationEl);
	        CustomDialogEl.setElement(this.refs.customDialogEl);
	        DashboardModalEl.setElement(this.refs.modalOrder);
	        ContextMenuEl.setElement(this.refs.contextMenuEl);
	        DashboardSpinnerEl.setElement(this.refs.dashboardSpinnerEl);
	
	        SessionStore.fetchUserInformationAndSaveIfNeeded(function () {
	            NumberUtils.initializeFormat();
	        });
	
	        // Once i18next is load refresh the react component
	        document.addEventListener('i18nextLoaded', function () {
	            _this.forceUpdate();
	        });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        SessionStore.removeChangeListener(this._onChange);
	        UIStateStore.removeChangeListener(this._onChange);
	    },
	    _onChange: function _onChange() {
	        this.setState(SessionStore.getSessionData());
	        //sync data between stores. (need to be refectored)
	    },
	    _onLeftNavChange: function _onLeftNavChange(e, key, payload) {
	        e.preventDefault();
	        if (SessionStore.isFullPaidVersion()) {
	            this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
	        } else {
	            if (key > 5) {
	                var tab = window.open(Constants.GO_PRO_URL, '_blank');
	                tab.focus();
	            } else {
	                this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
	            }
	        }
	    },
	    _onTouchLeftMenuBar: function _onTouchLeftMenuBar() {
	        this.refs.leftNav.toggle();
	        this._toggleStateSideber();
	    },
	    _onTouchRightMenuBar: function _onTouchRightMenuBar() {
	        this.refs.rightMenu.open();
	    },
	    _toggleStateSideber: function _toggleStateSideber() {
	        this.setState(function (prevState) {
	            return {
	                isSidebarOpen: !prevState.isSidebarOpen
	            };
	        });
	    },
	    render: function render() {
	
	        var fullVersionSidebarItems = [{ route: 'tanks/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_tanks_sections'), iconClassName: 'icon-bar icon-tanks-sections', permission: 'ADMIN_TANK_SHOW' }, { route: 'styleBeer', text: t('dashboard_sidebar_beer_styles'), iconClassName: 'icon-bar icon-beer-style-page-icon', permission: 'ADMIN_BEER_STYLE_SHOW' }, { route: 'items/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_items'), iconClassName: 'icon-bar icon-ingredients', permission: 'ADMIN_ITEM_SHOW' }, { route: 'non-inventory-items', text: t('dashboard_sidebar_non_inventory_items'), iconClassName: 'icon-bar icon-ingredients', permission: 'ADMIN_ITEM_SHOW' }, { route: 'products', text: t('dashboard_sidebar_products'), iconClassName: 'icon-bar icon-group-ingredients', permission: 'ADMIN_PRODUCT_SHOW' }, { route: 'location-item/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_inventory_transfers'), iconClassName: 'icon-bar icon-inventory-and-tranfers', permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW' }, { route: 'vendors', text: t('dashboard_sidebar_suppliers'), iconClassName: 'icon-bar icon-vendors', permission: 'ADMIN_VENDOR_SHOW' }, { route: 'purchase-item/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_purchase_items'), iconClassName: 'icon-bar icon-purchase-items', permission: 'ADMIN_PURCHASE_SHOW' }, { route: 'customers', text: t('dashboard_sidebar_customers'), iconClassName: 'icon-bar icon-customers', permission: 'ADMIN_CUSTOMER_SHOW' }, { route: 'sales/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_sales_orders'), iconClassName: 'icon-bar icon-Sales-order', permission: 'ADMIN_SALE_SHOW' }, { route: 'location', text: t('dashboard_sidebar_locations'), iconClassName: 'icon-bar icon-locations', permission: 'ADMIN_LOCATION_SHOW' }, { route: 'icons-sections', text: t('dashboard_sidebar_icons_in_sections'), iconClassName: 'icon-bar icon-select-icon', permission: 'ADMIN_ICON_SHOW' }, { route: 'user', text: t('dashboard_sidebar_users'), iconClassName: 'icon-bar icon-user-access', permission: 'ADMIN_USER_PERMISSION_SHOW' }, { route: 'user-permissions', text: t('dsahboard_sidebar_user_access'), iconClassName: 'icon-bar icon-user-access', permission: 'ADMIN_USER_PERMISSION_SHOW' }, { route: 'reports', text: t('dashboard_sidebar_reports'), iconClassName: 'icon-bar icon-reports', permission: 'ADMIN_REPORT_SHOW' }, { route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process', permission: 'ADMIN_TASK_SHOW' }, { route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page' // public permission
	        }];
	
	        var baseVersionSidebarItems = [{ route: 'tanks/page/:page', param: { page: 0 }, text: t('dashboard_sidebar_tanks_sections'), iconClassName: 'icon-bar icon-tanks-sections', permission: 'ADMIN_TANK_SHOW' }, { route: 'styleBeer', text: t('dashboard_sidebar_beer_styles'), iconClassName: 'icon-bar icon-beer-style-page-icon', permission: 'ADMIN_BEER_STYLE_SHOW' }, { route: 'icons-sections', text: t('dashboard_sidebar_icons_in_sections'), iconClassName: 'icon-bar icon-select-icon', permission: 'ADMIN_ICON_SHOW' }, { route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process', permission: 'ADMIN_TASK_SHOW' }, { route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page' }, // public permission
	        { route: '', param: { page: 0 }, text: t('dashboard_sidebar_items'), iconClassName: 'icon-bar icon-ingredients is-pro-version', permission: 'ADMIN_ITEM_SHOW' }, { route: '', text: t('dashboard_sidebar_non_inventory_items'), iconClassName: 'icon-bar icon-ingredients is-pro-version', permission: 'ADMIN_ITEM_SHOW' }, { route: '', text: t('dashboard_sidebar_products'), iconClassName: 'icon-bar icon-group-ingredients is-pro-version', permission: 'ADMIN_PRODUCT_SHOW' }, { route: '', param: { page: 0 }, text: t('dashboard_sidebar_inventory_transfers'), iconClassName: 'icon-bar icon-inventory-and-tranfers is-pro-version', permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW' }, { route: '', text: t('dashboard_sidebar_suppliers'), iconClassName: 'icon-bar icon-vendors is-pro-version', permission: 'ADMIN_VENDOR_SHOW' }, { route: '', param: { page: 0 }, text: t('dashboard_sidebar_purchase_items'), iconClassName: 'icon-bar icon-purchase-items is-pro-version', permission: 'ADMIN_PURCHASE_SHOW' }, { route: '', text: t('dashboard_sidebar_customers'), iconClassName: 'icon-bar icon-customers is-pro-version', permission: 'ADMIN_CUSTOMER_SHOW' }, { route: '', param: { page: 0 }, text: t('dashboard_sidebar_sales_orders'), iconClassName: 'icon-bar icon-Sales-order is-pro-version', permission: 'ADMIN_SALE_SHOW' }, { route: '', text: t('dashboard_sidebar_locations'), iconClassName: 'icon-bar icon-locations is-pro-version', permission: 'ADMIN_LOCATION_SHOW' }, { route: '', text: t('dashboard_sidebar_users'), iconClassName: 'icon-bar icon-user-access is-pro-version', permission: 'ADMIN_USER_PERMISSION_SHOW' }, { route: '', text: t('dsahboard_sidebar_user_access'), iconClassName: 'icon-bar icon-user-access is-pro-version', permission: 'ADMIN_USER_PERMISSION_SHOW' }, { route: '', text: t('dashboard_sidebar_reports'), iconClassName: 'icon-bar icon-reports is-pro-version', permission: 'ADMIN_REPORT_SHOW' }];
	
	        var menuItems = [],
	            styleContainer = {};
	        if (Security.loggedIn()) {
	            menuItems = UserPermissionStore.filterModules(SessionStore.isFullPaidVersion() ? fullVersionSidebarItems : baseVersionSidebarItems);
	            menuItems.unshift({ route: 'dashboard', text: t('dashboard_sidebar_dashboard'), iconClassName: 'icon-bar icon-dashboard-page' });
	        } else {
	            menuItems.push({ type: 'LINK', payload: ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/#/login', text: 'Log in' });
	        }
	
	        var headerEl = React.createElement(Header, {
	            onClickLeftMenuBar: this._onTouchLeftMenuBar,
	            onClickRightMenuBar: this._onTouchRightMenuBar,
	            isLogged: Security.loggedIn() });
	
	        return React.createElement("div", { className: "app-main" }, headerEl, React.createElement("div", { id: "main",
	            style: styleContainer }, React.createElement("div", null, React.createElement("div", {
	            id: "content",
	            style: {
	                zIndex: 5,
	                marginTop: 0
	            } }, React.createElement(RouteHandler, null)))), React.createElement("div", { className: "app-main__side-bar" }, React.createElement(LeftNav, {
	            ref: "leftNav",
	            style: { fontWeight: '300' },
	            menuItemClassName: "app-main__side-bar-item",
	            menuItems: menuItems,
	            docked: false,
	            disableSwipeToOpen: true,
	            onChange: this._onLeftNavChange,
	            selectedIndex: -1,
	            backgroundColor: Colors.indigo900,
	            header: React.createElement(HeaderSideBar, null) })), React.createElement(DashboardSpinner, { ref: "dashboardSpinnerEl" }), React.createElement(Notification, { ref: "notificationEl" }), React.createElement(Dialog, { ref: "customDialogEl" }), React.createElement(CustomContextMenu, { ref: "contextMenuEl" }), React.createElement(DashboardModal, { ref: "modalOrder" }), React.createElement(ScrollLock, null));
	    }
	});
	
	var routes = React.createElement(Route, { name: "app", handler: App, path: "/" }, React.createElement(Route, { name: "login", handler: Login }), React.createElement(Route, { name: "help", handler: Help }), React.createElement(Route, { name: "welcome", handler: Welcome }), React.createElement(Route, { name: "email-confirmed", handler: EmailConfirmed }), React.createElement(Route, { name: "preActivated", handler: PreActivated }), React.createElement(Route, { name: "contact", handler: Contact }), React.createElement(Route, { name: "tanks/page/:page", handler: TankAdmin }), React.createElement(Route, { name: "items/page/:page", handler: ItemsAdmin }), React.createElement(Route, { name: "non-inventory-items", handler: NonInventoryItemsAdmin }), React.createElement(Route, { name: "purchase-item/page/:page", handler: VendorPurchaseAdmin }), React.createElement(Route, { name: "icons-sections", handler: IconsAndSectionsAdmin }), React.createElement(Route, { name: "icons", handler: IconsAdmin }), React.createElement(Route, { name: "styleBeer", handler: StyleBeer }), React.createElement(Route, { name: "dashboard", handler: Dashboard }), React.createElement(Route, { name: "signUp", handler: SignUp }), React.createElement(Route, { name: "passwordRecovery", handler: PasswordRecovery }), React.createElement(Route, { name: "history", handler: HistoryAdmin }), React.createElement(Route, { name: "checkEmailResetPassword", handler: CheckEmailResetPassword }), React.createElement(Route, { name: "confirmationResetPassword", handler: ConfirmationResetPassword }), React.createElement(Route, { name: "styleBeer/:style/tasks", handler: BeerStyleConfigurationAdmin }), React.createElement(Route, { name: "products", handler: ProductsAdmin }), React.createElement(Route, { name: "location", handler: LocationAdmin }), React.createElement(Route, { name: "location-item/page/:page", handler: InventoryAndTransfersAdmin }), React.createElement(Route, { name: "user-permissions", handler: UserAccessAdmin }), React.createElement(Route, { name: "user", handler: UserAdmin }), React.createElement(Route, { name: "reports", handler: ReportAdmin }), React.createElement(Route, { name: "reports/by-beer-style", handler: ReportByBeerStyle }), React.createElement(Route, { name: "reports/by-products", handler: ReportByProduct }), React.createElement(Route, { name: "reports/by-tasks", handler: ReportByTask }), React.createElement(Route, { name: "reports/by-item-transaction", handler: ReportByItemTransaction }), React.createElement(Route, { name: "reports/by-batch-number", handler: ReportOrderByBatchNumber }), React.createElement(Route, { name: "vendors", handler: VendorAdmin }), React.createElement(Route, { name: "sales/page/:page", handler: SalesAdmin }), React.createElement(Route, { name: "sales/:saleId/items", handler: SalesItemsAdmin }), React.createElement(Route, { name: "customers", handler: CustomerAdmin }), React.createElement(Route, { name: "customers/:customerId/addresses", handler: CustomerAddressAdmin }), React.createElement(Route, { name: "customers/:customerId/contacts", handler: CustomerContactAdmin }), React.createElement(Route, { name: "customers/:customerId/items", handler: CustomerItemAdmin }), React.createElement(Route, { name: "vendors/:vendorId/addresses", handler: VendorAddressAdmin }), React.createElement(Route, { name: "vendors/:vendorId/contacts", handler: VendorContactAdmin }), React.createElement(Route, { name: "vendors/:vendorId/items", handler: VendorItemsAdmin }), React.createElement(Route, { name: "products/:productId/items", handler: ProductItemsAdmin }), React.createElement(Route, { name: "products/:productId/items-addition", handler: ProductItemsAdditionAdmin }), React.createElement(Route, { name: "products/:productId/icons", handler: ProductIconsAdmin }), React.createElement(Route, { name: "purchase-item/:purchaseId/vendors/:vendorId", handler: VendorPurchaseItemAdmin }), React.createElement(Route, { name: "purchase-item/:purchaseId/vendors/:vendorId/receive", handler: VendorReceiveItemAdmin }), React.createElement(Route, { name: "processes", handler: ProcessAdmin }), React.createElement(Route, { name: "tasks", handler: ProcessAdmin }), React.createElement(NotFoundRoute, { handler: NotFound }), React.createElement(DefaultRoute, { name: "home", handler: Login }));
	
	Router.run(routes, Router.HashLocation, function (Handler) {
	    React.render(React.createElement(Handler, null), document.getElementById('content-app'));
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(126);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keyMirror = __webpack_require__(827);
	
	/**
	 * Retrieve value from local session data from given key.
	 * @param {String} key
	 * @return {Object}
	 */
	function _getSession(key) {
	    if (sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined') {
	        return JSON.parse(sessionStorage.getItem(key));
	    } else {
	        return '';
	    }
	}
	
	function _isPaidVersion() {
	    return _getSession('cache_applicant_license') === 'FULL_VERSION' || _getSession('cache_applicant_license') === 'FREE_VERSION';
	}
	
	module.exports = {
	
	    ActionTypes: keyMirror({
	
	        // Header actions
	        CLICK_SHOW_SIDEBAR: null,
	
	        // Session Actions
	        LOGGED_IN: null,
	        LOGGED_OUT: null,
	
	        // Chronologyc actions
	        OPEN_DAY_NOTES: null,
	        CLOSE_DAY_NOTES: null,
	        NOTE_ADDED: null,
	        NOTE_CHANGED: null,
	        NOTE_REMOVED: null,
	        BREWING_NOTE_NEED_FETCH: null,
	        PACKAGING_NOTE_NEED_FETCH: null,
	
	        // Dashboard Actions
	        CONTEXT_MENU_ADD_DAY_ORDER_ABOVE: null,
	        CONTEXT_MENU_ADD_DAY_ORDER_BELOW: null,
	        CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE: null,
	        CONTEXT_MENU_MOVE_DAY_ORDER_AFTER: null,
	        CONTEXT_MENU_NEW_ORDER_DASHBOARD: null,
	        CONTEXT_MENU_REMOVE_DAY_ORDER: null,
	        CONTEXT_MENU_REMOVE_ORDER: null,
	        CONTEXT_MENU_CHANGE_ORDER_DASHBOARD: null,
	        CONTEXT_MENU_CHANGE_TASK_ORDER_DASHBOARD: null,
	        FORCE_CLEAN_ORDER_SELECTED_DASHBOARD: null,
	
	        FORCE_MANUAL_DRAWING_DASHBOARD: null,
	        FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD: null,
	        RIGHT_CLICK_DASHBOARD: null,
	        LEFT_SINGLE_CLICK_DASHBOARD_EMPTY: null,
	        LEFT_DOUBLE_CLICK_DASHBOARD_EMPTY: null,
	        LEFT_DOUBLE_CLICK_DASHBOARD_OCCUPIED: null,
	        RIGHT_DOUBLE_CLICK_DASHBOARD_EMPTY: null,
	        RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED: null,
	        RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE: null,
	
	        NEW_ORDER: null,
	        CHANGE_ORDER: null,
	        REMOVED_ORDER: null,
	
	        // when add new operation draft from user which is not saved in server side yet
	        NEW_ORDER_DRAFT: null,
	        CHANGE_ORDER_DRAFT: null,
	        REMOVED_ORDER_DRAFT: null,
	
	        SHOW_LOADING: null,
	        HIDE_LOADING: null,
	
	        // Operation which happens from polling mechanism
	        SAVE_DRAFT: null,
	        SAVE_DRAFT_SUCCESS: null,
	        SAVE_DRAFT_FAILURE: null,
	
	        // User Dashboard Tasks
	        FETCH_SCHEDULE_BOARD: null,
	        FETCH_SCHEDULE_BOARD_SUCCESS: null,
	        FETCH_SCHEDULE_BOARD_FAILURE: null,
	
	        SAVING_SCHEDULE_BOARD: null,
	        SAVING_SCHEDULE_BOARD_SUCCESS: null,
	        SAVING_SCHEDULE_BOARD_FAILURE: null,
	
	        ADDING_NOTE_SCHEDULE_BOARD: null,
	        ADDING_NOTE_SCHEDULE_BOARD_SUCCESS: null,
	        ADDING_NOTE_SCHEDULE_BOARD_FAILURE: null,
	
	        DELETING_SCHEDULE_BOARD: null,
	        DELETING_SCHEDULE_BOARD_SUCCESS: null,
	        DELETING_SCHEDULE_BOARD_FAILURE: null,
	
	        DELETING_USER_TASK: null,
	        DELETING_USER_TASK_SUCCESS: null,
	        DELETING_USER_TASK_FAILURE: null,
	
	        // Operation which came from an admin user
	        PUBLISHING_CHANGE_ADMIN_DRAFT: null,
	
	        // Operation which came from user on dashboard when an admin want to pushish
	        // draft operations.
	        PUBLISHING_DRAFT: null,
	        PUBLISHING_DRAFT_SUCCESS: null,
	        PUBLISHING_DRAFT_FAILURE: null,
	        UNDO_DRAFT: null,
	        UNDO_DRAFT_SUCCESS: null,
	        UNDO_DRAFT_FAILURE: null,
	        REDO_DRAFT: null,
	        REDO_DRAFT_SUCCESS: null,
	        REDO_DRAFT_FAILURE: null,
	
	        // when one batch of orders are already perform
	        PERFORM_BATCH_OPERATION_END: null,
	
	        FINISH_TO_DRAGGING_OR_RESIZING: null,
	
	        // Tank admin actions
	        ADDED_TANK: null,
	        CHANGED_TANK: null,
	        DELETED_TANK: null,
	
	        // Dashboard modal actions
	        DASHBOARD_MODAL_OPEN_NEW_ORDER: null,
	        DASHBOARD_MODAL_OPEN_EXISTING_ORDER: null,
	        DASHBOARD_MODAL_CHANGE_NUMBER: null,
	        DASHBOARD_MODAL_CHANGE_BEER_STYLE: null,
	        DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT: null,
	        DASHBOARD_MODAL_CHANGE_TASK_TYPE: null,
	        DASHBOARD_MODAL_CHANGE_TOGGLE: null,
	        DASHBOARD_MODAL_CHANGE_VOLUME: null, // the same to Combined and Single
	        DASHBOARD_MODAL_CLOSE_MODAL: null,
	        DASHBOARD_SWITCH_CLOSE_MODAL: null,
	
	        DASHBOARD_MODAL_BREW_CHANGE_BREW_DATE: null,
	        DASHBOARD_MODAL_BREW_CHANGE_FILTRATION: null,
	        DASHBOARD_MODAL_BREW_CHANGE_PACKAGING: null,
	
	        DASHBOARD_MODAL_SINGLE_CHANGE_FROM_DATE: null,
	        DASHBOARD_MODAL_SINGLE_CHANGE_TO_DATE: null,
	
	        // App actions
	        NEW_VERSION_API: null,
	
	        PERMISSION_REQUEST_UPDATE: null,
	        PERMISSION_UPDATED: null,
	
	        SAVE_CONFIGURATION_SETTINGS: null
	    }),
	
	    Permissions: {
	        ADMIN_TANK: 'Tanks/sections',
	        ADMIN_BEER_STYLE: 'Beer styles',
	        ADMIN_TASK: 'Tasks/QC',
	        ADMIN_ICON: 'Icons in sections',
	        ADMIN_ITEM: 'Items',
	        ADMIN_PURCHASE_ITEM: 'Purchase items',
	        ADMIN_CUSTOMER: 'Customers',
	        ADMIN_INVENTORY_AND_TRANSFERS: 'Inventory and transfers',
	        ADMIN_PRODUCT: 'Products',
	        ADMIN_LOCATION: 'Locations',
	        ADMIN_VENDOR: 'Suppliers',
	        ADMIN_SALE: 'Sales',
	        ADMIN_USER: 'Users',
	        ADMIN_USER_ACCESS: 'User access',
	        ADMIN_PURCHASE: 'Purchase items (PO)',
	        DASHBOARD: 'Dashboard pop-up window',
	        ADMIN_USER_PERMISSION: 'User Access',
	        ADMIN_BEER_STYLE_CONFIGURATION: 'Beer styles- Icon configuration',
	        ADMIN_REPORT: 'Reports'
	    },
	    // Analytics constants
	    Analytics: {
	        categories: keyMirror({
	            ADVERTISEMENT_BANNER_CLICK: null,
	            ADVERTISEMENT_BANNER_CLICK_ARROW: null,
	            ORDER: null,
	            ORDER_SINGLE: null,
	            DASHBOARD: null,
	            NOTES: null,
	            TANKS: null,
	            STYLE_BEER: null,
	            APPLICATION: null
	        }),
	        actions: keyMirror({
	            CLICK: null,
	            NEW: null,
	            CHANGE: null,
	            DELETE: null,
	            NAVIGATE: null,
	            SIGN_IN: null,
	            SIGN_UP: null,
	            SIGN_OUT: null,
	            A_LIVE: null
	        }),
	        labels: {
	            ORDER_DRAG_AND_DROP: 'Order changed - Drag and Drop',
	            ADVERTISEMENT_BANNER_CLICK: 'Banner clicked',
	            ORDER_RESIZED: 'Order changed - Vertical re-sized',
	            NOTES_BREWING: 'Notes changed - Brewing side',
	            NOTES_PACKAGING: 'Notes changed - Packaging side',
	            NOTES_PACKAGING_OPEN: 'Notes open - Packaging side',
	            NOTES_PACKAGING_CLOSE: 'Notes close - Packaging side',
	            NOTES_BREWING_OPEN: 'Notes open - Brewing side',
	            NOTES_BREWING_CLOSE: 'Notes close - Brewing side',
	            DASHBOARD_SELECT_ROW_DAY_BAR: 'Dashboard - Select day row bar'
	        }
	    },
	
	    // CACHE
	    KEY_CUSTOM_ICONS: 'cache_custom_icons',
	    KEY_PRODUCT_ICONS: 'cache_product_icons',
	    KEY_PRODUCT_ITEMS: 'cache_product_items',
	    KEY_LOCATION_ITEMS: 'cache_location_items',
	    KEY_PRODUCTS: 'cache_products',
	    KEY_TANK: 'cache_tanks',
	    KEY_BREW_PROCESS: 'cache_brew_process',
	    KEY_FERMENTING_PROCESS: 'cache_fermenting_process',
	    KEY_PACKAGING_PROCESS: 'cache_packaging_process',
	    KEY_ITEMS: 'cache_items',
	    KEY_LOCATION: 'cache_current_locator',
	    KEY_VENDOR_PURCHASE_ITEMS: 'cache_vendor_purchase_items',
	    KEY_VENDOR_ITEMS: 'cache_vendor_items',
	    KEY_BEER_STYLE_TASK_CONFIGURATIONS: 'cache_beerstyle_task_configurations',
	
	    // Custom header tags
	    APPLICANT_ID_CUSTOM_HEADER: 'X-Applicant-Id',
	    TOKEN_AUTH_CUSTOM_HEADER: 'X-AUTH-TOKEN',
	    LOCALE_CUSTOM_HEADER: 'X-Locale',
	    COUNTRY_CODE_CUSTOM_HEADER: 'X-Country-Code',
	    CURRENCY_CODE_CUSTOM_HEADER: 'X-Currency-Code',
	
	    // MODULES ACRONYM
	    MODULE_ITEM_ACRONYM: 'IT', //  item
	    MODULE_PRODUCT_ACRONYM: 'PR', //  products
	
	    // THE AMOUNT OF ITEMS WHICH SHOWS EACH TABLE ITEMS
	    MAX_ITEMS_BY_PAGES_ADMINS: 12,
	    MAX_VISIBLE_BUTTON_PAGES: 3,
	
	    // TYPE OF TANKS
	    TYPE_TANKS: ['BH', 'FV', 'BT'],
	    FERMENTING_SECTION_NAME: 'Fermenting',
	    PACKAGING_SECTION_NAME: 'Packaging',
	    BREWING_SECTION_NAME: 'Brewing',
	    TYPE_TANKS_WITH_SECTIONS: [{ type: 'BH', section: 'Brewing' }, { type: 'FV', section: 'Fermenting' }, {
	        type: 'BT',
	        section: 'Packaging'
	    }],
	    TANKS_SECTIONS: ['Brewing', 'Fermenting', 'Packaging'],
	    getSections: function getSections(t) {
	        var _ref, _ref2, _ref3;
	
	        var customField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'section';
	
	        return [(_ref = {}, _ref[customField] = 'Brewing', _ref.displayText = t('brewing'), _ref), (_ref2 = {}, _ref2[customField] = 'Fermenting', _ref2.displayText = t('fermenting'), _ref2), (_ref3 = {}, _ref3[customField] = 'Packaging', _ref3.displayText = t('packaging'), _ref3)];
	    },
	    getSectionsMapping: function getSectionsMapping(t) {
	        var _ref4;
	
	        return _ref4 = {}, _ref4['Brewing'] = t('brewing'), _ref4['Fermenting'] = t('fermenting'), _ref4['Packaging'] = t('packaging'), _ref4;
	    },
	    getIconsMapping: function getIconsMapping(t) {
	        var _ref5;
	
	        return _ref5 = {}, _ref5['brewing'] = t('brewing'), _ref5['filtration'] = t('filtration'), _ref5['packaging'] = t('packaging'), _ref5['Bottle'] = t('dashboard_service_cache_name_bottle'), _ref5['Fruit'] = t('dashboard_service_cache_name_fruit'), _ref5['Pumpkin'] = t('dashboard_service_cache_name_pumpkin'), _ref5['Honey'] = t('dashboard_service_cache_name_honey'), _ref5['Coffee Bean'] = t('dashboard_service_cache_name_coffee_bean'), _ref5['Cooling'] = t('dashboard_service_cache_name_cooling'), _ref5['Temperature'] = t('dashboard_service_cache_name_temperature'), _ref5['Firkin'] = t('dashboard_service_firkin'), _ref5['Keg'] = t('dashboard_service_cache_keg'), _ref5['Wood Barrel'] = t('dashboard_service_cache_name_wood_barrel'), _ref5['Tote'] = t('dashboard_service_cache_name_tote'), _ref5['Repair'] = t('dashboard_service_cache_name_repair'), _ref5['Report Problem'] = t('dashboard_service_cache_name_report_problem'), _ref5['Class or meeting'] = t('dashboard_service_cache_name_class_or_meeting'), _ref5['class_meeting'] = t('dashboard_service_cache_name_class_or_meeting'), _ref5['Note'] = t('dashboard_service_cache_name_note'), _ref5['Cleaning'] = t('dashboard_service_cache_name_cleaning'), _ref5['Transfer'] = t('dashboard_service_cache_name_transfer'), _ref5['Centrifuge'] = t('dashboard_service_cache_name_centrifuge'), _ref5['Column still'] = t('dashboard_service_cache_name_column_still'), _ref5['Pot still'] = t('dashboard_service_cache_name_pot_still'), _ref5['Brew & yeast'] = t('dashboard_service_cache_brew_yeast'), _ref5['Brew & Flask'] = t('dashboard_service_cache_name_brew_flask'), _ref5['Filter and Brew'] = t('dashboard_service_cache_name_filter_brew'), _ref5['Brew Day Before'] = t('dashboard_service_cache_name_brew_day_before'), _ref5['Can'] = t('dashboard_service_cache_name_can'), _ref5['Box'] = t('dashboard_service_cache_name_box'), _ref5['Bottle & keg'] = t('dashboard_service_cache_name_bottle_keg'), _ref5['Can & Keg'] = t('dashboard_service_cache_name_can_keg'), _ref5['Can & Bottle'] = t('dashboard_service_cache_name_can_bottle'), _ref5['Can, Bottle & Keg'] = t('dashboard_service_cache_name_can_bottle_keg'), _ref5['Can & Box'] = t('dashboard_service_cache_name_can_box'), _ref5['Bottle Pack'] = t('dashboard_service_cache_name_bottle_pack'), _ref5['No Pack'] = t('dashboard_service_cache_name_no_pack'), _ref5['Mix Box'] = t('dashboard_service_cache_name_mix_box'), _ref5['Co2'] = t('dashboard_service_cache_name_co2'), _ref5['Receiving Truck'] = t('dashboard_service_cache_name_receiving_truck'), _ref5['Shipping Truck'] = t('dashboard_service_cache_name_shipping_truck'), _ref5['Brew & CIP'] = t('dashboard_service_cache_name_brew_cip'), _ref5['Brew & O2'] = t('dashboard_service_cache_name_brew_o2'), _ref5['Brew, CIP & O2'] = t('dashboard_service_cache_name_brew_cip_o2'), _ref5['Yeast Drain'] = t('dashboard_service_cache_name_yeast_drain'), _ref5['Yeast From'] = t('dashboard_service_cache_name_yeast_from'), _ref5['Yeast Harvest'] = t('dashboard_service_cache_name_yeast_harvest'), _ref5['Yeast In From'] = t('dashboard_service_cache_name_yeast_in_from'), _ref5['Yeast In'] = t('dashboard_service_cache_name_yeast_in_from'), _ref5['Yeast New Pitch'] = t('dashboard_service_cache_name_yeast_new_pitch'), _ref5['Yeast Out'] = t('dashboard_service_cache_name_yeast_out'), _ref5['Fining or Enzymes'] = t('dashboard_service_fining_or_enzymes'), _ref5['no-icon'] = t('dashboard_service_cache_name_no_icon'), _ref5['Dry Hopping'] = t('dashboard_service_cache_name_dry_hopping'), _ref5['Dy and DH'] = t('dashboard_service_cache_name_dy_and_dh'), _ref5['DY and DH'] = t('dashboard_service_cache_name_dy_and_dh'), _ref5;
	    },
	    getProductCategoryMapping: function getProductCategoryMapping(t) {
	        var _ref6;
	
	        return _ref6 = {}, _ref6['FINISHED'] = t('finished'), _ref6['SEMI-FINISHED'] = t('semi_finished'), _ref6['IN PROGRESS'] = t('in_progress'), _ref6;
	    },
	    getCategoryMapping: function getCategoryMapping(t) {
	        var _ref7;
	
	        return _ref7 = {}, _ref7['Grains'] = t('grain'), _ref7['Hops'] = t('hops'), _ref7['Yeast'] = t('yeast'), _ref7['Additives'] = t('additives'), _ref7['Chemicals'] = t('chemicals'), _ref7['Packaging'] = t('packaging'), _ref7['FINISHED'] = t('finished'), _ref7['SEMI-FINISHED'] = t('semi_finished'), _ref7['Others'] = t('others'), _ref7;
	    },
	    ITEM_CATEGORY_NON_INVENTORY: 'NON-INVENTORY',
	    ITEM_CATEGORY: ['Grains', 'Hops', 'Yeast', 'Additives', 'Chemicals', 'Packaging', 'FINISHED', 'SEMI-FINISHED', 'Others'],
	    PRODUCT_CATEGORY: ['FINISHED', 'SEMI-FINISHED', 'IN PROGRESS'],
	    ITEM_SALEABLE_CATEGORY: ['FINISHED', 'SEMI-FINISHED', 'SALES-MARKETING'],
	
	    // SALES
	    SALE_STATE: ['OPEN', 'OPEN_PENDING', 'NOTIFIED', 'CONFIRM_NOTIFIED', 'DELIVERED', 'DELIVERED_PAID'],
	    SALE_PRIORITIES: ['LOW', 'MEDIUM', 'HIGH', 'IMMEDIATELY'],
	    getSalesPriorities: function getSalesPriorities(t) {
	        return [{ priority: 'LOW', displayText: t('sales_priority_state_low') }, { priority: 'MEDIUM', displayText: t('sales_priority_state_medium') }, { priority: 'HIGH', displayText: t('sales_priority_state_high') }, { priority: 'IMMEDIATELY', displayText: t('sales_priority_state_immediately') }];
	    },
	    getSalesStateMapping: function getSalesStateMapping(t) {
	        return {
	            LOW: t('sales_priority_state_low'),
	            MEDIUM: t('sales_priority_state_medium'),
	            HIGH: t('sales_priority_state_high'),
	            IMMEDIATELY: t('sales_priority_state_immediately'),
	            OPEN: t('sales_state_open'),
	            OPEN_PENDING: t('sales_state_open_pending'),
	            REOPEN_PENDING: t('sales_state_re_open_pending'),
	            NOTIFIED: t('sales_state_notified'),
	            CONFIRM_NOTIFIED: t('sales_state_confirm_notified'),
	            DELIVERED: t('sales_state_delivered'),
	            DELIVERED_PAID: t('sales_state_delivered_paid'),
	            VIRTUAL_ITEM_CATEGORY: t('sales_state_virtual_item_category')
	        };
	    },
	
	    SALE_STATE_OPEN: 'OPEN',
	    SALE_STATE_OPEN_PENDING: 'OPEN_PENDING',
	    SALE_STATE_REOPEN_PENDING: 'REOPEN_PENDING',
	    SALE_STATE_NOTIFIED: 'NOTIFIED',
	    SALE_STATE_CONFIRM_NOTIFIED: 'CONFIRM_NOTIFIED',
	    SALE_SATES_NOTIFIED: ['CONFIRM_NOTIFIED', 'NOTIFIED'],
	    SALE_STATE_DELIVERED: ['DELIVERED', 'DELIVERED_PAID'],
	    SALE_VIRTUAL_ITEM_CATEGORY: 'VIRTUAL_ITEM_CATEGORY',
	
	    // SALES ITEMS
	    SALE_ITEM_NOTIFIED: 'NOTIFIED',
	    SALE_ITEM_NON_NOTIFIED: 'NON_NOTIFIED',
	
	    PRODUCT_CATEGORY_CONSUME_VOLUME: ['FINISHED', 'SEMI-FINISHED'],
	    TYPE_TANK_FERMENTER: 'FV',
	    TYPE_TANK_BRITE_TANK: 'BT',
	    TYPE_TANK_BREW_HOUSE: 'BH',
	    DEFAULT_TANK_UNIT: 'v',
	
	    APP_MODULES: [{ name: 'DASHBOARD_ORDERS', displayName: 'Dashboard' }, { name: 'ADMIN_ICON', displayName: 'Icons', isDisabled: true }, { name: 'ADMIN_ITEM', displayName: 'Items' }, { name: 'ADMIN_PROCESS', displayName: 'Process' }, { name: 'ADMIN_PRODUCT', displayName: 'Products' }, { name: 'ADMIN_PRODUCT_ITEM', displayName: 'Product items' }, { name: 'ADMIN_PRODUCT_ICON', displayName: 'Product icons', isDisabled: true }, { name: 'ADMIN_TANK', displayName: 'Tanks' }, { name: 'ADMIN_BEER_STYLE', displayName: 'Beer style' }, { name: 'ADMIN_BEER_STYLE_CONFIGURATION', displayName: 'Config beer style' }, { name: 'ADMIN_LOCATION', displayName: 'Locations' }, { name: 'ADMIN_LOCATION_ITEM', displayName: 'Locations Items' }, { name: 'ADMIN_VENDORS', displayName: 'Vendors' }, { name: 'ADMIN_VENDORS_ADDRESS', displayName: 'Vendor address' }, { name: 'ADMIN_VENDORS_CONTACTS', displayName: 'Vendor contacts' }, { name: 'ADMIN_VENDORS_ITEM', displayName: 'Vendor items' }],
	
	    // Dashboard state togglers
	    TOGGLE_BT: 'TOGGLE_BT',
	    TOGGLE_FV: 'TOGGLE_FV',
	    TOGGLE_FV_BT: 'TOGGLE_FV_BT',
	    TOGGLE_BH: 'TOGGLE_BH',
	    TOGGLE_BH_BH: 'TOGGLE_BH_BH',
	    TOGGLE_BH_FV: 'TOGGLE_BH_FV',
	    TOGGLE_BH_BT: 'TOGGLE_BH_BT',
	    TOGGLE_BH_FV_BT: 'TOGGLE_BH_FV_BT',
	    TOGGLE_BH_FV_BH: 'TOGGLE_BH_FV_BH',
	    TOGGLE_BH_BT_BH: 'TOGGLE_BH_BT_BH',
	    TOGGLE_BH_FV_FV: 'TOGGLE_BH_FV_FV',
	    TOGGLE_BH_BT_BT: 'TOGGLE_BH_BT_BT',
	
	    CONTACTS_TYPE: ['PHONE', 'EMAIL'],
	    getContactMapping: function getContactMapping(t) {
	        return {
	            PHONE: t('phone'),
	            EMAIL: t('email')
	        };
	    },
	    getContacts: function getContacts(t) {
	        return [{ type: 'PHONE', displayText: t('phone') }, { type: 'EMAIL', displayText: t('email') }];
	    },
	
	
	    // LICENSES
	    LICENSE_FULL_VERSION: 'FULL_VERSION',
	    LICENSE_TRIAL_FULL_VERSION: 'TRIAL_FULL_VERSION',
	    LICENSE_FREE_VERSION: 'FREE_VERSION',
	
	    /**
	     * The entire purchase order is close when all of their purchase items
	     * are received or rejected.
	     */
	    PURCHASES_STATES: ['OPEN', 'OPEN_PENDING', 'OPEN_ORDERED', 'OPEN_ORDERED_LATE', 'RECEIVED', 'ORDER_PARTIALLY_RECEIVED', 'RECEIVED_WITH_ISSUE', 'CLOSED_COMPLETE', 'CLOSED_RESOLVED'],
	    getPurchaseStateMapping: function getPurchaseStateMapping(t) {
	        return {
	            'OPEN': t('purchase_state_open'),
	            'OPEN_PENDING': t('purchase_state_open_pending'),
	            'OPEN_ORDERED': t('purchase_state_open_ordered'),
	            'OPEN_ORDERED_LATE': t('purchase_state_open_ordered_late'),
	            'RECEIVED': t('purchase_state_received'),
	            'ORDER_PARTIALLY_RECEIVED': t('purchase_state_partially_received'),
	            'RECEIVED_WITH_ISSUE': t('purchase_state_received_with_issue'),
	            'CLOSED_COMPLETE': t('purchase_state_closed_complete'),
	            'CLOSED_COMPLETE_PAID': t('purchase_state_closed_complete_paid'),
	            'CLOSED_RESOLVED': t('purchase_state_closed_resolved'),
	            'CLOSED_RESOLVED_PAID': t('purchase_state_closed_resolved_paid'),
	            'PENDING': t('purchase_state_pending'),
	            'ORDERED': t('purchase_state_ordered'),
	            'NO_MORE_ON_THE_WAY': t('purchase_state_no_more_on_the_way'),
	            'MORE_ON_THE_WAY': t('purchase_state_more_on_the_way'),
	            'REJECT_REMAINDER': t('purchase_state_reject_remainder')
	        };
	    },
	
	    PURCHASE_STATES_REMOVABLE: ['OPEN', 'OPEN_PENDING', 'OPEN_ORDERED', 'OPEN_ORDERED_LATE'],
	
	    PURCHASE_STATE_DASHBOARD_COUNT_AS_ORDERED: ['ORDERED', 'MORE_ON_THE_WAY'],
	
	    PURCHASES_STATES_ITEMS: ['PENDING', 'ORDERED'],
	
	    getReceiveStatesMapping: function getReceiveStatesMapping(t) {
	        var _ref8;
	
	        return _ref8 = {}, _ref8['NO_MORE_ON_THE_WAY'] = t('purchase_receive_state_no_more_on_the_way'), _ref8['MORE_ON_THE_WAY'] = t('purchase_receive_state_more_on_the_way'), _ref8['REJECT_REMAINDER'] = t('purchase_receive_state_reject_reminder'), _ref8;
	    },
	
	
	    ONLY_NO_MORE_ON_THE_WAY: ['NO_MORE_ON_THE_WAY'],
	
	    RECEIVE_STATES_ITEMS: ['NO_MORE_ON_THE_WAY', 'MORE_ON_THE_WAY', 'REJECT_REMAINDER'],
	
	    PURCHASE_RED_STATE: ['OPEN', 'OPEN_PENDING', 'OPEN_ORDERED_LATE'],
	
	    PURCHASE_YELLOW_STATE: ['ORDER_PARTIALLY_RECEIVED', 'OPEN_ORDERED'],
	
	    PURCHASE_STATE_CLOSED_COMPLETE: 'CLOSED_COMPLETE',
	    PURCHASE_STATE_CLOSED_RESOLVE: 'CLOSED_COMPLETE',
	
	    PURCHASE_GREEN_STATE: ['CLOSED_COMPLETE', 'CLOSED_COMPLETE_PAID', 'CLOSED_RESOLVED', 'CLOSED_RESOLVED_PAID'],
	
	    SINGLE_TASK_TYPES: [{
	        type: 'BH',
	        text: 'Brewing'
	    }, {
	        text: 'Fermenting',
	        type: 'FV'
	    }, {
	        text: 'Packaging',
	        type: 'BT'
	    }],
	
	    SINGLE_LISTED_TASK_TYPES: [{
	        type: 'BH',
	        text: 'Brewing'
	    }, {
	        type: 'FV',
	        text: 'Fermenting'
	    }, {
	        type: 'BT',
	        text: 'Packaging'
	    }],
	
	    WHERE_KNOW_US: [{ source: 'WEB', name: 'Web/Google search' }, { source: 'PRO_BREWER', name: 'ProBrewer.com' }, { source: 'SOCIAL_MEDIA', name: 'Social Media' }, { source: 'COWORKER', name: 'Friend/Other Brewer' }, { source: 'OTHER', name: 'Other (please explain below)' }],
	
	    // TASK CONSTs
	    TYPE_TASK_FERMENTER: 'FERMENTER_TASK',
	    TYPE_TASK_PACKAGING: 'PACKAGING_TASK',
	    TYPE_TASK_BREWHOUSE: 'BREWHOUSE_TASK',
	
	    // TASK TYPES
	    BREW_TASK: 'BREW_TASK',
	    FILTRATION_TASK: 'FILTRATION_TASK',
	    PACKAGING_TASK: 'PACKAGING_TASK',
	    SECONDARY_TASK: 'SECONDARY_TASK',
	    SINGLE_TASK: 'SINGLE_TASK',
	    TASK_NON_VISIBLE: 'no-icon',
	    DEFAULT_TASK_BREWING: 'brewing',
	    DEFAULT_TASK_FILTRATION: 'filtration',
	    DEFAULT_TASK_PACKAGING: 'packaging',
	
	    FERMENTER_TYPE_TASK: 'fermenter',
	    PACKAGING_TYPE_TASK: 'packaging',
	    BREWING_TYPE_TASK: 'brewing',
	
	    ROLE_ADMIN: 'ADMIN',
	    ROLE_USER: 'USER',
	
	    HISTORY_TYPE_NEW: 'NEW',
	    HISTORY_TYPE_CHANGE: 'CHANGE',
	    HISTORY_TYPE_DELETE: 'DELETE',
	
	    LANGUAGE_ALLOWED: [{ display: 'English', value: 'en' }, { display: 'Spanish', value: 'es' }, { display: 'Portuguese', value: 'pt' }],
	
	    STANDARDISE_DECIMAL_SEPARATOR: '.',
	
	    // TEMPLATE
	    ROW_HIGHT: 35, // need sync with var: _template.$dashboard-height-row
	    HEADER_HIGHT: _isPaidVersion() ? 50 : 100, // need sync with: _template.$dashboard-height-header
	    COLUMN_HIGHT: 50,
	    WIDTH_COMMENT_DASHBOARD: 30, // need sync with: _template.$chronologyc-bar-with-column-expanded
	    WIDTH_COMMENT_BUTTON_DASHBOARD: 70, // need sync with: _template.$chronologyc-bar-with-column
	
	    // dashboard behavior
	    DEFAULT_MONTH_BEFORE: 0,
	    DEFAULT_DAYS_BEFORE: 21,
	    DEFAULT_MONTH_AFTER: 2,
	    DEFAULT_DAYS_AFTER: 0,
	    DAYS_BACKWARD_FORWARD: 20,
	
	    DEFAULT_LANGUAGE: 'en',
	    PREFERRED_LANGUAGE: navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en',
	
	    // APP Version key
	    APP_VERSION_KEY: 'APP_VERSION_KEY',
	
	    // Decimals
	    DEFAULT_AMOUNT_DECIMAL: 2,
	
	    // Inventory status icon
	
	    // GREEN WITH WHITE CHECK
	    INVENTORY_ALL_DISCOUNTED_AND_CONFIRMED: 'all_discounted_confirmed',
	
	    // GREEN
	    INVENTORY_SOME_CONFIRMED_AND_SOME_UNCONFIRMED: 'some_confirmed_some_unconfirmed',
	
	    // GREEN
	    INVENTORY_IS_ENOUGH_INVENTORY: 'is_enough_inventory',
	
	    // GREEN
	    INVENTORY_SOME_WAS_UNCONFIRMED_ALREADY_DISCOUNTED: 'some_was_unconfirmed_already_discounted',
	
	    // YELLOW CIRCLE
	    INVENTORY_MISSING_ITEMS_BUT_PURCHASE_IN_COMING: 'purchase_in_coming',
	
	    // RED CIRCLE
	    INVENTORY_MISSING_ITEMS: 'missing-items',
	
	    // RED CIRCLE WITH WHITE ADMIRATION
	    INVENTORY_SOME_PRODUCT_NON_CONFIRMED_OUT_SCOPE: 'some-product-non-confirmed-out-scope',
	
	    // The maximiun days before today that will be take care to calculate
	    // the reservation of the scope inventory (non-confirmed product in orders in the past)
	    INVENTORY_MAX_PAST_DAYS_SCOPE: 10,
	
	    // Errors code
	    ERROR_CODE_APPLICANT_ALREADY_EXIST: '0001',
	    ERROR_CODE_EMAIL_ALREADY_EXIST: '0002',
	    ERROR_CODE_USERNAME_ALREADY_EXIST: '0003',
	    ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST: '0004',
	    ERROR_CODE_ADMIN_USERNAME_SAME_GUEST_USERNAME: '0005',
	    ERROR_CODE_USERNAME_DO_NOT_EXIST: '0006',
	    ERROR_CODE_TANK_VOLUME_TOO_SMALL: '0007',
	    ERROR_CODE_VENDOR_WITHOUT_EMAIL: '0008',
	    ERROR_CODE_SALE_NOT_ENOUGH_ITEM: '0009',
	    ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL: '0010',
	
	    // Order operation
	    ORDER_OPERATION_NEW: 'NEW_ORDER',
	    ORDER_OPERATION_CHANGE: 'CHANGE_ORDER',
	    ORDER_OPERATION_DELETE: 'DELETE_ORDER',
	
	    // Brewing Note operation
	    NOTE_BREWING_OPERATION_NEW: 'NEW_BREWING_NOTE',
	    NOTE_BREWING_OPERATION_CHANGE: 'CHANGE_BREWING_NOTE',
	    NOTE_BREWING_OPERATION_DELETE: 'DELETE_BREWING_NOTE',
	
	    NOTE_TYPE_PACKAGING: 'NOTE_TYPE_PACKAGING',
	    NOTE_TYPE_BREWING: 'NOTE_TYPE_BREWING',
	
	    // Tabs
	    INDEX_FIRST_TAB: 0,
	    INDEX_SECOND_TAB: 1,
	
	    // DECIMAL FORMATTER
	    ITEM_AMOUNT_DIGITS_DECIMALS: 4,
	
	    INDEX_TABS_DIALOG_ORDER: {
	        'BH': 1,
	        'FV': 2,
	        'BT': 3
	    },
	
	    getReportByMapping: function getReportByMapping(t) {
	        var _ref9;
	
	        return _ref9 = {}, _ref9['Total'] = t('total'), _ref9['Month'] = t('month'), _ref9['Week'] = t('week'), _ref9['Day'] = t('day'), _ref9;
	    },
	
	
	    // Packaging Note operation
	    NOTE_PACKAGING_OPERATION_NEW: 'NEW_PACKAGING_NOTE',
	    NOTE_PACKAGING_OPERATION_CHANGE: 'CHANGE_PACKAGING_NOTE',
	    NOTE_PACKAGING_OPERATION_DELETE: 'DELETE_PACKAGING_NOTE',
	
	    DRAFT_ORDER_PREFIX: 'DRAFT_ORDER_ID_',
	    MAX_DRAFT_OPERATION: 35,
	    NOTE_PREFIX: 'NOTE_ID_',
	    DATE_FORMAT: 'YYYY-MM-DD',
	    DATE_FORMAT_DISPLAY: 'MM/DD/YYYY',
	    DATE_FORMAT_DISPLAY_COMBO: 'MMMM, ddd DD',
	    DATE_FORMAT_DISPLAY_COMBO_DAY: 'ddd, DD',
	    DATE_FORMAT_SHORT: 'MM-DD',
	    DATE_FORMAT_LONG: 'YYYY-MM-DDThh:mm:ssZZ',
	
	    // APP Modules
	    APP_MODULE_ADMIN_ICON: 'ADMIN_ICON',
	    APP_MODULE_ADMIN_ITEM: 'ADMIN_ITEM',
	    APP_MODULE_ADMIN_PRODUCT: 'ADMIN_PRODUCT',
	    APP_MODULE_ADMIN_PRODUCT_ICON: 'ADMIN_PRODUCT_ICON',
	    APP_MODULE_ADMIN_PRODUCT_ITEM: 'ADMIN_PRODUCT_ITEM',
	    APP_MODULE_ADMIN_TANK: 'ADMIN_TANK',
	    APP_MODULE_ADMIN_BEER_STYLE: 'ADMIN_BEER_STYLE',
	    APP_MODULE_ADMIN_BEER_STYLE_CONFIGURATION: 'ADMIN_BEER_STYLE_CONFIGURATION',
	    APP_MODULE_ADMIN_LOCATION: 'ADMIN_LOCATION',
	    APP_MODULE_ADMIN_LOCATION_ITEM: 'ADMIN_LOCATION_ITEM',
	    APP_MODULE_ADMIN_VENDORS: 'ADMIN_VENDORS',
	    APP_MODULE_ADMIN_VENDORS_CONTACTS: 'ADMIN_VENDORS_CONTACTS',
	    APP_MODULE_ADMIN_VENDORS_ADDRESS: 'ADMIN_VENDORS_ADDRESS',
	    APP_MODULE_ADMIN_VENDORS_ITEM: 'ADMIN_VENDORS_ITEM',
	    APP_MODULE_DASHBOARD_ORDERS: 'DASHBOARD_ORDERS',
	
	    //Order dates defaults
	    DEFAULT_FERMENTER_DAYS_AFTER_BREW_DAY: 13,
	    DEFAULT_PACKAGING_DAYS_AFTER_BREW_DAY: 14,
	
	    // KEYWORD EVENT
	    ENTER_KEY_CODE: 13,
	    P_KEY_CODE: 80,
	
	    REGEX_NAME_DEFAULT: /^[A-Za-z\d\&\-_ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей\s]+$/,
	    REGEX_NAME_SIGNUP: /^[A-Za-z0-9\-_. ]+$/,
	    REGEX_NAME_RELAXED: /^[A-Za-z\d\&\-_/ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей().°@,+\s]+$/,
	    REGEX_EMAIL: /^(([^ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей<>()\[\]\\.,;:\s@"]+(\.[^ñüéáíóúàèùâêîôûäëçãõÆØÅæøäЗахарченкоАлексей<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	
	    // Users Roles
	    USERS_ROLES: ['Administrator', 'Guest'],
	    getUserRolesMapping: function getUserRolesMapping(t) {
	        var _ref10;
	
	        return _ref10 = {}, _ref10['Administrator'] = t('administrator'), _ref10['Guest'] = t('guest'), _ref10;
	    },
	    getUserRoles: function getUserRoles(t) {
	        return [{ role: 'Administrator', displayText: t('administrator') }, { role: 'Guest', displayText: t('guest') }];
	    },
	
	
	    GO_PRO_URL: 'https://www.brewplanner.com/gopro',
	
	    TIME_WAIT_MODAL_EXPAND: 50,
	    TIME_WAIT_MODAL_REFRESH_EXPAND: 70 // Always this value should be longer than TIME_WAIT_MODAL_EXPAND
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.11.2
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(1187)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')$', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')$', 'i');
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(arguments).join(', ') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             if (this.isValid() && other.isValid()) {
	                 return other < this ? this : other;
	             } else {
	                 return valid__createInvalid();
	             }
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(matchOffset, this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format]() : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return +this > +localInput;
	        } else {
	            return +localInput < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return +this < +localInput;
	        } else {
	            return +this.clone().endOf(units) < +localInput;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return +this === +localInput;
	        } else {
	            inputMs = +localInput;
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // JSON.stringify(new Date(NaN)) === 'null'
	        return this.isValid() ? this.toISOString() : 'null';
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        // console.log("got", weekYear, week, weekday, "set", date.toISOString());
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = local__createLocal([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = getSet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = getSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto._months           = defaultLocaleMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto._monthsShort      = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto._monthsRegex      = defaultMonthsRegex;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto._monthsShortRegex = defaultMonthsShortRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.11.2';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(226)(module)))

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  /**
	   * This is a simple wrapper of i18Next that is loaded from `index.html` in a imperative way.
	   * @param translateKey
	   * @returns {*}
	   */
	  t: function t(translateKey) {
	    return window.i18next && window.i18next.t ? window.i18next.t(translateKey) : '';
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'assign': __webpack_require__(906),
	  'assignIn': __webpack_require__(476),
	  'assignInWith': __webpack_require__(208),
	  'assignWith': __webpack_require__(907),
	  'create': __webpack_require__(924),
	  'defaults': __webpack_require__(927),
	  'defaultsDeep': __webpack_require__(928),
	  'extend': __webpack_require__(941),
	  'extendWith': __webpack_require__(942),
	  'findKey': __webpack_require__(947),
	  'findLastKey': __webpack_require__(950),
	  'forIn': __webpack_require__(959),
	  'forInRight': __webpack_require__(960),
	  'forOwn': __webpack_require__(961),
	  'forOwnRight': __webpack_require__(962),
	  'functions': __webpack_require__(964),
	  'functionsIn': __webpack_require__(965),
	  'get': __webpack_require__(163),
	  'has': __webpack_require__(486),
	  'hasIn': __webpack_require__(487),
	  'invert': __webpack_require__(975),
	  'invertBy': __webpack_require__(976),
	  'invoke': __webpack_require__(977),
	  'keys': __webpack_require__(54),
	  'keysIn': __webpack_require__(68),
	  'mapKeys': __webpack_require__(1006),
	  'mapValues': __webpack_require__(1007),
	  'merge': __webpack_require__(1014),
	  'mergeWith': __webpack_require__(495),
	  'omit': __webpack_require__(1022),
	  'omitBy': __webpack_require__(1023),
	  'pick': __webpack_require__(1036),
	  'pickBy': __webpack_require__(1037),
	  'result': __webpack_require__(1050),
	  'set': __webpack_require__(1054),
	  'setWith': __webpack_require__(1055),
	  'toPairs': __webpack_require__(506),
	  'toPairsIn': __webpack_require__(1085),
	  'transform': __webpack_require__(1089),
	  'unset': __webpack_require__(1102),
	  'values': __webpack_require__(209),
	  'valuesIn': __webpack_require__(1104)
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ImmutabilityHelper = __webpack_require__(147);
	var Styles = __webpack_require__(369);
	
	// This mixin isn't necessary and will be removed in v0.11
	
	/**
	 *	@params:
	 *	styles = Current styles.
	 *  props = New style properties that will override the current style.
	 */
	module.exports = {
	
	  propTypes: {
	    style: React.PropTypes.object
	  },
	
	  //Moved this function to ImmutabilityHelper.merge
	  mergeStyles: function mergeStyles() {
	    return ImmutabilityHelper.merge.apply(this, arguments);
	  },
	
	  //Moved this function to /utils/styles.js
	  mergeAndPrefix: function mergeAndPrefix() {
	    return Styles.mergeAndPrefix.apply(this, arguments);
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ContentUtils = void 0,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(2),
	    REGEX_NAME_DEFAULT = _require2.REGEX_NAME_DEFAULT,
	    TYPE_TANK_FERMENTER = _require2.TYPE_TANK_FERMENTER,
	    TYPE_TANK_BRITE_TANK = _require2.TYPE_TANK_BRITE_TANK,
	    TYPE_TANK_BREW_HOUSE = _require2.TYPE_TANK_BREW_HOUSE,
	    FERMENTER_TYPE_TASK = _require2.FERMENTER_TYPE_TASK,
	    TYPE_TASK_FERMENTER = _require2.TYPE_TASK_FERMENTER,
	    TYPE_TASK_PACKAGING = _require2.TYPE_TASK_PACKAGING,
	    TYPE_TASK_BREWHOUSE = _require2.TYPE_TASK_BREWHOUSE,
	    PACKAGING_TYPE_TASK = _require2.PACKAGING_TYPE_TASK,
	    BREWING_TYPE_TASK = _require2.BREWING_TYPE_TASK,
	    PACKAGING_SECTION_NAME = _require2.PACKAGING_SECTION_NAME,
	    FERMENTING_SECTION_NAME = _require2.FERMENTING_SECTION_NAME,
	    BREWING_SECTION_NAME = _require2.BREWING_SECTION_NAME,
	    ITEM_CATEGORY_NON_INVENTORY = _require2.ITEM_CATEGORY_NON_INVENTORY,
	    localMemory = {},
	    _ = __webpack_require__(40),
	    _require3 = __webpack_require__(355),
	    max = _require3.max,
	    _require4 = __webpack_require__(8),
	    filter = _require4.filter,
	    map = _require4.map,
	    some = _require4.some,
	    CustomDialog = __webpack_require__(26),
	    DashboardAction = __webpack_require__(65),
	    get = __webpack_require__(5).get,
	    DateUtils = __webpack_require__(22),
	    numeral = __webpack_require__(637),
	    getBoundingClientRect = __webpack_require__(234),
	    singleAttributes = ['fromDate', 'toDate', 'singleTank'];
	
	
	var BREWING_INFO = Object.freeze({
	    className: 'is-brewhouse',
	    classNameSection: 'brewing-icon',
	    tankType: 'BH',
	    tankTypeName: 'brewing',
	    postFix: '_BH',
	    postFixTaskType: 'BREWHOUSE_TASK',
	    sectionName: 'Brewing',
	    tasksFieldName: 'batchs',
	    getMethodIcons: 'getBrewingProcess',
	    getDays: 'currentBrewingDays',
	    type: 'BH'
	});
	
	var FERMENTING_INFO = Object.freeze({
	    className: 'is-fermenter',
	    classNameSection: 'filtration-icon',
	    tankType: 'FV',
	    tankTypeName: 'fermenter',
	    postFix: '',
	    sectionName: 'Fermenting',
	    postFixTaskType: 'FERMENTER_TASK',
	    orderTankName: 'fermenterTank',
	    tasksFieldName: 'fermenterTasks',
	    getMethodIcons: 'getFermenterIcons',
	    getDays: 'currentFermenterDays',
	    type: 'FV'
	});
	
	var PACKAGING_INFO = Object.freeze({
	    className: 'is-britetank',
	    classNameSection: 'packaging-icon',
	    tankType: 'BT',
	    tankTypeName: 'packaging',
	    postFix: '_BT',
	    postFixTaskType: 'PACKAGING_TASK',
	    orderTankName: 'briteTank',
	    sectionName: 'Packaging',
	    tasksFieldName: 'packagingTasks',
	    getMethodIcons: 'getPackagingIcons',
	    getDays: 'currentPackagingDays',
	    type: 'BT'
	});
	
	var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	/**
	 * Helper class to handler the common/generic way the content in the browser, conditionals, cache handler,
	 * queries element, cloning object, and other king of stuffs.
	 */
	ContentUtils = {
	    isNull: function isNull(value) {
	        return _.isNull(value) || _.isUndefined(value);
	    },
	    isEmptyText: function isEmptyText(value) {
	        return this.isNull(value) || value === '';
	    },
	    isFunction: function isFunction(value) {
	        return typeof value === 'function';
	    },
	    setTimeout: function setTimeout(callback, after) {
	        _.delay(callback, after);
	    },
	    isNullOrEmpty: function isNullOrEmpty(value) {
	        return _.isNull(value) || _.isUndefined(value) || '' === _.trim(value);
	    },
	    isNotNullOrUndefined: function isNotNullOrUndefined(value) {
	        return !_.isNull(value) && !_.isUndefined(value);
	    },
	    trim: function trim(obj) {
	        if (!this.isNullOrEmpty(obj)) {
	            if (typeof obj === 'string') {
	                return obj.trim();
	            }
	        }
	        return obj;
	    },
	    isNullField: function isNullField(field, allowSpecialCharacter) {
	        return _.isNull(field) || _.isUndefined(field) || _.isNull(field.getValue()) || _.isUndefined(field.getValue()) || field.getValue().trim() === '' || allowSpecialCharacter ? false : !REGEX_NAME_DEFAULT.test(field.getValue());
	    },
	    isHidden: function isHidden(element) {
	        return element.offsetParent === null;
	    },
	    offset: function offset(element) {
	        if (!element) {
	            return null;
	        }
	        var rect = getBoundingClientRect(element);
	
	        return {
	            top: rect.top + window.pageYOffset,
	            left: rect.left + window.pageXOffset
	        };
	    },
	    inViewport: function inViewport(element, container, customOffset) {
	        if (this.isHidden(element)) {
	            return false;
	        }
	        var top, left, bottom, right, containerOffset, elementOffset;
	        if (typeof container === 'undefined' || container === window) {
	            top = window.pageYOffset;
	            left = window.pageXOffset;
	            bottom = top + window.innerHeight;
	            right = left + window.innerWidth;
	        } else {
	            containerOffset = this.offset(container);
	
	            top = containerOffset.top;
	            left = containerOffset.left;
	            bottom = top + container.offsetHeight;
	            right = left + container.offsetWidth;
	        }
	
	        elementOffset = this.offset(element);
	
	        return top < elementOffset.top + customOffset.bottom + element.offsetHeight && bottom > elementOffset.top - customOffset.top && left < elementOffset.left + customOffset.right + element.offsetWidth && right > elementOffset.left - customOffset.left;
	    },
	    pushSafe: function pushSafe(array, item) {
	        if (array && array.length) {
	            array.push(item);
	            return array;
	        } else {
	            return [];
	        }
	    },
	
	
	    /**
	     *  Retrieve is Chrome * Safari ≥ 3 Opera ≥ 14
	     * @returns {boolean}
	     */
	    isWebkit: function isWebkit() {
	        return 'WebkitAppearance' in document.documentElement.style;
	    },
	    isWindows: function isWindows() {
	        return navigator.platform.indexOf('Win') > -1;
	    },
	
	
	    /**
	     * Check if given two object (with the same properties), have the same values
	     * in each of the properties. Also optionally could check equality for specific set of properties.
	     *
	     * @param {Object} objectA  Object to be compare against to ObjectB.
	     * @param {Object} objectB  Object to be compare against to ObjectA.
	     * @param {Array} onlyProperties (Optional) just compare only the given property of each of object.
	     * @private
	     */
	    isSameObject: function isSameObject(objectA, objectB, onlyProperties) {
	        if (objectA && objectB) {
	            var props = Object.keys(objectA);
	
	            if (onlyProperties && onlyProperties.length > 0) {
	                props = props.filter(function (prop) {
	                    return onlyProperties.indexOf(prop) > -1;
	                });
	            }
	
	            return props.every(function (prop) {
	                if (objectA[prop] && objectB[prop]) {
	                    return objectA[prop] === objectB[prop];
	                }
	                return false;
	            });
	        }
	    },
	
	
	    /**
	     * Given a collection and one register, search and replace the new register for the older.
	     * @param list
	     * @param newItem
	     * @param matchAttribute
	     * @returns {Array}
	     * @private
	     */
	    replace: function replace(list, newItem, matchAttribute) {
	        var newList = _.filter(list, function (oldTask) {
	            return _.get(oldTask, matchAttribute) !== _.get(newItem, matchAttribute);
	        });
	        newList.push(newItem);
	        return newList;
	    },
	
	
	    /**
	     * Given a collection and a list of register, search and replace each new register for the older.
	     * @param list
	     * @param newItems
	     * @param matchAttribute
	     * @returns {Array}
	     * @private
	     */
	    replaceAll: function replaceAll(list, newItems, matchAttribute) {
	        if (list && newItems && list.length && newItems.length) {
	            for (var i = 0; i < newItems.length; i++) {
	                list = this.replace(list, newItems[i], matchAttribute);
	            }
	        }
	        return list;
	    },
	
	
	    /**
	     * Given a collection and one register, search and replace the new register for the older.
	     * @param list
	     * @param newItem
	     * @param matchAttribute
	     * @returns {Array}
	     * @private
	     */
	    replaceByAttributes: function replaceByAttributes(list, newItem, matchAttributes) {
	
	        if (!Array.isArray(matchAttributes)) {
	            // force to always be an array in order to work the following `every` command
	            matchAttributes = [matchAttributes];
	        }
	
	        if (this.isNullOrEmpty(list)) {
	            return list;
	        }
	
	        var hasSomeAttributeToCompare = some(matchAttributes, function (matchAttr) {
	            return Object.keys(list[0]).indexOf(matchAttr) > -1;
	        });
	        if (!hasSomeAttributeToCompare) {
	            // enter here means that any of the attributes match
	            return list;
	        }
	
	        var filteredItems = _.filter(list, function (oldTask) {
	            // filter only items which match all attributes equals
	            return !_.every(matchAttributes, function (matchAttribute) {
	                return _.get(oldTask, matchAttribute) === _.get(newItem, matchAttribute);
	            });
	        });
	
	        filteredItems.push(newItem);
	        return filteredItems;
	    },
	
	
	    /**
	     * Given a collection and a list of register, search and replace the news register for the olders.
	     * @param listWillRemoveDuplicated
	     * @param listToCompare
	     * @param matchAttribute
	     * @returns {Array}
	     * @private
	     */
	    removeDuplicatedList: function removeDuplicatedList(listWillRemoveDuplicated, listToCompare, matchAttribute) {
	        var itemsToFilter = _.map(listToCompare, function (newItem) {
	            return _.get(newItem, matchAttribute);
	        });
	        return _.filter(listWillRemoveDuplicated, function (oldTask) {
	            return !_.includes(itemsToFilter, _.get(oldTask, matchAttribute));
	        });
	    },
	
	
	    /**
	     * Search a specific node element and return it from the component.
	     * @param {HTMLElement}  component  is the component which could have searched target.
	     * @param {String} className        is the class of the component to be searched.
	     * @returns {HTMLElement} The component searched.
	     */
	    getComponentByClassName: function getComponentByClassName(component, className) {
	        while (component && component.classList && !component.classList.contains(className)) {
	            component = component.parentNode;
	        }
	        return component;
	    },
	
	
	    /**
	     * Remove some item which match with {@code objectMatcher} param.
	     * @param list
	     * @param objectMatcher
	     * @return {*}
	     */
	    removeItemByObjectEquality: function removeItemByObjectEquality(list, objectMatcher) {
	        return _.filter(list, function (item) {
	            var attrFields = Object.keys(objectMatcher);
	            var isTargetItem = _.every(attrFields, function (attribute) {
	                return item[attribute] === objectMatcher[attribute];
	            });
	            return !isTargetItem;
	        });
	    },
	    setAttribute: function setAttribute(obj, attr, value) {
	        if (attr.includes('.')) {
	            var allAttributes = attr.split('.');
	            var firstAttribute = allAttributes[0];
	            return this._setAttribute(obj, firstAttribute, allAttributes, value);
	        } else {
	            return obj[attr] = value;
	        }
	    },
	    _setAttribute: function _setAttribute(obj, attribute, attributes, value) {
	
	        var currentIndexAttribute = attributes.indexOf(attribute);
	
	        if (!obj) {
	            obj = {};
	        }
	
	        var isLastAttribute = currentIndexAttribute + 1 === attributes.length;
	
	        if (isLastAttribute) {
	            // leaf attribute
	            obj[attribute] = value;
	        } else {
	            // going deeper
	            var nextObj = obj[attribute];
	            var nextAttribute = attributes[currentIndexAttribute + 1];
	            obj[attribute] = this._setAttribute(nextObj, nextAttribute, attributes, value);
	        }
	
	        return obj;
	    },
	
	
	    /**
	     * Search a specific node element and return it from the component.
	     * @param {HTMLElement}  component  is the component which could have searched target.
	     * @param {String} attribute    is the name of the attribute target.
	     * @returns {HTMLElement} The component searched.
	     */
	    getComponentByAttribute: function getComponentByAttribute(component, attribute) {
	        while (component && component.hasAttribute && !component.hasAttribute(attribute)) {
	            component = component.parentNode;
	        }
	        return component;
	    },
	
	
	    /**
	     * Search a specific node element and return it from the component.
	     * @param {HTMLElement}  component      is the component which could have searched target.
	     * @param {String} targetTagName        is the component name to be searched.
	     * @returns {HTMLElement} The component searched.
	     */
	    getComponentByElement: function getComponentByElement(component, targetTagName) {
	        while (component && component.tagName !== targetTagName) {
	            component = component.parentNode;
	        }
	        return component;
	    },
	
	
	    /**
	     * The safe way to clone an object and lose their reference.
	     * @argument {Object} value     is the object that will be cloned.
	     * @return {Object} The clone object.
	     */
	    clone: function clone(value) {
	        if (!value) {
	            return null;
	        } else {
	            return JSON.parse(JSON.stringify(value));
	        }
	    },
	
	
	    /**
	     * Set given pair key value data into session storage.
	     * @param {String} key
	     * @param {Object} value
	     */
	    saveSession: function saveSession(key, value) {
	        try {
	            sessionStorage.setItem(key, JSON.stringify(value));
	        } catch (err) {
	            if (err.message.includes('exceeded the quota')) {
	                CustomDialog.showWarningConfirmation(t('warning'), t('notification_draft_maximum_capacity_publish'), function () {
	                    DashboardAction.publishingDraft();
	                });
	            }
	        }
	    },
	
	
	    /**
	     * Retrieve value from local session data from given key.
	     * @param {String} key
	     * @return {Object}
	     */
	    getSession: function getSession(key) {
	        if (sessionStorage.getItem(key) && sessionStorage.getItem(key) !== 'undefined') {
	            return JSON.parse(sessionStorage.getItem(key));
	        } else {
	            return '';
	        }
	    },
	
	
	    /**
	     * Set given pair key value data into local storage.
	     * @param {String} key
	     * @param {Object} value
	     */
	    saveLocal: function saveLocal(key, value) {
	        localStorage.setItem(key, JSON.stringify(value));
	    },
	
	
	    /**
	     * Set given pair key value data into local memory.
	     * @param {String} key
	     * @param {Object} value
	     */
	    saveMemory: function saveMemory(key, value) {
	        localMemory[key] = value;
	    },
	
	
	    /**
	     * Retrieve value from local memory data from given key.
	     * @param {String} key
	     * @return {Object}
	     */
	    getMemory: function getMemory(key) {
	        return localMemory[key];
	    },
	
	
	    /**
	     * Retrieve value from local session data from given key.
	     * @param {String} key
	     * @return {Object}
	     */
	    getLocal: function getLocal(key) {
	        if (localStorage.getItem(key) && localStorage.getItem(key) !== 'undefined') {
	            return JSON.parse(localStorage.getItem(key));
	        } else {
	            return '';
	        }
	    },
	
	
	    /**
	     * Filter event argument from arrays of arguments.
	     * @param arguments
	     * @return {*|Array}
	     */
	    filterEvents: function filterEvents(args) {
	        if (args) {
	            return _.find(args, function (argument) {
	                return argument && argument.eventPhase && argument.target;
	            });
	        }
	    },
	
	
	    /**
	     * Sort given list objets by given attribute
	     * @param list
	     * @param attr
	     * @returns {*}
	     */
	    sortList: function sortList(list, attr) {
	        var a,
	            b,
	            a1,
	            b1,
	            rx = /(\d+)|(\D+)/g,
	            rd = /\d+/;
	
	        if (list === undefined || list.sort === undefined) {
	            return list;
	        }
	
	        return (list || []).sort(function (as, bs) {
	            a = String(_.get(as, attr)).toLowerCase().match(rx);
	            b = String(_.get(bs, attr)).toLowerCase().match(rx);
	            while (a.length && b.length) {
	                a1 = a.shift();
	                b1 = b.shift();
	                if (rd.test(a1) || rd.test(b1)) {
	                    if (!rd.test(a1)) return 1;
	                    if (!rd.test(b1)) return -1;
	                    if (a1 != b1) return a1 - b1;
	                } else if (a1 != b1) return a1 > b1 ? 1 : -1;
	            }
	            return a.length - b.length;
	        });
	    },
	    sortListDesc: function sortListDesc(list, attr) {
	        return _.orderBy(list, [attr], ['desc']);
	    },
	    sortListByValue: function sortListByValue(list, attr, value) {
	        if (this.isNotEmptyArray(list)) {
	            return _.sortBy(list, function (fieldOne) {
	                return get(fieldOne, attr) === value ? -1 : 1;
	            });
	        } else {
	            return list;
	        }
	    },
	    filterNumbers: function filterNumbers(arrays) {
	        if (this.isNotEmptyArray(arrays)) {
	            return _.filter(arrays, function (obj) {
	                var isNumber = typeof obj === 'number';
	                return !isNumber;
	            });
	        }
	        return arrays;
	    },
	
	
	    /**
	     * Return the duplicate register from given list.
	     * @param list
	     * @returns {Array.<T>}
	     */
	    getDuplicates: function getDuplicates(list) {
	        var uniq = list.map(function (name) {
	            return { count: 1, name: name };
	        }).reduce(function (a, b) {
	            a[b.name] = (a[b.name] || 0) + b.count;
	            return a;
	        }, {});
	
	        return Object.keys(uniq).filter(function (a) {
	            return uniq[a] > 1;
	        });
	    },
	
	
	    /**
	     * Retrieve the non-duplicate register from given list.
	     * @param list
	     * @returns {Array.<T>}
	     */
	    getNonDuplicates: function getNonDuplicates(list) {
	        var uniq = list.map(function (name) {
	            return { count: 1, name: name };
	        }).reduce(function (a, b) {
	            a[b.name] = (a[b.name] || 0) + b.count;
	            return a;
	        }, {});
	
	        return Object.keys(uniq).filter(function (a) {
	            return uniq[a] === 1;
	        });
	    },
	
	
	    /**
	     * Retrieve the properly format of error code.
	     * @param message
	     * @returns {string}
	     */
	    formatMessageError: function formatMessageError(message) {
	        return message && message.indexOf('|') > -1 ? message.substring(0, message.indexOf('|')).trim() : message;
	    },
	
	
	    /**
	     * Given field component, check empties condition.
	     * @param value
	     * @returns {*|boolean}
	     */
	    isEmptyField: function isEmptyField(value) {
	        return _.isNull(value) || _.isUndefined(value) || value.getValue === undefined || _.isNull(value.getValue()) || _.isUndefined(value.getValue()) || value.getValue().trim() === '';
	    },
	    isValidText: function isValidText(text, fieldName) {
	        if (_.isNull(text) || _.isUndefined(text) || text === '') {
	            return fieldName + ' ' + t('notification_is_required');
	        } else if (!REGEX_NAME_DEFAULT.test(text)) {
	            return '' + t('notification_error_invalid_character');
	        } else if (text.length < 1) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_small');
	        } else if (text.length > 90) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_long');
	        }
	        return '';
	    },
	    isValidTextNotRequired: function isValidTextNotRequired(text, fieldName) {
	        if (_.isNull(text) || _.isUndefined(text) || text === '') {
	            return '';
	        } else if (!REGEX_NAME_DEFAULT.test(text)) {
	            return '' + t('notification_error_invalid_character');
	        } else if (text.length < 1) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_small');
	        } else if (text.length > 90) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_long');
	        }
	        return '';
	    },
	    isValidTextNotRequiredWithCustomValidation: function isValidTextNotRequiredWithCustomValidation(text, fieldName) {
	        var customRegex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : REGEX_NAME_DEFAULT;
	
	        if (_.isNull(text) || _.isUndefined(text) || text === '') {
	            return '';
	        } else if (!customRegex.test(text)) {
	            return '' + t('notification_error_invalid_character');
	        } else if (text.length < 1) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_small');
	        } else if (text.length > 90) {
	            return t('notification_label_the') + ' ' + fieldName + ' ' + t('notification_is_too_long');
	        }
	        return '';
	    },
	    isEmptyArray: function isEmptyArray(array) {
	        return _.get(array, 'length', 0) === 0;
	    },
	    isNotEmptyArray: function isNotEmptyArray(array) {
	        return _.get(array, 'length', 0) > 0;
	    },
	    stringifyObject: function stringifyObject(obj) {
	        if (!obj) {
	            return;
	        }
	
	        // open obj
	        var objString = '{';
	
	        for (var property in obj) {
	            objString += property;
	            objString += ':';
	            objString += typeof obj[property] === 'string' ? '"' + obj[property] + '"' : obj[property];
	            objString += ',';
	        }
	
	        // remove the last ','
	        objString = objString.substring(0, objString.length - 1);
	
	        // close obj
	        objString += '}';
	
	        return objString;
	    },
	
	
	    /**
	     * Remove item duplicate, checking equality by given attributes.
	     * @param array
	     * @param props
	     * @return {*}
	     */
	    removeDuplicateByAttribute: function removeDuplicateByAttribute(array, props) {
	        var _this = this;
	
	        if (_.get(array, 'length', 0) === 0 || _.get(props, 'length', 0) === 0) {
	            return array;
	        }
	
	        var nonDuplicates = [];
	
	        var _loop = function _loop() {
	            if (_isArray) {
	                if (_i >= _iterator.length) return 'break';
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) return 'break';
	                _ref = _i.value;
	            }
	
	            var obj = _ref;
	
	            var isDuplicate = _.some(nonDuplicates, function (target) {
	                return _this.isSameObject(target, obj, props);
	            });
	            if (!isDuplicate) {
	                nonDuplicates.push(obj);
	            }
	        };
	
	        for (var _iterator = array, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	
	        return nonDuplicates;
	    },
	
	
	    /**
	     * Retrieve in safe way the number of given string
	     * @param order
	     * @return {number}
	     */
	    getNumber: function getNumber(number) {
	        var defaultResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (typeof number === 'number') {
	            return number;
	        }
	        if (!number) {
	            return defaultResult;
	        }
	        if (number && number.match) {
	            return +_.join(number.match(/[\d]/gi), '');
	        } else {
	            return defaultResult;
	        }
	    },
	
	
	    /**
	     * Retrieve the object of given string content.
	     * @param {String} content The content that will be parsed
	     * @param {String} field (Optionally)
	     * @return {Object}
	     */
	    parse: function parse(content, field) {
	        if (!content) {
	            return content;
	        }
	
	        try {
	            if (field) {
	                var resultContent = _.get(content, field);
	                return typeof resultContent === 'string' ? JSON.parse(resultContent) : resultContent;
	            } else {
	                return typeof content === 'string' ? JSON.parse(content) : content;
	            }
	        } catch (e) {
	            console.error(e.message);
	            return content;
	        }
	    },
	
	
	    /**
	     * Convert given object to another serialized string object.
	     *
	     * @param {Object} obj                                  The Object that will be serialized
	     * @param {Boolean} stringifyManually (Optionally)      The Object that will be serialized
	     * @return {String}                                     The serialized object.
	     */
	    stringify: function stringify(obj) {
	        var stringifyManually = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        if (!obj) {
	            return;
	        }
	
	        if (!stringifyManually) {
	            // by default the we stringify an traditional way
	            try {
	                return JSON.stringify(obj);
	            } catch (e) {
	                console.warn('The common way of stringify is not working, fall back to manual way...');
	            }
	        }
	
	        // following here means that traditional way of stringify does'n worked. So we make a manual shallow serialization of given object.
	
	        // open obj
	        var objString = '{';
	
	        for (var property in obj) {
	            objString += property;
	            objString += ':';
	            objString += typeof obj[property] === 'string' ? '"' + obj[property] + '"' : obj[property];
	            objString += ',';
	        }
	
	        // remove the last ','
	        objString = objString.substring(0, objString.length - 1);
	
	        // close obj
	        objString += '}';
	
	        return objString;
	    },
	
	
	    /**
	     * Given an number or string extract the order id that contain.
	     * @param {String} dirtyId       The id that could have string  format with '_BT' prefix or just the number
	     * @return {String}
	     */
	    cleanId: function cleanId(orderId) {
	        if (orderId) {
	
	            if (!orderId || typeof orderId === 'number') {
	                return null;
	            }
	
	            if (this.isBT(orderId)) {
	                return orderId.substring(0, orderId.length - 3);
	            } else if (this.isBH(orderId)) {
	                return orderId.substring(0, orderId.indexOf('_BH'));
	            } else {
	                return orderId;
	            }
	        }
	        return null;
	    },
	    isBT: function isBT(id) {
	        return _.includes(id, 'BT');
	    },
	    isBH: function isBH(id) {
	        return _.includes(id, 'BH');
	    },
	    isBHOnly: function isBHOnly(id) {
	        return !this.isBHBatch(id) && _.includes(id, 'BH');
	    },
	    isBHBatch: function isBHBatch(id) {
	        return _.includes(id, 'BH|');
	    },
	    isSingle: function isSingle(order) {
	        for (var field in order) {
	            if (_.includes(singleAttributes, field)) {
	                return true;
	            }
	        }
	        return false;
	    },
	
	
	    /**
	     * Standardize the way to access information of Combined and Single Orders.
	     * @param order
	     * @param mappingFieldName
	     * @return {*}
	     */
	    getOrderField: function getOrderField(order, mappingFieldName, type) {
	        var offsetDays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	        if (!order) {
	            return;
	        }
	
	        var mappingFields = void 0;
	
	        if (order && order.isSingle) {
	            mappingFields = {
	                startDate: 'fromDate',
	                endDate: 'toDate'
	            };
	        } else {
	            if (this.isBT(type || order.i)) {
	                mappingFields = {
	                    startDate: 'filtrationDate',
	                    endDate: 'orderDate'
	                };
	            } else {
	                mappingFields = {
	                    startDate: 'brewDate',
	                    endDate: 'filtrationDate'
	                };
	            }
	        }
	
	        var dateWithoutOffset = _.get(order, mappingFields[mappingFieldName]);
	        return DateUtils.addDaysTextBasicFormat(dateWithoutOffset, offsetDays);
	    },
	    getTankTypeConfiguration: function getTankTypeConfiguration(tankType) {
	        switch (tankType) {
	            // BY TANK TYPE
	            case TYPE_TANK_FERMENTER:
	                return FERMENTING_INFO;
	            case TYPE_TANK_BRITE_TANK:
	                return PACKAGING_INFO;
	            case TYPE_TANK_BREW_HOUSE:
	                return BREWING_INFO;
	            // BY TASK TYPE
	            case FERMENTER_TYPE_TASK:
	                return FERMENTING_INFO;
	            case TYPE_TASK_FERMENTER:
	                return FERMENTING_INFO;
	            case PACKAGING_TYPE_TASK:
	                return PACKAGING_INFO;
	            case TYPE_TASK_PACKAGING:
	                return PACKAGING_INFO;
	            case BREWING_TYPE_TASK:
	                return BREWING_INFO;
	            case TYPE_TASK_BREWHOUSE:
	                return BREWING_INFO;
	            case 'Brewing':
	                return BREWING_INFO;
	        }
	    },
	
	
	    /**
	     * This kind of order should not exists. The main of this method is to provide to
	     * the user the way to delete this kind of order without change it.
	     * @param order
	     * @return {boolean}
	     */
	    isGhostOrder: function isGhostOrder(order) {
	        if (order) {
	            if (order.isSingle) {
	                return !!order.singleTank === false;
	            } else {
	                return !!order.briteTank === false || !!order.fermenterTank === false;
	            }
	        }
	    },
	
	
	    /**
	     * Just format properly the name of duplicated of given name.
	     *
	     * @param {String} name     Which will be duplicated
	     * @return {String}
	     */
	    formatDuplicateName: function formatDuplicateName(name) {
	        return name + ' - ' + t('label_copy');
	    },
	    formatApplicantIcons: function formatApplicantIcons(allIcons, applicantIcons) {
	        var applicantIconsIds = _.map(applicantIcons, function (applicationIcon) {
	            return _.get(applicationIcon, 'icon.id', _.get(applicationIcon, 'id'));
	        });
	        var allIconsWithoutApplicantIcon = _.filter(allIcons, function (icon) {
	            return !_.includes(applicantIconsIds, _.get(icon, 'id'));
	        });
	        var allIconsHydratedWithApplicantIcon = _.concat(allIconsWithoutApplicantIcon, applicantIcons);
	        return allIconsHydratedWithApplicantIcon;
	    },
	    markProductIcons: function markProductIcons(allIconsWithApplicantIcons, productIcons) {
	        var productIconsId = _.map(productIcons, function (productIcon) {
	            return _.get(productIcon, 'id');
	        });
	
	        return _.map(allIconsWithApplicantIcons, function (icon) {
	            if (_.includes(productIconsId, icon.id)) {
	                icon.isProductIconChecked = true;
	            } else {
	                icon.isProductIconChecked = false;
	            }
	            return icon;
	        });
	    },
	    retrieveNextItemCode: function retrieveNextItemCode(items, item, itemCodeModule) {
	        var categoryField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'category';
	
	        var itemCodeCategory = get(item, categoryField, '').substring(0, 2).toUpperCase(); //  acronym of Item module
	        var itemsWhitSameCategory = filter(items, function (itemFilter) {
	            return get(itemFilter, categoryField) === get(item, categoryField);
	        });
	        var codeItemsWithSameCategory = map(itemsWhitSameCategory, function (itemMapped) {
	            return ContentUtils.getNumber(itemMapped.code);
	        });
	        var isFirstItem = codeItemsWithSameCategory.length === 0;
	        var nextNumber = isFirstItem ? 1 : max(codeItemsWithSameCategory) + 1;
	        var nextItemCode = '' + itemCodeModule + itemCodeCategory + nextNumber;
	
	        return nextItemCode;
	    },
	    getRandomId: function getRandomId() {
	        var S4 = function S4() {
	            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
	        };
	        return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
	    },
	
	
	    /**
	     * Check if given {@param value} if are string or number.
	     * @param {Object || Array} value
	     * @return {boolean}
	     */
	    isStringOrIntegerItem: function isStringOrIntegerItem(value) {
	        if (value === undefined || value === null) {
	            return false;
	        }
	
	        return typeof value[0] === 'string' || typeof value[0] === 'number' || typeof value === 'number' || typeof value === 'string';
	    },
	    filterDisableTankDisabledIfNotHaveOrder: function filterDisableTankDisabledIfNotHaveOrder(tanks, orders) {
	        var existSomeDisabledTank = _.some(tanks, function (tank) {
	            return _.get(tank, 'enable') === false;
	        });
	
	        if (existSomeDisabledTank) {
	            // map tanks id which are disabled
	            var tanksIdDisabled = getTanksIdDisabled(tanks);
	            var tanksIdFromOrders = getTanksIdFromOrders(orders);
	            // search if some disabled tank is related from
	            // some order of current page
	            var tanksDisabledShouldBeVisible = _.intersection(tanksIdDisabled, tanksIdFromOrders);
	            var existSomeTankDisabledWhichNeedToBeVisible = ContentUtils.isNotEmptyArray(tanksDisabledShouldBeVisible);
	
	            if (!existSomeTankDisabledWhichNeedToBeVisible) {
	                // enter here means we filter all tanks disabled
	                // because we don't need theirs
	                var tanksEnable = _.filter(tanks, function (tank) {
	                    return _.get(tank, 'enable') === true || _.get(tank, 'enable') === undefined;
	                });
	                return tanksEnable;
	            }
	
	            return _.filter(tanks, function (tank) {
	                var isDisabledTank = _.get(tank, 'enable') === false;
	                if (isDisabledTank) {
	                    var tankId = _.get(tank, 'id');
	                    var isNeededToBeVisible = tanksDisabledShouldBeVisible.includes(tankId);
	                    return isNeededToBeVisible;
	                } else {
	                    // is enable, this tank we need to return it.
	                    return true;
	                }
	            });
	        } else {
	            // enter here means non exist disable tanks, so we
	            // don't need to filter any tank, just by section if needed.
	            return tanks;
	        }
	    },
	    filterTanksBySections: function filterTanksBySections(tanks, _ref2) {
	        var isVisibleBrewingSection = _ref2.isVisibleBrewingSection,
	            isVisibleFermentingSection = _ref2.isVisibleFermentingSection,
	            isVisiblePackagingSection = _ref2.isVisiblePackagingSection;
	
	        return (tanks || []).filter(function (tank) {
	            return isVisibleBrewingSection && tank.type === 'BH' || isVisibleFermentingSection && tank.type === 'FV' || isVisiblePackagingSection && tank.type === 'BT';
	        });
	    },
	    getNewColumnSingleBySection: function getNewColumnSingleBySection(order, tanks, _ref3) {
	        var isVisibleBrewingSection = _ref3.isVisibleBrewingSection,
	            isVisibleFermentingSection = _ref3.isVisibleFermentingSection,
	            isVisiblePackagingSection = _ref3.isVisiblePackagingSection;
	
	        var column = get(order, 'singleTank.column');
	        var amountBH = tanks.filter(function (t) {
	            return t.type === 'BH';
	        }).length;
	        var amountFV = tanks.filter(function (t) {
	            return t.type === 'FV';
	        }).length;
	
	        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection && order.currentSection === 'BT') {
	            column = column - (amountBH + amountFV) >= 0 ? column - (amountBH + amountFV) : column;
	        } else if (isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection && order.currentSection === 'BT') {
	            column = column - amountFV >= 0 ? column - amountFV : column;
	        } else if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
	            column = column - amountBH >= 0 ? column - amountBH : column;
	        } else if (!isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection && order.currentSection === 'FV') {
	            column = column - amountBH >= 0 ? column - amountBH : column;
	        }
	
	        return column;
	    },
	    getColumnsByCombinedOrderForFermenting: function getColumnsByCombinedOrderForFermenting(state, xPosition) {
	        var isVisibleBrewingSection = state.isVisibleBrewingSection,
	            isVisibleFermentingSection = state.isVisibleFermentingSection,
	            isVisiblePackagingSection = state.isVisiblePackagingSection,
	            tanks = state.tanks;
	
	        var amountBH = tanks.filter(function (t) {
	            return t.type === 'BH';
	        }).length;
	        var amountFV = tanks.filter(function (t) {
	            return t.type === 'FV';
	        }).length;
	
	        if (!isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection) {
	            return xPosition - amountBH;
	        }
	
	        if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
	            return xPosition - amountBH;
	        }
	
	        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
	            return xPosition - (amountBH + amountFV);
	        }
	
	        return xPosition;
	    },
	    getColumnsByCombinedOrderForPackaging: function getColumnsByCombinedOrderForPackaging(state, xPosition) {
	        var isVisibleBrewingSection = state.isVisibleBrewingSection,
	            isVisibleFermentingSection = state.isVisibleFermentingSection,
	            isVisiblePackagingSection = state.isVisiblePackagingSection,
	            tanks = state.tanks;
	
	        var amountBH = tanks.filter(function (t) {
	            return t.type === 'BH';
	        }).length;
	        var amountFV = tanks.filter(function (t) {
	            return t.type === 'FV';
	        }).length;
	
	        if (isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
	            return xPosition - amountFV;
	        }
	        if (!isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection) {
	            return xPosition - (amountFV + amountBH);
	        }
	        if (!isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection) {
	            return xPosition - amountBH;
	        }
	
	        return xPosition;
	    },
	    filterEnable: function filterEnable(items) {
	        return filter(items, function (item) {
	            var stateAttribute = getStateAttribute(item);
	
	            return _.get(item, stateAttribute) === true || // is defined by the user
	            _.get(item, stateAttribute) === undefined || // 'undefined' means is non defined yet, so by default is enable
	            _.get(item, stateAttribute) === null; // 'null' means is non defined yet, so by default is enable
	        });
	    },
	    filterEnableByAttribute: function filterEnableByAttribute(items, attributes) {
	        return filter(items, function (item) {
	            var isSomeDisable = _.some(attributes, function (attribute) {
	                return _.get(item, attribute) === false;
	            });
	            return isSomeDisable ? false : true;
	        });
	    },
	    getAmountPageNeeded: function getAmountPageNeeded(totalAmount, maxAmountPerPage) {
	        var totalAmountPages = 0;
	        if (totalAmount < maxAmountPerPage) {
	            return totalAmountPages;
	        }
	
	        totalAmountPages++;
	        if (totalAmount % maxAmountPerPage > 0) {
	            var resultDivision = numeral(totalAmount).divide(maxAmountPerPage).value();
	            return Math.trunc(resultDivision) + 1;
	        } else {
	            return numeral(totalAmount).divide(maxAmountPerPage).value();
	        }
	    },
	
	
	    /**
	     * This particular case exist because in some scenarios we need to know about the task of each product which come from,
	     * so it's only some specific needed for a short period of time (when need calculate inventory and other stuff), in order
	     * to be serializable again given list of task (avoid circular references), should be cleaned this reference.
	     *
	     * @param tasks
	     * @returns {Array}
	     */
	    cleanAllTasksOfProducts: function cleanAllTasksOfProducts(tasks) {
	        return _.map(tasks, function (task) {
	            if (!task || ContentUtils.isEmptyArray(get(task, 'products'))) {
	                return task;
	            }
	            task.products = _.map(_.get(task, 'products'), function (product) {
	                product.task = null;
	                return product;
	            });
	            return task;
	        });
	    },
	    capitalizeFirstLetter: function capitalizeFirstLetter(string) {
	        return string.charAt(0).toUpperCase() + string.slice(1);
	    },
	    formatMessage: function formatMessage(string) {
	        return this.capitalizeFirstLetter(string.replace(/_/g, ' ').toLowerCase());
	    },
	    isEqualByAttributes: function isEqualByAttributes(listOne, listTwo, attributes) {
	        return _.every(listOne, function (item) {
	            return _.some(listTwo, function (itemCompare) {
	                return _.every(attributes, function (attribute) {
	                    return itemCompare[attribute] === item[attribute];
	                });
	            });
	        });
	    },
	    isValidEmail: function isValidEmail(email) {
	        return EMAIL_REGEX.test(String(email).toLowerCase());
	    },
	    sortTanksAndAddColumn: function sortTanksAndAddColumn(tanks) {
	        var briteTanks, fermenterTanks, sortedTanks, brewhouseTanks;
	        if (tanks) {
	            // Group by type tanks.
	            briteTanks = _.filter(tanks, function (tank) {
	                return tank.type === TYPE_TANK_BRITE_TANK;
	            });
	            fermenterTanks = _.filter(tanks, function (tank) {
	                return tank.type === TYPE_TANK_FERMENTER;
	            });
	
	            brewhouseTanks = _.filter(tanks, function (tank) {
	                return tank.type === TYPE_TANK_BREW_HOUSE;
	            });
	
	            // Add sections field names
	            briteTanks = _.map(briteTanks, function (tank) {
	                tank.section = PACKAGING_SECTION_NAME;
	                return tank;
	            });
	            fermenterTanks = _.map(fermenterTanks, function (tank) {
	                tank.section = FERMENTING_SECTION_NAME;
	                return tank;
	            });
	            brewhouseTanks = _.map(brewhouseTanks, function (tank) {
	                tank.section = BREWING_SECTION_NAME;
	                return tank;
	            });
	
	            // Sort each type of group by their number
	            fermenterTanks = ContentUtils.sortList(fermenterTanks, 'name');
	            briteTanks = ContentUtils.sortList(briteTanks, 'name');
	            brewhouseTanks = ContentUtils.sortList(brewhouseTanks, 'name');
	
	            // The order that concat will change the order of visible tanks, eg fist brewhouse,
	            sortedTanks = _.concat(brewhouseTanks, fermenterTanks, briteTanks);
	
	            //Assign column attribute
	            sortedTanks = map(sortedTanks, function (tank, index) {
	                tank.column = index;
	                return tank;
	            });
	            return sortedTanks;
	        } else {
	            return tanks;
	        }
	    },
	    getItemId: function getItemId(obj) {
	        return _.get(obj, 'itemId') || _.get(obj, 'item.id') || _.get(obj, 'id');
	    },
	    filterNonInventoryItems: function filterNonInventoryItems(items) {
	        return _.filter(items, function (item) {
	            return _.get(item, 'category') !== ITEM_CATEGORY_NON_INVENTORY;
	        });
	    },
	    /*
	     /**
	    * Get color (black/white) depending on bgColor so it would be clearly seen.
	    * @param bgColor
	    * @returns {string}
	    */
	    getColorByBgColor: function getColorByBgColor(bgColor) {
	        if (!bgColor) bgColor = '';
	
	        var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
	        var r = parseInt(color.substring(0, 2), 16); // hexToR
	        var g = parseInt(color.substring(2, 4), 16); // hexToG
	        var b = parseInt(color.substring(4, 6), 16); // hexToB
	        return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000' : '#fff';
	    },
	    sortIcons: function sortIcons(items) {
	        return _.sortBy(items.map(function (item) {
	            item.sortOrder = getIconSortOrder(item.name);
	            return item;
	        }), 'sortOrder', ['desc']);
	    },
	    getIconText: function getIconText(text) {
	        return getIconData(text).icon;
	    }
	};
	
	function getIconSortOrder(text) {
	    return getIconData(text).sortOrder;
	}
	
	function getIconData(text) {
	    if (!text) {
	        text = '';
	    }
	    if (text.match(/VISIBILITY/)) {
	        return { icon: 'visibility', sortOrder: 0 };
	    } else if (text.match(/NEW/)) {
	        return { icon: 'add', sortOrder: 2 };
	    } else if (text.match(/EDIT/) || text === 'ADMIN_INVENTORY_AND_TRANSFERS_TRANSFER_SHOW' || text === 'ADMIN_INVENTORY_AND_TRANSFERS_ADJUST_SHOW') {
	        return { icon: 'mode_edit', sortOrder: 3 };
	    } else if (text.match(/DELETE/)) {
	        return { icon: 'remove', sortOrder: 4 };
	    } else if (text.match(/PRINT/)) {
	        return { icon: 'print', sortOrder: 5 };
	    } else if (text.match(/CONFIRM/)) {
	        return { icon: 'done', sortOrder: 7 };
	    } else if (text.match(/SEND/)) {
	        return { icon: 'send', sortOrder: 8 };
	    } else if (text.match(/ADMIN_REPORT/) && text !== 'ADMIN_REPORT_SHOW') {
	        return { icon: 'file_download', sortOrder: 9 };
	    } else if (text.match(/DUPLICATE/) || text === 'ADMIN_PRODUCT_DUPLICATE_SHOW') {
	        return { icon: 'content_copy', sortOrder: 6 };
	    } else if (text.match(/SHOW/)) {
	        return { icon: 'visibility', sortOrder: 1 };
	    } else {
	        return { icon: 'visibility', sortOrder: 0 };
	    }
	}
	
	/**
	 * Return the name of the state attribute.
	 * @param item
	 * @return {*}
	 */
	function getStateAttribute(item) {
	    var value = _.get(item, 'enable');
	    var isDefined = value !== null && value !== undefined;
	
	    if (isDefined) {
	        return 'enable';
	    } else {
	        return 'isEnable';
	    }
	}
	
	function getTanksIdDisabled(tanks) {
	    return _.map(_.filter(tanks, function (tank) {
	        return _.get(tank, 'enable') === false;
	    }), function (tank) {
	        return tank.id;
	    });
	}
	
	function getTanksIdFromOrders(orders) {
	    return _.flatten(_.map(orders, function (order) {
	        var tanksId = [];
	        var isSingleOrder = order && order.isSingle === true;
	        var haveBatchs = order && ContentUtils.isNotEmptyArray(order.batchs);
	
	        if (isSingleOrder) {
	            tanksId.push(order.singleTankId);
	        } else {
	            tanksId.push(order.briteTankId);
	            tanksId.push(order.fermenterTankId);
	        }
	        // add id of all turns
	        if (haveBatchs) {
	            for (var _iterator2 = order.batchs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                var _ref4;
	
	                if (_isArray2) {
	                    if (_i2 >= _iterator2.length) break;
	                    _ref4 = _iterator2[_i2++];
	                } else {
	                    _i2 = _iterator2.next();
	                    if (_i2.done) break;
	                    _ref4 = _i2.value;
	                }
	
	                var batch = _ref4;
	
	                var turnId = _.get(batch, 'turnId');
	                tanksId.push(turnId);
	            }
	        }
	
	        return tanksId;
	    }));
	}
	
	module.exports = ContentUtils;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'at': __webpack_require__(908),
	  'countBy': __webpack_require__(923),
	  'each': __webpack_require__(936),
	  'eachRight': __webpack_require__(937),
	  'every': __webpack_require__(940),
	  'filter': __webpack_require__(944),
	  'find': __webpack_require__(945),
	  'findLast': __webpack_require__(948),
	  'flatMap': __webpack_require__(951),
	  'forEach': __webpack_require__(350),
	  'forEachRight': __webpack_require__(485),
	  'groupBy': __webpack_require__(966),
	  'includes': __webpack_require__(969),
	  'invokeMap': __webpack_require__(978),
	  'keyBy': __webpack_require__(1001),
	  'map': __webpack_require__(494),
	  'orderBy': __webpack_require__(1025),
	  'partition': __webpack_require__(1035),
	  'reduce': __webpack_require__(1045),
	  'reduceRight': __webpack_require__(1046),
	  'reject': __webpack_require__(1047),
	  'sample': __webpack_require__(1053),
	  'sampleSize': __webpack_require__(501),
	  'shuffle': __webpack_require__(1056),
	  'size': __webpack_require__(1057),
	  'some': __webpack_require__(1060),
	  'sortBy': __webpack_require__(1061)
	};


/***/ },
/* 9 */
/***/ function(module, exports) {

	module.exports = function() {
		var list = [];
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
		return list;
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {};
	
	module.exports = function(list) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
		var styles = listToStyles(list);
		addStylesToDom(styles);
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j]));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j]));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			// var sourceMap = item[3];
			var part = {css: css, media: media/*, sourceMap: sourceMap*/};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function addStyle(obj) {
		var styleElement = document.createElement("style");
		var head = document.head || document.getElementsByTagName("head")[0];
		styleElement.type = "text/css";
		head.appendChild(styleElement);
		applyToTag(styleElement, obj);
		return function(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media /*&& newObj.sourceMap === obj.sourceMap*/)
					return;
				applyToTag(styleElement, obj = newObj);
			} else {
				head.removeChild(styleElement);
			}
		};
	};
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		// var sourceMap = obj.sourceMap;
	
		// No browser support
		// if(sourceMap && typeof btoa === "function") {
			// try {
				// css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(JSON.stringify(sourceMap)) + " */";
			// } catch(e) {}
		// }
		if(media) {
			styleElement.setAttribute("media", media)
		}
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	
	}


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var UIStateStore = __webpack_require__(183),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AppActionCreators = __webpack_require__(227),
	    Constants = __webpack_require__(2),
	    ActionTypes = Constants.ActionTypes,
	    RestUtils = __webpack_require__(51),
	    Security = __webpack_require__(13).auth,
	    ContentUtils = __webpack_require__(7),
	    BrowserUtils = __webpack_require__(185),
	    EventEmitter = __webpack_require__(109).EventEmitter,
	    hostApi = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    assign = __webpack_require__(74),
	    UserServiceImpl = __webpack_require__(181),
	    LocaleServiceImpl = __webpack_require__(407),
	    SessionActionCreators = __webpack_require__(228),
	    CustomDialog = __webpack_require__(26),
	    SchedulerAppDispatcher = __webpack_require__(42),
	    get = __webpack_require__(5).get,
	    UserPermissionStore = __webpack_require__(184),
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    filter = _require2.filter,
	    map = _require2.map,
	    some = _require2.some,
	    CHANGE_EVENT = 'emit',
	    KEY_IS_VISIBLE_BREWING_SECTION = 'cache_is_visible_brewing_section',
	    KEY_IS_VISIBLE_FERMENTING_SECTION = 'cache_is_visible_fermenting_section',
	    KEY_IS_VISIBLE_PACKAGING_SECTION = 'cache_is_visible_packaging_section',
	    KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING = 'cache_is_visible_beer_style_label_brewing',
	    KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING = 'cache_is_visible_beer_style_label_fermenting',
	    KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING = 'cache_is_visible_beer_style_label_packaging',
	    KEY_APPLICANT_USER_LOGGED = 'cache_applicant_user_logged',
	    KEY_LAST_BATCH_NUMBER = 'cache_last_batch_number',
	    KEY_APPLICANT_LICENSE = 'cache_applicant_license',
	    KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH = 'cache_has_pending_draft_without_publish',
	    KEY_APPLICANT_PHONE = 'cache_applicant_phone',
	    KEY_APPLICANT_EMAIL = 'cache_applicant_email',
	    KEY_ROLES_USER_LOGGED = 'cache_roles_user_logged',
	    KEY_CURRENCY = 'cache_current_currency',
	    KEY_CURRENCY_DIGITS = 'cache_current_currency_digits',
	    KEY_LOCATION = 'cache_current_locator',
	    KEY_TIME_ZONE = 'cache_current_timezone',
	    KEY_COUNTRY = 'cache_current_country',
	    KEY_CREATED_DATE = 'created_date',
	    KEY_IS_CALCULATING_INVENTORY_ENABLED = 'cache_is_calculating_inventory_enable',
	    KEY_CURRENCY_CONVERTER = 'cache_current_currency_converter',
	    KEY_COUNTRY_NAME = 'cache_current_country_name',
	    KEY_APPLICANT_DISPLAY_NAME = 'cache_applicant_display_name',
	    KEY_APPLICANT_ID = 'cache_applicant_id',
	    KEY_APPLICANT_ADDRESS = 'cache_applicant_address',
	    KEY_APPLICANT_TAX_ID = 'cache_applicant_city_tax_id',
	    KEY_APPLICANT_CITY_AND_STATE = 'cache_applicant_city_and_state',
	    KEY_USER_NAME = 'cache_user_name',
	    KEY_PERMISSIONS = 'cache_permissions',
	    KEY_USER_PERMISSIONS = 'cache_user_permissions',
	    KEY_LANGUAGE = 'cache_current_language',
	    KEY_MAX_INVENTORY_SCOPE_DATE = 'cache_max_inventory_scope_date';
	
	
	var PREFERRED_LANGUAGE = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en';
	
	var SessionStore = assign({}, EventEmitter.prototype, {
	
	    /**
	     * The last number of publish version fetched from the server.
	     *
	     * NOTE: this are not store in the local store, in order to sync between
	     * different windows in the same browser in the same applicant. The same for lastBrewingNoteNumber version.
	     */
	    lastPublishVersion: -1,
	    _isUserTaskFetching: true,
	
	    /**
	     * The last number of note version fetched from the server.
	     */
	    lastBrewingNoteNumber: -1,
	
	    /**
	     * The last number of note version fetched from the server.
	     */
	    lastPackagingNoteNumber: -1,
	
	    /**
	     * A list of information which each countries.
	     */
	    countries: [],
	
	    /**
	     * A list of information of currencies.
	     */
	    currencies: [],
	
	    /**
	     * Return the current app version.
	     * @returns {Number}
	     */
	    getCurrentAppVersion: function getCurrentAppVersion() {
	        return ContentUtils.getSession(Constants.APP_VERSION_KEY);
	    },
	    setDefaultLenguage: function setDefaultLenguage() {
	        ContentUtils.saveSession(Constants.DEFAULT_LANGUAGE);
	    },
	    setPreferredLenguage: function setPreferredLenguage() {
	        ContentUtils.saveSession(PREFERRED_LANGUAGE);
	    },
	    setMaxScopeInventoryDate: function setMaxScopeInventoryDate(date) {
	        ContentUtils.saveSession(KEY_MAX_INVENTORY_SCOPE_DATE, date);
	    },
	    getMaxScopeInventoryDate: function getMaxScopeInventoryDate() {
	        return ContentUtils.getSession(KEY_MAX_INVENTORY_SCOPE_DATE);
	    },
	
	
	    /**
	     * Update current app version.
	     * @param version
	     */
	    setCurrentAppVersion: function setCurrentAppVersion(version) {
	        ContentUtils.saveSession(Constants.APP_VERSION_KEY, version);
	    },
	
	
	    /**
	     * Retrieve the last number of publish order version fetched from the server.
	     */
	    getLastPublishVersion: function getLastPublishVersion() {
	        return this.lastPublishVersion;
	    },
	
	
	    /**
	     * Assign the new last published version.
	     * @param newVersion
	     */
	    setLastPublishVersion: function setLastPublishVersion(newVersion) {
	        this.lastPublishVersion = newVersion;
	    },
	
	
	    /**
	     * Retrieve the last brewing number of note version fetched from the server.
	     */
	    getLastBrewingNoteNumber: function getLastBrewingNoteNumber() {
	        return this.lastBrewingNoteNumber;
	    },
	
	
	    /**
	     * Assign the new last published version.
	     * @param newVersion
	     */
	    setLastPublicationAdminNumber: function setLastPublicationAdminNumber(newVersion) {
	        this.lastPublicationAdminNumber = newVersion;
	    },
	
	    /**
	     * Retrieve the last brewing number of note version fetched from the server.
	     */
	    getLastChangeUserToken: function getLastChangeUserToken() {
	        return this.lastChangeUserToken;
	    },
	    /**
	     * Assign the new last published version.
	     * @param newVersion
	     */
	    setLastChangeUserToken: function setLastChangeUserToken(newVersion) {
	        this.lastChangeUserToken = newVersion;
	    },
	
	    /**
	     * Retrieve the last brewing number of note version fetched from the server.
	     */
	    getLastPublicationAdminNumber: function getLastPublicationAdminNumber() {
	        return this.lastPublicationAdminNumber;
	    },
	
	    /**
	     * Assign the new last brewing note version.
	     * @param newVersion
	     */
	    setLastBrewingNoteNumber: function setLastBrewingNoteNumber(newVersion) {
	        this.lastBrewingNoteNumber = newVersion;
	    },
	
	
	    /**
	     * Retrieve the last oackaging number of note version fetched from the server.
	     */
	    getLastPackagingNoteNumber: function getLastPackagingNoteNumber() {
	        return this.lastPackagingNoteNumber;
	    },
	
	
	    /**
	     * Assign the new last packaging note version.
	     * @param newVersion
	     */
	    setLastPackagingNoteNumber: function setLastPackagingNoteNumber(newVersion) {
	        this.lastPackagingNoteNumber = newVersion;
	    },
	    emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	    },
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	    setCurrentUserRoles: function setCurrentUserRoles(roles) {
	        ContentUtils.saveSession(KEY_ROLES_USER_LOGGED, roles);
	    },
	    setCurrentCurrency: function setCurrentCurrency(currency) {
	        ContentUtils.saveLocal(KEY_CURRENCY, currency);
	    },
	    setCurrentCurrencyDigits: function setCurrentCurrencyDigits(digits) {
	        ContentUtils.saveLocal(KEY_CURRENCY_DIGITS, digits);
	    },
	    setHasPendingSavedDraftWithoutPublish: function setHasPendingSavedDraftWithoutPublish(hasPublish) {
	        ContentUtils.saveSession(KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH, hasPublish);
	    },
	    getHasPendingSavedDraftWithoutPublish: function getHasPendingSavedDraftWithoutPublish() {
	        return ContentUtils.getSession(KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH);
	    },
	    setUserTaskFetching: function setUserTaskFetching(isUserTaskFetching) {
	        this._isUserTaskFetching = isUserTaskFetching;
	    },
	    setUserTaskDate: function setUserTaskDate(date) {
	        this._userTaskDate = date;
	    },
	    getUserTaskDate: function getUserTaskDate() {
	        return this._userTaskDate;
	    },
	    isUserTaskFetching: function isUserTaskFetching() {
	        return this._isUserTaskFetching;
	    },
	    getCurrentCurrency: function getCurrentCurrency() {
	        return ContentUtils.getLocal(KEY_CURRENCY);
	    },
	    getCurrentCurrencyDigits: function getCurrentCurrencyDigits() {
	        return ContentUtils.getLocal(KEY_CURRENCY_DIGITS);
	    },
	    setCurrentCurrencyConverter: function setCurrentCurrencyConverter(currency) {
	        ContentUtils.saveSession(KEY_CURRENCY_CONVERTER, currency);
	    },
	    getCurrentCurrencyConverter: function getCurrentCurrencyConverter() {
	        return ContentUtils.getSession(KEY_CURRENCY_CONVERTER);
	    },
	    setCurrentLocation: function setCurrentLocation(location) {
	        ContentUtils.saveSession(KEY_LOCATION, location);
	    },
	    setLastBatchNumber: function setLastBatchNumber(batchNumber) {
	        ContentUtils.saveSession(KEY_LAST_BATCH_NUMBER, batchNumber);
	    },
	    getLastBatchNumber: function getLastBatchNumber() {
	        return ContentUtils.getSession(KEY_LAST_BATCH_NUMBER);
	    },
	    getCurrentLocation: function getCurrentLocation() {
	        return ContentUtils.getSession(KEY_LOCATION) || PREFERRED_LANGUAGE;
	    },
	    setCurrentTimezone: function setCurrentTimezone(location) {
	        ContentUtils.saveSession(KEY_TIME_ZONE, location);
	    },
	    getCurrentTimeZone: function getCurrentTimeZone() {
	        return ContentUtils.getSession(KEY_TIME_ZONE);
	    },
	    setCurrentLanguage: function setCurrentLanguage(language) {
	        ContentUtils.saveLocal(KEY_LANGUAGE, language);
	    },
	    getCurrentLanguage: function getCurrentLanguage() {
	        return ContentUtils.getLocal(KEY_LANGUAGE);
	    },
	    setCurrentLicense: function setCurrentLicense(license) {
	        ContentUtils.saveSession(KEY_APPLICANT_LICENSE, license);
	    },
	    getCurrentLicense: function getCurrentLicense() {
	        return ContentUtils.getSession(KEY_APPLICANT_LICENSE);
	    },
	    setCreatedDate: function setCreatedDate(createdDate) {
	        ContentUtils.saveSession(KEY_CREATED_DATE, createdDate);
	    },
	    getCreatedDate: function getCreatedDate() {
	        return ContentUtils.getSession(KEY_CREATED_DATE);
	    },
	    setApplicantDisplayName: function setApplicantDisplayName(name) {
	        ContentUtils.saveSession(KEY_APPLICANT_DISPLAY_NAME, name);
	    },
	    getApplicantDisplayName: function getApplicantDisplayName() {
	        var displayName = ContentUtils.getSession(KEY_APPLICANT_DISPLAY_NAME);
	        if (!displayName) {
	            return Security.getCurrentApplicant();
	        } else {
	            return displayName;
	        }
	    },
	    getCurrentCountry: function getCurrentCountry() {
	        return ContentUtils.getSession(KEY_COUNTRY);
	    },
	    setCurrentCountry: function setCurrentCountry(location) {
	        ContentUtils.saveSession(KEY_COUNTRY, location);
	    },
	    setCurrentCountryName: function setCurrentCountryName(location) {
	        ContentUtils.saveSession(KEY_COUNTRY_NAME, location);
	    },
	    getCurrentCountryName: function getCurrentCountryName() {
	        return ContentUtils.getSession(KEY_COUNTRY_NAME);
	    },
	    setCurrentApplicant: function setCurrentApplicant(applicant) {
	        ContentUtils.saveSession(KEY_APPLICANT_USER_LOGGED, applicant);
	    },
	    setIsCalculatingInventory: function setIsCalculatingInventory(isCalculatingInventoryEnabled) {
	        ContentUtils.saveLocal(KEY_IS_CALCULATING_INVENTORY_ENABLED, isCalculatingInventoryEnabled);
	    },
	    isCalculatingInventory: function isCalculatingInventory() {
	        return ContentUtils.getLocal(KEY_IS_CALCULATING_INVENTORY_ENABLED);
	    },
	    getCurrentUserRoles: function getCurrentUserRoles() {
	        return ContentUtils.getSession(KEY_ROLES_USER_LOGGED);
	    },
	    getCurrentApplicant: function getCurrentApplicant() {
	        return ContentUtils.getSession(KEY_APPLICANT_USER_LOGGED);
	    },
	    getApplicantAddress: function getApplicantAddress() {
	        return ContentUtils.getSession(KEY_APPLICANT_ADDRESS);
	    },
	    isVisibleBrewingSection: function isVisibleBrewingSection() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_BREWING_SECTION);
	    },
	    setIsVisibleBrewingSection: function setIsVisibleBrewingSection(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_BREWING_SECTION, value);
	    },
	    isVisibleFermentingSection: function isVisibleFermentingSection() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_FERMENTING_SECTION);
	    },
	    setIsVisibleFermentingSection: function setIsVisibleFermentingSection(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_FERMENTING_SECTION, value);
	    },
	    isVisiblePackagingSection: function isVisiblePackagingSection() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_PACKAGING_SECTION);
	    },
	    setIsVisiblePackagingSection: function setIsVisiblePackagingSection(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_PACKAGING_SECTION, value);
	    },
	    isVisibleBeerStyleLabelBrewing: function isVisibleBeerStyleLabelBrewing() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING);
	    },
	    setIsVisibleBeerStyleLabelBrewing: function setIsVisibleBeerStyleLabelBrewing(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING, value);
	    },
	    isVisibleBeerStyleLabelFermenting: function isVisibleBeerStyleLabelFermenting() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING);
	    },
	    setIsVisibleBeerStyleLabelFermenting: function setIsVisibleBeerStyleLabelFermenting(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING, value);
	    },
	    isVisibleBeerStyleLabelPackaging: function isVisibleBeerStyleLabelPackaging() {
	        return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING);
	    },
	    setIsVisibleBeerStyleLabelPackaging: function setIsVisibleBeerStyleLabelPackaging(value) {
	        ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING, value);
	    },
	    setApplicantAddress: function setApplicantAddress(address) {
	        ContentUtils.saveSession(KEY_APPLICANT_ADDRESS, address);
	    },
	    setApplicantCityAndState: function setApplicantCityAndState(address) {
	        ContentUtils.saveSession(KEY_APPLICANT_CITY_AND_STATE, address);
	    },
	    setApplicantTaxId: function setApplicantTaxId(taxId) {
	        ContentUtils.saveSession(KEY_APPLICANT_TAX_ID, taxId);
	    },
	    getApplicantTaxId: function getApplicantTaxId() {
	        return ContentUtils.getSession(KEY_APPLICANT_TAX_ID);
	    },
	    getApplicantCityAndState: function getApplicantCityAndState() {
	        return ContentUtils.getSession(KEY_APPLICANT_CITY_AND_STATE);
	    },
	    getApplicantPhone: function getApplicantPhone() {
	        return ContentUtils.getSession(KEY_APPLICANT_PHONE);
	    },
	    setApplicantPhone: function setApplicantPhone(applicantPhone) {
	        ContentUtils.saveSession(KEY_APPLICANT_PHONE, applicantPhone);
	    },
	    getApplicantEmail: function getApplicantEmail() {
	        return ContentUtils.getSession(KEY_APPLICANT_EMAIL);
	    },
	    setApplicantEmail: function setApplicantEmail(email) {
	        ContentUtils.saveSession(KEY_APPLICANT_EMAIL, email);
	    },
	    getAccountAgeDays: function getAccountAgeDays() {
	        var createdDate = new Date(this.getCreatedDate());
	        var currentDate = new Date();
	
	        return (currentDate - createdDate) / 1000 / 60 / 60 / 24;
	    },
	
	
	    // This function is a legacy function to determine what features the user has access to.
	    // For now, we set it all to true no matter what the user is, because we will gate access
	    // based on trial version and time frame.
	    isFullPaidVersion: function isFullPaidVersion() {
	        var isTrialActive = this.isTrialVersionActive();
	        return this.getCurrentLicense() === Constants.LICENSE_FULL_VERSION || this.isTrialVersion() && isTrialActive || this.isBasePaidVersion && isTrialActive;
	    },
	    isPaidVersion: function isPaidVersion() {
	        return this.isFullPaidVersion() || this.isBasePaidVersion() || this.isTrialVersion() && this.isTrialVersionActive();
	    },
	    isTrialVersionActive: function isTrialVersionActive() {
	        return this.getAccountAgeDays() < 14;
	    },
	    isTrialVersion: function isTrialVersion() {
	        return this.getCurrentLicense() === Constants.LICENSE_TRIAL_FULL_VERSION;
	    },
	    isBasePaidVersion: function isBasePaidVersion() {
	        return this.getCurrentLicense() === Constants.LICENSE_FREE_VERSION;
	    },
	
	
	    /**
	     * Retrieve if the current user logged is an adming user.
	     * @return {Boolean}
	     */
	    isAdminUser: function isAdminUser() {
	        if (BrowserUtils.isMobileNonIPad()) {
	            return false;
	        }
	
	        return this.isAbleToEditDates() || this.isAbleToEditAllWithoutDates();
	    },
	    hasAdminUserPermission: function hasAdminUserPermission() {
	        return [].some.call(this.getCurrentUserRoles(), function (role) {
	            return role === Constants.ROLE_ADMIN;
	        });
	    },
	    fetchUserInformationAndSaveIfNeeded: function fetchUserInformationAndSaveIfNeeded(onFinish) {
	        try {
	            var isUserLogged = !!Security.getCurrentApplicantId();
	            var self = this;
	            if (isUserLogged) {
	
	                // fetching first all permissions related of current user logged
	                this.fetchPermissions();
	
	                LocaleServiceImpl.getApplicantSetting(function () {
	                    // enter here means the server not have yet the
	                    // configuration so we need to infer it.
	                    var isEmptyResponse = !!this.response === false;
	
	                    if (isEmptyResponse) {
	                        // enter here means the user is loggin but don't have applicant configuration
	                        // so we need to save one
	                        self.inferUserInformation(function () {
	                            LocaleServiceImpl.saveSettingModal(self.getUserSettings.bind(self)());
	                        });
	                    } else {
	                        self.fillApplicantInformation(ContentUtils.parse(this.response));
	                    }
	
	                    if (onFinish) {
	                        onFinish();
	                    }
	                });
	            } else {
	                // the user is not loggin yet
	                this.inferUserInformation(onFinish);
	            }
	        } catch (error) {
	            console.info('Error when try to fetch user information: ' + error);
	        }
	    },
	    fetchUserInfoWithoutTriggerAction: function fetchUserInfoWithoutTriggerAction(onFinish) {
	        var isUserLogged = !!Security.getCurrentApplicantId();
	        var self = this;
	        if (isUserLogged) {
	            // fetching first all permissions related of current user logged
	            LocaleServiceImpl.getApplicantSetting(function () {
	                // enter here means the server not have yet the
	                // configuration so we need to infer it.
	                var isEmptyResponse = !!this.response === false;
	
	                if (isEmptyResponse) {
	                    // enter here means the user is loggin but don't have applicant configuration
	                    // so we need to save one
	                    self.inferUserInformation(function () {
	                        LocaleServiceImpl.saveSettingModal(self.getUserSettings.bind(self)());
	                    });
	                } else {
	                    self.fillApplicantInformation(ContentUtils.parse(this.response));
	                }
	
	                if (onFinish) {
	                    onFinish();
	                }
	            });
	        }
	    },
	    fetchPermissions: function fetchPermissions() {
	        SessionActionCreators.permissionRequestUpdate(ContentUtils.getSession('userNameSession'), ContentUtils.getSession('X-Auth-Token'), Security.getCurrentApplicantId());
	    },
	    getUserSettings: function getUserSettings() {
	        return {
	            countryCode: get(this.getCurrentCountry(), 'cca3'),
	            currencyCode: get(this.getCurrentCurrency(), 'code'),
	            timeZone: this.getCurrentTimeZone(),
	            locale: this.getCurrentLocation()
	        };
	    },
	    onTogglePermission: function onTogglePermission(permissionChanged) {
	        var isOff = permissionChanged.isSelected === 'NO';
	        permissionChanged.isChecked = isOff ? true : false;
	        permissionChanged.isSelected = isOff ? 'YES' : 'NO';
	        return permissionChanged;
	    },
	    forcePermission: function forcePermission(permissionChanged, state) {
	        permissionChanged.isChecked = state;
	        permissionChanged.isSelected = state ? 'YES' : 'NO';
	        return permissionChanged;
	    },
	    inferUserInformation: function inferUserInformation(onSuccess) {
	        this.currencies = __webpack_require__(187).currencies;
	        this.currencyDigits = __webpack_require__(314);
	        this.countries = __webpack_require__(313);
	
	        var currentLanguage = ContentUtils.getLocal('cache_current_language');
	        var currentCurrency = ContentUtils.getLocal('cache_current_currency');
	
	        if (currentCurrency && currentLanguage) {
	            // if user already have currency and language configured, do nothing.
	            return;
	        }
	
	        // default user information
	        this.setCurrentCountry('USA');
	        this.setCurrentCountryName('United States');
	        this.setCurrentTimezone('America/Denver');
	        this.setCurrentCurrency('USD');
	        this.setCurrentCurrencyConverter('1');
	
	        var currentLocale = localStorage.getItem('i18nextLng') || navigator.language || navigator.userLanguage;
	        if (currentLocale) {
	            // remove ""
	            currentLocale = currentLocale ? currentLocale.replaceAll('\"', '') : '';
	            currentLocale = currentLocale.indexOf('_') > -1 ? currentLocale.substring(0, currentLocale.indexOf('_')) : currentLocale.substring(0, currentLocale.indexOf('-')) ? currentLocale.substring(0, currentLocale.indexOf('-')) : currentLocale;
	        } else {
	            currentLocale = 'en';
	        }
	
	        this.setCurrentLanguage(currentLocale);
	
	        if (onSuccess) {
	            onSuccess();
	        }
	    },
	    fillApplicantInformation: function fillApplicantInformation(applicantConfigurtionDetail) {
	        this.currencies = __webpack_require__(187).currencies;
	        this.currencyDigits = __webpack_require__(314);
	        this.countries = __webpack_require__(313);
	
	        // If Locale changes need to refresh
	        if (this.getCurrentLanguage() !== get(applicantConfigurtionDetail, 'locale')) {
	            AppActionCreators.saveSettingModal();
	        }
	
	        var countryCode = get(applicantConfigurtionDetail, 'countryCode');
	        var timeZone = get(applicantConfigurtionDetail, 'timeZone');
	        var currencyCode = get(applicantConfigurtionDetail, 'currencyCode');
	        var currencyDigits = get(applicantConfigurtionDetail, 'currencyDigits');
	        var locale = get(applicantConfigurtionDetail, 'locale');
	        var currencyInfo = find(this.currencies, function (currency) {
	            return get(currency, 'code') === currencyCode;
	        });
	        var currencyDigitsInfo = find(this.currencyDigits, function (digits) {
	            return get(digits, 'value') === currencyDigits;
	        });
	        var currentCountry = find(this.countries, function (country) {
	            return get(country, 'cca2') === countryCode || get(country, 'cca3') === countryCode;
	        });
	        var applicantLicense = get(applicantConfigurtionDetail, 'versionName');
	        var applicantLogoSrc = get(applicantConfigurtionDetail, 'applicantLogoSrc');
	        var applicantDisplayName = get(applicantConfigurtionDetail, 'applicantDisplayName');
	        var applicantCreatedDate = get(applicantConfigurtionDetail, 'createdDate');
	
	        // successfully user information inferred
	        this.setCurrentCountry(currentCountry);
	        this.setCurrentCountryName(get(currentCountry, 'name.common', ''));
	        this.setCurrentCurrency(currencyInfo);
	        this.setCurrentCurrencyDigits(currencyDigitsInfo);
	        this.setCurrentTimezone(timeZone);
	        this.setCurrentLanguage(locale);
	        this.setCurrentLicense(applicantLicense);
	        this.setApplicantDisplayName(applicantDisplayName);
	        this.setCreatedDate(applicantCreatedDate);
	        Security.setCurrentApplicantLogoSrc(applicantLogoSrc);
	    },
	    getInferredUserInformation: function getInferredUserInformation() {
	        return {
	            countryCode: get(this.getCurrentCountry(), 'cca2'),
	            timeZone: this.getCurrentTimeZone(),
	            currencyCode: get(this.getCurrentCurrency(), 'code'),
	            locale: this.getCurrentLanguage()
	        };
	    },
	    getAllUsers: function getAllUsers(onSuccess, onFailure) {
	        UserServiceImpl.getUsers(onSuccess, onFailure, Security.getToken(), Security.getCurrentApplicantId());
	    },
	    fetchUserAccess: function fetchUserAccess(onSuccess, onFailure) {
	        UserServiceImpl.getUsersAccess(onSuccess, onFailure, Security.getToken(), Security.getCurrentApplicantId());
	    },
	    fetchGDPRCompliance: function fetchGDPRCompliance(texts, success, failure) {
	        var ajax = RestUtils.createXHR();
	        var self = this;
	
	        if (!texts) {
	            texts = {};
	        }
	
	        var _texts = texts,
	            confirmationAccept = _texts.confirmationAccept,
	            labelPrivacy = _texts.labelPrivacy,
	            labelAnd = _texts.labelAnd,
	            labelUserAgreement = _texts.labelUserAgreement;
	
	
	        var logout = function logout() {
	            Security.logout();
	        };
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            var isNotFound = this.status === 404;
	            if (isNotFound) {
	                CustomDialog.showWarningConfirmation('', confirmationAccept + ' <a target="_blank" href="https://www.brewplanner.com/privacy-policy">' + labelPrivacy + '</a> ' + labelAnd + ' <a target="_blank" href="https://www.brewplanner.com/user-agreement">' + labelUserAgreement + '</a>.', function () {
	                    self.confirmGDPRCompliance();
	                }, t('button_label_accept'), t('button_label_reject'), logout, logout);
	            }
	        });
	        ajax.open('GET', hostApi + '/gdpr/' + Security.getCurrentApplicant());
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    },
	    confirmGDPRCompliance: function confirmGDPRCompliance(success, failure) {
	        var self = this;
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {});
	        ajax.open('POST', hostApi + '/gdpr/' + self.getCurrentApplicant() + '/confirm');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    },
	    getSessionData: function getSessionData() {
	        return {
	            loggedIn: Security.loggedIn(),
	            isMessageDaysOpen: UIStateStore.isBrewingNotesBarOpen(),
	            isBrewingNotesBarOpen: UIStateStore.isBrewingNotesBarOpen(),
	            isPackagingNotesBarOpen: UIStateStore.isPackagingNotesBarOpen(),
	            avatarImage: '/assets/images/brand.png',
	            userDisplay: Security.getCurrentUserName(),
	            staticBox: false
	        };
	    },
	    getPermissions: function getPermissions() {
	        return ContentUtils.getSession(KEY_PERMISSIONS);
	    },
	    getUserPermissions: function getUserPermissions() {
	        return ContentUtils.getSession(KEY_USER_PERMISSIONS);
	    },
	    isAbleToChangeNotes: function isAbleToChangeNotes() {
	        return this.isAdminUser() ? true : some(this.getUserPermissions(), function (permission) {
	            return get(permission, 'name') === 'DASHBOARD_EDIT_NOTES';
	        });
	    },
	    isAbleToEditDates: function isAbleToEditDates() {
	        return this.hasAdminUserPermission() || some(this.getUserPermissions(), function (permission) {
	            return get(permission, 'name') === 'DASHBOARD_EDIT_ALL';
	        });
	    },
	    isAbleToEditAllWithoutDates: function isAbleToEditAllWithoutDates() {
	        return this.hasAdminUserPermission() || some(this.getUserPermissions(), function (permission) {
	            return get(permission, 'name') === 'DASHBOARD_EDIT_ALL_WITHOUT_DATES';
	        });
	    },
	    setPermissions: function setPermissions(permissions) {
	        ContentUtils.saveSession(KEY_PERMISSIONS, permissions);
	    },
	    setUserPermissions: function setUserPermissions(userPermissions) {
	        ContentUtils.saveSession(KEY_USER_PERMISSIONS, userPermissions);
	    },
	    setApplicantId: function setApplicantId(applicantId) {
	        ContentUtils.saveSession(KEY_APPLICANT_ID, applicantId);
	    },
	    getCurrentApplicantId: function getCurrentApplicantId() {
	        return ContentUtils.getSession(KEY_APPLICANT_ID);
	    },
	    setUserName: function setUserName(userName) {
	        ContentUtils.saveSession(KEY_USER_NAME, userName);
	    },
	    getHeaderHigh: function getHeaderHigh() {
	        return Constants.HEADER_HIGHT;
	    },
	    updatePermission: function updatePermission(userName, token, applicantId) {
	        var self = this;
	        UserPermissionStore.getUsersAccess(function (userInfo) {
	            var userPermissionsByUser = filter(get(userInfo, 'userPermissions'), function (userPermission) {
	                return get(userPermission, 'isEnable');
	            }) || [];
	            var userPermissionFiltered = filter(userPermissionsByUser, function (userPermission) {
	                return get(userPermission, 'user.username') === userName;
	            });
	            var userPermissionsAllowed = map(userPermissionFiltered, function (userPermission) {
	                return get(userPermission, 'permissions');
	            }) || [];
	
	            var permissions = get(userInfo, 'permissions');
	            var applicantVersion = get(userInfo, 'applicantVersion');
	            UserPermissionStore.setPermissions(permissions);
	            UserPermissionStore.setUserPermissions(userPermissionsAllowed);
	            self.setCurrentLicense(applicantVersion);
	
	            SessionActionCreators.permissionUpdated();
	        }, function () {
	            // code here when something goes wrong
	        }, token, applicantId);
	    }
	});
	
	SessionStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	
	    switch (action.type) {
	        case ActionTypes.LOGGED_IN:
	            SessionStore.setApplicantId(action.applicantId);
	            SessionStore.setUserName(action.userName);
	            SessionStore.fetchGDPRCompliance(action.texts, function () {
	                console.info('GDPR - Compliance success');
	            });
	            SessionStore.fetchUserInfoWithoutTriggerAction(function () {
	                SessionStore.emitChange();
	            });
	            break;
	
	        case ActionTypes.LOGGED_OUT:
	            Security.logout();
	            SessionStore.emitChange();
	            break;
	        case ActionTypes.PERMISSION_UPDATED:
	            {
	                SessionStore.emitChange();
	                break;
	            }
	        case ActionTypes.PERMISSION_REQUEST_UPDATE:
	            {
	                SessionStore.updatePermission(action.userName, action.token, action.applicantId);
	                break;
	            }
	        default:
	    }
	});
	
	module.exports = SessionStore;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  AppBar: __webpack_require__(1115),
	  AppCanvas: __webpack_require__(1116),
	  Avatar: __webpack_require__(513),
	  BeforeAfterWrapper: __webpack_require__(514),
	  Card: __webpack_require__(1123),
	  CardActions: __webpack_require__(1118),
	  CardExpandable: __webpack_require__(515),
	  CardHeader: __webpack_require__(1119),
	  CardMedia: __webpack_require__(1120),
	  CardText: __webpack_require__(1121),
	  CardTitle: __webpack_require__(1122),
	  Checkbox: __webpack_require__(358),
	  CircularProgress: __webpack_require__(1124),
	  ClearFix: __webpack_require__(166),
	  DatePicker: __webpack_require__(1130),
	  DatePickerDialog: __webpack_require__(516),
	  Dialog: __webpack_require__(359),
	  DropDownIcon: __webpack_require__(1133),
	  DropDownMenu: __webpack_require__(517),
	  EnhancedButton: __webpack_require__(88),
	  FlatButton: __webpack_require__(167),
	  FloatingActionButton: __webpack_require__(1135),
	  FontIcon: __webpack_require__(118),
	  IconButton: __webpack_require__(168),
	  IconMenu: __webpack_require__(1142),
	  LeftNav: __webpack_require__(1137),
	  LinearProgress: __webpack_require__(1138),
	  List: __webpack_require__(361),
	  ListDivider: __webpack_require__(518),
	  ListItem: __webpack_require__(519),
	  Menu: __webpack_require__(210),
	  MenuItem: __webpack_require__(520),
	  Mixins: __webpack_require__(1143),
	  Overlay: __webpack_require__(362),
	  Paper: __webpack_require__(55),
	  RadioButton: __webpack_require__(525),
	  RadioButtonGroup: __webpack_require__(1145),
	  RaisedButton: __webpack_require__(1146),
	  RefreshIndicator: __webpack_require__(1147),
	  Ripples: __webpack_require__(1148),
	  SelectField: __webpack_require__(1149),
	  Slider: __webpack_require__(1150),
	  SvgIcon: __webpack_require__(64),
	  Icons: {
	    NavigationMenu: __webpack_require__(532),
	    NavigationChevronLeft: __webpack_require__(530),
	    NavigationChevronRight: __webpack_require__(531)
	  },
	  Styles: __webpack_require__(169),
	  Snackbar: __webpack_require__(1151),
	  Tab: __webpack_require__(1167),
	  Tabs: __webpack_require__(1169),
	  Table: __webpack_require__(1166),
	  TableBody: __webpack_require__(1162),
	  TableFooter: __webpack_require__(1163),
	  TableHeader: __webpack_require__(1164),
	  TableHeaderColumn: __webpack_require__(533),
	  TableRow: __webpack_require__(1165),
	  TableRowColumn: __webpack_require__(364),
	  Theme: __webpack_require__(1170),
	  Toggle: __webpack_require__(536),
	  TimePicker: __webpack_require__(1175),
	  TextField: __webpack_require__(212),
	  Toolbar: __webpack_require__(538),
	  ToolbarGroup: __webpack_require__(537),
	  ToolbarSeparator: __webpack_require__(1179),
	  ToolbarTitle: __webpack_require__(1180),
	  Tooltip: __webpack_require__(365),
	  Utils: __webpack_require__(1184)
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var SecurityServiceImpl = __webpack_require__(408),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ContentUtils = __webpack_require__(7),
	    NavigationUtils = __webpack_require__(35),
	    DashboardSpinnerEl = __webpack_require__(156),
	    CustomDialog = __webpack_require__(26),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    KEY_COUNTRY = 'cache_current_country',
	    KEY_CURRENCY = 'cache_current_currency',
	    KEY_CURRENCY_DIGITS = 'cache_current_currency_digits',
	    KEY_APPLICANT_USER_LOGGED = 'cache_applicant_user_logged',
	    KEY_APPLICANT_IS_ACTIVE = 'cache_applicant_is_active',
	    KEY_APPLICANT_LOGO_SRC_LOGGED = 'cache_applicant_logo_src_logged',
	    KEY_APPLICANT_USER_ID_LOGGED = 'cache_applicant_user_id_logged',
	    KEY_ROLES_USER_LOGGED = 'cache_roles_user_logged',
	    KEY_PERMISSIONS = 'cache_permissions',
	    KEY_USER_PERMISSIONS = 'cache_user_permissions',
	    KEY_DRAFT = 'cache_draft';
	
	
	var auth = {
	
	    /**
	     * Log the given user.
	     * @param {String} userName
	     * @param {String} password
	     */
	    login: function login(userName, password, texts, onSuccess, onFailure) {
	        var self = this;
	        SecurityServiceImpl.login(userName, password, function () {
	            var token = this.getResponseHeader('X-AUTH-TOKEN');
	            self._saveToken(token);
	            self._setCurrentUser(userName);
	            var response = void 0;
	            SecurityServiceImpl.getCurrentApplicant(token, function () {
	                try {
	                    response = JSON.parse(this.responseText);
	                    self.setCurrentUserRoles(response.roles);
	                    self.setCurrentApplicant(response.applicant.name);
	                    self.setCurrentApplicantLogoSrc(response.applicant.logoSrc);
	                    self.setApplicantIsActive(response.applicant.status);
	                    self.setCurrentApplicantId(response.applicant.id);
	                    self._setCurrentUserName(response.username);
	                } catch (err) {
	                    console.error('ERROR when try to login: ' + err);
	                } finally {
	                    if (onSuccess) {
	                        onSuccess(userName, token, response.applicant.id, texts);
	                    }
	                }
	            });
	        }, function () {
	            if (onFailure) {
	                onFailure({ message: JSON.parse(this.responseText) });
	            }
	        });
	    },
	    loginFromSignUp: function loginFromSignUp(token, username) {
	        this._saveToken(token);
	        this._setCurrentUser(username);
	        var self = this;
	        var response = void 0;
	        SecurityServiceImpl.getCurrentApplicant(token, function () {
	            try {
	                response = JSON.parse(this.responseText);
	                self.setCurrentUserRoles(response.roles);
	                self.setCurrentApplicant(response.applicant.name);
	                self.setCurrentApplicantLogoSrc(response.applicant.logoSrc);
	                self.setApplicantIsActive(response.applicant.status);
	                self.setCurrentApplicantId(response.applicant.id);
	                self._setCurrentUserName(response.username);
	            } catch (err) {
	                console.error('ERROR when try to login: ' + err);
	            }
	        });
	    },
	
	
	    /**
	     * Clean content related the current user session and redirect to login page.
	     */
	    logout: function logout() {
	        this._resetAuthToken();
	        this._setCurrentUser('');
	        this.setCurrentApplicantId('');
	        this.setCurrentApplicantLogoSrc('');
	        this.setCurrentApplicant('');
	        this.setCurrentUserRoles('');
	        this._setCurrentUserName('');
	        window.location = apiAppUrl + '/#/login';
	    },
	
	
	    /**
	     * Retrieve if the current user are already logged or not.
	     * @return {Boolean}
	     */
	    loggedIn: function loggedIn() {
	        return !!this.getCurrentUser();
	    },
	
	
	    /**
	     * Retrieve the current user session from the cookie.
	     * @returns {String}
	     */
	    getCurrentUser: function getCurrentUser() {
	        return ContentUtils.getSession('userSession');
	    },
	
	
	    /**
	     * Retrieve the current user session from the cookie.
	     * @returns {String}
	     */
	    getCurrentUserName: function getCurrentUserName() {
	        return ContentUtils.getSession('userNameSession');
	    },
	    getCurrentApplicant: function getCurrentApplicant() {
	        return ContentUtils.getSession(KEY_APPLICANT_USER_LOGGED);
	    },
	    getPermissions: function getPermissions() {
	        return ContentUtils.getSession(KEY_PERMISSIONS);
	    },
	    getUserPermissions: function getUserPermissions() {
	        return ContentUtils.getSession(KEY_USER_PERMISSIONS);
	    },
	    getCurrentApplicantId: function getCurrentApplicantId() {
	        return ContentUtils.getSession(KEY_APPLICANT_USER_ID_LOGGED);
	    },
	    getCurrentCountry: function getCurrentCountry() {
	        return ContentUtils.getSession(KEY_COUNTRY);
	    },
	    getCurrentCurrency: function getCurrentCurrency() {
	        return ContentUtils.getLocal(KEY_CURRENCY);
	    },
	    getCurrentCurrencyDigits: function getCurrentCurrencyDigits() {
	        return ContentUtils.getLocal(KEY_CURRENCY_DIGITS);
	    },
	
	
	    /**
	     * Retrieve the current session token.
	     * @return {String}
	     */
	    getToken: function getToken() {
	        return ContentUtils.getSession('X-Auth-Token');
	    },
	
	
	    /**
	     * Save the current user name of the logged user.
	     * @param {String) username
	     * @private
	     */
	    _setCurrentUser: function _setCurrentUser(username) {
	        ContentUtils.saveSession('userSession', username);
	    },
	
	
	    /**
	     * Save the current user name of the logged user.
	     * @param {String) username
	     * @private
	     */
	    _setCurrentUserName: function _setCurrentUserName(username) {
	        ContentUtils.saveSession('userNameSession', username);
	    },
	    setCurrentUserRoles: function setCurrentUserRoles(roles) {
	        ContentUtils.saveSession(KEY_ROLES_USER_LOGGED, roles);
	    },
	    setCurrentApplicant: function setCurrentApplicant(applicant) {
	        ContentUtils.saveSession(KEY_APPLICANT_USER_LOGGED, applicant);
	    },
	    setApplicantIsActive: function setApplicantIsActive(applicantStatus) {
	        ContentUtils.saveSession(KEY_APPLICANT_IS_ACTIVE, 'ACTIVE' === applicantStatus);
	    },
	    isApplicantIsActive: function isApplicantIsActive() {
	        return ContentUtils.getSession(KEY_APPLICANT_IS_ACTIVE);
	    },
	    setCurrentApplicantLogoSrc: function setCurrentApplicantLogoSrc(logoSrc) {
	        ContentUtils.saveSession(KEY_APPLICANT_LOGO_SRC_LOGGED, logoSrc);
	    },
	    getCurrentApplicantLogoSrc: function getCurrentApplicantLogoSrc() {
	        return ContentUtils.getSession(KEY_APPLICANT_LOGO_SRC_LOGGED) || '/assets/images/empty_profile.png';
	    },
	    setCurrentApplicantId: function setCurrentApplicantId(applicant) {
	        ContentUtils.saveSession(KEY_APPLICANT_USER_ID_LOGGED, applicant);
	    },
	    setPermissions: function setPermissions(permissions) {
	        ContentUtils.saveSession(KEY_PERMISSIONS, permissions);
	    },
	    setUserPermissions: function setUserPermissions(userPermissions) {
	        ContentUtils.saveSession(KEY_USER_PERMISSIONS, userPermissions);
	    },
	
	
	    /**
	     * Save token in the current session.
	     * @param {String} token
	     * @private
	     */
	    _saveToken: function _saveToken(token) {
	        ContentUtils.saveSession('X-Auth-Token', token);
	    },
	
	
	    /**
	     * Clean the current session token.
	     * @private
	     */
	    _resetAuthToken: function _resetAuthToken() {
	        ContentUtils.saveSession('X-Auth-Token', '');
	    }
	};
	
	var triggerChangePageAnyWay = false;
	
	var Authentication = {
	    statics: {
	        willTransitionTo: function willTransitionTo() {
	            if (!auth.loggedIn()) {
	                window.location = apiAppUrl + '/#/login';
	            }
	        },
	        willTransitionFrom: function willTransitionFrom(transition, context) {
	            var nextPath = transition.path;
	
	            if (isCurrentPageDashboardView(context)) {
	                if (triggerChangePageAnyWay) {
	                    nextPath = nextPath.substring(1);
	                    NavigationUtils.goTo(nextPath);
	                    triggerChangePageAnyWay = false;
	                    DashboardSpinnerEl.hide();
	                } else {
	                    if (existPendingOperationToSaveOnDashboard()) {
	                        transition.abort();
	                        CustomDialog.showWarningConfirmation(t('warning'), t('notification_warning_leave_dashboard_before_auto_saved'),
	                        // CONFIRM
	                        function () {
	                            // remove all '/' to be existis
	                            nextPath = nextPath.substring(1);
	                            triggerChangePageAnyWay = true;
	                            NavigationUtils.goTo(nextPath);
	                        }, t('button_label_continue'), t('button_label_cancel'),
	                        // CANCEL
	                        function () {
	                            triggerChangePageAnyWay = false;
	                        });
	                    }
	                }
	            }
	        }
	    }
	};
	
	function existPendingOperationToSaveOnDashboard() {
	    return get(_getPendingOperations(), 'length', 0) > 0;
	}
	
	function isCurrentPageDashboardView(context) {
	    return context && context.state && (context.state.hasOwnProperty('immCurrentLayout') || context.state.hasOwnProperty('rangeOfDate'));
	}
	
	/**
	 * NOTE:
	 * The following methods (_getDraft & _getPendingOperations) are re-defined here,
	 * because the package module dependency of current version
	 * of Webpack don't allow cyclic dependency between modules.
	 */
	
	function _getDraft() {
	    var draft = ContentUtils.getSession(KEY_DRAFT);
	    if (!draft || Array.isArray(draft)) {
	        return [];
	    }
	    return ContentUtils.getSession(KEY_DRAFT);
	}
	
	function _getPendingOperations() {
	    return filter(_getDraft().operations, function (operation) {
	        return operation.isSaved === false;
	    }) || [];
	}
	
	// Expose for component mixing
	exports.Authentication = Authentication;
	
	// Expose api auth.
	exports.auth = auth;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1270);


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    toInteger = __webpack_require__(31);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(435),
	    baseMatchesProperty = __webpack_require__(436),
	    identity = __webpack_require__(78),
	    isArray = __webpack_require__(27),
	    property = __webpack_require__(498);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  var type = typeof value;
	  if (type == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * React Google Analytics Module
	 *
	 * @package react-ga
	 * @author  Adam Lofting <adam@mozillafoundation.org>
	 *          Atul Varma <atul@mozillafoundation.org>
	 */
	
	/**
	 * Utilities
	 */
	
	var _redacted = 'REDACTED (Potential Email Address)';
	var _debug = false;
	
	function warn (s) {
	  console.warn('[react-ga]', s);
	}
	
	function log (s) {
	  console.info('[react-ga]', s);
	}
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s.replace(/^\s+|\s+$/g, '');
	}
	
	function removeLeadingSlash (s) {
	  if (s.substring(0, 1) === '/') {
	    s = s.substring(1);
	  }
	  return s;
	}
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	function toTitleCase(s){
	  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
	  s = trim(s);
	
	  return s.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title){
	    if (index > 0 &&
	        index + match.length !== title.length &&
	        match.search(smallWords) > -1 &&
	        title.charAt(index - 2) !== ":" &&
	        (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
	        title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	// See if s could be an email address. We don't want to send personal data like email.
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return (/[^@]+@[^@]+/).test(s);
	}
	
	function format(s) {
	  if(mightBeEmail(s)) {
	    warn("This arg looks like an email address, redacting.");
	    s = _redacted;
	    return s;
	  }
	  s = toTitleCase(s);
	  return s;
	}
	
	var reactGA = {
	  initialize: function(gaTrackingID, options) {
	    if (!gaTrackingID) {
	      warn('gaTrackingID is required in initialize()');
	      return;
	    }
	
	    if (options) {
	      if (options.debug && options.debug === true) {
	        _debug = true;
	      }
	    }
	
	    // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	    /* jshint ignore:start */
	    (function(i, s, o, g, r, a, m) {
	      i['GoogleAnalyticsObject'] = r;
	      i[r] = i[r] || function() {
	        (i[r].q = i[r].q || []).push(arguments)
	      }, i[r].l = 1 * new Date();
	      a = s.createElement(o),
	          m = s.getElementsByTagName(o)[0];
	      a.async = 1;
	      a.src = g;
	      m.parentNode.insertBefore(a, m)
	    })(window, document, 'script',
	       '//www.google-analytics.com/analytics.js', 'ga');
	    /* jshint ignore:end */
	
	    ga('create', gaTrackingID, 'auto');
	  },
	
	  /**
	   * pageview:
	   * Basic GA pageview tracking
	   * @param  {String} path - the current page page e.g. '/about'
	   */
	  pageview: function (path) {
	    if (!path) {
	      warn('path is required in .pageview()');
	      return;
	    }
	
	    path = trim(path);
	    if (path === '') {
	      warn('path cannot be an empty string in .pageview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * modalview:
	   * a proxy to basic GA pageview tracking to consistently track
	   * modal views that are an equivalent UX to a traditional pageview
	   * @param  {String} modalName e.g. 'add-or-edit-club'
	   */
	  modalview: function (modalName) {
	    if (!modalName) {
	      warn('modalName is required in .modalview(modalName)');
	      return;
	    }
	
	    modalName = trim(modalName);
	    modalName = removeLeadingSlash(modalName);
	
	    if (modalName === '') {
	      warn('modalName cannot be an empty string or a single / in .modalview()');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	      modalName = trim(modalName);
	      var path = '/modal/' + modalName;
	      ga('send', 'pageview', path);
	
	      if (_debug) {
	        log('called ga(\'send\', \'pageview\', path);');
	        log('with path: ' + path);
	      }
	    }
	  },
	
	  /**
	   * event:
	   * GA event tracking
	   * @param args.category {String} required
	   * @param args.action {String} required
	   * @param args.label {String} optional
	   * @param args.value {Int} optional
	   * @param args.nonInteraction {boolean} optional
	   */
	  event: function (args) {
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.category || !args.action) {
	        warn('args.category AND args.action are required in event()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        'hitType': 'event',
	        'eventCategory': format(args.category),
	        'eventAction': format(args.action)
	      };
	
	      // Optional Fields
	      if (args.label) {
	        fieldObject.eventLabel = format(args.label);
	      }
	
	      if (args.value) {
	        if(typeof args.value !== 'number') {
	          warn('Expected `args.value` arg to be a Number.');
	        } else {
	          fieldObject.eventValue = args.value;
	        }
	      }
	
	      if (args.nonInteraction) {
	        if(typeof args.nonInteraction !== 'boolean') {
	          warn('`args.nonInteraction` must be a boolean.');
	        } else {
	          fieldObject.nonInteraction = args.nonInteraction;
	        }
	      }
	
	      // Send to GA
	      ga('send', fieldObject);
	
	      if (_debug) {
	        log('called ga(\'send\', fieldObject);');
	        log('with fieldObject: ' + JSON.stringify(fieldObject));
	      }
	    }
	  },
	
	  plugin: {
	    /**
	     * require:
	     * GA requires a plugin
	     * @param name {String} e.g. 'ecommerce' or 'myplugin'
	     */
	    require: function(name) {
	      if (typeof ga === 'function') {
	        ga('require', name);
	      }
	
	      if (_debug) {
	        log('called ga(\'require\', \'' + name + '\');');
	      }
	    },
	
	    /**
	     * execute:
	     * GA execute action for plugin
	     * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	     * @param action {String} e.g. 'addItem' or 'myCustomAction'
	     * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	     */
	    execute: function(pluginName, action, payload) {
	      if (typeof ga === 'function') {
	        if (typeof pluginName !== 'string') {
	          warn('Expected `pluginName` arg to be a String.');
	        } else if (typeof action !== 'string') {
	          warn('Expected `action` arg to be a String.');
	        } else {
	          var command = pluginName + ':' + action;
	          payload = payload || null;
	          if (payload) {
	            ga(command, payload);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	              log('with payload: ' + JSON.stringify(payload));
	            }
	          } else {
	            ga(command);
	            if (_debug) {
	              log('called ga(\'' + command + '\');');
	            }
	
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * outboundLink:
	   * GA outboundLink tracking
	   * @param args.label {String} e.g. url, or 'Create an Account'
	   * @param {function} hitCallback - Called after processing a hit.
	   */
	  outboundLink: function (args, hitCallback) {
	    if (typeof hitCallback !== 'function') {
	      warn('hitCallback function is required');
	      return;
	    }
	
	    if (typeof ga === 'function') {
	
	      // Simple Validation
	      if (!args || !args.label) {
	        warn('args.label is required in outboundLink()');
	        return;
	      }
	
	      // Required Fields
	      var fieldObject = {
	        'hitType': 'event',
	        'eventCategory': 'Outbound',
	        'eventAction': 'Click',
	        'eventLabel': format(args.label)
	      };
	
	      var safetyCallbackCalled = false;
	      var safetyCallback = function () {
	
	        // This prevents a delayed response from GA
	        // causing hitCallback from being fired twice
	        safetyCallbackCalled = true;
	
	        hitCallback();
	      };
	
	      // Using a timeout to ensure the execution of critical application code
	      // in the case when the GA server might be down
	      // or an ad blocker prevents sending the data
	
	      // register safety net timeout:
	      var t = setTimeout(safetyCallback, 250);
	
	      var clearableCallbackForGA = function () {
	          clearTimeout(t);
	          if (!safetyCallbackCalled) {
	            hitCallback();
	          }
	      };
	
	      fieldObject.hitCallback = clearableCallbackForGA;
	
	      // Send to GA
	      ga('send', fieldObject);
	
	      if (_debug) {
	        log('called ga(\'send\', fieldObject);');
	        log('with fieldObject: ' + JSON.stringify(fieldObject));
	      }
	    } else {
	      // if ga is not defined, return the callback so the application
	      // continues to work as expected
	      setTimeout(hitCallback, 0);
	    }
	  }
	};
	
	var OutboundLink = __webpack_require__(1193);
	OutboundLink.trackLink = reactGA.outboundLink;
	reactGA.OutboundLink = OutboundLink;
	
	module.exports = reactGA;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.DefaultRoute = __webpack_require__(651);
	exports.Link = __webpack_require__(1210);
	exports.NotFoundRoute = __webpack_require__(652);
	exports.Redirect = __webpack_require__(653);
	exports.Route = __webpack_require__(215);
	exports.RouteHandler = __webpack_require__(216);
	
	exports.HashLocation = __webpack_require__(656);
	exports.HistoryLocation = __webpack_require__(375);
	exports.RefreshLocation = __webpack_require__(657);
	exports.StaticLocation = __webpack_require__(658);
	exports.TestLocation = __webpack_require__(1213);
	
	exports.ImitateBrowserBehavior = __webpack_require__(650);
	exports.ScrollToTopBehavior = __webpack_require__(1208);
	
	exports.History = __webpack_require__(148);
	exports.Navigation = __webpack_require__(1204);
	exports.State = __webpack_require__(1206);
	
	exports.createRoute = __webpack_require__(122).createRoute;
	exports.createDefaultRoute = __webpack_require__(122).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(122).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(122).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(655);
	exports.create = __webpack_require__(654);
	exports.run = __webpack_require__(1214);

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    OrderUtils = __webpack_require__(49),
	    DateUtils = __webpack_require__(22),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    filter = _require.filter,
	    includes = _require.includes,
	    find = _require.find,
	    some = _require.some,
	    sortBy = _require.sortBy,
	    reduce = _require.reduce,
	    groupBy = _require.groupBy,
	    every = _require.every,
	    orderBy = _require.orderBy,
	    _require2 = __webpack_require__(53),
	    cloneDeep = _require2.cloneDeep,
	    _require3 = __webpack_require__(48),
	    uniq = _require3.uniq,
	    uniqBy = _require3.uniqBy,
	    _require4 = __webpack_require__(8),
	    flatMap = _require4.flatMap,
	    _require5 = __webpack_require__(5),
	    assign = _require5.assign,
	    merge = _require5.merge,
	    values = _require5.values,
	    get = __webpack_require__(5).get,
	    set = __webpack_require__(5).set,
	    DashboardModalUtils = __webpack_require__(50),
	    Constants = __webpack_require__(2),
	    _require6 = __webpack_require__(48),
	    concat = _require6.concat,
	    union = _require6.union,
	    flatten = _require6.flatten,
	    SessionStore = __webpack_require__(11),
	    DashboardServiceCache = __webpack_require__(28),
	    InventoryServiceImpl = __webpack_require__(406);
	
	/**
	 *
	 * <h1> Products integration with dashboard </h1>
	 *
	 * <h2> NEW ORDER FLOW </h2>
	 *
	 * <ol>
	 *     <li> First of all, when modal is loaded don't care about products. Because the beers style is not selected yet. </li>
	 *
	 * <li> Once the beer style are selected, if the beer style have any icon configuration that we need to load
	 * products then we need to load in the state context the product which need to be consume for the order.
	 * (`state.products` must be loaded which all icons that consume the order) </li>
	 *
	 * <li> When selected the icon (in some section), we need check if need to hydrated the task with products
	 * (depend of the icon and beer style already selected) </li>
	 *
	 * <li>If defined some product amount on some product in some task, the product must be added to the contexts
	 * of the order (state.products), in order to be able after when click submit those products. </li>
	 *
	 * <h2> CHANGE ORDER FLOW </h2>
	 *
	 * <li> We need to check which products are already assigned to the order and then hydrate each of one. </li>
	 *
	 * <li> When editing the order, the default configuration is not used (default beer styles only apply to new orders). </li>
	 *
	 */
	var InventoryStore = {
	
	    /**
	     * Locate the place of each location available item & purchase item by each items
	     * of each product of each task by each order and estimate where will have each
	     * items in chronologically way.
	     *
	     * @param {Array} orders
	     * @param {String} startingScopeInventoryDate (Optional)                 given date will determine the starting scope of the scope inventory
	     * @param {String} endingScopeInventoryDate (Optional)            given date will determine the ending scope of the scope inventory
	     */
	    hydrateOrderTaskWithInventoryScopeEstimation: function hydrateOrderTaskWithInventoryScopeEstimation(orders) {
	        var startingScopeInventoryDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SessionStore.getMaxScopeInventoryDate();
	        var endingScopeInventoryDate = arguments[2];
	
	        if (!SessionStore.isFullPaidVersion() || !SessionStore.isCalculatingInventory()) {
	            return orders;
	        }
	
	        var locationItemsAvailable = DashboardServiceCache.getLocationItems();
	        var purchaseItems = DashboardServiceCache.getVendorPurchaseItems();
	        var allSortedTasks = OrderUtils.getAllSortedTasksFromOrders(orders);
	        var filteredSortedTasks = this._filterScopeInventory(allSortedTasks, startingScopeInventoryDate, endingScopeInventoryDate);
	
	        this._hydrateInventoryScopeEstimationByTasks(filteredSortedTasks, locationItemsAvailable, purchaseItems);
	
	        return orders;
	    },
	    _hydrateInventoryScopeEstimationByTasks: function _hydrateInventoryScopeEstimationByTasks(tasks, locationItemsAvailable, purchaseItems) {
	        var allItemsIdNeeded = OrderUtils.getAllItemsIdFromTasks(tasks);
	        var purchaseItemRequested = this._filterPurchaseOrderOrdered(purchaseItems, allItemsIdNeeded);
	        locationItemsAvailable = this._discountConfirmedProductFromLocationItemAvailable(tasks, locationItemsAvailable, allItemsIdNeeded);
	
	        for (var _iterator = tasks, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var task = _ref;
	
	            task = this._hydrateOrderTaskWithInventoryScopeEstimationByTask(task, locationItemsAvailable, purchaseItemRequested);
	        }
	    },
	
	
	    /**
	     * We need to discounted the items from confirmed product first, otherwise we will end in the bug related to
	     * confirmed orders which reserve an inventory amount will not be reserve that amount in case that you create a
	     * order before. So, to prevent that bug, we should discount all confirmed product before checking inventory task
	     * in a chronological way.
	     * @param locationItemsAvailable
	     * @param allItemsIdNeeded
	     * @returns {Array}
	     * @private
	     */
	    _discountConfirmedProductFromLocationItemAvailable: function _discountConfirmedProductFromLocationItemAvailable(tasks, locationItemsAvailable, allItemsIdNeeded) {
	        var locationItemsAvailableOnlyNeeded = this._filterLocationItemNeeded(tasks, locationItemsAvailable, allItemsIdNeeded);
	        var confirmedProducts = OrderUtils.getAllProductsFromTasks(tasks).filter(function (product) {
	            return product.isConfirmed && !product.isDiscounted;
	        });
	        return this.updateLocationItemsWithProducts(confirmedProducts, locationItemsAvailableOnlyNeeded);
	    },
	
	
	    /**
	     * Calculate if have enough items available and purchase item available to
	     * archive the inventory needed by the current future (after to day) orders.
	     *
	     * NOTE: this method mutate the original reference of given Task, adding
	     * flags to indicate is location items & purchase items are enough. Also
	     * mutate given locationItemsAvailable in order to discount those product which are already confirmed.
	     * (in this case, when the user confirm the product we need to simulate at dashboard level as all of the item of the
	     * product was discounted, so it's more like a logical discount not physical, until the publishing of changes will be executed).
	     *
	     * @param {Object} task                     The task which will be analise the current scope inventory.
	     * @param {Array} locationItemsAvailable    The current location items available in the application.
	     * @param {Array} purchaseItems             The current purchase items (with state `ORDERED`) in the application.
	     * @return {Object} task                    Return the original task which additional flags about scope inventory
	     */
	    _hydrateOrderTaskWithInventoryScopeEstimationByTask: function _hydrateOrderTaskWithInventoryScopeEstimationByTask(task, locationItemsAvailable, purchaseItems) {
	        var _this = this;
	
	        // Add an item & product level info about if
	        // is enough or not the existing inventory or purchased orders
	        task.products = map(uniqBy(task.products, 'id'), function (product) {
	
	            if (product.isConfirmed || product.isNeededCalculateInventory === false) {
	                // enter here means the product is planned or already discounted,
	                // therefore do nothing with it
	
	                //  The `isNeededCalculateInventory` it's needed to don't reset the inventory when you
	                // are for example in the modal, and you are changing WhereInventortWasTaken (of one item in particular)
	                return product;
	            }
	
	            var haveAmountNeeded = NumberUtils.isGreater(product.amount, 0);
	            if (!haveAmountNeeded) {
	                // enter here means the product don't already have
	                // the `amount` defined by the client.
	
	                // clean items estimation in case that exist one before
	                product = _resetItemsEstimation(product);
	                return product;
	            }
	
	            if (product.needToPublishDisconfirmation) {
	                // enter here means the order was discounted, but was unconfirmed
	                // so we need simulate like we already return the item to the inventory
	                // (again it's still logically not physically, until the customer perform the publishing operation)
	                locationItemsAvailable = _this.returnItemsConsumed(product, locationItemsAvailable);
	            }
	
	            var taskDate = get(task, 'date');
	
	            // reset/initialize product in order to calculate properly with fresh state.
	            product = _this._resetInventoryFromProduct(product);
	
	            // process each item of the product
	            product.items = map(product.items, function (productItem) {
	                var itemNotNeedSubtract = productItem.addition === false && ContentUtils.isNullOrEmpty(productItem.whereInventoryWasTakenSave);
	
	                if (!itemNotNeedSubtract) {
	                    return productItem;
	                }
	
	                productItem = _this.processItemNonDiscountedYet(productItem, locationItemsAvailable, taskDate, purchaseItems);
	
	                if (productItem.isEnoughInventory === false) {
	                    product.someItemsIsNotEnoughInStock = true;
	                }
	
	                if (productItem.isEnoughInventory === false && productItem.isPurchasedAmountEnough === false) {
	                    product.someItemsIsNotEnoughInPurchase = true;
	                }
	
	                return productItem;
	            });
	
	            return product;
	        });
	
	        // this mark says about if the current availability stock
	        // is enough to perform all items of all product for this date
	        task.someItemsIsNotEnoughInStock = some(task.products, function (product) {
	            return product.someItemsIsNotEnoughInStock;
	        });
	
	        // this mark says that some items is not enough in purchased items
	        task.someItemsIsNotEnoughInPurchase = some(task.products, function (product) {
	            return product.someItemsIsNotEnoughInPurchase;
	        });
	
	        // this mark says if exist at least one product confirmed
	        task.someItemsWithConfirmedProduct = some(task.products, function (product) {
	            return product.isConfirmed;
	        });
	
	        return task;
	    },
	    _resetInventoryFromProduct: function _resetInventoryFromProduct(product) {
	        product.someItemsIsNotEnoughInStock = false;
	        product.someItemsIsNotEnoughInPurchase = false;
	        product.items = map(product.items, function (item) {
	            item.whereInventoryWasTakenNew = []; // reset the state of item changed from UI not persisted yet
	            item.existItemInStock = false;
	            item.isEnoughInventory = false;
	            return item;
	        });
	        return product;
	    },
	
	
	    /**
	     * Process the items which are non discounted yet of inventory in terms of the amount
	     * need to subtract of inventory or the Purchase order.
	     *
	     * NOTE: the same way as {@link _hydrateInventoryScopeEstimationByTask } this method mutate the
	     * reference passed by param (make side-effect). In order to update by each parent iteration
	     * the resultant amount.
	     *
	     * @param itemNonDiscountedYet
	     * @param locationItemsAvailable
	     * @param taskDate
	     * @param purchaseItems
	     * @return {*}
	     */
	    processItemNonDiscountedYet: function processItemNonDiscountedYet(itemNonDiscountedYet, locationItemsAvailable, taskDate, purchaseItems) {
	        // get `item` and `itemId` given Item or Product item by parameter
	        var _getItemAndItemId = this._getItemAndItemId(itemNonDiscountedYet),
	            item = _getItemAndItemId.item,
	            itemId = _getItemAndItemId.itemId;
	        // search in the stock the amount of items available in all of locations
	
	
	        var locationItemsResult = filter(locationItemsAvailable, function (locationItem) {
	            return locationItem.itemId === itemId || get(locationItem, 'item.id') === itemId;
	        }) || {};
	        var amountItemNeeded = item.amount; // is already multiplicand
	
	        // calculate the amount of the stock in all location from one particular item
	        var amountsLocation = map(locationItemsResult, function (locationItemResult) {
	            return get(locationItemResult, 'amount');
	        });
	        var amountInStock = reduce(amountsLocation, function (accumulateAmount, amount) {
	            return NumberUtils.sum(accumulateAmount, amount);
	        });
	        item.existItemInStock = NumberUtils.isGreater(amountInStock, 0);
	        item.isEnoughInventory = NumberUtils.isGreaterOrEquals(amountInStock, amountItemNeeded);
	
	        if (item.preventRecalculateWhereInventoryWasTaken) {
	            // enter here means will be subtracted the item where the user already defined. More info take a look the comment of
	            // method {@link this.turnOnWhereInventoryWasTakenNonChanged}
	            var result = this.subtractAmountFromSpecificLocationItems(item, locationItemsAvailable);
	            item = result.itemUpdated;
	            locationItemsAvailable = result.locationItemsAvailable;
	        } else {
	
	            // initialize the amount left needed as initially the amount we want
	            item.amountNeededLeft = cloneDeep(amountItemNeeded);
	            item.whereInventoryWasTakenNew = []; // reset where was inventory taken
	
	            if (item.existItemInStock) {
	                // enter here means that exist item in stock so we need
	                // to subtract the amount of stock from given location items available
	                var _result = this.subtractAmountFromLocationItems(item, locationItemsAvailable);
	                item = _result.itemUpdated;
	                locationItemsAvailable = _result.locationItemsAvailable;
	            }
	        }
	
	        if (!item.isEnoughInventory) {
	            // enter here means was not enough existing inventory
	            // so we need to search in purchased order the amount item
	            // needed and ,if is the case, add the amount purchase needed
	            var _result2 = this.subtractAmountFromPurchaseOrders(item, purchaseItems, taskDate);
	            item = _result2.itemUpdated;
	            purchaseItems = _result2.purchaseItemsUpdated;
	        }
	
	        return item;
	    },
	
	
	    /**
	     * Persist new item in the application that will be available from the dashboard.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addItem: function addItem(item, success, failure) {
	        InventoryServiceImpl.addItem(item, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new product in the application that will be available from the dashboard.
	     * @param product
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addProduct: function addProduct(product, success, failure) {
	        InventoryServiceImpl.addProduct(product, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new product in the application that will be available from the dashboard.
	     * @param product
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    duplicateProduct: function duplicateProduct(product, success, failure) {
	        InventoryServiceImpl.duplicateProduct(product, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new product in the application.
	     * @param product
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addProductItem: function addProductItem(productId, productItem, success, failure) {
	        InventoryServiceImpl.addProductItem(productId, productItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persis new location item in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addLocationItem: function addLocationItem(locationItem, success, failure) {
	        InventoryServiceImpl.addLocationItem(locationItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new product in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addIcon: function addIcon(icon, success, failure) {
	        InventoryServiceImpl.addIcon(icon, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new vendor in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendor: function addVendor(vendor, success, failure) {
	        InventoryServiceImpl.addVendor(vendor, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new vendor in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendorPurchase: function addVendorPurchase(vendorPurchase, success, failure) {
	        InventoryServiceImpl.addVendorPurchase(vendorPurchase, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addSale: function addSale(sale, success, failure) {
	        InventoryServiceImpl.addSale(sale, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addSaleItem: function addSaleItem(sale, success, failure) {
	        InventoryServiceImpl.addSaleItem(sale, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addCustomer: function addCustomer(customer, success, failure) {
	        InventoryServiceImpl.addCustomer(customer, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addCustomerAddress: function addCustomerAddress(customerId, customerAddress, success, failure) {
	        InventoryServiceImpl.addCustomerAddress(customerId, customerAddress, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addCustomerContact: function addCustomerContact(customerId, customerAddress, success, failure) {
	        InventoryServiceImpl.addCustomerContact(customerId, customerAddress, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    addCustomerItem: function addCustomerItem(customerId, customerItem, success, failure) {
	        InventoryServiceImpl.addCustomerItem(customerId, customerItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new purchase item in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendorPurchaseItem: function addVendorPurchaseItem(vendorPurchaseItem, success, failure) {
	        InventoryServiceImpl.addVendorPurchaseItem(vendorPurchaseItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Duplicate given vendor purchase
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    duplicateVendorPurchase: function duplicateVendorPurchase(vendorPurchaseItem, success, failure) {
	        InventoryServiceImpl.duplicateVendorPurchase(vendorPurchaseItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Mark Paid given vendor purchase
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    markPaidVendorPurchase: function markPaidVendorPurchase(vendorPurchaseId, success, failure) {
	        InventoryServiceImpl.markPaidVendorPurchase(vendorPurchaseId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Comment given vendor purchase
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    saveCommentOnlyVendorPurchase: function saveCommentOnlyVendorPurchase(vendorPurchaseId, comment, success, failure) {
	        InventoryServiceImpl.saveCommentOnlyVendorPurchase(vendorPurchaseId, comment, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new Vendor address in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendorAddress: function addVendorAddress(vendorId, address, success, failure) {
	        InventoryServiceImpl.addVendorAddress(vendorId, address, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new Vendor Contact in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendorContact: function addVendorContact(vendorId, contact, success, failure) {
	        InventoryServiceImpl.addVendorContact(vendorId, contact, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new Vendor Item in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addVendorItem: function addVendorItem(vendorId, itemId, vendorItem, success, failure) {
	        InventoryServiceImpl.addVendorItem(vendorId, itemId, vendorItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Persist new product in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addLocation: function addLocation(werahouse, success, failure) {
	        InventoryServiceImpl.addLocation(werahouse, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Send a comfirmation of purchase order items to the provider, to notify
	     * that applicant want's to purchase those items.
	     *
	     * @param {Number} vendorPurchaseId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    sendVendorPurchaseOrder: function sendVendorPurchaseOrder(vendorPurchaseId, success, failure) {
	        InventoryServiceImpl.sendVendorPurchaseOrder(vendorPurchaseId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Will confirm and persist all items of given purchase id. Which means will be added
	     * to the inventory after that.
	     *
	     * @param {Number} vendorPurchaseId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    confirmVendorPurchaseOrder: function confirmVendorPurchaseOrder(vendorPurchaseId, success, failure) {
	        InventoryServiceImpl.confirmVendorPurchaseOrder(vendorPurchaseId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    confirmSaleOrderDelivered: function confirmSaleOrderDelivered(saleId, success, failure) {
	        InventoryServiceImpl.confirmSaleOrderDelivered(saleId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Notified to the customer their sale order.
	     * @param {Number} saleId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    sendOrderToCustomer: function sendOrderToCustomer(saleId, success, failure) {
	        InventoryServiceImpl.sendOrderToCustomer(saleId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchItems: function fetchItems(pageNumber, success, failure) {
	        InventoryServiceImpl.getItems(pageNumber, function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch non inventory items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchNonInventoryItems: function fetchNonInventoryItems(success, failure) {
	        InventoryServiceImpl.getNonInventoryItems(function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchAllItems: function fetchAllItems(success, failure) {
	        InventoryServiceImpl.getAllItems(function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchItemsBy: function fetchItemsBy(filter, success, failure) {
	        InventoryServiceImpl.getItemsBy(filter, function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchFinishProducts: function fetchFinishProducts(success, failure) {
	        InventoryServiceImpl.getFinishProducts(function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchFinishItems: function fetchFinishItems(success, failure) {
	        InventoryServiceImpl.getFinishItems(function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch vendor items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorItems: function fetchVendorItems(vendorId, success, failure) {
	        InventoryServiceImpl.getVendorItems(vendorId, function () {
	            var items = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(items);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch vendor items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorPurchases: function fetchVendorPurchases(currentPage, success, failure) {
	        InventoryServiceImpl.getVendorPurchases(currentPage, function () {
	            var purchases = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(purchases);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch vendor items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorPurchasesWithTotalPrice: function fetchVendorPurchasesWithTotalPrice(currentPage, success, failure) {
	        InventoryServiceImpl.getVendorPurchasesWithTotalPrice(currentPage, function () {
	            var purchases = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(purchases);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch vendor items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorPurchasesBy: function fetchVendorPurchasesBy(filter, success, failure) {
	        InventoryServiceImpl.getVendorPurchasesBy(filter, function () {
	            var purchases = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(purchases);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Sales from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchSales: function fetchSales(page, success, failure) {
	        InventoryServiceImpl.getSales(page, function () {
	            var sales = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(sales);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Sales from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchSalesBy: function fetchSalesBy(filter, success, failure) {
	        InventoryServiceImpl.getSalesBy(filter, function () {
	            var sales = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(sales);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Sales from the server.
	     * @param {Number} SaleId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchSaleItems: function fetchSaleItems(saleId, success, failure) {
	        InventoryServiceImpl.getSaleItems(saleId, function () {
	            var sales = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(sales);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Comment given sale order
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    saveCommentOnlySaleOrder: function saveCommentOnlySaleOrder(saleId, comment, success, failure) {
	        InventoryServiceImpl.saveCommentOnlySaleOrder(saleId, comment, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Mark Paid given Sale
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    markPaidSale: function markPaidSale(saleId, success, failure) {
	        InventoryServiceImpl.markPaidSale(saleId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Customers from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchCustomers: function fetchCustomers(success, failure) {
	        InventoryServiceImpl.getCustomers(function () {
	            var sales = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(sales);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Retrieve the customers contacts from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchCustomerContacts: function fetchCustomerContacts(customerId, success, failure) {
	        InventoryServiceImpl.getCustomerContacts(customerId, function () {
	            var customerAddresses = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(customerAddresses);
	            }
	        }, failure);
	    },
	    fetchCustomerAddresses: function fetchCustomerAddresses(customerId, success, failure) {
	        InventoryServiceImpl.getCustomerAddresses(customerId, function () {
	            var customerAddresses = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(customerAddresses);
	            }
	        }, failure);
	    },
	    fetchCustomerItems: function fetchCustomerItems(customerId, success, failure) {
	        InventoryServiceImpl.getCustomerItems(customerId, function () {
	            var customerAddresses = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(customerAddresses);
	            }
	        }, failure);
	    },
	    fetchVendorPurchasesItem: function fetchVendorPurchasesItem(vendorId, success, failure) {
	        InventoryServiceImpl.getVendorPurchasesItem(vendorId, function () {
	            var purchases = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(purchases);
	            }
	        }, failure);
	    },
	    fetchIcons: function fetchIcons(success, failure) {
	        InventoryServiceImpl.getIcons(function () {
	            var icons = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(icons);
	            }
	        }, failure);
	    },
	    downloadReportXLS: function downloadReportXLS(filter, controllerName, success, failure) {
	        InventoryServiceImpl.downloadReportXLS(filter, controllerName, function () {
	
	            if (!success) {
	                success = function success() {};
	            }
	
	            if (!failure) {
	                failure = function failure() {};
	            }
	
	            if (this.status <= 201) {
	                success.bind(this)(this.response);
	            } else {
	                failure.bind(this)(this.response);
	            }
	        }, failure);
	    },
	    downloadReportPDF: function downloadReportPDF(filter, controllerName, success, failure) {
	        InventoryServiceImpl.downloadReportPDF(filter, controllerName, function () {
	
	            if (!success) {
	                success = function success() {};
	            }
	
	            if (!failure) {
	                failure = function failure() {};
	            }
	
	            if (this.status <= 201) {
	                success.bind(this)(this.response);
	            } else {
	                failure.bind(this)(this.response);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch icons from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchLocation: function fetchLocation(success, failure) {
	        InventoryServiceImpl.getLocation(function () {
	            var locations = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(locations);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch Vendor from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendor: function fetchVendor(success, failure) {
	        InventoryServiceImpl.getVendor(function () {
	            var vendorContent = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(vendorContent);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch Vendor Addresses from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorAddresses: function fetchVendorAddresses(vendorId, success, failure) {
	        InventoryServiceImpl.getVendorAddresses(vendorId, function () {
	            var addresses = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(addresses);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch Vendor Contact from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchVendorContacts: function fetchVendorContacts(vendorId, success, failure) {
	        InventoryServiceImpl.getVendorContacts(vendorId, function () {
	            var addresses = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(addresses);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch icons by items from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchIconByProduct: function fetchIconByProduct(productId, success, failure) {
	        InventoryServiceImpl.getIconByProduct(productId, function () {
	            var icons = ContentUtils.parse(this.responseText) || [];
	
	            if (success) {
	                success.bind(this)(icons);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch product from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchProducts: function fetchProducts(success, failure) {
	        InventoryServiceImpl.getProducts(function () {
	            var products = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(products);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items of given product product id from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchItemsAddition: function fetchItemsAddition(productId, success, failure) {
	        var isAddition = true;
	        InventoryServiceImpl.getItemsByProduct(productId, isAddition, function () {
	            var products = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(products);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items of given product product id from the server.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchItemsSubtraction: function fetchItemsSubtraction(productId, success, failure) {
	        var isAddition = false;
	        InventoryServiceImpl.getItemsByProduct(productId, isAddition, function () {
	            var products = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(products);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items of given product product id from the server.
	     * @param {Number} pageNumber
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchLocationItems: function fetchLocationItems(pageNumber, success, failure) {
	        InventoryServiceImpl.getItemsLocation(pageNumber, function () {
	            var result = ContentUtils.parse(this.responseText) || [];
	            var locationItems = result.locationItems;
	            var locations = result.locations;
	            var items = result.items;
	            if (success) {
	                success.bind(this)(items, locations, locationItems);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items of given product product id from the server.
	     * @param {Number} pageNumber
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchLocationItemsWithTotalAmount: function fetchLocationItemsWithTotalAmount(pageNumber, success, failure) {
	        InventoryServiceImpl.getLocationItemsWithTotalAmount(pageNumber, function () {
	            var locationItems = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(locationItems);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch items of given product product id from the server.
	     * @param {Number} pageNumber
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchLocationItemsWithTotalAmountBy: function fetchLocationItemsWithTotalAmountBy(filter, success, failure) {
	        InventoryServiceImpl.getLocationItemsWithTotalAmountBy(filter, function () {
	            var locationItems = ContentUtils.parse(this.responseText) || [];
	            if (success) {
	                success.bind(this)(locationItems);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent item in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeItem: function changeItem(item, success, failure) {
	        InventoryServiceImpl.changeItem(item, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent location item in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeLocationItem: function changeLocationItem(locationItem, success, failure) {
	        InventoryServiceImpl.changeLocationItem(locationItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent item in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorAddress: function changeVendorAddress(vendorId, address, success, failure) {
	        InventoryServiceImpl.changeVendorAddress(vendorId, address, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent Vendor Contact in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorContact: function changeVendorContact(vendorId, contact, success, failure) {
	        InventoryServiceImpl.changeVendorContact(vendorId, contact, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Vendor Item in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorItem: function changeVendorItem(vendorId, itemId, vendorItem, success, failure) {
	        InventoryServiceImpl.changeVendorItem(vendorId, itemId, vendorItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Vendor purchase in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorPurchase: function changeVendorPurchase(vendorPurchase, success, failure) {
	        InventoryServiceImpl.changeVendorPurchase(vendorPurchase, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing Sale
	     * @param Sale
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeSale: function changeSale(sale, success, failure) {
	        InventoryServiceImpl.changeSale(sale, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Amount Paid PO
	     * @param vendorPurchase
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeAmountPaidPO: function changeAmountPaidPO(vendorPurchase, value, success, failure) {
	        InventoryServiceImpl.changeAmountPaidPO(vendorPurchase, value, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Amount Paid SO
	     * @param Sale
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeAmountPaidSO: function changeAmountPaidSO(sale, success, failure) {
	        InventoryServiceImpl.changeAmountPaidSO(sale, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing SaleItem
	     * @param SaleItemc
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeSaleItem: function changeSaleItem(saleItem, success, failure) {
	        InventoryServiceImpl.changeSaleItem(saleItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing Sale
	     * @param Customer
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeCustomer: function changeCustomer(customer, success, failure) {
	        InventoryServiceImpl.changeCustomer(customer, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    changeCustomerAddress: function changeCustomerAddress(customerId, address, success, failure) {
	        InventoryServiceImpl.changeCustomerAddress(customerId, address, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    changeCustomerContact: function changeCustomerContact(customerId, contact, success, failure) {
	        InventoryServiceImpl.changeCustomerContact(customerId, contact, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    changeCustomerItem: function changeCustomerItem(customerId, customerItem, success, failure) {
	        InventoryServiceImpl.changeCustomerItems(customerId, customerItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    deleteCustomerContact: function deleteCustomerContact(customerId, customerContactId, success, failure) {
	        InventoryServiceImpl.deleteCustomerContact(customerId, customerContactId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    deleteCustomerAddress: function deleteCustomerAddress(customerId, customerAddressId, success, failure) {
	        InventoryServiceImpl.deleteCustomerAddress(customerId, customerAddressId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    deleteCustomerItems: function deleteCustomerItems(customerId, customerItemId, success, failure) {
	        InventoryServiceImpl.deleteCustomerItems(customerId, customerItemId, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Vendor Item in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorPurchaseItem: function changeVendorPurchaseItem(vendorPurchaseItem, success, failure) {
	        InventoryServiceImpl.changeVendorPurchaseItem(vendorPurchaseItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Vendor Item purchase received in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorPurchaseItemReceived: function changeVendorPurchaseItemReceived(vendorPurchaseItem, success, failure) {
	        InventoryServiceImpl.changeVendorPurchaseItemReceived(vendorPurchaseItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change Vendor Item purchase received in the application.
	     * @param icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendorPurchaseItemReceivedDraft: function changeVendorPurchaseItemReceivedDraft(vendorPurchaseItem, success, failure) {
	        InventoryServiceImpl.changeVendorPurchaseItemReceivedDraft(vendorPurchaseItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent vendor in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeVendor: function changeVendor(vendor, success, failure) {
	        InventoryServiceImpl.changeVendor(vendor, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent product in the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeProduct: function changeProduct(product, success, failure) {
	        InventoryServiceImpl.changeProduct(product, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing product item in the application.
	     * @param product
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeProductItem: function changeProductItem(productId, productItem, success, failure) {
	        InventoryServiceImpl.changeProductItem(productId, productItem, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing icon in the application.
	     * @param {Object} icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeIcon: function changeIcon(iconsChanged, success, failure) {
	        InventoryServiceImpl.changeIcon(iconsChanged, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing location in the application.
	     * @param {Object} icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeLocation: function changeLocation(location, success, failure) {
	        InventoryServiceImpl.changeLocation(location, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change existing icon in the application.
	     * @param {Object} icon
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeIconsFromProduct: function changeIconsFromProduct(productIdSelected, iconsChanged, success, failure) {
	        InventoryServiceImpl.changeIconFromProduct(productIdSelected, iconsChanged, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete items from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteItem: function deleteItem(item, success, failure) {
	        InventoryServiceImpl.deleteItem(item, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete sale from the application.
	     * @param saleId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteSale: function deleteSale(saleId, success, failure) {
	        InventoryServiceImpl.deleteSale(saleId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete sale from the application.
	     * @param saleId
	     * @param saleItemId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteSaleItem: function deleteSaleItem(saleId, saleItemId, success, failure) {
	        InventoryServiceImpl.deleteSaleItem(saleId, saleItemId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete customer from the application.
	     * @param saleId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteCustomer: function deleteCustomer(customerId, success, failure) {
	        InventoryServiceImpl.deleteCustomer(customerId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete location items from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteLocationItem: function deleteLocationItem(locationItemId, success, failure) {
	        InventoryServiceImpl.deleteLocationItem(locationItemId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete icon from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteIcon: function deleteIcon(item, success, failure) {
	        InventoryServiceImpl.deleteIcon(item, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete location from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteLocation: function deleteLocation(locationId, success, failure) {
	        InventoryServiceImpl.deleteLocation(locationId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete vendor from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteVendor: function deleteVendor(vendorId, success, failure) {
	        InventoryServiceImpl.deleteVendor(vendorId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete vendor from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteVendorAddress: function deleteVendorAddress(vendorId, addressId, success, failure) {
	        InventoryServiceImpl.deleteVendorAddress(vendorId, addressId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete vendor from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteVendorContact: function deleteVendorContact(vendorId, contactId, success, failure) {
	        InventoryServiceImpl.deleteVendorContact(vendorId, contactId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete vendor from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteVendorItem: function deleteVendorItem(vendorId, itemId, success, failure) {
	        InventoryServiceImpl.deleteVendorItem(vendorId, itemId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete items from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteProductItem: function deleteProductItem(item, success, failure) {
	        InventoryServiceImpl.deleteProductItem(item, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete Product from the application.
	     * @param item
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteProduct: function deleteProduct(product, success, failure) {
	        InventoryServiceImpl.deleteProduct(product, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete the given purchase id.
	     * @param purchaseId
	     * @param success
	     * @param failure
	     */
	    deletePurchase: function deletePurchase(purchaseId, success, failure) {
	        InventoryServiceImpl.deletePurchase(purchaseId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete the given purchase item id.
	     * @param purchaseItemId
	     * @param success
	     * @param failure
	     */
	    deletePurchaseItem: function deletePurchaseItem(purchaseItemId, success, failure) {
	        InventoryServiceImpl.deletePurchaseItem(purchaseItemId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	    isApplicantIcon: function isApplicantIcon(icon) {
	        return !!(icon && icon.iconOverridden);
	    },
	    isAlreadyInUseDefaultIcon: function isAlreadyInUseDefaultIcon(defaultIcon, customIconsByApplicant) {
	        return some(customIconsByApplicant, function (customIcon) {
	            return customIcon.iconId === defaultIcon.id;
	        });
	    },
	    filterOnlyProductIconsChanged: function filterOnlyProductIconsChanged(icons, iconsPristine) {
	        var _this2 = this;
	
	        var iconsChanged = [];
	
	        var _loop = function _loop() {
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) return 'break';
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) return 'break';
	                _ref2 = _i2.value;
	            }
	
	            var iconToValidate = _ref2;
	
	            var pristineIcon = find(iconsPristine, function (icon) {
	                return get(icon, 'iconDetail.name') === get(iconToValidate, 'iconDetail.name');
	            });
	
	            if (!_this2.isProductIconPristine(iconToValidate, pristineIcon)) {
	                iconsChanged.push(iconToValidate);
	            }
	        };
	
	        for (var _iterator2 = icons, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	        return iconsChanged;
	    },
	    discountInventoryAlreadyReserved: function discountInventoryAlreadyReserved(orders, locationItemsAvailable) {
	        return locationItemsAvailable;
	    },
	    calculateTotalVolumeOfProduct: function calculateTotalVolumeOfProduct(order) {
	
	        if (!order) {
	            return null;
	        }
	
	        if (order.isSingle) {
	            return _calculateTotalVolumeOfProduct(union(order.singleTasks, order.batchs));
	        } else {
	            return _calculateTotalVolumeOfProduct(union(order.fermenterTasks, order.packagingTasks, order.batchs));
	        }
	    },
	    calculateTotalVolumeFromTask: function calculateTotalVolumeFromTask(tasks) {
	        return _calculateTotalVolumeOfProduct(tasks);
	    },
	    calculateTotalVolumeOfProductLeft: function calculateTotalVolumeOfProductLeft(order) {
	        var totalBatchVolume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (order) {
	            var orderVolume = get(order, 'volume', get(order, 'orderVolume', 0));
	            return NumberUtils.subtract(orderVolume, this.calculateTotalVolumeOfProduct(order));
	        } else {
	            // enter here means don't have product so means to consume all total volume
	            return totalBatchVolume;
	        }
	    },
	    calculateTotalVolumeLeft: function calculateTotalVolumeLeft(tasks, batchVolume) {
	        return NumberUtils.subtract(batchVolume, _calculateTotalVolumeOfProduct(tasks));
	    },
	    filterOnlyIconsChanged: function filterOnlyIconsChanged(icons, iconsPristine) {
	        var _this3 = this;
	
	        var iconsChanged = [];
	
	        var _loop2 = function _loop2() {
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) return 'break';
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) return 'break';
	                _ref3 = _i3.value;
	            }
	
	            var iconToValidate = _ref3;
	
	            var pristineIcon = find(iconsPristine, function (icon) {
	                return get(icon, 'iconDetail.name') === get(iconToValidate, 'iconDetail.name');
	            });
	
	            if (!_this3.isIconPristine(iconToValidate, pristineIcon)) {
	                iconsChanged.push(iconToValidate);
	            }
	        };
	
	        for (var _iterator3 = icons, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            var _ret2 = _loop2();
	
	            if (_ret2 === 'break') break;
	        }
	        return iconsChanged;
	    },
	    isIconPristine: function isIconPristine(icon, iconChanged) {
	        return get(icon, 'iconDetail.isBrewingAllowed') === get(iconChanged, 'iconDetail.isBrewingAllowed') && get(icon, 'iconDetail.isFermentingAllowed') === get(iconChanged, 'iconDetail.isFermentingAllowed') && get(icon, 'iconDetail.isPackagingAllowed') === get(iconChanged, 'iconDetail.isPackagingAllowed');
	    },
	    isProductIconPristine: function isProductIconPristine(icon, iconChanged) {
	        return get(icon, 'isProductIconChecked') === get(iconChanged, 'isProductIconChecked');
	    },
	    formatIconsBySections: function formatIconsBySections(allDefaultIcons, customIconsFromApplicant) {
	        var _this4 = this;
	
	        var allDefaultIconsWithoutUse = filter(allDefaultIcons, function (defaultIcon) {
	            return !_this4.isAlreadyInUseDefaultIcon(defaultIcon, customIconsFromApplicant);
	        });
	
	        // mark as checked
	        customIconsFromApplicant = map(customIconsFromApplicant, function (customIcon) {
	            customIcon.isChecked = true;
	            return customIcon;
	        });
	
	        var allIconsWithCustomIconsFromApplicant = concat(allDefaultIconsWithoutUse, customIconsFromApplicant);
	
	        var brewingIcons = filter(allIconsWithCustomIconsFromApplicant, function (icon) {
	            return get(icon, 'iconDetail.isBrewingAllowed');
	        });
	        var fermentingIcons = filter(allIconsWithCustomIconsFromApplicant, function (icon) {
	            return get(icon, 'iconDetail.isFermentingAllowed');
	        });
	        var packagingIcons = filter(allIconsWithCustomIconsFromApplicant, function (icon) {
	            return get(icon, 'iconDetail.isPackagingAllowed');
	        });
	
	        return {
	            Brewing: brewingIcons,
	            Fermenting: fermentingIcons,
	            Packaging: packagingIcons
	        };
	    },
	
	
	    /**
	     * The idea is each task from one Order, need to contain all information of the products
	     * belong to it. Also each Product have the items which need to consume in inventory module.
	     * @param tasks
	     * @param beerStyleId
	     * @return {*}
	     */
	    hydrateTaskWithProducts: function hydrateTaskWithProducts(tasks, beerStyleId) {
	        if (!SessionStore.isFullPaidVersion()) {
	            return tasks;
	        }
	
	        var result = [];
	        var filteredProducts = DashboardServiceCache.getProductsByBeerStyle(beerStyleId);
	        var filteredProductsItems = DashboardServiceCache.getProductItemsByProducts(filteredProducts);
	        var filteredProductIcons = DashboardServiceCache.getProductIconsProducts(filteredProducts);
	
	        if (Array.isArray(tasks)) {
	            result = map(tasks, function (task) {
	                return _hydrateTaskWithProducts(task, beerStyleId, filteredProducts, filteredProductIcons, filteredProductsItems);
	            });
	        } else {
	            result = _hydrateTaskWithProducts(tasks, beerStyleId, filteredProducts, filteredProductIcons, filteredProductsItems);
	        }
	        return _sortItemsFromProductsAndFilterDisabled(result);
	    },
	    populateEachProductAmount: function populateEachProductAmount(order, taskFieldName, beerStyle) {
	        var maxTankVolume = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
	
	        var tasks = get(order, taskFieldName);
	        var tasksWithoutProducts = this.filterTaskWithoutProducts(tasks);
	        var tasksWithProductsConfiguration = this.filterTaskWithSomeProductConfiguration(tasks);
	        var tasksWithProductsConfigurationAmount = get(tasksWithProductsConfiguration, 'length') || 0;
	        var orderVolume = get(order, 'volume');
	        var isBatchSections = taskFieldName === 'batchs';
	        // the brewing batch should be spllited by the total volume;
	        var volumeByTask = isBatchSections ? NumberUtils.divide(orderVolume, tasksWithProductsConfigurationAmount) : orderVolume;
	
	        if (maxTankVolume && NumberUtils.isGreater(maxTankVolume, volumeByTask)) {
	            // enter here means that we define as maximum volume value the tank,
	            // because we don't want to auto-populate with some volume higher that the tank could support.
	            volumeByTask = maxTankVolume;
	        }
	
	        if (ContentUtils.isEmptyArray(tasks) || NumberUtils.isLessOrEquals(orderVolume, '0')) {
	            // enter here means we don't need to populate anything
	            return order;
	        }
	
	        order[taskFieldName] = union(map(tasksWithProductsConfiguration, function (task) {
	            var taskName = get(task, 'task') || get(task, 'name');
	
	            // so we search by default brewing icon
	            var products = DashboardServiceCache.getProductByIconNameEnables(taskName);
	            var productTarget = find(products, function (product) {
	                return get(product, 'beerStyleName') === get(beerStyle, 'name');
	            });
	
	            if (productTarget) {
	                var productVolume = NumberUtils.getNumber(get(productTarget, 'volume')) === 0 ? 1 : get(productTarget, 'volume');
	                var productItems = DashboardServiceCache.getProductItemsByProductId(productTarget.id);
	                // calculate the amount of product needed
	                var amountProductNeeded = NumberUtils.divide(volumeByTask, productVolume);
	
	                productTarget.amount = amountProductNeeded;
	                productTarget.volume = NumberUtils.multiplyAndTruncate(productTarget.amount, productVolume);
	                productTarget.isNeededCalculateInventory = true; // this flag is to indicate that this product needed to calculate
	                productTarget.task = task; // later remove this to avoid cycle references
	                productTarget.items = _multiplyAmountOfItems(productItems, productTarget.amount);
	
	                if (ContentUtils.isEmptyArray(task.products)) {
	                    task.products = [productTarget];
	                } else {
	                    task.products = ContentUtils.replaceByAttributes(task.products, productTarget, 'id'); //update in case that exist a new one
	                }
	                task.products = ContentUtils.removeDuplicateByAttribute(task.products, ['id']);
	            }
	
	            return task;
	        }), tasksWithoutProducts);
	
	        return order;
	    },
	    filterTaskWithSomeProductConfiguration: function filterTaskWithSomeProductConfiguration(tasks) {
	        var productIcons = DashboardServiceCache.getProductIcons();
	        return filter(tasks, function (task) {
	            var taskName = get(task, 'task') || get(task, 'name');
	            var haveIcon = taskName && taskName !== 'no-icon';
	            var matchSomeProduct = some(productIcons, function (productIcon) {
	                return get(productIcon, 'icon.iconDetail.name') === taskName || get(productIcon, 'icon.iconDetail.displayName') === taskName;
	            });
	            return haveIcon && matchSomeProduct;
	        });
	    },
	    filterTaskWithoutProducts: function filterTaskWithoutProducts(tasks) {
	        var productIcons = DashboardServiceCache.getProductIcons();
	        return filter(tasks, function (task) {
	            var taskName = get(task, 'task') || get(task, 'name');
	            var haveIcon = taskName && taskName !== 'no-icon';
	            var matchSomeProduct = some(productIcons, function (productIcon) {
	                return get(productIcon, 'icon.iconDetail.name') === taskName || get(productIcon, 'icon.iconDetail.displayName') === taskName;
	            });
	            return !(haveIcon && matchSomeProduct);
	        });
	    },
	    hydrateTaskWithProductsAmount: function hydrateTaskWithProductsAmount(nextState) {
	        if (SessionStore.isFullPaidVersion()) {
	            var order = get(nextState, 'order');
	            if (!order.volume) {
	                order.volume = get(nextState, 'orderVolume');
	            }
	            var beerStyle = get(nextState, 'styleBeerSelected');
	            var haveBrewing = ContentUtils.isNotEmptyArray(get(order, 'batchs'));
	
	            if (haveBrewing) {
	                nextState.order = this.populateEachProductAmount(order, 'batchs', beerStyle);
	            }
	
	            var isSingleOrder = get(order, 'isSingle') || get(nextState, 'singleTasks.length') > 0;
	
	            if (isSingleOrder) {
	                order.singleTasks = get(nextState, 'singleTasks');
	                nextState.order = this.populateEachProductAmount(order, 'singleTasks', beerStyle);
	                nextState.singleTasks = get(nextState, 'order.singleTasks');
	            } else {
	                order.fermenterTasks = get(nextState, 'fermenterTasks');
	                order.packagingTasks = get(nextState, 'packagingTasks');
	                nextState.order = this.populateEachProductAmount(order, 'fermenterTasks', beerStyle);
	                nextState.order = this.populateEachProductAmount(order, 'packagingTasks', beerStyle);
	                nextState.fermenterTasks = get(nextState, 'order.fermenterTasks');
	                nextState.packagingTasks = get(nextState, 'order.packagingTasks');
	            }
	        }
	        return nextState;
	    },
	    _filterScopeInventory: function _filterScopeInventory(allSortedTasks, startingScopeInventoryDate, endingScopeInventoryDate) {
	        if (startingScopeInventoryDate) {
	            if (endingScopeInventoryDate) {
	                return filter(allSortedTasks, function (task) {
	                    return DateUtils.isAfterOrEquals(task.date, startingScopeInventoryDate) && DateUtils.isBefore(endingScopeInventoryDate);
	                });
	            } else {
	                return filter(allSortedTasks, function (task) {
	                    return DateUtils.isAfterOrEquals(task.date, startingScopeInventoryDate);
	                });
	            }
	        }
	        return allSortedTasks;
	    },
	    _filterPurchaseOrderOrdered: function _filterPurchaseOrderOrdered(purchaseItems, allItemsId) {
	        var alreadyPurchaseItems = filter(purchaseItems, function (vendorPurchase) {
	            return Constants.PURCHASE_STATE_DASHBOARD_COUNT_AS_ORDERED.indexOf(get(vendorPurchase, 'state')) > -1;
	        });
	        return filter(alreadyPurchaseItems, function (purchaseItem) {
	            return allItemsId.indexOf(get(purchaseItem, 'itemId')) > -1;
	        });
	    },
	    _filterLocationItemNeeded: function _filterLocationItemNeeded(allTasks, locationItems, allItemsId) {
	        return filter(locationItems, function (locationItem) {
	            return allItemsId.indexOf(get(locationItem, 'item.id')) > -1;
	        });
	    },
	
	
	    /**
	     * Given task retrieve their inventory key string state.
	     *
	     * @param task
	     * @param maxScopeDate
	     * @returns {string}
	     */
	    getInventoryStatusFromTask: function getInventoryStatusFromTask(task) {
	        var maxScopeDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SessionStore.getMaxScopeInventoryDate();
	
	        var haveAtLeastOneProduct = this.haveAProducts(task);
	
	        if (!haveAtLeastOneProduct) {
	            return '';
	        }
	
	        if (this.isEveryProductAlreadyDiscountedAndConfirmed(task)) {
	            // green with white check
	            return Constants.INVENTORY_ALL_DISCOUNTED_AND_CONFIRMED;
	        }
	
	        if (this.isSomeProductNonConfirmedIsOutOfInventoryScope(task, maxScopeDate)) {
	            // RED WITH ADMIRATION WHITE
	            return Constants.INVENTORY_SOME_PRODUCT_NON_CONFIRMED_OUT_SCOPE;
	        }
	
	        if (this.isSomeItemsIsEnoughInPurchase(task)) {
	            // yellow
	            return Constants.INVENTORY_MISSING_ITEMS_BUT_PURCHASE_IN_COMING;
	        }
	
	        if (this.isSomeItemsIsNotEnoughInStock(task)) {
	            // red
	            return Constants.INVENTORY_MISSING_ITEMS;
	        }
	
	        if (this.isSomeProductWasUnconfirmedAlreadyDiscounted(task)) {
	            // green
	            return Constants.INVENTORY_SOME_WAS_UNCONFIRMED_ALREADY_DISCOUNTED;
	        }
	
	        if (this.isSomeProductAlreadyConfirmedAndSomeNotConfirmed(task)) {
	            // green
	            return Constants.INVENTORY_SOME_CONFIRMED_AND_SOME_UNCONFIRMED;
	        }
	
	        if (this.isEnoughInventory(task)) {
	            // green
	            return Constants.INVENTORY_IS_ENOUGH_INVENTORY;
	        }
	    },
	    isEnoughInventory: function isEnoughInventory(task) {
	        return get(task, 'someItemsIsNotEnoughInStock') === false;
	    },
	    isSomeProductNonConfirmedIsOutOfInventoryScope: function isSomeProductNonConfirmedIsOutOfInventoryScope(task, maxScopeDate) {
	        var isSomeNonConfirmedProduct = filter(get(task, 'products'), function (product) {
	            return !get(product, 'isConfirmed');
	        });
	
	        return isSomeNonConfirmedProduct && DateUtils.isBefore(get(task, 'date'), maxScopeDate);
	    },
	    isSomeProductAlreadyConfirmedAndSomeNotConfirmed: function isSomeProductAlreadyConfirmedAndSomeNotConfirmed(task) {
	        var someIsUnConfirmed = some(get(task, 'products'), function (product) {
	            return !get(product, 'isConfirmed');
	        });
	        var someIsConfirmed = some(get(task, 'products'), function (product) {
	            return get(product, 'isConfirmed');
	        });
	
	        return someIsUnConfirmed && someIsConfirmed;
	    },
	    isSomeProductWasUnconfirmedAlreadyDiscounted: function isSomeProductWasUnconfirmedAlreadyDiscounted(task) {
	        return some(get(task, 'products'), function (product) {
	            return !get(product, 'isConfirmed') && get(product, 'isDiscounted');
	        });
	    },
	    isSomeItemsIsNotEnoughInStock: function isSomeItemsIsNotEnoughInStock(task) {
	        return some(get(task, 'products'), function (product) {
	            return get(product, 'someItemsIsNotEnoughInStock') === true;
	        });
	    },
	    isSomeItemsIsEnoughInPurchase: function isSomeItemsIsEnoughInPurchase(task) {
	        return some(get(task, 'products'), function (product) {
	            return get(product, 'someItemsIsNotEnoughInStock') === true && get(product, 'someItemsIsNotEnoughInPurchase') === false;
	        });
	    },
	    isSomeProductAlreadyCalculated: function isSomeProductAlreadyCalculated(products) {
	        return some(products, function (product) {
	            return get(product, 'isNeededCalculateInventory') === false;
	        });
	    },
	    isEveryProductAlreadyDiscountedAndConfirmed: function isEveryProductAlreadyDiscountedAndConfirmed(task) {
	        var products = get(task, 'products') || [];
	        return every(products, function (product) {
	            return get(product, 'isDiscounted');
	        });
	    },
	    returnItemsConsumed: function returnItemsConsumed(product, locationItems) {
	        if (product) {
	            var productItems = get(product, 'items') || [];
	
	            var _loop3 = function _loop3() {
	                if (_isArray4) {
	                    if (_i4 >= _iterator4.length) return 'break';
	                    _ref4 = _iterator4[_i4++];
	                } else {
	                    _i4 = _iterator4.next();
	                    if (_i4.done) return 'break';
	                    _ref4 = _i4.value;
	                }
	
	                var productItem = _ref4;
	
	                var locationItemTarget = find(locationItems, function (locationItem) {
	                    return _getItemId(locationItem) === _getItemId(productItem);
	                });
	
	                if (locationItemTarget) {
	                    var amountsSubtract = (get(productItem, 'whereInventoryWasTakenSaved') || []).map(function (whereInventoryWasSubtracted) {
	                        return get(whereInventoryWasSubtracted, 'amountSubtracted', 0);
	                    });
	                    var amountToReturn = ContentUtils.isNullOrEmpty(amountsSubtract) ? '0' : reduce(amountsSubtract, function (total, amountSubtracted) {
	                        return NumberUtils.sum(total, amountSubtracted);
	                    });
	                    var existingLocationItemAmount = get(locationItemTarget, 'amount', '0');
	                    var newAmount = NumberUtils.sum(existingLocationItemAmount, amountToReturn);
	                    locationItemTarget.amount = newAmount;
	                    locationItems = ContentUtils.replaceByAttributes(locationItems, locationItemTarget, ['item.id', 'location.id']);
	                }
	            };
	
	            for (var _iterator4 = productItems, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	                var _ref4;
	
	                var _ret3 = _loop3();
	
	                if (_ret3 === 'break') break;
	            }
	        }
	
	        return locationItems;
	    },
	    getItemsIdNeedCalculateReservation: function getItemsIdNeedCalculateReservation(task, locationItems) {
	        var products = get(task, 'products') || [];
	        var productsWithAmount = get(products, function (product) {
	            return product.amount;
	        });
	        var items = filter(flatten(map(productsWithAmount, function (product) {
	            return get(product, 'items');
	        })), function (item) {
	            return item;
	        });
	        var itemsId = map(items, function (item) {
	            return get(item, 'itemId');
	        });
	        var itemsFromLocationItemsId = map(locationItems, function (locationItem) {
	            return get(locationItem, 'item.id');
	        });
	        return filter(itemsId, function (itemId) {
	            return itemsFromLocationItemsId.indexOf(itemId) > -1;
	        });
	    },
	
	
	    /**
	     * Update the amount of the location items tacking care the already amount reserved (Non published yet).
	     *
	     * Note: {@link the Product.whereInventoryWasTakenSaved} as reference those items which was published. So
	     * we don need it, because at that particular moment, the location items was affected and updated. So it does not need
	     * to simulate their reservation anymore because was physically discounted from the inventory.
	     *
	     * @param products
	     * @param locationItemsAvailable
	     */
	    updateLocationItemsWithProducts: function updateLocationItemsWithProducts() {
	        var products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var locationItemsAvailable = arguments[1];
	
	
	        if (ContentUtils.isEmptyArray(products)) {
	            return locationItemsAvailable;
	        }
	
	        var itemsIdOfProducts = flatMap(products, function (product) {
	            return product.items;
	        }).map(function (item) {
	            return item.itemId;
	        }) || [];
	        var noRepetedItemOfProducts = uniq(itemsIdOfProducts);
	
	        return map(locationItemsAvailable, function (locationItemAvailable) {
	
	            var locationItemRelatedOfSomeItemOfProducts = noRepetedItemOfProducts.indexOf(get(locationItemAvailable, 'item.id')) > -1;
	
	            if (ContentUtils.isNotEmptyArray(products) && locationItemRelatedOfSomeItemOfProducts) {
	
	                var productsShouldSubtract = filter(products, function (product) {
	                    return !(product.isDiscounted && !product.isConfirmed && !product.isSaved);
	                });
	                var productsShouldAdd = filter(products, function (product) {
	                    return product.isDiscounted && !product.isConfirmed && !product.isSaved;
	                });
	                var itemsShouldSubtract = flatten(map(productsShouldSubtract, function (product) {
	                    return product.items;
	                }));
	                var itemsShouldAdd = flatten(map(productsShouldAdd, function (product) {
	                    return product.items;
	                }));
	                // notice that we need to discount here the inventory which is already taken from location items
	                var whereInventoryWasTakenNewSubtract = filter(flatten(map(itemsShouldSubtract, function (item) {
	                    return get(item, 'whereInventoryWasTakenNew');
	                })), function (info) {
	                    return info;
	                });
	                var whereInventoryWasTakenNewAdd = filter(flatten(map(itemsShouldAdd, function (item) {
	                    return get(item, 'whereInventoryWasTakenNew');
	                })), function (info) {
	                    return info;
	                });
	                var whereInventoryWasTakenNewFilteredSubtract = filter(whereInventoryWasTakenNewSubtract, function (info) {
	                    return get(info, 'locationItemId') === get(locationItemAvailable, 'id');
	                });
	                var whereInventoryWasTakenNewFilteredAdd = filter(whereInventoryWasTakenNewAdd, function (info) {
	                    return get(info, 'locationItemId') === get(locationItemAvailable, 'id');
	                });
	
	                if (ContentUtils.isNotEmptyArray(whereInventoryWasTakenNewFilteredSubtract)) {
	                    var subtractedAmounts = map(whereInventoryWasTakenNewFilteredSubtract, function (item) {
	                        return get(item, 'amountSubtracted');
	                    });
	                    var totalAmountSubtracted = reduce(subtractedAmounts, function (num, total) {
	                        return NumberUtils.sum(num, total);
	                    });
	                    locationItemAvailable.amount = NumberUtils.subtract(locationItemAvailable.amount, totalAmountSubtracted);
	                }
	
	                if (ContentUtils.isNotEmptyArray(whereInventoryWasTakenNewFilteredAdd)) {
	                    var _subtractedAmounts = map(whereInventoryWasTakenNewFilteredAdd, function (item) {
	                        return get(item, 'amountSubtracted');
	                    });
	                    var totalAmountAdded = reduce(_subtractedAmounts, function (num, total) {
	                        return NumberUtils.sum(num, total);
	                    });
	                    locationItemAvailable.amount = NumberUtils.sum(locationItemAvailable.amount, totalAmountAdded);
	                }
	            }
	            return locationItemAvailable;
	        });
	    },
	    isSomeItemPurchased: function isSomeItemPurchased(purchaseItems, itemId) {
	        var purchaseItemOrdered = filter(purchaseItems, function (purchaseItem) {
	            return purchaseItem.state !== 'PENDING';
	        });
	
	        return some(purchaseItemOrdered, function (purchaseItem) {
	
	            var amountRequested = get(purchaseItem, 'amountRequestedUpdated', get(purchaseItem, 'amountRequested'));
	            var isItemPurchased = get(purchaseItem, 'itemId') === itemId;
	            var isPurchasedAmountGratherThanZero = NumberUtils.isGreater(amountRequested, 0);
	
	            return isItemPurchased && isPurchasedAmountGratherThanZero;
	        });
	    },
	    isSomeItemAlreadyPurchased: function isSomeItemAlreadyPurchased(purchaseItems) {
	        var purchaseItemOrdered = filter(purchaseItems, function (purchaseItem) {
	            return purchaseItem.state !== 'PENDING';
	        });
	
	        return some(purchaseItemOrdered, function (purchaseItem) {
	            var allWhereInventoryWasTaken = concat(get(purchaseItem, 'whereInventoryWasTakenNew'), get(purchaseItem, 'whereInventoryWasTakenSaved'));
	            return some(allWhereInventoryWasTaken, function (info) {
	                return NumberUtils.isGreater(get(info, 'amountPurchased'), 0);
	            });
	        });
	    },
	
	
	    /**
	     * Subtract the amount of the purchase order because. At business level we try to discount
	     * before to inventory and didn't was enough.
	     *
	     * @param item
	     * @param purchaseItems
	     * @param taskDate
	     * @return {*}
	     */
	    subtractAmountFromPurchaseOrders: function subtractAmountFromPurchaseOrders(item, purchaseItems, taskDate) {
	        var itemId = item.itemId;
	
	        // validate if have at lest one purchase item which the item needed
	        item.isPurchased = this.isSomeItemPurchased(purchaseItems, itemId);
	        item.isPurchasedAmountEnough = false; // by default, then we validate if we have enough or not
	
	        var foundPurchaseItemsTarget = false;
	
	        // sort by first higher amount request
	        // in order to optimize the searching request
	        var purchaseItemsFilterByItemId = filter(ContentUtils.filterEnable(purchaseItems), function (purchaseItem) {
	            return get(purchaseItem, 'itemId') === itemId && NumberUtils.isGreater(get(purchaseItem, 'amountRequestedUpdated', get(purchaseItem, 'amountRequested')), 0);
	        }) || [];
	        var purchaseItemsByAmountRequestDesc = this.sortPurchaseItemByAmountRequested(purchaseItemsFilterByItemId);
	
	        // iterate purchase items instead of filter first
	        // because we want to change amount reference of original purchase item list
	        for (var _iterator5 = purchaseItemsByAmountRequestDesc, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	            var _ref5;
	
	            if (_isArray5) {
	                if (_i5 >= _iterator5.length) break;
	                _ref5 = _iterator5[_i5++];
	            } else {
	                _i5 = _iterator5.next();
	                if (_i5.done) break;
	                _ref5 = _i5.value;
	            }
	
	            var purchaseItem = _ref5;
	
	
	            if (purchaseItem.itemId !== itemId) {
	                continue;
	            }
	
	            // check first if items which was purchase arrive
	            // before that we needed
	            if (!_isPurchaseItemArrive(taskDate, purchaseItem)) {
	                continue;
	            }
	
	            if (ContentUtils.isEmptyArray(item.whereInventoryWasTakenNew)) {
	                item.whereInventoryWasTakenNew = [];
	            }
	
	            var _processAmountSubtrac = this.processAmountSubtractedFromPurchaseItem(purchaseItem, item.amountNeededLeft),
	                purchaseItemUpdated = _processAmountSubtrac.purchaseItemUpdated,
	                amountPurchased = _processAmountSubtrac.amountPurchased,
	                haveEnoughPurchaseItems = _processAmountSubtrac.haveEnoughPurchaseItems;
	
	            purchaseItem = purchaseItemUpdated;
	
	            // the amount subtracted from the purchase
	            var amountSubtractedFromPurchase = haveEnoughPurchaseItems ? item.amountNeededLeft : amountPurchased;
	
	            // save record about amount left remaining
	            item.amountNeededLeft = haveEnoughPurchaseItems ? 0 : NumberUtils.subtract(item.amountNeededLeft, amountPurchased);
	
	            if (NumberUtils.isGreater(amountSubtractedFromPurchase, '0')) {
	                // don't make sense if don't subtract anything
	                // save the operation
	                item.whereInventoryWasTakenNew.push({
	                    itemId: get(item, 'item.id'),
	                    type: 'VENDOR_PURCHASE_ITEM_MODULE',
	                    amountSubtracted: amountSubtractedFromPurchase,
	                    vendorPurchaseItemId: purchaseItem.id,
	                    code: purchaseItem.code,
	                    purchaseId: purchaseItem.purchaseId,
	                    amountPurchased: amountPurchased,
	                    amountAfter: purchaseItem.amountRequestedUpdated,
	                    amountItemNeededLeft: cloneDeep(item.amountNeededLeft) // break reference
	                });
	            }
	            if (haveEnoughPurchaseItems) {
	                foundPurchaseItemsTarget = true;
	                break; // finish to finding more purchases
	            }
	        }
	
	        if (foundPurchaseItemsTarget) {
	            // remove the old item missing estimation
	            item.whereInventoryWasTakenNew = filter(item.whereInventoryWasTakenNew || [], function (inventoryInfo) {
	                return get(inventoryInfo, 'type') !== 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';
	            }) || [];
	
	            // say the amount purchased of this items are enough
	            item.isPurchasedAmountEnough = true;
	        } else {
	            // say the amount purchased of this items are not enough
	            item.isPurchasedAmountEnough = false;
	
	            if (ContentUtils.isEmptyArray(item.whereInventoryWasTakenNew)) {
	                item.whereInventoryWasTakenNew = [];
	            }
	
	            // remove the old item missing estimation
	            item.whereInventoryWasTakenNew = filter(item.whereInventoryWasTakenNew || [], function (inventoryInfo) {
	                return get(inventoryInfo, 'type') !== 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';
	            }) || [];
	
	            item.whereInventoryWasTakenNew.push({
	                type: 'VENDOR_PURCHASE_ITEM_MISSING_MODULE',
	                amountItemNeeded: cloneDeep(item.amountNeededLeft), // break reference
	                itemIdNeeded: get(item, 'item.id'),
	                dateNeeded: taskDate,
	                amountSubtracted: '0',
	                amountAfter: '0',
	                amountPurchased: '0'
	            });
	        }
	
	        return {
	            itemUpdated: item,
	            purchaseItemsUpdated: purchaseItems
	        };
	    },
	    processAmountSubtractedFromPurchaseItem: function processAmountSubtractedFromPurchaseItem(purchaseItem, amountNeededLeft) {
	        var relativeUnitAmount = get(purchaseItem, 'relativeUnitAmount');
	        this.discountAlreadyReceivedItems(purchaseItem);
	
	        var amountPurchased = this._getAmountPurchased(purchaseItem, relativeUnitAmount);
	        var haveEnoughPurchaseItems = NumberUtils.isGreaterOrEquals(amountPurchased, amountNeededLeft);
	
	        if (haveEnoughPurchaseItems) {
	            purchaseItem.amountSubtracted = amountNeededLeft;
	            if (NumberUtils.isGreater(relativeUnitAmount, 1)) {
	                // enter here means we need to update the amount request with the relative amount again in order
	                // to count properly the next time that need to count how many amount requested was taken
	                var amountRelativeSubtracted = NumberUtils.divideAndTruncate(purchaseItem.amountSubtracted, relativeUnitAmount, 10);
	                var amountRelativeRemain = NumberUtils.divideAndTruncate(amountPurchased, relativeUnitAmount, 10);
	                purchaseItem.amountRequestedUpdated = NumberUtils.subtract(amountRelativeRemain, amountRelativeSubtracted);
	            } else {
	                purchaseItem.amountRequestedUpdated = NumberUtils.subtract(amountPurchased, amountNeededLeft);
	            }
	        } else {
	            purchaseItem.amountSubtracted = amountPurchased;
	            purchaseItem.amountRequestedUpdated = '0';
	        }
	
	        return {
	            purchaseItemUpdated: purchaseItem,
	            amountPurchased: amountPurchased,
	            haveEnoughPurchaseItems: haveEnoughPurchaseItems
	        };
	    },
	
	
	    discountAlreadyReceivedItems: function discountAlreadyReceivedItems(purchaseItem) {
	        if (purchaseItem.state === 'MORE_ON_THE_WAY' && !purchaseItem.isAmountReceivedAlreadyCounted) {
	            // Enter here means we have some PO that I already received partially, but I'm waiting to receive more.
	            // So, we need to updated in the PO, the amount that we already received in order to don't calculate the amount ordered
	            // as the same of initial amount. Eg, As a admin, I already received 200 of 1000 item requested, It's left 800 to count in yellow state not 1000.
	            purchaseItem.isAmountReceivedAlreadyCounted = true;
	            purchaseItem.amountRequestedUpdated = NumberUtils.subtract(purchaseItem.amountRequestedNumber, purchaseItem.totalAmountReceived);
	        }
	    },
	
	    toSystemUnitAmount: function toSystemUnitAmount(relativeAmount, relativeUnitAmount) {
	        return Math.round(NumberUtils.multiplyAndTruncate(relativeAmount, relativeUnitAmount, 4));
	    },
	    toRelativeAmountPurchased: function toRelativeAmountPurchased(systemAmount, relativeUnitAmount) {
	        return NumberUtils.divideAndTruncate(systemAmount, relativeUnitAmount, 4);
	    },
	    _getAmountPurchased: function _getAmountPurchased(purchaseItem) {
	        var relativeUnitAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        var amountPurchased = get(purchaseItem, 'amountRequestedUpdated', get(purchaseItem, 'amountRequested'));
	
	        if (NumberUtils.isGreater(relativeUnitAmount, 1)) {
	            return this.toSystemUnitAmount(relativeUnitAmount, amountPurchased);
	        }
	
	        return amountPurchased;
	    },
	
	
	    /**
	     * This flag help to indicate when given product should not be calculated automatically. So imagine the situation
	     * where the user indicate manually where he want to subtract their item. (the user indicate which location want, different that the program suggest) Or
	     * laso other scenario would be after the user confirm their product.
	     * So whenever scenario was, when this flag is turn-on, we should not auto-calculated again about which location the item will taken, until turn-off again this indicator.
	     * @param product
	     * @returns {*}
	     */
	    turnOnWhereInventoryWasTakenNonChanged: function turnOnWhereInventoryWasTakenNonChanged(product) {
	        var items = get(product, 'items');
	
	        if (ContentUtils.isNotEmptyArray(items)) {
	            product.items = map(product.items, function (item) {
	                item.preventRecalculateWhereInventoryWasTaken = true;
	                return item;
	            });
	        }
	
	        return product;
	    },
	
	
	    /**
	     * The opposite of {@link this.turnOnWhereInventoryWasTakenNonChanged()}.
	     * @param product
	     * @returns {*}
	     */
	    turnOffWhereInventoryWasTakenNonChanged: function turnOffWhereInventoryWasTakenNonChanged(product) {
	        var items = get(product, 'items');
	
	        if (ContentUtils.isNotEmptyArray(items)) {
	            product.items = map(product.items, function (item) {
	                item.preventRecalculateWhereInventoryWasTaken = false;
	                return item;
	            });
	        }
	
	        return product;
	    },
	    subtractAmountFromLocationItems: function subtractAmountFromLocationItems(itemTarget, locationItemsAvailable) {
	
	        var originalItem = DashboardServiceCache.getItemById(get(itemTarget, 'itemId'));
	        var havePreferredLocation = get(originalItem, 'preferredLocation') !== null;
	        if (havePreferredLocation) {
	            // enter here means will order by preferred location first the items availables
	            // in order to consume first
	            var preferredLocationName = get(originalItem, 'preferredLocation.name');
	            locationItemsAvailable = ContentUtils.sortListByValue(locationItemsAvailable, 'location.name', preferredLocationName);
	        }
	
	        // item id which need the subtract from some location
	        var itemTargetId = get(itemTarget, 'item.id');
	
	        var locationItemsAvailablesFiltered = locationItemsAvailable.filter(function (item) {
	            return item.item.id === itemTargetId;
	        });
	
	        var locationItemsAvailableUpdated = map(locationItemsAvailablesFiltered, function (locationItemAvailable) {
	            // ask if still pending subtract the amount of the item
	            // or if location items is the need
	            var isAlreadyDiscountedAllItemsNeeded = NumberUtils.isEqual(itemTarget.amountNeededLeft, '0');
	            var isNotEnoughItemAvailable = NumberUtils.isLessOrEquals(locationItemAvailable.amount, '0');
	            var isLocationItemTarget = (get(locationItemAvailable, 'itemId') || get(locationItemAvailable, 'item.id')) === itemTargetId;
	
	            if (isAlreadyDiscountedAllItemsNeeded || !isLocationItemTarget || isNotEnoughItemAvailable) {
	                // when we already subtract all the item needed or
	                // the location item iterate it does not match with "itemTargetId" or
	                // is not enough item available in this location to subtract ---> keep searching for another location
	                return locationItemAvailable;
	            }
	
	            var amountInStockAvailable = get(locationItemAvailable, 'amount');
	            var isEnoughLocationItem = NumberUtils.isLessOrEquals(itemTarget.amountNeededLeft, amountInStockAvailable);
	            var amountStockSubtracted = '0';
	
	            if (isEnoughLocationItem) {
	                amountStockSubtracted = itemTarget.amountNeededLeft;
	                itemTarget.amountNeededLeft = '0';
	                locationItemAvailable.amount = NumberUtils.subtract(amountInStockAvailable, amountStockSubtracted);
	                // reset old purchased option just in case to clean old estimation
	                itemTarget.isPurchased = false;
	                itemTarget.isPurchasedAmountEnough = false;
	            } else {
	                // we discount all the amount from stock
	                amountStockSubtracted = amountInStockAvailable;
	                itemTarget.amountNeededLeft = NumberUtils.subtract(itemTarget.amountNeededLeft, amountInStockAvailable);
	                locationItemAvailable.amount = '0';
	            }
	
	            if (ContentUtils.isEmptyArray(itemTarget.whereInventoryWasTakenNew)) {
	                itemTarget.whereInventoryWasTakenNew = [];
	            }
	
	            // save the operation
	            itemTarget.whereInventoryWasTakenNew.push({
	                type: 'LOCATION_ITEM_MODULE',
	                itemId: get(itemTarget, 'item.id'),
	                amountSubtracted: amountStockSubtracted,
	                locationItemId: locationItemAvailable.id,
	                locationId: get(locationItemAvailable, 'location.id'),
	                amountInStock: amountInStockAvailable,
	                amountAfter: locationItemAvailable.amount,
	                amountItemNeededLeft: itemTarget.amountNeededLeft
	            });
	
	            return locationItemAvailable;
	        });
	
	        if (ContentUtils.isNotEmptyArray(locationItemsAvailableUpdated)) {
	            locationItemsAvailableUpdated.forEach(function (locationItemUpdated) {
	                locationItemsAvailableUpdated = ContentUtils.replaceByAttributes(locationItemsAvailable, locationItemUpdated, 'id');
	            });
	        }
	
	        return {
	            locationItemsAvailable: locationItemsAvailableUpdated,
	            itemUpdated: itemTarget
	        };
	    },
	    getTotalAmountReservedByItem: function getTotalAmountReservedByItem(task, itemId) {
	        if (!task || !itemId) {
	            return 0;
	        }
	
	        var products = get(task, 'products', []);
	        var total = {
	            amountReserved: 0,
	            amountPurchased: 0,
	            amountItemNeeded: 0
	        };
	        (products || []).forEach(function (product) {
	            var items = get(product, 'items');
	
	            var totalSubtracted = reduce(items, function (total, item) {
	                if (_getItemId(item) !== itemId) {
	                    return total;
	                }
	                var allTaskStockReserved = concat(get(item, 'whereInventoryWasTakenNew'), get(item, 'whereInventoryWasTakenSaved')).filter(function (whereInventoryWasTaken) {
	                    return whereInventoryWasTaken && whereInventoryWasTaken.type === 'LOCATION_ITEM_MODULE';
	                });
	
	                var amountSubtracted = reduce(allTaskStockReserved, function (total, whereInventoryWasTaken) {
	                    if (NumberUtils.isGreater(get(whereInventoryWasTaken, 'amountSubtracted'), 0)) {
	                        return NumberUtils.sum(total, get(whereInventoryWasTaken, 'amountSubtracted'));
	                    }
	                    return total;
	                }, 0);
	
	                return NumberUtils.sum(total, amountSubtracted);
	            }, 0);
	
	            var totalAmountPurchased = reduce(items, function (total, item) {
	                if (_getItemId(item) !== itemId) {
	                    return total;
	                }
	                var allRequested = concat(get(item, 'whereInventoryWasTakenNew'), get(item, 'whereInventoryWasTakenSaved')).filter(function (whereInventoryWasTaken) {
	                    return whereInventoryWasTaken && whereInventoryWasTaken.type === 'VENDOR_PURCHASE_ITEM_MODULE';
	                });
	
	                var amountPurchased = reduce(allRequested, function (total, whereInventoryWasTaken) {
	                    return NumberUtils.sum(total, get(whereInventoryWasTaken, 'amountSubtracted'));
	                }, 0);
	
	                return NumberUtils.sum(total, amountPurchased);
	            }, 0);
	
	            var totalItemNeeded = reduce(items, function (total, item) {
	                if (_getItemId(item) !== itemId) {
	                    return total;
	                }
	                var allTask = concat(get(item, 'whereInventoryWasTakenNew'), get(item, 'whereInventoryWasTakenSaved'));
	                var amountSubtracted = reduce(allTask, function (total, whereInventoryWasTaken) {
	                    return NumberUtils.sum(total, get(whereInventoryWasTaken, 'amountItemNeeded'));
	                }, 0);
	                return NumberUtils.sum(total, amountSubtracted);
	            }, 0);
	
	            total.amountPurchased = NumberUtils.sum(total.amountPurchased, totalAmountPurchased);
	            total.amountSubtracted = NumberUtils.sum(total.amountSubtracted, totalSubtracted);
	            total.amountItemNeeded = NumberUtils.sum(total.amountItemNeeded, totalItemNeeded);
	        });
	
	        total.amountPurchased = NumberUtils.formatDecimal(total.amountPurchased);
	        total.amountItemNeeded = NumberUtils.formatDecimal(total.amountItemNeeded);
	        total.amountSubtracted = NumberUtils.formatDecimal(total.amountSubtracted);
	
	        return total;
	    },
	    subtractAmountFromSpecificLocationItems: function subtractAmountFromSpecificLocationItems(itemTarget, locationItemsAvailable) {
	        var whereInventoryWasTakenList = get(itemTarget, 'whereInventoryWasTakenNew') || [];
	
	        // update the amount location items with the custom subtraction of given
	        // location items availables
	        var locationItemsAvailableUpdated = map(locationItemsAvailable, function (locationItemAvailable) {
	            var whereInventoryWasTakenTarget = find(whereInventoryWasTakenList, function (whereInventoryWasTaken) {
	                return get(whereInventoryWasTaken, 'locationId') === get(locationItemAvailable, 'location.id');
	            });
	
	            if (!whereInventoryWasTakenTarget) {
	                // enter here means the location items is not affected
	                return locationItemAvailable;
	            }
	
	            // subtract the specific amount
	            var amountInStockAvailable = get(locationItemAvailable, 'amount');
	            var amountSubtracted = get(whereInventoryWasTakenTarget, 'amountSubtracted');
	            locationItemAvailable.amount = NumberUtils.subtract(amountInStockAvailable, amountSubtracted);
	
	            return locationItemAvailable;
	        });
	
	        return {
	            locationItemsAvailable: locationItemsAvailableUpdated,
	            itemUpdated: itemTarget
	        };
	    },
	    updateProductItemFromProduct: function updateProductItemFromProduct(product, newProductItem) {
	        if (product && ContentUtils.isNotEmptyArray(product.items)) {
	            // update product items which are location amount updated
	            product.items = ContentUtils.replaceByAttributes(product.items, newProductItem, 'id');
	        }
	        return product;
	    },
	    createWhereInventoryWasTaken: function createWhereInventoryWasTaken(locationId, itemId, productItemAmount, newAmountLocationItem, whereInventoryWasTakenLatest) {
	        // we retrieve an existing locationItem in safe way because
	        // the amount availability was checked before
	        var existingLocationItem = DashboardServiceCache.getLocationItemByLocationIdAndItemId(locationId, itemId);
	        var amountSubtractedBefore = this.getTotalAmountSubtractedFromWhereInventoryWasTaken(whereInventoryWasTakenLatest);
	        var totalAmountSubtracted = NumberUtils.sum(amountSubtractedBefore, newAmountLocationItem);
	        var amountItemNeededLeft = NumberUtils.subtract(productItemAmount, totalAmountSubtracted);
	
	        var existingStockInLocation = get(existingLocationItem, 'amount') || '0.00';
	        var amountInStockLeft = NumberUtils.subtract(existingStockInLocation, totalAmountSubtracted);
	
	        return {
	            type: 'LOCATION_ITEM_MODULE',
	            itemId: itemId,
	            locationId: locationId,
	            locationItemId: get(existingLocationItem, 'id'),
	            amountSubtracted: newAmountLocationItem,
	            amountInStock: existingStockInLocation,
	            amountAfter: amountInStockLeft,
	            amountItemNeededLeft: amountItemNeededLeft,
	            isNew: true // flag to difference between `saved` to `new` kind of whereInventoryWasTaken once merge list
	        };
	    },
	    getTotalAmountSubtractedFromWhereInventoryWasTaken: function getTotalAmountSubtractedFromWhereInventoryWasTaken(whereInventoryWasTaken) {
	        var amountsSubtracted = map(whereInventoryWasTaken, function (inventoryInfo) {
	            return get(inventoryInfo, 'amountSubtracted');
	        });
	        return reduce(amountsSubtracted, function (total, amount) {
	            return NumberUtils.sum(total, amount);
	        });
	    },
	
	
	    /**
	     * Subtract the specific location items
	     *
	     * @param productItem
	     * @param {@Number} newAmountLocationItem       The new location which define the user
	     * @param locationId
	     * @return {{newProductItemAmount: *|string, newWhereInventoryWasTakenItemUpdated: *, productItemUpdated: *}}
	     */
	    onChangeAmountInLocation: function onChangeAmountInLocation(productItem, newAmountLocationItem, locationId) {
	        // indicate to the system about non-calculate
	        // where inventory was taken automatically until turn-off this flag again
	        productItem.preventRecalculateWhereInventoryWasTaken = true;
	        var itemId = get(productItem, 'item.id');
	
	        // retrieve the last update of each where inventory was taken
	        var whereInventoryWasTakenLatest = this.retrieveLatestWhereInventoryWasTaken(productItem);
	
	        // search if exist some whereInventory was taken from this particular location/item
	        var whereInventoryWasTakenItem = find(whereInventoryWasTakenLatest, function (itemTarget) {
	            return get(itemTarget, 'locationId') === locationId && get(itemTarget, 'itemId') === itemId && get(itemTarget, 'type') === 'LOCATION_ITEM_MODULE';
	        });
	        var productItemAmount = get(productItem, 'amount');
	
	        if (ContentUtils.isNull(whereInventoryWasTakenItem)) {
	            // enter here means doesn't exist where location was taken before for this particular location/item
	            whereInventoryWasTakenItem = this.createWhereInventoryWasTaken(locationId, itemId, productItemAmount, newAmountLocationItem, whereInventoryWasTakenLatest);
	            productItem.whereInventoryWasTakenNew = union(productItem.whereInventoryWasTakenNew, [whereInventoryWasTakenItem]);
	        } else {
	            // enter here means already exist where location was taken, so we need to change it
	            var whereInventoryWasTakenItemUpdated = this.changeAmountWhereInventoryWasTakenLocation(whereInventoryWasTakenItem, newAmountLocationItem);
	
	            var newWhereInventoryWasDeleted = whereInventoryWasTakenItemUpdated === undefined;
	            if (newWhereInventoryWasDeleted) {
	                // enter here means the user was selected '0' in one particular location
	                // so, we create a new one with 0
	                var newWhereInventoryWasTakenItem = this.createWhereInventoryWasTaken(locationId, itemId, productItemAmount, newAmountLocationItem, whereInventoryWasTakenLatest);
	                // remove the before wherePositionWasTaken
	                productItem.whereInventoryWasTakenNew = cloneDeep(ContentUtils.removeItemByObjectEquality(productItem.whereInventoryWasTakenNew, whereInventoryWasTakenItem)) || [];
	                productItem.whereInventoryWasTakenNew.push(newWhereInventoryWasTakenItem);
	            } else {
	                // remove the before wherePositionWasTaken
	                productItem.whereInventoryWasTakenNew = cloneDeep(ContentUtils.removeItemByObjectEquality(productItem.whereInventoryWasTakenNew, whereInventoryWasTakenItem)) || [];
	                productItem.whereInventoryWasTakenNew.push(whereInventoryWasTakenItemUpdated);
	            }
	        }
	
	        // retrieve each of `whereInventoryWasTaken` after update the productItem
	        var whereInventoryWasTakenLatestAfterUpdate = this.retrieveLatestWhereInventoryWasTaken(productItem);
	        var newProductItemAmount = this.getTotalAmountSubtracted(whereInventoryWasTakenLatestAfterUpdate) || '0.00'; // empty must be zero
	
	        // change product item to reflect the changes we want.
	        productItem.amount = newProductItemAmount;
	        productItem.manualAmount = newProductItemAmount;
	        return productItem;
	    },
	    retrieveLatestWhereInventoryWasTaken: function retrieveLatestWhereInventoryWasTaken(productItem) {
	        var whereInventoryWasTakenSaved = get(productItem, 'whereInventoryWasTakenSaved') || [];
	        var whereInventoryWasTakenNew = get(productItem, 'whereInventoryWasTakenNew') || [];
	
	        var whereInventoryWasTakenSavedFiltered = filter(whereInventoryWasTakenSaved, function (inventoryInfoSaved) {
	            var locationId = get(inventoryInfoSaved, 'locationId');
	            var itemId = get(inventoryInfoSaved, 'itemId');
	            var existInfoSavedNew = some(whereInventoryWasTakenNew, function (inventoryInfoNew) {
	                return get(inventoryInfoNew, 'locationId') === locationId && get(inventoryInfoNew, 'itemId') === itemId;
	            });
	            return existInfoSavedNew ? false : true;
	        });
	
	        return union(whereInventoryWasTakenSavedFiltered, whereInventoryWasTakenNew);
	    },
	    changeAmountOfProductItem: function changeAmountOfProductItem(product, itemId, newProductItemAmount) {
	        var productItems = get(product, 'items');
	        var productItemTarget = find(productItems, function (productItem) {
	            return get(productItem, 'id') === itemId || get(productItem, 'itemId') === itemId;
	        });
	        if (productItemTarget) {
	            productItemTarget.amount = newProductItemAmount;
	            productItemTarget.manualAmount = newProductItemAmount;
	            product.items = ContentUtils.replaceByAttributes(productItems, productItemTarget, 'id');
	            return product;
	        } else {
	            return product;
	        }
	    },
	    getTotalAmountSubtracted: function getTotalAmountSubtracted(whereInventoryWasSubtractedList) {
	        var amountsSubtracted = map(whereInventoryWasSubtractedList, function (whereInventoryWasSubtracted) {
	            var type = get(whereInventoryWasSubtracted, 'type');
	            if (type === 'LOCATION_ITEM_MODULE' || type === 'VENDOR_PURCHASE_ITEM_MODULE') {
	                return get(whereInventoryWasSubtracted, 'amountSubtracted');
	            }
	
	            if (type === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE') {
	                return get(whereInventoryWasSubtracted, 'amountItemNeeded');
	            }
	
	            return '0'; //should not entry here
	        });
	        return reduce(amountsSubtracted, function (sum, amount) {
	            return NumberUtils.sum(sum, amount);
	        });
	    },
	    changeAmountWhereInventoryWasTakenLocation: function changeAmountWhereInventoryWasTakenLocation(whereInventoryWasTakenLocation, newAmount) {
	        var hastNotAmountDefined = NumberUtils.isLessOrEquals(newAmount, 0);
	
	        if (hastNotAmountDefined || ContentUtils.isNull(whereInventoryWasTakenLocation)) {
	            // enter here means the location was taken should be removed
	            return undefined;
	        }
	
	        var amountInStock = whereInventoryWasTakenLocation.amountInStock;
	        var isNewAmountSubtractedGreaterThanAmountInLocation = NumberUtils.isGreater(newAmount, amountInStock);
	
	        if (isNewAmountSubtractedGreaterThanAmountInLocation) {
	            // enter here means is not possible to subtract
	            // more than available in location
	            return whereInventoryWasTakenLocation;
	        }
	
	        return merge(whereInventoryWasTakenLocation, {
	            amountInStock: amountInStock,
	            amountAfter: NumberUtils.subtract(amountInStock, newAmount),
	            amountSubtracted: newAmount,
	            amountItemNeededLeft: NumberUtils.subtract(whereInventoryWasTakenLocation.amountItemNeededLeft, newAmount)
	        });
	    },
	    getProposalLocationItems: function getProposalLocationItems(locations, items, locationItems) {
	        var proposalLocationItems = [];
	
	        var index = 0;
	
	        var _loop4 = function _loop4() {
	            if (_isArray6) {
	                if (_i6 >= _iterator6.length) return 'break';
	                _ref6 = _iterator6[_i6++];
	            } else {
	                _i6 = _iterator6.next();
	                if (_i6.done) return 'break';
	                _ref6 = _i6.value;
	            }
	
	            var location = _ref6;
	
	            var _loop5 = function _loop5() {
	                if (_isArray7) {
	                    if (_i7 >= _iterator7.length) return 'break';
	                    _ref7 = _iterator7[_i7++];
	                } else {
	                    _i7 = _iterator7.next();
	                    if (_i7.done) return 'break';
	                    _ref7 = _i7.value;
	                }
	
	                var item = _ref7;
	
	
	                var locationItemTarget = find(locationItems, function (locationItem) {
	                    return (get(locationItem, 'item.id') || get(locationItem, 'itemId')) === get(item, 'id') && (get(locationItem, 'location.id') || get(locationItem, 'locationId')) === get(location, 'id');
	                });
	                var amountInLocation = get(locationItemTarget, 'amount') || 0;
	                var isAlreadyCreated = ContentUtils.isNotNullOrUndefined(locationItemTarget);
	
	                if (isAlreadyCreated && NumberUtils.isGreater(NumberUtils.getNumber(amountInLocation), 0)) {
	                    // not need to create a proposal item
	                    proposalLocationItems.push(locationItemTarget);
	                    return 'continue';
	                }
	
	                var isCurrentLocationPreferred = get(item, 'preferredLocation.id') === get(location, 'id');
	                if (!isCurrentLocationPreferred) {
	                    // if the item is not preferred location, it doesn't make sense to create an item proposal,
	                    // only for preferred location item exist proposal item
	                    return 'continue';
	                }
	
	                index++;
	
	                // create a new empty proposal location items
	                proposalLocationItems.push({
	                    id: index, // need a fake id, in order to work table selection properly
	                    isProposalItem: true,
	                    item: item,
	                    location: location,
	                    amount: '0'
	                });
	            };
	
	            _loop6: for (var _iterator7 = items, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
	                var _ref7;
	
	                var _ret5 = _loop5();
	
	                switch (_ret5) {
	                    case 'break':
	                        break _loop6;
	
	                    case 'continue':
	                        continue;}
	            }
	        };
	
	        for (var _iterator6 = locations, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	            var _ref6;
	
	            var _ret4 = _loop4();
	
	            if (_ret4 === 'break') break;
	        }
	
	        return proposalLocationItems;
	    },
	    _getItemAndItemId: function _getItemAndItemId(itemNonDiscountedYet) {
	        var isProductItem = get(itemNonDiscountedYet, 'item') !== undefined;
	        var item = itemNonDiscountedYet;
	        var itemId = void 0;
	        if (isProductItem) {
	            // first check if the manual amount was defined, then
	            // check if have some estimateAmount, then a amount and by
	            // latest the defaultAmount.
	            item.amount = itemNonDiscountedYet.manualAmount || itemNonDiscountedYet.estimateAmount || itemNonDiscountedYet.amount || itemNonDiscountedYet.defaultAmount;
	            itemId = get(item, 'item.id');
	            item.itemId = itemId;
	        } else {
	            itemId = get(item, 'itemId') || get(item, 'id');
	            item.itemId = itemId;
	        }
	
	        return {
	            item: item,
	            itemId: itemId
	        };
	    },
	    sortPurchaseItemByAmountRequested: function sortPurchaseItemByAmountRequested(purchasedItems) {
	        if (ContentUtils.isEmptyArray(purchasedItems)) {
	            return purchasedItems;
	        }
	
	        var amountPurchaseWithNumber = map(purchasedItems, function (purchaseItem) {
	            purchaseItem.amountRequestedNumber = +purchaseItem.amountRequested;
	            return purchaseItem;
	        });
	        var purchaseItemsSorted = orderBy(amountPurchaseWithNumber, ['amountRequestedNumber'], ['desc']);
	        return purchaseItemsSorted;
	    },
	    onChangeProducts: function onChangeProducts(ordersCloned, nextState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder) {
	        var _ref8;
	
	        var draftOrder = nextState.order;
	
	        // This is important to don't re-calculate in case of exist a whereinventory was taken
	        // which indicate the user make some changes from the modal and don't want to remove these changes.
	        var hasSomeWhereInventoryWasTaken = some(productWithoutChange.items, function (item) {
	            return item && item.whereInventoryWasTakenNew && item.whereInventoryWasTakenNew.length > 0;
	        });
	
	        if (productWithoutChange.isNeededCalculateInventory || hasSomeWhereInventoryWasTaken) {
	            // enter here means we turn-off the flag about
	            // the needed to calculate the inventory, this turn-on from `InventoryStore.hydrateTaskWithProductsAmount`
	            productWithoutChange.isNeededCalculateInventory = false;
	        }
	
	        var isUnconfirmedProductAlreadySaved = productWithoutChange.isConfirmed === false && productWithoutChange.isDiscounted;
	        if (isUnconfirmedProductAlreadySaved && !productWithoutChange.needToPublishDisconfirmation) {
	            productWithoutChange = InventoryStore.toggleConfirmProduct(productWithoutChange, task.date);
	        }
	
	        // update the product from the task
	        var taskWithProductUpdated = DashboardModalUtils.updateProductOfTask(task, productWithoutChange);
	
	        // add/update newAmount of product in task
	        var taskFieldName = InventoryStore.getTaskFieldName(taskWithProductUpdated);
	        var orderTasks = get(draftOrder, taskFieldName);
	        var orderTasksUpdated = DashboardModalUtils.updateTask(orderTasks, taskWithProductUpdated);
	
	        // update task with new product amount
	        draftOrder[taskFieldName] = orderTasksUpdated;
	
	        // update orders with the latest draft order
	        ordersCloned = OrderUtils.updateOrder(ordersCloned, draftOrder);
	
	        // include dashboard orders in order to calculate scope inventory properly
	        ordersCloned = hydrateWithDashboardOrders(draftOrder, ordersCloned);
	
	        var startDate = OrderUtils.getStartDateOrder(draftOrder);
	        if (DateUtils.isBefore(startDate, SessionStore.getMaxScopeInventoryDate())) {
	            ordersCloned = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(ordersCloned, startDate, endDateOrder);
	        } else {
	            // hydrate the products and items which the state of inventory status
	            ordersCloned = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(ordersCloned, SessionStore.getMaxScopeInventoryDate(), endDateOrder);
	        }
	
	        return _ref8 = {}, _ref8[taskFieldName] = filter(orderTasksUpdated, function (task) {
	            return task;
	        }), _ref8.order = draftOrder, _ref8.ordersCloned = ordersCloned, _ref8.taskWithProductUpdated = taskWithProductUpdated, _ref8;
	    },
	    onChangeSingleProducts: function onChangeSingleProducts(ordersCloned, nextState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder) {
	        var _ref9;
	
	        var taskWithProductUpdated = void 0;
	
	        // get the current draft order (new / edit mode)
	        var draftOrder = nextState.order;
	
	        var isUnconfirmedProductAlreadySaved = productWithoutChange.isConfirmed === false && productWithoutChange.isDiscounted;
	        if (isUnconfirmedProductAlreadySaved && !productWithoutChange.needToPublishDisconfirmation) {
	            productWithoutChange = InventoryStore.toggleConfirmProduct(productWithoutChange, task.date);
	        }
	
	        // update the product from the task
	        taskWithProductUpdated = DashboardModalUtils.updateProductOfTask(task, productWithoutChange);
	
	        // add/update newAmount of product in task
	        var taskFieldName = InventoryStore.getTaskFieldName(taskWithProductUpdated, true);
	        var orderTasks = get(draftOrder, taskFieldName);
	        var orderTasksUpdated = DashboardModalUtils.updateTask(orderTasks, taskWithProductUpdated);
	
	        // update task with new product amount
	        draftOrder[taskFieldName] = orderTasksUpdated;
	        draftOrder.isSingle = true; // always override this mark to be sure
	
	        // update orders with the latest draft order
	        ordersCloned = OrderUtils.updateOrder(ordersCloned, draftOrder);
	
	        // include dashboard orders in order to calculate scope inventory properly
	        ordersCloned = hydrateWithDashboardOrders(draftOrder, ordersCloned);
	
	        // hydrate the products and items which the state of inventory status
	        var startDate = OrderUtils.getStartDateOrder(draftOrder);
	        if (DateUtils.isBefore(startDate, SessionStore.getMaxScopeInventoryDate())) {
	            ordersCloned = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(ordersCloned, startDate, endDateOrder);
	        } else {
	            ordersCloned = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(ordersCloned, SessionStore.getMaxScopeInventoryDate(), endDateOrder);
	        }
	
	        return _ref9 = {}, _ref9[taskFieldName] = filter(orderTasksUpdated, function (task) {
	            return task;
	        }), _ref9.order = draftOrder, _ref9.ordersCloned = ordersCloned, _ref9.taskWithProductUpdated = taskWithProductUpdated, _ref9;
	    },
	
	
	    /**
	     * Search given task a specific item.
	     * @param task
	     * @param item
	     * @returns {*}
	     */
	    someItemsExistInGivenTask: function someItemsExistInGivenTask(task, item) {
	        if (!item) {
	            return false;
	        }
	        var products = get(task, 'products') || [];
	        return some(products, function (product) {
	            var items = get(product, 'items');
	            return some(items, function (itemSearch) {
	                return _getItemId(itemSearch) === _getItemId(item);
	            });
	        });
	    },
	
	
	    /**
	     * Search given tasks a specific item.
	     * @param task
	     * @param item
	     * @returns {*}
	     */
	    isSomeItemInTasks: function isSomeItemInTasks(tasks, item) {
	        var _this5 = this;
	
	        return some(tasks, function (task) {
	            return _this5.someItemsExistInGivenTask(task, item);
	        });
	    },
	    onChangeProductByAmount: function onChangeProductByAmount(product, newAmount) {
	        if (ContentUtils.isNotNullOrUndefined(newAmount)) {
	            // when enter the first time never will have defaultAmount, so we
	            var productOrigin = cloneDeep(DashboardServiceCache.getProductById(get(product, 'id')));
	            var defaultProductVolume = get(productOrigin, 'volume');
	
	            product.volume = NumberUtils.multiplyAndTruncate(newAmount, defaultProductVolume);
	            product.amount = NumberUtils.truncate(newAmount, 2);
	            // reset custom amount already assigned from small amount
	            product.customAmount = undefined;
	            product.customVolume = undefined;
	
	            // update the amount of each item
	            var items = get(product, 'items');
	            var itemsUpdated = _multiplyAmountOfItems(items, product.amount);
	            product.items = itemsUpdated;
	        }
	        return product;
	    },
	    onChangeProductByVolume: function onChangeProductByVolume(product, newVolume) {
	        if (ContentUtils.isNotNullOrUndefined(newVolume)) {
	            var productOrigin = cloneDeep(DashboardServiceCache.getProductById(get(product, 'id')));
	            var defaultProductVolume = get(productOrigin, 'volume');
	            product.amount = NumberUtils.divide(newVolume, defaultProductVolume);
	            product.volume = NumberUtils.truncate(newVolume, 2);
	            // reset custom amount already assigned from small amount
	            product.customAmount = undefined;
	            product.customVolume = undefined;
	
	            // update the amount of each item
	            var items = get(product, 'items');
	            var itemsUpdated = _multiplyAmountOfItems(items, product.amount);
	            product.items = itemsUpdated;
	        }
	        return product;
	    },
	    onChangeAmountItem: function onChangeAmountItem(product, item, itemAmount) {
	        if (product === undefined || item === undefined || itemAmount === undefined) {
	            return product;
	        }
	
	        var isAlreadySubtracted = item && item.whereInventoryWasTakenSave;
	        var currentProductItem = void 0;
	        var productItems = get(product, 'items');
	        currentProductItem = find(productItems, function (productItem) {
	            return get(productItem, 'itemId') === get(item, 'itemId');
	        });
	
	        if (isAlreadySubtracted) {
	            currentProductItem = set(currentProductItem, 'adjustAmount', ContentUtils.getNumber(itemAmount, 0));
	        } else {
	            currentProductItem = set(currentProductItem, 'manualAmount', ContentUtils.getNumber(itemAmount, 0));
	        }
	
	        return product;
	    },
	
	
	    /**
	     * Mark a product as a Confirmed.
	     * @param product
	     * @return {*}
	     */
	    toggleConfirmProduct: function toggleConfirmProduct(product, dateTask) {
	        if (product && !DateUtils.isAfterToDayFullDate(product.endDate || dateTask)) {
	            product.isConfirmed = !product.isConfirmed;
	            if (!product.isConfirmed && product.isDiscounted) {
	                product.needToPublishDisconfirmation = true;
	            } else {
	                product.needToPublishDisconfirmation = false;
	            }
	        }
	
	        return product;
	    },
	    haveAProducts: function haveAProducts(task) {
	        var haveProducts = task && task.products && task.products.length > 0;
	        return haveProducts;
	    },
	
	
	    /**
	     * Indicate if some product have all theirs items already discounted
	     * @param task
	     * @return {boolean}
	     */
	    isSomeProductAlreadyDiscounted: function isSomeProductAlreadyDiscounted(task) {
	        var haveProducts = task && task.products && task.products.length > 0;
	        if (haveProducts) {
	            return some(task.products, function (product) {
	                return every(ContentUtils.filterEnable(product.items), function (item) {
	                    return get(item, 'whereInventoryWasTakenSave');
	                });
	            });
	        }
	        return false;
	    },
	    existSomePendingToPublishItem: function existSomePendingToPublishItem(task) {
	        var haveProducts = task && task.products && task.products.length > 0;
	        if (haveProducts) {
	            return this.isEveryProductAlreadyDiscounted(task) && some(task.products, function (product) {
	                return some(ContentUtils.filterEnable(product.items), function (item) {
	                    return get(item, 'whereInventoryWasTakenNew');
	                });
	            });
	        }
	        return false;
	    },
	    isEveryProductAlreadyDiscounted: function isEveryProductAlreadyDiscounted(task) {
	        var haveProducts = task && task.products && task.products.length > 0;
	        if (haveProducts) {
	            return every(task.products, function (product) {
	                return every(ContentUtils.filterEnable(product.items), function (item) {
	                    return item.whereInventoryWasTakenSave;
	                });
	            });
	        }
	        return false;
	    },
	    getTaskFieldName: function getTaskFieldName(task, isSingle) {
	        return _getTaskFieldName(task, isSingle);
	    },
	    addDefaultAmountAndVolumeToProduct: function addDefaultAmountAndVolumeToProduct(product) {
	        var isNotDefinedAmount = ContentUtils.isNull(get(product, 'amount'));
	
	        if (isNotDefinedAmount) {
	            return product;
	        }
	
	        var defaultAmount = get(product, 'defaultAmount');
	        var defaultVolume = get(product, 'defaultVolume');
	        var isNotDefinedDefaultAmount = ContentUtils.isNull(defaultAmount);
	        var isNotDefinedDefaultVolume = ContentUtils.isNull(defaultVolume);
	
	        if (isNotDefinedDefaultAmount) {
	            product.defaultAmount = get(product, 'amount');
	            Object.defineProperty(product, 'defaultAmount', { writable: false, configurable: false, enumerable: true });
	        }
	
	        if (isNotDefinedDefaultVolume) {
	            var originalProduct = DashboardServiceCache.getProductById(get(product, 'id'));
	            product.defaultVolume = get(originalProduct, 'volume');
	            Object.defineProperty(product, 'defaultVolume', { writable: false, configurable: false, enumerable: true });
	        }
	
	        return product;
	    },
	    hydrateWithDefaultAmountItems: function hydrateWithDefaultAmountItems(tasks) {
	        return map(tasks, function (task) {
	            var products = get(task, 'products') || [];
	
	            task.products = map(products, function (product) {
	                var items = get(product, 'items') || [];
	
	                product.items = map(items, function (item) {
	                    if (ContentUtils.isNull(item.defaultAmount)) {
	                        var itemId = get(item, 'itemId');
	                        var productId = get(product, 'id');
	
	                        var originItem = DashboardServiceCache.getProductItemsByProductIdAndItemId(productId, itemId);
	                        if (originItem) {
	                            // set default item
	                            item = Object.defineProperty(item, 'defaultAmount', {
	                                writable: false,
	                                enumerable: true,
	                                configurable: false,
	                                value: get(originItem, 'defaultAmount')
	                            });
	                        }
	                    }
	                    return item;
	                });
	                return product;
	            });
	            return task;
	        });
	    },
	    addDefaultAmountOfProductItem: function addDefaultAmountOfProductItem(item, productId) {
	        var isNotDefinedProductId = ContentUtils.isNull(productId);
	        if (isNotDefinedProductId) {
	            return item;
	        }
	
	        var itemId = get(item, 'item.id') || get(item, 'itemId');
	
	        var productItemTarget = DashboardServiceCache.getProductItemsByProductIdAndItemId(productId, itemId);
	        if (ContentUtils.isNotNullOrUndefined(productItemTarget)) {
	            return Object.defineProperty(item, 'defaultAmount', {
	                writable: false,
	                configurable: false,
	                enumerable: true,
	                value: productItemTarget.defaultAmount
	            });
	        }
	
	        return item;
	    },
	    haveMissingItemWhereLocationWasSubtract: function haveMissingItemWhereLocationWasSubtract(products) {
	        var subtractionProducts = filter(products, function (productFilter) {
	            return productFilter.addition;
	        });
	        return some(subtractionProducts, function (product) {
	            var list = [];
	
	            var whereInventoryWasTakenSave = get(product, 'whereInventoryWasTakenSave');
	            if (ContentUtils.isNotEmptyArray(whereInventoryWasTakenSave)) {
	                list = union(list, whereInventoryWasTakenSave);
	            }
	
	            var whereInventoryWasTakenNew = get(product, 'whereInventoryWasTakenNew');
	            if (ContentUtils.isNotEmptyArray(whereInventoryWasTakenNew)) {
	                list = union(list, whereInventoryWasTakenNew);
	            }
	
	            return some(list, function (item) {
	                return get(item, 'type') !== 'LOCATION_ITEM_MODULE';
	            });
	        });
	    },
	    onConfirmProduct: function onConfirmProduct(prevState, product, task, ordersCloned, temporaryOrderId) {
	        var _ref10;
	
	        var draftOrder = void 0;
	        // get the current draft order (new / edit mode)
	
	        if (prevState.order) {
	            draftOrder = prevState.order;
	        } else {
	            var currentDraftOrder = find(ordersCloned, function (order) {
	                return get(order, 'temporaryId') === temporaryOrderId;
	            });
	            var existOrderDraft = currentDraftOrder !== undefined;
	            if (existOrderDraft) {
	                draftOrder = currentDraftOrder;
	            }
	        }
	
	        var taskFieldName = void 0,
	            productUpdated = void 0,
	            orderTasksUpdated = void 0;
	
	        var dateTask = get(task, 'date');
	        productUpdated = InventoryStore.toggleConfirmProduct(product, dateTask);
	        var taskWithProductUpdated = DashboardModalUtils.updateProductOfTask(task, productUpdated);
	        taskFieldName = InventoryStore.getTaskFieldName(taskWithProductUpdated, prevState.order.isSingle);
	        var orderTasks = get(draftOrder, taskFieldName);
	
	        orderTasksUpdated = DashboardModalUtils.updateTask(orderTasks, taskWithProductUpdated);
	        draftOrder[taskFieldName] = orderTasksUpdated;
	        ordersCloned = ContentUtils.replaceByAttributes(ordersCloned, draftOrder, 'id');
	
	        if (productUpdated.isConfirmed) {
	            productUpdated = this.turnOnWhereInventoryWasTakenNonChanged(productUpdated);
	        } else {
	            productUpdated = this.turnOffWhereInventoryWasTakenNonChanged(productUpdated);
	            // We need to clear all where inventory was taken because we are changing
	            // the parent amount, to need to re-calculate inventory again.
	            productUpdated = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdated);
	            // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
	            productUpdated.isNeededCalculateInventory = undefined;
	        }
	
	        return _ref10 = {
	            product: productUpdated
	        }, _ref10[taskFieldName] = filter(orderTasksUpdated, function (task) {
	            return task;
	        }), _ref10.ordersCloned = ordersCloned, _ref10;
	    },
	    hydrateProductWithDefaultAmountAndVolume: function hydrateProductWithDefaultAmountAndVolume(existingTask) {
	        var _this6 = this;
	
	        var products = get(existingTask, 'products');
	
	        if (ContentUtils.isNotEmptyArray(products)) {
	            var productsUpdated = [];
	            var fullProducts = DashboardServiceCache.getProducts();
	
	            var _loop7 = function _loop7() {
	                if (_isArray8) {
	                    if (_i8 >= _iterator8.length) return 'break';
	                    _ref11 = _iterator8[_i8++];
	                } else {
	                    _i8 = _iterator8.next();
	                    if (_i8.done) return 'break';
	                    _ref11 = _i8.value;
	                }
	
	                var product = _ref11;
	
	                var productTarget = find(fullProducts, function (fullProduct) {
	                    return get(fullProduct, 'id') === get(product, 'id');
	                });
	
	                // complete each product task with full product info
	                var productUpdated = merge(productTarget, product);
	                var productUpdatedWithItems = _hydrateItems(productUpdated);
	                productUpdated = _this6.addDefaultAmountAndVolumeToProduct(productUpdatedWithItems);
	
	                productUpdated.taskDate = existingTask.date;
	
	                // set immutable `defaultVolume` field
	                if (ContentUtils.isNull(productUpdatedWithItems.defaultVolume)) {
	                    Object.defineProperty(productUpdatedWithItems, 'defaultVolume', {
	                        enumerable: true,
	                        writable: false,
	                        configurable: false
	                    });
	                }
	                productsUpdated.push(productUpdatedWithItems);
	            };
	
	            for (var _iterator8 = products, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
	                var _ref11;
	
	                var _ret6 = _loop7();
	
	                if (_ret6 === 'break') break;
	            }
	
	            // update full products
	            existingTask.products = productsUpdated;
	        }
	
	        return existingTask;
	    },
	    markProductsAsNeededToBeCalculateFromInventory: function markProductsAsNeededToBeCalculateFromInventory(products) {
	        var isNeeded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	        return map(products, function (product) {
	            product.isNeededCalculateInventory = isNeeded;
	            return product;
	        });
	    }
	};
	
	function _hydrateItems(productUpdated) {
	    var itemsDry = get(productUpdated, 'items');
	    var productId = get(productUpdated, 'id');
	
	    if (ContentUtils.isNotEmptyArray(itemsDry)) {
	        var itemsfull = DashboardServiceCache.getItems();
	        var itemsUpdated = [];
	
	        var _loop8 = function _loop8() {
	            if (_isArray9) {
	                if (_i9 >= _iterator9.length) return 'break';
	                _ref12 = _iterator9[_i9++];
	            } else {
	                _i9 = _iterator9.next();
	                if (_i9.done) return 'break';
	                _ref12 = _i9.value;
	            }
	
	            var itemDry = _ref12;
	
	            var itemTarget = find(itemsfull, function (item) {
	                return get(item, 'id') === (get(itemDry, 'itemId') || get(itemDry, 'item.id'));
	            });
	            var itemUpdate = merge(itemDry, itemTarget, { defaultAmount: get(itemDry, 'amount') });
	            // make a `defaultAmount` field immutable
	            itemUpdate = InventoryStore.addDefaultAmountOfProductItem(itemUpdate, productId);
	            itemsUpdated.push(itemUpdate);
	        };
	
	        for (var _iterator9 = itemsDry, _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
	            var _ref12;
	
	            var _ret7 = _loop8();
	
	            if (_ret7 === 'break') break;
	        }
	        productUpdated.items = itemsUpdated;
	    }
	    return productUpdated;
	}
	
	function _multiplyAmountOfItems(items, newAmount) {
	    return map(items, function (item) {
	        var itemAmount = get(item, 'defaultAmount', 1);
	        item.estimateAmount = NumberUtils.multiply(itemAmount, newAmount);
	        item.manualAmount = undefined;
	        return item;
	    });
	}
	
	function _sortItemsFromProductsAndFilterDisabled(tasks) {
	    if (Array.isArray(tasks)) {
	        return map(tasks, function (task) {
	            return _sortItemsFromProductAndFilterDisabled(task);
	        });
	    } else {
	        return _sortItemsFromProductAndFilterDisabled(tasks);
	    }
	}
	
	function _sortItemsFromProductAndFilterDisabled(task) {
	    if (task !== undefined) {
	
	        var products = get(task, 'products');
	        if (ContentUtils.isEmptyArray(products)) {
	            return task;
	        }
	
	        var productsUpdated = map(products, function (product) {
	            var items = ContentUtils.filterEnable(get(product, 'items'));
	
	            if (ContentUtils.isEmptyArray(items)) {
	                return product;
	            }
	            var itemsSorted = sortBy(items, 'item.description');
	            return set(product, 'items', itemsSorted);
	        });
	
	        task.products = productsUpdated;
	        return task;
	    }
	}
	
	function _hydrateTaskWithProducts(task, beerStyleId, filteredProducts, filteredProductIcons, filteredProductItems) {
	    var productByIcons = DashboardServiceCache.getProductByIconNameEnables(get(task, 'name'));
	    var productsNeeded = productByIcons.filter(function (product) {
	        return String(product.beerStyle.id) === String(beerStyleId);
	    });
	
	    if (ContentUtils.isEmptyArray(productsNeeded)) {
	        return task;
	    }
	
	    var existingProducts = get(task, 'products', []).filter(function (p) {
	        return NumberUtils.isGreater(p.amount, 0);
	    });
	    var allProductsWithExistingProducts = _keepExistingProduct(productsNeeded, existingProducts);
	    var safeProducts = cloneDeep(allProductsWithExistingProducts); // clone products to prevent unpredictable product changes
	
	    // filter only the products which will be used for the specific beer style & icon defined
	    //let electedProducts = _filterSuitableProductsForTask(safeProducts, beerStyleId, task, filteredProducts, filteredProductIcons);
	
	    if (ContentUtils.isNotEmptyArray(safeProducts)) {
	        safeProducts = _hydrateProducts(safeProducts, filteredProducts);
	        safeProducts = _hydrateProductItems(safeProducts, filteredProductItems);
	    }
	
	    if (task) {
	        task.products = safeProducts || [];
	        task.products = ContentUtils.removeDuplicateByAttribute(task.products, ['id']);
	    }
	
	    return task;
	}
	
	function _keepExistingProduct(allNewProducts, existingProduct) {
	    var existingProductsId = map(existingProduct, function (product) {
	        return product.id;
	    });
	    var newProductWithoutExistingProduct = filter(allNewProducts, function (product) {
	        return !existingProductsId.includes(product.id);
	    });
	    return ContentUtils.filterEnable(union(newProductWithoutExistingProduct, existingProduct));
	}
	
	/**
	 * The idea behind hydration product, like other hydration's, is to avoid persist duplicate information from server.
	 * In order to archive that we need to fill with full information of each product each on dry product.
	 * @param dryProducts
	 * @return {*}
	 * @private
	 */
	function _hydrateProducts(dryProducts) {
	    var fullProducts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getProducts();
	
	    return map(dryProducts, function (dryProduct) {
	        var defaultProduct = find(fullProducts, function (defaultProduct) {
	            return get(defaultProduct, 'id') === get(dryProduct, 'id');
	        });
	        // make shallow hydration are enough
	        var defaultVolume = get(defaultProduct, 'volume');
	        var productAmount = get(dryProduct, 'amount');
	
	        // hydrate volume multiplied
	        if (NumberUtils.isGreater(defaultVolume, '0')) {
	            dryProduct.volume = NumberUtils.multiply(defaultVolume, productAmount);
	        } else {
	            dryProduct.volume = '0';
	        }
	        return assign(defaultProduct, dryProduct);
	    });
	}
	
	function _hydrateProductItems(products) {
	    var fullProductItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getProductItems();
	
	    var safeProducts = cloneDeep(products);
	    return map(safeProducts, function (product) {
	        if (ContentUtils.isEmptyArray(product.items)) {
	            // Enter here when recently fetched the products from server and don't have item yet assigned,
	            // so we need to complete the default items configuration for each products.
	            product.items = cloneDeep(filter(fullProductItems, function (productItem) {
	                return get(productItem, 'product.id') === get(product, 'id');
	            }));
	            product.items = hydrateItems(product.items);
	        } else {
	            // Enter here when:
	            // A) The product is recently fetched from server, which have items but
	            // need to hydrate with full item information.
	            // B) The product have items, but need to be updated for new user changes.
	            product.items = map(product.items, function (item) {
	                return _hydrateProductItem(item);
	            });
	        }
	        return product;
	    });
	}
	
	function _hydrateProductItem(dryProductItem) {
	    if (dryProductItem) {
	        var productItemTarget = cloneDeep(find(DashboardServiceCache.getProductItems(), function (productItem) {
	            return get(productItem, 'item.id') === (get(dryProductItem, 'itemId') || get(dryProductItem, 'item.id'));
	        }));
	
	        // hydrate with full items info
	        var items = get(productItemTarget, 'items');
	        var haveItems = ContentUtils.isNotEmptyArray(items);
	        if (haveItems) {
	            var itemsUpdated = hydrateItems(items);
	            productItemTarget.items = itemsUpdated;
	        }
	
	        // always override default productItem (which came from server)
	        // to product item from UI (which have the latest user changes)
	        return merge(productItemTarget, dryProductItem);
	    }
	    return dryProductItem;
	}
	
	function hydrateItems(items) {
	    var fullItems = DashboardServiceCache.getItems();
	    return map(items, function (item) {
	        item = hydrateItem(item, fullItems);
	        return item;
	    });
	}
	
	function hydrateItem(item) {
	    var fullItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getItems();
	
	    var isProductItem = get(item, 'item.id') !== null;
	    var itemTarget = void 0;
	    if (isProductItem) {
	        itemTarget = find(fullItems, function (fullItem) {
	            return get(fullItem, 'id') === get(item, 'item.id');
	        });
	        itemTarget = merge(itemTarget, get(item, 'item'));
	        item.item = merge(itemTarget, item.item);
	    } else {
	        itemTarget = find(fullItems, function (fullItem) {
	            return get(fullItem, 'id') === get(item, 'id');
	        });
	        item = merge(itemTarget, item.item);
	    }
	    return item;
	}
	
	function _removeDuplicateTaskWithoutProduct(existingTasks) {
	    var clonedExistingTask = cloneDeep(existingTasks);
	
	    // check if exist some duplicate task by date
	    var conflictTask = filter(values(groupBy(clonedExistingTask, 'date')), function (task) {
	        return task.length > 1;
	    });
	    var existSomeDuplicatedTaskByDate = conflictTask && flatten(conflictTask).length > 1;
	
	    if (existSomeDuplicatedTaskByDate) {
	        //  filter non duplicated task
	        var properlyTask = filter(values(groupBy(clonedExistingTask, 'date')), function (task) {
	            return task.length === 1;
	        });
	
	        // filter from duplicated task, each task which have at least one product
	        var taskWhichProducts = filter(flatten(conflictTask), function (task) {
	            return ContentUtils.isNotEmptyArray(get(task, 'products'));
	        });
	
	        return flatten(union(properlyTask, taskWhichProducts));
	    } else {
	
	        return existingTasks;
	    }
	}
	
	function _calculateTotalVolumeOfProduct(tasks) {
	    // filter duplicated task
	    var filteredTask = _removeDuplicateTaskWithoutProduct(tasks);
	
	    // clean undefined products and product
	    var productsRaw = flatten(map(filteredTask, function (task) {
	        return task && task.products;
	    }));
	
	    // without amount which are just suggested product (not defined by the user)
	    var products = filter(flatten(productsRaw), function (product) {
	        return product && product.amount;
	    });
	
	    // in case of edit order, the product don't have category so we need to add it
	    var productsHydrated = _hydrateProducts(products);
	
	    // filter only the product which consume volume
	    var productFiltered = filter(productsHydrated, function (product) {
	        return includes(Constants.PRODUCT_CATEGORY_CONSUME_VOLUME, product.category);
	    });
	
	    // multiply the amount of product by each volume in order to know the total volume by product defined
	    // NOTE: use `defaultVolume` just in case that user change volume of product manually, se we need to calculate the orginal one.
	    // In case of `amount`, that field was updated by the amount computed which should need calculate the next volume.
	    var productsVolume = map(productFiltered, function (product) {
	        return NumberUtils.multiply(product.defaultVolume || product.volume, get(product, 'amount', 1));
	    });
	
	    return reduce(productsVolume, function (totalVolume, volume) {
	        return NumberUtils.sum(totalVolume, volume);
	    }) || 0;
	}
	
	function _getTaskFieldName(task, isSingle) {
	    var taskType = get(task, 'sectionType');
	    var isBrewingSection = task && task.turn;
	    if (isSingle) {
	        if (isBrewingSection) {
	            return 'batchs';
	        } else {
	            return 'singleTasks';
	        }
	    } else {
	        if (isBrewingSection) {
	            return 'batchs';
	        } else {
	            var tasksFieldName = get(ContentUtils.getTankTypeConfiguration(taskType), 'tasksFieldName');
	            return tasksFieldName;
	        }
	    }
	}
	
	/**
	 * Calculate when the item arrive by given task and purchase item.
	 * @param task
	 * @param purchaseItem
	 * @return {*|Boolean}
	 * @private
	 */
	function _isPurchaseItemArrive(taskDateFromTask, purchaseItem) {
	    var taskDate = DateUtils.toDateText(taskDateFromTask);
	    var requestedDate = DateUtils.toDateText(purchaseItem.dateRequested);
	    var arriveDate = DateUtils.toDateText(DateUtils.addDays(requestedDate, purchaseItem.arrivalDays));
	    return DateUtils.isBeforeOrEquals(arriveDate, taskDate);
	}
	
	function _resetItemsEstimation(product) {
	    var items = get(product, 'items');
	    var haveItems = ContentUtils.isNotEmptyArray(items);
	    if (haveItems) {
	        product.items = map(items, function (item) {
	            item.amountNeededLeft = undefined;
	            item.existItemInStock = undefined;
	            item.isEnoughInventory = undefined;
	            item.amount = undefined;
	            item.isPurchased = undefined;
	            item.isPurchasedAmountEnough = undefined;
	            item.whereInventoryWasTakenNew = undefined;
	            item.manualAmount = undefined;
	            item.estimateAmount = undefined;
	            return item;
	        });
	    }
	    return product;
	}
	
	function _getItemId(obj) {
	    return get(obj, 'itemId') || get(obj, 'item.id') || get(obj, 'id');
	}
	
	function hydrateWithDashboardOrders() {
	    var draftOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var ordersCloned = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var ordersFiltered = draftOrder.id === undefined ? ordersCloned : ordersCloned.filter(function (order) {
	        return order.id !== draftOrder.id;
	    });
	    ordersFiltered.push(draftOrder);
	    return ordersFiltered;
	}
	
	module.exports = InventoryStore;

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	var _el,
	
	/**
	 * The Basic notification popup.
	 * @type {{setElement: Function, show: Function}}
	 */
	Notification = {
	    /**
	     * In order to use popup notification, this are hosted in the main App module. And then,
	     * available through this Object for the rest of the application.
	     * @param notificationEl
	     */
	    setElement: function setElement(notificationEl) {
	        _el = notificationEl;
	    },
	
	
	    /**
	     * Show the message with the given message and type of them.
	     * @param message
	     * @param type
	     */
	    show: function show(message, type) {
	        _el.show(message, type ? type : 'error');
	    },
	
	
	    /**
	     * Show the message with the given message and type of them.
	     * @param message
	     * @param type
	     */
	    showImmediately: function showImmediately(message, type) {
	        _el.showImmediately(message, type ? type : 'error');
	    }
	};
	
	module.exports = Notification;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var moment = __webpack_require__(1185),
	    DateUtils,
	    _require = __webpack_require__(8),
	    forEach = _require.forEach,
	    includes = _require.includes,
	    DATE_FORMAT = __webpack_require__(2).DATE_FORMAT,
	    DATE_FORMAT_DISPLAY = __webpack_require__(2).DATE_FORMAT_DISPLAY,
	    DATE_FORMAT_SHORT = __webpack_require__(2).DATE_FORMAT_SHORT,
	    DEFAULT_MONTH_BEFORE = __webpack_require__(2).DEFAULT_MONTH_BEFORE,
	    DEFAULT_MONTH_AFTER = __webpack_require__(2).DEFAULT_MONTH_AFTER;
	
	
	DateUtils = {
	    /**
	     * From a certain date and certain amount of days to increment, calculates the new date.
	     * @argument {Date} date the date reference
	     * @argument {Number} days number of days that will increment from date reference
	     * @return {String} the calculdated date.
	     */
	    addDaysText: function addDaysText(date, days) {
	        var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DATE_FORMAT_DISPLAY;
	
	        if (typeof date === 'string') {
	            return moment(this.toDate(date)).add(days, 'days').format(format);
	        } else {
	            return moment(date).add(days, 'days').format(format);
	        }
	    },
	    getByDateFromNowInDays: function getByDateFromNowInDays(amountDays) {
	        return moment().add(amountDays, 'days').format(DATE_FORMAT);
	    },
	
	
	    /**
	     * From a certain date and certain amount of days to increment, calculates the new date.
	     * @argument {Date} date the date reference
	     * @argument {Number} days number of days that will increment from date reference
	     * @return {String} the calculdated date.
	     */
	    addDaysTextBasicFormat: function addDaysTextBasicFormat(date, days) {
	        if (typeof date === 'string') {
	            return moment(this.toDate(date)).add(days, 'days').format(DATE_FORMAT);
	        } else {
	            return moment(date).add(days, 'days').format(DATE_FORMAT);
	        }
	    },
	
	
	    /**
	     * From a certain date and certain amount of days to increment, calculates the new date.
	     * @argument {Date} date the date reference
	     * @argument {Number} days number of days that will increment from date reference
	     * @return {Date} the calculdated date
	     */
	    addDays: function addDays(date, days) {
	        if (typeof date === 'string') {
	            // convert to Date obj and call myself
	            return this.addDays(this.toDate(date), days);
	        } else {
	            return new Date(this.addDaysText(date, days));
	        }
	    },
	
	
	    /**
	     * Ask if the given date is before to day.
	     * @argument {String} currentDate to validate
	     * @argument {String} date to validate
	     * @return {Boolean}
	     */
	    isBeforeToDay: function isBeforeToDay(date) {
	        if (typeof date === 'string') {
	            return moment().unix() > moment(date, DATE_FORMAT).unix();
	        } else {
	            return moment().unix() > moment(this.toDateText(date), DATE_FORMAT).unix();
	        }
	    },
	
	
	    /**
	     * Ask if the given date is after to day.
	     * @argument {String} date to validate
	     * @return {Boolean}
	     */
	    isAfterToDay: function isAfterToDay(date) {
	        return !this.isBeforeToDay(date);
	    },
	    isAfterOrEqualsToDay: function isAfterOrEqualsToDay(date) {
	        return DateUtils.getToDayText() === date || !this.isBeforeToDay(date);
	    },
	    isBeforeOrEqualsToDay: function isBeforeOrEqualsToDay(date) {
	        return DateUtils.getToDayText() === date || this.isBeforeToDay(date);
	    },
	    isAfterToDayFullDate: function isAfterToDayFullDate(date) {
	        return moment().unix() < moment(date).unix();
	    },
	
	
	    /**
	     * Ask if the given date is after to another date defined.
	     * @argument {String} dateCompare to that will be validate
	     * @argument {String} date to that will be validate
	     * @return {Boolean}
	     */
	    isAfter: function isAfter(dateCompare, date) {
	        var isFullFormat = dateCompare && includes(dateCompare, 'T');
	        if (isFullFormat) {
	            return moment(dateCompare).unix() > moment(date).unix();
	        } else {
	            return moment(dateCompare, DATE_FORMAT).unix() > moment(date, DATE_FORMAT).unix();
	        }
	    },
	    removeZulu: function removeZulu(date) {
	        if (date.indexOf('Z')) {
	            return date.substring(0, date.length - 1);
	        } else {
	            return date;
	        }
	    },
	
	
	    /**
	     * Ask if the given date is after or equals to another date defined.
	     * @argument {String} dateCompare to that will be validate
	     * @argument {String} date to that will be validate
	     * @return {Boolean}
	     */
	    isAfterOrEquals: function isAfterOrEquals(dateCompare, date) {
	        if (dateCompare === date) {
	            return true;
	        }
	        return this.isAfter(dateCompare, date);
	    },
	
	
	    /**
	     * Ask if the given date is before to another date defined.
	     * @argument {String} dateCompare to that will be validate
	     * @argument {String} date to that will be validate
	     * @return {Boolean}
	     */
	    isBefore: function isBefore(dateCompare, date) {
	        return !this.isAfter(dateCompare, date) && !this.isEqual(dateCompare, date);
	    },
	
	
	    /**
	     * Ask if the given date is before to another date defined.
	     * @argument {String} dateCompare to that will be validate
	     * @argument {String} date to that will be validate
	     * @return {Boolean}
	     */
	    isBeforeOrEquals: function isBeforeOrEquals(dateCompare, date) {
	        if (dateCompare === date) {
	            return true;
	        }
	        return !this.isAfter(dateCompare, date) && !this.isEqual(dateCompare, date);
	    },
	
	
	    /**
	     * Compare if both dates are equals with each other.
	     * @argument {String} dateOne the date will be comper agains to dateTwo.
	     * @argument {String} dateTwo the date will be comper agains to dateOne.
	     * @return {Boolean}
	     */
	    isEqual: function isEqual(dateOne, dateTwo) {
	        return moment(dateOne, DATE_FORMAT).format(DATE_FORMAT) === moment(dateTwo, DATE_FORMAT).format(DATE_FORMAT);
	    },
	    incrementByDays: function incrementByDays(currentDate, oldFrom, oldTo, days) {
	        var date = this.toDateText(this.addDays(this.toDate(currentDate), days));
	        var from = this.toDateText(this.addDays(this.toDate(oldFrom), days));
	        var to = this.toDateText(this.addDays(this.toDate(oldTo), days));
	
	        return {
	            from: from,
	            to: to,
	            date: date
	        };
	    },
	    incrementByMonths: function incrementByMonths(currentDate, months) {
	        var newCurrentDate = moment(currentDate, DATE_FORMAT).add(months, 'month').format(DATE_FORMAT),
	            rangeFrom = moment(newCurrentDate, DATE_FORMAT).subtract(DEFAULT_MONTH_BEFORE, 'month').format(DATE_FORMAT),
	            rangeTo = moment(newCurrentDate, DATE_FORMAT).add(DEFAULT_MONTH_AFTER, 'month').format(DATE_FORMAT);
	        return {
	            from: rangeFrom,
	            to: rangeTo,
	            date: newCurrentDate
	        };
	    },
	
	
	    /**
	     * Validate if given date text is the first day of the current month.
	     * @param {String} dateText
	     * @returns {boolean}
	     */
	    isFirstDayOfCurrentMonth: function isFirstDayOfCurrentMonth(dateText) {
	        var dateToValidate = moment(this.toDateText(dateText), DATE_FORMAT);
	
	        if (moment(dateToValidate).format('MMMM') === this.getCurrentMonth() && moment(dateToValidate).format('DD') === '01') {
	            // first day of month
	            return true;
	        }
	        return false;
	    },
	
	
	    /**
	     * Retrieve the current mont.
	     */
	    getCurrentMonth: function getCurrentMonth() {
	        return moment().format('MMMM');
	    },
	    getCurrentDate: function getCurrentDate() {
	        return moment().format();
	    },
	    getToDayText: function getToDayText() {
	        return moment().format(DATE_FORMAT);
	    },
	
	
	    /**
	     * Retrieve is the given date is weekend or not.
	     * @argument {String} date that will be validated.
	     * @return {Boolean}
	     */
	    isWeekend: function isWeekend(date) {
	        var day = moment(date, DATE_FORMAT).day();
	        return day === 0 || day === 6;
	    },
	
	    /**
	     * Retrieve is the given date is weekend or not.
	     * @argument {String} date that will be validated.
	     * @return {Boolean}
	     */
	    isMondayTuesdayOrWednesday: function isMondayTuesdayOrWednesday(date) {
	        var day = moment(date, DATE_FORMAT).day();
	        return day === 1 || day === 3 || day === 5;
	    },
	
	    /**
	     * Retrieve is the given date is weekend or not.
	     * @argument {String} date that will be validated.
	     * @return {Boolean}
	     */
	    isSaturday: function isSaturday(date) {
	        var day = moment(date, DATE_FORMAT).day();
	        return day === 6;
	    },
	    isToDay: function isToDay(date) {
	        var isDateType = (typeof date === 'undefined' ? 'undefined' : _typeof(date)) === 'object';
	        if (isDateType) {
	            return this.toDateText(date) === moment().format(DATE_FORMAT);
	        }
	        return date === moment().format(DATE_FORMAT);
	    },
	
	
	    /**
	     * Retrieve is the given date is weekend or not.
	     * @argument {String} date that will be validated.
	     * @return {Boolean}
	     */
	    isSunday: function isSunday(date) {
	        var day = moment(date, DATE_FORMAT).day();
	        return day === 0;
	    },
	
	
	    /**
	     * Convert date string to object.
	     * @argument {String} date to ve converted Date object.
	     * @return {Date}
	     */
	    toDate: function toDate(date) {
	        return new Date(moment(date, DATE_FORMAT).format(DATE_FORMAT_DISPLAY));
	    },
	    toDateFullText: function toDateFullText(date) {
	        return moment(date).format();
	    },
	    toEndOfDate: function toEndOfDate(date) {
	        return moment(date).add(23, 'hours').add(59, 'minutes').format();
	    },
	    toStartOfDate: function toStartOfDate(date) {
	        return moment(date).startOf('day').format();
	    },
	
	
	    /**
	     * Return the current date.
	     * @return {String}
	     */
	    getNowDate: function getNowDate() {
	        return moment().format(DATE_FORMAT);
	    },
	
	
	    /**
	     * Convert date string to object.
	     * @argument {String} date DATE_FORMAT to ve converted Date object.
	     * @argument {String} hours (HH:mm)         to ve converted Date object (HHmm).
	     * @return {Date}
	     */
	    toDateAndHours: function toDateAndHours(date, hours) {
	        return moment(date + hours, DATE_FORMAT + 'HH:mm').toDate();
	    },
	    toDateFromFullDate: function toDateFromFullDate(date) {
	        return new Date(date);
	    },
	
	
	    /**
	     *
	     * @param date
	     * @return {*}
	     */
	    toHHMM: function toHHMM(date) {
	        return moment(date).format('HH:mm');
	    },
	
	
	    /**
	     * Convert date string to object.
	     * @argument {Date} date to ve converted Date object.
	     * @return {String}
	     */
	    toDateText: function toDateText(date) {
	        return moment(date).format(DATE_FORMAT);
	    },
	
	
	    /**
	     * Convert date string to object.
	     * @argument {Date} date to ve converted Date object.
	     * @return {String}
	     */
	    toDateTextWithHHMM: function toDateTextWithHHMM(date) {
	        return moment(date).format('HH:mm');
	    },
	
	
	    /**
	     * Convert date string to full string date format.
	     * @argument {Date} date to ve converted to string date.
	     * @return {String}
	     */
	    toFullDate: function toFullDate(date) {
	        return moment(date).format();
	    },
	
	
	    /**
	     * Change to shorter date format.
	     * @argument {String} date to be changed.
	     * @return {String}
	     */
	    toShortDateText: function toShortDateText(date) {
	        return moment(date, DATE_FORMAT).format(DATE_FORMAT_SHORT);
	    },
	
	
	    /**
	     * Retrieve the day of the date.
	     * @argument {String} date to be changed
	     * @return {String}
	     */
	    toDayText: function toDayText(date) {
	        return moment(date, DATE_FORMAT).format('DD');
	    },
	
	
	    /**
	     * Convert date to properly display date.
	     * @argument {Date} date the display that will be converted.
	     */
	    toDisplayDateText: function toDisplayDateText(date) {
	        return moment(date).format('MMMM DD');
	    },
	
	
	    /**
	     * Convert date to properly display date.
	     * @argument {Date} date the display that will be converted.
	     */
	    toDisplayDateTextShort: function toDisplayDateTextShort(date) {
	        return moment(date).format('MMM DD');
	    },
	
	
	    /**
	     * Convert date to properly display date.
	     * @argument {Date} date the display that will be converted.
	     */
	    toDisplayMonthText: function toDisplayMonthText(date) {
	        return moment(this.toDate(date)).format('MMMM');
	    },
	
	
	    /**
	     * Convert date to properly display date.
	     * @argument {Date} date the display that will be converted.
	     */
	    toYYYYMMDDhhmm: function toYYYYMMDDhhmm(date) {
	        return moment(date).format(DATE_FORMAT + ' HH:mm');
	    },
	
	
	    /**
	     * Convert date to properly display date.
	     * @argument {Date} date the display that will be converted.
	     */
	    toDisplayMonthTextShort: function toDisplayMonthTextShort(date) {
	        return moment(this.toDate(date)).format('MMM');
	    },
	
	
	    /**
	     * Retrieve the amount of days between current dashboard date range.
	     * @returns {Number}
	     */
	    getDaysBetween: function getDaysBetween(dateFrom, dateTo) {
	        var dateFromText = void 0,
	            dateToText = void 0;
	
	        if (typeof dateFrom === 'string') {
	            dateFromText = dateFrom;
	        } else {
	            dateFromText = this.toDateText(dateFrom);
	        }
	
	        if (typeof dateTo === 'string') {
	            dateToText = dateTo;
	        } else {
	            dateToText = this.toDateText(dateTo);
	        }
	
	        return moment(dateToText, DATE_FORMAT).diff(moment(dateFromText, DATE_FORMAT), 'days');
	    },
	
	
	    /**
	     * Retrieve the amount of days between dates.
	     * @param {Date} dateFrom
	     * @param {Date} dateTo
	     * @return {number}
	     */
	    getMinutesBetween: function getMinutesBetween(from, to) {
	        return +moment.duration(moment(to).diff(from)).asMinutes();
	    },
	
	
	    /**
	     * Ask if given date is between given range of dates.
	     * @param {String} dateCompare
	     * @param {String} from
	     * @param {String} to
	     * @return {Boolean}
	     */
	    isDateBetween: function isDateBetween(dateCompare, from, to) {
	        var dateFromText = void 0,
	            dateToText = void 0;
	
	        if (typeof from === 'string') {
	            dateFromText = from;
	        } else {
	            dateFromText = this.toDateText(from);
	        }
	
	        if (typeof to === 'string') {
	            dateToText = to;
	        } else {
	            dateToText = this.toDateText(to);
	        }
	
	        return this.isAfterOrEquals(dateCompare, dateFromText) && this.isBeforeOrEquals(dateCompare, dateToText);
	    },
	
	
	    /**
	     * Retrieve the earlt date given an arrays of dates.
	     * @arguments {String} dates with formant
	     */
	    getEarlyDate: function getEarlyDate(dates) {
	        var _this = this;
	
	        var earlyDate = void 0;
	        if (dates && dates.length) {
	            earlyDate = dates[0];
	            forEach(dates, function (date) {
	                if (_this.isBefore(earlyDate, date)) {
	                    earlyDate = date;
	                }
	            });
	            return earlyDate;
	        }
	    },
	
	
	    /**
	     * Sort given list of dates by field and date.
	     * @param lists
	     * @param field
	     * @return {Array}
	     */
	    sortListByDateField: function sortListByDateField(lists, field) {
	        var _this2 = this;
	
	        if (lists) {
	            return (lists || []).sort(function (a, b) {
	                if (_this2.isAfter(a[field], b[field])) {
	                    return 1;
	                }
	                if (_this2.isBefore(a[field], b[field])) {
	                    return -1;
	                }
	                return 0;
	            });
	        }
	    },
	
	
	    /**
	     * Sort given list of dates by field and date on desc order.
	     * @param lists
	     * @param field
	     * @return {Array}
	     */
	    sortListByDateFieldDesc: function sortListByDateFieldDesc(lists, field) {
	        var _this3 = this;
	
	        if (lists) {
	            return (lists || []).sort(function (a, b) {
	                if (_this3.isAfter(a[field], b[field])) {
	                    return -1;
	                }
	                if (_this3.isBefore(a[field], b[field])) {
	                    return 1;
	                }
	                return 0;
	            });
	        }
	    },
	
	
	    /**
	     * Convert date text to current applicant timezone.
	     *
	     * @param String dateText example a valid format date (eg:'2017-09-13T20:01:11.346Z').
	     * @Param String timeZone   (optionally) A properly time-zone format (eg: 'America/New_York').
	     * @Param String formatDate (optionally) A format date (eg: 'YYYY-MM-DD HH:mm').
	     */
	    toCurrentTimeZone: function toCurrentTimeZone(date, timeZone, formatDate) {
	        if (date) {
	            return moment.tz(date, timeZone || 'America/Denver').format(formatDate || DATE_FORMAT + ' HH:mm');
	        }
	    }
	};
	
	module.exports = DateUtils;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var get = __webpack_require__(5).get,
	    _require = __webpack_require__(8),
	    some = _require.some,
	    _require2 = __webpack_require__(79),
	    replace = _require2.replace,
	    trim = _require2.trim,
	    ContentUtils = __webpack_require__(7),
	    currencyFormatter = __webpack_require__(187),
	    Constants = __webpack_require__(2),
	    KEY_CURRENCY = 'cache_current_currency',
	    KEY_LOCATION = 'cache_current_locator',
	    numeral = __webpack_require__(637);
	
	var PREFERRED_LANGUAGE = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en';
	
	/**
	 * Helper class to handler the common/generic way the content in the browser, conditionals, cache handler,
	 * queries element, cloning object, and other king of stuffs.
	 */
	var NumberUtils = {
	    initializeFormat: function initializeFormat() {
	        var currency = ContentUtils.getLocal(KEY_CURRENCY);
	        if (numeral.locales['en'] === undefined) {
	            numeral.register('locale', ContentUtils.getSession(KEY_LOCATION) || PREFERRED_LANGUAGE, {
	                delimiters: {
	                    thousands: get(currency, 'thousandsSeparator'),
	                    decimal: get(currency, 'decimalSeparator')
	                },
	                currency: {
	                    symbol: get(currency, 'symbol')
	                }
	            });
	        }
	    },
	    isEqual: function isEqual(numOne, numTwo) {
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return numeral(numOneSafe).value() === numeral(numTwoSafe).value();
	    },
	    sum: function sum(numOne, numTwo) {
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return numeral(numOneSafe).add(numTwoSafe).value();
	    },
	    subtract: function subtract(numOne, numTwo) {
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return numeral(numOneSafe).subtract(numTwoSafe).value();
	    },
	    multiply: function multiply(numOne, numTwo) {
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return numeral(numOneSafe).multiply(numTwoSafe).value();
	    },
	    multiplyAndTruncate: function multiplyAndTruncate(numOne, numTwo) {
	        var truncateDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
	
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return this.truncate(numeral(numOneSafe).multiply(numTwoSafe).value(), truncateDecimal);
	    },
	    divide: function divide() {
	        var numOne = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	        var numTwo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return numeral(numOneSafe).divide(numTwoSafe).value();
	    },
	    divideAndTruncate: function divideAndTruncate(numOne, numTwo) {
	        var truncateDecimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
	
	        var numOneSafe = this.standardiseDecimalFormatNumber(removeText(numOne));
	        var numTwoSafe = this.standardiseDecimalFormatNumber(removeText(numTwo));
	        return this.truncate(numeral(numOneSafe).divide(numTwoSafe).value(), truncateDecimal);
	    },
	    isGreater: function isGreater(numOne, numTwo) {
	        numOne = +this.standardiseDecimalFormatNumber(numOne);
	        numTwo = +this.standardiseDecimalFormatNumber(numTwo);
	
	        return numOne > numTwo;
	    },
	    isGreaterOrEquals: function isGreaterOrEquals(numOne, numTwo) {
	        return this.isEqual(numOne, numTwo) || this.isGreater(numOne, numTwo);
	    },
	    isLess: function isLess(numOne, numTwo) {
	        numOne = +this.standardiseDecimalFormatNumber(numOne);
	        numTwo = +this.standardiseDecimalFormatNumber(numTwo);
	
	        return numOne < numTwo;
	    },
	    isLessOrEquals: function isLessOrEquals(numOne, numTwo) {
	        return this.isEqual(numOne, numTwo) || this.isLess(numOne, numTwo);
	    },
	    isNumber: function isNumber(number) {
	        var saveNumber = number.replace(',', '').replace('.', '');
	        return !isNaN(parseFloat(saveNumber)) && isFinite(saveNumber);
	    },
	    containSomeNotNumber: function containSomeNotNumber(number) {
	        var safeNumber = String(number);
	        return !!safeNumber.match(/^[0-9]*$/gm) === false;
	    },
	
	    /**
	     * Remove item duplicate, checking equality by given attributes.
	     * @param array
	     * @param props
	     * @return {*}
	     */
	    removeDuplicateByAttribute: function removeDuplicateByAttribute(array, props) {
	
	        if (get(array, 'length', 0) === 0 || get(props, 'length', 0) === 0) {
	            return array;
	        }
	
	        var nonDuplicates = [];
	
	        var _loop = function _loop() {
	            if (_isArray) {
	                if (_i >= _iterator.length) return 'break';
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) return 'break';
	                _ref = _i.value;
	            }
	
	            var obj = _ref;
	
	            var isDuplicate = some(nonDuplicates, function (target) {
	                return ContentUtils.isSameObject(target, obj, props);
	            });
	            if (!isDuplicate) {
	                nonDuplicates.push(obj);
	            }
	        };
	
	        for (var _iterator = array, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	
	        return nonDuplicates;
	    },
	
	
	    /**
	     * Retrieve in safe way the number of given string
	     * @param order
	     * @return {number}
	     */
	    getNumber: function getNumber(number) {
	        var defaultResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (typeof number === 'number') {
	            return number;
	        }
	        if (!number) {
	            return defaultResult;
	        }
	
	        if (number && typeof number === 'string' && this.isAbleToCastToNumber(number)) {
	            return +number;
	        }
	
	        var currencyInfo = this.getCurrentCurrency();
	        var currentThousands = get(currencyInfo, 'thousandsSeparator');
	
	        if (number && number.replace) {
	            if (number.indexOf(currentThousands) > -1) {
	                number = number.replace(currentThousands, '');
	            }
	
	            if (this.isAbleToCastToNumber(number)) {
	                return +number;
	            }
	        }
	
	        if (number) {
	            return +this.standardiseDecimalFormatNumber(number);
	        } else {
	            return defaultResult;
	        }
	    },
	    isAbleToCastToNumber: function isAbleToCastToNumber(value) {
	        return 'NaN' !== String(+value);
	    },
	
	
	    /**
	     * Retrieve in safe way the number text of given string
	     * which support decimal and dot thousand numbers.
	     * @param order
	     * @return {String}
	     */
	    getNumberString: function getNumberString(number) {
	        var defaultResult = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
	
	        var isInvalid = +number === 0 || String(number) === 'NaN';
	
	        if (isInvalid) {
	            return number;
	        }
	
	        if (!number) {
	            return defaultResult;
	        }
	        if (number && number.match) {
	            return number.match(/[\d.,]/gi).join('');
	        } else {
	            return defaultResult;
	        }
	    },
	    round: function round(value, precision) {
	        var multiplier = Math.pow(10, precision || 0);
	        return Math.round(value * multiplier) / multiplier;
	    },
	    inverseSign: function inverseSign(number) {
	        var safeNumber = String(number);
	        var isNegative = safeNumber.includes('-');
	        return +(isNegative ? safeNumber.substring(1) : '-' + safeNumber);
	    },
	    toNumber: function toNumber(number) {
	        return this.getNumber(number);
	    },
	
	
	    /**
	     * Retrieve the object of given string content.
	     * @param {String} content The content that will be parsed
	     * @param {String} field (Optionally)
	     * @return {Object}
	     */
	    parse: function parse(content, field) {
	        if (!content) {
	            return content;
	        }
	
	        try {
	            if (field) {
	                var resultContent = get(content, field);
	                return typeof resultContent === 'string' ? JSON.parse(resultContent) : resultContent;
	            } else {
	                return typeof content === 'string' ? JSON.parse(content) : content;
	            }
	        } catch (e) {
	            console.error(e.message);
	            return content;
	        }
	    },
	    formatDecimal: function formatDecimal(number) {
	        var decimalDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	        if (typeof decimalDigits === 'string') {
	            decimalDigits = +decimalDigits;
	        }
	        var currencyInfo = this.getCurrentCurrency();
	        return trim(currencyFormatter.format(this.standardiseDecimalFormatNumber(number), {
	            code: get(currencyInfo, 'code'),
	            precision: decimalDigits || get(currencyInfo, 'decimalDigits'),
	            decimalDigits: decimalDigits || get(currencyInfo, 'decimalDigits'),
	            symbolOnLeft: false,
	            symbol: '',
	            spaceBetweenAmountAndSymbol: false
	        }));
	    },
	
	
	    /**
	     * This method allow us to convert specific decimal number to an
	     * generic formatted. This are usefully when need persist in a generic
	     * way one number. For instance, if the user want to change the decimal
	     * format of APP to another different decimal numbers.
	     *
	     * @param {String|Number} number
	     * @return {String}
	     */
	    standardiseDecimalFormatNumber: function standardiseDecimalFormatNumber(number) {
	
	        var isInvalid = number === null || number === undefined || +number === 0 || String(number) === 'NaN';
	
	        if (isInvalid) {
	            return number;
	        }
	
	        // convert to string in order to avoid problems with `replace` and `,` character.
	        var safeNumber = String(number);
	
	        var currencyInfo = this.getCurrentCurrency();
	        var currentDecimalSeparator = get(currencyInfo, 'decimalSeparator');
	        var currentThousands = get(currencyInfo, 'thousandsSeparator');
	
	        var haveDecimalSeparator = String(number).includes(currentDecimalSeparator);
	        if (!haveDecimalSeparator) {
	            // enter here means we don't need to standardise nothing
	            // because don't found any particular decimal separator
	            return safeNumber;
	        }
	
	        // remove thousands character in order to be formatted
	        // again this character for their needed.
	        safeNumber = safeNumber.split(currentThousands).join('');
	
	        // change the decimal separator of this specific currency to a generic one
	        safeNumber = replace(safeNumber, currentDecimalSeparator, Constants.STANDARDISE_DECIMAL_SEPARATOR);
	
	        return trim(safeNumber);
	    },
	    isStandardizedNumber: function isStandardizedNumber(number) {
	        var isInvalid = +number === 0 || String(number) === 'NaN';
	
	        if (isInvalid) {
	            return number;
	        }
	
	        var safeNumber = String(number);
	
	        if (safeNumber.includes(',')) {
	            return false;
	        }
	
	        if (!safeNumber.includes('.')) {
	            return true;
	        }
	
	        if (safeNumber.match(/[.]/gi).length === 1) {
	            return true;
	        }
	
	        return false;
	    },
	    formatCurrency: function formatCurrency(number) {
	        var decimalDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
	
	        var currencyInfo = this.getCurrentCurrency();
	        return currencyFormatter.format(number, {
	            code: get(currencyInfo, 'code'),
	            decimalDigits: decimalDigits || get(currencyInfo, 'decimalDigits'),
	            precision: decimalDigits || get(currencyInfo, 'decimalDigits')
	        });
	    },
	    getCurrentCurrency: function getCurrentCurrency() {
	        return ContentUtils.getLocal(KEY_CURRENCY);
	    },
	    truncate: function truncate(text) {
	        var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	
	        var re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)'),
	            m = String(text).match(re);
	        return String(m ? parseFloat(m[1]) : text.valueOf());
	    }
	};
	
	/**
	 * Filter obj and return only numbers which and `.` character
	 * (which represent a generic decimal separator)
	 *
	 * @param num
	 * @return {string}
	 */
	function removeText(num) {
	
	    if (num === 'Infinity' || num === Infinity || num === undefined || num === '' || num === null) {
	        return '0';
	    }
	
	    return (num ? String(num).match(/[\d,.]/gi).join('') : num) || '0';
	}
	
	module.exports = NumberUtils;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AutoPrefix = __webpack_require__(63);
	
	module.exports = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || "linear";
	
	    return AutoPrefix.singleHyphened(property) + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 25 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(4),
	    t = _require.t;
	
	var _elCustomDialog = void 0,
	
	/**
	 * The Basic dialog popup.
	 * @type {{setElement: Function, show: Function}}
	 */
	CustomDialog = {
	    /**
	     * In order to use custom dialog, this are hosted in the main App module. And then,
	     * available through this Object for the rest of the application.
	     * @param notificationEl
	     */
	    setElement: function setElement(notificationEl) {
	        _elCustomDialog = notificationEl;
	    },
	    show: function show() {
	        _elCustomDialog.show(arguments);
	    },
	    showInfo: function showInfo(title, message, labelOk) {
	        _elCustomDialog.showInfo(title, message, labelOk);
	    },
	    showWarningConfirmation: function showWarningConfirmation(title, message, onConfirm, labelConfirm, labelCancel, onCancel, onClickAway) {
	        if (_elCustomDialog) {
	            _elCustomDialog.showWarningConfirmation(title, message, onConfirm, labelConfirm || t('confirm'), labelCancel || t('cancel'), onCancel, onClickAway);
	        }
	    }
	};
	
	module.exports = CustomDialog;

/***/ },
/* 27 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var KEY_ORDER = 'cache_orders',
	    _require = __webpack_require__(4),
	    t = _require.t,
	    KEY_TANK = 'cache_tanks',
	    KEY_DRAFT = 'cache_draft',
	    KEY_ITEMS = 'cache_items',
	    KEY_LOCATIONS = 'cache_locations',
	    KEY_BREW_PROCESS = 'cache_brew_process',
	    KEY_FERMENTING_PROCESS = 'cache_fermenting_process',
	    KEY_PACKAGING_PROCESS = 'cache_packaging_process',
	    KEY_VENDOR_PURCHASE_ITEMS = 'cache_vendor_purchase_items',
	    KEY_DRAFT_ORDER_AMOUNT = 'cache_draft_order_amount',
	    KEY_UNDO_DRAFT_ORDER_AMOUNT = 'cache_undo_draft_order_amount',
	    KEY_BEER_STYLE = 'cache_beerstyle',
	    CustomDialog = __webpack_require__(26),
	    KEY_BEER_STYLE_TASK_CONFIGURATIONS = 'cache_beerstyle_task_configurations',
	    _ = __webpack_require__(40),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(2),
	    FERMENTER_TYPE_TASK = _require2.FERMENTER_TYPE_TASK,
	    PACKAGING_TYPE_TASK = _require2.PACKAGING_TYPE_TASK,
	    BREWING_TYPE_TASK = _require2.BREWING_TYPE_TASK,
	    MAX_DRAFT_OPERATION = _require2.MAX_DRAFT_OPERATION,
	    KEY_VENDOR_ITEMS = _require2.KEY_VENDOR_ITEMS,
	    SessionStore = __webpack_require__(11),
	    DashboardAction = __webpack_require__(65),
	    Constants = __webpack_require__(2),
	    DashboardLayoutStore = __webpack_require__(108),
	    ChronologycServiceCache = __webpack_require__(107),
	    NumberUtils = __webpack_require__(23),
	    DateUtils = __webpack_require__(22),
	    moment = __webpack_require__(3),
	    ContentUtils = __webpack_require__(7);
	
	
	var DashboardServiceCache = {
	
	  /**
	   * We create the following legacy retriever method, in order to not show into the dashboard de broken image icon.
	   */
	  getFermenterIconsWithLegacy: function getFermenterIconsWithLegacy() {
	    return [{
	      tankType: 'FV',
	      name: Constants.TASK_NON_VISIBLE,
	      displayName: Constants.TASK_NON_VISIBLE
	    }, {
	      tankType: 'FV',
	      name: 'Yeast New Pitch',
	      displayName: t('dashboard_service_cache_name_yeast_new_pitch'),
	      src: '/assets/images/yeast-new-pitch.svg',
	      icon: 'icon-task icon-yeast-new-pitch'
	    }, {
	      tankType: 'FV',
	      name: 'Yeast In',
	      displayName: t('dashboard_service_cache_name_yeast_in_from'),
	      src: '/assets/images/yeast-in.svg',
	      icon: 'icon-task yeast-in icon-yeast-in'
	    }, {
	      tankType: 'FV',
	      name: 'Yeast Out',
	      displayName: t('dashboard_service_cache_name_yeast_out'),
	      src: '/assets/images/yeast-out.svg',
	      icon: 'icon-task yeast-out icon-yeast-out'
	    }, {
	      tankType: 'FV',
	      name: 'Yeast From',
	      displayName: t('dashboard_service_cache_name_yeast_from'),
	      src: '/assets/images/yeast-from.svg',
	      icon: 'icon-task yeast-from icon-yeast-from'
	    }, {
	      tankType: 'FV',
	      name: 'Yeast Harvest',
	      displayName: t('dashboard_service_cache_name_yeast_harvest'),
	      src: '/assets/images/yeast_harvest.svg',
	      icon: 'icon-task icon-yeast-harvest'
	    }, {
	      tankType: 'FV',
	      name: 'Yeast Drain',
	      displayName: t('dashboard_service_cache_name_yeast_drain'),
	      src: '/assets/images/yeast_drain.svg',
	      icon: 'icon-task icon-yeast-drain'
	    }, {
	      tankType: 'FV',
	      name: 'Fining or Enzymes',
	      displayName: t('dashboard_service_cache_name_finish_enzymes'),
	      src: '/assets/images/fining_enzymes_etc.svg',
	      icon: 'icon-task icon-fining-enzymes-etc'
	    }, {
	      tankType: 'FV',
	      name: 'Dry Hopping',
	      displayName: t('dashboard_service_cache_name_dry_hopping'),
	      src: '/assets/images/dry_hopping.svg',
	      icon: 'icon-task icon-dry-hopping'
	    }, {
	      tankType: 'FV',
	      name: 'DY and DH',
	      displayName: t('dashboard_service_cache_name_dy_and_dh'),
	      src: '/assets/images/dy_and_dh.svg',
	      icon: 'icon-task icon-dy-and-dh'
	    }, {
	      tankType: 'FV',
	      name: Constants.DEFAULT_TASK_BREWING,
	      displayName: Constants.DEFAULT_TASK_BREWING,
	      src: '/assets/images/brew.svg',
	      icon: 'icon-task icon-brewing'
	    }, {
	      tankType: 'FV',
	      name: 'Fruit',
	      displayName: t('dashboard_service_cache_name_fruit'),
	      src: '/assets/images/fruit.svg',
	      icon: 'icon-task icon-fruit'
	    }, {
	      tankType: 'FV',
	      name: 'Pumpkin',
	      displayName: t('dashboard_service_cache_name_pumpkin'),
	      src: '/assets/images/pumpkin.svg',
	      icon: 'icon-task icon-pumpkin'
	    }, {
	      tankType: 'FV',
	      name: 'Honey',
	      displayName: t('dashboard_service_cache_name_honey'),
	      src: '/assets/images/honey.svg',
	      icon: 'icon-task icon-honey'
	    }, {
	      tankType: 'FV',
	      name: 'Coffee Bean',
	      displayName: t('dashboard_service_cache_name_coffee_bean'),
	      src: '/assets/images/coffee-bean.svg',
	      icon: 'icon-task icon-coffee-bean'
	    }, {
	      tankType: 'FV',
	      name: 'Cooling',
	      displayName: t('dashboard_service_cache_name_cooling'),
	      src: '/assets/images/cooling.svg',
	      icon: 'icon-task icon-cooling'
	    }, {
	      tankType: 'FV',
	      name: 'Temperature',
	      displayName: t('dashboard_service_cache_name_temperature'),
	      src: '/assets/images/temperature.svg',
	      icon: 'icon-task icon-temperature'
	    }, {
	      tankType: 'FV',
	      name: 'Firkin',
	      displayName: t('dashboard_service_cache_name_firkin'),
	      src: '/assets/images/firkin.svg',
	      icon: 'icon-task icon-firkin'
	    }, {
	      tankType: 'FV',
	      name: 'Keg',
	      displayName: t('dashboard_service_cache_keg'),
	      src: '/assets/images/keg.svg',
	      icon: 'icon-task icon-keg'
	    }, {
	      tankType: 'FV',
	      name: 'Wood Barrel',
	      displayName: t('dashboard_service_cache_name_wood_barrel'),
	      src: '/assets/images/wood_barrel.svg',
	      icon: 'icon-task icon-wood-barrel'
	    }, {
	      tankType: 'FV',
	      name: 'Tote',
	      displayName: t('dashboard_service_cache_name_tote'),
	      src: '/assets/images/tote.svg',
	      icon: 'icon-task icon-tote'
	    }, {
	      tankType: 'FV',
	      name: 'Repair',
	      displayName: t('dashboard_service_cache_name_repair'),
	      src: '/assets/images/repair.svg',
	      icon: 'icon-task icon-repair'
	    }, {
	      tankType: 'FV',
	      name: 'Report Problem',
	      displayName: t('dashboard_service_cache_name_report_problem'),
	      src: '/assets/images/report_problem.svg',
	      icon: 'icon-task icon-report-problem'
	    }, {
	      tankType: 'FV',
	      name: 'class_meeting',
	      displayName: t('dashboard_service_cache_name_class_or_meeting'),
	      src: '/assets/images/class.svg',
	      icon: 'icon-task icon-class-meeting'
	    }, {
	      tankType: 'FV',
	      name: t('dashboard_service_cache_name_note'),
	      displayName: 'Note',
	      src: '/assets/images/ic_email_white_18px.svg',
	      icon: 'icon-task icon-email'
	    }, {
	      tankType: 'FV',
	      name: 'Cleaning',
	      displayName: t('dashboard_service_cache_name_cleaning'),
	      src: '/assets/images/cleaning.svg',
	      icon: 'icon-task icon-cleaning'
	    }, {
	      tankType: 'FV',
	      name: 'Transfer',
	      displayName: t('dashboard_service_cache_name_transfer'),
	      src: '/assets/images/transfer.svg',
	      icon: 'icon-task icon-transfer'
	    }, {
	      tankType: 'FV',
	      name: 'Centrifuge',
	      displayName: t('dashboard_service_cache_name_centrifuge'),
	      src: '/assets/images/centrifuge.svg',
	      icon: 'icon-task icon-centrifuge'
	    }, {
	      tankType: 'FV',
	      name: Constants.DEFAULT_TASK_FILTRATION,
	      displayName: Constants.DEFAULT_TASK_FILTRATION,
	      src: '/assets/images/filtration.svg',
	      icon: 'icon-task icon-filtration'
	    }, {
	      tankType: 'FV',
	      name: 'Column still',
	      displayName: t('dashboard_service_cache_name_column_still'),
	      src: '/assets/images/column_still_white.svg',
	      icon: 'icon-task icon-column-still'
	    }, {
	      tankType: 'FV',
	      name: 'Pot still',
	      displayName: t('dashboard_service_cache_name_pot_still'),
	      src: '/assets/images/pot_still_white.svg',
	      icon: 'icon-task icon-pot-still'
	    },
	
	    // Legacy ---------------------------------------------
	
	    {
	      tankType: 'FV',
	      name: 'Brew & yeast',
	      displayName: t('dashboard_service_cache_name_brew_yeast'),
	      src: '/assets/images/brew_and_yeast.svg',
	      icon: 'icon-task icon-brew-and-yeast',
	      isDiscontinued: true
	    }, {
	      tankType: 'FV',
	      name: 'Brew & Flask',
	      displayName: t('dashboard_service_cache_name_brew_flask'),
	      src: '/assets/images/brew_and_flask.svg',
	      icon: 'icon-task icon-brew-and-flask',
	      isDiscontinued: true
	    }, {
	      tankType: 'FV',
	      name: 'Filter and Brew',
	      displayName: t('dashboard_service_cache_name_filter_brew'),
	      src: '/assets/images/filter_and_brew_black.svg',
	      icon: 'icon-task icon-filter-and-brew-black',
	      isDiscontinued: true
	    }, {
	      tankType: 'FV',
	      name: 'Brew Day Before',
	      displayName: t('dashboard_service_cache_name_brew_day_before'),
	      src: '/assets/images/brew_day_before.svg',
	      icon: 'icon-task icon-brew-day-before',
	      isDiscontinued: true
	    }];
	  },
	  getPackagingIconsWithLegacy: function getPackagingIconsWithLegacy() {
	    return [{
	      tankType: 'BT',
	      displayName: Constants.TASK_NON_VISIBLE,
	      name: Constants.TASK_NON_VISIBLE
	    }, {
	      tankType: 'BT',
	      name: 'Bottle',
	      displayName: t('dashboard_service_cache_name_bottle'),
	      src: '/assets/images/bottle.svg',
	      icon: 'icon-task icon-bottle'
	    }, {
	      tankType: 'BT',
	      name: 'Can',
	      displayName: t('dashboard_service_cache_name_can'),
	      src: '/assets/images/can.svg',
	      icon: 'icon-task icon-can'
	    }, {
	      tankType: 'BT',
	      name: 'Keg',
	      displayName: t('dashboard_service_cache_keg'),
	      src: '/assets/images/keg.svg',
	      icon: 'icon-task icon-keg'
	    }, {
	      tankType: 'BT',
	      name: 'Box',
	      displayName: t('dashboard_service_cache_name_box'),
	      src: '/assets/images/box.svg',
	      icon: 'icon-task icon-box'
	    }, {
	      tankType: 'BT',
	      name: 'Bottle & keg',
	      displayName: t('dashboard_service_cache_name_bottle_keg'),
	      src: '/assets/images/bottle_and_keg.svg',
	      icon: 'icon-task icon-bottle-and-keg'
	    }, {
	      tankType: 'BT',
	      name: 'Can & Keg',
	      displayName: t('dashboard_service_cache_name_can_keg'),
	      src: '/assets/images/can_and_keg.svg',
	      icon: 'icon-task icon-can-and-keg'
	    }, {
	      tankType: 'BT',
	      name: 'Can & Bottle',
	      displayName: t('dashboard_service_cache_name_can_bottle'),
	      src: '/assets/images/can_and_bottle.svg',
	      icon: 'icon-task icon-can-and-bottle'
	    }, {
	      tankType: 'BT',
	      name: 'Can & Box',
	      displayName: t('dashboard_service_cache_name_can_box'),
	      src: '/assets/images/can_and_box.svg',
	      icon: 'icon-task icon-can-and-box'
	    }, {
	      tankType: 'BT',
	      name: 'Bottle Pack',
	      displayName: t('dashboard_service_cache_name_bottle_pack'),
	      src: '/assets/images/bottle_pack.svg',
	      icon: 'icon-task icon-bottle-pack'
	    }, {
	      tankType: 'BT',
	      name: 'No Pack',
	      displayName: t('dashboard_service_cache_name_no_pack'),
	      src: '/assets/images/no_pack.svg',
	      icon: 'icon-task icon-no-pack'
	    }, {
	      tankType: 'BT',
	      name: 'Mix Box',
	      displayName: t('dashboard_service_cache_name_mix_box'),
	      src: '/assets/images/mix-box.svg',
	      icon: 'icon-task icon-mix-box'
	    }, {
	      tankType: 'BT',
	      name: Constants.DEFAULT_TASK_PACKAGING,
	      displayName: Constants.DEFAULT_TASK_PACKAGING,
	      src: '/assets/images/packaging.svg',
	      icon: 'icon-task icon-packaging'
	    }, {
	      tankType: 'BT',
	      name: 'Co2',
	      displayName: t('dashboard_service_cache_name_co2'),
	      src: '/assets/images/co2.svg',
	      icon: 'icon-task icon-co2'
	    }, {
	      tankType: 'BT',
	      name: 'Receiving Truck',
	      displayName: t('dashboard_service_cache_name_receiving_truck'),
	      src: '/assets/images/receiving-truck.svg',
	      icon: 'icon-task icon-receiving-truck'
	    }, {
	      tankType: 'BT',
	      name: 'Shipping Truck',
	      displayName: t('dashboard_service_cache_name_shipping_truck'),
	      src: '/assets/images/shipping-truck.svg',
	      icon: 'icon-task icon-shipping-truck'
	    }, {
	      tankType: 'BT',
	      name: 'Fruit',
	      displayName: t('dashboard_service_cache_name_fruit'),
	      src: '/assets/images/fruit.svg',
	      icon: 'icon-task icon-fruit'
	    }, {
	      tankType: 'BT',
	      name: 'Pumpkin',
	      displayName: t('dashboard_service_cache_name_pumpkin'),
	      src: '/assets/images/pumpkin.svg',
	      icon: 'icon-task icon-pumpkin'
	    }, {
	      tankType: 'BT',
	      name: 'Honey',
	      displayName: t('dashboard_service_cache_name_honey'),
	      src: '/assets/images/honey.svg',
	      icon: 'icon-task icon-honey'
	    }, {
	      tankType: 'BT',
	      name: 'Coffee Bean',
	      displayName: t('dashboard_service_cache_name_coffee_bean'),
	      src: '/assets/images/coffee-bean.svg',
	      icon: 'icon-task coffee-bean'
	    }, {
	      tankType: 'BT',
	      name: 'Cooling',
	      displayName: t('dashboard_service_cache_name_cooling'),
	      src: '/assets/images/cooling.svg',
	      icon: 'icon-task icon-cooling'
	    }, {
	      tankType: 'BT',
	      name: 'Temperature',
	      displayName: t('dashboard_service_cache_name_temperature'),
	      src: '/assets/images/temperature.svg',
	      icon: 'icon-task icon-temperature'
	    }, {
	      tankType: 'BT',
	      name: 'Firkin',
	      displayName: t('dashboard_service_cache_name_firkin'),
	      src: '/assets/images/firkin.svg',
	      icon: 'icon-task icon-firkin'
	    }, {
	
	      tankType: 'BT',
	      name: 'Wood Barrel',
	      displayName: t('dashboard_service_cache_name_wood_barrel'),
	      src: '/assets/images/wood_barrel.svg',
	      icon: 'icon-task icon-wood-barrel'
	    }, {
	      tankType: 'BT',
	      name: 'Tote',
	      displayName: t('dashboard_service_cache_name_tote'),
	      src: '/assets/images/tote.svg',
	      icon: 'icon-task icon-tote'
	    }, {
	      tankType: 'BT',
	      name: 'Repair',
	      displayName: t('dashboard_service_cache_name_repair'),
	      src: '/assets/images/repair.svg',
	      icon: 'icon-task icon-repair'
	    }, {
	      tankType: 'BT',
	      name: 'Report Problem',
	      displayName: t('dashboard_service_cache_name_report_problem'),
	      src: '/assets/images/report_problem.svg',
	      icon: 'icon-task icon-report-problem'
	    }, {
	      tankType: 'BT',
	      name: 'class_meeting',
	      displayName: t('dashboard_service_cache_name_class_or_meeting'),
	      src: '/assets/images/class.svg',
	      icon: 'icon-task icon-class-meeting'
	    }, {
	      tankType: 'BT',
	      name: 'Note',
	      displayName: t('dashboard_service_cache_name_note'),
	      src: '/assets/images/ic_email_white_18px.svg',
	      icon: 'icon-task icon-email'
	    }, {
	      tankType: 'BT',
	      name: 'Cleaning',
	      displayName: t('dashboard_service_cache_name_cleaning'),
	      src: '/assets/images/cleaning.svg',
	      icon: 'icon-task icon-cleaning'
	    }, {
	      tankType: 'BT',
	      name: 'Transfer',
	      displayName: t('dashboard_service_cache_name_transfer'),
	      src: '/assets/images/transfer.svg',
	      icon: 'icon-task icon-transfer'
	    }, {
	      tankType: 'BT',
	      name: 'Centrifuge',
	      displayName: t('dashboard_service_cache_name_centrifuge'),
	      src: '/assets/images/centrifuge.svg',
	      icon: 'icon-task icon-centrifuge'
	    }, {
	      tankType: 'BT',
	      name: 'Fining or Enzymes',
	      displayName: t('dashboard_service_cache_name_finish_enzymes'),
	      src: '/assets/images/fining_enzymes_etc.svg',
	      icon: 'icon-task icon-fining-enzymes-etc'
	    }, {
	      tankType: 'BT',
	      name: Constants.DEFAULT_TASK_FILTRATION,
	      displayName: Constants.DEFAULT_TASK_FILTRATION,
	      src: '/assets/images/filtration.svg',
	      icon: 'icon-task icon-filtration'
	    }, {
	      tankType: 'BT',
	      name: 'Column still',
	      displayName: t('dashboard_service_cache_name_column_still'),
	      src: '/assets/images/column_still_white.svg',
	      icon: 'icon-task icon-column-still'
	    }, {
	      tankType: 'BT',
	      name: 'Pot still',
	      displayName: t('dashboard_service_cache_name_pot_still'),
	      src: '/assets/images/pot_still_white.svg',
	      icon: 'icon-task icon-pot-still'
	
	      // Legacy --------------------
	    }];
	  },
	  getBrewhouseIconsWithLegacy: function getBrewhouseIconsWithLegacy() {
	    return [{
	      tankType: 'BH',
	      name: Constants.TASK_NON_VISIBLE,
	      displayName: Constants.TASK_NON_VISIBLE
	    }, {
	      tankType: 'BH',
	      name: Constants.DEFAULT_TASK_BREWING,
	      displayName: Constants.DEFAULT_TASK_BREWING,
	      src: '/assets/images/brew.svg',
	      icon: 'icon-task icon-brewing'
	    }, {
	      tankType: 'BH',
	      name: 'Brew & CIP',
	      displayName: t('dashboard_service_cache_name_brew_cip'),
	      src: '/assets/images/brew-&-cip.svg',
	      icon: 'icon-task icon-brew-and-cip'
	    }, {
	      tankType: 'BH',
	      name: 'Bew & O2',
	      displayName: t('dashboard_service_cache_name_brew_o2'),
	      src: '/assets/images/brew-&-o2.svg',
	      icon: 'icon-task icon-brew-and-o2'
	    }, {
	      tankType: 'BH',
	      name: 'Bew, CIP & O2',
	      displayName: t('dashboard_service_cache_name_brew_cip_o2'),
	      src: '/assets/images/brew-cip-&-o2.svg',
	      icon: 'icon-task icon-brew-cip-and-o2'
	    }, {
	      tankType: 'BH',
	      name: 'Fruit',
	      displayName: t('dashboard_service_cache_name_fruit'),
	      src: '/assets/images/fruit.svg',
	      icon: 'icon-task icon-fruit'
	    }, {
	      tankType: 'BH',
	      name: 'Pumpkin',
	      displayName: t('dashboard_service_cache_name_pumpkin'),
	      src: '/assets/images/pumpkin.svg',
	      icon: 'icon-task icon-pumpkin'
	    }, {
	      tankType: 'BH',
	      name: 'Honey',
	      displayName: t('dashboard_service_cache_name_honey'),
	      src: '/assets/images/honey.svg',
	      icon: 'icon-task icon-honey'
	    }, {
	      tankType: 'BH',
	      name: 'Coffee Bean',
	      displayName: t('dashboard_service_cache_name_coffee_bean'),
	      src: '/assets/images/coffee-bean.svg',
	      icon: 'icon-task coffee-bean'
	    }, {
	      tankType: 'BH',
	      name: 'Cooling',
	      displayName: t('dashboard_service_cache_name_cooling'),
	      src: '/assets/images/cooling.svg',
	      icon: 'icon-task icon-cooling'
	    }, {
	      tankType: 'BH',
	      name: 'Temperature',
	      displayName: t('dashboard_service_cache_name_temperature'),
	      src: '/assets/images/temperature.svg',
	      icon: 'icon-task icon-temperature'
	    }, {
	      tankType: 'BH',
	      name: 'Firkin',
	      displayName: t('dashboard_service_cache_name_firkin'),
	      src: '/assets/images/firkin.svg',
	      icon: 'icon-task icon-firkin'
	    }, {
	      tankType: 'BH',
	      name: 'Wood Barrel',
	      displayName: t('dashboard_service_cache_name_wood_barrel'),
	      src: '/assets/images/wood_barrel.svg',
	      icon: 'icon-task icon-wood-barrel'
	    }, {
	      tankType: 'BH',
	      name: 'Tote',
	      displayName: t('dashboard_service_cache_name_tote'),
	      src: '/assets/images/tote.svg',
	      icon: 'icon-task icon-tote'
	    }, {
	      tankType: 'BH',
	      name: 'Repair',
	      displayName: t('dashboard_service_cache_name_repair'),
	      src: '/assets/images/repair.svg',
	      icon: 'icon-task icon-repair'
	    }, {
	      tankType: 'BH',
	      name: 'Report Problem',
	      displayName: t('dashboard_service_cache_name_report_problem'),
	      src: '/assets/images/report_problem.svg',
	      icon: 'icon-task icon-report-problem'
	    }, {
	      tankType: 'BH',
	      name: 'class_meeting',
	      displayName: t('dashboard_service_cache_name_class_or_meeting'),
	      src: '/assets/images/class.svg',
	      icon: 'icon-task icon-class-meeting'
	    }, {
	      tankType: 'BH',
	      name: 'Note',
	      displayName: t('dashboard_service_cache_name_note'),
	      src: '/assets/images/ic_email_white_18px.svg',
	      icon: 'icon-task icon-email'
	    }, {
	      tankType: 'BH',
	      name: 'Cleaning',
	      displayName: t('dashboard_service_cache_name_cleaning'),
	      src: '/assets/images/cleaning.svg',
	      icon: 'icon-task icon-cleaning'
	    }, {
	      tankType: 'BH',
	      name: 'Transfer',
	      displayName: t('dashboard_service_cache_name_transfer'),
	      src: '/assets/images/transfer.svg',
	      icon: 'icon-task icon-transfer'
	    }, {
	      tankType: 'BH',
	      name: 'Column still',
	      displayName: t('dashboard_service_cache_name_column_still'),
	      src: '/assets/images/column_still_white.svg',
	      icon: 'icon-task icon-column-still'
	    }, {
	      tankType: 'BH',
	      name: 'Pot still',
	      displayName: t('dashboard_service_cache_name_pot_still'),
	      src: '/assets/images/pot_still_white.svg',
	      icon: 'icon-task icon-pot-still'
	    }];
	  },
	  getCustomBrewingIcons: function getCustomBrewingIcons() {
	    var _this = this;
	
	    var mapping = Constants.getIconsMapping(t);
	    var brewingIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), function (icon) {
	      return _.get(icon, 'iconDetail.isBrewingAllowed');
	    });
	    return _.map(brewingIcons, function (icon) {
	      return _this._toIcon(icon, { tankType: 'BH' }, mapping);
	    }).sort(function (a, b) {
	      var idA = get(a, 'id');
	      var idB = get(b, 'id');
	      var displayNameA = get(a, 'displayName');
	      var displayNameB = get(b, 'displayName');
	
	      // Keep the object with id 1 at the start
	      if (idA === 1) {
	        return -1; // Keep a before b
	      } else if (idB === 1) {
	        return 1; // Move b before a
	      } else {
	        // Sort the rest alphabetically by display name
	        return displayNameA.localeCompare(displayNameB);
	      }
	    });
	  },
	  getCustomFermenterIcons: function getCustomFermenterIcons() {
	    var _this2 = this;
	
	    var mapping = Constants.getIconsMapping(t);
	    var fermenterIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), function (icon) {
	      return _.get(icon, 'iconDetail.isFermentingAllowed');
	    });
	
	    return _.map(fermenterIcons, function (icon) {
	      return _this2._toIcon(icon, { tankType: 'BH' }, mapping);
	    }).sort(function (a, b) {
	      var idA = get(a, 'id');
	      var idB = get(b, 'id');
	      var displayNameA = get(a, 'displayName');
	      var displayNameB = get(b, 'displayName');
	
	      // Keep the object with id 1 at the start
	      if (idA === 1) {
	        return -1; // Keep a before b
	      } else if (idB === 1) {
	        return 1; // Move b before a
	      } else {
	        // Sort the rest alphabetically by display name
	        return displayNameA.localeCompare(displayNameB);
	      }
	    });
	  },
	  getCustomPackagingIcons: function getCustomPackagingIcons() {
	    var _this3 = this;
	
	    var mapping = Constants.getIconsMapping(t);
	    var packagingIcons = _.filter(ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS), function (icon) {
	      return _.get(icon, 'iconDetail.isPackagingAllowed');
	    });
	    return _.map(packagingIcons, function (icon) {
	      return _this3._toIcon(icon, { tankType: 'BT' }, mapping);
	    }).sort(function (a, b) {
	      var idA = get(a, 'id');
	      var idB = get(b, 'id');
	      var displayNameA = get(a, 'displayName');
	      var displayNameB = get(b, 'displayName');
	
	      // Keep the object with id 1 at the start
	      if (idA === 1) {
	        return -1; // Keep a before b
	      } else if (idB === 1) {
	        return 1; // Move b before a
	      } else {
	        // Sort the rest alphabetically by display name
	        return displayNameA.localeCompare(displayNameB);
	      }
	    });
	  },
	  _toIcon: function _toIcon(icon, overrideAttributes, mapping) {
	    return _.merge({
	      id: icon.id,
	      name: _.trim(_.get(icon, 'iconDetail.name')),
	      displayName: mapping[_.trim(_.get(icon, 'iconDetail.displayName'))] || _.trim(_.get(icon, 'iconDetail.displayName')),
	      src: _.get(icon, 'iconDetail.urlImage'),
	      iconClassName: _.trim('icon-task ' + _.get(icon, 'iconDetail.iconClassName'))
	    }, overrideAttributes);
	  },
	  tryFVicons: function tryFVicons(item, icons) {
	    icons = DashboardServiceCache.getFermenterIconsWithLegacy();
	    item.icon = _.find(icons, function (icon) {
	      return icon.displayName === get(item, 'displayName') || icon.displayName === get(item, 'name') || icon.displayName === get(item, 'task', get(item, 'name')) || icon.name === get(item, 'name') || icon.name === get(item, 'displayName') || icon.name === get(item, 'task', get(item, 'name'));
	    });
	  },
	  tryBTicons: function tryBTicons(item, icons) {
	    icons = DashboardServiceCache.getPackagingIconsWithLegacy();
	    item.icon = _.find(icons, function (icon) {
	      return icon.displayName === get(item, 'displayName') || icon.displayName === get(item, 'name') || icon.displayName === get(item, 'task', get(item, 'name')) || icon.name === get(item, 'name') || icon.name === get(item, 'displayName') || icon.name === get(item, 'task', get(item, 'name'));
	    });
	  },
	  tryBHicons: function tryBHicons(item, icons) {
	    icons = DashboardServiceCache.getBrewhouseIconsWithLegacy();
	    item.icon = _.find(icons, function (icon) {
	      return icon.displayName === get(item, 'displayName') || icon.displayName === get(item, 'name') || icon.displayName === get(item, 'task', get(item, 'name')) || icon.name === get(item, 'name') || icon.name === get(item, 'displayName') || icon.name === get(item, 'task', get(item, 'name'));
	    });
	  },
	  hydrateWithIcon: function hydrateWithIcon(item, tankType, requestedFrom, icons) {
	    if (!item) {
	      return item;
	    }
	    // Find icon corresponding with the Name, DisplayName or Task Name of the item
	    if (requestedFrom === 'dashboard') {
	      item.icon = _.find(icons, function (icon) {
	        return icon.displayName === get(item, 'displayName') || icon.displayName === get(item, 'name') || icon.displayName === get(item, 'task', get(item, 'name')) || icon.name === get(item, 'name') || icon.name === get(item, 'displayName') || icon.name === get(item, 'task', get(item, 'name'));
	      });
	
	      // IF NOT FOUND IN THE TANKTYPE RECIVED FIND EVERYWHERE
	      if (item.icon === undefined) {
	        if (tankType !== 'FV') {
	          this.tryFVicons(item, icons);
	        }
	
	        if (item.icon === undefined) {
	          if (tankType !== 'BT') {
	            this.tryBTicons(item, icons);
	          }
	        }
	
	        if (item.icon === undefined) {
	          if (tankType !== 'BH') {
	            this.tryBHicons(item, icons);
	          }
	        }
	      }
	
	      // If icon not found need to return undefined to prevent non existent icon
	      if (item.icon === undefined && requestedFrom === 'dashboard') {
	        return undefined;
	      }
	    } else {
	      item.icon = _.find(icons, function (icon) {
	        return icon.displayName === get(item, 'typeTask') || icon.name === get(item, 'typeTask');
	      });
	    }
	
	    return item;
	  },
	  getFermenterIcons: function getFermenterIcons() {
	    return this.getCustomFermenterIcons();
	  },
	  getPackagingIcons: function getPackagingIcons() {
	    return this.getCustomPackagingIcons();
	  },
	  getBrewhouseIcons: function getBrewhouseIcons() {
	    return this.getCustomBrewingIcons();
	  },
	  findIconByDisplayName: function findIconByDisplayName(displayName) {
	    var iconTarget = _.find(this.getFermenterIcons(), function (icon) {
	      return icon.displayName === displayName;
	    });
	    if (iconTarget) {
	      return iconTarget;
	    }
	
	    iconTarget = _.find(this.getPackagingIcons(), function (icon) {
	      return icon.displayName === displayName;
	    });
	    if (iconTarget) {
	      return iconTarget;
	    }
	
	    iconTarget = _.find(this.getBrewhouseIcons(), function (icon) {
	      return icon.displayName === displayName;
	    });
	    if (iconTarget) {
	      return iconTarget;
	    }
	
	    return null;
	  },
	
	
	  /**
	   * Retrieve the task by their type.
	   * @param {String} type
	   * @return {Array}
	   */
	  getTasksByType: function getTasksByType(typeTask) {
	    if (typeTask === Constants.TYPE_TANK_FERMENTER) {
	      return this.getFermenterIcons();
	    } else if (typeTask === Constants.TYPE_TANK_BRITE_TANK) {
	      return this.getPackagingIcons();
	    } else if (typeTask === Constants.TYPE_TANK_BREW_HOUSE) {
	      return this.getBrewhouseIcons();
	    }
	  },
	  getIconsByType: function getIconsByType(type) {
	    if (type === FERMENTER_TYPE_TASK || type === 'FV') {
	      return this.getFermenterIcons();
	    } else if (type === PACKAGING_TYPE_TASK || type === 'BT') {
	      return this.getPackagingIcons();
	    } else if (type === BREWING_TYPE_TASK || type === 'BH') {
	      return this.getBrewhouseIcons();
	    }
	  },
	
	
	  /**
	   * Retrieve the current cache orders.
	   * @returns {*|Array}
	   */
	  getOrders: function getOrders() {
	    return ContentUtils.getMemory(KEY_ORDER) || [];
	  },
	  getOrdersByBatchNumber: function getOrdersByBatchNumber(batchNumber) {
	    return _.filter(this.getOrders(), function (order) {
	      return _.get(order, 'batchNumber') === batchNumber;
	    });
	  },
	  getOrdersSorted: function getOrdersSorted() {
	    var orders = this.getOrders() || [];
	    return orders.sort(function (order, orderCompare) {
	      var field = void 0;
	
	      if (order && order.isSingle) {
	        field = 'fromDate';
	      } else {
	        field = 'brewDate';
	      }
	
	      if (DateUtils.isAfter(order[field], orderCompare[field])) {
	        return 1;
	      }
	      if (DateUtils.isBefore(order[field], orderCompare[field])) {
	        return -1;
	      }
	      return 0;
	    });
	  },
	  getSafeOrder: function getSafeOrder(orderId) {
	    if (!orderId) {
	      return null;
	    }
	
	    var orderIdCleaned = ContentUtils.cleanId(orderId);
	
	    return _.cloneDeep(this.getOrder(orderIdCleaned));
	  },
	
	
	  /**
	   * Retrieve the specific order by their id.
	   * @param id
	   * @returns {*}
	   */
	  getOrder: function getOrder(id) {
	    var order = this.getOrders().filter(function (order) {
	      return order.id === id;
	    });
	
	    if (order && order.length === 1) {
	      return _.clone(order[0]);
	    } else {
	      return null;
	    }
	  },
	
	
	  /**
	   * Remove the given cache orders.
	   * @param id
	   */
	  removeOrder: function removeOrder(id) {
	    var targetId = ContentUtils.cleanId(id);
	    var restOfOrders = this.getOrders().filter(function (order) {
	      return ContentUtils.cleanId(order.id) !== targetId;
	    });
	
	    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);
	
	    // remove order from layout
	    DashboardLayoutStore.removeByOrderId(targetId);
	  },
	
	
	  /**
	   * Add new orders and remove the older.
	   * @param orders
	   */
	  setOrders: function setOrders(orders) {
	    this.clearOrderCache();
	    this.addOrders(orders);
	  },
	
	
	  /**
	   * Add a new orders in draft mode in local cache.
	   * @param orders
	   */
	  addOrders: function addOrders(orders) {
	    var self = this;
	    _.forEach(orders, function (order) {
	      self.addOrder(order);
	    });
	  },
	
	
	  /**
	   * Add a new order in draft mode in local cache and assign temporary
	   * id that will be remplace when the order will be pushed in the server side.
	   * @param newOrder
	   * @returns {*}
	   */
	  addOrder: function addOrder(newOrder) {
	    var orders = this.getOrders();
	    if (newOrder && !newOrder.id) {
	      newOrder.id = this._getTemporaryId();
	    }
	    orders.push(_.clone(newOrder));
	    ContentUtils.saveMemory(KEY_ORDER, orders);
	
	    return this.getOrder(newOrder.id);
	  },
	
	
	  /**
	   * Add a new Single order in draft mode in local cache and assign temporary
	   * id that will be remplace when the order will be pushed in the server side.
	   * @param newOrder
	   * @returns {*}
	   */
	  addSingleOrder: function addSingleOrder(newSingleOrder) {
	    var orders = this.getOrders();
	    if (newSingleOrder && !newSingleOrder.id) {
	      newSingleOrder.id = this._getTemporaryId();
	    }
	    orders.push(_.clone(newSingleOrder));
	    ContentUtils.saveMemory(KEY_ORDER, orders);
	
	    return this.getOrder(newSingleOrder.id);
	  },
	
	
	  /**
	   * Change the given order in local cache.
	   * @param newOrder
	   */
	  changeOrder: function changeOrder(newOrder) {
	    var restOfOrders = this.getOrders().filter(function (order) {
	      return order.id !== newOrder.id;
	    });
	    restOfOrders.push(_.clone(newOrder));
	    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);
	  },
	
	
	  /**
	   * Override or set the existent orders draft.
	   */
	  setDraft: function setDraft(draft) {
	    ContentUtils.saveSession(KEY_DRAFT, draft);
	  },
	  updateDraft: function updateDraft(draft) {
	    var pendingOperations = this.getPendingOperations();
	    var havePendingOperation = ContentUtils.isNotEmptyArray(pendingOperations);
	
	    if (havePendingOperation) {
	      this.setDraft(draft);
	      for (var _iterator = pendingOperations, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	          if (_i >= _iterator.length) break;
	          _ref = _iterator[_i++];
	        } else {
	          _i = _iterator.next();
	          if (_i.done) break;
	          _ref = _i.value;
	        }
	
	        var operation = _ref;
	
	        this.addOperation(operation);
	      }
	    } else {
	      this.setDraft(draft);
	    }
	  },
	
	
	  /**
	   * Retrieve the operation of current draft.
	   */
	  getOperations: function getOperations() {
	    return this.getDraft().operations || [];
	  },
	
	
	  /**
	   * Retrieve the redo operation of current draft.
	   */
	  getRedoOperations: function getRedoOperations() {
	    return this.getDraft().redoOperations || [];
	  },
	
	
	  /**
	   * Retrieve the redo operation of current draft.
	   */
	  undoOperations: function undoOperations() {
	    return this.getDraft().undoOperations || [];
	  },
	
	
	  /**
	   * Retrieve the pending operation that dont was saved in the backend side.
	   * @returns {*|Array}
	   */
	  getPendingOperations: function getPendingOperations() {
	    return _.filter(this.getDraft().operations, function (operation) {
	      return !operation.isSaved;
	    });
	  },
	
	  /**
	   * Retrieve the pending operation that dont was saved in the backend side.
	   * @returns {*|Array}
	   */
	  getNonPendingOperations: function getNonPendingOperations() {
	    return _.filter(this.getDraft().operations, function (operation) {
	      return operation.isSaved;
	    });
	  },
	
	
	  /**
	   * Retrieve if exist pending operation or not.
	   * @returns {boolean}
	   */
	  isAllOperationAlreadySaved: function isAllOperationAlreadySaved() {
	    return this.getPendingOperations().length === 0;
	  },
	
	
	  /**
	   * Retrieve the current draft, if doesn't not exist, create an empty one and then return them.
	   */
	  getDraft: function getDraft() {
	    var draft = ContentUtils.getSession(KEY_DRAFT);
	    if (!draft || ContentUtils.isEmptyArray(get(draft, 'operations'))) {
	      this._initEmptyDraft();
	    }
	    return ContentUtils.getSession(KEY_DRAFT);
	  },
	
	
	  /**
	   * Update the tanks from the cache.
	   * @param tanks
	   */
	  setTanks: function setTanks(tanks) {
	    ContentUtils.saveSession(KEY_TANK, tanks);
	  },
	
	
	  /**
	   * Retrieve the cache sorted tanks.
	   * @returns {*|Array}
	   */
	  getTanks: function getTanks() {
	    var tanks = void 0;
	    tanks = ContentUtils.getSession(KEY_TANK) || [];
	    return ContentUtils.sortTanksAndAddColumn(tanks);
	  },
	  getCurrentUnitTank: function getCurrentUnitTank() {
	    return _.get(this.getTanks(), '0.unit') || Constants.DEFAULT_TANK_UNIT;
	  },
	
	
	  /**
	   * Retrieve tank by column.
	   * @param column
	   * @returns {*}
	   */
	  getTankByColumn: function getTankByColumn(column) {
	    var tank = this.getTanks().filter(function (tank) {
	      return tank.column === column;
	    })[0];
	    return tank;
	  },
	
	
	  /**
	   * Add a new operation to the current draft.
	   * @param operation
	   */
	  addOperation: function addOperation(operation) {
	    var draft = this.getDraft(KEY_DRAFT);
	    operation.indexDraft = moment().unix();
	    if (draft.operations.length <= MAX_DRAFT_OPERATION) {
	      draft.operations.push(operation);
	      this.setDraft(draft);
	    } else {
	      CustomDialog.showWarningConfirmation(t('warning'), t('notification_draft_maximum_capacity_wait_a moment_or_publish'), function () {
	        DashboardAction.publishingDraft();
	      });
	      setTimeout(function () {
	        DashboardAction.hideLoading();
	      }, 2000);
	    }
	  },
	
	
	  /**
	   * Mark as save given operations.
	   */
	  markAsSavedOperationsUntilIndex: function markAsSavedOperationsUntilIndex() {
	    var operationsSaved = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var lastIndexDraftSaved = operationsSaved.map(function (op) {
	      return +op.indexDraft;
	    }).sort(function (a, b) {
	      return a - b;
	    }).pop();
	
	    var draft = this.getDraft();
	    draft.operations = _.map(draft.operations, function (operation) {
	      operation.isSaved = operation.indexDraft <= lastIndexDraftSaved;
	      return operation;
	    });
	    this.setDraft(draft);
	  },
	  cleanSavedOperations: function cleanSavedOperations() {
	    var draft = this.getDraft();
	    draft.operations = _.filter(draft.operations, function (operationSaved) {
	      return !operationSaved.isSaved;
	    });
	    this.setDraft(draft);
	  },
	
	
	  /**
	   * Clean all the cache about orders, tanks & drafts too.
	   */
	  clearAllCache: function clearAllCache(isTesting) {
	    if (isTesting) {
	      ContentUtils.saveMemory(KEY_TANK, []);
	    } else {
	      ContentUtils.saveSession(KEY_TANK, []);
	    }
	    ContentUtils.saveMemory(KEY_ORDER, []);
	    ContentUtils.saveSession(KEY_DRAFT, []);
	    ContentUtils.saveSession(KEY_BEER_STYLE, []);
	    ContentUtils.saveSession(Constants.KEY_LOCATION_ITEMS, []);
	    ContentUtils.saveSession(Constants.KEY_LOCATION, []);
	    ContentUtils.saveSession(Constants.KEY_CUSTOM_ICONS, []);
	    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ICONS, []);
	    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ITEMS, []);
	    ContentUtils.saveSession(Constants.KEY_PRODUCTS, []);
	    ContentUtils.saveSession(Constants.KEY_FERMENTING_PROCESS, []);
	    ContentUtils.saveSession(Constants.KEY_PACKAGING_PROCESS, []);
	    ContentUtils.saveSession(Constants.KEY_BREW_PROCESS, []);
	    ContentUtils.saveSession(Constants.KEY_ITEMS, []);
	    ContentUtils.saveSession(Constants.KEY_VENDOR_PURCHASE_ITEMS, []);
	    ContentUtils.saveSession(Constants.KEY_VENDOR_ITEMS, []);
	    ContentUtils.saveSession(Constants.KEY_BEER_STYLE_TASK_CONFIGURATIONS, []);
	  },
	
	
	  /**
	   * Clean only orders cache.
	   */
	  clearOrderCache: function clearOrderCache() {
	    ContentUtils.saveMemory(KEY_ORDER, []);
	  },
	
	
	  /**
	   * Clean operation of current draft, if it doesn't exit create a new one, and
	   * set as empty their operations.
	   */
	  cleanOperations: function cleanOperations() {
	    var draft = this.getDraft();
	    draft.operations = draft.operations.filter(function (operation) {
	      return !operation.isSaved;
	    }); // left only not saved operation.
	    this.setDraft(draft);
	  },
	  getProcessByType: function getProcessByType(type) {
	    switch (type) {
	      case Constants.TYPE_TANK_FERMENTER:
	        return this.getFermentingProcess();
	      case Constants.TYPE_TASK_FERMENTER:
	        return this.getFermentingProcess();
	      case Constants.TYPE_TASK_BREWHOUSE:
	        return this.getBrewingProcess();
	      case Constants.TYPE_TANK_BREW_HOUSE:
	        return this.getBrewingProcess();
	      case Constants.TYPE_TANK_BRITE_TANK:
	        return this.getPackagingProcess();
	      case Constants.TYPE_TASK_PACKAGING:
	        return this.getPackagingProcess();
	    }
	  },
	  getBrewingProcess: function getBrewingProcess() {
	    return ContentUtils.getSession(KEY_BREW_PROCESS) || [];
	  },
	  getFermentingProcess: function getFermentingProcess() {
	    return ContentUtils.getSession(KEY_FERMENTING_PROCESS) || [];
	  },
	  getPackagingProcess: function getPackagingProcess() {
	    return ContentUtils.getSession(KEY_PACKAGING_PROCESS) || [];
	  },
	  getReservationItem: function getReservationItem() {
	    //TODO: WIP...
	    return [];
	  },
	  _setIcons: function _setIcons(icons, iconsFromApplicant) {
	    var iconsWithApplicantIcons = ContentUtils.formatApplicantIcons(icons, iconsFromApplicant);
	    ContentUtils.saveSession(Constants.KEY_CUSTOM_ICONS, iconsWithApplicantIcons);
	  },
	  _setProductIcons: function _setProductIcons(productIcons) {
	    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ICONS, productIcons);
	  },
	  _hydrateWithProduct: function _hydrateWithProduct(productDry, products) {
	    var haveProductIcons = ContentUtils.isNotEmptyArray(productDry) && ContentUtils.isNotEmptyArray(products);
	    if (haveProductIcons) {
	      return _.map(productDry, function (productDry) {
	        var isDryProduct = productDry && productDry.product != undefined && typeof productDry.product === 'number';
	        if (isDryProduct) {
	          var productTarget = _.find(products, function (product) {
	            return product.id === productDry.product;
	          });
	          if (productTarget) {
	            productDry.product = productTarget;
	          }
	        }
	        return productDry;
	      });
	    }
	
	    return productDry;
	  },
	  _setProductItems: function _setProductItems(productItems) {
	    ContentUtils.saveMemory(Constants.KEY_PRODUCT_ITEMS, productItems);
	  },
	  _setLocationItems: function _setLocationItems(locationItems) {
	    ContentUtils.saveSession(Constants.KEY_LOCATION_ITEMS, locationItems);
	  },
	  _setProducts: function _setProducts(products) {
	    ContentUtils.saveSession(Constants.KEY_PRODUCTS, products);
	  },
	  _setLocations: function _setLocations(locations) {
	    ContentUtils.saveSession(KEY_LOCATIONS, locations);
	  },
	  getIcons: function getIcons() {
	    return ContentUtils.getSession(Constants.KEY_CUSTOM_ICONS);
	  },
	  getLocations: function getLocations() {
	    return ContentUtils.getSession(KEY_LOCATIONS);
	  },
	  getProducts: function getProducts() {
	    return ContentUtils.getSession(Constants.KEY_PRODUCTS);
	  },
	  getProductsByBeerStyle: function getProductsByBeerStyle(beerStyleId) {
	    var allProducts = this.getProducts();
	    return _.filter(allProducts, function (product) {
	      return +_.get(product, 'beerStyle.id') === +beerStyleId;
	    });
	  },
	  getProductItemsByProducts: function getProductItemsByProducts(products) {
	    var allProductItems = this.getProductItems();
	    var productsId = _.map(products, function (product) {
	      return product.id;
	    });
	    return _.filter(allProductItems, function (productItem) {
	      return productsId.includes(+_.get(productItem, 'product.id'));
	    });
	  },
	  getLocationItems: function getLocationItems() {
	    return ContentUtils.getSession(Constants.KEY_LOCATION_ITEMS);
	  },
	  getProductIcons: function getProductIcons() {
	    return ContentUtils.getMemory(Constants.KEY_PRODUCT_ICONS);
	  },
	  getProductIconsProducts: function getProductIconsProducts(products) {
	    var allProductIcons = this.getProductIcons();
	    var productsId = _.map(products, function (product) {
	      return product.id;
	    });
	    return _.filter(allProductIcons, function (productIcon) {
	      return productsId.includes(+_.get(productIcon, 'product.id'));
	    });
	  },
	  getProductByIconNameEnables: function getProductByIconNameEnables(taskName) {
	    return _.filter(this.getProductByIconName(taskName), function (productIcon) {
	      return get(productIcon, 'enable');
	    });
	  },
	  getProductByIconName: function getProductByIconName(taskName) {
	    var _this4 = this;
	
	    var productIcons = this.getProductIcons();
	    if (ContentUtils.isNotEmptyArray(productIcons)) {
	      var productIconsFiltered = _.filter(productIcons, function (pi) {
	        return get(pi, 'icon.iconDetail.name') === taskName || get(pi, 'icon.iconDetail.displayName') === taskName;
	      });
	      if (ContentUtils.isNotEmptyArray(productIconsFiltered)) {
	        var productMayRepeated = _.map(productIconsFiltered, function (productIcon) {
	          return productIcon.product;
	        });
	        var productHydrated = _.map(productMayRepeated, function (product) {
	          return _this4.getProductById(get(product, 'id'));
	        });
	        return ContentUtils.removeDuplicateByAttribute(productHydrated, ['id']);
	      }
	    }
	  },
	  getProductItems: function getProductItems() {
	    return ContentUtils.getMemory(Constants.KEY_PRODUCT_ITEMS);
	  },
	  getLocationItemByLocationIdAndItemId: function getLocationItemByLocationIdAndItemId(locationId, itemId) {
	    return _.find(this.getLocationItems(), function (locationItem) {
	      return get(locationItem, 'item.id') === itemId && get(locationItem, 'location.id') === locationId;
	    });
	  },
	  getLocationItemByItemId: function getLocationItemByItemId(locationId, itemId) {
	    return _.find(this.getLocationItems(), function (locationItem) {
	      return get(locationItem, 'item.id') === itemId;
	    });
	  },
	  getProductItemsByProductId: function getProductItemsByProductId(productId) {
	    return _.filter(this.getProductItems(), function (productItem) {
	      return _.get(productItem, 'product.id') === productId;
	    });
	  },
	  getProductItemsByProductIdAndItemId: function getProductItemsByProductIdAndItemId(productId, itemId) {
	    return _.find(this.getProductItems(), function (productItem) {
	      return _.get(productItem, 'product.id') === productId && _.get(productItem, 'item.id') === itemId;
	    });
	  },
	  getProductById: function getProductById(productId) {
	    return _.find(DashboardServiceCache.getProducts(), function (productPristine) {
	      return productId === get(productPristine, 'id');
	    });
	  },
	  getProductByName: function getProductByName(productName) {
	    return _.find(DashboardServiceCache.getProducts(), function (productPristine) {
	      return productName === get(productPristine, 'name');
	    });
	  },
	
	
	  /**
	   * Initialize the whole cache content to allow render the Dashboard Page.
	   * @param dashboardContent
	   */
	  fillCache: function fillCache(dashboardContent) {
	    // Sort tanks and add Column attributes and then save Tanks.
	    var tanksSortedWithColumns = ContentUtils.sortTanksAndAddColumn(dashboardContent.tanks);
	    this.setTanks(tanksSortedWithColumns);
	
	    // Save all kind of process such as Brewing, Fermenting and Packaging order process.
	    this._addTask(dashboardContent.process);
	
	    // Save Style Beers
	    this._setBeerStyles(_.orderBy(dashboardContent.styleBeers, 'name'));
	
	    // Save Beer Style Task Configurations
	    this._setBeerStyleConfiguration(dashboardContent.styleBeerConfiguration);
	
	    // Save the current version from each of Poll.
	    SessionStore.setLastPublishVersion(dashboardContent.lastPublicationNumber);
	    SessionStore.setLastBrewingNoteNumber(dashboardContent.lastBrewingNoteNumber);
	    SessionStore.setLastPackagingNoteNumber(dashboardContent.lastPackagingNoteNumber);
	    SessionStore.setCurrentAppVersion(dashboardContent.lastAppVersion);
	    SessionStore.setLastPublicationAdminNumber(dashboardContent.lastPublicationAdminNumber);
	    SessionStore.setLastChangeUserToken(dashboardContent.lastChangeUserToken);
	    if (dashboardContent.lastBatchNumberOrder) {
	      SessionStore.setLastBatchNumber(dashboardContent.lastBatchNumberOrder);
	    }
	    // Fill cache Notes from Chronologyc bar
	    ChronologycServiceCache.fillBrewingNoteCache(dashboardContent.brewingNotes);
	    ChronologycServiceCache.fillPackagingNoteCache(dashboardContent.packagingNotes);
	    // Fill cache about applicantConfiguration
	    SessionStore.setApplicantPhone(get(dashboardContent, 'applicantConfigurationDetail.applicantPhone'));
	    SessionStore.setApplicantEmail(get(dashboardContent, 'applicantConfigurationDetail.email'));
	    SessionStore.setApplicantAddress(get(dashboardContent, 'applicantConfigurationDetail.applicantAddress'));
	    SessionStore.setApplicantCityAndState(get(dashboardContent, 'applicantConfigurationDetail.applicantCityAndState'));
	    SessionStore.setApplicantTaxId(get(dashboardContent, 'applicantConfigurationDetail.applicantTaxId'));
	    // Section visibility filter
	    SessionStore.setIsVisibleBrewingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBrewingSection'));
	    SessionStore.setIsVisibleFermentingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisibleFermentingSection'));
	    SessionStore.setIsVisiblePackagingSection(get(dashboardContent, 'applicantConfigurationDetail.isVisiblePackagingSection'));
	    // BeerStyle label section filter
	    SessionStore.setIsVisibleBeerStyleLabelBrewing(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNameBrewingSection'));
	    SessionStore.setIsVisibleBeerStyleLabelFermenting(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNameFermentingSection'));
	    SessionStore.setIsVisibleBeerStyleLabelPackaging(get(dashboardContent, 'applicantConfigurationDetail.isVisibleBeerNamePackagingSection'));
	  },
	  fillCacheInventoryItems: function fillCacheInventoryItems(dashboardContent) {
	    // Save custom configuration of icons, applicantIcons & Products configuration
	    this._setIcons(dashboardContent.icons, dashboardContent.applicantIcons);
	    this._setLocations(dashboardContent.locations);
	    this._setLocationItems(dashboardContent.locationItems);
	    this._setItems(dashboardContent.items);
	    this._setVendorPurchaseItems(dashboardContent.vendorPurchaseItem);
	    this._setVendorItems(dashboardContent.vendorItems);
	    this._setLocationInformation(dashboardContent);
	  },
	  fillCacheInventoryProducts: function fillCacheInventoryProducts(dashboardContent) {
	    // Save custom configuration of icons, applicantIcons & Products configuration
	    var productIconHydrated = this._hydrateWithProduct(dashboardContent.productIcons, dashboardContent.products);
	    this._setProductIcons(productIconHydrated);
	    var productItemsHydrated = this._hydrateWithProduct(dashboardContent.productItems, dashboardContent.products);
	    this._setProductItems(productItemsHydrated);
	    this._setProducts(dashboardContent.products);
	  },
	  fillCacheOrder: function fillCacheOrder(orders) {
	    var self = this;
	    // Fill the tank of each order.
	    orders = this.hydratedOrdersWithTanks(orders, this.getTanks());
	
	    // Fill the style beer of each order.
	    orders = this.hydratedOrdesWithBeerStyles(orders, this.getBeerStyles());
	
	    // Fill the style beer of each order.
	    orders = this.hydratedOrdersWithProducts(orders, this.getProducts());
	
	    // clean order list
	    ContentUtils.saveMemory(KEY_ORDER, []);
	
	    // Add all existent order from the server, that could be already hydrated.
	    _.forEach(orders, function (order) {
	      self.addOrder(order);
	    });
	
	    // validate if while saving draft, don't have any new operation without saved yet
	    // so hydrate until save the next pendings operation
	    var pendingOperations = this.getPendingOperations();
	    if (ContentUtils.isNotEmptyArray(pendingOperations)) {
	      this._hydrateWithLastestNonSavedOperations(pendingOperations);
	    }
	
	    return orders;
	  },
	  _hydrateWithLastestNonSavedOperations: function _hydrateWithLastestNonSavedOperations(pendingOperations) {
	    var _this5 = this;
	
	    if (ContentUtils.isNotEmptyArray(pendingOperations)) {
	      var self = this;
	      _.forEach(pendingOperations, function (operation) {
	        var operationType = get(operation, 'typeOperation');
	        switch (operationType) {
	          case 'NEW_ORDER':
	            {
	              self.addOrder(get(operation, 'order'));
	              break;
	            }
	          case 'CHANGE_ORDER':
	            {
	              var existingOrder = _this5.getOrders();
	              if (existingOrder) {
	                self.changeOrder(operation.order);
	              } else {
	                self.addOrder(get(operation, 'order'));
	              }
	              break;
	            }
	          case 'DELETE_ORDER':
	            {
	              self.removeOrder(get(operation, 'order.id'));
	              break;
	            }
	        }
	      });
	    }
	  },
	  _setItems: function _setItems(items) {
	    ContentUtils.saveSession(KEY_ITEMS, items);
	  },
	  getItems: function getItems() {
	    return ContentUtils.getSession(KEY_ITEMS);
	  },
	  getItemById: function getItemById(itemId) {
	    return _.find(ContentUtils.getSession(KEY_ITEMS), function (item) {
	      return item.id === itemId;
	    });
	  },
	  _setVendorPurchaseItems: function _setVendorPurchaseItems(vendorPurchaseItems) {
	    ContentUtils.saveSession(KEY_VENDOR_PURCHASE_ITEMS, vendorPurchaseItems);
	  },
	  getVendorPurchaseItems: function getVendorPurchaseItems() {
	    return ContentUtils.getSession(KEY_VENDOR_PURCHASE_ITEMS);
	  },
	  _setVendorItems: function _setVendorItems(vendorItems) {
	    ContentUtils.saveSession(KEY_VENDOR_ITEMS, vendorItems);
	  },
	  getVendorItems: function getVendorItems() {
	    return ContentUtils.getSession(KEY_VENDOR_ITEMS);
	  },
	  _setLocationInformation: function _setLocationInformation() {
	    //const country = get(dashboardContent, 'country') || DashboardServiceCache.getCurrentCountry();
	    //SessionStore.setCurrentCountry(country);
	  },
	  _setBrewhouseProcess: function _setBrewhouseProcess(brewProcess) {
	    ContentUtils.saveSession(KEY_BREW_PROCESS, brewProcess);
	  },
	  _addTask: function _addTask(processList) {
	    ContentUtils.saveSession(KEY_FERMENTING_PROCESS, _.filter(processList, function (process) {
	      return process.processSection === Constants.FERMENTING_SECTION_NAME;
	    }));
	    ContentUtils.saveSession(KEY_PACKAGING_PROCESS, _.filter(processList, function (process) {
	      return process.processSection === Constants.PACKAGING_SECTION_NAME;
	    }));
	    ContentUtils.saveSession(KEY_BREW_PROCESS, _.filter(processList, function (process) {
	      return process.processSection === Constants.BREWING_SECTION_NAME;
	    }));
	  },
	  _setBeerStyleConfiguration: function _setBeerStyleConfiguration(tasks) {
	    ContentUtils.saveSession(KEY_BEER_STYLE_TASK_CONFIGURATIONS, tasks);
	  },
	  getBeerStyleTaskConfiguration: function getBeerStyleTaskConfiguration() {
	    return ContentUtils.getSession(KEY_BEER_STYLE_TASK_CONFIGURATIONS);
	  },
	  getBeerStyleTaskConfigurationByBeerStyle: function getBeerStyleTaskConfigurationByBeerStyle(beerStyleId) {
	    var configurations = this.getBeerStyleTaskConfiguration();
	    return _.filter(configurations, function (configuration) {
	      return get(configuration, 'styleBeerId') === beerStyleId;
	    });
	  },
	
	
	  /**
	   * Given orders and tanks, fill each order with the proper tank information.
	   * @param {Array} orders
	   * @param {Array} tanksToSave
	   * @returns {*}
	   */
	  hydratedOrdersWithTanks: function hydratedOrdersWithTanks(orders, tanks) {
	    var _this6 = this;
	
	    var briteTankOrder = void 0,
	        fermenterTankOrder = void 0,
	        singleTankOrder = void 0;
	    return _.map(orders, function (order) {
	      if (order.isSingle) {
	        singleTankOrder = _.find(tanks, function (tank) {
	          return String(tank.id) === String(order.singleTankId);
	        });
	        order.singleTank = singleTankOrder;
	      } else {
	        briteTankOrder = _.find(tanks, function (tank) {
	          return String(tank.id) === String(order.briteTankId);
	        });
	        fermenterTankOrder = _.find(tanks, function (tank) {
	          return String(tank.id) === String(order.fermenterTankId);
	        });
	        order.fermenterTank = fermenterTankOrder;
	        order.briteTank = briteTankOrder;
	      }
	      order = _this6.hydratedOrderWithBatchs(order, tanks);
	      return order;
	    });
	  },
	
	
	  /**
	   * Given order and tanks, hydrated with turns each batch if needed.
	   * @param order
	   * @param tanks
	   * @return {*}
	   */
	  hydratedOrderWithBatchs: function hydratedOrderWithBatchs(order, tanks) {
	    if (order && order.batchs) {
	      order.batchs = _.map(order.batchs, function (batch) {
	        batch.turn = _.find(tanks, function (tank) {
	          return tank.id === batch.turnId;
	        });
	        return batch;
	      });
	    }
	    return order;
	  },
	
	
	  /**
	   * Given orders and style beers fill each order with the proper style beer information.
	   * @param {Array} orders
	   * @param {Array} tanksToSave
	   * @returns {*}
	   */
	  hydratedOrdesWithBeerStyles: function hydratedOrdesWithBeerStyles(orders, styleBeers) {
	    var styleBeer = void 0;
	    return _.map(orders, function (order) {
	      styleBeer = _.find(styleBeers, function (styleBeer) {
	        return String(styleBeer.id) === String(order.styleBeerId);
	      });
	      order.styleBeer = styleBeer;
	      return order;
	    });
	  },
	  hydratedOrdersWithProducts: function hydratedOrdersWithProducts(orders, products) {
	    return _.map(orders, function (order) {
	      if (order) {
	        if (order.isSingle) {
	          order.singleTasks = _hydrateProductTask(order.singleTasks, products);
	        } else {
	          order.fermenterTasks = _hydrateProductTask(order.fermenterTasks, products);
	          order.packagingTasks = _hydrateProductTask(order.packagingTasks, products);
	          order.batchs = _hydrateProductTask(order.batchs, products);
	        }
	      }
	      return order;
	    });
	  },
	  getLatestBatchNumber: function getLatestBatchNumber() {
	    var _this7 = this;
	
	    // get last batch number from the server
	    var lastBatchNumberSavedFromServer = SessionStore.getLastBatchNumber();
	
	    // get the last batch number from the client
	    var localBatchNumber = get(_.maxBy(this.getOrders(), function (order) {
	      return _this7._getNumber(order);
	    }), 'batchNumber', '');
	
	    return NumberUtils.isGreater(lastBatchNumberSavedFromServer, localBatchNumber) ? lastBatchNumberSavedFromServer : localBatchNumber;
	  },
	  _getNumber: function _getNumber(order) {
	    if (!order) {
	      return 0;
	    }
	    var batchNumber = _.get(order, 'batchNumber', '');
	    if (batchNumber && batchNumber.match) {
	      return +_.join(batchNumber.match(/[\d]/gi), '');
	    } else {
	      return 0;
	    }
	  },
	
	
	  /**
	   * Save locally the style beers.
	   * @param styleBeer
	   * @private
	   */
	  _setBeerStyles: function _setBeerStyles(styleBeer) {
	    ContentUtils.saveSession(KEY_BEER_STYLE, styleBeer);
	  },
	
	
	  /**
	   * Retrieve the cache style beer.
	   * @returns {*}
	   */
	  getBeerStyles: function getBeerStyles() {
	    return ContentUtils.getSession(KEY_BEER_STYLE);
	  },
	
	
	  /**
	   * The temporary identifier to handler the new orders.
	   * @returns {string}
	   * @private
	   */
	  _getTemporaryId: function _getTemporaryId() {
	    return Constants.DRAFT_ORDER_PREFIX.toString() + Math.random();
	  },
	
	
	  /**
	   * Initialize an empty draft.
	   * @private
	   */
	  _initEmptyDraft: function _initEmptyDraft() {
	    this.setDraft({
	      applicant: SessionStore.getCurrentApplicant(),
	      operations: []
	    });
	  },
	
	
	  /**
	   * Order the tanks against the number of column asc order.
	   * @argument {Tank} tankA
	   * @argument {Tank} TankB
	   * @return {Number}
	   */
	  _prioritizeTank: function _prioritizeTank(tankA, tankB) {
	    var comlumnOne = tankA.name.match(/\d+/);
	    var comlumnTwo = tankB.name.match(/\d+/);
	    return comlumnOne - comlumnTwo;
	  },
	  updateOrder: function updateOrder(newOrder) {
	    var restOfOrders = (ContentUtils.getMemory(KEY_ORDER) || []).filter(function (order) {
	      return order.id !== newOrder.id;
	    });
	    restOfOrders.push(newOrder);
	    ContentUtils.saveMemory(KEY_ORDER, restOfOrders);
	  },
	  setDraftOrderAmount: function setDraftOrderAmount(draftOrderAmount) {
	    ContentUtils.saveLocal(KEY_DRAFT_ORDER_AMOUNT, draftOrderAmount);
	  },
	  setUndoDraftOrderAmount: function setUndoDraftOrderAmount(undoDraftOrderAmount) {
	    ContentUtils.saveLocal(KEY_UNDO_DRAFT_ORDER_AMOUNT, undoDraftOrderAmount);
	  },
	  getDraftOrderAmount: function getDraftOrderAmount() {
	    return ContentUtils.getLocal(KEY_DRAFT_ORDER_AMOUNT) || 0;
	  },
	  getUndoDraftOrderAmount: function getUndoDraftOrderAmount() {
	    return ContentUtils.getLocal(KEY_UNDO_DRAFT_ORDER_AMOUNT) || 0;
	  }
	};
	
	function _hydrateProductTask(tasks, products) {
	  if (ContentUtils.isNullOrEmpty(tasks)) {
	    return tasks;
	  }
	
	  return _.map(tasks, function (task) {
	    if (task && ContentUtils.isNotEmptyArray(task.products)) {
	      task.products = _.map(task.products, function (product) {
	        var productTarget = _.find(products, function (productSearch) {
	          return _.get(productSearch, 'id') === _.get(product, 'id');
	        });
	        if (productTarget) {
	          product.category = productTarget.category;
	          product.name = productTarget.name;
	          product.amountDefault = productTarget.amount;
	          // make immutable field
	          Object.defineProperty(product, 'amountDefault', {
	            configurable: false,
	            writable: false,
	            enumerable: true
	          });
	        }
	        return product;
	      });
	    }
	    return task;
	  });
	}
	
	module.exports = DashboardServiceCache;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _require = __webpack_require__(8),
	    forEach = _require.forEach;
	
	var Notification = __webpack_require__(21);
	
	var _require2 = __webpack_require__(5),
	    merge = _require2.merge;
	
	var ContentUtils = __webpack_require__(7);
	
	var AdminScaffoldingContextHolder = {
	
	    validators: [],
	
	    cleaners: [],
	
	    itemProviders: [],
	
	    isValid: function isValid() {
	        var isValid = true;
	        forEach(this.validators, function (validator) {
	            if (!validator()) {
	                isValid = false;
	            }
	        });
	        return isValid;
	    },
	
	
	    /**
	     * Clean each of field from the form.
	     */
	    clean: function clean() {
	        forEach(this.cleaners, function (cleaner) {
	            cleaner();
	        });
	    },
	
	
	    /**
	     * Retrieve the object that came from of each field of form.
	     * @returns {*}
	     */
	    getItem: function getItem() {
	        var item = {};
	        forEach(this.itemProviders, function (itemProvider) {
	            item = merge(item, itemProvider());
	        });
	        return item;
	    },
	    addValidator: function addValidator(validator) {
	        this.validators.push(validator);
	    },
	    addCleaner: function addCleaner(cleaner) {
	        this.cleaners.push(cleaner);
	    },
	    addItemProvider: function addItemProvider(itemProvider) {
	        this.itemProviders.push(itemProvider);
	    },
	    cleanContext: function cleanContext() {
	        this.validators = [];
	        this.cleaners = [];
	        this.itemProviders = [];
	    }
	};
	
	module.exports = {
	
	    /**
	     * Retrieve the new context holder instance each time to be called. For that, take care
	     * when consume them to share the same context by a group of component.
	     * @returns {*}
	     */
	    getContextHolderInstance: function getContextHolderInstance() {
	        AdminScaffoldingContextHolder.cleanContext();
	        return _extends({}, AdminScaffoldingContextHolder);
	    },
	
	
	    /**
	     * Update the row selected item and update scroll position
	     * @param obj
	     * @param itemIndex
	     * @param lastRowScrollPosition
	     * @param headerActiveFilters
	     */
	    __onRowSelection: function __onRowSelection(obj, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: obj,
	            isEditMode: !!obj,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    __onCancel: function __onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    __onFailureShowMessageError: function __onFailureShowMessageError(messageInfo) {
	        if (messageInfo) {
	            var messageError = ContentUtils.formatMessageError(messageInfo);
	            Notification.show(messageError);
	        }
	    },
	    __onEnterPress: function __onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    __addEnterKeyDown: function __addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    }
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    buttonFactory = {
	    primary: function primary(onClick, label, icon, style, className, isDisabled) {
	        var classNameValue = 'form-group-button form-group-button-primary ' + className + ' ' + (isDisabled ? ' is-disabled' : '');
	        return React.createElement("button", { style: style, onClick: isDisabled ? function () {} : onClick,
	            className: classNameValue }, label);
	    },
	    secondary: function secondary(onClick, label, icon, style, className, isDisabled) {
	        var classNameValue = 'form-group-button form-group-button-secondary ' + className + ' ' + (isDisabled ? ' is-disabled' : '');
	        return React.createElement("button", { style: style, onClick: isDisabled ? function () {} : onClick,
	            className: classNameValue }, label);
	    },
	    icon: function icon(onClick, label, _icon, style, className, isDisabled) {
	        var classNameValue = 'form-group-button form-group-button-icon ' + className + ' ' + (isDisabled ? ' is-disabled' : '');
	        return React.createElement("button", { style: style, onClick: isDisabled ? function () {} : onClick,
	            className: classNameValue }, label, React.createElement("i", { className: "material-icons md-48" }, _icon));
	    }
	};
	
	var FormGroupButton = React.createClass({ displayName: "FormGroupButton",
	
	    propTypes: {
	        type: PropTypes.oneOf(['primary', 'secondary', 'icon']),
	        label: PropTypes.string,
	        icon: PropTypes.string,
	        onClick: PropTypes.func,
	        style: PropTypes.object,
	        className: PropTypes.string,
	        disable: PropTypes.bool
	    },
	
	    render: function render() {
	        var _props = this.props,
	            onClick = _props.onClick,
	            type = _props.type,
	            label = _props.label,
	            style = _props.style,
	            icon = _props.icon,
	            className = _props.className,
	            disable = _props.disable;
	
	        return buttonFactory[type === undefined ? 'primary' : type](onClick, label, icon, style, className, disable);
	    }
	});
	
	module.exports = FormGroupButton;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(145);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3');
	 * // => 3
	 */
	function toInteger(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  var remainder = value % 1;
	  return value === value ? (remainder ? value - remainder : value) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  warning = function(condition, format ) {for (var args=[],$__0=2,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function()  {return args[argIndex++];});
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1330);
	
	var React = __webpack_require__(14),
	    PropTypes = React.PropTypes;
	
	var Loading = React.createClass({ displayName: "Loading",
	
	    propTypes: {
	        size: PropTypes.number
	    },
	
	    render: function render() {
	        return React.createElement("div", { className: "bp-loading text-center",
	            style: { paddingTop: '50px', margin: '0 auto' } }, React.createElement("i", { className: "bp-loading__icon" }));
	    }
	});
	
	module.exports = Loading;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    isSymbol = __webpack_require__(493);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = Symbol ? symbolProto.toString : undefined;
	
	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (value == null) {
	    return '';
	  }
	  if (isSymbol(value)) {
	    return Symbol ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toString;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API;
	
	var _require = __webpack_require__(8),
	    reduce = _require.reduce;
	
	var _require2 = __webpack_require__(48),
	    slice = _require2.slice;
	
	var isDevelopment = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV === 'development';
	
	var NavigationUtils = {
	
	    /**
	     * Change url location to given page.
	     */
	    goTo: function goTo(page, queryParams) {
	        if (isDevelopment) {
	            apiAppUrl = 'http://127.0.0.1:8000';
	        }
	        window.location = queryParams ? apiAppUrl + '/#/' + page + '?' + this.formatQueryParams(slice(arguments, 1)) : apiAppUrl + '/#/' + page;
	    },
	    goToForce: function goToForce(page, queryParams) {
	        if (isDevelopment) {
	            apiAppUrl = 'http://127.0.0.1:8000';
	        }
	        var url = queryParams ? apiAppUrl + '/#/' + page + '?' + this.formatQueryParams(slice(arguments, 1)) : apiAppUrl + '/#/' + page;
	        window.location.push(url);
	    },
	
	
	    /**
	     * Change url location to given page.
	     */
	    goToText: function goToText(page, textId) {
	        if (isDevelopment) {
	            apiAppUrl = 'http://127.0.0.1:8000';
	        }
	        window.location = apiAppUrl + '/#/' + page + '#' + textId;
	    },
	
	
	    /**
	     * Concat with `&` operator given the query params.
	     */
	    formatQueryParams: function formatQueryParams(queryParams) {
	        return reduce(queryParams, function (paramBefore, paramAfter) {
	            return paramBefore + '&' + paramAfter;
	        });
	    },
	
	
	    /**
	     * Retrieve the next path params defined.
	     */
	    getPathParam: function getPathParam(param) {
	        var pathParams = window.location.hash.split('/');
	        var targetIndex = pathParams.indexOf(param) + 1;
	        var paramValue = pathParams[targetIndex];
	        if (paramValue && paramValue.split) {
	            return paramValue.split('?')[0]; // remove to the last param the query params
	        } else {
	            return paramValue;
	        }
	    },
	
	
	    /**
	     * Retrieve the query params defined
	     */
	    getQueryParam: function getQueryParam(name, url) {
	        if (!url) url = window.location.href;
	        name = name.replace(/[\[\]]/g, '\\$&');
	        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
	            results = regex.exec(url);
	        if (!results) return null;
	        if (!results[2]) return '';
	        return decodeURIComponent(results[2].replace(/\+/g, ' '));
	    }
	};
	
	module.exports = NavigationUtils;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    mui = __webpack_require__(12),
	    set = __webpack_require__(5).set,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(79),
	    trim = _require2.trim,
	    AppConstants = __webpack_require__(2),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    BasicFormGroup = __webpack_require__(94),
	    SessionStore = __webpack_require__(11),
	    TextField = mui.TextField;
	
	
	var FormGroupTextfield = React.createClass({ displayName: "FormGroupTextfield",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        placeHolder: PropTypes.string,
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        messageError: PropTypes.string,
	        writerAttribute: PropTypes.string,
	        readerAttribute: PropTypes.string,
	        name: PropTypes.string,
	        decimalDigits: PropTypes.bool,
	        isRelaxedText: PropTypes.bool,
	        noInternalValidation: PropTypes.bool,
	        formatDecimal: PropTypes.string,
	        isDecimalFormat: PropTypes.bool,
	        amountDecimals: PropTypes.number,
	        isRequired: PropTypes.bool,
	        onEnter: PropTypes.func,
	        className: PropTypes.string,
	        onBlur: PropTypes.func,
	        id: PropTypes.string
	    }),
	
	    _el: null,
	
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {
	        if (this.refs && this._el) {
	            this._el.clearValue();
	        }
	    },
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            readerAttribute = _props.readerAttribute,
	            isDecimalFormat = _props.isDecimalFormat;
	
	
	        var value = void 0;
	        if (this._el) {
	            value = trim(this._el.getValue());
	        } else {
	            value = '';
	        }
	        var writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
	        var valueUpdated = isDecimalFormat ? NumberUtils.standardiseDecimalFormatNumber(value) : value;
	        var wrapper = set({}, writerAttributeSafe, valueUpdated);
	
	        return wrapper;
	    },
	    isValid: function isValid(onFinishValidation) {
	        var _props2 = this.props,
	            name = _props2.name,
	            additionalValidation = _props2.additionalValidation,
	            isRequired = _props2.isRequired,
	            isRelaxedText = _props2.isRelaxedText,
	            isDecimalFormat = _props2.isDecimalFormat,
	            noInternalValidation = _props2.noInternalValidation;
	
	        if (ContentUtils.isNull(isRequired)) {
	            isRequired = true;
	        }
	
	        var inputValue = trim(this._el.getValue());
	
	        var messageError = '';
	
	        if (!noInternalValidation) {
	            //console.log(this.props);
	            if (isRelaxedText && inputValue) {
	                messageError = ContentUtils.isValidTextNotRequiredWithCustomValidation(inputValue, name, AppConstants.REGEX_NAME_RELAXED);
	            } else {
	                if (isRequired) {
	                    messageError = ContentUtils.isValidText(inputValue, name);
	                } else {
	                    messageError = ContentUtils.isValidTextNotRequired(inputValue, name);
	                }
	            }
	        }
	
	        if (!messageError && additionalValidation) {
	            messageError = additionalValidation(inputValue);
	        }
	
	        this.setState({ messageError: messageError }, function () {
	            if (onFinishValidation) {
	                onFinishValidation();
	            }
	        });
	
	        if (isDecimalFormat && this._isNumberMoreThanPrecisionTen(NumberUtils.standardiseDecimalFormatNumber(inputValue))) {
	            messageError = t('form_group_textfield_error_message_amount_so_longer');
	        }
	
	        return messageError === '';
	    },
	    _isNumberMoreThanPrecisionTen: function _isNumberMoreThanPrecisionTen(number) {
	        return get(number, 'length') > 10 || 0;
	    },
	    _onEnter: function _onEnter() {
	        if (this.props.onEnter) {
	            this.props.onEnter();
	        }
	    },
	    _onBlur: function _onBlur() {
	        this.isValid(this.props.onBlur);
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props3 = this.props,
	            isDisabled = _props3.isDisabled,
	            label = _props3.label,
	            onChange = _props3.onChange,
	            value = _props3.value,
	            readerAttribute = _props3.readerAttribute,
	            isDark = _props3.isDark,
	            isImmutable = _props3.isImmutable,
	            isEditMode = _props3.isEditMode,
	            isDecimalFormat = _props3.isDecimalFormat,
	            decimalDigits = _props3.decimalDigits,
	            className = _props3.className;
	
	        // is disabled input
	
	        var isDisabledInput = !!isDisabled || isImmutable && isEditMode;
	
	        // prepare specific classes
	        var textFieldClassName = 'form-group form-group-textfield';
	        textFieldClassName += isDark ? ' is-dark' : '';
	        textFieldClassName += isDisabledInput ? ' is-disabled' : '';
	        textFieldClassName += ' is-dark';
	        if (className) {
	            textFieldClassName += ' ' + className;
	        }
	        var classNameElement = 'form-group-textfield-input' + (isDisabledInput ? ' is-disabled' : '');
	
	        var textFieldValue = "";
	
	        var decimalPositionsSettings = get(SessionStore.getCurrentCurrencyDigits(), 'value');
	
	        if (readerAttribute) {
	            // the input value
	            textFieldValue = value === undefined ? '' : get(value, readerAttribute, '');
	            textFieldValue = isDecimalFormat ? NumberUtils.formatDecimal(textFieldValue, decimalPositionsSettings) : textFieldValue;
	        } else {
	            textFieldValue = value;
	            textFieldValue = isDecimalFormat ? NumberUtils.formatDecimal(textFieldValue, decimalPositionsSettings) : textFieldValue;
	        }
	
	        return React.createElement("div", { className: textFieldClassName, id: this.props.id }, React.createElement(TextField, {
	            ref: function ref(_ref) {
	                return _this._el = _ref;
	            },
	            className: classNameElement,
	            floatingLabelStyle: { color: '#fff !important', fontWeight: '300' },
	            LabelStyle: { color: '#fff !important', fontWeight: '300' },
	            onChange: onChange,
	            onBlur: this._onBlur,
	            onEnterKeyDown: this._onEnter,
	            defaultValue: textFieldValue,
	            floatingLabelText: label ? label : '',
	            style: { width: '100%', color: 'white !important', fontWeight: '300' },
	            disabled: isDisabledInput,
	            errorText: get(this.state, 'messageError', '')
	        }));
	    }
	});
	
	module.exports = FormGroupTextfield;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'after': __webpack_require__(905),
	  'ary': __webpack_require__(475),
	  'before': __webpack_require__(478),
	  'bind': __webpack_require__(479),
	  'bindKey': __webpack_require__(910),
	  'curry': __webpack_require__(925),
	  'curryRight': __webpack_require__(926),
	  'debounce': __webpack_require__(480),
	  'defer': __webpack_require__(929),
	  'delay': __webpack_require__(930),
	  'flip': __webpack_require__(955),
	  'memoize': __webpack_require__(1013),
	  'negate': __webpack_require__(1020),
	  'once': __webpack_require__(1024),
	  'overArgs': __webpack_require__(1027),
	  'partial': __webpack_require__(497),
	  'partialRight': __webpack_require__(1034),
	  'rearg': __webpack_require__(1044),
	  'rest': __webpack_require__(16),
	  'spread': __webpack_require__(1071),
	  'throttle': __webpack_require__(1082),
	  'unary': __webpack_require__(1094),
	  'wrap': __webpack_require__(1106)
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactContext = __webpack_require__(381);
	var ReactCurrentOwner = __webpack_require__(93);
	
	var assign = __webpack_require__(25);
	var warning = __webpack_require__(32);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true
	};
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} object
	 * @param {string} key
	 */
	function defineWarningProperty(object, key) {
	  Object.defineProperty(object, key, {
	
	    configurable: false,
	    enumerable: true,
	
	    get: function() {
	      if (!this._store) {
	        return null;
	      }
	      return this._store[key];
	    },
	
	    set: function(value) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        false,
	        'Don\'t set the %s property of the React element. Instead, ' +
	        'specify the correct value when initially creating the element.',
	        key
	      ) : null);
	      this._store[key] = value;
	    }
	
	  });
	}
	
	/**
	 * This is updated to true if the membrane is successfully created.
	 */
	var useMutationMembrane = false;
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} element
	 */
	function defineMutationMembrane(prototype) {
	  try {
	    var pseudoFrozenProperties = {
	      props: true
	    };
	    for (var key in pseudoFrozenProperties) {
	      defineWarningProperty(prototype, key);
	    }
	    useMutationMembrane = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {string|object} ref
	 * @param {*} key
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function(type, key, ref, owner, context, props) {
	  // Built-in properties that belong on the element
	  this.type = type;
	  this.key = key;
	  this.ref = ref;
	
	  // Record the component responsible for creating this element.
	  this._owner = owner;
	
	  // TODO: Deprecate withContext, and then the context becomes accessible
	  // through the owner.
	  this._context = context;
	
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    // The validation flag and props are currently mutative. We put them on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    this._store = {props: props, originalProps: assign({}, props)};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    try {
	      Object.defineProperty(this._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true
	      });
	    } catch (x) {
	    }
	    this._store.validated = false;
	
	    // We're not allowed to set props directly on the object so we early
	    // return and rely on the prototype membrane to forward to the backing
	    // store.
	    if (useMutationMembrane) {
	      Object.freeze(this);
	      return;
	    }
	  }
	
	  this.props = props;
	};
	
	// We intentionally don't expose the function on the constructor property.
	// ReactElement should be indistinguishable from a plain object.
	ReactElement.prototype = {
	  _isReactElement: true
	};
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  defineMutationMembrane(ReactElement.prototype);
	}
	
	ReactElement.createElement = function(type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return new ReactElement(
	    type,
	    key,
	    ref,
	    ReactCurrentOwner.current,
	    ReactContext.current,
	    props
	  );
	};
	
	ReactElement.createFactory = function(type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. <Foo />.type === Foo.type.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceProps = function(oldElement, newProps) {
	  var newElement = new ReactElement(
	    oldElement.type,
	    oldElement.key,
	    oldElement.ref,
	    oldElement._owner,
	    oldElement._context,
	    newProps
	  );
	
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	  return newElement;
	};
	
	ReactElement.cloneElement = function(element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return new ReactElement(
	    element.type,
	    key,
	    ref,
	    owner,
	    element._context,
	    props
	  );
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function(object) {
	  // ReactTestUtils is often used outside of beforeEach where as React is
	  // within it. This leads to two different instances of React on the same
	  // page. To identify a element from a different React instance we use
	  // a flag instead of an instanceof check.
	  var isElement = !!(object && object._isReactElement);
	  // if (isElement && !(object instanceof ReactElement)) {
	  // This is an indicator that you're using multiple versions of React at the
	  // same time. This will screw with ownership and stuff. Fix it, please.
	  // TODO: We could possibly warn here.
	  // }
	  return isElement;
	};
	
	module.exports = ReactElement;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1316);
	__webpack_require__(690);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    _require = __webpack_require__(79),
	    kebabCase = _require.kebabCase,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    map = _require2.map,
	    _require3 = __webpack_require__(511),
	    uniqueId = _require3.uniqueId,
	    SessionStore = __webpack_require__(11),
	    BasicFormChange = __webpack_require__(398),
	    BasicFormNew = __webpack_require__(700),
	    UserPermissionStore = __webpack_require__(184),
	    _require4 = __webpack_require__(12),
	    IconButton = _require4.IconButton,
	    FontIcon = _require4.FontIcon,
	    _require5 = __webpack_require__(19),
	    Navigation = _require5.Navigation;
	
	
	var AdminScaffolding = React.createClass({ displayName: "AdminScaffolding",
	
	    mixins: [Navigation],
	
	    propTypes: {
	        additionalSubmitValue: PropTypes.object,
	        additionalPreSubmitValidation: PropTypes.func,
	        contextHolder: PropTypes.object,
	        fetchItems: PropTypes.func,
	        headerFields: function headerFields(props, propName) {
	            var fields = props[propName];
	            React.Children.forEach(fields, function (child) {
	                if (kebabCase(child.type.displayName).indexOf('form-group') === -1) {
	                    throw new Error('The children must be a `form-group` component.');
	                }
	            });
	        },
	        module: PropTypes.string,
	        messages: PropTypes.object,
	        addEnterKeyDown: PropTypes.func,
	        onAdd: PropTypes.func.isRequired,
	        onAddText: PropTypes.func,
	        onChange: PropTypes.func.isRequired,
	        onChangeText: PropTypes.func,
	        onDelete: PropTypes.func.isRequired,
	        onCancel: PropTypes.func.isRequired,
	        onDeleteText: PropTypes.string,
	        title: PropTypes.string,
	        additionalButtons: PropTypes.array,
	        value: PropTypes.object,
	        isDeleteHidden: PropTypes.boolean,
	        customClassName: PropTypes.string,
	        breadcrumb: PropTypes.array,
	        shouldFocusDidMount: PropTypes.bool,
	        isSaving: PropTypes.bool,
	        moduleName: PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isValid: true
	        };
	    },
	    goToHistory: function goToHistory() {
	        this.transitionTo('/history?selected-module=:module', {
	            module: this.props.module
	        });
	    },
	    shouldHidden: function shouldHidden(permissionTarget) {
	        return SessionStore.isFullPaidVersion() ? !UserPermissionStore.shouldShow(this.props.moduleName, permissionTarget) : !SessionStore.isAdminUser();
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props = this.props,
	            isSaving = _props.isSaving,
	            shouldFocusDidMount = _props.shouldFocusDidMount,
	            onDeleteText = _props.onDeleteText,
	            addEnterKeyDown = _props.addEnterKeyDown,
	            onAddText = _props.onAddText,
	            onChangeText = _props.onChangeText,
	            module = _props.module,
	            breadcrumb = _props.breadcrumb,
	            customClassName = _props.customClassName,
	            additionalPreSubmitValidation = _props.additionalPreSubmitValidation,
	            additionalSubmitValue = _props.additionalSubmitValue,
	            isDark = _props.isDark,
	            title = _props.title,
	            headerFields = _props.headerFields,
	            onAdd = _props.onAdd,
	            onChange = _props.onChange,
	            onDelete = _props.onDelete,
	            onCancel = _props.onCancel,
	            value = _props.value,
	            fetchItems = _props.fetchItems,
	            messages = _props.messages,
	            contextHolder = _props.contextHolder,
	            additionalButtons = _props.additionalButtons;
	
	
	        var additionalButtonsFiltered = SessionStore.isFullPaidVersion() ? SessionStore.hasAdminUserPermission() ? additionalButtons : filter(additionalButtons, function (button) {
	            return UserPermissionStore.shouldShow(_this.props.moduleName, button.permission);
	        }) : additionalButtons;
	        var additionalButtonChange = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, function (button) {
	            return button.type === 'CHANGE';
	        }), function (buttonEl) {
	            return buttonEl.el;
	        }) : null;
	        var additionalButtonNew = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, function (button) {
	            return button.type === 'NEW';
	        }), function (buttonEl) {
	            return buttonEl.el;
	        }) : null;
	        var formEl = value ? React.createElement(BasicFormChange, {
	            additionalPreSubmitValidation: additionalPreSubmitValidation,
	            isDark: isDark,
	            addEnterKeyDown: addEnterKeyDown,
	            title: title,
	            contextHolder: contextHolder,
	            messages: messages,
	            fetchItems: fetchItems,
	            value: value,
	            onChange: onChange,
	            onChangeText: onChangeText,
	            onCancel: onCancel,
	            onDelete: onDelete,
	            onDeleteText: onDeleteText,
	            additionalSubmitValue: additionalSubmitValue,
	            additionalButtons: additionalButtonChange,
	            isDeleteHidden: onDelete === undefined || this.shouldHidden('DELETE'),
	            isSaveHidden: onChange === undefined || this.shouldHidden('EDIT'),
	            breadcrumb: breadcrumb,
	            isValid: this.state.isValid,
	            shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount,
	            isSaving: isSaving
	        }, headerFields) : React.createElement(BasicFormNew, {
	            additionalPreSubmitValidation: additionalPreSubmitValidation,
	            addEnterKeyDown: addEnterKeyDown,
	            isDark: isDark,
	            title: title,
	            contextHolder: contextHolder,
	            messages: messages,
	            onAdd: onAdd,
	            onAddText: onAddText,
	            fetchItems: fetchItems,
	            additionalSubmitValue: additionalSubmitValue,
	            additionalButtons: additionalButtonNew,
	            isAddHidden: onAdd === undefined || this.shouldHidden('NEW'),
	            breadcrumb: breadcrumb,
	            isValid: this.state.isValid,
	            shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount,
	            isSaving: isSaving
	        }, headerFields);
	
	        var goToHistoryEl = module ? React.createElement("div", { className: "admin-scaffolding-history" }, React.createElement("small", null, t('label_history')), React.createElement(IconButton, { onClick: this.goToHistory, className: "right-option-menu", touch: true }, React.createElement(FontIcon, { color: '#fff', className: "material-icons" }, "history"))) : null;
	
	        var className = 'admin-scaffolding';
	
	        if (!this.state.isValid) {
	            className += ' is-invalid';
	        }
	
	        if (!SessionStore.isFullPaidVersion()) {
	            className += ' is-free-version';
	        }
	
	        return React.createElement("div", { className: className }, goToHistoryEl, React.createElement("div", { key: uniqueId('admin-scaffolding-header'), className: "admin-scaffolding-header" }, formEl), React.createElement("div", { key: uniqueId('admin-scaffolding-content'),
	            className: 'admin-scaffolding-content ' + customClassName }, this.props.children));
	    }
	});
	
	module.exports = AdminScaffolding;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 4.5.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash -d -o ./foo/lodash.js`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.5.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256,
	      FLIP_FLAG = 512;
	
	  /** Used to compose bitmasks for comparison styles. */
	  var UNORDERED_COMPARE_FLAG = 1,
	      PARTIAL_COMPARE_FLAG = 2;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	  /** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0x/i;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	      rsComboSymbolsRange = '\\u20d0-\\u20f0',
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsQuoteRange = '\\u2018\\u2019\\u201c\\u201d',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	  /** Used to match non-compound words composed of alphanumeric characters. */
	  var reBasicWord = /[a-zA-Z0-9]+/g;
	
	  /** Used to match complex or compound words. */
	  var reComplexWord = RegExp([
	    rsUpper + '?' + rsLower + '+(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsUpperMisc + '+(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	    rsUpper + '?' + rsLowerMisc + '+',
	    rsUpper + '+',
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasComplexWord = /[a-z][A-Z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Reflect', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_',
	    'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[mapTag] = cloneableTags[numberTag] =
	  cloneableTags[objectTag] = cloneableTags[regexpTag] =
	  cloneableTags[setTag] = cloneableTags[stringTag] =
	  cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
	  cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
	  cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `exports`. */
	  var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	    ? exports
	    : undefined;
	
	  /** Detect free variable `module`. */
	  var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	    ? module
	    : undefined;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = (freeModule && freeModule.exports === freeExports)
	    ? freeExports
	    : undefined;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	  /** Detect free variable `self`. */
	  var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	  /** Detect free variable `window`. */
	  var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	  /** Detect `this` as the global object. */
	  var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal ||
	    ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	      freeSelf || thisGlobal || Function('return this')();
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {...*} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    var length = args.length;
	    switch (length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * Creates a new array concatenating `array` with `other`.
	   *
	   * @private
	   * @param {Array} array The first array to concatenate.
	   * @param {Array} other The second array to concatenate.
	   * @returns {Array} Returns the new concatenated array.
	   */
	  function arrayConcat(array, other) {
	    var index = -1,
	        length = array.length,
	        othIndex = -1,
	        othLength = other.length,
	        result = Array(length + othLength);
	
	    while (++index < length) {
	      result[index] = array[index];
	    }
	    while (++othIndex < othLength) {
	      result[index++] = other[othIndex];
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    return !!array.length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * A specialized version of `_.includesWith` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * The base implementation of methods like `_.max` and `_.min` which accepts a
	   * `comparator` to determine the extremum value.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The iteratee invoked per iteration.
	   * @param {Function} comparator The comparator used to compare values.
	   * @returns {*} Returns the extremum value.
	   */
	  function baseExtremum(array, iteratee, comparator) {
	    var index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var value = array[index],
	          current = iteratee(value);
	
	      if (current != null && (computed === undefined
	            ? current === current
	            : comparator(current, computed)
	          )) {
	        var computed = current,
	            result = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of methods like `_.find` and `_.findKey`, without
	   * support for iteratee shorthands, which iterates over `collection` using
	   * `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @param {boolean} [retKey] Specify returning the key of the found element instead of the element itself.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFind(collection, predicate, eachFunc, retKey) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = retKey ? key : value;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define
	   * the sort order of `array` and replaces criteria objects with their
	   * corresponding values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` without support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the new array of key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing wrapper metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Checks if `value` is a global object.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	   */
	  function checkGlobal(value) {
	    return (value && value.Object === Object) ? value : null;
	  }
	
	  /**
	   * Compares values to sort them in ascending order.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function compareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * Used by `_.orderBy` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	   * specify an order of "desc" for descending or "asc" for ascending sort order
	   * of corresponding values.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]|string[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = compareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * (order == 'desc' ? -1 : 1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        result++;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is a host object in IE < 9.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	   */
	  function isHostObject(value) {
	    // Many host objects are `Object` objects that can coerce to strings
	    // despite having improperly defined `toString` methods.
	    var result = false;
	    if (value != null && typeof value.toString != 'function') {
	      try {
	        result = !!(value + '');
	      } catch (e) {}
	    }
	    return result;
	  }
	
	  /**
	   * Checks if `value` is a valid array-like index.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	   */
	  function isIndex(value, length) {
	    value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	    length = length == null ? MAX_SAFE_INTEGER : length;
	    return value > -1 && value % 1 == 0 && value < length;
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to an array.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    if (!(string && reHasComplexSymbol.test(string))) {
	      return string.length;
	    }
	    var result = reComplexSymbol.lastIndex = 0;
	    while (reComplexSymbol.test(string)) {
	      result++;
	    }
	    return result;
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return string.match(reComplexSymbol);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Use `context` to mock `Date#getTime` use in `_.now`.
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    context = context ? _.defaults({}, context, _.pick(root, contextProps)) : root;
	
	    /** Built-in constructor references. */
	    var Date = context.Date,
	        Error = context.Error,
	        Math = context.Math,
	        RegExp = context.RegExp,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = context.Array.prototype,
	        objectProto = context.Object.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = context.Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objectToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Reflect = context.Reflect,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        clearTimeout = context.clearTimeout,
	        enumerate = Reflect ? Reflect.enumerate : undefined,
	        getPrototypeOf = Object.getPrototypeOf,
	        getOwnPropertySymbols = Object.getOwnPropertySymbols,
	        iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined,
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = Object.keys,
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var Map = getNative(context, 'Map'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var mapCtorString = Map ? funcToString.call(Map) : '',
	        setCtorString = Set ? funcToString.call(Set) : '',
	        weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = Symbol ? symbolProto.valueOf : undefined,
	        symbolToString = Symbol ? symbolProto.toString : undefined;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chaining. Methods that operate on and return arrays, collections, and
	     * functions can be chained together. Methods that retrieve a single value or
	     * may return a primitive value will automatically end the chain sequence and
	     * return the unwrapped value. Otherwise, the value must be unwrapped with
	     * `_#value`.
	     *
	     * Explicit chaining, which must be unwrapped with `_#value` in all cases,
	     * may be enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization to merge iteratee calls; this avoids the creation
	     * of intermediate arrays and can greatly reduce the number of iteratee executions.
	     * Sections of a chain sequence qualify for shortcut fusion if the section is
	     * applied to an array of at least two hundred elements and any iteratees
	     * accept only one argument. The heuristic for whether a section qualifies
	     * for shortcut fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`, `difference`,
	     * `differenceBy`, `differenceWith`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flattenDepth`,
	     * `flip`, `flow`, `flowRight`, `fromPairs`, `functions`, `functionsIn`,
	     * `groupBy`, `initial`, `intersection`, `intersectionBy`, `intersectionWith`,
	     * `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`, `keys`, `keysIn`,
	     * `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`, `memoize`,
	     * `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`, `nthArg`,
	     * `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`, `overEvery`,
	     * `overSome`, `partial`, `partialRight`, `partition`, `pick`, `pickBy`, `plant`,
	     * `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`, `pullAt`, `push`,
	     * `range`, `rangeRight`, `rearg`, `reject`, `remove`, `rest`, `reverse`,
	     * `sampleSize`, `set`, `setWith`, `shuffle`, `slice`, `sort`, `sortBy`,
	     * `splice`, `spread`, `tail`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `toArray`, `toPairs`, `toPairsIn`,
	     * `toPath`, `toPlainObject`, `transform`, `unary`, `union`, `unionBy`,
	     * `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`, `unshift`, `unzip`,
	     * `unzipWith`, `values`, `valuesIn`, `without`, `wrap`, `xor`, `xorBy`,
	     * `xorWith`, `zip`, `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `endsWith`, `eq`,
	     * `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `floor`, `forEach`, `forEachRight`, `forIn`,
	     * `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`,
	     * `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`,
	     * `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	     * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	     * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	     * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`,
	     * `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`, `isSafeInteger`,
	     * `isSet`, `isString`, `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`,
	     * `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`,
	     * `lt`, `lte`, `max`, `maxBy`, `mean`, `min`, `minBy`, `noConflict`, `noop`,
	     * `now`, `pad`, `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `sample`,
	     * `shift`, `size`, `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`,
	     * `sortedLastIndex`, `sortedLastIndexBy`, `startCase`, `startsWith`, `subtract`,
	     * `sum`, `sumBy`, `template`, `times`, `toLower`, `toInteger`, `toLength`,
	     * `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`, `trimEnd`,
	     * `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`, `upperFirst`,
	     * `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
	          (arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an hash object.
	     *
	     * @private
	     * @constructor
	     * @returns {Object} Returns the new hash object.
	     */
	    function Hash() {}
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(hash, key) {
	      return hashHas(hash, key) && delete hash[key];
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(hash, key) {
	      if (nativeCreate) {
	        var result = hash[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @param {Object} hash The hash to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(hash, key) {
	      return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function hashSet(hash, key, value) {
	      hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function MapCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapClear() {
	      this.__data__ = {
	        'hash': new Hash,
	        'map': Map ? new Map : [],
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapDelete(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapGet(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.get(key) : assocGet(data.map, key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	      }
	      return Map ? data.map.has(key) : assocHas(data.map, key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache object.
	     */
	    function mapSet(key, value) {
	      var data = this.__data__;
	      if (isKeyable(key)) {
	        hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	      } else if (Map) {
	        data.map.set(key, value);
	      } else {
	        assocSet(data.map, key, value);
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a set cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.push(values[index]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache`.
	     *
	     * @private
	     * @param {Object} cache The set cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function cacheHas(cache, value) {
	      var map = cache.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        return hash[value] === HASH_UNDEFINED;
	      }
	      return map.has(value);
	    }
	
	    /**
	     * Adds `value` to the set cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var map = this.__data__;
	      if (isKeyable(value)) {
	        var data = map.__data__,
	            hash = typeof value == 'string' ? data.string : data.hash;
	
	        hash[value] = HASH_UNDEFINED;
	      }
	      else {
	        map.set(value, HASH_UNDEFINED);
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function Stack(values) {
	      var index = -1,
	          length = values ? values.length : 0;
	
	      this.clear();
	      while (++index < length) {
	        var entry = values[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = { 'array': [], 'map': null };
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocDelete(array, key) : data.map['delete'](key);
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocGet(array, key) : data.map.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      var data = this.__data__,
	          array = data.array;
	
	      return array ? assocHas(array, key) : data.map.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache object.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__,
	          array = data.array;
	
	      if (array) {
	        if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	          assocSet(array, key, value);
	        } else {
	          data.array = null;
	          data.map = new MapCache(array);
	        }
	      }
	      var map = data.map;
	      if (map) {
	        map.set(key, value);
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Removes `key` and its value from the associative array.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function assocDelete(array, key) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = array.length - 1;
	      if (index == lastIndex) {
	        array.pop();
	      } else {
	        splice.call(array, index, 1);
	      }
	      return true;
	    }
	
	    /**
	     * Gets the associative array value for `key`.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function assocGet(array, key) {
	      var index = assocIndexOf(array, key);
	      return index < 0 ? undefined : array[index][1];
	    }
	
	    /**
	     * Checks if an associative array value for `key` exists.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function assocHas(array, key) {
	      return assocIndexOf(array, key) > -1;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `key` is found in `array`
	     * of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to search.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Sets the associative array `key` to `value`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     */
	    function assocSet(array, key, value) {
	      var index = assocIndexOf(array, key);
	      if (index < 0) {
	        array.push([key, value]);
	      } else {
	        array[index][1] = value;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function assignInDefaults(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (typeof key == 'number' && value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          isNil = object == null,
	          length = paths.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = isNil ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the array-like object.
	     */
	    function baseCastArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the array-like object.
	     */
	    function baseCastFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function baseCastPath(value) {
	      return isArray(value) ? value : stringToPath(value);
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stack) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          if (isHostObject(value)) {
	            return object ? value : {};
	          }
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        assignValue(result, key, baseClone(subValue, isDeep, customizer, key, value, stack));
	      });
	      return isArr ? result : copySymbols(value, result);
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     */
	    function baseConforms(source) {
	      var props = keys(source),
	          length = props.length;
	
	      return function(object) {
	        if (object == null) {
	          return !length;
	        }
	        var index = length;
	        while (index--) {
	          var key = props[index],
	              predicate = source[key],
	              value = object[key];
	
	          if ((value === undefined && !(key in Object(object))) || !predicate(value)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    function baseCreate(proto) {
	      return isObject(proto) ? objectCreate(proto) : {};
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an array
	     * of `func` arguments.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments to provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support for
	     * excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && isArrayLikeObject(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return object == null ? object : baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	      // that are composed entirely of index properties, return `false` for
	      // `hasOwnProperty` checks of them.
	      return hasOwnProperty.call(object, key) ||
	        (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        caches[othIndex] = !comparator && (iteratee || array.length >= 120)
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          length = array.length,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      if (!isKey(path, object)) {
	        path = baseCastPath(path);
	        object = parent(object, path);
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {boolean} [bitmask] The bitmask of comparison flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - Unordered comparison
	     *     2 - Partial comparison
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, bitmask, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = getTag(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = getTag(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag && !isHostObject(object),
	          othIsObj = othTag == objectTag && !isHostObject(other),
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag, equalFunc, customizer, bitmask);
	      }
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      if (!isPartial) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, bitmask, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack,
	              result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;
	
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      var type = typeof value;
	      if (type == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      return nativeKeys(Object(object));
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't skip the constructor
	     * property of prototypes or treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      object = object == null ? object : Object(object);
	
	      var result = [];
	      for (var key in object) {
	        result.push(key);
	      }
	      return result;
	    }
	
	    // Fallback for IE < 9 with es6-shim.
	    if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	      baseKeysIn = function(object) {
	        return iteratorToArray(enumerate(object));
	      };
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value &&
	            (value !== undefined || (key in Object(object)));
	        };
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      var props = (isArray(source) || isTypedArray(source))
	        ? undefined
	        : keysIn(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      });
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        newValue = srcValue;
	        if (isArray(srcValue) || isTypedArray(srcValue)) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            isCommon = false;
	            newValue = baseClone(srcValue, true);
	          }
	          else {
	            newValue = objValue;
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      stack.set(srcValue, newValue);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1,
	          toIteratee = getIteratee();
	
	      iteratees = arrayMap(iteratees.length ? iteratees : Array(1), function(iteratee) {
	        return toIteratee(iteratee);
	      });
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property names.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, props) {
	      object = Object(object);
	      return arrayReduce(props, function(result, key) {
	        if (key in object) {
	          result[key] = object[key];
	        }
	        return result;
	      }, {});
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key) {
	        if (predicate(value, key)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAll`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values) {
	      return basePullAllBy(array, values);
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAllBy(array, values, iteratee) {
	      var index = -1,
	          length = values.length,
	          seen = array;
	
	      if (iteratee) {
	        seen = arrayMap(array, function(value) { return iteratee(value); });
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = baseIndexOf(seen, computed, fromIndex)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (lastIndex == length || index != previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          }
	          else if (!isKey(index, array)) {
	            var path = baseCastPath(index),
	                object = parent(array, path);
	
	            if (object != null) {
	              delete object[last(path)];
	            }
	          }
	          else {
	            delete array[index];
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments to numbers.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the new array of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          var newValue = value;
	          if (index != lastIndex) {
	            var objValue = nested[key];
	            newValue = customizer ? customizer(objValue, key, nested) : undefined;
	            if (newValue === undefined) {
	              newValue = objValue == null
	                ? (isIndex(path[index + 1]) ? [] : {})
	                : objValue;
	            }
	          }
	          assignValue(nested, key, newValue);
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq`.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array) {
	      return baseSortedUniqBy(array);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniqBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniqBy(array, iteratee) {
	      var index = 0,
	          length = array.length,
	          value = array[0],
	          computed = iteratee ? iteratee(value) : value,
	          seen = computed,
	          resIndex = 0,
	          result = [value];
	
	      while (++index < length) {
	        value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	        if (!eq(computed, seen)) {
	          seen = computed;
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	      object = parent(object, path);
	      var key = last(path);
	      return (object != null && has(object, key)) ? delete object[key] : true;
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var index = -1,
	          length = arrays.length;
	
	      while (++index < length) {
	        var result = result
	          ? arrayPush(
	              baseDifference(result, arrays[index], iteratee, comparator),
	              baseDifference(arrays[index], result, iteratee, comparator)
	            )
	          : arrays[index];
	      }
	      return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property names.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        assignFunc(result, props[index], index < valsLength ? values[index] : undefined);
	      }
	      return result;
	    }
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var Ctor = buffer.constructor,
	          result = new Ctor(buffer.length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var Ctor = arrayBuffer.constructor,
	          result = new Ctor(arrayBuffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map) {
	      var Ctor = map.constructor;
	      return arrayReduce(mapToArray(map), addMapEntry, new Ctor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var Ctor = regexp.constructor,
	          result = new Ctor(regexp.source, reFlags.exec(regexp));
	
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set) {
	      var Ctor = set.constructor;
	      return arrayReduce(setToArray(set), addSetEntry, new Ctor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return Symbol ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var arrayBuffer = typedArray.buffer,
	          buffer = isDeep ? cloneArrayBuffer(arrayBuffer) : arrayBuffer,
	          Ctor = typedArray.constructor;
	
	      return new Ctor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object) {
	      return copyObjectWith(source, props, object);
	    }
	
	    /**
	     * This function is like `copyObject` except that it accepts a function to
	     * customize copied values.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObjectWith(source, props, object, customizer) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : source[key];
	
	        assignValue(object, key, newValue);
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbol properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return rest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = typeof customizer == 'function'
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBaseWrapper(func, bitmask, thisArg) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = reHasComplexSymbol.test(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols ? strSymbols[0] : string.charAt(0),
	            trailing = strSymbols ? strSymbols.slice(1).join('') : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string)), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurryWrapper(func, bitmask, arity) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getPlaceholder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return rest(function(funcs) {
	        funcs = baseFlatten(funcs, 1);
	
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 &&
	              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	          isFlip = bitmask & FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getPlaceholder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurryWrapper(
	            func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new invoker function.
	     */
	    function createOver(arrayFunc) {
	      return rest(function(iteratees) {
	        iteratees = arrayMap(baseFlatten(iteratees, 1), getIteratee());
	        return rest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(string, length, chars) {
	      length = toInteger(length);
	
	      var strLength = stringSize(string);
	      if (!length || strLength >= length) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars === undefined ? ' ' : (chars + '');
	
	      var result = repeat(chars, nativeCeil(padLength / stringSize(chars)));
	      return reHasComplexSymbol.test(chars)
	        ? stringToArray(result).slice(0, padLength).join('')
	        : result.slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toNumber(start);
	        start = start === start ? start : 0;
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toNumber(end) || 0;
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & CURRY_FLAG,
	          newArgPos = argPos ? copyArray(argPos) : undefined,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	      if (!(bitmask & CURRY_BOUND_FLAG)) {
	        bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, newArgPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = toInteger(precision);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask of wrapper flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] == null
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == BIND_FLAG) {
	        var result = createBaseWrapper(func, bitmask, thisArg);
	      } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	        result = createCurryWrapper(func, bitmask, arity);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	        result = createPartialWrapper(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} [stack] Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	      var index = -1,
	          isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(array, other);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isUnordered) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, equalFunc, customizer, bitmask) {
	      switch (tag) {
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object) ? other != +other : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	          convert || (convert = setToArray);
	
	          // Recursively compare objects (susceptible to call stack limits).
	          return (isPartial || object.size == other.size) &&
	            equalFunc(convert(object), convert(other), customizer, bitmask | UNORDERED_COMPARE_FLAG);
	
	        case symbolTag:
	          return !!Symbol && (symbolValueOf.call(object) == symbolValueOf.call(other));
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	          objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : baseHas(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      return result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If the `_.iteratee` method is
	     * customized this function returns the custom method, otherwise it returns
	     * `baseIteratee`. If arguments are provided the chosen function is invoked
	     * with them and its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = toPairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getPlaceholder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Creates an array of the own symbol properties of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = getOwnPropertySymbols || function() {
	      return [];
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function getTag(value) {
	      return objectToString.call(value);
	    }
	
	    // Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
	    if ((Map && getTag(new Map) != mapTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = objectToString.call(value),
	            Ctor = result == objectTag ? value.constructor : null,
	            ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case mapCtorString: return mapTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasFunc(object, path);
	      if (!result && !isKey(path)) {
	        path = baseCastPath(path);
	        object = parent(object, path);
	        if (object != null) {
	          path = last(path);
	          result = hasFunc(object, path);
	        }
	      }
	      var length = object ? object.length : undefined;
	      return result || (
	        !!length && isLength(length) && isIndex(path, length) &&
	        (isArray(object) || isString(object) || isArguments(object))
	      );
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (isFunction(object.constructor) && !isPrototype(object))
	        ? baseCreate(getPrototypeOf(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Creates an array of index keys for `object` values of arrays,
	     * `arguments` objects, and strings, otherwise `null` is returned.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array|null} Returns index keys, else `null`.
	     */
	    function indexKeys(object) {
	      var length = object ? object.length : undefined;
	      if (isLength(length) &&
	          (isArray(object) || isString(object) || isArguments(object))) {
	        return baseTimes(length, String);
	      }
	      return null;
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (typeof value == 'number') {
	        return true;
	      }
	      return !isArray(value) &&
	        (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	          (object != null && value in Object(object)));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return type == 'number' || type == 'boolean' ||
	        (type == 'string' && value != '__proto__') || value == null;
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (isFunction(Ctor) && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * modify function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * combined case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	        ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = copyArray(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	      }
	      return objValue;
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    function stringToPath(string) {
	      var result = [];
	      toString(string).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=0] The length of each chunk.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size) {
	      size = nativeMax(toInteger(size), 0);
	
	      var length = array ? array.length : 0;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var concat = rest(function(array, values) {
	      if (!isArray(array)) {
	        array = array == null ? [] : [Object(array)];
	      }
	      values = baseFlatten(values, 1);
	      return arrayConcat(array, values);
	    });
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * given arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([3, 2, 1], [4, 2]);
	     * // => [3, 1]
	     */
	    var difference = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
	     * // => [3.1, 1.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = rest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true), getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = rest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3))
	        : -1;
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate) {
	      return (array && array.length)
	        ? baseFindIndex(array, getIteratee(predicate, 3), true)
	        : -1;
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs ? pairs.length : 0,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	     * from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      fromIndex = toInteger(fromIndex);
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return baseIndexOf(array, value, fromIndex);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     *
	     * _.intersection([2, 1], [4, 2], [1, 2]);
	     * // => [2]
	     */
	    var intersection = rest(function(arrays) {
	      var mapped = arrayMap(arrays, baseCastArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = rest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = rest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	      if (comparator === last(mapped)) {
	        comparator = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array ? nativeJoin.call(array, separator) : '';
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = (index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1)) + 1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    var pull = rest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pullAll(array, [2, 3]);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAllBy(array, values, getIteratee(iteratee))
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = rest(function(array, indexes) {
	      indexes = arrayMap(baseFlatten(indexes, 1), String);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(compareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array ? nativeReverse.call(array) : array;
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of [`Array#slice`](https://mdn.io/Array/slice)
	     * to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 5], 4);
	     * // => 0
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
	     *
	     * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([1, 1, 2, 2], 2);
	     * // => 2
	     */
	    function sortedIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5], 4);
	     * // => 1
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted into `array`.
	     * @example
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([1, 1, 2, 2], 2);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array ? array.length : 0;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniqBy(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with three
	     * arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2, 1], [4, 2], [1, 2]);
	     * // => [2, 1, 4]
	     */
	    var union = rest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [2.1, 1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, true), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length)
	        ? baseUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseUniq(array, getIteratee(iteratee))
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      return (array && array.length)
	        ? baseUniq(array, undefined, comparator)
	        : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = rest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([2, 1], [4, 2]);
	     * // => [1, 4]
	     */
	    var xor = rest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by which
	     * uniqueness is computed. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	     * // => [1.2, 4.3]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = rest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The comparator is invoked with
	     * two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = rest(function(arrays) {
	      var comparator = last(arrays);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = rest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property names and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} [props=[]] The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} [props=[]] The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = rest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method chaining enabled.
	     * The result of such method chaining must be unwrapped with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     *
	     * _(['a', 'b', 'c']).at(0, 2).value();
	     * // => ['a', 'c']
	     */
	    var wrapperAt = rest(function(paths) {
	      paths = baseFlatten(paths, 1);
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * This method is the wrapper version of `_.flatMap`.
	     *
	     * @name flatMap
	     * @memberOf _
	     * @category Seq
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _([1, 2]).flatMap(duplicate).value();
	     * // => [1, 1, 2, 2]
	     */
	    function wrapperFlatMap(iteratee) {
	      return this.map(iteratee).flatten();
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    function find(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEach);
	    }
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    function findLast(collection, predicate) {
	      predicate = getIteratee(predicate, 3);
	      if (isArray(collection)) {
	        var index = baseFindIndex(collection, predicate, true);
	        return index > -1 ? collection[index] : undefined;
	      }
	      return baseFind(collection, predicate, baseEachRight);
	    }
	
	    /**
	     * Creates an array of flattened values by running each element in `collection`
	     * through `iteratee` and concating its result to the other mapped values.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior use `_.forIn` or `_.forOwn`
	     * for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(value) {
	     *   console.log(value);
	     * });
	     * // => logs `1` then `2`
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' then 'b' (iteration order is not guaranteed)
	     */
	    function forEach(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEach(collection, iteratee)
	        : baseEach(collection, baseCastFunction(iteratee));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => logs `2` then `1`
	     */
	    function forEachRight(collection, iteratee) {
	      return (typeof iteratee == 'function' && isArray(collection))
	        ? arrayEachRight(collection, iteratee)
	        : baseEachRight(collection, baseCastFunction(iteratee));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of elements responsible for generating the key.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string it's checked
	     * for a substring of `value`, otherwise [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it's
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = rest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
	     * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
	     * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
	     * and `words`
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} [iteratees=[_.identity]] The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getIteratee(predicate, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var array = isArrayLike(collection) ? collection : values(collection),
	          length = array.length;
	
	      return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=0] The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n) {
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = baseClamp(toInteger(n), 0, length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sampleSize(collection, MAX_ARRAY_LENGTH);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        var result = collection.length;
	        return (result && isString(collection)) ? stringSize(collection) : result;
	      }
	      return keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by, specified individually or in arrays.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, function(o) { return o.user; });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.sortBy(users, 'user', function(o) {
	     *   return Math.floor(o.age / 10);
	     * });
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortBy = rest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees.length = 1;
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @type {Function}
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = Date.now;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = rest(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bind));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = rest(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getPlaceholder(bindKey));
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide an options object to indicate whether `func` should be invoked on
	     * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent calls
	     * to the debounced function return the result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it's invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          leading = false,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        args = maxTimeoutId = thisArg = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function flush() {
	        if ((timeoutId && trailingCall) || (maxTimeoutId && trailing)) {
	          result = func.apply(thisArg, args);
	        }
	        cancel();
	        return result;
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!lastCalled && !maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled);
	
	          var isCalled = (remaining <= 0 || remaining > maxWait) &&
	            (leading || maxTimeoutId);
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => logs 'deferred' after one or more milliseconds
	     */
	    var defer = rest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = rest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrapper(func, FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with arguments transformed by
	     * corresponding `transforms`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = rest(function(func, transforms) {
	      transforms = arrayMap(baseFlatten(transforms, 1), getIteratee());
	
	      var funcsLength = transforms.length;
	      return rest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partial));
	      return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = rest(function(func, partials) {
	      var holders = replaceHolders(partials, getPlaceholder(partialRight));
	      return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified individually or in arrays.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = rest(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, array);
	          case 1: return func.call(this, args[0], array);
	          case 2: return func.call(this, args[0], args[1], array);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = array;
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	      return rest(function(args) {
	        var array = args[start],
	            otherArgs = args.slice(0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide an options object to indicate whether
	     * `func` should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return partial(wrapper, value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      return baseClone(value, false, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, true);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      return baseClone(value, true, customizer);
	    }
	
	    /**
	     * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	      return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	        (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @type {Function}
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    function isArrayBuffer(value) {
	      return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	    }
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null &&
	        !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && objectToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = !Buffer ? constant(false) : function(value) {
	      return value instanceof Buffer;
	    };
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objectToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it's an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (isArrayLike(value) &&
	          (isArray(value) || isString(value) ||
	            isFunction(value.splice) || isArguments(value))) {
	        return !value.length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are **not** supported.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined` comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      return (objectToString.call(value) == errorTag) ||
	        (typeof value.message == 'string' && typeof value.name == 'string');
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MAX_VALUE);
	     * // => true
	     *
	     * _.isFinite(3.14);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 8 which returns 'object' for typed array constructors, and
	      // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	      var tag = isObject(value) ? objectToString.call(value) : '';
	      return tag == funcTag || tag == genTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return !!value && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    function isMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values. This method is
	     * equivalent to a `_.matches` function when `source` is partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined` comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(funcToString.call(value));
	      }
	      return isObjectLike(value) &&
	        (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && objectToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) ||
	          objectToString.call(value) != objectTag || isHostObject(value)) {
	        return false;
	      }
	      var proto = getPrototypeOf(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = proto.constructor;
	      return (typeof Ctor == 'function' &&
	        Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objectToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    function isSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && objectToString.call(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (iteratorSymbol && value[iteratorSymbol]) {
	        return iteratorToArray(value[iteratorSymbol]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This function is loosely based on [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3');
	     * // => 3
	     */
	    function toInteger(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      var remainder = value % 1;
	      return value === value ? (remainder ? value - remainder : value) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3);
	     * // => 3
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3');
	     * // => 3
	     */
	    function toNumber(value) {
	      if (isObject(value)) {
	        var other = isFunction(value.valueOf) ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	    }
	
	    /**
	     * Converts `value` to a string if it's not one. An empty string is returned
	     * for `null` and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (value == null) {
	        return '';
	      }
	      if (isSymbol(value)) {
	        return Symbol ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable properties of source objects to the destination
	     * object. Source objects are applied from left to right. Subsequent sources
	     * overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.c = 3;
	     * }
	     *
	     * function Bar() {
	     *   this.e = 5;
	     * }
	     *
	     * Foo.prototype.d = 4;
	     * Bar.prototype.f = 6;
	     *
	     * _.assign({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3, 'e': 5 }
	     */
	    var assign = createAssigner(function(object, source) {
	      copyObject(source, keys(source), object);
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * function Bar() {
	     *   this.d = 4;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     * Bar.prototype.e = 5;
	     *
	     * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer` which
	     * is invoked to produce the assigned values. If `customizer` returns `undefined`
	     * assignment is handled by the method instead. The `customizer` is invoked
	     * with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer` which
	     * is invoked to produce the assigned values. If `customizer` returns `undefined`
	     * assignment is handled by the method instead. The `customizer` is invoked
	     * with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObjectWith(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths of elements to pick,
	     *  specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     *
	     * _.at(['a', 'b', 'c'], 0, 2);
	     * // => ['a', 'c']
	     */
	    var at = rest(function(object, paths) {
	      return baseAt(object, baseFlatten(paths, 1));
	    });
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a `properties`
	     * object is given its own enumerable properties are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own and inherited enumerable properties of source objects to the
	     * destination object for all destination properties that resolve to `undefined`.
	     * Source objects are applied from left to right. Once a property is set,
	     * additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = rest(function(args) {
	      args.push(undefined, assignInDefaults);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = rest(function(args) {
	      args.push(undefined, mergeDefaults);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwn, true);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFind(object, getIteratee(predicate, 3), baseForOwnRight, true);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The iteratee is invoked with three arguments:
	     * (value, key, object). Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', then 'c' (iteration order is not guaranteed)
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, baseCastFunction(iteratee), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, baseCastFunction(iteratee), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The iteratee is invoked with three arguments:
	     * (value, key, object). Iteratee functions may exit iteration early by
	     * explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' then 'b' (iteration order is not guaranteed)
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, baseCastFunction(iteratee));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, baseCastFunction(iteratee));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     * var other = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b.c');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b', 'c']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` through `iteratee`.
	     * The corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = rest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      var isProto = isPrototype(object);
	      if (!(isProto || isArrayLike(object))) {
	        return baseKeys(object);
	      }
	      var indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      for (var key in object) {
	        if (baseHas(object, key) &&
	            !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(isProto && key == 'constructor')) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      var index = -1,
	          isProto = isPrototype(object),
	          props = baseKeysIn(object),
	          propsLength = props.length,
	          indexes = indexKeys(object),
	          skipIndexes = !!indexes,
	          result = indexes || [],
	          length = result.length;
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`. The iteratee is invoked with
	     * three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[iteratee(value, key, object)] = value;
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee is invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        result[key] = iteratee(value, key, object);
	      });
	      return result;
	    }
	
	    /**
	     * Recursively merges own and inherited enumerable properties of source objects
	     * into the destination object. Source properties that resolve to `undefined`
	     * are skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined` merging is handled by the
	     * method instead. The `customizer` is invoked with seven arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property names to omit, specified
	     *  individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = rest(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      props = arrayMap(baseFlatten(props, 1), String);
	      return basePick(object, baseDifference(keysIn(object), props));
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable properties of `object` that `predicate`
	     * doesn't return truthy for. The predicate is invoked with two arguments:
	     * (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      predicate = getIteratee(predicate);
	      return basePickBy(object, function(value, key) {
	        return !predicate(value, key);
	      });
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [props] The property names to pick, specified
	     *  individually or in arrays.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = rest(function(object, props) {
	      return object == null ? {} : basePick(object, baseFlatten(props, 1));
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      return object == null ? {} : basePickBy(object, getIteratee(predicate));
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it's invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      if (!isKey(path, object)) {
	        path = baseCastPath(path);
	        var result = get(object, path);
	        object = parent(object, path);
	      } else {
	        result = object == null ? undefined : object[path];
	      }
	      if (result === undefined) {
	        result = defaultValue;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.setWith({ '0': { 'length': 2 } }, '[0][1][2]', 3, Object);
	     * // => { '0': { '1': { '2': 3 }, 'length': 2 } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable key-value pairs for `object` which
	     * can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    function toPairs(object) {
	      return baseToPairs(object, keys(object));
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable key-value pairs for
	     * `object` which can be consumed by `_.fromPairs`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
	     */
	    function toPairsIn(object) {
	      return baseToPairs(object, keysIn(object));
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The iteratee is invoked with four arguments:
	     * (accumulator, value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getIteratee(iteratee, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = isFunction(Ctor) ? baseCreate(getPrototypeOf(object)) : {};
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object ? baseValues(object, keys(object)) : [];
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toNumber(start) || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toNumber(end) || 0;
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are floats,
	     * a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toNumber(lower) || 0;
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toNumber(upper) || 0;
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = typeof target == 'string' ? target : (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in IE < 9, they can break out of
	     * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = stringSize(string);
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      return createPadding('', leftLength, chars) + string + createPadding('', rightLength, chars);
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      return string + createPadding(string, length, chars);
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      return createPadding(string, length, chars) + string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#x15.1.2.2)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = toString(string).replace(reTrim, '');
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      string = toString(string);
	      n = toInteger(n);
	
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the new array of string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      return toString(string).split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + capitalize(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = baseClamp(toInteger(position), 0, string.length);
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, assignInDefaults);
	
	      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar');
	     * // => '--foo-bar'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar');
	     * // => '--FOO-BAR'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrim, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars);
	
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimEnd, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1)
	        .join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard || chars === undefined) {
	        return string.replace(reTrimStart, '');
	      }
	      chars = (chars + '');
	      if (!chars) {
	        return string;
	      }
	      var strSymbols = stringToArray(string);
	      return strSymbols
	        .slice(charsStartIndex(strSymbols, stringToArray(chars)))
	        .join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options=({})] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? toString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (reHasComplexSymbol.test(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? strSymbols.slice(0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = rest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind,
	     *  specified individually or in arrays.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, 'onClick');
	     * jQuery(element).on('click', view.onClick);
	     * // => logs 'clicked docs' when clicked
	     */
	    var bindAll = rest(function(object, methodNames) {
	      arrayEach(baseFlatten(methodNames, 1), function(key) {
	        object[key] = bind(object[key], object);
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` invoking the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.constant(true),                _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs ? pairs.length : 0,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return rest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument given to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name the created callback returns the
	     * property value for a given element. If `func` is an object the created
	     * callback returns `true` for elements that contain the equivalent object
	     * properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(callback, func) {
	     *   var p = /^(\S+)\s*([<>])\s*(\S+)$/.exec(func);
	     *   return !p ? callback(func) : function(object) {
	     *     return (p[2] == '>' ? object[p[1]] > p[3] : object[p[1]] < p[3]);
	     *   };
	     * });
	     *
	     * _.filter(users, 'age > 36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`. The created function is equivalent to
	     * `_.isMatch` with a `source` partially applied.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** This method supports comparing the same values as `_.isEqual`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invokeMap(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = rest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = rest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = (isObject(options) && 'chain' in options) ? options.chain : true,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns its nth argument.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     *
	     * func('a', 'b', 'c');
	     * // => 'b'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return function() {
	        return arguments[n];
	      };
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments provided
	     * to the created function and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} iteratees The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over(Math.max, Math.min);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments provided to the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments provided to the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} predicates The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome(Boolean, isFinite);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(true));
	     * // => [true, true, true, true]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = baseCastFunction(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     *
	     * var path = ['a', 'b', 'c'],
	     *     newPath = _.toPath(path);
	     *
	     * console.log(newPath);
	     * // => ['a', 'b', 'c']
	     *
	     * console.log(path === newPath);
	     * // => false
	     */
	    function toPath(value) {
	      return isArray(value) ? arrayMap(value, String) : stringToPath(value);
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      var result;
	      if (augend === undefined && addend === undefined) {
	        return 0;
	      }
	      if (augend !== undefined) {
	        result = augend;
	      }
	      if (addend !== undefined) {
	        result = result === undefined ? addend : (result + addend);
	      }
	      return result;
	    }
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey
	     * `undefined` is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, gt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), gt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return sum(array) / (array ? array.length : 0);
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey
	     * `undefined` is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, lt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee), lt)
	        : undefined;
	    }
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    function subtract(minuend, subtrahend) {
	      var result;
	      if (minuend === undefined && subtrahend === undefined) {
	        return 0;
	      }
	      if (minuend !== undefined) {
	        result = minuend;
	      }
	      if (subtrahend !== undefined) {
	        result = result === undefined ? subtrahend : (result - subtrahend);
	      }
	      return result;
	    }
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Avoid inheriting from `Object.prototype` when possible.
	    Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	    // Add functions to the `MapCache`.
	    MapCache.prototype.clear = mapClear;
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `SetCache`.
	    SetCache.prototype.push = cachePush;
	
	    // Add functions to the `Stack` cache.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = rest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      predicate = getIteratee(predicate, 3);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.flatMap = wrapperFlatMap;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    if (iteratorSymbol) {
	      lodash.prototype[iteratorSymbol] = wrapperToIterator;
	    }
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Expose lodash on the free variable `window` or `self` when available. This
	  // prevents errors in cases where lodash is loaded by a script tag in the presence
	  // of an AMD loader. See http://requirejs.org/docs/errors.html#mismatch for more details.
	  (freeWindow || freeSelf || {})._ = _;
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(226)(module), (function() { return this; }())))

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    mui = __webpack_require__(12),
	    ContentUtils = __webpack_require__(7),
	    _require = __webpack_require__(37),
	    delay = _require.delay,
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    filter = _require2.filter,
	    includes = _require2.includes,
	    every = _require2.every,
	    find = _require2.find,
	    _require3 = __webpack_require__(79),
	    capitalize = _require3.capitalize,
	    toLower = _require3.toLower,
	    trim = _require3.trim,
	    sortBy = __webpack_require__(8).sortBy,
	    get = __webpack_require__(5).get,
	    PositionUtil = __webpack_require__(59),
	    Table = mui.Table,
	    TableHeader = mui.TableHeader,
	    TableRow = mui.TableRow,
	    TableHeaderColumn = mui.TableHeaderColumn,
	    TableBody = mui.TableBody,
	    TableRowColumn = mui.TableRowColumn,
	    TextField = mui.TextField,
	    FontIcon = mui.FontIcon;
	
	
	var HeaderAppAndHeaderScaffoldingAndHeaderTable = 365;
	
	var AdminScaffoldingTable = React.createClass({ displayName: "AdminScaffoldingTable",
	    propTypes: {
	        children: PropTypes.array,
	        headerActiveFilters: PropTypes.array,
	        columnNames: PropTypes.array,
	        displayAttributes: PropTypes.array,
	        isRowSelected: PropTypes.bool,
	        allowShowDisable: PropTypes.bool,
	        attributeId: PropTypes.string,
	        onRowSelection: PropTypes.func,
	        sortByColumn: PropTypes.array,
	        value: PropTypes.any,
	        customHeightTable: PropTypes.number
	    },
	
	    _isRowSelected: function _isRowSelected(item) {
	        var value = this.props.value;
	
	        return item.id === get(value, 'id', '-1');
	    },
	
	
	    _lastRowScrollPosition: null,
	
	    getInitialState: function getInitialState() {
	        return {
	            filters: []
	        };
	    },
	    _onRowSelection: function _onRowSelection(onRowSelection, items, indexRowSelected) {
	        var _props = this.props,
	            sortByColumn = _props.sortByColumn,
	            allowShowDisable = _props.allowShowDisable;
	
	
	        if (sortByColumn) {
	            items = sortBy(items, function (row) {
	                return toLower(get(row, sortByColumn, []));
	            });
	        }
	
	        items = this._applyFiltersIfNeeded(items);
	
	        if (!allowShowDisable) {
	            // filter disable items
	            items = ContentUtils.filterEnable(items);
	        }
	
	        // delay selection row a little bit in order to give some
	        // time finish the selection table animation.
	        var itemSelected = items[indexRowSelected];
	        var indexRowSelectedItem = get(indexRowSelected, '0');
	        var _lastRowClickedPosition = this._lastRowScrollPosition;
	
	        var filterTargets = this._getFiltersTarget();
	
	        delay(function () {
	            onRowSelection(itemSelected, indexRowSelectedItem, _lastRowClickedPosition, filterTargets);
	        }, 50);
	    },
	    _onPreRowSelection: function _onPreRowSelection(evt) {
	        if (evt && evt.pageY) {
	            // save temporally the last position which
	            // had the table in order to return this
	            // position when the consumer refresh the
	            // scroll position
	            var parentScroll = PositionUtil.getParentScroll(evt.target);
	            this._lastRowScrollPosition = parentScroll.scrollTop;
	        }
	    },
	    _addFilter: function _addFilter(name, evt) {
	        var _this = this;
	
	        var match = get(evt, 'target.value');
	
	        this.setState(function (prevState) {
	            var newFilter = {
	                name: name,
	                match: match
	            };
	            return {
	                filters: ContentUtils.replace(ContentUtils.isNotEmptyArray(prevState.filters) ? prevState.filters : _this.props.headerActiveFilters, newFilter, 'name')
	            };
	        });
	    },
	    _applyFiltersIfNeeded: function _applyFiltersIfNeeded(rows) {
	        var filterTarget = this._getFiltersTarget();
	        var userWroteSomeFilter = !ContentUtils.isEmptyArray(filterTarget);
	        var existsSomeRowToDisplay = !ContentUtils.isEmptyArray(rows);
	
	        if (userWroteSomeFilter && existsSomeRowToDisplay) {
	            return filter(rows, function (row) {
	                var applySomeFilter = every(filterTarget, function (filter) {
	                    var rowValue = get(row, filter.name, '');
	                    var matcher = toLower(trim(filter.match));
	                    var value = toLower(trim(rowValue));
	                    return value.indexOf(matcher) > -1;
	                });
	                return applySomeFilter;
	            });
	        }
	
	        return rows;
	    },
	
	
	    /**
	     * Retrieve the current filter which the current user are using.
	     * @return {*}
	     * @private
	     */
	    _getFiltersTarget: function _getFiltersTarget() {
	        var filters = this.state.filters;
	        var headerActiveFilters = this.props.headerActiveFilters;
	
	
	        var filterTarget = void 0;
	        var isInternalFilterNotDefined = !filters || filters.length == 0;
	
	        if (isInternalFilterNotDefined) {
	            filterTarget = headerActiveFilters;
	        } else {
	            filterTarget = filters || [];
	        }
	
	        return filterTarget;
	    },
	    _getHeaderColumns: function _getHeaderColumns() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            columnNames = _props2.columnNames,
	            displayAttributes = _props2.displayAttributes,
	            filteredColumns = _props2.filteredColumns;
	
	
	        return map(displayAttributes, function (columnField, index) {
	            var columnDisplay = get(columnNames, index, columnField);
	            var activeFilter = find(ContentUtils.isNotEmptyArray(_this2.state.filters) ? _this2.state.filters : _this2.props.headerActiveFilters, function (activeFilter) {
	                return activeFilter.name == columnField;
	            });
	            var isNeededFilter = includes(filteredColumns, columnField);
	            var columnDisplayUpper = capitalize(columnDisplay);
	
	            var classNameHeaderFilter = 'admin-table-header__filter';
	            var classNameHeaderFilterIcon = 'material-icons admin-table-header__icon';
	
	            var containText = !!get(activeFilter, 'match');
	            if (containText) {
	                classNameHeaderFilter = classNameHeaderFilter.concat(' is-active');
	                classNameHeaderFilterIcon = classNameHeaderFilterIcon.concat(' is-active');
	            }
	
	            return React.createElement(TableHeaderColumn, {
	                className: "header-tank-column",
	                style: { paddingLeft: '8px' }
	            }, isNeededFilter ? React.createElement("div", null, React.createElement(FontIcon, {
	                color: { color: '#e0e0e0' },
	                className: classNameHeaderFilterIcon
	            }, "search"), React.createElement(TextField, {
	                onBlur: _this2._addFilter.bind(_this2, columnField),
	                onChange: _this2._addFilter.bind(_this2, columnField),
	                floatingLabelText: columnDisplayUpper,
	                className: classNameHeaderFilter,
	                defaultValue: activeFilter ? get(activeFilter, 'match') : ''
	            })) : columnDisplayUpper);
	        });
	    },
	    _getTableRowContent: function _getTableRowContent(item, attributeDisplay) {
	        var haveHTMLValue = !!attributeDisplay.getHTML;
	        var haveAttributeName = !!attributeDisplay.name;
	
	        if (!haveHTMLValue) {
	            return get(item, attributeDisplay.name);
	        } else if (haveHTMLValue && haveAttributeName) {
	            var value = get(item, attributeDisplay.name);
	            return attributeDisplay.getHTML(value);
	        } else if (haveHTMLValue && !haveAttributeName) {
	            return attributeDisplay.getHTML(item);
	        } else {
	            return item;
	        }
	    },
	    _getRows: function _getRows(sortedChildren) {
	        var _this3 = this;
	
	        var displayAttributes = this.props.displayAttributes;
	
	        var self = this;
	
	        var rowsEl = map(sortedChildren, function (item) {
	            var columnsEl = map(displayAttributes, function (attributeDisplay) {
	                var rowEl = void 0;
	                if (typeof attributeDisplay === 'string') {
	                    rowEl = React.createElement(TableRowColumn, {
	                        style: { opacity: item.enable === false ? '.5' : '1' },
	                        onClickCapture: _this3._onPreRowSelection
	                    }, get(item, attributeDisplay, ''));
	                } else {
	                    rowEl = React.createElement(TableRowColumn, {
	                        style: { opacity: item.enable === false ? '.5' : '1' },
	                        onClickCapture: _this3._onPreRowSelection
	                    }, _this3._getTableRowContent(item, attributeDisplay));
	                }
	                return rowEl;
	            });
	            var isSelectedRow = self._isRowSelected(item);
	            var tableRowClassName = 'admin-table-row';
	            if (isSelectedRow) {
	                tableRowClassName += ' is-selected';
	            }
	
	            var attributeId = get(item, 'attributeId') || get(item, 'id');
	
	            return React.createElement(TableRow, {
	                className: tableRowClassName,
	                style: { cursor: 'pointer' },
	                selected: isSelectedRow,
	                "data-row-id": attributeId
	            }, columnsEl);
	        });
	
	        return rowsEl;
	    },
	    render: function render() {
	        var _props3 = this.props,
	            onRowSelection = _props3.onRowSelection,
	            children = _props3.children,
	            sortByColumn = _props3.sortByColumn,
	            allowShowDisable = _props3.allowShowDisable;
	
	        var sortedChildren = void 0;
	
	        if (sortByColumn) {
	            sortedChildren = sortBy(children, function (row) {
	                return toLower(get(row, sortByColumn, ''));
	            });
	        }
	
	        var rowsFiltered = this._applyFiltersIfNeeded(sortedChildren || children);
	
	        var rowsWithoutDisabledItems = allowShowDisable ? rowsFiltered : filterDisabledItems(rowsFiltered);
	        var rowsEl = this._getRows(rowsWithoutDisabledItems || children);
	        var columnsHeaderEl = this._getHeaderColumns();
	        return React.createElement("div", { className: "admin-scaffolding-table" }, React.createElement(Table, {
	            className: "admin-table",
	            selectable: true,
	            fixedHeader: true,
	            multiSelectable: false,
	            deselectOnClickaway: false,
	            preScanRowData: false,
	            onRowSelection: this._onRowSelection.bind(this, onRowSelection, children)
	        }, React.createElement(TableHeader, {
	            displayRowCheckbox: false,
	            className: "admin-table-header",
	            style: { backgroundColor: '#838485' }
	        }, React.createElement(TableRow, {
	            className: "admin-table-header-row",
	            displayRowCheckbox: false
	        }, columnsHeaderEl)), React.createElement(TableBody, {
	            className: "admin-table-body",
	            displayRowCheckbox: false,
	            deselectOnClickaway: false
	        }, rowsEl)));
	    }
	});
	
	function filterDisabledItems(items) {
	    // the items which dont have `enable` field for now, we take as enable.
	    return filter(items, function (item) {
	        return item.enable === undefined || item.enable === true;
	    });
	}
	
	module.exports = AdminScaffoldingTable;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Dispatcher = __webpack_require__(812).Dispatcher;
	
	module.exports = new Dispatcher();

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(191),
	    isArguments = __webpack_require__(144),
	    isArray = __webpack_require__(27),
	    isArrayLikeObject = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && isArrayLikeObject(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	"use strict";
	
	var canUseDOM = !!(
	  (typeof window !== 'undefined' &&
	  window.document && window.document.createElement)
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'chunk': __webpack_require__(914),
	  'compact': __webpack_require__(919),
	  'concat': __webpack_require__(920),
	  'difference': __webpack_require__(931),
	  'differenceBy': __webpack_require__(932),
	  'differenceWith': __webpack_require__(933),
	  'drop': __webpack_require__(482),
	  'dropRight': __webpack_require__(483),
	  'dropRightWhile': __webpack_require__(934),
	  'dropWhile': __webpack_require__(935),
	  'fill': __webpack_require__(943),
	  'findIndex': __webpack_require__(946),
	  'findLastIndex': __webpack_require__(949),
	  'flatten': __webpack_require__(952),
	  'flattenDeep': __webpack_require__(953),
	  'flattenDepth': __webpack_require__(954),
	  'fromPairs': __webpack_require__(963),
	  'head': __webpack_require__(968),
	  'indexOf': __webpack_require__(970),
	  'initial': __webpack_require__(971),
	  'intersection': __webpack_require__(972),
	  'intersectionBy': __webpack_require__(973),
	  'intersectionWith': __webpack_require__(974),
	  'join': __webpack_require__(999),
	  'last': __webpack_require__(62),
	  'lastIndexOf': __webpack_require__(1002),
	  'pull': __webpack_require__(1039),
	  'pullAll': __webpack_require__(499),
	  'pullAllBy': __webpack_require__(1040),
	  'pullAt': __webpack_require__(1041),
	  'remove': __webpack_require__(1048),
	  'reverse': __webpack_require__(1051),
	  'slice': __webpack_require__(1058),
	  'sortedIndex': __webpack_require__(1062),
	  'sortedIndexBy': __webpack_require__(1063),
	  'sortedIndexOf': __webpack_require__(1064),
	  'sortedLastIndex': __webpack_require__(1065),
	  'sortedLastIndexBy': __webpack_require__(1066),
	  'sortedLastIndexOf': __webpack_require__(1067),
	  'sortedUniq': __webpack_require__(1068),
	  'sortedUniqBy': __webpack_require__(1069),
	  'tail': __webpack_require__(1076),
	  'take': __webpack_require__(1077),
	  'takeRight': __webpack_require__(1078),
	  'takeRightWhile': __webpack_require__(1079),
	  'takeWhile': __webpack_require__(1080),
	  'union': __webpack_require__(1096),
	  'unionBy': __webpack_require__(1097),
	  'unionWith': __webpack_require__(1098),
	  'uniq': __webpack_require__(1099),
	  'uniqBy': __webpack_require__(1100),
	  'uniqWith': __webpack_require__(1101),
	  'unzip': __webpack_require__(357),
	  'unzipWith': __webpack_require__(509),
	  'without': __webpack_require__(1105),
	  'xor': __webpack_require__(1108),
	  'xorBy': __webpack_require__(1109),
	  'xorWith': __webpack_require__(1110),
	  'zip': __webpack_require__(1111),
	  'zipObject': __webpack_require__(1112),
	  'zipObjectDeep': __webpack_require__(1113),
	  'zipWith': __webpack_require__(1114)
	};


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = __webpack_require__(40),
	    moment = __webpack_require__(3),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ChronologycStore = __webpack_require__(76),
	    BrewhouseStore = __webpack_require__(96),
	    ContentUtils = __webpack_require__(7),
	    DashboardServiceCache = __webpack_require__(28),
	    NumberUtils = __webpack_require__(23),
	    DateUtils = __webpack_require__(22),
	    DashboardModalUtils = __webpack_require__(50),
	    Notification = __webpack_require__(21),
	    Constants = __webpack_require__(2);
	
	
	var OrderUtils = {
	
	    /**
	     * Retrieve the amount of days of difference from old position to new position.
	     * @param positionOld
	     * @param positionNew
	     * @return {number}
	     */
	    getVerticalOffeset: function getVerticalOffeset(positionOld, positionNew) {
	        if (positionOld && positionNew) {
	            if (positionNew.y && positionOld.y) {
	                return +positionNew.y - +positionOld.y;
	            } else {
	                if (positionNew.isSingle) {
	                    var positionOldY = ChronologycStore.getYFromDate(_.get(positionOld.fromDate));
	                    var positionNewY = ChronologycStore.getYFromDate(_.get(positionNew.fromDate));
	                    return positionNewY - positionOldY;
	                } else {
	                    var _positionOldY = ChronologycStore.getYFromDate(_.get(positionOld.brewDate));
	                    var _positionNewY = ChronologycStore.getYFromDate(_.get(positionNew.brewDate));
	                    return _positionNewY - _positionOldY;
	                }
	            }
	        }
	    },
	
	
	    /**
	     * Check all dates of the order if are properly assigned.
	     * @param {Object} order the order to be validated
	     */
	    checkDateOfOrder: function checkDateOfOrder(order) {
	
	        if (_.get(order, 'isSingle')) {
	            return true;
	        }
	
	        if (DateUtils.isEqual(_.get(order, 'brewDate'), _.get(order, 'filtrationDate'))) {
	            Notification.show(t('dashboard_notification_brew_date_be_before_transfer_date'));
	            return false;
	        }
	
	        if (DateUtils.isEqual(_.get(order, 'brewDate'), _.get(order, 'orderDate'))) {
	            Notification.show(t('dashboard_notification_brew_date_must_be_different_as_packaging_date'));
	            return false;
	        }
	
	        if (DateUtils.isAfter(_.get(order, 'brewDate'), _.get(order, 'filtrationDate'))) {
	            Notification.show(t('dashboard_notification_brew_date_must_be_different_as_transfer_date'));
	            return false;
	        }
	
	        if (DateUtils.isAfter(_.get(order, 'brewDate'), _.get(order, 'orderDate'))) {
	            Notification.show(t('dashboard_notification_brew_date_must_be_before_packaging_date'));
	            return false;
	        }
	
	        if (DateUtils.isBefore(_.get(order, 'filtrationDate'), _.get(order, 'brewDate'))) {
	            Notification.show(t('dashboard_notification_transfer_date_must_be_after_brew_date'));
	            return false;
	        }
	
	        if (DateUtils.isAfter(_.get(order, 'filtrationDate'), _.get(order, 'orderDate'))) {
	            Notification.show(t('dashboard_notification_transfer_date_must_be_before_order_date'));
	            return false;
	        }
	
	        if (DateUtils.isBefore(_.get(order, 'orderDate'), _.get(order, 'brewDate'))) {
	            Notification.show(t('dashboard_notification_order_date_must_after_brew_date'));
	            return false;
	        }
	
	        if (DateUtils.isBefore(_.get(order, 'orderDate'), _.get(order, 'filtrationDate'))) {
	            Notification.show(t('dashboard_notification_packaging_date_must_be_same_or_after_transfer_date'));
	        }
	
	        return true;
	    },
	    isAlreadyPerformedGivenPosition: function isAlreadyPerformedGivenPosition() {
	        var positionPerformedIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var position = arguments[1];
	
	        return _.includes(positionPerformedIds, position.i);
	    },
	    isDirectionTop: function isDirectionTop(order) {
	        var isDirectionTop;
	
	        if (!order) {
	            return null;
	        }
	
	        var tasksTarget = _.filter(_.union(order.packagingTasks, order.fermenterTasks), function (task) {
	            return _.indexOf([Constants.BREW_TASK, Constants.FILTRATION_TASK, Constants.PACKAGING_TASK], task.type) > -1;
	        });
	
	        _.forEach(tasksTarget, function (task) {
	            if (task.type === Constants.BREW_TASK && _.get(order, 'brewDate') !== task.date) {
	                isDirectionTop = DateUtils.isBefore(_.get(order, 'brewDate'), task.date);
	                return;
	            }
	            if (task.type === Constants.FILTRATION_TASK && _.get(order, 'filtrationDate') !== task.date) {
	                isDirectionTop = DateUtils.isBefore(_.get(order, 'filtrationDate'), task.date);
	                return;
	            }
	            if (task.type === Constants.PACKAGING_TASK && _.get(order, 'orderDate') !== task.date) {
	                isDirectionTop = DateUtils.isBefore(_.get(order, 'orderDate'), task.date);
	                return;
	            }
	        });
	
	        return isDirectionTop;
	    },
	    getOrderAfterOrEqualDate: function getOrderAfterOrEqualDate(date) {
	        var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getOrders();
	
	        return _.filter(orders, function (order) {
	            if (_.get(order, 'isSingle')) {
	                return DateUtils.isAfterOrEquals(_.get(order, 'fromDate'), date);
	            } else {
	                return DateUtils.isAfterOrEquals(_.get(order, 'brewDate'), date);
	            }
	        });
	    },
	    updateOrder: function updateOrder() {
	        var orders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var newOrder = arguments[1];
	
	        var filteredOrders = _.filter(orders, function (order) {
	            return _.get(order, 'id') !== _.get(newOrder, 'id');
	        }) || [];
	        filteredOrders.push(newOrder);
	        return filteredOrders;
	    },
	    getAllSortedTasksFromOrders: function getAllSortedTasksFromOrders(orders) {
	        var allBrewingTasks = [];
	        var allRemainderTasks = [];
	
	        // get all task from all orders
	        if (ContentUtils.isNotEmptyArray(orders)) {
	            for (var _iterator = orders, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var order = _ref;
	
	                var orderTasks = this.getTaskFromOrder(order);
	                var allTasks = _.filter(orderTasks, function (task) {
	                    return task;
	                }); // remove undefined positions
	                var brewingTasks = _.filter(allTasks, function (task) {
	                    return task.turn;
	                }); // filter all brewing task
	                var remainderTasks = _.filter(allTasks, function (task) {
	                    return !task.turn;
	                }); // filter all brewing task
	
	                allBrewingTasks = allBrewingTasks.concat(brewingTasks);
	                allRemainderTasks = allRemainderTasks.concat(remainderTasks);
	            }
	        }
	
	        // filter task which have product and after to day
	        var remainderTasksWithProducts = _.filter(allRemainderTasks, function (task) {
	            return ContentUtils.isNotEmptyArray(_.get(task, 'products'));
	        });
	        var brewingTaskWithProducts = _.filter(allBrewingTasks, function (task) {
	            return ContentUtils.isNotEmptyArray(_.get(task, 'products'));
	        });
	        var remainderSortedTasksWithProducts = DateUtils.sortListByDateField(remainderTasksWithProducts, 'date');
	        var brewingSortedTaskWithProducts = DashboardModalUtils.sortBatchByColumAndDate(brewingTaskWithProducts);
	
	        // to store which are scheduled and which are requested
	        var allSortedTasks = _.concat(brewingSortedTaskWithProducts, remainderSortedTasksWithProducts);
	        var allSortedTasksWithoutMissingInventoryItems = this.cleanAllWhereInventoryWasTakenNewItemMissingFromTasks(allSortedTasks);
	        var allTaskSortedByDate = DateUtils.sortListByDateField(allSortedTasksWithoutMissingInventoryItems, 'date');
	
	        return allTaskSortedByDate;
	    },
	    getAllItemsIdFromTasks: function getAllItemsIdFromTasks(allTasks) {
	        var allProducts = _.flatten(_.map(allTasks, function (task) {
	            return task.products;
	        }));
	        var allItems = _.flatten(_.map(allProducts, function (product) {
	            return product.items;
	        }));
	        return _.map(allItems, function (item) {
	            return _.get(item, 'item.id') || _.get(item, 'itemId');
	        });
	    },
	    getOrderAfterOrEqualDateFromEndDate: function getOrderAfterOrEqualDateFromEndDate(date) {
	        var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getOrders();
	
	        return _.filter(orders, function (order) {
	            if (_.get(order, 'isSingle')) {
	                return DateUtils.isAfterOrEquals(_.get(order, 'toDate'), date);
	            } else {
	                return DateUtils.isAfterOrEquals(_.get(order, 'orderDate'), date);
	            }
	        });
	    },
	    getOrderBeforeDate: function getOrderBeforeDate(date) {
	        var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getOrders();
	
	        return _.filter(orders, function (order) {
	            if (_.get(order, 'isSingle')) {
	                return DateUtils.isBefore(_.get(order, 'fromDate'), date);
	            } else {
	                return DateUtils.isBefore(_.get(order, 'brewDate'), date);
	            }
	        });
	    },
	    getOrderBeforeDateFromEndDate: function getOrderBeforeDateFromEndDate(date) {
	        var orders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getOrders();
	
	        return _.filter(orders, function (order) {
	            if (_.get(order, 'isSingle')) {
	                return DateUtils.isBefore(_.get(order, 'toDate'), date);
	            } else {
	                return DateUtils.isBefore(_.get(order, 'orderDate'), date);
	            }
	        });
	    },
	    getOrderByRange: function getOrderByRange(from, to) {
	        var orders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DashboardServiceCache.getOrders();
	
	        var fromText = typeof from === 'string' ? from : DateUtils.toDateText(from);
	        var toText = typeof from === 'string' ? to : DateUtils.toDateText(to);
	        return _.filter(orders, function (order) {
	
	            if (!order) {
	                return false;
	            }
	
	            if (_.get(order, 'isSingle')) {
	
	                if (DateUtils.isAfterOrEquals(_.get(order, 'toDate'), fromText) && DateUtils.isBeforeOrEquals(_.get(order, 'toDate'), toText)) {
	                    return true;
	                }
	
	                if (DateUtils.isAfterOrEquals(_.get(order, 'fromDate'), fromText) && DateUtils.isBeforeOrEquals(_.get(order, 'fromDate'), toText)) {
	                    return true;
	                }
	
	                if (DateUtils.isBeforeOrEquals(_.get(order, 'fromDate'), fromText) && DateUtils.isAfterOrEquals(_.get(order, 'toDate'), toText)) {
	                    return true;
	                }
	            } else {
	
	                if (DateUtils.isAfterOrEquals(_.get(order, 'orderDate'), fromText) && DateUtils.isBeforeOrEquals(_.get(order, 'orderDate'), toText)) {
	                    return true;
	                }
	
	                if (DateUtils.isAfterOrEquals(_.get(order, 'brewDate'), fromText) && DateUtils.isBeforeOrEquals(_.get(order, 'brewDate'), toText)) {
	                    return true;
	                }
	
	                if (DateUtils.isBeforeOrEquals(_.get(order, 'brewDate'), fromText) && DateUtils.isAfterOrEquals(_.get(order, 'orderDate'), toText)) {
	                    return true;
	                }
	            }
	        });
	    },
	    isOrderPartiallyShown: function isOrderPartiallyShown(dashboardFrom, dashboardTo, orderPosition) {
	        if (orderPosition && orderPosition.order) {
	            var orderTarget = orderPosition.order;
	            if (ContentUtils.isBT(orderPosition.position.i)) {
	                return DateUtils.isBefore(orderTarget.filtrationDate, dashboardFrom) || DateUtils.isAfter(orderTarget.orderDate, dashboardTo);
	            } else {
	                return DateUtils.isBefore(orderTarget.brewDate, dashboardFrom) || DateUtils.isAfter(orderTarget.filtrationDate, dashboardTo);
	            }
	        }
	        return false;
	    },
	    convertOrderToPositions: function convertOrderToPositions(order, fromDashboard, customSinglePosition) {
	        var forceBatchAsRelocated = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        var positions = [];
	
	        if (_.get(order, 'isSingle')) {
	            positions = [this.toSingleTankPosition(order, fromDashboard, customSinglePosition)];
	        } else {
	            positions = [this.toBriteTankPosition(order, fromDashboard), this.toFermenterTankPosition(order, fromDashboard)];
	        }
	        // add brewhouse batch positions
	        if (_.get(order, 'batchs.length', 0) > 0) {
	            var batchs = _.get(order, 'batchs', []);
	            for (var _iterator2 = batchs, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                var _ref2;
	
	                if (_isArray2) {
	                    if (_i2 >= _iterator2.length) break;
	                    _ref2 = _iterator2[_i2++];
	                } else {
	                    _i2 = _iterator2.next();
	                    if (_i2.done) break;
	                    _ref2 = _i2.value;
	                }
	
	                var batch = _ref2;
	
	                var batchPosition = _.get(BrewhouseStore.toBatchPosition(order, batch), 'position');
	                if (forceBatchAsRelocated) {
	                    batchPosition.isRelocated = true;
	                }
	                if (batchPosition) {
	                    positions.push(batchPosition);
	                }
	            }
	        }
	
	        return positions;
	    },
	    toSingleTankPosition: function toSingleTankPosition(order, dashboardFrom, customPosition) {
	        var column = void 0,
	            height = void 0,
	            positionY = void 0,
	            id = void 0;
	
	        if (customPosition) {
	            column = _.get(customPosition, 'x');
	            height = _.get(customPosition, 'h');
	            positionY = _.get(customPosition, 'y');
	            id = _.get(customPosition, 'i');
	        } else {
	            column = _.get(order, 'singleTank.column');
	            height = ChronologycStore.getHFromDate(_.get(order, 'fromDate'), _.get(order, 'toDate'));
	            positionY = ChronologycStore.getYFromDate(_.get(order, 'fromDate'), dashboardFrom);
	            var tankTypeConfig = ContentUtils.getTankTypeConfiguration(_.get(order, 'singleTank.type'));
	            id = order.id + _.get(tankTypeConfig, 'postFix');
	        }
	        // only for singles, when add single order, we need to show not te single tak.
	        return {
	            h: height,
	            i: id,
	            static: false,
	            w: 1,
	            x: column,
	            y: positionY,
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle'),
	            volume: _.get(order, 'volume')
	        };
	    },
	    toBriteTankPosition: function toBriteTankPosition(order, dashboardFrom) {
	        return {
	            h: ChronologycStore.getHFromDate(_.get(order, 'filtrationDate'), _.get(order, 'orderDate')),
	            i: order.id + '_BT',
	            static: false,
	            w: 1,
	            x: _.get(order, 'briteTank.column'),
	            y: ChronologycStore.getYFromDate(_.get(order, 'filtrationDate'), dashboardFrom),
	            batchNumber: _.get(order, 'batchNumber'),
	            volume: _.get(order, 'volume'),
	            isSingle: _.get(order, 'isSingle')
	        };
	    },
	    toFermenterTankPosition: function toFermenterTankPosition(order, dashboardFrom) {
	        return {
	            h: ChronologycStore.getHFromDate(_.get(order, 'brewDate'), _.get(order, 'filtrationDate')),
	            i: order.id,
	            static: false,
	            w: 1,
	            x: _.get(order, 'fermenterTank.column'),
	            y: ChronologycStore.getYFromDate(_.get(order, 'brewDate'), dashboardFrom),
	            batchNumber: _.get(order, 'batchNumber'),
	            volume: _.get(order, 'volume'),
	            isSingle: _.get(order, 'isSingle')
	        };
	    },
	    toBatchPosition: function toBatchPosition(order, dashboardFrom) {
	        return {
	            h: ChronologycStore.getHFromDate(_.get(order, 'brewDate'), _.get(order, 'filtrationDate')),
	            i: order.id,
	            static: false,
	            w: 1,
	            x: _.get(order, 'fermenterTank.column'),
	            y: ChronologycStore.getYFromDate(_.get(order, 'brewDate'), dashboardFrom),
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle')
	        };
	    },
	    updateDates: function updateDates(order, offsetY) {
	
	        if (!order) {
	            return order;
	        }
	
	        var isSingle = _.get(order, 'isSingle');
	
	        if (isSingle) {
	            order.fromDate = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(_.get(order, 'fromDate')), offsetY);
	            order.toDate = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(_.get(order, 'toDate')), offsetY);
	        } else {
	            order.brewDate = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(_.get(order, 'brewDate')), offsetY);
	            order.filtrationDate = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(_.get(order, 'filtrationDate')), offsetY);
	            order.orderDate = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(_.get(order, 'orderDate')), offsetY);
	        }
	
	        return order;
	    },
	    checkIfTankHaveEnoughVolume: function checkIfTankHaveEnoughVolume(positionNew) {
	
	        if (ContentUtils.isBHBatch(positionNew.i)) {
	            return true;
	        }
	
	        var order = this.getOrder(ContentUtils.cleanId(positionNew.i));
	        var orderVolume = +_.get(order, 'volume', 0);
	
	        if (orderVolume > 0 && !BrewhouseStore.isProperlyVolumeOfTankDestination(positionNew, orderVolume)) {
	            return false;
	        }
	
	        return true;
	    },
	    isOutOfRangeNextTaskPosition: function isOutOfRangeNextTaskPosition(order, nextDateClickedText, isSingle, tankType) {
	        var fromDate = void 0,
	            toDate = void 0;
	
	        if (isSingle) {
	            fromDate = _.get(order, 'fromDate');
	            toDate = _.get(order, 'toDate');
	        } else {
	            if (tankType === 'FV') {
	                fromDate = _.get(order, 'brewDate');
	                toDate = _.get(order, 'filtrationDate');
	            } else if (tankType === 'BT') {
	                fromDate = _.get(order, 'filtrationDate');
	                toDate = _.get(order, 'orderDate');
	            }
	        }
	        if (!DateUtils.isDateBetween(nextDateClickedText, fromDate, toDate)) {
	            Notification.show(t('dashboard_notification_task_could_not_move_outside'));
	            return false;
	        }
	
	        return true;
	    },
	
	
	    /**
	     * Check and Update types if need of given combined order.
	     * NOTE: single orders, don't have spacial task type, so this logic apply only to combined orders.
	     * @param order
	     * @param task
	     * @private
	     */
	    updateTaskType: function updateTaskType(order, task) {
	        if (order && !order.isSingle) {
	            if (_.get(order, 'brewDate') === task.date) {
	                task.type = Constants.BREW_TASK;
	            } else if (_.get(order, 'filtrationDate') === task.date) {
	                task.type = Constants.FILTRATION_TASK;
	            } else if (_.get(order, 'orderDate') === task.date) {
	                task.type = Constants.PACKAGING_TASK;
	            } else {
	                task.type = Constants.SECONDARY_TASK;
	            }
	        }
	        return task;
	    },
	    filterUnneededPositions: function filterUnneededPositions(positionsPerformed) {
	        // remover ordenes duplicadas con post fijos duplicados
	        var orderFilteredId = [];
	        var positionToSave = [];
	
	        for (var _iterator3 = positionsPerformed, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	            }
	
	            var position = _ref3;
	
	            var id = ContentUtils.cleanId(position.newPosition.i);
	            if (_.includes(orderFilteredId, id) || ContentUtils.isBHBatch(position.newPosition.i)) {
	                // is already processed or is brew house batch so is not need to be processed
	                continue;
	            } else {
	                orderFilteredId.push(id);
	                positionToSave.push(position);
	            }
	        }
	
	        return positionToSave;
	    },
	
	
	    /**
	     * Retrieve order by Id.
	     * @param orderId
	     * @returns {*}
	     */
	    getOrder: function getOrder(orderId) {
	        return DashboardServiceCache.getOrder(orderId);
	    },
	    electBatchAvailable: function electBatchAvailable(batchsAvailable, oldBatch) {
	        var batchElected = _.find(batchsAvailable, function (batch) {
	            return _.get(batch, 'position.x') === _.get(oldBatch, 'x');
	        });
	        if (batchElected) {
	            return batchElected;
	        } else {
	            batchElected = _.first(batchsAvailable);
	            return batchElected;
	        }
	    },
	    getTaskFromOrder: function getTaskFromOrder(order) {
	        if (!order) {
	            return order;
	        }
	        if (_.get(order, 'isSingle')) {
	            return _.filter(_.concat(order.singleTasks, order.batchs), function (task) {
	                return task;
	            });
	        } else {
	            return _.filter(_.concat(order.batchs, order.fermenterTasks, order.packagingTasks), function (task) {
	                return task;
	            });
	        }
	    },
	    getTaskFromOrderBySectionAndDate: function getTaskFromOrderBySectionAndDate(order, sectionType, date) {
	        if (!order) {
	            return order;
	        }
	        var filteredTasks = [];
	        if (_.get(order, 'isSingle')) {
	            filteredTasks = _.filter(order.singleTasks, function (task) {
	                return (task.sectionType || task.tankType) === sectionType && DateUtils.toDateText(date) === task.date;
	            });
	        } else {
	            if (sectionType === 'FV') {
	                filteredTasks = _.filter(order.fermenterTasks, function (task) {
	                    return task.date === DateUtils.toDateText(date);
	                });
	            } else if (sectionType === 'BT') {
	                filteredTasks = _.filter(order.packagingTasks, function (task) {
	                    return task.date === DateUtils.toDateText(date);
	                });
	            } else {
	                filteredTasks = _.filter(order.batchs, function (task) {
	                    return task.date === DateUtils.toDateText(date);
	                });
	            }
	        }
	        return _.filter(filteredTasks, function (task) {
	            return task;
	        });
	    },
	    recalculateOffsetProductsEndDate: function recalculateOffsetProductsEndDate(task, offesetDays) {
	        var products = this.hydrateEndDateProduct(task, _.get(task, 'products'));
	
	        if (ContentUtils.isNotEmptyArray(products)) {
	            var productsUpdated = _.map(products, function (product) {
	                product.endDate = moment(product.endDate || task.date).add(offesetDays, 'days').format(Constants.DATE_FORMAT_LONG);
	                return product;
	            });
	            task.products = productsUpdated;
	        }
	
	        return task;
	    },
	    getAllProductsFromOrder: function getAllProductsFromOrder(order) {
	        var _this = this;
	
	        var tasks = this.getTaskFromOrder(order);
	        return _.flatMap(tasks, function (task) {
	            return _this.hydrateEndDateProduct(task, _.get(task, 'products')) || [];
	        });
	    },
	    hydrateEndDateProduct: function hydrateEndDateProduct(task, products) {
	        if (!task || !products || products.length === 0) return products;
	        return (products || []).map(function (product) {
	            product.endDate = task.date;
	            return product;
	        });
	    },
	    getAllProductsFromOrderBySectionAndDate: function getAllProductsFromOrderBySectionAndDate(order, sectionType, date) {
	        var _this2 = this;
	
	        var tasks = this.getTaskFromOrderBySectionAndDate(order, sectionType, date);
	        return _.flatMap(tasks, function (task) {
	            return _this2.hydrateEndDateProduct(task, _.get(task, 'products')) || [];
	        });
	    },
	    getAllWhereInventoryWasTakenFromAllItemsFromAllProductsFromOrders: function getAllWhereInventoryWasTakenFromAllItemsFromAllProductsFromOrders(orders, minDate) {
	        var whereInventoryWasTaken = [];
	        for (var _iterator4 = orders, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	            var _ref4;
	
	            if (_isArray4) {
	                if (_i4 >= _iterator4.length) break;
	                _ref4 = _iterator4[_i4++];
	            } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) break;
	                _ref4 = _i4.value;
	            }
	
	            var order = _ref4;
	
	            var products = this.getAllProductsFromOrder(order);
	            var filteredProducts = products.filter(function (product) {
	                var productDate = DateUtils.toDateText(product.endDate);
	                return DateUtils.isAfter(productDate, minDate);
	            });
	            for (var _iterator5 = filteredProducts, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	                var _ref5;
	
	                if (_isArray5) {
	                    if (_i5 >= _iterator5.length) break;
	                    _ref5 = _iterator5[_i5++];
	                } else {
	                    _i5 = _iterator5.next();
	                    if (_i5.done) break;
	                    _ref5 = _i5.value;
	                }
	
	                var product = _ref5;
	
	                for (var _iterator6 = product.items, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	                    var _ref6;
	
	                    if (_isArray6) {
	                        if (_i6 >= _iterator6.length) break;
	                        _ref6 = _iterator6[_i6++];
	                    } else {
	                        _i6 = _iterator6.next();
	                        if (_i6.done) break;
	                        _ref6 = _i6.value;
	                    }
	
	                    var item = _ref6;
	
	                    if (item.whereInventoryWasTakenNew && item.whereInventoryWasTakenNew.length) {
	                        whereInventoryWasTaken.push(item.whereInventoryWasTakenNew);
	                    }
	                    if (item.whereInventoryWasTakenSave && item.whereInventoryWasTakenSave.length) {
	                        whereInventoryWasTaken.push(item.whereInventoryWasTakenSave);
	                    }
	                }
	            }
	        }
	        return _.flatMap(whereInventoryWasTaken);
	    },
	    getAllProductsFromTasks: function getAllProductsFromTasks(tasks) {
	        var _this3 = this;
	
	        return _.flatMap(tasks, function (task) {
	            return _this3.hydrateEndDateProduct(task, _.get(task, 'products')) || [];
	        }) || [];
	    },
	    getAllFermentingProductsFromOrder: function getAllFermentingProductsFromOrder(order) {
	        return this.getAllProductsFromTasks(order.fermenterTasks);
	    },
	    getAllPackagingProductsFromOrder: function getAllPackagingProductsFromOrder(order) {
	        return this.getAllProductsFromTasks(order.packagingTasks);
	    },
	    getAllBrewingProductsFromOrder: function getAllBrewingProductsFromOrder(order) {
	        return this.getAllProductsFromTasks(order.batchs);
	    },
	    haveSomeProductConfirmed: function haveSomeProductConfirmed(tasks) {
	        return _.some(tasks, function (task) {
	            return _.some(_.get(task, 'products'), function (product) {
	                return _.get(product, 'isConfirmed');
	            });
	        });
	    },
	    haveSomeProductConfirmedFromOrder: function haveSomeProductConfirmedFromOrder(order) {
	        var tasks = this.getTaskFromOrder(order);
	        return _.some(tasks, function (task) {
	            return _.some(_.get(task, 'products'), function (product) {
	                return _.get(product, 'isConfirmed');
	            });
	        });
	    },
	    haveSomeProductConfirmedFromOrderAfterDate: function haveSomeProductConfirmedFromOrderAfterDate(order, dateClicked) {
	        var products = this.getAllProductsFromOrder(order);
	        return _.some(products, function (product) {
	            return DateUtils.isAfter(DateUtils.toDateText(product.endDate), DateUtils.toDateText(dateClicked)) && _.get(product, 'isConfirmed');
	        });
	    },
	    haveSomeProductConfirmedFromOrderAfterOrEqualDate: function haveSomeProductConfirmedFromOrderAfterOrEqualDate(order, dateClicked) {
	        var products = this.getAllProductsFromOrder(order);
	        return _.some(products, function (product) {
	            return (DateUtils.isEqual(DateUtils.toDateText(product.endDate), DateUtils.toDateText(dateClicked)) || DateUtils.isAfter(DateUtils.toDateText(product.endDate), DateUtils.toDateText(dateClicked))) && _.get(product, 'isConfirmed');
	        });
	    },
	    isAbleToMoveTaskADayBefore: function isAbleToMoveTaskADayBefore(order, dateClicked, tankClicked) {
	        return this.haveSomeProductConfirmedFromOrderByDate(order, dateClicked, tankClicked) === false &&
	        // Notice we should check a day before, in order to avoid to do an ENROQUE, to some confirmed product
	        this.haveSomeProductConfirmedFromOrderByDate(order, DateUtils.addDays(dateClicked, -1), tankClicked) === false;
	    },
	    isAbleToMoveTaskADayAfter: function isAbleToMoveTaskADayAfter(order, dateClicked, tankClicked) {
	        return this.haveSomeProductConfirmedFromOrderByDate(order, dateClicked, tankClicked) === false &&
	        // Notice we should check a day after, in order to avoid to do an ENROQUE, to some confirmed product
	        this.haveSomeProductConfirmedFromOrderByDate(order, DateUtils.addDays(dateClicked, 1), tankClicked) === false;
	    },
	    haveSomeProductConfirmedFromOrders: function haveSomeProductConfirmedFromOrders(orders) {
	        var _this4 = this;
	
	        return _.some(orders, function (order) {
	            return _this4.haveSomeProductConfirmedFromOrder(order);
	        });
	    },
	    haveSomeProductConfirmedFromButchNumber: function haveSomeProductConfirmedFromButchNumber(batchNumber) {
	        var orders = DashboardServiceCache.getOrdersByBatchNumber(batchNumber);
	        return this.haveSomeProductConfirmedFromOrders(orders);
	    },
	    haveSomeProductConfirmedFromOrderId: function haveSomeProductConfirmedFromOrderId(orderId) {
	        var order = DashboardServiceCache.getOrder(orderId);
	        return this.haveSomeProductConfirmedFromOrder(order);
	    },
	    haveSomeProductConfirmedByPosition: function haveSomeProductConfirmedByPosition(position) {
	        var orderId = ContentUtils.cleanId(position.i);
	        var taskInfo = ChronologycStore.getDateFromPositionY(position.y);
	        var order = DashboardServiceCache.getOrder(orderId);
	        var tasks = OrderUtils.getTaskFromOrderBySectionAndDate(order, 'BH', taskInfo.date);
	        var taskByColumn = tasks.find(function (task) {
	            return _.get(task, 'turn.column') === position.x;
	        });
	        var products = (taskByColumn || { products: [] }).products;
	        return _.some(products, function (product) {
	            return product && product.isConfirmed;
	        });
	    },
	    haveSomeProductConfirmedFromOrderByDate: function haveSomeProductConfirmedFromOrderByDate(order, date, tankClicked) {
	        var products = this.getAllProductsFromOrderBySectionAndDate(order, tankClicked.type, date);
	        return _.some(products, function (product) {
	            return product.isConfirmed || product.isDiscounted;
	        });
	    },
	    setDefaultEndHourToProductsOfTask: function setDefaultEndHourToProductsOfTask(task) {
	        task.products = this.hydrateEndDateProduct(task, _.get(task, 'products'));
	        return task;
	    },
	    overrideDefaultEndHourToProductsOfTask: function overrideDefaultEndHourToProductsOfTask(task) {
	        task.products = this.hydrateEndDateProduct(task, _.get(task, 'products'));
	        return task;
	    },
	    isChangedOrderAlreadyStarted: function isChangedOrderAlreadyStarted(orderId) {
	        var order = DashboardServiceCache.getOrder(orderId);
	        if (order) {
	            var isSingle = _.get(order, 'isSingle');
	            var fromDate = void 0,
	                toDate = void 0;
	            if (isSingle) {
	                fromDate = _.get(order, 'fromDate');
	                toDate = _.get(order, 'toDate');
	            } else {
	                fromDate = _.get(order, 'brewDate');
	                toDate = _.get(order, 'orderDate');
	            }
	            var isAfterToDay = DateUtils.isBeforeToDay(fromDate) || DateUtils.isBeforeToDay(toDate);
	
	            if (isAfterToDay) {
	                return true;
	            }
	        }
	        return false;
	    },
	    recalculateProcessDate: function recalculateProcessDate(task) {
	        var _this5 = this;
	
	        if (ContentUtils.isNotEmptyArray(task.process)) {
	            task.process = task.process.map(function (process) {
	                if (process.fromDate) {
	                    process.fromDate = task.date;
	                }
	
	                if (process.toDate) {
	                    process.toDate = task.date;
	                }
	
	                process = _this5._updateProcessTaskIdDate(process, task.date);
	
	                return process;
	            });
	        }
	        return task;
	    },
	    _updateProcessTaskIdDate: function _updateProcessTaskIdDate(process, newDateTask) {
	        if ('BREWHOUSE_TASK' === process.processSection) {
	            // in case that brewing, don't need to update any prefix date
	            return process;
	        }
	        var oldTaskId = process.taskId;
	        var oldProcessPostFix = oldTaskId.substring(oldTaskId.indexOf('_'), oldTaskId.length);
	        process.taskId = '' + newDateTask + oldProcessPostFix;
	        return process;
	    },
	    isResizeAllowed: function isResizeAllowed(startDate, endDate, toDay) {
	        var isStartDateAfterToDay = DateUtils.isAfterOrEquals(startDate, toDay);
	        var isEndDateAfterToDay = DateUtils.isAfterOrEquals(endDate, toDay);
	
	        return isStartDateAfterToDay && isEndDateAfterToDay;
	    },
	    isAbleToConfirmSomeProduct: function isAbleToConfirmSomeProduct(order, dateTask) {
	        var allTasks = this.getTaskFromOrder(order);
	        if (this.isAllProductAlreadyConfirmed(allTasks, dateTask)) {
	            return true;
	        }
	
	        var allBeforeTasksWithSomeProduct = _.filter(allTasks, function (task) {
	            return ContentUtils.isNotEmptyArray(_.get(task, 'products')) && _.some(_.get(task, 'products'), function (product) {
	                return NumberUtils.isGreater(_.get(product, 'amount'), '0');
	            }) && DateUtils.isBefore(_.get(task, 'date'), dateTask);
	        });
	
	        var allTasksHaveAtLeastSomeConfirmedProduct = _.every(allBeforeTasksWithSomeProduct, function (task) {
	            var products = _.get(task, 'products');
	            return _.some(products, function (product) {
	                return _.get(product, 'isConfirmed');
	            });
	        });
	
	        return allTasksHaveAtLeastSomeConfirmedProduct;
	    },
	    isAllProductAlreadyConfirmed: function isAllProductAlreadyConfirmed(allTasks, dateTask) {
	        var filteredTasks = _.filter(allTasks, function (task) {
	            return task.date === dateTask;
	        });
	        return _.every(filteredTasks, function (task) {
	            return _.every(_.get(task, 'products'), function (product) {
	                return product.isConfirmed;
	            });
	        });
	    },
	    cleanAllWhereInventoryWasTakenNewItemMissingFromTasks: function cleanAllWhereInventoryWasTakenNewItemMissingFromTasks(tasks) {
	        return _.map(tasks, function (task) {
	            var products = _.get(task, 'products');
	            task.products = _.map(products, function (product) {
	                var items = _.get(product, 'items');
	                product.items = _.map(items, function (item) {
	                    if (item && ContentUtils.isNotEmptyArray(item.whereInventoryWasTakenNew)) {
	                        item.whereInventoryWasTakenNew = _.filter(item.whereInventoryWasTakenNew, function (itemInfo) {
	                            return _.get(itemInfo, 'type') !== 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';
	                        });
	                    }
	                    return item;
	                });
	                return product;
	            });
	            return task;
	        });
	    },
	    cleanAllWhereInventoryWasTakenByProduct: function cleanAllWhereInventoryWasTakenByProduct(product) {
	        var items = _.get(product, 'items');
	        product.items = _.map(items, function (item) {
	            if (item && ContentUtils.isNotEmptyArray(item.whereInventoryWasTakenNew)) {
	                item.whereInventoryWasTakenNew = [];
	            }
	            return item;
	        });
	        return product;
	    },
	    replaceById: function replaceById(orders, newOrder) {
	        return ContentUtils.replaceByAttributes(orders, newOrder, 'id');
	    },
	    hasOneDayPackagingSide: function hasOneDayPackagingSide(order) {
	        if (!_.get(order, 'filtrationDate') || !_.get(order, 'orderDate')) {
	            return false;
	        }
	
	        return DateUtils.getDaysBetween(_.get(order, 'filtrationDate'), _.get(order, 'orderDate')) === 0;
	    },
	    hasOneDayFermenterSide: function hasOneDayFermenterSide(order) {
	        if (!_.get(order, 'brewDate') || !_.get(order, 'filtrationDate')) {
	            return false;
	        }
	
	        return DateUtils.getDaysBetween(_.get(order, 'brewDate'), _.get(order, 'filtrationDate')) === 0;
	    },
	    hasOneDaySingleOrder: function hasOneDaySingleOrder(order) {
	        if (!_.get(order, 'fromDate') || !_.get(order, 'toDate')) {
	            return false;
	        }
	
	        return DateUtils.getDaysBetween(_.get(order, 'fromDate'), _.get(order, 'toDate')) === 0;
	    },
	    getEndDateOrder: function getEndDateOrder(order) {
	        if (order && order.isSingle) {
	            return order.toDate;
	        } else {
	            return order.orderDate;
	        }
	    },
	    getStartDateOrder: function getStartDateOrder(order) {
	        if (order && order.isSingle) {
	            return order.fromDate;
	        } else {
	            return order.brewDate;
	        }
	    },
	    isOrderInRange: function isOrderInRange(dashboardFrom, dashboardTo, order) {
	        var orderFrom = this.getStartDateOrder(order);
	        var orderEnd = this.getEndDateOrder(order);
	
	        return DateUtils.isAfterOrEquals(orderFrom, dashboardFrom) && DateUtils.isBeforeOrEquals(orderEnd, dashboardTo);
	    },
	    toggleConfirmProduct: function toggleConfirmProduct(product) {
	        if (product) {
	            product.isConfirmed = !product.isConfirmed;
	            if (!product.isConfirmed && product.isDiscounted) {
	                product.needToPublishDisconfirmation = true;
	            } else {
	                product.needToPublishDisconfirmation = false;
	            }
	        }
	
	        return product;
	    },
	    hasSomeProductBeforeTodayAndBefore: function hasSomeProductBeforeTodayAndBefore(order, from) {
	        var taskOutRangeBefore = _.filter(this.getAllSortedTasksFromOrders([order]), function (task) {
	            return DateUtils.isBeforeToDay(task.date) && DateUtils.isBefore(task.date, from);
	        });
	
	        var someItemsBeforeNotConfirmed = false;
	
	        taskOutRangeBefore.forEach(function (task) {
	            if (task) {
	                task.products.forEach(function (p) {
	                    if (!p.isConfirmed) {
	                        someItemsBeforeNotConfirmed = true;
	                    }
	                });
	            }
	        });
	
	        var substractedItems = [];
	
	        if (someItemsBeforeNotConfirmed) {
	            substractedItems.push(this.getAllProductsFromTasks(taskOutRangeBefore).filter(function (p) {
	                return p.items.filter(function (i) {
	                    return !i.addition;
	                });
	            }));
	        }
	
	        return substractedItems.length > 0;
	    },
	    getCandidateProductToConfirm: function getCandidateProductToConfirm(orders, from, to) {
	        var candidateProducts = [];
	
	        for (var _iterator7 = orders, _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
	            var _ref7;
	
	            if (_isArray7) {
	                if (_i7 >= _iterator7.length) break;
	                _ref7 = _iterator7[_i7++];
	            } else {
	                _i7 = _iterator7.next();
	                if (_i7.done) break;
	                _ref7 = _i7.value;
	            }
	
	            var order = _ref7;
	
	            if (this.hasSomeProductBeforeTodayAndBefore(order, from)) {
	                // if there some product outside of the range of the order, should not allow to confirm the rest.
	                continue;
	            } else {
	                var tasks = _.filter(this.getAllSortedTasksFromOrders([order]), function (task) {
	                    return DateUtils.isBeforeToDay(task.date) && DateUtils.isAfterOrEquals(task.date, from) && DateUtils.isBeforeOrEquals(task.date, to);
	                });
	                var products = this.getAllProductsFromTasks(tasks);
	                var productsCandidateToConfirm = products.filter(function (p) {
	                    var substractedItems = p.items.filter(function (i) {
	                        return !i.addition;
	                    });
	                    return substractedItems.every(function (si) {
	                        return !!si.isEnoughInventory;
	                    });
	                });
	                candidateProducts.push(productsCandidateToConfirm);
	            }
	        }
	
	        return candidateProducts.flat();
	    },
	    confirmAllProductsByOrder: function confirmAllProductsByOrder(order, from, to) {
	        if (this.hasSomeProductBeforeTodayAndBefore(order, from)) {
	            // enter here means have some products before today and before range, so 
	            // we should not allow to confirm any product in the range.
	            return;
	        }
	
	        var wasConfirmedSomeProduct = false;
	
	        var candidateProductToConfirm = this.getCandidateProductToConfirm([order], from, to);
	
	        for (var _iterator8 = candidateProductToConfirm, _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
	            var _ref8;
	
	            if (_isArray8) {
	                if (_i8 >= _iterator8.length) break;
	                _ref8 = _iterator8[_i8++];
	            } else {
	                _i8 = _iterator8.next();
	                if (_i8.done) break;
	                _ref8 = _i8.value;
	            }
	
	            var product = _ref8;
	
	            this.toggleConfirmProduct(product); // changing the product reference of given task
	            wasConfirmedSomeProduct = true;
	        }
	        return wasConfirmedSomeProduct; // return the order with the confirmed products
	    }
	};
	
	module.exports = OrderUtils;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * The idea of this utils is have a common place tu put helper functions that will
	 * consume the different types of DashboardModals.
	 */
	
	var DateUtils = __webpack_require__(22),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    SessionStore = __webpack_require__(11),
	    DashboardServiceCache = __webpack_require__(28),
	    _ = __webpack_require__(40),
	    _require = __webpack_require__(2),
	    SECONDARY_TASK = _require.SECONDARY_TASK,
	    TASK_NON_VISIBLE = _require.TASK_NON_VISIBLE;
	
	/**
	 * Retrieve the index of Tab which need to be open given information.
	 * @param filtrationDate
	 * @param fermenterTasks
	 * @param packagingTasks
	 * @param dataClicked
	 * @param isFermenterTankClicked
	 * @returns {number}
	 */
	function getTabSelectedIndex(filtrationDate, fermenterTasks, packagingTasks, dataClicked, isFermenterTankClicked, tankTypeClicked) {
	    if (DateUtils.toDateText(filtrationDate) === DateUtils.toDateText(dataClicked) && isFermenterTankClicked) {
	        return 1; // this is the special case that the date of filtration exist on packaging task too, so we need to know which type of task was clicked
	    }
	
	    var dateText = DateUtils.toDateText(dataClicked);
	    var fermenterTask = _.find(fermenterTasks, function (task) {
	        return task.date === dateText;
	    });
	    var packagingTask = _.find(packagingTasks, function (task) {
	        return task.date === dateText;
	    });
	
	    if (tankTypeClicked === 'BH') {
	        // enter here means that was clicked a brewhouse batch
	        return 1;
	    }
	    return packagingTask ? 3 : isFermenterTankClicked && fermenterTask ? 2 : 0;
	}
	
	/**
	 * Analyze and fill if need to complete the products of each of bathes from the order.
	 * @param oldState
	 * @param nextState
	 * @return {*}
	 */
	function fillEachBatchWithProductMissing(oldState, nextState) {
	    if (SessionStore.isFullPaidVersion()) {
	        var haveMoreVolumeThanBefore = NumberUtils.isGreater(nextState.orderVolume, oldState.orderVolume);
	        var haveMoreAmountBatchsThanBefore = (_.get(oldState, 'order.batchs.length') || 0) < _.get(nextState, 'order.batchs.length');
	
	        if (haveMoreVolumeThanBefore && haveMoreAmountBatchsThanBefore) {
	            // only make sense enter here when the volume are larger than before
	            // which means we could need more batch to hydrate
	            var batchs = _.get(nextState, 'order.batchs');
	            var productIcons = DashboardServiceCache.getProductIcons();
	            var fullProducts = DashboardServiceCache.getProducts();
	            var productItems = DashboardServiceCache.getProductItems();
	            var currentBeerStyleId = _.get(nextState, 'styleBeerSelected.id');
	
	            var newBatchs = _.map(batchs, function (batch) {
	                var notHaveProducts = (_.get(batch, 'products.length') || 0) === 0;
	                if (notHaveProducts) {
	                    var currentIcon = _.get(batch, 'name');
	
	                    // icons filtered by current task name
	                    var productIconsByTaskName = _.filter(productIcons, function (productIcon) {
	                        return _.get(productIcon, 'icon.iconDetail.name') === currentIcon || _.get(productIcon, 'icon.iconDetail.displayName') === currentIcon;
	                    });
	
	                    if (ContentUtils.isNotEmptyArray(productIconsByTaskName)) {
	
	                        // hydrate each product icon with product
	                        var productIconsWithProducts = _.map(productIconsByTaskName, function (productIcon) {
	                            var productTarget = _.find(fullProducts, function (product) {
	                                return _.get(product, 'id') === _.get(productIcon, 'product.id');
	                            });
	                            productIcon = _.merge(productIcon, productTarget);
	                            productIcon.product = productTarget;
	                            return productIcon;
	                        });
	
	                        // filter full product by current beer stlye
	                        var emptyProducts = _.filter(productIconsWithProducts, function (productIcon) {
	                            return +_.get(productIcon, 'product.beerStyle.id') === +currentBeerStyleId;
	                        });
	                        if (ContentUtils.isNotEmptyArray(emptyProducts)) {
	
	                            // hydrate each of product with their productItems
	                            var emptyProductsHydratedWithItems = _.map(emptyProducts, function (emptyProduct) {
	                                emptyProduct.items = _.filter(productItems, function (productItem) {
	                                    return _.get(productItem, 'product.id') === _.get(emptyProduct, 'id');
	                                });
	                                return emptyProduct;
	                            });
	
	                            // assign finally each product needed by batch
	                            batch.products = emptyProductsHydratedWithItems;
	                        }
	                    }
	                }
	                return batch;
	            });
	
	            nextState = _.set(nextState, 'order.batchs', newBatchs);
	        }
	    }
	
	    return nextState;
	}
	
	/**
	 * Retrieve the non-select menu items that will be consume the drop-down menus.
	 * @argument {String} text                  the text that will be displayed.
	 * @return {Array}
	 */
	function getNonSelectedMenuItem(text) {
	    return [{ 'payload': 0, 'text': text }];
	}
	
	/**
	 * Check if exist more than one task for this task, in case that exist two task
	 * retrieve the SECONDARY_TASK insted of the default tasks (BREW_TASK, PACKAGING_TASK, FILTRATION_TASK)
	 * @param existingTasks
	 * @returns {*}
	 */
	function retrieveCustomTask(existingTasks) {
	    if (existingTasks && existingTasks.length) {
	        if (existingTasks.length === 1) {
	            return existingTasks[0];
	        } else {
	            return _.find(existingTasks, function (task) {
	                return task.type === SECONDARY_TASK;
	            });
	        }
	    }
	}
	
	function isSingle(isFVAllowed, isBTAllowed) {
	    return isFVAllowed === false || isBTAllowed === false;
	}
	
	/**
	 * Filter for type of tanks and convert in drop-down menu item model.
	 * @argument {String} type                  Type of that that will be filter.
	 * @argument {Array} tanks                  Tanks that will use for convert in properly menu item model.
	 * @return {Array}
	 * @private
	 */
	function toTankMenuItems(type, tanks) {
	    var locatorPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    return _.filter(tanks, function (tank) {
	        return tank.type === type;
	    }).map(function (tank, index) {
	        return {
	            payload: index + 1,
	            text: tank.name + ' - ' + tank.volume + (tank.unit || 'v'),
	            type: tank.type,
	            column: tank.column,
	            volume: tank.volume,
	            tankObj: tank,
	            locatorId: locatorPrefix + (index + 1)
	        };
	    });
	}
	
	/**
	 * Convert to raw Configuration Task, to a ready to use task.
	 * @param {Array} task                      The raw task.
	 * @param {String} fromDate                 The first that we use as reference to calculate the `date` field of real task.
	 * @param {Array} menuItems                 The Menu item to calculate the index position of the real task that will need to take.
	 * @private
	 * @returns {Array}
	 */
	function toConcreteTask(tasks, fromDate, menuItems, tankType) {
	    return _.map(tasks, function (task) {
	        var date = _.get(task, 'date', DateUtils.addDaysTextBasicFormat(fromDate, task.day - 1));
	        var payload = _.findIndex(menuItems, function (menuItem) {
	            return menuItem.displayName === _.get(task, 'typeTask', _.get(task, 'name')) || menuItem.name === _.get(task, 'typeTask', _.get(task, 'name'));
	        });
	        var name = _.get(task, 'typeTask', _.get(task, 'name'));
	        var label = _.get(task, 'label', '');
	        var type = _.get(task, 'type', SECONDARY_TASK);
	        var description = _.get(task, 'description', '');
	        var icon = _.get(task, 'icon', '');
	        return {
	            icon: icon,
	            date: date,
	            payload: payload,
	            name: name,
	            label: label,
	            description: description,
	            type: type,
	            tankType: tankType,
	            tasks: menuItems, // We need to load all the tasks in order to hydrate the menu items that will contain this particular task
	            isConfiguration: true // flag that allow us to remove this kind of task if we need to re-calculate again.
	        };
	    });
	}
	
	/**
	 * Retrieve an empty task.
	 * @param {String} date                     Date of task
	 * @param {String} taskType (Optionally)    The task type like BREW_TASK, FILTRATION_TASK, PACKAGING_TASK, SECONDARY_TASK, etc.
	 * @param {String} name     (Optionally)    The name of the task.
	 * @return {Object}
	 */
	function toEmptyTask(date) {
	    var taskType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SECONDARY_TASK;
	    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TASK_NON_VISIBLE;
	
	    var existingTask = {};
	    existingTask.name = name;
	    existingTask.date = date;
	    existingTask.label = '';
	    existingTask.description = '';
	    existingTask.type = taskType;
	
	    return existingTask;
	}
	
	function isToggleChange(nextProps, oldProps) {
	
	    var isChanged = false;
	
	    if (nextProps.isBHAllowed !== oldProps.isBHAllowed) {
	        return true;
	    }
	
	    if (nextProps.isFVAllowed !== oldProps.isFVAllowed) {
	        return true;
	    }
	
	    if (nextProps.isBTAllowed !== oldProps.isBTAllowed) {
	        return true;
	    }
	
	    return isChanged;
	}
	
	/**
	 * Search if exist some custom task that have an conflict with the a default task, and replace default task if
	 * will need it, without change their type of task. (In order to work the logic about brew task)
	 *
	 * @param existingTasks
	 * @private
	 * @returns {*}
	 */
	function removeDefaultTaskWhenExistCustom(existingTasks) {
	    var clonedExistingTask = _.cloneDeep(existingTasks);
	    var conflicTask = _.filter(_.values(_.groupBy(clonedExistingTask, 'date')), function (task) {
	        return task.length > 1;
	    });
	    if (conflicTask && conflicTask.length) {
	        var properlyTask = _.filter(_.values(_.groupBy(clonedExistingTask, 'date')), function (task) {
	            return task.length === 1;
	        });
	        var defaultTask = _.filter(_.flatten(conflicTask), function (taskRepeat) {
	            return taskRepeat.type !== 'SECONDARY_TASK';
	        });
	        var customTasks = _.filter(_.flatten(conflicTask), function (taskRepeat) {
	            return taskRepeat.type === 'SECONDARY_TASK';
	        });
	        var customTasksWithProperlyType = _.map(customTasks, function (customTask) {
	            var type = _.get(_.find(defaultTask, function (task) {
	                return task.date === customTask.date;
	            }), 'type', '');
	            if (type !== '') {
	                customTask.type = type;
	            }
	            return customTask;
	        });
	
	        return _.flatten(_.concat(properlyTask, customTasksWithProperlyType));
	    } else {
	
	        return existingTasks;
	    }
	}
	
	/**
	 * Retrieve the index necessary for fermenter tank of the drop down menu component.
	 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
	 * @argument {Object} order                     that will be used to get fermenter tank properties
	 * @return {Object}
	 * @private
	 */
	function getFermenterTank(menuItems, order) {
	    var fermenterTank = { index: 0, item: null }; // by default
	    menuItems.forEach(function (menuItem) {
	        if (menuItem.column === _.get(order, 'fermenterTank.column')) {
	            fermenterTank.index = menuItem.payload;
	            fermenterTank.item = menuItem;
	        }
	    });
	
	    return fermenterTank;
	}
	
	function getTasksFromProcess(newProcess, state) {
	    if (isBrewingProcess(newProcess)) {
	        return _.get(state, 'order.batchs');
	    }
	
	    if (_.get(state, 'order.isSingle')) {
	        return _.get(state, 'singleTasks');
	    }
	
	    if (isFermentingProcess(newProcess)) {
	        return _.get(state, 'fermenterTasks');
	    }
	
	    if (isPackagingProcess(newProcess)) {
	        return _.get(state, 'packagingTasks');
	    }
	}
	
	/**
	 * Retrieve the index necessary for briteTank drop of the down menu component.
	 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
	 * @argument {Object} order                     that will be used to get brite tank properties.
	 * @return {Object}
	 * @private
	 */
	function getBriteTank(menuItems, order) {
	    var briteTank = { index: 0, item: null }; // by default
	    menuItems.forEach(function (menuItem) {
	        if (menuItem.column === _.get(order, 'briteTank.column')) {
	            briteTank.index = menuItem.payload;
	            briteTank.item = menuItem;
	        }
	    });
	
	    return briteTank;
	}
	
	/**
	 * Retrieve the index necessary for single tank of the down menu component.
	 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
	 * @argument {Object} order                     that will be used to get brite tank properties.
	 * @return {Object}
	 * @private
	 */
	function getSingleTank(menuItems, order) {
	    var briteTank = { index: 0, item: null }; // by default
	    menuItems.forEach(function (menuItem) {
	        if (menuItem.column === _.get(order, 'singleTank.column')) {
	            briteTank.index = menuItem.payload;
	            briteTank.item = menuItem;
	        }
	    });
	
	    return briteTank;
	}
	
	function setTaskIds(tasks, taskType) {
	    return _.map(tasks, function (task) {
	        task.taskId = taskType + '_' + task.name + '_' + task.date;
	        return task;
	    });
	}
	
	/**
	 * Retrieve the index necessary for style beer of the drop down menu component.
	 * @argument {HTMLElement} menuItems            the menu items need it to take the target index.
	 * @argument {Object} order                     that will be used to get style beer properties
	 * @return {Object}
	 * @private
	 */
	function getStyleBeer(menuItems, order) {
	    var styleBeer = { index: 0, item: null }; // by default
	    menuItems.forEach(function (menuItem) {
	        if (menuItem.id === _.get(order, 'styleBeer.id')) {
	            styleBeer.index = menuItem.payload;
	            styleBeer.item = menuItem;
	        }
	    });
	
	    return styleBeer;
	}
	
	function formatProperOrderSelected(preOrderSelected) {
	    var newFormatOrder = _.cloneDeep(preOrderSelected);
	    var tankSelected = newFormatOrder.tankSelected;
	
	    if (tankSelected) {
	        newFormatOrder.tankSelected.tankObj = {
	            id: tankSelected.id,
	            column: tankSelected.column,
	            type: tankSelected.type
	        };
	    }
	
	    return newFormatOrder;
	}
	
	/**
	 * The format that will send the request against to the API.
	 * @param orderProcess
	 * @return {*}
	 */
	function formatOrderProcess(ordersProcess) {
	
	    if (Array.isArray(ordersProcess)) {
	        // change the format of object
	        var processFormatted = _.map(ordersProcess, function (brewProcess) {
	            return formatOrderProcess(brewProcess);
	        });
	        // remove the null positions of the array
	        return _.filter(processFormatted, function (process) {
	            return process;
	        });
	    }
	
	    var processId = _.get(ordersProcess, 'processId', _.get(ordersProcess, 'orderProcessHydrated.id'));
	    var taskId = _.get(ordersProcess, 'taskId');
	
	    if (!processId || !taskId) {
	        // just not need to take care for this kind of process, we don't need it
	        return null;
	    }
	
	    return {
	        processId: processId,
	        taskId: taskId,
	        processSection: ordersProcess.processSection,
	        fromDate: ordersProcess.fromDate,
	        fromHour: ordersProcess.fromHour,
	        toDate: ordersProcess.toDate,
	        toHour: ordersProcess.toHour,
	        note: _.get(ordersProcess, 'note', _.get(ordersProcess, 'orderProcessHydrated.note'))
	    };
	}
	
	function hydrateOrderWithTheirProcess(order) {
	    if (!order || ContentUtils.isEmptyArray(order.process)) {
	        return order;
	    }
	
	    var processList = _.get(order, 'process', []);
	
	    Array.from(['singleTasks', 'fermenterTasks', 'packagingTasks', 'batchs']).filter(function (fieldName) {
	        return order[fieldName];
	    }).forEach(function (fieldName) {
	        var tasks = order[fieldName];
	        order[fieldName] = fillWithProcess(tasks, processList);
	    });
	
	    order.process = null;
	
	    return order;
	}
	
	function fillWithProcess() {
	    var tasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var processList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var fermentingProcessList = processList.filter(isFermentingProcess);
	    var packagingProcessList = processList.filter(isPackagingProcess);
	    var brewingProcessList = processList.filter(isBrewingProcess);
	
	    return tasks.map(function (task) {
	        if (isFermentingTask(task)) {
	            var targetProcess = fermentingProcessList.find(function (process) {
	                return process.fromDate === task.date;
	            });
	            if (targetProcess) {
	                task = hydrateTaskFromProcess(task, targetProcess);
	            }
	        }
	        if (isPackagingTask(task)) {
	            var _targetProcess = packagingProcessList.find(function (process) {
	                return process.fromDate === task.date;
	            });
	            if (_targetProcess) {
	                task = hydrateTaskFromProcess(task, _targetProcess);
	            }
	        }
	        if (isBrewingTask(task)) {
	            var _targetProcess2 = brewingProcessList.find(function (process) {
	                return process.fromDate === task.date;
	            });
	            if (_targetProcess2) {
	                task = hydrateTaskFromProcess(task, _targetProcess2);
	            }
	        }
	
	        return task;
	    });
	}
	
	function hydrateTaskFromProcess(task, process) {
	    if (ContentUtils.isEmptyArray(task.process)) {
	        task.process = [];
	    }
	    task.process.push(process);
	    return task;
	}
	
	function isFermentingTask(task) {
	    return 'FILTRATION_TASK' === _.get(task, 'type');
	}
	
	function isBrewingTask(task) {
	    return 'BREW_TASK' === _.get(task, 'type');
	}
	
	function isFermentingProcess(process) {
	    return _.get(process, 'processSection') === 'FV' || _.get(process, 'processSection') === 'Fermenting' || _.get(process, 'taskId', '').indexOf('FERMENTER_TASK') > -1;
	}
	
	function isPackagingProcess(process) {
	    return _.get(process, 'processSection') === 'BT' || _.get(process, 'processSection') === 'Packaging' || _.get(process, 'taskId', '').indexOf('PACKAGING_TASK') > -1;
	}
	
	function isBrewingProcess(process) {
	    return _.get(process, 'processSection') === 'BH' || _.get(process, 'processSection') === 'Brewing' || _.get(process, 'processSection') === 'BREWHOUSE_TASK' || _.get(process, 'taskId', '').indexOf('BREW_TASK') > -1;
	}
	
	function isPackagingTask(task) {
	    return 'PACKAGING_TASK' === _.get(task, 'type');
	}
	
	function formatTasksProducts(tasks) {
	    return _.map(tasks, function (task) {
	        return formatTasksProduct(task);
	    });
	}
	
	function addProductOrderIdToTasks(tasks) {
	    return _.map(tasks, function (task) {
	        return addProductOrderIdToTask(task);
	    });
	}
	
	function addProductOrderIdToTask(task) {
	    if (!ContentUtils.isEmptyArray(task.products)) {
	        task.products = addProductOrderId(task.products);
	    }
	    return task;
	}
	
	function addProductOrderId(products) {
	    return _.map(products, function (product) {
	        product.tempId = ContentUtils.getRandomId();
	        return product;
	    });
	}
	
	function formatTasksProduct(task) {
	    if (!ContentUtils.isEmptyArray(task.products)) {
	        task.products = formatProducts(task.products, task.date);
	    }
	
	    task = hydrateTaskWithIconClass(task);
	    task.process = _.get(task, 'process') || [];
	
	    return task;
	}
	
	function hydrateTaskWithIconClass(task) {
	
	    if (task) {
	        var iconTarget = _.find(DashboardServiceCache.getIcons(), function (icon) {
	            return _.get(icon, 'name', _.get(icon, 'iconDetail.name')) === task.name;
	        });
	
	        if (iconTarget) {
	            task.iconClassName = _.get(iconTarget, 'iconDetail.iconClassName');
	        }
	    }
	
	    return task;
	}
	
	function cleanTasks(tasks) {
	    return _.map(tasks, function (task) {
	        if (task) {
	            task.tasks = undefined;
	        }
	        return task;
	    });
	}
	
	function formatProducts(products, taskDate) {
	    var productsWithAmount = _.filter(products, function (product) {
	        return NumberUtils.getNumber(product.amount) > 0;
	    });
	    return _.map(productsWithAmount, function (product) {
	        var productAmount = _.get(product, 'amount');
	        var endDate = _.get(product, 'endDate') || taskDate;
	        return _.assign(product, {
	            amount: productAmount,
	            endDate: endDate,
	            id: _.get(product, 'id'),
	            items: formatItems(product.items)
	        });
	    });
	}
	
	function formatItems(productItems) {
	    return _.map(productItems, function (productItem) {
	        return _.assign(productItem, {
	            id: _.get(productItem, 'id'),
	            itemId: _.get(productItem, 'item.id'),
	            description: _.get(productItem, 'item.description'),
	            amount: productItem.manualAmount || productItem.estimateAmount || productItem.amount || productItem.defaultAmount,
	            adjustAmount: productItem.adjustAmount
	        });
	    });
	}
	
	function getAmountOfProduct(product) {
	
	    if (product) {
	        return product.manualAmount || product.estimateAmount || product.amount || product.defaultAmount;
	    }
	    return product;
	}
	
	function isSameProcessAndTask(oldOrderProcess, newOrderProcess) {
	    var oldProcessId = +_.get(oldOrderProcess, 'processId', +_.get(oldOrderProcess, 'orderProcessHydrated.id'));
	    var newProcessId = +_.get(newOrderProcess, 'processId', +_.get(newOrderProcess, 'orderProcessHydrated.id'));
	
	    //@lint-ignore
	    return oldProcessId == newProcessId;
	}
	
	/**
	 * Sort batch by date and column.
	 *
	 * NOTE: we need to add column tu batch because the sortBy of lodash dont sort by deep child attribute.
	 * @param batchs
	 * @return {*}
	 */
	function sortBatchByColumAndDate(batchs) {
	    // sort first by dates
	    var sortedBatchDates = DateUtils.sortListByDateField(batchs, 'date');
	    // group batchs by dates
	    var batchGroupByDate = _.groupBy(sortedBatchDates, 'date');
	    var sortedBatchs = [];
	    // sort individual batch dates by each column of turn
	    var batchDates = Object.keys(batchGroupByDate);
	    for (var _iterator = batchDates, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	        var _ref;
	
	        if (_isArray) {
	            if (_i >= _iterator.length) break;
	            _ref = _iterator[_i++];
	        } else {
	            _i = _iterator.next();
	            if (_i.done) break;
	            _ref = _i.value;
	        }
	
	        var batchDate = _ref;
	
	        var batchsByDate = batchGroupByDate[batchDate];
	        var batchSortedByColumns = _.sortBy(batchsByDate, 'turn.column');
	        sortedBatchs = _.union(sortedBatchs, batchSortedByColumns);
	    }
	    return sortedBatchs;
	}
	
	function getIndexTab(props) {
	    var tabsVisibles = [];
	    var isBHAllowed = props.isBHAllowed,
	        isFVAllowed = props.isFVAllowed,
	        isBTAllowed = props.isBTAllowed,
	        order = props.order,
	        tankTypeClicked = props.tankTypeClicked,
	        currentSection = props.currentSection,
	        openGeneralTab = props.openGeneralTab;
	
	
	    if (openGeneralTab) {
	        return 0;
	    }
	
	    tabsVisibles.push({ type: 'general_tab' });
	    var tankClicked = _.get(props, 'tankClicked.type') || _.get(props, 'tankClicked');
	    if (order && order.isSingle) {
	        if (tankClicked === 'BH') {
	            return 1;
	        }
	        if (_.get(order.batchs, 'length') > 0) {
	            tabsVisibles.push({ type: 'BH' });
	        }
	        if (tankClicked === 'FV') {
	            tabsVisibles.push({ type: 'FV' });
	        } else if (tankClicked === 'BT') {
	            tabsVisibles.push({ type: 'BT' });
	        }
	        return _.findIndex(tabsVisibles, function (type) {
	            return type.type === currentSection;
	        });
	    } else {
	        if (isBHAllowed) {
	            tabsVisibles.push({ type: 'BH' });
	        }
	        if (isFVAllowed) {
	            tabsVisibles.push({ type: 'FV' });
	        }
	        if (isBTAllowed) {
	            tabsVisibles.push({ type: 'BT' });
	        }
	    }
	
	    return _.findIndex(tabsVisibles, function (type) {
	        return type.type === tankTypeClicked;
	    });
	}
	
	function isEmptyProcess(process) {
	    var _ref2 = process || {},
	        toDate = _ref2.toDate,
	        toHour = _ref2.toHour,
	        fromDate = _ref2.fromDate,
	        fromHour = _ref2.fromHour,
	        note = _ref2.note;
	
	    return (note === ' ' || note === '' || !note) && !toDate && !toHour && !fromDate && !fromHour && (note === '' || !note);
	}
	
	function updateProductOfTask(task, productUpdated) {
	
	    if (task) {
	        var products = _.get(task, 'products');
	        if (ContentUtils.isEmptyArray(products)) {
	            task.products = [productUpdated];
	        } else {
	            var productTarget = _.find(products, function (product) {
	                return _.get(productUpdated, 'id') === _.get(product, 'id');
	            });
	            if (ContentUtils.isNull(productTarget)) {
	                task.products.push(productUpdated);
	            } else {
	                task.products = ContentUtils.replaceByAttributes(products, productUpdated, 'id');
	            }
	        }
	    }
	
	    return task;
	}
	
	function updateTask(tasks, newTask) {
	    var isBrewingSection = newTask && newTask.turn;
	    tasks = tasks || [];
	    var attributeMatchers = isBrewingSection ? ['date', 'turn.column'] : ['date'];
	    var taskTarget = _.find(tasks, function (task) {
	        return _.get(task, attributeMatchers) === _.get(newTask, attributeMatchers);
	    });
	    var existTask = taskTarget !== undefined;
	    // update new task
	    if (ContentUtils.isEmptyArray(tasks)) {
	        return [newTask];
	    } else {
	        if (existTask) {
	            tasks = ContentUtils.replaceByAttributes(tasks, newTask, attributeMatchers);
	        } else {
	            tasks.push(newTask);
	        }
	    }
	
	    return _.filter(tasks, function (task) {
	        return task;
	    }); // clean undefined positions
	}
	
	function changeLabelName(task, nameValue) {
	    return _.set(task, 'label', nameValue);
	}
	
	function changeLabelNote(task, nameValue) {
	    return _.set(task, 'description', nameValue);
	}
	
	function findTaskFromGivenProcess() {
	    var tasks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var process = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var processDate = void 0;
	
	    if (isBrewBatch(process)) {
	        processDate = _.get(process, 'fromDate') || _.get(process, 'date');
	    } else {
	        processDate = getDateFromTaskId(process);
	    }
	    var taskDate = _.filter(tasks, function (task) {
	        return _.get(task, 'date') === processDate;
	    });
	
	    if (_.get(taskDate, 'length') === 1) {
	        return taskDate[0];
	    }
	
	    if (isFermentingProcess(process)) {
	        return _.find(taskDate, function (task) {
	            return task.tankType === 'FERMENTER_TASK';
	        });
	    }
	
	    if (isPackagingProcess(process)) {
	        return _.find(taskDate, function (task) {
	            return task.tankType === 'PACKAGING_TASK';
	        });
	    }
	
	    var batchs = _.filter(taskDate, function (task) {
	        return task.tankType !== 'PACKAGING_TASK' && task.tankType !== 'FERMENTER_TASK';
	    });
	
	    if (_.get(batchs, 'length') === 1) {
	        return batchs[0];
	    }
	
	    return _.find(batchs, function (batch) {
	        return _.get(batch, 'taskId') === _.get(process, 'taskId');
	    });
	}
	
	function isBrewBatch(process) {
	    return process && process.processSection === 'Brewing' || process && process.processSection === 'BREWHOUSE_TASK';
	}
	
	function getDateFromTaskId(process) {
	    if (process && process.taskId) {
	        var taskId = process.taskId;
	        return taskId.substring(0, taskId.indexOf('_'));
	    }
	}
	
	function hydrateBatchWithProcess(filteredBatchs, batchs) {
	    return _.map(filteredBatchs, function (filteredBatch) {
	        var batchTarget = _.find(batchs, function (batch) {
	            return _.get(batch, 'turnId') === _.get(filteredBatch, 'turnId') && _.get(batch, 'date') === _.get(filteredBatch, 'date');
	        });
	        if (batchTarget) {
	            filteredBatch.process = batchTarget.process;
	        }
	        return filteredBatch;
	    });
	}
	
	function updateProcessFromTask(task, newProcess) {
	
	    if (task && ContentUtils.isEmptyArray(task.process)) {
	        task.process = [];
	    }
	
	    if (task) {
	        var existingProcess = _.get(task, 'process', []);
	        var processCleaned = _.filter(existingProcess, function (process) {
	            return _.get(process, 'processId') !== _.get(newProcess, 'processId');
	        }) || [];
	        var newProcessFormatted = formatOrderProcess(newProcess);
	        task.process = processCleaned.concat(newProcessFormatted);
	    }
	
	    return task;
	}
	
	function removeProcessFromTasks(tasks, process) {
	    var processId = _.get(process, 'processId');
	    var taskId = _.get(process, 'taskId');
	
	    return _.map(tasks, function (task) {
	        if (task && (_.get(task, 'taskId') === taskId || _.get(task, 'turnId') === taskId)) {
	            var existingProcess = _.get(task, 'process', []);
	            var processCleaned = _.filter(existingProcess, function (process) {
	                return _.get(process, 'processId') != processId;
	            }) || [];
	            task.process = processCleaned;
	        }
	
	        return task;
	    });
	}
	
	module.exports = {
	    formatTasksProducts: formatTasksProducts,
	    formatTasksProduct: formatTasksProduct,
	    formatProducts: formatProducts,
	    isEmptyProcess: isEmptyProcess,
	    getNonSelectedMenuItem: getNonSelectedMenuItem,
	    getAmountOfProduct: getAmountOfProduct,
	    toTankMenuItems: toTankMenuItems,
	    toConcreteTask: toConcreteTask,
	    toEmptyTask: toEmptyTask,
	    getTabSelectedIndex: getTabSelectedIndex,
	    retrieveCustomTask: retrieveCustomTask,
	    getFermenterTank: getFermenterTank,
	    getBriteTank: getBriteTank,
	    getSingleTank: getSingleTank,
	    getStyleBeer: getStyleBeer,
	    removeDefaultTaskWhenExistCustom: removeDefaultTaskWhenExistCustom,
	    formatProperOrderSelected: formatProperOrderSelected,
	    formatOrderProcess: formatOrderProcess,
	    isSameProcessAndTask: isSameProcessAndTask,
	    isToggleChange: isToggleChange,
	    addProductOrderIdToTasks: addProductOrderIdToTasks,
	    addProductOrderIdToTask: addProductOrderIdToTask,
	    sortBatchByColumAndDate: sortBatchByColumAndDate,
	    changeLabelName: changeLabelName,
	    changeLabelNote: changeLabelNote,
	    cleanTasks: cleanTasks,
	    getIndexTab: getIndexTab,
	    isSingle: isSingle,
	    setTaskIds: setTaskIds,
	    updateProductOfTask: updateProductOfTask,
	    updateTask: updateTask,
	    fillEachBatchWithProductMissing: fillEachBatchWithProductMissing,
	    hydrateOrderWithTheirProcess: hydrateOrderWithTheirProcess,
	    findTaskFromGivenProcess: findTaskFromGivenProcess,
	    isPackagingProcess: isPackagingProcess,
	    isFermentingProcess: isFermentingProcess,
	    isBrewingProcess: isBrewingProcess,
	    updateProcessFromTask: updateProcessFromTask,
	    getTasksFromProcess: getTasksFromProcess,
	    removeProcessFromTasks: removeProcessFromTasks,
	    hydrateBatchWithProcess: hydrateBatchWithProcess,
	    getDateFromTaskId: getDateFromTaskId
	};

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Helper class to handler native rest ajax call.
	 */
	
	var util = {
	    /**
	     * Return the clean current path.
	     * Ej:
	     * <code>/#/myUrl >> /myUrl</code>
	     * @returns {*}
	     */
	    getCurrentPath: function getCurrentPath() {
	        return window.location.hash.indexOf('#') > -1 ? window.location.hash.split('#')[1] : window.location.hash;
	    },
	
	
	    /**
	     * Return the value of the given cookie.
	     * @param name
	     * @returns {String}
	     */
	    getCookie: function getCookie(name) {
	        var value = '; ' + document.cookie;
	        var parts = value.split('; ' + name + '=');
	        if (parts.length === 2) {
	            return parts.pop().split(';').shift();
	        }
	    },
	    formatQueryString: function formatQueryString(filter) {
	        if (filter && JSON.stringify(filter) !== '{}') {
	            return '?' + Object.keys(filter).map(function (key) {
	                return key + '=' + filter[key];
	            }).join('&');
	        } else {
	            return '';
	        }
	    },
	
	
	    /**
	     * Return the XSRF-TOKEN value from cookie.
	     * @param name
	     * @returns {String}
	     */
	    getCookieXSRF: function getCookieXSRF() {
	        return this.getCookie('XSRF-TOKEN');
	    },
	
	
	    /**
	     * Delete the cooke defined.
	     * @param name
	     */
	    deleteCookie: function deleteCookie(name) {
	        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	    },
	
	
	    /**
	     * Delete the specific XSRF cooke defined.
	     * @param name
	     */
	    deleteXSRFCookie: function deleteXSRFCookie() {
	        document.cookie = 'XSRF-TOKEN=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	    },
	
	
	    /**
	     * Return the rest client in cross browser compatibility way.
	     * @returns {*}
	     */
	    createXHR: function createXHR() {
	        try {
	            return new XMLHttpRequest();
	        } catch (e) {
	            try {
	                return new ActiveXObject('Microsoft.XMLHTTP');
	            } catch (e) {
	                return new ActiveXObject('Msxml2.XMLHTTP');
	            }
	        }
	    },
	    getCORSSafeUrl: function getCORSSafeUrl(myUrl) {
	        //  But if you make it from a browser, then it will work without problem ...
	        // However to make it work, we are going to use the cors-anywhere free service to bypass this
	        var proxy = 'https://sheltered-waters-34503.herokuapp.com/';
	        return proxy + myUrl;
	    },
	
	
	    /**
	     * Generic handler of HTTP response.
	     * @param self
	     * @param success
	     * @param failure
	     */
	    handlerResponse: function handlerResponse(self, success, failure) {
	        if (this._isUnauthenticated(self)) {
	            window.location = '#/login?continue=' + this.getCurrentPath();
	            if (failure) {
	                failure.bind(self)();
	            }
	        } else if (this._isUnauthorized(self)) {
	            window.location = '#/login?continue=' + this.getCurrentPath();
	            if (failure) {
	                failure.bind(self)();
	            }
	        } else if (this._isFailure(self)) {
	            if (failure) {
	                failure.bind(self)(this.getMessageResonse(self.responseText));
	            }
	        } else {
	            if (success) {
	                success.bind(self)();
	            }
	        }
	    },
	
	    /**
	     * Generic handler of HTTP response, in case of any error happens, just log out.
	     * @param self
	     * @param success
	     * @param failure
	     */
	    handlerResponseWithFullLogout: function handlerResponseWithFullLogout(self, success, failure) {
	        if (this._isUnauthenticated(self)) {
	            window.location = '#/login?continue=' + this.getCurrentPath();
	            if (failure) {
	                failure.bind(self)();
	            }
	        } else if (this._isUnauthorized(self)) {
	            window.location = '#/login?continue=' + this.getCurrentPath();
	            if (failure) {
	                failure.bind(self)();
	            }
	        } else if (this._isFailure(self)) {
	            window.location = '#/login?continue=' + this.getCurrentPath();
	            if (failure) {
	                failure.bind(self)(this.getMessageResonse(self.responseText));
	            }
	        } else {
	            if (success) {
	                success.bind(self)();
	            }
	        }
	    },
	
	
	    /**
	     * Standard way to retrieve message from request response.
	     * @param response
	     * @returns {*}
	     */
	    getMessageResonse: function getMessageResonse(response) {
	        return response ? JSON.parse(response).message : response;
	    },
	    _isUnauthenticated: function _isUnauthenticated(self) {
	        return self.status === 401;
	    },
	    _isUnauthorized: function _isUnauthorized(self) {
	        return self.status === 403;
	    },
	    _isFailure: function _isFailure(self) {
	        return self.status >= 400;
	    }
	};
	
	module.exports = util;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66),
	    isObjectLike = __webpack_require__(47);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object, else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'castArray': __webpack_require__(912),
	  'clone': __webpack_require__(915),
	  'cloneDeep': __webpack_require__(916),
	  'cloneDeepWith': __webpack_require__(917),
	  'cloneWith': __webpack_require__(918),
	  'eq': __webpack_require__(87),
	  'gt': __webpack_require__(351),
	  'gte': __webpack_require__(967),
	  'isArguments': __webpack_require__(144),
	  'isArray': __webpack_require__(27),
	  'isArrayBuffer': __webpack_require__(979),
	  'isArrayLike': __webpack_require__(66),
	  'isArrayLikeObject': __webpack_require__(52),
	  'isBoolean': __webpack_require__(980),
	  'isBuffer': __webpack_require__(488),
	  'isDate': __webpack_require__(981),
	  'isElement': __webpack_require__(982),
	  'isEmpty': __webpack_require__(983),
	  'isEqual': __webpack_require__(984),
	  'isEqualWith': __webpack_require__(985),
	  'isError': __webpack_require__(352),
	  'isFinite': __webpack_require__(986),
	  'isFunction': __webpack_require__(67),
	  'isInteger': __webpack_require__(489),
	  'isLength': __webpack_require__(164),
	  'isMap': __webpack_require__(987),
	  'isMatch': __webpack_require__(988),
	  'isMatchWith': __webpack_require__(989),
	  'isNaN': __webpack_require__(990),
	  'isNative': __webpack_require__(490),
	  'isNil': __webpack_require__(991),
	  'isNull': __webpack_require__(992),
	  'isNumber': __webpack_require__(491),
	  'isObject': __webpack_require__(46),
	  'isObjectLike': __webpack_require__(47),
	  'isPlainObject': __webpack_require__(353),
	  'isRegExp': __webpack_require__(492),
	  'isSafeInteger': __webpack_require__(993),
	  'isSet': __webpack_require__(994),
	  'isString': __webpack_require__(117),
	  'isSymbol': __webpack_require__(493),
	  'isTypedArray': __webpack_require__(165),
	  'isUndefined': __webpack_require__(995),
	  'isWeakMap': __webpack_require__(996),
	  'isWeakSet': __webpack_require__(997),
	  'lt': __webpack_require__(354),
	  'lte': __webpack_require__(1005),
	  'toArray': __webpack_require__(504),
	  'toInteger': __webpack_require__(31),
	  'toLength': __webpack_require__(505),
	  'toNumber': __webpack_require__(145),
	  'toPlainObject': __webpack_require__(507),
	  'toSafeInteger': __webpack_require__(1087),
	  'toString': __webpack_require__(34)
	};


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(328),
	    baseKeys = __webpack_require__(846),
	    indexKeys = __webpack_require__(467),
	    isArrayLike = __webpack_require__(66),
	    isIndex = __webpack_require__(114),
	    isPrototype = __webpack_require__(346);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var PropTypes = __webpack_require__(171);
	var Transitions = __webpack_require__(24);
	
	var Paper = React.createClass({
	  displayName: 'Paper',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    circle: React.PropTypes.bool,
	    rounded: React.PropTypes.bool,
	    transitionEnabled: React.PropTypes.bool,
	    zDepth: PropTypes.zDepth
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      circle: false,
	      rounded: true,
	      transitionEnabled: true,
	      zDepth: 1
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var circle = _props.circle;
	    var rounded = _props.rounded;
	    var style = _props.style;
	    var transitionEnabled = _props.transitionEnabled;
	    var zDepth = _props.zDepth;
	
	    var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	
	    var styles = {
	      backgroundColor: this.context.muiTheme.component.paper.backgroundColor,
	      transition: transitionEnabled && Transitions.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: this.context.muiTheme.contentFontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      boxShadow: this._getZDepthShadows(zDepth),
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    };
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles, style) }),
	      children
	    );
	  },
	
	  _getZDepthShadows: function _getZDepthShadows(zDepth) {
	    var shadows = [null, '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)', '0 3px 10px rgba(0, 0, 0, 0.16), 0 3px 10px rgba(0, 0, 0, 0.23)', '0 10px 30px rgba(0, 0, 0, 0.19), 0 6px 10px rgba(0, 0, 0, 0.23)', '0 14px 45px rgba(0, 0, 0, 0.25), 0 10px 18px rgba(0, 0, 0, 0.22)', '0 19px 60px rgba(0, 0, 0, 0.30), 0 15px 20px rgba(0, 0, 0, 0.22)'];
	
	    return shadows[zDepth];
	  }
	
	});
	
	module.exports = Paper;

/***/ },
/* 56 */
/***/ function(module, exports) {

	// To include this file in your project:
	// let mui = require('mui');
	// let Colors = mui.Styles.Colors;
	
	'use strict';
	
	module.exports = {
	
	  red50: '#ffebee',
	  red100: '#ffcdd2',
	  red200: '#ef9a9a',
	  red300: '#e57373',
	  red400: '#ef5350',
	  red500: '#f44336',
	  red600: '#e53935',
	  red700: '#d32f2f',
	  red800: '#c62828',
	  red900: '#b71c1c',
	  redA100: '#ff8a80',
	  redA200: '#ff5252',
	  redA400: '#ff1744',
	  redA700: '#d50000',
	
	  pink50: '#fce4ec',
	  pink100: '#f8bbd0',
	  pink200: '#f48fb1',
	  pink300: '#f06292',
	  pink400: '#ec407a',
	  pink500: '#e91e63',
	  pink600: '#d81b60',
	  pink700: '#c2185b',
	  pink800: '#ad1457',
	  pink900: '#880e4f',
	  pinkA100: '#ff80ab',
	  pinkA200: '#ff4081',
	  pinkA400: '#f50057',
	  pinkA700: '#c51162',
	
	  purple50: '#f3e5f5',
	  purple100: '#e1bee7',
	  purple200: '#ce93d8',
	  purple300: '#ba68c8',
	  purple400: '#ab47bc',
	  purple500: '#9c27b0',
	  purple600: '#8e24aa',
	  purple700: '#7b1fa2',
	  purple800: '#6a1b9a',
	  purple900: '#4a148c',
	  purpleA100: '#ea80fc',
	  purpleA200: '#e040fb',
	  purpleA400: '#d500f9',
	  purpleA700: '#aa00ff',
	
	  deepPurple50: '#ede7f6',
	  deepPurple100: '#d1c4e9',
	  deepPurple200: '#b39ddb',
	  deepPurple300: '#9575cd',
	  deepPurple400: '#7e57c2',
	  deepPurple500: '#673ab7',
	  deepPurple600: '#5e35b1',
	  deepPurple700: '#512da8',
	  deepPurple800: '#4527a0',
	  deepPurple900: '#311b92',
	  deepPurpleA100: '#b388ff',
	  deepPurpleA200: '#7c4dff',
	  deepPurpleA400: '#651fff',
	  deepPurpleA700: '#6200ea',
	
	  indigo50: '#e8eaf6',
	  indigo100: '#c5cae9',
	  indigo200: '#9fa8da',
	  indigo300: '#7986cb',
	  indigo400: '#5c6bc0',
	  indigo500: '#3f51b5',
	  indigo600: '#3949ab',
	  indigo700: '#303f9f',
	  indigo800: '#283593',
	  indigo900: '#1a237e',
	  indigoA100: '#8c9eff',
	  indigoA200: '#536dfe',
	  indigoA400: '#3d5afe',
	  indigoA700: '#304ffe',
	
	  blue50: '#e3f2fd',
	  blue100: '#bbdefb',
	  blue200: '#90caf9',
	  blue300: '#64b5f6',
	  blue400: '#42a5f5',
	  blue500: '#2196f3',
	  blue600: '#1e88e5',
	  blue700: '#1976d2',
	  blue800: '#1565c0',
	  blue900: '#0d47a1',
	  blueA100: '#82b1ff',
	  blueA200: '#448aff',
	  blueA400: '#2979ff',
	  blueA700: '#2962ff',
	
	  lightBlue50: '#e1f5fe',
	  lightBlue100: '#b3e5fc',
	  lightBlue200: '#81d4fa',
	  lightBlue300: '#4fc3f7',
	  lightBlue400: '#29b6f6',
	  lightBlue500: '#03a9f4',
	  lightBlue600: '#039be5',
	  lightBlue700: '#0288d1',
	  lightBlue800: '#0277bd',
	  lightBlue900: '#01579b',
	  lightBlueA100: '#80d8ff',
	  lightBlueA200: '#40c4ff',
	  lightBlueA400: '#00b0ff',
	  lightBlueA700: '#0091ea',
	
	  cyan50: '#e0f7fa',
	  cyan100: '#b2ebf2',
	  cyan200: '#80deea',
	  cyan300: '#4dd0e1',
	  cyan400: '#26c6da',
	  cyan500: '#00bcd4',
	  cyan600: '#00acc1',
	  cyan700: '#0097a7',
	  cyan800: '#00838f',
	  cyan900: '#006064',
	  cyanA100: '#84ffff',
	  cyanA200: '#18ffff',
	  cyanA400: '#00e5ff',
	  cyanA700: '#00b8d4',
	
	  teal50: '#e0f2f1',
	  teal100: '#b2dfdb',
	  teal200: '#80cbc4',
	  teal300: '#4db6ac',
	  teal400: '#26a69a',
	  teal500: '#009688',
	  teal600: '#00897b',
	  teal700: '#00796b',
	  teal800: '#00695c',
	  teal900: '#004d40',
	  tealA100: '#a7ffeb',
	  tealA200: '#64ffda',
	  tealA400: '#1de9b6',
	  tealA700: '#00bfa5',
	
	  green50: '#e8f5e9',
	  green100: '#c8e6c9',
	  green200: '#a5d6a7',
	  green300: '#81c784',
	  green400: '#66bb6a',
	  green500: '#4caf50',
	  green600: '#43a047',
	  green700: '#388e3c',
	  green800: '#2e7d32',
	  green900: '#1b5e20',
	  greenA100: '#b9f6ca',
	  greenA200: '#69f0ae',
	  greenA400: '#00e676',
	  greenA700: '#00c853',
	
	  lightGreen50: '#f1f8e9',
	  lightGreen100: '#dcedc8',
	  lightGreen200: '#c5e1a5',
	  lightGreen300: '#aed581',
	  lightGreen400: '#9ccc65',
	  lightGreen500: '#8bc34a',
	  lightGreen600: '#7cb342',
	  lightGreen700: '#689f38',
	  lightGreen800: '#558b2f',
	  lightGreen900: '#33691e',
	  lightGreenA100: '#ccff90',
	  lightGreenA200: '#b2ff59',
	  lightGreenA400: '#76ff03',
	  lightGreenA700: '#64dd17',
	
	  lime50: '#f9fbe7',
	  lime100: '#f0f4c3',
	  lime200: '#e6ee9c',
	  lime300: '#dce775',
	  lime400: '#d4e157',
	  lime500: '#cddc39',
	  lime600: '#c0ca33',
	  lime700: '#afb42b',
	  lime800: '#9e9d24',
	  lime900: '#827717',
	  limeA100: '#f4ff81',
	  limeA200: '#eeff41',
	  limeA400: '#c6ff00',
	  limeA700: '#aeea00',
	
	  yellow50: '#fffde7',
	  yellow100: '#fff9c4',
	  yellow200: '#fff59d',
	  yellow300: '#fff176',
	  yellow400: '#ffee58',
	  yellow500: '#ffeb3b',
	  yellow600: '#fdd835',
	  yellow700: '#fbc02d',
	  yellow800: '#f9a825',
	  yellow900: '#f57f17',
	  yellowA100: '#ffff8d',
	  yellowA200: '#ffff00',
	  yellowA400: '#ffea00',
	  yellowA700: '#ffd600',
	
	  amber50: '#fff8e1',
	  amber100: '#ffecb3',
	  amber200: '#ffe082',
	  amber300: '#ffd54f',
	  amber400: '#ffca28',
	  amber500: '#ffc107',
	  amber600: '#ffb300',
	  amber700: '#ffa000',
	  amber800: '#ff8f00',
	  amber900: '#ff6f00',
	  amberA100: '#ffe57f',
	  amberA200: '#ffd740',
	  amberA400: '#ffc400',
	  amberA700: '#ffab00',
	
	  orange50: '#fff3e0',
	  orange100: '#ffe0b2',
	  orange200: '#ffcc80',
	  orange300: '#ffb74d',
	  orange400: '#ffa726',
	  orange500: '#ff9800',
	  orange600: '#fb8c00',
	  orange700: '#f57c00',
	  orange800: '#ef6c00',
	  orange900: '#e65100',
	  orangeA100: '#ffd180',
	  orangeA200: '#ffab40',
	  orangeA400: '#ff9100',
	  orangeA700: '#ff6d00',
	
	  deepOrange50: '#fbe9e7',
	  deepOrange100: '#ffccbc',
	  deepOrange200: '#ffab91',
	  deepOrange300: '#ff8a65',
	  deepOrange400: '#ff7043',
	  deepOrange500: '#ff5722',
	  deepOrange600: '#f4511e',
	  deepOrange700: '#e64a19',
	  deepOrange800: '#d84315',
	  deepOrange900: '#bf360c',
	  deepOrangeA100: '#ff9e80',
	  deepOrangeA200: '#ff6e40',
	  deepOrangeA400: '#ff3d00',
	  deepOrangeA700: '#dd2c00',
	
	  brown50: '#efebe9',
	  brown100: '#d7ccc8',
	  brown200: '#bcaaa4',
	  brown300: '#a1887f',
	  brown400: '#8d6e63',
	  brown500: '#795548',
	  brown600: '#6d4c41',
	  brown700: '#5d4037',
	  brown800: '#4e342e',
	  brown900: '#3e2723',
	
	  blueGrey50: '#eceff1',
	  blueGrey100: '#cfd8dc',
	  blueGrey200: '#b0bec5',
	  blueGrey300: '#90a4ae',
	  blueGrey400: '#78909c',
	  blueGrey500: '#607d8b',
	  blueGrey600: '#546e7a',
	  blueGrey700: '#455a64',
	  blueGrey800: '#37474f',
	  blueGrey900: '#263238',
	
	  grey50: '#fafafa',
	  grey100: '#f5f5f5',
	  grey200: '#eeeeee',
	  grey300: '#e0e0e0',
	  grey400: '#bdbdbd',
	  grey500: '#9e9e9e',
	  grey600: '#757575',
	  grey700: '#616161',
	  grey800: '#424242',
	  grey900: '#212121',
	
	  black: '#000000',
	  white: '#ffffff',
	
	  transparent: 'rgba(0, 0, 0, 0)',
	  fullBlack: 'rgba(0, 0, 0, 1)',
	  darkBlack: 'rgba(0, 0, 0, 0.87)',
	  lightBlack: 'rgba(0, 0, 0, 0.54)',
	  minBlack: 'rgba(0, 0, 0, 0.26)',
	  faintBlack: 'rgba(0, 0, 0, 0.12)',
	  fullWhite: 'rgba(255, 255, 255, 1)',
	  darkWhite: 'rgba(255, 255, 255, 0.87)',
	  lightWhite: 'rgba(255, 255, 255, 0.54)'
	
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(177);
	
	var PropagationPhases = keyMirror({bubbled: null, captured: null});
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topBlur: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topReset: null,
	  topScroll: null,
	  topSelectionChange: null,
	  topSubmit: null,
	  topTextInput: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    mui = __webpack_require__(12),
	    ContentUtils = __webpack_require__(7),
	    ComponentUtils = __webpack_require__(77),
	    Constants = __webpack_require__(2),
	    set = __webpack_require__(5).set,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    _require3 = __webpack_require__(48),
	    union = _require3.union,
	    BasicFormGroup = __webpack_require__(94),
	    SelectField = mui.SelectField;
	
	
	var FormGroupDropdown = React.createClass({ displayName: "FormGroupDropdown",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        onChange: PropTypes.func,
	        onBlur: PropTypes.func,
	        outputMapper: PropTypes.object,
	        isImmutable: PropTypes.bool,
	        isEditMode: PropTypes.bool,
	        onEnter: PropTypes.func,
	
	        // Input fields ------------------------
	
	        /**
	         * The list of items which will be used to generate the MenuItem
	         */
	        items: PropTypes.array.isRequired,
	
	        /**
	         * This attribute are several proposes. For instance:
	         * As a `displayName` of given Menu item list ({@link items}).
	         * Also is used this attribute to read each menu item of Dropdown attribute, when
	         * need to know which menu item are selected.
	         */
	        readerAttribute: PropTypes.string,
	
	        /**
	         * This attribute will be use against to {@link value} props to retrieve the
	         * information needed from outside selected value. Will be use to match outer
	         * value which internal menu item.
	         */
	        readerAttributeValue: PropTypes.string,
	
	        // Output field ------------------------
	
	        /**
	         * This is attribute will use to write the name of the attribute when submit the form.
	         * (Optionally) When it doesn't defined we will use by default {@link readerAttribute}
	         */
	        writerAttribute: PropTypes.string,
	
	        /**
	         * This attribute allow us to specify the field will take at the moment
	         * to write the value of selected item.
	         */
	        customReaderWriterAttribute: PropTypes.string,
	
	        /**
	         * Is the value which are selected from outside of menu item. So we need to use
	         * {@link readerAttributeValue} in order to know which MenuItem
	         * are related to this outer `value`, specially when need to know which index of menu item
	         * are need to be selected.
	         */
	        value: PropTypes.string,
	
	        /**
	         * Indicate that special character validation will not be performed.
	         */
	        isRelaxedText: PropTypes.bool,
	        /**
	         * Indicate that special character validation will not be performed.
	         */
	        isFullRelaxedText: PropTypes.bool
	
	    }),
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedMenuItemIndex: 0,
	            selectedMenuItem: null,
	            selectedMenuItemIndexConsumer: -1,
	            resetSelection: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {
	        this.setState({
	            selectedMenuItemIndex: 0,
	            selectedMenuItem: null,
	            selectedMenuItemIndexConsumer: -1,
	            resetSelection: true,
	            isFocus: false
	        });
	    },
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            outputMapper = _props.outputMapper,
	            readerAttribute = _props.readerAttribute,
	            customReaderWriterAttribute = _props.customReaderWriterAttribute;
	
	        var currentValue = this._getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute);
	
	        var wrapper = {};
	        var safeWriterAttribute = writerAttribute || readerAttribute; // make writer attribute optionally
	
	        if (outputMapper) {
	            var keyOutput = outputMapper[currentValue];
	            wrapper = set(wrapper, safeWriterAttribute, keyOutput);
	        } else {
	            wrapper = set(wrapper, safeWriterAttribute, currentValue);
	        }
	
	        return wrapper;
	    },
	    _updateWithOnBlurSelected: function _updateWithOnBlurSelected(callback) {
	        if (this.refs && this.refs.dropdownEl) {
	            var currentItemSelectedEl = this.refs.dropdownEl.getDOMNode().querySelector('.form-group-dropdown-input div');
	
	            var haveItemSelected = currentItemSelectedEl && currentItemSelectedEl.innerText;
	            var haveItemsDefined = ContentUtils.isNotEmptyArray(this.props.items);
	
	            if (haveItemSelected && haveItemsDefined) {
	                var itemSelectedText = currentItemSelectedEl.innerText.trim();
	                var itemSelectedIndex = this._getIndexOfMenuItem(itemSelectedText);
	
	                this.setState({
	                    selectedMenuItem: { payload: itemSelectedIndex, text: itemSelectedText, itemModel: itemSelectedText },
	                    selectedMenuItemIndex: itemSelectedIndex,
	                    isFocus: false
	                }, function () {
	                    if (callback) {
	                        callback();
	                    }
	                });
	            }
	        } else {
	            if (callback) {
	                callback();
	            }
	        }
	    },
	    _getIndexOfMenuItem: function _getIndexOfMenuItem(textTarget) {
	        var _this = this;
	
	        var isMenuItemObject = _typeof(this.props.items[0]) === 'object';
	        var isMenuItemNumber = typeof this.props.items[0] === 'number';
	        var menuItemTexts = void 0;
	
	        if (isMenuItemObject) {
	            menuItemTexts = this.props.items.map(function (item) {
	                return get(item, 'name', get(item, 'description', get(item, _this.props.readerAttribute)));
	            });
	        } else if (isMenuItemNumber) {
	            menuItemTexts = this.props.items;
	            return menuItemTexts.indexOf(+textTarget) + 1;
	        } else {
	            menuItemTexts = this.props.items;
	        }
	
	        if (menuItemTexts) {
	            return menuItemTexts.indexOf(textTarget) + 1;
	        }
	    },
	    isValid: function isValid() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            name = _props2.name,
	            additionalValidation = _props2.additionalValidation,
	            additionalValidationFieldName = _props2.additionalValidationFieldName,
	            isRequired = _props2.isRequired,
	            isRelaxedText = _props2.isRelaxedText,
	            isFullRelaxedText = _props2.isFullRelaxedText,
	            readerAttribute = _props2.readerAttribute,
	            onBlur = _props2.onBlur,
	            items = _props2.items;
	
	        var messageError = '';
	        var selectedMenuItemValue = void 0;
	
	        if (ContentUtils.isNull(isRequired)) {
	            isRequired = true;
	        }
	
	        if (!isRequired) {
	            this.setState({ messageError: '' });
	            return messageError === '';
	        }
	
	        if (this.state.selectedMenuItemIndex > 0) {
	            selectedMenuItemValue = this._getSelectedMenuItemValue(readerAttribute);
	            messageError = this._checkSelectedMenuItemValue(isFullRelaxedText, isRelaxedText, selectedMenuItemValue);
	        } else {
	            messageError = ContentUtils.isValidText(null, name);
	        }
	
	        if (additionalValidationFieldName) {
	            var itemSelected = get(items, '' + (this.state.selectedMenuItemIndex - 1));
	            var attributeValue = get(itemSelected, additionalValidationFieldName);
	            if (!messageError && additionalValidation) {
	                messageError = additionalValidation(attributeValue);
	            }
	        } else {
	            if (!messageError && additionalValidation) {
	                messageError = additionalValidation(selectedMenuItemValue);
	            }
	        }
	
	        this.setState({ messageError: messageError }, function () {
	            if (onBlur) {
	                onBlur(get(_this2.state, 'selectedMenuItem.itemModel'));
	            }
	        });
	        return messageError === '';
	    },
	    _getSelectedMenuItemValue: function _getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute) {
	        var itemValue = this.props.items[this.state.selectedMenuItemIndex - 1];
	        var itemModel = void 0;
	
	        if (isStringOrIntegerItem(itemValue)) {
	            itemModel = get(this.state, 'selectedMenuItem.itemModel');
	        } else {
	            var attribute = customReaderWriterAttribute || readerAttribute || 'text';
	            itemModel = get(itemValue, attribute);
	        }
	
	        if (isStringOrIntegerItem(itemModel)) {
	            // enter here means that current MenuItem is just simple text or number
	            // which means that item model are the value it self
	            return itemModel;
	        } else {
	            return get(itemModel, customReaderWriterAttribute || readerAttribute || 'text');
	        }
	    },
	    _onChange: function _onChange(evt, index, menuItem) {
	        this.setState({
	            selectedMenuItem: menuItem,
	            selectedMenuItemIndex: menuItem.payload
	        });
	
	        if (this.props.onChange) {
	            this.props.onChange(evt, index, menuItem);
	        }
	    },
	    _resolveIndex: function _resolveIndex(menuItems) {
	        var _props3 = this.props,
	            value = _props3.value,
	            readerAttribute = _props3.readerAttribute,
	            readerAttributeValue = _props3.readerAttributeValue;
	
	        var selectedMenuItemIndex = get(this.state, 'selectedMenuItemIndex', 0);
	
	        if (!value || this.state.resetSelection) {
	            // enter here means that was trigger the clean of Dropdown, so reset their position
	            // or just the `value` is not defined
	            this.state.resetSelection = false;
	            return selectedMenuItemIndex;
	        }
	
	        var safeReaderAttributeValue = readerAttributeValue || readerAttribute; // make optionally reader attribute value
	
	        // Search the index of item that was defined by the consumer
	        // from `selectedMenuItem` and assign the properly `index` position.
	        var selectedMenuItemConsumer = find(menuItems, function (item, index) {
	            item.index = index;
	            // add item object in order to help to find properly index
	            var itemModel = get(item, 'itemModel', item);
	            var resultOne = getAttributeValue(itemModel, safeReaderAttributeValue);
	            var resultTwo = getAttributeValue(value, safeReaderAttributeValue);
	
	            return resultTwo !== undefined && resultOne !== undefined && resultOne === resultTwo;
	        });
	
	        var isValueChanged = selectedMenuItemConsumer && this.state.selectedMenuItemIndexConsumer != selectedMenuItemConsumer.index;
	
	        if (isValueChanged) {
	            // Enter here means that the consumer change the `value`
	            // of drop down, this change came from out side of Drop
	            // down component , generally from select another row of the table.
	            this.state.selectedMenuItemIndexConsumer = selectedMenuItemConsumer.index;
	            this.state.selectedMenuItemIndex = selectedMenuItemConsumer.index;
	            this.state.selectedMenuItem = selectedMenuItemConsumer;
	            return selectedMenuItemConsumer.index;
	        } else {
	            // Enter here means that was changed the Menu Item of the component
	            // The change came from inside of drop down
	            this.state.selectedMenuItem = get(this.state, 'selectedMenuItem');
	            this.state.selectedMenuItemIndex = selectedMenuItemIndex;
	            return selectedMenuItemIndex;
	        }
	    },
	    _checkSelectedMenuItemValue: function _checkSelectedMenuItemValue(isFullRelaxedText, isRelaxedText, selectedMenuItemValue) {
	        return isFullRelaxedText ? '' // empty string means is valid
	        : isRelaxedText ? ContentUtils.isValidTextNotRequiredWithCustomValidation(selectedMenuItemValue, name, Constants.REGEX_NAME_RELAXED) : ContentUtils.isValidText(selectedMenuItemValue, name);
	    },
	    _setFocus: function _setFocus() {
	        this.setState({
	            isFocus: true
	        });
	    },
	    render: function render() {
	        var _props4 = this.props,
	            isDisabled = _props4.isDisabled,
	            items = _props4.items,
	            isDark = _props4.isDark,
	            isImmutable = _props4.isImmutable,
	            isEditMode = _props4.isEditMode,
	            name = _props4.name,
	            readerAttribute = _props4.readerAttribute;
	
	
	        var menuItems = buildItems(items, readerAttribute, name) || [];
	        var indexValue = this._resolveIndex(menuItems);
	        var dropdownClassName = 'form-group form-group-dropdown';
	
	        if (isDark) {
	            dropdownClassName += ' is-dark';
	        }
	
	        if (this.state.isFocus) {
	            dropdownClassName += ' is-active';
	        }
	
	        var isDisabledInput = !!isDisabled || isImmutable && isEditMode;
	
	        dropdownClassName += isDisabledInput ? ' is-disabled' : '';
	
	        return React.createElement("div", { className: dropdownClassName }, React.createElement(SelectField, {
	            className: 'form-group-dropdown-input',
	            ref: "dropdownEl",
	            labelStyle: { color: '#fff', fontWeight: '300' },
	            onChange: this._onChange,
	            onEnterKeyDown: this.props.onEnter,
	            onBlur: this._updateWithOnBlurSelected.bind(this, this.isValid),
	            onFocus: this._setFocus,
	            floatingLabelStyle: { color: '#fff !important', fontWeight: '300' },
	            menuItems: menuItems,
	            selectedIndex: indexValue,
	            style: { width: '100%' },
	            errorText: get(this.state, 'messageError', ''),
	            disabled: isDisabledInput }));
	    }
	});
	
	/**
	 * Ask if given item is just text or an object. In case that is case, just
	 * retrieve them. Otherwise retrieve the attribute value of given object.
	 * @param item          {String | Object}
	 * @param attribute     {String}
	 * @return {string}
	 */
	function getAttributeValue(item, attribute) {
	    return typeof item === 'string' || typeof item === 'number' ? item : get(item, attribute);
	}
	
	function buildItems(items, readerAttribute, name) {
	    if (get(items, 'length', 0) > 0) {
	        if (isStringOrIntegerItem(items)) {
	            return ComponentUtils.toMenuItemsText(items, name);
	        } else {
	            var nonSelectItem = [{ payload: 0, text: t('select') + ' ' + name }];
	            return union(nonSelectItem, ComponentUtils.toMenuItems(items, readerAttribute, 'icon'));
	        }
	    } else {
	        // return empty selected
	        return [{ payload: 0, text: t('select') + ' ' + name }];
	    }
	}
	
	/**
	 * Check if given {@param value} if are string or number.
	 * @param {Object || Array} value
	 * @return {boolean}
	 */
	function isStringOrIntegerItem(value) {
	
	    if (value === undefined || value === null) {
	        return false;
	    }
	
	    return typeof value[0] === 'string' || typeof value[0] === 'number' || typeof value === 'number' || typeof value === 'string';
	}
	
	module.exports = FormGroupDropdown;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//const {COLUMN_HIGHT} = require('constants/AppConstants');
	
	var COLUMN_HIGHT = 50;
	
	var _require = __webpack_require__(37),
	    delay = _require.delay;
	
	var SessionStore = __webpack_require__(11);
	
	var relativeToViewport = void 0;
	
	var style = function style(element, prop) {
	    return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
	};
	
	var overflow = function overflow(element) {
	    return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
	};
	
	function isRelativeToViewport() {
	    if (relativeToViewport != null) return relativeToViewport;
	
	    var x = window.pageXOffset ? window.pageXOffset + window.innerWidth - 1 : 0;
	    var y = window.pageYOffset ? window.pageYOffset + window.innerHeight - 1 : 0;
	    if (x === 0 && y === 0) return true;
	
	    // Test with a point larger than the viewport. If it returns an element,
	    // then that means elementFromPoint takes page coordinates.
	    return relativeToViewport = !document.elementFromPoint(x, y);
	}
	
	var Util = {
	    elementFromPoint: function elementFromPoint(x, y) {
	        if (!isRelativeToViewport()) x += window.pageXOffset, y += window.pageYOffset;
	
	        return document.elementFromPoint(x, y);
	    },
	    closestFixed: function closestFixed(elm) {
	        if (window.getComputedStyle(elm).position === 'fixed') {
	            return elm;
	        } else {
	            if (elm.parentElement && !/body|html/.test(elm.parentElement.tagName.toLowerCase())) {
	                return this.closestFixed(elm.parentElement);
	            } else {
	                return null;
	            }
	        }
	    },
	    scrollTo: function scrollTo(to, scrolleableElement, callback) {
	        if (scrolleableElement) {
	            scrolleableElement.scrollTop = to;
	        } else {
	            window.scroll(0, to);
	        }
	
	        if (callback && typeof callback === 'function') {
	            delay(callback, 1000);
	        }
	    },
	    elementScrollTop: function elementScrollTop(element, manualOffset) {
	        var scrollTopValue = 0;
	        if (element && element.offsetParent) {
	            do {
	                if (manualOffset) {
	                    scrollTopValue += element.offsetTop + manualOffset;
	                } else {
	                    scrollTopValue += element.offsetTop;
	                }
	            } while (element === element.offsetParent);
	        }
	        return scrollTopValue;
	    },
	    elementScrollBottom: function elementScrollBottom(element, manualOffset) {
	        var scrollTopValue = 0;
	        if (element && element.offsetParent) {
	            do {
	                if (manualOffset) {
	                    scrollTopValue += element.offsetTop + manualOffset - window.innerHeight + SessionStore.getHeaderHigh() + COLUMN_HIGHT;
	                } else {
	                    scrollTopValue += element.offsetTop - window.innerHeight + SessionStore.getHeaderHigh() + COLUMN_HIGHT;
	                }
	            } while (element === element.offsetParent);
	        }
	        return scrollTopValue;
	    },
	    disableScrolling: function disableScrolling() {
	        if (window.addEventListener) // older FF
	            window.addEventListener('DOMMouseScroll', preventDefault, false);
	        window.onwheel = preventDefault; // modern standard
	        window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
	        window.ontouchmove = preventDefault; // mobile
	        document.onkeydown = preventDefaultForScrollKeys;
	    },
	    enableScrolling: function enableScrolling() {
	        if (window.removeEventListener) window.removeEventListener('DOMMouseScroll', preventDefault, false);
	        window.onmousewheel = document.onmousewheel = null;
	        window.onwheel = null;
	        window.ontouchmove = null;
	        document.onkeydown = null;
	    },
	    getParentScroll: function getParentScroll(element) {
	        if (!(element instanceof HTMLElement)) {
	            return window;
	        }
	
	        var parent = element;
	
	        while (parent) {
	            if (!parent.parentNode) {
	                return window;
	            }
	
	            if (/(scroll|auto)/.test(overflow(parent))) {
	                return parent;
	            }
	
	            parent = parent.parentNode;
	        }
	
	        return window;
	    },
	    getHeaderTankClickedId: function getHeaderTankClickedId(clientX) {
	        var MAX_PIXEL_CHECKED = 500;
	        for (var positionY = 0; positionY < MAX_PIXEL_CHECKED; positionY += 2) {
	            var currentElementClicked = this.elementFromPoint(clientX, positionY); // The distance of the header
	            if (currentElementClicked.classList.contains('fixed-header-tank-name') || currentElementClicked.classList.contains('react-grid-item')) {
	                return currentElementClicked.getAttribute('data-tank-id');
	            }
	        }
	    }
	};
	
	var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
	
	function preventDefault() {}
	
	function preventDefaultForScrollKeys(e) {
	    if (keys[e.keyCode]) {
	        preventDefault(e);
	        return false;
	    }
	}
	
	module.exports = Util;

/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module, global) {var checkGlobal = __webpack_require__(857);
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(freeExports && freeModule && typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(objectTypes[typeof self] && self);
	
	/** Detect free variable `window`. */
	var freeWindow = checkGlobal(objectTypes[typeof window] && window);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(objectTypes[typeof this] && this);
	
	/**
	 * Used as a reference to the global object.
	 *
	 * The `this` value is used if it's the global object to avoid Greasemonkey's
	 * restricted `window` object, otherwise the `window` object is used.
	 */
	var root = freeGlobal ||
	  ((freeWindow !== (thisGlobal && thisGlobal.window)) && freeWindow) ||
	    freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(226)(module), (function() { return this; }())))

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isBrowser = typeof window !== 'undefined';
	var Modernizr = isBrowser ? __webpack_require__(540) : undefined;
	
	//Keep track of already prefixed keys so we can skip Modernizr prefixing
	var prefixedKeys = {};
	
	module.exports = {
	
	  all: function all(styles) {
	    var prefixedStyle = {};
	    for (var key in styles) {
	      prefixedStyle[this.single(key)] = styles[key];
	    }
	    return prefixedStyle;
	  },
	
	  set: function set(style, key, value) {
	    style[this.single(key)] = value;
	  },
	
	  single: function single(key) {
	
	    //If a browser doesn't exist, we can't prefix with Modernizr so
	    //just return the key
	    if (!isBrowser) return key;
	
	    //Check if we've prefixed this key before, just return it
	    if (prefixedKeys.hasOwnProperty(key)) return prefixedKeys[key];
	
	    //Key hasn't been prefixed yet, prefix with Modernizr
	    var prefKey = Modernizr.prefixed(key);
	
	    // Windows 7 Firefox has an issue with the implementation of Modernizr.prefixed
	    // and is capturing 'false' as the CSS property name instead of the non-prefixed version.
	    if (prefKey === false) return key;
	
	    //Save the key off for the future and return the prefixed key
	    prefixedKeys[key] = prefKey;
	    return prefKey;
	  },
	
	  singleHyphened: function singleHyphened(key) {
	    var str = this.single(key);
	
	    return !str ? key : str.replace(/([A-Z])/g, function (str, m1) {
	      return '-' + m1.toLowerCase();
	    }).replace(/^ms-/, '-ms-');
	  }
	
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	
	var SvgIcon = React.createClass({
	  displayName: 'SvgIcon',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    color: React.PropTypes.string,
	    hoverColor: React.PropTypes.string,
	    onMouseEnter: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    viewBox: React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      viewBox: '0 0 24 24'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var color = _props.color;
	    var hoverColor = _props.hoverColor;
	    var onMouseEnter = _props.onMouseEnter;
	    var onMouseLeave = _props.onMouseLeave;
	    var style = _props.style;
	    var viewBox = _props.viewBox;
	
	    var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	
	    var offColor = color ? color : style && style.fill ? style.fill : this.context.muiTheme.palette.textColor;
	    var onColor = hoverColor ? hoverColor : offColor;
	
	    var mergedStyles = this.mergeAndPrefix({
	      display: 'inline-block',
	      height: 24,
	      width: 24,
	      userSelect: 'none',
	      transition: Transitions.easeOut()
	    }, style, {
	      // Make sure our fill color overrides fill provided in props.style
	      fill: this.state.hovered ? onColor : offColor
	    });
	
	    var events = hoverColor ? {
	      onMouseEnter: this._handleMouseEnter,
	      onMouseLeave: this._handleMouseLeave
	    } : {};
	
	    return React.createElement(
	      'svg',
	      _extends({}, other, events, {
	        style: mergedStyles,
	        viewBox: viewBox }),
	      children
	    );
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  }
	});
	
	module.exports = SvgIcon;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Dispatcher = __webpack_require__(42),
	    Constants = __webpack_require__(2),
	    ActionType = Constants.ActionTypes,
	    DashboardActionCreators = {
	  addOrderDraft: function addOrderDraft(order) {
	    Dispatcher.dispatch({
	      type: ActionType.NEW_ORDER_DRAFT,
	      order: order
	    });
	  },
	  fetchScheduleBoardByDate: function fetchScheduleBoardByDate(date) {
	    Dispatcher.dispatch({
	      type: ActionType.FETCH_SCHEDULE_BOARD,
	      date: date
	    });
	  },
	  saveChangedUserTaskName: function saveChangedUserTaskName(_ref) {
	    var date = _ref.date,
	        name = _ref.name,
	        id = _ref.id,
	        originalName = _ref.originalName;
	
	    Dispatcher.dispatch({
	      type: ActionType.SAVING_SCHEDULE_BOARD,
	      date: date,
	      name: name,
	      id: id,
	      originalName: originalName
	    });
	  },
	  addUserTaskName: function addUserTaskName(_ref2) {
	    var listId = _ref2.listId,
	        listName = _ref2.listName,
	        date = _ref2.date,
	        note = _ref2.note,
	        id = _ref2.id,
	        name = _ref2.name,
	        checked = _ref2.checked;
	
	    Dispatcher.dispatch({
	      type: ActionType.ADDING_NOTE_SCHEDULE_BOARD,
	      note: note,
	      name: name,
	      date: date,
	      id: id,
	      listId: listId,
	      listName: listName,
	      checked: checked
	    });
	  },
	  deleteUserTaskName: function deleteUserTaskName(id, listName) {
	    Dispatcher.dispatch({
	      type: ActionType.DELETING_SCHEDULE_BOARD,
	      id: id,
	      listName: listName
	    });
	  },
	  deleteUserTaskNameSuccess: function deleteUserTaskNameSuccess() {
	    Dispatcher.dispatch({ type: ActionType.DELETING_SCHEDULE_BOARD_SUCCESS });
	  },
	  deleteUserTaskNameFailure: function deleteUserTaskNameFailure() {
	    Dispatcher.dispatch({ type: ActionType.DELETING_SCHEDULE_BOARD_FAILURE });
	  },
	  saveChangedUserTaskNameSuccess: function saveChangedUserTaskNameSuccess() {
	    Dispatcher.dispatch({ type: ActionType.SAVING_SCHEDULE_BOARD_SUCCESS });
	  },
	  addUserTaskNameSuccess: function addUserTaskNameSuccess() {
	    Dispatcher.dispatch({ type: ActionType.ADDING_NOTE_SCHEDULE_BOARD_SUCCESS });
	  },
	  saveChangedUserTaskNameFailure: function saveChangedUserTaskNameFailure() {
	    Dispatcher.dispatch({ type: ActionType.SAVING_SCHEDULE_BOARD_FAILURE });
	  },
	  addUserTaskNameFailure: function addUserTaskNameFailure() {
	    Dispatcher.dispatch({ type: ActionType.ADDING_NOTE_SCHEDULE_BOARD_FAILURE });
	  },
	  fetchScheduleBoardByDateSuccess: function fetchScheduleBoardByDateSuccess(data) {
	    Dispatcher.dispatch({
	      type: ActionType.FETCH_SCHEDULE_BOARD_SUCCESS,
	      data: data
	    });
	  },
	  fetchScheduleBoardByDateFailure: function fetchScheduleBoardByDateFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.FETCH_SCHEDULE_BOARD_FAILURE
	    });
	  },
	  changeOrderDraft: function changeOrderDraft(order) {
	    Dispatcher.dispatch({
	      type: ActionType.CHANGE_ORDER_DRAFT,
	      order: order
	    });
	  },
	  removeOrderDraft: function removeOrderDraft(order) {
	    Dispatcher.dispatch({
	      type: ActionType.REMOVED_ORDER_DRAFT,
	      order: order
	    });
	  },
	  newOrder: function newOrder(order) {
	    Dispatcher.dispatch({
	      type: ActionType.NEW_ORDER,
	      order: order
	    });
	  },
	  changeToggle: function changeToggle(lastToggleChanged, isBHAllowed, isFVAllowed, isBTAllowed) {
	    Dispatcher.dispatch({
	      type: ActionType.DASHBOARD_MODAL_CHANGE_TOGGLE,
	      isBHAllowed: isBHAllowed,
	      isFVAllowed: isFVAllowed,
	      isBTAllowed: isBTAllowed,
	      lastToggleChanged: lastToggleChanged
	    });
	  },
	  changeOrder: function changeOrder(order) {
	    Dispatcher.dispatch({
	      type: ActionType.CHANGE_ORDER,
	      order: order
	    });
	  },
	  removedOrder: function removedOrder() {
	    Dispatcher.dispatch({
	      type: ActionType.REMOVED_ORDER
	    });
	  },
	  savingDraft: function savingDraft() {
	    Dispatcher.dispatch({
	      type: ActionType.SAVE_DRAFT
	    });
	  },
	  savingDraftSuccess: function savingDraftSuccess() {
	    Dispatcher.dispatch({
	      type: ActionType.SAVE_DRAFT_SUCCESS
	    });
	  },
	  showLoading: function showLoading() {
	    Dispatcher.dispatch({
	      type: ActionType.SHOW_LOADING
	    });
	  },
	  hideLoading: function hideLoading() {
	    Dispatcher.dispatch({
	      type: ActionType.HIDE_LOADING
	    });
	  },
	  savingDraftFailure: function savingDraftFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.SAVE_DRAFT_FAILURE
	    });
	  },
	  closeModal: function closeModal() {
	    Dispatcher.dispatch({
	      type: ActionType.DASHBOARD_MODAL_CLOSE_MODAL
	    });
	  },
	  publishingDraft: function publishingDraft() {
	    Dispatcher.dispatch({
	      type: ActionType.PUBLISHING_DRAFT
	    });
	  },
	  updateDashboardWithUserAdmin: function updateDashboardWithUserAdmin() {
	    Dispatcher.dispatch({
	      type: ActionType.PUBLISHING_CHANGE_ADMIN_DRAFT
	    });
	  },
	  publishingSuccess: function publishingSuccess(from, to) {
	    Dispatcher.dispatch({
	      type: ActionType.PUBLISHING_DRAFT_SUCCESS,
	      from: from,
	      to: to
	    });
	  },
	  publishingFailure: function publishingFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.PUBLISHING_DRAFT_FAILURE
	    });
	  },
	  undoDraft: function undoDraft() {
	    Dispatcher.dispatch({
	      type: ActionType.UNDO_DRAFT
	    });
	  },
	  undoDraftSuccess: function undoDraftSuccess() {
	    Dispatcher.dispatch({
	      type: ActionType.UNDO_DRAFT_SUCCESS
	    });
	  },
	  undoDraftFailure: function undoDraftFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.UNDO_DRAFT_FAILURE
	    });
	  },
	  redoDraft: function redoDraft() {
	    Dispatcher.dispatch({
	      type: ActionType.REDO_DRAFT
	    });
	  },
	  redoDraftSuccess: function redoDraftSuccess() {
	    Dispatcher.dispatch({
	      type: ActionType.REDO_DRAFT_SUCCESS
	    });
	  },
	  redoDraftFailure: function redoDraftFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.REDO_DRAFT_FAILURE
	    });
	  },
	  addedTank: function addedTank() {
	    Dispatcher.dispatch({
	      type: ActionType.ADDED_TANK
	    });
	  },
	  changedTank: function changedTank() {
	    Dispatcher.dispatch({
	      type: ActionType.CHANGED_TANK
	    });
	  },
	  needFetchBrewingNotes: function needFetchBrewingNotes() {
	    Dispatcher.dispatch({
	      type: ActionType.BREWING_NOTE_NEED_FETCH
	    });
	  },
	  needFetchPackagingNotes: function needFetchPackagingNotes() {
	    Dispatcher.dispatch({
	      type: ActionType.PACKAGING_NOTE_NEED_FETCH
	    });
	  },
	  deletedTank: function deletedTank() {
	    Dispatcher.dispatch({
	      type: ActionType.DELETED_TANK
	    });
	  },
	  executeBatchOperationsEnd: function executeBatchOperationsEnd(batchNumber) {
	    Dispatcher.dispatch({
	      type: ActionType.PERFORM_BATCH_OPERATION_END,
	      batchNumber: batchNumber
	    });
	  },
	  forceRenderDashboard: function forceRenderDashboard() {
	    Dispatcher.dispatch({ type: ActionType.FORCE_MANUAL_DRAWING_DASHBOARD });
	  },
	  forceReFetchAndRenderDashboard: function forceReFetchAndRenderDashboard(from, to) {
	    Dispatcher.dispatch({ type: ActionType.FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD, from: from, to: to });
	  },
	  removeUserTask: function removeUserTask(_ref3) {
	    var id = _ref3.id,
	        listId = _ref3.listId;
	
	    Dispatcher.dispatch({
	      type: ActionType.DELETING_USER_TASK,
	      id: id,
	      listId: listId
	    });
	  },
	  removeUserTaskSuccess: function removeUserTaskSuccess() {
	    Dispatcher.dispatch({
	      type: ActionType.DELETING_USER_TASK_SUCCESS
	    });
	  },
	  removeUserTaskFailure: function removeUserTaskFailure() {
	    Dispatcher.dispatch({
	      type: ActionType.DELETING_USER_TASK_FAILURE
	    });
	  }
	};
	
	module.exports = DashboardActionCreators;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(877),
	    isFunction = __webpack_require__(67),
	    isLength = __webpack_require__(164);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null &&
	    !(typeof value == 'function' && isFunction(value)) && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array constructors, and
	  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(847),
	    indexKeys = __webpack_require__(467),
	    isIndex = __webpack_require__(114),
	    isPrototype = __webpack_require__(346);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(664);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactElement = __webpack_require__(38);
	var ReactErrorUtils = __webpack_require__(1254);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactLifeCycle = __webpack_require__(383);
	var ReactPropTypeLocations = __webpack_require__(384);
	var ReactPropTypeLocationNames = __webpack_require__(222);
	var ReactUpdateQueue = __webpack_require__(385);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	var keyMirror = __webpack_require__(177);
	var keyOf = __webpack_require__(81);
	var warning = __webpack_require__(32);
	
	var MIXINS_KEY = keyOf({mixins: null});
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function(Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function(Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function(Constructor, childContextTypes) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      validateTypeDef(
	        Constructor,
	        childContextTypes,
	        ReactPropTypeLocations.childContext
	      );
	    }
	    Constructor.childContextTypes = assign(
	      {},
	      Constructor.childContextTypes,
	      childContextTypes
	    );
	  },
	  contextTypes: function(Constructor, contextTypes) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      validateTypeDef(
	        Constructor,
	        contextTypes,
	        ReactPropTypeLocations.context
	      );
	    }
	    Constructor.contextTypes = assign(
	      {},
	      Constructor.contextTypes,
	      contextTypes
	    );
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function(Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(
	        Constructor.getDefaultProps,
	        getDefaultProps
	      );
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function(Constructor, propTypes) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      validateTypeDef(
	        Constructor,
	        propTypes,
	        ReactPropTypeLocations.prop
	      );
	    }
	    Constructor.propTypes = assign(
	      {},
	      Constructor.propTypes,
	      propTypes
	    );
	  },
	  statics: function(Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  }
	};
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        typeof typeDef[propName] === 'function',
	        '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	        'React.PropTypes.',
	        Constructor.displayName || 'ReactClass',
	        ReactPropTypeLocationNames[location],
	        propName
	      ) : null);
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ?
	    ReactClassInterface[name] :
	    null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      specPolicy === SpecPolicy.OVERRIDE_BASE,
	      'ReactClassInterface: You are attempting to override ' +
	      '`%s` from your class specification. Ensure that your method names ' +
	      'do not overlap with React methods.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.OVERRIDE_BASE));
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      specPolicy === SpecPolicy.DEFINE_MANY ||
	      specPolicy === SpecPolicy.DEFINE_MANY_MERGED,
	      'ReactClassInterface: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be due ' +
	      'to a mixin.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.DEFINE_MANY ||
	    specPolicy === SpecPolicy.DEFINE_MANY_MERGED));
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    typeof spec !== 'function',
	    'ReactClass: You\'re attempting to ' +
	    'use a component class as a mixin. Instead, just use a regular object.'
	  ) : invariant(typeof spec !== 'function'));
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    !ReactElement.isValidElement(spec),
	    'ReactClass: You\'re attempting to ' +
	    'use a component as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactElement.isValidElement(spec)));
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod =
	        ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var markedDontBind = property && property.__reactDontBind;
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind =
	        isFunction &&
	        !isReactClassMethod &&
	        !isAlreadyDefined &&
	        !markedDontBind;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	            isReactClassMethod && (
	              (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	            ),
	            'ReactClass: Unexpected spec policy %s for key %s ' +
	            'when mixing in component specs.',
	            specPolicy,
	            name
	          ) : invariant(isReactClassMethod && (
	            (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	          )));
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !isReserved,
	      'ReactClass: You are attempting to define a reserved ' +
	      'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	      'as an instance property instead; it will still be accessible on the ' +
	      'constructor.',
	      name
	    ) : invariant(!isReserved));
	
	    var isInherited = name in Constructor;
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !isInherited,
	      'ReactClass: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be ' +
	      'due to a mixin.',
	      name
	    ) : invariant(!isInherited));
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    one && two && typeof one === 'object' && typeof two === 'object',
	    'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	  ) : invariant(one && two && typeof one === 'object' && typeof two === 'object'));
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        one[key] === undefined,
	        'mergeIntoWithNoDuplicateKeys(): ' +
	        'Tried to merge two objects with the same key: `%s`. This conflict ' +
	        'may be due to a mixin; in particular, this may be caused by two ' +
	        'getInitialState() or getDefaultProps() methods returning objects ' +
	        'with clashing keys.',
	        key
	      ) : invariant(one[key] === undefined));
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function(newThis ) {for (var args=[],$__0=1,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          false,
	          'bind(): React component methods may only be bound to the ' +
	          'component instance. See %s',
	          componentName
	        ) : null);
	      } else if (!args.length) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          false,
	          'bind(): You are binding a component method to the component. ' +
	          'React does this for you automatically in a high-performance ' +
	          'way, so you can safely remove this call. See %s',
	          componentName
	        ) : null);
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(
	        component,
	        ReactErrorUtils.guard(
	          method,
	          component.constructor.displayName + '.' + autoBindKey
	        )
	      );
	    }
	  }
	}
	
	var typeDeprecationDescriptor = {
	  enumerable: false,
	  get: function() {
	    var displayName = this.displayName || this.name || 'Component';
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      false,
	      '%s.type is deprecated. Use %s directly to access the class.',
	      displayName,
	      displayName
	    ) : null);
	    Object.defineProperty(this, 'type', {
	      value: this
	    });
	    return this;
	  }
	};
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function(newState, callback) {
	    ReactUpdateQueue.enqueueReplaceState(this, newState);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function() {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          owner._warnedAboutRefsInRender,
	          '%s is accessing isMounted inside its render() function. ' +
	          'render() should be a pure function of props and state. It should ' +
	          'never access something that requires stale data from the previous ' +
	          'render, such as refs. Move this logic to componentDidMount and ' +
	          'componentDidUpdate instead.',
	          owner.getName() || 'A component'
	        ) : null);
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(this);
	    return (
	      internalInstance &&
	      internalInstance !== ReactLifeCycle.currentlyMountingInstance
	    );
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function(partialProps, callback) {
	    ReactUpdateQueue.enqueueSetProps(this, partialProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function(newProps, callback) {
	    ReactUpdateQueue.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function() {};
	assign(
	  ReactClassComponent.prototype,
	  ReactComponent.prototype,
	  ReactClassMixin
	);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function(spec) {
	    var Constructor = function(props, context) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	          'JSX instead. See: https://fb.me/react-legacyfactory'
	        ) : null);
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' &&
	            this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(
	      mixSpecIntoComponent.bind(null, Constructor)
	    );
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    ) : invariant(Constructor.prototype.render));
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        spec.displayName || 'A component'
	      ) : null);
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    // Legacy hook
	    Constructor.type = Constructor;
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      try {
	        Object.defineProperty(Constructor, 'type', typeDeprecationDescriptor);
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function(mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(376);
	var PooledClass = __webpack_require__(91);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactPerf = __webpack_require__(103);
	var ReactReconciler = __webpack_require__(150);
	var Transaction = __webpack_require__(224);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    ReactUpdates.ReactReconcileTransaction && batchingStrategy,
	    'ReactUpdates: must inject a reconcile transaction class and batching ' +
	    'strategy'
	  ) : invariant(ReactUpdates.ReactReconcileTransaction && batchingStrategy));
	}
	
	var NESTED_UPDATES = {
	  initialize: function() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function() {
	    this.callbackQueue.reset();
	  },
	  close: function() {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction =
	    ReactUpdates.ReactReconcileTransaction.getPooled();
	}
	
	assign(
	  ReactUpdatesFlushTransaction.prototype,
	  Transaction.Mixin, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(
	      this,
	      this.reconcileTransaction.perform,
	      this.reconcileTransaction,
	      method,
	      scope,
	      a
	    );
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    len === dirtyComponents.length,
	    'Expected flush transaction\'s stored dirty-components length (%s) to ' +
	    'match dirty-components array length (%s).',
	    len,
	    dirtyComponents.length
	  ) : invariant(len === dirtyComponents.length));
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(
	      component,
	      transaction.reconcileTransaction
	    );
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(
	          callbacks[j],
	          component.getPublicInstance()
	        );
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure(
	  'ReactUpdates',
	  'flushBatchedUpdates',
	  flushBatchedUpdates
	);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	    ReactCurrentOwner.current == null,
	    'enqueueUpdate(): Render methods should be a pure function of props ' +
	    'and state; triggering nested component updates from render is not ' +
	    'allowed. If necessary, trigger nested updates in ' +
	    'componentDidUpdate.'
	  ) : null);
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    batchingStrategy.isBatchingUpdates,
	    'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' +
	    'updates are not being batched.'
	  ) : invariant(batchingStrategy.isBatchingUpdates));
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function(ReconcileTransaction) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ReconcileTransaction,
	      'ReactUpdates: must provide a reconcile transaction class'
	    ) : invariant(ReconcileTransaction));
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function(_batchingStrategy) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      _batchingStrategy,
	      'ReactUpdates: must provide a batching strategy'
	    ) : invariant(_batchingStrategy));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof _batchingStrategy.batchedUpdates === 'function',
	      'ReactUpdates: must provide a batchedUpdates() function'
	    ) : invariant(typeof _batchingStrategy.batchedUpdates === 'function'));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof _batchingStrategy.isBatchingUpdates === 'boolean',
	      'ReactUpdates: must provide an isBatchingUpdates boolean attribute'
	    ) : invariant(typeof _batchingStrategy.isBatchingUpdates === 'boolean'));
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1320);
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    set = __webpack_require__(5).set,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    map = _require2.map,
	    some = _require2.some,
	    ContentUtils = __webpack_require__(7),
	    BasicFormGroup = __webpack_require__(94),
	    TextFieldSuggested = __webpack_require__(230);
	
	
	var FormGroupTextFieldSuggested = React.createClass({ displayName: "FormGroupTextFieldSuggested",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	
	        placeHolder: PropTypes.string,
	        items: PropTypes.array,
	        itemsDisabled: PropTypes.array,
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        onBlur: PropTypes.func,
	        messageError: PropTypes.string,
	        name: PropTypes.string,
	        customErrorNonMatch: PropTypes.string,
	        isRequired: PropTypes.bool,
	        onEnter: PropTypes.func,
	
	        /**
	         * The current selected object
	         */
	        value: PropTypes.object,
	
	        // Input param -----------
	
	        /**
	         * The field which use to display the value
	         */
	        readerAttribute: PropTypes.string,
	
	        // Output param -------------
	
	        /**
	         * Just in case which need to save a custom value
	         */
	        readerAttributeValue: PropTypes.string,
	
	        writerAttribute: PropTypes.string,
	        isImmutable: PropTypes.bool,
	
	        onItemSelected: PropTypes.func
	    }),
	
	    getInitialState: function getInitialState() {
	        return {
	            itemSelected: null,
	            textWritten: ''
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {
	        if (this.isMounted()) {
	            this.getDOMNode().querySelector('input').value = '';
	        }
	    },
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            readerAttribute = _props.readerAttribute,
	            readerAttributeValue = _props.readerAttributeValue,
	            value = _props.value;
	        var itemSelected = this.state.itemSelected;
	
	
	        var isEditMode = !!value;
	        var writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
	        var readerAttributeSafe = readerAttributeValue || readerAttribute; // make writer attribute optionally
	
	        var valueToSave = void 0;
	        if (itemSelected) {
	            // first check internal state
	            valueToSave = get(this.state, 'itemSelected.' + readerAttributeSafe);
	        } else if (isEditMode) {
	            valueToSave = get(value, readerAttributeSafe);
	        }
	
	        var wrapper = set({}, writerAttributeSafe, valueToSave);
	
	        return wrapper;
	    },
	    isValid: function isValid() {
	        var messageError = this._getErrorInfo();
	        this.setState({ messageError: messageError });
	        return messageError === '';
	    },
	    _getErrorInfo: function _getErrorInfo() {
	        var _props2 = this.props,
	            additionalValidation = _props2.additionalValidation,
	            isRequired = _props2.isRequired,
	            readerAttributeValue = _props2.readerAttributeValue,
	            readerAttribute = _props2.readerAttribute,
	            items = _props2.items,
	            writerAttribute = _props2.writerAttribute,
	            value = _props2.value,
	            name = _props2.name,
	            customErrorNonMatch = _props2.customErrorNonMatch;
	        var _state = this.state,
	            textWritten = _state.textWritten,
	            itemSelected = _state.itemSelected;
	
	        if (ContentUtils.isNull(isRequired)) {
	            isRequired = true;
	        }
	
	        name = name || 'item';
	        var inputValue = this.getValue();
	
	        var messageError = '';
	        if (itemSelected) {
	            // enter here when item are selected
	            var matchAnyItem = this._isTextWrittenMatchSomeItem(items, readerAttribute, textWritten);
	            if (!matchAnyItem) {
	                if (customErrorNonMatch) {
	                    messageError = customErrorNonMatch;
	                } else {
	                    messageError = name + ' ' + t('notification_not_exist');
	                }
	            }
	        } else if (isRequired && inputValue) {
	            // enter here when the item are non-selected
	            // but exist some value entered by the consumer
	            var writerAttributeSafe = writerAttribute || readerAttribute;
	            var itemValue = inputValue ? get(inputValue, writerAttributeSafe) : get(value, writerAttributeSafe);
	
	            if (!itemValue) {
	                if (customErrorNonMatch) {
	                    messageError = customErrorNonMatch;
	                } else {
	                    messageError = name + ' ' + t('notification_not_exist');
	                }
	            } else {
	                var itemTarget = find(items, function (item) {
	                    return get(item, readerAttributeValue) === itemValue;
	                });
	                if (!itemTarget) {
	                    messageError = t('label_the') + ' ' + name + ' ' + t('notification_is_required');
	                }
	            }
	        }
	
	        if (!messageError && additionalValidation) {
	            messageError = additionalValidation(inputValue);
	        }
	
	        return messageError;
	    },
	    _isTextWrittenMatchSomeItem: function _isTextWrittenMatchSomeItem(items, readerAttribute, textWritten) {
	        return some(map(items, function (vendor) {
	            return get(vendor, readerAttribute);
	        }), function (text) {
	            return text === textWritten;
	        });
	    },
	    _onEnter: function _onEnter() {
	        if (this.props.onEnter) {
	            this.props.onEnter();
	        }
	    },
	    _onBlur: function _onBlur(itemSelected, textWritten) {
	        var _this = this;
	
	        var _props3 = this.props,
	            onBlur = _props3.onBlur,
	            readerAttribute = _props3.readerAttribute;
	
	        var safeTextWritten = ContentUtils.isEmptyText(textWritten) ? get(itemSelected, readerAttribute) : textWritten;
	        this.setState({
	            itemSelected: itemSelected,
	            textWritten: safeTextWritten
	        }, function () {
	            if (onBlur) {
	                onBlur(itemSelected, textWritten);
	            }
	            _this.isValid();
	        });
	    },
	    onItemSelected: function onItemSelected(itemSelected) {
	        var _this2 = this;
	
	        var textWritten = get(itemSelected, this.props.readerAttribute);
	        this.setState({
	            itemSelected: itemSelected,
	            textWritten: textWritten
	        }, function () {
	            return _this2.isValid();
	        });
	
	        if (this.props.onItemSelected) {
	            this.props.onItemSelected(itemSelected);
	        }
	    },
	    render: function render() {
	        var _props4 = this.props,
	            isDisabled = _props4.isDisabled,
	            label = _props4.label,
	            onChange = _props4.onChange,
	            value = _props4.value,
	            readerAttribute = _props4.readerAttribute,
	            isDark = _props4.isDark,
	            isImmutable = _props4.isImmutable,
	            isEditMode = _props4.isEditMode,
	            items = _props4.items,
	            itemsDisabled = _props4.itemsDisabled;
	
	        // is disabled input
	
	        var isDisabledInput = !!isDisabled || isImmutable && isEditMode;
	
	        // prepare specific classes
	        var textFieldClassName = 'form-group form-group-textfield-suggested';
	        textFieldClassName += isDark ? ' is-dark' : '';
	        textFieldClassName += isDisabledInput ? ' is-disabled' : '';
	        textFieldClassName += ' is-dark';
	        var className = 'form-group-textfield-suggested-input' + (isDisabledInput ? ' is-disabled' : '');
	
	        return React.createElement("div", { className: textFieldClassName }, React.createElement(TextFieldSuggested, {
	            readerAttribute: readerAttribute,
	            items: items,
	            itemsDisabled: itemsDisabled,
	            readerAttributeValue: "id",
	            className: className,
	            floatingLabelStyle: { color: '#fff !important', fontWeight: '300' },
	            LabelStyle: { color: '#fff !important', fontWeight: '300' },
	            onChange: onChange,
	            onBlur: this._onBlur,
	            onEnterKeyDown: this._onEnter,
	            value: value,
	            floatingLabelText: label ? label : '',
	            style: { width: '100%', color: 'white !important', fontWeight: '300' },
	            isDisabled: isDisabledInput,
	            errorText: get(this.state, 'messageError', ''),
	            onItemSelected: this.onItemSelected
	        }));
	    }
	});
	
	module.exports = FormGroupTextFieldSuggested;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ContentUtils = __webpack_require__(7),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ChronologycStore = __webpack_require__(76),
	    TankStore = __webpack_require__(97),
	    DashboardLayoutStore = __webpack_require__(108),
	    DateUtils = __webpack_require__(22),
	    OrderUtils = __webpack_require__(49),
	    EventEmitter = __webpack_require__(109).EventEmitter,
	    DashboardModalUtils = __webpack_require__(50),
	    DraftSchedule = __webpack_require__(735),
	    DashboardAction = __webpack_require__(65),
	    Notification = __webpack_require__(21),
	    assign = __webpack_require__(74),
	    _ = __webpack_require__(40),
	    CHANGE_EVENT = 'change',
	    propsToValiadte = ['x', 'y', 'i', 'h', 'batchNumber'],
	    Constants = __webpack_require__(2),
	    BrewhouseStore = __webpack_require__(96),
	    OrderSingleStore = __webpack_require__(746),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    AppDispatcher = __webpack_require__(42),
	    DashboardServiceCache = __webpack_require__(28);
	
	
	function isSiblingTankPositionAvailable(newPositionSiblingTank, differedDays) {
	    return newPositionSiblingTank && !DashboardLayoutStore.isEmpty(newPositionSiblingTank) && differedDays !== undefined;
	}
	
	var OrderStore = assign({}, EventEmitter.prototype, {
	
	    /**
	     * The tracking last order created from this store
	     */
	    lastOrderCreated: null,
	    /**
	     * The tracking last order created from this store
	     */
	    lastOrderUpdated: null,
	
	    /**
	     * Handler of new position of order taking and move sticky orders (same batch number) if need it.
	     * @param {Object} oldPosition
	     * @param {Object} newPosition
	     * @private
	     */
	    moveOrders: function moveOrders(positionOld, positionNew) {
	        try {
	
	            if (ContentUtils.isNull(positionNew)) {
	                return;
	            }
	
	            if (ContentUtils.isSameObject(positionOld, positionNew, propsToValiadte)) {
	                // just in case that we call this method with the same position, do nothing
	                return;
	            }
	
	            if (ChronologycStore.isPositionOutOfRange(positionNew)) {
	                Notification.show(t('dashboard_notification_keep_scrolling_to_view_entire_order'), 'warning');
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return;
	            }
	
	            if (DashboardLayoutStore.isInvalidMovement(positionNew, positionOld)) {
	                // Enter here means the auto-located new position was wrong, due a Grid Layout problem
	                // when you are resizing and order over an existing one, co-location it doesn't work properly.
	                // means you don't be able to resize (change the `h` and also the `y` of a position at the same time.
	                Notification.show(t('notification_the_position_is_taken'), 'warning');
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return;
	            }
	
	            if (!this._isProperlyTypeOfTankDestination(positionNew)) {
	                Notification.show(t('dashboard_notification_order_can_not_moved_differen_type_tank'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return;
	            }
	
	            if (!OrderUtils.checkIfTankHaveEnoughVolume(positionNew)) {
	                Notification.show(t('dashboard_notification_volume_capacity_insufficient'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return;
	            }
	
	            var result = void 0;
	            // calculate the new vertical position.
	            var offsetY = positionNew.y - positionOld.y;
	            var orderPosition = this.getSafeOrder(positionNew.i);
	            var haveBatchs = _.get(orderPosition, 'batchs.length', 0) > 0;
	
	            if (!ContentUtils.isBHBatch(positionNew.i) && haveBatchs && !BrewhouseStore.isEnoughVolumeInTank(orderPosition, positionNew.x)) {
	                Notification.show(t('dashboard_notification_volume_capacity_insufficient'));
	                DashboardAction.forceRenderDashboard();
	                return;
	            }
	
	            if (ContentUtils.isBHBatch(positionNew.i) && haveBatchs) {
	                // enter here means that move one batch from Brewhouse side and was a batch, otherwise if position is BH without batch is a single in BH section
	                result = this._changeBatchPosition(positionOld, positionNew, offsetY);
	            } else {
	                // enter here means that move one order from Fermenter or Packaging side.
	                if (offsetY === 0) {
	                    // enter here means that was a horizontal movement, so is not need to change neither linked orders
	                    result = this._changeOrderFromNewPosition(positionOld, positionNew);
	                } else {
	                    result = this._recalculateOrdersWithNewVerticalPosition(positionOld, positionNew, offsetY);
	                }
	            }
	
	            AppDispatcher.dispatch({ type: ActionTypes.FORCE_MANUAL_DRAWING_DASHBOARD });
	
	            return result;
	        } catch (error) {
	            console.error('OrderStore.moveOrders: ', error);
	            throw error;
	        }
	    },
	
	
	    /**
	     * Retrieve the last order updated
	     * @return {*}
	     */
	    getLastOrderCreated: function getLastOrderCreated() {
	        return this.lastOrderCreated;
	    },
	
	
	    /**
	     * Retrieve the last order updated
	     * @return {*}
	     */
	    getLastOrderUpdate: function getLastOrderUpdate() {
	        return this.lastOrderUpdated;
	    },
	
	
	    /**
	     * Retrieve the next batch number available.
	     * @return {*}
	     */
	    getNextBatchNumber: function getNextBatchNumber() {
	        var lastOrderCreated = this.lastOrderCreated || this.getOrders().filter(function (o) {
	            return o.dateCreated;
	        }).map(function (order) {
	            order.batchNumberInt = +_.join((order.batchNumber || '1').match(/[\d]/gi), '');
	            return order;
	        }).sort(function (a, b) {
	            return a.batchNumberInt - b.batchNumberInt;
	        }).slice(-1)[0];
	
	        if (!lastOrderCreated) {
	            return '1';
	        }
	
	        var batchNumber = lastOrderCreated.batchNumber;
	        var partNumber = _.join(batchNumber.match(/[\d]/gi), '');
	        var partText = _.join(batchNumber.match(/[\D]/gi), '');
	
	        if (batchNumber.indexOf(partNumber) > 0) {
	            return partText + (+partNumber + 1);
	        } else {
	            return +partNumber + 1 + partText;
	        }
	    },
	    getLastComputedOrderUpdated: function getLastComputedOrderUpdated() {
	        var orders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        if (orders && orders.sort && orders.length) {
	            return orders.sort(function (a, b) {
	                return new Date(a.lastUpdated).getTime() - new Date(b.lastUpdated).getTime();
	            }).slice(-1)[0];
	        }
	    },
	    getLastComputedOrderCreated: function getLastComputedOrderCreated() {
	        var orders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        if (orders && orders.sort && orders.length) {
	            return orders.sort(function (a, b) {
	                return new Date(a.dateCreated).getTime() - new Date(b.dateCreated).getTime();
	            }).slice(-1)[0];
	        }
	    },
	    getOrderByDateAndTank: function getOrderByDateAndTank(date, tank) {
	        var dateTarget = DateUtils.toDateText(date);
	        var tankId = _.get(tank, 'id');
	        return _.find(this.getOrders(), function (order) {
	            var targetFounded = false;
	
	            if (!order) return false;
	
	            if (order.isSingle) {
	                if (_.get(order, 'singleTankId') === tankId) {
	                    targetFounded = DateUtils.isDateBetween(dateTarget, order.fromDate, order.toDate);
	                } else {
	                    targetFounded = false;
	                }
	
	                if (!targetFounded && order.batchs) {
	                    // enter here means that dont found yet the order, so we need find by batch
	                    targetFounded = _.some(order.batchs, function (batch) {
	                        return batch.turnId === tankId;
	                    });
	                }
	            } else {
	                if (_.get(order, 'fermenterTankId') === tankId) {
	                    targetFounded = DateUtils.isDateBetween(dateTarget, order.brewDate, order.filtrationDate);
	                } else if (_.get(order, 'briteTankId') === tankId) {
	                    targetFounded = DateUtils.isDateBetween(dateTarget, order.filtrationDate, order.orderDate);
	                } else {
	                    targetFounded = false;
	                }
	
	                if (!targetFounded && order.batchs) {
	                    // enter here means that dont found yet the order, so we need find by batch
	                    targetFounded = _.some(order.batchs, function (batch) {
	                        return batch.turnId === tankId;
	                    });
	                }
	            }
	
	            return targetFounded;
	        });
	    },
	    updateLastOrderUpdated: function updateLastOrderUpdated(order) {
	        this.lastOrderUpdated = order;
	    },
	    updateLastOrderCreated: function updateLastOrderCreated(order) {
	        this.lastOrderCreated = order;
	    },
	    hydrateOrdersOutOfRange: function hydrateOrdersOutOfRange(layout) {
	        var fromDashboard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChronologycStore.getCurrentFrom();
	        var toDashboard = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ChronologycStore.getCurrentTo();
	
	        // clean layout with error orders with errors
	        var orders = _.filter(OrderUtils.getOrderByRange(fromDashboard, toDashboard), function (order) {
	            return order && order.briteTank && order.fermenterTank || order.singleTank;
	        });
	
	        // the current visible position of dashboard
	        var visualOrdersPositionsIds = _.map(layout, function (l) {
	            return ContentUtils.cleanId(l.i);
	        });
	        var visualOrdersPositionWithOrder = _.map(layout, function (l) {
	            return {
	                position: l,
	                order: _.find(orders, function (order) {
	                    return ContentUtils.cleanId(l.i) === order.id;
	                })
	            };
	        });
	
	        // CASE 1 - filter order that are completly ouside of dashboard modal, (the most frequent case)
	        var ordersCompletlyOutSide = _.filter(orders, function (order) {
	            return visualOrdersPositionsIds.indexOf(order.id) === -1;
	        });
	        var ordersCompletlyOutSidePositions = _.flatten(_.map(ordersCompletlyOutSide, function (order) {
	            return OrderUtils.convertOrderToPositions(order, fromDashboard);
	        }));
	
	        // CASE 2 - which order that not have sibling position
	        var ordersWithoutSiblingIds = ContentUtils.getNonDuplicates(visualOrdersPositionsIds);
	        var ordersWithoutSibling = _.filter(orders, function (order) {
	            return ordersWithoutSiblingIds.indexOf(order.id) > -1;
	        });
	        var ordersWithoutSiblingPositions = _.flatten(_.map(ordersWithoutSibling, function (order) {
	            return OrderUtils.convertOrderToPositions(order, fromDashboard);
	        }));
	
	        // CASE 3 - add sibling position in case of combined orders
	        var ordersWithSiblingPositionsIds = ContentUtils.getDuplicates(visualOrdersPositionsIds);
	        var ordersWithSiblingPositionsAndOrders = _.filter(visualOrdersPositionWithOrder, function (positionWithOrder) {
	            return ordersWithSiblingPositionsIds.indexOf(ContentUtils.cleanId(positionWithOrder.position.i)) > -1;
	        });
	
	        // Complete the partially position shown
	        var ordersWithSiblingPartiallyShown = _.filter(ordersWithSiblingPositionsAndOrders, OrderUtils.isOrderPartiallyShown.bind(this, fromDashboard, toDashboard));
	        var ordersWithSiblingPartiallyShownPosition = _.flatten(_.map(ordersWithSiblingPartiallyShown, function (positionAndOrder) {
	            return OrderUtils.convertOrderToPositions(positionAndOrder.order, fromDashboard, _.get(positionAndOrder, 'position'));
	        }));
	
	        // to Order
	        var ordersWithSibling = _.map(ordersWithSiblingPartiallyShown, function (positionAndOrder) {
	            return positionAndOrder.order;
	        });
	
	        // Group all Ids of order of the orders that was hydrated
	        var ordersToCalculate = _.map(_.concat(ordersCompletlyOutSide, ordersWithoutSibling, ordersWithSibling), function (order) {
	            return order.id;
	        });
	
	        // Add all brewhouse batch that are whiting current dashboard visible range
	        var brewhousePosition = _.filter(layout, function (p) {
	            return ContentUtils.isBHBatch(p.i);
	        });
	
	        // Remove all the operation that we already process before in order to avoid duplications errors
	        var ordersToCalculatePositions = _.filter(layout, function (l) {
	            return _.indexOf(ordersToCalculate, ContentUtils.cleanId(l.i)) === -1;
	        });
	
	        var boxesRecalculated = _.concat(ordersCompletlyOutSidePositions, ordersWithoutSiblingPositions, ordersWithSiblingPartiallyShownPosition, brewhousePosition);
	        var result = _.concat(ordersToCalculatePositions, boxesRecalculated);
	
	        // remove all duplicate positions
	        result = ContentUtils.removeDuplicateByAttribute(result, ['x', 'y']);
	
	        return result;
	    },
	
	
	    /**
	     * Given order, change or remove task if are necessary depend is dragging or resizing.
	     * @param order
	     * @param isDragging
	     * @param offsetDays
	     * @returns {Order | null}
	     */
	    recalculateOrderTasks: function recalculateOrderTasks(order, isDragging, offsetDays, offsetResizing, isBriteTank) {
	        if (!order) {
	            return null;
	        }
	
	        if (isDragging) {
	            order = this._recalculateOrderTasksWhenDragging(order, offsetDays);
	        } else {
	            order = this._recalculateOrderTasksWhenResizing(order, offsetResizing, isBriteTank);
	        }
	
	        return order;
	    },
	    _recalculateOrderTasksWhenDragging: function _recalculateOrderTasksWhenDragging(order, offsetDays) {
	        var isDirectionTop = offsetDays < 0;
	        var offsetDaysOfBrewDate = void 0;
	        // Invert positive or negative depended of the direction.
	        var newBrewDate = DateUtils.addDays(order.brewDate, offsetDays);
	
	        offsetDaysOfBrewDate = DateUtils.getDaysBetween(order.brewDate, newBrewDate);
	        offsetDaysOfBrewDate = isDirectionTop ? -Math.abs(offsetDaysOfBrewDate) : Math.abs(offsetDaysOfBrewDate);
	
	        // All date tasks must be changes without need to remove any task.
	        order.fermenterTasks = _.map(order.fermenterTasks, function (task) {
	            task.date = DateUtils.toDateText(DateUtils.addDays(DateUtils.toDate(task.date), offsetDaysOfBrewDate));
	            // update end dete or each product if needed
	            task = OrderUtils.recalculateOffsetProductsEndDate(task, offsetDays);
	
	            // Update task of each process
	            task = OrderUtils.recalculateProcessDate(task, offsetDays);
	            return task;
	        });
	
	        order.packagingTasks = _.map(order.packagingTasks, function (task) {
	            task.date = DateUtils.toDateText(DateUtils.addDays(DateUtils.toDate(task.date), offsetDaysOfBrewDate));
	
	            // update end dete or each product if needed
	            task = OrderUtils.recalculateOffsetProductsEndDate(task, offsetDays);
	
	            // Update task of each process
	            task = OrderUtils.recalculateProcessDate(task, offsetDays);
	            return task;
	        });
	
	        // compute the process batchs
	        if (ContentUtils.isNotEmptyArray(order.batchs)) {
	            order.batchs = order.batchs.map(function (batch) {
	                batch = OrderUtils.recalculateProcessDate(batch, offsetDays);
	                return batch;
	            });
	        }
	
	        return order;
	    },
	    _recalculateOrderTasksWhenResizing: function _recalculateOrderTasksWhenResizing(order) {
	        // NOTICE: when enter here the `order` is already updated. So, the only we need to do is:
	        // - Update the dates of type task of `FILTRATION_TASK` & `PACKAGING_TASK` type task.
	        // - Remove duplicity of `SECONDARY_TASK` in favor of `FILTRATION_TASK` or `PACKAGING_TASK`.
	        // - Remove `SECONDARY_TASK` which are out of range.
	
	        order = this._updateDateAndTypeTask(order, 'filtrationDate', 'fermenterTasks', Constants.FILTRATION_TASK);
	        order = this._updateDateAndTypeTask(order, 'orderDate', 'packagingTasks', Constants.PACKAGING_TASK);
	
	        // Remove unneeded fermented tasks
	        order.fermenterTasks = _.filter(order.fermenterTasks, function (task) {
	            return DateUtils.isAfterOrEquals(task.date, order.brewDate) && DateUtils.isBeforeOrEquals(task.date, order.filtrationDate);
	        });
	
	        // Remove unneeded packaging tasks
	        order.packagingTasks = _.filter(order.packagingTasks, function (task) {
	            return DateUtils.isAfterOrEquals(task.date, order.filtrationDate) && DateUtils.isBeforeOrEquals(task.date, order.orderDate);
	        });
	
	        return order;
	    },
	    _updateDateAndTypeTask: function _updateDateAndTypeTask(order, dateField, tasksField, taskType) {
	        var isCombinedOrder = order && !order.isSingle;
	        if (isCombinedOrder) {
	            // always search first by type task in order to return the old fermenter/packaging task which need to be updated
	            var dateTarget = order[dateField];
	            var existingTask = _.find(order[tasksField], function (task) {
	                return task.date === dateTarget;
	            });
	
	            if (existingTask) {
	                // update the fermenting/packaging task in order to keep sticky to their fermenting/packaging dates.
	                if (existingTask.type === taskType) {
	                    // Enter here when you don't change the order, it's just the same dates, so
	                    // it's not needed to do nothing.
	                    return order;
	                } else {
	                    // replace the new task updated for the old task
	                    existingTask.type = taskType;
	                    order[tasksField] = ContentUtils.replace(order[tasksField], existingTask, 'date');
	                }
	            } else {
	                // turn secondary previous primary
	                var _existingTask = _.find(order[tasksField], function (task) {
	                    return task.type === taskType;
	                });
	                if (_existingTask) {
	                    _existingTask.type = Constants.SECONDARY_TASK;
	                    order[tasksField] = ContentUtils.replace(order[tasksField], _existingTask, 'date');
	                }
	                // create new primary task
	                var newTask = DashboardModalUtils.toEmptyTask(dateTarget);
	                newTask.date = dateTarget;
	                newTask.type = taskType;
	                order[tasksField] = ContentUtils.pushSafe(order[tasksField], newTask);
	            }
	        }
	        return order;
	    },
	
	
	    /**
	     * Retrieve all cache orders.
	     * @returns {*|Array}
	     */
	    getOrders: function getOrders() {
	        return DashboardServiceCache.getOrders();
	    },
	
	
	    /**
	     * Retrieve order by Id.
	     * @param orderId
	     * @returns {*}
	     */
	    getOrder: function getOrder(orderId) {
	        return DashboardServiceCache.getOrder(orderId);
	    },
	
	
	    /**
	     * Retrieve order by batch number.
	     * @param orderId
	     * @returns {*}
	     */
	    getOrderByBatchNumber: function getOrderByBatchNumber(batchNumber) {
	        return _.filter(DashboardServiceCache.getOrders(), function (order) {
	            return order.batchNumber === batchNumber;
	        });
	    },
	
	
	    /**
	     * Retrieve order by Id, and also with postfix like: '_BT', '_BH', etc
	     * @param orderId
	     * @return {*}
	     */
	    getSafeOrder: function getSafeOrder(orderId) {
	        return DashboardServiceCache.getSafeOrder(orderId);
	    },
	
	
	    /**
	     * Given new order, find if already exist, so if really new we create a new one, if are existing one, we will change it.
	     * @param {Object} order
	     * @param {Function} onSuccess
	     * @param {Function} onFailure
	     * @param {Boolean} isBHAllowed
	     */
	    addOrder: function addOrder(order, onSuccess, onFailure, isBHAllowed) {
	        if (order.id) {
	            var orderRecovered = this.getOrder(order.id);
	            var offsetY = OrderUtils.getVerticalOffeset(orderRecovered, order);
	            if (orderRecovered) {
	                this.changeOrder(order, offsetY, onSuccess, onFailure, isBHAllowed);
	            } else {
	                this.addNewOrder(order, onSuccess, onFailure, isBHAllowed);
	            }
	        } else {
	            this.addNewOrder(order, onSuccess, onFailure, isBHAllowed);
	        }
	    },
	
	
	    /**
	     * Given new order, find if already exist, so if really new we create a new one, if are existing one, we will change it.
	     * @param {Object} Single order
	     * @param {Boolean} avoidBatchs
	     */
	    addNewSingleOrder: function addNewSingleOrder(singleOrder, onSuccess, onFailure, isBHAllowed, layout) {
	        var _this = this;
	
	        var positionTank = TankStore.getSingleTankPosition(singleOrder);
	
	        if (DashboardLayoutStore.isEmpty(positionTank)) {
	
	            if (isBHAllowed) {
	                // calculated batch of brewhouse
	                singleOrder = BrewhouseStore.recalculateBrewhouseBatchs(singleOrder, 0, layout);
	                if (singleOrder.volume && singleOrder.brewhouseMessageError) {
	                    // enter here means that the brew house is full
	                    if (onFailure) {
	                        onFailure(singleOrder.brewhouseMessageError);
	                    } else {
	                        Notification.show(singleOrder.brewhouseMessageError);
	                    }
	                    return;
	                }
	            } else {
	                singleOrder.isBHAllowed = false; // to indicated to lastOrderUpdate of dashboard that is not need to calculate brewhouse batchs
	            }
	
	            //Add order to local cache.
	            var orderSaved = DashboardServiceCache.addSingleOrder(singleOrder);
	            var tankTypeConfig = ContentUtils.getTankTypeConfiguration(_.get(singleOrder, 'singleTank.type'));
	            positionTank.i = orderSaved.id + _.get(tankTypeConfig, 'postFix');
	
	            DashboardLayoutStore.push(positionTank);
	
	            // Schedule operation
	            DraftSchedule.addOrder(orderSaved);
	
	            // Indicate last order in order to jump later
	            this.updateLastOrderCreated(orderSaved);
	            this.updateLastOrderUpdated(orderSaved);
	
	            // Trigger and Notify the new Order
	            DashboardAction.newOrder(orderSaved);
	            Notification.show(t('notification_new_order_saved'), 'success');
	            if (onSuccess) {
	                onSuccess();
	            }
	            // we need delay the mark order, in order to get time
	            // to the order which insert the node in the dashboard.
	            // NOTE: note try to do that during Dashboard.drawOrders
	            // because will be affected drag and drop operation.
	            setTimeout(function () {
	                _this.markOrder(_.get(orderSaved, 'id'));
	            }, 1000);
	        } else {
	            Notification.show(t('notification_the_position_is_taken'), 'error');
	        }
	    },
	    removeOneDaySingleOrder: function removeOneDaySingleOrder(order, dataClicked) {
	        if (order) {
	            // remove the task that was clicked
	            var dateClickedText = DateUtils.toDateText(dataClicked);
	            var singleTasks = _.get(order, 'singleTasks');
	            var singleTasksFiltered = _.filter(singleTasks, function (task) {
	                return task.date !== dateClickedText;
	            });
	            order.singleTasks = singleTasksFiltered || [];
	
	            // decrement on day the rest of the task
	            order = this.decrementTaskOneDay(order, 'singleTasks', dataClicked, false);
	            order = this.decrementDateOneDay(order, 'toDate');
	        }
	        return order;
	    },
	
	
	    /**
	     * Validate if given order have a properly dates, and if all validation pass, create a new order.
	     * Update layout of dashboard and trigger the proper element.
	     * @param order
	     */
	    addNewOrder: function addNewOrder(order, onSuccess, onFailure, isBHAllowed) {
	        var _this2 = this;
	
	        var positionBriteTank, positionFermenterTank, orderSaved;
	
	        if (!OrderUtils.checkDateOfOrder(order)) {
	            return;
	        }
	        positionBriteTank = TankStore.getBriteTankPosition(order);
	        positionFermenterTank = TankStore.getFermenterTankPosition(order);
	
	        if (DashboardLayoutStore.isEmptyPositions(order, positionBriteTank, positionFermenterTank)) {
	
	            if (isBHAllowed) {
	                // calculated batch of brewhouse
	                order = BrewhouseStore.recalculateBrewhouseBatchs(order);
	                if (order.volume && order.brewhouseMessageError) {
	                    // enter here means that the brew house is full
	                    if (onFailure) {
	                        onFailure(order.brewhouseMessageError);
	                    } else {
	                        Notification.show(order.brewhouseMessageError);
	                    }
	                    return;
	                }
	            } else {
	                order.isBHAllowed = false; // to indicated to lastOrderUpdate of dashboard that is not need to calculate brewhouse batchs
	            }
	
	            // Add order to local cache.
	            orderSaved = DashboardServiceCache.addOrder(order);
	
	            // Update layout
	            positionBriteTank.i = orderSaved.id + '_BT';
	            positionFermenterTank.i = orderSaved.id;
	            DashboardLayoutStore.push(positionBriteTank);
	            DashboardLayoutStore.push(positionFermenterTank);
	
	            // Schedule operation
	            DraftSchedule.addOrder(orderSaved);
	
	            this.updateLastOrderCreated(orderSaved);
	            this.updateLastOrderUpdated(orderSaved);
	
	            // Trigger and Notify the new Order
	            DashboardAction.newOrder(orderSaved);
	            Notification.show(t('notification_new_order_saved'), 'success');
	            if (onSuccess) {
	                onSuccess();
	            }
	            // we need delay the mark order, in order to get time
	            // to the order which insert the node in the dashboard.
	            // NOTE: note try to do that during Dashboard.drawOrders
	            // because will be affected drag and drop operation.
	            setTimeout(function () {
	                _this2.markOrder(_.get(order, 'id'));
	            }, 1000);
	        } else {
	            Notification.show(t('notification_the_position_is_taken'), 'error');
	        }
	    },
	
	
	    /**
	     * Remove given order from the cache, and schedule this operation in order to sync
	     * with the server states.
	     * @param order
	     */
	    removeOrder: function removeOrder(order) {
	        this.updateLastOrderUpdated(null);
	        this.updateLastOrderCreated(null);
	        DashboardServiceCache.removeOrder(order.id);
	        DraftSchedule.removeOrder(order);
	        DashboardAction.removedOrder();
	        Notification.show(t('notification_order_deleted'), 'success');
	    },
	
	
	    /**
	     * Change the given order from the cache, and schedule this operation in order to sync
	     * with the server this dashboard state.
	     * @param order
	     */
	    changeOrder: function changeOrder(order, offsetDays, onSuccess, onFailure, isBHAllowed) {
	        var _this3 = this;
	
	        var positionBriteTank, positionFermenterTank;
	
	        if (!OrderUtils.checkDateOfOrder(order)) {
	            return;
	        }
	
	        positionBriteTank = TankStore.getBriteTankPosition(order);
	        positionFermenterTank = TankStore.getFermenterTankPosition(order);
	        if (DashboardLayoutStore.isEmptyPositions(order, positionBriteTank, positionFermenterTank)) {
	            // calculated batch of brewhouse
	            if (isBHAllowed) {
	                order = BrewhouseStore.recalculateBrewhouseBatchs(order, offsetDays);
	                if (order.volume && order.brewhouseMessageError) {
	                    // enter here means that the brew house is full
	                    if (onFailure) {
	                        onFailure(order.brewhouseMessageError);
	                    } else {
	                        Notification.show(order.brewhouseMessageError);
	                    }
	                    return;
	                }
	            }
	
	            this.updateLastOrderUpdated(order);
	            this.markOrder(_.get(order, 'id'));
	            DashboardLayoutStore.updateLayoutPosition(positionFermenterTank, positionBriteTank);
	
	            DashboardServiceCache.changeOrder(order);
	            DraftSchedule.changeOrder(order);
	            DashboardAction.changeOrder(order);
	            Notification.show(t('notification_order_changed'), 'success');
	            if (onSuccess) {
	                onSuccess();
	            }
	            // we need delay the mark order, in order to get time
	            // to the order which insert the node in the dashboard.
	            // NOTE: note try to do that during Dashboard.drawOrders
	            // because will be affected drag and drop operation.
	            setTimeout(function () {
	                _this3.markOrder(_.get(order, 'id'));
	            }, 1000);
	        }
	    },
	    changeOrderLight: function changeOrderLight(order) {
	        var positionBriteTank = TankStore.getBriteTankPosition(order);
	        var positionFermenterTank = TankStore.getFermenterTankPosition(order);
	        DashboardLayoutStore.updateLayoutPosition(positionFermenterTank, positionBriteTank);
	        this.updateLastOrderUpdated(order);
	        DashboardServiceCache.changeOrder(order);
	        DraftSchedule.changeOrder(order);
	        DashboardAction.changeOrder(order);
	    },
	    addOneDayBelow: function addOneDayBelow(order, tankClicked, dateClicked) {
	        if (order && order.isSingle) {
	            order = this._addOneDayBelowSingleOrder(order, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applySingleOrderChange(order, true);
	                return true;
	            }
	        } else {
	            order = this._addOneDayBelowBrewOrder(order, tankClicked, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applyBrewOrderChange(order, true);
	                return true;
	            }
	        }
	    },
	    addOneDayAbove: function addOneDayAbove(order, tankClicked, dateClicked) {
	        if (order && order.isSingle) {
	            order = this._addOneDayAboveSingleOrder(order, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applySingleOrderChange(order, true);
	                return true;
	            }
	        } else {
	            order = this._addOneDayAboveBrewOrder(order, tankClicked, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applyBrewOrderChange(order, true);
	                return true;
	            }
	        }
	    },
	    removeOneDay: function removeOneDay(order, tankClicked, dateClicked) {
	        if (OrderUtils.hasOneDaySingleOrder(order) || OrderUtils.hasOneDayFermenterSide(order) || OrderUtils.hasOneDayPackagingSide(order)) {
	            Notification.show(t('notification_must_have_one_day'));
	            return false;
	        }
	
	        if (order && order.isSingle) {
	            order = OrderStore.removeOneDaySingleOrder(order, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applySingleOrderChange(order, true);
	                return true;
	            }
	        } else {
	            order = this._removeOneDayBrewOrder(order, tankClicked, dateClicked);
	            if (!order) {
	                return false;
	            } else {
	                this._applyBrewOrderChange(order, true);
	                return true;
	            }
	        }
	    },
	    moveTask: function moveTask(order, tankClicked, dateClicked, offset) {
	        var isSingle = _.get(order, 'isSingle'),
	            tankType = _.get(tankClicked, 'type');
	
	        order = this._moveTask(order, dateClicked, tankType, isSingle, offset);
	
	        if (!order) {
	            return false;
	        }
	
	        if (isSingle) {
	            this._applySingleOrderChange(order, true);
	            return true;
	        } else {
	            this._applyBrewOrderChange(order, true);
	            return true;
	        }
	    },
	    _moveTask: function _moveTask(order, dataClicked, tankType, isSingle, offsetDays) {
	        var nextDateClickedText = DateUtils.toDateText(DateUtils.addDays(dataClicked, offsetDays));
	        var dateClickedText = DateUtils.toDateText(dataClicked);
	        var taskFieldName = isSingle ? 'singleTasks' : ContentUtils.getTankTypeConfiguration(tankType).tasksFieldName;
	        var tasks = _.get(order, taskFieldName, []);
	
	        if (!OrderUtils.isOutOfRangeNextTaskPosition(order, nextDateClickedText, isSingle, tankType)) {
	            return false;
	        }
	
	        // find the current task clicked
	        var taskClicked = _.find(tasks, function (task) {
	            return task.date === dateClickedText;
	        });
	
	        if (taskClicked) {
	            // exchange dates between old and new dates
	            taskClicked = this._updateTasksDates(tasks, taskClicked, nextDateClickedText);
	        }
	
	        // update task type
	        order = this._updateTasksType(order, taskFieldName);
	
	        return order;
	    },
	    _updateTasksDates: function _updateTasksDates(tasks, taskClicked, nextDateClickedText) {
	        // search if exist a task in the same place that we need to move current task clicked.
	        var taskToBeReplaced = _.find(tasks, function (task) {
	            return task.date === nextDateClickedText;
	        });
	
	        if (taskToBeReplaced) {
	            // exchanges dates between the current task date and the task which will be in the next position
	            var taskClickedCloned = _.cloneDeep(taskClicked);
	            var taskToBeReplacedCloned = _.cloneDeep(taskToBeReplaced);
	
	            // change to task to be replace to task clicked
	            taskToBeReplaced.date = taskClickedCloned.date;
	
	            // change task clicked to task to be replashould calculate enough items purchased but don't arrive in timeced
	            taskClicked.date = taskToBeReplacedCloned.date;
	        } else {
	            // just only change the current task date with the the next empty position.
	            taskClicked.date = nextDateClickedText;
	        }
	
	        // add default end hour product
	        taskClicked = OrderUtils.overrideDefaultEndHourToProductsOfTask(taskClicked, nextDateClickedText);
	
	        return taskClicked;
	    },
	    _removeOneDayBrewOrder: function _removeOneDayBrewOrder(order, tankClicked, dataClicked) {
	        if (order) {
	            var tankType = _.get(tankClicked, 'type');
	
	            if (tankType === Constants.TYPE_TANK_FERMENTER) {
	                var isEnoughTankAvailable = this._checkAvailabilityDecrementOneDay(order, order.briteTank);
	
	                if (!isEnoughTankAvailable) {
	                    Notification.show('Not enough space to resize packaging', 'error');
	                    return null;
	                }
	
	                // remove the task that was clicked
	                var dateClickedText = DateUtils.toDateText(dataClicked);
	                var tasks = _.get(order, 'fermenterTasks');
	                var tasksFiltered = _.filter(tasks, function (task) {
	                    return task.date !== dateClickedText;
	                });
	                order.fermenterTasks = tasksFiltered || [];
	
	                // decrement on day the rest of the task
	                order = this.decrementTaskOneDay(order, 'fermenterTasks', dataClicked, false);
	                order = this.decrementDateOneDay(order, 'filtrationDate');
	            } else {
	                // remove the task that was clicked
	                var _dateClickedText = DateUtils.toDateText(dataClicked);
	                var _tasks = _.get(order, 'packagingTasks');
	                var _tasksFiltered = _.filter(_tasks, function (task) {
	                    return task.date !== _dateClickedText;
	                });
	                order.packagingTasks = _tasksFiltered || [];
	
	                // decrement on day the rest of the task
	                order = this.decrementTaskOneDay(order, 'packagingTasks', dataClicked, false);
	                order = this.decrementDateOneDay(order, 'orderDate');
	            }
	        }
	        return order;
	    },
	    _addOneDayBelowBrewOrder: function _addOneDayBelowBrewOrder(order, tankClicked, dateClicked) {
	        return this._addDayBrewOrder(order, tankClicked, dateClicked, true);
	    },
	    _addOneDayAboveBrewOrder: function _addOneDayAboveBrewOrder(order, tankClicked, dateClicked) {
	        return this._addDayBrewOrder(order, tankClicked, dateClicked, false);
	    },
	    _addOneDayBelowSingleOrder: function _addOneDayBelowSingleOrder(order, dateClicked) {
	        return this._addDaySingleOrder(order, dateClicked, true);
	    },
	    _addOneDayAboveSingleOrder: function _addOneDayAboveSingleOrder(order, dateClicked) {
	        return this._addDaySingleOrder(order, dateClicked, false);
	    },
	    _addDayBrewOrder: function _addDayBrewOrder(order, tankClicked, dateClicked, isExcludeDateClickedToBeUpdated) {
	        var isEnoughTankAvailable = false;
	        var tankType = _.get(tankClicked, 'type');
	
	        if (tankType === Constants.TYPE_TANK_FERMENTER) {
	            // This is the spacial case only of fermenting section, we need to check both dates tank, because in case
	            // to increment 1 day in fermenting section we need to increase also de packaging side 1 day too.
	            // This double check is to prevent to lose existing packaging tasks.
	            isEnoughTankAvailable = this._checkAvailabilityIncrementOneDay(order, order.fermenterTank);
	
	            if (!isEnoughTankAvailable) {
	                Notification.show(t('notification_not_enough_space_to_add_day_fermenting_section'), 'error');
	                return null;
	            }
	
	            isEnoughTankAvailable = this._checkAvailabilityIncrementOneDay(order, order.briteTank);
	
	            if (!isEnoughTankAvailable) {
	                Notification.show(t('notification_not_enough_space_to_add_day_packaging_section'), 'error');
	                return null;
	            }
	
	            // increment 1 day all task
	            order = this._incrementTasksOneDay(order, 'fermenterTasks', dateClicked, isExcludeDateClickedToBeUpdated);
	            order = this._incrementTasksOneDay(order, 'packagingTasks', dateClicked, false);
	
	            // increment 1 day last date
	            order = this._incrementDateOneDay(order, 'filtrationDate');
	            order = this._incrementDateOneDay(order, 'orderDate');
	
	            // update task type
	            order = this._updateTasksType(order, 'fermenterTasks');
	        } else if (tankType === Constants.TYPE_TANK_BRITE_TANK) {
	
	            isEnoughTankAvailable = this._checkAvailabilityIncrementOneDay(order, order.briteTank);
	
	            if (!isEnoughTankAvailable) {
	                Notification.show(t('notification_not_enough_space_to_add_day_packaging_section'), 'error');
	                return null;
	            }
	
	            // increment 1 day all task
	            order = this._incrementTasksOneDay(order, 'packagingTasks', dateClicked, isExcludeDateClickedToBeUpdated);
	
	            // increment 1 day last date
	            order = this._incrementDateOneDay(order, 'orderDate', false);
	
	            // update task type
	            order = this._updateTasksType(order, 'packagingTasks');
	        }
	
	        return order;
	    },
	    _addDaySingleOrder: function _addDaySingleOrder(order, dateClicked, isExcludeDateClickedToBeUpdated) {
	        var isEnoughTankAvailable = this._checkSingleOrderAvailabilityIncrementOneDay(order, order.singleTank);
	
	        if (!isEnoughTankAvailable) {
	            Notification.show(t('notification_not_enough_space_to_add_day'), 'error');
	            return null;
	        }
	
	        // increment 1 day all task
	        order = this._incrementTasksOneDay(order, 'singleTasks', dateClicked, isExcludeDateClickedToBeUpdated);
	
	        // increment 1 day last date
	        order = this._incrementDateOneDay(order, 'toDate', false);
	
	        return order;
	    },
	    _incrementDateOneDay: function _incrementDateOneDay(order, lastDateField) {
	        return this._changeDate(order, lastDateField, 1);
	    },
	    decrementDateOneDay: function decrementDateOneDay(order, lastDateField) {
	        return this._changeDate(order, lastDateField, -1);
	    },
	    decrementTaskOneDay: function decrementTaskOneDay(order, fieldName, dateClicked, isExcludeDateClickedToBeUpdated) {
	        return this._changeTask(order, fieldName, dateClicked, isExcludeDateClickedToBeUpdated, -1);
	    },
	    _incrementTasksOneDay: function _incrementTasksOneDay(order, fieldName, dateClicked, isExcludeDateClickedToBeUpdated) {
	        return this._changeTask(order, fieldName, dateClicked, isExcludeDateClickedToBeUpdated, 1);
	    },
	    _changeDate: function _changeDate(order, lastDateField, offsetDay) {
	        var lastDate = DateUtils.toDate(order[lastDateField]);
	        order[lastDateField] = DateUtils.addDaysTextBasicFormat(lastDate, offsetDay);
	        return order;
	    },
	    _changeTask: function _changeTask(order, fieldName, dateClicked, isExcludeDateClickedToBeUpdated, offsetDay) {
	        var tasks = _.get(order, fieldName);
	
	        // starting to separate in two groups of task:
	        // The First group: is the group of task after date clicked which need to be updated.
	        // The Second group: is the group of task which not need to be updated because is before to date clicked
	        if (tasks && _.get(tasks, 'length') > 0) {
	
	            // First group (need update)
	            var taskAfterClickedChanged = this._updateTasks(order, tasks, dateClicked, offsetDay, isExcludeDateClickedToBeUpdated);
	
	            // Second group (not need update)
	            var taskBeforeClicked = _.filter(tasks, function (task) {
	                if (isExcludeDateClickedToBeUpdated) {
	                    // which means was excluded to be updated, so need to be included to second group to non be updated
	                    return DateUtils.isBeforeOrEquals(task.date, DateUtils.toDateText(dateClicked));
	                } else {
	                    return DateUtils.isBefore(task.date, DateUtils.toDateText(dateClicked));
	                }
	            });
	
	            // combined both groups
	            var allTaskUpdated = _.concat(taskBeforeClicked, taskAfterClickedChanged);
	
	            // recalculate all of types of tasks
	            var allTaskTypeUpdated = _.map(allTaskUpdated, function (task) {
	                return OrderUtils.updateTaskType(order, task);
	            });
	
	            // updating order tasks with combined groups
	            order = _.set(order, fieldName, allTaskTypeUpdated);
	        }
	        return order;
	    },
	    _updateTasks: function _updateTasks(order, tasks, dateClicked, offsetDay, isExcludeDateClickedToBeUpdated) {
	        // filter the set of task that will need to be updated
	        var datesAftertDateClicked = _.filter(tasks, function (task) {
	            if (isExcludeDateClickedToBeUpdated) {
	                return DateUtils.isAfter(task.date, DateUtils.toDateText(dateClicked));
	            } else {
	                return DateUtils.isAfterOrEquals(task.date, DateUtils.toDateText(dateClicked));
	            }
	        });
	
	        // update task in terms of dates and types
	        var taskAfterClickedChanged = _.map(datesAftertDateClicked, function (task) {
	            task.date = DateUtils.addDaysTextBasicFormat(DateUtils.toDate(task.date), offsetDay);
	            return task;
	        });
	
	        return taskAfterClickedChanged;
	    },
	    _updateTasksType: function _updateTasksType(order, taskFieldName) {
	        var tasks = _.get(order, taskFieldName, []);
	        var tasksUpdated = _.map(tasks, function (task) {
	            return OrderUtils.updateTaskType(order, task);
	        });
	        order[taskFieldName] = tasksUpdated;
	        return order;
	    },
	    _checkAvailabilityIncrementOneDay: function _checkAvailabilityIncrementOneDay(order, tankClicked) {
	        return this._checkAvailabilityInLastDate(order, tankClicked, 1);
	    },
	    _checkAvailabilityDecrementOneDay: function _checkAvailabilityDecrementOneDay(order, tankClicked) {
	        return this._checkAvailabilityInLastDate(order, tankClicked, -1);
	    },
	    _checkSingleOrderAvailabilityIncrementOneDay: function _checkSingleOrderAvailabilityIncrementOneDay(order, tankClicked) {
	        return this._checkSingleOrderAvailabilityInLastDate(order, tankClicked, 1);
	    },
	    _checkSingleOrderAvailabilityDecrementOneDay: function _checkSingleOrderAvailabilityDecrementOneDay(order, tankClicked) {
	        return this._checkSingleOrderAvailabilityInLastDate(order, tankClicked, -1);
	    },
	    _checkAvailabilityInLastDate: function _checkAvailabilityInLastDate(order, tankClicked, offsetDay) {
	        var position = void 0,
	            lastDateOrder = void 0;
	        var tankType = _.get(tankClicked, 'type');
	
	        if (tankType === Constants.TYPE_TANK_FERMENTER) {
	            position = OrderUtils.toFermenterTankPosition(order, ChronologycStore.getCurrentFrom());
	            lastDateOrder = order.brewDate;
	        } else if (tankType === Constants.TYPE_TANK_BRITE_TANK) {
	            position = OrderUtils.toBriteTankPosition(order, ChronologycStore.getCurrentFrom());
	            lastDateOrder = order.filtrationDate;
	        }
	
	        // update position with the user interaction
	        // Add 1 day in order to really know if an extra day added
	        position.y = ChronologycStore.getYFromDate(lastDateOrder) + offsetDay;
	        position.x = tankClicked.column;
	
	        return DashboardLayoutStore.isEmpty(position);
	    },
	    _checkSingleOrderAvailabilityInLastDate: function _checkSingleOrderAvailabilityInLastDate(order, tankClicked, offsetDay) {
	        var position = void 0,
	            lastDateOrder = void 0;
	
	        position = OrderUtils.toSingleTankPosition(order, ChronologycStore.getCurrentFrom());
	        lastDateOrder = order.fromDate;
	
	        // update position with the user interaction
	        // Add 1 day in order to really know if an extra day added
	        position.y = ChronologycStore.getYFromDate(lastDateOrder) + offsetDay;
	        position.x = tankClicked.column;
	
	        return DashboardLayoutStore.isEmpty(position);
	    },
	    _applySingleOrderChange: function _applySingleOrderChange(order, nonDispatchAction) {
	        var singlePosition = TankStore.getSingleTankPosition(order);
	        DashboardLayoutStore.updateSingleLayoutPosition(singlePosition);
	        // Indicate last order in order to jump later
	        this.updateLastOrderUpdated(order);
	        this.markOrder(_.get(order, 'id'));
	
	        DashboardServiceCache.changeOrder(order);
	        DraftSchedule.changeOrder(order);
	        if (!nonDispatchAction) {
	            DashboardAction.changeOrder(order);
	        }
	    },
	    _applyBrewOrderChange: function _applyBrewOrderChange(order, nonDispatchAction) {
	        var positionBriteTank = TankStore.getBriteTankPosition(order);
	        var positionFermenterTank = TankStore.getFermenterTankPosition(order);
	        // Indicate last order in order to jump later
	        this.updateLastOrderUpdated(order);
	        this.markOrder(_.get(order, 'id'));
	
	        DashboardLayoutStore.updateLayoutPosition(positionFermenterTank, positionBriteTank);
	        DashboardServiceCache.changeOrder(order);
	        DraftSchedule.changeOrder(order);
	        if (!nonDispatchAction) {
	            DashboardAction.changeOrder(order);
	        }
	    },
	
	
	    /**
	     * Apply change of the given order without execute Commons validation in the order.
	     * @param order
	     * @private
	     */
	    _changeOrderWithoutCheck: function _changeOrderWithoutCheck(order) {
	        var offsetDays = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var isBatchingProcess = arguments[2];
	        var layout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DashboardLayoutStore.getLayout();
	        var isResizing = arguments[4];
	        var onSuccess = arguments[5];
	        var onFailure = arguments[6];
	
	        if (OrderUtils.checkDateOfOrder(order)) {
	
	            if (!isResizing && _.get(order, 'batchs.length', 0) > 0) {
	                // validate if have batchs, because toggle off on brewhouse not make brew batchs
	                order = BrewhouseStore.recalculateBrewhouseBatchsWithLayout(order, offsetDays, layout, isBatchingProcess);
	                if (order.volume && order.brewhouseMessageError) {
	                    // enter here means that the brew house is full
	                    if (onFailure) {
	                        onFailure(order.brewhouseMessageError);
	                    } else {
	                        Notification.show(order.brewhouseMessageError);
	                    }
	                    DashboardAction.forceRenderDashboard();
	                    return;
	                }
	            }
	
	            var positionBriteTank = TankStore.getBriteTankPosition(order);
	            var positionFermenterTank = TankStore.getFermenterTankPosition(order);
	            var batchsPositions = BrewhouseStore.getBatchPositions(order);
	
	            DashboardLayoutStore.updateLayoutPositions(positionFermenterTank, positionBriteTank, batchsPositions);
	
	            this.updateLastOrderUpdated(order);
	            this.markOrder(_.get(order, 'id'));
	
	            DashboardServiceCache.changeOrder(order);
	            DraftSchedule.changeOrder(order);
	            DashboardAction.changeOrder(order);
	            if (onSuccess) {
	                onSuccess();
	            }
	        }
	    },
	
	
	    /**
	     * Apply change of the given order without execute Commons validation in the order.
	     * @param order
	     */
	    changeSingleOrderWithoutCheck: function changeSingleOrderWithoutCheck(order, onSuccess, onFailure, isBHAllowed, layout) {
	        if (OrderSingleStore.checkDateOfSingleOrder(order)) {
	
	            if (isBHAllowed) {
	                // calculated batch of brewhouse
	                order = BrewhouseStore.recalculateBrewhouseBatchsWithLayout(order, 0, layout);
	                if (order.volume && order.brewhouseMessageError) {
	                    // enter here means that the brew house is full
	                    if (onFailure) {
	                        onFailure(order.brewhouseMessageError);
	                    } else {
	                        Notification.show(order.brewhouseMessageError);
	                    }
	                    return;
	                }
	            } else {
	                order.isBHAllowed = false; // to indicated to lastOrderUpdate of dashboard that is not need to calculate brewhouse batchs
	            }
	
	            var singlePosition = TankStore.getSingleTankPosition(order);
	            var batchsPositions = BrewhouseStore.getBatchPositions(order);
	
	            DashboardLayoutStore.updateLayoutPositions(singlePosition, batchsPositions);
	
	            // Indicate last order in order to jump later
	            this.updateLastOrderUpdated(order);
	            this.markOrder(_.get(order, 'id'));
	
	            DashboardServiceCache.changeOrder(order);
	            DraftSchedule.changeOrder(order);
	            DashboardAction.changeOrder(order);
	
	            if (onSuccess) {
	                onSuccess();
	            }
	        }
	    },
	    _changeOrderWithoutCheckBrewingSection: function _changeOrderWithoutCheckBrewingSection(order) {
	        if (OrderUtils.checkDateOfOrder(order)) {
	
	            var positionBriteTank = TankStore.getBriteTankPosition(order),
	                positionFermenterTank = TankStore.getFermenterTankPosition(order),
	                batchsPositions = BrewhouseStore.getBatchPositions(order);
	
	            DashboardLayoutStore.updateLayoutPositions(positionFermenterTank, positionBriteTank, batchsPositions);
	            this.updateLastOrderUpdated(order);
	            this.markOrder(_.get(order, 'id'));
	
	            DashboardServiceCache.changeOrder(order);
	            DraftSchedule.changeOrder(order);
	            DashboardAction.changeOrder(order);
	        }
	    },
	    changeSingleOrderWithoutCheckBrewingSection: function changeSingleOrderWithoutCheckBrewingSection(order, onSuccess) {
	        if (OrderSingleStore.checkDateOfSingleOrder(order)) {
	
	            var singlePosition = TankStore.getSingleTankPosition(order);
	            var batchsPositions = BrewhouseStore.getBatchPositions(order);
	
	            DashboardLayoutStore.updateLayoutPositions(singlePosition, batchsPositions);
	
	            // Indicate last order in order to jump later
	            this.updateLastOrderUpdated(order);
	            this.markOrder(_.get(order, 'id'));
	
	            DashboardServiceCache.changeOrder(order);
	            DraftSchedule.changeOrder(order);
	            DashboardAction.changeOrder(order);
	
	            if (onSuccess) {
	                onSuccess();
	            }
	        }
	    },
	
	
	    /**
	     * Given the position origin and destination, will be upgrade the order
	     * with the new postion. For that, will be execute all the validation of the order,
	     * like availability of tanks, dates consistency of the order, etc.
	     *
	     * @param {Object} positionNew is the destination position.
	     * @param {Object} positionOld is the origin position.
	     * @private
	     * @return {Object}
	     */
	    _changeOrderFromNewPosition: function _changeOrderFromNewPosition(positionOld, positionNew) {
	        var isBatchingProcess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var layout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DashboardLayoutStore.getLayout();
	
	        var order = this.getSafeOrder(_.get(positionNew, 'i'));
	
	        if (!order) return;
	
	        if (order.isSingle) {
	            return this._changeSingleOrder(positionOld, positionNew, order, isBatchingProcess, layout);
	        } else {
	            return this._changeOrder(positionOld, positionNew, order, isBatchingProcess, layout);
	        }
	    },
	    _changeSingleOrder: function _changeSingleOrder(positionOld, positionNew, order, isBatchingProcess) {
	        var _this4 = this;
	
	        var layout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DashboardLayoutStore.getLayout();
	
	        try {
	            var newFromDate = void 0,
	                newToDate = void 0,
	                isDragging = true,
	                orderVolume = ContentUtils.getNumber(_.get(order, 'volume', 0));
	
	            // Should not do save nothing if the same position
	            if (ContentUtils.isSameObject(positionOld, positionNew, propsToValiadte)) {
	                return;
	            }
	
	            if (!this._isProperlyTypeOfTankDestination(positionNew)) {
	                Notification.show(t('dashboard_notification_order_can_not_moved_differen_type_tank'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return order;
	            }
	
	            // NOTE:
	            // 1 - Only validate the volume of the order that have volume higher than zero.
	            // 2 - Only validate the volume of the orders, it doesn't include batch of BH, (because each of batch from BH have only a part of total volume of the order)
	            if (!ContentUtils.isBH(positionNew.i) && !ContentUtils.isBHBatch(positionNew.i) && orderVolume > 0 && !ContentUtils.isBHBatch(positionNew.i) && !BrewhouseStore.isProperlyVolumeOfTankDestination(positionNew, orderVolume)) {
	                // enter here means that try to move the position to another tank that don't have volume enough
	                Notification.show(t('dashboard_notification_volume_capacity_insufficient'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return order;
	            }
	
	            if (DashboardLayoutStore.isEmpty(positionNew)) {
	                newFromDate = ChronologycStore.getFirstDate(positionNew).date;
	                newToDate = ChronologycStore.getLastDate(positionNew).date;
	                order.singleTank = DashboardServiceCache.getTankByColumn(positionNew.x);
	                order.singleTankId = order.singleTank.id;
	
	                if (positionNew.h !== positionOld.h) {
	                    // enter here means that we are resizing vertical order movement
	                    isDragging = false;
	                }
	
	                order.fromDate = newFromDate || order.fromDate;
	                order.toDate = newToDate || order.toDate;
	                order = OrderSingleStore.recalculateSingleOrderTasks(order, isDragging, positionOld, positionNew);
	
	                var offsetDays = OrderUtils.getVerticalOffeset(positionOld, positionNew);
	
	                // calculated batch of brewhouse
	                if (_.get(order, 'batchs.length', 0) > 0) {
	                    // Only recalculate batch's of orders that already have batch before.
	                    order = BrewhouseStore.recalculateBrewhouseBatchsWithLayout(order, offsetDays, layout, isBatchingProcess);
	                    if (order.volume && order.brewhouseMessageError) {
	                        // enter here means that the brew house is full
	                        Notification.show(order.brewhouseMessageError);
	                        return;
	                    }
	                }
	
	                this.changeSingleOrderWithoutCheck(order);
	
	                // we need delay the mark order, in order to get time
	                // to the order which insert the node in the dashboard.
	                // NOTE: note try to do that during Dashboard.drawOrders
	                // because will be affected drag and drop operation.
	                setTimeout(function () {
	                    _this4.markOrder(_.get(order, 'id'));
	                }, 1000);
	            } else {
	                Notification.show(t('notification_no_space_available'));
	            }
	            return order;
	        } catch (error) {
	            console.error('OrderStore._changeSingleOrder: ', error);
	            throw error;
	        }
	    },
	    _changeOrder: function _changeOrder(oldPosition, newPosition, order, isBatchingProcess, nextLayout) {
	        try {
	            var isBriteTank = void 0,
	                newBrewDate = void 0,
	                newFiltrationDate = void 0,
	                newOrderDate = void 0,
	                newPositionSiblingTank = void 0,
	                differedDays = void 0,
	                orderId = ContentUtils.cleanId(newPosition.i),
	                nextTankAvailable = void 0,
	                isDragging = true,
	                orderVolume = +_.get(order, 'volume', 0),
	                offsetResizing = 0;
	
	            var backupLayout = _.cloneDeep(DashboardLayoutStore.getLayout());
	
	            if (ContentUtils.isSameObject(oldPosition, newPosition, propsToValiadte)) {
	                // enter here means that the old and new position is the same, so do nothing
	                return;
	            }
	
	            if (!this._isProperlyTypeOfTankDestination(newPosition)) {
	                // enter here means that try to move the position to another incompatible section
	                Notification.show(t('dashboard_notification_order_can_not_moved_differen_type_tank'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return null;
	            }
	
	            var offsetDays = newPosition.y - oldPosition.y;
	
	            if (orderVolume > 0 && !BrewhouseStore.isProperlyVolumeOfTankDestination(newPosition, orderVolume)) {
	                // enter here means that try to move the position to another tank that don't have volume enough
	                Notification.show(t('dashboard_notification_volume_capacity_insufficient'));
	                DashboardAction.forceRenderDashboard(); // needed to get back the position after the second time to retry move wrong
	                return null;
	            }
	
	            if (DashboardLayoutStore.isEmpty(newPosition)) {
	
	                isBriteTank = ContentUtils.isBT(newPosition.i);
	
	                if (!order) {
	                    Notification.show(t('notification_label_the_order') + orderId + t('notification_order_not_available'));
	                    return;
	                }
	
	                if (isBriteTank) {
	                    // enter here means the current position is brite tank
	                    newFiltrationDate = ChronologycStore.getFirstDate(newPosition).date;
	                    newOrderDate = ChronologycStore.getLastDate(newPosition).date;
	                    order.briteTank = DashboardServiceCache.getTankByColumn(newPosition.x);
	                    order.briteTankId = order.briteTank.id;
	                    order.orderDate = newOrderDate;
	                    order.filtrationDate = newFiltrationDate;
	                    // try to calculate the sibling tank
	                    newPositionSiblingTank = TankStore.getPositionFermenterFromBriteTank(order, newPosition, oldPosition);
	                } else {
	                    // enter here means the current position is fermenter tank
	                    newBrewDate = ChronologycStore.getFirstDate(newPosition).date;
	                    newFiltrationDate = ChronologycStore.getLastDate(newPosition).date;
	                    order.fermenterTank = DashboardServiceCache.getTankByColumn(newPosition.x);
	                    order.fermenterTankId = order.fermenterTank.id;
	                    order.brewDate = newBrewDate;
	                    order.filtrationDate = newFiltrationDate;
	                    // try to calculate the sibling tank
	                    newPositionSiblingTank = TankStore.getPositionBriteTankFromFermenter(order, newPosition, oldPosition);
	                    if (newPositionSiblingTank && newPositionSiblingTank.h <= 0) {
	                        Notification.show(t('notification_the_transfer_date_cannot_after_packaging_date'), 'error');
	                        return;
	                    }
	                }
	
	                if (newPosition.h !== oldPosition.h) {
	                    // means the current position is vertical resizing, not dragging
	                    isDragging = false;
	                    // days offset that was changed the filtration date or packaging date
	                    offsetResizing = newPosition.h - oldPosition.h;
	                }
	
	                // If change the vertical position we need to calculate the brew date or order date, depend the tank that was moved.
	                if (newPosition.y !== oldPosition.y || newPosition.h !== oldPosition.h) {
	                    differedDays = newPosition.y - oldPosition.y;
	                    if (isBriteTank) {
	                        newBrewDate = ChronologycStore.getDateFromPositionY(newPositionSiblingTank.y).date;
	                    } else {
	                        newOrderDate = ChronologycStore.getDateFromPositionY(newPositionSiblingTank.y + newPositionSiblingTank.h - 1).date;
	                    }
	                }
	
	                if (!newPositionSiblingTank && isBriteTank) {
	                    // Enter here means that the filtration tank was out of range and the change position came from brite tank.
	                    newPositionSiblingTank = TankStore.getFermenterTankPositionManual(orderId, order.fermenterTank.column, newBrewDate, newFiltrationDate, order.batchNumber, order.isSingle);
	                }
	
	                if (isSiblingTankPositionAvailable(newPositionSiblingTank, differedDays)) {
	                    // Enter here means the new position of sibling tank is already taken, for that, we try to follow another empty position in the same day in another tank.
	                    if (isBriteTank) {
	                        nextTankAvailable = TankStore.getNextFermenterTankAvailable(DateUtils.toDate(newBrewDate), DateUtils.toDate(newFiltrationDate), orderId, order.volume);
	                    } else {
	                        nextTankAvailable = TankStore.getNextBriteTankAvailable(DateUtils.toDate(newFiltrationDate), DateUtils.toDate(newOrderDate), orderId, order.volume);
	                    }
	                    if (nextTankAvailable) {
	                        // Enter here means that original position for sibling tank was taken but could be found another one for the same day.
	                        if (isBriteTank) {
	                            order.fermenterTank = nextTankAvailable;
	                            order.fermenterTankId = nextTankAvailable.id;
	                        } else {
	                            order.briteTank = nextTankAvailable;
	                            order.briteTankId = nextTankAvailable.id;
	                        }
	                    } else {
	                        // Enter here means that the new position of sibling tank was taken, we try to found another tank but all the tank for this day are taken too.
	                        Notification.show(t('notification_no_space_available'));
	                        DashboardLayoutStore.setLayout(backupLayout);
	                        return;
	                    }
	                }
	
	                order.brewDate = newBrewDate || order.brewDate;
	                order.orderDate = newOrderDate || order.orderDate;
	                order.filtrationDate = newFiltrationDate;
	                order.batchNumber = _.get(newPosition, 'batchNumber');
	                order = this.recalculateOrderTasks(order, isDragging, offsetDays, offsetResizing, isBriteTank);
	
	                this._changeOrderWithoutCheck(order, offsetDays, isBatchingProcess, nextLayout, !isDragging);
	            } else {
	                DashboardLayoutStore.setLayout(backupLayout);
	                Notification.show(t('notification_no_space_available'));
	                return;
	            }
	            return order;
	        } catch (error) {
	            console.error('OrderStore._changeOrder: ', error);
	            throw error;
	        }
	    },
	
	
	    /**
	     * Change the order which have another order asociated by Bach Number.
	     *
	     * <b>NOTE:</b> this method is full support by Single and Combined order compliance.
	     *
	     * @param oldPosition
	     * @param newPosition
	     * @param stickyOrdersWithoutOldPosition
	     * @param offsetY
	     * @return {Array}
	     * @private
	     */
	    _changeOrderFromNewPositionWithStickyOrder: function _changeOrderFromNewPositionWithStickyOrder(newPosition, offsetY) {
	        var _this5 = this;
	
	        var result = [];
	
	        var backupLayout = _.cloneDeep(DashboardLayoutStore.getLayout());
	
	        // this layout will be share the same state of positions along to all the batching processing operation
	        var nextLayout = _.cloneDeep(DashboardLayoutStore.getLayout());
	
	        // process all position of given batch number and return the result of this process
	        var resultProcess = this._processPositions(newPosition, nextLayout, offsetY);
	
	        // all the new position already processed
	        var newPositions = _.map(resultProcess.positionsPerformed, function (position) {
	            return position.newPosition;
	        });
	
	        // ask if same position is out of range of dashboard.
	        if (this._isSamePositionOutOfRange(newPositions)) {
	            Notification.show(t('notification_order_outside_visible_area'), 'warning');
	            DashboardLayoutStore.setLayout(backupLayout);
	            return result;
	        }
	
	        // Only apply all changes when ALL position are available's and passed all validations!!
	        if (resultProcess.isAllPositionAvailables) {
	            this._processPendingUpdatesOrders(resultProcess);
	
	            if (resultProcess.positionsPerformed && resultProcess.positionsPerformed.length > 0) {
	                // update layout position with new positions
	                _.forEach(_.map(resultProcess.positionsPerformed, function (position) {
	                    return position.newPosition;
	                }), function (newPosition) {
	                    DashboardLayoutStore.updateLayoutPositionBySpecificId(newPosition);
	                });
	
	                var isBatchingProcess = true;
	                // apply the whole chages of each positions computed because all validation was success!
	                _.forEach(resultProcess.positionsPerformed, function (position) {
	                    // calculate dates given old and new position already computed.
	                    result.push(_this5._changeOrderFromNewPosition(position.oldPosition, position.newPosition, isBatchingProcess));
	                });
	            }
	            backupLayout = null;
	            nextLayout = null;
	            // notify that all operation are already executed
	            DashboardAction.executeBatchOperationsEnd(_.get(newPosition, 'batchNumber'));
	            return result;
	        } else {
	            // enter here means that some of position don't have space enough, so all batch could not be moved, we restore the layout as the beginning
	            Notification.show('No space available', 'error');
	            DashboardLayoutStore.setLayout(backupLayout);
	            return result;
	        }
	    },
	    _processPendingUpdatesOrders: function _processPendingUpdatesOrders(resultProcess) {
	        // execute all pending update order operations
	        if (_.get(resultProcess, 'pendingUpdateOrders.length', 0) > 0) {
	            for (var _iterator = resultProcess.pendingUpdateOrders, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var pendingUpdateOrder = _ref;
	
	                pendingUpdateOrder();
	            }
	        }
	    },
	    _processPositions: function _processPositions(newPosition, nextLayout, offsetY) {
	        // the whole position of batch
	        var batchAllPositions = _.filter(nextLayout, function (position) {
	            return position.batchNumber === newPosition.batchNumber;
	        });
	
	        var resultProcess = {
	            isAllPositionAvailables: true
	        };
	
	        var positionPerformedIds = [];
	        var positionsPerformed = [];
	        var pendingUpdateOrders = [];
	        var result = {
	            isProcessOK: true
	        };
	
	        var batchNumber = newPosition.batchNumber;
	        var brewDates = this._getAllPositionByBatchnumberWithoutBrewhouse(batchNumber, nextLayout);
	        var brewhousesByY = this._getAllBrewhouseBatchsByY(batchNumber, nextLayout);
	
	        if (!this._checkIfOrderHaveEnoughBatchsAvailablesOnBrewDates(brewhousesByY, batchNumber, offsetY, brewDates, nextLayout, offsetY)) {
	            Notification.show(t('notification_not_enough_brewhouse_turns_available'));
	            result.isProcessOK = false;
	
	            return result;
	        }
	
	        var isAllPositionAvailables = true;
	
	        // process each position of whole batch order
	        for (var _iterator2 = batchAllPositions, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var oldPosition = _ref2;
	
	            var nextPosition = _.cloneDeep(oldPosition);
	
	            // apply offset to position
	            nextPosition.y = nextPosition.y + offsetY;
	
	            // only apply x and h which position that are currently dragged
	            if (oldPosition.i === newPosition.i) {
	                nextPosition.x = newPosition.x;
	                nextPosition.h = newPosition.h;
	            }
	
	            // check if already processed this order
	            if (OrderUtils.isAlreadyPerformedGivenPosition(positionPerformedIds, nextPosition)) {
	                // enter here means the position are already processed, so we continue with the next
	                continue;
	            } else {
	
	                if (ContentUtils.isBHBatch(nextPosition.i)) {
	                    // process batch position just to be sure that will valid the next position.
	                    result = this._processBatchPosition(nextPosition, oldPosition, nextLayout, positionPerformedIds, positionsPerformed, offsetY);
	                } else {
	                    // process all siblings of combined order and the single position in chase of singles.
	                    result = this._processPosition(nextPosition, oldPosition, nextLayout, positionPerformedIds, positionsPerformed, offsetY);
	                }
	
	                if (result.isProcessOK) {
	                    if (result.doUpdateOrder) {
	                        pendingUpdateOrders.push(result.doUpdateOrder);
	                    }
	                    nextLayout = result.nextLayout;
	                } else {
	                    // if it has at least one position that it doesn't available, should not say that
	                    // all positions are availables
	                    isAllPositionAvailables = false;
	                    break;
	                }
	            }
	        }
	
	        resultProcess.isAllPositionAvailables = isAllPositionAvailables;
	
	        // Remove all unneeded positions such us:
	        // When we have a combined order, eg: Fermenting and Packaging position,
	        // only keep one of them, and the another will be re-calculated in
	        // the `_changeOrder` method. Also all the batch position from brewhouse
	        // section, will be removed as well, because will be calculated again into
	        // the method `_changeOrder` too.
	        var positionsPerformedUpdated = OrderUtils.filterUnneededPositions(positionsPerformed);
	
	        resultProcess.positionsPerformed = positionsPerformedUpdated;
	        resultProcess.pendingUpdateOrders = pendingUpdateOrders;
	        return resultProcess;
	    },
	    _checkIfOrderHaveEnoughBatchsAvailablesOnBrewDates: function _checkIfOrderHaveEnoughBatchsAvailablesOnBrewDates(batchsByY, batchNumber, offsetY, brewDates, nextLayout) {
	        var amountBrewhouseBatch = _.filter(TankStore.getTanks(), function (tank) {
	            return tank.type === 'BH';
	        }).length;
	
	        var amountOfBatchAvailableByDate = {};
	        var amountOfBatchNonAvailableByDate = {};
	
	        // amount of non availables batch by date
	
	        var _loop = function _loop() {
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) return 'break';
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) return 'break';
	                _ref3 = _i3.value;
	            }
	
	            var brewDatePosition = _ref3;
	
	            var date = _.get(ChronologycStore.getDateFromPositionY(brewDatePosition.y), 'date');
	            var positionYUpdated = brewDatePosition.y + offsetY;
	            var dateUpdated = DateUtils.addDaysTextBasicFormat(date, offsetY);
	            var batchOccupied = _.filter(nextLayout, function (position) {
	                return position.y === positionYUpdated && ContentUtils.isBHBatch(position.i) && position.batchNumber !== batchNumber;
	            });
	
	            amountOfBatchNonAvailableByDate[dateUpdated] = _.get(batchOccupied, 'length', 0);
	            amountOfBatchAvailableByDate[dateUpdated] = amountBrewhouseBatch - _.get(batchOccupied, 'length', 0);
	        };
	
	        for (var _iterator3 = brewDates, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	
	        for (var _iterator4 = brewDates, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	            var _ref4;
	
	            if (_isArray4) {
	                if (_i4 >= _iterator4.length) break;
	                _ref4 = _iterator4[_i4++];
	            } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) break;
	                _ref4 = _i4.value;
	            }
	
	            var brewDatePosition = _ref4;
	
	            var _positionYUpdated = brewDatePosition.y + offsetY;
	            var brewDate = _.get(ChronologycStore.getDateFromPositionY(_positionYUpdated), 'date');
	
	            var amountOfBatchNeedToTake = _.get(batchsByY[brewDatePosition.y], 'length', 0);
	            if (amountOfBatchAvailableByDate[brewDate] < amountOfBatchNeedToTake) {
	                return false;
	            }
	        }
	
	        return true;
	    },
	    _getAllBrewhouseBatchsByY: function _getAllBrewhouseBatchsByY(batchNumber, nextLayout) {
	        var allBatchOfBrewhouse = _.filter(nextLayout, function (position) {
	            return position.batchNumber === batchNumber && ContentUtils.isBHBatch(position.i);
	        });
	        var groupBrewhouseBatchByOrder = _.groupBy(allBatchOfBrewhouse, function (position) {
	            return position.y;
	        });
	        return groupBrewhouseBatchByOrder;
	    },
	    _getAllPositionByBatchnumberWithoutBrewhouse: function _getAllPositionByBatchnumberWithoutBrewhouse(batchNumber, nextLayout) {
	        var allBatchOfBrewhouse = _.filter(nextLayout, function (position) {
	            return position.batchNumber === batchNumber && !ContentUtils.isBH(position.i) && !ContentUtils.isBT(position.i);
	        });
	
	        var groupBrewhouseBatchByOrder = _.groupBy(allBatchOfBrewhouse, function (position) {
	            return ContentUtils.cleanId(position.i);
	        });
	        var brewhouseBatch = [];
	
	        var _loop2 = function _loop2(orderId) {
	            var batchs = groupBrewhouseBatchByOrder[orderId];
	            var positionYBrewDate = _.get(_.minBy(batchs, 'y'), 'y');
	            var brewDateBrewhouseBatchs = _.filter(batchs, function (batch) {
	                return batch.y === positionYBrewDate;
	            });
	            brewhouseBatch.push(brewDateBrewhouseBatchs);
	        };
	
	        for (var orderId in groupBrewhouseBatchByOrder) {
	            _loop2(orderId);
	        }
	
	        return _.flatten(brewhouseBatch);
	    },
	    _processPosition: function _processPosition(nextPosition, oldPosition, nextLayout) {
	        var positionPerformedIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	        var _this6 = this;
	
	        var positionsPerformed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	        var offsetY = arguments[5];
	
	
	        var result = {
	            isProcessOK: true,
	            nextLayout: nextLayout
	        };
	
	        if (DashboardLayoutStore.isEmpty(nextPosition, nextLayout)) {
	            // enter here once the new position have an empty space their new location
	            result.doUpdateOrder = function () {
	                _this6._updateOrder(nextPosition, offsetY);
	            };
	            this._updatePositionPerformed(positionPerformedIds, positionsPerformed, nextPosition, oldPosition);
	            nextLayout = this._updateLayoutWithPosition(nextLayout, nextPosition);
	            result.nextLayout = nextLayout;
	            return result;
	        } else {
	            // enter here means that is occupied next position wich an order with another bach number
	            var nextPositionAvailable = this._getNextPositionAvailable(nextPosition, offsetY, nextLayout);
	
	            if (nextPositionAvailable) {
	                result.doUpdateOrder = function () {
	                    // enter here once the next available position have an empty, so we performed it
	                    _this6._updateOrder(nextPositionAvailable, offsetY);
	                };
	
	                this._updatePositionPerformed(positionPerformedIds, positionsPerformed, nextPositionAvailable, oldPosition);
	                nextLayout = this._updateLayoutWithPosition(nextLayout, nextPositionAvailable);
	                result.nextLayout = nextLayout;
	                return result;
	            } else {
	                // cancel all batch operation because one of the positions could not be re-located.
	                result.isProcessOK = false;
	                return result;
	            }
	        }
	    },
	    _processBatchPosition: function _processBatchPosition(nextPosition, oldPosition, nextLayout) {
	        var positionPerformedIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	        var positionsPerformed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	        var offsetY = arguments[5];
	
	        var result = {
	            isProcessOK: true,
	            nextLayout: nextLayout
	        };
	        var order = this.getSafeOrder(_.get(nextPosition, 'i'));
	        var orderUpdated = OrderUtils.updateDates(order, offsetY);
	        var startDate = ContentUtils.getOrderField(orderUpdated, 'startDate');
	        var batchAvailables = BrewhouseStore.getBatchAvailables(orderUpdated, startDate, offsetY, nextLayout);
	
	        if (_.get(batchAvailables, 'length', 0) === 0) {
	            result.isProcessOK = false;
	
	            return result;
	        } else {
	            var batchElected = OrderUtils.electBatchAvailable(batchAvailables, nextPosition);
	            var batchElectedPosition = _.get(batchElected, 'position');
	
	            // update this current position
	            nextLayout = this._updateLayoutWithPosition(nextLayout, batchElectedPosition, nextPosition.i);
	
	            this._updatePositionPerformed(positionPerformedIds, positionsPerformed, nextPosition, oldPosition);
	
	            result.nextLayout = nextLayout;
	
	            return result;
	        }
	    },
	    _updateOrderOfSiblingPositions: function _updateOrderOfSiblingPositions(nextLayout, order) {
	        var siblingPositions = _.filter(nextLayout, function (position) {
	            return position.batchNumber === order.batchNumber && ContentUtils.isBHBatch(position.i);
	        });
	
	        for (var _iterator5 = siblingPositions, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
	            var _ref5;
	
	            if (_isArray5) {
	                if (_i5 >= _iterator5.length) break;
	                _ref5 = _iterator5[_i5++];
	            } else {
	                _i5 = _iterator5.next();
	                if (_i5.done) break;
	                _ref5 = _i5.value;
	            }
	
	            var positionsUpdated = _ref5;
	
	            nextLayout = this._updateLayoutWithPosition(nextLayout, positionsUpdated);
	        }
	
	        return nextLayout;
	    },
	    _getNextPositionAvailable: function _getNextPositionAvailable(newPosition, offsetY, layout) {
	        var order = this.getSafeOrder(_.get(newPosition, 'i'));
	
	        // enter here which means the position could be or FV or BT position.
	        return this._getNextFermentingOrPackagingPositionAvailable(order, newPosition, offsetY, layout);
	    },
	    _getNextFermentingOrPackagingPositionAvailable: function _getNextFermentingOrPackagingPositionAvailable(order, newPosition, offsetDays, layout) {
	        var tank = TankStore.getTankByColumn(newPosition.x);
	        var startDate = DateUtils.toDate(ContentUtils.getOrderField(order, 'startDate', tank.type, offsetDays));
	        var endDate = DateUtils.toDate(ContentUtils.getOrderField(order, 'endDate', tank.type, offsetDays));
	        var tanksStatus = TankStore.getAvailabilityTanks(startDate, endDate, tank.type, order.id, layout);
	        var tanksAvailables = _.filter(tanksStatus, function (tank) {
	            return tank.isAvailable && +tank.volume >= +(order.volume || 0);
	        });
	
	        if (_.get(tanksAvailables, 'length', 0) === 0) {
	            // enter here which means that not found tank available so we need to stop batching movement process
	            return null;
	        }
	
	        for (var _iterator6 = tanksAvailables, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
	            var _ref6;
	
	            if (_isArray6) {
	                if (_i6 >= _iterator6.length) break;
	                _ref6 = _iterator6[_i6++];
	            } else {
	                _i6 = _iterator6.next();
	                if (_i6.done) break;
	                _ref6 = _i6.value;
	            }
	
	            var _tank = _ref6;
	
	            var positionNeedCheck = {
	                h: newPosition.h, // use the same
	                x: _.get(_tank, 'column'), // use the same
	                y: newPosition.y, // re-located tank
	                i: newPosition.i, // use the same
	                batchNumber: _.get(order, 'batchNumber'), // use the same
	                w: newPosition.w,
	                static: newPosition.static,
	                maxW: newPosition.maxW,
	                minW: newPosition.minW
	            };
	
	            // tankName field to avoid conditional between tank types
	            var tankNameField = _.get(ContentUtils.getTankTypeConfiguration(_tank.type), 'orderTankName');
	            // update tank which new tank available
	            order[tankNameField] = _tank;
	            //order = this.updateDates(order, offsetDays);
	            // update serialized order from new position available
	
	            return positionNeedCheck;
	        }
	        // if we are here, means don't have tank available to given position, so we need to stop batching movement process
	        return null;
	    },
	    _updateLayoutWithPosition: function _updateLayoutWithPosition(layout, newPosition, oldId) {
	        var targetId = oldId || newPosition.i;
	        newPosition.isRelocated = true;
	        layout = _.filter(layout, function (position) {
	            return position.i !== targetId;
	        });
	        layout.push(newPosition);
	        return layout;
	    },
	    _updatePositionPerformed: function _updatePositionPerformed() {
	        var positionPerformedIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var positionsPerformed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	        var newPosition = arguments[2];
	        var oldPosition = arguments[3];
	
	        // add to list of order ids already performed
	        newPosition.isRelocated = true;
	
	        positionPerformedIds.push(newPosition.i);
	
	        positionsPerformed.push({
	            oldPosition: oldPosition,
	            newPosition: newPosition
	        });
	    },
	    _updateOrder: function _updateOrder(newPosition, offsetY) {
	
	        if (!newPosition) {
	            return null;
	        }
	
	        // update the new position
	        var order = this.getSafeOrder(_.get(newPosition, 'i'));
	
	        // update dates
	        order = OrderUtils.updateDates(order, offsetY);
	
	        // we don't need to update icon task because, will be changed in the next steps
	
	        DashboardServiceCache.updateOrder(order);
	
	        return newPosition;
	    },
	    _recalculateOrdersWithNewVerticalPosition: function _recalculateOrdersWithNewVerticalPosition(oldPosition, newPosition, offsetY) {
	        var result = [],
	            isPositionTarget = void 0;
	
	        if (DashboardServiceCache.getTankByColumn(oldPosition.x).type !== DashboardServiceCache.getTankByColumn(newPosition.x).type) {
	            Notification.show(t('dashboard_notification_order_can_not_moved_differen_type_tank'));
	            return result;
	        }
	
	        // prepare both type of search.
	        var batchNumber = _.get(newPosition, 'batchNumber');
	        var orderId = _.get(newPosition, 'i');
	
	        if (OrderUtils.haveSomeProductConfirmedFromOrderId(orderId)) {
	            Notification.show(t('notification_confirmed_orders_cannot_moved'));
	            return result;
	        }
	
	        if (OrderUtils.haveSomeProductConfirmedFromButchNumber(batchNumber)) {
	            Notification.show(t('notification_confirmed_orders_cannot_moved_check_orders_with_same_batch_number'));
	            return result;
	        }
	
	        // by default search by batchNumber, if are undefined, will search by orderId
	        if (!batchNumber) {
	            isPositionTarget = function isPositionTarget(layoutPosition) {
	                return _.get(layoutPosition, 'i') === orderId;
	            };
	        } else {
	            isPositionTarget = function isPositionTarget(layoutPosition) {
	                return _.get(layoutPosition, 'batchNumber') === batchNumber;
	            };
	        }
	
	        var stickyOrdersWithoutOldPosition = _.filter(DashboardLayoutStore.getLayout(), function (position) {
	            // We need to filter both by ID (only in case of combined order), because then one of them we calculate as new position and the other will calculate
	            // from the first one. If we calculate each position (means not filter both), we could have bugs like re-process the same position twice and will
	            // produce several bugs when re-calculate the position again.
	            return isPositionTarget(position) && ContentUtils.cleanId(position.i) !== ContentUtils.cleanId(oldPosition.i);
	        }) || [];
	
	        if (_.get(stickyOrdersWithoutOldPosition, 'length') > 0) {
	            // Enter here means that found a sticky orders, so we need to recalculate first their availability and then process with the new position.
	            return this._changeOrderFromNewPositionWithStickyOrder(newPosition, offsetY);
	        } else {
	            // Enter here means that don't have sticky order, so is just normal movement (eg: an combined or single movement order).
	            return this._changeOrderFromNewPosition(oldPosition, newPosition);
	        }
	    },
	    _isSamePositionOutOfRange: function _isSamePositionOutOfRange(stickyPositionToUpdate) {
	        return _.some(stickyPositionToUpdate, function (position) {
	            return ChronologycStore.isPositionOutOfRange(position);
	        });
	    },
	
	
	    /**
	     * Validate if the column that try to take is compatible with the type of tank that came from.
	     * @param {Object} position that will be validated if is fit to the column that try to fill.
	     * @return {Boolean}
	     */
	    _isProperlyTypeOfTankDestination: function _isProperlyTypeOfTankDestination(position) {
	        var tankToValidate = _.find(DashboardServiceCache.getTanks(), function (tank) {
	            return tank.column === position.x;
	        });
	
	        if (tankToValidate) {
	            switch (tankToValidate.type) {
	                case Constants.TYPE_TANK_FERMENTER:
	                    return !ContentUtils.isBH(position.i) && !ContentUtils.isBT(position.i);
	                case Constants.TYPE_TANK_BRITE_TANK:
	                    return ContentUtils.isBT(position.i);
	                case Constants.TYPE_TANK_BREW_HOUSE:
	                    return ContentUtils.isBH(position.i);
	            }
	        } else {
	            Notification.show(t('notification_column_of_the_new_position') + position.x + t('notification_do_not_exist'), 'error');
	            return false;
	        }
	    },
	    _changeBatchPosition: function _changeBatchPosition(oldPosition, newPosition) {
	        var order = this.getSafeOrder(_.get(newPosition, 'i')),
	            daysBeetweenBrewingAndFermenting = void 0;
	
	        if (OrderUtils.haveSomeProductConfirmedByPosition(oldPosition)) {
	            Notification.show(t('notification_confirmed_orders_cannot_moved'));
	            return order;
	        }
	
	        if (DashboardLayoutStore.isEmpty(newPosition)) {
	            var brewDate = void 0;
	
	            if (order.isSingle) {
	                brewDate = _.get(order, 'fromDate');
	                daysBeetweenBrewingAndFermenting = DateUtils.getDaysBetween(order.fromDate, order.toDate);
	            } else {
	                brewDate = _.get(order, 'brewDate');
	                daysBeetweenBrewingAndFermenting = DateUtils.getDaysBetween(brewDate, order.filtrationDate);
	            }
	
	            var newBrewDate = _.get(ChronologycStore.getDateFromPositionY(newPosition.y), 'date');
	            var daysOffset = DateUtils.getDaysBetween(newBrewDate, brewDate);
	
	            if (daysOffset < -Math.abs(daysBeetweenBrewingAndFermenting) || daysOffset > 1) {
	                Notification.show(t('notification_all_brewhouse_must_be_completed_within_fermenting_period'));
	                return order;
	            }
	
	            if (daysOffset < -2) {
	                Notification.show(t('notification_warning_late_wort_addition'), 'warning');
	            }
	
	            var turn = DashboardServiceCache.getTankByColumn(newPosition.x);
	            var orderBatchs = _.get(order, 'batchs', []);
	            var oldBatch = _.find(orderBatchs, function (batch) {
	                return batch.date === _.get(ChronologycStore.getDateFromPositionY(oldPosition.y), 'date') && _.get(batch, 'turn.column') === oldPosition.x;
	            });
	
	            if (!oldBatch) {
	                // do nothing because this method was called wrong.
	                return order;
	            }
	
	            // create new batch
	            var batchUpdated = _.cloneDeep(oldBatch);
	            batchUpdated.turn = turn;
	            batchUpdated.turnId = _.get(turn, 'id');
	            batchUpdated.date = newBrewDate;
	            batchUpdated.position = newPosition;
	
	            var batchs = _.filter(orderBatchs, function (batch) {
	                return !(_.get(batch, 'turn.column') === _.get(oldBatch, 'turn.column') && _.get(batch, 'date') === _.get(oldBatch, 'date'));
	            });
	
	            // update batch changed
	            batchs.push(batchUpdated);
	
	            // Ask if at least one batch exist in brew day or one day before to brew day
	            if (!BrewhouseStore.isBrewdateAvailable(batchs, brewDate)) {
	                // enter here means that don't exist batch for brewDate, so could not possible to change the order
	                Notification.show(t('notification_brewhouse_must_have_at_least_one_brewdate'));
	                return order;
	            }
	
	            // update batchs of the order
	            order.batchs = batchs;
	
	            // save change
	            if (order.isSingle) {
	                this.changeSingleOrderWithoutCheckBrewingSection(order);
	            } else {
	                this._changeOrderWithoutCheckBrewingSection(order);
	            }
	        } else {
	            Notification.show(t('notification_brewhouse_at_full_capacity_on_selected_date'));
	            return order;
	        }
	    },
	    haveSomeConfirmedProductAtTheEndOfTheOrderBySectionForCombinedOrder: function haveSomeConfirmedProductAtTheEndOfTheOrderBySectionForCombinedOrder(order, sectionType) {
	        if (Constants.FERMENTING_SECTION_NAME === sectionType) {
	
	            var fermenterProducts = OrderUtils.getAllFermentingProductsFromOrder(order);
	            var fermenterDateProducts = _.filter(fermenterProducts, function (product) {
	                return DateUtils.isEqual(product.endDate, order.filtrationDate);
	            });
	            return _.some(fermenterDateProducts, function (product) {
	                return product.isConfirmed;
	            });
	        } else if (Constants.PACKAGING_SECTION_NAME === sectionType) {
	
	            var packagingProducts = OrderUtils.getAllPackagingProductsFromOrder(order);
	            var packagingDateProducts = _.filter(packagingProducts, function (product) {
	                return DateUtils.isEqual(product.endDate, order.orderDate);
	            });
	            return _.some(packagingDateProducts, function (product) {
	                return product.isConfirmed;
	            });
	        } else {
	
	            return false;
	        }
	    },
	    haveSomeConfirmedProductAtTheEndOfTheOrderForSingleOrder: function haveSomeConfirmedProductAtTheEndOfTheOrderForSingleOrder(order) {
	        var products = OrderUtils.getAllProductsFromOrder(order);
	        var productsDate = _.filter(products, function (product) {
	            return DateUtils.isEqual(product.endDate, order.toDate);
	        });
	        return _.some(productsDate, function (product) {
	            return product.isConfirmed;
	        });
	    },
	    isResizeAllowed: function isResizeAllowed(order, positionsInfo) {
	        var start = positionsInfo.start,
	            stop = positionsInfo.stop;
	
	
	        if (!start || !stop) {
	            return false;
	        }
	
	        var bottomOldPosition = start.y + start.h;
	        var bottomNewPosition = stop.y + stop.h;
	        // const positionSection = ContentUtils.isBT(stop.i) ? Constants.PACKAGING_SECTION_NAME : Constants.FERMENTING_SECTION_NAME;
	
	        var oldDate = _.get(ChronologycStore.getDateFromPositionY(bottomOldPosition - 1), 'date');
	        var newDate = _.get(ChronologycStore.getDateFromPositionY(bottomNewPosition - 1), 'date');
	
	        var from = void 0,
	            to = void 0,
	            isResizeDirectionTop = void 0;
	        if (DateUtils.isBefore(oldDate, newDate)) {
	            isResizeDirectionTop = false;
	            from = oldDate;
	            to = newDate;
	        } else {
	            isResizeDirectionTop = true;
	            from = newDate;
	            to = oldDate;
	        }
	
	        if (this.haveSomeConfirmedProductOutsideOfOrderAfterResizing(order, to, from, isResizeDirectionTop)) {
	            return false;
	        }
	
	        return true;
	    },
	    haveSomeConfirmedProductOutsideOfOrderAfterResizing: function haveSomeConfirmedProductOutsideOfOrderAfterResizing(order, previous, next, isResizeDirectionTop) {
	        var isNotResized = previous === next;
	        if (!isResizeDirectionTop || isNotResized) {
	            return false;
	        }
	        var previousDate = DateUtils.toDateText(previous);
	        var nextDate = DateUtils.toDateText(next);
	        var products = OrderUtils.getAllProductsFromOrder(order);
	        if (ContentUtils.isNotEmptyArray(products)) {
	            var filteredProducts = _.filter(products, function (product) {
	                var end = _.get(product, 'endDate');
	                var productDate = DateUtils.toDateText(end);
	                return DateUtils.isBeforeOrEquals(productDate, previousDate) && DateUtils.isAfter(productDate, nextDate);
	            });
	            return _.some(filteredProducts, function (product) {
	                return _.get(product, 'isConfirmed');
	            });
	        }
	        return false;
	    },
	    existSomeProductConfirmed: function existSomeProductConfirmed(order, oldDate, newDate) {
	        var isResizeDirectionTop = void 0;
	        if (DateUtils.isBefore(oldDate, newDate)) {
	            isResizeDirectionTop = false;
	        } else {
	            isResizeDirectionTop = true;
	        }
	        return this.haveSomeConfirmedProductIntoCurrentOrNextDate(order, oldDate, newDate, isResizeDirectionTop);
	    },
	    haveSomeConfirmedProductIntoCurrentOrNextDate: function haveSomeConfirmedProductIntoCurrentOrNextDate(order, previous, next, isResizeDirectionTop) {
	        var isNotResized = previous === next;
	        if (!isResizeDirectionTop || isNotResized) {
	            return false;
	        }
	        var previousDate = DateUtils.toDateText(previous);
	        var nextDate = DateUtils.toDateText(next);
	        var products = OrderUtils.getAllProductsFromOrder(order);
	        if (ContentUtils.isNotEmptyArray(products)) {
	            var filteredProducts = _.filter(products, function (product) {
	                return _.get(product, 'endDate') === previousDate || _.get(product, 'endDate') === nextDate;
	            });
	            return _.some(filteredProducts, function (product) {
	                return _.get(product, 'isConfirmed');
	            });
	        }
	        return false;
	    },
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	    markOrderListener: function markOrderListener(call) {
	        if (call) {
	            this._markOrder = call;
	        }
	    },
	    markOrder: function markOrder(orderId) {
	        if (this._markOrder) {
	            this._markOrder(orderId);
	        }
	    }
	});
	
	module.exports = OrderStore;

/***/ },
/* 73 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  DOWN: 40,
	  ESC: 27,
	  ENTER: 13,
	  LEFT: 37,
	  RIGHT: 39,
	  SPACE: 32,
	  TAB: 9,
	  UP: 38
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactElement = __webpack_require__(38);
	var ReactElementValidator = __webpack_require__(174);
	var ReactEmptyComponent = __webpack_require__(220);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactMarkupChecksum = __webpack_require__(670);
	var ReactPerf = __webpack_require__(103);
	var ReactReconciler = __webpack_require__(150);
	var ReactUpdateQueue = __webpack_require__(385);
	var ReactUpdates = __webpack_require__(70);
	
	var emptyObject = __webpack_require__(176);
	var containsNode = __webpack_require__(676);
	var getReactRootElementInContainer = __webpack_require__(1294);
	var instantiateReactComponent = __webpack_require__(392);
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(394);
	var shouldUpdateReactComponent = __webpack_require__(395);
	var warning = __webpack_require__(32);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          !isValid(cached, id),
	          'ReactMount: Two valid but unequal nodes with the same `%s`: %s',
	          ATTR_NAME, id
	        ) : invariant(!isValid(cached, id)));
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponent.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      internalGetID(node) === id,
	      'ReactMount: Unexpected modification of `%s`',
	      ATTR_NAME
	    ) : invariant(internalGetID(node) === id));
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(
	    targetID,
	    findDeepestCachedAncestorImpl
	  );
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup) {
	  var markup = ReactReconciler.mountComponent(
	    componentInstance, rootID, transaction, emptyObject
	  );
	  componentInstance._isTopLevel = true;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    shouldReuseMarkup) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  transaction.perform(
	    mountComponentIntoNode,
	    null,
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup
	  );
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function(container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function(
	      prevComponent,
	      nextElement,
	      container,
	      callback) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    ReactMount.scrollMonitor(container, function() {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] =
	        getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function(nextComponent, container) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      '_registerComponent(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function(
	    nextElement,
	    container,
	    shouldReuseMarkup
	  ) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      ReactCurrentOwner.current == null,
	      '_renderNewRootComponent(): Render methods should be a pure function ' +
	      'of props and state; triggering nested component updates from ' +
	      'render is not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(
	      componentInstance,
	      container
	    );
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(
	      batchedMountComponentIntoNode,
	      componentInstance,
	      reactRootID,
	      container,
	      shouldReuseMarkup
	    );
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] =
	        getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function(nextElement, container, callback) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ReactElement.isValidElement(nextElement),
	      'React.render(): Invalid component element.%s',
	      (
	        typeof nextElement === 'string' ?
	          ' Instead of passing an element string, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        typeof nextElement === 'function' ?
	          ' Instead of passing a component class, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        // Check if it quacks like an element
	        nextElement != null && nextElement.props !== undefined ?
	          ' This may be caused by unintentionally loading two independent ' +
	          'copies of React.' :
	          ''
	      )
	    ) : invariant(ReactElement.isValidElement(nextElement)));
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevElement = prevComponent._currentElement;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        return ReactMount._updateRootComponent(
	          prevComponent,
	          nextElement,
	          container,
	          callback
	        ).getPublicInstance();
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup =
	      reactRootElement && ReactMount.isRenderedByReact(reactRootElement);
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (ReactMount.isRenderedByReact(rootElementSibling)) {
	            ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	              false,
	              'render(): Target node has markup rendered by React, but there ' +
	              'are unrelated nodes as well. This is most commonly caused by ' +
	              'white-space inserted around server-rendered markup.'
	            ) : null);
	            break;
	          }
	
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;
	
	    var component = ReactMount._renderNewRootComponent(
	      nextElement,
	      container,
	      shouldReuseMarkup
	    ).getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into the supplied `container`.
	   *
	   * @param {function} constructor React component constructor.
	   * @param {?object} props Initial props of the component instance.
	   * @param {DOMElement} container DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  constructAndRenderComponent: function(constructor, props, container) {
	    var element = ReactElement.createElement(constructor, props);
	    return ReactMount.render(element, container);
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into a container node identified by supplied `id`.
	   *
	   * @param {function} componentConstructor React component constructor
	   * @param {?object} props Initial props of the component instance.
	   * @param {string} id ID of the DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in the container node.
	   */
	  constructAndRenderComponentByID: function(constructor, props, id) {
	    var domNode = document.getElementById(id);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      domNode,
	      'Tried to get element with id of "%s" but it is not present on the page.',
	      id
	    ) : invariant(domNode));
	    return ReactMount.constructAndRenderComponent(constructor, props, domNode);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function(container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      ReactCurrentOwner.current == null,
	      'unmountComponentAtNode(): Render methods should be a pure function of ' +
	      'props and state; triggering nested component updates from render is ' +
	      'not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'unmountComponentAtNode(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      return false;
	    }
	    ReactMount.unmountComponentFromNode(component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Unmounts a component and removes it from the DOM.
	   *
	   * @param {ReactComponent} instance React component instance.
	   * @param {DOMElement} container DOM element to unmount from.
	   * @final
	   * @internal
	   * @see {ReactMount.unmountComponentAtNode}
	   */
	  unmountComponentFromNode: function(instance, container) {
	    ReactReconciler.unmountComponent(instance);
	
	    if (container.nodeType === DOC_NODE_TYPE) {
	      container = container.documentElement;
	    }
	
	    // http://jsperf.com/emptying-a-node
	    while (container.lastChild) {
	      container.removeChild(container.lastChild);
	    }
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function(id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          // Call internalGetID here because getID calls isValid which calls
	          // findReactContainerForID (this function).
	          internalGetID(rootElement) === reactRootID,
	          'ReactMount: Root element ID differed from reactRootID.'
	        ) : invariant(// Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID));
	
	        var containerChild = container.firstChild;
	        if (containerChild &&
	            reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	            false,
	            'ReactMount: Root element has been removed from its original ' +
	            'container. New container:', rootElement.parentNode
	          ) : null);
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function(id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * True if the supplied `node` is rendered by React.
	   *
	   * @param {*} node DOM Element to check.
	   * @return {boolean} True if the DOM Element appears to be rendered by React.
	   * @internal
	   */
	  isRenderedByReact: function(node) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      return false;
	    }
	    var id = ReactMount.getID(node);
	    return id ? id.charAt(0) === SEPARATOR : false;
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function(node) {
	    var current = node;
	    while (current && current.parentNode !== current) {
	      if (ReactMount.isRenderedByReact(current)) {
	        return current;
	      }
	      current = current.parentNode;
	    }
	    return null;
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function(ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      false,
	      'findComponentRoot(..., %s): Unable to find element. This probably ' +
	      'means the DOM was unexpectedly mutated (e.g., by the browser), ' +
	      'usually due to forgetting a <tbody> when using tables, nesting tags ' +
	      'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' +
	      'parent. ' +
	      'Try inspecting the child nodes of the element with React ID `%s`.',
	      targetID,
	      ReactMount.getID(ancestorNode)
	    ) : invariant(false));
	  },
	
	  _mountImageIntoNode: function(markup, container, shouldReuseMarkup) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'mountComponentIntoNode(...): Target container is not valid.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	        );
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME,
	          checksum
	        );
	
	        var diffIndex = firstDifferenceIndex(markup, rootMarkup);
	        var difference = ' (client) ' +
	          markup.substring(diffIndex - 20, diffIndex + 20) +
	          '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          container.nodeType !== DOC_NODE_TYPE,
	          'You\'re trying to render a component to the document using ' +
	          'server rendering but the checksum was invalid. This usually ' +
	          'means you rendered a different component type or props on ' +
	          'the client from the one on the server, or your render() ' +
	          'methods are impure. React cannot handle this case due to ' +
	          'cross-browser quirks by rendering at the document root. You ' +
	          'should look for environment dependent code in your components ' +
	          'and ensure the props are the same client and server side:\n%s',
	          difference
	        ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	        if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	            false,
	            'React attempted to reuse markup in a container but the ' +
	            'checksum was invalid. This generally means that you are ' +
	            'using server rendering and the markup generated on the ' +
	            'server was not what the client was expecting. React injected ' +
	            'new markup to compensate which works but you have lost many ' +
	            'of the benefits of server rendering. Instead, figure out ' +
	            'why the markup being generated is different on the client ' +
	            'or server:\n%s',
	            difference
	          ) : null);
	        }
	      }
	    }
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      container.nodeType !== DOC_NODE_TYPE,
	      'You\'re trying to render a component to the document but ' +
	        'you didn\'t use server rendering. We can\'t do this ' +
	        'without using server rendering due to cross-browser quirks. ' +
	        'See React.renderToString() for server rendering.'
	    ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	    setInnerHTML(container, markup);
	  },
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(109).EventEmitter,
	    assign = __webpack_require__(74),
	    _require = __webpack_require__(355),
	    round = _require.round,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    filter = _require2.filter,
	    ContentUtils = __webpack_require__(7),
	    SchedulerAppDispatcher = __webpack_require__(42),
	    getBoundingClientRect = __webpack_require__(234),
	    DATE_FORMAT = __webpack_require__(2).DATE_FORMAT,
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    moment = __webpack_require__(3),
	    DateUtils = __webpack_require__(22),
	    ChronologycServiceCache = __webpack_require__(107),
	    ChronologycServiceImpl = __webpack_require__(742),
	    PositionUtil = __webpack_require__(59),
	    CHANGE_EVENT = 'emit',
	    currentRangeOfDate = [],
	    currentFrom,
	    currentTo,
	    ChronologycStore;
	
	
	ChronologycStore = assign({}, EventEmitter.prototype, {
	
	    _isNoteSaving: false,
	    _isWritingNote: false,
	
	    setIsNoteSavingTrue: function setIsNoteSavingTrue() {
	        this._isNoteSaving = true;
	    },
	    setIsNoteSavingFalse: function setIsNoteSavingFalse() {
	        this._isNoteSaving = false;
	    },
	    isSavingNote: function isSavingNote() {
	        return this._isNoteSaving;
	    },
	    setIsWritingTrue: function setIsWritingTrue() {
	        this._isWritingNote = true;
	    },
	    setIsWritingFalse: function setIsWritingFalse() {
	        this._isWritingNote = false;
	    },
	    isWritingNote: function isWritingNote() {
	        return this._isWritingNote;
	    },
	
	
	    setCurrentRange: function setCurrentRange(from, to) {
	        currentFrom = from;
	        currentTo = to;
	        currentRangeOfDate = this.getRangeOfDate(from, to);
	    },
	
	    fetchBrewingNotes: function fetchBrewingNotes(success) {
	        ChronologycServiceImpl.fetchBrewingNotes(function () {
	            ChronologycServiceCache.fillBrewingNoteCache(JSON.parse(this.responseText));
	            if (success) {
	                success();
	            }
	        });
	    },
	
	    fetchPackagingNotes: function fetchPackagingNotes(success) {
	        ChronologycServiceImpl.fetchPackagingNotes(function () {
	            ChronologycServiceCache.fillPackagingNoteCache(JSON.parse(this.responseText));
	            if (success) {
	                success();
	            }
	        });
	    },
	
	    emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	    },
	
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	
	    getRangeOfDate: function getRangeOfDate(from, to, typeBar) {
	        var days = [],
	            formatDate = null,
	            i = 0,
	            messages = void 0,
	            messageDay = void 0,
	            dayCompare = void 0;
	
	        if (moment(from, DATE_FORMAT).isAfter(moment(to, DATE_FORMAT))) {
	            //console.log('The date ' + from + ' cant be after to' + to);
	            return days;
	        }
	
	        messages = typeBar === 'packaging-bar' ? ChronologycServiceCache.getPackagingNotes() : ChronologycServiceCache.getBrewingNotes();
	
	        if (!messages) {
	            messages = [];
	        }
	
	        for (i = 0; moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT) !== to; i++) {
	            dayCompare = moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT);
	            messageDay = find(messages, function (msg) {
	                return get(msg, 'date') === dayCompare;
	            });
	            formatDate = getFormatDate(from, i, messageDay);
	            days.push(formatDate);
	        }
	        // add last the last day
	        dayCompare = moment(from, DATE_FORMAT).add(i, 'days').format(DATE_FORMAT);
	        messageDay = find(messages, function (msg) {
	            return get(msg, 'date') === dayCompare;
	        });
	        formatDate = getFormatDate(from, i, messageDay);
	
	        days.push(formatDate);
	        return days;
	    },
	
	    getCurrentRangeOfDate: function getCurrentRangeOfDate() {
	        return currentRangeOfDate;
	    },
	
	    getCurrentFrom: function getCurrentFrom() {
	        return currentFrom;
	    },
	
	    getCurrentTo: function getCurrentTo() {
	        return currentTo;
	    },
	
	    getFirstDate: function getFirstDate(newPosition) {
	        if (!newPosition) {
	            return;
	        }
	        var filterDate = filter(currentRangeOfDate, function (day) {
	            return day.index === newPosition.y;
	        });
	
	        if (filterDate && filterDate.length > 0) {
	            return filterDate[0];
	        } else {
	            var fromDate = this.getCurrentFrom();
	            return { date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), newPosition.y) };
	        }
	    },
	
	    getLastDate: function getLastDate(newPosition) {
	        if (!newPosition) {
	            return;
	        }
	        var filterDate = filter(currentRangeOfDate, function (day) {
	            return day.index === newPosition.y + (newPosition.h - 1);
	        });
	
	        if (filterDate && filterDate.length > 0) {
	            return filterDate[0];
	        } else {
	            var fromDate = this.getCurrentFrom();
	            return { date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), newPosition.y) };
	        }
	    },
	
	    /**
	     * Retrieve the Date of Event.clientY position.
	     * @param {Number} clientY
	     * @return {Date}
	     */
	    getDateFromClientY: function getDateFromClientY(clientY) {
	        // the number 5, is because 0, have problem in Chrome Win.
	        var elY = PositionUtil.elementFromPoint(5, clientY);
	        var chronologycRowWanted = void 0,
	            dateRow = void 0;
	
	        if (elY && elY.hasAttribute && elY.hasAttribute('data-date')) {
	            dateRow = DateUtils.toDate(elY.getAttribute('data-date'));
	        } else {
	            chronologycRowWanted = ContentUtils.getComponentByAttribute(elY, 'data-date');
	            if (chronologycRowWanted && chronologycRowWanted.getAttribute) {
	                dateRow = chronologycRowWanted.getAttribute('data-date');
	                dateRow = DateUtils.toDate(dateRow);
	            }
	        }
	
	        return dateRow;
	    },
	    _getChronologycElByClientY: function _getChronologycElByClientY(elY) {
	        var chronologycBarEl = ContentUtils.getComponentByClassName(elY, 'chronologyc-bar');
	        for (var _iterator = chronologycBarEl.childNodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var chronologycRow = _ref;
	
	            if (round(getBoundingClientRect(chronologycRow).top) === round(getBoundingClientRect(elY).top)) {
	                return chronologycRow;
	            }
	        }
	    },
	
	
	    getDateFromPositionY: function getDateFromPositionY(positionY) {
	        if (positionY === undefined || positionY === null) {
	            return;
	        }
	        var dateTarget;
	
	        var result = filter(currentRangeOfDate, function (date) {
	            return date.index === positionY;
	        });
	
	        if (result && result.length > 0) {
	            dateTarget = result[0];
	        } else {
	            var fromDate = this.getCurrentFrom();
	            dateTarget = { date: DateUtils.addDaysTextBasicFormat(DateUtils.toDate(fromDate), positionY) };
	        }
	
	        return dateTarget;
	    },
	
	    getYFromDate: function getYFromDate(dateTarget) {
	        return DateUtils.getDaysBetween(this.getCurrentFrom(), dateTarget);
	    },
	
	    isPositionOutOfRange: function isPositionOutOfRange(position) {
	        if (!position) {
	            return true;
	        }
	
	        var from = this.getDateFromPositionY(position.y).date;
	        var to = this.getDateFromPositionY(position.h + position.y - 1).date;
	
	        if (DateUtils.isBefore(from, this.getCurrentFrom()) || DateUtils.isAfter(to, this.getCurrentTo())) {
	            return true;
	        } else {
	            return false;
	        }
	    },
	
	
	    /**
	     * Retrieve the H between to dates.
	     * @argument {String} firstDate is the origin date
	     * @argument {String} lastDate is the last date
	     * @return {Number}
	     */
	    getHFromDate: function getHFromDate(firstDate, lastDate) {
	        return DateUtils.getDaysBetween(firstDate, lastDate) + 1; // The plus `one` is because ReactGridLayout, the minimal box Height is 1. Represent minimal height row position.
	    }
	
	});
	
	function getFormatDate(date, dateNumber, messageDay) {
	    return {
	        dateName: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('dd').substring(0, 1), // The format of chronologyc bar days name
	        dateNumber: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('D'),
	        dateNumberAndMonth: moment(date, DATE_FORMAT).add(dateNumber, 'days').format('MM-DD'),
	        date: moment(date, DATE_FORMAT).add(dateNumber, 'days').format(DATE_FORMAT),
	        time: moment(date, DATE_FORMAT).add(dateNumber, 'days').format() + dateNumber,
	        index: dateNumber,
	        message: messageDay
	    };
	}
	
	ChronologycStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	
	    switch (action.type) {
	        case ActionTypes.OPEN_DAY_NOTES:
	            ChronologycStore.emitChange();
	            break;
	
	        case ActionTypes.CLOSE_DAY_NOTES:
	            ChronologycStore.emitChange();
	            break;
	
	        case ActionTypes.NOTE_ADDED:
	            ChronologycStore.emitChange();
	            ChronologycStore.setIsNoteSavingFalse();
	            break;
	
	        case ActionTypes.NOTE_BREWING_OPERATION_NEW:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_BREWING_OPERATION_CHANGE:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_BREWING_OPERATION_DELETE:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_PACKAGING_OPERATION_NEW:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_PACKAGING_OPERATION_CHANGE:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_PACKAGING_OPERATION_DELETE:
	            ChronologycStore.setIsNoteSavingTrue();
	            break;
	
	        case ActionTypes.NOTE_CHANGED:
	            ChronologycStore.setIsNoteSavingFalse();
	            ChronologycStore.emitChange();
	            break;
	
	        case ActionTypes.NOTE_REMOVED:
	            ChronologycStore.setIsNoteSavingFalse();
	            ChronologycStore.emitChange();
	            break;
	
	        case ActionTypes.BREWING_NOTE_NEED_FETCH:
	            ChronologycStore.fetchBrewingNotes(function () {
	                ChronologycStore.emitChange();
	            });
	            break;
	
	        case ActionTypes.PACKAGING_NOTE_NEED_FETCH:
	            ChronologycStore.fetchPackagingNotes(function () {
	                ChronologycStore.emitChange();
	            });
	            break;
	
	        default:
	    }
	});
	
	module.exports = ChronologycStore;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(8),
	    map = _require.map,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    _require3 = __webpack_require__(5),
	    merge = _require3.merge,
	    get = __webpack_require__(5).get,
	    _require4 = __webpack_require__(48),
	    union = _require4.union;
	
	var ComponentUtils = {
	
	    /**
	     * Given items data text, retrieve the custom structure of dropdown menu to use given data.
	     */
	    toMenuItemsText: function toMenuItemsText(items, nonSelectText, locatorPrefix) {
	        var menuItem = [{ payload: 0, text: nonSelectText }];
	        return union(menuItem, map(items, function (item, index) {
	            return {
	                payload: index + 1,
	                text: item,
	                itemModel: item, // to be consistence which `toMenuItems` method
	                index: index,
	                locatorId: locatorPrefix ? locatorPrefix + index : index
	            };
	        }));
	    },
	
	
	    /**
	     * Given items data object, retrieve the custom structure of dropdown menu to use given data..
	     */
	    toMenuItems: function toMenuItems(items) {
	        var textAttr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
	        var iconAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'icon';
	        var locatorPrefix = arguments[3];
	        var extraArguments = arguments[4];
	
	        return map(items, function (item, index) {
	            return merge({
	                payload: index + 1,
	                text: textAttr ? typeof item === 'string' ? item : get(item, textAttr) : item,
	                itemModel: item,
	                iconClassName: get(item, iconAttr, ''),
	                locatorId: locatorPrefix ? locatorPrefix + index : index
	            }, extraArguments);
	        });
	    },
	
	
	    /**
	     * Given items data object, retrieve the custom structure of dropdown menu to use given data..
	     */
	    toMenuItemsWithNonSelectedItem: function toMenuItemsWithNonSelectedItem(items) {
	        var nonSelectText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t('component_utils_selected_item');
	        var textAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
	
	        var nonSelectedItem = [{ payload: 0, text: nonSelectText }];
	        return union(nonSelectedItem, map(items, function (item, index) {
	            return {
	                payload: index + 1,
	                text: textAttr ? typeof item === 'string' ? item : get(item, textAttr || 'icon') : item,
	                itemModel: item
	            };
	        }));
	    }
	};
	
	module.exports = ComponentUtils;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument given to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'camelCase': __webpack_require__(911),
	  'capitalize': __webpack_require__(348),
	  'deburr': __webpack_require__(481),
	  'endsWith': __webpack_require__(938),
	  'escape': __webpack_require__(484),
	  'escapeRegExp': __webpack_require__(939),
	  'kebabCase': __webpack_require__(1000),
	  'lowerCase': __webpack_require__(1003),
	  'lowerFirst': __webpack_require__(1004),
	  'pad': __webpack_require__(1030),
	  'padEnd': __webpack_require__(1031),
	  'padStart': __webpack_require__(1032),
	  'parseInt': __webpack_require__(1033),
	  'repeat': __webpack_require__(500),
	  'replace': __webpack_require__(1049),
	  'snakeCase': __webpack_require__(1059),
	  'split': __webpack_require__(1070),
	  'startCase': __webpack_require__(1072),
	  'startsWith': __webpack_require__(1073),
	  'template': __webpack_require__(1081),
	  'templateSettings': __webpack_require__(503),
	  'toLower': __webpack_require__(1084),
	  'toUpper': __webpack_require__(1088),
	  'trim': __webpack_require__(1090),
	  'trimEnd': __webpack_require__(1091),
	  'trimStart': __webpack_require__(1092),
	  'truncate': __webpack_require__(1093),
	  'unescape': __webpack_require__(1095),
	  'upperCase': __webpack_require__(1103),
	  'upperFirst': __webpack_require__(510),
	  'words': __webpack_require__(512)
	};


/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	function makeEmptyFunction(arg) {
	  return function() {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function() { return this; };
	emptyFunction.thatReturnsArgument = function(arg) { return arg; };
	
	module.exports = emptyFunction;


/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without loosing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	
	module.exports = keyOf;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AppDispatcher = __webpack_require__(42),
	    EventEmitter = __webpack_require__(109).EventEmitter,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ContextMenuEl = __webpack_require__(152),
	    DashboardSpinnerEl = __webpack_require__(156),
	    Constants = __webpack_require__(2),
	    ActionTypes = Constants.ActionTypes,
	    assign = __webpack_require__(74),
	    Security = __webpack_require__(13).auth,
	    ChronologycServiceCache = __webpack_require__(107),
	    DashboardLayoutStore = __webpack_require__(108),
	    SchedulerAppDispatcher = __webpack_require__(42),
	    DashboardServiceCache = __webpack_require__(28),
	    DashboardServiceImpl = __webpack_require__(132),
	    DashboardCache = __webpack_require__(414),
	    ChronologycStore = __webpack_require__(76),
	    OrderUtils = __webpack_require__(49),
	    NumberUtils = __webpack_require__(23),
	    TankStore = __webpack_require__(97),
	    OrderStore = __webpack_require__(72),
	    SessionStore = __webpack_require__(11),
	    ContentUtils = __webpack_require__(7),
	    PositionUtils = __webpack_require__(59),
	    Notification = __webpack_require__(21),
	    DateUtils = __webpack_require__(22),
	    DashboardAction = __webpack_require__(65),
	    CustomDialog = __webpack_require__(26),
	    moment = __webpack_require__(3),
	    CHANGE_EVENT = 'change',
	    _ = __webpack_require__(40),
	    _require2 = __webpack_require__(2),
	    DATE_FORMAT = _require2.DATE_FORMAT;
	
	
	var DashboardStore = assign({}, EventEmitter.prototype, {
	
	    currentDate: moment(DATE_FORMAT),
	
	    /**
	     * Is the indicator about when is in progress the saving draft.
	     */
	    _isSavingDraft: false,
	
	    /**
	     * Is the indicator about when is already saved all draft operations.
	     */
	    _isSavedDraft: false,
	
	    /**
	     * Is the indicator about when is in progress the published draft.
	     */
	    _isPublishingDraft: false,
	
	    /**
	     * Is the indicator about when is already finish the publish.
	     */
	    _isPublishedDraft: false,
	
	    /**
	     * Indicate if has operation without publish.
	     */
	    _hasOperationWithoutPublish: false,
	
	    /**
	     * Force to render manually the Dashboard View from Store, this flag is here because we need to sync
	     * from several places outside of Dashboard view when the dashboard need to be re-rendered.
	     */
	    _forceRenderDashboard: true,
	
	    /**
	     * This flag indicate when are in-progress dragging or resizing operation.
	     */
	    _isDraggingOrResizing: false,
	
	    /**
	     * This flag indicate when is needed load order out of range because we it on arrow blue dashboard options.
	     */
	    _triggerArrow: false,
	
	    _isNeedCleanSelectedOrders: false,
	
	    _contextMenuTemporaryDashboardLayout: null,
	
	    _isInitializedLayoutDashboard: false,
	
	    resetInitializedLayoutDashboard: function resetInitializedLayoutDashboard() {
	        this._isInitializedLayoutDashboard = false;
	    },
	    isNeedCleanSelectedOrders: function isNeedCleanSelectedOrders() {
	        return this._isNeedCleanSelectedOrders;
	    },
	    setNeedCleanSelectedOrders: function setNeedCleanSelectedOrders(isNeeded) {
	        this._isNeedCleanSelectedOrders = isNeeded;
	    },
	    setInitializedLayoutDashboard: function setInitializedLayoutDashboard() {
	        this._isInitializedLayoutDashboard = true;
	    },
	    isInitializedLayoutDashboard: function isInitializedLayoutDashboard() {
	        return this._isInitializedLayoutDashboard;
	    },
	    getTemporaryContextMenuDashboardLayout: function getTemporaryContextMenuDashboardLayout() {
	        return this._contextMenuTemporaryDashboardLayout;
	    },
	    setTemporaryContextMenuDashboardLayout: function setTemporaryContextMenuDashboardLayout(layout) {
	        this._contextMenuTemporaryDashboardLayout = layout;
	    },
	    setIsCalculatingInventory: function setIsCalculatingInventory(isCalculatingInventoryEnabled) {
	        SessionStore.setIsCalculatingInventory(isCalculatingInventoryEnabled);
	    },
	    getIsCalculatingInventory: function getIsCalculatingInventory() {
	        return SessionStore.isCalculatingInventory();
	    },
	
	
	    /**
	     * Indicate when the dashboard content is fetching.
	     */
	    isFetchingContent: false,
	
	    formatAmountsTwoDigit: function formatAmountsTwoDigit(orders) {
	        return orders.map(function (order) {
	            OrderUtils.getAllProductsFromOrder(order).forEach(function (product) {
	                product.amount = NumberUtils.formatDecimal(product.amount, 2);
	                product.items = product.items && product.items.length ? product.items.map(function (item) {
	                    item.amount = NumberUtils.formatDecimal(item.amount, 2);
	                    return item;
	                }) : [];
	                product.volume = NumberUtils.formatDecimal(product.volume, 2);
	                product.lastDiscountedAmount = NumberUtils.formatDecimal(product.lastDiscountedAmount, 2);
	            });
	            return order;
	        });
	    },
	
	
	    /**
	     * Fetch all the content need to render the whole dashboard page.
	     * @param {Function} success
	     * @param {Function} failure
	     * @param failure
	     */
	    fetchDashboardContent: function fetchDashboardContent(from, to, applicant, success, failure) {
	        if (!this.isFetchingDashboardContent()) {
	            this.setIsFetchingDashboardContent(true);
	
	            this.resetInitializedLayoutDashboard();
	            var self = this;
	
	            var fetchDashboard = false;
	            var fetchInventoryItems = false;
	            var fetchInventoryProduct = false;
	
	            // fetch orders and draft from scope
	            DashboardServiceImpl.fetchNextDashboardContent(from, to, applicant, function () {
	                var _JSON$parse = JSON.parse(this.response),
	                    brewingNotes = _JSON$parse.brewingNotes,
	                    packagingNotes = _JSON$parse.packagingNotes,
	                    orders = _JSON$parse.orders,
	                    hasDraft = _JSON$parse.hasDraft,
	                    draftOrderAmount = _JSON$parse.draftOrderAmount,
	                    undoDraftOrderAmount = _JSON$parse.undoDraftOrderAmount;
	
	                // Indicate that has pending draft operation to publish
	
	
	                DashboardStore.setHasOperationWithoutPublish(hasDraft);
	
	                DashboardServiceImpl.fetchDashboardContent(function () {
	                    var response = ContentUtils.parse(this.responseText);
	
	                    if (response.applicantStatus === 'BLOCKED' || SessionStore.isTrialVersion() && !SessionStore.isTrialVersionActive()) {
	                        Security.logout();
	                        window.location = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/#/login?message=applicant_blocked';
	                        return;
	                    }
	                    var sortedOrders = _sortOrdersChronologically(orders);
	                    SessionStore.setCurrentLanguage(_.get(response, 'applicantConfigurationDetail.locale'));
	                    DashboardServiceCache.fillCache(response);
	                    DashboardServiceCache.setDraftOrderAmount(draftOrderAmount);
	                    DashboardServiceCache.setUndoDraftOrderAmount(undoDraftOrderAmount);
	                    DashboardServiceCache.fillCacheOrder(sortedOrders);
	                    ChronologycServiceCache.setBrewingNotes(brewingNotes);
	                    ChronologycServiceCache.setPackagingNotes(packagingNotes);
	
	                    if (success) {
	                        fetchDashboard = true;
	                        onFinishFetchingAll({
	                            onSuccess: success.bind(self),
	                            fetchDashboard: fetchDashboard,
	                            fetchInventoryItems: fetchInventoryItems,
	                            fetchInventoryProduct: fetchInventoryProduct
	                        });
	                    }
	                }, function () {
	                    if (failure) {
	                        self.setIsFetchingDashboardContent(false);
	                        failure();
	                    }
	                });
	
	                DashboardServiceImpl.fetchDashboardInventoryItemsContent(function () {
	                    var response = ContentUtils.parse(this.responseText);
	                    DashboardServiceCache.fillCacheInventoryItems(response);
	
	                    self.setIsFetchingDashboardContent(false);
	                    if (success) {
	                        fetchInventoryItems = true;
	                        onFinishFetchingAll({
	                            onSuccess: success.bind(self),
	                            fetchDashboard: fetchDashboard,
	                            fetchInventoryItems: fetchInventoryItems,
	                            fetchInventoryProduct: fetchInventoryProduct
	                        });
	                    }
	                }, function () {
	                    if (failure) {
	                        self.setIsFetchingDashboardContent(false);
	                        failure();
	                    }
	                });
	
	                DashboardServiceImpl.fetchDashboardInventoryProductsContent(function () {
	                    var response = ContentUtils.parse(this.responseText);
	                    DashboardServiceCache.fillCacheInventoryProducts(response);
	
	                    self.setIsFetchingDashboardContent(false);
	                    if (success) {
	                        fetchInventoryProduct = true;
	                        onFinishFetchingAll({
	                            onSuccess: success.bind(self),
	                            fetchDashboard: fetchDashboard,
	                            fetchInventoryItems: fetchInventoryItems,
	                            fetchInventoryProduct: fetchInventoryProduct
	                        });
	                    }
	                }, function () {
	                    if (failure) {
	                        self.setIsFetchingDashboardContent(false);
	                        failure();
	                    }
	                });
	            });
	        }
	    },
	    updateDashboardContent: function updateDashboardContent(onSuccess, onFailure) {
	        DashboardServiceImpl.fetchDashboardContent(function () {
	            var response = ContentUtils.parse(this.responseText);
	            if (response.applicantStatus === 'BLOCKED') {
	                Security.logout();
	                window.location = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/#/login?message=applicant_blocked';
	                return;
	            }
	            DashboardServiceCache.fillCache(response);
	            if (onSuccess) onSuccess();
	        }, function () {
	            if (onFailure) onFailure();
	        });
	    },
	    setIsFetchingDashboardContent: function setIsFetchingDashboardContent(isFetching) {
	        this.isFetchingContent = isFetching;
	    },
	    isFetchingDashboardContent: function isFetchingDashboardContent() {
	        return this.isFetchingContent;
	    },
	    fetchDashboardContentCurrentRange: function fetchDashboardContentCurrentRange() {
	        var self = this;
	        this.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), function () {
	            self.forceRenderDashboard();
	            self.emitChange();
	        });
	    },
	    markAsSavedOperations: function markAsSavedOperations(draft) {
	        var operations = _.get(draft, 'operations');
	
	        if (ContentUtils.isNotEmptyArray(operations)) {
	            var updatedOperations = _.map(operations, function (operation) {
	                operation.isSaved = true;
	                return operation;
	            });
	            draft = _.set(draft, 'operations', updatedOperations);
	        }
	
	        return draft;
	    },
	    fetchNextDashboardContent: function fetchNextDashboardContent(from, to, applicant, onSuccess, onFailure) {
	        DashboardServiceImpl.fetchNextDashboardContent(from, to, applicant, onSuccess, onFailure);
	    },
	    isNeedForceRenderDashboard: function isNeedForceRenderDashboard() {
	        return this._forceRenderDashboard;
	    },
	    forceRenderDashboard: function forceRenderDashboard() {
	        this._forceRenderDashboard = true;
	    },
	    disabledForceRenderDashboard: function disabledForceRenderDashboard() {
	        this._forceRenderDashboard = false;
	    },
	    setTriggerArrow: function setTriggerArrow() {
	        this._triggerArrow = true;
	    },
	    unsetTriggerArrow: function unsetTriggerArrow() {
	        this._triggerArrow = false;
	    },
	    isTriggerArrow: function isTriggerArrow() {
	        return this._triggerArrow;
	    },
	    isPublishingDraft: function isPublishingDraft() {
	        return this._isPublishingDraft;
	    },
	    setPublishingDraft: function setPublishingDraft() {
	        this._isPublishingDraft = true;
	    },
	    unsetPublishingDraft: function unsetPublishingDraft() {
	        this._isPublishingDraft = false;
	    },
	    isDraggingOrResizing: function isDraggingOrResizing() {
	        return this._isDraggingOrResizing;
	    },
	    setDraggingOrResizing: function setDraggingOrResizing() {
	        this._isDraggingOrResizing = true;
	    },
	    unsetDraggingOrResizing: function unsetDraggingOrResizing() {
	        this._isDraggingOrResizing = false;
	    },
	    isPublishedDraft: function isPublishedDraft() {
	        return this._isPublishedDraft;
	    },
	    setPublishedDraft: function setPublishedDraft() {
	        this._isPublishedDraft = true;
	    },
	    setHasPendingSavedDraftWithoutPublish: function setHasPendingSavedDraftWithoutPublish(hasPending) {
	        SessionStore.setHasPendingSavedDraftWithoutPublish(hasPending);
	    },
	    hasPendingSavedDraftWithoutPublish: function hasPendingSavedDraftWithoutPublish() {
	        return SessionStore.getHasPendingSavedDraftWithoutPublish() || DashboardServiceCache.getPendingOperations().length > 0;
	    },
	    hasOperationWithoutPublish: function hasOperationWithoutPublish() {
	        // ask first for flag because when initial fetching
	        // that flag is assigned by a flag from backend side.
	        return this._hasOperationWithoutPublish || DashboardServiceCache.getOperations().length > 0;
	    },
	    setHasOperationWithoutPublish: function setHasOperationWithoutPublish(hasOperation) {
	        this._hasOperationWithoutPublish = hasOperation;
	    },
	    unsetPublishedDraft: function unsetPublishedDraft() {
	        this._isPublishedDraft = false;
	    },
	    setIsSavingDraft: function setIsSavingDraft() {
	        this._isSavingDraft = true;
	    },
	    unsetIsSavingDraft: function unsetIsSavingDraft() {
	        this._isSavingDraft = false;
	    },
	    isSavingDraft: function isSavingDraft() {
	        return this._isSavingDraft;
	    },
	    setIsSavedDraft: function setIsSavedDraft() {
	        this._isSavedDraft = true;
	    },
	    unsetIsSavedDraft: function unsetIsSavedDraft() {
	        this._isSavedDraft = false;
	    },
	    isSavedDraft: function isSavedDraft() {
	        return this._isSavedDraft;
	    },
	
	
	    /**
	     * Publish the current draft against to the server in order to be available all the orders changes, such as new order,
	     * changes and deletes, for the rest of the user of the applicant. After that will be deleted the current draft and notify.
	     * And finally will be available a new version of dashboard, in order to get the last changes for the rest of the users.
	     */
	    publishDraft: function publishDraft() {
	        DashboardServiceImpl.publishDraft(function () {
	            DashboardAction.publishingSuccess();
	        }, function () {
	            DashboardAction.publishingFailure();
	        });
	    },
	    undoDraft: function undoDraft() {
	        DashboardServiceImpl.undoDraft(function () {
	            DashboardAction.undoDraftSuccess();
	        }, function () {
	            DashboardAction.undoDraftFailure();
	        });
	    },
	    redoDraft: function redoDraft() {
	        DashboardServiceImpl.redoDraft(function () {
	            DashboardAction.redoDraftSuccess();
	        }, function () {
	            DashboardAction.redoDraftFailure();
	        });
	    },
	    getTankFromClientX: function getTankFromClientX(clientX) {
	        var tanks = TankStore.getTanks();
	        var tankSelectedId = PositionUtils.getHeaderTankClickedId(clientX);
	        return _.find(tanks, function (tank) {
	            return String(tank.id) == tankSelectedId;
	        });
	    },
	    getTankFromColumnTankEl: function getTankFromColumnTankEl(columTank) {
	        var tanks = TankStore.getTanks();
	        var tankSelectedId = columTank.getAttribute('data-tank-id');
	        return _.find(tanks, function (tank) {
	            return String(tank.id) == tankSelectedId;
	        });
	    },
	    _getTankHeader: function _getTankHeader(clientX) {
	        var tryToSearch = 50;
	        var trying = -1;
	        var target = void 0;
	        var increase = 5;
	        var startingPoint = SessionStore.getHeaderHigh();
	
	        while (trying < tryToSearch) {
	            trying++;
	            var targetY = startingPoint + increase * trying;
	            //console.log('Trying to find a column at position Y: [' + targetY + ']');
	            target = PositionUtils.elementFromPoint(clientX, targetY);
	            if (target && (target.classList.contains('fixed-header') || target.classList.contains('fixed-header-tank-name'))) {
	                //console.log('Column founded at position Y: [' + targetY + ']');
	                return target;
	            }
	        }
	        return null;
	    },
	    emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	    },
	    isOutsideOfDashboard: function isOutsideOfDashboard(dashboardFrom, dashboardTo, orderToValidate) {
	        if (DateUtils.isBefore(orderToValidate.brewDate, dashboardFrom) || DateUtils.isAfter(orderToValidate.orderDate, dashboardTo)) {
	            return true;
	        }
	        return false;
	    },
	    isOutsideSingleOfDashboard: function isOutsideSingleOfDashboard(dashboardFrom, dashboardTo, orderToValidate) {
	        if (DateUtils.isBefore(orderToValidate.fromDate, dashboardFrom) || DateUtils.isAfter(orderToValidate.toDate, dashboardTo)) {
	            return true;
	        }
	        return false;
	    },
	    setLayoutWithoutHydrated: function setLayoutWithoutHydrated(layout) {
	        DashboardLayoutStore.setLayout(layout);
	    },
	    setLayout: function setLayout(layout) {
	        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChronologycStore.getCurrentFrom();
	        var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ChronologycStore.getCurrentTo();
	
	        DashboardLayoutStore.setLayout(OrderStore.hydrateOrdersOutOfRange(layout, from, to));
	    },
	    cleanLayout: function cleanLayout() {
	        DashboardLayoutStore.cleanLayout();
	    },
	    getLayout: function getLayout() {
	        return DashboardLayoutStore.getLayout();
	    },
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	    setCurrentDate: function setCurrentDate(date) {
	        this.currentDate = date;
	    },
	
	
	    //TODO: testing propose
	    addBeerStyles: function addBeerStyles(beerStyles) {
	        DashboardServiceCache._setBeerStyles(beerStyles);
	    }
	});
	
	function onFinishFetchingAll(_ref) {
	    var onSuccess = _ref.onSuccess,
	        fetchDashboard = _ref.fetchDashboard,
	        fetchInventoryItems = _ref.fetchInventoryItems,
	        fetchInventoryProduct = _ref.fetchInventoryProduct;
	
	    if (fetchDashboard && fetchInventoryItems && fetchInventoryProduct) {
	        onSuccess();
	    }
	}
	
	function _buildMenuItemsBrewhouse(action, order) {
	    if (order) {
	        return _buildChangeOrderFromBrewhouseMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType);
	    }
	}
	
	function _buildMenuItemsGuest(action, order) {
	    if (order) {
	        return _buildChangeOrderFromGuestMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType);
	    }
	}
	
	function _buildMenuItems(action, order) {
	    if (order) {
	        return _buildChangeOrderMenuItems(order, action.dateClicked, action.isFermenterTank, action.tankType, action.tankClicked);
	    } else {
	        return _buildNewOrderMenuItems(action.dateClicked, action.tankClicked);
	    }
	}
	
	function _buildChangeOrderMenuItems(orderSelected, dateRow, isFermenterTank, tankType, tankClicked) {
	
	    return [{
	        icon: 'settings',
	        text: t('dashboard_store_text_edit_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
	                existingOrderInfo: {
	                    openGeneralTab: true,
	                    orderSelected: orderSelected,
	                    dateRow: dateRow,
	                    isFermenterTank: isFermenterTank,
	                    tankType: tankType
	                }
	            });
	        }
	    }, {
	        icon: 'border_color',
	        text: t('dashboard_store_text_edit_day'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_CHANGE_TASK_ORDER_DASHBOARD,
	                existingOrderInfo: {
	                    openGeneralTab: false,
	                    orderSelected: orderSelected,
	                    dateRow: dateRow,
	                    isFermenterTank: isFermenterTank,
	                    tankType: tankType
	                }
	            });
	        }
	    }, { isDivider: true }, {
	        icon: 'vertical_align_top',
	        text: t('dashboard_store_text_insert_day_above'),
	        onClick: function onClick(evt) {
	            evt.preventDefault();
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_ABOVE,
	                dateClicked: dateRow,
	                order: orderSelected,
	                tankClicked: tankClicked
	            });
	        }
	    }, {
	        icon: 'vertical_align_bottom',
	        text: t('dashboard_store_text_insert_day_below'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_BELOW,
	                dateClicked: dateRow,
	                order: orderSelected,
	                tankClicked: tankClicked
	            });
	        }
	    }, { isDivider: true }, {
	        icon: 'arrow_upward',
	        text: t('dashboard_store_text_move_day_before'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE,
	                dateClicked: dateRow,
	                order: orderSelected,
	                tankClicked: tankClicked
	            });
	        }
	    }, {
	        icon: 'arrow_downward',
	        text: t('dashboard_store_text_move_day_after'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_AFTER,
	                dateClicked: dateRow,
	                order: orderSelected,
	                tankClicked: tankClicked
	            });
	        }
	    }, { isDivider: true }, {
	        icon: 'exposure_neg_1',
	        text: t('dashboard_store_text_delete_day'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_REMOVE_DAY_ORDER,
	                dateClicked: dateRow,
	                order: orderSelected,
	                tankClicked: tankClicked
	            });
	        }
	    }, {
	        icon: 'delete',
	        text: t('dashboard_store_text_delete_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
	                order: orderSelected
	            });
	        }
	    }];
	}
	
	function _buildChangeOrderFromGuestMenuItems(orderSelected, dateRow, isFermenterTank, tankType) {
	    return [{
	        icon: 'visibility',
	        text: t('dashboard_store_text_show_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
	                existingOrderInfo: {
	                    openGeneralTab: true,
	                    orderSelected: orderSelected,
	                    dateRow: dateRow,
	                    isFermenterTank: isFermenterTank,
	                    tankType: tankType
	                }
	            });
	        }
	    }];
	}
	
	function _buildChangeOrderFromBrewhouseMenuItems(orderSelected, dateRow, isFermenterTank, tankType) {
	
	    return ContentUtils.isGhostOrder(orderSelected) ?
	    // Ghost Order
	    [{
	        icon: 'delete',
	        text: t('dashboard_store_text_delete_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
	                order: orderSelected
	            });
	        }
	    }] :
	    // Non Ghost Order
	    [{
	        icon: 'settings',
	        text: t('dashboard_store_text_edit_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD,
	                existingOrderInfo: {
	                    openGeneralTab: true,
	                    orderSelected: orderSelected,
	                    dateRow: dateRow,
	                    isFermenterTank: isFermenterTank,
	                    tankType: tankType
	                }
	            });
	        }
	    }, {
	        icon: 'delete',
	        text: t('dashboard_store_text_delete_order'),
	        onClick: function onClick() {
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_REMOVE_ORDER,
	                order: orderSelected
	            });
	        }
	    }];
	}
	
	function _buildNewOrderMenuItems(dateClicked, tankSelected) {
	    return [{
	        icon: 'add_circle_outline',
	        text: t('dashboard_store_text_create_order'),
	        onClick: function onClick() {
	            var preDefinedOrder = {
	                date: dateClicked,
	                tankSelected: tankSelected,
	                tankType: _.get(tankSelected, 'type')
	            };
	
	            AppDispatcher.dispatch({
	                type: ActionTypes.CONTEXT_MENU_NEW_ORDER_DASHBOARD,
	                preDefinedOrder: preDefinedOrder
	            });
	        }
	    }];
	}
	
	/*
	 Jero: This method will create here, because when we need to show immediately
	 spinner on dashboard we could not fire an event to perform this function body.
	 */
	function savingDraft() {
	    DashboardStore.setIsSavingDraft();
	    DashboardStore.unsetIsSavedDraft();
	    DashboardStore.emitChange();
	    DashboardStore.forceRenderDashboard();
	}
	
	function getAmountDaysDuration(tankType, order) {
	    var startDate = ContentUtils.getOrderField(order, 'startDate', tankType);
	    var endDate = ContentUtils.getOrderField(order, 'endDate', tankType);
	    return DateUtils.getDaysBetween(startDate, endDate) + 1; // add one day to
	}
	
	DashboardStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	    switch (action.type) {
	        case ActionTypes.RIGHT_CLICK_DASHBOARD:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                if (SessionStore.isAbleToEditDates()) {
	                    var menuItems = _buildMenuItems(action);
	                    var textDisplayDate = DateUtils.toDisplayDateText(action.dateClicked);
	                    var textDisplaySubtitleDate = new Date().getFullYear(); // current year
	                    DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
	                    ContextMenuEl.show(action.positionX, action.positionY, textDisplayDate, textDisplaySubtitleDate, menuItems);
	                } else {
	                    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                }
	                break;
	            }
	
	        case ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                var menuItemsFromOrder = void 0;
	                var targetOrder = _.find(OrderStore.getOrders(), function (order) {
	                    return order.id === action.orderId;
	                });
	                var brewingTank = _.get(action, 'tankType') === 'BH';
	
	                if (!SessionStore.isAdminUser()) {
	                    menuItemsFromOrder = _buildMenuItemsGuest(action, targetOrder);
	                } else if (brewingTank) {
	                    menuItemsFromOrder = _buildMenuItemsBrewhouse(action, targetOrder);
	                } else {
	                    menuItemsFromOrder = _buildMenuItems(action, targetOrder);
	                }
	
	                var dayDuration = getAmountDaysDuration(action.tankType, targetOrder);
	
	                var _textDisplayDate = DateUtils.toDisplayDateTextShort(action.dateClicked);
	                var beerStyleName = _.get(targetOrder, 'styleBeer.name');
	                var displayText = _textDisplayDate + ' - Batch: ' + action.batchNumber + ' - Days: ' + dayDuration;
	
	                DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
	                ContextMenuEl.show(action.positionX, action.positionY, displayText, beerStyleName, menuItemsFromOrder);
	                break;
	            }
	
	        case ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                var targetOrderBH = _.find(OrderStore.getOrders(), function (order) {
	                    return order.id === _.get(action, 'order.id');
	                });
	                var menuItemsFromOrderBH = _buildMenuItemsBrewhouse(action, targetOrderBH);
	                DashboardStore.setTemporaryContextMenuDashboardLayout(action.currentDashboard);
	                var _textDisplayDate2 = DateUtils.toDisplayDateText(action.dateClicked);
	                var _beerStyleName = _.get(targetOrderBH, 'styleBeer.name');
	                var _displayText = _textDisplayDate2 + ' - Batch: ' + action.batchNumber;
	                ContextMenuEl.show(action.positionX, action.positionY, _displayText, _beerStyleName, menuItemsFromOrderBH);
	            }
	
	        case ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_BELOW:
	            if (DashboardStore.isPublishingDraft()) {
	                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                return;
	            }
	            if (OrderUtils.haveSomeProductConfirmedFromOrderAfterDate(action.order, action.dateClicked)) {
	                Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
	                return;
	            }
	            if (!SessionStore.isAbleToEditDates()) {
	                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                return;
	            }
	            // Check if Fermenting and Packaging day have space
	            if (OrderStore.addOneDayBelow(action.order, action.tankClicked, action.dateClicked)) {
	                Notification.show(t('dashboard_notification_one_day_added'), 'success');
	                DashboardStore.emitChange();
	            }
	
	            ContextMenuEl.close();
	            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	            savingDraft();
	            DashboardStore.emitChange();
	            break;
	
	        case ActionTypes.CONTEXT_MENU_ADD_DAY_ORDER_ABOVE:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                if (OrderUtils.haveSomeProductConfirmedFromOrderAfterOrEqualDate(action.order, action.dateClicked)) {
	                    Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
	                    return;
	                }
	                if (!SessionStore.isAbleToEditDates()) {
	                    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                    return;
	                }
	
	                // Check if Fermenting and Packaging day have space
	                if (OrderStore.addOneDayAbove(action.order, action.tankClicked, action.dateClicked)) {
	                    Notification.show(t('dashboard_notification_one_day_added'), 'success');
	                    DashboardStore.emitChange();
	                }
	                ContextMenuEl.close();
	                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	                savingDraft();
	                DashboardStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_REMOVE_DAY_ORDER:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                if (OrderUtils.haveSomeProductConfirmedFromOrderAfterOrEqualDate(action.order, action.dateClicked)) {
	                    Notification.show(t('dashboard_notification_unconfirm_icons_and_publish_to_make_changes'));
	                    return;
	                }
	                if (!SessionStore.isAbleToEditDates()) {
	                    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                    return;
	                }
	
	                // Check in case of combined order, the packaging tank if can move up and have space.
	                CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_day'), function () {
	                    if (OrderStore.removeOneDay(action.order, action.tankClicked, action.dateClicked)) {
	                        Notification.show(t('dashboard_notification_day_has_been_deleted'), 'success');
	                        DashboardStore.forceRenderDashboard();
	                        DashboardStore.emitChange();
	                    }
	                });
	                ContextMenuEl.close();
	                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	                savingDraft();
	                DashboardStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_BEFORE:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	
	                if (!OrderUtils.isAbleToMoveTaskADayBefore(action.order, action.dateClicked, action.tankClicked)) {
	                    Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
	                    return;
	                }
	
	                if (!SessionStore.isAdminUser()) {
	                    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                    return;
	                }
	
	                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	
	                if (OrderStore.moveTask(action.order, action.tankClicked, action.dateClicked, -1)) {
	                    Notification.show(t('dashboard_notification_day_has_been_moved'), 'success');
	                    DashboardStore.emitChange();
	                }
	                ContextMenuEl.close();
	                savingDraft();
	                DashboardStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_MOVE_DAY_ORDER_AFTER:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	
	                if (!OrderUtils.isAbleToMoveTaskADayAfter(action.order, action.dateClicked, action.tankClicked)) {
	                    Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
	                    return;
	                }
	
	                if (!SessionStore.isAdminUser()) {
	                    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                    return;
	                }
	
	                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	
	                if (OrderStore.moveTask(action.order, action.tankClicked, action.dateClicked, 1)) {
	                    Notification.show(t('dashboard_notification_day_has_been_moved'), 'success');
	                    DashboardStore.emitChange();
	                }
	                ContextMenuEl.close();
	                savingDraft();
	                DashboardStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.FORCE_MANUAL_DRAWING_DASHBOARD:
	            {
	                if (!DashboardStore.isPublishingDraft()) {
	                    // enter here means it's saving draft finished
	                    DashboardStore.forceRenderDashboard();
	                    DashboardStore.emitChange();
	                }
	                break;
	            }
	        case ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD:
	            {
	                if (!DashboardStore.isSavingDraft() && !DashboardStore.isPublishingDraft()) {
	                    // enter here means it's saving draft finished
	                    DashboardStore.setNeedCleanSelectedOrders(true);
	                    OrderStore.updateLastOrderUpdated(null);
	                    DashboardStore.forceRenderDashboard();
	                    DashboardStore.emitChange();
	                }
	                break;
	            }
	
	        case ActionTypes.FORCE_MANUAL_RE_FETCH_AND_DRAWING_DASHBOARD:
	            {
	                DashboardStore.fetchDashboardContent(action.from, action.to, SessionStore.getCurrentApplicant(), function () {
	                    DashboardStore.forceRenderDashboard();
	                    DashboardStore.emitChange();
	                    window.location.reload(true);
	                });
	                break;
	            }
	
	        case ActionTypes.PERFORM_BATCH_OPERATION_END:
	            DashboardLayoutStore.resetAllPositionAsRelocatedDone(action.batchNumber);
	            break;
	
	        case ActionTypes.CONTEXT_MENU_REMOVE_ORDER:
	            if (DashboardStore.isPublishingDraft()) {
	                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                return;
	            }
	            if (!SessionStore.isAbleToEditDates()) {
	                Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	                return;
	            }
	            var orderHasSomeConfirmedProduct = OrderUtils.haveSomeProductConfirmedFromOrder(action.order);
	            CustomDialog.showWarningConfirmation(t('warning'), orderHasSomeConfirmedProduct ? t('notification_confirm_delete_orden_and _return_inventory') : t('notification_confirm_delete_orden'), function () {
	                OrderStore.removeOrder(action.order);
	                DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action.order, 'id'));
	                DashboardStore.forceRenderDashboard();
	                ContextMenuEl.close();
	                DashboardStore.setIsSavingDraft();
	                DashboardStore.emitChange();
	            });
	            ContextMenuEl.close();
	            DashboardStore.emitChange();
	            break;
	
	        case ActionTypes.DASHBOARD_MODAL_CLOSE_MODAL:
	            DashboardStore.emitChange();
	            break;
	        case ActionTypes.OPEN_DAY_NOTES:
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            break;
	
	        case ActionTypes.CLOSE_DAY_NOTES:
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            break;
	
	        case ActionTypes.NEW_VERSION_API:
	            DashboardCache.cleanCache();
	            DashboardServiceCache.clearAllCache();
	            window.location.reload(true); // reload all again from the server.
	            break;
	
	        case ActionTypes.SAVE_CONFIGURATION_SETTINGS:
	            // A hack to get the page to stop reloading
	            var lastConfigurationForceReload = window.localStorage.getItem('lastConfigurationForceReload');
	            if (lastConfigurationForceReload) {
	                if (new Date().getTime() - lastConfigurationForceReload < 60000) {
	                    return;
	                }
	            }
	
	            window.localStorage.setItem('lastConfigurationForceReload', new Date().getTime());
	            window.location.reload(true); // reload all again from the server.
	            break;
	
	        case ActionTypes.NEW_ORDER:
	            if (DashboardStore.isPublishingDraft()) {
	                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                return;
	            }
	            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
	            OrderStore.updateLastOrderUpdated(action.order);
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	
	            break;
	
	        case ActionTypes.CHANGE_ORDER:
	            if (DashboardStore.isPublishingDraft()) {
	                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                return;
	            }
	            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
	            OrderStore.updateLastOrderUpdated(action.order);
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.REMOVED_ORDER:
	            if (DashboardStore.isPublishingDraft()) {
	                Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                return;
	            }
	            DashboardCache.removeOrderAndCleanCacheScopeInventory(_.get(action, 'order.id'));
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.NEW_ORDER_DRAFT:
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.CHANGE_ORDER_DRAFT:
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.REMOVED_ORDER_DRAFT:
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.PUBLISHING_CHANGE_ADMIN_DRAFT:
	            {
	                DashboardStore.setIsSavingDraft();
	                DashboardSpinnerEl.show();
	                DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), function () {
	                    DashboardStore.forceRenderDashboard();
	                    ChronologycStore.emitChange();
	                    DashboardStore.emitChange();
	                    DashboardSpinnerEl.hide();
	                });
	                break;
	            }
	
	        case ActionTypes.SAVE_DRAFT:
	            // enter here when at level of server side is in-progress draft saving
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.SHOW_LOADING:
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.HIDE_LOADING:
	            DashboardSpinnerEl.hide();
	            break;
	
	        case ActionTypes.SAVE_DRAFT_SUCCESS:
	            // enter here when at level of server side is draft already saved
	            if (DashboardServiceCache.isAllOperationAlreadySaved() && !DashboardStore.isDraggingOrResizing()) {
	                // enter here only if don't have any non saved operation, because is still pending
	                // some non-saved operation wait to DraftSavedPoll save for us.
	                DashboardServiceCache.setUndoDraftOrderAmount(0);
	                DashboardStore.unsetIsSavingDraft();
	                DashboardSpinnerEl.hide();
	                DashboardStore.setIsSavedDraft();
	                DashboardStore.forceRenderDashboard();
	                DashboardStore.emitChange();
	                DashboardStore.setHasPendingSavedDraftWithoutPublish(DashboardStore.hasPendingSavedDraftWithoutPublish());
	            } else {
	                DashboardSpinnerEl.show();
	            }
	            break;
	
	        case ActionTypes.SAVE_DRAFT_FAILURE:
	            DashboardStore.unsetIsSavingDraft();
	            DashboardStore.unsetIsSavedDraft();
	            break;
	
	        case ActionTypes.UNDO_DRAFT:
	            DashboardSpinnerEl.show();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.undoDraft();
	            DashboardStore.emitChange();
	            DashboardStore.forceRenderDashboard();
	            break;
	
	        case ActionTypes.UNDO_DRAFT_SUCCESS:
	            DashboardStore.unsetIsSavedDraft();
	            DashboardStore.emitChange();
	            DashboardStore.forceRenderDashboard();
	
	            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), function () {
	                DashboardServiceCache.cleanOperations();
	                DashboardStore.forceRenderDashboard();
	                DashboardStore.unsetIsSavingDraft();
	                ChronologycStore.emitChange();
	                DashboardStore.emitChange();
	                DashboardSpinnerEl.hide();
	                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
	            });
	            break;
	
	        case ActionTypes.REDO_DRAFT:
	            DashboardSpinnerEl.show();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.redoDraft();
	            DashboardStore.forceRenderDashboard();
	            break;
	
	        case ActionTypes.REDO_DRAFT_SUCCESS:
	            DashboardStore.unsetIsSavedDraft();
	            DashboardStore.emitChange();
	            DashboardStore.forceRenderDashboard();
	
	            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), function () {
	                DashboardServiceCache.cleanOperations();
	                DashboardStore.forceRenderDashboard();
	                DashboardStore.unsetIsSavingDraft();
	                ChronologycStore.emitChange();
	                DashboardStore.emitChange();
	                DashboardSpinnerEl.hide();
	                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
	            });
	            break;
	
	        case ActionTypes.PUBLISHING_DRAFT:
	            DashboardStore.emitChange();
	            DashboardStore.publishDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.setIsSavingDraft();
	            DashboardStore.setPublishingDraft();
	            DashboardSpinnerEl.show();
	            break;
	
	        case ActionTypes.FINISH_TO_DRAGGING_OR_RESIZING:
	            if (!DashboardStore.isSavingDraft() && !DashboardStore.isPublishingDraft()) {
	                DashboardStore.emitChange();
	            }
	            break;
	
	        case ActionTypes.PUBLISHING_DRAFT_SUCCESS:
	            DashboardStore.setPublishedDraft();
	            DashboardStore.unsetPublishingDraft();
	            DashboardStore.setHasPendingSavedDraftWithoutPublish(DashboardServiceCache.getPendingOperations().length > 0);
	            DashboardStore.setHasOperationWithoutPublish(DashboardServiceCache.getOperations().length > 0);
	            DashboardStore.forceRenderDashboard();
	
	            DashboardStore.fetchDashboardContent(ChronologycStore.getCurrentFrom(), ChronologycStore.getCurrentTo(), SessionStore.getCurrentApplicant(), function () {
	                DashboardServiceCache.cleanOperations();
	                DashboardStore.forceRenderDashboard();
	                DashboardStore.unsetIsSavingDraft();
	                ChronologycStore.emitChange();
	                DashboardStore.emitChange();
	                DashboardSpinnerEl.hide();
	                Notification.show(t('dashboard_notification_operation_saved_success'), 'success');
	            });
	            break;
	
	        case ActionTypes.PUBLISHING_DRAFT_FAILURE:
	            DashboardStore.unsetPublishingDraft();
	            DashboardStore.unsetPublishedDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.hide();
	            Notification.show(t('dashboard_notification_something_was_wrong'));
	            break;
	
	        case ActionTypes.UNDO_DRAFT_FAILURE:
	            DashboardStore.unsetPublishingDraft();
	            DashboardStore.unsetPublishedDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.hide();
	            Notification.show(t('dashboard_notification_something_was_wrong'));
	            break;
	
	        case ActionTypes.REDO_DRAFT_FAILURE:
	            DashboardStore.unsetPublishingDraft();
	            DashboardStore.unsetPublishedDraft();
	            DashboardStore.forceRenderDashboard();
	            DashboardStore.emitChange();
	            DashboardSpinnerEl.hide();
	            Notification.show(t('dashboard_notification_something_was_wrong'));
	            break;
	
	        default:
	    }
	});
	
	function _sortOrdersChronologically(orders) {
	    return (orders || []).sort(function (order, orderCompare) {
	        var field = void 0;
	
	        if (order.isSingle) {
	            field = 'fromDate';
	        } else {
	            field = 'brewDate';
	        }
	
	        if (DateUtils.isAfter(order[field], orderCompare[field])) {
	            return 1;
	        }
	        if (DateUtils.isBefore(order[field], orderCompare[field])) {
	            return -1;
	        }
	        return 0;
	    });
	}
	
	module.exports = DashboardStore;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(189),
	    arrayEach = __webpack_require__(135),
	    assignValue = __webpack_require__(192),
	    baseAssign = __webpack_require__(429),
	    baseForOwn = __webpack_require__(98),
	    cloneBuffer = __webpack_require__(858),
	    copyArray = __webpack_require__(100),
	    copySymbols = __webpack_require__(865),
	    getTag = __webpack_require__(142),
	    initCloneArray = __webpack_require__(882),
	    initCloneByTag = __webpack_require__(883),
	    initCloneObject = __webpack_require__(884),
	    isArray = __webpack_require__(27),
	    isBuffer = __webpack_require__(488),
	    isHostObject = __webpack_require__(204),
	    isObject = __webpack_require__(46);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[mapTag] = cloneableTags[numberTag] =
	cloneableTags[objectTag] = cloneableTags[regexpTag] =
	cloneableTags[setTag] = cloneableTags[stringTag] =
	cloneableTags[symbolTag] = cloneableTags[uint8Tag] =
	cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] =
	cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    assignValue(result, key, baseClone(subValue, isDeep, customizer, key, value, stack));
	  });
	  return isArr ? result : copySymbols(value, result);
	}
	
	module.exports = baseClone;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(98),
	    createBaseEach = __webpack_require__(456);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(444),
	    createBaseWrapper = __webpack_require__(867),
	    createCurryWrapper = __webpack_require__(868),
	    createHybridWrapper = __webpack_require__(460),
	    createPartialWrapper = __webpack_require__(869),
	    getData = __webpack_require__(344),
	    mergeData = __webpack_require__(891),
	    setData = __webpack_require__(473),
	    toInteger = __webpack_require__(31);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	  var data = isBindKey ? undefined : getData(func);
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  if (data) {
	    mergeData(newData, data);
	  }
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBaseWrapper(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurryWrapper(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartialWrapper(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybridWrapper.apply(undefined, newData);
	  }
	  var setter = data ? baseSetData : setData;
	  return setter(result, newData);
	}
	
	module.exports = createWrapper;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (typeof value == 'number') {
	    return true;
	  }
	  return !isArray(value) &&
	    (reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	      (object != null && value in Object(object)));
	}
	
	module.exports = isKey;


/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Performs a [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var Colors = __webpack_require__(56);
	var Children = __webpack_require__(213);
	var Events = __webpack_require__(121);
	var KeyCode = __webpack_require__(73);
	var FocusRipple = __webpack_require__(211);
	var TouchRipple = __webpack_require__(363);
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement("style");
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    Events.on(window, 'keydown', function (e) {
	      tabPressed = e.keyCode === KeyCode.TAB;
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = React.createClass({
	  displayName: 'EnhancedButton',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    centerRipple: React.PropTypes.bool,
	    containerElement: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
	    disabled: React.PropTypes.bool,
	    disableFocusRipple: React.PropTypes.bool,
	    disableKeyboardFocus: React.PropTypes.bool,
	    disableTouchRipple: React.PropTypes.bool,
	    keyboardFocused: React.PropTypes.bool,
	    linkButton: React.PropTypes.bool,
	    focusRippleColor: React.PropTypes.string,
	    touchRippleColor: React.PropTypes.string,
	    focusRippleOpacity: React.PropTypes.number,
	    touchRippleOpacity: React.PropTypes.number,
	    onBlur: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    onKeyboardFocus: React.PropTypes.func,
	    onKeyDown: React.PropTypes.func,
	    onKeyUp: React.PropTypes.func,
	    onTouchTap: React.PropTypes.func,
	    tabIndex: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      containerElement: 'button',
	      onBlur: function onBlur() {},
	      onFocus: function onFocus() {},
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onKeyDown: function onKeyDown() {},
	      onKeyUp: function onKeyUp() {},
	      onTouchTap: function onTouchTap() {},
	      tabIndex: 0,
	      type: 'button'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isKeyboardFocused: !this.props.disabled && this.props.keyboardFocused && !this.props.disableKeyboardFocus
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: false });
	      if (nextProps.onKeyboardFocus) {
	        nextProps.onKeyboardFocus(null, false);
	      }
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    injectStyle();
	    listenForTabPresses();
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var centerRipple = _props.centerRipple;
	    var children = _props.children;
	    var containerElement = _props.containerElement;
	    var disabled = _props.disabled;
	    var disableFocusRipple = _props.disableFocusRipple;
	    var disableKeyboardFocus = _props.disableKeyboardFocus;
	    var disableTouchRipple = _props.disableTouchRipple;
	    var focusRippleColor = _props.focusRippleColor;
	    var focusRippleOpacity = _props.focusRippleOpacity;
	    var linkButton = _props.linkButton;
	    var touchRippleColor = _props.touchRippleColor;
	    var touchRippleOpacity = _props.touchRippleOpacity;
	    var onBlur = _props.onBlur;
	    var onFocus = _props.onFocus;
	    var onKeyUp = _props.onKeyUp;
	    var onKeyDown = _props.onKeyDown;
	    var onTouchTap = _props.onTouchTap;
	    var style = _props.style;
	    var tabIndex = _props.tabIndex;
	    var type = _props.type;
	
	    var other = _objectWithoutProperties(_props, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onFocus', 'onKeyUp', 'onKeyDown', 'onTouchTap', 'style', 'tabIndex', 'type']);
	
	    var mergedStyles = this.mergeAndPrefix({
	      border: 10,
	      background: 'none',
	      boxSizing: 'border-box',
	      display: 'inline-block',
	      font: 'inherit',
	      fontFamily: this.context.muiTheme.contentFontFamily,
	      tapHighlightColor: Colors.transparent,
	      appearance: linkButton ? null : 'button',
	      cursor: disabled ? 'default' : 'pointer',
	      textDecoration: 'none',
	      outline: 'none'
	    }, style);
	
	    if (disabled && linkButton) {
	      return React.createElement(
	        'span',
	        _extends({}, other, {
	          style: mergedStyles }),
	        children
	      );
	    }
	
	    var buttonProps = _extends({}, other, {
	      style: mergedStyles,
	      disabled: disabled,
	      onBlur: this._handleBlur,
	      onFocus: this._handleFocus,
	      onTouchTap: this._handleTouchTap,
	      onKeyUp: this._handleKeyUp,
	      onKeyDown: this._handleKeyDown,
	      tabIndex: tabIndex,
	      type: type
	    });
	    var buttonChildren = this._createButtonChildren();
	
	    return React.isValidElement(containerElement) ? React.cloneElement(containerElement, buttonProps, buttonChildren) : React.createElement(linkButton ? 'a' : containerElement, buttonProps, buttonChildren);
	  },
	
	  isKeyboardFocused: function isKeyboardFocused() {
	    return this.state.isKeyboardFocused;
	  },
	
	  removeKeyboardFocus: function removeKeyboardFocus(e) {
	    if (this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: false });
	      this.props.onKeyboardFocus(e, false);
	    }
	  },
	
	  setKeyboardFocus: function setKeyboardFocus(e) {
	    if (!this.state.isKeyboardFocused) {
	      this.setState({ isKeyboardFocused: true });
	      this.props.onKeyboardFocus(e, true);
	    }
	  },
	
	  _cancelFocusTimeout: function _cancelFocusTimeout() {
	    if (this._focusTimeout) {
	      clearTimeout(this._focusTimeout);
	      this._focusTimeout = null;
	    }
	  },
	
	  _createButtonChildren: function _createButtonChildren() {
	    var _props2 = this.props;
	    var centerRipple = _props2.centerRipple;
	    var children = _props2.children;
	    var disabled = _props2.disabled;
	    var disableFocusRipple = _props2.disableFocusRipple;
	    var disableKeyboardFocus = _props2.disableKeyboardFocus;
	    var disableTouchRipple = _props2.disableTouchRipple;
	    var focusRippleColor = _props2.focusRippleColor;
	    var focusRippleOpacity = _props2.focusRippleOpacity;
	    var touchRippleColor = _props2.touchRippleColor;
	    var touchRippleOpacity = _props2.touchRippleOpacity;
	    var isKeyboardFocused = this.state.isKeyboardFocused;
	
	    //Focus Ripple
	    var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? React.createElement(FocusRipple, {
	      color: focusRippleColor,
	      opacity: focusRippleOpacity,
	      show: isKeyboardFocused
	    }) : undefined;
	
	    //Touch Ripple
	    var touchRipple = !disabled && !disableTouchRipple ? React.createElement(
	      TouchRipple,
	      {
	        centerRipple: centerRipple,
	        color: touchRippleColor,
	        opacity: touchRippleOpacity },
	      children
	    ) : undefined;
	
	    return Children.create({
	      focusRipple: focusRipple,
	      touchRipple: touchRipple,
	      children: touchRipple ? undefined : children
	    });
	  },
	
	  _handleKeyDown: function _handleKeyDown(e) {
	    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
	      if (e.keyCode === KeyCode.ENTER && this.state.isKeyboardFocused) {
	        this._handleTouchTap(e);
	      }
	    }
	    this.props.onKeyDown(e);
	  },
	
	  _handleKeyUp: function _handleKeyUp(e) {
	    if (!this.props.disabled && e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
	      this._handleTouchTap(e);
	    }
	    this.props.onKeyUp(e);
	  },
	
	  _handleBlur: function _handleBlur(e) {
	    this._cancelFocusTimeout();
	    this.removeKeyboardFocus(e);
	    this.props.onBlur(e);
	  },
	
	  _handleFocus: function _handleFocus(e) {
	    var _this = this;
	
	    if (!this.props.disabled && !this.props.disableKeyboardFocus) {
	      //setTimeout is needed because the focus event fires first
	      //Wait so that we can capture if this was a keyboard focus
	      //or touch focus
	      this._focusTimeout = setTimeout(function () {
	        if (tabPressed) {
	          _this.setKeyboardFocus(e);
	        }
	      }, 150);
	
	      this.props.onFocus(e);
	    }
	  },
	
	  _handleTouchTap: function _handleTouchTap(e) {
	    this._cancelFocusTimeout();
	    if (!this.props.disabled) {
	      tabPressed = false;
	      this.removeKeyboardFocus(e);
	      this.props.onTouchTap(e);
	    }
	  }
	
	});
	
	module.exports = EnhancedButton;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(121);
	
	module.exports = {
	
	  componentDidMount: function componentDidMount() {
	    var listeners = this.windowListeners;
	
	    for (var eventName in listeners) {
	      var callbackName = listeners[eventName];
	      Events.on(window, eventName, this[callbackName]);
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    var listeners = this.windowListeners;
	
	    for (var eventName in listeners) {
	      var callbackName = listeners[eventName];
	      Events.off(window, eventName, this[callbackName]);
	    }
	  }
	
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var assign = __webpack_require__(25);
	var ReactPropTypes = __webpack_require__(1).PropTypes;
	var Route = __webpack_require__(122);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) {
	      return new Error("<" + componentName + "> may not have a \"" + propName + "\" prop");
	    }
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fiveArgumentPooler = function(a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function(instance) {
	  var Klass = this;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  ) : invariant(instance instanceof Klass));
	  if (instance.destructor) {
	    instance.destructor();
	  }
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function(CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var findDOMNode = __webpack_require__(677);
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function() {
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;


/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 *
	 * The depth indicate how many composite components are above this render level.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14),
	    PropTypes = React.PropTypes,
	    BasicFormGroup;
	
	/**
	 * The base class of form group components in order to work properly with them.
	 */
	BasicFormGroup = {
	
	  propTypes: {
	    /**
	     * Indicated that the component are enable or disabled.
	     */
	    isDisabled: PropTypes.bool,
	
	    /**
	     * Indicated that the component are enable or disabled.
	     */
	    additionalValidation: PropTypes.func,
	
	    /**
	     * Indicated that the component are required or not. (default should be required)
	     */
	    isRequired: PropTypes.bool,
	
	    /**
	     * The context holder to be use to handler each operation of the group component.
	     */
	    operationsHolder: PropTypes.object.isRequired,
	
	    /**
	     * The name of the attribute that will show the component.
	     */
	    displayAttribute: PropTypes.string.isRequired,
	
	    /**
	     * The name of the attribute that will use to read the `selectedItem` in order retrieve the
	     * current `value` defined.
	     */
	    readerAttribute: PropTypes.string.isRequired,
	
	    /**
	     * Pre defined input value. (Optionally)
	     */
	    value: PropTypes.any,
	
	    /**
	     * The name of the attribute that will retrieve the current `value` defined.
	     */
	    writerAttribute: PropTypes.string.isRequired,
	
	    /**
	     * The label of the group form component. (Optionally)
	     */
	    label: PropTypes.string,
	
	    /**
	     * The name of the component to be use to show in validation messages.
	     */
	    name: PropTypes.string
	  }
	};
	
	module.exports = BasicFormGroup;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DashboardServiceImpl = __webpack_require__(132),
	    ContentUtils = __webpack_require__(7),
	    DashboardServiceCache = __webpack_require__(28),
	    _ = __webpack_require__(40);
	
	var BeerStyleStore = {
	    getBeerStyles: function getBeerStyles() {
	        return _.sortBy(DashboardServiceCache.getBeerStyles(), 'name');
	    },
	
	
	    /**
	     * Fetch the all of style beers.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchStyleBeers: function fetchStyleBeers(success, failure) {
	        DashboardServiceImpl.getStyleBeers(function () {
	            success([].slice.call(ContentUtils.parse(this.responseText)));
	        }, failure);
	    },
	
	
	    /**
	     * Change already existing style beer in the application.
	     * @param {Object} styleBeer
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeStyleBeer: function changeStyleBeer(styleBeer, success, failure) {
	        DashboardServiceImpl.changeStyleBeer(styleBeer, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Add new estyle beer in the application.
	     * @param {Object} styleBeer
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addNewStyleBeer: function addNewStyleBeer(styleBeer, success, failure) {
	        DashboardServiceImpl.addStyleBeer(styleBeer, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Add new estyle beer in the application.
	     * @param {Object} styleBeer
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteStyleBeer: function deleteStyleBeer(styleBeer, success, failure) {
	        DashboardServiceImpl.deleteStyleBeer(styleBeer, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Add beer style configuration to current applicant.
	     * @param styleBeerConfiguration
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addBeerStyleConfiguration: function addBeerStyleConfiguration(configurationTank, success, failure) {
	        DashboardServiceImpl.addBeerStyleConfiguration(configurationTank, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change beer style configuration to current applicant.
	     * @param styleBeerConfiguration
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeBeerStyleConfiguration: function changeBeerStyleConfiguration(configurationTank, success, failure) {
	        DashboardServiceImpl.changeBeerStyleConfiguration(configurationTank, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	    fetchStyleBeersConfiguration: function fetchStyleBeersConfiguration(beerStyleId, success, failure) {
	        DashboardServiceImpl.getBeerStyleConfiguration(beerStyleId, function () {
	            var configurations = [].slice.call(ContentUtils.parse(this.responseText));
	            if (success) {
	                success(configurations);
	            }
	        }, failure);
	    },
	    deleteStyleBeersConfiguration: function deleteStyleBeersConfiguration(id, success, failure) {
	        DashboardServiceImpl.deleteBeerStyleConfiguration(id, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    }
	};
	
	module.exports = BeerStyleStore;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var BrewhouseService = __webpack_require__(741),
	    ContentUtils = __webpack_require__(7),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    NumberUtils = __webpack_require__(23),
	    DateUtils = __webpack_require__(22),
	    ChronologycStore = __webpack_require__(76),
	    TankStore = __webpack_require__(97),
	    moment = __webpack_require__(3),
	    Constants = __webpack_require__(2),
	    DashboardModalUtils = __webpack_require__(50),
	    DashboardLayoutStore = __webpack_require__(108),
	    DashboardServiceCache = __webpack_require__(28),
	    Notification = __webpack_require__(21),
	    _ = __webpack_require__(40);
	
	
	var BrewhouseStore = {
	    fetchTask: function fetchTask(success, failure) {
	        BrewhouseService.fetchTask(success, failure);
	    },
	    addTask: function addTask(content, success, failure) {
	        BrewhouseService.addTask(content, success, failure);
	    },
	    changeTask: function changeTask(content, success, failure) {
	        BrewhouseService.changeTask(content, success, failure);
	    },
	    deleteTask: function deleteTask(id, success, failure) {
	        BrewhouseService.deleteTask(id, success, failure);
	    },
	    getBatchPositions: function getBatchPositions(order) {
	        var _this = this;
	
	        var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        if (_.get(order, 'batchs.length', 0) === 0) {
	            return []; // non-batch
	        }
	
	        var batchs = _.get(order, 'batchs');
	
	        return _.map(batchs, function (batch) {
	            var position = _.get(_this.toBatchPosition(order, batch, offsetY), 'position');
	            return position;
	        });
	    },
	    toBatchPosition: function toBatchPosition(order, batch) {
	        var offsetY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var dashboardLayout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DashboardLayoutStore.getLayout();
	
	        var turns = _.map(_.filter(DashboardServiceCache.getTanks(), function (tank) {
	            return tank.type === 'BH';
	        }), function (turn) {
	            turn.volume = +turn.volume;
	            return turn;
	        });
	        var newPositionY = ChronologycStore.getYFromDate(batch.date) + offsetY;
	        var newBatchDate = _.get(ChronologycStore.getDateFromPositionY(newPositionY), 'date');
	        var positionId = _.get(order, 'id') + '_BH|' + _.get(batch, 'turn.column') + '|' + newBatchDate;
	        var turn = _.find(turns, function (turn) {
	            return _.get(batch, 'turnId') === turn.id;
	        });
	
	        var position = {
	            h: 1, // each batch have max 1 day
	            x: _.get(turn, 'column'), // use the same
	            y: newPositionY, // check existing batch with new Y position
	            i: positionId, // use the same
	            batchNumber: _.get(order, 'batchNumber'), // use the same
	            isRelocated: _.get(batch, 'position.isRelocated'),
	            // commons fields
	            static: true,
	            verticalCompact: true,
	            w: 1,
	            isResizable: false,
	            maxW: 1,
	            minW: 1
	        };
	
	        var newBatch = {
	            position: position, // not server persistence
	            isAvailable: DashboardLayoutStore.isEmpty(position, dashboardLayout), // not server persistence
	            turn: turn, // not server persistence
	            turnId: _.get(turn, 'id'), // will persist
	            label: _.get(batch, 'label'), // will persist
	            description: _.get(batch, 'description'), // will persist
	            task: _.get(batch, 'task'), // will persist
	            name: _.get(batch, 'task'), // will persist
	            date: newBatchDate, // will persist
	            products: _.get(batch, 'products') // will persist
	        };
	
	        // remove old batch of cloned order
	        var filteredBatchs = _.filter(order.batchs, function (oldBatch) {
	            return !(oldBatch.turnId === _.get(turn, 'id') && oldBatch.date === batch.date);
	        });
	        //let filteredBatchs = _.filter(order.batchs, batch => batch.turnId !== _.get(turn, 'id'));
	        // add new batch to replace old batch
	        filteredBatchs.push(newBatch);
	        // update batch with the position with order updated
	        newBatch.position = position;
	
	        return newBatch;
	    },
	
	
	    /**
	     * Check if given order have an existing batchs. In case that already have batchs, we try to update only vertical
	     * position (offset vertical position) of each existing batch if have space.
	     * In case that don't exist batchs before, we assign a new one.
	     * @param order
	     * @param offset
	     * @param turns
	     * @param {Object} brewDate
	     */
	    getBatchAvailables: function getBatchAvailables(order, brewDate) {
	        var offsetDays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	        var dashboardLayout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DashboardLayoutStore.getLayout();
	        var isBatchingProcess = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	
	        var turns = _.map(_.filter(DashboardServiceCache.getTanks(), function (tank) {
	            return tank.type === 'BH';
	        }), function (turn) {
	            turn.volume = +turn.volume;
	            return turn;
	        });
	
	        var resultBatchAvailables = void 0;
	
	        if (_.get(order, 'batchs.length') > 0) {
	            // enter here means that exist batch, and try to update to new position with the same turn only changing the date.
	
	            var orderVolume = +order.volume;
	            var resultRecalculatedExistingBatchs = this._recalculateExistingBatchs(order, dashboardLayout, offsetDays);
	
	            if (resultRecalculatedExistingBatchs.volumeAvailable < orderVolume) {
	                // enter means that the volume available is not enough, so we need to find the remaining volume needed to archive `orderVolume` target
	                var batchNotAvailables = _.filter(resultRecalculatedExistingBatchs.existingBatchsUpdated, function (batch) {
	                    return !batch.isAvailable;
	                });
	                var remainingVolume = orderVolume - resultRecalculatedExistingBatchs.volumeAvailable;
	                var newBatchAvailables = this._getNextBatchAvailable(order, turns, brewDate, remainingVolume, resultRecalculatedExistingBatchs.batchAvailables, dashboardLayout, isBatchingProcess);
	
	                if (_.get(batchNotAvailables, 'length') > _.get(newBatchAvailables, 'length')) {
	                    // enter here means usually means that between brewDate and packaginDate there is not batch available
	                    // between that range of dates.
	                    return null;
	                }
	
	                var newBatchAvailablesUpdated = this.migrateTaskFromOlderBatchNotAvailableToNewBatchAvailable(batchNotAvailables, newBatchAvailables);
	                return _.flatten(_.concat(newBatchAvailablesUpdated, resultRecalculatedExistingBatchs.batchAvailables));
	            }
	
	            if (resultRecalculatedExistingBatchs.volumeAvailable >= orderVolume) {
	                // enter here means that we have the batch with volume that we already needed. Finish here!
	                resultBatchAvailables = resultRecalculatedExistingBatchs.batchAvailables;
	            }
	        } else {
	            // Enter here means that the order is NEW, so just calculate the first batch available
	            resultBatchAvailables = this._getNextBatchAvailable(order, turns, brewDate, order.volume, null, dashboardLayout, isBatchingProcess);
	            if (!this.isEnoughBatchAvailable(+order.volume, resultBatchAvailables)) {
	                // enter here means that the are not enough batch for the current range of date of the current order
	                return null;
	            }
	        }
	
	        if (!isBatchingProcess) {
	            // enter here means that we need to revert re-located flag because is not executed this method from batching process
	            resultBatchAvailables = _.map(resultBatchAvailables, function (batch) {
	                batch = _.set(batch, 'position.isRelocated', false);
	                return batch;
	            });
	        }
	
	        return resultBatchAvailables;
	    },
	    isEnoughBatchAvailable: function isEnoughBatchAvailable(orderVolume, batchs) {
	        var filteredBatchs = _.filter(batchs, function (batch) {
	            return batch.isAvailable;
	        });
	        var totalBatchVolume = _.map(filteredBatchs, function (batch) {
	            return _.get(batch, 'turn.volume');
	        }, []).reduce(function (total, value) {
	            return total + value;
	        }, 0);
	        return totalBatchVolume >= orderVolume;
	    },
	    isEnoughVolumeInTank: function isEnoughVolumeInTank(order, columnTarget) {
	        var orderTank = TankStore.getTankByColumn(columnTarget);
	        return +orderTank.volume >= +_.get(order, 'volume');
	    },
	    _recalculateExistingBatchs: function _recalculateExistingBatchs(order, layout, offsetDays) {
	        var _this2 = this;
	
	        var existingBatchs = _.get(order, 'batchs');
	        var volumenTargetCount = 0;
	
	        var existingBatchsUpdated = _.map(existingBatchs, function (batch) {
	            var newBatch = _this2.toBatchPosition(order, batch, offsetDays, layout);
	            volumenTargetCount += +_.get(newBatch, 'turn.volume', 0) || 0;
	            if (newBatch.isAvailable) {
	                newBatch = _.set(newBatch, 'position.isRelocated', true);
	            }
	            return newBatch;
	        });
	
	        // search if some of batch is not available with the new vertical position.
	        var batchAvailables = _.filter(existingBatchsUpdated, function (batch) {
	            return batch.isAvailable;
	        });
	        var volumeAvailable = this._calculateTotalVolumeOfBatchs(batchAvailables);
	
	        return {
	            batchAvailables: batchAvailables,
	            volumeAvailable: volumeAvailable,
	            existingBatchsUpdated: existingBatchsUpdated
	        };
	    },
	    migrateTaskFromOlderBatchNotAvailableToNewBatchAvailable: function migrateTaskFromOlderBatchNotAvailableToNewBatchAvailable(oldBatchNotAvailable, newBatchAvailable) {
	        // ask if we have old task to migrate to new available task
	        if (_.get(oldBatchNotAvailable, 'length', 0) === 0) {
	            return newBatchAvailable;
	        }
	        // migrate old task to new batch available
	        return _.map(newBatchAvailable, function (newBatch, indexBatch) {
	            var oldBatch = oldBatchNotAvailable[indexBatch];
	            if (oldBatch) {
	                newBatch.task = _.get(oldBatch, 'task', '');
	                newBatch.label = _.get(oldBatch, 'label', '');
	                newBatch.description = _.get(oldBatch, 'description', '');
	                newBatch.products = _.get(oldBatch, 'products', '');
	            }
	            return newBatch;
	        });
	    },
	    _calculateTotalVolumeOfBatchs: function _calculateTotalVolumeOfBatchs() {
	        var batchs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var turnsVolume = _.map(batchs, function (batch) {
	            return +_.get(batch, 'turn.volume');
	        });
	        return _.reduce(turnsVolume, function (total, volume) {
	            return total + volume;
	        }, 0);
	    },
	    _getNextBatchAvailable: function _getNextBatchAvailable(order, turns, brewDate) {
	        var targetVolume = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Number.MAX_SAFE_INTEGER;
	        var batchOrderAlreadyAvailables = arguments[4];
	        var dashboardLayout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : DashboardLayoutStore.getLayout();
	        // default null max integer, in order to search all batch within 3 days
	        var daysBeetweenDates = void 0,
	            firstDate = void 0,
	            indexDay = -1,
	            batchAvailables = [],
	            volumenTargetCount = 0;
	
	        if (order.isSingle) {
	            daysBeetweenDates = DateUtils.getDaysBetween(order.fromDate, order.toDate);
	            firstDate = order.fromDate;
	        } else {
	            daysBeetweenDates = DateUtils.getDaysBetween(brewDate, order.filtrationDate);
	            firstDate = brewDate;
	        }
	
	        var brewDateY = ChronologycStore.getYFromDate(firstDate);
	        var MAX_DAYS_TO_CALCULATE_BREWHOUSE = daysBeetweenDates;
	
	        targetVolume = +targetVolume; // cast to number.
	        var allBatchFounded = false;
	
	        // first calculate all availability of each batch in the new position
	        while (indexDay < MAX_DAYS_TO_CALCULATE_BREWHOUSE) {
	            if (allBatchFounded) {
	                break;
	            }
	            indexDay++;
	            var batchDateY = brewDateY + indexDay;
	            var batchDate = _.get(ChronologycStore.getDateFromPositionY(batchDateY), 'date');
	
	            // iterate each turn of day in order to make batch validation
	
	            var _loop = function _loop() {
	                if (_isArray) {
	                    if (_i >= _iterator.length) return 'break';
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) return 'break';
	                    _ref = _i.value;
	                }
	
	                var turn = _ref;
	
	
	                var positionId = _.get(order, 'id') + '_BH|' + _.get(turn, 'column') + '|' + batchDate;
	                var position = {
	                    batchNumber: _.get(order, 'batchNumber'),
	                    h: 1, // each batch have max 1 day
	                    x: turn.column,
	                    y: batchDateY,
	                    i: positionId,
	                    isRelocated: true
	                };
	
	                // ask if this `position` is not already in use for the current order
	                if (_.some(batchOrderAlreadyAvailables, function (batchAlreadyTaken) {
	                    return _.get(batchAlreadyTaken, 'position.x') === position.x && _.get(batchAlreadyTaken, 'position.y') === position.y;
	                })) {
	                    return 'continue';
	                }
	
	                if (DashboardLayoutStore.isEmpty(position, dashboardLayout)) {
	                    batchAvailables.push({
	                        position: position, // not server persistence
	                        isAvailable: true, // not server persistence
	                        turn: turn, // not server persistence
	                        isRelocated: true, // not server persistence
	                        turnId: turn.id, // will persist
	                        date: batchDate // will persist
	                    });
	                    volumenTargetCount += +turn.volume || 0;
	                }
	
	                if (volumenTargetCount >= targetVolume) {
	                    allBatchFounded = true;
	                    return {
	                        v: batchAvailables
	                    };
	                }
	            };
	
	            _loop2: for (var _iterator = turns, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                var _ret = _loop();
	
	                switch (_ret) {
	                    case 'break':
	                        break _loop2;
	
	                    case 'continue':
	                        continue;
	
	                    default:
	                        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	                }
	            }
	        }
	
	        return batchAvailables;
	    },
	    recalculateBrewhouseBatchsWithLayout: function recalculateBrewhouseBatchsWithLayout(order, offsetDays) {
	        var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DashboardLayoutStore.getLayout();
	        var isBatchingProcess = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	        return this.recalculateBrewhouseBatchs(order, offsetDays, false, order.styleBeer, layout, isBatchingProcess);
	    },
	
	
	    /**
	     * Calculate all brewhouse batch needed for given order.
	     * @param {Object} order
	     * @param {Number} offsetDays
	     * @param {Boolean} forceToUpdateBatchAnyway
	     * @return {*}
	     */
	    recalculateBrewhouseBatchs: function recalculateBrewhouseBatchs(order, offsetDays, forceToUpdateBatchAnyway, beerStyleSelected) {
	        var layout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DashboardLayoutStore.getLayout();
	        var isBatchingProcess = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	        var orderVolume = ContentUtils.getNumber(_.get(order, 'volume'));
	
	        if (orderVolume === 0) {
	            // set zero which means the tab should be visible but just empty, otherwhise if batchs are undefiend
	            // the tab will not show
	            return _.set(order, 'batchs', []);
	        }
	
	        if (order && orderVolume) {
	            // already prepare for single mode.
	            var brewDate = void 0;
	
	            if (order.isSingle) {
	                brewDate = _.get(order, 'fromDate');
	            } else {
	                brewDate = _.get(order, 'brewDate');
	            }
	            var targetVolume = ContentUtils.getNumber(order.volume);
	
	            // starting flag to be use to indicate when all of batch wanted (which means target volume archived) are already founded
	            order.allBatchLocated = false;
	
	            // return the batch availables needed for the current order.
	            var batchAvailables = this.getBatchAvailables(order, brewDate, offsetDays, layout, isBatchingProcess);
	
	            if (!batchAvailables) {
	                // enter here means there not have enough tanks for the volume order or just all turns are already occupied
	                order.allBatchLocated = false;
	                order.brewhouseMessageError = t('brewhouse_store_message_error_do_not_have_enough_turns_available');
	                return order;
	            } else {
	                order.brewhouseMessageError = undefined;
	            }
	
	            if (!this.isBrewdateAvailable(batchAvailables, brewDate)) {
	                // enter here means that don't exist batch for brewDate, so could not possible to change the order
	                order.allBatchLocated = false;
	                order.brewhouseMessageError = t('notification_brewhouse_at_full_capacity_on_selected_date');
	                return order;
	            }
	
	            var batchFiltered = this._filterOnlyBatchNeeded(batchAvailables, orderVolume);
	            var totalBatchOrder = this._calculateTotalVolumeBatch(batchFiltered);
	            batchFiltered = DashboardModalUtils.hydrateBatchWithProcess(batchFiltered, order.batchs);
	
	            if (totalBatchOrder >= targetVolume) {
	                order.allBatchLocated = true;
	                order.brewhouseMessageError = undefined;
	                // apply configuration beer style of brewhouse section
	                order.batchs = this._applyBrewhouseConfigurationTask(batchFiltered, beerStyleSelected, order.batchs);
	                // update the endDate of each product of the batchs
	                order = this._recalculateBrewingProductEndDate(order, offsetDays);
	                return order;
	            } else {
	                order.allBatchLocated = false;
	                order.brewhouseMessageError = '';
	                if (forceToUpdateBatchAnyway) {
	                    order.batchs = batchFiltered;
	                }
	                return order;
	            }
	        } else {
	            // remove batch older, just in case that have batch before
	            order.batchs = null;
	        }
	
	        return order;
	    },
	    _recalculateBrewingProductEndDate: function _recalculateBrewingProductEndDate(order, offsetDays) {
	        order.batchs = _.map(order.batchs, function (task) {
	            return _recalculateOffsetProductsEndDate(task, offsetDays);
	        });
	        return order;
	    },
	    _applyBrewhouseConfigurationTask: function _applyBrewhouseConfigurationTask(batchs, currentBeerStyle, existingBatchs) {
	        if (batchs && currentBeerStyle) {
	            var brewingTaskConfiguration = _.filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), function (task) {
	                return task.styleBeerId === +currentBeerStyle.id && task.typeTank === Constants.BREWING_TYPE_TASK;
	            });
	
	            if (_.get(brewingTaskConfiguration, 'length', 0) > 0) {
	                // apply configuration of each batch
	                var sortedBatchs = DateUtils.sortListByDateField(batchs, 'date');
	
	                brewingTaskConfiguration.forEach(function (configBatch, index) {
	                    var batch = sortedBatchs[index];
	                    if (batch) {
	                        var existingBatch = existingBatchs.find(function (batchOld) {
	                            return batchOld.turnId === batch.turnId;
	                        });
	                        batch.task = batch.task || configBatch.typeTask;
	                        batch.name = batch.name || isEmpty(batch.name) ? batch.name : configBatch.typeTask;
	                        batch.label = batch.label || isEmpty(batch.label) ? batch.label : configBatch.label;
	                        batch.description = batch.description || isEmpty(batch.description) ? batch.description : configBatch.description;
	                        batch.isConfiguration = true;
	                        if (_.get(existingBatch, 'process.length', 0) > 0) {
	                            batch.process = existingBatch.process;
	                        }
	                    }
	                });
	                return DateUtils.sortListByDateField(sortedBatchs, 'date');
	            }
	        }
	        return batchs;
	    },
	
	
	    /**
	     * Ask if exist some batch on brew date or one day before of given brew date.
	     * @param {Array} batchs
	     * @param {String} brewdate
	     * @return {*}
	     */
	    isBrewdateAvailable: function isBrewdateAvailable(batchs, brewdate) {
	        return _.some(batchs, function (batch) {
	            return batch.date === brewdate;
	        }) || _.some(batchs, function (batch) {
	            return batch.date === DateUtils.addDaysTextBasicFormat(brewdate, -1);
	        });
	    },
	
	
	    /**
	     * Clean all information about brewhouse in given state.
	     * @param nextState
	     * @return {*}
	     */
	    cleanBrewhouse: function cleanBrewhouse(nextState, defaultValue) {
	        nextState = _.set(nextState, 'order.batchs', defaultValue);
	        nextState = _.set(nextState, 'batchs', defaultValue);
	        return nextState;
	    },
	
	
	    /**
	     * Validate if the column that try to take is enough at level of volume of tank.
	     * @param {Object} position         that will be validated if is fit to the column that try to fill.
	     * @param {integer} volume          The volume of the order that will be validated
	     * @return {Boolean}
	     */
	    isProperlyVolumeOfTankDestination: function isProperlyVolumeOfTankDestination(position, volume) {
	        var tankToValidate = _.find(DashboardServiceCache.getTanks(), function (tank) {
	            return tank.column === position.x;
	        });
	
	        if (tankToValidate) {
	            return +tankToValidate.volume >= +volume;
	        } else {
	            Notification.show(t('notification_column_of_the_new_position') + position.x + t(' notification_do_not_exist'), 'error');
	            return false;
	        }
	    },
	    calculateBatchVolume: function calculateBatchVolume(preDefinedOrder, batchNumber) {
	        var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DashboardLayoutStore.getLayout();
	
	        if (!batchNumber) {
	            batchNumber = String(_.get(preDefinedOrder, 'orderSelected.batchNumber'));
	        }
	        // filter orders by given bach number
	        var batchOrders = _.filter(layout, function (position) {
	            return String(position.batchNumber) === batchNumber;
	        });
	        // calculate FV total batch volume
	        var fermentingVolume = _calculateSectionVolume(batchOrders, function (item) {
	            return !ContentUtils.isBH(item.i) && !ContentUtils.isBT(item.i) && !ContentUtils.isBHBatch(item.i);
	        });
	        // calculate BT total batch volume
	        var packagingVolume = _calculateSectionVolume(batchOrders, function (item) {
	            return ContentUtils.isBT(item.i);
	        });
	        // get the max section volume
	        var totalBatchVolume = _.max([fermentingVolume, packagingVolume]);
	
	        preDefinedOrder.packagingVolume = packagingVolume;
	        preDefinedOrder.fermentingVolume = fermentingVolume;
	        preDefinedOrder.totalBatchVolume = totalBatchVolume;
	        preDefinedOrder.totalBatchVolumeMessageError = this.getLabelVolumeBySections(fermentingVolume, packagingVolume);
	
	        return preDefinedOrder;
	    },
	    getTaskFromOrder: function getTaskFromOrder(order) {
	        if (!order) {
	            return order;
	        }
	        if (_.get(order, 'isSingle')) {
	            return _.filter(_.concat(order.singleTasks, order.batchs), function (task) {
	                return task;
	            });
	        } else {
	            return _.filter(_.concat(order.batchs, order.fermenterTasks, order.packagingTasks), function (task) {
	                return task;
	            });
	        }
	    },
	    getAllProductsFromOrder: function getAllProductsFromOrder(order) {
	        var tasks = this.getTaskFromOrder(order);
	        return _.flatMap(tasks, function (task) {
	            return _.get(task, 'products') || [];
	        });
	    },
	    getAllItemsFromAllProductsFromOrder: function getAllItemsFromAllProductsFromOrder(order) {
	        var items = [];
	        var products = this.getAllProductsFromOrder(order);
	        for (var _iterator2 = products, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var product = _ref2;
	
	            items.push(product.items);
	        }
	        return _.flatMap(items);
	    },
	    calculateCostByOrder: function calculateCostByOrder(order, vendorItems) {
	        var allItems = this.getAllItemsFromAllProductsFromOrder(order);
	        return this.calculateCostByItems(allItems, vendorItems);
	    },
	    calculateCostByProduct: function calculateCostByProduct(product, vendorItems) {
	        return this.calculateCostByItems(product.items, vendorItems);
	    },
	    calculateCostByItems: function calculateCostByItems(allItems, vendorItems) {
	        // we should not calculate in batch cost the item Addition, because that product doesn't
	        // is created from the final product, so it doesn't count in the cost.
	        var allItemsWithoutAdditions = allItems.filter(function (item) {
	            return !item.addition;
	        });
	        return allItemsWithoutAdditions.reduce(function (total, item) {
	            var vendorItem = vendorItems.find(function (vendorItem) {
	                return vendorItem.itemId === item.itemId;
	            });
	            var priceUnit = vendorItem ? vendorItem.priceUnit || '1' : '1';
	            var relativeUnitAmount = vendorItem ? vendorItem.relativeUnitAmount || '1' : '1';
	            var value = NumberUtils.divide(priceUnit, relativeUnitAmount);
	            var subTotal = NumberUtils.multiply(value, item.amount);
	            total = NumberUtils.sum(subTotal, total);
	            total = NumberUtils.formatDecimal(total);
	            return total;
	        }, 0);
	    },
	    calculateBatchVolumeByBatchNumber: function calculateBatchVolumeByBatchNumber(batchNumber, orderIdExclusive) {
	        var layout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DashboardLayoutStore.getLayout();
	
	        var result = {};
	        var batchOrders = void 0;
	        // filter orders by given bach number
	        if (orderIdExclusive) {
	            batchOrders = _.filter(layout, function (position) {
	                return String(position.batchNumber) === batchNumber && ContentUtils.cleanId(position.i) === orderIdExclusive;
	            });
	        } else {
	            batchOrders = _.filter(layout, function (position) {
	                return String(position.batchNumber) === batchNumber;
	            });
	        }
	        // calculate FV total batch volume
	        var fermentingVolume = _calculateSectionVolume(batchOrders, function (item) {
	            return !ContentUtils.isBH(item.i) && !ContentUtils.isBT(item.i) && !ContentUtils.isBHBatch(item.i);
	        });
	        // calculate BT total batch volume
	        var packagingVolume = _calculateSectionVolume(batchOrders, function (item) {
	            return ContentUtils.isBT(item.i);
	        });
	        // get the max section volume
	        var totalBatchVolume = _.max([fermentingVolume, packagingVolume]);
	
	        result.packagingVolume = NumberUtils.getNumber(packagingVolume);
	        result.fermentingVolume = NumberUtils.getNumber(fermentingVolume);
	        result.totalBatchVolume = NumberUtils.getNumber(totalBatchVolume);
	        return result;
	    },
	    isSomeBatchChange: function isSomeBatchChange(oldBatchs, newBatchs) {
	        if (_.get(oldBatchs, 'length', 0) > 0 && _.get(newBatchs, 'length', 0) > 0) {
	            var _loop3 = function _loop3() {
	                if (_isArray3) {
	                    if (_i3 >= _iterator3.length) return 'break';
	                    _ref3 = _iterator3[_i3++];
	                } else {
	                    _i3 = _iterator3.next();
	                    if (_i3.done) return 'break';
	                    _ref3 = _i3.value;
	                }
	
	                var oldBatch = _ref3;
	
	                var newBatch = _.find(newBatchs, function (batch) {
	                    return batch.i === oldBatch.i;
	                });
	                if (!ContentUtils.isSameObject(oldBatch, newBatch, ['date', 'description', 'label', 'task'])) {
	                    return {
	                        v: false
	                    };
	                }
	            };
	
	            _loop4: for (var _iterator3 = oldBatchs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	                var _ref3;
	
	                var _ret2 = _loop3();
	
	                switch (_ret2) {
	                    case 'break':
	                        break _loop4;
	
	                    default:
	                        if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	                }
	            }
	        }
	        return true;
	    },
	    getLabelVolumeBySections: function getLabelVolumeBySections(fermentingVolume, packagingVolume) {
	        return 'Fermenting (' + fermentingVolume + ') Packaging (' + packagingVolume + ')';
	    },
	    formatBatchVolumeLeft: function formatBatchVolumeLeft(batchVolume) {
	        var unit = DashboardServiceCache.getCurrentUnitTank();
	        //return `${NumberUtils.formatDecimal(batchVolume)}${unit} (${NumberUtils.formatDecimal(leftVolume)}${unit} left)`;
	        return '' + NumberUtils.formatDecimal(batchVolume) + unit;
	    },
	
	
	    /**
	     * Given batchs retrieve the total of volume of all batchs.
	     * @param batchs
	     * @return {*}
	     * @private
	     */
	    _calculateTotalVolumeBatch: function _calculateTotalVolumeBatch(batchs) {
	        var volumeField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'turn.volume';
	
	        return _.reduce(_.map(batchs, function (batch) {
	            return +_.get(batch, volumeField);
	        }), function (total, batchVolume) {
	            return total + batchVolume;
	        }, 0);
	    },
	    _filterOnlyBatchNeeded: function _filterOnlyBatchNeeded() {
	        var batchs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	        var targetVolume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	        var targetBatchs = [];
	        var countVolume = 0;
	        for (var _iterator4 = batchs, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	            var _ref4;
	
	            if (_isArray4) {
	                if (_i4 >= _iterator4.length) break;
	                _ref4 = _iterator4[_i4++];
	            } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) break;
	                _ref4 = _i4.value;
	            }
	
	            var batch = _ref4;
	
	            var batchVolume = +_.get(batch, 'turn.volume');
	            countVolume += batchVolume;
	            if (countVolume < targetVolume) {
	                targetBatchs.push(batch);
	            } else if (countVolume >= targetVolume) {
	                targetBatchs.push(batch);
	                return targetBatchs;
	            }
	        }
	        return targetBatchs;
	    },
	    updateTankSelectionBrewhouseElegible: function updateTankSelectionBrewhouseElegible(dateClickedFrom) {
	        var nextState = {};
	        var dateClickedTo = DateUtils.addDays(dateClickedFrom.date, 14); // make 14, like default when open dialog new before select beer style!
	        var tankTypeTarget = 'FV'; // we search the first available from FV to simulate clicking on FV available position.
	        var tankAvailability = TankStore.getAvailabilityTanks(dateClickedFrom.date, dateClickedTo, tankTypeTarget);
	        var availableTanks = _.filter(tankAvailability, function (tank) {
	            return tank.isAvailable;
	        });
	        var tankElegible = _.first(availableTanks); // select the first available from FV
	        var tankElegibleIndex = _.findIndex(availableTanks, function (tank) {
	            return tank.id === _.get(tankElegible, 'id');
	        }); // select the first available from FV
	        nextState.tankSelected = tankElegible;
	        nextState.singleTank = tankElegible;
	        nextState.singleTankIndex = tankElegibleIndex;
	        nextState.orderDateClicked = dateClickedFrom.date;
	        // Assign the volume of turn instead of
	        // first fermenting tank eligible
	        nextState = _.set(nextState, 'tankSelected.volume', _.get(dateClickedFrom, 'tankSelected.volume'));
	        return nextState;
	    }
	};
	
	function _calculateSectionVolume(batchs, filterBatch) {
	    var batchsFiltered = _.filter(batchs, filterBatch);
	    var volumeBatchs = _.map(batchsFiltered, function (item) {
	        if (item && item.volume || item.volume === 0) {
	            return ContentUtils.getNumber(item.volume);
	        }
	        var order = DashboardServiceCache.getSafeOrder(_.get(item, 'i'));
	        if (!order) {
	            return 0;
	        }
	        var volumeOrder = +order.volume;
	        return volumeOrder;
	    });
	
	    var totalVolume = _.reduce(volumeBatchs, function (totalVolume, volume) {
	        return totalVolume + volume;
	    }, 0);
	    return totalVolume || 0;
	}
	
	function _recalculateOffsetProductsEndDate(task, offesetDays) {
	    var products = _.get(task, 'products');
	
	    if (ContentUtils.isNotEmptyArray(products)) {
	        var productsUpdated = _.map(products, function (product) {
	            product.endDate = moment(product.endDate || task.date).add(offesetDays, 'days').format(Constants.DATE_FORMAT_LONG);
	            return product;
	        });
	        task.products = productsUpdated;
	    }
	
	    return task;
	}
	
	function isEmpty(value) {
	    return '' === value;
	}
	
	module.exports = BrewhouseStore;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DashboardLayoutStore = __webpack_require__(108),
	    _ = __webpack_require__(40),
	    ChronologycStore = __webpack_require__(76),
	    ContentUtils = __webpack_require__(7),
	    DashboardServiceCache = __webpack_require__(28),
	    DateUtils = __webpack_require__(22),
	    DashboardAction = __webpack_require__(65),
	    DashboardServiceImpl = __webpack_require__(132);
	
	var TankStore = {
	
	    /**
	     * Persist new tank in the application that will be available from the dashboard.
	     * @param tank
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addTank: function addTank(tank, success, failure) {
	        DashboardServiceImpl.addTank(tank, function () {
	            DashboardAction.addedTank();
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Fetch tanks from the server and hydrate cache of tanks.
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    fetchTanks: function fetchTanks(success, failure) {
	        DashboardServiceImpl.getAllTanks(function () {
	            var tanks = [].slice.call(ContentUtils.parse(this.responseText));
	            DashboardServiceCache.setTanks(tanks);
	            if (success) {
	                success.bind(this)(tanks);
	            }
	        }, failure);
	    },
	    fetchTanksBy: function fetchTanksBy(filter, success, failure) {
	        DashboardServiceImpl.getTanksBy(filter, function () {
	            var tanks = [].slice.call(ContentUtils.parse(this.responseText));
	            DashboardServiceCache.setTanks(tanks);
	            if (success) {
	                success.bind(this)(tanks);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent tank in the application.
	     * @param tank
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeTank: function changeTank(tank, success, failure) {
	        DashboardServiceImpl.changeTank(tank, function () {
	            DashboardAction.changedTank();
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete tanks from the application.
	     * TBD: validate if need check before what happen if are orders assigned in this tank.
	     * @param tank
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteTank: function deleteTank(tank, success, failure) {
	        DashboardServiceImpl.deleteTank(tank, function () {
	            DashboardAction.deletedTank();
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	    setTanks: function setTanks(tanks) {
	        DashboardServiceCache.setTanks(tanks);
	    },
	
	
	    /**
	     * Given a range of date and type of tank, retrieve the availability of tanks.
	     *
	     * @param {Date} dateFrom            start range of date
	     * @param {Date} dateTo              end range of date
	     * @param {String} typeTank          type of tank that will check availability.
	     * @param {String} orderId           (optional) of the existing order.
	     * @return {Array}
	     */
	    getAvailabilityTanks: function getAvailabilityTanks(dateFrom, dateTo, typeTank, orderId) {
	        var layout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DashboardLayoutStore.getLayout();
	
	
	        // Filter only the type tanks that we need calculate the availability
	        var filterTanks = this.getTanks().filter(function (column) {
	            return column.type === typeTank;
	        });
	
	        // Iterate each of tank that we need to calculate their availability about `dateFrom` and `dateTo` params.
	        var tanksAvailability = filterTanks.map(function (tank) {
	
	            var dateFromText = DateUtils.toDateText(dateFrom),
	                dateToText = DateUtils.toDateText(dateTo),
	                newPosition,
	                idOrderCollision,
	                rangeCollisions;
	
	            // Convert `dateFrom` and `dateTo` to position of layout in order to allow calculate if are available or not these dates.
	            newPosition = {
	                x: tank.column,
	                h: ChronologycStore.getHFromDate(dateFromText, dateToText),
	                y: ChronologycStore.getYFromDate(dateFromText),
	                i: orderId || -1 // Is optional, because if dont define `orderId`, the search of collision will not take care about ID of order.
	            };
	
	            // Calculate if exist same other order in the `newPosition` that collision.
	            rangeCollisions = DashboardLayoutStore.getRangeCollisions(newPosition, layout) || [];
	
	            // In case that exist collision, save the Id of first of order to collision.
	            if (rangeCollisions.length > 0) {
	                idOrderCollision = _.map(rangeCollisions, function (range) {
	                    return ContentUtils.cleanId(_.get(range, 'rangeConflict.id'));
	                });
	            }
	
	            // Retrieve all the information needed to handler the availability or not of given `dateFrom`, `dateTo`, `typeTank`
	            // And `orderId`.
	            return {
	                id: tank.id,
	                type: tank.type,
	                column: tank.column,
	                volume: tank.volume,
	                unit: tank.unit,
	                name: tank.name,
	                isAvailable: rangeCollisions.length === 0,
	                idOrderCollision: idOrderCollision
	            };
	        }.bind(this));
	
	        return tanksAvailability;
	    },
	
	
	    /**
	     * Return the next Single tank available.
	     * @param fromDate
	     * @param toDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getNextSingleTankAvailable: function getNextSingleTankAvailable(fromDate, toDate, orderId, volume, tankType, layout) {
	        var availableTanks = this.getAvailabilityTanks(fromDate, toDate, tankType, orderId, layout);
	        return this._getNextMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Return the previous Single tank available.
	     * @param fromDate
	     * @param toDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getPreviouseSingleTankAvailable: function getPreviouseSingleTankAvailable(fromDate, toDate, orderId, volume, tankType, layout) {
	        var availableTanks = this.getAvailabilityTanks(fromDate, toDate, tankType, orderId, layout);
	        return this._getBeforeMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Return the next Brite tank available.
	     * @param filtrationDate
	     * @param orderDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getNextBriteTankAvailable: function getNextBriteTankAvailable(filtrationDate, orderDate, orderId, volume, layout) {
	        var availableTanks = this.getAvailabilityTanks(filtrationDate, orderDate, 'BT', orderId, layout);
	        return this._getNextMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Return the next Brite tank available.
	     * @param filtrationDate
	     * @param orderDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getPreviousBriteTankAvailable: function getPreviousBriteTankAvailable(filtrationDate, orderDate, orderId, volume, layout) {
	        var availableTanks = this.getAvailabilityTanks(filtrationDate, orderDate, 'BT', orderId, layout);
	        return this._getBeforeMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Return the next Brite tank available.
	     * @param filtrationDate
	     * @param orderDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getNextFermenterTankAvailable: function getNextFermenterTankAvailable(brewDate, filtrationDate, orderId, volume, layout) {
	        var availableTanks = this.getAvailabilityTanks(brewDate, filtrationDate, 'FV', orderId, layout);
	        return this._getNextMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Return the next Brite tank available.
	     * @param filtrationDate
	     * @param orderDate
	     * @param orderId
	     * @returns {*}
	     * @private
	     */
	    getPreviousFermenterTankAvailable: function getPreviousFermenterTankAvailable(brewDate, filtrationDate, orderId, volume, layout) {
	        var availableTanks = this.getAvailabilityTanks(brewDate, filtrationDate, 'FV', orderId, layout);
	        return this._getBeforeMostSuitableTank(availableTanks, volume || 0);
	    },
	
	
	    /**
	     * Given list of tanks and volume, return the most suitable tank.
	     * @param availableTanks
	     * @param volume
	     * @return {*}
	     * @private
	     */
	    _getNextMostSuitableTank: function _getNextMostSuitableTank(availableTanks, volume) {
	        var tanksAvailablesAndSuitables = _.filter(availableTanks, function (tank) {
	            return tank.isAvailable === true && +tank.volume >= +volume;
	        });
	        var tanksAvailablesWithNumberVolume = _.map(tanksAvailablesAndSuitables, function (tank) {
	            tank.volume = +tank.volume;
	            return tank;
	        });
	        return _.first(_.orderBy(tanksAvailablesWithNumberVolume, 'volume'));
	    },
	    _getBeforeMostSuitableTank: function _getBeforeMostSuitableTank(availableTanks, volumeTarget) {
	        var tanksAvailablesAndSuitables = _.filter(availableTanks, function (tank) {
	            return tank.isAvailable === true;
	        });
	        var tanksAvailablesWithNumberVolume = _.map(tanksAvailablesAndSuitables, function (tank) {
	            tank.volume = +tank.volume;
	            return tank;
	        });
	        tanksAvailablesAndSuitables = _.orderBy(tanksAvailablesWithNumberVolume, 'volume');
	        return _.find(tanksAvailablesAndSuitables, function (tank) {
	            return +tank.volume + 1 >= volumeTarget;
	        });
	    },
	    getTanks: function getTanks() {
	        return DashboardServiceCache.getTanks();
	    },
	    getTankById: function getTankById(tankId) {
	        return find(DashboardServiceCache.getTanks(), function (tank) {
	            return tankId === _.get(tank, 'id');
	        });
	    },
	    getTankByColumn: function getTankByColumn(column, success) {
	        var tanks = DashboardServiceCache.getTankByColumn(column);
	        if (success) {
	            success(tanks);
	        }
	        return tanks;
	    },
	    getTankByType: function getTankByType(column, success) {
	        var tanks = DashboardServiceCache.getTankByType(column);
	        if (success) {
	            success(tanks);
	        }
	        return tanks;
	    },
	
	
	    /**
	     * Retrieve the position new of brite tank.
	     * @param {Object}   order
	     * @param {Object}   positionNew
	     * @param {Object}   positionOld
	     * @return {Object}
	     */
	    getPositionBriteTankFromFermenter: function getPositionBriteTankFromFermenter(order, positionFVNew, positionFVOld) {
	        var boxBT = DashboardLayoutStore.getLayout().filter(function (box) {
	            if (box && order) {
	                return box.i === order.id + '_BT';
	            }
	            return false;
	        })[0],
	            newFiltrationPosition = positionFVNew.y + positionFVNew.h - 1,
	            briteTankOrderId = order.id + '_BT',
	            newBriteTankH = boxBT.h;
	
	        if (positionFVNew.h !== positionFVOld.h) {
	            // Enter here means that the fermentation date was changed by resizing the order. So we need to calculate the new height (h)
	            // of Packaging date.
	            if (positionFVNew.h < positionFVOld.h) {
	                newBriteTankH = positionFVOld.h - positionFVNew.h + this.getBriteTank(order.id).h;
	            } else {
	                newBriteTankH = this.getBriteTank(order.id).h - (positionFVNew.h - positionFVOld.h);
	            }
	        }
	
	        if (!boxBT) {
	            // Enter here means that BT is out of range of range of current dashboard.
	            return null;
	        }
	
	        return {
	            y: newFiltrationPosition,
	            x: boxBT.x,
	            h: newBriteTankH,
	            i: briteTankOrderId,
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle')
	        };
	    },
	    getPositionFermenterFromBriteTank: function getPositionFermenterFromBriteTank(order, positionBTNew, positionBTOld) {
	        var boxFermenter = DashboardLayoutStore.getLayout().filter(function (box) {
	            if (box && order) {
	                return box.i === order.id;
	            }
	            return false; // means that fermenter is out of range of current dashboard
	        })[0],
	            newBrewDayPosition,
	            newBriteTankH;
	
	        if (!boxFermenter) {
	            return null;
	        }
	        newBriteTankH = boxFermenter.h;
	        if (positionBTNew.h !== positionBTOld.h) {
	            // Enter here means that the fermentation date was changed by resizing the order. So we need to calculate the new height (h)
	            // of Packaging date.
	            if (positionBTNew.h < positionBTOld.h) {
	                newBriteTankH = positionBTOld.h - positionBTNew.h + this.getFilterTank(order.id).h;
	            } else {
	                newBriteTankH = this.getFilterTank(order.id).h - (positionBTNew.h - positionBTOld.h);
	            }
	        }
	
	        newBrewDayPosition = positionBTNew.y - boxFermenter.h + 1;
	
	        return {
	            y: newBrewDayPosition,
	            x: boxFermenter.x,
	            h: newBriteTankH,
	            i: order.id,
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle')
	        };
	    },
	    getBriteTank: function getBriteTank(orderId) {
	        return _.find(DashboardLayoutStore.getLayout(), function (box) {
	            return box.i === orderId + '_BT';
	        });
	    },
	    getFilterTank: function getFilterTank(orderId) {
	        return _.find(DashboardLayoutStore.getLayout(), function (box) {
	            return box.i === orderId;
	        });
	    },
	    getBriteTankPosition: function getBriteTankPosition(order) {
	        return {
	            h: ChronologycStore.getHFromDate(order.filtrationDate, order.orderDate),
	            x: _.get(order, 'briteTank.column'),
	            y: ChronologycStore.getYFromDate(order.filtrationDate),
	            i: order.id + '_BT',
	            w: 1,
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle'),
	            static: true
	        };
	    },
	    getFermenterTankPosition: function getFermenterTankPosition(order) {
	        var x = void 0;
	        if (order.fermenterTank) {
	            x = order.fermenterTank.column;
	        } else {
	            x = order.singleTank.column;
	        }
	        return {
	            h: ChronologycStore.getHFromDate(order.brewDate, order.filtrationDate),
	            x: x,
	            y: ChronologycStore.getYFromDate(order.brewDate),
	            i: String(order.id),
	            w: 1,
	            batchNumber: _.get(order, 'batchNumber'),
	            isSingle: _.get(order, 'isSingle'),
	            static: true
	        };
	    },
	    getFermenterTankPositionManual: function getFermenterTankPositionManual(orderId, column, brewDate, filtrationDate, batchNumber, isSingle) {
	        return {
	            h: ChronologycStore.getHFromDate(brewDate, filtrationDate),
	            x: column,
	            y: ChronologycStore.getYFromDate(brewDate),
	            i: String(orderId),
	            batchNumber: batchNumber,
	            isSingle: isSingle,
	            w: 1,
	            static: true
	        };
	    },
	    getSingleTankPosition: function getSingleTankPosition(singleOrder) {
	        var fromDate = void 0;
	        var toDate = void 0;
	        if (typeof singleOrder.fromDate === 'string') {
	            fromDate = singleOrder.fromDate;
	        } else {
	            fromDate = DateUtils.toDateText(singleOrder.fromDate);
	        }
	        if (typeof singleOrder.toDate === 'string') {
	            toDate = singleOrder.toDate;
	        } else {
	            toDate = DateUtils.toDateText(singleOrder.toDate);
	        }
	        var postFix = _.get(singleOrder, 'singleTank.type') === 'BT' ? '_BT' : '';
	        var id = String(singleOrder.id) + postFix;
	        return {
	            h: ChronologycStore.getHFromDate(fromDate, toDate),
	            x: _.get(singleOrder, 'singleTank.column'),
	            y: ChronologycStore.getYFromDate(fromDate),
	            batchNumber: _.get(singleOrder, 'batchNumber'),
	            i: id,
	            w: 1,
	            static: true,
	            isSingle: true
	        };
	    },
	    isFirstTankHigherOrEquals: function isFirstTankHigherOrEquals(tankHigherColumn, tankColumn) {
	        var tankHigher = this.getTankByColumn(tankHigherColumn);
	        var tank = this.getTankByColumn(tankColumn);
	
	        if (tankHigher && tank) {
	            return +tankHigher.volume >= +tank.volume;
	        }
	
	        return false;
	    }
	};
	
	module.exports = TankStore;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(324),
	    keys = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87),
	    isArrayLike = __webpack_require__(66),
	    isIndex = __webpack_require__(114),
	    isObject = __webpack_require__(46);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 102 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  /**
	   * The relative brightness of any point in a colorspace, normalized to 0 for
	   * darkest black and 1 for lightest white. RGB colors only. Does not take
	   * into account alpha values.
	   *
	   * TODO:
	   * - Take into account alpha values.
	   * - Identify why there are minor discrepancies for some use cases
	   *   (i.e. #F0F & #FFF). Note that these cases rarely occur.
	   *
	   * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	   */
	  _luminance: function _luminance(color) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('rgb') > -1) {
	      var rgb = color.values.map(function (val) {
	        val /= 255; // normalized
	        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	      });
	
	      return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
	    } else {
	      var message = 'Calculating the relative luminance is not available for ' + 'HSL and HSLA.';
	      console.error(message);
	      return -1;
	    }
	  },
	
	  /**
	   * @params:
	   * additionalValue = An extra value that has been calculated but not included
	   *                   with the original color object, such as an alpha value.
	   */
	  _convertColorToString: function _convertColorToString(color, additonalValue) {
	    var str = color.type + '(' + parseInt(color.values[0]) + ',' + parseInt(color.values[1]) + ',' + parseInt(color.values[2]);
	
	    if (additonalValue !== undefined) {
	      str += ',' + additonalValue + ')';
	    } else if (color.values.length === 4) {
	      str += ',' + color.values[3] + ')';
	    } else {
	      str += ')';
	    }
	
	    return str;
	  },
	
	  // Converts a color from hex format to rgb format.
	  _convertHexToRGB: function _convertHexToRGB(color) {
	    if (color.length === 4) {
	      var extendedColor = '#';
	      for (var i = 1; i < color.length; i++) {
	        extendedColor += color.charAt(i) + color.charAt(i);
	      }
	      color = extendedColor;
	    }
	
	    var values = {
	      r: parseInt(color.substr(1, 2), 16),
	      g: parseInt(color.substr(3, 2), 16),
	      b: parseInt(color.substr(5, 2), 16)
	    };
	
	    return 'rgb(' + values.r + ',' + values.g + ',' + values.b + ')';
	  },
	
	  // Returns the type and values of a color of any given type.
	  _decomposeColor: function _decomposeColor(color) {
	    if (color.charAt(0) === '#') {
	      return this._decomposeColor(this._convertHexToRGB(color));
	    }
	
	    var marker = color.indexOf('(');
	    var type = color.substring(0, marker);
	    var values = color.substring(marker + 1, color.length - 1).split(',');
	
	    return { type: type, values: values };
	  },
	
	  // Set the absolute transparency of a color.
	  // Any existing alpha values are overwritten.
	  fade: function fade(color, amount) {
	    color = this._decomposeColor(color);
	    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
	    return this._convertColorToString(color, amount);
	  },
	
	  // Desaturates rgb and sets opacity to 0.15
	  lighten: function lighten(color, amount) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('hsl') > -1) {
	      color.values[2] += amount;
	      return this._decomposeColor(this._convertColorToString(color));
	    } else if (color.type.indexOf('rgb') > -1) {
	      for (var i = 0; i < 3; i++) {
	        color.values[i] *= 1 + amount;
	        if (color.values[i] > 255) color.values[i] = 255;
	      }
	    }
	
	    if (color.type.indexOf('a') <= -1) color.type += 'a';
	
	    return this._convertColorToString(color, '0.15');
	  },
	
	  darken: function darken(color, amount) {
	    color = this._decomposeColor(color);
	
	    if (color.type.indexOf('hsl') > -1) {
	      color.values[2] += amount;
	      return this._decomposeColor(this._convertColorToString(color));
	    } else if (color.type.indexOf('rgb') > -1) {
	      for (var i = 0; i < 3; i++) {
	        color.values[i] *= 1 - amount;
	        if (color.values[i] < 0) color.values[i] = 0;
	      }
	    }
	
	    return this._convertColorToString(color);
	  },
	
	  // Calculates the contrast ratio between two colors.
	  //
	  // Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	  contrastRatio: function contrastRatio(background, foreground) {
	    var lumA = this._luminance(background);
	    var lumB = this._luminance(foreground);
	
	    if (lumA >= lumB) {
	      return ((lumA + 0.05) / (lumB + 0.05)).toFixed(2);
	    } else {
	      return ((lumB + 0.05) / (lumA + 0.05)).toFixed(2);
	    }
	  },
	
	  /**
	   * Determines how readable a color combination is based on its level.
	   * Levels are defined from @LeaVerou:
	   * https://github.com/LeaVerou/contrast-ratio/blob/gh-pages/contrast-ratio.js
	   */
	  contrastRatioLevel: function contrastRatioLevel(background, foreground) {
	    var levels = {
	      'fail': {
	        range: [0, 3],
	        color: 'hsl(0, 100%, 40%)'
	      },
	      'aa-large': {
	        range: [3, 4.5],
	        color: 'hsl(40, 100%, 45%)'
	      },
	      'aa': {
	        range: [4.5, 7],
	        color: 'hsl(80, 60%, 45%)'
	      },
	      'aaa': {
	        range: [7, 22],
	        color: 'hsl(95, 60%, 41%)'
	      }
	    };
	
	    var ratio = this.contrastRatio(background, foreground);
	
	    for (var level in levels) {
	      var range = levels[level].range;
	      if (ratio >= range[0] && ratio <= range[1]) return level;
	    }
	  }
	};

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function(object, objectName, methodNames) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(
	          objectName,
	          methodNames[key],
	          object[key]
	        );
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function(objName, fnName, func) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      var measuredFunc = null;
	      var wrapper = function() {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function(measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	
	var assign = __webpack_require__(25);
	var emptyFunction = __webpack_require__(80);
	var getEventTarget = __webpack_require__(391);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: getEventTarget,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ?
	    nativeEvent.defaultPrevented :
	    nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function() {
	    var event = this.nativeEvent;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function(Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.threeArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.threeArgumentPooler);
	
	module.exports = SyntheticEvent;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1326);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ContentUtils = __webpack_require__(7),
	    ComponentUtils = __webpack_require__(77),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(48),
	    union = _require2.union,
	    set = __webpack_require__(5).set,
	    _require3 = __webpack_require__(1),
	    PropTypes = _require3.PropTypes,
	    TextField = __webpack_require__(106),
	    MenuList = __webpack_require__(711);
	
	
	var ATTRIBUTE_ITEM_WITH_ICON = 'icon';
	var ATTRIBUTE_ITEM_WITH_ICON_HTML = 'iconHTML';
	
	var DropDown = React.createClass({ displayName: "DropDown",
	    propTypes: {
	        name: PropTypes.string,
	        readerAttribute: PropTypes.string,
	        /**
	         * The list of items of dropdown which have plain text or object.
	         * In case which items are objects, we could add icons to each of item-object
	         * have the name of class with the name of attribute
	         *
	         * (eg item: {icon: 'icon-task icon-task-yeast-in' ...} )
	         */
	        items: PropTypes.arrays,
	        errorText: PropTypes.string,
	        className: PropTypes.string,
	        floatingLabelText: PropTypes.string,
	        labelStyle: PropTypes.objec,
	        errorStyle: PropTypes.object,
	        onEnterKeyDown: PropTypes.func,
	        onChange: PropTypes.func,
	        onBlur: PropTypes.func,
	        selectedIndex: PropTypes.object,
	        disabled: PropTypes.bool,
	        value: PropTypes.object,
	        wrapperMenuItem: PropTypes.func,
	        styleText: PropTypes.object,
	        style: PropTypes.object,
	        ref: PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isExpanded: false,
	            selectedItem: null,
	            isPristine: true
	        };
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	    },
	    _onKeyDown: function _onKeyDown(evt) {
	        if (!evt) {
	            return;
	        }
	
	        var isListExpanded = this.state.isExpanded;
	        var isListCollapsed = !isListExpanded;
	
	        var isPressedKeyArrowUp = evt.keyCode === 38;
	        var isPressedKeyArrowDown = evt.keyCode === 40;
	        var isPressedKeyEnter = evt.keyCode === 13;
	        var isPressedKeyScape = evt.keyCode === 27;
	        var isPressedKeyBackspace = evt.keyCode === 8;
	        var isPressedKeyTab = evt.keyCode === 9;
	
	        if (isPressedKeyArrowDown && isListCollapsed) {
	            evt.preventDefault();
	            this.onPressArrowDownAndListIsCollapsed();
	        } else if ((isPressedKeyArrowDown || isPressedKeyArrowUp) && isListExpanded) {
	            evt.preventDefault();
	            this.onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown);
	        } else if (isPressedKeyEnter) {
	            evt.preventDefault();
	            evt.stopPropagation();
	
	            this.onPressEnter(evt);
	        } else if (isPressedKeyScape || isPressedKeyBackspace) {
	            evt.preventDefault();
	            this.onPressScapeOrBackspace();
	        }
	
	        if (!isPressedKeyTab) {
	            // just in case of any of before keys doesn't apply,
	            // only allow tab key event bubbling as normal flow (not
	            // prevent neither stop it). the Rest of actions need to be
	            // stopped to simulate not-edition behavior of drop-down component.
	            evt.preventDefault();
	            evt.stopPropagation();
	        }
	    },
	    onClickOutSide: function onClickOutSide(event) {
	        var targetEl = event && event.target;
	        var innerText = get(event, 'target.innerText');
	        var clickFromArrow = 'arrow_drop_down' === innerText;
	
	        if (targetEl && !clickFromArrow) {
	            // if clieck en label or input show not close dropdown
	            var clickInnerLabel = targetEl.classList.contains('bp-textfield__label') || targetEl.classList.contains('bp-textfield__input');
	            if (!clickInnerLabel) {
	                var menuDropdownEl = ContentUtils.getComponentByClassName(targetEl, 'bp-menu-list');
	
	                if (menuDropdownEl) {
	                    this.collapseList();
	                }
	            }
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onClickOutSide);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onClickOutSide, false);
	    },
	    onPressEnter: function onPressEnter(evt) {
	        var _this = this;
	
	        // select the first of the list
	        var _props = this.props,
	            onEnterKeyDown = _props.onEnterKeyDown,
	            items = _props.items,
	            onChange = _props.onChange,
	            readerAttribute = _props.readerAttribute,
	            name = _props.name;
	        var isExpanded = this.state.isExpanded;
	
	
	        if (isExpanded) {
	            var menuItems = buildItems(items, readerAttribute, name);
	            var currentIndexSelected = evt && evt.target && evt.target.getAttribute('data-menu-index');
	            var selectedItem = get(menuItems, currentIndexSelected);
	
	            this.setState({
	                selectedItem: selectedItem
	            }, function () {
	                _this.focusInput();
	                _this.collapseList();
	            });
	
	            onChange(selectedItem, evt);
	
	            if (onEnterKeyDown) {
	                onEnterKeyDown(selectedItem);
	            }
	        }
	    },
	    getItemEl: function getItemEl(index) {
	        return this.getDOMNode().querySelector('li[data-menu-index="' + index + '"]');
	    },
	    onPressScapeOrBackspace: function onPressScapeOrBackspace() {
	        this.collapseList();
	        this.focusInput();
	    },
	    isEditMode: function isEditMode() {
	        return !!this.props.value;
	    },
	    expandList: function expandList() {
	        this.setState({ isExpanded: true });
	    },
	    collapseList: function collapseList() {
	        this.setState({ isExpanded: false });
	    },
	    onPressArrowDownAndListIsCollapsed: function onPressArrowDownAndListIsCollapsed() {
	        var _this2 = this;
	
	        var selectedItem = this.state.selectedItem;
	
	
	        this.setState({ isExpanded: true }, function () {
	            var firstItem = selectedItem ? _this2.getItemEl(get(selectedItem, 'payload')) // specific selected item
	            : _this2.getDOMNode().querySelector('.bp-menu-list-item');
	
	            if (firstItem) {
	                firstItem.focus();
	            }
	        });
	    },
	    onPressArrowUpOrDownArrow: function onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown) {
	        // if the list is expanded, the client will
	        // be able to walk through the list of
	        // items which arrows keys (up & down)
	        var activeElement = document.activeElement;
	        var isFocusOutSideOfList = !activeElement.classList.contains('bp-menu-list-item');
	        var selectedItem = this.state.selectedItem;
	
	
	        if (isFocusOutSideOfList) {
	            var firstItem = selectedItem ? this.getItemEl(selectedItem.payload) : this.getDOMNode().querySelector('.bp-menu-list-item');
	
	            if (firstItem) {
	                firstItem.focus();
	            }
	        } else if (isPressedKeyArrowUp) {
	            var nextElement = activeElement.previousElementSibling;
	
	            if (nextElement) {
	                activeElement.previousElementSibling.focus();
	            } else {
	                this.collapseList();
	                this.focusInput();
	            }
	        } else if (isPressedKeyArrowDown) {
	            var _nextElement = activeElement.nextElementSibling;
	
	            if (_nextElement) {
	                if (activeElement.nextElementSibling) {
	                    activeElement.nextElementSibling.focus();
	                }
	            }
	        }
	    },
	    isListExpanded: function isListExpanded() {
	        var textWritten = this.state.textWritten;
	
	        var isCurrentFocusSomeListItem = document.activeElement && document.activeElement.classList.contains('bp-menu-list-item');
	        return !!isCurrentFocusSomeListItem || !!textWritten;
	    },
	    focusInput: function focusInput() {
	        this.getDOMNode().querySelector('input').focus();
	    },
	    getTextWritten: function getTextWritten() {
	        return this.getDOMNode().querySelector('.bp-textfield input').value;
	    },
	    _onClick: function _onClick(evt) {
	        if (evt && evt.preventDefault) {
	            evt.preventDefault();
	            evt.stopPropagation();
	        }
	
	        var onClick = this.props.onClick;
	
	
	        this.setState(function (prevState) {
	            return {
	                isExpanded: !prevState.isExpanded
	            };
	        }, function () {
	            if (onClick) {
	                onClick();
	            }
	        });
	    },
	    _onChange: function _onChange(selectedItem, evt) {
	        var _this3 = this;
	
	        if (evt && evt.preventDefault) {
	            evt.preventDefault();
	            evt.stopPropagation();
	        }
	        var onChange = this.props.onChange;
	
	        this.setState({
	            isExpanded: false,
	            selectedItem: selectedItem
	        }, function () {
	            _this3.focusInput();
	            if (onChange) {
	                onChange(selectedItem, evt);
	            }
	        });
	    },
	    _onBlur: function _onBlur(evt) {
	        evt.preventDefault();
	        var onBlur = this.props.onBlur;
	        var _state = this.state,
	            isExpanded = _state.isExpanded,
	            selectedItem = _state.selectedItem;
	
	
	        if (onBlur && !isExpanded) {
	            onBlur(selectedItem);
	        }
	    },
	    getValue: function getValue() {
	        return this.state.selectedItem || this.props.value;
	    },
	    render: function render() {
	        var _props2 = this.props,
	            floatingLabelText = _props2.floatingLabelText,
	            items = _props2.items,
	            errorText = _props2.errorText,
	            errorStyle = _props2.errorStyle,
	            className = _props2.className,
	            readerAttribute = _props2.readerAttribute,
	            selectedIndex = _props2.selectedIndex,
	            disabled = _props2.disabled,
	            labelStyle = _props2.labelStyle,
	            style = _props2.style,
	            name = _props2.name,
	            wrapperMenuItem = _props2.wrapperMenuItem,
	            key = _props2.key;
	
	
	        var menuItems = buildItems(items, readerAttribute, name, key);
	        var _state2 = this.state,
	            selectedItem = _state2.selectedItem,
	            isExpanded = _state2.isExpanded;
	
	        var haveSelectedIndexDefined = selectedIndex > -1;
	        var selectedItemByIndex = haveSelectedIndexDefined ? get(menuItems, selectedIndex) : null;
	        var selectedIndexText = haveSelectedIndexDefined ? get(selectedItemByIndex, 'itemModel.' + readerAttribute) : '';
	
	        // relay first internal state, (because is the latest state)
	        // then check if was defined some initially
	        var currentSelectedItemText = selectedItem ? get(selectedItem, 'itemModel.' + readerAttribute) : haveSelectedIndexDefined ? selectedIndexText : null;
	
	        return React.createElement("div", {
	            id: "bp-dropdown-container",
	            onKeyDownCapture: disabled ? null : this._onKeyDown,
	            onClick: disabled ? null : this._onClick,
	            onBlur: disabled ? null : this._onBlur,
	            style: style,
	            className: 'bp-drop-down' + (className ? ' ' + className : '') + (disabled ? ' is-disabled' : '')
	        }, React.createElement(TextField, {
	            floatingLabelText: floatingLabelText,
	            icon: "arrow_drop_down",
	            errorText: errorText,
	            labelStyle: labelStyle,
	            errorStyle: errorStyle,
	            style: set(labelStyle, 'cursor', 'pointer'),
	            value: currentSelectedItemText,
	            disabled: disabled }), React.createElement(MenuList, {
	            readerAttribute: "text", // is already build it from this fixed property
	            readerAttributeIcon: "itemModel.iconClassName",
	            customKey: key,
	            items: menuItems,
	            isExpanded: isExpanded,
	            wrapperMenuItem: wrapperMenuItem,
	            onChange: disabled ? null : this._onChange }));
	    }
	});
	
	function buildItems(items, readerAttribute, name) {
	    if (get(items, 'length', 0) > 0) {
	        if (ContentUtils.isStringOrIntegerItem(items)) {
	            return ComponentUtils.toMenuItemsText(items, name);
	        } else {
	            var nonSelectItem = [{ payload: 0, text: t('label_select') + ' ' + name }];
	            return union(nonSelectItem, ComponentUtils.toMenuItems(items, readerAttribute, ATTRIBUTE_ITEM_WITH_ICON, 'bp-dropdown-item-index-', ATTRIBUTE_ITEM_WITH_ICON_HTML));
	        }
	    } else {
	        return [{ payload: 0, text: t('label_select') + ' ' + name }];
	    }
	}
	
	module.exports = DropDown;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1336);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(12),
	    FontIcon = _require2.FontIcon,
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7);
	
	
	var TextField = React.createClass({ displayName: "TextField",
	    propTypes: {
	        value: PropTypes.string,
	        className: PropTypes.string,
	        floatingLabelText: PropTypes.string,
	        labelStyle: PropTypes.object,
	        errorText: PropTypes.string,
	        errorStyle: PropTypes.object,
	        onBlur: PropTypes.function,
	        onChange: PropTypes.function,
	        onFocus: PropTypes.function,
	        disabled: PropTypes.boolean,
	        multiLine: PropTypes.boolean,
	        style: PropTypes.object,
	        key: PropTypes.string,
	        icon: PropTypes.string,
	        onClickIcon: PropTypes.function,
	        ref: PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isActive: false,
	            consumerWrittenText: null
	        };
	    },
	    getValue: function getValue() {
	        return this.getDOMNode().querySelector('input').value;
	    },
	    componentWillMount: function componentWillMount() {
	        this.id = ContentUtils.getRandomId();
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        var lastValue = void 0;
	
	        if (this.state.consumerWrittenText) {
	            lastValue = this.state.consumerWrittenText;
	        } else {
	            lastValue = this.props.value;
	        }
	
	        return nextProps.value !== lastValue || nextProps.errorText !== this.props.errorText || nextProps.floatingLabelText !== this.props.floatingLabelText || nextProps.disabled !== this.props.disabled || nextState.isActive !== this.state.isActive || nextState.consumerWrittenText !== this.state.consumerWrittenText;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        // avoid same cases is out of sync props
	        // value which native input value
	        var el = this.getDOMNode().querySelector('input');
	        if ('' === this.props.value && this.props.value !== get(el, 'value')) {
	            this.setState({ isActive: false, consumerWrittenText: '' });
	            if (ContentUtils.isNotNullOrUndefined(this.props.value) && el) {
	                el.value = this.props.value;
	            }
	        } else if (el && this.props.value !== undefined && this.props.value !== null) {
	            el.value = this.props.value;
	        }
	    },
	    onFocus: function onFocus(evt) {
	        evt.preventDefault();
	        var onFocus = this.props.onFocus;
	
	        if (onFocus) {
	            onFocus(evt);
	        }
	        this.setState({
	            isActive: true
	        });
	    },
	    onBlur: function onBlur(evt) {
	        evt.preventDefault();
	        var onBlur = this.props.onBlur;
	
	        if (onBlur) {
	            onBlur(evt);
	        }
	
	        this.setState({
	            isActive: false,
	            consumerWrittenText: evt.target.value
	        });
	    },
	    getInputText: function getInputText() {
	        var _props = this.props,
	            disabled = _props.disabled,
	            style = _props.style,
	            value = _props.value,
	            onChange = _props.onChange,
	            ref = _props.ref;
	
	
	        var inputEl = disabled ? React.createElement("input", {
	            style: style,
	            disabled: true,
	            className: "bp-textfield__input is-disabled",
	            type: "text",
	            id: this.id,
	            defaultValue: value,
	            ref: ref }) : React.createElement("input", {
	            onChange: onChange,
	            onFocus: this.onFocus,
	            onBlur: this.onBlur,
	            style: style,
	            className: "bp-textfield__input",
	            type: "text",
	            defaultValue: value,
	            id: this.id,
	            ref: ref });
	
	        return inputEl;
	    },
	    getTextArea: function getTextArea() {
	        var _props2 = this.props,
	            value = _props2.value,
	            disabled = _props2.disabled,
	            style = _props2.style,
	            onChange = _props2.onChange,
	            ref = _props2.ref;
	
	
	        var inputEl = disabled ? React.createElement("textarea", {
	            disabled: true,
	            className: "bp-textfield__input bp-textfield__input--textarea is-disabled",
	            type: "text",
	            id: this.id,
	            defaultValue: value,
	            style: style,
	            ref: ref }) : React.createElement("textarea", {
	            onChange: onChange,
	            style: style,
	            onFocus: this.onFocus,
	            onBlur: this.onBlur,
	            className: "bp-textfield__input bp-textfield__input--textarea",
	            type: "text",
	            id: this.id,
	            defaultValue: value,
	            ref: ref });
	
	        return inputEl;
	    },
	    render: function render() {
	        var _props3 = this.props,
	            floatingLabelText = _props3.floatingLabelText,
	            errorText = _props3.errorText,
	            multiLine = _props3.multiLine,
	            value = _props3.value,
	            icon = _props3.icon,
	            labelStyle = _props3.labelStyle,
	            disabled = _props3.disabled,
	            errorStyle = _props3.errorStyle,
	            className = _props3.className,
	            onClickIcon = _props3.onClickIcon;
	        var _state = this.state,
	            isActive = _state.isActive,
	            consumerWrittenText = _state.consumerWrittenText;
	
	
	        var inputEl = multiLine ? this.getTextArea() : this.getInputText();
	        var consumerWriteText = !!consumerWrittenText;
	        var consumerCleanText = consumerWrittenText === '';
	        var consumerDefinedValue = !ContentUtils.isNullOrEmpty(value);
	        var consumerJustInitializeWithText = !consumerWriteText && consumerDefinedValue;
	        var inputIsInUse = !consumerCleanText && (consumerWriteText || consumerJustInitializeWithText);
	
	        var classNameBuilder = 'bp-textfield';
	
	        if (className) {
	            classNameBuilder += ' ' + className;
	        }
	
	        if (multiLine) {
	            classNameBuilder += ' is-textarea';
	        }
	
	        if (isActive) {
	            classNameBuilder += ' is-active';
	        }
	
	        if (errorText) {
	            classNameBuilder += ' have-error';
	        }
	
	        if (!floatingLabelText) {
	            classNameBuilder += ' is-empty-label';
	        }
	
	        if (disabled) {
	            classNameBuilder += ' is-disabled';
	        }
	
	        if (inputIsInUse || consumerDefinedValue) {
	            classNameBuilder += ' is-in-use';
	        }
	
	        var floatingLabelTextEl = floatingLabelText ? React.createElement("label", { style: labelStyle, className: "bp-textfield__label", htmlFor: this.id }, floatingLabelText) : null;
	
	        var errorTextEl = errorText ? React.createElement("span", { style: errorStyle, className: "bp-textfield__error" }, errorText) : null;
	
	        var underline = React.createElement("hr", { className: "bp-textfield__underline" });
	
	        var underlineFixed = React.createElement("hr", { className: "bp-textfield__underline-fixed" });
	
	        var iconEl = icon ? React.createElement(FontIcon, {
	            color: { color: '#e0e0e0' },
	            className: "material-icons bp-textfield__icon",
	            onClick: onClickIcon
	        }, icon) : null;
	
	        return React.createElement("div", { key: this.id + '-textfield-key', className: classNameBuilder }, inputEl, floatingLabelTextEl, underline, underlineFixed, errorTextEl, iconEl);
	    }
	});
	
	module.exports = TextField;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var KEY_BREWING_NOTES = 'cache_brewing_notes',
	    KEY_BREWING_NOTES_OPERATIONS = 'cache_brewing_notes_operations',
	    KEY_PACKAGING_NOTES = 'cache_packaging_notes',
	    KEY_PACKAGING_NOTES_OPERATIONS = 'cache_packaging_notes_operations',
	    ChronologycServiceCache,
	    _require = __webpack_require__(8),
	    filter = _require.filter,
	    Constants = __webpack_require__(2),
	    ContentUtils = __webpack_require__(7);
	
	
	ChronologycServiceCache = {
	
	    /**
	     * Add a new or change existing local brewing message.
	     * @param message
	     */
	    addBrewingNote: function addBrewingNote(newMessage) {
	        if (newMessage) {
	            var messageFilter = filter(this.getBrewingNotes(), function (message) {
	                return message.date !== newMessage.date;
	            });
	            messageFilter.push(newMessage);
	            this.setBrewingNotes(messageFilter);
	            return newMessage;
	        }
	    },
	
	    /**
	     * Add a new or change existing local pacakging message.
	     * @param message
	     */
	    addPackagingNote: function addPackagingNote(newMessage) {
	        if (newMessage) {
	            var messageFilter = filter(this.getPackagingNotes(), function (message) {
	                return message.date !== newMessage.date;
	            });
	            messageFilter.push(newMessage);
	            this.setPackagingNotes(messageFilter);
	            return newMessage;
	        }
	    },
	
	    /**
	     * Delete given message from local message.
	     * @param message
	     */
	    removeBrewingNote: function removeBrewingNote(newMessage) {
	        if (newMessage) {
	            var messageFilter = filter(this.getBrewingNotes(), function (message) {
	                return message.date !== newMessage.date;
	            });
	            this.setBrewingNotes(messageFilter);
	        }
	    },
	
	    /**
	     * Delete given message from local message.
	     * @param message
	     */
	    removePackagingNote: function removePackagingNote(newMessage) {
	        if (newMessage) {
	            var messageFilter = filter(this.getPackagingNotes(), function (message) {
	                return message.date !== newMessage.date;
	            });
	            this.setPackagingNotes(messageFilter);
	        }
	    },
	
	    /**
	     * Retrieve a brewing message by date.
	     * @param date
	     * @returns {*}
	     */
	    getBrewingNoteByDate: function getBrewingNoteByDate(date) {
	        return this.getBrewingNotes().filter(function (msg) {
	            return msg.date === date;
	        })[0];
	    },
	
	    /**
	     * Retrieve a packaging message by date.
	     * @param date
	     * @returns {*}
	     */
	    getPackagingNoteByDate: function getPackagingNoteByDate(date) {
	        return this.getPackagingNotes().filter(function (msg) {
	            return msg.date === date;
	        })[0];
	    },
	
	    /**
	     * Add a new brewing operation Note.
	     * @param operation
	     */
	    addBrewingOperation: function addBrewingOperation(operation) {
	        var operations = this.getBrewingOperations();
	        operation.indexOperation = operations.length + 1;
	        operations.push(operation);
	        this.setBrewingOperations(operations);
	    },
	
	    /**
	     * Add a new packaging operation Note.
	     * @param operation
	     */
	    addPackagingOperation: function addPackagingOperation(operation) {
	        var operations = this.getPackagingOperations();
	        operation.indexOperation = operations.length + 1;
	        operations.push(operation);
	        this.setPackagingOperations(operations);
	    },
	
	    /**
	     *  Load local cache notes. And then if exist pending operations pending, apply them to actual
	     *  local notes.
	     * @param {Array} brewingNotes
	     */
	    fillBrewingNoteCache: function fillBrewingNoteCache(brewingNotes) {
	        this.setBrewingNotes(brewingNotes);
	        var self = this,
	            pendingOperations = this.getBrewingOperations();
	
	        if (pendingOperations) {
	            // If have pending operations, means that after save notas to the server (polling way), during this process,
	            // the client did a new notes, that still are pending to save in the next polling save notes.
	
	            //Sort operations in chronologyc way
	            (pendingOperations || []).sort(this._prioritizeOperations);
	
	            [].forEach.call(pendingOperations, function (operation) {
	                switch (operation.typeOperation) {
	                    case Constants.NOTE_BREWING_OPERATION_NEW:
	                        self.addBrewingNote(operation.note);
	                        break;
	                    case Constants.NOTE_BREWING_OPERATION_CHANGE:
	                        self.addBrewingNote(operation.note);
	                        break;
	                    case Constants.NOTE_BREWING_OPERATION_DELETE:
	                        self.removeBrewingNote(operation.note);
	                        break;
	                    default:
	                }
	            });
	        }
	    },
	
	    /**
	     *  Load local cache notes. And then if exist pending operations pending, apply them to actual
	     *  local notes.
	     * @param {Array} packagingNotes
	     */
	    fillPackagingNoteCache: function fillPackagingNoteCache(packagingNotes) {
	        this.setPackagingNotes(packagingNotes);
	        var self = this,
	            pendingOperations = this.getPackagingOperations();
	
	        if (pendingOperations) {
	            // If have pending operations, means that after save notas to the server (polling way), during this process,
	            // the client did a new notes, that still are pending to save in the next polling save notes.
	
	            //Sort operations in chronologyc way
	            (pendingOperations || []).sort(this._prioritizeOperations);
	
	            [].forEach.call(pendingOperations, function (operation) {
	                switch (operation.typeOperation) {
	                    case Constants.NOTE_BREWING_OPERATION_NEW:
	                        self.addPackagingNote(operation.note);
	                        break;
	                    case Constants.NOTE_BREWING_OPERATION_CHANGE:
	                        self.addPackagingNote(operation.note);
	                        break;
	                    case Constants.NOTE_BREWING_OPERATION_DELETE:
	                        self.removePackagingNote(operation.note);
	                        break;
	                    default:
	                }
	            });
	        }
	    },
	
	    /**
	     * Sort operation from index operation number.
	     * @argument {Object} operationA
	     * @argument {Object} operationB
	     * @return {Number}
	     */
	    _prioritizeOperations: function _prioritizeOperations(operationA, operationB) {
	        return operationA.indexOperation - operationB.indexOperation;
	    },
	
	    /**
	     * Override current brewing local operations for defined by parameter.
	     * @param {Array} operations
	     */
	    setBrewingOperations: function setBrewingOperations(operations) {
	        ContentUtils.saveSession(KEY_BREWING_NOTES_OPERATIONS, operations);
	    },
	
	    /**
	     * Override current packaging local operations for defined by parameter.
	     * @param {Array} operations
	     */
	    setPackagingOperations: function setPackagingOperations(operations) {
	        ContentUtils.saveSession(KEY_PACKAGING_NOTES_OPERATIONS, operations);
	    },
	
	    /**
	     * Retrieve all the brewing operations.
	     */
	    getBrewingOperations: function getBrewingOperations() {
	        var operations = ContentUtils.getSession(KEY_BREWING_NOTES_OPERATIONS);
	        return operations === '' ? [] : operations;
	    },
	
	    /**
	     * Retrieve all the packaging operations.
	     */
	    getPackagingOperations: function getPackagingOperations() {
	        var operations = ContentUtils.getSession(KEY_PACKAGING_NOTES_OPERATIONS);
	        return operations === '' ? [] : operations;
	    },
	
	    /**
	     * Delete brewing operations performed.
	     * @param {Arrays} operationsSaved
	     */
	    deleteBrewingOperationPerformed: function deleteBrewingOperationPerformed(operationsSaved) {
	        var operations = this.getBrewingOperations(),
	            operationUpgraded;
	        operationUpgraded = filter(operations, function (operation) {
	            var filterOperation = false;
	            [].forEach.call(operationsSaved, function (operationSaved) {
	                if (operationSaved.indexOperation === operation.indexOperation) {
	                    filterOperation = true;
	                    return;
	                }
	            });
	            return !filterOperation;
	        });
	        this.setBrewingOperations(operationUpgraded);
	    },
	
	    /**
	     * Delete packaging operations performed.
	     * @param {Arrays} operationsSaved
	     */
	    deletePackagingOperationPerformed: function deletePackagingOperationPerformed(operationsSaved) {
	        var operations = this.getPackagingOperations(),
	            operationUpgraded;
	        operationUpgraded = filter(operations, function (operation) {
	            var filterOperation = false;
	            [].forEach.call(operationsSaved, function (operationSaved) {
	                if (operationSaved.indexOperation === operation.indexOperation) {
	                    filterOperation = true;
	                    return;
	                }
	            });
	            return !filterOperation;
	        });
	        this.setPackagingOperations(operationUpgraded);
	    },
	
	    /**
	     * Override current brewing local message for defined by parameter.
	     * @param messages
	     */
	    setBrewingNotes: function setBrewingNotes(messages) {
	        ContentUtils.saveSession(KEY_BREWING_NOTES, messages);
	    },
	
	    /**
	     * Override current packaging local message for defined by parameter.
	     * @param messages
	     */
	    setPackagingNotes: function setPackagingNotes(messages) {
	        ContentUtils.saveSession(KEY_PACKAGING_NOTES, messages);
	    },
	
	    /**
	     * Retrieve all brewing local message.
	     * @returns {*}
	     */
	    getBrewingNotes: function getBrewingNotes() {
	        var messagesRestore = ContentUtils.getSession(KEY_BREWING_NOTES);
	        return messagesRestore === '' ? [] : messagesRestore;
	    },
	
	    /**
	     * Retrieve all packaging local message.
	     * @returns {*}
	     */
	    getPackagingNotes: function getPackagingNotes() {
	        var messagesRestore = ContentUtils.getSession(KEY_PACKAGING_NOTES);
	        return messagesRestore === '' ? [] : messagesRestore;
	    }
	};
	
	module.exports = ChronologycServiceCache;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ContentUtils = __webpack_require__(7),
	    KEY_TANK = 'cache_tanks',
	    Notification = __webpack_require__(21),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _ = __webpack_require__(40);
	
	
	var DashboardLayoutStore = {
	
	    /**
	     * Contain the list of positions, at UI level, that indicate where the orders are renderer
	     * in the dashboard.
	     */
	    currentLayout: [],
	
	    getTankTypeByPositionX: function getTankTypeByPositionX(positionX) {
	        var tanks = ContentUtils.sortTanksAndAddColumn(ContentUtils.getSession(KEY_TANK)) || [];
	        var tankTarget = _.find(tanks, function (tank) {
	            return _.get(tank, 'column') === positionX;
	        });
	        return _.get(tankTarget, 'type');
	    },
	
	    /**
	     * Update single position in the layout, remove old position and put the new one.
	     * @param {Object} newPosition the position that will be updated in the dashboard.
	     */
	    updateSingleLayoutPosition: function updateSingleLayoutPosition(newPosition) {
	        var newLayout = this.currentLayout.filter(function (box) {
	            return ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(newPosition.i);
	        }.bind(this));
	        this.currentLayout = newLayout;
	        this.currentLayout.push(newPosition);
	    },
	    removeByOrderId: function removeByOrderId(orderId) {
	        this.currentLayout = _.filter(this.currentLayout, function (position) {
	            return ContentUtils.cleanId(position.i) !== ContentUtils.cleanId(orderId);
	        });
	    },
	    push: function push(position) {
	        this.currentLayout.push(position);
	    },
	    getLayout: function getLayout() {
	        return this.currentLayout;
	    },
	    setLayout: function setLayout(newLayout) {
	        this.currentLayout = newLayout;
	    },
	    cleanLayout: function cleanLayout() {
	        this.currentLayout = [];
	    },
	
	
	    /**
	     * Update position in the layout, remove old position and put the new one.
	     * @param {Object} newPosition the position that will be updated in the dashboard.
	     * @param {Object} newPositionTwo the position that will be updated in the dashboard.
	     */
	    updateLayoutPosition: function updateLayoutPosition(newPosition, newPositionTwo) {
	        if (newPosition && newPositionTwo) {
	            this.currentLayout = _.filter(this.currentLayout, function (box) {
	                return ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(newPosition.i);
	            });
	            this.currentLayout.push(newPosition);
	            this.currentLayout.push(newPositionTwo);
	        }
	    },
	
	
	    /**
	     * Update positions in the layout, remove old position and put the new one.
	     */
	    updateLayoutPositions: function updateLayoutPositions() {
	        var _arguments = arguments,
	            _this = this;
	
	        var amountPositions = _.get(arguments, 'length', 0);
	        if (amountPositions > 0) {
	            // remove all old positions
	            this.currentLayout = _.filter(this.currentLayout, function (box) {
	                return ContentUtils.cleanId(box.i) !== ContentUtils.cleanId(_arguments[0].i);
	            });
	            // add all new given positions
	            var positions = _.flatten(arguments);
	
	            _.forEach(positions, function (newPosition) {
	                _this.currentLayout.push(newPosition);
	            });
	        }
	    },
	    updateLayoutPositionBySpecificId: function updateLayoutPositionBySpecificId(newPosition) {
	        if (newPosition) {
	            this.currentLayout = _.filter(this.currentLayout, function (box) {
	                return box.i !== newPosition.i;
	            });
	            this.currentLayout.push(newPosition);
	        }
	    },
	    setAsRelocatedPositions: function setAsRelocatedPositions(batchNumber) {
	        var positionsBatch = _.filter(this.currentLayout, function (position) {
	            return position.batchNumber === batchNumber;
	        });
	        var positionBatchUpdated = _.map(positionsBatch, function (position) {
	            position.isRelocated = true;
	            return position;
	        });
	
	        for (var _iterator = positionBatchUpdated, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var position = _ref;
	
	            this.updateLayoutPositionBySpecificId(position);
	        }
	    },
	    resetAllPositionAsRelocatedDone: function resetAllPositionAsRelocatedDone(batchNumber) {
	        var positionsBatch = _.filter(this.currentLayout, function (position) {
	            return position.batchNumber === batchNumber;
	        });
	        var positionBatchUpdated = _.map(positionsBatch, function (position) {
	            position.isRelocated = false;
	            return position;
	        });
	
	        for (var _iterator2 = positionBatchUpdated, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	            var _ref2;
	
	            if (_isArray2) {
	                if (_i2 >= _iterator2.length) break;
	                _ref2 = _iterator2[_i2++];
	            } else {
	                _i2 = _iterator2.next();
	                if (_i2.done) break;
	                _ref2 = _i2.value;
	            }
	
	            var position = _ref2;
	
	            this.updateLayoutPositionBySpecificId(position);
	        }
	    },
	
	
	    /**
	     * Check against to dashboard layout if given <code>positionNew</code> produce collisions with another. In case that
	     * exist collisions return the information about which order collision against given <code>positionNew</code>.
	     *
	     * @param {Object} positionNew          The position that will be checked against the current dashboard layout.
	     * @param {Array}  dashboardLayout      (Optionally) The override layout dashboard. (by default we take the current dashboard layout)
	     * @return {Array} Return the array of collisions positions.
	     */
	    getRangeCollisions: function getRangeCollisions(positionNew) {
	        var _this2 = this;
	
	        var layoutConsumer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLayout();
	
	        // Filter only the boxes that are in the column(`positionNew.x`) that we need to check.
	        var boxesToValidate = _.filter(layoutConsumer, function (item) {
	            // Filter conditions:
	            // 1) Check if the position is a brewhouse batch.
	            //      A) True: ask if are already re-located the brewhouse batch.
	            //          A.1) Is already re-located, means that position whould take as ocuppied position.
	            //          A.2) Is not already re-located, means that position are still free.
	            // 2) The position is not brewhouse so:
	            //      A) Check if the X (column of layout of dashboard) are the column that we want to filter,
	            //      B) Check that are different position that currently try to find their collision. (Eg: is not valid
	            //          collision if taking care the same order that try to find the collision).
	            //      C) Check also that don't want to take as a collision orders which orders with the same batch number,
	            //         because, if we have 2 order with same batch number, and are just in the same line, allways we recalculate
	            //         one of the other to another 'empty' position
	            var isBrewhouseBatch = ContentUtils.isBHBatch(item.i);
	
	            if (isBrewhouseBatch && item.isRelocated) {
	                return item.x === positionNew.x && ContentUtils.cleanId(item.i) !== ContentUtils.cleanId(positionNew.i);
	            }
	
	            return item.x === positionNew.x && ContentUtils.cleanId(item.i) !== ContentUtils.cleanId(positionNew.i) && _this2.isDifferentBatchNumber(item.batchNumber, positionNew.batchNumber);
	        }),
	            ranges = void 0,
	            rangeNew = void 0,
	            conflictRanges = void 0;
	
	        if (boxesToValidate && boxesToValidate.length === 0) {
	            return [];
	        }
	
	        ranges = this.getExistingRanges(boxesToValidate);
	
	        rangeNew = {
	            from: positionNew.y,
	            to: positionNew.h + positionNew.y - 1,
	            i: positionNew.i
	        };
	
	        conflictRanges = [];
	
	        _.forEach(ranges, function (obj) {
	            if (rangeNew.from <= obj.to && rangeNew.to >= obj.from) {
	                conflictRanges.push({
	                    rangeNew: rangeNew,
	                    rangeConflict: obj
	                });
	            }
	        });
	
	        return conflictRanges;
	    },
	    isDifferentBatchNumber: function isDifferentBatchNumber(batchNumberOne, batchNumberTwo) {
	        var batchNumberOneText = String(batchNumberOne);
	        var batchNumberTwoText = String(batchNumberTwo);
	
	        if (batchNumberOneText === 'undefined' || batchNumberTwoText === 'undefined') {
	            return true;
	        }
	
	        return batchNumberOneText !== batchNumberTwoText;
	    },
	
	
	    /**
	     * Check if the given position have available space in the dashboard.
	     * @param {Object} positionNew   The position that will be validate their availability space.
	     * @return {Boolean}
	     */
	    isEmpty: function isEmpty(positionNew) {
	        var layoutConsumer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLayout();
	
	        var conflicRanges = this.getRangeCollisions(positionNew, layoutConsumer);
	        return conflicRanges.length === 0;
	    },
	
	
	    /**
	     * Validate if the order have an empty position in the dashboard.
	     * @param {Object} order that will be under validation of
	     *                          availability space on the dashboard.
	     */
	    isEmptyPositions: function isEmptyPositions(order, positionBriteTank, positionFermenterTank) {
	        if (!this.isEmpty(positionBriteTank)) {
	            Notification.show(t('dashboard_notification_brite_tank_position_occupied'));
	            return false;
	        }
	
	        if (!this.isEmpty(positionFermenterTank)) {
	            Notification.show(t('dashboard_notification_tank_position_occupied'));
	            return false;
	        }
	
	        return true;
	    },
	    getExistingRanges: function getExistingRanges(boxes) {
	        return _.map(boxes, function (box) {
	            return {
	                from: box.y,
	                to: box.y + box.h - 1,
	                id: box.i
	            };
	        });
	    },
	
	
	    /**
	     * There is not way to be valid to change high and y (vertical position) at the same time.
	     * @param positionNew
	     * @param positionOld
	     * @returns {boolean|boolean}
	     */
	    isInvalidMovement: function isInvalidMovement(positionNew, positionOld) {
	        var isDifferentY = _.get(positionNew, 'y') !== _.get(positionOld, 'y');
	        var isDifferentH = _.get(positionNew, 'h') !== _.get(positionOld, 'h');
	        return isDifferentH && isDifferentY;
	    }
	};
	
	module.exports = DashboardLayoutStore;

/***/ },
/* 109 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(78);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the array-like object.
	 */
	function baseCastFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = baseCastFunction;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27),
	    stringToPath = __webpack_require__(474);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function baseCastPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	module.exports = baseCastPath;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(318),
	    arrayIncludes = __webpack_require__(319),
	    arrayIncludesWith = __webpack_require__(320),
	    cacheHas = __webpack_require__(339),
	    createSet = __webpack_require__(870),
	    setToArray = __webpack_require__(206);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 114 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 115 */
/***/ function(module, exports) {

	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[++resIndex] = index;
	    }
	  }
	  return result;
	}
	
	module.exports = replaceHolders;


/***/ },
/* 116 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return string.match(reComplexSymbol);
	}
	
	module.exports = stringToArray;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	
	var FontIcon = React.createClass({
	  displayName: 'FontIcon',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    color: React.PropTypes.string,
	    hoverColor: React.PropTypes.string,
	    onMouseLeave: React.PropTypes.func,
	    onMouseEnter: React.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var hoverColor = _props.hoverColor;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	
	    var spacing = this.context.muiTheme.spacing;
	    var offColor = color ? color : style && style.color ? style.color : this.context.muiTheme.palette.textColor;
	    var onColor = hoverColor ? hoverColor : offColor;
	
	    var mergedStyles = this.mergeAndPrefix({
	      position: 'relative',
	      fontSize: spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: Transitions.easeOut()
	    }, style, {
	      color: this.state.hovered ? onColor : offColor
	    });
	
	    return React.createElement('span', _extends({}, other, {
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      style: mergedStyles }));
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    // hover is needed only when a hoverColor is defined
	    if (this.props.hoverColor !== undefined) this.setState({ hovered: false });
	    if (this.props.onMouseLeave) {
	      this.props.onMouseLeave(e);
	    }
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    // hover is needed only when a hoverColor is defined
	    if (this.props.hoverColor !== undefined) this.setState({ hovered: true });
	    if (this.props.onMouseEnter) {
	      this.props.onMouseEnter(e);
	    }
	  }
	});
	
	module.exports = FontIcon;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var Colors = __webpack_require__(56);
	
	var Typography = function Typography() {
	  _classCallCheck(this, Typography);
	
	  // text colors
	  this.textFullBlack = Colors.fullBlack;
	  this.textDarkBlack = Colors.darkBlack;
	  this.textLightBlack = Colors.lightBlack;
	  this.textMinBlack = Colors.minBlack;
	  this.textFullWhite = Colors.fullWhite;
	  this.textDarkWhite = Colors.darkWhite;
	  this.textLightWhite = Colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	module.exports = new Typography();

/***/ },
/* 120 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  addDays: function addDays(d, days) {
	    var newDate = this.clone(d);
	    newDate.setDate(d.getDate() + days);
	    return newDate;
	  },
	
	  addMonths: function addMonths(d, months) {
	    var newDate = this.clone(d);
	    newDate.setMonth(d.getMonth() + months);
	    return newDate;
	  },
	
	  addYears: function addYears(d, years) {
	    var newDate = this.clone(d);
	    newDate.setFullYear(d.getFullYear() + years);
	    return newDate;
	  },
	
	  clone: function clone(d) {
	    return new Date(d.getTime());
	  },
	
	  cloneAsDate: function cloneAsDate(d) {
	    var clonedDate = this.clone(d);
	    clonedDate.setHours(0, 0, 0, 0);
	    return clonedDate;
	  },
	
	  getDaysInMonth: function getDaysInMonth(d) {
	    var resultDate = this.getFirstDayOfMonth(d);
	
	    resultDate.setMonth(resultDate.getMonth() + 1);
	    resultDate.setDate(resultDate.getDate() - 1);
	
	    return resultDate.getDate();
	  },
	
	  getFirstDayOfMonth: function getFirstDayOfMonth(d) {
	    return new Date(d.getFullYear(), d.getMonth(), 1);
	  },
	
	  getFullMonth: function getFullMonth(d) {
	    var month = d.getMonth();
	    switch (month) {
	      case 0:
	        return 'January';
	      case 1:
	        return 'February';
	      case 2:
	        return 'March';
	      case 3:
	        return 'April';
	      case 4:
	        return 'May';
	      case 5:
	        return 'June';
	      case 6:
	        return 'July';
	      case 7:
	        return 'August';
	      case 8:
	        return 'September';
	      case 9:
	        return 'October';
	      case 10:
	        return 'November';
	      case 11:
	        return 'December';
	    }
	  },
	
	  getShortMonth: function getShortMonth(d) {
	    var month = d.getMonth();
	    switch (month) {
	      case 0:
	        return 'Jan';
	      case 1:
	        return 'Feb';
	      case 2:
	        return 'Mar';
	      case 3:
	        return 'Apr';
	      case 4:
	        return 'May';
	      case 5:
	        return 'Jun';
	      case 6:
	        return 'Jul';
	      case 7:
	        return 'Aug';
	      case 8:
	        return 'Sep';
	      case 9:
	        return 'Oct';
	      case 10:
	        return 'Nov';
	      case 11:
	        return 'Dec';
	    }
	  },
	
	  getDayOfWeek: function getDayOfWeek(d) {
	    var dow = d.getDay();
	    switch (dow) {
	      case 0:
	        return 'Sun';
	      case 1:
	        return 'Mon';
	      case 2:
	        return 'Tue';
	      case 3:
	        return 'Wed';
	      case 4:
	        return 'Thu';
	      case 5:
	        return 'Fri';
	      case 6:
	        return 'Sat';
	    }
	  },
	
	  getWeekArray: function getWeekArray(d) {
	    var dayArray = [];
	    var daysInMonth = this.getDaysInMonth(d);
	    var daysInWeek = undefined;
	    var emptyDays = undefined;
	    var firstDayOfWeek = undefined;
	    var week = undefined;
	    var weekArray = [];
	
	    for (var i = 1; i <= daysInMonth; i++) {
	      dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	    }
	
	    while (dayArray.length) {
	      firstDayOfWeek = dayArray[0].getDay();
	      daysInWeek = 7 - firstDayOfWeek;
	      emptyDays = 7 - daysInWeek;
	      week = dayArray.splice(0, daysInWeek);
	
	      for (var i = 0; i < emptyDays; i++) {
	        week.unshift(null);
	      }
	
	      weekArray.push(week);
	    }
	
	    return weekArray;
	  },
	
	  format: function format(date) {
	    var m = date.getMonth() + 1;
	    var d = date.getDate();
	    var y = date.getFullYear();
	    return m + '/' + d + '/' + y;
	  },
	
	  isEqualDate: function isEqualDate(d1, d2) {
	    return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	  },
	
	  isBeforeDate: function isBeforeDate(d1, d2) {
	    var date1 = this.cloneAsDate(d1);
	    var date2 = this.cloneAsDate(d2);
	
	    return date1.getTime() < date2.getTime();
	  },
	
	  isAfterDate: function isAfterDate(d1, d2) {
	    var date1 = this.cloneAsDate(d1);
	    var date2 = this.cloneAsDate(d2);
	
	    return date1.getTime() > date2.getTime();
	  },
	
	  isBetweenDates: function isBetweenDates(dateToCheck, startDate, endDate) {
	    return !this.isBeforeDate(dateToCheck, startDate) && !this.isAfterDate(dateToCheck, endDate);
	  },
	
	  isDateObject: function isDateObject(d) {
	    return d instanceof Date;
	  },
	
	  monthDiff: function monthDiff(d1, d2) {
	    var m = undefined;
	    m = (d1.getFullYear() - d2.getFullYear()) * 12;
	    m += d1.getMonth();
	    m -= d2.getMonth();
	    return m;
	  },
	
	  yearDiff: function yearDiff(d1, d2) {
	    return ~ ~(this.monthDiff(d1, d2) / 12);
	  }
	
	};

/***/ },
/* 121 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  once: function once(el, type, callback) {
	    var typeArray = type.split(' ');
	    var recursiveFunction = function recursiveFunction(e) {
	      e.target.removeEventListener(e.type, recursiveFunction);
	      return callback(e);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	
	  isKeyboard: function isKeyboard(e) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(e.type) !== -1;
	  }
	};

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	var PathUtils = __webpack_require__(374);
	
	var _currentRoute;
	
	var Route = (function () {
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  _createClass(Route, {
	    appendChild: {
	
	      /**
	       * Appends the given route to this route's child routes.
	       */
	
	      value: function appendChild(route) {
	        invariant(route instanceof Route, "route.appendChild must use a valid Route");
	
	        if (!this.childRoutes) this.childRoutes = [];
	
	        this.childRoutes.push(route);
	      }
	    },
	    toString: {
	      value: function toString() {
	        var string = "<Route";
	
	        if (this.name) string += " name=\"" + this.name + "\"";
	
	        string += " path=\"" + this.path + "\">";
	
	        return string;
	      }
	    }
	  }, {
	    createRoute: {
	
	      /**
	       * Creates and returns a new route. Options may be a URL pathname string
	       * with placeholders for named params or an object with any of the following
	       * properties:
	       *
	       * - name                     The name of the route. This is used to lookup a
	       *                            route relative to its parent route and should be
	       *                            unique among all child routes of the same parent
	       * - path                     A URL pathname string with optional placeholders
	       *                            that specify the names of params to extract from
	       *                            the URL when the path matches. Defaults to `/${name}`
	       *                            when there is a name given, or the path of the parent
	       *                            route, or /
	       * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	       *                            the scroll behavior of the router
	       * - isDefault                True to make this route the default route among all
	       *                            its siblings
	       * - isNotFound               True to make this route the "not found" route among
	       *                            all its siblings
	       * - onEnter                  A transition hook that will be called when the
	       *                            router is going to enter this route
	       * - onLeave                  A transition hook that will be called when the
	       *                            router is going to leave this route
	       * - handler                  A React component that will be rendered when
	       *                            this route is active
	       * - parentRoute              The parent route to use for this route. This option
	       *                            is automatically supplied when creating routes inside
	       *                            the callback to another invocation of createRoute. You
	       *                            only ever need to use this when declaring routes
	       *                            independently of one another to manually piece together
	       *                            the route hierarchy
	       *
	       * The callback may be used to structure your route hierarchy. Any call to
	       * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	       * inside the callback automatically uses this route as its parent.
	       */
	
	      value: function createRoute(options, callback) {
	        options = options || {};
	
	        if (typeof options === "string") options = { path: options };
	
	        var parentRoute = _currentRoute;
	
	        if (parentRoute) {
	          warning(options.parentRoute == null || options.parentRoute === parentRoute, "You should not use parentRoute with createRoute inside another route's child callback; it is ignored");
	        } else {
	          parentRoute = options.parentRoute;
	        }
	
	        var name = options.name;
	        var path = options.path || name;
	
	        if (path && !(options.isDefault || options.isNotFound)) {
	          if (PathUtils.isAbsolute(path)) {
	            if (parentRoute) {
	              invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, "You cannot nest path \"%s\" inside \"%s\"; the parent requires URL parameters", path, parentRoute.path);
	            }
	          } else if (parentRoute) {
	            // Relative paths extend their parent.
	            path = PathUtils.join(parentRoute.path, path);
	          } else {
	            path = "/" + path;
	          }
	        } else {
	          path = parentRoute ? parentRoute.path : "/";
	        }
	
	        if (options.isNotFound && !/\*$/.test(path)) path += "*"; // Auto-append * to the path of not found routes.
	
	        var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	        if (parentRoute) {
	          if (route.isDefault) {
	            invariant(parentRoute.defaultRoute == null, "%s may not have more than one default route", parentRoute);
	
	            parentRoute.defaultRoute = route;
	          } else if (route.isNotFound) {
	            invariant(parentRoute.notFoundRoute == null, "%s may not have more than one not found route", parentRoute);
	
	            parentRoute.notFoundRoute = route;
	          }
	
	          parentRoute.appendChild(route);
	        }
	
	        // Any routes created in the callback
	        // use this route as their parent.
	        if (typeof callback === "function") {
	          var currentRoute = _currentRoute;
	          _currentRoute = route;
	          callback.call(route, route);
	          _currentRoute = currentRoute;
	        }
	
	        return route;
	      }
	    },
	    createDefaultRoute: {
	
	      /**
	       * Creates and returns a route that is rendered when its parent matches
	       * the current URL.
	       */
	
	      value: function createDefaultRoute(options) {
	        return Route.createRoute(assign({}, options, { isDefault: true }));
	      }
	    },
	    createNotFoundRoute: {
	
	      /**
	       * Creates and returns a route that is rendered when its parent matches
	       * the current URL but none of its siblings do.
	       */
	
	      value: function createNotFoundRoute(options) {
	        return Route.createRoute(assign({}, options, { isNotFound: true }));
	      }
	    },
	    createRedirect: {
	
	      /**
	       * Creates and returns a route that automatically redirects the transition
	       * to another route. In addition to the normal options to createRoute, this
	       * function accepts the following options:
	       *
	       * - from         An alias for the `path` option. Defaults to *
	       * - to           The path/route/route name to redirect to
	       * - params       The params to use in the redirect URL. Defaults
	       *                to using the current params
	       * - query        The query to use in the redirect URL. Defaults
	       *                to using the current query
	       */
	
	      value: function createRedirect(options) {
	        return Route.createRoute(assign({}, options, {
	          path: options.path || options.from || "*",
	          onEnter: function onEnter(transition, params, query) {
	            transition.redirect(options.to, options.params || params, options.query || query);
	          }
	        }));
	      }
	    }
	  });
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	/*jslint bitwise: true */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function(domPropertyConfig) {
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(
	        domPropertyConfig.isCustomAttribute
	      );
	    }
	
	    for (var propName in Properties) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        !DOMProperty.isStandardName.hasOwnProperty(propName),
	        'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' +
	        '\'%s\' which has already been injected. You may be accidentally ' +
	        'injecting the same DOM property config twice, or you may be ' +
	        'injecting two configs that have conflicting property names.',
	        propName
	      ) : invariant(!DOMProperty.isStandardName.hasOwnProperty(propName)));
	
	      DOMProperty.isStandardName[propName] = true;
	
	      var lowerCased = propName.toLowerCase();
	      DOMProperty.getPossibleStandardName[lowerCased] = propName;
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        DOMProperty.getPossibleStandardName[attributeName] = propName;
	        DOMProperty.getAttributeName[propName] = attributeName;
	      } else {
	        DOMProperty.getAttributeName[propName] = lowerCased;
	      }
	
	      DOMProperty.getPropertyName[propName] =
	        DOMPropertyNames.hasOwnProperty(propName) ?
	          DOMPropertyNames[propName] :
	          propName;
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        DOMProperty.getMutationMethod[propName] = DOMMutationMethods[propName];
	      } else {
	        DOMProperty.getMutationMethod[propName] = null;
	      }
	
	      var propConfig = Properties[propName];
	      DOMProperty.mustUseAttribute[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_ATTRIBUTE);
	      DOMProperty.mustUseProperty[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_PROPERTY);
	      DOMProperty.hasSideEffects[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_SIDE_EFFECTS);
	      DOMProperty.hasBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_BOOLEAN_VALUE);
	      DOMProperty.hasNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_NUMERIC_VALUE);
	      DOMProperty.hasPositiveNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_POSITIVE_NUMERIC_VALUE);
	      DOMProperty.hasOverloadedBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_OVERLOADED_BOOLEAN_VALUE);
	
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        !DOMProperty.mustUseAttribute[propName] ||
	          !DOMProperty.mustUseProperty[propName],
	        'DOMProperty: Cannot require using both attribute and property: %s',
	        propName
	      ) : invariant(!DOMProperty.mustUseAttribute[propName] ||
	        !DOMProperty.mustUseProperty[propName]));
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        DOMProperty.mustUseProperty[propName] ||
	          !DOMProperty.hasSideEffects[propName],
	        'DOMProperty: Properties that have side effects must use property: %s',
	        propName
	      ) : invariant(DOMProperty.mustUseProperty[propName] ||
	        !DOMProperty.hasSideEffects[propName]));
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        !!DOMProperty.hasBooleanValue[propName] +
	          !!DOMProperty.hasNumericValue[propName] +
	          !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1,
	        'DOMProperty: Value can be one of boolean, overloaded boolean, or ' +
	        'numeric value, but not a combination: %s',
	        propName
	      ) : invariant(!!DOMProperty.hasBooleanValue[propName] +
	        !!DOMProperty.hasNumericValue[propName] +
	        !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1));
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Checks whether a property name is a standard property.
	   * @type {Object}
	   */
	  isStandardName: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties.
	   * @type {Object}
	   */
	  getPossibleStandardName: {},
	
	  /**
	   * Mapping from normalized names to attribute names that differ. Attribute
	   * names are used when rendering markup or with `*Attribute()`.
	   * @type {Object}
	   */
	  getAttributeName: {},
	
	  /**
	   * Mapping from normalized names to properties on DOM node instances.
	   * (This includes properties that mutate due to external factors.)
	   * @type {Object}
	   */
	  getPropertyName: {},
	
	  /**
	   * Mapping from normalized names to mutation methods. This will only exist if
	   * mutation cannot be set simply by the property or `setAttribute()`.
	   * @type {Object}
	   */
	  getMutationMethod: {},
	
	  /**
	   * Whether the property must be accessed and mutated as an object property.
	   * @type {Object}
	   */
	  mustUseAttribute: {},
	
	  /**
	   * Whether the property must be accessed and mutated using `*Attribute()`.
	   * (This includes anything that fails `<propName> in <element>`.)
	   * @type {Object}
	   */
	  mustUseProperty: {},
	
	  /**
	   * Whether or not setting a value causes side effects such as triggering
	   * resources to be loaded or text selection changes. We must ensure that
	   * the value is only set if it has changed.
	   * @type {Object}
	   */
	  hasSideEffects: {},
	
	  /**
	   * Whether the property should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasBooleanValue: {},
	
	  /**
	   * Whether the property must be numeric or parse as a
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasNumericValue: {},
	
	  /**
	   * Whether the property must be positive numeric or parse as a positive
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasPositiveNumericValue: {},
	
	  /**
	   * Whether the property can be used as a flag as well as with a value. Removed
	   * when strictly equal to false; present without a value when strictly equal
	   * to true; present with a value otherwise.
	   * @type {Object}
	   */
	  hasOverloadedBooleanValue: {},
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function(nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(662);
	var EventPluginUtils = __webpack_require__(218);
	
	var accumulateInto = __webpack_require__(387);
	var forEachAccumulated = __webpack_require__(388);
	var invariant = __webpack_require__(15);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @private
	 */
	var executeDispatchesAndRelease = function(event) {
	  if (event) {
	    var executeDispatch = EventPluginUtils.executeDispatch;
	    // Plugins can provide custom behavior when dispatching events.
	    var PluginModule = EventPluginRegistry.getPluginModuleForEvent(event);
	    if (PluginModule && PluginModule.executeDispatch) {
	      executeDispatch = PluginModule.executeDispatch;
	    }
	    EventPluginUtils.executeDispatchesInOrder(event, executeDispatch);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid =
	    InstanceHandle &&
	    InstanceHandle.traverseTwoPhase &&
	    InstanceHandle.traverseEnterLeave;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    valid,
	    'InstanceHandle not injected before use!'
	  ) : invariant(valid));
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function(InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function() {
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function(id, registrationName, listener) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !listener || typeof listener === 'function',
	      'Expected %s listener to be a function, instead got type %s',
	      registrationName, typeof listener
	    ) : invariant(!listener || typeof listener === 'function'));
	
	    var bankForRegistrationName =
	      listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function(id) {
	    for (var registrationName in listenerBank) {
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0, l = plugins.length; i < l; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(
	          topLevelType,
	          topLevelTarget,
	          topLevelTargetID,
	          nativeEvent
	        );
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function() {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    forEachAccumulated(processingEventQueue, executeDispatchesAndRelease);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !eventQueue,
	      'processEventQueue(): Additional events were enqueued while processing ' +
	      'an event queue. Support for this has not yet been implemented.'
	    ) : invariant(!eventQueue));
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function() {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function() {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPluginHub = __webpack_require__(124);
	
	var accumulateInto = __webpack_require__(387);
	var forEachAccumulated = __webpack_require__(388);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName =
	    event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    if (!domID) {
	      throw new Error('Dispatching id must not be null');
	    }
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners =
	      accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We can not perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(
	      event.dispatchMarker,
	      accumulateDirectionalDispatches,
	      event
	    );
	  }
	}
	
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners =
	        accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(
	    fromID,
	    toID,
	    accumulateDispatches,
	    leave,
	    enter
	  );
	}
	
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var EventPluginUtils = __webpack_require__(218);
	var ReactChildren = __webpack_require__(663);
	var ReactComponent = __webpack_require__(664);
	var ReactClass = __webpack_require__(69);
	var ReactContext = __webpack_require__(381);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactElement = __webpack_require__(38);
	var ReactElementValidator = __webpack_require__(174);
	var ReactDOM = __webpack_require__(1241);
	var ReactDOMTextComponent = __webpack_require__(667);
	var ReactDefaultInjection = __webpack_require__(1252);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactMount = __webpack_require__(75);
	var ReactPerf = __webpack_require__(103);
	var ReactPropTypes = __webpack_require__(672);
	var ReactReconciler = __webpack_require__(150);
	var ReactServerRendering = __webpack_require__(1264);
	
	var assign = __webpack_require__(25);
	var findDOMNode = __webpack_require__(677);
	var onlyChild = __webpack_require__(685);
	
	ReactDefaultInjection.inject();
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    only: onlyChild
	  },
	  Component: ReactComponent,
	  DOM: ReactDOM,
	  PropTypes: ReactPropTypes,
	  initializeTouchEvents: function(shouldUseTouch) {
	    EventPluginUtils.useTouchEvents = shouldUseTouch;
	  },
	  createClass: ReactClass.createClass,
	  createElement: createElement,
	  cloneElement: cloneElement,
	  createFactory: createFactory,
	  createMixin: function(mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	  constructAndRenderComponent: ReactMount.constructAndRenderComponent,
	  constructAndRenderComponentByID: ReactMount.constructAndRenderComponentByID,
	  findDOMNode: findDOMNode,
	  render: render,
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  isValidElement: ReactElement.isValidElement,
	  withContext: ReactContext.withContext,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  var ExecutionEnvironment = __webpack_require__(44);
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // If we're in Chrome, look for the devtools marker and provide a download
	    // link if not installed.
	    if (navigator.userAgent.indexOf('Chrome') > -1) {
	      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	        console.debug(
	          'Download the React DevTools for a better development experience: ' +
	          'https://fb.me/react-devtools'
	        );
	      }
	    }
	
	    var expectedFeatures = [
	      // shims
	      Array.isArray,
	      Array.prototype.every,
	      Array.prototype.forEach,
	      Array.prototype.indexOf,
	      Array.prototype.map,
	      Date.now,
	      Function.prototype.bind,
	      Object.keys,
	      String.prototype.split,
	      String.prototype.trim,
	
	      // shams
	      Object.create,
	      Object.freeze
	    ];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error(
	          'One or more ES5 shim/shams expected by React are not available: ' +
	          'https://fb.me/react-warning-polyfills'
	        );
	        break;
	      }
	    }
	  }
	}
	
	React.version = '0.13.3';
	
	module.exports = React;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPluginHub = __webpack_require__(124);
	var EventPluginRegistry = __webpack_require__(662);
	var ReactEventEmitterMixin = __webpack_require__(1255);
	var ViewportMetrics = __webpack_require__(386);
	
	var assign = __webpack_require__(25);
	var isEventSupported = __webpack_require__(393);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topBlur: 'blur',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topScroll: 'scroll',
	  topSelectionChange: 'selectionchange',
	  topTextInput: 'textInput',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(
	        ReactBrowserEventEmitter.handleTopLevel
	      );
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function() {
	    return !!(
	      (ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled())
	    );
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.
	      registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0, l = dependencies.length; i < l; i++) {
	      var dependency = dependencies[i];
	      if (!(
	            (isListening.hasOwnProperty(dependency) && isListening[dependency])
	          )) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'wheel',
	              mountAt
	            );
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'mousewheel',
	              mountAt
	            );
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'DOMMouseScroll',
	              mountAt
	            );
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              mountAt
	            );
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE
	            );
	          }
	        } else if (dependency === topLevelTypes.topFocus ||
	            dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topFocus,
	              'focus',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topBlur,
	              'blur',
	              mountAt
	            );
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topFocus,
	              'focusin',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topBlur,
	              'focusout',
	              mountAt
	            );
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	            dependency,
	            topEventMapping[dependency],
	            mountAt
	          );
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function() {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	module.exports = ReactBrowserEventEmitter;


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(674);
	
	var invariant = __webpack_require__(15);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 100;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || (
	    id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR
	  );
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return (
	    descendantID.indexOf(ancestorID) === 0 &&
	    isBoundary(descendantID, ancestorID.length)
	  );
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    isValidID(ancestorID) && isValidID(destinationID),
	    'getNextDescendantID(%s, %s): Received an invalid React DOM ID.',
	    ancestorID,
	    destinationID
	  ) : invariant(isValidID(ancestorID) && isValidID(destinationID)));
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    isAncestorIDOf(ancestorID, destinationID),
	    'getNextDescendantID(...): React has made an invalid assumption about ' +
	    'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.',
	    ancestorID,
	    destinationID
	  ) : invariant(isAncestorIDOf(ancestorID, destinationID)));
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    isValidID(longestCommonID),
	    'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s',
	    oneID,
	    twoID,
	    longestCommonID
	  ) : invariant(isValidID(longestCommonID)));
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    start !== stop,
	    'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.',
	    start
	  ) : invariant(start !== stop));
	  var traverseUp = isAncestorIDOf(stop, start);
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    traverseUp || isAncestorIDOf(start, stop),
	    'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' +
	    'not have a parent path.',
	    start,
	    stop
	  ) : invariant(traverseUp || isAncestorIDOf(start, stop)));
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start; /* until break */; id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      depth++ < MAX_TREE_DEPTH,
	      'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' +
	      'traversing the React DOM ID tree. This may be due to malformed IDs: %s',
	      start, stop
	    ) : invariant(depth++ < MAX_TREE_DEPTH));
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function() {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function(rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function(id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function(leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function(targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function(targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;


/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function(key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function(key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function(key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function(key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(690);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    SessionStore = __webpack_require__(11),
	    _require2 = __webpack_require__(79),
	    kebabCase = _require2.kebabCase,
	    UserPermissionStore = __webpack_require__(184),
	    _require3 = __webpack_require__(8),
	    filter = _require3.filter,
	    map = _require3.map,
	    _require4 = __webpack_require__(511),
	    uniqueId = _require4.uniqueId,
	    _require5 = __webpack_require__(12),
	    IconButton = _require5.IconButton,
	    FontIcon = _require5.FontIcon,
	    _require6 = __webpack_require__(19),
	    Navigation = _require6.Navigation,
	    BasicFormChange = __webpack_require__(398);
	
	
	var AdminScaffoldingGeneric = React.createClass({ displayName: "AdminScaffoldingGeneric",
	
	    mixins: [Navigation],
	
	    propTypes: {
	        additionalSubmitValue: PropTypes.object,
	        additionalPreSubmitValidation: PropTypes.func,
	        addEnterKeyDown: PropTypes.func,
	        breadcrumb: PropTypes.array,
	        contextHolder: PropTypes.object,
	        customClassName: PropTypes.string,
	        fetchItems: PropTypes.func,
	        headerFields: function headerFields(props, propName) {
	            var fields = props[propName];
	            React.Children.forEach(fields, function (child) {
	                if (kebabCase(child.type.displayName).indexOf('form-group') === -1) {
	                    throw new Error('The children must be a `form-group` component.');
	                }
	            });
	        },
	        module: PropTypes.string,
	        messages: PropTypes.object,
	        onAdd: PropTypes.func.isRequired,
	        onChange: PropTypes.func.isRequired,
	        onDelete: PropTypes.func, // is an optional functionality
	        onCancel: PropTypes.func.isRequired,
	        title: PropTypes.string,
	        additionalButtons: PropTypes.array,
	        value: PropTypes.object,
	        moduleName: PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isValid: true
	        };
	    },
	    goToHistory: function goToHistory() {
	        this.transitionTo('/history?selected-module=:module', {
	            module: this.props.module
	        });
	    },
	    shouldHidden: function shouldHidden(permissionTarget) {
	        return SessionStore.isFullPaidVersion() ? !UserPermissionStore.shouldShow(this.props.moduleName, permissionTarget) : !SessionStore.isAdminUser();
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props = this.props,
	            customClassName = _props.customClassName,
	            shouldFocusDidMount = _props.shouldFocusDidMount,
	            addEnterKeyDown = _props.addEnterKeyDown,
	            breadcrumb = _props.breadcrumb,
	            module = _props.module,
	            onChange = _props.onChange,
	            onDelete = _props.onDelete,
	            additionalPreSubmitValidation = _props.additionalPreSubmitValidation,
	            additionalSubmitValue = _props.additionalSubmitValue,
	            isDark = _props.isDark,
	            title = _props.title,
	            headerFields = _props.headerFields,
	            onCancel = _props.onCancel,
	            value = _props.value,
	            fetchItems = _props.fetchItems,
	            messages = _props.messages,
	            contextHolder = _props.contextHolder,
	            additionalButtons = _props.additionalButtons;
	
	        var additionalButtonsFiltered = SessionStore.isFullPaidVersion() ? filter(additionalButtons, function (button) {
	            return UserPermissionStore.shouldShow(_this.props.moduleName, button.permission);
	        }) : additionalButtons;
	        var additionalButtonChange = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, function (button) {
	            return button.type === 'CHANGE';
	        }), function (buttonEl) {
	            return buttonEl.el;
	        }) : null;
	        var additionalButtonNew = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, function (button) {
	            return button.type === 'NEW';
	        }), function (buttonEl) {
	            return buttonEl.el;
	        }) : null;
	        var formEl = value ? React.createElement(BasicFormChange, {
	            additionalPreSubmitValidation: additionalPreSubmitValidation,
	            isDark: isDark,
	            title: title,
	            addEnterKeyDown: addEnterKeyDown,
	            contextHolder: contextHolder,
	            messages: messages,
	            fetchItems: fetchItems,
	            value: value,
	            onChange: onChange,
	            onCancel: onCancel,
	            onDelete: onDelete,
	            additionalSubmitValue: additionalSubmitValue,
	            additionalButtons: additionalButtonChange,
	            isDeleteHidden: onDelete === undefined || this.shouldHidden('DELETE'),
	            isSaveHidden: onChange === undefined || this.shouldHidden('EDIT'),
	            breadcrumb: breadcrumb,
	            isValid: this.state.isValid,
	            shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount
	        }, headerFields) : React.createElement(BasicFormChange, {
	            additionalPreSubmitValidation: additionalPreSubmitValidation,
	            isDark: isDark,
	            title: title,
	            contextHolder: contextHolder,
	            messages: messages,
	            addEnterKeyDown: addEnterKeyDown,
	            fetchItems: fetchItems,
	            value: value,
	            onChange: onChange,
	            onCancel: onCancel,
	            onDelete: onDelete,
	            additionalButtons: additionalButtonNew,
	            additionalSubmitValue: additionalSubmitValue,
	            isHiddenAllButtons: true,
	            isDeleteHidden: onDelete === undefined || this.shouldHidden('DELETE'),
	            isSaveHidden: onChange === undefined || this.shouldHidden('EDIT'),
	            breadcrumb: breadcrumb,
	            isValid: this.state.isValid,
	            shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount
	        }, headerFields);
	
	        var goToHistoryEl = module ? React.createElement("div", { className: "admin-scaffolding-history" }, React.createElement("small", null, t('label_history')), React.createElement(IconButton, { onClick: this.goToHistory, className: "right-option-menu", touch: true }, React.createElement(FontIcon, { color: '#fff', className: "material-icons" }, "history"))) : null;
	
	        var className = 'admin-scaffolding';
	
	        if (customClassName) {
	            className += ' ' + customClassName;
	        }
	
	        if (!this.state.isValid) {
	            className += ' is-invalid';
	        }
	
	        if (!SessionStore.isFullPaidVersion()) {
	            className += ' is-free-version';
	        }
	
	        return React.createElement("div", { className: className }, goToHistoryEl, React.createElement("div", { key: uniqueId('admin-scaffolding-header'), className: "admin-scaffolding-header" }, formEl), React.createElement("div", { key: uniqueId('admin-scaffolding-content'), className: "admin-scaffolding-content" }, this.props.children));
	    }
	});
	
	module.exports = AdminScaffoldingGeneric;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1334);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var Stamp = React.createClass({ displayName: "Stamp",
	    propTypes: {
	        srcImage: PropTypes.string,
	        icon: PropTypes.string,
	        text: PropTypes.string,
	        badge: PropTypes.string,
	        className: PropTypes.string,
	        classNameIcon: PropTypes.string
	    },
	
	    getFontIcon: function getFontIcon(icon, classNameIcon, text) {
	        return React.createElement("i", {
	            className: 'bp-stamp__icon' + (text ? ' bp-stamp__icon-text' : ' bp-stamp__icon-non-text') + '\n                ' + (classNameIcon ? ' ' + classNameIcon : '')
	        }, icon ? icon : '');
	    },
	    getImageIcon: function getImageIcon(imageSrc) {
	        if (!imageSrc) {
	            return null;
	        }
	        return React.createElement("img", { className: "bp-stamp__image", src: imageSrc });
	    },
	    render: function render() {
	        var _props = this.props,
	            imageSrc = _props.imageSrc,
	            text = _props.text,
	            className = _props.className,
	            icon = _props.icon,
	            classNameIcon = _props.classNameIcon;
	
	        var classNameText = 'bp-stamp' + (text ? ' ' + text : ' is-empty-text');
	
	        if (className) {
	            classNameText = classNameText + ' ' + className;
	        }
	
	        var iconEl = imageSrc ? this.getImageIcon(imageSrc) : this.getFontIcon(icon, classNameIcon, text);
	
	        return React.createElement("div", { className: classNameText, "data-text": text }, React.createElement("div", { className: "bp-stamp__border-image" }, iconEl));
	    }
	});
	
	module.exports = Stamp;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    DashboardServiceCache = __webpack_require__(28),
	    SessionStore = __webpack_require__(11),
	    LocaleUtils = __webpack_require__(233),
	    Security = __webpack_require__(13).auth,
	    Constants = __webpack_require__(2),
	    get = __webpack_require__(5).get,
	    hostApi = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API;
	
	var DashboardService = {
	    getOrders: function getOrders(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/orders/' + SessionStore.getCurrentApplicant());
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    fetchNextDashboardContent: function fetchNextDashboardContent(from, to, applicant, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponseWithFullLogout(this, success, failure);
	        });
	
	        ajax.open('GET', hostApi + '/orders/' + applicant + '/range?from=' + from + '&to=' + to);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    addOrder: function addOrder(order, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(order));
	    },
	    changeFreeToProVersion: function changeFreeToProVersion(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/applicants/change-version/' + Constants.LICENSE_TRIAL_FULL_VERSION, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    fetchDashboardContent: function fetchDashboardContent(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
	        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
	        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
	        ajax.send();
	    },
	    fetchDashboardInventoryItemsContent: function fetchDashboardInventoryItemsContent(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard-items');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
	        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
	        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
	        ajax.send();
	    },
	    fetchDashboardInventoryProductsContent: function fetchDashboardInventoryProductsContent(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/orders/' + Security.getCurrentApplicant() + '/dashboard-products');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
	        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCountry(), 'cca2'));
	        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(SessionStore.getCurrentCurrency(), 'code'));
	        ajax.send();
	    },
	    fetchScheduleBoardByDate: function fetchScheduleBoardByDate(date, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/tasks/date/' + date);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    saveChangedUserTaskName: function saveChangedUserTaskName(_ref, success, failure) {
	        var date = _ref.date,
	            name = _ref.name,
	            id = _ref.id,
	            originalName = _ref.originalName;
	
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/tasks');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            applicantName: SessionStore.getCurrentApplicant(),
	            date: date,
	            name: name,
	            id: id,
	            oldTemplateName: originalName
	        }));
	    },
	    addUserTaskName: function addUserTaskName(_ref2, success, failure) {
	        var date = _ref2.date,
	            note = _ref2.note,
	            id = _ref2.id,
	            listId = _ref2.listId,
	            listName = _ref2.listName,
	            name = _ref2.name,
	            checked = _ref2.checked;
	
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/tasks/date/' + date + '/note');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            applicantName: SessionStore.getCurrentApplicant(),
	            message: note,
	            id: id,
	            taskListId: listId,
	            taskListName: listName,
	            name: name,
	            checked: checked
	        }));
	    },
	    deleteUserTaskName: function deleteUserTaskName(_ref3, success, failure) {
	        var id = _ref3.id,
	            listName = _ref3.listName;
	
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', hostApi + '/tasks/' + id);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            id: id,
	            name: listName
	        }));
	    },
	    removeUserTask: function removeUserTask(data, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', onFailure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, onSuccess, onFailure);
	        });
	        ajax.open('DELETE', hostApi + '/tasks/' + data.listId + '/task/' + data.id);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send();
	    },
	    publishDraft: function publishDraft(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/publish', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    undoDraft: function undoDraft(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/undo', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    redoDraft: function redoDraft(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/redo', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getDraft: function getDraft(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/draft');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    saveDraft: function saveDraft(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/draft');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            'applicant': SessionStore.getCurrentApplicant(),
	            'operations': DashboardServiceCache.getPendingOperations()
	        }));
	    },
	    removeOrder: function removeOrder(id, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', hostApi + '/orders/' + SessionStore.getCurrentApplicant() + '/' + id);
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    changeOrder: function changeOrder(order, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', hostApi + '/orders/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(order));
	    },
	    deleteTank: function deleteTank(id, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '/' + id);
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getTanks: function getTanks(page, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getAllTanks: function getAllTanks(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getTanksBy: function getTanksBy(filter, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/tanks/' + SessionStore.getCurrentApplicant() + '/filter' + RestUtils.formatQueryString(filter));
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    changeTank: function changeTank(tank, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', hostApi + '/tanks/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(tank));
	    },
	    addTank: function addTank(tank, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/tanks/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(tank));
	    },
	    addBeerStyleConfiguration: function addBeerStyleConfiguration(beerStyleConfiguration, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(beerStyleConfiguration));
	    },
	    changeBeerStyleConfiguration: function changeBeerStyleConfiguration(beerStyleConfiguration, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(beerStyleConfiguration));
	    },
	    deleteBeerStyleConfiguration: function deleteBeerStyleConfiguration(id, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure.bind(this));
	        });
	        ajax.open('DELETE', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(id);
	    },
	    getBeerStyleConfiguration: function getBeerStyleConfiguration(beerStyleId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant() + '/configurations/' + beerStyleId);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getStyleBeers: function getStyleBeers(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getIcons: function getIcons(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/icons', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    changeStyleBeer: function changeStyleBeer(styleBeer, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(styleBeer));
	    },
	    addStyleBeer: function addStyleBeer(styleBeer, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(styleBeer));
	    },
	    deleteStyleBeer: function deleteStyleBeer(styleBeer, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure.bind(this));
	        });
	        ajax.open('DELETE', hostApi + '/stylebeer/' + SessionStore.getCurrentApplicant(), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify({ id: styleBeer }));
	    }
	};
	module.exports = DashboardService;

/***/ },
/* 133 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(203),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(318),
	    arrayIncludes = __webpack_require__(319),
	    arrayIncludesWith = __webpack_require__(320),
	    arrayMap = __webpack_require__(45),
	    baseUnary = __webpack_require__(448),
	    cacheHas = __webpack_require__(339);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support for
	 * excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(468);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var isIterateeCall = __webpack_require__(101),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = typeof customizer == 'function'
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(159),
	    deburr = __webpack_require__(481),
	    words = __webpack_require__(512);
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string)), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getPlaceholder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	module.exports = getPlaceholder;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(134),
	    Set = __webpack_require__(419),
	    WeakMap = __webpack_require__(421);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var mapCtorString = Map ? funcToString.call(Map) : '',
	    setCtorString = Set ? funcToString.call(Set) : '',
	    weakMapCtorString = WeakMap ? funcToString.call(WeakMap) : '';
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for IE 11 providing `toStringTag` values for maps, sets, and weakmaps.
	if ((Map && getTag(new Map) != mapTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : null,
	        ctorString = typeof Ctor == 'function' ? funcToString.call(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case mapCtorString: return mapTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return type == 'number' || type == 'boolean' ||
	    (type == 'string' && value != '__proto__') || value == null;
	}
	
	module.exports = isKeyable;


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(52);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(46);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3);
	 * // => 3
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3');
	 * // => 3
	 */
	function toNumber(value) {
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var Events = __webpack_require__(121);
	var Dom = __webpack_require__(367);
	
	module.exports = {
	
	  //When the component mounts, listen to click events and check if we need to
	  //Call the componentClickAway function.
	  componentDidMount: function componentDidMount() {
	    if (!this.manuallyBindClickAway) this._bindClickAway();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._unbindClickAway();
	  },
	
	  _checkClickAway: function _checkClickAway(event) {
	    var el = React.findDOMNode(this);
	
	    // Check if the target is inside the current component
	    if (event.target !== el && !Dom.isDescendant(el, event.target) && document.documentElement.contains(event.target)) {
	      if (this.componentClickAway) this.componentClickAway();
	    }
	  },
	
	  _bindClickAway: function _bindClickAway() {
	    // On touch-enabled devices, both events fire, and the handler is called twice,
	    // but it's fine since all operations for which the mixin is used
	    // are idempotent.
	    Events.on(document, 'mouseup', this._checkClickAway);
	    Events.on(document, 'touchend', this._checkClickAway);
	  },
	
	  _unbindClickAway: function _unbindClickAway() {
	    Events.off(document, 'mouseup', this._checkClickAway);
	    Events.off(document, 'touchend', this._checkClickAway);
	  }
	
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var update = React.addons.update;
	
	function mergeSingle(objA, objB) {
	  if (!objA) return objB;
	  if (!objB) return objA;
	  return update(objA, { $merge: objB });
	}
	
	module.exports = {
	
	  merge: function merge() {
	    var args = Array.prototype.slice.call(arguments, 0);
	    var base = args[0];
	
	    for (var i = 1; i < args.length; i++) {
	      if (args[i]) {
	        base = mergeSingle(base, args[i]);
	      }
	    }
	    return base;
	  },
	
	  mergeItem: function mergeItem(obj, key, newValueObject) {
	    var command = {};
	    command[key] = { $merge: newValueObject };
	    return update(obj, command);
	  },
	
	  push: function push(array, obj) {
	    var newObj = Array.isArray(obj) ? obj : [obj];
	    return update(array, { $push: newObj });
	  },
	
	  shift: function shift(array) {
	    return update(array, { $splice: [[0, 1]] });
	  }
	
	};

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var invariant = __webpack_require__(15);
	var canUseDOM = __webpack_require__(44).canUseDOM;
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, "Cannot use History.back without a DOM");
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactFragment
	*/
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	
	var warning = __webpack_require__(32);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set a fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is opaque, for now.
	 */
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  var fragmentKey = '_reactFragment';
	  var didWarnKey = '_reactDidWarn';
	  var canWarnForReactFragment = false;
	
	  try {
	    // Feature test. Don't even try to issue this warning if we can't use
	    // enumerable: false.
	
	    var dummy = function() {
	      return 1;
	    };
	
	    Object.defineProperty(
	      {},
	      fragmentKey,
	      {enumerable: false, value: true}
	    );
	
	    Object.defineProperty(
	      {},
	      'key',
	      {enumerable: true, get: dummy}
	    );
	
	    canWarnForReactFragment = true;
	  } catch (x) { }
	
	  var proxyPropertyAccessWithWarning = function(obj, key) {
	    Object.defineProperty(obj, key, {
	      enumerable: true,
	      get: function() {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an opaque type. Accessing any of its ' +
	          'properties is deprecated. Pass it to one of the React.Children ' +
	          'helpers.'
	        ) : null);
	        this[didWarnKey] = true;
	        return this[fragmentKey][key];
	      },
	      set: function(value) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an immutable opaque type. Mutating its ' +
	          'properties is deprecated.'
	        ) : null);
	        this[didWarnKey] = true;
	        this[fragmentKey][key] = value;
	      }
	    });
	  };
	
	  var issuedWarnings = {};
	
	  var didWarnForFragment = function(fragment) {
	    // We use the keys and the type of the value as a heuristic to dedupe the
	    // warning to avoid spamming too much.
	    var fragmentCacheKey = '';
	    for (var key in fragment) {
	      fragmentCacheKey += key + ':' + (typeof fragment[key]) + ',';
	    }
	    var alreadyWarnedOnce = !!issuedWarnings[fragmentCacheKey];
	    issuedWarnings[fragmentCacheKey] = true;
	    return alreadyWarnedOnce;
	  };
	}
	
	var ReactFragment = {
	  // Wrap a keyed object in an opaque proxy that warns you if you access any
	  // of its properties.
	  create: function(object) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      if (typeof object !== 'object' || !object || Array.isArray(object)) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment only accepts a single object.',
	          object
	        ) : null);
	        return object;
	      }
	      if (ReactElement.isValidElement(object)) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment does not accept a ReactElement ' +
	          'without a wrapper object.'
	        ) : null);
	        return object;
	      }
	      if (canWarnForReactFragment) {
	        var proxy = {};
	        Object.defineProperty(proxy, fragmentKey, {
	          enumerable: false,
	          value: object
	        });
	        Object.defineProperty(proxy, didWarnKey, {
	          writable: true,
	          enumerable: false,
	          value: false
	        });
	        for (var key in object) {
	          proxyPropertyAccessWithWarning(proxy, key);
	        }
	        Object.preventExtensions(proxy);
	        return proxy;
	      }
	    }
	    return object;
	  },
	  // Extract the original keyed object from the fragment opaque type. Warn if
	  // a plain object is passed here.
	  extract: function(fragment) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      if (canWarnForReactFragment) {
	        if (!fragment[fragmentKey]) {
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	            didWarnForFragment(fragment),
	            'Any use of a keyed object should be wrapped in ' +
	            'React.addons.createFragment(object) before being passed as a ' +
	            'child.'
	          ) : null);
	          return fragment;
	        }
	        return fragment[fragmentKey];
	      }
	    }
	    return fragment;
	  },
	  // Check if this is a fragment and if so, extract the keyed object. If it
	  // is a fragment-like object, warn that it should be wrapped. Ignore if we
	  // can't determine what kind of object this is.
	  extractIfFragment: function(fragment) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      if (canWarnForReactFragment) {
	        // If it is the opaque type, return the keyed object.
	        if (fragment[fragmentKey]) {
	          return fragment[fragmentKey];
	        }
	        // Otherwise, check each property if it has an element, if it does
	        // it is probably meant as a fragment, so we can warn early. Defer,
	        // the warning to extract.
	        for (var key in fragment) {
	          if (fragment.hasOwnProperty(key) &&
	              ReactElement.isValidElement(fragment[key])) {
	            // This looks like a fragment object, we should provide an
	            // early warning.
	            return ReactFragment.extract(fragment);
	          }
	        }
	      }
	    }
	    return fragment;
	  }
	};
	
	module.exports = ReactFragment;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1263);
	var ReactElementValidator = __webpack_require__(174);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ReactElementValidator.checkAndWarnForMutatedProps(
	        internalInstance._currentElement
	      );
	    }
	    transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function(internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function(
	    internalInstance, nextElement, transaction, context
	  ) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && nextElement._owner != null) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(
	      prevElement,
	      nextElement
	    );
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(
	    internalInstance,
	    transaction
	  ) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(104);
	
	var getEventTarget = __webpack_require__(391);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function(event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function(event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;


/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	var _el = void 0;
	
	var ContextMenuEl = {
	    setElement: function setElement(contextMenuEl) {
	        _el = contextMenuEl;
	    },
	    show: function show() {
	        var _el2;
	
	        (_el2 = _el).show.apply(_el2, arguments);
	    },
	    close: function close() {
	        _el.close();
	    }
	};
	
	module.exports = ContextMenuEl;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1329);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    GridItem = __webpack_require__(229),
	    _require2 = __webpack_require__(53),
	    cloneDeep = _require2.cloneDeep,
	    _require3 = __webpack_require__(8),
	    filter = _require3.filter,
	    map = _require3.map,
	    orderBy = _require3.orderBy,
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7),
	    GridItemFilter = __webpack_require__(710);
	
	
	var GridItemWithFilter = React.createClass({ displayName: "GridItemWithFilter",
	
	    propTypes: {
	        label: PropTypes.string,
	        isCheckedItem: PropTypes.func,
	        isChangedItem: PropTypes.func,
	        items: PropTypes.array,
	        onCheckItem: PropTypes.func,
	        initialFilterText: PropTypes.string,
	        nonMatchingText: PropTypes.string,
	        displayNameField: PropTypes.string,
	        iconInnerText: PropTypes.string,
	        iconClassNameField: PropTypes.string,
	        idField: PropTypes.string,
	        filterHidden: PropTypes.bool,
	        keepSelectedSorting: PropTypes.bool,
	        dictionary: PropTypes.object
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            filterText: null,
	            isPristine: true
	        };
	    },
	    _onKeyDownFilter: function _onKeyDownFilter(evt) {
	        var haveSomeTextToFilter = evt && evt.target;
	        var haveEmptyText = evt && evt.target === '';
	
	        if (haveSomeTextToFilter || haveEmptyText) {
	            var filterText = evt.target.value;
	            this.setState({
	                filterText: filterText,
	                isPristine: false
	            });
	        }
	    },
	    _filterItems: function _filterItems(items, filterText) {
	        var safeItems = cloneDeep(items);
	        if (!filterText) {
	            return items;
	        }
	
	        var _props = this.props,
	            isChangedItem = _props.isChangedItem,
	            displayNameField = _props.displayNameField,
	            idField = _props.idField;
	
	        var filteredItems = filter(safeItems, function (item) {
	            var label = get(item, displayNameField) || '';
	            return label.toLowerCase().includes(filterText.toLowerCase()) || (isChangedItem ? isChangedItem(item) : false);
	        });
	
	        return ContentUtils.removeDuplicateByAttribute(filteredItems, idField);
	    },
	    _onCheck: function _onCheck(gridItemProps) {
	        if (this.props.onCheckItem) {
	            this.props.onCheckItem(gridItemProps, this._getCurrentTextFilter());
	        }
	    },
	    _getCurrentTextFilter: function _getCurrentTextFilter() {
	        var initialFilterText = this.props.initialFilterText;
	        var _state = this.state,
	            isPristine = _state.isPristine,
	            filterText = _state.filterText;
	
	
	        if (filterText) {
	            return filterText;
	        }
	
	        if (isPristine && initialFilterText) {
	            return initialFilterText;
	        }
	
	        return ''; // non-filter
	    },
	    _sortedItems: function _sortedItems(items) {
	        return ContentUtils.sortList(items || [], this.props.displayNameField);
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props2 = this.props,
	            keepSelectedSorting = _props2.keepSelectedSorting,
	            isCheckedItem = _props2.isCheckedItem,
	            isChangedItem = _props2.isChangedItem,
	            items = _props2.items,
	            nonMatchingText = _props2.nonMatchingText,
	            displayNameField = _props2.displayNameField,
	            iconClassNameField = _props2.iconClassNameField,
	            filterHidden = _props2.filterHidden,
	            label = _props2.label,
	            iconInnerText = _props2.iconInnerText,
	            dictionary = _props2.dictionary;
	
	        var finalFilterText = this._getCurrentTextFilter();
	        var sortedItems = this._sortedItems(items);
	        var itemsFiltered = this._filterItems(sortedItems, finalFilterText);
	
	        var isEmptyItems = ContentUtils.isEmptyArray(itemsFiltered);
	        var filterEl = filterHidden === true ? null : React.createElement(GridItemFilter, {
	            value: this._getCurrentTextFilter(),
	            onChange: this._onKeyDownFilter,
	            onBlur: this._onKeyDownFilter });
	        if (isEmptyItems) {
	            return React.createElement("div", { className: "bp-grid-item-withfilter" }, filterEl, React.createElement("div", { style: {
	                    backgroundColor: 'gray',
	                    textAlign: 'center',
	                    background: 'white',
	                    fontSize: '20px'
	                } }, React.createElement("p", null, nonMatchingText)));
	        }
	
	        var itemsFilteredSorted = keepSelectedSorting ? orderBy(itemsFiltered, isCheckedItem, ['desc']) : itemsFiltered;
	        var itemsFilteredAndExtraSorted = keepSelectedSorting ? itemsFilteredSorted : ContentUtils.sortIcons(itemsFilteredSorted);
	        var GridItemsEl = map(itemsFilteredAndExtraSorted, function (item) {
	            var label = dictionary ? dictionary[item.name] || '[' + get(item, displayNameField) + ']' : get(item, displayNameField);
	            var iconClass = get(item, iconClassNameField);
	            var iconInnerTextValue = get(item, iconInnerText);
	            var isChecked = isCheckedItem(item);
	            var isIconChanged = isChangedItem(item);
	
	            return React.createElement(GridItem, {
	                iconId: get(item, 'id'),
	                label: label,
	                iconClassName: iconClass,
	                iconInnerText: iconInnerTextValue,
	                isChecked: isChecked,
	                className: isIconChanged ? 'is-changed' : undefined,
	                onCheck: _this._onCheck });
	        });
	
	        return React.createElement("div", { className: "bp-grid-item-withfilter" }, React.createElement("h2", null, label), filterEl, GridItemsEl);
	    }
	});
	
	module.exports = GridItemWithFilter;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1335);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var Stamps = React.createClass({ displayName: "Stamps",
	    propTypes: {
	        maxVisible: PropTypes.number
	    },
	
	    render: function render() {
	        var children = this.props.children;
	
	
	        var countStamps = React.Children.count(children);
	
	        return React.createElement("div", { "data-total-count": countStamps, className: "bp-stamps" }, children);
	    }
	});
	
	module.exports = Stamps;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var EventEmitter = __webpack_require__(109).EventEmitter,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Constants = __webpack_require__(2),
	    ContentUtils = __webpack_require__(7),
	    DateUtils = __webpack_require__(22),
	    OrderUtils = __webpack_require__(49),
	    NumberUtils = __webpack_require__(23),
	    Notification = __webpack_require__(21),
	    DashboardLayoutStore = __webpack_require__(108),
	    DashboardStore = __webpack_require__(82),
	    BrewhouseStore = __webpack_require__(96),
	    OrderStore = __webpack_require__(72),
	    DashboardServiceCache = __webpack_require__(28),
	    ChronologycStore = __webpack_require__(76),
	    InventoryStore = __webpack_require__(20),
	    DashboardModalEl = __webpack_require__(180),
	    ContextMenuEl = __webpack_require__(152),
	    ActionTypes = Constants.ActionTypes,
	    _ = __webpack_require__(40),
	    assign = __webpack_require__(74),
	    CHANGE_EVENT = 'change',
	    SchedulerAppDispatcher = __webpack_require__(42);
	
	/**
	 * Add state outside of store object because make issues Flux action dispatch callbacks.
	 */
	var context = {
	    _lastToggleName: '',
	    _currentLayout: [],
	    _currentOrder: null,
	    _batchNumber: null,
	    _volumeOrder: null,
	    _pristineVolume: null,
	    _isBHAllowed: null,
	    _isFVAllowed: null,
	    _isBTAllowed: null,
	    _lastBatchNumber: null,
	    _lastManualVolume: null,
	    _styleBeerSelected: null,
	    _fermenterTankSelected: null,
	    _briteTankTankSelected: null,
	    _lastUpdatedTasks: []
	};
	
	var DashboardModalStore = assign({}, EventEmitter.prototype, {
	    emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	    },
	    setLastManualBatchNumber: function setLastManualBatchNumber(batchNumber) {
	        context._lastBatchNumber = batchNumber;
	    },
	    getLastManualBatchNumber: function getLastManualBatchNumber() {
	        return context._lastBatchNumber;
	    },
	    setStyleBeerSelected: function setStyleBeerSelected(styleBeerSelected) {
	        context._styleBeerSelected = styleBeerSelected;
	    },
	    getStyleBeerSelected: function getStyleBeerSelected() {
	        return context._styleBeerSelected;
	    },
	    setFermenterTankSelected: function setFermenterTankSelected(fermenterTankSelected) {
	        context._fermenterTankSelected = fermenterTankSelected;
	    },
	    getFermenterTankSelected: function getFermenterTankSelected() {
	        return context._fermenterTankSelected;
	    },
	    setBriteTankSelected: function setBriteTankSelected(briteTankSelected) {
	        context._briteTankTankSelected = briteTankSelected;
	    },
	    getBriteTankSelected: function getBriteTankSelected() {
	        return context._briteTankTankSelected;
	    },
	    setLastManualVolume: function setLastManualVolume(volume) {
	        return context._lastManualVolume = volume;
	    },
	    getLastManualVolume: function getLastManualVolume() {
	        return context._lastManualVolume;
	    },
	    setLastManualTask: function setLastManualTask(task) {
	        // find and replace if existing task
	        if (!context._lastUpdatedTasks) {
	            context._lastUpdatedTasks = [];
	        }
	
	        if (task) {
	            // remove possible duplicated task
	            context._lastUpdatedTasks = _.filter(context._lastUpdatedTasks, function (oldTask) {
	                return !(_.get(oldTask, 'date') === _.get(task, 'date') && _.get(oldTask, 'sectionType') === _.get(task, 'sectionType'));
	            });
	        }
	
	        context._lastUpdatedTasks.push(task);
	    },
	    getLastManualTask: function getLastManualTask() {
	        return context._lastUpdatedTasks;
	    },
	    updateLayoutAndCalculateSectionVolumeLabels: function updateLayoutAndCalculateSectionVolumeLabels(order) {
	        var batchNumber = _.get(order, 'batchNumber');
	        var oldBatchNumber = _.get(order, 'oldBatchNumber');
	
	        // use the last batch number over original batch number order
	        // because if exist last batch number means the user prefer user them over the original
	        var uniqueBatchNumbers = _.uniq([this.getLastManualBatchNumber(), batchNumber, oldBatchNumber]);
	        var batchNumbersCleaner = _.filter(uniqueBatchNumbers, function (batchNumber) {
	            return batchNumber;
	        });
	        var modalLayout = getMinimalLayoutFromBatchNumber(batchNumbersCleaner, order);
	        this.setCurrentLayout(modalLayout);
	
	        // draw section volumes in modal
	        DashboardModalEl.updateVolumeLabels(order);
	        DashboardModalEl.updateBatchCostLabel(order);
	    },
	    updateBatchNumberOfLayout: function updateBatchNumberOfLayout(orderId, oldBatchNumber, newBatchNumber) {
	        this.addPositionsToCurrentLayoutFromBatchNumber(newBatchNumber);
	
	        // update layout
	        var isNonEmptyLayout = _.get(context._currentLayout, 'length', 0) > 0;
	        var isDifferentOldBatchThanNewBatchNumber = oldBatchNumber !== newBatchNumber;
	
	        if (isNonEmptyLayout && isDifferentOldBatchThanNewBatchNumber) {
	            // enter here means that we change the batch number of current order, so we need to update the position of given
	            // order so, we need to update currentLayout in order to update each batch number of each positions
	            context._currentLayout = _.map(context._currentLayout, function (position) {
	                if (ContentUtils.cleanId(position.i) === orderId) {
	                    position.batchNumber = newBatchNumber;
	                }
	                return position;
	            });
	        }
	    },
	    addPositionsToCurrentLayoutFromBatchNumber: function addPositionsToCurrentLayoutFromBatchNumber(newBatchNumber) {
	        // add the new position of the batch number
	        var newPositionsOfNewBatchNumber = _.filter(DashboardLayoutStore.getLayout(), function (position) {
	            return position.batchNumber === newBatchNumber;
	        });
	        context._currentLayout = _.concat(context._currentLayout, newPositionsOfNewBatchNumber);
	
	        // to be sure to not duplicate positions
	        context._currentLayout = ContentUtils.removeDuplicateByAttribute(context._currentLayout, ['x', 'y', 'i', 'h']);
	    },
	    updateSectionLabels: function updateSectionLabels(batchVolumeInfo, order) {
	        // save total batch volume label and underline text too
	        var tasks = order.taskWithProductUpdates ? Array.isArray(order.taskWithProductUpdates) ? order.taskWithProductUpdates : [order.taskWithProductUpdates] : null;
	        if (tasks) {
	            batchVolumeInfo.productVolume = InventoryStore.calculateTotalVolumeFromTask(tasks, order);
	            batchVolumeInfo.productVolumeLeft = NumberUtils.subtract(batchVolumeInfo.totalBatchVolume, batchVolumeInfo.productVolume);
	        } else {
	            batchVolumeInfo.productVolume = '0';
	            batchVolumeInfo.productVolumeLeft = batchVolumeInfo.totalBatchVolume;
	        }
	        batchVolumeInfo.totalBatchVolumeMessageError = BrewhouseStore.getLabelVolumeBySections(batchVolumeInfo.fermentingVolume, batchVolumeInfo.packagingVolume);
	        batchVolumeInfo.totalBatchVolumeLeftMessage = BrewhouseStore.formatBatchVolumeLeft(batchVolumeInfo.totalBatchVolume, batchVolumeInfo.productVolumeLeft);
	        batchVolumeInfo.order = order;
	
	        return batchVolumeInfo;
	    },
	    _updateVolumeInfoWithCurrentNewVolumeOrder: function _updateVolumeInfoWithCurrentNewVolumeOrder(batchVolumeInfo, order) {
	        var isSingle = _.get(order, 'isSingle');
	        var newOrderVolume = _.get(order, 'volume');
	        if (isSingle) {
	            if (_.get(order, 'tankSelected.type') === 'FV') {
	                // we can use `tankSelected` because is just an NEW order.
	                batchVolumeInfo.fermentingVolume = NumberUtils.sum(batchVolumeInfo.fermentingVolume, newOrderVolume);
	            } else {
	                batchVolumeInfo.packagingVolume = NumberUtils.sum(batchVolumeInfo.packagingVolume, newOrderVolume);
	            }
	        } else {
	            batchVolumeInfo.fermentingVolume = NumberUtils.sum(batchVolumeInfo.fermentingVolume, newOrderVolume);
	            batchVolumeInfo.packagingVolume = NumberUtils.sum(batchVolumeInfo.packagingVolume, newOrderVolume);
	        }
	        batchVolumeInfo.totalBatchVolumeMessageError = BrewhouseStore.getLabelVolumeBySections(batchVolumeInfo.fermentingVolume, batchVolumeInfo.packagingVolume);
	
	        return batchVolumeInfo;
	    },
	    setCurrentLayout: function setCurrentLayout(layout) {
	        context._currentLayout = layout;
	    },
	    getCurrentLayout: function getCurrentLayout() {
	        return context._currentLayout;
	    },
	    cleanStore: function cleanStore() {
	        context._currentLayout = null;
	        context._lastBatchNumber = null;
	        context._currentOrder = null;
	        context._pristineVolume = null;
	        context._volumeOrder = null;
	        context._lastManualVolume = null;
	        context._lastUpdatedTasks = [];
	        context._lastToggleName = '';
	        context._batchNumber = null;
	        context._styleBeerSelected = null;
	        context._fermenterTankSelected = null;
	        context._briteTankTankSelected = null;
	        context._isFVAllowed = true;
	        context._isBTAllowed = true;
	        context._isBHAllowed = true;
	        context._isOpen = false;
	    },
	    getInitialState: function getInitialState() {
	        return _extends({
	            isOpen: false,
	            isNewModal: false,
	            isBHAllowed: true,
	            isFVAllowed: true,
	            isBTAllowed: true,
	            currencyInfo: NumberUtils.getCurrentCurrency()
	        }, this.getInitialStateWithoutToggles());
	    },
	    getInitialStateWithoutToggles: function getInitialStateWithoutToggles() {
	        return {
	            isOpen: false,
	            isNewModal: false,
	            shouldNeedValidate: true,
	            currentTabSelected: 0,
	            shouldNotUpdateChildren: false,
	            leftVolumeHighlighted: false
	        };
	    },
	    setCurrentOrder: function setCurrentOrder(order) {
	        context._currentOrder = order;
	    },
	    getBatchNumber: function getBatchNumber() {
	        return context._batchNumber;
	    },
	    setBatchNumber: function setBatchNumber(batchNumber) {
	        context._batchNumber = batchNumber;
	    },
	    getCurrentOrder: function getCurrentOrder() {
	        return context._currentOrder;
	    },
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	    getLastToggleConditional: function getLastToggleConditional() {
	        return 'is' + context._lastToggleName + 'Allowed';
	    },
	    setLastToggleConditional: function setLastToggleConditional(name) {
	        context._lastToggleName = name;
	    },
	    isBHAllowed: function isBHAllowed() {
	        return context._isBHAllowed;
	    },
	    isFVAllowed: function isFVAllowed() {
	        return context._isFVAllowed;
	    },
	    isBTAllowed: function isBTAllowed() {
	        return context._isBTAllowed;
	    },
	    setVolume: function setVolume(volumeOrder) {
	        context._volumeOrder = volumeOrder;
	    },
	    getVolume: function getVolume() {
	        return context._volumeOrder;
	    },
	    setToggles: function setToggles(isBHAllowed, isFVAllowed, isBTAllowed) {
	        context._isBHAllowed = isBHAllowed;
	        context._isFVAllowed = isFVAllowed;
	        context._isBTAllowed = isBTAllowed;
	    },
	    getPristineVolume: function getPristineVolume() {
	        return context._pristineVolume;
	    },
	    setPristineVolume: function setPristineVolume(volume) {
	        context._pristineVolume = volume;
	    },
	    prepareOrderFromAction: function prepareOrderFromAction() {
	        _prepareOrderFromAction.apply(this, arguments);
	    }
	});
	
	/**
	 * Given a batch number generate a minimal dashboard layout orders needed by work an efficient way
	 * in the dashboard modal which given particular batch number. (small part of dashboard)
	 * @param {Object | Array} batchNumbers
	 * @param {Object} batchNumbers (Optional)
	 * @return {Array}
	 */
	function getMinimalLayoutFromBatchNumber(batchNumbers, order) {
	    var ordersFromRange = void 0,
	        batchOrders = [];
	
	    // take all order with the same batch number (batch orders)
	    if (Array.isArray(batchNumbers)) {
	        for (var _iterator = batchNumbers, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var batchNumber = _ref;
	
	            batchOrders = _.union(OrderStore.getOrderByBatchNumber(batchNumber), batchOrders);
	        }
	    } else {
	        batchOrders = OrderStore.getOrderByBatchNumber(batchNumbers);
	    }
	    // put the current order from the list of batch orders
	    batchOrders = _replaceOlderOrderToNewOrder(batchOrders, order);
	
	    // update layout if needed update the position of batch number
	    // against the batch number each order from the batch
	    _syncOrderBatchNumberWithModalLayout(batchOrders);
	
	    // get the older and latest date from the current batch order
	    var earlyAndLaterOrderDate = _retrieveEarlyAndLaterOrder(batchOrders);
	
	    // retrieve all batchOrders which are in the range of the batch order date
	    ordersFromRange = OrderUtils.getOrderByRange(earlyAndLaterOrderDate.earlyDate, earlyAndLaterOrderDate.laterDate);
	
	    // convert the orders to positions from the partial minimal layout generated
	    var layout = _.flatten(_.map(ordersFromRange, function (order) {
	        return OrderUtils.convertOrderToPositions(order, ChronologycStore.getCurrentFrom(), null, true);
	    }));
	
	    // hydrate position with extra order information
	    if (order) {
	        layout = _updateLayoutWithOrder(layout, order);
	    }
	
	    return layout;
	}
	
	function _replaceOlderOrderToNewOrder(orders, newOrder) {
	    var isChangeOrder = newOrder && ContentUtils.isNotNullOrUndefined(_.get(newOrder, 'id'));
	    if (newOrder && isChangeOrder) {
	        return ContentUtils.replace(orders, newOrder, 'id');
	    }
	    return orders;
	}
	
	function _syncOrderBatchNumberWithModalLayout(orders) {
	    var layoutModal = DashboardModalStore.getCurrentLayout();
	    var layoutChanged = _.map(layoutModal, function (position) {
	        var positionOrderId = ContentUtils.cleanId(_.get(position, 'i'));
	        var ordersWithId = _.filter(orders, function (order) {
	            return ContentUtils.isNotNullOrUndefined(_.get(order, 'id'));
	        });
	        var orderTarget = _.find(ordersWithId, function (order) {
	            return _.get(order, 'id') === positionOrderId;
	        });
	        if (orderTarget && position) {
	            position.batchNumber = orderTarget.batchNumber;
	        }
	        return position;
	    });
	    DashboardModalStore.setCurrentLayout(layoutChanged);
	}
	
	function _retrieveEarlyAndLaterOrder(orders) {
	    var earlyDate = void 0,
	        laterDate = void 0;
	
	    for (var _iterator2 = orders, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	        var _ref2;
	
	        if (_isArray2) {
	            if (_i2 >= _iterator2.length) break;
	            _ref2 = _iterator2[_i2++];
	        } else {
	            _i2 = _iterator2.next();
	            if (_i2.done) break;
	            _ref2 = _i2.value;
	        }
	
	        var order = _ref2;
	
	        var startDate = ContentUtils.getOrderField(order, 'startDate');
	        var endDate = ContentUtils.getOrderField(order, 'endDate');
	        // initialize target dates
	        if (!earlyDate) {
	            earlyDate = startDate;
	        }
	
	        if (!laterDate) {
	            laterDate = endDate;
	        }
	
	        if (DateUtils.isBefore(startDate, earlyDate)) {
	            earlyDate = startDate;
	        }
	
	        if (DateUtils.isAfter(endDate, laterDate)) {
	            laterDate = endDate;
	        }
	    }
	
	    return {
	        earlyDate: earlyDate,
	        laterDate: laterDate
	    };
	}
	
	DashboardModalStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	
	    switch (action.type) {
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_TOGGLE:
	            {
	                DashboardModalStore.setLastToggleConditional(action.lastToggleChanged);
	                DashboardModalStore.setToggles(action.isBHAllowed, action.isFVAllowed, action.isBTAllowed);
	                DashboardModalStore.emitChange();
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_OPEN_NEW_ORDER:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                var order = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(order);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_OPEN_EXISTING_ORDER:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                var _order = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(_order);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_NUMBER:
	            {
	                // update new batch number in context
	                var newBatchNumber = _.get(action, 'batchNumber');
	                DashboardModalStore.setLastManualBatchNumber(newBatchNumber); // update last batch number
	                DashboardModalStore.setBatchNumber(newBatchNumber);
	
	                var _order2 = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(_order2);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME:
	            {
	                // update volume in context
	                var volume = NumberUtils.standardiseDecimalFormatNumber(_.get(action, 'volume'));
	                DashboardModalStore.setLastManualVolume(volume);
	                DashboardModalStore.setVolume(volume);
	
	                var _order3 = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(_order3);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT:
	            {
	                // save first the task with the specific product
	                DashboardModalStore.setLastManualTask(action.taskUpdated);
	
	                // update product in context
	                var _order4 = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(_order4);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE:
	            {
	                // update product in context
	                var _order5 = _prepareOrderFromAction(action);
	
	                // update layout, calculate section volumes and update labels to
	                DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(_order5);
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE:
	            {
	                // After change the beer style it should disable the toggles, in order
	                // to avoid future bugs
	                DashboardModalEl.disableToggles(function () {
	                    // clean information related to older beer style products
	                    var order = _prepareOrderFromAction(action);
	
	                    // update layout, calculate section volumes and update labels to
	                    DashboardModalStore.updateLayoutAndCalculateSectionVolumeLabels(order);
	                });
	                break;
	            }
	
	        case ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_EMPTY:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	
	                context._batchNumber = OrderStore.getNextBatchNumber();
	                action.preDefinedOrder.batchNumber = context._batchNumber;
	                var _volume = +_.get(action, 'preDefinedOrder.tankSelected.volume', 0);
	
	                // prepare Modal
	                DashboardModalStore.setCurrentLayout(DashboardLayoutStore.getLayout());
	                DashboardModalStore.setPristineVolume(_volume);
	                DashboardModalStore.setVolume(_volume);
	
	                // open modal
	                DashboardModalEl.openNewOrder(action.preDefinedOrder);
	
	                // close context menu
	                ContextMenuEl.close();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_CHANGE_TASK_ORDER_DASHBOARD:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                DashboardLayoutStore.setAsRelocatedPositions(_.get(action, 'existingOrderInfo.orderSelected.batchNumber'));
	                var _volume2 = +_.get(action, 'existingOrderInfo.orderSelected.volume', 0);
	
	                // prepare modal
	                DashboardModalStore.setCurrentLayout(getMinimalLayoutFromBatchNumber(context._batchNumber));
	                DashboardModalStore.setPristineVolume(_volume2);
	                DashboardModalStore.setVolume(_volume2);
	
	                // open modal
	                var existingOrderInfoWithTotalBatchVolume = BrewhouseStore.calculateBatchVolume(action.existingOrderInfo);
	
	                if (_.get(action, 'existingOrderInfo.orderSelected.isSingle')) {
	                    DashboardModalEl.openExistingSingleOrder(existingOrderInfoWithTotalBatchVolume);
	                } else {
	                    DashboardModalEl.openExistingBrewOrder(existingOrderInfoWithTotalBatchVolume);
	                }
	
	                // close context menu
	                ContextMenuEl.close();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_NEW_ORDER_DASHBOARD:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	
	                context._batchNumber = OrderStore.getNextBatchNumber();
	                var _volume3 = +_.get(action, 'preDefinedOrder.tankSelected.volume', 0);
	
	                // prepare Modal
	                DashboardModalStore.setCurrentLayout(getMinimalLayoutFromBatchNumber(context._batchNumber));
	                DashboardModalStore.setPristineVolume(_volume3);
	                DashboardModalStore.setVolume(_volume3);
	
	                // open modal
	                action.preDefinedOrder.batchNumber = context._batchNumber;
	                DashboardModalEl.openNewOrder(action.preDefinedOrder);
	
	                // close context menu
	                ContextMenuEl.close();
	                break;
	            }
	
	        case ActionTypes.CONTEXT_MENU_CHANGE_ORDER_DASHBOARD:
	            {
	                if (DashboardStore.isPublishingDraft()) {
	                    Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	                    return;
	                }
	                DashboardLayoutStore.setAsRelocatedPositions(_.get(action, 'existingOrderInfo.orderSelected.batchNumber'));
	                var existingOrderWithTotalBatchVolume = BrewhouseStore.calculateBatchVolume(action.existingOrderInfo);
	                var orderSelected = _.get(existingOrderWithTotalBatchVolume, 'orderSelected');
	                context._pristineVolume = +_.get(orderSelected, 'volume', 0);
	                var batchNumber = _.get(orderSelected, 'batchNumber');
	                var _volume4 = +_.get(action, 'existingOrderInfo.orderSelected.volume', 0);
	
	                // prepare Modal
	                DashboardModalStore.setPristineVolume(_volume4);
	                DashboardModalStore.setVolume(_volume4);
	                DashboardModalStore.setCurrentLayout(getMinimalLayoutFromBatchNumber(orderSelected.batchNumber));
	
	                // open modal
	                var batchVolumeInfo = BrewhouseStore.calculateBatchVolume(existingOrderWithTotalBatchVolume, batchNumber, DashboardModalStore.getCurrentLayout());
	                existingOrderWithTotalBatchVolume = _.merge(existingOrderWithTotalBatchVolume, batchVolumeInfo);
	
	                if (_.get(action, 'existingOrderInfo.orderSelected.isSingle')) {
	                    DashboardModalEl.openExistingSingleOrder(existingOrderWithTotalBatchVolume);
	                } else {
	                    DashboardModalEl.openExistingBrewOrder(existingOrderWithTotalBatchVolume);
	                }
	
	                // close context menu
	                ContextMenuEl.close();
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_MODAL_CLOSE_MODAL:
	            {
	                DashboardModalStore.cleanStore();
	                DashboardModalEl.close();
	                break;
	            }
	
	        case ActionTypes.DASHBOARD_SWITCH_CLOSE_MODAL:
	            {
	                DashboardModalStore.cleanStore();
	                DashboardModalEl.close();
	                break;
	            }
	
	        case ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_OCCUPIED:
	            {
	                if (ContentUtils.isGhostOrder(_.get(action, 'existingOrderInfo.orderSelected'))) {
	                    // in case that we clicked on order in wrong state, we want to do nothing.
	                    return;
	                }
	                var existingOrderInfo = _.get(action, 'existingOrderInfo');
	                DashboardLayoutStore.setAsRelocatedPositions(_.get(existingOrderInfo, 'orderSelected.batchNumber'));
	                var _orderSelected = _.get(existingOrderInfo, 'orderSelected');
	                var _volume5 = +_.get(_orderSelected, 'volume', 0);
	                var _batchNumber = _.get(action, 'existingOrderInfo.orderSelected.batchNumber');
	                var _batchVolumeInfo = BrewhouseStore.calculateBatchVolume(existingOrderInfo, _batchNumber, DashboardModalStore.getCurrentLayout());
	                var existingOrderInfoUpdated = _.merge(existingOrderInfo, _batchVolumeInfo);
	
	                // prepare Modal
	                DashboardModalStore.setPristineVolume(_volume5);
	                DashboardModalStore.setVolume(_volume5);
	                DashboardModalStore.setCurrentLayout(getMinimalLayoutFromBatchNumber(_orderSelected.batchNumber));
	
	                // open modal
	                if (_.get(_orderSelected, 'isSingle')) {
	                    DashboardModalEl.openExistingSingleOrder(existingOrderInfoUpdated);
	                } else {
	                    DashboardModalEl.openExistingBrewOrder(existingOrderInfoUpdated);
	                }
	                break;
	            }
	        default:
	    }
	});
	
	function _updateLayoutWithOrder(layout, order) {
	    if (order) {
	        return _.map(layout, function (position) {
	            var isOrderTarget = ContentUtils.cleanId(position.i) === order.id;
	            if (isOrderTarget) {
	                position.batchNumber = _.get(order, 'batchNumber');
	                position.volume = _.get(order, 'volume');
	            }
	            return position;
	        });
	    }
	    return layout;
	}
	
	/**
	 * Standardise the input actions to work in the same way to different scenarios.
	 * @param action
	 * @return {*}
	 */
	function _prepareOrderFromAction(action) {
	    // check actions values first over order values
	    var order = _.cloneDeep(_.get(action, 'order') || {}); // clone to prevent unwanted changes in edit mode
	    var volume = _.get(action, 'volume') || _.get(order, 'volume');
	    var isSingle = _.get(action, 'isSingle') || _.get(order, 'isSingle');
	
	    // prepare virtual/existing order to be handler after properly
	    order.isSingle = isSingle;
	    order.volume = volume || DashboardModalStore.getLastManualVolume();
	    order = _updateBatchNumber(order, action);
	    // order = _updateOrderWithLastManualTask(order);
	
	    // get all another orders with the same batch number
	    var anotherOrdersWithSameBatchNumber = _.filter(DashboardServiceCache.getOrders(), function (orderStored) {
	        return orderStored.batchNumber === order.batchNumber && orderStored.id != order.id;
	    });
	    var existAnotherOrderWithSameBachNumber = _.get(anotherOrdersWithSameBatchNumber, 'length', 0) > 0;
	
	    if (existAnotherOrderWithSameBachNumber) {
	        // put all orders in the same array to process each task from whole batch of orders.
	        var allOrdersOfTheBatch = _.concat(anotherOrdersWithSameBatchNumber, _.cloneDeep(order)); // clone to prevent unwanted changes
	
	        // if exist another order with the same batch number we need to identifier which task
	        // came from which order. So to do that, we need to add some orderId identifier to each task
	        var allOrdersOfTheBatchWhithOrderId = _markEachTaskFromOrderId(allOrdersOfTheBatch);
	
	        // put in the same array all task from all orders with the same batch number
	        var allTaskOfTheBatch = [];
	
	        for (var _iterator3 = allOrdersOfTheBatchWhithOrderId, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
	            var _ref3;
	
	            if (_isArray3) {
	                if (_i3 >= _iterator3.length) break;
	                _ref3 = _iterator3[_i3++];
	            } else {
	                _i3 = _iterator3.next();
	                if (_i3.done) break;
	                _ref3 = _i3.value;
	            }
	
	            var orderFromBatch = _ref3;
	
	            var tasksFromOrder = _getTaskFromOrderAndSetOrderId(orderFromBatch);
	            allTaskOfTheBatch.push(tasksFromOrder);
	        }
	
	        // update special list which contain the task with product properly updated
	        order.taskWithProductUpdates = _.filter(_.flatten(allTaskOfTheBatch), function (task) {
	            return task;
	        });
	    } else {
	        // enter here means the order don't have any order
	        // with the same batch number
	        var taskFromOrder = _getTaskFromOrderAndSetOrderId(order);
	
	        // update special list which contain the task with product properly updated
	        order.taskWithProductUpdates = taskFromOrder;
	    }
	
	    // remove undefined positions
	    order.taskWithProductUpdates = _.filter(order.taskWithProductUpdates, function (task) {
	        return task;
	    });
	
	    // update total batch cost only should be updated on NEW MODE.
	    order = addingBatchCost(order, action);
	
	    return order;
	}
	
	function addingBatchCost(order, action) {
	    if (isNewOrder(action)) {
	        order.totalBatchCost = '0';
	    } else {
	        order.totalBatchCost = BrewhouseStore.calculateCostByOrder(order, DashboardServiceCache.getVendorItems());
	    }
	    return order;
	}
	
	function isNewOrder(action) {
	    return action.type === 'DASHBOARD_MODAL_OPEN_NEW_ORDER' || action.type === 'DASHBOARD_MODAL_CHANGE_BEER_STYLE';
	}
	
	function _updateBatchNumber(order, action) {
	    var isBatchNumberChanged = _.get(order, 'batchNumber') !== _.get(action, 'batchNumber');
	
	    if (isBatchNumberChanged) {
	        order.oldBatchNumber = _.get(order, 'batchNumber');
	    }
	
	    order.batchNumber = _.get(action, 'batchNumber') || DashboardModalStore.getLastManualBatchNumber();
	
	    return order;
	}
	
	/**
	 * Assign the order id identifier to each task of the order.
	 * @param orders
	 * @return {*}
	 * @private
	 */
	function _markEachTaskFromOrderId(orders) {
	    if (orders) {
	        var _loop = function _loop() {
	            if (_isArray4) {
	                if (_i4 >= _iterator4.length) return 'break';
	                _ref4 = _iterator4[_i4++];
	            } else {
	                _i4 = _iterator4.next();
	                if (_i4.done) return 'break';
	                _ref4 = _i4.value;
	            }
	
	            var order = _ref4;
	
	            if (order.isSingle) {
	                order.singleTasks = _.map(order.singleTasks || [], function (task) {
	                    task.orderId = order.id;
	                    return task;
	                });
	            } else {
	                order.fermenterTasks = _.map(order.fermenterTasks || [], function (task) {
	                    task.orderId = order.id;
	                    return task;
	                });
	                order.packagingTasks = _.map(order.packagingTasks || [], function (task) {
	                    task.orderId = order.id;
	                    return task;
	                });
	            }
	            order.batchs = _.map(order.batchs || [], function (task) {
	                task.orderId = order.id;
	                return task;
	            });
	        };
	
	        for (var _iterator4 = orders, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
	            var _ref4;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	    }
	
	    return orders;
	}
	
	function _getTaskFromOrderAndSetOrderId(order) {
	    var orderId = _.get(order, 'id');
	    if (order.isSingle) {
	        var tasks = _.concat(order.singleTasks, order.batchs);
	        return _hydratedTasksWithOrderId(tasks, orderId);
	    } else {
	        var _tasks = _.concat(order.batchs, order.fermenterTasks, order.packagingTasks);
	        return _hydratedTasksWithOrderId(_tasks, orderId);
	    }
	}
	
	/*function _updateOrderWithLastManualTask(order) {
	    const lastManualTasks = DashboardModalStore.getLastManualTask();
	    if (order && ContentUtils.isNotEmptyArray(lastManualTasks)) {
	        for (const manualTask of lastManualTasks) {
	            let taskFieldName;
	
	            const conf = ContentUtils.getTankTypeConfiguration(_.get(manualTask, 'sectionType'));
	            if (conf) {
	                taskFieldName = _.get(conf, 'tasksFieldName');
	            }
	
	            if (taskFieldName) {
	                const existingTask = order[taskFieldName];
	                let removeManualTask = _removeDefaultTask(existingTask, manualTask) || [];
	                removeManualTask.push(manualTask);
	                order[taskFieldName] = removeManualTask;
	            }
	        }
	    }
	    return order;
	}*/
	
	/*
	function _removeDefaultTask(tasks, manualTasks) {
	    if (!tasks || !manualTasks) {
	        return tasks;
	    }
	
	    if (manualTasks.turn) {
	        // is batch tasks
	        return tasks.filter(task => String(task.turnId) !== String(manualTasks.turnId));
	    }
	    
	    if (!Array.isArray(manualTasks)) {
	        manualTasks = [manualTasks];
	    }
	    
	    return _.filter(tasks, task => {
	        return !_.some(manualTasks, manualTask =>
	            (
	                _.get(task, 'date') === _.get(manualTask, 'date') &&
	                _.get(task, 'sectionType') === _.get(manualTask, 'sectionType'))
	        );
	    });
	}
	*/
	
	function _hydratedTasksWithOrderId(tasks, orderId) {
	    if (tasks && orderId) {
	        return _.map(tasks, function (task) {
	            if (task) {
	                task.orderId = orderId;
	            }
	            return task;
	        });
	    }
	    return tasks;
	}
	
	module.exports = DashboardModalStore;

/***/ },
/* 156 */
/***/ function(module, exports) {

	'use strict';
	
	var _dashboardSpinnerEl = void 0,
	
	/**
	 * The Basic dialog popup.
	 * @type {{setElement: Function, show: Function}}
	 */
	CustomDialog = {
	    /**
	     * In order to use custom dialog, this are hosted in the main App module. And then,
	     * available through this Object for the rest of the application.
	     * @param notificationEl
	     */
	    setElement: function setElement(notificationEl) {
	        _dashboardSpinnerEl = notificationEl;
	    },
	    show: function show() {
	        if (_dashboardSpinnerEl) {
	            _dashboardSpinnerEl.show(arguments);
	        }
	    },
	    hide: function hide() {
	        if (_dashboardSpinnerEl) {
	            _dashboardSpinnerEl.hide(arguments);
	        }
	    }
	};
	
	module.exports = CustomDialog;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(640);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var defineDataProperty = __webpack_require__(307);
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var supportsDescriptors = __webpack_require__(310)();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object) {
			if (predicate === true) {
				if (object[name] === value) {
					return;
				}
			} else if (!isFunction(predicate) || !predicate()) {
				return;
			}
		}
	
		if (supportsDescriptors) {
			defineDataProperty(object, name, value, true);
		} else {
			defineDataProperty(object, name, value);
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Error = __webpack_require__(807);
	var $EvalError = __webpack_require__(806);
	var $RangeError = __webpack_require__(808);
	var $ReferenceError = __webpack_require__(809);
	var $SyntaxError = __webpack_require__(416);
	var $TypeError = __webpack_require__(133);
	var $URIError = __webpack_require__(810);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(818)();
	var hasProto = __webpack_require__(817)();
	
	var getProto = Object.getPrototypeOf || (
		hasProto
			? function (x) { return x.__proto__; } // eslint-disable-line no-proto
			: null
	);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(309);
	var hasOwn = __webpack_require__(819);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	var $exec = bind.call(Function.call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 159 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 160 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments to numbers.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var copyObjectWith = __webpack_require__(340);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object) {
	  return copyObjectWith(source, props, object);
	}
	
	module.exports = copyObject;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    get = __webpack_require__(163);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length == 1 ? object : get(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(327);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined` the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 164 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(164),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var BeforeAfterWrapper = __webpack_require__(514);
	
	var ClearFix = React.createClass({
	  displayName: 'ClearFix',
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var before = function before() {
	      return {
	        content: "' '",
	        display: 'table'
	      };
	    };
	
	    var after = before();
	    after.clear = 'both';
	
	    return React.createElement(
	      BeforeAfterWrapper,
	      _extends({}, other, {
	        beforeStyle: before(),
	        afterStyle: after,
	        style: this.props.style }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = ClearFix;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var Transitions = __webpack_require__(24);
	var Children = __webpack_require__(213);
	var ColorManipulator = __webpack_require__(102);
	var ImmutabilityHelper = __webpack_require__(147);
	var Typography = __webpack_require__(119);
	var EnhancedButton = __webpack_require__(88);
	var FlatButtonLabel = __webpack_require__(1117);
	
	function validateLabel(props, propName, componentName) {
	  if (!props.children && !props.label) {
	    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
	  }
	}
	
	var FlatButton = React.createClass({
	  displayName: 'FlatButton',
	
	  mixins: [PureRenderMixin],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    disabled: React.PropTypes.bool,
	    hoverColor: React.PropTypes.string,
	    label: validateLabel,
	    labelPosition: React.PropTypes.oneOf(['before', 'after']),
	    labelStyle: React.PropTypes.object,
	    onKeyboardFocus: React.PropTypes.func,
	    onMouseEnter: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    onTouchStart: React.PropTypes.func,
	    primary: React.PropTypes.bool,
	    rippleColor: React.PropTypes.string,
	    secondary: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      labelStyle: {},
	      labelPosition: 'before',
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      onTouchStart: function onTouchStart() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    };
	  },
	
	  getContextProps: function getContextProps() {
	    var theme = this.context.muiTheme;
	    var buttonTheme = theme.component.button;
	    var flatButtonTheme = theme.component.flatButton;
	
	    return {
	      buttonColor: flatButtonTheme.color,
	      buttonHeight: buttonTheme.height,
	      buttonMinWidth: buttonTheme.minWidth,
	      disabledTextColor: flatButtonTheme.disabledTextColor,
	      primaryTextColor: flatButtonTheme.primaryTextColor,
	      secondaryTextColor: flatButtonTheme.secondaryTextColor,
	      textColor: flatButtonTheme.textColor
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var disabled = _props.disabled;
	    var hoverColor = _props.hoverColor;
	    var label = _props.label;
	    var labelStyle = _props.labelStyle;
	    var labelPosition = _props.labelPosition;
	    var onKeyboardFocus = _props.onKeyboardFocus;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var onTouchStart = _props.onTouchStart;
	    var primary = _props.primary;
	    var rippleColor = _props.rippleColor;
	    var secondary = _props.secondary;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'label', 'labelStyle', 'labelPosition', 'onKeyboardFocus', 'onMouseLeave', 'onMouseEnter', 'onTouchStart', 'primary', 'rippleColor', 'secondary', 'style']);
	
	    var contextProps = this.getContextProps();
	
	    var defaultColor = disabled ? contextProps.disabledTextColor : primary ? contextProps.primaryTextColor : secondary ? contextProps.secondaryTextColor : contextProps.textColor;
	
	    var defaultHoverColor = ColorManipulator.fade(ColorManipulator.lighten(defaultColor, 0.4), 0.15);
	    var defaultRippleColor = ColorManipulator.fade(defaultColor, 0.8);
	    var buttonHoverColor = hoverColor || defaultHoverColor;
	    var buttonRippleColor = rippleColor || defaultRippleColor;
	    var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	    var mergedRootStyles = ImmutabilityHelper.merge({
	      color: defaultColor,
	      transition: Transitions.easeOut(),
	      fontSize: Typography.fontStyleButtonFontSize,
	      letterSpacing: 0,
	      textTransform: 'uppercase',
	      fontWeight: Typography.fontWeightMedium,
	      borderRadius: 2,
	      userSelect: 'none',
	      position: 'relative',
	      overflow: 'hidden',
	      backgroundColor: hovered ? buttonHoverColor : contextProps.buttonColor,
	      lineHeight: contextProps.buttonHeight + 'px',
	      minWidth: contextProps.buttonMinWidth,
	      padding: 0,
	      margin: 0,
	      //This is need so that ripples do not bleed past border radius.
	      //See: http://stackoverflow.com/questions/17298739
	      transform: 'translate3d(0, 0, 0)'
	    }, style);
	
	    var labelElement = label ? React.createElement(FlatButtonLabel, { label: label, style: labelStyle }) : undefined;
	    // Place label before or after children.
	    var childrenFragment = labelPosition === 'before' ? { labelElement: labelElement, children: children } : { children: children, labelElement: labelElement };
	    var enhancedButtonChildren = Children.create(childrenFragment);
	
	    return React.createElement(
	      EnhancedButton,
	      _extends({}, other, {
	        disabled: disabled,
	        focusRippleColor: buttonRippleColor,
	        onKeyboardFocus: this._handleKeyboardFocus,
	        onMouseLeave: this._handleMouseLeave,
	        onMouseEnter: this._handleMouseEnter,
	        onTouchStart: this._handleTouchStart,
	        style: mergedRootStyles,
	        touchRippleColor: buttonRippleColor }),
	      enhancedButtonChildren
	    );
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
	    this.setState({ isKeyboardFocused: isKeyboardFocused });
	    this.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    //Cancel hover styles for touch devices
	    if (!this.state.touch) this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({ touch: true });
	    this.props.onTouchStart(e);
	  }
	
	});
	
	module.exports = FlatButton;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var PropTypes = __webpack_require__(171);
	var EnhancedButton = __webpack_require__(88);
	var FontIcon = __webpack_require__(118);
	var Tooltip = __webpack_require__(365);
	var Children = __webpack_require__(213);
	
	var IconButton = React.createClass({
	  displayName: 'IconButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    disabled: React.PropTypes.bool,
	    iconClassName: React.PropTypes.string,
	    iconStyle: React.PropTypes.object,
	    onBlur: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    onKeyboardFocus: React.PropTypes.func,
	    tooltip: React.PropTypes.string,
	    tooltipStyles: React.PropTypes.object,
	    tooltipPosition: PropTypes.cornersAndCenter,
	    touch: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      tooltipShown: false
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      iconStyle: {},
	      tooltipPosition: 'bottom-center'
	    };
	  },
	
	  getStyles: function getStyles() {
	    var spacing = this.context.muiTheme.spacing;
	    var palette = this.context.muiTheme.palette;
	
	    var styles = {
	      root: {
	        position: 'relative',
	        boxSizing: 'border-box',
	        transition: Transitions.easeOut(),
	        padding: spacing.iconSize / 2,
	        width: spacing.iconSize * 2,
	        height: spacing.iconSize * 2,
	        fontSize: 0
	      },
	      tooltip: {
	        boxSizing: 'border-box'
	      },
	      icon: {
	        color: palette.textColor,
	        fill: palette.textColor
	      },
	      overlay: {
	        position: 'relative',
	        top: 0,
	        width: '100%',
	        height: '100%',
	        background: palette.disabledColor
	      },
	      disabled: {
	        color: palette.disabledColor,
	        fill: palette.disabledColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var iconClassName = _props.iconClassName;
	    var tooltip = _props.tooltip;
	    var touch = _props.touch;
	    var iconStyle = _props.iconStyle;
	
	    var other = _objectWithoutProperties(_props, ['disabled', 'iconClassName', 'tooltip', 'touch', 'iconStyle']);
	
	    var fonticon = undefined;
	
	    var styles = this.getStyles();
	    var tooltipPosition = this.props.tooltipPosition.split('-');
	
	    var tooltipElement = tooltip ? React.createElement(Tooltip, {
	      ref: 'tooltip',
	      label: tooltip,
	      show: this.state.tooltipShown,
	      touch: touch,
	      style: this.mergeStyles(styles.tooltip, this.props.tooltipStyles),
	      verticalPosition: tooltipPosition[0],
	      horizontalPosition: tooltipPosition[1] }) : null;
	
	    if (iconClassName) {
	      var iconHoverColor = iconStyle.iconHoverColor;
	
	      var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);
	
	      fonticon = React.createElement(
	        FontIcon,
	        {
	          className: iconClassName,
	          hoverColor: disabled ? null : iconHoverColor,
	          style: this.mergeStyles(styles.icon, disabled ? styles.disabled : {}, iconStyleFontIcon) },
	        this.props.children
	      );
	    }
	
	    var childrenStyle = disabled ? this.mergeStyles(iconStyle, styles.disabled) : iconStyle;
	
	    return React.createElement(
	      EnhancedButton,
	      _extends({}, other, {
	        ref: 'button',
	        centerRipple: true,
	        disabled: disabled,
	        style: this.mergeStyles(styles.root, this.props.style),
	        onBlur: this._handleBlur,
	        onFocus: this._handleFocus,
	        onMouseLeave: this._handleMouseLeave,
	        onMouseEnter: this._handleMouseEnter,
	        onKeyboardFocus: this._handleKeyboardFocus }),
	      tooltipElement,
	      fonticon,
	      Children.extend(this.props.children, {
	        style: childrenStyle
	      })
	    );
	  },
	
	  setKeyboardFocus: function setKeyboardFocus() {
	    this.refs.button.setKeyboardFocus();
	  },
	
	  _showTooltip: function _showTooltip() {
	    if (!this.props.disabled && this.props.tooltip) {
	      this.setState({ tooltipShown: true });
	    }
	  },
	
	  _hideTooltip: function _hideTooltip() {
	    if (this.props.tooltip) this.setState({ tooltipShown: false });
	  },
	
	  _handleBlur: function _handleBlur(e) {
	    this._hideTooltip();
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	
	  _handleFocus: function _handleFocus(e) {
	    this._showTooltip();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.button.isKeyboardFocused()) this._hideTooltip();
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this._showTooltip();
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this._showTooltip();
	      if (this.props.onFocus) this.props.onFocus(e);
	    } else if (!this.state.hovered) {
	      this._hideTooltip();
	      if (this.props.onBlur) this.props.onBlur(e);
	    }
	
	    if (this.props.onKeyboardFocus) this.props.onKeyboardFocus(e, keyboardFocused);
	  }
	
	});
	
	module.exports = IconButton;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  AutoPrefix: __webpack_require__(63),
	  Colors: __webpack_require__(56),
	  Spacing: __webpack_require__(527),
	  ThemeManager: __webpack_require__(528),
	  Transitions: __webpack_require__(24),
	  Typography: __webpack_require__(119)
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(121);
	
	module.exports = {
	
	  _testSupportedProps: function _testSupportedProps(props) {
	    var i = undefined,
	        el = document.createElement('div');
	
	    for (i in props) {
	      if (props.hasOwnProperty(i) && el.style[i] !== undefined) {
	        return props[i];
	      }
	    }
	  },
	
	  //Returns the correct event name to use
	  transitionEndEventName: function transitionEndEventName() {
	    return this._testSupportedProps({
	      'transition': 'transitionend',
	      'OTransition': 'otransitionend',
	      'MozTransition': 'transitionend',
	      'WebkitTransition': 'webkitTransitionEnd'
	    });
	  },
	
	  animationEndEventName: function animationEndEventName() {
	    return this._testSupportedProps({
	      'animation': 'animationend',
	      '-o-animation': 'oAnimationEnd',
	      '-moz-animation': 'animationend',
	      '-webkit-animation': 'webkitAnimationEnd'
	    });
	  },
	
	  onTransitionEnd: function onTransitionEnd(el, callback) {
	    var transitionEnd = this.transitionEndEventName();
	
	    Events.once(el, transitionEnd, function () {
	      return callback();
	    });
	  },
	
	  onAnimationEnd: function onAnimationEnd(el, callback) {
	    var animationEnd = this.animationEndEventName();
	
	    Events.once(el, animationEnd, function () {
	      return callback();
	    });
	  }
	};

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	module.exports = {
	
	  corners: React.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  cornersAndCenter: React.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
	
	  zDepth: React.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 172 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Actions that modify the URL.
	 */
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: "push",
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: "replace",
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: "pop"
	
	};
	
	module.exports = LocationActions;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1304);
	var warning = __webpack_require__(32);
	
	function shouldIgnoreValue(name, value) {
	  return value == null ||
	    (DOMProperty.hasBooleanValue[name] && !value) ||
	    (DOMProperty.hasNumericValue[name] && isNaN(value)) ||
	    (DOMProperty.hasPositiveNumericValue[name] && (value < 1)) ||
	    (DOMProperty.hasOverloadedBooleanValue[name] && value === false);
	}
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function(name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] ||
	        warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = (
	      DOMProperty.isCustomAttribute(lowerCasedName) ?
	        lowerCasedName :
	      DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ?
	        DOMProperty.getPossibleStandardName[lowerCasedName] :
	        null
	    );
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      standardName == null,
	      'Unknown DOM property %s. Did you mean %s?',
	      name,
	      standardName
	    ) : null);
	
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' +
	      quoteAttributeValueForBrowser(id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function(name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      if (shouldIgnoreValue(name, value)) {
	        return '';
	      }
	      var attributeName = DOMProperty.getAttributeName[name];
	      if (DOMProperty.hasBooleanValue[name] ||
	          (DOMProperty.hasOverloadedBooleanValue[name] && value === true)) {
	        return attributeName;
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function(node, name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(name, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        node.setAttribute(DOMProperty.getAttributeName[name], '' + value);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== ('' + value)) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        node.removeAttribute(name);
	      } else {
	        node.setAttribute(name, '' + value);
	      }
	    } else if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function(node, name) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.removeAttribute(DOMProperty.getAttributeName[name]);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        var defaultValue = DOMProperty.getDefaultValueForProperty(
	          node.nodeName,
	          propName
	        );
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactFragment = __webpack_require__(149);
	var ReactPropTypeLocations = __webpack_require__(384);
	var ReactPropTypeLocationNames = __webpack_require__(222);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactNativeComponent = __webpack_require__(221);
	
	var getIteratorFn = __webpack_require__(680);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	var NUMERIC_PROPERTY_REGEX = /^\d+$/;
	
	/**
	 * Gets the instance's name for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getName(instance) {
	  var publicInstance = instance && instance.getPublicInstance();
	  if (!publicInstance) {
	    return undefined;
	  }
	  var constructor = publicInstance.constructor;
	  if (!constructor) {
	    return undefined;
	  }
	  return constructor.displayName || constructor.name || undefined;
	}
	
	/**
	 * Gets the current owner's displayName for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getCurrentOwnerDisplayName() {
	  var current = ReactCurrentOwner.current;
	  return (
	    current && getName(current) || undefined
	  );
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  warnAndMonitorForKeyUse(
	    'Each child in an array or iterator should have a unique "key" prop.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Warn if the key is being defined as an object property but has an incorrect
	 * value.
	 *
	 * @internal
	 * @param {string} name Property name of the key.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validatePropertyKey(name, element, parentType) {
	  if (!NUMERIC_PROPERTY_REGEX.test(name)) {
	    return;
	  }
	  warnAndMonitorForKeyUse(
	    'Child objects should have non-numeric keys so ordering is preserved.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} message The base warning that gets output.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function warnAndMonitorForKeyUse(message, element, parentType) {
	  var ownerName = getCurrentOwnerDisplayName();
	  var parentName = typeof parentType === 'string' ?
	    parentType : parentType.displayName || parentType.name;
	
	  var useName = ownerName || parentName;
	  var memoizer = ownerHasKeyUseWarning[message] || (
	    (ownerHasKeyUseWarning[message] = {})
	  );
	  if (memoizer.hasOwnProperty(useName)) {
	    return;
	  }
	  memoizer[useName] = true;
	
	  var parentOrOwnerAddendum =
	    ownerName ? (" Check the render method of " + ownerName + ".") :
	    parentName ? (" Check the React.render call using <" + parentName + ">.") :
	    '';
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwnerAddendum = '';
	  if (element &&
	      element._owner &&
	      element._owner !== ReactCurrentOwner.current) {
	    // Name of the component that originally created this child.
	    var childOwnerName = getName(element._owner);
	
	    childOwnerAddendum = (" It was passed a child from " + childOwnerName + ".");
	  }
	
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	    false,
	    message + '%s%s See https://fb.me/react-warning-keys for more information.',
	    parentOrOwnerAddendum,
	    childOwnerAddendum
	  ) : null);
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    node._store.validated = true;
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    } else if (typeof node === 'object') {
	      var fragment = ReactFragment.extractIfFragment(node);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          validatePropertyKey(key, fragment[key], parentType);
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          typeof propTypes[propName] === 'function',
	          '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	          'React.PropTypes.',
	          componentName || 'React class',
	          ReactPropTypeLocationNames[location],
	          propName
	        ) : invariant(typeof propTypes[propName] === 'function'));
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(this);
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(false, 'Failed propType: %s%s', error.message, addendum) : null);
	      }
	    }
	  }
	}
	
	var warnedPropsMutations = {};
	
	/**
	 * Warn about mutating props when setting `propName` on `element`.
	 *
	 * @param {string} propName The string key within props that was set
	 * @param {ReactElement} element
	 */
	function warnForPropsMutation(propName, element) {
	  var type = element.type;
	  var elementName = typeof type === 'string' ? type : type.displayName;
	  var ownerName = element._owner ?
	    element._owner.getPublicInstance().constructor.displayName : null;
	
	  var warningKey = propName + '|' + elementName + '|' + ownerName;
	  if (warnedPropsMutations.hasOwnProperty(warningKey)) {
	    return;
	  }
	  warnedPropsMutations[warningKey] = true;
	
	  var elementInfo = '';
	  if (elementName) {
	    elementInfo = ' <' + elementName + ' />';
	  }
	  var ownerInfo = '';
	  if (ownerName) {
	    ownerInfo = ' The element was created by ' + ownerName + '.';
	  }
	
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	    false,
	    'Don\'t set .props.%s of the React component%s. Instead, specify the ' +
	    'correct value when initially creating the element or use ' +
	    'React.cloneElement to make a new element with updated props.%s',
	    propName,
	    elementInfo,
	    ownerInfo
	  ) : null);
	}
	
	// Inline Object.is polyfill
	function is(a, b) {
	  if (a !== a) {
	    // NaN
	    return b !== b;
	  }
	  if (a === 0 && b === 0) {
	    // +-0
	    return 1 / a === 1 / b;
	  }
	  return a === b;
	}
	
	/**
	 * Given an element, check if its props have been mutated since element
	 * creation (or the last call to this function). In particular, check if any
	 * new props have been added, which we can't directly catch by defining warning
	 * properties on the props object.
	 *
	 * @param {ReactElement} element
	 */
	function checkAndWarnForMutatedProps(element) {
	  if (!element._store) {
	    // Element was created using `new ReactElement` directly or with
	    // `ReactElement.createElement`; skip mutation checking
	    return;
	  }
	
	  var originalProps = element._store.originalProps;
	  var props = element.props;
	
	  for (var propName in props) {
	    if (props.hasOwnProperty(propName)) {
	      if (!originalProps.hasOwnProperty(propName) ||
	          !is(originalProps[propName], props[propName])) {
	        warnForPropsMutation(propName, element);
	
	        // Copy over the new value so that the two props objects match again
	        originalProps[propName] = props[propName];
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  if (element.type == null) {
	    // This has already warned. Don't throw.
	    return;
	  }
	  // Extract the component class from the element. Converts string types
	  // to a composite class which may have propTypes.
	  // TODO: Validating a string's propTypes is not decoupled from the
	  // rendering target which is problematic.
	  var componentClass = ReactNativeComponent.getComponentClassForElement(
	    element
	  );
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(
	      name,
	      componentClass.propTypes,
	      element.props,
	      ReactPropTypeLocations.prop
	    );
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      componentClass.getDefaultProps.isReactClassApproved,
	      'getDefaultProps is only used on classic React.createClass ' +
	      'definitions. Use a static property named `defaultProps` instead.'
	    ) : null);
	  }
	}
	
	var ReactElementValidator = {
	
	  checkAndWarnForMutatedProps: checkAndWarnForMutatedProps,
	
	  createElement: function(type, props, children) {
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      type != null,
	      'React.createElement: type should not be null or undefined. It should ' +
	        'be a string (for DOM elements) or a ReactClass (for composite ' +
	        'components).'
	    ) : null);
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], type);
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function(type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(
	      null,
	      type
	    );
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      try {
	        Object.defineProperty(
	          validatedFactory,
	          'type',
	          {
	            enumerable: false,
	            get: function() {
	              ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	                false,
	                'Factory.type is deprecated. Access the class directly ' +
	                'before passing it to createFactory.'
	              ) : null);
	              Object.defineProperty(this, 'type', {
	                value: type
	              });
	              return type;
	            }
	          }
	        );
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	
	    return validatedFactory;
	  },
	
	  cloneElement: function(element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule cloneWithProps
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactPropTransferer = __webpack_require__(1261);
	
	var keyOf = __webpack_require__(81);
	var warning = __webpack_require__(32);
	
	var CHILDREN_PROP = keyOf({children: null});
	
	/**
	 * Sometimes you want to change the props of a child passed to you. Usually
	 * this is to add a CSS class.
	 *
	 * @param {ReactElement} child child element you'd like to clone
	 * @param {object} props props you'd like to modify. className and style will be
	 * merged automatically.
	 * @return {ReactElement} a clone of child with props merged in.
	 */
	function cloneWithProps(child, props) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      !child.ref,
	      'You are calling cloneWithProps() on a child with a ref. This is ' +
	      'dangerous because you\'re creating a new child which will not be ' +
	      'added as a ref to its parent.'
	    ) : null);
	  }
	
	  var newProps = ReactPropTransferer.mergeProps(props, child.props);
	
	  // Use `child.props.children` if it is provided.
	  if (!newProps.hasOwnProperty(CHILDREN_PROP) &&
	      child.props.hasOwnProperty(CHILDREN_PROP)) {
	    newProps.children = child.props.children;
	  }
	
	  // The current API doesn't retain _owner and _context, which is why this
	  // doesn't use ReactElement.cloneAndReplaceProps.
	  return ReactElement.createElement(child.type, newProps);
	}
	
	module.exports = cloneWithProps;


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	"use strict";
	
	var emptyObject = {};
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    obj instanceof Object && !Array.isArray(obj),
	    'keyMirror(...): Argument must be an object.'
	  ) : invariant(obj instanceof Object && !Array.isArray(obj)));
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    mui = __webpack_require__(12),
	    ContentUtils = __webpack_require__(7),
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    debounce = _require2.debounce,
	    Loading = __webpack_require__(33),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    filter = _require3.filter,
	    includes = _require3.includes,
	    every = _require3.every,
	    _require4 = __webpack_require__(79),
	    capitalize = _require4.capitalize,
	    toLower = _require4.toLower,
	    trim = _require4.trim,
	    Pagination = __webpack_require__(713),
	    sortBy = __webpack_require__(8).sortBy,
	    get = __webpack_require__(5).get,
	    AppConstants = __webpack_require__(2),
	    TextFieldSuggested = __webpack_require__(230),
	    PositionUtil = __webpack_require__(59),
	    Table = mui.Table,
	    TableHeader = mui.TableHeader,
	    TableRow = mui.TableRow,
	    TableHeaderColumn = mui.TableHeaderColumn,
	    TableBody = mui.TableBody,
	    TableRowColumn = mui.TableRowColumn,
	    TextField = mui.TextField,
	    FontIcon = mui.FontIcon;
	
	
	var HeaderAppAndHeaderScaffoldingAndHeaderTable = 365,
	    timeToWaitUntilFinishWriteColumnSearching = 1000;
	
	var AdminScaffoldingTable = React.createClass({ displayName: "AdminScaffoldingTable",
	    propTypes: {
	        children: PropTypes.array,
	        headerActiveFilters: PropTypes.array,
	        columnNames: PropTypes.array,
	        displayAttributes: PropTypes.array,
	        isRowSelected: PropTypes.bool,
	        attributeId: PropTypes.string,
	        onRowSelection: PropTypes.func,
	        sortByColumn: PropTypes.array,
	        value: PropTypes.any,
	        customHeightTable: PropTypes.number,
	
	        onTypingFilter: PropTypes.func,
	        isLoading: PropTypes.bool,
	        currentPage: PropTypes.number,
	        maxPage: PropTypes.number,
	        onNextPage: PropTypes.function,
	        onPreviousPage: PropTypes.function,
	        onClickPage: PropTypes.function,
	        onCancel: PropTypes.function,
	        columnsFilterValue: PropTypes.object,
	        items: PropTypes.array
	    },
	
	    _isRowSelected: function _isRowSelected(item) {
	        var value = this.props.value;
	
	        return item.id === get(value, 'id', '-1');
	    },
	
	
	    _lastRowScrollPosition: null,
	
	    getInitialState: function getInitialState() {
	        return {
	            filters: []
	        };
	    },
	    _onRowSelection: function _onRowSelection(onRowSelection, items, indexRowSelected) {
	        var sortByColumn = this.props.sortByColumn;
	
	
	        if (sortByColumn) {
	            items = sortBy(items, function (row) {
	                return toLower(get(row, sortByColumn, []));
	            });
	        }
	
	        items = this._applyFiltersIfNeeded(items);
	
	        // filter disable items
	        items = ContentUtils.filterEnable(items);
	
	        // delay selection row a little bit in order to give some
	        // time finish the selection table animation.
	        var itemSelected = items[indexRowSelected];
	        var indexRowSelectedItem = get(indexRowSelected, '0');
	        var _lastRowClickedPosition = this._lastRowScrollPosition;
	
	        var filterTargets = this._getFiltersTarget();
	
	        delay(function () {
	            onRowSelection(itemSelected, indexRowSelectedItem, _lastRowClickedPosition, filterTargets);
	        }, 50);
	    },
	    _onPreRowSelection: function _onPreRowSelection(evt) {
	        if (evt && evt.pageY) {
	            // save temporally the last position which
	            // had the table in order to return this
	            // position when the consumer refresh the
	            // scroll position
	            var parentScroll = PositionUtil.getParentScroll(evt.target);
	            this._lastRowScrollPosition = parentScroll.scrollTop;
	        }
	    },
	    _addFilter: function _addFilter(name, self, index) {
	        // I call an imperative way because we can't get the value from the evt.target
	        // because we lose them from debounce arguments
	        var match = "";
	        if (name !== "state" && name !== "displayPriority") {
	            match = self.refs['column-filter-' + index].getValue();
	        } else {
	            match = self.id;
	        }
	        var newFilter = {
	            name: name,
	            match: match
	        };
	
	        /* const isEmptyFilterValue = ContentUtils.isEmptyText(match) || !match;
	        if (isEmptyFilterValue) {
	            this.props.onClickPage(0);
	            this.props.onCancel();
	        } else { */
	        if (this.props.onTypingFilter) {
	            this.props.onTypingFilter(newFilter.name, newFilter.match);
	        }
	        /* } */
	    },
	    _applyFiltersIfNeeded: function _applyFiltersIfNeeded(rows) {
	        var enableRows = ContentUtils.filterEnable(rows);
	        var filterTarget = this._getFiltersTarget();
	        var userWroteSomeFilter = !ContentUtils.isEmptyArray(filterTarget);
	        var existsSomeRowToDisplay = !ContentUtils.isEmptyArray(rows);
	
	        if (userWroteSomeFilter && existsSomeRowToDisplay) {
	            return filter(enableRows, function (row) {
	                var applySomeFilter = every(filterTarget, function (filter) {
	                    var rowValue = get(row, filter.name, '');
	                    var matcher = toLower(trim(filter.match));
	                    var value = toLower(trim(rowValue));
	                    return value.indexOf(matcher) > -1;
	                });
	                return applySomeFilter;
	            });
	        }
	
	        return rows;
	    },
	
	
	    /**
	     * Retrieve the current filter which the current user are using.
	     * @return {*}
	     * @private
	     */
	    _getFiltersTarget: function _getFiltersTarget() {
	        var filters = this.state.filters;
	        var headerActiveFilters = this.props.headerActiveFilters;
	
	
	        var filterTarget = void 0;
	        var isInternalFilterNotDefined = !filters || filters.length == 0;
	
	        if (isInternalFilterNotDefined) {
	            filterTarget = headerActiveFilters;
	        } else {
	            filterTarget = filters || [];
	        }
	
	        return filterTarget;
	    },
	    _getHeaderColumns: function _getHeaderColumns() {
	        var _this = this;
	
	        var _props = this.props,
	            columnNames = _props.columnNames,
	            displayAttributes = _props.displayAttributes,
	            filteredColumns = _props.filteredColumns,
	            columnsFilterValue = _props.columnsFilterValue,
	            items = _props.items;
	
	
	        columnsFilterValue || {};
	
	        return map(displayAttributes, function (possibleColumnField, index) {
	            var isCustomField = (typeof possibleColumnField === 'undefined' ? 'undefined' : _typeof(possibleColumnField)) === 'object';
	            var columnField = isCustomField ? possibleColumnField.name : possibleColumnField;
	            var columnDisplay = get(columnNames, index, columnField);
	            var columnFilterValue = columnsFilterValue[columnField];
	            var isNeededFilter = includes(filteredColumns, columnField);
	            var columnDisplayUpper = capitalize(columnDisplay);
	
	            var classNameHeaderFilter = 'admin-table-header__filter';
	            var classNameHeaderFilterSuggested = 'classNameHeaderFilterSuggested';
	            var classNameHeaderFilterIcon = 'material-icons admin-table-header__icon';
	            var classNameHeaderFilterIconClear = 'material-icons admin-table-header__iconClear';
	
	            var itemSelected = {};
	            var hasItems = false;
	
	            if (items && items[columnField] !== undefined && items[columnField].length > 0) {
	                hasItems = true;
	                items[columnField].forEach(function (e) {
	                    if (columnFilterValue === e.id) {
	                        itemSelected = { id: e.id, state: e.state };
	                    }
	                });
	            }
	
	            var self = _this;
	            return React.createElement(TableHeaderColumn, {
	                className: "header-tank-column",
	                style: { paddingLeft: '8px' }
	            }, isNeededFilter ? hasItems ? React.createElement("div", null, itemSelected.id !== undefined && React.createElement(FontIcon, {
	                className: classNameHeaderFilterIconClear,
	                color: { color: '#e0e0e0' },
	                onClick: function onClick() {
	                    return self._addFilter(columnField, { id: "" }, index);
	                }
	            }, "clear"), React.createElement(FontIcon, {
	                color: { color: '#e0e0e0' },
	                className: classNameHeaderFilterIcon
	            }, "search"), React.createElement(TextFieldSuggested, {
	                items: items[columnField],
	                name: columnDisplay,
	                readerAttribute: "state",
	                readerAttributeValue: "id",
	                isRequired: false,
	                floatingLabelText: columnDisplayUpper,
	                value: itemSelected,
	                onItemSelected: function onItemSelected(e) {
	                    return self._addFilter(columnField, e, index);
	                },
	
	                classCSS: classNameHeaderFilterSuggested,
	                defaultValue: itemSelected
	            })) : React.createElement("div", null, React.createElement(FontIcon, {
	                color: { color: '#e0e0e0' },
	                className: classNameHeaderFilterIcon
	            }, "search"), React.createElement(TextField, {
	                ref: 'column-filter-' + index,
	                onChange: debounce(function () {
	                    self._addFilter(columnField, self, index);
	                }, timeToWaitUntilFinishWriteColumnSearching),
	
	                floatingLabelText: columnDisplayUpper,
	                className: classNameHeaderFilter,
	                defaultValue: ContentUtils.isEmptyText(columnFilterValue) ? '' : columnFilterValue
	            })) : columnDisplayUpper);
	        });
	    },
	    _getTableRowContent: function _getTableRowContent(item, attributeDisplay) {
	        var haveHTMLValue = !!attributeDisplay.getHTML;
	        var haveAttributeName = !!attributeDisplay.name;
	
	        if (!haveHTMLValue) {
	            return get(item, attributeDisplay.name);
	        } else if (haveHTMLValue && haveAttributeName) {
	            return attributeDisplay.getHTML(item, attributeDisplay.name);
	        } else if (haveHTMLValue && !haveAttributeName) {
	            return attributeDisplay.getHTML(item);
	        } else {
	            return item;
	        }
	    },
	    _getRows: function _getRows(sortedChildren) {
	        var _this2 = this;
	
	        var displayAttributes = this.props.displayAttributes;
	
	        var self = this;
	
	        var rowsEl = map(sortedChildren, function (item) {
	            var columnsEl = map(displayAttributes, function (attributeDisplay) {
	                var rowEl = void 0;
	                if (typeof attributeDisplay === 'string') {
	                    rowEl = React.createElement(TableRowColumn, {
	                        onClickCapture: _this2._onPreRowSelection
	                    }, get(item, attributeDisplay, ''));
	                } else {
	                    rowEl = React.createElement(TableRowColumn, {
	                        onClickCapture: _this2._onPreRowSelection
	                    }, _this2._getTableRowContent(item, attributeDisplay));
	                }
	                return rowEl;
	            });
	            var isSelectedRow = self._isRowSelected(item);
	            var tableRowClassName = 'admin-table-row';
	            if (isSelectedRow) {
	                tableRowClassName += ' is-selected';
	            }
	
	            var attributeId = get(item, 'attributeId') || get(item, 'id');
	
	            return React.createElement(TableRow, {
	                className: tableRowClassName,
	                style: { cursor: 'pointer' },
	                selected: isSelectedRow,
	                "data-row-id": attributeId
	            }, columnsEl);
	        });
	
	        return rowsEl;
	    },
	    someFilterHasSomeValue: function someFilterHasSomeValue() {
	        return get(map(this.props.columnsFilterValue, function (key) {
	            return key;
	        }).filter(function (value) {
	            return value !== '';
	        }), 'length') > 0;
	    },
	    render: function render() {
	        var _props2 = this.props,
	            onRowSelection = _props2.onRowSelection,
	            children = _props2.children,
	            sortByColumn = _props2.sortByColumn,
	            customHeightTable = _props2.customHeightTable,
	            currentPage = _props2.currentPage,
	            onNextPage = _props2.onNextPage,
	            onPreviousPage = _props2.onPreviousPage,
	            maxPage = _props2.maxPage,
	            onClickPage = _props2.onClickPage,
	            isLoading = _props2.isLoading;
	
	        var sortedChildren = void 0;
	        if (sortByColumn) {
	            sortedChildren = sortBy(children, function (row) {
	                return toLower(get(row, sortByColumn, ''));
	            });
	        }
	
	        var rowsFiltered = this._applyFiltersIfNeeded(sortedChildren || children);
	
	        var rowsWithoutDisabledItems = filterDisabledItems(rowsFiltered);
	        var rowsEl = this._getRows(rowsWithoutDisabledItems || children);
	        var columnsHeaderEl = this._getHeaderColumns();
	        var bodyEl = isLoading ? null : React.createElement(TableBody, {
	            className: "admin-table-body",
	            displayRowCheckbox: false,
	            deselectOnClickaway: false }, rowsEl);
	        var loadingEl = isLoading ? React.createElement("div", { className: "admin-scaffolding-table__loading" }, React.createElement(Loading, null), " ") : null;
	        var paginationEl = this.someFilterHasSomeValue() ? null : React.createElement(Pagination, {
	            currentPage: currentPage,
	            maxPage: maxPage,
	            onNextPage: onNextPage,
	            onPreviousPage: onPreviousPage,
	            onClickPage: onClickPage });
	        return React.createElement("div", { className: "admin-scaffolding-table" }, React.createElement(Table, { className: "admin-table",
	            selectable: true,
	            fixedHeader: true,
	            multiSelectable: false,
	            deselectOnClickaway: false,
	            preScanRowData: false,
	            onRowSelection: this._onRowSelection.bind(this, onRowSelection, children) }, React.createElement(TableHeader, {
	            displayRowCheckbox: false,
	            className: "admin-table-header",
	            style: { backgroundColor: '#838485' }
	        }, React.createElement(TableRow, {
	            className: "admin-table-header-row",
	            displayRowCheckbox: false
	        }, columnsHeaderEl)), bodyEl), loadingEl, React.createElement("div", { className: "admin-scaffolding-table__pagination" }, paginationEl));
	    }
	});
	
	function filterDisabledItems(items) {
	    // the items which dont have `enable` field for now, we take as enable.
	    return filter(items, function (item) {
	        return item.enable === undefined || item.enable === true;
	    });
	}
	
	module.exports = AdminScaffoldingTable;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1325);
	__webpack_require__(1342);
	
	var React = __webpack_require__(1);
	var PropTypes = React.PropTypes;
	
	var _require = __webpack_require__(12),
	    Dialog = _require.Dialog;
	
	var CustomModal = React.createClass({ displayName: "CustomModal",
	
	    propTypes: {
	        actions: PropTypes.array,
	        boolean: PropTypes.isVisible,
	        customClass: PropTypes.string,
	        customStyle: PropTypes.object,
	        title: PropTypes.string
	    },
	
	    /**
	     * The internal reference to modal element.
	     */
	    _el: null,
	
	    componentDidMount: function componentDidMount() {
	        this._changeVisible(this.props);
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._changeVisible(nextProps);
	    },
	    _changeVisible: function _changeVisible(nextProps) {
	        if (nextProps) {
	            if (nextProps.isVisible) {
	                this._el.show();
	            } else {
	                this._el.dismiss();
	            }
	        }
	    },
	    _getRef: function _getRef(el) {
	        this._el = el;
	    },
	    render: function render() {
	        var _props = this.props,
	            title = _props.title,
	            actions = _props.actions,
	            customClass = _props.customClass,
	            customStyle = _props.customStyle;
	
	        return React.createElement("div", { className: "bp-custom-modal modal-order" }, React.createElement(Dialog, {
	            ref: this._getRef,
	            title: title,
	            actions: actions,
	            hideToolbarYearChange: false,
	            autoScrollBodyContent: true,
	            autoDetectWindowHeight: true,
	            modal: true,
	            contentStyle: customStyle,
	            contentClassName: 'dashboard-modal-content bp-custom-modal__content ' + (customClass ? ' ' + customClass : '')
	        }, this.props.children));
	    }
	});
	
	module.exports = CustomModal;

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	var _el = void 0;
	
	var DashboardModalEl = {
	    setElement: function setElement(notificationEl) {
	        _el = notificationEl;
	    },
	    openExistingSingleOrder: function openExistingSingleOrder(info) {
	        _el.openExistingSingleOrder(info.orderSelected, info.dateRow, info.isFermenterTank, info.tankType, info.openGeneralTab, info.fermentingVolume, info.packagingVolume, info.totalBatchVolume, info.totalBatchVolumeMessageError, info.tankClicked, info.totalBatchCost);
	    },
	    openExistingBrewOrder: function openExistingBrewOrder(info) {
	        _el.openExistingOrder(info.orderSelected, info.dateRow, info.isFermenterTank, info.tankType, info.openGeneralTab, info.fermentingVolume, info.packagingVolume, info.totalBatchVolume, info.totalBatchVolumeMessageError, info.tankClicked, info.totalBatchCost);
	    },
	    updateBatchVolumeAndLabel: function updateBatchVolumeAndLabel(totalFermenting, totalPackaging, order) {
	        _el.updateBatchVolumeAndLabel(totalFermenting, totalPackaging, order);
	    },
	    updateVolumeLabels: function updateVolumeLabels() {
	        _el.updateVolumeLabels.apply(_el, arguments);
	    },
	    updateBatchCostLabel: function updateBatchCostLabel() {
	        _el.updateBatchCostLabel.apply(_el, arguments);
	    },
	    openNewOrder: function openNewOrder() {
	        var _el2;
	
	        (_el2 = _el).openNewOrder.apply(_el2, arguments);
	    },
	    disableToggles: function disableToggles(callback) {
	        _el.disableToggles(callback);
	    },
	    enableToggles: function enableToggles(callback) {
	        _el.enableToggles(callback);
	    },
	    close: function close() {
	        _el.close();
	    }
	};
	
	module.exports = DashboardModalEl;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    Constants = __webpack_require__(2),
	    Security = __webpack_require__(13).auth,
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API;
	
	var UserServiceImpl = {
	    getUsers: function getUsers(onSuccess, onFailure, token, applicantId) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.response));
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/api/users', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    fetchUsers: function fetchUsers(onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.response));
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/api/users', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getUsersAccess: function getUsersAccess(onSuccess, onFailure, tokenString, applicantId) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.response));
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/api/users/permissions', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getEmailAlreadyUsed: function getEmailAlreadyUsed(onSuccess, onFailure, tokenString, applicantId, email) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(true);
	            }, function () {
	                onFailure.bind(this)(false);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/api/users/check', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send(email);
	    },
	    updatePermission: function updatePermission(userId, permissionId, isEnable, onSuccess, onFailure, token, applicantId) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/api/users/' + userId + '/permissions/' + permissionId + '?is-enable=' + isEnable, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    updatePermissions: function updatePermissions(userId, permissions, isEnable, onSuccess, onFailure, token, applicantId) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/api/users/' + userId + '/permissions');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, token || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(permissions));
	    },
	    updateUser: function updateUser(user, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', apiAppUrl + '/api/users', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(user));
	    },
	    createUser: function createUser(user, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', apiAppUrl + '/api/users', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(user));
	    },
	    changeUser: function changeUser(user, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('PUT', apiAppUrl + '/api/users', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(user));
	    },
	    deleteUser: function deleteUser(userId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/api/users/' + userId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    }
	};
	
	module.exports = UserServiceImpl;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	//TODO: no way to relax no-unused-vars from es-lint rule
	React.createClass({
	    render: function render() {}
	});
	
	var ChronologycStore = __webpack_require__(76),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    TankStore = __webpack_require__(97),
	    InventoryStore = __webpack_require__(20),
	    BeerStyleStore = __webpack_require__(95),
	    BrewhouseStore = __webpack_require__(96),
	    SessionStore = __webpack_require__(11),
	    DashboardModalStore = __webpack_require__(155),
	    DashboardModalEl = __webpack_require__(180),
	    OrderStore = __webpack_require__(72),
	    DashboardServiceCache = __webpack_require__(28),
	    _require2 = __webpack_require__(8),
	    some = _require2.some,
	    map = _require2.map,
	    filter = _require2.filter,
	    includes = _require2.includes,
	    find = _require2.find,
	    _require3 = __webpack_require__(48),
	    flatten = _require3.flatten,
	    concat = _require3.concat,
	    last = _require3.last,
	    findIndex = _require3.findIndex,
	    head = _require3.head,
	    _require4 = __webpack_require__(53),
	    cloneDeep = _require4.cloneDeep,
	    _require5 = __webpack_require__(355),
	    min = _require5.min,
	    _require6 = __webpack_require__(5),
	    assign = _require6.assign,
	    merge = _require6.merge,
	    sortBy = __webpack_require__(8).sortBy,
	    get = __webpack_require__(5).get,
	    set = __webpack_require__(5).set,
	    moment = __webpack_require__(3),
	    NumberUtils = __webpack_require__(23),
	    DateUtils = __webpack_require__(22),
	    OrderUtils = __webpack_require__(49),
	    ContentUtils = __webpack_require__(7),
	    DashboardModalUtils = __webpack_require__(50),
	    DashboardModalTaskCollapsible = __webpack_require__(403),
	    _require7 = __webpack_require__(50),
	    getNonSelectedMenuItem = _require7.getNonSelectedMenuItem,
	    toTankMenuItems = _require7.toTankMenuItems,
	    toConcreteTask = _require7.toConcreteTask,
	    getFermenterTank = _require7.getFermenterTank,
	    getBriteTank = _require7.getBriteTank,
	    getStyleBeer = _require7.getStyleBeer,
	    retrieveCustomTask = _require7.retrieveCustomTask,
	    setTaskIds = _require7.setTaskIds,
	    _require8 = __webpack_require__(2),
	    FERMENTER_TYPE_TASK = _require8.FERMENTER_TYPE_TASK,
	    PACKAGING_TYPE_TASK = _require8.PACKAGING_TYPE_TASK,
	    SECONDARY_TASK = _require8.SECONDARY_TASK,
	    TYPE_TASK_PACKAGING = _require8.TYPE_TASK_PACKAGING,
	    BREW_TASK = _require8.BREW_TASK,
	    FILTRATION_TASK = _require8.FILTRATION_TASK,
	    PACKAGING_TASK = _require8.PACKAGING_TASK,
	    DATE_FORMAT = _require8.DATE_FORMAT,
	    DATE_FORMAT_DISPLAY_COMBO_DAY = _require8.DATE_FORMAT_DISPLAY_COMBO_DAY,
	    TYPE_TASK_FERMENTER = _require8.TYPE_TASK_FERMENTER,
	    TYPE_TANK_FERMENTER = _require8.TYPE_TANK_FERMENTER,
	    TYPE_TANK_BRITE_TANK = _require8.TYPE_TANK_BRITE_TANK,
	    TYPE_TASK_BREWHOUSE = _require8.TYPE_TASK_BREWHOUSE,
	    TYPE_TANK_BREW_HOUSE = _require8.TYPE_TANK_BREW_HOUSE,
	    TASK_NON_VISIBLE = _require8.TASK_NON_VISIBLE;
	
	
	function _recalculateLayout(nextState) {
	    var ordersFromRange = OrderUtils.getOrderByRange(nextState.brewDate, nextState.orderDate);
	    var positionOrders = flatten(map(ordersFromRange, function (order) {
	        return OrderUtils.convertOrderToPositions(order, ChronologycStore.getCurrentFrom(), null, true);
	    }));
	    DashboardModalStore.setCurrentLayout(positionOrders);
	    return nextState;
	}
	
	/**
	 * Show the DashboardModalNew from the current clicked order.
	 */
	function openNewBrewOrder(preDefinedOrder) {
	    DashboardModalEl.openNewOrder(preDefinedOrder);
	}
	
	/**
	 * Show the DashboardModalChange from the existing clicked order.
	 */
	function openExistingBrewOrder(existingOrderInfo) {
	    DashboardModalEl.openExistingBrewOrder(existingOrderInfo);
	}
	
	function onChangeTaskType(oldItemSelected, typeTask, dateTask, state, evt, itemSelected) {
	    var _nextState;
	
	    var newTasks = [];
	    var nextState = {};
	
	    var displayNameIcon = get(itemSelected.itemModel, 'id') === 1 ? 'no-icon' : get(evt, 'text') || get(itemSelected, 'name') || get(itemSelected, 'text') || get(evt, 'target.value');
	    var currentIcon = DashboardServiceCache.findIconByDisplayName(displayNameIcon);
	
	    // check if exist some existing task before
	    // create a new one from scratch
	    var newTask = getNewTask(dateTask, state, typeTask, itemSelected);
	
	    if (ContentUtils.isEmptyArray(newTask.products)) {
	        newTask.isNewProduct = true;
	    }
	
	    // clean older products
	    newTask.products = [];
	
	    // set the new task icon information
	    newTask.displayName = displayNameIcon;
	    newTask.name = get(currentIcon, 'name') || 'no-icon';
	
	    if (currentIcon) {
	        newTask.icon = currentIcon;
	    } else {
	        newTask.icon = undefined;
	    }
	
	    // We need to identify the default task such as brewDate or FiltrationDate or Packaging date
	    newTask = assignTypeTask(state, newTask);
	
	    var tankTypeInfo = ContentUtils.getTankTypeConfiguration(typeTask);
	    var tasksFieldName = get(tankTypeInfo, 'tasksFieldName');
	
	    // avoid duplications
	    state.order[tasksFieldName] = filter(state.order[tasksFieldName], function (oldTask) {
	        return oldTask.date !== newTask.date;
	    });
	    // remove old task selected from given date
	    if (oldItemSelected) {
	        newTasks = filter(state.order[tasksFieldName], function (task) {
	            return get(oldItemSelected, 'date') !== task.date;
	        });
	    } else {
	        newTasks = state.order[tasksFieldName];
	    }
	    newTask = head(InventoryStore.hydrateTaskWithProducts([newTask], get(state, 'styleBeerSelected.id')));
	    newTasks.push(newTask);
	    nextState = (_nextState = {}, _nextState[tasksFieldName] = newTasks, _nextState);
	    state.order[tasksFieldName] = ContentUtils.replaceByAttributes(state.order[tasksFieldName], newTask, 'date');
	
	    state.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(state.order, DashboardServiceCache.getVendorItems());
	
	    return assign(state, nextState);
	}
	
	function assignTypeTask(state, newTask) {
	    if (state.order && newTask.date === state.order.brewDate || newTask.date === DateUtils.toDateText(state.brewDate)) {
	        newTask.type = BREW_TASK;
	    } else if (state.order && newTask.date === state.order.filtrationDate || newTask.date === DateUtils.toDateText(state.filtrationDate)) {
	        newTask.type = FILTRATION_TASK;
	    } else if (state.order && newTask.date === state.order.orderDate || newTask.date === DateUtils.toDateText(state.orderDate)) {
	        newTask.type = PACKAGING_TASK;
	    } else {
	        newTask.type = SECONDARY_TASK;
	    }
	
	    return newTask;
	}
	
	function getNewTask(dateTask, state, typeTask, itemSelected) {
	    var newTask = findExistingTask(dateTask, state, typeTask);
	    if (newTask === undefined) {
	        newTask = {
	            date: dateTask,
	            description: get(itemSelected, 'description') || '',
	            label: get(itemSelected, 'label') || ''
	        };
	    }
	    return newTask;
	}
	
	function onChangeBrewTurn(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, itemSelected) {
	    var nextState = cloneDeep(prevState);
	    var oldBatchs = get(nextState, 'batchs');
	    var batchNeedUpdate = cloneDeep(find(oldBatchs, function (batch) {
	        return batch.date === turnDate && batch.turnId === turnId;
	    }));
	    var batchFiltered = cloneDeep(filter(oldBatchs, function (batch) {
	        return !(batch.date === turnDate && batch.turnId === turnId);
	    })) || [];
	
	    // set value into brew batch
	    var batchUpdated = set(batchNeedUpdate, fieldName, targetValue);
	    batchUpdated.task = get(DashboardServiceCache.getBrewhouseIcons(), batchUpdated.payload - 1 + '.name');
	
	    // hydrate with existing product (only for edit mode)
	    batchUpdated = _completeWithOldProducts(batchUpdated, prevState, itemSelected);
	
	    // clean old products
	    batchNeedUpdate.products = [];
	
	    // hydrate each task with products
	    batchUpdated = head(InventoryStore.hydrateTaskWithProducts([batchUpdated], get(nextState, 'styleBeerSelected.id')));
	    batchUpdated.tankType = 'BH';
	
	    batchFiltered.push(batchUpdated);
	    var sortedBatchs = DateUtils.sortListByDateField(batchFiltered, 'date');
	
	    // update batch changed
	    nextState = set(nextState, 'order.batchs', sortedBatchs);
	
	    // the icon already selected
	    if (itemSelected) {
	        nextState.taskSelected = {
	            type: get(itemSelected, 'itemModel.tankType'),
	            name: get(itemSelected, 'itemModel.name')
	        };
	    } else {
	        nextState.taskSelected = {
	            type: get(batchUpdated, 'tankType'),
	            name: get(batchUpdated, 'name'),
	            task: get(batchUpdated, 'name')
	        };
	    }
	
	    nextState.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(nextState.order, DashboardServiceCache.getVendorItems());
	
	    return nextState;
	}
	
	function onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, itemSelected) {
	    var nextState = cloneDeep(prevState);
	    var oldBatchs = get(nextState, prevState.singleTank ? 'order.batchs' : 'batchs');
	    var batchNeedUpdate = cloneDeep(find(oldBatchs, function (batch) {
	        return batch.date === turnDate && batch.turnId === turnId;
	    }));
	    var batchFiltered = cloneDeep(filter(oldBatchs, function (batch) {
	        return !(batch.date === turnDate && batch.turnId === turnId);
	    })) || [];
	
	    // set value into brew batch
	    var batchUpdated = set(batchNeedUpdate, fieldName, targetValue);
	    batchUpdated.task = get(DashboardServiceCache.getBrewhouseIcons(), batchUpdated.payload - 1 + '.name');
	    batchUpdated.name = batchUpdated.task;
	
	    // hydrate with existing product (only for edit mode)
	    batchUpdated = _completeWithOldProducts(batchUpdated, prevState, itemSelected);
	
	    // clean old products
	    batchNeedUpdate.products = [];
	
	    // hydrate each task with products
	    batchUpdated = head(InventoryStore.hydrateTaskWithProducts([batchUpdated], get(nextState, 'styleBeerSelected.id')));
	    batchUpdated.tankType = 'BH';
	
	    batchFiltered.push(batchUpdated);
	    var sortedBatchs = DateUtils.sortListByDateField(batchFiltered, 'date');
	
	    // update batch changed
	    nextState = set(nextState, 'batchs', sortedBatchs);
	    nextState = set(nextState, 'order.batchs', sortedBatchs);
	
	    // the icon already selected
	    if (itemSelected) {
	        nextState.taskSelected = {
	            type: get(itemSelected, 'itemModel.tankType'),
	            name: get(itemSelected, 'itemModel.name'),
	            task: get(itemSelected, 'itemModel.name')
	        };
	    } else {
	        nextState.taskSelected = {
	            type: get(batchUpdated, 'tankType'),
	            name: get(batchUpdated, 'name'),
	            task: get(batchUpdated, 'name')
	        };
	    }
	
	    nextState.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(nextState.order, DashboardServiceCache.getVendorItems());
	
	    return nextState;
	}
	
	function _completeWithOldProducts(taskDry, prevState) {
	    if (prevState && prevState.order && taskDry) {
	        var tankType = get(taskDry, 'sectionType');
	        var taskFieldName = get(ContentUtils.getTankTypeConfiguration(tankType), 'tasksFieldName');
	        var existingTasks = get(prevState.order, taskFieldName);
	        var existingTask = find(existingTasks, function (task) {
	            return task.date === taskDry.date;
	        });
	        var haveExistingTask = !!existingTask;
	
	        if (haveExistingTask) {
	            taskDry.products = existingTask.products;
	        }
	    }
	    return taskDry;
	}
	
	function onChangePackagingDate(oldState, orderDate, isBHAllowed, nonForceUpdate) {
	    var nextState = cloneDeep(oldState) || {};
	
	    nextState.orderDate = orderDate;
	
	    // Loads menu items and set menu items properly depend of the sate context.
	    nextState = _recalculateLayout(nextState);
	    nextState = _recalculateTasks(nextState);
	    nextState = _initMenuItems(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // update brewhouse because in getNewModalState should force update when click an empty cell on packaging side
	
	    if (!nonForceUpdate) {
	        nextState.shouldNeedValidate = true;
	    }
	
	    return nextState;
	}
	
	function onChangeFiltrationDate(oldState, filtrationDate, isBHAllowed, nonForceUpdate) {
	    var nextState = cloneDeep(oldState) || {};
	
	    nextState.filtrationDate = filtrationDate;
	
	    nextState = _recalculateTasks(nextState);
	    nextState = _initMenuItems(nextState);
	
	    if (!nonForceUpdate) {
	        nextState.shouldNeedValidate = true;
	    }
	
	    return nextState;
	}
	
	function onChangeBriteTank(oldState, menuItem, isBHAllowed) {
	    var nextState = cloneDeep(oldState) || {};
	
	    nextState.briteTankTextColor = 'inherit';
	    nextState.briteTankSelected = menuItem;
	    nextState.briteTankSelectedIndex = get(menuItem, 'payload');
	    nextState.shouldNeedValidate = true;
	
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	
	    return nextState;
	}
	
	function onChangeFermenterTank(oldState, menuItem, isBHAllowed) {
	    var nextState = cloneDeep(oldState) || {};
	    nextState.fermenterTankTextColor = 'inherit';
	    nextState.fermenterTankSelected = menuItem;
	    nextState.fermenterTankSelectedIndex = get(menuItem, 'payload');
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState.shouldNeedValidate = true;
	    return nextState;
	}
	
	/**
	 * Given information about the order and type tank that will want to create a New Order, retrieve the state
	 * should be have the modal from that request, taking care about kind of tanks an some other stuffs
	 * (Fermenter, Packaging or BrewHouse side).
	 *
	 * @param preDefinedOrder
	 * @returns {Object}
	 */
	function getNewModalState(preDefinedOrder, isBHAllowed) {
	    var nextState = _getInitialState(preDefinedOrder, isBHAllowed);
	    nextState = _initMenuItems(nextState);
	    nextState = _setTankMenuItemClickedFromDashboard(nextState, get(preDefinedOrder, 'tankSelected'));
	
	    if (!isBHAllowed) {
	        // enter here means that toggle brewhouse is off
	        nextState = BrewhouseStore.cleanBrewhouse(nextState);
	    }
	
	    nextState = set(nextState, 'order.id', ContentUtils.getRandomId());
	    nextState = _someProductAlreadyConfirmed(nextState);
	
	    return nextState;
	}
	
	function findExistingTask(date, state, typeTask) {
	    var tasks = void 0;
	    if (typeTask === TYPE_TASK_FERMENTER) {
	        tasks = get(state, 'fermenterTasks');
	    } else if (typeTask === TYPE_TASK_PACKAGING) {
	        tasks = get(state, 'packagingTasks');
	    }
	
	    return find(tasks, function (task) {
	        return get(task, 'date') === date;
	    });
	}
	
	function _recalculateTasks(nextState) {
	
	    if (get(nextState, 'fermenterTasks.length') > 0) {
	        nextState.fermenterTasks = _recalculeteDateTask(nextState.fermenterTasks, nextState.brewDate, nextState.filtrationDate);
	        nextState.order.fermenterTasks = nextState.fermenterTasks;
	    }
	
	    if (get(nextState, 'packagingTasks.length') > 0) {
	        nextState.packagingTasks = _recalculeteDateTask(nextState.packagingTasks, nextState.filtrationDate, nextState.orderDate);
	        nextState.order.packagingTasks = nextState.packagingTasks;
	    }
	
	    return nextState;
	}
	
	function _getInitialState(preDefinedOrder) {
	    var nextState = {};
	    DashboardModalStore.setCurrentLayout(null);
	
	    // all toggles are open
	    nextState.isBHAllowed = true;
	    nextState.isFVAllowed = true;
	    nextState.isBTAllowed = true;
	
	    nextState.isNewModal = true;
	    nextState.isSingle = false;
	    nextState = set(nextState, 'order.batchs', []); // add empty batchs to allow calcualte the batch needed
	    nextState = set(nextState, 'batchs', []); // add empty batchs to allow calcualte the batch needed
	    nextState.dataClicked = '';
	    nextState.orderVolume = ContentUtils.getNumber(get(preDefinedOrder, 'tankSelected.volume'));
	    nextState.orderVolumePristine = ContentUtils.getNumber(get(preDefinedOrder, 'tankSelected.volume'));
	    nextState.tankTypeClicked = preDefinedOrder.tankTypeClicked;
	
	    if (get(preDefinedOrder, 'tankSelected.type', get(preDefinedOrder, 'tankTypeClicked')) === 'FV') {
	        nextState.isFermenterTankClicked = true;
	        nextState.brewDate = preDefinedOrder.date;
	    } else if (get(preDefinedOrder, 'tankSelected.type', get(preDefinedOrder, 'tankTypeClicked')) === 'BT') {
	        nextState.isFermenterTankClicked = false;
	        nextState.orderDate = preDefinedOrder.date;
	    } else if (get(preDefinedOrder, 'tankTypeClicked') === 'BH') {
	        // enter here means that was clicked the brewhouse section and by default is like
	        // was clicked the first column available in fermenting section
	        nextState.isFermenterTankClicked = true;
	        nextState.brewDate = preDefinedOrder.date;
	    }
	
	    nextState.commentOrder = '';
	    nextState.isSuggested = false;
	    nextState.isVolumeAlreadySuggested = true;
	    nextState.shouldNeedValidate = true;
	    nextState.batchNumber = preDefinedOrder.batchNumber;
	    nextState.styleBeerMessageError = nextState.styleBeerSelectedIndex ? '' : t('dashboard_modal_general_beer_style_inline_error');
	    nextState.styleBeerSelectedIndex = null;
	    nextState.styleBeerSelected = null;
	
	    return nextState;
	}
	
	function _setTankMenuItemClickedFromDashboard(nextState, tankClicked) {
	    if (nextState.isFermenterTankClicked) {
	        var fermenterTankSelected = DashboardModalUtils.getFermenterTank(nextState.fermenterTankMenuItems, { fermenterTank: tankClicked });
	        nextState.fermenterTankSelected = fermenterTankSelected.item;
	        nextState.fermenterTankSelectedIndex = fermenterTankSelected.index;
	        nextState.briteTankSelectedIndex = null;
	    } else {
	        var briteTankSelected = DashboardModalUtils.getBriteTank(nextState.briteTankMenuItems, { briteTank: tankClicked });
	        nextState.briteTankSelected = briteTankSelected.item;
	        nextState.briteTankSelectedIndex = briteTankSelected.index;
	        nextState.fermenterTankSelectedIndex = null;
	    }
	    return nextState;
	}
	
	function getExistingModalState(oldState, orderDateClicked, isFermenterTankClicked, tankTypeClicked, isBHAllowed) {
	    var nextState = {};
	    var order = cloneDeep(oldState.order) || cloneDeep(oldState);
	
	    if (order && !isBHAllowed) {
	        order.batchs = null;
	    }
	
	    nextState.order = order;
	    nextState.isVolumeAlreadySuggested = true; // in edit mode not need to suggest
	    nextState.isFermenterTankClicked = isFermenterTankClicked;
	    nextState.tankTypeClicked = tankTypeClicked;
	    nextState.isNewModal = false;
	    nextState.isSingle = false;
	    nextState.shouldNeedValidate = true;
	    nextState.brewDate = DateUtils.toDate(order.brewDate);
	    nextState.filtrationDate = DateUtils.toDate(order.filtrationDate);
	    nextState.orderDate = DateUtils.toDate(order.orderDate);
	
	    nextState = _recalculateLayout(nextState);
	    nextState = _initMenuItems(nextState);
	
	    var styleBeerSelected = getStyleBeer(nextState.beerStyleMenuItems, order);
	    var briteTankSelected = getBriteTank(nextState.briteTankMenuItems, order);
	    var fermenterTankSelected = getFermenterTank(nextState.fermenterTankMenuItems, order);
	
	    nextState.styleBeerSelectedIndex = styleBeerSelected.index;
	    nextState.styleBeerSelected = styleBeerSelected.item;
	    nextState.briteTankSelectedIndex = briteTankSelected.index;
	    nextState.briteTankSelected = briteTankSelected.item;
	    nextState.fermenterTankSelectedIndex = fermenterTankSelected.index;
	    nextState.fermenterTankSelected = fermenterTankSelected.item;
	    nextState.commentOrder = order.comment;
	    nextState.orderVolume = ContentUtils.getNumber(order.volume);
	    nextState.orderVolumePristine = ContentUtils.getNumber(order.volume);
	    nextState.fermenterTasks = setTaskIds(order.fermenterTasks, TYPE_TASK_FERMENTER);
	    nextState.packagingTasks = setTaskIds(order.packagingTasks, TYPE_TASK_PACKAGING);
	    nextState.dataClicked = orderDateClicked;
	    nextState.isFermenterTankClicked = isFermenterTankClicked;
	    nextState.batchNumber = order.batchNumber;
	
	    if (BrewhouseStore.isSomeBatchChange(get(oldState, 'order.batchs', []), get(nextState, 'order.batchs', []))) {
	        nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	        nextState.batchs = get(nextState, 'order.batchs');
	    }
	
	    return nextState;
	}
	
	function _someProductAlreadyConfirmed(nextState) {
	    var products = OrderUtils.getAllProductsFromOrder(nextState.order);
	    nextState.isSomeProductAlreadyConfirmed = some(products, function (product) {
	        return get(product, 'isConfirmed');
	    });
	    return nextState;
	}
	
	function onChangeBeerStyle(oldState, menuItem, selectedTankType, isBHAllowed) {
	    var nextState = cloneDeep(oldState) || {};
	
	    nextState.styleBeerTextColor = 'inherit';
	    nextState.styleBeerSelected = menuItem;
	    nextState.styleBeerSelectedIndex = get(menuItem, 'payload');
	    nextState.shouldNeedValidate = true;
	    nextState.isBeerStyleAlreadyDefined = true;
	
	    nextState = _recalculateDates(nextState, selectedTankType);
	    nextState = _recalculateLayout(nextState);
	    nextState = _initInitialTasks(nextState);
	    nextState = _initNewTasksWithConfiguration(nextState);
	    nextState = _initMenuItems(nextState);
	    nextState = _suggestionTank(nextState, true);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = _hydratedTasksWithProducts(nextState);
	    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
	    nextState = _updateOrderWithScopeEstimation(nextState); // the icons colors inventory
	
	    return nextState;
	}
	
	function _updateOrderWithScopeEstimation(nextState) {
	    var ordersWithInventoryScope = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation([nextState.order].concat(OrderStore.getOrders()));
	    nextState.order = ordersWithInventoryScope.find(function (order) {
	        return order.id === nextState.order.id;
	    });
	    return nextState;
	}
	
	function onChangeBrewDate(oldState, brewDate, isBHAllowed, nonForceUpdate) {
	    var nextState = cloneDeep(oldState) || {};
	
	    nextState.brewDate = brewDate;
	    nextState.offsetY = ChronologycStore.getYFromDate(DateUtils.toDateText(brewDate)) - ChronologycStore.getYFromDate(DateUtils.toDateText(nextState.brewDate));
	
	    nextState = _recalculateLayout(nextState);
	    nextState = _recalculateTasks(nextState);
	    nextState = _initMenuItems(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	
	    if (!nonForceUpdate) {
	        nextState.shouldNeedValidate = true;
	    }
	
	    return nextState;
	}
	
	function _hydratedTasksWithProducts(nextState) {
	    if (SessionStore.isFullPaidVersion()) {
	        var order = get(nextState, 'order');
	        var beerStyleId = get(nextState, 'styleBeerSelected.id');
	        nextState.fermenterTasks = InventoryStore.hydrateTaskWithProducts(nextState.fermenterTasks, beerStyleId);
	        nextState.packagingTasks = InventoryStore.hydrateTaskWithProducts(nextState.packagingTasks, beerStyleId);
	        order.batchs = InventoryStore.hydrateTaskWithProducts(DateUtils.sortListByDateField(order.batchs, 'date'), beerStyleId);
	    }
	    return nextState;
	}
	
	function _sinchronizedInnerOuterOrderDates(nextState) {
	    nextState = set(nextState, 'order.brewDate', DateUtils.toDateText(nextState.brewDate));
	    nextState = set(nextState, 'order.filtrationDate', DateUtils.toDateText(nextState.filtrationDate));
	    nextState = set(nextState, 'order.orderDate', DateUtils.toDateText(nextState.orderDate));
	
	    // update batch date
	    if (nextState.offsetY) {
	        nextState = set(nextState, 'order.batchs', map(get(nextState, 'order.batchs'), function (batch) {
	            var newBatchDate = DateUtils.addDays(DateUtils.toDate(batch.date), nextState.offsetY);
	            batch.date = DateUtils.toDateText(newBatchDate);
	            return batch;
	        }));
	    }
	    return nextState;
	}
	
	/**
	 * Load the BriteTank, FermenterTank and BeerStyle MenuItems to the State.
	 *
	 * @argument {Object} state         The state component.
	 * @private
	 */
	function _initMenuItems(state) {
	    var nextState = cloneDeep(state) || {};
	    nextState = _updateFermenterAndBriteTankAvailability(nextState);
	    nextState = _initBriteTankMenuItem(nextState);
	    nextState = _initFermenterTankMenuItem(nextState);
	    nextState = _initBeerStyleMenuItems(nextState);
	    return nextState;
	}
	
	function _updateFermenterAndBriteTankAvailability(nextState) {
	    var briteTankAvailables = void 0,
	        fermenterTankAvailables = void 0;
	
	    var brewDate = nextState.brewDate,
	        filtrationDate = nextState.filtrationDate,
	        orderDate = nextState.orderDate;
	
	    if (brewDate && filtrationDate && orderDate) {
	        if (nextState.isNewModal) {
	            briteTankAvailables = TankStore.getAvailabilityTanks(filtrationDate, orderDate, 'BT', null, DashboardModalStore.getCurrentLayout());
	            fermenterTankAvailables = TankStore.getAvailabilityTanks(brewDate, filtrationDate, 'FV', null, DashboardModalStore.getCurrentLayout());
	        } else {
	            briteTankAvailables = TankStore.getAvailabilityTanks(filtrationDate, orderDate, 'BT', nextState.order.id, DashboardModalStore.getCurrentLayout());
	            fermenterTankAvailables = TankStore.getAvailabilityTanks(brewDate, filtrationDate, 'FV', nextState.order.id, DashboardModalStore.getCurrentLayout());
	        }
	
	        nextState.briteTankAvailables = briteTankAvailables;
	        nextState.fermenterTankAvailables = fermenterTankAvailables;
	
	        if (!isTankSelectedAvailable(nextState.fermenterTankAvailables, get(nextState, 'fermenterTankSelected.id') || get(nextState, 'fermenterTankSelected.tankObj.id'))) {
	            nextState.fermenterTankSelected = null;
	        }
	        if (!isTankSelectedAvailable(nextState.briteTankAvailables, get(nextState, 'briteTankSelected.id') || get(nextState, 'briteTankSelected.tankObj.id'))) {
	            nextState.briteTankSelected = null;
	        }
	    }
	    return nextState;
	}
	
	function isTankSelectedAvailable(tanksAvailable, tankSelectedId) {
	    return tanksAvailable.filter(function (tank) {
	        return tank.isAvailable;
	    }).some(function (tank) {
	        return tank.id === tankSelectedId;
	    });
	}
	
	function _initBriteTankMenuItem(nextState) {
	    var tanks = TankStore.getTanks();
	    var briteTankMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_packaging_tank_placeholder'));
	    briteTankMenuItems = briteTankMenuItems.concat(toTankMenuItems('BT', tanks, 'modal-order-tank-bt-'));
	    nextState.briteTankMenuItems = _filterTanksByAvailability(nextState, briteTankMenuItems, nextState.briteTankAvailables);
	    return nextState;
	}
	
	function _initFermenterTankMenuItem(nextState) {
	    var tanks = TankStore.getTanks();
	    var fermenterTankMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_fermenting_tank_placeholder'));
	    fermenterTankMenuItems = fermenterTankMenuItems.concat(toTankMenuItems('FV', tanks, 'modal-order-tank-fv-'));
	    nextState.fermenterTankMenuItems = _filterTanksByAvailability(nextState, fermenterTankMenuItems, nextState.fermenterTankAvailables);
	    return nextState;
	}
	
	function _initBeerStyleMenuItems(nextState) {
	    var beerStyleMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_beer_style_placeholder'));
	    var isNewModal = nextState.isNewModal;
	    var beerStyles = isNewModal ? filter(BeerStyleStore.getBeerStyles(), function (beerStyle) {
	        return beerStyle.enable === true || beerStyle.enable === undefined;
	    }) : BeerStyleStore.getBeerStyles();
	    beerStyleMenuItems = concat(beerStyleMenuItems, map(beerStyles, function (beerStyle, index) {
	        return _extends(beerStyle, {
	            payload: index + 1,
	            text: beerStyle.name,
	            locatorId: 'modal-order-beer-style-locator-' + index
	        });
	    }));
	
	    nextState.beerStyleMenuItems = beerStyleMenuItems;
	    return nextState;
	}
	
	//TODO: need refactor this methods, is really really ugly :p
	/**
	 * Change the state of tank suggestion depended if it needed.
	 *
	 * NOTE: In order to calculate properly the suggestion, is necessary that state context already
	 * have the fermenter, brite tank available and menu item already loaded.
	 * @argument state {Object} Is the current state of the component
	 * @private
	 */
	function _changeSuggestionTank(state, avoidRecalculateTasks) {
	    var fermenterTankAvailable = void 0,
	        briteTankAvailable = void 0,
	        fermenterSuggestedAvailable = void 0,
	        briteTankSuggestedAvailable = void 0,
	        nextState = cloneDeep(state) || {},
	        isFVSelected = void 0;
	
	    isFVSelected = isFermenterTankSelected(state);
	
	    var cntIntRescue = 0;
	
	    if (isFVSelected) {
	
	        // find current fermenter selected if availables
	        fermenterTankAvailable = find(nextState.fermenterTankAvailables, function (fermenter) {
	            return nextState.fermenterTankSelected && fermenter.id === get(nextState, 'fermenterTankSelected.tankObj.id');
	        });
	
	        while (!fermenterTankAvailable || !briteTankAvailable) {
	            cntIntRescue++;
	
	            if (cntIntRescue > 40) {
	                //FIXME: WE NEED TO RESOLVE THIS
	                break;
	            }
	
	            // search until found both tanks available
	            if (!fermenterTankAvailable || !fermenterTankAvailable.isAvailable) {
	                // enter here means that current tank selected is not available, so we need to find another one
	                fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), ContentUtils.getNumber(nextState.orderVolume), DashboardModalStore.getCurrentLayout());
	            }
	
	            if (fermenterTankAvailable) {
	                var volumeTarget = ContentUtils.getNumber(fermenterTankAvailable.volume);
	                var maxBTCountTanks = get(nextState.briteTankAvailables, 'length');
	                var cntBTSearchRetries = 0;
	
	                while (!briteTankAvailable && cntBTSearchRetries < maxBTCountTanks) {
	                    // enter here means that we could not have a brite tank available, so we need to search another BT available starting with current FV volume target,
	                    // If don't found with current FV target volumen, we search with less volume target of BR tanks.
	                    // If dont have any of BT availables of BT tanks we will set briteTanksAvailables null;
	                    cntBTSearchRetries++;
	                    briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), volumeTarget, DashboardModalStore.getCurrentLayout());
	                    if (!briteTankAvailable) {
	                        var nextBTWithLessVolume = _getNextTankWithLessVolume(nextState.briteTankAvailables, volumeTarget);
	                        volumeTarget = ContentUtils.getNumber(get(nextBTWithLessVolume, 'volume'));
	                        if (nextBTWithLessVolume && nextBTWithLessVolume.isAvailable) {
	                            briteTankAvailable = nextBTWithLessVolume;
	                        }
	                    }
	                }
	
	                if (briteTankAvailable) {
	                    // enter here means that we found fermenter and brite tank available, and we need to update order volume with the less of both, FINISH!!
	                    nextState = _updateOrderVolumeIfNeed(nextState, briteTankAvailable, volumeTarget);
	                } else {
	                    // let with `fermenterTankAvailable` with tank selected and `briteTankAvailable` with non tank selected.
	                    break;
	                }
	            } else {
	                // enter here means that dont found tank avaiable so, we need to check tank with less volume
	                var cntSearchRetries = 0;
	                var maxCountTanks = get(nextState.fermenterTankAvailables, 'length');
	
	                while (!fermenterTankAvailable && cntSearchRetries < maxCountTanks) {
	                    cntSearchRetries++;
	                    fermenterTankAvailable = _getNextTankWithLessVolume(nextState.fermenterTankAvailables, get(nextState, 'orderVolume')); // we need to use fermenter tank selected
	                    if (fermenterTankAvailable && !nextState.isVolumeAlreadySuggested) {
	                        nextState.isVolumeAlreadySuggested = true;
	                        nextState.orderVolume = ContentUtils.getNumber(fermenterTankAvailable.volume);
	                    }
	                }
	
	                if (!fermenterTankAvailable) {
	                    // enter here means that we could not found any fermenter tank available, so let `fermenterTankAvailable` null
	                    break;
	                }
	            }
	        }
	    } else {
	        // find current brite tank selected if availables
	        briteTankAvailable = find(nextState.briteTankAvailables, function (briteTank) {
	            return nextState.briteTankSelected && briteTank.id === get(nextState, 'briteTankSelected.tankObj.id');
	        });
	
	        while (!fermenterTankAvailable || !briteTankAvailable) {
	            cntIntRescue++;
	            if (cntIntRescue > 40) {
	                //FIXME: WE NEED TO RESOLVE THIS
	                break;
	            }
	
	            // search until found both tanks available
	            if (!briteTankAvailable || !briteTankAvailable.isAvailable) {
	                // enter here means that current tank selected is not available, so we need to find another one
	                briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), nextState.orderVolume, state.currentLayout);
	            }
	
	            if (briteTankAvailable) {
	                var _volumeTarget = ContentUtils.getNumber(briteTankAvailable.volume);
	                var maxFVCountTanks = get(nextState.fermenterTankAvailables, 'length');
	                var cntFVSearchRetries = 0;
	
	                while (!fermenterTankAvailable && cntFVSearchRetries < maxFVCountTanks) {
	                    // enter here means that we could not have a ferementer tank available, so we need to search another FV available starting with current BT volumen target,
	                    // If don't found with current BT target volumen, we search with less volume target of FV tanks.
	                    // If dont have any of FV availables of FV tanks we will set fermentertankAvailable null;
	                    cntFVSearchRetries++;
	                    fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), _volumeTarget, state.currentLayout);
	                    if (!fermenterTankAvailable) {
	                        var nextFVWithLessVolume = _getNextTankWithLessVolume(nextState.fermenterTankAvailables, _volumeTarget, state.currentLayout);
	                        _volumeTarget = ContentUtils.getNumber(get(nextFVWithLessVolume, 'volume'));
	                        if (nextFVWithLessVolume && nextFVWithLessVolume.isAvailable) {
	                            fermenterTankAvailable = nextFVWithLessVolume;
	                        }
	                    }
	                }
	
	                if (fermenterTankAvailable) {
	                    // enter here means that we found fermenter and brite tank available, and we need to update order volume with the less of both, FINISH!!
	                    nextState = _updateOrderVolumeIfNeed(nextState, fermenterTankAvailable);
	                } else {
	                    // let with `briteTankAvailable` with tank selected and `ferementerTankAvailable` with non tank selected.
	                    break;
	                }
	            } else {
	                // enter here means that dont found tank avaiable so, we need to check tank with less volume
	                var _cntSearchRetries = 0;
	                var _maxCountTanks = get(nextState.briteTankAvailables, 'length');
	
	                while (!briteTankAvailable && _cntSearchRetries < _maxCountTanks) {
	                    _cntSearchRetries++;
	                    briteTankAvailable = _getNextTankWithLessVolume(nextState.briteTankAvailables, get(nextState, 'orderVolume')); // we need to use fermenter tank selected
	                    if (briteTankAvailable && !nextState.isVolumeAlreadySuggested) {
	                        nextState.isVolumeAlreadySuggested = true;
	                        nextState.orderVolume = ContentUtils.getNumber(briteTankAvailable.volume);
	                    }
	                }
	
	                if (!briteTankAvailable) {
	                    // enter here means that we could not found any briteTank tank available, so let `briteTankAvailable` null
	                    break;
	                }
	            }
	        }
	    }
	
	    // fill index tank tank selected in order to use in menu item.
	    fermenterSuggestedAvailable = toTankMenuItem(nextState.fermenterTankAvailables, fermenterTankAvailable);
	    nextState.fermenterTankSelectedIndex = fermenterSuggestedAvailable.index;
	    nextState.fermenterTankSelected = fermenterSuggestedAvailable.item;
	    if (nextState.fermenterTankSelected) {
	        nextState.fermenterTankSelected.tankObj = cloneDeep(fermenterSuggestedAvailable.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item structure
	    }
	    // Find BT the most efficient as possible.
	    briteTankSuggestedAvailable = toTankMenuItem(nextState.briteTankAvailables, briteTankAvailable);
	    nextState.briteTankSelectedIndex = briteTankSuggestedAvailable.index;
	    nextState.briteTankSelected = briteTankSuggestedAvailable.item;
	    if (nextState.briteTankSelected) {
	        nextState.briteTankSelected.tankObj = cloneDeep(briteTankSuggestedAvailable.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item
	    }
	
	    if (!avoidRecalculateTasks) {
	        // Update fermenter and packaging tasks
	        var orderInfo = {
	            brewDate: DateUtils.toDateText(nextState.brewDate),
	            filtrationDate: DateUtils.toDateText(nextState.filtrationDate),
	            orderDate: DateUtils.toDateText(nextState.orderDate),
	            fermenterTasks: nextState.fermenterTasks,
	            packagingTasks: nextState.packagingTasks
	        };
	        orderInfo = OrderStore.recalculateOrderTasks(orderInfo, false);
	        nextState.fermenterTasks = orderInfo.fermenterTasks;
	        nextState.packagingTasks = orderInfo.packagingTasks;
	    }
	
	    return nextState;
	}
	
	function _suggestionTank(state) {
	
	    var fermenterTankAvailable = void 0,
	        briteTankAvailable = void 0,
	        fermenterTankAvailableMenuItem = void 0,
	        briteTankAvailableMenuItem = void 0,
	        nextState = cloneDeep(state) || {};
	
	    var isFVSelected = isFermenterTankSelected(state);
	    var volumeTarget = ContentUtils.getNumber(nextState.orderVolume);
	
	    if (isFVSelected) {
	        // check the availability of current Fermenter tank selected
	        fermenterTankAvailable = find(nextState.fermenterTankAvailables, function (fermenter) {
	            return nextState.fermenterTankSelected && fermenter.id === get(nextState, 'fermenterTankSelected.tankObj.id');
	        });
	
	        briteTankAvailable = TankStore.getNextBriteTankAvailable(state.filtrationDate, state.orderDate, get(state, 'order.id'), volumeTarget, state.currentLayout);
	    } else {
	        // find current brite tank selected if availables
	        briteTankAvailable = find(nextState.briteTankAvailables, function (briteTank) {
	            return nextState.briteTankSelected && briteTank.id === get(nextState, 'briteTankSelected.tankObj.id');
	        });
	        fermenterTankAvailable = TankStore.getNextFermenterTankAvailable(state.brewDate, state.filtrationDate, get(state, 'order.id'), volumeTarget, state.currentLayout);
	    }
	
	    // Define Brite tank
	    if (briteTankAvailable && briteTankAvailable.isAvailable) {
	        briteTankAvailableMenuItem = briteTankAvailable;
	        // Find BT the most efficient as possible.
	        briteTankAvailableMenuItem = toTankMenuItem(nextState.briteTankAvailables, briteTankAvailableMenuItem);
	        nextState.briteTankSelectedIndex = briteTankAvailableMenuItem.index;
	        nextState.briteTankSelected = briteTankAvailableMenuItem.item;
	        if (nextState.briteTankSelected) {
	            nextState.briteTankSelected.tankObj = cloneDeep(briteTankAvailableMenuItem.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item
	        }
	    } else {
	        // enter here means that current brite tank selected is not available so we clean tank selected from dashboard
	        nextState.briteTankSelectedIndex = 0;
	        nextState.briteTankSelected = null;
	    }
	
	    // Define Fermenting tank
	    if (fermenterTankAvailable && fermenterTankAvailable.isAvailable) {
	        fermenterTankAvailableMenuItem = fermenterTankAvailable;
	        // fill index tank tank selected in order to use in menu item.
	        fermenterTankAvailableMenuItem = toTankMenuItem(nextState.fermenterTankAvailables, fermenterTankAvailableMenuItem);
	        nextState.fermenterTankSelectedIndex = fermenterTankAvailableMenuItem.index;
	        nextState.fermenterTankSelected = fermenterTankAvailableMenuItem.item;
	        if (nextState.fermenterTankSelected) {
	            nextState.fermenterTankSelected.tankObj = cloneDeep(fermenterTankAvailableMenuItem.item); // clone in order to break circular reference and make tankObj in order to be compatible with menu item structure
	        }
	    } else {
	        // enter here means that current brite tank selected is not available so we clean tank selected from dashboard
	        nextState.fermenterTankSelectedIndex = 0;
	        nextState.fermenterTankSelected = null;
	    }
	
	    return nextState;
	}
	
	function isFermenterTankSelected(state) {
	    var isFVSelected = void 0;
	
	    if (state.fermenterTankSelected !== undefined && state.briteTankSelected !== undefined) {
	        isFVSelected = get(state, 'isFermenterTankClicked');
	    } else {
	        isFVSelected = !!state.fermenterTankSelected;
	    }
	    return isFVSelected;
	}
	
	function _updateOrderVolumeIfNeed(nextState, lastTankChanged) {
	    var volumeTankChanged = ContentUtils.getNumber(get(lastTankChanged, 'volume'));
	    if (get(nextState, 'orderVolume') > volumeTankChanged && !nextState.isVolumeAlreadySuggested) {
	        nextState.isVolumeAlreadySuggested = true;
	        nextState = set(nextState, 'orderVolume', volumeTankChanged);
	    }
	    return nextState;
	}
	
	function _getNextTankWithLessVolume(tanksAvailables, currentVolumeTank) {
	    var tanksSorted = sortBy(cloneDeep(tanksAvailables), 'volume'); // clone deep in order to lose reference
	    return last(tanksSorted, function (tank) {
	        return tank.volume < (currentVolumeTank || 0);
	    }); // take the last one already sorted tank with less of current volume tank
	}
	
	function toTankMenuItem(availables, mostSuitableTank) {
	    //const availablesFiltered = filter(availables, tank => tank.isAvailable);
	    return {
	        index: findIndex(availables, function (tank) {
	            return get(tank, 'id') === get(mostSuitableTank, 'id');
	        }) + 1, // increment 1, in order to avoir the first item eg: 'Select item....'
	        item: mostSuitableTank
	    };
	}
	
	/**
	 * Initialize default task.
	 * @param {Object} nextState
	 * @private
	 * @returns {Object}
	 */
	function _initInitialTasks(nextState) {
	    nextState = _initFermentingTask(nextState);
	    nextState = _initPackagingTask(nextState);
	
	    return nextState;
	}
	
	function _initFermentingTask(nextState) {
	    var brewDateText = DateUtils.toDateText(nextState.brewDate),
	        filtrationDateText = DateUtils.toDateText(nextState.filtrationDate);
	
	    var fermenterTasks = [];
	
	    var brewTask = DashboardModalUtils.toEmptyTask(brewDateText, BREW_TASK);
	    var fermenterTask = DashboardModalUtils.toEmptyTask(filtrationDateText, FILTRATION_TASK);
	    fermenterTasks.push(brewTask);
	    fermenterTasks.push(fermenterTask);
	    nextState.fermenterTasks = fermenterTasks;
	
	    return nextState;
	}
	
	function _initPackagingTask(nextState) {
	    var orderDateText = DateUtils.toDateText(nextState.orderDate),
	        packagingTask = DashboardModalUtils.toEmptyTask(orderDateText, PACKAGING_TASK);
	    var packagingTasks = [];
	
	    packagingTasks.push(packagingTask);
	    nextState.packagingTasks = packagingTasks;
	
	    return nextState;
	}
	
	function _initNewTasksWithConfiguration(state) {
	    // Only into NEW order operation we use the beer style configuration.
	    if (state.styleBeerSelected) {
	        var nextState = {};
	
	        // Remove if exist other task configuration apply before in order to allow re-calculate the new days positions.
	        nextState.fermenterTasks = filter(state.fermenterTasks, function (task) {
	            return !task.isConfiguration;
	        });
	        nextState.packagingTasks = filter(state.packagingTasks, function (task) {
	            return !task.isConfiguration;
	        });
	
	        // the fermenting configuration task for the current beer style.
	        var fermenterTaskConfiguration = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), function (task) {
	            return task.styleBeerId === +state.styleBeerSelected.id && task.typeTank === FERMENTER_TYPE_TASK;
	        });
	
	        if (fermenterTaskConfiguration && fermenterTaskConfiguration.length) {
	            var fermenterTasksHydrated = concat(nextState.fermenterTasks, fermenterTaskConfiguration);
	            var fermenterTasks = toConcreteTask(fermenterTasksHydrated, state.brewDate, DashboardServiceCache.getFermenterIcons(), 'FV');
	
	            nextState.fermenterTasks = DashboardModalUtils.removeDefaultTaskWhenExistCustom(fermenterTasks);
	        }
	
	        // the packaging configuration task for the current beer style.
	        var packagingTaskConfiguration = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), function (task) {
	            return task.styleBeerId === +state.styleBeerSelected.id && task.typeTank === PACKAGING_TYPE_TASK;
	        });
	
	        // apply configuration if match with current beer style.
	        if (packagingTaskConfiguration && packagingTaskConfiguration.length) {
	            var packaginTasksHydrated = concat(nextState.packagingTasks, packagingTaskConfiguration);
	            var packaginTasks = toConcreteTask(packaginTasksHydrated, state.filtrationDate, DashboardServiceCache.getPackagingIcons(), 'BT');
	
	            nextState.packagingTasks = DashboardModalUtils.removeDefaultTaskWhenExistCustom(packaginTasks);
	        }
	        return assign(state, nextState);
	    }
	
	    return state;
	}
	
	function _recalculateDates(state, selectedTankType) {
	    var styleBeerSelected = state.styleBeerSelected,
	        brewDate = state.brewDate,
	        orderDate = state.orderDate;
	
	
	    if (styleBeerSelected) {
	        var nextState = {};
	        if (selectedTankType === TYPE_TANK_BRITE_TANK) {
	            // enter here means we are creating the order from fermenting section
	            var newBrewDate = DateUtils.addDays(orderDate, -Math.abs(styleBeerSelected.packagingDays + styleBeerSelected.fermenterDays - 2));
	            var newFiltrationDate = DateUtils.addDays(orderDate, -Math.abs(styleBeerSelected.packagingDays - 1));
	
	            nextState.filtrationDate = newFiltrationDate;
	            nextState.offsetY = ChronologycStore.getYFromDate(newBrewDate);
	            nextState.brewDate = newBrewDate;
	
	            return assign(state, nextState);
	        } else if (selectedTankType === TYPE_TANK_FERMENTER || selectedTankType === TYPE_TANK_BREW_HOUSE) {
	            // enter here means we are creating the order from packaging section
	            var newOrderDate = DateUtils.addDays(brewDate, styleBeerSelected.fermenterDays + styleBeerSelected.packagingDays - 2);
	            var _newFiltrationDate = DateUtils.addDays(brewDate, styleBeerSelected.fermenterDays - 1);
	
	            nextState.offsetY = 0; // Shold not change vertical position because we create order from Fermenting section, so the brew date still are the same.
	            nextState.filtrationDate = _newFiltrationDate;
	            nextState.orderDate = newOrderDate;
	
	            return assign(state, nextState);
	        }
	    }
	    return state;
	}
	
	/**
	 * Filter the tanks unavailables of the menu items defined.
	 * @argument {Object} state   Which containt information about state.
	 * @argument {Array} menuItems the items that substract the tanks unavailables.
	 * @argument {Object} TankAvailables.
	 * @return {Array}
	 * @private
	 */
	function _filterTanksByAvailability(state, menuItems, tankAvailables) {
	    if (menuItems && tankAvailables) {
	        if (!state.isNewModal && !state.order) {
	            // Means that will call this method in close modal after was cleaned.
	            return [];
	        }
	        menuItems = filter(menuItems, function (menuItem) {
	            var tankState = find(tankAvailables, function (tankAvailable) {
	                return menuItem.column !== undefined && menuItem.column !== null && menuItem.column === tankAvailable.column;
	            });
	            if (tankState) {
	                if (!state.isNewModal && !tankState.isAvailable) {
	                    return state.order.id === tankState.idOrderCollision;
	                } else {
	                    // show allays by availability the tank, it doesn't matter the volume that tank will have
	                    return tankState.isAvailable;
	                }
	            } else {
	                // enter here means when is first item of dropdown like "Select item ...."
	                return true;
	            }
	        });
	    }
	    return menuItems;
	}
	
	/**
	 * Compute the properly next state of Task when it change.
	 * @param {String} targetValue
	 * @param {String} existingPackagingTask
	 * @param {String} existingFermenterTasks
	 * @param {String} typeTask
	 * @param {String} dateTask
	 * @param {String} field
	 */
	function onChangeTask(targetValue, existingPackagingTask, existingFermenterTasks, typeTask, dateTask, field) {
	    var newTask = void 0,
	        nextState = {};
	
	    if (typeTask === TYPE_TASK_PACKAGING) {
	
	        var existingPackagingTaskSafe = DashboardModalUtils.removeDefaultTaskWhenExistCustom(existingPackagingTask);
	        newTask = find(existingPackagingTaskSafe, function (task) {
	            return task.date === dateTask;
	        });
	
	        if (!newTask) {
	            newTask = DashboardModalUtils.toEmptyTask(dateTask);
	            existingPackagingTaskSafe.push(newTask);
	        }
	
	        newTask[field] = targetValue;
	        nextState = {
	            packagingTasks: ContentUtils.replace(existingPackagingTaskSafe, newTask, 'date')
	        };
	    } else if (typeTask === TYPE_TASK_FERMENTER) {
	
	        var existingFermenterTaskSafe = DashboardModalUtils.removeDefaultTaskWhenExistCustom(existingFermenterTasks);
	        newTask = find(existingFermenterTaskSafe, function (task) {
	            return task.date === dateTask;
	        });
	
	        if (!newTask) {
	            newTask = DashboardModalUtils.toEmptyTask(dateTask);
	            existingFermenterTaskSafe.push(newTask);
	        }
	
	        newTask[field] = targetValue;
	        nextState = {
	            fermenterTasks: ContentUtils.replace(existingFermenterTaskSafe, newTask, 'date')
	        };
	    }
	    return nextState;
	}
	
	function onDeleteTask(existingPackagingTask, existingFermenterTasks, typeTask, dateTask) {
	    var nextState = {};
	    if (typeTask === TYPE_TASK_PACKAGING) {
	        nextState = {
	            packagingTasks: filter(existingPackagingTask, function (task) {
	                return task.date !== dateTask;
	            })
	        };
	    } else {
	        nextState = {
	            fermenterTasks: filter(existingFermenterTasks, function (task) {
	                return task.date !== dateTask;
	            })
	        };
	    }
	    return nextState;
	}
	
	/**
	 * Check all of fields of the order form and will indicate the errores founds.
	 * @argument {Object} self The context that was invoke.
	 * @return {Boolean}
	 * @private
	 */
	function isValidForm(state) {
	    var messagesError = {
	        brewDateMessageError: null,
	        filtrationDateMessageError: null,
	        styleBeerMessageError: null,
	        briteTankMessageError: null,
	        fermenterTankMessageError: null,
	        orderDateMessageError: null,
	        volumenTankMessageError: null
	    },
	        isValid = true;
	
	    if (!state.brewDate) {
	        messagesError.brewDateMessageError = t('dashboard_modal_general_brew_date_required');
	        isValid = false;
	    } else if (DateUtils.isAfter(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.filtrationDate)) || DateUtils.isAfter(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.orderDate)) || DateUtils.isEqual(DateUtils.toDateText(state.brewDate), DateUtils.toDateText(state.filtrationDate))) {
	        messagesError.brewDateMessageError = t('dashboard_modal_general_brew_date_inline_error_should_be_before_transfer_date');
	        isValid = false;
	    } else {
	        messagesError.brewDateMessageError = '';
	    }
	
	    if (!state.filtrationDate) {
	        messagesError.filtrationDateMessageError = t('dashboard_modal_general_transfer_date_inline_error_required');
	        isValid = false;
	    } else if (DateUtils.isAfter(DateUtils.toDateText(state.filtrationDate), DateUtils.toDateText(state.orderDate)) || DateUtils.isBefore(DateUtils.toDateText(state.filtrationDate), DateUtils.toDateText(state.brewDate))) {
	        messagesError.filtrationDateMessageError = t('dashboard_modal_general_transfer_date_inline_error_should_chronological');
	        isValid = false;
	    } else {
	        messagesError.filtrationDateMessageError = '';
	    }
	
	    if (!state.orderDate) {
	        messagesError.orderDateMessageError = t('dashboard_modal_general_packaging_date_required');
	        isValid = false;
	    } else if (DateUtils.isEqual(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.filtrationDate))) {
	        messagesError.orderDateMessageError = '';
	    } else if (DateUtils.isBefore(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.filtrationDate)) || DateUtils.isBefore(DateUtils.toDateText(state.orderDate), DateUtils.toDateText(state.brewDate))) {
	        messagesError.orderDateMessageError = t('dashboard_modal_general_packaging_date_inline_error_should_chronological');
	        isValid = false;
	    } else {
	        messagesError.orderDateMessageError = '';
	    }
	
	    if (!state.styleBeerSelected || !state.styleBeerSelected.id) {
	        messagesError.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error');
	        isValid = false;
	    } else {
	        messagesError.styleBeerMessageError = '';
	    }
	
	    if (get(state, 'fermenterTankMenuItems.length') === 1) {
	        messagesError.fermenterTankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
	        isValid = false;
	    } else if (!state.fermenterTankSelected || state.fermenterTankSelected.column === undefined || state.fermenterTankSelected.column < 0) {
	        messagesError.fermenterTankMessageError = t('dashboard_modal_general_transfer_date_inline_error_required');
	        isValid = false;
	    } else if (ContentUtils.getNumber(state.orderVolume) > get(state, 'fermenterTankSelected.tankObj.volume')) {
	        messagesError.fermenterTankMessageError = t('dashboard_modal_general_fermenting_tank_inline_error_no_enough_volume');
	        isValid = false;
	    } else {
	        messagesError.fermenterTankMessageError = '';
	    }
	
	    if (get(state, 'briteTankMenuItems.length') === 1) {
	        messagesError.briteTankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
	        isValid = false;
	    } else if (!state.briteTankSelected || !state.briteTankSelected.column) {
	        messagesError.briteTankMessageError = t('dashboard_modal_general_packaging_tank_inline_error_required');
	        isValid = false;
	    } else if (ContentUtils.getNumber(state.orderVolume) > get(state, 'briteTankSelected.tankObj.volume')) {
	        messagesError.briteTankMessageError = t('dashboard_modal_general_packaging_tank_inline_error_no_enough_volume');
	        isValid = false;
	    } else {
	        messagesError.briteTankMessageError = '';
	    }
	
	    var brewhouseMessageError = get(state, 'order.brewhouseMessageError');
	
	    if (brewhouseMessageError) {
	        messagesError.volumenTankMessageError = brewhouseMessageError;
	        isValid = false;
	    } else if (get(state, 'messagesError.volumenTankMessageError.length') > 0) {
	        isValid = false;
	        messagesError.volumenTankMessageError = get(state, 'messagesError.volumenTankMessageError');
	    } else {
	        messagesError.volumenTankMessageError = '';
	    }
	
	    return {
	        isValid: isValid,
	        messagesError: messagesError
	    };
	}
	
	function initializePackagingTask(self) {
	    return _initializeOrderTasks(self.state.filtrationDate, self.state.orderDate, self.state.packagingTasks, DashboardServiceCache.getPackagingIcons(), TYPE_TASK_PACKAGING, self.state.dataClicked, self);
	}
	
	function initializeFermentingTask(self) {
	    return _initializeOrderTasks(self.state.brewDate, self.state.filtrationDate, self.state.fermenterTasks, DashboardServiceCache.getFermenterIcons(), TYPE_TASK_FERMENTER, self.state.dataClicked, self);
	}
	
	function _initializeOrderTasks(fromDate, toDate, orderTasks, tasks, typeTask, dateTaskFocus, self) {
	    var indexDay = -1,
	        date = void 0,
	        dateTask = void 0,
	        taskEl = [],
	        fromDateText = void 0,
	        toDateText = void 0,
	        existingTasks = void 0,
	        dateTaskFocusText = dateTaskFocus ? DateUtils.toDateText(dateTaskFocus) : null,
	        typeTaskClassName = '',
	        isAlreadyExpanded = false;
	
	    if (DateUtils.isAfter(DateUtils.toDateText(fromDate), DateUtils.toDateText(toDate))) {
	        return;
	    }
	
	    var isEditMode = get(self, 'state.isNewModal') === false || get(self, 'state.isNewModal') === undefined;
	    var shouldBeDisabled = !SessionStore.isAbleToEditAllWithoutDates();
	
	    if (fromDate && toDate && orderTasks) {
	        fromDateText = DateUtils.toDateText(fromDate);
	        toDateText = DateUtils.toDateText(toDate);
	
	        var _loop = function _loop() {
	            isAlreadyExpanded = false;
	            var existingTask = null;
	            indexDay++;
	            date = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT_DISPLAY_COMBO_DAY);
	            dateTask = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT);
	            var keyAttr = 'key-' + indexDay + '-' + dateTask + '-' + typeTask;
	
	            var safeOrderTask = filter(orderTasks, function (task) {
	                return task;
	            }); // remove undefined
	            existingTasks = filter(safeOrderTask, function (task) {
	                return task.date === dateTask;
	            });
	            existingTask = retrieveCustomTask(existingTasks);
	
	            if (existingTask) {
	                existingTask.payload = getPayload(existingTask, tasks);
	                // Add src task in order to avoid calculate later
	                existingTask.imageSrc = get(find(tasks, function (task) {
	                    return task.displayName === existingTask.name;
	                }), 'src');
	                // Create and ID to later can use to Order Process
	                existingTask.taskId = dateTask + '_' + typeTask;
	                existingTask.sectionType = typeTask;
	            } else {
	                existingTask = {
	                    date: dateTask,
	                    payload: 1,
	                    imageSrc: '',
	                    taskId: dateTask + '_' + typeTask,
	                    sectionType: typeTask
	                };
	            }
	
	            // add default end hour product
	            existingTask = OrderUtils.setDefaultEndHourToProductsOfTask(existingTask, dateTask);
	
	            // hydrate with all field of each products
	            existingTask = InventoryStore.hydrateProductWithDefaultAmountAndVolume(existingTask);
	
	            if (dateTaskFocusText === dateTask) {
	                typeTaskClassName += ' is-focused';
	                isAlreadyExpanded = true;
	            }
	
	            var orderProcess = get(existingTask, 'process');
	            var existingProcess = DashboardServiceCache.getProcessByType(typeTask);
	            var orderProcessFiltered = filterOrderProcessByType(orderProcess, typeTask);
	
	            taskEl.push(React.createElement(DashboardModalTaskCollapsible, {
	                onChangeProcess: self._onChangeProcess,
	                onChangeProducts: self._onChangeProducts,
	                onChangeAmountItem: self._onChangeAmountItem,
	                onChangeVolumeItem: self._onChangeVolumeItem,
	                onChangeAmountInLocation: self._onChangeAmountInLocation,
	                onConfirmProduct: self._onConfirmProduct,
	                orderProcess: orderProcessFiltered,
	                order: self.state.order,
	                date: date,
	                uniqueId: keyAttr,
	                isAlreadyExpanded: isAlreadyExpanded,
	                existingProcess: existingProcess,
	                indexDay: indexDay,
	                shouldBeDisabled: shouldBeDisabled,
	                typeTask: typeTask,
	                typeTaskClassName: typeTaskClassName,
	                existingTask: existingTask,
	                tasks: tasks,
	                isEditMode: isEditMode,
	                // In this particularly case, I don't care the violation of LoD (Law of Demeter) in favor to DRY (Don't Repeat Your Self)
	                onChangeTaskType: self._onChangeTaskType.bind(self, existingTask, typeTask, dateTask),
	                onBlurLabel: self._onChangeName.bind(self, existingTask, typeTask, dateTask),
	                onBlurDescription: self._onChangeNote.bind(self, existingTask, typeTask, dateTask),
	                onToggleExpand: self._onToggleExpand.bind(self, existingTask) }));
	        };
	
	        do {
	            _loop();
	        } while (moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT) !== toDateText);
	    }
	
	    return taskEl;
	}
	
	function getPayload(existingTask, tasks) {
	    var payload = findIndex(tasks, function (task) {
	        return task.name === existingTask.name;
	    });
	    if (payload > -1) {
	        return payload + 1;
	    }
	    return findIndex(tasks, function (task) {
	        return task.displayName === existingTask.name;
	    }) + 1;
	}
	
	function initializeBrewingTurns(batchs, onChangeBrewingTaskType, onChangeProcess, onChangeProducts, onChangeAmountItem, onChangeVolumeItem, onChangeAmountInLocation, dateTaskFocus, onConfirmProduct, self) {
	    if (batchs) {
	        var batchsEl = [],
	            indexDay = -1,
	            typeTaskClassName = '';
	        var dateTaskFocusText = DateUtils.toDateText(dateTaskFocus);
	
	        // fix same sorted orders
	        var sortedBatchs = DashboardModalUtils.sortBatchByColumAndDate(batchs);
	        var isEditMode = get(self, 'state.isEditMode');
	        var isBrewingTankSelected = get(self, 'props.tankClicked.type') === 'BH';
	        var shouldBeDisabled = !SessionStore.isAdminUser();
	
	        var _loop2 = function _loop2() {
	            if (_isArray) {
	                if (_i >= _iterator.length) return 'break';
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) return 'break';
	                _ref = _i.value;
	            }
	
	            var batch = _ref;
	
	
	            indexDay++;
	            var date = moment(batch.date, DATE_FORMAT).format(DATE_FORMAT_DISPLAY_COMBO_DAY);
	            var dateTask = moment(batch.date, DATE_FORMAT).format(DATE_FORMAT);
	            var turnId = get(batch, 'turnId');
	            var turnName = get(batch, 'turn.name');
	            var process = get(batch, 'process', []);
	            var keyAttr = 'key-' + indexDay + '-' + dateTask + '-' + turnId;
	
	            var batchIconIndex = findIndex(DashboardServiceCache.getBrewhouseIcons(), function (icon) {
	                return icon.name === batch.task || icon.displayName === batch.task;
	            });
	
	            if (batchIconIndex === -1) {
	                // enter here means that don't exist batch task, so we define by default no-icon the same way of Packaging and Fermenting Tabs
	                batch.payload = findIndex(DashboardServiceCache.getBrewhouseIcons(), function (icon) {
	                    return icon.name === TASK_NON_VISIBLE;
	                }) + 1;
	            } else {
	                batch.payload = batchIconIndex + 1; // increment one for menu items payload propose
	            }
	
	            if (isBrewingTankSelected && dateTaskFocusText === dateTask && get(self, 'props.tankClicked.name') === turnName) {
	                typeTaskClassName += ' is-focused';
	            }
	
	            // Add a Common identifier between process of Brewhouse, Fermenting and Packaging
	            batch.taskId = String(turnId);
	            batch.sectionType = TYPE_TASK_BREWHOUSE;
	            batch.day = indexDay;
	            batch.date = dateTask;
	
	            // add default end hour product
	            batch = OrderUtils.setDefaultEndHourToProductsOfTask(batch, dateTask);
	
	            // hydrate with all field of each products
	            batch = InventoryStore.hydrateProductWithDefaultAmountAndVolume(batch);
	
	            var brewingProcess = DashboardServiceCache.getBrewingProcess();
	            var tasks = DashboardServiceCache.getBrewhouseIcons();
	            var existingBatch = batch;
	            var processFiltered = filterOrderProcessByType(process, TYPE_TASK_BREWHOUSE);
	
	            batchsEl.push(React.createElement(DashboardModalTaskCollapsible, {
	                onChangeProcess: onChangeProcess,
	                onChangeProducts: onChangeProducts,
	                onChangeAmountItem: onChangeAmountItem,
	                onChangeVolumeItem: onChangeVolumeItem,
	                onChangeAmountInLocation: onChangeAmountInLocation,
	                onConfirmProduct: onConfirmProduct,
	                orderProcess: processFiltered,
	                order: self.state.order,
	                date: date,
	                isEditMode: isEditMode,
	                uniqueId: keyAttr,
	                existingProcess: brewingProcess,
	                name: turnName,
	                indexDay: indexDay,
	                shouldBeDisabled: shouldBeDisabled,
	                typeTask: TYPE_TASK_BREWHOUSE,
	                typeTaskClassName: typeTaskClassName,
	                existingTask: existingBatch,
	                tasks: tasks,
	                onChangeTaskType: onChangeBrewingTaskType.bind(self, batch, dateTask, 'payload', turnId),
	                onBlurLabel: self._onChangeName.bind(self, batch, 'BH', dateTask),
	                onBlurDescription: self._onChangeNote.bind(self, batch, 'BH', dateTask),
	                onToggleExpand: self._onToggleExpand.bind(self, batch) }));
	        };
	
	        for (var _iterator = sortedBatchs, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            var _ret2 = _loop2();
	
	            if (_ret2 === 'break') break;
	        }
	        return batchsEl;
	    }
	    return batchs;
	}
	
	function filterOrderProcessByType(orderProcessList, type) {
	    return filter(orderProcessList, function (orderProcess) {
	        var taskId = get(orderProcess, 'taskId', '');
	        if (includes(taskId, '_')) {
	            // enter here means that have postfix, so we could be a FERMENTING or PACKAGING tasks.
	            return includes(taskId, type);
	        } else {
	            // enter here means is a brewhouse task (without post_fix of taskId)
	            return true;
	        }
	    });
	}
	
	function formatBatchs(consumerBatchs) {
	    var batchs = map(consumerBatchs, function (consumerBatch) {
	        var batch = {};
	        batch.task = get(DashboardServiceCache.getBrewhouseIcons(), consumerBatch.payload - 1 + '.name');
	        batch.label = consumerBatch.label || '';
	        batch.description = consumerBatch.description || '';
	        batch.turnId = consumerBatch.turnId;
	        batch.date = consumerBatch.date;
	        batch.process = get(consumerBatch, 'process');
	        batch.turn = consumerBatch.turn; // we need it to validate, this field will not be persisted in API
	        batch.products = DashboardModalUtils.formatProducts(ContentUtils.filterEnable(consumerBatch.products), batch.date);
	        return batch;
	    });
	
	    // fix same sorted orders
	    var sortedBatchs = DashboardModalUtils.sortBatchByColumAndDate(batchs);
	
	    return sortedBatchs;
	}
	
	function onChangeVolume(oldState, newVolume, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	
	    nextState = _recalculateLayout(nextState);
	    nextState = _updateVolume(nextState, newVolume);
	    nextState = _initMenuItems(nextState);
	
	    if (nextState.isNewModal) {
	        nextState = _recalculateFermenterTankByVolume(nextState);
	        nextState = _recalculateBriteTankByVolume(nextState);
	        nextState = _changeSuggestionTank(nextState);
	    }
	
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);
	
	    nextState.shouldNeedValidate = true;
	    return nextState;
	}
	
	function onChangeVolumeNew(oldState, newVolume, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	
	    nextState = _recalculateLayout(nextState);
	    nextState = _updateVolume(nextState, newVolume);
	    nextState = _initInitialTasks(nextState);
	    nextState = _initNewTasksWithConfiguration(nextState);
	    nextState = _initMenuItems(nextState);
	    nextState = _recalculateFermenterTankByVolume(nextState);
	    nextState = _recalculateBriteTankByVolume(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = _changeSuggestionTank(nextState);
	    nextState = _hydratedTasksWithProducts(nextState);
	    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
	    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);
	
	    nextState.shouldNeedValidate = true;
	    return nextState;
	}
	
	function _recalculateBrewhouse(oldState, nextState, isBHAllowed) {
	    // ask if change brewDate in order to update each batch date
	    var offsetDays = DateUtils.getDaysBetween(oldState.brewDate || nextState.brewDate, nextState.brewDate);
	
	    if (!isBHAllowed) {
	        // enter here means that the toggle is off, so is not needed to update any batch
	        return BrewhouseStore.cleanBrewhouse(nextState);
	    }
	
	    if (nextState.orderVolume > 0) {
	        // enter here means that is a new or change order with volume that need to calculate the new batchs
	        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(merge(nextState.order, {
	            volume: ContentUtils.getNumber(nextState.orderVolume),
	            brewDate: DateUtils.toDateText(nextState.brewDate),
	            filtrationDate: DateUtils.toDateText(nextState.filtrationDate),
	            orderDate: DateUtils.toDateText(nextState.orderDate),
	            isSingle: false,
	            isNewModal: nextState.isNewModal
	        }), offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
	        // enter here to sync calculated batch from order to outside batch from state
	        nextState.batchs = nextState.order.batchs;
	        return nextState;
	    }
	
	    if (nextState.isNewModal && !nextState.orderVolume) {
	        // enter here is a new order that should not have batchs
	        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array in order to still show the brewing tab
	    }
	
	    if (!nextState.isNewModal && get(nextState, 'order.batchs.length') > 0) {
	        // enter here means that is a change order that need to recalculate the batchs
	        nextState = _sinchronizedInnerOuterOrderDates(nextState);
	        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(nextState.order, offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
	        return nextState;
	    }
	
	    if (!nextState.isNewModal && !get(nextState, 'order.batchs.length')) {
	        // enter here means that is a change order that dont have batchs
	        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array in order to still show the brewing tab
	    }
	
	    return nextState;
	}
	
	function _updateVolume(nextState, newVolume) {
	    if (newVolume === undefined) {
	        newVolume = _getMinorVolumeOfCurrentTanksSelected(nextState);
	    } else if (NumberUtils.containSomeNotNumber(newVolume)) {
	        nextState = set(nextState, 'messagesError.volumenTankMessageError', t('dashboard_modal_general_volume_inline_error_must_be_number'));
	        nextState.orderVolume = newVolume;
	        return nextState;
	    } else {
	        nextState = set(nextState, 'messagesError.volumenTankMessageError', '');
	    }
	
	    nextState.orderVolume = ContentUtils.getNumber(newVolume);
	    if (!nextState.orderVolume) {
	        // could be --> 0 || null || undefined
	        nextState = set(nextState, 'order.volume', 0);
	        nextState.orderVolume = 0;
	    } else {
	        nextState = set(nextState, 'order.volume', nextState.orderVolume);
	    }
	
	    return nextState;
	}
	
	function _getMinorVolumeOfCurrentTanksSelected(nextState) {
	    return min([+get(nextState, 'briteTankSelected.tankObj.volume', 0), +get(nextState, 'fermenterTankSelected.tankObj.volume', 0)]);
	}
	
	function _recalculeteDateTask(tasks, fromDate, toDate) {
	    if (get(tasks, 'length') > 0) {
	
	        var filteredTasks = filter(tasks, function (task) {
	            return DateUtils.isDateBetween(task.date, fromDate, toDate);
	        });
	        return filteredTasks;
	    }
	    return tasks;
	}
	
	function _recalculateFermenterTankByVolume(state) {
	    var tankVolume = ContentUtils.getNumber(get(state, 'fermenterTankSelected.volume'), ContentUtils.getNumber(get(state, 'fermenterTankSelected.tankObj.volume')));
	    if (state.fermenterTankSelected && tankVolume < state.orderVolume) {
	        var nextState = cloneDeep(state);
	        // enter here means that the current brite tank dont have volume required, so se need to another brite tank to use it.
	        var fermenterTankFit = TankStore.getNextFermenterTankAvailable(nextState.brewDate, nextState.filtrationDate, get(nextState, 'orderId', get(nextState, 'order.id')), nextState.orderVolume, state.currentLayout);
	
	        if (fermenterTankFit) {
	            nextState.fermenterTankSelected = fermenterTankFit;
	        } else {
	            nextState.fermenterTankSelected = null;
	        }
	        return nextState;
	    }
	    return state;
	}
	
	function _recalculateBriteTankByVolume(state) {
	    var tankVolume = ContentUtils.getNumber(get(state, 'briteTankSelected.volume'), ContentUtils.getNumber(get(state, 'briteTankSelected.tankObj.volume')));
	    var orderVolume = ContentUtils.getNumber(state.orderVolume);
	
	    if (state.briteTankSelected && tankVolume < orderVolume) {
	        var nextState = cloneDeep(state);
	        // enter here means that the current brite tank dont have volume required, so se need to another brite tank to use it.
	        var briteTankFit = TankStore.getNextBriteTankAvailable(nextState.filtrationDate, nextState.orderDate, get(nextState, 'orderId', get(nextState, 'order.id')), ContentUtils.getNumber(nextState.orderVolume), state.currentLayout);
	
	        if (briteTankFit) {
	            nextState.briteTankSelected = briteTankFit;
	        } else {
	            nextState.briteTankSelected = null;
	        }
	        return nextState;
	    }
	    return state;
	}
	
	/**
	 * Reset all state of the modal.
	 * @argument {HTMLElement} self the context that was invoke
	 * @private
	 */
	function cleanModal(self) {
	    self.setState({
	        order: null,
	        dataClicked: null,
	        fermenterTasks: [],
	        packagingTasks: [],
	        brewingTasks: [],
	        batchs: [],
	        isSuggested: false,
	        brewDateMessageError: null,
	        filtrationDateMessageError: null,
	        orderDateMessageError: null,
	        styleBeerSelected: null,
	        briteTankSelected: null,
	        fermenterTankSelected: null,
	        filtrationDate: null,
	        brewDate: null,
	        orderDate: null,
	        styleBeerMessageError: null,
	        briteTankMessageError: null,
	        fermenterTankMessageError: null,
	        isSingleMode: false,
	        isBHAllowed: true,
	        isFVAllowed: true,
	        isBTAllowed: true,
	        currentSection: null
	    });
	}
	
	function onChangeProcess(prevState, oldProcessOrder, newProcessOrder, tasks) {
	    var _ref2;
	
	    var existingOrderProcess = find(oldProcessOrder, function (processOrder) {
	        return DashboardModalUtils.isSameProcessAndTask(processOrder, newProcessOrder);
	    });
	    var otherBrewProcess = filter(oldProcessOrder, function (processOrder) {
	        return !DashboardModalUtils.isSameProcessAndTask(processOrder, newProcessOrder);
	    }) || [];
	
	    if (existingOrderProcess) {
	        newProcessOrder = merge(existingOrderProcess, newProcessOrder);
	    }
	
	    var taskFieldName = get(newProcessOrder, 'isSingle') ? getTaskFieldNameByProcessFromSingle(newProcessOrder) : getTaskFieldNameByProcess(newProcessOrder);
	
	    var updatedOrder = prevState.order;
	
	    if (get(newProcessOrder, 'isDeletingOperation')) {
	        updatedOrder[taskFieldName] = DashboardModalUtils.removeProcessFromTasks(tasks, newProcessOrder);
	        return {
	            order: updatedOrder
	        };
	    }
	
	    otherBrewProcess.push(newProcessOrder);
	    var updatedTasks = updateTasksWithProcess(tasks, newProcessOrder);
	    updatedOrder[taskFieldName] = updatedTasks;
	
	    return _ref2 = {}, _ref2[taskFieldName] = updatedTasks, _ref2.order = updatedOrder, _ref2;
	}
	
	function updateTasksWithProcess(tasks, newProcessOrder) {
	    var taskTarget = DashboardModalUtils.findTaskFromGivenProcess(tasks, newProcessOrder);
	    if (taskTarget === undefined) {
	        var sectionType = getSectionType(newProcessOrder);
	        taskTarget = createNonIconTask(getTaskFromTaskId(newProcessOrder), sectionType);
	    }
	    var taskTargetUpdated = DashboardModalUtils.updateProcessFromTask(taskTarget, newProcessOrder);
	    return DashboardModalUtils.updateTask(tasks, taskTargetUpdated);
	}
	
	function updateStateTask(state, newTask) {
	    var _ref3;
	
	    var updatedTasks = void 0;
	    var taskFieldName = get(ContentUtils.getTankTypeConfiguration(newTask.tankType || newTask.sectionType), 'tasksFieldName');
	
	    if (!taskFieldName && isSingleTankFromBrewingSection(state)) {
	        // enter here where you create a single in brewing section, so
	        // which means there should not have any `batchs` field.
	        taskFieldName = 'singleTasks';
	
	        var existingTasks = get(state, taskFieldName) || [];
	        if (existTask(existingTasks, newTask)) {
	            updatedTasks = DashboardModalUtils.updateTask(existingTasks, newTask);
	        } else {
	            var newNonIconTask = createNonIconTask(newTask.date, state.currentSection, newTask.description, newTask.label);
	            existingTasks.push(newNonIconTask);
	            updatedTasks = existingTasks;
	        }
	    } else if (isSingle(state)) {
	        taskFieldName = newTask.sectionType === 'BREWHOUSE_TASK' ? 'batchs' : 'singleTasks';
	        var _existingTasks = get(state, taskFieldName) || [];
	        if (existTask(_existingTasks, newTask)) {
	            updatedTasks = DashboardModalUtils.updateTask(_existingTasks, newTask);
	        } else {
	            var _newNonIconTask = createNonIconTask(newTask.date, state.currentSection, newTask.description, newTask.label);
	            _existingTasks.push(_newNonIconTask);
	            updatedTasks = _existingTasks;
	        }
	    } else {
	        // enter here in combined orders
	        var _existingTasks2 = get(state, taskFieldName) || [];
	        updatedTasks = DashboardModalUtils.updateTask(_existingTasks2, newTask);
	        state[taskFieldName] = updatedTasks;
	        state.order[taskFieldName] = updatedTasks;
	    }
	
	    return _ref3 = {}, _ref3[taskFieldName] = updatedTasks, _ref3.order = state.order, _ref3;
	}
	
	function existTask(tasks, task) {
	    return some(tasks, function (taskValidate) {
	        return taskValidate.date === task.date && task.sectionType === taskValidate.sectionType;
	    });
	}
	
	function createNonIconTask(date, sectionType) {
	    var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var label = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	    return {
	        date: date,
	        description: description,
	        label: label,
	        sectionType: sectionType,
	        name: 'no-icon',
	        tankType: ContentUtils.getTankTypeConfiguration(sectionType).tankType
	    };
	}
	
	function isSingle(state) {
	    return state.singleTank !== undefined;
	}
	
	function isSingleTankFromBrewingSection(state) {
	    return get(state, 'singleTank.type') === 'BH';
	}
	
	function getTaskFieldNameByProcess(process) {
	    var isPackagingProcess = DashboardModalUtils.isPackagingProcess,
	        isFermentingProcess = DashboardModalUtils.isFermentingProcess;
	
	    return isPackagingProcess(process) ? 'packagingTasks' : isFermentingProcess(process) ? 'fermenterTasks' : 'batchs';
	}
	
	function getTaskFieldNameByProcessFromSingle(process) {
	    var isPackagingProcess = DashboardModalUtils.isPackagingProcess,
	        isFermentingProcess = DashboardModalUtils.isFermentingProcess;
	
	    return process.processSection === 'BH' ? 'singleTasks' : isPackagingProcess(process) ? 'singleTasks' : isFermentingProcess(process) ? 'singleTasks' : 'batchs';
	}
	
	function getTaskFromTaskId(process) {
	    if (hasDateFormat(process)) {
	        var taskId = process.taskId;
	        return taskId.substring(0, taskId.indexOf('_'));
	    } else {
	        return get(process, 'date');
	    }
	}
	
	function hasDateFormat(process) {
	    return process && process.taskId && process.taskId.indexOf('_') > -1;
	}
	
	function getSectionType(process) {
	    if (process && process.taskId) {
	        var taskId = process.taskId;
	        return taskId.indexOf('_') > -1 ? taskId.substring(taskId.indexOf('_') + 1, taskId.length) : process.processSection;
	    } else if (Array.isArray(process)) {
	        return get(process, 'processSection');
	    }
	}
	
	module.exports = {
	    onChangeBrewDate: onChangeBrewDate,
	    onChangeFiltrationDate: onChangeFiltrationDate,
	    onChangePackagingDate: onChangePackagingDate,
	    onChangeBeerStyle: onChangeBeerStyle,
	    onChangeBriteTank: onChangeBriteTank,
	    onChangeFermenterTank: onChangeFermenterTank,
	    onChangeTaskType: onChangeTaskType,
	    onChangeTask: onChangeTask,
	    onChangeVolume: onChangeVolume,
	    onChangeVolumeNew: onChangeVolumeNew,
	    onChangeProcess: onChangeProcess,
	    onDeleteTask: onDeleteTask,
	    onChangeBrewTurn: onChangeBrewTurn,
	    onChangeBrewTurnNew: onChangeBrewTurnNew,
	    getExistingModalState: getExistingModalState,
	    formatBatchs: formatBatchs,
	    getNewModalState: getNewModalState,
	    isValidForm: isValidForm,
	    hydratedTasksWithProducts: _hydratedTasksWithProducts,
	    initializePackagingTask: initializePackagingTask,
	    initializeFermentingTask: initializeFermentingTask,
	    someProductAlreadyConfirmed: _someProductAlreadyConfirmed,
	    initializeBrewingTurns: initializeBrewingTurns,
	    cleanModal: cleanModal,
	    updateStateTask: updateStateTask,
	    openNewBrewOrder: openNewBrewOrder,
	    openExistingBrewOrder: openExistingBrewOrder
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var EventEmitter = __webpack_require__(109).EventEmitter,
	    assign = __webpack_require__(74),
	    SchedulerAppDispatcher = __webpack_require__(42),
	    CHANGE_EVENT = 'change',
	    KEY_IS_BREWING_NOTES_OPEN = 'is_brewing_notes_open',
	    KEY_IS_PACKAGING_NOTES_OPEN = 'is_packaging_notes_open',
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    ContentUtils = __webpack_require__(7),
	    UIStateStore;
	
	/**
	 * The persistence state of UI.
	 */
	UIStateStore = assign({}, EventEmitter.prototype, {
	
	    emitChange: function emitChange() {
	        this.emit(CHANGE_EVENT);
	    },
	
	    removeChangeListener: function removeChangeListener(call) {
	        this.removeListener(CHANGE_EVENT, call);
	    },
	
	    addChangeListener: function addChangeListener(call) {
	        this.on(CHANGE_EVENT, call);
	    },
	
	    isBrewingNotesBarOpen: function isBrewingNotesBarOpen() {
	        return ContentUtils.getLocal(KEY_IS_BREWING_NOTES_OPEN);
	    },
	
	    isPackagingNotesBarOpen: function isPackagingNotesBarOpen() {
	        return ContentUtils.getLocal(KEY_IS_PACKAGING_NOTES_OPEN);
	    },
	
	    openBrowingNotesBar: function openBrowingNotesBar() {
	        ContentUtils.saveLocal(KEY_IS_BREWING_NOTES_OPEN, true);
	    },
	
	    closeBrowingNotesBar: function closeBrowingNotesBar() {
	        ContentUtils.saveLocal(KEY_IS_BREWING_NOTES_OPEN, false);
	    },
	
	    openPackagingNotesBar: function openPackagingNotesBar() {
	        ContentUtils.saveLocal(KEY_IS_PACKAGING_NOTES_OPEN, true);
	    },
	
	    closePackagingNotesBar: function closePackagingNotesBar() {
	        ContentUtils.saveLocal(KEY_IS_PACKAGING_NOTES_OPEN, false);
	    }
	});
	
	UIStateStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	
	    switch (action.type) {
	        case ActionTypes.CLICK_SHOW_SIDEBAR:
	            break;
	
	        default:
	    }
	});
	
	module.exports = UIStateStore;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(8),
	    filter = _require.filter,
	    map = _require.map,
	    Constants = __webpack_require__(2),
	    Security = __webpack_require__(13).auth,
	    ContentUtils = __webpack_require__(7),
	    RestUtils = __webpack_require__(51),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    KEY_PERMISSIONS = 'cache_permissions',
	    KEY_USER_PERMISSIONS = 'cache_user_permissions',
	    KEY_USER_PERMISSIONS_NAME = 'cache_user_permissions_name',
	    get = __webpack_require__(5).get;
	
	var UserPermissionStore = {
	    getPermissions: function getPermissions() {
	        return ContentUtils.getSession(KEY_PERMISSIONS) || [];
	    },
	    getUserPermissions: function getUserPermissions() {
	        return ContentUtils.getSession(KEY_USER_PERMISSIONS) || [];
	    },
	    getUserPermissionNames: function getUserPermissionNames() {
	        return ContentUtils.getSession(KEY_USER_PERMISSIONS_NAME) || [];
	    },
	    setUserPermissions: function setUserPermissions(userPermissions) {
	        ContentUtils.saveSession(KEY_USER_PERMISSIONS, userPermissions);
	        ContentUtils.saveSession(KEY_USER_PERMISSIONS_NAME, map(userPermissions, function (permission) {
	            return get(permission, 'name');
	        }));
	    },
	    setPermissions: function setPermissions(permissions) {
	        ContentUtils.saveSession(KEY_PERMISSIONS, permissions);
	    },
	
	
	    /**
	     * Filter the modules which are allowed by my user.
	     * @param modules
	     * @returns {*}
	     */
	    filterModules: function filterModules(modules) {
	        var _this = this;
	
	        var modulesNonEmpty = filter(modules, function (module) {
	            return module;
	        }); //remove undefined modules
	        return filter(modulesNonEmpty, function (module) {
	            var permissionName = get(module, 'permission');
	            var isMatcherPermission = _this.getUserPermissionNames().indexOf(permissionName) > -1;
	            var isModulePublic = module.permission === undefined;
	            return isMatcherPermission || isModulePublic;
	        });
	    },
	    shouldShow: function shouldShow(moduleName, permissionTarget) {
	        var permissions = this.getUserPermissionNames();
	        var permissionTargetName = moduleName + '_' + permissionTarget;
	        return permissions.some(function (permission) {
	            return permission === permissionTargetName;
	        });
	    },
	    getUsersAccess: function getUsersAccess(onSuccess, onFailure, tokenString, applicantId) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.response));
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/api/users/permissions', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, tokenString || Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, applicantId || Security.getCurrentApplicantId());
	        ajax.send();
	    }
	};
	
	module.exports = UserPermissionStore;

/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	var BrowserUtils = {
	
	    /**
	     * Retrieve is FF browser.
	     * @returns {boolean}
	     */
	    isFF: function isFF() {
	        return !!navigator.userAgent.match(/firefox/i);
	    },
	
	
	    /**
	     * Detects if it's a mobile browser
	     * @return {Boolean} true if it's a mobile browser
	     */
	    isMobile: function isMobile() {
	        return (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)
	        );
	    },
	
	
	    /**
	     * Detects if it's a mobile browser
	     * @return {Boolean} true if it's a mobile browser
	     */
	    isMobileNonIPad: function isMobileNonIPad() {
	        return (/iPhone|Android|BlackBerry/.test(navigator.userAgent)
	        );
	    },
	    isIpad: function isIpad() {
	        return !!navigator.userAgent.match(/IPad/ig);
	    },
	
	
	    /**
	     * Detects if it's a mobile browser
	     * @return {Boolean} true if it's a mobile browser
	     */
	    isMobileNonCareIPad: function isMobileNonCareIPad() {
	        return (/iPhone|iPod|Android|BlackBerry/.test(navigator.userAgent)
	        );
	    },
	    changeCursorWait: function changeCursorWait() {
	        document.body.style.cursor = 'wait';
	    },
	    changeCursorDefault: function changeCursorDefault() {
	        document.body.style.cursor = 'default';
	    }
	};
	
	module.exports = BrowserUtils;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DateUtils = __webpack_require__(22);
	var RECEVIED_STATE = ['RECEIVED', 'ORDER_PARTIALLY_RECEIVED', 'RECEIVED_WITH_ISSUE', 'CLOSED_COMPLETE', 'CLOSED_COMPLETE_PAID', 'CLOSED_RESOLVED', 'CLOSED_RESOLVED_PAID'];
	var get = __webpack_require__(5).get;
	
	var PurchaseOrderUtils = {
	    getDaysLeftToBeReceivedFromPurchaseOrder: function getDaysLeftToBeReceivedFromPurchaseOrder(purchaseOrder, t) {
	        var toDayDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date();
	
	
	        var amountDays = DateUtils.getDaysBetween(DateUtils.toDate(DateUtils.toDateText(toDayDate)), purchaseOrder.latestArrivalDate);
	
	        var isReceived = RECEVIED_STATE.indexOf(get(purchaseOrder, 'state')) > -1;
	        if (isReceived) {
	            return t('purchase_state_received') + ' (' + DateUtils.toDateText(purchaseOrder.receivedDate) + ')';
	        }
	
	        if (amountDays < 0) {
	            return t('overdue') + ' (' + Math.abs(amountDays) + ' ' + t('days') + ')';
	        } else {
	            return amountDays;
	        }
	    },
	    getLastReceivedDateFromPurchaseOrder: function getLastReceivedDateFromPurchaseOrder(purchaseOrder) {
	        if (purchaseOrder.partiallyReceivedDate) {
	            return purchaseOrder.partiallyReceivedDate;
	        }
	        if (purchaseOrder.receivedWithIssuesDate) {
	            return purchaseOrder.receivedWithIssuesDate;
	        }
	
	        if (purchaseOrder.receivedDate) {
	            return purchaseOrder.receivedDate;
	        }
	    },
	    getLastReceivedDateFromPurchaseOrderItem: function getLastReceivedDateFromPurchaseOrderItem(purchaseOrderItem) {
	        if (purchaseOrderItem.rejectRemainderDate) {
	            return purchaseOrderItem.rejectRemainderDate;
	        }
	        if (purchaseOrderItem.noMoreOnTheWayDate) {
	            return purchaseOrderItem.noMoreOnTheWayDate;
	        }
	
	        if (purchaseOrderItem.moreOnTheWayDate) {
	            return purchaseOrderItem.moreOnTheWayDate;
	        }
	
	        return undefined;
	    },
	
	
	    /**
	     * Indicate if given {@link VendorPurchaseItem} could be changed/removed.
	     * The only state which is able to deleted/changed it's PENDING, the rest of states
	     * happens after the supplier was notified by email. So we no longer able to change it.
	     * @param vendorPurchaseItem
	     * @returns {boolean}
	     */
	    isAbleToChangeVendorPurchaseItem: function isAbleToChangeVendorPurchaseItem(vendorPurchaseItem) {
	        return get(vendorPurchaseItem, 'state') === 'PENDING';
	    },
	    getPriceOfPurchaseItem: function getPriceOfPurchaseItem(purchaseItem) {
	        return get(purchaseItem, 'supplierPrice') || get(purchaseItem, 'priceUnit') || get(purchaseItem, 'vendorItem.priceUnit');
	    }
	};
	
	module.exports = PurchaseOrderUtils;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var accounting = __webpack_require__(695)
	var assign = __webpack_require__(804)
	var localeCurrency = __webpack_require__(828)
	var currencies = __webpack_require__(824)
	var localeFormats = __webpack_require__(825)
	
	var defaultCurrency = {
	  symbol: '',
	  thousandsSeparator: ',',
	  decimalSeparator: '.',
	  symbolOnLeft: true,
	  spaceBetweenAmountAndSymbol: false,
	  decimalDigits: 2
	}
	
	var defaultLocaleFormat = {}
	
	var formatMapping = [
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%s%v',
	      neg: '-%s%v',
	      zero: '%s%v'
	    }
	  },
	  {
	    symbolOnLeft: true,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%s %v',
	      neg: '-%s %v',
	      zero: '%s %v'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: false,
	    format: {
	      pos: '%v%s',
	      neg: '-%v%s',
	      zero: '%v%s'
	    }
	  },
	  {
	    symbolOnLeft: false,
	    spaceBetweenAmountAndSymbol: true,
	    format: {
	      pos: '%v %s',
	      neg: '-%v %s',
	      zero: '%v %s'
	    }
	  }
	]
	
	function format(value, options) {
	  var code = options.code || (options.locale && localeCurrency.getCurrency(options.locale))
	  var localeFormat = localeFormats[options.locale] || defaultLocaleFormat
	  var currency = assign({}, defaultCurrency, findCurrency(code), localeFormat)
	  
	  var symbolOnLeft = currency.symbolOnLeft
	  var spaceBetweenAmountAndSymbol = currency.spaceBetweenAmountAndSymbol
	
	  var format = formatMapping.filter(function(f) {
	    return f.symbolOnLeft == symbolOnLeft && f.spaceBetweenAmountAndSymbol == spaceBetweenAmountAndSymbol
	  })[0].format
	
	  return accounting.formatMoney(value, {
	    symbol: isUndefined(options.symbol)
	              ? currency.symbol
	              : options.symbol,
	
	    decimal: isUndefined(options.decimal)
	              ? currency.decimalSeparator
	              : options.decimal,
	
	    thousand: isUndefined(options.thousand)
	              ? currency.thousandsSeparator
	              : options.thousand,
	
	    precision: typeof options.precision === 'number'
	              ? options.precision
	              : currency.decimalDigits,
	
	    format: ['string', 'object'].indexOf(typeof options.format) > -1
	              ? options.format
	              : format
	  })
	}
	
	function findCurrency (currencyCode) {
	  return currencies[currencyCode]
	}
	
	function isUndefined (val) {
	  return typeof val === 'undefined'
	}
	
	module.exports = {
	  defaultCurrency: defaultCurrency,
	  get currencies() {
	    // In favor of backwards compatibility, the currencies map is converted to an array here
	    return Object.keys(currencies).map(function(key) {
	      return currencies[key]
	    })
	  },
	  findCurrency: findCurrency,
	  format: format
	}

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*eslint-disable no-unused-vars*/
	/*!
	 * jQuery JavaScript Library v3.1.0
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-07-07T21:44Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.0",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.0
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-01-04
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true;
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
		// Known :disabled false positives:
		// IE: *[disabled]:not(button, input, select, textarea, optgroup, option, menuitem, fieldset)
		// not IE: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Check form elements and option elements for explicit disabling
			return "label" in elem && elem.disabled === disabled ||
				"form" in elem && elem.disabled === disabled ||
	
				// Check non-disabled form elements for fieldset[disabled] ancestors
				"form" in elem && elem.disabled === false && (
					// Support: IE6-11+
					// Ancestry is covered for us
					elem.isDisabled === disabled ||
	
					// Otherwise, assume any non-<option> under fieldset[disabled] is disabled
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						("label" in elem || !disabledAncestor( elem )) !== disabled
				);
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnotwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? JSON.parse( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) ),
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support: IE <=9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox <=42
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				return ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			opt.duration = typeof opt.duration === "number" ?
				opt.duration : opt.duration in jQuery.fx.speeds ?
					jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in uncached url if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rts, "" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	return jQuery;
	} );


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var stackClear = __webpack_require__(897),
	    stackDelete = __webpack_require__(898),
	    stackGet = __webpack_require__(899),
	    stackHas = __webpack_require__(900),
	    stackSet = __webpack_require__(901);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function Stack(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add functions to the `Stack` cache.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87);
	
	/**
	 * Gets the index at which the first occurrence of `key` is found in `array`
	 * of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 194 */
/***/ function(module, exports) {

	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? current === current
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * The base implementation of methods like `_.find` and `_.findKey`, without
	 * support for iteratee shorthands, which iterates over `collection` using
	 * `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 196 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    baseCastPath = __webpack_require__(112),
	    isKey = __webpack_require__(86),
	    last = __webpack_require__(62),
	    parent = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  if (!isKey(path, object)) {
	    path = baseCastPath(path);
	    object = parent(object, path);
	    path = last(path);
	  }
	  var func = object == null ? object : object[path];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(845),
	    isObject = __webpack_require__(46),
	    isObjectLike = __webpack_require__(47);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedIndexBy = __webpack_require__(335),
	    identity = __webpack_require__(78);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	/**
	 * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	 * performs a binary search of `array` to determine the index at which `value`
	 * should be inserted into `array` in order to maintain its sort order.
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted
	 *  into `array`.
	 */
	function baseSortedIndex(array, value, retHighest) {
	  var low = 0,
	      high = array ? array.length : low;
	
	  if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	    while (low < high) {
	      var mid = (low + high) >>> 1,
	          computed = array[mid];
	
	      if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	        low = mid + 1;
	      } else {
	        high = mid;
	      }
	    }
	    return high;
	  }
	  return baseSortedIndexBy(array, value, identity, retHighest);
	}
	
	module.exports = baseSortedIndex;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99);
	
	/**
	 * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	 * without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseWhile(array, predicate, isDrop, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length) &&
	    predicate(array[index], index, array)) {}
	
	  return isDrop
	    ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	    : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	}
	
	module.exports = baseWhile;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(834),
	    baseAggregator = __webpack_require__(838),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(136),
	    isObject = __webpack_require__(46);
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtorWrapper(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors.
	    // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	module.exports = createCtorWrapper;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(490);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 204 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(203);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 206 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 207 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reComplexSymbol = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  if (!(string && reHasComplexSymbol.test(string))) {
	    return string.length;
	  }
	  var result = reComplexSymbol.lastIndex = 0;
	  while (reComplexSymbol.test(string)) {
	    result++;
	  }
	  return result;
	}
	
	module.exports = stringSize;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var copyObjectWith = __webpack_require__(340),
	    createAssigner = __webpack_require__(139),
	    keysIn = __webpack_require__(68);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer` which
	 * is invoked to produce the assigned values. If `customizer` returns `undefined`
	 * assignment is handled by the method instead. The `customizer` is invoked
	 * with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObjectWith(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(337),
	    keys = __webpack_require__(54);
	
	/**
	 * Creates an array of the own enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var CssEvent = __webpack_require__(170);
	var KeyLine = __webpack_require__(539);
	var KeyCode = __webpack_require__(73);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var ClickAwayable = __webpack_require__(146);
	var Paper = __webpack_require__(55);
	var MenuItem = __webpack_require__(520);
	var LinkMenuItem = __webpack_require__(1140);
	var SubheaderMenuItem = __webpack_require__(1141);
	
	/***********************
	* Nested Menu Component
	***********************/
	var NestedMenuItem = React.createClass({
	  displayName: 'NestedMenuItem',
	
	  mixins: [ClickAwayable, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    index: React.PropTypes.number.isRequired,
	    text: React.PropTypes.string,
	    menuItems: React.PropTypes.array.isRequired,
	    zDepth: React.PropTypes.number,
	    disabled: React.PropTypes.bool,
	    active: React.PropTypes.bool,
	    onItemTap: React.PropTypes.func,
	    menuItemStyle: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disabled: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false,
	      activeIndex: 0
	    };
	  },
	
	  componentClickAway: function componentClickAway() {
	    this._closeNestedMenu();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._positionNestedMenu();
	    var el = this.getDOMNode();
	    el.focus();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._positionNestedMenu();
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        lineHeight: this.getTheme().height + 'px',
	        color: this.context.muiTheme.palette.textColor
	      },
	      icon: {
	        float: 'left',
	        lineHeight: this.getTheme().height + 'px',
	        marginRight: this.getSpacing().desktopGutter
	      },
	      toggle: {
	        marginTop: (this.getTheme().height - this.context.muiTheme.component.radioButton.size) / 2,
	        float: 'right',
	        width: 42
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.context.muiTheme.palette.disabledColor
	      }
	    };
	
	    return styles;
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.menuItem;
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    styles = this.mergeAndPrefix(styles.root, this.props.active && !this.props.disabled && styles.rootWhenHovered, {
	      position: 'relative'
	    }, this.props.style);
	
	    var iconCustomArrowDropRight = {
	      marginRight: this.getSpacing().desktopGutterMini * -1,
	      color: this.context.muiTheme.component.dropDownMenu.accentColor
	    };
	
	    var _props = this.props;
	    var index = _props.index;
	    var menuItemStyle = _props.menuItemStyle;
	
	    var other = _objectWithoutProperties(_props, ['index', 'menuItemStyle']);
	
	    return React.createElement(
	      'div',
	      {
	        ref: 'root',
	        style: styles,
	        onMouseEnter: this._openNestedMenu,
	        onMouseLeave: this._closeNestedMenu,
	        onMouseOver: this._handleMouseOver,
	        onMouseOut: this._handleMouseOut },
	      React.createElement(
	        MenuItem,
	        {
	          index: index,
	          style: menuItemStyle,
	          disabled: this.props.disabled,
	          iconRightStyle: iconCustomArrowDropRight,
	          iconRightClassName: 'muidocs-icon-custom-arrow-drop-right',
	          onTouchTap: this._onParentItemTap },
	        this.props.text
	      ),
	      React.createElement(Menu, _extends({}, other, {
	        ref: 'nestedMenu',
	        menuItems: this.props.menuItems,
	        menuItemStyle: menuItemStyle,
	        onItemTap: this._onMenuItemTap,
	        hideable: true,
	        visible: this.state.open,
	        onRequestClose: this._closeNestedMenu,
	        zDepth: this.props.zDepth + 1 }))
	    );
	  },
	
	  toggleNestedMenu: function toggleNestedMenu() {
	    if (!this.props.disabled) this.setState({ open: !this.state.open });
	  },
	
	  isOpen: function isOpen() {
	    return this.state.open;
	  },
	
	  _positionNestedMenu: function _positionNestedMenu() {
	    var el = React.findDOMNode(this);
	    var nestedMenu = React.findDOMNode(this.refs.nestedMenu);
	    nestedMenu.style.left = el.offsetWidth + 'px';
	  },
	
	  _openNestedMenu: function _openNestedMenu() {
	    if (!this.props.disabled) this.setState({ open: true });
	  },
	
	  _closeNestedMenu: function _closeNestedMenu() {
	    this.setState({ open: false });
	    React.findDOMNode(this).focus();
	  },
	
	  _onParentItemTap: function _onParentItemTap() {
	    this.toggleNestedMenu();
	  },
	
	  _onMenuItemTap: function _onMenuItemTap(e, index, menuItem) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	    this._closeNestedMenu();
	  },
	  _handleMouseOver: function _handleMouseOver(e) {
	    if (!this.props.disabled && this.props.onMouseOver) this.props.onMouseOver(e, this.props.index);
	  },
	
	  _handleMouseOut: function _handleMouseOut(e) {
	    if (!this.props.disabled && this.props.onMouseOut) this.props.onMouseOut(e, this.props.index);
	  }
	
	});
	
	/****************
	* Menu Component
	****************/
	var Menu = React.createClass({
	  displayName: 'Menu',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    autoWidth: React.PropTypes.bool,
	    onItemTap: React.PropTypes.func,
	    onToggle: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    menuItems: React.PropTypes.array.isRequired,
	    selectedIndex: React.PropTypes.number,
	    hideable: React.PropTypes.bool,
	    visible: React.PropTypes.bool,
	    zDepth: React.PropTypes.number,
	    menuItemStyle: React.PropTypes.object,
	    menuItemStyleSubheader: React.PropTypes.object,
	    menuItemStyleLink: React.PropTypes.object,
	    menuItemClassName: React.PropTypes.string,
	    menuItemClassNameSubheader: React.PropTypes.string,
	    menuItemClassNameLink: React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      nestedMenuShown: false,
	      activeIndex: 0
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoWidth: true,
	      hideable: false,
	      visible: true,
	      zDepth: 1,
	      onRequestClose: function onRequestClose() {}
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var el = React.findDOMNode(this);
	
	    //Set the menu width
	    this._setKeyWidth(el);
	
	    //Show or Hide the menu according to visibility
	    this._renderVisibility();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (this.props.visible !== prevProps.visible || this.props.menuItems.length !== prevProps.menuItems.length) {
	      this._renderVisibility();
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    //Set the menu width
	    this._setKeyWidth(React.findDOMNode(this));
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.menu;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        backgroundColor: this.getTheme().containerBackgroundColor,
	        paddingTop: this.getSpacing().desktopGutterMini,
	        paddingBottom: this.getSpacing().desktopGutterMini,
	        transition: Transitions.easeOut(null, 'height'),
	        outline: 'none !important'
	      },
	      subheader: {
	        paddingLeft: this.context.muiTheme.component.menuSubheader.padding,
	        paddingRight: this.context.muiTheme.component.menuSubheader.padding
	      },
	      hideable: {
	        overflow: 'hidden',
	        position: 'absolute',
	        top: 0,
	        zIndex: 1
	      },
	      item: {
	        height: 34
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    return React.createElement(
	      Paper,
	      {
	        ref: 'paperContainer',
	        tabIndex: '0',
	        onKeyDown: this._onKeyDown,
	        zDepth: this.props.zDepth,
	        style: this.mergeAndPrefix(styles.root, this.props.hideable && styles.hideable, this.props.style) },
	      this._getChildren()
	    );
	  },
	
	  _getChildren: function _getChildren() {
	    var menuItem = undefined,
	        itemComponent = undefined,
	        isDisabled = undefined;
	
	    var styles = this.getStyles();
	
	    this._children = [];
	    //This array is used to keep track of all nested menu refs
	    this._nestedChildren = [];
	
	    for (var i = 0; i < this.props.menuItems.length; i++) {
	      menuItem = this.props.menuItems[i];
	      isDisabled = menuItem.disabled === undefined ? false : menuItem.disabled;
	
	      var _menuItem = menuItem;
	      var icon = _menuItem.icon;
	      var data = _menuItem.data;
	      var attribute = _menuItem.attribute;
	      var number = _menuItem.number;
	      var toggle = _menuItem.toggle;
	      var onTouchTap = _menuItem.onTouchTap;
	
	      var other = _objectWithoutProperties(_menuItem, ['icon', 'data', 'attribute', 'number', 'toggle', 'onTouchTap']);
	
	      switch (menuItem.type) {
	
	        case MenuItem.Types.LINK:
	          itemComponent = React.createElement(LinkMenuItem, {
	            key: i,
	            index: i,
	            active: this.state.activeIndex === i,
	            text: menuItem.text,
	            disabled: isDisabled,
	            className: this.props.menuItemClassNameLink,
	            style: this.props.menuItemStyleLink,
	            payload: menuItem.payload,
	            target: menuItem.target });
	          break;
	
	        case MenuItem.Types.SUBHEADER:
	          itemComponent = React.createElement(SubheaderMenuItem, {
	            key: i,
	            index: i,
	            className: this.props.menuItemClassNameSubheader,
	            style: this.mergeAndPrefix(styles.subheader, this.props.menuItemStyleSubheader),
	            firstChild: i === 0,
	            text: menuItem.text });
	          break;
	
	        case MenuItem.Types.NESTED:
	          var _props2 = this.props,
	              ref = _props2.ref,
	              key = _props2.key,
	              index = _props2.index,
	              zDepth = _props2.zDepth,
	              other = _objectWithoutProperties(_props2, ['ref', 'key', 'index', 'zDepth']);
	
	          itemComponent = React.createElement(NestedMenuItem, _extends({}, other, {
	            ref: i,
	            key: i,
	            index: i,
	            nested: true,
	            active: this.state.activeIndex === i,
	            text: menuItem.text,
	            disabled: isDisabled,
	            menuItems: menuItem.items,
	            menuItemStyle: this.props.menuItemStyle,
	            zDepth: this.props.zDepth,
	            onMouseEnter: this._onItemActivated,
	            onMouseLeave: this._onItemDeactivated,
	            onItemTap: this._onNestedItemTap }));
	          this._nestedChildren.push(i);
	          break;
	
	        default:
	          itemComponent = React.createElement(
	            MenuItem,
	            _extends({}, other, {
	              selected: this.props.selectedIndex === i,
	              key: i,
	              index: i,
	              active: this.state.activeIndex === i,
	              icon: menuItem.icon,
	              data: menuItem.data,
	              className: this.props.menuItemClassName,
	              style: this.props.menuItemStyle,
	              attribute: menuItem.attribute,
	              number: menuItem.number,
	              toggle: menuItem.toggle,
	              onToggle: this.props.onToggle,
	              disabled: isDisabled,
	              onTouchTap: this._onItemTap,
	              onMouseEnter: this._onItemActivated,
	              onMouseLeave: this._onItemDeactivated
	            }),
	            menuItem.text
	          );
	      }
	      this._children.push(itemComponent);
	    }
	
	    return this._children;
	  },
	
	  _setKeyWidth: function _setKeyWidth(el) {
	    //Update the menu width
	    var menuWidth = '100%';
	
	    if (this.props.autoWidth) {
	      el.style.width = 'auto';
	      menuWidth = KeyLine.getIncrementalDim(el.offsetWidth) + 'px';
	    }
	
	    el.style.width = menuWidth;
	  },
	
	  _renderVisibility: function _renderVisibility() {
	    if (this.props.hideable) {
	      if (this.props.visible) this._expandHideableMenu();else this._collapseHideableMenu();
	    }
	  },
	
	  _expandHideableMenu: function _expandHideableMenu() {
	    var _this = this;
	
	    var el = React.findDOMNode(this);
	    var container = React.findDOMNode(this.refs.paperContainer);
	    var padding = this.getSpacing().desktopGutterMini;
	    var height = this._getHiddenMenuHeight(el, padding);
	
	    //Add transition
	    if (!el.style.transition) {
	      el.style.transition = Transitions.easeOut();
	    }
	
	    this._nextAnimationFrame(function () {
	      container.style.overflow = 'hidden';
	
	      // Yeild to the DOM, then apply height and padding. This makes the transition smoother.
	      el.style.paddingTop = padding + 'px';
	      el.style.paddingBottom = padding + 'px';
	      el.style.height = height + 'px';
	      el.style.opacity = 1;
	
	      //Set the overflow to visible after the animation is done so
	      //that other nested menus can be shown
	      CssEvent.onTransitionEnd(el, function () {
	        //Make sure the menu is open before setting the overflow.
	        //This is to accout for fast clicks
	        if (_this.props.visible) container.style.overflow = 'visible';
	        el.style.transition = null;
	        el.focus();
	      });
	    });
	  },
	
	  _getHiddenMenuHeight: function _getHiddenMenuHeight(el, padding) {
	    //Add padding to the offset height, because it is not yet set in the style.
	    var height = padding * 2;
	
	    //Hide the element and allow the browser to automatically resize it.
	    el.style.visibility = 'hidden';
	    el.style.height = 'auto';
	
	    //Determine the height of the menu.
	    height += el.offsetHeight;
	
	    //Unhide the menu with the height set back to zero.
	    el.style.height = '0px';
	    el.style.visibility = 'visible';
	
	    return height;
	  },
	
	  _collapseHideableMenu: function _collapseHideableMenu() {
	    var el = React.findDOMNode(this);
	    var container = React.findDOMNode(this.refs.paperContainer);
	    var originalOpacity = el.style.opacity;
	
	    //Add transition
	    if (!el.style.transition && originalOpacity !== '') {
	      el.style.transition = Transitions.easeOut();
	    }
	
	    this._nextAnimationFrame(function () {
	      //Set the overflow to hidden so that animation works properly
	      container.style.overflow = 'hidden';
	
	      //Close the menu
	      el.style.opacity = 0;
	      el.style.height = '0px';
	      el.style.paddingTop = '0px';
	      el.style.paddingBottom = '0px';
	
	      var end = function end() {
	        el.style.transition = null;
	      };
	
	      if (originalOpacity === '') end();else CssEvent.onTransitionEnd(el, end);
	    });
	  },
	
	  _nextAnimationFrame: function _nextAnimationFrame(func) {
	    if (window.requestAnimationFrame) {
	      return window.requestAnimationFrame(func);
	    }
	    return setTimeout(func, 16);
	  },
	
	  _onNestedItemTap: function _onNestedItemTap(e, index, menuItem) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, menuItem);
	  },
	
	  _onItemTap: function _onItemTap(e, index) {
	    if (this.props.onItemTap) this.props.onItemTap(e, index, this.props.menuItems[index]);
	  },
	
	  _onItemToggle: function _onItemToggle(e, index, toggled) {
	    if (this.props.onItemToggle) this.props.onItemToggle(e, index, this.props.menuItems[index], toggled);
	  },
	  _onItemActivated: function _onItemActivated(e, index) {
	    this.setState({ activeIndex: index });
	  },
	  _onItemDeactivated: function _onItemDeactivated(e, index) {
	    if (this.state.activeKey === index) this.setState({ activeIndex: 0 });
	  },
	
	  _onKeyDown: function _onKeyDown(e) {
	    if (!(this.state.open || this.props.visible)) return;
	
	    var nested = this._children[this.state.activeIndex];
	    if (nested && nested.props.nested && this.refs[this.state.activeIndex].isOpen()) return;
	
	    switch (e.which) {
	      case KeyCode.UP:
	        this._activatePreviousItem();
	        break;
	      case KeyCode.DOWN:
	        this._activateNextItem();
	        break;
	      case KeyCode.RIGHT:
	        this._tryToggleNested(this.state.activeIndex);
	        break;
	      case KeyCode.LEFT:
	        this._close();
	        break;
	      case KeyCode.ESC:
	        this._close();
	        break;
	      case KeyCode.TAB:
	        this._close();
	        return; // so the tab key can propagate
	      case KeyCode.ENTER:
	      case KeyCode.SPACE:
	        e.stopPropagation(); // needs called before the close
	        this._triggerSelection(e);
	        break;
	      default:
	        return; //important
	    }
	    e.preventDefault();
	    e.stopPropagation();
	  },
	
	  _activatePreviousItem: function _activatePreviousItem() {
	    var active = this.state.activeIndex || 0;
	    active = Math.max(active - 1, 0);
	    this.setState({ activeIndex: active });
	  },
	
	  _activateNextItem: function _activateNextItem() {
	    var active = this.state.activeIndex || 0;
	    active = Math.min(active + 1, this._children.length - 1);
	    this.setState({ activeIndex: active });
	  },
	
	  _triggerSelection: function _triggerSelection(e) {
	    var index = this.state.activeIndex || 0;
	    this._onItemTap(e, index);
	  },
	
	  _close: function _close() {
	    this.props.onRequestClose();
	  },
	
	  _tryToggleNested: function _tryToggleNested(index) {
	    var item = this.refs[index];
	    if (item && item.toggleNestedMenu) item.toggleNestedMenu();
	  }
	
	});
	
	module.exports = Menu;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Colors = __webpack_require__(56);
	var Transitions = __webpack_require__(24);
	var ScaleInTransitionGroup = __webpack_require__(1182);
	
	var pulsateDuration = 750;
	
	var FocusRipple = React.createClass({
	  displayName: 'FocusRipple',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  propTypes: {
	    color: React.PropTypes.string,
	    innerStyle: React.PropTypes.object,
	    opacity: React.PropTypes.number,
	    show: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: Colors.darkBlack
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.show) {
	      this._setRippleSize();
	      this._pulsate();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.show) {
	      this._setRippleSize();
	      this._pulsate();
	    } else {
	      if (this._timeout) clearTimeout(this._timeout);
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var style = _props.style;
	
	    var mergedRootStyles = this.mergeStyles({
	      height: '100%',
	      width: '100%',
	      position: 'absolute',
	      top: 0,
	      left: 0
	    }, style);
	
	    var ripple = show ? this._getRippleElement(this.props) : null;
	
	    return React.createElement(
	      ScaleInTransitionGroup,
	      {
	        maxScale: 0.85,
	        style: mergedRootStyles },
	      ripple
	    );
	  },
	
	  _getRippleElement: function _getRippleElement(props) {
	    var color = props.color;
	    var innerStyle = props.innerStyle;
	    var opacity = props.opacity;
	
	    var innerStyles = this.mergeAndPrefix({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      borderRadius: '50%',
	      opacity: opacity ? opacity : 0.16,
	      backgroundColor: color,
	      transition: Transitions.easeOut(pulsateDuration + 'ms', 'transform', null, Transitions.easeInOutFunction)
	    }, innerStyle);
	
	    return React.createElement('div', { ref: 'innerCircle', style: innerStyles });
	  },
	
	  _pulsate: function _pulsate() {
	    if (!this.isMounted()) return;
	
	    var innerCircle = React.findDOMNode(this.refs.innerCircle);
	    if (!innerCircle) return;
	
	    var startScale = 'scale(1)';
	    var endScale = 'scale(0.85)';
	    var currentScale = innerCircle.style[AutoPrefix.single('transform')];
	    var nextScale = undefined;
	
	    currentScale = currentScale || startScale;
	    nextScale = currentScale === startScale ? endScale : startScale;
	
	    innerCircle.style[AutoPrefix.single('transform')] = nextScale;
	    this._timeout = setTimeout(this._pulsate, pulsateDuration);
	  },
	
	  _setRippleSize: function _setRippleSize() {
	    var el = React.findDOMNode(this.refs.innerCircle);
	    var height = el.offsetHeight;
	    var width = el.offsetWidth;
	    var size = Math.max(height, width);
	
	    var oldTop = 0;
	    // For browsers that don't support endsWith()
	    if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	      oldTop = parseInt(el.style.top);
	    }
	    el.style.height = size + 'px';
	    el.style.top = height / 2 - size / 2 + oldTop + 'px';
	  }
	
	});
	
	module.exports = FocusRipple;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var ColorManipulator = __webpack_require__(102);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var UniqueId = __webpack_require__(370);
	var EnhancedTextarea = __webpack_require__(1134);
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value || value === 0;
	}
	
	var TextField = React.createClass({
	  displayName: 'TextField',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    errorStyle: React.PropTypes.object,
	    errorText: React.PropTypes.string,
	    floatingLabelStyle: React.PropTypes.object,
	    floatingLabelText: React.PropTypes.string,
	    fullWidth: React.PropTypes.bool,
	    hintText: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.element]),
	    id: React.PropTypes.string,
	    inputStyle: React.PropTypes.object,
	    multiLine: React.PropTypes.bool,
	    onBlur: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    onEnterKeyDown: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    onKeyDown: React.PropTypes.func,
	    rows: React.PropTypes.number,
	    type: React.PropTypes.string,
	    underlineStyle: React.PropTypes.object,
	    underlineFocusStyle: React.PropTypes.object,
	    underlineDisabledStyle: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      fullWidth: false,
	      type: 'text',
	      rows: 1
	    };
	  },
	
	  getContextProps: function getContextProps() {
	    var theme = this.context.muiTheme;
	
	    return {
	      isRtl: theme.isRtl
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var props = this.props.children ? this.props.children.props : this.props;
	
	    return {
	      errorText: this.props.errorText,
	      hasValue: isValid(props.value) || isValid(props.defaultValue) || props.valueLink && isValid(props.valueLink.value)
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.textField;
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._uniqueId = UniqueId.generate();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var newState = {};
	
	    newState.errorText = nextProps.errorText;
	    if (nextProps.children && nextProps.children.props) {
	      nextProps = nextProps.children.props;
	    }
	
	    var hasValueLinkProp = nextProps.hasOwnProperty('valueLink');
	    var hasValueProp = nextProps.hasOwnProperty('value');
	    var hasNewDefaultValue = nextProps.defaultValue !== this.props.defaultValue;
	
	    if (hasValueLinkProp) {
	      newState.hasValue = isValid(nextProps.valueLink.value);
	    } else if (hasValueProp) {
	      newState.hasValue = isValid(nextProps.value);
	    } else if (hasNewDefaultValue) {
	      newState.hasValue = isValid(nextProps.defaultValue);
	    }
	
	    if (newState) this.setState(newState);
	  },
	
	  getStyles: function getStyles() {
	    var props = this.props;
	    var theme = this.getTheme();
	    var contextProps = this.getContextProps();
	
	    var styles = {
	      root: {
	        fontSize: 16,
	        lineHeight: '24px',
	        width: props.fullWidth ? '100%' : 256,
	        height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	        display: 'inline-block',
	        position: 'relative',
	        fontFamily: this.context.muiTheme.contentFontFamily,
	        transition: Transitions.easeOut('200ms', 'height')
	      },
	      error: {
	        position: 'relative',
	        bottom: 5,
	        fontSize: 12,
	        lineHeight: '12px',
	        color: theme.errorColor,
	        transition: Transitions.easeOut()
	      },
	      hint: {
	        position: 'absolute',
	        lineHeight: '22px',
	        opacity: 1,
	        color: theme.hintColor,
	        transition: Transitions.easeOut(),
	        bottom: 12
	      },
	      input: {
	        tapHighlightColor: 'rgba(0,0,0,0)',
	        padding: 0,
	        position: 'relative',
	        width: '100%',
	        height: '100%',
	        border: 'none',
	        outline: 'none',
	        backgroundColor: theme.backgroundColor,
	        color: props.disabled ? theme.disabledTextColor : theme.textColor,
	        font: 'inherit'
	      },
	      underline: {
	        border: 'none',
	        borderBottom: 'solid 1px ' + theme.borderColor,
	        position: 'absolute',
	        width: '100%',
	        bottom: 8,
	        margin: 0,
	        MozBoxSizing: 'content-box',
	        boxSizing: 'content-box',
	        height: 0
	      },
	      underlineAfter: {
	        position: 'absolute',
	        width: '100%',
	        overflow: 'hidden',
	        userSelect: 'none',
	        cursor: 'default',
	        bottom: 8,
	        borderBottom: 'dotted 2px ' + theme.disabledTextColor
	      },
	      underlineFocus: {
	        borderBottom: 'solid 2px',
	        borderColor: theme.focusColor,
	        transform: 'scaleX(0)',
	        transition: Transitions.easeOut()
	      }
	    };
	
	    styles.error = this.mergeAndPrefix(styles.error, props.errorStyle);
	    styles.underline = this.mergeAndPrefix(styles.underline, props.underlineStyle);
	    styles.underlineAfter = this.mergeAndPrefix(styles.underlineAfter, props.underlineDisabledStyle);
	
	    styles.floatingLabel = this.mergeStyles(styles.hint, {
	      lineHeight: '22px',
	      top: 38,
	      bottom: 'none',
	      opacity: 1,
	      transform: 'scale(1) translate3d(0, 0, 0)',
	      transformOrigin: contextProps.isRtl ? 'right top' : 'left top'
	    });
	
	    styles.textarea = this.mergeStyles(styles.input, {
	      marginTop: props.floatingLabelText ? 36 : 12,
	      marginBottom: props.floatingLabelText ? -36 : -12,
	      boxSizing: 'border-box',
	      font: 'inherit'
	    });
	
	    styles.focusUnderline = this.mergeStyles(styles.underline, styles.underlineFocus, props.underlineFocusStyle);
	
	    if (this.state.isFocused) {
	      styles.floatingLabel.color = theme.focusColor;
	      styles.floatingLabel.transform = 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)';
	      styles.focusUnderline.transform = 'scaleX(1)';
	    }
	
	    if (this.state.hasValue) {
	      styles.floatingLabel.color = ColorManipulator.fade(props.disabled ? theme.disabledTextColor : theme.floatingLabelColor, 0.5);
	      styles.floatingLabel.transform = 'perspective(1px) scale(0.75) translate3d(2px, -28px, 0)';
	      styles.hint.opacity = 0;
	    }
	
	    if (props.floatingLabelText) {
	      styles.hint.opacity = 0;
	      styles.input.boxSizing = 'border-box';
	      if (this.state.isFocused && !this.state.hasValue) styles.hint.opacity = 1;
	    }
	
	    if (props.style && props.style.height) {
	      styles.hint.lineHeight = props.style.height;
	    }
	
	    if (this.state.errorText && this.state.isFocused) styles.floatingLabel.color = styles.error.color;
	    if (props.floatingLabelText && !props.multiLine) styles.input.paddingTop = 26;
	
	    if (this.state.errorText) {
	      styles.focusUnderline.borderColor = styles.error.color;
	      styles.focusUnderline.transform = 'scaleX(1)';
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var errorStyle = _props.errorStyle;
	    var errorText = _props.errorText;
	    var floatingLabelText = _props.floatingLabelText;
	    var fullWidth = _props.fullWidth;
	    var hintText = _props.hintText;
	    var id = _props.id;
	    var multiLine = _props.multiLine;
	    var onBlur = _props.onBlur;
	    var onChange = _props.onChange;
	    var onFocus = _props.onFocus;
	    var type = _props.type;
	    var rows = _props.rows;
	
	    var other = _objectWithoutProperties(_props, ['className', 'errorStyle', 'errorText', 'floatingLabelText', 'fullWidth', 'hintText', 'id', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'type', 'rows']);
	
	    var styles = this.getStyles();
	
	    var inputId = id || this._uniqueId;
	
	    var errorTextElement = this.state.errorText ? React.createElement(
	      'div',
	      { style: styles.error },
	      this.state.errorText
	    ) : null;
	
	    var hintTextElement = hintText ? React.createElement(
	      'div',
	      { style: this.mergeAndPrefix(styles.hint) },
	      hintText
	    ) : null;
	
	    var floatingLabelTextElement = floatingLabelText ? React.createElement(
	      'label',
	      {
	        style: this.mergeAndPrefix(styles.floatingLabel, this.props.floatingLabelStyle),
	        htmlFor: inputId },
	      floatingLabelText
	    ) : null;
	
	    var inputProps = undefined;
	    var inputElement = undefined;
	
	    inputProps = {
	      id: inputId,
	      ref: this._getRef(),
	      style: this.mergeAndPrefix(styles.input, this.props.inputStyle),
	      onBlur: this._handleInputBlur,
	      onFocus: this._handleInputFocus,
	      disabled: this.props.disabled,
	      onKeyDown: this._handleInputKeyDown
	    };
	
	    if (!this.props.hasOwnProperty('valueLink')) {
	      inputProps.onChange = this._handleInputChange;
	    }
	    if (this.props.children) {
	      inputElement = React.cloneElement(this.props.children, _extends({}, inputProps, this.props.children.props));
	    } else {
	      inputElement = multiLine ? React.createElement(EnhancedTextarea, _extends({}, other, inputProps, {
	        rows: rows,
	        onHeightChange: this._handleTextAreaHeightChange,
	        textareaStyle: this.mergeAndPrefix(styles.textarea) })) : React.createElement('input', _extends({}, other, inputProps, {
	        type: type }));
	    }
	
	    var underlineElement = this.props.disabled ? React.createElement('div', { style: this.mergeAndPrefix(styles.underlineAfter) }) : React.createElement('hr', { style: this.mergeAndPrefix(styles.underline) });
	    var focusUnderlineElement = React.createElement('hr', { style: this.mergeAndPrefix(styles.focusUnderline) });
	
	    return React.createElement(
	      'div',
	      { className: className, style: this.mergeAndPrefix(styles.root, this.props.style) },
	      floatingLabelTextElement,
	      hintTextElement,
	      inputElement,
	      underlineElement,
	      focusUnderlineElement,
	      errorTextElement
	    );
	  },
	
	  blur: function blur() {
	    if (this.isMounted()) this._getInputNode().blur();
	  },
	
	  clearValue: function clearValue() {
	    this.setValue('');
	  },
	
	  focus: function focus() {
	    if (this.isMounted()) this._getInputNode().focus();
	  },
	
	  getValue: function getValue() {
	    return this.isMounted() ? this._getInputNode().value : undefined;
	  },
	
	  setErrorText: function setErrorText(newErrorText) {
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' && this.props.hasOwnProperty('errorText')) {
	      console.error('Cannot call TextField.setErrorText when errorText is defined as a property.');
	    } else if (this.isMounted()) {
	      this.setState({ errorText: newErrorText });
	    }
	  },
	
	  setValue: function setValue(newValue) {
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' && this._isControlled()) {
	      console.error('Cannot call TextField.setValue when value or valueLink is defined as a property.');
	    } else if (this.isMounted()) {
	      if (this.props.multiLine) {
	        this.refs[this._getRef()].setValue(newValue);
	      } else {
	        this._getInputNode().value = newValue;
	      }
	
	      this.setState({ hasValue: isValid(newValue) });
	    }
	  },
	
	  _getRef: function _getRef() {
	    return this.props.ref ? this.props.ref : 'input';
	  },
	
	  _getInputNode: function _getInputNode() {
	    return this.props.children || this.props.multiLine ? this.refs[this._getRef()].getInputNode() : React.findDOMNode(this.refs[this._getRef()]);
	  },
	
	  _handleInputBlur: function _handleInputBlur(e) {
	    this.setState({ isFocused: false });
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	
	  _handleInputChange: function _handleInputChange(e) {
	    this.setState({ hasValue: isValid(e.target.value) });
	    if (this.props.onChange) this.props.onChange(e);
	  },
	
	  _handleInputFocus: function _handleInputFocus(e) {
	    if (this.props.disabled) return;
	    this.setState({ isFocused: true });
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _handleInputKeyDown: function _handleInputKeyDown(e) {
	    if (e.keyCode === 13 && this.props.onEnterKeyDown) this.props.onEnterKeyDown(e);
	    if (this.props.onKeyDown) this.props.onKeyDown(e);
	  },
	
	  _handleTextAreaHeightChange: function _handleTextAreaHeightChange(e, height) {
	    var newHeight = height + 24;
	    if (this.props.floatingLabelText) newHeight += 24;
	    React.findDOMNode(this).style.height = newHeight + 'px';
	  },
	
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  }
	
	});
	
	module.exports = TextField;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var createFragment = React.addons.createFragment;
	
	module.exports = {
	
	  create: function create(fragments) {
	    var newFragments = {};
	    var validChildrenCount = 0;
	    var firstKey = undefined;
	
	    //Only create non-empty key fragments
	    for (var key in fragments) {
	      var currentChild = fragments[key];
	
	      if (currentChild) {
	        if (validChildrenCount === 0) firstKey = key;
	        newFragments[key] = currentChild;
	        validChildrenCount++;
	      }
	    }
	
	    if (validChildrenCount === 0) return undefined;
	    if (validChildrenCount === 1) return newFragments[firstKey];
	    return createFragment(newFragments);
	  },
	
	  extend: function extend(children, extendedProps, extendedChildren) {
	
	    return React.isValidElement(children) ? React.Children.map(children, function (child) {
	
	      var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	      var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	      return React.cloneElement(child, newProps, newChildren);
	    }) : children;
	  }
	
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(74);
	
	var utils = module.exports = {
	
	  /**
	   * Return the bottom coordinate of the layout.
	   *
	   * @param  {Array} layout Layout array.
	   * @return {Number}       Bottom coordinate.
	   */
	  bottom: function bottom(layout) {
	    var max = 0,
	        bottomY;
	    for (var i = 0, len = layout.length; i < len; i++) {
	      bottomY = layout[i].y + layout[i].h;
	      if (bottomY > max) max = bottomY;
	    }
	    return max;
	  },
	
	  /**
	   * Clones a shallow object.
	   * @param  {Object} obj Object to clone.
	   * @return {Object}   Cloned object.
	   */
	  clone: function clone(obj) {
	    return assign({}, obj);
	  },
	
	  /**
	   * Given two layouts, check if they collide.
	   *
	   * @param  {Object} l1 Layout object.
	   * @param  {Object} l2 Layout object.
	   * @return {Boolean}   True if colliding.
	   */
	  collides: function collides(l1, l2) {
	    if (l1 === l2) return false; // same element
	    if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
	    if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
	    if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
	    if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
	    return true; // boxes overlap
	  },
	
	  /**
	   * Given a layout, compact it. This involves going down each y coordinate and removing gaps
	   * between items.
	   *
	   * @param  {Array} layout Layout.
	   * @param  {Boolean} verticalCompact Whether or not to compact the layout
	   *   vertically.
	   * @return {Array}       Compacted Layout.
	   */
	  compact: function compact(layout, verticalCompact) {
	    // Statics go in the compareWith array right away so items flow around them.
	    var compareWith = utils.getStatics(layout),
	        out = [];
	    // We go through the items by row and column.
	    var sorted = utils.sortLayoutItemsByRowCol(layout);
	
	    for (var i = 0, len = sorted.length; i < len; i++) {
	      var l = sorted[i];
	
	      // Don't move static elements
	      if (!l['static']) {
	        l = utils.compactItem(compareWith, l, verticalCompact);
	
	        // Add to comparison array. We only collide with items before this one.
	        // Statics are already in this array.
	        compareWith.push(l);
	      }
	
	      // Add to output array to make sure they still come out in the right order.
	      out[layout.indexOf(l)] = l;
	
	      // Clear moved flag, if it exists.
	      delete l.moved;
	    }
	
	    return out;
	  },
	
	  compactItem: function compactItem(compareWith, l, verticalCompact) {
	    if (verticalCompact) {
	      // Move the element up as far as it can go without colliding.
	      while (l.y > 0 && !utils.getFirstCollision(compareWith, l)) {
	        l.y--;
	      }
	    }
	
	    // Move it down, and keep moving it down if it's colliding.
	    var collides;
	    while (collides = utils.getFirstCollision(compareWith, l)) {
	      l.y = collides.y + collides.h;
	    }
	    return l;
	  },
	
	  /**
	   * Given a layout, make sure all elements fit within its bounds.
	   *
	   * @param  {Array} layout Layout array.
	   * @param  {Number} bounds Number of columns.
	   * @return {[type]}        [description]
	   */
	  correctBounds: function correctBounds(layout, bounds) {
	    var collidesWith = utils.getStatics(layout);
	    for (var i = 0, len = layout.length; i < len; i++) {
	      var l = layout[i];
	      // Overflows right
	      if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
	      // Overflows left
	      if (l.x < 0) {
	        l.x = 0;
	        l.w = bounds.cols;
	      }
	      if (!l['static']) collidesWith.push(l);else {
	        // If this is static and collides with other statics, we must move it down.
	        // We have to do something nicer than just letting them overlap.
	        while (utils.getFirstCollision(collidesWith, l)) {
	          l.y++;
	        }
	      }
	    }
	    return layout;
	  },
	
	  /**
	   * Get a layout item by ID. Used so we can override later on if necessary.
	   *
	   * @param  {Array}  layout Layout array.
	   * @param  {Number} id     ID
	   * @return {LayoutItem}    Item at ID.
	   */
	  getLayoutItem: function getLayoutItem(layout, id) {
	    id = "" + id;
	    for (var i = 0, len = layout.length; i < len; i++) {
	      if ("" + layout[i].i === id) return layout[i];
	    }
	  },
	
	  /**
	   * Returns the first item this layout collides with.
	   * It doesn't appear to matter which order we approach this from, although
	   * perhaps that is the wrong thing to do.
	   *
	   * @param  {Object} layoutItem Layout item.
	   * @return {Object|undefined}  A colliding layout item, or undefined.
	   */
	  getFirstCollision: function getFirstCollision(layout, layoutItem) {
	    for (var i = 0, len = layout.length; i < len; i++) {
	      if (utils.collides(layout[i], layoutItem)) return layout[i];
	    }
	  },
	
	  getAllCollisions: function getAllCollisions(layout, layoutItem) {
	    var out = [];
	    for (var i = 0, len = layout.length; i < len; i++) {
	      if (utils.collides(layout[i], layoutItem)) out.push(layout[i]);
	    }
	    return out;
	  },
	
	  /**
	   * Get all static elements.
	   * @param  {Array} layout Array of layout objects.
	   * @return {Array}        Array of static layout items..
	   */
	  getStatics: function getStatics(layout) {
	    var out = [];
	    for (var i = 0, len = layout.length; i < len; i++) {
	      if (layout[i]['static']) out.push(layout[i]);
	    }
	    return out;
	  },
	
	  /**
	   * Move an element. Responsible for doing cascading movements of other elements.
	   *
	   * @param  {Array}      layout Full layout to modify.
	   * @param  {LayoutItem} l      element to move.
	   * @param  {Number}     [x]    X position in grid units.
	   * @param  {Number}     [y]    Y position in grid units.
	   * @param  {Boolean}    [isUserAction] If true, designates that the item we're moving is
	   *                                     being dragged/resized by th euser.
	   */
	  moveElement: function moveElement(layout, l, x, y, isUserAction) {
	    if (l['static']) return layout;
	
	    // Short-circuit if nothing to do.
	    if (l.y === y && l.x === x) return layout;
	
	    var movingUp = l.y > y;
	    // This is quite a bit faster than extending the object
	    if (x !== undefined) l.x = x;
	    if (y !== undefined) l.y = y;
	    l.moved = true;
	
	    // If this collides with anything, move it.
	    // When doing this comparison, we have to sort the items we compare with
	    // to ensure, in the case of multiple collisions, that we're getting the
	    // nearest collision.
	    var sorted = utils.sortLayoutItemsByRowCol(layout);
	    if (movingUp) sorted = sorted.reverse();
	    var collisions = utils.getAllCollisions(sorted, l);
	
	    // Move each item that collides away from this element.
	    for (var i = 0, len = collisions.length; i < len; i++) {
	      var collision = collisions[i];
	      // console.log('resolving collision between', l.i, 'at', l.y, 'and', collision.i, 'at', collision.y);
	
	      // Short circuit so we can't infinite loop
	      if (collision.moved) continue;
	
	      // This makes it feel a bit more precise by waiting to swap for just a bit when moving up.
	      if (l.y > collision.y && l.y - collision.y > collision.h / 4) continue;
	
	      // Don't move static items - we have to move *this* element away
	      if (collision['static']) {
	        layout = utils.moveElementAwayFromCollision(layout, collision, l, isUserAction);
	      } else {
	        layout = utils.moveElementAwayFromCollision(layout, l, collision, isUserAction);
	      }
	    }
	
	    return layout;
	  },
	
	  /**
	   * This is where the magic needs to happen - given a collision, move an element away from the collision.
	   * We attempt to move it up if there's room, otherwise it goes below.
	   *
	   * @param  {Array} layout            Full layout to modify.
	   * @param  {LayoutItem} collidesWith Layout item we're colliding with.
	   * @param  {LayoutItem} itemToMove   Layout item we're moving.
	   * @param  {Boolean} [isUserAction]  If true, designates that the item we're moving is being dragged/resized
	   *                                   by the user.
	   */
	  moveElementAwayFromCollision: function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction) {
	
	    // If there is enough space above the collision to put this element, move it there.
	    // We only do this on the main collision as this can get funky in cascades and cause
	    // unwanted swapping behavior.
	    if (isUserAction) {
	      // Make a mock item so we don't modify the item here, only modify in moveElement.
	      var fakeItem = {
	        x: itemToMove.x,
	        y: itemToMove.y,
	        w: itemToMove.w,
	        h: itemToMove.h
	      };
	      fakeItem.y = Math.max(collidesWith.y - itemToMove.h, 0);
	      if (!utils.getFirstCollision(layout, fakeItem)) {
	        return utils.moveElement(layout, itemToMove, undefined, fakeItem.y);
	      }
	    }
	
	    // Previously this was optimized to move below the collision directly, but this can cause problems
	    // with cascading moves, as an item may actually leapflog a collision and cause a reversal in order.
	    return utils.moveElement(layout, itemToMove, undefined, itemToMove.y + 1);
	  },
	
	  /**
	   * Helper to convert a number to a percentage string.
	   *
	   * @param  {Number} num Any number
	   * @return {String}     That number as a percentage.
	   */
	  perc: function perc(num) {
	    return num * 100 + '%';
	  },
	
	  setTransform: function setTransform(style, coords) {
	    // Replace unitless items with px
	    var x = ('' + coords[0]).replace(/(\d)$/, '$1px');
	    var y = ('' + coords[1]).replace(/(\d)$/, '$1px');
	    style.transform = "translate(" + x + "," + y + ")";
	    style.WebkitTransform = "translate(" + x + "," + y + ")";
	    style.MozTransform = "translate(" + x + "," + y + ")";
	    style.msTransform = "translate(" + x + "," + y + ")";
	    style.OTransform = "translate(" + x + "," + y + ")";
	    return style;
	  },
	
	  /**
	   * Get layout items sorted from top left to right and down.
	   *
	   * @return {Array} Array of layout objects.
	   * @return {Array}        Layout, sorted static items first.
	   */
	  sortLayoutItemsByRowCol: function sortLayoutItemsByRowCol(layout) {
	    return [].concat(layout).sort(function (a, b) {
	      if (a.y > b.y || a.y === b.y && a.x > b.x) {
	        return 1;
	      }
	      return -1;
	    });
	  },
	
	  /**
	   * Generate a layout using the initialLayout an children as a template.
	   * Missing entries will be added, extraneous ones will be truncated.
	   *
	   * @param  {Array}  initialLayout Layout passed in through props.
	   * @param  {String} breakpoint    Current responsive breakpoint.
	   * @param  {Boolean} verticalCompact Whether or not to compact the layout
	   *   vertically.
	   * @return {Array}                Working layout.
	   */
	  synchronizeLayoutWithChildren: function synchronizeLayoutWithChildren(initialLayout, children, cols, verticalCompact) {
	    // ensure 'children' is always an array
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	    initialLayout = initialLayout || [];
	
	    // Generate one layout item per child.
	    var layout = [];
	    for (var i = 0, len = children.length; i < len; i++) {
	      var child = children[i];
	      // Don't overwrite if it already exists.
	      var exists = utils.getLayoutItem(initialLayout, child.key);
	      if (exists) {
	        // Ensure 'i' is always a string
	        exists.i = '' + exists.i;
	        layout.push(exists);
	        continue;
	      }
	      // New item: attempt to use a layout item from the child, if it exists.
	      var g = child.props._grid;
	      if (g) {
	        utils.validateLayout([g], 'ReactGridLayout.child');
	        // Validated; add it to the layout. Bottom 'y' possible is the bottom of the layout.
	        // This allows you to do nice stuff like specify {y: Infinity}
	        if (verticalCompact) {
	          layout.push(assign({}, g, { y: Math.min(utils.bottom(layout), g.y), i: child.key }));
	        } else {
	          layout.push(assign({}, g, { y: g.y, i: child.key }));
	        }
	      } else {
	        // Nothing provided: ensure this is added to the bottom
	        layout.push({ w: 1, h: 1, x: 0, y: utils.bottom(layout), i: child.key });
	      }
	    }
	
	    // Correct the layout.
	    layout = utils.correctBounds(layout, { cols: cols });
	    layout = utils.compact(layout, verticalCompact);
	
	    return layout;
	  },
	
	  /**
	   * Validate a layout. Throws errors.
	   *
	   * @param  {Array}  layout        Array of layout items.
	   * @param  {String} [contextName] Context name for errors.
	   * @throw  {Error}                Validation error.
	   */
	  validateLayout: function validateLayout(layout, contextName) {
	    contextName = contextName || "Layout";
	    var subProps = ['x', 'y', 'w', 'h'];
	    if (!Array.isArray(layout)) throw new Error(contextName + " must be an array!");
	    for (var i = 0, len = layout.length; i < len; i++) {
	      for (var j = 0; j < subProps.length; j++) {
	        if (typeof layout[i][subProps[j]] !== 'number') {
	          throw new Error('ReactGridLayout: ' + contextName + '[' + i + '].' + subProps[j] + ' must be a Number!');
	        }
	      }
	      if (layout[i]['static'] !== undefined && typeof layout[i]['static'] !== 'boolean') {
	        throw new Error('ReactGridLayout: ' + contextName + '[' + i + '].static must be a Boolean!');
	      }
	    }
	  }
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var React = __webpack_require__(1);
	var invariant = __webpack_require__(15);
	var PropTypes = __webpack_require__(90);
	var RouteHandler = __webpack_require__(216);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div class="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  function Route() {
	    _classCallCheck(this, Route);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Route, _React$Component);
	
	  _createClass(Route, {
	    render: {
	      value: function render() {
	        invariant(false, "%s elements are for router configuration only and should not be rendered", this.constructor.name);
	      }
	    }
	  });
	
	  return Route;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var React = __webpack_require__(1);
	var ContextWrapper = __webpack_require__(1209);
	var assign = __webpack_require__(25);
	var PropTypes = __webpack_require__(90);
	
	var REF_NAME = "__routeHandler__";
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(RouteHandler, _React$Component);
	
	  _createClass(RouteHandler, {
	    getChildContext: {
	      value: function getChildContext() {
	        return {
	          routeDepth: this.context.routeDepth + 1
	        };
	      }
	    },
	    componentDidMount: {
	      value: function componentDidMount() {
	        this._updateRouteComponent(this.refs[REF_NAME]);
	      }
	    },
	    componentDidUpdate: {
	      value: function componentDidUpdate() {
	        this._updateRouteComponent(this.refs[REF_NAME]);
	      }
	    },
	    componentWillUnmount: {
	      value: function componentWillUnmount() {
	        this._updateRouteComponent(null);
	      }
	    },
	    _updateRouteComponent: {
	      value: function _updateRouteComponent(component) {
	        this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	      }
	    },
	    getRouteDepth: {
	      value: function getRouteDepth() {
	        return this.context.routeDepth;
	      }
	    },
	    createChildRouteHandler: {
	      value: function createChildRouteHandler(props) {
	        var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	        return route ? React.createElement(route.handler, assign({}, props || this.props, { ref: REF_NAME })) : null;
	      }
	    },
	    render: {
	      value: function render() {
	        var handler = this.createChildRouteHandler();
	        // <script/> for things like <CSSTransitionGroup/> that don't like null
	        return handler ? React.createElement(
	          ContextWrapper,
	          null,
	          handler
	        ) : React.createElement("script", null);
	      }
	    }
	  });
	
	  return RouteHandler;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusMixin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var focusNode = __webpack_require__(678);
	
	var AutoFocusMixin = {
	  componentDidMount: function() {
	    if (this.props.autoFocus) {
	      focusNode(this.getDOMNode());
	    }
	  }
	};
	
	module.exports = AutoFocusMixin;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function(InjectedMount) {
	    injection.Mount = InjectedMount;
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        InjectedMount && InjectedMount.getNode,
	        'EventPluginUtils.injection.injectMount(...): Injected Mount module ' +
	        'is missing getNode.'
	      ) : invariant(InjectedMount && InjectedMount.getNode));
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp ||
	         topLevelType === topLevelTypes.topTouchEnd ||
	         topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove ||
	         topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown ||
	         topLevelType === topLevelTypes.topTouchStart;
	}
	
	
	var validateEventDispatches;
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  validateEventDispatches = function(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ?
	      dispatchListeners.length :
	      dispatchListeners ? 1 : 0;
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      idsIsArr === listenersIsArr && IDsLen === listenersLen,
	      'EventPluginUtils: Invalid `event`.'
	    ) : invariant(idsIsArr === listenersIsArr && IDsLen === listenersLen));
	  };
	}
	
	/**
	 * Invokes `cb(event, listener, id)`. Avoids using call if no scope is
	 * provided. The `(listener,id)` pair effectively forms the "dispatch" but are
	 * kept separate to conserve memory.
	 */
	function forEachEventDispatch(event, cb) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      cb(event, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    cb(event, dispatchListeners, dispatchIDs);
	  }
	}
	
	/**
	 * Default implementation of PluginModule.executeDispatch().
	 * @param {SyntheticEvent} SyntheticEvent to handle
	 * @param {function} Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, listener, domID) {
	  event.currentTarget = injection.Mount.getNode(domID);
	  var returnValue = listener(event, domID);
	  event.currentTarget = null;
	  return returnValue;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, cb) {
	  forEachEventDispatch(event, cb);
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return id of the first dispatch execution who's listener returns true, or
	 * null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    !Array.isArray(dispatchListener),
	    'executeDirectDispatch(...): Invalid `event`.'
	  ) : invariant(!Array.isArray(dispatchListener)));
	  var res = dispatchListener ?
	    dispatchListener(event, dispatchID) :
	    null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {bool} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatch: executeDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	  injection: injection,
	  useTouchEvents: false
	};
	
	module.exports = EventPluginUtils;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactComponentWithPureRenderMixin
	*/
	
	'use strict';
	
	var shallowEqual = __webpack_require__(686);
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this Mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function(nextProps, nextState) {
	    return !shallowEqual(this.props, nextProps) ||
	           !shallowEqual(this.state, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactInstanceMap = __webpack_require__(129);
	
	var invariant = __webpack_require__(15);
	
	var component;
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function(emptyComponent) {
	    component = ReactElement.createFactory(emptyComponent);
	  }
	};
	
	var ReactEmptyComponentType = function() {};
	ReactEmptyComponentType.prototype.componentDidMount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Make sure we run these methods in the correct order, we shouldn't
	  // need this check. We're going to assume if we're here it means we ran
	  // componentWillUnmount already so there is no internal instance (it gets
	  // removed as part of the unmounting process).
	  if (!internalInstance) {
	    return;
	  }
	  registerNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.componentWillUnmount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Get rid of this check. See TODO in componentDidMount.
	  if (!internalInstance) {
	    return;
	  }
	  deregisterNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.render = function() {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    component,
	    'Trying to return null from a render, but no null placeholder component ' +
	    'was injected.'
	  ) : invariant(component));
	  return component();
	};
	
	var emptyElement = ReactElement.createElement(ReactEmptyComponentType);
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponent = {
	  emptyElement: emptyElement,
	  injection: ReactEmptyComponentInjection,
	  isNullComponentID: isNullComponentID
	};
	
	module.exports = ReactEmptyComponent;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function(componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function(componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  },
	  // Temporary hack since we expect DOM refs to behave like composites,
	  // for this release.
	  injectAutoWrapper: function(wrapperFactory) {
	    autoGenerateWrapperClass = wrapperFactory;
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    genericComponentClass,
	    'There is no registered component for the tag %s',
	    element.type
	  ) : invariant(genericComponentClass));
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(151);
	var ViewportMetrics = __webpack_require__(386);
	
	var getEventModifierState = __webpack_require__(390);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function(event) {
	    return event.relatedTarget || (
	      ((event.fromElement === event.srcElement ? event.toElement : event.fromElement))
	    );
	  },
	  // "Proprietary" Interface.
	  pageX: function(event) {
	    return 'pageX' in event ?
	      event.pageX :
	      event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function(event) {
	    return 'pageY' in event ?
	      event.pageY :
	      event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (!this.wrapperInitData) {
	      this.wrapperInitData = [];
	    } else {
	      this.wrapperInitData.length = 0;
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function() {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} args... Arguments to pass to the method (optional).
	   *                           Helps prevent need to bind in many cases.
	   * @return Return value from `method`.
	   */
	  perform: function(method, scope, a, b, c, d, e, f) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !this.isInTransaction(),
	      'Transaction.perform(...): Cannot initialize a transaction when there ' +
	      'is already an outstanding transaction.'
	    ) : invariant(!this.isInTransaction()));
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {
	          }
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ?
	          wrapper.initialize.call(this) :
	          null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function(startIndex) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      this.isInTransaction(),
	      'Transaction.closeAll(): Cannot close transaction when none are open.'
	    ) : invariant(this.isInTransaction()));
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {
	          }
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occured.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;


/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;


/***/ },
/* 226 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AppDispatcher = __webpack_require__(42);
	var ActionTypes = __webpack_require__(2).ActionTypes;
	
	var SessionActionCreators = {
	
	    updatingNewVersionApi: function updatingNewVersionApi() {
	        AppDispatcher.dispatch({
	            type: ActionTypes.NEW_VERSION_API
	        });
	    },
	
	    saveSettingModal: function saveSettingModal() {
	        AppDispatcher.dispatch({
	            type: ActionTypes.SAVE_CONFIGURATION_SETTINGS
	        });
	    }
	};
	
	module.exports = SessionActionCreators;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AppDispatcher = __webpack_require__(42);
	var ActionTypes = __webpack_require__(2).ActionTypes;
	
	var SessionActionCreators = {
	    loggedIn: function loggedIn(userName, token, applicantId, texts) {
	        AppDispatcher.dispatch({
	            type: ActionTypes.LOGGED_IN,
	            userName: userName,
	            token: token,
	            applicantId: applicantId,
	            texts: texts
	        });
	    },
	    loggedOut: function loggedOut() {
	        AppDispatcher.dispatch({
	            type: ActionTypes.LOGGED_OUT
	        });
	    },
	    signIn: function signIn(email, pass, onSuccess, onFailure) {
	        AppDispatcher.dispatch({
	            type: ActionTypes.SIGN_IN,
	            email: email,
	            pass: pass,
	            onSuccess: onSuccess,
	            onFailure: onFailure
	        });
	    },
	    permissionRequestUpdate: function permissionRequestUpdate(userName, token, applicantId) {
	        AppDispatcher.dispatch({
	            type: ActionTypes.PERMISSION_REQUEST_UPDATE,
	            userName: userName,
	            token: token,
	            applicantId: applicantId
	        });
	    },
	    permissionUpdated: function permissionUpdated() {
	        AppDispatcher.dispatch({
	            type: ActionTypes.PERMISSION_UPDATED
	        });
	    },
	    signUp: function signUp(userForm) {
	        AppDispatcher.dispatch({
	            type: ActionTypes.SIGN_UP,
	            userForm: userForm
	        });
	    }
	};
	
	module.exports = SessionActionCreators;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1327);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(12),
	    Checkbox = _require.Checkbox,
	    PropTypes = React.PropTypes;
	
	
	var GridItem = React.createClass({ displayName: "GridItem",
	    propTypes: {
	        className: PropTypes.string,
	        iconClassName: PropTypes.string,
	        iconInnerText: PropTypes.string,
	        iconId: PropTypes.number,
	        isChecked: PropTypes.boolean,
	        onCheck: PropTypes.func,
	        label: PropTypes.string,
	        urlImage: PropTypes.string,
	        showCheck: PropTypes.bool
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.refs.inputCheckbox) {
	            this.refs.inputCheckbox.setChecked(nextProps.isChecked);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        if (this.refs.inputCheckbox) {
	            this.refs.inputCheckbox.setChecked(this.props.isChecked);
	        }
	    },
	    onCheck: function onCheck() {
	        if (this.props.onCheck) {
	            this.props.onCheck(this.props);
	        }
	    },
	    _handleKeyPress: function _handleKeyPress(evt) {
	        if (evt.key === 'Enter' || evt.key === ' ') {
	            this.onCheck();
	        }
	    },
	    _getImage: function _getImage(urlImage) {
	        return (urlImage && urlImage) !== '' ? React.createElement("img", { className: "bp-grid-item__checkbox-image", src: urlImage }) : null; // prevent show broken image element
	    },
	    _getIcon: function _getIcon(iconClassName, iconInnerText) {
	        return React.createElement("i", { className: 'bp-grid-item__icon ' + (iconClassName ? ' ' + iconClassName : '') }, iconInnerText ? iconInnerText : null);
	    },
	    render: function render() {
	        var _props = this.props,
	            label = _props.label,
	            urlImage = _props.urlImage,
	            isChecked = _props.isChecked,
	            showCheck = _props.showCheck,
	            className = _props.className,
	            iconClassName = _props.iconClassName,
	            iconInnerText = _props.iconInnerText;
	
	
	        var haveUrlImage = !!urlImage;
	        var imageEl = haveUrlImage ? this._getImage(urlImage) : this._getIcon(iconClassName, iconInnerText);
	
	        var classNameEl = void 0,
	            classNameLabel = void 0;
	
	        if (isChecked) {
	            classNameLabel = 'bp-grid-item__label bp-grid-item__label--checked';
	            classNameEl = 'bp-grid-item__checkbox bp-grid-item__checkbox--checked';
	        } else {
	            classNameLabel = 'bp-grid-item__label';
	            classNameEl = 'bp-grid-item__checkbox';
	        }
	
	        if (className) {
	            classNameEl = classNameEl + ' ' + className;
	        }
	
	        var checkEl = showCheck ? React.createElement("div", {
	            className: "bp-grid-item bp-grid-item--checked pull-left",
	            "data-should-focus": "true",
	            tabIndex: "0",
	            onKeyPress: this._handleKeyPress
	        }, React.createElement("div", { className: classNameEl }, React.createElement(Checkbox, { onCheck: this.onCheck, ref: "inputCheckbox" }), imageEl), React.createElement("label", { className: "bp-grid-item__label" }, label)) : React.createElement("div", {
	            className: "bp-grid-item pull-left",
	            "data-should-focus": "true",
	            tabIndex: "0",
	            onKeyPress: this._handleKeyPress,
	            onClick: this.onCheck
	        }, React.createElement("div", { className: classNameEl }, imageEl), React.createElement("label", { className: classNameLabel }, label));
	
	        return checkEl;
	    }
	});
	
	module.exports = GridItem;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1337);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    some = _require2.some,
	    find = _require2.find,
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7),
	    TextFieldSuggestedList = __webpack_require__(716),
	    TextField = __webpack_require__(106);
	
	
	var DEFAULT_ATTRIBUTE_READER = 'name';
	var DEFAULT_ATTRIBUTE_ID = 'id';
	
	var TextFieldSuggested = React.createClass({ displayName: "TextFieldSuggested",
	
	    propTypes: {
	        value: PropTypes.string,
	        floatingLabelText: PropTypes.string,
	        items: PropTypes.array,
	        itemsDisabled: PropTypes.array,
	        isDisabled: PropTypes.bool,
	        errorText: PropTypes.string,
	        readerAttribute: PropTypes.string,
	        readerAttributeValue: PropTypes.string,
	        onItemSelected: PropTypes.func,
	        onEnterKeyDown: PropTypes.func,
	        onPressScape: PropTypes.func,
	        classCSS: PropTypes.string,
	        hiddenIcon: PropTypes.bool
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            itemSelected: null,
	            textWritten: null,
	            isPristine: true
	        };
	    },
	    onChangeText: function onChangeText(evt) {
	        if (evt && evt.target) {
	            var textWritten = evt.target.value;
	            evt.preventDefault();
	
	            this.setState({
	                isPressedKeyArrowDown: false,
	                isPristine: false,
	                textWritten: textWritten
	            });
	        }
	    },
	    onBlur: function onBlur() {
	        var _props = this.props,
	            onBlur = _props.onBlur,
	            items = _props.items,
	            readerAttribute = _props.readerAttribute,
	            value = _props.value,
	            readerAttributeValue = _props.readerAttributeValue;
	        var itemSelected = this.state.itemSelected;
	
	        var textWritten = this.getTextWritten();
	
	        var isListExpanded = this.isListExpanded();
	        // check by text written and then by current item selected (if really have)
	        var filterTextFiltered = textWritten || get(itemSelected, readerAttribute);
	
	        var itemsFiltered = filterItems(items, filterTextFiltered, readerAttribute, value, readerAttributeValue);
	        var matchSomeItemsWithTextWritten = some(itemsFiltered, function (item) {
	            return get(item, readerAttribute) === filterTextFiltered;
	        });
	
	        if (matchSomeItemsWithTextWritten) {
	            var lastItemSelected = void 0;
	            if (isListExpanded) {
	                var firstItemEnable = find(itemsFiltered, function (item) {
	                    return get(item, readerAttribute) === filterTextFiltered && get(item, 'isDisabled') !== true;
	                });
	                lastItemSelected = firstItemEnable;
	            } else {
	                lastItemSelected = itemSelected;
	            }
	
	            if (onBlur) {
	                onBlur(lastItemSelected, ContentUtils.trim(textWritten));
	            }
	        } else {
	            if (onBlur) {
	                onBlur(null, ContentUtils.trim(textWritten));
	            }
	        }
	    },
	    isEditMode: function isEditMode() {
	        return !!this.props.value;
	    },
	    onClick: function onClick(itemSelected) {
	        var _this = this;
	
	        var onItemSelected = this.props.onItemSelected;
	
	        if (itemSelected) {
	            this.setState({
	                itemSelected: itemSelected,
	                textWritten: null,
	                isPressedKeyArrowDown: false
	            }, function () {
	                _this.focusInput();
	                if (itemSelected && onItemSelected) {
	                    onItemSelected(itemSelected);
	                }
	            });
	        }
	    },
	    getValue: function getValue() {
	        return this.state.itemSelected;
	    },
	    cleanValue: function cleanValue() {
	        this.setState({
	            itemSelected: null
	        });
	    },
	    isListExpanded: function isListExpanded() {
	        var textWritten = this.state.textWritten;
	
	        var isCurrentFocusSomeListItem = document.activeElement && document.activeElement.classList.contains('bp-textfield-suggested-list-item');
	        return !!isCurrentFocusSomeListItem || !!textWritten;
	    },
	    onKeyDown: function onKeyDown(evt) {
	        var _props2 = this.props,
	            readerAttribute = _props2.readerAttribute,
	            items = _props2.items,
	            onEnterKeyDown = _props2.onEnterKeyDown,
	            onItemSelected = _props2.onItemSelected,
	            value = _props2.value;
	
	
	        if (!evt) {
	            return;
	        }
	
	        var itemSelected = this.state.itemSelected;
	
	
	        var isListExpanded = this.isListExpanded();
	        var isListCollapsed = !isListExpanded;
	        var isEditMode = this.isEditMode();
	        var isNewMode = !isEditMode;
	        var textWritten = this.getTextWritten();
	        var isSomeTextWritten = !!textWritten;
	        var isNotTextWritten = !isSomeTextWritten;
	
	        var isPressedKeyArrowUp = evt.keyCode === 38;
	        var isPressedKeyArrowDown = evt.keyCode === 40;
	        var isPressedKeyEnter = evt.keyCode === 13;
	        var isPressedKeyScape = evt.keyCode === 27;
	        var isPressedKeyBackspace = evt.keyCode === 8;
	        var isPressedKeyBackspaceAndWasRemovedAllText = isPressedKeyBackspace && get(textWritten, 'length', 0) <= 1;
	        var isEmptyTextWrittenIsListCollapsedIsNewModeIsPressedEnter = isNotTextWritten && isListCollapsed && isNewMode && isPressedKeyEnter;
	        var isItemEnable = evt.target && !evt.target.classList.contains('is-disabled');
	
	        if (isPressedKeyScape) {
	            this.onPressScape(isPressedKeyArrowDown);
	        } else if (isPressedKeyBackspaceAndWasRemovedAllText) {
	            this.onPressBackSpace(isPressedKeyArrowDown, onItemSelected);
	        } else if (!isEmptyTextWrittenIsListCollapsedIsNewModeIsPressedEnter && isPressedKeyEnter && isItemEnable) {
	            this.onPressEnter(items, textWritten, readerAttribute, isPressedKeyArrowDown, onEnterKeyDown, isListCollapsed, onItemSelected);
	        } else if (isPressedKeyArrowDown && isListCollapsed) {
	            this.onPressArrowDownAndListIsCollapsed(isEditMode, value, isPressedKeyArrowDown, readerAttribute, textWritten, itemSelected);
	        } else if (isListExpanded && (isPressedKeyArrowDown || isPressedKeyArrowUp)) {
	            this.onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown);
	        }
	    },
	    onPressBackSpace: function onPressBackSpace(isPressedKeyArrowDown, onItemSelected) {
	        this.setState({
	            isPressedKeyArrowDown: isPressedKeyArrowDown,
	            itemSelected: null,
	            textWritten: null
	        }, function () {
	            if (onItemSelected) {
	                onItemSelected(null);
	            }
	        });
	    },
	    onPressScape: function onPressScape(isPressedKeyArrowDown) {
	        var _this2 = this;
	
	        // just press scape and return the focus to the input
	        this.setState({
	            isPressedKeyArrowDown: isPressedKeyArrowDown,
	            textWritten: null
	        }, function () {
	            _this2.focusInput();
	            if (_this2.props.onPressScape) {
	                _this2.props.onPressScape();
	            }
	        });
	    },
	    onPressArrowUpOrDownArrow: function onPressArrowUpOrDownArrow(isPressedKeyArrowUp, isPressedKeyArrowDown) {
	        var _this3 = this;
	
	        // the user if list is open, their want to walk
	        // in the list of items with arrows (up & down), like a tab behavior
	        var activeElement = document.activeElement;
	        var isFocusOutSideOfList = !activeElement.classList.contains('bp-textfield-suggested-list-item');
	
	        if (isFocusOutSideOfList) {
	            var firstItem = this.getDOMNode().querySelector('.bp-textfield-suggested-list-item');
	            if (firstItem) {
	                firstItem.focus();
	            }
	        } else if (isPressedKeyArrowUp) {
	            var nextElement = activeElement.previousElementSibling;
	
	            if (nextElement) {
	                activeElement.previousElementSibling.focus();
	            } else {
	                this.setState({ textWritten: null, isPressedKeyArrowDown: isPressedKeyArrowDown }, function () {
	                    _this3.focusInput();
	                });
	            }
	        } else if (isPressedKeyArrowDown) {
	            var _nextElement = activeElement.nextElementSibling;
	
	            if (_nextElement) {
	                if (activeElement.nextElementSibling) {
	                    activeElement.nextElementSibling.focus();
	                }
	            }
	        }
	    },
	    onPressEnter: function onPressEnter(items, textWritten, readerAttribute, isPressedKeyArrowDown, onEnterKeyDown, isListCollapsed, onItemSelected) {
	        var _this4 = this;
	
	        var itemsFiltered = filterItems(items, textWritten, readerAttribute);
	        var existSomeItemFiltered = get(itemsFiltered, 'length', 0) >= 1;
	        var firstItemEnable = find(itemsFiltered, function (item) {
	            return item.isDisabled !== true;
	        });
	
	        if (existSomeItemFiltered) {
	
	            this.setState({
	                isPressedKeyArrowDown: isPressedKeyArrowDown,
	                itemSelected: firstItemEnable,
	                textWritten: null
	            }, function () {
	                _this4.focusInput();
	                if (onItemSelected) {
	                    onItemSelected(firstItemEnable);
	                }
	            });
	        }
	
	        // select the first of the list
	        if (onEnterKeyDown && isListCollapsed) {
	            onEnterKeyDown(firstItemEnable);
	        }
	    },
	    onPressArrowDownAndListIsCollapsed: function onPressArrowDownAndListIsCollapsed(isEditMode, value, isPressedKeyArrowDown, readerAttribute, textWritten, itemSelected) {
	        var _this5 = this;
	
	        // check if write some text, otherwise just use the selected value, and
	        // finally check default value (in case of edit mode)
	        this.setState({
	            isPressedKeyArrowDown: isPressedKeyArrowDown,
	            textWritten: ContentUtils.trim(textWritten ? textWritten : get(itemSelected, readerAttribute))
	        }, function () {
	            _this5.focusFirstItem();
	        });
	    },
	    focusFirstItem: function focusFirstItem() {
	        // user want to open dialog list to show all items possibles
	        var firstItemEl = this.getDOMNode().querySelector('.bp-textfield-suggested-list-item');
	        if (firstItemEl) {
	            firstItemEl.focus();
	        }
	    },
	    focusInput: function focusInput() {
	        // maybe reach to limit of item list, return focus to text-field
	        this.getDOMNode().querySelector('input').focus();
	    },
	    getTextWritten: function getTextWritten() {
	        return this.getDOMNode().querySelector('.bp-textfield-suggested input').value;
	    },
	    render: function render() {
	        var _props3 = this.props,
	            readerAttribute = _props3.readerAttribute,
	            items = _props3.items,
	            itemsDisabled = _props3.itemsDisabled,
	            floatingLabelText = _props3.floatingLabelText,
	            value = _props3.value,
	            errorText = _props3.errorText,
	            readerAttributeValue = _props3.readerAttributeValue,
	            isDisabled = _props3.isDisabled,
	            classCSS = _props3.classCSS,
	            hiddenIcon = _props3.hiddenIcon;
	        var _state = this.state,
	            itemSelected = _state.itemSelected,
	            isPristine = _state.isPristine,
	            isPressedKeyArrowDown = _state.isPressedKeyArrowDown,
	            textWritten = _state.textWritten;
	
	
	        var itemsFiltered = filterItems(items, textWritten, readerAttribute, value, readerAttributeValue);
	        var itemsDisabledFiltered = filterItems(itemsDisabled, textWritten, readerAttribute, value, readerAttributeValue);
	        var consumerWriteText = !!textWritten;
	        var consumerRemoveAllText = !isPristine && textWritten === '';
	
	        // relay first in internal (`itemSelected`) state
	        // because is the last user change. If not exist
	        // then check default value (`consumerDefinedValue`)
	        var currentItem = itemSelected ? itemSelected : isPristine ? value : null;
	        var currentValue = get(currentItem, readerAttribute);
	
	        // relay always in the last users changes
	        var textValue = consumerRemoveAllText ? null : consumerWriteText ? textWritten : currentValue;
	
	        // just if consumer not write text, not need to expand the suggested list
	        // only exception when hit arrow down
	        var isExpanded = isPressedKeyArrowDown || !!consumerWriteText;
	
	        return React.createElement("div", {
	            className: "bp-textfield-suggested" + (classCSS ? ' ' + classCSS : ''),
	            onKeyDownCapture: this.onKeyDown
	        }, React.createElement(TextField, {
	            errorText: errorText,
	            floatingLabelText: floatingLabelText,
	            icon: hiddenIcon ? '' : 'search',
	
	            onChange: this.onChangeText,
	            onBlur: this.onBlur,
	            onEnterKeyDown: this.onBlur,
	            disabled: isDisabled,
	            value: textValue }), React.createElement(TextFieldSuggestedList, {
	            textWritten: textValue,
	            isExpanded: isExpanded,
	            items: itemsFiltered,
	            itemsDisabled: itemsDisabledFiltered,
	            readerAttribute: readerAttribute,
	            onClick: this.onClick }));
	    }
	});
	
	function filterItems(items, textWritten) {
	    var readerAttribute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ATTRIBUTE_READER;
	    var currentSelected = arguments[3];
	    var readerAttributeValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_ATTRIBUTE_ID;
	
	    var notFilterDefined = ContentUtils.isNullOrEmpty(textWritten);
	    var textWrittenCleaned = ContentUtils.trim(textWritten);
	
	    if (notFilterDefined) {
	        return items;
	    }
	
	    var currentSelectedId = null;
	    if (currentSelected) {
	        currentSelectedId = get(currentSelected, readerAttributeValue);
	    }
	
	    return filter(items, function (item) {
	        if (currentSelectedId) {
	            var itemSelectedId = get(item, readerAttributeValue);
	            var isCurrentItemSelected = itemSelectedId === currentSelectedId;
	            if (isCurrentItemSelected) {
	                // enter here means don't want to repeat the item selected in the list
	                // to avoid duplication issues validations
	                return false;
	            }
	        }
	
	        return (get(item, readerAttribute, '') || '').toLowerCase().includes(textWrittenCleaned.toLowerCase());
	    });
	}
	
	module.exports = TextFieldSuggested;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1340);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    uploadcare = __webpack_require__(1379);
	
	var Uploader = React.createClass({ displayName: "Uploader",
	
	    propTypes: {
	        label: PropTypes.string,
	        isDisabled: PropTypes.bool,
	        onChange: PropTypes.func,
	        onUploadComplete: PropTypes.func,
	        imgSrc: PropTypes.func
	    },
	
	    componentDidMount: function componentDidMount() {
	        uploadcare.start({
	            publicKey: '5571fda16e2a7f7cd8b5',
	            tabs: 'all',
	            crop: '64x64',
	            live: true,
	            previewStep: true
	        });
	
	        var _props = this.props,
	            onChange = _props.onChange,
	            onUploadComplete = _props.onUploadComplete;
	
	        var widget = uploadcare.Widget('[role=uploadcare-uploader]'); // get internal reference element
	
	        if (onChange) {
	            widget.onChange(onChange);
	        }
	        if (onUploadComplete) {
	            widget.onUploadComplete(onUploadComplete);
	        }
	    },
	    getValue: function getValue() {
	        return this.refs.inputFile.getDOMNode().value;
	    },
	    setValue: function setValue(newValue) {
	        this.refs.inputFile.getDOMNode().value = newValue;
	    },
	    render: function render() {
	        var inputEl = this.props.isDisabled === true ? React.createElement("input", { ref: "inputFile",
	            type: "hidden",
	            "data-public-key": "5571fda16e2a7f7cd8b5",
	            role: "uploadcare-uploader",
	            name: "uploadcare-uploader-name",
	            id: "uploader-image-id",
	            disabled: true }) : React.createElement("input", { ref: "inputFile",
	            type: "hidden",
	            "data-public-key": "5571fda16e2a7f7cd8b5",
	            role: "uploadcare-uploader",
	            name: "uploadcare-uploader-name",
	            id: "uploader-image-id",
	            onChange: this.props.onChange });
	
	        return React.createElement("div", { className: "uploader" }, React.createElement("label", { className: "uploader uploader__label pull-left", for: "uploader-image-id" }, this.props.label), inputEl);
	    }
	});
	
	module.exports = Uploader;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var SchedulerAppDispatcher = __webpack_require__(42),
	    EventEmitter = __webpack_require__(109).EventEmitter,
	    Constants = __webpack_require__(2),
	    ActionTypes = Constants.ActionTypes,
	    SessionStore = __webpack_require__(11),
	    DashboardServiceImpl = __webpack_require__(132),
	    assign = __webpack_require__(74),
	    DashboardAction = __webpack_require__(65);
	
	var UserTaskStore = assign({}, EventEmitter.prototype, {
	
	  _scheduleBoardList: [],
	  _notesHasSameStateMapping: {},
	
	  setScheduleBoardList: function setScheduleBoardList(data) {
	    this._scheduleBoardList = data;
	  },
	  onChangeNote: function onChangeNote(originalNote, changedNote) {
	    this._notesHasSameStateMapping[originalNote.id] = this.isNoteEquals(originalNote, changedNote);
	  },
	  isAllChangesSaved: function isAllChangesSaved() {
	    return JSON.stringify(this._notesHasSameStateMapping || {}) === '{}' || Object.values(this._notesHasSameStateMapping).every(function (value) {
	      return value;
	    });
	  },
	  resetAllChangesNote: function resetAllChangesNote() {
	    this._notesHasSameStateMapping = {};
	  },
	  markAsSavedNote: function markAsSavedNote(task) {
	    this._notesHasSameStateMapping[task.id] = true;
	  },
	  isUserTaskFetching: function isUserTaskFetching() {
	    return SessionStore.isUserTaskFetching();
	  },
	  getScheduleBoardList: function getScheduleBoardList() {
	    return this._scheduleBoardList || [];
	  },
	  emitChange: function emitChange() {
	    this.emit('change');
	  },
	  addChangeListener: function addChangeListener(call) {
	    this.addListener('change', call);
	  },
	  removeChangeListener: function removeChangeListener(call) {
	    this.removeListener('change', call);
	  },
	  saveChangedUserTaskName: function saveChangedUserTaskName(data, onSuccess, onFailure) {
	    DashboardServiceImpl.saveChangedUserTaskName(data, onSuccess, onFailure);
	  },
	  removeUserTask: function removeUserTask(data, onSuccess, onFailure) {
	    DashboardServiceImpl.removeUserTask(data, onSuccess, onFailure);
	  },
	  addUserTaskName: function addUserTaskName(data, onSuccess, onFailure) {
	    DashboardServiceImpl.addUserTaskName(data, onSuccess, onFailure);
	  },
	  deleteUserTaskName: function deleteUserTaskName(data, onSuccess, onFailure) {
	    DashboardServiceImpl.deleteUserTaskName(data, onSuccess, onFailure);
	  },
	  fetchScheduleBoardByDate: function fetchScheduleBoardByDate(date) {
	    DashboardServiceImpl.fetchScheduleBoardByDate(date, function () {
	      DashboardAction.fetchScheduleBoardByDateSuccess(JSON.parse(this.response || '{}'));
	    }, function () {
	      DashboardAction.fetchScheduleBoardByDateFailure();
	    });
	  },
	  isNoteEquals: function isNoteEquals(original, changed) {
	    return original && changed && original.message === changed.message && original.name === changed.name && original.checked === changed.checked;
	  }
	});
	
	UserTaskStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
	  switch (action.type) {
	    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD:
	      SessionStore.setUserTaskFetching(true);
	      UserTaskStore.addUserTaskName({
	        date: action.date,
	        note: action.note,
	        id: action.id,
	        listId: action.listId,
	        listName: action.listName,
	        name: action.name,
	        checked: action.checked
	      }, DashboardAction.fetchScheduleBoardByDate.bind(this, action.date), DashboardAction.addUserTaskNameFailure);
	      break;
	
	    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD_SUCCESS:
	      SessionStore.setUserTaskFetching(false);
	      break;
	
	    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD_FAILURE:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.SAVING_SCHEDULE_BOARD:
	      SessionStore.setUserTaskFetching(true);
	      SessionStore.setUserTaskDate(action.date);
	      UserTaskStore.saveChangedUserTaskName({
	        date: action.date,
	        name: action.name,
	        id: action.id,
	        originalName: action.originalName
	      }, DashboardAction.saveChangedUserTaskNameSuccess, DashboardAction.saveChangedUserTaskNameFailure);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.SAVING_SCHEDULE_BOARD_SUCCESS:
	      UserTaskStore.fetchScheduleBoardByDate(SessionStore.getUserTaskDate());
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.SAVING_SCHEDULE_BOARD_FAILURE:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.DELETING_SCHEDULE_BOARD:
	      SessionStore.setUserTaskFetching(true);
	      UserTaskStore.deleteUserTaskName({ id: action.id, listName: action.listName }, DashboardAction.deleteUserTaskNameSuccess, DashboardAction.deleteUserTaskNameFailure);
	      break;
	
	    case ActionTypes.DELETING_SCHEDULE_BOARD_SUCCESS:
	      UserTaskStore.fetchScheduleBoardByDate(SessionStore.getUserTaskDate());
	      SessionStore.setUserTaskFetching(true);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.DELETING_SCHEDULE_BOARD_FAILURE:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.FETCH_SCHEDULE_BOARD:
	      SessionStore.setUserTaskFetching(true);
	      SessionStore.setUserTaskDate(action.date);
	      UserTaskStore.emitChange();
	      UserTaskStore.fetchScheduleBoardByDate(action.date);
	      break;
	
	    case ActionTypes.FETCH_SCHEDULE_BOARD_SUCCESS:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.setScheduleBoardList(action.data);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.FETCH_SCHEDULE_BOARD_FAILURE:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	    case ActionTypes.DELETING_USER_TASK:
	      UserTaskStore.removeUserTask({ id: action.id, listId: action.listId }, DashboardAction.fetchScheduleBoardByDate.bind(this, SessionStore.getUserTaskDate()), DashboardAction.removeUserTaskFailure);
	      break;
	
	    case ActionTypes.DELETING_USER_TASK_SUCCESS:
	      break;
	
	    case ActionTypes.DELETING_USER_TASK_FAILURE:
	      SessionStore.setUserTaskFetching(false);
	      UserTaskStore.emitChange();
	      break;
	
	  }
	});
	
	module.exports = UserTaskStore;

/***/ },
/* 233 */
/***/ function(module, exports) {

	'use strict';
	
	var LocaleUtils = {
	    getCurrentLocale: function getCurrentLocale() {
	        return navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en-gb';
	    }
	};
	
	module.exports = LocaleUtils;

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Module dependencies.
	 */
	
	var getDocument = __webpack_require__(816);
	
	/**
	 * Module exports.
	 */
	
	module.exports = getBoundingClientRect;
	
	/**
	 * Returns the "bounding client rectangle" of the given `TextNode`,
	 * `HTMLElement`, or `Range`.
	 *
	 * @param {Node} node
	 * @return {TextRectangle}
	 * @public
	 */
	
	function getBoundingClientRect (node) {
	  var rect = null;
	  var doc = getDocument(node);
	
	  if (node.nodeType === 3 /* TEXT_NODE */) {
	    // see: http://stackoverflow.com/a/6966613/376773
	    var range = doc.createRange();
	    range.selectNodeContents(node);
	    node = range;
	  }
	
	  if ('function' === typeof node.getBoundingClientRect) {
	    rect = node.getBoundingClientRect();
	
	    if (node.startContainer && rect.left === 0 && rect.top === 0) {
	      // Range instances sometimes report all `0`s
	      // see: http://stackoverflow.com/a/6847328/376773
	      var span = doc.createElement('span');
	
	      // Ensure span has dimensions and position by
	      // adding a zero-width space character
	      span.appendChild(doc.createTextNode('\u200b'));
	      node.insertNode(span);
	      rect = span.getBoundingClientRect();
	
	      // Remove temp SPAN and glue any broken text nodes back together
	      var spanParent = span.parentNode;
	      spanParent.removeChild(span);
	      spanParent.normalize();
	    }
	
	  }
	
	  return rect;
	}


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(309);
	var GetIntrinsic = __webpack_require__(158);
	var setFunctionLength = __webpack_require__(1310);
	
	var $TypeError = __webpack_require__(133);
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $defineProperty = __webpack_require__(308);
	var $max = GetIntrinsic('%Math.max%');
	
	module.exports = function callBind(originalFunction) {
		if (typeof originalFunction !== 'function') {
			throw new $TypeError('a function is required');
		}
		var func = $reflectApply(bind, $call, arguments);
		return setFunctionLength(
			func,
			1 + $max(0, originalFunction.length - (arguments.length - 1)),
			true
		);
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=\"button\"],input[type=\"reset\"],input[type=\"submit\"]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=\"checkbox\"],input[type=\"radio\"]{box-sizing:border-box;padding:0}input[type=\"number\"]::-webkit-inner-spin-button,input[type=\"number\"]::-webkit-outer-spin-button{height:auto}input[type=\"search\"]{-webkit-appearance:textfield;box-sizing:content-box}input[type=\"search\"]::-webkit-search-cancel-button,input[type=\"search\"]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".box-selector{background-color:#f6f6f6;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:1em 1em 2em;font-size:15px;font-family:\"Roboto\",sans-serif;cursor:pointer;border-bottom:solid .3em gray;transition:all .5s;overflow:auto}.box-selector:hover .box-selector__body{border-color:#f6f6f6}.box-selector:hover .box-selector__header{border-color:transparent}.box-selector:active{border-bottom:solid .1em gray;transform:translateY(4px)}.box-selector:hover{background-color:rgba(252,202,46,.54902);border-bottom:solid .3em #c69c26}.box-selector__header{padding-bottom:.3em;font-weight:100;color:#5c5e5d;font-size:1.4em;white-space:nowrap;margin-bottom:1.15em}.box-selector__body{width:8em;margin:0 auto;height:7.5em;border-radius:50%;border:solid .5em #e3e3e3;padding-top:0;overflow:hidden;background-color:#fff}.box-selector__body-image{text-align:center;padding:.8em 1.1em 1em 1em;width:100%;margin:0}", ""]);

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-chip{display:flex;align-items:center;justify-content:space-between;font-size:11px;height:1em;line-height:2.1em;margin:.5em;padding:1em 3px 1em 1em;border-radius:2em;box-shadow:inset 0 3px 10px 0 lightgrey;background-color:#f6f6f6;color:#777}.bp-chip:hover{background-color:#f1f1f1}.bp-chip__text{font-size:1em;line-height:2.1em;text-shadow:1px 2px 1px lightgrey;font-weight:400;padding-right:12px}.bp-chip__icon .material-icons{font-size:1em;line-height:1em;margin-top:.5em;border-radius:50%;padding:.4em;border:solid 1.5px;color:#000}", ""]);

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.admin-scaffolding-header{background-color:#031B3A}.admin-scaffolding-history{position:absolute;height:55px;width:58px;top:72px;right:8px;padding:4px;z-index:1;text-align:center;cursor:pointer}.admin-scaffolding-history:hover{background-color:#777}.admin-scaffolding-history:hover:before{content:' ';bottom:-2px;position:absolute;left:0;height:2px;width:inherit;border:1px solid #00bcd4}.admin-scaffolding-history .right-option-menu{top:-5px}.admin-scaffolding-history small{color:#fff;position:absolute;bottom:2px;left:12px}.admin-scaffolding-history button{padding:0}", ""]);

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".basic-form-container{background-color:#031B3A;color:#fff;padding-bottom:23px;padding-top:23px}.basic-form-container input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px transparent inset}@media (min-width:1200px){.basic-form-container{min-height:163px}}.basic-form-container .basic-form-breadcrumb{margin:9px 0 0 9px}.basic-form-container .basic-form-header{line-height:20px}.basic-form-container .basic-form-header h1{margin:0 0 15px -5px;padding-top:10px;font-size:30px;font-weight:300!important;letter-spacing:2px}.basic-form-container .basic-form-buttons{clear:both}.basic-form-container .basic-form-fields{font-weight:300!important;clear:both}@media (max-width:767px){.basic-form-container .basic-form-fields{max-width:208px}}.basic-form-container .basic-form-fields .form-group{float:left;margin-left:10px;width:200px}@media (max-width:767px){.basic-form-container .basic-form-fields .form-group{width:calc(100vw - 50px)}}.basic-form-container .basic-form-content{padding:7px 1px;margin-top:7px;font-weight:300!important}@media (max-width:767px){.basic-form-container .basic-form-content{clear:both;margin-top:-10px}}@media (max-width:767px){.basic-form-container .basic-form-content:not(.additional-button){margin-top:10px;display:flex;justify-content:flex-end;width:99%}}@media (max-width:767px){.basic-form-container .basic-form-content.additional-button .form-group-button{width:calc(100vw - 50px);display:block}}.basic-form-container .basic-form-content-additional-actions{line-height:47px}", ""]);

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".form-group-date-picker{margin-top:-23px}.form-group-date-picker label{color:#fff!important;font-weight:100}.form-group-date-picker input{color:#fff!important}", ""]);

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.form-group-dropdown-custom{position:relative;top:-25px}.form-group-dropdown-custom .bp-textfield__label{font-weight:300!important;color:#fff}.form-group-dropdown-custom .bp-textfield__icon{color:#fff;top:9px!important}", ""]);

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.form-group-image-chooser{top:-60px;margin-left:-130px!important;margin-right:30px;width:295px;position:relative;margin-top:20px}@media (max-width:767px){.form-group-image-chooser{top:-40px;margin-left:-130px!important;margin-right:30px;width:280px;position:relative;margin-top:20px}}.form-group-image-chooser .uploader{position:relative;top:35px;width:190px;display:inline}.form-group-image-chooser .uploader label{font-weight:300!important;left:190px;top:-12px;width:190px;margin-left:-50px;color:#fff!important}", ""]);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".form-group-textfield-suggested{width:auto!important;height:40px}.form-group-textfield-suggested .bp-textfield{height:1.3em}.form-group-textfield-suggested .bp-textfield__input{margin-top:.3em}.form-group-textfield-suggested .bp-textfield__label{color:#fff!important;font-weight:200!important}.form-group-textfield-suggested .bp-textfield__icon{bottom:0!important;color:#777}", ""]);

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.form-group-toggle{top:-23px;position:relative}.form-group-toggle label{font-weight:100!important;margin-top:16px;font-size:16px;margin-left:7px}@media (max-width:767px){.form-group-toggle label{margin-left:10px}.form-group-toggle label .form-group-toggle-input{margin-left:-5px;left:-10px}}", ""]);

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-breadcrumb{font-size:16px;font-weight:300;padding:.1em;overflow:hidden;display:block;height:2.2em;line-height:2.2em;cursor:pointer}.bp-breadcrumb__list{margin:.1em;padding:.5em;list-style:none;height:1.8em;line-height:.9em;overflow:hidden}.bp-breadcrumb__list li{position:relative;display:inline;margin-right:1.5em;margin-left:-1.5em;padding:.5em .5em .5em 1.7em;transition:all .5s;background-color:#fff}.bp-breadcrumb__list li:first-child,.bp-breadcrumb__list li:first-child:before{background-color:#fcca2e}.bp-breadcrumb__list li:nth-child(2),.bp-breadcrumb__list li:nth-child(2):before{background-color:#fde493}.bp-breadcrumb__list li:nth-child(3),.bp-breadcrumb__list li:nth-child(3):before{background-color:#fffdf7}.bp-breadcrumb__list li:nth-child(4),.bp-breadcrumb__list li:nth-child(4):before,.bp-breadcrumb__list li:nth-child(5),.bp-breadcrumb__list li:nth-child(5):before{background-color:#fff}.bp-breadcrumb__list li a{color:#000;text-decoration:none}.bp-breadcrumb__list li:hover{background-color:#777}.bp-breadcrumb__list li:hover a{color:#fff}.bp-breadcrumb__list li:hover:before{background-color:#777}.bp-breadcrumb__list li:before{content:\"\";right:0;top:0;position:absolute;height:2.2em;width:2.1em;z-index:2;border-right:solid .1em #777;border-bottom:solid .1em #777;border-radius:5em 3px 0 10px;transform:translateX(1.2em) scale(.8) rotate(-45deg);transition:all .5s;background-color:#fff}", ""]);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-carousel{height:7.12em;width:52em;font-size:14px;display:flex;justify-content:center;align-items:center;overflow:hidden}.bp-carousel__content{display:flex;height:inherit;width:52em;margin:0;padding:.35em 0;list-style:none}.bp-carousel__arrow{width:2em;height:6.42em;text-align:center;display:flex;align-items:center;top:calc(3.1em - 1em);justify-content:center;z-index:10;color:#fff;-moz-osx-font-smoothing:grayscale}.bp-carousel__arrow,.bp-carousel__arrow-left{cursor:pointer;-webkit-font-smoothing:antialiased}.bp-carousel__arrow-left{position:absolute;left:.4em;padding:1em;border-radius:1em;line-height:1em;height:1.5em;width:1.5em;font-weight:100;font-size:1.2em;background-color:rgba(128,128,128,.2)!important;text-shadow:0 3px 2px #000}.bp-carousel__arrow-left:hover{background-color:rgba(128,128,128,.7)!important;transition:all .3s}.bp-carousel__arrow-right{position:absolute;right:.4em;cursor:pointer;padding:1em;border-radius:1em;line-height:1em;height:1.5em;width:1.5em;font-weight:100;font-size:1.2em;background-color:rgba(128,128,128,.2)!important;text-shadow:0 3px 2px #000;-webkit-font-smoothing:antialiased}.bp-carousel__arrow-right:hover{background-color:rgba(128,128,128,.7)!important;transition:all .3s}.bp-carousel__arrow i{font-size:1em}.bp-carousel-item{width:52em;height:6.42em;position:relative;left:-52em}.bp-carousel-item.is-moving{transition:all 1s}.bp-carousel-item a{width:52em;height:6.42em;display:block}.bp-carousel-item__image{height:6.42em;background-size:cover;opacity:.8}.bp-carousel-item.pull-left-banner{transform:translateX(-52em)}.bp-carousel-item.pull-right-banner{transform:translateX(52em)}", ""]);

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".div[data-menu-context=\"right-click-context-menu\"]{position:fixed!important;z-index:-1!important;width:300px!important;overflow:hidden}.div[data-menu-context=\"right-click-context-menu\"].is-visible{z-index:1000!important}div[data-menu-context=\"right-click-context-menu\"]{padding-top:40px!important}div[data-menu-context=\"right-click-context-menu\"].is-new-mode:before{height:36px;top:-9px}div[data-menu-context=\"right-click-context-menu\"]:before{content:attr(data-display-first-line);height:75px;position:absolute;top:0;width:320px;text-overflow:ellipsis;padding-left:20px;line-height:20px;color:#fff;background-color:#757575;border-radius:2px 2px 0 0;font-weight:400;left:0;padding-top:35px;margin-bottom:9px;overflow:hidden}div[data-menu-context=\"right-click-context-menu\"]:after{content:attr(data-display-second-line);position:absolute;color:rgba(255,255,255,.79);top:10px;left:20px}.context-menu.icon .material-icons{left:20px!important}.context-menu.icon:hover{background-color:#eee!important;border-left:solid 3px #848484!important}.menu-container>div{overflow:hidden;box-shadow:2px 4px 8px 0 grey}.menu-container>div>div{padding-top:50px}", ""]);

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.dashboard-modal-content.bp-custom-modal__content h3{background-color:#fff!important;margin-bottom:-45px!important}.modal-order .dashboard-modal-content.bp-custom-modal__content h3{color:#000!important}", ""]);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-drop-down{cursor:pointer;width:inherit}.bp-drop-down .bp-textfield{width:auto}.bp-drop-down .bp-textfield__input{color:transparent;text-shadow:0 0 0 #fff}@media all and (-ms-high-contrast:none),(-ms-high-contrast:active){.bp-drop-down .bp-textfield__input{color:#fff}}.bp-drop-down .bp-textfield.is-empty-label .bp-textfield__input{margin-top:2.1em!important}", ""]);

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-grid-item{position:relative;width:120px;height:60px;margin:4px;transition:all .3s;border-radius:3px;box-shadow:3px 3px 8px 0 #777;color:#fff;text-align:center;background-color:#031B3A;overflow:hidden}.bp-grid-item input[type=\"checkbox\"]{height:60px!important}.bp-grid-item:hover{border:none;box-shadow:4px 5px 4px 0 #777;cursor:pointer;background-color:#2f2f2f}.bp-grid-item:hover svg path{fill:#031B3A}.bp-grid-item:hover__label{color:#031B3A}.bp-grid-item--checked{background-color:#fcca2e!important}.bp-grid-item--checked:hover{background-color:#c69c26}.bp-grid-item__label{position:absolute;bottom:0;left:0;width:inherit;font-size:12px;font-weight:500;text-align:center;cursor:pointer}.bp-grid-item__label--checked{color:#031B3A!important}.bp-grid-item__checkbox{height:61px;font-size:20px;text-align:left}.bp-grid-item__checkbox svg path{fill:#fcca2e}.bp-grid-item__checkbox svg path:hover{fill:#031B3A!important}.bp-grid-item__checkbox--checked{height:60px;border-radius:2px 2px;background-color:#fcca2e!important}.bp-grid-item__checkbox--checked:hover{background-color:#c69c26}.bp-grid-item__checkbox-image{height:35px;position:absolute;top:3px;left:23px}.bp-grid-item__checkbox.is-changed{border-bottom:solid 4px #e3007e;border-radius:3px}.bp-grid-item__checkbox-input{position:absolute;right:5px;top:5px;appearance:none;height:15px;width:15px}.bp-grid-item__checkbox-input.material-icons{cursor:pointer;outline:none;user-select:none;height:1.3em;width:1.3em;font-size:1.2em}.bp-grid-item__checkbox-input.material-icons.is-checked{border:none}.bp-grid-item__icon{font-size:28px;display:block;padding-top:6px;text-align:center;text-shadow:0 2px 4px #031B3A}", ""]);

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-grid-item-filter{margin:-20px 0 30px 5px}", ""]);

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-grid-item-withfilter{overflow:auto;padding:20px}", ""]);

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-loading{position:relative}.bp-loading__icon{background:url(/assets/images/loading-dashboard-2.gif) no-repeat center!important;background-size:52px!important;transform:scale(1.3) translateY(19px);width:52px;height:52px!important;display:block;top:60px}.bp-loading__icon,.bp-loading:before{position:absolute;left:calc(50vw - 30px)}.bp-loading:before{content:\"\";right:0;bottom:0;background:0 0;box-shadow:-17px 77px 27px 0 grey;height:7px;border-radius:50%;width:87px;top:100px}", ""]);

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-menu-list{position:absolute;width:inherit;background-color:#f6f6f6;box-shadow:1px 3px 4px #B3B3B3;color:#031B3A;z-index:10;cursor:pointer}.bp-menu-list ul{list-style:none;padding:0}", ""]);

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-menu-list-item{width:inherit;position:relative;line-height:40px;padding:0 5px;color:#031B3A;z-index:5;cursor:pointer}.bp-menu-list-item__content{display:flex;justify-content:flex-start}.bp-menu-list-item__content .bp-stamp__border-image{margin-top:3px}.bp-menu-list-item__content .bp-stamp__icon.icon-task:before{font-size:15px;left:9px;top:9px}.bp-menu-list-item__content-text{padding-left:7px}.bp-menu-list-item:hover,.bp-menu-list-item:focus{background-color:#d5d5d5;cursor:pointer;outline:none;transition:all .4s}.bp-menu-list-item li{list-style:none;margin:0;padding:0 5px}", ""]);

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.pagination-list{display:flex;position:absolute;bottom:-1.2em;left:50%;transform:translateX(-50%);justify-content:center;padding:.5em;background:rgba(204,204,204,.5);border-radius:15px 15px 0 0}@media (min-width:768px){.pagination-list{font-size:16px}}@media (max-width:767px){.pagination-list{font-size:13px;bottom:-1.5em}}.pagination-list .pagination-item{color:#434445;background-color:#00bcd4;width:3em;height:3em;padding:.9em 1em;border-radius:50%;margin:.1em;cursor:pointer;box-shadow:0 3px 4px 0 gray;background-color:#B3B3B3;font-size:.7em;text-align:center;font-weight:500;user-select:none}.pagination-list .pagination-item:hover{opacity:.5}.pagination-list .pagination-item:active{transform:translateY(2px)}.pagination-list .pagination-item.is-active{background-color:#fcca2e;opacity:.7}.pagination-list .pagination-item.is-active:hover{background-color:#fcca2e;opacity:.7}.pagination-list .pagination-start,.pagination-list .pagination-end{width:3em;height:3em;padding:.9em 1em;border-radius:50%;margin:.1em;cursor:pointer;box-shadow:0 3px 4px 0 gray;background-color:#777;font-size:.7em;text-align:center;font-weight:500;user-select:none;color:#f6f6f6}.pagination-list .pagination-start:hover,.pagination-list .pagination-end:hover{opacity:.5}.pagination-list .pagination-start:active,.pagination-list .pagination-end:active{transform:translateY(2px)}.pagination-list .pagination-start.is-active,.pagination-list .pagination-end.is-active{background-color:#fcca2e;opacity:.7}.pagination-list .pagination-start.is-active:hover,.pagination-list .pagination-end.is-active:hover{background-color:#fcca2e;opacity:.7}", ""]);

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-stamp{height:34px;position:relative;width:inherit;justify-content:space-around;padding:17px}.bp-stamp.is-empty-text .bp-stamp__image{top:6px}.bp-stamp:before{content:attr(data-text);color:#fff;width:37px;position:absolute;font-size:10px;bottom:-3px;left:0;z-index:1;text-align:center}.bp-stamp__border-image{background-color:#031B3A;border-radius:50%;box-shadow:1px 1px 1px 0 #777;height:inherit;width:35px;position:absolute;top:0;left:0}.bp-stamp__image{position:absolute;display:inline;height:22px;padding:2px;top:1px;width:inherit}.bp-stamp__icon{position:absolute;display:inline;height:auto;padding:7px;top:0;width:auto;background-color:transparent!important}.bp-stamp__icon.icon-task{left:49px;background-color:transparent!important}.bp-stamp__icon.icon-task:before{font-size:15px;left:8px}.bp-stamp__icon.material-icons{color:#fff;font-size:19px;left:0}.bp-stamp__icon-non-text{font-size:17px;padding:8px;color:#fff}.bp-stamp__icon-non-text:before{height:inherit;display:block;left:0;top:0;width:inherit;margin-left:-1px;padding:inherit;color:#fff;font-size:17px}.bp-stamp__icon-non-text.material-icons{top:3px;left:1px}.bp-stamp__icon-text{left:10px;top:13px}.bp-stamp__icon-text:before{font-size:15px;left:8px}", ""]);

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-stamps{display:flex;justify-content:flex-start;padding-left:0;margin-left:-15px}.bp-stamps--small,.bp-stamps--medium,.bp-stamps--large{height:30px}", ""]);

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-textfield{font-family:Roboto,sans-serif;display:flex;justify-content:flex-start;align-items:center;font-size:20px;height:2.5em;position:relative;cursor:pointer;width:256px;margin-top:15px}.bp-textfield.is-auto-with{width:auto}.bp-textfield.is-textarea{width:100%}.bp-textfield.is-disabled{cursor:not-allowed!important}.bp-textfield.is-disabled label{color:#7f7f7f!important;cursor:not-allowed!important}.bp-textfield.is-disabled input{color:#B3B3B3!important;cursor:not-allowed!important}@media not all and (min-resolution:.001dpcm){@supports (-webkit-appearance:none){.bp-textfield.is-disabled input{color:#4c4c4c!important}}}.bp-textfield__input{margin-top:2.1em;line-height:1.4em!important;padding:.8em .8em 1.5em 0;width:100%;font-size:.8em;border:none;background-color:inherit}.bp-textfield__input--textarea{position:absolute;top:-1.5em;overflow:hidden}.bp-textfield__input:focus{outline:none}.bp-textfield__input.is-disabled{color:#B3B3B3;cursor:not-allowed}.bp-textfield__icon{display:flex!important;height:1.3em;align-items:center;top:10px;color:lightgray}.bp-textfield__underline{height:2px;width:100%;display:inline-block;position:absolute;bottom:-22px;left:0;border:none;transform:scaleX(0);transition:all 450ms cubic-bezier(.23,1,.32,1)0ms;z-index:1}.bp-textfield__underline-fixed{height:1px;width:100%;display:inline-block;position:absolute;bottom:-21px;left:0;border-top:solid 1px #e0e0e0;border-bottom:none;border-left:none;border-right:none}.bp-textfield__error{position:absolute;height:48px;width:100%;left:0;bottom:-4.1em;font-size:.6em;color:#f44336}.bp-textfield__label{display:inline-block;position:absolute;width:100%;line-height:1.4em;left:0;bottom:-1px;padding-left:0;white-space:nowrap;font-size:1.1em;transition:all 300ms linear;color:#777;letter-spacing:1px}.bp-textfield.is-text-area{width:100%}.bp-textfield:not(.is-in-use):not(.is-active) .bp-textfield__label{font-size:.8em;font-weight:600;padding-bottom:0}.bp-textfield.is-in-use .bp-textfield__label{transform:translate3d(-25%,-65%,0) scale(.5)}.bp-textfield.have-error .bp-textfield__underline{transition:all 300ms linear;transform:scaleX(1)}.bp-textfield.is-active .bp-textfield__label{display:inline-block;transform:translate3d(-25%,-65%,0) scale(.5);color:#00bcd4}.bp-textfield.is-active .bp-textfield__underline{transition:all 300ms linear;border-top:solid 2px #00bcd4;transform:scaleX(1)}.bp-textfield.is-empty-label .bp-textfield__input{margin-top:0}.bp-textfield textarea{resize:none}", ""]);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-textfield-suggested{position:relative}.bp-textfield-suggested .bp-textfield__icon{top:-3px!important}", ""]);

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-textfield-suggested-list{position:absolute;top:32px;background-color:#f6f6f6;box-shadow:1px 3px 4px #B3B3B3;color:#031B3A;z-index:5;cursor:pointer}.bp-textfield-suggested-list ul{list-style:none;margin:0;padding:0}.bp-textfield-suggested-list .bp-textfield__icon{top:-5px!important}", ""]);

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-textfield-suggested-list-item{line-height:20px;padding:5px 10px;cursor:pointer}.bp-textfield-suggested-list-item .is-matching{padding:3px 0;border-radius:3px;font-weight:500;background-color:#fcca2e}.bp-textfield-suggested-list-item:hover,.bp-textfield-suggested-list-item:focus{background-color:#d5d5d5;outline:none}.bp-textfield-suggested-list-item.is-disabled{color:#B3B3B3;cursor:not-allowed}", ""]);

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.uploader{margin-top:0}.uploader .uploadcare-widget-button-open{margin-top:13px;padding:12px;font-weight:400;font-size:10px;background:#00bcd4!important}.uploader__label{padding-bottom:6px;color:rgba(0,0,0,.3)!important}", ""]);

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-custom-overlay{display:none;background-color:rgba(51,51,51,.63);height:100vh;width:100vw;z-index:8;position:fixed}.bp-custom-overlay.is-visible{display:initial}.bp-custom-overlay.is-visible.has-text:before{content:attr(data-text);position:fixed;top:50%;left:45%;background-color:#fff;padding:10px 20px;border-radius:5px;box-shadow:1px 2px 11px 2px;border:solid 2px #ddd;font-size:18px;font-weight:300}", ""]);

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.modal-order-container{background-color:#fff}@media (min-width:769px){.modal-order .dashboard-modal-content{max-width:none!important;width:900px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content{width:auto!important;margin:initial!important;overflow:inherit;height:900px!important;top:0}}@media (max-width:768px){.modal-order .dashboard-modal-content>div{width:inherit}}@media (min-width:769px){.modal-order .dashboard-modal-content>div{min-width:580px;width:auto}}.modal-order .dashboard-modal-content__label-batch-number{width:125px;top:-23px;position:relative;float:left;margin-right:5px;margin-left:20px}@media (max-width:768px){.modal-order .dashboard-modal-content__label-batch-number{top:-20px;position:relative;height:78px;margin:40px 0 7px;width:90%}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-cancel{margin:10px 0!important;padding:5px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-save{margin:10px 0!important;padding:5px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-remove{margin:10px 0!important;padding:5px!important}}.modal-order .dashboard-modal-content>div>div:nth-child(3){min-height:94px;padding-top:24px!important;border-top:solid 1px #d5d5d5;background-color:#f0f1f2;position:sticky;bottom:65px}@media (max-width:768px){.modal-order .dashboard-modal-content>div>div:nth-child(3){padding:15px;display:flex;flex-direction:column}}.modal-order .dashboard-modal-content>div>div:nth-child(3) button{background-color:#f0f1f2;margin-left:10px!important}.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){margin-top:25px!important;max-height:420px!important;height:420px!important}@media (max-height:740px) and (min-width:760px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:5rem!important}}@media (max-height:625px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:10rem!important}}@media (max-height:575px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:15rem!important}}@media (max-height:525px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:20rem!important}}@media (max-height:500px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:25rem!important}}.modal-order .inventory-transfer-modal>div>div:nth-child(2){margin-top:25px!important}.modal-order .dashboard-modal-content h3{background-color:#031B3A;line-height:34px!important;color:#fff!important;font-weight:400!important}@media (max-width:768px){.modal-order .modal-order-container.fluid-container{padding-left:0;padding-top:0;margin-top:0}}.modal-order .modal-order-dialog>div{min-width:580px}.modal-order .modal-order-dialog>div>div{background-color:#031B3A}.modal-order .modal-order-dialog>div:first-child{position:absolute;top:56px;z-index:2;left:0;background-color:#fff!important}.modal-order .modal-order-dialog>div:first-child>div:hover{color:#fff!important}.modal-order .modal-order-dialog>div:first-child>div{border-bottom:solid 1px #d5d5d5;color:#B3B3B3!important}.modal-order .modal-order-dialog>div:nth-child(2) div{z-index:3;position:absolute!important;top:103px;background-color:#e3007e!important;height:3px!important;margin-top:-3px!important}.modal-order ::-webkit-scrollbar{-webkit-appearance:none;width:7px;border-radius:4px;background-color:rgba(0,0,0,.5);-webkit-box-shadow:0 0 1px rgba(255,255,255,.5)}.modal-order .modal-order-task-container{background-color:#fff}.modal-order .modal-order-task-container .modal-order-task-list-item{list-style-type:none;line-height:20px;border-bottom:solid 2px #777;background-color:#fff}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe{position:relative;cursor:pointer}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.toggle-icon{right:-37px}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-body{top:25px}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-body.is-expanded,.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-expanded{color:#00bcd4}.modal-order .modal-order-task-container .modal-order-task-list-item-date{padding-top:22px;line-height:55px;height:65px;text-align:left;padding-left:0}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask{opacity:1!important}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask>div{width:110%!important}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask input{color:#000!important}.modal-order .modal-order-task-container .modal-order-task-list-item-label>div,.modal-order .modal-order-task-container .modal-order-task-list-item-description>div{width:auto!important}.modal-order .modal-order-task-container .modal-order-task-list-item-delete{margin-top:40px;cursor:pointer;color:gray}@media (max-width:767px){.modal-order .modal-order-task-container .modal-order-task-list-item-delete{margin-right:-10px}}.modal-order .modal-order-task-container .modal-order-task-list-item-delete:hover{margin-top:40px;cursor:pointer;color:#ababab}", ""]);

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}@media (max-width:767px){.modal-order-container{padding:25px 250px 25px 25px}}.modal-order-container .bp-drop-down .bp-textfield__input{color:initial}.modal-order-container .state-order-icon{width:120px;margin:0;text-align:center;padding:17px 35px 10px 10px;top:14px;position:relative;line-height:28px;height:50px;background:#f0f1f2;cursor:pointer!important;box-shadow:3px 3px 3px rgba(128,128,128,.69);transition:all .5s}.modal-order-container .state-order-icon.is-closed{background:#fcca2e;box-shadow:3px 3px 3px rgba(128,128,128,.69);transition:all 1s}.modal-order-container .state-order-icon.is-closed:hover,.modal-order-container .state-order-icon:hover{box-shadow:1px 1px 3px rgba(128,128,128,.69)}.modal-order-container .state-order-icon__icon{position:absolute!important;top:12px;right:-40px;padding:0}.modal-order-container .state-order-icon__label{padding:0;position:relative!important;top:-17px;line-height:50px}", ""]);

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.dashboard-modal-task-collapsible-content:before{position:relative;left:-35px;color:#777;font-size:20px}.dashboard-modal-task-collapsible-content__list-header{padding-top:12px;padding-bottom:5px;padding-left:20px;margin-left:0;margin-right:0;position:relative}.dashboard-modal-task-collapsible-content__input,.dashboard-modal-task-collapsible-content__note{display:inline-block;padding:0 11px}.dashboard-modal-task-collapsible-content__input>div>div,.dashboard-modal-task-collapsible-content__note>div>div{line-height:15px!important;font-size:15px}.dashboard-modal-task-collapsible-content__input{max-width:130px!important}.dashboard-modal-task-collapsible-content__input label{min-width:120px}.dashboard-modal-task-collapsible-content__input .bp-textfield{width:auto;padding-top:0;margin-top:0}.dashboard-modal-task-collapsible-content__input input{width:60px!important;font-size:14px!important}.dashboard-modal-task-collapsible-content__input-product-confirm label{padding-left:10px}.dashboard-modal-task-collapsible-content__input-product-confirm.is-restricted{margin-top:-15px!important;padding:10px 10px 5px 0;border-radius:5px;font-size:10px;left:-4%;width:initial;background-color:#fcca2e;text-align:left}.dashboard-modal-task-collapsible-content__input-product-name span{width:300px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.dashboard-modal-task-collapsible-content__input-more-detail{position:absolute;right:5%;top:0}.dashboard-modal-task-collapsible-content__input-end-hour input{top:4px}.dashboard-modal-task-collapsible-content__input-product-cost label{margin-top:-5px}.dashboard-modal-task-collapsible-content__input-product-cost div{border:none!important}.dashboard-modal-task-collapsible-content__input-product-cost input{height:53px!important;top:9px;width:107px!important}.dashboard-modal-task-collapsible-content__input-amount--small input{width:60px!important;font-size:14px!important}.dashboard-modal-task-collapsible-content__is-disabled-confirmed-product{background-color:#fcca2e!important;margin-bottom:10px!important;padding:10px;border-radius:5px;font-size:10px;text-align:left;position:relative;top:10px}.dashboard-modal-task-collapsible-content__time{display:inline-block;line-height:25px;min-width:105px;padding-top:20px;margin-top:5px}.dashboard-modal-task-collapsible-content__time>div>div>div{line-height:15px!important;font-size:15px}.dashboard-modal-task-collapsible-content__label{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;position:relative;display:inline-block;top:26px;left:-30px;font-size:14px;font-weight:400;font-family:Roboto,sans-serif;color:#777}.dashboard-modal-task-collapsible-content__label-product-name{min-width:150px;color:#77777c;border-radius:5px;padding:5px 5px 5px 10px;left:45px;margin-right:50px;top:17px}.dashboard-modal-task-collapsible-content__label-product-name.is-expanded{background-color:#d5d5d5}.dashboard-modal-task-collapsible-content__label-end-hour{position:absolute;left:-50px}.dashboard-modal-task-collapsible-content__label-amount-small{position:relative;padding:3px 10px 3px 35px;margin-right:-15px;border-radius:5px;line-height:25px;background-color:#d5d5d5;color:#77777c}.dashboard-modal-task-collapsible-content__label-amount-small .icon-operation{position:absolute;top:5px;left:7px}.dashboard-modal-task-collapsible-content__label-amount-small .icon-operation .material-icons{font-size:20px}.dashboard-modal-task-collapsible-content__separator{position:absolute;width:315px;left:32px;top:83px;border-bottom:solid 2px #00bcd4}.dashboard-modal-task-collapsible-content__note{font-size:15px}.dashboard-modal-task-collapsible-content__note i{position:relative;top:-35px!important;right:-80%;cursor:pointer;color:#777}.dashboard-modal-task-collapsible-content__note .bp-textfield{width:auto;padding-top:0;margin-top:0}.dashboard-modal-task-collapsible-content__list{padding:15px 0;background-color:#f0f1f2;border-top:solid 2px #00bcd4}.dashboard-modal-task-collapsible-content__list h2{margin-bottom:25px;padding-left:30px;font-size:25px;font-weight:300}.dashboard-modal-task-collapsible-content .where-items-was-subtracted{flex-direction:column;max-width:250px;margin-left:-23px;margin-top:-7px;margin-bottom:20px}.dashboard-modal-item-amount__list ul{background-color:rgba(221,221,221,.58);padding-top:15px;padding-bottom:15px}", ""]);

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.dashboard-modal-item-small{margin-bottom:25px;padding-right:10%}.dashboard-modal-item-small__toggle-edit{position:relative;top:-13px}.dashboard-modal-item-small__toggle-edit .material-icons{border-radius:50%;border:solid 2px;font-size:13px!important;padding:3px}.dashboard-modal-item-small__toggle-edit .material-icons.is-edit-mode{background-color:#fcca2e}.dashboard-modal-item-small__item{display:flex;justify-content:flex-end;flex-direction:row;margin-bottom:-25px}.dashboard-modal-item-small__item.is-confirmed{margin-bottom:-7px}.dashboard-modal-item-small__item-label{flex-basis:350px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dashboard-modal-item-small__item-input{padding-left:10px;max-width:97px}.dashboard-modal-item-small__item-input hr{border-bottom:solid 1px #7d7a7a!important}.dashboard-modal-item-small__item-input-small{display:flex;min-width:250px;margin:-15px;position:relative}.dashboard-modal-item-small__item-input-small.is-error{margin-bottom:30px!important;min-width:300px}.dashboard-modal-item-small__item-input-small .amount-name>hr{border-bottom:solid 1px #000!important;max-width:60px}.dashboard-modal-item-small__item-input-small .location-name{align-self:flex-end;padding-bottom:13px;padding-right:10px;white-space:nowrap;font-size:13px;font-weight:400}.dashboard-modal-item-small .where-items-was-subtracted{flex-direction:column;margin-right:5px}.dashboard-modal-item-small .where-items-was-subtracted.is-all-item-missing .is-item-missing{margin-top:23px;color:red}.dashboard-modal-item-small .where-items-was-subtracted.is-some-item-purchase.is-without-stock,.dashboard-modal-item-small .where-items-was-subtracted .is-single-item{margin-top:23px}.dashboard-modal-item-small .where-items-was-subtracted .is-item-missing{color:red}", ""]);

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-header .app-bar{padding:-5px 20px;z-index:12!important;background-color:#031B3A!important}.bp-header .app-bar .right-option-menu{left:-10px;top:-5px}.bp-header .app-bar .right-option-menu:hover{color:gray!important}.bp-header .app-bar.is-login{height:50px;background:url(/assets/images/logo-white.png) 50px 11px no-repeat;background-size:140px;background-position-y:15px;background-position-x:65px}@-moz-document url-prefix(){.bp-header .app-bar.is-login{background-position:65px 15px}}.bp-header .app-bar button span{left:0;top:-3px}.bp-header .app-bar svg path{fill:#fcca2e}.bp-header .app-bar .subscribe-message{display:flex;color:#fff;justify-content:center;align-items:center;width:20vw;margin-left:20px}.bp-header .app-bar .subscribe-message a{color:#fcca2e}.bp-header .right-menu{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bp-header .right-menu .avatar-applicant{margin-left:10px;margin-right:10px}", ""]);

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-header__app-bar{position:fixed;top:0;left:0;backgroundColor:#101112!important;z-index:9!important}.bp-header__app-bar-logo{height:35px;left:63px;top:34px;position:fixed}@media (min-width:1141px){.bp-header__app-bar-logo{height:32px;top:34px}}@media (max-width:1140px) and (min-width:992px){.bp-header__app-bar-logo{top:40px;height:20px}}@media (max-width:991px) and (min-width:691px){.bp-header__app-bar-logo{top:22px;height:20px}}@media (max-width:690px) and (min-width:649px){.bp-header__app-bar-logo{top:25px;height:13px}}@media (max-width:648px){.bp-header__app-bar-logo{display:none}}@media (min-width:768px){.bp-header__app-bar.is-login{background:url(\"/assets/images/logo-white_106x35.png\") 50px 11px no-repeat;background-size:130px;background-position-y:2px;background-position-x:60px}@-moz-document url-prefix(){.bp-header__app-bar.is-login{background-position:60px 2px}}}@media (min-width:992px){.bp-header__app-bar.is-login{background:url(\"/assets/images/logo-white_106x35.png\") 63px 11px no-repeat;background-size:170px;background-position-y:-5px;background-position-x:60px}@-moz-document url-prefix(){.bp-header__app-bar.is-login{background-position:50px -5px}}}@media (min-width:992px){.bp-header__app-bar{height:100px}}@media (min-width:768px) and (max-width:991px){.bp-header__app-bar{height:70px}}@media (max-width:767px){.bp-header__app-bar{height:50px}}@media (max-width:767px){.bp-header__app-bar{background:0 0}}.bp-header .bp-carousel{position:absolute!important;left:calc(50vw - 26.6em)!important}@media (max-width:991px) and (min-width:768px){.bp-header .bp-carousel{font-size:9px;top:3px}}@media (max-width:767px) and (min-width:600px){.bp-header .bp-carousel{font-size:8px;top:3px}}@media (max-width:600px) and (min-width:570px){.bp-header .bp-carousel{font-size:8px;top:3px}}@media (max-width:569px) and (min-width:510px){.bp-header .bp-carousel{font-size:7px;top:7px}}@media (max-width:509px) and (min-width:460px){.bp-header .bp-carousel{font-size:6px;top:10px}}@media (max-width:459px) and (min-width:420px){.bp-header .bp-carousel{font-size:5px;top:14px}}@media (max-width:419px) and (min-width:380px){.bp-header .bp-carousel{font-size:4px;top:17px}}@media (max-width:379px){.bp-header .bp-carousel{font-size:3px;top:18px}}@media (min-width:992px){.bp-header.app-bar{height:100px}}@media (min-width:768px) and (max-width:991px){.bp-header.app-bar{height:70px}}@media (max-width:767px){.bp-header.app-bar{height:50px}}.bp-header.app-bar button{top:18px;cursor:pointer;left:3px}@media (min-width:992px){.bp-header.app-bar button{top:18px}}@media (min-width:768px) and (max-width:991px){.bp-header.app-bar button{top:2px}}@media (max-width:767px){.bp-header.app-bar button{top:0}}", ""]);

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.dashboard-modal-content.bp-custom-modal__content.bp-setting-modal h3{background-color:#031B3A!important;color:#fff!important;padding-bottom:40px!important}.dashboard-modal-content.bp-custom-modal__content.bp-setting-modal h3~div,.bp-custom-modal__content.bp-setting-modal-tab.bp-setting-modal-tab-general{background-color:#fff}.bp-custom-modal__content.bp-setting-modal-tab.bp-setting-modal-tab-general svg path{fill:#5c5e5d!important}", ""]);

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-setting-modal-tab-general__field{background-color:#fff}.bp-setting-modal-tab-general__field.logo-row{margin:20px 0}.bp-setting-modal-tab-general__field .logo-img{height:100px;border-radius:50%;width:100px;border:solid 2px #fff;box-shadow:0 2px 10px 2px lightgrey;margin:0}.bp-setting-modal-tab-general__field.toggle-option{width:270px}", ""]);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.inventory-report{padding:20px;background-color:#fff;position:fixed;opacity:0;transition:all .5s ease-out;left:0;top:120vh;z-index:10;font-weight:500;box-shadow:0 -5px 20px 0 grey;right:40%;overflow:auto}@media (max-width:767px){.inventory-report{opacity:1}}.inventory-report .filter-report{top:32px;left:25px}@media (max-width:767px){.inventory-report .filter-report{top:-15px;left:0}}.inventory-report.is-active{opacity:.9;top:40vh;height:60vh;transition:all .5s ease-out}@media (max-width:767px){.inventory-report.is-active{right:0;top:60px;height:100vh;overflow:auto}}.inventory-report__header{display:flex;justify-content:flex-start;flex-direction:row;border-bottom:solid 1px lightgray}@media (max-width:767px){.inventory-report__header{flex-direction:column}}.inventory-report__header .btn-close{transform:scale(.8);position:absolute;right:25px}@media (max-width:767px){.inventory-report__header .btn-close{right:15px}}.inventory-report__header h3{margin-bottom:25px}.inventory-report__header h4{margin:15px 0;font-weight:400}.inventory-report__content{padding:10px 0}.inventory-report__content td.mui-table-row-column{text-overflow:initial!important}.inventory-report__footer{background-color:tomato}", ""]);

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-tabs{position:relative;display:flex;flex-direction:column}.bp-tabs__loading{position:absolute;top:10vh;left:0;right:0;bottom:0;z-index:5;display:flex;align-items:flex-start;justify-content:center;padding-top:50px;font-size:20px}.bp-tabs__header{display:flex;justify-content:flex-start;align-items:flex-end;border-bottom:solid 2px #e1e2e3;overflow-x:auto}.bp-tabs__header .bp-tab-header{padding:20px}.bp-tabs__header .bp-tab-header:hover{cursor:pointer;opacity:.7}.bp-tabs__header .bp-tab-header.is-active{border-bottom:solid 3px green;background-color:#e2e3e4}.bp-tabs__header--edit-mode,.bp-tabs__header--new-list{display:flex;padding:10px}.bp-tab{display:none}.bp-tab.is-active{display:block}.bp-tab.is-edit-mode{opacity:.5}", ""]);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.tasks{position:fixed;display:flex;flex-direction:column;bottom:0;left:0;right:20%;z-index:10;box-shadow:0 -5px 20px 0 grey;font-size:16px;padding:1.2em;background:#fff;top:40vh;opacity:.9;transition:all .5s ease-out}.tasks.is-hidden{top:120vh;opacity:0}@media (max-width:767px){.tasks{top:65px;right:0;height:auto;opacity:1}}.tasks__header{padding:1em 0;display:flex;justify-content:space-between}@media (max-width:767px){.tasks__header-date-picker{margin-top:-20px}}.tasks__header-date-label{margin-top:10px}.tasks__header-date-value{position:relative}.tasks__header-date-icon{position:absolute;top:0;right:0;z-index:-1}.tasks__header-close{transform:scale(.7);position:absolute;right:15px;top:15px}.tasks__container{display:flex;flex-grow:1;flex-direction:column;position:relative;overflow:auto}.tasks__footer{position:absolute;bottom:30px;right:30px}@media (max-width:767px){.tasks__footer{bottom:90px}}.tasks__new-tab{padding-top:20px}.task-list{list-style:none;margin:0;padding-inline-start:0}.task-item{display:flex;padding:1em 0;margin:0;position:relative}@media (max-width:767px){.task-item{position:relative;padding:0 1em 2.5em 0}}.task-item__message{display:flex;align-items:flex-start;margin-top:18px;flex-grow:1;max-width:800px}.task-item__message-inline-error{color:#f44336;font-size:12px;line-height:12px}.task-item__message-input{padding-left:18px;margin-top:-18px;width:100%}.task-item__message-input textarea{width:100%}@media (max-width:767px){.task-item__message-input{padding-left:0;margin-left:7px}}.task-item__message-input>div{width:100%!important}.task-item__label{align-self:center;padding-left:1em}.task-item__toggle{align-self:flex-start;margin-top:40px}.task-item__actions{display:flex;align-self:flex-end}@media (max-width:767px){.task-item__actions{position:absolute;bottom:0;left:0}}.task-item__actions-remove{right:0}@media (max-width:767px){.task-item__actions-save{left:-10px;bottom:-3px}}@media (max-width:767px){.task-item__actions-save button{left:0;top:0}}@media (max-width:767px){.task-item__actions-clear{left:-5px;bottom:-3px}}@media (max-width:767px){.task-item__actions-clear button{top:0;left:37px}}.task-item__actions-remove{position:relative;bottom:-10px}@media (max-width:767px){.task-item__actions-remove{position:absolute;right:0;bottom:0}}.task-item__users{align-self:flex-start;margin:0}@media (max-width:767px){.task-item__users{width:80px!important}}.task-item__users>div{max-width:110px}@media (max-width:767px){.task-item__users>div{width:80px!important}}@media (max-width:767px){.task-item__users div{width:89px!important}}", ""]);

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}", ""]);

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.custom-notification{min-height:50px}.custom-notification__icon{display:inline-block;position:absolute;top:0;bottom:0;width:40px;border-top-left-radius:2px;border-bottom-left-radius:2px;background-size:40px;background-repeat:no-repeat;background-position:center;vertical-align:middle;border-color:transparent}.custom-notification__icon--info{background-image:url(\"/assets/images/icon-info.svg\"),linear-gradient(to bottom left,#0288d1,#fff)}.custom-notification__icon--success{background-image:url(\"/assets/images/icon-success.svg\"),linear-gradient(to bottom left,#0f9d58,#fff)}.custom-notification__icon--error{background-image:url(\"/assets/images/icon-error.svg\"),linear-gradient(to bottom left,#db4437,#fff)}.custom-notification__icon--warning{background-image:url(\"/assets/images/icon-warn.svg\"),linear-gradient(to bottom left,#fcca2e,#fff)}.custom-notification__content{display:inline-block;margin-bottom:10px;margin-left:40px;padding:12px 15px 0;vertical-align:middle}.notifications-tr{top:130px!important}.notification{opacity:.8!important;border:none!important}.notification-dismiss{background-color:transparent!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.chronologyc-bar-inner-content{position:relative}.packaging-bar{right:0;border-left:solid 1px #031B3A}.packaging-bar .comment-day hr{z-index:1}.packaging-bar.is-close .chronologyc-row.row{float:right}.packaging-bar .chronologyc-row{border-right:solid 1px rgba(135,136,137,.54)}.packaging-bar .chronologyc-row.row{float:left}.packaging-bar .chronologyc-row:before{left:70px;box-shadow:none;z-index:-1}.brewing-bar{left:0;border-right:solid 1px #031B3A}.brewing-bar .chronologyc-row{border-left:solid 1px rgba(135,136,137,.54)}.brewing-bar .chronologyc-row.row{float:right}.brewing-bar .chronologyc-row.row:before{position:absolute;bottom:10%;border-left:5276px solid transparent;height:1px;width:303px;left:-1000px;top:-2px}.brewing-bar .chronologyc-row.row.is-white-row:before{height:35px;z-index:-1;background-color:#ebeced}.brewing-bar .chronologyc-row.row.is-dark-row:before{height:35px;z-index:-1;background-color:#f5f6f7}.brewing-bar .chronologyc-row.row.is-saturday:before{z-index:-1;height:35px;background-color:#d9e6ec}.brewing-bar .chronologyc-row.row.is-sunday:before{z-index:-1;height:35px;background-color:#c5d9e3}.brewing-bar .chronologyc-row.row.is-highlight:before{left:-1000px;height:35px;background-color:#fcca2e}.brewing-bar .chronologyc-row.row.is-selected:before{left:-1000px;background:rgba(252,202,46,.41);height:37px;box-shadow:11px 0 0 grey}.brewing-bar .chronologyc-row.row.is-month-starting .dateNumber:before{content:attr(data-month-name);position:absolute;top:0;left:73px;font-size:15px;font-weight:700;color:#389fe2;display:inline-block}.brewing-bar .chronologyc-row.row.is-month-starting:before{padding:2px 2px 2px 4px;border:solid 2px #000!important;border-bottom:none!important;height:35px;width:5000px;content:attr(data-month-name);color:#292929;font-size:20px}.comment-day{margin:0;top:0;font-size:12px}.comment-day input:focus{background-color:#fdf2c1!important}.comment-day .material-icons{font-size:38px}.comment-day input{font-size:14px!important;font-style:normal;padding:5px!important}.comment-day div{border-bottom:none!important}.comment-day hr{bottom:0!important;border-color:transparent;display:none}.comment-day hr:last-child{display:block;border-bottom:solid 2px #fcca2e!important}.comment-day>div{bottom:23px!important;top:35px!important}.comment-day>input{overflow:hidden;text-overflow:ellipsis;padding-right:90px!important}.chronologyc-bar{position:absolute;margin-top:10px;width:inherit;line-height:32px;vertical-align:inherit;white-space:nowrap;font-size:13px;font-family:sans-serif}.chronologyc-bar .chronologyc-bar-button{top:64px!important;background-color:#031B3A!important;padding:25px 22px!important;box-shadow:0 3px 3px gray!important}.chronologyc-bar .chronologyc-bar-button .material-icons{color:#fcca2e!important;font-size:25px}.chronologyc-bar .chronologyc-bar-button i{top:-13px!important}.chronologyc-bar .chronologyc-bar-button.is-open i{top:-17px!important;right:6px;font-size:40px!important}.chronologyc-bar .chronologyc-bar-button.is-open .material-icons{font-size:33px}.chronologyc-bar .chronologyc-bar-button.is-open.is-brewing-bar{left:calc(30% - 70px)}@-moz-document url-prefix(){.chronologyc-bar{top:inherit}}.chronologyc-bar>div{min-width:70px!important}.chronologyc-bar div>button{height:50px!important;background-color:#031B3A!important}.chronologyc-bar div>button span{color:#fcca2e!important}.chronologyc-bar.is-close{top:90px}.chronologyc-bar.is-close div>button{width:70px!important}.chronologyc-bar.is-close div>button div>div>span{padding:0!important}.chronologyc-bar .chronologyc-row{clear:both;margin:1px 0 0;position:relative;top:0;width:70px;height:34px;color:#477778;cursor:pointer}.chronologyc-bar .chronologyc-row .dateName{padding-left:15px;color:#777;font-weight:300}.chronologyc-bar .chronologyc-row .dateNumber{padding-right:15px;color:#031B3A;font-weight:700}.chronologyc-bar .chronologyc-row.is-sunday .dateName{color:#60abdd!important}.chronologyc-bar .chronologyc-row.is-sunday .dateNumber{color:#3a86b2!important}.chronologyc-bar .chronologyc-row.is-saturday .dateName{color:#60abdd!important}.chronologyc-bar .chronologyc-row.is-saturday .dateNumber{color:#3a86b2!important}.is-month-light{color:#477778!important}.is-brewing-note-open{margin-left:30%}.is-brewing-note-close{margin-left:70px}.is-packaging-note-open{margin-right:30%}.is-packaging-note-close{margin-right:70px}.chronologyc-row-data-date.is-packaging-bar-only-open .comment-day{height:39px!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.modal-order-container{background-color:#fff}@media (min-width:769px){.modal-order .dashboard-modal-content{max-width:none!important;width:900px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content{width:auto!important;margin:initial!important;overflow:inherit;height:900px!important;top:0}}@media (max-width:768px){.modal-order .dashboard-modal-content>div{width:inherit}}@media (min-width:769px){.modal-order .dashboard-modal-content>div{min-width:580px;width:auto}}.modal-order .dashboard-modal-content__label-batch-number{width:125px;top:-23px;position:relative;float:left;margin-right:5px;margin-left:20px}@media (max-width:768px){.modal-order .dashboard-modal-content__label-batch-number{top:-20px;position:relative;height:78px;margin:40px 0 7px;width:90%}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-cancel{margin:10px 0!important;padding:5px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-save{margin:10px 0!important;padding:5px!important}}@media (max-width:768px){.modal-order .dashboard-modal-content__button-remove{margin:10px 0!important;padding:5px!important}}.modal-order .dashboard-modal-content>div>div:nth-child(3){min-height:94px;padding-top:24px!important;border-top:solid 1px #d5d5d5;background-color:#f0f1f2;position:sticky;bottom:65px}@media (max-width:768px){.modal-order .dashboard-modal-content>div>div:nth-child(3){padding:15px;display:flex;flex-direction:column}}.modal-order .dashboard-modal-content>div>div:nth-child(3) button{background-color:#f0f1f2;margin-left:10px!important}.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){margin-top:25px!important;max-height:420px!important;height:420px!important}@media (max-height:740px) and (min-width:760px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:5rem!important}}@media (max-height:625px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:10rem!important}}@media (max-height:575px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:15rem!important}}@media (max-height:525px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:20rem!important}}@media (max-height:500px){.modal-order .dashboard-modal-content:not(.inventory-transfer-modal)>div>div:nth-child(2){padding-bottom:25rem!important}}.modal-order .inventory-transfer-modal>div>div:nth-child(2){margin-top:25px!important}.modal-order .dashboard-modal-content h3{background-color:#031B3A;line-height:34px!important;color:#fff!important;font-weight:400!important}@media (max-width:768px){.modal-order .modal-order-container.fluid-container{padding-left:0;padding-top:0;margin-top:0}}.modal-order .modal-order-dialog>div{min-width:580px}.modal-order .modal-order-dialog>div>div{background-color:#031B3A}.modal-order .modal-order-dialog>div:first-child{position:absolute;top:56px;z-index:2;left:0;background-color:#fff!important}.modal-order .modal-order-dialog>div:first-child>div:hover{color:#fff!important}.modal-order .modal-order-dialog>div:first-child>div{border-bottom:solid 1px #d5d5d5;color:#B3B3B3!important}.modal-order .modal-order-dialog>div:nth-child(2) div{z-index:3;position:absolute!important;top:103px;background-color:#e3007e!important;height:3px!important;margin-top:-3px!important}.modal-order ::-webkit-scrollbar{-webkit-appearance:none;width:7px;border-radius:4px;background-color:rgba(0,0,0,.5);-webkit-box-shadow:0 0 1px rgba(255,255,255,.5)}.modal-order .modal-order-task-container{background-color:#fff}.modal-order .modal-order-task-container .modal-order-task-list-item{list-style-type:none;line-height:20px;border-bottom:solid 2px #777;background-color:#fff}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe{position:relative;cursor:pointer}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.toggle-icon{right:-37px}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-body{top:25px}.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-body.is-expanded,.modal-order .modal-order-task-container .modal-order-task-list-item__receipe.is-expanded{color:#00bcd4}.modal-order .modal-order-task-container .modal-order-task-list-item-date{padding-top:22px;line-height:55px;height:65px;text-align:left;padding-left:0}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask{opacity:1!important}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask>div{width:110%!important}.modal-order .modal-order-task-container .modal-order-task-list-item-typetask input{color:#000!important}.modal-order .modal-order-task-container .modal-order-task-list-item-label>div,.modal-order .modal-order-task-container .modal-order-task-list-item-description>div{width:auto!important}.modal-order .modal-order-task-container .modal-order-task-list-item-delete{margin-top:40px;cursor:pointer;color:gray}@media (max-width:767px){.modal-order .modal-order-task-container .modal-order-task-list-item-delete{margin-right:-10px}}.modal-order .modal-order-task-container .modal-order-task-list-item-delete:hover{margin-top:40px;cursor:pointer;color:#ababab}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.chronologyc-button-header{position:fixed;width:calc(30% - 69px);height:50px;padding:10px;border-bottom:solid 3px #e3007e;margin-top:-10px;z-index:1;cursor:pointer;top:74px;background-color:#031B3A;color:#FEFFFF;box-shadow:0 3px 3px gray!important}.chronologyc-button-header:hover{border-color:#911C81}.chronologyc-button-header.is-packaging{right:-1px}.chronologyc-button-header .chronologyc-button-header-icon{top:10px;opacity:.4;filter:alpha(opacity=40)}.chronologyc-button-header .chronologyc-button-header-title{position:relative;top:-6px;left:10px}.form-group-button{height:32px;padding:9px 15px;margin:5px 5px 5px 10px;border:none;border-radius:2px;cursor:pointer;font-weight:400;font-size:10px}.form-group-button.form-group-button-primary{background-color:#00bcd4;color:#fff}.form-group-button.form-group-button-primary:hover{background-color:#008da1}.form-group-button.form-group-button-secondary{color:#fff;background-color:#777!important}.form-group-button.form-group-button-secondary:hover{color:#d5d5d5;background-color:#5c5e5d!important}.form-group-button.form-group-button-icon{color:#fff;position:relative;padding-left:30px;white-space:nowrap}.form-group-button.form-group-button-icon--delete{background-color:#FF6347}.form-group-button.form-group-button-icon--delete:hover{background-color:#C04F36!important}.form-group-button.form-group-button-icon--delete i{color:#fff!important}.form-group-button.form-group-button-icon.primary-icon{background-color:#00bcd4}.form-group-button.form-group-button-icon.primary-icon:hover{background-color:#008da1}.form-group-button.form-group-button-icon.primary-icon i{color:#fff}.form-group-button.form-group-button-icon.secondary-icon{background-color:#777}.form-group-button.form-group-button-icon.secondary-icon:hover{background-color:#5c5e5d}.form-group-button.form-group-button-icon.secondary-icon i{color:#fff}.form-group-button.form-group-button-icon i{position:absolute;top:5px;left:5px;font-size:20px;color:#fcca2e}.form-group-button.form-group-button-icon:hover{color:#d5d5d5!important}.additional-button .form-group-button{background-color:#777!important}.additional-button .form-group-button:hover{background-color:#5c5e5d!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.form-group-dropdown{margin-bottom:5px;min-width:190px}.form-group-dropdown.is-active hr{border-bottom:solid 2px #00bcd4!important}.form-group-dropdown .form-group-dropdown-input div>div{overflow:hidden;margin-right:10px!important;padding:0 10px!important}.form-group.form-group-dropdown.is-disabled hr,.form-group.form-group-dropdown.is-disabled>div>div svg path{display:none!important}.form-group-textfield{margin-top:-24px}.form-group-textfield .form-group-textfield-input label{white-space:nowrap}.form-group-textfield .form-group-textfield-input input{color:#fff!important;font-weight:300!important}.form-group-textfield .form-group-textfield-input div{width:inherit;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.form-group.form-group-textfield.is-disabled.is-dark>div>div{display:none}.form-group-color-picker{height:40px;margin:11px 5px;border-radius:2px;font-weight:400;font-size:10px;cursor:pointer}.form-group-color-picker-label{font-weight:400;font-size:10px;margin-left:5px}.basic-form-container{background-color:#031B3A;color:#fff;padding-bottom:23px;padding-top:23px}.basic-form-container input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px transparent inset}@media (min-width:1200px){.basic-form-container{min-height:163px}}.basic-form-container .basic-form-breadcrumb{margin:9px 0 0 9px}.basic-form-container .basic-form-header{line-height:20px}.basic-form-container .basic-form-header h1{margin:0 0 15px -5px;padding-top:10px;font-size:30px;font-weight:300!important;letter-spacing:2px}.basic-form-container .basic-form-buttons{clear:both}.basic-form-container .basic-form-fields{font-weight:300!important;clear:both}@media (max-width:767px){.basic-form-container .basic-form-fields{max-width:208px}}.basic-form-container .basic-form-fields .form-group{float:left;margin-left:10px;width:200px}@media (max-width:767px){.basic-form-container .basic-form-fields .form-group{width:calc(100vw - 50px)}}.basic-form-container .basic-form-content{padding:7px 1px;margin-top:7px;font-weight:300!important}@media (max-width:767px){.basic-form-container .basic-form-content{clear:both;margin-top:-10px}}@media (max-width:767px){.basic-form-container .basic-form-content:not(.additional-button){margin-top:10px;display:flex;justify-content:flex-end;width:99%}}@media (max-width:767px){.basic-form-container .basic-form-content.additional-button .form-group-button{width:calc(100vw - 50px);display:block}}.basic-form-container .basic-form-content-additional-actions{line-height:47px}.light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.admin-scaffolding-table{float:left}.admin-scaffolding-table__loading{position:fixed;bottom:50%}.admin-scaffolding-table__pagination{position:fixed;left:50%;transform:translateX(-50%);bottom:20px}.admin-scaffolding-table .admin-table .admin-table-header th{color:#fff!important;font-size:15px!important;font-weight:300!important;padding-left:25px!important}.admin-scaffolding-table .admin-table .admin-table-header th svg{display:none!important}.admin-scaffolding-table .admin-table .admin-table-header th:not(.header-tank-column){display:none}.admin-scaffolding-table .admin-table .admin-table-header__icon{position:absolute!important;right:20px;bottom:30px;font-size:21px!important}.admin-scaffolding-table .admin-table .admin-table-header__icon.is-active{color:#fff}@media (max-width:767px){.admin-scaffolding-table .admin-table .admin-table-header__icon{display:none!important}}.admin-scaffolding-table .admin-table .admin-table-header tr{background-color:#777}.admin-scaffolding-table .admin-table .admin-table-header__filter{color:#fff!important;font-weight:300;position:absolute;top:-10px;overflow:auto;width:100%!important}.admin-scaffolding-table .admin-table .admin-table-header__filter.is-active{color:#fcca2e!important;font-weight:700}.admin-scaffolding-table .admin-table .admin-table-header__filter.is-active input,.admin-scaffolding-table .admin-table .admin-table-header__filter.is-active label{font-weight:700}.admin-scaffolding-table .admin-table .admin-table-header__filter.is-active hr{border:1px solid #fcca2e!important}.admin-scaffolding-table .admin-table .admin-table-header__filter input{color:#fff!important;font-weight:400!important}.admin-scaffolding-table .admin-table .admin-table-header__filter label{color:#fff!important;font-weight:300}.admin-scaffolding-table .admin-table .admin-table-body tr:nth-child(odd){background-color:#ebeced}.admin-scaffolding-table .admin-table .admin-table-body tr{font-weight:300;line-height:20px!important;background-color:#f5f6f7}.admin-scaffolding-table .admin-table .admin-table-body tr svg{fill:#031B3A!important}.admin-scaffolding-table .admin-table .admin-table-row{border:none!important}.admin-scaffolding-table .admin-table .admin-table-row .bp-stamp__icon.bp-stamp__icon-non-text{height:inherit;padding:4px 1px;width:inherit;text-align:center}.admin-scaffolding-table .admin-table .admin-table-row.is-selected td{background-color:#fcca2e!important}.admin-scaffolding-table .admin-table .admin-table-row .mui-table-row-column{padding-right:47px!important;position:relative;text-overflow:initial!important}", ""]);

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}", ""]);

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.app-main__side-bar-item{transition:all .2s}.app-main__side-bar-item:hover{border-left:3px solid #0288d1;background-color:#B3B3B3;font-weight:500}.app-main__side-bar-item .is-disable{color:rgba(128,128,128,.56)!important}.app-bar{padding:-5px 20px;z-index:12!important}.app-bar .app-bar-main-banner{display:none}.app-bar.is-login .app-bar-main-banner{display:inline;position:absolute;background:#fff}@media (max-width:767px){.app-bar.is-login .app-bar-main-banner{height:35px;left:calc(20% - 20px);top:7px;width:calc(100vw - 35%)}}@media (min-width:768px){.app-bar.is-login .app-bar-main-banner{height:60px;left:30%;top:-5px}}@media (min-width:992px){.app-bar.is-login .app-bar-main-banner{height:80px;top:-15px;left:30%}}@media (min-width:1200px){.app-bar.is-login .app-bar-main-banner{top:-20px;height:90px;left:30%}}.app-bar button span{left:0}.app-bar svg path{fill:#fcca2e}.nav-bar-header{height:154px;background-color:#fff;padding:23px;text-align:center;margin-bottom:20px;margin-top:60px}.nav-bar-header.is-free-version{margin-top:0;margin-bottom:10px}.nav-bar-header img{height:60px;margin-left:-15px}.app_main__side-bar div:nth-child(2){background-color:#ff0}.grid-item-content{overflow:hidden}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}.admin-scaffolding-content{overflow:auto;position:relative}", ""]);

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "", ""]);

/***/ },
/* 282 */
281,
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".about-page-container{background-color:#fff}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.preactivated-page-container{background-color:#fff}.preactivated-page-container__header{font-size:40px;padding-bottom:10px}.preactivated-page-container__body{font-size:20px}.preactivated-page-container__footer{padding-top:30px;text-align:left}.preactivated-page-container__footer-signature{font-size:19px!important;color:#777}@media (max-width:767px){.preactivated-page-container__footer-signature{font-size:15px!important}}.preactivated-page-container__mail-support{color:#777;font-size:15px!important;padding-top:15px}@media (max-width:767px){.preactivated-page-container__mail-support{font-size:13px!important}}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.welcome-page-container{background-color:#fff;line-height:10px}.welcome-page-container__header{padding-bottom:10px}@media (max-width:767px){.welcome-page-container__header{font-size:45px!important}}@media (max-width:767px){.welcome-page-container__body{font-size:30px!important;line-height:20px!important}}.welcome-page-container__start-button{padding-top:20px}.header-tank-column{font-size:18px!important;font-weight:700}.header-tank{max-width:300px;padding:10px}.header-tank .header-tank-name{margin-bottom:20px}.header-tank .header-tank-btn>div{width:100px}.header-tank .separator-inline{color:transparent}.btn-right-fixed{position:fixed!important;right:10px;bottom:10px;box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),0 1px 0 rgba(255,255,255,.25)inset,0 -1px 0 rgba(0,0,0,.15)inset}.btn-icon-center{position:relative;top:-16px}.full-width{width:100%!important}.bp-login-view{margin-top:50px}.bp-login-view .login-content{position:relative;max-width:320px;top:5vh;margin:0 auto}.bp-login-view .login-content .sign-in__logo{padding-top:50px}.bp-login-view .sign-in__footer{display:flex;justify-content:space-between;padding-top:25px}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.signup-page-container{background-color:#fff;position:relative;max-width:600px;top:5vh;margin:0 auto;padding:0 10vw!important}@media (min-width:992px){.signup-page-container{padding:initial!important}}.signup-page-container .page-header{margin-top:10px;color:#B3B3B3;border-bottom:none}.signup-page-container .form-group.from-group-long-text.how-did-you-hear{margin-left:-25px;margin-right:-25px}.signup-page-container .form-group.from-group-long-text label~div{text-align:left}@media (max-width:767px){.signup-page-container .form-group.from-group-long-text label~div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:300px!important}}@media (min-width:768px){.signup-page-container .form-group.from-group-long-text label~div{width:100%}}@media (min-width:992px){.signup-page-container .form-group.from-group-long-text label~div{width:100%}}.signup-page-container .singup-page-button{margin-bottom:10px}.Page404,.Page500{border:1px dashed red}.light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-support-page{font-size:16px;text-align:center;overflow:hidden}.bp-support-page:not(.is-free-version){margin-top:64px}.bp-support-page__head{overflow-x:hidden;margin:0;padding:2em 5em;background:url(\"/assets/images/bg-beer.jpg\");background:url(\"/assets/images/bg-beer.jpg\"),radial-gradient(ellipse at bottom,orange 0,#002680 80%);background-blend-mode:overlay;background-attachment:fixed;background-position:center;background-repeat:no-repeat;background-size:cover}.bp-support-page__body{padding:5em}.bp-support-page__header-title{color:#fff;font-size:6em;font-weight:200}.bp-support-page__header-title h1{margin:.3em .67em}@media (max-width:767px){.bp-support-page__header-title{font-size:3em}.bp-support-page__header-title h1{margin:.1em .2em}}.bp-support-page__header-subtitle{font-size:1.3em;color:#fff;font-weight:300;max-width:26em;margin:0 auto;position:relative;top:-3em}@media (max-width:767px){.bp-support-page__header-subtitle{font-size:1em;top:0}}.bp-support-page__input{font-weight:100}.bp-support-page__input input{color:#fff;padding:.5em;line-height:1em;font-size:1.5em;width:50%;background:0 0;border-top:none;border-left:none;border-right:none}.bp-support-page__separator{height:2em;margin:2em 10em}.bp-support-page__question-box{height:14em;box-shadow:0 40px 56px -39px rgba(173,168,173,.96);overflow:hidden;text-align:center;border:solid 1px transparent;padding:1em;border-radius:2%;text-decoration:none}.bp-support-page__question-box>.material-icons--custom{height:auto;margin-top:7px;font-size:60px!important;text-align:center;background-size:30px}.bp-support-page__question-box>.material-icons--custom.icon-dashboard-page{background:url(\"/assets/images/dashboard-icon.svg\") no-repeat center}.bp-support-page__question-box>.material-icons--custom.icon-beer-style-page{background:url(\"/assets/images/beer-style-page-icon.svg\") no-repeat center}.bp-support-page__question-box>.material-icons--custom.icon-tanks-page{background:url(\"/assets/images/fermenter-tank-page-icon.svg\") no-repeat center}.bp-support-page__question-box>.material-icons--custom.icon-tanks-sections{background:url(\"/assets/images/brewing-fermenting-packaging.png\") no-repeat center;background-size:34px}.bp-support-page__question-box>.material-icons--custom.icon-help-page{background:url(\"/assets/images/help-page-icon.svg\") no-repeat center;background-size:36px}.bp-support-page__question-box>.material-icons--custom.icon-contact-page{background:url(\"/assets/images/contact-page-icon.svg\") no-repeat center}.bp-support-page__question-box>.material-icons--custom.icon-brewing{background:url(\"/assets/images/brew.svg\") no-repeat center}.bp-support-page__question-box>.material-icons--custom.icon-process{background:url(\"/assets/images/tasks.svg\") no-repeat center;background-size:25px}.bp-support-page__question-box>.icon-bar{width:3em;font-size:50px!important;color:gray!important}.bp-support-page__question-box>.icon-bar:hover{color:#000}.bp-support-page__question-box>.icon-bar.is-disable{color:rgba(128,128,128,.56)!important;cursor:not-allowed}.bp-support-page__question-box h1{font-weight:200;height:2.2em}.bp-support-page__question-box .i>{font-size:30px}.bp-support-page__question-box:hover{cursor:pointer;transition:all .4s;transform:translateY(10px);box-shadow:0 29px 47px -9px rgba(173,168,173,.96);border-radius:2%}.bp-support-page__question-box:active{transform:translateY(15px)}.bp-support-page__comment-title strong{font-weight:300;padding:1em}.bp-support-page__comment-text{font-weight:300;text-align:left;margin:10px;padding:2em 5em}.bp-support-page__comment-text strong{font-weight:400}.bp-support-page__footer{background-color:#f2f2f2;position:relative}.bp-support-page__footer-signature{font-weight:300;text-align:left;padding:1em 5em}.bp-support-page__footer-separator{border-bottom:solid 1px darkgray;margin:0 5em}.bp-support-page__footer-legal{font-weight:300;margin:0 5em;text-align:left;padding:.5em 1em;font-size:13px}.bp-support-page__footer-legal-version{float:right}a.bp-support-page__question-box{text-decoration:none}", ""]);

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-customer-admin__contact{min-width:120px;display:flex;justify-content:flex-start;align-items:center}.bp-customer-admin__contact-icon{margin:0;padding:0;width:55px}.bp-customer-admin__contact-label{width:100%;padding:5px}", ""]);

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.btn-modal-order.btn.btn-lg.btn-primary{position:fixed;right:16px;bottom:4px;height:50px;width:50px}.icon-task:before{color:#fff;position:absolute;top:-8px;left:3px;font-size:24px;text-shadow:1px 2px 4px #000}.icon-bar{height:35px;width:35px;left:5px;padding:0;margin:0;background-size:30px}.icon-bar.icon-transfers-page{background:url(\"/assets/images/transfers-page.svg\") no-repeat center}.icon-bar.icon-dashboard-page:before{font-size:32px!important}.icon-bar.icon-beer-style-page{background:url(\"/assets/images/beer-style-page-icon.svg\") no-repeat center}.icon-bar.icon-tanks-page{background:url(\"/assets/images/fermenter-tank-page-icon.svg\") no-repeat center}.icon-bar.icon-tanks-sections{background:url(\"/assets/images/brewing-fermenting-packaging.png\") no-repeat center;background-size:34px;left:2px;top:7px}.icon-bar.icon-help-page{background:url(\"/assets/images/help-page.svg\") no-repeat center;background-size:32px;top:7px;left:0}.icon-bar.icon-contact-page{background:url(\"/assets/images/contact-page-icon.svg\") no-repeat center}.icon-bar.icon-process{background:url(\"/assets/images/tasks.svg\") no-repeat center;background-size:25px;left:-1px;top:7px}.icon-bar.icon-ingridients-items:before{font-size:33px;position:absolute;top:-3px}.filtration-icon,.packaging-icon{position:absolute}.dashboard-icon.icon-task{margin:0;left:0;padding:0;background:none!important;border-radius:0;transform:translateY(10px);top:0!important;width:inherit!important}.dashboard-icon.icon-task:before{width:inherit!important;height:35px!important;top:0!important;display:flex;justify-content:center;align-items:center;left:0}.dashboard-icon.icon-task[data-dashboard-width=\"large\"]:before{font-size:2vw!important}.dashboard-icon.icon-task[data-dashboard-width=\"medium\"]:before{font-size:calc(2.5vw)!important}.dashboard-icon.icon-task[data-dashboard-width=\"small\"]:before{font-size:calc(2.5vw - 60%)!important}@media (max-width:767px){.dashboard-icon.icon-task[data-dashboard-width=\"large\"]:before{font-size:3vw!important}.dashboard-icon.icon-task[data-dashboard-width=\"medium\"]:before,.dashboard-icon.icon-task[data-dashboard-width=\"small\"]:before{font-size:calc(3vw)!important}}@media (min-width:768px){.dashboard-icon.icon-task[data-dashboard-width=\"large\"]:before{font-size:2.9vw!important}.dashboard-icon.icon-task[data-dashboard-width=\"medium\"]:before{font-size:calc(2.9vw)!important}.dashboard-icon.icon-task[data-dashboard-width=\"small\"]:before{font-size:calc(2.5vw - 60%)!important}}@media (min-width:992px){.dashboard-icon.icon-task[data-dashboard-width=\"large\"]:before{font-size:2.4vw!important}.dashboard-icon.icon-task[data-dashboard-width=\"medium\"]:before{font-size:calc(2.4vw)!important}.dashboard-icon.icon-task[data-dashboard-width=\"small\"]:before{font-size:calc(2.3vw - 60%)!important}}@media (min-width:1200px){.dashboard-icon.icon-task[data-dashboard-width=\"large\"]:before{font-size:1.4vw!important}.dashboard-icon.icon-task[data-dashboard-width=\"medium\"]:before{font-size:calc(1.5vw)!important}.dashboard-icon.icon-task[data-dashboard-width=\"small\"]:before{font-size:calc(1.3vw - 25%)!important}}.is-partially-out-side-of-dashboard{cursor:not-allowed!important}@media (max-width:767px){.dashboard-body .react-grid-item.cssTransforms{text-align:left!important}}.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"purchase_in_coming\"]:after{content:\" \";height:11px;width:11px;border-radius:50%;bottom:15px;position:absolute;box-shadow:1px 3px 4px #000;background:#ff0;background-color:#ff0!important;right:65%;top:0}.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"some_confirmed_some_unconfirmed\"]:after,.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"some_was_unconfirmed_already_discounted\"]:after,.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"is_enough_inventory\"]:after{content:\" \";height:11px;width:11px;border-radius:50%;bottom:15px;position:absolute;box-shadow:1px 3px 4px #000;background:green;background-color:green!important;right:65%;top:0}.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"all_discounted_confirmed\"]:after{border-radius:50%;bottom:15px;position:absolute;box-shadow:1px 3px 4px #000;background:green;content:\"✔\";font-size:13px;height:14px;width:14px;right:65%;top:0;color:#fff!important}.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"missing-items\"]:after{content:\" \";height:11px;width:11px;border-radius:50%;bottom:15px;position:absolute;box-shadow:1px 3px 4px #000;background:red;background-color:red!important;right:65%;top:0}.dashboard-icon[data-is-inventory-task=\"true\"][data-inventory-status-icon-state=\"some-product-non-confirmed-out-scope\"]:after{height:11px;width:11px;border-radius:50%;bottom:15px;position:absolute;box-shadow:1px 3px 4px #000;background:red;content:\"!\";font-size:10px;right:65%;top:0;color:#fff!important}.dashboard-icon:before{font-size:27px}.react-grid-item.cssTransforms.order-style[data-is-closed=\"true\"]{cursor:no-drop!important}.icon-task{height:35px;left:25px;width:30px;margin-top:0;margin-left:-47px;padding:0;border-radius:50px;background-size:21px!important;background-color:#5c5e5d!important;background-position-x:4px!important}.icon-task.icon-daily-task{background-size:28px}.dashboard-header .react-grid-item.cssTransforms:not(.is-fermenter):not(.fixed-header){transition-property:transform;top:-2px}@-moz-document url-prefix(){.dashboard-header .react-grid-item.cssTransforms:not(.is-fermenter):not(.fixed-header){top:0}}.dashboard-header .react-draggable.react-grid-item.cssTransforms.order-style:not(.fixed-header){margin-left:0}@-moz-document url-prefix(){.dashboard-header .react-draggable.react-grid-item.cssTransforms.order-style:not(.fixed-header){left:0}}.dashboard-header .react-grid-item.cssTransforms.fixed-header{height:50px!important;background-color:#031B3A!important;top:63px;padding-top:10px;position:fixed!important;z-index:6;font-size:13px;color:#ecedee;font-weight:300;text-align:center;box-shadow:0 3px 3px gray!important}.dashboard-header .react-grid-item.cssTransforms.fixed-header[data-tank-is-enable=\"false\"]{background-color:red!important;opacity:.4}@media (max-width:767px){.dashboard-header .react-grid-item.cssTransforms.fixed-header{font-size:10px;padding-top:4px}}.dashboard-header .fixed-header:after{content:attr(data-tank-volume);top:-20px!important;color:#fcca2e;font-weight:400;position:relative}.dashboard-header .fixed-header-tank-name{font-weight:500!important;overflow:hidden;height:35px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.dashboard-header .react-grid-item.fixed-header::before{content:\"\";position:absolute;height:10000px;border:#000;left:100%;top:10%;bottom:10%;border-left:1px solid rgba(135,136,137,.54)}.dashboard-header .react-grid-layout{height:50px}.dashboard-header .react-grid-layout.is-packaging-note-collapsed.is-brewing-note-collapsed .react-grid-item.cssTransforms:not(.fixed-header),.dashboard-header .react-grid-layout.is-brewing-note-collapsed:not(is-packaging-note-collapsed) .react-grid-item.cssTransforms:not(.fixed-header){top:3px}.dashboard-header .react-grid-item.cssTransforms.fixed-header.is-first-britetank::before,.dashboard-header .react-grid-item.cssTransforms.fixed-header.is-first-fermenter::before{top:50px;border-left:2px solid #292929}.react-grid-item.cssTransforms.fixed-header.is-disable-brew-separator.is-first-britetank::before,.react-grid-item.cssTransforms.fixed-header.is-disable-brew-separator.is-first-fermenter::before{border-left:1px solid rgba(135,136,137,.54)}@media (min-width:992px){.dashboard-body.is-free-version .react-grid-layout{margin-top:-50px}}@media (min-width:768px) and (max-width:991px){.dashboard-body.is-free-version .react-grid-layout{margin-top:-20px}}@media (max-width:767px){.dashboard-body.is-free-version .react-grid-layout{margin-top:0}}.dashboard-body .react-grid-layout{position:relative;transition:height 200ms ease;margin-top:50px}.dashboard-body .react-grid-layout .is-filter-active{z-index:10!important;opacity:1!important;box-shadow:0 0 40px 0 lightgrey;font-size:10px;text-align:right!important}@media (min-width:768px) and (max-width:991px){.dashboard-body .react-grid-layout.dashboard-content.is-dashboard-brewing-note-open.is-dashboard-packaging-note-close{background-color:green!important}}@media (max-width:767px){.dashboard-body .react-grid-layout.dashboard-content.is-dashboard-brewing-note-open.is-dashboard-packaging-note-close{background-color:greenyellow!important}}.dashboard-body .react-grid-layout.is-pristine{height:2130px}.dashboard-body .react-grid-layout.is-brewing-note-open.is-packaging-note-open,.dashboard-body .react-grid-layout.is-brewing-note-open.is-packaging-note-close{margin-top:-5px}.dashboard-body .react-resizable-handle.react-draggable{position:absolute;width:30%;height:34px;margin-top:-14px;margin-left:70%;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABlBMVEUAAAAAAAClZ7nPAAAAAXRSTlMAQObYZgAAABxJREFUKM9jYBgFFAFGRgYGJhqbT0s7YOZT2Q4ADWAAE5zWMkIAAAAASUVORK5CYII=);background-size:24px;background-position:bottom right;padding:0 0 0 7px;background-repeat:no-repeat;background-origin:content-box;box-sizing:border-box;cursor:n-resize;left:0!important;transform:none!important;-webkit-transform:none!important;-ms-transform:none!important;-o-transform:none!important;-moz-transform:none!important}@media (max-width:767px){.dashboard-body .react-resizable-handle.react-draggable{background-image:none}}.dashboard-body .react-draggable.react-grid-item.cssTransforms:before{position:absolute;bottom:2px;left:0;right:0;white-space:nowrap}@media (max-width:767px){.dashboard-body .react-draggable.react-grid-item.cssTransforms:before{content:attr(data-last-short-date);font-weight:700}}.dashboard-body .react-draggable.react-grid-item.cssTransforms:after{content:attr(data-first-date);position:absolute;top:0;left:0;right:0;line-height:12px;font-size:14px;padding-top:6px;white-space:nowrap}@media (max-width:767px){.dashboard-body .react-draggable.react-grid-item.cssTransforms:after{content:attr(data-first-short-date);font-weight:700}}.dashboard-body .react-draggable.react-grid-item.cssTransforms.is-fermenter:before{height:34px;color:#000;position:absolute;left:0;right:0;font-weight:700;padding-top:2px;white-space:nowrap;bottom:0}@media (max-width:767px){.dashboard-body .react-draggable.react-grid-item.cssTransforms.is-fermenter:before{font-size:12px;padding-top:5px;font-weight:700}}.dashboard-body .react-grid-item:not(.react-grid-placeholder){background:#7b7b7b;color:#fff}.dashboard-body .react-grid-item.cssTransforms{top:-2px}@-moz-document url-prefix(){.dashboard-body .react-grid-item.cssTransforms{top:0}}.dashboard-body .react-grid-item{transition:all 200ms ease;transition-property:left,top}.dashboard-body .react-grid-item.cssTransforms{transition-property:transform;text-align:center}@media (max-width:767px){.dashboard-body .react-grid-item.cssTransforms{text-align:left}}.dashboard-body .react-grid-item.resizing{z-index:1}.dashboard-body .react-grid-placeholder{background:rgba(50,50,50,.75);opacity:.9;transition-duration:100ms;z-index:2;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.dashboard-body .react-grid-item.react-draggable-dragging{transition:none;z-index:3}.dashboard-body .react-draggable{position:relative}.dashboard-body .react-draggable-active{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none}.dashboard-body .react-grid-resize-handle{position:absolute;opacity:0;width:20px;height:30px;line-height:38px;font-size:20px;text-align:right}.dashboard-body .react-grid-item:hover .react-grid-resize-handle{opacity:1}.btn-modal-order-circle{-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;border:none;bottom:10px;right:10px;-webkit-box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),inset 0 1px 0 rgba(255,255,255,.25),inset 0 -1px 0 rgba(0,0,0,.15);-moz-box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),inset 0 1px 0 rgba(255,255,255,.25),inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),inset 0 1px 0 rgba(255,255,255,.25),inset 0 -1px 0 rgba(0,0,0,.15);height:56px;width:56px;position:fixed;-webkit-transition-duration:.25s;transition-duration:.25s;-webkit-transition-property:background-color,-webkit-box-shadow;transition-property:background-color,box-shadow;z-index:6;background-color:#000}.btn-modal-order-circle .btn-order-text{font-size:35px;color:#fff;top:3px;position:relative;left:18px}.order-icon{width:inherit}.order-icon .order-icon-top{position:relative}.order-icon .order-icon-top i[data-tank-type=\"BH\"].order-icon-top-label{font-size:8px;opacity:.8}.order-icon .order-icon-top .order-icon-top-label{left:.2vw;top:0;box-shadow:0 2px 2px 0 #000;color:#fff;position:absolute;z-index:999;border-radius:2px;background-color:rgba(0,0,0,.84);background-color:#000;background-size:26px;padding:1px 2px;font-size:10px;overflow:hidden;max-width:25px;min-width:17px;word-wrap:break-word}.order-icon .order-icon-top .order-icon-top-label[data-tank-type=\"BH\"]{left:0}@media (max-width:767px){.order-icon .order-icon-top .order-icon-top-label{max-width:15px;min-width:13px;left:60%;font-size:8px}}@media (min-width:768px){.order-icon .order-icon-top .order-icon-top-label{max-width:20px;min-width:17px;left:65%!important}}@media (min-width:992px){.order-icon .order-icon-top .order-icon-top-label{max-width:20px;min-width:17px;left:60%}}@media (min-width:1200px){.order-icon .order-icon-top .order-icon-top-label{max-width:25px;min-width:17px;left:69%!important}}.order-icon .order-icon-bottom{width:inherit}.order-icon .order-icon-bottom img.stop-dragging.filtration-icon.center-icon-small{width:100%}@media (max-width:767px){.order-icon .order-icon-bottom img.stop-dragging.filtration-icon.center-icon-small{height:20px;margin-top:8px}}@media (min-width:768px){.order-icon .order-icon-bottom img.stop-dragging.filtration-icon.center-icon-small{height:28px;margin-top:5px}}@media (min-width:992px){.order-icon .order-icon-bottom img.stop-dragging.filtration-icon.center-icon-small{height:30px;margin-top:2px}}@media (min-width:1200px){.order-icon .order-icon-bottom img.stop-dragging.filtration-icon.center-icon-small{height:35px;margin-top:0}}.order-comment-icon{position:relative;top:1px;height:32px;display:block;margin:0 auto}.comentary-day-content.is-disabled .comment-day>input{color:#515151!important}.comentary-day-content.is-first-note.packaging-bar{margin-left:70px;border:none}.comentary-day-content.is-first-note.packaging-bar.is-packaging-bar-only-open{margin-top:3px}.comentary-day-content.is-first-note.brewing-bar{border:none}.stop-dragging{pointer-events:none}.center-icon-small,.center-icon-large{left:0}.btn-right-fixed{opacity:.7;position:fixed!important;bottom:10px;z-index:8;box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),0 1px 0 rgba(255,255,255,.25)inset,0 -1px 0 rgba(0,0,0,.15)inset}@media (max-width:767px){.btn-right-fixed.btn-right-add-mobile{right:10px}}.btn-right-fixed.btn-right-upload{right:10px}@media (max-width:767px){.btn-right-fixed.btn-right-upload{right:70px}}.btn-calculate-inventory{position:fixed;bottom:75px;height:56px;right:10px;transform:scale(.85)}.btn-calculate-inventory.is-published{bottom:10px}.with-opacity{opacity:.65}.with-opacity:hover{opacity:1!important}.btn-undo-redo{position:fixed!important;bottom:8px;z-index:8;box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),0 1px 0 rgba(255,255,255,.25)inset,0 -1px 0 rgba(0,0,0,.15)inset;background-color:#777;border:none;transform:scale(.8)!important}.btn-undo-redo.btn-undo{right:75px}.btn-undo-redo.btn-undo.with-redo,.btn-undo-redo.btn-redo{right:130px}.btn-undo-redo.btn-redo.with-redo{right:75px}.btn-forware-order i,.btn-backward-order i{background:url(/assets/images/loading-dashboard-2.gif) no-repeat center!important;background-size:52px!important;transform:scale(.7) translateY(19px);width:52px;height:52px!important}@media (max-width:767px){body.noselect.is-overflow-hidden.stop-scroll{height:100%!important;overflow:hidden!important}}.btn-user-tasks{position:fixed;left:8px;bottom:10px;transform:scale(.8)}@media (max-width:767px){.btn-user-tasks{left:initial;right:8px;transform:none}}.btn-user-tasks.btn-inventory-report{bottom:70px}@media (max-width:767px){.btn-user-tasks.btn-inventory-report{bottom:75px}}.dashboard-spinner{background:url(/assets/images/loading-dashboard-2.gif) no-repeat center!important;background-size:52px!important;transform:scale(.8) translateY(19px);width:52px;height:52px!important}.btn-center-top-fixed{top:170px}.btn-center-top-fixed,.btn-center-bottom-fixed{position:absolute!important;left:calc(50% - 30px);z-index:8;box-shadow:0 2px 10px rgba(0,0,0,.3),0 0 1px rgba(0,0,0,.1),0 1px 0 rgba(255,255,255,.25)inset,0 -1px 0 rgba(0,0,0,.15)inset}.btn-center-bottom-fixed{bottom:-30px!important;top:inherit;margin-top:-75px!important}.btn-center-bottom-fixed.is-pristine{bottom:10px}.btn-right-fixed.btn-publish{right:75px;background-color:#009688}.btn-icon-center{position:relative;top:-16px}.animated{box-shadow:7px 7px 12px 0 rgba(0,3,0,.62);transition:all .6s!important;z-index:5;opacity:1!important}.selected{border:#fcca2e solid 5px}@media (max-width:767px){.dashboard-header .react-grid-item.cssTransforms.fixed-header{font-size:7px;padding-top:17px;height:50px!important;top:63px}}@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(1.5)}100%{transform:scale(1)}}.dashboard-content.is-dashboard-brewing-note-open.is-dashboard-packaging-note-close .packaging-bar{margin-top:50px}@media (min-width:768px) and (max-width:991px){.dashboard-content.is-dashboard-brewing-note-open.is-dashboard-packaging-note-close .packaging-bar.chronologyc-bar.is-close{top:105px}}@media (max-width:767px){.dashboard-content.is-dashboard-brewing-note-open.is-dashboard-packaging-note-close .packaging-bar.chronologyc-bar.is-close{top:85px}}@media (max-width:767px){.dashboard-content.is-free-version.is-parent-brewing-note-close.is-parent-packaging-note-open .packaging-bar{margin-top:5px}}@media (min-width:992px){.dashboard-content.is-free-version.is-parent-brewing-note-close.is-parent-packaging-note-open .packaging-bar{margin-top:-20px}}@media (min-width:768px) and (max-width:991px){.dashboard-content.is-free-version.is-parent-brewing-note-close.is-parent-packaging-note-open .packaging-bar{margin-top:-5px}}@media (max-width:767px){.dashboard-content.is-free-version.is-parent-brewing-note-open.is-parent-packaging-note-open .packaging-bar{margin-top:5px}}@media (min-width:768px){.dashboard-content.is-free-version.is-parent-brewing-note-open.is-parent-packaging-note-open .packaging-bar{margin-top:5px}}@media (max-width:767px){.dashboard-content.is-free-version.is-parent-brewing-note-open.is-parent-packaging-note-close .packaging-bar{margin-top:5px}}@media (min-width:768px) and (max-width:991px){.dashboard-content.is-free-version.is-parent-brewing-note-open.is-parent-packaging-note-close .packaging-bar{margin-top:25px}}@media (min-width:992px){.dashboard-content.is-free-version.is-parent-brewing-note-open.is-parent-packaging-note-close .packaging-bar{margin-top:55px}}.dashboard-content.is-parent-brewing-note-close.is-parent-packaging-note-open:not(.is-free-version) .packaging-bar.chronologyc-bar{margin-top:60px}.dashboard-content.is-parent-brewing-note-open.is-parent-packaging-note-close:not(.is-free-version) .packaging-bar.chronologyc-bar{margin-top:-45px}@media (min-width:768px) and (max-width:991px){.dashboard-content.is-dashboard-brewing-note-close.is-dashboard-packaging-note-open .packaging-bar.chronologyc-bar{top:100px}}@media (max-width:767px){.dashboard-content.is-dashboard-brewing-note-close.is-dashboard-packaging-note-open .packaging-bar.chronologyc-bar{top:100px}}.chronologyc-row.row.chronologyc-row.row.is-to-day:after{border-bottom:solid 2px #e3007e!important;width:200vw;left:-100vw;position:absolute;bottom:0}.free-version-advertisement{position:fixed;bottom:0;background-color:#fcca2eb5;width:100vw;height:78px;justify-content:center;display:flex;align-items:center;z-index:7;border-top:solid #333 2px}@media (min-width:993px){.free-version-advertisement{font-size:22px}.free-version-advertisement p{padding-right:40px}}@media (max-width:992px){.free-version-advertisement{font-size:18px}}@media (max-width:677px){.free-version-advertisement{display:none}}.free-version-advertisement p{margin:0;padding-right:20px}span.order-icon-inventory-status{width:inherit}span.order-icon-inventory-status__amount{position:relative;bottom:1px;right:15px;padding:9px 5px;background-color:#0f9d58;height:10px;color:#fff;z-index:9999999;text-align:center;display:flex;justify-content:center;align-items:center;border:solid 1px #000;width:fit-content}span.order-icon-inventory-missing-status__amount{background-color:#db4437;color:#fff}span.order-icon-inventory-missing-status__amount,span.order-icon-inventory-requested-status__amount{position:relative;bottom:1px;right:15px;padding:9px 5px;height:10px;z-index:9999999;text-align:center;display:flex;justify-content:center;align-items:center;border:solid 1px #000;width:fit-content}span.order-icon-inventory-requested-status__amount{background-color:#fcca2e;color:#000}.beer-style-label{position:absolute;top:0;overflow:hidden;font-size:14px;text-align:left;z-index:0;box-shadow:none}.beer-style-label.is-brewing{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-dashboard-view-only-indicator{background-color:rgba(153,153,153,.38);position:fixed;bottom:10px;z-index:999;border-radius:20px;text-align:center;padding:6px 10px;color:#fff;text-shadow:0 0 4px #000;font-size:14px;width:135px;left:calc(45vw)}@media (max-width:767px){.bp-dashboard-view-only-indicator{font-size:11px;width:110px;left:36vw}}", ""]);

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.welcome-page-container{background-color:#fff;line-height:10px}.welcome-page-container__header{padding-bottom:10px}@media (max-width:767px){.welcome-page-container__header{font-size:45px!important}}@media (max-width:767px){.welcome-page-container__body{font-size:30px!important;line-height:20px!important}}.welcome-page-container__start-button{padding-top:20px}", ""]);

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}@media (max-width:767px){.bp-history-modal{font-size:10px}}@media (max-width:767px){.bp-history-modal__header{margin-bottom:4em}}.bp-history-modal__header-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6}.bp-history-modal__header-title~hr{margin-bottom:2em;border-bottom:solid 2px #777}.bp-history-modal__body-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6}.bp-history-modal__body-title~hr{margin-bottom:2em;border-bottom:solid 2px #777}", ""]);

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".bp-history-modal-description{display:flex;justify-content:space-between;width:80%}.bp-history-modal-description__field{line-height:4em;height:4em}.bp-history-modal-description__field-column-name{padding-bottom:.5em;padding-left:.9em}.bp-history-modal-description__field-value{padding-left:.9em;font-size:1em}", ""]);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-history-modal-fields{border-bottom:1px solid #d5d5d5;margin:0;background-color:#f6f6f6}.bp-history-modal-fields__field{overflow:hidden}.bp-history-modal-fields__field input{color:#777!important}@media (max-width:767px){.bp-history-modal-fields__field input{font-size:.7em!important}}.bp-history-modal-fields__field input~div{display:none!important}.bp-history-modal-fields__field-name>div>div{display:none}.bp-history-modal-fields__header.row{margin:0;padding:.5em 0;font-size:1em;color:#fff;background-color:#B3B3B3}.bp-history-modal-fields__content{padding-left:0}", ""]);

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".icon-and-section-view{font-family:\"Roboto\",sans-serif!important;font-size:14px!important;-webkit-font-smoothing:antialiased!important;-moz-osx-font-smoothing:grayscale!important;line-height:1.42857!important;color:#333!important;background-color:#fff}.icon-and-section-view .admin-scaffolding-content{padding:20px}", ""]);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}@media (max-width:767px){.bp-location-adjusts-modal{font-size:10px}}@media (max-width:767px){.bp-location-adjusts-modal__header{margin-bottom:4em}}.bp-location-adjusts-modal__fields{display:flex}@media (max-width:767px){.bp-location-adjusts-modal__fields{flex-wrap:wrap}}.bp-location-adjusts-modal__fields>div{margin-right:10px}.bp-location-adjusts-modal__header-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6!important}.bp-location-adjusts-modal__header-title~hr{margin-bottom:0;border-bottom:solid 2px #777}.bp-location-adjusts-modal__header-title~hr~div{margin-bottom:.5em}.bp-location-adjusts-modal__body-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6!important}.bp-location-adjusts-modal__body-title~hr{margin-bottom:0;border-bottom:solid 2px #777}", ""]);

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}@media (max-width:767px){.bp-location-transfer-modal{font-size:10px}}@media (max-width:767px){.bp-location-transfer-modal__header{margin-bottom:4em}}.bp-location-transfer-modal__fields{display:flex}.bp-location-transfer-modal__fields .bp-drop-down .bp-textfield__input{color:#000}@media (max-width:767px){.bp-location-transfer-modal__fields{flex-wrap:wrap}}.bp-location-transfer-modal__fields>div{margin-right:25px}.bp-location-transfer-modal__header-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6!important}.bp-location-transfer-modal__header-title~hr{margin-bottom:0;border-bottom:solid 2px #777}.bp-location-transfer-modal__header-title~hr~div{margin-right:2em;margin-bottom:.5em}.bp-location-transfer-modal__body-title{height:2em;line-height:2em;margin-bottom:-1em;padding-left:.5em;font-size:20px;font-weight:400;color:#777;background-color:#f6f6f6!important}.bp-location-transfer-modal__body-title~hr{margin-bottom:0;border-bottom:solid 2px #777}.bp-location-transfer-modal__select-from,.bp-location-transfer-modal__select-to{overflow:hidden}", ""]);

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.preactivated-page-container{background-color:#fff}.preactivated-page-container__header{font-size:40px;padding-bottom:10px}.preactivated-page-container__body{font-size:20px}.preactivated-page-container__footer{padding-top:30px;text-align:left}.preactivated-page-container__footer-signature{font-size:19px!important;color:#777}@media (max-width:767px){.preactivated-page-container__footer-signature{font-size:15px!important}}.preactivated-page-container__mail-support{color:#777;font-size:15px!important;padding-top:15px}@media (max-width:767px){.preactivated-page-container__mail-support{font-size:13px!important}}", ""]);

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.report-admin{overflow:auto;padding:2vh 4vh;display:flex;flex-direction:column;margin-top:40px}@media (max-width:767px){.report-admin{font-size:10px}}.report-admin__header{margin:1.2em 0;font-size:2em;font-weight:100}.report-admin__body{display:flex;justify-content:flex-start;padding:2em;border-top:solid 2px gray;border-radius:0 0 5px 5px;overflow:auto;background-color:#eee}@media (max-width:767px){.report-admin__body{flex-direction:column}.report-admin__body .box-selector{margin-bottom:2em}}.report-admin__body .box-selector{margin-right:2em}@media (max-width:767px){.report-admin__body .box-selector{font-size:10px;margin-right:0}}", ""]);

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.report-by-beer-style{height:100vh;padding:10vh 4vh}@media (max-width:767px){.report-by-beer-style{padding:5vh 0;font-size:10px}}.report-by-beer-style__header{max-width:500px;margin-top:1.2em;margin-bottom:1em!important;margin:0 auto;font-size:2em;font-weight:100}@media (max-width:767px){.report-by-beer-style__header{max-width:none;padding:0 1em 2em;margin:0!important}}.report-by-beer-style__body{padding:2em;max-width:500px;margin:0 auto;border-top:solid 2px gray;border-radius:0 0 5px 5px;background-color:#eee}@media (max-width:767px){.report-by-beer-style__body{max-width:none}}.report-by-beer-style__body-row{display:flex;justify-content:flex-start;flex-direction:row;align-items:center}@media (max-width:767px){.report-by-beer-style__body-row{flex-direction:column;justify-content:flex-start;align-items:flex-start;align-self:flex-end}}.report-by-beer-style__body-row>*{margin-right:1em}.report-by-beer-style__body-row-title{font-size:20px;font-weight:100;align-self:flex-end}@media (max-width:767px){.report-by-beer-style__body-row-title{align-self:flex-start}}.report-by-beer-style__body-content label{font-weight:100}.report-by-beer-style__body-content .box-selector{margin-right:1em}.report-by-beer-style__body-content .bp-grid-item-withfilter{padding:0}.report-by-beer-style__submit{display:flex;margin-top:1.5em;margin-left:-7px;width:100%;align-items:flex-end}.report-by-beer-style__submit .form-group-button.form-group-button-icon.primary-icon{width:inherit;box-shadow:0 2px 7px 0 grey;margin-top:3em}.bp-drop-down .bp-textfield.is-empty-label .bp-textfield__input{color:#000}", ""]);

/***/ },
/* 297 */
296,
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.report-by-beer-style{height:100vh;padding:10vh 4vh}@media (max-width:767px){.report-by-beer-style{padding:5vh 0;font-size:10px}}.report-by-beer-style__header{max-width:500px;margin-top:1.2em;margin-bottom:1em!important;margin:0 auto;font-size:2em;font-weight:100}@media (max-width:767px){.report-by-beer-style__header{max-width:none;padding:0 1em 2em;margin:0!important}}.report-by-beer-style__body{padding:2em;max-width:500px;margin:0 auto;border-top:solid 2px gray;border-radius:0 0 5px 5px;background-color:#eee}@media (max-width:767px){.report-by-beer-style__body{max-width:none}}.report-by-beer-style__body-row{display:flex;justify-content:flex-start;flex-direction:row;align-items:center}@media (max-width:767px){.report-by-beer-style__body-row{flex-direction:column;justify-content:flex-start;align-items:flex-start;align-self:flex-end}}.report-by-beer-style__body-row>*{margin-right:1em}.report-by-beer-style__body-row-title{font-size:20px;font-weight:100;align-self:flex-end}@media (max-width:767px){.report-by-beer-style__body-row-title{align-self:flex-start}}.report-by-beer-style__body-row-title-show-by{font-size:20px;font-weight:100;align-self:flex-end}@media (max-width:767px){.report-by-beer-style__body-row-title-show-by{align-self:flex-start;margin-top:20px!important;margin-bottom:-10px!important}}@media (min-width:768px){.report-by-beer-style__body-row-title-show-by{margin-bottom:-30px}}.report-by-beer-style__body-content label{font-weight:100}.report-by-beer-style__body-content .box-selector{margin-right:1em}.report-by-beer-style__body-content .bp-grid-item-withfilter{padding:0}.report-by-beer-style__submit{display:flex;margin-top:1.5em;margin-left:-7px;width:100%;align-items:flex-end}.report-by-beer-style__submit .form-group-button.form-group-button-icon.primary-icon{width:inherit;box-shadow:0 2px 7px 0 grey;margin-top:3em}.bp-drop-down .bp-textfield.is-empty-label .bp-textfield__input{color:#000}", ""]);

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.report-by-task{height:100vh;padding:10vh 4vh}@media (max-width:767px){.report-by-task{padding:5vh 0;font-size:10px}}.report-by-task__header{max-width:500px;margin-top:1.2em;margin-bottom:1em!important;margin:0 auto;font-size:2em;font-weight:100}@media (max-width:767px){.report-by-task__header{max-width:none;padding:0 1em 2em;margin:0!important}}.report-by-task__body{padding:2em;max-width:500px;margin:0 auto;border-top:solid 2px gray;border-radius:0 0 5px 5px;background-color:#eee}@media (max-width:767px){.report-by-task__body{max-width:none}}.report-by-task__body-row{display:flex;justify-content:flex-start;flex-direction:row;align-items:center}@media (max-width:767px){.report-by-task__body-row{flex-direction:column;justify-content:flex-start;align-items:flex-start;align-self:flex-end}}.report-by-task__body-row>*{margin-right:1em}.report-by-task__body-row-title{font-size:20px;font-weight:100;align-self:flex-end}@media (max-width:767px){.report-by-task__body-row-title{align-self:flex-start}}.report-by-task__body-row-title-show-by{font-size:20px;font-weight:100;align-self:flex-end}@media (max-width:767px){.report-by-task__body-row-title-show-by{align-self:flex-start;margin-top:20px!important;margin-bottom:-10px!important}}@media (min-width:768px){.report-by-task__body-row-title-show-by{margin-bottom:-30px}}.report-by-task__body-content label{font-weight:100}.report-by-task__body-content .box-selector{margin-right:1em}.report-by-task__body-content .bp-grid-item-withfilter{padding:0}.report-by-task__submit{display:flex;margin-top:1.5em;margin-left:-7px;width:100%;align-items:flex-end}.report-by-task__submit .form-group-button.form-group-button-icon.primary-icon{width:inherit;box-shadow:0 2px 7px 0 grey;margin-top:3em}.bp-drop-down .bp-textfield.is-empty-label .bp-textfield__input{color:#000}", ""]);

/***/ },
/* 300 */
296,
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".full-width{width:100%!important}.bp-login-view{margin-top:50px}.bp-login-view .login-content{position:relative;max-width:320px;top:5vh;margin:0 auto}.bp-login-view .login-content .sign-in__logo{padding-top:50px}.bp-login-view .sign-in__footer{display:flex;justify-content:space-between;padding-top:25px}", ""]);

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.signup-page-container{background-color:#fff;position:relative;max-width:600px;top:5vh;margin:0 auto;padding:0 10vw!important}@media (min-width:992px){.signup-page-container{padding:initial!important}}.signup-page-container .page-header{margin-top:10px;color:#B3B3B3;border-bottom:none}.signup-page-container .form-group.from-group-long-text.how-did-you-hear{margin-left:-25px;margin-right:-25px}.signup-page-container .form-group.from-group-long-text label~div{text-align:left}@media (max-width:767px){.signup-page-container .form-group.from-group-long-text label~div{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:300px!important}}@media (min-width:768px){.signup-page-container .form-group.from-group-long-text label~div{width:100%}}@media (min-width:992px){.signup-page-container .form-group.from-group-long-text label~div{width:100%}}.signup-page-container .singup-page-button{margin-bottom:10px}", ""]);

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".user-access-admin{font-size:15px}.user-access-admin__header{display:flex;align-items:center;padding-left:15px}.user-access-admin__header.is-first{margin-top:20px}.user-access-admin__header-text{font-size:2em;padding-left:10px;font-weight:100;margin:10px 0}.user-access-admin__header-toggle{padding-left:10px}.user-access-admin__boxes .bp-grid-item{width:130px;height:80px}.user-access-admin__boxes .bp-grid-item-withfilter{padding-top:0}.user-access-admin__boxes .bp-grid-item__checkbox{height:inherit}.user-access-admin__boxes .bp-grid-item__label{text-overflow:initial;white-space:initial;overflow:initial}.user-access-admin__boxes .bp-grid-item__icon{padding-top:15px}", ""]);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, "@import url(/assets/fonts/icons/icomoon.css);", ""]);
	exports.push([module.id, ".light{font-weight:300!important}hr,body{font-family:\"Roboto\",sans-serif}body{font-size:14px;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;line-height:1.42857;color:#333;background-color:#fff}html{height:100vh}.BPButton{background-color:#FFB902!important;font-size:18px!important}div,span,input,button,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.is-overflow-hidden{overflow-y:visible!important;overflow-x:hidden!important}@-webkit-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}@-moz-keyframes fade-in-out-cycle-transition{0%{opacity:1}50%{opacity:0}100%{opacity:1}}.fade-in-out-cycle-transition{-webkit-transition:all 1s ease-in-out;-moz-transition:all 1s ease-in-out;-o-transition:all 1s ease-in-out;-ms-transition:all 1s ease-in-out;transition:all 1s ease-in-out;-webkit-animation-direction:normal;-webkit-animation-duration:2s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:fade-in-out-cycle-transition;-webkit-animation-timing-function:ease-in-out;-moz-animation-direction:normal;-moz-animation-duration:2s;-moz-animation-iteration-count:infinite;-moz-animation-name:fade-in-out-cycle-transition;-moz-animation-timing-function:ease-in-out}.ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.app-main__side-bar-item .icon-bar.is-pro-version:after{content:\"MRP\";background:0 0;position:absolute;left:-23px;border-radius:4px;color:#959595;font-size:10px;line-height:11px;font-weight:bolder;padding:0 3px;top:9px}.app-main__side-bar-item .icon-bar.is-pro-version:before{color:#959595}.app-main__side-bar-item .icon-bar.is-pro-version~span{color:#959595}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-Thin.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:100;src:url(\"/assets/fonts/roboto/Roboto-ThinItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-Light.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:200;src:url(\"/assets/fonts/roboto/Roboto-LightItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Regular.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:400;src:url(\"/assets/fonts/roboto/Roboto-Italic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-Medium.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:500;src:url(\"/assets/fonts/roboto/Roboto-MediumItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-Bold.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:700;src:url(\"/assets/fonts/roboto/Roboto-BoldItalic.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:normal;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-Black.ttf\")}@font-face{font-family:\"Roboto, sans-serif\";font-style:italic;font-weight:900;src:url(\"/assets/fonts/roboto/Roboto-BlackItalic.ttf\")}.bp-vendor-admin__contact{min-width:120px;display:flex;justify-content:flex-start;align-items:center}.bp-vendor-admin__contact-icon{margin:0;padding:0;width:55px}.bp-vendor-admin__contact-label{width:100%;padding:5px}", ""]);

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(9)();
	exports.push([module.id, ".admin-table-vendor-purchase-width .admin-table-row td:nth-child(3){padding-left:0!important}.admin-table-vendor-purchase-width .admin-table-row td:nth-child(3)>div span:last-child{padding-left:5px!important}#comment{width:-webkit-fill-available}", ""]);

/***/ },
/* 306 */
287,
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(308);
	
	var $SyntaxError = __webpack_require__(416);
	var $TypeError = __webpack_require__(133);
	
	var gopd = __webpack_require__(417);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(158);
	
	/** @type {import('.')} */
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true) || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(814);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(308);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(418);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 312 */
/***/ function(module, exports) {

	module.exports = {
		"name": "BrewPlanner",
		"version": "2.51.76",
		"description": "Application for scheduled brew production.",
		"repository": {
			"type": "git",
			"url": "https://jero786@bitbucket.org:jero786/brewplanner.git"
		},
		"engines": {
			"node": ">=0.10.0"
		},
		"scripts": {
			"dev": "grunt serve",
			"start": "node server.js",
			"cypress:open": "npx cypress open",
			"cypress:run:po": "npx cypress run --spec 'cypress/e2e/purchaseItems/purchaseItems.spec.js'"
		},
		"main": "src/components/main.js",
		"private": true,
		"src": "src",
		"test": "test",
		"dist": "../brewplanner-schedule/src/main/resources/static",
		"mainInput": "main",
		"mainOutput": "main",
		"dependencies": {
			"bounding-client-rect": "^1.0.5",
			"currency-formatter": "^1.2.1",
			"es6-promise": "^4.1.0",
			"eventlistener": "0.0.1",
			"events": "1.1.0",
			"flux": "2.1.1",
			"immutable": "^3.8.1",
			"jquery": "3.1.0",
			"json-loader": "^0.5.4",
			"keymirror": "0.1.1",
			"locale-helpers": "^1.0.142",
			"lodash": "4.5.1",
			"material-ui": "0.11.1",
			"minimatch": "^3.0.4",
			"moment": "2.11.2",
			"moment-timezone": "^0.5.13",
			"node-sass": "^9.0.0",
			"normalize.css": "3.0.3",
			"numeral": "^2.0.6",
			"object-assign": "2.1.1",
			"react": "0.13",
			"react-ga": "1.2.0",
			"react-grid-layout": "0.8.5",
			"react-notification-system": "0.1.17",
			"react-router": "0.13.2",
			"react-tap-event-plugin": "0.2.2",
			"rest": "1.3.1",
			"sass-loader": "3.2.0",
			"spectrum-colorpicker": "1.8.0",
			"uploadcare-widget": "^2.10.3"
		},
		"devDependencies": {
			"babel-core": "6.9.0",
			"babel-loader": "6.2.4",
			"babel-plugin-transform-object-assign": "^6.5.0",
			"babel-polyfill": "^6.9.0",
			"babel-preset-es2015": "^6.9.0",
			"babel-preset-es2015-loose": "^7.0.0",
			"babel-preset-react": "6.5.0",
			"babel-preset-stage-2": "6.5.0",
			"compression-webpack-plugin": "^0.2.0",
			"css-loader": "~0.9.0",
			"enzyme": "^2.9.1",
			"eslint": "^1.3.1",
			"eslint-loader": "^1.0.0",
			"eslint-plugin-react": "^3.3.0",
			"expect": "^1.18.0",
			"expect-enzyme": "^1.0.0",
			"expect-immutable": "0.0.3",
			"expect-jsx": "^3.0.0",
			"file-loader": "^0.8.4",
			"grunt": "~0.4.5",
			"grunt-contrib-clean": "~0.6.0",
			"grunt-contrib-connect": "~0.8.0",
			"grunt-contrib-copy": "~0.5.0",
			"grunt-contrib-watch": "1.0.0",
			"grunt-karma": "~0.8.3",
			"grunt-open": "~0.2.3",
			"grunt-webpack": "~1.0.8",
			"html-loader": "^0.3.0",
			"imagemin": "^3.2.0",
			"jasmine-core": "2.5.2",
			"jshint": "^2.9.1",
			"jshint-loader": "~0.8.0",
			"json-loader": "^0.5.4",
			"jsxhint-loader": "~0.2.0",
			"karma": "^1.7.0",
			"karma-chrome-launcher": "^2.2.0",
			"karma-coverage": "^0.4.2",
			"karma-firefox-launcher": "~0.1.3",
			"karma-jasmine": "^1.1.0",
			"karma-puppeteer-launcher": "^1.0.4",
			"karma-script-launcher": "~0.1.0",
			"karma-sourcemap-loader": "^0.3.7",
			"karma-webpack": "^2.0.3",
			"load-grunt-tasks": "~0.6.0",
			"puppeteer": "^22.10.0",
			"react-hot-loader": "^1.0.7",
			"style-loader": "~0.8.0",
			"url-loader": "~0.5.5",
			"webpack": "^1.13.1",
			"webpack-dev-server": "^1.14.1"
		}
	};

/***/ },
/* 313 */
/***/ function(module, exports) {

	module.exports = [
		{
			"name": {
				"common": "Aruba",
				"official": "Aruba",
				"native": {
					"nld": {
						"official": "Aruba",
						"common": "Aruba"
					},
					"pap": {
						"official": "Aruba",
						"common": "Aruba"
					}
				}
			},
			"tld": [
				".aw"
			],
			"cca2": "AW",
			"ccn3": "533",
			"cca3": "ABW",
			"cioc": "ARU",
			"currency": [
				"AWG"
			],
			"callingCode": [
				"297"
			],
			"capital": "Oranjestad",
			"altSpellings": [
				"AW"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"nld": "Dutch",
				"pap": "Papiamento"
			},
			"translations": {
				"deu": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"fra": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"hrv": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"ita": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"jpn": {
					"official": "アルバ",
					"common": "アルバ"
				},
				"nld": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"por": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"rus": {
					"official": "Аруба",
					"common": "Аруба"
				},
				"slk": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"spa": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"fin": {
					"official": "Aruba",
					"common": "Aruba"
				},
				"zho": {
					"official": "阿鲁巴",
					"common": "阿鲁巴"
				}
			},
			"latlng": [
				12.5,
				-69.96666666
			],
			"demonym": "Aruban",
			"landlocked": false,
			"borders": [],
			"area": 180
		},
		{
			"name": {
				"common": "Afghanistan",
				"official": "Islamic Republic of Afghanistan",
				"native": {
					"prs": {
						"official": "جمهوری اسلامی افغانستان",
						"common": "افغانستان"
					},
					"pus": {
						"official": "د افغانستان اسلامي جمهوریت",
						"common": "افغانستان"
					},
					"tuk": {
						"official": "Owganystan Yslam Respublikasy",
						"common": "Owganystan"
					}
				}
			},
			"tld": [
				".af"
			],
			"cca2": "AF",
			"ccn3": "004",
			"cca3": "AFG",
			"cioc": "AFG",
			"currency": [
				"AFN"
			],
			"callingCode": [
				"93"
			],
			"capital": "Kabul",
			"altSpellings": [
				"AF",
				"Afġānistān"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"prs": "Dari",
				"pus": "Pashto",
				"tuk": "Turkmen"
			},
			"translations": {
				"cym": {
					"official": "Islamic Republic of Afghanistan",
					"common": "Affganistan"
				},
				"deu": {
					"official": "Islamische Republik Afghanistan",
					"common": "Afghanistan"
				},
				"fra": {
					"official": "République islamique d'Afghanistan",
					"common": "Afghanistan"
				},
				"hrv": {
					"official": "Islamska Republika Afganistan",
					"common": "Afganistan"
				},
				"ita": {
					"official": "Repubblica islamica dell'Afghanistan",
					"common": "Afghanistan"
				},
				"jpn": {
					"official": "アフガニスタン·イスラム共和国",
					"common": "アフガニスタン"
				},
				"nld": {
					"official": "Islamitische Republiek Afghanistan",
					"common": "Afghanistan"
				},
				"por": {
					"official": "República Islâmica do Afeganistão",
					"common": "Afeganistão"
				},
				"rus": {
					"official": "Исламская Республика Афганистан",
					"common": "Афганистан"
				},
				"slk": {
					"official": "Afgánsky islamský štát",
					"common": "Afganistan"
				},
				"spa": {
					"official": "República Islámica de Afganistán",
					"common": "Afganistán"
				},
				"fin": {
					"official": "Afganistanin islamilainen tasavalta",
					"common": "Afganistan"
				},
				"zho": {
					"official": "阿富汗伊斯兰共和国",
					"common": "阿富汗"
				}
			},
			"latlng": [
				33,
				65
			],
			"demonym": "Afghan",
			"landlocked": true,
			"borders": [
				"IRN",
				"PAK",
				"TKM",
				"UZB",
				"TJK",
				"CHN"
			],
			"area": 652230
		},
		{
			"name": {
				"common": "Angola",
				"official": "Republic of Angola",
				"native": {
					"por": {
						"official": "República de Angola",
						"common": "Angola"
					}
				}
			},
			"tld": [
				".ao"
			],
			"cca2": "AO",
			"ccn3": "024",
			"cca3": "AGO",
			"cioc": "ANG",
			"currency": [
				"AOA"
			],
			"callingCode": [
				"244"
			],
			"capital": "Luanda",
			"altSpellings": [
				"AO",
				"República de Angola",
				"ʁɛpublika de an'ɡɔla"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"cym": {
					"official": "Republic of Angola",
					"common": "Angola"
				},
				"deu": {
					"official": "Republik Angola",
					"common": "Angola"
				},
				"fra": {
					"official": "République d'Angola",
					"common": "Angola"
				},
				"hrv": {
					"official": "Republika Angola",
					"common": "Angola"
				},
				"ita": {
					"official": "Repubblica dell'Angola",
					"common": "Angola"
				},
				"jpn": {
					"official": "アンゴラ共和国",
					"common": "アンゴラ"
				},
				"nld": {
					"official": "Republiek Angola",
					"common": "Angola"
				},
				"por": {
					"official": "República de Angola",
					"common": "Angola"
				},
				"rus": {
					"official": "Республика Ангола",
					"common": "Ангола"
				},
				"slk": {
					"official": "Angolská republika",
					"common": "Angola"
				},
				"spa": {
					"official": "República de Angola",
					"common": "Angola"
				},
				"fin": {
					"official": "Angolan tasavalta",
					"common": "Angola"
				},
				"zho": {
					"official": "安哥拉共和国",
					"common": "安哥拉"
				}
			},
			"latlng": [
				-12.5,
				18.5
			],
			"demonym": "Angolan",
			"landlocked": false,
			"borders": [
				"COG",
				"COD",
				"ZMB",
				"NAM"
			],
			"area": 1246700
		},
		{
			"name": {
				"common": "Anguilla",
				"official": "Anguilla",
				"native": {
					"eng": {
						"official": "Anguilla",
						"common": "Anguilla"
					}
				}
			},
			"tld": [
				".ai"
			],
			"cca2": "AI",
			"ccn3": "660",
			"cca3": "AIA",
			"cioc": "",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1264"
			],
			"capital": "The Valley",
			"altSpellings": [
				"AI"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"fra": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"hrv": {
					"official": "Anguilla",
					"common": "Angvila"
				},
				"ita": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"jpn": {
					"official": "アングィラ",
					"common": "アンギラ"
				},
				"nld": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"por": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"rus": {
					"official": "Ангилья",
					"common": "Ангилья"
				},
				"slk": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"spa": {
					"official": "Anguila",
					"common": "Anguilla"
				},
				"fin": {
					"official": "Anguilla",
					"common": "Anguilla"
				},
				"zho": {
					"official": "安圭拉",
					"common": "安圭拉"
				}
			},
			"latlng": [
				18.25,
				-63.16666666
			],
			"demonym": "Anguillian",
			"landlocked": false,
			"borders": [],
			"area": 91
		},
		{
			"name": {
				"common": "Åland Islands",
				"official": "Åland Islands",
				"native": {
					"swe": {
						"official": "Landskapet Åland",
						"common": "Åland"
					}
				}
			},
			"tld": [
				".ax"
			],
			"cca2": "AX",
			"ccn3": "248",
			"cca3": "ALA",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"358"
			],
			"capital": "Mariehamn",
			"altSpellings": [
				"AX",
				"Aaland",
				"Aland",
				"Ahvenanmaa"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"swe": "Swedish"
			},
			"translations": {
				"deu": {
					"official": "Åland-Inseln",
					"common": "Åland"
				},
				"fra": {
					"official": "Ahvenanmaa",
					"common": "Ahvenanmaa"
				},
				"hrv": {
					"official": "Aland Islands",
					"common": "Ålandski otoci"
				},
				"ita": {
					"official": "Isole Åland",
					"common": "Isole Aland"
				},
				"jpn": {
					"official": "オーランド諸島",
					"common": "オーランド諸島"
				},
				"nld": {
					"official": "Åland eilanden",
					"common": "Ålandeilanden"
				},
				"por": {
					"official": "Ilhas Åland",
					"common": "Alândia"
				},
				"rus": {
					"official": "Аландские острова",
					"common": "Аландские острова"
				},
				"slk": {
					"official": "Alandské ostrovy",
					"common": "Alandy"
				},
				"spa": {
					"official": "Islas Åland",
					"common": "Alandia"
				},
				"fin": {
					"official": "Ahvenanmaan maakunta",
					"common": "Ahvenanmaa"
				},
				"zho": {
					"official": "奥兰群岛",
					"common": "奥兰群岛"
				}
			},
			"latlng": [
				60.116667,
				19.9
			],
			"demonym": "Ålandish",
			"landlocked": false,
			"borders": [],
			"area": 1580
		},
		{
			"name": {
				"common": "Albania",
				"official": "Republic of Albania",
				"native": {
					"sqi": {
						"official": "Republika e Shqipërisë",
						"common": "Shqipëria"
					}
				}
			},
			"tld": [
				".al"
			],
			"cca2": "AL",
			"ccn3": "008",
			"cca3": "ALB",
			"cioc": "ALB",
			"currency": [
				"ALL"
			],
			"callingCode": [
				"355"
			],
			"capital": "Tirana",
			"altSpellings": [
				"AL",
				"Shqipëri",
				"Shqipëria",
				"Shqipnia"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"sqi": "Albanian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Albania",
					"common": "Albania"
				},
				"deu": {
					"official": "Republik Albanien",
					"common": "Albanien"
				},
				"fra": {
					"official": "République d'Albanie",
					"common": "Albanie"
				},
				"hrv": {
					"official": "Republika Albanija",
					"common": "Albanija"
				},
				"ita": {
					"official": "Repubblica d'Albania",
					"common": "Albania"
				},
				"jpn": {
					"official": "アルバニア共和国",
					"common": "アルバニア"
				},
				"nld": {
					"official": "Republiek Albanië",
					"common": "Albanië"
				},
				"por": {
					"official": "República da Albânia",
					"common": "Albânia"
				},
				"rus": {
					"official": "Республика Албания",
					"common": "Албания"
				},
				"slk": {
					"official": "Albánska republika",
					"common": "Albánsko"
				},
				"spa": {
					"official": "República de Albania",
					"common": "Albania"
				},
				"fin": {
					"official": "Albanian tasavalta",
					"common": "Albania"
				},
				"zho": {
					"official": "阿尔巴尼亚共和国",
					"common": "阿尔巴尼亚"
				}
			},
			"latlng": [
				41,
				20
			],
			"demonym": "Albanian",
			"landlocked": false,
			"borders": [
				"MNE",
				"GRC",
				"MKD",
				"UNK"
			],
			"area": 28748
		},
		{
			"name": {
				"common": "Andorra",
				"official": "Principality of Andorra",
				"native": {
					"cat": {
						"official": "Principat d'Andorra",
						"common": "Andorra"
					}
				}
			},
			"tld": [
				".ad"
			],
			"cca2": "AD",
			"ccn3": "020",
			"cca3": "AND",
			"cioc": "AND",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"376"
			],
			"capital": "Andorra la Vella",
			"altSpellings": [
				"AD",
				"Principality of Andorra",
				"Principat d'Andorra"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"cat": "Catalan"
			},
			"translations": {
				"cym": {
					"official": "Principality of Andorra",
					"common": "Andorra"
				},
				"deu": {
					"official": "Fürstentum Andorra",
					"common": "Andorra"
				},
				"fra": {
					"official": "Principauté d'Andorre",
					"common": "Andorre"
				},
				"hrv": {
					"official": "Kneževina Andora",
					"common": "Andora"
				},
				"ita": {
					"official": "Principato di Andorra",
					"common": "Andorra"
				},
				"jpn": {
					"official": "アンドラ公国",
					"common": "アンドラ"
				},
				"nld": {
					"official": "Prinsdom Andorra",
					"common": "Andorra"
				},
				"por": {
					"official": "Principado de Andorra",
					"common": "Andorra"
				},
				"rus": {
					"official": "Княжество Андорра",
					"common": "Андорра"
				},
				"slk": {
					"official": "Andorrské kniežatstvo",
					"common": "Andorra"
				},
				"spa": {
					"official": "Principado de Andorra",
					"common": "Andorra"
				},
				"fin": {
					"official": "Andorran ruhtinaskunta",
					"common": "Andorra"
				},
				"zho": {
					"official": "安道尔公国",
					"common": "安道尔"
				}
			},
			"latlng": [
				42.5,
				1.5
			],
			"demonym": "Andorran",
			"landlocked": true,
			"borders": [
				"FRA",
				"ESP"
			],
			"area": 468
		},
		{
			"name": {
				"common": "United Arab Emirates",
				"official": "United Arab Emirates",
				"native": {
					"ara": {
						"official": "الإمارات العربية المتحدة",
						"common": "دولة الإمارات العربية المتحدة"
					}
				}
			},
			"tld": [
				".ae",
				"امارات."
			],
			"cca2": "AE",
			"ccn3": "784",
			"cca3": "ARE",
			"cioc": "UAE",
			"currency": [
				"AED"
			],
			"callingCode": [
				"971"
			],
			"capital": "Abu Dhabi",
			"altSpellings": [
				"AE",
				"UAE",
				"Emirates"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Vereinigte Arabische Emirate",
					"common": "Vereinigte Arabische Emirate"
				},
				"fra": {
					"official": "Émirats arabes unis",
					"common": "Émirats arabes unis"
				},
				"hrv": {
					"official": "Ujedinjeni Arapski Emirati",
					"common": "Ujedinjeni Arapski Emirati"
				},
				"ita": {
					"official": "Emirati Arabi Uniti",
					"common": "Emirati Arabi Uniti"
				},
				"jpn": {
					"official": "アラブ首長国連邦",
					"common": "アラブ首長国連邦"
				},
				"nld": {
					"official": "Verenigde Arabische Emiraten",
					"common": "Verenigde Arabische Emiraten"
				},
				"por": {
					"official": "Emirados Árabes Unidos",
					"common": "Emirados Árabes Unidos"
				},
				"rus": {
					"official": "Объединенные Арабские Эмираты",
					"common": "Объединённые Арабские Эмираты"
				},
				"slk": {
					"official": "Spojené arabské emiráty",
					"common": "Spojené arabské emiráty"
				},
				"spa": {
					"official": "Emiratos Árabes Unidos",
					"common": "Emiratos Árabes Unidos"
				},
				"fin": {
					"official": "Yhdistyneet arabiemiirikunnat",
					"common": "Arabiemiraatit"
				},
				"zho": {
					"official": "阿拉伯联合酋长国",
					"common": "阿拉伯联合酋长国"
				}
			},
			"latlng": [
				24,
				54
			],
			"demonym": "Emirati",
			"landlocked": false,
			"borders": [
				"OMN",
				"SAU"
			],
			"area": 83600
		},
		{
			"name": {
				"common": "Argentina",
				"official": "Argentine Republic",
				"native": {
					"grn": {
						"official": "Argentine Republic",
						"common": "Argentina"
					},
					"spa": {
						"official": "República Argentina",
						"common": "Argentina"
					}
				}
			},
			"tld": [
				".ar"
			],
			"cca2": "AR",
			"ccn3": "032",
			"cca3": "ARG",
			"cioc": "ARG",
			"currency": [
				"ARS"
			],
			"callingCode": [
				"54"
			],
			"capital": "Buenos Aires",
			"altSpellings": [
				"AR",
				"Argentine Republic",
				"República Argentina"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"grn": "Guaraní",
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Argentine Republic",
					"common": "Ariannin"
				},
				"deu": {
					"official": "Argentinische Republik",
					"common": "Argentinien"
				},
				"fra": {
					"official": "République argentine",
					"common": "Argentine"
				},
				"hrv": {
					"official": "Argentinski Republika",
					"common": "Argentina"
				},
				"ita": {
					"official": "Repubblica Argentina",
					"common": "Argentina"
				},
				"jpn": {
					"official": "アルゼンチン共和国",
					"common": "アルゼンチン"
				},
				"nld": {
					"official": "Argentijnse Republiek",
					"common": "Argentinië"
				},
				"por": {
					"official": "República Argentina",
					"common": "Argentina"
				},
				"rus": {
					"official": "Аргентинская Республика",
					"common": "Аргентина"
				},
				"slk": {
					"official": "Argentínska republika",
					"common": "Argentína"
				},
				"spa": {
					"official": "República Argentina",
					"common": "Argentina"
				},
				"fin": {
					"official": "Argentiinan tasavalta",
					"common": "Argentiina"
				},
				"zho": {
					"official": "阿根廷共和国",
					"common": "阿根廷"
				}
			},
			"latlng": [
				-34,
				-64
			],
			"demonym": "Argentine",
			"landlocked": false,
			"borders": [
				"BOL",
				"BRA",
				"CHL",
				"PRY",
				"URY"
			],
			"area": 2780400
		},
		{
			"name": {
				"common": "Armenia",
				"official": "Republic of Armenia",
				"native": {
					"hye": {
						"official": "Հայաստանի Հանրապետություն",
						"common": "Հայաստան"
					},
					"rus": {
						"official": "Республика Армения",
						"common": "Армения"
					}
				}
			},
			"tld": [
				".am"
			],
			"cca2": "AM",
			"ccn3": "051",
			"cca3": "ARM",
			"cioc": "ARM",
			"currency": [
				"AMD"
			],
			"callingCode": [
				"374"
			],
			"capital": "Yerevan",
			"altSpellings": [
				"AM",
				"Hayastan",
				"Republic of Armenia",
				"Հայաստանի Հանրապետություն"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"hye": "Armenian",
				"rus": "Russian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Armenia",
					"common": "Armenia"
				},
				"deu": {
					"official": "Republik Armenien",
					"common": "Armenien"
				},
				"fra": {
					"official": "République d'Arménie",
					"common": "Arménie"
				},
				"hrv": {
					"official": "Republika Armenija",
					"common": "Armenija"
				},
				"ita": {
					"official": "Repubblica di Armenia",
					"common": "Armenia"
				},
				"jpn": {
					"official": "アルメニア共和国",
					"common": "アルメニア"
				},
				"nld": {
					"official": "Republiek Armenië",
					"common": "Armenië"
				},
				"por": {
					"official": "República da Arménia",
					"common": "Arménia"
				},
				"rus": {
					"official": "Республика Армения",
					"common": "Армения"
				},
				"slk": {
					"official": "Arménska republika",
					"common": "Arménsko"
				},
				"spa": {
					"official": "República de Armenia",
					"common": "Armenia"
				},
				"fin": {
					"official": "Armenian tasavalta",
					"common": "Armenia"
				},
				"zho": {
					"official": "亚美尼亚共和国",
					"common": "亚美尼亚"
				}
			},
			"latlng": [
				40,
				45
			],
			"demonym": "Armenian",
			"landlocked": true,
			"borders": [
				"AZE",
				"GEO",
				"IRN",
				"TUR"
			],
			"area": 29743
		},
		{
			"name": {
				"common": "American Samoa",
				"official": "American Samoa",
				"native": {
					"eng": {
						"official": "American Samoa",
						"common": "American Samoa"
					},
					"smo": {
						"official": "Sāmoa Amelika",
						"common": "Sāmoa Amelika"
					}
				}
			},
			"tld": [
				".as"
			],
			"cca2": "AS",
			"ccn3": "016",
			"cca3": "ASM",
			"cioc": "ASA",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1684"
			],
			"capital": "Pago Pago",
			"altSpellings": [
				"AS",
				"Amerika Sāmoa",
				"Amelika Sāmoa",
				"Sāmoa Amelika"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"smo": "Samoan"
			},
			"translations": {
				"deu": {
					"official": "Amerikanisch-Samoa",
					"common": "Amerikanisch-Samoa"
				},
				"fra": {
					"official": "Samoa américaines",
					"common": "Samoa américaines"
				},
				"hrv": {
					"official": "američka Samoa",
					"common": "Američka Samoa"
				},
				"ita": {
					"official": "Samoa americane",
					"common": "Samoa Americane"
				},
				"jpn": {
					"official": "米サモア",
					"common": "アメリカ領サモア"
				},
				"nld": {
					"official": "Amerikaans Samoa",
					"common": "Amerikaans Samoa"
				},
				"por": {
					"official": "Samoa americana",
					"common": "Samoa Americana"
				},
				"rus": {
					"official": "американское Самоа",
					"common": "Американское Самоа"
				},
				"slk": {
					"official": "Americká Samoa",
					"common": "Americká Samoa"
				},
				"spa": {
					"official": "Samoa Americana",
					"common": "Samoa Americana"
				},
				"fin": {
					"official": "Amerikan Samoa",
					"common": "Amerikan Samoa"
				},
				"zho": {
					"official": "美属萨摩亚",
					"common": "美属萨摩亚"
				}
			},
			"latlng": [
				-14.33333333,
				-170
			],
			"demonym": "American Samoan",
			"landlocked": false,
			"borders": [],
			"area": 199
		},
		{
			"name": {
				"common": "Antarctica",
				"official": "Antarctica",
				"native": []
			},
			"tld": [
				".aq"
			],
			"cca2": "AQ",
			"ccn3": "010",
			"cca3": "ATA",
			"cioc": "",
			"currency": [],
			"callingCode": [],
			"capital": "",
			"altSpellings": [
				"AQ"
			],
			"region": "",
			"subregion": "",
			"languages": {},
			"translations": {
				"cym": {
					"official": "Antarctica",
					"common": "Antarctica"
				},
				"deu": {
					"official": "Antarktika",
					"common": "Antarktis"
				},
				"fra": {
					"official": "Antarctique",
					"common": "Antarctique"
				},
				"hrv": {
					"official": "Antarktika",
					"common": "Antarktika"
				},
				"ita": {
					"official": "Antartide",
					"common": "Antartide"
				},
				"jpn": {
					"official": "南極大陸",
					"common": "南極"
				},
				"nld": {
					"official": "Antarctica",
					"common": "Antarctica"
				},
				"por": {
					"official": "Antártica",
					"common": "Antártida"
				},
				"rus": {
					"official": "Антарктида",
					"common": "Антарктида"
				},
				"slk": {
					"official": "Antarktída",
					"common": "Antarktída"
				},
				"spa": {
					"official": "Antártida",
					"common": "Antártida"
				},
				"fin": {
					"official": "Etelämanner",
					"common": "Etelämanner"
				},
				"zho": {
					"official": "南极洲",
					"common": "南极洲"
				}
			},
			"latlng": [
				-90,
				0
			],
			"demonym": "Antarctican",
			"landlocked": false,
			"borders": [],
			"area": 14000000
		},
		{
			"name": {
				"common": "French Southern and Antarctic Lands",
				"official": "Territory of the French Southern and Antarctic Lands",
				"native": {
					"fra": {
						"official": "Territoire des Terres australes et antarctiques françaises",
						"common": "Terres australes et antarctiques françaises"
					}
				}
			},
			"tld": [
				".tf"
			],
			"cca2": "TF",
			"ccn3": "260",
			"cca3": "ATF",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [],
			"capital": "Port-aux-Français",
			"altSpellings": [
				"TF",
				"French Southern Territories"
			],
			"region": "",
			"subregion": "",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Gebiet der Französisch Süd-und Antarktisgebiete",
					"common": "Französische Süd-und Antarktisgebiete"
				},
				"fra": {
					"official": "Territoire des Terres australes et antarctiques françaises",
					"common": "Terres australes et antarctiques françaises"
				},
				"hrv": {
					"official": "Teritoriju Francuski južni i antarktički teritoriji",
					"common": "Francuski južni i antarktički teritoriji"
				},
				"ita": {
					"official": "Territorio della australi e antartiche francesi Terre",
					"common": "Territori Francesi del Sud"
				},
				"jpn": {
					"official": "フランス領南方·南極地域の領土",
					"common": "フランス領南方・南極地域"
				},
				"nld": {
					"official": "Grondgebied van de Franse Zuidelijke en Antarctische gebieden",
					"common": "Franse Gebieden in de zuidelijke Indische Oceaan"
				},
				"por": {
					"official": "Território do Sul e Antártica Francesa",
					"common": "Terras Austrais e Antárticas Francesas"
				},
				"rus": {
					"official": "Территория Французские Южные и Антарктические земли",
					"common": "Французские Южные и Антарктические территории"
				},
				"slk": {
					"official": "Francúzske južné a antarktické územia",
					"common": "Francúzske juŽné a antarktické územia"
				},
				"spa": {
					"official": "Territorio del Francés Tierras australes y antárticas",
					"common": "Tierras Australes y Antárticas Francesas"
				},
				"fin": {
					"official": "Ranskan eteläiset ja antarktiset alueet",
					"common": "Ranskan eteläiset ja antarktiset alueet"
				},
				"zho": {
					"official": "法国南部和南极土地",
					"common": "法国南部和南极土地"
				}
			},
			"latlng": [
				-49.25,
				69.167
			],
			"demonym": "French",
			"landlocked": false,
			"borders": [],
			"area": 7747
		},
		{
			"name": {
				"common": "Antigua and Barbuda",
				"official": "Antigua and Barbuda",
				"native": {
					"eng": {
						"official": "Antigua and Barbuda",
						"common": "Antigua and Barbuda"
					}
				}
			},
			"tld": [
				".ag"
			],
			"cca2": "AG",
			"ccn3": "028",
			"cca3": "ATG",
			"cioc": "ANT",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1268"
			],
			"capital": "Saint John's",
			"altSpellings": [
				"AG"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Antigua and Barbuda",
					"common": "Antigwa a Barbiwda"
				},
				"deu": {
					"official": "Antigua und Barbuda",
					"common": "Antigua und Barbuda"
				},
				"fra": {
					"official": "Antigua -et-Barbuda",
					"common": "Antigua-et-Barbuda"
				},
				"hrv": {
					"official": "Antigva i Barbuda",
					"common": "Antigva i Barbuda"
				},
				"ita": {
					"official": "Antigua e Barbuda",
					"common": "Antigua e Barbuda"
				},
				"jpn": {
					"official": "アンチグアバーブーダ",
					"common": "アンティグア・バーブーダ"
				},
				"nld": {
					"official": "Antigua en Barbuda",
					"common": "Antigua en Barbuda"
				},
				"por": {
					"official": "Antigua e Barbuda",
					"common": "Antígua e Barbuda"
				},
				"rus": {
					"official": "Антигуа и Барбуда",
					"common": "Антигуа и Барбуда"
				},
				"slk": {
					"official": "Antigua a Barbuda",
					"common": "Antigua a Barbuda"
				},
				"spa": {
					"official": "Antigua y Barbuda",
					"common": "Antigua y Barbuda"
				},
				"fin": {
					"official": "Antigua ja Barbuda",
					"common": "Antigua ja Barbuda"
				},
				"zho": {
					"official": "安提瓜和巴布达",
					"common": "安提瓜和巴布达"
				}
			},
			"latlng": [
				17.05,
				-61.8
			],
			"demonym": "Antiguan, Barbudan",
			"landlocked": false,
			"borders": [],
			"area": 442
		},
		{
			"name": {
				"common": "Australia",
				"official": "Commonwealth of Australia",
				"native": {
					"eng": {
						"official": "Commonwealth of Australia",
						"common": "Australia"
					}
				}
			},
			"tld": [
				".au"
			],
			"cca2": "AU",
			"ccn3": "036",
			"cca3": "AUS",
			"cioc": "AUS",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"61"
			],
			"capital": "Canberra",
			"altSpellings": [
				"AU"
			],
			"region": "Oceania",
			"subregion": "Australia and New Zealand",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Commonwealth of Australia",
					"common": "Awstralia"
				},
				"deu": {
					"official": "Commonwealth Australien",
					"common": "Australien"
				},
				"fra": {
					"official": "Australie",
					"common": "Australie"
				},
				"hrv": {
					"official": "Commonwealth of Australia",
					"common": "Australija"
				},
				"ita": {
					"official": "Commonwealth dell'Australia",
					"common": "Australia"
				},
				"jpn": {
					"official": "オーストラリア連邦",
					"common": "オーストラリア"
				},
				"nld": {
					"official": "Gemenebest van Australië",
					"common": "Australië"
				},
				"por": {
					"official": "Comunidade da Austrália",
					"common": "Austrália"
				},
				"rus": {
					"official": "Содружество Австралии",
					"common": "Австралия"
				},
				"slk": {
					"official": "Austrálsky zväz",
					"common": "Austrália"
				},
				"spa": {
					"official": "Mancomunidad de Australia",
					"common": "Australia"
				},
				"fin": {
					"official": "Australian liittovaltio",
					"common": "Australia"
				},
				"zho": {
					"official": "澳大利亚联邦",
					"common": "澳大利亚"
				}
			},
			"latlng": [
				-27,
				133
			],
			"demonym": "Australian",
			"landlocked": false,
			"borders": [],
			"area": 7692024
		},
		{
			"name": {
				"common": "Austria",
				"official": "Republic of Austria",
				"native": {
					"bar": {
						"official": "Republik Österreich",
						"common": "Österreich"
					}
				}
			},
			"tld": [
				".at"
			],
			"cca2": "AT",
			"ccn3": "040",
			"cca3": "AUT",
			"cioc": "AUT",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"43"
			],
			"capital": "Vienna",
			"altSpellings": [
				"AT",
				"Osterreich",
				"Oesterreich"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"bar": "Austro-Bavarian German"
			},
			"translations": {
				"cym": {
					"official": "Republic of Austria",
					"common": "Awstria"
				},
				"deu": {
					"official": "Republik Österreich",
					"common": "Österreich"
				},
				"fra": {
					"official": "République d'Autriche",
					"common": "Autriche"
				},
				"hrv": {
					"official": "Republika Austrija",
					"common": "Austrija"
				},
				"ita": {
					"official": "Repubblica d'Austria",
					"common": "Austria"
				},
				"jpn": {
					"official": "オーストリア共和国",
					"common": "オーストリア"
				},
				"nld": {
					"official": "Republiek Oostenrijk",
					"common": "Oostenrijk"
				},
				"por": {
					"official": "República da Áustria",
					"common": "Áustria"
				},
				"rus": {
					"official": "Австрийская Республика",
					"common": "Австрия"
				},
				"slk": {
					"official": "Rakúska republika",
					"common": "Rakúsko"
				},
				"spa": {
					"official": "República de Austria",
					"common": "Austria"
				},
				"fin": {
					"official": "Itävallan tasavalta",
					"common": "Itävalta"
				},
				"zho": {
					"official": "奥地利共和国",
					"common": "奥地利"
				}
			},
			"latlng": [
				47.33333333,
				13.33333333
			],
			"demonym": "Austrian",
			"landlocked": true,
			"borders": [
				"CZE",
				"DEU",
				"HUN",
				"ITA",
				"LIE",
				"SVK",
				"SVN",
				"CHE"
			],
			"area": 83871
		},
		{
			"name": {
				"common": "Azerbaijan",
				"official": "Republic of Azerbaijan",
				"native": {
					"aze": {
						"official": "Azərbaycan Respublikası",
						"common": "Azərbaycan"
					},
					"rus": {
						"official": "Азербайджанская Республика",
						"common": "Азербайджан"
					}
				}
			},
			"tld": [
				".az"
			],
			"cca2": "AZ",
			"ccn3": "031",
			"cca3": "AZE",
			"cioc": "AZE",
			"currency": [
				"AZN"
			],
			"callingCode": [
				"994"
			],
			"capital": "Baku",
			"altSpellings": [
				"AZ",
				"Republic of Azerbaijan",
				"Azərbaycan Respublikası"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"aze": "Azerbaijani",
				"rus": "Russian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Azerbaijan",
					"common": "Aserbaijan"
				},
				"deu": {
					"official": "Republik Aserbaidschan",
					"common": "Aserbaidschan"
				},
				"fra": {
					"official": "République d'Azerbaïdjan",
					"common": "Azerbaïdjan"
				},
				"hrv": {
					"official": "Republika Azerbajdžan",
					"common": "Azerbajdžan"
				},
				"ita": {
					"official": "Repubblica dell'Azerbaigian",
					"common": "Azerbaijan"
				},
				"jpn": {
					"official": "アゼルバイジャン共和国",
					"common": "アゼルバイジャン"
				},
				"nld": {
					"official": "Republiek Azerbeidzjan",
					"common": "Azerbeidzjan"
				},
				"por": {
					"official": "República do Azerbaijão",
					"common": "Azerbeijão"
				},
				"rus": {
					"official": "Азербайджанская Республика",
					"common": "Азербайджан"
				},
				"slk": {
					"official": "Azerbajǆanská republika",
					"common": "AzerbajǇan"
				},
				"spa": {
					"official": "República de Azerbaiyán",
					"common": "Azerbaiyán"
				},
				"fin": {
					"official": "Azerbaidzanin tasavalta",
					"common": "Azerbaidzan"
				},
				"zho": {
					"official": "阿塞拜疆共和国",
					"common": "阿塞拜疆"
				}
			},
			"latlng": [
				40.5,
				47.5
			],
			"demonym": "Azerbaijani",
			"landlocked": true,
			"borders": [
				"ARM",
				"GEO",
				"IRN",
				"RUS",
				"TUR"
			],
			"area": 86600
		},
		{
			"name": {
				"common": "Burundi",
				"official": "Republic of Burundi",
				"native": {
					"fra": {
						"official": "République du Burundi",
						"common": "Burundi"
					},
					"run": {
						"official": "Republika y'Uburundi ",
						"common": "Uburundi"
					}
				}
			},
			"tld": [
				".bi"
			],
			"cca2": "BI",
			"ccn3": "108",
			"cca3": "BDI",
			"cioc": "BDI",
			"currency": [
				"BIF"
			],
			"callingCode": [
				"257"
			],
			"capital": "Bujumbura",
			"altSpellings": [
				"BI",
				"Republic of Burundi",
				"Republika y'Uburundi",
				"République du Burundi"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"fra": "French",
				"run": "Kirundi"
			},
			"translations": {
				"cym": {
					"official": "Republic of Burundi",
					"common": "Bwrwndi"
				},
				"deu": {
					"official": "Republik Burundi",
					"common": "Burundi"
				},
				"fra": {
					"official": "République du Burundi",
					"common": "Burundi"
				},
				"hrv": {
					"official": "Burundi",
					"common": "Burundi"
				},
				"ita": {
					"official": "Repubblica del Burundi",
					"common": "Burundi"
				},
				"jpn": {
					"official": "ブルンジ共和国",
					"common": "ブルンジ"
				},
				"nld": {
					"official": "Republiek Burundi",
					"common": "Burundi"
				},
				"por": {
					"official": "República do Burundi",
					"common": "Burundi"
				},
				"rus": {
					"official": "Республика Бурунди",
					"common": "Бурунди"
				},
				"slk": {
					"official": "Burundská republika",
					"common": "Burundi"
				},
				"spa": {
					"official": "República de Burundi",
					"common": "Burundi"
				},
				"fin": {
					"official": "Burundin tasavalta",
					"common": "Burundi"
				},
				"zho": {
					"official": "布隆迪共和国",
					"common": "布隆迪"
				}
			},
			"latlng": [
				-3.5,
				30
			],
			"demonym": "Burundian",
			"landlocked": true,
			"borders": [
				"COD",
				"RWA",
				"TZA"
			],
			"area": 27834
		},
		{
			"name": {
				"common": "Belgium",
				"official": "Kingdom of Belgium",
				"native": {
					"deu": {
						"official": "Königreich Belgien",
						"common": "Belgien"
					},
					"fra": {
						"official": "Royaume de Belgique",
						"common": "Belgique"
					},
					"nld": {
						"official": "Koninkrijk België",
						"common": "België"
					}
				}
			},
			"tld": [
				".be"
			],
			"cca2": "BE",
			"ccn3": "056",
			"cca3": "BEL",
			"cioc": "BEL",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"32"
			],
			"capital": "Brussels",
			"altSpellings": [
				"BE",
				"België",
				"Belgie",
				"Belgien",
				"Belgique",
				"Kingdom of Belgium",
				"Koninkrijk België",
				"Royaume de Belgique",
				"Königreich Belgien"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"deu": "German",
				"fra": "French",
				"nld": "Dutch"
			},
			"translations": {
				"cym": {
					"official": "Kingdom of Belgium",
					"common": "Gwlad Belg"
				},
				"deu": {
					"official": "Königreich Belgien",
					"common": "Belgien"
				},
				"fra": {
					"official": "Royaume de Belgique",
					"common": "Belgique"
				},
				"hrv": {
					"official": "Kraljevina Belgija",
					"common": "Belgija"
				},
				"ita": {
					"official": "Regno del Belgio",
					"common": "Belgio"
				},
				"jpn": {
					"official": "ベルギー王国",
					"common": "ベルギー"
				},
				"nld": {
					"official": "Koninkrijk België",
					"common": "België"
				},
				"por": {
					"official": "Reino da Bélgica",
					"common": "Bélgica"
				},
				"rus": {
					"official": "Королевство Бельгия",
					"common": "Бельгия"
				},
				"slk": {
					"official": "Belgické kráľovstvo",
					"common": "Belgicko"
				},
				"spa": {
					"official": "Reino de Bélgica",
					"common": "Bélgica"
				},
				"fin": {
					"official": "Belgian kuningaskunta",
					"common": "Belgia"
				},
				"zho": {
					"official": "比利时王国",
					"common": "比利时"
				}
			},
			"latlng": [
				50.83333333,
				4
			],
			"demonym": "Belgian",
			"landlocked": false,
			"borders": [
				"FRA",
				"DEU",
				"LUX",
				"NLD"
			],
			"area": 30528
		},
		{
			"name": {
				"common": "Benin",
				"official": "Republic of Benin",
				"native": {
					"fra": {
						"official": "République du Bénin",
						"common": "Bénin"
					}
				}
			},
			"tld": [
				".bj"
			],
			"cca2": "BJ",
			"ccn3": "204",
			"cca3": "BEN",
			"cioc": "BEN",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"229"
			],
			"capital": "Porto-Novo",
			"altSpellings": [
				"BJ",
				"Republic of Benin",
				"République du Bénin"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Republic of Benin",
					"common": "Benin"
				},
				"deu": {
					"official": "Republik Benin",
					"common": "Benin"
				},
				"fra": {
					"official": "République du Bénin",
					"common": "Bénin"
				},
				"hrv": {
					"official": "Republika Benin",
					"common": "Benin"
				},
				"ita": {
					"official": "Repubblica del Benin",
					"common": "Benin"
				},
				"jpn": {
					"official": "ベナン共和国",
					"common": "ベナン"
				},
				"nld": {
					"official": "Republiek Benin",
					"common": "Benin"
				},
				"por": {
					"official": "República do Benin",
					"common": "Benin"
				},
				"rus": {
					"official": "Республика Бенин",
					"common": "Бенин"
				},
				"slk": {
					"official": "Beninská republika",
					"common": "Benin"
				},
				"spa": {
					"official": "República de Benin",
					"common": "Benín"
				},
				"fin": {
					"official": "Beninin tasavalta",
					"common": "Benin"
				},
				"zho": {
					"official": "贝宁共和国",
					"common": "贝宁"
				}
			},
			"latlng": [
				9.5,
				2.25
			],
			"demonym": "Beninese",
			"landlocked": false,
			"borders": [
				"BFA",
				"NER",
				"NGA",
				"TGO"
			],
			"area": 112622
		},
		{
			"name": {
				"common": "Burkina Faso",
				"official": "Burkina Faso",
				"native": {
					"fra": {
						"official": "République du Burkina",
						"common": "Burkina Faso"
					}
				}
			},
			"tld": [
				".bf"
			],
			"cca2": "BF",
			"ccn3": "854",
			"cca3": "BFA",
			"cioc": "BUR",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"226"
			],
			"capital": "Ouagadougou",
			"altSpellings": [
				"BF"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"deu": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"fra": {
					"official": "République du Burkina",
					"common": "Burkina Faso"
				},
				"hrv": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"ita": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"jpn": {
					"official": "ブルキナファソ",
					"common": "ブルキナファソ"
				},
				"nld": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"por": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"rus": {
					"official": "Буркина -Фасо",
					"common": "Буркина-Фасо"
				},
				"slk": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"spa": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"fin": {
					"official": "Burkina Faso",
					"common": "Burkina Faso"
				},
				"zho": {
					"official": "布基纳法索",
					"common": "布基纳法索"
				}
			},
			"latlng": [
				13,
				-2
			],
			"demonym": "Burkinabe",
			"landlocked": true,
			"borders": [
				"BEN",
				"CIV",
				"GHA",
				"MLI",
				"NER",
				"TGO"
			],
			"area": 272967
		},
		{
			"name": {
				"common": "Bangladesh",
				"official": "People's Republic of Bangladesh",
				"native": {
					"ben": {
						"official": "বাংলাদেশ গণপ্রজাতন্ত্রী",
						"common": "বাংলাদেশ"
					}
				}
			},
			"tld": [
				".bd"
			],
			"cca2": "BD",
			"ccn3": "050",
			"cca3": "BGD",
			"cioc": "BAN",
			"currency": [
				"BDT"
			],
			"callingCode": [
				"880"
			],
			"capital": "Dhaka",
			"altSpellings": [
				"BD",
				"People's Republic of Bangladesh",
				"Gônôprôjatôntri Bangladesh"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"ben": "Bengali"
			},
			"translations": {
				"cym": {
					"official": "People's Republic of Bangladesh",
					"common": "Bangladesh"
				},
				"deu": {
					"official": "Volksrepublik Bangladesch",
					"common": "Bangladesch"
				},
				"fra": {
					"official": "La République populaire du Bangladesh",
					"common": "Bangladesh"
				},
				"hrv": {
					"official": "Narodna Republika Bangladeš",
					"common": "Bangladeš"
				},
				"ita": {
					"official": "Repubblica popolare del Bangladesh",
					"common": "Bangladesh"
				},
				"jpn": {
					"official": "バングラデシュ人民共和国",
					"common": "バングラデシュ"
				},
				"nld": {
					"official": "Volksrepubliek Bangladesh",
					"common": "Bangladesh"
				},
				"por": {
					"official": "República Popular do Bangladesh",
					"common": "Bangladesh"
				},
				"rus": {
					"official": "Народная Республика Бангладеш",
					"common": "Бангладеш"
				},
				"slk": {
					"official": "Bangladéšska ľudová republika",
					"common": "Bangladéš"
				},
				"spa": {
					"official": "República Popular de Bangladesh",
					"common": "Bangladesh"
				},
				"fin": {
					"official": "Bangladeshin kansantasavalta",
					"common": "Bangladesh"
				},
				"zho": {
					"official": "孟加拉人民共和国",
					"common": "孟加拉国"
				}
			},
			"latlng": [
				24,
				90
			],
			"demonym": "Bangladeshi",
			"landlocked": false,
			"borders": [
				"MMR",
				"IND"
			],
			"area": 147570
		},
		{
			"name": {
				"common": "Bulgaria",
				"official": "Republic of Bulgaria",
				"native": {
					"bul": {
						"official": "Република България",
						"common": "България"
					}
				}
			},
			"tld": [
				".bg"
			],
			"cca2": "BG",
			"ccn3": "100",
			"cca3": "BGR",
			"cioc": "BUL",
			"currency": [
				"BGN"
			],
			"callingCode": [
				"359"
			],
			"capital": "Sofia",
			"altSpellings": [
				"BG",
				"Republic of Bulgaria",
				"Република България"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"bul": "Bulgarian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Bulgaria",
					"common": "Bwlgaria"
				},
				"deu": {
					"official": "Republik Bulgarien",
					"common": "Bulgarien"
				},
				"fra": {
					"official": "République de Bulgarie",
					"common": "Bulgarie"
				},
				"hrv": {
					"official": "Republika Bugarska",
					"common": "Bugarska"
				},
				"ita": {
					"official": "Repubblica di Bulgaria",
					"common": "Bulgaria"
				},
				"jpn": {
					"official": "ブルガリア共和国",
					"common": "ブルガリア"
				},
				"nld": {
					"official": "Republiek Bulgarije",
					"common": "Bulgarije"
				},
				"por": {
					"official": "República da Bulgária",
					"common": "Bulgária"
				},
				"rus": {
					"official": "Республика Болгария",
					"common": "Болгария"
				},
				"slk": {
					"official": "Bulharská republika",
					"common": "Bulharsko"
				},
				"spa": {
					"official": "República de Bulgaria",
					"common": "Bulgaria"
				},
				"fin": {
					"official": "Bulgarian tasavalta",
					"common": "Bulgaria"
				},
				"zho": {
					"official": "保加利亚共和国",
					"common": "保加利亚"
				}
			},
			"latlng": [
				43,
				25
			],
			"demonym": "Bulgarian",
			"landlocked": false,
			"borders": [
				"GRC",
				"MKD",
				"ROU",
				"SRB",
				"TUR"
			],
			"area": 110879
		},
		{
			"name": {
				"common": "Bahrain",
				"official": "Kingdom of Bahrain",
				"native": {
					"ara": {
						"official": "مملكة البحرين",
						"common": "‏البحرين"
					}
				}
			},
			"tld": [
				".bh"
			],
			"cca2": "BH",
			"ccn3": "048",
			"cca3": "BHR",
			"cioc": "BRN",
			"currency": [
				"BHD"
			],
			"callingCode": [
				"973"
			],
			"capital": "Manama",
			"altSpellings": [
				"BH",
				"Kingdom of Bahrain",
				"Mamlakat al-Baḥrayn"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"cym": {
					"official": "Kingdom of Bahrain",
					"common": "Bahrain"
				},
				"deu": {
					"official": "Königreich Bahrain",
					"common": "Bahrain"
				},
				"fra": {
					"official": "Royaume de Bahreïn",
					"common": "Bahreïn"
				},
				"hrv": {
					"official": "Kraljevina Bahrein",
					"common": "Bahrein"
				},
				"ita": {
					"official": "Regno del Bahrain",
					"common": "Bahrein"
				},
				"jpn": {
					"official": "バーレーン王国",
					"common": "バーレーン"
				},
				"nld": {
					"official": "Koninkrijk Bahrein",
					"common": "Bahrein"
				},
				"por": {
					"official": "Reino do Bahrein",
					"common": "Bahrein"
				},
				"rus": {
					"official": "Королевство Бахрейн",
					"common": "Бахрейн"
				},
				"slk": {
					"official": "Bahrajnské kráľovstvo",
					"common": "Bahrajn"
				},
				"spa": {
					"official": "Reino de Bahrein",
					"common": "Bahrein"
				},
				"fin": {
					"official": "Bahrainin kuningaskunta",
					"common": "Bahrain"
				},
				"zho": {
					"official": "巴林王国",
					"common": "巴林"
				}
			},
			"latlng": [
				26,
				50.55
			],
			"demonym": "Bahraini",
			"landlocked": false,
			"borders": [],
			"area": 765
		},
		{
			"name": {
				"common": "Bahamas",
				"official": "Commonwealth of the Bahamas",
				"native": {
					"eng": {
						"official": "Commonwealth of the Bahamas",
						"common": "Bahamas"
					}
				}
			},
			"tld": [
				".bs"
			],
			"cca2": "BS",
			"ccn3": "044",
			"cca3": "BHS",
			"cioc": "BAH",
			"currency": [
				"BSD"
			],
			"callingCode": [
				"1242"
			],
			"capital": "Nassau",
			"altSpellings": [
				"BS",
				"Commonwealth of the Bahamas"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Commonwealth of the Bahamas",
					"common": "Bahamas"
				},
				"deu": {
					"official": "Commonwealth der Bahamas",
					"common": "Bahamas"
				},
				"fra": {
					"official": "Commonwealth des Bahamas",
					"common": "Bahamas"
				},
				"hrv": {
					"official": "Zajednica Bahama",
					"common": "Bahami"
				},
				"ita": {
					"official": "Commonwealth delle Bahamas",
					"common": "Bahamas"
				},
				"jpn": {
					"official": "バハマ",
					"common": "バハマ"
				},
				"nld": {
					"official": "Gemenebest van de Bahama's",
					"common": "Bahama’s"
				},
				"por": {
					"official": "Comunidade das Bahamas",
					"common": "Bahamas"
				},
				"rus": {
					"official": "Содружество Багамских Островов",
					"common": "Багамские Острова"
				},
				"slk": {
					"official": "Bahamské spoločenstvo",
					"common": "Bahamy"
				},
				"spa": {
					"official": "Commonwealth de las Bahamas",
					"common": "Bahamas"
				},
				"fin": {
					"official": "Bahaman liittovaltio",
					"common": "Bahamasaaret"
				},
				"zho": {
					"official": "巴哈马联邦",
					"common": "巴哈马"
				}
			},
			"latlng": [
				24.25,
				-76
			],
			"demonym": "Bahamian",
			"landlocked": false,
			"borders": [],
			"area": 13943
		},
		{
			"name": {
				"common": "Bosnia and Herzegovina",
				"official": "Bosnia and Herzegovina",
				"native": {
					"bos": {
						"official": "Bosna i Hercegovina",
						"common": "Bosna i Hercegovina"
					},
					"hrv": {
						"official": "Bosna i Hercegovina",
						"common": "Bosna i Hercegovina"
					},
					"srp": {
						"official": "Боснa и Херцеговина",
						"common": "Боснa и Херцеговина"
					}
				}
			},
			"tld": [
				".ba"
			],
			"cca2": "BA",
			"ccn3": "070",
			"cca3": "BIH",
			"cioc": "BIH",
			"currency": [
				"BAM"
			],
			"callingCode": [
				"387"
			],
			"capital": "Sarajevo",
			"altSpellings": [
				"BA",
				"Bosnia-Herzegovina",
				"Босна и Херцеговина"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"bos": "Bosnian",
				"hrv": "Croatian",
				"srp": "Serbian"
			},
			"translations": {
				"cym": {
					"official": "Bosnia and Herzegovina",
					"common": "Bosnia a Hercegovina"
				},
				"deu": {
					"official": "Bosnien und Herzegowina",
					"common": "Bosnien und Herzegowina"
				},
				"fra": {
					"official": "Bosnie-et-Herzégovine",
					"common": "Bosnie-Herzégovine"
				},
				"hrv": {
					"official": "Bosna i Hercegovina",
					"common": "Bosna i Hercegovina"
				},
				"ita": {
					"official": "Bosnia-Erzegovina",
					"common": "Bosnia ed Erzegovina"
				},
				"jpn": {
					"official": "ボスニア·ヘルツェゴビナ",
					"common": "ボスニア・ヘルツェゴビナ"
				},
				"nld": {
					"official": "Bosnië-Herzegovina",
					"common": "Bosnië en Herzegovina"
				},
				"por": {
					"official": "Bósnia e Herzegovina",
					"common": "Bósnia e Herzegovina"
				},
				"rus": {
					"official": "Босния и Герцеговина",
					"common": "Босния и Герцеговина"
				},
				"slk": {
					"official": "Republika Bosny a Hercegoviny",
					"common": "Bosna a Hercegovina"
				},
				"spa": {
					"official": "Bosnia y Herzegovina",
					"common": "Bosnia y Herzegovina"
				},
				"fin": {
					"official": "Bosnia ja Hertsegovina",
					"common": "Bosnia ja Hertsegovina"
				},
				"zho": {
					"official": "波斯尼亚和黑塞哥维那",
					"common": "波斯尼亚和黑塞哥维那"
				}
			},
			"latlng": [
				44,
				18
			],
			"demonym": "Bosnian, Herzegovinian",
			"landlocked": false,
			"borders": [
				"HRV",
				"MNE",
				"SRB"
			],
			"area": 51209
		},
		{
			"name": {
				"common": "Saint Barthélemy",
				"official": "Collectivity of Saint Barthélemy",
				"native": {
					"fra": {
						"official": "Collectivité de Saint-Barthélemy",
						"common": "Saint-Barthélemy"
					}
				}
			},
			"tld": [
				".bl"
			],
			"cca2": "BL",
			"ccn3": "652",
			"cca3": "BLM",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"590"
			],
			"capital": "Gustavia",
			"altSpellings": [
				"BL",
				"St. Barthelemy",
				"Collectivity of Saint Barthélemy",
				"Collectivité de Saint-Barthélemy"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Gebietskörperschaft Saint -Barthélemy",
					"common": "Saint-Barthélemy"
				},
				"fra": {
					"official": "Collectivité de Saint-Barthélemy",
					"common": "Saint-Barthélemy"
				},
				"hrv": {
					"official": "Kolektivnost sv Barthélemy",
					"common": "Saint Barthélemy"
				},
				"ita": {
					"official": "Collettività di Saint Barthélemy",
					"common": "Antille Francesi"
				},
				"jpn": {
					"official": "サン·バルテルミー島の集合体",
					"common": "サン・バルテルミー"
				},
				"nld": {
					"official": "Gemeenschap Saint Barthélemy",
					"common": "Saint Barthélemy"
				},
				"por": {
					"official": "Coletividade de Saint Barthélemy",
					"common": "São Bartolomeu"
				},
				"rus": {
					"official": "Коллективность Санкт -Бартельми",
					"common": "Сен-Бартелеми"
				},
				"slk": {
					"official": "Svätý Bartolomej",
					"common": "Svätý Bartolomej"
				},
				"spa": {
					"official": "Colectividad de San Barthélemy",
					"common": "San Bartolomé"
				},
				"fin": {
					"official": "Saint-Barthélemyn yhteisö",
					"common": "Saint-Barthélemy"
				},
				"zho": {
					"official": "圣巴泰勒米集体",
					"common": "圣巴泰勒米"
				}
			},
			"latlng": [
				18.5,
				-63.41666666
			],
			"demonym": "Saint Barthélemy Islander",
			"landlocked": false,
			"borders": [],
			"area": 21
		},
		{
			"name": {
				"common": "Belarus",
				"official": "Republic of Belarus",
				"native": {
					"bel": {
						"official": "Рэспубліка Беларусь",
						"common": "Белару́сь"
					},
					"rus": {
						"official": "Республика Беларусь",
						"common": "Беларусь"
					}
				}
			},
			"tld": [
				".by"
			],
			"cca2": "BY",
			"ccn3": "112",
			"cca3": "BLR",
			"cioc": "BLR",
			"currency": [
				"BYN"
			],
			"callingCode": [
				"375"
			],
			"capital": "Minsk",
			"altSpellings": [
				"BY",
				"Bielaruś",
				"Republic of Belarus",
				"Белоруссия",
				"Республика Белоруссия"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"bel": "Belarusian",
				"rus": "Russian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Belarus",
					"common": "Belarws"
				},
				"deu": {
					"official": "Republik Belarus",
					"common": "Weißrussland"
				},
				"fra": {
					"official": "République de Biélorussie",
					"common": "Biélorussie"
				},
				"hrv": {
					"official": "Republika Bjelorusija",
					"common": "Bjelorusija"
				},
				"ita": {
					"official": "Repubblica di Belarus",
					"common": "Bielorussia"
				},
				"jpn": {
					"official": "ベラルーシ共和国",
					"common": "ベラルーシ"
				},
				"nld": {
					"official": "Republiek Belarus",
					"common": "Wit-Rusland"
				},
				"por": {
					"official": "República da Bielorrússia",
					"common": "Bielorússia"
				},
				"rus": {
					"official": "Республика Беларусь",
					"common": "Беларусь"
				},
				"slk": {
					"official": "Bieloruská republika",
					"common": "Bielorusko"
				},
				"spa": {
					"official": "República de Belarús",
					"common": "Bielorrusia"
				},
				"fin": {
					"official": "Valko-Venäjän tasavalta",
					"common": "Valko-Venäjä"
				},
				"zho": {
					"official": "白俄罗斯共和国",
					"common": "白俄罗斯"
				}
			},
			"latlng": [
				53,
				28
			],
			"demonym": "Belarusian",
			"landlocked": true,
			"borders": [
				"LVA",
				"LTU",
				"POL",
				"RUS",
				"UKR"
			],
			"area": 207600
		},
		{
			"name": {
				"common": "Belize",
				"official": "Belize",
				"native": {
					"bjz": {
						"official": "Belize",
						"common": "Belize"
					},
					"eng": {
						"official": "Belize",
						"common": "Belize"
					},
					"spa": {
						"official": "Belice",
						"common": "Belice"
					}
				}
			},
			"tld": [
				".bz"
			],
			"cca2": "BZ",
			"ccn3": "084",
			"cca3": "BLZ",
			"cioc": "BIZ",
			"currency": [
				"BZD"
			],
			"callingCode": [
				"501"
			],
			"capital": "Belmopan",
			"altSpellings": [
				"BZ"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"bjz": "Belizean Creole",
				"eng": "English",
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Belize",
					"common": "Belize"
				},
				"deu": {
					"official": "Belize",
					"common": "Belize"
				},
				"fra": {
					"official": "Belize",
					"common": "Belize"
				},
				"hrv": {
					"official": "Belize",
					"common": "Belize"
				},
				"ita": {
					"official": "Belize",
					"common": "Belize"
				},
				"jpn": {
					"official": "ベリーズ",
					"common": "ベリーズ"
				},
				"nld": {
					"official": "Belize",
					"common": "Belize"
				},
				"por": {
					"official": "Belize",
					"common": "Belize"
				},
				"rus": {
					"official": "Белиз",
					"common": "Белиз"
				},
				"slk": {
					"official": "Belize",
					"common": "Belize"
				},
				"spa": {
					"official": "Belice",
					"common": "Belice"
				},
				"fin": {
					"official": "Belize",
					"common": "Belize"
				},
				"zho": {
					"official": "伯利兹",
					"common": "伯利兹"
				}
			},
			"latlng": [
				17.25,
				-88.75
			],
			"demonym": "Belizean",
			"landlocked": false,
			"borders": [
				"GTM",
				"MEX"
			],
			"area": 22966
		},
		{
			"name": {
				"common": "Bermuda",
				"official": "Bermuda",
				"native": {
					"eng": {
						"official": "Bermuda",
						"common": "Bermuda"
					}
				}
			},
			"tld": [
				".bm"
			],
			"cca2": "BM",
			"ccn3": "060",
			"cca3": "BMU",
			"cioc": "BER",
			"currency": [
				"BMD"
			],
			"callingCode": [
				"1441"
			],
			"capital": "Hamilton",
			"altSpellings": [
				"BM",
				"The Islands of Bermuda",
				"The Bermudas",
				"Somers Isles"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Bermuda",
					"common": "Bermiwda"
				},
				"deu": {
					"official": "Bermuda",
					"common": "Bermuda"
				},
				"fra": {
					"official": "Bermudes",
					"common": "Bermudes"
				},
				"hrv": {
					"official": "Bermuda",
					"common": "Bermudi"
				},
				"ita": {
					"official": "Bermuda",
					"common": "Bermuda"
				},
				"jpn": {
					"official": "バミューダ",
					"common": "バミューダ"
				},
				"nld": {
					"official": "Bermuda",
					"common": "Bermuda"
				},
				"por": {
					"official": "Bermudas",
					"common": "Bermudas"
				},
				"rus": {
					"official": "Бермудские острова",
					"common": "Бермудские Острова"
				},
				"slk": {
					"official": "Bermudy",
					"common": "Bermudy"
				},
				"spa": {
					"official": "Bermuda",
					"common": "Bermudas"
				},
				"fin": {
					"official": "Bermuda",
					"common": "Bermuda"
				},
				"zho": {
					"official": "百慕大",
					"common": "百慕大"
				}
			},
			"latlng": [
				32.33333333,
				-64.75
			],
			"demonym": "Bermudian",
			"landlocked": false,
			"borders": [],
			"area": 54
		},
		{
			"name": {
				"common": "Bolivia",
				"official": "Plurinational State of Bolivia",
				"native": {
					"aym": {
						"official": "Wuliwya Suyu",
						"common": "Wuliwya"
					},
					"grn": {
						"official": "Tetã Volívia",
						"common": "Volívia"
					},
					"que": {
						"official": "Buliwya Mamallaqta",
						"common": "Buliwya"
					},
					"spa": {
						"official": "Estado Plurinacional de Bolivia",
						"common": "Bolivia"
					}
				}
			},
			"tld": [
				".bo"
			],
			"cca2": "BO",
			"ccn3": "068",
			"cca3": "BOL",
			"cioc": "BOL",
			"currency": [
				"BOB",
				"BOV"
			],
			"callingCode": [
				"591"
			],
			"capital": "Sucre",
			"altSpellings": [
				"BO",
				"Buliwya",
				"Wuliwya",
				"Bolivia, Plurinational State of",
				"Plurinational State of Bolivia",
				"Estado Plurinacional de Bolivia",
				"Buliwya Mamallaqta",
				"Wuliwya Suyu",
				"Tetã Volívia"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"aym": "Aymara",
				"grn": "Guaraní",
				"que": "Quechua",
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Plurinational State of Bolivia",
					"common": "Bolifia"
				},
				"deu": {
					"official": "Multinationaler Staat von Bolivien",
					"common": "Bolivien"
				},
				"fra": {
					"official": "État plurinational de Bolivie",
					"common": "Bolivie"
				},
				"hrv": {
					"official": "Plurinational State of Bolivia",
					"common": "Bolivija"
				},
				"ita": {
					"official": "Stato Plurinazionale della Bolivia",
					"common": "Bolivia"
				},
				"jpn": {
					"official": "ボリビアの多民族国",
					"common": "ボリビア多民族国"
				},
				"nld": {
					"official": "Plurinationale Staat van Bolivia",
					"common": "Bolivia"
				},
				"por": {
					"official": "Estado Plurinacional da Bolívia",
					"common": "Bolívia"
				},
				"rus": {
					"official": "Многонациональное Государство Боливия",
					"common": "Боливия"
				},
				"slk": {
					"official": "Bolívijská republika",
					"common": "Bolívia"
				},
				"spa": {
					"official": "Estado Plurinacional de Bolivia",
					"common": "Bolivia"
				},
				"fin": {
					"official": "Bolivian monikansainen valtio",
					"common": "Bolivia"
				},
				"zho": {
					"official": "多民族玻利维亚国",
					"common": "玻利维亚"
				}
			},
			"latlng": [
				-17,
				-65
			],
			"demonym": "Bolivian",
			"landlocked": true,
			"borders": [
				"ARG",
				"BRA",
				"CHL",
				"PRY",
				"PER"
			],
			"area": 1098581
		},
		{
			"name": {
				"common": "Brazil",
				"official": "Federative Republic of Brazil",
				"native": {
					"por": {
						"official": "República Federativa do Brasil",
						"common": "Brasil"
					}
				}
			},
			"tld": [
				".br"
			],
			"cca2": "BR",
			"ccn3": "076",
			"cca3": "BRA",
			"cioc": "BRA",
			"currency": [
				"BRL"
			],
			"callingCode": [
				"55"
			],
			"capital": "Brasília",
			"altSpellings": [
				"BR",
				"Brasil",
				"Federative Republic of Brazil",
				"República Federativa do Brasil"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"cym": {
					"official": "Federative Republic of Brazil",
					"common": "Brasil"
				},
				"deu": {
					"official": "Föderative Republik Brasilien",
					"common": "Brasilien"
				},
				"fra": {
					"official": "République fédérative du Brésil",
					"common": "Brésil"
				},
				"hrv": {
					"official": "Savezne Republike Brazil",
					"common": "Brazil"
				},
				"ita": {
					"official": "Repubblica federativa del Brasile",
					"common": "Brasile"
				},
				"jpn": {
					"official": "ブラジル連邦共和国",
					"common": "ブラジル"
				},
				"nld": {
					"official": "Federale Republiek Brazilië",
					"common": "Brazilië"
				},
				"por": {
					"official": "República Federativa do Brasil",
					"common": "Brasil"
				},
				"rus": {
					"official": "Федеративная Республика Бразилия",
					"common": "Бразилия"
				},
				"slk": {
					"official": "Brazílska federatívna republika",
					"common": "Brazília"
				},
				"spa": {
					"official": "República Federativa del Brasil",
					"common": "Brasil"
				},
				"fin": {
					"official": "Brasilian liittotasavalta",
					"common": "Brasilia"
				},
				"zho": {
					"official": "巴西联邦共和国",
					"common": "巴西"
				}
			},
			"latlng": [
				-10,
				-55
			],
			"demonym": "Brazilian",
			"landlocked": false,
			"borders": [
				"ARG",
				"BOL",
				"COL",
				"GUF",
				"GUY",
				"PRY",
				"PER",
				"SUR",
				"URY",
				"VEN"
			],
			"area": 8515767
		},
		{
			"name": {
				"common": "Barbados",
				"official": "Barbados",
				"native": {
					"eng": {
						"official": "Barbados",
						"common": "Barbados"
					}
				}
			},
			"tld": [
				".bb"
			],
			"cca2": "BB",
			"ccn3": "052",
			"cca3": "BRB",
			"cioc": "BAR",
			"currency": [
				"BBD"
			],
			"callingCode": [
				"1246"
			],
			"capital": "Bridgetown",
			"altSpellings": [
				"BB"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"deu": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"fra": {
					"official": "Barbade",
					"common": "Barbade"
				},
				"hrv": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"ita": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"jpn": {
					"official": "バルバドス",
					"common": "バルバドス"
				},
				"nld": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"por": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"rus": {
					"official": "Барбадос",
					"common": "Барбадос"
				},
				"slk": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"spa": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"fin": {
					"official": "Barbados",
					"common": "Barbados"
				},
				"zho": {
					"official": "巴巴多斯",
					"common": "巴巴多斯"
				}
			},
			"latlng": [
				13.16666666,
				-59.53333333
			],
			"demonym": "Barbadian",
			"landlocked": false,
			"borders": [],
			"area": 430
		},
		{
			"name": {
				"common": "Brunei",
				"official": "Nation of Brunei, Abode of Peace",
				"native": {
					"msa": {
						"official": "Nation of Brunei, Abode Damai",
						"common": "Negara Brunei Darussalam"
					}
				}
			},
			"tld": [
				".bn"
			],
			"cca2": "BN",
			"ccn3": "096",
			"cca3": "BRN",
			"cioc": "BRU",
			"currency": [
				"BND"
			],
			"callingCode": [
				"673"
			],
			"capital": "Bandar Seri Begawan",
			"altSpellings": [
				"BN",
				"Brunei Darussalam",
				"Nation of Brunei",
				"the Abode of Peace"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"msa": "Malay"
			},
			"translations": {
				"cym": {
					"official": "Nation of Brunei, Abode of Peace",
					"common": "Brunei"
				},
				"deu": {
					"official": "Nation von Brunei, Wohnung des Friedens",
					"common": "Brunei"
				},
				"fra": {
					"official": "État de Brunei Darussalam",
					"common": "Brunei"
				},
				"hrv": {
					"official": "Nacija od Bruneja, Kuću Mira",
					"common": "Brunej"
				},
				"ita": {
					"official": "Nazione di Brunei, Dimora della Pace",
					"common": "Brunei"
				},
				"jpn": {
					"official": "ブルネイ、平和の精舎の国家",
					"common": "ブルネイ・ダルサラーム"
				},
				"nld": {
					"official": "Natie van Brunei, de verblijfplaats van de Vrede",
					"common": "Brunei"
				},
				"por": {
					"official": "Nação do Brunei, Morada da Paz",
					"common": "Brunei"
				},
				"rus": {
					"official": "Нация Бруней, обитель мира",
					"common": "Бруней"
				},
				"slk": {
					"official": "Brunejský sultanât",
					"common": "Brunej"
				},
				"spa": {
					"official": "Nación de Brunei, Morada de la Paz",
					"common": "Brunei"
				},
				"fin": {
					"official": "Brunei Darussalamin valtio",
					"common": "Brunei"
				},
				"zho": {
					"official": "文莱和平之国",
					"common": "文莱"
				}
			},
			"latlng": [
				4.5,
				114.66666666
			],
			"demonym": "Bruneian",
			"landlocked": false,
			"borders": [
				"MYS"
			],
			"area": 5765
		},
		{
			"name": {
				"common": "Bhutan",
				"official": "Kingdom of Bhutan",
				"native": {
					"dzo": {
						"official": "འབྲུག་རྒྱལ་ཁབ་",
						"common": "འབྲུག་ཡུལ་"
					}
				}
			},
			"tld": [
				".bt"
			],
			"cca2": "BT",
			"ccn3": "064",
			"cca3": "BTN",
			"cioc": "BHU",
			"currency": [
				"BTN",
				"INR"
			],
			"callingCode": [
				"975"
			],
			"capital": "Thimphu",
			"altSpellings": [
				"BT",
				"Kingdom of Bhutan"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"dzo": "Dzongkha"
			},
			"translations": {
				"cym": {
					"official": "Kingdom of Bhutan",
					"common": "Bhwtan"
				},
				"deu": {
					"official": "Königreich Bhutan",
					"common": "Bhutan"
				},
				"fra": {
					"official": "Royaume du Bhoutan",
					"common": "Bhoutan"
				},
				"hrv": {
					"official": "Kraljevina Butan",
					"common": "Butan"
				},
				"ita": {
					"official": "Regno del Bhutan",
					"common": "Bhutan"
				},
				"jpn": {
					"official": "ブータン王国",
					"common": "ブータン"
				},
				"nld": {
					"official": "Koninkrijk Bhutan",
					"common": "Bhutan"
				},
				"por": {
					"official": "Reino do Butão",
					"common": "Butão"
				},
				"rus": {
					"official": "Королевство Бутан",
					"common": "Бутан"
				},
				"slk": {
					"official": "Bhutánske krâľovstvo",
					"common": "Bhután"
				},
				"spa": {
					"official": "Reino de Bután",
					"common": "Bután"
				},
				"fin": {
					"official": "Bhutanin kuningaskunta",
					"common": "Bhutan"
				},
				"zho": {
					"official": "不丹王国",
					"common": "不丹"
				}
			},
			"latlng": [
				27.5,
				90.5
			],
			"demonym": "Bhutanese",
			"landlocked": true,
			"borders": [
				"CHN",
				"IND"
			],
			"area": 38394
		},
		{
			"name": {
				"common": "Bouvet Island",
				"official": "Bouvet Island",
				"native": {
					"nor": {
						"official": "Bouvetøya",
						"common": "Bouvetøya"
					}
				}
			},
			"tld": [
				".bv"
			],
			"cca2": "BV",
			"ccn3": "074",
			"cca3": "BVT",
			"cioc": "",
			"currency": [
				"NOK"
			],
			"callingCode": [],
			"capital": "",
			"altSpellings": [
				"BV",
				"Bouvetøya",
				"Bouvet-øya"
			],
			"region": "",
			"subregion": "",
			"languages": {
				"nor": "Norwegian"
			},
			"translations": {
				"deu": {
					"official": "Bouvet-Insel",
					"common": "Bouvetinsel"
				},
				"fra": {
					"official": "Île Bouvet",
					"common": "Île Bouvet"
				},
				"hrv": {
					"official": "Bouvet Island",
					"common": "Otok Bouvet"
				},
				"ita": {
					"official": "Isola Bouvet",
					"common": "Isola Bouvet"
				},
				"jpn": {
					"official": "ブーヴェ島",
					"common": "ブーベ島"
				},
				"nld": {
					"official": "Bouvet Island",
					"common": "Bouveteiland"
				},
				"por": {
					"official": "Ilha Bouvet",
					"common": "Ilha Bouvet"
				},
				"rus": {
					"official": "Остров Буве",
					"common": "Остров Буве"
				},
				"slk": {
					"official": "Bouvetov ostrov",
					"common": "Bouvetov ostrov"
				},
				"spa": {
					"official": "Isla Bouvet",
					"common": "Isla Bouvet"
				},
				"fin": {
					"official": "Bouvet'nsaari",
					"common": "Bouvet'nsaari"
				},
				"zho": {
					"official": "布维岛",
					"common": "布维岛"
				}
			},
			"latlng": [
				-54.43333333,
				3.4
			],
			"demonym": "",
			"landlocked": false,
			"borders": [],
			"area": 49
		},
		{
			"name": {
				"common": "Botswana",
				"official": "Republic of Botswana",
				"native": {
					"eng": {
						"official": "Republic of Botswana",
						"common": "Botswana"
					},
					"tsn": {
						"official": "Lefatshe la Botswana",
						"common": "Botswana"
					}
				}
			},
			"tld": [
				".bw"
			],
			"cca2": "BW",
			"ccn3": "072",
			"cca3": "BWA",
			"cioc": "BOT",
			"currency": [
				"BWP"
			],
			"callingCode": [
				"267"
			],
			"capital": "Gaborone",
			"altSpellings": [
				"BW",
				"Republic of Botswana",
				"Lefatshe la Botswana"
			],
			"region": "Africa",
			"subregion": "Southern Africa",
			"languages": {
				"eng": "English",
				"tsn": "Tswana"
			},
			"translations": {
				"deu": {
					"official": "Republik Botsuana",
					"common": "Botswana"
				},
				"fra": {
					"official": "République du Botswana",
					"common": "Botswana"
				},
				"hrv": {
					"official": "Republika Bocvana",
					"common": "Bocvana"
				},
				"ita": {
					"official": "Repubblica del Botswana",
					"common": "Botswana"
				},
				"jpn": {
					"official": "ボツワナ共和国",
					"common": "ボツワナ"
				},
				"nld": {
					"official": "Republiek Botswana",
					"common": "Botswana"
				},
				"por": {
					"official": "República do Botswana",
					"common": "Botswana"
				},
				"rus": {
					"official": "Республика Ботсвана",
					"common": "Ботсвана"
				},
				"slk": {
					"official": "Botswanská republika",
					"common": "Botswana"
				},
				"spa": {
					"official": "República de Botswana",
					"common": "Botswana"
				},
				"fin": {
					"official": "Botswanan tasavalta",
					"common": "Botswana"
				},
				"zho": {
					"official": "博茨瓦纳共和国",
					"common": "博茨瓦纳"
				}
			},
			"latlng": [
				-22,
				24
			],
			"demonym": "Motswana",
			"landlocked": true,
			"borders": [
				"NAM",
				"ZAF",
				"ZMB",
				"ZWE"
			],
			"area": 582000
		},
		{
			"name": {
				"common": "Central African Republic",
				"official": "Central African Republic",
				"native": {
					"fra": {
						"official": "République centrafricaine",
						"common": "République centrafricaine"
					},
					"sag": {
						"official": "Ködörösêse tî Bêafrîka",
						"common": "Bêafrîka"
					}
				}
			},
			"tld": [
				".cf"
			],
			"cca2": "CF",
			"ccn3": "140",
			"cca3": "CAF",
			"cioc": "CAF",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"236"
			],
			"capital": "Bangui",
			"altSpellings": [
				"CF",
				"Central African Republic",
				"République centrafricaine"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"fra": "French",
				"sag": "Sango"
			},
			"translations": {
				"cym": {
					"official": "Central African Republic",
					"common": "Gweriniaeth Canolbarth Affrica"
				},
				"deu": {
					"official": "Zentralafrikanische Republik",
					"common": "Zentralafrikanische Republik"
				},
				"fra": {
					"official": "République centrafricaine",
					"common": "République centrafricaine"
				},
				"hrv": {
					"official": "Centralna Afrička Republika",
					"common": "Srednjoafrička Republika"
				},
				"ita": {
					"official": "Repubblica Centrafricana",
					"common": "Repubblica Centrafricana"
				},
				"jpn": {
					"official": "中央アフリカ共和国",
					"common": "中央アフリカ共和国"
				},
				"nld": {
					"official": "Centraal-Afrikaanse Republiek",
					"common": "Centraal-Afrikaanse Republiek"
				},
				"por": {
					"official": "República Centro-Africano",
					"common": "República Centro-Africana"
				},
				"rus": {
					"official": "Центрально-Африканская Республика",
					"common": "Центральноафриканская Республика"
				},
				"slk": {
					"official": "Stredoafrická republika",
					"common": "Stredoafrická republika"
				},
				"spa": {
					"official": "República Centroafricana",
					"common": "República Centroafricana"
				},
				"fin": {
					"official": "Keski-Afrikan tasavalta",
					"common": "Keski-Afrikan tasavalta"
				},
				"zho": {
					"official": "中非共和国",
					"common": "中非共和国"
				}
			},
			"latlng": [
				7,
				21
			],
			"demonym": "Central African",
			"landlocked": true,
			"borders": [
				"CMR",
				"TCD",
				"COD",
				"COG",
				"SSD",
				"SDN"
			],
			"area": 622984
		},
		{
			"name": {
				"common": "Canada",
				"official": "Canada",
				"native": {
					"eng": {
						"official": "Canada",
						"common": "Canada"
					},
					"fra": {
						"official": "Canada",
						"common": "Canada"
					}
				}
			},
			"tld": [
				".ca"
			],
			"cca2": "CA",
			"ccn3": "124",
			"cca3": "CAN",
			"cioc": "CAN",
			"currency": [
				"CAD"
			],
			"callingCode": [
				"1"
			],
			"capital": "Ottawa",
			"altSpellings": [
				"CA"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"eng": "English",
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Canada",
					"common": "Canada"
				},
				"deu": {
					"official": "Kanada",
					"common": "Kanada"
				},
				"fra": {
					"official": "Canada",
					"common": "Canada"
				},
				"hrv": {
					"official": "Kanada",
					"common": "Kanada"
				},
				"ita": {
					"official": "Canada",
					"common": "Canada"
				},
				"jpn": {
					"official": "カナダ",
					"common": "カナダ"
				},
				"nld": {
					"official": "Canada",
					"common": "Canada"
				},
				"por": {
					"official": "Canadá",
					"common": "Canadá"
				},
				"rus": {
					"official": "Канада",
					"common": "Канада"
				},
				"slk": {
					"official": "Kanada",
					"common": "Kanada"
				},
				"spa": {
					"official": "Canadá",
					"common": "Canadá"
				},
				"fin": {
					"official": "Kanada",
					"common": "Kanada"
				},
				"zho": {
					"official": "加拿大",
					"common": "加拿大"
				}
			},
			"latlng": [
				60,
				-95
			],
			"demonym": "Canadian",
			"landlocked": false,
			"borders": [
				"USA"
			],
			"area": 9984670
		},
		{
			"name": {
				"common": "Cocos (Keeling) Islands",
				"official": "Territory of the Cocos (Keeling) Islands",
				"native": {
					"eng": {
						"official": "Territory of the Cocos (Keeling) Islands",
						"common": "Cocos (Keeling) Islands"
					}
				}
			},
			"tld": [
				".cc"
			],
			"cca2": "CC",
			"ccn3": "166",
			"cca3": "CCK",
			"cioc": "",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"61"
			],
			"capital": "West Island",
			"altSpellings": [
				"CC",
				"Territory of the Cocos (Keeling) Islands",
				"Keeling Islands"
			],
			"region": "Oceania",
			"subregion": "Australia and New Zealand",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Territory of the Cocos (Keeling) Islands",
					"common": "Ynysoedd Cocos"
				},
				"deu": {
					"official": "Gebiet der Cocos (Keeling) Islands",
					"common": "Kokosinseln"
				},
				"fra": {
					"official": "Territoire des îles Cocos (Keeling)",
					"common": "Îles Cocos"
				},
				"hrv": {
					"official": "Teritoriju Kokosovi (Keeling) Islands",
					"common": "Kokosovi Otoci"
				},
				"ita": {
					"official": "Territorio della (Keeling) Isole Cocos",
					"common": "Isole Cocos e Keeling"
				},
				"jpn": {
					"official": "ココス諸島の領土",
					"common": "ココス（キーリング）諸島"
				},
				"nld": {
					"official": "Grondgebied van de Eilanden Cocos (Keeling )",
					"common": "Cocoseilanden"
				},
				"por": {
					"official": "Território dos Cocos (Keeling)",
					"common": "Ilhas Cocos (Keeling)"
				},
				"rus": {
					"official": "Территория Кокосовые (Килинг) острова",
					"common": "Кокосовые острова"
				},
				"slk": {
					"official": "Kokosové ostrovy",
					"common": "Kokosové ostrovy"
				},
				"spa": {
					"official": "Territorio de los (Keeling) Islas Cocos",
					"common": "Islas Cocos o Islas Keeling"
				},
				"fin": {
					"official": "Kookossaaret",
					"common": "Kookossaaret"
				},
				"zho": {
					"official": "科科斯",
					"common": "科科斯"
				}
			},
			"latlng": [
				-12.5,
				96.83333333
			],
			"demonym": "Cocos Islander",
			"landlocked": false,
			"borders": [],
			"area": 14
		},
		{
			"name": {
				"common": "Switzerland",
				"official": "Switzerland",
				"native": {
					"fra": {
						"official": "Confédération suisse",
						"common": "Suisse"
					},
					"gsw": {
						"official": "Schweizerische Eidgenossenschaft",
						"common": "Schweiz"
					},
					"ita": {
						"official": "Confederazione Svizzera",
						"common": "Svizzera"
					},
					"roh": {
						"official": "Confederaziun svizra",
						"common": "Svizra"
					}
				}
			},
			"tld": [
				".ch"
			],
			"cca2": "CH",
			"ccn3": "756",
			"cca3": "CHE",
			"cioc": "SUI",
			"currency": [
				"CHE",
				"CHF",
				"CHW"
			],
			"callingCode": [
				"41"
			],
			"capital": "Bern",
			"altSpellings": [
				"CH",
				"Swiss Confederation",
				"Schweiz",
				"Suisse",
				"Svizzera",
				"Svizra"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"fra": "French",
				"gsw": "Swiss German",
				"ita": "Italian",
				"roh": "Romansh"
			},
			"translations": {
				"deu": {
					"official": "Schweizerische Eidgenossenschaft",
					"common": "Schweiz"
				},
				"fra": {
					"official": "Confédération suisse",
					"common": "Suisse"
				},
				"hrv": {
					"official": "švicarska Konfederacija",
					"common": "Švicarska"
				},
				"ita": {
					"official": "Confederazione svizzera",
					"common": "Svizzera"
				},
				"jpn": {
					"official": "スイス連邦",
					"common": "スイス"
				},
				"nld": {
					"official": "Zwitserse Confederatie",
					"common": "Zwitserland"
				},
				"por": {
					"official": "Confederação Suíça",
					"common": "Suíça"
				},
				"rus": {
					"official": "Швейцарская Конфедерация",
					"common": "Швейцария"
				},
				"slk": {
					"official": "Švajčiarska konfederácia",
					"common": "Švajčiarsko"
				},
				"spa": {
					"official": "Confederación Suiza",
					"common": "Suiza"
				},
				"fin": {
					"official": "Sveitsin valaliitto",
					"common": "Sveitsi"
				},
				"zho": {
					"official": "瑞士联邦",
					"common": "瑞士"
				}
			},
			"latlng": [
				47,
				8
			],
			"demonym": "Swiss",
			"landlocked": true,
			"borders": [
				"AUT",
				"FRA",
				"ITA",
				"LIE",
				"DEU"
			],
			"area": 41284
		},
		{
			"name": {
				"common": "Chile",
				"official": "Republic of Chile",
				"native": {
					"spa": {
						"official": "República de Chile",
						"common": "Chile"
					}
				}
			},
			"tld": [
				".cl"
			],
			"cca2": "CL",
			"ccn3": "152",
			"cca3": "CHL",
			"cioc": "CHI",
			"currency": [
				"CLF",
				"CLP"
			],
			"callingCode": [
				"56"
			],
			"capital": "Santiago",
			"altSpellings": [
				"CL",
				"Republic of Chile",
				"República de Chile"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Chile",
					"common": "Chile"
				},
				"deu": {
					"official": "Republik Chile",
					"common": "Chile"
				},
				"fra": {
					"official": "République du Chili",
					"common": "Chili"
				},
				"hrv": {
					"official": "Republika Čile",
					"common": "Čile"
				},
				"ita": {
					"official": "Repubblica del Cile",
					"common": "Cile"
				},
				"jpn": {
					"official": "チリ共和国",
					"common": "チリ"
				},
				"nld": {
					"official": "Republiek Chili",
					"common": "Chili"
				},
				"por": {
					"official": "República do Chile",
					"common": "Chile"
				},
				"rus": {
					"official": "Республика Чили",
					"common": "Чили"
				},
				"slk": {
					"official": "Čílska republika",
					"common": "Čile"
				},
				"spa": {
					"official": "República de Chile",
					"common": "Chile"
				},
				"fin": {
					"official": "Chilen tasavalta",
					"common": "Chile"
				},
				"zho": {
					"official": "智利共和国",
					"common": "智利"
				}
			},
			"latlng": [
				-30,
				-71
			],
			"demonym": "Chilean",
			"landlocked": false,
			"borders": [
				"ARG",
				"BOL",
				"PER"
			],
			"area": 756102
		},
		{
			"name": {
				"common": "China",
				"official": "People's Republic of China",
				"native": {
					"zho": {
						"official": "中华人民共和国",
						"common": "中国"
					}
				}
			},
			"tld": [
				".cn",
				".中国",
				".中國",
				".公司",
				".网络"
			],
			"cca2": "CN",
			"ccn3": "156",
			"cca3": "CHN",
			"cioc": "CHN",
			"currency": [
				"CNY"
			],
			"callingCode": [
				"86"
			],
			"capital": "Beijing",
			"altSpellings": [
				"CN",
				"Zhōngguó",
				"Zhongguo",
				"Zhonghua",
				"People's Republic of China",
				"中华人民共和国",
				"Zhōnghuá Rénmín Gònghéguó"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"zho": "Chinese"
			},
			"translations": {
				"cym": {
					"official": "People's Republic of China",
					"common": "Tsieina"
				},
				"deu": {
					"official": "Volksrepublik China",
					"common": "China"
				},
				"fra": {
					"official": "République populaire de Chine",
					"common": "Chine"
				},
				"hrv": {
					"official": "Narodna Republika Kina",
					"common": "Kina"
				},
				"ita": {
					"official": "Repubblica popolare cinese",
					"common": "Cina"
				},
				"jpn": {
					"official": "中華人民共和国",
					"common": "中国"
				},
				"nld": {
					"official": "Volksrepubliek China",
					"common": "China"
				},
				"por": {
					"official": "República Popular da China",
					"common": "China"
				},
				"rus": {
					"official": "Народная Республика Китай",
					"common": "Китай"
				},
				"slk": {
					"official": "Čínska ľudová republika",
					"common": "Čína"
				},
				"spa": {
					"official": "República Popular de China",
					"common": "China"
				},
				"fin": {
					"official": "Kiinan kansantasavalta",
					"common": "Kiina"
				}
			},
			"latlng": [
				35,
				105
			],
			"demonym": "Chinese",
			"landlocked": false,
			"borders": [
				"AFG",
				"BTN",
				"MMR",
				"HKG",
				"IND",
				"KAZ",
				"PRK",
				"KGZ",
				"LAO",
				"MAC",
				"MNG",
				"PAK",
				"RUS",
				"TJK",
				"VNM"
			],
			"area": 9706961
		},
		{
			"name": {
				"common": "Ivory Coast",
				"official": "Republic of Côte d'Ivoire",
				"native": {
					"fra": {
						"official": "République de Côte d'Ivoire",
						"common": "Côte d'Ivoire"
					}
				}
			},
			"tld": [
				".ci"
			],
			"cca2": "CI",
			"ccn3": "384",
			"cca3": "CIV",
			"cioc": "CIV",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"225"
			],
			"capital": "Yamoussoukro",
			"altSpellings": [
				"CI",
				"Côte d'Ivoire",
				"Ivory Coast",
				"Republic of Côte d'Ivoire",
				"République de Côte d'Ivoire"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Côte d'Ivoire",
					"common": "Elfenbeinküste"
				},
				"fra": {
					"official": "République de Côte d' Ivoire",
					"common": "Côte d'Ivoire"
				},
				"hrv": {
					"official": "Republika Côte d'Ivoire",
					"common": "Obala Bjelokosti"
				},
				"ita": {
					"official": "Repubblica della Costa d'Avorio",
					"common": "Costa d'Avorio"
				},
				"jpn": {
					"official": "コートジボワール共和国",
					"common": "コートジボワール"
				},
				"nld": {
					"official": "Republiek Ivoorkust",
					"common": "Ivoorkust"
				},
				"por": {
					"official": "República da Côte d'Ivoire",
					"common": "Costa do Marfim"
				},
				"rus": {
					"official": "Республика Кот-д'Ивуаре",
					"common": "Кот-д’Ивуар"
				},
				"slk": {
					"official": "Republika Pobrežie Slonoviny",
					"common": "Pobržie Slonoviny"
				},
				"spa": {
					"official": "República de Côte d'Ivoire",
					"common": "Costa de Marfil"
				},
				"fin": {
					"official": "Norsunluurannikon tasavalta",
					"common": "Norsunluurannikko"
				},
				"zho": {
					"official": "科特迪瓦共和国",
					"common": "科特迪瓦"
				}
			},
			"latlng": [
				8,
				-5
			],
			"demonym": "Ivorian",
			"landlocked": false,
			"borders": [
				"BFA",
				"GHA",
				"GIN",
				"LBR",
				"MLI"
			],
			"area": 322463
		},
		{
			"name": {
				"common": "Cameroon",
				"official": "Republic of Cameroon",
				"native": {
					"eng": {
						"official": "Republic of Cameroon",
						"common": "Cameroon"
					},
					"fra": {
						"official": "République du Cameroun",
						"common": "Cameroun"
					}
				}
			},
			"tld": [
				".cm"
			],
			"cca2": "CM",
			"ccn3": "120",
			"cca3": "CMR",
			"cioc": "CMR",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"237"
			],
			"capital": "Yaoundé",
			"altSpellings": [
				"CM",
				"Republic of Cameroon",
				"République du Cameroun"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"eng": "English",
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Republic of Cameroon",
					"common": "Camerŵn"
				},
				"deu": {
					"official": "Republik Kamerun",
					"common": "Kamerun"
				},
				"fra": {
					"official": "République du Cameroun",
					"common": "Cameroun"
				},
				"hrv": {
					"official": "Republika Kamerun",
					"common": "Kamerun"
				},
				"ita": {
					"official": "Repubblica del Camerun",
					"common": "Camerun"
				},
				"jpn": {
					"official": "カメルーン共和国",
					"common": "カメルーン"
				},
				"nld": {
					"official": "Republiek Kameroen",
					"common": "Kameroen"
				},
				"por": {
					"official": "República dos Camarões",
					"common": "Camarões"
				},
				"rus": {
					"official": "Республика Камерун",
					"common": "Камерун"
				},
				"slk": {
					"official": "Kamerunská republika",
					"common": "Kamerun"
				},
				"spa": {
					"official": "República de Camerún",
					"common": "Camerún"
				},
				"fin": {
					"official": "Kamerunin tasavalta",
					"common": "Kamerun"
				},
				"zho": {
					"official": "喀麦隆共和国",
					"common": "喀麦隆"
				}
			},
			"latlng": [
				6,
				12
			],
			"demonym": "Cameroonian",
			"landlocked": false,
			"borders": [
				"CAF",
				"TCD",
				"COG",
				"GNQ",
				"GAB",
				"NGA"
			],
			"area": 475442
		},
		{
			"name": {
				"common": "DR Congo",
				"official": "Democratic Republic of the Congo",
				"native": {
					"fra": {
						"official": "République démocratique du Congo",
						"common": "RD Congo"
					},
					"kon": {
						"official": "Repubilika ya Kongo Demokratiki",
						"common": "Repubilika ya Kongo Demokratiki"
					},
					"lin": {
						"official": "Republiki ya Kongó Demokratiki",
						"common": "Republiki ya Kongó Demokratiki"
					},
					"lua": {
						"official": "Ditunga dia Kongu wa Mungalaata",
						"common": "Ditunga dia Kongu wa Mungalaata"
					},
					"swa": {
						"official": "Jamhuri ya Kidemokrasia ya Kongo",
						"common": "Jamhuri ya Kidemokrasia ya Kongo"
					}
				}
			},
			"tld": [
				".cd"
			],
			"cca2": "CD",
			"ccn3": "180",
			"cca3": "COD",
			"cioc": "COD",
			"currency": [
				"CDF"
			],
			"callingCode": [
				"243"
			],
			"capital": "Kinshasa",
			"altSpellings": [
				"CD",
				"DR Congo",
				"Congo-Kinshasa",
				"Congo, the Democratic Republic of the",
				"DRC"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"fra": "French",
				"kon": "Kikongo",
				"lin": "Lingala",
				"lua": "Tshiluba",
				"swa": "Swahili"
			},
			"translations": {
				"cym": {
					"official": "Democratic Republic of the Congo",
					"common": "Gweriniaeth Ddemocrataidd Congo"
				},
				"deu": {
					"official": "Demokratische Republik Kongo",
					"common": "Kongo (Dem. Rep.)"
				},
				"fra": {
					"official": "République démocratique du Congo",
					"common": "Congo (Rép. dém.)"
				},
				"hrv": {
					"official": "Demokratska Republika Kongo",
					"common": "Kongo, Demokratska Republika"
				},
				"ita": {
					"official": "Repubblica Democratica del Congo",
					"common": "Congo (Rep. Dem.)"
				},
				"jpn": {
					"official": "コンゴ民主共和国",
					"common": "コンゴ民主共和国"
				},
				"nld": {
					"official": "Democratische Republiek Congo",
					"common": "Congo (DRC)"
				},
				"por": {
					"official": "República Democrática do Congo",
					"common": "República Democrática do Congo"
				},
				"rus": {
					"official": "Демократическая Республика Конго",
					"common": "Демократическая Республика Конго"
				},
				"slk": {
					"official": "Konžská demokratická republika",
					"common": "Kongo"
				},
				"spa": {
					"official": "República Democrática del Congo",
					"common": "Congo (Rep. Dem.)"
				},
				"fin": {
					"official": "Kongon demokraattinen tasavalta",
					"common": "Kongon demokraattinen tasavalta"
				},
				"zho": {
					"official": "刚果民主共和国",
					"common": "民主刚果"
				}
			},
			"latlng": [
				0,
				25
			],
			"demonym": "Congolese",
			"landlocked": false,
			"borders": [
				"AGO",
				"BDI",
				"CAF",
				"COG",
				"RWA",
				"SSD",
				"TZA",
				"UGA",
				"ZMB"
			],
			"area": 2344858
		},
		{
			"name": {
				"common": "Republic of the Congo",
				"official": "Republic of the Congo",
				"native": {
					"fra": {
						"official": "République du Congo",
						"common": "République du Congo"
					},
					"kon": {
						"official": "Repubilika ya Kongo",
						"common": "Repubilika ya Kongo"
					},
					"lin": {
						"official": "Republíki ya Kongó",
						"common": "Republíki ya Kongó"
					}
				}
			},
			"tld": [
				".cg"
			],
			"cca2": "CG",
			"ccn3": "178",
			"cca3": "COG",
			"cioc": "CGO",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"242"
			],
			"capital": "Brazzaville",
			"altSpellings": [
				"CG",
				"Congo",
				"Congo-Brazzaville"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"fra": "French",
				"kon": "Kikongo",
				"lin": "Lingala"
			},
			"translations": {
				"cym": {
					"official": "Republic of the Congo",
					"common": "Gweriniaeth y Congo"
				},
				"deu": {
					"official": "Republik Kongo",
					"common": "Kongo"
				},
				"fra": {
					"official": "République du Congo",
					"common": "Congo"
				},
				"hrv": {
					"official": "Republika Kongo",
					"common": "Kongo"
				},
				"ita": {
					"official": "Repubblica del Congo",
					"common": "Congo"
				},
				"jpn": {
					"official": "コンゴ共和国",
					"common": "コンゴ共和国"
				},
				"nld": {
					"official": "Republiek Congo",
					"common": "Congo"
				},
				"por": {
					"official": "República do Congo",
					"common": "Congo"
				},
				"rus": {
					"official": "Республика Конго",
					"common": "Республика Конго"
				},
				"slk": {
					"official": "Konžská republika",
					"common": "Kongo"
				},
				"spa": {
					"official": "República del Congo",
					"common": "Congo"
				},
				"fin": {
					"official": "Kongon tasavalta",
					"common": "Kongo-Brazzaville"
				},
				"zho": {
					"official": "刚果共和国",
					"common": "刚果"
				}
			},
			"latlng": [
				-1,
				15
			],
			"demonym": "Congolese",
			"landlocked": false,
			"borders": [
				"AGO",
				"CMR",
				"CAF",
				"COD",
				"GAB"
			],
			"area": 342000
		},
		{
			"name": {
				"common": "Cook Islands",
				"official": "Cook Islands",
				"native": {
					"eng": {
						"official": "Cook Islands",
						"common": "Cook Islands"
					},
					"rar": {
						"official": "Kūki 'Āirani",
						"common": "Kūki 'Āirani"
					}
				}
			},
			"tld": [
				".ck"
			],
			"cca2": "CK",
			"ccn3": "184",
			"cca3": "COK",
			"cioc": "COK",
			"currency": [
				"NZD"
			],
			"callingCode": [
				"682"
			],
			"capital": "Avarua",
			"altSpellings": [
				"CK",
				"Kūki 'Āirani"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"rar": "Cook Islands Māori"
			},
			"translations": {
				"cym": {
					"official": "Cook Islands",
					"common": "Ynysoedd Cook"
				},
				"deu": {
					"official": "Cook-Inseln",
					"common": "Cookinseln"
				},
				"fra": {
					"official": "Îles Cook",
					"common": "Îles Cook"
				},
				"hrv": {
					"official": "Cook Islands",
					"common": "Cookovo Otočje"
				},
				"ita": {
					"official": "Isole Cook",
					"common": "Isole Cook"
				},
				"jpn": {
					"official": "クック諸島",
					"common": "クック諸島"
				},
				"nld": {
					"official": "Cook eilanden",
					"common": "Cookeilanden"
				},
				"por": {
					"official": "Ilhas Cook",
					"common": "Ilhas Cook"
				},
				"rus": {
					"official": "острова Кука",
					"common": "Острова Кука"
				},
				"slk": {
					"official": "Cookove ostrovy",
					"common": "Cookove ostrovy"
				},
				"spa": {
					"official": "Islas Cook",
					"common": "Islas Cook"
				},
				"fin": {
					"official": "Cookinsaaret",
					"common": "Cookinsaaret"
				},
				"zho": {
					"official": "库克群岛",
					"common": "库克群岛"
				}
			},
			"latlng": [
				-21.23333333,
				-159.76666666
			],
			"demonym": "Cook Islander",
			"landlocked": false,
			"borders": [],
			"area": 236
		},
		{
			"name": {
				"common": "Colombia",
				"official": "Republic of Colombia",
				"native": {
					"spa": {
						"official": "República de Colombia",
						"common": "Colombia"
					}
				}
			},
			"tld": [
				".co"
			],
			"cca2": "CO",
			"ccn3": "170",
			"cca3": "COL",
			"cioc": "COL",
			"currency": [
				"COP"
			],
			"callingCode": [
				"57"
			],
			"capital": "Bogotá",
			"altSpellings": [
				"CO",
				"Republic of Colombia",
				"República de Colombia"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Colombia",
					"common": "Colombia"
				},
				"deu": {
					"official": "Republik Kolumbien",
					"common": "Kolumbien"
				},
				"fra": {
					"official": "République de Colombie",
					"common": "Colombie"
				},
				"hrv": {
					"official": "Republika Kolumbija",
					"common": "Kolumbija"
				},
				"ita": {
					"official": "Repubblica di Colombia",
					"common": "Colombia"
				},
				"jpn": {
					"official": "コロンビア共和国",
					"common": "コロンビア"
				},
				"nld": {
					"official": "Republiek Colombia",
					"common": "Colombia"
				},
				"por": {
					"official": "República da Colômbia",
					"common": "Colômbia"
				},
				"rus": {
					"official": "Республика Колумбия",
					"common": "Колумбия"
				},
				"slk": {
					"official": "Kolumbijská republika",
					"common": "Kolumbia"
				},
				"spa": {
					"official": "República de Colombia",
					"common": "Colombia"
				},
				"fin": {
					"official": "Kolumbian tasavalta",
					"common": "Kolumbia"
				},
				"zho": {
					"official": "哥伦比亚共和国",
					"common": "哥伦比亚"
				}
			},
			"latlng": [
				4,
				-72
			],
			"demonym": "Colombian",
			"landlocked": false,
			"borders": [
				"BRA",
				"ECU",
				"PAN",
				"PER",
				"VEN"
			],
			"area": 1141748
		},
		{
			"name": {
				"common": "Comoros",
				"official": "Union of the Comoros",
				"native": {
					"ara": {
						"official": "الاتحاد القمري",
						"common": "القمر‎"
					},
					"fra": {
						"official": "Union des Comores",
						"common": "Comores"
					},
					"zdj": {
						"official": "Udzima wa Komori",
						"common": "Komori"
					}
				}
			},
			"tld": [
				".km"
			],
			"cca2": "KM",
			"ccn3": "174",
			"cca3": "COM",
			"cioc": "COM",
			"currency": [
				"KMF"
			],
			"callingCode": [
				"269"
			],
			"capital": "Moroni",
			"altSpellings": [
				"KM",
				"Union of the Comoros",
				"Union des Comores",
				"Udzima wa Komori",
				"al-Ittiḥād al-Qumurī"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"ara": "Arabic",
				"fra": "French",
				"zdj": "Comorian"
			},
			"translations": {
				"cym": {
					"official": "Union of the Comoros",
					"common": "Comoros"
				},
				"deu": {
					"official": "Union der Komoren",
					"common": "Union der Komoren"
				},
				"fra": {
					"official": "Union des Comores",
					"common": "Comores"
				},
				"hrv": {
					"official": "Savez Komori",
					"common": "Komori"
				},
				"ita": {
					"official": "Unione delle Comore",
					"common": "Comore"
				},
				"jpn": {
					"official": "コモロ連合",
					"common": "コモロ"
				},
				"nld": {
					"official": "Unie van de Comoren",
					"common": "Comoren"
				},
				"por": {
					"official": "União das Comores",
					"common": "Comores"
				},
				"rus": {
					"official": "Союз Коморских Островов",
					"common": "Коморы"
				},
				"slk": {
					"official": "Komorská únia",
					"common": "Komory"
				},
				"spa": {
					"official": "Unión de las Comoras",
					"common": "Comoras"
				},
				"fin": {
					"official": "Komorien liitto",
					"common": "Komorit"
				},
				"zho": {
					"official": "科摩罗联盟",
					"common": "科摩罗"
				}
			},
			"latlng": [
				-12.16666666,
				44.25
			],
			"demonym": "Comoran",
			"landlocked": false,
			"borders": [],
			"area": 1862
		},
		{
			"name": {
				"common": "Cape Verde",
				"official": "Republic of Cabo Verde",
				"native": {
					"por": {
						"official": "República de Cabo Verde",
						"common": "Cabo Verde"
					}
				}
			},
			"tld": [
				".cv"
			],
			"cca2": "CV",
			"ccn3": "132",
			"cca3": "CPV",
			"cioc": "CPV",
			"currency": [
				"CVE"
			],
			"callingCode": [
				"238"
			],
			"capital": "Praia",
			"altSpellings": [
				"CV",
				"Republic of Cabo Verde",
				"República de Cabo Verde"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"cym": {
					"official": "Republic of Cabo Verde",
					"common": "Cape Verde"
				},
				"deu": {
					"official": "Republik Cabo Verde",
					"common": "Kap Verde"
				},
				"fra": {
					"official": "République du Cap-Vert",
					"common": "Îles du Cap-Vert"
				},
				"hrv": {
					"official": "Republika Cabo Verde",
					"common": "Zelenortska Republika"
				},
				"ita": {
					"official": "Repubblica di Capo Verde",
					"common": "Capo Verde"
				},
				"jpn": {
					"official": "カーボベルデ共和国",
					"common": "カーボベルデ"
				},
				"nld": {
					"official": "Republiek van Cabo Verde",
					"common": "Kaapverdië"
				},
				"por": {
					"official": "República de Cabo Verde",
					"common": "Cabo Verde"
				},
				"rus": {
					"official": "Республика Кабо -Верде",
					"common": "Кабо-Верде"
				},
				"slk": {
					"official": "Kapverdská republika",
					"common": "Kapverdy"
				},
				"spa": {
					"official": "República de Cabo Verde",
					"common": "Cabo Verde"
				},
				"fin": {
					"official": "Kap Verden tasavalta",
					"common": "Kap Verde"
				},
				"zho": {
					"official": "佛得角共和国",
					"common": "佛得角"
				}
			},
			"latlng": [
				16,
				-24
			],
			"demonym": "Cape Verdian",
			"landlocked": false,
			"borders": [],
			"area": 4033
		},
		{
			"name": {
				"common": "Costa Rica",
				"official": "Republic of Costa Rica",
				"native": {
					"spa": {
						"official": "República de Costa Rica",
						"common": "Costa Rica"
					}
				}
			},
			"tld": [
				".cr"
			],
			"cca2": "CR",
			"ccn3": "188",
			"cca3": "CRI",
			"cioc": "CRC",
			"currency": [
				"CRC"
			],
			"callingCode": [
				"506"
			],
			"capital": "San José",
			"altSpellings": [
				"CR",
				"Republic of Costa Rica",
				"República de Costa Rica"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Costa Rica",
					"common": "Costa Rica"
				},
				"deu": {
					"official": "Republik Costa Rica",
					"common": "Costa Rica"
				},
				"fra": {
					"official": "République du Costa Rica",
					"common": "Costa Rica"
				},
				"hrv": {
					"official": "Republika Kostarika",
					"common": "Kostarika"
				},
				"ita": {
					"official": "Repubblica di Costa Rica",
					"common": "Costa Rica"
				},
				"jpn": {
					"official": "コスタリカ共和国",
					"common": "コスタリカ"
				},
				"nld": {
					"official": "Republiek Costa Rica",
					"common": "Costa Rica"
				},
				"por": {
					"official": "República da Costa Rica",
					"common": "Costa Rica"
				},
				"rus": {
					"official": "Республика Коста-Рика",
					"common": "Коста-Рика"
				},
				"slk": {
					"official": "Kostarická republika",
					"common": "Kostarika"
				},
				"spa": {
					"official": "República de Costa Rica",
					"common": "Costa Rica"
				},
				"fin": {
					"official": "Costa Rican tasavalta",
					"common": "Costa Rica"
				},
				"zho": {
					"official": "哥斯达黎加共和国",
					"common": "哥斯达黎加"
				}
			},
			"latlng": [
				10,
				-84
			],
			"demonym": "Costa Rican",
			"landlocked": false,
			"borders": [
				"NIC",
				"PAN"
			],
			"area": 51100
		},
		{
			"name": {
				"common": "Cuba",
				"official": "Republic of Cuba",
				"native": {
					"spa": {
						"official": "República de Cuba",
						"common": "Cuba"
					}
				}
			},
			"tld": [
				".cu"
			],
			"cca2": "CU",
			"ccn3": "192",
			"cca3": "CUB",
			"cioc": "CUB",
			"currency": [
				"CUC",
				"CUP"
			],
			"callingCode": [
				"53"
			],
			"capital": "Havana",
			"altSpellings": [
				"CU",
				"Republic of Cuba",
				"República de Cuba"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Cuba",
					"common": "Ciwba"
				},
				"deu": {
					"official": "Republik Kuba",
					"common": "Kuba"
				},
				"fra": {
					"official": "République de Cuba",
					"common": "Cuba"
				},
				"hrv": {
					"official": "Republika Kuba",
					"common": "Kuba"
				},
				"ita": {
					"official": "Repubblica di Cuba",
					"common": "Cuba"
				},
				"jpn": {
					"official": "キューバ共和国",
					"common": "キューバ"
				},
				"nld": {
					"official": "Republiek Cuba",
					"common": "Cuba"
				},
				"por": {
					"official": "República de Cuba",
					"common": "Cuba"
				},
				"rus": {
					"official": "Республика Куба",
					"common": "Куба"
				},
				"slk": {
					"official": "Kubánska republika",
					"common": "Kuba"
				},
				"spa": {
					"official": "República de Cuba",
					"common": "Cuba"
				},
				"fin": {
					"official": "Kuuban tasavalta",
					"common": "Kuuba"
				},
				"zho": {
					"official": "古巴共和国",
					"common": "古巴"
				}
			},
			"latlng": [
				21.5,
				-80
			],
			"demonym": "Cuban",
			"landlocked": false,
			"borders": [],
			"area": 109884
		},
		{
			"name": {
				"common": "Curaçao",
				"official": "Country of Curaçao",
				"native": {
					"eng": {
						"official": "Country of Curaçao",
						"common": "Curaçao"
					},
					"nld": {
						"official": "Land Curaçao",
						"common": "Curaçao"
					},
					"pap": {
						"official": "Pais Kòrsou",
						"common": "Pais Kòrsou"
					}
				}
			},
			"tld": [
				".cw"
			],
			"cca2": "CW",
			"ccn3": "531",
			"cca3": "CUW",
			"cioc": "",
			"currency": [
				"ANG"
			],
			"callingCode": [
				"5999"
			],
			"capital": "Willemstad",
			"altSpellings": [
				"CW",
				"Curacao",
				"Kòrsou",
				"Country of Curaçao",
				"Land Curaçao",
				"Pais Kòrsou"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English",
				"nld": "Dutch",
				"pap": "Papiamento"
			},
			"translations": {
				"deu": {
					"official": "Land Curaçao",
					"common": "Curaçao"
				},
				"fra": {
					"official": "Curaçao",
					"common": "Curaçao"
				},
				"nld": {
					"official": "Land Curaçao",
					"common": "Curaçao"
				},
				"por": {
					"official": "País de Curaçao",
					"common": "ilha da Curação"
				},
				"rus": {
					"official": "Страна Кюрасао",
					"common": "Кюрасао"
				},
				"slk": {
					"official": "Curacao",
					"common": "Curacao"
				},
				"spa": {
					"official": "País de Curazao",
					"common": "Curazao"
				},
				"fin": {
					"official": "Curaçao",
					"common": "Curaçao"
				},
				"zho": {
					"official": "库拉索",
					"common": "库拉索"
				}
			},
			"latlng": [
				12.116667,
				-68.933333
			],
			"demonym": "Dutch",
			"landlocked": false,
			"borders": [],
			"area": 444
		},
		{
			"name": {
				"common": "Christmas Island",
				"official": "Territory of Christmas Island",
				"native": {
					"eng": {
						"official": "Territory of Christmas Island",
						"common": "Christmas Island"
					}
				}
			},
			"tld": [
				".cx"
			],
			"cca2": "CX",
			"ccn3": "162",
			"cca3": "CXR",
			"cioc": "",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"61"
			],
			"capital": "Flying Fish Cove",
			"altSpellings": [
				"CX",
				"Territory of Christmas Island"
			],
			"region": "Oceania",
			"subregion": "Australia and New Zealand",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Territory of Christmas Island",
					"common": "Ynys y Nadolig"
				},
				"deu": {
					"official": "Gebiet der Weihnachtsinsel",
					"common": "Weihnachtsinsel"
				},
				"fra": {
					"official": "Territoire de l'île Christmas",
					"common": "Île Christmas"
				},
				"hrv": {
					"official": "Teritorij Božićni otok",
					"common": "Božićni otok"
				},
				"ita": {
					"official": "Territorio di Christmas Island",
					"common": "Isola di Natale"
				},
				"jpn": {
					"official": "クリスマス島の領土",
					"common": "クリスマス島"
				},
				"nld": {
					"official": "Grondgebied van Christmas Island",
					"common": "Christmaseiland"
				},
				"por": {
					"official": "Território da Ilha Christmas",
					"common": "Ilha do Natal"
				},
				"rus": {
					"official": "Территория острова Рождества",
					"common": "Остров Рождества"
				},
				"slk": {
					"official": "Teritórium Vianočného ostrova",
					"common": "Vianočnú ostrov"
				},
				"spa": {
					"official": "Territorio de la Isla de Navidad",
					"common": "Isla de Navidad"
				},
				"fin": {
					"official": "Joulusaaren alue",
					"common": "Joulusaari"
				},
				"zho": {
					"official": "圣诞岛",
					"common": "圣诞岛"
				}
			},
			"latlng": [
				-10.5,
				105.66666666
			],
			"demonym": "Christmas Islander",
			"landlocked": false,
			"borders": [],
			"area": 135
		},
		{
			"name": {
				"common": "Cayman Islands",
				"official": "Cayman Islands",
				"native": {
					"eng": {
						"official": "Cayman Islands",
						"common": "Cayman Islands"
					}
				}
			},
			"tld": [
				".ky"
			],
			"cca2": "KY",
			"ccn3": "136",
			"cca3": "CYM",
			"cioc": "CAY",
			"currency": [
				"KYD"
			],
			"callingCode": [
				"1345"
			],
			"capital": "George Town",
			"altSpellings": [
				"KY"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Cayman Islands",
					"common": "Ynysoedd_Cayman"
				},
				"deu": {
					"official": "Cayman-Inseln",
					"common": "Kaimaninseln"
				},
				"fra": {
					"official": "Îles Caïmans",
					"common": "Îles Caïmans"
				},
				"hrv": {
					"official": "Kajmanski otoci",
					"common": "Kajmanski otoci"
				},
				"ita": {
					"official": "Isole Cayman",
					"common": "Isole Cayman"
				},
				"jpn": {
					"official": "ケイマン諸島",
					"common": "ケイマン諸島"
				},
				"nld": {
					"official": "Caymaneilanden",
					"common": "Caymaneilanden"
				},
				"por": {
					"official": "Ilhas Cayman",
					"common": "Ilhas Caimão"
				},
				"rus": {
					"official": "Каймановы острова",
					"common": "Каймановы острова"
				},
				"slk": {
					"official": "Kajmanie ostrovy",
					"common": "Kajmanie ostrovy"
				},
				"spa": {
					"official": "Islas Caimán",
					"common": "Islas Caimán"
				},
				"fin": {
					"official": "Caymansaaret",
					"common": "Caymansaaret"
				},
				"zho": {
					"official": "开曼群岛",
					"common": "开曼群岛"
				}
			},
			"latlng": [
				19.5,
				-80.5
			],
			"demonym": "Caymanian",
			"landlocked": false,
			"borders": [],
			"area": 264
		},
		{
			"name": {
				"common": "Cyprus",
				"official": "Republic of Cyprus",
				"native": {
					"ell": {
						"official": "Δημοκρατία της Κύπρος",
						"common": "Κύπρος"
					},
					"tur": {
						"official": "Kıbrıs Cumhuriyeti",
						"common": "Kıbrıs"
					}
				}
			},
			"tld": [
				".cy"
			],
			"cca2": "CY",
			"ccn3": "196",
			"cca3": "CYP",
			"cioc": "CYP",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"357"
			],
			"capital": "Nicosia",
			"altSpellings": [
				"CY",
				"Kýpros",
				"Kıbrıs",
				"Republic of Cyprus",
				"Κυπριακή Δημοκρατία",
				"Kıbrıs Cumhuriyeti"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"ell": "Greek",
				"tur": "Turkish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Cyprus",
					"common": "Cyprus"
				},
				"deu": {
					"official": "Republik Zypern",
					"common": "Zypern"
				},
				"fra": {
					"official": "République de Chypre",
					"common": "Chypre"
				},
				"hrv": {
					"official": "Republika Cipar",
					"common": "Cipar"
				},
				"ita": {
					"official": "Repubblica di Cipro",
					"common": "Cipro"
				},
				"jpn": {
					"official": "キプロス共和国",
					"common": "キプロス"
				},
				"nld": {
					"official": "Republiek Cyprus",
					"common": "Cyprus"
				},
				"por": {
					"official": "República de Chipre",
					"common": "Chipre"
				},
				"rus": {
					"official": "Республика Кипр",
					"common": "Кипр"
				},
				"slk": {
					"official": "Cyperská republika",
					"common": "Cyprus"
				},
				"spa": {
					"official": "República de Chipre",
					"common": "Chipre"
				},
				"fin": {
					"official": "Kyproksen tasavalta",
					"common": "Kypros"
				},
				"zho": {
					"official": "塞浦路斯共和国",
					"common": "塞浦路斯"
				}
			},
			"latlng": [
				35,
				33
			],
			"demonym": "Cypriot",
			"landlocked": false,
			"borders": [
				"GBR"
			],
			"area": 9251
		},
		{
			"name": {
				"common": "Czechia",
				"official": "Czech Republic",
				"native": {
					"ces": {
						"official": "česká republika",
						"common": "Česko"
					},
					"slk": {
						"official": "Česká republika",
						"common": "Česko"
					}
				}
			},
			"tld": [
				".cz"
			],
			"cca2": "CZ",
			"ccn3": "203",
			"cca3": "CZE",
			"cioc": "CZE",
			"currency": [
				"CZK"
			],
			"callingCode": [
				"420"
			],
			"capital": "Prague",
			"altSpellings": [
				"CZ",
				"Česká republika",
				"Česko"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"ces": "Czech",
				"slk": "Slovak"
			},
			"translations": {
				"cym": {
					"official": "Czech Republic",
					"common": "Y Weriniaeth Tsiec"
				},
				"deu": {
					"official": "Tschechische Republik",
					"common": "Tschechien"
				},
				"fra": {
					"official": "République tchèque",
					"common": "Tchéquie"
				},
				"hrv": {
					"official": "Češka",
					"common": "Češka"
				},
				"ita": {
					"official": "Repubblica Ceca",
					"common": "Cechia"
				},
				"jpn": {
					"official": "チェコ共和国",
					"common": "チェコ"
				},
				"nld": {
					"official": "Tsjechische Republiek",
					"common": "Tsjechië"
				},
				"por": {
					"official": "República Checa",
					"common": "Chéquia"
				},
				"rus": {
					"official": "Чешская Республика",
					"common": "Чехия"
				},
				"slk": {
					"official": "Česká republika",
					"common": "Česko"
				},
				"spa": {
					"official": "República Checa",
					"common": "Chequia"
				},
				"fin": {
					"official": "Tšekin tasavalta",
					"common": "Tšekki"
				},
				"zho": {
					"official": "捷克共和国",
					"common": "捷克"
				}
			},
			"latlng": [
				49.75,
				15.5
			],
			"demonym": "Czech",
			"landlocked": true,
			"borders": [
				"AUT",
				"DEU",
				"POL",
				"SVK"
			],
			"area": 78865
		},
		{
			"name": {
				"common": "Germany",
				"official": "Federal Republic of Germany",
				"native": {
					"deu": {
						"official": "Bundesrepublik Deutschland",
						"common": "Deutschland"
					}
				}
			},
			"tld": [
				".de"
			],
			"cca2": "DE",
			"ccn3": "276",
			"cca3": "DEU",
			"cioc": "GER",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"49"
			],
			"capital": "Berlin",
			"altSpellings": [
				"DE",
				"Federal Republic of Germany",
				"Bundesrepublik Deutschland"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"deu": "German"
			},
			"translations": {
				"deu": {
					"official": "Bundesrepublik Deutschland",
					"common": "Deutschland"
				},
				"fra": {
					"official": "République fédérale d'Allemagne",
					"common": "Allemagne"
				},
				"hrv": {
					"official": "Njemačka Federativna Republika",
					"common": "Njemačka"
				},
				"ita": {
					"official": "Repubblica federale di Germania",
					"common": "Germania"
				},
				"jpn": {
					"official": "ドイツ連邦共和国",
					"common": "ドイツ"
				},
				"nld": {
					"official": "Bondsrepubliek Duitsland",
					"common": "Duitsland"
				},
				"por": {
					"official": "República Federal da Alemanha",
					"common": "Alemanha"
				},
				"rus": {
					"official": "Федеративная Республика Германия",
					"common": "Германия"
				},
				"slk": {
					"official": "Nemecká spolková republika",
					"common": "Nemecko"
				},
				"spa": {
					"official": "República Federal de Alemania",
					"common": "Alemania"
				},
				"fin": {
					"official": "Saksan liittotasavalta",
					"common": "Saksa"
				},
				"zho": {
					"official": "德意志联邦共和国",
					"common": "德国"
				}
			},
			"latlng": [
				51,
				9
			],
			"demonym": "German",
			"landlocked": false,
			"borders": [
				"AUT",
				"BEL",
				"CZE",
				"DNK",
				"FRA",
				"LUX",
				"NLD",
				"POL",
				"CHE"
			],
			"area": 357114
		},
		{
			"name": {
				"common": "Djibouti",
				"official": "Republic of Djibouti",
				"native": {
					"ara": {
						"official": "جمهورية جيبوتي",
						"common": "جيبوتي‎"
					},
					"fra": {
						"official": "République de Djibouti",
						"common": "Djibouti"
					}
				}
			},
			"tld": [
				".dj"
			],
			"cca2": "DJ",
			"ccn3": "262",
			"cca3": "DJI",
			"cioc": "DJI",
			"currency": [
				"DJF"
			],
			"callingCode": [
				"253"
			],
			"capital": "Djibouti",
			"altSpellings": [
				"DJ",
				"Jabuuti",
				"Gabuuti",
				"Republic of Djibouti",
				"République de Djibouti",
				"Gabuutih Ummuuno",
				"Jamhuuriyadda Jabuuti"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"ara": "Arabic",
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Republic of Djibouti",
					"common": "Djibouti"
				},
				"deu": {
					"official": "Republik Dschibuti",
					"common": "Dschibuti"
				},
				"fra": {
					"official": "République de Djibouti",
					"common": "Djibouti"
				},
				"hrv": {
					"official": "Republika Džibuti",
					"common": "Džibuti"
				},
				"ita": {
					"official": "Repubblica di Gibuti",
					"common": "Gibuti"
				},
				"jpn": {
					"official": "ジブチ共和国",
					"common": "ジブチ"
				},
				"nld": {
					"official": "Republiek Djibouti",
					"common": "Djibouti"
				},
				"por": {
					"official": "República do Djibouti",
					"common": "Djibouti"
				},
				"rus": {
					"official": "Республика Джибути",
					"common": "Джибути"
				},
				"slk": {
					"official": "ǅibutská republika",
					"common": "ǅibutsko"
				},
				"spa": {
					"official": "República de Djibouti",
					"common": "Djibouti"
				},
				"fin": {
					"official": "Dijiboutin tasavalta",
					"common": "Dijibouti"
				},
				"zho": {
					"official": "吉布提共和国",
					"common": "吉布提"
				}
			},
			"latlng": [
				11.5,
				43
			],
			"demonym": "Djibouti",
			"landlocked": false,
			"borders": [
				"ERI",
				"ETH",
				"SOM"
			],
			"area": 23200
		},
		{
			"name": {
				"common": "Dominica",
				"official": "Commonwealth of Dominica",
				"native": {
					"eng": {
						"official": "Commonwealth of Dominica",
						"common": "Dominica"
					}
				}
			},
			"tld": [
				".dm"
			],
			"cca2": "DM",
			"ccn3": "212",
			"cca3": "DMA",
			"cioc": "DMA",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1767"
			],
			"capital": "Roseau",
			"altSpellings": [
				"DM",
				"Dominique",
				"Wai‘tu kubuli",
				"Commonwealth of Dominica"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "Commonwealth of Dominica",
					"common": "Dominica"
				},
				"deu": {
					"official": "Commonwealth von Dominica",
					"common": "Dominica"
				},
				"fra": {
					"official": "Commonwealth de la Dominique",
					"common": "Dominique"
				},
				"hrv": {
					"official": "Zajednica Dominika",
					"common": "Dominika"
				},
				"ita": {
					"official": "Commonwealth di Dominica",
					"common": "Dominica"
				},
				"jpn": {
					"official": "ドミニカ国",
					"common": "ドミニカ国"
				},
				"nld": {
					"official": "Gemenebest Dominica",
					"common": "Dominica"
				},
				"por": {
					"official": "Comunidade da Dominica",
					"common": "Dominica"
				},
				"rus": {
					"official": "Содружество Доминики",
					"common": "Доминика"
				},
				"slk": {
					"official": "Dominické spoločenstvo",
					"common": "Dominika"
				},
				"spa": {
					"official": "Mancomunidad de Dominica",
					"common": "Dominica"
				},
				"fin": {
					"official": "Dominican liittovaltio",
					"common": "Dominica"
				},
				"zho": {
					"official": "多米尼加共和国",
					"common": "多米尼加"
				}
			},
			"latlng": [
				15.41666666,
				-61.33333333
			],
			"demonym": "Dominican",
			"landlocked": false,
			"borders": [],
			"area": 751
		},
		{
			"name": {
				"common": "Denmark",
				"official": "Kingdom of Denmark",
				"native": {
					"dan": {
						"official": "Kongeriget Danmark",
						"common": "Danmark"
					}
				}
			},
			"tld": [
				".dk"
			],
			"cca2": "DK",
			"ccn3": "208",
			"cca3": "DNK",
			"cioc": "DEN",
			"currency": [
				"DKK"
			],
			"callingCode": [
				"45"
			],
			"capital": "Copenhagen",
			"altSpellings": [
				"DK",
				"Danmark",
				"Kingdom of Denmark",
				"Kongeriget Danmark"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"dan": "Danish"
			},
			"translations": {
				"cym": {
					"official": "Kingdom of Denmark",
					"common": "Denmarc"
				},
				"deu": {
					"official": "Königreich Dänemark",
					"common": "Dänemark"
				},
				"fra": {
					"official": "Royaume du Danemark",
					"common": "Danemark"
				},
				"hrv": {
					"official": "Kraljevina Danska",
					"common": "Danska"
				},
				"ita": {
					"official": "Regno di Danimarca",
					"common": "Danimarca"
				},
				"jpn": {
					"official": "デンマーク王国",
					"common": "デンマーク"
				},
				"nld": {
					"official": "Koninkrijk Denemarken",
					"common": "Denemarken"
				},
				"por": {
					"official": "Reino da Dinamarca",
					"common": "Dinamarca"
				},
				"rus": {
					"official": "Королевство Дания",
					"common": "Дания"
				},
				"slk": {
					"official": "Dánske kráľovstvo",
					"common": "Dánsko"
				},
				"spa": {
					"official": "Reino de Dinamarca",
					"common": "Dinamarca"
				},
				"fin": {
					"official": "Tanskan kuningaskunta",
					"common": "Tanska"
				},
				"zho": {
					"official": "丹麦王国",
					"common": "丹麦"
				}
			},
			"latlng": [
				56,
				10
			],
			"demonym": "Danish",
			"landlocked": false,
			"borders": [
				"DEU"
			],
			"area": 43094
		},
		{
			"name": {
				"common": "Dominican Republic",
				"official": "Dominican Republic",
				"native": {
					"spa": {
						"official": "República Dominicana",
						"common": "República Dominicana"
					}
				}
			},
			"tld": [
				".do"
			],
			"cca2": "DO",
			"ccn3": "214",
			"cca3": "DOM",
			"cioc": "DOM",
			"currency": [
				"DOP"
			],
			"callingCode": [
				"1809",
				"1829",
				"1849"
			],
			"capital": "Santo Domingo",
			"altSpellings": [
				"DO"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Dominican Republic",
					"common": "Gweriniaeth_Dominica"
				},
				"deu": {
					"official": "Dominikanische Republik",
					"common": "Dominikanische Republik"
				},
				"fra": {
					"official": "République Dominicaine",
					"common": "République dominicaine"
				},
				"hrv": {
					"official": "Dominikanska Republika",
					"common": "Dominikanska Republika"
				},
				"ita": {
					"official": "Repubblica Dominicana",
					"common": "Repubblica Dominicana"
				},
				"jpn": {
					"official": "ドミニカ共和国",
					"common": "ドミニカ共和国"
				},
				"nld": {
					"official": "Dominicaanse Republiek",
					"common": "Dominicaanse Republiek"
				},
				"por": {
					"official": "República Dominicana",
					"common": "República Dominicana"
				},
				"rus": {
					"official": "Доминиканская Республика",
					"common": "Доминиканская Республика"
				},
				"slk": {
					"official": "Dominikánska republika",
					"common": "Dominikánska republika"
				},
				"spa": {
					"official": "República Dominicana",
					"common": "República Dominicana"
				},
				"fin": {
					"official": "Dominikaaninen tasavalta",
					"common": "Dominikaaninen tasavalta"
				},
				"zho": {
					"official": "多明尼加共和国",
					"common": "多明尼加"
				}
			},
			"latlng": [
				19,
				-70.66666666
			],
			"demonym": "Dominican",
			"landlocked": false,
			"borders": [
				"HTI"
			],
			"area": 48671
		},
		{
			"name": {
				"common": "Algeria",
				"official": "People's Democratic Republic of Algeria",
				"native": {
					"ara": {
						"official": "الجمهورية الديمقراطية الشعبية الجزائرية",
						"common": "الجزائر"
					}
				}
			},
			"tld": [
				".dz",
				"الجزائر."
			],
			"cca2": "DZ",
			"ccn3": "012",
			"cca3": "DZA",
			"cioc": "ALG",
			"currency": [
				"DZD"
			],
			"callingCode": [
				"213"
			],
			"capital": "Algiers",
			"altSpellings": [
				"DZ",
				"Dzayer",
				"Algérie"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"cym": {
					"official": "People's Democratic Republic of Algeria",
					"common": "Algeria"
				},
				"deu": {
					"official": "Demokratische Volksrepublik Algerien",
					"common": "Algerien"
				},
				"fra": {
					"official": "République démocratique et populaire d'Algérie",
					"common": "Algérie"
				},
				"hrv": {
					"official": "Narodna Demokratska Republika Alžir",
					"common": "Alžir"
				},
				"ita": {
					"official": "Repubblica popolare democratica di Algeria",
					"common": "Algeria"
				},
				"jpn": {
					"official": "アルジェリア人民民主共和国",
					"common": "アルジェリア"
				},
				"nld": {
					"official": "Democratische Volksrepubliek Algerije",
					"common": "Algerije"
				},
				"por": {
					"official": "República Argelina Democrática e Popular",
					"common": "Argélia"
				},
				"rus": {
					"official": "Народно-Демократическая Республика Алжир",
					"common": "Алжир"
				},
				"slk": {
					"official": "Alžírska demokratická ľudová republika",
					"common": "Alžírsko"
				},
				"spa": {
					"official": "República Argelina Democrática y Popular",
					"common": "Argelia"
				},
				"fin": {
					"official": "Algerian demokraattinen kansantasavalta",
					"common": "Algeria"
				},
				"zho": {
					"official": "阿尔及利亚人民民主共和国",
					"common": "阿尔及利亚"
				}
			},
			"latlng": [
				28,
				3
			],
			"demonym": "Algerian",
			"landlocked": false,
			"borders": [
				"TUN",
				"LBY",
				"NER",
				"ESH",
				"MRT",
				"MLI",
				"MAR"
			],
			"area": 2381741
		},
		{
			"name": {
				"common": "Ecuador",
				"official": "Republic of Ecuador",
				"native": {
					"spa": {
						"official": "República del Ecuador",
						"common": "Ecuador"
					}
				}
			},
			"tld": [
				".ec"
			],
			"cca2": "EC",
			"ccn3": "218",
			"cca3": "ECU",
			"cioc": "ECU",
			"currency": [
				"USD"
			],
			"callingCode": [
				"593"
			],
			"capital": "Quito",
			"altSpellings": [
				"EC",
				"Republic of Ecuador",
				"República del Ecuador"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Ecuador",
					"common": "Ecwador"
				},
				"deu": {
					"official": "Republik Ecuador",
					"common": "Ecuador"
				},
				"fra": {
					"official": "République de l'Équateur",
					"common": "Équateur"
				},
				"hrv": {
					"official": "Republika Ekvador",
					"common": "Ekvador"
				},
				"ita": {
					"official": "Repubblica dell'Ecuador",
					"common": "Ecuador"
				},
				"jpn": {
					"official": "エクアドル共和国",
					"common": "エクアドル"
				},
				"nld": {
					"official": "Republiek Ecuador",
					"common": "Ecuador"
				},
				"por": {
					"official": "República do Equador",
					"common": "Equador"
				},
				"rus": {
					"official": "Республика Эквадор",
					"common": "Эквадор"
				},
				"slk": {
					"official": "Ekvádorská republika",
					"common": "Ekvádor"
				},
				"spa": {
					"official": "República del Ecuador",
					"common": "Ecuador"
				},
				"fin": {
					"official": "Ecuadorin tasavalta",
					"common": "Ecuador"
				},
				"zho": {
					"official": "厄瓜多尔共和国",
					"common": "厄瓜多尔"
				}
			},
			"latlng": [
				-2,
				-77.5
			],
			"demonym": "Ecuadorean",
			"landlocked": false,
			"borders": [
				"COL",
				"PER"
			],
			"area": 276841
		},
		{
			"name": {
				"common": "Egypt",
				"official": "Arab Republic of Egypt",
				"native": {
					"ara": {
						"official": "جمهورية مصر العربية",
						"common": "مصر"
					}
				}
			},
			"tld": [
				".eg",
				".مصر"
			],
			"cca2": "EG",
			"ccn3": "818",
			"cca3": "EGY",
			"cioc": "EGY",
			"currency": [
				"EGP"
			],
			"callingCode": [
				"20"
			],
			"capital": "Cairo",
			"altSpellings": [
				"EG",
				"Arab Republic of Egypt"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"cym": {
					"official": "Arab Republic of Egypt",
					"common": "Yr Aifft"
				},
				"deu": {
					"official": "Arabische Republik Ägypten",
					"common": "Ägypten"
				},
				"fra": {
					"official": "République arabe d'Égypte",
					"common": "Égypte"
				},
				"hrv": {
					"official": "Arapska Republika Egipat",
					"common": "Egipat"
				},
				"ita": {
					"official": "Repubblica araba d'Egitto",
					"common": "Egitto"
				},
				"jpn": {
					"official": "エジプト·アラブ共和国",
					"common": "エジプト"
				},
				"nld": {
					"official": "Arabische Republiek Egypte",
					"common": "Egypte"
				},
				"por": {
					"official": "República Árabe do Egipto",
					"common": "Egito"
				},
				"rus": {
					"official": "Арабская Республика Египет",
					"common": "Египет"
				},
				"slk": {
					"official": "Egyptská arabská republika",
					"common": "Egypt"
				},
				"spa": {
					"official": "República Árabe de Egipto",
					"common": "Egipto"
				},
				"fin": {
					"official": "Egyptin arabitasavalta",
					"common": "Egypti"
				},
				"zho": {
					"official": "阿拉伯埃及共和国",
					"common": "埃及"
				}
			},
			"latlng": [
				27,
				30
			],
			"demonym": "Egyptian",
			"landlocked": false,
			"borders": [
				"ISR",
				"LBY",
				"SDN"
			],
			"area": 1002450
		},
		{
			"name": {
				"common": "Eritrea",
				"official": "State of Eritrea",
				"native": {
					"ara": {
						"official": "دولة إرتريا",
						"common": "إرتريا‎"
					},
					"eng": {
						"official": "State of Eritrea",
						"common": "Eritrea"
					},
					"tir": {
						"official": "ሃገረ ኤርትራ",
						"common": "ኤርትራ"
					}
				}
			},
			"tld": [
				".er"
			],
			"cca2": "ER",
			"ccn3": "232",
			"cca3": "ERI",
			"cioc": "ERI",
			"currency": [
				"ERN"
			],
			"callingCode": [
				"291"
			],
			"capital": "Asmara",
			"altSpellings": [
				"ER",
				"State of Eritrea",
				"ሃገረ ኤርትራ",
				"Dawlat Iritriyá",
				"ʾErtrā",
				"Iritriyā"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"ara": "Arabic",
				"eng": "English",
				"tir": "Tigrinya"
			},
			"translations": {
				"cym": {
					"official": "State of Eritrea",
					"common": "Eritrea"
				},
				"deu": {
					"official": "Staat Eritrea",
					"common": "Eritrea"
				},
				"fra": {
					"official": "État d'Érythrée",
					"common": "Érythrée"
				},
				"hrv": {
					"official": "Država Eritreji",
					"common": "Eritreja"
				},
				"ita": {
					"official": "Stato di Eritrea",
					"common": "Eritrea"
				},
				"jpn": {
					"official": "エリトリア国",
					"common": "エリトリア"
				},
				"nld": {
					"official": "Staat Eritrea",
					"common": "Eritrea"
				},
				"por": {
					"official": "Estado da Eritreia",
					"common": "Eritreia"
				},
				"rus": {
					"official": "Государство Эритрея",
					"common": "Эритрея"
				},
				"slk": {
					"official": "Eritrejský štát",
					"common": "Eritrea"
				},
				"spa": {
					"official": "Estado de Eritrea",
					"common": "Eritrea"
				},
				"fin": {
					"official": "Eritrean valtio",
					"common": "Eritrea"
				},
				"zho": {
					"official": "厄立特里亚",
					"common": "厄立特里亚"
				}
			},
			"latlng": [
				15,
				39
			],
			"demonym": "Eritrean",
			"landlocked": false,
			"borders": [
				"DJI",
				"ETH",
				"SDN"
			],
			"area": 117600
		},
		{
			"name": {
				"common": "Western Sahara",
				"official": "Sahrawi Arab Democratic Republic",
				"native": {
					"ber": {
						"official": "Sahrawi Arab Democratic Republic",
						"common": "Western Sahara"
					},
					"mey": {
						"official": "الجمهورية العربية الصحراوية الديمقراطية",
						"common": "الصحراء الغربية"
					},
					"spa": {
						"official": "República Árabe Saharaui Democrática",
						"common": "Sahara Occidental"
					}
				}
			},
			"tld": [
				".eh"
			],
			"cca2": "EH",
			"ccn3": "732",
			"cca3": "ESH",
			"cioc": "",
			"currency": [
				"MAD",
				"DZD",
				"MRO"
			],
			"callingCode": [
				"212"
			],
			"capital": "El Aaiún",
			"altSpellings": [
				"EH",
				"Taneẓroft Tutrimt"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ber": "Berber",
				"mey": "Hassaniya",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Demokratische Arabische Republik Sahara",
					"common": "Westsahara"
				},
				"fra": {
					"official": "République arabe sahraouie démocratique",
					"common": "Sahara Occidental"
				},
				"hrv": {
					"official": "Sahrawi Arab Demokratska Republika",
					"common": "Zapadna Sahara"
				},
				"ita": {
					"official": "Repubblica Araba Saharawi Democratica",
					"common": "Sahara Occidentale"
				},
				"jpn": {
					"official": "サハラアラブ民主共和国",
					"common": "西サハラ"
				},
				"nld": {
					"official": "Sahrawi Arabische Democratische Republiek",
					"common": "Westelijke Sahara"
				},
				"por": {
					"official": "República Árabe Saharaui Democrática",
					"common": "Saara Ocidental"
				},
				"rus": {
					"official": "Sahrawi Арабская Демократическая Республика",
					"common": "Западная Сахара"
				},
				"slk": {
					"official": "Západná Sahara",
					"common": "Západná Sahara"
				},
				"spa": {
					"official": "República Árabe Saharaui Democrática",
					"common": "Sahara Occidental"
				},
				"fin": {
					"official": "Länsi-Sahara",
					"common": "Länsi-Sahara"
				},
				"zho": {
					"official": "阿拉伯撒哈拉民主共和国",
					"common": "西撒哈拉"
				}
			},
			"latlng": [
				24.5,
				-13
			],
			"demonym": "Sahrawi",
			"landlocked": false,
			"borders": [
				"DZA",
				"MRT",
				"MAR"
			],
			"area": 266000
		},
		{
			"name": {
				"common": "Spain",
				"official": "Kingdom of Spain",
				"native": {
					"cat": {
						"official": "Regne d'Espanya",
						"common": "Espanya"
					},
					"eus": {
						"official": "Espainiako Erresuma",
						"common": "Espainia"
					},
					"glg": {
						"official": "Reino de España",
						"common": ""
					},
					"oci": {
						"official": "Reialme d'Espanha",
						"common": "Espanha"
					},
					"spa": {
						"official": "Reino de España",
						"common": "España"
					}
				}
			},
			"tld": [
				".es"
			],
			"cca2": "ES",
			"ccn3": "724",
			"cca3": "ESP",
			"cioc": "ESP",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"34"
			],
			"capital": "Madrid",
			"altSpellings": [
				"ES",
				"Kingdom of Spain",
				"Reino de España"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"cat": "Catalan",
				"eus": "Basque",
				"glg": "Galician",
				"oci": "Occitan",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Königreich Spanien",
					"common": "Spanien"
				},
				"fra": {
					"official": "Royaume d'Espagne",
					"common": "Espagne"
				},
				"hrv": {
					"official": "Kraljevina Španjolska",
					"common": "Španjolska"
				},
				"ita": {
					"official": "Regno di Spagna",
					"common": "Spagna"
				},
				"jpn": {
					"official": "スペイン王国",
					"common": "スペイン"
				},
				"nld": {
					"official": "Koninkrijk Spanje",
					"common": "Spanje"
				},
				"por": {
					"official": "Reino de Espanha",
					"common": "Espanha"
				},
				"rus": {
					"official": "Королевство Испания",
					"common": "Испания"
				},
				"slk": {
					"official": "Španielske kráľovstvo",
					"common": "Španielsko"
				},
				"spa": {
					"official": "Reino de España",
					"common": "España"
				},
				"fin": {
					"official": "Espanjan kuningaskunta",
					"common": "Espanja"
				},
				"zho": {
					"official": "西班牙王国",
					"common": "西班牙"
				}
			},
			"latlng": [
				40,
				-4
			],
			"demonym": "Spanish",
			"landlocked": false,
			"borders": [
				"AND",
				"FRA",
				"GIB",
				"PRT",
				"MAR"
			],
			"area": 505992
		},
		{
			"name": {
				"common": "Estonia",
				"official": "Republic of Estonia",
				"native": {
					"est": {
						"official": "Eesti Vabariik",
						"common": "Eesti"
					}
				}
			},
			"tld": [
				".ee"
			],
			"cca2": "EE",
			"ccn3": "233",
			"cca3": "EST",
			"cioc": "EST",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"372"
			],
			"capital": "Tallinn",
			"altSpellings": [
				"EE",
				"Eesti",
				"Republic of Estonia",
				"Eesti Vabariik"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"est": "Estonian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Estonia",
					"common": "Estonia"
				},
				"deu": {
					"official": "Republik Estland",
					"common": "Estland"
				},
				"fra": {
					"official": "République d'Estonie",
					"common": "Estonie"
				},
				"hrv": {
					"official": "Republika Estonija",
					"common": "Estonija"
				},
				"ita": {
					"official": "Repubblica di Estonia",
					"common": "Estonia"
				},
				"jpn": {
					"official": "エストニア共和国",
					"common": "エストニア"
				},
				"nld": {
					"official": "Republiek Estland",
					"common": "Estland"
				},
				"por": {
					"official": "República da Estónia",
					"common": "Estónia"
				},
				"rus": {
					"official": "Эстонская Республика",
					"common": "Эстония"
				},
				"slk": {
					"official": "Estónska republika",
					"common": "Estónsko"
				},
				"spa": {
					"official": "República de Estonia",
					"common": "Estonia"
				},
				"fin": {
					"official": "Viron tasavalta",
					"common": "Viro"
				},
				"zho": {
					"official": "爱沙尼亚共和国",
					"common": "爱沙尼亚"
				}
			},
			"latlng": [
				59,
				26
			],
			"demonym": "Estonian",
			"landlocked": false,
			"borders": [
				"LVA",
				"RUS"
			],
			"area": 45227
		},
		{
			"name": {
				"common": "Ethiopia",
				"official": "Federal Democratic Republic of Ethiopia",
				"native": {
					"amh": {
						"official": "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",
						"common": "ኢትዮጵያ"
					}
				}
			},
			"tld": [
				".et"
			],
			"cca2": "ET",
			"ccn3": "231",
			"cca3": "ETH",
			"cioc": "ETH",
			"currency": [
				"ETB"
			],
			"callingCode": [
				"251"
			],
			"capital": "Addis Ababa",
			"altSpellings": [
				"ET",
				"ʾĪtyōṗṗyā",
				"Federal Democratic Republic of Ethiopia",
				"የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"amh": "Amharic"
			},
			"translations": {
				"cym": {
					"official": "Federal Democratic Republic of Ethiopia",
					"common": "Ethiopia"
				},
				"deu": {
					"official": "Demokratische Bundesrepublik Äthiopien",
					"common": "Äthiopien"
				},
				"fra": {
					"official": "République fédérale démocratique d'Éthiopie",
					"common": "Éthiopie"
				},
				"hrv": {
					"official": "Savezna Demokratska Republika Etiopija",
					"common": "Etiopija"
				},
				"ita": {
					"official": "Repubblica federale democratica di Etiopia",
					"common": "Etiopia"
				},
				"jpn": {
					"official": "エチオピア連邦民主共和国",
					"common": "エチオピア"
				},
				"nld": {
					"official": "Federale Democratische Republiek Ethiopië",
					"common": "Ethiopië"
				},
				"por": {
					"official": "República Federal Democrática da Etiópia",
					"common": "Etiópia"
				},
				"rus": {
					"official": "Федеративная Демократическая Республика Эфиопия",
					"common": "Эфиопия"
				},
				"slk": {
					"official": "Etiópska federatívna demokratická republika",
					"common": "Etiópia"
				},
				"spa": {
					"official": "República Democrática Federal de Etiopía",
					"common": "Etiopía"
				},
				"fin": {
					"official": "Etiopian demokraattinen liittotasavalta",
					"common": "Etiopia"
				},
				"zho": {
					"official": "埃塞俄比亚联邦民主共和国",
					"common": "埃塞俄比亚"
				}
			},
			"latlng": [
				8,
				38
			],
			"demonym": "Ethiopian",
			"landlocked": true,
			"borders": [
				"DJI",
				"ERI",
				"KEN",
				"SOM",
				"SSD",
				"SDN"
			],
			"area": 1104300
		},
		{
			"name": {
				"common": "Finland",
				"official": "Republic of Finland",
				"native": {
					"fin": {
						"official": "Suomen tasavalta",
						"common": "Suomi"
					},
					"swe": {
						"official": "Republiken Finland",
						"common": "Finland"
					}
				}
			},
			"tld": [
				".fi"
			],
			"cca2": "FI",
			"ccn3": "246",
			"cca3": "FIN",
			"cioc": "FIN",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"358"
			],
			"capital": "Helsinki",
			"altSpellings": [
				"FI",
				"Suomi",
				"Republic of Finland",
				"Suomen tasavalta",
				"Republiken Finland"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"fin": "Finnish",
				"swe": "Swedish"
			},
			"translations": {
				"deu": {
					"official": "Republik Finnland",
					"common": "Finnland"
				},
				"fra": {
					"official": "République de Finlande",
					"common": "Finlande"
				},
				"hrv": {
					"official": "Republika Finska",
					"common": "Finska"
				},
				"ita": {
					"official": "Repubblica di Finlandia",
					"common": "Finlandia"
				},
				"jpn": {
					"official": "フィンランド共和国",
					"common": "フィンランド"
				},
				"nld": {
					"official": "Republiek Finland",
					"common": "Finland"
				},
				"por": {
					"official": "República da Finlândia",
					"common": "Finlândia"
				},
				"rus": {
					"official": "Финляндская Республика",
					"common": "Финляндия"
				},
				"slk": {
					"official": "Fínska republika",
					"common": "Fínsko"
				},
				"spa": {
					"official": "República de Finlandia",
					"common": "Finlandia"
				},
				"fin": {
					"official": "Suomen tasavalta",
					"common": "Suomi"
				},
				"zho": {
					"official": "芬兰共和国",
					"common": "芬兰"
				}
			},
			"latlng": [
				64,
				26
			],
			"demonym": "Finnish",
			"landlocked": false,
			"borders": [
				"NOR",
				"SWE",
				"RUS"
			],
			"area": 338424
		},
		{
			"name": {
				"common": "Fiji",
				"official": "Republic of Fiji",
				"native": {
					"eng": {
						"official": "Republic of Fiji",
						"common": "Fiji"
					},
					"fij": {
						"official": "Matanitu Tugalala o Viti",
						"common": "Viti"
					},
					"hif": {
						"official": "रिपब्लिक ऑफ फीजी",
						"common": "फिजी"
					}
				}
			},
			"tld": [
				".fj"
			],
			"cca2": "FJ",
			"ccn3": "242",
			"cca3": "FJI",
			"cioc": "FIJ",
			"currency": [
				"FJD"
			],
			"callingCode": [
				"679"
			],
			"capital": "Suva",
			"altSpellings": [
				"FJ",
				"Viti",
				"Republic of Fiji",
				"Matanitu ko Viti",
				"Fijī Gaṇarājya"
			],
			"region": "Oceania",
			"subregion": "Melanesia",
			"languages": {
				"eng": "English",
				"fij": "Fijian",
				"hif": "Fiji Hindi"
			},
			"translations": {
				"deu": {
					"official": "Republik Fidschi",
					"common": "Fidschi"
				},
				"fra": {
					"official": "République des Fidji",
					"common": "Fidji"
				},
				"hrv": {
					"official": "Republika Fidži",
					"common": "Fiđi"
				},
				"ita": {
					"official": "Repubblica di Figi",
					"common": "Figi"
				},
				"jpn": {
					"official": "フィジー共和国",
					"common": "フィジー"
				},
				"nld": {
					"official": "Republiek Fiji",
					"common": "Fiji"
				},
				"por": {
					"official": "República de Fiji",
					"common": "Fiji"
				},
				"rus": {
					"official": "Республика Фиджи",
					"common": "Фиджи"
				},
				"slk": {
					"official": "Fiǆijská republika",
					"common": "Fiǆi"
				},
				"spa": {
					"official": "República de Fiji",
					"common": "Fiyi"
				},
				"fin": {
					"official": "Fidžin tasavalta",
					"common": "Fidži"
				},
				"zho": {
					"official": "斐济共和国",
					"common": "斐济"
				}
			},
			"latlng": [
				-18,
				175
			],
			"demonym": "Fijian",
			"landlocked": false,
			"borders": [],
			"area": 18272
		},
		{
			"name": {
				"common": "Falkland Islands",
				"official": "Falkland Islands",
				"native": {
					"eng": {
						"official": "Falkland Islands",
						"common": "Falkland Islands"
					}
				}
			},
			"tld": [
				".fk"
			],
			"cca2": "FK",
			"ccn3": "238",
			"cca3": "FLK",
			"cioc": "",
			"currency": [
				"FKP"
			],
			"callingCode": [
				"500"
			],
			"capital": "Stanley",
			"altSpellings": [
				"FK",
				"Islas Malvinas",
				"Falkland Islands (Malvinas)"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Falkland-Inseln",
					"common": "Falklandinseln"
				},
				"fra": {
					"official": "Îles Malouines",
					"common": "Îles Malouines"
				},
				"hrv": {
					"official": "Falklandski otoci",
					"common": "Falklandski Otoci"
				},
				"ita": {
					"official": "Isole Falkland",
					"common": "Isole Falkland o Isole Malvine"
				},
				"jpn": {
					"official": "フォークランド",
					"common": "フォークランド（マルビナス）諸島"
				},
				"nld": {
					"official": "Falkland eilanden",
					"common": "Falklandeilanden"
				},
				"por": {
					"official": "Ilhas Malvinas",
					"common": "Ilhas Malvinas"
				},
				"rus": {
					"official": "Фолклендские острова",
					"common": "Фолклендские острова"
				},
				"slk": {
					"official": "Falklandské ostrovy",
					"common": "Falklandy"
				},
				"spa": {
					"official": "islas Malvinas",
					"common": "Islas Malvinas"
				},
				"fin": {
					"official": "Falkandinsaaret",
					"common": "Falkandinsaaret"
				},
				"zho": {
					"official": "福克兰群岛",
					"common": "福克兰群岛"
				}
			},
			"latlng": [
				-51.75,
				-59
			],
			"demonym": "Falkland Islander",
			"landlocked": false,
			"borders": [],
			"area": 12173
		},
		{
			"name": {
				"common": "France",
				"official": "French Republic",
				"native": {
					"fra": {
						"official": "République française",
						"common": "France"
					}
				}
			},
			"tld": [
				".fr"
			],
			"cca2": "FR",
			"ccn3": "250",
			"cca3": "FRA",
			"cioc": "FRA",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"33"
			],
			"capital": "Paris",
			"altSpellings": [
				"FR",
				"French Republic",
				"République française"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Französische Republik",
					"common": "Frankreich"
				},
				"fra": {
					"official": "République française",
					"common": "France"
				},
				"hrv": {
					"official": "Francuska Republika",
					"common": "Francuska"
				},
				"ita": {
					"official": "Repubblica francese",
					"common": "Francia"
				},
				"jpn": {
					"official": "フランス共和国",
					"common": "フランス"
				},
				"nld": {
					"official": "Franse Republiek",
					"common": "Frankrijk"
				},
				"por": {
					"official": "República Francesa",
					"common": "França"
				},
				"rus": {
					"official": "Французская Республика",
					"common": "Франция"
				},
				"slk": {
					"official": "Francúzska republika",
					"common": "Francúzsko"
				},
				"spa": {
					"official": "República francés",
					"common": "Francia"
				},
				"fin": {
					"official": "Ranskan tasavalta",
					"common": "Ranska"
				},
				"zho": {
					"official": "法兰西共和国",
					"common": "法国"
				}
			},
			"latlng": [
				46,
				2
			],
			"demonym": "French",
			"landlocked": false,
			"borders": [
				"AND",
				"BEL",
				"DEU",
				"ITA",
				"LUX",
				"MCO",
				"ESP",
				"CHE"
			],
			"area": 551695
		},
		{
			"name": {
				"common": "Faroe Islands",
				"official": "Faroe Islands",
				"native": {
					"dan": {
						"official": "Færøerne",
						"common": "Færøerne"
					},
					"fao": {
						"official": "Føroyar",
						"common": "Føroyar"
					}
				}
			},
			"tld": [
				".fo"
			],
			"cca2": "FO",
			"ccn3": "234",
			"cca3": "FRO",
			"cioc": "",
			"currency": [
				"DKK"
			],
			"callingCode": [
				"298"
			],
			"capital": "Tórshavn",
			"altSpellings": [
				"FO",
				"Føroyar",
				"Færøerne"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"dan": "Danish",
				"fao": "Faroese"
			},
			"translations": {
				"deu": {
					"official": "Färöer",
					"common": "Färöer-Inseln"
				},
				"fra": {
					"official": "Îles Féroé",
					"common": "Îles Féroé"
				},
				"hrv": {
					"official": "Farski Otoci",
					"common": "Farski Otoci"
				},
				"ita": {
					"official": "Isole Faroe",
					"common": "Isole Far Oer"
				},
				"jpn": {
					"official": "フェロー諸島",
					"common": "フェロー諸島"
				},
				"nld": {
					"official": "Faeröer",
					"common": "Faeröer"
				},
				"por": {
					"official": "Ilhas Faroe",
					"common": "Ilhas Faroé"
				},
				"rus": {
					"official": "Фарерские острова",
					"common": "Фарерские острова"
				},
				"slk": {
					"official": "Faerské ostrovy",
					"common": "Faerské ostrovy"
				},
				"spa": {
					"official": "Islas Feroe",
					"common": "Islas Faroe"
				},
				"fin": {
					"official": "Färsaaret",
					"common": "Färsaaret"
				},
				"zho": {
					"official": "法罗群岛",
					"common": "法罗群岛"
				}
			},
			"latlng": [
				62,
				-7
			],
			"demonym": "Faroese",
			"landlocked": false,
			"borders": [],
			"area": 1393
		},
		{
			"name": {
				"common": "Micronesia",
				"official": "Federated States of Micronesia",
				"native": {
					"eng": {
						"official": "Federated States of Micronesia",
						"common": "Micronesia"
					}
				}
			},
			"tld": [
				".fm"
			],
			"cca2": "FM",
			"ccn3": "583",
			"cca3": "FSM",
			"cioc": "FSM",
			"currency": [
				"USD"
			],
			"callingCode": [
				"691"
			],
			"capital": "Palikir",
			"altSpellings": [
				"FM",
				"Federated States of Micronesia",
				"Micronesia, Federated States of"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Föderierte Staaten von Mikronesien",
					"common": "Mikronesien"
				},
				"fra": {
					"official": "États fédérés de Micronésie",
					"common": "Micronésie"
				},
				"hrv": {
					"official": "Savezne Države Mikronezije",
					"common": "Mikronezija"
				},
				"ita": {
					"official": "Stati federati di Micronesia",
					"common": "Micronesia"
				},
				"jpn": {
					"official": "ミクロネシア連邦",
					"common": "ミクロネシア連邦"
				},
				"nld": {
					"official": "Federale Staten van Micronesia",
					"common": "Micronesië"
				},
				"por": {
					"official": "Estados Federados da Micronésia",
					"common": "Micronésia"
				},
				"rus": {
					"official": "Федеративные Штаты Микронезии",
					"common": "Федеративные Штаты Микронезии"
				},
				"slk": {
					"official": "Mikron/u00e9zske federatívne štáty",
					"common": "Mikronézia"
				},
				"spa": {
					"official": "Estados Federados de Micronesia",
					"common": "Micronesia"
				},
				"fin": {
					"official": "Mikronesian liittovaltio",
					"common": "Mikronesia"
				},
				"zho": {
					"official": "密克罗尼西亚联邦",
					"common": "密克罗尼西亚"
				}
			},
			"latlng": [
				6.91666666,
				158.25
			],
			"demonym": "Micronesian",
			"landlocked": false,
			"borders": [],
			"area": 702
		},
		{
			"name": {
				"common": "Gabon",
				"official": "Gabonese Republic",
				"native": {
					"fra": {
						"official": "République gabonaise",
						"common": "Gabon"
					}
				}
			},
			"tld": [
				".ga"
			],
			"cca2": "GA",
			"ccn3": "266",
			"cca3": "GAB",
			"cioc": "GAB",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"241"
			],
			"capital": "Libreville",
			"altSpellings": [
				"GA",
				"Gabonese Republic",
				"République Gabonaise"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Gabunische Republik",
					"common": "Gabun"
				},
				"fra": {
					"official": "République gabonaise",
					"common": "Gabon"
				},
				"hrv": {
					"official": "Gabon Republika",
					"common": "Gabon"
				},
				"ita": {
					"official": "Repubblica gabonese",
					"common": "Gabon"
				},
				"jpn": {
					"official": "ガボン共和国",
					"common": "ガボン"
				},
				"nld": {
					"official": "Republiek Gabon",
					"common": "Gabon"
				},
				"por": {
					"official": "República do Gabão",
					"common": "Gabão"
				},
				"rus": {
					"official": "Габона Республика",
					"common": "Габон"
				},
				"slk": {
					"official": "Gabonská republika",
					"common": "Gabon"
				},
				"spa": {
					"official": "República de Gabón",
					"common": "Gabón"
				},
				"fin": {
					"official": "Gabonin tasavalta",
					"common": "Gabon"
				},
				"zho": {
					"official": "加蓬共和国",
					"common": "加蓬"
				}
			},
			"latlng": [
				-1,
				11.75
			],
			"demonym": "Gabonese",
			"landlocked": false,
			"borders": [
				"CMR",
				"COG",
				"GNQ"
			],
			"area": 267668
		},
		{
			"name": {
				"common": "United Kingdom",
				"official": "United Kingdom of Great Britain and Northern Ireland",
				"native": {
					"eng": {
						"official": "United Kingdom of Great Britain and Northern Ireland",
						"common": "United Kingdom"
					}
				}
			},
			"tld": [
				".uk"
			],
			"cca2": "GB",
			"ccn3": "826",
			"cca3": "GBR",
			"cioc": "GBR",
			"currency": [
				"GBP"
			],
			"callingCode": [
				"44"
			],
			"capital": "London",
			"altSpellings": [
				"GB",
				"UK",
				"Great Britain"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Vereinigtes Königreich Großbritannien und Nordirland",
					"common": "Vereinigtes Königreich"
				},
				"fra": {
					"official": "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
					"common": "Royaume-Uni"
				},
				"hrv": {
					"official": "Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske",
					"common": "Ujedinjeno Kraljevstvo"
				},
				"ita": {
					"official": "Regno Unito di Gran Bretagna e Irlanda del Nord",
					"common": "Regno Unito"
				},
				"jpn": {
					"official": "グレート·ブリテンおよび北アイルランド連合王国",
					"common": "イギリス"
				},
				"nld": {
					"official": "Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland",
					"common": "Verenigd Koninkrijk"
				},
				"por": {
					"official": "Reino Unido da Grã-Bretanha e Irlanda do Norte",
					"common": "Reino Unido"
				},
				"rus": {
					"official": "Соединенное Королевство Великобритании и Северной Ирландии",
					"common": "Великобритания"
				},
				"slk": {
					"official": "Spojené kráľovstvo Veľkej Británie a SevernéhoÌrska",
					"common": "Veľká Británia (Spojené kráľovstvo)"
				},
				"spa": {
					"official": "Reino Unido de Gran Bretaña e Irlanda del Norte",
					"common": "Reino Unido"
				},
				"fin": {
					"official": "Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta",
					"common": "Yhdistynyt kuningaskunta"
				},
				"zho": {
					"official": "大不列颠及北爱尔兰联合王国",
					"common": "英国"
				}
			},
			"latlng": [
				54,
				-2
			],
			"demonym": "British",
			"landlocked": false,
			"borders": [
				"IRL"
			],
			"area": 242900
		},
		{
			"name": {
				"common": "Georgia",
				"official": "Georgia",
				"native": {
					"kat": {
						"official": "საქართველო",
						"common": "საქართველო"
					}
				}
			},
			"tld": [
				".ge"
			],
			"cca2": "GE",
			"ccn3": "268",
			"cca3": "GEO",
			"cioc": "GEO",
			"currency": [
				"GEL"
			],
			"callingCode": [
				"995"
			],
			"capital": "Tbilisi",
			"altSpellings": [
				"GE",
				"Sakartvelo"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"kat": "Georgian"
			},
			"translations": {
				"deu": {
					"official": "Georgia",
					"common": "Georgien"
				},
				"fra": {
					"official": "République de Géorgie",
					"common": "Géorgie"
				},
				"hrv": {
					"official": "Gruzija",
					"common": "Gruzija"
				},
				"ita": {
					"official": "Georgia",
					"common": "Georgia"
				},
				"jpn": {
					"official": "グルジア",
					"common": "グルジア"
				},
				"nld": {
					"official": "Georgia",
					"common": "Georgië"
				},
				"por": {
					"official": "Georgia",
					"common": "Geórgia"
				},
				"rus": {
					"official": "Грузия",
					"common": "Грузия"
				},
				"slk": {
					"official": "Gruzínsko",
					"common": "Gruzínsko"
				},
				"spa": {
					"official": "Georgia",
					"common": "Georgia"
				},
				"fin": {
					"official": "Georgia",
					"common": "Georgia"
				},
				"zho": {
					"official": "格鲁吉亚",
					"common": "格鲁吉亚"
				}
			},
			"latlng": [
				42,
				43.5
			],
			"demonym": "Georgian",
			"landlocked": false,
			"borders": [
				"ARM",
				"AZE",
				"RUS",
				"TUR"
			],
			"area": 69700
		},
		{
			"name": {
				"common": "Guernsey",
				"official": "Bailiwick of Guernsey",
				"native": {
					"eng": {
						"official": "Bailiwick of Guernsey",
						"common": "Guernsey"
					},
					"fra": {
						"official": "Bailliage de Guernesey",
						"common": "Guernesey"
					},
					"nfr": {
						"official": "Dgèrnésiais",
						"common": "Dgèrnésiais"
					}
				}
			},
			"tld": [
				".gg"
			],
			"cca2": "GG",
			"ccn3": "831",
			"cca3": "GGY",
			"cioc": "",
			"currency": [
				"GBP"
			],
			"callingCode": [
				"44"
			],
			"capital": "St. Peter Port",
			"altSpellings": [
				"GG",
				"Bailiwick of Guernsey",
				"Bailliage de Guernesey"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"eng": "English",
				"fra": "French",
				"nfr": "Guernésiais"
			},
			"translations": {
				"deu": {
					"official": "Guernsey",
					"common": "Guernsey"
				},
				"fra": {
					"official": "Bailliage de Guernesey",
					"common": "Guernesey"
				},
				"hrv": {
					"official": "Struka Guernsey",
					"common": "Guernsey"
				},
				"ita": {
					"official": "Baliato di Guernsey",
					"common": "Guernsey"
				},
				"jpn": {
					"official": "ガーンジーの得意分野",
					"common": "ガーンジー"
				},
				"nld": {
					"official": "Baljuwschap Guernsey",
					"common": "Guernsey"
				},
				"por": {
					"official": "Bailiado de Guernsey",
					"common": "Guernsey"
				},
				"rus": {
					"official": "Коронное владение Гернси",
					"common": "Гернси"
				},
				"slk": {
					"official": "Guernsey",
					"common": "Guernsey"
				},
				"spa": {
					"official": "Bailía de Guernsey",
					"common": "Guernsey"
				},
				"fin": {
					"official": "Guernsey",
					"common": "Guernsey"
				},
				"zho": {
					"official": "根西岛",
					"common": "根西岛"
				}
			},
			"latlng": [
				49.46666666,
				-2.58333333
			],
			"demonym": "Channel Islander",
			"landlocked": false,
			"borders": [],
			"area": 78
		},
		{
			"name": {
				"common": "Ghana",
				"official": "Republic of Ghana",
				"native": {
					"eng": {
						"official": "Republic of Ghana",
						"common": "Ghana"
					}
				}
			},
			"tld": [
				".gh"
			],
			"cca2": "GH",
			"ccn3": "288",
			"cca3": "GHA",
			"cioc": "GHA",
			"currency": [
				"GHS"
			],
			"callingCode": [
				"233"
			],
			"capital": "Accra",
			"altSpellings": [
				"GH"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Ghana",
					"common": "Ghana"
				},
				"fra": {
					"official": "République du Ghana",
					"common": "Ghana"
				},
				"hrv": {
					"official": "Republika Gana",
					"common": "Gana"
				},
				"ita": {
					"official": "Repubblica del Ghana",
					"common": "Ghana"
				},
				"jpn": {
					"official": "ガーナ共和国",
					"common": "ガーナ"
				},
				"nld": {
					"official": "Republiek Ghana",
					"common": "Ghana"
				},
				"por": {
					"official": "República do Gana",
					"common": "Gana"
				},
				"rus": {
					"official": "Республика Гана",
					"common": "Гана"
				},
				"slk": {
					"official": "Ghansk/u00e1 republika",
					"common": "Ghana"
				},
				"spa": {
					"official": "República de Ghana",
					"common": "Ghana"
				},
				"fin": {
					"official": "Ghanan tasavalta",
					"common": "Ghana"
				},
				"zho": {
					"official": "加纳共和国",
					"common": "加纳"
				}
			},
			"latlng": [
				8,
				-2
			],
			"demonym": "Ghanaian",
			"landlocked": false,
			"borders": [
				"BFA",
				"CIV",
				"TGO"
			],
			"area": 238533
		},
		{
			"name": {
				"common": "Gibraltar",
				"official": "Gibraltar",
				"native": {
					"eng": {
						"official": "Gibraltar",
						"common": "Gibraltar"
					}
				}
			},
			"tld": [
				".gi"
			],
			"cca2": "GI",
			"ccn3": "292",
			"cca3": "GIB",
			"cioc": "",
			"currency": [
				"GIP"
			],
			"callingCode": [
				"350"
			],
			"capital": "Gibraltar",
			"altSpellings": [
				"GI"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"fra": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"hrv": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"ita": {
					"official": "Gibilterra",
					"common": "Gibilterra"
				},
				"jpn": {
					"official": "ジブラルタル",
					"common": "ジブラルタル"
				},
				"nld": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"por": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"rus": {
					"official": "Гибралтар",
					"common": "Гибралтар"
				},
				"slk": {
					"official": "Gibraltár",
					"common": "Gibraltár"
				},
				"spa": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"fin": {
					"official": "Gibraltar",
					"common": "Gibraltar"
				},
				"zho": {
					"official": "直布罗陀",
					"common": "直布罗陀"
				}
			},
			"latlng": [
				36.13333333,
				-5.35
			],
			"demonym": "Gibraltar",
			"landlocked": false,
			"borders": [
				"ESP"
			],
			"area": 6
		},
		{
			"name": {
				"common": "Guinea",
				"official": "Republic of Guinea",
				"native": {
					"fra": {
						"official": "République de Guinée",
						"common": "Guinée"
					}
				}
			},
			"tld": [
				".gn"
			],
			"cca2": "GN",
			"ccn3": "324",
			"cca3": "GIN",
			"cioc": "GUI",
			"currency": [
				"GNF"
			],
			"callingCode": [
				"224"
			],
			"capital": "Conakry",
			"altSpellings": [
				"GN",
				"Republic of Guinea",
				"République de Guinée"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Guinea",
					"common": "Guinea"
				},
				"fra": {
					"official": "République de Guinée",
					"common": "Guinée"
				},
				"hrv": {
					"official": "Republika Gvineja",
					"common": "Gvineja"
				},
				"ita": {
					"official": "Repubblica di Guinea",
					"common": "Guinea"
				},
				"jpn": {
					"official": "ギニア共和国",
					"common": "ギニア"
				},
				"nld": {
					"official": "Republiek Guinee",
					"common": "Guinee"
				},
				"por": {
					"official": "República da Guiné",
					"common": "Guiné"
				},
				"rus": {
					"official": "Республика Гвинея",
					"common": "Гвинея"
				},
				"slk": {
					"official": "Guinejská republika",
					"common": "Guinea"
				},
				"spa": {
					"official": "República de Guinea",
					"common": "Guinea"
				},
				"fin": {
					"official": "Guinean tasavalta",
					"common": "Guinea"
				},
				"zho": {
					"official": "几内亚共和国",
					"common": "几内亚"
				}
			},
			"latlng": [
				11,
				-10
			],
			"demonym": "Guinean",
			"landlocked": false,
			"borders": [
				"CIV",
				"GNB",
				"LBR",
				"MLI",
				"SEN",
				"SLE"
			],
			"area": 245857
		},
		{
			"name": {
				"common": "Guadeloupe",
				"official": "Guadeloupe",
				"native": {
					"fra": {
						"official": "Guadeloupe",
						"common": "Guadeloupe"
					}
				}
			},
			"tld": [
				".gp"
			],
			"cca2": "GP",
			"ccn3": "312",
			"cca3": "GLP",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"590"
			],
			"capital": "Basse-Terre",
			"altSpellings": [
				"GP",
				"Gwadloup"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Guadeloupe",
					"common": "Guadeloupe"
				},
				"fra": {
					"official": "Guadeloupe",
					"common": "Guadeloupe"
				},
				"hrv": {
					"official": "Gvadalupa",
					"common": "Gvadalupa"
				},
				"ita": {
					"official": "Guadeloupe",
					"common": "Guadeloupa"
				},
				"jpn": {
					"official": "グアドループ島",
					"common": "グアドループ"
				},
				"nld": {
					"official": "Guadeloupe",
					"common": "Guadeloupe"
				},
				"por": {
					"official": "Guadalupe",
					"common": "Guadalupe"
				},
				"rus": {
					"official": "Гваделупа",
					"common": "Гваделупа"
				},
				"slk": {
					"official": "Guadeloupe",
					"common": "Guadeloupe"
				},
				"spa": {
					"official": "Guadalupe",
					"common": "Guadalupe"
				},
				"fin": {
					"official": "Guadeloupen departmentti",
					"common": "Guadeloupe"
				},
				"zho": {
					"official": "瓜德罗普岛",
					"common": "瓜德罗普岛"
				}
			},
			"latlng": [
				16.25,
				-61.583333
			],
			"demonym": "Guadeloupian",
			"landlocked": false,
			"borders": [],
			"area": 1628
		},
		{
			"name": {
				"common": "Gambia",
				"official": "Republic of the Gambia",
				"native": {
					"eng": {
						"official": "Republic of the Gambia",
						"common": "Gambia"
					}
				}
			},
			"tld": [
				".gm"
			],
			"cca2": "GM",
			"ccn3": "270",
			"cca3": "GMB",
			"cioc": "GAM",
			"currency": [
				"GMD"
			],
			"callingCode": [
				"220"
			],
			"capital": "Banjul",
			"altSpellings": [
				"GM",
				"Republic of the Gambia"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Gambia",
					"common": "Gambia"
				},
				"fra": {
					"official": "République de Gambie",
					"common": "Gambie"
				},
				"hrv": {
					"official": "Republika Gambija",
					"common": "Gambija"
				},
				"ita": {
					"official": "Repubblica del Gambia",
					"common": "Gambia"
				},
				"jpn": {
					"official": "ガンビア共和国",
					"common": "ガンビア"
				},
				"nld": {
					"official": "Republiek Gambia",
					"common": "Gambia"
				},
				"por": {
					"official": "República da Gâmbia",
					"common": "Gâmbia"
				},
				"rus": {
					"official": "Республика Гамбия",
					"common": "Гамбия"
				},
				"slk": {
					"official": "Gambijsk/u00e1 republika",
					"common": "Gambia"
				},
				"spa": {
					"official": "República de Gambia",
					"common": "Gambia"
				},
				"fin": {
					"official": "Gambian tasavalta",
					"common": "Gambia"
				},
				"zho": {
					"official": "冈比亚共和国",
					"common": "冈比亚"
				}
			},
			"latlng": [
				13.46666666,
				-16.56666666
			],
			"demonym": "Gambian",
			"landlocked": false,
			"borders": [
				"SEN"
			],
			"area": 10689
		},
		{
			"name": {
				"common": "Guinea-Bissau",
				"official": "Republic of Guinea-Bissau",
				"native": {
					"por": {
						"official": "República da Guiné-Bissau",
						"common": "Guiné-Bissau"
					}
				}
			},
			"tld": [
				".gw"
			],
			"cca2": "GW",
			"ccn3": "624",
			"cca3": "GNB",
			"cioc": "GBS",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"245"
			],
			"capital": "Bissau",
			"altSpellings": [
				"GW",
				"Republic of Guinea-Bissau",
				"República da Guiné-Bissau"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"deu": {
					"official": "Republik Guinea-Bissau",
					"common": "Guinea-Bissau"
				},
				"fra": {
					"official": "République de Guinée-Bissau",
					"common": "Guinée-Bissau"
				},
				"hrv": {
					"official": "Republika Gvineja Bisau",
					"common": "Gvineja Bisau"
				},
				"ita": {
					"official": "Repubblica di Guinea-Bissau",
					"common": "Guinea-Bissau"
				},
				"jpn": {
					"official": "ギニアビサウ共和国",
					"common": "ギニアビサウ"
				},
				"nld": {
					"official": "Republiek Guinee-Bissau",
					"common": "Guinee-Bissau"
				},
				"por": {
					"official": "República da Guiné-Bissau",
					"common": "Guiné-Bissau"
				},
				"rus": {
					"official": "Республика Гвинея -Бисау",
					"common": "Гвинея-Бисау"
				},
				"slk": {
					"official": "Guinejsko-bissauská republika",
					"common": "Guinea-Bissau"
				},
				"spa": {
					"official": "República de Guinea-Bissau",
					"common": "Guinea-Bisáu"
				},
				"fin": {
					"official": "Guinea-Bissaun tasavalta",
					"common": "Guinea-Bissau"
				},
				"zho": {
					"official": "几内亚比绍共和国",
					"common": "几内亚比绍"
				}
			},
			"latlng": [
				12,
				-15
			],
			"demonym": "Guinea-Bissauan",
			"landlocked": false,
			"borders": [
				"GIN",
				"SEN"
			],
			"area": 36125
		},
		{
			"name": {
				"common": "Equatorial Guinea",
				"official": "Republic of Equatorial Guinea",
				"native": {
					"fra": {
						"official": "République de la Guinée Équatoriale",
						"common": "Guinée équatoriale"
					},
					"por": {
						"official": "República da Guiné Equatorial",
						"common": "Guiné Equatorial"
					},
					"spa": {
						"official": "República de Guinea Ecuatorial",
						"common": "Guinea Ecuatorial"
					}
				}
			},
			"tld": [
				".gq"
			],
			"cca2": "GQ",
			"ccn3": "226",
			"cca3": "GNQ",
			"cioc": "GEQ",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"240"
			],
			"capital": "Malabo",
			"altSpellings": [
				"GQ",
				"Republic of Equatorial Guinea",
				"República de Guinea Ecuatorial",
				"République de Guinée équatoriale",
				"República da Guiné Equatorial"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"fra": "French",
				"por": "Portuguese",
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of Equatorial Guinea",
					"common": "Gini Gyhydeddol"
				},
				"deu": {
					"official": "Republik Äquatorialguinea",
					"common": "Äquatorialguinea"
				},
				"fra": {
					"official": "République de Guinée équatoriale",
					"common": "Guinée équatoriale"
				},
				"hrv": {
					"official": "Republika Ekvatorska Gvineja",
					"common": "Ekvatorijalna Gvineja"
				},
				"ita": {
					"official": "Repubblica della Guinea Equatoriale",
					"common": "Guinea Equatoriale"
				},
				"jpn": {
					"official": "赤道ギニア共和国",
					"common": "赤道ギニア"
				},
				"nld": {
					"official": "Republiek Equatoriaal-Guinea",
					"common": "Equatoriaal-Guinea"
				},
				"por": {
					"official": "República da Guiné Equatorial",
					"common": "Guiné Equatorial"
				},
				"rus": {
					"official": "Республика Экваториальная Гвинея",
					"common": "Экваториальная Гвинея"
				},
				"slk": {
					"official": "Republika rovníkovej Guiney",
					"common": "Rovníková Guinea"
				},
				"spa": {
					"official": "República de Guinea Ecuatorial",
					"common": "Guinea Ecuatorial"
				},
				"fin": {
					"official": "Päiväntasaajan Guinean tasavalta",
					"common": "Päiväntasaajan Guinea"
				},
				"zho": {
					"official": "赤道几内亚共和国",
					"common": "赤道几内亚"
				}
			},
			"latlng": [
				2,
				10
			],
			"demonym": "Equatorial Guinean",
			"landlocked": false,
			"borders": [
				"CMR",
				"GAB"
			],
			"area": 28051
		},
		{
			"name": {
				"common": "Greece",
				"official": "Hellenic Republic",
				"native": {
					"ell": {
						"official": "Ελληνική Δημοκρατία",
						"common": "Ελλάδα"
					}
				}
			},
			"tld": [
				".gr"
			],
			"cca2": "GR",
			"ccn3": "300",
			"cca3": "GRC",
			"cioc": "GRE",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"30"
			],
			"capital": "Athens",
			"altSpellings": [
				"GR",
				"Elláda",
				"Hellenic Republic",
				"Ελληνική Δημοκρατία"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"ell": "Greek"
			},
			"translations": {
				"deu": {
					"official": "Hellenische Republik",
					"common": "Griechenland"
				},
				"fra": {
					"official": "République hellénique",
					"common": "Grèce"
				},
				"hrv": {
					"official": "Helenska Republika",
					"common": "Grčka"
				},
				"ita": {
					"official": "Repubblica ellenica",
					"common": "Grecia"
				},
				"jpn": {
					"official": "ギリシャ共和国",
					"common": "ギリシャ"
				},
				"nld": {
					"official": "Helleense Republiek",
					"common": "Griekenland"
				},
				"por": {
					"official": "República Helénica",
					"common": "Grécia"
				},
				"rus": {
					"official": "Греческая Республика",
					"common": "Греция"
				},
				"slk": {
					"official": "Grécka republika",
					"common": "Greécko"
				},
				"spa": {
					"official": "República Helénica",
					"common": "Grecia"
				},
				"fin": {
					"official": "Helleenien tasavalta",
					"common": "Kreikka"
				},
				"zho": {
					"official": "希腊共和国",
					"common": "希腊"
				}
			},
			"latlng": [
				39,
				22
			],
			"demonym": "Greek",
			"landlocked": false,
			"borders": [
				"ALB",
				"BGR",
				"TUR",
				"MKD"
			],
			"area": 131990
		},
		{
			"name": {
				"common": "Grenada",
				"official": "Grenada",
				"native": {
					"eng": {
						"official": "Grenada",
						"common": "Grenada"
					}
				}
			},
			"tld": [
				".gd"
			],
			"cca2": "GD",
			"ccn3": "308",
			"cca3": "GRD",
			"cioc": "GRN",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1473"
			],
			"capital": "St. George's",
			"altSpellings": [
				"GD"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"fra": {
					"official": "Grenade",
					"common": "Grenade"
				},
				"hrv": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"ita": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"jpn": {
					"official": "グレナダ",
					"common": "グレナダ"
				},
				"nld": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"por": {
					"official": "Grenada",
					"common": "Granada"
				},
				"rus": {
					"official": "Гренада",
					"common": "Гренада"
				},
				"slk": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"spa": {
					"official": "Granada",
					"common": "Grenada"
				},
				"fin": {
					"official": "Grenada",
					"common": "Grenada"
				},
				"zho": {
					"official": "格林纳达",
					"common": "格林纳达"
				}
			},
			"latlng": [
				12.11666666,
				-61.66666666
			],
			"demonym": "Grenadian",
			"landlocked": false,
			"borders": [],
			"area": 344
		},
		{
			"name": {
				"common": "Greenland",
				"official": "Greenland",
				"native": {
					"kal": {
						"official": "Kalaallit Nunaat",
						"common": "Kalaallit Nunaat"
					}
				}
			},
			"tld": [
				".gl"
			],
			"cca2": "GL",
			"ccn3": "304",
			"cca3": "GRL",
			"cioc": "",
			"currency": [
				"DKK"
			],
			"callingCode": [
				"299"
			],
			"capital": "Nuuk",
			"altSpellings": [
				"GL",
				"Grønland"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"kal": "Greenlandic"
			},
			"translations": {
				"deu": {
					"official": "Grönland",
					"common": "Grönland"
				},
				"fra": {
					"official": "Groenland",
					"common": "Groenland"
				},
				"hrv": {
					"official": "Grenland",
					"common": "Grenland"
				},
				"ita": {
					"official": "Groenlandia",
					"common": "Groenlandia"
				},
				"jpn": {
					"official": "グリーンランド",
					"common": "グリーンランド"
				},
				"nld": {
					"official": "Groenland",
					"common": "Groenland"
				},
				"por": {
					"official": "Groenlândia",
					"common": "Gronelândia"
				},
				"rus": {
					"official": "Гренландия",
					"common": "Гренландия"
				},
				"slk": {
					"official": "Grónsko",
					"common": "Grónsko"
				},
				"spa": {
					"official": "Groenlandia",
					"common": "Groenlandia"
				},
				"fin": {
					"official": "Groönlanti",
					"common": "Groönlanti"
				},
				"zho": {
					"official": "格陵兰",
					"common": "格陵兰"
				}
			},
			"latlng": [
				72,
				-40
			],
			"demonym": "Greenlandic",
			"landlocked": false,
			"borders": [],
			"area": 2166086
		},
		{
			"name": {
				"common": "Guatemala",
				"official": "Republic of Guatemala",
				"native": {
					"spa": {
						"official": "República de Guatemala",
						"common": "Guatemala"
					}
				}
			},
			"tld": [
				".gt"
			],
			"cca2": "GT",
			"ccn3": "320",
			"cca3": "GTM",
			"cioc": "GUA",
			"currency": [
				"GTQ"
			],
			"callingCode": [
				"502"
			],
			"capital": "Guatemala City",
			"altSpellings": [
				"GT"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Guatemala",
					"common": "Guatemala"
				},
				"fra": {
					"official": "République du Guatemala",
					"common": "Guatemala"
				},
				"hrv": {
					"official": "Republika Gvatemala",
					"common": "Gvatemala"
				},
				"ita": {
					"official": "Repubblica del Guatemala",
					"common": "Guatemala"
				},
				"jpn": {
					"official": "グアテマラ共和国",
					"common": "グアテマラ"
				},
				"nld": {
					"official": "Republiek Guatemala",
					"common": "Guatemala"
				},
				"por": {
					"official": "República da Guatemala",
					"common": "Guatemala"
				},
				"rus": {
					"official": "Республика Гватемала",
					"common": "Гватемала"
				},
				"slk": {
					"official": "Guatemalská republika",
					"common": "Guatemala"
				},
				"spa": {
					"official": "República de Guatemala",
					"common": "Guatemala"
				},
				"fin": {
					"official": "Guatemalan tasavalta",
					"common": "Guatemala"
				},
				"zho": {
					"official": "危地马拉共和国",
					"common": "危地马拉"
				}
			},
			"latlng": [
				15.5,
				-90.25
			],
			"demonym": "Guatemalan",
			"landlocked": false,
			"borders": [
				"BLZ",
				"SLV",
				"HND",
				"MEX"
			],
			"area": 108889
		},
		{
			"name": {
				"common": "French Guiana",
				"official": "Guiana",
				"native": {
					"fra": {
						"official": "Guyanes",
						"common": "Guyane française"
					}
				}
			},
			"tld": [
				".gf"
			],
			"cca2": "GF",
			"ccn3": "254",
			"cca3": "GUF",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"594"
			],
			"capital": "Cayenne",
			"altSpellings": [
				"GF",
				"Guiana",
				"Guyane"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Guayana",
					"common": "Französisch Guyana"
				},
				"fra": {
					"official": "Guyane",
					"common": "Guyane"
				},
				"hrv": {
					"official": "Gijana",
					"common": "Francuska Gvajana"
				},
				"ita": {
					"official": "Guiana",
					"common": "Guyana francese"
				},
				"jpn": {
					"official": "ギアナ",
					"common": "フランス領ギアナ"
				},
				"nld": {
					"official": "Guyana",
					"common": "Frans-Guyana"
				},
				"por": {
					"official": "Guiana",
					"common": "Guiana Francesa"
				},
				"rus": {
					"official": "Гвиана",
					"common": "Французская Гвиана"
				},
				"slk": {
					"official": "Francúzska Guyana",
					"common": "Guyana"
				},
				"spa": {
					"official": "Guayana",
					"common": "Guayana Francesa"
				},
				"fin": {
					"official": "Ranskan Guayana",
					"common": "Ranskan Guayana"
				},
				"zho": {
					"official": "法属圭亚那",
					"common": "法属圭亚那"
				}
			},
			"latlng": [
				4,
				-53
			],
			"demonym": "",
			"landlocked": false,
			"borders": [
				"BRA",
				"SUR"
			],
			"area": 83534
		},
		{
			"name": {
				"common": "Guam",
				"official": "Guam",
				"native": {
					"cha": {
						"official": "Guåhån",
						"common": "Guåhån"
					},
					"eng": {
						"official": "Guam",
						"common": "Guam"
					},
					"spa": {
						"official": "Guam",
						"common": "Guam"
					}
				}
			},
			"tld": [
				".gu"
			],
			"cca2": "GU",
			"ccn3": "316",
			"cca3": "GUM",
			"cioc": "GUM",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1671"
			],
			"capital": "Hagåtña",
			"altSpellings": [
				"GU",
				"Guåhån"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"cha": "Chamorro",
				"eng": "English",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Guam",
					"common": "Guam"
				},
				"fra": {
					"official": "Guam",
					"common": "Guam"
				},
				"hrv": {
					"official": "Guam",
					"common": "Guam"
				},
				"ita": {
					"official": "Guam",
					"common": "Guam"
				},
				"jpn": {
					"official": "グアム",
					"common": "グアム"
				},
				"nld": {
					"official": "Guam",
					"common": "Guam"
				},
				"por": {
					"official": "Guam",
					"common": "Guam"
				},
				"rus": {
					"official": "Гуам",
					"common": "Гуам"
				},
				"slk": {
					"official": "Guam",
					"common": "Guam"
				},
				"spa": {
					"official": "Guam",
					"common": "Guam"
				},
				"fin": {
					"official": "Guam",
					"common": "Guam"
				},
				"zho": {
					"official": "关岛",
					"common": "关岛"
				}
			},
			"latlng": [
				13.46666666,
				144.78333333
			],
			"demonym": "Guamanian",
			"landlocked": false,
			"borders": [],
			"area": 549
		},
		{
			"name": {
				"common": "Guyana",
				"official": "Co-operative Republic of Guyana",
				"native": {
					"eng": {
						"official": "Co-operative Republic of Guyana",
						"common": "Guyana"
					}
				}
			},
			"tld": [
				".gy"
			],
			"cca2": "GY",
			"ccn3": "328",
			"cca3": "GUY",
			"cioc": "GUY",
			"currency": [
				"GYD"
			],
			"callingCode": [
				"592"
			],
			"capital": "Georgetown",
			"altSpellings": [
				"GY",
				"Co-operative Republic of Guyana"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Kooperative Republik Guyana",
					"common": "Guyana"
				},
				"fra": {
					"official": "République coopérative de Guyana",
					"common": "Guyana"
				},
				"hrv": {
					"official": "Zadruga Republika Gvajana",
					"common": "Gvajana"
				},
				"ita": {
					"official": "Co -operative Republic of Guyana",
					"common": "Guyana"
				},
				"jpn": {
					"official": "ガイアナの協同共和国",
					"common": "ガイアナ"
				},
				"nld": {
					"official": "Coöperatieve Republiek Guyana",
					"common": "Guyana"
				},
				"por": {
					"official": "Co -operative República da Guiana",
					"common": "Guiana"
				},
				"rus": {
					"official": "Кооперативная Республика Гайана",
					"common": "Гайана"
				},
				"slk": {
					"official": "Guyanská kooperatívna republika",
					"common": "Guyana"
				},
				"spa": {
					"official": "República Cooperativa de Guyana",
					"common": "Guyana"
				},
				"fin": {
					"official": "Guayanan osuustoiminnallinen tasavalta",
					"common": "Guayana"
				},
				"zho": {
					"official": "圭亚那共和国",
					"common": "圭亚那"
				}
			},
			"latlng": [
				5,
				-59
			],
			"demonym": "Guyanese",
			"landlocked": false,
			"borders": [
				"BRA",
				"SUR",
				"VEN"
			],
			"area": 214969
		},
		{
			"name": {
				"common": "Hong Kong",
				"official": "Hong Kong Special Administrative Region of the People's Republic of China",
				"native": {
					"eng": {
						"official": "Hong Kong Special Administrative Region of the People's Republic of China",
						"common": "Hong Kong"
					},
					"zho": {
						"official": "中华人民共和国香港特别行政区",
						"common": "香港"
					}
				}
			},
			"tld": [
				".hk",
				".香港"
			],
			"cca2": "HK",
			"ccn3": "344",
			"cca3": "HKG",
			"cioc": "HKG",
			"currency": [
				"HKD"
			],
			"callingCode": [
				"852"
			],
			"capital": "City of Victoria",
			"altSpellings": [
				"HK"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"eng": "English",
				"zho": "Chinese"
			},
			"translations": {
				"deu": {
					"official": "Sonderverwaltungszone der Volksrepublik China",
					"common": "Hongkong"
				},
				"fra": {
					"official": "Région administrative spéciale de Hong Kong de la République populaire de Chine",
					"common": "Hong Kong"
				},
				"hrv": {
					"official": "Hong Kong Posebnog upravnog područjaNarodne Republike Kine",
					"common": "Hong Kong"
				},
				"ita": {
					"official": "Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese",
					"common": "Hong Kong"
				},
				"jpn": {
					"official": "中華人民共和国香港特別行政区",
					"common": "香港"
				},
				"nld": {
					"official": "Hong Kong Speciale Administratieve Regio van de Volksrepubliek China",
					"common": "Hongkong"
				},
				"por": {
					"official": "Hong Kong Região Administrativa Especial da República Popular da China",
					"common": "Hong Kong"
				},
				"rus": {
					"official": "Hong Kong Специальный административный район Китайской Народной Республики Китая",
					"common": "Гонконг"
				},
				"slk": {
					"official": "Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong",
					"common": "Hongkong"
				},
				"spa": {
					"official": "Hong Kong Región Administrativa Especial de la República Popular China",
					"common": "Hong Kong"
				},
				"fin": {
					"official": "Hong Kongin erityishallintoalue",
					"common": "Hongkong"
				}
			},
			"latlng": [
				22.267,
				114.188
			],
			"demonym": "Hong Konger",
			"landlocked": false,
			"borders": [
				"CHN"
			],
			"area": 1104
		},
		{
			"name": {
				"common": "Heard Island and McDonald Islands",
				"official": "Heard Island and McDonald Islands",
				"native": {
					"eng": {
						"official": "Heard Island and McDonald Islands",
						"common": "Heard Island and McDonald Islands"
					}
				}
			},
			"tld": [
				".hm",
				".aq"
			],
			"cca2": "HM",
			"ccn3": "334",
			"cca3": "HMD",
			"cioc": "",
			"currency": [
				"AUD"
			],
			"callingCode": [],
			"capital": "",
			"altSpellings": [
				"HM",
				"Heard Island and McDonald Islands"
			],
			"region": "",
			"subregion": "",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Heard und McDonaldinseln",
					"common": "Heard und die McDonaldinseln"
				},
				"fra": {
					"official": "Des îles Heard et McDonald",
					"common": "Îles Heard-et-MacDonald"
				},
				"hrv": {
					"official": "Otok Heard i otočje McDonald",
					"common": "Otok Heard i otočje McDonald"
				},
				"ita": {
					"official": "Isole Heard e McDonald",
					"common": "Isole Heard e McDonald"
				},
				"jpn": {
					"official": "ハード島とマクドナルド諸島",
					"common": "ハード島とマクドナルド諸島"
				},
				"nld": {
					"official": "Heard en McDonaldeilanden",
					"common": "Heard-en McDonaldeilanden"
				},
				"por": {
					"official": "Ilha Heard e Ilhas McDonald",
					"common": "Ilha Heard e Ilhas McDonald"
				},
				"rus": {
					"official": "Остров Херд и острова Макдональд",
					"common": "Остров Херд и острова Макдональд"
				},
				"slk": {
					"official": "Teritórium Heardovho ostrova a Macdonaldových ostrovov",
					"common": "Heardov ostrov"
				},
				"spa": {
					"official": "Islas Heard y McDonald",
					"common": "Islas Heard y McDonald"
				},
				"fin": {
					"official": "Heard ja McDonaldinsaaret",
					"common": "Heard ja McDonaldinsaaret"
				},
				"zho": {
					"official": "赫德岛和麦当劳群岛",
					"common": "赫德岛和麦当劳群岛"
				}
			},
			"latlng": [
				-53.1,
				72.51666666
			],
			"demonym": "Heard and McDonald Islander",
			"landlocked": false,
			"borders": [],
			"area": 412
		},
		{
			"name": {
				"common": "Honduras",
				"official": "Republic of Honduras",
				"native": {
					"spa": {
						"official": "República de Honduras",
						"common": "Honduras"
					}
				}
			},
			"tld": [
				".hn"
			],
			"cca2": "HN",
			"ccn3": "340",
			"cca3": "HND",
			"cioc": "HON",
			"currency": [
				"HNL"
			],
			"callingCode": [
				"504"
			],
			"capital": "Tegucigalpa",
			"altSpellings": [
				"HN",
				"Republic of Honduras",
				"República de Honduras"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Honduras",
					"common": "Honduras"
				},
				"fra": {
					"official": "République du Honduras",
					"common": "Honduras"
				},
				"hrv": {
					"official": "Republika Honduras",
					"common": "Honduras"
				},
				"ita": {
					"official": "Repubblica di Honduras",
					"common": "Honduras"
				},
				"jpn": {
					"official": "ホンジュラス共和国",
					"common": "ホンジュラス"
				},
				"nld": {
					"official": "Republiek Honduras",
					"common": "Honduras"
				},
				"por": {
					"official": "República de Honduras",
					"common": "Honduras"
				},
				"rus": {
					"official": "Республика Гондурас",
					"common": "Гондурас"
				},
				"slk": {
					"official": "Honduraská republika",
					"common": "Honduras"
				},
				"spa": {
					"official": "República de Honduras",
					"common": "Honduras"
				},
				"fin": {
					"official": "Hondurasin tasavalta",
					"common": "Honduras"
				},
				"zho": {
					"official": "洪都拉斯共和国",
					"common": "洪都拉斯"
				}
			},
			"latlng": [
				15,
				-86.5
			],
			"demonym": "Honduran",
			"landlocked": false,
			"borders": [
				"GTM",
				"SLV",
				"NIC"
			],
			"area": 112492
		},
		{
			"name": {
				"common": "Croatia",
				"official": "Republic of Croatia",
				"native": {
					"hrv": {
						"official": "Republika Hrvatska",
						"common": "Hrvatska"
					}
				}
			},
			"tld": [
				".hr"
			],
			"cca2": "HR",
			"ccn3": "191",
			"cca3": "HRV",
			"cioc": "CRO",
			"currency": [
				"HRK"
			],
			"callingCode": [
				"385"
			],
			"capital": "Zagreb",
			"altSpellings": [
				"HR",
				"Hrvatska",
				"Republic of Croatia",
				"Republika Hrvatska"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"hrv": "Croatian"
			},
			"translations": {
				"cym": {
					"official": "Republic of Croatia",
					"common": "Croatia"
				},
				"deu": {
					"official": "Republik Kroatien",
					"common": "Kroatien"
				},
				"fra": {
					"official": "République de Croatie",
					"common": "Croatie"
				},
				"hrv": {
					"official": "Republika Hrvatska",
					"common": "Hrvatska"
				},
				"ita": {
					"official": "Repubblica di Croazia",
					"common": "Croazia"
				},
				"jpn": {
					"official": "クロアチア共和国",
					"common": "クロアチア"
				},
				"nld": {
					"official": "Republiek Kroatië",
					"common": "Kroatië"
				},
				"por": {
					"official": "República da Croácia",
					"common": "Croácia"
				},
				"rus": {
					"official": "Республика Хорватия",
					"common": "Хорватия"
				},
				"slk": {
					"official": "Chorvátska republika",
					"common": "Chorvátsko"
				},
				"spa": {
					"official": "República de Croacia",
					"common": "Croacia"
				},
				"fin": {
					"official": "Kroatian tasavalta",
					"common": "Kroatia"
				},
				"zho": {
					"official": "克罗地亚共和国",
					"common": "克罗地亚"
				}
			},
			"latlng": [
				45.16666666,
				15.5
			],
			"demonym": "Croatian",
			"landlocked": false,
			"borders": [
				"BIH",
				"HUN",
				"MNE",
				"SRB",
				"SVN"
			],
			"area": 56594
		},
		{
			"name": {
				"common": "Haiti",
				"official": "Republic of Haiti",
				"native": {
					"fra": {
						"official": "République d'Haïti",
						"common": "Haïti"
					},
					"hat": {
						"official": "Repiblik Ayiti",
						"common": "Ayiti"
					}
				}
			},
			"tld": [
				".ht"
			],
			"cca2": "HT",
			"ccn3": "332",
			"cca3": "HTI",
			"cioc": "HAI",
			"currency": [
				"HTG",
				"USD"
			],
			"callingCode": [
				"509"
			],
			"capital": "Port-au-Prince",
			"altSpellings": [
				"HT",
				"Republic of Haiti",
				"République d'Haïti",
				"Repiblik Ayiti"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"fra": "French",
				"hat": "Haitian Creole"
			},
			"translations": {
				"deu": {
					"official": "Republik Haiti",
					"common": "Haiti"
				},
				"fra": {
					"official": "République d'Haïti",
					"common": "Haïti"
				},
				"hrv": {
					"official": "Republika Haiti",
					"common": "Haiti"
				},
				"ita": {
					"official": "Repubblica di Haiti",
					"common": "Haiti"
				},
				"jpn": {
					"official": "ハイチ共和国",
					"common": "ハイチ"
				},
				"nld": {
					"official": "Republiek Haïti",
					"common": "Haïti"
				},
				"por": {
					"official": "República do Haiti",
					"common": "Haiti"
				},
				"rus": {
					"official": "Республика Гаити",
					"common": "Гаити"
				},
				"slk": {
					"official": "Haitská republika",
					"common": "Haiti"
				},
				"spa": {
					"official": "República de Haití",
					"common": "Haiti"
				},
				"fin": {
					"official": "Haitin tasavalta",
					"common": "Haiti"
				},
				"zho": {
					"official": "海地共和国",
					"common": "海地"
				}
			},
			"latlng": [
				19,
				-72.41666666
			],
			"demonym": "Haitian",
			"landlocked": false,
			"borders": [
				"DOM"
			],
			"area": 27750
		},
		{
			"name": {
				"common": "Hungary",
				"official": "Hungary",
				"native": {
					"hun": {
						"official": "Magyarország",
						"common": "Magyarország"
					}
				}
			},
			"tld": [
				".hu"
			],
			"cca2": "HU",
			"ccn3": "348",
			"cca3": "HUN",
			"cioc": "HUN",
			"currency": [
				"HUF"
			],
			"callingCode": [
				"36"
			],
			"capital": "Budapest",
			"altSpellings": [
				"HU"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"hun": "Hungarian"
			},
			"translations": {
				"deu": {
					"official": "Ungarn",
					"common": "Ungarn"
				},
				"fra": {
					"official": "Hongrie",
					"common": "Hongrie"
				},
				"hrv": {
					"official": "Madžarska",
					"common": "Mađarska"
				},
				"ita": {
					"official": "Ungheria",
					"common": "Ungheria"
				},
				"jpn": {
					"official": "ハンガリー",
					"common": "ハンガリー"
				},
				"nld": {
					"official": "Hongarije",
					"common": "Hongarije"
				},
				"por": {
					"official": "Hungria",
					"common": "Hungria"
				},
				"rus": {
					"official": "Венгрия",
					"common": "Венгрия"
				},
				"slk": {
					"official": "Maďarsko",
					"common": "Maďarsko"
				},
				"spa": {
					"official": "Hungría",
					"common": "Hungría"
				},
				"fin": {
					"official": "Unkari",
					"common": "Unkari"
				},
				"zho": {
					"official": "匈牙利",
					"common": "匈牙利"
				}
			},
			"latlng": [
				47,
				20
			],
			"demonym": "Hungarian",
			"landlocked": true,
			"borders": [
				"AUT",
				"HRV",
				"ROU",
				"SRB",
				"SVK",
				"SVN",
				"UKR"
			],
			"area": 93028
		},
		{
			"name": {
				"common": "Indonesia",
				"official": "Republic of Indonesia",
				"native": {
					"ind": {
						"official": "Republik Indonesia",
						"common": "Indonesia"
					}
				}
			},
			"tld": [
				".id"
			],
			"cca2": "ID",
			"ccn3": "360",
			"cca3": "IDN",
			"cioc": "INA",
			"currency": [
				"IDR"
			],
			"callingCode": [
				"62"
			],
			"capital": "Jakarta",
			"altSpellings": [
				"ID",
				"Republic of Indonesia",
				"Republik Indonesia"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"ind": "Indonesian"
			},
			"translations": {
				"deu": {
					"official": "Republik Indonesien",
					"common": "Indonesien"
				},
				"fra": {
					"official": "République d'Indonésie",
					"common": "Indonésie"
				},
				"hrv": {
					"official": "Republika Indonezija",
					"common": "Indonezija"
				},
				"ita": {
					"official": "Repubblica di Indonesia",
					"common": "Indonesia"
				},
				"jpn": {
					"official": "インドネシア共和国",
					"common": "インドネシア"
				},
				"nld": {
					"official": "Republiek Indonesië",
					"common": "Indonesië"
				},
				"por": {
					"official": "República da Indonésia",
					"common": "Indonésia"
				},
				"rus": {
					"official": "Республика Индонезия",
					"common": "Индонезия"
				},
				"slk": {
					"official": "Indonézska republika",
					"common": "Indonézia"
				},
				"spa": {
					"official": "República de Indonesia",
					"common": "Indonesia"
				},
				"fin": {
					"official": "Indonesian tasavalta",
					"common": "Indonesia"
				},
				"zho": {
					"official": "印度尼西亚共和国",
					"common": "印度尼西亚"
				}
			},
			"latlng": [
				-5,
				120
			],
			"demonym": "Indonesian",
			"landlocked": false,
			"borders": [
				"TLS",
				"MYS",
				"PNG"
			],
			"area": 1904569
		},
		{
			"name": {
				"common": "Isle of Man",
				"official": "Isle of Man",
				"native": {
					"eng": {
						"official": "Isle of Man",
						"common": "Isle of Man"
					},
					"glv": {
						"official": "Ellan Vannin or Mannin",
						"common": "Mannin"
					}
				}
			},
			"tld": [
				".im"
			],
			"cca2": "IM",
			"ccn3": "833",
			"cca3": "IMN",
			"cioc": "",
			"currency": [
				"GBP"
			],
			"callingCode": [
				"44"
			],
			"capital": "Douglas",
			"altSpellings": [
				"IM",
				"Ellan Vannin",
				"Mann",
				"Mannin"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"eng": "English",
				"glv": "Manx"
			},
			"translations": {
				"deu": {
					"official": "Isle of Man",
					"common": "Insel Man"
				},
				"fra": {
					"official": "Isle of Man",
					"common": "Île de Man"
				},
				"hrv": {
					"official": "Mana ostrvo",
					"common": "Otok Man"
				},
				"ita": {
					"official": "Isola di Man",
					"common": "Isola di Man"
				},
				"jpn": {
					"official": "マン島",
					"common": "マン島"
				},
				"nld": {
					"official": "Isle of Man",
					"common": "Isle of Man"
				},
				"por": {
					"official": "Isle of Man",
					"common": "Ilha de Man"
				},
				"rus": {
					"official": "Остров Мэн",
					"common": "Остров Мэн"
				},
				"slk": {
					"official": "Ostrov Man",
					"common": "Man"
				},
				"spa": {
					"official": "Isla de Man",
					"common": "Isla de Man"
				},
				"fin": {
					"official": "Mansaari",
					"common": "Mansaari"
				},
				"zho": {
					"official": "马恩岛",
					"common": "马恩岛"
				}
			},
			"latlng": [
				54.25,
				-4.5
			],
			"demonym": "Manx",
			"landlocked": false,
			"borders": [],
			"area": 572
		},
		{
			"name": {
				"common": "India",
				"official": "Republic of India",
				"native": {
					"eng": {
						"official": "Republic of India",
						"common": "India"
					},
					"hin": {
						"official": "भारत गणराज्य",
						"common": "भारत"
					},
					"tam": {
						"official": "இந்தியக் குடியரசு",
						"common": "இந்தியா"
					}
				}
			},
			"tld": [
				".in"
			],
			"cca2": "IN",
			"ccn3": "356",
			"cca3": "IND",
			"cioc": "IND",
			"currency": [
				"INR"
			],
			"callingCode": [
				"91"
			],
			"capital": "New Delhi",
			"altSpellings": [
				"IN",
				"Bhārat",
				"Republic of India",
				"Bharat Ganrajya",
				"இந்தியா"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"eng": "English",
				"hin": "Hindi",
				"tam": "Tamil"
			},
			"translations": {
				"deu": {
					"official": "Republik Indien",
					"common": "Indien"
				},
				"fra": {
					"official": "République de l'Inde",
					"common": "Inde"
				},
				"hrv": {
					"official": "Republika Indija",
					"common": "Indija"
				},
				"ita": {
					"official": "Repubblica dell'India",
					"common": "India"
				},
				"jpn": {
					"official": "インド共和国",
					"common": "インド"
				},
				"nld": {
					"official": "Republiek India",
					"common": "India"
				},
				"por": {
					"official": "República da Índia",
					"common": "Índia"
				},
				"rus": {
					"official": "Республика Индия",
					"common": "Индия"
				},
				"slk": {
					"official": "Indická republika",
					"common": "India"
				},
				"spa": {
					"official": "República de la India",
					"common": "India"
				},
				"fin": {
					"official": "Intian tasavalta",
					"common": "Intia"
				},
				"zho": {
					"official": "印度共和国",
					"common": "印度"
				}
			},
			"latlng": [
				20,
				77
			],
			"demonym": "Indian",
			"landlocked": false,
			"borders": [
				"AFG",
				"BGD",
				"BTN",
				"MMR",
				"CHN",
				"NPL",
				"PAK",
				"LKA"
			],
			"area": 3287590
		},
		{
			"name": {
				"common": "British Indian Ocean Territory",
				"official": "British Indian Ocean Territory",
				"native": {
					"eng": {
						"official": "British Indian Ocean Territory",
						"common": "British Indian Ocean Territory"
					}
				}
			},
			"tld": [
				".io"
			],
			"cca2": "IO",
			"ccn3": "086",
			"cca3": "IOT",
			"cioc": "",
			"currency": [
				"USD"
			],
			"callingCode": [
				"246"
			],
			"capital": "Diego Garcia",
			"altSpellings": [
				"IO"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"cym": {
					"official": "British Indian Ocean Territory",
					"common": "Tiriogaeth Brydeinig Cefnfor India"
				},
				"deu": {
					"official": "Britisch-Indischer Ozean",
					"common": "Britisches Territorium im Indischen Ozean"
				},
				"fra": {
					"official": "Territoire britannique de l' océan Indien",
					"common": "Territoire britannique de l'océan Indien"
				},
				"hrv": {
					"official": "British Indian Ocean Territory",
					"common": "Britanski Indijskooceanski teritorij"
				},
				"ita": {
					"official": "Territorio britannico dell'Oceano Indiano",
					"common": "Territorio britannico dell'oceano indiano"
				},
				"jpn": {
					"official": "イギリス領インド洋地域",
					"common": "イギリス領インド洋地域"
				},
				"nld": {
					"official": "Brits Indische Oceaan Territorium",
					"common": "Britse Gebieden in de Indische Oceaan"
				},
				"por": {
					"official": "British Indian Ocean Territory",
					"common": "Território Britânico do Oceano Índico"
				},
				"rus": {
					"official": "Британская территория Индийского океана",
					"common": "Британская территория в Индийском океане"
				},
				"slk": {
					"official": "Britské indickooceánske územie",
					"common": "Britské indickooceánske územie"
				},
				"spa": {
					"official": "Territorio Británico del Océano Índico",
					"common": "Territorio Británico del Océano Índico"
				},
				"fin": {
					"official": "Brittiläinen Intian valtameren alue",
					"common": "Brittiläinen Intian valtameren alue"
				},
				"zho": {
					"official": "英属印度洋领地",
					"common": "英属印度洋领地"
				}
			},
			"latlng": [
				-6,
				71.5
			],
			"demonym": "Indian",
			"landlocked": false,
			"borders": [],
			"area": 60
		},
		{
			"name": {
				"common": "Ireland",
				"official": "Republic of Ireland",
				"native": {
					"eng": {
						"official": "Republic of Ireland",
						"common": "Ireland"
					},
					"gle": {
						"official": "Poblacht na hÉireann",
						"common": "Éire"
					}
				}
			},
			"tld": [
				".ie"
			],
			"cca2": "IE",
			"ccn3": "372",
			"cca3": "IRL",
			"cioc": "IRL",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"353"
			],
			"capital": "Dublin",
			"altSpellings": [
				"IE",
				"Éire",
				"Republic of Ireland",
				"Poblacht na hÉireann"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"eng": "English",
				"gle": "Irish"
			},
			"translations": {
				"deu": {
					"official": "Republik Irland",
					"common": "Irland"
				},
				"fra": {
					"official": "République d'Irlande",
					"common": "Irlande"
				},
				"hrv": {
					"official": "Republika Irska",
					"common": "Irska"
				},
				"ita": {
					"official": "Repubblica d'Irlanda",
					"common": "Irlanda"
				},
				"jpn": {
					"official": "アイルランド共和国",
					"common": "アイルランド"
				},
				"nld": {
					"official": "Republic of Ireland",
					"common": "Ierland"
				},
				"por": {
					"official": "República da Irlanda",
					"common": "Irlanda"
				},
				"rus": {
					"official": "Ирландия",
					"common": "Ирландия"
				},
				"slk": {
					"official": "Írska republika",
					"common": "Írsko"
				},
				"spa": {
					"official": "República de Irlanda",
					"common": "Irlanda"
				},
				"fin": {
					"official": "Irlannin tasavalta",
					"common": "Irlanti"
				},
				"zho": {
					"official": "爱尔兰共和国",
					"common": "爱尔兰"
				}
			},
			"latlng": [
				53,
				-8
			],
			"demonym": "Irish",
			"landlocked": false,
			"borders": [
				"GBR"
			],
			"area": 70273
		},
		{
			"name": {
				"common": "Iran",
				"official": "Islamic Republic of Iran",
				"native": {
					"fas": {
						"official": "جمهوری اسلامی ایران",
						"common": "ایران"
					}
				}
			},
			"tld": [
				".ir",
				"ایران."
			],
			"cca2": "IR",
			"ccn3": "364",
			"cca3": "IRN",
			"cioc": "IRI",
			"currency": [
				"IRR"
			],
			"callingCode": [
				"98"
			],
			"capital": "Tehran",
			"altSpellings": [
				"IR",
				"Islamic Republic of Iran",
				"Iran, Islamic Republic of",
				"Jomhuri-ye Eslāmi-ye Irān"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"fas": "Persian"
			},
			"translations": {
				"deu": {
					"official": "Islamische Republik Iran",
					"common": "Iran"
				},
				"fra": {
					"official": "République islamique d'Iran",
					"common": "Iran"
				},
				"hrv": {
					"official": "Islamska Republika Iran",
					"common": "Iran"
				},
				"ita": {
					"official": "Repubblica islamica dell'Iran",
					"common": "Iran"
				},
				"jpn": {
					"official": "イラン·イスラム共和国",
					"common": "イラン・イスラム共和国"
				},
				"nld": {
					"official": "Islamitische Republiek Iran",
					"common": "Iran"
				},
				"por": {
					"official": "República Islâmica do Irã",
					"common": "Irão"
				},
				"rus": {
					"official": "Исламская Республика Иран",
					"common": "Иран"
				},
				"slk": {
					"official": "Iránska islamská republika",
					"common": "Irán"
				},
				"spa": {
					"official": "República Islámica de Irán",
					"common": "Iran"
				},
				"fin": {
					"official": "Iranin islamilainen tasavalta",
					"common": "Iran"
				},
				"zho": {
					"official": "伊朗伊斯兰共和国",
					"common": "伊朗"
				}
			},
			"latlng": [
				32,
				53
			],
			"demonym": "Iranian",
			"landlocked": false,
			"borders": [
				"AFG",
				"ARM",
				"AZE",
				"IRQ",
				"PAK",
				"TUR",
				"TKM"
			],
			"area": 1648195
		},
		{
			"name": {
				"common": "Iraq",
				"official": "Republic of Iraq",
				"native": {
					"ara": {
						"official": "جمهورية العراق",
						"common": "العراق"
					},
					"arc": {
						"official": "ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ",
						"common": "ܩܘܼܛܢܵܐ"
					},
					"ckb": {
						"official": "کۆماری عێراق",
						"common": "کۆماری"
					}
				}
			},
			"tld": [
				".iq"
			],
			"cca2": "IQ",
			"ccn3": "368",
			"cca3": "IRQ",
			"cioc": "IRQ",
			"currency": [
				"IQD"
			],
			"callingCode": [
				"964"
			],
			"capital": "Baghdad",
			"altSpellings": [
				"IQ",
				"Republic of Iraq",
				"Jumhūriyyat al-‘Irāq"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic",
				"arc": "Aramaic",
				"ckb": "Sorani"
			},
			"translations": {
				"deu": {
					"official": "Republik Irak",
					"common": "Irak"
				},
				"fra": {
					"official": "République d'Irak",
					"common": "Irak"
				},
				"hrv": {
					"official": "Republika Irak",
					"common": "Irak"
				},
				"ita": {
					"official": "Repubblica dell'Iraq",
					"common": "Iraq"
				},
				"jpn": {
					"official": "イラク共和国",
					"common": "イラク"
				},
				"nld": {
					"official": "Republiek Irak",
					"common": "Irak"
				},
				"por": {
					"official": "República do Iraque",
					"common": "Iraque"
				},
				"rus": {
					"official": "Республика Ирак",
					"common": "Ирак"
				},
				"slk": {
					"official": "Iracká republika",
					"common": "Irak"
				},
				"spa": {
					"official": "República de Irak",
					"common": "Irak"
				},
				"fin": {
					"official": "Irakin tasavalta",
					"common": "Irak"
				},
				"zho": {
					"official": "伊拉克共和国",
					"common": "伊拉克"
				}
			},
			"latlng": [
				33,
				44
			],
			"demonym": "Iraqi",
			"landlocked": false,
			"borders": [
				"IRN",
				"JOR",
				"KWT",
				"SAU",
				"SYR",
				"TUR"
			],
			"area": 438317
		},
		{
			"name": {
				"common": "Iceland",
				"official": "Iceland",
				"native": {
					"isl": {
						"official": "Ísland",
						"common": "Ísland"
					}
				}
			},
			"tld": [
				".is"
			],
			"cca2": "IS",
			"ccn3": "352",
			"cca3": "ISL",
			"cioc": "ISL",
			"currency": [
				"ISK"
			],
			"callingCode": [
				"354"
			],
			"capital": "Reykjavik",
			"altSpellings": [
				"IS",
				"Island",
				"Republic of Iceland",
				"Lýðveldið Ísland"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"isl": "Icelandic"
			},
			"translations": {
				"deu": {
					"official": "Island",
					"common": "Island"
				},
				"fra": {
					"official": "République d'Islande",
					"common": "Islande"
				},
				"hrv": {
					"official": "Island",
					"common": "Island"
				},
				"ita": {
					"official": "Islanda",
					"common": "Islanda"
				},
				"jpn": {
					"official": "アイスランド",
					"common": "アイスランド"
				},
				"nld": {
					"official": "IJsland",
					"common": "IJsland"
				},
				"por": {
					"official": "Islândia",
					"common": "Islândia"
				},
				"rus": {
					"official": "Исландия",
					"common": "Исландия"
				},
				"slk": {
					"official": "Islandská republika",
					"common": "Island"
				},
				"spa": {
					"official": "Islandia",
					"common": "Islandia"
				},
				"fin": {
					"official": "Islanti",
					"common": "Islanti"
				},
				"zho": {
					"official": "冰岛",
					"common": "冰岛"
				}
			},
			"latlng": [
				65,
				-18
			],
			"demonym": "Icelander",
			"landlocked": false,
			"borders": [],
			"area": 103000
		},
		{
			"name": {
				"common": "Israel",
				"official": "State of Israel",
				"native": {
					"ara": {
						"official": "دولة إسرائيل",
						"common": "إسرائيل"
					},
					"heb": {
						"official": "מדינת ישראל",
						"common": "ישראל"
					}
				}
			},
			"tld": [
				".il"
			],
			"cca2": "IL",
			"ccn3": "376",
			"cca3": "ISR",
			"cioc": "ISR",
			"currency": [
				"ILS"
			],
			"callingCode": [
				"972"
			],
			"capital": "Jerusalem",
			"altSpellings": [
				"IL",
				"State of Israel",
				"Medīnat Yisrā'el"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic",
				"heb": "Hebrew"
			},
			"translations": {
				"deu": {
					"official": "Staat Israel",
					"common": "Israel"
				},
				"fra": {
					"official": "État d'Israël",
					"common": "Israël"
				},
				"hrv": {
					"official": "Država Izrael",
					"common": "Izrael"
				},
				"ita": {
					"official": "Stato di Israele",
					"common": "Israele"
				},
				"jpn": {
					"official": "イスラエル国",
					"common": "イスラエル"
				},
				"nld": {
					"official": "Staat Israël",
					"common": "Israël"
				},
				"por": {
					"official": "Estado de Israel",
					"common": "Israel"
				},
				"rus": {
					"official": "Государство Израиль",
					"common": "Израиль"
				},
				"slk": {
					"official": "Izraelský štát",
					"common": "Izrael"
				},
				"spa": {
					"official": "Estado de Israel",
					"common": "Israel"
				},
				"fin": {
					"official": "Israelin valtio",
					"common": "Israel"
				},
				"zho": {
					"official": "以色列国",
					"common": "以色列"
				}
			},
			"latlng": [
				31.47,
				35.13
			],
			"demonym": "Israeli",
			"landlocked": false,
			"borders": [
				"EGY",
				"JOR",
				"LBN",
				"SYR"
			],
			"area": 20770
		},
		{
			"name": {
				"common": "Italy",
				"official": "Italian Republic",
				"native": {
					"bar": {
						"official": "Italienische Republik",
						"common": "Italien"
					},
					"ita": {
						"official": "Repubblica italiana",
						"common": "Italia"
					},
					"srd": {
						"official": "Repubbricanu Italia",
						"common": "Italia"
					}
				}
			},
			"tld": [
				".it"
			],
			"cca2": "IT",
			"ccn3": "380",
			"cca3": "ITA",
			"cioc": "ITA",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"39"
			],
			"capital": "Rome",
			"altSpellings": [
				"IT",
				"Italian Republic",
				"Repubblica italiana"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"bar": "Austro-Bavarian German",
				"ita": "Italian",
				"srd": "Sardinian"
			},
			"translations": {
				"deu": {
					"official": "Italienische Republik",
					"common": "Italien"
				},
				"fra": {
					"official": "République italienne",
					"common": "Italie"
				},
				"hrv": {
					"official": "talijanska Republika",
					"common": "Italija"
				},
				"ita": {
					"official": "Repubblica italiana",
					"common": "Italia"
				},
				"jpn": {
					"official": "イタリア共和国",
					"common": "イタリア"
				},
				"nld": {
					"official": "Italiaanse Republiek",
					"common": "Italië"
				},
				"por": {
					"official": "República Italiana",
					"common": "Itália"
				},
				"rus": {
					"official": "итальянская Республика",
					"common": "Италия"
				},
				"slk": {
					"official": "Talianska republika",
					"common": "Taliansko"
				},
				"spa": {
					"official": "República Italiana",
					"common": "Italia"
				},
				"fin": {
					"official": "Italian tasavalta",
					"common": "Italia"
				},
				"zho": {
					"official": "意大利共和国",
					"common": "意大利"
				}
			},
			"latlng": [
				42.83333333,
				12.83333333
			],
			"demonym": "Italian",
			"landlocked": false,
			"borders": [
				"AUT",
				"FRA",
				"SMR",
				"SVN",
				"CHE",
				"VAT"
			],
			"area": 301336
		},
		{
			"name": {
				"common": "Jamaica",
				"official": "Jamaica",
				"native": {
					"eng": {
						"official": "Jamaica",
						"common": "Jamaica"
					},
					"jam": {
						"official": "Jamaica",
						"common": "Jamaica"
					}
				}
			},
			"tld": [
				".jm"
			],
			"cca2": "JM",
			"ccn3": "388",
			"cca3": "JAM",
			"cioc": "JAM",
			"currency": [
				"JMD"
			],
			"callingCode": [
				"1876"
			],
			"capital": "Kingston",
			"altSpellings": [
				"JM"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English",
				"jam": "Jamaican Patois"
			},
			"translations": {
				"deu": {
					"official": "Jamaika",
					"common": "Jamaika"
				},
				"fra": {
					"official": "Jamaïque",
					"common": "Jamaïque"
				},
				"hrv": {
					"official": "Jamajka",
					"common": "Jamajka"
				},
				"ita": {
					"official": "Giamaica",
					"common": "Giamaica"
				},
				"jpn": {
					"official": "ジャマイカ",
					"common": "ジャマイカ"
				},
				"nld": {
					"official": "Jamaica",
					"common": "Jamaica"
				},
				"por": {
					"official": "Jamaica",
					"common": "Jamaica"
				},
				"rus": {
					"official": "Ямайка",
					"common": "Ямайка"
				},
				"slk": {
					"official": "Jamajka",
					"common": "Jamajka"
				},
				"spa": {
					"official": "Jamaica",
					"common": "Jamaica"
				},
				"fin": {
					"official": "Jamaika",
					"common": "Jamaika"
				},
				"zho": {
					"official": "牙买加",
					"common": "牙买加"
				}
			},
			"latlng": [
				18.25,
				-77.5
			],
			"demonym": "Jamaican",
			"landlocked": false,
			"borders": [],
			"area": 10991
		},
		{
			"name": {
				"common": "Jersey",
				"official": "Bailiwick of Jersey",
				"native": {
					"eng": {
						"official": "Bailiwick of Jersey",
						"common": "Jersey"
					},
					"fra": {
						"official": "Bailliage de Jersey",
						"common": "Jersey"
					},
					"nrf": {
						"official": "Bailliage dé Jèrri",
						"common": "Jèrri"
					}
				}
			},
			"tld": [
				".je"
			],
			"cca2": "JE",
			"ccn3": "832",
			"cca3": "JEY",
			"cioc": "",
			"currency": [
				"GBP"
			],
			"callingCode": [
				"44"
			],
			"capital": "Saint Helier",
			"altSpellings": [
				"JE",
				"Bailiwick of Jersey",
				"Bailliage de Jersey",
				"Bailliage dé Jèrri"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"eng": "English",
				"fra": "French",
				"nrf": "Jèrriais"
			},
			"translations": {
				"deu": {
					"official": "Vogtei Jersey",
					"common": "Jersey"
				},
				"fra": {
					"official": "Bailliage de Jersey",
					"common": "Jersey"
				},
				"hrv": {
					"official": "Struka od Jersey",
					"common": "Jersey"
				},
				"ita": {
					"official": "Baliato di Jersey",
					"common": "Isola di Jersey"
				},
				"jpn": {
					"official": "ジャージの得意分野",
					"common": "ジャージー"
				},
				"nld": {
					"official": "Baljuwschap Jersey",
					"common": "Jersey"
				},
				"por": {
					"official": "Bailiado de Jersey",
					"common": "Jersey"
				},
				"rus": {
					"official": "Коронное владение Джерси",
					"common": "Джерси"
				},
				"slk": {
					"official": "Bailiwick Jersey",
					"common": "Jersey"
				},
				"spa": {
					"official": "Bailía de Jersey",
					"common": "Jersey"
				},
				"fin": {
					"official": "Jersey",
					"common": "Jersey"
				},
				"zho": {
					"official": "泽西岛",
					"common": "泽西岛"
				}
			},
			"latlng": [
				49.25,
				-2.16666666
			],
			"demonym": "Channel Islander",
			"landlocked": false,
			"borders": [],
			"area": 116
		},
		{
			"name": {
				"common": "Jordan",
				"official": "Hashemite Kingdom of Jordan",
				"native": {
					"ara": {
						"official": "المملكة الأردنية الهاشمية",
						"common": "الأردن"
					}
				}
			},
			"tld": [
				".jo",
				"الاردن."
			],
			"cca2": "JO",
			"ccn3": "400",
			"cca3": "JOR",
			"cioc": "JOR",
			"currency": [
				"JOD"
			],
			"callingCode": [
				"962"
			],
			"capital": "Amman",
			"altSpellings": [
				"JO",
				"Hashemite Kingdom of Jordan",
				"al-Mamlakah al-Urdunīyah al-Hāshimīyah"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Haschemitisches Königreich Jordanien",
					"common": "Jordanien"
				},
				"fra": {
					"official": "Royaume hachémite de Jordanie",
					"common": "Jordanie"
				},
				"hrv": {
					"official": "Hašemitske Kraljevine Jordan",
					"common": "Jordan"
				},
				"ita": {
					"official": "Regno hascemita di Giordania",
					"common": "Giordania"
				},
				"jpn": {
					"official": "ヨルダン·ハシミテ王国",
					"common": "ヨルダン"
				},
				"nld": {
					"official": "Hasjemitisch Koninkrijk Jordanië",
					"common": "Jordanië"
				},
				"por": {
					"official": "Reino Hachemita da Jordânia",
					"common": "Jordânia"
				},
				"rus": {
					"official": "Иорданского Хашимитского Королевства",
					"common": "Иордания"
				},
				"slk": {
					"official": "Jordánske hášimovské kráľovstvo",
					"common": "Jordánsko"
				},
				"spa": {
					"official": "Reino Hachemita de Jordania",
					"common": "Jordania"
				},
				"fin": {
					"official": "Jordanian hašemiittinen kunigaskunta",
					"common": "Jordania"
				},
				"zho": {
					"official": "约旦哈希姆王国",
					"common": "约旦"
				}
			},
			"latlng": [
				31,
				36
			],
			"demonym": "Jordanian",
			"landlocked": false,
			"borders": [
				"IRQ",
				"ISR",
				"SAU",
				"SYR"
			],
			"area": 89342
		},
		{
			"name": {
				"common": "Japan",
				"official": "Japan",
				"native": {
					"jpn": {
						"official": "日本",
						"common": "日本"
					}
				}
			},
			"tld": [
				".jp",
				".みんな"
			],
			"cca2": "JP",
			"ccn3": "392",
			"cca3": "JPN",
			"cioc": "JPN",
			"currency": [
				"JPY"
			],
			"callingCode": [
				"81"
			],
			"capital": "Tokyo",
			"altSpellings": [
				"JP",
				"Nippon",
				"Nihon"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"jpn": "Japanese"
			},
			"translations": {
				"deu": {
					"official": "Japan",
					"common": "Japan"
				},
				"fra": {
					"official": "Japon",
					"common": "Japon"
				},
				"hrv": {
					"official": "Japan",
					"common": "Japan"
				},
				"ita": {
					"official": "Giappone",
					"common": "Giappone"
				},
				"jpn": {
					"official": "日本",
					"common": "日本"
				},
				"nld": {
					"official": "Japan",
					"common": "Japan"
				},
				"por": {
					"official": "Japão",
					"common": "Japão"
				},
				"rus": {
					"official": "Япония",
					"common": "Япония"
				},
				"slk": {
					"official": "Japonsko",
					"common": "Japonsko"
				},
				"spa": {
					"official": "Japón",
					"common": "Japón"
				},
				"fin": {
					"official": "Japani",
					"common": "Japani"
				},
				"zho": {
					"official": "日本国",
					"common": "日本"
				}
			},
			"latlng": [
				36,
				138
			],
			"demonym": "Japanese",
			"landlocked": false,
			"borders": [],
			"area": 377930
		},
		{
			"name": {
				"common": "Kazakhstan",
				"official": "Republic of Kazakhstan",
				"native": {
					"kaz": {
						"official": "Қазақстан Республикасы",
						"common": "Қазақстан"
					},
					"rus": {
						"official": "Республика Казахстан",
						"common": "Казахстан"
					}
				}
			},
			"tld": [
				".kz",
				".қаз"
			],
			"cca2": "KZ",
			"ccn3": "398",
			"cca3": "KAZ",
			"cioc": "KAZ",
			"currency": [
				"KZT"
			],
			"callingCode": [
				"76",
				"77"
			],
			"capital": "Astana",
			"altSpellings": [
				"KZ",
				"Qazaqstan",
				"Казахстан",
				"Republic of Kazakhstan",
				"Қазақстан Республикасы",
				"Qazaqstan Respublïkası",
				"Республика Казахстан",
				"Respublika Kazakhstan"
			],
			"region": "Asia",
			"subregion": "Central Asia",
			"languages": {
				"kaz": "Kazakh",
				"rus": "Russian"
			},
			"translations": {
				"deu": {
					"official": "Republik Kasachstan",
					"common": "Kasachstan"
				},
				"fra": {
					"official": "République du Kazakhstan",
					"common": "Kazakhstan"
				},
				"hrv": {
					"official": "Republika Kazahstan",
					"common": "Kazahstan"
				},
				"ita": {
					"official": "Repubblica del Kazakhstan",
					"common": "Kazakistan"
				},
				"jpn": {
					"official": "カザフスタン共和国",
					"common": "カザフスタン"
				},
				"nld": {
					"official": "Republiek Kazachstan",
					"common": "Kazachstan"
				},
				"por": {
					"official": "República do Cazaquistão",
					"common": "Cazaquistão"
				},
				"rus": {
					"official": "Республика Казахстан",
					"common": "Казахстан"
				},
				"slk": {
					"official": "Kazašská republika",
					"common": "Kazachstan"
				},
				"spa": {
					"official": "República de Kazajstán",
					"common": "Kazajistán"
				},
				"fin": {
					"official": "Kazakstanin tasavalta",
					"common": "Kazakstan"
				},
				"zho": {
					"official": "哈萨克斯坦共和国",
					"common": "哈萨克斯坦"
				}
			},
			"latlng": [
				48,
				68
			],
			"demonym": "Kazakhstani",
			"landlocked": true,
			"borders": [
				"CHN",
				"KGZ",
				"RUS",
				"TKM",
				"UZB"
			],
			"area": 2724900
		},
		{
			"name": {
				"common": "Kenya",
				"official": "Republic of Kenya",
				"native": {
					"eng": {
						"official": "Republic of Kenya",
						"common": "Kenya"
					},
					"swa": {
						"official": "Republic of Kenya",
						"common": "Kenya"
					}
				}
			},
			"tld": [
				".ke"
			],
			"cca2": "KE",
			"ccn3": "404",
			"cca3": "KEN",
			"cioc": "KEN",
			"currency": [
				"KES"
			],
			"callingCode": [
				"254"
			],
			"capital": "Nairobi",
			"altSpellings": [
				"KE",
				"Republic of Kenya",
				"Jamhuri ya Kenya"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"swa": "Swahili"
			},
			"translations": {
				"deu": {
					"official": "Republik Kenia",
					"common": "Kenia"
				},
				"fra": {
					"official": "République du Kenya",
					"common": "Kenya"
				},
				"hrv": {
					"official": "Republika Kenija",
					"common": "Kenija"
				},
				"ita": {
					"official": "Repubblica del Kenya",
					"common": "Kenya"
				},
				"jpn": {
					"official": "ケニア共和国",
					"common": "ケニア"
				},
				"nld": {
					"official": "Republiek Kenia",
					"common": "Kenia"
				},
				"por": {
					"official": "República do Quénia",
					"common": "Quénia"
				},
				"rus": {
					"official": "Республика Кения",
					"common": "Кения"
				},
				"slk": {
					"official": "Kenská republika",
					"common": "Keňa"
				},
				"spa": {
					"official": "República de Kenya",
					"common": "Kenia"
				},
				"fin": {
					"official": "Kenian tasavalta",
					"common": "Kenia"
				},
				"zho": {
					"official": "肯尼亚共和国",
					"common": "肯尼亚"
				}
			},
			"latlng": [
				1,
				38
			],
			"demonym": "Kenyan",
			"landlocked": false,
			"borders": [
				"ETH",
				"SOM",
				"SSD",
				"TZA",
				"UGA"
			],
			"area": 580367
		},
		{
			"name": {
				"common": "Kyrgyzstan",
				"official": "Kyrgyz Republic",
				"native": {
					"kir": {
						"official": "Кыргыз Республикасы",
						"common": "Кыргызстан"
					},
					"rus": {
						"official": "Кыргызская Республика",
						"common": "Киргизия"
					}
				}
			},
			"tld": [
				".kg"
			],
			"cca2": "KG",
			"ccn3": "417",
			"cca3": "KGZ",
			"cioc": "KGZ",
			"currency": [
				"KGS"
			],
			"callingCode": [
				"996"
			],
			"capital": "Bishkek",
			"altSpellings": [
				"KG",
				"Киргизия",
				"Kyrgyz Republic",
				"Кыргыз Республикасы",
				"Kyrgyz Respublikasy"
			],
			"region": "Asia",
			"subregion": "Central Asia",
			"languages": {
				"kir": "Kyrgyz",
				"rus": "Russian"
			},
			"translations": {
				"deu": {
					"official": "Kirgisische Republik",
					"common": "Kirgisistan"
				},
				"fra": {
					"official": "République kirghize",
					"common": "Kirghizistan"
				},
				"hrv": {
					"official": "Kirgistanu",
					"common": "Kirgistan"
				},
				"ita": {
					"official": "Kirghizistan",
					"common": "Kirghizistan"
				},
				"jpn": {
					"official": "キルギス共和国",
					"common": "キルギス"
				},
				"nld": {
					"official": "Kirgizische Republiek",
					"common": "Kirgizië"
				},
				"por": {
					"official": "República do Quirguistão",
					"common": "Quirguistão"
				},
				"rus": {
					"official": "Кыргызская Республика",
					"common": "Киргизия"
				},
				"slk": {
					"official": "Kirgizská republika",
					"common": "Kirgizsko"
				},
				"spa": {
					"official": "República Kirguisa",
					"common": "Kirguizistán"
				},
				"fin": {
					"official": "Kirgisian tasavalta",
					"common": "Kirgisia"
				},
				"zho": {
					"official": "吉尔吉斯斯坦共和国",
					"common": "吉尔吉斯斯坦"
				}
			},
			"latlng": [
				41,
				75
			],
			"demonym": "Kirghiz",
			"landlocked": true,
			"borders": [
				"CHN",
				"KAZ",
				"TJK",
				"UZB"
			],
			"area": 199951
		},
		{
			"name": {
				"common": "Cambodia",
				"official": "Kingdom of Cambodia",
				"native": {
					"khm": {
						"official": "ព្រះរាជាណាចក្រកម្ពុជា",
						"common": "Kâmpŭchéa"
					}
				}
			},
			"tld": [
				".kh"
			],
			"cca2": "KH",
			"ccn3": "116",
			"cca3": "KHM",
			"cioc": "CAM",
			"currency": [
				"KHR"
			],
			"callingCode": [
				"855"
			],
			"capital": "Phnom Penh",
			"altSpellings": [
				"KH",
				"Kingdom of Cambodia"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"khm": "Khmer"
			},
			"translations": {
				"cym": {
					"official": "Kingdom of Cambodia",
					"common": "Cambodia"
				},
				"deu": {
					"official": "Königreich Kambodscha",
					"common": "Kambodscha"
				},
				"fra": {
					"official": "Royaume du Cambodge",
					"common": "Cambodge"
				},
				"hrv": {
					"official": "Kraljevina Kambodža",
					"common": "Kambodža"
				},
				"ita": {
					"official": "Regno di Cambogia",
					"common": "Cambogia"
				},
				"jpn": {
					"official": "カンボジア王国",
					"common": "カンボジア"
				},
				"nld": {
					"official": "Koninkrijk Cambodja",
					"common": "Cambodja"
				},
				"por": {
					"official": "Reino do Camboja",
					"common": "Camboja"
				},
				"rus": {
					"official": "Королевство Камбоджа",
					"common": "Камбоджа"
				},
				"slk": {
					"official": "Kamboǆské kráľovstvo",
					"common": "Kamboǆa"
				},
				"spa": {
					"official": "Reino de Camboya",
					"common": "Camboya"
				},
				"fin": {
					"official": "Kambodžan kuningaskunta",
					"common": "Kambodža"
				},
				"zho": {
					"official": "柬埔寨王国",
					"common": "柬埔寨"
				}
			},
			"latlng": [
				13,
				105
			],
			"demonym": "Cambodian",
			"landlocked": false,
			"borders": [
				"LAO",
				"THA",
				"VNM"
			],
			"area": 181035
		},
		{
			"name": {
				"common": "Kiribati",
				"official": "Independent and Sovereign Republic of Kiribati",
				"native": {
					"eng": {
						"official": "Independent and Sovereign Republic of Kiribati",
						"common": "Kiribati"
					},
					"gil": {
						"official": "Ribaberiki Kiribati",
						"common": "Kiribati"
					}
				}
			},
			"tld": [
				".ki"
			],
			"cca2": "KI",
			"ccn3": "296",
			"cca3": "KIR",
			"cioc": "KIR",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"686"
			],
			"capital": "South Tarawa",
			"altSpellings": [
				"KI",
				"Republic of Kiribati",
				"Ribaberiki Kiribati"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"eng": "English",
				"gil": "Gilbertese"
			},
			"translations": {
				"deu": {
					"official": "Unabhängige und souveräne Republik Kiribati",
					"common": "Kiribati"
				},
				"fra": {
					"official": "République de Kiribati",
					"common": "Kiribati"
				},
				"hrv": {
					"official": "Samostalne i suverene Republike Kiribati",
					"common": "Kiribati"
				},
				"ita": {
					"official": "Repubblica indipendente e sovrano di Kiribati",
					"common": "Kiribati"
				},
				"jpn": {
					"official": "キリバスの独立と主権共和国",
					"common": "キリバス"
				},
				"nld": {
					"official": "Onafhankelijke en soevereine republiek Kiribati",
					"common": "Kiribati"
				},
				"por": {
					"official": "Independente e soberano República de Kiribati",
					"common": "Kiribati"
				},
				"rus": {
					"official": "Независимой и суверенной Республики Кирибати",
					"common": "Кирибати"
				},
				"slk": {
					"official": "Kiribatská republika",
					"common": "Kiribati"
				},
				"spa": {
					"official": "República Independiente y Soberano de Kiribati",
					"common": "Kiribati"
				},
				"fin": {
					"official": "Kiribatin tasavalta",
					"common": "Kiribati"
				},
				"zho": {
					"official": "基里巴斯共和国",
					"common": "基里巴斯"
				}
			},
			"latlng": [
				1.41666666,
				173
			],
			"demonym": "I-Kiribati",
			"landlocked": false,
			"borders": [],
			"area": 811
		},
		{
			"name": {
				"common": "Saint Kitts and Nevis",
				"official": "Federation of Saint Christopher and Nevisa",
				"native": {
					"eng": {
						"official": "Federation of Saint Christopher and Nevisa",
						"common": "Saint Kitts and Nevis"
					}
				}
			},
			"tld": [
				".kn"
			],
			"cca2": "KN",
			"ccn3": "659",
			"cca3": "KNA",
			"cioc": "SKN",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1869"
			],
			"capital": "Basseterre",
			"altSpellings": [
				"KN",
				"Federation of Saint Christopher and Nevis"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Föderation von Saint Kitts und Nevisa",
					"common": "Saint Christopher und Nevis"
				},
				"fra": {
					"official": "Fédération de Saint -Christophe-et Nevisa",
					"common": "Saint-Christophe-et-Niévès"
				},
				"hrv": {
					"official": "Federacija Sv.Kristofora i Nevisa",
					"common": "Sveti Kristof i Nevis"
				},
				"ita": {
					"official": "Federazione di Saint Christopher e Nevisa",
					"common": "Saint Kitts e Nevis"
				},
				"jpn": {
					"official": "セントクリストファーNevisa連盟",
					"common": "セントクリストファー・ネイビス"
				},
				"nld": {
					"official": "Federatie van Saint Kitts en Nevisa",
					"common": "Saint Kitts en Nevis"
				},
				"por": {
					"official": "Federação de São Cristóvão e Nevisa",
					"common": "São Cristóvão e Nevis"
				},
				"rus": {
					"official": "Федерация Сент-Кристофер и Nevisa",
					"common": "Сент-Китс и Невис"
				},
				"slk": {
					"official": "Feder໡cia Svätého Krištofa a Nevisu",
					"common": "Svätý Krištof a Nevis"
				},
				"spa": {
					"official": "Federación de San Cristóbal y Nevisa",
					"common": "San Cristóbal y Nieves"
				},
				"fin": {
					"official": "Saint Christopherin ja Nevisin federaatio",
					"common": "Saint Kitts ja Nevis"
				},
				"zho": {
					"official": "圣克里斯托弗和尼维斯联邦",
					"common": "圣基茨和尼维斯"
				}
			},
			"latlng": [
				17.33333333,
				-62.75
			],
			"demonym": "Kittitian or Nevisian",
			"landlocked": false,
			"borders": [],
			"area": 261
		},
		{
			"name": {
				"common": "South Korea",
				"official": "Republic of Korea",
				"native": {
					"kor": {
						"official": "한국",
						"common": "대한민국"
					}
				}
			},
			"tld": [
				".kr",
				".한국"
			],
			"cca2": "KR",
			"ccn3": "410",
			"cca3": "KOR",
			"cioc": "KOR",
			"currency": [
				"KRW"
			],
			"callingCode": [
				"82"
			],
			"capital": "Seoul",
			"altSpellings": [
				"KR",
				"Korea, Republic of",
				"Republic of Korea"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"kor": "Korean"
			},
			"translations": {
				"deu": {
					"official": "Republik Korea",
					"common": "Südkorea"
				},
				"fra": {
					"official": "République de Corée",
					"common": "Corée du Sud"
				},
				"hrv": {
					"official": "Republika Koreja",
					"common": "Južna Koreja"
				},
				"ita": {
					"official": "Repubblica di Corea",
					"common": "Corea del Sud"
				},
				"jpn": {
					"official": "大韓民国",
					"common": "大韓民国"
				},
				"nld": {
					"official": "Republiek Korea",
					"common": "Zuid-Korea"
				},
				"por": {
					"official": "República da Coreia",
					"common": "Coreia do Sul"
				},
				"rus": {
					"official": "Республика Корея",
					"common": "Южная Корея"
				},
				"slk": {
					"official": "Kórejská republika",
					"common": "Južná Kórea"
				},
				"spa": {
					"official": "República de Corea",
					"common": "Corea del Sur"
				},
				"fin": {
					"official": "Korean tasavalta",
					"common": "Etelä-Korea"
				},
				"zho": {
					"official": "大韩民国",
					"common": "韩国"
				}
			},
			"latlng": [
				37,
				127.5
			],
			"demonym": "South Korean",
			"landlocked": false,
			"borders": [
				"PRK"
			],
			"area": 100210
		},
		{
			"name": {
				"common": "Kosovo",
				"official": "Republic of Kosovo",
				"native": {
					"sqi": {
						"official": "Republika e Kosovës",
						"common": "Kosova"
					},
					"srp": {
						"official": "Република Косово",
						"common": "Косово"
					}
				}
			},
			"tld": [],
			"cca2": "XK",
			"ccn3": "",
			"cca3": "UNK",
			"cioc": "KOS",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"383"
			],
			"capital": "Pristina",
			"altSpellings": [
				"XK",
				"Република Косово"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"sqi": "Albanian",
				"srp": "Serbian"
			},
			"translations": {
				"deu": {
					"official": "Republik Kosovo",
					"common": "Kosovo"
				},
				"fra": {
					"official": "République du Kosovo",
					"common": "Kosovo"
				},
				"hrv": {
					"official": "Republika Kosovo",
					"common": "Kosovo"
				},
				"ita": {
					"official": "Repubblica del Kosovo",
					"common": "Kosovo"
				},
				"nld": {
					"official": "Republiek Kosovo",
					"common": "Kosovo"
				},
				"por": {
					"official": "República do Kosovo",
					"common": "Kosovo"
				},
				"rus": {
					"official": "Республика Косово",
					"common": "Республика Косово"
				},
				"slk": {
					"official": "Republika Kosovo",
					"common": "Kosovo"
				},
				"spa": {
					"official": "República de Kosovo",
					"common": "Kosovo"
				},
				"fin": {
					"official": "Kosovon tasavalta",
					"common": "Kosovo"
				},
				"zho": {
					"official": "科索沃共和国",
					"common": "科索沃"
				}
			},
			"latlng": [
				42.666667,
				21.166667
			],
			"demonym": "Kosovar",
			"landlocked": true,
			"borders": [
				"ALB",
				"MKD",
				"MNE",
				"SRB"
			],
			"area": 10908
		},
		{
			"name": {
				"common": "Kuwait",
				"official": "State of Kuwait",
				"native": {
					"ara": {
						"official": "دولة الكويت",
						"common": "الكويت"
					}
				}
			},
			"tld": [
				".kw"
			],
			"cca2": "KW",
			"ccn3": "414",
			"cca3": "KWT",
			"cioc": "KUW",
			"currency": [
				"KWD"
			],
			"callingCode": [
				"965"
			],
			"capital": "Kuwait City",
			"altSpellings": [
				"KW",
				"State of Kuwait",
				"Dawlat al-Kuwait"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Staat Kuwait",
					"common": "Kuwait"
				},
				"fra": {
					"official": "État du Koweït",
					"common": "Koweït"
				},
				"hrv": {
					"official": "Država Kuvajt",
					"common": "Kuvajt"
				},
				"ita": {
					"official": "Stato del Kuwait",
					"common": "Kuwait"
				},
				"jpn": {
					"official": "クウェート国",
					"common": "クウェート"
				},
				"nld": {
					"official": "Staat Koeweit",
					"common": "Koeweit"
				},
				"por": {
					"official": "Estado do Kuwait",
					"common": "Kuwait"
				},
				"rus": {
					"official": "Государство Кувейт",
					"common": "Кувейт"
				},
				"slk": {
					"official": "Kuvajtský štát",
					"common": "Kuvajt"
				},
				"spa": {
					"official": "Estado de Kuwait",
					"common": "Kuwait"
				},
				"fin": {
					"official": "Kuwaitin valtio",
					"common": "Kuwait"
				},
				"zho": {
					"official": "科威特国",
					"common": "科威特"
				}
			},
			"latlng": [
				29.5,
				45.75
			],
			"demonym": "Kuwaiti",
			"landlocked": false,
			"borders": [
				"IRQ",
				"SAU"
			],
			"area": 17818
		},
		{
			"name": {
				"common": "Laos",
				"official": "Lao People's Democratic Republic",
				"native": {
					"lao": {
						"official": "ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ",
						"common": "ສປປລາວ"
					}
				}
			},
			"tld": [
				".la"
			],
			"cca2": "LA",
			"ccn3": "418",
			"cca3": "LAO",
			"cioc": "LAO",
			"currency": [
				"LAK"
			],
			"callingCode": [
				"856"
			],
			"capital": "Vientiane",
			"altSpellings": [
				"LA",
				"Lao",
				"Lao People's Democratic Republic",
				"Sathalanalat Paxathipatai Paxaxon Lao"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"lao": "Lao"
			},
			"translations": {
				"deu": {
					"official": "Laos, Demokratische Volksrepublik",
					"common": "Laos"
				},
				"fra": {
					"official": "République démocratique populaire lao",
					"common": "Laos"
				},
				"hrv": {
					"official": "Narodna Demokratska Republika",
					"common": "Laos"
				},
				"ita": {
					"official": "Repubblica democratica popolare del Laos",
					"common": "Laos"
				},
				"jpn": {
					"official": "ラオス人民民主共和国",
					"common": "ラオス人民民主共和国"
				},
				"nld": {
					"official": "Lao Democratische Volksrepubliek",
					"common": "Laos"
				},
				"por": {
					"official": "Laos, República Democrática",
					"common": "Laos"
				},
				"rus": {
					"official": "Лаосская Народно-Демократическая Республика",
					"common": "Лаос"
				},
				"slk": {
					"official": "Laoská ľudovodemokratická republika",
					"common": "Laos"
				},
				"spa": {
					"official": "República Democrática Popular Lao",
					"common": "Laos"
				},
				"fin": {
					"official": "Laosin demokraattinen kansantasavalta",
					"common": "Laos"
				},
				"zho": {
					"official": "老挝人民民主共和国",
					"common": "老挝"
				}
			},
			"latlng": [
				18,
				105
			],
			"demonym": "Laotian",
			"landlocked": true,
			"borders": [
				"MMR",
				"KHM",
				"CHN",
				"THA",
				"VNM"
			],
			"area": 236800
		},
		{
			"name": {
				"common": "Lebanon",
				"official": "Lebanese Republic",
				"native": {
					"ara": {
						"official": "الجمهورية اللبنانية",
						"common": "لبنان"
					},
					"fra": {
						"official": "République libanaise",
						"common": "Liban"
					}
				}
			},
			"tld": [
				".lb"
			],
			"cca2": "LB",
			"ccn3": "422",
			"cca3": "LBN",
			"cioc": "LIB",
			"currency": [
				"LBP"
			],
			"callingCode": [
				"961"
			],
			"capital": "Beirut",
			"altSpellings": [
				"LB",
				"Lebanese Republic",
				"Al-Jumhūrīyah Al-Libnānīyah"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic",
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Libanesische Republik",
					"common": "Libanon"
				},
				"fra": {
					"official": "République libanaise",
					"common": "Liban"
				},
				"hrv": {
					"official": "Libanonska Republika",
					"common": "Libanon"
				},
				"ita": {
					"official": "Repubblica libanese",
					"common": "Libano"
				},
				"jpn": {
					"official": "レバノン共和国",
					"common": "レバノン"
				},
				"nld": {
					"official": "Libanese Republiek",
					"common": "Libanon"
				},
				"por": {
					"official": "República Libanesa",
					"common": "Líbano"
				},
				"rus": {
					"official": "Ливанская Республика",
					"common": "Ливан"
				},
				"slk": {
					"official": "Libanonská republika",
					"common": "Libanon"
				},
				"spa": {
					"official": "República Libanesa",
					"common": "Líbano"
				},
				"fin": {
					"official": "Libanonin tasavalta",
					"common": "Libanon"
				},
				"zho": {
					"official": "黎巴嫩共和国",
					"common": "黎巴嫩"
				}
			},
			"latlng": [
				33.83333333,
				35.83333333
			],
			"demonym": "Lebanese",
			"landlocked": false,
			"borders": [
				"ISR",
				"SYR"
			],
			"area": 10452
		},
		{
			"name": {
				"common": "Liberia",
				"official": "Republic of Liberia",
				"native": {
					"eng": {
						"official": "Republic of Liberia",
						"common": "Liberia"
					}
				}
			},
			"tld": [
				".lr"
			],
			"cca2": "LR",
			"ccn3": "430",
			"cca3": "LBR",
			"cioc": "LBR",
			"currency": [
				"LRD"
			],
			"callingCode": [
				"231"
			],
			"capital": "Monrovia",
			"altSpellings": [
				"LR",
				"Republic of Liberia"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Liberia",
					"common": "Liberia"
				},
				"fra": {
					"official": "République du Libéria",
					"common": "Liberia"
				},
				"hrv": {
					"official": "Republika Liberija",
					"common": "Liberija"
				},
				"ita": {
					"official": "Repubblica di Liberia",
					"common": "Liberia"
				},
				"jpn": {
					"official": "リベリア共和国",
					"common": "リベリア"
				},
				"nld": {
					"official": "Republiek Liberia",
					"common": "Liberia"
				},
				"por": {
					"official": "República da Libéria",
					"common": "Libéria"
				},
				"rus": {
					"official": "Республика Либерия",
					"common": "Либерия"
				},
				"slk": {
					"official": "Libérijská republika",
					"common": "Libéria"
				},
				"spa": {
					"official": "República de Liberia",
					"common": "Liberia"
				},
				"fin": {
					"official": "Liberian tasavalta",
					"common": "Liberia"
				},
				"zho": {
					"official": "利比里亚共和国",
					"common": "利比里亚"
				}
			},
			"latlng": [
				6.5,
				-9.5
			],
			"demonym": "Liberian",
			"landlocked": false,
			"borders": [
				"GIN",
				"CIV",
				"SLE"
			],
			"area": 111369
		},
		{
			"name": {
				"common": "Libya",
				"official": "State of Libya",
				"native": {
					"ara": {
						"official": "الدولة ليبيا",
						"common": "‏ليبيا"
					}
				}
			},
			"tld": [
				".ly"
			],
			"cca2": "LY",
			"ccn3": "434",
			"cca3": "LBY",
			"cioc": "LBA",
			"currency": [
				"LYD"
			],
			"callingCode": [
				"218"
			],
			"capital": "Tripoli",
			"altSpellings": [
				"LY",
				"State of Libya",
				"Dawlat Libya"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Staat Libyen",
					"common": "Libyen"
				},
				"fra": {
					"official": "Grande République arabe libyenne populaire et socialiste",
					"common": "Libye"
				},
				"hrv": {
					"official": "Država Libiji",
					"common": "Libija"
				},
				"ita": {
					"official": "Stato della Libia",
					"common": "Libia"
				},
				"jpn": {
					"official": "リビアの国家",
					"common": "リビア"
				},
				"nld": {
					"official": "Staat van Libië",
					"common": "Libië"
				},
				"por": {
					"official": "Estado da Líbia",
					"common": "Líbia"
				},
				"rus": {
					"official": "Государство Ливии",
					"common": "Ливия"
				},
				"slk": {
					"official": "Líbya",
					"common": "Líbya"
				},
				"spa": {
					"official": "Estado de Libia",
					"common": "Libia"
				},
				"fin": {
					"official": "Libyan valtio",
					"common": "Libya"
				},
				"zho": {
					"official": "利比亚国",
					"common": "利比亚"
				}
			},
			"latlng": [
				25,
				17
			],
			"demonym": "Libyan",
			"landlocked": false,
			"borders": [
				"DZA",
				"TCD",
				"EGY",
				"NER",
				"SDN",
				"TUN"
			],
			"area": 1759540
		},
		{
			"name": {
				"common": "Saint Lucia",
				"official": "Saint Lucia",
				"native": {
					"eng": {
						"official": "Saint Lucia",
						"common": "Saint Lucia"
					}
				}
			},
			"tld": [
				".lc"
			],
			"cca2": "LC",
			"ccn3": "662",
			"cca3": "LCA",
			"cioc": "LCA",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1758"
			],
			"capital": "Castries",
			"altSpellings": [
				"LC"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "St. Lucia",
					"common": "Saint Lucia"
				},
				"fra": {
					"official": "Sainte-Lucie",
					"common": "Sainte-Lucie"
				},
				"hrv": {
					"official": "Sveta Lucija",
					"common": "Sveta Lucija"
				},
				"ita": {
					"official": "Santa Lucia",
					"common": "Santa Lucia"
				},
				"jpn": {
					"official": "セントルシア",
					"common": "セントルシア"
				},
				"nld": {
					"official": "Saint Lucia",
					"common": "Saint Lucia"
				},
				"por": {
					"official": "Santa Lúcia",
					"common": "Santa Lúcia"
				},
				"rus": {
					"official": "Сент-Люсия",
					"common": "Сент-Люсия"
				},
				"slk": {
					"official": "Svätá Lucia",
					"common": "Svätá Lucia"
				},
				"spa": {
					"official": "Santa Lucía",
					"common": "Santa Lucía"
				},
				"fin": {
					"official": "Saint Lucia",
					"common": "Saint Lucia"
				},
				"zho": {
					"official": "圣卢西亚",
					"common": "圣卢西亚"
				}
			},
			"latlng": [
				13.88333333,
				-60.96666666
			],
			"demonym": "Saint Lucian",
			"landlocked": false,
			"borders": [],
			"area": 616
		},
		{
			"name": {
				"common": "Liechtenstein",
				"official": "Principality of Liechtenstein",
				"native": {
					"deu": {
						"official": "Fürstentum Liechtenstein",
						"common": "Liechtenstein"
					}
				}
			},
			"tld": [
				".li"
			],
			"cca2": "LI",
			"ccn3": "438",
			"cca3": "LIE",
			"cioc": "LIE",
			"currency": [
				"CHF"
			],
			"callingCode": [
				"423"
			],
			"capital": "Vaduz",
			"altSpellings": [
				"LI",
				"Principality of Liechtenstein",
				"Fürstentum Liechtenstein"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"deu": "German"
			},
			"translations": {
				"deu": {
					"official": "Fürstentum Liechtenstein",
					"common": "Liechtenstein"
				},
				"fra": {
					"official": "Principauté du Liechtenstein",
					"common": "Liechtenstein"
				},
				"hrv": {
					"official": "Kneževina Lihtenštajn",
					"common": "Lihtenštajn"
				},
				"ita": {
					"official": "Principato del Liechtenstein",
					"common": "Liechtenstein"
				},
				"jpn": {
					"official": "リヒテンシュタイン公国",
					"common": "リヒテンシュタイン"
				},
				"nld": {
					"official": "Vorstendom Liechtenstein",
					"common": "Liechtenstein"
				},
				"por": {
					"official": "Principado de Liechtenstein",
					"common": "Liechtenstein"
				},
				"rus": {
					"official": "Княжество Лихтенштейн",
					"common": "Лихтенштейн"
				},
				"slk": {
					"official": "Lichtenštajnské kniežatstvo",
					"common": "Lichtenštajnsko"
				},
				"spa": {
					"official": "Principado de Liechtenstein",
					"common": "Liechtenstein"
				},
				"fin": {
					"official": "Liechensteinin ruhtinaskunta",
					"common": "Liechenstein"
				},
				"zho": {
					"official": "列支敦士登公国",
					"common": "列支敦士登"
				}
			},
			"latlng": [
				47.26666666,
				9.53333333
			],
			"demonym": "Liechtensteiner",
			"landlocked": true,
			"borders": [
				"AUT",
				"CHE"
			],
			"area": 160
		},
		{
			"name": {
				"common": "Sri Lanka",
				"official": "Democratic Socialist Republic of Sri Lanka",
				"native": {
					"sin": {
						"official": "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය",
						"common": "ශ්‍රී ලංකාව"
					},
					"tam": {
						"official": "இலங்கை சனநாயக சோசலிசக் குடியரசு",
						"common": "இலங்கை"
					}
				}
			},
			"tld": [
				".lk",
				".இலங்கை",
				".ලංකා"
			],
			"cca2": "LK",
			"ccn3": "144",
			"cca3": "LKA",
			"cioc": "SRI",
			"currency": [
				"LKR"
			],
			"callingCode": [
				"94"
			],
			"capital": "Colombo",
			"altSpellings": [
				"LK",
				"ilaṅkai",
				"Democratic Socialist Republic of Sri Lanka"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"sin": "Sinhala",
				"tam": "Tamil"
			},
			"translations": {
				"deu": {
					"official": "Demokratische Sozialistische Republik Sri Lanka",
					"common": "Sri Lanka"
				},
				"fra": {
					"official": "République démocratique socialiste du Sri Lanka",
					"common": "Sri Lanka"
				},
				"hrv": {
					"official": "Demokratska Socijalističke Republike Šri Lanke",
					"common": "Šri Lanka"
				},
				"ita": {
					"official": "Repubblica democratica socialista dello Sri Lanka",
					"common": "Sri Lanka"
				},
				"jpn": {
					"official": "スリランカ民主社会主義共和国",
					"common": "スリランカ"
				},
				"nld": {
					"official": "Democratische Socialistische Republiek Sri Lanka",
					"common": "Sri Lanka"
				},
				"por": {
					"official": "República Democrática Socialista do Sri Lanka",
					"common": "Sri Lanka"
				},
				"rus": {
					"official": "Демократическая Социалистическая Республика Шри-Ланка",
					"common": "Шри-Ланка"
				},
				"slk": {
					"official": "Srílanská demokratická socialistická republika",
					"common": "Srí Lanka"
				},
				"spa": {
					"official": "República Democrática Socialista de Sri Lanka",
					"common": "Sri Lanka"
				},
				"fin": {
					"official": "Sri Lankan demokraattinen sosialistinen tasavalta",
					"common": "Sri Lanka"
				},
				"zho": {
					"official": "斯里兰卡民主社会主义共和国",
					"common": "斯里兰卡"
				}
			},
			"latlng": [
				7,
				81
			],
			"demonym": "Sri Lankan",
			"landlocked": false,
			"borders": [
				"IND"
			],
			"area": 65610
		},
		{
			"name": {
				"common": "Lesotho",
				"official": "Kingdom of Lesotho",
				"native": {
					"eng": {
						"official": "Kingdom of Lesotho",
						"common": "Lesotho"
					},
					"sot": {
						"official": "Kingdom of Lesotho",
						"common": "Lesotho"
					}
				}
			},
			"tld": [
				".ls"
			],
			"cca2": "LS",
			"ccn3": "426",
			"cca3": "LSO",
			"cioc": "LES",
			"currency": [
				"LSL",
				"ZAR"
			],
			"callingCode": [
				"266"
			],
			"capital": "Maseru",
			"altSpellings": [
				"LS",
				"Kingdom of Lesotho",
				"Muso oa Lesotho"
			],
			"region": "Africa",
			"subregion": "Southern Africa",
			"languages": {
				"eng": "English",
				"sot": "Sotho"
			},
			"translations": {
				"deu": {
					"official": "Königreich Lesotho",
					"common": "Lesotho"
				},
				"fra": {
					"official": "Royaume du Lesotho",
					"common": "Lesotho"
				},
				"hrv": {
					"official": "Kraljevina Lesoto",
					"common": "Lesoto"
				},
				"ita": {
					"official": "Regno del Lesotho",
					"common": "Lesotho"
				},
				"jpn": {
					"official": "レソト王国",
					"common": "レソト"
				},
				"nld": {
					"official": "Koninkrijk Lesotho",
					"common": "Lesotho"
				},
				"por": {
					"official": "Reino do Lesoto",
					"common": "Lesoto"
				},
				"rus": {
					"official": "Королевство Лесото",
					"common": "Лесото"
				},
				"slk": {
					"official": "Lesothské kráľovstvo",
					"common": "Lesotho"
				},
				"spa": {
					"official": "Reino de Lesotho",
					"common": "Lesotho"
				},
				"fin": {
					"official": "Lesothon kuningaskunta",
					"common": "Lesotho"
				},
				"zho": {
					"official": "莱索托王国",
					"common": "莱索托"
				}
			},
			"latlng": [
				-29.5,
				28.5
			],
			"demonym": "Mosotho",
			"landlocked": true,
			"borders": [
				"ZAF"
			],
			"area": 30355
		},
		{
			"name": {
				"common": "Lithuania",
				"official": "Republic of Lithuania",
				"native": {
					"lit": {
						"official": "Lietuvos Respublikos",
						"common": "Lietuva"
					}
				}
			},
			"tld": [
				".lt"
			],
			"cca2": "LT",
			"ccn3": "440",
			"cca3": "LTU",
			"cioc": "LTU",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"370"
			],
			"capital": "Vilnius",
			"altSpellings": [
				"LT",
				"Republic of Lithuania",
				"Lietuvos Respublika"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"lit": "Lithuanian"
			},
			"translations": {
				"deu": {
					"official": "Republik Litauen",
					"common": "Litauen"
				},
				"fra": {
					"official": "République de Lituanie",
					"common": "Lituanie"
				},
				"hrv": {
					"official": "Republika Litva",
					"common": "Litva"
				},
				"ita": {
					"official": "Repubblica di Lituania",
					"common": "Lituania"
				},
				"jpn": {
					"official": "リトアニア共和国",
					"common": "リトアニア"
				},
				"nld": {
					"official": "Republiek Litouwen",
					"common": "Litouwen"
				},
				"por": {
					"official": "República da Lituânia",
					"common": "Lituânia"
				},
				"rus": {
					"official": "Литовская Республика",
					"common": "Литва"
				},
				"slk": {
					"official": "Litovská republika",
					"common": "Litva"
				},
				"spa": {
					"official": "República de Lituania",
					"common": "Lituania"
				},
				"fin": {
					"official": "Liettuan tasavalta",
					"common": "Liettua"
				},
				"zho": {
					"official": "立陶宛共和国",
					"common": "立陶宛"
				}
			},
			"latlng": [
				56,
				24
			],
			"demonym": "Lithuanian",
			"landlocked": false,
			"borders": [
				"BLR",
				"LVA",
				"POL",
				"RUS"
			],
			"area": 65300
		},
		{
			"name": {
				"common": "Luxembourg",
				"official": "Grand Duchy of Luxembourg",
				"native": {
					"deu": {
						"official": "Großherzogtum Luxemburg",
						"common": "Luxemburg"
					},
					"fra": {
						"official": "Grand-Duché de Luxembourg",
						"common": "Luxembourg"
					},
					"ltz": {
						"official": "Groussherzogtum Lëtzebuerg",
						"common": "Lëtzebuerg"
					}
				}
			},
			"tld": [
				".lu"
			],
			"cca2": "LU",
			"ccn3": "442",
			"cca3": "LUX",
			"cioc": "LUX",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"352"
			],
			"capital": "Luxembourg",
			"altSpellings": [
				"LU",
				"Grand Duchy of Luxembourg",
				"Grand-Duché de Luxembourg",
				"Großherzogtum Luxemburg",
				"Groussherzogtum Lëtzebuerg"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"deu": "German",
				"fra": "French",
				"ltz": "Luxembourgish"
			},
			"translations": {
				"deu": {
					"official": "Großherzogtum Luxemburg,",
					"common": "Luxemburg"
				},
				"fra": {
					"official": "Grand-Duché de Luxembourg",
					"common": "Luxembourg"
				},
				"hrv": {
					"official": "Veliko Vojvodstvo Luksemburg",
					"common": "Luksemburg"
				},
				"ita": {
					"official": "Granducato di Lussemburgo",
					"common": "Lussemburgo"
				},
				"jpn": {
					"official": "ルクセンブルク大公国",
					"common": "ルクセンブルク"
				},
				"nld": {
					"official": "Groothertogdom Luxemburg",
					"common": "Luxemburg"
				},
				"por": {
					"official": "Grão-Ducado do Luxemburgo",
					"common": "Luxemburgo"
				},
				"rus": {
					"official": "Великое Герцогство Люксембург",
					"common": "Люксембург"
				},
				"slk": {
					"official": "Luxemburské veľkovojvodstvo",
					"common": "Luxembursko"
				},
				"spa": {
					"official": "Gran Ducado de Luxemburgo",
					"common": "Luxemburgo"
				},
				"fin": {
					"official": "Luxemburgin suurherttuakunta",
					"common": "Luxemburg"
				},
				"zho": {
					"official": "卢森堡大公国",
					"common": "卢森堡"
				}
			},
			"latlng": [
				49.75,
				6.16666666
			],
			"demonym": "Luxembourger",
			"landlocked": true,
			"borders": [
				"BEL",
				"FRA",
				"DEU"
			],
			"area": 2586
		},
		{
			"name": {
				"common": "Latvia",
				"official": "Republic of Latvia",
				"native": {
					"lav": {
						"official": "Latvijas Republikas",
						"common": "Latvija"
					}
				}
			},
			"tld": [
				".lv"
			],
			"cca2": "LV",
			"ccn3": "428",
			"cca3": "LVA",
			"cioc": "LAT",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"371"
			],
			"capital": "Riga",
			"altSpellings": [
				"LV",
				"Republic of Latvia",
				"Latvijas Republika"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"lav": "Latvian"
			},
			"translations": {
				"deu": {
					"official": "Republik Lettland",
					"common": "Lettland"
				},
				"fra": {
					"official": "République de Lettonie",
					"common": "Lettonie"
				},
				"hrv": {
					"official": "Republika Latvija",
					"common": "Latvija"
				},
				"ita": {
					"official": "Repubblica di Lettonia",
					"common": "Lettonia"
				},
				"jpn": {
					"official": "ラトビア共和国",
					"common": "ラトビア"
				},
				"nld": {
					"official": "Republiek Letland",
					"common": "Letland"
				},
				"por": {
					"official": "República da Letónia",
					"common": "Letónia"
				},
				"rus": {
					"official": "Латвийская Республика",
					"common": "Латвия"
				},
				"slk": {
					"official": "Lotyšská republika",
					"common": "Lotyšsko"
				},
				"spa": {
					"official": "República de Letonia",
					"common": "Letonia"
				},
				"fin": {
					"official": "Latvian tasavalta",
					"common": "Latvia"
				},
				"zho": {
					"official": "拉脱维亚共和国",
					"common": "拉脱维亚"
				}
			},
			"latlng": [
				57,
				25
			],
			"demonym": "Latvian",
			"landlocked": false,
			"borders": [
				"BLR",
				"EST",
				"LTU",
				"RUS"
			],
			"area": 64559
		},
		{
			"name": {
				"common": "Macau",
				"official": "Macao Special Administrative Region of the People's Republic of China",
				"native": {
					"por": {
						"official": "Região Administrativa Especial de Macau da República Popular da China",
						"common": "Macau"
					},
					"zho": {
						"official": "中华人民共和国澳门特别行政区",
						"common": "澳门"
					}
				}
			},
			"tld": [
				".mo"
			],
			"cca2": "MO",
			"ccn3": "446",
			"cca3": "MAC",
			"cioc": "",
			"currency": [
				"MOP"
			],
			"callingCode": [
				"853"
			],
			"capital": "",
			"altSpellings": [
				"MO",
				"澳门",
				"Macao",
				"Macao Special Administrative Region of the People's Republic of China",
				"中華人民共和國澳門特別行政區",
				"Região Administrativa Especial de Macau da República Popular da China"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"por": "Portuguese",
				"zho": "Chinese"
			},
			"translations": {
				"deu": {
					"official": "Sonderverwaltungsregion Macau der Volksrepublik China",
					"common": "Macao"
				},
				"fra": {
					"official": "Région administrative spéciale de Macao de la République populaire de Chine",
					"common": "Macao"
				},
				"hrv": {
					"official": "Makao Posebnog upravnog područjaNarodne Republike Kine",
					"common": "Makao"
				},
				"ita": {
					"official": "Macao Regione amministrativa speciale della Repubblica Popolare Cinese",
					"common": "Macao"
				},
				"jpn": {
					"official": "中華人民共和国マカオ特別行政区",
					"common": "マカオ"
				},
				"nld": {
					"official": "Speciale Administratieve Regio Macau van de Volksrepubliek China",
					"common": "Macao"
				},
				"por": {
					"official": "Macau Região Administrativa Especial da República Popular da China",
					"common": "Macau"
				},
				"rus": {
					"official": "Специальный административный район Макао Китайской Народной Республики Китай",
					"common": "Макао"
				},
				"slk": {
					"official": "Macao, Špeciàlna administratívna oblasŦ",
					"common": "Macao"
				},
				"spa": {
					"official": "Macao, Región Administrativa Especial de la República Popular China",
					"common": "Macao"
				},
				"fin": {
					"official": "Macaon Kiinan kansantasavallan erityishallintoalue",
					"common": "Macao"
				}
			},
			"latlng": [
				22.16666666,
				113.55
			],
			"demonym": "Chinese",
			"landlocked": false,
			"borders": [
				"CHN"
			],
			"area": 30
		},
		{
			"name": {
				"common": "Saint Martin",
				"official": "Saint Martin",
				"native": {
					"fra": {
						"official": "Saint-Martin",
						"common": "Saint-Martin"
					}
				}
			},
			"tld": [
				".fr",
				".gp"
			],
			"cca2": "MF",
			"ccn3": "663",
			"cca3": "MAF",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"590"
			],
			"capital": "Marigot",
			"altSpellings": [
				"MF",
				"Collectivity of Saint Martin",
				"Collectivité de Saint-Martin",
				"Saint Martin (French part)"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "St. Martin",
					"common": "Saint Martin"
				},
				"fra": {
					"official": "Saint-Martin",
					"common": "Saint-Martin"
				},
				"hrv": {
					"official": "Saint Martin",
					"common": "Sveti Martin"
				},
				"ita": {
					"official": "saint Martin",
					"common": "Saint Martin"
				},
				"jpn": {
					"official": "サンマルタン島",
					"common": "サン・マルタン（フランス領）"
				},
				"nld": {
					"official": "Saint Martin",
					"common": "Saint-Martin"
				},
				"por": {
					"official": "saint Martin",
					"common": "São Martinho"
				},
				"rus": {
					"official": "Сен-Мартен",
					"common": "Сен-Мартен"
				},
				"slk": {
					"official": "Saint-Martin",
					"common": "Saint-Martin"
				},
				"spa": {
					"official": "Saint Martin",
					"common": "Saint Martin"
				},
				"fin": {
					"official": "Saint-Martin",
					"common": "Saint-Martin"
				},
				"zho": {
					"official": "圣马丁",
					"common": "圣马丁"
				}
			},
			"latlng": [
				18.08333333,
				-63.95
			],
			"demonym": "Saint Martin Islander",
			"landlocked": false,
			"borders": [
				"SXM"
			],
			"area": 53
		},
		{
			"name": {
				"common": "Morocco",
				"official": "Kingdom of Morocco",
				"native": {
					"ara": {
						"official": "المملكة المغربية",
						"common": "المغرب"
					},
					"ber": {
						"official": "ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ",
						"common": "ⵍⵎⴰⵖⵔⵉⴱ"
					}
				}
			},
			"tld": [
				".ma",
				"المغرب."
			],
			"cca2": "MA",
			"ccn3": "504",
			"cca3": "MAR",
			"cioc": "MAR",
			"currency": [
				"MAD"
			],
			"callingCode": [
				"212"
			],
			"capital": "Rabat",
			"altSpellings": [
				"MA",
				"Kingdom of Morocco",
				"Al-Mamlakah al-Maġribiyah"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic",
				"ber": "Berber"
			},
			"translations": {
				"deu": {
					"official": "Königreich Marokko",
					"common": "Marokko"
				},
				"fra": {
					"official": "Royaume du Maroc",
					"common": "Maroc"
				},
				"hrv": {
					"official": "Kraljevina Maroko",
					"common": "Maroko"
				},
				"ita": {
					"official": "Regno del Marocco",
					"common": "Marocco"
				},
				"jpn": {
					"official": "モロッコ王国",
					"common": "モロッコ"
				},
				"nld": {
					"official": "Koninkrijk Marokko",
					"common": "Marokko"
				},
				"por": {
					"official": "Reino de Marrocos",
					"common": "Marrocos"
				},
				"rus": {
					"official": "Королевство Марокко",
					"common": "Марокко"
				},
				"slk": {
					"official": "Marocké kniežatstvo",
					"common": "Maroko"
				},
				"spa": {
					"official": "Reino de Marruecos",
					"common": "Marruecos"
				},
				"fin": {
					"official": "Marokon kuningaskunta",
					"common": "Marokko"
				},
				"zho": {
					"official": "摩洛哥王国",
					"common": "摩洛哥"
				}
			},
			"latlng": [
				32,
				-5
			],
			"demonym": "Moroccan",
			"landlocked": false,
			"borders": [
				"DZA",
				"ESH",
				"ESP"
			],
			"area": 446550
		},
		{
			"name": {
				"common": "Monaco",
				"official": "Principality of Monaco",
				"native": {
					"fra": {
						"official": "Principauté de Monaco",
						"common": "Monaco"
					}
				}
			},
			"tld": [
				".mc"
			],
			"cca2": "MC",
			"ccn3": "492",
			"cca3": "MCO",
			"cioc": "MON",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"377"
			],
			"capital": "Monaco",
			"altSpellings": [
				"MC",
				"Principality of Monaco",
				"Principauté de Monaco"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Fürstentum Monaco",
					"common": "Monaco"
				},
				"fra": {
					"official": "Principauté de Monaco",
					"common": "Monaco"
				},
				"hrv": {
					"official": "Kneževina Monako",
					"common": "Monako"
				},
				"ita": {
					"official": "Principato di Monaco",
					"common": "Principato di Monaco"
				},
				"jpn": {
					"official": "モナコ公国",
					"common": "モナコ"
				},
				"nld": {
					"official": "Vorstendom Monaco",
					"common": "Monaco"
				},
				"por": {
					"official": "Principado do Mónaco",
					"common": "Mónaco"
				},
				"rus": {
					"official": "Княжество Монако",
					"common": "Монако"
				},
				"slk": {
					"official": "Monacké kniežatstvo",
					"common": "Monako"
				},
				"spa": {
					"official": "Principado de Mónaco",
					"common": "Mónaco"
				},
				"fin": {
					"official": "Monacon ruhtinaskunta",
					"common": "Monaco"
				},
				"zho": {
					"official": "摩纳哥公国",
					"common": "摩纳哥"
				}
			},
			"latlng": [
				43.73333333,
				7.4
			],
			"demonym": "Monegasque",
			"landlocked": false,
			"borders": [
				"FRA"
			],
			"area": 2.02
		},
		{
			"name": {
				"common": "Moldova",
				"official": "Republic of Moldova",
				"native": {
					"ron": {
						"official": "Republica Moldova",
						"common": "Moldova"
					}
				}
			},
			"tld": [
				".md"
			],
			"cca2": "MD",
			"ccn3": "498",
			"cca3": "MDA",
			"cioc": "MDA",
			"currency": [
				"MDL"
			],
			"callingCode": [
				"373"
			],
			"capital": "Chișinău",
			"altSpellings": [
				"MD",
				"Moldova, Republic of",
				"Republic of Moldova",
				"Republica Moldova"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"ron": "Moldavian"
			},
			"translations": {
				"deu": {
					"official": "Republik Moldau",
					"common": "Moldawie"
				},
				"fra": {
					"official": "République de Moldavie",
					"common": "Moldavie"
				},
				"hrv": {
					"official": "Moldavija",
					"common": "Moldova"
				},
				"ita": {
					"official": "Repubblica di Moldova",
					"common": "Moldavia"
				},
				"jpn": {
					"official": "モルドバ共和国",
					"common": "モルドバ共和国"
				},
				"nld": {
					"official": "Republiek Moldavië",
					"common": "Moldavië"
				},
				"por": {
					"official": "República da Moldávia",
					"common": "Moldávia"
				},
				"rus": {
					"official": "Молдова",
					"common": "Молдавия"
				},
				"slk": {
					"official": "Moldavská republika",
					"common": "Moldavsko"
				},
				"spa": {
					"official": "República de Moldova",
					"common": "Moldavia"
				},
				"fin": {
					"official": "Moldovan tasavalta",
					"common": "Moldova"
				},
				"zho": {
					"official": "摩尔多瓦共和国",
					"common": "摩尔多瓦"
				}
			},
			"latlng": [
				47,
				29
			],
			"demonym": "Moldovan",
			"landlocked": true,
			"borders": [
				"ROU",
				"UKR"
			],
			"area": 33846
		},
		{
			"name": {
				"common": "Madagascar",
				"official": "Republic of Madagascar",
				"native": {
					"fra": {
						"official": "République de Madagascar",
						"common": "Madagascar"
					},
					"mlg": {
						"official": "Repoblikan'i Madagasikara",
						"common": "Madagasikara"
					}
				}
			},
			"tld": [
				".mg"
			],
			"cca2": "MG",
			"ccn3": "450",
			"cca3": "MDG",
			"cioc": "MAD",
			"currency": [
				"MGA"
			],
			"callingCode": [
				"261"
			],
			"capital": "Antananarivo",
			"altSpellings": [
				"MG",
				"Republic of Madagascar",
				"Repoblikan'i Madagasikara",
				"République de Madagascar"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"fra": "French",
				"mlg": "Malagasy"
			},
			"translations": {
				"deu": {
					"official": "Republik Madagaskar",
					"common": "Madagaskar"
				},
				"fra": {
					"official": "République de Madagascar",
					"common": "Madagascar"
				},
				"hrv": {
					"official": "Republika Madagaskar",
					"common": "Madagaskar"
				},
				"ita": {
					"official": "Repubblica del Madagascar",
					"common": "Madagascar"
				},
				"jpn": {
					"official": "マダガスカル共和国",
					"common": "マダガスカル"
				},
				"nld": {
					"official": "Republiek Madagaskar",
					"common": "Madagaskar"
				},
				"por": {
					"official": "República de Madagáscar",
					"common": "Madagáscar"
				},
				"rus": {
					"official": "Республика Мадагаскар",
					"common": "Мадагаскар"
				},
				"slk": {
					"official": "Madagaskarská republika",
					"common": "Madagaskar"
				},
				"spa": {
					"official": "República de Madagascar",
					"common": "Madagascar"
				},
				"fin": {
					"official": "Madagaskarin tasavalta",
					"common": "Madagaskar"
				},
				"zho": {
					"official": "马达加斯加共和国",
					"common": "马达加斯加"
				}
			},
			"latlng": [
				-20,
				47
			],
			"demonym": "Malagasy",
			"landlocked": false,
			"borders": [],
			"area": 587041
		},
		{
			"name": {
				"common": "Maldives",
				"official": "Republic of the Maldives",
				"native": {
					"div": {
						"official": "ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ",
						"common": "ދިވެހިރާއްޖޭގެ"
					}
				}
			},
			"tld": [
				".mv"
			],
			"cca2": "MV",
			"ccn3": "462",
			"cca3": "MDV",
			"cioc": "MDV",
			"currency": [
				"MVR"
			],
			"callingCode": [
				"960"
			],
			"capital": "Malé",
			"altSpellings": [
				"MV",
				"Maldive Islands",
				"Republic of the Maldives",
				"Dhivehi Raajjeyge Jumhooriyya"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"div": "Maldivian"
			},
			"translations": {
				"deu": {
					"official": "Republik Malediven",
					"common": "Malediven"
				},
				"fra": {
					"official": "République des Maldives",
					"common": "Maldives"
				},
				"hrv": {
					"official": "Republika Maldivi",
					"common": "Maldivi"
				},
				"ita": {
					"official": "Repubblica delle Maldive",
					"common": "Maldive"
				},
				"jpn": {
					"official": "モルディブ共和国",
					"common": "モルディブ"
				},
				"nld": {
					"official": "Republiek van de Malediven",
					"common": "Maldiven"
				},
				"por": {
					"official": "República das Maldivas",
					"common": "Maldivas"
				},
				"slk": {
					"official": "República de las Maldivas",
					"common": "Maldivas"
				},
				"rus": {
					"official": "Республика Мальдивы",
					"common": "Мальдивы"
				},
				"svk": {
					"official": "Maldivská republika",
					"common": "Maldivy"
				},
				"fin": {
					"official": "Malediivien tasavalta",
					"common": "Malediivit"
				},
				"zho": {
					"official": "马尔代夫共和国",
					"common": "马尔代夫"
				}
			},
			"latlng": [
				3.25,
				73
			],
			"demonym": "Maldivan",
			"landlocked": false,
			"borders": [],
			"area": 300
		},
		{
			"name": {
				"common": "Mexico",
				"official": "United Mexican States",
				"native": {
					"spa": {
						"official": "Estados Unidos Mexicanos",
						"common": "México"
					}
				}
			},
			"tld": [
				".mx"
			],
			"cca2": "MX",
			"ccn3": "484",
			"cca3": "MEX",
			"cioc": "MEX",
			"currency": [
				"MXN"
			],
			"callingCode": [
				"52"
			],
			"capital": "Mexico City",
			"altSpellings": [
				"MX",
				"Mexicanos",
				"United Mexican States",
				"Estados Unidos Mexicanos"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Vereinigte Mexikanische Staaten",
					"common": "Mexiko"
				},
				"fra": {
					"official": "États-Unis du Mexique",
					"common": "Mexique"
				},
				"hrv": {
					"official": "Sjedinjene Meksičke Države",
					"common": "Meksiko"
				},
				"ita": {
					"official": "Stati Uniti del Messico",
					"common": "Messico"
				},
				"jpn": {
					"official": "メキシコ合衆国",
					"common": "メキシコ"
				},
				"nld": {
					"official": "Verenigde Mexicaanse Staten",
					"common": "Mexico"
				},
				"por": {
					"official": "Estados Unidos Mexicanos",
					"common": "México"
				},
				"rus": {
					"official": "Мексиканских Соединенных Штатов",
					"common": "Мексика"
				},
				"slk": {
					"official": "Spojené štášy mexické",
					"common": "Mexiko"
				},
				"spa": {
					"official": "Estados Unidos Mexicanos",
					"common": "México"
				},
				"fin": {
					"official": "Meksikon yhdysvallat",
					"common": "Meksiko"
				},
				"zho": {
					"official": "墨西哥合众国",
					"common": "墨西哥"
				}
			},
			"latlng": [
				23,
				-102
			],
			"demonym": "Mexican",
			"landlocked": false,
			"borders": [
				"BLZ",
				"GTM",
				"USA"
			],
			"area": 1964375
		},
		{
			"name": {
				"common": "Marshall Islands",
				"official": "Republic of the Marshall Islands",
				"native": {
					"eng": {
						"official": "Republic of the Marshall Islands",
						"common": "Marshall Islands"
					},
					"mah": {
						"official": "Republic of the Marshall Islands",
						"common": "M̧ajeļ"
					}
				}
			},
			"tld": [
				".mh"
			],
			"cca2": "MH",
			"ccn3": "584",
			"cca3": "MHL",
			"cioc": "MHL",
			"currency": [
				"USD"
			],
			"callingCode": [
				"692"
			],
			"capital": "Majuro",
			"altSpellings": [
				"MH",
				"Republic of the Marshall Islands",
				"Aolepān Aorōkin M̧ajeļ"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"eng": "English",
				"mah": "Marshallese"
			},
			"translations": {
				"deu": {
					"official": "Republik der Marshall-Inseln",
					"common": "Marshallinseln"
				},
				"fra": {
					"official": "République des Îles Marshall",
					"common": "Îles Marshall"
				},
				"hrv": {
					"official": "Republika Maršalovi Otoci",
					"common": "Maršalovi Otoci"
				},
				"ita": {
					"official": "Repubblica delle Isole Marshall",
					"common": "Isole Marshall"
				},
				"jpn": {
					"official": "マーシャル諸島共和国",
					"common": "マーシャル諸島"
				},
				"nld": {
					"official": "Republiek van de Marshall-eilanden",
					"common": "Marshalleilanden"
				},
				"por": {
					"official": "República das Ilhas Marshall",
					"common": "Ilhas Marshall"
				},
				"rus": {
					"official": "Республика Маршалловы острова",
					"common": "Маршалловы Острова"
				},
				"slk": {
					"official": "Republika Marshallových ostrovov",
					"common": "Marshallove ostrovy"
				},
				"spa": {
					"official": "República de las Islas Marshall",
					"common": "Islas Marshall"
				},
				"fin": {
					"official": "Marshallinsaarten tasavalta",
					"common": "Marshallinsaaret"
				},
				"zho": {
					"official": "马绍尔群岛共和国",
					"common": "马绍尔群岛"
				}
			},
			"latlng": [
				9,
				168
			],
			"demonym": "Marshallese",
			"landlocked": false,
			"borders": [],
			"area": 181
		},
		{
			"name": {
				"common": "Macedonia",
				"official": "Republic of Macedonia",
				"native": {
					"mkd": {
						"official": "Република Македонија",
						"common": "Македонија"
					}
				}
			},
			"tld": [
				".mk"
			],
			"cca2": "MK",
			"ccn3": "807",
			"cca3": "MKD",
			"cioc": "MKD",
			"currency": [
				"MKD"
			],
			"callingCode": [
				"389"
			],
			"capital": "Skopje",
			"altSpellings": [
				"MK",
				"Macedonia, the Former Yugoslav Republic of",
				"Republic of Macedonia",
				"Република Македонија"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"mkd": "Macedonian"
			},
			"translations": {
				"deu": {
					"official": "Republik Mazedonien",
					"common": "Mazedonien"
				},
				"fra": {
					"official": "République de Macédoine",
					"common": "Macédoine"
				},
				"hrv": {
					"official": "Republika Makedonija",
					"common": "Makedonija"
				},
				"ita": {
					"official": "Repubblica di Macedonia",
					"common": "Macedonia"
				},
				"jpn": {
					"official": "マケドニア共和国",
					"common": "マケドニア旧ユーゴスラビア共和国"
				},
				"nld": {
					"official": "Republic of Macedonia",
					"common": "Macedonië"
				},
				"por": {
					"official": "República da Macedónia",
					"common": "Macedónia"
				},
				"rus": {
					"official": "Республика Македония",
					"common": "Республика Македония"
				},
				"slk": {
					"official": "Macedónska republika",
					"common": "Macedónsko"
				},
				"spa": {
					"official": "República de Macedonia",
					"common": "Macedonia"
				},
				"fin": {
					"official": "Makedonian tasavalta",
					"common": "Makedonia"
				},
				"zho": {
					"official": "马其顿共和国",
					"common": "马其顿"
				}
			},
			"latlng": [
				41.83333333,
				22
			],
			"demonym": "Macedonian",
			"landlocked": true,
			"borders": [
				"ALB",
				"BGR",
				"GRC",
				"UNK",
				"SRB"
			],
			"area": 25713
		},
		{
			"name": {
				"common": "Mali",
				"official": "Republic of Mali",
				"native": {
					"fra": {
						"official": "République du Mali",
						"common": "Mali"
					}
				}
			},
			"tld": [
				".ml"
			],
			"cca2": "ML",
			"ccn3": "466",
			"cca3": "MLI",
			"cioc": "MLI",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"223"
			],
			"capital": "Bamako",
			"altSpellings": [
				"ML",
				"Republic of Mali",
				"République du Mali"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Mali",
					"common": "Mali"
				},
				"fra": {
					"official": "République du Mali",
					"common": "Mali"
				},
				"hrv": {
					"official": "Republika Mali",
					"common": "Mali"
				},
				"ita": {
					"official": "Repubblica del Mali",
					"common": "Mali"
				},
				"jpn": {
					"official": "マリ共和国",
					"common": "マリ"
				},
				"nld": {
					"official": "Republiek Mali",
					"common": "Mali"
				},
				"por": {
					"official": "República do Mali",
					"common": "Mali"
				},
				"rus": {
					"official": "Республика Мали",
					"common": "Мали"
				},
				"slk": {
					"official": "Malijská republika",
					"common": "Mali"
				},
				"spa": {
					"official": "República de Malí",
					"common": "Mali"
				},
				"fin": {
					"official": "Malin tasavalta",
					"common": "Mali"
				},
				"zho": {
					"official": "马里共和国",
					"common": "马里"
				}
			},
			"latlng": [
				17,
				-4
			],
			"demonym": "Malian",
			"landlocked": true,
			"borders": [
				"DZA",
				"BFA",
				"GIN",
				"CIV",
				"MRT",
				"NER",
				"SEN"
			],
			"area": 1240192
		},
		{
			"name": {
				"common": "Malta",
				"official": "Republic of Malta",
				"native": {
					"eng": {
						"official": "Republic of Malta",
						"common": "Malta"
					},
					"mlt": {
						"official": "Repubblika ta ' Malta",
						"common": "Malta"
					}
				}
			},
			"tld": [
				".mt"
			],
			"cca2": "MT",
			"ccn3": "470",
			"cca3": "MLT",
			"cioc": "MLT",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"356"
			],
			"capital": "Valletta",
			"altSpellings": [
				"MT",
				"Republic of Malta",
				"Repubblika ta' Malta"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"eng": "English",
				"mlt": "Maltese"
			},
			"translations": {
				"deu": {
					"official": "Republik Malta",
					"common": "Malta"
				},
				"fra": {
					"official": "République de Malte",
					"common": "Malte"
				},
				"hrv": {
					"official": "Republika Malta",
					"common": "Malta"
				},
				"ita": {
					"official": "Repubblica di Malta",
					"common": "Malta"
				},
				"jpn": {
					"official": "マルタ共和国",
					"common": "マルタ"
				},
				"nld": {
					"official": "Republiek Malta",
					"common": "Malta"
				},
				"por": {
					"official": "República de Malta",
					"common": "Malta"
				},
				"rus": {
					"official": "Республика Мальта",
					"common": "Мальта"
				},
				"slk": {
					"official": "Maltská republika",
					"common": "Malta"
				},
				"spa": {
					"official": "República de Malta",
					"common": "Malta"
				},
				"fin": {
					"official": "Maltan tasavalta",
					"common": "Malta"
				},
				"zho": {
					"official": "马耳他共和国",
					"common": "马耳他"
				}
			},
			"latlng": [
				35.83333333,
				14.58333333
			],
			"demonym": "Maltese",
			"landlocked": false,
			"borders": [],
			"area": 316
		},
		{
			"name": {
				"common": "Myanmar",
				"official": "Republic of the Union of Myanmar",
				"native": {
					"mya": {
						"official": "ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်",
						"common": "မြန်မာ"
					}
				}
			},
			"tld": [
				".mm"
			],
			"cca2": "MM",
			"ccn3": "104",
			"cca3": "MMR",
			"cioc": "MYA",
			"currency": [
				"MMK"
			],
			"callingCode": [
				"95"
			],
			"capital": "Naypyidaw",
			"altSpellings": [
				"MM",
				"Burma",
				"Republic of the Union of Myanmar",
				"Pyidaunzu Thanmăda Myăma Nainngandaw"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"mya": "Burmese"
			},
			"translations": {
				"deu": {
					"official": "Republik der Union von Myanmar",
					"common": "Myanmar"
				},
				"fra": {
					"official": "République de l'Union du Myanmar",
					"common": "Birmanie"
				},
				"hrv": {
					"official": "Republika Unije Mijanmar",
					"common": "Mijanmar"
				},
				"ita": {
					"official": "Repubblica dell'Unione di Myanmar",
					"common": "Birmania"
				},
				"jpn": {
					"official": "ミャンマー連邦共和国",
					"common": "ミャンマー"
				},
				"nld": {
					"official": "Republiek van de Unie van Myanmar",
					"common": "Myanmar"
				},
				"por": {
					"official": "República da União de Myanmar",
					"common": "Myanmar"
				},
				"rus": {
					"official": "Республика Союза Мьянма",
					"common": "Мьянма"
				},
				"slk": {
					"official": "Mjanmarská zväzová republika",
					"common": "Mjanmarsko"
				},
				"spa": {
					"official": "República de la Unión de Myanmar",
					"common": "Myanmar"
				},
				"fin": {
					"official": "Myanmarin liiton tasavalta",
					"common": "Myanmar"
				},
				"zho": {
					"official": "缅甸联邦共和国",
					"common": "缅甸"
				}
			},
			"latlng": [
				22,
				98
			],
			"demonym": "Bamar",
			"landlocked": false,
			"borders": [
				"BGD",
				"CHN",
				"IND",
				"LAO",
				"THA"
			],
			"area": 676578
		},
		{
			"name": {
				"common": "Montenegro",
				"official": "Montenegro",
				"native": {
					"srp": {
						"official": "Црна Гора",
						"common": "Црна Гора"
					}
				}
			},
			"tld": [
				".me"
			],
			"cca2": "ME",
			"ccn3": "499",
			"cca3": "MNE",
			"cioc": "MNE",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"382"
			],
			"capital": "Podgorica",
			"altSpellings": [
				"ME",
				"Crna Gora"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"srp": "Montenegrin"
			},
			"translations": {
				"deu": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"fra": {
					"official": "Monténégro",
					"common": "Monténégro"
				},
				"hrv": {
					"official": "Crna Gora",
					"common": "Crna Gora"
				},
				"ita": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"jpn": {
					"official": "モンテネグロ",
					"common": "モンテネグロ"
				},
				"nld": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"por": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"rus": {
					"official": "Черногория",
					"common": "Черногория"
				},
				"slk": {
					"official": "Čierna Hora",
					"common": "Čierna Hora"
				},
				"spa": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"fin": {
					"official": "Montenegro",
					"common": "Montenegro"
				},
				"zho": {
					"official": "黑山",
					"common": "黑山"
				}
			},
			"latlng": [
				42.5,
				19.3
			],
			"demonym": "Montenegrin",
			"landlocked": false,
			"borders": [
				"ALB",
				"BIH",
				"HRV",
				"UNK",
				"SRB"
			],
			"area": 13812
		},
		{
			"name": {
				"common": "Mongolia",
				"official": "Mongolia",
				"native": {
					"mon": {
						"official": "Монгол улс",
						"common": "Монгол улс"
					}
				}
			},
			"tld": [
				".mn"
			],
			"cca2": "MN",
			"ccn3": "496",
			"cca3": "MNG",
			"cioc": "MGL",
			"currency": [
				"MNT"
			],
			"callingCode": [
				"976"
			],
			"capital": "Ulan Bator",
			"altSpellings": [
				"MN"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"mon": "Mongolian"
			},
			"translations": {
				"deu": {
					"official": "Mongolei",
					"common": "Mongolei"
				},
				"fra": {
					"official": "Mongolie",
					"common": "Mongolie"
				},
				"hrv": {
					"official": "Mongolija",
					"common": "Mongolija"
				},
				"ita": {
					"official": "Mongolia",
					"common": "Mongolia"
				},
				"jpn": {
					"official": "モンゴル",
					"common": "モンゴル"
				},
				"nld": {
					"official": "Mongolië",
					"common": "Mongolië"
				},
				"por": {
					"official": "Mongólia",
					"common": "Mongólia"
				},
				"rus": {
					"official": "Монголия",
					"common": "Монголия"
				},
				"slk": {
					"official": "Mongolsko",
					"common": "Mongolsko"
				},
				"spa": {
					"official": "Mongolia",
					"common": "Mongolia"
				},
				"fin": {
					"official": "Mongolian tasavalta",
					"common": "Mongolia"
				},
				"zho": {
					"official": "蒙古",
					"common": "蒙古"
				}
			},
			"latlng": [
				46,
				105
			],
			"demonym": "Mongolian",
			"landlocked": true,
			"borders": [
				"CHN",
				"RUS"
			],
			"area": 1564110
		},
		{
			"name": {
				"common": "Northern Mariana Islands",
				"official": "Commonwealth of the Northern Mariana Islands",
				"native": {
					"cal": {
						"official": "Commonwealth of the Northern Mariana Islands",
						"common": "Northern Mariana Islands"
					},
					"cha": {
						"official": "Sankattan Siha Na Islas Mariånas",
						"common": "Na Islas Mariånas"
					},
					"eng": {
						"official": "Commonwealth of the Northern Mariana Islands",
						"common": "Northern Mariana Islands"
					}
				}
			},
			"tld": [
				".mp"
			],
			"cca2": "MP",
			"ccn3": "580",
			"cca3": "MNP",
			"cioc": "",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1670"
			],
			"capital": "Saipan",
			"altSpellings": [
				"MP",
				"Commonwealth of the Northern Mariana Islands",
				"Sankattan Siha Na Islas Mariånas"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"cal": "Carolinian",
				"cha": "Chamorro",
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Commonwealth der Nördlichen Marianen",
					"common": "Nördliche Marianen"
				},
				"fra": {
					"official": "Commonwealth des îles Mariannes du Nord",
					"common": "Îles Mariannes du Nord"
				},
				"hrv": {
					"official": "Zajednica je Sjeverni Marijanski otoci",
					"common": "Sjevernomarijanski otoci"
				},
				"ita": {
					"official": "Commonwealth delle Isole Marianne Settentrionali",
					"common": "Isole Marianne Settentrionali"
				},
				"jpn": {
					"official": "北マリアナ諸島",
					"common": "北マリアナ諸島"
				},
				"nld": {
					"official": "Commonwealth van de Noordelijke Marianen",
					"common": "Noordelijke Marianeneilanden"
				},
				"por": {
					"official": "Comunidade das Ilhas Marianas do Norte",
					"common": "Marianas Setentrionais"
				},
				"rus": {
					"official": "Содружество Северных Марианских островов",
					"common": "Северные Марианские острова"
				},
				"slk": {
					"official": "Spoločenstvo ostrovov Severné Mariány",
					"common": "Severné Mariány"
				},
				"spa": {
					"official": "Mancomunidad de las Islas Marianas del Norte",
					"common": "Islas Marianas del Norte"
				},
				"fin": {
					"official": "Pohjois-Mariaanit",
					"common": "Pohjois-Mariaanit"
				},
				"zho": {
					"official": "北马里亚纳群岛",
					"common": "北马里亚纳群岛"
				}
			},
			"latlng": [
				15.2,
				145.75
			],
			"demonym": "American",
			"landlocked": false,
			"borders": [],
			"area": 464
		},
		{
			"name": {
				"common": "Mozambique",
				"official": "Republic of Mozambique",
				"native": {
					"por": {
						"official": "República de Moçambique",
						"common": "Moçambique"
					}
				}
			},
			"tld": [
				".mz"
			],
			"cca2": "MZ",
			"ccn3": "508",
			"cca3": "MOZ",
			"cioc": "MOZ",
			"currency": [
				"MZN"
			],
			"callingCode": [
				"258"
			],
			"capital": "Maputo",
			"altSpellings": [
				"MZ",
				"Republic of Mozambique",
				"República de Moçambique"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"deu": {
					"official": "Republik Mosambik",
					"common": "Mosambik"
				},
				"fra": {
					"official": "République du Mozambique",
					"common": "Mozambique"
				},
				"hrv": {
					"official": "Republika Mozambiku",
					"common": "Mozambik"
				},
				"ita": {
					"official": "Repubblica del Mozambico",
					"common": "Mozambico"
				},
				"jpn": {
					"official": "モザンビーク共和国",
					"common": "モザンビーク"
				},
				"nld": {
					"official": "Republiek Mozambique",
					"common": "Mozambique"
				},
				"por": {
					"official": "República de Moçambique",
					"common": "Moçambique"
				},
				"rus": {
					"official": "Республика Мозамбик",
					"common": "Мозамбик"
				},
				"slk": {
					"official": "Mozambická republika",
					"common": "Mozambik"
				},
				"spa": {
					"official": "República de Mozambique",
					"common": "Mozambique"
				},
				"fin": {
					"official": "Mosambikin tasavalta",
					"common": "Mosambik"
				},
				"zho": {
					"official": "莫桑比克共和国",
					"common": "莫桑比克"
				}
			},
			"latlng": [
				-18.25,
				35
			],
			"demonym": "Mozambican",
			"landlocked": false,
			"borders": [
				"MWI",
				"ZAF",
				"SWZ",
				"TZA",
				"ZMB",
				"ZWE"
			],
			"area": 801590
		},
		{
			"name": {
				"common": "Mauritania",
				"official": "Islamic Republic of Mauritania",
				"native": {
					"ara": {
						"official": "الجمهورية الإسلامية الموريتانية",
						"common": "موريتانيا"
					}
				}
			},
			"tld": [
				".mr"
			],
			"cca2": "MR",
			"ccn3": "478",
			"cca3": "MRT",
			"cioc": "MTN",
			"currency": [
				"MRO"
			],
			"callingCode": [
				"222"
			],
			"capital": "Nouakchott",
			"altSpellings": [
				"MR",
				"Islamic Republic of Mauritania",
				"al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Islamische Republik Mauretanien",
					"common": "Mauretanien"
				},
				"fra": {
					"official": "République islamique de Mauritanie",
					"common": "Mauritanie"
				},
				"hrv": {
					"official": "Islamska Republika Mauritanija",
					"common": "Mauritanija"
				},
				"ita": {
					"official": "Repubblica islamica di Mauritania",
					"common": "Mauritania"
				},
				"jpn": {
					"official": "モーリタニア·イスラム共和国",
					"common": "モーリタニア"
				},
				"nld": {
					"official": "Islamitische Republiek Mauritanië",
					"common": "Mauritanië"
				},
				"por": {
					"official": "República Islâmica da Mauritânia",
					"common": "Mauritânia"
				},
				"rus": {
					"official": "Исламская Республика Мавритания",
					"common": "Мавритания"
				},
				"slk": {
					"official": "Mauritánska islamská republika",
					"common": "Mauritánia"
				},
				"spa": {
					"official": "República Islámica de Mauritania",
					"common": "Mauritania"
				},
				"fin": {
					"official": "Mauritanian islamilainen tasavalta",
					"common": "Mauritania"
				},
				"zho": {
					"official": "毛里塔尼亚伊斯兰共和国",
					"common": "毛里塔尼亚"
				}
			},
			"latlng": [
				20,
				-12
			],
			"demonym": "Mauritanian",
			"landlocked": false,
			"borders": [
				"DZA",
				"MLI",
				"SEN",
				"ESH"
			],
			"area": 1030700
		},
		{
			"name": {
				"common": "Montserrat",
				"official": "Montserrat",
				"native": {
					"eng": {
						"official": "Montserrat",
						"common": "Montserrat"
					}
				}
			},
			"tld": [
				".ms"
			],
			"cca2": "MS",
			"ccn3": "500",
			"cca3": "MSR",
			"cioc": "",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1664"
			],
			"capital": "Plymouth",
			"altSpellings": [
				"MS"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"fra": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"hrv": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"ita": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"jpn": {
					"official": "モントセラト",
					"common": "モントセラト"
				},
				"nld": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"por": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"rus": {
					"official": "Монтсеррат",
					"common": "Монтсеррат"
				},
				"slk": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"spa": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"fin": {
					"official": "Montserrat",
					"common": "Montserrat"
				},
				"zho": {
					"official": "蒙特塞拉特",
					"common": "蒙特塞拉特"
				}
			},
			"latlng": [
				16.75,
				-62.2
			],
			"demonym": "Montserratian",
			"landlocked": false,
			"borders": [],
			"area": 102
		},
		{
			"name": {
				"common": "Martinique",
				"official": "Martinique",
				"native": {
					"fra": {
						"official": "Martinique",
						"common": "Martinique"
					}
				}
			},
			"tld": [
				".mq"
			],
			"cca2": "MQ",
			"ccn3": "474",
			"cca3": "MTQ",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"596"
			],
			"capital": "Fort-de-France",
			"altSpellings": [
				"MQ"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Martinique",
					"common": "Martinique"
				},
				"fra": {
					"official": "Martinique",
					"common": "Martinique"
				},
				"hrv": {
					"official": "Martinique",
					"common": "Martinique"
				},
				"ita": {
					"official": "Martinique",
					"common": "Martinica"
				},
				"jpn": {
					"official": "マルティニーク島",
					"common": "マルティニーク"
				},
				"nld": {
					"official": "Martinique",
					"common": "Martinique"
				},
				"por": {
					"official": "Martinique",
					"common": "Martinica"
				},
				"rus": {
					"official": "Мартиника",
					"common": "Мартиника"
				},
				"spa": {
					"official": "Martinica",
					"common": "Martinica"
				},
				"svk": {
					"official": "Martinik",
					"common": "Martinik"
				},
				"fin": {
					"official": "Martinique",
					"common": "Martinique"
				},
				"zho": {
					"official": "马提尼克",
					"common": "马提尼克"
				}
			},
			"latlng": [
				14.666667,
				-61
			],
			"demonym": "French",
			"landlocked": false,
			"borders": [],
			"area": 1128
		},
		{
			"name": {
				"common": "Mauritius",
				"official": "Republic of Mauritius",
				"native": {
					"eng": {
						"official": "Republic of Mauritius",
						"common": "Mauritius"
					},
					"fra": {
						"official": "République de Maurice",
						"common": "Maurice"
					},
					"mfe": {
						"official": "Republik Moris",
						"common": "Moris"
					}
				}
			},
			"tld": [
				".mu"
			],
			"cca2": "MU",
			"ccn3": "480",
			"cca3": "MUS",
			"cioc": "MRI",
			"currency": [
				"MUR"
			],
			"callingCode": [
				"230"
			],
			"capital": "Port Louis",
			"altSpellings": [
				"MU",
				"Republic of Mauritius",
				"République de Maurice"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"fra": "French",
				"mfe": "Mauritian Creole"
			},
			"translations": {
				"deu": {
					"official": "Republik Mauritius",
					"common": "Mauritius"
				},
				"fra": {
					"official": "République de Maurice",
					"common": "Île Maurice"
				},
				"hrv": {
					"official": "Republika Mauricijus",
					"common": "Mauricijus"
				},
				"ita": {
					"official": "Repubblica di Mauritius",
					"common": "Mauritius"
				},
				"jpn": {
					"official": "モーリシャス共和国",
					"common": "モーリシャス"
				},
				"nld": {
					"official": "Republiek Mauritius",
					"common": "Mauritius"
				},
				"por": {
					"official": "República das Maurícias",
					"common": "Maurício"
				},
				"rus": {
					"official": "Республика Маврикий",
					"common": "Маврикий"
				},
				"slk": {
					"official": "Maurícijská republika",
					"common": "Maurícius"
				},
				"spa": {
					"official": "República de Mauricio",
					"common": "Mauricio"
				},
				"fin": {
					"official": "Mauritiuksen tasavalta",
					"common": "Mauritius"
				},
				"zho": {
					"official": "毛里求斯共和国",
					"common": "毛里求斯"
				}
			},
			"latlng": [
				-20.28333333,
				57.55
			],
			"demonym": "Mauritian",
			"landlocked": false,
			"borders": [],
			"area": 2040
		},
		{
			"name": {
				"common": "Malawi",
				"official": "Republic of Malawi",
				"native": {
					"eng": {
						"official": "Republic of Malawi",
						"common": "Malawi"
					},
					"nya": {
						"official": "Chalo cha Malawi, Dziko la Malaŵi",
						"common": "Malaŵi"
					}
				}
			},
			"tld": [
				".mw"
			],
			"cca2": "MW",
			"ccn3": "454",
			"cca3": "MWI",
			"cioc": "MAW",
			"currency": [
				"MWK"
			],
			"callingCode": [
				"265"
			],
			"capital": "Lilongwe",
			"altSpellings": [
				"MW",
				"Republic of Malawi"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"nya": "Chewa"
			},
			"translations": {
				"deu": {
					"official": "Republik Malawi",
					"common": "Malawi"
				},
				"fra": {
					"official": "République du Malawi",
					"common": "Malawi"
				},
				"hrv": {
					"official": "Republika Malavi",
					"common": "Malavi"
				},
				"ita": {
					"official": "Repubblica del Malawi",
					"common": "Malawi"
				},
				"jpn": {
					"official": "マラウイ共和国",
					"common": "マラウイ"
				},
				"nld": {
					"official": "Republiek Malawi",
					"common": "Malawi"
				},
				"por": {
					"official": "República do Malawi",
					"common": "Malawi"
				},
				"rus": {
					"official": "Республика Малави",
					"common": "Малави"
				},
				"slk": {
					"official": "Malawijská republika",
					"common": "Malawi"
				},
				"spa": {
					"official": "República de Malawi",
					"common": "Malawi"
				},
				"fin": {
					"official": "Malawin tasavalta",
					"common": "Malawi"
				},
				"zho": {
					"official": "马拉维共和国",
					"common": "马拉维"
				}
			},
			"latlng": [
				-13.5,
				34
			],
			"demonym": "Malawian",
			"landlocked": true,
			"borders": [
				"MOZ",
				"TZA",
				"ZMB"
			],
			"area": 118484
		},
		{
			"name": {
				"common": "Malaysia",
				"official": "Malaysia",
				"native": {
					"eng": {
						"official": "Malaysia",
						"common": "Malaysia"
					},
					"msa": {
						"official": "مليسيا",
						"common": "مليسيا"
					}
				}
			},
			"tld": [
				".my"
			],
			"cca2": "MY",
			"ccn3": "458",
			"cca3": "MYS",
			"cioc": "MAS",
			"currency": [
				"MYR"
			],
			"callingCode": [
				"60"
			],
			"capital": "Kuala Lumpur",
			"altSpellings": [
				"MY"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"eng": "English",
				"msa": "Malay"
			},
			"translations": {
				"deu": {
					"official": "Malaysia",
					"common": "Malaysia"
				},
				"fra": {
					"official": "Fédération de Malaisie",
					"common": "Malaisie"
				},
				"hrv": {
					"official": "Malezija",
					"common": "Malezija"
				},
				"ita": {
					"official": "Malaysia",
					"common": "Malesia"
				},
				"jpn": {
					"official": "マレーシア",
					"common": "マレーシア"
				},
				"nld": {
					"official": "Maleisië",
					"common": "Maleisië"
				},
				"por": {
					"official": "Malásia",
					"common": "Malásia"
				},
				"rus": {
					"official": "Малайзия",
					"common": "Малайзия"
				},
				"slk": {
					"official": "Malajzia",
					"common": "Malajzia"
				},
				"spa": {
					"official": "Malasia",
					"common": "Malasia"
				},
				"fin": {
					"official": "Malesia",
					"common": "Malesia"
				},
				"zho": {
					"official": "马来西亚",
					"common": "马来西亚"
				}
			},
			"latlng": [
				2.5,
				112.5
			],
			"demonym": "Malaysian",
			"landlocked": false,
			"borders": [
				"BRN",
				"IDN",
				"THA"
			],
			"area": 330803
		},
		{
			"name": {
				"common": "Mayotte",
				"official": "Department of Mayotte",
				"native": {
					"fra": {
						"official": "Département de Mayotte",
						"common": "Mayotte"
					}
				}
			},
			"tld": [
				".yt"
			],
			"cca2": "YT",
			"ccn3": "175",
			"cca3": "MYT",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"262"
			],
			"capital": "Mamoudzou",
			"altSpellings": [
				"YT",
				"Department of Mayotte",
				"Département de Mayotte"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Übersee-Département Mayotte",
					"common": "Mayotte"
				},
				"fra": {
					"official": "Département de Mayotte",
					"common": "Mayotte"
				},
				"hrv": {
					"official": "Odjel Mayotte",
					"common": "Mayotte"
				},
				"ita": {
					"official": "Dipartimento di Mayotte",
					"common": "Mayotte"
				},
				"jpn": {
					"official": "マヨット科",
					"common": "マヨット"
				},
				"nld": {
					"official": "Afdeling Mayotte",
					"common": "Mayotte"
				},
				"por": {
					"official": "Departamento de Mayotte",
					"common": "Mayotte"
				},
				"rus": {
					"official": "Департамент Майотта",
					"common": "Майотта"
				},
				"slk": {
					"official": "Department Mayotte",
					"common": "Mayotte"
				},
				"spa": {
					"official": "Departamento de Mayotte",
					"common": "Mayotte"
				},
				"fin": {
					"official": "Mayotte",
					"common": "Mayotte"
				},
				"zho": {
					"official": "马约特",
					"common": "马约特"
				}
			},
			"latlng": [
				-12.83333333,
				45.16666666
			],
			"demonym": "Mahoran",
			"landlocked": false,
			"borders": [],
			"area": 374
		},
		{
			"name": {
				"common": "Namibia",
				"official": "Republic of Namibia",
				"native": {
					"afr": {
						"official": "Republiek van Namibië",
						"common": "Namibië"
					},
					"deu": {
						"official": "Republik Namibia",
						"common": "Namibia"
					},
					"eng": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"her": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"hgm": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"kwn": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"loz": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"ndo": {
						"official": "Republic of Namibia",
						"common": "Namibia"
					},
					"tsn": {
						"official": "Lefatshe la Namibia",
						"common": "Namibia"
					}
				}
			},
			"tld": [
				".na"
			],
			"cca2": "NA",
			"ccn3": "516",
			"cca3": "NAM",
			"cioc": "NAM",
			"currency": [
				"NAD",
				"ZAR"
			],
			"callingCode": [
				"264"
			],
			"capital": "Windhoek",
			"altSpellings": [
				"NA",
				"Namibië",
				"Republic of Namibia"
			],
			"region": "Africa",
			"subregion": "Southern Africa",
			"languages": {
				"afr": "Afrikaans",
				"deu": "German",
				"eng": "English",
				"her": "Herero",
				"hgm": "Khoekhoe",
				"kwn": "Kwangali",
				"loz": "Lozi",
				"ndo": "Ndonga",
				"tsn": "Tswana"
			},
			"translations": {
				"deu": {
					"official": "Republik Namibia",
					"common": "Namibia"
				},
				"fra": {
					"official": "République de Namibie",
					"common": "Namibie"
				},
				"hrv": {
					"official": "Republika Namibija",
					"common": "Namibija"
				},
				"ita": {
					"official": "Repubblica di Namibia",
					"common": "Namibia"
				},
				"jpn": {
					"official": "ナミビア共和国",
					"common": "ナミビア"
				},
				"nld": {
					"official": "Republiek Namibië",
					"common": "Namibië"
				},
				"por": {
					"official": "República da Namíbia",
					"common": "Namíbia"
				},
				"rus": {
					"official": "Республика Намибия",
					"common": "Намибия"
				},
				"slk": {
					"official": "Namíbijská republika",
					"common": "Namíbia"
				},
				"spa": {
					"official": "República de Namibia",
					"common": "Namibia"
				},
				"fin": {
					"official": "Namibian tasavalta",
					"common": "Namibia"
				},
				"zho": {
					"official": "纳米比亚共和国",
					"common": "纳米比亚"
				}
			},
			"latlng": [
				-22,
				17
			],
			"demonym": "Namibian",
			"landlocked": false,
			"borders": [
				"AGO",
				"BWA",
				"ZAF",
				"ZMB"
			],
			"area": 825615
		},
		{
			"name": {
				"common": "New Caledonia",
				"official": "New Caledonia",
				"native": {
					"fra": {
						"official": "Nouvelle-Calédonie",
						"common": "Nouvelle-Calédonie"
					}
				}
			},
			"tld": [
				".nc"
			],
			"cca2": "NC",
			"ccn3": "540",
			"cca3": "NCL",
			"cioc": "",
			"currency": [
				"XPF"
			],
			"callingCode": [
				"687"
			],
			"capital": "Nouméa",
			"altSpellings": [
				"NC"
			],
			"region": "Oceania",
			"subregion": "Melanesia",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Neukaledonien",
					"common": "Neukaledonien"
				},
				"fra": {
					"official": "Nouvelle-Calédonie",
					"common": "Nouvelle-Calédonie"
				},
				"hrv": {
					"official": "Nova Kaledonija",
					"common": "Nova Kaledonija"
				},
				"ita": {
					"official": "Nuova Caledonia",
					"common": "Nuova Caledonia"
				},
				"jpn": {
					"official": "ニューカレドニア",
					"common": "ニューカレドニア"
				},
				"nld": {
					"official": "nieuw -Caledonië",
					"common": "Nieuw-Caledonië"
				},
				"por": {
					"official": "New Caledonia",
					"common": "Nova Caledónia"
				},
				"rus": {
					"official": "Новая Каледония",
					"common": "Новая Каледония"
				},
				"slk": {
					"official": "Nová Kaledónia",
					"common": "Nová Kaledónia"
				},
				"spa": {
					"official": "nueva Caledonia",
					"common": "Nueva Caledonia"
				},
				"fin": {
					"official": "Uusi-Kaledonia",
					"common": "Uusi-Kaledonia"
				},
				"zho": {
					"official": "新喀里多尼亚",
					"common": "新喀里多尼亚"
				}
			},
			"latlng": [
				-21.5,
				165.5
			],
			"demonym": "New Caledonian",
			"landlocked": false,
			"borders": [],
			"area": 18575
		},
		{
			"name": {
				"common": "Niger",
				"official": "Republic of Niger",
				"native": {
					"fra": {
						"official": "République du Niger",
						"common": "Niger"
					}
				}
			},
			"tld": [
				".ne"
			],
			"cca2": "NE",
			"ccn3": "562",
			"cca3": "NER",
			"cioc": "NIG",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"227"
			],
			"capital": "Niamey",
			"altSpellings": [
				"NE",
				"Nijar"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Niger",
					"common": "Niger"
				},
				"fra": {
					"official": "République du Niger",
					"common": "Niger"
				},
				"hrv": {
					"official": "Republika Niger",
					"common": "Niger"
				},
				"ita": {
					"official": "Repubblica del Niger",
					"common": "Niger"
				},
				"jpn": {
					"official": "ニジェール共和国",
					"common": "ニジェール"
				},
				"nld": {
					"official": "Republiek Niger",
					"common": "Niger"
				},
				"por": {
					"official": "República do Níger",
					"common": "Níger"
				},
				"rus": {
					"official": "Республика Нигер",
					"common": "Нигер"
				},
				"slk": {
					"official": "Nigérská republika",
					"common": "Niger"
				},
				"spa": {
					"official": "República de Níger",
					"common": "Níger"
				},
				"fin": {
					"official": "Nigerin tasavalta",
					"common": "Niger"
				},
				"zho": {
					"official": "尼日尔共和国",
					"common": "尼日尔"
				}
			},
			"latlng": [
				16,
				8
			],
			"demonym": "Nigerien",
			"landlocked": true,
			"borders": [
				"DZA",
				"BEN",
				"BFA",
				"TCD",
				"LBY",
				"MLI",
				"NGA"
			],
			"area": 1267000
		},
		{
			"name": {
				"common": "Norfolk Island",
				"official": "Territory of Norfolk Island",
				"native": {
					"eng": {
						"official": "Territory of Norfolk Island",
						"common": "Norfolk Island"
					},
					"pih": {
						"official": "Teratri of Norf'k Ailen",
						"common": "Norf'k Ailen"
					}
				}
			},
			"tld": [
				".nf"
			],
			"cca2": "NF",
			"ccn3": "574",
			"cca3": "NFK",
			"cioc": "",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"672"
			],
			"capital": "Kingston",
			"altSpellings": [
				"NF",
				"Territory of Norfolk Island",
				"Teratri of Norf'k Ailen"
			],
			"region": "Oceania",
			"subregion": "Australia and New Zealand",
			"languages": {
				"eng": "English",
				"pih": "Norfuk"
			},
			"translations": {
				"deu": {
					"official": "Gebiet der Norfolk-Insel",
					"common": "Norfolkinsel"
				},
				"fra": {
					"official": "Territoire de l'île Norfolk",
					"common": "Île Norfolk"
				},
				"hrv": {
					"official": "Teritorij Norfolk Island",
					"common": "Otok Norfolk"
				},
				"ita": {
					"official": "Territorio di Norfolk Island",
					"common": "Isola Norfolk"
				},
				"jpn": {
					"official": "ノーフォーク島の領土",
					"common": "ノーフォーク島"
				},
				"nld": {
					"official": "Grondgebied van Norfolk Island",
					"common": "Norfolkeiland"
				},
				"por": {
					"official": "Território da Ilha Norfolk",
					"common": "Ilha Norfolk"
				},
				"rus": {
					"official": "Территория острова Норфолк",
					"common": "Норфолк"
				},
				"slk": {
					"official": "Teritórium ostrova Norfolk",
					"common": "Norfolk"
				},
				"spa": {
					"official": "Territorio de la Isla Norfolk",
					"common": "Isla de Norfolk"
				},
				"fin": {
					"official": "Norfolkinsaaren territorio",
					"common": "Norfolkinsaari"
				},
				"zho": {
					"official": "诺福克岛",
					"common": "诺福克岛"
				}
			},
			"latlng": [
				-29.03333333,
				167.95
			],
			"demonym": "Norfolk Islander",
			"landlocked": false,
			"borders": [],
			"area": 36
		},
		{
			"name": {
				"common": "Nigeria",
				"official": "Federal Republic of Nigeria",
				"native": {
					"eng": {
						"official": "Federal Republic of Nigeria",
						"common": "Nigeria"
					}
				}
			},
			"tld": [
				".ng"
			],
			"cca2": "NG",
			"ccn3": "566",
			"cca3": "NGA",
			"cioc": "NGR",
			"currency": [
				"NGN"
			],
			"callingCode": [
				"234"
			],
			"capital": "Abuja",
			"altSpellings": [
				"NG",
				"Nijeriya",
				"Naíjíríà",
				"Federal Republic of Nigeria"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Bundesrepublik Nigeria",
					"common": "Nigeria"
				},
				"fra": {
					"official": "République fédérale du Nigeria",
					"common": "Nigéria"
				},
				"hrv": {
					"official": "Savezna Republika Nigerija",
					"common": "Nigerija"
				},
				"ita": {
					"official": "Repubblica federale di Nigeria",
					"common": "Nigeria"
				},
				"jpn": {
					"official": "ナイジェリア連邦共和国",
					"common": "ナイジェリア"
				},
				"nld": {
					"official": "Federale Republiek Nigeria",
					"common": "Nigeria"
				},
				"por": {
					"official": "República Federal da Nigéria",
					"common": "Nigéria"
				},
				"rus": {
					"official": "Федеративная Республика Нигерия",
					"common": "Нигерия"
				},
				"slk": {
					"official": "Nigérijská federatívna republika",
					"common": "Nigéria"
				},
				"spa": {
					"official": "República Federal de Nigeria",
					"common": "Nigeria"
				},
				"fin": {
					"official": "Nigerian liittotasavalta",
					"common": "Nigeria"
				},
				"zho": {
					"official": "尼日利亚联邦共和国",
					"common": "尼日利亚"
				}
			},
			"latlng": [
				10,
				8
			],
			"demonym": "Nigerian",
			"landlocked": false,
			"borders": [
				"BEN",
				"CMR",
				"TCD",
				"NER"
			],
			"area": 923768
		},
		{
			"name": {
				"common": "Nicaragua",
				"official": "Republic of Nicaragua",
				"native": {
					"spa": {
						"official": "República de Nicaragua",
						"common": "Nicaragua"
					}
				}
			},
			"tld": [
				".ni"
			],
			"cca2": "NI",
			"ccn3": "558",
			"cca3": "NIC",
			"cioc": "NCA",
			"currency": [
				"NIO"
			],
			"callingCode": [
				"505"
			],
			"capital": "Managua",
			"altSpellings": [
				"NI",
				"Republic of Nicaragua",
				"República de Nicaragua"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Nicaragua",
					"common": "Nicaragua"
				},
				"fra": {
					"official": "République du Nicaragua",
					"common": "Nicaragua"
				},
				"hrv": {
					"official": "Republika Nikaragva",
					"common": "Nikaragva"
				},
				"ita": {
					"official": "Repubblica del Nicaragua",
					"common": "Nicaragua"
				},
				"jpn": {
					"official": "ニカラグア共和国",
					"common": "ニカラグア"
				},
				"nld": {
					"official": "Republiek Nicaragua",
					"common": "Nicaragua"
				},
				"por": {
					"official": "República da Nicarágua",
					"common": "Nicarágua"
				},
				"rus": {
					"official": "Республика Никарагуа",
					"common": "Никарагуа"
				},
				"slk": {
					"official": "Nikaragujská republika",
					"common": "Nikaragua"
				},
				"spa": {
					"official": "República de Nicaragua",
					"common": "Nicaragua"
				},
				"fin": {
					"official": "Nicaraguan tasavalta",
					"common": "Nicaragua"
				},
				"zho": {
					"official": "尼加拉瓜共和国",
					"common": "尼加拉瓜"
				}
			},
			"latlng": [
				13,
				-85
			],
			"demonym": "Nicaraguan",
			"landlocked": false,
			"borders": [
				"CRI",
				"HND"
			],
			"area": 130373
		},
		{
			"name": {
				"common": "Niue",
				"official": "Niue",
				"native": {
					"eng": {
						"official": "Niue",
						"common": "Niue"
					},
					"niu": {
						"official": "Niuē",
						"common": "Niuē"
					}
				}
			},
			"tld": [
				".nu"
			],
			"cca2": "NU",
			"ccn3": "570",
			"cca3": "NIU",
			"cioc": "",
			"currency": [
				"NZD"
			],
			"callingCode": [
				"683"
			],
			"capital": "Alofi",
			"altSpellings": [
				"NU"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"niu": "Niuean"
			},
			"translations": {
				"deu": {
					"official": "Niue",
					"common": "Niue"
				},
				"fra": {
					"official": "Niue",
					"common": "Niue"
				},
				"hrv": {
					"official": "Niue",
					"common": "Niue"
				},
				"ita": {
					"official": "Niue",
					"common": "Niue"
				},
				"jpn": {
					"official": "ニウエ",
					"common": "ニウエ"
				},
				"nld": {
					"official": "Niue",
					"common": "Niue"
				},
				"por": {
					"official": "Niue",
					"common": "Niue"
				},
				"rus": {
					"official": "Ниуэ",
					"common": "Ниуэ"
				},
				"slk": {
					"official": "Niue",
					"common": "Niue"
				},
				"spa": {
					"official": "Niue",
					"common": "Niue"
				},
				"fin": {
					"official": "Niue",
					"common": "Niue"
				},
				"zho": {
					"official": "纽埃",
					"common": "纽埃"
				}
			},
			"latlng": [
				-19.03333333,
				-169.86666666
			],
			"demonym": "Niuean",
			"landlocked": false,
			"borders": [],
			"area": 260
		},
		{
			"name": {
				"common": "Netherlands",
				"official": "Netherlands",
				"native": {
					"nld": {
						"official": "Nederland",
						"common": "Nederland"
					}
				}
			},
			"tld": [
				".nl"
			],
			"cca2": "NL",
			"ccn3": "528",
			"cca3": "NLD",
			"cioc": "NED",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"31"
			],
			"capital": "Amsterdam",
			"altSpellings": [
				"NL",
				"Holland",
				"Nederland"
			],
			"region": "Europe",
			"subregion": "Western Europe",
			"languages": {
				"nld": "Dutch"
			},
			"translations": {
				"deu": {
					"official": "Niederlande",
					"common": "Niederlande"
				},
				"fra": {
					"official": "Pays-Bas",
					"common": "Pays-Bas"
				},
				"hrv": {
					"official": "Holandija",
					"common": "Nizozemska"
				},
				"ita": {
					"official": "Paesi Bassi",
					"common": "Paesi Bassi"
				},
				"jpn": {
					"official": "オランダ",
					"common": "オランダ"
				},
				"nld": {
					"official": "Nederland",
					"common": "Nederland"
				},
				"por": {
					"official": "Holanda",
					"common": "Holanda"
				},
				"rus": {
					"official": "Нидерланды",
					"common": "Нидерланды"
				},
				"slk": {
					"official": "Holandské kráľovstvo",
					"common": "Holansko"
				},
				"spa": {
					"official": "Países Bajos",
					"common": "Países Bajos"
				},
				"fin": {
					"official": "Alankomaat",
					"common": "Alankomaat"
				},
				"zho": {
					"official": "荷兰",
					"common": "荷兰"
				}
			},
			"latlng": [
				52.5,
				5.75
			],
			"demonym": "Dutch",
			"landlocked": false,
			"borders": [
				"BEL",
				"DEU"
			],
			"area": 41850
		},
		{
			"name": {
				"common": "Norway",
				"official": "Kingdom of Norway",
				"native": {
					"nno": {
						"official": "Kongeriket Noreg",
						"common": "Noreg"
					},
					"nob": {
						"official": "Kongeriket Norge",
						"common": "Norge"
					},
					"smi": {
						"official": "Norgga gonagasriika",
						"common": "Norgga"
					}
				}
			},
			"tld": [
				".no"
			],
			"cca2": "NO",
			"ccn3": "578",
			"cca3": "NOR",
			"cioc": "NOR",
			"currency": [
				"NOK"
			],
			"callingCode": [
				"47"
			],
			"capital": "Oslo",
			"altSpellings": [
				"NO",
				"Norge",
				"Noreg",
				"Kingdom of Norway",
				"Kongeriket Norge",
				"Kongeriket Noreg"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"nno": "Norwegian Nynorsk",
				"nob": "Norwegian Bokmål",
				"smi": "Sami"
			},
			"translations": {
				"deu": {
					"official": "Königreich Norwegen",
					"common": "Norwegen"
				},
				"fra": {
					"official": "Royaume de Norvège",
					"common": "Norvège"
				},
				"hrv": {
					"official": "Kraljevina Norveška",
					"common": "Norveška"
				},
				"ita": {
					"official": "Regno di Norvegia",
					"common": "Norvegia"
				},
				"jpn": {
					"official": "ノルウェー王国",
					"common": "ノルウェー"
				},
				"nld": {
					"official": "Koninkrijk Noorwegen",
					"common": "Noorwegen"
				},
				"por": {
					"official": "Reino da Noruega",
					"common": "Noruega"
				},
				"rus": {
					"official": "Королевство Норвегия",
					"common": "Норвегия"
				},
				"slk": {
					"official": "Nórske kráľovstvo",
					"common": "Nórsko"
				},
				"spa": {
					"official": "Reino de Noruega",
					"common": "Noruega"
				},
				"fin": {
					"official": "Norjan kuningaskunta",
					"common": "Norja"
				},
				"zho": {
					"official": "挪威王国",
					"common": "挪威"
				}
			},
			"latlng": [
				62,
				10
			],
			"demonym": "Norwegian",
			"landlocked": false,
			"borders": [
				"FIN",
				"SWE",
				"RUS"
			],
			"area": 323802
		},
		{
			"name": {
				"common": "Nepal",
				"official": "Federal Democratic Republic of Nepal",
				"native": {
					"nep": {
						"official": "नेपाल संघीय लोकतान्त्रिक गणतन्त्र",
						"common": "नेपाल"
					}
				}
			},
			"tld": [
				".np"
			],
			"cca2": "NP",
			"ccn3": "524",
			"cca3": "NPL",
			"cioc": "NEP",
			"currency": [
				"NPR"
			],
			"callingCode": [
				"977"
			],
			"capital": "Kathmandu",
			"altSpellings": [
				"NP",
				"Federal Democratic Republic of Nepal",
				"Loktāntrik Ganatantra Nepāl"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"nep": "Nepali"
			},
			"translations": {
				"deu": {
					"official": "Demokratischen Bundesrepublik Nepal",
					"common": "Népal"
				},
				"fra": {
					"official": "République du Népal",
					"common": "Népal"
				},
				"hrv": {
					"official": "Savezna Demokratska Republika Nepal",
					"common": "Nepal"
				},
				"ita": {
					"official": "Repubblica federale democratica del Nepal",
					"common": "Nepal"
				},
				"jpn": {
					"official": "ネパール連邦民主共和国",
					"common": "ネパール"
				},
				"nld": {
					"official": "Federale Democratische Republiek Nepal",
					"common": "Nepal"
				},
				"por": {
					"official": "República Democrática Federal do Nepal",
					"common": "Nepal"
				},
				"rus": {
					"official": "Федеративная Демократическая Республика Непал",
					"common": "Непал"
				},
				"slk": {
					"official": "Nepálska federatívna demokratická republika",
					"common": "Nepál"
				},
				"spa": {
					"official": "República Democrática Federal de Nepal",
					"common": "Nepal"
				},
				"fin": {
					"official": "Nepalin demokraattinen liittotasavalta",
					"common": "Nepal"
				},
				"zho": {
					"official": "尼泊尔联邦民主共和国",
					"common": "尼泊尔"
				}
			},
			"latlng": [
				28,
				84
			],
			"demonym": "Nepalese",
			"landlocked": true,
			"borders": [
				"CHN",
				"IND"
			],
			"area": 147181
		},
		{
			"name": {
				"common": "Nauru",
				"official": "Republic of Nauru",
				"native": {
					"eng": {
						"official": "Republic of Nauru",
						"common": "Nauru"
					},
					"nau": {
						"official": "Republic of Nauru",
						"common": "Nauru"
					}
				}
			},
			"tld": [
				".nr"
			],
			"cca2": "NR",
			"ccn3": "520",
			"cca3": "NRU",
			"cioc": "NRU",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"674"
			],
			"capital": "Yaren",
			"altSpellings": [
				"NR",
				"Naoero",
				"Pleasant Island",
				"Republic of Nauru",
				"Ripublik Naoero"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"eng": "English",
				"nau": "Nauru"
			},
			"translations": {
				"deu": {
					"official": "Republik Nauru",
					"common": "Nauru"
				},
				"fra": {
					"official": "République de Nauru",
					"common": "Nauru"
				},
				"hrv": {
					"official": "Republika Nauru",
					"common": "Nauru"
				},
				"ita": {
					"official": "Repubblica di Nauru",
					"common": "Nauru"
				},
				"jpn": {
					"official": "ナウル共和国",
					"common": "ナウル"
				},
				"nld": {
					"official": "Republiek Nauru",
					"common": "Nauru"
				},
				"por": {
					"official": "República de Nauru",
					"common": "Nauru"
				},
				"rus": {
					"official": "Республика Науру",
					"common": "Науру"
				},
				"slk": {
					"official": "Naurská republika",
					"common": "Nauru"
				},
				"spa": {
					"official": "República de Nauru",
					"common": "Nauru"
				},
				"fin": {
					"official": "Naurun tasavalta",
					"common": "Nauru"
				},
				"zho": {
					"official": "瑙鲁共和国",
					"common": "瑙鲁"
				}
			},
			"latlng": [
				-0.53333333,
				166.91666666
			],
			"demonym": "Nauruan",
			"landlocked": false,
			"borders": [],
			"area": 21
		},
		{
			"name": {
				"common": "New Zealand",
				"official": "New Zealand",
				"native": {
					"eng": {
						"official": "New Zealand",
						"common": "New Zealand"
					},
					"mri": {
						"official": "Aotearoa",
						"common": "Aotearoa"
					},
					"nzs": {
						"official": "New Zealand",
						"common": "New Zealand"
					}
				}
			},
			"tld": [
				".nz"
			],
			"cca2": "NZ",
			"ccn3": "554",
			"cca3": "NZL",
			"cioc": "NZL",
			"currency": [
				"NZD"
			],
			"callingCode": [
				"64"
			],
			"capital": "Wellington",
			"altSpellings": [
				"NZ",
				"Aotearoa"
			],
			"region": "Oceania",
			"subregion": "Australia and New Zealand",
			"languages": {
				"eng": "English",
				"mri": "Māori",
				"nzs": "New Zealand Sign Language"
			},
			"translations": {
				"deu": {
					"official": "Neuseeland",
					"common": "Neuseeland"
				},
				"fra": {
					"official": "Nouvelle-Zélande",
					"common": "Nouvelle-Zélande"
				},
				"hrv": {
					"official": "Novi Zeland",
					"common": "Novi Zeland"
				},
				"ita": {
					"official": "Nuova Zelanda",
					"common": "Nuova Zelanda"
				},
				"jpn": {
					"official": "ニュージーランド",
					"common": "ニュージーランド"
				},
				"nld": {
					"official": "Nieuw Zeeland",
					"common": "Nieuw-Zeeland"
				},
				"por": {
					"official": "nova Zelândia",
					"common": "Nova Zelândia"
				},
				"rus": {
					"official": "Новая Зеландия",
					"common": "Новая Зеландия"
				},
				"slk": {
					"official": "Nový Zéland",
					"common": "Nový Zéland"
				},
				"spa": {
					"official": "nueva Zelanda",
					"common": "Nueva Zelanda"
				},
				"fin": {
					"official": "Uusi-Seelanti",
					"common": "Uusi-Seelanti"
				},
				"zho": {
					"official": "新西兰",
					"common": "新西兰"
				}
			},
			"latlng": [
				-41,
				174
			],
			"demonym": "New Zealander",
			"landlocked": false,
			"borders": [],
			"area": 270467
		},
		{
			"name": {
				"common": "Oman",
				"official": "Sultanate of Oman",
				"native": {
					"ara": {
						"official": "سلطنة عمان",
						"common": "عمان"
					}
				}
			},
			"tld": [
				".om"
			],
			"cca2": "OM",
			"ccn3": "512",
			"cca3": "OMN",
			"cioc": "OMA",
			"currency": [
				"OMR"
			],
			"callingCode": [
				"968"
			],
			"capital": "Muscat",
			"altSpellings": [
				"OM",
				"Sultanate of Oman",
				"Salṭanat ʻUmān"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Sultanat Oman",
					"common": "Oman"
				},
				"fra": {
					"official": "Sultanat d'Oman",
					"common": "Oman"
				},
				"hrv": {
					"official": "Sultanat Oman",
					"common": "Oman"
				},
				"ita": {
					"official": "Sultanato dell'Oman",
					"common": "oman"
				},
				"jpn": {
					"official": "オマーン·スルタン国",
					"common": "オマーン"
				},
				"nld": {
					"official": "Sultanaat van Oman",
					"common": "Oman"
				},
				"por": {
					"official": "Sultanato de Omã",
					"common": "Omã"
				},
				"rus": {
					"official": "Султанат Оман",
					"common": "Оман"
				},
				"slk": {
					"official": "Ománsky sultanát",
					"common": "Omán"
				},
				"spa": {
					"official": "Sultanato de Omán",
					"common": "Omán"
				},
				"fin": {
					"official": "Omanin sulttaanikunta",
					"common": "Oman"
				},
				"zho": {
					"official": "阿曼苏丹国",
					"common": "阿曼"
				}
			},
			"latlng": [
				21,
				57
			],
			"demonym": "Omani",
			"landlocked": false,
			"borders": [
				"SAU",
				"ARE",
				"YEM"
			],
			"area": 309500
		},
		{
			"name": {
				"common": "Pakistan",
				"official": "Islamic Republic of Pakistan",
				"native": {
					"eng": {
						"official": "Islamic Republic of Pakistan",
						"common": "Pakistan"
					},
					"urd": {
						"official": "اسلامی جمہوریۂ پاكستان",
						"common": "پاكستان"
					}
				}
			},
			"tld": [
				".pk"
			],
			"cca2": "PK",
			"ccn3": "586",
			"cca3": "PAK",
			"cioc": "PAK",
			"currency": [
				"PKR"
			],
			"callingCode": [
				"92"
			],
			"capital": "Islamabad",
			"altSpellings": [
				"PK",
				"Pākistān",
				"Islamic Republic of Pakistan",
				"Islāmī Jumhūriya'eh Pākistān"
			],
			"region": "Asia",
			"subregion": "Southern Asia",
			"languages": {
				"eng": "English",
				"urd": "Urdu"
			},
			"translations": {
				"deu": {
					"official": "Islamische Republik Pakistan",
					"common": "Pakistan"
				},
				"fra": {
					"official": "République islamique du Pakistan",
					"common": "Pakistan"
				},
				"hrv": {
					"official": "Islamska Republika Pakistan",
					"common": "Pakistan"
				},
				"ita": {
					"official": "Repubblica islamica del Pakistan",
					"common": "Pakistan"
				},
				"jpn": {
					"official": "パキスタン",
					"common": "パキスタン"
				},
				"nld": {
					"official": "Islamitische Republiek Pakistan",
					"common": "Pakistan"
				},
				"por": {
					"official": "República Islâmica do Paquistão",
					"common": "Paquistão"
				},
				"rus": {
					"official": "Исламская Республика Пакистан",
					"common": "Пакистан"
				},
				"slk": {
					"official": "Pakistanská islamská republika",
					"common": "Pakistan"
				},
				"spa": {
					"official": "República Islámica de Pakistán",
					"common": "Pakistán"
				},
				"fin": {
					"official": "Pakistanin islamilainen tasavalta",
					"common": "Pakistan"
				},
				"zho": {
					"official": "巴基斯坦伊斯兰共和国",
					"common": "巴基斯坦"
				}
			},
			"latlng": [
				30,
				70
			],
			"demonym": "Pakistani",
			"landlocked": false,
			"borders": [
				"AFG",
				"CHN",
				"IND",
				"IRN"
			],
			"area": 881912
		},
		{
			"name": {
				"common": "Panama",
				"official": "Republic of Panama",
				"native": {
					"spa": {
						"official": "República de Panamá",
						"common": "Panamá"
					}
				}
			},
			"tld": [
				".pa"
			],
			"cca2": "PA",
			"ccn3": "591",
			"cca3": "PAN",
			"cioc": "PAN",
			"currency": [
				"PAB",
				"USD"
			],
			"callingCode": [
				"507"
			],
			"capital": "Panama City",
			"altSpellings": [
				"PA",
				"Republic of Panama",
				"República de Panamá"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Panama",
					"common": "Panama"
				},
				"fra": {
					"official": "République du Panama",
					"common": "Panama"
				},
				"hrv": {
					"official": "Republika Panama",
					"common": "Panama"
				},
				"ita": {
					"official": "Repubblica di Panama",
					"common": "Panama"
				},
				"jpn": {
					"official": "パナマ共和国",
					"common": "パナマ"
				},
				"nld": {
					"official": "Republiek Panama",
					"common": "Panama"
				},
				"por": {
					"official": "República do Panamá",
					"common": "Panamá"
				},
				"rus": {
					"official": "Республика Панама",
					"common": "Панама"
				},
				"slk": {
					"official": "Panamská republika",
					"common": "Panama"
				},
				"spa": {
					"official": "República de Panamá",
					"common": "Panamá"
				},
				"fin": {
					"official": "Panaman tasavalta",
					"common": "Panama"
				},
				"zho": {
					"official": "巴拿马共和国",
					"common": "巴拿马"
				}
			},
			"latlng": [
				9,
				-80
			],
			"demonym": "Panamanian",
			"landlocked": false,
			"borders": [
				"COL",
				"CRI"
			],
			"area": 75417
		},
		{
			"name": {
				"common": "Pitcairn Islands",
				"official": "Pitcairn Group of Islands",
				"native": {
					"eng": {
						"official": "Pitcairn Group of Islands",
						"common": "Pitcairn Islands"
					}
				}
			},
			"tld": [
				".pn"
			],
			"cca2": "PN",
			"ccn3": "612",
			"cca3": "PCN",
			"cioc": "",
			"currency": [
				"NZD"
			],
			"callingCode": [
				"64"
			],
			"capital": "Adamstown",
			"altSpellings": [
				"PN",
				"Pitcairn",
				"Pitcairn Henderson Ducie and Oeno Islands"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Pitcairn Inselgruppe",
					"common": "Pitcairn"
				},
				"fra": {
					"official": "Groupe d'îles Pitcairn",
					"common": "Îles Pitcairn"
				},
				"hrv": {
					"official": "Pitcairn skupine otoka",
					"common": "Pitcairnovo otočje"
				},
				"ita": {
					"official": "Pitcairn gruppo di isole",
					"common": "Isole Pitcairn"
				},
				"jpn": {
					"official": "島のピトケアングループ",
					"common": "ピトケアン"
				},
				"nld": {
					"official": "Pitcairn groep eilanden",
					"common": "Pitcairneilanden"
				},
				"por": {
					"official": "Pitcairn grupo de ilhas",
					"common": "Ilhas Pitcairn"
				},
				"rus": {
					"official": "Питкэрн группа островов",
					"common": "Острова Питкэрн"
				},
				"slk": {
					"official": "Pitcairnove ostrovy",
					"common": "Pitcairnove ostrovy"
				},
				"spa": {
					"official": "Grupo de Islas Pitcairn",
					"common": "Islas Pitcairn"
				},
				"fin": {
					"official": "Pitcairn",
					"common": "Pitcairn"
				},
				"zho": {
					"official": "皮特凯恩群岛",
					"common": "皮特凯恩群岛"
				}
			},
			"latlng": [
				-25.06666666,
				-130.1
			],
			"demonym": "Pitcairn Islander",
			"landlocked": false,
			"borders": [],
			"area": 47
		},
		{
			"name": {
				"common": "Peru",
				"official": "Republic of Peru",
				"native": {
					"aym": {
						"official": "Piruw Suyu",
						"common": "Piruw"
					},
					"que": {
						"official": "Piruw Ripuwlika",
						"common": "Piruw"
					},
					"spa": {
						"official": "República del Perú",
						"common": "Perú"
					}
				}
			},
			"tld": [
				".pe"
			],
			"cca2": "PE",
			"ccn3": "604",
			"cca3": "PER",
			"cioc": "PER",
			"currency": [
				"PEN"
			],
			"callingCode": [
				"51"
			],
			"capital": "Lima",
			"altSpellings": [
				"PE",
				"Republic of Peru",
				"República del Perú"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"aym": "Aymara",
				"que": "Quechua",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Peru",
					"common": "Peru"
				},
				"fra": {
					"official": "République du Pérou",
					"common": "Pérou"
				},
				"hrv": {
					"official": "Republika Peru",
					"common": "Peru"
				},
				"ita": {
					"official": "Repubblica del Perù",
					"common": "Perù"
				},
				"jpn": {
					"official": "ペルー共和国",
					"common": "ペルー"
				},
				"nld": {
					"official": "Republiek Peru",
					"common": "Peru"
				},
				"por": {
					"official": "República do Peru",
					"common": "Perú"
				},
				"rus": {
					"official": "Республика Перу",
					"common": "Перу"
				},
				"slk": {
					"official": "Peruánska republika",
					"common": "Peru"
				},
				"spa": {
					"official": "República de Perú",
					"common": "Perú"
				},
				"fin": {
					"official": "Perun tasavalta",
					"common": "Peru"
				},
				"zho": {
					"official": "秘鲁共和国",
					"common": "秘鲁"
				}
			},
			"latlng": [
				-10,
				-76
			],
			"demonym": "Peruvian",
			"landlocked": false,
			"borders": [
				"BOL",
				"BRA",
				"CHL",
				"COL",
				"ECU"
			],
			"area": 1285216
		},
		{
			"name": {
				"common": "Philippines",
				"official": "Republic of the Philippines",
				"native": {
					"eng": {
						"official": "Republic of the Philippines",
						"common": "Philippines"
					},
					"fil": {
						"official": "Republic of the Philippines",
						"common": "Pilipinas"
					}
				}
			},
			"tld": [
				".ph"
			],
			"cca2": "PH",
			"ccn3": "608",
			"cca3": "PHL",
			"cioc": "PHI",
			"currency": [
				"PHP"
			],
			"callingCode": [
				"63"
			],
			"capital": "Manila",
			"altSpellings": [
				"PH",
				"Republic of the Philippines",
				"Repúblika ng Pilipinas"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"eng": "English",
				"fil": "Filipino"
			},
			"translations": {
				"deu": {
					"official": "Republik der Philippinen",
					"common": "Philippinen"
				},
				"fra": {
					"official": "République des Philippines",
					"common": "Philippines"
				},
				"hrv": {
					"official": "Republika Filipini",
					"common": "Filipini"
				},
				"ita": {
					"official": "Repubblica delle Filippine",
					"common": "Filippine"
				},
				"jpn": {
					"official": "フィリピン共和国",
					"common": "フィリピン"
				},
				"nld": {
					"official": "Republiek der Filipijnen",
					"common": "Filipijnen"
				},
				"por": {
					"official": "República das Filipinas",
					"common": "Filipinas"
				},
				"rus": {
					"official": "Республика Филиппины",
					"common": "Филиппины"
				},
				"slk": {
					"official": "Filipínska republika",
					"common": "Filipíny"
				},
				"spa": {
					"official": "República de las Filipinas",
					"common": "Filipinas"
				},
				"fin": {
					"official": "Filippiinien tasavalta",
					"common": "Filippiinit"
				},
				"zho": {
					"official": "菲律宾共和国",
					"common": "菲律宾"
				}
			},
			"latlng": [
				13,
				122
			],
			"demonym": "Filipino",
			"landlocked": false,
			"borders": [],
			"area": 342353
		},
		{
			"name": {
				"common": "Palau",
				"official": "Republic of Palau",
				"native": {
					"eng": {
						"official": "Republic of Palau",
						"common": "Palau"
					},
					"pau": {
						"official": "Beluu er a Belau",
						"common": "Belau"
					}
				}
			},
			"tld": [
				".pw"
			],
			"cca2": "PW",
			"ccn3": "585",
			"cca3": "PLW",
			"cioc": "PLW",
			"currency": [
				"USD"
			],
			"callingCode": [
				"680"
			],
			"capital": "Ngerulmud",
			"altSpellings": [
				"PW",
				"Republic of Palau",
				"Beluu er a Belau"
			],
			"region": "Oceania",
			"subregion": "Micronesia",
			"languages": {
				"eng": "English",
				"pau": "Palauan"
			},
			"translations": {
				"deu": {
					"official": "Palau",
					"common": "Palau"
				},
				"fra": {
					"official": "République des Palaos (Palau)",
					"common": "Palaos (Palau)"
				},
				"hrv": {
					"official": "Republika Palau",
					"common": "Palau"
				},
				"ita": {
					"official": "Repubblica di Palau",
					"common": "Palau"
				},
				"jpn": {
					"official": "パラオ共和国",
					"common": "パラオ"
				},
				"nld": {
					"official": "Republiek van Palau",
					"common": "Palau"
				},
				"por": {
					"official": "República de Palau",
					"common": "Palau"
				},
				"rus": {
					"official": "Республика Палау",
					"common": "Палау"
				},
				"slk": {
					"official": "Palauská republika",
					"common": "Palau"
				},
				"spa": {
					"official": "República de Palau",
					"common": "Palau"
				},
				"fin": {
					"official": "Palaun tasavalta",
					"common": "Palau"
				},
				"zho": {
					"official": "帕劳共和国",
					"common": "帕劳"
				}
			},
			"latlng": [
				7.5,
				134.5
			],
			"demonym": "Palauan",
			"landlocked": false,
			"borders": [],
			"area": 459
		},
		{
			"name": {
				"common": "Papua New Guinea",
				"official": "Independent State of Papua New Guinea",
				"native": {
					"eng": {
						"official": "Independent State of Papua New Guinea",
						"common": "Papua New Guinea"
					},
					"hmo": {
						"official": "Independen Stet bilong Papua Niugini",
						"common": "Papua Niu Gini"
					},
					"tpi": {
						"official": "Independen Stet bilong Papua Niugini",
						"common": "Papua Niugini"
					}
				}
			},
			"tld": [
				".pg"
			],
			"cca2": "PG",
			"ccn3": "598",
			"cca3": "PNG",
			"cioc": "PNG",
			"currency": [
				"PGK"
			],
			"callingCode": [
				"675"
			],
			"capital": "Port Moresby",
			"altSpellings": [
				"PG",
				"Independent State of Papua New Guinea",
				"Independen Stet bilong Papua Niugini"
			],
			"region": "Oceania",
			"subregion": "Melanesia",
			"languages": {
				"eng": "English",
				"hmo": "Hiri Motu",
				"tpi": "Tok Pisin"
			},
			"translations": {
				"deu": {
					"official": "Unabhängige Staat Papua-Neuguinea",
					"common": "Papua-Neuguinea"
				},
				"fra": {
					"official": "État indépendant de Papouasie-Nouvelle-Guinée",
					"common": "Papouasie-Nouvelle-Guinée"
				},
				"hrv": {
					"official": "Nezavisna Država Papui Novoj Gvineji",
					"common": "Papua Nova Gvineja"
				},
				"ita": {
					"official": "Stato indipendente di Papua Nuova Guinea",
					"common": "Papua Nuova Guinea"
				},
				"jpn": {
					"official": "パプアニューギニア独立国",
					"common": "パプアニューギニア"
				},
				"nld": {
					"official": "Onafhankelijke Staat Papoea -Nieuw-Guinea",
					"common": "Papoea-Nieuw-Guinea"
				},
				"por": {
					"official": "Estado Independente da Papua Nova Guiné",
					"common": "Papua Nova Guiné"
				},
				"rus": {
					"official": "Независимое Государство Папуа-Новой Гвинеи",
					"common": "Папуа — Новая Гвинея"
				},
				"slk": {
					"official": "Nezávislý štát Papua-Nová Guinea",
					"common": "Papua-Nová Guinea"
				},
				"spa": {
					"official": "Estado Independiente de Papúa Nueva Guinea",
					"common": "Papúa Nueva Guinea"
				},
				"fin": {
					"official": "Papua-Uuden-Guinean Itsenäinen valtio",
					"common": "Papua-Uusi-Guinea"
				},
				"zho": {
					"official": "巴布亚新几内亚",
					"common": "巴布亚新几内亚"
				}
			},
			"latlng": [
				-6,
				147
			],
			"demonym": "Papua New Guinean",
			"landlocked": false,
			"borders": [
				"IDN"
			],
			"area": 462840
		},
		{
			"name": {
				"common": "Poland",
				"official": "Republic of Poland",
				"native": {
					"pol": {
						"official": "Rzeczpospolita Polska",
						"common": "Polska"
					}
				}
			},
			"tld": [
				".pl"
			],
			"cca2": "PL",
			"ccn3": "616",
			"cca3": "POL",
			"cioc": "POL",
			"currency": [
				"PLN"
			],
			"callingCode": [
				"48"
			],
			"capital": "Warsaw",
			"altSpellings": [
				"PL",
				"Republic of Poland",
				"Rzeczpospolita Polska"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"pol": "Polish"
			},
			"translations": {
				"deu": {
					"official": "Republik Polen",
					"common": "Polen"
				},
				"fra": {
					"official": "République de Pologne",
					"common": "Pologne"
				},
				"hrv": {
					"official": "Republika Poljska",
					"common": "Poljska"
				},
				"ita": {
					"official": "Repubblica di Polonia",
					"common": "Polonia"
				},
				"jpn": {
					"official": "ポーランド共和国",
					"common": "ポーランド"
				},
				"nld": {
					"official": "Republiek Polen",
					"common": "Polen"
				},
				"por": {
					"official": "República da Polónia",
					"common": "Polónia"
				},
				"rus": {
					"official": "Республика Польша",
					"common": "Польша"
				},
				"slk": {
					"official": "Poľská republika",
					"common": "Poľsko"
				},
				"spa": {
					"official": "República de Polonia",
					"common": "Polonia"
				},
				"fin": {
					"official": "Puolan tasavalta",
					"common": "Puola"
				},
				"zho": {
					"official": "波兰共和国",
					"common": "波兰"
				}
			},
			"latlng": [
				52,
				20
			],
			"demonym": "Polish",
			"landlocked": false,
			"borders": [
				"BLR",
				"CZE",
				"DEU",
				"LTU",
				"RUS",
				"SVK",
				"UKR"
			],
			"area": 312679
		},
		{
			"name": {
				"common": "Puerto Rico",
				"official": "Commonwealth of Puerto Rico",
				"native": {
					"eng": {
						"official": "Commonwealth of Puerto Rico",
						"common": "Puerto Rico"
					},
					"spa": {
						"official": "Estado Libre Asociado de Puerto Rico",
						"common": "Puerto Rico"
					}
				}
			},
			"tld": [
				".pr"
			],
			"cca2": "PR",
			"ccn3": "630",
			"cca3": "PRI",
			"cioc": "PUR",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1787",
				"1939"
			],
			"capital": "San Juan",
			"altSpellings": [
				"PR",
				"Commonwealth of Puerto Rico",
				"Estado Libre Asociado de Puerto Rico"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Commonwealth von Puerto Rico",
					"common": "Puerto Rico"
				},
				"fra": {
					"official": "Porto Rico",
					"common": "Porto Rico"
				},
				"hrv": {
					"official": "Zajednica Puerto Rico",
					"common": "Portoriko"
				},
				"ita": {
					"official": "Commonwealth di Porto Rico",
					"common": "Porto Rico"
				},
				"jpn": {
					"official": "プエルトリコのコモンウェルス",
					"common": "プエルトリコ"
				},
				"nld": {
					"official": "Gemenebest van Puerto Rico",
					"common": "Puerto Rico"
				},
				"por": {
					"official": "Commonwealth of Puerto Rico",
					"common": "Porto Rico"
				},
				"rus": {
					"official": "Содружество Пуэрто-Рико",
					"common": "Пуэрто-Рико"
				},
				"slk": {
					"official": "Portorické spoločenstvo",
					"common": "Portoriko"
				},
				"spa": {
					"official": "Asociado de Puerto Rico",
					"common": "Puerto Rico"
				},
				"fin": {
					"official": "Puerto Rico",
					"common": "Puerto Rico"
				},
				"zho": {
					"official": "波多黎各联邦",
					"common": "波多黎各"
				}
			},
			"latlng": [
				18.25,
				-66.5
			],
			"demonym": "Puerto Rican",
			"landlocked": false,
			"borders": [],
			"area": 8870
		},
		{
			"name": {
				"common": "North Korea",
				"official": "Democratic People's Republic of Korea",
				"native": {
					"kor": {
						"official": "조선 민주주의 인민 공화국",
						"common": "북한"
					}
				}
			},
			"tld": [
				".kp"
			],
			"cca2": "KP",
			"ccn3": "408",
			"cca3": "PRK",
			"cioc": "PRK",
			"currency": [
				"KPW"
			],
			"callingCode": [
				"850"
			],
			"capital": "Pyongyang",
			"altSpellings": [
				"KP",
				"Democratic People's Republic of Korea",
				"조선민주주의인민공화국",
				"Chosŏn Minjujuŭi Inmin Konghwaguk",
				"Korea, Democratic People's Republic of"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"kor": "Korean"
			},
			"translations": {
				"deu": {
					"official": "Demokratische Volksrepublik Korea",
					"common": "Nordkorea"
				},
				"fra": {
					"official": "République populaire démocratique de Corée",
					"common": "Corée du Nord"
				},
				"hrv": {
					"official": "Demokratska Narodna Republika Koreja",
					"common": "Sjeverna Koreja"
				},
				"ita": {
					"official": "Repubblica democratica popolare di Corea",
					"common": "Corea del Nord"
				},
				"jpn": {
					"official": "朝鮮民主主義人民共和国",
					"common": "朝鮮民主主義人民共和国"
				},
				"nld": {
					"official": "Democratische Volksrepubliek Korea",
					"common": "Noord-Korea"
				},
				"por": {
					"official": "República Popular Democrática da Coreia",
					"common": "Coreia do Norte"
				},
				"rus": {
					"official": "Корейская Народно-Демократическая Республика Корея",
					"common": "Северная Корея"
				},
				"slk": {
					"official": "Kórejská ľudovodemokratická republika",
					"common": "Kórejská ľudovodemokratická republika (KĽR, Severná Kórea)"
				},
				"spa": {
					"official": "República Popular Democrática de Corea",
					"common": "Corea del Norte"
				},
				"fin": {
					"official": "Korean demokraattinen kansantasavalta",
					"common": "Pohjois-Korea"
				},
				"zho": {
					"official": "朝鲜人民民主共和国",
					"common": "朝鲜"
				}
			},
			"latlng": [
				40,
				127
			],
			"demonym": "North Korean",
			"landlocked": false,
			"borders": [
				"CHN",
				"KOR",
				"RUS"
			],
			"area": 120538
		},
		{
			"name": {
				"common": "Portugal",
				"official": "Portuguese Republic",
				"native": {
					"por": {
						"official": "República português",
						"common": "Portugal"
					}
				}
			},
			"tld": [
				".pt"
			],
			"cca2": "PT",
			"ccn3": "620",
			"cca3": "PRT",
			"cioc": "POR",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"351"
			],
			"capital": "Lisbon",
			"altSpellings": [
				"PT",
				"Portuguesa",
				"Portuguese Republic",
				"República Portuguesa"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"deu": {
					"official": "Portugiesische Republik",
					"common": "Portugal"
				},
				"fra": {
					"official": "République portugaise",
					"common": "Portugal"
				},
				"hrv": {
					"official": "Portugalska Republika",
					"common": "Portugal"
				},
				"ita": {
					"official": "Repubblica portoghese",
					"common": "Portogallo"
				},
				"jpn": {
					"official": "ポルトガル共和国",
					"common": "ポルトガル"
				},
				"nld": {
					"official": "Portugese Republiek",
					"common": "Portugal"
				},
				"por": {
					"official": "República português",
					"common": "Portugal"
				},
				"rus": {
					"official": "Португальская Республика",
					"common": "Португалия"
				},
				"slk": {
					"official": "Portugalská republika",
					"common": "Portugalsko"
				},
				"spa": {
					"official": "República Portuguesa",
					"common": "Portugal"
				},
				"fin": {
					"official": "Portugalin tasavalta",
					"common": "Portugali"
				},
				"zho": {
					"official": "葡萄牙共和国",
					"common": "葡萄牙"
				}
			},
			"latlng": [
				39.5,
				-8
			],
			"demonym": "Portuguese",
			"landlocked": false,
			"borders": [
				"ESP"
			],
			"area": 92090
		},
		{
			"name": {
				"common": "Paraguay",
				"official": "Republic of Paraguay",
				"native": {
					"grn": {
						"official": "Tetã Paraguái",
						"common": "Paraguái"
					},
					"spa": {
						"official": "República de Paraguay",
						"common": "Paraguay"
					}
				}
			},
			"tld": [
				".py"
			],
			"cca2": "PY",
			"ccn3": "600",
			"cca3": "PRY",
			"cioc": "PAR",
			"currency": [
				"PYG"
			],
			"callingCode": [
				"595"
			],
			"capital": "Asunción",
			"altSpellings": [
				"PY",
				"Republic of Paraguay",
				"República del Paraguay",
				"Tetã Paraguái"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"grn": "Guaraní",
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Paraguay",
					"common": "Paraguay"
				},
				"fra": {
					"official": "République du Paraguay",
					"common": "Paraguay"
				},
				"hrv": {
					"official": "Republika Paragvaj",
					"common": "Paragvaj"
				},
				"ita": {
					"official": "Repubblica del Paraguay",
					"common": "Paraguay"
				},
				"jpn": {
					"official": "パラグアイ共和国",
					"common": "パラグアイ"
				},
				"nld": {
					"official": "Republiek Paraguay",
					"common": "Paraguay"
				},
				"por": {
					"official": "República do Paraguai",
					"common": "Paraguai"
				},
				"rus": {
					"official": "Республика Парагвай",
					"common": "Парагвай"
				},
				"slk": {
					"official": "Paraguajská republika",
					"common": "Paraguaj"
				},
				"spa": {
					"official": "República de Paraguay",
					"common": "Paraguay"
				},
				"fin": {
					"official": "Paraguayn tasavalta",
					"common": "Paraguay"
				},
				"zho": {
					"official": "巴拉圭共和国",
					"common": "巴拉圭"
				}
			},
			"latlng": [
				-23,
				-58
			],
			"demonym": "Paraguayan",
			"landlocked": true,
			"borders": [
				"ARG",
				"BOL",
				"BRA"
			],
			"area": 406752
		},
		{
			"name": {
				"common": "Palestine",
				"official": "State of Palestine",
				"native": {
					"ara": {
						"official": "دولة فلسطين",
						"common": "فلسطين"
					}
				}
			},
			"tld": [
				".ps",
				"فلسطين."
			],
			"cca2": "PS",
			"ccn3": "275",
			"cca3": "PSE",
			"cioc": "PLE",
			"currency": [
				"ILS"
			],
			"callingCode": [
				"970"
			],
			"capital": "Ramallah",
			"altSpellings": [
				"PS",
				"Palestine, State of",
				"State of Palestine",
				"Dawlat Filasṭin"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Staat Palästina",
					"common": "Palästina"
				},
				"fra": {
					"official": "État de Palestine",
					"common": "Palestine"
				},
				"hrv": {
					"official": "State of Palestine",
					"common": "Palestina"
				},
				"ita": {
					"official": "Stato di Palestina",
					"common": "Palestina"
				},
				"jpn": {
					"official": "パレスチナ自治政府",
					"common": "パレスチナ"
				},
				"nld": {
					"official": "Staat Palestina",
					"common": "Palestijnse gebieden"
				},
				"por": {
					"official": "Estado da Palestina",
					"common": "Palestina"
				},
				"rus": {
					"official": "Государство Палестина",
					"common": "Палестина"
				},
				"slk": {
					"official": "Palestínsky štát",
					"common": "Palestína"
				},
				"spa": {
					"official": "Estado de Palestina",
					"common": "Palestina"
				},
				"fin": {
					"official": "Palestiinan valtio",
					"common": "Palestiina"
				},
				"zho": {
					"official": "巴勒斯坦国",
					"common": "巴勒斯坦"
				}
			},
			"latlng": [
				31.9,
				35.2
			],
			"demonym": "Palestinian",
			"landlocked": false,
			"borders": [
				"ISR",
				"EGY",
				"JOR"
			],
			"area": 6220
		},
		{
			"name": {
				"common": "French Polynesia",
				"official": "French Polynesia",
				"native": {
					"fra": {
						"official": "Polynésie française",
						"common": "Polynésie française"
					}
				}
			},
			"tld": [
				".pf"
			],
			"cca2": "PF",
			"ccn3": "258",
			"cca3": "PYF",
			"cioc": "",
			"currency": [
				"XPF"
			],
			"callingCode": [
				"689"
			],
			"capital": "Papeetē",
			"altSpellings": [
				"PF",
				"Polynésie française",
				"French Polynesia",
				"Pōrīnetia Farāni"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Französisch-Polynesien",
					"common": "Französisch-Polynesien"
				},
				"fra": {
					"official": "Polynésie française",
					"common": "Polynésie française"
				},
				"hrv": {
					"official": "Francuska Polinezija",
					"common": "Francuska Polinezija"
				},
				"ita": {
					"official": "Polinesia Francese",
					"common": "Polinesia Francese"
				},
				"jpn": {
					"official": "フランス領ポリネシア",
					"common": "フランス領ポリネシア"
				},
				"nld": {
					"official": "Frans-Polynesië",
					"common": "Frans-Polynesië"
				},
				"por": {
					"official": "Polinésia Francesa",
					"common": "Polinésia Francesa"
				},
				"rus": {
					"official": "Французская Полинезия",
					"common": "Французская Полинезия"
				},
				"slk": {
					"official": "Francúzska Polynézia",
					"common": "Francúzska Polynézia"
				},
				"spa": {
					"official": "Polinesia francés",
					"common": "Polinesia Francesa"
				},
				"fin": {
					"official": "Ranskan Polynesia",
					"common": "Ranskan Polynesia"
				},
				"zho": {
					"official": "法属波利尼西亚",
					"common": "法属波利尼西亚"
				}
			},
			"latlng": [
				-15,
				-140
			],
			"demonym": "French Polynesian",
			"landlocked": false,
			"borders": [],
			"area": 4167
		},
		{
			"name": {
				"common": "Qatar",
				"official": "State of Qatar",
				"native": {
					"ara": {
						"official": "دولة قطر",
						"common": "قطر"
					}
				}
			},
			"tld": [
				".qa",
				"قطر."
			],
			"cca2": "QA",
			"ccn3": "634",
			"cca3": "QAT",
			"cioc": "QAT",
			"currency": [
				"QAR"
			],
			"callingCode": [
				"974"
			],
			"capital": "Doha",
			"altSpellings": [
				"QA",
				"State of Qatar",
				"Dawlat Qaṭar"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Staat Katar",
					"common": "Katar"
				},
				"fra": {
					"official": "État du Qatar",
					"common": "Qatar"
				},
				"hrv": {
					"official": "Država Katar",
					"common": "Katar"
				},
				"ita": {
					"official": "Stato del Qatar",
					"common": "Qatar"
				},
				"jpn": {
					"official": "カタール国",
					"common": "カタール"
				},
				"nld": {
					"official": "Staat Qatar",
					"common": "Qatar"
				},
				"por": {
					"official": "Estado do Qatar",
					"common": "Catar"
				},
				"rus": {
					"official": "Государство Катар",
					"common": "Катар"
				},
				"slk": {
					"official": "Katarský štát",
					"common": "Katar"
				},
				"spa": {
					"official": "Estado de Qatar",
					"common": "Catar"
				},
				"fin": {
					"official": "Qatarin valtio",
					"common": "Qatar"
				},
				"zho": {
					"official": "卡塔尔国",
					"common": "卡塔尔"
				}
			},
			"latlng": [
				25.5,
				51.25
			],
			"demonym": "Qatari",
			"landlocked": false,
			"borders": [
				"SAU"
			],
			"area": 11586
		},
		{
			"name": {
				"common": "Réunion",
				"official": "Réunion Island",
				"native": {
					"fra": {
						"official": "Ile de la Réunion",
						"common": "La Réunion"
					}
				}
			},
			"tld": [
				".re"
			],
			"cca2": "RE",
			"ccn3": "638",
			"cca3": "REU",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"262"
			],
			"capital": "Saint-Denis",
			"altSpellings": [
				"RE",
				"Reunion"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Réunion",
					"common": "Réunion"
				},
				"fra": {
					"official": "Ile de la Réunion",
					"common": "Réunion"
				},
				"hrv": {
					"official": "Réunion Island",
					"common": "Réunion"
				},
				"ita": {
					"official": "Réunion",
					"common": "Riunione"
				},
				"jpn": {
					"official": "レユニオン島",
					"common": "レユニオン"
				},
				"nld": {
					"official": "Réunion",
					"common": "Réunion"
				},
				"por": {
					"official": "Ilha da Reunião",
					"common": "Reunião"
				},
				"rus": {
					"official": "Реюньон",
					"common": "Реюньон"
				},
				"slk": {
					"official": "Réunionský zámorský departmán",
					"common": "Réunion"
				},
				"spa": {
					"official": "Isla de la Reunión",
					"common": "Reunión"
				},
				"fin": {
					"official": "Réunion",
					"common": "Réunion"
				},
				"zho": {
					"official": "留尼旺岛",
					"common": "留尼旺岛"
				}
			},
			"latlng": [
				-21.15,
				55.5
			],
			"demonym": "French",
			"landlocked": false,
			"borders": [],
			"area": 2511
		},
		{
			"name": {
				"common": "Romania",
				"official": "Romania",
				"native": {
					"ron": {
						"official": "România",
						"common": "România"
					}
				}
			},
			"tld": [
				".ro"
			],
			"cca2": "RO",
			"ccn3": "642",
			"cca3": "ROU",
			"cioc": "ROU",
			"currency": [
				"RON"
			],
			"callingCode": [
				"40"
			],
			"capital": "Bucharest",
			"altSpellings": [
				"RO",
				"Rumania",
				"Roumania",
				"România"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"ron": "Romanian"
			},
			"translations": {
				"deu": {
					"official": "Rumänien",
					"common": "Rumänien"
				},
				"fra": {
					"official": "Roumanie",
					"common": "Roumanie"
				},
				"hrv": {
					"official": "Rumunija",
					"common": "Rumunjska"
				},
				"ita": {
					"official": "Romania",
					"common": "Romania"
				},
				"jpn": {
					"official": "ルーマニア",
					"common": "ルーマニア"
				},
				"nld": {
					"official": "Roemenië",
					"common": "Roemenië"
				},
				"por": {
					"official": "Romênia",
					"common": "Roménia"
				},
				"rus": {
					"official": "Румыния",
					"common": "Румыния"
				},
				"slk": {
					"official": "Rumunsko",
					"common": "Rumunsko"
				},
				"spa": {
					"official": "Rumania",
					"common": "Rumania"
				},
				"fin": {
					"official": "Romania",
					"common": "Romania"
				},
				"zho": {
					"official": "罗马尼亚",
					"common": "罗马尼亚"
				}
			},
			"latlng": [
				46,
				25
			],
			"demonym": "Romanian",
			"landlocked": false,
			"borders": [
				"BGR",
				"HUN",
				"MDA",
				"SRB",
				"UKR"
			],
			"area": 238391
		},
		{
			"name": {
				"common": "Russia",
				"official": "Russian Federation",
				"native": {
					"rus": {
						"official": "Российская Федерация",
						"common": "Россия"
					}
				}
			},
			"tld": [
				".ru",
				".su",
				".рф"
			],
			"cca2": "RU",
			"ccn3": "643",
			"cca3": "RUS",
			"cioc": "RUS",
			"currency": [
				"RUB"
			],
			"callingCode": [
				"7"
			],
			"capital": "Moscow",
			"altSpellings": [
				"RU",
				"Rossiya",
				"Russian Federation",
				"Российская Федерация",
				"Rossiyskaya Federatsiya"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"rus": "Russian"
			},
			"translations": {
				"deu": {
					"official": "Russische Föderation",
					"common": "Russland"
				},
				"fra": {
					"official": "Fédération de Russie",
					"common": "Russie"
				},
				"hrv": {
					"official": "Ruska Federacija",
					"common": "Rusija"
				},
				"ita": {
					"official": "Federazione russa",
					"common": "Russia"
				},
				"jpn": {
					"official": "ロシア連邦",
					"common": "ロシア連邦"
				},
				"nld": {
					"official": "Russische Federatie",
					"common": "Rusland"
				},
				"por": {
					"official": "Federação Russa",
					"common": "Rússia"
				},
				"rus": {
					"official": "Россия Федерация",
					"common": "Россия"
				},
				"slk": {
					"official": "Ruská federácia",
					"common": "Rusko"
				},
				"spa": {
					"official": "Federación de Rusia",
					"common": "Rusia"
				},
				"fin": {
					"official": "Venäjän federaatio",
					"common": "Venäjä"
				},
				"zho": {
					"official": "俄罗斯联邦",
					"common": "俄罗斯"
				}
			},
			"latlng": [
				60,
				100
			],
			"demonym": "Russian",
			"landlocked": false,
			"borders": [
				"AZE",
				"BLR",
				"CHN",
				"EST",
				"FIN",
				"GEO",
				"KAZ",
				"PRK",
				"LVA",
				"LTU",
				"MNG",
				"NOR",
				"POL",
				"UKR"
			],
			"area": 17098242
		},
		{
			"name": {
				"common": "Rwanda",
				"official": "Republic of Rwanda",
				"native": {
					"eng": {
						"official": "Republic of Rwanda",
						"common": "Rwanda"
					},
					"fra": {
						"official": "République rwandaise",
						"common": "Rwanda"
					},
					"kin": {
						"official": "Repubulika y'u Rwanda",
						"common": "Rwanda"
					}
				}
			},
			"tld": [
				".rw"
			],
			"cca2": "RW",
			"ccn3": "646",
			"cca3": "RWA",
			"cioc": "RWA",
			"currency": [
				"RWF"
			],
			"callingCode": [
				"250"
			],
			"capital": "Kigali",
			"altSpellings": [
				"RW",
				"Republic of Rwanda",
				"Repubulika y'u Rwanda",
				"République du Rwanda"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"fra": "French",
				"kin": "Kinyarwanda"
			},
			"translations": {
				"deu": {
					"official": "Republik Ruanda",
					"common": "Ruanda"
				},
				"fra": {
					"official": "République rwandaise",
					"common": "Rwanda"
				},
				"hrv": {
					"official": "Republika Ruandi",
					"common": "Ruanda"
				},
				"ita": {
					"official": "Repubblica del Ruanda",
					"common": "Ruanda"
				},
				"jpn": {
					"official": "ルワンダ共和国",
					"common": "ルワンダ"
				},
				"nld": {
					"official": "Republiek Rwanda",
					"common": "Rwanda"
				},
				"por": {
					"official": "República do Ruanda",
					"common": "Ruanda"
				},
				"rus": {
					"official": "Республика Руанда",
					"common": "Руанда"
				},
				"slk": {
					"official": "Rwandská republika",
					"common": "Rwanda"
				},
				"spa": {
					"official": "República de Rwanda",
					"common": "Ruanda"
				},
				"fin": {
					"official": "Ruandan tasavalta",
					"common": "Ruanda"
				},
				"zho": {
					"official": "卢旺达共和国",
					"common": "卢旺达"
				}
			},
			"latlng": [
				-2,
				30
			],
			"demonym": "Rwandan",
			"landlocked": true,
			"borders": [
				"BDI",
				"COD",
				"TZA",
				"UGA"
			],
			"area": 26338
		},
		{
			"name": {
				"common": "Saudi Arabia",
				"official": "Kingdom of Saudi Arabia",
				"native": {
					"ara": {
						"official": "المملكة العربية السعودية",
						"common": "العربية السعودية"
					}
				}
			},
			"tld": [
				".sa",
				".السعودية"
			],
			"cca2": "SA",
			"ccn3": "682",
			"cca3": "SAU",
			"cioc": "KSA",
			"currency": [
				"SAR"
			],
			"callingCode": [
				"966"
			],
			"capital": "Riyadh",
			"altSpellings": [
				"Saudi",
				"SA",
				"Kingdom of Saudi Arabia",
				"Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Königreich Saudi-Arabien",
					"common": "Saudi-Arabien"
				},
				"fra": {
					"official": "Royaume d'Arabie Saoudite",
					"common": "Arabie Saoudite"
				},
				"hrv": {
					"official": "Kraljevina Saudijska Arabija",
					"common": "Saudijska Arabija"
				},
				"ita": {
					"official": "Arabia Saudita",
					"common": "Arabia Saudita"
				},
				"jpn": {
					"official": "サウジアラビア王国",
					"common": "サウジアラビア"
				},
				"nld": {
					"official": "Koninkrijk van Saoedi-Arabië",
					"common": "Saoedi-Arabië"
				},
				"por": {
					"official": "Reino da Arábia Saudita",
					"common": "Arábia Saudita"
				},
				"rus": {
					"official": "Королевство Саудовская Аравия",
					"common": "Саудовская Аравия"
				},
				"slk": {
					"official": "Saudskoarabské kráľovstvo",
					"common": "Saudská Arábia"
				},
				"spa": {
					"official": "Reino de Arabia Saudita",
					"common": "Arabia Saudí"
				},
				"fin": {
					"official": "Saudi-Arabian kuningaskunta",
					"common": "Saudi-Arabia"
				},
				"zho": {
					"official": "沙特阿拉伯王国",
					"common": "沙特阿拉伯"
				}
			},
			"latlng": [
				25,
				45
			],
			"demonym": "Saudi Arabian",
			"landlocked": false,
			"borders": [
				"IRQ",
				"JOR",
				"KWT",
				"OMN",
				"QAT",
				"ARE",
				"YEM"
			],
			"area": 2149690
		},
		{
			"name": {
				"common": "Sudan",
				"official": "Republic of the Sudan",
				"native": {
					"ara": {
						"official": "جمهورية السودان",
						"common": "السودان"
					},
					"eng": {
						"official": "Republic of the Sudan",
						"common": "Sudan"
					}
				}
			},
			"tld": [
				".sd"
			],
			"cca2": "SD",
			"ccn3": "729",
			"cca3": "SDN",
			"cioc": "SUD",
			"currency": [
				"SDG"
			],
			"callingCode": [
				"249"
			],
			"capital": "Khartoum",
			"altSpellings": [
				"SD",
				"Republic of the Sudan",
				"Jumhūrīyat as-Sūdān"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic",
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Sudan",
					"common": "Sudan"
				},
				"fra": {
					"official": "République du Soudan",
					"common": "Soudan"
				},
				"hrv": {
					"official": "Republika Sudan",
					"common": "Sudan"
				},
				"ita": {
					"official": "Repubblica del Sudan",
					"common": "Sudan"
				},
				"jpn": {
					"official": "スーダン共和国",
					"common": "スーダン"
				},
				"nld": {
					"official": "Republiek Soedan",
					"common": "Soedan"
				},
				"por": {
					"official": "República do Sudão",
					"common": "Sudão"
				},
				"rus": {
					"official": "Республика Судан",
					"common": "Судан"
				},
				"slk": {
					"official": "Sudánska republika",
					"common": "Sudán"
				},
				"spa": {
					"official": "República de Sudán",
					"common": "Sudán"
				},
				"fin": {
					"official": "Sudanin tasavalta",
					"common": "Sudan"
				},
				"zho": {
					"official": "苏丹共和国",
					"common": "苏丹"
				}
			},
			"latlng": [
				15,
				30
			],
			"demonym": "Sudanese",
			"landlocked": false,
			"borders": [
				"CAF",
				"TCD",
				"EGY",
				"ERI",
				"ETH",
				"LBY",
				"SSD"
			],
			"area": 1886068
		},
		{
			"name": {
				"common": "Senegal",
				"official": "Republic of Senegal",
				"native": {
					"fra": {
						"official": "République du Sénégal",
						"common": "Sénégal"
					}
				}
			},
			"tld": [
				".sn"
			],
			"cca2": "SN",
			"ccn3": "686",
			"cca3": "SEN",
			"cioc": "SEN",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"221"
			],
			"capital": "Dakar",
			"altSpellings": [
				"SN",
				"Republic of Senegal",
				"République du Sénégal"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Senegal",
					"common": "Senegal"
				},
				"fra": {
					"official": "République du Sénégal",
					"common": "Sénégal"
				},
				"hrv": {
					"official": "Republika Senegal",
					"common": "Senegal"
				},
				"ita": {
					"official": "Repubblica del Senegal",
					"common": "Senegal"
				},
				"jpn": {
					"official": "セネガル共和国",
					"common": "セネガル"
				},
				"nld": {
					"official": "Republiek Senegal",
					"common": "Senegal"
				},
				"por": {
					"official": "República do Senegal",
					"common": "Senegal"
				},
				"rus": {
					"official": "Республика Сенегал",
					"common": "Сенегал"
				},
				"slk": {
					"official": "Senegalská republika",
					"common": "Senegal"
				},
				"spa": {
					"official": "República de Senegal",
					"common": "Senegal"
				},
				"fin": {
					"official": "Senegalin tasavalta",
					"common": "Senegal"
				},
				"zho": {
					"official": "塞内加尔共和国",
					"common": "塞内加尔"
				}
			},
			"latlng": [
				14,
				-14
			],
			"demonym": "Senegalese",
			"landlocked": false,
			"borders": [
				"GMB",
				"GIN",
				"GNB",
				"MLI",
				"MRT"
			],
			"area": 196722
		},
		{
			"name": {
				"common": "Singapore",
				"official": "Republic of Singapore",
				"native": {
					"zho": {
						"official": "新加坡共和国",
						"common": "新加坡"
					},
					"eng": {
						"official": "Republic of Singapore",
						"common": "Singapore"
					},
					"msa": {
						"official": "Republik Singapura",
						"common": "Singapura"
					},
					"tam": {
						"official": "சிங்கப்பூர் குடியரசு",
						"common": "சிங்கப்பூர்"
					}
				}
			},
			"tld": [
				".sg",
				".新加坡",
				".சிங்கப்பூர்"
			],
			"cca2": "SG",
			"ccn3": "702",
			"cca3": "SGP",
			"cioc": "SIN",
			"currency": [
				"SGD"
			],
			"callingCode": [
				"65"
			],
			"capital": "Singapore",
			"altSpellings": [
				"SG",
				"Singapura",
				"Republik Singapura",
				"新加坡共和国"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"zho": "Chinese",
				"eng": "English",
				"msa": "Malay",
				"tam": "Tamil"
			},
			"translations": {
				"deu": {
					"official": "Republik Singapur",
					"common": "Singapur"
				},
				"fra": {
					"official": "République de Singapour",
					"common": "Singapour"
				},
				"hrv": {
					"official": "Republika Singapur",
					"common": "Singapur"
				},
				"ita": {
					"official": "Repubblica di Singapore",
					"common": "Singapore"
				},
				"jpn": {
					"official": "シンガポール共和国",
					"common": "シンガポール"
				},
				"nld": {
					"official": "Republiek Singapore",
					"common": "Singapore"
				},
				"por": {
					"official": "República de Singapura",
					"common": "Singapura"
				},
				"rus": {
					"official": "Республика Сингапур",
					"common": "Сингапур"
				},
				"slk": {
					"official": "Singapurská republika",
					"common": "Singapur"
				},
				"spa": {
					"official": "República de Singapur",
					"common": "Singapur"
				},
				"fin": {
					"official": "Singaporen tasavalta",
					"common": "Singapore"
				}
			},
			"latlng": [
				1.36666666,
				103.8
			],
			"demonym": "Singaporean",
			"landlocked": false,
			"borders": [],
			"area": 710
		},
		{
			"name": {
				"common": "South Georgia",
				"official": "South Georgia and the South Sandwich Islands",
				"native": {
					"eng": {
						"official": "South Georgia and the South Sandwich Islands",
						"common": "South Georgia"
					}
				}
			},
			"tld": [
				".gs"
			],
			"cca2": "GS",
			"ccn3": "239",
			"cca3": "SGS",
			"cioc": "",
			"currency": [
				"GBP"
			],
			"callingCode": [
				"500"
			],
			"capital": "King Edward Point",
			"altSpellings": [
				"GS",
				"South Georgia and the South Sandwich Islands"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Südgeorgien und die Südlichen Sandwichinseln",
					"common": "Südgeorgien und die Südlichen Sandwichinseln"
				},
				"fra": {
					"official": "Géorgie du Sud et les îles Sandwich du Sud",
					"common": "Géorgie du Sud-et-les Îles Sandwich du Sud"
				},
				"hrv": {
					"official": "Južna Džordžija i Otoci Južni Sendvič",
					"common": "Južna Georgija i otočje Južni Sandwich"
				},
				"ita": {
					"official": "Georgia del Sud e isole Sandwich del Sud",
					"common": "Georgia del Sud e Isole Sandwich Meridionali"
				},
				"jpn": {
					"official": "サウスジョージア·サウスサンドウィッチ諸島",
					"common": "サウスジョージア・サウスサンドウィッチ諸島"
				},
				"nld": {
					"official": "Zuid-Georgië en de Zuidelijke Sandwich-eilanden",
					"common": "Zuid-Georgia en Zuidelijke Sandwicheilanden"
				},
				"por": {
					"official": "Geórgia do Sul e Sandwich do Sul",
					"common": "Ilhas Geórgia do Sul e Sandwich do Sul"
				},
				"rus": {
					"official": "Южная Георгия и Южные Сандвичевы острова",
					"common": "Южная Георгия и Южные Сандвичевы острова"
				},
				"slk": {
					"official": "Južná Georgia a Južné Sandwichove ostrovy",
					"common": "Južná Georgia a Južné Sandwichove ostrovy"
				},
				"spa": {
					"official": "Georgia del Sur y las Islas Sandwich del Sur",
					"common": "Islas Georgias del Sur y Sandwich del Sur"
				},
				"fin": {
					"official": "Etelä-Georgia ja Eteläiset Sandwichsaaret",
					"common": "Etelä-Georgia ja Eteläiset Sandwichsaaret"
				},
				"zho": {
					"official": "南乔治亚岛和南桑威奇群岛",
					"common": "南乔治亚"
				}
			},
			"latlng": [
				-54.5,
				-37
			],
			"demonym": "South Georgian South Sandwich Islander",
			"landlocked": false,
			"borders": [],
			"area": 3903
		},
		{
			"name": {
				"common": "Svalbard and Jan Mayen",
				"official": "Svalbard og Jan Mayen",
				"native": {
					"nor": {
						"official": "Svalbard og Jan Mayen",
						"common": "Svalbard og Jan Mayen"
					}
				}
			},
			"tld": [
				".sj"
			],
			"cca2": "SJ",
			"ccn3": "744",
			"cca3": "SJM",
			"cioc": "",
			"currency": [
				"NOK"
			],
			"callingCode": [
				"4779"
			],
			"capital": "Longyearbyen",
			"altSpellings": [
				"SJ",
				"Svalbard and Jan Mayen Islands"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"nor": "Norwegian"
			},
			"translations": {
				"deu": {
					"official": "Inselgruppe Spitzbergen",
					"common": "Spitzbergen"
				},
				"fra": {
					"official": "Jan Mayen Svalbard",
					"common": "Svalbard et Jan Mayen"
				},
				"hrv": {
					"official": "Svalbard og Jan Mayen",
					"common": "Svalbard i Jan Mayen"
				},
				"ita": {
					"official": "Svalbard og Jan Mayen",
					"common": "Svalbard e Jan Mayen"
				},
				"jpn": {
					"official": "スバールバル諸島OGヤンマイエン",
					"common": "スヴァールバル諸島およびヤンマイエン島"
				},
				"nld": {
					"official": "Svalbard og Jan Mayen",
					"common": "Svalbard en Jan Mayen"
				},
				"por": {
					"official": "Svalbard og Jan Mayen",
					"common": "Ilhas Svalbard e Jan Mayen"
				},
				"rus": {
					"official": "Свальбарда ог Ян-Майен",
					"common": "Шпицберген и Ян-Майен"
				},
				"slk": {
					"official": "Svalbard a Jan Mayen",
					"common": "Svalbard a Jan Mayen"
				},
				"spa": {
					"official": "Svalbard og Jan Mayen",
					"common": "Islas Svalbard y Jan Mayen"
				},
				"fin": {
					"official": "Huippuvuoret",
					"common": "Huippuvuoret"
				},
				"zho": {
					"official": "斯瓦尔巴特",
					"common": "斯瓦尔巴特"
				}
			},
			"latlng": [
				78,
				20
			],
			"demonym": "Norwegian",
			"landlocked": false,
			"borders": [],
			"area": -1
		},
		{
			"name": {
				"common": "Solomon Islands",
				"official": "Solomon Islands",
				"native": {
					"eng": {
						"official": "Solomon Islands",
						"common": "Solomon Islands"
					}
				}
			},
			"tld": [
				".sb"
			],
			"cca2": "SB",
			"ccn3": "090",
			"cca3": "SLB",
			"cioc": "SOL",
			"currency": [
				"SBD"
			],
			"callingCode": [
				"677"
			],
			"capital": "Honiara",
			"altSpellings": [
				"SB"
			],
			"region": "Oceania",
			"subregion": "Melanesia",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Salomon-Inseln",
					"common": "Salomonen"
				},
				"fra": {
					"official": "Îles Salomon",
					"common": "Îles Salomon"
				},
				"hrv": {
					"official": "Solomonski Otoci",
					"common": "Solomonski Otoci"
				},
				"ita": {
					"official": "Isole Salomone",
					"common": "Isole Salomone"
				},
				"jpn": {
					"official": "ソロモン諸島",
					"common": "ソロモン諸島"
				},
				"nld": {
					"official": "Solomon eilanden",
					"common": "Salomonseilanden"
				},
				"por": {
					"official": "Ilhas Salomão",
					"common": "Ilhas Salomão"
				},
				"rus": {
					"official": "Соломоновы острова",
					"common": "Соломоновы Острова"
				},
				"slk": {
					"official": "Salomonove ostrovy",
					"common": "Salomonove ostrovy"
				},
				"spa": {
					"official": "islas Salomón",
					"common": "Islas Salomón"
				},
				"fin": {
					"official": "Salomonsaaret",
					"common": "Salomonsaaret"
				},
				"zho": {
					"official": "所罗门群岛",
					"common": "所罗门群岛"
				}
			},
			"latlng": [
				-8,
				159
			],
			"demonym": "Solomon Islander",
			"landlocked": false,
			"borders": [],
			"area": 28896
		},
		{
			"name": {
				"common": "Sierra Leone",
				"official": "Republic of Sierra Leone",
				"native": {
					"eng": {
						"official": "Republic of Sierra Leone",
						"common": "Sierra Leone"
					}
				}
			},
			"tld": [
				".sl"
			],
			"cca2": "SL",
			"ccn3": "694",
			"cca3": "SLE",
			"cioc": "SLE",
			"currency": [
				"SLL"
			],
			"callingCode": [
				"232"
			],
			"capital": "Freetown",
			"altSpellings": [
				"SL",
				"Republic of Sierra Leone"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Sierra Leone",
					"common": "Sierra Leone"
				},
				"fra": {
					"official": "République de Sierra Leone",
					"common": "Sierra Leone"
				},
				"hrv": {
					"official": "Republika Sijera Leone",
					"common": "Sijera Leone"
				},
				"ita": {
					"official": "Repubblica della Sierra Leone",
					"common": "Sierra Leone"
				},
				"jpn": {
					"official": "シエラレオネ共和国",
					"common": "シエラレオネ"
				},
				"nld": {
					"official": "Republiek Sierra Leone",
					"common": "Sierra Leone"
				},
				"por": {
					"official": "República da Serra Leoa",
					"common": "Serra Leoa"
				},
				"rus": {
					"official": "Республика Сьерра-Леоне",
					"common": "Сьерра-Леоне"
				},
				"slk": {
					"official": "Sierraleonská republika",
					"common": "Sierra Leone"
				},
				"spa": {
					"official": "República de Sierra Leona",
					"common": "Sierra Leone"
				},
				"fin": {
					"official": "Sierra Leonen tasavalta",
					"common": "Sierra Leone"
				},
				"zho": {
					"official": "塞拉利昂共和国",
					"common": "塞拉利昂"
				}
			},
			"latlng": [
				8.5,
				-11.5
			],
			"demonym": "Sierra Leonean",
			"landlocked": false,
			"borders": [
				"GIN",
				"LBR"
			],
			"area": 71740
		},
		{
			"name": {
				"common": "El Salvador",
				"official": "Republic of El Salvador",
				"native": {
					"spa": {
						"official": "República de El Salvador",
						"common": "El Salvador"
					}
				}
			},
			"tld": [
				".sv"
			],
			"cca2": "SV",
			"ccn3": "222",
			"cca3": "SLV",
			"cioc": "ESA",
			"currency": [
				"SVC",
				"USD"
			],
			"callingCode": [
				"503"
			],
			"capital": "San Salvador",
			"altSpellings": [
				"SV",
				"Republic of El Salvador",
				"República de El Salvador"
			],
			"region": "Americas",
			"subregion": "Central America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"cym": {
					"official": "Republic of El Salvador",
					"common": "El Salvador"
				},
				"deu": {
					"official": "Republik El Salvador",
					"common": "El Salvador"
				},
				"fra": {
					"official": "République du Salvador",
					"common": "Salvador"
				},
				"hrv": {
					"official": "Republika El Salvador",
					"common": "Salvador"
				},
				"ita": {
					"official": "Repubblica di El Salvador",
					"common": "El Salvador"
				},
				"jpn": {
					"official": "エルサルバドル共和国",
					"common": "エルサルバドル"
				},
				"nld": {
					"official": "Republiek El Salvador",
					"common": "El Salvador"
				},
				"por": {
					"official": "República de El Salvador",
					"common": "El Salvador"
				},
				"rus": {
					"official": "Республика Эль-Сальвадор",
					"common": "Сальвадор"
				},
				"slk": {
					"official": "Salvádorská republika",
					"common": "Salvádor"
				},
				"spa": {
					"official": "República de El Salvador",
					"common": "El Salvador"
				},
				"fin": {
					"official": "El Salvadorin tasavalta",
					"common": "El Salvador"
				},
				"zho": {
					"official": "萨尔瓦多共和国",
					"common": "萨尔瓦多"
				}
			},
			"latlng": [
				13.83333333,
				-88.91666666
			],
			"demonym": "Salvadoran",
			"landlocked": false,
			"borders": [
				"GTM",
				"HND"
			],
			"area": 21041
		},
		{
			"name": {
				"common": "San Marino",
				"official": "Most Serene Republic of San Marino",
				"native": {
					"ita": {
						"official": "Serenissima Repubblica di San Marino",
						"common": "San Marino"
					}
				}
			},
			"tld": [
				".sm"
			],
			"cca2": "SM",
			"ccn3": "674",
			"cca3": "SMR",
			"cioc": "SMR",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"378"
			],
			"capital": "City of San Marino",
			"altSpellings": [
				"SM",
				"Republic of San Marino",
				"Repubblica di San Marino"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"ita": "Italian"
			},
			"translations": {
				"deu": {
					"official": "Republik San Marino",
					"common": "San Marino"
				},
				"fra": {
					"official": "République de Saint-Marin",
					"common": "Saint-Marin"
				},
				"hrv": {
					"official": "Većina Serene Republika San Marino",
					"common": "San Marino"
				},
				"ita": {
					"official": "Serenissima Repubblica di San Marino",
					"common": "San Marino"
				},
				"jpn": {
					"official": "サンマリノのほとんどセリーヌ共和国",
					"common": "サンマリノ"
				},
				"nld": {
					"official": "Meest Serene Republiek San Marino",
					"common": "San Marino"
				},
				"por": {
					"official": "Sereníssima República de San Marino",
					"common": "San Marino"
				},
				"rus": {
					"official": "Большинство Serene Республика Сан-Марино",
					"common": "Сан-Марино"
				},
				"slk": {
					"official": "Sanmarínska republika",
					"common": "San Maríno"
				},
				"spa": {
					"official": "Serenísima República de San Marino",
					"common": "San Marino"
				},
				"fin": {
					"official": "San Marinon seesteinen tasavalta",
					"common": "San Marino"
				},
				"zho": {
					"official": "圣马力诺共和国",
					"common": "圣马力诺"
				}
			},
			"latlng": [
				43.76666666,
				12.41666666
			],
			"demonym": "Sammarinese",
			"landlocked": true,
			"borders": [
				"ITA"
			],
			"area": 61
		},
		{
			"name": {
				"common": "Somalia",
				"official": "Federal Republic of Somalia",
				"native": {
					"ara": {
						"official": "جمهورية الصومال‎‎",
						"common": "الصومال‎‎"
					},
					"som": {
						"official": "Jamhuuriyadda Federaalka Soomaaliya",
						"common": "Soomaaliya"
					}
				}
			},
			"tld": [
				".so"
			],
			"cca2": "SO",
			"ccn3": "706",
			"cca3": "SOM",
			"cioc": "SOM",
			"currency": [
				"SOS"
			],
			"callingCode": [
				"252"
			],
			"capital": "Mogadishu",
			"altSpellings": [
				"SO",
				"aṣ-Ṣūmāl",
				"Federal Republic of Somalia",
				"Jamhuuriyadda Federaalka Soomaaliya",
				"Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"ara": "Arabic",
				"som": "Somali"
			},
			"translations": {
				"deu": {
					"official": "Bundesrepublik Somalia",
					"common": "Somalia"
				},
				"fra": {
					"official": "République fédérale de Somalie",
					"common": "Somalie"
				},
				"hrv": {
					"official": "Savezna Republika Somaliji",
					"common": "Somalija"
				},
				"ita": {
					"official": "Repubblica federale di Somalia",
					"common": "Somalia"
				},
				"jpn": {
					"official": "ソマリア連邦共和国",
					"common": "ソマリア"
				},
				"nld": {
					"official": "Federale Republiek Somalië",
					"common": "Somalië"
				},
				"por": {
					"official": "República Federal da Somália",
					"common": "Somália"
				},
				"rus": {
					"official": "Федеративная Республика Сомали",
					"common": "Сомали"
				},
				"slk": {
					"official": "Somálska federatívna republika",
					"common": "Somálsko"
				},
				"spa": {
					"official": "República Federal de Somalia",
					"common": "Somalia"
				},
				"fin": {
					"official": "Somalian liittotasavalta",
					"common": "Somalia"
				},
				"zho": {
					"official": "索马里共和国",
					"common": "索马里"
				}
			},
			"latlng": [
				10,
				49
			],
			"demonym": "Somali",
			"landlocked": false,
			"borders": [
				"DJI",
				"ETH",
				"KEN"
			],
			"area": 637657
		},
		{
			"name": {
				"common": "Saint Pierre and Miquelon",
				"official": "Saint Pierre and Miquelon",
				"native": {
					"fra": {
						"official": "Collectivité territoriale de Saint-Pierre-et-Miquelon",
						"common": "Saint-Pierre-et-Miquelon"
					}
				}
			},
			"tld": [
				".pm"
			],
			"cca2": "PM",
			"ccn3": "666",
			"cca3": "SPM",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"508"
			],
			"capital": "Saint-Pierre",
			"altSpellings": [
				"PM",
				"Collectivité territoriale de Saint-Pierre-et-Miquelon"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "St. Pierre und Miquelon",
					"common": "Saint-Pierre und Miquelon"
				},
				"fra": {
					"official": "Saint-Pierre-et-Miquelon",
					"common": "Saint-Pierre-et-Miquelon"
				},
				"hrv": {
					"official": "Saint Pierre i Miquelon",
					"common": "Sveti Petar i Mikelon"
				},
				"ita": {
					"official": "Saint Pierre e Miquelon",
					"common": "Saint-Pierre e Miquelon"
				},
				"jpn": {
					"official": "サンピエール島·ミクロン島",
					"common": "サンピエール島・ミクロン島"
				},
				"nld": {
					"official": "Saint-Pierre en Miquelon",
					"common": "Saint Pierre en Miquelon"
				},
				"por": {
					"official": "Saint Pierre e Miquelon",
					"common": "Saint-Pierre e Miquelon"
				},
				"rus": {
					"official": "Сен-Пьер и Микелон",
					"common": "Сен-Пьер и Микелон"
				},
				"slk": {
					"official": "Ostrovy Saint Pierre a Miquelon",
					"common": "Saint Pierre a Miquelon"
				},
				"spa": {
					"official": "San Pedro y Miquelón",
					"common": "San Pedro y Miquelón"
				},
				"fin": {
					"official": "Saint-Pierre ja Miquelon",
					"common": "Saint-Pierre ja Miquelon"
				},
				"zho": {
					"official": "圣皮埃尔和密克隆",
					"common": "圣皮埃尔和密克隆"
				}
			},
			"latlng": [
				46.83333333,
				-56.33333333
			],
			"demonym": "French",
			"landlocked": false,
			"borders": [],
			"area": 242
		},
		{
			"name": {
				"common": "Serbia",
				"official": "Republic of Serbia",
				"native": {
					"srp": {
						"official": "Република Србија",
						"common": "Србија"
					}
				}
			},
			"tld": [
				".rs",
				".срб"
			],
			"cca2": "RS",
			"ccn3": "688",
			"cca3": "SRB",
			"cioc": "SRB",
			"currency": [
				"RSD"
			],
			"callingCode": [
				"381"
			],
			"capital": "Belgrade",
			"altSpellings": [
				"RS",
				"Srbija",
				"Republic of Serbia",
				"Република Србија",
				"Republika Srbija"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"srp": "Serbian"
			},
			"translations": {
				"deu": {
					"official": "Republik Serbien",
					"common": "Serbien"
				},
				"fra": {
					"official": "République de Serbie",
					"common": "Serbie"
				},
				"hrv": {
					"official": "Republika Srbija",
					"common": "Srbija"
				},
				"ita": {
					"official": "Repubblica di Serbia",
					"common": "Serbia"
				},
				"jpn": {
					"official": "セルビア共和国",
					"common": "セルビア"
				},
				"nld": {
					"official": "Republiek Servië",
					"common": "Servië"
				},
				"por": {
					"official": "República da Sérvia",
					"common": "Sérvia"
				},
				"rus": {
					"official": "Республика Сербия",
					"common": "Сербия"
				},
				"slk": {
					"official": "Srbská republika",
					"common": "Srbsko"
				},
				"spa": {
					"official": "República de Serbia",
					"common": "Serbia"
				},
				"fin": {
					"official": "Serbian tasavalta",
					"common": "Serbia"
				},
				"zho": {
					"official": "塞尔维亚共和国",
					"common": "塞尔维亚"
				}
			},
			"latlng": [
				44,
				21
			],
			"demonym": "Serbian",
			"landlocked": true,
			"borders": [
				"BIH",
				"BGR",
				"HRV",
				"HUN",
				"UNK",
				"MKD",
				"MNE",
				"ROU"
			],
			"area": 88361
		},
		{
			"name": {
				"common": "South Sudan",
				"official": "Republic of South Sudan",
				"native": {
					"eng": {
						"official": "Republic of South Sudan",
						"common": "South Sudan"
					}
				}
			},
			"tld": [
				".ss"
			],
			"cca2": "SS",
			"ccn3": "728",
			"cca3": "SSD",
			"cioc": "",
			"currency": [
				"SSP"
			],
			"callingCode": [
				"211"
			],
			"capital": "Juba",
			"altSpellings": [
				"SS"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Südsudan",
					"common": "Südsudan"
				},
				"fra": {
					"official": "République du Soudan du Sud",
					"common": "Soudan du Sud"
				},
				"hrv": {
					"official": "Republika Južni Sudan",
					"common": "Južni Sudan"
				},
				"ita": {
					"official": "Repubblica del Sudan del Sud",
					"common": "Sudan del sud"
				},
				"jpn": {
					"official": "南スーダン共和国",
					"common": "南スーダン"
				},
				"nld": {
					"official": "Republiek Zuid-Soedan",
					"common": "Zuid-Soedan"
				},
				"por": {
					"official": "República do Sudão do Sul",
					"common": "Sudão do Sul"
				},
				"rus": {
					"official": "Республика Южный Судан",
					"common": "Южный Судан"
				},
				"slk": {
					"official": "Juhosudánska republika",
					"common": "Južný Sudán"
				},
				"spa": {
					"official": "República de Sudán del Sur",
					"common": "Sudán del Sur"
				},
				"fin": {
					"official": "Etelä-Sudanin tasavalta",
					"common": "Etelä-Sudan"
				},
				"zho": {
					"official": "南苏丹共和国",
					"common": "南苏丹"
				}
			},
			"latlng": [
				7,
				30
			],
			"demonym": "South Sudanese",
			"landlocked": true,
			"borders": [
				"CAF",
				"COD",
				"ETH",
				"KEN",
				"SDN",
				"UGA"
			],
			"area": 619745
		},
		{
			"name": {
				"common": "São Tomé and Príncipe",
				"official": "Democratic Republic of São Tomé and Príncipe",
				"native": {
					"por": {
						"official": "República Democrática do São Tomé e Príncipe",
						"common": "São Tomé e Príncipe"
					}
				}
			},
			"tld": [
				".st"
			],
			"cca2": "ST",
			"ccn3": "678",
			"cca3": "STP",
			"cioc": "STP",
			"currency": [
				"STD"
			],
			"callingCode": [
				"239"
			],
			"capital": "São Tomé",
			"altSpellings": [
				"ST",
				"Democratic Republic of São Tomé and Príncipe",
				"Sao Tome and Principe",
				"República Democrática de São Tomé e Príncipe"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"por": "Portuguese"
			},
			"translations": {
				"deu": {
					"official": "Demokratische Republik São Tomé und Príncipe",
					"common": "São Tomé und Príncipe"
				},
				"fra": {
					"official": "République démocratique de São Tomé et Príncipe",
					"common": "São Tomé et Príncipe"
				},
				"hrv": {
					"official": "Demokratska Republika São Tome i Principe",
					"common": "Sveti Toma i Princip"
				},
				"ita": {
					"official": "Repubblica democratica di São Tomé e Príncipe",
					"common": "São Tomé e Príncipe"
				},
				"jpn": {
					"official": "サントメ·プリンシペ民主共和国",
					"common": "サントメ・プリンシペ"
				},
				"nld": {
					"official": "Democratische Republiek Sao Tomé en Principe",
					"common": "Sao Tomé en Principe"
				},
				"por": {
					"official": "República Democrática de São Tomé e Príncipe",
					"common": "São Tomé e Príncipe"
				},
				"slk": {
					"official": "República Democrática de Santo Tomé y Príncipe",
					"common": "Santo Tomé y Príncipe"
				},
				"rus": {
					"official": "Демократическая Республика Сан-Томе и Принсипи",
					"common": "Сан-Томе и Принсипи"
				},
				"svk": {
					"official": "Demokratická republika Svätého Tomáša A princovho ostrova",
					"common": "Svätý Tomáš a Princov ostrov"
				},
				"fin": {
					"official": "São Tomé ja Príncipen demokraattinen tasavalta",
					"common": "São Téme ja Príncipe"
				},
				"zho": {
					"official": "圣多美和普林西比民主共和国",
					"common": "圣多美和普林西比"
				}
			},
			"latlng": [
				1,
				7
			],
			"demonym": "Sao Tomean",
			"landlocked": false,
			"borders": [],
			"area": 964
		},
		{
			"name": {
				"common": "Suriname",
				"official": "Republic of Suriname",
				"native": {
					"nld": {
						"official": "Republiek Suriname",
						"common": "Suriname"
					}
				}
			},
			"tld": [
				".sr"
			],
			"cca2": "SR",
			"ccn3": "740",
			"cca3": "SUR",
			"cioc": "SUR",
			"currency": [
				"SRD"
			],
			"callingCode": [
				"597"
			],
			"capital": "Paramaribo",
			"altSpellings": [
				"SR",
				"Sarnam",
				"Sranangron",
				"Republic of Suriname",
				"Republiek Suriname"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"nld": "Dutch"
			},
			"translations": {
				"deu": {
					"official": "Republik Suriname",
					"common": "Suriname"
				},
				"fra": {
					"official": "République du Suriname",
					"common": "Surinam"
				},
				"hrv": {
					"official": "Republika Surinam",
					"common": "Surinam"
				},
				"ita": {
					"official": "Repubblica del Suriname",
					"common": "Suriname"
				},
				"jpn": {
					"official": "スリナム共和国",
					"common": "スリナム"
				},
				"nld": {
					"official": "Republiek Suriname",
					"common": "Suriname"
				},
				"por": {
					"official": "República do Suriname",
					"common": "Suriname"
				},
				"rus": {
					"official": "Республика Суринам",
					"common": "Суринам"
				},
				"slk": {
					"official": "Surinamská republika",
					"common": "Surinam"
				},
				"spa": {
					"official": "República de Suriname",
					"common": "Surinam"
				},
				"fin": {
					"official": "Surinamen tasavalta",
					"common": "Suriname"
				},
				"zho": {
					"official": "苏里南共和国",
					"common": "苏里南"
				}
			},
			"latlng": [
				4,
				-56
			],
			"demonym": "Surinamer",
			"landlocked": false,
			"borders": [
				"BRA",
				"GUF",
				"GUY"
			],
			"area": 163820
		},
		{
			"name": {
				"common": "Slovakia",
				"official": "Slovak Republic",
				"native": {
					"slk": {
						"official": "Slovenská republika",
						"common": "Slovensko"
					}
				}
			},
			"tld": [
				".sk"
			],
			"cca2": "SK",
			"ccn3": "703",
			"cca3": "SVK",
			"cioc": "SVK",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"421"
			],
			"capital": "Bratislava",
			"altSpellings": [
				"SK",
				"Slovak Republic",
				"Slovenská republika"
			],
			"region": "Europe",
			"subregion": "Central Europe",
			"languages": {
				"slk": "Slovak"
			},
			"translations": {
				"deu": {
					"official": "Slowakische Republik",
					"common": "Slowakei"
				},
				"fra": {
					"official": "République slovaque",
					"common": "Slovaquie"
				},
				"hrv": {
					"official": "slovačka",
					"common": "Slovačka"
				},
				"ita": {
					"official": "Repubblica slovacca",
					"common": "Slovacchia"
				},
				"jpn": {
					"official": "スロバキア共和国",
					"common": "スロバキア"
				},
				"nld": {
					"official": "Slowaakse Republiek",
					"common": "Slowakije"
				},
				"por": {
					"official": "República Eslovaca",
					"common": "Eslováquia"
				},
				"rus": {
					"official": "Словацкая Республика",
					"common": "Словакия"
				},
				"slk": {
					"official": "Slovenská republika",
					"common": "Slovensko"
				},
				"spa": {
					"official": "República Eslovaca",
					"common": "República Eslovaca"
				},
				"fin": {
					"official": "Slovakian tasavalta",
					"common": "Slovakia"
				},
				"zho": {
					"official": "斯洛伐克共和国",
					"common": "斯洛伐克"
				}
			},
			"latlng": [
				48.66666666,
				19.5
			],
			"demonym": "Slovak",
			"landlocked": true,
			"borders": [
				"AUT",
				"CZE",
				"HUN",
				"POL",
				"UKR"
			],
			"area": 49037
		},
		{
			"name": {
				"common": "Slovenia",
				"official": "Republic of Slovenia",
				"native": {
					"slv": {
						"official": "Republika Slovenija",
						"common": "Slovenija"
					}
				}
			},
			"tld": [
				".si"
			],
			"cca2": "SI",
			"ccn3": "705",
			"cca3": "SVN",
			"cioc": "SLO",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"386"
			],
			"capital": "Ljubljana",
			"altSpellings": [
				"SI",
				"Republic of Slovenia",
				"Republika Slovenija"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"slv": "Slovene"
			},
			"translations": {
				"deu": {
					"official": "Republik Slowenien",
					"common": "Slowenien"
				},
				"fra": {
					"official": "République de Slovénie",
					"common": "Slovénie"
				},
				"hrv": {
					"official": "Republika Slovenija",
					"common": "Slovenija"
				},
				"ita": {
					"official": "Repubblica di Slovenia",
					"common": "Slovenia"
				},
				"jpn": {
					"official": "スロベニア共和国",
					"common": "スロベニア"
				},
				"nld": {
					"official": "Republiek Slovenië",
					"common": "Slovenië"
				},
				"por": {
					"official": "República da Eslovénia",
					"common": "Eslovénia"
				},
				"rus": {
					"official": "Республика Словения",
					"common": "Словения"
				},
				"slk": {
					"official": "Slovinská republika",
					"common": "Slovinsko"
				},
				"spa": {
					"official": "República de Eslovenia",
					"common": "Eslovenia"
				},
				"fin": {
					"official": "Slovenian tasavalta",
					"common": "Slovenia"
				},
				"zho": {
					"official": "斯洛文尼亚共和国",
					"common": "斯洛文尼亚"
				}
			},
			"latlng": [
				46.11666666,
				14.81666666
			],
			"demonym": "Slovene",
			"landlocked": false,
			"borders": [
				"AUT",
				"HRV",
				"ITA",
				"HUN"
			],
			"area": 20273
		},
		{
			"name": {
				"common": "Sweden",
				"official": "Kingdom of Sweden",
				"native": {
					"swe": {
						"official": "Konungariket Sverige",
						"common": "Sverige"
					}
				}
			},
			"tld": [
				".se"
			],
			"cca2": "SE",
			"ccn3": "752",
			"cca3": "SWE",
			"cioc": "SWE",
			"currency": [
				"SEK"
			],
			"callingCode": [
				"46"
			],
			"capital": "Stockholm",
			"altSpellings": [
				"SE",
				"Kingdom of Sweden",
				"Konungariket Sverige"
			],
			"region": "Europe",
			"subregion": "Northern Europe",
			"languages": {
				"swe": "Swedish"
			},
			"translations": {
				"deu": {
					"official": "Königreich Schweden",
					"common": "Schweden"
				},
				"fra": {
					"official": "Royaume de Suède",
					"common": "Suède"
				},
				"hrv": {
					"official": "Kraljevina Švedska",
					"common": "Švedska"
				},
				"ita": {
					"official": "Regno di Svezia",
					"common": "Svezia"
				},
				"jpn": {
					"official": "スウェーデン王国",
					"common": "スウェーデン"
				},
				"nld": {
					"official": "Koninkrijk Zweden",
					"common": "Zweden"
				},
				"por": {
					"official": "Reino da Suécia",
					"common": "Suécia"
				},
				"rus": {
					"official": "Королевство Швеция",
					"common": "Швеция"
				},
				"slk": {
					"official": "Švédske kráľovstvo",
					"common": "Švédsko"
				},
				"spa": {
					"official": "Reino de Suecia",
					"common": "Suecia"
				},
				"fin": {
					"official": "Ruotsin kuningaskunta",
					"common": "Ruotsi"
				},
				"zho": {
					"official": "瑞典王国",
					"common": "瑞典"
				}
			},
			"latlng": [
				62,
				15
			],
			"demonym": "Swedish",
			"landlocked": false,
			"borders": [
				"FIN",
				"NOR"
			],
			"area": 450295
		},
		{
			"name": {
				"common": "Swaziland",
				"official": "Kingdom of Swaziland",
				"native": {
					"eng": {
						"official": "Kingdom of Swaziland",
						"common": "Swaziland"
					},
					"ssw": {
						"official": "Kingdom of Swaziland",
						"common": "Swaziland"
					}
				}
			},
			"tld": [
				".sz"
			],
			"cca2": "SZ",
			"ccn3": "748",
			"cca3": "SWZ",
			"cioc": "SWZ",
			"currency": [
				"SZL"
			],
			"callingCode": [
				"268"
			],
			"capital": "Lobamba",
			"altSpellings": [
				"SZ",
				"weSwatini",
				"Swatini",
				"Ngwane",
				"Kingdom of Swaziland",
				"Umbuso waseSwatini"
			],
			"region": "Africa",
			"subregion": "Southern Africa",
			"languages": {
				"eng": "English",
				"ssw": "Swazi"
			},
			"translations": {
				"deu": {
					"official": "Königreich Swasiland",
					"common": "Swasiland"
				},
				"fra": {
					"official": "Royaume du Swaziland",
					"common": "Swaziland"
				},
				"hrv": {
					"official": "Kraljevina Svazi",
					"common": "Svazi"
				},
				"ita": {
					"official": "Regno dello Swaziland",
					"common": "Swaziland"
				},
				"jpn": {
					"official": "スワジランド王国",
					"common": "スワジランド"
				},
				"nld": {
					"official": "Koninkrijk Swaziland",
					"common": "Swaziland"
				},
				"por": {
					"official": "Reino da Suazilândia",
					"common": "Suazilândia"
				},
				"rus": {
					"official": "Королевство Свазиленд",
					"common": "Свазиленд"
				},
				"slk": {
					"official": "Svazijské kráľovstvo",
					"common": "Svazijsko"
				},
				"spa": {
					"official": "Reino de Swazilandia",
					"common": "Suazilandia"
				},
				"fin": {
					"official": "Swazimaan kuningaskunta",
					"common": "Swazimaa"
				},
				"zho": {
					"official": "斯威士兰王国",
					"common": "斯威士兰"
				}
			},
			"latlng": [
				-26.5,
				31.5
			],
			"demonym": "Swazi",
			"landlocked": true,
			"borders": [
				"MOZ",
				"ZAF"
			],
			"area": 17364
		},
		{
			"name": {
				"common": "Sint Maarten",
				"official": "Sint Maarten",
				"native": {
					"eng": {
						"official": "Sint Maarten",
						"common": "Sint Maarten"
					},
					"fra": {
						"official": "Saint-Martin",
						"common": "Saint-Martin"
					},
					"nld": {
						"official": "Sint Maarten",
						"common": "Sint Maarten"
					}
				}
			},
			"tld": [
				".sx"
			],
			"cca2": "SX",
			"ccn3": "534",
			"cca3": "SXM",
			"cioc": "",
			"currency": [
				"ANG"
			],
			"callingCode": [
				"1721"
			],
			"capital": "Philipsburg",
			"altSpellings": [
				"SX",
				"Sint Maarten (Dutch part)"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English",
				"fra": "French",
				"nld": "Dutch"
			},
			"translations": {
				"deu": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"fra": {
					"official": "Sint Maarten",
					"common": "Saint-Martin"
				},
				"ita": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"jpn": {
					"official": "シントマールテン島",
					"common": "シント・マールテン"
				},
				"nld": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"por": {
					"official": "Sint Maarten",
					"common": "São Martinho"
				},
				"rus": {
					"official": "Синт-Маартен",
					"common": "Синт-Мартен"
				},
				"slk": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"spa": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"fin": {
					"official": "Sint Maarten",
					"common": "Sint Maarten"
				},
				"zho": {
					"official": "圣马丁岛",
					"common": "圣马丁岛"
				}
			},
			"latlng": [
				18.033333,
				-63.05
			],
			"demonym": "St. Maartener",
			"landlocked": false,
			"borders": [
				"MAF"
			],
			"area": 34
		},
		{
			"name": {
				"common": "Seychelles",
				"official": "Republic of Seychelles",
				"native": {
					"crs": {
						"official": "Repiblik Sesel",
						"common": "Sesel"
					},
					"eng": {
						"official": "Republic of Seychelles",
						"common": "Seychelles"
					},
					"fra": {
						"official": "République des Seychelles",
						"common": "Seychelles"
					}
				}
			},
			"tld": [
				".sc"
			],
			"cca2": "SC",
			"ccn3": "690",
			"cca3": "SYC",
			"cioc": "SEY",
			"currency": [
				"SCR"
			],
			"callingCode": [
				"248"
			],
			"capital": "Victoria",
			"altSpellings": [
				"SC",
				"Republic of Seychelles",
				"Repiblik Sesel",
				"République des Seychelles"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"crs": "Seychellois Creole",
				"eng": "English",
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik der Seychellen",
					"common": "Seychellen"
				},
				"fra": {
					"official": "République des Seychelles",
					"common": "Seychelles"
				},
				"hrv": {
					"official": "Republika Sejšeli",
					"common": "Sejšeli"
				},
				"ita": {
					"official": "Repubblica delle Seychelles",
					"common": "Seychelles"
				},
				"jpn": {
					"official": "セイシェル共和国",
					"common": "セーシェル"
				},
				"nld": {
					"official": "Republiek der Seychellen",
					"common": "Seychellen"
				},
				"por": {
					"official": "República das Seychelles",
					"common": "Seicheles"
				},
				"rus": {
					"official": "Республика Сейшельские Острова",
					"common": "Сейшельские Острова"
				},
				"slk": {
					"official": "Seychelská republika",
					"common": "Seychely"
				},
				"spa": {
					"official": "República de las Seychelles",
					"common": "Seychelles"
				},
				"fin": {
					"official": "Seychellien tasavalta",
					"common": "Seychellit"
				},
				"zho": {
					"official": "塞舌尔共和国",
					"common": "塞舌尔"
				}
			},
			"latlng": [
				-4.58333333,
				55.66666666
			],
			"demonym": "Seychellois",
			"landlocked": false,
			"borders": [],
			"area": 452
		},
		{
			"name": {
				"common": "Syria",
				"official": "Syrian Arab Republic",
				"native": {
					"ara": {
						"official": "الجمهورية العربية السورية",
						"common": "سوريا"
					}
				}
			},
			"tld": [
				".sy",
				"سوريا."
			],
			"cca2": "SY",
			"ccn3": "760",
			"cca3": "SYR",
			"cioc": "SYR",
			"currency": [
				"SYP"
			],
			"callingCode": [
				"963"
			],
			"capital": "Damascus",
			"altSpellings": [
				"SY",
				"Syrian Arab Republic",
				"Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Arabische Republik Syrien",
					"common": "Syrien"
				},
				"fra": {
					"official": "République arabe syrienne",
					"common": "Syrie"
				},
				"hrv": {
					"official": "Sirijska Arapska Republika",
					"common": "Sirija"
				},
				"ita": {
					"official": "Repubblica araba siriana",
					"common": "Siria"
				},
				"jpn": {
					"official": "シリアアラブ共和国",
					"common": "シリア・アラブ共和国"
				},
				"nld": {
					"official": "Syrische Arabische Republiek",
					"common": "Syrië"
				},
				"por": {
					"official": "República Árabe Síria",
					"common": "Síria"
				},
				"rus": {
					"official": "Сирийская Арабская Республика",
					"common": "Сирия"
				},
				"slk": {
					"official": "Sýrska arabská republika",
					"common": "Sýria"
				},
				"spa": {
					"official": "República Árabe Siria",
					"common": "Siria"
				},
				"fin": {
					"official": "Syyrian arabitasavalta",
					"common": "Syyria"
				},
				"zho": {
					"official": "叙利亚阿拉伯共和国",
					"common": "叙利亚"
				}
			},
			"latlng": [
				35,
				38
			],
			"demonym": "Syrian",
			"landlocked": false,
			"borders": [
				"IRQ",
				"ISR",
				"JOR",
				"LBN",
				"TUR"
			],
			"area": 185180
		},
		{
			"name": {
				"common": "Turks and Caicos Islands",
				"official": "Turks and Caicos Islands",
				"native": {
					"eng": {
						"official": "Turks and Caicos Islands",
						"common": "Turks and Caicos Islands"
					}
				}
			},
			"tld": [
				".tc"
			],
			"cca2": "TC",
			"ccn3": "796",
			"cca3": "TCA",
			"cioc": "",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1649"
			],
			"capital": "Cockburn Town",
			"altSpellings": [
				"TC"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Turks und Caicos Inseln",
					"common": "Turks-und Caicosinseln"
				},
				"fra": {
					"official": "Îles Turques et Caïques",
					"common": "Îles Turques-et-Caïques"
				},
				"hrv": {
					"official": "Otoci Turks i Caicos",
					"common": "Otoci Turks i Caicos"
				},
				"ita": {
					"official": "Turks e Caicos",
					"common": "Isole Turks e Caicos"
				},
				"jpn": {
					"official": "タークス·カイコス諸島",
					"common": "タークス・カイコス諸島"
				},
				"nld": {
					"official": "Turks-en Caicoseilanden",
					"common": "Turks-en Caicoseilanden"
				},
				"por": {
					"official": "Ilhas Turks e Caicos",
					"common": "Ilhas Turks e Caicos"
				},
				"rus": {
					"official": "Теркс и Кайкос острова",
					"common": "Теркс и Кайкос"
				},
				"slk": {
					"official": "Ostrovy Turks a Caicos",
					"common": "Turks a Caicos"
				},
				"spa": {
					"official": "Islas Turcas y Caicos",
					"common": "Islas Turks y Caicos"
				},
				"fin": {
					"official": "Turks-ja Caicossaaret",
					"common": "Turks-ja Caicossaaret"
				},
				"zho": {
					"official": "特克斯和凯科斯群岛",
					"common": "特克斯和凯科斯群岛"
				}
			},
			"latlng": [
				21.75,
				-71.58333333
			],
			"demonym": "Turks and Caicos Islander",
			"landlocked": false,
			"borders": [],
			"area": 948
		},
		{
			"name": {
				"common": "Chad",
				"official": "Republic of Chad",
				"native": {
					"ara": {
						"official": "جمهورية تشاد",
						"common": "تشاد‎"
					},
					"fra": {
						"official": "République du Tchad",
						"common": "Tchad"
					}
				}
			},
			"tld": [
				".td"
			],
			"cca2": "TD",
			"ccn3": "148",
			"cca3": "TCD",
			"cioc": "CHA",
			"currency": [
				"XAF"
			],
			"callingCode": [
				"235"
			],
			"capital": "N'Djamena",
			"altSpellings": [
				"TD",
				"Tchad",
				"Republic of Chad",
				"République du Tchad"
			],
			"region": "Africa",
			"subregion": "Middle Africa",
			"languages": {
				"ara": "Arabic",
				"fra": "French"
			},
			"translations": {
				"cym": {
					"official": "Republic of Chad",
					"common": "Tsiad"
				},
				"deu": {
					"official": "Republik Tschad",
					"common": "Tschad"
				},
				"fra": {
					"official": "République du Tchad",
					"common": "Tchad"
				},
				"hrv": {
					"official": "Čadu",
					"common": "Čad"
				},
				"ita": {
					"official": "Repubblica del Ciad",
					"common": "Ciad"
				},
				"jpn": {
					"official": "チャド共和国",
					"common": "チャド"
				},
				"nld": {
					"official": "Republiek Tsjaad",
					"common": "Tsjaad"
				},
				"por": {
					"official": "República do Chade",
					"common": "Chade"
				},
				"rus": {
					"official": "Республика Чад",
					"common": "Чад"
				},
				"slk": {
					"official": "Čadská republika",
					"common": "Čad"
				},
				"spa": {
					"official": "República de Chad",
					"common": "Chad"
				},
				"fin": {
					"official": "Tšadin tasavalta",
					"common": "Tšad"
				},
				"zho": {
					"official": "乍得共和国",
					"common": "乍得"
				}
			},
			"latlng": [
				15,
				19
			],
			"demonym": "Chadian",
			"landlocked": true,
			"borders": [
				"CMR",
				"CAF",
				"LBY",
				"NER",
				"NGA",
				"SSD"
			],
			"area": 1284000
		},
		{
			"name": {
				"common": "Togo",
				"official": "Togolese Republic",
				"native": {
					"fra": {
						"official": "République togolaise",
						"common": "Togo"
					}
				}
			},
			"tld": [
				".tg"
			],
			"cca2": "TG",
			"ccn3": "768",
			"cca3": "TGO",
			"cioc": "TOG",
			"currency": [
				"XOF"
			],
			"callingCode": [
				"228"
			],
			"capital": "Lomé",
			"altSpellings": [
				"TG",
				"Togolese",
				"Togolese Republic",
				"République Togolaise"
			],
			"region": "Africa",
			"subregion": "Western Africa",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Republik Togo",
					"common": "Togo"
				},
				"fra": {
					"official": "République togolaise",
					"common": "Togo"
				},
				"hrv": {
					"official": "Togolese Republika",
					"common": "Togo"
				},
				"ita": {
					"official": "Repubblica del Togo",
					"common": "Togo"
				},
				"jpn": {
					"official": "トーゴ共和国",
					"common": "トーゴ"
				},
				"nld": {
					"official": "Republiek Togo",
					"common": "Togo"
				},
				"por": {
					"official": "República do Togo",
					"common": "Togo"
				},
				"rus": {
					"official": "Того Республика",
					"common": "Того"
				},
				"slk": {
					"official": "Togská republika",
					"common": "Togo"
				},
				"spa": {
					"official": "República de Togo",
					"common": "Togo"
				},
				"fin": {
					"official": "Togon tasavalta",
					"common": "Togo"
				},
				"zho": {
					"official": "多哥共和国",
					"common": "多哥"
				}
			},
			"latlng": [
				8,
				1.16666666
			],
			"demonym": "Togolese",
			"landlocked": false,
			"borders": [
				"BEN",
				"BFA",
				"GHA"
			],
			"area": 56785
		},
		{
			"name": {
				"common": "Thailand",
				"official": "Kingdom of Thailand",
				"native": {
					"tha": {
						"official": "ราชอาณาจักรไทย",
						"common": "ประเทศไทย"
					}
				}
			},
			"tld": [
				".th",
				".ไทย"
			],
			"cca2": "TH",
			"ccn3": "764",
			"cca3": "THA",
			"cioc": "THA",
			"currency": [
				"THB"
			],
			"callingCode": [
				"66"
			],
			"capital": "Bangkok",
			"altSpellings": [
				"TH",
				"Prathet",
				"Thai",
				"Kingdom of Thailand",
				"ราชอาณาจักรไทย",
				"Ratcha Anachak Thai"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"tha": "Thai"
			},
			"translations": {
				"deu": {
					"official": "Königreich Thailand",
					"common": "Thailand"
				},
				"fra": {
					"official": "Royaume de Thaïlande",
					"common": "Thaïlande"
				},
				"hrv": {
					"official": "Kraljevina Tajland",
					"common": "Tajland"
				},
				"ita": {
					"official": "Regno di Thailandia",
					"common": "Tailandia"
				},
				"jpn": {
					"official": "タイ王国",
					"common": "タイ"
				},
				"nld": {
					"official": "Koninkrijk Thailand",
					"common": "Thailand"
				},
				"por": {
					"official": "Reino da Tailândia",
					"common": "Tailândia"
				},
				"rus": {
					"official": "Королевство Таиланд",
					"common": "Таиланд"
				},
				"slk": {
					"official": "Thajské kráľovstvo",
					"common": "Thajsko"
				},
				"spa": {
					"official": "Reino de Tailandia",
					"common": "Tailandia"
				},
				"fin": {
					"official": "Thaimaan kuningaskunta",
					"common": "Thaimaa"
				},
				"zho": {
					"official": "泰王国",
					"common": "泰国"
				}
			},
			"latlng": [
				15,
				100
			],
			"demonym": "Thai",
			"landlocked": false,
			"borders": [
				"MMR",
				"KHM",
				"LAO",
				"MYS"
			],
			"area": 513120
		},
		{
			"name": {
				"common": "Tajikistan",
				"official": "Republic of Tajikistan",
				"native": {
					"rus": {
						"official": "Республика Таджикистан",
						"common": "Таджикистан"
					},
					"tgk": {
						"official": "Ҷумҳурии Тоҷикистон",
						"common": "Тоҷикистон"
					}
				}
			},
			"tld": [
				".tj"
			],
			"cca2": "TJ",
			"ccn3": "762",
			"cca3": "TJK",
			"cioc": "TJK",
			"currency": [
				"TJS"
			],
			"callingCode": [
				"992"
			],
			"capital": "Dushanbe",
			"altSpellings": [
				"TJ",
				"Toçikiston",
				"Republic of Tajikistan",
				"Ҷумҳурии Тоҷикистон",
				"Çumhuriyi Toçikiston"
			],
			"region": "Asia",
			"subregion": "Central Asia",
			"languages": {
				"rus": "Russian",
				"tgk": "Tajik"
			},
			"translations": {
				"deu": {
					"official": "Republik Tadschikistan",
					"common": "Tadschikistan"
				},
				"fra": {
					"official": "République du Tadjikistan",
					"common": "Tadjikistan"
				},
				"hrv": {
					"official": "Republika Tadžikistan",
					"common": "Tađikistan"
				},
				"ita": {
					"official": "Repubblica del Tajikistan",
					"common": "Tagikistan"
				},
				"jpn": {
					"official": "タジキスタン共和国",
					"common": "タジキスタン"
				},
				"nld": {
					"official": "Tadzjikistan",
					"common": "Tadzjikistan"
				},
				"por": {
					"official": "República do Tajiquistão",
					"common": "Tajiquistão"
				},
				"rus": {
					"official": "Республика Таджикистан",
					"common": "Таджикистан"
				},
				"slk": {
					"official": "Taǆická republika",
					"common": "Taǆikistan"
				},
				"spa": {
					"official": "República de Tayikistán",
					"common": "Tayikistán"
				},
				"fin": {
					"official": "Tadžikistanin tasavalta",
					"common": "Tadžikistan"
				},
				"zho": {
					"official": "塔吉克斯坦共和国",
					"common": "塔吉克斯坦"
				}
			},
			"latlng": [
				39,
				71
			],
			"demonym": "Tadzhik",
			"landlocked": true,
			"borders": [
				"AFG",
				"CHN",
				"KGZ",
				"UZB"
			],
			"area": 143100
		},
		{
			"name": {
				"common": "Tokelau",
				"official": "Tokelau",
				"native": {
					"eng": {
						"official": "Tokelau",
						"common": "Tokelau"
					},
					"smo": {
						"official": "Tokelau",
						"common": "Tokelau"
					},
					"tkl": {
						"official": "Tokelau",
						"common": "Tokelau"
					}
				}
			},
			"tld": [
				".tk"
			],
			"cca2": "TK",
			"ccn3": "772",
			"cca3": "TKL",
			"cioc": "",
			"currency": [
				"NZD"
			],
			"callingCode": [
				"690"
			],
			"capital": "Fakaofo",
			"altSpellings": [
				"TK"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"smo": "Samoan",
				"tkl": "Tokelauan"
			},
			"translations": {
				"deu": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"fra": {
					"official": "Îles Tokelau",
					"common": "Tokelau"
				},
				"hrv": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"ita": {
					"official": "Tokelau",
					"common": "Isole Tokelau"
				},
				"jpn": {
					"official": "トケラウ諸島",
					"common": "トケラウ"
				},
				"nld": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"por": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"rus": {
					"official": "Токелау",
					"common": "Токелау"
				},
				"slk": {
					"official": "Tokelauské ostrovy",
					"common": "Tokelau"
				},
				"spa": {
					"official": "Tokelau",
					"common": "Islas Tokelau"
				},
				"fin": {
					"official": "Tokelau",
					"common": "Tokelau"
				},
				"zho": {
					"official": "托克劳",
					"common": "托克劳"
				}
			},
			"latlng": [
				-9,
				-172
			],
			"demonym": "Tokelauan",
			"landlocked": false,
			"borders": [],
			"area": 12
		},
		{
			"name": {
				"common": "Turkmenistan",
				"official": "Turkmenistan",
				"native": {
					"rus": {
						"official": "Туркменистан",
						"common": "Туркмения"
					},
					"tuk": {
						"official": "Türkmenistan",
						"common": "Türkmenistan"
					}
				}
			},
			"tld": [
				".tm"
			],
			"cca2": "TM",
			"ccn3": "795",
			"cca3": "TKM",
			"cioc": "TKM",
			"currency": [
				"TMT"
			],
			"callingCode": [
				"993"
			],
			"capital": "Ashgabat",
			"altSpellings": [
				"TM"
			],
			"region": "Asia",
			"subregion": "Central Asia",
			"languages": {
				"rus": "Russian",
				"tuk": "Turkmen"
			},
			"translations": {
				"deu": {
					"official": "Turkmenistan",
					"common": "Turkmenistan"
				},
				"fra": {
					"official": "Turkménistan",
					"common": "Turkménistan"
				},
				"hrv": {
					"official": "Turkmenistan",
					"common": "Turkmenistan"
				},
				"ita": {
					"official": "Turkmenistan",
					"common": "Turkmenistan"
				},
				"jpn": {
					"official": "トルクメニスタン",
					"common": "トルクメニスタン"
				},
				"nld": {
					"official": "Turkmenistan",
					"common": "Turkmenistan"
				},
				"por": {
					"official": "Turcomenistão",
					"common": "Turquemenistão"
				},
				"rus": {
					"official": "Туркменистан",
					"common": "Туркмения"
				},
				"slk": {
					"official": "Turkménsko",
					"common": "Turkménsko"
				},
				"spa": {
					"official": "Turkmenistán",
					"common": "Turkmenistán"
				},
				"fin": {
					"official": "Turkmenistan",
					"common": "Turkmenistan"
				},
				"zho": {
					"official": "土库曼斯坦",
					"common": "土库曼斯坦"
				}
			},
			"latlng": [
				40,
				60
			],
			"demonym": "Turkmen",
			"landlocked": true,
			"borders": [
				"AFG",
				"IRN",
				"KAZ",
				"UZB"
			],
			"area": 488100
		},
		{
			"name": {
				"common": "Timor-Leste",
				"official": "Democratic Republic of Timor-Leste",
				"native": {
					"por": {
						"official": "República Democrática de Timor-Leste",
						"common": "Timor-Leste"
					},
					"tet": {
						"official": "Repúblika Demokrátika Timór-Leste",
						"common": "Timór-Leste"
					}
				}
			},
			"tld": [
				".tl"
			],
			"cca2": "TL",
			"ccn3": "626",
			"cca3": "TLS",
			"cioc": "TLS",
			"currency": [
				"USD"
			],
			"callingCode": [
				"670"
			],
			"capital": "Dili",
			"altSpellings": [
				"TL",
				"East Timor",
				"Democratic Republic of Timor-Leste",
				"República Democrática de Timor-Leste",
				"Repúblika Demokrátika Timór-Leste",
				"Timór Lorosa'e",
				"Timor Lorosae"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"por": "Portuguese",
				"tet": "Tetum"
			},
			"translations": {
				"deu": {
					"official": "Demokratische Republik Timor-Leste",
					"common": "Timor-Leste"
				},
				"fra": {
					"official": "République démocratique du Timor oriental",
					"common": "Timor oriental"
				},
				"hrv": {
					"official": "Demokratska Republika Timor-Leste",
					"common": "Istočni Timor"
				},
				"ita": {
					"official": "Repubblica Democratica di Timor Est",
					"common": "Timor Est"
				},
				"jpn": {
					"official": "東ティモール民主共和国",
					"common": "東ティモール"
				},
				"nld": {
					"official": "Democratische Republiek Oost-Timor",
					"common": "Oost-Timor"
				},
				"por": {
					"official": "República Democrática de Timor-Leste",
					"common": "Timor-Leste"
				},
				"rus": {
					"official": "Демократическая Республика Тимор -Лешти",
					"common": "Восточный Тимор"
				},
				"slk": {
					"official": "Východotimorská demokratická republika",
					"common": "Východný Timor"
				},
				"spa": {
					"official": "República Democrática de Timor-Leste",
					"common": "Timor Oriental"
				},
				"fin": {
					"official": "Itä-Timorin demokraattinen tasavalta",
					"common": "Itä-Timor"
				},
				"zho": {
					"official": "东帝汶民主共和国",
					"common": "东帝汶"
				}
			},
			"latlng": [
				-8.83333333,
				125.91666666
			],
			"demonym": "East Timorese",
			"landlocked": false,
			"borders": [
				"IDN"
			],
			"area": 14874
		},
		{
			"name": {
				"common": "Tonga",
				"official": "Kingdom of Tonga",
				"native": {
					"eng": {
						"official": "Kingdom of Tonga",
						"common": "Tonga"
					},
					"ton": {
						"official": "Kingdom of Tonga",
						"common": "Tonga"
					}
				}
			},
			"tld": [
				".to"
			],
			"cca2": "TO",
			"ccn3": "776",
			"cca3": "TON",
			"cioc": "TGA",
			"currency": [
				"TOP"
			],
			"callingCode": [
				"676"
			],
			"capital": "Nuku'alofa",
			"altSpellings": [
				"TO"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"ton": "Tongan"
			},
			"translations": {
				"deu": {
					"official": "Königreich Tonga",
					"common": "Tonga"
				},
				"fra": {
					"official": "Royaume des Tonga",
					"common": "Tonga"
				},
				"hrv": {
					"official": "Kraljevina Tonga",
					"common": "Tonga"
				},
				"ita": {
					"official": "Regno di Tonga",
					"common": "Tonga"
				},
				"jpn": {
					"official": "トンガ王国",
					"common": "トンガ"
				},
				"nld": {
					"official": "Koninkrijk Tonga",
					"common": "Tonga"
				},
				"por": {
					"official": "Reino de Tonga",
					"common": "Tonga"
				},
				"rus": {
					"official": "Королевство Тонга",
					"common": "Тонга"
				},
				"slk": {
					"official": "Tongské kráľovstvo",
					"common": "Tonga"
				},
				"spa": {
					"official": "Reino de Tonga",
					"common": "Tonga"
				},
				"fin": {
					"official": "Tongan kuningaskunta",
					"common": "Tonga"
				},
				"zho": {
					"official": "汤加王国",
					"common": "汤加"
				}
			},
			"latlng": [
				-20,
				-175
			],
			"demonym": "Tongan",
			"landlocked": false,
			"borders": [],
			"area": 747
		},
		{
			"name": {
				"common": "Trinidad and Tobago",
				"official": "Republic of Trinidad and Tobago",
				"native": {
					"eng": {
						"official": "Republic of Trinidad and Tobago",
						"common": "Trinidad and Tobago"
					}
				}
			},
			"tld": [
				".tt"
			],
			"cca2": "TT",
			"ccn3": "780",
			"cca3": "TTO",
			"cioc": "TTO",
			"currency": [
				"TTD"
			],
			"callingCode": [
				"1868"
			],
			"capital": "Port of Spain",
			"altSpellings": [
				"TT",
				"Republic of Trinidad and Tobago"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Trinidad und Tobago",
					"common": "Trinidad und Tobago"
				},
				"fra": {
					"official": "République de Trinité-et-Tobago",
					"common": "Trinité-et-Tobago"
				},
				"hrv": {
					"official": "Republika Trinidad i Tobago",
					"common": "Trinidad i Tobago"
				},
				"ita": {
					"official": "Repubblica di Trinidad e Tobago",
					"common": "Trinidad e Tobago"
				},
				"jpn": {
					"official": "トリニダード·トバゴ共和国",
					"common": "トリニダード・トバゴ"
				},
				"nld": {
					"official": "Republiek Trinidad en Tobago",
					"common": "Trinidad en Tobago"
				},
				"por": {
					"official": "República de Trinidad e Tobago",
					"common": "Trinidade e Tobago"
				},
				"rus": {
					"official": "Республика Тринидад и Тобаго",
					"common": "Тринидад и Тобаго"
				},
				"slk": {
					"official": "Republika Trinidad a Tobaga",
					"common": "Trinidad a Tobago"
				},
				"spa": {
					"official": "República de Trinidad y Tobago",
					"common": "Trinidad y Tobago"
				},
				"fin": {
					"official": "Trinidadin ja Tobagon tasavalta",
					"common": "Trinidad ja Tobago"
				},
				"zho": {
					"official": "特立尼达和多巴哥共和国",
					"common": "特立尼达和多巴哥"
				}
			},
			"latlng": [
				11,
				-61
			],
			"demonym": "Trinidadian",
			"landlocked": false,
			"borders": [],
			"area": 5130
		},
		{
			"name": {
				"common": "Tunisia",
				"official": "Tunisian Republic",
				"native": {
					"ara": {
						"official": "الجمهورية التونسية",
						"common": "تونس"
					}
				}
			},
			"tld": [
				".tn"
			],
			"cca2": "TN",
			"ccn3": "788",
			"cca3": "TUN",
			"cioc": "TUN",
			"currency": [
				"TND"
			],
			"callingCode": [
				"216"
			],
			"capital": "Tunis",
			"altSpellings": [
				"TN",
				"Republic of Tunisia",
				"al-Jumhūriyyah at-Tūnisiyyah"
			],
			"region": "Africa",
			"subregion": "Northern Africa",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Tunesische Republik",
					"common": "Tunesien"
				},
				"fra": {
					"official": "République tunisienne",
					"common": "Tunisie"
				},
				"hrv": {
					"official": "Tuniski Republika",
					"common": "Tunis"
				},
				"ita": {
					"official": "Repubblica tunisina",
					"common": "Tunisia"
				},
				"jpn": {
					"official": "チュニジア共和国",
					"common": "チュニジア"
				},
				"nld": {
					"official": "Republiek Tunesië",
					"common": "Tunesië"
				},
				"por": {
					"official": "República da Tunísia",
					"common": "Tunísia"
				},
				"rus": {
					"official": "Тунисской Республики",
					"common": "Тунис"
				},
				"slk": {
					"official": "Tuniská republika",
					"common": "Tunisko"
				},
				"spa": {
					"official": "República de Túnez",
					"common": "Túnez"
				},
				"fin": {
					"official": "Tunisian tasavalta",
					"common": "Tunisia"
				},
				"zho": {
					"official": "突尼斯共和国",
					"common": "突尼斯"
				}
			},
			"latlng": [
				34,
				9
			],
			"demonym": "Tunisian",
			"landlocked": false,
			"borders": [
				"DZA",
				"LBY"
			],
			"area": 163610
		},
		{
			"name": {
				"common": "Turkey",
				"official": "Republic of Turkey",
				"native": {
					"tur": {
						"official": "Türkiye Cumhuriyeti",
						"common": "Türkiye"
					}
				}
			},
			"tld": [
				".tr"
			],
			"cca2": "TR",
			"ccn3": "792",
			"cca3": "TUR",
			"cioc": "TUR",
			"currency": [
				"TRY"
			],
			"callingCode": [
				"90"
			],
			"capital": "Ankara",
			"altSpellings": [
				"TR",
				"Turkiye",
				"Republic of Turkey",
				"Türkiye Cumhuriyeti"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"tur": "Turkish"
			},
			"translations": {
				"deu": {
					"official": "Republik Türkei",
					"common": "Türkei"
				},
				"fra": {
					"official": "République de Turquie",
					"common": "Turquie"
				},
				"hrv": {
					"official": "Republika Turska",
					"common": "Turska"
				},
				"ita": {
					"official": "Repubblica di Turchia",
					"common": "Turchia"
				},
				"jpn": {
					"official": "トルコ共和国",
					"common": "トルコ"
				},
				"nld": {
					"official": "Republiek Turkije",
					"common": "Turkije"
				},
				"por": {
					"official": "República da Turquia",
					"common": "Turquia"
				},
				"rus": {
					"official": "Республика Турции",
					"common": "Турция"
				},
				"slk": {
					"official": "Turecká republika",
					"common": "Turecko"
				},
				"spa": {
					"official": "República de Turquía",
					"common": "Turquía"
				},
				"fin": {
					"official": "Turkin tasavalta",
					"common": "Turkki"
				},
				"zho": {
					"official": "土耳其共和国",
					"common": "土耳其"
				}
			},
			"latlng": [
				39,
				35
			],
			"demonym": "Turkish",
			"landlocked": false,
			"borders": [
				"ARM",
				"AZE",
				"BGR",
				"GEO",
				"GRC",
				"IRN",
				"IRQ",
				"SYR"
			],
			"area": 783562
		},
		{
			"name": {
				"common": "Tuvalu",
				"official": "Tuvalu",
				"native": {
					"eng": {
						"official": "Tuvalu",
						"common": "Tuvalu"
					},
					"tvl": {
						"official": "Tuvalu",
						"common": "Tuvalu"
					}
				}
			},
			"tld": [
				".tv"
			],
			"cca2": "TV",
			"ccn3": "798",
			"cca3": "TUV",
			"cioc": "TUV",
			"currency": [
				"AUD"
			],
			"callingCode": [
				"688"
			],
			"capital": "Funafuti",
			"altSpellings": [
				"TV"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"tvl": "Tuvaluan"
			},
			"translations": {
				"deu": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"fra": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"hrv": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"ita": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"jpn": {
					"official": "ツバル",
					"common": "ツバル"
				},
				"nld": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"por": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"rus": {
					"official": "Тувалу",
					"common": "Тувалу"
				},
				"slk": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"spa": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"fin": {
					"official": "Tuvalu",
					"common": "Tuvalu"
				},
				"zho": {
					"official": "图瓦卢",
					"common": "图瓦卢"
				}
			},
			"latlng": [
				-8,
				178
			],
			"demonym": "Tuvaluan",
			"landlocked": false,
			"borders": [],
			"area": 26
		},
		{
			"name": {
				"common": "Taiwan",
				"official": "Republic of China (Taiwan)",
				"native": {
					"zho": {
						"official": "中华民国",
						"common": "臺灣"
					}
				}
			},
			"tld": [
				".tw",
				".台湾",
				".台灣"
			],
			"cca2": "TW",
			"ccn3": "158",
			"cca3": "TWN",
			"cioc": "TPE",
			"currency": [
				"TWD"
			],
			"callingCode": [
				"886"
			],
			"capital": "Taipei",
			"altSpellings": [
				"TW",
				"Táiwān",
				"Republic of China",
				"中華民國",
				"Zhōnghuá Mínguó",
				"Chinese Taipei for IOC",
				"Taiwan, Province of China"
			],
			"region": "Asia",
			"subregion": "Eastern Asia",
			"languages": {
				"zho": "Chinese"
			},
			"translations": {
				"deu": {
					"official": "Republik China (Taiwan)",
					"common": "Taiwan"
				},
				"fra": {
					"official": "République de Chine (Taïwan)",
					"common": "Taïwan"
				},
				"hrv": {
					"official": "Republika Kina",
					"common": "Tajvan"
				},
				"ita": {
					"official": "Repubblica cinese (Taiwan)",
					"common": "Taiwan"
				},
				"jpn": {
					"official": "中華民国",
					"common": "台湾（台湾省/中華民国）"
				},
				"nld": {
					"official": "Republiek China (Taiwan)",
					"common": "Taiwan"
				},
				"por": {
					"official": "República da China",
					"common": "Ilha Formosa"
				},
				"rus": {
					"official": "Китайская Республика",
					"common": "Тайвань"
				},
				"slk": {
					"official": "Čínska republika",
					"common": "Taiwan"
				},
				"spa": {
					"official": "República de China en Taiwán",
					"common": "Taiwán"
				},
				"fin": {
					"official": "Kiinan tasavalta",
					"common": "Taiwan"
				}
			},
			"latlng": [
				23.5,
				121
			],
			"demonym": "Taiwanese",
			"landlocked": false,
			"borders": [],
			"area": 36193
		},
		{
			"name": {
				"common": "Tanzania",
				"official": "United Republic of Tanzania",
				"native": {
					"eng": {
						"official": "United Republic of Tanzania",
						"common": "Tanzania"
					},
					"swa": {
						"official": "Jamhuri ya Muungano wa Tanzania",
						"common": "Tanzania"
					}
				}
			},
			"tld": [
				".tz"
			],
			"cca2": "TZ",
			"ccn3": "834",
			"cca3": "TZA",
			"cioc": "TAN",
			"currency": [
				"TZS"
			],
			"callingCode": [
				"255"
			],
			"capital": "Dodoma",
			"altSpellings": [
				"TZ",
				"Tanzania, United Republic of",
				"United Republic of Tanzania",
				"Jamhuri ya Muungano wa Tanzania"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"swa": "Swahili"
			},
			"translations": {
				"deu": {
					"official": "Vereinigte Republik Tansania",
					"common": "Tansania"
				},
				"fra": {
					"official": "République -Unie de Tanzanie",
					"common": "Tanzanie"
				},
				"hrv": {
					"official": "Ujedinjena Republika Tanzanija",
					"common": "Tanzanija"
				},
				"ita": {
					"official": "Repubblica Unita di Tanzania",
					"common": "Tanzania"
				},
				"jpn": {
					"official": "タンザニア連合共和国",
					"common": "タンザニア"
				},
				"nld": {
					"official": "Verenigde Republiek Tanzania",
					"common": "Tanzania"
				},
				"por": {
					"official": "República Unida da Tanzânia",
					"common": "Tanzânia"
				},
				"rus": {
					"official": "Объединенная Республика Танзания",
					"common": "Танзания"
				},
				"slk": {
					"official": "Tanzánijská zjednotená republika",
					"common": "Tanzánia"
				},
				"spa": {
					"official": "República Unida de Tanzania",
					"common": "Tanzania"
				},
				"fin": {
					"official": "Tansanian yhdistynyt tasavalta",
					"common": "Tansania"
				},
				"zho": {
					"official": "坦桑尼亚联合共和国",
					"common": "坦桑尼亚"
				}
			},
			"latlng": [
				-6,
				35
			],
			"demonym": "Tanzanian",
			"landlocked": false,
			"borders": [
				"BDI",
				"COD",
				"KEN",
				"MWI",
				"MOZ",
				"RWA",
				"UGA",
				"ZMB"
			],
			"area": 945087
		},
		{
			"name": {
				"common": "Uganda",
				"official": "Republic of Uganda",
				"native": {
					"eng": {
						"official": "Republic of Uganda",
						"common": "Uganda"
					},
					"swa": {
						"official": "Republic of Uganda",
						"common": "Uganda"
					}
				}
			},
			"tld": [
				".ug"
			],
			"cca2": "UG",
			"ccn3": "800",
			"cca3": "UGA",
			"cioc": "UGA",
			"currency": [
				"UGX"
			],
			"callingCode": [
				"256"
			],
			"capital": "Kampala",
			"altSpellings": [
				"UG",
				"Republic of Uganda",
				"Jamhuri ya Uganda"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English",
				"swa": "Swahili"
			},
			"translations": {
				"deu": {
					"official": "Republik Uganda",
					"common": "Uganda"
				},
				"fra": {
					"official": "République de l'Ouganda",
					"common": "Ouganda"
				},
				"hrv": {
					"official": "Republika Uganda",
					"common": "Uganda"
				},
				"ita": {
					"official": "Repubblica di Uganda",
					"common": "Uganda"
				},
				"jpn": {
					"official": "ウガンダ共和国",
					"common": "ウガンダ"
				},
				"nld": {
					"official": "Republiek Uganda",
					"common": "Oeganda"
				},
				"por": {
					"official": "República do Uganda",
					"common": "Uganda"
				},
				"rus": {
					"official": "Республика Уганда",
					"common": "Уганда"
				},
				"slk": {
					"official": "Ugandská republika",
					"common": "Uganda"
				},
				"spa": {
					"official": "República de Uganda",
					"common": "Uganda"
				},
				"fin": {
					"official": "Ugandan tasavalta",
					"common": "Uganda"
				},
				"zho": {
					"official": "乌干达共和国",
					"common": "乌干达"
				}
			},
			"latlng": [
				1,
				32
			],
			"demonym": "Ugandan",
			"landlocked": true,
			"borders": [
				"COD",
				"KEN",
				"RWA",
				"SSD",
				"TZA"
			],
			"area": 241550
		},
		{
			"name": {
				"common": "Ukraine",
				"official": "Ukraine",
				"native": {
					"rus": {
						"official": "Украина",
						"common": "Украина"
					},
					"ukr": {
						"official": "Україна",
						"common": "Україна"
					}
				}
			},
			"tld": [
				".ua",
				".укр"
			],
			"cca2": "UA",
			"ccn3": "804",
			"cca3": "UKR",
			"cioc": "UKR",
			"currency": [
				"UAH"
			],
			"callingCode": [
				"380"
			],
			"capital": "Kiev",
			"altSpellings": [
				"UA",
				"Ukrayina"
			],
			"region": "Europe",
			"subregion": "Eastern Europe",
			"languages": {
				"rus": "Russian",
				"ukr": "Ukrainian"
			},
			"translations": {
				"deu": {
					"official": "Ukraine",
					"common": "Ukraine"
				},
				"fra": {
					"official": "Ukraine",
					"common": "Ukraine"
				},
				"hrv": {
					"official": "Ukrajina",
					"common": "Ukrajina"
				},
				"ita": {
					"official": "Ucraina",
					"common": "Ucraina"
				},
				"jpn": {
					"official": "ウクライナ",
					"common": "ウクライナ"
				},
				"nld": {
					"official": "Oekraïne",
					"common": "Oekraïne"
				},
				"por": {
					"official": "Ucrânia",
					"common": "Ucrânia"
				},
				"rus": {
					"official": "Украина",
					"common": "Украина"
				},
				"slk": {
					"official": "Ukrajina",
					"common": "Ukrajina"
				},
				"spa": {
					"official": "Ucrania",
					"common": "Ucrania"
				},
				"fin": {
					"official": "Ukraina",
					"common": "Ukraina"
				},
				"zho": {
					"official": "乌克兰",
					"common": "乌克兰"
				}
			},
			"latlng": [
				49,
				32
			],
			"demonym": "Ukrainian",
			"landlocked": false,
			"borders": [
				"BLR",
				"HUN",
				"MDA",
				"POL",
				"ROU",
				"RUS",
				"SVK"
			],
			"area": 603500
		},
		{
			"name": {
				"common": "United States Minor Outlying Islands",
				"official": "United States Minor Outlying Islands",
				"native": {
					"eng": {
						"official": "United States Minor Outlying Islands",
						"common": "United States Minor Outlying Islands"
					}
				}
			},
			"tld": [
				".us"
			],
			"cca2": "UM",
			"ccn3": "581",
			"cca3": "UMI",
			"cioc": "",
			"currency": [
				"USD"
			],
			"callingCode": [],
			"capital": "",
			"altSpellings": [
				"UM"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "USA, kleinere ausgelagerte Inseln",
					"common": "Kleinere Inselbesitzungen der Vereinigten Staaten"
				},
				"fra": {
					"official": "Îles mineures éloignées des États-Unis",
					"common": "Îles mineures éloignées des États-Unis"
				},
				"hrv": {
					"official": "Mali udaljeni otoci SAD-a",
					"common": "Mali udaljeni otoci SAD-a"
				},
				"ita": {
					"official": "Stati Uniti Isole Minori",
					"common": "Isole minori esterne degli Stati Uniti d'America"
				},
				"jpn": {
					"official": "アメリカ合衆国外諸島",
					"common": "合衆国領有小離島"
				},
				"nld": {
					"official": "Kleine afgelegen eilanden van de Verenigde Staten",
					"common": "Kleine afgelegen eilanden van de Verenigde Staten"
				},
				"por": {
					"official": "Estados Unidos Ilhas Menores Distantes",
					"common": "Ilhas Menores Distantes dos Estados Unidos"
				},
				"rus": {
					"official": "Внешние малые острова США",
					"common": "Внешние малые острова США"
				},
				"slk": {
					"official": "Menšie odľahlé ostrovy Spjoených štátov",
					"common": "Menšie odľahlé ostrovy USA"
				},
				"spa": {
					"official": "Estados Unidos Islas menores alejadas de",
					"common": "Islas Ultramarinas Menores de Estados Unidos"
				},
				"fin": {
					"official": "Yhdysvaltain asumattomat saaret",
					"common": "Yhdysvaltain asumattomat saaret"
				},
				"zho": {
					"official": "美国本土外小岛屿",
					"common": "美国本土外小岛屿"
				}
			},
			"latlng": [],
			"demonym": "American",
			"landlocked": false,
			"borders": [],
			"area": 34.2
		},
		{
			"name": {
				"common": "Uruguay",
				"official": "Oriental Republic of Uruguay",
				"native": {
					"spa": {
						"official": "República Oriental del Uruguay",
						"common": "Uruguay"
					}
				}
			},
			"tld": [
				".uy"
			],
			"cca2": "UY",
			"ccn3": "858",
			"cca3": "URY",
			"cioc": "URU",
			"currency": [
				"UYI",
				"UYU"
			],
			"callingCode": [
				"598"
			],
			"capital": "Montevideo",
			"altSpellings": [
				"UY",
				"Oriental Republic of Uruguay",
				"República Oriental del Uruguay"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Republik Östlich des Uruguay",
					"common": "Uruguay"
				},
				"fra": {
					"official": "République orientale de l'Uruguay",
					"common": "Uruguay"
				},
				"hrv": {
					"official": "Orijentalna Republika Urugvaj",
					"common": "Urugvaj"
				},
				"ita": {
					"official": "Repubblica Orientale dell'Uruguay",
					"common": "Uruguay"
				},
				"jpn": {
					"official": "ウルグアイ東方共和国",
					"common": "ウルグアイ"
				},
				"nld": {
					"official": "Oosterse Republiek Uruguay",
					"common": "Uruguay"
				},
				"por": {
					"official": "República Oriental do Uruguai",
					"common": "Uruguai"
				},
				"rus": {
					"official": "Восточной Республики Уругвай",
					"common": "Уругвай"
				},
				"slk": {
					"official": "Uruguajská východná republika",
					"common": "Uruguaj"
				},
				"spa": {
					"official": "República Oriental del Uruguay",
					"common": "Uruguay"
				},
				"fin": {
					"official": "Uruguayn itäinen tasavalta",
					"common": "Uruguay"
				},
				"zho": {
					"official": "乌拉圭东岸共和国",
					"common": "乌拉圭"
				}
			},
			"latlng": [
				-33,
				-56
			],
			"demonym": "Uruguayan",
			"landlocked": false,
			"borders": [
				"ARG",
				"BRA"
			],
			"area": 181034
		},
		{
			"name": {
				"common": "United States",
				"official": "United States of America",
				"native": {
					"eng": {
						"official": "United States of America",
						"common": "United States"
					}
				}
			},
			"tld": [
				".us"
			],
			"cca2": "US",
			"ccn3": "840",
			"cca3": "USA",
			"cioc": "USA",
			"currency": [
				"USD",
				"USN",
				"USS"
			],
			"callingCode": [
				"1"
			],
			"capital": "Washington D.C.",
			"altSpellings": [
				"US",
				"USA",
				"United States of America"
			],
			"region": "Americas",
			"subregion": "Northern America",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Vereinigte Staaten von Amerika",
					"common": "Vereinigte Staaten von Amerika"
				},
				"fra": {
					"official": "Les états-unis d'Amérique",
					"common": "États-Unis"
				},
				"hrv": {
					"official": "Sjedinjene Države Amerike",
					"common": "Sjedinjene Američke Države"
				},
				"ita": {
					"official": "Stati Uniti d'America",
					"common": "Stati Uniti d'America"
				},
				"jpn": {
					"official": "アメリカ合衆国",
					"common": "アメリカ合衆国"
				},
				"nld": {
					"official": "Verenigde Staten van Amerika",
					"common": "Verenigde Staten"
				},
				"por": {
					"official": "Estados Unidos da América",
					"common": "Estados Unidos"
				},
				"rus": {
					"official": "Соединенные Штаты Америки",
					"common": "Соединённые Штаты Америки"
				},
				"slk": {
					"official": "Spojené štáty Americké",
					"common": "Spojené štáty americké"
				},
				"spa": {
					"official": "Estados Unidos de América",
					"common": "Estados Unidos"
				},
				"fin": {
					"official": "Amerikan yhdysvallat",
					"common": "Yhdysvallat"
				},
				"zho": {
					"official": "美利坚合众国",
					"common": "美国"
				}
			},
			"latlng": [
				38,
				-97
			],
			"demonym": "American",
			"landlocked": false,
			"borders": [
				"CAN",
				"MEX"
			],
			"area": 9372610
		},
		{
			"name": {
				"common": "Uzbekistan",
				"official": "Republic of Uzbekistan",
				"native": {
					"rus": {
						"official": "Республика Узбекистан",
						"common": "Узбекистан"
					},
					"uzb": {
						"official": "O'zbekiston Respublikasi",
						"common": "O‘zbekiston"
					}
				}
			},
			"tld": [
				".uz"
			],
			"cca2": "UZ",
			"ccn3": "860",
			"cca3": "UZB",
			"cioc": "UZB",
			"currency": [
				"UZS"
			],
			"callingCode": [
				"998"
			],
			"capital": "Tashkent",
			"altSpellings": [
				"UZ",
				"Republic of Uzbekistan",
				"O‘zbekiston Respublikasi",
				"Ўзбекистон Республикаси"
			],
			"region": "Asia",
			"subregion": "Central Asia",
			"languages": {
				"rus": "Russian",
				"uzb": "Uzbek"
			},
			"translations": {
				"deu": {
					"official": "Republik Usbekistan",
					"common": "Usbekistan"
				},
				"fra": {
					"official": "République d'Ouzbékistan",
					"common": "Ouzbékistan"
				},
				"hrv": {
					"official": "Republika Uzbekistan",
					"common": "Uzbekistan"
				},
				"ita": {
					"official": "Repubblica di Uzbekistan",
					"common": "Uzbekistan"
				},
				"jpn": {
					"official": "ウズベキスタン共和国",
					"common": "ウズベキスタン"
				},
				"nld": {
					"official": "Republiek Oezbekistan",
					"common": "Oezbekistan"
				},
				"por": {
					"official": "República do Usbequistão",
					"common": "Uzbequistão"
				},
				"rus": {
					"official": "Республика Узбекистан",
					"common": "Узбекистан"
				},
				"slk": {
					"official": "Uzbecká republika",
					"common": "Uzbekistan"
				},
				"spa": {
					"official": "República de Uzbekistán",
					"common": "Uzbekistán"
				},
				"fin": {
					"official": "Uzbekistanin tasavalta",
					"common": "Uzbekistan"
				},
				"zho": {
					"official": "乌兹别克斯坦共和国",
					"common": "乌兹别克斯坦"
				}
			},
			"latlng": [
				41,
				64
			],
			"demonym": "Uzbekistani",
			"landlocked": true,
			"borders": [
				"AFG",
				"KAZ",
				"KGZ",
				"TJK",
				"TKM"
			],
			"area": 447400
		},
		{
			"name": {
				"common": "Vatican City",
				"official": "Vatican City State",
				"native": {
					"ita": {
						"official": "Stato della Città del Vaticano",
						"common": "Vaticano"
					},
					"lat": {
						"official": "Status Civitatis Vaticanæ",
						"common": "Vaticanæ"
					}
				}
			},
			"tld": [
				".va"
			],
			"cca2": "VA",
			"ccn3": "336",
			"cca3": "VAT",
			"cioc": "",
			"currency": [
				"EUR"
			],
			"callingCode": [
				"3906698",
				"379"
			],
			"capital": "Vatican City",
			"altSpellings": [
				"VA",
				"Holy See (Vatican City State)",
				"Vatican City State",
				"Stato della Città del Vaticano"
			],
			"region": "Europe",
			"subregion": "Southern Europe",
			"languages": {
				"ita": "Italian",
				"lat": "Latin"
			},
			"translations": {
				"deu": {
					"official": "Staat Vatikanstadt",
					"common": "Vatikanstadt"
				},
				"fra": {
					"official": "Cité du Vatican",
					"common": "Cité du Vatican"
				},
				"hrv": {
					"official": "Vatikan",
					"common": "Vatikan"
				},
				"ita": {
					"official": "Città del Vaticano",
					"common": "Città del Vaticano"
				},
				"jpn": {
					"official": "バチカン市国の状態",
					"common": "バチカン市国"
				},
				"nld": {
					"official": "Vaticaanstad",
					"common": "Vaticaanstad"
				},
				"por": {
					"official": "Cidade do Vaticano",
					"common": "Cidade do Vaticano"
				},
				"rus": {
					"official": "Город-государство Ватикан",
					"common": "Ватикан"
				},
				"slk": {
					"official": "Svätá stolica (Vatikánsky mestský štát",
					"common": "Vatikán"
				},
				"spa": {
					"official": "Ciudad del Vaticano",
					"common": "Ciudad del Vaticano"
				},
				"fin": {
					"official": "Vatikaanin kaupunkivaltio",
					"common": "Vatikaani"
				},
				"zho": {
					"official": "梵蒂冈城国",
					"common": "梵蒂冈"
				}
			},
			"latlng": [
				41.9,
				12.45
			],
			"demonym": "Italian",
			"landlocked": true,
			"borders": [
				"ITA"
			],
			"area": 0.44
		},
		{
			"name": {
				"common": "Saint Vincent and the Grenadines",
				"official": "Saint Vincent and the Grenadines",
				"native": {
					"eng": {
						"official": "Saint Vincent and the Grenadines",
						"common": "Saint Vincent and the Grenadines"
					}
				}
			},
			"tld": [
				".vc"
			],
			"cca2": "VC",
			"ccn3": "670",
			"cca3": "VCT",
			"cioc": "VIN",
			"currency": [
				"XCD"
			],
			"callingCode": [
				"1784"
			],
			"capital": "Kingstown",
			"altSpellings": [
				"VC"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "St. Vincent und die Grenadinen",
					"common": "Saint Vincent und die Grenadinen"
				},
				"fra": {
					"official": "Saint-Vincent-et-les Grenadines",
					"common": "Saint-Vincent-et-les-Grenadines"
				},
				"hrv": {
					"official": "Sveti Vincent i Grenadini",
					"common": "Sveti Vincent i Grenadini"
				},
				"ita": {
					"official": "Saint Vincent e Grenadine",
					"common": "Saint Vincent e Grenadine"
				},
				"jpn": {
					"official": "セントビンセントおよびグレナディーン諸島",
					"common": "セントビンセントおよびグレナディーン諸島"
				},
				"nld": {
					"official": "Saint Vincent en de Grenadines",
					"common": "Saint Vincent en de Grenadines"
				},
				"por": {
					"official": "São Vicente e Granadinas",
					"common": "São Vincente e Granadinas"
				},
				"rus": {
					"official": "Сент-Винсент и Гренадины",
					"common": "Сент-Винсент и Гренадины"
				},
				"slk": {
					"official": "Svätý Vincent a Grenadíny",
					"common": "Svätý Vincent a Grenadíny"
				},
				"spa": {
					"official": "San Vicente y las Granadinas",
					"common": "San Vicente y Granadinas"
				},
				"fin": {
					"official": "Saint Vincent ja Grenadiinit",
					"common": "Saint Vincent ja Grenadiinit"
				},
				"zho": {
					"official": "圣文森特和格林纳丁斯",
					"common": "圣文森特和格林纳丁斯"
				}
			},
			"latlng": [
				13.25,
				-61.2
			],
			"demonym": "Saint Vincentian",
			"landlocked": false,
			"borders": [],
			"area": 389
		},
		{
			"name": {
				"common": "Venezuela",
				"official": "Bolivarian Republic of Venezuela",
				"native": {
					"spa": {
						"official": "República Bolivariana de Venezuela",
						"common": "Venezuela"
					}
				}
			},
			"tld": [
				".ve"
			],
			"cca2": "VE",
			"ccn3": "862",
			"cca3": "VEN",
			"cioc": "VEN",
			"currency": [
				"VEF"
			],
			"callingCode": [
				"58"
			],
			"capital": "Caracas",
			"altSpellings": [
				"VE",
				"Bolivarian Republic of Venezuela",
				"Venezuela, Bolivarian Republic of",
				"República Bolivariana de Venezuela"
			],
			"region": "Americas",
			"subregion": "South America",
			"languages": {
				"spa": "Spanish"
			},
			"translations": {
				"deu": {
					"official": "Bolivarische Republik Venezuela",
					"common": "Venezuela"
				},
				"fra": {
					"official": "République bolivarienne du Venezuela",
					"common": "Venezuela"
				},
				"hrv": {
					"official": "BOLIVARIJANSKA Republika Venezuela",
					"common": "Venezuela"
				},
				"ita": {
					"official": "Repubblica Bolivariana del Venezuela",
					"common": "Venezuela"
				},
				"jpn": {
					"official": "ベネズエラ·ボリバル共和国",
					"common": "ベネズエラ・ボリバル共和国"
				},
				"nld": {
					"official": "Bolivariaanse Republiek Venezuela",
					"common": "Venezuela"
				},
				"por": {
					"official": "República Bolivariana da Venezuela",
					"common": "Venezuela"
				},
				"rus": {
					"official": "Боливарианская Республика Венесуэла",
					"common": "Венесуэла"
				},
				"slk": {
					"official": "Venezuelská bolívarovská republika",
					"common": "Venezuela"
				},
				"spa": {
					"official": "República Bolivariana de Venezuela",
					"common": "Venezuela"
				},
				"fin": {
					"official": "Venezuelan bolivariaainen tasavalta",
					"common": "Venezuela"
				},
				"zho": {
					"official": "委内瑞拉玻利瓦尔共和国",
					"common": "委内瑞拉"
				}
			},
			"latlng": [
				8,
				-66
			],
			"demonym": "Venezuelan",
			"landlocked": false,
			"borders": [
				"BRA",
				"COL",
				"GUY"
			],
			"area": 916445
		},
		{
			"name": {
				"common": "British Virgin Islands",
				"official": "Virgin Islands",
				"native": {
					"eng": {
						"official": "Virgin Islands",
						"common": "British Virgin Islands"
					}
				}
			},
			"tld": [
				".vg"
			],
			"cca2": "VG",
			"ccn3": "092",
			"cca3": "VGB",
			"cioc": "IVB",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1284"
			],
			"capital": "Road Town",
			"altSpellings": [
				"VG",
				"Virgin Islands, British"
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Jungferninseln",
					"common": "Britische Jungferninseln"
				},
				"fra": {
					"official": "îles Vierges",
					"common": "Îles Vierges britanniques"
				},
				"hrv": {
					"official": "Djevičanski Otoci",
					"common": "Britanski Djevičanski Otoci"
				},
				"ita": {
					"official": "Isole Vergini",
					"common": "Isole Vergini Britanniche"
				},
				"jpn": {
					"official": "バージン諸島",
					"common": "イギリス領ヴァージン諸島"
				},
				"nld": {
					"official": "Maagdeneilanden",
					"common": "Britse Maagdeneilanden"
				},
				"por": {
					"official": "Ilhas Virgens",
					"common": "Ilhas Virgens"
				},
				"rus": {
					"official": "Виргинские острова",
					"common": "Британские Виргинские острова"
				},
				"slk": {
					"official": "Panenské ostrovy",
					"common": "Panenské ostrovy"
				},
				"spa": {
					"official": "Islas Vírgenes",
					"common": "Islas Vírgenes del Reino Unido"
				},
				"fin": {
					"official": "Brittiläiset Neitsytsaaret",
					"common": "Neitsytsaaret"
				},
				"zho": {
					"official": "英属维尔京群岛",
					"common": "英属维尔京群岛"
				}
			},
			"latlng": [
				18.431383,
				-64.62305
			],
			"demonym": "Virgin Islander",
			"landlocked": false,
			"borders": [],
			"area": 151
		},
		{
			"name": {
				"common": "United States Virgin Islands",
				"official": "Virgin Islands of the United States",
				"native": {
					"eng": {
						"official": "Virgin Islands of the United States",
						"common": "United States Virgin Islands"
					}
				}
			},
			"tld": [
				".vi"
			],
			"cca2": "VI",
			"ccn3": "850",
			"cca3": "VIR",
			"cioc": "ISV",
			"currency": [
				"USD"
			],
			"callingCode": [
				"1340"
			],
			"capital": "Charlotte Amalie",
			"altSpellings": [
				"VI",
				"Virgin Islands, U.S."
			],
			"region": "Americas",
			"subregion": "Caribbean",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Jungferninseln der Vereinigten Staaten",
					"common": "Amerikanische Jungferninseln"
				},
				"fra": {
					"official": "Îles Vierges des États-Unis",
					"common": "Îles Vierges des États-Unis"
				},
				"hrv": {
					"official": "Djevičanski Otoci SAD",
					"common": "Američki Djevičanski Otoci"
				},
				"ita": {
					"official": "Isole Vergini degli Stati Uniti",
					"common": "Isole Vergini americane"
				},
				"jpn": {
					"official": "米国のバージン諸島",
					"common": "アメリカ領ヴァージン諸島"
				},
				"nld": {
					"official": "Maagdeneilanden van de Verenigde Staten",
					"common": "Amerikaanse Maagdeneilanden"
				},
				"por": {
					"official": "Ilhas Virgens dos Estados Unidos",
					"common": "Ilhas Virgens dos Estados Unidos"
				},
				"rus": {
					"official": "Виргинские острова Соединенных Штатов",
					"common": "Виргинские Острова"
				},
				"slk": {
					"official": "Americké Panenské ostrovy",
					"common": "Americké Panenské ostrovy"
				},
				"spa": {
					"official": "Islas Vírgenes de los Estados Unidos",
					"common": "Islas Vírgenes de los Estados Unidos"
				},
				"fin": {
					"official": "Yhdysvaltain Neitsytsaaret",
					"common": "Neitsytsaaret"
				},
				"zho": {
					"official": "美属维尔京群岛",
					"common": "美属维尔京群岛"
				}
			},
			"latlng": [
				18.35,
				-64.933333
			],
			"demonym": "Virgin Islander",
			"landlocked": false,
			"borders": [],
			"area": 347
		},
		{
			"name": {
				"common": "Vietnam",
				"official": "Socialist Republic of Vietnam",
				"native": {
					"vie": {
						"official": "Cộng hòa xã hội chủ nghĩa Việt Nam",
						"common": "Việt Nam"
					}
				}
			},
			"tld": [
				".vn"
			],
			"cca2": "VN",
			"ccn3": "704",
			"cca3": "VNM",
			"cioc": "VIE",
			"currency": [
				"VND"
			],
			"callingCode": [
				"84"
			],
			"capital": "Hanoi",
			"altSpellings": [
				"VN",
				"Socialist Republic of Vietnam",
				"Cộng hòa Xã hội chủ nghĩa Việt Nam",
				"Viet Nam"
			],
			"region": "Asia",
			"subregion": "South-Eastern Asia",
			"languages": {
				"vie": "Vietnamese"
			},
			"translations": {
				"deu": {
					"official": "Sozialistische Republik Vietnam",
					"common": "Vietnam"
				},
				"fra": {
					"official": "République socialiste du Viêt Nam",
					"common": "Viêt Nam"
				},
				"hrv": {
					"official": "Socijalistička Republika Vijetnam",
					"common": "Vijetnam"
				},
				"ita": {
					"official": "Repubblica socialista del Vietnam",
					"common": "Vietnam"
				},
				"jpn": {
					"official": "ベトナム社会主義共和国",
					"common": "ベトナム"
				},
				"nld": {
					"official": "Socialistische Republiek Vietnam",
					"common": "Vietnam"
				},
				"por": {
					"official": "República Socialista do Vietname",
					"common": "Vietname"
				},
				"rus": {
					"official": "Социалистическая Республика Вьетнам",
					"common": "Вьетнам"
				},
				"slk": {
					"official": "Vietnamská socialistická republika",
					"common": "Vietnam"
				},
				"spa": {
					"official": "República Socialista de Vietnam",
					"common": "Vietnam"
				},
				"fin": {
					"official": "Vietnamin sosialistinen tasavalta",
					"common": "Vietnam"
				},
				"zho": {
					"official": "越南社会主义共和国",
					"common": "越南"
				}
			},
			"latlng": [
				16.16666666,
				107.83333333
			],
			"demonym": "Vietnamese",
			"landlocked": false,
			"borders": [
				"KHM",
				"CHN",
				"LAO"
			],
			"area": 331212
		},
		{
			"name": {
				"common": "Vanuatu",
				"official": "Republic of Vanuatu",
				"native": {
					"bis": {
						"official": "Ripablik blong Vanuatu",
						"common": "Vanuatu"
					},
					"eng": {
						"official": "Republic of Vanuatu",
						"common": "Vanuatu"
					},
					"fra": {
						"official": "République de Vanuatu",
						"common": "Vanuatu"
					}
				}
			},
			"tld": [
				".vu"
			],
			"cca2": "VU",
			"ccn3": "548",
			"cca3": "VUT",
			"cioc": "VAN",
			"currency": [
				"VUV"
			],
			"callingCode": [
				"678"
			],
			"capital": "Port Vila",
			"altSpellings": [
				"VU",
				"Republic of Vanuatu",
				"Ripablik blong Vanuatu",
				"République de Vanuatu"
			],
			"region": "Oceania",
			"subregion": "Melanesia",
			"languages": {
				"bis": "Bislama",
				"eng": "English",
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Vanuatu",
					"common": "Vanuatu"
				},
				"fra": {
					"official": "République de Vanuatu",
					"common": "Vanuatu"
				},
				"hrv": {
					"official": "Republika Vanuatu",
					"common": "Vanuatu"
				},
				"ita": {
					"official": "Repubblica di Vanuatu",
					"common": "Vanuatu"
				},
				"jpn": {
					"official": "バヌアツ共和国",
					"common": "バヌアツ"
				},
				"nld": {
					"official": "Republiek Vanuatu",
					"common": "Vanuatu"
				},
				"por": {
					"official": "República de Vanuatu",
					"common": "Vanuatu"
				},
				"rus": {
					"official": "Республика Вануату",
					"common": "Вануату"
				},
				"slk": {
					"official": "Vanuatská republika",
					"common": "Vanuatu"
				},
				"spa": {
					"official": "República de Vanuatu",
					"common": "Vanuatu"
				},
				"fin": {
					"official": "Vanuatun tasavalta",
					"common": "Vanuatu"
				},
				"zho": {
					"official": "瓦努阿图共和国",
					"common": "瓦努阿图"
				}
			},
			"latlng": [
				-16,
				167
			],
			"demonym": "Ni-Vanuatu",
			"landlocked": false,
			"borders": [],
			"area": 12189
		},
		{
			"name": {
				"common": "Wallis and Futuna",
				"official": "Territory of the Wallis and Futuna Islands",
				"native": {
					"fra": {
						"official": "Territoire des îles Wallis et Futuna",
						"common": "Wallis et Futuna"
					}
				}
			},
			"tld": [
				".wf"
			],
			"cca2": "WF",
			"ccn3": "876",
			"cca3": "WLF",
			"cioc": "",
			"currency": [
				"XPF"
			],
			"callingCode": [
				"681"
			],
			"capital": "Mata-Utu",
			"altSpellings": [
				"WF",
				"Territory of the Wallis and Futuna Islands",
				"Territoire des îles Wallis et Futuna"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"fra": "French"
			},
			"translations": {
				"deu": {
					"official": "Gebiet der Wallis und Futuna",
					"common": "Wallis und Futuna"
				},
				"fra": {
					"official": "Territoire des îles Wallis et Futuna",
					"common": "Wallis-et-Futuna"
				},
				"hrv": {
					"official": "Teritoriju Wallis i Futuna",
					"common": "Wallis i Fortuna"
				},
				"ita": {
					"official": "Territorio delle Isole Wallis e Futuna",
					"common": "Wallis e Futuna"
				},
				"jpn": {
					"official": "ウォリス·フツナ諸島の領土",
					"common": "ウォリス・フツナ"
				},
				"nld": {
					"official": "Grondgebied van de Wallis en Futuna",
					"common": "Wallis en Futuna"
				},
				"por": {
					"official": "Território das Ilhas Wallis e Futuna",
					"common": "Wallis e Futuna"
				},
				"rus": {
					"official": "Территория Уоллис и Футуна острова",
					"common": "Уоллис и Футуна"
				},
				"slk": {
					"official": "Teritórium ostrovov Wallis a Futuna",
					"common": "Wallis a Futuna"
				},
				"spa": {
					"official": "Territorio de las Islas Wallis y Futuna",
					"common": "Wallis y Futuna"
				},
				"fin": {
					"official": "Wallisin ja Futunan yhteisö",
					"common": "Wallis ja Futuna"
				},
				"zho": {
					"official": "瓦利斯和富图纳群岛",
					"common": "瓦利斯和富图纳群岛"
				}
			},
			"latlng": [
				-13.3,
				-176.2
			],
			"demonym": "Wallis and Futuna Islander",
			"landlocked": false,
			"borders": [],
			"area": 142
		},
		{
			"name": {
				"common": "Samoa",
				"official": "Independent State of Samoa",
				"native": {
					"eng": {
						"official": "Independent State of Samoa",
						"common": "Samoa"
					},
					"smo": {
						"official": "Malo Saʻoloto Tutoʻatasi o Sāmoa",
						"common": "Sāmoa"
					}
				}
			},
			"tld": [
				".ws"
			],
			"cca2": "WS",
			"ccn3": "882",
			"cca3": "WSM",
			"cioc": "SAM",
			"currency": [
				"WST"
			],
			"callingCode": [
				"685"
			],
			"capital": "Apia",
			"altSpellings": [
				"WS",
				"Independent State of Samoa",
				"Malo Saʻoloto Tutoʻatasi o Sāmoa"
			],
			"region": "Oceania",
			"subregion": "Polynesia",
			"languages": {
				"eng": "English",
				"smo": "Samoan"
			},
			"translations": {
				"deu": {
					"official": "Unabhängige Staat Samoa",
					"common": "Samoa"
				},
				"fra": {
					"official": "Samoa",
					"common": "Samoa"
				},
				"hrv": {
					"official": "Nezavisna Država Samoa",
					"common": "Samoa"
				},
				"ita": {
					"official": "Stato indipendente di Samoa",
					"common": "Samoa"
				},
				"jpn": {
					"official": "サモア独立国",
					"common": "サモア"
				},
				"nld": {
					"official": "Onafhankelijke Staat Samoa",
					"common": "Samoa"
				},
				"por": {
					"official": "Estado Independente de Samoa",
					"common": "Samoa"
				},
				"rus": {
					"official": "Независимое Государство Самоа",
					"common": "Самоа"
				},
				"slk": {
					"official": "Nezávislý štátSamoa",
					"common": "Samoa"
				},
				"spa": {
					"official": "Estado Independiente de Samoa",
					"common": "Samoa"
				},
				"fin": {
					"official": "Samoan itsenäinen valtio",
					"common": "Samoa"
				},
				"zho": {
					"official": "萨摩亚独立国",
					"common": "萨摩亚"
				}
			},
			"latlng": [
				-13.58333333,
				-172.33333333
			],
			"demonym": "Samoan",
			"landlocked": false,
			"borders": [],
			"area": 2842
		},
		{
			"name": {
				"common": "Yemen",
				"official": "Republic of Yemen",
				"native": {
					"ara": {
						"official": "الجمهورية اليمنية",
						"common": "اليَمَن"
					}
				}
			},
			"tld": [
				".ye"
			],
			"cca2": "YE",
			"ccn3": "887",
			"cca3": "YEM",
			"cioc": "YEM",
			"currency": [
				"YER"
			],
			"callingCode": [
				"967"
			],
			"capital": "Sana'a",
			"altSpellings": [
				"YE",
				"Yemeni Republic",
				"al-Jumhūriyyah al-Yamaniyyah"
			],
			"region": "Asia",
			"subregion": "Western Asia",
			"languages": {
				"ara": "Arabic"
			},
			"translations": {
				"deu": {
					"official": "Republik Jemen",
					"common": "Jemen"
				},
				"fra": {
					"official": "République du Yémen",
					"common": "Yémen"
				},
				"hrv": {
					"official": "Republika Jemen",
					"common": "Jemen"
				},
				"ita": {
					"official": "Repubblica dello Yemen",
					"common": "Yemen"
				},
				"jpn": {
					"official": "イエメン共和国",
					"common": "イエメン"
				},
				"nld": {
					"official": "Republiek Jemen",
					"common": "Jemen"
				},
				"por": {
					"official": "República do Iêmen",
					"common": "Iémen"
				},
				"rus": {
					"official": "Йеменская Республика",
					"common": "Йемен"
				},
				"slk": {
					"official": "Jemenská republika",
					"common": "Jemen"
				},
				"spa": {
					"official": "República de Yemen",
					"common": "Yemen"
				},
				"fin": {
					"official": "Jemenin tasavalta",
					"common": "Jemen"
				},
				"zho": {
					"official": "也门共和国",
					"common": "也门"
				}
			},
			"latlng": [
				15,
				48
			],
			"demonym": "Yemeni",
			"landlocked": false,
			"borders": [
				"OMN",
				"SAU"
			],
			"area": 527968
		},
		{
			"name": {
				"common": "South Africa",
				"official": "Republic of South Africa",
				"native": {
					"afr": {
						"official": "Republiek van Suid-Afrika",
						"common": "South Africa"
					},
					"eng": {
						"official": "Republic of South Africa",
						"common": "South Africa"
					},
					"nbl": {
						"official": "IRiphabliki yeSewula Afrika",
						"common": "Sewula Afrika"
					},
					"nso": {
						"official": "Rephaboliki ya Afrika-Borwa ",
						"common": "Afrika-Borwa"
					},
					"sot": {
						"official": "Rephaboliki ya Afrika Borwa",
						"common": "Afrika Borwa"
					},
					"ssw": {
						"official": "IRiphabhulikhi yeNingizimu Afrika",
						"common": "Ningizimu Afrika"
					},
					"tsn": {
						"official": "Rephaboliki ya Aforika Borwa",
						"common": "Aforika Borwa"
					},
					"tso": {
						"official": "Riphabliki ra Afrika Dzonga",
						"common": "Afrika Dzonga"
					},
					"ven": {
						"official": "Riphabuḽiki ya Afurika Tshipembe",
						"common": "Afurika Tshipembe"
					},
					"xho": {
						"official": "IRiphabliki yaseMzantsi Afrika",
						"common": "Mzantsi Afrika"
					},
					"zul": {
						"official": "IRiphabliki yaseNingizimu Afrika",
						"common": "Ningizimu Afrika"
					}
				}
			},
			"tld": [
				".za"
			],
			"cca2": "ZA",
			"ccn3": "710",
			"cca3": "ZAF",
			"cioc": "RSA",
			"currency": [
				"ZAR"
			],
			"callingCode": [
				"27"
			],
			"capital": "Pretoria",
			"altSpellings": [
				"ZA",
				"RSA",
				"Suid-Afrika",
				"Republic of South Africa"
			],
			"region": "Africa",
			"subregion": "Southern Africa",
			"languages": {
				"afr": "Afrikaans",
				"eng": "English",
				"nbl": "Southern Ndebele",
				"nso": "Northern Sotho",
				"sot": "Southern Sotho",
				"ssw": "Swazi",
				"tsn": "Tswana",
				"tso": "Tsonga",
				"ven": "Venda",
				"xho": "Xhosa",
				"zul": "Zulu"
			},
			"translations": {
				"deu": {
					"official": "Republik Südafrika",
					"common": "Republik Südafrika"
				},
				"fra": {
					"official": "République d'Afrique du Sud",
					"common": "Afrique du Sud"
				},
				"hrv": {
					"official": "Južnoafrička Republika",
					"common": "Južnoafrička Republika"
				},
				"ita": {
					"official": "Repubblica del Sud Africa",
					"common": "Sud Africa"
				},
				"jpn": {
					"official": "南アフリカ共和国",
					"common": "南アフリカ"
				},
				"nld": {
					"official": "Zuid -Afrika",
					"common": "Zuid-Afrika"
				},
				"por": {
					"official": "República da África do Sul",
					"common": "África do Sul"
				},
				"rus": {
					"official": "Южно-Африканская Республика",
					"common": "Южно-Африканская Республика"
				},
				"slk": {
					"official": "Juhoafrická republika",
					"common": "Juhoafrická republika"
				},
				"spa": {
					"official": "República de Sudáfrica",
					"common": "República de Sudáfrica"
				},
				"fin": {
					"official": "Etelä-Afrikan tasavalta",
					"common": "Etelä-Afrikka"
				},
				"zho": {
					"official": "南非共和国",
					"common": "南非"
				}
			},
			"latlng": [
				-29,
				24
			],
			"demonym": "South African",
			"landlocked": false,
			"borders": [
				"BWA",
				"LSO",
				"MOZ",
				"NAM",
				"SWZ",
				"ZWE"
			],
			"area": 1221037
		},
		{
			"name": {
				"common": "Zambia",
				"official": "Republic of Zambia",
				"native": {
					"eng": {
						"official": "Republic of Zambia",
						"common": "Zambia"
					}
				}
			},
			"tld": [
				".zm"
			],
			"cca2": "ZM",
			"ccn3": "894",
			"cca3": "ZMB",
			"cioc": "ZAM",
			"currency": [
				"ZMW"
			],
			"callingCode": [
				"260"
			],
			"capital": "Lusaka",
			"altSpellings": [
				"ZM",
				"Republic of Zambia"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"eng": "English"
			},
			"translations": {
				"deu": {
					"official": "Republik Sambia",
					"common": "Sambia"
				},
				"fra": {
					"official": "République de Zambie",
					"common": "Zambie"
				},
				"hrv": {
					"official": "Republika Zambija",
					"common": "Zambija"
				},
				"ita": {
					"official": "Repubblica di Zambia",
					"common": "Zambia"
				},
				"jpn": {
					"official": "ザンビア共和国",
					"common": "ザンビア"
				},
				"nld": {
					"official": "Republiek Zambia",
					"common": "Zambia"
				},
				"por": {
					"official": "República da Zâmbia",
					"common": "Zâmbia"
				},
				"rus": {
					"official": "Республика Замбия",
					"common": "Замбия"
				},
				"slk": {
					"official": "Zambijská republika",
					"common": "Zambia"
				},
				"spa": {
					"official": "República de Zambia",
					"common": "Zambia"
				},
				"fin": {
					"official": "Sambian tasavalta",
					"common": "Sambia"
				},
				"zho": {
					"official": "赞比亚共和国",
					"common": "赞比亚"
				}
			},
			"latlng": [
				-15,
				30
			],
			"demonym": "Zambian",
			"landlocked": true,
			"borders": [
				"AGO",
				"BWA",
				"COD",
				"MWI",
				"MOZ",
				"NAM",
				"TZA",
				"ZWE"
			],
			"area": 752612
		},
		{
			"name": {
				"common": "Zimbabwe",
				"official": "Republic of Zimbabwe",
				"native": {
					"bwg": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"eng": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"kck": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"khi": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"ndc": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"nde": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"nya": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"sna": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"sot": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"toi": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"tsn": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"tso": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"ven": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"xho": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					},
					"zib": {
						"official": "Republic of Zimbabwe",
						"common": "Zimbabwe"
					}
				}
			},
			"tld": [
				".zw"
			],
			"cca2": "ZW",
			"ccn3": "716",
			"cca3": "ZWE",
			"cioc": "ZIM",
			"currency": [
				"ZWL"
			],
			"callingCode": [
				"263"
			],
			"capital": "Harare",
			"altSpellings": [
				"ZW",
				"Republic of Zimbabwe"
			],
			"region": "Africa",
			"subregion": "Eastern Africa",
			"languages": {
				"bwg": "Chibarwe",
				"eng": "English",
				"kck": "Kalanga",
				"khi": "Khoisan",
				"ndc": "Ndau",
				"nde": "Northern Ndebele",
				"nya": "Chewa",
				"sna": "Shona",
				"sot": "Sotho",
				"toi": "Tonga",
				"tsn": "Tswana",
				"tso": "Tsonga",
				"ven": "Venda",
				"xho": "Xhosa",
				"zib": "Zimbabwean Sign Language"
			},
			"translations": {
				"deu": {
					"official": "Republik Simbabwe",
					"common": "Simbabwe"
				},
				"fra": {
					"official": "République du Zimbabwe",
					"common": "Zimbabwe"
				},
				"hrv": {
					"official": "Republika Zimbabve",
					"common": "Zimbabve"
				},
				"ita": {
					"official": "Repubblica dello Zimbabwe",
					"common": "Zimbabwe"
				},
				"jpn": {
					"official": "ジンバブエ共和国",
					"common": "ジンバブエ"
				},
				"nld": {
					"official": "Republiek Zimbabwe",
					"common": "Zimbabwe"
				},
				"por": {
					"official": "República do Zimbabwe",
					"common": "Zimbabwe"
				},
				"rus": {
					"official": "Республика Зимбабве",
					"common": "Зимбабве"
				},
				"slk": {
					"official": "Zimbabwianska republika",
					"common": "Zimbabwe"
				},
				"spa": {
					"official": "República de Zimbabue",
					"common": "Zimbabue"
				},
				"fin": {
					"official": "Zimbabwen tasavalta",
					"common": "Zimbabwe"
				},
				"zho": {
					"official": "津巴布韦共和国",
					"common": "津巴布韦"
				}
			},
			"latlng": [
				-20,
				30
			],
			"demonym": "Zimbabwean",
			"landlocked": true,
			"borders": [
				"BWA",
				"MOZ",
				"ZAF",
				"ZMB"
			],
			"area": 390757
		}
	];

/***/ },
/* 314 */
/***/ function(module, exports) {

	module.exports = [
		{
			"value": "1"
		},
		{
			"value": "2"
		},
		{
			"value": "3"
		},
		{
			"value": "4"
		}
	];

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(136),
	    baseLodash = __webpack_require__(331);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(136),
	    baseLodash = __webpack_require__(331);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var mapClear = __webpack_require__(886),
	    mapDelete = __webpack_require__(887),
	    mapGet = __webpack_require__(888),
	    mapHas = __webpack_require__(889),
	    mapSet = __webpack_require__(890);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function MapCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = values[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add functions to the `MapCache`.
	MapCache.prototype.clear = mapClear;
	MapCache.prototype['delete'] = mapDelete;
	MapCache.prototype.get = mapGet;
	MapCache.prototype.has = mapHas;
	MapCache.prototype.set = mapSet;
	
	module.exports = MapCache;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(317),
	    cachePush = __webpack_require__(856);
	
	/**
	 *
	 * Creates a set cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.push(values[index]);
	  }
	}
	
	// Add functions to the `SetCache`.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(138);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  return !!array.length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.includesWith` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(52);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the array-like object.
	 */
	function baseCastArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = baseCastArrayLikeObject;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(325),
	    createBaseEach = __webpack_require__(456);
	
	/**
	 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	module.exports = baseEachRight;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(457);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(433),
	    keys = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwnRight(object, iteratee) {
	  return object && baseForRight(object, iteratee, keys);
	}
	
	module.exports = baseForOwnRight;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    isFunction = __webpack_require__(67);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from `props`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the new array of filtered property names.
	 */
	function baseFunctions(object, props) {
	  return arrayFilter(props, function(key) {
	    return isFunction(object[key]);
	  });
	}
	
	module.exports = baseFunctions;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(112),
	    isKey = __webpack_require__(86);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 328 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return hasOwnProperty.call(object, key) ||
	    (typeof object == 'object' && key in object && getPrototypeOf(object) === null);
	}
	
	module.exports = baseHas;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(318),
	    arrayIncludes = __webpack_require__(319),
	    arrayIncludesWith = __webpack_require__(320),
	    arrayMap = __webpack_require__(45),
	    baseUnary = __webpack_require__(448),
	    cacheHas = __webpack_require__(339);
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    caches[othIndex] = !comparator && (iteratee || array.length >= 120)
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      length = array.length,
	      seen = caches[0];
	
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      var othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(189),
	    baseIsEqual = __webpack_require__(198);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack,
	          result = customizer ? customizer(objValue, srcValue, key, object, source, stack) : undefined;
	
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 331 */
/***/ function(module, exports) {

	/**
	 * The function whose prototype all chaining wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(189),
	    arrayEach = __webpack_require__(135),
	    assignMergeValue = __webpack_require__(424),
	    baseMergeDeep = __webpack_require__(848),
	    isArray = __webpack_require__(27),
	    isObject = __webpack_require__(46),
	    isTypedArray = __webpack_require__(165),
	    keysIn = __webpack_require__(68);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  var props = (isArray(source) || isTypedArray(source))
	    ? undefined
	    : keysIn(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	module.exports = baseMerge;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(192),
	    baseCastPath = __webpack_require__(112),
	    isIndex = __webpack_require__(114),
	    isKey = __webpack_require__(86),
	    isObject = __webpack_require__(46);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = path[index];
	    if (isObject(nested)) {
	      var newValue = value;
	      if (index != lastIndex) {
	        var objValue = nested[key];
	        newValue = customizer ? customizer(objValue, key, nested) : undefined;
	        if (newValue === undefined) {
	          newValue = objValue == null
	            ? (isIndex(path[index + 1]) ? [] : {})
	            : objValue;
	        }
	      }
	      assignValue(nested, key, newValue);
	    }
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 335 */
/***/ function(module, exports) {

	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295,
	    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeMin = Math.min;
	
	/**
	 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	 * which invokes `iteratee` for `value` and each element of `array` to compute
	 * their sort ranking. The iteratee is invoked with one argument; (value).
	 *
	 * @private
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function} iteratee The iteratee invoked per element.
	 * @param {boolean} [retHighest] Specify returning the highest qualified index.
	 * @returns {number} Returns the index at which `value` should be inserted into `array`.
	 */
	function baseSortedIndexBy(array, value, iteratee, retHighest) {
	  value = iteratee(value);
	
	  var low = 0,
	      high = array ? array.length : 0,
	      valIsNaN = value !== value,
	      valIsNull = value === null,
	      valIsUndef = value === undefined;
	
	  while (low < high) {
	    var mid = nativeFloor((low + high) / 2),
	        computed = iteratee(array[mid]),
	        isDef = computed !== undefined,
	        isReflexive = computed === computed;
	
	    if (valIsNaN) {
	      var setLow = isReflexive || retHighest;
	    } else if (valIsNull) {
	      setLow = isReflexive && isDef && (retHighest || computed != null);
	    } else if (valIsUndef) {
	      setLow = isReflexive && (retHighest || isDef);
	    } else if (computed == null) {
	      setLow = false;
	    } else {
	      setLow = retHighest ? (computed <= value) : (computed < value);
	    }
	    if (setLow) {
	      low = mid + 1;
	    } else {
	      high = mid;
	    }
	  }
	  return nativeMin(high, MAX_ARRAY_INDEX);
	}
	
	module.exports = baseSortedIndexBy;


/***/ },
/* 336 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(191),
	    baseDifference = __webpack_require__(137),
	    baseUniq = __webpack_require__(113);
	
	/**
	 * The base implementation of methods like `_.xor`, without support for
	 * iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 */
	function baseXor(arrays, iteratee, comparator) {
	  var index = -1,
	      length = arrays.length;
	
	  while (++index < length) {
	    var result = result
	      ? arrayPush(
	          baseDifference(result, arrays[index], iteratee, comparator),
	          baseDifference(arrays[index], result, iteratee, comparator)
	        )
	      : arrays[index];
	  }
	  return (result && result.length) ? baseUniq(result, iteratee, comparator) : [];
	}
	
	module.exports = baseXor;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(143);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Checks if `value` is in `cache`.
	 *
	 * @private
	 * @param {Object} cache The set cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function cacheHas(cache, value) {
	  var map = cache.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    return hash[value] === HASH_UNDEFINED;
	  }
	  return map.has(value);
	}
	
	module.exports = cacheHas;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(192);
	
	/**
	 * This function is like `copyObject` except that it accepts a function to
	 * customize copied values.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObjectWith(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObjectWith;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    arrayMap = __webpack_require__(45),
	    baseFlatten = __webpack_require__(43),
	    baseIteratee = __webpack_require__(17),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates a function like `_.over`.
	 *
	 * @private
	 * @param {Function} arrayFunc The function to iterate over iteratees.
	 * @returns {Function} Returns the new invoker function.
	 */
	function createOver(arrayFunc) {
	  return rest(function(iteratees) {
	    iteratees = arrayMap(baseFlatten(iteratees, 1), baseIteratee);
	    return rest(function(args) {
	      var thisArg = this;
	      return arrayFunc(iteratees, function(iteratee) {
	        return apply(iteratee, thisArg, args);
	      });
	    });
	  });
	}
	
	module.exports = createOver;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var repeat = __webpack_require__(500),
	    stringSize = __webpack_require__(207),
	    stringToArray = __webpack_require__(116),
	    toInteger = __webpack_require__(31);
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil;
	
	/**
	 * Creates the padding for `string` based on `length`. The `chars` string
	 * is truncated if the number of characters exceeds `length`.
	 *
	 * @private
	 * @param {string} string The string to create padding for.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padding for `string`.
	 */
	function createPadding(string, length, chars) {
	  length = toInteger(length);
	
	  var strLength = stringSize(string);
	  if (!length || strLength >= length) {
	    return '';
	  }
	  var padLength = length - strLength;
	  chars = chars === undefined ? ' ' : (chars + '');
	
	  var result = repeat(chars, nativeCeil(padLength / stringSize(chars)));
	  return reHasComplexSymbol.test(chars)
	    ? stringToArray(result).slice(0, padLength).join('')
	    : result.slice(0, padLength);
	}
	
	module.exports = createPadding;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31),
	    toNumber = __webpack_require__(145),
	    toString = __webpack_require__(34);
	
	/**
	 * Creates a function like `_.round`.
	 *
	 * @private
	 * @param {string} methodName The name of the `Math` method to use when rounding.
	 * @returns {Function} Returns the new round function.
	 */
	function createRound(methodName) {
	  var func = Math[methodName];
	  return function(number, precision) {
	    number = toNumber(number);
	    precision = toInteger(precision);
	    if (precision) {
	      // Shift with exponential notation to avoid floating-point issues.
	      // See [MDN](https://mdn.io/round#Examples) for more details.
	      var pair = (toString(number) + 'e').split('e'),
	          value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	      pair = (toString(value) + 'e').split('e');
	      return +(pair[0] + 'e' + (+pair[1] - precision));
	    }
	    return func(number);
	  };
	}
	
	module.exports = createRound;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(471),
	    noop = __webpack_require__(356);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(885),
	    toPairs = __webpack_require__(506);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = toPairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(67);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (isFunction(Ctor) && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to an array.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34),
	    upperFirst = __webpack_require__(510);
	
	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}
	
	module.exports = capitalize;


/***/ },
/* 349 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var getter = _.constant(object);
	 *
	 * getter() === object;
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(135),
	    baseCastFunction = __webpack_require__(111),
	    baseEach = __webpack_require__(84),
	    isArray = __webpack_require__(27);
	
	/**
	 * Iterates over elements of `collection` invoking `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length" property
	 * are iterated like arrays. To avoid this behavior use `_.forIn` or `_.forOwn`
	 * for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => logs `1` then `2`
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a' then 'b' (iteration order is not guaranteed)
	 */
	function forEach(collection, iteratee) {
	  return (typeof iteratee == 'function' && isArray(collection))
	    ? arrayEach(collection, iteratee)
	    : baseEach(collection, baseCastFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 351 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is greater than `other`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	 * @example
	 *
	 * _.gt(3, 1);
	 * // => true
	 *
	 * _.gt(3, 3);
	 * // => false
	 *
	 * _.gt(1, 3);
	 * // => false
	 */
	function gt(value, other) {
	  return value > other;
	}
	
	module.exports = gt;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var errorTag = '[object Error]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	 * `SyntaxError`, `TypeError`, or `URIError` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	 * @example
	 *
	 * _.isError(new Error);
	 * // => true
	 *
	 * _.isError(Error);
	 * // => false
	 */
	function isError(value) {
	  if (!isObjectLike(value)) {
	    return false;
	  }
	  return (objectToString.call(value) == errorTag) ||
	    (typeof value.message == 'string' && typeof value.name == 'string');
	}
	
	module.exports = isError;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var isHostObject = __webpack_require__(204),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototypeOf(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 354 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is less than `other`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	 * @example
	 *
	 * _.lt(1, 3);
	 * // => true
	 *
	 * _.lt(3, 3);
	 * // => false
	 *
	 * _.lt(3, 1);
	 * // => false
	 */
	function lt(value, other) {
	  return value < other;
	}
	
	module.exports = lt;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'add': __webpack_require__(904),
	  'ceil': __webpack_require__(913),
	  'floor': __webpack_require__(956),
	  'max': __webpack_require__(1010),
	  'maxBy': __webpack_require__(1011),
	  'mean': __webpack_require__(1012),
	  'min': __webpack_require__(1017),
	  'minBy': __webpack_require__(1018),
	  'round': __webpack_require__(1052),
	  'subtract': __webpack_require__(1074),
	  'sum': __webpack_require__(502),
	  'sumBy': __webpack_require__(1075)
	};


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    arrayMap = __webpack_require__(45),
	    baseProperty = __webpack_require__(333),
	    baseTimes = __webpack_require__(336),
	    isArrayLikeObject = __webpack_require__(52);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.zip` except that it accepts an array of grouped
	 * elements and creates an array regrouping the elements to their pre-zip
	 * configuration.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	 * // => [['fred', 30, true], ['barney', 40, false]]
	 *
	 * _.unzip(zipped);
	 * // => [['fred', 'barney'], [30, 40], [true, false]]
	 */
	function unzip(array) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var length = 0;
	  array = arrayFilter(array, function(group) {
	    if (isArrayLikeObject(group)) {
	      length = nativeMax(group.length, length);
	      return true;
	    }
	  });
	  return baseTimes(length, function(index) {
	    return arrayMap(array, baseProperty(index));
	  });
	}
	
	module.exports = unzip;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var EnhancedSwitch = __webpack_require__(360);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var CheckboxOutline = __webpack_require__(1158);
	var CheckboxChecked = __webpack_require__(1159);
	
	var Checkbox = React.createClass({
	  displayName: 'Checkbox',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    checked: React.PropTypes.bool,
	    checkedIcon: React.PropTypes.element,
	    defaultChecked: React.PropTypes.bool,
	    iconStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    onCheck: React.PropTypes.func,
	    unCheckedIcon: React.PropTypes.element
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      switched: this.props.checked || this.props.defaultChecked || this.props.valueLink && this.props.valueLink.value || false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.checkbox;
	  },
	
	  getStyles: function getStyles() {
	    var checkboxSize = 24;
	    var styles = {
	      icon: {
	        height: checkboxSize,
	        width: checkboxSize
	      },
	      check: {
	        position: 'absolute',
	        opacity: 0,
	        transform: 'scale(0)',
	        transitionOrigin: '50% 50%',
	        transition: Transitions.easeOut('450ms', 'opacity', '0ms') + ', ' + Transitions.easeOut('0ms', 'transform', '450ms'),
	        fill: this.getTheme().checkedColor
	      },
	      box: {
	        position: 'absolute',
	        opacity: 1,
	        fill: this.getTheme().boxColor,
	        transition: Transitions.easeOut('2s', null, '200ms')
	      },
	      checkWhenSwitched: {
	        opacity: 1,
	        transform: 'scale(1)',
	        transition: Transitions.easeOut('0ms', 'opacity', '0ms') + ', ' + Transitions.easeOut('800ms', 'transform', '0ms')
	      },
	      boxWhenSwitched: {
	        transition: Transitions.easeOut('100ms', null, '0ms'),
	        fill: this.getTheme().checkedColor
	      },
	      checkWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      boxWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var iconStyle = _props.iconStyle;
	    var onCheck = _props.onCheck;
	    var checkedIcon = _props.checkedIcon;
	    var unCheckedIcon = _props.unCheckedIcon;
	
	    var other = _objectWithoutProperties(_props, ['iconStyle', 'onCheck', 'checkedIcon', 'unCheckedIcon']);
	
	    var styles = this.getStyles();
	    var boxStyles = this.mergeAndPrefix(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	    var checkStyles = this.mergeAndPrefix(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	    var checkedElement = checkedIcon ? React.cloneElement(checkedIcon, {
	      style: this.mergeAndPrefix(checkStyles, checkedIcon.props.style)
	    }) : React.createElement(CheckboxChecked, {
	      style: checkStyles
	    });
	
	    var unCheckedElement = unCheckedIcon ? React.cloneElement(unCheckedIcon, {
	      style: this.mergeAndPrefix(boxStyles, unCheckedIcon.props.style)
	    }) : React.createElement(CheckboxOutline, {
	      style: boxStyles
	    });
	
	    var checkboxElement = React.createElement(
	      'div',
	      null,
	      unCheckedElement,
	      checkedElement
	    );
	
	    var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	    var mergedIconStyle = this.mergeAndPrefix(styles.icon, iconStyle);
	
	    var labelStyle = this.mergeAndPrefix(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: "enhancedSwitch",
	      inputType: "checkbox",
	      switched: this.state.switched,
	      switchElement: checkboxElement,
	      rippleColor: rippleColor,
	      iconStyle: mergedIconStyle,
	      onSwitch: this._handleCheck,
	      labelStyle: labelStyle,
	      onParentShouldUpdate: this._handleStateChange,
	      defaultSwitched: this.props.defaultChecked,
	      labelPosition: this.props.labelPosition ? this.props.labelPosition : "right"
	    };
	
	    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
	  },
	
	  isChecked: function isChecked() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	
	  setChecked: function setChecked(newCheckedValue) {
	    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	  },
	
	  _handleCheck: function _handleCheck(e, isInputChecked) {
	    if (this.props.onCheck) this.props.onCheck(e, isInputChecked);
	  },
	
	  _handleStateChange: function _handleStateChange(newSwitched) {
	    this.setState({ switched: newSwitched });
	  }
	
	});
	
	module.exports = Checkbox;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var WindowListenable = __webpack_require__(89);
	var CssEvent = __webpack_require__(170);
	var KeyCode = __webpack_require__(73);
	var Transitions = __webpack_require__(24);
	var StylePropable = __webpack_require__(6);
	var FlatButton = __webpack_require__(167);
	var Overlay = __webpack_require__(362);
	var Paper = __webpack_require__(55);
	
	var ReactTransitionGroup = React.addons.TransitionGroup;
	
	var TransitionItem = React.createClass({
	  displayName: 'TransitionItem',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      style: {}
	    };
	  },
	
	  componentWillEnter: function componentWillEnter(callback) {
	    var spacing = this.context.muiTheme.spacing;
	
	    this.setState({
	      style: {
	        opacity: 1,
	        transform: 'translate3d(0, ' + spacing.desktopKeylineIncrement + 'px, 0)'
	      }
	    });
	
	    setTimeout(callback, 450); // matches transition duration
	  },
	
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    this.setState({
	      style: {
	        opacity: 0,
	        transform: 'translate3d(0, 0, 0)'
	      }
	    });
	
	    setTimeout((function () {
	      if (_this.isMounted()) callback();
	    }).bind(this), 450); // matches transition duration
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(this.state.style, style) }),
	      this.props.children
	    );
	  }
	});
	
	var Dialog = React.createClass({
	  displayName: 'Dialog',
	
	  mixins: [WindowListenable, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    actions: React.PropTypes.array,
	    autoDetectWindowHeight: React.PropTypes.bool,
	    autoScrollBodyContent: React.PropTypes.bool,
	    bodyStyle: React.PropTypes.object,
	    contentClassName: React.PropTypes.string,
	    contentStyle: React.PropTypes.object,
	    modal: React.PropTypes.bool,
	    openImmediately: React.PropTypes.bool,
	    onClickAway: React.PropTypes.func,
	    onDismiss: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    repositionOnUpdate: React.PropTypes.bool,
	    title: React.PropTypes.node
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp',
	    resize: '_positionDialog'
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoDetectWindowHeight: false,
	      autoScrollBodyContent: false,
	      actions: [],
	      modal: false,
	      repositionOnUpdate: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: this.props.openImmediately || false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._positionDialog();
	    if (this.props.openImmediately) {
	      this.refs.dialogOverlay.preventScrolling();
	      this._onShow();
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._positionDialog();
	  },
	
	  getStyles: function getStyles() {
	    var spacing = this.context.muiTheme.spacing;
	
	    var main = {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      zIndex: 10,
	      top: 0,
	      left: -10000,
	      width: '100%',
	      height: '100%',
	      transition: Transitions.easeOut('0ms', 'left', '450ms')
	    };
	
	    var content = {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      transition: Transitions.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: 10
	    };
	
	    var body = {
	      padding: spacing.desktopGutter,
	      overflowY: this.props.autoScrollBodyContent ? 'auto' : 'hidden',
	      overflowX: 'hidden'
	    };
	
	    var gutter = spacing.desktopGutter + 'px ';
	    var title = {
	      margin: 0,
	      padding: gutter + gutter + '0 ' + gutter,
	      color: this.context.muiTheme.palette.textColor,
	      fontSize: 24,
	      lineHeight: '32px',
	      fontWeight: '400'
	    };
	
	    if (this.state.open) {
	      main = this.mergeAndPrefix(main, {
	        left: 0,
	        transition: Transitions.easeOut('0ms', 'left', '0ms')
	      });
	    }
	
	    return {
	      main: this.mergeAndPrefix(main, this.props.style),
	      content: this.mergeAndPrefix(content, this.props.contentStyle),
	      paper: {
	        background: this.context.muiTheme.canvasColor
	      },
	      body: this.mergeStyles(body, this.props.bodyStyle),
	      title: this.mergeStyles(title, this.props.titleStyle)
	    };
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var actions = this._getActionsContainer(this.props.actions);
	    var title = undefined;
	    if (this.props.title) {
	      // If the title is a string, wrap in an h3 tag.
	      // If not, just use it as a node.
	      title = Object.prototype.toString.call(this.props.title) === '[object String]' ? React.createElement(
	        'h3',
	        { style: styles.title },
	        this.props.title
	      ) : this.props.title;
	    }
	
	    return React.createElement(
	      'div',
	      { ref: 'container', style: styles.main },
	      React.createElement(
	        ReactTransitionGroup,
	        { component: 'div', ref: 'dialogWindow' },
	        this.state.open && React.createElement(
	          TransitionItem,
	          {
	            className: this.props.contentClassName,
	            style: styles.content },
	          React.createElement(
	            Paper,
	            {
	              style: styles.paper,
	              zDepth: 4 },
	            title,
	            React.createElement(
	              'div',
	              { ref: 'dialogContent', style: styles.body },
	              this.props.children
	            ),
	            actions
	          )
	        )
	      ),
	      React.createElement(Overlay, {
	        ref: 'dialogOverlay',
	        show: this.state.open,
	        autoLockScrolling: false,
	        onTouchTap: this._handleOverlayTouchTap })
	    );
	  },
	
	  isOpen: function isOpen() {
	    return this.state.open;
	  },
	
	  dismiss: function dismiss() {
	    var _this2 = this;
	
	    CssEvent.onTransitionEnd(this.getDOMNode(), (function () {
	      _this2.refs.dialogOverlay.allowScrolling();
	    }).bind(this));
	
	    this.setState({ open: false });
	    this._onDismiss();
	  },
	
	  show: function show() {
	    this.refs.dialogOverlay.preventScrolling();
	    this.setState({ open: true }, this._onShow);
	  },
	
	  _getAction: function _getAction(actionJSON, key) {
	    var _this3 = this;
	
	    var styles = { marginRight: 8 };
	    var props = {
	      key: key,
	      secondary: true,
	      onClick: actionJSON.onClick,
	      onTouchTap: function onTouchTap() {
	        if (actionJSON.onTouchTap) {
	          actionJSON.onTouchTap.call(undefined);
	        }
	        if (!(actionJSON.onClick || actionJSON.onTouchTap)) {
	          _this3.dismiss();
	        }
	      },
	      label: actionJSON.text,
	      style: styles
	    };
	    if (actionJSON.ref) {
	      props.ref = actionJSON.ref;
	      props.keyboardFocused = actionJSON.ref === this.props.actionFocus;
	    }
	
	    return React.createElement(FlatButton, props);
	  },
	
	  _getActionsContainer: function _getActionsContainer(actions) {
	    var actionContainer = undefined;
	    var actionObjects = [];
	    var actionStyle = {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      padding: 8,
	      marginBottom: 8,
	      width: '100%',
	      textAlign: 'right'
	    };
	
	    if (actions.length) {
	      for (var i = 0; i < actions.length; i++) {
	        var currentAction = actions[i];
	
	        //if the current action isn't a react object, create one
	        if (!React.isValidElement(currentAction)) {
	          currentAction = this._getAction(currentAction, i);
	        }
	
	        actionObjects.push(currentAction);
	      }
	
	      actionContainer = React.createElement(
	        'div',
	        { style: actionStyle },
	        actionObjects
	      );
	    }
	
	    return actionContainer;
	  },
	
	  _positionDialog: function _positionDialog() {
	    if (this.state.open) {
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = this.getDOMNode();
	      var dialogWindow = this.refs.dialogWindow.getDOMNode();
	      var dialogContent = this.refs.dialogContent.getDOMNode();
	      var minPaddingTop = 16;
	
	      //Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      //Vertically center the dialog window, but make sure it doesn't
	      //transition to that position.
	      if (this.props.repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (this.props.autoDetectWindowHeight || this.props.autoScrollBodyContent) {
	        var styles = this.getStyles();
	        var maxDialogContentHeight = clientHeight - 2 * (styles.body.padding + 64);
	
	        if (this.props.title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	        if (this.props.actions) maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  },
	
	  _onShow: function _onShow() {
	    if (this.props.onShow) this.props.onShow();
	  },
	
	  _onDismiss: function _onDismiss() {
	    if (this.props.onDismiss) this.props.onDismiss();
	  },
	
	  _handleOverlayTouchTap: function _handleOverlayTouchTap(e) {
	    if (this.props.modal) {
	      e.stopPropagation();
	    } else {
	      this.dismiss();
	      if (this.props.onClickAway) this.props.onClickAway();
	    }
	  },
	
	  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
	    if (e.keyCode === KeyCode.ESC && !this.props.modal) {
	      this.dismiss();
	    }
	  }
	
	});
	
	module.exports = Dialog;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var KeyCode = __webpack_require__(73);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var UniqueId = __webpack_require__(370);
	var WindowListenable = __webpack_require__(89);
	var ClearFix = __webpack_require__(166);
	var FocusRipple = __webpack_require__(211);
	var TouchRipple = __webpack_require__(363);
	var Paper = __webpack_require__(55);
	
	var EnhancedSwitch = React.createClass({
	  displayName: 'EnhancedSwitch',
	
	  mixins: [WindowListenable, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    id: React.PropTypes.string,
	    inputType: React.PropTypes.string.isRequired,
	    switchElement: React.PropTypes.element.isRequired,
	    onParentShouldUpdate: React.PropTypes.func.isRequired,
	    switched: React.PropTypes.bool.isRequired,
	    rippleStyle: React.PropTypes.object,
	    rippleColor: React.PropTypes.string,
	    iconStyle: React.PropTypes.object,
	    thumbStyle: React.PropTypes.object,
	    trackStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    name: React.PropTypes.string,
	    value: React.PropTypes.string,
	    label: React.PropTypes.string,
	    onSwitch: React.PropTypes.func,
	    required: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    defaultSwitched: React.PropTypes.bool,
	    labelPosition: React.PropTypes.oneOf(['left', 'right']),
	    disableFocusRipple: React.PropTypes.bool,
	    disableTouchRipple: React.PropTypes.bool
	  },
	
	  windowListeners: {
	    keydown: '_handleWindowKeydown',
	    keyup: '_handleWindowKeyup'
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isKeyboardFocused: false,
	      parentWidth: 100
	    };
	  },
	
	  getEvenWidth: function getEvenWidth() {
	    return parseInt(window.getComputedStyle(React.findDOMNode(this.refs.root)).getPropertyValue('width'), 10);
	  },
	
	  componentDidMount: function componentDidMount() {
	    var inputNode = React.findDOMNode(this.refs.checkbox);
	    if (!this.props.switched || inputNode.checked !== this.props.switched) {
	      this.props.onParentShouldUpdate(inputNode.checked);
	    }
	
	    window.addEventListener("resize", this._handleResize);
	
	    this._handleResize();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener("resize", this._handleResize);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var hasCheckedLinkProp = nextProps.hasOwnProperty('checkedLink');
	    var hasCheckedProp = nextProps.hasOwnProperty('checked');
	    var hasToggledProp = nextProps.hasOwnProperty('toggled');
	    var hasNewDefaultProp = nextProps.hasOwnProperty('defaultSwitched') && nextProps.defaultSwitched !== this.props.defaultSwitched;
	    var newState = {};
	
	    if (hasCheckedProp) {
	      newState.switched = nextProps.checked;
	    } else if (hasToggledProp) {
	      newState.switched = nextProps.toggled;
	    } else if (hasCheckedLinkProp) {
	      newState.switched = nextProps.checkedLink.value;
	    } else if (hasNewDefaultProp) {
	      newState.switched = nextProps.defaultSwitched;
	    }
	
	    if (newState.switched !== undefined && newState.switched !== this.props.switched) {
	      this.props.onParentShouldUpdate(newState.switched);
	    }
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.palette;
	  },
	
	  getStyles: function getStyles() {
	    var spacing = this.context.muiTheme.spacing;
	    var switchWidth = 60 - spacing.desktopGutterLess;
	    var labelWidth = 'calc(100% - 60px)';
	    var styles = {
	      root: {
	        position: 'relative',
	        cursor: this.props.disabled ? 'default' : 'pointer',
	        overflow: 'visible',
	        display: 'table',
	        height: 'auto',
	        width: '100%'
	      },
	      input: {
	        position: 'absolute',
	        cursor: this.props.disabled ? 'default' : 'pointer',
	        pointerEvents: 'all',
	        opacity: 0,
	        width: '100%',
	        height: '100%',
	        zIndex: 2,
	        left: 0,
	        boxSizing: 'border-box',
	        padding: 0,
	        margin: 0
	      },
	      controls: {
	        width: '100%',
	        height: '100%'
	      },
	      label: {
	        float: 'left',
	        position: 'relative',
	        display: 'block',
	        width: labelWidth,
	        lineHeight: '24px',
	        color: this.getTheme().textColor
	      },
	      wrap: {
	        transition: Transitions.easeOut(),
	        float: 'left',
	        position: 'relative',
	        display: 'block',
	        width: switchWidth,
	        marginRight: this.props.labelPosition === 'right' ? spacing.desktopGutterLess : 0,
	        marginLeft: this.props.labelPosition === 'left' ? spacing.desktopGutterLess : 0
	      },
	      ripple: {
	        height: '200%',
	        width: '200%',
	        top: -12,
	        left: -12
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var type = _props.type;
	    var name = _props.name;
	    var value = _props.value;
	    var label = _props.label;
	    var onSwitch = _props.onSwitch;
	    var defaultSwitched = _props.defaultSwitched;
	    var onBlur = _props.onBlur;
	    var onFocus = _props.onFocus;
	    var onMouseUp = _props.onMouseUp;
	    var onMouseDown = _props.onMouseDown;
	    var onMouseLeave = _props.onMouseLeave;
	    var onTouchStart = _props.onTouchStart;
	    var onTouchEnd = _props.onTouchEnd;
	    var disableTouchRipple = _props.disableTouchRipple;
	    var disableFocusRipple = _props.disableFocusRipple;
	    var className = _props.className;
	
	    var other = _objectWithoutProperties(_props, ['type', 'name', 'value', 'label', 'onSwitch', 'defaultSwitched', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'disableTouchRipple', 'disableFocusRipple', 'className']);
	
	    var styles = this.getStyles();
	    var wrapStyles = this.mergeAndPrefix(styles.wrap, this.props.iconStyle);
	    var rippleStyle = this.mergeAndPrefix(styles.ripple, this.props.rippleStyle);
	    var rippleColor = this.props.hasOwnProperty('rippleColor') ? this.props.rippleColor : this.getTheme().primary1Color;
	
	    if (this.props.thumbStyle) {
	      wrapStyles.marginLeft /= 2;
	      wrapStyles.marginRight /= 2;
	    }
	
	    var inputId = this.props.id || UniqueId.generate();
	
	    var labelStyle = this.mergeAndPrefix(styles.label, this.props.labelStyle);
	    var labelElement = this.props.label ? React.createElement(
	      'label',
	      { style: labelStyle, htmlFor: inputId },
	      this.props.label
	    ) : null;
	
	    var inputProps = {
	      ref: "checkbox",
	      type: this.props.inputType,
	      style: this.mergeAndPrefix(styles.input),
	      name: this.props.name,
	      value: this.props.value,
	      defaultChecked: this.props.defaultSwitched,
	      onBlur: this._handleBlur,
	      onFocus: this._handleFocus
	    };
	
	    var hideTouchRipple = this.props.disabled || disableTouchRipple;
	
	    if (!hideTouchRipple) {
	      inputProps.onMouseUp = this._handleMouseUp;
	      inputProps.onMouseDown = this._handleMouseDown;
	      inputProps.onMouseLeave = this._handleMouseLeave;
	      inputProps.onTouchStart = this._handleTouchStart;
	      inputProps.onTouchEnd = this._handleTouchEnd;
	    }
	
	    if (!this.props.hasOwnProperty('checkedLink')) {
	      inputProps.onChange = this._handleChange;
	    }
	
	    var inputElement = React.createElement('input', _extends({}, other, inputProps));
	
	    var touchRipple = React.createElement(TouchRipple, {
	      ref: 'touchRipple',
	      key: 'touchRipple',
	      style: rippleStyle,
	      color: rippleColor,
	      centerRipple: true });
	
	    var focusRipple = React.createElement(FocusRipple, {
	      key: 'focusRipple',
	      innerStyle: rippleStyle,
	      color: rippleColor,
	      show: this.state.isKeyboardFocused });
	
	    var ripples = [hideTouchRipple ? null : touchRipple, this.props.disabled || disableFocusRipple ? null : focusRipple];
	
	    // If toggle component (indicated by whether the style includes thumb) manually lay out
	    // elements in order to nest ripple elements
	    var switchElement = !this.props.thumbStyle ? React.createElement(
	      'div',
	      { style: wrapStyles },
	      this.props.switchElement,
	      ripples
	    ) : React.createElement(
	      'div',
	      { style: wrapStyles },
	      React.createElement('div', { style: this.props.trackStyle }),
	      React.createElement(
	        Paper,
	        { style: this.props.thumbStyle, zDepth: 1, circle: true },
	        ' ',
	        ripples,
	        ' '
	      )
	    );
	
	    var labelPositionExist = this.props.labelPosition;
	
	    // Position is left if not defined or invalid.
	    var elementsInOrder = labelPositionExist && this.props.labelPosition.toUpperCase() === "RIGHT" ? React.createElement(
	      ClearFix,
	      { style: this.mergeAndPrefix(styles.controls) },
	      switchElement,
	      labelElement
	    ) : React.createElement(
	      ClearFix,
	      { style: this.mergeAndPrefix(styles.controls) },
	      labelElement,
	      switchElement
	    );
	
	    return React.createElement(
	      'div',
	      { ref: 'root', className: className, style: this.mergeAndPrefix(styles.root, this.props.style) },
	      inputElement,
	      elementsInOrder
	    );
	  },
	
	  isSwitched: function isSwitched() {
	    return React.findDOMNode(this.refs.checkbox).checked;
	  },
	
	  // no callback here because there is no event
	  setSwitched: function setSwitched(newSwitchedValue) {
	    if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	      this.props.onParentShouldUpdate(newSwitchedValue);
	      React.findDOMNode(this.refs.checkbox).checked = newSwitchedValue;
	    } else if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	      var message = 'Cannot call set method while checked is defined as a property.';
	      console.error(message);
	    }
	  },
	
	  getValue: function getValue() {
	    return React.findDOMNode(this.refs.checkbox).value;
	  },
	
	  isKeyboardFocused: function isKeyboardFocused() {
	    return this.state.isKeyboardFocused;
	  },
	
	  _handleChange: function _handleChange(e) {
	    this._tabPressed = false;
	    this.setState({
	      isKeyboardFocused: false
	    });
	
	    var isInputChecked = React.findDOMNode(this.refs.checkbox).checked;
	
	    if (!this.props.hasOwnProperty('checked')) {
	      this.props.onParentShouldUpdate(isInputChecked);
	    }
	    if (this.props.onSwitch) {
	      this.props.onSwitch(e, isInputChecked);
	    }
	  },
	
	  // Checkbox inputs only use SPACE to change their state. Using ENTER will
	  // update the ui but not the input.
	  _handleWindowKeydown: function _handleWindowKeydown(e) {
	    if (e.keyCode === KeyCode.TAB) {
	      this._tabPressed = true;
	    }
	    if (e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
	      this._handleChange(e);
	    }
	  },
	
	  _handleWindowKeyup: function _handleWindowKeyup(e) {
	    if (e.keyCode === KeyCode.SPACE && this.state.isKeyboardFocused) {
	      this._handleChange(e);
	    }
	  },
	
	  /**
	   * Because both the ripples and the checkbox input cannot share pointer
	   * events, the checkbox input takes control of pointer events and calls
	   * ripple animations manually.
	   */
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.refs.touchRipple.start(e);
	    }
	  },
	
	  _handleMouseUp: function _handleMouseUp() {
	    this.refs.touchRipple.end();
	  },
	
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.refs.touchRipple.end();
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.refs.touchRipple.start(e);
	  },
	
	  _handleTouchEnd: function _handleTouchEnd() {
	    this.refs.touchRipple.end();
	  },
	
	  _handleBlur: function _handleBlur(e) {
	    this.setState({
	      isKeyboardFocused: false
	    });
	
	    if (this.props.onBlur) {
	      this.props.onBlur(e);
	    }
	  },
	
	  _handleFocus: function _handleFocus(e) {
	    var _this = this;
	
	    //setTimeout is needed becuase the focus event fires first
	    //Wait so that we can capture if this was a keyboard focus
	    //or touch focus
	    setTimeout(function () {
	      if (_this._tabPressed) {
	        _this.setState({
	          isKeyboardFocused: true
	        });
	      }
	    }, 150);
	
	    if (this.props.onFocus) {
	      this.props.onFocus(e);
	    }
	  },
	
	  _handleResize: function _handleResize() {
	    this.setState({ parentWidth: this.getEvenWidth() });
	  }
	
	});
	
	module.exports = EnhancedSwitch;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var PropTypes = __webpack_require__(171);
	var StylePropable = __webpack_require__(6);
	var Typography = __webpack_require__(119);
	var Paper = __webpack_require__(55);
	
	var List = React.createClass({
	  displayName: 'List',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    insetSubheader: React.PropTypes.bool,
	    subheader: React.PropTypes.string,
	    subheaderStyle: React.PropTypes.object,
	    zDepth: PropTypes.zDepth
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      zDepth: 0
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var insetSubheader = _props.insetSubheader;
	    var style = _props.style;
	    var subheader = _props.subheader;
	    var subheaderStyle = _props.subheaderStyle;
	    var zDepth = _props.zDepth;
	
	    var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);
	
	    var styles = {
	      root: {
	        padding: 0,
	        paddingBottom: 8,
	        paddingTop: subheader ? 0 : 8
	      },
	
	      subheader: {
	        color: Typography.textLightBlack,
	        fontSize: 14,
	        fontWeight: Typography.fontWeightMedium,
	        lineHeight: '48px',
	        paddingLeft: insetSubheader ? 72 : 16
	      }
	    };
	
	    var subheaderElement = undefined;
	    if (subheader) {
	      var mergedSubheaderStyles = this.mergeAndPrefix(styles.subheader, subheaderStyle);
	      subheaderElement = React.createElement(
	        'div',
	        { style: mergedSubheaderStyles },
	        subheader
	      );
	    }
	
	    return React.createElement(
	      Paper,
	      _extends({}, other, {
	        style: this.mergeStyles(styles.root, style),
	        zDepth: zDepth }),
	      subheaderElement,
	      children
	    );
	  }
	});
	
	module.exports = List;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var Colors = __webpack_require__(56);
	
	var Overlay = React.createClass({
	  displayName: 'Overlay',
	
	  _originalBodyOverflow: '',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    autoLockScrolling: React.PropTypes.bool,
	    show: React.PropTypes.bool,
	    transitionEnabled: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoLockScrolling: true,
	      transitionEnabled: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._originalBodyOverflow = document.getElementsByTagName('body')[0].style.oveflow;
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.autoLockScrolling) {
	      if (this.props.show) {
	        this._preventScrolling();
	      } else {
	        this._allowScrolling();
	      }
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._allowScrolling();
	  },
	
	  setOpacity: function setOpacity(opacity) {
	    var overlay = React.findDOMNode(this);
	    overlay.style.opacity = opacity;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        position: 'fixed',
	        height: '100%',
	        width: '100%',
	        zIndex: 9,
	        top: 0,
	        left: '-100%',
	        opacity: 0,
	        backgroundColor: Colors.lightBlack,
	        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
	
	        // Two ways to promote overlay to its own render layer
	        willChange: 'opacity',
	        transform: 'translateZ(0)',
	
	        transition: this.props.transitionEnabled && Transitions.easeOut('0ms', 'left', '400ms') + ',' + Transitions.easeOut('400ms', 'opacity')
	      },
	      rootWhenShown: {
	        left: '0',
	        opacity: 1,
	        transition: this.props.transitionEnabled && Transitions.easeOut('0ms', 'left') + ',' + Transitions.easeOut('400ms', 'opacity')
	      }
	    };
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var show = _props.show;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['show', 'style']);
	
	    var styles = this.mergeAndPrefix(this.getStyles().root, this.props.style, this.props.show && this.getStyles().rootWhenShown);
	
	    return React.createElement('div', _extends({}, other, { style: styles }));
	  },
	
	  preventScrolling: function preventScrolling() {
	    if (!this.props.autoLockScrolling) this._preventScrolling();
	  },
	
	  allowScrolling: function allowScrolling() {
	    if (!this.props.autoLockScrolling) this._allowScrolling();
	  },
	
	  _preventScrolling: function _preventScrolling() {
	    var body = document.getElementsByTagName('body')[0];
	    body.style.overflow = 'hidden';
	  },
	
	  _allowScrolling: function _allowScrolling() {
	    var body = document.getElementsByTagName('body')[0];
	    body.style.overflow = this._originalBodyOverflow || '';
	  }
	
	});
	
	module.exports = Overlay;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var ReactTransitionGroup = React.addons.TransitionGroup;
	var StylePropable = __webpack_require__(6);
	var Dom = __webpack_require__(367);
	var ImmutabilityHelper = __webpack_require__(147);
	var CircleRipple = __webpack_require__(526);
	
	var TouchRipple = React.createClass({
	  displayName: 'TouchRipple',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  propTypes: {
	    centerRipple: React.PropTypes.bool,
	    color: React.PropTypes.string,
	    opacity: React.PropTypes.number
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      //This prop allows us to only render the ReactTransitionGroup
	      //on the first click of the component, making the inital
	      //render faster
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var style = _props.style;
	    var _state = this.state;
	    var hasRipples = _state.hasRipples;
	    var ripples = _state.ripples;
	
	    var rippleGroup = undefined;
	    if (hasRipples) {
	      var mergedStyles = this.mergeAndPrefix({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        overflow: 'hidden'
	      }, style);
	
	      rippleGroup = React.createElement(
	        ReactTransitionGroup,
	        { style: mergedStyles },
	        ripples
	      );
	    }
	
	    return React.createElement(
	      'div',
	      {
	        onMouseUp: this._handleMouseUp,
	        onMouseDown: this._handleMouseDown,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchStart: this._handleTouchStart,
	        onTouchEnd: this._handleTouchEnd },
	      rippleGroup,
	      children
	    );
	  },
	
	  start: function start(e, isRippleTouchGenerated) {
	    var ripples = this.state.ripples;
	
	    //Do nothing if we're starting a click-event-generated ripple
	    //while having touch-generated ripples
	    if (!isRippleTouchGenerated) {
	      for (var i = 0; i < ripples.length; i++) {
	        if (ripples[i].props.touchGenerated) return;
	      }
	    }
	
	    //Add a ripple to the ripples array
	    ripples = ImmutabilityHelper.push(ripples, React.createElement(CircleRipple, {
	      key: this.state.nextKey,
	      style: !this.props.centerRipple ? this._getRippleStyle(e) : {},
	      color: this.props.color,
	      opacity: this.props.opacity,
	      touchGenerated: isRippleTouchGenerated }));
	
	    this.setState({
	      hasRipples: true,
	      nextKey: this.state.nextKey + 1,
	      ripples: ripples
	    });
	  },
	
	  end: function end() {
	    var currentRipples = this.state.ripples;
	    this.setState({
	      ripples: ImmutabilityHelper.shift(currentRipples)
	    });
	  },
	
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) this.start(e, false);
	  },
	
	  _handleMouseUp: function _handleMouseUp() {
	    this.end();
	  },
	
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.end();
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.start(e, true);
	  },
	
	  _handleTouchEnd: function _handleTouchEnd() {
	    this.end();
	  },
	
	  _getRippleStyle: function _getRippleStyle(e) {
	    var style = {};
	    var el = React.findDOMNode(this);
	    var elHeight = el.offsetHeight;
	    var elWidth = el.offsetWidth;
	    var offset = Dom.offset(el);
	    var isTouchEvent = e.touches && e.touches.length;
	    var pageX = isTouchEvent ? e.touches[0].pageX : e.pageX;
	    var pageY = isTouchEvent ? e.touches[0].pageY : e.pageY;
	    var pointerX = pageX - offset.left;
	    var pointerY = pageY - offset.top;
	    var topLeftDiag = this._calcDiag(pointerX, pointerY);
	    var topRightDiag = this._calcDiag(elWidth - pointerX, pointerY);
	    var botRightDiag = this._calcDiag(elWidth - pointerX, elHeight - pointerY);
	    var botLeftDiag = this._calcDiag(pointerX, elHeight - pointerY);
	    var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	    var rippleSize = rippleRadius * 2;
	    var left = pointerX - rippleRadius;
	    var top = pointerY - rippleRadius;
	
	    style.height = rippleSize + 'px';
	    style.width = rippleSize + 'px';
	    style.top = top + 'px';
	    style.left = left + 'px';
	
	    return style;
	  },
	
	  _calcDiag: function _calcDiag(a, b) {
	    return Math.sqrt(a * a + b * b);
	  }
	
	});
	
	module.exports = TouchRipple;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var TableRowColumn = React.createClass({
	  displayName: 'TableRowColumn',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    columnNumber: React.PropTypes.number,
	    hoverable: React.PropTypes.bool,
	    onClick: React.PropTypes.func,
	    onHover: React.PropTypes.func,
	    onHoverExit: React.PropTypes.func,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hoverable: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.tableRowColumn;
	  },
	
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var styles = {
	      root: {
	        paddingLeft: theme.spacing,
	        paddingRight: theme.spacing,
	        height: theme.height,
	        textAlign: 'left',
	        fontSize: 13,
	        overflow: 'hidden',
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis'
	      }
	    };
	
	    if (React.Children.count(this.props.children) === 1 && !isNaN(this.props.children)) {
	      styles.textAlign = 'right';
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var columnNumber = _props.columnNumber;
	    var hoverable = _props.hoverable;
	    var onClick = _props.onClick;
	    var onHover = _props.onHover;
	    var onHoverExit = _props.onHoverExit;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	
	    var styles = this.getStyles();
	    var handlers = {
	      onClick: this._onClick,
	      onMouseEnter: this._onMouseEnter,
	      onMouseLeave: this._onMouseLeave
	    };
	    var classes = 'mui-table-row-column';
	    if (className) classes += ' ' + className;
	
	    return React.createElement(
	      'td',
	      _extends({
	        key: this.props.key,
	        className: classes,
	        style: this.mergeAndPrefix(styles.root, style)
	      }, handlers, other),
	      this.props.children
	    );
	  },
	
	  _onClick: function _onClick(e) {
	    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
	  },
	
	  _onMouseEnter: function _onMouseEnter(e) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: true });
	      if (this.props.onHover) this.props.onHover(e, this.props.columnNumber);
	    }
	  },
	
	  _onMouseLeave: function _onMouseLeave(e) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: false });
	      if (this.props.onHoverExit) this.props.onHoverExit(e, this.props.columnNumber);
	    }
	  }
	
	});
	
	module.exports = TableRowColumn;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var Colors = __webpack_require__(56);
	
	var Tooltip = React.createClass({
	  displayName: 'Tooltip',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    label: React.PropTypes.string.isRequired,
	    show: React.PropTypes.bool,
	    touch: React.PropTypes.bool,
	    verticalPosition: React.PropTypes.oneOf(['top', 'bottom']),
	    horizontalPosition: React.PropTypes.oneOf(['left', 'right', 'center'])
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._setRippleSize();
	    this._setTooltipPosition();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps() {
	    this._setTooltipPosition();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._setRippleSize();
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      offsetWidth: null
	    };
	  },
	
	  getStyles: function getStyles() {
	    var verticalPosition = this.props.verticalPosition;
	    var horizontalPosition = this.props.horizontalPosition;
	    var touchMarginOffset = this.props.touch ? 10 : 0;
	    var touchOffsetTop = this.props.touch ? -20 : -10;
	    var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	    var styles = {
	      root: {
	        position: 'absolute',
	        fontFamily: this.context.muiTheme.contentFontFamily,
	        fontSize: '10px',
	        lineHeight: '22px',
	        padding: '0 8px',
	        color: Colors.white,
	        overflow: 'hidden',
	        top: -10000,
	        borderRadius: 2,
	        userSelect: 'none',
	        opacity: 0,
	        right: horizontalPosition === 'left' ? 12 : null,
	        left: horizontalPosition === 'center' ? (this.state.offsetWidth - 48) / 2 * -1 : null,
	        transition: Transitions.easeOut('0ms', 'top', '450ms') + ',' + Transitions.easeOut('450ms', 'transform', '0ms') + ',' + Transitions.easeOut('450ms', 'opacity', '0ms')
	      },
	      label: {
	        position: 'relative',
	        whiteSpace: 'nowrap'
	      },
	      ripple: {
	        position: 'absolute',
	        left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	        top: verticalPosition === 'bottom' ? 0 : '100%',
	        transform: 'translate(-50%, -50%)',
	        borderRadius: '50%',
	        backgroundColor: 'transparent',
	        transition: Transitions.easeOut('0ms', 'width', '450ms') + ',' + Transitions.easeOut('0ms', 'height', '450ms') + ',' + Transitions.easeOut('450ms', 'backgroundColor', '0ms')
	      },
	      rootWhenShown: {
	        top: verticalPosition === 'top' ? touchOffsetTop : 36,
	        opacity: 0.9,
	        transform: 'translate3d(0px, ' + offset + 'px, 0px)',
	        transition: Transitions.easeOut('0ms', 'top', '0ms') + ',' + Transitions.easeOut('450ms', 'transform', '0ms') + ',' + Transitions.easeOut('450ms', 'opacity', '0ms')
	      },
	      rootWhenTouched: {
	        fontSize: '14px',
	        lineHeight: '32px',
	        padding: '0 16px'
	      },
	      rippleWhenShown: {
	        backgroundColor: Colors.grey700,
	        transition: Transitions.easeOut('450ms', 'width', '0ms') + ',' + Transitions.easeOut('450ms', 'height', '0ms') + ',' + Transitions.easeOut('450ms', 'backgroundColor', '0ms')
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	
	    var other = _objectWithoutProperties(_props, ['label']);
	
	    var styles = this.getStyles();
	    return React.createElement(
	      'div',
	      _extends({}, other, {
	        style: this.mergeAndPrefix(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style) }),
	      React.createElement('div', {
	        ref: 'ripple',
	        style: this.mergeAndPrefix(styles.ripple, this.props.show && styles.rippleWhenShown) }),
	      React.createElement(
	        'span',
	        { style: this.mergeAndPrefix(styles.label) },
	        this.props.label
	      )
	    );
	  },
	
	  _setRippleSize: function _setRippleSize() {
	    var ripple = React.findDOMNode(this.refs.ripple);
	    var tooltip = window.getComputedStyle(React.findDOMNode(this));
	    var tooltipWidth = parseInt(tooltip.getPropertyValue("width"), 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	    var tooltipHeight = parseInt(tooltip.getPropertyValue("height"), 10);
	
	    var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	    if (this.props.show) {
	      ripple.style.height = rippleDiameter + 'px';
	      ripple.style.width = rippleDiameter + 'px';
	    } else {
	      ripple.style.width = '0px';
	      ripple.style.height = '0px';
	    }
	  },
	
	  _setTooltipPosition: function _setTooltipPosition() {
	    var tooltip = React.findDOMNode(this);
	    this.setState({ offsetWidth: tooltip.offsetWidth });
	  }
	
	});
	
	module.exports = Tooltip;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var ReactTransitionGroup = React.addons.TransitionGroup;
	var StylePropable = __webpack_require__(6);
	var SlideInChild = __webpack_require__(1183);
	
	var SlideIn = React.createClass({
	  displayName: 'SlideIn',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    enterDelay: React.PropTypes.number,
	    childStyle: React.PropTypes.object,
	    direction: React.PropTypes.oneOf(['left', 'right', 'up', 'down'])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0,
	      direction: 'left'
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var enterDelay = _props.enterDelay;
	    var children = _props.children;
	    var childStyle = _props.childStyle;
	    var direction = _props.direction;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	
	    var mergedRootStyles = this.mergeAndPrefix({
	      position: 'relative',
	      overflow: 'hidden',
	      height: '100%'
	    }, style);
	
	    var newChildren = React.Children.map(children, function (child) {
	      return React.createElement(
	        SlideInChild,
	        {
	          key: child.key,
	          direction: direction,
	          enterDelay: enterDelay,
	          getLeaveDirection: _this._getLeaveDirection,
	          style: childStyle },
	        child
	      );
	    }, this);
	
	    return React.createElement(
	      ReactTransitionGroup,
	      _extends({}, other, {
	        style: mergedRootStyles,
	        component: 'div' }),
	      newChildren
	    );
	  },
	
	  _getLeaveDirection: function _getLeaveDirection() {
	    return this.props.direction;
	  }
	
	});
	
	module.exports = SlideIn;

/***/ },
/* 367 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  },
	
	  getStyleAttributeAsNumber: function getStyleAttributeAsNumber(el, attr) {
	    var attrStyle = el.style[attr];
	    var attrNum = 0;
	    if (attrStyle && attrStyle.length) {
	      attrNum = parseInt(attrStyle);
	    }
	
	    return attrNum;
	  },
	
	  addClass: function addClass(el, className) {
	    if (el.classList) el.classList.add(className);else el.className += ' ' + className;
	  },
	
	  removeClass: function removeClass(el, className) {
	    if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	  },
	
	  hasClass: function hasClass(el, className) {
	    if (el.classList) return el.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	  },
	
	  toggleClass: function toggleClass(el, className) {
	    if (this.hasClass(el, className)) this.removeClass(el, className);else this.addClass(el, className);
	  },
	
	  forceRedraw: function forceRedraw(el) {
	    var originalDisplay = el.style.display;
	
	    el.style.display = 'none';
	    el.style.display = originalDisplay;
	  },
	
	  withoutTransition: function withoutTransition(el, callback) {
	    var originalTransition = el.style.transition;
	
	    //turn off transition
	    el.style.transition = null;
	
	    callback();
	
	    //force a redraw
	    this.forceRedraw(el);
	
	    //put the transition back
	    el.style.transition = originalTransition;
	  }
	
	};

/***/ },
/* 368 */
/***/ function(module, exports) {

	'use strict';
	
	function isObject(obj) {
	  return typeof obj === 'object' && obj !== null;
	}
	
	/**
	*  A recursive merge between two objects.
	*
	*  @param base     - the object whose properties are to be overwritten. It
	*                    should be either the root level or some nested level.
	*  @param override - an object containing properties to be overwritten. It
	*                    should have the same structure as the object object.
	*/
	var extend = function extend(base, override) {
	
	  var mergedObject = {};
	
	  //Loop through each key in the base object
	  Object.keys(base).forEach(function (key) {
	
	    var baseProp = base[key];
	    var overrideProp = undefined;
	
	    if (isObject(override)) overrideProp = override[key];
	
	    //Recursive call extend if the prop is another object, else just copy it over
	    mergedObject[key] = isObject(baseProp) && !Array.isArray(baseProp) ? extend(baseProp, overrideProp) : baseProp;
	  });
	
	  //Loop through each override key and override the props in the
	  //base object
	  if (isObject(override)) {
	
	    Object.keys(override).forEach(function (overrideKey) {
	
	      var overrideProp = override[overrideKey];
	
	      //Only copy over props that are not objects
	      if (!isObject(overrideProp) || Array.isArray(overrideProp)) {
	        mergedObject[overrideKey] = overrideProp;
	      }
	    });
	  }
	
	  return mergedObject;
	};
	
	module.exports = extend;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var AutoPrefix = __webpack_require__(63);
	var ImmutabilityHelper = __webpack_require__(147);
	
	module.exports = {
	
	  mergeAndPrefix: function mergeAndPrefix() {
	    var mergedStyles = ImmutabilityHelper.merge.apply(this, arguments);
	    return AutoPrefix.all(mergedStyles);
	  }
	
	};

/***/ },
/* 370 */
/***/ function(module, exports) {

	"use strict";
	
	var index = 0;
	
	module.exports = {
	  generate: function generate() {
	    return "mui-id-" + index++;
	  }
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var deepEqual = __webpack_require__(805);
	
	// Like PureRenderMixin, but with deep comparisons.
	var PureDeepRenderMixin = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return !deepEqual(this.props, nextProps) || !deepEqual(this.state, nextState);
	  }
	};
	
	module.exports = PureDeepRenderMixin;

/***/ },
/* 372 */
/***/ function(module, exports) {

	var CONSTANTS = {
	
	  // Positions
	  positions: {
	    tl: 'tl',
	    tr: 'tr',
	    tc: 'tc',
	    bl: 'bl',
	    br: 'br',
	    bc: 'bc'
	  },
	
	  // Levels
	  levels: {
	    success: 'success',
	    error: 'error',
	    warning: 'warning',
	    info: 'info'
	  },
	
	  // Notification defaults
	  notification: {
	    title: null,
	    message: null,
	    level: null,
	    position: 'tr',
	    autoDismiss: 5,
	    dismissible: true,
	    action: null
	  }
	};
	
	
	module.exports = CONSTANTS;


/***/ },
/* 373 */
/***/ function(module, exports) {

	var Helpers = {
	  timer: function(callback, delay) {
	    var timerId, start, remaining = delay;
	
	    this.pause = function() {
	        clearTimeout(timerId);
	        remaining -= new Date() - start;
	    };
	
	    this.resume = function() {
	        start = new Date();
	        clearTimeout(timerId);
	        timerId = setTimeout(callback, remaining);
	    };
	
	    this.clear = function() {
	      clearTimeout(timerId);
	    }
	
	    this.resume();
	  }
	}
	
	module.exports = Helpers;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var invariant = __webpack_require__(15);
	var objectAssign = __webpack_require__(74);
	var qs = __webpack_require__(1216);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return "([^/?#]+)";
	      } else if (match === "*") {
	        paramNames.push("splat");
	        return "(.*?)";
	      } else {
	        return "\\" + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp("^" + source + "$", "i"),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === "/";
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, "/") + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) {
	      return null;
	    }var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || "splat";
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === "?") {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return "";
	      } else {
	        invariant(params[paramName] != null, "Missing \"%s\" parameter for path \"%s\"", paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === "splat" && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, "Missing splat # %s for path \"%s\"", splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, "/");
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, "");
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? objectAssign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: "brackets" });
	
	    if (queryString) {
	      return PathUtils.withoutQuery(path) + "?" + queryString;
	    }return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var LocationActions = __webpack_require__(172);
	var History = __webpack_require__(148);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) {
	    return;
	  } // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener("popstate", onPopState, false);
	      } else {
	        window.attachEvent("onpopstate", onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener("popstate", onPopState, false);
	      } else {
	        window.removeEvent("onpopstate", onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, "", path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, "", path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return "<HistoryLocation>";
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        callbacks.length === contexts.length,
	        'Mismatched list of contexts in callback queue'
	      ) : invariant(callbacks.length === contexts.length));
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0, l = callbacks.length; i < l; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function() {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function() {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(672);
	
	var invariant = __webpack_require__(15);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(input) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    input.props.checkedLink == null || input.props.valueLink == null,
	    'Cannot provide a checkedLink and a valueLink. If you want to use ' +
	    'checkedLink, you probably don\'t want to use valueLink and vice versa.'
	  ) : invariant(input.props.checkedLink == null || input.props.valueLink == null));
	}
	function _assertValueLink(input) {
	  _assertSingleLink(input);
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    input.props.value == null && input.props.onChange == null,
	    'Cannot provide a valueLink and a value or onChange event. If you want ' +
	    'to use value or onChange, you probably don\'t want to use valueLink.'
	  ) : invariant(input.props.value == null && input.props.onChange == null));
	}
	
	function _assertCheckedLink(input) {
	  _assertSingleLink(input);
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    input.props.checked == null && input.props.onChange == null,
	    'Cannot provide a checkedLink and a checked property or onChange event. ' +
	    'If you want to use checked or onChange, you probably don\'t want to ' +
	    'use checkedLink'
	  ) : invariant(input.props.checked == null && input.props.onChange == null));
	}
	
	/**
	 * @param {SyntheticEvent} e change event to handle
	 */
	function _handleLinkedValueChange(e) {
	  /*jshint validthis:true */
	  this.props.valueLink.requestChange(e.target.value);
	}
	
	/**
	  * @param {SyntheticEvent} e change event to handle
	  */
	function _handleLinkedCheckChange(e) {
	  /*jshint validthis:true */
	  this.props.checkedLink.requestChange(e.target.checked);
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  Mixin: {
	    propTypes: {
	      value: function(props, propName, componentName) {
	        if (!props[propName] ||
	            hasReadOnlyValue[props.type] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `value` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultValue`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      checked: function(props, propName, componentName) {
	        if (!props[propName] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `checked` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultChecked`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      onChange: ReactPropTypes.func
	    }
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return input.props.valueLink.value;
	    }
	    return input.props.value;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function(input) {
	    if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return input.props.checkedLink.value;
	    }
	    return input.props.checked;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {function} change callback either from onChange prop or link.
	   */
	  getOnChange: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return _handleLinkedValueChange;
	    } else if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return _handleLinkedCheckChange;
	    }
	    return input.props.onChange;
	  }
	};
	
	module.exports = LinkedValueUtils;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LocalEventTrapMixin
	 */
	
	'use strict';
	
	var ReactBrowserEventEmitter = __webpack_require__(127);
	
	var accumulateInto = __webpack_require__(387);
	var forEachAccumulated = __webpack_require__(388);
	var invariant = __webpack_require__(15);
	
	function remove(event) {
	  event.remove();
	}
	
	var LocalEventTrapMixin = {
	  trapBubbledEvent:function(topLevelType, handlerBaseName) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(this.isMounted(), 'Must be mounted to trap events') : invariant(this.isMounted()));
	    // If a component renders to null or if another component fatals and causes
	    // the state of the tree to be corrupted, `node` here can be null.
	    var node = this.getDOMNode();
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      node,
	      'LocalEventTrapMixin.trapBubbledEvent(...): Requires node to be rendered.'
	    ) : invariant(node));
	    var listener = ReactBrowserEventEmitter.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      node
	    );
	    this._localEventListeners =
	      accumulateInto(this._localEventListeners, listener);
	  },
	
	  // trapCapturedEvent would look nearly identical. We don't implement that
	  // method because it isn't currently needed.
	
	  componentWillUnmount:function() {
	    if (this._localEventListeners) {
	      forEachAccumulated(this._localEventListeners, remove);
	    }
	  }
	};
	
	module.exports = LocalEventTrapMixin;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(666);
	var ReactMount = __webpack_require__(75);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates:
	    ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID:
	    ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function(rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function(environment) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        !injected,
	        'ReactCompositeComponent: injectEnvironment() can only be called once.'
	      ) : invariant(!injected));
	      ReactComponentEnvironment.unmountIDFromEnvironment =
	        environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID =
	        environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates =
	        environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactContext
	 */
	
	'use strict';
	
	var assign = __webpack_require__(25);
	var emptyObject = __webpack_require__(176);
	var warning = __webpack_require__(32);
	
	var didWarn = false;
	
	/**
	 * Keeps track of the current context.
	 *
	 * The context is automatically passed down the component ownership hierarchy
	 * and is accessible via `this.context` on ReactCompositeComponents.
	 */
	var ReactContext = {
	
	  /**
	   * @internal
	   * @type {object}
	   */
	  current: emptyObject,
	
	  /**
	   * Temporarily extends the current context while executing scopedCallback.
	   *
	   * A typical use case might look like
	   *
	   *  render: function() {
	   *    var children = ReactContext.withContext({foo: 'foo'}, () => (
	   *
	   *    ));
	   *    return <div>{children}</div>;
	   *  }
	   *
	   * @param {object} newContext New context to merge into the existing context
	   * @param {function} scopedCallback Callback to run with the new context
	   * @return {ReactComponent|array<ReactComponent>}
	   */
	  withContext: function(newContext, scopedCallback) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        didWarn,
	        'withContext is deprecated and will be removed in a future version. ' +
	        'Use a wrapper component with getChildContext instead.'
	      ) : null);
	
	      didWarn = true;
	    }
	
	    var result;
	    var previousContext = ReactContext.current;
	    ReactContext.current = assign({}, previousContext, newContext);
	    try {
	      result = scopedCallback();
	    } finally {
	      ReactContext.current = previousContext;
	    }
	    return result;
	  }
	
	};
	
	module.exports = ReactContext;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(661);
	var DOMProperty = __webpack_require__(123);
	var DOMPropertyOperations = __webpack_require__(173);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(379);
	var ReactMount = __webpack_require__(75);
	var ReactMultiChild = __webpack_require__(1259);
	var ReactPerf = __webpack_require__(103);
	
	var assign = __webpack_require__(25);
	var escapeTextContentForBrowser = __webpack_require__(225);
	var invariant = __webpack_require__(15);
	var isEventSupported = __webpack_require__(393);
	var keyOf = __webpack_require__(81);
	var warning = __webpack_require__(32);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = {'string': true, 'number': true};
	
	var STYLE = keyOf({style: null});
	
	var ELEMENT_NODE_TYPE = 1;
	
	/**
	 * Optionally injectable operations for mutating the DOM
	 */
	var BackendIDOperations = null;
	
	/**
	 * @param {?object} props
	 */
	function assertValidProps(props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (props.dangerouslySetInnerHTML != null) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      props.children == null,
	      'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
	    ) : invariant(props.children == null));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof props.dangerouslySetInnerHTML === 'object' &&
	      '__html' in props.dangerouslySetInnerHTML,
	      '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' +
	      'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' +
	      'for more information.'
	    ) : invariant(typeof props.dangerouslySetInnerHTML === 'object' &&
	    '__html' in props.dangerouslySetInnerHTML));
	  }
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      props.innerHTML == null,
	      'Directly setting property `innerHTML` is not permitted. ' +
	      'For more information, lookup documentation on `dangerouslySetInnerHTML`.'
	    ) : null);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      !props.contentEditable || props.children == null,
	      'A component is `contentEditable` and contains `children` managed by ' +
	      'React. It is now your responsibility to guarantee that none of ' +
	      'those nodes are unexpectedly modified or duplicated. This is ' +
	      'probably not intentional.'
	    ) : null);
	  }
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    props.style == null || typeof props.style === 'object',
	    'The `style` prop expects a mapping from style properties to values, ' +
	    'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' +
	    'using JSX.'
	  ) : invariant(props.style == null || typeof props.style === 'object'));
	}
	
	function putListener(id, registrationName, listener, transaction) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      registrationName !== 'onScroll' || isEventSupported('scroll', true),
	      'This browser doesn\'t support the `onScroll` event'
	    ) : null);
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ?
	      container.ownerDocument :
	      container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getPutListenerQueue().enqueuePutListener(
	    id,
	    registrationName,
	    listener
	  );
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	// We accept any tag to be rendered but since this gets injected into abitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(VALID_TAG_REGEX.test(tag), 'Invalid tag: %s', tag) : invariant(VALID_TAG_REGEX.test(tag)));
	    validatedTagCache[tag] = true;
	  }
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag;
	  this._renderedChildren = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function(element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} The computed markup.
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    assertValidProps(this._currentElement.props);
	    var closeTag = omittedCloseTags[this._tag] ? '' : '</' + this._tag + '>';
	    return (
	      this._createOpenTagMarkupAndPutListeners(transaction) +
	      this._createContentMarkup(transaction, context) +
	      closeTag
	    );
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function(transaction) {
	    var props = this._currentElement.props;
	    var ret = '<' + this._tag;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, propValue, transaction);
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup =
	          DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret + '>';
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID + '>';
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function(transaction, context) {
	    var prefix = '';
	    if (this._tag === 'listing' ||
	        this._tag === 'pre' ||
	        this._tag === 'textarea') {
	      // Add an initial newline because browsers ignore the first newline in
	      // a <listing>, <pre>, or <textarea> as an "authoring convenience" -- see
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody.
	      prefix = '\n';
	    }
	
	    var props = this._currentElement.props;
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        return prefix + innerHTML.__html;
	      }
	    } else {
	      var contentToUse =
	        CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        return prefix + escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(
	          childrenToUse,
	          transaction,
	          context
	        );
	        return prefix + mountImages.join('');
	      }
	    }
	    return prefix;
	  },
	
	  receiveComponent: function(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(transaction, prevElement, nextElement, context) {
	    assertValidProps(this._currentElement.props);
	    this._updateDOMProperties(prevElement.props, transaction);
	    this._updateDOMChildren(prevElement.props, transaction, context);
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMProperties: function(lastProps, transaction) {
	    var nextProps = this._currentElement.props;
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) ||
	         !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        deleteListener(this._rootNodeID, propKey);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.deletePropertyByID(
	          this._rootNodeID,
	          propKey
	        );
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ?
	        this._previousStyleCopy :
	        lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) &&
	                (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) &&
	                lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, nextProp, transaction);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.updatePropertyByID(
	          this._rootNodeID,
	          propKey,
	          nextProp
	        );
	      }
	    }
	    if (styleUpdates) {
	      BackendIDOperations.updateStylesByID(
	        this._rootNodeID,
	        styleUpdates
	      );
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMChildren: function(lastProps, transaction, context) {
	    var nextProps = this._currentElement.props;
	
	    var lastContent =
	      CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent =
	      CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml =
	      lastProps.dangerouslySetInnerHTML &&
	      lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml =
	      nextProps.dangerouslySetInnerHTML &&
	      nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        BackendIDOperations.updateInnerHTMLByID(
	          this._rootNodeID,
	          nextHtml
	        );
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function() {
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(
	  ReactDOMComponent.prototype,
	  ReactDOMComponent.Mixin,
	  ReactMultiChild.Mixin
	);
	
	ReactDOMComponent.injection = {
	  injectIDOperations: function(IDOperations) {
	    ReactDOMComponent.BackendIDOperations = BackendIDOperations = IDOperations;
	  }
	};
	
	module.exports = ReactDOMComponent;


/***/ },
/* 383 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLifeCycle
	 */
	
	'use strict';
	
	/**
	 * This module manages the bookkeeping when a component is in the process
	 * of being mounted or being unmounted. This is used as a way to enforce
	 * invariants (or warnings) when it is not recommended to call
	 * setState/forceUpdate.
	 *
	 * currentlyMountingInstance: During the construction phase, it is not possible
	 * to trigger an update since the instance is not fully mounted yet. However, we
	 * currently allow this as a convenience for mutating the initial state.
	 *
	 * currentlyUnmountingInstance: During the unmounting phase, the instance is
	 * still mounted and can therefore schedule an update. However, this is not
	 * recommended and probably an error since it's about to be unmounted.
	 * Therefore we still want to trigger in an error for that case.
	 */
	
	var ReactLifeCycle = {
	  currentlyMountingInstance: null,
	  currentlyUnmountingInstance: null
	};
	
	module.exports = ReactLifeCycle;


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(177);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactLifeCycle = __webpack_require__(383);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactElement = __webpack_require__(38);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	function enqueueUpdate(internalInstance) {
	  if (internalInstance !== ReactLifeCycle.currentlyMountingInstance) {
	    // If we're in a componentWillMount handler, don't enqueue a rerender
	    // because ReactUpdates assumes we're in a browser context (which is
	    // wrong for server rendering) and we're about to do a render anyway.
	    // See bug in #1740.
	    ReactUpdates.enqueueUpdate(internalInstance);
	  }
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    ReactCurrentOwner.current == null,
	    '%s(...): Cannot update during an existing state transition ' +
	    '(such as within `render`). Render methods should be a pure function ' +
	    'of props and state.',
	    callerName
	  ) : invariant(ReactCurrentOwner.current == null));
	
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !callerName,
	        '%s(...): Can only update a mounted or mounting component. ' +
	        'This usually means you called %s() on an unmounted ' +
	        'component. This is a no-op.',
	        callerName,
	        callerName
	      ) : null);
	    }
	    return null;
	  }
	
	  if (internalInstance === ReactLifeCycle.currentlyUnmountingInstance) {
	    return null;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function(publicInstance, callback) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance ||
	        internalInstance === ReactLifeCycle.currentlyMountingInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function(internalInstance, callback) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldUpdateComponent`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'forceUpdate'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function(publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function(publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue =
	      internalInstance._pendingStateQueue ||
	      (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function(publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      internalInstance._isTopLevel,
	      'setProps(...): You called `setProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    var props = assign({}, element.props, partialProps);
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function(publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      internalInstance._isTopLevel,
	      'replaceProps(...): You called `replaceProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function(internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;


/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    next != null,
	    'accumulateInto(...): Accumulated items must not be null or undefined.'
	  ) : invariant(next != null));
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;


/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;


/***/ },
/* 389 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;


/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  /*jshint validthis:true */
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;


/***/ },
/* 391 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(665);
	var ReactEmptyComponent = __webpack_require__(220);
	var ReactNativeComponent = __webpack_require__(221);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function() { };
	assign(
	  ReactCompositeComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin,
	  {
	    _instantiateReactComponent: instantiateReactComponent
	  }
	);
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return (
	    typeof type === 'function' &&
	    typeof type.prototype !== 'undefined' &&
	    typeof type.prototype.mountComponent === 'function' &&
	    typeof type.prototype.receiveComponent === 'function'
	  );
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {*} parentCompositeType The composite type that resolved this.
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, parentCompositeType) {
	  var instance;
	
	  if (node === null || node === false) {
	    node = ReactEmptyComponent.emptyElement;
	  }
	
	  if (typeof node === 'object') {
	    var element = node;
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        element && (typeof element.type === 'function' ||
	                    typeof element.type === 'string'),
	        'Only functions or strings can be mounted as React components.'
	      ) : null);
	    }
	
	    // Special case string values
	    if (parentCompositeType === element.type &&
	        typeof element.type === 'string') {
	      // Avoid recursion if the wrapper renders itself.
	      instance = ReactNativeComponent.createInternalComponent(element);
	      // All native components are currently wrapped in a composite so we're
	      // safe to assume that this is what we should instantiate.
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // represenations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      false,
	      'Encountered invalid React node of type %s',
	      typeof node
	    ) : invariant(false));
	  }
	
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      typeof instance.construct === 'function' &&
	      typeof instance.mountComponent === 'function' &&
	      typeof instance.receiveComponent === 'function' &&
	      typeof instance.unmountComponent === 'function',
	      'Only React Components can be mounted.'
	    ) : null);
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function(node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function(node, html) {
	    MSApp.execUnsafeLocalFunction(function() {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) ||
	          html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        node.innerHTML = '\uFEFF' + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var warning = __webpack_require__(32);
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  if (prevElement != null && nextElement != null) {
	    var prevType = typeof prevElement;
	    var nextType = typeof nextElement;
	    if (prevType === 'string' || prevType === 'number') {
	      return (nextType === 'string' || nextType === 'number');
	    } else {
	      if (nextType === 'object' &&
	          prevElement.type === nextElement.type &&
	          prevElement.key === nextElement.key) {
	        var ownersMatch = prevElement._owner === nextElement._owner;
	        var prevName = null;
	        var nextName = null;
	        var nextDisplayName = null;
	        if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	          if (!ownersMatch) {
	            if (prevElement._owner != null &&
	                prevElement._owner.getPublicInstance() != null &&
	                prevElement._owner.getPublicInstance().constructor != null) {
	              prevName =
	                prevElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement._owner != null &&
	                nextElement._owner.getPublicInstance() != null &&
	                nextElement._owner.getPublicInstance().constructor != null) {
	              nextName =
	                nextElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement.type != null &&
	                nextElement.type.displayName != null) {
	              nextDisplayName = nextElement.type.displayName;
	            }
	            if (nextElement.type != null && typeof nextElement.type === 'string') {
	              nextDisplayName = nextElement.type;
	            }
	            if (typeof nextElement.type !== 'string' ||
	                nextElement.type === 'input' ||
	                nextElement.type === 'textarea') {
	              if ((prevElement._owner != null &&
	                  prevElement._owner._isOwnerNecessary === false) ||
	                  (nextElement._owner != null &&
	                  nextElement._owner._isOwnerNecessary === false)) {
	                if (prevElement._owner != null) {
	                  prevElement._owner._isOwnerNecessary = true;
	                }
	                if (nextElement._owner != null) {
	                  nextElement._owner._isOwnerNecessary = true;
	                }
	                ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	                  false,
	                  '<%s /> is being rendered by both %s and %s using the same ' +
	                  'key (%s) in the same place. Currently, this means that ' +
	                  'they don\'t preserve state. This behavior should be very ' +
	                  'rare so we\'re considering deprecating it. Please contact ' +
	                  'the React team and explain your use case so that we can ' +
	                  'take that into consideration.',
	                  nextDisplayName || 'Unknown Component',
	                  prevName || '[Unknown]',
	                  nextName || '[Unknown]',
	                  prevElement.key
	                ) : null);
	              }
	            }
	          }
	        }
	        return ownersMatch;
	      }
	    }
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(268);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(268, function() {
			var newContent = __webpack_require__(268);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14),
	    PropTypes = React.PropTypes,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(79),
	    kebabCase = _require2.kebabCase,
	    BasicForm,
	    Notification = __webpack_require__(21);
	
	/**
	 * The base class Form that make a contract that will need to stick all his child's component in
	 * order to be use them.
	 */
	BasicForm = {
	
	  propTypes: {
	
	    /**
	     * The current object of form. If `value` is defined means the form is to change.
	     * Otherwise means that is a new form.
	     *
	     */
	    value: PropTypes.object,
	
	    /**
	     * Trigger fetch items from the parent admin consumer.
	     */
	    fetchItems: PropTypes.func.isRequired,
	
	    /**
	     * The name of item that handler this form.
	     */
	    itemName: PropTypes.string.isRequired,
	
	    /**
	     * The title of the form
	     */
	    title: PropTypes.string,
	
	    /**
	     * Assure that the children element are that we expected.
	     * @param props
	     * @param propName
	     * @param componentName
	     */
	    children: function children(props, propName) {
	      var fields = props[propName];
	      React.Children.forEach(fields, function (child) {
	        if (kebabCase(child.type.displayName).indexOf('form-group') === -1) {
	          throw new Error('The children must be a `form-group` component.');
	        }
	      });
	    }
	  },
	
	  /**
	   * Generic ajax error notification.
	   */
	  onFailure: function onFailure() {
	    Notification.show(t('dashboard_notification_error_try_again'), 'error');
	  }
	};
	
	module.exports = BasicForm;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(14),
	    PropTypes = React.PropTypes,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(5),
	    merge = _require2.merge,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    _require4 = __webpack_require__(37),
	    debounce = _require4.debounce,
	    BasicFormChange = void 0,
	    Notification = __webpack_require__(21),
	    Breadcrumb = __webpack_require__(399),
	    BasicForm = __webpack_require__(397),
	    FormGroupButton = __webpack_require__(30);
	
	
	BasicFormChange = React.createClass({ displayName: "BasicFormChange",
	
	  mixins: [BasicForm],
	
	  isLoading: false,
	
	  propTypes: _extends({}, BasicForm.propTypes, {
	    additionalSubmitValue: PropTypes.object,
	    additionalPreSubmitValidation: PropTypes.func,
	    additionalButtons: PropTypes.array,
	    children: PropTypes.array.isRequired,
	    contextHolder: PropTypes.object.isRequired,
	    messages: PropTypes.object,
	    onChange: PropTypes.func.isRequired,
	    onCancel: PropTypes.func.isRequired,
	    onDelete: PropTypes.func.isRequired,
	    onDeleteText: PropTypes.string,
	    value: PropTypes.object,
	    isValid: PropTypes.bool,
	    isDeleteHidden: PropTypes.boolean,
	    isSaveHidden: PropTypes.boolean,
	    isSaving: PropTypes.boolean,
	    isHiddenAllButtons: PropTypes.boolean,
	    breadcrumb: PropTypes.array,
	    shouldFocusDidMount: PropTypes.func,
	    addEnterKeyDown: PropTypes.func
	  }),
	
	  getInitialState: function getInitialState() {
	    return {
	      isValid: true
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var addEnterKeyDown = this.props.addEnterKeyDown;
	
	    // register to child
	
	    if (addEnterKeyDown) {
	      addEnterKeyDown(this._onChange.bind(this));
	    }
	  },
	  _onDelete: function _onDelete() {
	    var _props = this.props,
	        onDelete = _props.onDelete,
	        value = _props.value,
	        additionalPreSubmitValidation = _props.additionalPreSubmitValidation;
	
	
	    if (additionalPreSubmitValidation && additionalPreSubmitValidation(value) !== '') {
	      Notification.show(additionalPreSubmitValidation(value), 'warning');
	      return;
	    }
	
	    onDelete(value.id, this._onDeleteSuccess, this.onFailure);
	  },
	  _onDeleteSuccess: function _onDeleteSuccess() {
	    Notification.show(this.props.messages.deleteSuccessMessage, 'success');
	    this._cleanForm();
	  },
	  _onChange: function _onChange() {
	    var _props2 = this.props,
	        contextHolder = _props2.contextHolder,
	        value = _props2.value,
	        onChange = _props2.onChange,
	        additionalSubmitValue = _props2.additionalSubmitValue,
	        additionalPreSubmitValidation = _props2.additionalPreSubmitValidation;
	
	    if (this.isLoading) {
	      Notification.show(t('dashboard_notification_please_wait_finish_process'));
	    } else {
	      if (contextHolder.isValid()) {
	        this.isLoading = true;
	        var item = contextHolder.getItem();
	        if (additionalPreSubmitValidation && additionalPreSubmitValidation(item) !== '') {
	          Notification.show(additionalPreSubmitValidation(item), 'warning');
	          return;
	        }
	        if (additionalSubmitValue) {
	          item = merge(item, additionalSubmitValue);
	        }
	        item.id = value.id;
	        try {
	          onChange(item, this._onChangeSuccess, this._onChangeFailure);
	        } catch (err) {
	          console.error(err);
	        } finally {
	          this.isLoading = false;
	        }
	      }
	    }
	  },
	  _onChangeSuccess: function _onChangeSuccess(ajax) {
	    if (ajax.status >= 200 && ajax.status < 300) {
	      Notification.show(this.props.messages.changeSuccessMessage, 'success');
	      this.props.fetchItems();
	    } else {
	      Notification.show(this.props.messages.changeFailureMessage, 'error');
	    }
	    this.isLoading = false;
	    this._cleanForm();
	  },
	  _onChangeFailure: function _onChangeFailure() {
	    this.isLoading = false;
	  },
	  _cleanForm: function _cleanForm() {
	    var _props3 = this.props,
	        contextHolder = _props3.contextHolder,
	        onCancel = _props3.onCancel,
	        fetchItems = _props3.fetchItems;
	
	    contextHolder.clean();
	    if (onCancel) {
	      onCancel();
	    }
	    if (fetchItems) {
	      fetchItems();
	    }
	  },
	  _getActionEl: function _getActionEl() {
	    var _props4 = this.props,
	        isDeleteHidden = _props4.isDeleteHidden,
	        isHiddenAllButtons = _props4.isHiddenAllButtons,
	        isSaveHidden = _props4.isSaveHidden,
	        onDeleteText = _props4.onDeleteText,
	        isSaving = _props4.isSaving;
	
	
	    if (isHiddenAllButtons) {
	      return React.createElement("div", { className: "basic-form-content pull-left" });
	    } else {
	      return React.createElement("div", { className: "basic-form-content pull-left" }, isDeleteHidden ? null : React.createElement(FormGroupButton, {
	        label: onDeleteText ? onDeleteText : t('button_label_delete').toUpperCase(),
	        type: "icon",
	        icon: "delete_forever",
	        className: "form-group-button-icon--delete",
	        onClick: debounce(this._onDelete, 500),
	        disable: isSaving }), React.createElement(FormGroupButton, {
	        label: (t('button_label_cancel') || '').toUpperCase(),
	        icon: "cancel",
	        type: "icon",
	        className: "secondary-icon",
	        onClick: this._cleanForm,
	        disable: isSaving }), isSaveHidden ? null : React.createElement(FormGroupButton, {
	        icon: "save",
	        className: "primary-icon",
	        type: "icon",
	        label: t('button_label_save').toUpperCase(),
	        onClick: debounce(this._onChange, 500),
	        disable: isSaving }));
	    }
	  },
	  _getAdditionalButtonsEl: function _getAdditionalButtonsEl() {
	    var additionalButtons = this.props.additionalButtons;
	
	    return additionalButtons ? map(additionalButtons, function (button) {
	      return React.createElement("span", { className: "basic-form-content additional-button pull-left" }, button);
	    }) : null;
	  },
	  render: function render() {
	    var _props5 = this.props,
	        title = _props5.title,
	        children = _props5.children,
	        breadcrumb = _props5.breadcrumb,
	        isValid = _props5.isValid;
	
	    var actionsEl = this._getActionEl();
	    var additionalButtonsEl = this._getAdditionalButtonsEl();
	
	    var className = 'basic-form-container container-fluid';
	
	    if (!isValid) {
	      className += ' is-invalid';
	    }
	
	    return React.createElement("div", { className: className }, breadcrumb ? React.createElement("div", { className: "basic-form-breadcrumb" }, React.createElement(Breadcrumb, { items: breadcrumb })) : null, React.createElement("div", { className: "basic-form-header col-xs-12" }, React.createElement("h1", null, title)), React.createElement("div", { className: "basic-form-fields" }, children), React.createElement("div", { className: "basic-form-buttons" }, additionalButtonsEl, actionsEl));
	  }
	});
	
	module.exports = BasicFormChange;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1322);
	
	var React = __webpack_require__(1),
	    Router = __webpack_require__(19),
	    Link = Router.Link,
	    _require = __webpack_require__(8),
	    map = _require.map;
	
	
	var BreadCrumbItem = React.createClass({ displayName: "BreadCrumbItem",
	
	    propTypes: {
	        link: React.PropTypes.string,
	        displayName: React.PropTypes.string
	    },
	
	    render: function render() {
	        var _props = this.props,
	            link = _props.link,
	            displayName = _props.displayName;
	
	        return React.createElement("li", { className: "bp-breadcrumb__list-item" }, link ? React.createElement(Link, { to: link }, displayName) : React.createElement("a", { hred: "#" }, displayName));
	    }
	});
	
	var BreadCrumb = React.createClass({ displayName: "BreadCrumb",
	
	    propTypes: {
	        items: React.PropTypes.array
	    },
	
	    render: function render() {
	        var itemsEl = map(this.props.items, function (item) {
	            return React.createElement(BreadCrumbItem, { link: item.link,
	                displayName: item.displayName });
	        });
	        return React.createElement("div", { className: "bp-breadcrumb" }, React.createElement("ul", { className: "bp-breadcrumb__list" }, itemsEl));
	    }
	});
	
	module.exports = BreadCrumb;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var FlatSphere = React.createClass({ displayName: "FlatSphere",
	    propTypes: {
	        bgColor: PropTypes.string,
	        text: PropTypes.string
	    },
	    render: function render() {
	        var _props = this.props,
	            bgColor = _props.bgColor,
	            text = _props.text;
	
	        return React.createElement("div", null, React.createElement("span", {
	            className: "text-center",
	            style: {
	                height: '20px',
	                borderRadius: '22px',
	                boxShadow: '1px 2px 4px 0px gray',
	                backgroundColor: bgColor,
	                border: 'solid 0px black',
	                padding: '10px 17px',
	                left: '0',
	                position: 'relative',
	                opacity: '.6'
	            } }), React.createElement("span", { style: { paddingLeft: '10px' } }, text));
	    }
	});
	
	module.exports = FlatSphere;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(691);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    get = __webpack_require__(5).get,
	    DateUtils = __webpack_require__(22),
	    BeerStyleStore = __webpack_require__(95),
	    DashboardServiceCache = __webpack_require__(28),
	    SessionStore = __webpack_require__(11),
	    ComponentUtils = __webpack_require__(77),
	    ContentUtils = __webpack_require__(7),
	    _require3 = __webpack_require__(12),
	    TextField = _require3.TextField,
	    _require4 = __webpack_require__(40),
	    concat = _require4.concat,
	    DropDown = __webpack_require__(105),
	    _require5 = __webpack_require__(12),
	    DatePicker = _require5.DatePicker,
	    SelectField = _require5.SelectField;
	
	
	var DashboardModalBrewBody = React.createClass({ displayName: "DashboardModalBrewBody",
	    propTypes: {
	        onChangeBrewDate: PropTypes.func,
	        onChangeVolume: PropTypes.func,
	        onChangeComment: PropTypes.func,
	        onChangeFiltrationDate: PropTypes.func,
	        onChangeOrderDate: PropTypes.func,
	        onChangeBeerStyle: PropTypes.func,
	        onChangeBriteTank: PropTypes.func,
	        parentState: PropTypes.object,
	        onChangeFermenterTank: PropTypes.func,
	        refsSubscriber: PropTypes.object,
	        isBeerStyleAlreadyDefined: PropTypes.bool
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        var _props = this.props,
	            refsSubscriber = _props.refsSubscriber,
	            styleBeerSelectedIndex = _props.styleBeerSelectedIndex;
	
	
	        if (styleBeerSelectedIndex === -1) {
	            refsSubscriber.beerStyle.setState({});
	        }
	    },
	    _getMenuItemIcons: function _getMenuItemIcons(typeTank) {
	        var nonSelectItem = [{ payload: 0, text: 'Icon...' }];
	        var tasks = DashboardServiceCache.getIconsByType(typeTank);
	        return concat(nonSelectItem, ComponentUtils.toMenuItems(tasks, 'displayName', 'icon'));
	    },
	    render: function render() {
	        var _props2 = this.props,
	            refsSubscriber = _props2.refsSubscriber,
	            parentState = _props2.parentState,
	            onChangeBrewDate = _props2.onChangeBrewDate,
	            onChangeFiltrationDate = _props2.onChangeFiltrationDate,
	            onChangeOrderDate = _props2.onChangeOrderDate,
	            onChangeBeerStyle = _props2.onChangeBeerStyle,
	            onChangeBriteTank = _props2.onChangeBriteTank,
	            onChangeVolume = _props2.onChangeVolume,
	            onChangeComment = _props2.onChangeComment,
	            onChangeFermenterTank = _props2.onChangeFermenterTank;
	
	        // only disabled if beerStyle is not defined or is a Guest user
	
	        var isDisabledComponent = isDisableComponent(parentState);
	
	        // max date allowed to brew date
	        var maxDateFrom = DateUtils.toDateText(parentState.filtrationDate) === DateUtils.toDateText(parentState.brewDate) ? parentState.brewDate : DateUtils.addDays(parentState.filtrationDate, -1);
	
	        var isNewModal = parentState.isNewModal;
	
	        var haveErrorText = get(parentState, 'styleBeerMessageError.length') > 0;
	        return React.createElement("div", null, React.createElement("div", { className: "visible-xs row" }, React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DropDown, {
	            floatingLabelText: t('dashboard_modal_general_beer_style'),
	            onChange: onChangeBeerStyle,
	            ref: function ref(input) {
	                return refsSubscriber.beerStyle = input;
	            },
	            wrapperMenuItem: _getWrapperColor,
	            items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(),
	            style: { minWidth: '250px', marginBottom: haveErrorText ? '15px' : '-12px' },
	            errorStyle: { color: isNewModal ? 'blue !important' : '#B3B3B3' },
	            labelStyle: { color: 'black' },
	            errorText: parentState.styleBeerMessageError,
	            selectedIndex: parentState.styleBeerSelectedIndex,
	            disabled: !isNewModal ? true : isDisabledComponent,
	            readerAttribute: "name",
	            name: t('dashboard_modal_general_beer_style')
	        }), React.createElement("br", null), React.createElement(SelectField, {
	            floatingLabelText: t('dashboard_modal_general_fermenting_tank'),
	            onChange: onChangeFermenterTank,
	            ref: function ref(input) {
	                return refsSubscriber.fermenterTank = input;
	            },
	            menuItems: parentState.fermenterTankMenuItems,
	            errorText: parentState.fermenterTankMessageError,
	            value: parentState.fermenterTankSelectedIndex,
	            disabled: isDisabledComponent
	        }), React.createElement("br", null), React.createElement(SelectField, {
	            floatingLabelText: t('dashboard_modal_general_packaging_tank'),
	            onChange: onChangeBriteTank,
	            ref: function ref(input) {
	                return refsSubscriber.briteTank = input;
	            },
	            menuItems: parentState.briteTankMenuItems,
	            errorText: parentState.briteTankMessageError,
	            value: parentState.briteTankSelectedIndex,
	            disabled: isDisabledComponent }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return refsSubscriber.orderVolume = input;
	            },
	            floatingLabelText: t('dashboard_modal_general_volume'),
	            onBlur: onChangeVolume,
	            errorText: parentState.volumenTankMessageError,
	            defaultValue: get(parentState, 'orderVolume'),
	            disabled: isDisabledComponent || get(parentState, 'isSomeProductAlreadyConfirmed') })), React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_brew_date'),
	            ref: function ref(input) {
	                return refsSubscriber.brewDate = input;
	            },
	            hintText: t('dashboard_modal_general_brew_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.brewDate,
	            onChange: isDisabledComponent ? function () {} : onChangeBrewDate,
	            errorText: parentState.brewDateMessageError,
	            disabled: isDisabledComponent,
	            maxDate: maxDateFrom }), React.createElement(DatePicker, {
	            onChange: isDisabledComponent ? function () {} : onChangeFiltrationDate,
	            floatingLabelText: t('dashboard_modal_general_transfer_date'),
	            ref: function ref(input) {
	                return refsSubscriber.filtrationDate = input;
	            },
	            hintText: t('dashboard_modal_general_transfer_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.filtrationDate,
	            errorText: parentState.filtrationDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.brewDate,
	            maxDate: ContentUtils.isEmptyText(parentState.orderDate) ? new Date() : parentState.orderDate
	        }), React.createElement(DatePicker, {
	            onChange: isDisabledComponent ? function () {} : onChangeOrderDate,
	            floatingLabelText: t('dashboard_modal_general_packaging_date'),
	            ref: function ref(input) {
	                return refsSubscriber.orderDate = input;
	            },
	            hintText: t('dashboard_modal_general_packaging_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.orderDate,
	            errorText: parentState.orderDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.filtrationDate })), React.createElement("br", null), React.createElement("div", { className: "col-xs-12" }, React.createElement(TextField, {
	            onBlur: onChangeComment,
	            floatingLabelText: t('dashboard_modal_general_add_comment'),
	            multiLine: true,
	            defaultValue: get(parentState, 'order.comment', ''),
	            style: { width: '100%' },
	            disabled: isDisabledComponent })), React.createElement("div", { className: "clearfix" })), React.createElement("div", { className: "hidden-xs row" }, React.createElement("div", { style: { paddingTop: '15px' }, className: "col-xs-12 col-sm-6" }, React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_brew_date'),
	            ref: function ref(input) {
	                return refsSubscriber.brewDate = input;
	            },
	            hintText: t('dashboard_modal_general_brew_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.brewDate,
	            onChange: isDisabledComponent ? function () {} : onChangeBrewDate,
	            errorText: parentState.brewDateMessageError,
	            disabled: isDisabledComponent,
	            maxDate: maxDateFrom }), React.createElement(DatePicker, {
	            onChange: isDisabledComponent ? function () {} : onChangeFiltrationDate,
	            floatingLabelText: t('dashboard_modal_general_transfer_date'),
	            ref: function ref(input) {
	                return refsSubscriber.filtrationDate = input;
	            },
	            hintText: t('dashboard_modal_general_transfer_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.filtrationDate,
	            errorText: parentState.filtrationDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.brewDate,
	            maxDate: ContentUtils.isEmptyText(parentState.orderDate) ? new Date() : parentState.orderDate
	        }), React.createElement(DatePicker, {
	            onChange: isDisabledComponent ? function () {} : onChangeOrderDate,
	            floatingLabelText: t('dashboard_modal_general_packaging_date'),
	            ref: function ref(input) {
	                return refsSubscriber.orderDate = input;
	            },
	            hintText: t('dashboard_modal_general_packaging_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.orderDate,
	            errorText: parentState.orderDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.filtrationDate })), React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DropDown, {
	            floatingLabelText: t('dashboard_modal_general_beer_style'),
	            onChange: onChangeBeerStyle,
	            ref: function ref(input) {
	                return refsSubscriber.beerStyle = input;
	            },
	            wrapperMenuItem: _getWrapperColor,
	            items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(),
	            style: { minWidth: '250px', marginBottom: haveErrorText ? '15px' : '-12px' },
	            errorStyle: { color: isNewModal ? 'blue !important' : '#B3B3B3' },
	            labelStyle: { color: 'black' },
	            errorText: parentState.styleBeerMessageError,
	            selectedIndex: parentState.styleBeerSelectedIndex,
	            disabled: !isNewModal ? true : isDisabledComponent,
	            readerAttribute: "name",
	            name: t('dashboard_modal_general_beer_style')
	        }), React.createElement("br", null), React.createElement(SelectField, {
	            floatingLabelText: t('dashboard_modal_general_fermenting_tank'),
	            onChange: onChangeFermenterTank,
	            ref: function ref(input) {
	                return refsSubscriber.fermenterTank = input;
	            },
	            menuItems: parentState.fermenterTankMenuItems,
	            errorText: parentState.fermenterTankMessageError,
	            value: parentState.fermenterTankSelectedIndex,
	            disabled: isDisabledComponent
	        }), React.createElement("br", null), React.createElement(SelectField, {
	            floatingLabelText: t('dashboard_modal_general_packaging_tank'),
	            onChange: onChangeBriteTank,
	            ref: function ref(input) {
	                return refsSubscriber.briteTank = input;
	            },
	            menuItems: parentState.briteTankMenuItems,
	            errorText: parentState.briteTankMessageError,
	            value: parentState.briteTankSelectedIndex,
	            disabled: isDisabledComponent }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return refsSubscriber.orderVolume = input;
	            },
	            floatingLabelText: t('dashboard_modal_general_volume'),
	            onBlur: onChangeVolume,
	            errorText: parentState.volumenTankMessageError,
	            defaultValue: get(parentState, 'orderVolume'),
	            disabled: isDisabledComponent || get(parentState, 'isSomeProductAlreadyConfirmed') })), React.createElement("br", null), React.createElement("div", { className: "col-xs-12" }, React.createElement(TextField, {
	            onBlur: onChangeComment,
	            floatingLabelText: t('dashboard_modal_general_add_comment'),
	            multiLine: true,
	            defaultValue: get(parentState, 'order.comment', ''),
	            style: { width: '100%' },
	            disabled: isDisabledComponent })), React.createElement("div", { className: "clearfix" })));
	    }
	});
	
	function isDisableComponent(parentState) {
	    return SessionStore.isAdminUser() ? false : !SessionStore.isAdminUser() ? false : !parentState.isBeerStyleAlreadyDefined;
	}
	
	function _getWrapperColor(item) {
	    var isMenuItemUsed = item.payload !== undefined;
	    var beerStyle = void 0;
	
	    if (isMenuItemUsed) {
	        beerStyle = item.itemModel;
	    } else {
	        beerStyle = item;
	    }
	
	    return React.createElement("div", null, React.createElement("span", {
	        className: "text-center",
	        style: {
	            height: '20px',
	            borderRadius: '22px',
	            boxShadow: beerStyle ? '1px 2px 4px 0px gray' : '0 0 0 0 #fff',
	            backgroundColor: get(beerStyle, 'color'),
	            border: 'solid 0px black',
	            padding: '8px 16px',
	            left: '0',
	            position: 'relative',
	            opacity: '.6'
	        } }), React.createElement("span", { style: { paddingLeft: '10px' } }, get(beerStyle, 'name') || get(item, 'text')));
	}
	
	module.exports = DashboardModalBrewBody;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(691);
	
	var React = __webpack_require__(1),
	    _ = __webpack_require__(40),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ContentUtils = __webpack_require__(7),
	    DateUtils = __webpack_require__(22),
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    SessionStore = __webpack_require__(11),
	    BeerStyleStore = __webpack_require__(95),
	    _require3 = __webpack_require__(12),
	    TextField = _require3.TextField,
	    DropDown = __webpack_require__(105),
	    AppConstants = __webpack_require__(2),
	    _require4 = __webpack_require__(12),
	    DatePicker = _require4.DatePicker,
	    SelectField = _require4.SelectField;
	
	
	var DashboardModalSingleBody = React.createClass({ displayName: "DashboardModalSingleBody",
	    propTypes: {
	        sectionName: PropTypes.string,
	        initFromDate: PropTypes.string,
	        initToDate: PropTypes.string,
	        onChangeFromDate: PropTypes.func,
	        isBeerStyleAlreadyDefined: PropTypes.bool,
	        onChangeVolume: PropTypes.func,
	        onChangeComment: PropTypes.func,
	        onChangeToDate: PropTypes.func,
	        onChangeCloseOrder: PropTypes.func,
	        onChangeBeerStyle: PropTypes.func,
	        onChangeTank: PropTypes.func,
	        parentState: PropTypes.object,
	        tankSelected: PropTypes.object,
	        refsSubscriber: PropTypes.object
	    },
	
	    render: function render() {
	        var _props = this.props,
	            onChangeComment = _props.onChangeComment,
	            refsSubscriber = _props.refsSubscriber,
	            parentState = _props.parentState,
	            onChangeTank = _props.onChangeTank,
	            onChangeFromDate = _props.onChangeFromDate,
	            onChangeToDate = _props.onChangeToDate,
	            onChangeBeerStyle = _props.onChangeBeerStyle,
	            initFromDate = _props.initFromDate,
	            initToDate = _props.initToDate,
	            onChangeVolume = _props.onChangeVolume,
	            sectionName = _props.sectionName,
	            tankTypeClicked = _props.tankTypeClicked;
	
	        // only disabled if beerStyle is not defined or is a Guest user
	
	        var isDisabledComponent = isDisableComponent(parentState);
	
	        if (!isDisabledComponent) {
	            // only disabled if beerStyle is not defined or is a Guest user
	            isDisabledComponent = isDisableComponent(parentState, tankTypeClicked);
	        }
	
	        var isBrewingSection = sectionName === AppConstants.BREWING_SECTION_NAME;
	        var isNewModal = parentState.isNewModal;
	        var haveErrorText = _.get(parentState, 'styleBeerMessageError.length') > 0;
	        return React.createElement("div", null, React.createElement("div", { className: "visible-xs row" }, React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DropDown, {
	            floatingLabelText: t('dashboard_modal_general_beer_style'),
	            onChange: onChangeBeerStyle,
	            ref: function ref(input) {
	                return refsSubscriber.beerStyle = input;
	            },
	            wrapperMenuItem: _getWrapperColor,
	            items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(),
	            style: { minWidth: '250px', marginBottom: haveErrorText ? '25px' : '7px' },
	            errorStyle: { color: isNewModal ? 'blue !important' : '#B3B3B3' },
	            errorText: parentState.styleBeerMessageError,
	            selectedIndex: parentState.styleBeerSelectedIndex,
	            disabled: !isNewModal ? true : isDisabledComponent,
	            readerAttribute: "name",
	            name: t('dashboard_modal_general_beer_style')
	        }), React.createElement(SelectField, {
	            floatingLabelText: sectionName + (isBrewingSection ? ' ' + t('turn') : ' ' + t('tank')),
	
	            onChange: onChangeTank,
	            menuItems: parentState.tankMenuItems,
	            errorText: parentState.tankMessageError,
	            value: parentState.singleTankIndex,
	            disabled: isDisabledComponent }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return refsSubscriber.orderVolume = input;
	            },
	            floatingLabelText: t('dashboard_modal_general_volume'),
	            onBlur: onChangeVolume,
	            errorText: parentState.volumenTankMessageError,
	            defaultValue: _.get(parentState, 'orderVolume'),
	            disabled: isDisabledComponent || _.get(parentState, 'isSomeProductAlreadyConfirmed') })), React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_from_date'),
	            hintText: t('dashboard_modal_general_from_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.fromDate || initFromDate,
	            onChange: isDisabledComponent ? function () {} : onChangeFromDate,
	            errorText: parentState.fromDateMessageError,
	            disabled: isDisabledComponent,
	            maxDate: parentState.toDate }), React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_to_date'),
	            hintText: t('dashboard_modal_general_to_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.toDate || initToDate,
	            onChange: isDisabledComponent ? function () {} : onChangeToDate,
	            errorText: parentState.toDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.fromDate })), React.createElement("div", { className: "col-xs-12" }, React.createElement(TextField, {
	            onBlur: onChangeComment,
	            floatingLabelText: t('dashboard_modal_general_add_comment'),
	            multiLine: true,
	            defaultValue: _.get(parentState, 'order.comment', ''),
	            style: { width: '100%' },
	            disabled: isDisabledComponent })), React.createElement("div", { className: "clearfix" })), React.createElement("div", { className: "hidden-xs row" }, React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_from_date'),
	            hintText: t('dashboard_modal_general_from_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.fromDate || initFromDate,
	            onChange: isDisabledComponent ? function () {} : onChangeFromDate,
	            errorText: parentState.fromDateMessageError,
	            disabled: isDisabledComponent,
	            maxDate: parentState.toDate }), React.createElement(DatePicker, {
	            floatingLabelText: t('dashboard_modal_general_to_date'),
	            hintText: t('dashboard_modal_general_to_date'),
	            formatDate: DateUtils.toDisplayDateText,
	            value: parentState.toDate || initToDate,
	            onChange: isDisabledComponent ? function () {} : onChangeToDate,
	            errorText: parentState.toDateMessageError,
	            disabled: isDisabledComponent,
	            minDate: parentState.fromDate })), React.createElement("div", { className: "col-xs-12 col-sm-6" }, React.createElement(DropDown, {
	            floatingLabelText: t('dashboard_modal_general_beer_style'),
	            onChange: onChangeBeerStyle,
	            ref: function ref(input) {
	                return refsSubscriber.beerStyle = input;
	            },
	            wrapperMenuItem: _getWrapperColor,
	            items: isNewModal ? ContentUtils.filterEnable(BeerStyleStore.getBeerStyles()) : BeerStyleStore.getBeerStyles(),
	            style: { minWidth: '250px', marginBottom: haveErrorText ? '25px' : '7px' },
	            errorStyle: { color: isNewModal ? 'blue !important' : '#B3B3B3' },
	            errorText: parentState.styleBeerMessageError,
	            selectedIndex: parentState.styleBeerSelectedIndex,
	            disabled: !isNewModal ? true : isDisabledComponent,
	            readerAttribute: "name",
	            name: t('dashboard_modal_general_beer_style')
	        }), React.createElement(SelectField, {
	            floatingLabelText: sectionName + (isBrewingSection ? ' ' + t('turn') : ' ' + t('tank')),
	
	            onChange: onChangeTank,
	            menuItems: parentState.tankMenuItems,
	            errorText: parentState.tankMessageError,
	            value: parentState.singleTankIndex,
	            disabled: isDisabledComponent }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return refsSubscriber.orderVolume = input;
	            },
	            floatingLabelText: t('dashboard_modal_general_volume'),
	            onBlur: onChangeVolume,
	            errorText: parentState.volumenTankMessageError,
	            defaultValue: _.get(parentState, 'orderVolume'),
	            disabled: isDisabledComponent || _.get(parentState, 'isSomeProductAlreadyConfirmed') })), React.createElement("div", { className: "col-xs-12" }, React.createElement(TextField, {
	            onBlur: onChangeComment,
	            floatingLabelText: t('dashboard_modal_general_add_comment'),
	            multiLine: true,
	            defaultValue: _.get(parentState, 'order.comment', ''),
	            style: { width: '100%' },
	            disabled: isDisabledComponent })), React.createElement("div", { className: "clearfix" })));
	    }
	});
	
	function isDisableComponent(parentState, tankTypeClicked) {
	    return SessionStore.isAdminUser() ? false : !SessionStore.isAdminUser() || tankTypeClicked ? false : !parentState.isBeerStyleAlreadyDefined;
	}
	
	function _getWrapperColor(item) {
	    var isMenuItemUsed = item.payload !== undefined;
	    var beerStyle = void 0;
	
	    if (isMenuItemUsed) {
	        beerStyle = item.itemModel;
	    } else {
	        beerStyle = item;
	    }
	
	    return React.createElement("div", null, React.createElement("span", {
	        className: "text-center",
	        style: {
	            height: '20px',
	            borderRadius: '22px',
	            boxShadow: beerStyle ? '1px 2px 4px 0px gray' : '0 0 0 0 #fff',
	            backgroundColor: _.get(beerStyle, 'color'),
	            border: 'solid 0px black',
	            padding: '8px 16px',
	            left: '0',
	            position: 'relative',
	            opacity: '.6'
	        } }), React.createElement("span", { style: { paddingLeft: '10px' } }, _.get(beerStyle, 'name') || _.get(item, 'text')));
	}
	
	module.exports = DashboardModalSingleBody;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _iconsProvider;
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    SessionStore = __webpack_require__(11),
	    TextField = __webpack_require__(106),
	    getBoundingClientRect = __webpack_require__(234),
	    DashboardServiceCache = __webpack_require__(28),
	    _ = __webpack_require__(40),
	    DashboardModalTaskCollapsibleContent = __webpack_require__(724),
	    _require3 = __webpack_require__(2),
	    TASK_NON_VISIBLE = _require3.TASK_NON_VISIBLE,
	    TYPE_TASK_FERMENTER = _require3.TYPE_TASK_FERMENTER,
	    ComponentUtils = __webpack_require__(77),
	    ContentUtils = __webpack_require__(7),
	    DropDown = __webpack_require__(105),
	    PositionUtils = __webpack_require__(59);
	
	
	var iconsProvider = (_iconsProvider = {}, _iconsProvider['FERMENTER_TASK'] = DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache), _iconsProvider['FV'] = DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache), _iconsProvider['PACKAGING_TASK'] = DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache), _iconsProvider['BT'] = DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache), _iconsProvider['BREWHOUSE_TASK'] = DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache), _iconsProvider['BH'] = DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache), _iconsProvider);
	
	var DashboardModalTaskCollapsible = React.createClass({ displayName: "DashboardModalTaskCollapsible",
	
	    propTypes: {
	        date: PropTypes.string,
	        order: PropTypes.object,
	        uniqueId: PropTypes.string,
	        existingTask: PropTypes.object,
	        existingProcess: PropTypes.object,
	        indexDay: PropTypes.number,
	        name: PropTypes.string,
	        orderProcess: PropTypes.array,
	        onChangeTaskType: PropTypes.func,
	        onBlurLabel: PropTypes.func,
	        onBlurDescription: PropTypes.func,
	        onToggleExpand: PropTypes.func,
	        onChangeProcess: PropTypes.func,
	        onChangeProducts: PropTypes.func,
	        onChangeAmountInLocation: PropTypes.func,
	        onChangeAmountItem: PropTypes.func,
	        onChangeVolumeItem: PropTypes.func,
	        isEditMode: PropTypes.bool,
	        onDeleteTask: PropTypes.func,
	        typeTask: PropTypes.string,
	        typeTaskClassName: PropTypes.string,
	        tasks: PropTypes.array,
	        onConfirmProduct: PropTypes.func.isRequired
	    },
	
	    onToggleExpand: function onToggleExpand() {
	        var _this = this;
	
	        this.setState(function (prevState) {
	            return {
	                isCollapsed: !prevState.isCollapsed
	            };
	        }, function () {
	            if (_this.props.onToggleExpand) {
	                _this.props.onToggleExpand();
	            }
	        });
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isCollapsed: true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var _this2 = this;
	
	        // Force focus to proper task clicked
	        _.delay(function () {
	            _this2._focusElement();
	        }, 500); // set time out in order to fix issue about non focus setting
	    },
	    _focusElement: function _focusElement() {
	        var dropdownSelected = document.querySelector('.is-focused input');
	
	        if (dropdownSelected && this.isMounted()) {
	            var dropdownSelectedEl = ContentUtils.getComponentByClassName(dropdownSelected, 'modal-order-task-list-item');
	            var indexDay = +dropdownSelectedEl.getAttribute('data-index-day');
	            var parentScrollEl = PositionUtils.getParentScroll(dropdownSelected);
	            var heightDayRow = getBoundingClientRect(dropdownSelectedEl).height;
	            var modalHalfHeight = getBoundingClientRect(parentScrollEl).height / 2;
	            var positionHeight = indexDay * heightDayRow;
	
	            if (positionHeight < modalHalfHeight) {
	                // enter here means that we are clicked on days before the middle of height of dashboard
	                positionHeight = 0;
	            } else {
	                //
	                positionHeight = positionHeight - modalHalfHeight;
	            }
	
	            parentScrollEl.scrollTop = positionHeight;
	            dropdownSelected.focus();
	        }
	    },
	    render: function render() {
	        var _props = this.props,
	            onDeleteTask = _props.onDeleteTask,
	            onBlurDescription = _props.onBlurDescription,
	            onChangeTaskType = _props.onChangeTaskType,
	            tasks = _props.tasks,
	            onBlurLabel = _props.onBlurLabel,
	            date = _props.date,
	            indexDay = _props.indexDay,
	            existingTask = _props.existingTask,
	            typeTask = _props.typeTask,
	            typeTaskClassName = _props.typeTaskClassName,
	            name = _props.name,
	            orderProcess = _props.orderProcess,
	            existingProcess = _props.existingProcess,
	            uniqueId = _props.uniqueId,
	            onChangeProcess = _props.onChangeProcess,
	            onChangeProducts = _props.onChangeProducts,
	            onChangeAmountItem = _props.onChangeAmountItem,
	            onChangeVolumeItem = _props.onChangeVolumeItem,
	            isEditMode = _props.isEditMode,
	            onChangeAmountInLocation = _props.onChangeAmountInLocation,
	            onConfirmProduct = _props.onConfirmProduct,
	            order = _props.order,
	            shouldBeDisabled = _props.shouldBeDisabled;
	
	
	        var taskLabelClassName = 'modal-order-task-list-item-label col-xs-2 ' + typeTaskClassName;
	        var notesEl = void 0;
	        var classNameDescription = void 0;
	        var payloadNonIcon = _.findIndex(tasks, function (task) {
	            return task.name === TASK_NON_VISIBLE;
	        }) + 1;
	
	        if (name) {
	            notesEl = React.createElement("span", { className: "modal-order-task-list-item-date col-xs-2" }, name);
	            classNameDescription = 'modal-order-task-list-item-description col-xs-2';
	        } else {
	            notesEl = null;
	            classNameDescription = 'modal-order-task-list-item-description col-xs-4';
	        }
	
	        var classNameIconPlus = !this.state.isCollapsed ? 'material-icons toggle-icon modal-order-task-list-item__receipe is-expanded' : 'material-icons toggle-icon modal-order-task-list-item__receipe';
	        var someProductConfirmed = _.some(_.get(existingTask, 'products'), function (product) {
	            return _.get(product, 'isConfirmed');
	        });
	        var taskMenus = iconsProvider[typeTask]();
	        var isDisabled = someProductConfirmed || (SessionStore.isAdminUser() ? false : shouldBeDisabled);
	
	        return React.createElement("li", { "data-section-type": typeTask, "data-index-day": indexDay + 1, key: uniqueId, className: "modal-order-task-list-item row" }, React.createElement("span", { className: "modal-order-task-list-item-date col-xs-2"
	        }, date), React.createElement("span", null, notesEl), React.createElement("span", { className: "modal-order-task-list-item-typetask col-xs-3" }, React.createElement(DropDown, {
	            floatingLabelText: t('icon'),
	            name: t('dashboard_modal_task_icon'),
	            key: 'typeTask-' + indexDay + _.get(existingTask, 'id') + this.props.uniqueId,
	            selectedIndex: !existingTask || existingTask.payload === 0 ? payloadNonIcon : existingTask.payload,
	            readerAttribute: "displayName",
	            autoWidth: false,
	            onChange: onChangeTaskType.bind(existingTask),
	            items: taskMenus,
	            menuItems: ComponentUtils.toMenuItems(tasks, 'displayName', 'icon', 'modal-order-type-task-' + (typeTask === TYPE_TASK_FERMENTER ? 'fv' : 'bt') + '-locator-'),
	            disabled: isDisabled,
	            style: { width: '102%' } })), React.createElement("span", { className: taskLabelClassName }, React.createElement(TextField, {
	            floatingLabelText: t('label'),
	            errorStyle: { color: 'orange' },
	            value: _.get(existingTask, 'label'),
	            disabled: isDisabled,
	            key: 'taskLabel-' + indexDay + _.get(existingTask, 'id'),
	            onBlur: onBlurLabel
	        })), React.createElement("span", { className: classNameDescription }, React.createElement(TextField, {
	            floatingLabelText: t('note'),
	            value: _.get(existingTask, 'description'),
	            key: 'taskDescription-' + indexDay + _.get(existingTask, 'id'),
	            onBlur: onBlurDescription,
	            disabled: isDisabled
	        })), React.createElement("span", { className: "modal-order-task-list-item-delete col-xs-1" }, React.createElement("i", { title: t('dashboard_modal_task_delete_task'),
	            style: { display: 'none' }, /* display: showDeleteIcon ? 'inline' : 'none' Temporary hidden  */
	            className: "material-icons md-16",
	            onClick: onDeleteTask }, "delete")), React.createElement("span", { className: classNameIconPlus }, this.state.isCollapsed ? React.createElement("i", { title: t('dashboard_modal_task_add_recipe'),
	            "data-test-id": "expand-task",
	            className: "material-icons md-16",
	            onClick: this.onToggleExpand }, "add_circle_outline") : React.createElement("i", { title: t('dashboard_modal_task_add_recipe'),
	            "data-test-id": "expand-task",
	            className: "material-icons md-16",
	            onClick: this.onToggleExpand }, "remove_circle_outline")), React.createElement(DashboardModalTaskCollapsibleContent, {
	            key: 'collapsible-content-' + indexDay + _.get(existingTask, 'id'),
	            existingTask: existingTask,
	            existingProcess: existingProcess,
	            orderProcess: orderProcess,
	            shouldBeDisabled: shouldBeDisabled,
	            order: order,
	            onChangeProcess: onChangeProcess,
	            onChangeProducts: onChangeProducts,
	            onConfirmProduct: onConfirmProduct,
	            onChangeAmountItem: onChangeAmountItem,
	            onChangeVolumeItem: onChangeVolumeItem,
	            onChangeAmountInLocation: onChangeAmountInLocation,
	            isCollapsed: this.state.isCollapsed,
	            isEditMode: isEditMode }));
	    }
	});
	
	module.exports = DashboardModalTaskCollapsible;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1344);
	
	var React = __webpack_require__(1),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AppDispatcher = __webpack_require__(42),
	    MenuItem = __webpack_require__(522),
	    DashboardServiceCache = __webpack_require__(28),
	    Constants = __webpack_require__(2),
	    CustomDialog = __webpack_require__(26),
	    MenuDivider = __webpack_require__(521),
	    Security = __webpack_require__(13).auth,
	    SessionStore = __webpack_require__(11),
	    ContentUtils = __webpack_require__(7),
	    SettingModal = __webpack_require__(405),
	    PositionUtils = __webpack_require__(59),
	    categories = __webpack_require__(2).Analytics.categories,
	    actions = __webpack_require__(2).Analytics.actions,
	    $ = __webpack_require__(188),
	    ga = __webpack_require__(18),
	    DASHBOARD_ID = '#dashboard-id',
	    _require2 = __webpack_require__(12),
	    AppBar = _require2.AppBar,
	    IconMenu = _require2.IconMenu,
	    Avatar = _require2.Avatar,
	    FontIcon = _require2.FontIcon,
	    IconButton = _require2.IconButton;
	
	
	var Header = React.createClass({ displayName: "Header",
	
	    getInitialState: function getInitialState() {
	        return {
	            isSettingModalOpen: false
	        };
	    },
	    _toggleSettingModalShow: function _toggleSettingModalShow() {
	        this.setState(function (prevState) {
	            return {
	                isSettingModalOpen: !prevState.isSettingModalOpen
	            };
	        });
	    },
	    _onExit: function _onExit() {
	        var _this = this;
	
	        if (DashboardServiceCache.getPendingOperations().length > 0) {
	            CustomDialog.showWarningConfirmation(t('warning'), t('notification_warning_leave_dashboard_before_auto_saved'), function () {
	                _this._logout();
	            }, t('button_label_continue'), t('button_label_cancel'));
	        } else {
	            this._logout();
	        }
	    },
	    _logout: function _logout() {
	        Security.logout();
	        ga.event({
	            category: categories.APPLICATION,
	            action: actions.SIGN_OUT,
	            label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	        });
	    },
	    _printDashboard: function _printDashboard(e) {
	        e.preventDefault();
	
	        // remove selection dashboard to avoid problem when print the orders
	        AppDispatcher.dispatch({ type: ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD });
	
	        setTimeout(function () {
	            var useWidth = $(DASHBOARD_ID).prop('scrollWidth');
	            var scrollHeight = $(PositionUtils.getParentScroll(document.querySelector(DASHBOARD_ID))).prop('scrollHeight');
	            var scrollY = -Math.abs(document.documentElement.scrollTop);
	            var useHeight = scrollHeight;
	
	            html2canvas(document.querySelector(DASHBOARD_ID), { width: useWidth, height: useHeight, scrollY: scrollY }).then(function (canvas) {
	                ReImg.fromCanvas(canvas).downloadPng();
	            });
	        }, 2000);
	    },
	    render: function render() {
	        var _props = this.props,
	            isLogged = _props.isLogged,
	            onClickLeftMenuBar = _props.onClickLeftMenuBar,
	            onClickRightMenuBar = _props.onClickRightMenuBar;
	
	        var isDashboardPage = window.location.href.includes('dashboard');
	        var appBarStyle = 'app-bar',
	            buttonRightBar = void 0;
	        var appBarContent = null;
	
	        if (isLogged) {
	            var iconButtonElement = React.createElement(IconButton, { className: "right-option-menu", touch: true }, React.createElement(Avatar, { className: "avatar-applicant",
	                src: Security.getCurrentApplicantLogoSrc() }, Security.getCurrentUserName()));
	
	            var exitIcon = React.createElement(FontIcon, { className: "material-icons" }, "exit_to_app");
	            var settingIcon = React.createElement(FontIcon, { className: "material-icons" }, "settings");
	            var printIcon = React.createElement(FontIcon, { className: "material-icons" }, "print");
	
	            appBarStyle += ' is-login';
	
	            buttonRightBar = isDashboardPage ? getIconMenu.call(this, iconButtonElement, settingIcon, printIcon, exitIcon) : React.createElement(IconMenu, { className: "right-menu", ref: "rightMenu", iconButtonElement: iconButtonElement }, React.createElement(Avatar, { className: "avatar-applicant",
	                src: Security.getCurrentApplicantLogoSrc() }, Security.getCurrentUserName()), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
	                value: "settings",
	                leftIcon: settingIcon,
	                primaryText: t('dashboard_menu_settings'),
	                onClick: this._toggleSettingModalShow }), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
	                value: "exit",
	                leftIcon: exitIcon,
	                primaryText: t('dashboard_menu_exit'),
	                onClick: this._onExit }));
	
	            if (!(SessionStore.getCurrentLicense() === Constants.LICENSE_FULL_VERSION || SessionStore.isBasePaidVersion())) {
	                appBarContent = React.createElement("div", { className: "subscribe-message" }, React.createElement("a", { target: "_blank", href: "https://www.brewplanner.com/payment" }, React.createElement("button", { className: "BPButton", style: { color: 'white', fontWeight: 500 } }, "Upgrade")), " ", React.createElement("span", null, Math.floor(14 - Math.floor(SessionStore.getAccountAgeDays())), " days left in you free trial. "));
	            }
	
	            if (SessionStore.isBasePaidVersion() && SessionStore.isTrialVersionActive()) {
	                appBarContent = React.createElement("div", { className: "subscribe-message" }, React.createElement("span", null, "You are currently on the Base plan. There are ", Math.floor(14 - Math.floor(SessionStore.getAccountAgeDays())), " days left in your trial period for MRP! To avoid disruptions, upgrade to the ", React.createElement("a", { href: "https://buy.stripe.com/aEUdRCasg5QKfhm6oo" }, "MRP"), " plan!"));
	            }
	        } else {
	            buttonRightBar = null;
	        }
	
	        return React.createElement("div", { className: 'bp-header ' + (Security.loggedIn() ? ' is-login' : '')
	        }, React.createElement(SettingModal, {
	            isOpen: this.state.isSettingModalOpen,
	            onClose: this._toggleSettingModalShow }), React.createElement(AppBar, {
	            className: appBarStyle,
	            onLeftIconButtonTouchTap: onClickLeftMenuBar,
	            onRightIconButtonTouchTap: onClickRightMenuBar,
	            iconElementRight: buttonRightBar,
	
	            style: { position: 'fixed', top: 0, backgroundColor: '#101112' },
	            ref: "mainAppBar"
	        }, appBarContent));
	    }
	});
	
	function getIconMenu(iconButtonElement, settingIcon, printIcon, exitIcon) {
	    return React.createElement(IconMenu, { className: "right-menu", ref: "rightMenu", iconButtonElement: iconButtonElement }, React.createElement(Avatar, { className: "avatar-applicant",
	        src: Security.getCurrentApplicantLogoSrc() }, Security.getCurrentUserName()), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
	        value: "settings",
	        leftIcon: settingIcon,
	        primaryText: t('dashboard_menu_settings'),
	        onClick: this._toggleSettingModalShow }), React.createElement(MenuItem, {
	        value: "print",
	        leftIcon: printIcon,
	        primaryText: t('dashboard_menu_print_dashboard'),
	        onClick: this._printDashboard }), React.createElement(MenuDivider, null), React.createElement(MenuItem, {
	        value: "exit",
	        leftIcon: exitIcon,
	        primaryText: t('dashboard_menu_exit'),
	        onClick: this._onExit }));
	}
	
	module.exports = {
	    getIconMenu: getIconMenu,
	    Header: Header
	};

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1346);
	
	var React = __webpack_require__(1),
	    AppActionCreators = __webpack_require__(227),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    _require2 = __webpack_require__(12),
	    FlatButton = _require2.FlatButton,
	    _require3 = __webpack_require__(37),
	    delay = _require3.delay,
	    SettingModalTabGeneral = __webpack_require__(729),
	    LocaleServiceImpl = __webpack_require__(407),
	    CustomModal = __webpack_require__(179),
	    _require4 = __webpack_require__(1),
	    PropTypes = _require4.PropTypes,
	    Notification = __webpack_require__(21);
	
	
	var originalState = {
	    codeCurrency: SessionStore.getCurrentCurrency(),
	    codeCountry: SessionStore.getCurrentCountry()
	};
	
	var SettingModal = React.createClass({ displayName: "SettingModal",
	
	    propTypes: {
	        isOpen: PropTypes.bool,
	        onClose: PropTypes.func
	    },
	
	    _modalEl: null,
	
	    getInitialState: function getInitialState() {
	        return originalState;
	    },
	    onChangeSettings: function onChangeSettings(nextState) {
	        this.setState(function (prevState) {
	            return _extends(prevState, nextState);
	        });
	    },
	    _saveAndClose: function _saveAndClose() {
	        var _state = this.state,
	            isVisibleBrewingSection = _state.isVisibleBrewingSection,
	            isVisibleFermentingSection = _state.isVisibleFermentingSection,
	            isVisiblePackagingSection = _state.isVisiblePackagingSection,
	            email = _state.email;
	
	
	        var validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
	        if (email.match(validRegex)) {
	            if (this.state.resultEmail) {
	                if (!isVisibleBrewingSection && !isVisibleFermentingSection && !isVisiblePackagingSection) {
	                    Notification.show(t('setting_modal_all_section_disable_error'), 'error');
	                } else {
	                    LocaleServiceImpl.saveSettingModal(this.state, function () {
	                        Notification.show(t('dashboard_notification_reseting_browser'), 'info');
	                        delay(function () {
	                            AppActionCreators.saveSettingModal();
	                        }, 1999);
	                    });
	                    this._close();
	                }
	            } else {
	                Notification.show(t('setting_modal_general_email_in_use'), 'error');
	            }
	        } else {
	            Notification.show(t('setting_modal_general_email_invalid'), 'error');
	        }
	    },
	    _close: function _close() {
	        this.props.onClose();
	    },
	    _getContentEl: function _getContentEl() {
	        return React.createElement("div", { className: "bp-custom-modal__content bp-setting-modal" }, React.createElement(SettingModalTabGeneral, {
	            onChangeSettings: this.onChangeSettings,
	            resultEmail: this.state.resultEmail }));
	    },
	    _getActionsModal: function _getActionsModal() {
	        return [React.createElement(FlatButton, {
	            style: { 'display': SessionStore.isAdminUser() ? 'inline' : 'none' },
	            label: t('button_label_save'),
	            primary: true,
	            onTouchTap: this._saveAndClose
	        }), React.createElement(FlatButton, {
	            label: t('button_label_cancel'),
	            onTouchTap: this._close
	        })];
	    },
	    render: function render() {
	        var isOpen = this.props.isOpen;
	
	
	        if (!isOpen) {
	            return null;
	        }
	
	        var actionsEl = this._getActionsModal();
	        var contentEl = this._getContentEl();
	
	        return React.createElement(CustomModal, {
	            customClass: "bp-setting-modal",
	            actions: actionsEl,
	            title: t('dashboard_menu_settings'),
	            isVisible: isOpen
	        }, contentEl);
	    }
	});
	
	module.exports = SettingModal;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    Security = __webpack_require__(13).auth,
	    get = __webpack_require__(5).get,
	    Constants = __webpack_require__(2);
	
	var InventoryServiceImpl = {
	    getIconByProduct: function getIconByProduct(productId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/icons/products/' + productId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getProducts: function getProducts(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/products', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getFinishProducts: function getFinishProducts(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/products?state=FINISHED', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getFinishItems: function getFinishItems(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items?category=FINISHED', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getLocation: function getLocation(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/locations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendor: function getVendor(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendorAddresses: function getVendorAddresses(vendorId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendorContacts: function getVendorContacts(vendorId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendorPurchases: function getVendorPurchases(page, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/purchases?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendorPurchasesWithTotalPrice: function getVendorPurchasesWithTotalPrice(page, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/purchases/total-price?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    downloadReportXLS: function downloadReportXLS(filter, controllerName, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            success.bind(this)();
	        }, failure);
	
	        ajax.open('POST', apiAppUrl + '/' + controllerName + '/reports' + RestUtils.formatQueryString(filter), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.responseType = 'arraybuffer';
	        ajax.onload = function () {
	            if (this.status === 200) {
	                var filename = '';
	                var disposition = ajax.getResponseHeader('Content-Disposition');
	                if (disposition && disposition.indexOf('attachment') !== -1) {
	                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	                    var matches = filenameRegex.exec(disposition);
	                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
	                }
	                var type = ajax.getResponseHeader('Content-Type');
	
	                var blob = typeof File === 'function' ? new File([this.response], filename, { type: type }) : new Blob([this.response], { type: type });
	                if (typeof window.navigator.msSaveBlob !== 'undefined') {
	                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
	                    window.navigator.msSaveBlob(blob, filename);
	                } else {
	                    var URL = window.URL || window.webkitURL;
	                    var downloadUrl = URL.createObjectURL(blob);
	
	                    if (filename) {
	                        // use HTML5 a[download] attribute to specify filename
	                        var a = document.createElement('a');
	                        // safari doesn't support this yet
	                        if (typeof a.download === 'undefined') {
	                            window.location = downloadUrl;
	                        } else {
	                            a.href = downloadUrl;
	                            a.download = filename;
	                            document.body.appendChild(a);
	                            a.click();
	                        }
	                    } else {
	                        window.location = downloadUrl;
	                    }
	
	                    setTimeout(function () {
	                        URL.revokeObjectURL(downloadUrl);
	                    }, 100); // cleanup
	                }
	            }
	        };
	        ajax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	        ajax.send();
	    },
	    downloadReportPDF: function downloadReportPDF(filter, controllerName, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            success.bind(this)();
	        }, failure);
	
	        ajax.open('POST', apiAppUrl + '/' + controllerName + '/reports' + RestUtils.formatQueryString(filter), true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.responseType = 'arraybuffer';
	        ajax.onload = function () {
	            if (this.status === 200) {
	                var filename = '';
	                var disposition = ajax.getResponseHeader('Content-Disposition');
	                if (disposition && disposition.indexOf('attachment') !== -1) {
	                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
	                    var matches = filenameRegex.exec(disposition);
	                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
	                }
	                var type = ajax.getResponseHeader('Content-Type');
	
	                var blob = typeof File === 'function' ? new File([this.response], filename, { type: type }) : new Blob([this.response], { type: type });
	                if (typeof window.navigator.msSaveBlob !== 'undefined') {
	                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
	                    window.navigator.msSaveBlob(blob, filename);
	                } else {
	                    var URL = window.URL || window.webkitURL;
	                    var downloadUrl = URL.createObjectURL(blob);
	
	                    if (filename) {
	                        // use HTML5 a[download] attribute to specify filename
	                        var a = document.createElement('a');
	                        // safari doesn't support this yet
	                        if (typeof a.download === 'undefined') {
	                            window.location = downloadUrl;
	                        } else {
	                            a.href = downloadUrl;
	                            a.download = filename;
	                            document.body.appendChild(a);
	                            a.click();
	                        }
	                    } else {
	                        window.location = downloadUrl;
	                    }
	
	                    setTimeout(function () {
	                        URL.revokeObjectURL(downloadUrl);
	                    }, 100); // cleanup
	                }
	            }
	        };
	        ajax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
	        ajax.send();
	    },
	    getVendorPurchasesBy: function getVendorPurchasesBy(filter, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/purchases/filter' + RestUtils.formatQueryString(filter));
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getSales: function getSales(page, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	        ajax.open('GET', apiAppUrl + '/sales?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getSalesBy: function getSalesBy(filter, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	        ajax.open('GET', apiAppUrl + '/sales/filter' + RestUtils.formatQueryString(filter));
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getSaleItems: function getSaleItems(saleId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/sales/' + saleId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getCustomers: function getCustomers(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/customers', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getCustomerAddresses: function getCustomerAddresses(customerId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getCustomerItems: function getCustomerItems(customerId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getCustomerContacts: function getCustomerContacts(customerId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getVendorPurchasesItem: function getVendorPurchasesItem(vendorId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/purchases-items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send();
	    },
	    getItemsByProduct: function getItemsByProduct(productId, isAddition, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items/products/' + productId + '?is-addition=' + isAddition, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getItems: function getItems(page, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getNonInventoryItems: function getNonInventoryItems(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items/non-inventory');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getAllItems: function getAllItems(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items/all');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getItemsBy: function getItemsBy(filter, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/items/filter' + RestUtils.formatQueryString(filter));
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getItemsLocation: function getItemsLocation(pageNumber, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/locations/items?page=' + pageNumber + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getLocationItemsWithTotalAmount: function getLocationItemsWithTotalAmount(pageNumber, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/locations/items/total-amount?page=' + pageNumber + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getLocationItemsWithTotalAmountBy: function getLocationItemsWithTotalAmountBy(filter, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/locations/items/total-amount/filter' + RestUtils.formatQueryString(filter));
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getVendorItems: function getVendorItems(vendorId, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    getIcons: function getIcons(callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/icons', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    addVendorItem: function addVendorItem(vendorId, itemId, vendorItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorItem));
	    },
	    addIcon: function addIcon(icon, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/icons', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(icon));
	    },
	    addVendor: function addVendor(vendor, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendor));
	    },
	    addVendorPurchase: function addVendorPurchase(vendorPurchase, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchase));
	    },
	    duplicateVendorPurchase: function duplicateVendorPurchase(vendorPurchase, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        var purchaseId = get(vendorPurchase, 'purchase.id');
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + purchaseId + '/duplicate', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    markPaidVendorPurchase: function markPaidVendorPurchase(vendorPurchaseId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/paid', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    saveCommentOnlyVendorPurchase: function saveCommentOnlyVendorPurchase(vendorPurchaseId, comment, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/comment', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(comment);
	    },
	    addVendorPurchaseItem: function addVendorPurchaseItem(vendorPurchaseItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchaseItem));
	    },
	    addSale: function addSale(sale, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(sale));
	    },
	    addSaleItem: function addSaleItem(sale, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + sale.saleId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(sale));
	    },
	    addCustomer: function addCustomer(customer, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/customers', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customer));
	    },
	    addCustomerItem: function addCustomerItem(customerId, customerItemId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerItemId));
	    },
	    addCustomerContact: function addCustomerContact(customerId, customerContact, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerContact));
	    },
	    addCustomerAddress: function addCustomerAddress(customerId, customerAddress, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerAddress));
	    },
	    changeSale: function changeSale(sale, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/sales', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(sale));
	    },
	    changeAmountPaidPO: function changeAmountPaidPO(vendorPurchase, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + vendorPurchase.id + '/paidMod', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchase));
	    },
	    changeAmountPaidSO: function changeAmountPaidSO(sale, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + sale.id + '/paidMod', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(sale));
	    },
	    changeSaleItem: function changeSaleItem(sale, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/sales/' + sale.saleId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(sale));
	    },
	    changeCustomer: function changeCustomer(customer, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/customers', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customer));
	    },
	    changeCustomerAddress: function changeCustomerAddress(customerId, customerAddress, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerAddress));
	    },
	    changeCustomerItems: function changeCustomerItems(customerId, customerItemId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerItemId));
	    },
	    changeCustomerContact: function changeCustomerContact(customerId, customerContact, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(customerContact));
	    },
	    addVendorAddress: function addVendorAddress(vendorId, address, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(address));
	    },
	    addVendorContact: function addVendorContact(vendorId, contact, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(contact));
	    },
	    addLocation: function addLocation(location, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/locations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(location));
	    },
	    addProduct: function addProduct(product, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/products', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(product));
	    },
	    duplicateProduct: function duplicateProduct(product, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/products/' + get(product, 'duplicatedId') + '/duplicate', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(product));
	    },
	    addItem: function addItem(item, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(item));
	    },
	    addProductItem: function addProductItem(productId, productItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/items/products/' + productId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(productItem));
	    },
	    addLocationItem: function addLocationItem(locationItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        var locationId = get(locationItem, 'locationId');
	        var itemId = get(locationItem, 'itemId');
	
	        ajax.open('POST', apiAppUrl + '/locations/' + locationId + '/items/' + itemId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(locationItem));
	    },
	    changeProductItem: function changeProductItem(productId, productItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/items/products/' + productId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(productItem));
	    },
	    changeItem: function changeItem(item, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(item));
	    },
	    changeLocationItem: function changeLocationItem(locationItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        var locationId = get(locationItem, 'locationId');
	        var itemId = get(locationItem, 'itemId');
	
	        ajax.open('PUT', apiAppUrl + '/locations/' + locationId + '/items/' + itemId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(locationItem));
	    },
	    changeVendorItem: function changeVendorItem(vendorId, itemId, vendorItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorItem));
	    },
	    changeVendorPurchase: function changeVendorPurchase(vendorPurchase, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchase));
	    },
	    changeVendorPurchaseItem: function changeVendorPurchaseItem(vendorPurchaseItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchaseItem));
	    },
	    changeVendorPurchaseItemReceived: function changeVendorPurchaseItemReceived(vendorPurchaseItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items-received', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchaseItem));
	    },
	    changeVendorPurchaseItemReceivedDraft: function changeVendorPurchaseItemReceivedDraft(vendorPurchaseItem, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items-received/draft', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendorPurchaseItem));
	    },
	    changeProduct: function changeProduct(product, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/products', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(product));
	    },
	    changeIconFromProduct: function changeIconFromProduct(productIdSelected, iconsChanged, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/icons/products/' + productIdSelected, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(iconsChanged));
	    },
	    changeIcon: function changeIcon(iconsChanged, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/icons', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(iconsChanged));
	    },
	    changeVendor: function changeVendor(vendor, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(vendor));
	    },
	    changeVendorAddress: function changeVendorAddress(vendorId, address, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(address));
	    },
	    changeVendorContact: function changeVendorContact(vendorId, contact, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(contact));
	    },
	    changeLocation: function changeLocation(location, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/locations', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(location));
	    },
	    sendVendorPurchaseOrder: function sendVendorPurchaseOrder(vendorPurchaseId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/send', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(location));
	    },
	    sendOrderToCustomer: function sendOrderToCustomer(saleId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/sendEmail', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    confirmVendorPurchaseOrder: function confirmVendorPurchaseOrder(vendorPurchaseId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('PUT', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/confirm', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(location));
	    },
	    confirmSaleOrderDelivered: function confirmSaleOrderDelivered(saleId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText).message);
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/confirm-delivered', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(location));
	    },
	    saveCommentOnlySaleOrder: function saveCommentOnlySaleOrder(saleId, comment, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/comment', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(comment);
	    },
	    markPaidSale: function markPaidSale(saleId, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/paid', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    saveTransfer: function saveTransfer(transferInfo, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        var locationFromId = get(transferInfo, 'locationFromId');
	        var locationToId = get(transferInfo, 'locationToId');
	        var itemId = get(transferInfo, 'itemId');
	
	        ajax.open('POST', apiAppUrl + '/locations/items/' + itemId + '/from/' + locationFromId + '/to/' + locationToId, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(transferInfo));
	    },
	    deleteItem: function deleteItem(productItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/items/' + productItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteSale: function deleteSale(saleId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/sales/' + saleId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteSaleItem: function deleteSaleItem(saleId, saleItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/sales/' + saleId + '/items/' + saleItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteCustomer: function deleteCustomer(customerId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteCustomerContact: function deleteCustomerContact(customerId, customerContactId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/contacts/' + customerContactId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteCustomerAddress: function deleteCustomerAddress(customerId, customerAddressId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/addresses/' + customerAddressId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteCustomerItems: function deleteCustomerItems(customerId, customerItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/items/' + customerItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteLocationItem: function deleteLocationItem(locationItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/locations/items/' + locationItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteLocation: function deleteLocation(locationId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/locations/' + locationId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteVendor: function deleteVendor(vendorId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteVendorAddress: function deleteVendorAddress(vendorId, addressesId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/addresses/' + addressesId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteVendorContact: function deleteVendorContact(vendorId, contactId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/contacts/' + contactId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteVendorItem: function deleteVendorItem(vendorId, itemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteProduct: function deleteProduct(productId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/products/' + productId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deletePurchase: function deletePurchase(purchaseId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/purchases/' + purchaseId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deletePurchaseItem: function deletePurchaseItem(vendorPurchaseItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/vendors/purchase-items/' + vendorPurchaseItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    deleteProductItem: function deleteProductItem(productItemId, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('DELETE', apiAppUrl + '/items/products/' + productItemId);
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    }
	};
	
	module.exports = InventoryServiceImpl;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    _require = __webpack_require__(5),
	    merge = _require.merge,
	    get = __webpack_require__(5).get,
	    LocaleUtils = __webpack_require__(233),
	    Constants = __webpack_require__(2),
	    Security = __webpack_require__(13).auth,
	    hostApi = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API;
	
	
	var LocaleServiceImpl = {
	    saveSettingModal: function saveSettingModal(applicantConfiguration, success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('POST', hostApi + '/applicants/settings');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.send(JSON.stringify(applicantConfiguration));
	    },
	    getApplicantSetting: function getApplicantSetting(success, failure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', hostApi + '/applicants/settings');
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.LOCALE_CUSTOM_HEADER, LocaleUtils.getCurrentLocale());
	        ajax.setRequestHeader(Constants.COUNTRY_CODE_CUSTOM_HEADER, get(Security.getCurrentCountry(), 'cca2'));
	        ajax.setRequestHeader(Constants.CURRENCY_CODE_CUSTOM_HEADER, get(Security.getCurrentCurrency(), 'code'));
	        ajax.send();
	    },
	    getCurrentLocaleInfo: function getCurrentLocaleInfo(onSuccess, onFailure) {
	        var _this = this;
	
	        this.getIP(function (hostIp) {
	            var ip = hostIp && hostIp.ip ? hostIp.ip : '';
	            _this.getCurrentCountry(ip, function (countryInfo) {
	                _this.getTimeZoneInfo(ip, function (timeZoneInfo) {
	                    var allResponses = merge({}, countryInfo, timeZoneInfo);
	                    onSuccess(allResponses);
	                }, onFailure);
	            }, onFailure);
	        }, onFailure);
	    },
	    getTimeZoneInfo: function getTimeZoneInfo(hostIp, onSuccess, onError) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.responseText));
	            });
	        }, onError);
	        var myUrl = 'http://ip-api.com/json?ip=' + hostIp;
	        ajax.open('GET', myUrl);
	        ajax.send();
	    },
	    getCurrentCountry: function getCurrentCountry(hostIp, onSuccess, onError) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.responseText));
	            });
	        }, onError);
	        var myUrl = 'http://www.geoplugin.net/json.gp?ip=' + hostIp;
	        ajax.open('GET', RestUtils.getCORSSafeUrl(myUrl));
	        ajax.send();
	    },
	    getIP: function getIP(onSuccess, onError) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.responseText));
	            });
	        }, onError);
	        ajax.open('GET', 'https://jsonip.com');
	        ajax.send();
	    }
	};
	
	module.exports = LocaleServiceImpl;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API;
	
	var SecurityServiceImpl = {
	
	    login: function login(username, password, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/api/login', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            username: username,
	            password: password
	        }));
	    },
	
	    passwordRecovery: function passwordRecovery(username, password, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/passwordrecovery', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify({
	            username: username,
	            password: password
	        }));
	    },
	
	    getCurrentApplicant: function getCurrentApplicant(token, callback) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                callback.bind(this)();
	            });
	        });
	
	        ajax.open('GET', apiAppUrl + '/api/users/current', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('X-AUTH-TOKEN', token);
	        ajax.send();
	    }
	};
	
	module.exports = SecurityServiceImpl;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var DateUtils = __webpack_require__(22),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    OrderUtils = __webpack_require__(49),
	    NumberUtils = __webpack_require__(23),
	    React = __webpack_require__(1),
	    DashboardServiceCache = __webpack_require__(28),
	    BrewhouseStore = __webpack_require__(96),
	    BeerStyleStore = __webpack_require__(95),
	    OrderStore = __webpack_require__(72),
	    SessionStore = __webpack_require__(11),
	    InventoryStore = __webpack_require__(20),
	    DashboardModalStore = __webpack_require__(155),
	    TankStore = __webpack_require__(97),
	    DashboardModalEl = __webpack_require__(180),
	    DashboardLayoutStore = __webpack_require__(108),
	    DashboardModalUtils = __webpack_require__(50),
	    ChronologycStore = __webpack_require__(76),
	    DashboardModalTaskCollapsible = __webpack_require__(403),
	    _require2 = __webpack_require__(2),
	    SINGLE_TASK = _require2.SINGLE_TASK,
	    DATE_FORMAT = _require2.DATE_FORMAT,
	    DATE_FORMAT_DISPLAY_COMBO_DAY = _require2.DATE_FORMAT_DISPLAY_COMBO_DAY,
	    TYPE_TANK_FERMENTER = _require2.TYPE_TANK_FERMENTER,
	    TYPE_TANK_BRITE_TANK = _require2.TYPE_TANK_BRITE_TANK,
	    TYPE_TANK_BREW_HOUSE = _require2.TYPE_TANK_BREW_HOUSE,
	    moment = __webpack_require__(3),
	    _require3 = __webpack_require__(50),
	    getNonSelectedMenuItem = _require3.getNonSelectedMenuItem,
	    toConcreteTask = _require3.toConcreteTask,
	    getStyleBeer = _require3.getStyleBeer,
	    setTaskIds = _require3.setTaskIds,
	    ContentUtils = __webpack_require__(7),
	    _require4 = __webpack_require__(8),
	    some = _require4.some,
	    map = _require4.map,
	    filter = _require4.filter,
	    find = _require4.find,
	    countBy = _require4.countBy,
	    _require5 = __webpack_require__(48),
	    flatten = _require5.flatten,
	    concat = _require5.concat,
	    findIndex = _require5.findIndex,
	    uniqBy = _require5.uniqBy,
	    head = _require5.head,
	    _require6 = __webpack_require__(53),
	    cloneDeep = _require6.cloneDeep,
	    clone = _require6.clone,
	    _require7 = __webpack_require__(5),
	    assign = _require7.assign,
	    merge = _require7.merge,
	    get = __webpack_require__(5).get,
	    set = __webpack_require__(5).set;
	
	//TODO: no way to relax no-unused-vars from es-lint rule
	React.createClass({
	    render: function render() {}
	});
	
	function _recalculateLayout(nextState) {
	    var ordersFromRange = OrderUtils.getOrderByRange(nextState.fromDate, nextState.toDate);
	    // convert orders to position objects
	    var positionOrders = flatten(map(ordersFromRange, function (order) {
	        return OrderUtils.convertOrderToPositions(order, ChronologycStore.getCurrentFrom(), null, true);
	    }));
	    DashboardModalStore.setCurrentLayout(positionOrders);
	    return nextState;
	}
	
	function getNewModalState(props, isBHAllowed, isFVAllowed, isBTAllowed, currentSection) {
	    var currentTankClicked = get(props, 'preDefinedOrder.tankSelected') || get(props, 'tankSelected');
	
	    var nextState = _getInitialState(props, currentSection, currentTankClicked);
	    nextState = _initMenuItems(nextState, currentTankClicked);
	    nextState = _updateVolume(nextState, ContentUtils.getNumber(get(nextState, 'tankSelected.volume', 0)));
	    nextState = _sinchronizedInnerOuterFromToDates(nextState);
	    nextState = _someProductAlreadyConfirmed(nextState);
	
	    return nextState;
	}
	
	function _someProductAlreadyConfirmed(nextState) {
	    var products = OrderUtils.getAllProductsFromOrder(nextState.order);
	    nextState.isSomeProductAlreadyConfirmed = some(products, function (product) {
	        return get(product, 'isConfirmed');
	    });
	    return nextState;
	}
	
	function _getInitialState(props, currentSection, currentTankClicked) {
	    var nextState = {};
	    var predefinedOrder = get(props, 'preDefinedOrder');
	
	    // define default tank selected
	    var tankSelected = get(props, 'tankSelected');
	    var tankSelectedType = get(tankSelected, 'type');
	    var isCurrentSectionSameAsTankSelectedType = tankSelectedType === currentSection;
	    if (isCurrentSectionSameAsTankSelectedType) {
	        nextState.tankSelected = tankSelected;
	    }
	
	    // define default brewhouse batchs
	    if (currentSection === 'BH') {
	        nextState = set(nextState, 'order.batchs', null);
	    } else {
	        nextState = set(nextState, 'order.batchs', props.isBHAllowed ? [] : null);
	    }
	
	    DashboardModalStore.setCurrentLayout(null);
	    nextState.orderVolumePristine = ContentUtils.getNumber(get(currentTankClicked, 'volume'));
	    nextState.currentSection = currentSection;
	    nextState.fromDate = props.initFromDate;
	    nextState.toDate = props.initFromDate;
	    nextState.isNewModal = true;
	    nextState.isNewModal = true;
	    nextState.toDateMessageError = null;
	    nextState.fromDateMessageError = null;
	    nextState.tankTypeMessageError = null;
	    nextState.styleBeerSelectedIndex = null;
	    nextState.styleBeerSelected = null;
	    nextState.tankMessageError = null;
	    nextState.shouldNeedValidate = true;
	    nextState.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error');
	    nextState.batchNumber = predefinedOrder.batchNumber;
	    nextState.forceDisableToggle = false;
	
	    return nextState;
	}
	
	function getExistingModalState(oldState, isBHAllowed, orderDateClicked) {
	    var nextState = cloneDeep(oldState);
	    var existingOrder = get(nextState, 'order');
	    var tankType = ContentUtils.getTankTypeConfiguration(get(existingOrder, 'singleTank.type'));
	    var typeTask = get(tankType, 'tankType');
	
	    nextState.order = existingOrder;
	    nextState.tankSelected = existingOrder.singleTank;
	    nextState.fromDate = DateUtils.toDate(existingOrder.fromDate);
	    nextState.toDate = DateUtils.toDate(existingOrder.toDate);
	    nextState.singleTasks = setTaskIds(existingOrder.singleTasks, typeTask);
	    nextState.orderVolume = ContentUtils.getNumber(existingOrder.volume);
	    nextState.orderVolumePristine = ContentUtils.getNumber(existingOrder.volume);
	    nextState.dataClicked = orderDateClicked;
	    nextState.toDateMessageError = null;
	    nextState.fromDateMessageError = null;
	    nextState.tankTypeMessageError = null;
	    nextState.tankMessageError = null;
	    nextState.isNewModal = false;
	    nextState.isSingle = true;
	    nextState.commentOrder = existingOrder.comment;
	    nextState.shouldNeedValidate = true;
	    nextState.batchNumber = existingOrder.batchNumber;
	
	    nextState = _recalculateLayout(nextState);
	    nextState = _initMenuItems(nextState, existingOrder.singleTank, get(existingOrder, 'singleTank.type'));
	    nextState = _updateExistingBeerStyle(nextState, existingOrder);
	
	    return nextState;
	}
	
	function _hydratedTasksWithProducts(nextState) {
	    if (SessionStore.isFullPaidVersion()) {
	        var order = get(nextState, 'order');
	        var beerStyleId = get(nextState, 'styleBeerSelected.id');
	        nextState.singleTasks = InventoryStore.hydrateTaskWithProducts(nextState.singleTasks, beerStyleId);
	        order.batchs = InventoryStore.hydrateTaskWithProducts(order.batchs, beerStyleId);
	    }
	    return nextState;
	}
	
	function initializeSingleTasksEl(currentListedTaskTypeSelected, self) {
	    switch (currentListedTaskTypeSelected) {
	        case TYPE_TANK_FERMENTER:
	            return _initializeOrderTasks(self.state.fromDate, self.state.toDate, self.state.singleTasks, self.state.process, DashboardServiceCache.getFermenterIcons(), TYPE_TANK_FERMENTER, self.state.dataClicked, self._onBlurLabelOrDescription, self._onChangeTask, self._onChangeProcess, self._onChangeProducts, self._onChangeAmountItem, self._onChangeVolumeItem, self._onChangeAmountInLocation, self._onConfirmProduct, self);
	        case TYPE_TANK_BRITE_TANK:
	            return _initializeOrderTasks(self.state.fromDate, self.state.toDate, self.state.singleTasks, self.state.process, DashboardServiceCache.getPackagingIcons(), TYPE_TANK_BRITE_TANK, self.state.dataClicked, self._onBlurLabelOrDescription, self._onChangeTask, self._onChangeProcess, self._onChangeProducts, self._onChangeAmountItem, self._onChangeVolumeItem, self._onChangeAmountInLocation, self._onConfirmProduct, self);
	        case TYPE_TANK_BREW_HOUSE:
	            return _initializeOrderTasks(self.state.fromDate, self.state.toDate, self.state.singleTasks, self.state.process, DashboardServiceCache.getBrewhouseIcons(), TYPE_TANK_BREW_HOUSE, self.state.dataClicked, self._onBlurLabelOrDescription, self._onChangeTask, self._onChangeProcess, self._onChangeProducts, self._onChangeAmountItem, self._onChangeVolumeItem, self._onChangeAmountInLocation, self._onConfirmProduct, self);
	    }
	}
	
	function _initializeOrderTasks(fromDate, toDate, singleTasks, orderProcess, tasks, tankType, dateTaskFocus, onBlurLabelOrDescription, onChangeTaskConsumer, onChangeProcess, onChangeProducts, onChangeAmountItem, onChangeVolumeItem, onChangeAmountInLocation, onConfirmProduct, self) {
	    var indexDay = -1,
	        date = void 0,
	        dateTask = void 0,
	        taskEl = [],
	        fromDateText = void 0,
	        toDateText = void 0,
	        existingTask = void 0,
	        existingTasks = void 0,
	        dateTaskFocusText = dateTaskFocus ? DateUtils.toDateText(dateTaskFocus) : null,
	        tankTypeClassName = 'modal-order-task-list-item-label col-xs-2';
	
	    if (DateUtils.isAfter(DateUtils.toDateText(fromDate), DateUtils.toDateText(toDate))) {
	        return;
	    }
	
	    var isEditMode = get(self, 'state.isNewModal') === false || get(self, 'state.isNewModal') === undefined;
	    var shouldBeDisabled = !SessionStore.isAbleToEditAllWithoutDates();
	
	    var existSingleTask = fromDate && toDate && singleTasks;
	
	    if (existSingleTask) {
	        fromDateText = DateUtils.toDateText(fromDate);
	        toDateText = DateUtils.toDateText(toDate);
	
	        do {
	            indexDay++;
	            date = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT_DISPLAY_COMBO_DAY);
	            dateTask = moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT);
	            existingTasks = filter(singleTasks, function (task) {
	                return task.date === dateTask && task.tankType === tankType;
	            });
	
	            var existingProcess = DashboardServiceCache.getProcessByType(tankType);
	
	            // add especial class name to center the focus an specific task, this happen only into edit mode, when double click from dashboard into one task.
	            if (dateTaskFocusText === dateTask) {
	                tankTypeClassName += ' is-focused';
	            }
	
	            if (existingTasks && existingTasks.length > 0) {
	                existingTask = existingTasks[0];
	
	                if (!existingTask.tankType) {
	                    // in chase that `existingTask` don't have tankType, we take this from current TankType of Tank selected.
	                    existingTask.tankType = get(self, 'state.singleTank.type');
	                }
	                // load the rest of the menu list of task, which is the same task type of `existingTask`. In order to
	                // allow each task have their own list of item tasks, just in case if want to change to another of the same type of task.
	                if (!existingTask.tasks) {
	                    existingTask.tasks = DashboardServiceCache.getTasksByType(existingTask.tankType);
	                }
	
	                // assign proper payload to existing task order
	                existingTask.payload = getPayload(existingTask, tasks);
	
	                // Create and ID to later can use to Order Process
	                existingTask.taskId = dateTask + '_' + existingTask.tankType;
	                existingTask.taskIdByTaskType = get(ContentUtils.getTankTypeConfiguration(existingTask.tankType), 'postFixTaskType') + '_' + dateTask;
	                existingTask.sectionType = existingTask.tankType;
	
	                // add default end hour product
	                existingTask = OrderUtils.setDefaultEndHourToProductsOfTask(existingTask, dateTask);
	
	                // custom key
	                var keyAttr = 'key-' + indexDay + '-' + dateTask + '-' + tankType + '-' + existingTask.taskId;
	
	                // Add src task in order to avoid calculate
	                existingTask.imageSrc = get(find(tasks, function (task) {
	                    return task.displayName === existingTask.name;
	                }), 'src');
	
	                // hydrate with all field of each products
	                existingTask = InventoryStore.hydrateProductWithDefaultAmountAndVolume(existingTask);
	
	                taskEl.push(React.createElement(DashboardModalTaskCollapsible, {
	                    onChangeProcess: onChangeProcess,
	                    orderProcess: orderProcess,
	                    onChangeProducts: onChangeProducts,
	                    onChangeAmountItem: onChangeAmountItem,
	                    onChangeAmountInLocation: onChangeAmountInLocation,
	                    onChangeVolumeItem: onChangeVolumeItem,
	                    onConfirmProduct: onConfirmProduct,
	                    date: date,
	                    order: self.state.order,
	                    isEditMode: isEditMode,
	                    uniqueId: keyAttr,
	                    existingProcess: existingProcess,
	                    indexDay: indexDay,
	                    shouldBeDisabled: shouldBeDisabled,
	                    showDeleteIcon: true,
	                    typeTask: existingTask.tankType,
	                    typeTaskClassName: tankTypeClassName,
	                    existingTask: existingTask,
	                    tasks: existingTask.tasks,
	                    onChangeTaskType: onChangeTaskConsumer.bind(self, existingTask.tasks, existingTask, existingTask.tankType, dateTask),
	                    onBlurLabel: self._onChangeName.bind(self, existingTask, tankType, dateTask),
	                    onBlurDescription: self._onChangeNote.bind(self, existingTask, tankType, dateTask),
	                    onToggleExpand: self._onToggleExpand.bind(self, existingTask) }));
	            } else {
	                // custom key
	                var _keyAttr = 'key-' + indexDay + '-' + dateTask + '-' + tankType + '-' + get(existingTasks, 'length', 0);
	
	                existingTask = {
	                    payload: 1,
	                    imageSrc: '',
	                    taskId: dateTask + '_' + tankType,
	                    date: dateTask
	                };
	
	                taskEl.push(React.createElement(DashboardModalTaskCollapsible, {
	                    onChangeProcess: onChangeProcess,
	                    orderProcess: orderProcess,
	                    onChangeProducts: onChangeProducts,
	                    onChangeAmountItem: onChangeAmountItem,
	                    onChangeAmountInLocation: onChangeAmountInLocation,
	                    onConfirmProduct: onConfirmProduct,
	                    onChangeVolumeItem: onChangeVolumeItem,
	                    date: date,
	                    order: self.state.order,
	                    isEditMode: isEditMode,
	                    uniqueId: _keyAttr,
	                    existingTask: existingTask,
	                    existingProcess: existingProcess,
	                    indexDay: indexDay,
	                    shouldBeDisabled: shouldBeDisabled,
	                    showDeleteIcon: false,
	                    typeTask: tankType,
	                    typeTaskClassName: tankTypeClassName,
	                    tasks: tasks,
	                    onChangeTaskType: onChangeTaskConsumer.bind(self, tasks, existingTask, tankType, dateTask),
	                    onBlurLabel: self._onChangeName.bind(self, existingTask, tankType, dateTask),
	                    onBlurDescription: self._onChangeNote.bind(self, existingTask, tankType, dateTask),
	                    onToggleExpand: self._onToggleExpand.bind(self, existingTask) }));
	            }
	        } while (moment(fromDateText, DATE_FORMAT).add(indexDay, 'days').format(DATE_FORMAT) !== toDateText);
	    }
	
	    return taskEl;
	}
	
	function onChangeFromDate(oldState, fromDate, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState.offsetY = ChronologycStore.getYFromDate(DateUtils.toDateText(fromDate)) - ChronologycStore.getYFromDate(DateUtils.toDateText(oldState.fromDate));
	    nextState.fromDate = fromDate;
	    if (nextState.order) {
	        // we need to keep `state.order` up-to in order to perform properly the following validation.
	        nextState.order.fromDate = DateUtils.toDateText(fromDate);
	    }
	    nextState = _recalculateLayout(nextState);
	    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
	    nextState = _recalculateSingleOrderTasks(oldState, nextState);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState); // to avoid data issues
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues
	
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	    nextState.shouldNeedValidate = true;
	
	    return nextState;
	}
	
	function onChangeToDate(oldState, toDate, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState.toDate = toDate;
	    nextState.shouldNeedValidate = true;
	    if (nextState.order) {
	        // we need to keep `state.order` up-to date before submit in order to perform properly the following validation.
	        nextState.order.toDate = DateUtils.toDateText(toDate);
	    }
	    nextState = _recalculateLayout(nextState);
	    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState);
	    nextState = _recalculateSingleOrderTasks(oldState, nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues
	
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	
	    return nextState;
	}
	
	function onChangeFromDateEditMode(oldState, fromDate, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState.fromDate = fromDate;
	    if (nextState.order) {
	        // we need to keep `state.order` up-to in order to perform properly the following validation.
	        nextState.order.fromDate = DateUtils.toDateText(fromDate);
	    }
	    nextState = _recalculateLayout(nextState);
	    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
	    nextState = _recalculateSingleOrderTasks(oldState, nextState);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState); // to avoid data issues
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues
	
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	    nextState.shouldNeedValidate = true;
	
	    return nextState;
	}
	
	function onChangeToDateEditMode(oldState, toDate, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState.toDate = toDate;
	    nextState.shouldNeedValidate = true;
	    if (nextState.order) {
	        // we need to keep `state.order` up-to date before submit in order to perform properly the following validation.
	        nextState.order.toDate = DateUtils.toDateText(toDate);
	    }
	    nextState = _recalculateLayout(nextState);
	    nextState = _initTankMenuItems(nextState, nextState.currentSection, nextState.singleTank);
	    nextState = _recalculateSingleOrderTasks(oldState, nextState);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState); // to avoid data issues
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed); // to avoid data issues
	
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	
	    return nextState;
	}
	
	function onChangeTank(oldState, menuItem) {
	    var nextState = clone(oldState);
	    nextState = _updateTankSelected(nextState, menuItem);
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	
	    return nextState;
	}
	
	function onChangeTankEditMode(oldState, menuItem) {
	    var nextState = clone(oldState);
	    nextState = _updateTankSelected(nextState, menuItem);
	    nextState.shouldNeedValidate = true;
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	
	    return nextState;
	}
	
	function onDeleteTask(singleTasks, dateTask) {
	    var nextState = {
	        singleTasks: filter(singleTasks, function (task) {
	            return task.date !== dateTask;
	        })
	    };
	    nextState.shouldNeedValidate = false;
	
	    return nextState;
	}
	
	/**
	 * Reset all state of the modal.
	 * @argument {HTMLElement} self the context that was invoke
	 * @private
	 */
	function cleanModal(self) {
	    self.setState(_extends({}, {
	        singleOrder: null,
	        dataClicked: null,
	        singleTasks: [],
	        batchs: [],
	        isSuggested: false,
	        styleBeerSelected: null,
	        singleTankIndex: null,
	        isSingleMode: false,
	        order: null,
	        singleTank: null,
	        shouldNeedValidate: false,
	        isBHAllowed: true,
	        isFVAllowed: true,
	        isBTAllowed: true,
	        currentSection: null
	    }, getInitialStateErrorMessages()));
	}
	
	function onChangeBeerStyle(oldState, menuItem, currentSection, isBHAllowed) {
	    var nextState = cloneDeep(oldState) || {};
	    nextState.styleBeerTextColor = 'inherit';
	    nextState.styleBeerSelected = menuItem;
	    nextState.styleBeerSelectedIndex = menuItem.payload;
	    nextState.shouldNeedValidate = true;
	    nextState.isBeerStyleAlreadyDefined = true;
	    nextState = set(nextState, 'order.isSingle', true);
	
	    nextState = _recalculateFromToDate(nextState, currentSection);
	    nextState = _recalculateLayout(nextState);
	    nextState = _updateTankSelected(nextState, nextState.singleTank);
	    nextState = _initInitialTasks(nextState);
	    nextState = _initNewTasksWithConfiguration(nextState, currentSection);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = _hydratedTasksWithProducts(nextState);
	    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
	    nextState = _updateOrderWithScopeEstimation(nextState); // the icons colors inventory
	
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	
	    return nextState;
	}
	
	function _updateOrderWithScopeEstimation(nextState) {
	    var ordersWithInventoryScope = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation([nextState.order].concat(OrderStore.getOrders()));
	    nextState.order = ordersWithInventoryScope.find(function (order) {
	        return order.id === nextState.order.id;
	    });
	    return nextState;
	}
	
	function onChangeVolume(oldState, newVolume, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState = _updateVolume(nextState, newVolume);
	    if (nextState.isNewModal) {
	        nextState = _recalculateSingleTankByVolume(nextState);
	    }
	    nextState = _recalculateLayout(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	    nextState.shouldNeedValidate = true;
	    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);
	
	    return nextState;
	}
	
	function onChangeVolumeNew(oldState, newVolume, isBHAllowed) {
	    var nextState = cloneDeep(oldState);
	    nextState = _updateVolume(nextState, newVolume);
	    var currentSection = get(nextState, 'currentSection');
	
	    nextState = _recalculateSingleTankByVolume(nextState);
	    nextState = _recalculateLayout(nextState);
	    nextState = _initInitialTasks(nextState);
	    nextState = _initNewTasksWithConfiguration(nextState, currentSection);
	    nextState = _sinchronizedInnerOuterFromToDates(nextState);
	    nextState = _recalculateBrewhouse(oldState, nextState, isBHAllowed);
	    nextState = _hydratedTasksWithProducts(nextState);
	    nextState = InventoryStore.hydrateTaskWithProductsAmount(nextState);
	    nextState = merge(nextState, isValidForm(nextState).messagesError);
	    nextState.shouldNeedValidate = true;
	    nextState = DashboardModalUtils.fillEachBatchWithProductMissing(oldState, nextState);
	
	    return nextState;
	}
	
	function onChangeTask(targetValue, existingSingleTask, dateTask, field) {
	    var newTask = find(existingSingleTask, function (task) {
	        return task.date === dateTask;
	    });
	    var nextState = {};
	
	    if (!newTask) {
	        newTask = DashboardModalUtils.toEmptyTask(dateTask);
	        existingSingleTask.push(newTask);
	    }
	
	    newTask[field] = targetValue;
	    nextState.singleTasks = ContentUtils.replace(existingSingleTask, newTask, 'date');
	    return nextState;
	}
	
	/**
	 * Initialize default task.
	 * @param {Object} nextState
	 * @private
	 * @returns {Object}
	 */
	function _initInitialTasks(nextState) {
	    var singleTasks = [];
	    nextState.singleTasks = singleTasks;
	    return nextState;
	}
	
	function getPayload(existingTask, tasks) {
	    var payload = findIndex(tasks, function (task) {
	        return task.name === existingTask.name;
	    });
	    if (payload > -1) {
	        return payload + 1;
	    }
	    return findIndex(tasks, function (task) {
	        return task.displayName === existingTask.name;
	    }) + 1;
	}
	
	function _onChangeTaskType(tasks, oldItemSelected, typeTask, dateTask, state, evt, itemSelected) {
	    var newTask = {},
	        newTasks = [],
	        nextState = {};
	
	    var displayNameIcon = get(itemSelected.itemModel, 'id') === 1 ? 'no-icon' : get(evt, 'text') || get(itemSelected, 'name') || get(itemSelected, 'text') || get(evt, 'target.value');
	    var currentIcon = DashboardServiceCache.findIconByDisplayName(displayNameIcon);
	    // check if exist some existing task before
	    // create a new one from scratch
	    newTask = findExistingTask(dateTask, state, typeTask);
	    if (newTask === undefined) {
	        newTask = {};
	        newTask.date = dateTask;
	        newTask.description = get(itemSelected, 'description') || '', newTask.label = get(itemSelected, 'label') || '', newTask.tankType = typeTask;
	    }
	
	    if (ContentUtils.isEmptyArray(newTask.products)) {
	        newTask.isNewProduct = true;
	    }
	
	    // clean older products
	    newTask.products = [];
	
	    // set the new task icon information
	    newTask.displayName = displayNameIcon;
	    newTask.name = get(currentIcon, 'name') || 'no-icon';
	    newTask.type = SINGLE_TASK;
	    newTask.tankType = typeTask;
	    newTask.tasks = tasks;
	
	    if (oldItemSelected) {
	        newTasks = filter(state.singleTasks, function (packagingTask) {
	            return get(oldItemSelected, 'date') !== packagingTask.date;
	        });
	    } else {
	        newTasks = state.singleTasks;
	    }
	
	    newTask = head(InventoryStore.hydrateTaskWithProducts([newTask], get(state, 'styleBeerSelected.id')));
	    newTasks.push(newTask);
	
	    nextState = { singleTasks: newTasks };
	    state.order.singleTasks = ContentUtils.replaceByAttributes(state.order.singleTasks, newTask, 'date');
	    nextState.shouldNeedValidate = false;
	
	    state.order.totalBatchCost = BrewhouseStore.calculateCostByOrder(state.order, DashboardServiceCache.getVendorItems());
	
	    return assign(state, nextState);
	}
	
	function findExistingTask(date, state) {
	    return find(get(state, 'singleTasks'), function (task) {
	        return task.date === date;
	    });
	}
	
	function _updateExistingBeerStyle(nextState, existingOrder) {
	    var styleBeerSelected = getStyleBeer(nextState.beerStyleMenuItems, existingOrder);
	    nextState.styleBeerSelectedIndex = styleBeerSelected.index;
	    nextState.styleBeerSelected = styleBeerSelected.item;
	
	    return nextState;
	}
	
	function _sinchronizedInnerOuterFromToDates(nextState) {
	    nextState = set(nextState, 'order.fromDate', DateUtils.toDateText(nextState.fromDate));
	    nextState = set(nextState, 'order.toDate', DateUtils.toDateText(nextState.toDate));
	
	    return nextState;
	}
	
	function _updateVolume(nextState, newVolume) {
	
	    if (NumberUtils.containSomeNotNumber(newVolume)) {
	        nextState = set(nextState, 'messagesError.volumenTankMessageError', t('notification_volume_must_be_a_number'));
	        nextState.orderVolume = newVolume;
	        return nextState;
	    } else {
	        nextState = set(nextState, 'messagesError.volumenTankMessageError', '');
	    }
	
	    nextState.orderVolume = ContentUtils.getNumber(newVolume);
	
	    if (!nextState.orderVolume) {
	        // could be --> 0 || null || undefined
	        nextState = set(nextState, 'order.volume', 0);
	        nextState.orderVolume = 0;
	    } else {
	        nextState = set(nextState, 'order.volume', nextState.orderVolume);
	    }
	
	    return nextState;
	}
	
	function _recalculateSingleTankByVolume(state) {
	    var tankVolume = ContentUtils.getNumber(get(state, 'singleTank.volume'));
	    var orderVolume = ContentUtils.getNumber(state.orderVolume);
	
	    if (state.singleTank && tankVolume < orderVolume) {
	        var nextState = cloneDeep(state);
	        var singleTankNext = TankStore.getNextSingleTankAvailable(nextState.fromDate, nextState.toDate, nextState.orderId, nextState.orderVolume, get(nextState, 'tankSelected.type'), DashboardModalStore.getCurrentLayout());
	
	        if (ContentUtils.getNumber(get(singleTankNext, 'volume')) >= ContentUtils.getNumber(state.orderVolume)) {
	            // enter here means that we sure that is time to change the tank available, because found another tank more suitable
	            nextState = _updateTankSelected(nextState, singleTankNext);
	        }
	        return nextState;
	    }
	
	    return state;
	}
	
	function _recalculateBrewhouse(oldState, nextState, isBHAllowed) {
	    var isFVAllowed = nextState.currentSection === 'FV';
	    var isBTAllowed = nextState.currentSection === 'BT';
	
	    if (isBHAllowed === undefined) {
	        isBHAllowed = get(nextState, 'order.batchs.length') > 0;
	    }
	
	    if (countBy([isBHAllowed, isFVAllowed, isBTAllowed], function (num) {
	        return num;
	    }).false === 2 && get(nextState, 'order.batchs.length', 0) === 0) {
	        // enter here means only one toggle is 'ON', so is just a single without brewhouse section
	        return BrewhouseStore.cleanBrewhouse(nextState);
	    }
	
	    if (!isBHAllowed) {
	        // enter here means that the toggle brehouse is off, so is not needed to show brewing tab neither update any batch
	        return BrewhouseStore.cleanBrewhouse(nextState);
	    }
	
	    if (!nextState.orderVolume) {
	        // could be zero, null or undefined
	        // enter here is a new order that should not have batchs
	        return BrewhouseStore.cleanBrewhouse(nextState, []); // default empty array [] in order to still show the brewing tab
	    }
	
	    if (nextState.orderVolume > 0) {
	        // compare old fromDate to new fromDate in order to know the offset
	        var offsetDays = DateUtils.getDaysBetween(oldState.fromDate || nextState.fromDate, nextState.fromDate);
	
	        // enter here means that the order have volume, so need to calculate the batch needed for this volume.
	        nextState.order = BrewhouseStore.recalculateBrewhouseBatchs(merge(nextState.order, {
	            volume: ContentUtils.getNumber(nextState.orderVolume),
	            fromDate: DateUtils.toDateText(nextState.fromDate),
	            toDate: DateUtils.toDateText(nextState.toDate),
	            isSingle: true,
	            isNewModal: nextState.isNewModal
	        }), offsetDays, true, nextState.styleBeerSelected, DashboardModalStore.getCurrentLayout());
	        return nextState;
	    }
	
	    return nextState;
	}
	
	function _checkAvailabilityOfDates(nextState) {
	    var singlePosition = void 0;
	    if (nextState.isNewModal) {
	        singlePosition = TankStore.getSingleTankPosition(nextState);
	    } else {
	        singlePosition = TankStore.getSingleTankPosition(nextState.order);
	    }
	    // validate index in order to not show the error when don't have selected any tank menu item
	    if (nextState.singleTankIndex > -1 && !DashboardLayoutStore.isEmpty(singlePosition, DashboardModalStore.getCurrentLayout())) {
	        return t('dashboard_notification_tank_position_occupied');
	    } else {
	        return '';
	    }
	}
	
	function _recalculateSingleOrderTasks(oldState, nextState) {
	    // remove duplication
	    nextState.singleTasks = uniqBy(nextState.singleTasks, function (l) {
	        return l.date;
	    });
	
	    // Remove unneeded packaging tasks
	    nextState.singleTasks = filter(nextState.singleTasks, function (task) {
	        return DateUtils.isBeforeOrEquals(task.date, DateUtils.toDateText(nextState.toDate)) && DateUtils.isAfterOrEquals(task.date, DateUtils.toDateText(nextState.fromDate));
	    });
	
	    return nextState;
	}
	
	function _initNewTasksWithConfiguration(nextState, currentSection) {
	    if (currentSection === 'BH') {
	        // so we don't want to apply configuration beer style to single Brewhouse section
	        // because the way that work the single from Brewhouse, is different to Fermenting and Packaging
	        // section.
	        return nextState;
	    }
	    // Only into NEW order operation we use the beer style configuration.
	    if (nextState.styleBeerSelected) {
	        // Remove if exist other task configuration apply before in order to allow re-calculate the new days positions.
	        var singleTasks = filter(nextState.singleTasks, function (task) {
	            return !task.isConfiguration;
	        });
	
	        var conf = ContentUtils.getTankTypeConfiguration(get(nextState, 'tankSelected.type') || currentSection);
	        var sectionName = get(conf, 'tankTypeName');
	        var configurationTasks = filter(DashboardServiceCache.getBeerStyleTaskConfiguration(), function (task) {
	            return task.styleBeerId === +nextState.styleBeerSelected.id && task.typeTank === sectionName;
	        }) || [];
	
	        // apply configuration if exist some configuration task
	        if (configurationTasks && configurationTasks.length > 0) {
	            // get only task dates in order to use later
	            var existingDateTask = map(configurationTasks, function (task) {
	                return DateUtils.addDaysTextBasicFormat(nextState.fromDate, task.day - 1);
	            });
	            // remove default task to avoid duplicated task
	            var defaultIconsFiltered = filter(singleTasks, function (task) {
	                return existingDateTask.indexOf(task.date) === -1;
	            });
	            // apply menu item format to single task
	            var configurationConcretTasks = toConcreteTask(configurationTasks, nextState.fromDate, DashboardServiceCache[get(conf, 'getMethodIcons')](), get(nextState, 'tankSelected.type'));
	            // combined default task with configuration task
	            nextState.singleTasks = concat(defaultIconsFiltered, configurationConcretTasks);
	            return nextState;
	        }
	    }
	
	    return nextState;
	}
	
	function _recalculateFromToDate(nextState, tankTypeSelected) {
	    var styleBeerSelected = nextState.styleBeerSelected,
	        fromDate = nextState.fromDate;
	
	    if (styleBeerSelected) {
	        if (tankTypeSelected === TYPE_TANK_FERMENTER) {
	            nextState.offsetY = 0;
	            nextState.toDate = DateUtils.addDays(fromDate, styleBeerSelected.fermenterDays - 1);
	        } else if (tankTypeSelected === TYPE_TANK_BRITE_TANK) {
	            var newFromDate = DateUtils.addDays(nextState.toDate, -Math.abs(styleBeerSelected.packagingDays - 1));
	            nextState.offsetY = DateUtils.getDaysBetween(fromDate, newFromDate); // should need calculate diff
	            nextState.fromDate = newFromDate;
	        }
	        return nextState;
	    } else {
	        return nextState;
	    }
	}
	
	function _initMenuItems(nextState, tankSelected) {
	    var overrideSection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nextState.currentSection;
	
	    nextState = _updateTankSelected(nextState, tankSelected, overrideSection);
	    nextState = _initBeerStyleMenuItems(nextState);
	
	    return nextState;
	}
	
	function _updateTankSelected(nextState, tankSelected) {
	    var overrideSection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : nextState.currentSection;
	
	    // sync tankMenuItems with current section
	    nextState = _initTankMenuItems(nextState, overrideSection, tankSelected);
	    nextState = _initTankType(nextState, overrideSection);
	
	    return nextState;
	}
	
	function _initBeerStyleMenuItems(nextState) {
	    var beerStyleMenuItems = getNonSelectedMenuItem(t('dashboard_modal_general_beer_style_placeholder'));
	    var isNewModal = nextState.isNewModal;
	    var beerStyles = isNewModal ? filter(BeerStyleStore.getBeerStyles(), function (beerStyle) {
	        return beerStyle.enable === true || beerStyle.enable === undefined;
	    }) : BeerStyleStore.getBeerStyles();
	
	    beerStyleMenuItems = concat(beerStyleMenuItems, map(beerStyles, function (beerStyle, index) {
	        return _extends(beerStyle, {
	            payload: index + 1,
	            text: beerStyle.name,
	            locatorId: 'modal-order-beer-style-locator-' + index
	        });
	    }));
	    nextState.beerStyleMenuItems = beerStyleMenuItems;
	
	    return nextState;
	}
	
	function _initTankType(nextState, tankType) {
	    switch (tankType) {
	        case TYPE_TANK_FERMENTER:
	            nextState.listedTaskTypeSelected = { type: TYPE_TANK_FERMENTER };
	            nextState.listedTaskTypeSelectedIndex = 1;
	            nextState.tankType = 1;
	            nextState.tankTypeSelectedIndex = 1;
	            return nextState;
	        case TYPE_TANK_BRITE_TANK:
	            nextState.listedTaskTypeSelected = { type: TYPE_TANK_BRITE_TANK };
	            nextState.listedTaskTypeSelectedIndex = 2;
	            nextState.tankTypeSelectedIndex = 2;
	            nextState.tankType = 2;
	            return nextState;
	        case TYPE_TANK_BREW_HOUSE:
	            nextState.listedTaskTypeSelected = { type: TYPE_TANK_BREW_HOUSE };
	            nextState.listedTaskTypeSelectedIndex = 3;
	            nextState.tankTypeSelectedIndex = 3;
	            nextState.tankType = 3;
	            return nextState;
	        default:
	            return nextState;
	    }
	}
	
	function _initTankMenuItems(nextState, tankType, tankSelected) {
	    var nonSelectedItemText = tankType === TYPE_TANK_BREW_HOUSE ? t('dashboard_modal_task_menu_item_select_turn') : t('dashboard_modal_task_menu_item_select_tank');
	
	    var selectedEmptyTank = getNonSelectedMenuItem(nonSelectedItemText);
	    var tanks = void 0,
	        tanksAvailables = void 0;
	
	    if (nextState.isNewModal) {
	        tanks = TankStore.getAvailabilityTanks(nextState.fromDate, nextState.toDate, tankType, null, DashboardModalStore.getCurrentLayout());
	        tanksAvailables = filter(tanks, function (tank) {
	            return tank.isAvailable;
	        });
	    } else {
	        tanks = TankStore.getAvailabilityTanks(nextState.fromDate, nextState.toDate, tankType, nextState.order.id, DashboardModalStore.getCurrentLayout());
	        tanksAvailables = filter(tanks, function (tank) {
	            return tank.isAvailable;
	        });
	    }
	
	    nextState.tankMenuItems = concat(selectedEmptyTank, DashboardModalUtils.toTankMenuItems(tankType, tanksAvailables));
	
	    nextState = _defineSomeTankSelectionAvailable(nextState, tankSelected, tanksAvailables);
	
	    return nextState;
	}
	
	function _defineSomeTankSelectionAvailable(nextState, tankSelected, tanksAvailables) {
	
	    var tankMenuItems = get(nextState, 'tankMenuItems');
	    var existTankSelected = !!tankSelected;
	    var firstTankAvailable = get(tankMenuItems, '1.tankObj');
	    var existTankAvailable = get(nextState, 'tankMenuItems.length', 0) > 1;
	
	    if (!existTankAvailable) {
	        // enter here means is not longer exist tank available
	        // so we clean current tank selected
	        nextState = _cleanTankSelected(nextState);
	    }
	
	    if (existTankSelected) {
	        var tankSelectedId = get(tankSelected, 'id', get(tankSelected, 'tankObj.id'));
	        tankSelected.id = tankSelectedId; // need to override because same cases id is not there
	        var existTankSelectedInTankMenuItems = !!find(tankMenuItems, function (menuItem) {
	            return get(menuItem, 'tankObj.id') === tankSelectedId;
	        });
	
	        if (existTankSelectedInTankMenuItems) {
	            // remain the same tank selected
	            // just update index and selection
	            // values in case that are not already defined
	            nextState = _setTankSelected(nextState, tankSelected, tanksAvailables);
	            return nextState;
	        } else {
	            nextState = _setTankSelected(nextState, firstTankAvailable, tanksAvailables);
	        }
	    } else {
	        nextState = _setTankSelected(nextState, firstTankAvailable, tanksAvailables);
	    }
	
	    return nextState;
	}
	
	function _cleanTankSelected(nextState) {
	    nextState.singleTank = null;
	    nextState.singleTankId = null;
	    nextState.singleTankIndex = null;
	    nextState.tankSelected = null;
	    return nextState;
	}
	
	function _setTankSelected(nextState, selectedTank, tanks) {
	    // If enter here means that was already cheked the current `selectedTank` as
	    // a available, so just add the `isAvailable` = true in order to reflect that.
	    if (selectedTank) selectedTank.isAvailable = true;
	
	    nextState.singleTank = selectedTank;
	    nextState.singleTankId = get(selectedTank, 'id');
	    nextState.singleTankIndex = findIndex(tanks, function (tank) {
	        return get(selectedTank, 'id') === get(tank, 'id');
	    }) + 1; // select the first available from FV;
	    nextState.tankSelected = selectedTank;
	    return nextState;
	}
	
	function isValidForm(state) {
	    var messagesError = getInitialStateErrorMessages();
	    var isValid = true;
	
	    if (!state.shouldNeedValidate) {
	        return {
	            isValid: isValid,
	            messagesError: messagesError
	        };
	    }
	
	    if (DateUtils.isAfter(DateUtils.toDateText(state.fromDate), DateUtils.toDateText(state.toDate))) {
	        messagesError.fromDateMessageError = t('dashboard_modal_from_date_inline_error');
	        isValid = false;
	    } else {
	        messagesError.fromDateMessageError = _checkAvailabilityOfDates(state);
	        messagesError.toDateMessageError = _checkAvailabilityOfDates(state);
	        if (messagesError.fromDateMessageError !== '' || messagesError.toDateMessageError !== '') {
	            isValid = false;
	        }
	    }
	
	    if (!state.styleBeerSelected || !get(state, 'styleBeerSelected.id')) {
	        messagesError.styleBeerMessageError = t('dashboard_modal_general_beer_style_inline_error_required');
	        isValid = false;
	    } else {
	        messagesError.styleBeerMessageError = '';
	    }
	
	    if (get(state, 'tankMenuItems.length') === 1) {
	        messagesError.tankMessageError = t('dashboard_modal_general_tank_inline_error_no_space');
	        isValid = false;
	    } else if (state.singleTankIndex === -1 || !state.singleTank || get(state, 'singleTank.column') === undefined || get(state, 'singleTank.column') < 0) {
	        messagesError.tankMessageError = t('dashboard_modal_general_tank_inline_error_required');
	        isValid = false;
	    } else {
	        messagesError.tankMessageError = '';
	    }
	
	    if (state.tankTypeSelectedIndex === 0) {
	        messagesError.tankTypeMessageError = t('dashboard_modal_general_tank_inline_error_section_required');
	        isValid = false;
	    } else {
	        messagesError.tankTypeMessageError = '';
	    }
	
	    var orderVolume = ContentUtils.getNumber(get(state, 'orderVolume', 0));
	    var tankVolume = ContentUtils.getNumber(get(state, 'singleTank.volume', 0));
	
	    var brewhouseMessageError = get(state, 'order.brewhouseMessageError');
	
	    if (brewhouseMessageError) {
	        messagesError.volumenTankMessageError = brewhouseMessageError;
	        isValid = false;
	    } else if (get(state, 'messagesError.volumenTankMessageError.length') > 0) {
	        isValid = false;
	        messagesError.volumenTankMessageError = get(state, 'messagesError.volumenTankMessageError');
	    } else if (tankVolume < orderVolume) {
	        messagesError.volumenTankMessageError = t('dashboard_notification_volume_capacity_insufficient');
	        isValid = false;
	    } else {
	        messagesError.volumenTankMessageError = '';
	    }
	
	    return {
	        isValid: isValid,
	        messagesError: messagesError
	    };
	}
	
	function getInitialStateErrorMessages() {
	    return {
	        toDateMessageError: null,
	        fromDateMessageError: null,
	        listedTaskTypeMessageError: null,
	        styleBeerSelectedMessageError: null,
	        tankTypeMessageError: null,
	        tankMessageError: null
	    };
	}
	
	/**
	 * Show the DashboardModalNew from the current clicked order.
	 */
	function openNewSingleOrder(preDefinedOrder) {
	    DashboardModalEl.openNewOrder(preDefinedOrder);
	}
	/**
	 * Show the DashboardModalChangefrom the existing clicked order.
	 */
	function openExistingSingleOrder(existingOrderInfo) {
	    DashboardModalEl.openExistingSingleOrder(existingOrderInfo);
	}
	
	module.exports = {
	    getNewModalState: getNewModalState,
	    getExistingModalState: getExistingModalState,
	    isValidForm: isValidForm,
	    initializeSingleTasksEl: initializeSingleTasksEl,
	    onDeleteTask: onDeleteTask,
	    onChangeTask: onChangeTask,
	    onChangeFromDate: onChangeFromDate,
	    onChangeFromDateEditMode: onChangeFromDateEditMode,
	    onChangeToDate: onChangeToDate,
	    onChangeToDateEditMode: onChangeToDateEditMode,
	    onChangeBeerStyle: onChangeBeerStyle,
	    onChangeTaskType: _onChangeTaskType,
	    onChangeTank: onChangeTank,
	    onChangeTankEditMode: onChangeTankEditMode,
	    onChangeVolume: onChangeVolume,
	    onChangeVolumeNew: onChangeVolumeNew,
	    cleanModal: cleanModal,
	    openNewSingleOrder: openNewSingleOrder,
	    openExistingSingleOrder: openExistingSingleOrder,
	    hydratedTasksWithProducts: _hydratedTasksWithProducts
	};

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryServiceImpl = __webpack_require__(743),
	    Constants = __webpack_require__(2),
	    TankStore = __webpack_require__(97),
	    Notification = __webpack_require__(21),
	    DashboardServiceCache = __webpack_require__(28),
	    ContentUtils = __webpack_require__(7);
	
	var HistoryStore = {
	    fetchHistories: function fetchHistories(success, failure) {
	        HistoryServiceImpl.getHistories(function () {
	            var histories = ContentUtils.parse(this.responseText);
	            if (success) {
	                success(histories);
	            }
	        }, failure);
	    },
	    saveChangeFields: function saveChangeFields(fieldChanges, success, failure) {
	        HistoryServiceImpl.saveChanges(function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	    restore: function restore(selectedModule, history) {
	        switch (selectedModule) {
	            case Constants.APP_MODULE_ADMIN_TANK:
	                var tankTarget = DashboardServiceCache.getTanks().find(function (tank) {
	                    return tank.id === history.id;
	                });
	                tankTarget.isEnable = true;
	                TankStore.changeTank(tankTarget, function () {
	                    Notification.show('Tank restored');
	                });
	                break;
	        }
	    }
	};
	
	module.exports = HistoryStore;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DashboardServiceImpl = __webpack_require__(132),
	    ContentUtils = __webpack_require__(7);
	
	var IconStore = {
	    fetchIcons: function fetchIcons(success, failure) {
	        DashboardServiceImpl.getIcons(function () {
	            var icons = ContentUtils.parse(this.responseText);
	            if (success) {
	                success(icons);
	            }
	        }, failure);
	    }
	};
	
	module.exports = IconStore;

/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    generateKeyReportByBeerStyle: function generateKeyReportByBeerStyle(infoReport) {
	        var key = 'REPORT_BY_BEER_STYLES';
	
	        if (infoReport.isShowConfirmed) {
	            key += '_CONFIRMED';
	        } else {
	            key += '_PLANNED';
	        }
	
	        if (infoReport.isDetailedByBeerStyle) {
	            key += '_SHOW_DETAIL';
	        } else {
	            key += '_NON_SHOW_DETAIL';
	        }
	
	        switch (infoReport.filterByOptionIndex) {
	            case 0:
	                {
	                    key += '_BY_TOTAL';
	                    break;
	                }
	            case 1:
	                {
	                    key += '_BY_MONTH';
	                    break;
	                }
	            case 2:
	                {
	                    key += '_BY_WEEK';
	                    break;
	                }
	            case 3:
	                {
	                    key += '_BY_DAY';
	                    break;
	                }
	        }
	
	        return key;
	    },
	    generateKeyReportByProduct: function generateKeyReportByProduct(infoReport) {
	        var key = 'REPORT_BY_PRODUCT';
	
	        if (infoReport.isShowConfirmed) {
	            key += '_CONFIRMED';
	        } else {
	            key += '_PLANNED';
	        }
	
	        switch (infoReport.filterByOptionIndex) {
	            case 0:
	                {
	                    key += '_BY_TOTAL';
	                    break;
	                }
	            case 1:
	                {
	                    key += '_BY_MONTH';
	                    break;
	                }
	            case 2:
	                {
	                    key += '_BY_WEEK';
	                    break;
	                }
	            case 3:
	                {
	                    key += '_BY_DAY';
	                    break;
	                }
	        }
	
	        return key;
	    }
	};

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var BrowserUtils = __webpack_require__(185);
	
	/**
	 * Attaches or deattaches a callback from the resize change event
	 * @param  {String}     actionType   determines whether to use addEventListener or removeEventListener
	 * @param  {Function}   callback the handler to be attached
	 */
	function _handleResizeHandlerAttachment(actionType, callback) {
	    var focusableElements = ['input', 'select', 'textarea'],
	        body = document.getElementsByTagName('body')[0],
	        action = actionType === 'add' ? HTMLElement.prototype.addEventListener : HTMLElement.prototype.removeEventListener,
	        safeWindowsAction = actionType === 'add' ? window.addEventListener : window.removeEventListener,
	        delegatedCallback = function delegatedCallback(event) {
	        var targetType = event.target.nodeName.toLowerCase();
	        if (focusableElements.indexOf(targetType) > -1) {
	            callback();
	        }
	    };
	
	    if (BrowserUtils.isMobileNonIPad()) {
	        action.call(body, 'focusin', delegatedCallback, false);
	        action.call(body, 'focusout', delegatedCallback, false);
	        action.call(document, 'orientationchange', callback, false);
	    } else {
	        safeWindowsAction.call(window, 'resize', callback, false);
	    }
	}
	
	/**
	 * Utility set of methods to handle the viewport properties.
	 * @type {Object}
	 */
	var Viewport = {
	
	    /**
	     * Adds a handler to the viewport size change event, considering
	     * also problematic cases in mobile devices
	     * @callback  callback
	     */
	    onResize: function onResize(callback) {
	        _handleResizeHandlerAttachment('add', callback);
	    },
	
	
	    /**
	     * Removes a handler off the viewport size change event
	     * @callback  callback   the handler to be removed
	     */
	    offResize: function offResize(callback) {
	        _handleResizeHandlerAttachment('remove', callback);
	    },
	    isInsideViewport: function isInsideViewport(el) {
	        if (el && el.getBoundingClientRect) {
	            var rect = el.getBoundingClientRect();
	            return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
	        } else {
	            false;
	        }
	    }
	};
	
	module.exports = Viewport;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _require = __webpack_require__(8),
	    filter = _require.filter;
	//const DateUtils = require('utils/DateUtils');
	//const SessionStore = require('stores/SessionStore');
	
	
	var renderedOrdersEl = {}; // using HashMap in memory to perform O(1) constant time
	
	
	function addOrderEl(from, to, orderId, orderEl) {
	    renderedOrdersEl[_getKey(from, to, orderId)] = orderEl;
	}
	
	function addBatchEl(from, to, orderId, orderEl) {
	    renderedOrdersEl[_getKeyBrewing(from, to, orderId)] = orderEl;
	}
	
	function getOrderEl(from, to, orderId) {
	    return renderedOrdersEl[_getKey(from, to, orderId)];
	}
	
	function getBatchEl(from, to, orderId) {
	    return renderedOrdersEl[_getKeyBrewing(from, to, orderId)];
	}
	
	function removeOrder(orderId) {
	    var keys = Object.keys(renderedOrdersEl);
	    var targetKeys = filter(keys, function (key) {
	        return key.indexOf(orderId) > -1;
	    }) || [];
	
	    targetKeys.forEach(function (key) {
	        renderedOrdersEl[key] = undefined;
	    });
	}
	
	function cleanCacheFromDate() /*fromDate*/{
	    /*
	    Object.keys(renderedOrdersEl).forEach(key => {
	        const orderFromDate = key.substring(0, key.indexOf('_'));
	        if (DateUtils.isAfterOrEquals(orderFromDate, fromDate)) {
	            renderedOrdersEl[key] = undefined;
	        }
	    });
	    */
	}
	
	function removeOrderAndCleanCacheScopeInventory() /*orderId*/{
	    //removeOrder(orderId);
	    //cleanCacheFromDate(SessionStore.getMaxScopeInventoryDate());
	}
	
	function _getKey(from, to, orderId) {
	    return from + '_' + to + '_' + orderId;
	}
	
	function _getKeyBrewing(from, to, orderId) {
	    return from + '_' + to + '_' + orderId + '__BH';
	}
	
	function cleanCache() {
	    Object.keys(renderedOrdersEl, function (key) {
	        renderedOrdersEl[key] = undefined;
	    });
	}
	
	module.exports = {
	    getOrderEl: getOrderEl,
	    getBatchEl: getBatchEl,
	    addOrderEl: addOrderEl,
	    addBatchEl: addBatchEl,
	    cleanCache: cleanCache,
	    cleanCacheFromDate: cleanCacheFromDate,
	    removeOrder: removeOrder,
	    removeOrderAndCleanCacheScopeInventory: removeOrderAndCleanCacheScopeInventory
	};

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(158);
	
	var callBind = __webpack_require__(235);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 416 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(158);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 418 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(203),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(203),
	    root = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 422 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function assignInDefaults(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = assignInDefaults;


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(193);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the associative array.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function assocDelete(array, key) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = array.length - 1;
	  if (index == lastIndex) {
	    array.pop();
	  } else {
	    splice.call(array, index, 1);
	  }
	  return true;
	}
	
	module.exports = assocDelete;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(193);
	
	/**
	 * Gets the associative array value for `key`.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function assocGet(array, key) {
	  var index = assocIndexOf(array, key);
	  return index < 0 ? undefined : array[index][1];
	}
	
	module.exports = assocGet;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(193);
	
	/**
	 * Checks if an associative array value for `key` exists.
	 *
	 * @private
	 * @param {Array} array The array to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function assocHas(array, key) {
	  return assocIndexOf(array, key) > -1;
	}
	
	module.exports = assocHas;


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(193);
	
	/**
	 * Sets the associative array `key` to `value`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function assocSet(array, key, value) {
	  var index = assocIndexOf(array, key);
	  if (index < 0) {
	    array.push([key, value]);
	  } else {
	    array[index][1] = value;
	  }
	}
	
	module.exports = assocSet;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(161),
	    keys = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var get = __webpack_require__(163);
	
	/**
	 * The base implementation of `_.at` without support for individual paths.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {string[]} paths The property paths of elements to pick.
	 * @returns {Array} Returns the new array of picked elements.
	 */
	function baseAt(object, paths) {
	  var index = -1,
	      isNil = object == null,
	      length = paths.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = isNil ? undefined : get(object, paths[index]);
	  }
	  return result;
	}
	
	module.exports = baseAt;


/***/ },
/* 431 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The base implementation of `_.delay` and `_.defer` which accepts an array
	 * of `func` arguments.
	 *
	 * @private
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {Object} args The arguments to provide to `func`.
	 * @returns {number} Returns the timer id.
	 */
	function baseDelay(func, wait, args) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return setTimeout(function() { func.apply(undefined, args); }, wait);
	}
	
	module.exports = baseDelay;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(457);
	
	/**
	 * This function is like `baseFor` except that it iterates over properties
	 * in the opposite order.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseForRight = createBaseFor(true);
	
	module.exports = baseForRight;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(330),
	    getMatchData = __webpack_require__(345);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value &&
	        (value !== undefined || (key in Object(object)));
	    };
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(198),
	    get = __webpack_require__(163),
	    hasIn = __webpack_require__(487);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseIteratee = __webpack_require__(17),
	    baseMap = __webpack_require__(434),
	    baseSortBy = __webpack_require__(853),
	    compareMultiple = __webpack_require__(864);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1,
	      toIteratee = baseIteratee;
	
	  iteratees = arrayMap(iteratees.length ? iteratees : Array(1), function(iteratee) {
	    return toIteratee(iteratee);
	  });
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(159);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property names.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property names to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return arrayReduce(props, function(result, key) {
	    if (key in object) {
	      result[key] = object[key];
	    }
	    return result;
	  }, {});
	}
	
	module.exports = basePick;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(842);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, predicate) {
	  var result = {};
	  baseForIn(object, function(value, key) {
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  });
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseIndexOf = __webpack_require__(138);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAllBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAllBy(array, values, iteratee) {
	  var index = -1,
	      length = values.length,
	      seen = array;
	
	  if (iteratee) {
	    seen = arrayMap(array, function(value) { return iteratee(value); });
	  }
	  while (++index < length) {
	    var fromIndex = 0,
	        value = values[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    while ((fromIndex = baseIndexOf(seen, computed, fromIndex)) > -1) {
	      if (seen !== array) {
	        splice.call(seen, fromIndex, 1);
	      }
	      splice.call(array, fromIndex, 1);
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAllBy;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(112),
	    isIndex = __webpack_require__(114),
	    isKey = __webpack_require__(86),
	    last = __webpack_require__(62),
	    parent = __webpack_require__(162);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * The base implementation of `_.pullAt` without support for individual
	 * indexes or capturing the removed elements.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {number[]} indexes The indexes of elements to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAt(array, indexes) {
	  var length = array ? indexes.length : 0,
	      lastIndex = length - 1;
	
	  while (length--) {
	    var index = indexes[length];
	    if (lastIndex == length || index != previous) {
	      var previous = index;
	      if (isIndex(index)) {
	        splice.call(array, index, 1);
	      }
	      else if (!isKey(index, array)) {
	        var path = baseCastPath(index),
	            object = parent(array, path);
	
	        if (object != null) {
	          delete object[last(path)];
	        }
	      }
	      else {
	        delete array[index];
	      }
	    }
	  }
	  return array;
	}
	
	module.exports = basePullAt;


/***/ },
/* 442 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */
	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}
	
	module.exports = baseRandom;


/***/ },
/* 443 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseReduce;


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(78),
	    metaMap = __webpack_require__(471);
	
	/**
	 * The base implementation of `setData` without support for hot loop detection.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetData = !metaMap ? identity : function(func, data) {
	  metaMap.set(func, data);
	  return func;
	};
	
	module.exports = baseSetData;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(87);
	
	/**
	 * The base implementation of `_.sortedUniqBy` without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniqBy(array, iteratee) {
	  var index = 0,
	      length = array.length,
	      value = array[0],
	      computed = iteratee ? iteratee(value) : value,
	      seen = computed,
	      resIndex = 0,
	      result = [value];
	
	  while (++index < length) {
	    value = array[index],
	    computed = iteratee ? iteratee(value) : value;
	
	    if (!eq(computed, seen)) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseSortedUniqBy;


/***/ },
/* 446 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the new array of key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 448 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing wrapper metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	 *
	 * @private
	 * @param {Array} props The property names.
	 * @param {Array} values The property values.
	 * @param {Function} assignFunc The function to assign values.
	 * @returns {Object} Returns the new object.
	 */
	function baseZipObject(props, values, assignFunc) {
	  var index = -1,
	      length = props.length,
	      valsLength = values.length,
	      result = {};
	
	  while (++index < length) {
	    assignFunc(result, props[index], index < valsLength ? values[index] : undefined);
	  }
	  return result;
	}
	
	module.exports = baseZipObject;


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(138);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(138);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(420);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var Ctor = arrayBuffer.constructor,
	      result = new Ctor(arrayBuffer.byteLength),
	      view = new Uint8Array(result);
	
	  view.set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 453 */
/***/ function(module, exports) {

	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsNull = value === null,
	        valIsUndef = value === undefined,
	        valIsReflexive = value === value;
	
	    var othIsNull = other === null,
	        othIsUndef = other === undefined,
	        othIsReflexive = other === other;
	
	    if ((value > other && !othIsNull) || !valIsReflexive ||
	        (valIsNull && !othIsUndef && othIsReflexive) ||
	        (valIsUndef && othIsReflexive)) {
	      return 1;
	    }
	    if ((value < other && !valIsNull) || !othIsReflexive ||
	        (othIsNull && !valIsUndef && valIsReflexive) ||
	        (othIsUndef && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 454 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	module.exports = composeArgs;


/***/ },
/* 455 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array|Object} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	module.exports = composeArgsRight;


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 457 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var stringToArray = __webpack_require__(116),
	    toString = __webpack_require__(34);
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);
	
	    var strSymbols = reHasComplexSymbol.test(string)
	      ? stringToArray(string)
	      : undefined;
	
	    var chr = strSymbols ? strSymbols[0] : string.charAt(0),
	        trailing = strSymbols ? strSymbols.slice(1).join('') : string.slice(1);
	
	    return chr[methodName]() + trailing;
	  };
	}
	
	module.exports = createCaseFirst;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(316),
	    baseFlatten = __webpack_require__(43),
	    getData = __webpack_require__(344),
	    getFuncName = __webpack_require__(464),
	    isArray = __webpack_require__(27),
	    isLaziable = __webpack_require__(469),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return rest(function(funcs) {
	    funcs = baseFlatten(funcs, 1);
	
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 &&
	          isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(454),
	    composeArgsRight = __webpack_require__(455),
	    countHolders = __webpack_require__(866),
	    createCtorWrapper = __webpack_require__(202),
	    createRecurryWrapper = __webpack_require__(463),
	    getPlaceholder = __webpack_require__(141),
	    reorder = __webpack_require__(896),
	    replaceHolders = __webpack_require__(115),
	    root = __webpack_require__(61);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    ARY_FLAG = 128,
	    FLIP_FLAG = 512;
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        index = length,
	        args = Array(length);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getPlaceholder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtorWrapper(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	module.exports = createHybridWrapper;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(844);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(851),
	    isIterateeCall = __webpack_require__(101),
	    toNumber = __webpack_require__(145);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toNumber(start);
	    start = start === start ? start : 0;
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toNumber(end) || 0;
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : (toNumber(step) || 0);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(100),
	    isLaziable = __webpack_require__(469),
	    setData = __webpack_require__(473);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurryWrapper(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newArgPos = argPos ? copyArray(argPos) : undefined,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	  var newData = [
	    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	    newHoldersRight, newArgPos, ary, arity
	  ];
	
	  var result = wrapFunc.apply(undefined, newData);
	  if (isLaziable(func)) {
	    setData(result, newData);
	  }
	  result.placeholder = placeholder;
	  return result;
	}
	
	module.exports = createRecurryWrapper;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(895);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(112),
	    isArguments = __webpack_require__(144),
	    isArray = __webpack_require__(27),
	    isIndex = __webpack_require__(114),
	    isKey = __webpack_require__(86),
	    isLength = __webpack_require__(164),
	    isString = __webpack_require__(117),
	    last = __webpack_require__(62),
	    parent = __webpack_require__(162);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  if (object == null) {
	    return false;
	  }
	  var result = hasFunc(object, path);
	  if (!result && !isKey(path)) {
	    path = baseCastPath(path);
	    object = parent(object, path);
	    if (object != null) {
	      path = last(path);
	      result = hasFunc(object, path);
	    }
	  }
	  var length = object ? object.length : undefined;
	  return result || (
	    !!length && isLength(length) && isIndex(path, length) &&
	    (isArray(object) || isString(object) || isArguments(object))
	  );
	}
	
	module.exports = hasPath;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(hash, key) {
	  return nativeCreate ? hash[key] !== undefined : hasOwnProperty.call(hash, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(336),
	    isArguments = __webpack_require__(144),
	    isArray = __webpack_require__(27),
	    isLength = __webpack_require__(164),
	    isString = __webpack_require__(117);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(315),
	    getData = __webpack_require__(344),
	    getFuncName = __webpack_require__(464),
	    lodash = __webpack_require__(1107);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(421);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ },
/* 472 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	module.exports = reInterpolate;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetData = __webpack_require__(444),
	    now = __webpack_require__(496);
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 150,
	    HOT_SPAN = 16;
	
	/**
	 * Sets metadata for `func`.
	 *
	 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	 * period of time, it will trip its breaker and transition to an identity function
	 * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	 * for more details.
	 *
	 * @private
	 * @param {Function} func The function to associate metadata with.
	 * @param {*} data The metadata.
	 * @returns {Function} Returns `func`.
	 */
	var setData = (function() {
	  var count = 0,
	      lastCalled = 0;
	
	  return function(key, value) {
	    var stamp = now(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return key;
	      }
	    } else {
	      count = 0;
	    }
	    return baseSetData(key, value);
	  };
	}());
	
	module.exports = setData;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	function stringToPath(string) {
	  var result = [];
	  toString(string).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = stringToPath;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var ARY_FLAG = 128;
	
	/**
	 * Creates a function that accepts up to `n` arguments, ignoring any
	 * additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} [n=func.length] The arity cap.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	 * // => [6, 8, 10]
	 */
	function ary(func, n, guard) {
	  n = guard ? undefined : n;
	  n = (func && n == null) ? func.length : n;
	  return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	}
	
	module.exports = ary;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(161),
	    createAssigner = __webpack_require__(139),
	    keysIn = __webpack_require__(68);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * function Bar() {
	 *   this.d = 4;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 * Bar.prototype.e = 5;
	 *
	 * _.assignIn({ 'a': 1 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4, 'e': 5 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    isError = __webpack_require__(352),
	    rest = __webpack_require__(16);
	
	/**
	 * Attempts to invoke `func`, returning either the result or the caught error
	 * object. Any additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Function} func The function to attempt.
	 * @returns {*} Returns the `func` result or error object.
	 * @example
	 *
	 * // Avoid throwing errors for invalid selectors.
	 * var elements = _.attempt(function(selector) {
	 *   return document.querySelectorAll(selector);
	 * }, '>_>');
	 *
	 * if (_.isError(elements)) {
	 *   elements = [];
	 * }
	 */
	var attempt = rest(function(func, args) {
	  try {
	    return apply(func, undefined, args);
	  } catch (e) {
	    return isError(e) ? e : new Error(e);
	  }
	});
	
	module.exports = attempt;


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that invokes `func`, with the `this` binding and arguments
	 * of the created function, while it's called less than `n` times. Subsequent
	 * calls to the created function return the result of the last `func` invocation.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {number} n The number of calls at which `func` is no longer invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * jQuery(element).on('click', _.before(5, addContactToList));
	 * // => allows adding up to 4 contacts to the list
	 */
	function before(n, func) {
	  var result;
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n > 0) {
	      result = func.apply(this, arguments);
	    }
	    if (n <= 1) {
	      func = undefined;
	    }
	    return result;
	  };
	}
	
	module.exports = before;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85),
	    getPlaceholder = __webpack_require__(141),
	    replaceHolders = __webpack_require__(115),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and prepends any additional `_.bind` arguments to those provided to the
	 * bound function.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind` this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * var greet = function(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * };
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = rest(function(func, thisArg, partials) {
	  var bitmask = BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getPlaceholder(bind));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrapper(func, bitmask, thisArg, partials, holders);
	});
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46),
	    now = __webpack_require__(496),
	    toNumber = __webpack_require__(145);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide an options object to indicate whether `func` should be invoked on
	 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent calls
	 * to the debounced function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it's invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      leading = false,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(toNumber(options.maxWait) || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    args = maxTimeoutId = thisArg = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function flush() {
	    if ((timeoutId && trailingCall) || (maxTimeoutId && trailing)) {
	      result = func.apply(thisArg, args);
	    }
	    cancel();
	    return result;
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!lastCalled && !maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled);
	
	      var isCalled = (remaining <= 0 || remaining > maxWait) &&
	        (leading || maxTimeoutId);
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(871),
	    toString = __webpack_require__(34);
	
	/** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0';
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.drop([1, 2, 3]);
	 * // => [2, 3]
	 *
	 * _.drop([1, 2, 3], 2);
	 * // => [3]
	 *
	 * _.drop([1, 2, 3], 5);
	 * // => []
	 *
	 * _.drop([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function drop(array, n, guard) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = drop;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Creates a slice of `array` with `n` elements dropped from the end.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to drop.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.dropRight([1, 2, 3]);
	 * // => [1, 2]
	 *
	 * _.dropRight([1, 2, 3], 2);
	 * // => [1]
	 *
	 * _.dropRight([1, 2, 3], 5);
	 * // => []
	 *
	 * _.dropRight([1, 2, 3], 0);
	 * // => [1, 2, 3]
	 */
	function dropRight(array, n, guard) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = dropRight;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var escapeHtmlChar = __webpack_require__(875),
	    toString = __webpack_require__(34);
	
	/** Used to match HTML entities and HTML characters. */
	var reUnescapedHtml = /[&<>"'`]/g,
	    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	/**
	 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
	 * their corresponding HTML entities.
	 *
	 * **Note:** No other characters are escaped. To escape additional
	 * characters use a third-party library like [_he_](https://mths.be/he).
	 *
	 * Though the ">" character is escaped for symmetry, characters like
	 * ">" and "/" don't need escaping in HTML and have no special meaning
	 * unless they're part of a tag or unquoted attribute value.
	 * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	 * (under "semi-related fun fact") for more details.
	 *
	 * Backticks are escaped because in IE < 9, they can break out of
	 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	 * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	 * for more details.
	 *
	 * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	 * to reduce XSS vectors.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escape('fred, barney, & pebbles');
	 * // => 'fred, barney, &amp; pebbles'
	 */
	function escape(string) {
	  string = toString(string);
	  return (string && reHasUnescapedHtml.test(string))
	    ? string.replace(reUnescapedHtml, escapeHtmlChar)
	    : string;
	}
	
	module.exports = escape;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEachRight = __webpack_require__(836),
	    baseCastFunction = __webpack_require__(111),
	    baseEachRight = __webpack_require__(323),
	    isArray = __webpack_require__(27);
	
	/**
	 * This method is like `_.forEach` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @alias eachRight
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @example
	 *
	 * _.forEachRight([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => logs `2` then `1`
	 */
	function forEachRight(collection, iteratee) {
	  return (typeof iteratee == 'function' && isArray(collection))
	    ? arrayEachRight(collection, iteratee)
	    : baseEachRight(collection, baseCastFunction(iteratee));
	}
	
	module.exports = forEachRight;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(328),
	    hasPath = __webpack_require__(465);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': { 'c': 3 } } };
	 * var other = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b.c');
	 * // => true
	 *
	 * _.has(object, ['a', 'b', 'c']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(843),
	    hasPath = __webpack_require__(465);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': _.create({ 'c': 3 }) }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b.c');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b', 'c']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var constant = __webpack_require__(349),
	    root = __webpack_require__(61);
	
	/** Used to determine if values are of the language type `Object`. */
	var objectTypes = {
	  'function': true,
	  'object': true
	};
	
	/** Detect free variable `exports`. */
	var freeExports = (objectTypes[typeof exports] && exports && !exports.nodeType)
	  ? exports
	  : undefined;
	
	/** Detect free variable `module`. */
	var freeModule = (objectTypes[typeof module] && module && !module.nodeType)
	  ? module
	  : undefined;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = (freeModule && freeModule.exports === freeExports)
	  ? freeExports
	  : undefined;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? constant(false) : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(226)(module)))

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	
	/**
	 * Checks if `value` is an integer.
	 *
	 * **Note:** This method is based on [`Number.isInteger`](https://mdn.io/Number/isInteger).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	 * @example
	 *
	 * _.isInteger(3);
	 * // => true
	 *
	 * _.isInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isInteger(Infinity);
	 * // => false
	 *
	 * _.isInteger('3');
	 * // => false
	 */
	function isInteger(value) {
	  return typeof value == 'number' && value == toInteger(value);
	}
	
	module.exports = isInteger;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(67),
	    isHostObject = __webpack_require__(204),
	    isObjectLike = __webpack_require__(47);
	
	/** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(funcToString.call(value));
	  }
	  return isObjectLike(value) &&
	    (isHostObject(value) ? reIsNative : reIsHostCtor).test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && objectToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	function isRegExp(value) {
	  return isObject(value) && objectToString.call(value) == regexpTag;
	}
	
	module.exports = isRegExp;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseIteratee = __webpack_require__(17),
	    baseMap = __webpack_require__(434),
	    isArray = __webpack_require__(27);
	
	/**
	 * Creates an array of values by running each element in `collection` through
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `curry`, `curryRight`, `drop`, `dropRight`, `every`, `fill`,
	 * `invert`, `parseInt`, `random`, `range`, `rangeRight`, `slice`, `some`,
	 * `sortBy`, `take`, `takeRight`, `template`, `trim`, `trimEnd`, `trimStart`,
	 * and `words`
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(332),
	    createAssigner = __webpack_require__(139);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined` merging is handled by the
	 * method instead. The `customizer` is invoked with seven arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 496 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @type {Function}
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = Date.now;
	
	module.exports = now;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85),
	    getPlaceholder = __webpack_require__(141),
	    replaceHolders = __webpack_require__(115),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes `func` with `partial` arguments prepended
	 * to those provided to the new function. This method is like `_.bind` except
	 * it does **not** alter the `this` binding.
	 *
	 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * var greet = function(greeting, name) {
	 *   return greeting + ' ' + name;
	 * };
	 *
	 * var sayHelloTo = _.partial(greet, 'hello');
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 *
	 * // Partially applied with placeholders.
	 * var greetFred = _.partial(greet, _, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 */
	var partial = rest(function(func, partials) {
	  var holders = replaceHolders(partials, getPlaceholder(partial));
	  return createWrapper(func, PARTIAL_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partial.placeholder = {};
	
	module.exports = partial;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(333),
	    basePropertyDeep = __webpack_require__(849),
	    isKey = __webpack_require__(86);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var basePullAll = __webpack_require__(850);
	
	/**
	 * This method is like `_.pull` except that it accepts an array of values to remove.
	 *
	 * **Note:** Unlike `_.difference`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3, 1, 2, 3];
	 *
	 * _.pullAll(array, [2, 3]);
	 * console.log(array);
	 * // => [1, 1]
	 */
	function pullAll(array, values) {
	  return (array && array.length && values && values.length)
	    ? basePullAll(array, values)
	    : array;
	}
	
	module.exports = pullAll;


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31),
	    toString = __webpack_require__(34);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor;
	
	/**
	 * Repeats the given string `n` times.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to repeat.
	 * @param {number} [n=0] The number of times to repeat the string.
	 * @returns {string} Returns the repeated string.
	 * @example
	 *
	 * _.repeat('*', 3);
	 * // => '***'
	 *
	 * _.repeat('abc', 2);
	 * // => 'abcabc'
	 *
	 * _.repeat('abc', 0);
	 * // => ''
	 */
	function repeat(string, n) {
	  string = toString(string);
	  n = toInteger(n);
	
	  var result = '';
	  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	    return result;
	  }
	  // Leverage the exponentiation by squaring algorithm for a faster repeat.
	  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	  do {
	    if (n % 2) {
	      result += string;
	    }
	    n = nativeFloor(n / 2);
	    string += string;
	  } while (n);
	
	  return result;
	}
	
	module.exports = repeat;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(160),
	    baseRandom = __webpack_require__(442),
	    toArray = __webpack_require__(504),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Gets `n` random elements at unique keys from `collection` up to the
	 * size of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @param {number} [n=0] The number of elements to sample.
	 * @returns {Array} Returns the random elements.
	 * @example
	 *
	 * _.sampleSize([1, 2, 3], 2);
	 * // => [3, 1]
	 *
	 * _.sampleSize([1, 2, 3], 4);
	 * // => [2, 3, 1]
	 */
	function sampleSize(collection, n) {
	  var index = -1,
	      result = toArray(collection),
	      length = result.length,
	      lastIndex = length - 1;
	
	  n = baseClamp(toInteger(n), 0, length);
	  while (++index < n) {
	    var rand = baseRandom(index, lastIndex),
	        value = result[rand];
	
	    result[rand] = result[index];
	    result[index] = value;
	  }
	  result.length = n;
	  return result;
	}
	
	module.exports = sampleSize;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var baseSum = __webpack_require__(446),
	    identity = __webpack_require__(78);
	
	/**
	 * Computes the sum of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * _.sum([4, 2, 8, 6]);
	 * // => 20
	 */
	function sum(array) {
	  return (array && array.length)
	    ? baseSum(array, identity)
	    : 0;
	}
	
	module.exports = sum;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var escape = __webpack_require__(484),
	    reEscape = __webpack_require__(893),
	    reEvaluate = __webpack_require__(894),
	    reInterpolate = __webpack_require__(472);
	
	/**
	 * By default, the template delimiters used by lodash are like those in
	 * embedded Ruby (ERB). Change the following template settings to use
	 * alternative delimiters.
	 *
	 * @static
	 * @memberOf _
	 * @type {Object}
	 */
	var templateSettings = {
	
	  /**
	   * Used to detect `data` property values to be HTML-escaped.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'escape': reEscape,
	
	  /**
	   * Used to detect code to be evaluated.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'evaluate': reEvaluate,
	
	  /**
	   * Used to detect `data` property values to inject.
	   *
	   * @memberOf _.templateSettings
	   * @type {RegExp}
	   */
	  'interpolate': reInterpolate,
	
	  /**
	   * Used to reference the data object in the template text.
	   *
	   * @memberOf _.templateSettings
	   * @type {string}
	   */
	  'variable': '',
	
	  /**
	   * Used to import variables into the compiled template.
	   *
	   * @memberOf _.templateSettings
	   * @type {Object}
	   */
	  'imports': {
	
	    /**
	     * A reference to the `lodash` function.
	     *
	     * @memberOf _.templateSettings.imports
	     * @type {Function}
	     */
	    '_': { 'escape': escape }
	  }
	};
	
	module.exports = templateSettings;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    copyArray = __webpack_require__(100),
	    getTag = __webpack_require__(142),
	    isArrayLike = __webpack_require__(66),
	    isString = __webpack_require__(117),
	    iteratorToArray = __webpack_require__(470),
	    mapToArray = __webpack_require__(347),
	    setToArray = __webpack_require__(206),
	    stringToArray = __webpack_require__(116),
	    values = __webpack_require__(209);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var iteratorSymbol = typeof (iteratorSymbol = Symbol && Symbol.iterator) == 'symbol' ? iteratorSymbol : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (iteratorSymbol && value[iteratorSymbol]) {
	    return iteratorToArray(value[iteratorSymbol]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(160),
	    toInteger = __webpack_require__(31);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Converts `value` to an integer suitable for use as the length of an
	 * array-like object.
	 *
	 * **Note:** This method is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toLength(3);
	 * // => 3
	 *
	 * _.toLength(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toLength(Infinity);
	 * // => 4294967295
	 *
	 * _.toLength('3');
	 * // => 3
	 */
	function toLength(value) {
	  return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	}
	
	module.exports = toLength;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(447),
	    keys = __webpack_require__(54);
	
	/**
	 * Creates an array of own enumerable key-value pairs for `object` which
	 * can be consumed by `_.fromPairs`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	function toPairs(object) {
	  return baseToPairs(object, keys(object));
	}
	
	module.exports = toPairs;


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(161),
	    keysIn = __webpack_require__(68);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is given the ID is appended to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {string} [prefix=''] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return toString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    arrayMap = __webpack_require__(45),
	    unzip = __webpack_require__(357);
	
	/**
	 * This method is like `_.unzip` except that it accepts `iteratee` to specify
	 * how regrouped values should be combined. The iteratee is invoked with the
	 * elements of each group: (...group).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array of grouped elements to process.
	 * @param {Function} [iteratee=_.identity] The function to combine regrouped values.
	 * @returns {Array} Returns the new array of regrouped elements.
	 * @example
	 *
	 * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	 * // => [[1, 10, 100], [2, 20, 200]]
	 *
	 * _.unzipWith(zipped, _.add);
	 * // => [3, 30, 300]
	 */
	function unzipWith(array, iteratee) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  var result = unzip(array);
	  if (iteratee == null) {
	    return result;
	  }
	  return arrayMap(result, function(group) {
	    return apply(iteratee, undefined, group);
	  });
	}
	
	module.exports = unzipWith;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(458);
	
	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');
	
	module.exports = upperFirst;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'attempt': __webpack_require__(477),
	  'bindAll': __webpack_require__(909),
	  'cond': __webpack_require__(921),
	  'conforms': __webpack_require__(922),
	  'constant': __webpack_require__(349),
	  'flow': __webpack_require__(957),
	  'flowRight': __webpack_require__(958),
	  'identity': __webpack_require__(78),
	  'iteratee': __webpack_require__(998),
	  'matches': __webpack_require__(1008),
	  'matchesProperty': __webpack_require__(1009),
	  'method': __webpack_require__(1015),
	  'methodOf': __webpack_require__(1016),
	  'mixin': __webpack_require__(1019),
	  'noop': __webpack_require__(356),
	  'nthArg': __webpack_require__(1021),
	  'over': __webpack_require__(1026),
	  'overEvery': __webpack_require__(1028),
	  'overSome': __webpack_require__(1029),
	  'property': __webpack_require__(498),
	  'propertyOf': __webpack_require__(1038),
	  'range': __webpack_require__(1042),
	  'rangeRight': __webpack_require__(1043),
	  'times': __webpack_require__(1083),
	  'toPath': __webpack_require__(1086),
	  'uniqueId': __webpack_require__(508)
	};


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsQuoteRange = '\\u2018\\u2019\\u201c\\u201d',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsQuoteRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match non-compound words composed of alphanumeric characters. */
	var reBasicWord = /[a-zA-Z0-9]+/g;
	
	/** Used to match complex or compound words. */
	var reComplexWord = RegExp([
	  rsUpper + '?' + rsLower + '+(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsUpperMisc + '+(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
	  rsUpper + '?' + rsLowerMisc + '+',
	  rsUpper + '+',
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasComplexWord = /[a-z][A-Z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    pattern = reHasComplexWord.test(string) ? reComplexWord : reBasicWord;
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var StylePropable = __webpack_require__(6);
	var Colors = __webpack_require__(56);
	
	var Avatar = React.createClass({
	  displayName: 'Avatar',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    backgroundColor: React.PropTypes.string,
	    color: React.PropTypes.string,
	    icon: React.PropTypes.element,
	    size: React.PropTypes.number,
	    src: React.PropTypes.string,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      backgroundColor: Colors.grey400,
	      color: Colors.white,
	      size: 40
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var backgroundColor = _props.backgroundColor;
	    var color = _props.color;
	    var icon = _props.icon;
	    var size = _props.size;
	    var src = _props.src;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['backgroundColor', 'color', 'icon', 'size', 'src', 'style']);
	
	    var styles = {
	      root: {
	        height: size,
	        width: size,
	        userSelect: 'none',
	        borderRadius: '50%',
	        display: 'inline-block'
	      }
	    };
	
	    if (src) {
	      var borderColor = this.context.muiTheme.component.avatar.borderColor;
	
	      if (borderColor) {
	        styles.root = this.mergeStyles(styles.root, {
	          height: size - 2,
	          width: size - 2,
	          border: 'solid 1px ' + borderColor
	        });
	      }
	
	      return React.createElement('img', _extends({}, other, { src: src, style: this.mergeAndPrefix(styles.root, style) }));
	    } else {
	      styles.root = this.mergeStyles(styles.root, {
	        backgroundColor: backgroundColor,
	        textAlign: 'center',
	        lineHeight: size + 'px',
	        fontSize: size / 2 + 4,
	        color: color
	      });
	
	      var styleIcon = {
	        margin: 8
	      };
	
	      var iconElement = icon ? React.cloneElement(icon, {
	        color: color,
	        style: this.mergeStyles(styleIcon, icon.props.style)
	      }) : null;
	
	      return React.createElement(
	        'div',
	        _extends({}, other, { style: this.mergeAndPrefix(styles.root, style) }),
	        iconElement,
	        this.props.children
	      );
	    }
	  }
	});
	
	module.exports = Avatar;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var BeforeAfterWrapper = React.createClass({
	  displayName: 'BeforeAfterWrapper',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    beforeStyle: React.PropTypes.object,
	    afterStyle: React.PropTypes.object,
	    beforeElementType: React.PropTypes.string,
	    afterElementType: React.PropTypes.string,
	    elementType: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      beforeElementType: 'div',
	      afterElementType: 'div',
	      elementType: 'div'
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var beforeStyle = _props.beforeStyle;
	    var afterStyle = _props.afterStyle;
	    var beforeElementType = _props.beforeElementType;
	    var afterElementType = _props.afterElementType;
	    var elementType = _props.elementType;
	
	    var other = _objectWithoutProperties(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	
	    var beforeElement = undefined,
	        afterElement = undefined;
	
	    beforeStyle = AutoPrefix.all({ boxSizing: 'border-box' });
	    afterStyle = AutoPrefix.all({ boxSizing: 'border-box' });
	
	    if (this.props.beforeStyle) beforeElement = React.createElement(this.props.beforeElementType, {
	      style: this.mergeAndPrefix(beforeStyle, this.props.beforeStyle),
	      key: "::before"
	    });
	    if (this.props.afterStyle) afterElement = React.createElement(this.props.afterElementType, {
	      style: this.mergeAndPrefix(afterStyle, this.props.afterStyle),
	      key: "::after"
	    });
	
	    var children = [beforeElement, this.props.children, afterElement];
	
	    var props = other;
	    props.style = this.props.style;
	
	    return React.createElement(this.props.elementType, props, children);
	  }
	
	});
	
	module.exports = BeforeAfterWrapper;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var Extend = __webpack_require__(368);
	var OpenIcon = __webpack_require__(1155);
	var CloseIcon = __webpack_require__(1154);
	var IconButton = __webpack_require__(168);
	var StylePropable = __webpack_require__(6);
	
	var CardExpandable = React.createClass({
	  displayName: 'CardExpandable',
	
	  mixins: [StylePropable],
	
	  getStyles: function getStyles() {
	    var contextProps = this.getContextProps();
	
	    var directionStyle = contextProps.isRtl ? {
	      left: 4
	    } : {
	      right: 4
	    };
	
	    return {
	      root: Extend({
	        top: 0,
	        bottom: 0,
	        margin: 'auto',
	        position: 'absolute'
	      }, directionStyle)
	    };
	  },
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    onExpanding: React.PropTypes.func.isRequired,
	    expanded: React.PropTypes.bool
	  },
	
	  getContextProps: function getContextProps() {
	    var theme = this.context.muiTheme;
	
	    return {
	      isRtl: theme.isRtl
	    };
	  },
	
	  _onExpanding: function _onExpanding() {
	    if (this.props.expanded === true) this.props.onExpanding(false);else this.props.onExpanding(true);
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	
	    var expandable = undefined;
	    if (this.props.expanded === true) expandable = React.createElement(OpenIcon, null);else expandable = React.createElement(CloseIcon, null);
	
	    var mergedStyles = this.mergeAndPrefix(styles.root, this.props.style);
	
	    var expandableBtn = React.createElement(
	      IconButton,
	      {
	        style: mergedStyles,
	        onClick: this._onExpanding },
	      expandable
	    );
	
	    return expandableBtn;
	  }
	});
	
	module.exports = CardExpandable;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var WindowListenable = __webpack_require__(89);
	var CssEvent = __webpack_require__(170);
	var KeyCode = __webpack_require__(73);
	var Calendar = __webpack_require__(1128);
	var Dialog = __webpack_require__(359);
	var FlatButton = __webpack_require__(167);
	
	var DatePickerDialog = React.createClass({
	  displayName: 'DatePickerDialog',
	
	  mixins: [StylePropable, WindowListenable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    disableYearSelection: React.PropTypes.bool,
	    initialDate: React.PropTypes.object,
	    maxDate: React.PropTypes.object,
	    minDate: React.PropTypes.object,
	    onAccept: React.PropTypes.func,
	    onClickAway: React.PropTypes.func,
	    onDismiss: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    shouldDisableDate: React.PropTypes.func,
	    showYearSelector: React.PropTypes.bool
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isCalendarActive: false,
	      showMonthDayPicker: true
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var initialDate = _props.initialDate;
	    var onAccept = _props.onAccept;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['initialDate', 'onAccept', 'style']);
	
	    var styles = {
	      root: {
	        color: this.context.muiTheme.component.datePicker.calendarTextColor,
	        fontSize: 14
	      },
	
	      dialogContent: {
	        width: this.props.mode === 'landscape' ? 480 : 320
	      },
	
	      dialogBodyContent: {
	        padding: 0
	      },
	
	      actions: {
	        marginRight: 8
	      }
	    };
	
	    var actions = [React.createElement(FlatButton, {
	      key: 0,
	      label: 'Cancel',
	      secondary: true,
	      style: styles.actions,
	      onTouchTap: this._handleCancelTouchTap })];
	
	    if (!this.props.autoOk) {
	      actions.push(React.createElement(FlatButton, {
	        key: 1,
	        label: 'OK',
	        secondary: true,
	        disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	        style: styles.actions,
	        onTouchTap: this._handleOKTouchTap }));
	    }
	
	    return React.createElement(
	      Dialog,
	      _extends({}, other, {
	        ref: 'dialog',
	        style: styles.root,
	        contentStyle: styles.dialogContent,
	        bodyStyle: styles.dialogBodyContent,
	        actions: actions,
	        onDismiss: this._handleDialogDismiss,
	        onShow: this._handleDialogShow,
	        onClickAway: this._handleDialogClickAway,
	        repositionOnUpdate: false }),
	      React.createElement(Calendar, {
	        ref: 'calendar',
	        onDayTouchTap: this._onDayTouchTap,
	        initialDate: this.props.initialDate,
	        isActive: this.state.isCalendarActive,
	        minDate: this.props.minDate,
	        maxDate: this.props.maxDate,
	        shouldDisableDate: this.props.shouldDisableDate,
	        shouldShowMonthDayPickerFirst: this.state.showMonthDayPicker,
	        showYearSelector: this.props.showYearSelector,
	        mode: this.props.mode })
	    );
	  },
	
	  show: function show() {
	    this.refs.dialog.show();
	  },
	
	  dismiss: function dismiss() {
	    this.refs.dialog.dismiss();
	  },
	
	  _onDayTouchTap: function _onDayTouchTap() {
	    if (this.props.autoOk) {
	      setTimeout(this._handleOKTouchTap, 300);
	    }
	  },
	
	  _handleCancelTouchTap: function _handleCancelTouchTap() {
	    this.dismiss();
	  },
	
	  _handleOKTouchTap: function _handleOKTouchTap() {
	    if (this.props.onAccept && !this.refs.calendar.isSelectedDateDisabled()) {
	      this.props.onAccept(this.refs.calendar.getSelectedDate());
	    }
	
	    this.dismiss();
	  },
	
	  _handleDialogShow: function _handleDialogShow() {
	    this.setState({
	      isCalendarActive: true
	    });
	
	    if (this.props.onShow) this.props.onShow();
	  },
	
	  _handleDialogDismiss: function _handleDialogDismiss() {
	    var _this = this;
	
	    CssEvent.onTransitionEnd(this.refs.dialog.getDOMNode(), function () {
	      _this.setState({
	        isCalendarActive: false,
	        showMonthDayPicker: true
	      });
	    });
	
	    if (this.props.onDismiss) this.props.onDismiss();
	  },
	
	  _handleDialogClickAway: function _handleDialogClickAway() {
	    var _this2 = this;
	
	    CssEvent.onTransitionEnd(this.refs.dialog.getDOMNode(), function () {
	      _this2.setState({
	        isCalendarActive: false,
	        showMonthDayPicker: true
	      });
	    });
	
	    if (this.props.onClickAway) this.props.onClickAway();
	  },
	
	  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
	    if (this.state.isCalendarActive) {
	      switch (e.keyCode) {
	        case KeyCode.ENTER:
	          this._handleOKTouchTap();
	          break;
	      }
	    }
	  }
	
	});
	
	module.exports = DatePickerDialog;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var KeyCode = __webpack_require__(73);
	var DropDownArrow = __webpack_require__(529);
	var Paper = __webpack_require__(55);
	var Menu = __webpack_require__(210);
	var ClearFix = __webpack_require__(166);
	
	var DropDownMenu = React.createClass({
	  displayName: 'DropDownMenu',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	  propTypes: {
	    className: React.PropTypes.string,
	    displayMember: React.PropTypes.string,
	    valueMember: React.PropTypes.string,
	    autoWidth: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    onChange: React.PropTypes.func,
	    menuItems: React.PropTypes.array.isRequired,
	    menuItemStyle: React.PropTypes.object,
	    underlineStyle: React.PropTypes.object,
	    iconStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    selectedIndex: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoWidth: true,
	      disabled: false,
	      valueMember: 'payload',
	      displayMember: 'text'
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false,
	      selectedIndex: this._isControlled() ? null : this.props.selectedIndex || 0
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.autoWidth) this._setWidth();
	    if (this.props.hasOwnProperty('selectedIndex')) this._setSelectedIndex(this.props);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.autoWidth) this._setWidth();
	    if (nextProps.hasOwnProperty('value') || nextProps.hasOwnProperty('valueLink')) {
	      return;
	    } else if (nextProps.hasOwnProperty('selectedIndex')) {
	      this._setSelectedIndex(nextProps);
	    }
	  },
	
	  getStyles: function getStyles() {
	    var disabled = this.props.disabled;
	
	    var zIndex = 5; // As AppBar
	    var spacing = this.context.muiTheme.spacing;
	    var accentColor = this.context.muiTheme.component.dropDownMenu.accentColor;
	    var backgroundColor = this.context.muiTheme.component.menu.backgroundColor;
	    var styles = {
	      root: {
	        transition: Transitions.easeOut(),
	        position: 'relative',
	        display: 'inline-block',
	        height: spacing.desktopSubheaderHeight,
	        fontSize: spacing.desktopDropDownMenuFontSize,
	        outline: 'none'
	      },
	      control: {
	        cursor: disabled ? 'not-allowed' : 'pointer',
	        position: 'static',
	        height: '100%'
	      },
	      controlBg: {
	        transition: Transitions.easeOut(),
	        backgroundColor: backgroundColor,
	        height: '100%',
	        width: '100%',
	        opacity: 0
	      },
	      icon: {
	        position: 'absolute',
	        top: (spacing.desktopToolbarHeight - 24) / 2,
	        right: spacing.desktopGutterLess,
	        fill: this.context.muiTheme.component.dropDownMenu.accentColor
	      },
	      label: {
	        transition: Transitions.easeOut(),
	        lineHeight: spacing.desktopToolbarHeight + 'px',
	        position: 'absolute',
	        paddingLeft: spacing.desktopGutter,
	        top: 0,
	        opacity: 1,
	        color: disabled ? this.context.muiTheme.palette.disabledColor : this.context.muiTheme.palette.textColor
	      },
	      underline: {
	        borderTop: 'solid 1px ' + accentColor,
	        margin: '-1px ' + spacing.desktopGutter + 'px'
	      },
	      menu: {
	        zIndex: zIndex + 1
	      },
	      menuItem: {
	        paddingRight: spacing.iconSize + spacing.desktopGutterLess + spacing.desktopGutterMini,
	        height: spacing.desktopDropDownMenuItemHeight,
	        lineHeight: spacing.desktopDropDownMenuItemHeight + 'px',
	        whiteSpace: 'nowrap'
	      },
	      rootWhenOpen: {
	        opacity: 1
	      },
	      labelWhenOpen: {
	        opacity: 0,
	        top: spacing.desktopToolbarHeight / 2
	      },
	      overlay: {
	        height: '100%',
	        width: '100%',
	        position: 'fixed',
	        top: 0,
	        left: 0,
	        zIndex: zIndex
	      }
	    };
	
	    return styles;
	  },
	
	  getInputNode: function getInputNode() {
	    var root = this.refs.root;
	    var item = this.props.menuItems[this.state.selectedIndex];
	    if (item) {
	      root.value = item[this.props.displayMember];
	    }
	
	    return root;
	  },
	
	  render: function render() {
	    var _this = this;
	    var styles = this.getStyles();
	    var selectedIndex = this._isControlled() ? null : this.state.selectedIndex;
	    var displayValue = "";
	    if (selectedIndex) {
	      if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	        console.assert(!!this.props.menuItems[selectedIndex], 'SelectedIndex of ' + selectedIndex + ' does not exist in menuItems.');
	      }
	    } else {
	      if (this.props.valueMember && this._isControlled()) {
	        var value = this.props.hasOwnProperty('value') ? this.props.value : this.props.valueLink.value;
	        if (value) {
	          for (var i = 0; i < this.props.menuItems.length; i++) {
	            if (this.props.menuItems[i][this.props.valueMember] === value) {
	              selectedIndex = i;
	            }
	          }
	        }
	      }
	    }
	
	    var selectedItem = this.props.menuItems[selectedIndex];
	    if (selectedItem) {
	      displayValue = selectedItem[this.props.displayMember];
	    }
	
	    var menuItems = this.props.menuItems.map(function (item) {
	      item.text = item[_this.props.displayMember];
	      item.payload = item[_this.props.valueMember];
	      return item;
	    });
	
	    return React.createElement(
	      'div',
	      {
	        ref: 'root',
	        onKeyDown: this._onKeyDown,
	        onFocus: this.props.onFocus,
	        onBlur: this.props.onBlur,
	        className: this.props.className,
	        style: this.mergeAndPrefix(styles.root, this.state.open && styles.rootWhenOpen, this.props.style) },
	      React.createElement(
	        ClearFix,
	        { style: this.mergeAndPrefix(styles.control), onTouchTap: this._onControlClick },
	        React.createElement(Paper, { style: this.mergeAndPrefix(styles.controlBg), zDepth: 0 }),
	        React.createElement(
	          'div',
	          { style: this.mergeAndPrefix(styles.label, this.state.open && styles.labelWhenOpen, this.props.labelStyle) },
	          displayValue
	        ),
	        React.createElement(DropDownArrow, { style: this.mergeAndPrefix(styles.icon, this.props.iconStyle) }),
	        React.createElement('div', { style: this.mergeAndPrefix(styles.underline, this.props.underlineStyle) })
	      ),
	      React.createElement(Menu, {
	        ref: 'menuItems',
	        autoWidth: this.props.autoWidth,
	        selectedIndex: selectedIndex,
	        menuItems: menuItems,
	        style: styles.menu,
	        menuItemStyle: this.mergeAndPrefix(styles.menuItem, this.props.menuItemStyle),
	        hideable: true,
	        visible: this.state.open,
	        onRequestClose: this._onMenuRequestClose,
	        onItemTap: this._onMenuItemClick }),
	      this.state.open && React.createElement('div', { style: styles.overlay, onTouchTap: this._handleOverlayTouchTap })
	    );
	  },
	
	  _setWidth: function _setWidth() {
	    var el = React.findDOMNode(this);
	    var menuItemsDom = React.findDOMNode(this.refs.menuItems);
	    if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	      el.style.width = 'auto';
	      el.style.width = menuItemsDom.offsetWidth + 'px';
	    }
	  },
	
	  _setSelectedIndex: function _setSelectedIndex(props) {
	    var selectedIndex = props.selectedIndex;
	
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' && selectedIndex < 0) {
	      console.warn('Cannot set selectedIndex to a negative index.', selectedIndex);
	    }
	
	    this.setState({ selectedIndex: selectedIndex > -1 ? selectedIndex : 0 });
	  },
	
	  _onControlClick: function _onControlClick() {
	    if (!this.props.disabled) {
	      this.setState({ open: !this.state.open });
	    }
	  },
	
	  _onKeyDown: function _onKeyDown(e) {
	    switch (e.which) {
	      case KeyCode.UP:
	        if (!this.state.open) {
	          this._selectPreviousItem();
	        } else {
	          if (e.altKey) {
	            this.setState({ open: false });
	          }
	        }
	        break;
	      case KeyCode.DOWN:
	        if (!this.state.open) {
	          if (e.altKey) {
	            this.setState({ open: true });
	          } else {
	            this._selectNextItem();
	          }
	        }
	        break;
	      case KeyCode.ENTER:
	      case KeyCode.SPACE:
	        this.setState({ open: true });
	        break;
	      default:
	        return; //important
	    }
	    e.preventDefault();
	  },
	
	  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
	    if (this.props.onChange && this.state.selectedIndex !== key) {
	      var selectedItem = this.props.menuItems[key];
	      if (selectedItem) {
	        e.target.value = selectedItem[this.props.valueMember];
	      }
	
	      if (this.props.valueLink) {
	        this.props.valueLink.requestChange(e.target.value);
	      } else {
	        this.props.onChange(e, key, payload);
	      }
	    }
	
	    this.setState({
	      selectedIndex: key,
	      value: e.target.value,
	      open: false
	    });
	  },
	
	  _onMenuRequestClose: function _onMenuRequestClose() {
	    this.setState({ open: false });
	  },
	
	  _selectPreviousItem: function _selectPreviousItem() {
	    this.setState({ selectedIndex: Math.max(this.state.selectedIndex - 1, 0) });
	  },
	
	  _selectNextItem: function _selectNextItem() {
	    this.setState({ selectedIndex: Math.min(this.state.selectedIndex + 1, this.props.menuItems.length - 1) });
	  },
	
	  _handleOverlayTouchTap: function _handleOverlayTouchTap() {
	    this.setState({
	      open: false
	    });
	  },
	
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  }
	
	});
	
	module.exports = DropDownMenu;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var StylePropable = __webpack_require__(6);
	
	var ListDivider = React.createClass({
	  displayName: 'ListDivider',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    inset: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var inset = _props.inset;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['inset', 'style']);
	
	    var mergedStyles = this.mergeAndPrefix({
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: this.context.muiTheme.palette.borderColor
	    }, style);
	
	    return React.createElement('hr', _extends({}, other, { style: mergedStyles }));
	  }
	});
	
	module.exports = ListDivider;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var ColorManipulator = __webpack_require__(102);
	var StylePropable = __webpack_require__(6);
	var Colors = __webpack_require__(56);
	var Transitions = __webpack_require__(24);
	var Typography = __webpack_require__(119);
	var EnhancedButton = __webpack_require__(88);
	var IconButton = __webpack_require__(168);
	var OpenIcon = __webpack_require__(1156);
	var CloseIcon = __webpack_require__(529);
	var NestedList = __webpack_require__(1139);
	
	var ListItem = React.createClass({
	  displayName: 'ListItem',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    autoGenerateNestedIndicator: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    disableKeyboardFocus: React.PropTypes.bool,
	    initiallyOpen: React.PropTypes.bool,
	    innerDivStyle: React.PropTypes.object,
	    insetChildren: React.PropTypes.bool,
	    innerStyle: React.PropTypes.object,
	    leftAvatar: React.PropTypes.element,
	    leftCheckbox: React.PropTypes.element,
	    leftIcon: React.PropTypes.element,
	    nestedLevel: React.PropTypes.number,
	    nestedItems: React.PropTypes.arrayOf(React.PropTypes.element),
	    onKeyboardFocus: React.PropTypes.func,
	    onMouseEnter: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    onNestedListToggle: React.PropTypes.func,
	    onTouchStart: React.PropTypes.func,
	    rightAvatar: React.PropTypes.element,
	    rightIcon: React.PropTypes.element,
	    rightIconButton: React.PropTypes.element,
	    rightToggle: React.PropTypes.element,
	    primaryText: React.PropTypes.node,
	    secondaryText: React.PropTypes.node,
	    secondaryTextLines: React.PropTypes.oneOf([1, 2])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoGenerateNestedIndicator: true,
	      initiallyOpen: false,
	      nestedItems: [],
	      nestedLevel: 0,
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseLeave: function onMouseLeave() {},
	      onNestedListToggle: function onNestedListToggle() {},
	      onTouchStart: function onTouchStart() {},
	      secondaryTextLines: 1
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: this.props.initiallyOpen,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var autoGenerateNestedIndicator = _props.autoGenerateNestedIndicator;
	    var children = _props.children;
	    var disabled = _props.disabled;
	    var disableKeyboardFocus = _props.disableKeyboardFocus;
	    var innerDivStyle = _props.innerDivStyle;
	    var insetChildren = _props.insetChildren;
	    var leftAvatar = _props.leftAvatar;
	    var leftCheckbox = _props.leftCheckbox;
	    var leftIcon = _props.leftIcon;
	    var nestedItems = _props.nestedItems;
	    var nestedLevel = _props.nestedLevel;
	    var onKeyboardFocus = _props.onKeyboardFocus;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var onTouchStart = _props.onTouchStart;
	    var rightAvatar = _props.rightAvatar;
	    var rightIcon = _props.rightIcon;
	    var rightIconButton = _props.rightIconButton;
	    var rightToggle = _props.rightToggle;
	    var primaryText = _props.primaryText;
	    var secondaryText = _props.secondaryText;
	    var secondaryTextLines = _props.secondaryTextLines;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'onKeyboardFocus', 'onMouseLeave', 'onMouseEnter', 'onTouchStart', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'secondaryText', 'secondaryTextLines', 'style']);
	
	    var textColor = this.context.muiTheme.palette.textColor;
	    var hoverColor = ColorManipulator.fade(textColor, 0.1);
	    var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	    var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	    var twoLine = secondaryText && secondaryTextLines === 1;
	    var threeLine = secondaryText && secondaryTextLines > 1;
	    var hasCheckbox = leftCheckbox || rightToggle;
	
	    var styles = {
	      root: {
	        backgroundColor: (this.state.isKeyboardFocused || this.state.hovered) && !this.state.rightIconButtonHovered && !this.state.rightIconButtonKeyboardFocused ? hoverColor : null,
	        color: textColor,
	        display: 'block',
	        fontSize: 16,
	        lineHeight: '16px',
	        position: 'relative',
	        transition: Transitions.easeOut()
	      },
	
	      //This inner div is needed so that ripples will span the entire container
	      innerDiv: {
	        marginLeft: nestedLevel * this.context.muiTheme.component.listItem.nestedLevelDepth,
	        paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	        paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	        paddingBottom: singleAvatar ? 20 : 16,
	        paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	        position: 'relative'
	      },
	
	      icons: {
	        height: 24,
	        width: 24,
	        display: 'block',
	        position: 'absolute',
	        top: twoLine ? 12 : singleAvatar ? 4 : 0,
	        padding: 12
	      },
	
	      leftIcon: {
	        color: Colors.grey600,
	        fill: Colors.grey600,
	        left: 4
	      },
	
	      rightIcon: {
	        color: Colors.grey400,
	        fill: Colors.grey400,
	        right: 4
	      },
	
	      avatars: {
	        position: 'absolute',
	        top: singleAvatar ? 8 : 16
	      },
	
	      label: {
	        cursor: 'pointer'
	      },
	
	      leftAvatar: {
	        left: 16
	      },
	
	      rightAvatar: {
	        right: 16
	      },
	
	      leftCheckbox: {
	        position: 'absolute',
	        display: 'block',
	        width: 24,
	        top: twoLine ? 24 : singleAvatar ? 16 : 12,
	        left: 16
	      },
	
	      primaryText: {
	        margin: 0
	      },
	
	      rightIconButton: {
	        position: 'absolute',
	        display: 'block',
	        top: twoLine ? 12 : singleAvatar ? 4 : 0,
	        right: 4
	      },
	
	      rightToggle: {
	        position: 'absolute',
	        display: 'block',
	        width: 54,
	        top: twoLine ? 25 : singleAvatar ? 17 : 13,
	        right: 8
	      },
	
	      secondaryText: {
	        fontSize: 14,
	        lineHeight: threeLine ? '18px' : '16px',
	        height: threeLine ? 36 : 16,
	        margin: 0,
	        marginTop: 4,
	        color: Typography.textLightBlack,
	
	        //needed for 2 and 3 line ellipsis
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        whiteSpace: threeLine ? null : 'nowrap',
	        display: threeLine ? '-webkit-box' : null,
	        WebkitLineClamp: threeLine ? 2 : null,
	        WebkitBoxOrient: threeLine ? 'vertical' : null
	      }
	    };
	
	    var contentChildren = [];
	
	    if (leftIcon) {
	      this._pushElement(contentChildren, leftIcon, this.mergeStyles(styles.icons, styles.leftIcon));
	    }
	
	    if (rightIcon) {
	      this._pushElement(contentChildren, rightIcon, this.mergeStyles(styles.icons, styles.rightIcon));
	    }
	
	    if (leftAvatar) {
	      this._pushElement(contentChildren, leftAvatar, this.mergeStyles(styles.avatars, styles.leftAvatar));
	    }
	
	    if (rightAvatar) {
	      this._pushElement(contentChildren, rightAvatar, this.mergeStyles(styles.avatars, styles.rightAvatar));
	    }
	
	    if (leftCheckbox) {
	      this._pushElement(contentChildren, leftCheckbox, this.mergeStyles(styles.leftCheckbox));
	    }
	
	    //RightIconButtonElement
	    var hasNestListItems = nestedItems.length;
	    var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	    var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	    if (rightIconButton || needsNestedIndicator) {
	      var rightIconButtonElement = rightIconButton;
	      var rightIconButtonHandlers = {
	        onKeyboardFocus: this._handleRightIconButtonKeyboardFocus,
	        onMouseEnter: this._handleRightIconButtonMouseEnter,
	        onMouseLeave: this._handleRightIconButtonMouseLeave,
	        onTouchTap: this._handleRightIconButtonTouchTap,
	        onMouseDown: this._handleRightIconButtonMouseUp,
	        onMouseUp: this._handleRightIconButtonMouseUp
	      };
	
	      // Create a nested list indicator icon if we don't have an icon on the right
	      if (needsNestedIndicator) {
	        rightIconButtonElement = this.state.open ? React.createElement(
	          IconButton,
	          null,
	          React.createElement(OpenIcon, null)
	        ) : React.createElement(
	          IconButton,
	          null,
	          React.createElement(CloseIcon, null)
	        );
	        rightIconButtonHandlers.onTouchTap = this._handleNestedListToggle;
	      }
	
	      this._pushElement(contentChildren, rightIconButtonElement, this.mergeStyles(styles.rightIconButton), rightIconButtonHandlers);
	    }
	
	    if (rightToggle) {
	      this._pushElement(contentChildren, rightToggle, this.mergeStyles(styles.rightToggle));
	    }
	
	    if (primaryText) {
	      var secondaryTextElement = this._createTextElement(styles.primaryText, primaryText, 'primaryText');
	      contentChildren.push(secondaryTextElement);
	    }
	
	    if (secondaryText) {
	      var secondaryTextElement = this._createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	      contentChildren.push(secondaryTextElement);
	    }
	
	    var nestedList = nestedItems.length ? React.createElement(
	      NestedList,
	      { nestedLevel: nestedLevel + 1, open: this.state.open },
	      nestedItems
	    ) : undefined;
	
	    return hasCheckbox ? this._createLabelElement(styles, contentChildren) : disabled ? this._createDisabledElement(styles, contentChildren) : React.createElement(
	      'div',
	      null,
	      React.createElement(
	        EnhancedButton,
	        _extends({}, other, {
	          disabled: disabled,
	          disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	          linkButton: true,
	          onKeyboardFocus: this._handleKeyboardFocus,
	          onMouseLeave: this._handleMouseLeave,
	          onMouseEnter: this._handleMouseEnter,
	          onTouchStart: this._handleTouchStart,
	          ref: 'enhancedButton',
	          style: this.mergeAndPrefix(styles.root, style) }),
	        React.createElement(
	          'div',
	          { style: this.mergeAndPrefix(styles.innerDiv, innerDivStyle) },
	          contentChildren
	        )
	      ),
	      nestedList
	    );
	  },
	
	  applyFocusState: function applyFocusState(focusState) {
	    var button = this.refs.enhancedButton;
	    var buttonEl = React.findDOMNode(button);
	
	    if (button) {
	      switch (focusState) {
	        case 'none':
	          buttonEl.blur();
	          break;
	        case 'focused':
	          buttonEl.focus();
	          break;
	        case 'keyboard-focused':
	          button.setKeyboardFocus();
	          buttonEl.focus();
	          break;
	      }
	    }
	  },
	
	  _createDisabledElement: function _createDisabledElement(styles, contentChildren) {
	    var _props2 = this.props;
	    var innerDivStyle = _props2.innerDivStyle;
	    var style = _props2.style;
	
	    var mergedDivStyles = this.mergeAndPrefix(styles.root, styles.innerDiv, innerDivStyle, style);
	
	    return React.createElement('div', { style: mergedDivStyles }, contentChildren);
	  },
	
	  _createLabelElement: function _createLabelElement(styles, contentChildren) {
	    var _props3 = this.props;
	    var innerDivStyle = _props3.innerDivStyle;
	    var style = _props3.style;
	
	    var mergedLabelStyles = this.mergeAndPrefix(styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	    return React.createElement('label', { style: mergedLabelStyles }, contentChildren);
	  },
	
	  _createTextElement: function _createTextElement(styles, data, key) {
	    var isAnElement = React.isValidElement(data);
	    var mergedStyles = isAnElement ? this.mergeStyles(styles, data.props.style) : null;
	
	    return isAnElement ? React.cloneElement(data, {
	      key: key,
	      style: mergedStyles
	    }) : React.createElement(
	      'div',
	      { key: key, style: styles },
	      data
	    );
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, isKeyboardFocused) {
	    this.setState({ isKeyboardFocused: isKeyboardFocused });
	    this.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.state.touch) this.setState({ hovered: true });
	    this.props.onMouseEnter(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    this.props.onMouseLeave(e);
	  },
	
	  _handleNestedListToggle: function _handleNestedListToggle(e) {
	    e.stopPropagation();
	    this.setState({ open: !this.state.open });
	    this.props.onNestedListToggle(this);
	  },
	
	  _handleRightIconButtonKeyboardFocus: function _handleRightIconButtonKeyboardFocus(e, isKeyboardFocused) {
	    var iconButton = this.props.rightIconButton;
	    var newState = {};
	
	    newState.rightIconButtonKeyboardFocused = isKeyboardFocused;
	    if (isKeyboardFocused) newState.isKeyboardFocused = false;
	    this.setState(newState);
	
	    if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(e, isKeyboardFocused);
	  },
	
	  _handleRightIconButtonMouseDown: function _handleRightIconButtonMouseDown(e) {
	    var iconButton = this.props.rightIconButton;
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onMouseDown) iconButton.props.onMouseDown(e);
	  },
	
	  _handleRightIconButtonMouseLeave: function _handleRightIconButtonMouseLeave(e) {
	    var iconButton = this.props.rightIconButton;
	    this.setState({ rightIconButtonHovered: false });
	    if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(e);
	  },
	
	  _handleRightIconButtonMouseEnter: function _handleRightIconButtonMouseEnter(e) {
	    var iconButton = this.props.rightIconButton;
	    this.setState({ rightIconButtonHovered: true });
	    if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(e);
	  },
	
	  _handleRightIconButtonMouseUp: function _handleRightIconButtonMouseUp(e) {
	    var iconButton = this.props.rightIconButton;
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(e);
	  },
	
	  _handleRightIconButtonTouchTap: function _handleRightIconButtonTouchTap(e) {
	    var iconButton = this.props.rightIconButton;
	
	    //Stop the event from bubbling up to the list-item
	    e.stopPropagation();
	    if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(e);
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({ touch: true });
	    this.props.onTouchStart(e);
	  },
	
	  _pushElement: function _pushElement(children, element, baseStyles, additionalProps) {
	    if (element) {
	      var styles = this.mergeStyles(baseStyles, element.props.style);
	      children.push(React.cloneElement(element, _extends({
	        key: children.length,
	        style: styles
	      }, additionalProps)));
	    }
	  }
	
	});
	
	module.exports = ListItem;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var FontIcon = __webpack_require__(118);
	var Toggle = __webpack_require__(536);
	
	var Types = {
	  LINK: 'LINK',
	  SUBHEADER: 'SUBHEADER',
	  NESTED: 'NESTED'
	};
	
	var MenuItem = React.createClass({
	  displayName: 'MenuItem',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    index: React.PropTypes.number.isRequired,
	    className: React.PropTypes.string,
	    iconClassName: React.PropTypes.string,
	    iconRightClassName: React.PropTypes.string,
	    iconStyle: React.PropTypes.object,
	    iconRightStyle: React.PropTypes.object,
	    attribute: React.PropTypes.string,
	    number: React.PropTypes.string,
	    data: React.PropTypes.string,
	    toggle: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    onTouchTap: React.PropTypes.func,
	    onToggle: React.PropTypes.func,
	    selected: React.PropTypes.bool,
	    active: React.PropTypes.bool
	  },
	
	  statics: {
	    Types: Types
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      toggle: false,
	      disabled: false,
	      active: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.menuItem;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        lineHeight: this.getTheme().height + 'px',
	        paddingLeft: this.getTheme().padding,
	        paddingRight: this.getTheme().padding,
	        color: this.context.muiTheme.palette.textColor
	      },
	      number: {
	        float: 'right',
	        width: 24,
	        textAlign: 'center'
	      },
	      attribute: {
	        float: 'right'
	      },
	      iconRight: {
	        lineHeight: this.getTheme().height + 'px',
	        float: 'right'
	      },
	      icon: {
	        float: 'left',
	        lineHeight: this.getTheme().height + 'px',
	        marginRight: this.getSpacing().desktopGutter
	      },
	      data: {
	        display: 'block',
	        paddingLeft: this.getSpacing().desktopGutter * 2,
	        lineHeight: this.getTheme().dataHeight + 'px',
	        height: this.getTheme().dataHeight + 'px',
	        verticalAlign: 'top',
	        top: -12,
	        position: 'relative',
	        fontWeight: 300,
	        color: this.context.muiTheme.palette.textColor
	      },
	      toggle: {
	        marginTop: (this.getTheme().height - this.context.muiTheme.component.radioButton.size) / 2,
	        float: 'right',
	        width: 42
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.context.muiTheme.palette.disabledColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var icon = undefined;
	    var data = undefined;
	    var iconRight = undefined;
	    var attribute = undefined;
	    var number = undefined;
	    var toggleElement = undefined;
	    var styles = this.getStyles();
	
	    if (this.props.iconClassName) icon = React.createElement(FontIcon, { style: this.mergeAndPrefix(styles.icon, this.props.iconStyle, this.props.selected && styles.rootWhenSelected), className: this.props.iconClassName });
	    if (this.props.iconRightClassName) iconRight = React.createElement(FontIcon, { style: this.mergeAndPrefix(styles.iconRight, this.props.iconRightStyle), className: this.props.iconRightClassName });
	    if (this.props.data) data = React.createElement(
	      'span',
	      { style: this.mergeAndPrefix(styles.data) },
	      this.props.data
	    );
	    if (this.props.number !== undefined) number = React.createElement(
	      'span',
	      { style: this.mergeAndPrefix(styles.number) },
	      this.props.number
	    );
	    if (this.props.attribute !== undefined) attribute = React.createElement(
	      'span',
	      { style: this.mergeAndPrefix(styles.style) },
	      this.props.attribute
	    );
	    if (this.props.icon) icon = this.props.icon;
	
	    if (this.props.toggle) {
	      var _props = this.props;
	      var toggle = _props.toggle;
	      var onTouchTap = _props.onTouchTap;
	      var onToggle = _props.onToggle;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var children = _props.children;
	      var label = _props.label;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['toggle', 'onTouchTap', 'onToggle', 'onMouseEnter', 'onMouseLeave', 'children', 'label', 'style']);
	
	      toggleElement = React.createElement(Toggle, _extends({}, other, { onToggle: this._handleToggle, style: styles.toggle }));
	    }
	
	    return React.createElement(
	      'div',
	      {
	        key: this.props.index,
	        className: this.props.className,
	        onTouchTap: this._handleTouchTap,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        style: this.mergeAndPrefix(styles.root, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled) },
	      icon,
	      this.props.children,
	      data,
	      attribute,
	      number,
	      toggleElement,
	      iconRight
	    );
	  },
	
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.index);
	  },
	
	  _handleToggle: function _handleToggle(e, toggled) {
	    if (!this.props.disabled && this.props.onToggle) this.props.onToggle(e, this.props.index, toggled);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e, this.props.index);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e, this.props.index);
	  }
	});
	
	module.exports = MenuItem;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var StylePropable = __webpack_require__(6);
	var ListDivider = __webpack_require__(518);
	
	var MenuDivider = React.createClass({
	  displayName: 'MenuDivider',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var mergedStyles = this.mergeAndPrefix({
	      marginTop: 7,
	      marginBottom: 8
	    }, style);
	
	    return React.createElement(ListDivider, _extends({}, other, { style: mergedStyles }));
	  }
	});
	
	module.exports = MenuDivider;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var Colors = __webpack_require__(56);
	var CheckIcon = __webpack_require__(1157);
	var ListItem = __webpack_require__(519);
	
	var MenuItem = React.createClass({
	  displayName: 'MenuItem',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    checked: React.PropTypes.bool,
	    desktop: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    innerDivStyle: React.PropTypes.object,
	    insetChildren: React.PropTypes.bool,
	    focusState: React.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	    leftIcon: React.PropTypes.element,
	    rightIcon: React.PropTypes.element,
	    secondaryText: React.PropTypes.node,
	    value: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      focusState: 'none'
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._applyFocusState();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._applyFocusState();
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var checked = _props.checked;
	    var children = _props.children;
	    var desktop = _props.desktop;
	    var disabled = _props.disabled;
	    var focusState = _props.focusState;
	    var innerDivStyle = _props.innerDivStyle;
	    var insetChildren = _props.insetChildren;
	    var leftIcon = _props.leftIcon;
	    var rightIcon = _props.rightIcon;
	    var secondaryText = _props.secondaryText;
	    var style = _props.style;
	    var value = _props.value;
	
	    var other = _objectWithoutProperties(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'rightIcon', 'secondaryText', 'style', 'value']);
	
	    var disabledColor = this.context.muiTheme.palette.disabledColor;
	    var textColor = this.context.muiTheme.palette.textColor;
	    var leftIndent = desktop ? 64 : 72;
	    var sidePadding = desktop ? 24 : 16;
	
	    var styles = {
	      root: {
	        color: disabled ? disabledColor : textColor,
	        lineHeight: desktop ? '32px' : '48px',
	        fontSize: desktop ? 15 : 16,
	        whiteSpace: 'nowrap'
	      },
	
	      innerDivStyle: {
	        paddingLeft: leftIcon || insetChildren || checked ? leftIndent : sidePadding,
	        paddingRight: sidePadding,
	        paddingBottom: 0,
	        paddingTop: 0
	      },
	
	      secondaryText: {
	        float: 'right'
	      },
	
	      leftIconDesktop: {
	        padding: 0,
	        left: 24,
	        top: 4
	      },
	
	      rightIconDesktop: {
	        padding: 0,
	        right: 24,
	        top: 4,
	        fill: Colors.grey600
	      }
	    };
	
	    var mergedRootStyles = this.mergeStyles(styles.root, style);
	    var mergedInnerDivStyles = this.mergeStyles(styles.innerDivStyle, innerDivStyle);
	
	    //Left Icon
	    var leftIconElement = leftIcon ? leftIcon : checked ? React.createElement(CheckIcon, null) : null;
	    if (leftIconElement && desktop) {
	      var mergedLeftIconStyles = this.mergeStyles(styles.leftIconDesktop, leftIconElement.props.style);
	      leftIconElement = React.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	    }
	
	    //Right Icon
	    var rightIconElement = undefined;
	    if (rightIcon) {
	      var mergedRightIconStyles = desktop ? this.mergeStyles(styles.rightIconDesktop, rightIcon.props.style) : null;
	      rightIconElement = React.cloneElement(rightIcon, { style: mergedRightIconStyles });
	    }
	
	    //Secondary Text
	    var secondaryTextElement = undefined;
	    if (secondaryText) {
	      var secondaryTextIsAnElement = React.isValidElement(secondaryText);
	      var mergedSecondaryTextStyles = secondaryTextIsAnElement ? this.mergeStyles(styles.secondaryText, secondaryText.props.style) : null;
	
	      secondaryTextElement = secondaryTextIsAnElement ? React.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : React.createElement(
	        'div',
	        { style: styles.secondaryText },
	        secondaryText
	      );
	    }
	
	    return React.createElement(
	      ListItem,
	      _extends({}, other, {
	        disabled: disabled,
	        innerDivStyle: mergedInnerDivStyles,
	        insetChildren: insetChildren,
	        leftIcon: leftIconElement,
	        ref: 'listItem',
	        rightIcon: rightIconElement,
	        style: mergedRootStyles }),
	      children,
	      secondaryTextElement
	    );
	  },
	
	  _applyFocusState: function _applyFocusState() {
	    this.refs.listItem.applyFocusState(this.props.focusState);
	  }
	});
	
	module.exports = MenuItem;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var update = React.addons.update;
	var Controllable = __webpack_require__(524);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	var KeyCode = __webpack_require__(73);
	var PropTypes = __webpack_require__(171);
	var List = __webpack_require__(361);
	var Paper = __webpack_require__(55);
	
	var Menu = React.createClass({
	  displayName: 'Menu',
	
	  mixins: [StylePropable, Controllable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    animated: React.PropTypes.bool,
	    autoWidth: React.PropTypes.bool,
	    desktop: React.PropTypes.bool,
	    initiallyKeyboardFocused: React.PropTypes.bool,
	    listStyle: React.PropTypes.object,
	    maxHeight: React.PropTypes.number,
	    multiple: React.PropTypes.bool,
	    onEscKeyDown: React.PropTypes.func,
	    onItemTouchTap: React.PropTypes.func,
	    onKeyDown: React.PropTypes.func,
	    openDirection: PropTypes.corners,
	    selectedMenuItemStyle: React.PropTypes.object,
	    width: PropTypes.stringOrNumber,
	    zDepth: PropTypes.zDepth
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animated: false,
	      autoWidth: true,
	      maxHeight: null,
	      onEscKeyDown: function onEscKeyDown() {},
	      onItemTouchTap: function onItemTouchTap() {},
	      onKeyDown: function onKeyDown() {},
	      openDirection: 'bottom-left',
	      zDepth: 1
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var selectedIndex = this._getSelectedIndex(this.props);
	
	    return {
	      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
	      isKeyboardFocused: this.props.initiallyKeyboardFocused,
	      keyWidth: this.props.desktop ? 64 : 56
	    };
	  },
	
	  componentDidEnter: function componentDidEnter() {
	    this._animateOpen();
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.autoWidth) this._setWidth();
	    if (!this.props.animated) this._animateOpen();
	    this._setScollPosition();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    if (this.props.autoWidth) this._setWidth();
	  },
	
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    var rootStyle = React.findDOMNode(this).style;
	
	    AutoPrefix.set(rootStyle, 'transition', Transitions.easeOut('250ms', ['opacity', 'transform']));
	    AutoPrefix.set(rootStyle, 'transform', 'translate3d(0,-8px,0)');
	    rootStyle.opacity = 0;
	
	    setTimeout((function () {
	      if (_this.isMounted()) callback();
	    }).bind(this), 250);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var selectedIndex = this._getSelectedIndex(nextProps);
	
	    this.setState({
	      focusIndex: selectedIndex >= 0 ? selectedIndex : 0,
	      keyWidth: nextProps.desktop ? 64 : 56
	    });
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props;
	    var animated = _props.animated;
	    var autoWidth = _props.autoWidth;
	    var children = _props.children;
	    var desktop = _props.desktop;
	    var initiallyKeyboardFocused = _props.initiallyKeyboardFocused;
	    var listStyle = _props.listStyle;
	    var maxHeight = _props.maxHeight;
	    var multiple = _props.multiple;
	    var openDirection = _props.openDirection;
	    var selectedMenuItemStyle = _props.selectedMenuItemStyle;
	    var style = _props.style;
	    var value = _props.value;
	    var valueLink = _props.valueLink;
	    var width = _props.width;
	    var zDepth = _props.zDepth;
	
	    var other = _objectWithoutProperties(_props, ['animated', 'autoWidth', 'children', 'desktop', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);
	
	    var openDown = openDirection.split('-')[0] === 'bottom';
	    var openLeft = openDirection.split('-')[1] === 'left';
	
	    var styles = {
	      root: {
	        //Nested div bacause the List scales x faster than
	        //it scales y
	        transition: animated ? Transitions.easeOut('250ms', 'transform') : null,
	        position: 'absolute',
	        zIndex: 10,
	        top: openDown ? 0 : null,
	        bottom: !openDown ? 0 : null,
	        left: !openLeft ? 0 : null,
	        right: openLeft ? 0 : null,
	        transform: 'scaleX(0)',
	        transformOrigin: openLeft ? 'right' : 'left'
	      },
	
	      list: {
	        display: 'table-cell',
	        paddingBottom: desktop ? 16 : 8,
	        paddingTop: desktop ? 16 : 8,
	        userSelect: 'none',
	        width: width
	      },
	
	      menuItemContainer: {
	        transition: animated ? Transitions.easeOut(null, 'opacity') : null,
	        opacity: 0
	      },
	
	      paper: {
	        transition: animated ? Transitions.easeOut('500ms', ['transform', 'opacity']) : null,
	        transform: 'scaleY(0)',
	        transformOrigin: openDown ? 'top' : 'bottom',
	        opacity: 0,
	        maxHeight: maxHeight,
	        overflowY: maxHeight ? 'scroll' : null
	      },
	
	      selectedMenuItem: {
	        color: this.context.muiTheme.palette.accent1Color
	      }
	    };
	
	    var mergedRootStyles = this.mergeAndPrefix(styles.root, style);
	    var mergedListStyles = this.mergeStyles(styles.list, listStyle);
	
	    //Cascade children opacity
	    var cumulativeDelay = openDown ? 175 : 325;
	    var cascadeChildrenCount = this._getCascadeChildrenCount();
	    var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);
	
	    var menuItemIndex = 0;
	    var newChildren = React.Children.map(children, (function (child) {
	
	      var childIsADivider = child.type.displayName === 'MenuDivider';
	      var childIsDisabled = child.props.disabled;
	      var childrenContainerStyles = {};
	
	      if (animated) {
	        var focusIndex = _this2.state.focusIndex;
	        var transitionDelay = 0;
	
	        //Only cascade the visible menu items
	        if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
	          cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
	          transitionDelay = cumulativeDelay;
	        }
	
	        childrenContainerStyles = _this2.mergeAndPrefix(styles.menuItemContainer, {
	          transitionDelay: transitionDelay + 'ms'
	        });
	      }
	
	      var clonedChild = childIsADivider ? child : childIsDisabled ? React.cloneElement(child, { desktop: desktop }) : _this2._cloneMenuItem(child, menuItemIndex, styles);
	
	      if (!childIsADivider && !childIsDisabled) menuItemIndex++;
	
	      return animated ? React.createElement(
	        'div',
	        { style: childrenContainerStyles },
	        clonedChild
	      ) : clonedChild;
	    }).bind(this));
	
	    return React.createElement(
	      'div',
	      {
	        onKeyDown: this._handleKeyDown,
	        style: mergedRootStyles },
	      React.createElement(
	        Paper,
	        {
	          ref: 'scrollContainer',
	          style: styles.paper,
	          zDepth: zDepth },
	        React.createElement(
	          List,
	          _extends({}, other, {
	            ref: 'list',
	            style: mergedListStyles }),
	          newChildren
	        )
	      )
	    );
	  },
	
	  setKeyboardFocused: function setKeyboardFocused(keyboardFocused) {
	    this.setState({
	      isKeyboardFocused: keyboardFocused
	    });
	  },
	
	  _animateOpen: function _animateOpen() {
	    var rootStyle = React.findDOMNode(this).style;
	    var scrollContainerStyle = React.findDOMNode(this.refs.scrollContainer).style;
	    var menuContainers = React.findDOMNode(this.refs.list).childNodes;
	
	    AutoPrefix.set(rootStyle, 'transform', 'scaleX(1)');
	    AutoPrefix.set(scrollContainerStyle, 'transform', 'scaleY(1)');
	    scrollContainerStyle.opacity = 1;
	
	    for (var i = 0; i < menuContainers.length; ++i) {
	      menuContainers[i].style.opacity = 1;
	    }
	  },
	
	  _cloneMenuItem: function _cloneMenuItem(child, childIndex, styles) {
	    var _this3 = this;
	
	    var _props2 = this.props;
	    var desktop = _props2.desktop;
	    var selectedMenuItemStyle = _props2.selectedMenuItemStyle;
	
	    var selected = this._isChildSelected(child, this.props);
	    var selectedChildrenStyles = {};
	
	    if (selected) {
	      selectedChildrenStyles = this.mergeStyles(styles.selectedMenuItem, selectedMenuItemStyle);
	    }
	
	    var mergedChildrenStyles = this.mergeStyles(child.props.style || {}, selectedChildrenStyles);
	
	    var isFocused = childIndex === this.state.focusIndex;
	    var focusState = 'none';
	    if (isFocused) {
	      focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	    }
	
	    return React.cloneElement(child, {
	      desktop: desktop,
	      focusState: focusState,
	      onTouchTap: function onTouchTap(e) {
	        _this3._handleMenuItemTouchTap(e, child);
	        if (child.props.onTouchTap) child.props.onTouchTap(e);
	      },
	      ref: isFocused ? 'focusedMenuItem' : null,
	      style: mergedChildrenStyles
	    });
	  },
	
	  _decrementKeyboardFocusIndex: function _decrementKeyboardFocusIndex() {
	    var index = this.state.focusIndex;
	
	    index--;
	    if (index < 0) index = 0;
	
	    this._setFocusIndex(index, true);
	  },
	
	  _getCascadeChildrenCount: function _getCascadeChildrenCount() {
	    var _props3 = this.props;
	    var children = _props3.children;
	    var desktop = _props3.desktop;
	    var maxHeight = _props3.maxHeight;
	
	    var count = 1;
	    var currentHeight = desktop ? 16 : 8;
	    var menuItemHeight = desktop ? 32 : 48;
	
	    //MaxHeight isn't set - cascade all of the children
	    if (!maxHeight) return React.Children.count(children);
	
	    //Count all the children that will fit inside the
	    //max menu height
	    React.Children.forEach(children, function (child) {
	      if (currentHeight < maxHeight) {
	        var childIsADivider = child.type.displayName === 'MenuDivider';
	
	        currentHeight += childIsADivider ? 16 : menuItemHeight;
	        count++;
	      }
	    });
	
	    return count;
	  },
	
	  _getMenuItemCount: function _getMenuItemCount() {
	    var menuItemCount = 0;
	    React.Children.forEach(this.props.children, function (child) {
	      var childIsADivider = child.type.displayName === 'MenuDivider';
	      var childIsDisabled = child.props.disabled;
	      if (!childIsADivider && !childIsDisabled) menuItemCount++;
	    });
	    return menuItemCount;
	  },
	
	  _getSelectedIndex: function _getSelectedIndex(props) {
	    var _this4 = this;
	
	    var children = props.children;
	
	    var selectedIndex = -1;
	    var menuItemIndex = 0;
	
	    React.Children.forEach(children, (function (child) {
	      var childIsADivider = child.type.displayName === 'MenuDivider';
	
	      if (_this4._isChildSelected(child, props)) selectedIndex = menuItemIndex;
	      if (!childIsADivider) menuItemIndex++;
	    }).bind(this));
	
	    return selectedIndex;
	  },
	
	  _handleKeyDown: function _handleKeyDown(e) {
	    switch (e.keyCode) {
	      case KeyCode.DOWN:
	        e.preventDefault();
	        this._incrementKeyboardFocusIndex();
	        break;
	      case KeyCode.ESC:
	        this.props.onEscKeyDown(e);
	        break;
	      case KeyCode.TAB:
	        e.preventDefault();
	        if (e.shiftKey) {
	          this._decrementKeyboardFocusIndex();
	        } else {
	          this._incrementKeyboardFocusIndex();
	        }
	        break;
	      case KeyCode.UP:
	        e.preventDefault();
	        this._decrementKeyboardFocusIndex();
	        break;
	    }
	    this.props.onKeyDown(e);
	  },
	
	  _handleMenuItemTouchTap: function _handleMenuItemTouchTap(e, item) {
	    var multiple = this.props.multiple;
	    var valueLink = this.getValueLink(this.props);
	    var menuValue = valueLink.value;
	    var itemValue = item.props.value;
	
	    if (multiple) {
	      var index = menuValue.indexOf(itemValue);
	      var newMenuValue = index === -1 ? update(menuValue, { $push: [itemValue] }) : update(menuValue, { $splice: [[index, 1]] });
	
	      valueLink.requestChange(e, newMenuValue);
	    } else if (!multiple && itemValue !== menuValue) {
	      valueLink.requestChange(e, itemValue);
	    }
	
	    this.props.onItemTouchTap(e, item);
	  },
	
	  _incrementKeyboardFocusIndex: function _incrementKeyboardFocusIndex() {
	    var index = this.state.focusIndex;
	    var maxIndex = this._getMenuItemCount() - 1;
	
	    index++;
	    if (index > maxIndex) index = maxIndex;
	
	    this._setFocusIndex(index, true);
	  },
	
	  _isChildSelected: function _isChildSelected(child, props) {
	    var multiple = props.multiple;
	    var menuValue = this.getValueLink(props).value;
	    var childValue = child.props.value;
	
	    return multiple && menuValue.length && menuValue.indexOf(childValue) !== -1 || !multiple && menuValue && menuValue === childValue;
	  },
	
	  _setFocusIndex: function _setFocusIndex(newIndex, isKeyboardFocused) {
	    this.setState({
	      focusIndex: newIndex,
	      isKeyboardFocused: isKeyboardFocused
	    });
	  },
	
	  _setScollPosition: function _setScollPosition() {
	    var desktop = this.props.desktop;
	    var focusedMenuItem = this.refs.focusedMenuItem;
	    var menuItemHeight = desktop ? 32 : 48;
	
	    if (focusedMenuItem) {
	      var selectedOffSet = React.findDOMNode(focusedMenuItem).offsetTop;
	
	      //Make the focused item be the 2nd item in the list the
	      //user sees
	      var scrollTop = selectedOffSet - menuItemHeight;
	      if (scrollTop < menuItemHeight) scrollTop = 0;
	
	      React.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	    }
	  },
	
	  _setWidth: function _setWidth() {
	    var el = React.findDOMNode(this);
	    var listEl = React.findDOMNode(this.refs.list);
	    var elWidth = el.offsetWidth;
	    var keyWidth = this.state.keyWidth;
	    var minWidth = keyWidth * 1.5;
	    var keyIncrements = elWidth / keyWidth;
	    var newWidth = undefined;
	
	    keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	    newWidth = keyIncrements * keyWidth;
	
	    if (newWidth < minWidth) newWidth = minWidth;
	
	    el.style.width = newWidth + 'px';
	    listEl.style.width = newWidth + 'px';
	  }
	
	});
	
	module.exports = Menu;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	
	module.exports = {
	
	  propTypes: {
	    onChange: React.PropTypes.func,
	    value: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
	    valueLink: React.PropTypes.shape({
	      value: React.PropTypes.string.isRequired,
	      requestChange: React.PropTypes.func.isRequired
	    })
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onChange: function onChange() {}
	    };
	  },
	
	  getValueLink: function getValueLink(props) {
	    return props.valueLink || {
	      value: props.value,
	      requestChange: props.onChange
	    };
	  }
	
	};

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var EnhancedSwitch = __webpack_require__(360);
	var RadioButtonOff = __webpack_require__(1161);
	var RadioButtonOn = __webpack_require__(1160);
	
	var RadioButton = React.createClass({
	  displayName: 'RadioButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    iconStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    onCheck: React.PropTypes.func
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.radioButton;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      icon: {
	        height: this.getTheme().size,
	        width: this.getTheme().size
	      },
	      target: {
	        transition: Transitions.easeOut(),
	        position: 'absolute',
	        opacity: 1,
	        transform: 'scale(1)',
	        fill: this.getTheme().borderColor
	      },
	      fill: {
	        position: 'absolute',
	        opacity: 1,
	        transform: 'scale(0)',
	        transformOrigin: '50% 50%',
	        transition: Transitions.easeOut(),
	        fill: this.getTheme().checkedColor
	      },
	      targetWhenChecked: {
	        opacity: 0,
	        transform: 'scale(0)'
	      },
	      fillWhenChecked: {
	        opacity: 1,
	        transform: 'scale(1)'
	      },
	      targetWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      fillWhenDisabled: {
	        fill: this.getTheme().disabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var onCheck = _props.onCheck;
	
	    var other = _objectWithoutProperties(_props, ['onCheck']);
	
	    var styles = this.getStyles();
	    var onStyles = this.mergeAndPrefix(styles.target, this.props.checked && styles.targetWhenChecked, this.props.iconStyle, this.props.disabled && styles.targetWhenDisabled);
	    var offStyles = this.mergeAndPrefix(styles.fill, this.props.checked && styles.fillWhenChecked, this.props.iconStyle, this.props.disabled && styles.fillWhenDisabled);
	
	    var radioButtonElement = React.createElement(
	      'div',
	      null,
	      React.createElement(RadioButtonOff, { style: onStyles }),
	      React.createElement(RadioButtonOn, { style: offStyles })
	    );
	
	    var rippleColor = this.props.checked ? this.getTheme().checkedColor : this.getTheme().borderColor;
	
	    var iconStyle = this.mergeAndPrefix(styles.icon, this.props.iconStyle);
	
	    var labelStyle = this.mergeAndPrefix(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: "enhancedSwitch",
	      inputType: "radio",
	      switched: this.props.checked || false,
	      switchElement: radioButtonElement,
	      rippleColor: rippleColor,
	      iconStyle: iconStyle,
	      labelStyle: labelStyle,
	      onSwitch: this._handleCheck,
	      onParentShouldUpdate: this._handleStateChange,
	      labelPosition: this.props.labelPosition ? this.props.labelPosition : "right"
	    };
	
	    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
	  },
	
	  // Only called when selected, not when unselected.
	  _handleCheck: function _handleCheck(e) {
	    if (this.props.onCheck) this.props.onCheck(e, this.props.value);
	  },
	
	  _handleStateChange: function _handleStateChange() {},
	
	  isChecked: function isChecked() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	
	  // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	  // RadioButton's checked value.
	  setChecked: function setChecked(newCheckedValue) {
	    this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	  },
	
	  getValue: function getValue() {
	    return this.refs.enhancedSwitch.getValue();
	  }
	
	});
	
	module.exports = RadioButton;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	var Colors = __webpack_require__(56);
	
	var CircleRipple = React.createClass({
	  displayName: 'CircleRipple',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  propTypes: {
	    color: React.PropTypes.string,
	    opacity: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: Colors.darkBlack,
	      opacity: 0.16
	    };
	  },
	
	  componentWillAppear: function componentWillAppear(callback) {
	    this._initializeAnimation(callback);
	  },
	
	  componentWillEnter: function componentWillEnter(callback) {
	    this._initializeAnimation(callback);
	  },
	
	  componentDidAppear: function componentDidAppear() {
	    this._animate();
	  },
	
	  componentDidEnter: function componentDidEnter() {
	    this._animate();
	  },
	
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    var style = React.findDOMNode(this).style;
	    style.opacity = 0;
	    setTimeout((function () {
	      if (_this.isMounted()) callback();
	    }).bind(this), 2000);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var opacity = _props.opacity;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'opacity', 'style']);
	
	    var mergedStyles = this.mergeAndPrefix({
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%',
	      borderRadius: '50%',
	      backgroundColor: color
	    }, style);
	
	    return React.createElement('div', _extends({}, other, { style: mergedStyles }));
	  },
	
	  _animate: function _animate() {
	    var style = React.findDOMNode(this).style;
	    var transitionValue = Transitions.easeOut('2s', 'opacity') + ',' + Transitions.easeOut('1s', 'transform');
	    AutoPrefix.set(style, 'transition', transitionValue);
	    AutoPrefix.set(style, 'transform', 'scale(1)');
	  },
	
	  _initializeAnimation: function _initializeAnimation(callback) {
	    var _this2 = this;
	
	    var style = React.findDOMNode(this).style;
	    style.opacity = this.props.opacity;
	    AutoPrefix.set(style, 'transform', 'scale(0)');
	    setTimeout((function () {
	      if (_this2.isMounted()) callback();
	    }).bind(this), 0);
	  }
	
	});
	
	module.exports = CircleRipple;

/***/ },
/* 527 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopLeftNavMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Extend = __webpack_require__(368);
	
	var Types = {
	  LIGHT: __webpack_require__(1153),
	  DARK: __webpack_require__(1152)
	};
	
	var ThemeManager = function ThemeManager() {
	  return {
	
	    //In most cases, theme variables remain static thoughout the life of an
	    //app. If you plan on mutating theme variables after the theme has been
	    //intialized, set static to false. This will allow components to update
	    //when theme variables change. For more information see issue #1176
	    'static': true,
	
	    types: Types,
	    template: Types.LIGHT,
	
	    spacing: Types.LIGHT.spacing,
	    contentFontFamily: 'Roboto, sans-serif',
	
	    palette: Types.LIGHT.getPalette(),
	    component: Types.LIGHT.getComponentThemes(Types.LIGHT.getPalette()),
	
	    getCurrentTheme: function getCurrentTheme() {
	      return this;
	    },
	
	    // Component gets updated to reflect palette changes.
	    setTheme: function setTheme(newTheme) {
	      this.setSpacing(newTheme.spacing);
	      this.setContentFontFamily(newTheme.contentFontFamily);
	      this.setPalette(newTheme.getPalette());
	      this.setComponentThemes(newTheme.getComponentThemes(newTheme.getPalette()));
	    },
	
	    setSpacing: function setSpacing(newSpacing) {
	      this.spacing = Extend(this.spacing, newSpacing);
	      this.component = Extend(this.component, this.template.getComponentThemes(this.palette, this.spacing));
	    },
	
	    setContentFontFamily: function setContentFontFamily(newContentFontFamily) {
	      if (typeof newContentFontFamily !== "undefined" && newContentFontFamily !== null) {
	        this.contentFontFamily = newContentFontFamily;
	        this.component = Extend(this.component, this.template.getComponentThemes(this.palette, this.spacing));
	      }
	    },
	
	    setPalette: function setPalette(newPalette) {
	      this.palette = Extend(this.palette, newPalette);
	      this.component = Extend(this.component, this.template.getComponentThemes(this.palette));
	    },
	
	    setComponentThemes: function setComponentThemes(overrides) {
	      this.component = Extend(this.component, overrides);
	    },
	
	    setIsRtl: function setIsRtl(isRtl) {
	      this.isRtl = !!isRtl;
	    }
	  };
	};
	
	module.exports = ThemeManager;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationArrowDropDown = React.createClass({
	  displayName: 'NavigationArrowDropDown',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M7 10l5 5 5-5z' })
	    );
	  }
	
	});
	
	module.exports = NavigationArrowDropDown;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationChevronLeft = React.createClass({
	  displayName: 'NavigationChevronLeft',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	    );
	  }
	
	});
	
	module.exports = NavigationChevronLeft;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationChevronRight = React.createClass({
	  displayName: 'NavigationChevronRight',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	    );
	  }
	
	});
	
	module.exports = NavigationChevronRight;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationMenu = React.createClass({
	  displayName: 'NavigationMenu',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	    );
	  }
	
	});
	
	module.exports = NavigationMenu;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Tooltip = __webpack_require__(365);
	
	var TableHeaderColumn = React.createClass({
	  displayName: 'TableHeaderColumn',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    columnNumber: React.PropTypes.number,
	    onClick: React.PropTypes.func,
	    style: React.PropTypes.object,
	    tooltip: React.PropTypes.string,
	    tooltipStyle: React.PropTypes.object
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.tableHeaderColumn;
	  },
	
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var styles = {
	      root: {
	        fontWeight: 'normal',
	        fontSize: 12,
	        paddingLeft: theme.spacing,
	        paddingRight: theme.spacing,
	        height: theme.height,
	        textAlign: 'left',
	        whiteSpace: 'nowrap',
	        textOverflow: 'ellipsis',
	        color: this.getTheme().textColor,
	        position: 'relative'
	      },
	      tooltip: {
	        boxSizing: 'border-box',
	        marginTop: theme.height / 2
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var handlers = {
	      onMouseEnter: this._onMouseEnter,
	      onMouseLeave: this._onMouseLeave,
	      onClick: this._onClick
	    };
	    var _props = this.props;
	    var className = _props.className;
	    var columnNumber = _props.columnNumber;
	    var onClick = _props.onClick;
	    var style = _props.style;
	    var tooltip = _props.tooltip;
	    var tooltipStyle = _props.tooltipStyle;
	
	    var other = _objectWithoutProperties(_props, ['className', 'columnNumber', 'onClick', 'style', 'tooltip', 'tooltipStyle']);
	
	    var classes = 'mui-table-header-column';
	    if (className) classes += ' ' + className;
	
	    if (this.props.tooltip !== undefined) {
	      tooltip = React.createElement(Tooltip, {
	        label: this.props.tooltip,
	        show: this.state.hovered,
	        style: this.mergeAndPrefix(styles.tooltip, tooltipStyle) });
	    }
	
	    return React.createElement(
	      'th',
	      _extends({
	        key: this.props.key,
	        className: classes,
	        style: this.mergeAndPrefix(styles.root, style)
	      }, handlers, other),
	      tooltip,
	      this.props.children
	    );
	  },
	
	  _onMouseEnter: function _onMouseEnter() {
	    if (this.props.tooltip !== undefined) this.setState({ hovered: true });
	  },
	
	  _onMouseLeave: function _onMouseLeave() {
	    if (this.props.tooltip !== undefined) this.setState({ hovered: false });
	  },
	
	  _onClick: function _onClick(e) {
	    if (this.props.onClick) this.props.onClick(e, this.props.columnNumber);
	  }
	
	});
	
	module.exports = TableHeaderColumn;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var ClockNumber = React.createClass({
	  displayName: 'ClockNumber',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    value: React.PropTypes.number,
	    type: React.PropTypes.oneOf(['hour', 'minute']),
	    onSelected: React.PropTypes.func,
	    isSelected: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: 0,
	      type: 'minute',
	      isSelected: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.timePicker;
	  },
	
	  render: function render() {
	    var pos = this.props.value;
	    var inner = false;
	
	    if (this.props.type === "hour") {
	      inner = pos < 1 || pos > 12;
	      pos %= 12;
	    } else {
	      pos = pos / 5;
	    }
	
	    var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	    var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	    var styles = {
	      root: {
	        display: "inline-block",
	        position: "absolute",
	        width: 32,
	        height: 32,
	        borderRadius: "100%",
	        left: 'calc(50% - 16px)',
	        top: 10,
	        textAlign: "center",
	        paddingTop: 5,
	        userSelect: "none", /* Chrome all / Safari all */
	        fontSize: "1.1em",
	        pointerEvents: "none",
	        boxSizing: "border-box"
	      }
	    };
	
	    if (this.props.isSelected) {
	      styles.root.backgroundColor = this.getTheme().accentColor;
	      styles.root.color = this.getTheme().selectTextColor;
	    }
	
	    var transformPos = positions[pos];
	
	    if (inner) {
	      styles.root.width = "28px";
	      styles.root.height = "28px";
	      styles.root.left = 'calc(50% - 14px)';
	      transformPos = innerPositions[pos];
	    }
	
	    var _transformPos = transformPos;
	
	    var _transformPos2 = _slicedToArray(_transformPos, 2);
	
	    var x = _transformPos2[0];
	    var y = _transformPos2[1];
	
	    styles.root.transform = "translate(" + x + "px, " + y + "px)";
	
	    return React.createElement(
	      'span',
	      { style: this.mergeAndPrefix(styles.root) },
	      this.props.value
	    );
	  }
	});
	
	module.exports = ClockNumber;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var ClockPointer = React.createClass({
	  displayName: 'ClockPointer',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    value: React.PropTypes.number,
	    type: React.PropTypes.oneOf(['hour', 'minute'])
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      inner: this.isInner(this.props.value)
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      value: null,
	      type: 'minute',
	      hasSelected: false
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      inner: this.isInner(nextProps.value)
	    });
	  },
	
	  isInner: function isInner(value) {
	    if (this.props.type !== "hour") {
	      return false;
	    }
	    return value < 1 || value > 12;
	  },
	
	  getAngle: function getAngle() {
	    if (this.props.type === "hour") {
	      return this.calcAngle(this.props.value, 12);
	    }
	
	    return this.calcAngle(this.props.value, 60);
	  },
	
	  calcAngle: function calcAngle(value, base) {
	    value %= base;
	    var angle = 360 / base * value;
	    return angle;
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.timePicker;
	  },
	
	  render: function render() {
	    if (this.props.value === null) {
	      return React.createElement('span', null);
	    }
	
	    var angle = this.getAngle();
	
	    var styles = {
	      root: {
	        height: "30%",
	        background: this.getTheme().accentColor,
	        width: 2,
	        left: 'calc(50% - 1px)',
	        position: "absolute",
	        bottom: "50%",
	        transformOrigin: "bottom",
	        pointerEvents: "none",
	        transform: "rotateZ(" + angle + "deg)"
	      },
	      mark: {
	        background: this.getTheme().selectTextColor,
	        border: "4px solid " + this.getTheme().accentColor,
	        width: 7,
	        height: 7,
	        position: "absolute",
	        top: -5,
	        left: -6,
	        borderRadius: "100%"
	      }
	    };
	
	    if (!this.state.inner) {
	      styles.root.height = "40%";
	    }
	
	    if (this.props.hasSelected) {
	      styles.mark.display = "none";
	    }
	
	    return React.createElement(
	      'div',
	      { style: this.mergeAndPrefix(styles.root) },
	      React.createElement('div', { style: styles.mark })
	    );
	  }
	});
	
	module.exports = ClockPointer;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var Paper = __webpack_require__(55);
	var EnhancedSwitch = __webpack_require__(360);
	
	var Toggle = React.createClass({
	  displayName: 'Toggle',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    elementStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    onToggle: React.PropTypes.func,
	    toggled: React.PropTypes.bool,
	    defaultToggled: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      switched: this.props.toggled || this.props.defaultToggled || this.props.valueLink && this.props.valueLink.value || false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.toggle;
	  },
	
	  getStyles: function getStyles() {
	    var toggleSize = 20;
	    var toggleTrackWidth = 36;
	    var styles = {
	      icon: {
	        width: 36,
	        padding: '4px 0px 6px 2px'
	      },
	      toggleElement: {
	        width: toggleTrackWidth
	      },
	      track: {
	        transition: Transitions.easeOut(),
	        width: '100%',
	        height: 14,
	        borderRadius: 30,
	        backgroundColor: this.getTheme().trackOffColor
	      },
	      thumb: {
	        transition: Transitions.easeOut(),
	        position: 'absolute',
	        top: 1,
	        left: 0,
	        width: toggleSize,
	        height: toggleSize,
	        lineHeight: '24px',
	        borderRadius: '50%',
	        backgroundColor: this.getTheme().thumbOffColor
	      },
	      trackWhenSwitched: {
	        backgroundColor: this.getTheme().trackOnColor
	      },
	      thumbWhenSwitched: {
	        backgroundColor: this.getTheme().thumbOnColor,
	        left: '100%'
	      },
	      trackWhenDisabled: {
	        backgroundColor: this.getTheme().trackDisabledColor
	      },
	      thumbWhenDisabled: {
	        backgroundColor: this.getTheme().thumbDisabledColor
	      },
	      label: {
	        color: this.props.disabled ? this.getTheme().labelDisabledColor : this.getTheme().labelColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var onToggle = _props.onToggle;
	
	    var other = _objectWithoutProperties(_props, ['onToggle']);
	
	    var styles = this.getStyles();
	
	    var trackStyles = this.mergeAndPrefix(styles.track, this.props.trackStyle, this.state.switched && styles.trackWhenSwitched, this.props.disabled && styles.trackWhenDisabled);
	
	    var thumbStyles = this.mergeAndPrefix(styles.thumb, this.props.thumbStyle, this.state.switched && styles.thumbWhenSwitched, this.props.disabled && styles.thumbWhenDisabled);
	
	    if (this.state.switched) {
	      thumbStyles.marginLeft = '-' + thumbStyles.width;
	    }
	
	    var toggleElementStyles = this.mergeAndPrefix(styles.toggleElement, this.props.elementStyle);
	
	    var toggleElement = React.createElement(
	      'div',
	      { style: toggleElementStyles },
	      React.createElement('div', { style: trackStyles }),
	      React.createElement(Paper, { style: thumbStyles, circle: true, zDepth: 1 })
	    );
	
	    var customRippleStyle = this.mergeAndPrefix({
	      top: -10,
	      left: -10
	    }, this.props.rippleStyle);
	
	    var rippleColor = this.state.switched ? this.getTheme().thumbOnColor : this.context.muiTheme.component.textColor;
	
	    var iconStyle = this.mergeAndPrefix(styles.icon, this.props.iconStyle);
	
	    var labelStyle = this.mergeAndPrefix(styles.label, this.props.labelStyle);
	
	    var enhancedSwitchProps = {
	      ref: "enhancedSwitch",
	      inputType: "checkbox",
	      switchElement: toggleElement,
	      rippleStyle: customRippleStyle,
	      rippleColor: rippleColor,
	      iconStyle: iconStyle,
	      trackStyle: trackStyles,
	      thumbStyle: thumbStyles,
	      labelStyle: labelStyle,
	      switched: this.state.switched,
	      onSwitch: this._handleToggle,
	      onParentShouldUpdate: this._handleStateChange,
	      defaultSwitched: this.props.defaultToggled,
	      labelPosition: this.props.labelPosition ? this.props.labelPosition : "left"
	    };
	
	    if (this.props.hasOwnProperty('toggled')) enhancedSwitchProps.checked = this.props.toggled;
	
	    return React.createElement(EnhancedSwitch, _extends({}, other, enhancedSwitchProps));
	  },
	
	  isToggled: function isToggled() {
	    return this.refs.enhancedSwitch.isSwitched();
	  },
	
	  setToggled: function setToggled(newToggledValue) {
	    this.refs.enhancedSwitch.setSwitched(newToggledValue);
	  },
	
	  _handleToggle: function _handleToggle(e, isInputChecked) {
	    if (this.props.onToggle) this.props.onToggle(e, isInputChecked);
	  },
	
	  _handleStateChange: function _handleStateChange(newSwitched) {
	    this.setState({ switched: newSwitched });
	  }
	
	});
	
	module.exports = Toggle;

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var Colors = __webpack_require__(56);
	var StylePropable = __webpack_require__(6);
	
	var ToolbarGroup = React.createClass({
	  displayName: 'ToolbarGroup',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    float: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      float: 'left'
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.toolbar;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing.desktopGutter;
	  },
	
	  getStyles: function getStyles() {
	    var marginHorizontal = this.getSpacing();
	    var marginVertical = (this.getTheme().height - this.context.muiTheme.component.button.height) / 2;
	    var styles = {
	      root: {
	        position: 'relative',
	        float: this.props.float
	      },
	      dropDownMenu: {
	        root: {
	          float: 'left',
	          color: Colors.lightBlack, // removes hover color change, we want to keep it
	          display: 'inline-block',
	          marginRight: this.getSpacing()
	        },
	        controlBg: {
	          backgroundColor: this.getTheme().menuHoverColor,
	          borderRadius: 0
	        },
	        underline: {
	          display: 'none'
	        }
	      },
	      button: {
	        float: 'left',
	        margin: marginVertical + 'px ' + marginHorizontal + 'px',
	        position: 'relative'
	      },
	      icon: {
	        root: {
	          float: 'left',
	          cursor: 'pointer',
	          color: this.getTheme().iconColor,
	          lineHeight: this.getTheme().height + 'px',
	          paddingLeft: this.getSpacing()
	        },
	        hover: {
	          color: Colors.darkBlack
	        }
	      },
	      span: {
	        float: 'left',
	        color: this.getTheme().iconColor,
	        lineHeight: this.getTheme().height + 'px'
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var styles = this.getStyles();
	
	    if (this.props.firstChild) styles.marginLeft = -24;
	    if (this.props.lastChild) styles.marginRight = -24;
	
	    var newChildren = React.Children.map(this.props.children, function (currentChild) {
	      if (!currentChild) {
	        return null;
	      }
	      switch (currentChild.type.displayName) {
	        case 'DropDownMenu':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.dropDownMenu.root, currentChild.props.style),
	            styleControlBg: styles.dropDownMenu.controlBg,
	            styleUnderline: styles.dropDownMenu.underline
	          });
	        case 'DropDownIcon':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles({ float: 'left' }, currentChild.props.style),
	            iconStyle: styles.icon.root,
	            onMouseEnter: _this._handleMouseEnterDropDownMenu,
	            onMouseLeave: _this._handleMouseLeaveDropDownMenu
	          });
	        case 'RaisedButton':case 'FlatButton':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.button, currentChild.props.style)
	          });
	        case 'FontIcon':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.icon.root, currentChild.props.style),
	            onMouseEnter: _this._handleMouseEnterFontIcon,
	            onMouseLeave: _this._handleMouseLeaveFontIcon
	          });
	        case 'ToolbarSeparator':case 'ToolbarTitle':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles(styles.span, currentChild.props.style)
	          });
	        default:
	          return currentChild;
	      }
	    }, this);
	
	    return React.createElement(
	      'div',
	      { className: this.props.className, style: this.mergeAndPrefix(styles.root, this.props.style) },
	      newChildren
	    );
	  },
	
	  _handleMouseEnterDropDownMenu: function _handleMouseEnterDropDownMenu(e) {
	    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
	    e.target.style.color = this.getStyles().icon.hover.color;
	  },
	
	  _handleMouseLeaveDropDownMenu: function _handleMouseLeaveDropDownMenu(e) {
	    e.target.style.zIndex = 'auto';
	    e.target.style.color = this.getStyles().icon.root.color;
	  },
	
	  _handleMouseEnterFontIcon: function _handleMouseEnterFontIcon(e) {
	    e.target.style.zIndex = this.getStyles().icon.hover.zIndex;
	    e.target.style.color = this.getStyles().icon.hover.color;
	  },
	
	  _handleMouseLeaveFontIcon: function _handleMouseLeaveFontIcon(e) {
	    e.target.style.zIndex = 'auto';
	    e.target.style.color = this.getStyles().icon.root.color;
	  }
	});
	
	module.exports = ToolbarGroup;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var Toolbar = React.createClass({
	  displayName: 'Toolbar',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    style: React.PropTypes.object
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.toolbar;
	  },
	
	  getStyles: function getStyles() {
	    return this.mergeAndPrefix({
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	      backgroundColor: this.getTheme().backgroundColor,
	      height: this.getTheme().height,
	      width: '100%',
	      padding: this.props.noGutter ? 0 : '0px ' + this.context.muiTheme.spacing.desktopGutter + 'px'
	    }, this.props.style);
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      { className: this.props.className, style: this.getStyles() },
	      this.props.children
	    );
	  }
	
	});
	
	module.exports = Toolbar;

/***/ },
/* 539 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = {
	
	  Desktop: {
	    GUTTER: 24,
	    GUTTER_LESS: 16,
	    INCREMENT: 64,
	    MENU_ITEM_HEIGHT: 32
	  },
	
	  getIncrementalDim: function getIncrementalDim(dim) {
	    return Math.ceil(dim / this.Desktop.INCREMENT) * this.Desktop.INCREMENT;
	  }
	};

/***/ },
/* 540 */
/***/ function(module, exports) {

	/* Modernizr 2.8.3 (Custom Build) | MIT & BSD
	 * Build: http://modernizr.com/download/#-borderradius-boxshadow-opacity-csstransforms-csstransforms3d-csstransitions-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes
	 */
	
	'use strict';
	
	module.exports = (function (window, document, undefined) {
	
	    var version = '2.8.3',
	        Modernizr = {},
	        docElement = document.documentElement,
	        mod = 'modernizr',
	        modElem = document.createElement(mod),
	        mStyle = modElem.style,
	        prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),
	        omPrefixes = 'Webkit Moz O ms',
	        cssomPrefixes = omPrefixes.split(' '),
	        domPrefixes = omPrefixes.toLowerCase().split(' '),
	        tests = {},
	        classes = [],
	        slice = classes.slice,
	        featureName = undefined,
	        injectElementWithStyles = function injectElementWithStyles(rule, callback, nodes, testnames) {
	
	        var style = undefined,
	            ret = undefined,
	            node = undefined,
	            docOverflow = undefined,
	            div = document.createElement('div'),
	            body = document.body,
	            fakeBody = body || document.createElement('body');
	
	        if (parseInt(nodes, 10)) {
	            while (nodes--) {
	                node = document.createElement('div');
	                node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
	                div.appendChild(node);
	            }
	        }
	
	        style = ['&#173;', '<style id="s', mod, '">', rule, '</style>'].join('');
	        div.id = mod;
	        (body ? div : fakeBody).innerHTML += style;
	        fakeBody.appendChild(div);
	        if (!body) {
	            fakeBody.style.background = '';
	            fakeBody.style.overflow = 'hidden';
	            docOverflow = docElement.style.overflow;
	            docElement.style.overflow = 'hidden';
	            docElement.appendChild(fakeBody);
	        }
	
	        ret = callback(div, rule);
	        if (!body) {
	            fakeBody.parentNode.removeChild(fakeBody);
	            docElement.style.overflow = docOverflow;
	        } else {
	            div.parentNode.removeChild(div);
	        }
	
	        return !!ret;
	    },
	        _hasOwnProperty = ({}).hasOwnProperty,
	        hasOwnProp = undefined;
	
	    function is(obj, type) {
	        return typeof obj === type;
	    }
	
	    if (!is(_hasOwnProperty, 'undefined') && !is(_hasOwnProperty.call, 'undefined')) {
	        hasOwnProp = function (object, property) {
	            return _hasOwnProperty.call(object, property);
	        };
	    } else {
	        hasOwnProp = function (object, property) {
	            return property in object && is(object.constructor.prototype[property], 'undefined');
	        };
	    }
	
	    if (!Function.prototype.bind) {
	        Function.prototype.bind = function bind(that) {
	
	            var target = this;
	
	            if (typeof target != "function") {
	                throw new TypeError();
	            }
	
	            var args = slice.call(arguments, 1),
	                bound = function bound() {
	
	                if (this instanceof bound) {
	
	                    var F = function F() {};
	                    F.prototype = target.prototype;
	                    var _self = new F();
	
	                    var result = target.apply(_self, args.concat(slice.call(arguments)));
	                    if (Object(result) === result) {
	                        return result;
	                    }
	                    return _self;
	                } else {
	
	                    return target.apply(that, args.concat(slice.call(arguments)));
	                }
	            };
	
	            return bound;
	        };
	    }
	
	    function setCss(str) {
	        mStyle.cssText = str;
	    }
	
	    function setCssAll(str1, str2) {
	        return setCss(prefixes.join(str1 + ';') + (str2 || ''));
	    }
	
	    function contains(str, substr) {
	        return !! ~('' + str).indexOf(substr);
	    }
	
	    function testProps(props, prefixed) {
	        for (var i in props) {
	            var prop = props[i];
	            if (!contains(prop, "-") && mStyle[prop] !== undefined) {
	                return prefixed == 'pfx' ? prop : true;
	            }
	        }
	        return false;
	    }
	
	    function testDOMProps(props, obj, elem) {
	        for (var i in props) {
	            var item = obj[props[i]];
	            if (item !== undefined) {
	
	                if (elem === false) return props[i];
	
	                if (is(item, 'function')) {
	                    return item.bind(elem || obj);
	                }
	
	                return item;
	            }
	        }
	        return false;
	    }
	
	    function testPropsAll(prop, prefixed, elem) {
	
	        var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
	            props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');
	
	        if (is(prefixed, "string") || is(prefixed, "undefined")) {
	            return testProps(props, prefixed);
	        } else {
	            props = (prop + ' ' + domPrefixes.join(ucProp + ' ') + ucProp).split(' ');
	            return testDOMProps(props, prefixed, elem);
	        }
	    }
	
	    tests.borderradius = function () {
	        return testPropsAll('borderRadius');
	    };
	
	    tests.boxshadow = function () {
	        return testPropsAll('boxShadow');
	    };
	
	    tests.opacity = function () {
	        setCssAll('opacity:.55');
	
	        return (/^0.55$/.test(mStyle.opacity)
	        );
	    };
	    tests.csstransforms = function () {
	        return !!testPropsAll('transform');
	    };
	
	    tests.csstransforms3d = function () {
	
	        var ret = !!testPropsAll('perspective');
	
	        if (ret && 'webkitPerspective' in docElement.style) {
	
	            injectElementWithStyles('@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}', function (node) {
	                ret = node.offsetLeft === 9 && node.offsetHeight === 3;
	            });
	        }
	        return ret;
	    };
	
	    tests.csstransitions = function () {
	        return testPropsAll('transition');
	    };
	
	    for (var feature in tests) {
	        if (hasOwnProp(tests, feature)) {
	            featureName = feature.toLowerCase();
	            Modernizr[featureName] = tests[feature]();
	
	            classes.push((Modernizr[featureName] ? '' : 'no-') + featureName);
	        }
	    }
	
	    Modernizr.addTest = function (feature, test) {
	        if (typeof feature == 'object') {
	            for (var key in feature) {
	                if (hasOwnProp(feature, key)) {
	                    Modernizr.addTest(key, feature[key]);
	                }
	            }
	        } else {
	
	            feature = feature.toLowerCase();
	
	            if (Modernizr[feature] !== undefined) {
	                return Modernizr;
	            }
	
	            test = typeof test == 'function' ? test() : test;
	
	            if (typeof enableClasses !== "undefined" && enableClasses) {
	                docElement.className += ' ' + (test ? '' : 'no-') + feature;
	            }
	            Modernizr[feature] = test;
	        }
	
	        return Modernizr;
	    };
	
	    setCss('');
	
	    Modernizr._version = version;
	
	    Modernizr._prefixes = prefixes;
	    Modernizr._domPrefixes = domPrefixes;
	    Modernizr._cssomPrefixes = cssomPrefixes;
	
	    Modernizr.testProp = function (prop) {
	        return testProps([prop]);
	    };
	
	    Modernizr.testAllProps = testPropsAll;
	
	    Modernizr.testStyles = injectElementWithStyles;
	    Modernizr.prefixed = function (prop, obj, elem) {
	        if (!obj) {
	            return testPropsAll(prop, 'pfx');
	        } else {
	            return testPropsAll(prop, obj, elem);
	        }
	    };
	
	    return Modernizr;
	})(window, window.document);

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : afrikaans (af)
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Moroccan Arabic (ar-ma)
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic Saudi Arabia (ar-sa)
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  : Tunisian Arabic (ar-tn)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! Locale: Arabic (ar)
	//! Author: Abdel Said: https://github.com/abdelsaid
	//! Changes in months, weekdays: Ahmed Elkhatib
	//! Native plural forms: forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : azerbaijani (az)
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : belarusian (be)
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bulgarian (bg)
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (bn)
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেবুয়ারী_মার্চ_এপ্রিল_মে_জুন_জুলাই_অগাস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপর_মে_জুন_জুল_অগ_সেপ্ট_অক্টো_নভ_ডিসেম্'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পত্তিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পত্তি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রব_সম_মঙ্গ_বু_ব্রিহ_শু_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        isPM: function (input) {
	            return /^(দুপুর|বিকাল|রাত)$/.test(input);
	        },
	        //Bengali is a vast language its spoken
	        //in different forms in various parts of the world.
	        //I have just generalized with most common one used
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tibetan (bo)
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        isPM: function (input) {
	            return /^(ཉིན་གུང|དགོང་དག|མཚན་མོ)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : breton (br)
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : bosnian (bs)
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : catalan (ca)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : czech (cs)
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chuvash (cv)
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh (cy)
	//! author : Robert Allen
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : danish (da)
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : austrian german (de-at)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : german (de)
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dhivehi (dv)
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return '' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : modern greek (el)
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : australian english (en-au)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian english (en-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM, YYYY',
	            LLL : 'D MMMM, YYYY h:mm A',
	            LLLL : 'dddd, D MMMM, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain english (en-gb)
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish english (en-ie)
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : New Zealand english (en-nz)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : esperanto (eo)
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : spanish (es)
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : estonian (et)
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : euskara (eu)
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian (fa)
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : finnish (fi)
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : faroese (fo)
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : canadian french (fr-ca)
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swiss french (fr)
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : french (fr)
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : frisian (fy)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : great britain scottish gealic (gd)
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : galician (gl)
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'Xaneiro_Febreiro_Marzo_Abril_Maio_Xuño_Xullo_Agosto_Setembro_Outubro_Novembro_Decembro'.split('_'),
	        monthsShort : 'Xan._Feb._Mar._Abr._Mai._Xuñ._Xul._Ago._Set._Out._Nov._Dec.'.split('_'),
	        weekdays : 'Domingo_Luns_Martes_Mércores_Xoves_Venres_Sábado'.split('_'),
	        weekdaysShort : 'Dom._Lun._Mar._Mér._Xov._Ven._Sáb.'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Mé_Xo_Ve_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str === 'uns segundos') {
	                    return 'nuns segundos';
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew (he)
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hindi (hi)
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hrvatski (hr)
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : hungarian (hu)
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian (hy-am)
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Indonesia (id)
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : icelandic (is)
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : italian (it)
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : japanese (ja)
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Boso Jowo (jv)
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian (ka)
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : kazakh (kk)
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'Қаңтар_Ақпан_Наурыз_Сәуір_Мамыр_Маусым_Шілде_Тамыз_Қыркүйек_Қазан_Қараша_Желтоқсан'.split('_'),
	        monthsShort : 'Қаң_Ақп_Нау_Сәу_Мам_Мау_Шіл_Там_Қыр_Қаз_Қар_Жел'.split('_'),
	        weekdays : 'Жексенбі_Дүйсенбі_Сейсенбі_Сәрсенбі_Бейсенбі_Жұма_Сенбі'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Сей_Сәр_Бей_Жұм_Сен'.split('_'),
	        weekdaysMin : 'Жк_Дй_Сй_Ср_Бй_Жм_Сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : khmer (km)
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មិនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : korean (ko)
	//!
	//! authors
	//!
	//! - Kyungwook, Park : https://github.com/kyungw00k
	//! - Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한달',
	            MM : '%d달',
	            y : '일년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish (lb)
	//! author : mweimerskirch : https://github.com/mweimerskirch, David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : lao (lo)
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian (lt)
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_')
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : latvian (lv)
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin (me)
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sri.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : macedonian (mk)
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : malayalam (ml)
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        isPM : function (input) {
	            return /^(ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi (mr)
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bahasa Malaysia (ms-MY)
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese (my)
	//! author : Squar team, mysquar.com
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian bokmål (nb)
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : nepali/nepalese
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : dutch (nl)
	//! author : Joris Röling : https://github.com/jjupiter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : norwegian nynorsk (nn)
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'for %s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : polish (pl)
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : brazilian portuguese (pt-br)
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : portuguese (pt)
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : romanian (ro)
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : russian (ru)
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[й|я]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'Января_Февраля_Марта_Апреля_Мая_Июня_Июля_Августа_Сентября_Октября_Ноября_Декабря'.split('_'),
	            standalone: 'Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь'.split('_')
	        },
	        monthsShort : {
	            format: 'янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек'.split('_'),
	            standalone: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_')
	        },
	        weekdays : {
	            standalone: 'Воскресенье_Понедельник_Вторник_Среда_Четверг_Пятница_Суббота'.split('_'),
	            format: 'Воскресенье_Понедельник_Вторник_Среду_Четверг_Пятницу_Субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	        weekdaysMin : 'Вс_Пн_Вт_Ср_Чт_Пт_Сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami (se)
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese (si)
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovak (sk)
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : slovenian (sl)
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD. MM. YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian (sq)
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author: Menelion Elensúle: https://github.com/Oire (tests)
	//! author : Oerd Cukalla : https://github.com/oerd (fixes)
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-cyrillic (sr-cyrl)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар'],
	        monthsShort: ['јан.', 'феб.', 'мар.', 'апр.', 'мај', 'јун', 'јул', 'авг.', 'сеп.', 'окт.', 'нов.', 'дец.'],
	        weekdays: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота'],
	        weekdaysShort: ['нед.', 'пон.', 'уто.', 'сре.', 'чет.', 'пет.', 'суб.'],
	        weekdaysMin: ['не', 'по', 'ут', 'ср', 'че', 'пе', 'су'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian-latin (sr)
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
	        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
	        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
	        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
	        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swedish (sv)
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : swahili (sw)
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : tamil (ta)
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : telugu (te)
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : thai (th)
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา'.split('_'),
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        longDateFormat : {
	            LT : 'H นาฬิกา m นาที',
	            LTS : 'H นาฬิกา m นาที s วินาที',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H นาฬิกา m นาที',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H นาฬิกา m นาที'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog/Filipino (tl-ph)
	//! author : Dan Hagman
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon (tlh)
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'leS' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'waQ' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'nem' :
	    	time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	    	time.slice(0, -3) + 'Hu’' :
	    	(output.indexOf('jar') !== -1) ?
	    	time.slice(0, -3) + 'wen' :
	    	(output.indexOf('DIS') !== -1) ?
	    	time.slice(0, -3) + 'ben' :
	    	time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	    	ten = Math.floor((number % 100) / 10),
	    	one = number % 10,
	    	word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : turkish (tr)
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : talossan (tzl)
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v with the help of Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt in Latin (tzm-latn)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Morocco Central Atlas Tamaziɣt (tzm)
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : ukrainian (uk)
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : uzbek (uz)
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : vietnamese (vi)
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : chinese (zh-cn)
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() - startOfWeek.unix() >= 7 * 24 * 3600 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : traditional chinese (zh-tw)
	//! author : Ben : https://github.com/ben-lin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '一分鐘',
	            mm : '%d分鐘',
	            h : '一小時',
	            hh : '%d小時',
	            d : '一天',
	            dd : '%d天',
	            M : '一個月',
	            MM : '%d個月',
	            y : '一年',
	            yy : '%d年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ },
/* 638 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(638);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(641);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1190);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 641 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1191);


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var GridItem = __webpack_require__(1194);
	var utils = __webpack_require__(214);
	var PureDeepRenderMixin = __webpack_require__(371);
	var WidthListeningMixin = __webpack_require__(644);
	
	/**
	 * A reactive, fluid grid layout with draggable, resizable components.
	 */
	var ReactGridLayout = React.createClass({
	  displayName: 'ReactGridLayout',
	
	  mixins: [PureDeepRenderMixin, WidthListeningMixin],
	
	  propTypes: {
	    //
	    // Basic props
	    //
	
	    // If true, the container height swells and contracts to fit contents
	    autoSize: React.PropTypes.bool,
	    // # of cols.
	    cols: React.PropTypes.number,
	
	    // A selector that will not be draggable.
	    draggableCancel: React.PropTypes.string,
	    // A selector for the draggable handler
	    draggableHandle: React.PropTypes.string,
	
	    // If true, the layout will compact vertically
	    verticalCompact: React.PropTypes.bool,
	
	    // layout is an array of object with the format:
	    // {x: Number, y: Number, w: Number, h: Number}
	    layout: function layout(props, propName, componentName) {
	      var layout = props.layout;
	      // I hope you're setting the _grid property on the grid items
	      if (layout === undefined) return;
	      utils.validateLayout(layout, 'layout');
	    },
	
	    layouts: function layouts(props, propName, componentName) {
	      if (props.layouts) {
	        throw new Error("ReactGridLayout does not use `layouts`: Use ReactGridLayout.Responsive.");
	      }
	    },
	
	    // margin between items [x, y] in px
	    margin: React.PropTypes.array,
	    // Rows have a static height, but you can change this based on breakpoints if you like
	    rowHeight: React.PropTypes.number,
	
	    //
	    // Flags
	    //
	    isDraggable: React.PropTypes.bool,
	    isResizable: React.PropTypes.bool,
	    // Use CSS transforms instead of top/left
	    useCSSTransforms: React.PropTypes.bool,
	
	    //
	    // Callbacks
	    //
	
	    // Callback so you can save the layout.
	    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
	    onLayoutChange: React.PropTypes.func,
	
	    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e).
	    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
	    onDragStart: React.PropTypes.func,
	    // Calls on each drag movement.
	    onDrag: React.PropTypes.func,
	    // Calls when drag is complete.
	    onDragStop: React.PropTypes.func,
	    //Calls when resize starts.
	    onResizeStart: React.PropTypes.func,
	    // Calls when resize movement happens.
	    onResize: React.PropTypes.func,
	    // Calls when resize is complete.
	    onResizeStop: React.PropTypes.func,
	
	    //
	    // Other validations
	    //
	
	    // Children must not have duplicate keys.
	    children: function children(props, propName, componentName) {
	      React.PropTypes.node.apply(this, arguments);
	      var children = props[propName];
	
	      // Check children keys for duplicates. Throw if found.
	      var keys = {};
	      React.Children.forEach(children, function (child, i, list) {
	        if (keys[child.key]) {
	          throw new Error("Duplicate child key found! This will cause problems in ReactGridLayout.");
	        }
	        keys[child.key] = true;
	      });
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      autoSize: true,
	      cols: 12,
	      rowHeight: 150,
	      layout: [],
	      margin: [10, 10],
	      isDraggable: true,
	      isResizable: true,
	      useCSSTransforms: true,
	      verticalCompact: true,
	      onLayoutChange: function onLayoutChange() {},
	      onDragStart: function onDragStart() {},
	      onDrag: function onDrag() {},
	      onDragStop: function onDragStop() {},
	      onResizeStart: function onResizeStart() {},
	      onResize: function onResize() {},
	      onResizeStop: function onResizeStop() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      activeDrag: null,
	      isMounted: false,
	      layout: utils.synchronizeLayoutWithChildren(this.props.layout, this.props.children, this.props.cols, this.props.verticalCompact),
	      width: this.props.initialWidth
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    // Call back with layout on mount. This should be done after correcting the layout width
	    // to ensure we don't rerender with the wrong width.
	    this.props.onLayoutChange(this.state.layout);
	    this.setState({ isMounted: true });
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // This allows you to set the width manually if you like.
	    // Use manual width changes in combination with `listenToWindowResize: false`
	    if (nextProps.width !== this.props.width) this.onWidthChange(nextProps.width);
	
	    // If children change, regenerate the layout.
	    if (nextProps.children.length !== this.props.children.length) {
	      this.setState({
	        layout: utils.synchronizeLayoutWithChildren(this.state.layout, nextProps.children, nextProps.cols, this.props.verticalCompact)
	      });
	    }
	
	    // Allow parent to set layout directly.
	    if (nextProps.layout && JSON.stringify(nextProps.layout) !== JSON.stringify(this.state.layout)) {
	      this.setState({
	        layout: utils.synchronizeLayoutWithChildren(nextProps.layout, nextProps.children, nextProps.cols, this.props.verticalCompact)
	      });
	    }
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    // Call back so we can store the layout
	    // Do it only when a resize/drag is not active, otherwise there are way too many callbacks
	    if (this.state.layout !== prevState.layout && !this.state.activeDrag) {
	      this.props.onLayoutChange(this.state.layout, this.state.layouts);
	    }
	  },
	
	  /**
	   * Calculates a pixel value for the container.
	   * @return {String} Container height in pixels.
	   */
	  containerHeight: function containerHeight() {
	    if (!this.props.autoSize) return;
	    return utils.bottom(this.state.layout) * this.props.rowHeight + this.props.margin[1] + 'px';
	  },
	
	  /**
	   * When the width changes, save it to state. This helps with left/width calculations.
	   */
	  onWidthChange: function onWidthChange(width) {
	    this.setState({ width: width });
	  },
	
	  /**
	   * When dragging starts
	   * @param {Number} i Index of the child
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} element The current dragging DOM element
	   * @param {Object} position Drag information
	   */
	  onDragStart: function onDragStart(i, x, y, _ref) {
	    var e = _ref.e;
	    var element = _ref.element;
	    var position = _ref.position;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	
	    // No need to clone, `l` hasn't changed.
	    this.props.onDragStart(layout, l, l, null, e);
	  },
	  /**
	   * Each drag movement create a new dragelement and move the element to the dragged location
	   * @param {Number} i Index of the child
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} element The current dragging DOM element
	   * @param {Object} position Drag information
	   */
	  onDrag: function onDrag(i, x, y, _ref2) {
	    var e = _ref2.e;
	    var element = _ref2.element;
	    var position = _ref2.position;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	    // Clone layout item so we can pass it to the callback.
	    var oldL = utils.clone(l);
	
	    // Create placeholder (display only)
	    var placeholder = {
	      w: l.w, h: l.h, x: l.x, y: l.y, placeholder: true, i: i
	    };
	
	    // Move the element to the dragged location.
	    layout = utils.moveElement(layout, l, x, y, true /* isUserAction */);
	
	    this.props.onDrag(layout, oldL, l, placeholder, e);
	
	    this.setState({
	      layout: utils.compact(layout, this.props.verticalCompact),
	      activeDrag: placeholder
	    });
	  },
	
	  /**
	   * When dragging stops, figure out which position the element is closest to and update its x and y.
	   * @param  {Number} i Index of the child.
	   * @param {Number} i Index of the child
	   * @param {Number} x X position of the move
	   * @param {Number} y Y position of the move
	   * @param {Event} e The mousedown event
	   * @param {Element} element The current dragging DOM element
	   * @param {Object} position Drag information
	   */
	  onDragStop: function onDragStop(i, x, y, _ref3) {
	    var e = _ref3.e;
	    var element = _ref3.element;
	    var position = _ref3.position;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	    var oldL = utils.clone(l);
	
	    // Move the element here
	    layout = utils.moveElement(layout, l, x, y, true /* isUserAction */);
	
	    this.props.onDragStop(layout, oldL, l, null, e);
	
	    // Set state
	    this.setState({ layout: utils.compact(layout, this.props.verticalCompact), activeDrag: null });
	  },
	
	  onResizeStart: function onResizeStart(i, w, h, _ref4) {
	    var e = _ref4.e;
	    var element = _ref4.element;
	    var size = _ref4.size;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	
	    // No need to clone, item hasn't changed
	    this.props.onResizeStart(layout, l, l, null, e);
	  },
	
	  onResize: function onResize(i, w, h, _ref5) {
	    var e = _ref5.e;
	    var element = _ref5.element;
	    var size = _ref5.size;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	    var oldL = utils.clone(l);
	
	    // Set new width and height.
	    l.w = w;
	    l.h = h;
	
	    // Create placeholder element (display only)
	    var placeholder = {
	      w: w, h: h, x: l.x, y: l.y, placeholder: true, i: i
	    };
	
	    this.props.onResize(layout, oldL, l, placeholder, e);
	
	    // Re-compact the layout and set the drag placeholder.
	    this.setState({ layout: utils.compact(layout, this.props.verticalCompact), activeDrag: placeholder });
	  },
	
	  onResizeStop: function onResizeStop(i, x, y, _ref6) {
	    var e = _ref6.e;
	    var element = _ref6.element;
	    var size = _ref6.size;
	
	    var layout = this.state.layout;
	    var l = utils.getLayoutItem(layout, i);
	    var oldL = utils.clone(l);
	
	    this.props.onResizeStop(layout, oldL, l, null, e);
	
	    this.setState({ activeDrag: null, layout: utils.compact(layout, this.props.verticalCompact) });
	  },
	
	  /**
	   * Create a placeholder object.
	   * @return {Element} Placeholder div.
	   */
	  placeholder: function placeholder() {
	    if (!this.state.activeDrag) return '';
	
	    // {...this.state.activeDrag} is pretty slow, actually
	    return React.createElement(
	      GridItem,
	      {
	        w: this.state.activeDrag.w,
	        h: this.state.activeDrag.h,
	        x: this.state.activeDrag.x,
	        y: this.state.activeDrag.y,
	        i: this.state.activeDrag.i,
	        isPlaceholder: true,
	        className: 'react-grid-placeholder',
	        containerWidth: this.state.width,
	        cols: this.props.cols,
	        margin: this.props.margin,
	        rowHeight: this.props.rowHeight,
	        isDraggable: false,
	        isResizable: false,
	        useCSSTransforms: this.props.useCSSTransforms
	      },
	      React.createElement('div', null)
	    );
	  },
	
	  /**
	   * Given a grid item, set its style attributes & surround in a <Draggable>.
	   * @param  {Element} child React element.
	   * @param  {Number}  i     Index of element.
	   * @return {Element}       Element wrapped in draggable and properly placed.
	   */
	  processGridItem: function processGridItem(child) {
	    var i = child.key;
	    var l = utils.getLayoutItem(this.state.layout, i);
	
	    // watchStart property tells Draggable to react to changes in the start param
	    // Must be turned off on the item we're dragging as the changes in `activeDrag` cause rerenders
	    var drag = this.state.activeDrag;
	    var moveOnStartChange = drag && drag.i === i ? false : true;
	
	    // Parse 'static'. Any properties defined directly on the grid item will take precedence.
	    var draggable, resizable;
	    if (l['static'] || this.props.isDraggable === false) draggable = false;
	    if (l['static'] || this.props.isResizable === false) resizable = false;
	
	    return React.createElement(
	      GridItem,
	      _extends({
	        containerWidth: this.state.width,
	        cols: this.props.cols,
	        margin: this.props.margin,
	        rowHeight: this.props.rowHeight,
	        moveOnStartChange: moveOnStartChange,
	        cancel: this.props.draggableCancel,
	        handle: this.props.draggableHandle,
	        onDragStop: this.onDragStop,
	        onDragStart: this.onDragStart,
	        onDrag: this.onDrag,
	        onResizeStart: this.onResizeStart,
	        onResize: this.onResize,
	        onResizeStop: this.onResizeStop,
	        isDraggable: draggable,
	        isResizable: resizable,
	        useCSSTransforms: this.props.useCSSTransforms && this.state.isMounted,
	        usePercentages: !this.state.isMounted
	      }, l),
	      child
	    );
	  },
	
	  render: function render() {
	    // Calculate classname
	    var _props = this.props;
	    var className = _props.className;
	
	    var props = _objectWithoutProperties(_props, ['className']);
	
	    className = 'react-grid-layout ' + (className || '');
	
	    return React.createElement(
	      'div',
	      _extends({}, props, { className: className, style: { height: this.containerHeight() } }),
	      React.Children.map(this.props.children, this.processGridItem),
	      this.placeholder()
	    );
	  }
	});
	
	module.exports = ReactGridLayout;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var React = __webpack_require__(1);
	
	/**
	 * A simple mixin that provides facility for listening to container resizes.
	 */
	var WidthListeningMixin = {
	
	  propTypes: {
	    // This allows setting this on the server side
	    initialWidth: React.PropTypes.number,
	
	    // If false, you should supply width yourself. Good if you want to debounce resize events
	    // or reuse a handler from somewhere else.
	    listenToWindowResize: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialWidth: 1280,
	      listenToWindowResize: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.listenToWindowResize) {
	      window.addEventListener('resize', this.onWindowResize);
	      // This is intentional. Once to properly set the breakpoint and resize the elements,
	      // and again to compensate for any scrollbar that appeared because of the first step.
	      this.onWindowResize();
	      this.onWindowResize();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    window.removeEventListener('resize', this.onWindowResize);
	  },
	
	  /**
	   * On window resize, update width.
	   */
	  onWindowResize: function onWindowResize() {
	    this.onWidthChange(this.getDOMNode().offsetWidth);
	  }
	
	};
	
	module.exports = WidthListeningMixin;

/***/ },
/* 645 */
/***/ function(module, exports) {

	// Used for calculations
	var defaultWidth = 320;
	var defaultColors = {
	  success: '#5ea400',
	  error: '#ec3d3d',
	  warning: '#ebad1a',
	  info: '#369cc7'
	}
	
	var STYLES = {
	
	  Wrapper: {},
	  Containers: {
	    DefaultStyle: {
	      fontFamily: 'inherit',
	      position: 'fixed',
	      width: defaultWidth,
	      padding: '0 10px 10px 10px',
	      zIndex: 9998,
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      height: 'auto'
	    },
	
	    tl: {
	      top: "0px",
	      bottom: "auto",
	      left: '0px',
	      right: 'auto'
	    },
	
	    tr: {
	      top: "0px",
	      bottom: "auto",
	      left: 'auto',
	      right: '0px'
	    },
	
	    tc: {
	      top: "0px",
	      bottom: "auto",
	      margin: "0 auto",
	      left: "50%",
	      marginLeft: -(defaultWidth/2)
	    },
	
	    bl: {
	      top: "auto",
	      bottom: "0px",
	      left: '0px',
	      right: 'auto'
	    },
	
	    br: {
	      top: "auto",
	      bottom: "0px",
	      left: 'auto',
	      right: '0px'
	    },
	
	    bc: {
	      top: "auto",
	      bottom: "0px",
	      margin: "0 auto",
	      left: "50%",
	      marginLeft: -(defaultWidth/2)
	    }
	
	  },
	
	  NotificationItem: {
	    DefaultStyle: {
	      position: 'relative',
	      width: '100%',
	      cursor: 'pointer',
	      borderRadius: '2px',
	      fontSize: '13px',
	      border: '1px solid',
	      borderTopWidth: '4px',
	      margin: '10px 0 0',
	      padding: '10px',
	      display: 'block',
	      WebkitBoxSizing: 'border-box',
	      MozBoxSizing: 'border-box',
	      boxSizing: 'border-box',
	      WebkitBoxShadow: '0px 0px 5px 2px rgba(0,0,0,0.1)',
	      MozBoxShadow: '0px 0px 5px 2px rgba(0,0,0,0.1)',
	      boxShadow: '0px 0px 5px 2px rgba(0,0,0,0.1)',
	      opacity: 0,
	      transition: '0.3s ease-in-out',
	
	      isHidden: {
	        opacity: 0
	      },
	
	      isVisible: {
	        opacity: 0.9
	      }
	    },
	
	    success: {
	      borderColor: '#d0ddbe',
	      borderTopColor: defaultColors.success,
	      backgroundColor: '#f0f5ea',
	      color: '#4b583a'
	    },
	
	    error: {
	      borderColor: '#edbfbf',
	      borderTopColor: defaultColors.error,
	      backgroundColor: '#f4e9e9',
	      color: '#412f2f'
	    },
	
	    warning: {
	      borderColor: '#ecd9ab',
	      borderTopColor: defaultColors.warning,
	      backgroundColor: '#f9f6f0',
	      color: '#5a5343'
	    },
	
	    info: {
	      borderColor: '#b2d0dd',
	      borderTopColor: defaultColors.info,
	      backgroundColor: '#e8f0f4',
	      color: '#41555d'
	    }
	  },
	
	  Title: {
	    DefaultStyle: {
	      fontSize: '14px',
	      margin: '0 0 5px 0',
	      padding: 0,
	      fontWeight: 'bold'
	    },
	
	    success: {
	      color: defaultColors.success
	    },
	
	    error: {
	      color: defaultColors.error
	    },
	
	    warning: {
	      color: defaultColors.warning
	    },
	
	    info: {
	      color: defaultColors.info
	    }
	
	  },
	
	  MessageWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  },
	
	  Dismiss: {
	    DefaultStyle: {
	      fontFamily: 'Arial',
	      fontSize: '17px',
	      position: 'absolute',
	      top: '4px',
	      right: '5px',
	      lineHeight: '15px',
	      backgroundColor: '#dededf',
	      color: '#ffffff',
	      borderRadius: '50%',
	      width: '14px',
	      height: '14px',
	      fontWeight: 'bold',
	      textAlign: 'center'
	    },
	
	    success: {
	      color: '#f0f5ea',
	      backgroundColor: '#b0ca92'
	    },
	
	    error: {
	      color: '#f4e9e9',
	      backgroundColor: '#e4bebe'
	    },
	
	    warning: {
	      color: '#f9f6f0',
	      backgroundColor: '#e1cfac'
	    },
	
	    info: {
	      color: '#e8f0f4',
	      backgroundColor: '#a4becb'
	    }
	  },
	
	  Action: {
	    DefaultStyle: {
	      background: '#ffffff',
	      borderRadius: '2px',
	      padding: '6px 20px',
	      fontWeight: 'bold',
	      margin: '10px 0 0 0',
	      border: 0
	    },
	
	    success: {
	      backgroundColor: defaultColors.success,
	      color: '#ffffff'
	    },
	
	    error: {
	      backgroundColor: defaultColors.error,
	      color: '#ffffff'
	    },
	
	    warning: {
	      backgroundColor: defaultColors.warning,
	      color: '#ffffff'
	    },
	
	    info: {
	      backgroundColor: defaultColors.info,
	      color: '#ffffff'
	    }
	  },
	
	  ActionWrapper: {
	    DefaultStyle: {
	      margin: 0,
	      padding: 0
	    }
	  }
	};
	
	module.exports = STYLES;


/***/ },
/* 646 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Draggable = __webpack_require__(642);
	var PureRenderMixin = __webpack_require__(219);
	var assign = __webpack_require__(74);
	var cloneWithProps = __webpack_require__(175);
	
	var Resizable = module.exports = React.createClass({
	  displayName: 'Resizable',
	  mixins: [PureRenderMixin],
	
	  propTypes: {
	    // Require that one and only one child be present.
	    children: React.PropTypes.element.isRequired,
	    // Functions
	    onResizeStop: React.PropTypes.func,
	    onResizeStart: React.PropTypes.func,
	    onResize: React.PropTypes.func,
	
	    width: React.PropTypes.number.isRequired,
	    height: React.PropTypes.number.isRequired,
	    // If you change this, be sure to update your css
	    handleSize: React.PropTypes.array,
	    // These will be passed wholesale to react-draggable
	    draggableOpts: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      handleSize: [20, 20]
	    };
	  },
	
	  minConstraints: function minConstraints() {
	    return parseConstraints(this.props.minConstraints, this.props.handleSize) || this.props.handleSize;
	  },
	
	  maxConstraints: function maxConstraints() {
	    return parseConstraints(this.props.maxConstraints, this.props.handleSize);
	  },
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  resizeHandler: function resizeHandler(handlerName) {
	    var me = this;
	    return function (e, _ref) {
	      var element = _ref.element;
	      var position = _ref.position;
	
	      me.props[handlerName] && me.props[handlerName](e, { element: element, size: calcWH(position, me.props.handleSize) });
	    };
	  },
	
	  render: function render() {
	    var p = this.props;
	
	    // What we're doing here is getting the child of this element, and cloning it with this element's props.
	    // We are then defining its children as:
	    // Its original children (resizable's child's children), and
	    // A draggable handle.
	    return cloneWithProps(p.children, assign({}, p, {
	      children: [p.children.props.children, React.createElement(
	        Draggable,
	        _extends({}, p.draggableOpts, {
	          start: { x: p.width - 20, y: p.height - 20 },
	          moveOnStartChange: true,
	          onStop: this.resizeHandler('onResizeStop'),
	          onStart: this.resizeHandler('onResizeStart'),
	          onDrag: this.resizeHandler('onResize'),
	          minConstraints: this.minConstraints(),
	          maxConstraints: this.maxConstraints()
	        }),
	        React.createElement('span', { className: 'react-resizable-handle' })
	      )]
	    }));
	  }
	});
	
	/**
	 * Parse left and top coordinates; we have to add the handle size to get the full picture.
	 * @param  {Number} options.left Left coordinate.
	 * @param  {Number} options.top  Top coordinate.
	 * @param  {Array}  handleSize   Handle data.
	 * @return {Object}              Coordinates
	 */
	function calcWH(_ref, handleSize) {
	  var left = _ref.left;
	  var top = _ref.top;
	
	  return { width: left + handleSize[0], height: top + handleSize[1] };
	}
	
	/**
	 * Constraints must be subtracted by the size of the handle to work properly.
	 * This has a side-effect of effectively limiting the minimum size to the handleSize,
	 * which IMO is fine.
	 * @param  {Array} constraints Constraints array.
	 * @param  {Array} handleSize  Handle size array.
	 * @return {Array}             Transformed constraints.
	 */
	function parseConstraints(constraints, handleSize) {
	  if (!constraints) {
	    return;
	  }return constraints.map(function (c, i) {
	    return c - handleSize[i];
	  });
	}

/***/ },
/* 648 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ },
/* 649 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Encapsulates a redirect to the given route.
	 */
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var LocationActions = __webpack_require__(172);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var PropTypes = __webpack_require__(90);
	var RouteHandler = __webpack_require__(216);
	var Route = __webpack_require__(215);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(DefaultRoute, _Route);
	
	  return DefaultRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var PropTypes = __webpack_require__(90);
	var RouteHandler = __webpack_require__(216);
	var Route = __webpack_require__(215);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(NotFoundRoute, _Route);
	
	  return NotFoundRoute;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var PropTypes = __webpack_require__(90);
	var Route = __webpack_require__(215);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    if (_Route != null) {
	      _Route.apply(this, arguments);
	    }
	  }
	
	  _inherits(Redirect, _Route);
	
	  return Redirect;
	})(Route);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* jshint -W058 */
	var React = __webpack_require__(1);
	var warning = __webpack_require__(32);
	var invariant = __webpack_require__(15);
	var canUseDOM = __webpack_require__(44).canUseDOM;
	var LocationActions = __webpack_require__(172);
	var ImitateBrowserBehavior = __webpack_require__(650);
	var HashLocation = __webpack_require__(656);
	var HistoryLocation = __webpack_require__(375);
	var RefreshLocation = __webpack_require__(657);
	var StaticLocation = __webpack_require__(658);
	var ScrollHistory = __webpack_require__(1205);
	var createRoutesFromReactChildren = __webpack_require__(655);
	var isReactChildren = __webpack_require__(1212);
	var Transition = __webpack_require__(1207);
	var PropTypes = __webpack_require__(90);
	var Redirect = __webpack_require__(649);
	var History = __webpack_require__(148);
	var Cancellation = __webpack_require__(648);
	var Match = __webpack_require__(1203);
	var Route = __webpack_require__(122);
	var supportsHistory = __webpack_require__(1215);
	var PathUtils = __webpack_require__(374);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : "/";
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) {
	    return false;
	  }return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, "You may not have more than one route named \"%s\"", route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) {
	    return false;
	  }return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) {
	    return false;
	  }return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === "string") location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV === "test", "You should not use a static location in a DOM environment because " + "the router will not be kept in sync with the current URL");
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, "You cannot use %s without a DOM", location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: "Router",
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, "Cannot find a route named \"%s\"", to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? "#" + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, "goBack() was ignored because there is no router history");
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error("Unhandled aborted transition! Reason: " + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) {
	          return;
	        } // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, "No route matches path \"%s\". Make sure you have <Route path=\"%s\"> somewhere in your routes", path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, "Router is already running");
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) {
	          return to === state.path;
	        }return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* jshint -W084 */
	var React = __webpack_require__(1);
	var assign = __webpack_require__(25);
	var warning = __webpack_require__(32);
	var DefaultRoute = __webpack_require__(651);
	var NotFoundRoute = __webpack_require__(652);
	var Redirect = __webpack_require__(653);
	var Route = __webpack_require__(122);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || "UnknownComponent";
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) {
	    return;
	  }var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) {
	    return Route.createDefaultRoute(createRouteOptions(props));
	  }if (type === NotFoundRoute) {
	    return Route.createNotFoundRoute(createRouteOptions(props));
	  }if (type === Redirect) {
	    return Route.createRedirect(createRouteOptions(props));
	  }return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var LocationActions = __webpack_require__(172);
	var History = __webpack_require__(148);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === "/") {
	    return true;
	  }HashLocation.replace("/" + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener("hashchange", onHashChange, false);
	      } else {
	        window.attachEvent("onhashchange", onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener("hashchange", onHashChange, false);
	      } else {
	        window.removeEvent("onhashchange", onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + "#" + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split("#")[1] || "");
	  },
	
	  toString: function toString() {
	    return "<HashLocation>";
	  }
	
	};
	
	module.exports = HashLocation;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var HistoryLocation = __webpack_require__(375);
	var History = __webpack_require__(148);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return "<RefreshLocation>";
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var invariant = __webpack_require__(15);
	
	function throwCannotModify() {
	  invariant(false, "You cannot modify a static location");
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  _createClass(StaticLocation, {
	    getCurrentPath: {
	      value: function getCurrentPath() {
	        return this.path;
	      }
	    },
	    toString: {
	      value: function toString() {
	        return "<StaticLocation path=\"" + this.path + "\">";
	      }
	    }
	  });
	
	  return StaticLocation;
	})();
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ },
/* 659 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 660 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function(prop) {
	  prefixes.forEach(function(prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundImage: true,
	    backgroundPosition: true,
	    backgroundRepeat: true,
	    backgroundColor: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(660);
	var ExecutionEnvironment = __webpack_require__(44);
	
	var camelizeStyleName = __webpack_require__(1285);
	var dangerousStyleValue = __webpack_require__(1290);
	var hyphenateStyleName = __webpack_require__(1297);
	var memoizeStringOnly = __webpack_require__(1301);
	var warning = __webpack_require__(32);
	
	var processStyleName = memoizeStringOnly(function(styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      false,
	      'Unsupported style property %s. Did you mean %s?',
	      name,
	      camelizeStyleName(name)
	    ) : null);
	  };
	
	  var warnBadVendoredStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      false,
	      'Unsupported vendor-prefixed style property %s. Did you mean %s?',
	      name,
	      name.charAt(0).toUpperCase() + name.slice(1)
	    ) : null);
	  };
	
	  var warnStyleValueWithSemicolon = function(name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      false,
	      'Style property values shouldn\'t contain a semicolon. ' +
	      'Try "%s: %s" instead.',
	      name,
	      value.replace(badStyleValueWithSemicolonPattern, '')
	    ) : null);
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function(name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function(styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function(node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      pluginIndex > -1,
	      'EventPluginRegistry: Cannot inject event plugins that do not exist in ' +
	      'the plugin ordering, `%s`.',
	      pluginName
	    ) : invariant(pluginIndex > -1));
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      PluginModule.extractEvents,
	      'EventPluginRegistry: Event plugins must implement an `extractEvents` ' +
	      'method, but `%s` does not.',
	      pluginName
	    ) : invariant(PluginModule.extractEvents));
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        publishEventForPlugin(
	          publishedEvents[eventName],
	          PluginModule,
	          eventName
	        ),
	        'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.',
	        eventName,
	        pluginName
	      ) : invariant(publishEventForPlugin(
	        publishedEvents[eventName],
	        PluginModule,
	        eventName
	      )));
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    !EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName),
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'event name, `%s`.',
	    eventName
	  ) : invariant(!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName)));
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(
	          phasedRegistrationName,
	          PluginModule,
	          eventName
	        );
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(
	      dispatchConfig.registrationName,
	      PluginModule,
	      eventName
	    );
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    !EventPluginRegistry.registrationNameModules[registrationName],
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'registration name, `%s`.',
	    registrationName
	  ) : invariant(!EventPluginRegistry.registrationNameModules[registrationName]));
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] =
	    PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function(InjectedEventPluginOrder) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !EventPluginOrder,
	      'EventPluginRegistry: Cannot inject event plugin ordering more than ' +
	      'once. You are likely trying to load more than one copy of React.'
	    ) : invariant(!EventPluginOrder));
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) ||
	          namesToPlugins[pluginName] !== PluginModule) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          !namesToPlugins[pluginName],
	          'EventPluginRegistry: Cannot inject two different event plugins ' +
	          'using the same name, `%s`.',
	          pluginName
	        ) : invariant(!namesToPlugins[pluginName]));
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[
	        dispatchConfig.registrationName
	      ] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[
	        dispatchConfig.phasedRegistrationNames[phase]
	      ];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function() {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	var ReactFragment = __webpack_require__(149);
	
	var traverseAllChildren = __webpack_require__(687);
	var warning = __webpack_require__(32);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var threeArgumentPooler = PooledClass.threeArgumentPooler;
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.forEachFunction = forEachFunction;
	  this.forEachContext = forEachContext;
	}
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(traverseContext, child, name, i) {
	  var forEachBookKeeping = traverseContext;
	  forEachBookKeeping.forEachFunction.call(
	    forEachBookKeeping.forEachContext, child, i);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	
	  var traverseContext =
	    ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, mapFunction, mapContext) {
	  this.mapResult = mapResult;
	  this.mapFunction = mapFunction;
	  this.mapContext = mapContext;
	}
	PooledClass.addPoolingTo(MapBookKeeping, threeArgumentPooler);
	
	function mapSingleChildIntoContext(traverseContext, child, name, i) {
	  var mapBookKeeping = traverseContext;
	  var mapResult = mapBookKeeping.mapResult;
	
	  var keyUnique = !mapResult.hasOwnProperty(name);
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      keyUnique,
	      'ReactChildren.map(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	
	  if (keyUnique) {
	    var mappedChild =
	      mapBookKeeping.mapFunction.call(mapBookKeeping.mapContext, child, i);
	    mapResult[name] = mappedChild;
	  }
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * TODO: This may likely break any calls to `ReactChildren.map` that were
	 * previously relying on the fact that we guarded against null children.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	
	  var mapResult = {};
	  var traverseContext = MapBookKeeping.getPooled(mapResult, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	  return ReactFragment.create(mapResult);
	}
	
	function forEachSingleChildDummy(traverseContext, child, name, i) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  count: countChildren
	};
	
	module.exports = ReactChildren;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactUpdateQueue = __webpack_require__(385);
	
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context) {
	  this.props = props;
	  this.context = context;
	}
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function(partialState, callback) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    typeof partialState === 'object' ||
	    typeof partialState === 'function' ||
	    partialState == null,
	    'setState(...): takes an object of state variables to update or a ' +
	    'function which returns an object of state variables.'
	  ) : invariant(typeof partialState === 'object' ||
	  typeof partialState === 'function' ||
	  partialState == null));
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      partialState != null,
	      'setState(...): You passed an undefined or null state object; ' +
	      'instead, use forceUpdate().'
	    ) : null);
	  }
	  ReactUpdateQueue.enqueueSetState(this, partialState);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function(callback) {
	  ReactUpdateQueue.enqueueForceUpdate(this);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  var deprecatedAPIs = {
	    getDOMNode: [
	      'getDOMNode',
	      'Use React.findDOMNode(component) instead.'
	    ],
	    isMounted: [
	      'isMounted',
	      'Instead, make sure to clean up subscriptions and pending requests in ' +
	      'componentWillUnmount to prevent memory leaks.'
	    ],
	    replaceProps: [
	      'replaceProps',
	      'Instead, call React.render again at the top level.'
	    ],
	    replaceState: [
	      'replaceState',
	      'Refactor your code to use setState instead (see ' +
	      'https://github.com/facebook/react/issues/3236).'
	    ],
	    setProps: [
	      'setProps',
	      'Instead, call React.render again at the top level.'
	    ]
	  };
	  var defineDeprecationWarning = function(methodName, info) {
	    try {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function() {
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	            false,
	            '%s(...) is deprecated in plain JavaScript React classes. %s',
	            info[0],
	            info[1]
	          ) : null);
	          return undefined;
	        }
	      });
	    } catch (x) {
	      // IE will fail on defineProperty (es5-shim/sham too)
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(380);
	var ReactContext = __webpack_require__(381);
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactElement = __webpack_require__(38);
	var ReactElementValidator = __webpack_require__(174);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactLifeCycle = __webpack_require__(383);
	var ReactNativeComponent = __webpack_require__(221);
	var ReactPerf = __webpack_require__(103);
	var ReactPropTypeLocations = __webpack_require__(384);
	var ReactPropTypeLocationNames = __webpack_require__(222);
	var ReactReconciler = __webpack_require__(150);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	var emptyObject = __webpack_require__(176);
	var invariant = __webpack_require__(15);
	var shouldUpdateReactComponent = __webpack_require__(395);
	var warning = __webpack_require__(32);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function(element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._isTopLevel = false;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(this._currentElement._context);
	
	    var Component = ReactNativeComponent.getComponentClassForElement(
	      this._currentElement
	    );
	
	    // Initialize the public class
	    var inst = new Component(publicProps, publicContext);
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        inst.render != null,
	        '%s(...): No `render` method found on the returned component ' +
	        'instance: you may have forgotten to define `render` in your ' +
	        'component or you may have accidentally tried to render an element ' +
	        'whose type is a function that isn\'t a React component.',
	        Component.displayName || Component.name || 'Component'
	      ) : null);
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      this._warnIfContextsDiffer(this._currentElement._context, context);
	    }
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !inst.getInitialState ||
	        inst.getInitialState.isReactClassApproved,
	        'getInitialState was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Did you mean to define a state property instead?',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !inst.getDefaultProps ||
	        inst.getDefaultProps.isReactClassApproved,
	        'getDefaultProps was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Use a static property to define defaultProps instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !inst.propTypes,
	        'propTypes was defined as an instance property on %s. Use a static ' +
	        'property to define propTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        !inst.contextTypes,
	        'contextTypes was defined as an instance property on %s. Use a ' +
	        'static property to define contextTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        typeof inst.componentShouldUpdate !== 'function',
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        (this.getName() || 'A component')
	      ) : null);
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof initialState === 'object' && !Array.isArray(initialState),
	      '%s.state: must be set to an object or null',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var childContext;
	    var renderedElement;
	
	    var previouslyMounting = ReactLifeCycle.currentlyMountingInstance;
	    ReactLifeCycle.currentlyMountingInstance = this;
	    try {
	      if (inst.componentWillMount) {
	        inst.componentWillMount();
	        // When mounting, calls to `setState` by `componentWillMount` will set
	        // `this._pendingStateQueue` without triggering a re-render.
	        if (this._pendingStateQueue) {
	          inst.state = this._processPendingState(inst.props, inst.context);
	        }
	      }
	
	      childContext = this._getValidatedChildContext(context);
	      renderedElement = this._renderValidatedComponent(childContext);
	    } finally {
	      ReactLifeCycle.currentlyMountingInstance = previouslyMounting;
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(
	      renderedElement,
	      this._currentElement.type // The wrapping type
	    );
	
	    var markup = ReactReconciler.mountComponent(
	      this._renderedComponent,
	      rootID,
	      transaction,
	      this._mergeChildContext(context, childContext)
	    );
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function() {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      var previouslyUnmounting = ReactLifeCycle.currentlyUnmountingInstance;
	      ReactLifeCycle.currentlyUnmountingInstance = this;
	      try {
	        inst.componentWillUnmount();
	      } finally {
	        ReactLifeCycle.currentlyUnmountingInstance = previouslyUnmounting;
	      }
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	
	    // Reset pending fields
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Schedule a partial update to the props. Only used for internal testing.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @internal
	   */
	  _setPropsInternal: function(partialProps, callback) {
	    // This is a deoptimized path. We optimize for always having an element.
	    // This creates an extra internal element.
	    var element = this._pendingElement || this._currentElement;
	    this._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      assign({}, element.props, partialProps)
	    );
	    ReactUpdates.enqueueUpdate(this, callback);
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function(context) {
	    var maskedContext = null;
	    // This really should be getting the component class for the element,
	    // but we know that we're not going to need it for built-ins.
	    if (typeof this._currentElement.type === 'string') {
	      return emptyObject;
	    }
	    var contextTypes = this._currentElement.type.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function(context) {
	    var maskedContext = this._maskContext(context);
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.contextTypes) {
	        this._checkPropTypes(
	          Component.contextTypes,
	          maskedContext,
	          ReactPropTypeLocations.context
	        );
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _getValidatedChildContext: function(currentContext) {
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        typeof inst.constructor.childContextTypes === 'object',
	        '%s.getChildContext(): childContextTypes must be defined in order to ' +
	        'use getChildContext().',
	        this.getName() || 'ReactCompositeComponent'
	      ) : invariant(typeof inst.constructor.childContextTypes === 'object'));
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        this._checkPropTypes(
	          inst.constructor.childContextTypes,
	          childContext,
	          ReactPropTypeLocations.childContext
	        );
	      }
	      for (var name in childContext) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          name in inst.constructor.childContextTypes,
	          '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
	          this.getName() || 'ReactCompositeComponent',
	          name
	        ) : invariant(name in inst.constructor.childContextTypes));
	      }
	      return childContext;
	    }
	    return null;
	  },
	
	  _mergeChildContext: function(currentContext, childContext) {
	    if (childContext) {
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function(newProps) {
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.propTypes) {
	        this._checkPropTypes(
	          Component.propTypes,
	          newProps,
	          ReactPropTypeLocations.prop
	        );
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function(propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	            typeof propTypes[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually ' +
	            'from React.PropTypes.',
	            componentName || 'React class',
	            ReactPropTypeLocationNames[location],
	            propName
	          ) : invariant(typeof propTypes[propName] === 'function'));
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // React.render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	              false,
	              'Failed Composite propType: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          } else {
	            ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	              false,
	              'Failed Context Types: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(
	      transaction,
	      prevElement,
	      nextElement,
	      prevContext,
	      nextContext
	    );
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(
	        this,
	        this._pendingElement || this._currentElement,
	        transaction,
	        this._context
	      );
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        ReactElementValidator.checkAndWarnForMutatedProps(
	          this._currentElement
	        );
	      }
	
	      this.updateComponent(
	        transaction,
	        this._currentElement,
	        this._currentElement,
	        this._context,
	        this._context
	      );
	    }
	  },
	
	  /**
	   * Compare two contexts, warning if they are different
	   * TODO: Remove this check when owner-context is removed
	   */
	   _warnIfContextsDiffer: function(ownerBasedContext, parentBasedContext) {
	    ownerBasedContext = this._maskContext(ownerBasedContext);
	    parentBasedContext = this._maskContext(parentBasedContext);
	    var parentKeys = Object.keys(parentBasedContext).sort();
	    var displayName = this.getName() || 'ReactCompositeComponent';
	    for (var i = 0; i < parentKeys.length; i++) {
	      var key = parentKeys[i];
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        ownerBasedContext[key] === parentBasedContext[key],
	        'owner-based and parent-based contexts differ '  +
	        '(values: `%s` vs `%s`) for key (%s) while mounting %s ' +
	        '(see: http://fb.me/react-context-by-parent)',
	        ownerBasedContext[key],
	        parentBasedContext[key],
	        key,
	        displayName
	      ) : null);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(
	    transaction,
	    prevParentElement,
	    nextParentElement,
	    prevUnmaskedContext,
	    nextUnmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var nextContext = inst.context;
	    var nextProps = inst.props;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement !== nextParentElement) {
	      nextContext = this._processContext(nextParentElement._context);
	      nextProps = this._processProps(nextParentElement.props);
	
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        if (nextUnmaskedContext != null) {
	          this._warnIfContextsDiffer(
	            nextParentElement._context,
	            nextUnmaskedContext
	          );
	        }
	      }
	
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate =
	      this._pendingForceUpdate ||
	      !inst.shouldComponentUpdate ||
	      inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        typeof shouldUpdate !== 'undefined',
	        '%s.shouldComponentUpdate(): Returned undefined instead of a ' +
	        'boolean value. Make sure to return true or false.',
	        this.getName() || 'ReactCompositeComponent'
	      ) : null);
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(
	        nextParentElement,
	        nextProps,
	        nextState,
	        nextContext,
	        transaction,
	        nextUnmaskedContext
	      );
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(
	        nextState,
	        typeof partial === 'function' ?
	          partial.call(inst, nextState, props, context) :
	          partial
	      );
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function(
	    nextElement,
	    nextProps,
	    nextState,
	    nextContext,
	    transaction,
	    unmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var prevProps = inst.props;
	    var prevState = inst.state;
	    var prevContext = inst.context;
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (inst.componentDidUpdate) {
	      transaction.getReactMountReady().enqueue(
	        inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext),
	        inst
	      );
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var childContext = this._getValidatedChildContext();
	    var nextRenderedElement = this._renderValidatedComponent(childContext);
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(
	        prevComponentInstance,
	        nextRenderedElement,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(
	        nextRenderedElement,
	        this._currentElement.type
	      );
	      var nextMarkup = ReactReconciler.mountComponent(
	        this._renderedComponent,
	        thisID,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function(prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(
	      prevComponentID,
	      nextMarkup
	    );
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function() {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' &&
	          inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function(childContext) {
	    var renderedComponent;
	    var previousContext = ReactContext.current;
	    ReactContext.current = this._mergeChildContext(
	      this._currentElement._context,
	      childContext
	    );
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent =
	        this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactContext.current = previousContext;
	      ReactCurrentOwner.current = null;
	    }
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      // TODO: An `isValidNode` function would probably be more appropriate
	      renderedComponent === null || renderedComponent === false ||
	      ReactElement.isValidElement(renderedComponent),
	      '%s.render(): A valid ReactComponent must be returned. You may have ' +
	        'returned undefined, an array or some other invalid object.',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(// TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false ||
	    ReactElement.isValidElement(renderedComponent)));
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function(ref, component) {
	    var inst = this.getPublicInstance();
	    var refs = inst.refs === emptyObject ? (inst.refs = {}) : inst.refs;
	    refs[ref] = component.getPublicInstance();
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return (
	      type.displayName || (constructor && constructor.displayName) ||
	      type.name || (constructor && constructor.name) ||
	      null
	    );
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by React.render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function() {
	    return this._instance;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(
	  ReactCompositeComponentMixin,
	  'ReactCompositeComponent',
	  {
	    mountComponent: 'mountComponent',
	    updateComponent: 'updateComponent',
	    _renderValidatedComponent: '_renderValidatedComponent'
	  }
	);
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(661);
	var DOMChildrenOperations = __webpack_require__(1229);
	var DOMPropertyOperations = __webpack_require__(173);
	var ReactMount = __webpack_require__(75);
	var ReactPerf = __webpack_require__(103);
	
	var invariant = __webpack_require__(15);
	var setInnerHTML = __webpack_require__(394);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyById()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML:
	    '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes. This is made injectable via
	 * `ReactDOMComponent.BackendIDOperations`.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Updates a DOM node to remove a property. This should only be used to remove
	   * DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A property name to remove, see `DOMProperty`.
	   * @internal
	   */
	  deletePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	    DOMPropertyOperations.deleteValueForProperty(node, name, value);
	  },
	
	  /**
	   * Updates a DOM node with new style values. If a value is specified as '',
	   * the corresponding style property will be unset.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {object} styles Mapping from styles to values.
	   * @internal
	   */
	  updateStylesByID: function(id, styles) {
	    var node = ReactMount.getNode(id);
	    CSSPropertyOperations.setValueForStyles(node, styles);
	  },
	
	  /**
	   * Updates a DOM node's innerHTML.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} html An HTML string.
	   * @internal
	   */
	  updateInnerHTMLByID: function(id, html) {
	    var node = ReactMount.getNode(id);
	    setInnerHTML(node, html);
	  },
	
	  /**
	   * Updates a DOM node's text content set by `props.content`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} content Text content.
	   * @internal
	   */
	  updateTextContentByID: function(id, content) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.updateTextContent(node, content);
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function(id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function(updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  updatePropertyByID: 'updatePropertyByID',
	  deletePropertyByID: 'deletePropertyByID',
	  updateStylesByID: 'updateStylesByID',
	  updateInnerHTMLByID: 'updateInnerHTMLByID',
	  updateTextContentByID: 'updateTextContentByID',
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMPropertyOperations = __webpack_require__(173);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(379);
	var ReactDOMComponent = __webpack_require__(382);
	
	var assign = __webpack_require__(25);
	var escapeTextContentForBrowser = __webpack_require__(225);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function(props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function(text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    var escapedText = escapeTextContentForBrowser(this._stringText);
	
	    if (transaction.renderToStaticMarkup) {
	      // Normally we'd wrap this in a `span` for the reasons stated above, but
	      // since this is a situation where React won't take over (static pages),
	      // we can simply return the text as it is.
	      return escapedText;
	    }
	
	    return (
	      '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' +
	        escapedText +
	      '</span>'
	    );
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        ReactDOMComponent.BackendIDOperations.updateTextContentByID(
	          this._rootNodeID,
	          nextStringText
	        );
	      }
	    }
	  },
	
	  unmountComponent: function() {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	var ReactDefaultPerfAnalysis = __webpack_require__(1253);
	var ReactMount = __webpack_require__(75);
	var ReactPerf = __webpack_require__(103);
	
	var performanceNow = __webpack_require__(1303);
	
	function roundFloat(val) {
	  return Math.floor(val * 100) / 100;
	}
	
	function addValue(obj, key, val) {
	  obj[key] = (obj[key] || 0) + val;
	}
	
	var ReactDefaultPerf = {
	  _allMeasurements: [], // last item in the list is the current one
	  _mountStack: [0],
	  _injected: false,
	
	  start: function() {
	    if (!ReactDefaultPerf._injected) {
	      ReactPerf.injection.injectMeasure(ReactDefaultPerf.measure);
	    }
	
	    ReactDefaultPerf._allMeasurements.length = 0;
	    ReactPerf.enableMeasure = true;
	  },
	
	  stop: function() {
	    ReactPerf.enableMeasure = false;
	  },
	
	  getLastMeasurements: function() {
	    return ReactDefaultPerf._allMeasurements;
	  },
	
	  printExclusive: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getExclusiveSummary(measurements);
	    console.table(summary.map(function(item) {
	      return {
	        'Component class name': item.componentName,
	        'Total inclusive time (ms)': roundFloat(item.inclusive),
	        'Exclusive mount time (ms)': roundFloat(item.exclusive),
	        'Exclusive render time (ms)': roundFloat(item.render),
	        'Mount time per instance (ms)': roundFloat(item.exclusive / item.count),
	        'Render time per instance (ms)': roundFloat(item.render / item.count),
	        'Instances': item.count
	      };
	    }));
	    // TODO: ReactDefaultPerfAnalysis.getTotalTime() does not return the correct
	    // number.
	  },
	
	  printInclusive: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(measurements);
	    console.table(summary.map(function(item) {
	      return {
	        'Owner > component': item.componentName,
	        'Inclusive time (ms)': roundFloat(item.time),
	        'Instances': item.count
	      };
	    }));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },
	
	  getMeasurementsSummaryMap: function(measurements) {
	    var summary = ReactDefaultPerfAnalysis.getInclusiveSummary(
	      measurements,
	      true
	    );
	    return summary.map(function(item) {
	      return {
	        'Owner > component': item.componentName,
	        'Wasted time (ms)': item.time,
	        'Instances': item.count
	      };
	    });
	  },
	
	  printWasted: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    console.table(ReactDefaultPerf.getMeasurementsSummaryMap(measurements));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },
	
	  printDOM: function(measurements) {
	    measurements = measurements || ReactDefaultPerf._allMeasurements;
	    var summary = ReactDefaultPerfAnalysis.getDOMSummary(measurements);
	    console.table(summary.map(function(item) {
	      var result = {};
	      result[DOMProperty.ID_ATTRIBUTE_NAME] = item.id;
	      result['type'] = item.type;
	      result['args'] = JSON.stringify(item.args);
	      return result;
	    }));
	    console.log(
	      'Total time:',
	      ReactDefaultPerfAnalysis.getTotalTime(measurements).toFixed(2) + ' ms'
	    );
	  },
	
	  _recordWrite: function(id, fnName, totalTime, args) {
	    // TODO: totalTime isn't that useful since it doesn't count paints/reflows
	    var writes =
	      ReactDefaultPerf
	        ._allMeasurements[ReactDefaultPerf._allMeasurements.length - 1]
	        .writes;
	    writes[id] = writes[id] || [];
	    writes[id].push({
	      type: fnName,
	      time: totalTime,
	      args: args
	    });
	  },
	
	  measure: function(moduleName, fnName, func) {
	    return function() {for (var args=[],$__0=0,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	      var totalTime;
	      var rv;
	      var start;
	
	      if (fnName === '_renderNewRootComponent' ||
	          fnName === 'flushBatchedUpdates') {
	        // A "measurement" is a set of metrics recorded for each flush. We want
	        // to group the metrics for a given flush together so we can look at the
	        // components that rendered and the DOM operations that actually
	        // happened to determine the amount of "wasted work" performed.
	        ReactDefaultPerf._allMeasurements.push({
	          exclusive: {},
	          inclusive: {},
	          render: {},
	          counts: {},
	          writes: {},
	          displayNames: {},
	          totalTime: 0
	        });
	        start = performanceNow();
	        rv = func.apply(this, args);
	        ReactDefaultPerf._allMeasurements[
	          ReactDefaultPerf._allMeasurements.length - 1
	        ].totalTime = performanceNow() - start;
	        return rv;
	      } else if (fnName === '_mountImageIntoNode' ||
	          moduleName === 'ReactDOMIDOperations') {
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (fnName === '_mountImageIntoNode') {
	          var mountID = ReactMount.getID(args[1]);
	          ReactDefaultPerf._recordWrite(mountID, fnName, totalTime, args[0]);
	        } else if (fnName === 'dangerouslyProcessChildrenUpdates') {
	          // special format
	          args[0].forEach(function(update) {
	            var writeArgs = {};
	            if (update.fromIndex !== null) {
	              writeArgs.fromIndex = update.fromIndex;
	            }
	            if (update.toIndex !== null) {
	              writeArgs.toIndex = update.toIndex;
	            }
	            if (update.textContent !== null) {
	              writeArgs.textContent = update.textContent;
	            }
	            if (update.markupIndex !== null) {
	              writeArgs.markup = args[1][update.markupIndex];
	            }
	            ReactDefaultPerf._recordWrite(
	              update.parentID,
	              update.type,
	              totalTime,
	              writeArgs
	            );
	          });
	        } else {
	          // basic format
	          ReactDefaultPerf._recordWrite(
	            args[0],
	            fnName,
	            totalTime,
	            Array.prototype.slice.call(args, 1)
	          );
	        }
	        return rv;
	      } else if (moduleName === 'ReactCompositeComponent' && (
	        (// TODO: receiveComponent()?
	        (fnName === 'mountComponent' ||
	        fnName === 'updateComponent' || fnName === '_renderValidatedComponent')))) {
	
	        if (typeof this._currentElement.type === 'string') {
	          return func.apply(this, args);
	        }
	
	        var rootNodeID = fnName === 'mountComponent' ?
	          args[0] :
	          this._rootNodeID;
	        var isRender = fnName === '_renderValidatedComponent';
	        var isMount = fnName === 'mountComponent';
	
	        var mountStack = ReactDefaultPerf._mountStack;
	        var entry = ReactDefaultPerf._allMeasurements[
	          ReactDefaultPerf._allMeasurements.length - 1
	        ];
	
	        if (isRender) {
	          addValue(entry.counts, rootNodeID, 1);
	        } else if (isMount) {
	          mountStack.push(0);
	        }
	
	        start = performanceNow();
	        rv = func.apply(this, args);
	        totalTime = performanceNow() - start;
	
	        if (isRender) {
	          addValue(entry.render, rootNodeID, totalTime);
	        } else if (isMount) {
	          var subMountTime = mountStack.pop();
	          mountStack[mountStack.length - 1] += totalTime;
	          addValue(entry.exclusive, rootNodeID, totalTime - subMountTime);
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        } else {
	          addValue(entry.inclusive, rootNodeID, totalTime);
	        }
	
	        entry.displayNames[rootNodeID] = {
	          current: this.getName(),
	          owner: this._currentElement._owner ?
	            this._currentElement._owner.getName() :
	            '<root>'
	        };
	
	        return rv;
	      } else {
	        return func.apply(this, args);
	      }
	    };
	  }
	};
	
	module.exports = ReactDefaultPerf;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1249);
	
	var containsNode = __webpack_require__(676);
	var focusNode = __webpack_require__(678);
	var getActiveElement = __webpack_require__(679);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function(elem) {
	    return elem && (
	      ((elem.nodeName === 'INPUT' && elem.type === 'text') ||
	      elem.nodeName === 'TEXTAREA' || elem.contentEditable === 'true')
	    );
	  },
	
	  getSelectionInformation: function() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange:
	          ReactInputSelection.hasSelectionCapabilities(focusedElem) ?
	          ReactInputSelection.getSelection(focusedElem) :
	          null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem &&
	        isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(
	          priorFocusedElem,
	          priorSelectionRange
	        );
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function(input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || {start: 0, end: 0};
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1283);
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function(markup) {
	    var checksum = adler32(markup);
	    return markup.replace(
	      '>',
	      ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '">'
	    );
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function(markup, element) {
	    var existingChecksum = element.getAttribute(
	      ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	    );
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(177);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactFragment = __webpack_require__(149);
	var ReactPropTypeLocationNames = __webpack_require__(222);
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var elementTypeChecker = createElementTypeChecker();
	var nodeTypeChecker = createNodeChecker();
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: elementTypeChecker,
	  instanceOf: createInstanceTypeChecker,
	  node: nodeTypeChecker,
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error(
	          ("Required " + locationName + " `" + propName + "` was not specified in ") +
	          ("`" + componentName + "`.")
	        );
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + preciseType + "` ") +
	        ("supplied to `" + componentName + "`, expected `" + expectedType + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an array.")
	      );
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactElement.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected instance of `" + expectedClassName + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` of value `" + propValue + "` ") +
	      ("supplied to `" + componentName + "`, expected one of " + valuesString + ".")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an object.")
	      );
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  function validate(props, propName, componentName, location) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	      ("`" + componentName + "`.")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactNode.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `object`.")
	      );
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	      propValue = ReactFragment.extractIfFragment(propValue);
	      for (var k in propValue) {
	        if (!isNode(propValue[k])) {
	          return false;
	        }
	      }
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	module.exports = ReactPropTypes;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPutListenerQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	
	var assign = __webpack_require__(25);
	
	function ReactPutListenerQueue() {
	  this.listenersToPut = [];
	}
	
	assign(ReactPutListenerQueue.prototype, {
	  enqueuePutListener: function(rootNodeID, propKey, propValue) {
	    this.listenersToPut.push({
	      rootNodeID: rootNodeID,
	      propKey: propKey,
	      propValue: propValue
	    });
	  },
	
	  putListeners: function() {
	    for (var i = 0; i < this.listenersToPut.length; i++) {
	      var listenerToPut = this.listenersToPut[i];
	      ReactBrowserEventEmitter.putListener(
	        listenerToPut.rootNodeID,
	        listenerToPut.propKey,
	        listenerToPut.propValue
	      );
	    }
	  },
	
	  reset: function() {
	    this.listenersToPut.length = 0;
	  },
	
	  destructor: function() {
	    this.reset();
	  }
	});
	
	PooledClass.addPoolingTo(ReactPutListenerQueue);
	
	module.exports = ReactPutListenerQueue;


/***/ },
/* 674 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function(_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(126);
	var ReactTransitionChildMapping = __webpack_require__(1268);
	
	var assign = __webpack_require__(25);
	var cloneWithProps = __webpack_require__(175);
	var emptyFunction = __webpack_require__(80);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      )
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(
	        this._handleDoneEntering.bind(this, key)
	      );
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function(key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      var newChildren = assign({}, this.state.children);
	      delete newChildren[key];
	      this.setState({children: newChildren});
	    }
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(cloneWithProps(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.props,
	      childrenToRender
	    );
	  }
	});
	
	module.exports = ReactTransitionGroup;


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	var isTextNode = __webpack_require__(1298);
	
	/*jslint bitwise:true */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if (outerNode.contains) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(93);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactMount = __webpack_require__(75);
	
	var invariant = __webpack_require__(15);
	var isNode = __webpack_require__(683);
	var warning = __webpack_require__(32);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        owner._warnedAboutRefsInRender,
	        '%s is accessing getDOMNode or findDOMNode inside its render(). ' +
	        'render() should be a pure function of props and state. It should ' +
	        'never access something that requires stale data from the previous ' +
	        'render, such as refs. Move this logic to componentDidMount and ' +
	        'componentDidUpdate instead.',
	        owner.getName() || 'A component'
	      ) : null);
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (isNode(componentOrElement)) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    componentOrElement.render == null ||
	    typeof componentOrElement.render !== 'function',
	    'Component (with keys: %s) contains `render` method ' +
	    'but is not mounted in the DOM',
	    Object.keys(componentOrElement)
	  ) : invariant(componentOrElement.render == null ||
	  typeof componentOrElement.render !== 'function'));
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    false,
	    'Element appears to be neither ReactComponent nor DOMNode (keys: %s)',
	    Object.keys(componentOrElement)
	  ) : invariant(false));
	}
	
	module.exports = findDOMNode;


/***/ },
/* 678 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	"use strict";
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch(e) {
	  }
	}
	
	module.exports = focusNode;


/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document body is not yet defined.
	 */
	function getActiveElement() /*?DOMElement*/ {
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;


/***/ },
/* 680 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (
	    (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL])
	  );
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	var shouldWrap = {
	  // Force wrapping for SVG elements because if they get created inside a <div>,
	  // they will be initialized in the wrong namespace (and will not display).
	  'circle': true,
	  'clipPath': true,
	  'defs': true,
	  'ellipse': true,
	  'g': true,
	  'line': true,
	  'linearGradient': true,
	  'path': true,
	  'polygon': true,
	  'polyline': true,
	  'radialGradient': true,
	  'rect': true,
	  'stop': true,
	  'text': true
	};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg>', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap,
	
	  'circle': svgWrap,
	  'clipPath': svgWrap,
	  'defs': svgWrap,
	  'ellipse': svgWrap,
	  'g': svgWrap,
	  'line': svgWrap,
	  'linearGradient': svgWrap,
	  'path': svgWrap,
	  'polygon': svgWrap,
	  'polyline': svgWrap,
	  'radialGradient': svgWrap,
	  'rect': svgWrap,
	  'stop': svgWrap,
	  'text': svgWrap
	};
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(!!dummyNode, 'Markup wrapping node not initialized') : invariant(!!dummyNode));
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	
	module.exports = getMarkupWrap;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ?
	      'textContent' :
	      'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;


/***/ },
/* 683 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (
	    ((typeof Node === 'function' ? object instanceof Node : typeof object === 'object' &&
	    typeof object.nodeType === 'number' &&
	    typeof object.nodeName === 'string'))
	  ));
	}
	
	module.exports = isNode;


/***/ },
/* 684 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  return elem && (
	    (elem.nodeName === 'INPUT' && supportedInputTypes[elem.type] || elem.nodeName === 'TEXTAREA')
	  );
	}
	
	module.exports = isTextInputElement;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    ReactElement.isValidElement(children),
	    'onlyChild must be passed a children with exactly one child.'
	  ) : invariant(ReactElement.isValidElement(children)));
	  return children;
	}
	
	module.exports = onlyChild;


/***/ },
/* 686 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	'use strict';
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactFragment = __webpack_require__(149);
	var ReactInstanceHandles = __webpack_require__(128);
	
	var getIteratorFn = __webpack_require__(680);
	var invariant = __webpack_require__(15);
	var warning = __webpack_require__(32);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} key Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(
	    userProvidedKeyEscapeRegex,
	    userProvidedKeyEscaper
	  );
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!number} indexSoFar Number of children encountered until this point.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  indexSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null ||
	      type === 'string' ||
	      type === 'number' ||
	      ReactElement.isValidElement(children)) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar,
	      indexSoFar
	    );
	    return 1;
	  }
	
	  var child, nextName, nextIndex;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = (
	        (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	        getComponentKey(child, i)
	      );
	      nextIndex = indexSoFar + subtreeCount;
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        nextIndex,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            getComponentKey(child, ii++)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      } else {
	        if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	            didWarnAboutMaps,
	            'Using Maps as children is not yet fully supported. It is an ' +
	            'experimental feature that might be removed. Convert it to a ' +
	            'sequence / iterable of keyed ReactElements instead.'
	          ) : null);
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = (
	              (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	              wrapUserProvidedKey(entry[0]) + SUBSEPARATOR +
	              getComponentKey(child, 0)
	            );
	            nextIndex = indexSoFar + subtreeCount;
	            subtreeCount += traverseAllChildrenImpl(
	              child,
	              nextName,
	              nextIndex,
	              callback,
	              traverseContext
	            );
	          }
	        }
	      }
	    } else if (type === 'object') {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        children.nodeType !== 1,
	        'traverseAllChildren(...): Encountered an invalid child; DOM ' +
	        'elements are not valid children of React components.'
	      ) : invariant(children.nodeType !== 1));
	      var fragment = ReactFragment.extract(children);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          child = fragment[key];
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            wrapUserProvidedKey(key) + SUBSEPARATOR +
	            getComponentKey(child, 0)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      }
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', 0, callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionName = __webpack_require__(1311);
	var $TypeError = __webpack_require__(133);
	
	var $Object = Object;
	
	module.exports = setFunctionName(function flags() {
		if (this == null || this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.hasIndices) {
			result += 'd';
		}
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.unicodeSets) {
			result += 'v';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	}, 'get flags', true);
	


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(688);
	
	var supportsDescriptors = __webpack_require__(157).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	
	module.exports = function getPolyfill() {
		if (supportsDescriptors && (/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (
				descriptor
				&& typeof descriptor.get === 'function'
				&& typeof RegExp.prototype.dotAll === 'boolean'
				&& typeof RegExp.prototype.hasIndices === 'boolean'
			) {
				/* eslint getter-return: 0 */
				var calls = '';
				var o = {};
				Object.defineProperty(o, 'hasIndices', {
					get: function () {
						calls += 'd';
					}
				});
				Object.defineProperty(o, 'sticky', {
					get: function () {
						calls += 'y';
					}
				});
				if (calls === 'dy') {
					return descriptor.get;
				}
			}
		}
		return implementation;
	};


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(240);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(240, function() {
			var newContent = __webpack_require__(240);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(267);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(267, function() {
			var newContent = __webpack_require__(267);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(277);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(277, function() {
			var newContent = __webpack_require__(277);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(301);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(301, function() {
			var newContent = __webpack_require__(301);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(306);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(306, function() {
			var newContent = __webpack_require__(306);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * accounting.js v0.4.1
	 * Copyright 2014 Open Exchange Rates
	 *
	 * Freely distributable under the MIT license.
	 * Portions of accounting.js are inspired or borrowed from underscore.js
	 *
	 * Full details and documentation:
	 * http://openexchangerates.github.io/accounting.js/
	 */
	
	(function(root, undefined) {
	
		/* --- Setup --- */
	
		// Create the local library object, to be exported or referenced globally later
		var lib = {};
	
		// Current version
		lib.version = '0.4.1';
	
	
		/* --- Exposed settings --- */
	
		// The library's settings configuration object. Contains default parameters for
		// currency and number formatting
		lib.settings = {
			currency: {
				symbol : "$",		// default currency symbol is '$'
				format : "%s%v",	// controls output: %s = symbol, %v = value (can be object, see docs)
				decimal : ".",		// decimal point separator
				thousand : ",",		// thousands separator
				precision : 2,		// decimal places
				grouping : 3		// digit grouping (not implemented yet)
			},
			number: {
				precision : 0,		// default precision on numbers is 0
				grouping : 3,		// digit grouping (not implemented yet)
				thousand : ",",
				decimal : "."
			}
		};
	
	
		/* --- Internal Helper Methods --- */
	
		// Store reference to possibly-available ECMAScript 5 methods for later
		var nativeMap = Array.prototype.map,
			nativeIsArray = Array.isArray,
			toString = Object.prototype.toString;
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js
		 */
		function isString(obj) {
			return !!(obj === '' || (obj && obj.charCodeAt && obj.substr));
		}
	
		/**
		 * Tests whether supplied parameter is a string
		 * from underscore.js, delegates to ECMA5's native Array.isArray
		 */
		function isArray(obj) {
			return nativeIsArray ? nativeIsArray(obj) : toString.call(obj) === '[object Array]';
		}
	
		/**
		 * Tests whether supplied parameter is a true object
		 */
		function isObject(obj) {
			return obj && toString.call(obj) === '[object Object]';
		}
	
		/**
		 * Extends an object with a defaults object, similar to underscore's _.defaults
		 *
		 * Used for abstracting parameter handling from API methods
		 */
		function defaults(object, defs) {
			var key;
			object = object || {};
			defs = defs || {};
			// Iterate over object non-prototype properties:
			for (key in defs) {
				if (defs.hasOwnProperty(key)) {
					// Replace values with defaults only if undefined (allow empty/zero values):
					if (object[key] == null) object[key] = defs[key];
				}
			}
			return object;
		}
	
		/**
		 * Implementation of `Array.map()` for iteration loops
		 *
		 * Returns a new Array as a result of calling `iterator` on each array value.
		 * Defers to native Array.map if available
		 */
		function map(obj, iterator, context) {
			var results = [], i, j;
	
			if (!obj) return results;
	
			// Use native .map method if it exists:
			if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
	
			// Fallback for native .map:
			for (i = 0, j = obj.length; i < j; i++ ) {
				results[i] = iterator.call(context, obj[i], i, obj);
			}
			return results;
		}
	
		/**
		 * Check and normalise the value of precision (must be positive integer)
		 */
		function checkPrecision(val, base) {
			val = Math.round(Math.abs(val));
			return isNaN(val)? base : val;
		}
	
	
		/**
		 * Parses a format string or object and returns format obj for use in rendering
		 *
		 * `format` is either a string with the default (positive) format, or object
		 * containing `pos` (required), `neg` and `zero` values (or a function returning
		 * either a string or object)
		 *
		 * Either string or format.pos must contain "%v" (value) to be valid
		 */
		function checkCurrencyFormat(format) {
			var defaults = lib.settings.currency.format;
	
			// Allow function as format parameter (should return string or object):
			if ( typeof format === "function" ) format = format();
	
			// Format can be a string, in which case `value` ("%v") must be present:
			if ( isString( format ) && format.match("%v") ) {
	
				// Create and return positive, negative and zero formats:
				return {
					pos : format,
					neg : format.replace("-", "").replace("%v", "-%v"),
					zero : format
				};
	
			// If no format, or object is missing valid positive value, use defaults:
			} else if ( !format || !format.pos || !format.pos.match("%v") ) {
	
				// If defaults is a string, casts it to an object for faster checking next time:
				return ( !isString( defaults ) ) ? defaults : lib.settings.currency.format = {
					pos : defaults,
					neg : defaults.replace("%v", "-%v"),
					zero : defaults
				};
	
			}
			// Otherwise, assume format was fine:
			return format;
		}
	
	
		/* --- API Methods --- */
	
		/**
		 * Takes a string/array of strings, removes all formatting/cruft and returns the raw float value
		 * Alias: `accounting.parse(string)`
		 *
		 * Decimal must be included in the regular expression to match floats (defaults to
		 * accounting.settings.number.decimal), so if the number uses a non-standard decimal 
		 * separator, provide it as the second argument.
		 *
		 * Also matches bracketed negatives (eg. "$ (1.99)" => -1.99)
		 *
		 * Doesn't throw any errors (`NaN`s become 0) but this may change in future
		 */
		var unformat = lib.unformat = lib.parse = function(value, decimal) {
			// Recursively unformat arrays:
			if (isArray(value)) {
				return map(value, function(val) {
					return unformat(val, decimal);
				});
			}
	
			// Fails silently (need decent errors):
			value = value || 0;
	
			// Return the value as-is if it's already a number:
			if (typeof value === "number") return value;
	
			// Default decimal point comes from settings, but could be set to eg. "," in opts:
			decimal = decimal || lib.settings.number.decimal;
	
			 // Build regex to strip out everything except digits, decimal point and minus sign:
			var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]),
				unformatted = parseFloat(
					("" + value)
					.replace(/\((.*)\)/, "-$1") // replace bracketed values with negatives
					.replace(regex, '')         // strip out any cruft
					.replace(decimal, '.')      // make sure decimal point is standard
				);
	
			// This will fail silently which may cause trouble, let's wait and see:
			return !isNaN(unformatted) ? unformatted : 0;
		};
	
	
		/**
		 * Implementation of toFixed() that treats floats more like decimals
		 *
		 * Fixes binary rounding issues (eg. (0.615).toFixed(2) === "0.61") that present
		 * problems for accounting- and finance-related software.
		 */
		var toFixed = lib.toFixed = function(value, precision) {
			precision = checkPrecision(precision, lib.settings.number.precision);
			var power = Math.pow(10, precision);
	
			// Multiply up by precision, round accurately, then divide and use native toFixed():
			return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
		};
	
	
		/**
		 * Format a number, with comma-separated thousands and custom precision/decimal places
		 * Alias: `accounting.format()`
		 *
		 * Localise by overriding the precision and thousand / decimal separators
		 * 2nd parameter `precision` can be an object matching `settings.number`
		 */
		var formatNumber = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val) {
					return formatNumber(val, precision, thousand, decimal);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(precision) ? precision : {
						precision : precision,
						thousand : thousand,
						decimal : decimal
					}),
					lib.settings.number
				),
	
				// Clean up precision
				usePrecision = checkPrecision(opts.precision),
	
				// Do some calc:
				negative = number < 0 ? "-" : "",
				base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "",
				mod = base.length > 3 ? base.length % 3 : 0;
	
			// Format the number:
			return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split('.')[1] : "");
		};
	
	
		/**
		 * Format a number into currency
		 *
		 * Usage: accounting.formatMoney(number, symbol, precision, thousandsSep, decimalSep, format)
		 * defaults: (0, "$", 2, ",", ".", "%s%v")
		 *
		 * Localise by overriding the symbol, precision, thousand / decimal separators and format
		 * Second param can be an object matching `settings.currency` which is the easiest way.
		 *
		 * To do: tidy up the parameters
		 */
		var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
			// Resursively format arrays:
			if (isArray(number)) {
				return map(number, function(val){
					return formatMoney(val, symbol, precision, thousand, decimal, format);
				});
			}
	
			// Clean up number:
			number = unformat(number);
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero):
				formats = checkCurrencyFormat(opts.format),
	
				// Choose which format to use for this value:
				useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
	
			// Return with currency symbol added:
			return useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
		};
	
	
		/**
		 * Format a list of numbers into an accounting column, padding with whitespace
		 * to line up currency symbols, thousand separators and decimals places
		 *
		 * List should be an array of numbers
		 * Second parameter can be an object containing keys that match the params
		 *
		 * Returns array of accouting-formatted number strings of same length
		 *
		 * NB: `white-space:pre` CSS rule is required on the list container to prevent
		 * browsers from collapsing the whitespace in the output strings.
		 */
		lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
			if (!list) return [];
	
			// Build options object from second param (if object) or all params, extending defaults:
			var opts = defaults(
					(isObject(symbol) ? symbol : {
						symbol : symbol,
						precision : precision,
						thousand : thousand,
						decimal : decimal,
						format : format
					}),
					lib.settings.currency
				),
	
				// Check format (returns object with pos, neg and zero), only need pos for now:
				formats = checkCurrencyFormat(opts.format),
	
				// Whether to pad at start of string or after currency symbol:
				padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false,
	
				// Store value for the length of the longest string in the column:
				maxLength = 0,
	
				// Format the list according to options, store the length of the longest string:
				formatted = map(list, function(val, i) {
					if (isArray(val)) {
						// Recursively format columns if list is a multi-dimensional array:
						return lib.formatColumn(val, opts);
					} else {
						// Clean up the value
						val = unformat(val);
	
						// Choose which format to use for this value (pos, neg or zero):
						var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero,
	
							// Format this value, push into formatted list and save the length:
							fVal = useFormat.replace('%s', opts.symbol).replace('%v', formatNumber(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
	
						if (fVal.length > maxLength) maxLength = fVal.length;
						return fVal;
					}
				});
	
			// Pad each number in the list and send back the column of numbers:
			return map(formatted, function(val, i) {
				// Only if this is a string (not a nested array, which would have already been padded):
				if (isString(val) && val.length < maxLength) {
					// Depending on symbol position, pad after symbol or at index 0:
					return padAfterSymbol ? val.replace(opts.symbol, opts.symbol+(new Array(maxLength - val.length + 1).join(" "))) : (new Array(maxLength - val.length + 1).join(" ")) + val;
				}
				return val;
			});
		};
	
	
		/* --- Module Definition --- */
	
		// Export accounting for CommonJS. If being loaded as an AMD module, define it as such.
		// Otherwise, just add `accounting` to the global object
		if (true) {
			if (typeof module !== 'undefined' && module.exports) {
				exports = module.exports = lib;
			}
			exports.accounting = lib;
		} else if (typeof define === 'function' && define.amd) {
			// Return the library as an AMD module:
			define([], function() {
				return lib;
			});
		} else {
			// Use accounting.noConflict to restore `accounting` back to its original value.
			// Returns a reference to the library's `accounting` object;
			// e.g. `var numbers = accounting.noConflict();`
			lib.noConflict = (function(oldAccounting) {
				return function() {
					// Reset the value of the root's `accounting` variable:
					root.accounting = oldAccounting;
					// Delete the noConflict method:
					lib.noConflict = undefined;
					// Return reference to the library to re-assign it:
					return lib;
				};
			})(root.accounting);
	
			// Declare `fx` on the root (global/window) object:
			root['accounting'] = lib;
		}
	
		// Root will be `window` in browser or `global` on the server:
	}(this));


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Dispatcher = __webpack_require__(42),
	    Constants = __webpack_require__(2),
	    ActionType = Constants.ActionTypes,
	    ChronologycActionCreators = {
	
	    openDayNotes: function openDayNotes() {
	        Dispatcher.dispatch({
	            type: ActionType.OPEN_DAY_NOTES
	        });
	    },
	
	    closeDayNotes: function closeDayNotes() {
	        Dispatcher.dispatch({
	            type: ActionType.CLOSE_DAY_NOTES
	        });
	    },
	
	    noteAdded: function noteAdded() {
	        Dispatcher.dispatch({
	            type: ActionType.NOTE_ADDED
	        });
	    },
	
	    noteRemoved: function noteRemoved() {
	        Dispatcher.dispatch({
	            type: ActionType.NOTE_REMOVED
	        });
	    },
	
	    noteChanged: function noteChanged() {
	        Dispatcher.dispatch({
	            type: ActionType.NOTE_CHANGED
	        });
	    }
	
	};
	
	module.exports = ChronologycActionCreators;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1314);
	var Router = __webpack_require__(19);
	
	var _require = __webpack_require__(19),
	    Navigation = _require.Navigation;
	
	var React = __webpack_require__(1);
	
	var _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes;
	
	var Link = Router.Link;
	
	
	var BoxSelector = React.createClass({ displayName: "BoxSelector",
	
	    mixins: [Navigation],
	
	    propTypes: {
	        title: PropTypes.string,
	        imageSrc: PropTypes.string,
	        style: PropTypes.object,
	        link: PropTypes.string
	    },
	
	    render: function render() {
	        var _props = this.props,
	            title = _props.title,
	            imageSrc = _props.imageSrc,
	            style = _props.style,
	            link = _props.link;
	
	        return React.createElement("a", { style: { textDecoration: 'none' }, href: link || '' }, React.createElement("article", { className: "box-selector", style: style }, React.createElement("h1", { className: "box-selector__header" }, title), React.createElement("p", { className: "box-selector__body" }, React.createElement("img", { className: "box-selector__body-image", src: imageSrc }))));
	    }
	});
	
	module.exports = BoxSelector;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1315);
	
	var React = __webpack_require__(1),
	    Router = __webpack_require__(19),
	    Navigation = Router.Navigation,
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var Chip = React.createClass({ displayName: "Chip",
	
	    mixins: [Navigation],
	
	    propTypes: {
	        icon: PropTypes.string,
	        text: PropTypes.string,
	        link: PropTypes.string,
	        onClickLink: PropTypes.func,
	        bgColorIcon: PropTypes.string,
	        colorIcon: PropTypes.string,
	        className: PropTypes.string
	    },
	
	    _onClickLink: function _onClickLink() {
	        var _props = this.props,
	            onClickLink = _props.onClickLink,
	            link = _props.link;
	
	
	        if (link) {
	            var param = link.substring(link.indexOf(':') + 1, link.length);
	            this.transitionTo(link, { selectLocationItemId: param });
	            if (onClickLink) {
	                onClickLink();
	            }
	        }
	    },
	    render: function render() {
	        var _props2 = this.props,
	            icon = _props2.icon,
	            text = _props2.text,
	            bgColorIcon = _props2.bgColorIcon,
	            colorIcon = _props2.colorIcon,
	            className = _props2.className;
	
	        var classNameEl = 'bp-chip';
	
	        if (className) {
	            classNameEl += ' ' + className;
	        }
	
	        var iconEl = icon ? React.createElement("span", { className: "bp-chip__icon" }, React.createElement("i", {
	            dangerouslySetInnerHTML: { __html: icon },
	            className: "material-icons",
	            style: { color: colorIcon || 'black', backgroundColor: bgColorIcon } })) : null;
	
	        return React.createElement("div", { onClick: this._onClickLink, className: classNameEl }, React.createElement("span", { className: "bp-chip__text" }, text), React.createElement("span", { className: "txt-default pull-left" }, iconEl));
	    }
	});
	
	module.exports = Chip;

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var forEach = __webpack_require__(350);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    ContextMenuEl = __webpack_require__(152),
	    DateUtils = __webpack_require__(22),
	    OrderStore = __webpack_require__(72),
	    SessionStore = __webpack_require__(11),
	    ContentUtils = __webpack_require__(7),
	    BrowserUtils = __webpack_require__(185),
	    OrderUtils = __webpack_require__(49),
	    ChronologycAction = __webpack_require__(696),
	    NotificationEl = __webpack_require__(21),
	    moment = __webpack_require__(3),
	    mui = __webpack_require__(12),
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    TextField = mui.TextField,
	    IconButton = mui.IconButton,
	    ChronologycStore = __webpack_require__(76),
	    NoteSchedule = __webpack_require__(736),
	    ChronologycServiceCache = __webpack_require__(107),
	    UIStateStore = __webpack_require__(183),
	    Note,
	    Chronologyc,
	    ga = __webpack_require__(18),
	    WIDTH_COMMENT_DASHBOARD = __webpack_require__(2).WIDTH_COMMENT_DASHBOARD,
	    WIDTH_COMMENT_BUTTON_DASHBOARD = __webpack_require__(2).WIDTH_COMMENT_BUTTON_DASHBOARD,
	    ROW_HIGHT = __webpack_require__(2).ROW_HIGHT,
	    categories = __webpack_require__(2).Analytics.categories,
	    labels = __webpack_require__(2).Analytics.labels,
	    actions = __webpack_require__(2).Analytics.actions;
	
	
	var AMOUNT_CHARACTER_TO_SHOW_TOOLTIP = 25;
	
	var rowsSelectedState = {
	    isPressedClick: false,
	    startDatePressed: '',
	    endDatePressed: ''
	};
	
	Note = React.createClass({ displayName: "Note",
	
	    propTypes: {
	        day: PropTypes.string,
	        to: PropTypes.object,
	        from: PropTypes.object,
	        typeBar: PropTypes.string,
	        isFirstNote: PropTypes.bool,
	        isDisabled: PropTypes.bool
	    },
	
	    /**
	     * Save the current message for this day of brewing notes.
	     * @private
	     */
	    _onBlurBrewingNote: function _onBlurBrewingNote() {
	        ChronologycStore.setIsWritingFalse();
	        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'false');
	        var oldValue = this.refs.menssage.getDOMNode().getAttribute('data-value') || this.props.day.message || '';
	        var newValue = this.refs.menssage.getValue(),
	            note = void 0,
	            noteRecover = void 0;
	
	        note = {
	            date: this.props.day.date,
	            message: this.refs.menssage.getValue()
	        };
	
	        this._showHideOrUpdateTooltipNote(newValue, 'brewing-bar');
	
	        if (newValue && !oldValue) {
	            // is new note operation
	            note = ChronologycServiceCache.addBrewingNote(note); // assign temporaryId
	            ChronologycStore.setIsNoteSavingTrue();
	            NoteSchedule.addBrewingNote(note);
	
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NEW,
	                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else if (!newValue && oldValue) {
	            // is remove note operation
	            noteRecover = ChronologycServiceCache.getBrewingNoteByDate(note.date);
	            ChronologycStore.setIsNoteSavingTrue();
	            ChronologycServiceCache.removeBrewingNote(noteRecover);
	            NoteSchedule.removeBrewingNote(note);
	            ga.event({
	                category: categories.NOTES,
	                action: actions.DELETE,
	                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else if (newValue) {
	            // is change note operation
	            ChronologycStore.setIsNoteSavingTrue();
	            ChronologycServiceCache.addBrewingNote(note);
	            NoteSchedule.changeBrewingNote(note);
	            ga.event({
	                category: categories.NOTES,
	                action: actions.CHANGE,
	                label: labels.NOTES_BREWING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        }
	
	        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);
	    },
	    _onFocusMessage: function _onFocusMessage() {
	        ChronologycStore.setIsWritingTrue();
	        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'true');
	    },
	    _showHideOrUpdateTooltipNote: function _showHideOrUpdateTooltipNote(date, typeBar) {
	        var newValue = typeBar === 'packaging-bar' ? ChronologycServiceCache.getPackagingNoteByDate(date) : ChronologycServiceCache.getBrewingNoteByDate(date);
	        var tooltipValue = newValue && newValue.message && newValue.message.length > AMOUNT_CHARACTER_TO_SHOW_TOOLTIP ? newValue.message : undefined;
	        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);
	        var el = this.refs.menssage.getDOMNode();
	
	        if (el._tippy) {
	            //     // first you need to check if exist an instance
	            var instance = el._tippy;
	            if (tooltipValue) {
	                //         // enter here means we are updating the tooltip text
	                instance.setProps({ 'content': tooltipValue });
	            } else {
	                //         // enter here means you remove it text or it's smaller than before
	                //         // so we need to destroy the tooltip instance.
	                instance.destroy();
	            }
	        } else if (tooltipValue) {
	            //     // enter here means there is not already instance created for
	            //     // this element, so should only add a tooltip if text length is enough
	            el.setAttribute('data-tippy-content', tooltipValue || '');
	            tippy(el);
	        }
	    },
	
	
	    /**
	     * Save the current message for this day of packaging notes.
	     * @private
	     */
	    _onBlurPackagingNote: function _onBlurPackagingNote() {
	        ChronologycStore.setIsWritingFalse();
	        this.refs.menssage.getDOMNode().setAttribute('data-is-writing', 'false');
	        var oldValue = this.refs.menssage.getDOMNode().getAttribute('data-value') || this.props.day.message || '';
	        var newValue = this.refs.menssage.getValue(),
	            note = void 0,
	            noteRecover = void 0;
	
	        this.refs.menssage.getDOMNode().setAttribute('data-value', newValue);
	
	        this._showHideOrUpdateTooltipNote(newValue, 'packaging-bar');
	
	        note = {
	            date: this.props.day.date,
	            message: this.refs.menssage.getValue()
	        };
	
	        if (newValue && !oldValue) {
	            // is new note operation
	            note = ChronologycServiceCache.addPackagingNote(note); // assign temporaryId
	            ChronologycStore.setIsNoteSavingTrue();
	            NoteSchedule.addPackagingNote(note);
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NEW,
	                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else if (!newValue && oldValue) {
	            // is remove note operation
	            noteRecover = ChronologycServiceCache.getPackagingNoteByDate(note.date);
	            ChronologycStore.setIsNoteSavingTrue();
	            ChronologycServiceCache.removePackagingNote(noteRecover);
	            NoteSchedule.removePackagingNote(note);
	            ga.event({
	                category: categories.NOTES,
	                action: actions.DELETE,
	                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else if (newValue) {
	            // is change note operation
	            ChronologycServiceCache.addPackagingNote(note);
	            ChronologycStore.setIsNoteSavingTrue();
	            NoteSchedule.changePackagingNote(note);
	            ga.event({
	                category: categories.NOTES,
	                action: actions.CHANGE,
	                label: labels.NOTES_PACKAGING + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this._updateDate(nextProps.day);
	    },
	    componentDidMount: function componentDidMount() {
	        this._updateDate(this.props.day);
	        var text = this.refs.menssage.getValue();
	
	        var el = this.refs.menssage.getDOMNode();
	        tippy(el);
	
	        // Initialize tooltip of large notes
	        // if (text && text.length > AMOUNT_CHARACTER_TO_SHOW_TOOLTIP) {
	        //     const el = this.refs.menssage.getDOMNode();
	        //     el.setAttribute('data-tippy-content', this.refs.menssage.getValue() || '');
	        //     tippy(el);
	        // }
	    },
	
	
	    /**
	     * Update text of the note.
	     * @param messageDay
	     * @private
	     */
	    _updateDate: function _updateDate(messageDay) {
	        var messageObject, textMessage;
	
	        if (!this.refs.menssage) {
	            return;
	        }
	
	        if (this.refs.menssage.getDOMNode().getAttribute('data-is-writing') === 'true') {
	            // enter here means that the note are changing by the consumer
	            return;
	        }
	
	        if (messageDay.message && this.refs.menssage.getValue() !== messageDay.message.message) {
	            messageObject = messageDay.message;
	            textMessage = messageObject.message ? messageObject.message : '';
	            this.refs.menssage.setValue(textMessage);
	        } else if (!messageDay.message && this.refs.menssage.getValue()) {
	            // If enter here means that we remove a message, ant just need to clean textfield value.
	            this.refs.menssage.setValue('');
	        }
	    },
	    render: function render() {
	        var _this = this;
	
	        var style,
	            comentaryDayContent = SessionStore.isAdminUser() || SessionStore.isAbleToChangeNotes() ? 'comentary-day-content' : 'comentary-day-content is-disabled';
	        if (this.props.typeBar === 'packaging-bar') {
	            style = {
	                display: UIStateStore.isPackagingNotesBarOpen() ? 'block' : 'none',
	                position: 'relative',
	                top: '35px'
	            };
	        } else {
	            style = {
	                display: UIStateStore.isBrewingNotesBarOpen() ? 'block' : 'none',
	                position: 'relative',
	                top: '35px'
	            };
	        }
	
	        if (this.props.isFirstNote) {
	            comentaryDayContent += ' is-first-note';
	            comentaryDayContent += ' ' + this.props.typeBar;
	        }
	        return React.createElement("div", { "data-date": this.props.day.date }, React.createElement("div", { style: style, className: comentaryDayContent, "data-date": this.props.day.date }, React.createElement(TextField, {
	            ref: "menssage",
	            className: "comment-day",
	            fullWidth: true,
	            style: { height: ROW_HIGHT + 'px' },
	            underlineDisabledStyle: { color: 'black', borderBottom: 'solid 1px #e0e0e0;;', zIndex: '1' },
	            disabled: this.props.isDisabled,
	            onMouseMove: function onMouseMove(evt) {
	                _this._showHideOrUpdateTooltipNote(evt.target.getAttribute('data-date'), _this.props.typeBar);
	            },
	            onBlur: this.props.typeBar === 'packaging-bar' ? this._onBlurPackagingNote : this._onBlurBrewingNote,
	            onFocus: this._onFocusMessage,
	            "data-old-value": "",
	            "data-is-writing": "false",
	            "data-date": this.props.day.date })));
	    }
	});
	
	Chronologyc = React.createClass({ displayName: "Chronologyc",
	
	    propTypes: {
	        day: PropTypes.object,
	        typeBar: PropTypes.string,
	        showForwardOrders: PropTypes.func,
	        showBackwardOrders: PropTypes.func,
	        shouldUpdate: PropTypes.bool
	    },
	
	    componentWillMount: function componentWillMount() {
	        UIStateStore.addChangeListener(this._onChange);
	        ChronologycStore.addChangeListener(this._onChange);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        UIStateStore.removeChangeListener(this._onChange);
	        ChronologycStore.removeChangeListener(this._onChange);
	    },
	
	
	    startingWatcherScroll: null,
	    endingWatcherScroll: null,
	    startingTimeout: null,
	    endingTimeout: null,
	
	    _onChange: function _onChange() {
	        this.forceUpdate();
	    },
	    _onClick: function _onClick(evt, _ref) {
	        var date = _ref.date;
	
	        var barEl = ContentUtils.getComponentByElement(evt.target, 'DIV');
	        if (barEl.classList.contains('is-highlight') && this.props.onDoubleClick) {
	            barEl.classList.remove('is-selected');
	            this.props.onDoubleClick(date);
	        }
	        cleanClassNames(evt);
	        barEl.classList.toggle('is-highlight');
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	        if (ChronologycStore.isSavingNote()) {
	            return false;
	        }
	
	        return nextProps.shouldUpdate;
	    },
	    render: function render() {
	        var elements = [],
	            currentDaysBar = ChronologycStore.getRangeOfDate(this.props.from, this.props.to, this.props.typeBar),
	            styleInlineChronologycBar = {},
	            styleInlineButtonMessageDay = {},
	            iconButton = React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "note_add"),
	            chronologicBarStyle = 'chronologyc-bar-button',
	            isPackagingBar = this.props.typeBar === 'packaging-bar';
	
	        chronologicBarStyle += SessionStore.isPaidVersion() ? '' : ' is-free-version';
	
	        if (isPackagingBar) {
	            styleInlineChronologycBar = { width: UIStateStore.isPackagingNotesBarOpen() ? WIDTH_COMMENT_DASHBOARD + '%' : 'inherit' };
	            styleInlineButtonMessageDay = {
	                position: 'fixed',
	                zIndex: 2,
	                height: ROW_HIGHT + 'px',
	                marginButton: ROW_HIGHT + 'px',
	                width: WIDTH_COMMENT_BUTTON_DASHBOARD + 'px !important'
	            };
	        } else {
	            styleInlineChronologycBar = { width: UIStateStore.isBrewingNotesBarOpen() ? WIDTH_COMMENT_DASHBOARD + '%' : 'inherit' };
	            styleInlineButtonMessageDay = {
	                position: 'fixed',
	                zIndex: 2,
	                height: ROW_HIGHT + 'px',
	                marginButton: ROW_HIGHT + 'px',
	                width: WIDTH_COMMENT_BUTTON_DASHBOARD + 'px !important'
	            };
	        }
	        if (currentDaysBar) {
	            // Open notes button
	            if (UIStateStore.isBrewingNotesBarOpen() && this.props.typeBar !== 'packaging-bar') {
	                iconButton = React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "keyboard_arrow_left");
	                chronologicBarStyle += ' is-open';
	                elements.push(getChronologycBarEl(_dispatchOpenBrewNote, true, t('dashboard_brewing_notes'), 'note_add'));
	            }
	
	            if (UIStateStore.isPackagingNotesBarOpen() && isPackagingBar) {
	                iconButton = React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "keyboard_arrow_right");
	                chronologicBarStyle += ' is-open';
	                elements.push(getChronologycBarEl(_dispatchOpenPackagingNote, false, t('dashboard_packaging_notes'), 'note_add'));
	            }
	
	            if (isPackagingBar) {
	                chronologicBarStyle += ' is-packaging-bar';
	            } else {
	                chronologicBarStyle += ' is-brewing-bar';
	            }
	
	            elements.push(React.createElement(IconButton, {
	                tooltipPosition: isPackagingBar ? 'bottom-left' : 'bottom-right',
	                onClick: isPackagingBar ? _dispatchOpenPackagingNote : _dispatchOpenBrewNote,
	                onTouchTap: BrowserUtils.isIpad() ? isPackagingBar ? _dispatchOpenPackagingNote : _dispatchOpenBrewNote : function () {},
	                className: chronologicBarStyle,
	                style: styleInlineButtonMessageDay,
	                labelStyle: {
	                    color: 'black'
	                },
	                tooltip: isPackagingBar ? t('dashboard_packaging_notes') : t('dashboard_brewing_notes') }, iconButton));
	
	            var styleRow = '',
	                chronologycBar = this.props.typeBar + ' chronologyc-bar';
	
	            if (isPackagingBar) {
	                if (!UIStateStore.isPackagingNotesBarOpen()) {
	                    chronologycBar += ' is-close';
	                }
	            } else {
	                if (!UIStateStore.isBrewingNotesBarOpen()) {
	                    chronologycBar += ' is-close';
	                }
	            }
	
	            if (!SessionStore.isPaidVersion()) {
	                chronologycBar += ' is-free-version';
	            }
	
	            currentDaysBar.forEach(function (day, index) {
	                styleRow = 'chronologyc-row row';
	                var isFirstNote = false;
	                if (DateUtils.isSaturday(day.date)) {
	                    styleRow += ' is-saturday';
	                }
	
	                if (DateUtils.isSunday(day.date)) {
	                    styleRow += ' is-sunday';
	                }
	
	                if (+moment(DateUtils.toDate(day.date)).format('DD') === 1) {
	                    styleRow += ' is-month-starting';
	                }
	
	                if (day.date === this.props.from && !isPackagingBar) {
	                    styleRow += ' is-starting-range';
	                }
	
	                if (day.date === DateUtils.addDaysTextBasicFormat(this.props.to, -1) && !isPackagingBar) {
	                    styleRow += ' is-ending-range';
	                }
	
	                if (+moment(DateUtils.toDate(day.date)).format('MM') % 2 === 0) {
	                    styleRow += ' is-month-light';
	                } else {
	                    styleRow += ' is-month-dark';
	                }
	
	                if (DateUtils.isToDay(day.date)) {
	                    styleRow += ' is-highlight ';
	                }
	
	                if (!isPackagingBar && DateUtils.isToDay(day.date)) {
	                    styleRow += ' is-to-day';
	                }
	
	                if (DateUtils.isMondayTuesdayOrWednesday(day.date)) {
	                    styleRow += ' is-dark-row';
	                } else {
	                    styleRow += ' is-white-row';
	                }
	
	                if (index === 0) {
	                    styleRow += ' is-first-note';
	                    isFirstNote = true;
	                }
	
	                elements.push(_createRowChronologycBar(this.props.typeBar, styleRow, day, this._onClick, isFirstNote));
	            }.bind(this));
	        }
	
	        return React.createElement("div", { style: styleInlineChronologycBar, className: chronologycBar }, React.createElement("div", {
	            className: "chronologyc-bar-inner-content",
	            onContextMenu: function onContextMenu(evt) {
	                if (evt.nativeEvent.button === 2) {
	                    evt.preventDefault();
	
	                    var orders = OrderStore.getOrders();
	                    var filteredOrders = OrderUtils.getOrderByRange(rowsSelectedState.startDatePressed, rowsSelectedState.endDatePressed, orders);
	
	                    var candidateProductToConfirm = OrderUtils.getCandidateProductToConfirm(filteredOrders, rowsSelectedState.startDatePressed, rowsSelectedState.endDatePressed);
	
	                    ContextMenuEl.show(evt.clientX, evt.clientY, rowsSelectedState.startDatePressed + ' / ' + rowsSelectedState.endDatePressed, t('dashboard_modal_general_from_date') + ' / ' + t('dashboard_modal_general_to_date'), [{
	                        icon: 'done_all',
	                        text: t('dashboard_menu_items_confirm_all_products'),
	                        onClick: function onClick() {
	                            if (candidateProductToConfirm.length) {
	                                for (var _iterator = filteredOrders, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                                    var _ref2;
	
	                                    if (_isArray) {
	                                        if (_i >= _iterator.length) break;
	                                        _ref2 = _iterator[_i++];
	                                    } else {
	                                        _i = _iterator.next();
	                                        if (_i.done) break;
	                                        _ref2 = _i.value;
	                                    }
	
	                                    var order = _ref2;
	
	                                    var wasConfirmedSomeProduct = OrderUtils.confirmAllProductsByOrder(order, rowsSelectedState.startDatePressed, rowsSelectedState.endDatePressed);
	                                    if (wasConfirmedSomeProduct) {
	                                        OrderStore.changeOrderLight(order);
	                                    }
	                                }
	                            } else {
	                                NotificationEl.show(t('dashboard_menu_items_notification_no_confirmed_product', 'info'));
	                            }
	                        }
	                    }]);
	                }
	            },
	            onMouseDown: function onMouseDown(evt) {
	                if (evt.nativeEvent.button !== 2) {
	                    cleanClassNamesSelected();
	                    var rowEl = getRowParent(evt);
	                    if (!rowEl) return;
	                    rowEl.childNodes[1].classList.toggle('is-selected');
	                    rowsSelectedState.isPressedClick = true;
	                    rowsSelectedState.startDatePressed = rowEl.getAttribute('data-date');
	                    rowsSelectedState.endDatePressed = rowEl.getAttribute('data-date');
	                }
	            },
	            onMouseMove: function onMouseMove(evt) {
	                if (rowsSelectedState.isPressedClick && evt.nativeEvent.button !== 2) {
	                    var rowEl = getRowParent(evt);
	                    if (!rowEl) return;
	
	                    if (!rowEl.childNodes[1].classList.contains('is-selected')) {
	                        rowEl.childNodes[1].classList.add('is-selected');
	                    }
	
	                    // THS IS NEEDED IF THE USER LEAVES THE CRONOLOGYC BAR TO CHECK IF NEED TO MARK MORE ROWS DOWN
	                    if (DateUtils.isAfter(rowEl.getAttribute('data-date'), rowsSelectedState.endDatePressed)) {
	                        var sum = 1;
	                        var next = DateUtils.addDays(rowsSelectedState.endDatePressed, sum);
	                        var query = '[data-date="' + DateUtils.toDateText(next) + '"]';
	                        var oldRowEl = document.querySelector(query);
	                        while (DateUtils.isAfter(rowEl.getAttribute('data-date'), DateUtils.toDateText(next))) {
	                            if (!oldRowEl.childNodes[1].classList.contains('is-selected')) {
	                                oldRowEl.childNodes[1].classList.add('is-selected');
	                            }
	                            sum++;
	                            next = DateUtils.addDays(rowsSelectedState.endDatePressed, sum);
	                            query = '[data-date="' + DateUtils.toDateText(next) + '"]';
	                            oldRowEl = document.querySelector(query);
	                        }
	                    }
	
	                    // THS IS NEEDED IF THE USER LEAVES THE CRONOLOGYC BAR TO CHECK IF NEED TO MARK MORE ROWS UP
	                    if (DateUtils.isBefore(rowEl.getAttribute('data-date'), rowsSelectedState.startDatePressed)) {
	                        var _sum = -1;
	                        var _next = DateUtils.addDays(rowsSelectedState.startDatePressed, _sum);
	                        var _query = '[data-date="' + DateUtils.toDateText(_next) + '"]';
	                        var nextRowEl = document.querySelector(_query);
	                        while (DateUtils.isBefore(rowEl.getAttribute('data-date'), DateUtils.toDateText(_next))) {
	                            if (!nextRowEl.childNodes[1].classList.contains('is-selected')) {
	                                nextRowEl.childNodes[1].classList.add('is-selected');
	                            }
	                            _sum--;
	                            _next = DateUtils.addDays(rowsSelectedState.startDatePressed, _sum);
	                            _query = '[data-date="' + DateUtils.toDateText(_next) + '"]';
	                            nextRowEl = document.querySelector(_query);
	                        }
	                    }
	
	                    // CHECK IF SELECTED WILL REPLACE START OR END DATE
	                    if (DateUtils.isBefore(rowEl.getAttribute('data-date'), rowsSelectedState.startDatePressed)) {
	                        rowsSelectedState.startDatePressed = rowEl.getAttribute('data-date');
	                    } else if (DateUtils.isAfter(rowEl.getAttribute('data-date'), rowsSelectedState.endDatePressed)) {
	                        rowsSelectedState.endDatePressed = rowEl.getAttribute('data-date');
	                    }
	                }
	            },
	            onMouseUp: function onMouseUp(evt) {
	                if (evt.nativeEvent.button !== 2) {
	                    rowsSelectedState.isPressedClick = false;
	                }
	            }
	        }, elements));
	    }
	});
	
	/**
	 * Create each of day row with the Chronology left side bar.
	 * @param styleRow
	 * @param day
	 * @param onClick
	 * @returns {XML}
	 * @private
	 */
	function _createRowChronologycBar(typeBar, styleRow, day, _onClick2, isFirstNote) {
	
	    var className = 'chronologyc-row-data-date';
	
	    if (!UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen() && isFirstNote) {
	        // enter here means that only are open packaging side notes
	        className += ' is-packaging-bar-only-open';
	    }
	
	    var isDisabled = SessionStore.isAdminUser() ? false : SessionStore.isAbleToChangeNotes() ? false : true;
	
	    return React.createElement("div", { className: className, "data-date": day.date }, React.createElement(Note, { isDisabled: isDisabled, typeBar: typeBar, day: day, isFirstNote: isFirstNote }), React.createElement("div", {
	        "data-month-name": DateUtils.toDisplayMonthText(day.date),
	        "data-date": day.date,
	        onClick: function onClick(evt) {
	            return _onClick2(evt, day);
	        },
	        className: 'chronologyc-row row ' + styleRow
	    }, React.createElement("span", {
	        className: "dateName pull-left",
	        ref: day.time + '_TWO',
	        "data-month-name": DateUtils.toDisplayMonthTextShort(day.date),
	        key: day.time + '_TWO' }, day.dateName), React.createElement("span", {
	        className: "dateNumber pull-right",
	        ref: day.time,
	        "data-month-name": DateUtils.toDisplayMonthTextShort(day.date).toUpperCase(),
	        key: day.time }, day.dateNumber)));
	}
	
	/**
	 * Toggle the action of open and close Left SideBar of messages.
	 * @private
	 */
	function _dispatchOpenBrewNote() {
	    NotificationEl.showImmediately(t('notification_wait_notes_loading'), 'info', 5);
	    delay(function () {
	        if (UIStateStore.isBrewingNotesBarOpen()) {
	            UIStateStore.closeBrowingNotesBar();
	            ChronologycAction.closeDayNotes();
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NAVIGATE,
	                label: labels.NOTES_BREWING_CLOSE + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else {
	            UIStateStore.openBrowingNotesBar();
	            ChronologycAction.openDayNotes();
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NAVIGATE,
	                label: labels.NOTES_BREWING_OPEN + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        }
	    }, 500);
	}
	
	function getChronologycBarEl(onClick, isBrewing, title, icon) {
	    var chronologycButtonHeaderStyle = 'chronologyc-button-header text-center';
	    chronologycButtonHeaderStyle += isBrewing ? ' is-brewing' : ' is-packaging';
	    chronologycButtonHeaderStyle += SessionStore.isPaidVersion() ? '' : ' is-free-version';
	    return React.createElement("div", { onClick: onClick,
	        onTouchTap: BrowserUtils.isIpad() ? onClick : function () {},
	        className: chronologycButtonHeaderStyle }, React.createElement("span", { className: "chronologyc-button-header-icon" }, React.createElement("i", {
	        className: "material-icons md-48" }, icon)), React.createElement("span", { className: "chronologyc-button-header-title" }, title));
	}
	
	/**
	 * Toggle the action of open and close right SideBar of messages.
	 * @private
	 */
	function _dispatchOpenPackagingNote() {
	    NotificationEl.showImmediately(t('notification_wait_notes_loading'), 'info', 5);
	    delay(function () {
	        if (UIStateStore.isPackagingNotesBarOpen()) {
	            UIStateStore.closePackagingNotesBar();
	            ChronologycAction.closeDayNotes();
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NAVIGATE,
	                label: labels.NOTES_PACKAGING_CLOSE + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        } else {
	            UIStateStore.openPackagingNotesBar();
	            ChronologycAction.openDayNotes();
	            ga.event({
	                category: categories.NOTES,
	                action: actions.NAVIGATE,
	                label: labels.NOTES_PACKAGING_OPEN + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        }
	    }, 500);
	}
	
	/**
	 * Clean the last highlight of chronologyc bar.
	 * @argument {Event} evt that will take from the target element.
	 */
	function cleanClassNames(evt) {
	    if (evt && evt.target) {
	        var barEl = ContentUtils.getComponentByClassName(evt.target, 'chronologyc-bar');
	        Array.from(barEl.querySelectorAll('.is-highlight')).forEach(function (rowEl) {
	            rowEl.classList.remove('is-highlight');
	        });
	    } else {
	        Array.from(document.querySelectorAll('.is-highlight')).forEach(function (rowEl) {
	            rowEl.classList.remove('is-highlight');
	        });
	    }
	}
	
	function cleanClassNamesSelected(evt) {
	    if (evt && evt.target) {
	        var barEl = ContentUtils.getComponentByClassName(evt.target, 'is-selected');
	        Array.from(barEl.querySelectorAll('.is-selected')).forEach(function (rowEl) {
	            rowEl.classList.remove('is-selected');
	        });
	    } else {
	        Array.from(document.querySelectorAll('.is-selected')).forEach(function (rowEl) {
	            rowEl.classList.remove('is-selected');
	        });
	    }
	}
	
	function getRowParent(evt) {
	    var el = evt.target;
	
	    while (el && !el.classList.contains('chronologyc-row-data-date')) {
	        el = el.parentElement;
	    }
	    return el;
	}
	
	module.exports = Chronologyc;

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(5),
	    merge = _require2.merge,
	    ContentUtils = __webpack_require__(7),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    _require4 = __webpack_require__(37),
	    debounce = _require4.debounce,
	    Notification = __webpack_require__(21),
	    Breadcrumb = __webpack_require__(399),
	    BasicForm = __webpack_require__(397),
	    FormGroupButton = __webpack_require__(30);
	
	
	var BasicFormNew = React.createClass({ displayName: "BasicFormNew",
	
	  mixins: [BasicForm],
	
	  propTypes: _extends({}, BasicForm.propTypes, {
	    additionalPreSubmitValidation: PropTypes.func,
	    additionalWriterValue: PropTypes.object,
	    contextHolder: PropTypes.object,
	    children: PropTypes.array.isRequired,
	    onAdd: PropTypes.func.isRequired,
	    onAddText: PropTypes.func,
	    urlBack: PropTypes.string,
	    isAddHidden: PropTypes.boolean,
	    breadcrumb: PropTypes.array,
	    isValid: PropTypes.bool,
	    isSaving: PropTypes.bool,
	    addEnterKeyDown: PropTypes.func
	  }),
	
	  componentDidMount: function componentDidMount() {
	    var _props = this.props,
	        addEnterKeyDown = _props.addEnterKeyDown,
	        shouldFocusDidMount = _props.shouldFocusDidMount;
	
	    // register to child
	
	    if (addEnterKeyDown) {
	      addEnterKeyDown(this._onAdd.bind(this));
	    }
	
	    if (shouldFocusDidMount) {
	      var self = this;
	      var elementFocusables = self.getDOMNode().querySelectorAll('.basic-form-fields div[tabindex="0"], .basic-form-fields input');
	      if (elementFocusables && ContentUtils.isNotEmptyArray(elementFocusables)) {
	        elementFocusables[0].focus(); // focus on first focusable element
	      }
	    }
	  },
	  _onAdd: function _onAdd() {
	    var _props2 = this.props,
	        contextHolder = _props2.contextHolder,
	        onAdd = _props2.onAdd,
	        additionalSubmitValue = _props2.additionalSubmitValue,
	        additionalPreSubmitValidation = _props2.additionalPreSubmitValidation;
	
	    if (this.isLoading) {
	      Notification.show(t('dashboard_notification_please_wait_finish_process'));
	    } else {
	      if (contextHolder.isValid()) {
	        this.isLoading = true;
	        var item = contextHolder.getItem();
	        if (additionalPreSubmitValidation && !additionalPreSubmitValidation(item)) {
	          return;
	        }
	        if (additionalSubmitValue) {
	          item = merge(item, additionalSubmitValue);
	        }
	        try {
	          onAdd(item, this._onAddSuccess, this._onAddFailure);
	        } catch (err) {
	          console.error(err);
	        } finally {
	          this.isLoading = false;
	        }
	      }
	    }
	  },
	  _onAddSuccess: function _onAddSuccess(ajax) {
	    var _props3 = this.props,
	        contextHolder = _props3.contextHolder,
	        fetchItems = _props3.fetchItems;
	
	
	    if (ajax.status >= 200 && ajax.status < 300) {
	      Notification.show(this.props.messages.addSuccessMessage, 'success');
	      fetchItems();
	    } else {
	      Notification.show(this.props.messages.addFailureMessage);
	    }
	    contextHolder.clean();
	  },
	  _onAddFailure: function _onAddFailure() {},
	  render: function render() {
	    var _props4 = this.props,
	        title = _props4.title,
	        children = _props4.children,
	        additionalButtons = _props4.additionalButtons,
	        isAddHidden = _props4.isAddHidden,
	        breadcrumb = _props4.breadcrumb,
	        isValid = _props4.isValid,
	        onAddText = _props4.onAddText,
	        isSaving = _props4.isSaving;
	
	    var addText = onAddText ? onAddText : t('tank_buttom_label_create');
	
	    var buttonNewEl = isAddHidden ? null : React.createElement("div", { className: "basic-form-content pull-left" }, React.createElement(FormGroupButton, {
	      icon: "save",
	      className: "primary-icon",
	      type: "icon",
	      label: addText,
	      onClick: debounce(this._onAdd, 500),
	      disable: isSaving }));
	    var additionalButtonsEl = additionalButtons ? map(additionalButtons, function (button) {
	      return React.createElement("span", { className: "basic-form-content additional-button pull-left" }, button);
	    }) : null;
	
	    var className = 'basic-form-container container-fluid';
	
	    if (!isValid) {
	      className += ' is-invalid';
	    }
	    return React.createElement("div", { className: className }, breadcrumb ? React.createElement("div", { className: "basic-form-breadcrumb" }, React.createElement(Breadcrumb, { items: breadcrumb })) : null, React.createElement("div", { className: "basic-form-header col-xs-12" }, React.createElement("h1", null, title)), React.createElement("div", { className: "basic-form-fields" }, children), React.createElement("div", { className: "basic-form-buttons" }, additionalButtonsEl, buttonNewEl));
	  }
	});
	
	module.exports = BasicFormNew;

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1312);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    PropTypes = React.PropTypes,
	    get = __webpack_require__(5).get,
	    set = __webpack_require__(5).set,
	    ContentUtils = __webpack_require__(7),
	    BasicFormGroup = __webpack_require__(94),
	    $ = __webpack_require__(188),
	    DEFAULT_EMPTY_COLOR = '#000000';
	
	
	var FormGroupColorPicker = React.createClass({ displayName: "FormGroupColorPicker",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        placeHolder: PropTypes.string,
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        messageError: PropTypes.string,
	        isDark: PropTypes.bool
	    }),
	
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	        $('#colorPickerSelected').spectrum({
	            preferredFormat: 'hex',
	            showPalette: true,
	            chooseText: t('form_group_label_confirm_color'),
	            cancelText: 'Cancel',
	            palette: [['#000', '#444', '#666', '#999', '#ccc', '#eee', '#f3f3f3', '#fff'], ['#f00', '#f90', '#ff0', '#0f0', '#0ff', '#00f', '#90f', '#f0f'], ['#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3', '#d9d2e9', '#ead1dc'], ['#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#9fc5e8', '#b4a7d6', '#d5a6bd'], ['#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6fa8dc', '#8e7cc3', '#c27ba0'], ['#c00', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3d85c6', '#674ea7', '#a64d79'], ['#900', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#0b5394', '#351c75', '#741b47'], ['#600', '#783f04', '#7f6000', '#274e13', '#0c343d', '#073763', '#20124d', '#4c1130']]
	        });
	    },
	    clean: function clean() {
	        this.refs.colorSelected.getDOMNode().value = DEFAULT_EMPTY_COLOR;
	    },
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            readerAttribute = _props.readerAttribute;
	
	        var value = $('#colorPickerSelected').spectrum('get').toHexString();
	        var safeWritterAttribute = writerAttribute || readerAttribute;
	
	        var wrapper = set({}, safeWritterAttribute, value || DEFAULT_EMPTY_COLOR);
	        return wrapper;
	    },
	    isValid: function isValid() {
	        var _props2 = this.props,
	            messageError = _props2.messageError,
	            readerAttribute = _props2.readerAttribute;
	
	        var inputValue = get(this.getValue(), readerAttribute);
	        var messageErrorResult = ContentUtils.isNullOrEmpty(inputValue) ? messageError : '';
	
	        this.setState({ messageError: messageErrorResult });
	        return messageErrorResult === '';
	    },
	
	
	    /**
	     * The action when change the color of beer style.
	     * @param evt
	     * @param index
	     * @param menuItem
	     * @private
	     */
	    _onChangeColor: function _onChangeColor(evt) {
	        var onChange = this.props.onChange;
	
	
	        this.setState({
	            colorSelected: evt.target.value
	        });
	
	        if (onChange) {
	            onChange();
	        }
	    },
	    _resolveValue: function _resolveValue(value, readerAttribute) {
	        var inputColor = get(value, readerAttribute);
	
	        if (ContentUtils.isNullOrEmpty(inputColor)) {
	            return DEFAULT_EMPTY_COLOR;
	        }
	
	        return inputColor;
	    },
	    render: function render() {
	        var _props3 = this.props,
	            isDisabled = _props3.isDisabled,
	            isDark = _props3.isDark,
	            value = _props3.value,
	            readerAttribute = _props3.readerAttribute;
	
	        var colorPickerClassName = 'form-group form-group-color-picker';
	        if (isDark) {
	            colorPickerClassName += ' is-dark';
	        }
	        return React.createElement("div", { className: colorPickerClassName }, React.createElement("input", {
	            id: "colorPickerSelected",
	            ref: "colorSelected",
	            type: "color",
	            onChange: this._onChangeColor,
	            disabled: isDisabled === undefined ? false : isDisabled,
	            defaultValue: this._resolveValue(value, readerAttribute),
	            errorText: get(this.state, 'messageError', '') }), React.createElement("label", { className: "form-group-color-picker-label", for: "colorPickerSelected" }, t('form_group_label_chance_color')));
	    }
	});
	
	module.exports = FormGroupColorPicker;

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1317);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    ContentUtils = __webpack_require__(7),
	    SessionStore = __webpack_require__(11),
	    DateUtils = __webpack_require__(22),
	    DEFAULT_WRITTER_ATTRIBUTE = 'date',
	    BasicFormGroup = __webpack_require__(94),
	    _require = __webpack_require__(12),
	    DatePicker = _require.DatePicker;
	
	
	var FormGroupDatePicket = React.createClass({ displayName: "FormGroupDatePicket",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        onEnter: PropTypes.func,
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        hintText: PropTypes.string,
	        formatDate: PropTypes.func,
	        errorText: PropTypes.string,
	        floatingLabel: PropTypes.string,
	        value: PropTypes.object
	    }),
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedDate: ''
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	
	
	    _el: null,
	
	    clean: function clean() {
	        this.setState({
	            selectedDate: ''
	        });
	    },
	    isDateObj: function isDateObj(selectedDate) {
	        return (typeof selectedDate === 'undefined' ? 'undefined' : _typeof(selectedDate)) === 'object';
	    },
	    onChange: function onChange(evt, date) {
	        var _this = this;
	
	        var selectedDate = this.isDateObj(date) ? DateUtils.toDateText(date) : date;
	        this.setState({
	            selectedDate: selectedDate
	        }, function () {
	            if (_this.props.onChange) {
	                _this.props.onChange();
	            }
	        });
	    },
	    _getDate: function _getDate() {
	        var _props = this.props,
	            formatDate = _props.formatDate,
	            value = _props.value;
	        var selectedDate = this.state.selectedDate;
	        // internal value (should be the latest) over default value
	
	        var date = selectedDate || value;
	        return ContentUtils.isFunction(formatDate) ? formatDate(date) : date;
	    },
	    getValue: function getValue() {
	        var _ref;
	
	        var writterAttribute = this.props.writerAttribute || DEFAULT_WRITTER_ATTRIBUTE;
	        return _ref = {}, _ref[writterAttribute] = this._getDate(), _ref;
	    },
	    isValid: function isValid(onFinishValidation) {
	        var messageError = '';
	
	        if (onFinishValidation) {
	            onFinishValidation();
	        }
	
	        return messageError === '';
	    },
	    _onEnter: function _onEnter() {
	        if (this.props.onEnter) {
	            this.props.onEnter();
	        }
	    },
	    _onBlur: function _onBlur() {
	        if (this.props.onBlur) {
	            this.isValid(this.props.onBlur);
	        }
	    },
	    render: function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            floatingLabel = _props2.floatingLabel,
	            hintText = _props2.hintText,
	            formatDate = _props2.formatDate,
	            errorText = _props2.errorText,
	            disabled = _props2.disabled;
	
	
	        return React.createElement("div", { className: "form-group form-group-date-picker" }, React.createElement(DatePicker, {
	            floatingLabelText: floatingLabel,
	            ref: function ref(input) {
	                return _this2._el = input;
	            },
	            hintText: hintText,
	            formatDate: ContentUtils.isNull(formatDate) ? DateUtils.toDisplayDateText : formatDate,
	            onChange: this.onChange,
	            errorText: errorText,
	            value: this._getDate(),
	            disabled: disabled ? true : !SessionStore.isAdminUser(),
	            onBlur: this.onBlur }));
	    }
	});
	
	module.exports = FormGroupDatePicket;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1318);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    DropDown = __webpack_require__(105),
	    ContentUtils = __webpack_require__(7),
	    _require = __webpack_require__(48),
	    findIndex = _require.findIndex,
	    Constants = __webpack_require__(2),
	    set = __webpack_require__(5).set,
	    get = __webpack_require__(5).get,
	    BasicFormGroup = __webpack_require__(94);
	
	
	var DEFAULT_READER_ATTRIBUTE = 'text';
	
	var FormGroupDropdownCustom = React.createClass({ displayName: "FormGroupDropdownCustom",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        onChange: PropTypes.func,
	        onBlur: PropTypes.func,
	        outputMapper: PropTypes.object,
	        isImmutable: PropTypes.bool,
	        isEditMode: PropTypes.bool,
	        onEnter: PropTypes.func,
	        name: PropTypes.string,
	        floatingLabelText: PropTypes.string,
	        wrapperMenuItem: PropTypes.func,
	        idAttribute: PropTypes.any,
	
	        // Input fields ------------------------
	
	        /**
	         * The list of items which will be used to generate the MenuItem
	         */
	        items: PropTypes.array.isRequired,
	
	        /**
	         * This attribute are several proposes. For instance:
	         * As a `displayName` of given Menu item list ({@link items}).
	         * Also is used this attribute to read each menu item of Dropdown attribute, when
	         * need to know which menu item are selected.
	         */
	        readerAttribute: PropTypes.string,
	
	        /**
	         * This attribute will be use against to {@link value} props to retrieve the
	         * information needed from outside selected value. Will be use to match outer
	         * value which internal menu item.
	         */
	        readerAttributeValue: PropTypes.string,
	
	        // Output field ------------------------
	
	        /**
	         * This is attribute will use to write the name of the attribute when submit the form.
	         * (Optionally) When it doesn't defined we will use by default {@link readerAttribute}
	         */
	        writerAttribute: PropTypes.string,
	
	        /**
	         * This attribute allow us to specify the field will take at the moment
	         * to write the value of selected item.
	         */
	        customReaderWriterAttribute: PropTypes.string,
	
	        /**
	         * Is the value which are selected from outside of menu item. So we need to use
	         * {@link readerAttributeValue} in order to know which MenuItem
	         * are related to this outer `value`, specially when need to know which index of menu item
	         * are need to be selected.
	         */
	        value: PropTypes.string
	    }),
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedMenuItemIndex: -1,
	            selectedMenuItem: null
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {
	        this.setState({
	            selectedMenuItemIndex: -1,
	            selectedMenuItem: null,
	            isFocus: false
	        });
	    },
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            outputMapper = _props.outputMapper,
	            readerAttribute = _props.readerAttribute,
	            customReaderWriterAttribute = _props.customReaderWriterAttribute,
	            value = _props.value,
	            idAttribute = _props.idAttribute,
	            items = _props.items;
	
	
	        var isEditMode = ContentUtils.isNotNullOrUndefined(value);
	
	        var selectedMenuItemIndex = this.state.selectedMenuItemIndex;
	        if (isEditMode && selectedMenuItemIndex === -1) {
	            selectedMenuItemIndex = getIndexValue(items, value, idAttribute || 'id');
	        }
	
	        var currentValue = this._getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute, selectedMenuItemIndex);
	
	        var wrapper = {};
	        var safeWriterAttribute = writerAttribute || readerAttribute; // make writer attribute optionally
	
	        if (outputMapper) {
	            var keyOutput = outputMapper[currentValue];
	            wrapper = set(wrapper, safeWriterAttribute, keyOutput);
	        } else {
	            wrapper = set(wrapper, safeWriterAttribute, currentValue);
	        }
	
	        return wrapper;
	    },
	    _onBlur: function _onBlur(callback, selectedItem) {
	        if (this.refs && this.refs.dropdownEl) {
	            var haveItemSelected = !!selectedItem;
	            var haveItemsDefined = ContentUtils.isNotEmptyArray(this.props.items);
	
	            if (haveItemSelected && haveItemsDefined) {
	                var itemSelectedIndex = get(selectedItem, 'payload');
	
	                this.setState({
	                    selectedItem: selectedItem,
	                    selectedMenuItemIndex: itemSelectedIndex,
	                    isFocus: false
	                }, function () {
	                    if (callback) {
	                        callback();
	                    }
	                });
	            }
	        } else {
	            if (callback) {
	                callback();
	            }
	        }
	    },
	    _getIndexOfMenuItem: function _getIndexOfMenuItem(textTarget) {
	        var isMenuItemObject = _typeof(this.props.items[0]) === 'object';
	        var isMenuItemNumber = typeof this.props.items[0] === 'number';
	        var menuItemTexts = void 0;
	
	        if (isMenuItemObject) {
	            menuItemTexts = this.props.items.map(function (item) {
	                return get(item, 'name', get(item, 'description'));
	            });
	        } else if (isMenuItemNumber) {
	            menuItemTexts = this.props.items;
	            return menuItemTexts.indexOf(+textTarget) + 1;
	        } else {
	            menuItemTexts = this.props.items;
	        }
	
	        if (menuItemTexts) {
	            return menuItemTexts.indexOf(textTarget) + 1;
	        }
	    },
	    isValid: function isValid() {
	        var _props2 = this.props,
	            name = _props2.name,
	            additionalValidation = _props2.additionalValidation,
	            additionalValidationFieldName = _props2.additionalValidationFieldName,
	            isRequired = _props2.isRequired,
	            isRelaxedText = _props2.isRelaxedText,
	            readerAttribute = _props2.readerAttribute,
	            onBlur = _props2.onBlur,
	            items = _props2.items,
	            value = _props2.value,
	            idAttribute = _props2.idAttribute;
	
	        var messageError = '';
	        var selectedMenuItemValue = void 0;
	
	        if (ContentUtils.isNull(isRequired)) {
	            isRequired = true;
	        }
	
	        if (!isRequired) {
	            this.setState({ messageError: '' });
	            return messageError === '';
	        }
	
	        var isEditMode = ContentUtils.isNotNullOrUndefined(value);
	        var isNewMode = isEditMode === false;
	        var isNonItemselected = this.state.selectedMenuItemIndex === -1;
	
	        var selectedMenuItemIndex = this.state.selectedMenuItemIndex;
	        if (isEditMode && selectedMenuItemIndex === -1) {
	            selectedMenuItemIndex = getIndexValue(items, value, idAttribute);
	        }
	
	        if (selectedMenuItemIndex > -1) {
	            selectedMenuItemValue = this._getSelectedMenuItemValue(readerAttribute, readerAttribute, selectedMenuItemIndex);
	            messageError = this._checkSelectedMenuItemValue(isRelaxedText, selectedMenuItemValue);
	        } else if (isEditMode) {
	            messageError = ContentUtils.isValidText(null, name);
	        }
	
	        if (additionalValidationFieldName) {
	            var itemSelected = get(items, '' + (this.state.selectedMenuItemIndex - 1));
	            var attributeValue = get(itemSelected, additionalValidationFieldName);
	            if (!messageError && additionalValidation) {
	                messageError = additionalValidation(attributeValue);
	            }
	        } else {
	            if (!messageError && additionalValidation) {
	                messageError = additionalValidation(selectedMenuItemValue);
	            }
	        }
	
	        if (isNewMode && isNonItemselected) {
	            messageError = name + ' ' + t('notification_is_required');
	        }
	
	        this.setState({ messageError: messageError }, function () {
	            if (onBlur) {
	                onBlur();
	            }
	        });
	        return messageError === '';
	    },
	    _getSelectedMenuItemValue: function _getSelectedMenuItemValue(readerAttribute, customReaderWriterAttribute, selectedMenuItemIndex) {
	        var index = selectedMenuItemIndex - 1;
	
	        if (index < 0) {
	            index = this.state.selectedMenuItemIndex - 1;
	        }
	        var itemValue = this.props.items[index];
	        var itemModel = void 0;
	
	        if (ContentUtils.isStringOrIntegerItem(itemValue)) {
	            itemModel = get(this.state, 'selectedMenuItem.itemModel');
	        } else {
	            var attribute = customReaderWriterAttribute || readerAttribute || 'text';
	            itemModel = get(itemValue, attribute);
	        }
	
	        if (ContentUtils.isStringOrIntegerItem(itemModel)) {
	            // enter here means that current MenuItem is just simple text or number
	            // which means that item model are the value it self
	            return itemModel;
	        } else {
	            return get(itemModel, customReaderWriterAttribute || readerAttribute || 'text');
	        }
	    },
	    _onChange: function _onChange(selectedMenuItem, evt) {
	        var onChange = this.props.onChange;
	
	        this.setState({
	            selectedMenuItem: selectedMenuItem,
	            selectedMenuItemIndex: selectedMenuItem.payload
	        });
	
	        if (onChange) {
	            onChange(evt, get(selectedMenuItem, 'index'), selectedMenuItem);
	        }
	    },
	    _checkSelectedMenuItemValue: function _checkSelectedMenuItemValue(isRelaxedText, selectedMenuItemValue) {
	        return isRelaxedText ? ContentUtils.isValidTextNotRequiredWithCustomValidation(selectedMenuItemValue, name, Constants.REGEX_NAME_RELAXED) : ContentUtils.isValidText(selectedMenuItemValue, name);
	    },
	    _setFocus: function _setFocus() {
	        this.setState({
	            isFocus: true
	        });
	    },
	    render: function render() {
	        var _props3 = this.props,
	            floatingLabelText = _props3.floatingLabelText,
	            isDisabled = _props3.isDisabled,
	            items = _props3.items,
	            isImmutable = _props3.isImmutable,
	            isEditMode = _props3.isEditMode,
	            onEnter = _props3.onEnter,
	            name = _props3.name,
	            readerAttribute = _props3.readerAttribute,
	            value = _props3.value,
	            wrapperMenuItem = _props3.wrapperMenuItem,
	            idAttribute = _props3.idAttribute;
	        var _state = this.state,
	            isFocus = _state.isFocus,
	            selectedMenuItemIndex = _state.selectedMenuItemIndex;
	
	
	        var dropdownClassName = 'form-group form-group-dropdown-custom';
	
	        if (isFocus) {
	            dropdownClassName += ' is-active';
	        }
	
	        var isDisabledInput = !!isDisabled || isImmutable && isEditMode;
	
	        dropdownClassName += isDisabledInput ? ' is-disabled' : '';
	
	        var currentSelectedIndex = selectedMenuItemIndex > -1 ? selectedMenuItemIndex : getIndexValue(items, value, idAttribute || 'id');
	
	        return React.createElement("div", { className: dropdownClassName }, React.createElement(DropDown, {
	            className: 'form-group-dropdown-input',
	            ref: "dropdownEl",
	            readerAttribute: readerAttribute || DEFAULT_READER_ATTRIBUTE,
	
	            wrapperMenuItem: wrapperMenuItem,
	            floatingLabelText: floatingLabelText,
	            labelStyle: { color: '#fff', fontWeight: '300' },
	            onChange: this._onChange,
	            onEnterKeyDown: onEnter,
	            name: name,
	            onBlur: this._onBlur.bind(this, this.isValid),
	            onFocus: this._setFocus,
	            floatingLabelStyle: {
	                color: '#fff !important',
	                fontWeight: '300'
	            },
	            items: items,
	            selectedIndex: currentSelectedIndex,
	            style: { width: '100%' },
	            errorText: get(this.state, 'messageError', ''),
	            disabled: isDisabledInput }));
	    }
	});
	
	function getIndexValue(items, value, idAttribute) {
	    return findIndex(items, function (item) {
	        return get(item, idAttribute) === get(value, idAttribute);
	    }) + 1; // transform to payload index
	}
	
	module.exports = FormGroupDropdownCustom;

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1319);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    BasicFormGroup = __webpack_require__(94),
	    _ = __webpack_require__(40),
	    Uploader = __webpack_require__(231);
	
	var FormGroupImageChooser = React.createClass({ displayName: "FormGroupImageChooser",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        placeHolder: PropTypes.string,
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        messageError: PropTypes.string,
	        isRequired: PropTypes.bool,
	        isDisabled: PropTypes.bool
	    }),
	
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {
	        this.refs.inputImage.setValue('');
	    },
	    getValue: function getValue() {
	        var writerAttribute = this.props.writerAttribute;
	
	        var value = this.refs.inputImage.getValue();
	        var wrapper = {};
	
	        wrapper = _.set(wrapper, writerAttribute, value);
	        return wrapper;
	    },
	    isValid: function isValid() {
	        this.setState({ messageError: '' });
	        return true;
	    },
	    render: function render() {
	        return React.createElement("div", { className: "form-group form-group-image-chooser" }, React.createElement(Uploader, { isDisable: this.props.isDisabled, label: this.props.label, ref: "inputImage" }));
	    }
	});
	
	module.exports = FormGroupImageChooser;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1321);
	
	var React = __webpack_require__(1),
	    PropTypes = React.PropTypes,
	    mui = __webpack_require__(12),
	    set = __webpack_require__(5).set,
	    get = __webpack_require__(5).get,
	    BasicFormGroup = __webpack_require__(94),
	    Toggle = mui.Toggle;
	
	
	var FormGroupToggle = React.createClass({ displayName: "FormGroupToggle",
	
	    propTypes: _extends({}, BasicFormGroup.propTypes, {
	        label: PropTypes.string,
	        onChange: PropTypes.func,
	        messageError: PropTypes.string,
	        writerAttribute: PropTypes.string,
	        readerAttribute: PropTypes.string,
	        name: PropTypes.string,
	        decimalDigits: PropTypes.bool,
	        formatDecimal: PropTypes.string,
	        amountDecimals: PropTypes.number,
	        isRequired: PropTypes.bool,
	        onEnter: PropTypes.func,
	        className: PropTypes.string
	    }),
	
	    _el: null,
	
	    componentDidMount: function componentDidMount() {
	        var operationsHolder = this.props.operationsHolder;
	        // React will throw a warning for bind the context with each operation, but we need it, otherwise
	        // we don't have access to the context of the component when need to perform each operation.
	
	        operationsHolder.addValidator(this.isValid.bind(this));
	        operationsHolder.addCleaner(this.clean.bind(this));
	        operationsHolder.addItemProvider(this.getValue.bind(this));
	    },
	    clean: function clean() {},
	    getValue: function getValue() {
	        var _props = this.props,
	            writerAttribute = _props.writerAttribute,
	            readerAttribute = _props.readerAttribute;
	
	        var value = this._el.isToggled();
	        var writerAttributeSafe = writerAttribute || readerAttribute; // make writer attribute optionally
	        var wrapper = set({}, writerAttributeSafe, value);
	
	        return wrapper;
	    },
	    isValid: function isValid() {
	        this.setState({ messageError: '' });
	        return true;
	    },
	    _onEnter: function _onEnter() {
	        if (this.props.onEnter) {
	            this.props.onEnter();
	        }
	    },
	    onChange: function onChange() {
	        this._el.setToggled(!this._el.isToggled());
	    },
	    render: function render() {
	        var _this = this;
	
	        var _props2 = this.props,
	            isDisabled = _props2.isDisabled,
	            label = _props2.label,
	            value = _props2.value,
	            readerAttribute = _props2.readerAttribute,
	            isImmutable = _props2.isImmutable,
	            isEditMode = _props2.isEditMode,
	            className = _props2.className;
	
	        // is disabled input
	
	        var isDisabledInput = !!isDisabled || isImmutable && isEditMode;
	
	        // prepare specific classes
	        var textFieldClassName = 'form-group form-group-toggle';
	        textFieldClassName += isDisabledInput ? ' is-disabled' : '';
	        if (className) {
	            textFieldClassName += ' ' + className;
	        }
	        var classNameElement = 'form-group-toggle-input' + (isDisabledInput ? ' is-disabled' : '');
	
	        // the input value
	        var safeValue = value === undefined ? false : readerAttribute ? get(value, readerAttribute, '') : value;
	
	        return React.createElement("div", { className: textFieldClassName }, React.createElement("label", null, label), React.createElement(Toggle, {
	            ref: function ref(_ref) {
	                return _this._el = _ref;
	            },
	            className: classNameElement,
	            floatingLabelStyle: { color: '#fff !important', fontWeight: '300' },
	            LabelStyle: { color: '#fff !important', fontWeight: '300' },
	            onEnterKeyDown: this._onEnter,
	            defaultToggled: safeValue,
	            floatingLabelText: label ? label : '',
	            style: { width: '100%', color: 'white !important', fontWeight: '300' },
	            disabled: isDisabledInput,
	            errorText: get(this.state, 'messageError', '') }));
	    }
	});
	
	module.exports = FormGroupToggle;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1323);
	
	var React = __webpack_require__(1),
	    CarouselItem = __webpack_require__(707),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    find = _require.find,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(1),
	    PropTypes = _require3.PropTypes;
	
	
	var INTERVAL_TIME = 1000 * 32; // 32 seg
	
	var Carousel = React.createClass({ displayName: "Carousel",
	    /**
	     * interval of carousel component.
	     */
	    interval: null,
	
	    propTypes: {
	        items: PropTypes.string,
	        onClick: PropTypes.func,
	        onClickArrow: PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            prevIndex: 0,
	            currentIndex: 1,
	            nextIndex: 2,
	            isBannerMoving: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var _this = this;
	
	        this.interval = setInterval(function () {
	            _this.onClickArrow('RIGHT');
	        }, INTERVAL_TIME);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        clearInterval(this.interval);
	    },
	    onClickArrowLeft: function onClickArrowLeft() {
	        this.onClickArrow('LEFT');
	    },
	    onClickArrowRight: function onClickArrowRight() {
	        this.onClickArrow('RIGHT');
	    },
	    onClickArrow: function onClickArrow(direction) {
	        var _this2 = this;
	
	        var _props = this.props,
	            items = _props.items,
	            onClickArrow = _props.onClickArrow;
	
	        var haveItemsSeveralItems = items && items.length > 1;
	
	        if (!haveItemsSeveralItems) {
	            return;
	        }
	
	        var isLeftDirection = direction === 'LEFT';
	        var isRightDirection = direction === 'RIGHT';
	
	        this.setState({
	            isLeftDirection: isLeftDirection,
	            isRightDirection: isRightDirection,
	            isBannerMoving: true
	        }, function () {
	            delay(function () {
	                _this2.onBannerMoveEnd(direction);
	                if (onClickArrow) {
	                    onClickArrow();
	                }
	            }, 1001); // keep sync with $carousel-transition
	        });
	    },
	    onBannerMoveEnd: function onBannerMoveEnd(direction) {
	        var _this3 = this;
	
	        this.setState(function (prevState) {
	            var lastUpdateItems = prevState.itemsUpdated || _this3.props.items;
	            var itemsUpdated = _translateItemPositions(lastUpdateItems, direction);
	            return { itemsUpdated: itemsUpdated, isBannerMoving: false };
	        });
	    },
	    render: function render() {
	        var _this4 = this;
	
	        var _props2 = this.props,
	            items = _props2.items,
	            onClick = _props2.onClick;
	        var _state = this.state,
	            isLeftDirection = _state.isLeftDirection,
	            itemsUpdated = _state.itemsUpdated,
	            isBannerMoving = _state.isBannerMoving;
	
	        var lastUpdateItems = itemsUpdated || items;
	
	        var prevItem = find(lastUpdateItems, function (item) {
	            return item.index === 0;
	        });
	        var currentItem = find(lastUpdateItems, function (item) {
	            return item.index === 1;
	        });
	        var nextItem = find(lastUpdateItems, function (item) {
	            return item.index === 2;
	        });
	
	        var filteredItems = [prevItem, currentItem, nextItem];
	
	        var currentItemsEl = map(filteredItems, function (filterItem) {
	            var className = void 0;
	
	            if (isBannerMoving) {
	                className = _buildClassName(filterItem, isLeftDirection);
	            }
	
	            return React.createElement(CarouselItem, {
	                onClick: onClick.bind(_this4, filterItem),
	                imageSrc: filterItem.imgSrc,
	                imageStyle: filterItem.imgStyle || {},
	                name: filterItem.name,
	                link: filterItem.link,
	                linkHoverName: filterItem.name,
	                className: className });
	        });
	
	        return React.createElement("div", { className: "bp-carousel" }, React.createElement("div", {
	            onClick: isBannerMoving ? null : this.onClickArrowLeft,
	            className: "bp-carousel__arrow bp-carousel__arrow-left"
	        }, React.createElement("i", { className: "material-icons" }, "keyboard_arrow_left")), React.createElement("ul", { className: "bp-carousel__content" }, currentItemsEl), React.createElement("div", {
	            onClick: isBannerMoving ? null : this.onClickArrowRight,
	            className: "bp-carousel__arrow bp-carousel__arrow-right"
	        }, React.createElement("i", { className: "material-icons" }, "keyboard_arrow_right")));
	    }
	});
	
	function _buildClassName(item, isLeftDirection) {
	    var className = '';
	    var isCenterBanner = item.index === 1;
	    var isLeftBanner = item.index === 0;
	    var isRightBanner = item.index === 2;
	    var isRightDirection = isLeftDirection === false;
	
	    if (isRightDirection) {
	        if (isRightBanner) {
	            className += 'pull-left-banner';
	        } else if (isCenterBanner) {
	            className += 'pull-left-banner';
	        }
	    } else {
	        if (isLeftBanner) {
	            className += 'pull-right-banner';
	        } else if (isCenterBanner) {
	            className += 'pull-right-banner';
	        }
	    }
	
	    className += ' is-moving';
	
	    return className;
	}
	
	function _updateItemIndex(item, direction, amountItems) {
	    var currentIndex = get(item, 'index');
	    var nextIndex = currentIndex;
	    var firstIndexPosition = 0;
	    var isLeftDirection = direction === 'LEFT';
	    var isRightDirection = direction === 'RIGHT';
	    var isFirstPosition = currentIndex === firstIndexPosition;
	    var isLastPosition = currentIndex === amountItems;
	
	    if (isFirstPosition && isLeftDirection) {
	        nextIndex++;
	    } else if (isFirstPosition && isRightDirection) {
	        nextIndex = amountItems;
	    } else if (isLastPosition && isLeftDirection) {
	        nextIndex = firstIndexPosition;
	    } else if (isLastPosition && isRightDirection) {
	        nextIndex--;
	    } else if (isLeftDirection) {
	        nextIndex++;
	    } else if (isRightDirection) {
	        nextIndex--;
	    }
	
	    item.index = nextIndex;
	
	    return item;
	}
	
	function _translateItemPositions(items, direction) {
	    var amountItems = get(items, 'length', 1);
	    return map(items, function (item) {
	        return _updateItemIndex(item, direction, amountItems - 1);
	    });
	}
	
	module.exports = Carousel;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var CarouselItem = React.createClass({ displayName: "CarouselItem",
	    propTypes: {
	        className: PropTypes.string,
	        imageStyle: PropTypes.obj,
	        imageSrc: PropTypes.string,
	        name: PropTypes.string,
	        link: PropTypes.string,
	        linkHoverName: PropTypes.string,
	        onClick: PropTypes.func
	    },
	
	    render: function render() {
	        var _props = this.props,
	            imageSrc = _props.imageSrc,
	            link = _props.link,
	            linkHoverName = _props.linkHoverName,
	            className = _props.className,
	            onClick = _props.onClick,
	            imageStyle = _props.imageStyle;
	
	        return React.createElement("li", { onClick: onClick, className: 'bp-carousel-item' + (className ? ' ' + className : '') }, React.createElement("a", { target: "_blank", name: linkHoverName, href: link }, React.createElement("div", { style: _extends({}, { backgroundImage: 'url(' + imageSrc + ')' }, imageStyle), className: "bp-carousel-item__image" })));
	    }
	});
	
	module.exports = CarouselItem;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1324);
	var React = __webpack_require__(1),
	    Menu = __webpack_require__(523),
	    MenuItem = __webpack_require__(522),
	    MenuDivider = __webpack_require__(521),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    FontIcon = __webpack_require__(118),
	    PopupUtils = __webpack_require__(748);
	
	
	var CustomContextMenu = React.createClass({ displayName: "CustomContextMenu",
	
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('click', this.onClickOutSide);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('click', this.onClickOutSide, false);
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isVisible: false,
	            isNewMode: false
	        };
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        var targetEl = this.refs.targetEl.getDOMNode();
	        var menuEl = this.refs.contextMenuEl.getDOMNode();
	        PopupUtils.setPosition(menuEl, targetEl, ['bottom', 'top'], ['left', 'right']);
	    },
	    onClickOutSide: function onClickOutSide() {
	        this.close();
	    },
	    show: function show(x, y, displayText, textDisplaySubtitleDate, menuItems, isNewMode) {
	        this.setState(function (prevState) {
	            return {
	                isVisible: !prevState.isVisible,
	                left: x,
	                top: y,
	                displayText: displayText,
	                textDisplaySubtitleDate: textDisplaySubtitleDate,
	                menuItems: menuItems,
	                isNewMode: isNewMode
	            };
	        });
	    },
	    close: function close() {
	        this.setState({
	            isVisible: false
	        });
	    },
	    render: function render() {
	        var _state = this.state,
	            isNewMode = _state.isNewMode,
	            menuItems = _state.menuItems,
	            displayText = _state.displayText,
	            isVisible = _state.isVisible,
	            top = _state.top,
	            left = _state.left,
	            textDisplaySubtitleDate = _state.textDisplaySubtitleDate;
	
	        var meuItemsEl = map(menuItems, function (menuItem) {
	            if (menuItem.isDivider) {
	                return React.createElement(MenuDivider, null);
	            }
	            var fontIcon = React.createElement(FontIcon, { className: "material-icons" }, menuItem.icon);
	            return React.createElement(MenuItem, {
	                className: "context-menu icon",
	                leftIcon: fontIcon,
	                primaryText: menuItem.text,
	                onClick: menuItem.onClick });
	        });
	
	        return React.createElement("div", { className: "menu-container", ref: "targetEl", style: {
	                display: isVisible ? 'block' : 'none',
	                position: 'absolute',
	                top: top + 'px',
	                left: left + 'px',
	                minWidth: '320px !important',
	                overflow: 'hidden !important'
	            } }, React.createElement(Menu, { width: 320, desktop: true,
	            ref: "contextMenuEl",
	            "data-is-new-mode": isNewMode,
	            "data-display-first-line": displayText,
	            "data-display-second-line": textDisplaySubtitleDate,
	            "data-menu-context": "right-click-context-menu",
	            style: {
	                display: isVisible ? 'block' : 'none',
	                position: 'fixed',
	                top: top + 'px',
	                left: left + 'px',
	                minWidth: '320px !important'
	            } }, meuItemsEl));
	    }
	});
	
	module.exports = CustomContextMenu;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(12),
	    Dialog = _require2.Dialog,
	    FlatButton = _require2.FlatButton,
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(37),
	    delay = _require3.delay,
	    _require4 = __webpack_require__(48),
	    concat = _require4.concat,
	    DEFAULT_LABEL_OK = t('password_recovery_primary_button'),
	    DEFAULT_LABEL_CONFIRM = t('button_label_continue'),
	    DEFAULT_LABEL_CANCEL = t('button_label_cancel');
	
	
	var CustomDialog = React.createClass({ displayName: "CustomDialog",
	
	    getInitialState: function getInitialState() {
	        return {
	            title: 'title_test',
	            message: 'message_test',
	            type: 'info'
	        };
	    },
	    showInfo: function showInfo(title, message, labelOk) {
	        this.show({
	            title: title,
	            message: message,
	            labelOk: labelOk || t('ok'),
	            type: 'info'
	        });
	    },
	    showWarningConfirmation: function showWarningConfirmation(title, message, onConfirm, labelConfirm, labelOk, onCancel, onClickAway) {
	        this.show({
	            title: title,
	            message: message,
	            labelConfirm: labelConfirm,
	            onConfirm: onConfirm,
	            onCancel: onCancel,
	            labelOk: labelOk || t('ok'),
	            type: 'warning',
	            onClickAway: onClickAway
	        });
	    },
	    show: function show(params) {
	        var _this = this;
	
	        var title = get(params, 'title', '');
	        var message = get(params, 'message', '');
	        var type = get(params, 'type', 'info');
	        var onConfirm = get(params, 'onConfirm');
	        var onCancel = get(params, 'onCancel');
	        var labelConfirm = get(params, 'labelConfirm');
	        var labelOk = get(params, 'labelOk');
	        var onClickAway = get(params, 'onClickAway');
	
	        this.setState({
	            title: title,
	            message: message,
	            onConfirm: onConfirm,
	            onCancel: onCancel,
	            labelConfirm: labelConfirm,
	            labelOk: labelOk,
	            type: type,
	            onClickAway: onClickAway
	        }, function () {
	            _this.refs.customDialog.show();
	            var self = _this;
	            if (_this.refs.customDialog && _this.refs.customDialog.getDOMNode()) {
	                delay(function () {
	                    var buttonEl = self.refs.customDialog.getDOMNode().querySelector('button');
	                    if (buttonEl) {
	                        buttonEl.focus();
	                        buttonEl.scrollIntoView();
	                    }
	                }, 1000);
	            }
	        });
	    },
	    close: function close() {
	        this.refs.customDialog.dismiss();
	    },
	    getDefaultActions: function getDefaultActions(onCancel, label) {
	        var _this2 = this;
	
	        var isPrimary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        var onCancelAction = void 0;
	
	        if (onCancel) {
	            onCancelAction = function onCancelAction() {
	                if (onCancel) {
	                    onCancel();
	                }
	                _this2.close();
	            };
	        } else {
	            onCancelAction = this.close;
	        }
	        return [React.createElement(FlatButton, {
	            label: label,
	            primary: isPrimary,
	            onTouchTap: onCancelAction
	        })];
	    },
	    getConfirmAction: function getConfirmAction(onClick, label) {
	        var _this3 = this;
	
	        var onClickAfterClose = function onClickAfterClose(onClickCallback) {
	            if (onClickCallback) {
	                onClickCallback();
	            }
	            _this3.close();
	        };
	        return React.createElement(FlatButton, {
	            label: label,
	            primary: true,
	            onTouchTap: onClickAfterClose.bind(this, onClick)
	        });
	    },
	    render: function render() {
	        var _state = this.state,
	            message = _state.message,
	            title = _state.title,
	            onConfirm = _state.onConfirm,
	            labelConfirm = _state.labelConfirm,
	            labelOk = _state.labelOk,
	            onCancel = _state.onCancel,
	            onClickAway = _state.onClickAway;
	
	        var actionsWithClose = void 0;
	
	        if (onConfirm) {
	            actionsWithClose = this.getDefaultActions(onCancel, labelOk || DEFAULT_LABEL_CANCEL, false);
	            actionsWithClose = concat(this.getConfirmAction(onConfirm, labelConfirm || DEFAULT_LABEL_CONFIRM), actionsWithClose);
	        } else {
	            actionsWithClose = this.getDefaultActions(onCancel, labelOk || DEFAULT_LABEL_OK);
	        }
	
	        return React.createElement(Dialog, {
	            ref: "customDialog",
	            title: title,
	            actions: actionsWithClose,
	            actionFocus: "submit",
	            modal: false,
	            onClickAway: onClickAway
	        }, React.createElement("div", null, React.createElement("div", { dangerouslySetInnerHTML: getMessage(message) })));
	    }
	});
	
	function getMessage(message) {
	    return { __html: message };
	}
	
	module.exports = CustomDialog;

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1328);
	
	var _require = __webpack_require__(4),
	    t = _require.t;
	
	var React = __webpack_require__(1),
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    TextField = __webpack_require__(106);
	
	
	var GridItemFilter = React.createClass({ displayName: "GridItemFilter",
	    propTypes: {
	        onChange: PropTypes.func,
	        onBlur: PropTypes.func,
	        onEnter: PropTypes.func,
	        value: PropTypes.func
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var _props = this.props,
	            onChange = _props.onChange,
	            onBlur = _props.onBlur,
	            onEnter = _props.onEnter,
	            value = _props.value;
	
	        return React.createElement("div", { className: "bp-grid-item-filter should-focus" }, React.createElement(TextField, {
	            ref: function ref(_ref) {
	                return _this._el = _ref;
	            },
	            icon: "search",
	            floatingLabelStyle: {
	                color: '#fff !important',
	                fontWeight: '200'
	            },
	            LabelStyle: { color: '#fff !important', fontWeight: '300' },
	            onChange: onChange,
	            onBlur: onBlur,
	            onEnterKeyDown: onEnter,
	            floatingLabelText: t('filter_icon'),
	            value: value,
	            style: {
	                width: '100%',
	                fontWeight: '300'
	            } }));
	    }
	});
	
	module.exports = GridItemFilter;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1331);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    get = __webpack_require__(5).get,
	    MenuListItem = __webpack_require__(712),
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes;
	
	
	var MenuList = React.createClass({ displayName: "MenuList",
	    propTypes: {
	        items: PropTypes.array,
	        isExpanded: PropTypes.bool,
	        readerAttribute: PropTypes.string,
	        readerAttributeIcon: PropTypes.string,
	        onChange: PropTypes.func,
	        wrapperMenuItem: PropTypes.func,
	        key: PropTypes.string
	    },
	
	    render: function render() {
	        var _props = this.props,
	            items = _props.items,
	            isExpanded = _props.isExpanded,
	            readerAttribute = _props.readerAttribute,
	            readerAttributeIcon = _props.readerAttributeIcon,
	            onChange = _props.onChange,
	            wrapperMenuItem = _props.wrapperMenuItem,
	            key = _props.key;
	
	        var itemsEl = map(items, function (item, index) {
	            var customKey = key ? key + '-' + index : get(item, 'locatorId') + '-' + index;
	            return React.createElement(MenuListItem, {
	                key: customKey,
	                readerAttribute: readerAttribute,
	                readerAttributeIcon: readerAttributeIcon,
	                item: item,
	                onChange: onChange,
	                index: index,
	                wrapperMenuItem: wrapperMenuItem,
	                isDisabled: get(item, 'isDisabled') });
	        });
	        return React.createElement("div", {
	            style: {
	                display: isExpanded ? 'block' : 'none'
	            },
	            className: "bp-menu-list"
	        }, React.createElement("ul", null, itemsEl));
	    }
	});
	
	module.exports = MenuList;

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1332);
	
	var React = __webpack_require__(1),
	    Stamp = __webpack_require__(131),
	    get = __webpack_require__(5).get,
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var MenuListItem = React.createClass({ displayName: "MenuListItem",
	    propTypes: {
	        item: PropTypes.object,
	        index: PropTypes.number,
	        isDisabled: PropTypes.bool,
	        readerAttribute: PropTypes.string,
	        readerAttributeIcon: PropTypes.string,
	        onChange: PropTypes.func,
	        wrapperMenuItem: PropTypes.func,
	        key: PropTypes.string
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return false;
	        }
	        return true;
	    },
	    onKeyDown: function onKeyDown(evt) {
	        var _props = this.props,
	            onChange = _props.onChange,
	            item = _props.item,
	            index = _props.index;
	
	        var isKeyPressEnter = evt.keyCode === 13;
	        var isKeyPressSpace = evt.keyCode === 32;
	        var isKeyPressScape = evt.keyCode === 27;
	
	        if (isKeyPressEnter || isKeyPressSpace || isKeyPressScape) {
	            onChange(item, index);
	        }
	    },
	    getTextItem: function getTextItem(item, readerAttribute) {
	        var _props2 = this.props,
	            readerAttributeIcon = _props2.readerAttributeIcon,
	            wrapperMenuItem = _props2.wrapperMenuItem;
	
	        var text = get(item, readerAttribute);
	        var haveItems = !!get(item, readerAttributeIcon);
	        var haveWrapperMenuItems = !!wrapperMenuItem;
	
	        if (haveWrapperMenuItems) {
	            return React.createElement("span", { className: "bp-menu-list-item__content" }, wrapperMenuItem(item));
	        } else if (haveItems) {
	            return React.createElement("span", { className: "bp-menu-list-item__content" }, React.createElement(Stamp, { classNameIcon: get(item, readerAttributeIcon) }), React.createElement("span", { className: "bp-menu-list-item__content-text" }, text));
	        } else {
	            return React.createElement("span", { className: "bp-menu-list-item__content" }, text);
	        }
	    },
	    onChange: function onChange(evt) {
	        var _props3 = this.props,
	            onChange = _props3.onChange,
	            item = _props3.item;
	
	
	        if (onChange) {
	            onChange(item, evt);
	        }
	    },
	    render: function render() {
	        var _props4 = this.props,
	            item = _props4.item,
	            readerAttribute = _props4.readerAttribute,
	            onChange = _props4.onChange,
	            isDisabled = _props4.isDisabled,
	            index = _props4.index,
	            locatorId = _props4.locatorId,
	            key = _props4.key;
	
	        var textEl = this.getTextItem(item, readerAttribute, isDisabled);
	        return React.createElement("li", {
	            "data-menu-index": index,
	            onKeyDown: isDisabled ? null : this.onKeyDown,
	            "data-locator-id": locatorId,
	            tabIndex: "0",
	            key: key + '-menu-item-id',
	            onClick: isDisabled ? null : onChange ? this.onChange : null,
	
	            className: 'bp-menu-list-item' + (isDisabled ? ' is-disabled' : '')
	
	        }, textEl);
	    }
	});
	
	module.exports = MenuListItem;

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1333);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    NumberUtils = __webpack_require__(23),
	    Constants = __webpack_require__(2),
	    EMPTY_ACTION = function EMPTY_ACTION() {},
	    PaginationItem = __webpack_require__(714);
	
	
	var Pagination = React.createClass({ displayName: "Pagination",
	
	    propTypes: {
	        currentPage: PropTypes.number,
	        maxPage: PropTypes.number,
	        maxVisibleButtonPages: PropTypes.number,
	        onNextPage: PropTypes.function,
	        onPreviousPage: PropTypes.function,
	        onClickPage: PropTypes.function
	    },
	
	    getInitialState: function getInitialState() {
	        var _props = this.props,
	            currentPage = _props.currentPage,
	            maxVisibleButtonPages = _props.maxVisibleButtonPages;
	
	
	        return {
	            startIndex: getStartIndex(currentPage, maxVisibleButtonPages)
	        };
	    },
	    _onPreviousPage: function _onPreviousPage() {
	        this.setState(function (prevState) {
	            prevState.startIndex = prevState.startIndex - 1;
	            return prevState;
	        });
	    },
	    _onNextPage: function _onNextPage() {
	        this.setState(function (prevState) {
	            prevState.startIndex = prevState.startIndex + 1;
	            return prevState;
	        });
	    },
	    render: function render() {
	        var _props2 = this.props,
	            currentPage = _props2.currentPage,
	            maxPage = _props2.maxPage,
	            onClickPage = _props2.onClickPage,
	            maxVisibleButtonPages = _props2.maxVisibleButtonPages;
	        var startIndex = this.state.startIndex;
	
	        var maxVisibleButtonPagination = maxVisibleButtonPages || Constants.MAX_VISIBLE_BUTTON_PAGES;
	        var i = void 0,
	            paginationListEl = [],
	            arrowLeftEl = void 0,
	            arrowRightEl = void 0;
	
	        var singlePage = maxPage <= 1;
	        var isVisibleButtonMorePages = NumberUtils.isGreater(maxPage, maxVisibleButtonPagination);
	        var isVisibleButtonLeftMorePages = startIndex > 0;
	
	        if (isVisibleButtonMorePages && isVisibleButtonLeftMorePages) {
	            arrowLeftEl = React.createElement("i", { onClick: this._onPreviousPage, className: "pagination-start material-icons" }, "keyboard_arrow_left");
	        }
	
	        var pageVisibles = 0;
	
	        for (i = 0; i < maxPage; i++) {
	            if (isVisibleButtonMorePages && i < startIndex) {
	                continue;
	            } else {
	                pageVisibles++;
	            }
	
	            if (pageVisibles > maxVisibleButtonPagination) {
	                break;
	            }
	
	            paginationListEl.push(React.createElement(PaginationItem, { onClick: onClickPage ? onClickPage.bind(this, i) : EMPTY_ACTION,
	                pageNumber: i + 1,
	                isActive: i === +currentPage }));
	        }
	
	        if (isVisibleButtonMorePages && i < maxPage) {
	            arrowRightEl = React.createElement("i", { onClick: this._onNextPage, className: "pagination-start material-icons" }, "keyboard_arrow_right");
	        }
	
	        return React.createElement("div", { style: { display: singlePage ? 'none' : 'flex' }, className: "pagination-list" }, arrowLeftEl, paginationListEl, arrowRightEl);
	    }
	});
	
	/**
	 * Calculate the middle of the position
	 * @param currentPage
	 * @param visiblePages
	 * @returns {*}
	 */
	function getStartIndex(currentPage, visiblePages) {
	    var middleCurrentRange = NumberUtils.divide(visiblePages, 2);
	    var startIndexTarget = NumberUtils.subtract(currentPage, middleCurrentRange);
	
	    return NumberUtils.isGreater(startIndexTarget, 0) ? startIndexTarget - 1 : 0;
	}
	
	module.exports = Pagination;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var PaginationItem = React.createClass({ displayName: "PaginationItem",
	    propType: {
	        pageNumber: PropTypes.number,
	        isActive: PropTypes.bool,
	        onClick: PropTypes.function
	    },
	
	    render: function render() {
	        var className = 'pagination-item';
	
	        if (this.props.isActive) {
	            className += ' is-active';
	        }
	
	        return React.createElement("div", { onClick: this.props.onClick, className: className }, this.props.pageNumber);
	    }
	});
	
	module.exports = PaginationItem;

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var cancelScrollEvent = function cancelScrollEvent(e) {
	    e.stopImmediatePropagation();
	    e.preventDefault();
	    e.returnValue = false;
	    return false;
	};
	
	var addScrollEventListener = function addScrollEventListener(elem, handler) {
	    elem.addEventListener('wheel', handler, false);
	};
	
	var removeScrollEventListener = function removeScrollEventListener(elem, handler) {
	    elem.removeEventListener('wheel', handler, false);
	};
	
	var ScrollLockMixin = {
	    scrollLock: function scrollLock(elem) {
	        elem = elem || this.getDOMNode();
	        this.scrollElem = elem;
	        addScrollEventListener(elem, this.onScrollHandler);
	    },
	    scrollRelease: function scrollRelease(elem) {
	        elem = elem || this.scrollElem;
	        removeScrollEventListener(elem, this.onScrollHandler);
	    },
	    onScrollHandler: function onScrollHandler(e) {
	        var elem = this.scrollElem;
	        var scrollTop = elem.scrollTop;
	        var scrollHeight = elem.scrollHeight;
	        var height = elem.clientHeight;
	        var wheelDelta = e.deltaY;
	        var isDeltaPositive = wheelDelta > 0;
	
	        if (isDeltaPositive && wheelDelta > scrollHeight - height - scrollTop) {
	            elem.scrollTop = scrollHeight;
	            return cancelScrollEvent(e);
	        } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	            elem.scrollTop = 0;
	            return cancelScrollEvent(e);
	        }
	    }
	};
	
	var ScrollLock = React.createClass({ displayName: "ScrollLock",
	    mixins: [ScrollLockMixin],
	
	    componentDidMount: function componentDidMount() {
	        this.scrollLock();
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.scrollRelease();
	    },
	
	
	    // show nothing because is just rendering
	    render: function render() {
	        return React.createElement("span", null);
	    }
	});
	
	module.exports = ScrollLock;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1338);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    _require2 = __webpack_require__(48),
	    union = _require2.union,
	    get = __webpack_require__(5).get,
	    TextFieldSuggestedListItem = __webpack_require__(717),
	    _require3 = __webpack_require__(1),
	    PropTypes = _require3.PropTypes;
	
	
	var TextFieldSuggestedList = React.createClass({ displayName: "TextFieldSuggestedList",
	    propTypes: {
	        items: PropTypes.array,
	        itemsDisabled: PropTypes.array,
	        isExpanded: PropTypes.bool,
	        readerAttribute: PropTypes.string,
	        textWritten: PropTypes.string
	    },
	
	    render: function render() {
	        var _props = this.props,
	            items = _props.items,
	            itemsDisabled = _props.itemsDisabled,
	            isExpanded = _props.isExpanded,
	            readerAttribute = _props.readerAttribute,
	            onClick = _props.onClick,
	            textWritten = _props.textWritten;
	
	        var allItems = union(items, itemsDisabled);
	        var itemsEl = map(allItems, function (item) {
	            return React.createElement(TextFieldSuggestedListItem, {
	                readerAttribute: readerAttribute,
	                item: item,
	                matchText: textWritten,
	                onClick: onClick,
	                isDisabled: get(item, 'isDisabled') });
	        });
	        return React.createElement("div", {
	            style: {
	                display: isExpanded ? 'block' : 'none'
	            },
	            className: "bp-textfield-suggested-list"
	        }, React.createElement("ul", null, itemsEl));
	    }
	});
	
	module.exports = TextFieldSuggestedList;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1339);
	
	var React = __webpack_require__(1),
	    get = __webpack_require__(5).get,
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	
	var TextFieldSuggestedListItem = React.createClass({ displayName: "TextFieldSuggestedListItem",
	
	    propTypes: {
	        item: PropTypes.object,
	        isDisabled: PropTypes.bool,
	        readerAttribute: PropTypes.readerAttribute,
	        onClick: PropTypes.func,
	        matchText: PropTypes.string
	    },
	
	    onKeyDown: function onKeyDown(evt) {
	        var _props = this.props,
	            onClick = _props.onClick,
	            item = _props.item;
	
	        var isKeyPressEnter = evt.keyCode === 13;
	        var isKeyPressSpace = evt.keyCode === 32;
	        var isKeyPressScape = evt.keyCode === 27;
	
	        if (isKeyPressEnter || isKeyPressSpace || isKeyPressScape) {
	            onClick(item);
	        }
	    },
	    getTextItem: function getTextItem(item, matchText, readerAttribute) {
	        var haveMatchText = !!matchText;
	        var text = get(item, readerAttribute);
	
	        if (haveMatchText) {
	            return React.createElement("span", null, getTextHeightLighted(text, matchText));
	        } else {
	            return React.createElement("span", null, text);
	        }
	    },
	    render: function render() {
	        var _props2 = this.props,
	            item = _props2.item,
	            readerAttribute = _props2.readerAttribute,
	            onClick = _props2.onClick,
	            isDisabled = _props2.isDisabled,
	            matchText = _props2.matchText;
	
	        var textEl = this.getTextItem(item, matchText, readerAttribute, isDisabled);
	        return React.createElement("li", {
	            onKeyDown: isDisabled ? null : this.onKeyDown,
	            tabIndex: "0",
	            onClick: isDisabled ? null : onClick.bind(this, item),
	            className: 'bp-textfield-suggested-list-item' + (isDisabled ? ' is-disabled' : '')
	        }, textEl);
	    }
	});
	
	function getTextHeightLighted(text, matchText) {
	    var safeText = text || '';
	    var textNotKeySensitive = safeText.toLowerCase();
	    var matchTextNotKeySensitive = matchText.toLowerCase();
	
	    var indexStartingMatch = textNotKeySensitive.indexOf(matchTextNotKeySensitive);
	    var matchingTextLength = matchText.length;
	    var indexEndMatching = indexStartingMatch + matchingTextLength;
	    var lengthText = safeText.length;
	
	    var firstTextWithoutHeightLight = safeText.substring(0, indexStartingMatch);
	    var textWithoutHeightLight = safeText.substring(indexStartingMatch, indexEndMatching);
	    var lastTextWithoutHeightLight = safeText.substring(indexEndMatching, lengthText);
	
	    return React.createElement("span", null, React.createElement("span", null, firstTextWithoutHeightLight), React.createElement("span", { className: "is-matching" }, textWithoutHeightLight), React.createElement("span", null, lastTextWithoutHeightLight));
	}
	
	module.exports = TextFieldSuggestedListItem;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1341);
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes;
	
	var CustomOverlay = React.createClass({ displayName: "CustomOverlay",
	
	    propTypes: {
	        show: PropTypes.bool,
	        text: PropTypes.String
	    },
	
	    render: function render() {
	        var _props = this.props,
	            isVisible = _props.isVisible,
	            text = _props.text;
	
	
	        var className = 'bp-custom-overlay';
	
	        if (isVisible) {
	            className += ' is-visible';
	        }
	
	        if (text) {
	            className += ' has-text';
	        }
	
	        return React.createElement("div", { "data-text": text, className: className });
	    }
	});
	
	module.exports = CustomOverlay;

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    OrderStore = __webpack_require__(72),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AppDispatcher = __webpack_require__(42),
	    _ = __webpack_require__(40),
	    DashboardModalSingleNew = __webpack_require__(723),
	    DashboardModalSingleChange = __webpack_require__(722),
	    DashboardModalBrewNew = __webpack_require__(721),
	    DashboardModalBrewChange = __webpack_require__(720),
	    BrewhouseStore = __webpack_require__(96),
	    DashboardModalStore = __webpack_require__(155),
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    DashboardActionCreator = __webpack_require__(65),
	    ga = __webpack_require__(18),
	    categories = __webpack_require__(2).Analytics.categories,
	    actions = __webpack_require__(2).Analytics.actions,
	    _require2 = __webpack_require__(2),
	    TOGGLE_BT = _require2.TOGGLE_BT,
	    TOGGLE_FV = _require2.TOGGLE_FV,
	    TOGGLE_FV_BT = _require2.TOGGLE_FV_BT,
	    TOGGLE_BH = _require2.TOGGLE_BH,
	    TOGGLE_BH_FV = _require2.TOGGLE_BH_FV,
	    TOGGLE_BH_BT = _require2.TOGGLE_BH_BT,
	    TOGGLE_BH_FV_BT = _require2.TOGGLE_BH_FV_BT,
	    TOGGLE_BH_FV_BH = _require2.TOGGLE_BH_FV_BH,
	    TOGGLE_BH_BT_BH = _require2.TOGGLE_BH_BT_BH,
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    _require3 = __webpack_require__(50),
	    formatProperOrderSelected = _require3.formatProperOrderSelected,
	    _require4 = __webpack_require__(12),
	    Dialog = _require4.Dialog,
	    FlatButton = _require4.FlatButton,
	    Toggle = _require4.Toggle,
	    TextField = _require4.TextField,
	    toggleStyle = {
	    float: 'left',
	    width: '85px'
	},
	    CustomDialog = __webpack_require__(26);
	
	
	var EMPTY_ELEMENT = React.createElement("div", null);
	var labelStyle = function labelStyle() {
	    return {
	        left: '10px',
	        transform: 'perspective(1px) scale(0.85) translate3d(10px, -28px, 0)',
	        transformOrigin: 'left top'
	    };
	};
	
	var DashboardModal = React.createClass({ displayName: "DashboardModal",
	
	    _ref: {},
	
	    _lastDiffVolume: 0,
	
	    getInitialState: function getInitialState() {
	        return DashboardModalStore.getInitialState();
	    },
	    componentWillMount: function componentWillMount() {
	        DashboardModalStore.addChangeListener(this._onChangeDashboardModal);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        DashboardModalStore.removeChangeListener(this._onChangeDashboardModal);
	
	        if (this._ref.toggleBH) {
	            this._ref.toggleBH.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
	        }
	
	        if (this._ref.toggleFV) {
	            this._ref.toggleFV.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
	        }
	
	        if (this._ref.toggleBT) {
	            this._ref.toggleBT.querySelector('input[type="checkbox"]').removeEventListener('change', this._nonAbleToChangeToggles);
	        }
	    },
	    _onChangeDashboardModal: function _onChangeDashboardModal() {},
	
	
	    /**
	     * needed time out to calculate an imperative way the total batch volume.
	     */
	    _timeout: null,
	
	    //TODO: could be improve this `shouldComponentUpdate`
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        return true; //nextProps.shouldUpdate;
	    },
	    componentDidMount: function componentDidMount() {
	        if (this._ref.toggleBH) {
	            this._ref.toggleBH.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
	        }
	
	        if (this._ref.toggleFV) {
	            this._ref.toggleFV.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
	        }
	
	        if (this._ref.toggleBT) {
	            this._ref.toggleBT.querySelector('input[type="checkbox"]').addEventListener('change', this._nonAbleToChangeToggles);
	        }
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        var _this = this;
	
	        var nextState = {};
	        var callback = undefined;
	        var modal = this._getModal(this.state);
	
	        // Validate field error only once refs already been there.
	        if (this.state.shouldNeedValidate && modal) {
	            var modalEl = this.refs[modal.refName];
	            if (modalEl) {
	                var resultValidation = modalEl.isValidForm();
	
	                if (resultValidation.isValid !== undefined && !resultValidation.isValid) {
	                    nextState = _.merge(nextState, resultValidation.messagesError);
	                }
	                nextState.shouldNeedValidate = false;
	            }
	        }
	
	        if (this._ref.toggleBH) {
	            this._ref.toggleBH.setToggled(this.state.isBHAllowed);
	        }
	
	        if (this._ref.toggleFV) {
	            this._ref.toggleFV.setToggled(this.state.isFVAllowed);
	        }
	
	        if (this._ref.toggleBT) {
	            this._ref.toggleBT.setToggled(this.state.isBTAllowed);
	        }
	
	        //TODO: when update to material-ui 15v use show/dismiss props instead of current imperative way (`this.modalOrder.dismiss/show()`).
	        if (this.state.triggerOpen) {
	            nextState.triggerOpen = false;
	            nextState.isOpen = true;
	            callback = function callback() {
	                if (_this.modalOrder) {
	                    _this.modalOrder.show();
	                }
	            };
	        } else if (this.state.triggerClose) {
	            nextState.triggerClose = false;
	            nextState.isOpen = false;
	            callback = function callback() {
	                if (_this.modalOrder) {
	                    _this.modalOrder.dismiss();
	                }
	            };
	        }
	
	        // trigger only one setState
	        if (Object.keys(nextState).length > 0) {
	            this.setState(nextState, callback);
	        }
	
	        if (this._timeout) {
	            clearTimeout(this._timeout);
	        }
	    },
	    openExistingOrder: function openExistingOrder(order, orderDateClicked, isFermenterTankClicked, tankType, openGeneralTab, fermentingVolume, packagingVolume, totalBatchVolume, totalBatchVolumeMessageError, tankClicked, totalBatchCost) {
	        var _this2 = this;
	
	        this.setState(_extends({
	            totalBatchCost: totalBatchCost,
	            order: formatProperOrderSelected(order),
	            isTransfer: true,
	            isFermenterTankClicked: isFermenterTankClicked,
	            orderDateClicked: orderDateClicked,
	            isOpen: true,
	            forceDisableToggle: false,
	            isSingle: false,
	            tankType: tankType,
	            triggerOpen: true,
	            isNewModal: false,
	            batchNumber: order.batchNumber,
	            isBHAllowed: _.get(order, 'batchs.length', 0) > 0,
	            openGeneralTab: openGeneralTab,
	            fermentingVolume: fermentingVolume,
	            packagingVolume: packagingVolume,
	            totalBatchVolume: totalBatchVolume,
	            totalBatchVolumeMessageError: totalBatchVolumeMessageError,
	            tankClicked: tankClicked
	        }, _getToggleState(order)), function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_OPEN_EXISTING_ORDER,
	                order: _this2.state.order,
	                volume: _this2.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
	                batchNumber: _this2._ref.batchNumber.getValue(),
	                isSingle: !(_this2.state.isFVAllowed && _this2.state.isBTAllowed)
	            });
	        });
	    },
	    openExistingSingleOrder: function openExistingSingleOrder(order, orderDateClicked, isFermenterTankClicked, tankType, openGeneralTab, fermentingVolume, packagingVolume, totalBatchVolume, totalBatchVolumeMessageError, tankClicked) {
	        var _this3 = this;
	
	        this.setState(_extends({
	            order: formatProperOrderSelected(order),
	            isFermenterTankClicked: isFermenterTankClicked,
	            tankType: tankType,
	            orderDateClicked: orderDateClicked,
	            isTransfer: false,
	            isSingle: true,
	            isOpen: true,
	            triggerOpen: true,
	            isNewModal: false,
	            forceDisableToggle: false,
	            batchNumber: order.batchNumber,
	            isBHAllowed: _.get(order, 'batchs.length', 0) > 0,
	            openGeneralTab: openGeneralTab,
	            totalBatchVolume: totalBatchVolume,
	            fermentingVolume: fermentingVolume,
	            packagingVolume: packagingVolume,
	            totalBatchVolumeMessageError: totalBatchVolumeMessageError,
	            tankClicked: tankClicked
	        }, _getToggleState(order)), function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_OPEN_EXISTING_ORDER,
	                order: _this3.state.order,
	                volume: _this3.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
	                batchNumber: _this3._ref.batchNumber.getValue(),
	                isSingle: !(_this3.state.isFVAllowed && _this3.state.isBTAllowed)
	            });
	        });
	    },
	    openNewOrder: function openNewOrder(preDefinedOrder) {
	        var _this4 = this;
	
	        if (DashboardStore.isPublishingDraft()) {
	            Notification.show(t('dashboard_notification_please_wait_publication_finished'), 'warning');
	            return;
	        }
	        var isBrewhouseSection = _.get(preDefinedOrder, 'tankSelected.type') === 'BH';
	        if (isBrewhouseSection) {
	            var selectedTankAndDateClicked = BrewhouseStore.updateTankSelectionBrewhouseElegible(preDefinedOrder);
	            var predefinedOrder = formatProperOrderSelected(selectedTankAndDateClicked);
	            predefinedOrder.date = selectedTankAndDateClicked.orderDateClicked;
	            predefinedOrder.tankTypeClicked = preDefinedOrder.tankType;
	
	            this.setState({
	                order: predefinedOrder,
	                isOpen: true,
	                isSingle: false,
	                isTransfer: true,
	                triggerOpen: true,
	                isNewModal: true,
	                // defult all toggles are open
	                isBHAllowed: true,
	                isFVAllowed: true,
	                isBTAllowed: true,
	                forceDisableToggle: false,
	
	                tankSelected: selectedTankAndDateClicked.tankSelected,
	                batchNumber: preDefinedOrder.batchNumber || OrderStore.getNextBatchNumber(),
	                tankType: preDefinedOrder.tankType,
	                totalBatchVolume: _.get(preDefinedOrder, 'tankSelected.volume'),
	                totalBatchVolumeMessageError: _.get(preDefinedOrder, 'totalBatchVolumeMessageError')
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_OPEN_NEW_ORDER,
	                    volume: _this4.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
	                    batchNumber: _this4._ref.batchNumber.getValue(),
	                    isSingle: !(_this4.state.isFVAllowed && _this4.state.isBTAllowed)
	                });
	            });
	        } else {
	
	            var formatOrder = formatProperOrderSelected(preDefinedOrder);
	            formatOrder.tankTypeClicked = preDefinedOrder.tankType;
	
	            this.setState({
	                order: formatOrder,
	                isOpen: true,
	                isTransfer: true,
	                triggerOpen: true,
	                isNewModal: true,
	                tankSelected: preDefinedOrder.tankSelected,
	                batchNumber: preDefinedOrder.batchNumber || OrderStore.getNextBatchNumber(),
	                tankType: preDefinedOrder.tankType,
	                totalBatchVolume: _.get(preDefinedOrder, 'tankSelected.volume'),
	                totalBatchVolumeMessageError: _.get(preDefinedOrder, 'totalBatchVolumeMessageError')
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_OPEN_NEW_ORDER,
	                    volume: _this4.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
	                    batchNumber: _this4._ref.batchNumber.getValue(),
	                    isSingle: !(_this4.state.isFVAllowed && _this4.state.isBTAllowed)
	                });
	            });
	        }
	    },
	    close: function close() {
	        if (this.isMounted()) {
	            if (this.modalOrder) {
	                this.modalOrder.dismiss();
	            }
	            this._lastDiffVolume = 0;
	            var batchNumber = _.get(this.state, 'order.batchNumber');
	            var modalEl = this._getModal(this.state);
	            DashboardModalStore.setCurrentLayout(null);
	
	            if (modalEl) {
	                var modalRefName = modalEl.refName;
	                var modal = this.refs[modalRefName];
	                if (modal) {
	                    modal.clean();
	                }
	                this.setState(DashboardModalStore.getInitialState(), function () {
	                    DashboardActionCreator.executeBatchOperationsEnd(batchNumber);
	                }); // reset state of modal
	            }
	        }
	    },
	    updateVolumeLabels: function updateVolumeLabels(batchVolumeInfo) {
	        // update total batch volume with order volume left `10bbl (5bbl left)`
	        this._updateBatchVolumeLeftLabel(batchVolumeInfo);
	    },
	    updateBatchCostLabel: function updateBatchCostLabel(order) {
	        this._ref.totalBatchCost.setValue(_.get(order, 'totalBatchCost'));
	    },
	    _updateBatchVolumeLeftLabel: function _updateBatchVolumeLeftLabel(order) {
	        this._ref.batchTotalVolume.setValue(_.get(order, 'volume'));
	    },
	    _removeAndClose: function _removeAndClose() {
	        var _this5 = this;
	
	        this.close();
	        CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_orden'), function () {
	            OrderStore.removeOrder(_this5.state.order);
	            ga.event({
	                category: categories.ORDER,
	                action: actions.DELETE,
	                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	        });
	    },
	    _saveAndClose: function _saveAndClose() {
	        var _this6 = this;
	
	        var modalEl = this._getModal(this.state);
	        if (modalEl) {
	            var modalRefName = modalEl.refName;
	            var modal = this.refs[modalRefName];
	            modal.submit(this._ref, function () {
	                return _this6.close();
	            });
	        }
	    },
	    _getSingleNew: function _getSingleNew(state, title, currentSection, sectionName, isBHAllowed, isFVAllowed, isBTAllowed) {
	        var isTransfer = state.isTransfer,
	            order = state.order,
	            tankSelected = state.tankSelected,
	            tankType = state.tankType,
	            openGeneralTab = state.openGeneralTab,
	            shouldNotUpdateChildren = state.shouldNotUpdateChildren;
	
	        return {
	            currentSection: currentSection,
	            title: title,
	            refName: 'dashboardModalChild',
	            el: React.createElement(DashboardModalSingleNew, {
	                ref: "dashboardModalChild",
	                isSingleMode: isTransfer,
	                isBHAllowed: isBHAllowed,
	                isBTAllowed: isBTAllowed,
	                isFVAllowed: isFVAllowed,
	                preDefinedOrder: order,
	                tankSelected: tankSelected,
	                isNew: true,
	                initFromDate: order.date,
	                onActiveFirstTab: this._onChangeTab,
	                tankTypeClicked: tankType,
	                currentSection: currentSection,
	                sectionName: sectionName,
	                openGeneralTab: openGeneralTab,
	                shouldNotUpdate: shouldNotUpdateChildren })
	        };
	    },
	    _getSingleChange: function _getSingleChange(state, title, currentSection, sectionName, isBHAllowed, isFVAllowed, isBTAllowed) {
	        var order = state.order,
	            orderDateClicked = state.orderDateClicked,
	            tankSelected = state.tankSelected,
	            openGeneralTab = state.openGeneralTab,
	            shouldNotUpdateChildren = state.shouldNotUpdateChildren,
	            tankClicked = state.tankClicked;
	
	        return {
	            currentSection: currentSection,
	            title: title,
	            refName: 'dashboardModalChild',
	            el: React.createElement(DashboardModalSingleChange, {
	                ref: "dashboardModalChild",
	                isBHAllowed: isBHAllowed,
	                isBTAllowed: isBTAllowed,
	                isFVAllowed: isFVAllowed,
	                orderDateClicked: orderDateClicked,
	                order: order,
	                tankSelected: tankSelected,
	                onActiveFirstTab: this._onChangeTab,
	                currentSection: currentSection,
	                sectionName: sectionName,
	                openGeneralTab: openGeneralTab,
	                tankClicked: tankClicked || currentSection,
	                shouldNotUpdate: shouldNotUpdateChildren })
	        };
	    },
	    _getCombinedNew: function _getCombinedNew(state, title, isBHAllowed, isFVAllowed, isBTAllowed) {
	        var isTransfer = state.isTransfer,
	            order = state.order,
	            orderDateClicked = state.orderDateClicked,
	            tankSelected = state.tankSelected,
	            tankType = state.tankType,
	            openGeneralTab = state.openGeneralTab,
	            shouldNotUpdateChildren = state.shouldNotUpdateChildren;
	
	        return {
	            title: title,
	            refName: 'dashboardModalChild',
	            el: React.createElement(DashboardModalBrewNew, {
	                ref: "dashboardModalChild",
	                isSingleMode: isTransfer,
	                isBHAllowed: isBHAllowed,
	                isBTAllowed: isBTAllowed,
	                isFVAllowed: isFVAllowed,
	                tankSelected: tankSelected,
	                tankTypeClicked: tankType,
	                orderDateClicked: orderDateClicked,
	                order: order,
	                onActiveFirstTab: this._onChangeTab,
	                openGeneralTab: openGeneralTab,
	                shouldNotUpdate: shouldNotUpdateChildren })
	        };
	    },
	    _getCombinedChange: function _getCombinedChange(state, title, isBHAllowed, isFVAllowed, isBTAllowed) {
	        var isNewModal = state.isNewModal,
	            order = state.order,
	            isFermenterTankClicked = state.isFermenterTankClicked,
	            orderDateClicked = state.orderDateClicked,
	            tankType = state.tankType,
	            openGeneralTab = state.openGeneralTab,
	            shouldNotUpdateChildren = state.shouldNotUpdateChildren,
	            tankClicked = state.tankClicked;
	
	        return {
	            title: title,
	            refName: 'dashboardModalChild',
	            el: React.createElement(DashboardModalBrewChange, {
	                ref: "dashboardModalChild",
	                isSingleMode: isNewModal,
	                isBHAllowed: isBHAllowed,
	                isBTAllowed: isBTAllowed,
	                isFVAllowed: isFVAllowed,
	                tankTypeClicked: tankType,
	                isFermenterTankClicked: isFermenterTankClicked,
	                orderDateClicked: orderDateClicked,
	                order: order,
	                tankClicked: tankClicked,
	                onActiveFirstTab: this._onChangeTab,
	                openGeneralTab: openGeneralTab,
	                shouldNotUpdate: shouldNotUpdateChildren })
	        };
	    },
	    _getCombinedNewFromBrewHouse: function _getCombinedNewFromBrewHouse(state) {
	        return this._getCombinedNew(state);
	    },
	    _getCombinedChangeFromBrewhouse: function _getCombinedChangeFromBrewhouse(state) {
	        return this._getCombinedChange(state);
	    },
	    _onToggle: function _onToggle(name) {
	        var _this7 = this;
	
	        var toggleConditional = 'is' + name + 'Allowed';
	        var order = this.state.order;
	
	        var toggleConditions = [];
	        var newStateToggle = !this.state[toggleConditional];
	        toggleConditions.push({ name: 'isBHAllowed', state: this.state.isBHAllowed });
	        toggleConditions.push({ name: 'isBTAllowed', state: this.state.isBTAllowed });
	        toggleConditions.push({ name: 'isFVAllowed', state: this.state.isFVAllowed });
	
	        toggleConditions = _.filter(toggleConditions, function (toggle) {
	            return toggle.name !== toggleConditional;
	        });
	        toggleConditions.push({ name: toggleConditional, state: newStateToggle });
	
	        if (_.every(toggleConditions, function (toggles) {
	            return !toggles.state;
	        })) {
	            // enter here means that all the toggles are off
	            this.close();
	            return;
	        }
	
	        if (order) {
	            var isCombinedOrder = _.get(_.find(toggleConditions, function (toggle) {
	                return toggle.name === 'isBTAllowed';
	            }), 'state') && _.get(_.find(toggleConditions, function (toggle) {
	                return toggle.name === 'isFVAllowed';
	            }), 'state');
	            order.isSingle = !isCombinedOrder;
	
	            if (order.tankSelected && order.isSingle) {
	                order.singleTank = order.tankSelected;
	                order.tankSelected = null;
	            }
	        }
	
	        this.setState(function (prevState) {
	            var _ref;
	
	            return _ref = {}, _ref[toggleConditional] = !prevState[toggleConditional], _ref.order = order, _ref;
	        }, function () {
	            DashboardActionCreator.changeToggle(toggleConditional, _this7.state.isBHAllowed, _this7.state.isFVAllowed, _this7.state.isBTAllowed);
	        });
	    },
	    _onChangeStore: function _onChangeStore() {},
	    _onChangeBatchNumber: function _onChangeBatchNumber() {
	        AppDispatcher.dispatch({
	            type: ActionTypes.DASHBOARD_MODAL_CHANGE_NUMBER,
	            order: this.state.order,
	            volume: this.refs.dashboardModalChild.state.orderVolume, // take the last order volume defined
	            batchNumber: this._ref.batchNumber.getValue(),
	            isSingle: !(this.state.isFVAllowed && this.state.isBTAllowed)
	        });
	    },
	    _onChangeTab: function _onChangeTab() /*index*/{
	        //this.setState({
	        //    currentTabSelected: _.get(index, 'props.tabIndex')
	        //});
	    },
	    _getModal: function _getModal(state) {
	        var modalKey = getToggleKey(state);
	        switch (modalKey) {
	            case TOGGLE_BT:
	                // single
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('packaging'), 'BT', t('packaging'), false, false, true) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('packaging'), 'BT', t('packaging'), false, false, true);
	            case TOGGLE_FV:
	                // single
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('fermenting'), 'FV', t('fermenting'), false, true, false) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('fermenting'), 'FV', t('fermenting'), false, true, false);
	            case TOGGLE_BH:
	                // single
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing'), 'BH', t('brewing'), true, false, false) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing'), 'BH', t('brewing'), true, false, false);
	            // All order with brewhouse  ------------------------
	            case TOGGLE_BH_FV:
	                // single c/ BH  with tab open in FV
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing') + '-' + t('fermenting'), 'FV', t('fermenting'), true, true, false) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing') + '-' + t('fermenting'), 'FV', t('fermenting'), true, true, false);
	            case TOGGLE_BH_BT:
	                // single c/ BH with tab open in BT
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing') + '-' + t('packaging'), 'BT', t('packaging'), true, false, true) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing') + '-' + t('packaging'), 'BT', t('packaging'), true, false, true);
	            case TOGGLE_BH_FV_BH:
	                // single c/ BH with open in BH
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing') + '-' + t('fermenting'), 'BH', t('fermenting'), true, true, false) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing') + '-' + t('fermenting'), 'BH', t('fermenting'), true, true, false);
	            case TOGGLE_BH_BT_BH:
	                // single c/ BH with open in BH
	                return state.isNewModal ? this._getSingleNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing') + '-' + t('packaging'), 'BH', t('packaging'), true, false, true) : this._getSingleChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing') + '-' + t('packaging'), 'BH', t('packaging'), true, false, true);
	            // all order without brewhouse ------------------------
	            case TOGGLE_FV_BT:
	                // combined s/ BH
	                return state.isNewModal ? this._getCombinedNew(state, t('dashboard_modal_title_new') + ' ' + t('fermenting') + '-' + t('packaging'), false, true, true) : this._getCombinedChange(state, t('dashboard_modal_title_edit') + ' ' + t('fermenting') + '-' + t('packaging'), false, true, true);
	            case TOGGLE_BH_FV_BT:
	                // combined c/ BH
	                return state.isNewModal ? this._getCombinedNew(state, t('dashboard_modal_title_new') + ' ' + t('brewing') + '-' + t('fermenting') + '-' + t('packaging'), true, true, true) : this._getCombinedChange(state, t('dashboard_modal_title_edit') + ' ' + t('brewing') + '-' + t('fermenting') + '-' + t('packaging'), true, true, true);
	            default:
	        }
	    },
	    _onToggleBH: function _onToggleBH() {
	        return this._onToggle('BH');
	    },
	    _onToggleFV: function _onToggleFV() {
	        return this._onToggle('FV');
	    },
	    _onToggleBT: function _onToggleBT() {
	        return this._onToggle('BT');
	    },
	    disableToggles: function disableToggles(callback) {
	        this._ref.toggleBH.setDisabled(true);
	        this._ref.toggleFV.setDisabled(true);
	        this._ref.toggleBT.setDisabled(true);
	        if (callback) {
	            callback();
	        }
	    },
	    enableToggles: function enableToggles(callback) {
	        this._ref.toggleBH.setDisabled(false);
	        this._ref.toggleFV.setDisabled(false);
	        this._ref.toggleBT.setDisabled(false);
	        if (callback) {
	            callback();
	        }
	    },
	    _setModal: function _setModal(_el) {
	        this.modalOrder = _el;
	    },
	    _nonAbleToChangeToggles: function _nonAbleToChangeToggles() {
	        if (!this.state.isBHAllowed || !this.state.isFVAllowed || !this.state.isBTAllowed) {
	            Notification.show(t('dashboard_notification_modal_section_must_be_choosen_before_beer_style'), 'error');
	        }
	    },
	    render: function render() {
	        var _this8 = this;
	
	        var _state = this.state,
	            isNewModal = _state.isNewModal,
	            isOpen = _state.isOpen,
	            currencyInfo = _state.currencyInfo;
	
	
	        if (!isOpen) {
	            return EMPTY_ELEMENT;
	        }
	
	        var modal = this._getModal(this.state);
	        if (!modal) {
	            // some cases enter here when hit in close button
	            return null;
	        }
	        var dashboardModalEl = modal.el;
	        var modalTitle = modal.title;
	
	        if (modal.currentSection !== 'BH') {
	            toggleStyle.display = 'initial';
	        }
	
	        var batchNumberLabelStyle = {
	            color: this.state.packagingVolume !== this.state.fermentingVolume ? 'orange' : '#B3B3B3'
	        };
	
	        var isEditable = SessionStore.isAdminUser();
	
	        var actions = [React.createElement("div", { style: {
	                display: this.state.isNewModal ? 'inline-block' : 'none',
	                top: '15px',
	                position: 'relative',
	                float: 'left',
	                marginLeft: '-6px'
	            } }, React.createElement(Toggle, {
	            style: toggleStyle,
	            ref: function ref(input) {
	                return _this8._ref.toggleBH = input;
	            },
	            name: "toggleBH",
	            label: t('label_brewing'),
	            labelStyle: labelStyle(this.state.forceDisableToggle),
	            defaultToggled: this.state.isBHAllowed,
	            defaultValue: this.state.isBHAllowed,
	            onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleBH,
	            disabled: this.state.forceDisableToggle }), React.createElement(Toggle, {
	            style: toggleStyle,
	            ref: function ref(input) {
	                return _this8._ref.toggleFV = input;
	            },
	            name: "toggleFV",
	            label: t('label_fermenting'),
	            labelStyle: labelStyle(this.state.forceDisableToggle),
	            defaultToggled: this.state.isFVAllowed,
	            defaultValue: this.state.isFVAllowed,
	            onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleFV,
	            disabled: this.state.forceDisableToggle }), React.createElement(Toggle, {
	            style: toggleStyle,
	            ref: function ref(input) {
	                return _this8._ref.toggleBT = input;
	            },
	            name: "toggleBT",
	            label: t('label_packaging'),
	            labelStyle: labelStyle(this.state.forceDisableToggle),
	            defaultToggled: this.state.isBTAllowed,
	            defaultValue: this.state.isBTAllowed,
	            onToggle: this.state.forceDisableToggle ? this._nonAbleToChangeToggles : this._onToggleBT,
	            disabled: this.state.forceDisableToggle })), React.createElement("div", { className: "dashboard-modal-content__label-batch-number", style: {
	                paddingLeft: this.state.isNewModal ? '20px' : '0'
	            } }, React.createElement(TextField, {
	            ref: function ref(input) {
	                return _this8._ref.batchNumber = input;
	            },
	            floatingLabelText: t('dashboard_modal_footer_batch_number'),
	            multiLine: false,
	            onBlur: this._onChangeBatchNumber,
	            defaultValue: _.get(this.state, 'batchNumber', ''),
	            style: { width: '110%' },
	            disabled: !isEditable
	        })), React.createElement("div", { style: {
	                top: '-23px',
	                position: 'relative',
	                height: '75px',
	                float: 'left',
	                paddingLeft: this.state.isNewModal ? '20px' : '0',
	                minWidth: '100px'
	            } }, React.createElement(TextField, {
	            ref: function ref(input) {
	                return _this8._ref.batchTotalVolume = input;
	            },
	            floatingLabelText: t('dashboard_modal_footer_batch_volume'),
	            multiLine: false,
	            defaultValue: _.get(this.state, 'totalBatchVolume', ''),
	            errorStyle: batchNumberLabelStyle,
	            style: { width: '100%', textAlign: 'left' },
	            disabled: true
	        })), React.createElement("div", { style: {
	                top: '-23px',
	                position: 'relative',
	                height: '75px',
	                float: 'left',
	                paddingLeft: this.state.isNewModal ? '20px' : '0',
	                minWidth: '100px',
	                display: isNewModal ? 'none' : 'initial'
	            } }, React.createElement(TextField, {
	            ref: function ref(input) {
	                return _this8._ref.totalBatchCost = input;
	            },
	            floatingLabelText: t('dashboard_modal_footer_batch_cost'),
	            multiLine: false,
	            defaultValue: _.get(currencyInfo, 'symbol') + ' ' + _.get(this.state, 'totalBatchCost', ''),
	            errorStyle: batchNumberLabelStyle,
	            style: { width: '100%', textAlign: 'left' },
	            disabled: true
	        })), React.createElement(FlatButton, {
	            label: t('button_label_cancel'),
	            className: "dashboard-modal-content__button-cancel",
	            secondary: true,
	            onTouchTap: this.close,
	            "data-button": "cancel"
	        }), React.createElement(FlatButton, {
	            style: { 'display': isEditable ? 'inline' : 'none' },
	            label: t('button_label_save'),
	            className: "dashboard-modal-content__button-save",
	            primary: true,
	            onTouchTap: this._saveAndClose,
	            "data-button": "save"
	        })];
	
	        if (!isNewModal) {
	            if (modal.currentSection === 'BH') {
	                // enter here means is a single change dialog from brewing section, so is not need to show the toggle BH because, singles
	                // from brewing section can't have any batch.
	                toggleStyle.display = 'none';
	            }
	            if (SessionStore.hasAdminUserPermission() || SessionStore.isAbleToEditDates()) {
	                actions.splice(3, 0, React.createElement(FlatButton, {
	                    style: { 'display': isEditable ? 'inline' : 'none' },
	                    label: t('button_label_remove'),
	                    className: "dashboard-modal-content__button-remove",
	                    primary: true,
	                    onTouchTap: this._removeAndClose
	                }));
	            }
	        }
	
	        return React.createElement("div", { className: "modal-order" }, React.createElement(Dialog, {
	            ref: this._setModal,
	            title: modalTitle,
	            actions: actions,
	            actionFocus: "submit",
	            hideToolbarYearChange: false,
	            autoScrollBodyContent: true,
	            autoDetectWindowHeight: true,
	            modal: true,
	            contentStyle: { minHeight: '420px !important', height: '420px', top: '-80px' },
	            contentClassName: "dashboard-modal-content"
	        }, dashboardModalEl));
	    }
	});
	
	/**
	 * Calculate the type of Dialog is and retrieve the key that allow to be created.
	 * @param state
	 * @return {Object} current state context of modal.
	 */
	function getToggleKey(state) {
	    var modalKey = 'TOGGLE';
	
	    if (_.get(state, 'isBHAllowed')) {
	        modalKey += '_BH';
	    }
	
	    if (_.get(state, 'isFVAllowed')) {
	        modalKey += '_FV';
	    }
	
	    if (_.get(state, 'isBTAllowed')) {
	        modalKey += '_BT';
	    }
	
	    return modalKey;
	}
	
	function _getToggleState(order) {
	    var toggleState = {
	        isBHAllowed: false,
	        isFVAllowed: false,
	        isBTAllowed: false
	    };
	    if (order && order.isSingle) {
	        var tankType = _.get(order, 'singleTank.type');
	        if (tankType === 'BH' || _.get(order.batchs, 'length') > 0) {
	            toggleState.isBHAllowed = true;
	        }
	        if (tankType === 'FV') {
	            toggleState.isFVAllowed = true;
	        } else if (tankType === 'BT') {
	            toggleState.isBTAllowed = true;
	        }
	    } else {
	        if (_.get(order.batchs, 'length') > 0) {
	            toggleState.isBHAllowed = true;
	        }
	        toggleState.isFVAllowed = true;
	        toggleState.isBTAllowed = true;
	    }
	
	    return toggleState;
	}
	
	module.exports = DashboardModal;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(5),
	    merge = _require2.merge,
	    _require3 = __webpack_require__(4),
	    t = _require3.t,
	    _require4 = __webpack_require__(37),
	    delay = _require4.delay,
	    Notification = __webpack_require__(21),
	    get = __webpack_require__(5).get,
	    OrderUtils = __webpack_require__(49),
	    _require5 = __webpack_require__(53),
	    cloneDeep = _require5.cloneDeep,
	    AppDispatcher = __webpack_require__(42),
	    DashboardServiceCache = __webpack_require__(28),
	    ContentUtils = __webpack_require__(7),
	    _require6 = __webpack_require__(50),
	    formatTasksProducts = _require6.formatTasksProducts,
	    getIndexTab = _require6.getIndexTab,
	    removeDefaultTaskWhenExistCustom = _require6.removeDefaultTaskWhenExistCustom,
	    changeLabelName = _require6.changeLabelName,
	    changeLabelNote = _require6.changeLabelNote,
	    getTasksFromProcess = _require6.getTasksFromProcess,
	    updateTask = _require6.updateTask,
	    actions = __webpack_require__(2).Analytics.actions,
	    ga = __webpack_require__(18),
	    _require7 = __webpack_require__(182),
	    onChangeBrewDate = _require7.onChangeBrewDate,
	    onChangeFiltrationDate = _require7.onChangeFiltrationDate,
	    onChangePackagingDate = _require7.onChangePackagingDate,
	    onChangeBeerStyle = _require7.onChangeBeerStyle,
	    onChangeBriteTank = _require7.onChangeBriteTank,
	    onChangeFermenterTank = _require7.onChangeFermenterTank,
	    onChangeTask = _require7.onChangeTask,
	    onChangeProcess = _require7.onChangeProcess,
	    getExistingModalState = _require7.getExistingModalState,
	    onChangeTaskType = _require7.onChangeTaskType,
	    onDeleteTask = _require7.onDeleteTask,
	    _isValidForm = _require7.isValidForm,
	    onChangeVolume = _require7.onChangeVolume,
	    cleanModal = _require7.cleanModal,
	    onChangeBrewTurnNew = _require7.onChangeBrewTurnNew,
	    initializeBrewingTurns = _require7.initializeBrewingTurns,
	    initializeFermentingTask = _require7.initializeFermentingTask,
	    initializePackagingTask = _require7.initializePackagingTask,
	    formatBatchs = _require7.formatBatchs,
	    someProductAlreadyConfirmed = _require7.someProductAlreadyConfirmed,
	    onChangeBrewTurn = _require7.onChangeBrewTurn,
	    updateStateTask = _require7.updateStateTask,
	    InventoryStore = __webpack_require__(20),
	    DateUtils = __webpack_require__(22),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    OrderStore = __webpack_require__(72),
	    SessionStore = __webpack_require__(11),
	    DashboardModalBrewBody = __webpack_require__(401),
	    categories = __webpack_require__(2).Analytics.categories,
	    _require8 = __webpack_require__(2),
	    TIME_WAIT_MODAL_EXPAND = _require8.TIME_WAIT_MODAL_EXPAND,
	    _require9 = __webpack_require__(12),
	    Tab = _require9.Tab,
	    Tabs = _require9.Tabs;
	
	
	var ModalDashboardBrewChange = React.createClass({ displayName: "ModalDashboardBrewChange",
	
	    propTypes: {
	        isSingleMode: PropTypes.boolean,
	        openGeneralTab: PropTypes.boolean,
	        onToggleSingleMode: PropTypes.function,
	        onActiveFirstTab: PropTypes.function,
	        onChangeBatchVolumeLeft: PropTypes.function,
	        tankTypeClicked: PropTypes.string,
	        tankSelected: PropTypes.object,
	        tankClicked: PropTypes.object
	    },
	
	    /**
	     * This obj need it in order to the childs register their refs components,
	     * And can use them from here to make validation stuffs (the parent).
	     */
	    _refs: {
	        brewDate: null,
	        beerStyle: null,
	        briteTank: null,
	        commentOrder: null,
	        filtrationDate: null,
	        fermenterTank: null,
	        orderDate: null
	    },
	
	    componentWillMount: function componentWillMount() {
	        var _props = this.props,
	            order = _props.order,
	            orderDateClicked = _props.orderDateClicked,
	            isFermenterTankClicked = _props.isFermenterTankClicked,
	            tankTypeClicked = _props.tankTypeClicked,
	            isBHAllowed = _props.isBHAllowed;
	
	        var nextState = getExistingModalState(order, orderDateClicked, isFermenterTankClicked, tankTypeClicked, isBHAllowed);
	
	        this.setState(nextState);
	
	        // set temporary to find after update estimation inventory in each task
	        this.orderId = get(order, 'id');
	
	        // save the order safely to non change at dashboard level anything
	        this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var orderDateClicked = nextProps.orderDateClicked,
	            isFermenterTankClicked = nextProps.isFermenterTankClicked,
	            tankTypeClicked = nextProps.tankTypeClicked,
	            isBHAllowed = nextProps.isBHAllowed;
	
	
	        var nextState = getExistingModalState(this.state, orderDateClicked, isFermenterTankClicked, tankTypeClicked, isBHAllowed);
	
	        this.setState(nextState);
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isBeerStyleAlreadyDefined: true
	        };
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.orderId = null;
	        this.ordersCloned = null;
	    },
	    componentDidMount: function componentDidMount() {
	        this.refs.refTabs.setState({
	            // fix the bug when click on packaging side it does not open the packaging tab
	            selectedIndex: getIndexTab(this.props)
	        });
	    },
	    triggerValidation: function triggerValidation(nextState) {
	        return this.isValidForm(nextState).messagesError;
	    },
	
	
	    /**
	     * This method will execute all validation needed for this form.
	     *
	     * @param nextState
	     * @public
	     * @returns {*}
	     */
	    isValidForm: function isValidForm(nextState) {
	        return _isValidForm(nextState || this.state, this._refs);
	    },
	
	
	    /**
	     * This method will add new brew order.
	     * @param afterSubmit
	     */
	    submit: function submit(parentRefs, afterSubmit) {
	        var _this = this;
	
	        var isValidResult = this.isValidForm();
	        if (isValidResult && !isValidResult.isValid) {
	            this.setState(isValidResult.messagesError, function () {
	                if (_this.refs.refTabs) {
	                    _this.refs.refTabs.setState({
	                        selectedIndex: 0
	                    });
	                }
	            });
	            return;
	        }
	
	        var order = this.state.order || {};
	        order.applicant = SessionStore.getCurrentApplicant();
	        order.styleBeerId = this.state.styleBeerSelected.id;
	        order.briteTankId = this.state.briteTankSelected.tankObj.id;
	        order.fermenterTankId = this.state.fermenterTankSelected.tankObj.id;
	        order.batchNumber = parentRefs.batchNumber.getValue();
	        order.styleBeer = this.state.styleBeerSelected;
	        order.briteTank = this.state.briteTankSelected.tankObj;
	        order.fermenterTank = this.state.fermenterTankSelected.tankObj;
	        order.orderDate = DateUtils.toDateText(this.state.orderDate);
	        order.brewDate = DateUtils.toDateText(this.state.brewDate);
	        order.filtrationDate = DateUtils.toDateText(this.state.filtrationDate);
	        order.comment = this.state.commentOrder;
	        order.volume = ContentUtils.getNumber(this.state.orderVolume);
	
	        order.fermenterTasks = ContentUtils.cleanAllTasksOfProducts(formatTasksProducts(removeDefaultTaskWhenExistCustom(this.state.fermenterTasks)));
	
	        order.packagingTasks = ContentUtils.cleanAllTasksOfProducts(formatTasksProducts(removeDefaultTaskWhenExistCustom(this.state.packagingTasks)));
	
	        var isBHAllowed = void 0;
	        var batchs = get(this.state, 'batchs');
	
	        if (get(batchs, 'length', 0) > 0) {
	            order.batchs = ContentUtils.cleanAllTasksOfProducts(formatTasksProducts(formatBatchs(batchs)));
	
	            isBHAllowed = true;
	        } else {
	            order.batchs = [];
	            isBHAllowed = false;
	        }
	
	        var onSucess = function onSucess() {
	            // on success
	            ga.event({
	                category: categories.ORDER,
	                action: actions.CHANGE,
	                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	
	            _this.clean();
	            afterSubmit();
	        };
	
	        var onFailure = function onFailure(errorMessage) {
	            return _this.setState({ volumenTankMessageError: errorMessage });
	        };
	
	        OrderStore.changeOrder(order, null, onSucess, onFailure, isBHAllowed);
	    },
	    clean: function clean() {
	        cleanModal(this);
	    },
	    _onChangeProcess: function _onChangeProcess(newProcessOrder) {
	        var tasks = getTasksFromProcess(newProcessOrder, this.state);
	        var result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
	        this.setState(result);
	    },
	    _onChangeAmountItem: function _onChangeAmountItem(productChanged, itemChanged, newAmount) {
	        itemChanged.amount = newAmount;
	        itemChanged.manualAmount = newAmount;
	        itemChanged.item.amount = newAmount;
	
	        // update the list of items from product
	        var items = get(productChanged, 'items');
	        var itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
	        productChanged.items = itemsChanged;
	
	        return productChanged;
	    },
	    _onChangeAmountInLocation: function _onChangeAmountInLocation(task, productUpdated) {
	        var avoidMultiplicateAmountItems = true;
	        this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
	    },
	    _onChangeProducts: function _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
	        var _this2 = this;
	
	        var taskType = get(task, 'sectionType');
	        var taskWithProductUpdated = void 0;
	
	        this.setState(function (prevState) {
	            var endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
	            var nextState = InventoryStore.onChangeProducts(_this2.ordersCloned, prevState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
	            taskWithProductUpdated = nextState.taskWithProductUpdated;
	            _this2.ordersCloned = nextState.ordersCloned;
	            nextState.taskWithProductUpdated = null;
	            nextState.ordersCloned = null; // not needed to put in set state context
	
	            return nextState;
	        }, function () {
	            // update combined ask before trigger action
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
	                newAmount: newAmount,
	                order: _this2.state.order,
	                batchNumber: _this2.state.batchNumber,
	                isSingle: false,
	                taskType: taskType,
	                taskUpdated: task,
	                taskWithProductUpdated: taskWithProductUpdated
	            });
	        });
	    },
	    _onChangeVolumeItem: function _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
	        this._onChangeProducts(product, product.amount, uniqueId, task);
	    },
	    _onChangeBrewDate: function _onChangeBrewDate(nill, brewDate) {
	        var _this3 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.brewDate, brewDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	        this.setState(function (prevState) {
	            var nextState = onChangeBrewDate(prevState, brewDate, _this3.props.isBHAllowed);
	            nextState = merge(nextState, _this3.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _onChangeOrderDate: function _onChangeOrderDate(nill, orderDate) {
	        var _this4 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.orderDate, orderDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	
	        this.setState(function (prevState) {
	            var nextState = onChangePackagingDate(prevState, orderDate, _this4.props.isBHAllowed);
	            nextState = merge(nextState, _this4.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _onChangeFiltrationDate: function _onChangeFiltrationDate(nill, filtrationDate) {
	        var _this5 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.filtrationDate, filtrationDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	
	        this.setState(function (prevState) {
	            var nextState = onChangeFiltrationDate(prevState, filtrationDate, _this5.props.isBHAllowed);
	            nextState = merge(nextState, _this5.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _onChangeBeerStyle: function _onChangeBeerStyle(evt) {
	        var _this6 = this;
	
	        var beerStyleSelected = merge(evt, evt.itemModel);
	        this.setState(function (prevState) {
	            var nextState = onChangeBeerStyle(prevState, beerStyleSelected, get(_this6.props, 'tankTypeClicked'), _this6.props.isBHAllowed);
	            nextState = merge(nextState, _this6.triggerValidation(nextState));
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
	                volume: _this6.state.orderVolume,
	                batchNumber: _this6.state.batchNumber,
	                order: _this6.state.order,
	                isSingle: false
	            });
	        });
	    },
	    _onChangeBriteTank: function _onChangeBriteTank(evt, index, menuItem) {
	        var _this7 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        this.setState(function (prevState) {
	            var nextState = onChangeBriteTank(prevState, menuItem, _this7.props.isBHAllowed);
	            nextState = merge(nextState, _this7.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _onChangeFermenterTank: function _onChangeFermenterTank(evt, index, menuItem) {
	        var _this8 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        this.setState(function (prevState) {
	            var nextState = onChangeFermenterTank(prevState, menuItem, _this8.props.isBHAllowed);
	            nextState = merge(nextState, _this8.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _onChangeVolume: function _onChangeVolume(evt) {
	        var _this9 = this;
	
	        var volume = get(evt, 'target.value');
	        this.setState(function (prevState) {
	            var nextState = onChangeVolume(prevState, volume, _this9.props.isBHAllowed);
	            nextState = merge(nextState, _this9.triggerValidation(nextState));
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
	                volume: volume,
	                batchNumber: _this9.state.batchNumber,
	                order: _this9.state.order,
	                isSingle: false
	            });
	        });
	    },
	    _onChangeComment: function _onChangeComment(evt) {
	        var commentOrder = get(evt, 'target.value');
	        this.setState({
	            commentOrder: commentOrder
	        });
	    },
	    _notifyToParentIfVolumeAlreadyChanged: function _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
	        if (prevState.orderVolume !== nextState.orderVolume) {
	            props.onChangeVolume(prevState, nextState);
	        }
	    },
	    _onDeleteTask: function _onDeleteTask(itemSelected, typeTask, dateTask) {
	        this.setState(function (prevState) {
	            var nextState = onDeleteTask(prevState.packagingTasks, prevState.fermenterTasks, typeTask, dateTask);
	            return nextState;
	        });
	    },
	    _onChangeTask: function _onChangeTask(itemSelected, typeTask, dateTask, field, evt) {
	        var targetValue = get(evt, 'target.value', '');
	        this.setState(function (prevState) {
	            var nextState = onChangeTask(targetValue, prevState.packagingTasks, prevState.fermenterTasks, typeTask, dateTask, field);
	            return nextState;
	        });
	    },
	    _onChangeTaskType: function _onChangeTaskType(oldItemSelected, typeTask, dateTask, itemSelected, evt) {
	        var _this10 = this;
	
	        if (typeTask === 'BH') {
	            this.setState(function (prevState) {
	                return onChangeBrewTurnNew(oldItemSelected, dateTask, 'batchs', prevState, get(itemSelected, 'turnId'), itemSelected, itemSelected);
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                    order: _this10.state.order
	                });
	            });
	        } else {
	            this.setState(function (prevState) {
	                return onChangeTaskType(oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected);
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                    order: _this10.state.order
	                });
	            });
	        }
	    },
	    _onChangeBrewingTaskType: function _onChangeBrewingTaskType(oldItemSelected, turnDate, fieldName, turnId, newMenuItemSelected) {
	        var _this11 = this;
	
	        var targetValue = get(newMenuItemSelected, 'payload');
	        this.setState(function (prevState) {
	            return onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, newMenuItemSelected);
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                order: _this11.state.order
	            });
	        });
	    },
	    _onChangeNote: function _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeName: function _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeCloseOrder: function _onChangeCloseOrder() {
	        this.setState(function (prevState) {
	            var order = get(prevState, 'order');
	            order.closed = !order.closed;
	            return {
	                order: order
	            };
	        });
	    },
	    _onConfirmProduct: function _onConfirmProduct(product, uniqueId, task) {
	        var _this12 = this;
	
	        // update the product instance of the task
	        product.isSaved = false;
	        this.setState(function (prevState) {
	            var result = InventoryStore.onConfirmProduct(prevState, product, task, _this12.ordersCloned, _this12.temporaryOrderId);
	            _this12.ordersCloned = result.ordersCloned;
	            result.ordersCloned = null;
	            result = someProductAlreadyConfirmed(prevState);
	            return result;
	        }, function () {
	            _this12._onChangeProducts(product, product.amount, uniqueId, task);
	        });
	    },
	    _onToggleExpand: function _onToggleExpand(existingTask) {
	        var _this13 = this;
	
	        delay(function () {
	            //console.log(this.state);
	            var hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(_this13.state, 'styleBeerSelected.id'));
	            _this13._updateExistingTask(hydratedTask);
	        }, TIME_WAIT_MODAL_EXPAND);
	    },
	    _updateExistingTask: function _updateExistingTask(updatedTask) {
	        if (SessionStore.isFullPaidVersion()) {
	            if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
	                this.setState(function (prevState) {
	                    prevState.batchs = updateTask(prevState.batchs, updatedTask);
	                    prevState.order.batchs = prevState.batchs;
	                    return prevState;
	                });
	            } else if (updatedTask.sectionType === 'FERMENTER_TASK') {
	                this.setState(function (prevState) {
	                    prevState.order.fermenterTasks = updateTask(prevState.order.fermenterTasks, updatedTask);
	                    prevState.fermenterTasks = prevState.order.fermenterTasks;
	                    return prevState;
	                });
	            } else {
	                this.setState(function (prevState) {
	                    prevState.order.packagingTasks = updateTask(prevState.order.packagingTasks, updatedTask);
	                    prevState.packagingTasks = prevState.order.packagingTasks;
	                    return prevState;
	                });
	            }
	        }
	    },
	    render: function render() {
	        var currentTabOpen = getIndexTab(this.props);
	        var fermentingTask = initializeFermentingTask(this);
	        var packagingTask = initializePackagingTask(this);
	
	        // default is empty list in order to still showing the Brewing Tab when the order don't have any assigned bach
	        var batchs = get(this.state, 'batchs');
	        var brewingTab = void 0,
	            tabsContent = void 0;
	
	        var bodyContent = React.createElement(DashboardModalBrewBody, {
	            onChangeCloseOrder: this._onChangeCloseOrder,
	            parentState: this.state,
	            onChangeBrewDate: this._onChangeBrewDate,
	            onChangeFiltrationDate: this._onChangeFiltrationDate,
	            onChangeOrderDate: this._onChangeOrderDate,
	            onChangeBeerStyle: this._onChangeBeerStyle,
	            onChangeBriteTank: this._onChangeBriteTank,
	            onChangeVolume: this._onChangeVolume,
	            onChangeComment: this._onChangeComment,
	            onChangeFermenterTank: this._onChangeFermenterTank,
	            refsSubscriber: this._refs });
	
	        if (!batchs) {
	            // enter here means that the order don't with brewhouse
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), React.createElement(Tab, { label: t('dashboard_modal_tab_fermenting') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, { label: t('dashboard_modal_tab_packaging') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	        } else if (get(batchs, 'length') === 0) {
	            // enter here means that the order work with brewhouse but don't have batch
	            brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("br", null), React.createElement("div", { className: "modal-order-task-list container-fluid text-center" }, React.createElement("h5", null, t('dashboard_modal_order_volume_zero')))));
	
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { label: t('dashboard_modal_tab_fermenting') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, { label: t('dashboard_modal_tab_packaging') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	        } else if (get(batchs, 'length') > 0) {
	
	            // fix same sorted orders
	            var brewingTasks = initializeBrewingTurns(batchs, this._onChangeBrewingTaskType, this._onChangeProcess, this._onChangeProducts, this._onChangeAmountItem, this._onChangeVolumeItem, this._onChangeAmountInLocation, this.state.dataClicked, this._onConfirmProduct, this);
	
	            brewingTab = React.createElement(Tab, { ref: "generalTab", onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, brewingTasks)));
	
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { label: t('dashboard_modal_tab_fermenting') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, { label: t('dashboard_modal_tab_packaging') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	        }
	
	        return tabsContent;
	    }
	});
	
	module.exports = ModalDashboardBrewChange;

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(5),
	    merge = _require.merge,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    moment = __webpack_require__(3),
	    Notification = __webpack_require__(21),
	    _require3 = __webpack_require__(1),
	    PropTypes = _require3.PropTypes,
	    _require4 = __webpack_require__(8),
	    find = _require4.find,
	    _require5 = __webpack_require__(53),
	    cloneDeep = _require5.cloneDeep,
	    _require6 = __webpack_require__(37),
	    delay = _require6.delay,
	    ContentUtils = __webpack_require__(7),
	    OrderUtils = __webpack_require__(49),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    _require7 = __webpack_require__(50),
	    formatTasksProducts = _require7.formatTasksProducts,
	    addProductOrderIdToTasks = _require7.addProductOrderIdToTasks,
	    removeDefaultTaskWhenExistCustom = _require7.removeDefaultTaskWhenExistCustom,
	    changeLabelName = _require7.changeLabelName,
	    changeLabelNote = _require7.changeLabelNote,
	    getTasksFromProcess = _require7.getTasksFromProcess,
	    updateTask = _require7.updateTask,
	    AppDispatcher = __webpack_require__(42),
	    actions = __webpack_require__(2).Analytics.actions,
	    ga = __webpack_require__(18),
	    _require8 = __webpack_require__(182),
	    onChangeBrewDate = _require8.onChangeBrewDate,
	    onChangeFiltrationDate = _require8.onChangeFiltrationDate,
	    onChangePackagingDate = _require8.onChangePackagingDate,
	    onChangeBeerStyle = _require8.onChangeBeerStyle,
	    onChangeBriteTank = _require8.onChangeBriteTank,
	    onChangeFermenterTank = _require8.onChangeFermenterTank,
	    getNewModalState = _require8.getNewModalState,
	    onChangeTaskType = _require8.onChangeTaskType,
	    onChangeTask = _require8.onChangeTask,
	    onDeleteTask = _require8.onDeleteTask,
	    onChangeBrewTurnNew = _require8.onChangeBrewTurnNew,
	    _isValidForm = _require8.isValidForm,
	    cleanModal = _require8.cleanModal,
	    onChangeVolumeNew = _require8.onChangeVolumeNew,
	    onChangeProcess = _require8.onChangeProcess,
	    initializePackagingTask = _require8.initializePackagingTask,
	    initializeFermentingTask = _require8.initializeFermentingTask,
	    initializeBrewingTurns = _require8.initializeBrewingTurns,
	    formatBatchs = _require8.formatBatchs,
	    someProductAlreadyConfirmed = _require8.someProductAlreadyConfirmed,
	    updateStateTask = _require8.updateStateTask,
	    InventoryStore = __webpack_require__(20),
	    DashboardServiceCache = __webpack_require__(28),
	    DateUtils = __webpack_require__(22),
	    OrderStore = __webpack_require__(72),
	    SessionStore = __webpack_require__(11),
	    DashboardModalBrewBody = __webpack_require__(401),
	    INDEX_FIRST_TAB = 0,
	    categories = __webpack_require__(2).Analytics.categories,
	    _require9 = __webpack_require__(2),
	    TIME_WAIT_MODAL_EXPAND = _require9.TIME_WAIT_MODAL_EXPAND,
	    _require10 = __webpack_require__(12),
	    Tab = _require10.Tab,
	    Tabs = _require10.Tabs;
	
	
	var ModalDashboardBrewNew = React.createClass({ displayName: "ModalDashboardBrewNew",
	  propTypes: {
	    isSingleMode: PropTypes.boolean,
	    isBHAllowed: PropTypes.boolean,
	    isFVAllowed: PropTypes.boolean,
	    isBTAllowed: PropTypes.boolean,
	    tankSelected: PropTypes.obj,
	    onActiveFirstTab: PropTypes.function
	  },
	
	  /**
	   * A temporary id which use to recognize the order before
	   * was created in order store.
	   */
	  temporaryOrderId: null,
	
	  /**
	   * Orders cloned to work safely with the temporary order.
	   */
	  ordersCloned: null,
	
	  /**
	   * This obj need it in order to the childs register their refs components,
	   * And can use them from here to make validation stuffs (the parent).
	   */
	  _refs: {
	    brewDate: null,
	    beerStyle: null,
	    briteTank: null,
	    commentOrder: null,
	    filtrationDate: null,
	    fermenterTank: null,
	    orderDate: null
	  },
	
	  triggerValidation: function triggerValidation(nextState) {
	    return this.isValidForm(nextState).messagesError;
	  },
	  componentWillMount: function componentWillMount() {
	    var _props = this.props,
	        isBHAllowed = _props.isBHAllowed,
	        isFVAllowed = _props.isFVAllowed,
	        isBTAllowed = _props.isBTAllowed;
	
	    var nextState = getNewModalState(this.props.order, isBHAllowed, isFVAllowed, isBTAllowed);
	
	    this.temporaryOrderId = get(nextState, 'order.id');
	
	    this.setState(nextState);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextState) {
	    var isBHAllowed = nextProps.isBHAllowed,
	        isFVAllowed = nextProps.isFVAllowed,
	        isBTAllowed = nextProps.isBTAllowed;
	
	    var computedNextState = getNewModalState(nextProps.order, isBHAllowed, isFVAllowed, isBTAllowed);
	
	    if (nextProps.shouldNotUpdate && !nextState.changeCamefromCurrentComponent) {
	      computedNextState.triggerNotUpdate = true;
	    } else {
	      computedNextState.triggerNotUpdate = false;
	    }
	
	    this.setState(computedNextState);
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    // always render unless we should declare manually should NOT be render.
	    var shouldRender = nextState.triggerNotUpdate ? false : true;
	    return shouldRender;
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.state.changeCamefromCurrentComponent = false;
	  },
	  getInitialState: function getInitialState() {
	    return {
	      isVolumeAlreadySuggested: false,
	      isBeerStyleAlreadyDefined: false,
	      triggerNotUpdate: false,
	      changeCamefromCurrentComponent: false,
	      isSomeProductAlreadyConfirmed: false,
	      isBrewingProductsLoaded: false,
	      isFermentingProductsLoaded: false,
	      isPackagingProductsLoaded: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    // set temporary to find after update estimation inventory in each task
	    this.temporaryOrderId = ContentUtils.getRandomId();
	    // save the order safely to non change at dashboard level anything
	    this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.temporaryOrderId = null;
	    this.ordersCloned = null;
	  },
	
	
	  /**
	   * This method will execute all validation needed for this form.
	   *
	   * @param nextState
	   * @public
	   * @returns {*}
	   */
	  isValidForm: function isValidForm(nextState) {
	    return _isValidForm(nextState || this.state, this._refs);
	  },
	
	
	  /**
	   * This method will add new brew order.
	   * @param afterSubmit
	   */
	  submit: function submit(parentRefs, afterSubmit) {
	    var _this = this;
	
	    var isValidResult = this.isValidForm();
	    if (isValidResult && !isValidResult.isValid) {
	      this.setState(isValidResult.messagesError, function () {
	        if (_this.refs.refTabs) {
	          _this.refs.refTabs.setState({
	            selectedIndex: 0
	          });
	        }
	      });
	      return;
	    }
	
	    var order = {};
	    order.applicant = SessionStore.getCurrentApplicant();
	    order.dateCreated = moment().format(); // it's needed to calculate properly batch number
	    order.styleBeerId = this.state.styleBeerSelected.id;
	    order.briteTankId = this.state.briteTankSelected.tankObj.id;
	    order.fermenterTankId = this.state.fermenterTankSelected.tankObj.id;
	    order.styleBeer = this.state.styleBeerSelected;
	    order.batchNumber = parentRefs.batchNumber.getValue();
	    order.briteTank = this.state.briteTankSelected.tankObj;
	    order.fermenterTank = this.state.fermenterTankSelected.tankObj;
	    order.orderDate = DateUtils.toDateText(this.state.orderDate);
	    order.brewDate = DateUtils.toDateText(this.state.brewDate);
	    order.filtrationDate = DateUtils.toDateText(this.state.filtrationDate);
	    order.comment = this.state.commentOrder;
	    order.volume = ContentUtils.getNumber(this.state.orderVolume);
	    order.fermenterTasks = ContentUtils.cleanAllTasksOfProducts(addProductOrderIdToTasks(formatTasksProducts(removeDefaultTaskWhenExistCustom(this.state.fermenterTasks))));
	    order.packagingTasks = ContentUtils.cleanAllTasksOfProducts(addProductOrderIdToTasks(formatTasksProducts(removeDefaultTaskWhenExistCustom(this.state.packagingTasks))));
	
	    var batchs = ContentUtils.cleanAllTasksOfProducts(get(this.state, 'order.batchs'));
	
	    var isBHAllowed = void 0;
	
	    if (get(batchs, 'length', 0) > 0) {
	      order.batchs = addProductOrderIdToTasks(formatTasksProducts(formatBatchs(batchs)));
	      isBHAllowed = true;
	    } else {
	      order.batchs = [];
	      isBHAllowed = false;
	    }
	
	    var onSuccess = function onSuccess() {
	      // on success
	      ga.event({
	        category: categories.ORDER,
	        action: actions.NEW,
	        label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	      });
	      _this.clean();
	      afterSubmit();
	    };
	
	    var onFailure = function onFailure(errorMessage) {
	      return _this.setState({ volumenTankMessageError: errorMessage });
	    };
	
	    OrderStore.addOrder(order, onSuccess, onFailure, isBHAllowed);
	  },
	  clean: function clean() {
	    cleanModal(this);
	  },
	  _onChangeBrewDate: function _onChangeBrewDate(_, brewDate) {
	    var _this2 = this;
	
	    if (!SessionStore.isAbleToEditDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.brewDate, brewDate)) {
	      Notification.show(t('notification_unconfirm_product_and_try_again'));
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var nextState = onChangeBrewDate(prevState, brewDate, _this2.props.isBHAllowed);
	      nextState = merge(nextState, _this2.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeOrderDate: function _onChangeOrderDate(nill, orderDate) {
	    var _this3 = this;
	
	    if (!SessionStore.isAbleToEditDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.orderDate, orderDate)) {
	      Notification.show(t('notification_unconfirm_product_and_try_again'));
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var nextState = onChangePackagingDate(prevState, orderDate, _this3.props.isBHAllowed);
	      nextState = merge(nextState, _this3.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeFiltrationDate: function _onChangeFiltrationDate(nill, filtrationDate) {
	    var _this4 = this;
	
	    if (!SessionStore.isAbleToEditDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.filtrationDate, filtrationDate)) {
	      Notification.show(t('notification_unconfirm_product_and_try_again'));
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var nextState = onChangeFiltrationDate(prevState, filtrationDate, _this4.props.isBHAllowed);
	      nextState = merge(nextState, _this4.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeBeerStyle: function _onChangeBeerStyle(evt) {
	    var _this5 = this;
	
	    var self = this;
	    var beerStyleSelected = merge(evt, evt.itemModel);
	    this.setState(function (prevState) {
	      // clean batch if style change to clear products
	      prevState.order.batchs && (prevState.order.batchs = []);
	      var nextState = onChangeBeerStyle(prevState, beerStyleSelected, get(self.props, 'tankSelected.type', get(self.props, 'tankTypeClicked')), self.props.isBHAllowed);
	      nextState = merge(nextState, self.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	
	      // set the id of the draft order to be consistent
	      var oldOrder = find(self.ordersCloned, function (orderFind) {
	        return orderFind.id === self.temporaryOrderId;
	      });
	      nextState.order.id = self.temporaryOrderId;
	      if (oldOrder) {
	        oldOrder.id = self.temporaryOrderId;
	      }
	
	      // auto populate each product given the volume of the order
	      _this5.ordersCloned = ContentUtils.replaceByAttributes(self.ordersCloned, nextState.order, 'id');
	
	      nextState.isBeerStyleAlreadyDefined = true;
	      return nextState;
	    }, function () {
	      AppDispatcher.dispatch({
	        type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
	        volume: _this5.state.orderVolume,
	        batchNumber: _this5.state.batchNumber,
	        order: null,
	        isSingle: false
	      });
	    });
	  },
	  _onChangeBriteTank: function _onChangeBriteTank(evt, index, menuItem) {
	    var _this6 = this;
	
	    if (!SessionStore.isAbleToEditDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    this.setState(function (prevState) {
	      var nextState = onChangeBriteTank(prevState, menuItem, _this6.props.isBHAllowed);
	      nextState = merge(nextState, _this6.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeFermenterTank: function _onChangeFermenterTank(evt, index, menuItem) {
	    var _this7 = this;
	
	    if (!SessionStore.isAbleToEditDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    this.setState(function (prevState) {
	      var nextState = onChangeFermenterTank(prevState, menuItem, _this7.props.isBHAllowed);
	      nextState = merge(nextState, _this7.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onDeleteTask: function _onDeleteTask(itemSelected, typeTask, dateTask) {
	    this.setState(function (prevState) {
	      var nextState = onDeleteTask(prevState.packagingTasks, prevState.fermenterTasks, typeTask, dateTask);
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeVolume: function _onChangeVolume(evt) {
	    var _this8 = this;
	
	    var volume = get(evt, 'target.value');
	    this.setState(function (prevState) {
	      var nextState = onChangeVolumeNew(prevState, volume, _this8.props.isBHAllowed);
	      nextState = merge(nextState, _this8.triggerValidation(nextState));
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    }, function () {
	      AppDispatcher.dispatch({
	        type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
	        volume: _this8.state.orderVolume,
	        batchNumber: _this8.state.batchNumber,
	        order: null,
	        isSingle: false
	      });
	    });
	  },
	  _onChangeComment: function _onChangeComment(evt) {
	    var commentOrder = get(evt, 'target.value');
	    this.setState({
	      commentOrder: commentOrder
	    });
	  },
	  _onChangeTask: function _onChangeTask(itemSelected, typeTask, dateTask, field, evt) {
	
	    if (!SessionStore.isAbleToEditAllWithoutDates()) {
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    var targetValue = get(evt, 'target.value', '');
	    this.setState(function (prevState) {
	      var nextState = onChangeTask(targetValue, prevState.packagingTasks, prevState.fermenterTasks, typeTask, dateTask, field);
	      return nextState;
	    });
	  },
	  _onChangeAmountItem: function _onChangeAmountItem(productChanged, itemChanged, newAmount) {
	    itemChanged.amount = newAmount;
	    itemChanged.manualAmount = newAmount;
	    itemChanged.item.amount = newAmount;
	
	    // update the list of items from product
	    var items = get(productChanged, 'items');
	    var itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
	    productChanged.items = itemsChanged;
	    productChanged = InventoryStore.onChangeProductByAmount(productChanged, newAmount);
	    return productChanged;
	  },
	  _onChangeProducts: function _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
	    var _this9 = this;
	
	    var taskWithProductUpdated = void 0;
	    this.setState(function (prevState) {
	      var endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
	      var nextState = InventoryStore.onChangeProducts(_this9.ordersCloned, prevState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
	
	      taskWithProductUpdated = nextState.taskWithProductUpdated;
	      _this9.ordersCloned = nextState.ordersCloned;
	      nextState.taskWithProductUpdated = null;
	      return nextState;
	    }, function () {
	      AppDispatcher.dispatch({
	        type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
	        newAmount: newAmount,
	        order: _this9.state.order,
	        batchNumber: _this9.state.batchNumber,
	        isSingle: false,
	        taskUpdated: task,
	        taskWithProductUpdated: taskWithProductUpdated
	      });
	    });
	  },
	  _onChangeVolumeItem: function _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
	    this._onChangeProducts(product, product.amount, uniqueId, task);
	  },
	  _onChangeProductsNonUpdated: function _onChangeProductsNonUpdated(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
	    var endDateOrder = OrderUtils.getEndDateOrder(get(this.state, 'order'));
	    return InventoryStore.onChangeProducts(this.ordersCloned, this.state, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
	  },
	  _onChangeTaskType: function _onChangeTaskType(oldItemSelected, typeTask, dateTask, itemSelected, evt) {
	    this.setState(function (prevState) {
	      var nextState = void 0;
	
	      if (typeTask === 'BH') {
	        nextState = onChangeBrewTurnNew(oldItemSelected, dateTask, 'batchs', prevState, itemSelected.turnId, evt.target.value, itemSelected);
	      } else {
	        nextState = onChangeTaskType(oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected);
	      }
	
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeBrewingTaskType: function _onChangeBrewingTaskType(oldItemSelected, turnDate, fieldName, turnId, newItemSelected) {
	
	    var targetValue = get(newItemSelected, 'payload');
	    this.setState(function (prevState) {
	      var nextState = onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, newItemSelected);
	      nextState.changeCamefromCurrentComponent = true;
	      return nextState;
	    });
	  },
	  _onChangeNote: function _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
	    var targetValue = get(evt, 'target.value');
	    var itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
	    this.setState(updateStateTask(this.state, itemSelectedUpdated));
	  },
	  _onChangeName: function _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
	    var targetValue = get(evt, 'target.value');
	    var itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
	    this.setState(updateStateTask(this.state, itemSelectedUpdated));
	  },
	  _onChangeProcess: function _onChangeProcess(newProcessOrder) {
	    var tasks = getTasksFromProcess(newProcessOrder, this.state);
	    var result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
	    result.changeCamefromCurrentComponent = true;
	    this.setState(result);
	  },
	  _notifyToParentIfVolumeAlreadyChanged: function _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
	    if (prevState.orderVolume !== nextState.orderVolume) {
	      props.onChangeVolume(prevState, nextState);
	    }
	  },
	  _onChangeAmountInLocation: function _onChangeAmountInLocation(task, productUpdated) {
	    var avoidMultiplicateAmountItems = true;
	    this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
	  },
	  _onChangeCloseOrder: function _onChangeCloseOrder() {
	    this.setState(function (prevState) {
	      var order = get(prevState, 'order');
	      order.closed = !order.closed;
	      return {
	        order: order
	      };
	    });
	  },
	  _onConfirmProduct: function _onConfirmProduct(product, uniqueId, task) {
	    var _this10 = this;
	
	    this.setState(function (prevState) {
	      var result = InventoryStore.onConfirmProduct(prevState, product, task, _this10.ordersCloned, _this10.temporaryOrderId);
	      _this10.ordersCloned = result.ordersCloned;
	      result.ordersCloned = null;
	      result = someProductAlreadyConfirmed(prevState);
	      return result;
	    }, function () {
	      _this10._onChangeProducts(product, product.amount, uniqueId, task);
	    });
	  },
	  _onToggleExpand: function _onToggleExpand(existingTask) {
	    var _this11 = this;
	
	    delay(function () {
	      var hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(_this11.state, 'styleBeerSelected.id'));
	      _this11._updateExistingTask(hydratedTask);
	    }, TIME_WAIT_MODAL_EXPAND);
	  },
	  _updateExistingTask: function _updateExistingTask(updatedTask) {
	    if (SessionStore.isFullPaidVersion()) {
	      if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
	        this.setState(function (prevState) {
	          prevState.order.batchs = updateTask(prevState.batchs, updatedTask);
	          prevState.batchs = prevState.order.batchs;
	          return prevState;
	        });
	      } else if (updatedTask.sectionType === 'FERMENTER_TASK') {
	        this.setState(function (prevState) {
	          prevState.order.fermenterTasks = updateTask(prevState.order.fermenterTasks, updatedTask);
	          prevState.fermenterTasks = prevState.order.fermenterTasks;
	          return prevState;
	        });
	      } else {
	        this.setState(function (prevState) {
	          prevState.order.packagingTasks = updateTask(prevState.order.packagingTasks, updatedTask);
	          prevState.packagingTasks = prevState.order.packagingTasks;
	          return prevState;
	        });
	      }
	    }
	  },
	  render: function render() {
	    var brewingTab = void 0,
	        brewingTasks = void 0;
	    var fermentingTask = initializeFermentingTask(this);
	    var packagingTask = initializePackagingTask(this);
	    var batchs = get(this.state, 'order.batchs');
	
	    var bodyContent = React.createElement(DashboardModalBrewBody, {
	      isBeerStyleAlreadyDefined: this.state.isBeerStyleAlreadyDefined,
	      parentState: this.state,
	      onChangeCloseOrder: this._onChangeCloseOrder,
	      onChangeBrewDate: this._onChangeBrewDate,
	      onChangeFiltrationDate: this._onChangeFiltrationDate,
	      onChangeOrderDate: this._onChangeOrderDate,
	      onChangeBeerStyle: this._onChangeBeerStyle,
	      onChangeBriteTank: this._onChangeBriteTank,
	      onChangeVolume: this._onChangeVolume,
	      onChangeComment: this._onChangeComment,
	      onChangeFermenterTank: this._onChangeFermenterTank,
	      refsSubscriber: this._refs });
	
	    if (!batchs) {
	      // enter here means that the order don't with brewhouse
	      return React.createElement(Tabs, {
	        ref: "refTabs",
	        className: "modal-order-dialog",
	        initialSelectedIndex: INDEX_FIRST_TAB
	      }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_fermenting')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_packaging')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	    } else if (get(batchs, 'length') === 0) {
	      // enter here means that the order work with brewhouse but don't have batch
	      brewingTab = React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("br", null), React.createElement("div", { className: "modal-order-task-list container-fluid text-center" }, React.createElement("h5", null, t('dashboard_modal_order_volume_zero')))));
	
	      return React.createElement(Tabs, {
	        ref: "refTabs",
	        className: "modal-order-dialog",
	        initialSelectedIndex: INDEX_FIRST_TAB
	      }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_fermenting')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_packaging')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	    } else if (get(batchs, 'length') > 0) {
	      // enter here means that the order have batchs availables in brewhouse
	      brewingTasks = initializeBrewingTurns(batchs, this._onChangeBrewingTaskType, this._onChangeProcess, this._onChangeProducts, this._onChangeAmountItem, this._onChangeVolumeItem, this._onChangeAmountInLocation, null, // non selected task before
	      this._onConfirmProduct, this);
	
	      var _brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, brewingTasks)));
	
	      return React.createElement(Tabs, {
	        ref: "refTabs",
	        className: "modal-order-dialog",
	        initialSelectedIndex: INDEX_FIRST_TAB
	      }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), _brewingTab, React.createElement(Tab, { onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_fermenting')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, fermentingTask))), React.createElement(Tab, {
	        onActive: this.props.onActiveFirstTab,
	        label: t('dashboard_modal_tab_packaging')
	      }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, packagingTask))));
	    }
	  }
	});
	
	module.exports = ModalDashboardBrewNew;

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    some = _require3.some,
	    _require4 = __webpack_require__(5),
	    merge = _require4.merge,
	    _require5 = __webpack_require__(37),
	    delay = _require5.delay,
	    Notification = __webpack_require__(21),
	    _require6 = __webpack_require__(53),
	    cloneDeep = _require6.cloneDeep,
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7),
	    OrderUtils = __webpack_require__(49),
	    DateUtils = __webpack_require__(22),
	    DashboardServiceCache = __webpack_require__(28),
	    ga = __webpack_require__(18),
	    DashboardModalStore = __webpack_require__(155),
	    AppDispatcher = __webpack_require__(42),
	    categories = __webpack_require__(2).Analytics.categories,
	    OrderStore = __webpack_require__(72),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    _require7 = __webpack_require__(50),
	    formatTasksProducts = _require7.formatTasksProducts,
	    getIndexTab = _require7.getIndexTab,
	    changeLabelNote = _require7.changeLabelNote,
	    changeLabelName = _require7.changeLabelName,
	    cleanTasks = _require7.cleanTasks,
	    getTasksFromProcess = _require7.getTasksFromProcess,
	    updateTask = _require7.updateTask,
	    actions = __webpack_require__(2).Analytics.actions,
	    DashboardModalSingleBody = __webpack_require__(402),
	    SessionStore = __webpack_require__(11),
	    _require8 = __webpack_require__(409),
	    _isValidForm = _require8.isValidForm,
	    onChangeFromDateEditMode = _require8.onChangeFromDateEditMode,
	    onChangeToDateEditMode = _require8.onChangeToDateEditMode,
	    onChangeBeerStyle = _require8.onChangeBeerStyle,
	    getExistingModalState = _require8.getExistingModalState,
	    onChangeVolume = _require8.onChangeVolume,
	    onChangeTaskType = _require8.onChangeTaskType,
	    initializeSingleTasksEl = _require8.initializeSingleTasksEl,
	    onDeleteTask = _require8.onDeleteTask,
	    onChangeTask = _require8.onChangeTask,
	    onChangeTankEditMode = _require8.onChangeTankEditMode,
	    cleanModal = _require8.cleanModal,
	    _require9 = __webpack_require__(12),
	    Tab = _require9.Tab,
	    Tabs = _require9.Tabs,
	    _require10 = __webpack_require__(182),
	    onChangeBrewTurnNew = _require10.onChangeBrewTurnNew,
	    initializeBrewingTurns = _require10.initializeBrewingTurns,
	    formatBatchs = _require10.formatBatchs,
	    onChangeProcess = _require10.onChangeProcess,
	    someProductAlreadyConfirmed = _require10.someProductAlreadyConfirmed,
	    onChangeBrewTurn = _require10.onChangeBrewTurn,
	    updateStateTask = _require10.updateStateTask,
	    _require11 = __webpack_require__(2),
	    TIME_WAIT_MODAL_EXPAND = _require11.TIME_WAIT_MODAL_EXPAND,
	    InventoryStore = __webpack_require__(20);
	
	
	var DashboardModalSingleChange = React.createClass({ displayName: "DashboardModalSingleChange",
	
	    propTypes: {
	        close: PropTypes.function,
	        initFromDate: PropTypes.object,
	        orderDateClicked: PropTypes.string,
	        openGeneralTab: PropTypes.boolean,
	        onActiveFirstTab: PropTypes.function,
	        sectionName: PropTypes.string,
	        order: PropTypes.object,
	        tankClicked: PropTypes.object
	    },
	
	    _refs: {
	        beerStyle: null,
	        singleType: null
	    },
	
	    componentWillMount: function componentWillMount() {
	        var nextState = getExistingModalState(this.props, this.props.isBHAllowed, this.props.orderDateClicked);
	        this.setState(nextState);
	
	        // set temporary to find after update estimation inventory in each task
	        this.orderId = get(this.props.order, 'id');
	
	        // save the order safely to non change at dashboard level anything
	        this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var nextState = getExistingModalState(nextProps, nextProps.isBHAllowed, this.props.orderDateClicked);
	
	        this.setState(nextState);
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isBeerStyleAlreadyDefined: true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.refs.refTabs.setState({
	            // fix the bug when click on packaging side it does not open the packaging tab
	            selectedIndex: getIndexTab(this.props)
	        });
	    },
	
	
	    /**
	     * This method will execute all validation needed for this form.
	     *
	     * @param nextState
	     * @public
	     * @returns {*}
	     */
	    isValidForm: function isValidForm(prevState) {
	        var nextState = merge(this.state, prevState);
	        if (prevState && prevState.singleTank) {
	            nextState.singleTank = prevState.singleTank;
	        }
	        return _isValidForm(nextState, this._refs);
	    },
	    triggerValidation: function triggerValidation(nextState) {
	        return this.isValidForm(nextState).messagesError;
	    },
	
	
	    /**
	     * This method will add new single order.
	     * @param afterSubmit
	     */
	    submit: function submit(parentRefs, afterSubmit) {
	        var _this = this;
	
	        var isValidResult = this.isValidForm(this.state);
	        if (isValidResult && !isValidResult.isValid) {
	            this.setState(isValidResult.messagesError, function () {
	                if (_this.refs.refTabs) {
	                    _this.refs.refTabs.setState({
	                        selectedIndex: 0
	                    });
	                }
	            });
	            return;
	        }
	
	        var singleOrder = this.state.order;
	        singleOrder.applicant = SessionStore.getCurrentApplicant();
	        singleOrder.styleBeerId = this.state.styleBeerSelected.id;
	        singleOrder.singleTank = this.state.singleTank;
	        singleOrder.singleTankId = get(this.state, 'singleTank.tankObj.id', get(this.state, 'singleTank.id'));
	        singleOrder.styleBeer = this.state.styleBeerSelected;
	        singleOrder.fromDate = DateUtils.toDateText(this.state.fromDate);
	        singleOrder.toDate = DateUtils.toDateText(this.state.toDate);
	        singleOrder.comment = this.state.commentOrder;
	        singleOrder.singleTasks = cleanTasks(ContentUtils.cleanAllTasksOfProducts(formatTasksProducts(this.state.singleTasks)));
	        singleOrder.batchNumber = parentRefs.batchNumber.getValue();
	        singleOrder.isSingle = true;
	        singleOrder.volume = ContentUtils.getNumber(this.state.orderVolume);
	
	        var batchs = ContentUtils.cleanAllTasksOfProducts(singleOrder.batchs);
	        var isBHAllowed = void 0;
	
	        if (get(singleOrder, 'singleTank.type') !== 'BH' && get(batchs, 'length', 0) > 0) {
	            singleOrder.batchs = cleanTasks(formatTasksProducts(formatBatchs(batchs)));
	            isBHAllowed = true;
	        } else {
	            singleOrder.batchs = [];
	            isBHAllowed = false;
	        }
	
	        var onSuccess = function onSuccess() {
	            ga.event({
	                category: categories.ORDER_SINGLE,
	                action: actions.CHANGE,
	                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	
	            _this.clean();
	
	            afterSubmit();
	        };
	
	        var onFailure = function onFailure(errorMessage) {
	            return _this.setState({ volumenTankMessageError: errorMessage });
	        };
	
	        OrderStore.changeSingleOrderWithoutCheck(singleOrder, onSuccess, onFailure, isBHAllowed, DashboardModalStore.getCurrentLayout());
	    },
	    clean: function clean() {
	        cleanModal(this);
	    },
	    _onChangeFromDate: function _onChangeFromDate(evt, fromDate) {
	        var _this2 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.fromDate, fromDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	        this.setState(function (previousState) {
	            return onChangeFromDateEditMode(previousState, fromDate, _this2.props.isBHAllowed);
	        });
	    },
	    _onChangeToDate: function _onChangeToDate(evt, toDate) {
	        var _this3 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.toDate, toDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	        this.setState(function (previousState) {
	            return onChangeToDateEditMode(previousState, toDate, _this3.props.isBHAllowed);
	        });
	    },
	    _onChangeBeerStyle: function _onChangeBeerStyle(evt) {
	        var _this4 = this;
	
	        var beerStyleSelected = merge(evt, evt.itemModel);
	        this.setState(function (previousState) {
	            return onChangeBeerStyle(previousState, beerStyleSelected, previousState.currentSection, _this4.props.isBHAllowed);
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
	                volume: _this4.state.orderVolume,
	                batchNumber: _this4.state.batchNumber,
	                order: _this4.state.order,
	                isSingle: true
	            });
	        });
	    },
	    _onChangeTask: function _onChangeTask(tasks, oldItemSelected, typeTask, dateTask, itemSelected, evt) {
	        var _this5 = this;
	
	        if (typeTask === 'BH' && !isSingleFromBrewingSection(this.state)) {
	            this.setState(function (prevState) {
	                return onChangeBrewTurnNew(oldItemSelected, dateTask, 'batchs', prevState, get(itemSelected, 'turnId'), itemSelected, itemSelected);
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                    order: _this5.state.order
	                });
	            });
	        } else {
	            this.setState(function (prevState) {
	                return onChangeTaskType(tasks, oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected);
	            }, function () {
	                AppDispatcher.dispatch({
	                    type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                    order: _this5.state.order
	                });
	            });
	        }
	    },
	    _onDeleteTask: function _onDeleteTask(tasks, itemSelected, typeTask, dateTask) {
	        this.setState(function (prevState) {
	            return onDeleteTask(prevState.singleTasks, dateTask);
	        });
	    },
	    _onChangeAmountItem: function _onChangeAmountItem(productChanged, itemChanged, newAmount) {
	        itemChanged.amount = newAmount;
	        itemChanged.manualAmount = newAmount;
	        itemChanged.item.amount = newAmount;
	
	        // update the list of items from product
	        var items = get(productChanged, 'items');
	        var itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
	        productChanged.items = itemsChanged;
	
	        return productChanged;
	    },
	    _onConfirmProduct: function _onConfirmProduct(product, uniqueId, task) {
	        var _this6 = this;
	
	        // update the product instance of the task
	        product.isSaved = false;
	        this.setState(function (prevState) {
	            var result = InventoryStore.onConfirmProduct(prevState, product, task, _this6.ordersCloned, _this6.temporaryOrderId);
	            _this6.ordersCloned = result.ordersCloned;
	            result.isSomeProductAlreadyConfirmed = true;
	            result.ordersCloned = null;
	            result = someProductAlreadyConfirmed(prevState);
	            return result;
	        }, function () {
	            _this6._onChangeProducts(product, product.amount, uniqueId, task);
	        });
	    },
	    _onChangeVolumeItem: function _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
	        this._onChangeProducts(product, product.amount, uniqueId, task);
	    },
	    _onChangeAmountInLocation: function _onChangeAmountInLocation(task, productUpdated) {
	        var avoidMultiplicateAmountItems = true;
	        this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
	    },
	    _onChangeProducts: function _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
	        var _this7 = this;
	
	        var taskType = get(task, 'sectionType');
	        var taskWithProductUpdated = void 0;
	        this.setState(function (prevState) {
	            var endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
	            var nextState = InventoryStore.onChangeSingleProducts(_this7.ordersCloned, prevState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
	
	            taskWithProductUpdated = nextState.taskWithProductUpdated;
	            _this7.ordersCloned = nextState.ordersCloned;
	            nextState.taskWithProductUpdated = null;
	            nextState.ordersCloned = null; // not needed to put in set state context
	
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
	                newAmount: newAmount,
	                order: _this7.state.order,
	                batchNumber: _this7.state.batchNumber,
	                isSingle: true,
	                taskType: taskType,
	                taskUpdated: task,
	                taskWithProductUpdated: taskWithProductUpdated
	            });
	        });
	    },
	    _onBlurLabelOrDescription: function _onBlurLabelOrDescription(tasks, itemSelected, typeTask, dateTask, field, evt) {
	        var targetValue = get(evt, 'target.value', '');
	        this.setState(function (prevState) {
	            return onChangeTask(targetValue, prevState.singleTasks, dateTask, field);
	        });
	    },
	    _notifyToParentIfVolumeAlreadyChanged: function _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
	        if (prevState.orderVolume !== nextState.orderVolume) {
	            props.onChangeVolume(prevState, nextState);
	        }
	    },
	    _onChangeTank: function _onChangeTank(evt, index, menuItem) {
	        var _this8 = this;
	
	        this.setState(function (prevState) {
	            var nextState = onChangeTankEditMode(prevState, menuItem);
	            nextState = merge(nextState, _this8.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _initializeTasks: function _initializeTasks(currentListedTaskTypeSelected) {
	        return initializeSingleTasksEl(currentListedTaskTypeSelected, this);
	    },
	    _existSomeTaskByDate: function _existSomeTaskByDate(date) {
	        return some(this.state.singleTasks, function (task) {
	            return get(task, 'date') === DateUtils.toDateText(date);
	        });
	    },
	    _onChangeVolume: function _onChangeVolume(evt) {
	        var _this9 = this;
	
	        var volume = get(evt, 'target.value');
	        this.setState(function (prevState) {
	            var nextState = onChangeVolume(prevState, volume, _this9.props.isBHAllowed);
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
	                batchNumber: _this9.state.batchNumber,
	                volume: volume,
	                order: _this9.state.order,
	                isSingle: true
	            });
	        });
	    },
	    _onChangeComment: function _onChangeComment(evt) {
	        var commentOrder = get(evt, 'target.value');
	        this.setState({
	            commentOrder: commentOrder
	        });
	    },
	    _onChangeBrewingTaskType: function _onChangeBrewingTaskType(oldItemSelected, turnDate, fieldName, turnId, newMenuItemSelected) {
	        var _this10 = this;
	
	        var targetValue = get(newMenuItemSelected, 'payload');
	        this.setState(function (prevState) {
	            return onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, newMenuItemSelected);
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_TASK_TYPE,
	                order: _this10.state.order
	            });
	        });
	    },
	    _onChangeNote: function _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeName: function _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeProcess: function _onChangeProcess(newProcessOrder) {
	        var tasks = getTasksFromProcess(newProcessOrder, this.state);
	        var result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
	        this.setState(result);
	    },
	    _onChangeCloseOrder: function _onChangeCloseOrder() {
	        this.setState(function (prevState) {
	            var order = get(prevState, 'order');
	            order.closed = !order.closed;
	            return {
	                order: order
	            };
	        });
	    },
	    _onToggleExpand: function _onToggleExpand(existingTask) {
	        var _this11 = this;
	
	        delay(function () {
	            var hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(_this11.state, 'styleBeerSelected.id'));
	            _this11._updateExistingTask(hydratedTask);
	        }, TIME_WAIT_MODAL_EXPAND);
	    },
	    _updateExistingTask: function _updateExistingTask(updatedTask) {
	        if (SessionStore.isFullPaidVersion()) {
	            if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
	                this.setState(function (prevState) {
	                    prevState.batchs = updateTask(prevState.batchs, updatedTask);
	                    prevState.order.batchs = prevState.order.batchs;
	                    return prevState;
	                });
	            } else {
	                this.setState(function (prevState) {
	                    prevState.order.singleTasks = updateTask(prevState.order.singleTasks, updatedTask);
	                    prevState.singleTasks = prevState.order.singleTasks;
	                    return prevState;
	                });
	            }
	        }
	    },
	    render: function render() {
	        var currentTabOpen = getIndexTab(this.props);
	        var _props = this.props,
	            isBHAllowed = _props.isBHAllowed,
	            isBTAllowed = _props.isBTAllowed,
	            isFVAllowed = _props.isFVAllowed;
	
	
	        var brewingTab = void 0,
	            tabsContent = void 0;
	
	        var currentTaskTypeSelected = get(this.state, 'listedTaskTypeSelected.type');
	        var tasks = this._initializeTasks(currentTaskTypeSelected);
	        var bodyContent = React.createElement(DashboardModalSingleBody, {
	            tankTypeClicked: this.props.tankTypeClicked,
	            initFromDate: this.props.initFromDate,
	            onChangeCloseOrder: this._onChangeCloseOrder,
	            initToDate: DateUtils.addDays(this.props.initFromDate, 1),
	            parentState: this.state,
	            sectionName: this.props.sectionName,
	            onChangeFromDate: this._onChangeFromDate,
	            onChangeToDate: this._onChangeToDate,
	            onChangeBeerStyle: this._onChangeBeerStyle,
	            onChangeTank: this._onChangeTank,
	            onChangeVolume: this._onChangeVolume,
	            onChangeComment: this._onChangeComment,
	            refsSubscriber: this._refs });
	
	        var isSingleWithoutBrewingSection = isBHAllowed === false || isBHAllowed && !isFVAllowed && !isBTAllowed;
	        var batchs = get(this.state, 'order.batchs');
	
	        if (isSingleWithoutBrewingSection || !batchs) {
	            tabsContent = React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        } else if (get(batchs, 'length') === 0) {
	            brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("br", null), React.createElement("div", { className: "modal-order-task-list container-fluid text-center" }, React.createElement("h5", null, t('dashboard_modal_order_volume_zero')))));
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        } else if (get(batchs, 'length') > 0) {
	            // sort batch in order to avoid issues ordering after change each batch task
	            var sortedBatchs = map(batchs, function (batch) {
	                batch.column = get(batch, 'turn.column');
	                return batch;
	            });
	            var brewingTasks = initializeBrewingTurns(sortedBatchs, this._onChangeBrewingTaskType, this._onChangeProcess, this._onChangeProducts, this._onChangeAmountItem, this._onChangeVolumeItem, this._onChangeAmountInLocation, this.state.dataClicked, this._onConfirmProduct, this);
	
	            brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, brewingTasks)));
	            tabsContent = React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: currentTabOpen }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        }
	
	        return tabsContent;
	    }
	});
	
	function isSingleFromBrewingSection(state) {
	    return get(state, 'order.isSingle') && get(state, 'sectionName') === 'Brewing';
	}
	
	module.exports = DashboardModalSingleChange;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    find = _require3.find,
	    _require4 = __webpack_require__(5),
	    merge = _require4.merge,
	    moment = __webpack_require__(3),
	    _require5 = __webpack_require__(53),
	    cloneDeep = _require5.cloneDeep,
	    sortBy = __webpack_require__(8).sortBy,
	    Notification = __webpack_require__(21),
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7),
	    OrderUtils = __webpack_require__(49),
	    DateUtils = __webpack_require__(22),
	    _require6 = __webpack_require__(37),
	    delay = _require6.delay,
	    ga = __webpack_require__(18),
	    categories = __webpack_require__(2).Analytics.categories,
	    OrderStore = __webpack_require__(72),
	    DashboardServiceCache = __webpack_require__(28),
	    DashboardModalStore = __webpack_require__(155),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    AppDispatcher = __webpack_require__(42),
	    _require7 = __webpack_require__(50),
	    formatTasksProducts = _require7.formatTasksProducts,
	    addProductOrderIdToTasks = _require7.addProductOrderIdToTasks,
	    formatOrderProcess = _require7.formatOrderProcess,
	    changeLabelName = _require7.changeLabelName,
	    changeLabelNote = _require7.changeLabelNote,
	    cleanTasks = _require7.cleanTasks,
	    hydrateOrderWithTheirProcess = _require7.hydrateOrderWithTheirProcess,
	    getTasksFromProcess = _require7.getTasksFromProcess,
	    updateTask = _require7.updateTask,
	    actions = __webpack_require__(2).Analytics.actions,
	    DashboardModalSingleBody = __webpack_require__(402),
	    _require8 = __webpack_require__(2),
	    INDEX_FIRST_TAB = _require8.INDEX_FIRST_TAB,
	    TIME_WAIT_MODAL_EXPAND = _require8.TIME_WAIT_MODAL_EXPAND,
	    InventoryStore = __webpack_require__(20),
	    _require9 = __webpack_require__(182),
	    initializeBrewingTurns = _require9.initializeBrewingTurns,
	    onChangeBrewTurnNew = _require9.onChangeBrewTurnNew,
	    formatBatchs = _require9.formatBatchs,
	    onChangeProcess = _require9.onChangeProcess,
	    someProductAlreadyConfirmed = _require9.someProductAlreadyConfirmed,
	    updateStateTask = _require9.updateStateTask,
	    SessionStore = __webpack_require__(11),
	    _require10 = __webpack_require__(409),
	    _isValidForm = _require10.isValidForm,
	    onChangeFromDate = _require10.onChangeFromDate,
	    onChangeToDate = _require10.onChangeToDate,
	    onChangeBeerStyle = _require10.onChangeBeerStyle,
	    getNewModalState = _require10.getNewModalState,
	    onChangeTaskType = _require10.onChangeTaskType,
	    initializeSingleTasksEl = _require10.initializeSingleTasksEl,
	    onChangeTask = _require10.onChangeTask,
	    onChangeTank = _require10.onChangeTank,
	    cleanModal = _require10.cleanModal,
	    onChangeVolumeNew = _require10.onChangeVolumeNew,
	    _require11 = __webpack_require__(12),
	    Tab = _require11.Tab,
	    Tabs = _require11.Tabs;
	
	
	var DashboardModalSingleNew = React.createClass({ displayName: "DashboardModalSingleNew",
	
	    propTypes: {
	        close: PropTypes.function,
	        currentSection: PropTypes.string,
	        isBHAllowed: PropTypes.boolean,
	        isFVAllowed: PropTypes.boolean,
	        isBTAllowed: PropTypes.boolean,
	        initFromDate: PropTypes.object,
	        isSingleMode: PropTypes.boolean,
	        tankSelected: PropTypes.obj,
	        onActiveFirstTab: PropTypes.function,
	        openGeneralTab: PropTypes.boolean,
	        preDefinedOrder: PropTypes.object,
	        tankTypeClicked: PropTypes.string,
	        sectionName: PropTypes.string
	    },
	
	    _refs: {},
	
	    getInitialState: function getInitialState() {
	        return {
	            isBeerStyleAlreadyDefined: false,
	            order: this.props.preDefinedOrder
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        var _props = this.props,
	            isBHAllowed = _props.isBHAllowed,
	            isFVAllowed = _props.isFVAllowed,
	            isBTAllowed = _props.isBTAllowed,
	            currentSection = _props.currentSection;
	
	        var nextState = getNewModalState(this.props, isBHAllowed, isFVAllowed, isBTAllowed, currentSection);
	        this.setState(nextState);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.temporaryOrderId = null;
	        this.ordersCloned = null;
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var isBHAllowed = nextProps.isBHAllowed,
	            isFVAllowed = nextProps.isFVAllowed,
	            isBTAllowed = nextProps.isBTAllowed,
	            currentSection = nextProps.currentSection;
	
	        var nextState = getNewModalState(nextProps, isBHAllowed, isFVAllowed, isBTAllowed, currentSection);
	        this.setState(nextState);
	    },
	    componentDidMount: function componentDidMount() {
	        // set temporary to find after update estimation inventory in each task
	        this.temporaryOrderId = ContentUtils.getRandomId();
	
	        // save the order safely to non change at dashboard level anything
	        this.ordersCloned = cloneDeep(DashboardServiceCache.getOrdersSorted());
	    },
	
	
	    /**
	     * This method will execute all validation needed for this form.
	     *
	     * @param nextState
	     * @public
	     * @returns {*}
	     */
	    isValidForm: function isValidForm(prevState) {
	        var nextState = merge(this.state, prevState);
	        return _isValidForm(nextState);
	    },
	    triggerValidation: function triggerValidation(nextState) {
	        return this.isValidForm(nextState).messagesError;
	    },
	
	
	    /**
	     * This method will add new single order.
	     * @param afterSubmit
	     */
	    submit: function submit(parentRefs, afterSubmit) {
	        var _this = this;
	
	        var isValidResult = this.isValidForm();
	        if (isValidResult && !isValidResult.isValid) {
	            this.setState(isValidResult.messagesError, function () {
	                if (_this.refs.refTabs) {
	                    _this.refs.refTabs.setState({
	                        selectedIndex: 0
	                    });
	                }
	            });
	            return;
	        }
	
	        var singleOrder = {};
	        singleOrder.applicant = SessionStore.getCurrentApplicant();
	        singleOrder.styleBeerId = this.state.styleBeerSelected.id;
	        singleOrder.dateCreated = moment().format(); // it's needed to calculate properly batch number
	        singleOrder.singleTank = this.state.singleTank;
	        singleOrder.singleTankId = get(this.state, 'singleTank.id', get(this.state, 'singleTank.tankObj.id'));
	        singleOrder.styleBeer = this.state.styleBeerSelected;
	        singleOrder.fromDate = DateUtils.toDateText(this.state.fromDate);
	        singleOrder.toDate = DateUtils.toDateText(this.state.toDate);
	        singleOrder.comment = this.state.commentOrder;
	        singleOrder.volume = ContentUtils.getNumber(this.state.orderVolume);
	        singleOrder.batchNumber = parentRefs.batchNumber.getValue();
	        singleOrder.isSingle = true;
	        singleOrder.singleTasks = cleanTasks(ContentUtils.cleanAllTasksOfProducts(addProductOrderIdToTasks(formatTasksProducts(this.state.singleTasks))));
	        singleOrder.batchs = cleanTasks(addProductOrderIdToTasks(formatTasksProducts(formatBatchs(get(this.state, 'order.batchs')))));
	
	        var batchs = ContentUtils.cleanAllTasksOfProducts(get(this.state, 'order.batchs'));
	
	        var isBHAllowed = void 0;
	        if (get(singleOrder, 'singleTank.type') !== 'BH' && get(batchs, 'length', 0) > 0) {
	            // note about validation of BH, because never the single order from brewhouse will have batch assigned
	            isBHAllowed = true;
	        } else {
	            singleOrder.batchs = [];
	            isBHAllowed = false;
	        }
	
	        var onSuccess = function onSuccess() {
	            // on success
	            ga.event({
	                category: categories.ORDER_SINGLE,
	                action: actions.NEW,
	                label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	            });
	
	            _this.clean();
	            afterSubmit();
	        };
	
	        var onFailure = function onFailure(errorMessage) {
	            return _this.setState({ volumenTankMessageError: errorMessage });
	        };
	        OrderStore.addNewSingleOrder(singleOrder, onSuccess, onFailure, isBHAllowed, DashboardModalStore.getCurrentLayout());
	    },
	    clean: function clean() {
	        cleanModal(this);
	    },
	    _onChangeFromDate: function _onChangeFromDate(evt, fromDate) {
	        var _this2 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.fromDate, fromDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	        this.setState(function (prevState) {
	            return onChangeFromDate(prevState, fromDate, _this2.props.isBHAllowed);
	        });
	    },
	    _onChangeToDate: function _onChangeToDate(evt, toDate) {
	        var _this3 = this;
	
	        if (!SessionStore.isAbleToEditDates()) {
	            Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	            return;
	        }
	        if (OrderStore.existSomeProductConfirmed(this.state.order, this.state.toDate, toDate)) {
	            Notification.show(t('notification_unconfirm_product_and_try_again'));
	            return;
	        }
	        this.setState(function (prevState) {
	            return onChangeToDate(prevState, toDate, _this3.props.isBHAllowed);
	        });
	    },
	    _onChangeBeerStyle: function _onChangeBeerStyle(evt) {
	        var _this4 = this;
	
	        var beerStyleSelected = merge(evt, evt.itemModel);
	        var self = this;
	        this.setState(function (prevState) {
	            var nextState = onChangeBeerStyle(prevState, beerStyleSelected, _this4.props.currentSection, _this4.props.isBHAllowed);
	
	            // set the id of the draft order to be consistent
	            var oldOrder = find(self.ordersCloned, function (orderFind) {
	                return orderFind.id === self.temporaryOrderId;
	            });
	            nextState.order.id = self.temporaryOrderId;
	            if (oldOrder) {
	                oldOrder.id = self.temporaryOrderId;
	            }
	
	            // auto populate each product given the volume of the order
	            _this4.ordersCloned = ContentUtils.replaceByAttributes(self.ordersCloned, nextState.order, 'id');
	
	            nextState.isBeerStyleAlreadyDefined = true;
	
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_BEER_STYLE,
	                volume: _this4.state.orderVolume,
	                batchNumber: _this4.state.batchNumber,
	                order: null,
	                isSingle: true
	            });
	        });
	    },
	    _onChangeAmountItem: function _onChangeAmountItem(productChanged, itemChanged, newAmount) {
	        itemChanged.amount = newAmount;
	        itemChanged.manualAmount = newAmount;
	        itemChanged.item.amount = newAmount;
	
	        // update the list of items from product
	        var items = get(productChanged, 'items');
	        var itemsChanged = ContentUtils.replace(items, itemChanged, 'id');
	        productChanged.items = itemsChanged;
	        productChanged = InventoryStore.onChangeProductByAmount(productChanged, newAmount);
	
	        return productChanged;
	    },
	    _onChangeVolumeItem: function _onChangeVolumeItem(product, newPorcent, uniqueId, task) {
	        this._onChangeProducts(product, product.amount, uniqueId, task);
	    },
	    _onChangeAmountInLocation: function _onChangeAmountInLocation(task, productUpdated) {
	        var avoidMultiplicateAmountItems = true;
	        this._onChangeProducts(productUpdated, productUpdated.amount, '', task, avoidMultiplicateAmountItems);
	    },
	    _onChangeProducts: function _onChangeProducts(productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct) {
	        var _this5 = this;
	
	        var taskType = get(task, 'sectionType');
	        var taskWithProductUpdated = void 0;
	        this.setState(function (prevState) {
	            var endDateOrder = OrderUtils.getEndDateOrder(prevState.order);
	            var nextState = InventoryStore.onChangeSingleProducts(_this5.ordersCloned, prevState, productWithoutChange, newAmount, uniqueId, task, avoidMultiplyItemByAmountProduct, endDateOrder);
	
	            taskWithProductUpdated = nextState.taskWithProductUpdated;
	            _this5.ordersCloned = nextState.ordersCloned;
	            nextState.taskWithProductUpdated = null;
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_PRODUCT_AMOUNT,
	                newAmount: newAmount,
	                order: _this5.state.order,
	                batchNumber: _this5.state.batchNumber,
	                isSingle: true,
	                taskType: taskType,
	                taskUpdated: task,
	                taskWithProductUpdated: taskWithProductUpdated
	            });
	        });
	    },
	    _onChangeTask: function _onChangeTask(tasks, oldItemSelected, typeTask, dateTask, itemSelected, evt) {
	        this.setState(function (prevState) {
	            return onChangeTaskType(tasks, oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected);
	        });
	    },
	    _onBlurLabelOrDescription: function _onBlurLabelOrDescription(tasks, itemSelected, typeTask, dateTask, field, evt) {
	        var targetValue = get(evt, 'target.value', '');
	        this.setState(function (prevState) {
	            return onChangeTask(targetValue, prevState.singleTasks, dateTask, field);
	        });
	    },
	    _onChangeVolume: function _onChangeVolume(evt) {
	        var _this6 = this;
	
	        var volume = get(evt, 'target.value');
	        this.setState(function (prevState) {
	            var nextState = onChangeVolumeNew(prevState, volume, _this6.props.isBHAllowed);
	            return nextState;
	        }, function () {
	            AppDispatcher.dispatch({
	                type: ActionTypes.DASHBOARD_MODAL_CHANGE_VOLUME,
	                volume: _this6.state.orderVolume,
	                batchNumber: _this6.state.batchNumber,
	                isSingle: true,
	                order: null
	            });
	        });
	    },
	    _onChangeComment: function _onChangeComment(evt) {
	        var commentOrder = get(evt, 'target.value');
	        this.setState({
	            commentOrder: commentOrder
	        });
	    },
	    _notifyToParentIfVolumeAlreadyChanged: function _notifyToParentIfVolumeAlreadyChanged(prevState, nextState, props) {
	        if (prevState.orderVolume !== nextState.orderVolume) {
	            props.onChangeVolumeNew(prevState, nextState);
	        }
	    },
	    _onChangeTank: function _onChangeTank(evt, index, menuItem) {
	        var _this7 = this;
	
	        this.setState(function (prevState) {
	            var nextState = onChangeTank(prevState, menuItem, _this7.props.isBHAllowed);
	            nextState = merge(nextState, _this7.triggerValidation(nextState));
	            return nextState;
	        });
	    },
	    _initializeTasks: function _initializeTasks(currentListedTaskTypeSelected) {
	        return initializeSingleTasksEl(currentListedTaskTypeSelected, this);
	    },
	    _onChangeBrewingTaskType: function _onChangeBrewingTaskType(oldItemSelected, turnDate, fieldName, turnId, newItemSelected) {
	        var targetValue = get(newItemSelected, 'payload');
	        this.setState(function (prevState) {
	            var nextState = onChangeBrewTurnNew(oldItemSelected, turnDate, fieldName, prevState, turnId, targetValue, newItemSelected);
	            nextState.changeCamefromCurrentComponent = true;
	            return nextState;
	        });
	    },
	    _onChangeProcess: function _onChangeProcess(newProcessOrder) {
	        var tasks = getTasksFromProcess(newProcessOrder, this.state);
	        var result = onChangeProcess(this.state, newProcessOrder.existingProcess, newProcessOrder, tasks);
	        this.setState(result);
	    },
	    _onChangeNote: function _onChangeNote(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelNote(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeName: function _onChangeName(oldItemSelected, typeTask, dateTask, evt) {
	        var targetValue = get(evt, 'target.value');
	        var itemSelectedUpdated = changeLabelName(oldItemSelected, targetValue);
	        this.setState(updateStateTask(this.state, itemSelectedUpdated));
	    },
	    _onChangeTaskType: function _onChangeTaskType(oldItemSelected, typeTask, dateTask, itemSelected, evt) {
	        var _this8 = this;
	
	        this.setState(function (prevState) {
	            var nextState = onChangeTaskType(_this8.state.singleTasks, oldItemSelected, typeTask, dateTask, prevState, evt, itemSelected);
	            nextState.changeCamefromCurrentComponent = true;
	            return nextState;
	        });
	    },
	    _onChangeCloseOrder: function _onChangeCloseOrder() {
	        this.setState(function (prevState) {
	            var order = get(prevState, 'order');
	            order.closed = !order.closed;
	            return {
	                order: order
	            };
	        });
	    },
	    _onConfirmProduct: function _onConfirmProduct(product, uniqueId, task) {
	        var _this9 = this;
	
	        this.setState(function (prevState) {
	            var result = InventoryStore.onConfirmProduct(prevState, product, task, _this9.ordersCloned, _this9.temporaryOrderId);
	            _this9.ordersCloned = result.ordersCloned;
	            result.ordersCloned = null;
	            result = someProductAlreadyConfirmed(prevState);
	            return result;
	        }, function () {
	            _this9._onChangeProducts(product, product.amount, uniqueId, task);
	        });
	    },
	    _onToggleExpand: function _onToggleExpand(existingTask) {
	        var _this10 = this;
	
	        delay(function () {
	            var hydratedTask = InventoryStore.hydrateTaskWithProducts(existingTask, get(_this10.state, 'styleBeerSelected.id'));
	            _this10._updateExistingTask(hydratedTask);
	        }, TIME_WAIT_MODAL_EXPAND);
	    },
	    _updateExistingTask: function _updateExistingTask(updatedTask) {
	        if (SessionStore.isFullPaidVersion()) {
	            if (updatedTask.sectionType === 'BREWHOUSE_TASK') {
	                this.setState(function (prevState) {
	                    prevState.order.batchs = updateTask(prevState.order.batchs, updatedTask);
	                    prevState.batchs = prevState.order.batchs;
	                    return prevState;
	                });
	            } else {
	                this.setState(function (prevState) {
	                    prevState.order.singleTasks = updateTask(prevState.order.singleTasks, updatedTask);
	                    prevState.singleTasks = prevState.order.singleTasks;
	                    return prevState;
	                });
	            }
	        }
	    },
	    render: function render() {
	        var currentTaskTypeSelected = get(this.state, 'listedTaskTypeSelected.type');
	        var tasks = this._initializeTasks(currentTaskTypeSelected);
	
	        var bodyContent = React.createElement(DashboardModalSingleBody, {
	            tankTypeClicked: this.props.tankTypeClicked,
	            initFromDate: this.props.initFromDate,
	            onChangeCloseOrder: this._onChangeCloseOrder,
	            initToDate: DateUtils.addDays(this.props.initFromDate, 1),
	            parentState: this.state,
	            sectionName: this.props.sectionName,
	            onChangeFromDate: this._onChangeFromDate,
	            onChangeToDate: this._onChangeToDate,
	            onChangeBeerStyle: this._onChangeBeerStyle,
	            onChangeTank: this._onChangeTank,
	            onChangeVolume: this._onChangeVolume,
	            onChangeComment: this._onChangeComment,
	            refsSubscriber: this._refs });
	
	        var batchs = get(this.state, 'order.batchs');
	        var brewingTab = void 0;
	
	        // sort batch in order to avoid issues ordering after change each batch task
	        var sortedBatchs = sortBy(map(batchs, function (batch) {
	            var column = get(batch, 'turn.column');
	            if (column) {
	                batch.column = column;
	            }
	            return batch;
	        }), ['date'], ['desc']);
	
	        if (!batchs) {
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: INDEX_FIRST_TAB }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-tab modal-order-container fluid-container" }, bodyContent)), React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-tab modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        } else if (get(batchs, 'length') === 0) {
	            brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("br", null), React.createElement("div", { className: "modal-order-task-list container-fluid text-center" }, React.createElement("h5", null, t('dashboard_modal_order_volume_zero')))));
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: INDEX_FIRST_TAB }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_tab_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        } else if (get(sortedBatchs, 'length') > 0) {
	            var brewingTasks = initializeBrewingTurns(sortedBatchs, this._onChangeBrewingTaskType, this._onChangeProcess, this._onChangeProducts, this._onChangeAmountItem, this._onChangeVolumeItem, this._onChangeAmountInLocation, null, // non selected task before
	            this._onConfirmProduct, this);
	
	            brewingTab = React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('brewing') }, React.createElement("div", { className: "modal-order-task-container" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, brewingTasks)));
	            return React.createElement(Tabs, { className: "modal-order-dialog",
	                ref: "refTabs",
	                initialSelectedIndex: INDEX_FIRST_TAB }, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: t('dashboard_modal_single_new_label_general') }, React.createElement("div", { className: "modal-order-container fluid-container" }, bodyContent)), brewingTab, React.createElement(Tab, { onActive: this.props.onActiveFirstTab, label: this.props.sectionName }, React.createElement("div", { className: "modal-order-task-container container-fluid" }, React.createElement("ul", { className: "modal-order-task-list container-fluid" }, tasks))));
	        }
	    }
	});
	
	module.exports = DashboardModalSingleNew;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(396);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    uniqueId = __webpack_require__(508),
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(53),
	    cloneDeep = _require3.cloneDeep,
	    _require4 = __webpack_require__(8),
	    find = _require4.find,
	    map = _require4.map,
	    sortBy = _require4.sortBy,
	    ContentUtils = __webpack_require__(7),
	    SessionStore = __webpack_require__(11),
	    OrderUtils = __webpack_require__(49),
	    _require5 = __webpack_require__(12),
	    FontIcon = _require5.FontIcon,
	    DashboardServiceCache = __webpack_require__(28),
	    DashboardModalTaskCollapsibleItem = __webpack_require__(725),
	    DashboardModalTaskCollapsibleItemAmount = __webpack_require__(726);
	
	
	var DashboardModalTaskCollapsibleContent = React.createClass({ displayName: "DashboardModalTaskCollapsibleContent",
	
	    propTypes: {
	        order: PropTypes.object,
	        orderProcess: PropTypes.array,
	        existingProcess: PropTypes.object,
	        existingTask: PropTypes.object,
	        onBlurLabel: PropTypes.func,
	        isCollapsed: PropTypes.bool,
	        isEditMode: PropTypes.bool,
	        onChangeProcess: PropTypes.func,
	        onChangeProducts: PropTypes.func,
	        onChangeAmountItem: PropTypes.func,
	        onChangeAmountInLocation: PropTypes.func,
	        onChangeVolumeItem: PropTypes.func,
	        products: PropTypes.array,
	        onConfirmProduct: PropTypes.func.isRequired
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.setState({
	            keyAttrFirst: uniqueId('dmtcci_'),
	            keyAttrSecond: uniqueId('dmtcc_')
	        });
	    },
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        return this.isMounted();
	    },
	    componentDidMount: function componentDidMount() {},
	    _getHydrateProcessWithOrderProcess: function _getHydrateProcessWithOrderProcess() {
	        var _props = this.props,
	            existingTask = _props.existingTask,
	            existingProcess = _props.existingProcess;
	
	        var orderProcess = void 0;
	
	        if (existingTask && existingTask.process && existingTask.process.length) {
	            orderProcess = existingTask.process;
	        } else {
	            orderProcess = this.props.orderProcess;
	        }
	        var taskId = get(existingTask, 'taskId');
	
	        if (!ContentUtils.isEmptyArray(orderProcess)) {
	            // enter here means an existing order
	            var hydratedProcess = map(existingProcess, function (existingProcessObj) {
	                var existingProcessOrder = find(orderProcess, function (orderProcessRow) {
	                    return +get(orderProcessRow, 'processId') === get(existingProcessObj, 'id') && get(orderProcessRow, 'taskId') === taskId;
	                });
	
	                if (existingProcessOrder) {
	                    existingProcessObj.fromDate = get(existingProcessOrder, 'fromDate', '');
	                    existingProcessObj.toDate = get(existingProcessOrder, 'toDate', '');
	                    existingProcessObj.fromHour = get(existingProcessOrder, 'fromHour', '');
	                    existingProcessObj.toHour = get(existingProcessOrder, 'toHour', '');
	                    existingProcessObj.note = get(existingProcessOrder, 'note', '');
	                    existingProcessObj.taskId = get(existingProcessOrder, 'taskId', '');
	                }
	
	                return existingProcessObj;
	            });
	
	            return sortBy(hydratedProcess, 'sequenceOrder');
	        } else {
	            // enter here means is a new order, so nothing to hydrate
	            return sortBy(existingProcess, 'sequenceOrder');
	        }
	    },
	    _getProcessEl: function _getProcessEl() {
	        var orderProcessHydrated = this._getHydrateProcessWithOrderProcess();
	        var _props2 = this.props,
	            existingTask = _props2.existingTask,
	            onChangeProcess = _props2.onChangeProcess,
	            order = _props2.order;
	
	        var keyAttrFirst = this.state.keyAttrFirst;
	        var enableTasks = ContentUtils.filterEnable(orderProcessHydrated);
	
	        if (ContentUtils.isEmptyArray(enableTasks)) {
	            return React.createElement("label", { style: { fontWeight: '200' }, className: "container text-center" }, React.createElement(FontIcon, {
	                style: {
	                    top: '3px',
	                    right: '4px',
	                    fontSize: '18px',
	                    color: '#fcca2e'
	                },
	                className: "material-icons"
	            }, "announcement"), ' ' + t('dashboard_modal_task_qc_information'));
	        }
	
	        return map(enableTasks, function (processAlreadyHydrated) {
	            return React.createElement(DashboardModalTaskCollapsibleItem, {
	                fromDate: get(processAlreadyHydrated, 'fromDate'),
	                fromHour: get(processAlreadyHydrated, 'fromHour'),
	                toDate: get(processAlreadyHydrated, 'toDate'),
	                toHour: get(processAlreadyHydrated, 'toHour'),
	                isSingle: get(order, 'isSingle'),
	                uniqueId: keyAttrFirst,
	                orderProcessHydrated: processAlreadyHydrated,
	                existingTask: existingTask,
	                onChangeProcess: onChangeProcess });
	        });
	    },
	    _getProductsEl: function _getProductsEl() {
	        var _this = this;
	
	        var _props3 = this.props,
	            onChangeProducts = _props3.onChangeProducts,
	            onChangeAmountItem = _props3.onChangeAmountItem,
	            onChangeVolumeItem = _props3.onChangeVolumeItem,
	            existingTask = _props3.existingTask,
	            onChangeAmountInLocation = _props3.onChangeAmountInLocation,
	            onConfirmProduct = _props3.onConfirmProduct,
	            order = _props3.order,
	            shouldBeDisabled = _props3.shouldBeDisabled;
	
	        var products = get(existingTask, 'products');
	        var isNewProduct = get(existingTask, 'isNewProduct');
	
	        // only show product which may be disabled in case that those
	        // already exist before ('isNewProduct') indicate that don't exist before.
	        // means is a new assignment with no-product selected before.
	        var enableProducts = isNewProduct ? ContentUtils.filterEnable(products) : products;
	        var productsSorted = sortBy(enableProducts, 'name');
	        var allowToConfirmProduct = OrderUtils.isAbleToConfirmSomeProduct(order, get(existingTask, 'date'));
	
	        if (ContentUtils.isEmptyArray(productsSorted)) {
	            return React.createElement("label", { style: { fontWeight: '400' }, className: "container text-center" }, React.createElement(FontIcon, {
	                style: {
	                    top: '3px',
	                    right: '4px',
	                    fontSize: '18px',
	                    color: '#fcca2e'
	                },
	                className: "material-icons"
	            }, "announcement"), ' ' + t('dashboard_modal_task_error_no_items_associated'));
	        }
	
	        return map(productsSorted, function (product, index) {
	            return React.createElement(DashboardModalTaskCollapsibleItemAmount, {
	                shouldBeDisabled: shouldBeDisabled,
	                onChangeProducts: onChangeProducts,
	                onChangeAmountInLocation: onChangeAmountInLocation,
	                onChangeAmountItem: onChangeAmountItem,
	                onChangeVolumeItem: onChangeVolumeItem,
	                onConfirmProduct: onConfirmProduct,
	                uniqueId: 'product-item-amount-' + index + '-' + product.id + '-' + get(existingTask, 'taskId'),
	                product: cloneDeep(product),
	                allowToConfirmProduct: allowToConfirmProduct,
	                task: existingTask,
	                renderItemAgain: function renderItemAgain() {
	                    return _this.forceUpdate();
	                },
	                locations: DashboardServiceCache.getLocations() });
	        });
	    },
	    _toggleVisibleStyle: function _toggleVisibleStyle() {
	        return this.props.isCollapsed ? {
	            position: 'absolute',
	            top: '2px',
	            opacity: '0',
	            height: '0',
	            overflow: 'hidden'
	        } : {
	            position: 'relative',
	            transition: 'opacity 1s ease-out',
	            opacity: '1',
	            height: 'auto',
	            overflow: 'inherit',
	            top: '2px'
	        };
	    },
	    render: function render() {
	        var keyAttrSecond = this.state.keyAttrSecond;
	
	        // Process elements
	
	        var orderProcessHydratedEl = this._getProcessEl();
	
	        // Product elements
	        var productsEl = this._getProductsEl();
	
	        // turn to show/hide content list
	        var listStyle = this._toggleVisibleStyle();
	
	        return SessionStore.isFullPaidVersion() ? React.createElement("ul", { key: keyAttrSecond, className: "dashboard-modal-task-collapsible-content__list", style: listStyle }, React.createElement("h2", null, t('dashboard_modal_task_products_title')), productsEl, React.createElement("h2", null, t('dashboard_modal_task_qc_title')), orderProcessHydratedEl) : React.createElement("ul", { key: keyAttrSecond, className: "dashboard-modal-task-collapsible-content__list", style: listStyle }, React.createElement("h2", null, t('dashboard_modal_task_qc_title')), orderProcessHydratedEl);
	    }
	});
	
	module.exports = DashboardModalTaskCollapsibleContent;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(396);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    _require3 = __webpack_require__(12),
	    TimePicker = _require3.TimePicker,
	    TextField = __webpack_require__(106),
	    DashboardModalUtils = __webpack_require__(50),
	    _ = __webpack_require__(40),
	    DateUtils = __webpack_require__(22);
	
	
	var DashboardModalTaskCollapsibleItem = React.createClass({ displayName: "DashboardModalTaskCollapsibleItem",
	
	    propTypes: {
	        orderProcessHydrated: PropTypes.object,
	        uniqueId: PropTypes.string,
	        existingTask: PropTypes.object,
	        onChangeProcess: PropTypes.func,
	        isSingle: PropTypes.bool,
	        fromDate: PropTypes.string,
	        fromHour: PropTypes.string,
	        toDate: PropTypes.string,
	        toHour: PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            total: '',
	            note: '',
	            noteUpdated: '',
	            isDefinedFromDate: false,
	            isDefinedToDate: false
	        };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	
	        var fromDate = nextProps.fromDate,
	            fromHour = nextProps.fromHour,
	            toDate = nextProps.toDate,
	            toHour = nextProps.toHour;
	
	        var isDefinedFromDate = void 0,
	            isDefinedToDate = void 0,
	            fromDateDefined = void 0,
	            toDateDefined = void 0;
	
	        if (fromDate) {
	            fromDateDefined = DateUtils.toDateAndHours(fromDate, fromHour);
	            this.refs.fromDate.setTime(fromDateDefined);
	            isDefinedFromDate = true;
	        }
	
	        if (toDate) {
	            toDateDefined = DateUtils.toDateAndHours(toDate, toHour);
	            this.refs.toDate.setTime(toDateDefined);
	            isDefinedToDate = true;
	        }
	
	        if (isDefinedFromDate && isDefinedToDate) {
	            this._updateTotalLabel(fromDateDefined, toDateDefined);
	            this.setState({
	                isDefinedToDate: true,
	                isDefinedFromDate: true
	            });
	        }
	    },
	    _onChangeNote: function _onChangeNote(evt) {
	
	        var note = evt.target.value || '';
	
	        this.setState({
	            note: note
	        });
	
	        this.props.onChangeProcess({
	            note: note,
	            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
	            existingProcess: _.get(this.props, 'existingTask.process') || [],
	            date: _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask')),
	            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection'),
	            taskId: _.get(this.props, 'existingTask.taskId'),
	            processId: _.get(this.props, 'orderProcessHydrated.id')
	        });
	    },
	    _onChangeFromDate: function _onChangeFromDate(context, fromDate) {
	        var toDate = this.refs.toDate.getTime();
	        var isDefinedToDate = this.state.isDefinedToDate;
	
	
	        if (isDefinedToDate) {
	            // enter here means that both dates are already defined
	            this._updateTotalLabel(fromDate, toDate);
	        }
	
	        var taskDate = _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask'));
	
	        // this method came from DashboardModalBrewStore.onChangeProcess
	        this.props.onChangeProcess({
	            existingProcess: _.get(this.props, 'existingTask.process') || [],
	            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
	            fromDate: taskDate,
	            fromHour: DateUtils.toDateTextWithHHMM(fromDate),
	            date: taskDate,
	            // following field just to identify
	            taskId: _.get(this.props, 'existingTask.taskId'),
	            processId: _.get(this.props, 'orderProcessHydrated.id'),
	            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection')
	        });
	
	        this.setState({ isDefinedFromDate: true });
	    },
	    _onChangeToDate: function _onChangeToDate(context, toDate) {
	        var fromDate = this.refs.fromDate.getTime();
	        var isDefinedFromDate = this.state.isDefinedFromDate;
	
	
	        if (isDefinedFromDate) {
	            // enter here means that both dates are already defined
	            this._updateTotalLabel(fromDate, toDate);
	        }
	
	        var taskDate = _.get(this.props, 'existingTask.date') || DashboardModalUtils.getDateFromTaskId(_.get(this.props, 'existingTask'));
	
	        // this method came from DashboardModalBrewStore.onChangeProcess
	        this.props.onChangeProcess({
	            existingProcess: _.get(this.props, 'existingTask.process') || [],
	            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
	            toDate: taskDate,
	            toHour: DateUtils.toDateTextWithHHMM(toDate),
	            date: taskDate,
	            // following field just to identify
	            taskId: _.get(this.props, 'existingTask.taskId'),
	            processId: _.get(this.props, 'orderProcessHydrated.id'),
	            processSection: _.get(this.props, 'existingTask.sectionType') || _.get(this.props, 'orderProcessHydrated.processSection')
	        });
	
	        this.setState({ isDefinedToDate: true });
	    },
	    _updateTotalLabel: function _updateTotalLabel(from, to) {
	        if (from && to) {
	            var minutesDiff = DateUtils.getMinutesBetween(from, to);
	            this.setState({ total: minutesDiff + ' min' });
	        } else {
	            this.setState({ total: '' });
	        }
	    },
	    _onDeleteProcess: function _onDeleteProcess() {
	        // this method came from DashboardModalBrewStore.onChangeProcess
	        this.props.onChangeProcess({
	            toDate: null,
	            toHour: null,
	            fromDate: null,
	            fromHour: null,
	            note: '',
	            isDeletingOperation: true,
	            // following field just to identify,
	            isSingle: _.get(this.props, 'isSingle') || this.props.existingTask.type === 'SINGLE_TASK',
	            taskId: _.get(this.props, 'existingTask.taskId'),
	            processId: _.get(this.props, 'orderProcessHydrated.id'),
	            processSection: _.get(this.props, 'orderProcessHydrated.processSection')
	        });
	
	        this.setState({ total: '' });
	        this.setState({ note: '' });
	
	        // TODO: Workaround of material-ui 0.10.0 that not update value of internal input after change it.
	        this.refs.fromDate.getDOMNode().querySelector('input').value = '';
	        this.refs.toDate.getDOMNode().querySelector('input').value = '';
	    },
	    isEmpty: function isEmpty() {
	        var process = _.get(this.props, 'orderProcessHydrated', {});
	        return DashboardModalUtils.isEmptyProcess(process);
	    },
	    render: function render() {
	        var _props = this.props,
	            orderProcessHydrated = _props.orderProcessHydrated,
	            uniqueId = _props.uniqueId;
	
	        var styleInputs = {
	            marginTop: '-10px',
	            height: '40px',
	            lineHeight: '25px',
	            width: 'initial'
	        };
	
	        return React.createElement("li", { key: uniqueId, className: "dashboard-modal-task-collapsible-content row", style: {
	                listStyle: 'none'
	            } }, React.createElement("label", { className: "dashboard-modal-task-collapsible-content__label text-left col-xs-offset-1 col-xs-2" }, orderProcessHydrated.label), React.createElement("div", { className: "dashboard-modal-task-collapsible-content__time col-xs-2" }, React.createElement(TimePicker, {
	            hintText: t('dashboard_modal_task_qc_start'),
	            style: styleInputs,
	            ref: "fromDate",
	            key: 'fromDate-' + uniqueId,
	            onChange: this._onChangeFromDate })), React.createElement("div", { className: "dashboard-modal-task-collapsible-content__time col-xs-2" }, React.createElement(TimePicker, {
	            hintText: t('dashboard_modal_task_qc_end'),
	            style: styleInputs,
	            ref: "toDate",
	            key: 'toDate-' + uniqueId,
	            onChange: this._onChangeToDate })), React.createElement("div", { className: "dashboard-modal-task-collapsible-content__input col-xs-1" }, React.createElement(TextField, {
	            onBlur: this._onChangeNote,
	            floatingLabelText: t('dashboard_modal_task_qc_total'),
	            value: this.state.total,
	            disabled: true,
	            key: 'timeTotal-' + uniqueId })), React.createElement("div", { className: "dashboard-modal-task-collapsible-content__note col-xs-3" }, React.createElement(TextField, {
	            onBlur: this._onChangeNote,
	            floatingLabelText: t('dashboard_modal_task_qc_note'),
	            value: this.state.note || _.get(orderProcessHydrated, 'note', ''),
	            key: 'timeNote-' + uniqueId }), React.createElement("i", { title: t('dashboard_modal_task_delete_process'),
	            style: {
	                display: this.isEmpty() ? 'none' : 'initial'
	            },
	            className: "material-icons md-16 ",
	            onClick: this._onDeleteProcess }, "delete")));
	    }
	});
	
	module.exports = DashboardModalTaskCollapsibleItem;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(396);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(1),
	    PropTypes = _require.PropTypes,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    _require3 = __webpack_require__(8),
	    find = _require3.find,
	    map = _require3.map,
	    every = _require3.every,
	    some = _require3.some,
	    filter = _require3.filter,
	    DashboardServiceCache = __webpack_require__(28),
	    get = __webpack_require__(5).get,
	    _require4 = __webpack_require__(37),
	    delay = _require4.delay,
	    _require5 = __webpack_require__(5),
	    merge = _require5.merge,
	    NumberUtils = __webpack_require__(23),
	    ContentUtils = __webpack_require__(7),
	    OrderUtils = __webpack_require__(49),
	    SessionStore = __webpack_require__(11),
	    BrewhouseStore = __webpack_require__(96),
	    DateUtils = __webpack_require__(22),
	    _require6 = __webpack_require__(2),
	    TIME_WAIT_MODAL_REFRESH_EXPAND = _require6.TIME_WAIT_MODAL_REFRESH_EXPAND,
	    InventoryStore = __webpack_require__(20),
	    DashboardModalTaskCollapsibleItemAmountSmall = __webpack_require__(727),
	    _require7 = __webpack_require__(12),
	    FontIcon = _require7.FontIcon,
	    TextField = _require7.TextField,
	    Toggle = _require7.Toggle;
	
	
	var DashboardModalTaskCollapsibleItemAmount = React.createClass({ displayName: "DashboardModalTaskCollapsibleItemAmount",
	
	    propTypes: {
	        task: PropTypes.object,
	        product: PropTypes.object,
	        uniqueId: PropTypes.string,
	        amount: PropTypes.number,
	        locations: PropTypes.array,
	        allowToConfirmProduct: PropTypes.boolean,
	        shouldBeDisabled: PropTypes.boolean,
	        onChangeAmountInLocation: PropTypes.func.isRequired,
	        onChangeProducts: PropTypes.func.isRequired,
	        onChangeVolumeItem: PropTypes.func.isRequired,
	        renderItemAgain: PropTypes.func.isRequired,
	        onChangeAmountItem: PropTypes.func.isRequired,
	        onConfirmProduct: PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isCollapsed: true,
	            isDisabled: true,
	            isFocusAmountField: false,
	            isFocusVolumeField: false,
	            amount: '',
	            isCalculatingInventory: SessionStore.isCalculatingInventory(),
	            currencyInfo: NumberUtils.getCurrentCurrency(),
	            vendorItems: DashboardServiceCache.getVendorItems()
	        };
	    },
	    onToggleExpand: function onToggleExpand() {
	        this.setState(function (prevState) {
	            return {
	                isCollapsed: !prevState.isCollapsed
	            };
	        });
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        var _this = this;
	
	        var product = this.props.product;
	
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	
	        delay(function () {
	            var amount = get(product, 'customAmount') || get(product, 'amount') || '';
	            var haveAmountDefined = !!amount;
	            if (!_this.isMounted()) {
	                // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	                return;
	            }
	            if (_this.refs.inputValue) {
	                _this.refs.inputValue.setValue(haveAmountDefined ? NumberUtils.formatDecimal(get(product, 'customAmount') || get(product, 'amount') || '') : '');
	            }
	            if (_this.refs.inputVolumeValue) {
	                _this.refs.inputVolumeValue.setValue(haveAmountDefined ? NumberUtils.formatDecimal(get(product, 'customVolume') || get(product, 'volume') || '') : '');
	            }
	
	            if (_this.state.isDisabled && haveAmountDefined && NumberUtils.isGreater(amount, 0)) {
	                _this.forceUpdate(); // need to sync the amount display of amount of the component.
	                _this.props.renderItemAgain();
	            }
	        }, TIME_WAIT_MODAL_REFRESH_EXPAND); // these need to be longer than time expend on product scope hydratation from DashboardModal[B|S][New|Change] _onToggleExpand function timeout.
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var amount = get(nextProps, 'product.amount', 0);
	        var endDate = get(nextProps, 'product.endDate') || get(nextProps, 'task.date');
	        var isDisabled = NumberUtils.isLessOrEquals(amount, 0);
	        this.setState({
	            amount: amount,
	            isDisabled: isDisabled
	        }, function () {
	            if (!_this2.isMounted()) {
	                // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	                return;
	            }
	            if (endDate && _this2.refs.toDate) {
	                _this2.refs.toDate.setTime(DateUtils.toDateFromFullDate(endDate));
	            }
	        });
	    },
	    _onChangeAmountSmall: function _onChangeAmountSmall(productItem, evt) {
	        var _props = this.props,
	            onChangeProducts = _props.onChangeProducts,
	            product = _props.product,
	            uniqueId = _props.uniqueId,
	            task = _props.task;
	
	        var newAmount = get(evt, 'target.value');
	        var itemId = get(productItem, 'item.id');
	
	        // update the amount of the product item
	        var productUpdated = InventoryStore.changeAmountOfProductItem(product, itemId, newAmount);
	
	        // each time we need to update product amount, we reset flag
	        // just in case that we change amount from one particular location
	        productUpdated = InventoryStore.turnOffWhereInventoryWasTakenNonChanged(productUpdated);
	
	        var avoidMultiplyItemByAmountProduct = true;
	
	        // We need to clear all where inventory was taken because we are changing
	        // the parent amount, to need to re-calculate inventory again.
	        productUpdated = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdated);
	        // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
	        productUpdated.isNeededCalculateInventory = undefined;
	
	        onChangeProducts(productUpdated, productUpdated.amount, uniqueId, task, avoidMultiplyItemByAmountProduct);
	    },
	    _onChangeAmountInLocation: function _onChangeAmountInLocation(productItemUpdated) {
	        var _props2 = this.props,
	            onChangeProducts = _props2.onChangeProducts,
	            product = _props2.product,
	            uniqueId = _props2.uniqueId,
	            task = _props2.task;
	
	        // update product items which are location amount updated
	
	        var productUpdated = InventoryStore.updateProductItemFromProduct(product, productItemUpdated);
	
	        var avoidMultiplyItemByAmountProduct = true;
	        onChangeProducts(productUpdated, productUpdated.amount, uniqueId, task, avoidMultiplyItemByAmountProduct);
	    },
	    _onChangeAmount: function _onChangeAmount() {
	        var _props3 = this.props,
	            onChangeProducts = _props3.onChangeProducts,
	            product = _props3.product,
	            uniqueId = _props3.uniqueId,
	            task = _props3.task;
	
	
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	
	        if (this.refs.inputValue) {
	            var newAmount = NumberUtils.standardiseDecimalFormatNumber(this.refs.inputValue.getValue());
	            var amountOld = get(find(get(task, 'products'), function (p) {
	                return p.id === product.id;
	            }), 'amount');
	            var isSameAmount = NumberUtils.isEqual(newAmount, amountOld);
	
	            if (isSameAmount) {
	                this._onBlurFocusableElement();
	                return;
	            }
	
	            var isDisabled = newAmount === 0 || newAmount === undefined;
	            var haveAmountDefined = NumberUtils.isGreater(newAmount, 0);
	            this._onBlurFocusableElement();
	            this.setState(function (prevState) {
	                return {
	                    isCollapsed: haveAmountDefined ? prevState.isCollapsed : true,
	                    isDisabled: haveAmountDefined ? isDisabled : true
	                };
	            }, function () {
	                if (onChangeProducts !== undefined) {
	                    // each time we need to update product amount, we reset flag
	                    // just in case that we change amount from one particular location
	                    var productUpdated = InventoryStore.turnOffWhereInventoryWasTakenNonChanged(product);
	                    var productUpdatedByAmount = InventoryStore.onChangeProductByAmount(productUpdated, newAmount);
	
	                    // We need to clear all where inventory was taken because we are changing
	                    // the parent amount, to need to re-calculate inventory again.
	                    productUpdated = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdated);
	                    // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
	                    productUpdated.isNeededCalculateInventory = undefined;
	
	                    onChangeProducts(productUpdatedByAmount, newAmount, uniqueId, task);
	                }
	            });
	        }
	    },
	    _onChangeVolume: function _onChangeVolume() {
	        var _props4 = this.props,
	            onChangeVolumeItem = _props4.onChangeVolumeItem,
	            product = _props4.product,
	            uniqueId = _props4.uniqueId,
	            task = _props4.task;
	
	        if (this.refs.inputVolumeValue) {
	            var newPorcent = NumberUtils.standardiseDecimalFormatNumber(this.refs.inputVolumeValue.getValue());
	            var oldPorcent = get(find(get(task, 'products'), function (p) {
	                return p.id === product.id;
	            }), 'volume');
	            var isSamePorcent = NumberUtils.isEqual(newPorcent, oldPorcent);
	
	            if (isSamePorcent) {
	                this._onBlurFocusableElement();
	                return;
	            }
	
	            var isDisabled = newPorcent === 0 || newPorcent === undefined;
	            var haveAmountDefined = NumberUtils.isGreater(newPorcent, 0);
	
	            this._onBlurFocusableElement();
	            this.setState(function (prevState) {
	                return {
	                    isCollapsed: haveAmountDefined ? prevState.isCollapsed : true,
	                    isDisabled: haveAmountDefined ? isDisabled : true
	                };
	            }, function () {
	                if (onChangeVolumeItem !== undefined) {
	                    var productUpdatedByVolume = InventoryStore.onChangeProductByVolume(product, newPorcent);
	                    // We need to clear all where inventory was taken because we are changing
	                    // the parent amount, to need to re-calculate inventory again.
	                    productUpdatedByVolume = OrderUtils.cleanAllWhereInventoryWasTakenByProduct(productUpdatedByVolume);
	                    // The following needs to be `undefined`, are related with InventoryStore.onChangeProducts and InventoryStore._hydrateOrderTaskWithInventoryScopeEstimationByTask
	                    productUpdatedByVolume.isNeededCalculateInventory = undefined;
	                    onChangeVolumeItem(productUpdatedByVolume, newPorcent, uniqueId, task);
	                }
	            });
	        }
	    },
	    _getIconToggleEl: function _getIconToggleEl() {
	        var _state = this.state,
	            isCollapsed = _state.isCollapsed,
	            isDisabled = _state.isDisabled;
	
	        var couldExpand = !isDisabled && !this.state.isCollapsed;
	        var classNameIconPlus = couldExpand ? 'material-icons modal-order-task-list-item__receipe is-body is-expanded' : 'material-icons modal-order-task-list-item__receipe is-body';
	
	        return React.createElement("span", { className: classNameIconPlus }, isCollapsed || isDisabled ? React.createElement("i", { style: {
	                color: isDisabled ? '#d5d5d5' : 'initial',
	                cursor: isDisabled ? 'default' : 'pointer'
	            },
	            "data-test-id": "icon-button-detail-product",
	            title: t('dashboard_modal_task_customize_items'),
	            className: "material-icons md-16",
	            onClick: this.onToggleExpand }, "add_circle_outline") : React.createElement("i", { title: t('dashboard_modal_task_customize_items'),
	            "data-test-id": "icon-button-detail-product",
	            className: "material-icons md-16",
	            onClick: this.onToggleExpand }, "remove_circle_outline"));
	    },
	    _getProductItemsEl: function _getProductItemsEl(productUpdated, locations) {
	        var _this3 = this;
	
	        var _state2 = this.state,
	            isCollapsed = _state2.isCollapsed,
	            isDisabled = _state2.isDisabled;
	        var task = this.props.task;
	
	        var isConfirmed = get(productUpdated, 'isConfirmed');
	        var productItems = ContentUtils.filterEnable(get(productUpdated, 'items'));
	        // filter product items addition, because is not need to show it
	        var productItemsFiltered = filter(productItems, function (productItem) {
	            return get(productItem, 'addition') !== true;
	        });
	        var productItemsSorted = ContentUtils.sortList(productItemsFiltered, 'item.description');
	
	        return isCollapsed || isDisabled ? null : React.createElement("ul", null, map(productItemsSorted, function (productItem) {
	            return React.createElement(DashboardModalTaskCollapsibleItemAmountSmall, {
	                amount: _this3._getItemAmount(productItem),
	                onChangeAmountInLocation: _this3._onChangeAmountInLocation,
	                locations: locations,
	                isConfirmed: isConfirmed,
	                task: task,
	                productItem: productItem,
	                product: productUpdated,
	                onChangeAmount: _this3._onChangeAmountSmall });
	        }));
	    },
	    _getItemAmount: function _getItemAmount(productItem) {
	        // get first manual amount, then estimated amount, and finally original amount of item.
	        // Here should be reduce all where inventory was taken from the productItem
	        var adjustAmountValue = +get(productItem, 'adjustAmount');
	        var adjustAmountValueSafe = ContentUtils.isNull(adjustAmountValue) || adjustAmountValue === 0 || adjustAmountValue === 'NaN' ? undefined : adjustAmountValue;
	
	        return adjustAmountValueSafe || get(productItem, 'manualAmount') || get(productItem, 'estimateAmount') || get(productItem, 'amount', 0);
	    },
	    _getIconInventoryIndicator: function _getIconInventoryIndicator(product) {
	        var productAmount = get(product, 'amount') || 0;
	        var haveAmount = NumberUtils.isGreater(productAmount, 0);
	        var hasConfirm = get(product, 'isConfirmed');
	        var hasDiscounted = get(product, 'isDiscounted');
	
	        if (!haveAmount || hasConfirm || !hasConfirm && hasDiscounted) {
	            // enter here means we don't need the icon of
	            // inventory status
	            return;
	        }
	
	        //const productUpdated = _hydrateItemsFromProduct(product);
	        var productItems = get(product, 'items');
	
	        // remove product item addition
	        productItems = filter(productItems, function (productItem) {
	            return get(productItem, 'addition') !== true && NumberUtils.isGreater(get(productItem, 'amount'), '0');
	        });
	
	        // check if all the item have enough item in existing inventory
	        var isEnoughInventory = every(productItems, function (productItem) {
	            return productItem.isEnoughInventory;
	        });
	
	        // check if at least have some items, to indicate that some items was discounted
	        var existItemInStock = some(productItems, function (productItem) {
	            return productItem.existItemInStock;
	        });
	
	        // in case that non exist enough item in inventory check if at least is
	        // already purchased (Check for more information {@link InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation)}
	        var isPurchased = InventoryStore.isSomeItemAlreadyPurchased(productItems);
	
	        // indicate that some purchase not was enough
	        var missingPurchase = !isEnoughInventory && some(productItems, function (productItem) {
	            return !productItem.isEnoughInventory && !productItem.isPurchasedAmountEnough;
	        });
	
	        if (!product || !product.amount) {
	            // enter here means don't have product yet
	            return null;
	        }
	
	        var topPosition = 25;
	        var iconsEl = [];
	        var horizontalIndex = -30;
	        var initialOffeset = 4;
	
	        if (existItemInStock) {
	            horizontalIndex += 30 + initialOffeset;
	            initialOffeset = 0;
	            iconsEl.push({
	                type: 'STOCK',
	                el: React.createElement(FontIcon, {
	                    "data-inventory-info": "enough_inventory",
	                    style: {
	                        fontSize: '12px;',
	                        top: topPosition + 'px',
	                        padding: '3px',
	                        borderRadius: '50%',
	                        border: 'solid 2px black',
	                        position: 'absolute',
	                        backgroundColor: '#0f9d58',
	                        right: '-' + horizontalIndex + 'px'
	                    },
	                    className: "material-icons"
	                }, "home")
	            });
	        }
	
	        if (isPurchased) {
	            horizontalIndex += 30 + initialOffeset;
	            initialOffeset = 0;
	            iconsEl.push({
	                type: 'PURCHASE',
	                el: React.createElement(FontIcon, {
	                    "data-inventory-info": "need_purchase",
	                    style: {
	                        fontSize: '12px;',
	                        top: topPosition + 'px',
	                        padding: '3px',
	                        borderRadius: '50%',
	                        border: 'solid 2px black',
	                        position: 'absolute',
	                        backgroundColor: '#fcca2e',
	                        right: '-' + horizontalIndex + 'px'
	                    },
	                    className: "material-icons"
	                }, "shopping_cart")
	            });
	        }
	
	        if (missingPurchase || !isEnoughInventory && !isPurchased) {
	            horizontalIndex += 30 + initialOffeset;
	            initialOffeset = 0;
	            iconsEl.push({
	                type: 'MISSING',
	                el: React.createElement(FontIcon, {
	                    "data-inventory-info": "not_inventory",
	                    style: {
	                        fontSize: '12px;',
	                        top: topPosition + 'px',
	                        padding: '3px',
	                        borderRadius: '50%',
	                        border: 'solid 2px black',
	                        position: 'absolute',
	                        backgroundColor: '#db4437',
	                        right: '-' + horizontalIndex + 'px'
	                    },
	                    className: "material-icons"
	                }, "shopping_cart")
	            });
	        }
	
	        return iconsEl;
	    },
	    _getToggleConfirmProduct: function _getToggleConfirmProduct(product, uniqueId, onConfirmProduct, task) {
	        var _state3 = this.state,
	            isFocusAmountValue = _state3.isFocusAmountValue,
	            isFocusVolumeValue = _state3.isFocusVolumeValue,
	            isCalculatingInventory = _state3.isCalculatingInventory;
	
	        var shouldHideToggle = isFocusAmountValue || isFocusVolumeValue;
	        var isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;
	        var haveProductAmount = NumberUtils.isGreater(get(product, 'amount'), '0');
	        var itemsSubtraction = filter(get(product, 'items'), function (item) {
	            return !item.addition;
	        });
	        var haveSomeItemMissing = InventoryStore.haveMissingItemWhereLocationWasSubtract(itemsSubtraction);
	
	        var toggleEl = shouldHideToggle || !this.isMounted() ? null : isCalculatingInventory ? React.createElement("div", null, React.createElement("label", null, t('dashboard_modal_task_confirmed')), React.createElement(Toggle, {
	            name: "isConfirmProduct",
	            defaultToggled: product.isConfirmed,
	            defaultValue: product.isConfirmed,
	            onToggle: onConfirmProduct.bind(this, product, uniqueId, task) })) : null;
	
	        var restrictedLabelEl = isDisconfirmingPublishedProduct ? React.createElement("label", null, t('dashboard_modal_task_items_return_inventory_label')) : null;
	
	        var className = 'dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-confirm col-xs-2';
	        if (restrictedLabelEl) {
	            className += ' is-restricted';
	        }
	
	        return haveProductAmount && !haveSomeItemMissing ? React.createElement("div", {
	            className: className }, restrictedLabelEl ? restrictedLabelEl : toggleEl) : null;
	    },
	    _onFocusElement: function _onFocusElement(focusField) {
	        switch (focusField) {
	            case 'AMOUNT':
	                this.setState({
	                    isFocusAmountValue: true,
	                    isFocusVolumeValue: false
	                });
	                break;
	            case 'VOLUME':
	                this.setState({
	                    isFocusAmountValue: false,
	                    isFocusVolumeValue: true
	                });
	                break;
	        }
	    },
	    _onBlurFocusableElement: function _onBlurFocusableElement() {
	        this.setState({
	            isFocusAmountValue: false,
	            isFocusVolumeValue: false
	        });
	    },
	    _getRowEditable: function _getRowEditable(product, uniqueId, onConfirmProduct, task, isCalculatingInventory) {
	        var styleInputs = {
	            marginTop: '-10px',
	            height: '40px',
	            lineHeight: '25px',
	            width: 'initial'
	        };
	
	        var _props5 = this.props,
	            allowToConfirmProduct = _props5.allowToConfirmProduct,
	            shouldBeDisabled = _props5.shouldBeDisabled;
	
	        var isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;
	        var productItems = get(product, 'items');
	        var isTaskAfterToDay = DateUtils.isAfterToDay(product.taskDate); // not included today
	        var productItemsSubtraction = filter(productItems, function (productItem) {
	            return !productItem.addition;
	        }) || [];
	        var productItemsAddition = filter(productItems, function (productItem) {
	            return productItem.addition;
	        }) || [];
	        var thereIsNotItemSubstractionAndAddition = productItemsSubtraction && productItemsSubtraction.length === 0 && productItemsAddition && productItemsAddition.length === 0;
	        var thereIsNotItemSubstraction = productItemsSubtraction && productItemsSubtraction.length === 0;
	        var iconInventoryIndicator = this._getIconInventoryIndicator(product);
	        var someItemNeedPurchaseOrIsMissing = some(iconInventoryIndicator, function (info) {
	            return get(info, 'type') === 'PURCHASE' || get(info, 'type') === 'MISSING';
	        });
	        var items = get(product, 'items', []) || [];
	        var productCost = BrewhouseStore.calculateCostByItems(items, this.state.vendorItems);
	        console.log(productCost);
	
	        // this flag indicate if possible to confirm manually
	        // the discount of the items of the product against to inventory
	        var showConfirmProduct = someItemNeedPurchaseOrIsMissing ? false : !DateUtils.isAfterToDayFullDate(product.endDate || task.date);
	        var iconToggleEl = thereIsNotItemSubstraction ? null : this._getIconToggleEl();
	        var isProductConfirmed = get(product, 'isConfirmed');
	        var toggleConfirmProductEl = isTaskAfterToDay && isCalculatingInventory || thereIsNotItemSubstractionAndAddition ? null : !allowToConfirmProduct ? React.createElement("label", { className: "dashboard-modal-task-collapsible-content__is-disabled-confirmed-product" }, t('dashboard_modal_task_confirm_prior'), React.createElement("br", null), t('dashboard_modal_task_icon_first')) : isDisconfirmingPublishedProduct || showConfirmProduct ? this._getToggleConfirmProduct(product, uniqueId, onConfirmProduct, task) : null;
	
	        var inputsShouldBeDisable = shouldBeDisabled ? true : isDisconfirmingPublishedProduct || isProductConfirmed ? true : false;
	
	        return React.createElement("li", { key: 'content__list-' + uniqueId, className: "dashboard-modal-task-collapsible-content dashboard-modal-task-collapsible-content__list-header row",
	            style: {
	                listStyle: 'none'
	            } }, React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-name col-xs-2" }, React.createElement("label", null, t('dashboard_modal_task_products_name')), React.createElement("div", null, get(product, 'name') + ' ')), React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-amount col-xs-2" }, React.createElement("label", null, t('dashboard_modal_task_products_amount') + ' ', React.createElement("small", null, t('dashboard_modal_task_products_unit'))), React.createElement(TextField, {
	            key: 'text-amount-' + uniqueId,
	            onBlur: this._onChangeAmount.bind(this),
	            onFocus: this._onFocusElement.bind(this, 'AMOUNT'),
	            ref: "inputValue",
	            hintText: t('dashboard_modal_task_products_amount'),
	            style: styleInputs,
	            defaultValue: get(product, 'customAmount') || get(product, 'amount') || '',
	            disabled: inputsShouldBeDisable
	        })), React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-volume col-xs-2" }, React.createElement("label", null, t('dashboard_modal_task_products_volume') + ' ', React.createElement("small", null, "(", DashboardServiceCache.getCurrentUnitTank(), ")")), React.createElement(TextField, {
	            key: 'text-amount-' + uniqueId,
	            onBlur: this._onChangeVolume.bind(this),
	            onFocus: this._onFocusElement.bind(this, 'VOLUME'),
	            ref: "inputVolumeValue",
	            hintText: t('dashboard_modal_task_products_volume'),
	            style: styleInputs,
	            disabled: inputsShouldBeDisable
	        })), React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-product-cost col-xs-2" }, React.createElement(TextField, {
	            floatingLabelText: t('dashboard_modal_footer_product_cost'),
	            value: get(this.state.currencyInfo, 'symbol') + ' ' + productCost,
	            disabled: true,
	            style: styleInputs,
	            key: 'productCost-' + uniqueId })), React.createElement("div", { className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-end-hour col-xs-2" }, toggleConfirmProductEl), React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-more-detail col-xs-1" }, React.createElement("span", null, map(iconInventoryIndicator, function (info) {
	            return get(info, 'el');
	        }) || null), iconToggleEl));
	    },
	    _getRowNonEditable: function _getRowNonEditable(productUpdated, uniqueId) {
	        var messageError = get(productUpdated, 'name') + ' ' + t('dashboard_modal_task_inline_error_without_items_yet');
	        return React.createElement("li", { key: 'content__list-' + uniqueId, className: "dashboard-modal-task-collapsible-content  dashboard-modal-task-collapsible-content__list-header row",
	            style: {
	                listStyle: 'none'
	            } }, React.createElement("label", {
	            className: "dashboard-modal-task-collapsible-content__label dashboard-modal-task-collapsible-content__label-product-name text-left col-xs-offset-1 col-xs-2" }, (get(productUpdated, 'item.description') || '') + ' ' + (get(productUpdated, 'item.unit') || '')), React.createElement("div", {
	            className: "dashboard-modal-task-collapsible-content__input dashboard-modal-task-collapsible-content__input-amount col-xs-6" }, React.createElement(FontIcon, {
	            style: {
	                position: 'absolute',
	                right: '165px',
	                top: '3px',
	                fontSize: '18px',
	                color: '#fcca2e'
	            },
	            className: "material-icons"
	        }, "warning"), " ", messageError));
	    },
	    render: function render() {
	        var _props6 = this.props,
	            product = _props6.product,
	            uniqueId = _props6.uniqueId,
	            locations = _props6.locations,
	            onConfirmProduct = _props6.onConfirmProduct,
	            task = _props6.task;
	        var isCalculatingInventory = this.state.isCalculatingInventory;
	
	        var sortedLocations = ContentUtils.sortListDesc(locations, 'id');
	        var productUpdated = _hydrateProduct(product);
	        var productUpdatedWithItems = _hydrateItemsFromProduct(productUpdated);
	
	        var productItems = get(productUpdatedWithItems, 'items');
	        var haveProductItems = get(productItems, 'length', 0) > 0;
	        var inputAmount = haveProductItems ? this._getRowEditable(productUpdated, uniqueId, onConfirmProduct, task, isCalculatingInventory) : this._getRowNonEditable(productUpdated, uniqueId);
	
	        var productItemsEl = this._getProductItemsEl(productUpdated, sortedLocations);
	
	        return React.createElement("div", { key: 'content-' + uniqueId, className: "dashboard-modal-item-amount" }, React.createElement("div", { className: "dashboard-modal-item-amount__header" }, inputAmount), React.createElement("div", { className: "dashboard-modal-item-amount__list" }, productItemsEl));
	    }
	});
	
	function _hydrateProduct(product) {
	    var fullProducts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DashboardServiceCache.getProducts();
	
	    var productTarget = find(fullProducts, function (fullProduct) {
	        return get(fullProduct, 'id') === get(product, 'id');
	    });
	    // complete each product task with full product info
	    var productUpdated = merge(productTarget, product);
	
	    return productUpdated;
	}
	
	function _hydrateItemsFromProduct(productUpdated) {
	    var itemsDry = get(productUpdated, 'items');
	
	    if (ContentUtils.isNotEmptyArray(itemsDry)) {
	        var itemsfull = DashboardServiceCache.getItems();
	        var itemsUpdated = [];
	
	        var _loop = function _loop() {
	            if (_isArray) {
	                if (_i >= _iterator.length) return 'break';
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) return 'break';
	                _ref = _i.value;
	            }
	
	            var productItemDry = _ref;
	
	            var itemDry = get(productItemDry, 'item');
	            var itemDryId = get(productItemDry, 'itemId') || get(itemDry, 'id');
	            var itemTarget = find(itemsfull, function (item) {
	                return get(item, 'id') === itemDryId;
	            });
	            var itemUpdate = merge(itemTarget, itemDry);
	
	            productItemDry.item = itemUpdate;
	            itemsUpdated.push(productItemDry);
	        };
	
	        for (var _iterator = itemsDry, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            var _ret = _loop();
	
	            if (_ret === 'break') break;
	        }
	        productUpdated.items = itemsUpdated;
	    }
	    return productUpdated;
	}
	
	module.exports = DashboardModalTaskCollapsibleItemAmount;

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1343);
	
	var React = __webpack_require__(1),
	    AppDispatcher = __webpack_require__(42),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    find = _require3.find,
	    filter = _require3.filter,
	    some = _require3.some,
	    get = __webpack_require__(5).get,
	    InventoryStore = __webpack_require__(20),
	    NumberUtils = __webpack_require__(23),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    DashboardServiceCache = __webpack_require__(28),
	    ContentUtils = __webpack_require__(7),
	    Chips = __webpack_require__(698),
	    _require4 = __webpack_require__(12),
	    TextField = _require4.TextField,
	    FontIcon = _require4.FontIcon,
	    IconButton = _require4.IconButton;
	
	
	var DashboardModalTaskCollapsibleItemAmountSmall = React.createClass({ displayName: "DashboardModalTaskCollapsibleItemAmountSmall",
	    propTypes: {
	        task: PropTypes.object,
	        product: PropTypes.object,
	        productItem: PropTypes.object,
	        onChangeAmount: PropTypes.func,
	        onChangeAmountInLocation: PropTypes.func,
	        uniqueId: PropTypes.string,
	        isConfirmed: PropTypes.string,
	        amount: PropTypes.number
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            isCollapsed: true,
	            isEditMode: false,
	            needConfirm: false,
	            locationsAmountChanged: [],
	            errors: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	        var amount = this.props.amount;
	
	        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
	    },
	    componentDidUpdate: function componentDidUpdate() {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	        var amount = this.props.amount;
	
	        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.isMounted()) {
	            // avoid several problem of rendering when try to call 'refs' which are not mounted yet
	            return;
	        }
	        var amount = nextProps.amount;
	
	        this.refs.inputValue.setValue(NumberUtils.truncate(amount));
	    },
	    getLocationSubtractionNonEditable: function getLocationSubtractionNonEditable(productItem, locations, whereInventoryWasTaken) {
	        var unit = get(productItem, 'unit');
	
	        // filter location item with zero
	        var whereInventoryWasTakenFiltered = filter(whereInventoryWasTaken, function (inventoryTaken) {
	            return !(get(inventoryTaken, 'type') === 'LOCATION_ITEM_MODULE' && NumberUtils.isEqual(get(inventoryTaken, 'amountSubtracted') || '0', '0'));
	        });
	
	        return map(whereInventoryWasTakenFiltered, function (inventoryTaken) {
	            var isFromStock = get(inventoryTaken, 'type') === 'LOCATION_ITEM_MODULE';
	            var isVendorPurchaseItem = get(inventoryTaken, 'type') === 'VENDOR_PURCHASE_ITEM_MODULE';
	            var isVendorPurchaseItemMissing = get(inventoryTaken, 'type') === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';
	
	            if (isFromStock) {
	                // is enough items or discount all and then
	                var iconInfo = productItem.existItemInStock ? { bgColor: '#0f9d58', icon: 'home' } : { bgColor: '#db4437', icon: 'error' };
	
	                var locationTarget = find(locations, function (location) {
	                    return get(location, 'id') === get(inventoryTaken, 'locationId');
	                });
	                var locationName = get(locationTarget, 'name') || '';
	                var amount = NumberUtils.truncate(get(inventoryTaken, 'amountSubtracted') || '');
	                var textShips = locationName + ' (' + amount + ' ' + unit + ')';
	                return React.createElement(Chips, {
	                    className: productItem.existItemInStock ? 'enough-inventory' : 'not-enough-inventory',
	                    onClickLink: function onClickLink() {
	                        //AppDispatcher.dispatch({
	                        //    type: ActionTypes.DASHBOARD_MODAL_CLOSE_MODAL
	                        //});
	                    },
	                    icon: "home",
	                    bgColorIcon: iconInfo.bgColor,
	                    text: textShips });
	            } else if (isVendorPurchaseItem) {
	                var _iconInfo = productItem.isPurchased ? { bgColor: '#fcca2e', icon: 'home' } : { bgColor: '#db4437', icon: 'error' };
	
	                var vendorPurchaseCode = get(inventoryTaken, 'code') || '';
	                var _amount = NumberUtils.truncate(get(inventoryTaken, 'amountSubtracted') || '');
	                var _textShips = 'PO #' + vendorPurchaseCode + ' (' + _amount + ' ' + unit + ')';
	
	                return React.createElement(Chips, {
	                    className: productItem.isPurchased ? 'is-purchased' : 'not-enough-inventory',
	                    icon: "shopping_cart",
	                    bgColorIcon: _iconInfo.bgColor,
	                    text: _textShips });
	            } else if (isVendorPurchaseItemMissing) {
	                var _iconInfo2 = { bgColor: '#db4437', icon: 'error' };
	                var _amount2 = NumberUtils.truncate(get(inventoryTaken, 'amountItemNeeded') || '');
	                var _textShips2 = t('dashboard_modal_task_inline_error_need_purchase') + ' (' + _amount2 + ' ' + unit + ')';
	
	                return React.createElement(Chips, {
	                    className: "is-item-missing not-enough-inventory",
	                    icon: "shopping_cart",
	                    bgColorIcon: _iconInfo2.bgColor,
	                    text: _textShips2 });
	            }
	        });
	    },
	    onChangeAmountInLocation: function onChangeAmountInLocation(location, whereInventoryWasTakenLocation, index, productItem, evt) {
	        var _props = this.props,
	            product = _props.product,
	            onChangeAmountInLocation = _props.onChangeAmountInLocation;
	
	        // prevent to re-calculate inventory
	
	        product.isNeededCalculateInventory = false;
	
	        var locationId = get(location, 'id');
	        var itemId = get(productItem, 'item.id');
	
	        // get the current amount in stock
	        var amountInStock = getAmountInStock(product, locationId, itemId);
	        // the new amount to subtract in give location
	        var newAmountLocationItem = evt.target.value;
	
	        var isNotEnoughStock = NumberUtils.isGreater(newAmountLocationItem, amountInStock);
	
	        if (isNotEnoughStock) {
	            var errorMessage = t('dashboard_modal_task_inline_error_max_amount_from_this_location_is') + ' ' + NumberUtils.truncate(amountInStock);
	            this.setState(function (prevState) {
	                var errors = prevState.errors || [];
	                // remove old error
	                errors = filter(errors, function (error) {
	                    return get(error, 'index') !== index;
	                });
	                // add new one
	                errors.push({ index: index, errorMessage: errorMessage });
	                return {
	                    errors: errors
	                };
	            });
	        } else {
	
	            var productItemUpdated = InventoryStore.onChangeAmountInLocation(productItem, newAmountLocationItem, locationId);
	            onChangeAmountInLocation.bind(this, productItemUpdated)();
	
	            this.setState(function (prevState) {
	                var errors = prevState.errors || [];
	                // remove old error
	                errors = filter(errors, function (error) {
	                    return get(error, 'index') !== index;
	                });
	                return {
	                    errors: errors
	                };
	            });
	        }
	    },
	    toggleEditMode: function toggleEditMode() {
	        this.setState(function (prevState) {
	            return {
	                isEditMode: !prevState.isEditMode,
	                errors: [] // clean old errors
	            };
	        });
	    },
	    getLocationSubtractionEditable: function getLocationSubtractionEditable() {
	        var _this = this;
	
	        var _props2 = this.props,
	            locations = _props2.locations,
	            productItem = _props2.productItem;
	
	        var sortedLocations = ContentUtils.sortListDesc(locations, 'id');
	        var errors = this.state.errors;
	
	        var whereInventoryWasTaken = get(productItem, 'whereInventoryWasTakenNew');
	        var itemId = get(productItem, 'item.id');
	        var unit = get(productItem, 'item.unit');
	        var whereInventoryWasTakenLocations = filter(whereInventoryWasTaken, function (whereWasTaken) {
	            return get(whereWasTaken, 'type') === 'LOCATION_ITEM_MODULE';
	        });
	        var haveLocationWasTaken = ContentUtils.isNotEmptyArray(whereInventoryWasTakenLocations);
	
	        var locationEditEl = map(ContentUtils.filterEnable(sortedLocations), function (location, index) {
	            var whereInventoryWasTakenLocation = haveLocationWasTaken ? find(whereInventoryWasTakenLocations, function (inventoryInfo) {
	                return get(inventoryInfo, 'locationId') === get(location, 'id') && get(inventoryInfo, 'itemId') === itemId;
	            }) : null;
	
	            var errorMessageText = get(find(errors, function (error) {
	                return get(error, 'index') === index;
	            }), 'errorMessage') || '';
	
	            return React.createElement("span", { "data-item-name": "", className: errorMessageText === '' ? 'dashboard-modal-item-small__item-input-small' : 'dashboard-modal-item-small__item-input-small is-error' }, React.createElement("small", { className: "location-name" }, get(location, 'name') + ' (' + unit + ')'), React.createElement(TextField, {
	                className: "amount-name",
	                onBlur: _this.onChangeAmountInLocation.bind(_this, location, whereInventoryWasTakenLocation, index, productItem),
	                hintText: t('dashboard_modal_task_products_amount'),
	                errorText: errorMessageText,
	                defaultValue: get(whereInventoryWasTakenLocation, 'amountSubtracted') || '0',
	                key: 'input-small-' + index,
	                disabled: false }));
	        });
	
	        return React.createElement("span", { className: "dashboard-modal-item-small__edit-location-content" }, locationEditEl);
	    },
	    textfieldAmountItem: function textfieldAmountItem(_ref) {
	        var styleInputs = _ref.styleInputs,
	            uniqueId = _ref.uniqueId,
	            isDisconfirmingPublishedProduct = _ref.isDisconfirmingPublishedProduct,
	            isConfirmed = _ref.isConfirmed,
	            isEditMode = _ref.isEditMode,
	            existSomeLocationToEdit = _ref.existSomeLocationToEdit,
	            productItem = _ref.productItem,
	            onChangeAmount = _ref.onChangeAmount,
	            buttonToggleEditModoEl = _ref.buttonToggleEditModoEl;
	
	        return React.createElement("div", { className: isConfirmed ? 'dashboard-modal-item-small__item is-confirmed' : 'dashboard-modal-item-small__item' }, React.createElement("span", {
	            className: "dashboard-modal-item-small__item-label text-right",
	            style: {
	                display: 'inline !important',
	                top: '7px',
	                left: '12px'
	            }
	        }, get(productItem, 'description') + ' (' + get(productItem, 'item.unit') + ')'), React.createElement("span", { className: "dashboard-modal-item-small__item-input" }, React.createElement(TextField, {
	            onBlur: onChangeAmount.bind(this, productItem),
	            ref: "inputValue",
	            hintText: t('dashboard_modal_task_products_amount'),
	            style: styleInputs,
	            key: uniqueId,
	            disabled: isDisconfirmingPublishedProduct || isConfirmed ? true : isEditMode && existSomeLocationToEdit })), React.createElement("span", { className: "dashboard-modal-item-small__toggle-edit" }, buttonToggleEditModoEl));
	    },
	    render: function render() {
	        var _props3 = this.props,
	            productItem = _props3.productItem,
	            uniqueId = _props3.uniqueId,
	            onChangeAmount = _props3.onChangeAmount,
	            locations = _props3.locations,
	            isConfirmed = _props3.isConfirmed,
	            product = _props3.product;
	
	        var sortedLocations = ContentUtils.sortListDesc(locations, 'id');
	        var isEditMode = this.state.isEditMode;
	
	        var styleInputs = {
	            marginTop: '-10px',
	            height: '40px',
	            lineHeight: '25px',
	            width: 'initial'
	        };
	
	        // ask if have at least one item in location to edit
	        // otherwise non needed the edit mode
	        var existSomeLocationToEdit = some(get(productItem, 'whereInventoryWasTakenNew'), function (whereInventoryWasTaken) {
	            return get(whereInventoryWasTaken, 'type') === 'LOCATION_ITEM_MODULE';
	        });
	
	        var isDisconfirmingPublishedProduct = !product.isConfirmed && product.isDiscounted;
	
	        // check if item will need to subtract or add
	        var isAddition = get(productItem, 'addition');
	        var buttonToggleEditMode = isConfirmed ? null : isEditMode ? React.createElement(IconButton, { onClick: this.toggleEditMode, className: "is-visibility-mode", touch: true }, React.createElement(FontIcon, { color: '#000000', className: "material-icons" }, "save")) : React.createElement(IconButton, { onClick: this.toggleEditMode, className: "is-edit-mode", touch: true }, React.createElement(FontIcon, { color: '#000000', className: "material-icons" }, "mode_edit"));
	
	        var whereInventoryWasTaken = InventoryStore.retrieveLatestWhereInventoryWasTaken(productItem);
	
	        // filter location item with zero
	        var onlyItemMissing = get(whereInventoryWasTaken, 'length') === 1 && get(whereInventoryWasTaken, '0.type') === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE';
	
	        var singleItem = get(whereInventoryWasTaken, 'length') === 1;
	
	        var someItemPurchase = some(whereInventoryWasTaken, function (info) {
	            return get(info, 'type') === 'VENDOR_PURCHASE_ITEM_MODULE';
	        });
	        var withoutAnyStock = !some(whereInventoryWasTaken, function (info) {
	            return get(info, 'type') === 'LOCATION_ITEM_MODULE';
	        });
	
	        var extraItemClassName = '';
	
	        if (onlyItemMissing) {
	            extraItemClassName += ' is-all-item-missing';
	        }
	
	        if (singleItem) {
	            extraItemClassName += ' is-single-item';
	        }
	
	        if (someItemPurchase) {
	            extraItemClassName += ' is-some-item-purchase';
	        }
	
	        if (withoutAnyStock) {
	            extraItemClassName += ' is-without-stock';
	        }
	
	        // show where need to subtract in case of the item are subtraction
	        var locationsSubtractionInfoEl = isAddition || isDisconfirmingPublishedProduct ? null : isEditMode && !isConfirmed ? this.getLocationSubtractionEditable() : this.getLocationSubtractionNonEditable(productItem, sortedLocations, whereInventoryWasTaken);
	
	        // only show when we have at least one location to adjust
	        var buttonToggleEditModoEl = !isDisconfirmingPublishedProduct ? buttonToggleEditMode : null;
	
	        var textfieldAmountItemEl = this.textfieldAmountItem({
	            styleInputs: styleInputs,
	            uniqueId: uniqueId,
	            isDisconfirmingPublishedProduct: isDisconfirmingPublishedProduct,
	            isConfirmed: isConfirmed,
	            isEditMode: isEditMode,
	            existSomeLocationToEdit: existSomeLocationToEdit,
	            productItem: productItem,
	            onChangeAmount: onChangeAmount,
	            buttonToggleEditModoEl: buttonToggleEditModoEl
	        });
	
	        return React.createElement("li", {
	            key: uniqueId,
	            "data-item-description": get(productItem, 'item.description'),
	            className: "dashboard-modal-item-small",
	            style: { listStyle: 'none' }
	        }, textfieldAmountItemEl, React.createElement("div", { "data-item-description": get(productItem, 'item.description'), className: 'where-items-was-subtracted' + extraItemClassName }, locationsSubtractionInfoEl));
	    }
	});
	
	function getAmountInStock(product, locationId, itemId) {
	    // Calculate scope inventory again of each group of items & items
	    var locationItemsAvailable = DashboardServiceCache.getLocationItems();
	    var isUnconfirmedProductAlreadySaved = product.isConfirmed === false && product.isDiscounted;
	    if (isUnconfirmedProductAlreadySaved) {
	        // enter here means we need to simulate to return items to inventory in order to
	        // calculate the new adjust of amount of items of the product
	        locationItemsAvailable = InventoryStore.returnItemsConsumed(product, locationItemsAvailable);
	    }
	
	    var locationItemTarget = find(locationItemsAvailable, function (locationItem) {
	        return get(locationItem, 'location.id') === locationId && get(locationItem, 'item.id') === itemId;
	    });
	
	    // current existing stock in this location
	    return get(locationItemTarget, 'amount') || '0';
	}
	
	module.exports = DashboardModalTaskCollapsibleItemAmountSmall;

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1345);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(12),
	    AppBar = _require2.AppBar,
	    LeftNav = _require2.LeftNav,
	    MenuItem = _require2.MenuItem,
	    Styles = _require2.Styles,
	    Avatar = _require2.Avatar,
	    FontIcon = _require2.FontIcon,
	    IconButton = _require2.IconButton,
	    AppDispatcher = __webpack_require__(42),
	    Carousel = __webpack_require__(706),
	    CustomDialog = __webpack_require__(26),
	    _require3 = __webpack_require__(404),
	    getIconMenu = _require3.getIconMenu,
	    DashboardServiceCache = __webpack_require__(28),
	    Security = __webpack_require__(13).auth,
	    $ = __webpack_require__(188),
	    ga = __webpack_require__(18),
	    Constants = __webpack_require__(2),
	    get = __webpack_require__(5).get,
	    SettingModal = __webpack_require__(405),
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    SessionStore = __webpack_require__(11),
	    Colors = Styles.Colors,
	    ContentUtils = __webpack_require__(7),
	    PositionUtils = __webpack_require__(59),
	    actions = __webpack_require__(2).Analytics.actions,
	    categories = __webpack_require__(2).Analytics.categories;
	
	
	var HeaderSideBar = React.createClass({ displayName: "HeaderSideBar",
	  render: function render() {
	    return React.createElement("div", { className: "nav-bar-header is-free-version hidden-xs" }, React.createElement("img", { src: "/assets/images/logo-small.png" }));
	  }
	});
	
	var imageList = [{
	  imgSrc: '/assets/images/banner-v3.gif',
	  name: 'Brewplanner LLC',
	  link: 'https://www.brewplanner.com/videos',
	  index: 0
	}, {
	  imgSrc: '/assets/images/banner-v3.gif',
	  name: 'Brewplanner LLC',
	  link: 'https://www.brewplanner.com/videos',
	  index: 1
	}, {
	  imgSrc: '/assets/images/banner-v3.gif',
	  name: 'Brewplanner LLC',
	  link: 'https://www.brewplanner.com/videos',
	  index: 2
	}];
	
	var DASHBOARD_ID = '#dashboard-id';
	
	var Header = React.createClass({ displayName: "Header",
	
	  contextTypes: {
	    router: React.PropTypes.func
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      isSettingModalOpen: false
	    };
	  },
	  _toggleSettingModalShow: function _toggleSettingModalShow() {
	    this.setState(function (prevState) {
	      return {
	        isSettingModalOpen: !prevState.isSettingModalOpen
	      };
	    });
	  },
	  _onExit: function _onExit() {
	    var _this = this;
	
	    if (DashboardServiceCache.getPendingOperations().length > 0) {
	      CustomDialog.showWarningConfirmation(t('warning'), t('notification_warning_leave_dashboard_before_auto_saved'), function () {
	        _this._logout();
	      }, t('button_label_continue'), t('button_label_cancel'));
	    } else {
	      this._logout();
	    }
	  },
	  _logout: function _logout() {
	    Security.logout();
	    ga.event({
	      category: categories.APPLICATION,
	      action: actions.SIGN_OUT,
	      label: 'Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	    });
	  },
	  _printDashboard: function _printDashboard(e) {
	    e.preventDefault();
	
	    // remove selection dashboard to avoid problem when print the orders
	    AppDispatcher.dispatch({ type: ActionTypes.FORCE_CLEAN_ORDER_SELECTED_DASHBOARD });
	
	    setTimeout(function () {
	      var useWidth = $(DASHBOARD_ID).prop('scrollWidth');
	      var scrollHeight = $(PositionUtils.getParentScroll(document.querySelector(DASHBOARD_ID))).prop('scrollHeight');
	      var scrollY = -Math.abs(document.documentElement.scrollTop);
	      var useHeight = scrollHeight;
	
	      html2canvas(document.querySelector(DASHBOARD_ID), { width: useWidth, height: useHeight, scrollY: scrollY }).then(function (canvas) {
	        ReImg.fromCanvas(canvas).downloadPng();
	      });
	    }, 2000);
	  },
	  componentDidMount: function componentDidMount() {
	    this.refs.leftNav.close();
	  },
	  _onTouchLeftMenuBar: function _onTouchLeftMenuBar() {
	    this.refs.leftNav.toggle();
	  },
	  _onLeftNavChange: function _onLeftNavChange(e, key, payload) {
	    e.preventDefault();
	    if (key > 5) {
	      var tab = window.open(Constants.GO_PRO_URL, '_blank');
	      tab.focus();
	    } else {
	      this.context.router.transitionTo(payload.route, payload.param ? payload.param : undefined);
	    }
	  },
	  render: function render() {
	    var buttonRightBar = void 0,
	        appBarContent = void 0;
	
	    if (Security.loggedIn()) {
	      var iconButtonElement = React.createElement(IconButton, { className: "right-option-menu", touch: true }, React.createElement(Avatar, { className: "avatar-applicant",
	        src: Security.getCurrentApplicantLogoSrc() }, Security.getCurrentUserName()));
	      var exitIcon = React.createElement(FontIcon, { className: "material-icons" }, "exit_to_app");
	      var settingIcon = React.createElement(FontIcon, { className: "material-icons" }, "settings");
	      var printIcon = React.createElement(FontIcon, { className: "material-icons" }, "print");
	
	      buttonRightBar = getIconMenu.call(this, iconButtonElement, settingIcon, printIcon, exitIcon);
	      appBarContent = React.createElement("div", { style: {
	          display: 'inline-block',
	          lineHeight: 0
	        } }, React.createElement("img", { className: "bp-header__app-bar-logo", src: "/assets/images/logo-white_106x35.png" }), React.createElement(Carousel, { onClick: onClickBanner, items: imageList }));
	    } else {
	      buttonRightBar = null;
	      appBarContent = null;
	    }
	
	    var menuItems = [],
	        appBarStyle = 'app-bar';
	
	    if (Security.loggedIn()) {
	      menuItems = [{
	        route: 'tanks/page/:page',
	        param: { page: 0 },
	        text: t('dashboard_sidebar_tanks_sections'),
	        iconClassName: 'icon-bar icon-tanks-sections'
	      }, {
	        route: 'styleBeer',
	        text: t('dashboard_sidebar_beer_styles'),
	        iconClassName: 'icon-bar icon-beer-style-page-icon'
	      }, { route: 'tasks', text: t('dashboard_sidebar_tasks_qc'), iconClassName: 'icon-bar icon-process' }, {
	        route: 'icons-sections',
	        text: t('dashboard_sidebar_icons_in_sections'),
	        iconClassName: 'icon-bar icon-select-icon'
	      }, { route: 'help', text: t('dashboard_sidebar_help_contact'), iconClassName: 'icon-bar icon-help-page' }, {
	        route: '',
	        param: { page: 0 },
	        text: t('dashboard_sidebar_items'),
	        iconClassName: 'icon-bar icon-ingredients is-pro-version',
	        permission: 'ADMIN_ITEM_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_non_inventory_items'),
	        iconClassName: 'icon-bar icon-ingredients is-pro-version',
	        permission: 'ADMIN_ITEM_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_products'),
	        iconClassName: 'icon-bar icon-group-ingredients is-pro-version',
	        permission: 'ADMIN_PRODUCT_SHOW'
	      }, {
	        route: '',
	        param: { page: 0 },
	        text: t('dashboard_sidebar_inventory_transfers'),
	        iconClassName: 'icon-bar icon-inventory-and-tranfers is-pro-version',
	        permission: 'ADMIN_INVENTORY_AND_TRANSFERS_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_suppliers'),
	        iconClassName: 'icon-bar icon-vendors is-pro-version',
	        permission: 'ADMIN_VENDOR_SHOW'
	      }, {
	        route: '',
	        param: { page: 0 },
	        text: t('dashboard_sidebar_purchase_items'),
	        iconClassName: 'icon-bar icon-purchase-items is-pro-version',
	        permission: 'ADMIN_PURCHASE_SHOW'
	      }, {
	        route: '',
	        text: 'Customers',
	        iconClassName: 'icon-bar icon-customers is-pro-version',
	        permission: 'ADMIN_CUSTOMER_SHOW'
	      }, {
	        route: '',
	        param: { page: 0 },
	        text: t('dashboard_sidebar_sales_orders'),
	        iconClassName: 'icon-bar icon-Sales-order is-pro-version',
	        permission: 'ADMIN_SALE_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_locations'),
	        iconClassName: 'icon-bar icon-locations is-pro-version',
	        permission: 'ADMIN_LOCATION_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_users'),
	        iconClassName: 'icon-bar icon-user-access is-pro-version',
	        permission: 'ADMIN_USER_PERMISSION_SHOW'
	      }, {
	        route: '',
	        text: t('dsahboard_sidebar_user_access'),
	        iconClassName: 'icon-bar icon-user-access is-pro-version',
	        permission: 'ADMIN_USER_PERMISSION_SHOW'
	      }, {
	        route: '',
	        text: t('dashboard_sidebar_reports'),
	        iconClassName: 'icon-bar icon-reports is-pro-version',
	        permission: 'ADMIN_REPORT_SHOW'
	      }];
	      menuItems.unshift({
	        route: 'dashboard',
	        text: t('dashboard_sidebar_dashboard'),
	        iconClassName: 'icon-bar icon-dashboard-page'
	      });
	      appBarStyle += ' is-login';
	    } else {
	      menuItems.push({ type: MenuItem.Types.LINK, payload: ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/#/login', text: 'Log in' });
	    }
	
	    return React.createElement("div", {
	      className: 'bp-header app-bar' + (Security.loggedIn() ? ' is-login' : '')
	
	    }, React.createElement(SettingModal, {
	      isOpen: this.state.isSettingModalOpen,
	      onClose: this._toggleSettingModalShow }), React.createElement(AppBar, {
	      onLeftIconButtonTouchTap: this._onTouchLeftMenuBar,
	      iconElementRight: buttonRightBar,
	      className: "bp-header__app-bar",
	      style: {
	        backgroundColor: '#101112',
	        zIndex: 9
	      },
	      ref: "mainAppBar"
	    }, appBarContent), React.createElement(LeftNav, {
	      ref: "leftNav",
	      style: { fontWeight: '300' },
	      menuItemClassName: 'app-main__side-bar-item ' + (SessionStore.isFullPaidVersion() ? '' : ' is-free-version'),
	      menuItems: menuItems,
	      docked: false,
	      disableSwipeToOpen: true,
	      onChange: this._onLeftNavChange,
	      selectedIndex: -1,
	      backgroundColor: Colors.indigo900,
	      header: React.createElement(HeaderSideBar, null) }));
	  }
	});
	
	function onClickBanner(item) {
	  ga.event({
	    category: categories.ADVERTISEMENT_BANNER_CLICK,
	    action: actions.CLICK,
	    label: t('label_banner') + ' ' + get(item, 'name')
	  });
	}
	
	module.exports = Header;

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1347);
	
	var React = __webpack_require__(1),
	    ComponentUtils = __webpack_require__(77),
	    ContentUtils = __webpack_require__(7),
	    UserServiceImpl = __webpack_require__(181),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    Constants = __webpack_require__(2),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    find = _require3.find,
	    Uploader = __webpack_require__(231),
	    TextField = __webpack_require__(106),
	    _require4 = __webpack_require__(48),
	    findIndex = _require4.findIndex,
	    get = __webpack_require__(5).get,
	    Security = __webpack_require__(13).auth,
	    _require5 = __webpack_require__(12),
	    SelectField = _require5.SelectField,
	    Toggle = _require5.Toggle,
	    SessionStore = __webpack_require__(11);
	
	
	var SettingModalTabGeneral = React.createClass({ displayName: "SettingModalTabGeneral",
	
	    /**
	     * All currencies available
	     */
	    currencies: null,
	
	    /**
	     * All countries available
	     */
	    countries: null,
	
	    propType: {
	        model: PropTypes.object,
	        onChangeSettings: PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        // all currencies and countries available
	        this.currencies = __webpack_require__(187).currencies;
	        this.currencyDigits = __webpack_require__(314);
	        this.countries = __webpack_require__(313);
	        this.countries = ContentUtils.sortList(this.countries, 'name.common');
	        var currencyCode = get(SessionStore.getCurrentCurrency(), 'code');
	        var currencyDigitsCode = +get(SessionStore.getCurrentCurrencyDigits(), 'value');
	        var applicantAddress = SessionStore.getApplicantAddress();
	        var applicantPhone = SessionStore.getApplicantPhone();
	        var email = SessionStore.getApplicantEmail();
	        var applicantCityAndState = SessionStore.getApplicantCityAndState();
	        var applicantTaxId = SessionStore.getApplicantTaxId();
	        var applicantLogoSrc = Security.getCurrentApplicantLogoSrc();
	        var applicantDisplayName = SessionStore.getApplicantDisplayName();
	
	        var initialState = {
	            preferredCurrencyName: SessionStore.getCurrentCurrency(),
	            preferredCurrencyIndex: this._getCurrencyIndex(currencyCode),
	            preferredDigitsIndex: this._getCurrencyDigitsIndex(currencyDigitsCode),
	            preferredCountry: SessionStore.getCurrentCountry(),
	            preferredCountryIndex: this._getCountryIndex(SessionStore.getCurrentCountry()),
	            currentLanguageIndex: this._getCurrentLanguageIndex(),
	            isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
	            isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
	            isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging(),
	            isVisibleBrewingSection: SessionStore.isVisibleBrewingSection(),
	            isVisibleFermentingSection: SessionStore.isVisibleFermentingSection(),
	            isVisiblePackagingSection: SessionStore.isVisiblePackagingSection(),
	            applicantAddress: applicantAddress,
	            applicantPhone: applicantPhone,
	            email: email,
	            resultEmail: true,
	            applicantCityAndState: applicantCityAndState,
	            applicantTaxId: applicantTaxId,
	            applicantLogoSrc: applicantLogoSrc,
	            applicantDisplayName: applicantDisplayName
	        };
	
	        return initialState;
	    },
	    componentDidMount: function componentDidMount() {
	        this.props.onChangeSettings(this.state);
	    },
	    onChangeCurrency: function onChangeCurrency(event, indexCurrency, selectedCurrency) {
	        var _this = this;
	
	        var preferredCurrency = find(this.currencies, function (currency, index) {
	            return index === get(selectedCurrency, 'itemModel.payload');
	        });
	        var preferredCurrencyIndex = this._getCurrencyIndex(get(preferredCurrency, 'code'));
	
	        this.setState({
	            preferredCurrency: preferredCurrency,
	            preferredCurrencyIndex: preferredCurrencyIndex
	        }, function () {
	            _this.props.onChangeSettings({
	                currencyCode: get(_this.state.preferredCurrency, 'code'),
	                countryCode: get(_this.state.preferredCountry, 'cca2')
	            });
	        });
	    },
	    onChangeCurrencyDigits: function onChangeCurrencyDigits(event, indexCurrency, selectedCurrencyDigits) {
	        var _this2 = this;
	
	        var preferredDigits = get(selectedCurrencyDigits, 'text');
	        var preferredDigitsIndex = this._getCurrencyDigitsIndex(+preferredDigits);
	
	        this.setState({
	            preferredDigits: preferredDigits,
	            preferredDigitsIndex: preferredDigitsIndex
	        }, function () {
	            _this2.props.onChangeSettings({
	                currencyDigits: +preferredDigits
	            });
	        });
	    },
	    onChangeCountry: function onChangeCountry(evt, text, selectedItem) {
	        var _this3 = this;
	
	        var countryCurrencies = get(selectedItem, 'itemModel.currency');
	        var isCurrencyAll = countryCurrencies.indexOf('ALL') > -1;
	
	        var preferredCurrency = void 0;
	        var preferredCurrencyCode = void 0;
	        var preferredCountry = get(selectedItem, 'itemModel');
	
	        if (isCurrencyAll) {
	            // enter here means that this particular country we don't
	            // know which specific currency use, so we choose default
	            // currency defined
	            preferredCurrencyCode = get(SessionStore.getCurrentCurrency(), 'code');
	            preferredCurrency = find(this.currencies, function (currency) {
	                return get(currency, 'code') === preferredCurrencyCode;
	            });
	        } else {
	            preferredCurrencyCode = get(countryCurrencies, '0'); // chose the first one;
	            preferredCurrency = find(this.currencies, function (currency) {
	                return get(currency, 'code') === preferredCurrencyCode;
	            });
	        }
	
	        this.setState({
	            preferredCurrencyIndex: this._getCurrencyIndex(preferredCurrencyCode),
	            preferredCountryIndex: this._getCountryIndex(selectedItem.itemModel),
	            preferredCountry: preferredCountry,
	            preferredCurrency: preferredCurrency
	        }, function () {
	            _this3.props.onChangeSettings({
	                currencyCode: get(_this3.state.preferredCurrency, 'code'),
	                countryCode: get(_this3.state.preferredCountry, 'cca2'),
	                applicantPhone: get(_this3.state, 'applicantPhone'),
	                email: get(_this3.state, 'email'),
	                applicantAddress: get(_this3.state, 'applicantAddress')
	            });
	        });
	    },
	    _getCountryIndex: function _getCountryIndex(countrySelected) {
	        return findIndex(this.countries, function (country) {
	            return get(country, 'cca2') === get(countrySelected, 'cca2');
	        }) + 1;
	    },
	    _getCurrentLanguageIndex: function _getCurrentLanguageIndex() {
	        var currentLocale = SessionStore.getCurrentLanguage();
	        var targetIndex = Constants.LANGUAGE_ALLOWED.findIndex(function (value) {
	            return value.value === currentLocale;
	        });
	        return targetIndex === -1 ? 1 : targetIndex + 1; // added extra one to prepare index of element
	    },
	    _getCurrencyIndex: function _getCurrencyIndex(currencyCodeSelected) {
	        return findIndex(this.currencies, function (currency) {
	            return get(currency, 'code') === currencyCodeSelected;
	        }) + 1;
	    },
	    _getCurrencyDigitsIndex: function _getCurrencyDigitsIndex(currencyDigitsSelected) {
	        return findIndex(this.currencyDigits, function (digits) {
	            return +get(digits, 'value') === currencyDigitsSelected;
	        }) + 1;
	    },
	    _getCountryMenuItems: function _getCountryMenuItems() {
	        return ComponentUtils.toMenuItems(this.countries, 'name.common', 'location');
	    },
	    _getLanguageMenuItems: function _getLanguageMenuItems() {
	        var uniqueLenguage = map(Constants.LANGUAGE_ALLOWED, function (text) {
	            return { payload: text, text: text.display };
	        });
	        return ComponentUtils.toMenuItems(uniqueLenguage, 'text', 'location');
	    },
	    onChangeLanguage: function onChangeLanguage(value) {
	        var _this4 = this;
	
	        this.setState({ currentLanguageIndex: value.target.value }, function () {
	            var locale = Constants.LANGUAGE_ALLOWED[get(_this4.state, 'currentLanguageIndex') - 1];
	            _this4.props.onChangeSettings({
	                currentLanguageIndex: get(_this4.state, 'currentLanguageIndex'),
	                locale: locale.value
	            });
	        });
	    },
	    _getCurrencyMenuItems: function _getCurrencyMenuItems() {
	        var currencies = map(this.currencies, function (currency, payload) {
	            return { payload: payload, text: get(currency, 'code') + ' - ' + get(currency, 'symbol') };
	        });
	        return ComponentUtils.toMenuItems(currencies, 'text', 'currencies');
	    },
	    _getCurrencyDigitsMenuItems: function _getCurrencyDigitsMenuItems() {
	        var currencyDigits = map(this.currencyDigits, function (currencyDigit) {
	            return { text: '' + currencyDigit.value };
	        });
	        return ComponentUtils.toMenuItems(currencyDigits, 'text', 'currencyDigits');
	    },
	    _onChangeAddress: function _onChangeAddress(evt) {
	        var _this5 = this;
	
	        var applicantAddress = get(evt, 'target.value');
	        this.setState({
	            applicantAddress: applicantAddress
	        }, function () {
	            _this5.props.onChangeSettings({
	                applicantAddress: get(_this5.state, 'applicantAddress')
	            });
	        });
	    },
	    _onChangeCityAndState: function _onChangeCityAndState(evt) {
	        var _this6 = this;
	
	        var applicantCityAndState = get(evt, 'target.value');
	        this.setState({
	            applicantCityAndState: applicantCityAndState
	        }, function () {
	            _this6.props.onChangeSettings({
	                applicantCityAndState: get(_this6.state, 'applicantCityAndState')
	            });
	        });
	    },
	    _onChangeTaxId: function _onChangeTaxId(evt) {
	        var _this7 = this;
	
	        var applicantTaxId = get(evt, 'target.value');
	        this.setState({
	            applicantTaxId: applicantTaxId
	        }, function () {
	            _this7.props.onChangeSettings({
	                applicantTaxId: applicantTaxId
	            });
	        });
	    },
	    _onChangePhone: function _onChangePhone(evt) {
	        var _this8 = this;
	
	        var applicantPhone = get(evt, 'target.value');
	        this.setState({
	            applicantPhone: applicantPhone
	        }, function () {
	            _this8.props.onChangeSettings({
	                applicantPhone: get(_this8.state, 'applicantPhone')
	            });
	        });
	    },
	    _onChangeEmail: function _onChangeEmail(evt) {
	        var _this9 = this;
	
	        var email = get(evt, 'target.value');
	        this.setState({
	            email: email
	        }, function () {
	            _this9.props.onChangeSettings({
	                email: get(_this9.state, 'email')
	            });
	        });
	        UserServiceImpl.getEmailAlreadyUsed(function () {
	            _this9.props.onChangeSettings({
	                resultEmail: true
	            });
	        }, function () {
	            _this9.props.onChangeSettings({
	                resultEmail: false
	            });
	        }, Security.getToken(), Security.getCurrentApplicantId(), email);
	    },
	    _onChangeApplicantLogo: function _onChangeApplicantLogo(evt) {
	        var _this10 = this;
	
	        var applicantLogoSrc = evt.cdnUrl;
	        this.setState({
	            applicantLogoSrc: applicantLogoSrc
	        }, function () {
	            _this10.props.onChangeSettings({
	                applicantLogoSrc: applicantLogoSrc
	            });
	        });
	    },
	    _onChangeApplicantName: function _onChangeApplicantName(evt) {
	        var _this11 = this;
	
	        var applicantDisplayName = get(evt, 'target.value');
	        this.setState({
	            applicantDisplayName: applicantDisplayName
	        }, function () {
	            _this11.props.onChangeSettings({
	                applicantDisplayName: get(_this11.state, 'applicantDisplayName')
	            });
	        });
	    },
	    render: function render() {
	        var _this12 = this;
	
	        var languageMenuItems = this._getLanguageMenuItems();
	        var currenciesMenuItems = this._getCurrencyMenuItems();
	        var currencyDigitsMenuItems = this._getCurrencyDigitsMenuItems();
	        var countriesMenuItems = this._getCountryMenuItems();
	
	        return React.createElement("div", { className: "bp-custom-modal__content bp-setting-modal-tab bp-setting-modal-tab-general", label: t('setting_modal_tab_gral_label_general') }, React.createElement("div", { className: "bp-setting-modal-tab-general__field logo-row" }, React.createElement("img", { className: "logo-img", src: this.state.applicantLogoSrc, alt: t('setting_modal_tab_gral_label_logo_of_applicant') }), React.createElement(Uploader, { imgSrc: this.state.applicantLogoSrc, onUploadComplete: this._onChangeApplicantLogo })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangeApplicantName,
	            floatingLabelText: t('setting_modal_general_text_company_name'),
	            value: this.state.applicantDisplayName })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangeAddress,
	            floatingLabelText: t('setting_modal_general_text_street_name_number'),
	            value: this.state.applicantAddress })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangeCityAndState,
	            floatingLabelText: t('setting_modal_general_text_city_state_zip_code'),
	            value: this.state.applicantCityAndState })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(SelectField, {
	            floatingLabelText: t('setting_modal_general_text_country'),
	            onChange: this.onChangeCountry,
	            menuItems: countriesMenuItems,
	            disabled: SessionStore.isAdminUser() ? false : true,
	            value: this.state.preferredCountryIndex })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangePhone,
	            floatingLabelText: t('setting_modal_general_text_phone'),
	            value: this.state.applicantPhone })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangeEmail,
	            onChange: this._onChangeEmail,
	            floatingLabelText: t('setting_modal_general_text_email'),
	            value: this.state.email,
	            disabled: SessionStore.isAdminUser() ? false : true })), SessionStore.isAdminUser() && React.createElement("div", { className: "bp-setting-modal-tab-general__field alert alert-warning", style: { 'max-width': '253px',
	                'margin-top': '10px',
	                'margin-bottom': '0px' } }, React.createElement("h6", { style: { 'margin-top': '0px', 'margin-bottom': '0px' } }, t('setting_modal_general_email_message'))), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(SelectField, {
	            floatingLabelText: t('setting_modal_general_text_language'),
	            menuItems: languageMenuItems,
	            value: this.state.currentLanguageIndex,
	            onChange: this.onChangeLanguage })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(SelectField, {
	            floatingLabelText: t('setting_modal_general_text_currency'),
	            onChange: this.onChangeCurrency,
	            menuItems: currenciesMenuItems,
	            value: this.state.preferredCurrencyIndex,
	            disabled: SessionStore.isAdminUser() ? false : true })), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(SelectField, {
	            floatingLabelText: t('setting_modal_general_text_currency_digits'),
	            onChange: this.onChangeCurrencyDigits,
	            menuItems: currencyDigitsMenuItems,
	            value: this.state.preferredDigitsIndex,
	            disabled: SessionStore.isAdminUser() ? false : true }), SessionStore.isAdminUser() && React.createElement("div", { className: "bp-setting-modal-tab-general__field alert alert-warning", style: { 'max-width': '253px',
	                'margin-top': '10px',
	                'margin-bottom': '0px' } }, React.createElement("h6", { style: { 'margin-top': '0px', 'margin-bottom': '0px' } }, t('setting_modal_general_text_currency_digits_help')))), React.createElement("div", { className: "bp-setting-modal-tab-general__field" }, React.createElement(TextField, {
	            onBlur: this._onChangeTaxId,
	            floatingLabelText: t('setting_modal_general_text_tax_id'),
	            value: this.state.applicantTaxId })), React.createElement("div", { style: { margin: '20px 0' } }, React.createElement("h4", null, t('setting_modal_general_filter_section_title'), ":")), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('brewing'),
	            defaultToggled: this.state.isVisibleBrewingSection,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisibleBrewingSection: value
	                }, function () {
	                    SessionStore.setIsVisibleBrewingSection(value);
	                    _this12.props.onChangeSettings({
	                        isVisibleBrewingSection: value
	                    });
	                });
	            } })), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('fermenting'),
	            defaultToggled: this.state.isVisibleFermentingSection,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisibleFermentingSection: value
	                }, function () {
	                    SessionStore.setIsVisibleFermentingSection(value);
	                    _this12.props.onChangeSettings({
	                        isVisibleFermentingSection: value
	                    });
	                });
	            } })), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('dashboard_modal_tab_packaging'),
	            defaultToggled: this.state.isVisiblePackagingSection,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisiblePackagingSection: value
	                }, function () {
	                    SessionStore.setIsVisiblePackagingSection(value);
	                    _this12.props.onChangeSettings({
	                        isVisiblePackagingSection: value
	                    });
	                });
	            } })), React.createElement("div", { className: "bp-setting-modal-tab-general__field alert alert-danger", style: { margin: '2px 0', 'max-width': '270px' } }, React.createElement("h6", { style: { 'margin-top': '0px', 'margin-bottom': '0px' } }, t('setting_modal_general_filter_section_alert'))), React.createElement("div", { style: { margin: '20px 0' } }, React.createElement("h4", null, t('setting_modal_general_toggle_tile'), ":")), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('brewing'),
	            defaultToggled: this.state.isVisibleBeerStyleLabelBrewing,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisibleBeerStyleLabelBrewing: value
	                }, function () {
	                    SessionStore.setIsVisibleBeerStyleLabelBrewing(value);
	                    _this12.props.onChangeSettings({
	                        isVisibleBeerNameBrewingSection: value
	                    });
	                });
	            } })), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('fermenting'),
	            defaultToggled: this.state.isVisibleBeerStyleLabelFermenting,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisibleBeerStyleLabelFermenting: value
	                }, function () {
	                    SessionStore.setIsVisibleBeerStyleLabelFermenting(value);
	                    _this12.props.onChangeSettings({
	                        isVisibleBeerNameFermentingSection: value
	                    });
	                });
	            } })), React.createElement("div", { className: "bp-setting-modal-tab-general__field toggle-option" }, React.createElement(Toggle, {
	            label: t('dashboard_modal_tab_packaging'),
	            defaultToggled: this.state.isVisibleBeerStyleLabelPackaging,
	            onToggle: function onToggle(_, value) {
	                _this12.setState({
	                    isVisibleBeerStyleLabelPackaging: value
	                }, function () {
	                    SessionStore.setIsVisibleBeerStyleLabelPackaging(value);
	                    _this12.props.onChangeSettings({
	                        isVisibleBeerNamePackagingSection: value
	                    });
	                });
	            } })));
	    }
	});
	
	module.exports = SettingModalTabGeneral;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1348);
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(12),
	    TextField = _require.TextField;
	
	var moment = __webpack_require__(3);
	
	var OrderUtils = __webpack_require__(49);
	
	var _require2 = __webpack_require__(2),
	    INVENTORY_MAX_PAST_DAYS_SCOPE = _require2.INVENTORY_MAX_PAST_DAYS_SCOPE;
	
	var _require3 = __webpack_require__(4),
	    t = _require3.t;
	
	var _require4 = __webpack_require__(12),
	    FloatingActionButton = _require4.FloatingActionButton,
	    Table = _require4.Table,
	    TableHeader = _require4.TableHeader,
	    TableRow = _require4.TableRow,
	    TableRowColumn = _require4.TableRowColumn,
	    TableHeaderColumn = _require4.TableHeaderColumn,
	    TableBody = _require4.TableBody;
	
	var NumberUtils = __webpack_require__(23);
	var DateUtils = __webpack_require__(22);
	
	var WIDTH_DESCRIPTION_ITEM = '30%';
	
	var InventoryReport = React.createClass({ displayName: "InventoryReport",
	
	  propTypes: {
	    orders: React.PropTypes.array,
	    items: React.PropTypes.array,
	    itemSelected: React.PropTypes.object,
	    locationItems: React.PropTypes.array,
	    vendorPurchaseItems: React.PropTypes.array,
	    isVisible: React.PropTypes.bool,
	    onClose: React.PropTypes.func,
	    onSelectItem: React.PropTypes.func,
	    dateFrom: React.PropTypes.string,
	    dateTo: React.PropTypes.string
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var _this = this;
	
	    if (!prevProps.isVisible && this.props.isVisible) {
	      this.timeout = setTimeout(function () {
	        _this.refs.filterReport.getDOMNode().querySelector('input').focus();
	      }, 750);
	    } else if (prevProps.isVisible && !this.props.isVisible) {
	      this.cleanTimeouts();
	    }
	  },
	  getInitialState: function getInitialState() {
	    return {
	      limitInventoryCalculate: DateUtils.getByDateFromNowInDays(-INVENTORY_MAX_PAST_DAYS_SCOPE),
	      filterName: ''
	    };
	  },
	  cleanTimeouts: function cleanTimeouts() {
	    clearTimeout(this.timeout || 0);
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        isVisible = _props.isVisible,
	        orders = _props.orders,
	        onClose = _props.onClose,
	        items = _props.items,
	        dateFrom = _props.dateFrom,
	        dateTo = _props.dateTo,
	        locationItems = _props.locationItems,
	        itemSelected = _props.itemSelected,
	        vendorPurchaseItems = _props.vendorPurchaseItems;
	    var _state = this.state,
	        limitInventoryCalculate = _state.limitInventoryCalculate,
	        filterName = _state.filterName;
	
	
	    var groupTotalsByItem = getTotalByItemsId(orders, limitInventoryCalculate);
	    var stockByItemId = getRealStockByItemId(locationItems);
	    var requestedByItemId = getRequestedByItemId(vendorPurchaseItems);
	    var itemsFiltered = getItemsRow(groupTotalsByItem, stockByItemId, requestedByItemId, items);
	    var setFilterByName = function setFilterByName(name) {
	      return _this2.setState({ filterName: name });
	    };
	    var cleanFilterByName = function cleanFilterByName() {
	      return _this2.setState({ filterName: '' }, function () {
	        return _this2.refs.filterReport.setValue('');
	      });
	    }; // it's not enough to clean the state, you need to clean it from DOM puajj);
	    var onChangeFilterByName = getOnChangeFilterByName(setFilterByName);
	    var displayDateFrom = moment(dateFrom).format('ll');
	    var displayDateTo = moment(dateTo).format('ll');
	    var itemsAlreadyFiltered = itemsFiltered.filter(function (item) {
	      if (!filterName) return true;
	      return item.name.toLowerCase().includes(filterName.toLowerCase());
	    });
	    return React.createElement("div", { className: 'inventory-report ' + (isVisible ? 'is-active' : '') }, React.createElement("div", { className: "inventory-report__header" }, React.createElement("div", { className: "report-title" }, React.createElement("h3", null, t('dashboard_inventory_report_title')), React.createElement("h4", null, t('date-from'), ": ", DateUtils.isBeforeToDay(displayDateFrom) ? limitInventoryCalculate // don't show before limit inventory calculation
	    : displayDateFrom, " - ", t('date-to'), ": ", displayDateTo)), React.createElement("div", null, React.createElement(TextField, {
	      floatingLabelText: '' + t('dashboard_inventory_report_filter_name'),
	      className: "filter-report",
	      fullWidth: true,
	      onChange: onChangeFilterByName,
	      ref: "filterReport"
	    })), React.createElement("div", { className: "btn-close" }, React.createElement(FloatingActionButton, {
	      onClick: function onClick() {
	        cleanFilterByName();
	        onClose();
	      },
	      iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3" }, React.createElement("i", { className: "material-icons md-38 btn-icon-center" }, "close")))), React.createElement("div", { className: "inventory-report__content" }, React.createElement(Table, {
	      selectable: true,
	      fixedHeader: true,
	      multiSelectable: false,
	      onRowSelection: function onRowSelection(_ref) {
	        var index = _ref[0];
	
	        if (index !== undefined) {
	          var itemFiltered = itemsAlreadyFiltered[index] || {};
	          var targetItem = (items || []).find(function (item) {
	            return +item.id === +itemFiltered.itemId;
	          });
	          _this2.props.onSelectItem(targetItem);
	        } else {
	          _this2.props.onSelectItem(undefined);
	        }
	      }
	    }, React.createElement(TableHeader, { className: "admin-table-header" }, React.createElement(TableRow, { className: "admin-table-header-row" }, React.createElement(TableHeaderColumn, { style: { width: WIDTH_DESCRIPTION_ITEM + ' !important' } }, t('name')), React.createElement(TableHeaderColumn, null, t('dashboard_inventory_report_column_stock_item')), React.createElement(TableHeaderColumn, null, t('dashboard_inventory_report_column_reserved_item')), React.createElement(TableHeaderColumn, null, t('dashboard_inventory_report_column_missing_item')), React.createElement(TableHeaderColumn, null, t('dashboard_inventory_report_column_requested_item')), React.createElement(TableHeaderColumn, null, t('dashboard_inventory_report_column_virtual_stock')))), React.createElement(TableBody, { className: "admin-table-body",
	      deselectOnClickaway: false }, itemsAlreadyFiltered.map(function (item) {
	      return React.createElement(TableRow, { selected: itemSelected && itemSelected.id === +item.itemId, key: 'key-' + item.itemId }, Object.keys(item).filter(function (key) {
	        return key !== 'itemId';
	      }).map(function (key, index) {
	        return React.createElement(TableRowColumn, {
	          style: index === 0 ? { width: WIDTH_DESCRIPTION_ITEM + ' !important' } : {}
	        }, item[key]);
	      }));
	    })))), React.createElement("div", { className: "inventory-report__footer" }));
	  }
	});
	
	function getOnChangeFilterByName(setFilterByName) {
	  return function (evt) {
	    setFilterByName(evt.target.value);
	  };
	}
	
	function getTotalByItemsId(orders, limitInventoryCalculate) {
	  var allItems = OrderUtils.getAllWhereInventoryWasTakenFromAllItemsFromAllProductsFromOrders(orders, limitInventoryCalculate);
	  var groupTotalsByItem = allItems.filter(function (item) {
	    return item.type === 'LOCATION_ITEM_MODULE' || item.type === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE' || item.type === 'VENDOR_PURCHASE_ITEM_MODULE';
	  }).reduce(function (total, whereInventory) {
	    var _ref2 = whereInventory.type === 'VENDOR_PURCHASE_ITEM_MISSING_MODULE' ? { to: 'totalMissing', from: 'amountItemNeeded', itemIdKey: 'itemIdNeeded' } : { to: 'totalReserved', from: 'amountSubtracted', itemIdKey: 'itemId' },
	        to = _ref2.to,
	        from = _ref2.from,
	        itemIdKey = _ref2.itemIdKey;
	
	    var itemId = whereInventory[itemIdKey];
	
	    if (!total[itemId]) {
	      total[itemId] = {
	        totalMissing: 0,
	        totalReserved: 0,
	        totalRequested: 0
	      };
	    }
	
	    var value = total[itemId][to];
	    total[itemId][to] = +NumberUtils.sum(value, whereInventory[from] || 0);
	
	    return total;
	  }, {});
	  return groupTotalsByItem;
	}
	
	function getRealStockByItemId(locationItems) {
	  return locationItems.reduce(function (total, locationItem) {
	    var itemId = locationItem.item.id;
	    if (total[itemId]) {
	      total[itemId] = NumberUtils.sum(total[itemId], locationItem.amount);
	    } else {
	      total[itemId] = locationItem.amount;
	    }
	    return total;
	  }, {});
	}
	
	function getRequestedByItemId(vendorPurchaseItems) {
	  return vendorPurchaseItems
	  /**
	   * The reserved requested items only matters the state `ORDERED`.
	   * The rest of the sates it doesn't matters because:
	   *
	   *  - "NO_MORE_ON_THE_WAY" & REJECT_REMAINDER": Because these state means that real stock was affected.
	   *  - "PENDING": Because the provider doesn't receive the email yet.
	   */
	  .filter(function (vendorPurchaseItem) {
	    return vendorPurchaseItem.state === 'ORDERED';
	  }).reduce(function (total, vendorPurchaseItem) {
	    var itemId = vendorPurchaseItem.itemId;
	    var amountRequested = NumberUtils.multiply(vendorPurchaseItem.relativeUnitAmount || 1, vendorPurchaseItem.amountRequested);
	    if (total[itemId]) {
	      total[itemId] = NumberUtils.sum(total[itemId], amountRequested);
	    } else {
	      total[itemId] = amountRequested;
	    }
	    return total;
	  }, {});
	}
	
	function getItemsRow(groupTotalsByItem, stockByItemId, requestedByItemId, items) {
	  var itemsFiltered = Object.keys(groupTotalsByItem).map(function (itemId) {
	    var stock = NumberUtils.formatDecimal(stockByItemId[itemId] || 0);
	    var amountRequested = NumberUtils.formatDecimal(requestedByItemId[itemId] || 0);
	    var amountReserved = NumberUtils.formatDecimal(groupTotalsByItem[itemId]['totalReserved'] || 0);
	    var amountMissingItems = NumberUtils.formatDecimal(groupTotalsByItem[itemId]['totalMissing'] || 0);
	
	    // Virtual stock = real stock + purchased - (stock reserved + purchased reserved)
	    var rawVirtualStock = NumberUtils.formatDecimal(NumberUtils.subtract(NumberUtils.sum(stock, amountRequested), amountReserved));
	
	    /**
	     * In case of missing items grather than 0, we should take as a reference that will be the virtual stock, because the
	     * missing item is already taking in account all stock reserved and also purchased reserved too.
	     * In case of missing with 0, we should calulcate the virtual stock, which was actually calculated above.
	     */
	    var virtualAmount = NumberUtils.isGreater(amountMissingItems, 0) ? '-' + amountMissingItems : rawVirtualStock;
	
	    return { // The order of the following properties matters, it's the way that will display in the table
	      itemId: itemId,
	      name: ((items || []).find(function (item) {
	        return item.id === +itemId;
	      }) || { description: '' }).description,
	      stock: stock,
	      amountReserved: amountReserved,
	      amountMissingItems: amountMissingItems,
	      amountRequested: amountRequested,
	      virtualAmount: virtualAmount
	    };
	  }).sort(function (a, b) {
	    return NumberUtils.isEqual(a.virtualAmount, b.virtualAmount) ? 0 : NumberUtils.isGreater(a.virtualAmount, b.virtualAmount) ? 1 : -1;
	  });
	  return itemsFiltered;
	}
	
	module.exports = InventoryReport;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var NotificationSystem = __webpack_require__(1200),
	    React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Notification,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay;
	
	
	var _resetThemeModal = {
	    borderTop: 'none',
	    backgroundColor: '#fff',
	    boxShadow: '9px 20px 34px -5px gray'
	};
	
	var MAX_NOTIFICATION_ALLOW = 3;
	var currentNotifications = [];
	
	Notification = React.createClass({ displayName: "Notification",
	
	    _notificationSystem: null,
	
	    showImmediately: function showImmediately(message, type, autoDismiss, actionHandler) {
	        var notificationConf = {
	            message: '<div class="custom-notification"><i class="custom-notification__icon custom-notification__icon--' + (type || 'error') + '"></i><span class="custom-notification__content">' + message + '</span></div>',
	            level: type || 'error',
	            autoDismiss: type === 'error' ? false : autoDismiss || 10
	        };
	        currentNotifications.push(this._notificationSystem.addNotification(notificationConf));
	        if (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
	            while (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
	                var lastNotification = currentNotifications.shift();
	                this._notificationSystem.removeNotification(lastNotification); // remove last
	            }
	        }
	    },
	
	    show: function show(message, type, autoDismiss, actionHandler) {
	        var _this = this;
	
	        delay(function () {
	            var notificationConf = {
	                message: '<div class="custom-notification"><i class="custom-notification__icon custom-notification__icon--' + (type || 'error') + '"></i><span class="custom-notification__content">' + message + '</span></div>',
	                level: type || 'error',
	                autoDismiss: type === 'error' ? false : autoDismiss || 10
	            };
	
	            currentNotifications.push(_this._notificationSystem.addNotification(notificationConf));
	
	            if (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
	                while (currentNotifications.length > MAX_NOTIFICATION_ALLOW) {
	                    var lastNotification = currentNotifications.shift();
	                    _this._notificationSystem.removeNotification(lastNotification); // remove last
	                }
	            }
	        }, 100);
	    },
	
	    componentDidMount: function componentDidMount() {
	        this._notificationSystem = this.refs.notificationSystem;
	    },
	
	    render: function render() {
	
	        var style = {
	            NotificationItem: {
	                info: _resetThemeModal,
	                error: _resetThemeModal,
	                warning: _resetThemeModal,
	                success: _resetThemeModal,
	                DefaultStyle: {
	                    padding: '3px 0 0 0', //need to override with style 0
	                    minHeight: '50px'
	                }
	            }
	        };
	        return React.createElement("div", { className: "bp-notification-container" }, React.createElement(NotificationSystem, {
	            className: "custom-notification",
	            allowHTML: true,
	            ref: "notificationSystem",
	            onClick: function onClick() {},
	            style: style }));
	    }
	});
	
	module.exports = Notification;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1349);
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(4),
	    t = _require.t;
	
	var _require2 = __webpack_require__(12),
	    TextField = _require2.TextField,
	    IconButton = _require2.IconButton,
	    CircularProgress = _require2.CircularProgress;
	
	var CustomDialog = __webpack_require__(26);
	var get = __webpack_require__(5).get;
	
	var Tabs = React.createClass({ displayName: "Tabs",
	
	  propTypes: {
	    isLoading: React.PropTypes.bool,
	    activeIndexTab: React.PropTypes.number,
	    fetchList: React.PropTypes.func,
	    onSaveChangedTab: React.PropTypes.func,
	    onSaveNewTab: React.PropTypes.func,
	    onDeleteExistingTab: React.PropTypes.func,
	    onChangeTab: React.PropTypes.func,
	    children: React.PropTypes.any
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      indexTabActive: this.props.activeIndexTab || 0,
	      isEditMode: false
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.activeIndexTab !== this.props.activeIndexTab) {
	      this.setState({ indexTabActive: nextProps.activeIndexTab });
	    }
	  },
	  fetchList: function fetchList() {
	    this.props.fetchList();
	  },
	  onAddNewTab: function onAddNewTab(newName) {
	    this.props.onSaveNewTab(newName, this.state.indexTabActive);
	  },
	  onChangeExistingTab: function onChangeExistingTab(tabId, changedName, originalName) {
	    this.props.onSaveChangedTab(tabId, changedName, originalName, this.state.indexTabActive);
	  },
	  onDeleteExistingTab: function onDeleteExistingTab(id, listName) {
	    this.props.onDeleteExistingTab(id, listName);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        children = _props.children,
	        isLoading = _props.isLoading;
	    var _state = this.state,
	        indexTabActive = _state.indexTabActive,
	        isNewMode = _state.isNewMode,
	        isEditMode = _state.isEditMode;
	
	    var self = this;
	    var getTabsHeader = function getTabsHeader(indexTabActive) {
	      return React.createElement("div", { className: "bp-tabs__header", id: "tab-header-id" }, children && React.Children.map(children.filter(function (child) {
	        return child;
	      }), function (child, tabIndex) {
	        return React.createElement("div", {
	          key: 'child-id-' + (child && child.props && child.props.id),
	          className: 'bp-tab-header' + (tabIndex === indexTabActive ? ' is-active' : ''),
	          onClick: function onClick(evt) {
	            if (evt) evt.preventDefault();
	            self.setState(function (prevState) {
	              return {
	                indexTabActive: tabIndex,
	                isEditMode: prevState.indexTabActive === tabIndex,
	                isNewMode: false
	              };
	            }, function () {
	              return _this.props.onChangeTab();
	            });
	          }
	        }, tabIndex === indexTabActive && isEditMode ? React.createElement(EditModeTab, {
	          label: child.props.label,
	          onClose: function onClose() {
	            return self.setState({
	              isEditMode: false,
	              isNewMode: false
	            });
	          },
	          onSave: function onSave(changedName) {
	            return self.setState({
	              isEditMode: false,
	              isNewMode: false
	            }, function () {
	              return self.onChangeExistingTab(child.props.id, changedName, child.props.label);
	            });
	          },
	          onDelete: function onDelete() {
	            return self.setState(function () {
	              return {
	                isEditMode: false,
	                isNewMode: false
	              };
	            }, function () {
	              return self.onDeleteExistingTab(child.props.id, child.props.label);
	            });
	          } }) : get(child, 'props.label'));
	      }), React.createElement("div", { className: "bp-tabs__header--new-list" }, !isNewMode && React.createElement(IconButton, {
	        onClick: function onClick() {
	          return _this.setState(function (prevState) {
	            return { isNewMode: !prevState.isNewMode, isEditMode: false };
	          });
	        },
	        iconClassName: "material-icons",
	        backgroundColor: "lightgray" }, "add_circle_outline"), isNewMode && React.createElement(NewModeTab, {
	        onClose: function onClose() {
	          return _this.setState(function (prevState) {
	            return { isNewMode: !prevState.isNewMode, isEditMode: false };
	          });
	        },
	        onSave: function onSave(newName) {
	          return _this.onAddNewTab(newName);
	        } })));
	    };
	
	    return React.createElement("div", { className: "bp-tabs" }, isLoading && React.createElement("div", { className: "bp-tabs__loading" }, React.createElement(CircularProgress, { mode: "indeterminate", size: 1.5 })), getTabsHeader(indexTabActive), React.createElement("div", { className: "bp-tabs__body" }, React.Children.map((children || []).filter(function (child) {
	      return child;
	    }), function (childTab, tabIndex) {
	      return childTab && React.cloneElement(childTab, {
	        'isActive': tabIndex === indexTabActive,
	        'isEditMode': tabIndex === indexTabActive && isEditMode,
	        tabIndex: tabIndex,
	        key: 'tab-index-' + tabIndex
	      });
	    })));
	  }
	});
	
	var NewModeTab = React.createClass({ displayName: "NewModeTab",
	
	  getInitialState: function getInitialState() {
	    return {
	      listName: ''
	    };
	  },
	  onKeyPressOverInput: function onKeyPressOverInput(evt) {
	    if (evt.charCode === 13) {
	      this.props.onSave(evt.target.value);
	      this.props.onClose();
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    if (this._inputEl) this._inputEl.focus();
	  },
	  refCallback: function refCallback(el) {
	    if (el) this._inputEl = el;
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        onClose = _props2.onClose,
	        onSave = _props2.onSave;
	    var listName = this.state.listName;
	
	    return React.createElement("div", { className: "bp-tabs__header--new-mode", onClick: function onClick(evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	      } }, React.createElement(TextField, {
	      ref: this.refCallback,
	      floatingLabelText: t('dashboard_user_task_list_name'),
	      onBlur: function onBlur(evt) {
	        return _this2.setState({ listName: evt.target.value });
	      },
	      onKeyPress: this.onKeyPressOverInput }), React.createElement(IconButton, {
	      onClick: onClose,
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "close"), React.createElement(IconButton, {
	      onClick: function onClick() {
	        onSave(listName);
	        onClose();
	      },
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "save"));
	  }
	});
	
	var EditModeTab = React.createClass({ displayName: "EditModeTab",
	
	  getInitialState: function getInitialState() {
	    return {
	      listName: this.props.label
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    if (this._inputEl) this._inputEl.focus();
	  },
	  refCallback: function refCallback(el) {
	    if (el) this._inputEl = el;
	  },
	  onKeyPressOverInput: function onKeyPressOverInput(evt) {
	    if (evt.charCode === 13) {
	      this.props.onSave(evt.target.value);
	      this.props.onClose();
	    }
	  },
	  render: function render() {
	    var _this3 = this;
	
	    var _props3 = this.props,
	        label = _props3.label,
	        onClose = _props3.onClose,
	        onSave = _props3.onSave,
	        onDelete = _props3.onDelete;
	    var listName = this.state.listName;
	
	
	    return React.createElement("div", { className: "bp-tabs__header--edit-mode", onClick: function onClick(evt) {
	        evt.preventDefault();
	        evt.stopPropagation();
	      } }, React.createElement(TextField, {
	      ref: this.refCallback,
	      defaultValue: label,
	      onBlur: function onBlur(evt) {
	        return _this3.setState({ listName: evt.target.value });
	      },
	      onKeyPress: this.onKeyPressOverInput }), React.createElement(IconButton, {
	      onClick: function onClick() {
	        return CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_user_list_tasks'), function () {
	          onClose();
	          onDelete();
	        });
	      },
	
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "delete"), React.createElement(IconButton, {
	      onClick: onClose,
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "close"), React.createElement(IconButton, {
	      onClick: function onClick() {
	        return onSave(listName);
	      },
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "save"));
	  }
	});
	
	var Tab = React.createClass({ displayName: "Tab",
	  render: function render() {
	    var _props4 = this.props,
	        children = _props4.children,
	        isActive = _props4.isActive,
	        isEditMode = _props4.isEditMode;
	
	    return React.createElement("div", { className: 'bp-tab' + (isActive ? ' is-active' : '') + (isEditMode ? 'is-edit-mode' : '')
	    }, children);
	  }
	});
	
	module.exports = {
	  Tab: Tab,
	  Tabs: Tabs
	};

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1350);
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(232),
	    isNoteEquals = _require.isNoteEquals;
	
	var DateUtils = __webpack_require__(22);
	
	var _require2 = __webpack_require__(4),
	    t = _require2.t;
	
	var _require3 = __webpack_require__(12),
	    Checkbox = _require3.Checkbox,
	    FloatingActionButton = _require3.FloatingActionButton,
	    IconButton = _require3.IconButton,
	    TextField = _require3.TextField,
	    DatePicker = _require3.DatePicker;
	
	var MAX_CHARACTER_ALLOWED = 200;
	
	var Tasks = React.createClass({ displayName: "Tasks",
	
	  propTypes: {
	    children: React.PropTypes.any,
	    onClickClose: React.PropTypes.func,
	    onChangeDate: React.PropTypes.func,
	    isHidden: React.PropTypes.bool,
	    date: React.PropTypes.string
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    if (prevProps && this.props && prevProps.isHidden && !this.props.isHidden && this.props.onOpen) {
	      this.props.onOpen(this.props.date);
	    }
	  },
	  render: function render() {
	    var _props = this.props,
	        children = _props.children,
	        onClickClose = _props.onClickClose,
	        isHidden = _props.isHidden,
	        date = _props.date,
	        onChangeDate = _props.onChangeDate;
	
	
	    return React.createElement("div", { className: 'tasks' + (isHidden ? ' is-hidden' : '') }, React.createElement("div", { className: "tasks__header" }, React.createElement("div", { className: "tasks__header-date-picker" }, React.createElement("h3", { className: "tasks__header-date-label" }, t('dashboard_user_task_title')), React.createElement("div", { className: "tasks__header-date-value" }, React.createElement(DatePicker, {
	      textFieldStyle: { fontSize: '25px' },
	      value: DateUtils.toDate(date),
	      defaultValue: DateUtils.toDate(date),
	      onChange: function onChange(_, date) {
	        onChangeDate(DateUtils.toDateText(date));
	      },
	      hintText: "Inline",
	      container: "inline",
	      formatDate: DateUtils.toDisplayDateText }), React.createElement("div", { className: "tasks__header-date-icon" }, React.createElement(IconButton, { iconClassName: "material-icons", tooltip: "GitHub" }, "edit_calendar")))), React.createElement("div", { className: "tasks__header-close" }, React.createElement(FloatingActionButton, {
	      onClick: onClickClose,
	      className: "tasks__header-close-btn",
	      iconClassName: "with-opacity muidocs-icon-action-grade",
	      backgroundColor: "gray"
	    }, React.createElement("i", { className: "material-icons md-16 btn-icon-center" }, "close")))), React.createElement("div", { className: "tasks__container" }, children), React.createElement("div", { className: "tasks__footer" }));
	  }
	});
	
	var TaskList = React.createClass({ displayName: "TaskList",
	  render: function render() {
	    return React.createElement("ul", { className: "task-list" }, this.props.children);
	  }
	});
	
	TaskList.propTypes = {};
	
	var TaskItem = React.createClass({ displayName: "TaskItem",
	
	  getInitialState: function getInitialState() {
	    return _extends({ isEditMode: this.props.isEditMode }, this.getDefaultState());
	  },
	  getDefaultState: function getDefaultState() {
	    return _extends({
	      message: this.props.deleteDisabled ? '' : this.props.message,
	      name: this.props.deleteDisabled ? '' : this.props.name,
	      checked: this.props.deleteDisabled ? false : this.props.checked,
	      errorMessage: ''
	    });
	  },
	
	
	  propTypes: {
	    message: React.PropTypes.string,
	    name: React.PropTypes.string,
	    checked: React.PropTypes.string,
	    onSave: React.PropTypes.func,
	    onDelete: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    isEditMode: React.PropTypes.bool,
	    deleteDisabled: React.PropTypes.bool
	  },
	
	  onSaveHandler: function onSaveHandler() {
	    var onSave = this.props.onSave;
	    var _state = this.state,
	        message = _state.message,
	        name = _state.name,
	        checked = _state.checked;
	
	    if (!getMessageError(message)) {
	      // it's not needed to check edition because we will save it.
	      this.handlerChangeWithoutCheckEdition();
	      onSave({ note: message, name: name, checked: checked });
	      this.setState({ isEditMode: false });
	    }
	  },
	
	
	  /**
	   * Horrible hack, because even after update state properly, material UI is not updating their internal state.
	   */
	  forceResetInputs: function forceResetInputs() {
	    this.getDOMNode().querySelector('.task-item__toggle input').checked = this.props.checked;
	    this.getDOMNode().querySelector('.task-item__users input').value = this.props.name;
	    this.getDOMNode().querySelector('.task-item__message input').value = this.props.message;
	    this.handlerChange();
	  },
	  handlerChange: function handlerChange() {
	    this.setState({ isEditMode: !isNoteEquals(this.props, this.state) });
	    this.props.onChange(this.state);
	  },
	  handlerChangeWithoutCheckEdition: function handlerChangeWithoutCheckEdition() {
	    this.props.onChange(this.state);
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (!prevState.isEditMode && this.state.isEditMode && this.state.isFocusMessage) {
	      if (this._el) {
	        this._el.getDOMNode().focus();
	      }
	    }
	  },
	  handlerReset: function handlerReset() {
	    var _props2 = this.props,
	        name = _props2.name,
	        message = _props2.message,
	        checked = _props2.checked; // reset to default state
	
	    this.setState({
	      errorMessage: '',
	      isEditMode: false, // say false because it was removed all changes
	      name: name,
	      message: message,
	      checked: checked,
	      isFocusMessage: false
	    }, this.forceResetInputs);
	  },
	  handlerKeyDown: function handlerKeyDown(evt) {
	    var isKeyPressEnter = evt.keyCode === 13;
	    var isKeyPressScape = evt.keyCode === 27;
	    if (isKeyPressScape) this.handlerReset();
	    if (isKeyPressEnter) this.onSaveHandler();
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props3 = this.props,
	        onDelete = _props3.onDelete,
	        deleteDisabled = _props3.deleteDisabled;
	    var _state2 = this.state,
	        isEditMode = _state2.isEditMode,
	        message = _state2.message,
	        name = _state2.name,
	        checked = _state2.checked,
	        errorMessage = _state2.errorMessage;
	
	    var self = this;
	    return React.createElement("li", { className: "task-item" }, React.createElement("div", { className: "task-item__toggle" }, React.createElement(Checkbox, {
	      defaultChecked: checked,
	      onCheck: function onCheck(evt) {
	        return _this.setState({ checked: evt.target.checked }, _this.handlerChange);
	      },
	      onKeyDown: this.handlerKeyDown })), React.createElement("div", { className: "task-item__users" }, React.createElement(TextField, { defaultValue: name || '',
	      floatingLabelText: t('dashboard_user_task_task_item_label_name'),
	      onChange: function onChange(evt) {
	        return _this.setState({ name: evt.target.value }, _this.handlerChange);
	      },
	      onKeyDown: this.handlerKeyDown,
	      onBlur: function onBlur() {
	        return _this.setState({ errorMessage: t(getMessageError(message)) });
	      } })), React.createElement("div", { className: "task-item__message" }, React.createElement("div", { className: "task-item__message-input" }, React.createElement(TextField, {
	      floatingLabelText: t('dashboard_user_task_task_item_label_task'),
	      defaultValue: message,
	      errorText: errorMessage,
	      multiline: true,
	      ref: function ref(input) {
	        if (input) {
	          self._el = input;
	        }
	      },
	      onBlur: function onBlur() {
	        return _this.setState({ errorMessage: t(getMessageError(message)), isFocusMessage: false });
	      },
	      onChange: function onChange(evt) {
	        return _this.setState({ message: evt.target.value }, _this.handlerChange);
	      },
	      onKeyDown: this.handlerKeyDown })), React.createElement("div", { className: "task-item__actions" }, isEditMode && !deleteDisabled && React.createElement("div", { className: "task-item__actions task-item__actions-clear" }, React.createElement(IconButton, {
	      onClick: this.handlerReset,
	      iconClassName: "material-icons",
	      backgroundColor: "lightgray" }, "clear")), isEditMode && React.createElement("div", { className: "task-item__actions task-item__actions-save" }, React.createElement(IconButton, {
	      iconClassName: "material-icons",
	      onClick: this.onSaveHandler,
	      backgroundColor: "lightgray" }, "send"))), !isEditMode && !deleteDisabled && React.createElement("div", { className: "task-item__actions-remove" }, React.createElement(IconButton, {
	      iconClassName: "material-icons",
	      onClick: onDelete,
	      backgroundColor: "lightgray" }, "delete"))));
	  }
	});
	
	function getMessageError(message) {
	  var messageSafe = message || '';
	  return messageSafe.length > MAX_CHARACTER_ALLOWED ? 'dashboard_user_task_inline_error_name_max_amount' : messageSafe.length === 0 ? 'dashboard_user_task_inline_error_name' : '';
	}
	
	module.exports = {
	  Tasks: Tasks,
	  TaskItem: TaskItem,
	  TaskList: TaskList
	};

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	
	var UserTaskStore = __webpack_require__(232),
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    _require = __webpack_require__(733),
	    Tasks = _require.Tasks,
	    TaskList = _require.TaskList,
	    TaskItem = _require.TaskItem,
	    CustomDialog = __webpack_require__(26),
	    _require2 = __webpack_require__(732),
	    Tabs = _require2.Tabs,
	    Tab = _require2.Tab,
	    _require3 = __webpack_require__(4),
	    t = _require3.t,
	    DashboardActionCreators = __webpack_require__(65),
	    sortBy = __webpack_require__(8).sortBy,
	    DateUtils = __webpack_require__(22);
	
	
	var MAX_CHARACTER_ALLOWED_LIST_NAME = 50;
	
	var UserTasks = React.createClass({ displayName: "UserTasks",
	
	  _timeouts: [],
	
	  propTypes: {
	    isUserTaskVisible: React.PropTypes.bool,
	    onClickClose: React.PropTypes.func,
	    onChangeDate: React.PropTypes.func,
	    date: React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      date: this.props.date,
	      isUserTaskFetching: true,
	      scheduleBoardList: UserTaskStore.getScheduleBoardList(),
	      notesHasSameStateMapping: this.initializeNotesStateMapping()
	    };
	  },
	
	
	  initializeNotesStateMapping: function initializeNotesStateMapping() {
	    return UserTaskStore.getScheduleBoardList().reduce(function (mapping, item) {
	      var _extends2;
	
	      return _extends(mapping, (_extends2 = {}, _extends2[item.id] = true, _extends2));
	    }, {});
	  },
	
	  focusNewTask: function focusNewTask() {
	    this._timeouts.push(setTimeout(function () {
	      try {
	        var newInput = Array.from(document.querySelectorAll('.bp-tab.is-active .task-item .task-item__message-input input')).pop();
	        var textArea = Array.from(document.querySelectorAll('.bp-tab.is-active .task-item .task-item__message-input textarea')).pop();
	        if (textArea) {
	          textArea.focus();
	        } else if (newInput) {
	          newInput.focus();
	        }
	      } catch (error) {
	        // do-nothing
	      }
	    }, 500)); // until end ant
	  },
	  componentWillMount: function componentWillMount() {
	    UserTaskStore.addChangeListener(this.onChange);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    UserTaskStore.removeChangeListener(this.onChange);
	    this.cleanTimeouts();
	  },
	  cleanTimeouts: function cleanTimeouts() {
	    if (this._timeouts && this._timeouts.length) {
	      this._timeouts.forEach(function (timeout) {
	        return clearTimeout(timeout);
	      });
	    }
	  },
	  onChange: function onChange() {
	    var _this = this;
	
	    this.setState({
	      date: SessionStore.getUserTaskDate(),
	      isUserTaskFetching: UserTaskStore.isUserTaskFetching(),
	      scheduleBoardList: UserTaskStore.getScheduleBoardList()
	    }, function () {
	      _this.focusNewTask();
	    });
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    if (prevState.activeIndexTab !== this.state.activeIndexTab) {
	      document.querySelector('.bp-tab-header.is-active').scrollIntoView();
	    }
	  },
	  getDate: function getDate() {
	    var _state = this.state,
	        scheduleBoardList = _state.scheduleBoardList,
	        date = _state.date;
	
	
	    var currentDate = date || scheduleBoardList[0].date;
	
	    if (!currentDate) {
	      currentDate = DateUtils.getCurrentDate();
	    }
	    return currentDate;
	  },
	  getScheduleFilter: function getScheduleFilter(currentDate) {
	    var scheduleBoardFilter = (this.state.scheduleBoardList || []).filter(function (board) {
	      return board.date === currentDate;
	    });
	
	    if (!scheduleBoardFilter || scheduleBoardFilter.length === 0) {
	      scheduleBoardFilter = [];
	    }
	
	    return sortBy(scheduleBoardFilter, 'name');
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var _state2 = this.state,
	        isUserTaskFetching = _state2.isUserTaskFetching,
	        activeIndexTab = _state2.activeIndexTab;
	    var _props = this.props,
	        isUserTaskVisible = _props.isUserTaskVisible,
	        _onClickClose = _props.onClickClose,
	        _onChangeDate = _props.onChangeDate;
	
	
	    var currentDate = this.getDate();
	    var scheduleBoardFilter = this.getScheduleFilter(currentDate);
	
	    function showPleaseCreateTaskFirstMessage(scheduleBoardFilter) {
	      return scheduleBoardFilter && scheduleBoardFilter.length === 0 && React.createElement("label", { style: { paddingTop: '10px' } }, t('dashboard_user_task_label_please_create_list_first'));
	    }
	
	    return React.createElement(Tasks, {
	      date: currentDate,
	      isHidden: !isUserTaskVisible,
	      onOpen: function onOpen() {
	        return _this2.focusNewTask();
	      },
	      onChangeDate: function onChangeDate(date) {
	        return _onChangeDate(date);
	      },
	      onClickClose: function onClickClose() {
	        if (UserTaskStore.isAllChangesSaved()) {
	          _this2.setState({ scheduleDate: null });
	          _onClickClose();
	        } else {
	          CustomDialog.showWarningConfirmation(t('warning'), t('dashboard_user_task_notification_please_save_changes'), function () {
	            UserTaskStore.resetAllChangesNote();
	            _this2.setState({ scheduleDate: null });
	            _onClickClose();
	          });
	        }
	      }
	    }, React.createElement(Tabs, {
	      activeIndexTab: activeIndexTab,
	      isLoading: isUserTaskFetching,
	      fetchList: function fetchList() {
	        return DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(currentDate || DateUtils.getCurrentDate()));
	      },
	      onSaveNewTab: function onSaveNewTab(name) {
	        DashboardActionCreators.saveChangedUserTaskName({
	          date: DateUtils.toDateText(currentDate),
	          name: name
	        });
	        selectedTab(_this2, null, scheduleBoardFilter, name);
	      },
	      onChangeTab: function onChangeTab() {
	        _this2.focusNewTask();
	      },
	      onSaveChangedTab: function onSaveChangedTab(taskId, changedName, originalName, tabIndex) {
	        if (!changedName) {
	          CustomDialog.showInfo('warning', t('dashboard_user_task_notification_not_allow_empty_list_name'));
	          return;
	        }
	        if (changedName.length > MAX_CHARACTER_ALLOWED_LIST_NAME) {
	          DashboardStore.unsetIsSavedDraft();
	          CustomDialog.showInfo('warning', t('dashboard_user_task_list_inline_error_name_max_amount'));
	          return;
	        }
	        DashboardActionCreators.saveChangedUserTaskName({
	          date: DateUtils.toDateText(currentDate),
	          name: changedName,
	          originalName: originalName,
	          id: taskId
	        });
	        selectedTab(_this2, tabIndex, scheduleBoardFilter, name);
	      },
	      onDeleteExistingTab: function onDeleteExistingTab(taskId, taskName) {
	        DashboardActionCreators.deleteUserTaskName(taskId, taskName);
	        selectedTab(_this2, 0, scheduleBoardFilter, name);
	      }
	    }, scheduleBoardFilter.length > 0 && scheduleBoardFilter.map(function (taskList) {
	      return React.createElement(Tab, {
	        key: 'tab-key-id-' + taskList.id + '-' + taskList.name,
	        id: taskList.id,
	        label: taskList.name
	      }, React.createElement(TaskList, null, showExistingTasks(taskList, currentDate, _this2), showNewEmptyTask(taskList, currentDate, _this2)));
	    })), showPleaseCreateTaskFirstMessage(scheduleBoardFilter));
	  }
	});
	
	function showNewEmptyTask(taskList, currentDate, self) {
	  return taskList.id && React.createElement(TaskItem, {
	    key: 'task-new-' + String(Math.random()).slice(2, 20),
	    ref: function ref(_ref) {
	      if (_ref) {
	        self._el = _ref;
	      }
	    },
	    "data-task-new-id": "task-item-id",
	    deleteDisabled: true,
	    isEditMode: true,
	    message: "",
	    name: "",
	    onChange: function onChange() {},
	    checked: false,
	    onSave: function onSave(_ref2) {
	      var note = _ref2.note,
	          name = _ref2.name,
	          checked = _ref2.checked;
	
	      DashboardActionCreators.addUserTaskName({
	        note: note,
	        name: name,
	        checked: checked,
	        id: null, // because it's new task
	        date: DateUtils.toDateText(currentDate),
	        listId: taskList.id,
	        listName: taskList.name
	      });
	    },
	    onDelete: function onDelete() {/* do nothing because is new */
	    } });
	}
	
	function showExistingTasks(taskList, currentDate) {
	  return taskList.tasks.length ? sortBy(taskList.tasks, 'id').map(function (task) {
	    return React.createElement(TaskItem, {
	      key: 'task-item-filled-' + (task.id || task.name),
	      "data-task-new-id": "task-item-id",
	      message: task.message,
	      name: task.name,
	      checked: task.checked,
	      onSave: function onSave(_ref3) {
	        var note = _ref3.note,
	            name = _ref3.name,
	            checked = _ref3.checked;
	
	        DashboardActionCreators.addUserTaskName({
	          note: note,
	          name: name,
	          checked: checked,
	          id: task.id,
	          date: DateUtils.toDateText(currentDate),
	          listId: taskList.id,
	          listName: taskList.name
	        });
	        UserTaskStore.markAsSavedNote(task);
	      },
	      onChange: function onChange(changedNote) {
	        return UserTaskStore.onChangeNote(task, changedNote);
	      },
	      onDelete: function onDelete() {
	        CustomDialog.showWarningConfirmation(t('warning'), t('notification_confirm_delete_user_task'), function () {
	          DashboardActionCreators.removeUserTask({
	            id: task.id,
	            listId: taskList.id
	          });
	        });
	      } });
	  }) : null;
	}
	
	function selectedTab(self, currentIndex, scheduleBoardFilter, name) {
	  self._timeouts.push(setTimeout(function () {
	    self.cleanTimeouts();
	    var activeIndexTab = currentIndex !== null ? currentIndex : sortBy(scheduleBoardFilter.concat([{ name: name }]), 'name').findIndex(function (item) {
	      return item.name === name;
	    });
	    // simulate as the tab already was there, so I simulate to add it, and sort it to
	    // be sure that the index will be the right once when the real item arrives from the API response.
	    self.setState({ activeIndexTab: activeIndexTab }, function () {
	      return self.focusNewTask();
	    });
	  }, 1000));
	}
	
	module.exports = UserTasks;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Constants = __webpack_require__(2),
	    DashboardServiceCache = __webpack_require__(28),
	    SessionStore = __webpack_require__(11),
	    DashboardActionCreators = __webpack_require__(65),
	    DashboardSpinnerEl = __webpack_require__(156);
	
	/**
	 * The draft mechanism to handler an effective/optimistic way the orders that we add, change or delete from the Dashboard.
	 * @type {{operations: Array, addOrder: Function, changeOrder: Function, deleteOrder: Function, _getTemporaryId: Function, _toDraft: Function}}
	 */
	var DraftSchedule = {
	
	    /**
	     * The current applicant.
	     */
	    applicant: SessionStore.getCurrentApplicant(),
	
	    /**
	     * Save a draft order with temporary id that will be replace once we publish all the
	     * operation of the current draft.
	     * @param order
	     * @returns {*}
	     */
	    addOrder: function addOrder(order) {
	        DashboardActionCreators.addOrderDraft(order);
	        DashboardSpinnerEl.show();
	        DashboardServiceCache.addOperation({
	            typeOperation: Constants.ORDER_OPERATION_NEW,
	            order: order,
	            isSaved: false
	        });
	    },
	
	    /**
	     * Add an change order operation to the stack of operations.
	     * @param order
	     */
	    changeOrder: function changeOrder(order) {
	        DashboardSpinnerEl.show();
	        DashboardServiceCache.addOperation({
	            typeOperation: Constants.ORDER_OPERATION_CHANGE,
	            order: order,
	            isSaved: false
	        });
	    },
	
	    /**
	     * Add an delete order operation to the stack of operations.
	     * @param order
	     */
	    removeOrder: function removeOrder(order) {
	        DashboardSpinnerEl.show();
	        DashboardServiceCache.addOperation({
	            typeOperation: Constants.ORDER_OPERATION_DELETE,
	            order: order,
	            isSaved: false
	        });
	    }
	};
	
	module.exports = DraftSchedule;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Constants = __webpack_require__(2);
	var ChronologycServiceCache = __webpack_require__(107);
	
	var NoteSchedule = {
	
	    /**
	     * Add new brewing note operation.
	     * @param {Object} note
	     */
	    addBrewingNote: function addBrewingNote(note) {
	        ChronologycServiceCache.addBrewingOperation({
	            typeOperation: Constants.NOTE_BREWING_OPERATION_NEW,
	            note: note
	        });
	    },
	
	    /**
	     * Change brewing note operation.
	     * @param {Object} note
	     */
	    changeBrewingNote: function changeBrewingNote(note) {
	        ChronologycServiceCache.addBrewingOperation({
	            typeOperation: Constants.NOTE_BREWING_OPERATION_CHANGE,
	            note: note
	        });
	    },
	
	    /**
	     * Remove brewing note operation.
	     * @param {Object} note
	     */
	    removeBrewingNote: function removeBrewingNote(note) {
	        ChronologycServiceCache.addBrewingOperation({
	            typeOperation: Constants.NOTE_BREWING_OPERATION_DELETE,
	            note: note
	        });
	    },
	
	    /**
	     * Add new packaging note operation.
	     * @param {Object} note
	     */
	    addPackagingNote: function addPackagingNote(note) {
	        ChronologycServiceCache.addPackagingOperation({
	            typeOperation: Constants.NOTE_PACKAGING_OPERATION_NEW,
	            note: note
	        });
	    },
	
	    /**
	     * Change packaging note operation.
	     * @param {Object} note
	     */
	    changePackagingNote: function changePackagingNote(note) {
	        ChronologycServiceCache.addPackagingOperation({
	            typeOperation: Constants.NOTE_PACKAGING_OPERATION_CHANGE,
	            note: note
	        });
	    },
	
	    /**
	     * Remove packaging note operation.
	     * @param {Object} note
	     */
	    removePackagingNote: function removePackagingNote(note) {
	        ChronologycServiceCache.addPackagingOperation({
	            typeOperation: Constants.NOTE_PACKAGING_OPERATION_DELETE,
	            note: note
	        });
	    }
	};
	
	module.exports = NoteSchedule;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var POLL_FREQUENCY = 1000 * 60 * 5,
	    RestUtils = __webpack_require__(51),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    ContentUtils = __webpack_require__(7),
	    packageJson = __webpack_require__(312),
	    Security = __webpack_require__(13).auth,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    notification = __webpack_require__(21),
	    AppAction = __webpack_require__(227),
	    categories = __webpack_require__(2).Analytics.categories,
	    actions = __webpack_require__(2).Analytics.actions,
	    ga = __webpack_require__(18);
	
	/**
	 * The simple polling class that ask for changes against to version of the server.
	 * @type {{inProgress: boolean, intervalId: *, poll: Function, start: Function, stop: Function}}
	 */
	var PollerAppVersion = {
	
	    /**
	     * The flag that allow as to not pull other request after finish the previous one.
	     */
	    inProgress: false,
	
	    /**
	     * The native interval id that allow as to stop the cycle when we need it.
	     */
	    intervalId: null,
	
	    /**
	     * Poll against the resources defined in dashboard to ask for dashboard changes.
	     */
	    poll: function poll() {
	        if (this.inProgress) {
	            return;
	        }
	        var self = this;
	        var ajax = RestUtils.createXHR();
	        var path = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/api/app/version';
	
	        this.inProgress = true;
	
	        ajax.addEventListener('error', function (error) {
	            if (!error) {
	                error = {};
	            }
	            if (!error.type) {
	                error.type = '';
	            }
	            try {
	                console.warn('PollerAppVersion Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
	            } catch (error) {
	                // do-nothing
	            }
	            self.inProgress = false;
	        });
	
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	
	                try {
	                    var license = SessionStore.isFullPaidVersion() ? 'FULL-VERSION' : SessionStore.isBasePaidVersion() ? 'BASE-VERSION' : 'TRIAL-VERSION';
	                    ga.event({
	                        category: categories.APPLICATION,
	                        action: actions.A_LIVE,
	                        label: packageJson.version + 'v | ' + license + ' | app: ' + SessionStore.getCurrentApplicant() + ' user: ' + ContentUtils.getSession('userNameSession')
	                    });
	                    if (this.responseText.indexOf('version') > -1) {
	                        var currentAppVersionFetched = +JSON.parse(this.responseText).version;
	                        if (SessionStore.getCurrentAppVersion() < currentAppVersionFetched) {
	                            SessionStore.setCurrentAppVersion(currentAppVersionFetched);
	                            notification.show(t('dashboard_notification_new_brewplanner_version'), 'info', 5);
	                            delay(function () {
	                                AppAction.updatingNewVersionApi();
	                            }, 5000);
	                        }
	                    }
	                    self.inProgress = false;
	                } catch (error) {
	                    self.inProgress = false;
	                    PollerAppVersion.stop();
	                    PollerAppVersion.start(); // start over again.
	                }
	            }, function () {
	                // retry again
	                self.inProgress = false;
	            });
	        });
	
	        ajax.open('GET', path);
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    },
	
	    /**
	     * Start pulling.
	     */
	    start: function start() {
	        this.refreshIntervalId = setInterval(this.poll, POLL_FREQUENCY);
	    },
	
	    /**
	     * Stop pulling.
	     */
	    stop: function stop() {
	        clearInterval(this.refreshIntervalId);
	    }
	};
	
	module.exports = PollerAppVersion;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var POLL_FREQUENCY = 1000 * 15,
	    RestUtils = __webpack_require__(51),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    Security = __webpack_require__(13).auth,
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    notification = __webpack_require__(21),
	    DashboardStore = __webpack_require__(82),
	    DashboardAction = __webpack_require__(65);
	
	/**
	 * The simple polling class that ask for changes against to the server.
	 * @type {{inProgress: boolean, refreshIntervalId: *, poll: Function, start: Function, stop: Function}}
	 */
	var PollerDashboard = {
	
	  /**
	   * The flag that allow as to not pull other request after finish the previous one.
	   */
	  inProgress: false,
	
	  /**
	   * The native interval id that allow as to stop the cycle when we need it.
	   */
	  refreshIntervalId: null,
	
	  /**
	   * Poll against the resources defined in dashboard to ask for dashboard changes.
	   */
	  poll: function poll() {
	    if (this.inProgress || DashboardStore.isFetchingDashboardContent()) {
	      // this will prevent, in case that fetch user dashboard content takes more than
	      // poller initialization, just skip current interval poller, to finish fetching dashboard content.
	      return;
	    }
	    var self = this;
	    var ajax = RestUtils.createXHR();
	    var path = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/orders/' + SessionStore.getCurrentApplicant() + '/publish/version';
	
	    try {
	
	      this.inProgress = true;
	
	      ajax.addEventListener('error', function (error) {
	        if (!error) {
	          error = {};
	        }
	        if (!error.type) {
	          error.type = '';
	        }
	
	        self.inProgress = false;
	      });
	
	      ajax.addEventListener('load', function () {
	        RestUtils.handlerResponse(this, function () {
	          try {
	            if (DashboardStore && DashboardStore.setIsSavedDraft) {
	              DashboardStore.setIsSavedDraft();
	            }
	
	            if (!SessionStore.isAdminUser()) {
	              if (this.responseText.indexOf('lastPublicationNumber') > -1) {
	                var lastPublicationNumber = +JSON.parse(this.responseText).lastPublicationNumber;
	                if (+SessionStore.getLastPublishVersion() < lastPublicationNumber) {
	                  SessionStore.setLastPublishVersion(lastPublicationNumber);
	                  notification.show(t('dashboard_notification_updated_orders'), 'info');
	                  DashboardAction.publishingSuccess();
	                  DashboardStore.fetchDashboardContentCurrentRange();
	                }
	              }
	
	              if (this.responseText.indexOf('lastBrewingNoteVersion') > -1) {
	                var lastBrewingVersion = +JSON.parse(this.responseText).lastBrewingNoteVersion;
	                if (SessionStore.isAdminUser() === false && +SessionStore.getLastBrewingNoteNumber() < lastBrewingVersion) {
	                  SessionStore.setLastBrewingNoteNumber(lastBrewingVersion);
	                  notification.show(t('dashboard_notification_updated_notes'), 'info');
	                  DashboardAction.needFetchBrewingNotes();
	                }
	              }
	              if (this.responseText.indexOf('lastPackagingNoteVersion') > -1) {
	                var lastPackagingVersion = +JSON.parse(this.responseText).lastPackagingNoteVersion;
	                if (SessionStore.isAdminUser() === false && +SessionStore.getLastPackagingNoteNumber() < lastPackagingVersion) {
	                  SessionStore.setLastPackagingNoteNumber(lastPackagingVersion);
	                  notification.show(t('dashboard_notification_updated_notes'), 'info');
	                  DashboardAction.needFetchPackagingNotes();
	                }
	              }
	            }
	
	            if (SessionStore.isAdminUser()) {
	              var lastChangeUserToken = get(JSON.parse(this.responseText), 'lastChangeUserToken');
	              var isTheSameAdminUser = Security.getToken() === lastChangeUserToken;
	
	              // only make sense when current user is an admin
	              if (!isTheSameAdminUser) {
	                var lastPublicationAdminNumber = get(JSON.parse(this.responseText), 'lastPublicationAdminNumber');
	                if (+SessionStore.getLastPublicationAdminNumber() < lastPublicationAdminNumber) {
	                  SessionStore.setLastPublicationAdminNumber(lastPublicationAdminNumber);
	                  notification.show(t('dashboard_notification_updateging_dashboard'), 'info');
	                  delay(function () {
	                    DashboardAction.updateDashboardWithUserAdmin();
	                  }, 2500); // time wait until refresh browser
	                }
	                var _lastPublicationNumber = get(JSON.parse(this.responseText), 'lastPublicationNumber');
	                if (+SessionStore.getLastPublishVersion() < _lastPublicationNumber) {
	                  SessionStore.setLastPublishVersion(_lastPublicationNumber);
	                  notification.show(t('dashboard_notification_updateging_dashboard'), 'info');
	                  delay(function () {
	                    DashboardStore.fetchDashboardContentCurrentRange();
	                  }, 2500); // time wait until refresh browser
	                }
	              }
	            }
	
	            self.inProgress = false;
	          } catch (err) {
	            DashboardStore.unsetIsSavedDraft();
	            self.inProgress = false;
	            PollerDashboard.stop();
	            PollerDashboard.start(); // start over again.
	          }
	        }, function () {
	          // retry again
	          self.inProgress = false;
	        });
	      });
	
	      ajax.open('GET', path);
	      ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	      ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	      ajax.send();
	    } catch (err) {
	      DashboardStore.unsetIsSavedDraft();
	      self.inProgress = false;
	      self.stop();
	      self.start(); // start over again.
	    }
	  },
	
	
	  /**
	   * Start pulling.
	   */
	  start: function start() {
	    this.refreshIntervalId = setInterval(this.poll, POLL_FREQUENCY);
	  },
	
	
	  /**
	   * Stop pulling.
	   */
	  stop: function stop() {
	    clearInterval(this.refreshIntervalId);
	  }
	};
	
	module.exports = PollerDashboard;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var POLL_FREQUENCY = 1000 * 10,
	    ContentUtils = __webpack_require__(7),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    RestUtils = __webpack_require__(51),
	    Security = __webpack_require__(13).auth,
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    _require2 = __webpack_require__(2),
	    MAX_DRAFT_OPERATION = _require2.MAX_DRAFT_OPERATION,
	    DashboardSpinnerEl = __webpack_require__(156),
	    Notification = __webpack_require__(21),
	    DashboardAction = __webpack_require__(65),
	    DashboardServiceCache = __webpack_require__(28);
	
	/**
	 * The simple pulling class that auto save in pulling way the current draft if was changed.
	 * @type {{inProgress: boolean, intervalId: null, poll: Function, start: Function, stop: Function}}
	 */
	var PollerDraft = {
	
	  /**
	   * The flag that allow as to not pull other request after finish the previous one.
	   */
	  inProgress: false,
	
	  /**
	   * The native interval id that allow as to stop the cycle when we need it.
	   */
	  intervalId: null,
	
	  /**
	   * Auto save draft in backend side in pulling way.
	   */
	  poll: function poll(callback) {
	    if (this._shouldPoll()) {
	      var self = this;
	      try {
	
	        this.inProgress = true;
	        var ajax = RestUtils.createXHR();
	        var path = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/orders/' + SessionStore.getCurrentApplicant() + '/draft';
	        var currentPendingOperations = DashboardServiceCache.getPendingOperations();
	
	        ajax.addEventListener('error', function (error) {
	          if (!error) {
	            error = {};
	          }
	          if (!error.type) {
	            error.type = '';
	          }
	
	          console.error('PollerSaveDraft Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
	          self.inProgress = false;
	          if (callback) {
	            callback();
	          }
	        });
	
	        DashboardSpinnerEl.show();
	
	        ajax.addEventListener('load', function () {
	          RestUtils.handlerResponse(this, function () {
	            var _ContentUtils$parse = ContentUtils.parse(this.responseText),
	                lastIndexSaved = _ContentUtils$parse.lastIndexSaved;
	
	            Notification.show(t('dashboard_notification_draft_auto_saved'), 'success');
	            DashboardServiceCache.markAsSavedOperationsUntilIndex(currentPendingOperations, lastIndexSaved);
	            DashboardAction.savingDraftSuccess();
	            DashboardSpinnerEl.hide();
	            self.inProgress = false;
	
	            if (callback) {
	              callback(lastIndexSaved);
	            }
	          }, function () {
	            // retry again
	            self.inProgress = false;
	          });
	        });
	
	        ajax.open('POST', path);
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	
	        ajax.send(JSON.stringify({
	          'operations': currentPendingOperations
	        }));
	      } catch (err) {
	        self.inProgress = false;
	        console.error(err);
	        DashboardAction.savingDraftFailure();
	      }
	    }
	
	    this._cleanSavedOperations();
	  },
	
	
	  /**
	   * Valid if need to poll pending operations
	   * @returns {boolean}
	   * @private
	   */
	  _shouldPoll: function _shouldPoll() {
	
	    if (this.inProgress === true) {
	      return false;
	    }
	    if (DashboardServiceCache.getPendingOperations().filter(function (operation) {
	      return !operation.isSaved;
	    }).length > 0) {
	      return true;
	    }
	    return false;
	  },
	
	
	  /**
	   * Clean non saved draft operations in order to improve memory consumption.
	   * @private
	   */
	  _cleanSavedOperations: function _cleanSavedOperations() {
	    var hasPendingOperationToSave = DashboardServiceCache.getPendingOperations().length > 0;
	    var maxOperationAllowed = DashboardServiceCache.getOperations().length >= MAX_DRAFT_OPERATION;
	    var hasOperations = DashboardServiceCache.getOperations().length > 0;
	    if (SessionStore.isAdminUser() && hasOperations && maxOperationAllowed) {
	      DashboardServiceCache.cleanSavedOperations();
	    } else if (SessionStore.isAdminUser() && hasOperations && !hasPendingOperationToSave && !DashboardStore.isPublishingDraft() && !DashboardStore.isSavingDraft() && !DashboardStore.isDraggingOrResizing()) {
	      DashboardServiceCache.cleanSavedOperations();
	    }
	  },
	
	
	  /**
	   * Start pulling in order to auto save given draft.
	   */
	  start: function start() {
	    if (SessionStore.isAdminUser()) {
	      this.refreshIntervalId = setInterval(this.poll.bind(this), POLL_FREQUENCY);
	    }
	  },
	
	
	  /**
	   * Stop current pulling
	   */
	  stop: function stop() {
	    clearInterval(this.refreshIntervalId);
	  }
	};
	
	module.exports = PollerDraft;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var POLL_FREQUENCY = 1000 * 3,
	    // 3 seconds
	//const POLL_FREQUENCY = 1000 * 10, // 10 seconds
	RestUtils = __webpack_require__(51),
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    Notification = __webpack_require__(21),
	    Security = __webpack_require__(13).auth,
	    ChronologycServiceCache = __webpack_require__(107);
	
	/**
	 * The simple pulling class that auto save in pulling way notes of dashboard.
	 * @type {{inProgress: boolean, intervalId: null, poll: Function, start: Function, stop: Function}}
	 */
	var PollerSaveNote = {
	
	    /**
	     * The flag that allow as to not pull other request after finish the previous one.
	     */
	    inProgress: false,
	    /**
	     * The native interval id that allow as to stop the cycle when we need it.
	     */
	    intervalId: null,
	
	    /**
	     * Auto save draft in backend side in pulling way.
	     */
	    poll: function poll(callback) {
	
	        if (this._shouldPoll()) {
	            var self = this;
	            var ajax = RestUtils.createXHR();
	            var path = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/operations';
	            var currentBrewingPendingOperations = ChronologycServiceCache.getBrewingOperations();
	            var currentPackagingPendingOperations = ChronologycServiceCache.getPackagingOperations();
	
	            try {
	                this.inProgress = true;
	
	                ajax.addEventListener('error', function (error) {
	                    if (!error) {
	                        error = {};
	                    }
	                    if (!error.type) {
	                        error.type = '';
	                    }
	
	                    console.error('PollerSaveNote Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
	                    self.inProgress = false;
	                    if (callback) {
	                        callback();
	                    }
	                });
	
	                /**
	                 * After save notes in server side, the Publish note number will increment +1
	                 * That change will produce that PollerDashboard#pool() will trigger DashboardActionCreators#needFetchNotes() action.
	                 * And after that, the Chronologyc view will render with the new notes values.
	                 */
	                ajax.addEventListener('load', function () {
	                    RestUtils.handlerResponse(this, function () {
	                        DashboardStore.setIsSavedDraft();
	                        ChronologycServiceCache.deleteBrewingOperationPerformed(currentBrewingPendingOperations);
	                        ChronologycServiceCache.deletePackagingOperationPerformed(currentPackagingPendingOperations);
	                        self.inProgress = false;
	                        if (callback) {
	                            callback();
	                        }
	                    }, function () {
	                        // retry again
	                        self.inProgress = false;
	                    });
	                });
	
	                ajax.open('POST', path);
	                ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	                ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	
	                ajax.send(JSON.stringify({
	                    'brewingOperations': currentBrewingPendingOperations,
	                    'packagingOperations': currentPackagingPendingOperations,
	                    'lastBrewingNoteNumber': SessionStore.getLastBrewingNoteNumber(),
	                    'lastPackagingNoteNumber': SessionStore.getLastPackagingNoteNumber()
	                }));
	                Notification.show('Notes Saved', 'success', 3);
	            } catch (err) {
	                self.inProgress = false;
	                DashboardStore.unsetIsSavedDraft();
	            }
	        }
	    },
	
	    /**
	     * Valid if need to poll pending operations
	     * @returns {boolean}
	     * @private
	     */
	    _shouldPoll: function _shouldPoll() {
	        if (this.inProgress === true) {
	            return false;
	        }
	        if (ChronologycServiceCache.getBrewingOperations().length > 0 || ChronologycServiceCache.getPackagingOperations().length > 0) {
	            return true;
	        }
	        return false;
	    },
	
	    /**
	     * Start pulling in order to auto save given draft.
	     */
	    start: function start() {
	        if (SessionStore.isAdminUser()) {
	            this.refreshIntervalId = setInterval(this.poll.bind(this), POLL_FREQUENCY);
	        }
	    },
	
	    /**
	     * Stop current pulling
	     */
	    stop: function stop() {
	        clearInterval(this.refreshIntervalId);
	    }
	};
	
	module.exports = PollerSaveNote;

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    Security = __webpack_require__(13).auth,
	    SessionStore = __webpack_require__(11);
	
	var BrewhouseServiceImpl = {
	    fetchTask: function fetchTask(onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', onFailure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.responseText));
	            }, function () {
	                onFailure.bind(this)(this.responseText);
	            });
	        });
	        ajax.open('GET', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process');
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    },
	    addTask: function addTask(content, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', onFailure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess(this);
	            }, function () {
	                onFailure(this);
	            });
	        });
	        ajax.open('POST', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send(JSON.stringify(content));
	    },
	    changeTask: function changeTask(content, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', onFailure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess(this);
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	        ajax.open('PUT', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send(JSON.stringify(content));
	    },
	    deleteTask: function deleteTask(id, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('error', onFailure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess(this);
	            }, function () {
	                onFailure.bind(this)();
	            });
	        });
	        ajax.open('DELETE', apiAppUrl + '/brewhouse/' + SessionStore.getCurrentApplicant() + '/process/' + id, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    }
	};
	
	module.exports = BrewhouseServiceImpl;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    Security = __webpack_require__(13).auth,
	    Constants = __webpack_require__(2),
	    SessionStore = __webpack_require__(11);
	
	var ChronologycService = {
	
	    fetchBrewingNotes: function fetchBrewingNotes(success, failure) {
	        var ajax = RestUtils.createXHR();
	
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/type/' + Constants.NOTE_TYPE_BREWING, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    },
	
	    fetchPackagingNotes: function fetchPackagingNotes(success, failure) {
	        var ajax = RestUtils.createXHR();
	
	        ajax.addEventListener('error', failure);
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, success, failure);
	        });
	        ajax.open('GET', ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API + '/notes/' + SessionStore.getCurrentApplicant() + '/type/' + Constants.NOTE_TYPE_PACKAGING, true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
	        ajax.send();
	    }
	};
	
	module.exports = ChronologycService;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    Constants = __webpack_require__(2),
	    Security = __webpack_require__(13).auth;
	
	var HistoryServiceImpl = {
	    getHistories: function getHistories(onSuccess) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	        ajax.open('GET', apiAppUrl + '/histories', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send();
	    },
	    saveChanges: function saveChanges(historyChanges, onSuccess) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                onSuccess.bind(this);
	            });
	        });
	        ajax.open('POST', apiAppUrl + '/histories', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
	        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
	        ajax.send(JSON.stringify(historyChanges));
	    }
	};
	
	module.exports = HistoryServiceImpl;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var RestUtils = __webpack_require__(51),
	    Security = __webpack_require__(13).auth,
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    signUpService;
	
	signUpService = {
	
	    signUp: function signUp(singUp, onSuccess, onFailure) {
	        var ajax = RestUtils.createXHR();
	        ajax.addEventListener('load', function () {
	            RestUtils.handlerResponse(this, function () {
	                var token = this.getResponseHeader('X-AUTH-TOKEN');
	                if (token) {
	                    Security.loginFromSignUp(token, singUp.username);
	                } else {
	                    onFailure.bind(this)({ message: 'No token found in response' });
	                }
	                onSuccess.bind(this)();
	            }, function () {
	                onFailure.bind(this)(JSON.parse(this.responseText));
	            });
	        });
	
	        ajax.open('POST', apiAppUrl + '/signup', true);
	        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        ajax.send(JSON.stringify(singUp));
	
	        try {
	            if (window.rdt) {
	                window.rdt('track', 'SignUp', {
	                    'currency': 'USD',
	                    'value': 100
	                });
	            }
	        } catch (e) {
	            console.log('Error in reddit tracking', e);
	        }
	    }
	
	};
	
	exports.signUpService = signUpService;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var NumberUtils = __webpack_require__(23),
	    get = __webpack_require__(5).get,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    InventoryServiceImpl = __webpack_require__(406);
	
	
	var LocationStore = {
	
	    /**
	     * Persist new item in the application that will be available from the dashboard.
	     * @param {Object} transferInfo
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    saveTransfer: function saveTransfer(transferInfo, success, failure) {
	        InventoryServiceImpl.saveTransfer(transferInfo, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Perform the validation needed to defined is possible and if is valid the transference.
	     * @param amountOrigin
	     * @param estimatedAmount
	     * @param amountTransfer
	     * @return {*}
	     */
	    isValidTransfer: function isValidTransfer(amountOrigin, estimatedAmount, amountTransfer) {
	        if (amountOrigin === 0) {
	            return t('inventory_and_transfer_error_inline_amount_should_be_bigger_than_zero');
	        }
	
	        if (NumberUtils.isLess(amountTransfer, 0) || NumberUtils.isLess(estimatedAmount, 0)) {
	            return t('inventory_and_transfer_error_inline_amount_should_be_bigger_than_zero');
	        }
	
	        if (NumberUtils.isGreater(amountTransfer, amountOrigin)) {
	            return t('inventory_and_transfer_error_inline_insufficient_amount_in_location');
	        }
	
	        return ''; // transfer was success
	    },
	
	
	    /**
	     * Perform the validation needed to defined is possible and if is valid the adjust.
	     * @param locationItem
	     * @param amountTransfer
	     * @return {*}
	     */
	    isValidAdjust: function isValidAdjust(locationItem, amountTransfer) {
	        var amountFromAdjusts = get(locationItem, 'amount');
	        var amountToTransfer = NumberUtils.toNumber(amountTransfer);
	
	        if (amountToTransfer > amountFromAdjusts) {
	            return t('inventory_and_transfer_error_inline_insufficient_amount_in_location');
	        }
	
	        return ''; // transfer was success
	    },
	
	
	    /**
	     * Make a transference between locations from specific amounts of items,
	     * and return the result of amounts between origin and destination.
	     *
	     * @param {String} amountOrigin         The amount of items which have the origin location
	     *                                          before perform the transference.
	     * @param {String} locationItemTo      The amount of items which have the destination location
	     *                                          before perform the transference
	     * @param {String} amountToTransfer     The amount will be transferred between locations.
	     * @return {Object}
	     *
	     * Note: Will return the results which standardise decimal format.
	     */
	    transfer: function transfer(amountOrigin, amountDestination, amountToTransfer) {
	
	        var amountTransferStandardise = NumberUtils.standardiseDecimalFormatNumber(amountToTransfer);
	        var remainingAmountOrigin = NumberUtils.subtract(NumberUtils.standardiseDecimalFormatNumber(amountOrigin), amountTransferStandardise);
	        var updateAmountDestination = NumberUtils.sum(NumberUtils.standardiseDecimalFormatNumber(amountDestination), amountTransferStandardise);
	
	        return {
	            locationItemAmountFrom: String(remainingAmountOrigin),
	            locationItemAmountTo: String(updateAmountDestination),
	            amountToTransfer: String(amountToTransfer)
	        };
	    }
	};
	
	module.exports = LocationStore;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var DateUtils = __webpack_require__(22),
	    DashboardModalUtils = __webpack_require__(50),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Notification = __webpack_require__(21),
	    OrderUtils = __webpack_require__(49),
	    ContentUtils = __webpack_require__(7),
	    _ = __webpack_require__(40),
	    Constants = __webpack_require__(2);
	
	
	var OrderSingleStore = {
	    recalculateSingleOrderTasksWhenDragging: function recalculateSingleOrderTasksWhenDragging(order, positionNew, positionOld) {
	        var offsetDays = positionNew.y - positionOld.y;
	        var isDirectionTop = positionOld.y > positionNew.y;
	
	        // Invert positive or negative depended of the direction.
	        var offsetDaysOfFromDate = isDirectionTop ? -Math.abs(offsetDays) : Math.abs(offsetDays);
	
	        // All date tasks must be changes without need to remove any task.
	        order.singleTasks = _.map(order.singleTasks, function (task) {
	            task.date = DateUtils.toDateText(DateUtils.addDays(DateUtils.toDate(task.date), offsetDaysOfFromDate));
	            // update end dete or each product if needed
	            task = OrderUtils.recalculateOffsetProductsEndDate(task, offsetDays);
	
	            // Update task of each process
	            task = OrderUtils.recalculateProcessDate(task, offsetDays);
	            return task;
	        });
	
	        return order;
	    },
	    recalculateSingleOrderTasksWhenResizing: function recalculateSingleOrderTasksWhenResizing(order) {
	        // NOTICE: when enter here the `order` is already updated.
	        var dateTarget = order.toDate;
	        var existingTask = _.find(_.get(order, 'singleTasks'), function (task) {
	            return task.date === dateTarget;
	        });
	
	        if (!existingTask) {
	            var newTask = DashboardModalUtils.toEmptyTask(dateTarget);
	            newTask.date = dateTarget;
	            newTask.type = Constants.SECONDARY_TASK; // singles always are secondary.
	            order.singleTasks = ContentUtils.pushSafe(order.singleTasks, newTask);
	        }
	
	        order = removeTasksOutOfRange(order);
	
	        return order;
	    },
	
	
	    /**
	     * Check all dates of the single order if are properly assigned.
	     * @param {Object} order the order to be validated
	     * @private
	     */
	    checkDateOfSingleOrder: function checkDateOfSingleOrder(order) {
	        if (DateUtils.isBefore(order.toDate, order.fromDate)) {
	            Notification.show(t('dashboard_notification_brew_date_must_be_before_packaging_date'));
	            return false;
	        }
	
	        return true;
	    },
	
	
	    /**
	     *
	     * Given order, change or remove task if are necessary depend is dragging or resizing.
	     * @param order
	     * @param isDragging
	     * @param positionOld
	     * @param positionNew
	     * @return {*}
	     */
	    recalculateSingleOrderTasks: function recalculateSingleOrderTasks(order, isDragging, positionOld, positionNew) {
	
	        if (!order) {
	            return null;
	        }
	
	        if (isDragging) {
	            order = this.recalculateSingleOrderTasksWhenDragging(order, positionNew, positionOld);
	        } else {
	            order = this.recalculateSingleOrderTasksWhenResizing(order);
	        }
	
	        return order;
	    }
	};
	
	function removeTasksOutOfRange(order) {
	    order.singleTasks = _.filter(order.singleTasks, function (task) {
	        return DateUtils.isBeforeOrEquals(task.date, order.toDate) && DateUtils.isAfterOrEquals(task.date, order.fromDate);
	    });
	    return order;
	}
	
	module.exports = OrderSingleStore;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var UserServiceImpl = __webpack_require__(181);
	
	var UserStore = {
	
	    /**
	     * Persist new User in the application.
	     * @param User
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    addUser: function addUser(User, success, failure) {
	        UserServiceImpl.createUser(User, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Change persistent User in the application.
	     * @param User
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    changeUser: function changeUser(User, success, failure) {
	        UserServiceImpl.changeUser(User, function () {
	            if (success) {
	                success(this);
	            }
	        }, failure);
	    },
	
	
	    /**
	     * Delete Users from the application.
	     * @param {Long} userId
	     * @param {Function} success
	     * @param {Function} failure
	     */
	    deleteUser: function deleteUser(userId, success, failure) {
	        UserServiceImpl.deleteUser(userId, function () {
	            if (success) {
	                success();
	            }
	        }, failure);
	    },
	    fetchUsers: function fetchUsers(success, failure) {
	        UserServiceImpl.fetchUsers(function (users) {
	            if (success) {
	                success(users);
	            }
	        }, failure);
	    }
	};
	
	module.exports = UserStore;

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Viewport = __webpack_require__(413);
	
	var BASE_MARGIN = 5,
	    CONNECTOR_MARGIN = 4,
	    VERTICAL_POSITIONS = ['top', 'bottom'],
	    HORIZONTAL_POSITIONS = ['left', 'right'],
	    VERTICAL_ALIGNMENTS = ['top', 'middle', 'bottom'],
	    HORIZONTAL_ALIGNMENTS = ['left', 'center', 'right'];
	
	/**
	 * Makes calculations for box-shadow sizes
	 * @param  {HTMLElmenet} element Element source for box-shadow sizes
	 * @return {object} object.top {Number}
	 *                  object.bottom {Number}
	 *                  object.left {Number}
	 *                  object.right {Number}
	 */
	function getBoxShadowSize(element) {
	    var style = window.getComputedStyle(element),
	        shadowSize,
	        shadowSizeArray,
	        hShadow,
	        vShadow,
	        spread,
	        blur,
	        result = {
	        left: 0,
	        right: 0,
	        top: 0,
	        bottom: 0
	    };
	
	    shadowSize = style.getPropertyValue('box-shadow');
	    if (shadowSize === 'none') {
	        return result;
	    }
	
	    // Remove all possible color definitions
	    shadowSize = shadowSize.replace(/rgba?\([^\)]+\)/gi, '');
	    shadowSize = shadowSize.replace(/#[0-9a-f]+/gi, '');
	
	    // Remove any alpha characters
	    shadowSize = shadowSize.replace(/[a-z]+/gi, '').trim();
	
	    shadowSizeArray = shadowSize.split(' ');
	
	    hShadow = +shadowSizeArray[0];
	    vShadow = +shadowSizeArray[1];
	    blur = +shadowSizeArray[2];
	    spread = +shadowSizeArray[3];
	
	    result.left = Math.max(spread - hShadow + 0.5 * blur, 0);
	    result.right = Math.max(spread + hShadow + 0.5 * blur, 0);
	    result.top = Math.max(spread - vShadow + 0.5 * blur, 0);
	    result.bottom = Math.max(spread + vShadow + 0.5 * blur, 0);
	
	    return result;
	}
	
	/**
	 * Some math to retrieve the current position of the target element.
	 * @argument {HTMLElement} The element to get the position.
	 *
	 * @return {object} object.x {Number}
	 *                  object.y {Number}
	 */
	function _getAbsolutePosition(elem) {
	    var x = 0,
	        y = 0;
	    // offset is relative to parent so,
	    // we traverse all the tree up until
	    // target has no more parents.
	    do {
	        if (elem) {
	            x += parseInt(elem.offsetTop, 10);
	            y += parseInt(elem.offsetLeft, 10);
	            elem = elem.offsetParent;
	        }
	    } while (elem && !_generatesNewStackingContext(elem));
	    return {
	        x: x,
	        y: y
	    };
	}
	
	/**
	 * Determines if the element is in a stacked context.
	 * @param {HTMLElement} elem Element source to check stacked context
	 * @returns {boolean}
	 * @private
	 */
	function _generatesNewStackingContext(elem) {
	    var styles = elem ? window.getComputedStyle(elem) : null,
	        pos;
	    if (styles) {
	        pos = styles.position;
	        if (pos === 'absolute' || pos === 'relative' || pos === 'fixed') {
	            return true;
	        }
	    }
	    return false;
	}
	
	/**
	 * Determines if the element has non-zero offsetWidth and offsetHeight.
	 * @param  {HTMLElement} elem Element to detect width and height
	 * @return {Boolean}      True if the element has non-zero width and height
	 */
	function _hasDimension(elem) {
	    return elem.offsetWidth > 0 && elem.offsetHeight > 0;
	}
	
	/**
	 * Retrieves the dimensions of the object.
	 *
	 * @argument {HTMLElement} The element which we want to get the dimension.
	 *
	 * @return {object} object.width {Number}
	 *                  object.height {Number}
	 */
	function _getDimension(elem) {
	    var dimensions = {},
	        style = {
	        'position': '',
	        'display': '',
	        'top': '',
	        'left': ''
	    },
	        moved = false,
	        domRect,
	        rect = {},
	        key = '';
	
	    // If we have dimensions we can just use it.
	    if (!_hasDimension(elem)) {
	        domRect = elem.getBoundingClientRect();
	
	        if (!domRect.width || !domRect.height) {
	
	            // If we don't have dimensions we need to put the elem in a state
	            // that we can truly get the width and height and then restore
	            // everything.
	            moved = true;
	            for (key in style) {
	                style[key] = elem.style[key] || '';
	            }
	
	            // @TODO Maybe a better strategy here. The main issue with this
	            // is performance.
	            elem.style.position = 'absolute';
	            elem.style.left = '-1000px';
	            elem.style.top = '-1000px';
	            elem.style.display = 'inline-block';
	        } else {
	            rect.width = domRect.width;
	            rect.height = domRect.height;
	        }
	    }
	    dimensions = {
	        width: rect.width || elem.offsetWidth,
	        height: rect.height || elem.offsetHeight
	    };
	
	    if (moved) {
	        for (key in style) {
	            elem.style[key] = style[key];
	        }
	    }
	
	    return dimensions;
	}
	
	/**
	 * Retrieve the position and the dimensions of an element.
	 *
	 * @return {object} object.left {Number}
	 *                  object.top {Number}
	 *                  object.right {Number}
	 *                  object.bottom {Number}
	 *                  object.width {Number}
	 *                  object.height {Number}
	 */
	function _getRect(elem) {
	    var rect = {},
	        position = _getAbsolutePosition(elem),
	        dimension = _getDimension(elem);
	    rect.left = position.y;
	    rect.right = position.y + dimension.width;
	    rect.top = position.x;
	    rect.bottom = position.x + dimension.height;
	    rect.width = dimension.width;
	    rect.height = dimension.height;
	
	    return rect;
	}
	
	/**
	 * Math to determine if the top position is available.
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {Number} margin                margin between the popup and the target
	 * @argument {Object} boxShadow             calculated size of box-shadow property of child
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryTopPosition(targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType) {
	    var available = targetRect.top,
	        finalMargin = margin + boxShadow.bottom,
	        needed = childRect.height + finalMargin;
	
	    if (needed < available) {
	        currentPositionType.position = 'top';
	        currentPosition.x = targetRect.top - needed;
	    }
	}
	
	/**
	 * Math to determine if the bottom position is available.
	 *
	 * @argument {object}   targetRect          position and dimensions of the parent object.
	 * @argument {object}   childRect           position and dimensions of the child object.
	 * @argument {Number}   margin              margin between the popup and the target
	 * @argument {Object}   boxShadow           calculated size of box-shadow property of child
	 * @argument {object}   currentPosition     current calculations for positioning the popup
	 * @argument {object}   currentPositionType current type of position or alignment
	 * @argument {Boolean}  force               when set on true, forces the positioning (used as fallback)
	 *
	 * @return {object} result
	 */
	function _tryBottomPosition(targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType, force) {
	    var finalMargin = margin + boxShadow.top,
	        available = _getPageSize(this.ownerDocument).height - targetRect.bottom,
	        needed = childRect.height + finalMargin;
	
	    if (needed < available || force) {
	        currentPositionType.position = 'bottom';
	        currentPosition.x = targetRect.bottom + finalMargin;
	    }
	}
	
	/**
	 * Math to determine if the right position is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {Number} margin                margin between the popup and the target
	 * @argument {Object} boxShadow             calculated size of box-shadow property of child
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryRightPosition(targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType) {
	    var finalMargin = margin + boxShadow.left,
	        available = _getPageSize(this.ownerDocument).width - targetRect.right,
	        needed = childRect.width + finalMargin;
	
	    if (needed < available) {
	        currentPositionType.position = 'right';
	        currentPosition.y = targetRect.right + finalMargin;
	    }
	}
	
	/**
	 * Math to determine if the left position is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {Number} margin                margin between the popup and the target
	 * @argument {Object} boxShadow             calculated size of box-shadow property of child
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryLeftPosition(targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType) {
	    var finalMargin = margin + boxShadow.right,
	        available = targetRect.left,
	        needed = childRect.width + finalMargin;
	
	    if (needed < available) {
	        currentPositionType.position = 'left';
	        currentPosition.y = targetRect.left - needed;
	    }
	}
	
	/**
	 * Math to determine if the left alignment is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryLeftAlignment(targetRect, childRect, currentPosition, currentPositionType) {
	    var available = _getPageSize(this.ownerDocument).width - targetRect.left,
	        needed = childRect.width;
	
	    if (needed < available) {
	        currentPositionType.alignment = 'left';
	        currentPosition.y = targetRect.left;
	    }
	}
	
	/**
	 * Math to determine if the center alignment is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryCenterAlignment(targetRect, childRect, currentPosition, currentPositionType) {
	    var available = _getPageSize(this.ownerDocument).width,
	        needed = childRect.width,
	        halfChild,
	        targetCenterPos;
	
	    if (needed < available) {
	        currentPositionType.alignment = 'center';
	
	        halfChild = childRect.width / 2;
	        targetCenterPos = targetRect.left + targetRect.width / 2;
	
	        if (targetCenterPos > halfChild) {
	            // Popup left half fits
	            if (targetCenterPos + halfChild < available) {
	                // Popup fits centered
	                currentPosition.y = targetCenterPos - halfChild;
	            } else {
	                // Popup doesn't fit on the right, so will be sticky to that side
	                currentPosition.y = available - childRect.width;
	            }
	        } else {
	            // Popup doesn't fit on the left, so will be sticky to that side
	            currentPosition.y = 0;
	        }
	    }
	}
	
	/**
	 * Math to determine if the right alignment is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryRightAlignment(targetRect, childRect, currentPosition, currentPositionType) {
	    var available = targetRect.right,
	        needed = childRect.width;
	
	    if (needed < available) {
	        currentPositionType.alignment = 'right';
	        currentPosition.y = targetRect.left - childRect.width + targetRect.width;
	    }
	}
	
	/**
	 * Math to determine if the top alignment is available.
	 *
	 * @argument {object}   targetRect          position and dimensions of the parent object.
	 * @argument {object}   childRect           position and dimensions of the child object.
	 * @argument {object}   currentPosition     current calculations for positioning the popup
	 * @argument {object}   currentPositionType current type of position or alignment
	 * @argument {Boolean}  force               when set on true, forces the positioning (used as fallback)
	 *
	 * @return {object} result
	 */
	function _tryTopAlignment(targetRect, childRect, currentPosition, currentPositionType, force) {
	    var available = _getPageSize(this.ownerDocument).height - targetRect.top,
	        needed = childRect.height;
	
	    if (needed < available || force) {
	        currentPositionType.alignment = 'top';
	        currentPosition.x = targetRect.top;
	    }
	}
	
	/**
	 * Math to determine if the middle alignment is available.
	 *
	 * @argument {object} targetRect            position and dimensions of the parent object.
	 * @argument {object} childRect             position and dimensions of the child object.
	 * @argument {object} currentPosition       current calculations for positioning the popup
	 * @argument {object} currentPositionType   current type of position or alignment
	 *
	 * @return {object} result
	 */
	function _tryMiddleAlignment(targetRect, childRect, currentPosition, currentPositionType) {
	    var available = _getPageSize(this.ownerDocument).height,
	        child,
	        targetPos;
	
	    currentPositionType.alignment = 'middle';
	
	    child = childRect.height;
	    targetPos = targetRect.top;
	
	    // Popup top half fits
	    if (targetPos + child < available) {
	        // Popup fits centered
	        currentPosition.x = targetPos;
	    } else {
	        // Popup doesn't fit on the bottom, so will be sticky to that side
	        currentPosition.x = Math.max(0, available - childRect.height);
	    }
	}
	
	/**
	 * Math to determine if the bottom alignment is available.
	 *
	 * @argument {object} targetRect position and dimensions of the parent object.
	 * @argument {object} childRect position and dimensions of the child object.
	 * @argument {object} result current calculation for positioning the popup
	 *
	 * @return {object} result
	 */
	function _tryBottomAlignment(targetRect, childRect, currentPosition, currentPositionType) {
	    var available = targetRect.bottom,
	        needed = childRect.height;
	
	    if (needed < available) {
	        currentPositionType.alignment = 'bottom';
	        currentPosition.x = targetRect.bottom - needed;
	    }
	}
	
	/**
	 * Calculates document width and height relative to viewport (position fixed) in a crossbrowser way
	 * @param  {HTMLElement} elementOwnerDocument ownerDocument property of an element contained in the document
	 * @return {Object}         object.height   {Number}
	 *                          object.width    {Number}
	 */
	function _getPageSize(elementOwnerDocument) {
	    var documentEl = elementOwnerDocument.documentElement;
	
	    return {
	        width: Math.max(documentEl.clientWidth, window.innerWidth || 0),
	        height: Math.max(documentEl.clientHeight, window.innerHeight || 0)
	    };
	}
	
	/**
	 * Calculates position for the popup
	 * @param  {HTMLElement}    component                   component to be rendered as a popup
	 * @param  {Object}         target                      contains position and dimensions of target element
	 * @param  {Array}          positionOrder               ordered list of possible positions to fit the popup
	 * @param  {Object}         alignmentOrder              ordered list of possible alignments to try to fit the popup
	 * @param  {Object}         margin                      margin between the popup and the target
	 * @param  {Object}         customPositioningMethods    custom position or alignment methods
	 * @return {Object}         object.x
	 *                          object.y
	 *                          object.positionFound
	 *                          object.alignmentFound
	 */
	function _getPopupPosition(component, target, positionOrder, alignmentOrder, margin, customPositioningMethods) {
	    var currentPosition = {
	        x: -1,
	        y: -1
	    },
	        positionMap = {
	        'top': _tryTopPosition,
	        'left': _tryLeftPosition,
	        'right': _tryRightPosition,
	        'bottom': _tryBottomPosition
	    },
	        alignmentMap = {
	        'top': _tryTopAlignment,
	        'left': _tryLeftAlignment,
	        'right': _tryRightAlignment,
	        'bottom': _tryBottomAlignment,
	        'middle': _tryMiddleAlignment,
	        'center': _tryCenterAlignment
	    },
	        boxShadow = {
	        top: 0,
	        left: 0,
	        right: 0,
	        bottom: 0
	    },
	        currentPositionType = {},
	        childRect,
	        connector = component.querySelector('.connector'),
	        targetRect,
	        positionFound,
	        alignmentFound,
	        verticalPosition,
	        method,
	        posibleAlignments;
	
	    customPositioningMethods = customPositioningMethods || {};
	    targetRect = _getRect(target);
	    if (!component.style.minWidth) {
	        component.style.minWidth = targetRect.width + 'px';
	    }
	    childRect = _getRect(component);
	
	    // If the component has a connector, we need to add extra margin
	    if (connector) {
	        margin = BASE_MARGIN + (margin || CONNECTOR_MARGIN);
	    } else {
	        margin = BASE_MARGIN + (margin || 0);
	        boxShadow = getBoxShadowSize(component);
	    }
	
	    // Checks every position on the array until one fits on the page
	    positionFound = positionOrder.some(function (pos) {
	        var method = customPositioningMethods[pos] || positionMap[pos];
	        if (method) {
	            method.call(target, targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType);
	            return currentPositionType.position;
	        }
	    });
	
	    if (!positionFound) {
	        method = customPositioningMethods.bottom || positionMap.bottom;
	        // If there's no space anywhere, popup is forced to be added at the bottom
	        method.call(target, targetRect, childRect, margin, boxShadow, currentPosition, currentPositionType, true);
	    }
	
	    verticalPosition = VERTICAL_POSITIONS.indexOf(currentPositionType.position) > -1;
	    if (verticalPosition) {
	        posibleAlignments = HORIZONTAL_ALIGNMENTS;
	    } else {
	        posibleAlignments = VERTICAL_ALIGNMENTS;
	    }
	
	    // Check every alignment on the array that matches with the position until one fits on the page
	    alignmentFound = alignmentOrder.some(function (align) {
	        var method;
	        if (posibleAlignments.indexOf(align) > -1) {
	            method = customPositioningMethods[align] || alignmentMap[align];
	            method.call(target, targetRect, childRect, currentPosition, currentPositionType);
	            return currentPositionType.alignment;
	        }
	    });
	
	    // If there's no space anywhere, popup is forced to be aligned to the top
	    if (!alignmentFound && !verticalPosition) {
	        method = customPositioningMethods.top || alignmentMap.top;
	        alignmentMap.top.call(target, targetRect, childRect, currentPosition, currentPositionType, true);
	    }
	
	    if (connector && currentPositionType.alignment === 'middle') {
	        // TODO: handle connector with height different from 14px
	        // Problem: at this point, '_getRect(connector)' returns 0-values
	        connector.style.top = (Math.min(childRect.height, targetRect.height) - 14) / 2 + 'px';
	    }
	
	    return {
	        'currentPosition': currentPosition,
	        'currentPositionType': currentPositionType
	    };
	}
	
	/**
	 * Resets all position and alignments classes
	 * @param  {HTMLElement} component Component to clear classes
	 */
	function _clearPosition(component) {
	    VERTICAL_POSITIONS.forEach(function (pos) {
	        this.classList.remove('position-' + pos);
	    }, component);
	
	    HORIZONTAL_POSITIONS.forEach(function (pos) {
	        this.classList.remove('position-' + pos);
	    }, component);
	
	    VERTICAL_ALIGNMENTS.forEach(function (alignment) {
	        this.classList.remove('alignment-' + alignment);
	    }, component);
	
	    HORIZONTAL_ALIGNMENTS.forEach(function (alignment) {
	        this.classList.remove('alignment-' + alignment);
	    }, component);
	}
	
	/**
	 * Updates styles of component with position and alignments
	 * @param  {HTMLElement}    component      Component to show as a popup
	 * @param  {Object}         positionTarget Position and alignments to be set
	 */
	function _updateComponent(component, positionTarget) {
	    _clearPosition(component);
	
	    component.classList.add('position-' + positionTarget.currentPositionType.position);
	    component.classList.add('alignment-' + positionTarget.currentPositionType.alignment);
	
	    component.style.top = positionTarget.currentPosition.x + 'px';
	    component.style.left = positionTarget.currentPosition.y + 'px';
	}
	
	/**
	 * Sets position order and alignment order based on parameters or default values
	 * Obtains coordinates for popup
	 * Updates component with new coordinates
	 * @param  {HTMLElement}    component                   component to show as a popup
	 * @param  {HTMLElement}    referenceElement            reference element to position the popup
	 * @param  {Array}          positions                   ordered list of possible positions to fit the popup
	 * @param  {Array}          alignment                   ordered list of possible alignments to try to fit the popup
	 * @param  {Number}         margin                      margin to add to the BASE_MARGIN
	 * @param  {Object}         customPositioningMethods    custom position or alignment methods
	 * @return {Boolean}                                    true if a position for the popup could be found
	 */
	function _setPosition(component, referenceElement, positions, alignment, margin, customPositioningMethods) {
	
	    var finalAlignment, positionTarget, orderPosition;
	
	    orderPosition = positions || ['bottom', 'top'];
	    finalAlignment = alignment || ['left', 'right'];
	
	    positionTarget = _getPopupPosition(component, referenceElement, orderPosition, finalAlignment, margin, customPositioningMethods);
	
	    if (!positionTarget.currentPositionType.position || !positionTarget.currentPositionType.alignment) {
	        _hide(component);
	        return false;
	    }
	
	    _updateComponent(component, positionTarget);
	
	    return true;
	}
	
	/**
	 * Adds listener for browser resize.
	 * @param  {HTMLElement}    popupElement                Component where a resize listening method should be installed
	 * @param  {HTMLElement}    referenceElement            Reference element to position the popup
	 * @param  {Array}          positions                   ordered list of possible positions to fit the popup
	 * @param  {Array}          alignment                   ordered list of possible alignments to try to fit the popup
	 * @param  {Number}         margin                      margin to add to the BASE_MARGIN
	 * @param  {Object}         customPositioningMethods    custom position or alignment methods
	 * @return {Function}                                   Return a reference for future removal of listener
	 */
	function _installResizeMethod(popupElement, referenceElement, positions, alignment, margin, customPositioningMethods) {
	    var resizeMethod;
	
	    resizeMethod = function resizeMethod() {
	        if (popupElement.classList.contains('visible')) {
	            _setPosition(popupElement, referenceElement, positions, alignment, margin, customPositioningMethods);
	        }
	    };
	
	    Viewport.onResize(resizeMethod);
	
	    return resizeMethod;
	}
	
	/**
	 * Removes listener for browser resize
	 * @param  {Function} callback Reference of the listener to remove
	 */
	function _uninstallResizeMethod(callback) {
	    Viewport.offResize(callback);
	}
	
	/**
	 * Calculates popup position based on the reference HTML element on conf.target.
	 * Then, calls popupElement.show.
	 * If extraOpts exists, uses it as an argument for show method
	 * @param  {HTMLElement}    popupElement                component to show as a popup
	 * @param  {HTMLElement}    referenceElement            reference element to position the popup
	 * @param  {Array}          positions                   ordered list of possible positions to fit the popup
	 * @param  {Array}          alignment                   ordered list of possible alignments to try to fit the popup
	 * @param  {Object}         extraOpts                   Optional. Properties to be send to the popupElement
	 * @param  {Number}         margin                      margin to add to the BASE_MARGIN
	 * @param  {Object}         customPositioningMethods    custom position or alignment methods
	 */
	function _show(popupElement, referenceElement, positions, alignment, extraOpts, margin, customPositioningMethods) {
	    var setupSuccessful = false;
	
	    if (!document.body.contains(referenceElement)) {
	        // Silently fail if the target is not in the DOM.
	        return;
	    }
	
	    if (popupElement.show && !popupElement.classList.contains('visible')) {
	        setupSuccessful = _setPosition(popupElement, referenceElement, positions, alignment, margin, customPositioningMethods);
	        if (setupSuccessful) {
	            popupElement.show(extraOpts);
	        }
	    }
	}
	
	/**
	 * Hides the previously shown component
	 * @param  {HTMLElement} popupElement Component to be hidden
	 */
	function _hide(popupElement) {
	    if (popupElement.classList.contains('visible')) {
	        popupElement.close();
	    }
	}
	
	module.exports = {
	    installResizeMethod: _installResizeMethod,
	    uninstallResizeMethod: _uninstallResizeMethod,
	    clearPosition: _clearPosition,
	    setPosition: _setPosition,
	    show: _show,
	    hide: _hide
	};

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    CustomDialog = __webpack_require__(26),
	    SessionStore = __webpack_require__(11),
	    BeerStyleStore = __webpack_require__(95),
	    IconStore = __webpack_require__(411),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    Loading = __webpack_require__(33),
	    NumberUtils = __webpack_require__(23),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupColorPicker = __webpack_require__(701),
	    FormGroupButton = __webpack_require__(30),
	    FormGroupToggle = __webpack_require__(705),
	    Stamps = __webpack_require__(154),
	    Stamp = __webpack_require__(131),
	    DashboardServiceCache = __webpack_require__(28),
	    Authentication = __webpack_require__(13).Authentication,
	    ContentUtils = __webpack_require__(7),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    map = _require2.map,
	    filter = _require2.filter,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    Notification = __webpack_require__(21),
	    _require4 = __webpack_require__(2),
	    FERMENTER_TYPE_TASK = _require4.FERMENTER_TYPE_TASK,
	    PACKAGING_TYPE_TASK = _require4.PACKAGING_TYPE_TASK,
	    BREWING_TYPE_TASK = _require4.BREWING_TYPE_TASK,
	    _ = __webpack_require__(40),
	    ga = __webpack_require__(18);
	
	
	var BeerStyleAdmin = React.createClass({ displayName: "BeerStyleAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            isSaving: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchBeerStyles();
	        ga.pageview('/style-beer-admin');
	    },
	    fetchBeerStyles: function fetchBeerStyles() {
	        var self = this;
	        IconStore.fetchIcons(function (icons) {
	            var dirtyIcons = get(icons, 'icons', []);
	            var cleanIcons = map(dirtyIcons, function (icon) {
	                return icon.iconDetail;
	            });
	            BeerStyleStore.fetchStyleBeers(function (beerStyles) {
	                self.setState({
	                    beerStyles: self._hydrateBeerStyleWithIcons(beerStyles, cleanIcons)
	                });
	            });
	        });
	    },
	    _hydrateBeerStyleWithIcons: function _hydrateBeerStyleWithIcons(beerStyles, icons) {
	        for (var _iterator = beerStyles, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	            var _ref;
	
	            if (_isArray) {
	                if (_i >= _iterator.length) break;
	                _ref = _iterator[_i++];
	            } else {
	                _i = _iterator.next();
	                if (_i.done) break;
	                _ref = _i.value;
	            }
	
	            var beerStyle = _ref;
	
	            var configurations = get(beerStyle, 'styleBeerConfigurationTaskDto');
	            if (ContentUtils.isNotEmptyArray(configurations)) {
	                for (var _iterator2 = configurations, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
	                    var _ref2;
	
	                    if (_isArray2) {
	                        if (_i2 >= _iterator2.length) break;
	                        _ref2 = _iterator2[_i2++];
	                    } else {
	                        _i2 = _iterator2.next();
	                        if (_i2.done) break;
	                        _ref2 = _i2.value;
	                    }
	
	                    var configuration = _ref2;
	
	
	                    var iconTarget = DashboardServiceCache.hydrateWithIcon(configuration, 'typeTask', 'admin', icons).icon;
	
	                    if (iconTarget) {
	                        configuration.icon = iconTarget;
	                    }
	                }
	
	                var configurationsSorted = _.sortBy(configurations, 'day');
	                beerStyle = _.set(beerStyle, 'styleBeerConfigurationTaskDto', configurationsSorted);
	            }
	        }
	
	        return beerStyles;
	    },
	    _onDeleteBeerStyle: function _onDeleteBeerStyle(tank, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('beer_style_confirm_delete'), function () {
	            BeerStyleStore.deleteStyleBeer(tank, onSuccess, onFailure);
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{
	            displayName: t('beer_style_label_name')
	        }];
	    },
	    _onChangeBeerStyle: function _onChangeBeerStyle(tank, onSuccess, onFailure) {
	        BeerStyleStore.changeStyleBeer(tank, onSuccess, onFailure);
	    },
	    _onAddBeerStyle: function _onAddBeerStyle(tank, onSuccess, onFailure) {
	        BeerStyleStore.addNewStyleBeer(tank, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState(function (prevState) {
	            return {
	                selectedItem: item,
	                isEditMode: !prevState.isEditMode,
	                headerActiveFilters: headerActiveFilters
	            };
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null
	        });
	    },
	    _getWrapperColor: function _getWrapperColor(beerStyle) {
	        return React.createElement("div", null, React.createElement("span", {
	            className: "text-center",
	            style: {
	                height: '20px',
	                borderRadius: '22px',
	                boxShadow: '1px 2px 4px 0px gray',
	                backgroundColor: get(beerStyle, 'color'),
	                border: 'solid 0px black',
	                padding: '10px 17px',
	                left: '0',
	                position: 'relative',
	                opacity: '.6'
	            } }), React.createElement("span", { style: { paddingLeft: '10px' } }, get(beerStyle, 'name')));
	    },
	    _goToSelectedBeerStyle: function _goToSelectedBeerStyle() {
	        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'brewing';
	
	        this.transitionTo('/styleBeer/:styleBeerId/tasks', {
	            styleBeerId: get(this.state, 'selectedItem.id')
	        }, {
	            type: type,
	            packagingDays: get(this.state, 'selectedItem.packagingDays'),
	            fermenterDays: get(this.state, 'selectedItem.fermenterDays'),
	            beerStyleName: get(this.state, 'selectedItem.name')
	        });
	    },
	    _getStampsIcons: function _getStampsIcons(type, stamps) {
	        var filteredStamps = filter(stamps, function (stamp) {
	            return get(stamp, 'typeTank') === type;
	        });
	
	        return React.createElement(Stamps, null, map(filteredStamps, function (stamp) {
	            var iconClassName = 'icon-task ' + get(stamp, 'icon.iconClassName');
	            return React.createElement(Stamp, {
	                text: get(stamp, 'day'),
	                classNameIcon: iconClassName });
	        }));
	    },
	    _onDuplicate: function _onDuplicate(contextHolder) {
	        var _this2 = this;
	
	        // get value from all fields
	        var currentSelectedItem = contextHolder.getItem();
	
	        // override with duplicate label
	        currentSelectedItem.name = ContentUtils.formatDuplicateName(currentSelectedItem.name);
	
	        // add date to duplicate and remove id in order
	        // to generate a new one like new item
	        currentSelectedItem.duplicatedId = get(this.state, 'selectedItem.id');
	        currentSelectedItem.id = null;
	        currentSelectedItem.isDuplicated = true;
	
	        this._onAddBeerStyle(currentSelectedItem, function () {
	            Notification.show(t('beer_style_duplicated_success'), 'success');
	            _this2.fetchBeerStyles();
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    render: function render() {
	        if (!this.state.beerStyles) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('beer_style_admin_change_message_success'),
	                changeFailureMessage: t('beer_style_admin_change_message_failure'),
	                deleteSuccessMessage: t('beer_style_admin_delete_message_success'),
	                addSuccessMessage: t('beer_style_admin_add_message_success'),
	                addFailureMessage: t('beer_style_admin_add_message_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                beerStyles = _state.beerStyles,
	                headerActiveFilters = _state.headerActiveFilters,
	                isSaving = _state.isSaving;
	
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                name: t('beer_style_label_name'),
	                value: selectedItem,
	                label: t('beer_style_label_name_named'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupColorPicker, {
	                operationsHolder: contextHolder,
	                readerAttribute: "color",
	                name: t('beer_style_color'),
	                value: selectedItem,
	                label: t('beer_style_color'),
	                isRequired: true }), React.createElement(FormGroupTextfield, {
	                additionalValidation: function additionalValidation(value) {
	                    return NumberUtils.isNumber(value) && value > 0 ? '' : t('error_inline_bigger_than_zero');
	                },
	                operationsHolder: contextHolder,
	                readerAttribute: "fermenterDays",
	                name: t('beer_style_days_fermenter_label'),
	                value: selectedItem,
	                label: t('beer_style_fermenter_days'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                additionalValidation: function additionalValidation(value) {
	                    return NumberUtils.isNumber(value) && value > 0 ? '' : t('error_inline_bigger_than_zero');
	                },
	                operationsHolder: contextHolder,
	                readerAttribute: "packagingDays",
	                name: t('beer_style_days_packaging_label'),
	                value: selectedItem,
	                label: t('beer_style_packaging_days'),
	                onEnter: this._onEnterPress })];
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                el: React.createElement(FormGroupToggle, {
	                    operationsHolder: contextHolder,
	                    name: t('beer_style_admin_status_enable_label'),
	                    value: selectedItem,
	                    label: t('beer_style_admin_status_enable_label'),
	                    readerAttribute: "enable" })
	            }, {
	                type: 'CHANGE',
	                permission: 'BREWING_ICONS',
	                el: React.createElement(FormGroupButton, {
	                    label: t('beer_style_admin_set_brewing_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSelectedBeerStyle.bind(this, 'brewing') })
	            }, {
	                type: 'CHANGE',
	                permission: 'FERMENTING_ICONS',
	                el: React.createElement(FormGroupButton, {
	                    label: t('beer_style_admin_set_fermenting_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSelectedBeerStyle.bind(this, 'fermenter') })
	            }, {
	                type: 'CHANGE',
	                permission: 'PACKAGING_ICONS',
	                el: React.createElement(FormGroupButton, {
	                    label: t('beer_style_admin_set_packaging_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSelectedBeerStyle.bind(this, 'packaging') })
	            }];
	
	            additionalButtons.push({
	                type: 'CHANGE',
	                permission: 'DUPLICATE',
	                el: React.createElement(FormGroupButton, {
	                    label: t('beer_style_admin_duplicate'),
	                    icon: "content_copy",
	                    type: "icon",
	                    onClick: this._onDuplicate.bind(this, contextHolder) })
	            });
	
	            return React.createElement(AdminScaffolding, {
	                isDisabled: isSaving,
	                moduleName: "ADMIN_BEER_STYLE",
	                messages: messages,
	                title: t('beer_style_label_name'),
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchBeerStyles,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddBeerStyle,
	                onChange: this._onChangeBeerStyle,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteBeerStyle,
	                additionalButtons: additionalButtons,
	                breadcrumb: this._getBreadcrumbLinks(),
	                addEnterKeyDown: this._addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                allowShowDisable: true,
	                headerActiveFilters: headerActiveFilters,
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['name'],
	                columnNames: [t('name'), t('beer_style_brewing_icons'), t('beer_style_fermenting_icons'), t('beer_style_packaging_icons')],
	                filteredColumns: ['name', 'brewingDays', 'fermenterDays', 'packagingDays'],
	                displayAttributes: [{
	                    getHTML: this._getWrapperColor
	                }, {
	                    name: 'styleBeerConfigurationTaskDto',
	                    getHTML: this._getStampsIcons.bind(this, 'brewing')
	                }, {
	                    name: 'styleBeerConfigurationTaskDto',
	                    getHTML: this._getStampsIcons.bind(this, 'fermenter')
	                }, {
	                    name: 'styleBeerConfigurationTaskDto',
	                    getHTML: this._getStampsIcons.bind(this, 'packaging')
	                }]
	            }, beerStyles));
	        }
	    }
	});
	
	module.exports = BeerStyleAdmin;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _iconsProvider;
	
	var React = __webpack_require__(1),
	    SessionStore = __webpack_require__(11),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    BeerStyleStore = __webpack_require__(95),
	    IconStore = __webpack_require__(411),
	    ContentUtils = __webpack_require__(7),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    _require2 = __webpack_require__(2),
	    FERMENTER_TYPE_TASK = _require2.FERMENTER_TYPE_TASK,
	    PACKAGING_TYPE_TASK = _require2.PACKAGING_TYPE_TASK,
	    BREWING_TYPE_TASK = _require2.BREWING_TYPE_TASK,
	    getIconsMapping = _require2.getIconsMapping,
	    NavigationUtils = __webpack_require__(35),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupDropdownCustom = __webpack_require__(703),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    Stamps = __webpack_require__(154),
	    Stamp = __webpack_require__(131),
	    DashboardServiceCache = __webpack_require__(28),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    filter = _require3.filter,
	    includes = _require3.includes,
	    get = __webpack_require__(5).get,
	    _require4 = __webpack_require__(19),
	    Navigation = _require4.Navigation,
	    ga = __webpack_require__(18);
	
	
	var MAX_BREW_CONFIGURATION = 12;
	// initialize array of [1...12] numbers
	var BREW_NUMBERS = Array.apply(null, { length: MAX_BREW_CONFIGURATION }).map(Number.call, Number).map(function (num) {
	  return num + 1;
	});
	
	var iconsProvider = (_iconsProvider = {}, _iconsProvider[FERMENTER_TYPE_TASK] = DashboardServiceCache.getFermenterIcons.bind(DashboardServiceCache), _iconsProvider[PACKAGING_TYPE_TASK] = DashboardServiceCache.getPackagingIcons.bind(DashboardServiceCache), _iconsProvider[BREWING_TYPE_TASK] = DashboardServiceCache.getBrewhouseIcons.bind(DashboardServiceCache), _iconsProvider);
	
	var BeerStyleConfigurationAdmin = React.createClass({ displayName: "BeerStyleConfigurationAdmin",
	
	  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	  getInitialState: function getInitialState() {
	    return {
	      currentBeerStyle: NavigationUtils.getPathParam('styleBeer'),
	      currentBeerStyleName: NavigationUtils.getQueryParam('beerStyleName'),
	      currentPackagingDays: NavigationUtils.getQueryParam('packagingDays'),
	      currentFermenterDays: NavigationUtils.getQueryParam('fermenterDays'),
	      currentBrewingDays: NavigationUtils.getQueryParam('brewingDays'),
	      typeTank: NavigationUtils.getQueryParam('type')
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchBeerStyleTasks();
	    ga.pageview('/style-beer-admin-configuration');
	  },
	  _backToBeerStyle: function _backToBeerStyle() {
	    this.transitionTo('/styleBeer');
	  },
	  _goTo: function _goTo(type) {
	    this.transitionTo('/styleBeer/:styleBeer/tasks?' + 'type=:type&' + 'packagingDays=:packagingDays&' + 'fermenterDays=:fermenterDays&' + 'beerStyleName=:beerStyleName&', {
	      styleBeer: NavigationUtils.getPathParam('styleBeer'),
	      packagingDays: NavigationUtils.getQueryParam('packagingDays'),
	      fermenterDays: NavigationUtils.getQueryParam('fermenterDays'),
	      beerStyleName: NavigationUtils.getQueryParam('beerStyleName'),
	      type: type
	    });
	    window.location.reload(true);
	  },
	  fetchBeerStyleTasks: function fetchBeerStyleTasks() {
	    var _this = this;
	
	    IconStore.fetchIcons(function (icons) {
	      BeerStyleStore.fetchStyleBeersConfiguration(_this.state.currentBeerStyle, function (configurationTask) {
	        var beerStyleConfigurationFiltered = filter(configurationTask, function (beerStyle) {
	          return beerStyle.typeTank === _this.state.typeTank;
	        });
	        var dirtyIcons = get(icons, 'icons', []);
	        var cleanIcons = map(dirtyIcons, function (icon) {
	          return icon.iconDetail;
	        });
	        var beerStyleConfigurationHydrated = _this._hydrateConfigurationWithIcons(beerStyleConfigurationFiltered, cleanIcons);
	        _this.setState({
	          beerStyleConfigurationTasks: beerStyleConfigurationHydrated
	        });
	      });
	    });
	  },
	  _hydrateConfigurationWithIcons: function _hydrateConfigurationWithIcons(configurationTasks, icons) {
	    return map(configurationTasks, function (task) {
	      return DashboardServiceCache.hydrateWithIcon(task, 'typeTask', 'admin', icons);
	    });
	  },
	  _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	    var _this2 = this;
	
	    this.setState(function (prevState) {
	      return {
	        selectedTask: item,
	        isEditMode: !prevState.isEditMode,
	        headerActiveFilters: headerActiveFilters
	      };
	    }, function () {
	      // stay the position of the scroll after row select when
	      // the offset is outside of initial viewport page.
	      _this2.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	    });
	  },
	  _onEnterPress: function _onEnterPress() {
	    if (this.onEnterKeyDown) {
	      this.onEnterKeyDown();
	    }
	  },
	  _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	    this.onEnterKeyDown = onEnterKeyDown;
	  },
	  _onDeleteBeerStyle: function _onDeleteBeerStyle(id, onSuccess, onFailure) {
	    BeerStyleStore.deleteStyleBeersConfiguration(id, onSuccess, onFailure);
	  },
	  _onChangeBeerStyle: function _onChangeBeerStyle(beerStyleConf, onSuccess, onFailure) {
	    BeerStyleStore.changeBeerStyleConfiguration(beerStyleConf, onSuccess, onFailure);
	  },
	  _onAddBeerStyle: function _onAddBeerStyle(beerStyleConf, onSuccess, onFailure) {
	    BeerStyleStore.addBeerStyleConfiguration(beerStyleConf, onSuccess, onFailure);
	  },
	  _onCancel: function _onCancel() {
	    this.setState({
	      selectedTask: null
	    });
	  },
	  _isValidDayTask: function _isValidDayTask(items, currentDay, selectedDay) {
	    if (selectedDay && existAnotherTaskWithSameDay(items, currentDay, +selectedDay)) {
	      return t('beer_style_configuration_admin_inline_error_one_task_per_day');
	    }
	    return ''; // empty is valid
	  },
	  _getBreadcrumbLinks: function _getBreadcrumbLinks(currentBeerStyleName) {
	    return [{
	      displayName: t('beer_style_configuration_label_name'),
	      link: 'styleBeer'
	    }, {
	      displayName: '' + currentBeerStyleName
	    }];
	  },
	  _getStampsIcons: function _getStampsIcons(stamp) {
	    var iconClassName = 'icon-task ' + get(stamp, 'icon.iconClassName');
	    return React.createElement(Stamps, null, React.createElement(Stamp, {
	      text: get(stamp, 'day'),
	      classNameIcon: iconClassName }));
	  },
	  _getNavigationItems: function _getNavigationItems(type) {
	    if (type === 'fermenter') {
	      return [this.getButtonNavigation(t('beer_style_configuration_set_brewing_icons'), 'brewing'), this.getButtonNavigation(t('beer_style_configuration_set_packaging_icons'), 'packaging')];
	    } else if (type === 'brewing') {
	      return [this.getButtonNavigation(t('beer_style_configuration_set_fermenting_icons'), 'fermenter'), this.getButtonNavigation(t('beer_style_configuration_set_packaging_icons'), 'packaging')];
	    } else {
	      return [this.getButtonNavigation(t('beer_style_configuration_set_brewing_icons'), 'brewing'), this.getButtonNavigation(t('beer_style_configuration_set_fermenting_icons'), 'fermenter')];
	    }
	  },
	  getButtonNavigation: function getButtonNavigation(label, urlType) {
	    return {
	      type: 'NEW',
	      permission: 'EDIT',
	      el: React.createElement(FormGroupButton, {
	        label: label,
	        icon: "subdirectory_arrow_right",
	        type: "icon",
	        onClick: this._goTo.bind(this, urlType) })
	    };
	  },
	  render: function render() {
	    var contextHolder = this.getContextHolderInstance();
	    var _state = this.state,
	        selectedTask = _state.selectedTask,
	        typeTank = _state.typeTank,
	        currentBeerStyle = _state.currentBeerStyle,
	        beerStyleConfigurationTasks = _state.beerStyleConfigurationTasks,
	        currentBeerStyleName = _state.currentBeerStyleName;
	
	    var messages = {
	      changeSuccessMessage: t('beer_style_configuration_admin_change_message_success'),
	      changeFailureMessage: t('beer_style_configuration_admin_change_message_failure'),
	      deleteSuccessMessage: t('beer_style_configuration_admin_delete_message_success'),
	      addSuccessMessage: t('beer_style_configuration_admin_add_message_success'),
	      addFailureMessage: t('beer_style_configuration_admin_add_message_failure')
	    };
	
	    var tasks = iconsProvider[typeTank]();
	    var isAdminBrewing = typeTank === 'brewing';
	    var additionalButtons = [{
	      type: 'CHANGE',
	      permission: 'EDIT',
	      el: React.createElement(FormGroupButton, {
	        label: t('back'),
	        icon: "subdirectory_arrow_left",
	        type: "icon",
	        onClick: this._backToBeerStyle })
	    }, {
	      type: 'NEW',
	      permission: 'EDIT',
	      el: React.createElement(FormGroupButton, {
	        label: t('back'),
	        icon: "subdirectory_arrow_left",
	        type: "icon",
	        onClick: this._backToBeerStyle })
	    }].concat(this._getNavigationItems(typeTank));
	
	    var availablesDays = typeTank === BREWING_TYPE_TASK ? BREW_NUMBERS : getAvailablesDays(this.state);
	    var label = typeTank === BREWING_TYPE_TASK ? t('beer_style_configuration_admin_brew_turn_order') : t('day');
	    var selectedDay = selectedTask ? selectedTask.day : null;
	    var tankTypeFormatted = t(ContentUtils.getTankTypeConfiguration(typeTank).sectionName.toLowerCase());
	
	    if (selectedTask) {
	      // adapter selected item, in order to do the same reader attribute
	      selectedTask.displayName = selectedTask.typeTask;
	    }
	
	    var formFieldsEl = [React.createElement(FormGroupDropdown, {
	      operationsHolder: contextHolder,
	      additionalValidation: this._isValidDayTask.bind(this, beerStyleConfigurationTasks, selectedDay),
	      items: availablesDays,
	      readerAttribute: "day",
	      name: label,
	      value: selectedTask }), React.createElement(FormGroupDropdownCustom, {
	      items: tasks,
	      operationsHolder: contextHolder,
	      idAttribute: "name",
	      readerAttribute: "displayName",
	      customReaderWriterAttribute: "name",
	      writerAttribute: "typeTask",
	      name: t('icon'),
	      isRequired: true,
	      isRelaxedText: true,
	      floatingLabelText: t('select_icon'),
	      value: get(selectedTask, 'icon') }), React.createElement(FormGroupTextfield, {
	      operationsHolder: contextHolder,
	      readerAttribute: "label",
	      isRequired: false,
	      isRelaxedText: true,
	      name: t('label'),
	      value: selectedTask,
	      label: t('label'),
	      onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	      operationsHolder: contextHolder,
	      readerAttribute: "description",
	      isRequired: false,
	      isRelaxedText: true,
	      name: t('description'),
	      value: selectedTask,
	      label: t('description'),
	      onEnter: this._onEnterPress })];
	    var title = tankTypeFormatted + ' ' + t('icons_admin_title');
	    var ICONS_MAPPING = getIconsMapping(t);
	    return React.createElement(AdminScaffolding, {
	      moduleName: "ADMIN_BEER_STYLE_CONFIGURATION",
	      messages: messages,
	      additionalSubmitValue: { styleBeerId: currentBeerStyle, typeTank: typeTank },
	      additionalButtons: additionalButtons,
	      title: title,
	      contextHolder: contextHolder,
	      value: selectedTask,
	      fetchItems: this.fetchBeerStyleTasks,
	      headerFields: formFieldsEl,
	      onAdd: this._onAddBeerStyle,
	      onAddText: t('label_add'),
	      onChange: this._onChangeBeerStyle,
	      onCancel: this._onCancel,
	      onDelete: this._onDeleteBeerStyle,
	      breadcrumb: this._getBreadcrumbLinks(currentBeerStyleName),
	      addEnterKeyDown: this._addEnterKeyDown
	    }, React.createElement(AdminScaffoldingTable, {
	      sortByColumn: "day",
	      onRowSelection: this._onRowSelection,
	      value: selectedTask,
	      filteredColumns: ['label', 'description'],
	      columnNames: [isAdminBrewing ? t('beer_style_configuration_admin_brew_turn_order') : t('day'), t('icon'), t('label'), t('description')],
	      displayAttributes: [{
	        getHTML: this._getStampsIcons
	      }, 'displayIcon', 'label', 'description'] }, beerStyleConfigurationTasks && beerStyleConfigurationTasks.length > 0 ? beerStyleConfigurationTasks.map(function (task) {
	      task.displayIcon = ICONS_MAPPING[task.typeTask];
	      return task;
	    }) : beerStyleConfigurationTasks));
	  }
	});
	
	function existAnotherTaskWithSameDay(items, currentDay, day) {
	  if (currentDay) {
	    return includes(filter(map(items, function (config) {
	      return +config.day;
	    }), function (dayFilter) {
	      return dayFilter !== currentDay;
	    }), +day);
	  } else {
	    return includes(map(items, function (config) {
	      return +config.day;
	    }), +day);
	  }
	}
	
	/**
	 * Retrieve the days could be select the consumer.
	 * @param {Object}
	 * @returns {Array}
	 */
	function getAvailablesDays(context) {
	  var days = [];
	  var index = 0;
	
	  var maxDaysField = get(ContentUtils.getTankTypeConfiguration(context.typeTank), 'getDays');
	  var maxDays = +get(context, maxDaysField);
	
	  while (++index <= maxDays) {
	    days.push(index);
	  }
	
	  return days;
	}
	
	module.exports = BeerStyleConfigurationAdmin;

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1367);
	__webpack_require__(692);
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Router = __webpack_require__(19),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    mui = __webpack_require__(12),
	    Route = Router.Route,
	    RouteHandler = Router.RouteHandler,
	    Link = Router.Link,
	    RaisedButton = mui.RaisedButton;
	
	
	var CheckEmailResetPassword = React.createClass({ displayName: "CheckEmailResetPassword",
	
	  handlerClick: function handlerClick() {
	    window.location = apiAppUrl + '/#/login';
	  },
	
	  render: function render() {
	    return React.createElement("div", { className: "preactivated-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h1", { className: "light" }, t('confirm_new_password_static_page_title')), React.createElement("p", { className: "text-left" }, t('confirm_new_password_static_page_text')), React.createElement("p", { className: "text-left" }, t('confirm_new_password_static_page_greeting')), React.createElement("br", null), React.createElement(RaisedButton, {
	      label: t('label_login'),
	      primary: true,
	      onTouchTap: this.handlerClick }), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("img", { style: { height: '60px' }, src: "/assets/images/logo-small-dark.png" })));
	  }
	});
	
	module.exports = CheckEmailResetPassword;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(694);
	__webpack_require__(692);
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    mui = __webpack_require__(12),
	    RaisedButton = mui.RaisedButton;
	
	
	var About = React.createClass({ displayName: "About",
	
	    handlerClick: function handlerClick() {
	        window.location = apiAppUrl + '/#/login';
	    },
	
	    render: function render() {
	        return React.createElement("div", { className: "welcome-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h2", { className: "light" }, t('password_reset_success_title')), React.createElement("p", null, t('password_reset_success_description')), React.createElement("br", null), React.createElement("br", null), React.createElement(RaisedButton, {
	            label: t('password_reset_success_cta_start'),
	            primary: true,
	            onTouchTap: this.handlerClick }), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("img", { style: { height: '60px' }, src: "/assets/images/logo-small-dark.png" })));
	    }
	});
	
	module.exports = About;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Router = __webpack_require__(19),
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    mui = __webpack_require__(12),
	    Route = Router.Route,
	    RouteHandler = Router.RouteHandler,
	    Link = Router.Link,
	    RaisedButton = mui.RaisedButton;
	
	
	var Contact = React.createClass({ displayName: "Contact",
	
	    render: function render() {
	        return React.createElement("div", { className: "preactivated-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h1", { className: "light" }, t('contact_us_title')), React.createElement("p", null, t('contact_us_title')), React.createElement("a", { href: "mailto:support@brewplanner.com?Subject=Need%20help",
	            target: "_top" }, "support@brewplanner.com"), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("span", { className: "text-center" }, React.createElement("p", null, t('confirm_new_password_static_page_greeting')), React.createElement("a", { className: "text-left", href: "http://www.brewplanner.com", target: "_top" }, "Brewplanner.com"))));
	    }
	});
	
	module.exports = Contact;

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    CustomDialog = __webpack_require__(26),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18);
	
	
	var CustomerAddressAdmin = React.createClass({ displayName: "CustomerAddressAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedCustomer: null,
	            name: NavigationUtils.getQueryParam('name'),
	            customerId: NavigationUtils.getQueryParam('customers')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchCustomer();
	        ga.pageview('/customer-address-admin');
	    },
	    fetchCustomer: function fetchCustomer() {
	        var self = this;
	        var customerId = NavigationUtils.getPathParam('customers');
	        InventoryStore.fetchCustomerAddresses(customerId, function (addresses) {
	            self.setState({
	                addresses: addresses
	            });
	        });
	    },
	    backToCustomer: function backToCustomer() {
	        this.transitionTo('/customers');
	    },
	    onDeleteAddress: function onDeleteAddress(addressId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('customer_address_confirm_delete_address'), function () {
	            InventoryStore.deleteCustomerAddress(NavigationUtils.getPathParam('customers'), addressId, onSuccess, onFailure);
	        });
	    },
	    onChangeAddress: function onChangeAddress(address, onSuccess, onFailure) {
	        address.customerId = this.state.customerId;
	        InventoryStore.changeCustomerAddress(NavigationUtils.getPathParam('customers'), address, onSuccess, onFailure);
	    },
	    onAddAddress: function onAddAddress(address, onSuccess, onFailure) {
	        address.customerId = this.state.customerId;
	        InventoryStore.addCustomerAddress(NavigationUtils.getPathParam('customers'), address, onSuccess, onFailure);
	    },
	    getBreadcrumbLinks: function getBreadcrumbLinks() {
	        return [{ link: 'customers', displayName: t('custumer_admin_customers') }, { displayName: get(this.state, 'name') }];
	    },
	    _goToContacts: function _goToContacts() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        var name = NavigationUtils.getQueryParam('name');
	        this.transitionTo('/customers/:customerId/contacts', {
	            customerId: customerId
	        }, { name: name });
	    },
	    _goToSetItems: function _goToSetItems() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        var name = NavigationUtils.getQueryParam('name');
	        this.transitionTo('/customers/:customerId/items', {
	            customerId: customerId
	        }, { name: name });
	    },
	    render: function render() {
	        var _state = this.state,
	            addresses = _state.addresses,
	            selectedItem = _state.selectedItem;
	
	        if (!addresses) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('customer_address_change_success'),
	                changeFailureMessage: t('customer_address_change_failure'),
	                deleteSuccessMessage: t('customer_address_delete_success'),
	                addSuccessMessage: t('customer_address_add_success'),
	                addFailureMessage: t('customer_address_add_failure')
	            };
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_address_set_contacts'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToContacts.bind(this) })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_price'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSetItems.bind(this) })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                isRelaxedText: true,
	                operationsHolder: contextHolder,
	                displayAttribute: "address",
	                readerAttribute: "address",
	                writerAttribute: "address",
	                isRequired: true,
	                name: t('address'),
	                value: selectedItem,
	                label: t('address'),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                displayAttribute: "postCode",
	                readerAttribute: "postCode",
	                writerAttribute: "postCode",
	                isRequired: true,
	                name: t('post_code'),
	                value: selectedItem,
	                label: t('post_code'),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                isRelaxedText: true,
	                displayAttribute: "city",
	                readerAttribute: "city",
	                writerAttribute: "city",
	                isRequired: true,
	                name: t('city'),
	                value: selectedItem,
	                label: t('city'),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                isRelaxedText: true,
	                displayAttribute: "state",
	                readerAttribute: "state",
	                writerAttribute: "state",
	                isRequired: true,
	                name: t('state'),
	                value: selectedItem,
	                label: t('state'),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                displayAttribute: "country",
	                readerAttribute: "country",
	                writerAttribute: "country",
	                isRequired: true,
	                name: t('country'),
	                value: selectedItem,
	                label: t('country'),
	                onEnter: this.__onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_CUSTOMER_ADDRESS",
	                title: t('customer_address_title'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchCustomer,
	                headerFields: formFieldsEl,
	                onAdd: this.onAddAddress,
	                onChange: this.onChangeAddress,
	                onCancel: this.__onCancel,
	                onDelete: this.onDeleteAddress,
	                additionalButtons: additionalButtons,
	                breadcrumb: this.getBreadcrumbLinks(),
	                addEnterKeyDown: this.__addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['name'],
	                filteredColumns: ['address', 'postCode', 'city', 'state', 'country'],
	                columnNames: [t('address'), t('post_code'), t('city'), t('state'), t('country')],
	                displayAttributes: ['address', 'postCode', 'city', 'state', 'country']
	            }, addresses)));
	        }
	    }
	});
	
	module.exports = CustomerAddressAdmin;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CONTACT_ICONS;
	
	__webpack_require__(1357);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(8),
	    map = _require.map,
	    _require2 = __webpack_require__(4),
	    t = _require2.t,
	    CustomDialog = __webpack_require__(26),
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    Stamps = __webpack_require__(154),
	    Stamp = __webpack_require__(131),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var CONTACT_ICONS = (_CONTACT_ICONS = {}, _CONTACT_ICONS['PHONE'] = 'phone', _CONTACT_ICONS['EMAIL'] = 'email', _CONTACT_ICONS);
	
	var CustomerAdmin = React.createClass({ displayName: "CustomerAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedCustomer: null
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchCustomer();
	        ga.pageview('/customers-admin');
	    },
	    fetchCustomer: function fetchCustomer() {
	        var self = this;
	        InventoryStore.fetchCustomers(function (customers) {
	            self.setState({
	                customers: customers
	            });
	        });
	    },
	    _goToAddress: function _goToAddress() {
	        this.transitionTo('/customers/:customerId/addresses', {
	            customerId: get(this.state, 'selectedItem.id')
	        }, {
	            name: get(this.state, 'selectedItem.name')
	        });
	    },
	    _goToSetItems: function _goToSetItems() {
	        this.transitionTo('/customers/:customerId/items', {
	            customerId: get(this.state, 'selectedItem.id')
	        }, {
	            name: get(this.state, 'selectedItem.name')
	        });
	    },
	    _goToContacts: function _goToContacts() {
	        this.transitionTo('/customers/:customerId/contacts', {
	            customerId: get(this.state, 'selectedItem.id')
	        }, {
	            name: get(this.state, 'selectedItem.name')
	        });
	    },
	    _onDeleteCustomer: function _onDeleteCustomer(customerId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('custumer_admin_confirm_delete_customer'), function () {
	            InventoryStore.deleteCustomer(customerId, onSuccess, onFailure);
	        });
	    },
	    _onChangeCustomer: function _onChangeCustomer(customer, onSuccess, onFailure) {
	        InventoryStore.changeCustomer(customer, onSuccess, onFailure);
	    },
	    _onAddCustomer: function _onAddCustomer(customer, onSuccess, onFailure) {
	        InventoryStore.addCustomer(customer, onSuccess, onFailure);
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{
	            displayName: t('custumer_admin_customers')
	        }];
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _getStampsIcons: function _getStampsIcons(contacts) {
	        return React.createElement(Stamps, null, map(contacts, function (contact) {
	            return React.createElement("span", { className: "bp-customer-admin__contact" }, React.createElement(Stamp, {
	                icon: CONTACT_ICONS[get(contact, 'type')],
	                classNameIcon: "material-icons",
	                className: "bp-customer-admin__contact-icon" }), React.createElement("div", { className: "bp-customer-admin__contact-label" }, get(contact, 'contactInfo')));
	        }));
	    },
	    render: function render() {
	        var _state = this.state,
	            customers = _state.customers,
	            selectedItem = _state.selectedItem;
	
	        if (!customers) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('customer_admin_change_success_message'),
	                changeFailureMessage: t('customer_admin_change_failure_message'),
	                deleteSuccessMessage: t('customer_admin_delete_success_message'),
	                addSuccessMessage: t('customer_admin_add_success_message'),
	                addFailureMessage: t('customer_admin_add_failure_message')
	            };
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'ADDRESS_SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_address'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToAddress.bind(this) })
	            }, {
	                type: 'CHANGE',
	                permission: 'CONTACT_SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_address_set_contacts'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToContacts.bind(this) })
	            }, {
	                type: 'CHANGE',
	                permission: 'PRICE_SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_price'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSetItems.bind(this) })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                isRequired: true,
	                name: t('customer_admin_name_or_company_name'),
	                value: selectedItem,
	                label: t('name'),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "termsDate",
	                isRequired: true,
	                name: t('vendor_admin_label_terms'),
	                value: selectedItem,
	                label: t('vendor_admin_label_terms'),
	                onEnter: this.__onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('custumer_admin_customers'),
	                moduleName: "ADMIN_CUSTOMER",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchCustomer,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddCustomer,
	                onChange: this._onChangeCustomer,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteCustomer,
	                additionalButtons: additionalButtons,
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['name'],
	                filteredColumns: ['name', 'contacts', 'termsDate'],
	                columnNames: [t('customer_admin_company_name'), t('customer_admin_column_name_contacts'), t('vendor_admin_label_terms')],
	                displayAttributes: ['name', {
	                    name: 'contacts',
	                    getHTML: this._getStampsIcons
	                }, 'termsDate']
	            }, customers)));
	        }
	    }
	});
	
	module.exports = CustomerAdmin;

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    CustomDialog = __webpack_require__(26),
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    AppConstants = __webpack_require__(2),
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18);
	
	
	var CustomerContactAdmin = React.createClass({ displayName: "CustomerContactAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            isEditMode: false,
	            selectedCustomer: null,
	            name: NavigationUtils.getQueryParam('name'),
	            customerId: NavigationUtils.getPathParam('customers')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchCustomer();
	        ga.pageview('/customer-contact-admin');
	    },
	    fetchCustomer: function fetchCustomer() {
	        var self = this;
	        var customerId = NavigationUtils.getPathParam('customers');
	        InventoryStore.fetchCustomerContacts(customerId, function (contacts) {
	            self.setState({
	                contacts: contacts
	            });
	        });
	    },
	    backToCustomer: function backToCustomer() {
	        this.transitionTo('/customers');
	    },
	    onDeleteContact: function onDeleteContact(contactId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('customer_contact_admin_confirm_delete_contact'), function () {
	            var customerId = NavigationUtils.getPathParam('customers');
	            InventoryStore.deleteCustomerContact(customerId, contactId, onSuccess, onFailure);
	        });
	    },
	    _onChangeContact: function _onChangeContact(contact, onSuccess, onFailure) {
	        contact.customerId = this.state.customerId;
	        InventoryStore.changeCustomerContact(NavigationUtils.getPathParam('customers'), contact, onSuccess, onFailure);
	    },
	    onAddContact: function onAddContact(contact, onSuccess, onFailure) {
	        contact.customerId = this.state.customerId;
	        InventoryStore.addCustomerContact(NavigationUtils.getPathParam('customers'), contact, onSuccess, onFailure);
	    },
	    _goToSetItems: function _goToSetItems() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        this.transitionTo('/customers/:customerId/items', {
	            customerId: customerId
	        }, {
	            name: get(this.state, 'name')
	        });
	    },
	    _goToAddress: function _goToAddress() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        this.transitionTo('/customers/:customerId/addresses', {
	            customerId: customerId
	        }, {
	            name: get(this.state, 'name')
	        });
	    },
	    getBreadcrumbLinks: function getBreadcrumbLinks() {
	        return [{ link: 'customers', displayName: t('custumer_admin_customers') }, { displayName: get(this.state, 'name') }];
	    },
	    render: function render() {
	        var _state = this.state,
	            contacts = _state.contacts,
	            selectedItem = _state.selectedItem,
	            isEditMode = _state.isEditMode;
	
	        if (!contacts) {
	            return React.createElement(Loading, null);
	        } else {
	
	            var currentSelectedSection = selectedItem && selectedItem.type ? AppConstants.getContactMapping(t)[selectedItem.type] : '';
	
	            var currentSelectedValueHydrated = currentSelectedSection ? _extends({}, selectedItem, { displayText: currentSelectedSection }) : selectedItem;
	
	            var messages = {
	                changeSuccessMessage: t('customer_contact_admin_change_success_message'),
	                changeFailureMessage: t('customer_contact_admin_change_failure_message'),
	                deleteSuccessMessage: t('customer_contact_admin_delete_success_message'),
	                addSuccessMessage: t('customer_contact_admin_add_success_message'),
	                addFailureMessage: t('customer_contact_admin_add_failure_message')
	            };
	            var contextHolder = this.getContextHolderInstance();
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_price'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToSetItems.bind(this) })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_address'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToAddress.bind(this) })
	            }];
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                isRequired: true,
	                isRelaxedText: true,
	                name: t('name'),
	                value: selectedItem,
	                label: t('customer_contact_admin_label_contact_name'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupDropdown, {
	                items: AppConstants.getContacts(t),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "type",
	                writerAttribute: "type",
	                name: t('label_type'),
	                label: t('customer_contact_admin_label_type'),
	                value: currentSelectedValueHydrated || 'EMAIL',
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "contactInfo",
	                isRequired: false,
	                isRelaxedText: true,
	                name: t('customer_contact_admin_label_contact_info'),
	                value: selectedItem,
	                label: t('customer_contact_admin_label_contact_info'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_CUSTOMER_CONTACT",
	                title: t('customer_contact_admin_title_customer_contacts'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchCustomer,
	                headerFields: formFieldsEl,
	                onAdd: this.onAddContact,
	                onAddText: t('label_add'),
	                onChange: this._onChangeContact,
	                onCancel: this.__onCancel,
	                onDelete: this.onDeleteContact,
	                additionalButtons: additionalButtons,
	                addEnterKeyDown: this.__addEnterKeyDown,
	                breadcrumb: this.getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['name', 'displayType', 'contactInfo'],
	                sortByColumn: ['displayType'],
	                columnNames: [t('customer_contact_admin_label_contact_name'), t('customer_contact_admin_label_type'), t('customer_contact_admin_column_name_contact')],
	                displayAttributes: ['name', 'displayType', 'contactInfo']
	            }, contacts.map(function (contact) {
	                contact.displayType = AppConstants.getContactMapping(t)[contact.type];
	                return contact;
	            }))));
	        }
	    }
	});
	
	module.exports = CustomerContactAdmin;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    CustomDialog = __webpack_require__(26),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    map = _require2.map,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var CustomerItemAdmin = React.createClass({ displayName: "CustomerItemAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedCustomer: null,
	            name: NavigationUtils.getQueryParam('name'),
	            customerId: NavigationUtils.getPathParam('customers')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchCustomer();
	        ga.pageview('/customer-items-admin');
	    },
	    fetchCustomer: function fetchCustomer() {
	        var self = this;
	        var customerId = NavigationUtils.getPathParam('customers');
	        InventoryStore.fetchFinishItems(function (items) {
	            InventoryStore.fetchCustomerItems(customerId, function (customerItems) {
	                self.setState({
	                    customerItems: self._decoratorVendorItems(ContentUtils.filterEnableByAttribute(customerItems, ['item.isEnable', 'enable'])),
	                    items: ContentUtils.filterEnable(items)
	                });
	            });
	        });
	    },
	    backToCustomer: function backToCustomer() {
	        this.transitionTo('/customers');
	    },
	    _decoratorVendorItems: function _decoratorVendorItems(vendorItems) {
	        return map(vendorItems, function (vendorItem) {
	            vendorItem.salePriceDisplay = NumberUtils.formatCurrency(vendorItem.salePrice, 4);
	            return vendorItem;
	        });
	    },
	    onDeleteCustomerItem: function onDeleteCustomerItem(customerItemId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('customer_item_admin_confirm_delete'), function () {
	            InventoryStore.deleteCustomerItems(NavigationUtils.getPathParam('customers'), customerItemId, onSuccess, onFailure);
	        });
	    },
	    onChangeCustomerItem: function onChangeCustomerItem(customerItem, onSuccess, onFailure) {
	        customerItem.customerId = NavigationUtils.getPathParam('customers');
	        customerItem.itemId = customerItem.itemId;
	        InventoryStore.changeCustomerItem(NavigationUtils.getPathParam('customers'), customerItem, onSuccess, onFailure);
	    },
	    onAddCustomerItem: function onAddCustomerItem(customerItem, onSuccess, onFailure) {
	        customerItem.customerId = NavigationUtils.getPathParam('customers');
	        customerItem.itemId = customerItem.itemId;
	        InventoryStore.addCustomerItem(NavigationUtils.getPathParam('customers'), customerItem, onSuccess, onFailure);
	    },
	    getBreadcrumbLinks: function getBreadcrumbLinks() {
	        return [{ link: 'customers', displayName: t('custumer_admin_customers') }, { displayName: get(this.state, 'name') }];
	    },
	    _amountValidation: function _amountValidation(inputValue) {
	        if (ContentUtils.isEmptyText(inputValue)) {
	            return '';
	        }
	
	        var result = NumberUtils.isNumber(inputValue) ? '' : t('customer_item_admin_amount_must_number');
	        var isNumber = result === '';
	
	        if (isNumber) {
	            return NumberUtils.isGreaterOrEquals(inputValue, 0) ? '' : t('sales_items_could_not_negative');
	        }
	    },
	    _goToAddress: function _goToAddress() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        this.transitionTo('/customers/:customerId/addresses', {
	            customerId: customerId
	        }, {
	            name: get(this.state, 'name')
	        });
	    },
	    _goToContacts: function _goToContacts() {
	        var customerId = NavigationUtils.getPathParam('customers');
	        this.transitionTo('/customers/:customerId/contacts', {
	            customerId: customerId
	        }, {
	            name: get(this.state, 'name')
	        });
	    },
	    render: function render() {
	        var _state = this.state,
	            customerItems = _state.customerItems,
	            selectedItem = _state.selectedItem;
	
	        if (!customerItems) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('customer_item_admin_change_success_message'),
	                changeFailureMessage: t('customer_item_admin_change_failure_message'),
	                deleteSuccessMessage: t('customer_item_admin_delete_success_message'),
	                addSuccessMessage: t('customer_item_admin_add_success_message'),
	                addFailureMessage: t('customer_item_admin_add_failure_message')
	            };
	            var items = this.state.items;
	
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToCustomer })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_set_address'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToAddress.bind(this) })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('customer_address_set_contacts'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToContacts.bind(this) })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	                operationsHolder: contextHolder,
	                items: items,
	                readerAttribute: "description",
	                readerAttributeValue: "id",
	                writerAttribute: "itemId",
	                itemsDisabled: filterItemsAlreadyInUse(items, customerItems),
	                customErrorNonMatch: t('customer_item_admin_item_error_non_match'),
	                name: t('customer_item_admin_label_item'),
	                label: t('customer_item_admin_label_item'),
	                value: get(selectedItem, 'item'),
	                onChange: this.onChangeSelectedItem,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "salePrice",
	                name: t('customer_item_admin_label_price'),
	                value: selectedItem,
	                isRelaxedText: true,
	                label: t('customer_item_admin_label_price'),
	                isDecimalFormat: true,
	                additionalValidation: this._amountValidation,
	                onEnter: this.__onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_CUSTOMER_PRICE",
	                title: t('customer_item_admin_title_item_customer_price'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchCustomer,
	                headerFields: formFieldsEl,
	                onAdd: this.onAddCustomerItem,
	                onChange: this.onChangeCustomerItem,
	                onCancel: this.__onCancel,
	                onDelete: this.onDeleteCustomerItem,
	                additionalButtons: additionalButtons,
	                breadcrumb: this.getBreadcrumbLinks(),
	                addEnterKeyDown: this.__addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['name'],
	                filteredColumns: ['item.description', 'salePriceDisplay'],
	                columnNames: [t('customer_item_admin_label_item'), t('customer_item_admin_label_price')],
	                displayAttributes: ['item.description', 'salePriceDisplay']
	            }, customerItems)));
	        }
	    }
	});
	
	function filterItemsAlreadyInUse(items, selectedItems) {
	    var itemIdsAlreadyInUse = map(selectedItems, function (selectedItem) {
	        return get(selectedItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	module.exports = CustomerItemAdmin;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var AppDispatcher = __webpack_require__(42),
	    React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    CustomDialog = __webpack_require__(26),
	    Loading = __webpack_require__(33),
	    Notification = __webpack_require__(21),
	    UserTaskStore = __webpack_require__(232),
	    NumberUtils = __webpack_require__(23),
	    ChronologycServiceCache = __webpack_require__(107),
	    ContextMenuEl = __webpack_require__(152),
	    CustomOverlay = __webpack_require__(718),
	    UserTasks = __webpack_require__(734),
	    InventoryReport = __webpack_require__(730),
	    moment = __webpack_require__(3),
	    Router = __webpack_require__(19),
	    DashboardCache = __webpack_require__(414),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    filter = _require3.filter,
	    find = _require3.find,
	    some = _require3.some,
	    forEach = _require3.forEach,
	    _require4 = __webpack_require__(48),
	    union = _require4.union,
	    Authentication = __webpack_require__(13).Authentication,
	    DashboardActionCreators = __webpack_require__(65),
	    ga = {
	  modalview: function modalview() {},
	  pageview: function pageview() {},
	  event: function event() {}
	},
	    DashboardViewOnlyIndicator = __webpack_require__(760),
	    categories = __webpack_require__(2).Analytics.categories,
	    actions = __webpack_require__(2).Analytics.actions,
	    labels = __webpack_require__(2).Analytics.labels,
	    ActionTypes = __webpack_require__(2).ActionTypes,
	    ReactGridLayout = __webpack_require__(1197),
	    DateUtils = __webpack_require__(22),
	    ContentUtils = __webpack_require__(7),
	    OrderUtils = __webpack_require__(49),
	    PositionUtils = __webpack_require__(59),
	    BrowserUtils = __webpack_require__(185),
	    Viewport = __webpack_require__(413),
	    PollerDashboard = __webpack_require__(738),
	    PollerSaveDraft = __webpack_require__(739),
	    PollerSaveNote = __webpack_require__(740),
	    DashboardServiceImpl = __webpack_require__(132),
	    PollerAppVersion = __webpack_require__(737),
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    InventoryStore = __webpack_require__(20),
	    TankStore = __webpack_require__(97),
	    DashboardServiceCache = __webpack_require__(28),
	    ChronologycStore = __webpack_require__(76),
	    OrderStore = __webpack_require__(72),
	    ChronologycBar = __webpack_require__(699),
	    UIStateStore = __webpack_require__(183),
	    Immutable = __webpack_require__(820),
	    _require5 = __webpack_require__(2),
	    ROW_HIGHT = _require5.ROW_HIGHT,
	    DATE_FORMAT = _require5.DATE_FORMAT,
	    DEFAULT_MONTH_BEFORE = _require5.DEFAULT_MONTH_BEFORE,
	    DEFAULT_MONTH_AFTER = _require5.DEFAULT_MONTH_AFTER,
	    TASK_NON_VISIBLE = _require5.TASK_NON_VISIBLE,
	    DEFAULT_DAYS_AFTER = _require5.DEFAULT_DAYS_AFTER,
	    DEFAULT_DAYS_BEFORE = _require5.DEFAULT_DAYS_BEFORE,
	    DAYS_BACKWARD_FORWARD = _require5.DAYS_BACKWARD_FORWARD,
	    INVENTORY_MAX_PAST_DAYS_SCOPE = _require5.INVENTORY_MAX_PAST_DAYS_SCOPE,
	    mui = __webpack_require__(12),
	    FloatingActionButton = mui.FloatingActionButton,
	    FlatButton = mui.FlatButton,
	    Dialog = mui.Dialog,
	    propsToValiadte = ['x', 'y', 'i', 'h'],
	    BREAK_POINTS_DASHBOARD = { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 30 };
	
	
	var initialResizing = void 0,
	    isDashboardAlreadyFreezed = false,
	    scrollingAdjustInProgress = false,
	
	/**
	 * The visible array of positions which is visible into the dashboard.
	 * @type {Array}
	 */
	visibleLayoutOrders = [];
	
	__webpack_require__(1358);
	
	moment.locale(localStorage.getItem('i18nextLng'));
	
	function ShowNotificationShouldExistOneTankPerSection() {
	  return React.createElement("div", { className: "text-center jumbotron",
	    style: {
	      paddingTop: '10%',
	      margin: '0 auto',
	      position: 'absolute',
	      width: '100%',
	      height: '100%'
	    } }, React.createElement("p", null, t('dashboard_notification_check_tank_configuration_profile')));
	}
	
	var Dashboard = React.createClass({ displayName: "Dashboard",
	
	  mixins: [Authentication, Router.Navigation],
	
	  contextTypes: {
	    router: React.PropTypes.func
	  },
	
	  /**
	   * Current position of dashboard.
	   */
	  positions: {
	    start: null,
	    stop: null
	  },
	
	  isStopByPromptConfirm: false,
	
	  getInitialState: function getInitialState() {
	    var dateReference = moment().format(DATE_FORMAT),
	        // to day
	    rangeFrom = moment(dateReference, DATE_FORMAT).subtract(DEFAULT_MONTH_BEFORE, 'month').subtract(DEFAULT_DAYS_BEFORE, 'days').format(DATE_FORMAT),
	        rangeTo = moment(dateReference, DATE_FORMAT).add(DEFAULT_MONTH_AFTER, 'month').add(DEFAULT_DAYS_AFTER, 'days').format(DATE_FORMAT);
	
	    ChronologycStore.setCurrentRange(rangeFrom, rangeTo);
	    DashboardStore.forceRenderDashboard();
	
	    return {
	      isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
	      isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
	      isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging(),
	      from: ChronologycStore.getCurrentFrom(),
	      to: ChronologycStore.getCurrentTo(),
	      rangeOfDate: ChronologycStore.getCurrentRangeOfDate(),
	      dateReference: dateReference,
	      isPublishedDisabled: DashboardStore.hasPendingSavedDraftWithoutPublish(),
	      isDashboardBackwardForwarePristine: true,
	      immCurrentLayout: Immutable.List([]),
	      shouldRender: DashboardStore.isNeedForceRenderDashboard(),
	      isSearchExpand: false,
	      isInventoryReportVisible: false,
	      isUserTaskVisible: false,
	      currentDate: DateUtils.getCurrentDate(),
	      userTaskDate: DateUtils.getCurrentDate(),
	      itemSearchTarget: null,
	      isFilterModeActivated: false,
	      filterToggleChange: false,
	      items: [],
	      isCalculatingInventory: DashboardStore.getIsCalculatingInventory() === '' ? true : DashboardStore.getIsCalculatingInventory(), // '' is the default state of first time.
	      minDateInventory: DateUtils.getByDateFromNowInDays(-INVENTORY_MAX_PAST_DAYS_SCOPE)
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    document.getElementsByTagName('body')[0].classList.add('is-overflow-hidden'); // Fix material side effect on calendars of modal orders
	    UIStateStore.addChangeListener(this._onChangeUI);
	    DashboardStore.addChangeListener(this._onChange);
	    OrderStore.addChangeListener(this._onChange);
	    OrderStore.markOrderListener(this._markOrder);
	
	    var maxScopeInventoryDate = moment().add(-INVENTORY_MAX_PAST_DAYS_SCOPE, 'days').format(DATE_FORMAT);
	    SessionStore.setMaxScopeInventoryDate(maxScopeInventoryDate);
	
	    var isGuestUser = !SessionStore.isAdminUser();
	    this.setState({
	      isGuestUser: isGuestUser,
	      maxScopeInventoryDate: maxScopeInventoryDate,
	      isAbleToEditDates: SessionStore.isAbleToEditDates(),
	      isAbleToEditAllWithoutDates: SessionStore.isAbleToEditAllWithoutDates()
	    });
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    // remove listeners
	    document.getElementsByTagName('body')[0].classList.remove('is-overflow-hidden'); // Fix material side effect on calendars of modal orders
	    UIStateStore.removeChangeListener(this._onChangeUI);
	    DashboardStore.removeChangeListener(this._onChange);
	    OrderStore.removeChangeListener(this._markOrder);
	
	    // remove the interval of scroll watcher
	    if (this.intervalCheckScrollWatcher) {
	      clearInterval(this.intervalCheckScrollWatcher);
	    }
	
	    // close context menu in case that are open
	    ContextMenuEl.close();
	
	    // stop all poller
	    PollerSaveNote.stop();
	    PollerDashboard.stop();
	    PollerSaveDraft.stop();
	    PollerAppVersion.stop();
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return this._shouldRenderDashboard(nextState);
	  },
	  componentDidMount: function componentDidMount() {
	    ga.pageview('/dashboard');
	
	    if (!SessionStore.isCalculatingInventory()) {
	      // enter the first time, to set default value.
	      SessionStore.setIsCalculatingInventory(true);
	    }
	    var _state = this.state,
	        from = _state.from,
	        to = _state.to;
	
	    // register the scroll watcher which allow to
	    // auto loading the new range when it rich one of the border (top/bottom)
	    // of the dashboard which turn visible the spinner of the dashboard.
	
	    this._registerScrollWatcher();
	    var self = this;
	
	    DashboardStore.fetchDashboardContent(from, to, SessionStore.getCurrentApplicant(), function onFetchDashboardContentSuccess() {
	      self._onChange();
	      self._setScrollPositionOnToday();
	    });
	
	    PollerAppVersion.start();
	    PollerDashboard.start();
	    PollerSaveDraft.start();
	    PollerSaveNote.start();
	  },
	  componentWillUpdate: function componentWillUpdate() {
	    ChronologycStore.setCurrentRange(this.state.from, this.state.to);
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this._fireResize();
	    var needToHydrateDashboardLayout = !DashboardStore.isInitializedLayoutDashboard() && get(this.refs, 'dashboardGrid.state.layout.length', 0) > 0;
	    if (needToHydrateDashboardLayout) {
	      // we not need to fill position out of range because
	      // just needed the positions of current dashboard visible, which are position
	      // that came from component that was initialized for us previously in the render method.
	      DashboardStore.setInitializedLayoutDashboard();
	      DashboardStore.setLayoutWithoutHydrated(get(this.refs, 'dashboardGrid.state.layout', []));
	    }
	
	    // ask if we need to recalculate the current visible range of dashboard
	    // (only when trigger arrow button to move current visible range of dates)
	    if (!DashboardStore.isSavingDraft() && DashboardStore.isTriggerArrow()) {
	      visibleLayoutOrders = get(this.refs, 'dashboardGrid.state.layout', []);
	      var _state2 = this.state,
	          from = _state2.from,
	          to = _state2.to;
	
	      ChronologycStore.setCurrentRange(from, to);
	      DashboardStore.setLayoutWithoutHydrated(visibleLayoutOrders, from, to);
	      DashboardStore.unsetTriggerArrow();
	      this._fetchOrdersAndDraft(from, to, SessionStore.getCurrentApplicant());
	    }
	
	    this._adaptHeightDashboardToNewRangeVisible();
	
	    // just reset flag in case that we trigger before
	    DashboardStore.disabledForceRenderDashboard();
	
	    if (this.state.isUserTaskVisible || this.state.isInventoryReportVisible) {
	      document.body.classList.add('stop-scroll');
	    } else {
	      document.body.classList.remove('stop-scroll');
	    }
	
	    if (this._someLabelHasChange()) {
	      this.setState({
	        isVisibleBeerStyleLabelBrewing: SessionStore.isVisibleBeerStyleLabelBrewing(),
	        isVisibleBeerStyleLabelFermenting: SessionStore.isVisibleBeerStyleLabelFermenting(),
	        isVisibleBeerStyleLabelPackaging: SessionStore.isVisibleBeerStyleLabelPackaging()
	      });
	    }
	  },
	  _someLabelHasChange: function _someLabelHasChange() {
	    return this.state.isVisibleBeerStyleLabelBrewing !== SessionStore.isVisibleBeerStyleLabelBrewing() || this.state.isVisibleBeerStyleLabelFermenting !== SessionStore.isVisibleBeerStyleLabelFermenting() || this.state.isVisibleBeerStyleLabelPackaging !== SessionStore.isVisibleBeerStyleLabelPackaging();
	  },
	  _markOrder: function _markOrder(orderId) {
	    _markOrders(this.refs.dashboardGrid.getDOMNode(), orderId);
	  },
	  _shouldRenderDashboard: function _shouldRenderDashboard(nextState) {
	    if (this.state.immCurrentLayout.count() === 0) {
	      // enter here happen on initial rendering of dashboard
	      return true;
	    }
	
	    if (this.state.isInventoryReportVisible !== get(nextState, 'isInventoryReportVisible')) {
	      return true;
	    }
	    // ask first if we trigger manual render dashboard.
	    if (DashboardStore.isNeedForceRenderDashboard()) {
	      return true;
	      // make a shallow equality in order to know if exist some change
	    } else if (nextState && nextState.immCurrentLayout && !Immutable.is(this.state.immCurrentLayout, nextState.immCurrentLayout)) {
	      return true;
	    }
	    return false;
	  },
	  _setScrollPositionOnToday: function _setScrollPositionOnToday() {
	    this._setPositionScrollByDate(function (date) {
	      return DateUtils.isToDay(date);
	    }, -100);
	  },
	  _fetchOrdersAndDraft: function _fetchOrdersAndDraft(from, to, applicant) {
	    var self = this;
	    // retrieve the orders & notes from next dashboard range
	    DashboardStore.fetchNextDashboardContent(from, to, applicant, function () {
	      var _JSON$parse = JSON.parse(this.responseText),
	          brewingNotes = _JSON$parse.brewingNotes,
	          packagingNotes = _JSON$parse.packagingNotes,
	          orders = _JSON$parse.orders,
	          hasDraft = _JSON$parse.hasDraft;
	
	      var orderUpdated = DashboardServiceCache.fillCacheOrder(orders);
	
	      // Indicate that has pending draft operation to publish
	      DashboardStore.setHasOperationWithoutPublish(hasDraft);
	      ChronologycServiceCache.setBrewingNotes(brewingNotes);
	      ChronologycServiceCache.setPackagingNotes(packagingNotes);
	      self.setState({ orders: orderUpdated, brewingNotes: brewingNotes, packagingNotes: packagingNotes });
	    });
	  },
	  _adaptHeightDashboardToNewRangeVisible: function _adaptHeightDashboardToNewRangeVisible() {
	    if (this.refs.dashboardGrid) {
	      var amountDaysCurrentDashboard = DateUtils.getDaysBetween(this.state.from, this.state.to) * 35;
	      // change height of dashboard and change position of bottom arrow
	      this.refs.dashboardGrid.getDOMNode().style.height = amountDaysCurrentDashboard + 'px';
	      if (this.btnBackward) {
	        this.btnBackward.getDOMNode().style.top = amountDaysCurrentDashboard + 140 + 'px';
	      }
	      if (this.btnForward) {
	        var offsetBtnForward = SessionStore.isFullPaidVersion() ? 0 : 50;
	        this.btnForward.getDOMNode().style.top = offsetBtnForward + 'px';
	      }
	    }
	  },
	
	
	  /**
	   * Set the position of the scroll in the current month.
	   * @private
	   */
	  _setPositionScrollByDate: function _setPositionScrollByDate(conditionFilter, offset, positionAtBottom, onEndScroll) {
	    if (!existAtLeastOneTankOnEachSection(this.state.tanks)) {
	      // enter here means the dashboard is not loading, so we don't need to position scroll
	      return;
	    }
	
	    var chronologicMonthEL = this._getChronologycRowByMonthName(conditionFilter);
	    var scrollTop = void 0;
	    if (!positionAtBottom) {
	      // TOP
	      if (UIStateStore.isBrewingNotesBarOpen() && !UIStateStore.isPackagingNotesBarOpen()) {
	        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, -1);
	      } else if (UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen()) {
	        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, -1);
	      } else {
	        scrollTop = PositionUtils.elementScrollTop(chronologicMonthEL, ROW_HIGHT - 1);
	      }
	    } else {
	      // BOTTOM
	      if (UIStateStore.isBrewingNotesBarOpen() && !UIStateStore.isPackagingNotesBarOpen()) {
	        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, -1 + ROW_HIGHT);
	      } else if (UIStateStore.isBrewingNotesBarOpen() && UIStateStore.isPackagingNotesBarOpen()) {
	        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, ROW_HIGHT - 6);
	      } else {
	        scrollTop = PositionUtils.elementScrollBottom(chronologicMonthEL, ROW_HIGHT - 1 + ROW_HIGHT);
	      }
	    }
	    if (offset !== undefined) {
	      scrollTop = offset + scrollTop;
	    }
	    PositionUtils.scrollTo(scrollTop + -ROW_HIGHT, null, onEndScroll);
	  },
	  _getChronologycRowByMonthName: function _getChronologycRowByMonthName(conditionFilter) {
	    return filter(this.refs.chronologycBrewingBar.getDOMNode().querySelectorAll('.chronologyc-row.row'), function (row) {
	      return conditionFilter(row.getAttribute('data-date'));
	    })[0];
	  },
	
	
	  /**
	   * Handler invoked each time the store emit incoming changes.
	   * @private
	   */
	  _onChange: function _onChange() {
	    var _this = this;
	
	    var tanksRecover = TankStore.getTanks(),
	        orders = OrderStore.getOrders(),
	        lastOrderUpdate = OrderStore.getLastOrderUpdate(),
	        items = DashboardServiceCache.getItems();
	
	    if (DashboardStore.isNeedCleanSelectedOrders()) {
	      DashboardStore.setNeedCleanSelectedOrders(false);
	      _clearOrdersSelection(this.getDOMNode());
	    }
	
	    this.setState(function (prevState) {
	      return {
	        tanks: tanksRecover,
	        orders: orders,
	        items: items,
	        locationItems: DashboardServiceCache.getLocationItems(),
	        vendorPurchaseItems: DashboardServiceCache.getVendorPurchaseItems(),
	        lastOrderUpdate: lastOrderUpdate,
	        draftOrderAmount: (DashboardServiceCache.getOperations() || []).length || DashboardServiceCache.getDraftOrderAmount(),
	        undoDraftOrderAmount: DashboardServiceCache.getUndoDraftOrderAmount(),
	        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish(),
	        isVisibleBrewingSection: SessionStore.isVisibleBrewingSection(),
	        isVisibleFermentingSection: SessionStore.isVisibleFermentingSection(),
	        isVisiblePackagingSection: SessionStore.isVisiblePackagingSection(),
	        isGuestUser: _this._isGuestUserBecauseSomeSectionIsHidden() || prevState.isGuestUser
	      };
	    });
	  },
	  _isGuestUserBecauseSomeSectionIsHidden: function _isGuestUserBecauseSomeSectionIsHidden() {
	    return [SessionStore.isVisibleBrewingSection(), SessionStore.isVisibleFermentingSection(), SessionStore.isVisiblePackagingSection()].some(function (isVisibleSection) {
	      return isVisibleSection === false;
	    });
	  },
	  _onChangeUI: function _onChangeUI() {
	    this._fireResize();
	  },
	
	
	  /**
	   * Handler event on drag start.
	   * @param layout
	   * @param position
	   * @private
	   */
	  _onResizeStart: function _onResizeStart(layout, position) {
	    initialResizing = new Date().getTime();
	
	    var event = ContentUtils.filterEvents(arguments);
	    DashboardStore.setDraggingOrResizing();
	
	    if (event) {
	      this._freezeDashboard(layout, position, event);
	    }
	
	    visibleLayoutOrders = ContentUtils.clone(layout);
	    this.positions.start = ContentUtils.clone(position);
	  },
	
	
	  /**
	   * Handler event on resize stop.
	   * @param layout
	   * @param position
	   * @private
	   */
	  _onResizeStop: function _onResizeStop(layout, position) {
	    var _this2 = this;
	
	    initialResizing = 0;
	
	    DashboardStore.unsetDraggingOrResizing();
	
	    var event = ContentUtils.filterEvents(arguments);
	    var evt = arguments[4];
	    evt.preventDefault();
	    evt.stopPropagation();
	
	    var backupStop = this.positions.start;
	    this.positions.stop = ContentUtils.clone(position);
	    this._unFreezeDashboard(layout, position, event);
	
	    var currentOrder = find(this.state.orders, function (order) {
	      return get(order, 'id') === ContentUtils.cleanId(position.i);
	    });
	    if (!SessionStore.isAbleToEditDates()) {
	      this.positions.stop = backupStop;
	      this._forceRefreshDashboard();
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	
	    if (OrderStore.isResizeAllowed(currentOrder, this.positions)) {
	      //this.isStopByPromptConfirm = true;
	      delay(function () {
	        _this2._markOrder(position.i, 0);
	      }, 500);
	      // always render dashboard after resize vertically because we need to check if we move same order in wrong place
	      ga.event({
	        category: categories.ORDER,
	        action: actions.CHANGE,
	        label: labels.ORDER_RESIZED + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	      });
	    } else {
	      this.positions.stop = backupStop;
	      this._forceRefreshDashboard();
	      Notification.show(t('dashboard_notification_unconfirm_and_publish_before_change'));
	    }
	  },
	
	
	  /**
	   * Handler event on drag start.
	   * @param layout
	   * @param position
	   * @private
	   */
	  _onDragStart: function _onDragStart(layout, position) {
	    console.time('Dragging');
	    DashboardStore.disabledForceRenderDashboard();
	    DashboardStore.setDraggingOrResizing();
	
	    // Filter argument because sometimes when drag from the image, the event argument change the order
	    var event = ContentUtils.filterEvents(arguments);
	    if (event) {
	      this._freezeDashboard(layout, position, event);
	    }
	
	    try {
	      this.positions.start = ContentUtils.clone(position);
	      visibleLayoutOrders = ContentUtils.clone(layout);
	    } catch (e) {
	      visibleLayoutOrders = layout;
	      console.error('On drag start throw error ' + e);
	    }
	  },
	
	
	  /**
	   * Handler event on drag stop.
	   * @param layout
	   * @param position
	   * @private
	   */
	  _onDragStop: function _onDragStop(layout, position) {
	    var _this3 = this;
	
	    this._unFreezeDashboard(layout, position);
	    DashboardStore.unsetDraggingOrResizing();
	
	    window.scroll(0, window.scrollY); // Fix in case that drag outside of current viewport
	
	    this.positions.stop = ContentUtils.clone(position);
	
	    var isSamePosition = ContentUtils.isSameObject(this.positions.start, this.positions.stop, ['x', 'y', 'h']);
	    if (!SessionStore.isAbleToEditDates()) {
	      this._forceRefreshDashboard();
	      Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	      return;
	    }
	    if (isSamePosition) {
	      // enter here means the user just clicked above an order.
	      // so the only needed is to hightlighet the order
	      //this._markOrder(position.i, 0);
	    } else {
	      delay(function () {
	        _this3._markOrder(position.i, 0);
	        ga.event({
	          category: categories.ORDER,
	          action: actions.CHANGE,
	          label: labels.ORDER_DRAG_AND_DROP + ' Applicant: ' + SessionStore.getCurrentApplicant() + ' User: ' + ContentUtils.getSession('userNameSession')
	        });
	      }, 50);
	    }
	  },
	  _forceRefreshDashboard: function _forceRefreshDashboard() {
	    this._cleanPositions();
	    AppDispatcher.dispatch({ type: ActionTypes.FORCE_MANUAL_DRAWING_DASHBOARD });
	    var self = this;
	    setTimeout(function () {
	      self._fireResize();
	      self.forceUpdate();
	    }, 100);
	  },
	  _freezeDashboard: function _freezeDashboard(layout, position) {
	    if (!isDashboardAlreadyFreezed) {
	      isDashboardAlreadyFreezed = true;
	      forEach(layout, function (l) {
	        // To avoid freeze orders in non-dragging ca_onSingleClickses.
	        if (l.i !== position.i) {
	          l.static = true;
	        }
	      });
	    }
	  },
	  _unFreezeDashboard: function _unFreezeDashboard(layout, position) {
	    forEach(layout, function (l) {
	      // for that always are static.
	      if (l.i !== position.i) {
	        l.static = false;
	      }
	    });
	    isDashboardAlreadyFreezed = false;
	  },
	
	
	  /**
	   * Fire resize event in order to repaint dashboard.
	   * @private
	   */
	  _fireResize: function _fireResize() {
	    var evt = document.createEvent('UIEvents');
	    evt.initUIEvent('resize', true, false, window, 0);
	    delay(function () {
	      window.dispatchEvent(evt);
	    }, 250);
	  },
	
	
	  /**
	   * Execute publish current draft.
	   * @param evt
	   * @private
	   */
	  _onPublishDraft: function _onPublishDraft(evt) {
	    evt.stopPropagation();
	    evt.preventDefault();
	    DashboardActionCreators.publishingDraft();
	  },
	  _onToggleCalculateInventory: function _onToggleCalculateInventory(evt) {
	    var _this4 = this;
	
	    if (evt && evt.stopPropagation) {
	      evt.stopPropagation();
	      evt.preventDefault();
	    }
	    this.setState(function (prevState) {
	      return {
	        isCalculatingInventory: !prevState.isCalculatingInventory
	      };
	    }, function () {
	      _this4._forceRefreshDashboard();
	      SessionStore.setIsCalculatingInventory(_this4.state.isCalculatingInventory);
	    });
	  },
	
	
	  /**
	   * On change of the grid layout component.
	   */
	  _onLayoutChange: function _onLayoutChange() {
	    if (this._needRenderDashboard()) {
	      try {
	        DashboardStore.setLayoutWithoutHydrated(visibleLayoutOrders);
	        var newOrder = OrderStore.moveOrders(this.positions.start, this.positions.stop);
	        // get from view the current update layout
	        visibleLayoutOrders = get(this.refs, 'dashboardGrid.state.layout') || visibleLayoutOrders;
	
	        if (!newOrder) {
	          DashboardActionCreators.forceRenderDashboard();
	          return;
	        }
	
	        DashboardCache.removeOrderAndCleanCacheScopeInventory(get(newOrder, 'id'));
	        this.setState({
	          immCurrentLayout: Immutable.fromJS(visibleLayoutOrders),
	          isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
	        });
	      } catch (e) {
	        console.error(e.message);
	      } finally {
	        this._cleanPositions();
	        console.timeEnd('Dragging');
	      }
	    }
	  },
	
	
	  /**
	   * clean current positions.
	   * @private
	   */
	  _cleanPositions: function _cleanPositions() {
	    this.positions.stop = null;
	    this.positions.start = null;
	  },
	
	
	  /**
	   * Validate if is necessary trigger render dashboard or not.
	   * @return {boolean}
	   * @private
	   */
	  _needRenderDashboard: function _needRenderDashboard() {
	
	    if (ContentUtils.isNull(this.positions) || ContentUtils.isNull(this.positions.start) || ContentUtils.isNull(this.positions.stop)) {
	      return false;
	    }
	
	    if (DashboardStore.isNeedForceRenderDashboard() && !DashboardStore.isSavingDraft() && !DashboardStore.isTriggerArrow()) {
	      DashboardStore.disabledForceRenderDashboard();
	      return true;
	    }
	
	    if (this.state.shouldRenderDashboard) {
	      this.state.shouldRenderDashboard = false;
	      return true;
	    }
	
	    if (this.positions.start && this.positions.stop && !this.isStopByPromptConfirm) {
	      if (!ContentUtils.isSameObject(this.positions.start, this.positions.stop, propsToValiadte)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	  _getChronologycElByClientY: function _getChronologycElByClientY(elY) {
	    // enter here means that we clicked an empty cell with brewing note closed, so the element which found was the span of chronologyc
	    return ContentUtils.getComponentByAttribute(elY, 'data-date');
	  },
	  _forwardOrder: function _forwardOrder() {
	    var _this5 = this;
	
	    if (DashboardStore.isSavingDraft()) {
	      // enter here means the scroll could not be load until finish
	      // to save draft
	      return false;
	    }
	    PositionUtils.enableScrolling();
	    DashboardActionCreators.hideLoading();
	    var dates = DateUtils.incrementByDays(this.state.dateReference, this.state.from, this.state.to, -DAYS_BACKWARD_FORWARD);
	
	    var lastFrom = this.state.from;
	
	    DashboardStore.forceRenderDashboard();
	    DashboardStore.setTriggerArrow();
	
	    // fix issue when focus are in some notes, after
	    // autos-scrolling don't re-locate the note
	    this._resetFocus();
	
	    // need to reset because the transition order
	    // when select is not looking good here
	    _clearOrdersSelection(this.getDOMNode());
	
	    this.setState(function (prevState) {
	      return {
	        from: dates.from,
	        to: dates.to,
	        dateReference: dates.date,
	        isDashboardBackwardForwarePristine: false,
	        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
	      };
	    }, function () {
	      _this5._setPositionScrollByDate(function (date) {
	        return date === lastFrom;
	      }, 0, false, function () {
	        // On end scroll.
	      });
	    });
	    if (this.refs.chronologycBrewingBar && this.refs.chronologycPackagingBar) {
	      // Fix issue that not execute render in chronology bar
	      this.refs.chronologycBrewingBar.forceUpdate();
	      this.refs.chronologycPackagingBar.forceUpdate();
	    }
	  },
	  _backwardOrder: function _backwardOrder() {
	    var _this6 = this;
	
	    if (DashboardStore.isSavingDraft()) {
	      // enter here means the scroll could not be load until finish
	      // to save draft
	      return false;
	    }
	    PositionUtils.enableScrolling();
	    DashboardActionCreators.hideLoading();
	    var dates = DateUtils.incrementByDays(this.state.dateReference, this.state.from, this.state.to, DAYS_BACKWARD_FORWARD);
	
	    var lastTo = this.state.to;
	    DashboardStore.forceRenderDashboard();
	    DashboardStore.setTriggerArrow();
	
	    // fix issue when focus are in some notes, after
	    // autos-scrolling don't re-locate the note
	    this._resetFocus();
	
	    // need to reset because the transition order
	    // when select is not looking good here
	    _clearOrdersSelection(this.getDOMNode());
	
	    this.setState(function () {
	      return {
	        from: dates.from,
	        to: dates.to,
	        dateReference: dates.date,
	        isDashboardBackwardForwarePristine: false,
	        isPublishedDisabled: !DashboardStore.hasPendingSavedDraftWithoutPublish()
	      };
	    }, function () {
	      _this6._setPositionScrollByDate(function (date) {
	        return date === lastTo;
	      }, 0, true, function () {
	        // On end scrolling
	      });
	    });
	
	    if (this.refs.chronologycBrewingBar && this.refs.chronologycPackagingBar) {
	      // Fix issue that not execute render in chronology bar
	      this.refs.chronologycBrewingBar.forceUpdate();
	      this.refs.chronologycPackagingBar.forceUpdate();
	    }
	  },
	  _resetFocus: function _resetFocus() {
	    if (document && document.activeElement) {
	      document.activeElement.blur();
	    }
	  },
	  _onRightClick: function _onRightClick(evt) {
	    evt.preventDefault();
	    var tankType = evt.target.getAttribute('data-tank-type');
	    var orderId = evt.target.getAttribute('data-order-id');
	    var currentDashboard = this.refs.dashboardGrid.state.layout;
	
	    if (orderId) {
	      AppDispatcher.dispatch({
	        type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
	        orderId: evt.target.getAttribute('data-order-id'),
	        positionX: evt.clientX,
	        positionY: evt.clientY,
	        dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
	        tankClicked: DashboardStore.getTankFromClientX(evt.clientX),
	        isFermenterTank: tankType === 'FV',
	        batchNumber: get(OrderStore.getOrder(orderId), 'batchNumber'),
	        tankType: tankType,
	        currentDashboard: currentDashboard
	      });
	    } else {
	      AppDispatcher.dispatch({
	        type: ActionTypes.RIGHT_CLICK_DASHBOARD,
	        positionX: evt.clientX,
	        positionY: evt.clientY,
	        dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
	        tankClicked: DashboardStore.getTankFromClientX(evt.clientX),
	        isFermenterTank: tankType === 'FV',
	        tankType: tankType,
	        currentDashboard: currentDashboard
	      });
	    }
	  },
	  _onSingleClick: function _onSingleClick(evt) {
	
	    if (window.Cypress) {
	      var clientY = window.Cypress.env('fixture.orderClickedY');
	      var clientX = window.Cypress.env('fixture.orderClickedX');
	      this._onDoubleClickEmptyCell(_extends({}, evt, {
	        clientY: clientY,
	        clientX: clientX,
	        preventDefault: function preventDefault() {},
	        stopPropagation: function stopPropagation() {}
	      }));
	      return;
	    }
	
	    if (evt && evt.target) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      var newOrderSelectedId = evt.target.getAttribute('data-order-id');
	      var newOrderSelected = OrderStore.getOrder(newOrderSelectedId);
	      if (newOrderSelected) {
	        OrderStore.updateLastOrderUpdated(newOrderSelected);
	      }
	      this._markOrder(newOrderSelectedId);
	      if (newOrderSelectedId != null) {
	        //Notification.show('Icon/s confirmed, unconfirm to make changes');
	      } else {
	        this._onDoubleClickEmptyCell(evt);
	      }
	    }
	  },
	
	
	  /**
	   * Capture element from cords of mouse click on empty cell of dashboard.
	   * @param {MouseEvent} evt
	   * @private
	   */
	  _onDoubleClickEmptyCell: function _onDoubleClickEmptyCell(evt) {
	    evt.preventDefault();
	    evt.stopPropagation();
	    var tankClicked = DashboardStore.getTankFromClientX(evt.clientX);
	
	    _clearOrderSelected(evt.target);
	
	    if (tankClicked) {
	      var dateClicked = ChronologycStore.getDateFromClientY(evt.clientY);
	      var preDefinedOrder = {
	        date: dateClicked,
	        tankSelected: tankClicked,
	        tankType: get(tankClicked, 'type')
	      };
	
	      if (!SessionStore.isAbleToEditDates()) {
	        Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	        return;
	      }
	
	      this._prepareDashboardToNewOrder();
	
	      AppDispatcher.dispatch({
	        type: ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_EMPTY,
	        preDefinedOrder: preDefinedOrder
	      });
	    }
	  },
	
	
	  /**
	   * Open a Modal order.
	   * @private
	   */
	  _prepareDashboardToNewOrder: function _prepareDashboardToNewOrder() {
	    _clearOrderSelected(this.refs.dashboardGrid.getDOMNode());
	    ga.modalview('/dashboard/new-order-from-empty-cell');
	  },
	  _registerScrollWatcher: function _registerScrollWatcher() {
	    this.intervalCheckScrollWatcher = setInterval(this._checkIfNeedMoreContent, 500);
	  },
	  _checkIfNeedMoreContent: function _checkIfNeedMoreContent() {
	    var isScrollOnTop = Viewport.isInsideViewport(document.querySelector('.btn-center-top-fixed'));
	    var isScrollOnBottom = Viewport.isInsideViewport(document.querySelector('.btn-center-bottom-fixed'));
	
	    if (scrollingAdjustInProgress) {
	      // enter here means is in progress scrolling movement
	      return;
	    }
	    if (isScrollOnTop) {
	      DashboardActionCreators.showLoading();
	      scrollingAdjustInProgress = true;
	      PositionUtils.disableScrolling();
	      delay(function () {
	        scrollingAdjustInProgress = false;
	        var isScrollOnTop = Viewport.isInsideViewport(document.querySelector('.btn-center-top-fixed'));
	        if (isScrollOnTop) {
	          document.querySelector('.btn-center-top-fixed').click();
	        }
	      }, 800);
	    } else if (isScrollOnBottom) {
	      DashboardActionCreators.showLoading();
	      scrollingAdjustInProgress = true;
	      PositionUtils.disableScrolling();
	      delay(function () {
	        scrollingAdjustInProgress = false;
	        var isScrollOnBottom = Viewport.isInsideViewport(document.querySelector('.btn-center-bottom-fixed'));
	        if (isScrollOnBottom) {
	          document.querySelector('.btn-center-bottom-fixed').click();
	        }
	      }, 800);
	    }
	  },
	  getFixedFreeVersionAdvertisement: function getFixedFreeVersionAdvertisement() {
	    return React.createElement("div", { className: "free-version-advertisement" }, React.createElement("p", null, t('dashboard_notification_free_trial_platium_version')), React.createElement(FlatButton, {
	      label: t('dashboard_label_try_now'),
	      primary: true,
	      onTouchTap: onClickTryProVersion.bind(this)
	    }));
	  },
	  _onClickUndo: function _onClickUndo(evt) {
	    evt.stopPropagation();
	    evt.preventDefault();
	    DashboardActionCreators.undoDraft();
	  },
	  _onClickRedoButton: function _onClickRedoButton(evt) {
	    evt.stopPropagation();
	    evt.preventDefault();
	    DashboardActionCreators.redoDraft();
	  },
	  _handlerOpenUserTask: function _handlerOpenUserTask(date, isToggle) {
	    var _this7 = this;
	
	    if (UserTaskStore.isAllChangesSaved()) {
	      this.setState(function (prevState) {
	        return {
	          isUserTaskVisible: isToggle ? !prevState.isUserTaskVisible : true,
	          userTaskDate: DateUtils.toDateText(date ? date : prevState.userTaskDate)
	        };
	      }, function () {
	        if (_this7.state.isUserTaskVisible) {
	          DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(date));
	        }
	      });
	    } else {
	      CustomDialog.showWarningConfirmation(t('warning'), t('dashboard_user_task_notification_please_save_changes'), function () {
	        UserTaskStore.resetAllChangesNote();
	        _this7.setState(function (prevState) {
	          return {
	            isUserTaskVisible: isToggle ? !prevState.isUserTaskVisible : true,
	            userTaskDate: DateUtils.toDateText(date ? date : prevState.userTaskDate)
	          };
	        }, function () {
	          if (_this7.state.isUserTaskVisible) {
	            DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(date));
	          }
	        });
	      });
	    }
	  },
	
	
	  _timeouts: [],
	
	  _handlerToggleOpenUserTask: function _handlerToggleOpenUserTask(date) {
	    var _this8 = this;
	
	    var isToggle = true;
	    this.toggleTasks(function () {
	      _this8._handlerOpenUserTask(date, isToggle);
	    });
	  },
	  _handlerKeepOpenUserTask: function _handlerKeepOpenUserTask(date) {
	    var _this9 = this;
	
	    this.openTasks(function () {
	      _this9._handlerOpenUserTask(date);
	    });
	  },
	  clearTimeout: function (_clearTimeout) {
	    function clearTimeout() {
	      return _clearTimeout.apply(this, arguments);
	    }
	
	    clearTimeout.toString = function () {
	      return _clearTimeout.toString();
	    };
	
	    return clearTimeout;
	  }(function () {
	    if (this._timeouts && this._timeouts.length) {
	      this._timeouts.forEach(function (time) {
	        return clearTimeout(time);
	      });
	    }
	  }),
	  _handlerToggleUserTask: function _handlerToggleUserTask() {
	    var _this10 = this;
	
	    this.toggleTasks(function () {
	      _this10.setState(function (prevState) {
	        return {
	          isUserTaskVisible: !prevState.isUserTaskVisible,
	          userTaskDate: DateUtils.toDateText(prevState.userTaskDate ? prevState.userTaskDate : DateUtils.getCurrentDate())
	        };
	      }, function () {
	        if (_this10.state.isUserTaskVisible) {
	          DashboardActionCreators.fetchScheduleBoardByDate(DateUtils.toDateText(_this10.state.userTaskDate));
	        }
	      });
	    });
	  },
	  closeTasks: function closeTasks(onClose) {
	    var _this11 = this;
	
	    document.querySelector('.tasks').classList.add('is-hidden');
	    this._timeouts.push(setTimeout(function () {
	      onClose();
	      _this11.clearTimeout();
	    }, 501));
	  },
	  toggleTasks: function toggleTasks(onToggle) {
	    var _this12 = this;
	
	    document.querySelector('.tasks').classList.toggle('is-hidden');
	    this._timeouts.push(setTimeout(function () {
	      onToggle();
	      _this12.clearTimeout();
	    }, 501));
	  },
	  openTasks: function openTasks(onOpen) {
	    var _this13 = this;
	
	    var taskEl = document.querySelector('.tasks');
	    if (taskEl.classList.contains('is-hidden')) {
	      taskEl.classList.remove('is-hidden');
	      this._timeouts.push(setTimeout(function () {
	        onOpen();
	        _this13.clearTimeout();
	      }, 501));
	    } else {
	      onOpen();
	    }
	  },
	  render: function render() {
	    var _this14 = this;
	
	    var dashboardBody = ' dashboard-body',
	        dashboardHeader = ' dashboard-header';
	
	    dashboardHeader = UIStateStore.isBrewingNotesBarOpen() ? 'is-brewing-note-open' : 'is-brewing-note-close';
	    dashboardHeader = UIStateStore.isPackagingNotesBarOpen() ? dashboardHeader + ' is-packaging-note-open' : dashboardHeader + ' is-packaging-note-close';
	
	    dashboardBody = this.state.isDashboardBackwardForwarePristine ? dashboardHeader + ' is-pristine' : dashboardHeader;
	    dashboardBody = !UIStateStore.isPackagingNotesBarOpen() ? dashboardHeader + ' is-packaging-note-collapsed' : dashboardHeader;
	    dashboardBody = !UIStateStore.isBrewingNotesBarOpen() ? dashboardHeader + ' is-brewing-note-collapsed' : dashboardHeader;
	    var amountDaysCurrentDashboard = DateUtils.getDaysBetween(this.state.from, this.state.to);
	
	    if (this.state.tanks === undefined || this.state.tanks.length === 0) {
	      return React.createElement(Loading, null);
	    }
	
	    if (!existAtLeastOneTankOnEachSection(this.state.tanks)) {
	      return ShowNotificationShouldExistOneTankPerSection();
	    }
	
	    var _state3 = this.state,
	        tanks = _state3.tanks,
	        orders = _state3.orders,
	        from = _state3.from,
	        to = _state3.to,
	        isDashboardBackwardForwarePristine = _state3.isDashboardBackwardForwarePristine,
	        isSearchExpand = _state3.isSearchExpand,
	        draftOrderAmount = _state3.draftOrderAmount,
	        undoDraftOrderAmount = _state3.undoDraftOrderAmount,
	        isUserTaskVisible = _state3.isUserTaskVisible,
	        isInventoryReportVisible = _state3.isInventoryReportVisible,
	        userTaskDate = _state3.userTaskDate,
	        items = _state3.items,
	        locationItems = _state3.locationItems,
	        vendorPurchaseItems = _state3.vendorPurchaseItems,
	        isFilterModeActivated = _state3.isFilterModeActivated,
	        filterItem = _state3.filterItem,
	        isVisibleBrewingSection = _state3.isVisibleBrewingSection,
	        isVisibleFermentingSection = _state3.isVisibleFermentingSection,
	        isVisiblePackagingSection = _state3.isVisiblePackagingSection,
	        isGuestUser = _state3.isGuestUser;
	
	
	    var enableTanks = ContentUtils.filterDisableTankDisabledIfNotHaveOrder(tanks, orders);
	    var tanksFilteredBySection = ContentUtils.filterTanksBySections(enableTanks, {
	      isVisibleBrewingSection: isVisibleBrewingSection,
	      isVisibleFermentingSection: isVisibleFermentingSection,
	      isVisiblePackagingSection: isVisiblePackagingSection
	    });
	    var isSaving = DashboardStore.isSavingDraft();
	    var tanksEl = drawHeaderTanksEl(tanksFilteredBySection, {
	      isVisibleBrewingSection: isVisibleBrewingSection,
	      isVisibleFermentingSection: isVisibleFermentingSection,
	      isVisiblePackagingSection: isVisiblePackagingSection
	    });
	    var ordersEl = drawOrdersEl(this);
	
	    var isPublishButtonVisible = isPublishButtonReadyToPublish() || draftOrderAmount > 0 || undoDraftOrderAmount > 0;
	    var publishDraftButton = React.createElement(FloatingActionButton, {
	      ref: "btnPublish",
	      style: { 'display': isPublishButtonVisible ? 'inherit' : 'none' },
	      onClick: this._onPublishDraft, className: "with-opacity btn-right-fixed btn-right-upload hidden-xs",
	      iconClassName: "with-opacity muidocs-icon-action-grade", backgroundColor: "#0f9d58" }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "cloud_upload"));
	
	    var _getDashboardButtons$ = getDashboardButtons.call(this, isPublishButtonVisible, draftOrderAmount, isSaving, undoDraftOrderAmount, isDashboardBackwardForwarePristine, this._handlerToggleUserTask),
	        undoButton = _getDashboardButtons$.undoButton,
	        redoButton = _getDashboardButtons$.redoButton,
	        forwardButton = _getDashboardButtons$.forwardButton,
	        backwardButton = _getDashboardButtons$.backwardButton,
	        iconUserTask = _getDashboardButtons$.iconUserTask,
	        iconInventoryReport = _getDashboardButtons$.iconInventoryReport;
	
	    var iconDisableShowInventory = React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "calculate");
	    var iconDisableShowInventoryEl = SessionStore.isFullPaidVersion() ? getToggleShowInventoryButtonEl.call(this, isPublishButtonVisible, isSearchExpand, iconDisableShowInventory) : null;
	
	    var shouldShowGuestIndicator = isGuestUser ? true : !SessionStore.isAdminUser();
	    var isAllSectionActive = isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection;
	
	    var readOnlyIndicator = shouldShowGuestIndicator ? React.createElement(DashboardViewOnlyIndicator, { isAllSectionActive: isAllSectionActive }) : null;
	
	    var customOverlayEl = React.createElement(CustomOverlay, { isVisible: DashboardStore.isPublishingDraft(),
	      text: t('dashboard_text_publishing_in_progress') });
	
	    var customOverlayFilterEl = React.createElement(CustomOverlay, { isVisible: isSearchExpand || isFilterModeActivated });
	
	    var dashboardBodyClassName = 'dashboard-body' + (SessionStore.isPaidVersion() ? '' : ' is-free-version');
	    var dashboardPageClassName = 'dashboard-content' + (SessionStore.isPaidVersion() ? '' : ' is-free-version');
	
	    if (UIStateStore.isBrewingNotesBarOpen()) {
	      dashboardPageClassName += ' is-parent-brewing-note-open';
	    } else {
	      dashboardPageClassName += ' is-parent-brewing-note-close';
	    }
	
	    if (UIStateStore.isPackagingNotesBarOpen()) {
	      dashboardPageClassName += ' is-parent-packaging-note-open';
	    } else {
	      dashboardPageClassName += ' is-parent-packaging-note-close';
	    }
	
	    return React.createElement("section", { id: "dashboard-id", className: dashboardPageClassName }, customOverlayEl, customOverlayFilterEl, readOnlyIndicator, React.createElement(ChronologycBar, {
	      showForwardOrders: this._forwardOrder,
	      showBackwardOrders: this._backwardOrder,
	      ref: "chronologycBrewingBar", shouldUpdate: true, typeBar: "brewing-bar",
	      from: from,
	      to: to,
	      onDoubleClick: this._handlerKeepOpenUserTask }), React.createElement(ChronologycBar, { ref: "chronologycPackagingBar", shouldUpdate: true, typeBar: "packaging-bar",
	      from: from,
	      to: to,
	      onDoubleClick: this._handlerKeepOpenUserTask }), React.createElement("div", { className: "dashboard-header" }, React.createElement(ReactGridLayout, {
	      ref: "dashboardHeaderGrid",
	      className: dashboardHeader,
	      initialWidth: "1280",
	      cols: tanksFilteredBySection.length,
	      rowHeight: ROW_HIGHT,
	      margin: [1, 1],
	      verticalCompact: false,
	      autoSize: false,
	      useCSSTransforms: true,
	      isResizable: true,
	      breakpoints: BREAK_POINTS_DASHBOARD }, tanksEl)), React.createElement("div", { className: dashboardBodyClassName, "data-days-current-range": amountDaysCurrentDashboard }, React.createElement(ReactGridLayout, {
	      ref: "dashboardGrid",
	      className: dashboardBody,
	      initialWidth: "1280",
	      cols: tanksFilteredBySection.length,
	      rowHeight: ROW_HIGHT,
	      margin: [1, 1],
	      onDragStop: this._onDragStop,
	      onDragStart: this._onDragStart,
	      onResizeStart: this._onResizeStart,
	      onResizeStop: this._onResizeStop,
	      onLayoutChange: this._onLayoutChange,
	      onDoubleClick: this._onDoubleClickEmptyCell,
	      onClick: this._onSingleClick,
	      onContextMenu: this._onRightClick,
	      verticalCompact: false,
	      autoSize: false,
	      useCSSTransforms: true,
	      isResizable: true,
	      breakpoints: BREAK_POINTS_DASHBOARD
	    }, ordersEl)), iconInventoryReport, iconUserTask, iconDisableShowInventoryEl, publishDraftButton, redoButton, undoButton, forwardButton, backwardButton, React.createElement(UserTasks, {
	      date: userTaskDate,
	      isUserTaskVisible: isUserTaskVisible,
	      onClickClose: function onClickClose() {
	        _this14.closeTasks(function () {
	          return _this14.setState({ isUserTaskVisible: false });
	        });
	      },
	      onChangeDate: this._handlerOpenUserTask }), React.createElement(InventoryReport, {
	      items: items,
	      dateFrom: from,
	      dateTo: to,
	      locationItems: locationItems,
	      vendorPurchaseItems: vendorPurchaseItems,
	      isVisible: isInventoryReportVisible,
	      orders: this.state.orders,
	      itemSelected: filterItem,
	      onSelectItem: function onSelectItem(item) {
	        _this14.setState(function (prevState) {
	          return {
	            filterItem: item,
	            isFilterModeActivated: !!item,
	            filterToggleChange: !prevState.filterToggleChange
	          };
	        }, function () {
	          return _this14.forceUpdate();
	        });
	      },
	      onClose: function onClose() {
	        return _this14.setState({
	          isInventoryReportVisible: false,
	          isFilterModeActivated: false,
	          filterItem: null
	        });
	      } }));
	  }
	});
	
	function getDashboardButtons(isPublishButtonVisible, draftOrderAmount, isSaving, undoDraftOrderAmount, isDashboardBackwardForwarePristine, handlerOpenUserTask) {
	  var _this15 = this;
	
	  var undoButton = React.createElement(FloatingActionButton, {
	    ref: "btnUndo",
	    style: { 'display': isPublishButtonVisible && draftOrderAmount > 0 && !isSaving ? 'inherit' : 'none' },
	    onClick: this._onClickUndo,
	    className: 'btn-undo-redo btn-undo ' + (+undoDraftOrderAmount > 0 ? ' with-redo' : '') + ' with-opacity hidden-xs',
	    iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3" }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "undo"));
	  var redoButton = React.createElement(FloatingActionButton, {
	    ref: "btnRedo",
	    style: { 'display': isPublishButtonVisible && +undoDraftOrderAmount && !isSaving > 0 ? 'inherit' : 'none' },
	    onClick: this._onClickRedoButton,
	    className: 'btn-undo-redo btn-redo ' + (+undoDraftOrderAmount > 0 ? ' with-redo' : '') + ' with-opacity hidden-xs',
	    iconClassName: "muidocs-icon-action-grade", backgroundColor: "#B3B3B3" }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "redo"));
	
	  var forwardButton = React.createElement(FloatingActionButton, {
	    backgroundColor: "#fff",
	    ref: function ref(el) {
	      if (el) {
	        _this15.btnForward = el;
	      }
	    },
	    onClick: this._forwardOrder, className: "btn-center-top-fixed btn-backward-order",
	    iconClassName: "muidocs-icon-action-grade" }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }));
	
	  var backwardButton = React.createElement(FloatingActionButton, {
	    backgroundColor: "#fff",
	    ref: function ref(el) {
	      if (el) {
	        _this15.btnBackward = el;
	      }
	    },
	    onClick: this._backwardOrder,
	    className: isDashboardBackwardForwarePristine ? 'btn-center-bottom-fixed btn-forware-order is-pristine' : 'btn-center-bottom-fixed btn-forware-order',
	    iconClassName: "muidocs-icon-action-grade" }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }));
	
	  var iconUserTask = React.createElement("div", { className: 'btn-user-tasks with-opacity' + (isPublishButtonVisible ? ' is-button-draft-visible' : '') }, React.createElement(FloatingActionButton, {
	    onClick: function onClick() {
	      UserTaskStore.resetAllChangesNote();
	      handlerOpenUserTask(DateUtils.getCurrentDate());
	    },
	    style: { color: '#fff !important' },
	    iconClassName: "muidocs-icon-action-grade",
	    backgroundColor: this.state.isUserTaskVisible ? '#0f9d58' : '#B3B3B3'
	  }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "checklist")));
	
	  var iconInventoryReport = React.createElement("div", {
	    className: 'btn-user-tasks btn-inventory-report with-opacity' + (isPublishButtonVisible ? ' is-button-draft-visible' : '') }, React.createElement(FloatingActionButton, {
	    onClick: function onClick() {
	      _this15.setState(function (prevState) {
	        return {
	          isInventoryReportVisible: !prevState.isInventoryReportVisible
	        };
	      });
	    },
	    style: { color: '#fff !important' },
	    iconClassName: "muidocs-icon-action-grade",
	    backgroundColor: this.state.isInventoryReportVisible ? '#0f9d58' : '#B3B3B3'
	  }, React.createElement("i", { className: "material-icons md-48 btn-icon-center" }, "list")));
	
	  return {
	    undoButton: undoButton,
	    redoButton: redoButton,
	    forwardButton: forwardButton,
	    backwardButton: backwardButton,
	    iconUserTask: iconUserTask,
	    iconInventoryReport: iconInventoryReport
	  };
	}
	
	function existAtLeastOneTankOnEachSection(tanks) {
	  var existBHTank = some(tanks, function (t) {
	    return t.type === 'BH';
	  });
	  var existFVTank = some(tanks, function (t) {
	    return t.type === 'FV';
	  });
	  var existBTTank = some(tanks, function (t) {
	    return t.type === 'BT';
	  });
	  return existBHTank && existFVTank && existBTTank;
	}
	
	/**
	 * Retrieve the elements Header, such as fermenters and carbonators, that will
	 * fill the Header section of the Dashboard.
	 *
	 * @argument {Array} tanks the list of fermenter & carbonators.
	 * @argument {Array} orders from the dashboard
	 * @return {Array} return the Fermenter & Carbonators Header elements.
	 */
	function drawHeaderTanksEl(tanks, _ref) {
	  var isVisibleBrewingSection = _ref.isVisibleBrewingSection,
	      isVisibleFermentingSection = _ref.isVisibleFermentingSection,
	      isVisiblePackagingSection = _ref.isVisiblePackagingSection;
	
	  var elements = [],
	      sizeRow = 1,
	      isFistBriteTankFounded = false,
	      isFistFermenterTankFounded = false,
	      tankClassName = 'fixed-header';
	
	  var isDisableBrewSeparator = !isVisibleBrewingSection && !isVisibleFermentingSection && isVisiblePackagingSection || !isVisibleBrewingSection && isVisibleFermentingSection && !isVisiblePackagingSection || !isVisibleBrewingSection && isVisibleFermentingSection && isVisiblePackagingSection;
	
	  if (isDisableBrewSeparator) {
	    tankClassName += ' is-disable-brew-separator';
	  }
	
	  ContentUtils.filterEnable(tanks).forEach(function (tank, index, array) {
	    var item = array[index + 1] || { type: '' };
	    if (!isFistFermenterTankFounded && array.length > 1 && item.type === 'FV') {
	      tankClassName += ' is-first-fermenter';
	      isFistFermenterTankFounded = true;
	    } else if (!isFistBriteTankFounded && array.length > 1 && item.type === 'BT') {
	      tankClassName += ' is-first-britetank';
	      isFistBriteTankFounded = true;
	    } else {
	      tankClassName = 'fixed-header';
	    }
	
	    if (!SessionStore.isPaidVersion()) {
	      tankClassName += ' is-free-version';
	    }
	
	    elements.push(React.createElement("div", { className: tankClassName,
	      "data-tank-type": tank.type,
	      "data-tank-id": tank.id,
	      "data-tank-is-enable": tank.enable,
	      "data-tank-volume": tank.volume + tank.unit,
	      ref: tank.id,
	      key: tank.id,
	      _grid: {
	        x: index,
	        y: 0,
	        w: 1,
	        h: sizeRow,
	        static: true
	      } }, React.createElement("span", {
	      "data-tank-type": tank.type,
	      "data-tank-id": tank.id,
	      "data-tank-is-enable": tank.enable,
	      "data-tank-volume": tank.volume + tank.unit,
	      className: "fixed-header-tank-name" }, tank.name)));
	  });
	
	  return elements;
	}
	
	/**
	 * We need to be sure, that all draft operation are already saved in order to be ready to publish.
	 * Otherwise we could left some latest changes for some order outside of the publishing mechanism.
	 * @returns {boolean}
	 */
	function isPublishButtonReadyToPublish() {
	  return SessionStore.isAdminUser() && DashboardStore.hasOperationWithoutPublish() && DashboardServiceCache.isAllOperationAlreadySaved();
	}
	
	/**
	 * Draw the visible orders of the Dashboard.
	 * @param context
	 * @return {Array} Orders elements.
	 */
	function drawOrdersEl(context) {
	  var state = context.state;
	  var orderEl = void 0;
	  var ordersEl = [];
	  var batchsEl = void 0;
	  var hydratedOrders = InventoryStore.hydrateOrderTaskWithInventoryScopeEstimation(state.orders);
	  if (hydratedOrders) {
	    forEach(ContentUtils.filterEnable(hydratedOrders), function (order) {
	      orderEl = undefined;
	      if (ContentUtils.isEmptyArray(orderEl)) {
	        if (order && order.isSingle) {
	          orderEl = drawSingleOrder(order, state.from, state.to, context);
	          if (orderEl) {
	            DashboardCache.addOrderEl(state.from, state.to, order.id, orderEl);
	            ordersEl = union(ordersEl, orderEl);
	          }
	        } else {
	          if (DateUtils.isBefore(order.orderDate, state.from) || DateUtils.isAfter(order.brewDate, state.to)) {
	            //console.warn('WARNING: your are getting orders out of range of current range of dashbord');
	          } else {
	            orderEl = drawOrderEl(order, state.from, state.to, context);
	            if (orderEl) {
	              DashboardCache.addOrderEl(state.from, state.to, order.id, orderEl);
	              ordersEl = union(ordersEl, orderEl);
	            }
	          }
	        }
	      } else {
	        ordersEl = union(ordersEl, orderEl);
	      }
	
	      batchsEl = undefined;
	      if (ContentUtils.isEmptyArray(batchsEl)) {
	        batchsEl = drawBrewhouseBatchs(state, order, context);
	        if (ContentUtils.isNotEmptyArray(batchsEl)) {
	          DashboardCache.addBatchEl(state.from, state.to, order.id, batchsEl);
	          ordersEl = union(ordersEl, batchsEl);
	        }
	      } else {
	        ordersEl = union(ordersEl, batchsEl);
	      }
	    });
	
	    return ordersEl;
	  }
	}
	
	/**
	 * Create an UI elments of the order
	 * @argument order {Object} the order that we take all information about it.
	 * @argument from {String} the date from
	 * @argument to {String} the date to
	 */
	function drawOrderEl(order, from, to, context) {
	  var isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(OrderUtils.getTaskFromOrder(order));
	  var isOrderPartiallyOutSideOfDashboardRange = !OrderUtils.isOrderInRange(from, to, order);
	  var isOrderStatic = context.state.isGuestUser ? true : isOrderPartiallyOutSideOfDashboardRange ? true : !context.state.isAbleToEditDates;
	
	  var isVisibleBeerStyleLabelFermenting = context.state.isVisibleBeerStyleLabelFermenting;
	  var isVisibleBeerStyleLabelPackaging = context.state.isVisibleBeerStyleLabelPackaging;
	  var isClosedOrder = get(order, 'closed') === true;
	
	  if (!order.fermenterTank || !order.briteTank) {
	    //console.warn('***** ORDER TANK NULL:' + JSON.stringify(order));
	    return null;
	  }
	
	  if (!order.styleBeer) {
	    //console.warn('***** ORDER STYLE_BEER NULL:' + JSON.stringify(order));
	    return null;
	  }
	
	  var elements = [];
	
	  var fermenterHY = _calculateHY(from, to, order.brewDate, order.filtrationDate),
	      orderHY = _calculateHY(from, to, order.filtrationDate, order.orderDate);
	
	  var isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));
	
	  if (!fermenterHY && !orderHY) {
	    return elements;
	  }
	
	  var itemFiltered = get(context, 'state.filterItem');
	  var maxScopeInventoryDate = get(context, 'state.maxScopeInventoryDate');
	  var isCalculatingInventory = get(context, 'state.isCalculatingInventory');
	  var minDateInventory = get(context, 'state.minDateInventory');
	
	  // Fermenter tasks
	  var fermenterTasks = filter(order.fermenterTasks, function (task) {
	    return DateUtils.isAfterOrEquals(task.date, from) && DateUtils.isBeforeOrEquals(task.date, to);
	  });
	  var fermenterTasksSorted = DateUtils.sortListByDateField(fermenterTasks, 'date');
	  var fermenterTasksEl = map(fermenterTasksSorted, function (task) {
	    return drawIconAndLabel(order, task, from, 'FV', itemFiltered, maxScopeInventoryDate, isCalculatingInventory, minDateInventory);
	  });
	  var isSearchExpand = get(context, 'state.isSearchExpand') || get(context, 'state.isFilterModeActivated');
	  var fermenterIsHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(fermenterTasks, itemFiltered) : false;
	
	  // Packaging tasks
	  var packagingTasks = filter(order.packagingTasks, function (taskFilter) {
	    return DateUtils.isAfterOrEquals(taskFilter.date, from) && DateUtils.isBeforeOrEquals(taskFilter.date, to);
	  });
	  var packagingTasksSorted = DateUtils.sortListByDateField(packagingTasks, 'date');
	  var packagingTasksEl = map(packagingTasksSorted, function (task) {
	    return drawIconAndLabel(order, task, from, 'BT', itemFiltered, maxScopeInventoryDate, isCalculatingInventory, minDateInventory);
	  });
	  var packagingTasksIsHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(packagingTasks, itemFiltered) : false;
	
	  var isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
	  var className = isCurrentLastOrderChanged ? 'is-fermenter order-style is-last-order-changed' : 'is-fermenter order-style';
	  var classNameBT = isCurrentLastOrderChanged ? 'order-style is-last-order-changed' : 'order-style';
	
	  if (isOrderPartiallyOutSideOfDashboardRange) {
	    className += ' is-partially-out-side-of-dashboard';
	  }
	
	  if (fermenterHY && context.state.isVisibleFermentingSection) {
	    var xPosition = +order.fermenterTank.column;
	    elements.push(React.createElement("div", {
	      onDoubleClick: onDoubleClickOrder,
	      onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null,
	      onContextMenuCapture: openRightButtonContextMenu,
	      className: className + (fermenterIsHighLighted ? ' is-filter-active' : ''),
	      "data-tank-type": 'FV',
	      "data-x": xPosition,
	      "data-y": fermenterHY.y,
	      "data-first-date": "",
	      "data-some-product-confirmed": isSomeProductConfirmed,
	      "data-is-closed": isClosedOrder,
	      "data-first-short-date": "",
	      "data-last-date": "",
	      "data-last-short-date": "",
	      "data-order-id": order.id,
	      "data-batch-number": order.batchNumber,
	      "data-is-selected": isOrderSelected,
	      style: {
	        backgroundColor: get(order, 'styleBeer.color', ''),
	        opacity: '0.6',
	        transition: 'width 0s',
	        fontWeight: '600',
	        cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
	      },
	      ref: order.id,
	      key: order.id, // position: i
	      _grid: {
	        i: order.id,
	        minW: 1,
	        maxW: 1,
	        x: ContentUtils.getColumnsByCombinedOrderForFermenting(context.state, xPosition),
	        y: fermenterHY.y,
	        w: 1,
	        h: fermenterHY.h + 1,
	        batchNumber: get(order, 'batchNumber'),
	        static: isOrderStatic
	      } }, isVisibleBeerStyleLabelFermenting && React.createElement(OrderBeerStyleLabel, { order: order }), fermenterTasksEl));
	  }
	  if (orderHY && context.state.isVisiblePackagingSection) {
	    var _xPosition = +order.briteTank.column;
	    elements.push(React.createElement("div", {
	      onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null,
	      onDoubleClick: onDoubleClickOrder,
	      onContextMenuCapture: openRightButtonContextMenu,
	      className: classNameBT + (packagingTasksIsHighLighted ? ' is-filter-active' : ''),
	      "data-x": _xPosition,
	      "data-y": orderHY.y,
	      "data-tank-type": 'BT',
	      "data-some-product-confirmed": isSomeProductConfirmed,
	      "data-is-closed": isClosedOrder,
	      "data-first-date": "",
	      "data-first-short-date": "",
	      "data-last-date": "",
	      "data-last-short-date": "",
	      "data-order-id": order.id,
	      "data-batch-number": order.batchNumber,
	      "data-is-selected": isOrderSelected,
	      style: {
	        backgroundColor: get(order, 'styleBeer.color'),
	        opacity: '0.6',
	        transition: 'width 0s',
	        fontWeight: '600',
	        cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
	      },
	      ref: order.id + '_BT',
	      key: order.id + '_BT', // position: i
	      _grid: {
	        i: order.id + '_BT',
	        minW: 1,
	        maxW: 1,
	        x: ContentUtils.getColumnsByCombinedOrderForPackaging(context.state, _xPosition),
	        y: orderHY.y,
	        w: 1,
	        h: orderHY.h + 1,
	        batchNumber: get(order, 'batchNumber'),
	        static: isOrderStatic
	      } }, isVisibleBeerStyleLabelPackaging && React.createElement(OrderBeerStyleLabel, { order: order }), packagingTasksEl));
	  }
	
	  return elements;
	}
	
	var OrderBeerStyleLabel = React.createClass({ displayName: "OrderBeerStyleLabel",
	  render: function render() {
	    var order = this.props.order;
	
	    var shouldDark = ContentUtils.getColorByBgColor(get(order, 'styleBeer.color')).indexOf('#000') > -1;
	    return React.createElement("div", {
	      "data-first-date": "",
	      "data-first-short-date": "",
	      "data-last-date": "",
	      "data-last-short-date": "",
	      "data-order-id": order.id,
	      "data-batch-number": order.batchNumber,
	      style: {
	        color: shouldDark ? 'black' : 'white'
	      },
	      className: "beer-style-label" }, get(order, 'styleBeer.name'));
	  }
	});
	
	function getIconSize() {
	  var isOpenPackaging = UIStateStore.isPackagingNotesBarOpen();
	  var isBrewingNotesBarOpen = UIStateStore.isBrewingNotesBarOpen();
	
	  if (isBrewingNotesBarOpen && isOpenPackaging) {
	    return 'small';
	  }
	
	  if (!isBrewingNotesBarOpen && isOpenPackaging || isBrewingNotesBarOpen && !isOpenPackaging) {
	    return 'medium';
	  }
	
	  if (!isBrewingNotesBarOpen && !isOpenPackaging) {
	    return 'large';
	  }
	}
	
	function openContextMenuRightClick(tankClicked, order, evt) {
	  if (evt) {
	    // we need to stop propagation in order to avoid bubbling this event and will
	    // be captured with the listener of empty cell of Dashboard.
	    evt.stopPropagation();
	    // just avoid to show default context menu of browser.
	    evt.preventDefault();
	
	    AppDispatcher.dispatch({
	      type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
	      order: order,
	      tankClicked: tankClicked,
	      dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
	      positionX: evt.clientX,
	      positionY: evt.clientY,
	      isBrewingTankClicked: get(tankClicked, 'type') === 'BH'
	    });
	  }
	}
	
	function openRightButtonContextMenu(evt) {
	  var orderId = evt.currentTarget.getAttribute('data-order-id');
	  var orderSelected = OrderStore.getOrder(orderId);
	  var tankType = evt.currentTarget.getAttribute('data-tank-type');
	  var isSingle = evt.currentTarget.getAttribute('data-is-single');
	  var tankClicked = isSingle ? orderSelected.singleTank : tankType === 'FV' ? orderSelected.fermenterTank : orderSelected.briteTank;
	
	  openContextMenuRightClick(tankClicked, orderSelected);
	}
	
	function openContextMenuRightClickFromBrewhouse(tankClicked, order, evt) {
	  // we need to stop propagation in order to avoid bubbling this event and will
	  // be captured with the listener of empty cell of Dashboard.
	  //evt.stopPropagation();
	  // just avoid to show default context menu of browser.
	  evt.preventDefault();
	
	  if (!SessionStore.isAbleToEditDates()) {
	    Notification.show(t('dashboard_notification_dont_enough_permission_section'));
	  }
	
	  AppDispatcher.dispatch({
	    type: ActionTypes.RIGHT_DOUBLE_CLICK_DASHBOARD_OCCUPIED_BREWHOUSE,
	    order: order,
	    batchNumber: get(order, 'batchNumber'),
	    tankClicked: tankClicked,
	    dateClicked: ChronologycStore.getDateFromClientY(evt.clientY),
	    positionX: evt.clientX,
	    positionY: evt.clientY,
	    tankType: 'BH'
	  });
	}
	
	/**
	 * The event handler of click an order.
	 * NOTE: this method is required to set Dashboard Component context before to use it.
	 * @argument {Event} evt the event from the order.
	 */
	function onDoubleClickOrder(evt) {
	  ContextMenuEl.close();
	  evt.preventDefault();
	  evt.stopPropagation();
	  evt.nativeEvent.stopImmediatePropagation();
	
	  var isMobile = BrowserUtils.isMobileNonCareIPad();
	  if (isMobile) {
	    return;
	  }
	
	  var orderEl = ContentUtils.getComponentByAttribute(evt.target, 'data-tank-type');
	  var orderId = evt.currentTarget.getAttribute('data-order-id');
	  var orderSelected = OrderStore.getOrder(orderId);
	  var tankType = orderEl.getAttribute('data-tank-type');
	  var dateRow = ChronologycStore.getDateFromClientY(evt.clientY);
	  var tankClicked = DashboardStore.getTankFromClientX(evt.clientX);
	  var isFermenterTank = JSON.parse(orderEl.classList.contains('is-fermenter'));
	
	  // this are needed in order to complete position that currently are not visible
	
	  AppDispatcher.dispatch({
	    type: ActionTypes.LEFT_DOUBLE_CLICK_DASHBOARD_OCCUPIED,
	    existingOrderInfo: {
	      orderSelected: orderSelected,
	      tankClicked: tankClicked,
	      dateRow: dateRow,
	      isFermenterTank: isFermenterTank,
	      tankType: tankType
	    }
	  });
	}
	
	/**
	 * Clean orders selected.
	 * @param {HTMLElement} dashboardEl
	 */
	function _clearOrderSelected(dashboardEl) {
	  if (dashboardEl) {
	    var ordersSelectedEl = dashboardEl.querySelectorAll('div[data-is-selected=true]');
	    OrderStore.updateLastOrderUpdated(null);
	    if (ordersSelectedEl) {
	      forEach(ordersSelectedEl, function (el) {
	        el.classList.remove('animated');
	        el.setAttribute('data-is-selected', 'false');
	      });
	    }
	  }
	}
	
	/**
	 * Highlight given order id from the dashboard and update the dashboard component state.
	 * @param {HTMLElement} el          The order element that are selected.
	 * @param {String}      id          The order id. (Optionally)
	 * @private
	 */
	function _markOrders(el, id) {
	  if (!el) {
	    return;
	  }
	
	  var orderId = ContentUtils.cleanId(id || el.getAttribute('data-order-id')),
	      dashboardEl = ContentUtils.getComponentByClassName(el, 'react-grid-layout'),
	      ordersEl = void 0;
	
	  if (!dashboardEl) {
	    return;
	  }
	
	  // retrieve the order to take batch number
	  var order = OrderStore.getOrder(orderId);
	  OrderStore.updateLastOrderUpdated(order);
	
	  if (order && !order.batchNumber) {
	    ordersEl = dashboardEl.querySelectorAll('div[data-order-id="' + orderId + '"]');
	  } else if (order) {
	    ordersEl = dashboardEl.querySelectorAll('div[data-batch-number="' + order.batchNumber + '"]');
	  }
	
	  // Clean before selection order.
	  _clearOrdersSelection(el);
	
	  if (ordersEl && ordersEl.length > 0) {
	    forEach(ordersEl, function (el) {
	      //el.classList.add('selected');
	      el.classList.add('animated');
	      el.setAttribute('data-is-selected', 'true');
	    });
	  }
	}
	
	/**
	 * Clear all height light of the order in the dashboard.
	 * @param context
	 * @private
	 */
	function _clearOrdersSelection(context, onFinish) {
	  var dashboardEl = ContentUtils.getComponentByClassName(context, 'react-grid-layout');
	
	  if (dashboardEl) {
	    var lastElSelected = dashboardEl.querySelectorAll('div[data-is-selected=true]');
	    if (lastElSelected) {
	      forEach(lastElSelected, function (el) {
	        //el.classList.remove('selected');
	        el.classList.remove('animated');
	        el.setAttribute('data-is-selected', 'false');
	      });
	    }
	  }
	
	  if (onFinish) {
	    onFinish();
	  }
	}
	
	function drawBrewhouseBatchs(state, order, context) {
	  if (order && order.batchs) {
	    var batchsEl = [];
	    // in case which some product are confirmed, the order will be frizzed
	
	    forEach(order.batchs, function (batch) {
	      var tankHY = _calculateHY(state.from, state.to, batch.date, batch.date);
	      var isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(batch);
	      var isStaticOrder = DashboardStore.isPublishingDraft() || isSomeProductConfirmed || !context.state.isAbleToEditDates;
	      if (tankHY && state.isVisibleBrewingSection) {
	        batchsEl.push(_drawBatch(state, order, tankHY, batch, state.from, context, isStaticOrder, isSomeProductConfirmed));
	      }
	    });
	    return batchsEl;
	  }
	}
	
	function drawIconAndLabel(order, task, fromDashboard, tankType, itemFiltered, maxScopeInventoryDate, isCalculatingInventory, minDateInventory) {
	  if (!order || !task) {
	    return;
	  }
	
	  // The vertical distance of pixels from date reference to the icon & label position.
	  var iconYPosition = _getYIconPosition(task, order, fromDashboard, tankType);
	
	  // display elements
	  var isHighlighted = DateUtils.isAfter(task.date, minDateInventory) && isCalculatingInventory ? InventoryStore.someItemsExistInGivenTask(task, itemFiltered) : false;
	  var labelEl = _getIconLabel(task, order, iconYPosition, tankType);
	  var iconEl = SessionStore.isFullPaidVersion() && isCalculatingInventory ? _getIconEl(task, order, iconYPosition, tankType, isHighlighted, maxScopeInventoryDate) : _getIconElFreeVersion(task, order, iconYPosition, tankType);
	
	  var _ref2 = isCalculatingInventory ? InventoryStore.getTotalAmountReservedByItem(task, ContentUtils.getItemId(itemFiltered)) : {
	    amountItemReserved: 0,
	    amountItemNeeded: 0
	  },
	      amountSubtracted = _ref2.amountSubtracted,
	      amountItemNeeded = _ref2.amountItemNeeded,
	      amountPurchased = _ref2.amountPurchased;
	
	  return React.createElement("div", { className: "order-icon" }, isHighlighted && NumberUtils.isGreater(amountItemNeeded, 0) ? getInventoryMissingStatusEL(get(itemFiltered, 'description'), amountItemNeeded, iconYPosition) : null, isHighlighted && NumberUtils.isGreater(amountSubtracted, 0) ? getInventoryStatusEL(get(itemFiltered, 'description'), amountSubtracted, iconYPosition) : null, isHighlighted && NumberUtils.isGreater(amountPurchased, 0) ? getInventoryRequestedStatusEL(get(itemFiltered, 'description'), amountPurchased, iconYPosition) : null, React.createElement("div", { className: "order-icon-top" }, labelEl), React.createElement("div", { className: "order-icon-bottom" }, iconEl));
	}
	
	function getInventoryStatusEL(itemDescription, amount, iconYPosition) {
	  return React.createElement("span", { className: "order-icon-inventory-status" }, React.createElement("span", { className: "order-icon-inventory-status__amount",
	    style: {
	      transform: 'translateY(' + iconYPosition + ')'
	    }
	  }, amount));
	}
	
	function getInventoryMissingStatusEL(itemDescription, amount, iconYPosition) {
	  return React.createElement("span", { className: "order-icon-inventory-status" }, React.createElement("span", { className: "order-icon-inventory-missing-status__amount",
	    style: {
	      transform: 'translateY(' + iconYPosition + ')'
	    }
	  }, amount));
	}
	
	function getInventoryRequestedStatusEL(itemDescription, amount, iconYPosition) {
	  return React.createElement("span", { className: "order-icon-inventory-status" }, React.createElement("span", { className: "order-icon-inventory-requested-status__amount",
	    style: {
	      transform: 'translateY(' + iconYPosition + ')'
	    }
	  }, amount));
	}
	
	function _getYIconPosition(task, order, fromDashboard, tankType) {
	  var isBrewingBatch = tankType === 'BH' && task.turnId;
	  if (isBrewingBatch) {
	    // enter here means is the batch so don't more than 1 row height
	    return '0px';
	  }
	
	  // the first date of the order an generic way
	  var fromDate = ContentUtils.getOrderField(order, 'startDate', tankType);
	
	  // ask which is first date top of the order or top of dashboard visible (in case as partial show order)
	  var dateReference = DateUtils.isBefore(fromDate, fromDashboard) ? fromDashboard : fromDate;
	
	  // calculate the amount of days of the order
	  var daysRangeFromTask = DateUtils.getDaysBetween(dateReference, task.date);
	
	  var iconYPosition = daysRangeFromTask * ROW_HIGHT + 'px';
	  return iconYPosition;
	}
	
	function _getIconLabel(icon, order, iconYPosition, tankType) {
	  return icon.label ? React.createElement("i", { className: "order-icon-top-label",
	    "data-tank-type": tankType,
	    "data-order-id": order.id,
	    "data-batch-number": order.batchNumber,
	    style: {
	      transform: 'translateY(' + iconYPosition + ')',
	      width: 'inherit !important'
	    } }, icon.label) : null;
	}
	
	function _getIconEl(task, order, iconYPosition, tankType, isIconHighLighted, maxScopeInventoryDate) {
	  var iconInfo = _getIconInfo(tankType, task);
	  var iconClassName = get(iconInfo, 'icon.icon') + ' ' + get(iconInfo, 'iconClassName');
	  var isEnoughStockItems = task.someItemsIsNotEnoughInStock === false;
	  var haveEnoughPurchaseItem = task.someItemsIsNotEnoughInPurchase === false;
	  return iconClassName ? React.createElement("span", {
	    className: 'dashboard-icon stop-dragging filtration-icon center-icon-small text-center icon-task ' + iconClassName + (isIconHighLighted ? ' is-icon-highlighted' : ''),
	    "data-order-id": order.id,
	    "data-batch-number": order.batchNumber,
	    "data-dashboard-width": getIconSize(),
	    "data-is-inventory-task": InventoryStore.haveAProducts(task),
	    "data-inventory-status-icon-state": InventoryStore.getInventoryStatusFromTask(task, maxScopeInventoryDate),
	    "data-is-inventory-scheduled": isEnoughStockItems,
	    "data-is-already-purchase-items": haveEnoughPurchaseItem,
	    style: {
	      transform: 'translateY(' + iconYPosition + ')',
	      width: 'inherit !important',
	      visibility: task.name === TASK_NON_VISIBLE ? 'hidden' : 'inherit'
	    }
	  }) : null;
	}
	
	function _getIconElFreeVersion(task, order, iconYPosition, tankType) {
	  var iconInfo = _getIconInfo(tankType, task);
	  var iconClassName = get(iconInfo, 'icon.icon') + ' ' + get(iconInfo, 'iconClassName');
	  return iconClassName ? React.createElement("span", {
	    className: 'dashboard-icon stop-dragging icon-task filtration-icon center-icon-small text-center ' + iconClassName,
	    "data-order-id": order.id,
	    "data-batch-number": order.batchNumber,
	    "data-dashboard-width": getIconSize(),
	    style: {
	      transform: 'translateY(' + iconYPosition + ')',
	      width: 'inherit !important',
	      visibility: task.name === TASK_NON_VISIBLE ? 'hidden' : 'inherit'
	    }
	  }) : null;
	}
	
	function _getIconInfo(tankType, task) {
	  return DashboardServiceCache.hydrateWithIcon(task, tankType, 'dashboard', tankType === 'FV' ? DashboardServiceCache.getFermenterIconsWithLegacy() : tankType === 'BT' ? DashboardServiceCache.getPackagingIconsWithLegacy() : DashboardServiceCache.getBrewhouseIconsWithLegacy());
	}
	
	function isStaticBatchOrder(isStaticOrder, order, self) {
	  return isStaticOrder || DashboardStore.isPublishingDraft() ? true : get(order, 'closed') ? true : SessionStore.isAdminUser() ? false : true;
	}
	
	function _drawBatch(state, order, tankHY, batch, from, self, isStaticOrder, isSomeProductConfirmed) {
	  var isVisibleBeerStyleLabelBrewing = state.isVisibleBeerStyleLabelBrewing;
	  var isStatic = state.isGuestUser ? true : isStaticBatchOrder(isStaticOrder, order, self);
	  order.isBHAllowed = true; // just to be sure, set isBHAllowed in true otherwise this drawing operation not make sense.
	  order.currentSection = 'BH'; // just to open tab of order modal properly
	  var column = +get(batch, 'turn.column');
	  var isClosedOrder = get(order, 'closed');
	  var currentTank = DashboardServiceCache.getTankByColumn(column);
	  var orderId = order.id;
	  var orderIdWithPrefix = order.id + '_BH';
	  var tankType = 'BH';
	  // This is necessary because react grid layout set new positions when
	  // you do double click, and will cause side effects
	  self.positions.stop = null;
	  self.positions.start = null;
	
	  var isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));
	  var className = isCurrentLastOrderChanged ? 'order-style is-last-order-changed' : 'order-style';
	
	  // draw the icon and label elements
	  var filterItem = get(state, 'filterItem');
	  var iconEl = drawIconAndLabel(order, batch, from, tankType, filterItem, state.maxScopeInventoryDate, state.isCalculatingInventory, state.minDateInventory);
	
	  var onRightClick = function onRightClick(evt) {
	    openContextMenuRightClickFromBrewhouse(currentTank, order, evt);
	  }; // do nothing in brewhouse section
	
	  var isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
	  var isSearchExpand = get(state, 'isSearchExpand') || get(state, 'isFilterModeActivated');
	  var isHighLighted = isSearchExpand ? InventoryStore.isSomeItemInTasks(get(order, 'batchs'), filterItem) : false;
	
	  return React.createElement("div", {
	    onDoubleClick: onDoubleClickOrder,
	    onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null,
	    className: className + (isHighLighted ? ' is-filter-active' : ''),
	    onContextMenuCapture: onRightClick,
	    "data-tank-type": tankType,
	    "data-some-product-confirmed": isSomeProductConfirmed,
	    "data-is-closed": isClosedOrder,
	    "data-first-date": "",
	    "data-first-short-date": "",
	    "data-last-date": "",
	    "data-last-short-date": "",
	    "data-order-id": orderId,
	    "data-x": column,
	    "data-y": tankHY.y,
	    "data-batch-number": order.batchNumber,
	    "data-is-selected": isOrderSelected,
	    style: {
	      backgroundColor: get(order, 'styleBeer.color'),
	      opacity: '0.6',
	      transition: 'width 0s',
	      fontWeight: '600',
	      cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
	    },
	    key: orderIdWithPrefix + '|' + column + '|' + batch.date,
	    _grid: {
	      verticalCompact: true,
	      isResizable: false,
	      // initialize in false this flag, because will be useful when
	      // need to know in Brewhouse store, which position are already
	      // re-located, in order to know if are available that position
	      // or not.
	      isRelocated: false,
	      minW: 1,
	      maxW: 1,
	      x: column,
	      y: tankHY.y,
	      w: 1,
	      h: tankHY.h + 1,
	      i: orderId,
	      batchNumber: get(order, 'batchNumber'),
	      static: isStatic
	    }
	  }, isVisibleBeerStyleLabelBrewing && React.createElement(OrderBeerStyleLabel, { order: order }), iconEl);
	}
	
	function drawSingleOrder(order, from, to, context) {
	  var isSomeProductConfirmed = OrderUtils.haveSomeProductConfirmed(OrderUtils.getTaskFromOrder(order));
	  var isOrderPartiallyOutSideOfDashboardRange = !OrderUtils.isOrderInRange(from, to, order);
	  var isStatic = context.state.isGuestUser ? true : isOrderPartiallyOutSideOfDashboardRange ? true : !context.state.isAbleToEditDates;
	
	  var isVisibleBeerStyleLabelFermenting = context.state.isVisibleBeerStyleLabelFermenting;
	  var isVisibleBeerStyleLabelPackaging = context.state.isVisibleBeerStyleLabelPackaging;
	
	  if (!order.singleTank) {
	    //console.warn('***** SINGLE ORDER TANK NULL:' + JSON.stringify(order));
	    return null;
	  }
	  var elements = [],
	      tankHY = _calculateHY(from, to, order.fromDate, order.toDate);
	
	  if (!tankHY) {
	    return elements;
	  }
	
	  var isCurrentLastOrderChanged = ContentUtils.cleanId(order.id) === ContentUtils.cleanId(get(OrderStore.getLastOrderUpdate(), 'id'));
	  order.currentSection = get(order, 'singleTank.type');
	
	  var tankType = get(order, 'singleTank.type'),
	      tankTypeConfiguration = ContentUtils.getTankTypeConfiguration(tankType);
	
	  var itemFiltered = get(context, 'state.filterItem');
	  var singleIcons = filter(order.singleTasks, function (taskFilter) {
	    return DateUtils.isAfterOrEquals(taskFilter.date, from) && DateUtils.isBeforeOrEquals(taskFilter.date, to);
	  });
	  var singleIconsSorted = DateUtils.sortListByDateField(singleIcons, 'date');
	  var singleIconsEl = map(singleIconsSorted, function (singleTask) {
	    return drawIconAndLabel(order, singleTask, from, order.currentSection, get(context, 'state.filterItem'), get(context, 'state.maxScopeInventoryDate'), get(context, 'state.isCalculatingInventory'), get(context, 'state.minDateInventory'));
	  });
	  var className = tankTypeConfiguration.className + ' order-style';
	  var isHighLighted = get(context, 'state.isSearchExpand') || get(context, 'state.isFilterModeActivated') ? InventoryStore.isSomeItemInTasks(order.singleTasks, itemFiltered) : false;
	
	  if (isCurrentLastOrderChanged) {
	    className += ' is-last-order-changed';
	  }
	
	  if (isOrderPartiallyOutSideOfDashboardRange) {
	    className += ' is-partially-out-side-of-dashboard';
	  }
	
	  var isClosedOrder = get(order, 'closed') === true;
	  var isOrderSelected = order.id === get(OrderStore.getLastOrderUpdate(), 'id');
	  var elID = order.id + get(tankTypeConfiguration, 'postFix');
	
	  var _context$state = context.state,
	      isVisibleBrewingSection = _context$state.isVisibleBrewingSection,
	      isVisibleFermentingSection = _context$state.isVisibleFermentingSection,
	      isVisiblePackagingSection = _context$state.isVisiblePackagingSection;
	
	
	  if (isVisibleBrewingSection && tankType === 'BH' || isVisibleFermentingSection && tankType === 'FV' || isVisiblePackagingSection && tankType === 'BT') {
	
	    var column = ContentUtils.getNewColumnSingleBySection(order, context.state.tanks, {
	      isVisibleBrewingSection: isVisibleBrewingSection,
	      isVisibleFermentingSection: isVisibleFermentingSection,
	      isVisiblePackagingSection: isVisiblePackagingSection
	    });
	
	    elements.push(React.createElement("div", {
	      onContextMenuCapture: openRightButtonContextMenu,
	      onDoubleClick: onDoubleClickOrder,
	      onTouchTap: BrowserUtils.isIpad() ? onDoubleClickOrder : null,
	      className: className + (isHighLighted ? ' is-filter-active' : ''),
	      "data-tank-type": tankType,
	      "data-first-date": "",
	      "data-some-product-confirmed": isSomeProductConfirmed,
	      "data-is-closed": isClosedOrder,
	      "data-first-short-date": "",
	      "data-last-date": "",
	      "data-is-single": true,
	      "data-last-short-date": "",
	      "data-order-id": order.id,
	      "data-volume": order.volume,
	      "data-is-selected": isOrderSelected,
	      "data-batch-number": order.batchNumber,
	      style: {
	        backgroundColor: get(order, 'styleBeer.color'),
	        opacity: '0.6',
	        transition: 'width 0s',
	        fontWeight: '600',
	        cursor: SessionStore.isAbleToEditDates() ? 'pointer' : 'default'
	      },
	      ref: elID,
	      key: elID,
	      _grid: {
	        minW: 1,
	        maxW: 1,
	        x: column,
	        y: tankHY.y,
	        w: 1,
	        h: tankHY.h + 1,
	        i: elID,
	        batchNumber: get(order, 'batchNumber'),
	        volume: get(order, 'volume'),
	        static: isStatic
	      }
	    }, tankType === 'FV' && isVisibleBeerStyleLabelFermenting && React.createElement(OrderBeerStyleLabel, { order: order }), tankType === 'BT' && isVisibleBeerStyleLabelPackaging && React.createElement(OrderBeerStyleLabel, { order: order }), singleIconsEl));
	  }
	
	  return elements;
	}
	
	function getToggleShowInventoryButtonEl(isPublishButtonVisible, isSearchExpand, iconDisableShowInventory) {
	  return React.createElement("div", { className: "btn-calculate-inventory with-opacity" }, React.createElement(FloatingActionButton, {
	    ref: "btnSearch",
	    onClick: this._onToggleCalculateInventory,
	    className: "btn-right-upload btn-search with-opacity hidden-xs",
	    iconClassName: "muidocs-icon-action-grade",
	    backgroundColor: this.state.isCalculatingInventory ? '#0288d1' : '#B3B3B3' }, iconDisableShowInventory));
	}
	
	/**
	 * Calculate the first position of date (the vertical initial position, `Y`) and their height (`H`) in the current layout of dashboard.
	 *
	 * @param {StringDate} from          The first current date that show the dashboard.
	 * @param {StringDate} to            The last current date that show the dashboard.
	 * @param {StringDate} fromBox       The current from target date.
	 * @param {StringDate} toBox         The current to target date.
	 * @returns {{y: *, h: *}}
	 * @private
	 */
	function _calculateHY(from, to, fromBox, toBox) {
	  var i = -1,
	      y,
	      h,
	      dateValidate,
	      firstDate = DateUtils.toDate(from);
	
	  if (DateUtils.isBefore(toBox, from) || DateUtils.isAfter(fromBox, to)) {
	    // Enter here means that this part of the order should not be render because is out of range of dashboard.
	    return null;
	  }
	
	  while (true) {
	    i++;
	    dateValidate = DateUtils.addDaysTextBasicFormat(firstDate, i);
	    if (fromBox === dateValidate) {
	      y = i;
	    }
	
	    if (toBox === dateValidate || DateUtils.isAfter(dateValidate, to) || DateUtils.isEqual(dateValidate, to)) {
	      if (!y) {
	        // Enter here means that boxFrom is before of dashboard 'from', so we define the first position of dashboard
	        // in order to draw only a part of the order.
	        y = 0;
	      }
	
	      h = i - y;
	      break;
	    }
	  }
	
	  if (!h) {
	    // Enter here means that toBox date is after of dashboard range 'to'.
	    h = i - y;
	  }
	
	  return {
	    y: y,
	    h: h
	  };
	}
	
	function onClickTryProVersion() {
	  var self = this;
	  DashboardServiceImpl.changeFreeToProVersion(function () {
	    delay(function () {
	      DashboardActionCreators.forceReFetchAndRenderDashboard(self.state.from, self.state.to);
	      window.location.reload(true);
	    }, 1000);
	  });
	}
	
	module.exports = Dashboard;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    mui = __webpack_require__(12),
	    CardText = mui.CardText;
	
	
	var DashboardSpinner = React.createClass({ displayName: "DashboardSpinner",
	
	    getInitialState: function getInitialState() {
	        return {
	            isVisible: false
	        };
	    },
	    show: function show() {
	        this.setState({
	            isVisible: true
	        });
	    },
	    hide: function hide() {
	        this.setState({
	            isVisible: false
	        });
	    },
	    isVisible: function isVisible() {
	        return this.state.isVisible;
	    },
	    render: function render() {
	        var el = this.state.isVisible ? React.createElement(CardText, { className: "dashboard-spinner", zDepth: 1, style: {
	                zIndex: '20',
	                fontSize: '15px',
	                position: 'fixed',
	                right: '1px',
	                marginRight: '90px',
	                float: 'right',
	                bottom: '16px',
	                boxShadow: 'none !important',
	                backgroundColor: '#fff !important',
	                borderRadius: '50%',
	                margin: '0px',
	                padding: '37px'
	            } }) : null;
	
	        return el;
	    }
	});
	
	module.exports = DashboardSpinner;

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var _require = __webpack_require__(4),
	    t = _require.t;
	
	__webpack_require__(1359);
	
	var DashboardViewOnlyIndicator = React.createClass({ displayName: "DashboardViewOnlyIndicator",
	    render: function render() {
	        var isAllSectionActive = this.props.isAllSectionActive;
	
	        return React.createElement("div", { className: "bp-dashboard-view-only-indicator" }, isAllSectionActive ? t('label_view_only_mode') : t('label_not_drag_mode'));
	    }
	});
	
	module.exports = DashboardViewOnlyIndicator;

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1360);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    mui = __webpack_require__(12),
	    RaisedButton = mui.RaisedButton;
	
	
	var About = React.createClass({ displayName: "About",
	
	    handlerClick: function handlerClick() {
	        window.location = apiAppUrl + '/#/login';
	    },
	
	    render: function render() {
	        return React.createElement("div", { className: "welcome-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h1", { className: "welcome-page-container__header light" }, "Your email has been confirmed. Welcome to BrewPlanner!"), React.createElement("div", { className: "welcome-page-container__body" }, React.createElement("p", null, t('welcome_message_help_you_planning')), React.createElement("br", null), React.createElement("p", null, t('welcome_check_out_video_tutorials'), ' ', React.createElement("a", {
	            target: "_blank",
	            href: "http://www.brewplanner.com/videos"
	        }, t('welcome_label_here')), ' ' + t('welcome_get_started'))), React.createElement("br", null), React.createElement("div", { className: "welcome-page-container__start-button" }, React.createElement(RaisedButton, {
	            label: t('welcome_label_start'),
	            primary: true,
	            onTouchTap: this.handlerClick })), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("img", {
	            style: { height: '60px' },
	            src: "/assets/images/logo-small-dark.png" })));
	    }
	});
	
	module.exports = About;

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    moment = __webpack_require__(3),
	    SessionStore = __webpack_require__(11),
	    FontIcon = __webpack_require__(118),
	    PositionUtil = __webpack_require__(59),
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    ga = __webpack_require__(18),
	    packageJson = __webpack_require__(312);
	
	
	var Help = React.createClass({ displayName: "Help",
	
	  componentDidMount: function componentDidMount() {
	    ga.pageview('/help');
	  },
	  goToLink: function goToLink(refName, evt) {
	    var _this = this;
	
	    evt.preventDefault();
	    evt.stopPropagation();
	
	    delay(function () {
	      var scrollTop = PositionUtil.elementScrollTop(_this.refs[refName].getDOMNode());
	      PositionUtil.scrollTo(scrollTop + -110);
	    }, 350); // timeout to show effect transition return
	  },
	
	
	  render: function render() {
	    return React.createElement("div", { className: 'bp-support-page' + (SessionStore.isFullPaidVersion() ? '' : ' is-free-version') }, React.createElement("div", { className: "bp-support-page__head" }, React.createElement("div", { className: "bp-support-page__header" }, React.createElement("h1", { className: "bp-support-page__header-title" }, t('help_title'))), React.createElement("div", { className: "bp-support-page__header-subtitle" }, t('help_subtitle'))), React.createElement("div", { className: "bp-support-page__body" }, React.createElement("div", { className: "bp-support-page__question-content row" }, React.createElement("a", { target: "_blank", href: "http://www.brewplanner.com/videos",
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_subtitle_video_tutorials')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "ondemand_video")), React.createElement("a", { target: "_blank", href: "http://www.brewplanner.com/faq",
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_frequently_questions')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "ring_volume")), React.createElement("a", { className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12",
	      href: "mailto:support@brewplanner.com?Subject=Need%20help",
	      target: "_top" }, React.createElement("h1", null, t('help_contact_us')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "mail_outline")), React.createElement("article", { onClick: this.goToLink.bind(this, 'gettingStarted'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_getting_started')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "tag_faces")), React.createElement("article", { onClick: this.goToLink.bind(this, 'tankAndSection'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_assign_tanks_sections')), React.createElement(FontIcon, { className: "icon-tanks-page" })), React.createElement("article", { onClick: this.goToLink.bind(this, 'assignBeerStyle'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", { className: "bp-support-page__question-box-title" }, t('help_assign_beer_styles')), React.createElement(FontIcon, { className: "icon-beer-style-page" })), React.createElement("article", { onClick: this.goToLink.bind(this, 'settingProcess'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_setting_processes')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "settings")), React.createElement("article", { onClick: this.goToLink.bind(this, 'scheduleBrew'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_schedule_a_brew')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "watch_later")), React.createElement("article", { onClick: this.goToLink.bind(this, 'batchNumber'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_batch_numbers')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "exposure_plus_1")), React.createElement("article", { onClick: this.goToLink.bind(this, 'scenarios'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_possible_scenarios')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "developer_board")), React.createElement("article", { onClick: this.goToLink.bind(this, 'iconLabelAndProcess'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_icons_labels_processes')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "device_hub")), React.createElement("article", { onClick: this.goToLink.bind(this, 'notes'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('notes')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "note_add")), React.createElement("article", { onClick: this.goToLink.bind(this, 'messages'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('messages')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "sms")), React.createElement("article", { onClick: this.goToLink.bind(this, 'changeOrder'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('help_make_changes_to_an_order')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "mode_edit")), React.createElement("article", { onClick: this.goToLink.bind(this, 'display'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('display')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "tv")), React.createElement("article", { onClick: this.goToLink.bind(this, 'publish'),
	      className: "bp-support-page__question-box col-md-3 col-sm-4 col-xs-12" }, React.createElement("h1", null, t('publish')), React.createElement(FontIcon, { className: "material-icons material-icons--custom" }, "cloud_upload")))), React.createElement("hr", { className: "bp-support-page__separator" }), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "gettingStarted", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_getting_started'), ":")), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_getting_started_description_1')), React.createElement("li", null, t('help_getting_started_description_part_2')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "tankAndSection", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_assign_tanks_sections'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_assign_tanks_sections_part_1')), React.createElement("li", null, t('help_assign_tanks_sections_part_2')), React.createElement("li", null, t('help_assign_tanks_sections_part_3')), React.createElement("li", null, t('help_assign_tanks_sections_part_4')), React.createElement("li", null, t('help_assign_tanks_sections_part_5')), React.createElement("li", null, t('help_assign_tanks_sections_part_6')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "assignBeerStyle", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_assign_beer_styles'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_assign_beer_styles_description_part_1')), React.createElement("li", null, t('help_assign_beer_styles_description_part_2')), React.createElement("li", null, t('help_assign_beer_styles_description_part_3')), React.createElement("li", null, t('help_assign_beer_styles_description_part_4')), React.createElement("li", null, t('help_assign_beer_styles_description_part_5')), React.createElement("li", null, t('help_assign_beer_styles_description_part_6')), React.createElement("li", null, t('help_assign_beer_styles_description_part_7')), React.createElement("li", null, t('help_assign_beer_styles_description_part_8')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "settingProcess", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_setting_processes'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_setting_processes_description_part_1')), React.createElement("li", null, t('help_setting_processes_description_part_2')), React.createElement("li", null, t('help_setting_processes_description_part_3')), React.createElement("li", null, t('help_setting_processes_description_part_4')), React.createElement("li", null, t('help_setting_processes_description_part_5')), React.createElement("li", null, t('help_setting_processes_description_part_6')), React.createElement("li", null, t('help_setting_processes_description_part_7')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "scheduleBrew", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_schedule_a_brew'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_schedule_a_brew_description_part_1')), React.createElement("li", null, t('help_schedule_a_brew_description_part_2')), React.createElement("li", null, t('help_schedule_a_brew_description_part_3')), React.createElement("li", null, t('help_schedule_a_brew_description_part_4')), React.createElement("li", null, t('help_schedule_a_brew_description_part_5')), React.createElement("li", null, t('help_schedule_a_brew_description_part_6')), React.createElement("li", null, t('help_schedule_a_brew_description_part_7')), React.createElement("li", null, t('help_schedule_a_brew_description_part_8')), React.createElement("li", null, t('help_schedule_a_brew_description_part_9')), React.createElement("li", null, t('help_schedule_a_brew_description_part_10')), React.createElement("li", null, t('help_schedule_a_brew_description_part_11')), React.createElement("li", null, t('help_schedule_a_brew_description_part_12')), React.createElement("li", null, t('help_schedule_a_brew_description_part_13')), React.createElement("li", null, t('help_schedule_a_brew_description_part_14')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "batchNumber", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_batch_numbers'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_batch_numbers_description_part_1')), React.createElement("li", null, t('help_batch_numbers_description_part_2')), React.createElement("li", null, t('help_batch_numbers_description_part_3')), React.createElement("li", null, t('help_batch_numbers_description_part_4')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "scenarios", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_possible_scenarios'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_possible_scenarios_description_part_1')), React.createElement("li", null, t('help_possible_scenarios_description_part_2')), React.createElement("li", null, t('help_possible_scenarios_description_part_3')), React.createElement("li", null, t('help_possible_scenarios_description_part_4')), React.createElement("li", null, t('help_possible_scenarios_description_part_5')), React.createElement("li", null, t('help_possible_scenarios_description_part_6')), React.createElement("li", null, t('help_possible_scenarios_description_part_7')), React.createElement("li", null, t('help_possible_scenarios_description_part_8')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "iconLabelAndProcess", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_icons_labels_processes'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_icons_labels_processes_description_part_1')), React.createElement("li", null, t('help_icons_labels_processes_description_part_2')), React.createElement("li", null, t('help_icons_labels_processes_description_part_3')), React.createElement("li", null, t('help_icons_labels_processes_description_part_4')), React.createElement("li", null, t('help_icons_labels_processes_description_part_5')), React.createElement("li", null, t('help_icons_labels_processes_description_part_6')), React.createElement("li", null, t('help_icons_labels_processes_description_part_7')), React.createElement("li", null, t('help_icons_labels_processes_description_part_8')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "notes", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_notes_title'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_notes_description_part_1')), React.createElement("li", null, t('help_notes_description_part_2')))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "messages", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_messages_title'))), React.createElement("p", { className: "bp-support-page__comment-text" }, t('help_messages_description'))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "changeOrder", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_make_changes_to_an_order'))), React.createElement("ol", { className: "bp-support-page__comment-text" }, React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_1')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_2')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_3')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_4')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_5')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_6')), React.createElement("li", null, t('help_make_changes_to_an_orde_description_part_7'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_8'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_9'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_10'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_11'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_12'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_13'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_14'), React.createElement("br", null), t('help_make_changes_to_an_orde_description_part_15'), React.createElement("br", null)))), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "display", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_display_title'))), React.createElement("p", { className: "bp-support-page__comment-text" }, t('help_display_description'))), React.createElement("br", null), React.createElement("div", { className: "bp-support-page__comment" }, React.createElement("h2", { ref: "publish", className: "bp-support-page__comment-title" }, React.createElement("strong", null, t('help_publish_title'))), React.createElement("p", { className: "bp-support-page__comment-text" }, t('help_publish_description_part_1')), React.createElement("p", { className: "bp-support-page__comment-text" }, t('help_publish_description_part_2'), React.createElement("a", {
	      href: "mailto:support@brewplanner.com?Subject=Need%20help",
	      target: "_top" }, "support@brewplanner.com"), ".")), React.createElement("div", { className: "bp-support-page__footer" }, React.createElement("hr", null), React.createElement("div", { className: "bp-support-page__footer-signature" }, t('thank_you'), React.createElement("br", null), t('confirm_new_password_static_page_greeting'), React.createElement("br", null), React.createElement("small", null, React.createElement("a", { href: "http://www.brewplanner.com",
	      target: "_top" }, "www.Brewplanner.com"))), React.createElement("hr", { className: "bp-support-page__footer-separator" }), React.createElement("div", { className: "bp-support-page__footer-legal" }, "Copyright © ", moment().format('YYYY'), " Brewplanner" + ' ' + "LLC.", React.createElement("i", { className: "bp-support-page__footer-legal-version" }, 'v' + packageJson.version)), React.createElement("br", null)));
	  }
	});
	
	module.exports = Help;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    CustomDialog = __webpack_require__(26),
	    SessionStore = __webpack_require__(11),
	    HistoryStore = __webpack_require__(410),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    Loading = __webpack_require__(33),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    _require2 = __webpack_require__(8),
	    find = _require2.find,
	    filter = _require2.filter,
	    map = _require2.map,
	    DateUtils = __webpack_require__(22),
	    get = __webpack_require__(5).get,
	    NavigationUtils = __webpack_require__(35),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    HistoryModal = __webpack_require__(764),
	    AppConstants = __webpack_require__(2),
	    ga = __webpack_require__(18);
	
	
	var HistoryAdmin = React.createClass({ displayName: "HistoryAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        var selectedModule = NavigationUtils.getQueryParam('selected-module');
	        if (selectedModule) {
	            selectedModule = find(AppConstants.APP_MODULES, function (module) {
	                return module.name === selectedModule;
	            });
	        }
	        return {
	            selectedModule: selectedModule,
	            selectedItem: null,
	            isEditMode: false
	        };
	    },
	
	
	    _modalEl: null,
	
	    componentDidMount: function componentDidMount() {
	        this.fetchHistorys();
	        ga.pageview('/history-admin');
	    },
	    fetchHistorys: function fetchHistorys() {
	        var self = this;
	        HistoryStore.fetchHistories(function (histories) {
	            self.setState({
	                histories: self._customHydration(histories)
	            });
	        });
	    },
	    _customHydration: function _customHydration(histories) {
	        return map(histories, function (history) {
	            return history;
	        });
	    },
	    _onDeleteBeerStyle: function _onDeleteBeerStyle(tank, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('history_admin_confirm_delete_history'), function () {
	            HistoryStore.deleteStyleBeer(tank, onSuccess, onFailure);
	        });
	    },
	    _onChangeBeerStyle: function _onChangeBeerStyle(tank, onSuccess, onFailure) {
	        HistoryStore.changeStyleBeer(tank, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition) {
	        var _this = this;
	
	        this.setState(function (prevState) {
	            return {
	                selectedItem: item,
	                isEditMode: !prevState.isEditMode
	            };
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    _formatRowChanges: function _formatRowChanges(changes) {
	        return map(changes, function (change) {
	            change.dateDisplay = DateUtils.toYYYYMMDDhhmm(change.date);
	            return change;
	        });
	    },
	    _onChangeModule: function _onChangeModule() {
	        this.setState({
	            selectedModule: get(arguments, '2.itemModel')
	        });
	    },
	    _openMoreDetail: function _openMoreDetail() {
	        this._modalEl.show();
	    },
	    render: function render() {
	        var _this2 = this;
	
	        if (!this.state.histories) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('history_admin_change_success_message'),
	                changeFailureMessage: t('history_admin_change_failure_message'),
	                deleteSuccessMessage: t('history_admin_delete_success_message'),
	                addSuccessMessage: t('history_admin_add_success_message'),
	                addFailureMessage: t('history_admin_add_failure_message')
	            };
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                selectedModule = _state.selectedModule,
	                histories = _state.histories;
	
	            var contextHolder = this.getContextHolderInstance();
	            var filteredHistories = find(histories, function (history) {
	                return history.module === get(selectedModule, 'name');
	            });
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                el: React.createElement(FormGroupButton, {
	                    label: t('history_admin_label_show_more_detail'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._openMoreDetail.bind(this, selectedItem) })
	            }];
	
	            var formFieldsEl = [React.createElement(FormGroupDropdown, {
	                items: filter(AppConstants.APP_MODULES, function (module) {
	                    return !module.isDisabled;
	                }),
	                operationsHolder: contextHolder,
	                displayAttribute: "displayName",
	                readerAttribute: "displayName",
	                writerAttribute: "displayName",
	                name: t('label_modules'),
	                value: selectedModule,
	                isEditMode: selectedItem !== undefined,
	                onChange: this._onChangeModule })];
	
	            return React.createElement("div", { className: "bp-history-admin" }, React.createElement(HistoryModal, {
	                ref: function ref(_ref) {
	                    return _this2._modalEl = _ref;
	                },
	                historySelected: selectedItem,
	                selectedModule: selectedModule }), React.createElement(AdminScaffoldingGeneric, {
	                messages: messages,
	                title: t('history_admin_title_history_changes'),
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchHistorys,
	                headerFields: formFieldsEl,
	                onCancel: this._onCancel,
	                additionalButtons: additionalButtons
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['date'],
	                columnNames: [t('history_admin_column_name_date_display'), t('history_admin_column_name_type'), t('history_admin_column_name_user')],
	                filteredColumns: ['dateDisplay', 'type', 'userName'],
	                displayAttributes: ['dateDisplay', 'type', 'userName']
	            }, this._formatRowChanges(get(filteredHistories, 'changes')))));
	        }
	    }
	});
	
	module.exports = HistoryAdmin;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1361);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    _require2 = __webpack_require__(12),
	    FlatButton = _require2.FlatButton,
	    HistoryModalDescription = __webpack_require__(765),
	    CustomModal = __webpack_require__(179),
	    HistoryStore = __webpack_require__(410),
	    _require3 = __webpack_require__(1),
	    PropTypes = _require3.PropTypes,
	    HistoryModalFields = __webpack_require__(766),
	    Constants = __webpack_require__(2),
	    get = __webpack_require__(5).get;
	
	
	var HistoryModal = React.createClass({ displayName: "HistoryModal",
	
	    propTypes: {
	        historySelected: PropTypes.object,
	        selectedModule: PropTypes.object
	    },
	
	    _modalEl: null,
	
	    getInitialState: function getInitialState() {
	        return {
	            isVisible: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.setState({
	            title: t('history_modal_title_history_detail')
	        });
	    },
	    _saveAndClose: function _saveAndClose() {
	        var _this = this;
	
	        HistoryStore.saveChangeFields(function () {
	            return _this.close();
	        });
	    },
	    show: function show() {
	        this.setState({
	            isVisible: true
	        });
	    },
	    close: function close() {
	        this.setState({
	            isVisible: false
	        });
	    },
	    restore: function restore() {
	        var _props = this.props,
	            selectedModule = _props.selectedModule,
	            historySelected = _props.historySelected;
	
	        HistoryStore.restore(selectedModule, historySelected);
	    },
	    _getContentEl: function _getContentEl(historySelected, selectedModule) {
	        return React.createElement("div", { className: "bp-history-modal" }, React.createElement("div", { className: "bp-history-modal__header" }, React.createElement("h4", { className: "bp-history-modal__header-title" }, t('history_modal_title_overview')), React.createElement("hr", null), React.createElement(HistoryModalDescription, { history: historySelected, selectedModule: selectedModule })), React.createElement("div", { className: "bp-history-modal__body" }, React.createElement("h4", { className: "bp-history-modal__body-title" }, t('history_modal_title_changes_detail')), React.createElement("hr", null), React.createElement(HistoryModalFields, { history: historySelected })));
	    },
	    _getActionsModal: function _getActionsModal(historySelected) {
	        var historyType = get(historySelected, 'type');
	        switch (historyType) {
	            case Constants.HISTORY_TYPE_CHANGE:
	                return [React.createElement(FlatButton, {
	                    label: t('history_modal_button_label_cancel'),
	                    onTouchTap: this.close
	                })];
	            case Constants.HISTORY_TYPE_DELETE:
	                return [React.createElement(FlatButton, {
	                    label: t('history_modal_button_label_cancel'),
	                    onTouchTap: this.close
	                })];
	            case Constants.HISTORY_TYPE_NEW:
	                return [React.createElement(FlatButton, {
	                    label: t('history_modal_button_label_cancel'),
	                    onTouchTap: this.close
	                })];
	        }
	    },
	    render: function render() {
	        var _props2 = this.props,
	            historySelected = _props2.historySelected,
	            selectedModule = _props2.selectedModule;
	
	
	        if (!historySelected) {
	            return null;
	        }
	
	        var actionsEl = this._getActionsModal(historySelected);
	        var contentEl = this._getContentEl(historySelected, selectedModule);
	
	        return React.createElement(CustomModal, {
	            actions: actionsEl,
	            title: this.state.title,
	            isVisible: this.state.isVisible
	        }, contentEl);
	    }
	});
	
	module.exports = HistoryModal;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1362);
	var React = __webpack_require__(1);
	var DateUtils = __webpack_require__(22),
	    _require = __webpack_require__(4),
	    t = _require.t;
	
	
	var HistoryModalDescription = React.createClass({ displayName: "HistoryModalDescription",
	    render: function render() {
	        var _props = this.props,
	            history = _props.history,
	            selectedModule = _props.selectedModule;
	
	        return React.createElement("div", null, React.createElement("dl", { className: "bp-history-modal-description" }, React.createElement("div", { className: "bp-history-modal-description__field" }, React.createElement("dt", { className: "bp-history-modal-description__field-column-name" }, t('history_modal_description_change_date')), React.createElement("dd", { className: "bp-history-modal-description__field-value" }, DateUtils.toYYYYMMDDhhmm(history.date))), React.createElement("div", { className: "bp-history-modal-description__field" }, React.createElement("dt", { className: "bp-history-modal-description__field-column-name" }, t('history_modal_description_type_operation')), React.createElement("dd", { className: "bp-history-modal-description__field-value" }, history.type)), React.createElement("div", { className: "bp-history-modal-description__field" }, React.createElement("dt", { className: "bp-history-modal-description__field-column-name" }, t('history_modal_description_user:')), React.createElement("dd", { className: "bp-history-modal-description__field-value" }, history.userName)), React.createElement("div", { className: "bp-history-modal-description__field" }, React.createElement("dt", { className: "bp-history-modal-description__field-column-name" }, t('history_modal_description_module:')), React.createElement("dd", { className: "bp-history-modal-description__field-value" }, selectedModule.displayName))));
	    }
	});
	
	module.exports = HistoryModalDescription;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1363);
	
	var React = __webpack_require__(1),
	    get = __webpack_require__(5).get,
	    _require = __webpack_require__(8),
	    map = _require.map,
	    _require2 = __webpack_require__(1),
	    PropTypes = _require2.PropTypes,
	    _require3 = __webpack_require__(12),
	    TextField = _require3.TextField,
	    _require4 = __webpack_require__(4),
	    t = _require4.t;
	
	
	var HistoryModalFields = React.createClass({ displayName: "HistoryModalFields",
	
	    propTypes: {
	        history: PropTypes.object
	    },
	
	    _el: null,
	
	    _ref: function _ref(el) {
	        this._el = el;
	    },
	    _getHeaderColumns: function _getHeaderColumns(fieldChanges) {
	        var _get = get(fieldChanges, '0'),
	            oldValue = _get.oldValue;
	
	        return React.createElement("div", { className: "bp-history-modal-fields__header row" }, React.createElement("div", { className: "bp-history-modal-fields__header-column col-xs-4" }, React.createElement("strong", null, t('history_modal_fields_field_name'))), oldValue ? React.createElement("div", { className: "bp-history-modal-fields__header-column col-xs-4" }, React.createElement("strong", null, t('history_modal_fields_old_value'))) : null, React.createElement("div", { className: "bp-history-modal-fields__header-column col-xs-4" }, React.createElement("strong", null, t('history_modal_fields_new_value'))));
	    },
	    _getFieldEl: function _getFieldEl(fieldChanges) {
	        return map(fieldChanges, function (change) {
	            var newValue = change.newValue,
	                oldValue = change.oldValue,
	                displayName = change.displayName;
	
	            return React.createElement("div", { className: "bp-history-modal-fields row" }, React.createElement("div", { className: "bp-history-modal-fields__field bp-history-modal-fields__field-name col-xs-4" }, React.createElement(TextField, {
	                disabled: true,
	                defaultValue: displayName })), oldValue ? React.createElement("div", {
	                className: "bp-history-modal-fields__field bp-history-modal-fields__field-value col-xs-4" }, React.createElement(TextField, {
	                defaultValue: oldValue,
	                disabled: true })) : null, React.createElement("div", { className: "bp-history-modal-fields__field bp-history-modal-fields__field-value col-xs-4" }, React.createElement(TextField, {
	                disabled: true,
	                defaultValue: newValue })));
	        });
	    },
	    render: function render() {
	        var fieldChanges = get(this.props, 'history.fieldChanges');
	        var fieldsEl = this._getFieldEl(fieldChanges);
	        var headersEl = this._getHeaderColumns(fieldChanges);
	        return React.createElement("div", { className: "bp-history-modal-fields__content" }, headersEl, fieldsEl);
	    }
	});
	
	module.exports = HistoryModalFields;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    GridItem = __webpack_require__(229),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupImageChooser = __webpack_require__(704),
	    FormGroupDropdown = __webpack_require__(58),
	    ga = __webpack_require__(18),
	    _ = __webpack_require__(40);
	
	
	var IconsAdmin = React.createClass({ displayName: "IconsAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedIcon: null,
	            isEditMode: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchIcons();
	        ga.pageview('/icons-admin');
	    },
	    fetchIcons: function fetchIcons() {
	        var self = this;
	        InventoryStore.fetchIcons(function (icons) {
	            self.setState({
	                icons: icons
	            });
	        });
	    },
	    _onDeleteIcon: function _onDeleteIcon(icon, onSuccess, onFailure) {
	        InventoryStore.deleteIcon(icon, onSuccess, onFailure);
	    },
	    _onChangeIcon: function _onChangeIcon(icon, onSuccess, onFailure) {
	        InventoryStore.addIcon(icon, onSuccess, onFailure);
	    },
	    _onAddIcon: function _onAddIcon(icon, onSuccess, onFailure) {
	        InventoryStore.addIcon(icon, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(icon) {
	        this.setState(function (prevState) {
	            if (icon === prevState.selectedIcon) {
	                return {
	                    selectedIcon: null,
	                    isEditMode: false
	                };
	            } else {
	                return {
	                    selectedIcon: icon,
	                    isEditMode: true
	                };
	            }
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedIcon: null,
	            isEditMode: false
	        });
	    },
	    render: function render() {
	        var _this = this;
	
	        if (!this.state.icons) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('icons_admin_change_success'),
	                changeFailureMessage: t('icons_admin_failure_success'),
	                deleteSuccessMessage: t('icons_admin_delete_success'),
	                addSuccessMessage: t('icons_admin_add_success'),
	                addFailureMessage: t('icons_admin_add_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedIcon = _state.selectedIcon,
	                icons = _state.icons,
	                isEditMode = _state.isEditMode;
	
	
	            var GridItemsEl = _.map(icons, function (item) {
	                return React.createElement(GridItem, {
	                    icon: item,
	                    isChecked: _.get(item, 'cameFromApplicant', false) || _.get(_this.state, 'selectedIcon.id') === _.get(item, 'id'),
	
	                    onCheck: _this._onRowSelection });
	            });
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                displayAttribute: "name",
	                readerAttribute: "iconDetail.displayName",
	                writerAttribute: "displayName",
	                name: t('icons_admin_name_label'),
	                value: selectedIcon,
	                label: t('icons_admin_name_label') }), React.createElement(FormGroupDropdown, {
	                operationsHolder: contextHolder,
	                items: icons,
	                displayAttribute: "text",
	                readerAttribute: "iconDetail.name",
	                writerAttribute: "urlImage",
	                name: t('icon'),
	                value: selectedIcon,
	                isRequired: false,
	                isEditMode: isEditMode }), React.createElement(FormGroupImageChooser, {
	                operationsHolder: contextHolder,
	                displayAttribute: "imageSrc",
	                readerAttribute: "iconDetail.displayName",
	                writerAttribute: "urlCustomImage",
	                name: "imageSrc",
	                value: selectedIcon,
	                label: t('icons_admin_select_icon') })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffoldingGeneric, {
	                title: t('icons_admin_title'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedIcon,
	                fetchItems: this.fetchIcons,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddIcon,
	                onChange: this._onChangeIcon,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteIcon
	            }, GridItemsEl));
	        }
	    }
	});
	
	module.exports = IconsAdmin;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	__webpack_require__(1364);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Constants = __webpack_require__(2),
	    ContentUtils = __webpack_require__(7),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    DashboardStore = __webpack_require__(82),
	    FormGroupDropdown = __webpack_require__(58),
	    AppConstants = __webpack_require__(2),
	    GridItemWithFilter = __webpack_require__(153),
	    ga = __webpack_require__(18),
	    _ = __webpack_require__(40);
	
	
	var IconsAndSectionsAdmin = React.createClass({ displayName: "IconsAndSectionsAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder],
	
	    getInitialState: function getInitialState() {
	        return {
	            sectionSelected: Constants.BREWING_SECTION_NAME,
	            selectedIcon: Constants.BREWING_SECTION_NAME,
	            isEditMode: false,
	            iconsMapping: null,
	            filterText: null
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchIcons();
	        ga.pageview('/icons-section-admin');
	    },
	    fetchIcons: function fetchIcons() {
	        var self = this;
	        InventoryStore.fetchIcons(function (response) {
	            var icons = ContentUtils.formatApplicantIcons(response.icons, response.iconsFromApplicant);
	            var iconsFiltered = _.filter(icons, function (icon) {
	                return _.get(icon, 'iconDetail.name') !== Constants.TASK_NON_VISIBLE;
	            }); // remove only this icons
	            var iconsSorted = _.orderBy(iconsFiltered, 'iconDetail.name');
	            var iconsPristine = _.cloneDeep(iconsSorted);
	            self.setState({
	                icons: iconsSorted,
	                iconsPristine: iconsPristine,
	                iconsChanged: [] // clean icon changed
	            });
	        });
	    },
	    _saveChanges: function _saveChanges(icon, onSuccess, onFailure) {
	        var _state = this.state,
	            icons = _state.icons,
	            iconsPristine = _state.iconsPristine;
	
	        var iconMappingConverted = InventoryStore.filterOnlyIconsChanged(icons, iconsPristine);
	        InventoryStore.changeIcon({
	            iconsChanged: iconMappingConverted
	        }, onSuccess, onFailure);
	        DashboardStore.updateDashboardContent();
	    },
	    _onChangeSection: function _onChangeSection(evt, index, value) {
	        this.setState({
	            sectionSelected: _.get(value, 'itemModel.section')
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.fetchIcons();
	        this.setState({
	            filterText: ''
	        });
	    },
	    _onCheckIcon: function _onCheckIcon(gridItemProps, filterText) {
	        var iconId = gridItemProps.iconId;
	        var _state2 = this.state,
	            sectionSelected = _state2.sectionSelected,
	            icons = _state2.icons;
	
	        // update state of icon
	
	        var currentIconChecked = _.find(this.state.icons, function (icon) {
	            return icon.id === iconId;
	        });
	        var oldStateIcon = isCheckedIcon(sectionSelected, currentIconChecked);
	        var newStateIcon = !oldStateIcon;
	        currentIconChecked = updateSectionIcon(sectionSelected, currentIconChecked, newStateIcon);
	
	        var iconsFiltered = _.filter(icons, function (icon) {
	            return icon.id !== currentIconChecked.id;
	        });
	        var allIconsWithIconUpdated = _.concat(iconsFiltered, currentIconChecked);
	
	        this.setState({
	            icons: _.orderBy(allIconsWithIconUpdated, 'iconDetail.name'),
	            iconsChanged: this.getIconChangedUpdated(currentIconChecked),
	            filterText: filterText
	        });
	    },
	    getIconChangedUpdated: function getIconChangedUpdated(iconChangedNew) {
	        var _state3 = this.state,
	            sectionSelected = _state3.sectionSelected,
	            iconsChanged = _state3.iconsChanged,
	            iconsPristine = _state3.iconsPristine;
	
	        // find if already change the icon
	
	        var iconChangedOld = _.find(iconsChanged, function (iconChanged) {
	            return _.get(iconChanged, 'id') === _.get(iconChangedNew, 'id');
	        });
	        var existIconChanged = !!iconChangedOld;
	
	        // ask if we apply the same change that before
	        var isSomeStateIconChanged = isSameStateIcon(iconChangedOld, iconChangedNew, sectionSelected);
	        var iconChangedUpdated = void 0;
	
	        if (existIconChanged && isSomeStateIconChanged) {
	            // we don't need to change nothing because is the same state
	            iconChangedUpdated = iconsChanged;
	        } else if (existIconChanged && isSomeStateIconChanged === false) {
	            // we need to update the changed icon
	            var iconsChangedFiltered = _.filter(iconsChanged, function (iconChanged) {
	                return _.get(iconChanged, 'id') !== _.get(iconChangedNew, 'id');
	            });
	            iconChangedUpdated = _.concat(iconsChangedFiltered, iconChangedNew);
	        } else if (!existIconChanged) {
	            // just need to add the new changed icon
	            iconChangedUpdated = _.concat(iconsChanged, iconChangedNew);
	        } else {
	            // we don't need to do nothing
	            iconChangedUpdated = iconsChanged;
	        }
	
	        // filter all icon changed which have the same state of icon pristine
	        iconChangedUpdated = _.filter(iconChangedUpdated, function (iconChanged) {
	            var iconPristine = _.find(iconsPristine, function (iconPristine) {
	                return _.get(iconPristine, 'id') === _.get(iconChanged, 'id');
	            });
	            var isSameStateIconPristine = isSameStateIcon(iconPristine, iconChanged, sectionSelected);
	            return !isSameStateIconPristine;
	        });
	
	        // add where section came from the icon changed
	        iconChangedUpdated = _.map(iconChangedUpdated, function (icon) {
	            icon.sectionChanged = sectionSelected;
	            return icon;
	        });
	
	        return iconChangedUpdated;
	    },
	    isChangedIcon: function isChangedIcon(icon) {
	        var _state4 = this.state,
	            iconsChanged = _state4.iconsChanged,
	            sectionSelected = _state4.sectionSelected;
	
	        var isChangedIcon = !!_.find(iconsChanged, function (iconChanged) {
	            return _.get(iconChanged, 'id') === _.get(icon, 'id') && _.get(iconChanged, 'sectionChanged') === sectionSelected;
	        });
	
	        return isChangedIcon;
	    },
	    render: function render() {
	        if (!this.state.icons) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('icons_and_sections_admin_change_success'),
	                changeFailureMessage: t('icons_and_sections_admin_change_failure'),
	                addSuccessMessage: t('icons_and_sections_admin_delete_success'),
	                addFailureMessage: t('icons_and_sections_admin_add_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state5 = this.state,
	                selectedIcon = _state5.selectedIcon,
	                isEditMode = _state5.isEditMode,
	                icons = _state5.icons,
	                sectionSelected = _state5.sectionSelected,
	                iconsPristine = _state5.iconsPristine;
	
	            var originalStateIcons = isOriginalState(icons, iconsPristine, sectionSelected);
	
	            var currentSelectedSection = selectedIcon && selectedIcon.section ? AppConstants.getSectionsMapping(t)[selectedIcon.section] : '';
	
	            var currentSelectedCategoryValue = currentSelectedSection ? _extends({}, selectedIcon, { displayText: currentSelectedSection }) : selectedIcon;
	
	            var formFieldsEl = [React.createElement(FormGroupDropdown, {
	                isFullRelaxedText: true,
	                items: AppConstants.getSections(t),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "section",
	                readerAttributeValue: "section",
	                writerAttribute: "type",
	                outputMapper: {
	                    Fermenting: 'FV',
	                    Packaging: 'BT',
	                    Brewing: 'BH'
	                },
	                name: t('icons_and_sections_admin_section_label'),
	                isImmutable: true,
	                value: sectionSelected,
	                isEditMode: isEditMode,
	                onChange: this._onChangeSection })];
	
	            return React.createElement(AdminScaffoldingGeneric, {
	                title: t('icons_and_sections_admin_title'),
	                moduleName: "ADMIN_ICON",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: originalStateIcons ? undefined : currentSelectedCategoryValue,
	                fetchItems: this.fetchIcons,
	                headerFields: formFieldsEl,
	                onChange: originalStateIcons ? undefined : this._saveChanges,
	                onCancel: originalStateIcons ? undefined : this._onCancel,
	                isMultiSelection: true
	            }, React.createElement(GridItemWithFilter, {
	                items: translateIcons(icons, t),
	                isCheckedItem: isCheckedIcon.bind(this, sectionSelected),
	                isChangedItem: this.isChangedIcon,
	                onCheckItem: this._onCheckIcon,
	                displayNameField: "iconDetail.displayNameText",
	                iconClassNameField: "iconDetail.iconClassName",
	                idField: "iconDetail.id",
	                initialFilterText: this.state.filterText,
	                nonMatchingText: t('icons_and_sections_non_matching'),
	                keepSelectedSorting: false }));
	        }
	    }
	});
	
	function translateIcons(icons, t) {
	    return icons.map(function (icon) {
	        icon.iconDetail.displayNameText = Constants.getIconsMapping(t)[icon.iconDetail.displayName] || icon.iconDetail.displayName;
	        return icon;
	    });
	}
	
	function isOriginalState(iconsChanged, iconPristine, currentSection) {
	    return _.every(iconsChanged, function (iconChanged) {
	        var iconCompare = _.find(iconPristine, function (iconPristine) {
	            return iconPristine.id === iconChanged.id;
	        });
	        return isSameStateIcon(iconCompare, iconChanged, currentSection);
	    });
	}
	
	function isSameStateIcon(icon, iconCompare, currentSection) {
	    if (icon && iconCompare) {
	        var isCheckedIconCompare = isCheckedIcon(currentSection, iconCompare);
	        var isCheckedIconChanged = isCheckedIcon(currentSection, icon);
	        var isSameState = isCheckedIconCompare === isCheckedIconChanged;
	        return isSameState;
	    }
	}
	
	function isCheckedIcon(currentSection, icon) {
	    switch (currentSection) {
	        case Constants.BREWING_SECTION_NAME:
	            return _.get(icon, 'iconDetail.isBrewingAllowed');
	        case Constants.FERMENTING_SECTION_NAME:
	            return _.get(icon, 'iconDetail.isFermentingAllowed');
	        case Constants.PACKAGING_SECTION_NAME:
	            return _.get(icon, 'iconDetail.isPackagingAllowed');
	    }
	}
	
	function updateSectionIcon(currentSection, icon, newCheckedState) {
	    switch (currentSection) {
	        case Constants.BREWING_SECTION_NAME:
	            return _.set(icon, 'iconDetail.isBrewingAllowed', newCheckedState);
	        case Constants.FERMENTING_SECTION_NAME:
	            return _.set(icon, 'iconDetail.isFermentingAllowed', newCheckedState);
	        case Constants.PACKAGING_SECTION_NAME:
	            return _.set(icon, 'iconDetail.isPackagingAllowed', newCheckedState);
	    }
	}
	
	module.exports = IconsAndSectionsAdmin;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1365);
	
	var React = __webpack_require__(1),
	    SessionStore = __webpack_require__(11),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ComponentUtils = __webpack_require__(77),
	    ContentUtils = __webpack_require__(7),
	    Notification = __webpack_require__(21),
	    NumberUtils = __webpack_require__(23),
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    _require3 = __webpack_require__(37),
	    delay = _require3.delay,
	    _require4 = __webpack_require__(12),
	    FlatButton = _require4.FlatButton,
	    SelectField = _require4.SelectField,
	    TextField = _require4.TextField,
	    get = __webpack_require__(5).get,
	    CustomModal = __webpack_require__(179),
	    InventoryStore = __webpack_require__(20),
	    _require5 = __webpack_require__(48),
	    findIndex = _require5.findIndex,
	    _require6 = __webpack_require__(1),
	    PropTypes = _require6.PropTypes;
	
	
	var InventoryAndTransfersAdjustsModal = React.createClass({ displayName: "InventoryAndTransfersAdjustsModal",
	
	    mixins: [Navigation],
	
	    propTypes: {
	        selectedLocationItem: PropTypes.object,
	        items: PropTypes.array,
	        locations: PropTypes.array,
	        onClose: PropTypes.function
	    },
	
	    _inputAmountToAdjust: null,
	
	    getInitialState: function getInitialState() {
	        return {
	            isVisible: false,
	            title: t('inventory_and_transfer_subtitle'),
	            locationsFromMessageError: '',
	            locationsToIndex: 1, // select the fist location items
	            adjustAmount: 0,
	            locationsToMessageError: '',
	            locationsAmountMessageError: '',
	            itemMessageError: ''
	        };
	    },
	    componentWillUnmount: function componentWillUnmount() {},
	    focusAmount: function focusAmount() {
	        var _this = this;
	
	        if (this._inputAmountToAdjust) {
	            delay(function () {
	                _this._inputAmountToAdjust.getDOMNode().querySelector('input').focus();
	            }, 500); // give time to finish open dialog transition
	        }
	    },
	    _onSaveAndClose: function _onSaveAndClose() {
	        var selectedLocationItem = this.props.selectedLocationItem;
	        var isProposal = get(selectedLocationItem, 'isProposalItem');
	        var adjustValue = this._inputAmountToAdjust.getDOMNode().querySelector('input').value;
	        var self = this;
	        var locationItemAdjust = {
	            id: get(selectedLocationItem, 'id'),
	            amount: NumberUtils.standardiseDecimalFormatNumber(adjustValue),
	            locationId: get(selectedLocationItem, 'locationId') || get(selectedLocationItem, 'location.id'),
	            location: get(selectedLocationItem, 'location'),
	            itemId: get(selectedLocationItem, 'itemId') || get(selectedLocationItem, 'item.id'),
	            item: get(selectedLocationItem, 'item')
	        };
	
	        if (isProposal) {
	            InventoryStore.addLocationItem(locationItemAdjust, function (response) {
	                Notification.show(t('inventory_and_transfer_adjust_success'), 'success');
	                if (response) {
	                    var locationItemChanged = JSON.parse(response.responseText);
	                    self.transitionTo('/location-item/page/:page', { page: 0 }, { selectLocationItemId: get(locationItemChanged, 'id') });
	                }
	                self.close();
	            }, function () {
	                Notification.show(t('dashboard_notification_something_was_wrong'));
	            });
	        } else {
	            InventoryStore.changeLocationItem(locationItemAdjust, function () {
	                Notification.show(t('inventory_and_transfer_adjust_success'), 'success');
	                self.close();
	            }, function () {
	                Notification.show(t('dashboard_notification_something_was_wrong'));
	            });
	        }
	    },
	    show: function show() {
	        var _this2 = this;
	
	        this.setState({
	            isVisible: true
	        }, function () {
	            _this2.focusAmount();
	        });
	    },
	    close: function close() {
	        var self = this;
	        this.setState({
	            isVisible: false
	        }, function () {
	            self.props.onClose();
	        });
	    },
	    _onChangeLocationTo: function _onChangeLocationTo(evt, index, locationSelected) {
	        this.setState({
	            locationsToIndex: get(locationSelected, 'payload')
	        });
	    },
	    _onChangeAmount: function _onChangeAmount(evt) {
	        var adjustAmountString = NumberUtils.getNumberString(get(evt, 'target.value'));
	        var adjustAmount = NumberUtils.standardiseDecimalFormatNumber(adjustAmountString);
	        this.setState({
	            adjustAmount: adjustAmount
	        });
	    },
	    _onChangeItem: function _onChangeItem(evt, index, itemSelected) {
	        this.setState({
	            itemsIndex: get(itemSelected, 'payload')
	        });
	    },
	    _getContentEl: function _getContentEl(selectedLocationItem) {
	        var _this3 = this;
	
	        var unit = get(selectedLocationItem, 'unit', '');
	        var selectedLocationName = get(selectedLocationItem, 'locationName', '');
	        var selectedItemName = get(selectedLocationItem, 'description', '');
	        var unitWithParenthesis = unit ? '(' + unit + ')' : unit;
	
	        var enableLocations = ContentUtils.filterEnable(this.props.locations);
	        var enableItems = ContentUtils.filterEnable(this.props.items);
	        var locationMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableLocations, t('inventory_and_transfer_select_location_placeholder'));
	        var itemMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableItems, t('inventory_and_transfer_select_items_placeholder'), 'description');
	
	        var locationIndexFrom = findIndex(enableLocations, function (locationItem) {
	            return get(locationItem, 'name') === selectedLocationName;
	        }) + 1;
	        var itemIndexFrom = findIndex(enableItems, function (item) {
	            return get(item, 'description') === selectedItemName;
	        }) + 1;
	        var currentAmount = NumberUtils.formatDecimal(get(selectedLocationItem, 'amount'), get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	
	        var haveVolumedDefined = NumberUtils.toNumber(currentAmount) > 0;
	
	        return React.createElement("div", { className: "bp-location-adjusts-modal" }, React.createElement("div", { className: "bp-location-adjusts-modal__header" }, React.createElement("h4", { className: "bp-location-adjusts-modal__header-title" }, t('inventory_and_transfer_title')), React.createElement("hr", null), React.createElement("div", { className: "bp-location-adjusts-modal__fields" }, React.createElement(SelectField, {
	            floatingLabelText: t('inventory_and_transfer_location'),
	            menuItems: locationMenuItems,
	            errorText: this.state.locationsFromMessageError,
	            value: locationIndexFrom,
	            disabled: true
	        }), React.createElement(SelectField, {
	            floatingLabelText: t('inventory_and_transfer_items') + ' ' + unitWithParenthesis,
	            menuItems: itemMenuItems,
	            errorText: this.state.itemMessageError,
	            value: itemIndexFrom,
	            disabled: true
	        }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return _this3._inputAmountToAdjust = input;
	            },
	            className: "bp-location-adjusts-modal__input",
	            defaultValue: currentAmount,
	            floatingLabelText: t('inventory_and_transfer_amount') + ' ' + unitWithParenthesis,
	            disabled: true }), React.createElement(TextField, {
	            ref: function ref(input) {
	                return _this3._inputAmountToAdjust = input;
	            },
	            className: "bp-location-adjusts-modal__input",
	            defaultValue: haveVolumedDefined ? currentAmount : '',
	            hintText: t('inventory_and_transfer_enter_amount'),
	            floatingLabelText: t('inventory_and_transfer_adjust_amount') + ' ' + unitWithParenthesis,
	            onEnterKeyDown: this._onSaveAndClose,
	            onBlur: this._onChangeAmount }))));
	    },
	    _getActionsModal: function _getActionsModal() {
	        return [React.createElement(FlatButton, {
	            label: t('inventory_and_transfer_label_buttom_cancel'),
	            onTouchTap: this.close
	        }), React.createElement(FlatButton, {
	            label: t('inventory_and_transfer_label_buttom_save'),
	            onTouchTap: this._onSaveAndClose,
	            primary: true
	        })];
	    },
	    render: function render() {
	        var _props = this.props,
	            selectedLocationItem = _props.selectedLocationItem,
	            selectedModule = _props.selectedModule;
	
	
	        if (!selectedLocationItem) {
	            return null;
	        }
	
	        var actionsEl = this._getActionsModal(selectedLocationItem);
	        var contentEl = this._getContentEl(selectedLocationItem, selectedModule);
	
	        return React.createElement(CustomModal, {
	            customClass: "inventory-transfer-modal modal-adjust",
	            actions: actionsEl,
	            title: this.state.title,
	            isVisible: this.state.isVisible
	        }, contentEl);
	    }
	});
	
	module.exports = InventoryAndTransfersAdjustsModal;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    InventoryStore = __webpack_require__(20),
	    NumberUtils = __webpack_require__(23),
	    ContentUtils = __webpack_require__(7),
	    NavigationUtils = __webpack_require__(35),
	    PositionUtils = __webpack_require__(59),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    find = _require2.find,
	    filter = _require2.filter,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    Constants = __webpack_require__(2),
	    _require4 = __webpack_require__(37),
	    delay = _require4.delay,
	    Loading = __webpack_require__(33),
	    Notification = __webpack_require__(21),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTablePaged = __webpack_require__(178),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    get = __webpack_require__(5).get,
	    InventoryAndTransfersModal = __webpack_require__(771),
	    InventoryAndTransfersAdjustsModal = __webpack_require__(769),
	    ga = __webpack_require__(18);
	
	
	var InventoryAndTransfersAdmin = React.createClass({ displayName: "InventoryAndTransfersAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    _modalTransfer: null,
	
	    _modalAdjust: null,
	
	    getInitialState: function getInitialState() {
	        return {
	            isFetching: true,
	            selectLocationItemId: null,
	            filter: {
	                description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: ''
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	        ga.pageview('/inventory-and-transfers');
	    },
	    fetchItems: function fetchItems() {
	        var self = this;
	        var currentPage = NavigationUtils.getPathParam('page');
	        InventoryStore.fetchAllItems(function (items) {
	            InventoryStore.fetchLocation(function (locations) {
	                InventoryStore.fetchLocationItemsWithTotalAmount(currentPage, function (locationItems) {
	                    var enableLocationItems = ContentUtils.filterEnable(locationItems);
	                    var enableLocations = ContentUtils.filterEnable(locations);
	                    var enableItems = ContentUtils.filterEnable(filterNonInventoryItems(items));
	                    var filteredEnableLocationItems = enableLocationItems.filter(filterLocationItemNonDefaultItemWithAmountZero(items));
	                    self.setState({
	                        locations: locations,
	                        locationItems: self._hydrateLocationItems(enableLocations, enableItems, filteredEnableLocationItems),
	                        selectLocationItemId: NavigationUtils.getQueryParam('selectLocationItemId'),
	                        isFetching: false,
	                        items: enableItems
	                    }, self._onFinishRenderingFetchLocationItems);
	                });
	            });
	        });
	    },
	    _hydrateLocationItems: function _hydrateLocationItems(locations, items, locationItems) {
	
	        // add some extra visual information
	        var locationItemsFormatted = map(locationItems, function (locationItem) {
	            locationItem.amount = get(locationItem, 'amount');
	            locationItem.totalAmount = NumberUtils.formatDecimal(get(locationItem, 'totalAmount')) + ' ' + get(locationItem, 'unit', '');
	            locationItem.amountWithUnit = NumberUtils.formatDecimal(get(locationItem, 'amount')) + ' ' + get(locationItem, 'unit', '');
	            locationItem.locationName = get(locationItem, 'location.name') || get(locationItem, 'locationName');
	            locationItem.description = get(locationItem, 'item.description') || get(locationItem, 'description');
	            locationItem.category = get(locationItem, 'item.category') || get(locationItem, 'category');
	            locationItem.subCategory = get(locationItem, 'item.subCategory') || get(locationItem, 'subCategory');
	            return locationItem;
	        });
	
	        return locationItemsFormatted;
	    },
	    fetchItemsBy: function fetchItemsBy(filter) {
	        var self = this;
	        filter.code = '';
	        filter.unit = '';
	        filter.salePrice = '';
	        filter.weight = '';
	        InventoryStore.fetchItemsBy(filter, function (items) {
	            InventoryStore.fetchLocationItemsWithTotalAmountBy(filter, function (locationItems) {
	                var enableLocationItems = ContentUtils.filterEnable(locationItems);
	                var filteredLocationItems = enableLocationItems.filter(filterLocationItemNonDefaultItemWithAmountZero(items));
	                self.setState({
	                    locationItems: self._hydrateLocationItems(self.state.locations, items, filteredLocationItems),
	                    selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
	                    isFetching: false
	                });
	            });
	        });
	    },
	    _onFinishRenderingFetchLocationItems: function _onFinishRenderingFetchLocationItems() {
	        var _state = this.state,
	            selectLocationItemId = _state.selectLocationItemId,
	            locationItems = _state.locationItems;
	
	        var haveProductSelectedTable = !!selectLocationItemId;
	
	        if (haveProductSelectedTable) {
	            var self = this;
	            this.setState({
	                selectLocationItem: find(locationItems, function (locationItem) {
	                    return get(locationItem, 'id') === +selectLocationItemId;
	                })
	            }, function () {
	                self._setPositionScrollById.bind(self)(selectLocationItemId);
	            });
	        }
	    },
	    _setPositionScrollById: function _setPositionScrollById(productSelectedId) {
	        var tableEl = this.getDOMNode().querySelector('.mui-body-table');
	        var rowEl = tableEl.querySelector('tr[data-row-id="' + productSelectedId + '"]');
	        var positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
	        tableEl.scrollTop = positionTopRowEl;
	    },
	    _openTransfersModal: function _openTransfersModal() {
	        var amount = get(this.state, 'selectLocationItem.amount');
	        if (NumberUtils.isGreater(amount, 0)) {
	            this._modalTransfer.show(this.state.selectLocationItem);
	        } else {
	            Notification.show(t('inventory_and_transfer_main_error_no_amount_to_transfer'));
	        }
	    },
	    _openAdjustsModal: function _openAdjustsModal() {
	        this._modalAdjust.show(this.state.selectLocationItem);
	    },
	    _onRowSelection: function _onRowSelection(locationItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectLocationItem: locationItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	
	            _this._addQueryParamWithRowSelected(locationItem, lastRowScrollPosition);
	        });
	    },
	    _addQueryParamWithRowSelected: function _addQueryParamWithRowSelected(locationItem, lastRowScrollPosition) {
	        var _this2 = this;
	
	        this.transitionTo('/location-item/page/:page', { page: NavigationUtils.getPathParam('page') }, {
	            selectLocationItemId: get(locationItem, 'id')
	        });
	        // Is needed to force scroll position again
	        // in order to avoid jumping scroll behavior
	        delay(function () {
	            _this2.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        }, 1);
	    },
	    _onCancel: function _onCancel() {
	        this.transitionTo('/location-item/page/:page', { page: NavigationUtils.getPathParam('page') });
	        this.setState({
	            selectLocationItem: null,
	            selectLocationItemId: null,
	            filter: { description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: '' }
	        });
	    },
	    reset: function reset() {
	        var _this3 = this;
	
	        this.setState({
	            selectLocationItem: null,
	            selectLocationItemId: null,
	            filter: { description: '', category: '', subCategory: '', amount: '', locationName: '', totalAmount: '' }
	        }, function () {
	            _this3.fetchItems();
	        });
	    },
	    _onTypingFilter: function _onTypingFilter(name, match) {
	        var _this4 = this;
	
	        if (!this.state.isFetching) {
	            this.setState(function (prevState) {
	                var nextFilter = prevState.filter || {};
	                nextFilter[name] = match;
	                _this4.fetchItemsBy(nextFilter);
	                return {
	                    filter: nextFilter,
	                    isFetching: true
	                };
	            });
	        }
	    },
	    _onClickPage: function _onClickPage(page) {
	        this.transitionTo('/location-item/page/:page', { page: page });
	        this.fetchItems();
	    },
	    _printReport: function _printReport() {
	        InventoryStore.downloadReportXLS(this.state.filter, 'locations/items');
	    },
	    render: function render() {
	        var _this5 = this;
	
	        if (this.state.isFetching) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('inventory_and_transfer_main_change_success'),
	                changeFailureMessage: t('inventory_and_transfer_main_failure'),
	                deleteSuccessMessage: t('inventory_and_transfer_main_delete_success'),
	                addSuccessMessage: t('inventory_and_transfer_main_add_success'),
	                addFailureMessage: t('inventory_and_transfer_main_add_failure')
	            };
	            var CATEGORIES_TEXTS = Constants.getCategoryMapping(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state2 = this.state,
	                selectLocationItem = _state2.selectLocationItem,
	                typeTank = _state2.typeTank,
	                currentBeerStyle = _state2.currentBeerStyle,
	                locationItems = _state2.locationItems,
	                locations = _state2.locations,
	                isFetching = _state2.isFetching;
	
	
	            var formFieldsEl = [];
	            var isItemSelected = !!selectLocationItem;
	            var existMoreThanOneLocation = (get(ContentUtils.filterEnable(locations), 'length') || 0) >= 2;
	
	            var additionalButtons = [{
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('inventory_and_transfer_print_report'),
	                    icon: "file_download",
	                    type: "icon",
	                    onClick: this._printReport })
	            }];
	
	            if (isItemSelected) {
	                if (existMoreThanOneLocation) {
	                    additionalButtons.push({
	                        type: 'CHANGE',
	                        permission: 'TRANSFER_SHOW',
	                        el: React.createElement(FormGroupButton, {
	                            label: t('inventory_and_transfer_transfer'),
	                            icon: "compare_arrows",
	                            type: "icon",
	                            onClick: this._openTransfersModal })
	                    });
	                }
	
	                additionalButtons.push({
	                    type: 'CHANGE',
	                    permission: 'ADJUST_SHOW',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('inventory_and_transfer_adjust'),
	                        icon: "adjust",
	                        type: "icon",
	                        onClick: this._openAdjustsModal })
	                });
	            }
	
	            var count = get(locationItems, '0.totalSize') || 0;
	
	            if (locationItems && locationItems.length) {
	                locationItems = locationItems.map(function (item) {
	                    item.displayCategory = CATEGORIES_TEXTS[item.category] || item.category;
	                    return item;
	                });
	            }
	            return React.createElement("div", { className: "bp-location-item" }, React.createElement(InventoryAndTransfersModal, {
	                ref: function ref(_ref) {
	                    return _this5._modalTransfer = _ref;
	                },
	                selectedLocationItem: selectLocationItem,
	                locations: locations,
	                locationItems: locationItems,
	                onClose: this.reset }), React.createElement(InventoryAndTransfersAdjustsModal, {
	                ref: function ref(_ref2) {
	                    return _this5._modalAdjust = _ref2;
	                },
	                selectedLocationItem: selectLocationItem,
	                locations: locations,
	                items: locationItems,
	                onClose: this.reset }), React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_INVENTORY_AND_TRANSFERS",
	                messages: messages,
	                additionalSubmitValue: { styleBeerId: currentBeerStyle, typeTank: typeTank },
	                title: t('inventory_and_transfer_main_title'),
	                contextHolder: contextHolder,
	                value: selectLocationItem,
	                fetchItems: this.fetchItems,
	                headerFields: formFieldsEl,
	                onCancel: this._onCancel,
	                additionalButtons: additionalButtons
	            }, React.createElement(AdminScaffoldingTablePaged, {
	                customHeightTable: 290,
	                headerActiveFilters: this.state.headerActiveFilters,
	                sortByColumn: ['description'],
	                onRowSelection: this._onRowSelection,
	                value: selectLocationItem,
	                columnNames: [t('inventory_and_transfer_column_item'), t('inventory_and_transfer_column_category'), t('inventory_and_transfer_column_sub_category'), t('inventory_and_transfer_column_location_name'), t('inventory_and_transfer_column_amount'), t('inventory_and_transfer_column_total_amount')],
	                filteredColumns: ['description', 'category', 'subCategory', 'locationName', 'amountWithUnit', 'totalAmount'],
	                displayAttributes: ['description', 'category', 'subCategory', 'locationName', 'amountWithUnit', 'totalAmount'],
	                isLoading: isFetching,
	                maxPage: ContentUtils.getAmountPageNeeded(count, Constants.MAX_ITEMS_BY_PAGES_ADMINS),
	                onClickPage: this._onClickPage,
	                currentPage: NavigationUtils.getPathParam('page'),
	                columnsFilterValue: this.state.filter,
	                onCancel: this._onCancel,
	                onTypingFilter: this._onTypingFilter
	            }, locationItems)));
	        }
	    }
	});
	
	function filterNonInventoryItems(items) {
	    return filter(items, function (item) {
	        return get(item, 'category') !== Constants.ITEM_CATEGORY_NON_INVENTORY;
	    });
	}
	
	function filterLocationItemNonDefaultItemWithAmountZero(items) {
	    return function (locationItem) {
	        try {
	            if (NumberUtils.isGreater(locationItem.amount, 0)) {
	                return true;
	            }
	            var item = (items || []).find(function (item) {
	                return item.id === locationItem.itemId;
	            });
	            return item && locationItem && item.preferredLocation && item.preferredLocation.id === locationItem.locationId;
	        } catch (error) {
	            // in case of error, do nothing
	        }
	        return true;
	    };
	}
	
	module.exports = InventoryAndTransfersAdmin;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1366);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Notification = __webpack_require__(21),
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    ContentUtils = __webpack_require__(7),
	    SessionStore = __webpack_require__(11),
	    ComponentUtils = __webpack_require__(77),
	    LocationStore = __webpack_require__(745),
	    DropDown = __webpack_require__(105),
	    NumberUtils = __webpack_require__(23),
	    _require3 = __webpack_require__(12),
	    FlatButton = _require3.FlatButton,
	    SelectField = _require3.SelectField,
	    TextField = _require3.TextField,
	    get = __webpack_require__(5).get,
	    CustomModal = __webpack_require__(179),
	    _require4 = __webpack_require__(48),
	    findIndex = _require4.findIndex,
	    _require5 = __webpack_require__(8),
	    filter = _require5.filter,
	    find = _require5.find,
	    map = _require5.map,
	    reduce = _require5.reduce,
	    _require6 = __webpack_require__(1),
	    PropTypes = _require6.PropTypes;
	
	
	var AMOUNT_DECIMALS = 4;
	
	var InventoryAndTransfersModal = React.createClass({ displayName: "InventoryAndTransfersModal",
	
	  propTypes: {
	    items: PropTypes.array,
	    locationItems: PropTypes.array,
	    locations: PropTypes.array,
	    onClose: PropTypes.function
	  },
	
	  _inputAmountToTransfer: null,
	
	  getInitialState: function getInitialState() {
	    return {
	      locationsToIndex: 1,
	      isVisible: false,
	      title: t('inventory_and_transfer_modal_title'),
	      locationsFromMessageError: '',
	      locationsToMessageError: '',
	      locationsAmountMessageError: '',
	      itemMessageError: ''
	    };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },
	  focusAmount: function focusAmount() {
	    var self = this;
	    if (this._inputAmountToTransfer) {
	      delay(function () {
	        self._inputAmountToTransfer.getDOMNode().querySelector('input').focus();
	      }, 500); // give time to finish open dialog transition
	    }
	  },
	  _onSaveAndClose: function _onSaveAndClose() {
	    var locationItems = this.props.locationItems;
	    var _state = this.state,
	        selectedLocationItemFrom = _state.selectedLocationItemFrom,
	        selectedLocationItemTo = _state.selectedLocationItemTo;
	    var amountToTransfer = this.state.amountToTransfer;
	
	
	    var amountToTransferStandarized = NumberUtils.standardiseDecimalFormatNumber(amountToTransfer);
	    var amountOrigin = NumberUtils.getNumberString(get(selectedLocationItemFrom, 'amount'));
	    var messageError = LocationStore.isValidTransfer(amountOrigin, this.state.estimatedOrigin, amountToTransferStandarized);
	    var isValidTransfer = messageError === '';
	    var self = this;
	
	    if (isValidTransfer) {
	      // locations identifiers
	      var locationToId = get(selectedLocationItemTo, 'locationId') || get(selectedLocationItemTo, 'location.id') || get(selectedLocationItemTo, 'id');
	      var locationFromId = get(selectedLocationItemFrom, 'locationId') || get(selectedLocationItemFrom, 'location.id');
	      var itemId = get(selectedLocationItemFrom, 'itemId');
	
	      // the amounts of origin and destination without apply the transfer yet
	      var locationItemTo = find(locationItems, function (locationItem) {
	        return get(locationItem, 'locationId') === locationToId && get(locationItem, 'itemId') === itemId;
	      });
	      var locationToAmount = get(locationItemTo, 'amount');
	
	      // the amounts of items already updated & transfer info
	      var transferInfo = LocationStore.transfer(amountOrigin, locationToAmount, amountToTransferStandarized);
	      transferInfo.locationFromId = locationFromId;
	      transferInfo.locationToId = locationToId;
	      transferInfo.itemId = itemId;
	
	      LocationStore.saveTransfer(transferInfo, function () {
	        Notification.show(t('inventory_and_transfer_modal_transfer_success'), 'success');
	        self.close();
	      }, function () {
	        Notification.show(t('dashboard_notification_something_was_wrong'));
	      });
	    } else {
	      this.setState({
	        locationsAmountMessageError: messageError
	      });
	    }
	  },
	  show: function show(selectedLocationItemFrom) {
	    var _this = this;
	
	    var locations = this.props.locations;
	
	
	    var enableLocations = ContentUtils.filterEnable(locations);
	
	    // Select location destination
	    var selectedLocationId = get(selectedLocationItemFrom, 'locationId', '') || get(selectedLocationItemFrom, 'location.id');
	    var locationsWithoutFrom = filter(enableLocations, function (location) {
	      return get(location, 'id') !== selectedLocationId;
	    }) || [];
	    var selectedLocationItemTo = get(locationsWithoutFrom, '0'); // just pick the first one
	    var locationsToIndex = 1; // always the first one
	
	    var initialState = {
	      locationsWithoutFrom: locationsWithoutFrom,
	      locationsToIndex: locationsToIndex,
	      selectedLocationItemFrom: selectedLocationItemFrom,
	      selectedLocationItemTo: selectedLocationItemTo,
	      selectedLocationToId: get(selectedLocationItemTo, 'id'),
	      estimatedOrigin: null,
	      estimatedDestination: null,
	      amountToTransfer: 0, // initial,
	      isVisible: true
	    };
	
	    this.setState(initialState, function () {
	      _this.focusAmount();
	    });
	  },
	  close: function close() {
	    var self = this;
	    this.setState(this.getInitialState(), function () {
	      self.props.onClose();
	    });
	  },
	  _onChangeLocationTo: function _onChangeLocationTo(locationToSelected) {
	    this._inputAmountToTransfer.setValue('');
	
	    var itemId = get(this.state, 'selectedLocationItemFrom.itemId');
	    var itemUnit = get(this.state, 'selectedLocationItemFrom.unit');
	    var locationId = get(locationToSelected, 'itemModel.id');
	    var selectedLocationItemTo = find(this.props.locationItems, function (locationItem) {
	      return get(locationItem, 'itemId') === itemId && get(locationItem, 'locationId') === locationId;
	    });
	    if (!selectedLocationItemTo) {
	      var emptyState = {
	        itemId: itemId,
	        itemUnit: itemUnit,
	        locationId: locationId,
	        locationName: locationToSelected.text,
	        applicantId: SessionStore.getCurrentApplicantId(),
	        locationsItems: this.props.locationItems
	      };
	      selectedLocationItemTo = getEmptyLocationItemTo(emptyState);
	    }
	    this.setState(function (prevState) {
	      return {
	        locationsToIndex: get(locationToSelected, 'payload'),
	        selectedLocationItemTo: selectedLocationItemTo,
	        estimatedDestination: null, // reset destination in order to re-calculate total destination again
	        amountToTransfer: null,
	        estimatedOrigin: get(prevState, 'selectedLocationItemFrom.amount'), // reset to origin amount
	        // reset message error
	        locationToId: locationId,
	        locationsFromMessageError: '',
	        locationsToMessageError: '',
	        locationsAmountMessageError: '',
	        itemMessageError: ''
	      };
	    });
	  },
	  _onChangeAmount: function _onChangeAmount(evt) {
	    var _this2 = this;
	
	    var amountToTransfer = NumberUtils.standardiseDecimalFormatNumber(NumberUtils.getNumberString(get(evt, 'target.value')));
	
	    var _state2 = this.state,
	        selectedLocationItemFrom = _state2.selectedLocationItemFrom,
	        selectedLocationItemTo = _state2.selectedLocationItemTo;
	
	
	    this.setState(function (prevState) {
	      // amount origin
	      var amountOriginPristine = get(selectedLocationItemFrom, 'amount');
	
	      // amount destination
	      var amountDestinationPristine = get(selectedLocationItemTo, 'amount');
	
	      var messageError = LocationStore.isValidTransfer(amountOriginPristine, _this2.state.estimatedOrigin, amountToTransfer);
	      var isValidTransfer = messageError === '';
	
	      if (isValidTransfer) {
	        // make transfer
	        var estimatedTransferInfo = LocationStore.transfer(amountOriginPristine, amountDestinationPristine, amountToTransfer);
	        var estimatedOrigin = get(estimatedTransferInfo, 'locationItemAmountFrom');
	        var estimatedDestination = get(estimatedTransferInfo, 'locationItemAmountTo');
	
	        return {
	          amountToTransfer: amountToTransfer,
	          estimatedOrigin: estimatedOrigin,
	          estimatedDestination: estimatedDestination,
	          // reset message error
	          locationsFromMessageError: '',
	          locationsToMessageError: '',
	          locationsAmountMessageError: '',
	          itemMessageError: ''
	        };
	      } else {
	        return {
	          locationsAmountMessageError: messageError
	        };
	      }
	    });
	  },
	  _onChangeItem: function _onChangeItem(evt, index, itemSelected) {
	    this.setState({
	      itemsIndex: get(itemSelected, 'payload')
	    });
	  },
	  _getContentEl: function _getContentEl() {
	    var _this3 = this;
	
	    var _props = this.props,
	        locations = _props.locations,
	        locationItems = _props.locationItems;
	
	    var enableLocations = ContentUtils.filterEnable(locations);
	    var _state3 = this.state,
	        estimatedOrigin = _state3.estimatedOrigin,
	        estimatedDestination = _state3.estimatedDestination,
	        selectedLocationItemFrom = _state3.selectedLocationItemFrom,
	        selectedLocationItemTo = _state3.selectedLocationItemTo,
	        locationsWithoutFrom = _state3.locationsWithoutFrom;
	
	    var itemMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(locationItems, t('inventory_and_transfer_select_items_placeholder'), t('description'));
	
	    // From information
	    var selectedItemId = get(selectedLocationItemFrom, 'itemId', '');
	    var selectedLocationId = get(selectedLocationItemFrom, 'locationId', '');
	    var unit = get(selectedLocationItemFrom, 'unit', '');
	    var unitWithParenthesis = unit ? ' (' + unit + ')' : unit;
	    var locationIndexFrom = findIndex(enableLocations, function (location) {
	      return get(location, 'id') === selectedLocationId;
	    }) + 1;
	    var itemIndexFrom = findIndex(locationItems, function (locationItem) {
	      return get(locationItem, 'itemId') === selectedItemId;
	    }) + 1;
	    var locationItemFrom = estimatedOrigin || estimatedOrigin === 0 ? NumberUtils.formatDecimal(estimatedOrigin, AMOUNT_DECIMALS) : NumberUtils.formatDecimal(get(selectedLocationItemFrom, 'amount'), AMOUNT_DECIMALS);
	    var locationMenuItems = ComponentUtils.toMenuItemsWithNonSelectedItem(enableLocations, t('inventory_and_transfer_select_location_placeholder'));
	
	    // To information
	    var locationItemToAmount = get(selectedLocationItemTo, 'amount');
	
	    return React.createElement("div", { className: "bp-location-transfer-modal" }, React.createElement("div", { className: "bp-location-transfer-modal__header" }, React.createElement("h4", { className: "bp-location-transfer-modal__header-title" }, t('inventory_and_transfer_modal_from_label')), React.createElement("hr", null), React.createElement("div", { className: "bp-location-transfer-modal__fields" }, React.createElement(SelectField, {
	      id: "",
	      className: "bp-location-transfer-modal__select-from",
	      floatingLabelText: t('inventory_and_transfer_modal_from_label'),
	      menuItems: locationMenuItems,
	      errorText: this.state.locationsFromMessageError,
	      value: locationIndexFrom,
	      disabled: true
	    }), React.createElement(SelectField, {
	      floatingLabelText: '' + t('inventory_and_transfer_items') + unitWithParenthesis,
	      menuItems: itemMenuItems,
	      errorText: this.state.itemMessageError,
	      value: itemIndexFrom,
	      disabled: true
	    }), React.createElement(TextField, {
	      className: "bp-location-transfer-modal__input",
	      value: locationItemFrom,
	      floatingLabelText: t('inventory_and_transfer_modal_amount_in_locations') + ' ' + unitWithParenthesis,
	      onEnterKeyDown: this._onSaveAndClose,
	      onBlur: this._onChangeAmount,
	      disabled: true }))), React.createElement("div", { className: "bp-location-transfer-modal__body" }, React.createElement("h4", { className: "bp-location-transfer-modal__body-title" }, t('inventory_and_transfer_modal_to_label')), React.createElement("hr", null), React.createElement("div", { className: "bp-location-transfer-modal__fields" }, React.createElement(DropDown, {
	      className: "bp-location-transfer-modal__select-to",
	      floatingLabelText: t('inventory_and_transfer_modal_to_label'),
	      onChange: this._onChangeLocationTo,
	      items: locationsWithoutFrom,
	      readerAttribute: "name",
	      name: t('inventory_and_transfer_location'),
	      errorText: this.state.locationsToMessageError,
	      selectedIndex: this.state.locationsToIndex }), React.createElement(TextField, {
	      ref: function ref(input) {
	        return _this3._inputAmountToTransfer = input;
	      },
	      className: "bp-location-transfer-modal__input",
	      hintText: t('inventory_and_transfer_modal_enter_amount'),
	      floatingLabelText: t('inventory_and_transfer_amount') + ' ' + unitWithParenthesis,
	      onEnterKeyDown: this._onSaveAndClose,
	      onBlur: this._onChangeAmount,
	      errorText: this.state.locationsAmountMessageError }), React.createElement(TextField, {
	      className: "bp-location-transfer-modal__input",
	      value: NumberUtils.formatDecimal(estimatedDestination ? estimatedDestination : locationItemToAmount, AMOUNT_DECIMALS),
	      floatingLabelText: t('inventory_and_transfer_modal_amount_in_locations') + ' ' + unitWithParenthesis,
	      onEnterKeyDown: this._onSaveAndClose,
	      onBlur: this._onChangeAmount,
	      disabled: true }))));
	  },
	  _getActionsModal: function _getActionsModal() {
	    return [React.createElement(FlatButton, {
	      label: t('inventory_and_transfer_modal_cancel'),
	      onTouchTap: this.close
	    }), React.createElement(FlatButton, {
	      label: t('inventory_and_transfer_modal_save'),
	      onTouchTap: this._onSaveAndClose,
	      primary: true
	    })];
	  },
	  render: function render() {
	    var selectedModule = this.props.selectedModule;
	    var selectedLocationItemFrom = this.state.selectedLocationItemFrom;
	
	
	    if (!selectedLocationItemFrom) {
	      return null;
	    }
	
	    var actionsEl = this._getActionsModal(selectedLocationItemFrom);
	    var contentEl = this._getContentEl(selectedLocationItemFrom, selectedModule);
	
	    return React.createElement(CustomModal, {
	      actions: actionsEl,
	      title: this.state.title,
	      isVisible: this.state.isVisible,
	      customClass: "inventory-transfer-modal modal-transfer"
	    }, contentEl);
	  }
	});
	
	function getEmptyLocationItemTo(emptyState) {
	  var totalAmount = getTotalItemAmountCrossLocation(locationItems, itemId);
	  var itemId = emptyState.itemId,
	      itemUnit = emptyState.itemUnit,
	      locationId = emptyState.locationId,
	      locationName = emptyState.locationName,
	      applicantId = emptyState.applicantId,
	      locationItems = emptyState.locationItems;
	
	  return {
	    isEnable: true,
	    id: undefined, // because it doesn't exist yet
	    name: locationName,
	    item: { id: itemId },
	    location: { id: locationId },
	    applicant: { id: applicantId },
	    amount: '0',
	    totalAmount: totalAmount,
	    totalAmountFormatted: NumberUtils.formatDecimal(totalAmount) + ' ' + itemUnit
	  };
	}
	
	function getTotalItemAmountCrossLocation(locationItems, itemId) {
	  var locationItemsFiltered = filter(locationItems, function (locationItem) {
	    return get(locationItem, 'itemId') === itemId;
	  });
	  if (ContentUtils.isNotEmptyArray(locationItemsFiltered)) {
	    var locationItemsAmount = map(locationItems, function (locationItem) {
	      return get(locationItem, 'amount');
	    }) || ['0']; // empty state
	    return reduce(locationItemsAmount, function (total, amount) {
	      return NumberUtils.sum(total, amount);
	    }) || '0'; // empty state
	  }
	}
	
	module.exports = InventoryAndTransfersModal;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTablePaged = __webpack_require__(178),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Authentication = __webpack_require__(13).Authentication,
	    ContentUtils = __webpack_require__(7),
	    InventoryStore = __webpack_require__(20),
	    Notification = __webpack_require__(21),
	    NavigationUtils = __webpack_require__(35),
	    _require2 = __webpack_require__(8),
	    orderBy = _require2.orderBy,
	    map = _require2.map,
	    filter = _require2.filter,
	    Constants = __webpack_require__(2),
	    get = __webpack_require__(5).get,
	    CustomDialog = __webpack_require__(26),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var pageUrl = '/items/page/';
	
	var ItemsAdmin = React.createClass({ displayName: "ItemsAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            isEditMode: false,
	            isFetching: true,
	            filter: {
	                code: '',
	                description: '',
	                category: '',
	                subCategory: '',
	                unit: ''
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	        ga.pageview('/items-admin');
	    },
	    fetchItems: function fetchItems() {
	        var self = this;
	        var currentPage = NavigationUtils.getPathParam('page');
	        InventoryStore.fetchItems(currentPage, function (items) {
	            InventoryStore.fetchLocation(function (locations) {
	                var itemsSorted = ContentUtils.filterEnable(ContentUtils.sortList(items, 'description'));
	                var locationSorted = ContentUtils.filterEnable(ContentUtils.sortList(locations, 'name'));
	                self.setState({
	                    items: self.filterVirtualSaleItems(itemsSorted),
	                    locations: ContentUtils.filterEnable(locationSorted),
	                    isFetching: false
	                });
	            });
	        });
	    },
	    fetchItemsBy: function fetchItemsBy(filter) {
	        var self = this;
	        InventoryStore.fetchItemsBy(filter, function (items) {
	            InventoryStore.fetchLocation(function (locations) {
	                var itemsSorted = ContentUtils.sortList(ContentUtils.filterEnable(items), 'description');
	                var locationSorted = ContentUtils.sortList(ContentUtils.filterEnable(locations), 'name');
	                self.setState({
	                    items: self.filterVirtualSaleItems(itemsSorted),
	                    locations: ContentUtils.filterEnable(locationSorted),
	                    isFetching: false
	                });
	            });
	        });
	    },
	    _onClickPage: function _onClickPage(page) {
	        this.transitionTo('/items/page/:page', { page: page });
	        this.fetchItems();
	    },
	    filterVirtualSaleItems: function filterVirtualSaleItems(items) {
	        return filter(items, function (item) {
	            return get(item, 'category') !== Constants.SALE_VIRTUAL_ITEM_CATEGORY;
	        });
	    },
	    onDeleteItem: function onDeleteItem(item, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('item_admin_delete_warning'), function () {
	            InventoryStore.deleteItem(item, onSuccess, onFailure);
	        });
	    },
	    onChangeItem: function onChangeItem(item, onSuccess, onFailure) {
	        InventoryStore.changeItem(item, onSuccess, onFailure);
	        this.setState(_extends(this.getInitialState(), { selectedItem: item }));
	    },
	    onAddItem: function onAddItem(item, onSuccess, onFailure) {
	        InventoryStore.addItem(item, onSuccess, onFailure);
	    },
	    onDuplicate: function onDuplicate(contextHolder) {
	        var _this = this;
	
	        // get value from all fiels
	        var currentSelectedItem = contextHolder.getItem();
	
	        // override with duplicate label
	        currentSelectedItem.description = ContentUtils.formatDuplicateName(currentSelectedItem.description);
	
	        // remove id in order to generate a new one like new item
	        currentSelectedItem.id = null;
	
	        this.onAddItem(currentSelectedItem, function () {
	            Notification.show(t('item_admin_item_duplicated_success'), 'success');
	            _this.fetchItems();
	        });
	    },
	    shouldNotAllowRepeatName: function shouldNotAllowRepeatName(items, newItemName) {
	        var itemNames = map(items, function (item) {
	            return get(item, 'description');
	        }) || [];
	        var currentItemDescription = get(this.state, 'selectedItem.description');
	
	        if (currentItemDescription) {
	            itemNames = filter(itemNames, function (itemName) {
	                return itemName != currentItemDescription;
	            });
	        }
	
	        var alreadyExist = itemNames.indexOf(newItemName) > -1;
	
	        return alreadyExist ? t('item_admin_item_already_exist') : '';
	    },
	    _onTypingFilter: function _onTypingFilter(name, match) {
	        var _this2 = this;
	
	        if (!this.state.isFetching) {
	            this.setState(function (prevState) {
	                var nextFilter = prevState.filter || {};
	                nextFilter[name] = match;
	                _this2.fetchItemsBy(nextFilter);
	                return {
	                    filter: nextFilter,
	                    isFetching: true
	                };
	            });
	        }
	    },
	    _onCancel: function _onCancel() {
	        this.transitionTo(getCurrentUrl());
	        this.setState({
	            selectedItem: null,
	            isEditMode: false,
	            filter: {
	                code: '',
	                description: '',
	                category: '',
	                subCategory: '',
	                unit: '',
	                salePrice: ''
	            }
	        });
	    },
	    _printReport: function _printReport() {
	        InventoryStore.downloadReportXLS(this.state.filter, 'items');
	    },
	    _onChangeDropDownItem: function _onChangeDropDownItem(selectedItem) {
	        this.setState({
	            selectProductItemDropDown: selectedItem
	        });
	    },
	    _onChangeDropDownLocation: function _onChangeDropDownLocation(selectedItem) {
	        this.setState({
	            selectProductItemDropDown: selectedItem
	        });
	    },
	    render: function render() {
	        if (!this.state.items) {
	            return React.createElement(Loading, null);
	        } else {
	            var CATEGORIES_TEXTS = Constants.getCategoryMapping(t);
	            var CATEGORIES = Constants.ITEM_CATEGORY.map(function (category) {
	                return { category: category, displayText: CATEGORIES_TEXTS[category] };
	            });
	            var messages = {
	                changeSuccessMessage: t('item_admin_change_success'),
	                changeFailureMessage: t('item_admin_change_failure'),
	                deleteSuccessMessage: t('item_admin_delete_success'),
	                addSuccessMessage: t('item_admin_add_success'),
	                addFailureMessage: t('item_admin_add_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'DUPLICATE',
	                el: React.createElement(FormGroupButton, {
	                    label: t('button_duplicate'),
	                    icon: "content_copy",
	                    type: "icon",
	                    onClick: this.onDuplicate.bind(this, contextHolder) })
	            }];
	
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                items = _state.items,
	                isEditMode = _state.isEditMode,
	                locations = _state.locations,
	                isFetching = _state.isFetching;
	
	
	            var currentSelectedCategory = selectedItem && selectedItem.category ? CATEGORIES_TEXTS[selectedItem.category] : '';
	
	            var currentSelectedCategoryValue = currentSelectedCategory ? _extends({}, selectedItem, { displayText: currentSelectedCategory }) : selectedItem;
	
	            var secuancialOrder = ContentUtils.filterEnable(orderBy(items, 'description'));
	
	            if (secuancialOrder && secuancialOrder.length) {
	                secuancialOrder = secuancialOrder.map(function (item) {
	                    item.displayCategory = CATEGORIES_TEXTS[item.category];
	                    return item;
	                });
	            }
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "description",
	                isRelaxedText: true,
	                name: t('item_admin_description_label'),
	                value: selectedItem,
	                label: t('item_admin_description_label'),
	                isEditMode: isEditMode,
	                additionalValidation: this.shouldNotAllowRepeatName.bind(this, secuancialOrder),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextFieldSuggested, {
	                operationsHolder: contextHolder,
	                items: CATEGORIES,
	                readerAttribute: "displayText",
	                readerAttributeValue: "category",
	                writerAttribute: "category",
	                name: t('item_admin_category'),
	                label: t('item_admin_category'),
	                isImmutable: true,
	                value: currentSelectedCategoryValue,
	                onChange: this._onChangeDropDownItem,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "subCategory",
	                isRelaxedText: true,
	                isRequired: false,
	                name: t('item_admin_subcategory'),
	                value: selectedItem,
	                label: t('item_admin_subcategory'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "unit",
	                isRelaxedText: true,
	                name: t('item_admin_unit'),
	                value: selectedItem,
	                label: t('item_admin_unit'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextFieldSuggested, {
	                operationsHolder: contextHolder,
	                items: locations,
	                readerAttribute: "name",
	                writerAttribute: "preferredLocationId",
	                readerAttributeValue: "id",
	                label: t('item_admin_preferred_location'),
	                name: t('item_admin_preferred_location'),
	                isImmutable: true,
	                value: get(selectedItem, 'preferredLocation'),
	                onChange: this._onChangeDropDownLocation,
	                onEnter: this.__onEnterPress })];
	
	            var totalItems = get(secuancialOrder, '0.totalSize') || 0;
	            var self = this;
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('item_admin_title'),
	                moduleName: "ADMIN_ITEM",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: function fetchItems() {
	                    return (self.fetchItems() || []).map(function (item) {
	                        item.displayCategory = CATEGORIES_TEXTS[item.category];
	                        return item;
	                    });
	                },
	                headerFields: formFieldsEl,
	                onAdd: this.onAddItem,
	                onChange: this.onChangeItem,
	                onCancel: this._onCancel,
	                onDelete: this.onDeleteItem,
	                additionalButtons: additionalButtons,
	                addEnterKeyDown: this.__addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTablePaged, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['description'],
	                filteredColumns: ['code', 'description', 'category', 'subCategory', 'unit'],
	                displayAttributes: ['code', 'description', 'displayCategory', 'subCategory', 'unit', 'preferredLocation.name'],
	                columnNames: [t('item_admin_column_code'), t('item_admin_column_item_description'), t('item_admin_column_category'), t('item_admin_column_sub_category'), t('item_admin_column_unit'), t('item_admin_column_preferred_location')],
	                isLoading: isFetching,
	                maxPage: ContentUtils.getAmountPageNeeded(totalItems, Constants.MAX_ITEMS_BY_PAGES_ADMINS),
	                onClickPage: this._onClickPage,
	                currentPage: NavigationUtils.getPathParam('page'),
	                columnsFilterValue: this.state.filter,
	                onCancel: this._onCancel,
	                onTypingFilter: this._onTypingFilter
	            }, secuancialOrder)));
	        }
	    }
	});
	
	function getCurrentUrl() {
	    return pageUrl + NavigationUtils.getPathParam('page');
	}
	module.exports = ItemsAdmin;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    Authentication = __webpack_require__(13).Authentication,
	    ContentUtils = __webpack_require__(7),
	    InventoryStore = __webpack_require__(20),
	    NavigationUtils = __webpack_require__(35),
	    _require2 = __webpack_require__(8),
	    orderBy = _require2.orderBy,
	    map = _require2.map,
	    filter = _require2.filter,
	    Constants = __webpack_require__(2),
	    get = __webpack_require__(5).get,
	    CustomDialog = __webpack_require__(26),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var pageUrl = '/non-inventory-items';
	
	var NonInventoryItemsAdmin = React.createClass({ displayName: "NonInventoryItemsAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            isEditMode: false,
	            isFetching: true,
	            filter: {
	                code: '',
	                description: '',
	                category: '',
	                subCategory: '',
	                unit: '',
	                salePrice: ''
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	        ga.pageview('/non-items-admin');
	    },
	    fetchItems: function fetchItems() {
	        var self = this;
	        InventoryStore.fetchNonInventoryItems(function (items) {
	            var itemsSorted = ContentUtils.filterEnable(ContentUtils.sortList(items, 'description'));
	            self.setState({
	                items: self.filterVirtualSaleItems(itemsSorted),
	                isFetching: false
	            });
	        });
	    },
	    fetchItemsBy: function fetchItemsBy(filter) {
	        var self = this;
	        InventoryStore.fetchItemsBy(filter, function (items) {
	            var itemsSorted = ContentUtils.sortList(ContentUtils.filterEnable(items), 'description');
	            self.setState({
	                items: self.filterVirtualSaleItems(itemsSorted),
	                isFetching: false
	            });
	        });
	    },
	    filterVirtualSaleItems: function filterVirtualSaleItems(items) {
	        return filter(items, function (item) {
	            return get(item, 'category') !== Constants.SALE_VIRTUAL_ITEM_CATEGORY;
	        });
	    },
	    onDeleteItem: function onDeleteItem(item, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('non_inventory_warning_delete_items'), function () {
	            InventoryStore.deleteItem(item, onSuccess, onFailure);
	        });
	    },
	    onChangeItem: function onChangeItem(item, onSuccess, onFailure) {
	        item.category = Constants.ITEM_CATEGORY_NON_INVENTORY;
	        InventoryStore.changeItem(item, onSuccess, onFailure);
	    },
	    onAddItem: function onAddItem(item, onSuccess, onFailure) {
	        item.category = Constants.ITEM_CATEGORY_NON_INVENTORY;
	        InventoryStore.addItem(item, onSuccess, onFailure);
	    },
	    shouldNotAllowRepeatName: function shouldNotAllowRepeatName(items, newItemName) {
	        var itemNames = map(items, function (item) {
	            return get(item, 'description');
	        }) || [];
	        var currentItemDescription = get(this.state, 'selectedItem.description');
	
	        if (currentItemDescription) {
	            itemNames = filter(itemNames, function (itemName) {
	                return itemName != currentItemDescription;
	            });
	        }
	
	        var alreadyExist = itemNames.indexOf(newItemName) > -1;
	
	        return alreadyExist ? t('non_inventory_error_item_already_exist') : '';
	    },
	    _onTypingFilter: function _onTypingFilter(name, match) {
	        var _this = this;
	
	        if (!this.state.isFetching) {
	            this.setState(function (prevState) {
	                var nextFilter = prevState.filter || {};
	                nextFilter[name] = match;
	                _this.fetchItemsBy(nextFilter);
	                return {
	                    filter: nextFilter,
	                    isFetching: true
	                };
	            });
	        }
	    },
	    _onCancel: function _onCancel() {
	        this.transitionTo(getCurrentUrl());
	        this.setState({
	            selectedItem: null,
	            isEditMode: false,
	            filter: {
	                code: '',
	                description: '',
	                category: '',
	                subCategory: '',
	                unit: '',
	                salePrice: ''
	            }
	        });
	    },
	    render: function render() {
	        if (!this.state.items) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('non_inventory_items_change_success'),
	                changeFailureMessage: t('non_inventory_items_change_failure'),
	                deleteSuccessMessage: t('non_inventory_items_delete_success'),
	                addSuccessMessage: t('non_inventory_items_add_success'),
	                addFailureMessage: t('non_inventory_items_add_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                items = _state.items,
	                isEditMode = _state.isEditMode,
	                isFetching = _state.isFetching;
	
	            var secuancialOrder = ContentUtils.filterEnable(orderBy(items, 'description'));
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "description",
	                isRelaxedText: true,
	                name: t('non_inventory_column_item_description'),
	                value: selectedItem,
	                label: t('non_inventory_item_description'),
	                isEditMode: isEditMode,
	                additionalValidation: this.shouldNotAllowRepeatName.bind(this, secuancialOrder),
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "unit",
	                isRelaxedText: true,
	                name: t('non_inventory_item_unit'),
	                value: selectedItem,
	                label: t('non_inventory_item_unit'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "salePrice",
	                isRelaxedText: true,
	                name: t('non_inventory_item_price'),
	                value: selectedItem,
	                label: t('non_inventory_item_price'),
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('non_inventory_items_title'),
	                moduleName: "ADMIN_ITEM",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchItems,
	                headerFields: formFieldsEl,
	                onAdd: this.onAddItem,
	                onChange: this.onChangeItem,
	                onCancel: this._onCancel,
	                onDelete: this.onDeleteItem,
	                addEnterKeyDown: this.__addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['description'],
	                filteredColumns: ['code', 'description', 'category', 'subCategory', 'unit', 'salePrice'],
	                displayAttributes: ['code', 'description', 'category', 'unit', 'salePrice'],
	                columnNames: [t('non_inventory_column_code'), t('non_inventory_column_item_description'), t('non_inventory_column_category'), t('non_inventory_column_unit'), t('non_inventory_column_price')],
	                isLoading: isFetching,
	                columnsFilterValue: this.state.filter,
	                onCancel: this._onCancel,
	                onTypingFilter: this._onTypingFilter
	            }, secuancialOrder)));
	        }
	    }
	});
	
	function getCurrentUrl() {
	    return pageUrl + NavigationUtils.getPathParam('page');
	}
	
	module.exports = NonInventoryItemsAdmin;

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    CustomDialog = __webpack_require__(26),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(8),
	    orderBy = _require2.orderBy,
	    filter = _require2.filter,
	    ga = __webpack_require__(18);
	
	
	var LocationsAdmin = React.createClass({ displayName: "LocationsAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedLocation: null,
	            isEditMode: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchLocation();
	        ga.pageview('/locations-admin');
	    },
	    fetchLocation: function fetchLocation() {
	        var self = this;
	        InventoryStore.fetchLocation(function (locations) {
	            self.setState({
	                locations: locations
	            });
	        });
	    },
	    _onDeleteLocation: function _onDeleteLocation(location, onSuccess, onFailure) {
	        var haveSingleLocation = get(filter(this.state.locations, function (location) {
	            return location.enable;
	        }), 'length') === 1;
	        if (haveSingleLocation) {
	            CustomDialog.showInfo(t('error'), t('location_admin_error_must_exist_one_location'));
	        } else {
	            CustomDialog.showWarningConfirmation(t('warning'), t('location_admin_warning_deleting_location_will_remove_all_related'), function () {
	                InventoryStore.deleteLocation(location, onSuccess, onFailure);
	            });
	        }
	    },
	    _onChangeLocation: function _onChangeLocation(location, onSuccess, onFailure) {
	        InventoryStore.changeLocation(location, onSuccess, onFailure);
	    },
	    _onAddLocation: function _onAddLocation(location, onSuccess, onFailure) {
	        InventoryStore.addLocation(location, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(location, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedLocation: location,
	            isEditMode: !!location,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedLocation: null,
	            isEditMode: false
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    render: function render() {
	        if (!this.state.locations) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('location_admin_change_success'),
	                changeFailureMessage: t('location_admin_change_failure'),
	                deleteSuccessMessage: t('location_admin_delete_success'),
	                addSuccessMessage: t('location_admin_add_success'),
	                addFailureMessage: t('location_admin_failure_success')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedLocation = _state.selectedLocation,
	                locations = _state.locations,
	                isEditMode = _state.isEditMode;
	
	            var secuancialOrder = orderBy(locations, 'description');
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                isRequired: true,
	                name: t('location_admin_name'),
	                value: selectedLocation,
	                label: t('location_admin_name'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "address",
	                isRequired: false,
	                name: t('location_admin_address'),
	                value: selectedLocation,
	                label: t('location_admin_address'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "location-items-view" }, React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_LOCATION",
	                title: t('location_admin_title'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedLocation,
	                fetchItems: this.fetchLocation,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddLocation,
	                onChange: this._onChangeLocation,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteLocation,
	                addEnterKeyDown: this._addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this._onRowSelection,
	                value: selectedLocation,
	                filteredColumns: ['name'],
	                sortByColumn: ['name'],
	                columnNames: [t('location_admin_column_name'), t('location_admin_column_address')],
	                displayAttributes: ['name', 'address']
	            }, secuancialOrder)));
	        }
	    }
	});
	
	module.exports = LocationsAdmin;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    mui = __webpack_require__(12),
	    RaisedButton = mui.RaisedButton,
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation;
	
	
	var Page404 = React.createClass({ displayName: "Page404",
	
	    mixins: [Navigation],
	
	    handleSubmit: function handleSubmit() {
	        this.transitionTo('/dashboard');
	    },
	
	
	    render: function render() {
	        return React.createElement("div", { className: "text-center jumbotron",
	            style: {
	                paddingTop: '5%',
	                backgroundColor: '#fff'
	            } }, React.createElement("h1", null, t('page404_message_error_404')), React.createElement("h3", null, t('page404_message_error_beer_not_found')), React.createElement("br", null), React.createElement(RaisedButton, { label: t('page404_label_go_to_dashboard'), secondary: true, onClick: this.handleSubmit }));
	    }
	});
	
	module.exports = Page404;

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(693);
	
	var React = __webpack_require__(14),
	    mui = __webpack_require__(12),
	    TextField = mui.TextField,
	    RaisedButton = mui.RaisedButton,
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    ContentUtils = __webpack_require__(7),
	    NavigationUtils = __webpack_require__(35),
	    SecurityServiceImpl = __webpack_require__(408),
	    _require2 = __webpack_require__(79),
	    toLower = _require2.toLower,
	    ERROR_CODE_USERNAME_DO_NOT_EXIST = __webpack_require__(2).ERROR_CODE_USERNAME_DO_NOT_EXIST,
	    REGEX_NAME_DEFAULT = __webpack_require__(2).REGEX_NAME_DEFAULT;
	
	
	var Router = __webpack_require__(19);
	
	var PasswordRecovery = React.createClass({ displayName: "PasswordRecovery",
	
	    contextTypes: {
	        router: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            error: false
	        };
	    },
	
	    handleSubmit: function handleSubmit(event) {
	        event.preventDefault();
	        var username = toLower(this.refs.username.getValue());
	        var pass = this.refs.pass.getValue();
	
	        if (this.isValidForm) {
	            SecurityServiceImpl.passwordRecovery(username, pass, this._onSuccess, this._onFailure);
	        }
	    },
	
	    _onSuccess: function _onSuccess() {
	        var router = this.context.router;
	
	        var nextPath = router.getCurrentQuery().nextPath;
	        if (nextPath) {
	            router.replaceWith(nextPath);
	        } else {
	            router.replaceWith('/checkEmailResetPassword');
	        }
	    },
	
	    _onFailure: function _onFailure(message) {
	        this.setState({
	            error: true,
	            errorUsername: message.message.indexOf(ERROR_CODE_USERNAME_DO_NOT_EXIST) > -1 ? t('password_recovery_inline_error_username_does_not_exist') : ''
	        });
	        this.forceUpdate();
	    },
	
	    isValidForm: function isValidForm() {
	        var messagesError = this._getEmptyModelForm(null),
	            isValid = true,
	            pass = this.refs.pass.getValue(),
	            passAgain = this.refs.passAgain.getValue();
	
	        if (pass != passAgain) {
	            messagesError.errorPassword = t('password_recovery_inline_error_password_does_not_match');
	            messagesError.errorPasswordAgain = t('password_recovery_inline_error_password_does_not_match');
	            isValid = false;
	        }
	
	        if (ContentUtils.isEmptyField(this.refs.username)) {
	            messagesError.errorUsername = t('password_recovery_inline_error_username_required');
	            isValid = false;
	        } else if (!REGEX_NAME_DEFAULT.test(this.refs.username.getValue()) || this.refs.username.getValue().trim() === '') {
	            messagesError.errorUsername = t('password_recovery_inline_error_username_does_not_exist');
	            isValid = false;
	        }
	
	        if (ContentUtils.isEmptyField(this.refs.pass)) {
	            messagesError.errorPassword = t('password_recovery_inline_error_password_required');
	            isValid = false;
	        }
	
	        if (ContentUtils.isEmptyField(this.refs.passAgain)) {
	            messagesError.errorPasswordAgain = t('password_recovery_inline_error_password_required');
	            isValid = false;
	        }
	
	        this.setState(messagesError);
	
	        return isValid;
	    },
	
	    _getEmptyModelForm: function _getEmptyModelForm() {
	        return {
	            errorUsername: '',
	            errorPassword: '',
	            errorPasswordAgain: ''
	        };
	    },
	
	    render: function render() {
	        return React.createElement("div", { id: "page-passwordrecovery", style: { marginTop: SessionStore.isFullPaidVersion() ? '100px' : '0' }, className: "row" }, React.createElement("div", {
	            className: "text-center col-xs-8 col-xs-offset-2 col-sm-5 col-sm-offset-4 col-md-4 col-md-offset-4 col-lg-4 col-lg-offset-4" }, React.createElement("form", { onSubmit: this.handleSubmit, className: "box" }, React.createElement("div", { className: "box-content login-content" }, React.createElement("div", { className: "text-center" }, React.createElement("img", { src: "/assets/images/logo-small.png" })), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            className: "full-width",
	            ref: "username",
	            hintText: t('password_recovery_placeholder_username'),
	            defaultValue: NavigationUtils.getQueryParam('userName') || '',
	            floatingLabelText: t('password_recovery_label_username'),
	            onEnterKeyDown: this.handleSubmit,
	            onBlur: this.isValidForm,
	            errorText: this.state.errorUsername })), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            type: "password",
	            className: "full-width",
	            ref: "pass",
	            hintText: t('password_recovery_placeholder_new_password'),
	            defaultValue: "",
	            floatingLabelText: t('password_recovery_label_new_password'),
	            onEnterKeyDown: this.handleSubmit,
	            onBlur: this.isValidForm,
	            errorText: this.state.errorPassword })), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            type: "password",
	            className: "full-width",
	            ref: "passAgain",
	            hintText: t('password_recovery_placeholder_confirm_new_password'),
	            defaultValue: "",
	            floatingLabelText: t('password_recovery_label_confirm_new_password'),
	            onEnterKeyDown: this.handleSubmit,
	            onBlur: this.isValidForm,
	            errorText: this.state.errorPasswordAgain })), React.createElement("div", { className: "text-center" }, React.createElement(RaisedButton, { label: t('password_recovery_primary_button'), secondary: true, onClick: this.handleSubmit }))))));
	    }
	});
	
	module.exports = PasswordRecovery;

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    NavigationUtils = __webpack_require__(35);
	
	
	var PreActivated = React.createClass({ displayName: "PreActivated",
	
	  render: function render() {
	    return React.createElement("div", { className: "preactivated-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h1", { className: "preactivated-page-container__header light" }, t('pre_activated_title')), React.createElement("p", {
	      className: "preactivated-page-container__body" }, t('pre_activated_description_1') + ' ', React.createElement("strong", null, NavigationUtils.getQueryParam('email')), ' ' + t('pre_activated_description_2')), React.createElement("br", null), React.createElement("div", { className: "preactivated-page-container__footer" }, React.createElement("p", {
	      className: "preactivated-page-container__footer-signature" }, t('confirm_new_password_static_page_greeting')), React.createElement("img", { style: { height: '60px' }, src: "/assets/images/logo-small-dark.png" }), React.createElement("p", { className: "preactivated-page-container__mail-support" }, t('pre_activated_did_not_receive_email') + ' ', React.createElement("a", {
	      href: "mailto:support@brewplanner.com?Subject=Need%20help",
	      target: "_top" }, "support@brewplanner.com"), "."))));
	  }
	});
	
	module.exports = PreActivated;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupDropdown = __webpack_require__(58),
	    Authentication = __webpack_require__(13).Authentication,
	    NumberUtils = __webpack_require__(23),
	    BrewhouseStore = __webpack_require__(96),
	    AppConstants = __webpack_require__(2),
	    CustomDialog = __webpack_require__(26),
	    ga = __webpack_require__(18);
	
	
	var TaskAdmin = React.createClass({ displayName: "TaskAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            isEditMode: false
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.fetchTask();
	        ga.pageview('/task-admin');
	    },
	
	    fetchTask: function fetchTask() {
	        var self = this;
	        BrewhouseStore.fetchTask(function (tasks) {
	            self.setState({
	                tasks: tasks
	            });
	        });
	    },
	    _onDeleteTask: function _onDeleteTask(task, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('process_admin_delete_confirmation'), function () {
	            BrewhouseStore.deleteTask(task, onSuccess, onFailure);
	        });
	    },
	    _onChangeTask: function _onChangeTask(task, onSuccess, onFailure) {
	        BrewhouseStore.changeTask(task, onSuccess, onFailure);
	    },
	    _onAddTask: function _onAddTask(task, onSuccess, onFailure) {
	        BrewhouseStore.addTask(task, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: item,
	            isEditMode: !!item,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    render: function render() {
	        if (!this.state.tasks) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('process_admin_change_success'),
	                changeFailureMessage: t('process_admin_change_failure'),
	                deleteSuccessMessage: t('process_admin_delete_success'),
	                addSuccessMessage: t('process_admin_add_success'),
	                addFailureMessage: t('process_admin_failure')
	            };
	            var sectionMapping = AppConstants.getSectionsMapping(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                tasks = _state.tasks,
	                isEditMode = _state.isEditMode,
	                headerActiveFilters = _state.headerActiveFilters;
	
	
	            var currentSelectedSection = selectedItem && selectedItem.processSection ? sectionMapping[selectedItem.processSection] : '';
	
	            var currentSelectedValue = currentSelectedSection ? _extends({}, selectedItem, { displayText: currentSelectedSection }) : selectedItem;
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "label",
	                isRelaxedText: true,
	                name: t('process_admin_task_name'),
	                value: selectedItem,
	                label: t('process_admin_task_name'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupDropdown, {
	                items: AppConstants.getSections(t, 'processSection'),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "processSection",
	                readerAttributeValue: "processSection",
	                writerAttribute: "processSection",
	                name: t('process_admin_section'),
	                label: t('process_admin_section'),
	                isImmutable: true,
	                value: currentSelectedValue,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "sequenceOrder",
	                additionalValidation: function additionalValidation(inputValue) {
	                    return NumberUtils.isNumber(inputValue) ? '' : t('process_admin_error_inline_order_must_be_number');
	                },
	                name: t('process_admin_sequence_number'),
	                value: selectedItem,
	                label: t('process_admin_sequence_number'),
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('process_admin_title'),
	                moduleName: "ADMIN_TASK",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchTask,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddTask,
	                onChange: this._onChangeTask,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteTask,
	                addEnterKeyDown: this._addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: headerActiveFilters,
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['taskSection', 'sequenceOrder'],
	                displayAttributes: ['label', 'displaySection', 'sequenceOrder'],
	                filteredColumns: ['label', 'displaySection', 'sequenceOrder'],
	                columnNames: [t('process_admin_task_name'), t('process_admin_section'), t('process_admin_sequence_number')]
	            }, tasks.map(function (task) {
	                task.displaySection = sectionMapping[task.processSection];
	                return task;
	            }))));
	        }
	    }
	});
	
	module.exports = TaskAdmin;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    Constants = __webpack_require__(2),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    GridItem = __webpack_require__(229),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    NumberUtils = __webpack_require__(23),
	    NavigationUtils = __webpack_require__(35),
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    GridItemWithFilter = __webpack_require__(153),
	    FormGroupButton = __webpack_require__(30),
	    ga = __webpack_require__(18),
	    _ = __webpack_require__(40);
	
	
	var ProductIconsAdmin = React.createClass({ displayName: "ProductIconsAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            sectionSelected: Constants.BREWING_SECTION_NAME,
	            selectedIcon: Constants.BREWING_SECTION_NAME,
	            isEditMode: false,
	            iconsMapping: null,
	            productName: NavigationUtils.getQueryParam('productName')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchIcons();
	        ga.pageview('/product-icons-admin');
	    },
	    fetchIcons: function fetchIcons() {
	        var self = this;
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        InventoryStore.fetchIconByProduct(productIdSelected, function (response) {
	            var applicantIcons = formatApplicantIcons(response.icons, response.iconsFromApplicant);
	            var icons = markProductIcons(applicantIcons, response.iconsByProductFromApplicant);
	            var iconsFiltered = _.filter(icons, function (icon) {
	                return _.get(icon, 'iconDetail.name') !== Constants.TASK_NON_VISIBLE;
	            }); // remove only this icons
	            var iconsSorted = _.orderBy(iconsFiltered, 'iconDetail.name');
	            var iconsPristine = _.cloneDeep(iconsSorted);
	            self.setState({
	                icons: iconsSorted,
	                iconsPristine: iconsPristine,
	                beerStyleName: _.get(response, 'product.beerStyle.name'),
	                productName: _.get(response, 'product.name'),
	                iconsChanged: []
	            });
	        });
	    },
	    getIconChangedUpdated: function getIconChangedUpdated(iconChangedNew) {
	        var _state = this.state,
	            sectionSelected = _state.sectionSelected,
	            iconsChanged = _state.iconsChanged,
	            iconsPristine = _state.iconsPristine;
	
	        // find if already change the icon
	
	        var iconChangedOld = _.find(iconsChanged, function (iconChanged) {
	            return _.get(iconChanged, 'id') === _.get(iconChangedNew, 'id');
	        });
	        var existIconChanged = !!iconChangedOld;
	
	        // ask if we apply the same change that before
	        var isSomeStateIconChanged = isSameStateIcon(iconChangedOld, iconChangedNew, sectionSelected);
	        var iconChangedUpdated = void 0;
	
	        if (existIconChanged && isSomeStateIconChanged) {
	            // we don't need to change nothing because is the same state
	            iconChangedUpdated = iconsChanged;
	        } else if (existIconChanged && isSomeStateIconChanged === false) {
	            // we need to update the changed icon
	            var iconsChangedFiltered = _.filter(iconsChanged, function (iconChanged) {
	                return _.get(iconChanged, 'id') !== _.get(iconChangedNew, 'id');
	            });
	            iconChangedUpdated = _.concat(iconsChangedFiltered, iconChangedNew);
	        } else if (!existIconChanged) {
	            // just need to add the new changed icon
	            iconChangedUpdated = _.concat(iconsChanged, iconChangedNew);
	        } else {
	            // we don't need to do nothing
	            iconChangedUpdated = iconsChanged;
	        }
	
	        // filter all icon changed which have the same state of icon pristine
	        iconChangedUpdated = _.filter(iconChangedUpdated, function (iconChanged) {
	            var iconPristine = _.find(iconsPristine, function (iconPristine) {
	                return _.get(iconPristine, 'id') === _.get(iconChanged, 'id');
	            });
	            var isSameStateIconPristine = isSameStateIcon(iconPristine, iconChanged, sectionSelected);
	            return !isSameStateIconPristine;
	        });
	
	        // add where section came from the icon changed
	        iconChangedUpdated = _.map(iconChangedUpdated, function (icon) {
	            icon.sectionChanged = sectionSelected;
	            return icon;
	        });
	
	        return iconChangedUpdated;
	    },
	    _saveChanges: function _saveChanges(icon, onSuccess, onFailure) {
	        var _state2 = this.state,
	            icons = _state2.icons,
	            iconsPristine = _state2.iconsPristine;
	
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var iconMappingConverted = InventoryStore.filterOnlyProductIconsChanged(icons, iconsPristine);
	
	        InventoryStore.changeIconsFromProduct(productIdSelected, {
	            iconsChanged: iconMappingConverted
	        }, onSuccess, onFailure);
	    },
	    _onChangeSection: function _onChangeSection(evt, index, value) {
	        this.setState({
	            sectionSelected: _.get(value, 'text')
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.fetchIcons();
	        this.setState({
	            filterText: ''
	        });
	    },
	    _onCheckIcon: function _onCheckIcon(gridItemProps, filterText) {
	        var iconId = gridItemProps.iconId;
	        var icons = this.state.icons;
	
	        // update state of icon
	
	        var currentIconChecked = _.find(this.state.icons, function (icon) {
	            return icon.id === iconId;
	        });
	        var oldStateIcon = isCheckedIcon(currentIconChecked);
	        var newStateIcon = !oldStateIcon;
	        currentIconChecked = updateSectionIcon(currentIconChecked, newStateIcon);
	
	        var iconsFiltered = _.filter(icons, function (icon) {
	            return icon.id !== currentIconChecked.id;
	        });
	        var allIconsWithIconUpdated = _.concat(iconsFiltered, currentIconChecked);
	
	        this.setState({
	            icons: _.orderBy(allIconsWithIconUpdated, 'iconDetail.name'),
	            iconsChanged: this.getIconChangedUpdated(currentIconChecked),
	            filterText: filterText
	        });
	    },
	    _backToProduct: function _backToProduct() {
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	        this.transitionTo('/products', {}, {
	            productSelectedId: productSelectedId
	        });
	    },
	    _goToProductItems: function _goToProductItems() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/:page', {
	            productId: productIdSelected,
	            page: 'items'
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    _goToProductItemsAddition: function _goToProductItemsAddition() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/items-addition', {
	            productId: productIdSelected
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        var _state3 = this.state,
	            productName = _state3.productName,
	            beerStyleName = _state3.beerStyleName;
	
	        var volumeWithUnit = this._getVolumeWithUnit();
	        return [{
	            displayName: t('dashboard_sidebar_products'),
	            link: 'products'
	        }, {
	            displayName: productName + ' (' + beerStyleName + ' ' + volumeWithUnit + ')'
	        }];
	    },
	    _getVolumeWithUnit: function _getVolumeWithUnit() {
	        var unit = NavigationUtils.getQueryParam('unit');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var volumeFormatted = NumberUtils.formatDecimal(volume);
	        return '' + volumeFormatted + unit;
	    },
	    isChangedIcon: function isChangedIcon(icon) {
	        var _state4 = this.state,
	            iconsChanged = _state4.iconsChanged,
	            sectionSelected = _state4.sectionSelected;
	
	        var isChangedIcon = !!_.find(iconsChanged, function (iconChanged) {
	            return _.get(iconChanged, 'id') === _.get(icon, 'id') && _.get(iconChanged, 'sectionChanged') === sectionSelected;
	        });
	
	        return isChangedIcon;
	    },
	    render: function render() {
	        if (!this.state.icons) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('product_admin_change_success'),
	                changeFailureMessage: t('product_admin_change_failure'),
	                deleteSuccessMessage: t('product_admin_delete_success'),
	                addSuccessMessage: t('product_admin_add_success'),
	                addFailureMessage: t('product_admin_add_failure')
	            };
	            var additionalButtons = [{
	                permission: 'SHOW',
	                type: 'CHANGE',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToProduct })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToProduct })
	            }, {
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('product_admin_set_subsctraction_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToProductItems })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('product_admin_set_subsctraction_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToProductItems })
	            }, {
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('product_admin_set_addition_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToProductItemsAddition })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('product_admin_set_addition_icons'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToProductItemsAddition })
	            }];
	            var contextHolder = this.getContextHolderInstance();
	            var _state5 = this.state,
	                selectedIcon = _state5.selectedIcon,
	                icons = _state5.icons,
	                iconsPristine = _state5.iconsPristine;
	
	            var originalStateIcons = isOriginalState(icons, iconsPristine);
	
	            var iconsFiltered = _.filter(icons, function (icon) {
	                return isCurrentIconVisible(icon);
	            });
	
	            return React.createElement(AdminScaffoldingGeneric, {
	                title: t('product_admin_title'),
	                moduleName: "ADMIN_PRODUCT_ICON",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: originalStateIcons ? undefined : selectedIcon,
	                fetchItems: this.fetchIcons,
	                headerFields: [],
	                onChange: originalStateIcons ? undefined : this._saveChanges,
	                onCancel: originalStateIcons ? undefined : this._onCancel,
	                additionalButtons: additionalButtons,
	                customClassName: "grid-item-content",
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(GridItemWithFilter, {
	                items: translateIcons(iconsFiltered, t),
	                isCheckedItem: isCheckedIcon,
	                isChangedItem: this.isChangedIcon,
	                displayNameField: "iconDetail.displayNameText",
	                iconClassNameField: "iconDetail.iconClassName",
	                onCheckItem: this._onCheckIcon,
	                initialFilterText: this.state.filterText,
	                nonMatchingText: t('product_admin_non_matching_found'),
	                keepSelectedSorting: false }));
	        }
	    }
	});
	
	function isCheckedIcon(icon) {
	    return !!_.get(icon, 'isProductIconChecked');
	}
	
	function isCurrentIconVisible(icon) {
	    return _.get(icon, 'iconDetail.isBrewingAllowed') || _.get(icon, 'iconDetail.isFermentingAllowed') || _.get(icon, 'iconDetail.isPackagingAllowed');
	}
	
	function updateSectionIcon(icon, newCheckedState) {
	    icon = _.set(icon, 'isProductIconChecked', newCheckedState);
	    icon = _.set(icon, 'productIconChecked', newCheckedState);
	    return icon;
	}
	
	function isOriginalState(iconsChanged, iconPristine) {
	    return _.every(iconsChanged, function (iconChanged) {
	        var iconCompare = _.find(iconPristine, function (iconPristine) {
	            return iconPristine.id === iconChanged.id;
	        });
	        return isSameStateIcon(iconCompare, iconChanged);
	    });
	}
	
	function isSameStateIcon(icon, iconCompare) {
	    if (icon && iconCompare) {
	        var isCheckedIconCompare = isCheckedIcon(iconCompare);
	        var isCheckedIconChanged = isCheckedIcon(icon);
	        var isSameState = isCheckedIconCompare === isCheckedIconChanged;
	        return isSameState;
	    }
	}
	
	function translateIcons(icons, t) {
	    return icons.map(function (icon) {
	        icon.iconDetail.displayNameText = Constants.getIconsMapping(t)[icon.iconDetail.displayName] || icon.iconDetail.displayName;
	        return icon;
	    });
	}
	
	function formatApplicantIcons(allIcons, applicantIcons) {
	    var applicantIconsIds = _.map(applicantIcons, function (icon) {
	        return icon.id;
	    });
	    var allIconsWithoutApplicantIcon = _.filter(allIcons, function (icon) {
	        return !_.includes(applicantIconsIds, icon.id);
	    });
	    var allIconsHydratedWithApplicantIcon = _.concat(allIconsWithoutApplicantIcon, applicantIcons);
	    return allIconsHydratedWithApplicantIcon;
	}
	
	function markProductIcons(allIconsWithApplicantIcons, productIcons) {
	
	    var productIconsId = _.map(productIcons, function (productIcon) {
	        return _.get(productIcon, 'id');
	    });
	
	    return _.map(allIconsWithApplicantIcons, function (icon) {
	        if (_.includes(productIconsId, icon.id)) {
	            icon.isProductIconChecked = true;
	        } else {
	            icon.isProductIconChecked = false;
	        }
	        return icon;
	    });
	}
	
	module.exports = ProductIconsAdmin;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    some = _require2.some,
	    map = _require2.map,
	    get = __webpack_require__(5).get,
	    Constants = __webpack_require__(2),
	    SessionStore = __webpack_require__(11),
	    InventoryStore = __webpack_require__(20),
	    NumberUtils = __webpack_require__(23),
	    ContentUtils = __webpack_require__(7),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    NavigationUtils = __webpack_require__(35),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var AMOUNT_DECIMAL = 4;
	
	var ProductItemAdditionAdmin = React.createClass({ displayName: "ProductItemAdditionAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            product: NavigationUtils.getPathParam('products'),
	            productName: NavigationUtils.getQueryParam('productName'),
	            beerStyleName: NavigationUtils.getQueryParam('beerStyle'),
	            volume: NavigationUtils.getQueryParam('volume'),
	            unit: NavigationUtils.getQueryParam('unit'),
	            isEditMode: false
	        };
	    },
	    _hydrateProductItems: function _hydrateProductItems(productItems) {
	        return map(productItems, function (productItem) {
	            productItem.amountWithUnit = NumberUtils.formatDecimal(get(productItem, 'defaultAmount')) + ' ' + get(productItem, 'item.unit', '');
	            return productItem;
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	        ga.pageview('/product-items');
	    },
	    _backToProducts: function _backToProducts() {
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	        this.transitionTo('/products', {}, {
	            productSelectedId: productSelectedId
	        });
	    },
	    _goToIcons: function _goToIcons() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/:page', {
	            productId: productIdSelected,
	            page: 'icons'
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    fetchItems: function fetchItems() {
	        var self = this;
	        var currentProductId = NavigationUtils.getPathParam('products');
	
	        InventoryStore.fetchAllItems(function (items) {
	            InventoryStore.fetchItemsAddition(currentProductId, function (productItems) {
	                var productItemsHydrated = self._hydrateProductItems(productItems);
	                var itemsSorted = ContentUtils.sortList(items, 'description');
	
	                self.setState({
	                    productItems: ContentUtils.filterEnable(productItemsHydrated),
	                    items: ContentUtils.filterNonInventoryItems(ContentUtils.filterEnable(itemsSorted))
	                });
	            });
	        });
	    },
	    _onRowSelection: function _onRowSelection(productItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        if (productItem && productItem.item) {
	            productItem.name = get(productItem, 'item.description');
	        }
	
	        this.setState({
	            selectProductItem: productItem,
	            isEditMode: !!productItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onDeleteItem: function _onDeleteItem(id, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('product_addition_warning_confirm_remove_item'), function () {
	            InventoryStore.deleteProductItem(id, onSuccess, onFailure);
	        });
	        this._clean();
	    },
	    _onChangeItem: function _onChangeItem(productItem, onSuccess, onFailure) {
	        var productId = NavigationUtils.getPathParam('products');
	        productItem.isAddition = true;
	        InventoryStore.changeProductItem(productId, productItem, onSuccess, onFailure);
	        this._clean();
	    },
	    _onAddItem: function _onAddItem(productItem, onSuccess, onFailure) {
	        var productId = NavigationUtils.getPathParam('products');
	        productItem.isAddition = true;
	        InventoryStore.addProductItem(productId, productItem, onSuccess, onFailure);
	        this._clean();
	    },
	    _onCancel: function _onCancel() {
	        this._clean();
	    },
	    _clean: function _clean() {
	        this.setState({
	            preSelectedItem: null,
	            selectProductItem: null,
	            selectProductItemDropDown: null
	        });
	    },
	    _onBlurSelectedItem: function _onBlurSelectedItem(preSelectedItem) {
	        if (preSelectedItem) {
	            this.setState(function (prevState) {
	                if (prevState.selectedItem) {
	                    return {
	                        preSelectedItem: _extends(prevState.selectedItem, preSelectedItem)
	                    };
	                } else {
	                    return {
	                        preSelectedItem: preSelectedItem
	                    };
	                }
	            });
	        }
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        var _state = this.state,
	            productName = _state.productName,
	            beerStyleName = _state.beerStyleName;
	
	        var volumeWithUnit = this._getVolumeWithUnit();
	        return [{
	            displayName: t('dashboard_sidebar_products'),
	            link: 'products'
	        }, {
	            displayName: productName + ' (' + beerStyleName + ' ' + volumeWithUnit + ')'
	        }];
	    },
	    _getVolumeWithUnit: function _getVolumeWithUnit() {
	        var _state2 = this.state,
	            volume = _state2.volume,
	            unit = _state2.unit;
	
	        var volumeFormatted = NumberUtils.formatDecimal(volume);
	        return '' + volumeFormatted + unit;
	    },
	    _isValidProductItems: function _isValidProductItems(selectedItemId) {
	        var currentItemId = get(selectedItemId, 'item.id');
	        var selectProductItem = this.state.selectProductItem;
	
	        var isNewProductItem = ContentUtils.isNull(selectProductItem);
	        var productItemsId = void 0;
	
	        // only in the new operation
	        if (isNewProductItem) {
	            productItemsId = map(this.state.productItems, function (productItem) {
	                return get(productItem, 'item.id');
	            }) || [];
	        } else {
	            var previousSelectedItemId = get(this.state, 'item.id') || currentItemId;
	            productItemsId = filter(map(this.state.productItems, function (productItem) {
	                return get(productItem, 'item.id');
	            }), function (itemId) {
	                return itemId !== previousSelectedItemId;
	            }) || [];
	        }
	
	        var isAlreadyExist = productItemsId.includes(currentItemId);
	        if (isAlreadyExist) {
	            return t('product_addition_warning_item_duplicated');
	        }
	        return ''; // empty is valid
	    },
	    _onChangeDropDownItem: function _onChangeDropDownItem(selectedItem) {
	        this.setState({
	            selectProductItemDropDown: selectedItem
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _goToProductItems: function _goToProductItems() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/:page', {
	            productId: productIdSelected,
	            page: 'items'
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    render: function render() {
	        var contextHolder = this.getContextHolderInstance();
	        var _state3 = this.state,
	            selectProductItem = _state3.selectProductItem,
	            typeTank = _state3.typeTank,
	            currentBeerStyle = _state3.currentBeerStyle,
	            productItems = _state3.productItems,
	            items = _state3.items,
	            isEditMode = _state3.isEditMode,
	            selectProductItemDropDown = _state3.selectProductItemDropDown,
	            preSelectedItem = _state3.preSelectedItem;
	
	        var messages = {
	            changeSuccessMessage: t('product_addition_admin_change_success'),
	            changeFailureMessage: t('product_addition_admin_change_failure'),
	            deleteSuccessMessage: t('product_addition_delete_success'),
	            addSuccessMessage: t('product_addition_add_success'),
	            addFailureMessage: t('product_addition_add_failure')
	        };
	        var itemUnit = void 0;
	
	        if (selectProductItem) {
	            itemUnit = get(selectProductItem, 'item.unit');
	        } else {
	            itemUnit = get(preSelectedItem, 'unit');
	        }
	        var itemUnitWithParenthesis = itemUnit ? '(' + itemUnit + ')' : 'unit';
	        var currentItemSelected = get(selectProductItemDropDown, 'item') || get(selectProductItem, 'item');
	        var volumeWithUnit = this._getVolumeWithUnit();
	
	        var additionalButtons = [{
	            type: 'CHANGE',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('back'),
	                icon: "subdirectory_arrow_left",
	                type: "icon",
	                onClick: this._backToProducts })
	        }, {
	            type: 'NEW',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('back'),
	                icon: "subdirectory_arrow_left",
	                type: "icon",
	                onClick: this._backToProducts })
	        }, {
	            permission: 'SHOW',
	            type: 'NEW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_addition_set_icons'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToIcons })
	        }, {
	            type: 'CHANGE',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_addition_set_subtraction_items'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToProductItems })
	        }, {
	            type: 'NEW',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_addition_set_subtraction_items'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToProductItems })
	        }];
	
	        var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	            operationsHolder: contextHolder,
	            items: items,
	            itemsDisabled: filterItemsAlreadyInUse(items, productItems),
	            readerAttribute: "description",
	            readerAttributeValue: "id",
	            writerAttribute: "item.id",
	            name: t('item'),
	            isImmutable: true,
	            additionalValidation: this._isValidProductItems.bind(this),
	            value: currentItemSelected || preSelectedItem,
	            onChange: this._onChangeDropDownItem,
	            onEnter: this._onEnterPress,
	            onBlur: this._onBlurSelectedItem }), React.createElement(FormGroupTextfield, {
	            operationsHolder: contextHolder,
	            readerAttribute: "defaultAmount",
	            additionalValidation: function additionalValidation(inputValue) {
	                return NumberUtils.isNumber(inputValue) && NumberUtils.getNumber(inputValue) > 0 ? '' : t('product_addition_inline_error_amount_must_be_greater_than_zero');
	            },
	            name: t('product_addition_column_amount'),
	            value: selectProductItem,
	            label: t('product_addition_column_amount') + ' ' + itemUnitWithParenthesis + ' ' + t('per') + ' (' + volumeWithUnit + ')',
	            isRelaxedText: true,
	            isDecimalFormat: true,
	            decimalDigits: AMOUNT_DECIMAL,
	            isEditMode: isEditMode,
	            onEnter: this._onEnterPress })];
	        return React.createElement(AdminScaffolding, {
	            messages: messages,
	            moduleName: "ADMIN_PRODUCT_ITEMS_ADDITION",
	            additionalSubmitValue: {
	                styleBeerId: currentBeerStyle,
	                typeTank: typeTank
	            },
	            additionalButtons: additionalButtons,
	            title: t('product_addition_title'),
	            contextHolder: contextHolder,
	            value: selectProductItem,
	            onAddText: t('product_addition_add'),
	            fetchItems: this.fetchItems,
	            headerFields: formFieldsEl,
	            addEnterKeyDown: this._addEnterKeyDown,
	            onAdd: this._onAddItem,
	            onChange: this._onChangeItem,
	            onCancel: this._onCancel,
	            onDelete: this._onDeleteItem,
	            breadcrumb: this._getBreadcrumbLinks(),
	            shouldFocusDidMount: true
	        }, React.createElement(AdminScaffoldingTable, {
	            headerActiveFilters: this.state.headerActiveFilters,
	            sortByColumn: ['item.description'],
	            onRowSelection: this._onRowSelection,
	            value: selectProductItem,
	            columnNames: [t('product_addition_column_description'), t('product_addition_column_amount'), t('product_addition_column_unit')],
	            filteredColumns: ['item.description', 'amountWithUnit'],
	            nameFieldIdentifier: "item.id",
	            displayAttributes: ['item.description', 'amountWithUnit']
	        }, productItems));
	    }
	});
	
	function filterItemsAlreadyInUse(items, productItems) {
	    var itemIdsAlreadyInUse = map(productItems, function (productItem) {
	        return get(productItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	module.exports = ProductItemAdditionAdmin;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(8),
	    filter = _require2.filter,
	    some = _require2.some,
	    map = _require2.map,
	    get = __webpack_require__(5).get,
	    Constants = __webpack_require__(2),
	    SessionStore = __webpack_require__(11),
	    InventoryStore = __webpack_require__(20),
	    NumberUtils = __webpack_require__(23),
	    ContentUtils = __webpack_require__(7),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    NavigationUtils = __webpack_require__(35),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var AMOUNT_DECIMAL = 4;
	
	var ProductItemAdmin = React.createClass({ displayName: "ProductItemAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            product: NavigationUtils.getPathParam('products'),
	            productName: NavigationUtils.getQueryParam('productName'),
	            beerStyleName: NavigationUtils.getQueryParam('beerStyle'),
	            volume: NavigationUtils.getQueryParam('volume'),
	            unit: NavigationUtils.getQueryParam('unit'),
	            isEditMode: false
	        };
	    },
	    _hydrateProductItems: function _hydrateProductItems(productItems) {
	        return map(productItems, function (productItem) {
	            productItem.amountWithUnit = NumberUtils.formatDecimal(get(productItem, 'defaultAmount')) + ' ' + get(productItem, 'item.unit', '');
	            return productItem;
	        });
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	        ga.pageview('/product-items');
	    },
	    _backToProducts: function _backToProducts() {
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	        this.transitionTo('/products', {}, {
	            productSelectedId: productSelectedId
	        });
	    },
	    _goToIcons: function _goToIcons() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/:page', {
	            productId: productIdSelected,
	            page: 'icons'
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    fetchItems: function fetchItems() {
	        var self = this;
	        var currentProductId = NavigationUtils.getPathParam('products');
	
	        InventoryStore.fetchAllItems(function (items) {
	            InventoryStore.fetchItemsSubtraction(currentProductId, function (productItems) {
	                var productItemsHydrated = self._hydrateProductItems(productItems);
	                var itemsSorted = ContentUtils.sortList(items, 'description');
	
	                self.setState({
	                    productItems: ContentUtils.filterEnable(productItemsHydrated),
	                    items: ContentUtils.filterNonInventoryItems(ContentUtils.filterEnable(itemsSorted))
	                });
	            });
	        });
	    },
	    _onRowSelection: function _onRowSelection(productItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        if (productItem && productItem.item) {
	            productItem.name = get(productItem, 'item.description');
	        }
	
	        this.setState({
	            selectProductItem: productItem,
	            isEditMode: !!productItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onDeleteItem: function _onDeleteItem(id, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('product_substraction_warning_remove_item_future'), function () {
	            InventoryStore.deleteProductItem(id, onSuccess, onFailure);
	        });
	        this._clean();
	    },
	    _onChangeItem: function _onChangeItem(productItem, onSuccess, onFailure) {
	        var productId = NavigationUtils.getPathParam('products');
	        productItem.isAddition = false;
	        InventoryStore.changeProductItem(productId, productItem, onSuccess, onFailure);
	        this._clean();
	    },
	    _onAddItem: function _onAddItem(productItem, onSuccess, onFailure) {
	        var productId = NavigationUtils.getPathParam('products');
	        productItem.isAddition = false;
	        InventoryStore.addProductItem(productId, productItem, onSuccess, onFailure);
	        this._clean();
	    },
	    _onCancel: function _onCancel() {
	        this._clean();
	    },
	    _clean: function _clean() {
	        this.setState({
	            selectProductItem: null,
	            selectProductItemDropDown: null,
	            preSelectedItem: null
	        });
	    },
	    _onBlurSelectedItem: function _onBlurSelectedItem(preSelectedItem) {
	        if (preSelectedItem) {
	            this.setState(function (prevState) {
	                if (prevState.selectedItem) {
	                    return {
	                        preSelectedItem: _extends(prevState.selectedItem, preSelectedItem)
	                    };
	                } else {
	                    return {
	                        preSelectedItem: preSelectedItem
	                    };
	                }
	            });
	        }
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        var _state = this.state,
	            productName = _state.productName,
	            beerStyleName = _state.beerStyleName;
	
	        var volumeWithUnit = this._getVolumeWithUnit();
	        return [{
	            displayName: t('dashboard_sidebar_products'),
	            link: 'products'
	        }, {
	            displayName: productName + ' (' + beerStyleName + ' ' + volumeWithUnit + ')'
	        }];
	    },
	    _getVolumeWithUnit: function _getVolumeWithUnit() {
	        var _state2 = this.state,
	            volume = _state2.volume,
	            unit = _state2.unit;
	
	        var volumeFormatted = NumberUtils.formatDecimal(volume);
	        return '' + volumeFormatted + unit;
	    },
	    _isValidProductItems: function _isValidProductItems(selectedItemId) {
	        var currentItemId = get(selectedItemId, 'item.id');
	        var selectProductItem = this.state.selectProductItem;
	
	        var isNewProductItem = ContentUtils.isNull(selectProductItem);
	        var productItemsId = void 0;
	
	        // only in the new operation
	        if (isNewProductItem) {
	            productItemsId = map(this.state.productItems, function (productItem) {
	                return get(productItem, 'item.id');
	            }) || [];
	        } else {
	            var previousSelectedItemId = get(this.state, 'item.id') || currentItemId;
	            productItemsId = filter(map(this.state.productItems, function (productItem) {
	                return get(productItem, 'item.id');
	            }), function (itemId) {
	                return itemId !== previousSelectedItemId;
	            }) || [];
	        }
	
	        var isAlreadyExist = productItemsId.includes(currentItemId);
	        if (isAlreadyExist) {
	            return t('product_substraction_warning_item_duplicated');
	        }
	        return ''; // empty is valid
	    },
	    _onChangeDropDownItem: function _onChangeDropDownItem(selectedItem) {
	        this.setState({
	            selectProductItemDropDown: selectedItem
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _goToProductItemsAddition: function _goToProductItemsAddition() {
	        var productIdSelected = NavigationUtils.getPathParam('products');
	        var productName = NavigationUtils.getQueryParam('productName');
	        var beerStyle = NavigationUtils.getQueryParam('beerStyle');
	        var volume = NavigationUtils.getQueryParam('volume');
	        var unit = NavigationUtils.getQueryParam('unit');
	        var productSelectedId = NavigationUtils.getQueryParam('productSelectedId');
	
	        this.transitionTo('/products/' + productIdSelected + '/items');
	
	        this.transitionTo('/products/:productId/items-addition', {
	            productId: productIdSelected
	        }, {
	            productSelectedId: productSelectedId,
	            productName: productName,
	            beerStyle: beerStyle,
	            volume: volume,
	            unit: unit
	        });
	    },
	    render: function render() {
	        var contextHolder = this.getContextHolderInstance();
	        var messages = {
	            changeSuccessMessage: t('product_substraction_change_success'),
	            changeFailureMessage: t('product_substraction_change_failure'),
	            deleteSuccessMessage: t('product_substraction_delete_success'),
	            addSuccessMessage: t('product_substraction_add_success'),
	            addFailureMessage: t('product_substraction_add_failure')
	        };
	        var _state3 = this.state,
	            selectProductItem = _state3.selectProductItem,
	            typeTank = _state3.typeTank,
	            currentBeerStyle = _state3.currentBeerStyle,
	            productItems = _state3.productItems,
	            items = _state3.items,
	            isEditMode = _state3.isEditMode,
	            selectProductItemDropDown = _state3.selectProductItemDropDown,
	            preSelectedItem = _state3.preSelectedItem;
	
	
	        var itemUnit = void 0;
	
	        if (selectProductItem) {
	            itemUnit = get(selectProductItem, 'item.unit');
	        } else {
	            itemUnit = get(preSelectedItem, 'unit');
	        }
	
	        var itemUnitWithParenthesis = itemUnit ? '(' + itemUnit + ')' : 'unit';
	        var currentItemSelected = get(selectProductItemDropDown, 'item') || get(selectProductItem, 'item');
	        var volumeWithUnit = this._getVolumeWithUnit();
	
	        var additionalButtons = [{
	            type: 'CHANGE',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('back'),
	                icon: "subdirectory_arrow_left",
	                type: "icon",
	                onClick: this._backToProducts })
	        }, {
	            type: 'NEW',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('back'),
	                icon: "subdirectory_arrow_left",
	                type: "icon",
	                onClick: this._backToProducts })
	        }, {
	            permission: 'SHOW',
	            type: 'NEW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_addition_set_icons'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToIcons })
	        }, {
	            type: 'CHANGE',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_admin_set_addition_icons'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToProductItemsAddition })
	        }, {
	            type: 'NEW',
	            permission: 'SHOW',
	            el: React.createElement(FormGroupButton, {
	                label: t('product_admin_set_addition_icons'),
	                icon: "subdirectory_arrow_right",
	                type: "icon",
	                onClick: this._goToProductItemsAddition })
	        }];
	
	        var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	            operationsHolder: contextHolder,
	            items: items,
	            itemsDisabled: filterItemsAlreadyInUse(items, productItems),
	            readerAttribute: "description",
	            readerAttributeValue: "id",
	            writerAttribute: "item.id",
	            name: t('item'),
	            additionalValidation: this._isValidProductItems.bind(this),
	            value: currentItemSelected || preSelectedItem,
	            onChange: this._onChangeDropDownItem,
	            onEnter: this._onEnterPress,
	            onBlur: this._onBlurSelectedItem,
	            isImmutable: true }), React.createElement(FormGroupTextfield, {
	            operationsHolder: contextHolder,
	            readerAttribute: "defaultAmount",
	            additionalValidation: function additionalValidation(inputValue) {
	                return NumberUtils.isNumber(inputValue) && NumberUtils.getNumber(inputValue) > 0 ? '' : t('product_items_subtraction_admin_message_amount_number');
	            },
	            name: t('label_amount'),
	            value: selectProductItem,
	            label: t('label_amount') + ' ' + itemUnitWithParenthesis + ' ' + t('per') + ' (' + volumeWithUnit + ')',
	            isRelaxedText: true,
	            isDecimalFormat: true,
	            decimalDigits: AMOUNT_DECIMAL,
	            isEditMode: isEditMode,
	            onEnter: this._onEnterPress })];
	        return React.createElement(AdminScaffolding, {
	            moduleName: "ADMIN_PRODUCT_ITEMS_SUBSTRACTION",
	            messages: messages,
	            additionalSubmitValue: {
	                styleBeerId: currentBeerStyle,
	                typeTank: typeTank
	            },
	            additionalButtons: additionalButtons,
	            title: t('product_items_subtraction_admin_title_subtraction_items'),
	            onAddText: t('product_addition_add'),
	            contextHolder: contextHolder,
	            value: selectProductItem,
	            fetchItems: this.fetchItems,
	            headerFields: formFieldsEl,
	            addEnterKeyDown: this._addEnterKeyDown,
	            onAdd: this._onAddItem,
	            onChange: this._onChangeItem,
	            onCancel: this._onCancel,
	            onDelete: this._onDeleteItem,
	            breadcrumb: this._getBreadcrumbLinks(),
	            shouldFocusDidMount: true
	        }, React.createElement(AdminScaffoldingTable, {
	            headerActiveFilters: this.state.headerActiveFilters,
	            sortByColumn: ['item.description'],
	            onRowSelection: this._onRowSelection,
	            value: selectProductItem,
	            columnNames: [t('product_addition_column_description'), t('product_addition_column_amount'), t('product_addition_column_unit')],
	            filteredColumns: ['item.description', 'amountWithUnit'],
	            nameFieldIdentifier: "item.id",
	            displayAttributes: ['item.description', 'amountWithUnit']
	        }, productItems));
	    }
	});
	
	function filterItemsAlreadyInUse(items, productItems) {
	    var itemIdsAlreadyInUse = map(productItems, function (productItem) {
	        return get(productItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	module.exports = ProductItemAdmin;

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    NumberUtils = __webpack_require__(23),
	    NavigationUtils = __webpack_require__(35),
	    PositionUtils = __webpack_require__(59),
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    Notification = __webpack_require__(21),
	    ContentUtils = __webpack_require__(7),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    FormGroupButton = __webpack_require__(30),
	    Constants = __webpack_require__(2),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    BeerStyleStore = __webpack_require__(95),
	    Stamps = __webpack_require__(154),
	    Stamp = __webpack_require__(131),
	    DashboardServiceCache = __webpack_require__(28),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    find = _require3.find,
	    filter = _require3.filter,
	    get = __webpack_require__(5).get,
	    ga = __webpack_require__(18),
	    _require4 = __webpack_require__(8),
	    orderBy = _require4.orderBy,
	    _require5 = __webpack_require__(19),
	    Navigation = _require5.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var AMOUNT_DECIMALS = 4;
	
	var ProductsAdmin = React.createClass({ displayName: "ProductsAdmin",
	  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedProduct: null,
	      isEditMode: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchProducts();
	    ga.pageview('/products-admin');
	  },
	  fetchProducts: function fetchProducts() {
	    var self = this;
	    InventoryStore.fetchProducts(function (products) {
	      InventoryStore.fetchLocation(function (locations) {
	        BeerStyleStore.fetchStyleBeers(function (beerStyles) {
	          InventoryStore.fetchIcons(function (response) {
	            var icons = ContentUtils.formatApplicantIcons(response.icons, response.iconsFromApplicant);
	            self.setState({
	              locations: ContentUtils.filterEnable(locations),
	              products: self._hydrateProducts(products, icons),
	              productSelectedId: NavigationUtils.getQueryParam('productSelectedId'),
	              beerStyles: beerStyles,
	              isEditMode: ContentUtils.isNotNullOrUndefined(NavigationUtils.getQueryParam('productSelectedId')),
	              unit: DashboardServiceCache.getCurrentUnitTank()
	            }, self._onFinishRenderingFetchProducts);
	          });
	        });
	      });
	    });
	  },
	  _onFinishRenderingFetchProducts: function _onFinishRenderingFetchProducts() {
	    var _state = this.state,
	        productSelectedId = _state.productSelectedId,
	        products = _state.products;
	
	    var haveProductSelectedTable = !!productSelectedId;
	
	    if (haveProductSelectedTable) {
	      var self = this;
	      this.setState({
	        selectedProduct: find(products, function (product) {
	          return get(product, 'id') === +productSelectedId;
	        })
	      }, function () {
	        self._setPositionScrollById.bind(self)(productSelectedId);
	      });
	    }
	  },
	  _addQueryParamWithRowSelected: function _addQueryParamWithRowSelected(product, lastRowScrollPosition) {
	    var _this = this;
	
	    this.transitionTo('/products', {}, {
	      productSelectedId: get(product, 'id')
	    });
	    // Is needed to force scroll position again
	    // in order to avoid jumping scroll behavior
	    delay(function () {
	      _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	    }, 1);
	  },
	  _setPositionScrollById: function _setPositionScrollById(productSelectedId) {
	    var tableEl = this.getDOMNode().querySelector('.mui-body-table');
	    var rowEl = tableEl.querySelector('tr[data-row-id="' + productSelectedId + '"]');
	    var positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
	    tableEl.scrollTop = positionTopRowEl;
	  },
	  _hydrateProducts: function _hydrateProducts(products, iconsFull) {
	    return map(products, function (product) {
	      product.volumeWithUnit = NumberUtils.formatDecimal(product.volume) + ' ' + DashboardServiceCache.getCurrentUnitTank();
	
	      if (product && ContentUtils.isNotEmptyArray(product.iconsId)) {
	        product.iconsFull = map(product.iconsId, function (iconId) {
	          return find(iconsFull, function (iconFull) {
	            return iconFull.id === iconId;
	          });
	        });
	      }
	
	      return product;
	    });
	  },
	  _onDeleteProduct: function _onDeleteProduct(product, onSuccess, onFailure) {
	    CustomDialog.showWarningConfirmation(t('warning'), t('product_admin_general_warning_confirm_delete'), function () {
	      InventoryStore.deleteProduct(product, onSuccess, onFailure);
	    });
	  },
	  _onChangeProducts: function _onChangeProducts(product, onSuccess, onFailure) {
	    InventoryStore.changeProduct(product, onSuccess, onFailure);
	  },
	  _onAddProduct: function _onAddProduct(product, onSuccess, onFailure) {
	    var products = this.state.products;
	
	    var codeProduct = ContentUtils.retrieveNextItemCode(products, product, Constants.MODULE_PRODUCT_ACRONYM);
	    product.code = codeProduct;
	    InventoryStore.addProduct(product, onSuccess, onFailure);
	  },
	  _onDuplicateProduct: function _onDuplicateProduct(product, onSuccess, onFailure) {
	    var products = this.state.products;
	
	    var codeProduct = ContentUtils.retrieveNextItemCode(products, product, Constants.MODULE_PRODUCT_ACRONYM);
	    product.code = codeProduct;
	    InventoryStore.duplicateProduct(product, onSuccess, onFailure);
	  },
	  _onRowSelection: function _onRowSelection(product, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	    var _this2 = this;
	
	    if (product && product.beerStyle) {
	      product.beerStyleName = product.beerStyle.name;
	    }
	    this.setState({
	      selectedProduct: product,
	      isEditMode: !!product,
	      headerActiveFilters: headerActiveFilters
	    }, function () {
	      // stay the position of the scroll after row select when
	      // the offset is outside of initial viewport page.
	      _this2.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	
	      _this2._addQueryParamWithRowSelected(product, lastRowScrollPosition);
	    });
	  },
	  _onCancel: function _onCancel() {
	    this.transitionTo('/products');
	    this.setState({
	      selectedProduct: null,
	      selectedProductId: null,
	      isEditMode: false
	    });
	  },
	  _goTo: function _goTo(page) {
	    if (page) {
	      this.transitionTo('/products/:productId/:page', {
	        productId: get(this.state, 'selectedProduct.id'),
	        page: page
	      }, {
	        productName: get(this.state, 'selectedProduct.name'),
	        productSelectedId: get(this.state, 'selectedProduct.id'),
	        beerStyle: get(this.state, 'selectedProduct.beerStyle.name'),
	        volume: get(this.state, 'selectedProduct.volume'),
	        unit: get(this.state, 'selectedProduct.unit')
	      });
	    }
	  },
	  _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	    return [{
	      displayName: t('product_admin_general_title')
	    }];
	  },
	  _getStampsIcons: function _getStampsIcons(iconsFull) {
	    return React.createElement(Stamps, null, map(iconsFull, function (stamp) {
	      return React.createElement(Stamp, { classNameIcon: get(stamp, 'iconDetail.iconClassName') });
	    }));
	  },
	  _onEnterPress: function _onEnterPress() {
	    if (this.onEnterKeyDown) {
	      this.onEnterKeyDown();
	    }
	  },
	  _onDuplicate: function _onDuplicate(contextHolder) {
	    var _this3 = this;
	
	    // get value from all fields
	    var currentSelectedItem = contextHolder.getItem();
	
	    // override with duplicate label
	    currentSelectedItem.name = ContentUtils.formatDuplicateName(currentSelectedItem.name);
	
	    // add date to duplicate and remove id in order
	    // to generate a new one like new item
	    currentSelectedItem.duplicatedId = NavigationUtils.getQueryParam('productSelectedId');
	    currentSelectedItem.id = null;
	    currentSelectedItem.isDuplicated = true;
	
	    this._onDuplicateProduct(currentSelectedItem, function () {
	      Notification.show(t('product_admin_general_suplicated_success'), 'success');
	      _this3.fetchProducts();
	    });
	  },
	  _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	    this.onEnterKeyDown = onEnterKeyDown;
	  },
	  _getWrapperColor: function _getWrapperColor(item) {
	    var isMenuItemUsed = item.payload !== undefined;
	    var beerStyle = void 0;
	
	    if (isMenuItemUsed) {
	      beerStyle = item.itemModel;
	    } else {
	      beerStyle = item;
	    }
	
	    return React.createElement("div", null, React.createElement("span", {
	      className: "text-center",
	      style: {
	        height: '20px',
	        borderRadius: '22px',
	        boxShadow: beerStyle ? '1px 2px 4px 0px gray' : '0 0 0 0 #fff',
	        backgroundColor: get(beerStyle, 'color'),
	        border: 'solid 0px black',
	        padding: '10px 17px',
	        left: '0',
	        position: 'relative',
	        opacity: '.6'
	      } }), React.createElement("span", { style: { paddingLeft: '10px' } }, get(beerStyle, 'name') || get(item, 'text')));
	  },
	  render: function render() {
	    if (!this.state.products || !this.state.beerStyles) {
	      return React.createElement(Loading, null);
	    } else {
	      var CATEGORIES_TEXTS = Constants.getProductCategoryMapping(t);
	      var PRODUCT_CATEGORIES = Constants.PRODUCT_CATEGORY.map(function (category) {
	        return { category: category, displayText: Constants.getProductCategoryMapping(t)[category] };
	      });
	      var messages = {
	        changeSuccessMessage: t('product_admin_general_change_success'),
	        changeFailureMessage: t('product_admin_general_change_failure'),
	        deleteSuccessMessage: t('product_admin_general_delete_success'),
	        addSuccessMessage: t('product_admin_general_add_success'),
	        addFailureMessage: t('product_admin_general_add_failure')
	      };
	
	      var contextHolder = this.getContextHolderInstance();
	
	      var _state2 = this.state,
	          selectedProduct = _state2.selectedProduct,
	          products = _state2.products,
	          isEditMode = _state2.isEditMode;
	
	
	      if (products && products.length) {
	        products = products.map(function (item) {
	          item.displayCategory = CATEGORIES_TEXTS[item.category];
	          return item;
	        });
	      }
	
	      var currentSelectedCategory = selectedProduct && selectedProduct.category ? CATEGORIES_TEXTS[selectedProduct.category] : '';
	
	      var currentSelectedCategoryValue = currentSelectedCategory ? _extends({}, selectedProduct, { displayText: currentSelectedCategory }) : selectedProduct;
	
	      var unitName = this.state.unit ? this.state.unit : '';
	      var unitNameWhitParenthesis = unitName ? '(' + unitName + ')' : '';
	      var additionalButtons = [{
	        type: 'CHANGE',
	        permission: 'ICON_SHOW',
	        el: React.createElement(FormGroupButton, {
	          label: t('product_admin_general_set_icons'),
	          icon: "subdirectory_arrow_right",
	          type: "icon",
	          onClick: this._goTo.bind(this, 'icons') })
	      }, {
	        type: 'CHANGE',
	        permission: 'ITEMS_SUBSTRACTION_SHOW',
	        el: React.createElement(FormGroupButton, {
	          label: t('product_admin_general_set_substraction_item'),
	          icon: "subdirectory_arrow_right",
	          type: "icon",
	          onClick: this._goTo.bind(this, 'items') })
	      }, {
	        type: 'CHANGE',
	        permission: 'ITEMS_ADDITION_SHOW',
	        el: React.createElement(FormGroupButton, {
	          label: t('product_admin_general_set_addition_item'),
	          icon: "subdirectory_arrow_right",
	          type: "icon",
	          onClick: this._goTo.bind(this, 'items-addition') })
	      }, {
	        type: 'CHANGE',
	        permission: 'DUPLICATE_SHOW',
	        el: React.createElement(FormGroupButton, {
	          label: t('product_admin_general_duplicated'),
	          icon: "content_copy",
	          type: "icon",
	          onClick: this._onDuplicate.bind(this, contextHolder) })
	      }];
	      var sortedBeerStyle = orderBy(this.state.beerStyles, 'name');
	      var formFieldsEl = [React.createElement(FormGroupTextfield, {
	        operationsHolder: contextHolder,
	        readerAttribute: "name",
	        isRelaxedText: true,
	        name: t('name'),
	        value: selectedProduct,
	        label: t('product_admin_general_column_name'),
	        isEditMode: isEditMode,
	        onEnter: this._onEnterPress }), React.createElement(FormGroupTextFieldSuggested, {
	        operationsHolder: contextHolder,
	        items: isEditMode ? sortedBeerStyle : filterBeerStyleEnable(sortedBeerStyle),
	        readerAttribute: "name",
	        idAttribute: "id",
	        label: t('product_admin_general_column_beer_style'),
	        readerAttributeValue: "id",
	        writerAttribute: "beerStyleId",
	        customReaderWriterAttribute: "id",
	        name: t('beer_style_label_name'),
	        floatingLabelText: t('product_admin_general_column_beer_style'),
	        isImmutable: true,
	        value: get(selectedProduct, 'beerStyle'),
	        onChange: this._onChangeDropDownItem,
	        onEnter: this.__onEnterPress }), React.createElement(FormGroupTextFieldSuggested, {
	        operationsHolder: contextHolder,
	        items: PRODUCT_CATEGORIES,
	        readerAttribute: "displayText",
	        readerAttributeValue: "category",
	        writerAttribute: "category",
	        name: t('category'),
	        value: currentSelectedCategoryValue,
	        label: t('product_admin_category'),
	        isImmutable: true,
	        onChange: this._onChangeDropDownItem,
	        onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	        operationsHolder: contextHolder,
	        readerAttribute: "volume",
	        additionalValidation: function additionalValidation(inputValue) {
	          return NumberUtils.isNumber(inputValue) ? '' : t('product_admin_general_must_be_a_number');
	        },
	        name: t('volume'),
	        value: selectedProduct,
	        label: t('volume') + ' ' + unitNameWhitParenthesis,
	        isRelaxedText: true,
	        isDecimalFormat: true,
	        decimalDigits: AMOUNT_DECIMALS,
	        isEditMode: isEditMode,
	        onEnter: this._onEnterPress })];
	
	      return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	        moduleName: "ADMIN_PRODUCT",
	        title: t('product_admin_general_title'),
	        messages: messages,
	        contextHolder: contextHolder,
	        value: selectedProduct,
	        fetchItems: this.fetchProducts,
	        headerFields: formFieldsEl,
	        onAdd: this._onAddProduct,
	        onChange: this._onChangeProducts,
	        onCancel: this._onCancel,
	        onDelete: this._onDeleteProduct,
	        addEnterKeyDown: this._addEnterKeyDown,
	        additionalButtons: additionalButtons,
	        breadcrumb: this._getBreadcrumbLinks()
	      }, React.createElement(AdminScaffoldingTable, {
	        headerActiveFilters: this.state.headerActiveFilters,
	        onRowSelection: this._onRowSelection,
	        value: selectedProduct,
	        sortByColumn: ['name'],
	        filteredColumns: ['name', 'beerStyle.name', 'volumeWithUnit', 'amountItems'],
	        displayAttributes: ['name', {
	          name: 'beerStyle',
	          getHTML: this._getWrapperColor
	        }, 'displayCategory', 'volumeWithUnit', {
	          name: 'iconsFull',
	          getHTML: this._getStampsIcons.bind(this)
	        }, 'amountItems'],
	        columnNames: [t('product_admin_general_column_name'), t('product_admin_general_column_beer_style'), t('product_admin_general_column_category'), t('product_admin_general_column_volume'), t('product_admin_general_column_icons'), t('product_admin_general_column_amount_items')]
	      }, products)));
	    }
	  }
	});
	
	function filterBeerStyleEnable(beerStyles) {
	  return filter(beerStyles, function (beerStyle) {
	    return get(beerStyle, 'enable') === true || get(beerStyle, 'enable') === undefined;
	  });
	}
	
	module.exports = ProductsAdmin;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1368);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    SessionStore = __webpack_require__(11),
	    BoxSelector = __webpack_require__(697);
	
	
	var ReportAdmin = React.createClass({ displayName: "ReportAdmin",
	
	  getInitialState: function getInitialState() {
	    return {};
	  },
	  render: function render() {
	
	    var permissions = SessionStore.getUserPermissions().map(function (permission) {
	      return permission.name;
	    });
	    var ALL_REPORT = [{
	      title: t('report_general_by_product'),
	      imageSrc: 'https://d1nhio0ox7pgb.cloudfront.net/_img/g_collection_png/standard/256x256/package.png',
	      style: { fontSize: '10px', backgroundColor: 'red !important' },
	      permission: 'ADMIN_REPORT_BY_PRODUCT',
	      link: '/#/reports/by-products'
	    }, {
	      title: t('report_general_by_task'),
	      imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
	      style: {},
	      permission: 'ADMIN_REPORT_BY_TASK',
	      link: '/#/reports/by-tasks'
	    }, {
	      title: t('report_general_by_item_transaction'),
	      imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
	      style: {},
	      permission: 'ADMIN_REPORT_BY_ITEM_TRANSACTION',
	      link: '/#/reports/by-item-transaction'
	    }, {
	      title: t('report_general_by_batch_number'),
	      imageSrc: 'https://cdn3.iconfinder.com/data/icons/hotel-restaurant-flat-vol-3/150/clipboard__checklist__tasklist__document-512.png',
	      style: {},
	      permission: 'ADMIN_REPORT_BY_BATCH_NUMBER',
	      link: '/#/reports/by-batch-number'
	    }].filter(function (report) {
	      return permissions.some(function (userPermission) {
	        return userPermission === report.permission;
	      });
	    });
	
	    var reportsEl = map(ALL_REPORT, function (module) {
	      return React.createElement(BoxSelector, {
	        imageSrc: module.imageSrc,
	        title: module.title,
	        stlye: module.style,
	        link: module.link });
	    });
	
	    return React.createElement("div", { className: "report-admin" }, React.createElement("div", { className: "report-admin__header" }, t('report_general_select_report')), React.createElement("div", { className: "report-admin__body" }, reportsEl));
	  }
	});
	
	module.exports = ReportAdmin;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1369);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    BeerStyleStore = __webpack_require__(95),
	    ReportStore = __webpack_require__(412),
	    DropDown = __webpack_require__(105),
	    ContentUtils = __webpack_require__(7),
	    InventoryStore = __webpack_require__(20),
	    _require2 = __webpack_require__(12),
	    DatePicker = _require2.DatePicker,
	    Toggle = _require2.Toggle,
	    RadioButtonGroup = _require2.RadioButtonGroup,
	    RadioButton = _require2.RadioButton,
	    CircularProgress = _require2.CircularProgress,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    filter = _require3.filter,
	    find = _require3.find,
	    ComponentUtils = __webpack_require__(77),
	    _require4 = __webpack_require__(53),
	    cloneDeep = _require4.cloneDeep,
	    get = __webpack_require__(5).get,
	    FormGroupButton = __webpack_require__(30),
	    GridItemWithFilter = __webpack_require__(153);
	
	
	var FILTER_BY_OPTIONS = ['Month', 'Week', 'Day'].map(function (name, index) {
	    return {
	        payload: index + 1,
	        name: name
	    };
	});
	
	var ReportByBeerStyle = React.createClass({ displayName: "ReportByBeerStyle",
	
	    getInitialState: function getInitialState() {
	        return {
	            filter: {
	                moduleName: 'REPORT_BY_BEER_STYLES',
	                isDetailedByBeerStyle: false,
	                isAllSelected: true,
	                dateTo: new Date(),
	                dateFrom: new Date(),
	                isShowConfirmed: true,
	                selectedBeerStyleIds: [],
	                reportKey: '',
	                filterByOptionIndex: 0,
	                isGeneratingReport: false,
	                isFetching: true
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        var self = this;
	        this.setState({ isFetching: true });
	        BeerStyleStore.fetchStyleBeers(function (beerStyles) {
	            self.setState(function (prevState) {
	
	                prevState.beerStyles = map(beerStyles, function (beerStyle) {
	                    beerStyle.iconClassName = '';
	                    return beerStyle;
	                });
	
	                prevState.filter.selectedBeerStyleIds = map(beerStyles, function (beerStyle) {
	                    return get(beerStyle, 'id');
	                });
	
	                prevState.isFetching = false;
	
	                return prevState;
	            });
	        });
	    },
	    isSelectedBeerStyle: function isSelectedBeerStyle(item) {
	        return this.state.filter.selectedBeerStyleIds.indexOf(item.id) > -1;
	    },
	    isChangedBeerStyle: function isChangedBeerStyle() {
	        return false;
	    },
	    onChangeBeerStyle: function onChangeBeerStyle(item) {
	        var self = this;
	        this.setState(function (prevState) {
	            if (ContentUtils.isNullOrEmpty(prevState.filter.selectedBeerStyleIds)) {
	                prevState.filter.selectedBeerStyleIds = [];
	            }
	
	            var isAlreadySelected = prevState.filter.selectedBeerStyleIds.indexOf(item.iconId) > -1;
	            if (item.isChecked && isAlreadySelected) {
	                prevState.filter.selectedBeerStyleIds = filter(prevState.filter.selectedBeerStyleIds, function (id) {
	                    return id !== item.iconId;
	                });
	            } else if (!item.isChecked && !isAlreadySelected) {
	                prevState.filter.selectedBeerStyleIds.push(item.iconId);
	            }
	
	            item.isChecked = !item.isChecked;
	            prevState.filter.isAllSelected = self._isAllSelected(prevState);
	
	            return prevState;
	        });
	    },
	    onChangeFrom: function onChangeFrom(nil, dateFrom) {
	        //this.refs.dateFrom.setDate(dateFrom);
	        this.setState(function (prevState) {
	            prevState.filter.dateFrom = dateFrom;
	            return prevState;
	        });
	    },
	    onChangeTo: function onChangeTo(nil, dateTo) {
	        //this.refs.dateTo.setDate(dateTo);
	        this.setState(function (prevState) {
	            prevState.filter.dateTo = dateTo;
	            return prevState;
	        });
	    },
	    onToggleDetailedByBeerStyle: function onToggleDetailedByBeerStyle() {
	        this.setState(function (prevState) {
	            prevState.filter.isDetailedByBeerStyle = !prevState.filter.isDetailedByBeerStyle;
	            return prevState;
	        });
	    },
	    onToggleSelectAll: function onToggleSelectAll(evt, isSelected) {
	        var self = this;
	
	        this.setState(function (prevState) {
	            if (isSelected) {
	                prevState.filter.selectedBeerStyleIds = map(prevState.beerStyles, function (beerStyle) {
	                    return get(beerStyle, 'id');
	                });
	            } else {
	                prevState.filter.selectedBeerStyleIds = [];
	            }
	
	            prevState.filter.isAllSelected = self._isAllSelected(prevState);
	            return prevState;
	        });
	    },
	    onChangeIsPlanned: function onChangeIsPlanned(evt, value) {
	        this.setState(function (prevState) {
	            prevState.filter.isShowConfirmed = value === 'CONFIRMED';
	            return prevState;
	        });
	    },
	    _onSelectBeerStyle: function _onSelectBeerStyle(optionSelected) {
	        var options = ComponentUtils.toMenuItemsWithNonSelectedItem(FILTER_BY_OPTIONS, 'Total');
	        var optionTarget = find(options, function (option) {
	            return option.text === (get(optionSelected, 'name') || get(optionSelected, 'text'));
	        });
	        this.setState(function (prevState) {
	            prevState.filter.filterByOptionIndex = get(optionTarget, 'payload');
	            return prevState;
	        });
	    },
	    _isAllSelected: function _isAllSelected(prevState) {
	        var amountSelected = get(prevState.filter.selectedBeerStyleIds, 'length') || 0;
	        var amountBeerStyle = get(prevState.beerStyles, 'length') || 0;
	        return amountSelected > 0 && amountSelected === amountBeerStyle;
	    },
	    _onSubmit: function _onSubmit() {
	        var _this = this;
	
	        var filter = cloneDeep(this.state.filter);
	        filter.dateFrom = this.refs.dateFrom.getDate().toISOString();
	        filter.dateTo = this.refs.dateTo.getDate().toISOString();
	        filter.reportKey = ReportStore.generateKeyReportByBeerStyle(filter);
	        this.setState({
	            isGeneratingReport: true
	        }, function () {
	            InventoryStore.downloadReportXLS(filter, 'orders/by-beerstyle', function () {
	                _this.setState({
	                    isGeneratingReport: false
	                });
	            }, function () {
	                _this.setState({
	                    messageErrorItem: t('dashboard_notification_something_was_wrong')
	                });
	            });
	        });
	    },
	    render: function render() {
	        var _state$filter = this.state.filter,
	            isShowConfirmed = _state$filter.isShowConfirmed,
	            dateFrom = _state$filter.dateFrom,
	            dateTo = _state$filter.dateTo,
	            isDetailedByBeerStyle = _state$filter.isDetailedByBeerStyle,
	            isAllSelected = _state$filter.isAllSelected;
	
	
	        return React.createElement("div", { className: "report-by-beer-style" }, React.createElement("div", { className: "report-by-beer-style__header" }, t('report_beer_style_title')), React.createElement("div", { className: "report-by-beer-style__body" }, React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: '8px' },
	            className: "report-by-beer-style__body-row-title" }, t('report_beer_style_range')), React.createElement(DatePicker, {
	            ref: "dateFrom",
	            style: { maxWidth: '200px', overflow: 'auto' },
	            value: dateFrom,
	            onChange: this.onChangeFrom,
	            floatingLabelText: t('report_beer_style_from') }), React.createElement(DatePicker, {
	            ref: "dateTo",
	            value: dateTo,
	            style: { maxWidth: '200px', overflow: 'auto' },
	            onChange: this.onChangeTo,
	            floatingLabelText: t('report_beer_style_to') })), React.createElement("br", null), React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: 0 }, className: "report-by-beer-style__body-row-title" }, t('report_beer_style_show_by')), React.createElement(DropDown, {
	            readerAttribute: "text",
	            name: t('report_beer_style_beer_style'),
	            items: ComponentUtils.toMenuItemsWithNonSelectedItem(FILTER_BY_OPTIONS, 'Total'),
	            selectedIndex: this.state.filter.filterByOptionIndex + 1,
	            onChange: this._onSelectBeerStyle })), React.createElement("br", null), React.createElement("br", null), React.createElement("div", { className: "report-by-beer-style__body-content" }, React.createElement("label", { className: "report-by-beer-style__body-row-title" }, "Selected beer styles"), React.createElement(Toggle, {
	            style: { maxWidth: '120px' },
	            value: isAllSelected,
	            defaultToggled: isAllSelected,
	            label: t('report_beer_style_select_all'),
	            labelStyle: { fontWeight: '100' },
	            onToggle: this.onToggleSelectAll }), this.state.isFetching && React.createElement(CircularProgress, null), !this.state.isFetching && React.createElement(GridItemWithFilter, {
	            items: this.state.beerStyles,
	            isCheckedItem: this.isSelectedBeerStyle,
	            isChangedItem: this.isChangedBeerStyle,
	            onCheckItem: this.onChangeBeerStyle,
	            displayNameField: "name",
	            iconClassNameField: "iconDetail.iconClassName",
	            idField: "iconDetail.id",
	            initialFilterText: this.state.filterText,
	            nonMatchingText: t('report_beer_style_warning_non_matching_found'),
	            keepSelectedSorting: false }), React.createElement("br", null), React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement(Toggle, {
	            style: { maxWidth: '190px' },
	            value: isDetailedByBeerStyle,
	            label: t('report_beer_style_show_by_beer_style'),
	            labelStyle: { fontWeight: '100' },
	            onToggle: this.onToggleDetailedByBeerStyle })), React.createElement(RadioButtonGroup, { ref: "refPlannedConfirmed", onChange: this.onChangeIsPlanned, name: "isPlanned",
	            defaultSelected: isShowConfirmed ? 'CONFIRMED' : 'PLANNED' }, React.createElement(RadioButton, {
	            value: "PLANNED",
	            label: t('report_beer_style_planned'),
	            style: { marginTop: 16 } }), React.createElement(RadioButton, {
	            value: "CONFIRMED",
	            label: t('report_beer_style_confirmed'),
	            style: { marginTop: 16 } }))), React.createElement("div", { className: "report-by-beer-style__submit" }, React.createElement(FormGroupButton, {
	            className: "primary-icon",
	            type: "icon",
	            label: t('report_beer_style_download_report'),
	            onClick: this.state.isGeneratingReport ? function () {} : this._onSubmit }), this.state.isGeneratingReport && React.createElement(CircularProgress, { size: .4 }))));
	    }
	});
	
	module.exports = ReportByBeerStyle;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1370);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    moment = __webpack_require__(3),
	    ContentUtils = __webpack_require__(7),
	    DateUtils = __webpack_require__(22),
	    InventoryStore = __webpack_require__(20),
	    _require2 = __webpack_require__(12),
	    DatePicker = _require2.DatePicker,
	    CircularProgress = _require2.CircularProgress,
	    _require3 = __webpack_require__(53),
	    cloneDeep = _require3.cloneDeep,
	    get = __webpack_require__(5).get,
	    FormGroupButton = __webpack_require__(30),
	    TextFieldSuggested = __webpack_require__(230);
	
	
	var ReportByItemTransaction = React.createClass({ displayName: "ReportByItemTransaction",
	
	    getInitialState: function getInitialState() {
	        return {
	            filter: {
	                moduleName: 'REPORT_BY_ITEM_TRANSACTION',
	                messageErrorItem: '',
	                dateTo: new Date(),
	                dateFrom: moment().add(-1, 'days').toDate(),
	                reportKey: '',
	                isFetching: true,
	                isGeneratingReport: false
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchItems();
	    },
	    fetchItems: function fetchItems() {
	        var _this = this;
	
	        this.setState({
	            isFetching: true
	        }, function () {
	            InventoryStore.fetchAllItems(function (items) {
	                var itemsSorted = ContentUtils.sortList(items, 'description');
	                _this.setState({
	                    items: ContentUtils.filterEnable(itemsSorted),
	                    isFetching: false
	                });
	            });
	        });
	    },
	    onChangeFrom: function onChangeFrom(nil, dateFrom) {
	        this.setState(function (prevState) {
	            prevState.filter.dateFrom = dateFrom;
	            return prevState;
	        });
	    },
	    onChangeTo: function onChangeTo(nil, dateTo) {
	        this.setState(function (prevState) {
	            prevState.filter.dateTo = dateTo;
	            return prevState;
	        });
	    },
	    _onSubmit: function _onSubmit() {
	        var _this2 = this;
	
	        var filter = cloneDeep(this.state.filter);
	        filter.dateFrom = this.refs.dateFrom.getDate().toISOString();
	        filter.dateTo = this.refs.dateTo.getDate().toISOString();
	        filter.itemId = get(this.state, 'itemSelected.id');
	
	        if (!filter.itemId) {
	            this.setState({
	                messageErrorItem: t('report_item_warning_item_is_required')
	            });
	            return;
	        }
	
	        filter.reportKey = 'REPORT_BY_ITEM_TRANSACTION';
	
	        this.setState({
	            isGeneratingReport: true
	        }, function () {
	            InventoryStore.downloadReportXLS(filter, 'items/by-item-transaction', function () {
	                _this2.setState({
	                    isGeneratingReport: false,
	                    messageErrorItem: ''
	                });
	            }, function () {
	                _this2.setState({
	                    messageErrorItem: t('dashboard_notification_something_was_wrong')
	                });
	            });
	        });
	    },
	    onItemSelected: function onItemSelected(itemSelected) {
	        var textWritten = get(itemSelected, this.props.readerAttribute);
	        this.setState({
	            itemSelected: itemSelected,
	            textWritten: textWritten
	        });
	    },
	    render: function render() {
	        var _state$filter = this.state.filter,
	            dateFrom = _state$filter.dateFrom,
	            dateTo = _state$filter.dateTo;
	        var _state = this.state,
	            items = _state.items,
	            itemSelected = _state.itemSelected,
	            messageErrorItem = _state.messageErrorItem,
	            isFetching = _state.isFetching,
	            isGeneratingReport = _state.isGeneratingReport;
	
	
	        return React.createElement("div", { className: "report-by-beer-style" }, React.createElement("div", { className: "report-by-beer-style__header" }, t('report_by_item_transaction')), React.createElement("div", { className: "report-by-beer-style__body" }, React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: '8px' },
	            className: "report-by-beer-style__body-row-title" }, t('report_beer_style_range')), React.createElement(DatePicker, {
	            formatDate: DateUtils.toDateText,
	            ref: "dateFrom",
	            style: { maxWidth: '200px', overflow: 'auto' },
	            value: dateFrom,
	            onChange: this.onChangeFrom,
	            floatingLabelText: t('report_beer_style_from') }), React.createElement(DatePicker, {
	            formatDate: DateUtils.toDateText,
	            ref: "dateTo",
	            value: dateTo,
	            style: { maxWidth: '200px', overflow: 'auto' },
	            onChange: this.onChangeTo,
	            floatingLabelText: t('report_beer_style_to') })), React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: 0 }, className: "report-by-beer-style__body-row-title-show-by" }, t('report_by_item_transaction_label_item_description')), React.createElement(TextFieldSuggested, {
	            readerAttribute: "description",
	            items: items,
	            readerAttributeValue: "id",
	            className: "report-by-item-transaction",
	            floatingLabelStyle: { color: '#fff !important', fontWeight: '300' },
	            LabelStyle: { color: '#fff !important', fontWeight: '300' },
	            value: itemSelected,
	            floatingLabelText: t('report_item_description'),
	            style: { width: '100%', color: 'white !important', fontWeight: '300' },
	            onItemSelected: this.onItemSelected,
	            errorText: messageErrorItem
	        }), isFetching && React.createElement(CircularProgress, null)), React.createElement("div", { className: "report-by-beer-style__submit" }, React.createElement(FormGroupButton, {
	            className: "primary-icon",
	            type: "icon",
	            label: t('report_item_download_report'),
	            onClick: isGeneratingReport ? function () {} : this._onSubmit,
	            disable: isGeneratingReport }), isGeneratingReport && React.createElement(CircularProgress, { size: .4 }))));
	    }
	});
	
	module.exports = ReportByItemTransaction;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1371);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    ReportStore = __webpack_require__(412),
	    Constants = __webpack_require__(2),
	    DropDown = __webpack_require__(105),
	    ContentUtils = __webpack_require__(7),
	    DateUtils = __webpack_require__(22),
	    Notification = __webpack_require__(21),
	    InventoryStore = __webpack_require__(20),
	    _require2 = __webpack_require__(12),
	    DatePicker = _require2.DatePicker,
	    Toggle = _require2.Toggle,
	    RadioButtonGroup = _require2.RadioButtonGroup,
	    RadioButton = _require2.RadioButton,
	    CircularProgress = _require2.CircularProgress,
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    filter = _require3.filter,
	    ComponentUtils = __webpack_require__(77),
	    _require4 = __webpack_require__(53),
	    cloneDeep = _require4.cloneDeep,
	    get = __webpack_require__(5).get,
	    FormGroupButton = __webpack_require__(30),
	    GridItemWithFilter = __webpack_require__(153);
	
	
	var ReportByProduct = React.createClass({ displayName: "ReportByProduct",
	
	  getInitialState: function getInitialState() {
	    return {
	      isFetching: true,
	      isGeneratingReport: false,
	      filter: {
	        moduleName: 'REPORT_BY_PRODUCT',
	        isDetailedByProduct: false,
	        isAllSelected: true,
	        dateTo: new Date(),
	        dateFrom: new Date(),
	        isShowConfirmed: true,
	        selectedProductIds: [],
	        reportKey: '',
	        filterByOptionIndex: 0
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var self = this;
	    this.setState({
	      isFetching: true
	    });
	    InventoryStore.fetchProducts(function (products) {
	      self.setState(function (prevState) {
	
	        prevState.products = map(products, function (product) {
	          product.iconClassName = '';
	          product.nameWithBeerStyle = productWithBeerStyle(product);
	          return product;
	        });
	
	        prevState.filter.selectedProductIds = map(products, function (beerStyle) {
	          return get(beerStyle, 'id');
	        });
	
	        prevState.isFetching = false;
	
	        return prevState;
	      });
	    });
	  },
	  isSelectedProduct: function isSelectedProduct(item) {
	    return this.state.filter.selectedProductIds.indexOf(item.id) > -1;
	  },
	  isChangedProduct: function isChangedProduct() {
	    return false;
	  },
	  onChangeProduct: function onChangeProduct(item) {
	    var self = this;
	    this.setState(function (prevState) {
	      if (ContentUtils.isNullOrEmpty(prevState.filter.selectedProductIds)) {
	        prevState.filter.selectedProductIds = [];
	      }
	
	      var isAlreadySelected = prevState.filter.selectedProductIds.indexOf(item.iconId) > -1;
	      if (item.isChecked && isAlreadySelected) {
	        prevState.filter.selectedProductIds = filter(prevState.filter.selectedProductIds, function (id) {
	          return id !== item.iconId;
	        });
	      } else if (!item.isChecked && !isAlreadySelected) {
	        prevState.filter.selectedProductIds.push(item.iconId);
	      }
	
	      item.isChecked = !item.isChecked;
	      prevState.filter.isAllSelected = self._isAllSelected(prevState);
	
	      return prevState;
	    });
	  },
	  onChangeFrom: function onChangeFrom(nil, dateFrom) {
	    //this.refs.dateFrom.setDate(dateFrom);
	    this.setState(function (prevState) {
	      prevState.filter.dateFrom = dateFrom;
	      return prevState;
	    });
	  },
	  onChangeTo: function onChangeTo(nil, dateTo) {
	    //this.refs.dateTo.setDate(dateTo);
	    this.setState(function (prevState) {
	      prevState.filter.dateTo = dateTo;
	      return prevState;
	    });
	  },
	  onToggleSelectAll: function onToggleSelectAll(evt, isSelected) {
	    var self = this;
	
	    this.setState(function (prevState) {
	      if (isSelected) {
	        prevState.filter.selectedProductIds = map(prevState.products, function (beerStyle) {
	          return get(beerStyle, 'id');
	        });
	      } else {
	        prevState.filter.selectedProductIds = [];
	      }
	
	      prevState.filter.isAllSelected = self._isAllSelected(prevState);
	      return prevState;
	    });
	  },
	  onChangeIsPlanned: function onChangeIsPlanned(evt, value) {
	    this.setState(function (prevState) {
	      prevState.filter.isShowConfirmed = value === 'CONFIRMED';
	      return prevState;
	    });
	  },
	  getFilterOptions: function getFilterOptions() {
	    return ['Month', 'Week', 'Day'].map(function (name, index) {
	      return {
	        payload: index + 1,
	        name: name,
	        displayName: Constants.getReportByMapping(t)[name]
	      };
	    });
	  },
	  _onSelectProduct: function _onSelectProduct(optionSelected) {
	    this.setState(function (prevState) {
	      prevState.filter.filterByOptionIndex = get(optionSelected, 'itemModel.payload');
	      return prevState;
	    });
	  },
	  _isAllSelected: function _isAllSelected(prevState) {
	    var amountSelected = get(prevState.filter.selectedProductIds, 'length') || 0;
	    var amountProduct = get(prevState.products, 'length') || 0;
	    return amountSelected > 0 && amountSelected === amountProduct;
	  },
	  _onSubmit: function _onSubmit(evt) {
	    var _this = this;
	
	    evt.preventDefault();
	    if (this.state.isGeneratingReport) return; // prevent to search twice
	
	    var filter = cloneDeep(this.state.filter);
	    filter.dateFrom = this.refs.dateFrom.getDate().toISOString();
	    filter.dateTo = this.refs.dateTo.getDate().toISOString();
	    filter.reportKey = ReportStore.generateKeyReportByProduct(filter);
	    this.setState({ isGeneratingReport: true });
	    InventoryStore.downloadReportXLS(filter, 'orders/by-products', function () {
	      _this.setState({ isGeneratingReport: false });
	    }, function () {
	      Notification.show(t('dashboard_notification_something_was_wrong'), 'error');
	    });
	  },
	  render: function render() {
	    var _state$filter = this.state.filter,
	        isShowConfirmed = _state$filter.isShowConfirmed,
	        dateFrom = _state$filter.dateFrom,
	        dateTo = _state$filter.dateTo,
	        isAllSelected = _state$filter.isAllSelected,
	        isFetching = _state$filter.isFetching;
	    var isGeneratingReport = this.state.isGeneratingReport;
	
	
	    return React.createElement("div", { className: "report-by-beer-style" }, React.createElement("div", { className: "report-by-beer-style__header" }, t('report_by_product_title_product_report')), React.createElement("div", { className: "report-by-beer-style__body" }, React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: '8px' },
	      className: "report-by-beer-style__body-row-title" }, t('report_beer_style_range')), React.createElement(DatePicker, {
	      formatDate: DateUtils.toDateText,
	      ref: "dateFrom",
	      style: { maxWidth: '200px', overflow: 'auto' },
	      value: dateFrom,
	      onChange: this.onChangeFrom,
	      floatingLabelText: t('report_by_product_label_from') }), React.createElement(DatePicker, {
	      formatDate: DateUtils.toDateText,
	      ref: "dateTo",
	      value: dateTo,
	      style: { maxWidth: '200px', overflow: 'auto' },
	      onChange: this.onChangeTo,
	      floatingLabelText: t('report_by_product_label_to') })), React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: 0 },
	      className: "report-by-beer-style__body-row-title-show-by" }, t('report_beer_style_show_by')), React.createElement(DropDown, {
	      readerAttribute: "text",
	      name: t('report_item_product_by'),
	      items: ComponentUtils.toMenuItemsWithNonSelectedItem(this.getFilterOptions(), t('report_item_total'), 'displayName'),
	      selectedIndex: this.state.filter.filterByOptionIndex + 1,
	      onChange: this._onSelectProduct })), React.createElement("br", null), React.createElement("br", null), React.createElement("div", { className: "report-by-beer-style__body-content" }, React.createElement("label", { className: "report-by-beer-style__body-row-title" }, t('report_by_product_label_selected_products')), React.createElement("br", null), React.createElement(Toggle, {
	      style: { maxWidth: '120px' },
	      value: get(this.state, 'filterText.length') > 0 ? false : isAllSelected,
	      defaultToggled: isAllSelected,
	      label: t('report_item_select_all'),
	      labelStyle: { fontWeight: '100' },
	      onToggle: this.onToggleSelectAll }), React.createElement("br", null), !isFetching && React.createElement(GridItemWithFilter, {
	      items: this.state.products,
	      isCheckedItem: this.isSelectedProduct,
	      isChangedItem: this.isChangedProduct,
	      onCheckItem: this.onChangeProduct,
	      displayNameField: "nameWithBeerStyle",
	      iconClassNameField: "iconDetail.iconClassName",
	      idField: "iconDetail.id",
	      initialFilterText: this.state.filterText,
	      nonMatchingText: t('icons_and_sections_non_matching'),
	      keepSelectedSorting: false }), isFetching && React.createElement(CircularProgress, null), React.createElement(RadioButtonGroup, { ref: "refPlannedConfirmed", onChange: this.onChangeIsPlanned, name: "isPlanned",
	      defaultSelected: isShowConfirmed ? 'CONFIRMED' : 'PLANNED' }, React.createElement(RadioButton, {
	      value: "PLANNED",
	      label: t('report_beer_style_planned'),
	      style: { marginTop: 16 } }), React.createElement(RadioButton, {
	      value: "CONFIRMED",
	      label: t('report_beer_style_confirmed'),
	      style: { marginTop: 16 } }))), React.createElement("div", { className: "report-by-beer-style__submit" }, React.createElement(FormGroupButton, {
	      className: "primary-icon",
	      type: "icon",
	      label: t('report_beer_style_download_report'),
	      onClick: isGeneratingReport ? function () {} : this._onSubmit,
	      disable: isGeneratingReport }), isGeneratingReport && React.createElement(CircularProgress, { size: .4 }))));
	  }
	});
	
	function productWithBeerStyle(product) {
	  var beerStyle = get(product, 'beerStyle.name') || '';
	  return (getTwoFirstWords(beerStyle) + ' - ' + product.name).replace(',', ' ');
	}
	
	function getTwoFirstWords() {
	  var beerStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	  return beerStyle.split(' ').slice(0, 2);
	}
	
	module.exports = ReportByProduct;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1372);
	
	var React = __webpack_require__(1),
	    DateUtils = __webpack_require__(22),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    InventoryStore = __webpack_require__(20),
	    _require2 = __webpack_require__(12),
	    DatePicker = _require2.DatePicker,
	    CircularProgress = _require2.CircularProgress,
	    _require3 = __webpack_require__(53),
	    cloneDeep = _require3.cloneDeep,
	    FormGroupButton = __webpack_require__(30);
	
	
	var ReportByTask = React.createClass({ displayName: "ReportByTask",
	
	  getInitialState: function getInitialState() {
	    return {
	      filter: {
	        moduleName: 'REPORT_BY_PRODUCT',
	        isAllSelected: true,
	        dateTo: new Date(),
	        date: new Date(),
	        isShowConfirmed: true,
	        selectedTaskIds: [],
	        reportKey: '',
	        filterByOptionIndex: 0,
	        isGeneratingReport: false
	      }
	    };
	  },
	  componentDidMount: function componentDidMount() {},
	  onChangeFrom: function onChangeFrom(nil, date) {
	    this.setState(function (prevState) {
	      prevState.filter.date = date;
	      return prevState;
	    });
	  },
	  _onSubmit: function _onSubmit() {
	    var _this = this;
	
	    var filter = cloneDeep(this.state.filter);
	    filter.date = this.refs.date.getDate().toISOString();
	    filter.reportKey = 'REPORT_BY_TASK_BY_DATE';
	    this.setState({
	      isGeneratingReport: true
	    }, function () {
	      InventoryStore.downloadReportXLS(filter, 'orders/by-tasks', function () {
	        _this.setState({ isGeneratingReport: false, messageErrorItem: '' });
	      });
	    }, function () {
	      Notification.show(t('dashboard_notification_something_was_wrong'), 'error');
	    });
	  },
	  render: function render() {
	    var date = this.state.filter.date;
	    var isGeneratingReport = this.state.isGeneratingReport;
	
	
	    return React.createElement("div", { className: "report-by-beer-style" }, React.createElement("div", { className: "report-by-beer-style__header" }, t('report_task_title')), React.createElement("div", { className: "report-by-beer-style__body" }, React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: '8px' },
	      className: "report-by-beer-style__body-row-title" }, t('report_task_date')), React.createElement(DatePicker, {
	      ref: "date",
	      formatDate: DateUtils.toDateText,
	      style: { maxWidth: '200px', overflow: 'auto' },
	      value: date,
	      onChange: this.onChangeFrom })), React.createElement("div", { className: "report-by-beer-style__submit" }, React.createElement(FormGroupButton, {
	      className: "primary-icon",
	      type: "icon",
	      label: t('report_item_download_report'),
	      onClick: isGeneratingReport ? function () {} : this._onSubmit }), isGeneratingReport && React.createElement(CircularProgress, { size: .4 }))));
	  }
	});
	
	module.exports = ReportByTask;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1373);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    InventoryStore = __webpack_require__(20),
	    _require2 = __webpack_require__(53),
	    cloneDeep = _require2.cloneDeep,
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(12),
	    CircularProgress = _require3.CircularProgress,
	    FormGroupButton = __webpack_require__(30),
	    TextField = __webpack_require__(106);
	
	
	var ReportByItemTransaction = React.createClass({ displayName: "ReportByItemTransaction",
	
	  getInitialState: function getInitialState() {
	    return {
	      filter: {
	        moduleName: 'REPORT_ORDER_BY_BATCH_NUMBER',
	        messageErrorItem: '',
	        batchNumber: '',
	        reportKey: ''
	      }
	    };
	  },
	  _onSubmit: function _onSubmit() {
	    var _this = this;
	
	    var filter = cloneDeep(this.state.filter);
	    filter.batchNumber = get(this.state, 'batchNumber');
	
	    if (!filter.batchNumber) {
	      this.setState({
	        messageErrorItem: t('report_batch_number_inline_error_batch_number_is_required')
	      });
	      return;
	    }
	
	    filter.reportKey = 'REPORT_ORDER_BY_BATCH_NUMBER';
	    this.setState({
	      isGeneratingReport: true
	    }, function () {
	      InventoryStore.downloadReportXLS(filter, '/orders/by-batch-number/' + filter.batchNumber, function () {
	        _this.setState({
	          isGeneratingReport: false,
	          messageErrorItem: ''
	        });
	      }, function () {
	        _this.setState({
	          isGeneratingReport: false,
	          messageErrorItem: t('report_error_not_found_by_batch_number')
	        });
	      });
	    });
	  },
	  onBlurBatchNumber: function onBlurBatchNumber(evt) {
	    this.setState({
	      batchNumber: evt.target.value
	    });
	  },
	  render: function render() {
	    var _state = this.state,
	        batchNumber = _state.batchNumber,
	        isGeneratingReport = _state.isGeneratingReport;
	
	    var messageError = this.state.messageErrorItem || this.state.error || '';
	
	    return React.createElement("div", { className: "report-by-beer-style" }, React.createElement("div", { className: "report-by-beer-style__header" }, t('report_batch_number_title')), React.createElement("div", { className: "report-by-beer-style__body" }, React.createElement("div", { className: "report-by-beer-style__body-row" }, React.createElement("label", { style: { marginBottom: 0 }, className: "report-by-beer-style__body-row-title-show-by" }, t('report_batch_number_batch_number')), React.createElement(TextField, {
	      className: "full-width id-username",
	      hintText: t('report_batch_number_enter_batch_number'),
	      defaultValue: batchNumber,
	      floatingLabelText: t('report_batch_number_batch_number'),
	      onEnterKeyDown: this.handleSubmit,
	      errorText: messageError,
	      onBlur: this.onBlurBatchNumber
	    })), React.createElement("div", { className: "report-by-beer-style__submit" }, React.createElement(FormGroupButton, {
	      className: "primary-icon",
	      type: "icon",
	      label: t('report_item_download_report'),
	      onClick: isGeneratingReport ? function () {} : this._onSubmit }), isGeneratingReport && React.createElement(CircularProgress, { size: .4 }))));
	  }
	});
	
	module.exports = ReportByItemTransaction;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(37),
	    delay = _require2.delay,
	    DateUtils = __webpack_require__(22),
	    NumberUtils = __webpack_require__(23),
	    NavigationUtils = __webpack_require__(35),
	    _require3 = __webpack_require__(8),
	    map = _require3.map,
	    find = _require3.find,
	    reduce = _require3.reduce,
	    SessionStore = __webpack_require__(11),
	    FlatSphere = __webpack_require__(400),
	    LocaleUtils = __webpack_require__(233),
	    Notification = __webpack_require__(21),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTablePaged = __webpack_require__(178),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupButton = __webpack_require__(30),
	    Loading = __webpack_require__(33),
	    ContentUtils = __webpack_require__(7),
	    CustomDialog = __webpack_require__(26),
	    AppConstants = __webpack_require__(2),
	    InventoryStore = __webpack_require__(20),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupDatePicker = __webpack_require__(702),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    FormGroupDropdown = __webpack_require__(58),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require4 = __webpack_require__(19),
	    Navigation = _require4.Navigation,
	    get = __webpack_require__(5).get;
	
	
	var pageUrl = '/sales/page/';
	
	var INITIAL_STATE = {
	  selectedItem: null,
	  selectedCustomer: null,
	  selectedShippingTo: null,
	  selectedBillingTo: null,
	  isEditMode: false,
	  isFetching: true,
	  amountPaid: null,
	  filter: Object.freeze({
	    code: '',
	    customerName: '',
	    state: '',
	    displayDateOpen: '',
	    displayDeliveredDate: '',
	    displayPriority: '',
	    amountPaid: '',
	    totalPriceWithUnit: ''
	  })
	};
	
	var SalesAdmin = React.createClass({ displayName: "SalesAdmin",
	
	  mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	  getInitialState: function getInitialState() {
	    return INITIAL_STATE;
	  },
	  componentDidMount: function componentDidMount() {
	    this.fetchItems();
	    ga.pageview('/sales-admin');
	  },
	  fetchItems: function fetchItems() {
	    var self = this;
	    var currentPage = NavigationUtils.getPathParam('page');
	    InventoryStore.fetchSales(currentPage, function (sales) {
	      InventoryStore.fetchCustomers(function (customers) {
	        self.setState({
	          sales: self._sortSalesOrder(self._hydrateAdditionalInfo(ContentUtils.filterEnable(sales))),
	          isFetching: false,
	          customers: ContentUtils.filterEnable(customers)
	        });
	      });
	    });
	  },
	  fetchItemsBy: function fetchItemsBy(filter) {
	    var self = this;
	    InventoryStore.fetchSalesBy(filter, function (sales) {
	      InventoryStore.fetchCustomers(function (customers) {
	        self.setState({
	          sales: self._sortSalesOrder(self._hydrateAdditionalInfo(ContentUtils.filterEnable(sales))),
	          isFetching: false,
	          customers: ContentUtils.filterEnable(customers)
	        });
	      });
	    });
	  },
	  _onClickPage: function _onClickPage(page) {
	    this.transitionTo('/sales/page/:page', { page: page });
	    this.fetchItems();
	  },
	  _sortSalesOrder: function _sortSalesOrder(sales) {
	    return DateUtils.sortListByDateFieldDesc(sales, 'dateCreated');
	  },
	  _hydrateAdditionalInfo: function _hydrateAdditionalInfo(sales) {
	    return map(sales, function (sale) {
	      sale.displayDateOpen = DateUtils.toCurrentTimeZone(sale.dateCreated, SessionStore.getCurrentTimeZone());
	      sale.displayDeliveredDate = DateUtils.toCurrentTimeZone(sale.deliveredDate, SessionStore.getCurrentTimeZone());
	
	      var saleItems = get(sale, 'items') || [];
	      var saleItemsPrices = map(saleItems, function (saleItem) {
	        var priceByUnit = NumberUtils.formatDecimal(get(saleItem, 'customPriceUnit'), get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	        var amount = get(saleItem, 'amount') || 1;
	        return NumberUtils.multiplyAndTruncate(priceByUnit, amount);
	      });
	      sale.totalPrice = reduce(saleItemsPrices, function (total, itemPrice) {
	        return NumberUtils.sum(total, itemPrice);
	      });
	      sale.totalPriceWithUnit = NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(sale.totalSalePrice, get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	      sale.amountPaid = sale.sale.amountPaid > 0 ? NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(sale.sale.amountPaid, get(SessionStore.getCurrentCurrencyDigits(), 'value')) : NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(sale.totalSalePrice, get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	
	      return sale;
	    });
	  },
	  onDeleteSale: function onDeleteSale(saleId, onSuccess, onFailure) {
	    var sales = get(this.state, 'sales') || [];
	    var sale = find(sales, function (sale) {
	      return sale.id === saleId;
	    });
	    var isSaleDelivered = AppConstants.SALE_STATE_DELIVERED.includes(get(sale, 'state'));
	
	    if (isSaleDelivered) {
	      CustomDialog.showInfo(t('warning'), t('sales_warning_not_able_deliver_orders'));
	    } else {
	      CustomDialog.showWarningConfirmation(t('warning'), t('sales_warning_confirm_delete_sale'), function () {
	        InventoryStore.deleteSale(saleId, onSuccess, onFailure);
	      });
	    }
	  },
	  onChangeSale: function onChangeSale(sale, onSuccess) {
	    var allAddress = get(this.state, 'selectedItem.allAddress');
	    sale.shipTo = find(allAddress, function (address) {
	      return get(address, 'id') === get(sale, 'shipToId');
	    });
	    sale.billTo = find(allAddress, function (address) {
	      return get(address, 'id') === get(sale, 'billToId');
	    });
	    InventoryStore.changeSale(sale, onSuccess, this.__onFailureShowMessageError);
	    this.clearValue();
	  },
	  onAddSale: function onAddSale(sale, onSuccess, onFailure) {
	    var customerAddress = get(this.state, 'customerAddress');
	    sale.shipTo = find(customerAddress, function (address) {
	      return get(address, 'id') === get(sale, 'shipToId');
	    });
	    sale.billTo = find(customerAddress, function (address) {
	      return get(address, 'id') === get(sale, 'billToId');
	    });
	    InventoryStore.addSale(sale, onSuccess, onFailure);
	    this.clearValue();
	  },
	  saveNewAmount: function saveNewAmount() {
	    var value = get(this.state, 'amountPaid');
	    if (ContentUtils.isEmptyText(value)) {
	      value = get(this.state.selectedItem, 'totalSalePrice') ? get(this.state.selectedItem, 'totalSalePrice').replaceAll(".", ",") : "0,00";
	    }
	
	    switch (NumberUtils.getCurrentCurrency().decimalSeparator) {
	      case '.':
	        if (/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(value)) {
	          InventoryStore.changeAmountPaidSO({
	            id: get(this.state.selectedItem, 'id'),
	            amountPaid: value
	          }, this.onSuccess, this.__onFailureShowMessageError);
	        };
	        break;
	      case ',':
	        if (/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(value)) {
	          InventoryStore.changeAmountPaidSO({
	            id: get(this.state.selectedItem, 'id'),
	            amountPaid: value
	          }, this.onSuccess, this.__onFailureShowMessageError);
	        };
	        break;
	    }
	
	    this.fetchItems();
	    this.clearValue();
	  },
	  _isPaid: function _isPaid() {
	    return get(this.state, 'selectedItem.state') === 'DELIVERED_PAID';
	  },
	  _onChangeAmount: function _onChangeAmount(sale) {
	    this.state.amountPaid = sale.target.value;
	  },
	  _onChangeComment: function _onChangeComment(sale) {
	    this.state.selectedItem.comment = sale.target.value !== "" ? sale.target.value : "null";
	  },
	  _amountValidation: function _amountValidation(inputValue) {
	    /* const formatter = new Intl.NumberFormat(LocaleUtils.getCurrentLocale(), {
	      style: 'currency',
	      currency: SessionStore.getCurrentCurrency().code,
	    
	      // These options are needed to round to whole numbers if that's what you want.
	      minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	      maximumFractionDigits: 4, // (causes 2500.99 to be printed as $2,501)
	    }); */
	    //console.log(SessionStore.getCurrentCurrency().code);
	    //console.log(formatter.format(inputValue));
	    //console.log(inputValue.replace(/\B(?=(\d{3})+(?!\d))/g,"."));
	    if (ContentUtils.isEmptyText(inputValue)) {
	      return '';
	    }
	    if (get(inputValue, 'length') > 17) {
	      return t('vendor_purchase_max_price');
	    }
	    //console.log(/^(?:\d{1,3}(?:.\d{3})*(?:\,\d+)?|\d+(\,\d+)?)$)/.test(inputValue));
	    switch (NumberUtils.getCurrentCurrency().decimalSeparator) {
	      case '.':
	        if (!/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(inputValue)) {
	          return t('notification_error_invalid_character');
	        };
	        break;
	      case ',':
	        if (!/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(inputValue)) {
	          return t('notification_error_invalid_character');
	        };
	        break;
	    }
	    /*if (+inputValue.split(",")[0] > +get(this.state.selectedItem, 'totalSalePrice') !== null ? +get(this.state.selectedItem, 'totalSalePrice').split(",")[0] : 0) {
	      return t('notification_error_invalid_character');
	    } */
	
	    return '';
	  },
	  _goToSetItems: function _goToSetItems() {
	    this.transitionTo('/sales/:saleId/items', {
	      saleId: get(this.state.selectedItem, 'id')
	    }, {
	      customerId: get(this.state, 'selectedItem.customerId'),
	      name: get(this.state, 'selectedItem.customerName'),
	      code: get(this.state, 'selectedItem.code'),
	      isClosed: AppConstants.SALE_STATE_DELIVERED.includes(get(this.state, 'selectedItem.state')),
	      comment: get(this.state, 'selectedItem.comment') !== "null" ? get(this.state, 'selectedItem.comment') : ""
	    });
	  },
	  _onFailureWhenSendEmailToCustomer: function _onFailureWhenSendEmailToCustomer(messageInfo) {
	    if (messageInfo) {
	      var haveNotEmail = messageInfo.includes(AppConstants.ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL);
	      if (haveNotEmail) {
	        var self = this;
	        CustomDialog.showWarningConfirmation(t('warning'), t('sales_warning_no_item'), function () {
	          self.transitionTo('/customers/:customerId/contacts', {
	            customerId: get(self.state, 'selectedItem.customerId')
	          }, {
	            name: get(self.state, 'selectedItem.customerName')
	          });
	        });
	      } else {
	        var messageError = ContentUtils.formatMessageError(messageInfo);
	        Notification.show(messageError);
	      }
	    }
	  },
	  getBreadcrumbLinks: function getBreadcrumbLinks() {
	    return [{ displayName: t('sales_title') }];
	  },
	  onSuccessSave: function onSuccessSave() {
	    this.fetchItems(function () {
	      Notification.show(t('sales_was_created_success'), 'success');
	    });
	  },
	  _saveComment: function _saveComment() {
	    InventoryStore.saveCommentOnlySaleOrder(get(this.state, 'selectedItem.id'), get(this.state, 'selectedItem.comment') !== "" ? get(this.state, 'selectedItem.comment') : "null");
	    Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + get(this.state, 'selectedItem.id') + " " + t('updated'), 'success');
	  },
	  _showIndicator: function _showIndicator(sale) {
	    var colorFlat = 'red';
	    var statePurchase = get(sale, 'state');
	    var isRedState = AppConstants.PURCHASE_RED_STATE.includes(statePurchase);
	    var isYellowState = AppConstants.SALE_SATES_NOTIFIED.includes(statePurchase);
	    var isGreenState = AppConstants.SALE_STATE_DELIVERED.includes(statePurchase);
	
	    if (isRedState) {
	      colorFlat = 'red';
	    } else if (isYellowState) {
	      colorFlat = 'yellow';
	    } else if (isGreenState) {
	      colorFlat = 'green';
	    }
	
	    return React.createElement(FlatSphere, { bgColor: colorFlat, text: AppConstants.getSalesStateMapping(t)[statePurchase] });
	  },
	  _sendOrderToCustomer: function _sendOrderToCustomer() {
	    var _this = this;
	
	    var self = this;
	    CustomDialog.showWarningConfirmation(t('warning'), t('sales_customer_will_be_notified'), function () {
	      var saleId = get(_this.state, 'selectedItem.id');
	      InventoryStore.sendOrderToCustomer(saleId, self._onSuccessWhenSendEmailConfirmation, self._onFailureWhenSendEmailToCustomer);
	    });
	  },
	  _onSuccessWhenSendEmailConfirmation: function _onSuccessWhenSendEmailConfirmation() {
	    Notification.show(t('sales_order_was_sent'), 'success');
	    this.fetchItems();
	  },
	  _onTypingFilter: function _onTypingFilter(name, match) {
	    var _this2 = this;
	
	    if (!this.state.isFetching) {
	      this.setState(function (prevState) {
	        var nextFilter = _extends({}, prevState.filter) || {};
	        nextFilter[name] = match;
	        _this2.fetchItemsBy(nextFilter);
	        return {
	          filter: nextFilter,
	          isFetching: true
	        };
	      });
	    }
	  },
	  clearValue: function clearValue() {
	    this._onCancel();
	  },
	  clearFilters: function clearFilters() {
	    this.setState({
	      selectedItem: null,
	      selectedCustomer: null,
	      selectedShippingTo: null,
	      selectedBillingTo: null,
	      isEditMode: false,
	      isFetching: true,
	      amountPaid: null,
	      filter: Object.freeze({
	        code: '',
	        customerName: '',
	        state: '',
	        displayDateOpen: '',
	        displayDeliveredDate: '',
	        displayPriority: '',
	        amountPaid: '',
	        totalPriceWithUnit: ''
	      })
	    });
	    this._onClickPage(0);
	  },
	  _onCancel: function _onCancel() {
	    this.transitionTo(getCurrentUrl());
	    this.setState(INITIAL_STATE);
	  },
	  _printReport: function _printReport() {
	    InventoryStore.downloadReportXLS(this.state.filter, 'sales');
	  },
	  _onPaid: function _onPaid() {
	    var _this3 = this;
	
	    InventoryStore.markPaidSale(this.state.selectedItem.id, function () {
	      _this3._isPaid() ? Notification.show(t('vendor_purchase_removed_paid') + " " + _this3.state.selectedItem.id, 'success') : Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + _this3.state.selectedItem.code + t('vendor_purchase_marked_paid'), 'success');
	      _this3.fetchItems();
	      _this3.state.selectedItem = null;
	    });
	  },
	  _onSelectBillingTo: function _onSelectBillingTo(evt, index, menuItem) {
	    var selectedBillingToAddress = get(menuItem, 'itemModel.id');
	    this.setState(function (prevState) {
	      var selectedBillingTo = find(prevState.customerAddress, function (customerAddress) {
	        return get(customerAddress, 'id') === selectedBillingToAddress;
	      });
	      return {
	        selectedBillingTo: selectedBillingTo ? selectedBillingTo : prevState.selectedBillingTo
	      };
	    });
	  },
	  _onSelectShippingTo: function _onSelectShippingTo(evt, index, menuItem) {
	    var selectedShippingToValue = get(menuItem, 'itemModel.id');
	    this.setState(function (prevState) {
	      var selectedShippingTo = find(prevState.customerAddress, function (customerAddress) {
	        return get(customerAddress, 'id') === selectedShippingToValue;
	      });
	      return {
	        selectedShippingTo: selectedShippingTo ? selectedShippingTo : prevState.selectedShippingTo
	      };
	    });
	  },
	  _onSelectCustomer: function _onSelectCustomer(customer) {
	    if (customer) {
	      var self = this;
	      InventoryStore.fetchCustomerAddresses(get(customer, 'id'), function (customerAddress) {
	        self.setState({
	          customerAddress: customerAddress,
	          selectedCustomer: customer
	        });
	      });
	    }
	  },
	  formatDate: function formatDate(date) {
	    if (typeof date === 'string') {
	      return DateUtils.toDate(date);
	    } else {
	      return DateUtils.toDateText(date);
	    }
	  },
	  _commentValidation: function _commentValidation(comment) {
	    if (ContentUtils.isEmptyText(comment)) {
	      return '';
	    }
	
	    if (get(comment, 'length') >= 500) {
	      return t('vendor_purchase_max_amount_characters');
	    }
	
	    return '';
	  },
	  _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	    var _this4 = this;
	
	    this.setState({
	      selectedItem: item,
	      isEditMode: !!item,
	      headerActiveFilters: headerActiveFilters
	    }, function () {
	      // stay the position of the scroll after row select when
	      // the offset Y es outside of initial viewport page.
	      _this4.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	
	      _this4._addQueryParamWithRowSelected(item, lastRowScrollPosition);
	
	      // select customer
	      var _state = _this4.state,
	          selectedItem = _state.selectedItem,
	          customers = _state.customers;
	
	      var customerId = get(selectedItem, 'customerId');
	      var customer = find(customers, function (customer) {
	        return get(customer, 'id') === customerId;
	      });
	      _this4._onSelectCustomer(customer);
	    });
	  },
	  _addQueryParamWithRowSelected: function _addQueryParamWithRowSelected(selectedItem, lastRowScrollPosition) {
	    var _this5 = this;
	
	    this.transitionTo(getCurrentUrl(), {}, {
	      selectedItemId: get(selectedItem, 'id')
	    });
	    // Is needed to force scroll position again
	    // in order to avoid jumping scroll behavior
	    delay(function () {
	      _this5.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	    }, 1);
	  },
	  render: function render() {
	    var _this6 = this;
	
	    if (!this.state.sales) {
	      return React.createElement(Loading, null);
	    } else {
	      var messages = {
	        changeSuccessMessage: t('sales_admin_change_success'),
	        changeFailureMessage: t('sales_admin_change_failure'),
	        deleteSuccessMessage: t('sales_admin_delete_success'),
	        addSuccessMessage: t('sales_admin_add_success'),
	        addFailureMessage: t('sales_admin_add_failure')
	      };
	      var salesPrioritiesMapping = AppConstants.getSalesStateMapping(t);
	      var contextHolder = this.getContextHolderInstance();
	      var _state2 = this.state,
	          selectedItem = _state2.selectedItem,
	          sales = _state2.sales,
	          isEditMode = _state2.isEditMode,
	          customers = _state2.customers,
	          isFetching = _state2.isFetching,
	          selectedCustomer = _state2.selectedCustomer,
	          selectedShippingTo = _state2.selectedShippingTo,
	          selectedBillingTo = _state2.selectedBillingTo,
	          customerAddress = _state2.customerAddress;
	
	      var hasSelectedItem = ContentUtils.isNotNullOrUndefined(selectedItem);
	      var currentStateSelected = hasSelectedItem ? find(sales, function (sale) {
	        return get(sale, 'id') === get(selectedItem, 'id');
	      }).state : get(selectedItem, 'state');
	
	      var isCurrentItemSelectedOpenPending = AppConstants.SALE_STATE_OPEN_PENDING === currentStateSelected;
	      var isCurrentItemDelivered = AppConstants.SALE_STATE_DELIVERED.includes(currentStateSelected);
	      var isCurrentItemReOpenPending = AppConstants.SALE_STATE_REOPEN_PENDING === currentStateSelected;
	
	      var safeCustomerAddress = get(selectedItem, 'allAddress') || customerAddress;
	      var selectedItemShippingTo = isEditMode ? selectedShippingTo ? selectedShippingTo : getAddress(safeCustomerAddress, selectedItem, 'shipToId') : selectedShippingTo;
	      var selectedItemBillingTo = isEditMode ? selectedBillingTo ? selectedBillingTo : getAddress(safeCustomerAddress, selectedItem, 'billToId') : selectedBillingTo;
	      var currentCustomer = isEditMode ? getExistingCustomer(customers, selectedItem) : selectedCustomer;
	
	      var currentSelection = selectedItem && selectedItem.displayPriority ? AppConstants.getSectionsMapping(t)[selectedItem.displayPriority] : '';
	
	      var currentSelectedValue = currentSelection ? _extends({}, selectedItem, { displayText: currentSelection }) : selectedItem;
	
	      var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	        operationsHolder: contextHolder,
	        items: customers,
	        readerAttribute: "name",
	        readerAttributeValue: "id",
	        writerAttribute: "customerId",
	        customErrorNonMatch: t('sales_customer_name_required'),
	        label: t('sales_customer_name'),
	        name: t('customer'),
	        value: currentCustomer,
	        isEditMode: isEditMode,
	        isImmutable: true,
	        onEnter: this.__onEnterPress,
	        onBlur: this._onSelectCustomer }), React.createElement(FormGroupDropdown, {
	        isRelaxedText: true,
	        noInternalValidation: true,
	        items: safeCustomerAddress,
	        operationsHolder: contextHolder,
	        readerAttribute: "address",
	        writerAttribute: "billToId",
	        customReaderWriterAttribute: "id",
	        name: t('sales_bill_to'),
	        value: selectedItemBillingTo,
	        isEditMode: isEditMode,
	        onEnter: this.__onEnterPress,
	        onChange: this._onSelectBillingTo,
	        isRequired: true }), React.createElement(FormGroupDropdown, {
	        isRelaxedText: true,
	        noInternalValidation: true,
	        items: safeCustomerAddress,
	        operationsHolder: contextHolder,
	        readerAttribute: "address",
	        writerAttribute: "shipToId",
	        customReaderWriterAttribute: "id",
	        name: t('sales_ship_to'),
	        value: selectedItemShippingTo,
	        isEditMode: isEditMode,
	        isRequired: true,
	        onEnter: this.__onEnterPress,
	        onChange: this._onSelectShippingTo }), {/* <FormGroupDropdown
	                                                 items={AppConstants.getSalesPriorities(t)}
	                                                 operationsHolder={contextHolder}
	                                                 readerAttribute="displayText"
	                                                 customReaderWriterAttribute="displayPriority"
	                                                 readerAttributeValue="displayPriority"
	                                                 writerAttribute="displayPriority"
	                                                 name={t('sales_priority')}
	                                                 value={currentSelectedValue}
	                                                 isEditMode={isEditMode}
	                                                 isRequired={false}
	                                                 onEnter={this.__onEnterPress}
	                                                /> */}, React.createElement(FormGroupTextfield, {
	        isRelaxedText: false,
	        additionalValidation: function additionalValidation(inputValue) {
	          return _this6._amountValidation(inputValue);
	        },
	        noInternalValidation: true,
	        operationsHolder: contextHolder,
	        // readerAttribute="amountPaid"
	        name: t('sales_column_amount_paid'),
	        value: get(selectedItem, "amountPaid", '').replace("$ ", "").toString(),
	        label: t('sales_column_amount_paid'),
	        isEditMode: isEditMode,
	        isRequired: false,
	        onChange: this._onChangeAmount }), React.createElement(FormGroupDatePicker, {
	        operationsHolder: contextHolder,
	        value: get(selectedItem, 'deliveredDate'),
	        floatingLabel: t('sales_shipping_date'),
	        writerAttribute: "deliveredDate",
	        formatDate: this.formatDate }), React.createElement(FormGroupTextfield, {
	        operationsHolder: contextHolder,
	        readerAttribute: "comment",
	        name: t('comment'),
	        value: selectedItem,
	        label: t('comment'),
	        additionalValidation: this._commentValidation,
	        isRelaxedText: false,
	        noInternalValidation: true,
	        isEditMode: isEditMode,
	        isRequired: false,
	        onChange: this._onChangeComment,
	        id: "comment" })];
	
	      var additionalButtons = [{
	        type: 'CHANGE',
	        permission: 'VIEW_ORDER',
	        el: React.createElement(FormGroupButton, {
	          label: isCurrentItemDelivered ? t('sales_view_order') : t('sales_edit_order'),
	
	          icon: isCurrentItemDelivered ? 'visibility' : 'mode_edit',
	
	          type: "icon",
	          onClick: this._goToSetItems })
	      }, {
	
	        type: 'CHANGE',
	        permission: 'EDIT_ORDER',
	        el: React.createElement(FormGroupButton, {
	          label: isCurrentItemDelivered ? t('vendor_change_amount') : t('vendor_change_amount'),
	
	          icon: 'mode_edit',
	
	          type: "icon",
	          onClick: this.saveNewAmount })
	      }, !isCurrentItemDelivered && /* {
	                                    type: 'CHANGE',
	                                    permission: 'EDIT_ORDER',
	                                    el: (
	                                    <FormGroupButton
	                                    label={
	                                    isCurrentItemDelivered
	                                    ? t('vendor_change_amount')
	                                    : t('vendor_change_amount')
	                                    }
	                                    icon={
	                                    'mode_edit'
	                                    }
	                                    type="icon"
	                                    onClick={this.saveNewAmount}
	                                    />
	                                    )
	                                    }, */
	      {
	        type: 'NEW',
	        permission: 'PRINT_REPORT',
	        el: React.createElement(FormGroupButton, {
	          label: t('sales_print_report'),
	          icon: "file_download",
	          type: "icon",
	          onClick: this._printReport })
	      }, {
	        type: 'NEW',
	        permission: 'CLEAR_FILTER',
	        el: React.createElement(FormGroupButton, {
	          label: t('button_label_clear_filters'),
	          icon: "clear",
	          type: "icon",
	          onClick: this.clearFilters })
	      }];
	
	      if (isCurrentItemSelectedOpenPending || isCurrentItemReOpenPending) {
	        additionalButtons.push({
	          permission: 'SEND_ORDER',
	          type: 'CHANGE',
	          el: React.createElement(FormGroupButton, {
	            label: t('sales_send_order'),
	            icon: "send",
	            type: "icon",
	            onClick: this._sendOrderToCustomer })
	        });
	      }
	
	      var totalPurchases = get(sales, '0.count') || 0;
	
	      var state = [];
	      var displayPriority = [];
	
	      var allSalesStates = AppConstants.getSalesStateMapping(t);
	      if (allSalesStates['OPEN'] !== undefined) {
	        Object.keys(allSalesStates).forEach(function (e, i) {
	          if (i <= 3) {
	            displayPriority.push({ id: e, state: allSalesStates[e] });
	          } else {
	            state.push({ id: e, state: allSalesStates[e] });
	          }
	        });
	      }
	
	      additionalButtons.push({
	        type: 'CHANGE',
	        permission: 'SAVE_COMMENT',
	        el: React.createElement(FormGroupButton, {
	          label: t('button_label_save_comment'),
	          icon: "save",
	          type: "icon",
	          onClick: this._saveComment })
	      });
	
	      additionalButtons.push({
	        type: 'CHANGE',
	        permission: 'MARK_PAID',
	        el: isCurrentItemDelivered && React.createElement(FormGroupButton, {
	          label: this._isPaid() ? t('button_revert_paid') : t('button_mark_paid'),
	          icon: "paid",
	          type: "icon",
	          onClick: this._onPaid.bind() })
	      });
	
	      return React.createElement(AdminScaffolding, {
	        messages: messages,
	        moduleName: "ADMIN_SALE",
	        additionalButtons: additionalButtons,
	        title: isCurrentItemDelivered ? '' + t('sales_item_close_order') + get(selectedItem, 'code') : isEditMode ? '' + t('sales_item_editing_order') + get(selectedItem, 'code') : t('sales_item_no_orders'),
	
	        contextHolder: contextHolder,
	        value: selectedItem,
	        onAddText: t('sales_create'),
	        fetchItems: this.fetchItems,
	        headerFields: formFieldsEl,
	        onAdd: this.onAddSale,
	        onChange: this.onChangeSale,
	        onCancel: this._onCancel,
	        onDelete: this.onDeleteSale,
	        addEnterKeyDown: this.__addEnterKeyDown,
	        breadcrumb: this.getBreadcrumbLinks(),
	        isDark: true
	      }, React.createElement(AdminScaffoldingTablePaged, {
	        onRowSelection: this._onRowSelection,
	        value: selectedItem,
	        filteredColumns: ['code', 'customerName', 'state', 'displayDateOpen', 'displayDeliveredDate',
	        /* 'displayPriority', */
	        'amountPaid', 'totalPriceWithUnit'],
	        displayAttributes: ['code', 'customerName', {
	          name: 'state',
	          getHTML: this._showIndicator
	        }, 'displayDateOpen', 'displayDeliveredDate',
	        /* 'displayPriority', */
	        'amountPaid', 'totalPriceWithUnit'],
	        columnNames: [t('sales_column_number'), t('sales_column_customer'), t('sales_column_status'), t('sales_column_created'), t('sales_column_shipping_date'),
	        /* t('sales_column_priority'), */
	        t('sales_column_amount_paid'), t('sales_column_total_price')],
	
	        isLoading: isFetching,
	        maxPage: ContentUtils.getAmountPageNeeded(totalPurchases, AppConstants.MAX_ITEMS_BY_PAGES_ADMINS),
	        onClickPage: this._onClickPage,
	        currentPage: NavigationUtils.getPathParam('page'),
	        columnsFilterValue: this.state.filter,
	        onCancel: this._onCancel,
	        onTypingFilter: this._onTypingFilter,
	        sortByColumn: ['created'],
	        items: { state: state, displayPriority: displayPriority }
	      }, sales.map(function (sale) {
	        sale.displayPriority = salesPrioritiesMapping[sale.priority];
	        sale.displaySate = salesPrioritiesMapping[sale.status];
	        return sale;
	      })));
	    }
	  }
	});
	
	function getExistingCustomer(customers, selectedItem) {
	  return find(customers, function (customer) {
	    return get(customer, 'id') === get(selectedItem, 'customerId');
	  });
	}
	
	function getCurrentUrl() {
	  return pageUrl + NavigationUtils.getPathParam('page');
	}
	
	function getAddress(customerAddress, selectedItem, fieldId) {
	  return find(customerAddress, function (address) {
	    return get(address, 'id') === get(selectedItem, fieldId);
	  });
	}
	
	module.exports = SalesAdmin;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Loading = __webpack_require__(33),
	    Constants = __webpack_require__(2),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    Notification = __webpack_require__(21),
	    InventoryStore = __webpack_require__(20),
	    NavigationUtils = __webpack_require__(35),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    filter = _require2.filter,
	    find = _require2.find,
	    some = _require2.some,
	    _require3 = __webpack_require__(48),
	    concat = _require3.concat,
	    get = __webpack_require__(5).get,
	    _require4 = __webpack_require__(19),
	    Navigation = _require4.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var SaleItemAdmin = React.createClass({ displayName: "SaleItemAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            saleId: NavigationUtils.getPathParam('sales'),
	            name: NavigationUtils.getQueryParam('name'),
	            customerId: NavigationUtils.getQueryParam('customerId'),
	            code: NavigationUtils.getQueryParam('code'),
	            isClosedOrder: NavigationUtils.getQueryParam('isClosed') !== 'false',
	            comment: NavigationUtils.getQueryParam('comment'),
	            selectedItem: null,
	            isEditMode: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchSaleItems();
	        ga.pageview('/sales-item-admin');
	    },
	    backToSales: function backToSales() {
	        this.transitionTo('/sales/page/:page', { page: 0 });
	    },
	    fetchSaleItems: function fetchSaleItems(callBack) {
	        var _state = this.state,
	            saleId = _state.saleId,
	            customerId = _state.customerId;
	
	        var self = this;
	        InventoryStore.fetchFinishItems(function (items) {
	            InventoryStore.fetchNonInventoryItems(function (nonInventoryItems) {
	                InventoryStore.fetchCustomerItems(customerId, function (customerItems) {
	                    InventoryStore.fetchSaleItems(saleId, function (saleItems) {
	                        self.setState({
	                            saleItems: self._hydrateSaleItems(ContentUtils.filterEnable(saleItems)),
	                            items: concat(adaptNonInventoryItemToVendorItem(nonInventoryItems), ContentUtils.filterEnable(items)),
	                            customerItems: customerItems
	                        }, function () {
	                            if (callBack) {
	                                callBack();
	                            }
	                        });
	                    });
	                });
	            });
	        });
	    },
	    onDeleteSaleItem: function onDeleteSaleItem(saleItemId, onSuccess, onFailure) {
	        var saleId = get(this.state, 'saleId');
	        CustomDialog.showWarningConfirmation(t('warning'), t('sales_items_delete_confirmation'), function () {
	            InventoryStore.deleteSaleItem(saleId, saleItemId, onSuccess, onFailure);
	        });
	    },
	    changeSaleItem: function changeSaleItem(saleItem, onSuccess, onFailure) {
	        saleItem.amount = NumberUtils.standardiseDecimalFormatNumber(saleItem.amount);
	        InventoryStore.changeSaleItem(saleItem, onSuccess, onFailure);
	        this.setState({
	            preSelectedItem: null
	        });
	    },
	    getCustomPrice: function getCustomPrice() {
	        var _state2 = this.state,
	            selectedItem = _state2.selectedItem,
	            preSelectedItem = _state2.preSelectedItem,
	            items = _state2.items,
	            customerItems = _state2.customerItems,
	            isEditMode = _state2.isEditMode;
	
	        var isNewMode = isEditMode === false;
	
	        if (isNewMode) {
	            var haveSelectedItemDropdown = ContentUtils.isNotNullOrUndefined(preSelectedItem);
	            if (haveSelectedItemDropdown) {
	                // enter here means is a new item, and the item was already
	                // defined so we search the customer sale price of the item
	                var customerItemTarget = find(customerItems, function (customerItem) {
	                    return get(customerItem, 'item.id') === get(preSelectedItem, 'id');
	                });
	                var haveCustomCustomerItem = ContentUtils.isNotNullOrUndefined(customerItemTarget);
	
	                if (haveCustomCustomerItem) {
	                    return get(customerItemTarget, 'salePrice') || '0';
	                }
	
	                // enter here means the customer items doesn't exist,
	                // so we continue search to base price of item.
	                var itemTarget = find(items, function (item) {
	                    return get(item, 'id') === get(preSelectedItem, 'id');
	                });
	                return get(itemTarget, 'salePrice') || '0';
	            } else {
	                return '0';
	            }
	        } else {
	            // in change mode, just show the price already saved
	            return get(selectedItem, 'customPriceUnit') || '0';
	        }
	    },
	    addSaleItem: function addSaleItem(saleItem, onSuccess, onFailure) {
	        saleItem.saleId = NavigationUtils.getPathParam('sales');
	        saleItem.amount = NumberUtils.standardiseDecimalFormatNumber(saleItem.amount || '0');
	        InventoryStore.addSaleItem(saleItem, onSuccess, onFailure);
	        this.setState({
	            preSelectedItem: null
	        });
	    },
	    getBreadcrumbLinks: function getBreadcrumbLinks() {
	        return [{ link: '/sales/page/0', displayName: t('sales_title') }, { displayName: t('order') + ' #' + NavigationUtils.getQueryParam('code') }];
	    },
	    _confirmOrderDelivered: function _confirmOrderDelivered() {
	        var _this = this;
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('sales_warning_after_this_confirmation_will_be_closed'), function () {
	            var saleId = get(_this.state, 'saleId');
	            InventoryStore.confirmSaleOrderDelivered(saleId, _this._onSuccessWhenTryDeliver, _this._onFailureWhenTryDeliver);
	        });
	    },
	    _onSuccessWhenTryDeliver: function _onSuccessWhenTryDeliver() {
	        this.transitionTo('/sales/:saleId/items', {
	            saleId: get(this.state, 'saleId')
	        }, {
	            customerId: NavigationUtils.getQueryParam('customerId'),
	            name: NavigationUtils.getQueryParam('name'),
	            code: NavigationUtils.getQueryParam('code'),
	            isClosed: true
	        });
	
	        Notification.show(t('sales_order_was_sent'), 'success');
	
	        setTimeout(function () {
	            window.location.reload(true);
	        }, 1500);
	    },
	    _onFailureWhenTryDeliver: function _onFailureWhenTryDeliver(messageInfo) {
	        if (messageInfo) {
	            var haveNotEnoughItemsToSell = messageInfo.includes('0009');
	            if (haveNotEnoughItemsToSell) {
	                CustomDialog.showInfo(t('warning'), ContentUtils.formatMessageError(messageInfo));
	            } else {
	                var messageError = ContentUtils.formatMessageError(messageInfo);
	                Notification.show(messageError);
	            }
	        }
	    },
	    _amountValidation: function _amountValidation(inputValue) {
	        if (ContentUtils.isEmptyText(inputValue)) {
	            return '';
	        }
	
	        var result = NumberUtils.isNumber(inputValue) ? '' : t('sales_items_amount_must_a_number');
	        var isNumber = result === '';
	
	        if (isNumber) {
	            return NumberUtils.isGreater(inputValue, -1) ? '' : t('sales_items_could_not_negative');
	        }
	
	        return result;
	    },
	    _amountValidationNonZero: function _amountValidationNonZero(inputValue) {
	        if (ContentUtils.isEmptyText(inputValue)) {
	            return '';
	        }
	
	        if (NumberUtils.isEqual(inputValue, '0')) {
	            return t('product_addition_inline_error_amount_must_be_greater_than_zero');
	        }
	
	        var result = NumberUtils.isNumber(inputValue) ? '' : t('sales_items_amount_must_a_number');
	        var isNumber = result === '';
	
	        if (isNumber) {
	            return NumberUtils.isGreater(inputValue, -1) ? '' : t('sales_items_could_not_negative');
	        }
	
	        return result;
	    },
	    _commentValidation: function _commentValidation(comment) {
	        if (ContentUtils.isEmptyText(comment)) {
	            return '';
	        }
	
	        if (get(comment, 'length') >= 500) {
	            return t('vendor_purchase_max_amount_characters');
	        }
	
	        return '';
	    },
	    _hydrateSaleItems: function _hydrateSaleItems(saleItems) {
	        return map(ContentUtils.filterEnable(saleItems), function (saleItems) {
	            saleItems.amountWithUnit = saleItems.amount + ' (' + get(saleItems, 'item.unit', t('item_admin_column_unit')) + ')';
	            saleItems.customPriceUnitWithSymbol = NumberUtils.getCurrentCurrency().symbol + ' ' + (NumberUtils.formatDecimal(saleItems.customPriceUnit, get(SessionStore.getCurrentCurrencyDigits(), 'value')) || NumberUtils.formatDecimal('0', get(SessionStore.getCurrentCurrencyDigits(), 'value')));
	            saleItems.customTotalPriceUnitWithSymbol = NumberUtils.getCurrentCurrency().symbol + ' ' + showTotalPrice(saleItems);
	            return saleItems;
	        });
	    },
	    _saveComment: function _saveComment() {
	        InventoryStore.saveCommentOnlySaleOrder(this.state.saleId, this.state.comment !== "" ? this.state.comment : "null");
	        Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.saleId + " " + t('updated'), 'success');
	    },
	    _onChangeComment: function _onChangeComment(sale) {
	        this.state.comment = sale.target.value !== "" ? sale.target.value : "null";
	    },
	    onChangeSelectedItem: function onChangeSelectedItem(preSelectedVendorItem) {
	        if (preSelectedVendorItem) {
	            this.setState(function () {
	                return {
	                    preSelectedItem: preSelectedVendorItem
	                };
	            });
	        }
	    },
	    _onBlurSelectedItem: function _onBlurSelectedItem(preSelectedVendorItem) {
	        if (preSelectedVendorItem) {
	            this.setState(function (prevState) {
	                if (prevState.selectedItem) {
	                    return {
	                        preSelectedItem: _extends(prevState.selectedItem, preSelectedVendorItem)
	                    };
	                } else {
	                    return {
	                        preSelectedItem: preSelectedVendorItem
	                    };
	                }
	            });
	        }
	    },
	    _onSuccessWhenSendEmailConfirmation: function _onSuccessWhenSendEmailConfirmation() {
	        Notification.show(t('sales_order_was_sent'), 'success');
	        this.fetchSaleItems();
	    },
	    _onFailureWhenSendEmailToCustomer: function _onFailureWhenSendEmailToCustomer(messageInfo) {
	        if (messageInfo) {
	            var haveNotEmail = messageInfo.includes(Constants.ERROR_CODE_SALE_WITHOUT_CONTACT_EMAIL);
	            if (haveNotEmail) {
	                var self = this;
	                CustomDialog.showWarningConfirmation(t('warning'), t('sales_items_failure_email_customer'), function () {
	                    self.transitionTo('/customers/:customerId/contacts', {
	                        customerId: NavigationUtils.getQueryParam('customerId')
	                    }, {
	                        name: get(self.state, 'selectedItem.customerName')
	                    });
	                });
	            } else {
	                var messageError = ContentUtils.formatMessageError(messageInfo);
	                Notification.show(messageError);
	            }
	        }
	    },
	    _sendOrderToCustomer: function _sendOrderToCustomer() {
	        var self = this;
	        CustomDialog.showWarningConfirmation(t('warning'), t('sales_customer_will_be_notified'), function () {
	            var saleId = NavigationUtils.getPathParam('sales');
	            InventoryStore.sendOrderToCustomer(saleId, self._onSuccessWhenSendEmailConfirmation, self._onFailureWhenSendEmailToCustomer);
	        });
	    },
	    _printReport: function _printReport() {
	        InventoryStore.downloadReportPDF(this.state.filter, 'sales/' + this.state.saleId);
	    },
	    render: function render() {
	        var _this2 = this;
	
	        var saleItems = this.state.saleItems;
	
	        if (!saleItems) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('sales_items_change_success'),
	                changeFailureMessage: t('sales_items_change_failure'),
	                deleteSuccessMessage: t('sales_items_delete_succes'),
	                addSuccessMessage: t('sales_items_add_success'),
	                addFailureMessage: t('sales_items_add_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state3 = this.state,
	                selectedItem = _state3.selectedItem,
	                preSelectedItem = _state3.preSelectedItem,
	                _saleItems = _state3.saleItems,
	                isEditMode = _state3.isEditMode,
	                items = _state3.items,
	                isClosedOrder = _state3.isClosedOrder,
	                code = _state3.code;
	
	
	            var hasAtLeastOneSaleItem = get(_saleItems, 'length') > 0;
	            var hasSomeNonNotified = some(_saleItems, function (saleItem) {
	                return get(saleItem, 'state') === Constants.SALE_ITEM_NON_NOTIFIED;
	            });
	            var unit = void 0;
	
	            if (selectedItem) {
	                unit = getUnitFromVendorItem(selectedItem);
	            } else {
	                unit = getUnitFromVendorItem(preSelectedItem);
	            }
	
	            var unitWithParenthesis = unit ? '(' + unit + ')' : t('unit');
	            var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	                operationsHolder: contextHolder,
	                items: items,
	                readerAttribute: "description",
	                readerAttributeValue: "id",
	                writerAttribute: "itemId",
	                itemsDisabled: filterItemsAlreadyInUse(items, _saleItems),
	                customErrorNonMatch: t('sales_items_error_non_match'),
	                name: t('item'),
	                isEditMode: isEditMode,
	                isImmutable: true,
	                label: t('item'),
	                value: get(selectedItem, 'item') || preSelectedItem,
	                onChange: this._onBlurSelectedItem,
	                onBlur: this._onBlurSelectedItem }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "amount",
	                additionalValidation: this._amountValidationNonZero,
	                name: t('label_amount'),
	                value: selectedItem,
	                label: t('item') + ' ' + unitWithParenthesis,
	                isRelaxedText: true,
	                isEditMode: isEditMode,
	                isDecimalFormat: false,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "customPriceUnit",
	                additionalValidation: this._amountValidation,
	                name: t('sales_items_custom_price') + ' ' + unitWithParenthesis,
	                value: { customPriceUnit: this.getCustomPrice() },
	                label: t('sales_items_custom_price') + ' ' + unitWithParenthesis,
	                isRelaxedText: true,
	                isRequired: false,
	                isDecimalFormat: true,
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "comment",
	                name: t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + t('comment'),
	                value: this.state,
	                label: t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + t('comment'),
	                additionalValidation: function additionalValidation(inputValue) {
	                    return _this2._commentValidation(inputValue);
	                },
	                isRelaxedText: false,
	                noInternalValidation: true,
	                isEditMode: isEditMode,
	                isRequired: false,
	                onEnter: this._onEnterPress,
	                onChange: this._onChangeComment,
	                id: "comment" })];
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToSales })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this.backToSales })
	            }, {
	                type: 'NEW',
	                permission: 'PRINT_REPORT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('sales_print'),
	                    icon: "file_download",
	                    type: "icon",
	                    onClick: this._printReport })
	            }];
	
	            if (hasAtLeastOneSaleItem && !isClosedOrder) {
	                additionalButtons.push({
	                    type: 'NEW',
	                    permission: 'SEND_ORDER',
	                    el: React.createElement(FormGroupButton, {
	                        label: hasSomeNonNotified ? t('sales_send_order') : t('sales_items_re_send_order'),
	                        icon: "send",
	                        type: "icon",
	                        onClick: this._sendOrderToCustomer })
	                });
	            }
	
	            if (hasAtLeastOneSaleItem && // has some sale items
	            !hasSomeNonNotified && // all items has been sent
	            !isClosedOrder // is open order
	            ) {
	                    additionalButtons.push({
	                        type: 'NEW',
	                        permission: 'SEND_ORDER',
	                        el: React.createElement(FormGroupButton, {
	                            label: t('sales_confirm_deliver'),
	                            icon: "local_shipping",
	                            type: "icon",
	                            onClick: this._confirmOrderDelivered })
	                    });
	                }
	
	            if (hasAtLeastOneSaleItem && // has some sale items
	            !isClosedOrder // is open order
	            ) {
	                    additionalButtons.push({
	                        type: 'CHANGE',
	                        permission: 'CHANGE',
	                        el: React.createElement(FormGroupButton, {
	                            label: t('button_label_save'),
	                            icon: "save",
	                            type: "icon",
	                            onClick: this.__onEnterPress })
	                    });
	                }
	
	            additionalButtons.push({
	                type: 'NEW',
	                permission: 'SAVE_COMMENT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('button_label_save_comment'),
	                    icon: "save",
	                    type: "icon",
	                    onClick: this._saveComment })
	            });
	
	            return React.createElement(AdminScaffolding, {
	                messages: messages,
	                moduleName: "ADMIN_SALE",
	                onAddText: t('vendor_admin_label_associate'),
	                onDeleteText: t('vendor_admin_label_disassociate'),
	                onChangeText: t('button_label_save'),
	                additionalButtons: additionalButtons,
	                title: isClosedOrder ? t('sales_items_sale_order') + ' #' + code + ' ' + t('closed') : isEditMode ? t('sales_items_editing_item') : t('sales_items_editing_sales_order') + ' #' + NavigationUtils.getQueryParam('code'),
	
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchSaleItems,
	                headerFields: formFieldsEl,
	                onAdd: isClosedOrder ? undefined : this.addSaleItem,
	
	                onChange: isClosedOrder ? undefined : this.changeSaleItem,
	
	                onCancel: this.__onCancel,
	                onDelete: isClosedOrder ? undefined : this.onDeleteSaleItem,
	
	                addEnterKeyDown: this.__addEnterKeyDown,
	                breadcrumb: this.getBreadcrumbLinks(),
	                isDark: true
	            }, React.createElement(AdminScaffoldingTable, {
	                sortByColumn: "item.name",
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['item.description', 'amountWithUnit', 'customPriceUnitWithSymbol', 'customTotalPriceUnitWithSymbol'],
	                displayAttributes: ['item.description', 'amountWithUnit', 'customPriceUnitWithSymbol', 'customTotalPriceUnitWithSymbol'],
	                columnNames: [t('sales_items_column_name'), t('sales_items_column_amount'), t('sales_items_column_price'), t('sales_column_total_price')]
	            }, _saleItems));
	        }
	    }
	});
	
	function filterItemsAlreadyInUse(items, selectedItems) {
	    var itemIdsAlreadyInUse = map(selectedItems, function (selectedItem) {
	        return get(selectedItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	function getUnitFromVendorItem(vendorItem) {
	    return get(vendorItem, 'item.unit') || get(vendorItem, 'unit');
	}
	
	function showTotalPrice(saleItems) {
	    return NumberUtils.formatDecimal(NumberUtils.multiply(saleItems.customPriceUnit, saleItems.amount || 1) || NumberUtils.formatDecimal('0'), get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	}
	
	function adaptNonInventoryItemToVendorItem() {
	    var nonInventoryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return map(nonInventoryItems, function (nonInventoryItem) {
	        nonInventoryItem.item = {
	            id: nonInventoryItem.id,
	            description: nonInventoryItem.description
	        };
	        nonInventoryItem.minimumOrder = 1;
	        return nonInventoryItem;
	    });
	}
	
	module.exports = SaleItemAdmin;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(693);
	
	var React = __webpack_require__(14),
	    mui = __webpack_require__(12),
	    TextField = mui.TextField,
	    RaisedButton = mui.RaisedButton,
	    security = __webpack_require__(13),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    DashboardStore = __webpack_require__(82),
	    ContentUtils = __webpack_require__(7),
	    NavigationUtils = __webpack_require__(35),
	    NumberUtils = __webpack_require__(23),
	    auth = security.auth,
	    _require2 = __webpack_require__(79),
	    toLower = _require2.toLower,
	    SessionActionCreators = __webpack_require__(228),
	    ga = __webpack_require__(18),
	    _require$Analytics = __webpack_require__(2).Analytics,
	    categories = _require$Analytics.categories,
	    actions = _require$Analytics.actions,
	    Router = __webpack_require__(19),
	    Link = Router.Link;
	
	
	var Login = React.createClass({ displayName: "Login",
	
	    mixins: [Router.Navigation],
	
	    contextTypes: {
	        router: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        this.MESSAGE_ERRORS = {
	            applicant_blocked: 'sign_in_user_blocked'
	        };
	        return {
	            error: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        DashboardStore.setIsFetchingDashboardContent(false);
	        var messageErrorCode = NavigationUtils.getQueryParam('message');
	        if (messageErrorCode) {
	            this.setState({ error: messageErrorCode });
	        }
	    },
	    handleSubmit: function handleSubmit(texts, event) {
	        DashboardStore.setIsFetchingDashboardContent(false);
	        event.preventDefault();
	        var username = toLower(this.refs.username.getValue());
	        var pass = this.refs.pass.getValue();
	        auth.login(username, pass, texts, this._onSuccess, this._onFailure);
	    },
	    _onSuccess: function _onSuccess(userName, token, applicantId, texts) {
	        DashboardStore.setIsFetchingDashboardContent(false);
	        this.transitionTo('/dashboard');
	        SessionActionCreators.loggedIn(userName, token, applicantId, texts);
	        SessionActionCreators.permissionRequestUpdate(userName, token, applicantId);
	        SessionStore.fetchUserInformationAndSaveIfNeeded(function () {
	            NumberUtils.initializeFormat();
	        });
	        ga.event({
	            category: categories.APPLICATION,
	            action: actions.SIGN_IN,
	            label: t('signin_applicant') + SessionStore.getCurrentApplicant() + t('history_modal_description_user') + ContentUtils.getSession('userNameSession')
	        });
	    },
	    _onFailure: function _onFailure() {
	        this.setState({
	            error: t('sign_in_error_inline')
	        });
	    },
	    render: function render() {
	
	        var errorText = t(this.MESSAGE_ERRORS[this.state.error || '']);
	        var isApplicantBlocked = this.state.error === 'applicant_blocked';
	
	        var loginContentClassName = 'box-content login-content';
	
	        if (!SessionStore.isFullPaidVersion()) {
	            loginContentClassName += ' is-free-version';
	        }
	
	        var texts = {
	            confirmationAccept: t('confirmation_accept_brewplanner_updated'),
	            labelPrivacy: t('label_privacy_policy'),
	            labelAnd: t('label_and'),
	            labelUserAgreement: t('label_user_agreement')
	        };
	
	        var handlerSubmit = this.handleSubmit.bind(this, texts);
	
	        return React.createElement("div", { id: "page-login", className: "row" }, React.createElement("div", { className: "text-center bp-login-view" }, React.createElement("form", { onSubmit: handlerSubmit, className: "box" }, React.createElement("div", { className: loginContentClassName }, React.createElement("img", { idth: "150", height: "60", src: "/assets/images/logo-small.png" }), React.createElement("div", { className: "text-center" }, isApplicantBlocked && React.createElement("div", { style: { border: '1px solid red', borderRadius: 20, padding: 20, backgroundColor: 'red', color: 'white' } }, React.createElement("div", null, "Your trial version or subscription has ended..."), React.createElement("br", null), React.createElement("a", { target: "_blank", href: "https://www.brewplanner.com/payment" }, React.createElement(RaisedButton, { className: "BPButton", secondary: true, label: "Upgrade" }))), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            className: "full-width id-username",
	            ref: "username",
	            hintText: t('sign_in_placeholder_username'),
	            defaultValue: "",
	            floatingLabelText: t('sign_in_label_username'),
	            onEnterKeyDown: handlerSubmit,
	            errorText: this.state.error ? 'Login failed' : '' })), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            type: "password",
	            className: "full-width id-password",
	            ref: "pass",
	            hintText: t('sign_in_placeholder_password'),
	            defaultValue: "",
	            floatingLabelText: t('sign_in_label_password'),
	            onEnterKeyDown: handlerSubmit,
	            errorText: errorText })), React.createElement(RaisedButton, { className: "BPButton", label: "Sign in", secondary: true, onClick: handlerSubmit }), React.createElement("div", { className: "text-center" }, React.createElement("br", null), React.createElement(Link, { to: "signUp", className: "txt-default" }, t('sign_in_label_need_account')), " | ", React.createElement("span", { className: "text-right" }, React.createElement(Link, { to: "passwordRecovery", className: "txt-default" }, t('sign_in_label_forgot_password')))))))));
	    }
	});
	
	module.exports = Login;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1374);
	
	var React = __webpack_require__(14),
	    Router = __webpack_require__(19),
	    _ = __webpack_require__(40),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    Link = Router.Link,
	    Uploader = __webpack_require__(231),
	    ComponentUtils = __webpack_require__(77),
	    _require2 = __webpack_require__(79),
	    toLower = _require2.toLower,
	    trim = _require2.trim,
	    signUpService = __webpack_require__(744).signUpService,
	    ERROR_CODE_APPLICANT_ALREADY_EXIST = __webpack_require__(2).ERROR_CODE_APPLICANT_ALREADY_EXIST,
	    REGEX_NAME_SIGNUP = __webpack_require__(2).REGEX_NAME_SIGNUP,
	    ERROR_CODE_EMAIL_ALREADY_EXIST = __webpack_require__(2).ERROR_CODE_EMAIL_ALREADY_EXIST,
	    ERROR_CODE_USERNAME_ALREADY_EXIST = __webpack_require__(2).ERROR_CODE_USERNAME_ALREADY_EXIST,
	    ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST = __webpack_require__(2).ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST,
	    REGEX_EMAIL = __webpack_require__(2).REGEX_EMAIL,
	    WHERE_KNOW_US = __webpack_require__(2).WHERE_KNOW_US,
	    mui = __webpack_require__(12),
	    PositionUtil = __webpack_require__(59),
	    ContentUtils = __webpack_require__(7),
	    TextField = mui.TextField,
	    RaisedButton = mui.RaisedButton,
	    DropDownMenu = mui.DropDownMenu,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation;
	
	
	var Signup = React.createClass({ displayName: "Signup",
	
	    mixins: [Navigation],
	
	    contextTypes: {
	        router: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return this._getEmptyModelForm('');
	    },
	    handleSubmit: function handleSubmit(event) {
	        event.preventDefault();
	
	        if (this.isValidForm(true)) {
	            var signUp = {
	                applicant: trim(this.refs.applicant.getValue()),
	                username: trim(this.refs.username.getValue()),
	                password: this.refs.password.getValue(),
	                email: toLower(this.refs.email.getValue()),
	                // guestUsername: trim(this.refs.guestUsername.getValue()),
	                // guestPassword: this.refs.guestPassword.getValue(),
	                // applicantLogoSrc: this.refs.applicantLogo.getValue(),
	                applicantConfigurationDetail: SessionStore.getInferredUserInformation()
	                // whereKnowUsDetail: this.refs.whereKnowUsDetail.getValue(),
	                // whereKnowUs: this._getCurrentWhereKnowUs().source
	            };
	            signUpService.signUp(signUp, this._onSuccess, this._onFailure);
	        }
	    },
	    _getCurrentWhereKnowUs: function _getCurrentWhereKnowUs() {
	        var _this = this;
	
	        return WHERE_KNOW_US.find(function (type) {
	            return type.name === _this.refs.whereKnowUs.getInputNode().value;
	        }) || { source: 'NOT_ANSWERED' };
	    },
	
	
	    _onSuccess: function _onSuccess() {
	        var _this2 = this;
	
	        this.setState({
	            successfulSignup: true
	        });
	        setTimeout(function () {
	            _this2.transitionTo('/dashboard', {}, {
	                email: _this2.refs.email.getValue()
	            });
	        }, 1000);
	    },
	
	    _onFailure: function _onFailure(message) {
	        this.setState({
	            error: true,
	            errorApplicantName: message.message.indexOf(ERROR_CODE_APPLICANT_ALREADY_EXIST) > -1 ? t('sign_up_error_applicant_already_exist') : '',
	            errorEmail: message.message.indexOf(ERROR_CODE_EMAIL_ALREADY_EXIST) > -1 ? t('sign_up_error_email_already_exist') : '',
	            errorUsername: message.message.indexOf(ERROR_CODE_USERNAME_ALREADY_EXIST) > -1 ? t('sign_up_error_username_already_exist') : '',
	            errorUsernameGuest: message.message.indexOf(ERROR_CODE_USERNAME_GUEST_ALREADY_EXIST) > -1 ? t('sign_up_error_username_guest_already_exist') : ''
	        });
	    },
	    isValidForm: function isValidForm(onSubmit) {
	        return true;
	    },
	
	
	    // isValidForm(onSubmit) {
	    //     let messagesError = this._getEmptyModelForm(null),
	    //         isValid = true,
	    //         isFocusAssigned = false;
	
	    //     const {
	    //         isPristineApplicantName,
	    //         isPristineEmail,
	    //         isPristineUsername,
	    //         isPristinePasswordAdmin,
	    //         isPristineUsernameGuest,
	    //         isPristinePasswordGuest
	    //     } = this.state;
	
	    //     isValid = isPristineApplicantName && isPristineEmail && isPristineUsername && isPristinePasswordAdmin && isPristineUsernameGuest && isPristinePasswordGuest;
	
	    //     if (!isPristineApplicantName || onSubmit) {
	    //         if (ContentUtils.isEmptyField(this.refs.applicant)) {
	    //             messagesError.errorApplicantName = 'The Brewery is required';
	    //             isValid = false;
	    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.applicant.getValue())) {
	    //             messagesError.errorApplicantName = 'Special characters not allowed';
	    //             isValid = false;
	    //         } else if (this.refs.applicant.getValue().length < 3) {
	    //             messagesError.errorApplicantName = 'The Brewery name is too small';
	    //             isValid = false;
	    //         } else if (this.refs.applicant.getValue().length > 90) {
	    //             messagesError.errorApplicantName = 'The Brewery name is too long';
	    //             isValid = false;
	    //         }
	
	    //         if (!isValid) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.applicant.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	
	    //     if (!isPristineUsername || onSubmit) {
	    //         if (ContentUtils.isEmptyField(this.refs.username)) {
	    //             messagesError.errorUsername = 'The username is required';
	    //             isValid = false;
	    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.username.getValue())) {
	    //             messagesError.errorUsername = 'Special characters not allowed';
	    //             isValid = false;
	    //         } else if (this.refs.username.getValue().length > 90) {
	    //             messagesError.errorUsername = 'The username is too long';
	    //             isValid = false;
	    //         } else if (this.refs.username.getValue().length < 2) {
	    //             messagesError.errorUsername = 'The username is too small';
	    //             isValid = false;
	    //         }
	
	    //         if (!isValid && !isFocusAssigned) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.username.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     if (onSubmit) {
	    //         if (!this.refs.whereKnowUsDetail.getValue()) {
	    //             // enter here means the dropdown dont was defined
	    //             messagesError.errorWhereKnowUsDetail = '';
	    //         } else if (this.refs.whereKnowUsDetail.getValue().length > 200) {
	    //             messagesError.errorWhereKnowUsDetail = 'The comment is too long';
	    //             isValid = false;
	    //         } else {
	    //             messagesError.errorWhereKnowUsDetail = '';
	    //         }
	
	    //         if (!isValid && !isFocusAssigned) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.whereKnowUsDetail.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     // Guest username validation
	    //     if (!isPristineUsernameGuest || onSubmit) {
	    //         if (ContentUtils.isEmptyField(this.refs.guestUsername)) {
	    //             messagesError.errorUsernameGuest = 'The guest name is required';
	    //         } else if (!REGEX_NAME_DEFAULT.test(this.refs.guestUsername.getValue())) {
	    //             messagesError.errorUsernameGuest = 'Special characters not allowed';
	    //             isValid = false;
	    //         } else if (this.refs.guestUsername.getValue().length > 90) {
	    //             messagesError.errorUsernameGuest = 'The guest name is too long';
	    //             isValid = false;
	    //         } else if (this.refs.guestUsername.getValue().length < 2) {
	    //             messagesError.errorUsernameGuest = 'The guest name is too small';
	    //             isValid = false;
	    //         }
	
	    //         if (this.refs.guestUsername.getValue() === this.refs.username.getValue()) {
	    //             messagesError.errorUsernameGuest = 'The guest username cannot be the same as the admin username';
	    //             messagesError.errorUsername = 'The admin username cannot be the same as the guest username';
	    //             isValid = false;
	    //         }
	
	    //         if (!isValid && !isFocusAssigned) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.guestUsername.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     if (!isPristinePasswordAdmin || onSubmit) {
	    //         // Admin password
	    //         if (ContentUtils.isEmptyField(this.refs.password)) {
	    //             messagesError.errorPasswordAdmin = 'The admin password is required';
	    //             isValid = false;
	    //         } else if (this.refs.password.getValue().length < 2) {
	    //             messagesError.errorPasswordAdmin = 'The password is too small';
	    //             isValid = false;
	    //         } else if (this.refs.password.getValue().length > 30) {
	    //             messagesError.errorPasswordAdmin = 'The password is too long';
	    //             isValid = false;
	    //         }
	    //         if (!isValid && !isFocusAssigned) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.password.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     if (!isPristinePasswordGuest || onSubmit) {
	    //         // Guest password
	    //         if (ContentUtils.isEmptyField(this.refs.guestPassword)) {
	    //             messagesError.errorPasswordGuest = 'The guest password is required';
	    //             isValid = false;
	    //         } else if (this.refs.guestPassword.getValue().length < 2) {
	    //             messagesError.errorPasswordGuest = 'The password is too small';
	    //             isValid = false;
	    //         } else if (this.refs.guestPassword.getValue().length > 30) {
	    //             messagesError.errorPasswordGuest = 'The password is too long';
	    //             isValid = false;
	    //         }
	    //         if (!isValid && !isFocusAssigned) {
	    //             isFocusAssigned = true;
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.guestPassword.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     if (!isPristineEmail || onSubmit) {
	    //         // Email Validation
	    //         if (ContentUtils.isEmptyField(this.refs.email)) {
	    //             messagesError.errorEmail = 'The email is required';
	    //             isValid = false;
	    //         } else if (!REGEX_EMAIL.test(this.refs.email.getValue())) {
	    //             messagesError.errorEmail = 'The email format is not valid';
	    //             isValid = false;
	    //         } else if (this.refs.email.getValue().length <= 4) {
	    //             messagesError.errorEmail = 'The email format is too small';
	    //             isValid = false;
	    //         } else if (this.refs.email.getValue().length > 90) {
	    //             messagesError.errorEmail = 'The email is too long';
	    //             isValid = false;
	    //         }
	
	    //         if (!isValid && !isFocusAssigned) {
	    //             const scrollTop = PositionUtil.elementScrollTop(this.refs.email.getDOMNode());
	    //             PositionUtil.scrollTo(scrollTop);
	    //         }
	    //     }
	
	    //     this.setState(messagesError);
	
	    //     return isValid;
	    // },
	
	    onBlurInput: function onBlurInput(target) {
	        var _setState,
	            _this3 = this;
	
	        this.setState((_setState = {}, _setState[_.get(target.target.attributes['data-input-name'], 'value')] = false, _setState), function () {
	            _this3.isValidForm(false);
	        });
	    },
	    render: function render() {
	        return React.createElement("div", { id: "page-login", className: "signup-page-container" }, React.createElement("div", {
	            className: "text-center" }, React.createElement("div", { className: "box" }, React.createElement("div", { className: "box-content" }, React.createElement("div", { className: "text-center" }, React.createElement("img", { style: { height: '80px', marginTop: '50px' }, src: "/assets/images/logo-small.png" }), React.createElement("h3", { className: "page-header light" }, t('sign_up_welcome_title'))), React.createElement("div", null, React.createElement("h4", { className: "page-header light" }, "Sign up with an account for free!")), React.createElement("div", { className: "form-group" }, React.createElement(TextField, {
	            className: "full-width",
	            ref: "applicant",
	            "data-input-name": "isPristineApplicantName",
	            hintText: t('sign_up_placeholder_applicant'),
	            defaultValue: "",
	            errorText: this.state.errorApplicantName,
	            onBlur: this.onBlurInput,
	            floatingLabelText: t('sign_up_label_applicant') })), React.createElement("div", { className: "form-group from-group-long-text" }, React.createElement(TextField, {
	            className: "full-width",
	            ref: "email",
	            "data-input-name": "isPristineEmail",
	            hintText: t('sign_up_placeholder_email'),
	            errorText: this.state.errorEmail,
	            defaultValue: "",
	            onBlur: this.onBlurInput,
	            floatingLabelText: t('sign_up_label_email') })), React.createElement("div", { className: "form-group from-group-long-text" }, React.createElement(TextField, {
	            className: "full-width",
	            ref: "username",
	            "data-input-name": "isPristineUsername",
	            hintText: t('sign_up_placeholder_username'),
	            defaultValue: "",
	            errorText: this.state.errorUsername,
	            onBlur: this.onBlurInput,
	            floatingLabelText: t('sign_up_admin_username') })), React.createElement("div", { className: "form-group from-group-long-text" }, React.createElement(TextField, {
	            className: "full-width",
	            type: "password",
	            ref: "password",
	            "data-input-name": "isPristinePasswordAdmin",
	            hintText: t('sign_up_label_password'),
	            errorText: this.state.errorPasswordAdmin,
	            defaultValue: "",
	            onBlur: this.onBlurInput,
	            floatingLabelText: t('sign_up_label_password') })),
	
	        /* <div className="form-group from-group-long-text">
	            <TextField
	                className="full-width"
	                ref="guestUsername"
	                hintText={t('sign_up_placeholder_guest')}
	                data-input-name="isPristineUsernameGuest"
	                errorText={this.state.errorUsernameGuest}
	                defaultValue=""
	                onBlur={this.onBlurInput}
	                floatingLabelText={t('sign_up_label_guest')}/>
	        </div>
	         <div className="form-group from-group-long-text">
	            <TextField
	                className="full-width"
	                type="password"
	                ref="guestPassword"
	                hintText={t('sign_up_placeholder_guest_password')}
	                data-input-name="isPristinePasswordGuest"
	                errorText={this.state.errorPasswordGuest}
	                defaultValue=""
	                onBlur={this.onBlurInput}
	                floatingLabelText={t('sign_up_label_guest_password')}/>
	        </div>*/
	        React.createElement("div", { className: "singup-page-button text-center" }, React.createElement(RaisedButton, { className: "BPButton", label: "Sign Up", primary: true, onClick: this.handleSubmit })), React.createElement("hr", null), React.createElement("div", { className: "text-right", style: { marginBottom: '30px' } }, React.createElement(Link, { to: "login", className: "txt-default" }, t('sign_up_label_already_have_an_account'))), this.state.successfulSignup && React.createElement("div", { className: "text-right", style: { marginBottom: '30px' } }, "Your account has been created. Taking you to BrewPlanner! Please check your email to confirm your account.")))));
	    },
	    _getEmptyModelForm: function _getEmptyModelForm(defaultValue) {
	        return {
	            errorApplicantName: defaultValue,
	            errorEmail: defaultValue,
	            errorUsername: defaultValue,
	            errorPasswordAdmin: defaultValue,
	            errorUsernameGuest: defaultValue,
	            errorPasswordGuest: defaultValue,
	
	            isPristineApplicantName: true,
	            isPristineEmail: true,
	            isPristineUsername: true,
	            isPristinePasswordAdmin: true,
	            isPristineUsernameGuest: true,
	            isPristinePasswordGuest: true
	        };
	    }
	});
	
	function isValidUsername(inputValue) {
	    return (inputValue || '').match(/\s|[A-Z]/) === null;
	}
	
	module.exports = Signup;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    TankStore = __webpack_require__(97),
	    Notification = __webpack_require__(21),
	    DashboardServiceCache = __webpack_require__(28),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupTextfield = __webpack_require__(36),
	    Loading = __webpack_require__(33),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    PositionUtils = __webpack_require__(59),
	    NavigationUtils = __webpack_require__(35),
	    Authentication = __webpack_require__(13).Authentication,
	    AppConstants = __webpack_require__(2),
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18),
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(37),
	    delay = _require3.delay,
	    InventoryStore = __webpack_require__(20),
	    _require4 = __webpack_require__(8),
	    find = _require4.find,
	    filter = _require4.filter,
	    map = _require4.map,
	    CustomDialog = __webpack_require__(26);
	
	
	var pageUrl = '/tanks/page/';
	
	var TankAdmin = React.createClass({ displayName: "TankAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            selectedItemId: null,
	            isEditMode: false,
	            isFetching: true,
	            filter: { name: '', section: '', volume: '' }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchTanks();
	        ga.pageview('tank-admin');
	        document.addEventListener('i18nextLoaded', this.onI18NLoaded);
	    },
	    componentWillMount: function componentWillMount() {
	        document.removeEventListener('i18nextLoaded', this.onI18NLoaded);
	    },
	    fetchTanks: function fetchTanks() {
	        var _this = this;
	
	        var self = this;
	        TankStore.fetchTanks(function () {
	            self.setState({
	                tanks: _this._hydrateTanks(ContentUtils.filterEnable(DashboardServiceCache.getTanks())),
	                selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
	                isFetching: false
	            }, self._onFinishRenderingFetchTanks);
	        });
	    },
	    fetchTanksBy: function fetchTanksBy(filter) {
	        var _this2 = this;
	
	        var self = this;
	        TankStore.fetchTanksBy(filter, function () {
	            self.setState({
	                tanks: _this2._hydrateTanks(ContentUtils.filterEnable(DashboardServiceCache.getTanks())),
	                selectedItemId: NavigationUtils.getQueryParam('selectedItemId'),
	                isFetching: false
	            });
	        });
	    },
	    _onFinishRenderingFetchTanks: function _onFinishRenderingFetchTanks() {
	        var _state = this.state,
	            selectedItemId = _state.selectedItemId,
	            locationItems = _state.locationItems;
	
	        var haveProductSelectedTable = !!selectedItemId;
	
	        if (haveProductSelectedTable) {
	            var self = this;
	            this.setState({
	                selectedItemId: find(locationItems, function (locationItem) {
	                    return get(locationItem, 'id') === +selectedItemId;
	                })
	            }, function () {
	                self._setPositionScrollById.bind(self)(selectedItemId);
	            });
	        }
	    },
	    _hydrateTanks: function _hydrateTanks(tanks) {
	        return map(tanks, function (tank) {
	            var tankUnit = get(tank, 'unit', AppConstants.DEFAULT_TANK_UNIT);
	            tank.volumeWithUnit = get(tank, 'volume') + (tankUnit ? ' ' + tankUnit : '');
	            tank.unit = tankUnit;
	            return tank;
	        });
	    },
	    _setPositionScrollById: function _setPositionScrollById(selectedTankId) {
	        var tableEl = this.getDOMNode().querySelector('.mui-body-table');
	        var rowEl = tableEl.querySelector('tr[data-row-id="' + selectedTankId + '"]');
	        var positionTopRowEl = PositionUtils.elementScrollTop(rowEl);
	        tableEl.scrollTop = positionTopRowEl;
	    },
	    _onDeleteTank: function _onDeleteTank(tank, onSuccess) {
	        var _this3 = this;
	
	        var tankWillDelete = find(TankStore.getTanks(), function (tankFilter) {
	            return tankFilter.id === tank;
	        });
	
	        if (filter(TankStore.getTanks(), function (tankFilter) {
	            return tankFilter.type === tankWillDelete.type;
	        }).length === 1) {
	            CustomDialog.showInfo(t('signup_error'), t('tank_error_at_least_one_tank_per_section'));
	            return;
	        }
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_delete_tank'), function () {
	            TankStore.deleteTank(tank, onSuccess, _this3.__onFailureShowMessageError);
	        });
	    },
	    _onChangeTank: function _onChangeTank(tank, onSuccess) {
	        var _this4 = this;
	
	        var isBrewingTank = get(tank, 'type') === 'BH';
	        var isVolumeChanged = get(tank, 'volume') !== get(this.state, 'selectedItem.volume');
	        if (isBrewingTank && isVolumeChanged) {
	            CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_change_volume'), function () {
	                TankStore.changeTank(tank, onSuccess, _this4._onFailure);
	            });
	        } else {
	            TankStore.changeTank(tank, onSuccess, this._onFailure);
	        }
	    },
	    _onAddTank: function _onAddTank(tank, onSuccess, onFailure) {
	        var isBrewingTank = tank && tank.type === 'BH';
	        var tanks = get(this.state, 'tanks');
	        var currentBrewing = find(tanks, function (tank) {
	            return get(tank, 'type') === 'BH';
	        });
	        var haveTheSameVolume = currentBrewing && get(currentBrewing, 'volume') === get(tank, 'volume');
	        if (isBrewingTank && !haveTheSameVolume) {
	            CustomDialog.showWarningConfirmation(t('warning'), t('tank_confirm_change_volume'), function () {
	                TankStore.addTank(tank, onSuccess, onFailure);
	            });
	        } else {
	            TankStore.addTank(tank, onSuccess, onFailure);
	        }
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this5 = this;
	
	        this.setState({
	            selectedItem: item,
	            isEditMode: !!item,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this5.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	
	            _this5._addQueryParamWithRowSelected(item, lastRowScrollPosition);
	        });
	    },
	    _addQueryParamWithRowSelected: function _addQueryParamWithRowSelected(selectedItem, lastRowScrollPosition) {
	        var _this6 = this;
	
	        this.transitionTo(getCurrentUrl(), {}, {
	            selectedItemId: get(selectedItem, 'id')
	        });
	        // Is needed to force scroll position again
	        // in order to avoid jumping scroll behavior
	        delay(function () {
	            _this6.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        }, 1);
	    },
	    _onCancel: function _onCancel() {
	        this.transitionTo(getCurrentUrl());
	        this.setState({
	            selectedItem: null,
	            isEditMode: false,
	            filter: { name: '', section: '', volume: '' }
	        });
	    },
	    _onFailure: function _onFailure(messageInfo) {
	        if (messageInfo) {
	            var messageError = ContentUtils.formatMessageError(messageInfo);
	            Notification.show(messageError);
	        }
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _onTypingFilter: function _onTypingFilter(name, match) {
	        var _this7 = this;
	
	        if (!this.state.isFetching) {
	            this.setState(function (prevState) {
	                var nextFilter = prevState.filter || {};
	                nextFilter[name] = match;
	                _this7.fetchTanksBy(nextFilter);
	                return {
	                    filter: nextFilter,
	                    isFetching: true
	                };
	            });
	        }
	    },
	    _printReport: function _printReport() {
	        InventoryStore.downloadReportXLS(this.state.filter, 'tanks');
	    },
	    render: function render() {
	        if (!this.state.tanks) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('tank_admin_change_message_success'),
	                changeFailureMessage: t('tank_admin_change_message_failure'),
	                deleteSuccessMessage: t('tank_admin_delete_message_success'),
	                addSuccessMessage: t('tank_admin_add_message_success'),
	                addFailureMessage: t('tank_admin_add_message_failure')
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state2 = this.state,
	                selectedItem = _state2.selectedItem,
	                tanks = _state2.tanks,
	                isEditMode = _state2.isEditMode;
	
	
	            var currentSelectedSection = selectedItem && selectedItem.section ? AppConstants.getSectionsMapping(t)[selectedItem.section] : '';
	
	            var currentSelectedCategoryValue = currentSelectedSection ? _extends({}, selectedItem, { displayText: currentSelectedSection }) : selectedItem;
	
	            var unit = get(selectedItem, 'unit');
	            var unitWithParenthesis = unit ? '(' + unit + ')' : '';
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                name: t('tank_label_name'),
	                value: selectedItem,
	                label: t('tank_placeholder_name'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupDropdown, {
	                isFullRelaxedText: true,
	                items: AppConstants.getSections(t),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "section",
	                readerAttributeValue: "section",
	                writerAttribute: "type",
	                outputMapper: {
	                    Fermenting: 'FV',
	                    Packaging: 'BT',
	                    Brewing: 'BH'
	                },
	                name: t('tank_label_section'),
	                isImmutable: true,
	                value: currentSelectedCategoryValue,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "volume",
	                additionalValidation: function additionalValidation(inputValue) {
	                    return NumberUtils.isNumber(inputValue) ? containSomeDecimalValueDigit(inputValue) ? t('tank_admin_decimal_not_supported') : '' : t('tank_admin_must_be_number');
	                },
	                name: t('tank_label_volume'),
	                value: selectedItem,
	                label: t('tank_label_volume') + ' ' + unitWithParenthesis,
	                isRelaxedText: true,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "unit",
	                isRelaxedText: true,
	                name: t('tank_label_unit'),
	                value: selectedItem || { unit: DashboardServiceCache.getCurrentUnitTank() },
	                label: t('tank_label_unit'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress })];
	
	            return React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_TANK",
	                messages: messages,
	                title: t('dashboard_sidebar_tanks_sections'),
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchTanks,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddTank,
	                onChange: this._onChangeTank,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteTank,
	                addEnterKeyDown: this._addEnterKeyDown,
	                isDark: true
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['name', 'volumeWithUnit'],
	                displayAttributes: ['name', 'displaySection', 'volumeWithUnit'],
	                columnNames: [t('tank_label_name'), t('tank_label_section'), t('tank_label_volume_with_unit')]
	            }, tanks.map(function (tank) {
	                tank.displaySection = AppConstants.getSectionsMapping(t)[tank.section];
	                return tank;
	            })));
	        }
	    }
	});
	
	function getCurrentUrl() {
	    return pageUrl + NavigationUtils.getPathParam('page');
	}
	
	function containSomeDecimalValueDigit(value) {
	    if (value && value.indexOf) {
	        return value.indexOf('.') > -1 || value.indexOf(',') > -1;
	    }
	    return false;
	}
	
	module.exports = TankAdmin;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1375);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    filter = _require2.filter,
	    find = _require2.find,
	    UserServiceImpl = __webpack_require__(181),
	    SessionStore = __webpack_require__(11),
	    InventoryStore = __webpack_require__(20),
	    ContentUtils = __webpack_require__(7),
	    sortBy = __webpack_require__(8).sortBy,
	    _require3 = __webpack_require__(12),
	    Toggle = _require3.Toggle,
	    SessionActionCreators = __webpack_require__(228),
	    Notification = __webpack_require__(21),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    Loading = __webpack_require__(33),
	    FormGroupDropdown = __webpack_require__(58),
	    Authentication = __webpack_require__(13).Authentication,
	    GridItemWithFilter = __webpack_require__(153),
	    ga = __webpack_require__(18),
	    _require4 = __webpack_require__(19),
	    Navigation = _require4.Navigation,
	    _require5 = __webpack_require__(53),
	    cloneDeep = _require5.cloneDeep,
	    get = __webpack_require__(5).get,
	    _require6 = __webpack_require__(8),
	    groupBy = _require6.groupBy;
	
	
	var UserAccessAdmin = React.createClass({ displayName: "UserAccessAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    /**
	     * The model wit all local changes from the session.
	     */
	    modelChanges: [],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedPermission: null,
	            isEditMode: false,
	            isPristineForm: true,
	            isFetching: true,
	            userSelected: null,
	            localChanges: []
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchUsersAccess();
	        ga.pageview('/users-access-admin');
	    },
	    fetchUsersAccess: function fetchUsersAccess() {
	        var self = this;
	        var userSelectedId = NavigationUtils.getQueryParam('userId');
	
	        InventoryStore.fetchIcons(function (icons) {
	            SessionStore.fetchUserAccess(function (userInfo) {
	                var userPermissionsAllowed = filter(get(userInfo, 'userPermissions'), function (userPermission) {
	                    return get(userPermission, 'isEnable');
	                }) || [];
	                var userPermissionFiltered = filter(userPermissionsAllowed, function (userPermission) {
	                    return get(userPermission, 'user.id') === +userSelectedId;
	                });
	                var userPermissionsId = map(userPermissionFiltered, function (userPermission) {
	                    return get(userPermission, 'permissions.id');
	                }) || [];
	                var users = filter(get(userInfo, 'users'), function (user) {
	                    return get(user, 'accountEnabled');
	                });
	                var permissions = self._filterPermissionForOldGuestUsers(userSelectedId, users, get(userInfo, 'permissions'));
	
	                var permissionsUpdated = map(self._filterAdminPermissions(permissions), function (permission) {
	                    var permissionName = get(permission, 'name');
	                    var moduleName = get(permission, 'module');
	
	                    // set all items needed to visualize properly each box
	                    var permissionNameWithoutModule = permissionName.replace(moduleName + '_', '');
	                    permission.displayName = ContentUtils.formatMessage(permissionNameWithoutModule);
	                    permission.isSelected = userPermissionsId.indexOf(get(permission, 'id')) > -1 ? 'YES' : 'NO';
	                    permission.iconClassNameField = 'material-icons';
	                    permission.iconInnerText = ContentUtils.getIconText(permissionName);
	
	                    return permission;
	                });
	
	                self.setState({
	                    users: users,
	                    icons: get(icons, 'icons'),
	                    permissions: permissionsUpdated,
	                    localChanges: [],
	                    permissionsPristine: cloneDeep(permissionsUpdated),
	                    isPristineForm: true, // reset pristine indicator,
	                    userPermissions: get(userInfo, 'userPermissions'),
	                    isEditMode: false,
	                    isFetching: false,
	                    userSelected: find(users, function (user) {
	                        return get(user, 'id') === +userSelectedId;
	                    })
	                });
	            });
	        });
	    },
	    _filterPermissionForOldGuestUsers: function _filterPermissionForOldGuestUsers(userIdSelected, users, permissions) {
	        var userTarget = find(users, function (user) {
	            return user.id === +userIdSelected;
	        });
	
	        var isGuestUser = this._isGuestUser(userTarget);
	        var isAdminUser = this._isAdminUser(userTarget);
	        if (isGuestUser || isAdminUser) {
	            return filter(permissions, function (permission) {
	                return get(permission, 'name') !== 'DASHBOARD_EDIT_NOTES';
	            });
	        } else {
	            return permissions;
	        }
	    },
	    _isGuestUser: function _isGuestUser(user) {
	        var roles = get(user, 'roles');
	        if (ContentUtils.isNotEmptyArray(roles)) {
	            return roles.length === 1 && roles[0] === 'USER';
	        } else {
	            return false;
	        }
	    },
	    _isAdminUser: function _isAdminUser(user) {
	        var roles = get(user, 'roles');
	        if (ContentUtils.isNotEmptyArray(roles)) {
	            return roles.some(function (role) {
	                return role === 'ADMIN';
	            });
	        } else {
	            return false;
	        }
	    },
	    _filterAdminPermissions: function _filterAdminPermissions(permissions) {
	        return filter(permissions, function (p) {
	            return p.module !== 'ADMIN_USER' && p.module !== 'ADMIN_USER_PERMISSION';
	        });
	    },
	    _onChangeUser: function _onChangeUser(evt, index, menuItem) {
	        var _this = this;
	
	        var isNonSelectedUser = index === 0;
	        if (isNonSelectedUser) {
	            this.setState(function (prevState) {
	                return {
	                    userSelected: null,
	                    selectedPermission: null,
	                    isEditMode: false,
	                    localChanges: [],
	                    permissions: prevState.permissions.map(function (p) {
	                        p.isChecked = false;
	                        p.isSelected = 'NO';
	                        return p;
	                    })
	                };
	            }, function () {
	                _this.transitionTo('user-permissions');
	            });
	        } else {
	            this.setState({
	                userSelected: get(menuItem, 'itemModel'),
	                selectedPermission: null
	            }, function () {
	                _this.transitionTo('user-permissions', null, { userId: _this.state.userSelected.id });
	                _this.fetchUsersAccess();
	            });
	        }
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            userSelected: null,
	            selectedPermission: null,
	            isEditMode: false
	        }, this.fetchUsersAccess);
	    },
	    onSavePermission: function onSavePermission(item, onSuccess, onFailure) {
	        var _this2 = this;
	
	        var userSelectedId = NavigationUtils.getQueryParam('userId');
	        UserServiceImpl.updatePermissions(userSelectedId, this.state.localChanges, item.isSelected, function () {
	            Notification.show(t('user_access_saved_notification'), 'success');
	
	            SessionActionCreators.permissionRequestUpdate(ContentUtils.getSession('userNameSession'), ContentUtils.getSession('X-Auth-Token'), SessionStore.getCurrentApplicantId());
	
	            _this2.setState({
	                userSelected: null,
	                selectedPermission: null,
	                isEditMode: false
	            }, _this2.fetchUsersAccess);
	        }, onFailure);
	    },
	    isCheckedItem: function isCheckedItem(permission) {
	        return permission.isSelected === 'YES';
	    },
	    isChangedItem: function isChangedItem(permissionChanged) {
	        var permissionAlreadyChanged = find(this.state.localChanges, function (permission) {
	            return get(permission, 'iconId') === get(permissionChanged, 'id');
	        });
	        return permissionAlreadyChanged !== undefined;
	    },
	    onCheckItem: function onCheckItem(permissionChanged) {
	        var _this3 = this;
	
	        this.setState(function (prevState) {
	            var permissionTarget = find(prevState.permissions, function (permission) {
	                return get(permission, 'id') === get(permissionChanged, 'iconId');
	            });
	            permissionTarget = SessionStore.onTogglePermission(permissionTarget);
	            prevState.permissions = ContentUtils.replace(prevState.permissions, permissionTarget, 'id');
	            prevState.localChanges = _this3.updatePermissions(prevState.localChanges, [permissionTarget]), prevState.selectedPermission = permissionTarget;
	            return prevState;
	        });
	    },
	    _onToggle: function _onToggle(moduleName) {
	        var _this4 = this;
	
	        this.setState(function (prevState) {
	            var permissions = prevState.permissions,
	                isEditMode = prevState.isEditMode,
	                oldLocalChanges = prevState.localChanges;
	
	            var localChanges = (permissions || []).filter(function (permission) {
	                return permission.module === moduleName;
	            });
	            var somePermissionOff = localChanges.some(function (permission) {
	                return permission.isSelected === 'NO';
	            });
	            if (somePermissionOff) {
	                localChanges.forEach(function (permission) {
	                    return SessionStore.forcePermission(permission, true);
	                });
	            } else {
	                localChanges.forEach(function (permission) {
	                    return SessionStore.forcePermission(permission, false);
	                });
	            }
	            return {
	                permissions: ContentUtils.replaceAll(permissions, localChanges, 'id'),
	                localChanges: _this4.updatePermissions(oldLocalChanges, localChanges),
	                isEditMode: !isEditMode
	            };
	        });
	    },
	    updatePermissions: function updatePermissions(oldPermissions, newPermissions) {
	        var newPermissionChangedIds = newPermissions.map(function (permission) {
	            return permission.id;
	        });
	        var oldLocalChangesWithoutRepeated = oldPermissions.filter(function (permission) {
	            return newPermissionChangedIds.indexOf(permission.id) === -1;
	        });
	        return oldLocalChangesWithoutRepeated.concat(newPermissions);
	    },
	    render: function render() {
	        var _this5 = this;
	
	        if (this.state.isFetching) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('user_access_change_success_message'),
	                changeFailureMessage: t('user_access_change_failure_message'),
	                deleteSuccessMessage: t('user_access_delete_message'),
	                addSuccessMessage: t('user_access_add_success_message'),
	                addFailureMessage: t('user_access_add_failure_message')
	            };
	            var dictionary = getDictionary(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                isEditMode = _state.isEditMode,
	                users = _state.users,
	                permissions = _state.permissions,
	                userSelected = _state.userSelected,
	                localChanges = _state.localChanges;
	
	            var permissionByModules = groupBy(permissions, 'module');
	            var isCurrentUserAdmin = this._isAdminUser(userSelected);
	
	            var modulesName = Object.keys(permissionByModules);
	            var modulesNameSorted = sortBy(modulesName);
	            var modulesNameSortedWithoutDashboard = modulesNameSorted.filter(function (moduleName) {
	                return moduleName !== 'DASHBOARD';
	            });
	
	            var permissionByModulesEl = isCurrentUserAdmin ? null : map(modulesNameSortedWithoutDashboard, function (moduleName) {
	                var premissionsValue = get(permissionByModules, moduleName);
	                var sortedPermissionsValue = ContentUtils.sortIcons(premissionsValue);
	                var isToggleOn = _this5.state.permissions.filter(function (permission) {
	                    return permission.module === moduleName;
	                }).every(function (permission) {
	                    return permission.isSelected === 'YES';
	                });
	                return React.createElement("div", null, React.createElement("div", { className: "user-access-admin__header" }, React.createElement("h2", { className: "user-access-admin__header-text" }, dictionary[moduleName]), React.createElement("div", { className: "user-access-admin__header-toggle" }, React.createElement(Toggle, {
	                    name: "isConfirmProduct",
	                    toggled: isToggleOn,
	                    onToggle: _this5._onToggle.bind(_this5, moduleName) }))), React.createElement("div", { className: "user-access-admin__boxes" }, React.createElement(GridItemWithFilter, {
	                    showSwitcher: true,
	                    filterHidden: true,
	                    items: sortedPermissionsValue,
	                    isCheckedItem: _this5.isCheckedItem,
	                    isChangedItem: _this5.isChangedItem,
	                    onCheckItem: _this5.onCheckItem,
	                    displayNameField: "displayName",
	                    iconInnerText: "iconInnerText",
	                    iconClassNameField: "iconClassNameField",
	                    idField: "id",
	                    initialFilterText: "",
	                    keepSelectedSorting: false,
	                    dictionary: dictionary })));
	            });
	
	            var formFieldsEl = [React.createElement(FormGroupDropdown, {
	                items: users,
	                operationsHolder: contextHolder,
	                readerAttribute: "username",
	                name: t('label_user'),
	                value: userSelected,
	                isEditMode: isEditMode,
	                onEnter: this.__onEnterPress,
	                onChange: this._onChangeUser })];
	
	            var isDashboardToggleOn = this.state.permissions.filter(function (permission) {
	                return permission.module === 'DASHBOARD';
	            }).every(function (permission) {
	                return permission.isSelected === 'YES';
	            });
	            return React.createElement(AdminScaffoldingGeneric, {
	                messages: messages,
	                moduleName: "ADMIN_USER_PERMISSION",
	                title: t('user_access_user_level'),
	                contextHolder: contextHolder,
	                value: !ContentUtils.isNullOrEmpty(localChanges),
	                fetchItems: this.fetchUsersAccess,
	                onCancel: this._onCancel,
	                headerFields: formFieldsEl,
	                addEnterKeyDown: this.__addEnterKeyDown,
	                onChange: this.onSavePermission,
	                keepSelectedSorting: false
	            }, isCurrentUserAdmin ? null : React.createElement("div", null, React.createElement("div", { className: "user-access-admin__header is-first" }, React.createElement("h2", { className: "user-access-admin__header-text" }, dictionary['DASHBOARD_SHOW']), React.createElement("div", { className: "user-access-admin__header-toggle" }, React.createElement(Toggle, {
	                name: "isConfirmProduct",
	                toggled: isDashboardToggleOn,
	                onToggle: this._onToggle.bind(this, 'DASHBOARD') }))), React.createElement("div", { className: "user-access-admin__boxes" }, React.createElement(GridItemWithFilter, {
	                showSwitcher: true,
	                filterHidden: true,
	                items: ContentUtils.sortIcons(get(permissionByModules, 'DASHBOARD')),
	                isCheckedItem: this.isCheckedItem,
	                isChangedItem: this.isChangedItem,
	                onCheckItem: this.onCheckItem,
	                displayNameField: "displayName",
	                iconInnerText: "iconInnerText",
	                iconClassNameField: "iconClassNameField",
	                idField: "id",
	                initialFilterText: "",
	                keepSelectedSorting: false,
	                dictionary: dictionary }))), isCurrentUserAdmin ? React.createElement("h2", { style: {
	                    margin: '0 auto',
	                    padding: '50px',
	                    display: 'flex',
	                    justifyContent: 'center'
	                }, className: "user-access-admin__subtitle" }, t('user_access_no_allow_change_admin_message')) : null, permissionByModulesEl);
	        }
	    }
	});
	
	var getDictionary = function getDictionary(t) {
	    return {
	        'ADMIN_TANK_SHOW': t('user_access_widget_tank_show'),
	        'ADMIN_TANK_NEW': t('user_access_widget_tank_new'),
	        'ADMIN_TANK_EDIT': t('user_access_widget_tank_edit'),
	        'ADMIN_TANK_DELETE': t('user_access_widget_tank_delete'),
	        'ADMIN_TANK_PRINT_REPORT': t('user_access_widget_print_report'),
	        'ADMIN_BEER_STYLE_SHOW': t('user_access_widget_style_show'),
	        'ADMIN_BEER_STYLE_NEW': t('user_access_widget_style_new'),
	        'ADMIN_BEER_STYLE_EDIT': t('user_access_widget_style_edit'),
	        'ADMIN_BEER_STYLE_DELETE': t('user_access_widget_style_delete'),
	        'ADMIN_BEER_STYLE_BREWING_ICONS': t('user_access_widget_style_brewing_icons'),
	        'ADMIN_BEER_STYLE_FERMENTING_ICONS': t('user_access_widget_style_fermenting_icons'),
	        'ADMIN_BEER_STYLE_PACKAGING_ICONS': t('user_access_widget_style_packaging_icons'),
	        'ADMIN_BEER_STYLE_DUPLICATE': t('user_access_widget_style_duplicate'),
	        'ADMIN_BEER_STYLE_CONFIGURATION_NEW': t('user_access_widget_style_configuration_new'),
	        'ADMIN_BEER_STYLE_CONFIGURATION_EDIT': t('user_access_widget_style_configuration_edit'),
	        'ADMIN_BEER_STYLE_CONFIGURATION_DELETE': t('user_access_widget_style_configuration_delete'),
	        'ADMIN_TASK_SHOW': t('user_access_widget_task_show'),
	        'ADMIN_TASK_NEW': t('user_access_widget_task_new'),
	        'ADMIN_TASK_EDIT': t('user_access_widget_task_edit'),
	        'ADMIN_TASK_DELETE': t('user_access_widget_task_delete'),
	        'ADMIN_ICON_SHOW': t('user_access_widget_icon_show'),
	        'ADMIN_ICON_EDIT': t('user_access_widget_icon_edit'),
	        'ADMIN_ITEM_SHOW': t('user_access_widget_item_show'),
	        'ADMIN_ITEM_NEW': t('user_access_widget_item_new'),
	        'ADMIN_ITEM_EDIT': t('user_access_widget_item_edit'),
	        'ADMIN_ITEM_DELETE': t('user_access_widget_item_delete'),
	        'ADMIN_ITEM_DUPLICATE': t('user_access_widget_purchase_duplicate'),
	        'ADMIN_PURCHASE_SHOW': t('user_access_widget_purchase_show'),
	        'ADMIN_PURCHASE_NEW': t('user_access_widget_purchase_new'),
	        'ADMIN_PURCHASE_ITEM_NEW': t('user_access_widget_purchase_new_item'),
	        'ADMIN_PURCHASE_EDIT': t('user_access_widget_purchase_edit'),
	        'ADMIN_PURCHASE_DELETE': t('user_access_widget_purchase_delete'),
	        'ADMIN_PURCHASE_DUPLICATE': t('user_access_widget_purchase_duplicate'),
	        'ADMIN_PURCHASE_VIEW_ORDER': t('user_access_widget_purchase_view_order'),
	        'ADMIN_PURCHASE_PRINT_REPORT': t('user_access_widget_purchase_print_report'),
	        'ADMIN_PURCHASE_SEND_PENDING_ORDER': t('user_access_widget_purchase_send_pending_order'),
	        'ADMIN_PURCHASE_NEW_ITEM': t('user_access_widget_purchase_new_item'),
	        'ADMIN_PURCHASE_ITEM_EDIT': t('user_access_widget_purchase_edit_item'),
	        'ADMIN_PURCHASE_ITEM_DELETE': t('user_access_widget_purchase_delete_item'),
	        'ADMIN_PURCHASE_CONFIRM_RECEIVE': t('user_access_widget_purchase_confirm_receive'),
	        'ADMIN_SALE_SHOW': t('user_access_widget_sale_show'),
	        'ADMIN_SALE_NEW': t('user_access_widget_sale_new'),
	        'ADMIN_SALE_EDIT': t('user_access_widget_sale_edit'),
	        'ADMIN_SALE_DELETE': t('user_access_widget_sale_delete'),
	        'ADMIN_SALE_SEND_ORDER': t('user_access_widget_sale_send_order'),
	        'ADMIN_SALE_CONFIRM_ORDER': t('user_access_widget_sale_confirm_order'),
	        'ADMIN_SALE_VIEW_ORDER': t('user_access_widget_sale_view_order'),
	        'ADMIN_SALE_PRINT_REPORT': t('user_access_widget_sale_print_report'),
	        'ADMIN_SALE_ITEM_NEW': t('user_access_widget_sale_item_new'),
	        'ADMIN_SALE_ITEM_EDIT': t('user_access_widget_sale_item_edit'),
	        'ADMIN_SALE_ITEM_DELETE': t('user_access_widget_sale_item_delete'),
	        'ADMIN_INVENTORY_AND_TRANSFERS_SHOW': t('user_access_widget_inventory_and_transfer_show'),
	        'ADMIN_INVENTORY_AND_TRANSFERS_TRANSFER_SHOW': t('user_access_widget_inventory_and_transfer_transfer_show'),
	        'ADMIN_INVENTORY_AND_TRANSFERS_ADJUST_SHOW': t('user_access_widget_inventory_and_transfer_adjust_show'),
	        'ADMIN_PRODUCT_SHOW': t('user_access_widget_product_show'),
	        'ADMIN_PRODUCT_NEW': t('user_access_widget_product_new'),
	        'ADMIN_PRODUCT_EDIT': t('user_access_widget_product_edit'),
	        'ADMIN_PRODUCT_DELETE': t('user_access_widget_product_delete'),
	        'ADMIN_PRODUCT_ICON_SHOW': t('user_access_widget_product_icon_show'),
	        'ADMIN_PRODUCT_ICON_NEW': t('user_access_widget_product_icon_new'),
	        'ADMIN_PRODUCT_ICON_EDIT': t('user_access_widget_product_icon_edit'),
	        'ADMIN_PRODUCT_ICON_DELETE': t('user_access_widget_product_icon_delete'),
	        'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_SHOW': t('user_access_widget_product_item_substraction_show'),
	        'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_NEW': t('user_access_widget_product_item_substraction_new'),
	        'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_EDIT': t('user_access_widget_product_item_substraction_edit'),
	        'ADMIN_PRODUCT_ITEMS_SUBSTRACTION_DELETE': t('user_access_widget_product_item_substraction_delete'),
	        'ADMIN_PRODUCT_ITEMS_ADDITION_SHOW': t('user_access_widget_product_item_addition_show'),
	        'ADMIN_PRODUCT_ITEMS_ADDITION_NEW': t('user_access_widget_product_item_addition_new'),
	        'ADMIN_PRODUCT_ITEMS_ADDITION_EDIT': t('user_access_widget_product_item_addition_edit'),
	        'ADMIN_PRODUCT_ITEMS_ADDITION_DELETE': t('user_access_widget_product_item_addition_delete'),
	        'ADMIN_PRODUCT_DUPLICATE_SHOW': t('user_access_widget_product_duplicate_show'),
	        'ADMIN_LOCATION_SHOW': t('user_access_widget_location_show'),
	        'ADMIN_LOCATION_NEW': t('user_access_widget_location_new'),
	        'ADMIN_LOCATION_EDIT': t('user_access_widget_location_edit'),
	        'ADMIN_LOCATION_DELETE': t('user_access_widget_location_delete'),
	        'ADMIN_VENDOR_SHOW': t('user_access_widget_vendor_show'),
	        'ADMIN_VENDOR_NEW': t('user_access_widget_vendor_new'),
	        'ADMIN_VENDOR_EDIT': t('user_access_widget_vendor_edit'),
	        'ADMIN_VENDOR_DELETE': t('user_access_widget_vendor_delete'),
	        'ADMIN_VENDOR_SET_ITEMS': t('user_access_widget_vendor_set_items'),
	        'ADMIN_VENDOR_SET_CONTACTS': t('user_access_widget_vendor_set_contacts'),
	        'ADMIN_VENDOR_SET_ADDRESS': t('user_access_widget_vendor_set_address'),
	        'ADMIN_VENDOR_ADDRESS_SHOW': t('user_access_widget_address_show'),
	        'ADMIN_VENDOR_ADDRESS_NEW': t('user_access_widget_address_new'),
	        'ADMIN_VENDOR_ADDRESS_EDIT': t('user_access_widget_address_edit'),
	        'ADMIN_VENDOR_ADDRESS_DELETE': t('user_access_widget_address_delete'),
	        'ADMIN_VENDOR_CONTACT_SHOW': t('user_access_widget_contact_show'),
	        'ADMIN_VENDOR_CONTACT_NEW': t('user_access_widget_contact_new'),
	        'ADMIN_VENDOR_CONTACT_EDIT': t('user_access_widget_contact_edit'),
	        'ADMIN_VENDOR_CONTACT_DELETE': t('user_access_widget_contact_delete'),
	        'ADMIN_VENDOR_ITEMS_SHOW': t('user_access_widget_items_show'),
	        'ADMIN_VENDOR_ITEMS_NEW': t('user_access_widget_items_new'),
	        'ADMIN_VENDOR_ITEMS_EDIT': t('user_access_widget_items_edit'),
	        'ADMIN_VENDOR_ITEMS_DELETE': t('user_access_widget_items_delete'),
	        'ADMIN_CUSTOMER_SHOW': t('user_access_widget_customer_show'),
	        'ADMIN_CUSTOMER_NEW': t('user_access_widget_customer_new'),
	        'ADMIN_CUSTOMER_EDIT': t('user_access_widget_customer_edit'),
	        'ADMIN_CUSTOMER_DELETE': t('user_access_widget_customer_delete'),
	        'ADMIN_CUSTOMER_ADDRESS_SHOW': t('user_access_widget_customer_address_show'),
	        'ADMIN_CUSTOMER_ADDRESS_NEW': t('user_access_widget_customer_address_new'),
	        'ADMIN_CUSTOMER_ADDRESS_EDIT': t('user_access_widget_customer_address_edit'),
	        'ADMIN_CUSTOMER_ADDRESS_DELETE': t('user_access_widget_customer_address_delete'),
	        'ADMIN_CUSTOMER_CONTACT_SHOW': t('user_access_widget_customer_contact_show'),
	        'ADMIN_CUSTOMER_CONTACT_NEW': t('user_access_widget_customer_contact_new'),
	        'ADMIN_CUSTOMER_CONTACT_EDIT': t('user_access_widget_customer_contact_edit'),
	        'ADMIN_CUSTOMER_CONTACT_DELETE': t('user_access_widget_customer_contact_delete'),
	        'ADMIN_CUSTOMER_PRICE_SHOW': t('user_access_widget_customer_price_show'),
	        'ADMIN_CUSTOMER_PRICE_NEW': t('user_access_widget_customer_price_new'),
	        'ADMIN_CUSTOMER_PRICE_EDIT': t('user_access_widget_customer_price_edit'),
	        'ADMIN_CUSTOMER_PRICE_DELETE': t('user_access_widget_customer_price_delete'),
	        'ADMIN_REPORT_SHOW': t('user_access_widget_report_show'),
	        'ADMIN_REPORT_BY_BATCH_NUMBER': t('user_access_widget_report_batch_number_show'),
	        'ADMIN_REPORT_BY_ITEM_TRANSACTION': t('user_access_widget_report_items_show'),
	        'ADMIN_REPORT_BY_PRODUCT': t('user_access_widget_report_group_item_show'),
	        'ADMIN_REPORT_BY_TASK': t('user_access_widget_report_tasks_show'),
	        'DASHBOARD_EDIT_NOTES': t('user_access_widget_dashboard_edit_notes'),
	        'DASHBOARD_EDIT_ALL': t('user_access_widget_dashboard_edit_all'),
	        'DASHBOARD_EDIT_ALL_WITHOUT_DATES': t('user_access_widget_dashboard_edit_all_without_date'),
	        'ADMIN_TANK': t('user_access_widget_title_admin_tank'),
	        'ADMIN_BEER_STYLE': t('user_access_widget_title_admin_beer_style'),
	        'ADMIN_TASK': t('user_access_widget_title_admin_task'),
	        'ADMIN_ICON': t('user_access_widget_title_admin_icon'),
	        'ADMIN_ITEM': t('user_access_widget_title_admin_item'),
	        'ADMIN_PURCHASE_ITEM': t('user_access_widget_title_admin_purchase_item'),
	        'ADMIN_CUSTOMER': t('user_access_widget_title_admin_customer'),
	        'ADMIN_INVENTORY_AND_TRANSFERS': t('user_access_widget_title_admin_inventory_and_transfers'),
	        'ADMIN_PRODUCT': t('user_access_widget_title_admin_product'),
	        'ADMIN_LOCATION': t('user_access_widget_title_admin_location'),
	        'ADMIN_VENDOR': t('user_access_widget_title_admin_vendor'),
	        'ADMIN_SALE': t('user_access_widget_title_admin_sale'),
	        'ADMIN_USER': t('user_access_widget_title_admin_user'),
	        'ADMIN_USER_ACCESS': t('user_access_widget_title_admin_user_access'),
	        'ADMIN_PURCHASE': t('user_access_widget_title_admin_purchase_item'),
	        'DASHBOARD_SHOW': t('user_access_widget_title_admin_dashboard'),
	        'ADMIN_USER_PERMISSION': t('user_access_widget_title_admin_user_access'),
	        'ADMIN_BEER_STYLE_CONFIGURATION': t('user_access_widget_title_admin_beer_style_configuration'),
	        'ADMIN_REPORT': t('user_access_widget_title_admin_report')
	    };
	};
	
	module.exports = UserAccessAdmin;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    UserStore = __webpack_require__(747),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    FormGroupDropdown = __webpack_require__(58),
	    Loading = __webpack_require__(33),
	    Authentication = __webpack_require__(13).Authentication,
	    ContentUtils = __webpack_require__(7),
	    AppConstants = __webpack_require__(2),
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18),
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(8),
	    filter = _require3.filter,
	    CustomDialog = __webpack_require__(26);
	
	
	var UserAdmin = React.createClass({ displayName: "UserAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedItem: null,
	            selectedItemId: null,
	            isEditMode: false,
	            isFetching: true
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchUsers();
	        ga.pageview('User-admin');
	    },
	    fetchUsers: function fetchUsers() {
	        var self = this;
	        UserStore.fetchUsers(function (users) {
	            users = users.map(function (user) {
	                user.role = user.roles.includes('ADMIN') ? AppConstants.USERS_ROLES[0] : AppConstants.USERS_ROLES[1];
	                return user;
	            });
	            self.setState({
	                users: filter(users, function (user) {
	                    return get(user, 'accountEnabled');
	                }),
	                isFetching: false
	            });
	        });
	    },
	    _onDeleteUser: function _onDeleteUser(userId, onSuccess) {
	        var _this = this;
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('user_admin_delete_question'), function () {
	            UserStore.deleteUser(userId, onSuccess, _this.__onFailureShowMessageError);
	        });
	    },
	    _onChangeUser: function _onChangeUser(User, onSuccess) {
	        UserStore.changeUser(User, onSuccess, this.__onFailureShowMessageError);
	    },
	    _onAddUser: function _onAddUser(User, onSuccess) {
	        UserStore.addUser(User, onSuccess, this.__onFailureShowMessageError);
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _goToChangePasswordPage: function _goToChangePasswordPage() {
	        this.transitionTo('/passwordRecovery', {}, { userName: get(this.state, 'selectedItem.username') });
	    },
	    _getRoleText: function _getRoleText(text) {
	        var isAdmin = text.roles.includes('ADMIN');
	        return React.createElement("span", null, isAdmin ? AppConstants.getUserRoles(t)[0].displayText : AppConstants.getUserRoles(t)[1].displayText);
	    },
	    render: function render() {
	        if (!this.state.users) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('user_admin_change_success_message'),
	                changeFailureMessage: t('user_admin_change_failure_message'),
	                deleteSuccessMessage: t('user_admin_delete_success_message'),
	                addSuccessMessage: t('user_admin_add_success_message'),
	                addFailureMessage: t('user_admin_add_failure_message')
	            };
	            var userRolMapping = AppConstants.getUserRolesMapping(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                users = _state.users,
	                isEditMode = _state.isEditMode;
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "username",
	                name: t('user_admin_label_username'),
	                value: selectedItem,
	                label: t('user_admin_label_username'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress,
	                additionalValidation: validateUserName(t) }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "email",
	                additionalValidation: function additionalValidation(inputValue) {
	                    return ContentUtils.isValidEmail(inputValue) ? '' : t('notification_define_valid_email');
	                },
	                isRelaxedText: true,
	                name: t('email'),
	                value: selectedItem,
	                label: t('email'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress })];
	
	            if (!isEditMode) {
	                formFieldsEl.push(React.createElement(FormGroupTextfield, {
	                    operationsHolder: contextHolder,
	                    readerAttribute: "password",
	                    isRelaxedText: true,
	                    name: t('password'),
	                    value: selectedItem,
	                    label: t('password'),
	                    isEditMode: isEditMode,
	                    onEnter: this._onEnterPress }));
	            }
	
	            formFieldsEl.push(React.createElement(FormGroupDropdown, {
	                items: AppConstants.getUserRoles(t),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "role",
	                readerAttributeValue: "role",
	                writerAttribute: "role",
	                outputMapper: {
	                    Administrator: t('user_admin_label_rol_admin'),
	                    Guest: t('user_admin_label_rol_guest')
	                },
	                name: t('user_admin_label_rol'),
	                isImmutable: selectedItem && selectedItem.principal,
	                value: selectedItem,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }));
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'PERMISSION_EDIT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('user_admin_change_password'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToChangePasswordPage })
	            }];
	
	            return React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_USER",
	                messages: messages,
	                title: t('users'),
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchUsers,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddUser,
	                additionalButtons: additionalButtons,
	                onChange: this._onChangeUser,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteUser,
	                addEnterKeyDown: this._addEnterKeyDown,
	                isDark: true
	            }, React.createElement("span", { style: { 'color': 'white', 'background-color': '#434445', 'padding-right': '15px', 'padding-left': '15px', 'display': 'flex', 'align-items': 'center', 'paddingBottom': '5px' } }, React.createElement("i", { className: "material-icons md-48", style: { 'color': 'white' } }, "info"), React.createElement("span", { style: { 'padding': '0 0.5rem' } }, SessionStore.getApplicantEmail()), t('user_admin_label_company_email')), React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this.__onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['username', 'email', 'roles'],
	                displayAttributes: ['username', 'email', { getHTML: this._getRoleText }],
	                columnNames: [t('user_admin_label_username'), t('email'), t('user_admin_label_rol')]
	            }, users.map(function (user) {
	                user.displayRole = userRolMapping[user.role];
	                return user;
	            })));
	        }
	    }
	});
	
	function validateUserName(t) {
	    return function (inputValue) {
	        return (inputValue || '').match(/\s|[A-Z]/) === null ? '' : t('user_admin_error_inline_user_invalid');
	    };
	}
	
	module.exports = UserAdmin;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    CustomDialog = __webpack_require__(26),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18);
	
	
	var VendorAddressAdmin = React.createClass({ displayName: "VendorAddressAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedVendor: null,
	            companyName: NavigationUtils.getQueryParam('companyName')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchVendor();
	        ga.pageview('/vendor-address-admin');
	    },
	    fetchVendor: function fetchVendor() {
	        var self = this;
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        InventoryStore.fetchVendorAddresses(vendorId, function (addresses) {
	            self.setState({
	                addresses: addresses
	            });
	        });
	    },
	    _goToContacts: function _goToContacts() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/contacts', { vendorId: vendorId }, { companyName: companyName });
	    },
	    _goToSetItems: function _goToSetItems() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/items', { vendorId: vendorId }, { companyName: companyName });
	    },
	    _backToVendor: function _backToVendor() {
	        this.transitionTo('/vendors');
	    },
	    _onDeleteAddress: function _onDeleteAddress(addressId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_admin_confirm_delete_address'), function () {
	            InventoryStore.deleteVendorAddress(NavigationUtils.getPathParam('vendors'), addressId, onSuccess, onFailure);
	        });
	    },
	    _onChangeAddress: function _onChangeAddress(address, onSuccess, onFailure) {
	        InventoryStore.changeVendorAddress(NavigationUtils.getPathParam('vendors'), address, onSuccess, onFailure);
	    },
	    _onAddAddress: function _onAddAddress(address, onSuccess, onFailure) {
	        InventoryStore.addVendorAddress(NavigationUtils.getPathParam('vendors'), address, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item) {
	        this.setState({
	            selectedItem: item
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ link: 'vendors', displayName: t('dashboard_sidebar_suppliers') }, { displayName: get(this.state, 'companyName') }];
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    render: function render() {
	        var _state = this.state,
	            addresses = _state.addresses,
	            selectedItem = _state.selectedItem;
	
	        if (!addresses) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('vendor_admin_change_address_success_message'),
	                changeFailureMessage: t('vendor_admin_change_address_failure_message'),
	                deleteSuccessMessage: t('vendor_admin_delete_address_success_message'),
	                addSuccessMessage: t('vendor_admin_add_address_success_message'),
	                addFailureMessage: t('vendor_admin_add_address_failure_message')
	            };
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_address_set_contacts'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToContacts })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_set_items'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToSetItems })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                isRelaxedText: true,
	                operationsHolder: contextHolder,
	                displayAttribute: "address",
	                readerAttribute: "address",
	                writerAttribute: "address",
	                isRequired: true,
	                name: t('address'),
	                value: selectedItem,
	                label: t('vendor_admin_label_address'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isRelaxedText: true,
	                operationsHolder: contextHolder,
	                displayAttribute: "postCode",
	                readerAttribute: "postCode",
	                writerAttribute: "postCode",
	                isRequired: true,
	                name: t('post_code'),
	                value: selectedItem,
	                label: t('vendor_admin_label_post_code'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isRelaxedText: true,
	                operationsHolder: contextHolder,
	                displayAttribute: "city",
	                readerAttribute: "city",
	                writerAttribute: "city",
	                isRequired: true,
	                name: t('city'),
	                value: selectedItem,
	                label: t('vendor_admin_label_city'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isRelaxedText: true,
	                operationsHolder: contextHolder,
	                displayAttribute: "state",
	                readerAttribute: "state",
	                writerAttribute: "state",
	                isRequired: true,
	                name: t('state'),
	                value: selectedItem,
	                label: t('vendor_admin_label_state'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                displayAttribute: "country",
	                readerAttribute: "country",
	                writerAttribute: "country",
	                isRequired: true,
	                name: t('country'),
	                value: selectedItem,
	                label: t('vendor_admin_label_country'),
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                moduleName: "ADMIN_VENDOR_ADDRESS",
	                title: t('vendor_admin_label_supplier_addresses'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchVendor,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddAddress,
	                onChange: this._onChangeAddress,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteAddress,
	                additionalButtons: additionalButtons,
	                breadcrumb: this._getBreadcrumbLinks(),
	                addEnterKeyDown: this._addEnterKeyDown
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['name'],
	                filteredColumns: ['address', 'postCode', 'city', 'state', 'country'],
	                columnNames: [t('vendor_admin_label_address'), t('vendor_admin_label_post_code'), t('vendor_admin_label_city'), t('vendor_admin_label_state'), t('vendor_admin_label_country')],
	                displayAttributes: ['address', 'postCode', 'city', 'state', 'country']
	            }, addresses)));
	        }
	    }
	});
	
	module.exports = VendorAddressAdmin;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _CONTACT_ICONS;
	
	__webpack_require__(1376);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    CustomDialog = __webpack_require__(26),
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    Stamps = __webpack_require__(154),
	    Stamp = __webpack_require__(131),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var CONTACT_ICONS = (_CONTACT_ICONS = {}, _CONTACT_ICONS['PHONE'] = 'phone', _CONTACT_ICONS['EMAIL'] = 'email', _CONTACT_ICONS);
	
	var VendorAdmin = React.createClass({ displayName: "VendorAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedVendor: null
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchVendor();
	        ga.pageview('/vendors-admin');
	    },
	    fetchVendor: function fetchVendor() {
	        var self = this;
	        InventoryStore.fetchVendor(function (vendors) {
	            self.setState({
	                vendors: vendors
	            });
	        });
	    },
	    _goToAddress: function _goToAddress() {
	        this.transitionTo('/vendors/:vendorId/addresses', {
	            vendorId: get(this.state, 'selectedItem.id')
	        }, {
	            companyName: get(this.state, 'selectedItem.companyName')
	        });
	    },
	    _goToContacts: function _goToContacts() {
	        this.transitionTo('/vendors/:vendorId/contacts', {
	            vendorId: get(this.state, 'selectedItem.id')
	        }, {
	            companyName: get(this.state, 'selectedItem.companyName')
	        });
	    },
	    _goToItems: function _goToItems() {
	        this.transitionTo('/vendors/:vendorId/items', {
	            vendorId: get(this.state, 'selectedItem.id')
	        }, {
	            companyName: get(this.state, 'selectedItem.companyName')
	        });
	    },
	    _onDeleteVendor: function _onDeleteVendor(vendorId, onSuccess, onFailure) {
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_admin_confirm_delete_supplier'), function () {
	            InventoryStore.deleteVendor(vendorId, onSuccess, onFailure);
	        });
	    },
	    _onChangeVendor: function _onChangeVendor(vendor, onSuccess, onFailure) {
	        InventoryStore.changeVendor(vendor, onSuccess, onFailure);
	    },
	    _onAddVendor: function _onAddVendor(vendor, onSuccess, onFailure) {
	        InventoryStore.addVendor(vendor, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: item,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{
	            displayName: t('dashboard_sidebar_suppliers')
	        }];
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _getStampsIcons: function _getStampsIcons(contacts) {
	        return React.createElement(Stamps, null, map(contacts, function (contact) {
	            return React.createElement("span", { className: "bp-vendor-admin__contact" }, React.createElement(Stamp, {
	                icon: CONTACT_ICONS[get(contact, 'type')],
	                classNameIcon: "material-icons",
	                className: "bp-vendor-admin__contact-icon" }), React.createElement("div", { className: "bp-vendor-admin__contact-label ellipsis" }, get(contact, 'contactInfo')));
	        }));
	    },
	    render: function render() {
	        var _state = this.state,
	            vendors = _state.vendors,
	            selectedItem = _state.selectedItem;
	
	        if (!vendors) {
	            return React.createElement(Loading, null);
	        } else {
	
	            var messages = {
	                changeSuccessMessage: t('vendor_admin_change_success_message'),
	                changeFailureMessage: t('vendor_admin_change_failure_message'),
	                deleteSuccessMessage: t('vendor_admin_delete_success_message'),
	                addSuccessMessage: t('vendor_admin_add_success_message'),
	                addFailureMessage: t('vendor_admin_add_failure_message')
	            };
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_label_set_address'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToAddress.bind(this) })
	            }, {
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_address_set_contacts'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToContacts.bind(this) })
	            }, {
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_set_items'),
	                    icon: "subdirectory_arrow_right",
	                    type: "icon",
	                    onClick: this._goToItems.bind(this) })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "companyName",
	                isRequired: true,
	                name: t('vendor_admin_label_company_name'),
	                value: selectedItem,
	                label: t('vendor_admin_label_company_name'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "dueDate",
	                isRequired: true,
	                name: t('vendor_admin_label_due_date'),
	                value: selectedItem,
	                label: t('vendor_admin_label_due_date'),
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "termsDate",
	                isRequired: true,
	                name: t('vendor_admin_label_terms'),
	                value: selectedItem,
	                label: t('vendor_admin_label_terms'),
	                /* additionalValidation={inputValue =>
	                    NumberUtils.isNumber(inputValue)
	                        ? ''
	                        : t('vendor_admin_must_be_number')} */
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('vendor_admin_title_suppliers'),
	                moduleName: "ADMIN_VENDOR",
	                onAddText: t('vendor_admin_label_associate'),
	                onDeleteText: t('vendor_admin_label_disassociate'),
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchVendor,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddVendor,
	                onChange: this._onChangeVendor,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteVendor,
	                additionalButtons: additionalButtons,
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['companyName'],
	                filteredColumns: ['companyName', 'contacts', 'dueDate', 'termsDate'],
	                columnNames: [t('vendor_admin_label_company_name'), t('vendor_admin_column_name_contacts'), t('vendor_admin_label_due_date'), t('vendor_admin_label_terms')],
	                displayAttributes: ['companyName', {
	                    name: 'contacts',
	                    getHTML: this._getStampsIcons
	                }, 'dueDate', 'termsDate']
	            }, vendors)));
	        }
	    }
	});
	
	module.exports = VendorAdmin;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AdminScaffolding = __webpack_require__(39),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    AppConstants = __webpack_require__(2),
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    _require2 = __webpack_require__(19),
	    Navigation = _require2.Navigation,
	    ga = __webpack_require__(18);
	
	
	var VendorContactAdmin = React.createClass({ displayName: "VendorContactAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            isEditMode: false,
	            selectedVendor: null,
	            companyName: NavigationUtils.getQueryParam('companyName')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchVendor();
	        ga.pageview('/vendor-contact-admin');
	    },
	    fetchVendor: function fetchVendor() {
	        var self = this;
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        InventoryStore.fetchVendorContacts(vendorId, function (contacts) {
	            self.setState({
	                contacts: contacts
	            });
	        });
	    },
	    _backToVendor: function _backToVendor() {
	        this.transitionTo('/vendors');
	    },
	    _onDeleteContact: function _onDeleteContact(contactId, onSuccess, onFailure) {
	        var vendorId = get(this.state, 'selectedItem.vendor.id');
	        InventoryStore.deleteVendorContact(vendorId, contactId, onSuccess, onFailure);
	    },
	    _goToAddress: function _goToAddress() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/addresses', { vendorId: vendorId }, { companyName: companyName });
	    },
	    _goToSetItems: function _goToSetItems() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/items', { vendorId: vendorId }, { companyName: companyName });
	    },
	    _onChangeContact: function _onChangeContact(contact, onSuccess, onFailure) {
	        InventoryStore.changeVendorContact(NavigationUtils.getPathParam('vendors'), contact, onSuccess, onFailure);
	    },
	    _onAddContact: function _onAddContact(contact, onSuccess, onFailure) {
	        InventoryStore.addVendorContact(NavigationUtils.getPathParam('vendors'), contact, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(item, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: item,
	            isEditMode: !!item,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset is outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ link: 'vendors', displayName: t('dashboard_sidebar_suppliers') }, { displayName: get(this.state, 'companyName') }];
	    },
	    render: function render() {
	        var _state = this.state,
	            contacts = _state.contacts,
	            selectedItem = _state.selectedItem,
	            isEditMode = _state.isEditMode;
	
	
	        if (!contacts) {
	            return React.createElement(Loading, null);
	        } else {
	
	            var currentSelectedSection = selectedItem && selectedItem.type ? AppConstants.getContactMapping(t)[selectedItem.type] : '';
	
	            var currentSelectedValueHydrated = currentSelectedSection ? _extends({}, selectedItem, { displayText: currentSelectedSection }) : selectedItem;
	
	            var messages = {
	                changeSuccessMessage: t('vendor_contact_change_success_message'),
	                changeFailureMessage: t('vendor_contact_change_failure_message'),
	                deleteSuccessMessage: t('vendor_contact_delete_success_message'),
	                addSuccessMessage: t('vendor_contact_add_success_message'),
	                addFailureMessage: t('vendor_contact_add_failure_message')
	            };
	            var contextHolder = this.getContextHolderInstance();
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_label_set_address'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToAddress })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_set_items'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToSetItems })
	            }];
	
	            var formFieldsEl = [React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                isRequired: true,
	                isRelaxedText: true,
	                name: t('label_name'),
	                value: selectedItem,
	                label: t('vendor_contact_label_contact_name'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupDropdown, {
	                items: AppConstants.getContacts(t),
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                customReaderWriterAttribute: "type",
	                writerAttribute: "type",
	                name: t('label_type'),
	                label: t('vendor_contact_label_type'),
	                value: currentSelectedValueHydrated || 'EMAIL',
	                isRequired: true,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "contactInfo",
	                isRequired: true,
	                isRelaxedText: true,
	                name: t('vendor_contact_label_contact_info'),
	                value: selectedItem,
	                label: t('vendor_contact_label_contact_info'),
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "brewhouse-view" }, React.createElement(AdminScaffolding, {
	                title: t('vendor_contact_title_supplier_contacts'),
	                moduleName: "ADMIN_VENDOR_CONTACT",
	                messages: messages,
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchVendor,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddContact,
	                onAddText: t('vendor_contact_label_add'),
	                onChange: this._onChangeContact,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteContact,
	                additionalButtons: additionalButtons,
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                headerActiveFilters: this.state.headerActiveFilters,
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['name', 'contactInfo'],
	                sortByColumn: ['displayType'],
	                columnNames: [t('vendor_contact_label_contact_name'), t('vendor_contact_label_type'), t('vendor_contact_label_contact_info')],
	                displayAttributes: ['name', 'displayType', 'contactInfo']
	            }, contacts.map(function (contact) {
	                contact.displayType = AppConstants.getContactMapping(t)[contact.type];
	                return contact;
	            }))));
	        }
	    }
	});
	
	module.exports = VendorContactAdmin;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    AdminScaffolding = __webpack_require__(39),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Loading = __webpack_require__(33),
	    NavigationUtils = __webpack_require__(35),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Authentication = __webpack_require__(13).Authentication,
	    InventoryStore = __webpack_require__(20),
	    get = __webpack_require__(5).get,
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    PurchaseOrderUtils = __webpack_require__(186),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    find = _require2.find,
	    filter = _require2.filter,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    ga = __webpack_require__(18);
	
	
	var VendorItemAdmin = React.createClass({ displayName: "VendorItemAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            selectedVendor: null,
	            companyName: NavigationUtils.getQueryParam('companyName')
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchVendorItems();
	        ga.pageview('/vendor-item-admin');
	    },
	    fetchVendorItems: function fetchVendorItems() {
	        var self = this;
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        InventoryStore.fetchVendorItems(vendorId, function (vendorItems) {
	            InventoryStore.fetchAllItems(function (items) {
	                var currencyInfo = NumberUtils.getCurrentCurrency();
	                self.setState({
	                    vendorItems: ContentUtils.filterEnable(self._decoratorVendorItems(vendorItems)),
	                    items: ContentUtils.filterEnable(items),
	                    currentCurrency: get(currencyInfo, 'symbol')
	                });
	            });
	        });
	    },
	    _decoratorVendorItems: function _decoratorVendorItems(vendorItems) {
	        return map(vendorItems, function (vendorItem) {
	            vendorItem.code = get(vendorItem, 'supplierCode') || get(vendorItem, 'item.code');
	            vendorItem.unit = get(vendorItem, 'supplierUnit') || get(vendorItem, 'item.unit');
	            vendorItem.priceUnitDisplay = NumberUtils.formatCurrency(PurchaseOrderUtils.getPriceOfPurchaseItem(vendorItem), +get(SessionStore.getCurrentCurrencyDigits(), 'value')) + ' /' + get(vendorItem, 'unit');
	            return vendorItem;
	        });
	    },
	    _backToVendor: function _backToVendor() {
	        this.transitionTo('/vendors');
	    },
	    _onDeleteVendorItem: function _onDeleteVendorItem(itemId, onSuccess, onFailure) {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        InventoryStore.deleteVendorItem(vendorId, itemId, onSuccess, onFailure);
	        this._clean();
	    },
	    _onChangeVendorItem: function _onChangeVendorItem(item, onSuccess, onFailure) {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var itemId = item.itemId;
	        InventoryStore.changeVendorItem(vendorId, itemId, item, onSuccess, onFailure);
	        this.setState(_extends(this.getInitialState(), { selectedItem: item }));
	    },
	    _onAddVendorItem: function _onAddVendorItem(item, onSuccess, onFailure) {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var itemId = item.itemId;
	        InventoryStore.addVendorItem(vendorId, itemId, item, onSuccess, onFailure);
	        this._clean();
	    },
	    _onRowSelection: function _onRowSelection(selectedItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: selectedItem,
	            isEditMode: !!selectedItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this._clean();
	    },
	    _clean: function _clean() {
	        this.setState({
	            preSelectedItem: null,
	            selectedItem: null,
	            selectedItemDropDown: null
	        });
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ link: 'vendors', displayName: t('vendor_admin_title_suppliers') }, { displayName: get(this.state, 'companyName') }];
	    },
	    _onChangeItem: function _onChangeItem(evt, index, selectedItemDropdown) {
	        var items = this.state.items;
	
	        var selectedItem = find(items, function (item) {
	            return get(selectedItemDropdown, 'itemModel.id') === get(item, 'id');
	        });
	        this.setState({
	            selectedItemDropDown: selectedItem
	        });
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _onBlurSelectedItem: function _onBlurSelectedItem(preSelectedVendorItem) {
	        if (preSelectedVendorItem) {
	            this.setState(function (prevState) {
	                if (prevState.selectedItem) {
	                    return {
	                        preSelectedItem: _extends(prevState.selectedItem, preSelectedVendorItem)
	                    };
	                } else {
	                    return {
	                        preSelectedItem: preSelectedVendorItem
	                    };
	                }
	            });
	        }
	    },
	    _goToContacts: function _goToContacts() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/contacts', { vendorId: vendorId }, { companyName: companyName });
	    },
	    _goToAddress: function _goToAddress() {
	        var vendorId = NavigationUtils.getPathParam('vendors');
	        var companyName = NavigationUtils.getQueryParam('companyName');
	        this.transitionTo('/vendors/:vendorId/addresses', { vendorId: vendorId }, { companyName: companyName });
	    },
	    render: function render() {
	        var _state = this.state,
	            items = _state.items,
	            vendorItems = _state.vendorItems,
	            selectedItem = _state.selectedItem,
	            currentCurrency = _state.currentCurrency;
	
	        if (!items) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('vendor_item_change_success_message'),
	                changeFailureMessage: t('vendor_item_change_failure_message'),
	                deleteSuccessMessage: t('vendor_item_delete_success_message'),
	                addSuccessMessage: t('vendor_item_add_success_message'),
	                addFailureMessage: t('vendor_item_add_failure_message')
	            };
	            var preSelectedItem = this.state.preSelectedItem;
	
	
	            var relativeUnitAmountLabelDisplay = void 0;
	            var unit = void 0;
	            if (selectedItem) {
	                unit = getUnitFromVendorItem(selectedItem);
	                relativeUnitAmountLabelDisplay = t('label_amount') + ' (' + get(selectedItem, 'item.unit') + ') ' + t('per') + ' (' + unit + ')';
	            } else {
	                unit = get(preSelectedItem, 'supplierUnit') || get(preSelectedItem, 'unit');
	                relativeUnitAmountLabelDisplay = t('label_amount') + ' ' + (String(unit) === 'undefined' ? '' : '(' + unit + ')') + ' ' + t('vendor_item_label_per_supplier_unit');
	            }
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_label_set_address'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToAddress })
	            }, {
	                type: 'NEW',
	                permission: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_admin_address_set_contacts'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._goToContacts })
	            }];
	
	            var contextHolder = this.getContextHolderInstance();
	
	            var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	                onBlur: this._onBlurSelectedItem,
	                operationsHolder: contextHolder,
	                isImmutable: true,
	                items: items,
	                isEditMode: !!(get(selectedItem, 'item') || preSelectedItem),
	                itemsDisabled: filterItemsAlreadyInUse(items, vendorItems),
	                readerAttribute: "description",
	                readerAttributeValue: "id",
	                writerAttribute: "itemId",
	                name: t('item'),
	                value: get(selectedItem, 'item') || preSelectedItem,
	                onChange: this._onChangeItem,
	                onEnter: this._onEnterPress,
	                label: t('vendor_item_label_write_item_name') }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "supplierCode",
	                name: t('vendor_item_label_supplier_code'),
	                isRequired: false,
	                value: selectedItem,
	                isRelaxedText: true,
	                decimalDigits: 4,
	                onEnter: this._onEnterPress,
	                label: t('vendor_item_label_supplier_code') }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "supplierUnit",
	                isRequired: true,
	                name: t('vendor_item_label_supplier_unit'),
	                value: selectedItem,
	                isRelaxedText: true,
	                onEnter: this._onEnterPress,
	                label: t('vendor_item_label_supplier_unit') }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "priceUnit",
	                isRequired: false,
	                name: t('vendor_item_label_price'),
	                value: selectedItem,
	                isRelaxedText: true,
	                decimalDigits: 4,
	                isDecimalFormat: true,
	                onEnter: this._onEnterPress,
	                label: t('vendor_item_label_price') + ' (' + currentCurrency + ') ' + t('vendor_item_label_per_supplier_unit') }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "relativeUnitAmount",
	                isRequired: false,
	                name: relativeUnitAmountLabelDisplay,
	                value: selectedItem || '1',
	                isRelaxedText: true,
	                decimalDigits: 4,
	                isDecimalFormat: true,
	                onEnter: this._onEnterPress,
	                label: relativeUnitAmountLabelDisplay }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "minimumOrder",
	                isRequired: true,
	                name: t('vendor_item_column_name_minimum_order'),
	                value: selectedItem,
	                onEnter: this._onEnterPress,
	                label: '' + t('vendor_item_column_name_minimum_order') }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "arrivalDays",
	                isRequired: true,
	                name: t('vendor_item_label_arrival_days'),
	                value: selectedItem,
	                label: t('vendor_item_label_arrival_days'),
	                onEnter: this._onEnterPress })];
	
	            return React.createElement("div", { className: "bp-vendor-items-view" }, React.createElement(AdminScaffolding, {
	                title: t('vendor_item_title_supplier_items'),
	                moduleName: "ADMIN_VENDOR_ITEMS",
	                messages: messages,
	                onAddText: t('vendor_admin_label_associate'),
	                onDeleteText: t('vendor_admin_label_disassociate'),
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchVendorItems,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddVendorItem,
	                onChange: this._onChangeVendorItem,
	                onCancel: this._onCancel,
	                onDelete: this._onDeleteVendorItem,
	                addEnterKeyDown: this._addEnterKeyDown,
	                additionalButtons: additionalButtons,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: ['priceUnit'],
	                filteredColumns: ['code', 'unit', 'item.description', 'priceUnitDisplay', 'relativeUnitAmount', 'minimumOrder', 'arrivalDays'],
	                columnNames: [t('vendor_item_label_supplier_code'), t('vendor_item_label_supplier_unit'), t('item'), t('vendor_item_column_name_price_per_unit'), t('vendor_item_column_name_relative_unit_amount'), t('vendor_item_column_name_minimum_order'), t('vendor_item_label_arrival_day'), t('vendor_item_column_name_preferred')],
	                displayAttributes: ['code', 'unit', 'item.description', 'priceUnitDisplay', 'relativeUnitAmount', 'minimumOrder', 'arrivalDays']
	            }, vendorItems)));
	        }
	    }
	});
	
	function filterItemsAlreadyInUse(items, vendorItems) {
	    var itemIdsAlreadyInUse = map(vendorItems, function (vendorItem) {
	        return get(vendorItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	function getUnitFromVendorItem(vendorItem) {
	    return get(vendorItem, 'supplierUnit') || get(vendorItem, 'item.unit');
	}
	
	module.exports = VendorItemAdmin;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1377);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    DateUtils = __webpack_require__(22),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    find = _require2.find,
	    SessionStore = __webpack_require__(11),
	    FlatSphere = __webpack_require__(400),
	    Notification = __webpack_require__(21),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTablePaged = __webpack_require__(178),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupDropdown = __webpack_require__(58),
	    FormGroupButton = __webpack_require__(30),
	    Loading = __webpack_require__(33),
	    ContentUtils = __webpack_require__(7),
	    NavigationUtils = __webpack_require__(35),
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    NumberUtils = __webpack_require__(23),
	    PurchaseOrderUtils = __webpack_require__(186),
	    AppConstants = __webpack_require__(2),
	    InventoryStore = __webpack_require__(20),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    get = __webpack_require__(5).get,
	    CustomDialog = __webpack_require__(26);
	
	
	var pageUrl = '/purchase-item/page/';
	
	var VendorPurchaseAdmin = React.createClass({ displayName: "VendorPurchaseAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	
	        return {
	            selectedItem: null,
	            isEditMode: false,
	            isFetching: true,
	            filter: {
	                code: '',
	                companyName: '',
	                displayDateOpen: '',
	                displayEstimatedDateArrive: '',
	                state: '',
	                amountPaid: '',
	                estimatedPricesWithCurrency: '',
	                daysLeft: ''
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchPurchases();
	        ga.pageview('/vendor-purchase-admin');
	    },
	    fetchPurchases: function fetchPurchases() {
	        var self = this;
	        var currentPage = NavigationUtils.getPathParam('page');
	        InventoryStore.fetchLocation(function (locations) {
	            InventoryStore.fetchVendor(function (vendors) {
	                InventoryStore.fetchVendorPurchasesWithTotalPrice(currentPage, function (purchases) {
	                    self.setState({
	                        purchases: ContentUtils.filterEnable(self._sortPurchaseOrder(self._hydrateAdditionalInfo(purchases, locations))),
	                        vendors: ContentUtils.filterEnable(vendors),
	                        locations: ContentUtils.filterEnable(locations),
	                        isFetching: false
	                    });
	                });
	            });
	        });
	    },
	    _onClickPage: function _onClickPage(page) {
	        this.transitionTo('/purchase-item/page/:page', { page: page });
	        this.fetchPurchases();
	    },
	    fetchPurchasesBy: function fetchPurchasesBy(filter) {
	        var self = this;
	        InventoryStore.fetchVendor(function (vendors) {
	            InventoryStore.fetchVendorPurchasesBy(filter, function (purchases) {
	                self.setState({
	                    purchases: ContentUtils.filterEnable(self._sortPurchaseOrder(self._hydrateAdditionalInfo(purchases))),
	                    vendors: ContentUtils.filterEnable(vendors),
	                    isFetching: false
	                });
	            });
	        });
	    },
	    _hydrateAdditionalInfo: function _hydrateAdditionalInfo(purchases, locations) {
	        return map(purchases, function (purchase) {
	            // estimate date arrive
	            // format date properly
	            purchase.displayDateOpen = DateUtils.toCurrentTimeZone(purchase.openDate, SessionStore.getCurrentTimeZone());
	            if (purchase.latestArrivalDate) {
	                purchase.displayEstimatedDateArrive = DateUtils.toDateText(purchase.latestArrivalDate);
	                purchase.daysLeft = PurchaseOrderUtils.getDaysLeftToBeReceivedFromPurchaseOrder(purchase, t);
	            }
	            // add currency to estimate purchase price
	            purchase.estimatedPricesWithCurrency = get(SessionStore.getCurrentCurrency(), 'symbol') + ' ' + (NumberUtils.formatDecimal(purchase.totalPurchasePrice, get(SessionStore.getCurrentCurrencyDigits(), 'value')) || NumberUtils.formatDecimal(0, get(SessionStore.getCurrentCurrencyDigits(), 'value')));
	            purchase.shipTo = find(locations, function (location) {
	                return location.id === purchase.shipToId;
	            });
	            purchase.amountPaid = purchase.amountPaid ? NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(purchase.amountPaid, get(SessionStore.getCurrentCurrencyDigits(), 'value')) : NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(purchase.totalPurchasePrice, get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	            return purchase;
	        });
	    },
	    _sortPurchaseOrder: function _sortPurchaseOrder(purchases) {
	        return DateUtils.sortListByDateFieldDesc(purchases, 'dateCreated');
	    },
	    _getEarlyDate: function _getEarlyDate(purchaseItems) {
	        var sortedPurchaseItems = DateUtils.sortListByDateField(purchaseItems, 'dateRequested');
	        return get(sortedPurchaseItems, '0.openDate');
	    },
	    _onDeletePurchase: function _onDeletePurchase(purchase, onSuccess, onFailure) {
	        var selectedItem = this.state.selectedItem;
	
	        if (isRemovable(selectedItem)) {
	            CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_confirm_delete_purchase_order'), function () {
	                InventoryStore.deletePurchase(purchase, onSuccess, onFailure);
	            });
	        } else {
	            CustomDialog.showInfo(t('warning'), t('vendor_purchase_can_not_be_deleted'));
	        }
	    },
	    _onChangePurchase: function _onChangePurchase(purchase, onSuccess) {
	        InventoryStore.changeVendorPurchase(purchase, onSuccess, this._onFailure);
	    },
	    _onAddPurchase: function _onAddPurchase(purchase, onSuccess, onFailure) {
	        InventoryStore.addVendorPurchase(purchase, onSuccess, onFailure);
	    },
	    _onRowSelection: function _onRowSelection(purchase, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: purchase,
	            isEditMode: !!purchase,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _isClosed: function _isClosed() {
	        return get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE' || get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE_PAID' || get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED' || get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED_PAID' || get(this.state, 'selectedItem.state').indexOf('RECEIVED') > -1;
	    },
	    _isPaid: function _isPaid() {
	        return get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE_PAID' || get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED_PAID';
	    },
	    _goToSetItems: function _goToSetItems() {
	        this.transitionTo('purchase-item/:purchaseId/vendors/:vendorId', {
	            purchaseId: get(this.state, 'selectedItem.id'),
	            vendorId: get(this.state, 'selectedItem.vendorId')
	        }, {
	            companyName: get(this.state, 'selectedItem.companyName'),
	            code: get(this.state, 'selectedItem.code'),
	            isClosed: this._isClosed(),
	            comment: get(this.state, 'selectedItem.comment')
	        });
	    },
	    _goToReceive: function _goToReceive() {
	        this.transitionTo('purchase-item/:purchaseId/vendors/:vendorId/receive', {
	            purchaseId: get(this.state.selectedItem, 'id'),
	            vendorId: get(this.state, 'selectedItem.vendorId')
	        }, {
	            companyName: get(this.state, 'selectedItem.companyName'),
	            code: get(this.state, 'selectedItem.code'),
	            isClosed: this._isClosed()
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false,
	            filter: {
	                code: '',
	                state: '',
	                companyName: '',
	                displayDateOpen: '',
	                displayEstimatedDateArrive: '',
	                estimatedPricesWithCurrency: '',
	                amountPaid: '',
	                daysLeft: ''
	            }
	        });
	        this._onClickPage(0);
	    },
	    _onFailure: function _onFailure(messageInfo) {
	        if (messageInfo) {
	            var messageError = ContentUtils.formatMessageError(messageInfo);
	            Notification.show(messageError);
	        }
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ displayName: t('vendor_purchase_purchase_order') }];
	    },
	    _sendToProvider: function _sendToProvider() {
	        var _this2 = this;
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_confirm_supplier_notification'), function () {
	            InventoryStore.sendVendorPurchaseOrder(get(_this2.state.selectedItem, 'id'), _this2._onSuccessPurchaseItem, _this2._onFailurePurchaseItem);
	        });
	    },
	    _onSuccessPurchaseItem: function _onSuccessPurchaseItem() {
	        this.fetchPurchases(function () {
	            Notification.show(t('vendor_purchase_confirm_order_was_sent'), 'success');
	        });
	    },
	    _onFailurePurchaseItem: function _onFailurePurchaseItem(messageInfo) {
	        var _this3 = this;
	
	        if (messageInfo) {
	            var haveNotEmail = messageInfo.includes('0008');
	            if (haveNotEmail) {
	                CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_no_email_associated_with_vendor'), function () {
	                    _this3.transitionTo('/vendors/:vendorId/contacts', {
	                        vendorId: NavigationUtils.getPathParam('vendors')
	                    }, {
	                        companyName: NavigationUtils.getQueryParam('companyName')
	                    });
	                });
	            } else {
	                var messageError = ContentUtils.formatMessageError(messageInfo);
	                Notification.show(messageError);
	            }
	        }
	    },
	    _showIndicator: function _showIndicator(purchase, field) {
	        var colorFlat = 'red';
	
	        var statusKey = get(purchase, field || 'displayState');
	        var displayState = AppConstants.getPurchaseStateMapping(t)[statusKey];
	        var statePurchase = get(purchase, 'state');
	        var isRedState = AppConstants.PURCHASE_RED_STATE.includes(statePurchase);
	        var isYellowState = AppConstants.PURCHASE_YELLOW_STATE.includes(statePurchase);
	        var isGreenState = AppConstants.PURCHASE_GREEN_STATE.includes(statePurchase);
	
	        if (isRedState) {
	            colorFlat = 'red';
	        } else if (isYellowState) {
	            colorFlat = 'yellow';
	        } else if (isGreenState) {
	            colorFlat = 'green';
	        }
	        return React.createElement(FlatSphere, { bgColor: colorFlat, text: displayState });
	    },
	    _onDuplicate: function _onDuplicate(contextHolder) {
	        var _this4 = this;
	
	        // get value from all fields
	        var currentSelectedItem = contextHolder.getItem();
	
	        // set purchase id
	        currentSelectedItem.purchase = { id: this.state.selectedItem.id };
	
	        InventoryStore.duplicateVendorPurchase(currentSelectedItem, function () {
	            Notification.show(t('vendor_purchase_duplicated_purchase'), 'success');
	            _this4.fetchPurchases();
	        });
	    },
	    _onPaid: function _onPaid() {
	        var _this5 = this;
	
	        InventoryStore.markPaidVendorPurchase(this.state.selectedItem.id, function () {
	            _this5._isPaid() ? Notification.show(t('vendor_purchase_removed_paid') + " " + _this5.state.selectedItem.code, 'success') : Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + _this5.state.selectedItem.code + t('vendor_purchase_marked_paid'), 'success');
	            _this5.fetchPurchases();
	            _this5.state.selectedItem = null;
	        });
	    },
	    _onChangeAmount: function _onChangeAmount(purchase) {
	        this.state.amountPaid = purchase.target.value;
	    },
	    _amountValidation: function _amountValidation(inputValue) {
	        if (ContentUtils.isEmptyText(inputValue)) {
	            return '';
	        }
	        if (get(inputValue, 'length') > 17) {
	            return t('vendor_purchase_max_price');
	        }
	
	        switch (NumberUtils.getCurrentCurrency().decimalSeparator) {
	            case '.':
	                if (!/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(inputValue)) {
	                    return t('notification_error_invalid_character');
	                };
	                break;
	            case ',':
	                if (!/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(inputValue)) {
	                    return t('notification_error_invalid_character');
	                };
	                break;
	        }
	        /*if (+inputValue.split(",")[0] > +get(this.state.selectedItem, 'totalSalePrice') !== null ? +get(this.state.selectedItem, 'totalSalePrice').split(",")[0] : 0) {
	          return t('notification_error_invalid_character');
	        } */
	
	        return '';
	    },
	    saveNewAmount: function saveNewAmount() {
	        var value = get(this.state, 'amountPaid');
	
	        if (ContentUtils.isEmptyText(value)) {
	            value = get(this.state.selectedItem, 'totalPurchasePrice') ? get(this.state.selectedItem, 'totalPurchasePrice').replaceAll(".", ",") : "0,00";
	        }
	
	        switch (NumberUtils.getCurrentCurrency().decimalSeparator) {
	            case '.':
	                if (/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(value)) {
	                    InventoryStore.changeAmountPaidPO({
	                        id: get(this.state.selectedItem, 'id'),
	                        amountPaid: value
	                    }, this.onSuccess, this.__onFailureShowMessageError);
	                };
	                break;
	            case ',':
	                if (/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(value)) {
	                    InventoryStore.changeAmountPaidPO({
	                        id: get(this.state.selectedItem, 'id'),
	                        amountPaid: value
	                    }, this.onSuccess, this.__onFailureShowMessageError);
	                };
	                break;
	        }
	        this.fetchPurchases();
	        this._onCancel();
	    },
	    _onTypingFilter: function _onTypingFilter(name, match) {
	        var _this6 = this;
	
	        if (!this.state.isFetching) {
	            this.setState(function (prevState) {
	                var nextFilter = prevState.filter || {};
	                nextFilter[name] = match;
	                _this6.fetchPurchasesBy(nextFilter);
	                return {
	                    filter: nextFilter,
	                    isFetching: true
	                };
	            });
	        }
	    },
	    _commentValidation: function _commentValidation(comment) {
	        if (ContentUtils.isEmptyText(comment)) {
	            return '';
	        }
	
	        if (get(comment, 'length') >= 500) {
	            return t('vendor_purchase_max_amount_characters');
	        }
	
	        return '';
	    },
	    _printReport: function _printReport() {
	        InventoryStore.downloadReportXLS(this.state.filter, 'vendors/purchases');
	    },
	    render: function render() {
	        var _this7 = this;
	
	        if (!this.state.purchases) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('vendor_purchase_change_success_message'),
	                changeFailureMessage: t('vendor_purchase_change_failure_message'),
	                deleteSuccessMessage: t('vendor_purchase_delete_success_message'),
	                addSuccessMessage: t('vendor_purchase_add_success_message'),
	                addFailureMessage: t('vendor_purchase_add_failure_message')
	            };
	            var displayStateMapping = AppConstants.getPurchaseStateMapping(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state = this.state,
	                selectedItem = _state.selectedItem,
	                purchases = _state.purchases,
	                isEditMode = _state.isEditMode,
	                vendors = _state.vendors,
	                isFetching = _state.isFetching,
	                locations = _state.locations;
	
	            var stateSelected = get(selectedItem, 'state') || '';
	            var isClosed = stateSelected.includes('CLOSED');
	            var isReceived = stateSelected.includes('RECEIVED');
	            var purchaseWithDisplayText = (purchases || []).map(function (purchase) {
	                purchase.displayState = displayStateMapping[purchase.state];
	                if (purchase.latestArrivalDate) {
	                    purchase.daysLeft = PurchaseOrderUtils.getDaysLeftToBeReceivedFromPurchaseOrder(purchase, t);
	                }
	                return purchase;
	            });
	
	            var state = { 'state': [] };
	            if (displayStateMapping['OPEN'] !== undefined) {
	                Object.keys(displayStateMapping).forEach(function (e) {
	                    state['state'].push({ id: e, state: displayStateMapping[e] });
	                });
	            };
	
	            var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	                operationsHolder: contextHolder,
	                items: vendors,
	                readerAttribute: "companyName",
	                readerAttributeValue: "id",
	                writerAttribute: "vendor.id",
	                customErrorNonMatch: t('notification_supplier_name_required'),
	                label: t('vendor_purchase_label_supplier_name'),
	                name: t('vendor_purchase_label_supplier_name'),
	                value: get(selectedItem, 'vendor') || find(vendors, function (vendor) {
	                    return get(vendor, 'id') === get(selectedItem, 'vendorId');
	                }),
	                isImmutable: true,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupDropdown, {
	                items: locations,
	                operationsHolder: contextHolder,
	                readerAttribute: "name",
	                writerAttribute: "shipTo",
	                customReaderWriterAttribute: "id",
	                name: t('vendor_purchase_label_ship_to'),
	                label: t('vendor_purchase_label_ship_to'),
	                value: get(selectedItem, 'shipTo'),
	                isEditMode: isEditMode,
	                isRequired: true,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isRelaxedText: false,
	                additionalValidation: function additionalValidation(inputValue) {
	                    return _this7._amountValidation(inputValue);
	                },
	                noInternalValidation: true,
	                operationsHolder: contextHolder,
	                writerAttribute: "amountPaid",
	                name: t('sales_column_amount_paid'),
	                value: get(selectedItem, "amountPaid", '').replace("$ ", "").toString(),
	                label: t('sales_column_amount_paid'),
	                formatDecimal: get(SessionStore.getCurrentCurrencyDigits(), 'value'),
	                isEditMode: isEditMode,
	                isRequired: false,
	                onChange: this._onChangeAmount }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "comment",
	                name: t('comment'),
	                value: selectedItem,
	                label: t('comment'),
	                additionalValidation: this._commentValidation,
	                isRelaxedText: false,
	                noInternalValidation: true,
	                isEditMode: isEditMode,
	                isRequired: false,
	                onEnter: this._onEnterPress,
	                id: "comment" })];
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'VIEW_ORDER',
	                el: React.createElement(FormGroupButton, {
	                    label: isClosed || isReceived ? t('vendor_purchase_label_view_order') : t('vendor_purchase_label_edit_order'),
	                    icon: isClosed || isReceived ? 'visibility' : 'mode_edit',
	                    type: "icon",
	                    onClick: this._goToSetItems })
	            }, {
	                type: 'NEW',
	                permission: 'PRINT_REPORT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('vendor_purchase_label_print_report'),
	                    icon: "file_download",
	                    type: "icon",
	                    onClick: this._printReport })
	            }, {
	                type: 'NEW',
	                permission: 'CLEAR_FILTER',
	                el: React.createElement(FormGroupButton, {
	                    label: t('button_label_clear_filters'),
	                    icon: "clear",
	                    type: "icon",
	                    onClick: this._onCancel.bind() })
	            }];
	
	            if (selectedItem) {
	                var haveSomePurchaseItem = NumberUtils.isGreater(get(selectedItem, 'itemsAmount'), 0);
	                var haveSomePurchaseItemPending = selectedItem.state === 'OPEN_PENDING';
	                var isAlreadyNotified = selectedItem.state === 'OPEN_ORDERED' || selectedItem.state === 'ORDER_PARTIALLY_RECEIVED';
	
	                if (isAlreadyNotified) {
	                    additionalButtons.push({
	                        type: 'CHANGE',
	                        permission: 'VIEW_ORDER',
	                        el: React.createElement(FormGroupButton, {
	                            label: isClosed ? t('vendor_purchase_label_view_order') : t('vendor_purchase_label_receive_order'),
	                            icon: isClosed ? 'visibility' : 'local_shipping',
	                            type: "icon",
	                            onClick: this._goToReceive })
	                    });
	                }
	
	                if (!isClosed) {
	                    if (haveSomePurchaseItem && haveSomePurchaseItemPending) {
	                        additionalButtons.push({
	                            permission: 'SEND_PENDING_ORDER',
	                            type: 'CHANGE',
	                            el: React.createElement(FormGroupButton, {
	                                label: t('vendor_purchase_label_send_pending'),
	                                icon: "send",
	                                type: "icon",
	                                onClick: this._sendToProvider })
	                        });
	                    }
	                }
	
	                additionalButtons.push({
	                    type: 'CHANGE',
	                    permission: 'DUPLICATE',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('button_duplicate'),
	                        icon: "content_copy",
	                        type: "icon",
	                        onClick: this._onDuplicate.bind(this, contextHolder) })
	                });
	
	                additionalButtons.push({
	                    type: 'CHANGE',
	                    permission: 'MARK_PAID',
	                    el: this._isClosed() && React.createElement(FormGroupButton, {
	                        label: this._isPaid() ? t('button_revert_paid') : t('button_mark_paid'),
	                        icon: "paid",
	                        type: "icon",
	                        onClick: this._onPaid.bind() })
	                });
	
	                additionalButtons.push({
	                    type: 'CHANGE',
	                    permission: 'EDIT_ORDER',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('vendor_change_amount'),
	                        icon: 'mode_edit',
	
	                        type: "icon",
	                        onClick: this.saveNewAmount })
	                });
	            }
	
	            var totalPurchases = get(purchases, '0.count') || 0;
	
	            return React.createElement(AdminScaffolding, {
	                messages: messages,
	                moduleName: "ADMIN_PURCHASE",
	                additionalButtons: additionalButtons,
	                title: isEditMode ? t('vendor_purchase_title_button_edit_order') : t('vendor_purchase_title_button_new_order'),
	
	                contextHolder: contextHolder,
	                value: selectedItem,
	                onAddText: t('vendor_purchase_text_create'),
	                fetchItems: this.fetchPurchases,
	                headerFields: formFieldsEl,
	                onAdd: this._onAddPurchase,
	                onChange: this._onChangePurchase,
	                onCancel: this._onCancel,
	                onDelete: this._onDeletePurchase,
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement("div", { className: "admin-table-vendor-purchase-width" }, React.createElement(AdminScaffoldingTablePaged, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['code', 'companyName', 'state', 'displayDateOpen', 'displayEstimatedDateArrive', 'amountPaid', 'estimatedPricesWithCurrency', 'daysLeft'],
	                displayAttributes: ['code', 'companyName', {
	                    name: 'state',
	                    getHTML: this._showIndicator
	                }, 'displayDateOpen', 'displayEstimatedDateArrive', 'amountPaid', 'estimatedPricesWithCurrency', 'daysLeft'],
	                columnNames: [t('vendor_purchase_column_name_number'), t('vendor_purchase_column_name_supplier'), t('vendor_purchase_column_name_status'), t('vendor_purchase_column_name_created'), t('vendor_purchase_column_name_arrive'), t('vendor_purchase_column_amount_paid'), t('vendor_purchase_column_name_price'), t('vendor_purchase_column_name_days_left')],
	                isLoading: isFetching,
	                maxPage: ContentUtils.getAmountPageNeeded(totalPurchases, AppConstants.MAX_ITEMS_BY_PAGES_ADMINS),
	                onClickPage: this._onClickPage,
	                currentPage: NavigationUtils.getPathParam('page'),
	                columnsFilterValue: this.state.filter,
	                onCancel: this._onCancel,
	                onTypingFilter: this._onTypingFilter,
	                items: state
	            }, ContentUtils.filterEnable(purchaseWithDisplayText))));
	        }
	    }
	});
	function getCurrentUrl() {
	    return pageUrl + NavigationUtils.getPathParam('page');
	}
	function isRemovable(selectedPurchase) {
	    var statePurchase = get(selectedPurchase, 'state');
	    return AppConstants.PURCHASE_STATES_REMOVABLE.includes(statePurchase);
	}
	
	module.exports = VendorPurchaseAdmin;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    SessionStore = __webpack_require__(11),
	    Notification = __webpack_require__(21),
	    AdminScaffolding = __webpack_require__(39),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    Loading = __webpack_require__(33),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    InventoryStore = __webpack_require__(20),
	    NavigationUtils = __webpack_require__(35),
	    AppConstants = __webpack_require__(2),
	    PurchaseOrderUtils = __webpack_require__(186),
	    DateUtils = __webpack_require__(22),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    filter = _require2.filter,
	    some = _require2.some,
	    _require3 = __webpack_require__(48),
	    concat = _require3.concat,
	    get = __webpack_require__(5).get,
	    set = __webpack_require__(5).set,
	    _require4 = __webpack_require__(19),
	    Navigation = _require4.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var VendorPurchaseItemAdmin = React.createClass({ displayName: "VendorPurchaseItemAdmin",
	
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            purchaseId: NavigationUtils.getPathParam('purchase-item'),
	            vendorId: NavigationUtils.getPathParam('vendors'),
	            companyName: NavigationUtils.getQueryParam('companyName'),
	            isClosedOrder: NavigationUtils.getQueryParam('isClosed') !== 'false',
	            comment: NavigationUtils.getQueryParam('comment'),
	            selectedItem: null,
	            isEditMode: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchPurchases();
	        ga.pageview('/vendor-purchase-item-admin');
	    },
	    _backToVendor: function _backToVendor() {
	        this.transitionTo('/purchase-item/page/:page', { page: 0 });
	    },
	    fetchPurchases: function fetchPurchases(callBack) {
	        var _state = this.state,
	            purchaseId = _state.purchaseId,
	            vendorId = _state.vendorId;
	
	        var self = this;
	        InventoryStore.fetchVendorItems(vendorId, function (vendorItems) {
	            InventoryStore.fetchNonInventoryItems(function (items) {
	                InventoryStore.fetchVendorPurchasesItem(purchaseId, function (purchases) {
	                    self.setState({
	                        purchases: ContentUtils.filterEnable(self._hydratePurchasesWithExtraInfo(purchases)),
	                        vendorItems: concat(ContentUtils.filterEnable(vendorItems), adaptNonInventoryItemToVendorItem(filterExistingNonInventoryItems(items, vendorItems)))
	                    }, function () {
	                        if (callBack) {
	                            callBack();
	                        }
	                    });
	                });
	            });
	        });
	    },
	    _hydratePurchasesWithExtraInfo: function _hydratePurchasesWithExtraInfo(purchases) {
	        return map(purchases, function (purchase) {
	            if (purchase.customArrivalDays) {
	
	                var unit = getUnitFromVendorItem(get(purchase, 'vendorItem'));
	                purchase.amountWithUnit = NumberUtils.formatDecimal(purchase.amountRequested, get(SessionStore.getCurrentCurrencyDigits(), 'value')) + ' ' + unit;
	
	                purchase.amountReceivedWithUnit = NumberUtils.formatDecimal(purchase.totalAmountReceived, get(SessionStore.getCurrentCurrencyDigits(), 'value')) + ' ' + unit;
	
	                var costVendorPurchaseItem = PurchaseOrderUtils.getPriceOfPurchaseItem(purchase);
	                purchase.priceUnitWithCurrency = NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(costVendorPurchaseItem, get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	                purchase.totalPriceUnitWithCurrency = NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(NumberUtils.multiply(get(purchase, 'totalAmountReceived') || get(purchase, 'amountRequested'), costVendorPurchaseItem), get(SessionStore.getCurrentCurrencyDigits(), 'value'));
	
	                purchase.dateReceivedDate = DateUtils.toCurrentTimeZone(PurchaseOrderUtils.getLastReceivedDateFromPurchaseOrderItem(purchase), SessionStore.getCurrentTimeZone());
	
	                return set(purchase, 'vendorItem.arrivalDays', get(purchase, 'customArrivalDays'));
	            }
	            return purchase;
	        });
	    },
	    _onDeletePurchase: function _onDeletePurchase(purchase, onSuccess, onFailure) {
	        var selectedPurchaseItem = get(this.state, 'selectedItem');
	        if (!PurchaseOrderUtils.isAbleToChangeVendorPurchaseItem(selectedPurchaseItem)) {
	            Notification.show(t('vendor_purchase_item_sent_cannot_deleted'));
	            return;
	        }
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_item_confirm_delete'), function () {
	            InventoryStore.deletePurchaseItem(purchase, onSuccess, onFailure);
	        });
	    },
	    _onChangePurchase: function _onChangePurchase(purchase, onSuccess) {
	        purchase.amountRequested = NumberUtils.standardiseDecimalFormatNumber(purchase.amountRequested);
	        InventoryStore.changeVendorPurchaseItem(purchase, onSuccess, this._onFailurePurchaseItem);
	        this.setState({
	            preSelectedItem: null
	        });
	    },
	    _onAddPurchase: function _onAddPurchase(purchase, onSuccess, onFailure) {
	        purchase.vendorId = NavigationUtils.getPathParam('vendors');
	        purchase.purchaseId = NavigationUtils.getPathParam('purchase-item');
	        purchase.amountRequested = NumberUtils.standardiseDecimalFormatNumber(purchase.amountRequested);
	        InventoryStore.addVendorPurchaseItem(purchase, onSuccess, onFailure);
	        this.setState({
	            preSelectedItem: null
	        });
	    },
	    _onRowSelection: function _onRowSelection(selectedItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this = this;
	
	        this.setState({
	            selectedItem: selectedItem,
	            isEditMode: !!selectedItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    _onFailurePurchaseItem: function _onFailurePurchaseItem(messageInfo) {
	        var _this2 = this;
	
	        if (messageInfo) {
	            var haveNotEmail = messageInfo.includes('0008');
	            if (haveNotEmail) {
	                CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_item_no_email_associated_add_email'), function () {
	                    _this2.transitionTo('/vendors/:vendorId/contacts', {
	                        vendorId: NavigationUtils.getPathParam('vendors')
	                    }, {
	                        companyName: NavigationUtils.getQueryParam('companyName')
	                    });
	                });
	            } else {
	                var messageError = ContentUtils.formatMessageError(messageInfo);
	                Notification.show(messageError);
	            }
	        }
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ link: '/purchase-item/page/0', param: { page: 0 }, displayName: t('vendor_purchase_item_label') }, { displayName: NavigationUtils.getQueryParam('code') }];
	    },
	    _backToPurchaseItem: function _backToPurchaseItem() {
	        this.transitionTo('/purchase-item/page/:page', { page: 0 });
	    },
	    _amountValidation: function _amountValidation(inputValue) {
	        var result = NumberUtils.isNumber(NumberUtils.standardiseDecimalFormatNumber(inputValue)) ? '' : t('vendor_purchase_item_amount_must_be_number');
	        var isNumber = result === '';
	
	        if (isNumber) {
	            var minimumOrder = get(this.state, 'selectedItem.vendorItem.minimumOrder') || get(this.state, 'preSelectedItem.minimumOrder');
	            var isAmountEnough = NumberUtils.isGreater(inputValue, minimumOrder) || NumberUtils.isEqual(inputValue, minimumOrder);
	            return isAmountEnough ? '' : t('vendor_purchase_item_amount_must_be_greater') + ' ' + minimumOrder;
	        }
	
	        return result;
	    },
	    _onBlurSelectedItem: function _onBlurSelectedItem(preSelectedVendorItem) {
	        if (preSelectedVendorItem) {
	            this.setState(function (prevState) {
	                if (prevState.selectedItem) {
	                    return {
	                        preSelectedItem: _extends(prevState.selectedItem, preSelectedVendorItem)
	                    };
	                } else {
	                    return {
	                        preSelectedItem: preSelectedVendorItem
	                    };
	                }
	            });
	        }
	    },
	    _sendToProvider: function _sendToProvider() {
	        var _this3 = this;
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_purchase_confirm_supplier_notification'), function () {
	            InventoryStore.sendVendorPurchaseOrder(_this3.state.purchaseId, _this3._onSuccessPurchaseItem, _this3._onFailurePurchaseItem);
	        });
	    },
	    _saveComment: function _saveComment() {
	        InventoryStore.saveCommentOnlyVendorPurchase(this.state.purchaseId, this.state.comment !== "" ? this.state.comment : "null");
	        Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.purchaseId + " " + t('updated'), 'success');
	    },
	    _onSuccessPurchaseItem: function _onSuccessPurchaseItem() {
	        this.fetchPurchases(function () {
	            Notification.show(t('vendor_purchase_confirm_order_was_sent'), 'success');
	        });
	    },
	    _showIndicator: function _showIndicator(purchase) {
	        var bgColor = get(purchase, 'state') === 'PENDING' ? 'red' : 'green';
	        return React.createElement("div", null, React.createElement("span", {
	            className: "text-center",
	            style: {
	                height: '20px',
	                borderRadius: '22px',
	                boxShadow: '1px 2px 4px 0px gray',
	                backgroundColor: bgColor,
	                border: 'solid 0px black',
	                padding: '10px 17px',
	                left: '0',
	                position: 'relative',
	                opacity: '.6'
	            } }), React.createElement("span", { style: { paddingLeft: '10px' } }, get(purchase, 'needConfirm')));
	    },
	    _commentValidation: function _commentValidation(inputValue) {
	        this.state.comment = inputValue;
	        if (ContentUtils.isEmptyText(this.state.comment)) {
	            return '';
	        }
	        if (get(this.state.comment, 'length') >= 200) {
	            return t('vendor_purchase_max_amount_characters');
	        }
	
	        return '';
	    },
	    _printPO: function _printPO() {
	        var code = NavigationUtils.getQueryParam('code');
	        InventoryStore.downloadReportXLS("", 'vendors/purchases/' + this.state.purchaseId);
	    },
	    render: function render() {
	        var _this4 = this;
	
	        var purchases = this.state.purchases;
	
	        if (!purchases) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('vendor_purchase_item_change_success_message'),
	                changeFailureMessage: t('vendor_purchase_item_change_failure_message'),
	                deleteSuccessMessage: t('vendor_purchase_item_delete_success_message'),
	                addSuccessMessage: t('vendor_purchase_item_add_success_message'),
	                addFailureMessage: t('vendor_purchase_item_add_failure_message')
	            };
	            var orderStateMapping = AppConstants.getPurchaseStateMapping(t);
	            var contextHolder = this.getContextHolderInstance();
	            var _state2 = this.state,
	                selectedItem = _state2.selectedItem,
	                _purchases = _state2.purchases,
	                isEditMode = _state2.isEditMode,
	                vendorItems = _state2.vendorItems,
	                preSelectedItem = _state2.preSelectedItem,
	                isClosedOrder = _state2.isClosedOrder,
	                companyName = _state2.companyName,
	                comment = _state2.comment;
	
	            var vendorItemPurchases = map(_purchases, function (purchase) {
	                return get(purchase, 'vendorItem');
	            });
	
	            var unit = void 0;
	
	            if (selectedItem) {
	                unit = getUnitFromVendorItem(get(selectedItem, 'vendorItem'));
	            } else {
	                unit = getUnitFromVendorItem(preSelectedItem);
	            }
	
	            var additionalButtons = [{
	                type: 'CHANGE',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'SHOW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToVendor })
	            }, {
	                type: 'NEW',
	                permission: 'PRINT_REPORT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('purchase_print'),
	                    icon: "file_download",
	                    type: "icon",
	                    onClick: this._printPO })
	            }];
	
	            // once have next state of MORE_ON_THE_WAY should not return ir
	            var currentStateItem = get(selectedItem, 'state', '');
	            var shouldBeImmutable = isClosedOrder || isEditMode && (currentStateItem === 'NO_MORE_ON_THE_WAY' || currentStateItem === 'REJECT_REMAINDER');
	
	            var unitWithParenthesis = unit ? '(' + unit + ')' : '(' + t('unit') + ')';
	
	            var formFieldsEl = [React.createElement(FormGroupTextFieldSuggested, {
	                isDisabled: shouldBeImmutable,
	                operationsHolder: contextHolder,
	                items: vendorItems,
	                readerAttribute: "item.description",
	                readerAttributeValue: "id",
	                writerAttribute: "vendorItemId",
	                itemsDisabled: filterItemsAlreadyInUse(vendorItems, vendorItemPurchases),
	                customErrorNonMatch: t('sales_items_error_non_match'),
	                name: t('item'),
	                isImmutable: true,
	                isEditMode: isEditMode,
	                label: t('item') + ' ' + unitWithParenthesis,
	                value: get(selectedItem, 'vendorItem') || preSelectedItem,
	                onBlur: this._onBlurSelectedItem,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isDisabled: shouldBeImmutable,
	                operationsHolder: contextHolder,
	                readerAttribute: "amountRequested",
	                additionalValidation: this._amountValidation,
	                name: t('vendor_item_label_amount'),
	                value: selectedItem,
	                label: t('vendor_item_label_amount') + ' ' + unitWithParenthesis,
	                isRelaxedText: true,
	                isDecimalFormat: false,
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                isDisabled: shouldBeImmutable,
	                operationsHolder: contextHolder,
	                displayAttribute: "vendorItem.arrivalDays",
	                readerAttribute: "vendorItem.arrivalDays",
	                writerAttribute: "customArrivalDays",
	                name: t('vendor_purchase_item_arrival_days'),
	                label: t('vendor_purchase_item_arrival_days'),
	                additionalValidation: function additionalValidation(inputValue) {
	                    return NumberUtils.isNumber(inputValue) ? NumberUtils.isGreater(inputValue, 0) ? '' : t('vendor_purchase_item_arrival_day_greater_zero') : t('vendor_purchase_item_arrival_days_must_be_number');
	                },
	                value: selectedItem || { vendorItem: preSelectedItem },
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }), React.createElement(FormGroupTextfield, {
	                operationsHolder: contextHolder,
	                readerAttribute: "comment",
	                name: t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + t('comment'),
	                value: this.state,
	                label: t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + t('comment'),
	                additionalValidation: function additionalValidation(inputValue) {
	                    return _this4._commentValidation(inputValue);
	                },
	                isRelaxedText: false,
	                noInternalValidation: true,
	                isEditMode: isEditMode,
	                isRequired: false,
	                onEnter: this._onEnterPress,
	                id: "comment" })];
	
	            var haveSomePurchaseItem = ContentUtils.isNotEmptyArray(_purchases);
	            var haveSomePurchaseItemPending = some(_purchases, function (purchase) {
	                return get(purchase, 'state') === 'PENDING';
	            });
	            var haveSomeNonPurchaseItemPending = some(_purchases, function (purchase) {
	                return get(purchase, 'state') !== 'PENDING';
	            });
	
	            if (!isClosedOrder && haveSomePurchaseItem && haveSomePurchaseItemPending) {
	                additionalButtons.push({
	                    type: 'NEW',
	                    permission: 'SEND_PENDING_ORDER',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('vendor_purchase_label_send_pending'),
	                        icon: "send",
	                        type: "icon",
	                        onClick: this._sendToProvider })
	                });
	            } else if (!isClosedOrder && haveSomePurchaseItem && haveSomeNonPurchaseItemPending) {
	                additionalButtons.push({
	                    type: 'CHANGE',
	                    permission: 'SEND_PENDING_ORDER',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('vendor_purchase_item_label_resend_pending'),
	                        icon: "send",
	                        type: "icon",
	                        onClick: this._sendToProvider })
	                });
	                additionalButtons.push({
	                    type: 'NEW',
	                    permission: 'SEND_PENDING_ORDER',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('vendor_purchase_item_label_resend_pending'),
	                        icon: "send",
	                        type: "icon",
	                        onClick: this._sendToProvider })
	                });
	            }
	
	            additionalButtons.push({
	                type: 'NEW',
	                permission: 'SAVE_COMMENT',
	                el: React.createElement(FormGroupButton, {
	                    label: t('button_label_save_comment'),
	                    icon: "save",
	                    type: "icon",
	                    onClick: this._saveComment })
	            });
	
	            return React.createElement(AdminScaffolding, {
	                messages: messages,
	                moduleName: "ADMIN_PURCHASE",
	                additionalButtons: additionalButtons,
	                title: isClosedOrder ? isIncompleteOrder(_purchases) ? t('vendor_purchase_item_state_closed_incomplete') : t('vendor_purchase_item_state_closed_complete') : t('vendor_purchase_item_order_from') + companyName,
	
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchPurchases,
	                headerFields: formFieldsEl,
	                onAdd: shouldBeImmutable || isClosedOrder ? undefined : this._onAddPurchase,
	
	                onChange: shouldBeImmutable || isClosedOrder ? undefined : this._onChangePurchase,
	
	                onCancel: this._onCancel,
	                onDelete: shouldBeImmutable || isClosedOrder ? undefined : this._onDeletePurchase,
	
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks(),
	                isDark: true
	            }, React.createElement(AdminScaffoldingTable, {
	                sortByColumn: "vendorItem.item.description",
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                filteredColumns: ['vendorItem.item.description', 'amountWithUnit', 'amountReceivedWithUnit', 'priceUnitWithCurrency', 'totalPriceUnitWithCurrency', 'dateReceivedDate', 'displayState', 'vendorItem.arrivalDays'],
	                displayAttributes: ['vendorItem.item.description', 'amountWithUnit', 'amountReceivedWithUnit', 'priceUnitWithCurrency', 'totalPriceUnitWithCurrency', 'dateReceivedDate', 'displayState', 'vendorItem.arrivalDays', {
	                    getHTML: this._showIndicator
	                }],
	                columnNames: [t('vendor_purchase_item_column_item'), t('vendor_purchase_item_column_amt_requested'), t('vendor_purchase_item_column_amt_received'), t('vendor_purchase_item_column_unit_price'), t('vendor_purchase_item_column_total_price'), t('vendor_purchase_item_column_date_received'), t('vendor_purchase_column_name_status'), t('vendor_item_label_arrival_days'), t('vendor_purchase_item_column_email_status')]
	            }, _purchases.map(function (purchase) {
	                purchase.displayState = orderStateMapping[purchase.state];
	                return purchase;
	            })));
	        }
	    }
	});
	
	function filterItemsAlreadyInUse(items, vendorItems) {
	    var itemIdsAlreadyInUse = map(vendorItems, function (vendorItem) {
	        return get(vendorItem, 'item.id');
	    }) || [];
	    var itemsFiltered = filter(items, function (item) {
	        return itemIdsAlreadyInUse.includes(get(item, 'item.id'));
	    });
	    var itemsMarked = map(itemsFiltered, function (item) {
	        item.isDisabled = true;
	        return item;
	    });
	
	    return itemsMarked;
	}
	
	function filterExistingNonInventoryItems(items, vendorItems) {
	    var alreadyExistingItemsId = map(vendorItems, function (vendorItem) {
	        return get(vendorItem, 'item.id');
	    }) || [];
	    return filter(items, function (item) {
	        return alreadyExistingItemsId.indexOf(get(item, 'id')) === -1;
	    });
	}
	
	function isIncompleteOrder(purchases) {
	    return some(purchases, function (purchase) {
	        return NumberUtils.isLess(get(purchase, 'totalAmountReceived'), get(purchase, 'amountRequested'));
	    });
	}
	
	function getUnitFromVendorItem(vendorItem) {
	    return get(vendorItem, 'supplierUnit') || get(vendorItem, 'item.unit');
	}
	
	function adaptNonInventoryItemToVendorItem() {
	    var nonInventoryItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return map(nonInventoryItems, function (nonInventoryItem) {
	        nonInventoryItem.item = {
	            id: nonInventoryItem.id,
	            description: nonInventoryItem.description
	        };
	        nonInventoryItem.minimumOrder = 1;
	        return nonInventoryItem;
	    });
	}
	
	module.exports = VendorPurchaseItemAdmin;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    AppConstants = __webpack_require__(2),
	    SessionStore = __webpack_require__(11),
	    Notification = __webpack_require__(21),
	    AdminScaffoldingGeneric = __webpack_require__(130),
	    AdminScaffoldingTable = __webpack_require__(41),
	    AdminScaffoldingContextHolder = __webpack_require__(29),
	    FormGroupTextfield = __webpack_require__(36),
	    FormGroupButton = __webpack_require__(30),
	    FormGroupDropdown = __webpack_require__(58),
	    Loading = __webpack_require__(33),
	    ContentUtils = __webpack_require__(7),
	    NumberUtils = __webpack_require__(23),
	    DateUtils = __webpack_require__(22),
	    PurchaseOrderUtils = __webpack_require__(186),
	    InventoryStore = __webpack_require__(20),
	    NavigationUtils = __webpack_require__(35),
	    FormGroupTextFieldSuggested = __webpack_require__(71),
	    Authentication = __webpack_require__(13).Authentication,
	    ga = __webpack_require__(18),
	    _require2 = __webpack_require__(8),
	    map = _require2.map,
	    some = _require2.some,
	    every = _require2.every,
	    filter = _require2.filter,
	    get = __webpack_require__(5).get,
	    _require3 = __webpack_require__(19),
	    Navigation = _require3.Navigation,
	    CustomDialog = __webpack_require__(26);
	
	
	var VendorReceiveItemAdmin = React.createClass({ displayName: "VendorReceiveItemAdmin",
	    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],
	
	    getInitialState: function getInitialState() {
	        return {
	            purchaseId: NavigationUtils.getPathParam('purchase-item'),
	            vendorId: NavigationUtils.getPathParam('vendors'),
	            companyName: NavigationUtils.getQueryParam('companyName'),
	            selectedItem: null,
	            isEditMode: false
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.fetchPurchases();
	        ga.pageview('/vendor-receive-item-admin');
	    },
	    _backToVendor: function _backToVendor() {
	        this.transitionTo('/purchase-item/page/:page', { page: 0 });
	    },
	    fetchPurchases: function fetchPurchases(callback) {
	        var _this = this;
	
	        var _state = this.state,
	            purchaseId = _state.purchaseId,
	            vendorId = _state.vendorId;
	
	        var self = this;
	        InventoryStore.fetchVendorItems(vendorId, function (vendorItems) {
	            InventoryStore.fetchVendorPurchasesItem(purchaseId, function (purchases) {
	                var purchasesFiltered = filterNonInventoryItemsFromPurchase(ContentUtils.filterEnable(_this._hydratePurchases(purchases)));
	                var vendorItemsFiltered = filterNonInventoryItems(ContentUtils.filterEnable(vendorItems));
	                self.setState({
	                    purchases: purchasesFiltered,
	                    vendorItems: vendorItemsFiltered
	                }, function () {
	                    if (callback) {
	                        callback();
	                    }
	                });
	            });
	        });
	    },
	    _needActionIcon: function _needActionIcon(purchase) {
	        var bgColor = purchase.noMoreOnTheWay ? 'green' : purchase.state === 'MORE_ON_THE_WAY' ? 'yellow' : purchase.draftMode === true ? 'red' : 'green';
	        return React.createElement("div", null, React.createElement("span", {
	            className: "text-center",
	            style: {
	                height: '20px',
	                borderRadius: '22px',
	                boxShadow: '1px 2px 4px 0px gray',
	                backgroundColor: bgColor,
	                border: 'solid 0px black',
	                padding: '10px 17px',
	                left: '0',
	                position: 'relative',
	                opacity: '.6'
	            } }), React.createElement("span", { style: { paddingLeft: '10px' } }, AppConstants.getPurchaseStateMapping(t)[get(purchase, 'needAction')]));
	    },
	    _hydratePurchases: function _hydratePurchases(purchases) {
	        return map(purchases, function (purchase) {
	            var unit = get(purchase, 'vendorItem.supplierUnit') || get(purchase, 'vendorItem.item.unit');
	
	            purchase.needAction = getStateText(purchase);
	
	            // add unit label to show in the table
	            purchase.amountRequestedWithUnit = NumberUtils.formatDecimal(purchase.amountRequested) + ' ' + unit;
	
	            var costPurchaseItem = PurchaseOrderUtils.getPriceOfPurchaseItem(purchase);
	            purchase.priceUnitWithCurrency = NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(costPurchaseItem);
	            purchase.totalPriceUnitWithCurrency = NumberUtils.getCurrentCurrency().symbol + ' ' + NumberUtils.formatDecimal(NumberUtils.multiply(get(purchase, 'totalAmountReceived') || get(purchase, 'amountRequested'), costPurchaseItem));
	
	            // set as default next state if the item is already `ORDERED`
	            var haveDefaultState = purchase.state === 'ORDERED';
	            var haveAmountReceived = NumberUtils.isGreater(purchase.totalAmountReceived, 0);
	
	            if (haveDefaultState) {
	                // set auto suggested state
	                purchase.suggested = true;
	                purchase.state = 'NO_MORE_ON_THE_WAY';
	
	                // set auto suggested amount request
	                var _haveAmountReceived = !!purchase.totalAmountReceived;
	
	                if (!_haveAmountReceived) {
	                    purchase.totalAmountReceived = purchase.amountRequested;
	                }
	
	                purchase.amountReceivedWithUnit = NumberUtils.formatDecimal(purchase.totalAmountReceived || '0') + ' ' + unit;
	            } else if (haveAmountReceived) {
	                purchase.amountReceivedWithUnit = NumberUtils.formatDecimal(purchase.totalAmountReceived || '0') + ' ' + unit;
	            }
	
	            if (!purchase.amountReceivedWithUnit) {
	                purchase.amountReceivedWithUnit = '0 ' + unit;
	            }
	
	            purchase.dateReceivedDate = DateUtils.toCurrentTimeZone(PurchaseOrderUtils.getLastReceivedDateFromPurchaseOrderItem(purchase), SessionStore.getCurrentTimeZone());
	
	            return purchase;
	        });
	    },
	    _onChangePurchase: function _onChangePurchase(purchase, onSuccess) {
	        InventoryStore.changeVendorPurchaseItemReceivedDraft(purchase, onSuccess, this._onFailure);
	    },
	    _onRowSelection: function _onRowSelection(selectedItem, itemIndex, lastRowScrollPosition, headerActiveFilters) {
	        var _this2 = this;
	
	        this.setState({
	            selectedItem: selectedItem,
	            isEditMode: !!selectedItem,
	            headerActiveFilters: headerActiveFilters
	        }, function () {
	            // stay the position of the scroll after row select when
	            // the offset Y es outside of initial viewport page.
	            _this2.getDOMNode().querySelector('.mui-body-table').scrollTop = lastRowScrollPosition;
	        });
	    },
	    _onCancel: function _onCancel() {
	        this.setState({
	            selectedItem: null,
	            isEditMode: false
	        });
	    },
	    _onFailure: function _onFailure(messageInfo) {
	        if (messageInfo) {
	            var messageError = ContentUtils.formatMessageError(messageInfo);
	            Notification.show(messageError);
	        }
	    },
	    _onEnterPress: function _onEnterPress() {
	        if (this.onEnterKeyDown) {
	            this.onEnterKeyDown();
	        }
	    },
	    _addEnterKeyDown: function _addEnterKeyDown(onEnterKeyDown) {
	        this.onEnterKeyDown = onEnterKeyDown;
	    },
	    _getBreadcrumbLinks: function _getBreadcrumbLinks() {
	        return [{ link: '/purchase-item/page/0', param: { page: 0 }, displayName: t('vendor_purchase_item_label') }, { displayName: NavigationUtils.getQueryParam('code') }];
	    },
	    _backToPurchaseItem: function _backToPurchaseItem() {
	        this.transitionTo('/purchase-item/page/:page', { page: 0 });
	    },
	    _confirmOrdered: function _confirmOrdered() {
	        var _this3 = this;
	
	        CustomDialog.showWarningConfirmation(t('warning'), t('vendor_receive_item_confirmation_add_inventory'), function () {
	            InventoryStore.confirmVendorPurchaseOrder(_this3.state.purchaseId, _this3._onSuccessPurchaseItem, _this3._onFailurePurchaseItem);
	        });
	    },
	    _onSuccessPurchaseItem: function _onSuccessPurchaseItem() {
	        this.fetchPurchases(function () {
	            Notification.show(t('vendor_receive_item_successfully'), 'success');
	        });
	    },
	    _onDelete: function _onDelete() {},
	    render: function render() {
	        var purchases = this.state.purchases;
	
	        if (!purchases) {
	            return React.createElement(Loading, null);
	        } else {
	            var messages = {
	                changeSuccessMessage: t('vendor_receive_item_change_success_message'),
	                changeFailureMessage: t('vendor_receive_item_change_failure_message'),
	                deleteSuccessMessage: t('vendor_receive_item_delete_success_message'),
	                addSuccessMessage: t('vendor_receive_item_add_success_message'),
	                addFailureMessage: t('vendor_receive_item_add_failure_message')
	            };
	            var addingDisplaySate = function addingDisplaySate(state) {
	                return {
	                    state: state,
	                    displayText: AppConstants.getPurchaseStateMapping(t)[state]
	                };
	            };
	            var contextHolder = this.getContextHolderInstance();
	            var _state2 = this.state,
	                selectedItem = _state2.selectedItem,
	                _purchases = _state2.purchases,
	                isEditMode = _state2.isEditMode,
	                vendorItems = _state2.vendorItems;
	
	
	            var isClosedOrder = checkIfOrderAreClosed(_purchases);
	            var isPartiallyReceived = _purchases.some(function (purchase) {
	                return purchase.amountRequested > purchase.lastAmountReceived;
	            });
	            var unit = getUnitFromVendorItem(selectedItem);
	            var unitWithParenthesis = unit ? '(' + unit + ')' : '(' + t('unit') + ')';
	            var shouldBeImmutable = shouldBeImmutableSelectedItem(selectedItem, isClosedOrder);
	
	            var formFieldsEl = selectedItem ? [React.createElement(FormGroupTextFieldSuggested, {
	                isDisabled: true,
	                operationsHolder: contextHolder,
	                items: vendorItems,
	                readerAttribute: "item.description",
	                readerAttributeValue: "id",
	                writerAttribute: "vendorItemId",
	                name: t('item'),
	                label: t('item') + ' ' + unitWithParenthesis,
	                isImmutable: true,
	                isEditMode: isEditMode,
	                value: get(selectedItem, 'vendorItem'),
	                onEnter: this._onEnterPress })] : [];
	
	            if (isMoreOnTheWaySelectedItem(selectedItem)) {
	                formFieldsEl.push(React.createElement(FormGroupTextfield, {
	                    operationsHolder: contextHolder,
	                    readerAttribute: "totalAmountReceived",
	                    writerAttribute: "lastAmountReceived",
	                    additionalValidation: function additionalValidation(inputValue) {
	                        return NumberUtils.isNumber(inputValue) ? '' : t('vendor_receive_item_volume_must_number');
	                    },
	                    name: t('label_amount'),
	                    value: selectedItem,
	                    label: t('vendor_receive_item_amount_received') + ' ' + unitWithParenthesis,
	                    isDisabled: true,
	                    isDecimal: true,
	                    isRelaxedText: true,
	                    isEditMode: isEditMode,
	                    onEnter: this._onEnterPress }));
	
	                formFieldsEl.push(React.createElement(FormGroupTextfield, {
	                    isDisabled: shouldBeImmutable,
	                    value: { totalAmountReceived: 0 },
	                    operationsHolder: contextHolder,
	                    readerAttribute: "totalAmountReceived",
	                    writerAttribute: "lastAmountReceived",
	                    additionalValidation: function additionalValidation(inputValue) {
	                        return NumberUtils.isNumber(inputValue) ? '' : t('vendor_receive_item_volume_must_number');
	                    },
	                    name: t('label_amount'),
	                    label: t('vendor_receive_item_new_amount_received') + ' ' + unitWithParenthesis,
	                    isRelaxedText: true,
	                    isDecimal: true,
	                    isEditMode: isEditMode,
	                    onEnter: this._onEnterPress }));
	            } else {
	                formFieldsEl.push(React.createElement(FormGroupTextfield, {
	                    isDisabled: shouldBeImmutable,
	                    operationsHolder: contextHolder,
	                    readerAttribute: "totalAmountReceived",
	                    writerAttribute: "lastAmountReceived",
	                    additionalValidation: function additionalValidation(inputValue) {
	                        return NumberUtils.isNumber(inputValue) ? '' : t('vendor_receive_item_volume_must_number');
	                    },
	                    name: t('label_amount'),
	                    value: selectedItem,
	                    isDecimal: true,
	                    label: t('vendor_receive_item_amount_received') + ' ' + unitWithParenthesis,
	                    isRelaxedText: true,
	                    isEditMode: isEditMode,
	                    onEnter: this._onEnterPress }));
	            }
	
	            var currentSelectedSection = selectedItem && selectedItem.state ? AppConstants.getPurchaseStateMapping(t)[selectedItem.state] : '';
	
	            var currentSelectedValue = currentSelectedSection ? _extends({}, selectedItem, { displayText: currentSelectedSection }) : selectedItem;
	
	            formFieldsEl.push(React.createElement(FormGroupDropdown, {
	                isDisabled: shouldBeImmutable,
	                items: shouldShowOnlyNoMoreOnTheWay(selectedItem) ? AppConstants.ONLY_NO_MORE_ON_THE_WAY.map(addingDisplaySate) : AppConstants.RECEIVE_STATES_ITEMS.map(addingDisplaySate),
	
	                operationsHolder: contextHolder,
	                readerAttribute: "displayText",
	                writerAttribute: "state",
	                customReaderWriterAttribute: "state",
	                readerAttributeValue: "state",
	                name: t('vendor_receive_item_column_email_status'),
	                label: t('vendor_receive_item_status_received'),
	                value: currentSelectedValue || 'RECEIVED',
	                isEditMode: isEditMode,
	                onEnter: this._onEnterPress }));
	
	            var additionalButtons = [{
	                permission: 'CONFIRM_RECEIVE',
	                type: 'CHANGE',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToPurchaseItem })
	            }, {
	                permission: 'CONFIRM_RECEIVE',
	                type: 'NEW',
	                el: React.createElement(FormGroupButton, {
	                    label: t('back'),
	                    icon: "subdirectory_arrow_left",
	                    type: "icon",
	                    onClick: this._backToPurchaseItem })
	            }];
	
	            var haveSomePurchaseItem = ContentUtils.isNotEmptyArray(_purchases);
	
	            var haveSomePurchaseItemPending = some(_purchases, function (purchase) {
	                return isDraftPurchase(purchase) || isSuggestedOrder(purchase);
	            });
	            var needSendEmailBefore = some(_purchases, function (purchase) {
	                return isPendingPurchase(purchase);
	            });
	
	            if (!needSendEmailBefore && haveSomePurchaseItem && haveSomePurchaseItemPending) {
	                additionalButtons.push({
	                    type: 'NEW',
	                    permission: 'CONFIRM_RECEIVE',
	                    el: React.createElement(FormGroupButton, {
	                        label: t('vendor_receive_item_label_confirm_received'),
	                        icon: "local_shipping",
	                        type: "icon",
	                        onClick: this._confirmOrdered })
	                });
	            }
	
	            return React.createElement(AdminScaffoldingGeneric, {
	                messages: messages,
	                moduleName: "ADMIN_PURCHASE",
	                additionalButtons: additionalButtons,
	                title: isClosedOrder ? isPartiallyReceived ? t('vendor_receive_item_status_close_resolved') : t('vendor_receive_item_status_close_completed') : isEditMode ? t('vendor_receive_item_receive_existing_item') : t('vendor_receive_item_receive_item'),
	
	                contextHolder: contextHolder,
	                value: selectedItem,
	                fetchItems: this.fetchPurchases,
	                headerFields: formFieldsEl,
	                onChange: isClosedOrder || shouldBeImmutable ? undefined : this._onChangePurchase,
	
	                onCancel: this._onCancel,
	                onDelete: shouldBeImmutable || isClosedOrder ? undefined : this._onDelete,
	
	                addEnterKeyDown: this._addEnterKeyDown,
	                breadcrumb: this._getBreadcrumbLinks()
	            }, React.createElement(AdminScaffoldingTable, {
	                onRowSelection: this._onRowSelection,
	                value: selectedItem,
	                sortByColumn: "vendorItem.item.description",
	                filteredColumns: ['vendorItem.item.description', 'amountRequestedWithUnit', 'amountReceivedWithUnit', 'priceUnitWithCurrency', 'totalPriceUnitWithCurrency', 'dateReceivedDate', 'needAction'],
	                displayAttributes: ['vendorItem.item.description', 'amountRequestedWithUnit', 'amountReceivedWithUnit', 'priceUnitWithCurrency', 'totalPriceUnitWithCurrency', 'dateReceivedDate', 'displayState', {
	                    getHTML: this._needActionIcon
	                }],
	                columnNames: [t('vendor_receive_item_column_item'), t('vendor_receive_item_column_amt_requested'), t('vendor_receive_item_column_amt_received'), t('vendor_receive_item_column_unit_price'), t('vendor_receive_item_column_total_price'), t('vendor_receive_item_column_date_received'), t('vendor_receive_item_column_email_status'), t('vendor_receive_item_column_action')]
	            }, _purchases.map(function (purchase) {
	                purchase.displayState = AppConstants.getPurchaseStateMapping(t)[purchase.state];
	                return purchase;
	            })));
	        }
	    }
	});
	
	function checkIfOrderAreClosed(purchases) {
	    return every(purchases, function (purchase) {
	        var haveCloseableState = 'REJECT_REMAINDER' === purchase.state || 'NO_MORE_ON_THE_WAY' === purchase.state;
	        var isNonSuggestedItem = purchase.suggested === false || purchase.suggested === undefined;
	        var isNonDraftMore = purchase.draftMode === false || purchase.draftMode === undefined;
	
	        return haveCloseableState && isNonSuggestedItem && isNonDraftMore;
	    });
	}
	
	function shouldBeImmutableSelectedItem(selectedItem, isClosedOrder) {
	    // once have next state of MORE_ON_THE_WAY should not return it
	    var currentStateItem = get(selectedItem, 'state', '');
	    var isDraftMode = get(selectedItem, 'draftMode', '');
	    var itemSuggested = get(selectedItem, 'suggested', false);
	    var shouldBeImmutable = false;
	
	    if (isClosedOrder) {
	        // enter here means the order could not be changed any more,
	        // because is already closed
	        shouldBeImmutable = true;
	    } else if (isDraftMode) {
	        shouldBeImmutable = false;
	    } else {
	        if (itemSuggested) {
	            // enter here means the item was pre-defined by the system
	            // but is not saved the suggested state of the item
	            shouldBeImmutable = false;
	        } else if (!ContentUtils.isEmptyText(currentStateItem)) {
	            // enter here ask if current item selection have
	            // a non returned state.
	            shouldBeImmutable = currentStateItem === 'NO_MORE_ON_THE_WAY' || currentStateItem === 'REJECT_REMAINDER';
	        }
	    }
	
	    return shouldBeImmutable;
	}
	
	function isSuggestedOrder(purchase) {
	    return get(purchase, 'suggested');
	}
	
	function isPendingPurchase(purchase) {
	    return get(purchase, 'state') === 'PENDING';
	}
	
	function isDraftPurchase(purchase) {
	    return get(purchase, 'draftMode');
	}
	
	function shouldShowOnlyNoMoreOnTheWay(selectedItem) {
	    return NumberUtils.isGreater(get(selectedItem, 'lastTotalAmountReceived'), get(selectedItem, 'amountRequested'));
	}
	
	function isMoreOnTheWaySelectedItem(selectedItem) {
	    return get(selectedItem, 'state', '') === 'MORE_ON_THE_WAY';
	}
	
	function getStateText(purchase) {
	    var state = get(purchase, 'state');
	
	    if (state === 'NO_MORE_ON_THE_WAY') {
	        return 'CLOSED_COMPLETE';
	    } else if (state === 'REJECT_REMAINDER') {
	        return 'CLOSED_INCOMPLETE';
	    } else if (state === 'MORE_ON_THE_WAY') {
	        return 'OPEN_INCOMPLETE';
	    } else {
	        return state;
	    }
	}
	
	function getUnitFromVendorItem(vendorItem) {
	    return get(vendorItem, 'vendorItem.supplierUnit') || get(vendorItem, 'vendorItem.item.unit');
	}
	
	function filterNonInventoryItems(vendorItems) {
	    return filter(vendorItems, function (vendorItem) {
	        return get(vendorItem, 'item.category') !== AppConstants.ITEM_CATEGORY_NON_INVENTORY;
	    });
	}
	function filterNonInventoryItemsFromPurchase(purchases) {
	    return filter(purchases, function (purchase) {
	        return get(purchase, 'vendorItem.item.category') !== AppConstants.ITEM_CATEGORY_NON_INVENTORY;
	    });
	}
	
	module.exports = VendorReceiveItemAdmin;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(694);
	
	var React = __webpack_require__(1),
	    _require = __webpack_require__(4),
	    t = _require.t,
	    apiAppUrl = ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).URL_API,
	    mui = __webpack_require__(12),
	    RaisedButton = mui.RaisedButton;
	
	
	var About = React.createClass({ displayName: "About",
	
	    handlerClick: function handlerClick() {
	        window.location = apiAppUrl + '/#/login';
	    },
	
	    render: function render() {
	        return React.createElement("div", { className: "welcome-page-container jumbotron" }, React.createElement("div", { className: "container text-center" }, React.createElement("h1", { className: "welcome-page-container__header light" }, t('welcome_to_brew_planner')), React.createElement("div", { className: "welcome-page-container__body" }, React.createElement("p", null, t('welcome_message_help_you_planning')), React.createElement("br", null), React.createElement("p", null, t('welcome_check_out_video_tutorials'), ' ', React.createElement("a", {
	            target: "_blank",
	            href: "http://www.brewplanner.com/videos"
	        }, t('welcome_label_here')), ' ' + t('welcome_get_started'))), React.createElement("br", null), React.createElement("div", { className: "welcome-page-container__start-button" }, React.createElement(RaisedButton, {
	            label: t('welcome_label_start'),
	            primary: true,
	            onTouchTap: this.handlerClick })), React.createElement("br", null), React.createElement("br", null), React.createElement("br", null), React.createElement("img", {
	            style: { height: '60px' },
	            src: "/assets/images/logo-small-dark.png" })));
	    }
	});
	
	module.exports = About;

/***/ },
/* 804 */
646,
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(640);
	var isArguments = __webpack_require__(821);
	var is = __webpack_require__(1188);
	var isRegex = __webpack_require__(823);
	var flags = __webpack_require__(1308);
	var isDate = __webpack_require__(822);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 806 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 807 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 808 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 809 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 810 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(813);


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(811);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ? ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ? ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ? ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ? ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ? ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ },
/* 814 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 815 */
/***/ function(module, exports) {

	'use strict';
	
	var functionsHaveNames = function functionsHaveNames() {
		return typeof function f() {}.name === 'string';
	};
	
	var gOPD = Object.getOwnPropertyDescriptor;
	if (gOPD) {
		try {
			gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			gOPD = null;
		}
	}
	
	functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
		if (!functionsHaveNames() || !gOPD) {
			return false;
		}
		var desc = gOPD(function () {}, 'name');
		return !!desc && !!desc.configurable;
	};
	
	var $bind = Function.prototype.bind;
	
	functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
		return functionsHaveNames() && typeof $bind === 'function' && function f() {}.bind().name !== '';
	};
	
	module.exports = functionsHaveNames;


/***/ },
/* 816 */
/***/ function(module, exports) {

	
	/**
	 * Module exports.
	 */
	
	module.exports = getDocument;
	
	// defined by w3c
	var DOCUMENT_NODE = 9;
	
	/**
	 * Returns `true` if `w` is a Document object, or `false` otherwise.
	 *
	 * @param {?} d - Document object, maybe
	 * @return {Boolean}
	 * @private
	 */
	
	function isDocument (d) {
	  return d && d.nodeType === DOCUMENT_NODE;
	}
	
	/**
	 * Returns the `document` object associated with the given `node`, which may be
	 * a DOM element, the Window object, a Selection, a Range. Basically any DOM
	 * object that references the Document in some way, this function will find it.
	 *
	 * @param {Mixed} node - DOM node, selection, or range in which to find the `document` object
	 * @return {Document} the `document` object associated with `node`
	 * @public
	 */
	
	function getDocument(node) {
	  if (isDocument(node)) {
	    return node;
	
	  } else if (isDocument(node.ownerDocument)) {
	    return node.ownerDocument;
	
	  } else if (isDocument(node.document)) {
	    return node.document;
	
	  } else if (node.parentNode) {
	    return getDocument(node.parentNode);
	
	  // Range support
	  } else if (node.commonAncestorContainer) {
	    return getDocument(node.commonAncestorContainer);
	
	  } else if (node.startContainer) {
	    return getDocument(node.startContainer);
	
	  // Selection support
	  } else if (node.anchorNode) {
	    return getDocument(node.anchorNode);
	  }
	}


/***/ },
/* 817 */
/***/ function(module, exports) {

	'use strict';
	
	var test = {
		__proto__: null,
		foo: {}
	};
	
	var $Object = Object;
	
	/** @type {import('.')} */
	module.exports = function hasProto() {
		// @ts-expect-error: TS errors on an inherited property for some reason
		return { __proto__: test }.foo === test.foo
			&& !(test instanceof $Object);
	};


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(418);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(309);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(311)();
	var callBound = __webpack_require__(415);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = __webpack_require__(311)();
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(415);
	var hasToStringTag = __webpack_require__(311)();
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 824 */
/***/ function(module, exports) {

	module.exports = {
		"AED": {
			"code": "AED",
			"symbol": "د.إ.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AFN": {
			"code": "AFN",
			"symbol": "؋",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ALL": {
			"code": "ALL",
			"symbol": "Lek",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AMD": {
			"code": "AMD",
			"symbol": "֏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ANG": {
			"code": "ANG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AOA": {
			"code": "AOA",
			"symbol": "Kz",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ARS": {
			"code": "ARS",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"AUD": {
			"code": "AUD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AWG": {
			"code": "AWG",
			"symbol": "ƒ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"AZN": {
			"code": "AZN",
			"symbol": "₼",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BAM": {
			"code": "BAM",
			"symbol": "КМ",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BBD": {
			"code": "BBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BDT": {
			"code": "BDT",
			"symbol": "৳",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"BGN": {
			"code": "BGN",
			"symbol": "лв.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BHD": {
			"code": "BHD",
			"symbol": "د.ب.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"BIF": {
			"code": "BIF",
			"symbol": "FBu",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BMD": {
			"code": "BMD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BND": {
			"code": "BND",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"BOB": {
			"code": "BOB",
			"symbol": "Bs",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BRL": {
			"code": "BRL",
			"symbol": "R$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BSD": {
			"code": "BSD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTC": {
			"code": "BTC",
			"symbol": "Ƀ",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BTN": {
			"code": "BTN",
			"symbol": "Nu.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"BWP": {
			"code": "BWP",
			"symbol": "P",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"BYR": {
			"code": "BYR",
			"symbol": "р.",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"BZD": {
			"code": "BZD",
			"symbol": "BZ$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CAD": {
			"code": "CAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CDF": {
			"code": "CDF",
			"symbol": "FC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CHF": {
			"code": "CHF",
			"symbol": "CHF",
			"thousandsSeparator": "'",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CLP": {
			"code": "CLP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CNY": {
			"code": "CNY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"COP": {
			"code": "COP",
			"symbol": "$",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"CRC": {
			"code": "CRC",
			"symbol": "₡",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUC": {
			"code": "CUC",
			"symbol": "CUC",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CUP": {
			"code": "CUP",
			"symbol": "$MN",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CVE": {
			"code": "CVE",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"CZK": {
			"code": "CZK",
			"symbol": "Kč",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DJF": {
			"code": "DJF",
			"symbol": "Fdj",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"DKK": {
			"code": "DKK",
			"symbol": "kr.",
			"thousandsSeparator": "",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"DOP": {
			"code": "DOP",
			"symbol": "RD$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"DZD": {
			"code": "DZD",
			"symbol": "د.ج.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"EGP": {
			"code": "EGP",
			"symbol": "ج.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ERN": {
			"code": "ERN",
			"symbol": "Nfk",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ETB": {
			"code": "ETB",
			"symbol": "ETB",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"EUR": {
			"code": "EUR",
			"symbol": "€",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"FJD": {
			"code": "FJD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"FKP": {
			"code": "FKP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GBP": {
			"code": "GBP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GEL": {
			"code": "GEL",
			"symbol": "Lari",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"GHS": {
			"code": "GHS",
			"symbol": "₵",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GIP": {
			"code": "GIP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GMD": {
			"code": "GMD",
			"symbol": "D",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GNF": {
			"code": "GNF",
			"symbol": "FG",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"GTQ": {
			"code": "GTQ",
			"symbol": "Q",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"GYD": {
			"code": "GYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HKD": {
			"code": "HKD",
			"symbol": "HK$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HNL": {
			"code": "HNL",
			"symbol": "L.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HRK": {
			"code": "HRK",
			"symbol": "kn",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"HTG": {
			"code": "HTG",
			"symbol": "G",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"HUF": {
			"code": "HUF",
			"symbol": "Ft",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IDR": {
			"code": "IDR",
			"symbol": "Rp",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"ILS": {
			"code": "ILS",
			"symbol": "₪",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"INR": {
			"code": "INR",
			"symbol": "₹",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"IQD": {
			"code": "IQD",
			"symbol": "د.ع.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"IRR": {
			"code": "IRR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": "/",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ISK": {
			"code": "ISK",
			"symbol": "kr.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"JMD": {
			"code": "JMD",
			"symbol": "J$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"JOD": {
			"code": "JOD",
			"symbol": "د.ا.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"JPY": {
			"code": "JPY",
			"symbol": "¥",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KES": {
			"code": "KES",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KGS": {
			"code": "KGS",
			"symbol": "сом",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"KHR": {
			"code": "KHR",
			"symbol": "៛",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KMF": {
			"code": "KMF",
			"symbol": "CF",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KPW": {
			"code": "KPW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KRW": {
			"code": "KRW",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"KWD": {
			"code": "KWD",
			"symbol": "د.ك.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"KYD": {
			"code": "KYD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"KZT": {
			"code": "KZT",
			"symbol": "₸",
			"thousandsSeparator": " ",
			"decimalSeparator": "-",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LAK": {
			"code": "LAK",
			"symbol": "₭",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"LBP": {
			"code": "LBP",
			"symbol": "ل.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"LKR": {
			"code": "LKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 0
		},
		"LRD": {
			"code": "LRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LSL": {
			"code": "LSL",
			"symbol": "M",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"LYD": {
			"code": "LYD",
			"symbol": "د.ل.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 3
		},
		"MAD": {
			"code": "MAD",
			"symbol": "د.م.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MDL": {
			"code": "MDL",
			"symbol": "lei",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MGA": {
			"code": "MGA",
			"symbol": "Ar",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"MKD": {
			"code": "MKD",
			"symbol": "ден.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"MMK": {
			"code": "MMK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MNT": {
			"code": "MNT",
			"symbol": "₮",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MOP": {
			"code": "MOP",
			"symbol": "MOP$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MRO": {
			"code": "MRO",
			"symbol": "UM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MTL": {
			"code": "MTL",
			"symbol": "₤",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MUR": {
			"code": "MUR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MVR": {
			"code": "MVR",
			"symbol": "MVR",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"MWK": {
			"code": "MWK",
			"symbol": "MK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MXN": {
			"code": "MXN",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MYR": {
			"code": "MYR",
			"symbol": "RM",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"MZN": {
			"code": "MZN",
			"symbol": "MT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"NAD": {
			"code": "NAD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NGN": {
			"code": "NGN",
			"symbol": "₦",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NIO": {
			"code": "NIO",
			"symbol": "C$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NOK": {
			"code": "NOK",
			"symbol": "kr",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"NPR": {
			"code": "NPR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"NZD": {
			"code": "NZD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"OMR": {
			"code": "OMR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"PAB": {
			"code": "PAB",
			"symbol": "B/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PEN": {
			"code": "PEN",
			"symbol": "S/.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PGK": {
			"code": "PGK",
			"symbol": "K",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PHP": {
			"code": "PHP",
			"symbol": "₱",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PKR": {
			"code": "PKR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"PLN": {
			"code": "PLN",
			"symbol": "zł",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"PYG": {
			"code": "PYG",
			"symbol": "₲",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"QAR": {
			"code": "QAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RON": {
			"code": "RON",
			"symbol": "lei",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RSD": {
			"code": "RSD",
			"symbol": "Дин.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RUB": {
			"code": "RUB",
			"symbol": "₽",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"RWF": {
			"code": "RWF",
			"symbol": "RWF",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SAR": {
			"code": "SAR",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SBD": {
			"code": "SBD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SCR": {
			"code": "SCR",
			"symbol": "₨",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDD": {
			"code": "SDD",
			"symbol": "LSd",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SDG": {
			"code": "SDG",
			"symbol": "£‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SEK": {
			"code": "SEK",
			"symbol": "kr",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SGD": {
			"code": "SGD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SHP": {
			"code": "SHP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SLL": {
			"code": "SLL",
			"symbol": "Le",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SOS": {
			"code": "SOS",
			"symbol": "S",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SRD": {
			"code": "SRD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"STD": {
			"code": "STD",
			"symbol": "Db",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SVC": {
			"code": "SVC",
			"symbol": "₡",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"SYP": {
			"code": "SYP",
			"symbol": "£",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"SZL": {
			"code": "SZL",
			"symbol": "E",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"THB": {
			"code": "THB",
			"symbol": "฿",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TJS": {
			"code": "TJS",
			"symbol": "TJS",
			"thousandsSeparator": " ",
			"decimalSeparator": ";",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TMT": {
			"code": "TMT",
			"symbol": "m",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"TND": {
			"code": "TND",
			"symbol": "د.ت.‏",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 3
		},
		"TOP": {
			"code": "TOP",
			"symbol": "T$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TRY": {
			"code": "TRY",
			"symbol": "TL",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"TTD": {
			"code": "TTD",
			"symbol": "TT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TVD": {
			"code": "TVD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TWD": {
			"code": "TWD",
			"symbol": "NT$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"TZS": {
			"code": "TZS",
			"symbol": "TSh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UAH": {
			"code": "UAH",
			"symbol": "₴",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UGX": {
			"code": "UGX",
			"symbol": "USh",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"USD": {
			"code": "USD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"UYU": {
			"code": "UYU",
			"symbol": "$U",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"UZS": {
			"code": "UZS",
			"symbol": "сўм",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VEB": {
			"code": "VEB",
			"symbol": "Bs.",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"VEF": {
			"code": "VEF",
			"symbol": "Bs. F.",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"VND": {
			"code": "VND",
			"symbol": "₫",
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 1
		},
		"VUV": {
			"code": "VUV",
			"symbol": "VT",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 0
		},
		"WST": {
			"code": "WST",
			"symbol": "WS$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XAF": {
			"code": "XAF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XCD": {
			"code": "XCD",
			"symbol": "$",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XOF": {
			"code": "XOF",
			"symbol": "F",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"XPF": {
			"code": "XPF",
			"symbol": "F",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"YER": {
			"code": "YER",
			"symbol": "﷼",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"ZAR": {
			"code": "ZAR",
			"symbol": "R",
			"thousandsSeparator": " ",
			"decimalSeparator": ",",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"ZMW": {
			"code": "ZMW",
			"symbol": "ZK",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		},
		"WON": {
			"code": "WON",
			"symbol": "₩",
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"decimalDigits": 2
		}
	};

/***/ },
/* 825 */
/***/ function(module, exports) {

	module.exports = {
		"de-AT": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"el-GR": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"en-IE": {
			"symbolOnLeft": true,
			"thousandsSeparator": ",",
			"decimalSeparator": ".",
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"es-ES": {
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"symbolOnLeft": false,
			"spaceBetweenAmountAndSymbol": true,
			"decimalDigits": 2
		},
		"it-IT": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-NL": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		},
		"nl-BE": {
			"symbolOnLeft": true,
			"spaceBetweenAmountAndSymbol": false,
			"thousandsSeparator": ".",
			"decimalSeparator": ",",
			"decimalDigits": 2
		}
	};

/***/ },
/* 826 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2017b",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
			"Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0",
			"America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0",
			"America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
			"America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
			"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
			"Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|-02|20|0||30",
			"Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Pacific/Port_Moresby|+10|-a0|0||25e4",
			"Pacific/Pohnpei|+11|-b0|0||34e3",
			"Pacific/Tarawa|+12|-c0|0||29e3",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Indian/Christmas|+07|-70|0||21e2",
			"Etc/GMT-8|+08|-80|0|",
			"Pacific/Palau|+09|-90|0||21e3",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Cocos|+0630|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
			"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
			"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
			"Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Juba",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Kuala_Lumpur|Asia/Singapore",
			"Asia/Kuala_Lumpur|Singapore",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Atlantic/South_Georgia|Etc/GMT+2",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Indian/Christmas|Etc/GMT-7",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Palau|Etc/GMT-9",
			"Pacific/Pohnpei|Etc/GMT-11",
			"Pacific/Pohnpei|Pacific/Ponape",
			"Pacific/Port_Moresby|Etc/GMT-10",
			"Pacific/Port_Moresby|Pacific/Chuuk",
			"Pacific/Port_Moresby|Pacific/Truk",
			"Pacific/Port_Moresby|Pacific/Yap",
			"Pacific/Tarawa|Etc/GMT-12",
			"Pacific/Tarawa|Pacific/Funafuti",
			"Pacific/Tarawa|Pacific/Wake",
			"Pacific/Tarawa|Pacific/Wallis"
		]
	};

/***/ },
/* 827 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	"use strict";
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  if (!(obj instanceof Object && !Array.isArray(obj))) {
	    throw new Error('keyMirror(...): Argument must be an object.');
	  }
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var map = __webpack_require__(829);
	
	var getCountryCode = function(localeString) {
	    var components = localeString.split("_");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    components = localeString.split("-");
	    if (components.length == 2) {
	        return components.pop();
	    }
	    return localeString;
	}
	
	exports.getCurrency = function(locale) {
	    var countryCode = getCountryCode(locale).toUpperCase();
	    if (countryCode in map) {
	        return map[countryCode];
	    }
	    return null;
	}
	
	exports.getLocales = function(currencyCode) {
	    currencyCode = currencyCode.toUpperCase();
	    var locales = [];
	    for (countryCode in map) {
	        if (map[countryCode] === currencyCode) {
	            locales.push(countryCode);
	        }
	    }
	    return locales;
	}

/***/ },
/* 829 */
/***/ function(module, exports) {

	// Generated using ShowCurrencies.java
	var map = {
	AD: 'EUR',
	AE: 'AED',
	AF: 'AFN',
	AG: 'XCD',
	AI: 'XCD',
	AL: 'ALL',
	AM: 'AMD',
	AN: 'ANG',
	AO: 'AOA',
	AR: 'ARS',
	AS: 'USD',
	AT: 'EUR',
	AU: 'AUD',
	AW: 'AWG',
	AX: 'EUR',
	AZ: 'AZN',
	BA: 'BAM',
	BB: 'BBD',
	BD: 'BDT',
	BE: 'EUR',
	BF: 'XOF',
	BG: 'BGN',
	BH: 'BHD',
	BI: 'BIF',
	BJ: 'XOF',
	BL: 'EUR',
	BM: 'BMD',
	BN: 'BND',
	BO: 'BOB',
	BQ: 'USD',
	BR: 'BRL',
	BS: 'BSD',
	BT: 'BTN',
	BV: 'NOK',
	BW: 'BWP',
	BY: 'BYR',
	BZ: 'BZD',
	CA: 'CAD',
	CC: 'AUD',
	CD: 'CDF',
	CF: 'XAF',
	CG: 'XAF',
	CH: 'CHF',
	CI: 'XOF',
	CK: 'NZD',
	CL: 'CLP',
	CM: 'XAF',
	CN: 'CNY',
	CO: 'COP',
	CR: 'CRC',
	CU: 'CUP',
	CV: 'CVE',
	CW: 'ANG',
	CX: 'AUD',
	CY: 'EUR',
	CZ: 'CZK',
	DE: 'EUR',
	DJ: 'DJF',
	DK: 'DKK',
	DM: 'XCD',
	DO: 'DOP',
	DZ: 'DZD',
	EC: 'USD',
	EE: 'EUR',
	EG: 'EGP',
	EH: 'MAD',
	ER: 'ERN',
	ES: 'EUR',
	ET: 'ETB',
	FI: 'EUR',
	FJ: 'FJD',
	FK: 'FKP',
	FM: 'USD',
	FO: 'DKK',
	FR: 'EUR',
	GA: 'XAF',
	GB: 'GBP',
	GD: 'XCD',
	GE: 'GEL',
	GF: 'EUR',
	GG: 'GBP',
	GH: 'GHS',
	GI: 'GIP',
	GL: 'DKK',
	GM: 'GMD',
	GN: 'GNF',
	GP: 'EUR',
	GQ: 'XAF',
	GR: 'EUR',
	GS: 'GBP',
	GT: 'GTQ',
	GU: 'USD',
	GW: 'XOF',
	GY: 'GYD',
	HK: 'HKD',
	HM: 'AUD',
	HN: 'HNL',
	HR: 'HRK',
	HT: 'HTG',
	HU: 'HUF',
	ID: 'IDR',
	IE: 'EUR',
	IL: 'ILS',
	IM: 'GBP',
	IN: 'INR',
	IO: 'USD',
	IQ: 'IQD',
	IR: 'IRR',
	IS: 'ISK',
	IT: 'EUR',
	JE: 'GBP',
	JM: 'JMD',
	JO: 'JOD',
	JP: 'JPY',
	KE: 'KES',
	KG: 'KGS',
	KH: 'KHR',
	KI: 'AUD',
	KM: 'KMF',
	KN: 'XCD',
	KP: 'KPW',
	KR: 'KRW',
	KW: 'KWD',
	KY: 'KYD',
	KZ: 'KZT',
	LA: 'LAK',
	LB: 'LBP',
	LC: 'XCD',
	LI: 'CHF',
	LK: 'LKR',
	LR: 'LRD',
	LS: 'LSL',
	LT: 'LTL',
	LU: 'EUR',
	LV: 'LVL',
	LY: 'LYD',
	MA: 'MAD',
	MC: 'EUR',
	MD: 'MDL',
	ME: 'EUR',
	MF: 'EUR',
	MG: 'MGA',
	MH: 'USD',
	MK: 'MKD',
	ML: 'XOF',
	MM: 'MMK',
	MN: 'MNT',
	MO: 'MOP',
	MP: 'USD',
	MQ: 'EUR',
	MR: 'MRO',
	MS: 'XCD',
	MT: 'EUR',
	MU: 'MUR',
	MV: 'MVR',
	MW: 'MWK',
	MX: 'MXN',
	MY: 'MYR',
	MZ: 'MZN',
	NA: 'NAD',
	NC: 'XPF',
	NE: 'XOF',
	NF: 'AUD',
	NG: 'NGN',
	NI: 'NIO',
	NL: 'EUR',
	NO: 'NOK',
	NP: 'NPR',
	NR: 'AUD',
	NU: 'NZD',
	NZ: 'NZD',
	OM: 'OMR',
	PA: 'PAB',
	PE: 'PEN',
	PF: 'XPF',
	PG: 'PGK',
	PH: 'PHP',
	PK: 'PKR',
	PL: 'PLN',
	PM: 'EUR',
	PN: 'NZD',
	PR: 'USD',
	PS: 'ILS',
	PT: 'EUR',
	PW: 'USD',
	PY: 'PYG',
	QA: 'QAR',
	RE: 'EUR',
	RO: 'RON',
	RS: 'RSD',
	RU: 'RUB',
	RW: 'RWF',
	SA: 'SAR',
	SB: 'SBD',
	SC: 'SCR',
	SD: 'SDG',
	SE: 'SEK',
	SG: 'SGD',
	SH: 'SHP',
	SI: 'EUR',
	SJ: 'NOK',
	SK: 'EUR',
	SL: 'SLL',
	SM: 'EUR',
	SN: 'XOF',
	SO: 'SOS',
	SR: 'SRD',
	ST: 'STD',
	SV: 'SVC',
	SX: 'ANG',
	SY: 'SYP',
	SZ: 'SZL',
	TC: 'USD',
	TD: 'XAF',
	TF: 'EUR',
	TG: 'XOF',
	TH: 'THB',
	TJ: 'TJS',
	TK: 'NZD',
	TL: 'USD',
	TM: 'TMT',
	TN: 'TND',
	TO: 'TOP',
	TR: 'TRY',
	TT: 'TTD',
	TV: 'AUD',
	TW: 'TWD',
	TZ: 'TZS',
	UA: 'UAH',
	UG: 'UGX',
	UM: 'USD',
	US: 'USD',
	UY: 'UYU',
	UZ: 'UZS',
	VA: 'EUR',
	VC: 'XCD',
	VE: 'VEF',
	VG: 'USD',
	VI: 'USD',
	VN: 'VND',
	VU: 'VUV',
	WF: 'XPF',
	WS: 'WST',
	YE: 'YER',
	YT: 'EUR',
	ZA: 'ZAR',
	ZM: 'ZMK',
	ZW: 'ZWL'
	};
	
	module.exports = map;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Creates an hash object.
	 *
	 * @private
	 * @constructor
	 * @returns {Object} Returns the new hash object.
	 */
	function Hash() {}
	
	// Avoid inheriting from `Object.prototype` when possible.
	Hash.prototype = nativeCreate ? nativeCreate(null) : objectProto;
	
	module.exports = Hash;


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 832 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 833 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 834 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 835 */
/***/ function(module, exports) {

	/**
	 * Creates a new array concatenating `array` with `other`.
	 *
	 * @private
	 * @param {Array} array The first array to concatenate.
	 * @param {Array} other The second array to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 */
	function arrayConcat(array, other) {
	  var index = -1,
	      length = array.length,
	      othIndex = -1,
	      othLength = other.length,
	      result = Array(length + othLength);
	
	  while (++index < length) {
	    result[index] = array[index];
	  }
	  while (++othIndex < othLength) {
	    result[index++] = other[othIndex];
	  }
	  return result;
	}
	
	module.exports = arrayConcat;


/***/ },
/* 836 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEachRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEachRight(array, iteratee) {
	  var length = array.length;
	
	  while (length--) {
	    if (iteratee(array[length], length, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEachRight;


/***/ },
/* 837 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduceRight` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the last element of `array` as the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	  var length = array.length;
	  if (initAccum && length) {
	    accumulator = array[--length];
	  }
	  while (length--) {
	    accumulator = iteratee(accumulator, array[length], length, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduceRight;


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(54);
	
	/**
	 * The base implementation of `_.conforms` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {Function} Returns the new function.
	 */
	function baseConforms(source) {
	  var props = keys(source),
	      length = props.length;
	
	  return function(object) {
	    if (object == null) {
	      return !length;
	    }
	    var index = length;
	    while (index--) {
	      var key = props[index],
	          predicate = source[key],
	          value = object[key];
	
	      if ((value === undefined && !(key in Object(object))) || !predicate(value)) {
	        return false;
	      }
	    }
	    return true;
	  };
	}
	
	module.exports = baseConforms;


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31),
	    toLength = __webpack_require__(505);
	
	/**
	 * The base implementation of `_.fill` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to fill.
	 * @param {*} value The value to fill `array` with.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns `array`.
	 */
	function baseFill(array, value, start, end) {
	  var length = array.length;
	
	  start = toInteger(start);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : toInteger(end);
	  if (end < 0) {
	    end += length;
	  }
	  end = start > end ? 0 : toLength(end);
	  while (start < end) {
	    array[start++] = value;
	  }
	  return array;
	}
	
	module.exports = baseFill;


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(324),
	    keysIn = __webpack_require__(68);
	
	/**
	 * The base implementation of `_.forIn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return object == null ? object : baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 843 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(98);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(189),
	    equalArrays = __webpack_require__(872),
	    equalByTag = __webpack_require__(873),
	    equalObjects = __webpack_require__(874),
	    getTag = __webpack_require__(142),
	    isArray = __webpack_require__(27),
	    isHostObject = __webpack_require__(204),
	    isTypedArray = __webpack_require__(165);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag, equalFunc, customizer, bitmask);
	  }
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	  if (!isPartial) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 846 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(831),
	    iteratorToArray = __webpack_require__(470);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(424),
	    baseClone = __webpack_require__(83),
	    copyArray = __webpack_require__(100),
	    isArguments = __webpack_require__(144),
	    isArray = __webpack_require__(27),
	    isArrayLikeObject = __webpack_require__(52),
	    isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(46),
	    isPlainObject = __webpack_require__(353),
	    isTypedArray = __webpack_require__(165),
	    toPlainObject = __webpack_require__(507);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(327);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	var basePullAllBy = __webpack_require__(440);
	
	/**
	 * The base implementation of `_.pullAll`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @returns {Array} Returns `array`.
	 */
	function basePullAll(array, values) {
	  return basePullAllBy(array, values);
	}
	
	module.exports = basePullAll;


/***/ },
/* 851 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments to numbers.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the new array of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 853 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define
	 * the sort order of `array` and replaces criteria objects with their
	 * corresponding values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedUniqBy = __webpack_require__(445);
	
	/**
	 * The base implementation of `_.sortedUniq`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseSortedUniq(array) {
	  return baseSortedUniqBy(array);
	}
	
	module.exports = baseSortedUniq;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(112),
	    has = __webpack_require__(486),
	    isKey = __webpack_require__(86),
	    last = __webpack_require__(62),
	    parent = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = isKey(path, object) ? [path + ''] : baseCastPath(path);
	  object = parent(object, path);
	  var key = last(path);
	  return (object != null && has(object, key)) ? delete object[key] : true;
	}
	
	module.exports = baseUnset;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(143);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the set cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var map = this.__data__;
	  if (isKeyable(value)) {
	    var data = map.__data__,
	        hash = typeof value == 'string' ? data.string : data.hash;
	
	    hash[value] = HASH_UNDEFINED;
	  }
	  else {
	    map.set(value, HASH_UNDEFINED);
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 857 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 858 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var Ctor = buffer.constructor,
	      result = new Ctor(buffer.length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(832),
	    arrayReduce = __webpack_require__(159),
	    mapToArray = __webpack_require__(347);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map) {
	  var Ctor = map.constructor;
	  return arrayReduce(mapToArray(map), addMapEntry, new Ctor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 860 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var Ctor = regexp.constructor,
	      result = new Ctor(regexp.source, reFlags.exec(regexp));
	
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(833),
	    arrayReduce = __webpack_require__(159),
	    setToArray = __webpack_require__(206);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set) {
	  var Ctor = set.constructor;
	  return arrayReduce(setToArray(set), addSetEntry, new Ctor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = Symbol ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return Symbol ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(452);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var arrayBuffer = typedArray.buffer,
	      buffer = isDeep ? cloneArrayBuffer(arrayBuffer) : arrayBuffer,
	      Ctor = typedArray.constructor;
	
	  return new Ctor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(453);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(161),
	    getSymbols = __webpack_require__(878);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 866 */
/***/ function(module, exports) {

	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	module.exports = countHolders;


/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	var createCtorWrapper = __webpack_require__(202),
	    root = __webpack_require__(61);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBaseWrapper(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	module.exports = createBaseWrapper;


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    createCtorWrapper = __webpack_require__(202),
	    createHybridWrapper = __webpack_require__(460),
	    createRecurryWrapper = __webpack_require__(463),
	    getPlaceholder = __webpack_require__(141),
	    replaceHolders = __webpack_require__(115),
	    root = __webpack_require__(61);
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurryWrapper(func, bitmask, arity) {
	  var Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getPlaceholder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurryWrapper(
	        func, bitmask, createHybridWrapper, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createCurryWrapper;


/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    createCtorWrapper = __webpack_require__(202),
	    root = __webpack_require__(61);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1;
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg` and the `partials` prepended to those provided to
	 * the wrapper.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask of wrapper flags. See `createWrapper` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartialWrapper(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtorWrapper(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	module.exports = createPartialWrapper;


/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(419),
	    noop = __webpack_require__(356);
	
	/**
	 * Creates a set of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && new Set([1, 2]).size === 2) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 871 */
/***/ function(module, exports) {

	/** Used to map latin-1 supplementary letters to basic latin letters. */
	var deburredLetters = {
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss'
	};
	
	/**
	 * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	function deburrLetter(letter) {
	  return deburredLetters[letter];
	}
	
	module.exports = deburrLetter;


/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(321);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} [stack] Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var index = -1,
	      isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      isUnordered = bitmask & UNORDERED_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isUnordered) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack);
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    Uint8Array = __webpack_require__(420),
	    mapToArray = __webpack_require__(347),
	    setToArray = __webpack_require__(206);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = Symbol ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask) {
	  switch (tag) {
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return (isPartial || object.size == other.size) &&
	        equalFunc(convert(object), convert(other), customizer, bitmask | UNORDERED_COMPARE_FLAG);
	
	    case symbolTag:
	      return !!Symbol && (symbolValueOf.call(object) == symbolValueOf.call(other));
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(328),
	    keys = __webpack_require__(54);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual` for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 875 */
/***/ function(module, exports) {

	/** Used to map characters to HTML entities. */
	var htmlEscapes = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '`': '&#96;'
	};
	
	/**
	 * Used by `_.escape` to convert characters to HTML entities.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeHtmlChar(chr) {
	  return htmlEscapes[chr];
	}
	
	module.exports = escapeHtmlChar;


/***/ },
/* 876 */
/***/ function(module, exports) {

	/** Used to escape characters for inclusion in compiled string literals. */
	var stringEscapes = {
	  '\\': '\\',
	  "'": "'",
	  '\n': 'n',
	  '\r': 'r',
	  '\u2028': 'u2028',
	  '\u2029': 'u2029'
	};
	
	/**
	 * Used by `_.template` to escape characters for inclusion in compiled string literals.
	 *
	 * @private
	 * @param {string} chr The matched character to escape.
	 * @returns {string} Returns the escaped character.
	 */
	function escapeStringChar(chr) {
	  return '\\' + stringEscapes[chr];
	}
	
	module.exports = escapeStringChar;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(333);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 878 */
/***/ function(module, exports) {

	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = getOwnPropertySymbols || function() {
	  return [];
	};
	
	module.exports = getSymbols;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	var hashHas = __webpack_require__(466);
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(hash, key) {
	  return hashHas(hash, key) && delete hash[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @param {Object} hash The hash to query.
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(hash, key) {
	  if (nativeCreate) {
	    var result = hash[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(hash, key) ? hash[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(205);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 */
	function hashSet(hash, key, value) {
	  hash[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	}
	
	module.exports = hashSet;


/***/ },
/* 882 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(452),
	    cloneMap = __webpack_require__(859),
	    cloneRegExp = __webpack_require__(860),
	    cloneSet = __webpack_require__(861),
	    cloneSymbol = __webpack_require__(862),
	    cloneTypedArray = __webpack_require__(863);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(136),
	    isFunction = __webpack_require__(67),
	    isPrototype = __webpack_require__(346);
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (isFunction(object.constructor) && !isPrototype(object))
	    ? baseCreate(getPrototypeOf(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(830),
	    Map = __webpack_require__(134);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': Map ? new Map : [],
	    'string': new Hash
	  };
	}
	
	module.exports = mapClear;


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(134),
	    assocDelete = __webpack_require__(425),
	    hashDelete = __webpack_require__(879),
	    isKeyable = __webpack_require__(143);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapDelete(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashDelete(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map['delete'](key) : assocDelete(data.map, key);
	}
	
	module.exports = mapDelete;


/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(134),
	    assocGet = __webpack_require__(426),
	    hashGet = __webpack_require__(880),
	    isKeyable = __webpack_require__(143);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapGet(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashGet(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.get(key) : assocGet(data.map, key);
	}
	
	module.exports = mapGet;


/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(134),
	    assocHas = __webpack_require__(427),
	    hashHas = __webpack_require__(466),
	    isKeyable = __webpack_require__(143);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapHas(key) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    return hashHas(typeof key == 'string' ? data.string : data.hash, key);
	  }
	  return Map ? data.map.has(key) : assocHas(data.map, key);
	}
	
	module.exports = mapHas;


/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(134),
	    assocSet = __webpack_require__(428),
	    hashSet = __webpack_require__(881),
	    isKeyable = __webpack_require__(143);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache object.
	 */
	function mapSet(key, value) {
	  var data = this.__data__;
	  if (isKeyable(key)) {
	    hashSet(typeof key == 'string' ? data.string : data.hash, key, value);
	  } else if (Map) {
	    data.map.set(key, value);
	  } else {
	    assocSet(data.map, key, value);
	  }
	  return this;
	}
	
	module.exports = mapSet;


/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	var composeArgs = __webpack_require__(454),
	    composeArgsRight = __webpack_require__(455),
	    copyArray = __webpack_require__(100),
	    replaceHolders = __webpack_require__(115);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256;
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Merges the function metadata of `source` into `data`.
	 *
	 * Merging metadata reduces the number of wrappers used to invoke a function.
	 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	 * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	 * modify function arguments, making the order in which they are executed important,
	 * preventing the merging of metadata. However, we make an exception for a safe
	 * combined case where curried functions have `_.ary` and or `_.rearg` applied.
	 *
	 * @private
	 * @param {Array} data The destination metadata.
	 * @param {Array} source The source metadata.
	 * @returns {Array} Returns `data`.
	 */
	function mergeData(data, source) {
	  var bitmask = data[1],
	      srcBitmask = source[1],
	      newBitmask = bitmask | srcBitmask,
	      isCommon = newBitmask < (BIND_FLAG | BIND_KEY_FLAG | ARY_FLAG);
	
	  var isCombo =
	    ((srcBitmask == ARY_FLAG) && (bitmask == CURRY_FLAG)) ||
	    ((srcBitmask == ARY_FLAG) && (bitmask == REARG_FLAG) && (data[7].length <= source[8])) ||
	    ((srcBitmask == (ARY_FLAG | REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == CURRY_FLAG));
	
	  // Exit early if metadata can't be merged.
	  if (!(isCommon || isCombo)) {
	    return data;
	  }
	  // Use source `thisArg` if available.
	  if (srcBitmask & BIND_FLAG) {
	    data[2] = source[2];
	    // Set when currying a bound function.
	    newBitmask |= bitmask & BIND_FLAG ? 0 : CURRY_BOUND_FLAG;
	  }
	  // Compose partial arguments.
	  var value = source[3];
	  if (value) {
	    var partials = data[3];
	    data[3] = partials ? composeArgs(partials, value, source[4]) : copyArray(value);
	    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : copyArray(source[4]);
	  }
	  // Compose partial right arguments.
	  value = source[5];
	  if (value) {
	    partials = data[5];
	    data[5] = partials ? composeArgsRight(partials, value, source[6]) : copyArray(value);
	    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : copyArray(source[6]);
	  }
	  // Use source `argPos` if available.
	  value = source[7];
	  if (value) {
	    data[7] = copyArray(value);
	  }
	  // Use source `ary` if it's smaller.
	  if (srcBitmask & ARY_FLAG) {
	    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	  }
	  // Use source `arity` if one is not provided.
	  if (data[9] == null) {
	    data[9] = source[9];
	  }
	  // Use source `func` and merge bitmasks.
	  data[0] = source[0];
	  data[1] = newBitmask;
	
	  return data;
	}
	
	module.exports = mergeData;


/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(332),
	    isObject = __webpack_require__(46);
	
	/**
	 * Used by `_.defaultsDeep` to customize its `_.merge` use.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to merge.
	 * @param {Object} object The parent object of `objValue`.
	 * @param {Object} source The parent object of `srcValue`.
	 * @param {Object} [stack] Tracks traversed source values and their merged counterparts.
	 * @returns {*} Returns the value to assign.
	 */
	function mergeDefaults(objValue, srcValue, key, object, source, stack) {
	  if (isObject(objValue) && isObject(srcValue)) {
	    stack.set(srcValue, objValue);
	    baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
	  }
	  return objValue;
	}
	
	module.exports = mergeDefaults;


/***/ },
/* 893 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEscape = /<%-([\s\S]+?)%>/g;
	
	module.exports = reEscape;


/***/ },
/* 894 */
/***/ function(module, exports) {

	/** Used to match template delimiters. */
	var reEvaluate = /<%([\s\S]+?)%>/g;
	
	module.exports = reEvaluate;


/***/ },
/* 895 */
/***/ function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var copyArray = __webpack_require__(100),
	    isIndex = __webpack_require__(114);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	module.exports = reorder;


/***/ },
/* 897 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = { 'array': [], 'map': null };
	}
	
	module.exports = stackClear;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	var assocDelete = __webpack_require__(425);
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocDelete(array, key) : data.map['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var assocGet = __webpack_require__(426);
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocGet(array, key) : data.map.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	var assocHas = __webpack_require__(427);
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  var data = this.__data__,
	      array = data.array;
	
	  return array ? assocHas(array, key) : data.map.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(317),
	    assocSet = __webpack_require__(428);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache object.
	 */
	function stackSet(key, value) {
	  var data = this.__data__,
	      array = data.array;
	
	  if (array) {
	    if (array.length < (LARGE_ARRAY_SIZE - 1)) {
	      assocSet(array, key, value);
	    } else {
	      data.array = null;
	      data.map = new MapCache(array);
	    }
	  }
	  var map = data.map;
	  if (map) {
	    map.set(key, value);
	  }
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 902 */
/***/ function(module, exports) {

	/** Used to map HTML entities to characters. */
	var htmlUnescapes = {
	  '&amp;': '&',
	  '&lt;': '<',
	  '&gt;': '>',
	  '&quot;': '"',
	  '&#39;': "'",
	  '&#96;': '`'
	};
	
	/**
	 * Used by `_.unescape` to convert HTML entities to characters.
	 *
	 * @private
	 * @param {string} chr The matched character to unescape.
	 * @returns {string} Returns the unescaped character.
	 */
	function unescapeHtmlChar(chr) {
	  return htmlUnescapes[chr];
	}
	
	module.exports = unescapeHtmlChar;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(315),
	    LodashWrapper = __webpack_require__(316),
	    copyArray = __webpack_require__(100);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ },
/* 904 */
/***/ function(module, exports) {

	/**
	 * Adds two numbers.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {number} augend The first number in an addition.
	 * @param {number} addend The second number in an addition.
	 * @returns {number} Returns the total.
	 * @example
	 *
	 * _.add(6, 4);
	 * // => 10
	 */
	function add(augend, addend) {
	  var result;
	  if (augend === undefined && addend === undefined) {
	    return 0;
	  }
	  if (augend !== undefined) {
	    result = augend;
	  }
	  if (addend !== undefined) {
	    result = result === undefined ? addend : (result + addend);
	  }
	  return result;
	}
	
	module.exports = add;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * The opposite of `_.before`; this method creates a function that invokes
	 * `func` once it's called `n` or more times.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {number} n The number of calls before `func` is invoked.
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var saves = ['profile', 'settings'];
	 *
	 * var done = _.after(saves.length, function() {
	 *   console.log('done saving!');
	 * });
	 *
	 * _.forEach(saves, function(type) {
	 *   asyncSave({ 'type': type, 'complete': done });
	 * });
	 * // => logs 'done saving!' after the two async saves have completed
	 */
	function after(n, func) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  n = toInteger(n);
	  return function() {
	    if (--n < 1) {
	      return func.apply(this, arguments);
	    }
	  };
	}
	
	module.exports = after;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(161),
	    createAssigner = __webpack_require__(139),
	    keys = __webpack_require__(54);
	
	/**
	 * Assigns own enumerable properties of source objects to the destination
	 * object. Source objects are applied from left to right. Subsequent sources
	 * overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.c = 3;
	 * }
	 *
	 * function Bar() {
	 *   this.e = 5;
	 * }
	 *
	 * Foo.prototype.d = 4;
	 * Bar.prototype.f = 6;
	 *
	 * _.assign({ 'a': 1 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3, 'e': 5 }
	 */
	var assign = createAssigner(function(object, source) {
	  copyObject(source, keys(source), object);
	});
	
	module.exports = assign;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var copyObjectWith = __webpack_require__(340),
	    createAssigner = __webpack_require__(139),
	    keys = __webpack_require__(54);
	
	/**
	 * This method is like `_.assign` except that it accepts `customizer` which
	 * is invoked to produce the assigned values. If `customizer` returns `undefined`
	 * assignment is handled by the method instead. The `customizer` is invoked
	 * with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObjectWith(source, keys(source), object, customizer);
	});
	
	module.exports = assignWith;


/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	var baseAt = __webpack_require__(430),
	    baseFlatten = __webpack_require__(43),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of values corresponding to `paths` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {...(string|string[])} [paths] The property paths of elements to pick,
	 *  specified individually or in arrays.
	 * @returns {Array} Returns the new array of picked elements.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	 *
	 * _.at(object, ['a[0].b.c', 'a[1]']);
	 * // => [3, 4]
	 *
	 * _.at(['a', 'b', 'c'], 0, 2);
	 * // => ['a', 'c']
	 */
	var at = rest(function(object, paths) {
	  return baseAt(object, baseFlatten(paths, 1));
	});
	
	module.exports = at;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(135),
	    baseFlatten = __webpack_require__(43),
	    bind = __webpack_require__(479),
	    rest = __webpack_require__(16);
	
	/**
	 * Binds methods of an object to the object itself, overwriting the existing
	 * method.
	 *
	 * **Note:** This method doesn't set the "length" property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Object} object The object to bind and assign the bound methods to.
	 * @param {...(string|string[])} methodNames The object method names to bind,
	 *  specified individually or in arrays.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var view = {
	 *   'label': 'docs',
	 *   'onClick': function() {
	 *     console.log('clicked ' + this.label);
	 *   }
	 * };
	 *
	 * _.bindAll(view, 'onClick');
	 * jQuery(element).on('click', view.onClick);
	 * // => logs 'clicked docs' when clicked
	 */
	var bindAll = rest(function(object, methodNames) {
	  arrayEach(baseFlatten(methodNames, 1), function(key) {
	    object[key] = bind(object[key], object);
	  });
	  return object;
	});
	
	module.exports = bindAll;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85),
	    getPlaceholder = __webpack_require__(141),
	    replaceHolders = __webpack_require__(115),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    PARTIAL_FLAG = 32;
	
	/**
	 * Creates a function that invokes the method at `object[key]` and prepends
	 * any additional `_.bindKey` arguments to those provided to the bound function.
	 *
	 * This method differs from `_.bind` by allowing bound functions to reference
	 * methods that may be redefined or don't yet exist.
	 * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	 * for more details.
	 *
	 * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Object} object The object to invoke the method on.
	 * @param {string} key The key of the method.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * var object = {
	 *   'user': 'fred',
	 *   'greet': function(greeting, punctuation) {
	 *     return greeting + ' ' + this.user + punctuation;
	 *   }
	 * };
	 *
	 * var bound = _.bindKey(object, 'greet', 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * object.greet = function(greeting, punctuation) {
	 *   return greeting + 'ya ' + this.user + punctuation;
	 * };
	 *
	 * bound('!');
	 * // => 'hiya fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bindKey(object, 'greet', _, '!');
	 * bound('hi');
	 * // => 'hiya fred!'
	 */
	var bindKey = rest(function(object, key, partials) {
	  var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getPlaceholder(bindKey));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrapper(key, bitmask, object, partials, holders);
	});
	
	// Assign default placeholders.
	bindKey.placeholder = {};
	
	module.exports = bindKey;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(348),
	    createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__foo_bar__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});
	
	module.exports = camelCase;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(27);
	
	/**
	 * Casts `value` as an array if it's not one.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast array.
	 * @example
	 *
	 * _.castArray(1);
	 * // => [1]
	 *
	 * _.castArray({ 'a': 1 });
	 * // => [{ 'a': 1 }]
	 *
	 * _.castArray('abc');
	 * // => ['abc']
	 *
	 * _.castArray(null);
	 * // => [null]
	 *
	 * _.castArray(undefined);
	 * // => [undefined]
	 *
	 * _.castArray();
	 * // => []
	 *
	 * var array = [1, 2, 3];
	 * console.log(_.castArray(array) === array);
	 * // => true
	 */
	function castArray() {
	  if (!arguments.length) {
	    return [];
	  }
	  var value = arguments[0];
	  return isArray(value) ? value : [value];
	}
	
	module.exports = castArray;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(343);
	
	/**
	 * Computes `number` rounded up to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {number} number The number to round up.
	 * @param {number} [precision=0] The precision to round up to.
	 * @returns {number} Returns the rounded up number.
	 * @example
	 *
	 * _.ceil(4.006);
	 * // => 5
	 *
	 * _.ceil(6.004, 2);
	 * // => 6.01
	 *
	 * _.ceil(6040, -2);
	 * // => 6100
	 */
	var ceil = createRound('ceil');
	
	module.exports = ceil;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    toInteger = __webpack_require__(31);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=0] The length of each chunk.
	 * @returns {Array} Returns the new array containing chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size) {
	  size = nativeMax(toInteger(size), 0);
	
	  var length = array ? array.length : 0;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = -1,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[++resIndex] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83);
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value);
	}
	
	module.exports = clone;


/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83);
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83);
	
	/**
	 * This method is like `_.cloneWith` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * }
	 *
	 * var el = _.cloneDeepWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 20
	 */
	function cloneDeepWith(value, customizer) {
	  return baseClone(value, true, customizer);
	}
	
	module.exports = cloneDeepWith;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83);
	
	/**
	 * This method is like `_.clone` except that it accepts `customizer` which
	 * is invoked to produce the cloned value. If `customizer` returns `undefined`
	 * cloning is handled by the method instead. The `customizer` is invoked with
	 * up to four arguments; (value [, index|key, object, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @returns {*} Returns the cloned value.
	 * @example
	 *
	 * function customizer(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(false);
	 *   }
	 * }
	 *
	 * var el = _.cloneWith(document.body, customizer);
	 *
	 * console.log(el === document.body);
	 * // => false
	 * console.log(el.nodeName);
	 * // => 'BODY'
	 * console.log(el.childNodes.length);
	 * // => 0
	 */
	function cloneWith(value, customizer) {
	  return baseClone(value, false, customizer);
	}
	
	module.exports = cloneWith;


/***/ },
/* 919 */
/***/ function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	var arrayConcat = __webpack_require__(835),
	    baseFlatten = __webpack_require__(43),
	    isArray = __webpack_require__(27),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates a new array concatenating `array` with any additional arrays
	 * and/or values.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to concatenate.
	 * @param {...*} [values] The values to concatenate.
	 * @returns {Array} Returns the new concatenated array.
	 * @example
	 *
	 * var array = [1];
	 * var other = _.concat(array, 2, [3], [[4]]);
	 *
	 * console.log(other);
	 * // => [1, 2, 3, [4]]
	 *
	 * console.log(array);
	 * // => [1]
	 */
	var concat = rest(function(array, values) {
	  if (!isArray(array)) {
	    array = array == null ? [] : [Object(array)];
	  }
	  values = baseFlatten(values, 1);
	  return arrayConcat(array, values);
	});
	
	module.exports = concat;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    arrayMap = __webpack_require__(45),
	    baseIteratee = __webpack_require__(17),
	    rest = __webpack_require__(16);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that iterates over `pairs` invoking the corresponding
	 * function of the first predicate to return truthy. The predicate-function
	 * pairs are invoked with the `this` binding and arguments of the created
	 * function.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Array} pairs The predicate-function pairs.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.cond([
	 *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	 *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	 *   [_.constant(true),                _.constant('no match')]
	 * ]);
	 *
	 * func({ 'a': 1, 'b': 2 });
	 * // => 'matches A'
	 *
	 * func({ 'a': 0, 'b': 1 });
	 * // => 'matches B'
	 *
	 * func({ 'a': '1', 'b': '2' });
	 * // => 'no match'
	 */
	function cond(pairs) {
	  var length = pairs ? pairs.length : 0;
	
	  pairs = !length ? [] : arrayMap(pairs, function(pair) {
	    if (typeof pair[1] != 'function') {
	      throw new TypeError(FUNC_ERROR_TEXT);
	    }
	    return [baseIteratee(pair[0]), pair[1]];
	  });
	
	  return rest(function(args) {
	    var index = -1;
	    while (++index < length) {
	      var pair = pairs[index];
	      if (apply(pair[0], this, args)) {
	        return apply(pair[1], this, args);
	      }
	    }
	  });
	}
	
	module.exports = cond;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83),
	    baseConforms = __webpack_require__(839);
	
	/**
	 * Creates a function that invokes the predicate properties of `source` with
	 * the corresponding property values of a given object, returning `true` if
	 * all predicates return truthy, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Object} source The object of property predicates to conform to.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 }
	 * ];
	 *
	 * _.filter(users, _.conforms({ 'age': _.partial(_.gt, _, 38) }));
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 */
	function conforms(source) {
	  return baseConforms(baseClone(source, true));
	}
	
	module.exports = conforms;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(201);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` through `iteratee`. The corresponding value
	 * of each key is the number of times the key was returned by `iteratee`.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.countBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': 1, '6': 2 }
	 *
	 * _.countBy(['one', 'two', 'three'], 'length');
	 * // => { '3': 2, '5': 1 }
	 */
	var countBy = createAggregator(function(result, value, key) {
	  hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	});
	
	module.exports = countBy;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(429),
	    baseCreate = __webpack_require__(136);
	
	/**
	 * Creates an object that inherits from the `prototype` object. If a `properties`
	 * object is given its own enumerable properties are assigned to the created object.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} prototype The object to inherit from.
	 * @param {Object} [properties] The properties to assign to the object.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * function Shape() {
	 *   this.x = 0;
	 *   this.y = 0;
	 * }
	 *
	 * function Circle() {
	 *   Shape.call(this);
	 * }
	 *
	 * Circle.prototype = _.create(Shape.prototype, {
	 *   'constructor': Circle
	 * });
	 *
	 * var circle = new Circle;
	 * circle instanceof Circle;
	 * // => true
	 *
	 * circle instanceof Shape;
	 * // => true
	 */
	function create(prototype, properties) {
	  var result = baseCreate(prototype);
	  return properties ? baseAssign(result, properties) : result;
	}
	
	module.exports = create;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_FLAG = 8;
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrapper(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var CURRY_RIGHT_FLAG = 16;
	
	/**
	 * This method is like `_.curry` except that arguments are applied to `func`
	 * in the manner of `_.partialRight` instead of `_.partial`.
	 *
	 * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curryRight(abc);
	 *
	 * curried(3)(2)(1);
	 * // => [1, 2, 3]
	 *
	 * curried(2, 3)(1);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(3)(1, _)(2);
	 * // => [1, 2, 3]
	 */
	function curryRight(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrapper(func, CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curryRight.placeholder;
	  return result;
	}
	
	// Assign default placeholders.
	curryRight.placeholder = {};
	
	module.exports = curryRight;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    assignInDefaults = __webpack_require__(423),
	    assignInWith = __webpack_require__(208),
	    rest = __webpack_require__(16);
	
	/**
	 * Assigns own and inherited enumerable properties of source objects to the
	 * destination object for all destination properties that resolve to `undefined`.
	 * Source objects are applied from left to right. Once a property is set,
	 * additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var defaults = rest(function(args) {
	  args.push(undefined, assignInDefaults);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    mergeDefaults = __webpack_require__(892),
	    mergeWith = __webpack_require__(495),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.defaults` except that it recursively assigns
	 * default properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	 * // => { 'user': { 'name': 'barney', 'age': 36 } }
	 *
	 */
	var defaultsDeep = rest(function(args) {
	  args.push(undefined, mergeDefaults);
	  return apply(mergeWith, undefined, args);
	});
	
	module.exports = defaultsDeep;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(431),
	    rest = __webpack_require__(16);
	
	/**
	 * Defers invoking the `func` until the current call stack has cleared. Any
	 * additional arguments are provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to defer.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.defer(function(text) {
	 *   console.log(text);
	 * }, 'deferred');
	 * // => logs 'deferred' after one or more milliseconds
	 */
	var defer = rest(function(func, args) {
	  return baseDelay(func, 1, args);
	});
	
	module.exports = defer;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var baseDelay = __webpack_require__(431),
	    rest = __webpack_require__(16),
	    toNumber = __webpack_require__(145);
	
	/**
	 * Invokes `func` after `wait` milliseconds. Any additional arguments are
	 * provided to `func` when it's invoked.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to delay.
	 * @param {number} wait The number of milliseconds to delay invocation.
	 * @param {...*} [args] The arguments to invoke `func` with.
	 * @returns {number} Returns the timer id.
	 * @example
	 *
	 * _.delay(function(text) {
	 *   console.log(text);
	 * }, 1000, 'later');
	 * // => logs 'later' after one second
	 */
	var delay = rest(function(func, wait, args) {
	  return baseDelay(func, toNumber(wait) || 0, args);
	});
	
	module.exports = delay;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(137),
	    baseFlatten = __webpack_require__(43),
	    isArrayLikeObject = __webpack_require__(52),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of unique `array` values not included in the other
	 * given arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.difference([3, 2, 1], [4, 2]);
	 * // => [3, 1]
	 */
	var difference = rest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(137),
	    baseFlatten = __webpack_require__(43),
	    baseIteratee = __webpack_require__(17),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.difference` except that it accepts `iteratee` which
	 * is invoked for each element of `array` and `values` to generate the criterion
	 * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.differenceBy([3.1, 2.2, 1.3], [4.4, 2.5], Math.floor);
	 * // => [3.1, 1.3]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	 * // => [{ 'x': 2 }]
	 */
	var differenceBy = rest(function(array, values) {
	  var iteratee = last(values);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, true), baseIteratee(iteratee))
	    : [];
	});
	
	module.exports = differenceBy;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(137),
	    baseFlatten = __webpack_require__(43),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.difference` except that it accepts `comparator`
	 * which is invoked to compare elements of `array` to `values`. The comparator
	 * is invoked with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 *
	 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }]
	 */
	var differenceWith = rest(function(array, values) {
	  var comparator = last(values);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, true), undefined, comparator)
	    : [];
	});
	
	module.exports = differenceWith;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseWhile = __webpack_require__(200);
	
	/**
	 * Creates a slice of `array` excluding elements dropped from the end.
	 * Elements are dropped until `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.dropRightWhile(users, function(o) { return !o.active; });
	 * // => objects for ['barney']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.dropRightWhile(users, ['active', false]);
	 * // => objects for ['barney']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.dropRightWhile(users, 'active');
	 * // => objects for ['barney', 'fred', 'pebbles']
	 */
	function dropRightWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), true, true)
	    : [];
	}
	
	module.exports = dropRightWhile;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseWhile = __webpack_require__(200);
	
	/**
	 * Creates a slice of `array` excluding elements dropped from the beginning.
	 * Elements are dropped until `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.dropWhile(users, function(o) { return !o.active; });
	 * // => objects for ['pebbles']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.dropWhile(users, { 'user': 'barney', 'active': false });
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.dropWhile(users, ['active', false]);
	 * // => objects for ['pebbles']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.dropWhile(users, 'active');
	 * // => objects for ['barney', 'fred', 'pebbles']
	 */
	function dropWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), true)
	    : [];
	}
	
	module.exports = dropWhile;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(350);


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(485);


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(160),
	    toInteger = __webpack_require__(31),
	    toString = __webpack_require__(34);
	
	/**
	 * Checks if `string` ends with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to search.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=string.length] The position to search from.
	 * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	 * @example
	 *
	 * _.endsWith('abc', 'c');
	 * // => true
	 *
	 * _.endsWith('abc', 'b');
	 * // => false
	 *
	 * _.endsWith('abc', 'b', 2);
	 * // => true
	 */
	function endsWith(string, target, position) {
	  string = toString(string);
	  target = typeof target == 'string' ? target : (target + '');
	
	  var length = string.length;
	  position = position === undefined
	    ? length
	    : baseClamp(toInteger(position), 0, length);
	
	  position -= target.length;
	  return position >= 0 && string.indexOf(target, position) == position;
	}
	
	module.exports = endsWith;


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/** Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns). */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	    reHasRegExpChar = RegExp(reRegExpChar.source);
	
	/**
	 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to escape.
	 * @returns {string} Returns the escaped string.
	 * @example
	 *
	 * _.escapeRegExp('[lodash](https://lodash.com/)');
	 * // => '\[lodash\]\(https://lodash\.com/\)'
	 */
	function escapeRegExp(string) {
	  string = toString(string);
	  return (string && reHasRegExpChar.test(string))
	    ? string.replace(reRegExpChar, '\\$&')
	    : string;
	}
	
	module.exports = escapeRegExp;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(422),
	    baseEvery = __webpack_require__(840),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27),
	    isIterateeCall = __webpack_require__(101);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check, else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': false },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(476);


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(208);


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	var baseFill = __webpack_require__(841),
	    isIterateeCall = __webpack_require__(101);
	
	/**
	 * Fills elements of `array` with `value` from `start` up to, but not
	 * including, `end`.
	 *
	 * **Note:** This method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to fill.
	 * @param {*} value The value to fill `array` with.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.fill(array, 'a');
	 * console.log(array);
	 * // => ['a', 'a', 'a']
	 *
	 * _.fill(Array(3), 2);
	 * // => [2, 2, 2]
	 *
	 * _.fill([4, 6, 8, 10], '*', 1, 3);
	 * // => [4, '*', '*', 10]
	 */
	function fill(array, value, start, end) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	    start = 0;
	    end = length;
	  }
	  return baseFill(array, value, start, end);
	}
	
	module.exports = fill;


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    baseFilter = __webpack_require__(432),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(84),
	    baseFind = __webpack_require__(195),
	    baseFindIndex = __webpack_require__(196),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	function find(collection, predicate) {
	  predicate = baseIteratee(predicate, 3);
	  if (isArray(collection)) {
	    var index = baseFindIndex(collection, predicate);
	    return index > -1 ? collection[index] : undefined;
	  }
	  return baseFind(collection, predicate, baseEach);
	}
	
	module.exports = find;


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(196),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate) {
	  return (array && array.length)
	    ? baseFindIndex(array, baseIteratee(predicate, 3))
	    : -1;
	}
	
	module.exports = findIndex;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	var baseFind = __webpack_require__(195),
	    baseForOwn = __webpack_require__(98),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFind(object, baseIteratee(predicate, 3), baseForOwn, true);
	}
	
	module.exports = findKey;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	var baseEachRight = __webpack_require__(323),
	    baseFind = __webpack_require__(195),
	    baseFindIndex = __webpack_require__(196),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27);
	
	/**
	 * This method is like `_.find` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * _.findLast([1, 2, 3, 4], function(n) {
	 *   return n % 2 == 1;
	 * });
	 * // => 3
	 */
	function findLast(collection, predicate) {
	  predicate = baseIteratee(predicate, 3);
	  if (isArray(collection)) {
	    var index = baseFindIndex(collection, predicate, true);
	    return index > -1 ? collection[index] : undefined;
	  }
	  return baseFind(collection, predicate, baseEachRight);
	}
	
	module.exports = findLast;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(196),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * This method is like `_.findIndex` except that it iterates over elements
	 * of `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	 * // => 2
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	 * // => 0
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastIndex(users, ['active', false]);
	 * // => 2
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastIndex(users, 'active');
	 * // => 0
	 */
	function findLastIndex(array, predicate) {
	  return (array && array.length)
	    ? baseFindIndex(array, baseIteratee(predicate, 3), true)
	    : -1;
	}
	
	module.exports = findLastIndex;


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	var baseFind = __webpack_require__(195),
	    baseForOwnRight = __webpack_require__(325),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * This method is like `_.findKey` except that it iterates over elements of
	 * a collection in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findLastKey(users, function(o) { return o.age < 40; });
	 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastKey(users, { 'age': 36, 'active': true });
	 * // => 'barney'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastKey(users, 'active');
	 * // => 'pebbles'
	 */
	function findLastKey(object, predicate) {
	  return baseFind(object, baseIteratee(predicate, 3), baseForOwnRight, true);
	}
	
	module.exports = findLastKey;


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    map = __webpack_require__(494);
	
	/**
	 * Creates an array of flattened values by running each element in `collection`
	 * through `iteratee` and concating its result to the other mapped values.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	module.exports = flattenDeep;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Recursively flatten `array` up to `depth` times.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @param {number} [depth=1] The maximum recursion depth.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * var array = [1, [2, [3, [4]], 5]];
	 *
	 * _.flattenDepth(array, 1);
	 * // => [1, 2, [3, [4]], 5]
	 *
	 * _.flattenDepth(array, 2);
	 * // => [1, 2, 3, [4], 5]
	 */
	function flattenDepth(array, depth) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  depth = depth === undefined ? 1 : toInteger(depth);
	  return baseFlatten(array, depth);
	}
	
	module.exports = flattenDepth;


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var FLIP_FLAG = 512;
	
	/**
	 * Creates a function that invokes `func` with arguments reversed.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to flip arguments for.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var flipped = _.flip(function() {
	 *   return _.toArray(arguments);
	 * });
	 *
	 * flipped('a', 'b', 'c', 'd');
	 * // => ['d', 'c', 'b', 'a']
	 */
	function flip(func) {
	  return createWrapper(func, FLIP_FLAG);
	}
	
	module.exports = flip;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(343);
	
	/**
	 * Computes `number` rounded down to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {number} number The number to round down.
	 * @param {number} [precision=0] The precision to round down to.
	 * @returns {number} Returns the rounded down number.
	 * @example
	 *
	 * _.floor(4.006);
	 * // => 4
	 *
	 * _.floor(0.046, 2);
	 * // => 0.04
	 *
	 * _.floor(4060, -2);
	 * // => 4000
	 */
	var floor = createRound('floor');
	
	module.exports = floor;


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(459);
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] Functions to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow(_.add, square);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(459);
	
	/**
	 * This method is like `_.flow` except that it creates a function that
	 * invokes the given functions from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] Functions to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flowRight(square, _.add);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flowRight = createFlow(true);
	
	module.exports = flowRight;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastFunction = __webpack_require__(111),
	    baseFor = __webpack_require__(324),
	    keysIn = __webpack_require__(68);
	
	/**
	 * Iterates over own and inherited enumerable properties of an object invoking
	 * `iteratee` for each property. The iteratee is invoked with three arguments:
	 * (value, key, object). Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a', 'b', then 'c' (iteration order is not guaranteed)
	 */
	function forIn(object, iteratee) {
	  return object == null
	    ? object
	    : baseFor(object, baseCastFunction(iteratee), keysIn);
	}
	
	module.exports = forIn;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastFunction = __webpack_require__(111),
	    baseForRight = __webpack_require__(433),
	    keysIn = __webpack_require__(68);
	
	/**
	 * This method is like `_.forIn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forInRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'
	 */
	function forInRight(object, iteratee) {
	  return object == null
	    ? object
	    : baseForRight(object, baseCastFunction(iteratee), keysIn);
	}
	
	module.exports = forInRight;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastFunction = __webpack_require__(111),
	    baseForOwn = __webpack_require__(98);
	
	/**
	 * Iterates over own enumerable properties of an object invoking `iteratee`
	 * for each property. The iteratee is invoked with three arguments:
	 * (value, key, object). Iteratee functions may exit iteration early by
	 * explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'a' then 'b' (iteration order is not guaranteed)
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, baseCastFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastFunction = __webpack_require__(111),
	    baseForOwnRight = __webpack_require__(325);
	
	/**
	 * This method is like `_.forOwn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwnRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'
	 */
	function forOwnRight(object, iteratee) {
	  return object && baseForOwnRight(object, baseCastFunction(iteratee));
	}
	
	module.exports = forOwnRight;


/***/ },
/* 963 */
/***/ function(module, exports) {

	/**
	 * The inverse of `_.toPairs`; this method returns an object composed
	 * from key-value `pairs`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} pairs The key-value pairs.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.fromPairs([['fred', 30], ['barney', 40]]);
	 * // => { 'fred': 30, 'barney': 40 }
	 */
	function fromPairs(pairs) {
	  var index = -1,
	      length = pairs ? pairs.length : 0,
	      result = {};
	
	  while (++index < length) {
	    var pair = pairs[index];
	    result[pair[0]] = pair[1];
	  }
	  return result;
	}
	
	module.exports = fromPairs;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(326),
	    keys = __webpack_require__(54);
	
	/**
	 * Creates an array of function property names from own enumerable properties
	 * of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the new array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functions(new Foo);
	 * // => ['a', 'b']
	 */
	function functions(object) {
	  return object == null ? [] : baseFunctions(object, keys(object));
	}
	
	module.exports = functions;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(326),
	    keysIn = __webpack_require__(68);
	
	/**
	 * Creates an array of function property names from own and inherited
	 * enumerable properties of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the new array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functionsIn(new Foo);
	 * // => ['a', 'b', 'c']
	 */
	function functionsIn(object) {
	  return object == null ? [] : baseFunctions(object, keysIn(object));
	}
	
	module.exports = functionsIn;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(201);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` through `iteratee`. The corresponding value
	 * of each key is an array of elements responsible for generating the key.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    result[key] = [value];
	  }
	});
	
	module.exports = groupBy;


/***/ },
/* 967 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is greater than or equal to `other`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	 * @example
	 *
	 * _.gte(3, 1);
	 * // => true
	 *
	 * _.gte(3, 3);
	 * // => true
	 *
	 * _.gte(1, 3);
	 * // => false
	 */
	function gte(value, other) {
	  return value >= other;
	}
	
	module.exports = gte;


/***/ },
/* 968 */
/***/ function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @alias first
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.head([1, 2, 3]);
	 * // => 1
	 *
	 * _.head([]);
	 * // => undefined
	 */
	function head(array) {
	  return array ? array[0] : undefined;
	}
	
	module.exports = head;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(138),
	    isArrayLike = __webpack_require__(66),
	    isString = __webpack_require__(117),
	    toInteger = __webpack_require__(31),
	    values = __webpack_require__(209);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string it's checked
	 * for a substring of `value`, otherwise [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	 * // => true
	 *
	 * _.includes('pebbles', 'eb');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(138),
	    toInteger = __webpack_require__(31);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Gets the index at which the first occurrence of `value` is found in `array`
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons. If `fromIndex` is negative, it's used as the offset
	 * from the end of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.indexOf([1, 2, 1, 2], 2);
	 * // => 1
	 *
	 * // Search from the `fromIndex`.
	 * _.indexOf([1, 2, 1, 2], 2, 2);
	 * // => 3
	 */
	function indexOf(array, value, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  fromIndex = toInteger(fromIndex);
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return baseIndexOf(array, value, fromIndex);
	}
	
	module.exports = indexOf;


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	var dropRight = __webpack_require__(483);
	
	/**
	 * Gets all but the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.initial([1, 2, 3]);
	 * // => [1, 2]
	 */
	function initial(array) {
	  return dropRight(array, 1);
	}
	
	module.exports = initial;


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseCastArrayLikeObject = __webpack_require__(322),
	    baseIntersection = __webpack_require__(329),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 *
	 * _.intersection([2, 1], [4, 2], [1, 2]);
	 * // => [2]
	 */
	var intersection = rest(function(arrays) {
	  var mapped = arrayMap(arrays, baseCastArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseCastArrayLikeObject = __webpack_require__(322),
	    baseIntersection = __webpack_require__(329),
	    baseIteratee = __webpack_require__(17),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.intersection` except that it accepts `iteratee`
	 * which is invoked for each element of each `arrays` to generate the criterion
	 * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 *
	 * _.intersectionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	 * // => [2.1]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }]
	 */
	var intersectionBy = rest(function(arrays) {
	  var iteratee = last(arrays),
	      mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	  if (iteratee === last(mapped)) {
	    iteratee = undefined;
	  } else {
	    mapped.pop();
	  }
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped, baseIteratee(iteratee))
	    : [];
	});
	
	module.exports = intersectionBy;


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseCastArrayLikeObject = __webpack_require__(322),
	    baseIntersection = __webpack_require__(329),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.intersection` except that it accepts `comparator`
	 * which is invoked to compare elements of `arrays`. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.intersectionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }]
	 */
	var intersectionWith = rest(function(arrays) {
	  var comparator = last(arrays),
	      mapped = arrayMap(arrays, baseCastArrayLikeObject);
	
	  if (comparator === last(mapped)) {
	    comparator = undefined;
	  } else {
	    mapped.pop();
	  }
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped, undefined, comparator)
	    : [];
	});
	
	module.exports = intersectionWith;


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(349),
	    createInverter = __webpack_require__(461),
	    identity = __webpack_require__(78);
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite property
	 * assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    createInverter = __webpack_require__(461);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * This method is like `_.invert` except that the inverted object is generated
	 * from the results of running each element of `object` through `iteratee`.
	 * The corresponding inverted value of each inverted key is an array of keys
	 * responsible for generating the inverted value. The iteratee is invoked
	 * with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invertBy(object);
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 *
	 * _.invertBy(object, function(value) {
	 *   return 'group' + value;
	 * });
	 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	 */
	var invertBy = createInverter(function(result, value, key) {
	  if (hasOwnProperty.call(result, value)) {
	    result[value].push(key);
	  } else {
	    result[value] = [key];
	  }
	}, baseIteratee);
	
	module.exports = invertBy;


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(197),
	    rest = __webpack_require__(16);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = rest(baseInvoke);
	
	module.exports = invoke;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    baseEach = __webpack_require__(84),
	    baseInvoke = __webpack_require__(197),
	    isArrayLike = __webpack_require__(66),
	    isKey = __webpack_require__(86),
	    rest = __webpack_require__(16);
	
	/**
	 * Invokes the method at `path` of each element in `collection`, returning
	 * an array of the results of each invoked method. Any additional arguments
	 * are provided to each invoked method. If `methodName` is a function it's
	 * invoked for, and `this` bound to, each element in `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array|Function|string} path The path of the method to invoke or
	 *  the function invoked per iteration.
	 * @param {...*} [args] The arguments to invoke each method with.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	 * // => [[1, 5, 7], [1, 2, 3]]
	 *
	 * _.invokeMap([123, 456], String.prototype.split, '');
	 * // => [['1', '2', '3'], ['4', '5', '6']]
	 */
	var invokeMap = rest(function(collection, path, args) {
	  var index = -1,
	      isFunc = typeof path == 'function',
	      isProp = isKey(path),
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value) {
	    var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	    result[++index] = func ? apply(func, value, args) : baseInvoke(value, path, args);
	  });
	  return result;
	});
	
	module.exports = invokeMap;


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	var arrayBufferTag = '[object ArrayBuffer]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as an `ArrayBuffer` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArrayBuffer(new ArrayBuffer(2));
	 * // => true
	 *
	 * _.isArrayBuffer(new Array(2));
	 * // => false
	 */
	function isArrayBuffer(value) {
	  return isObjectLike(value) && objectToString.call(value) == arrayBufferTag;
	}
	
	module.exports = isArrayBuffer;


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a boolean primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isBoolean(false);
	 * // => true
	 *
	 * _.isBoolean(null);
	 * // => false
	 */
	function isBoolean(value) {
	  return value === true || value === false ||
	    (isObjectLike(value) && objectToString.call(value) == boolTag);
	}
	
	module.exports = isBoolean;


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var dateTag = '[object Date]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Date` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isDate(new Date);
	 * // => true
	 *
	 * _.isDate('Mon April 23 2012');
	 * // => false
	 */
	function isDate(value) {
	  return isObjectLike(value) && objectToString.call(value) == dateTag;
	}
	
	module.exports = isDate;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47),
	    isPlainObject = __webpack_require__(353);
	
	/**
	 * Checks if `value` is likely a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	}
	
	module.exports = isElement;


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(144),
	    isArray = __webpack_require__(27),
	    isArrayLike = __webpack_require__(66),
	    isFunction = __webpack_require__(67),
	    isString = __webpack_require__(117);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is empty. A value is considered empty unless it's an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (isArrayLike(value) &&
	      (isArray(value) || isString(value) ||
	        isFunction(value.splice) || isArguments(value))) {
	    return !value.length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(198);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are **not** supported.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(198);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined` comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsFinite = root.isFinite;
	
	/**
	 * Checks if `value` is a finite primitive number.
	 *
	 * **Note:** This method is based on [`Number.isFinite`](https://mdn.io/Number/isFinite).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	 * @example
	 *
	 * _.isFinite(3);
	 * // => true
	 *
	 * _.isFinite(Number.MAX_VALUE);
	 * // => true
	 *
	 * _.isFinite(3.14);
	 * // => true
	 *
	 * _.isFinite(Infinity);
	 * // => false
	 */
	function isFinite(value) {
	  return typeof value == 'number' && nativeIsFinite(value);
	}
	
	module.exports = isFinite;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(142),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	function isMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = isMap;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(330),
	    getMatchData = __webpack_require__(345);
	
	/**
	 * Performs a partial deep comparison between `object` and `source` to
	 * determine if `object` contains equivalent property values. This method is
	 * equivalent to a `_.matches` function when `source` is partially applied.
	 *
	 * **Note:** This method supports comparing the same values as `_.isEqual`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred', 'age': 40 };
	 *
	 * _.isMatch(object, { 'age': 40 });
	 * // => true
	 *
	 * _.isMatch(object, { 'age': 36 });
	 * // => false
	 */
	function isMatch(object, source) {
	  return object === source || baseIsMatch(object, source, getMatchData(source));
	}
	
	module.exports = isMatch;


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(330),
	    getMatchData = __webpack_require__(345);
	
	/**
	 * This method is like `_.isMatch` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined` comparisons
	 * are handled by the method instead. The `customizer` is invoked with five
	 * arguments: (objValue, srcValue, index|key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var object = { 'greeting': 'hello' };
	 * var source = { 'greeting': 'hi' };
	 *
	 * _.isMatchWith(object, source, customizer);
	 * // => true
	 */
	function isMatchWith(object, source, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return baseIsMatch(object, source, getMatchData(source), customizer);
	}
	
	module.exports = isMatchWith;


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(491);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	 * which returns `true` for `undefined` and other non-numeric values.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 991 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 992 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	var isInteger = __webpack_require__(489);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	 * double precision number which isn't the result of a rounded unsafe integer.
	 *
	 * **Note:** This method is based on [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	 * @example
	 *
	 * _.isSafeInteger(3);
	 * // => true
	 *
	 * _.isSafeInteger(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isSafeInteger(Infinity);
	 * // => false
	 *
	 * _.isSafeInteger('3');
	 * // => false
	 */
	function isSafeInteger(value) {
	  return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isSafeInteger;


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(142),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	function isSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = isSet;


/***/ },
/* 995 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(142),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var weakMapTag = '[object WeakMap]';
	
	/**
	 * Checks if `value` is classified as a `WeakMap` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isWeakMap(new WeakMap);
	 * // => true
	 *
	 * _.isWeakMap(new Map);
	 * // => false
	 */
	function isWeakMap(value) {
	  return isObjectLike(value) && getTag(value) == weakMapTag;
	}
	
	module.exports = isWeakMap;


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var weakSetTag = '[object WeakSet]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `WeakSet` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isWeakSet(new WeakSet);
	 * // => true
	 *
	 * _.isWeakSet(new Set);
	 * // => false
	 */
	function isWeakSet(value) {
	  return isObjectLike(value) && objectToString.call(value) == weakSetTag;
	}
	
	module.exports = isWeakSet;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * Creates a function that invokes `func` with the arguments of the created
	 * function. If `func` is a property name the created callback returns the
	 * property value for a given element. If `func` is an object the created
	 * callback returns `true` for elements that contain the equivalent object
	 * properties, otherwise it returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @returns {Function} Returns the callback.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 }
	 * ];
	 *
	 * // Create custom iteratee shorthands.
	 * _.iteratee = _.wrap(_.iteratee, function(callback, func) {
	 *   var p = /^(\S+)\s*([<>])\s*(\S+)$/.exec(func);
	 *   return !p ? callback(func) : function(object) {
	 *     return (p[2] == '>' ? object[p[1]] > p[3] : object[p[1]] < p[3]);
	 *   };
	 * });
	 *
	 * _.filter(users, 'age > 36');
	 * // => [{ 'user': 'fred', 'age': 40 }]
	 */
	function iteratee(func) {
	  return baseIteratee(typeof func == 'function' ? func : baseClone(func, true));
	}
	
	module.exports = iteratee;


/***/ },
/* 999 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeJoin = arrayProto.join;
	
	/**
	 * Converts all elements in `array` into a string separated by `separator`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to convert.
	 * @param {string} [separator=','] The element separator.
	 * @returns {string} Returns the joined string.
	 * @example
	 *
	 * _.join(['a', 'b', 'c'], '~');
	 * // => 'a~b~c'
	 */
	function join(array, separator) {
	  return array ? nativeJoin.call(array, separator) : '';
	}
	
	module.exports = join;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__foo_bar__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(201);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` through `iteratee`. The corresponding value
	 * of each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  result[key] = value;
	});
	
	module.exports = keyBy;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(468),
	    toInteger = __webpack_require__(31);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * This method is like `_.indexOf` except that it iterates over elements of
	 * `array` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=array.length-1] The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.lastIndexOf([1, 2, 1, 2], 2);
	 * // => 3
	 *
	 * // Search from the `fromIndex`.
	 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	 * // => 1
	 */
	function lastIndexOf(array, value, fromIndex) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return -1;
	  }
	  var index = length;
	  if (fromIndex !== undefined) {
	    index = toInteger(fromIndex);
	    index = (index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1)) + 1;
	  }
	  if (value !== value) {
	    return indexOfNaN(array, index, true);
	  }
	  while (index--) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = lastIndexOf;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string`, as space separated words, to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the lower cased string.
	 * @example
	 *
	 * _.lowerCase('--Foo-Bar');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('fooBar');
	 * // => 'foo bar'
	 *
	 * _.lowerCase('__FOO_BAR__');
	 * // => 'foo bar'
	 */
	var lowerCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + word.toLowerCase();
	});
	
	module.exports = lowerCase;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var createCaseFirst = __webpack_require__(458);
	
	/**
	 * Converts the first character of `string` to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.lowerFirst('Fred');
	 * // => 'fred'
	 *
	 * _.lowerFirst('FRED');
	 * // => 'fRED'
	 */
	var lowerFirst = createCaseFirst('toLowerCase');
	
	module.exports = lowerFirst;


/***/ },
/* 1005 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is less than or equal to `other`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	 * @example
	 *
	 * _.lte(1, 3);
	 * // => true
	 *
	 * _.lte(3, 3);
	 * // => true
	 *
	 * _.lte(3, 1);
	 * // => false
	 */
	function lte(value, other) {
	  return value <= other;
	}
	
	module.exports = lte;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(98),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * property of `object` through `iteratee`. The iteratee is invoked with
	 * three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[iteratee(value, key, object)] = value;
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(98),
	    baseIteratee = __webpack_require__(17);
	
	/**
	 * Creates an object with the same keys as `object` and values generated by
	 * running each own enumerable property of `object` through `iteratee`. The
	 * iteratee is invoked with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    result[key] = iteratee(value, key, object);
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83),
	    baseMatches = __webpack_require__(435);
	
	/**
	 * Creates a function that performs a partial deep comparison between a given
	 * object and `source`, returning `true` if the given object has equivalent
	 * property values, else `false`. The created function is equivalent to
	 * `_.isMatch` with a `source` partially applied.
	 *
	 * **Note:** This method supports comparing the same values as `_.isEqual`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	 * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	 */
	function matches(source) {
	  return baseMatches(baseClone(source, true));
	}
	
	module.exports = matches;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(83),
	    baseMatchesProperty = __webpack_require__(436);
	
	/**
	 * Creates a function that performs a partial deep comparison between the
	 * value at `path` of a given object to `srcValue`, returning `true` if the
	 * object value is equivalent, else `false`.
	 *
	 * **Note:** This method supports comparing the same values as `_.isEqual`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * _.find(users, _.matchesProperty('user', 'fred'));
	 * // => { 'user': 'fred' }
	 */
	function matchesProperty(path, srcValue) {
	  return baseMatchesProperty(path, baseClone(srcValue, true));
	}
	
	module.exports = matchesProperty;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(194),
	    gt = __webpack_require__(351),
	    identity = __webpack_require__(78);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey
	 * `undefined` is returned.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, gt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(194),
	    baseIteratee = __webpack_require__(17),
	    gt = __webpack_require__(351);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee), gt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	var sum = __webpack_require__(502);
	
	/**
	 * Computes the mean of the values in `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {number} Returns the mean.
	 * @example
	 *
	 * _.mean([4, 2, 8, 6]);
	 * // => 5
	 */
	function mean(array) {
	  return sum(array) / (array ? array.length : 0);
	}
	
	module.exports = mean;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(317);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoizing function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new memoize.Cache;
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(332),
	    createAssigner = __webpack_require__(139);
	
	/**
	 * Recursively merges own and inherited enumerable properties of source objects
	 * into the destination object. Source properties that resolve to `undefined`
	 * are skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(197),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates a function that invokes the method at `path` of a given object.
	 * Any additional arguments are provided to the invoked method.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': _.constant(2) } } },
	 *   { 'a': { 'b': { 'c': _.constant(1) } } }
	 * ];
	 *
	 * _.map(objects, _.method('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.invokeMap(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	var method = rest(function(path, args) {
	  return function(object) {
	    return baseInvoke(object, path, args);
	  };
	});
	
	module.exports = method;


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(197),
	    rest = __webpack_require__(16);
	
	/**
	 * The opposite of `_.method`; this method creates a function that invokes
	 * the method at a given path of `object`. Any additional arguments are
	 * provided to the invoked method.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Object} object The object to query.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var array = _.times(3, _.constant),
	 *     object = { 'a': array, 'b': array, 'c': array };
	 *
	 * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	 * // => [2, 0]
	 *
	 * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	 * // => [2, 0]
	 */
	var methodOf = rest(function(object, args) {
	  return function(path) {
	    return baseInvoke(object, path, args);
	  };
	});
	
	module.exports = methodOf;


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(194),
	    identity = __webpack_require__(78),
	    lt = __webpack_require__(354);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey
	 * `undefined` is returned.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, lt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(194),
	    baseIteratee = __webpack_require__(17),
	    lt = __webpack_require__(354);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee), lt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(135),
	    arrayPush = __webpack_require__(191),
	    baseFunctions = __webpack_require__(326),
	    copyArray = __webpack_require__(100),
	    isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(46),
	    keys = __webpack_require__(54);
	
	/**
	 * Adds all own enumerable function properties of a source object to the
	 * destination object. If `object` is a function then methods are added to
	 * its prototype as well.
	 *
	 * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	 * avoid conflicts caused by modifying the original.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Function|Object} [object=lodash] The destination object.
	 * @param {Object} source The object of functions to add.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.chain=true] Specify whether the functions added
	 *  are chainable.
	 * @returns {Function|Object} Returns `object`.
	 * @example
	 *
	 * function vowels(string) {
	 *   return _.filter(string, function(v) {
	 *     return /[aeiou]/i.test(v);
	 *   });
	 * }
	 *
	 * _.mixin({ 'vowels': vowels });
	 * _.vowels('fred');
	 * // => ['e']
	 *
	 * _('fred').vowels().value();
	 * // => ['e']
	 *
	 * _.mixin({ 'vowels': vowels }, { 'chain': false });
	 * _('fred').vowels();
	 * // => ['e']
	 */
	function mixin(object, source, options) {
	  var props = keys(source),
	      methodNames = baseFunctions(source, props);
	
	  var chain = (isObject(options) && 'chain' in options) ? options.chain : true,
	      isFunc = isFunction(object);
	
	  arrayEach(methodNames, function(methodName) {
	    var func = source[methodName];
	    object[methodName] = func;
	    if (isFunc) {
	      object.prototype[methodName] = function() {
	        var chainAll = this.__chain__;
	        if (chain || chainAll) {
	          var result = object(this.__wrapped__),
	              actions = result.__actions__ = copyArray(this.__actions__);
	
	          actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	          result.__chain__ = chainAll;
	          return result;
	        }
	        return func.apply(object, arrayPush([this.value()], arguments));
	      };
	    }
	  });
	
	  return object;
	}
	
	module.exports = mixin;


/***/ },
/* 1020 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    return !predicate.apply(this, arguments);
	  };
	}
	
	module.exports = negate;


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(31);
	
	/**
	 * Creates a function that returns its nth argument.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {number} [n=0] The index of the argument to return.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.nthArg(1);
	 *
	 * func('a', 'b', 'c');
	 * // => 'b'
	 */
	function nthArg(n) {
	  n = toInteger(n);
	  return function() {
	    return arguments[n];
	  };
	}
	
	module.exports = nthArg;


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseDifference = __webpack_require__(137),
	    baseFlatten = __webpack_require__(43),
	    basePick = __webpack_require__(438),
	    keysIn = __webpack_require__(68),
	    rest = __webpack_require__(16);
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable properties of `object` that are not omitted.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property names to omit, specified
	 *  individually or in arrays.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = rest(function(object, props) {
	  if (object == null) {
	    return {};
	  }
	  props = arrayMap(baseFlatten(props, 1), String);
	  return basePick(object, baseDifference(keysIn(object), props));
	});
	
	module.exports = omit;


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    basePickBy = __webpack_require__(439);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable properties of `object` that `predicate`
	 * doesn't return truthy for. The predicate is invoked with two arguments:
	 * (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, function(value, key) {
	    return !predicate(value, key);
	  });
	}
	
	module.exports = omitBy;


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	var before = __webpack_require__(478);
	
	/**
	 * Creates a function that is restricted to invoking `func` once. Repeat calls
	 * to the function return the value of the first invocation. The `func` is
	 * invoked with the `this` binding and arguments of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new restricted function.
	 * @example
	 *
	 * var initialize = _.once(createApplication);
	 * initialize();
	 * initialize();
	 * // `initialize` invokes `createApplication` once
	 */
	function once(func) {
	  return before(2, func);
	}
	
	module.exports = once;


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(437),
	    isArray = __webpack_require__(27);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} [iteratees=[_.identity]] The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    createOver = __webpack_require__(341);
	
	/**
	 * Creates a function that invokes `iteratees` with the arguments provided
	 * to the created function and returns their results.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} iteratees The iteratees to invoke.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.over(Math.max, Math.min);
	 *
	 * func(1, 2, 3, 4);
	 * // => [4, 1]
	 */
	var over = createOver(arrayMap);
	
	module.exports = over;


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    arrayMap = __webpack_require__(45),
	    baseFlatten = __webpack_require__(43),
	    baseIteratee = __webpack_require__(17),
	    rest = __webpack_require__(16);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Creates a function that invokes `func` with arguments transformed by
	 * corresponding `transforms`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to wrap.
	 * @param {...(Function|Function[])} [transforms] The functions to transform
	 * arguments, specified individually or in arrays.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * function doubled(n) {
	 *   return n * 2;
	 * }
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var func = _.overArgs(function(x, y) {
	 *   return [x, y];
	 * }, square, doubled);
	 *
	 * func(9, 3);
	 * // => [81, 6]
	 *
	 * func(10, 5);
	 * // => [100, 10]
	 */
	var overArgs = rest(function(func, transforms) {
	  transforms = arrayMap(baseFlatten(transforms, 1), baseIteratee);
	
	  var funcsLength = transforms.length;
	  return rest(function(args) {
	    var index = -1,
	        length = nativeMin(args.length, funcsLength);
	
	    while (++index < length) {
	      args[index] = transforms[index].call(this, args[index]);
	    }
	    return apply(func, this, args);
	  });
	});
	
	module.exports = overArgs;


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(422),
	    createOver = __webpack_require__(341);
	
	/**
	 * Creates a function that checks if **all** of the `predicates` return
	 * truthy when invoked with the arguments provided to the created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} predicates The predicates to check.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.overEvery(Boolean, isFinite);
	 *
	 * func('1');
	 * // => true
	 *
	 * func(null);
	 * // => false
	 *
	 * func(NaN);
	 * // => false
	 */
	var overEvery = createOver(arrayEvery);
	
	module.exports = overEvery;


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(321),
	    createOver = __webpack_require__(341);
	
	/**
	 * Creates a function that checks if **any** of the `predicates` return
	 * truthy when invoked with the arguments provided to the created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} predicates The predicates to check.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var func = _.overSome(Boolean, isFinite);
	 *
	 * func('1');
	 * // => true
	 *
	 * func(null);
	 * // => true
	 *
	 * func(NaN);
	 * // => false
	 */
	var overSome = createOver(arraySome);
	
	module.exports = overSome;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	var createPadding = __webpack_require__(342),
	    stringSize = __webpack_require__(207),
	    toInteger = __webpack_require__(31),
	    toString = __webpack_require__(34);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeFloor = Math.floor;
	
	/**
	 * Pads `string` on the left and right sides if it's shorter than `length`.
	 * Padding characters are truncated if they can't be evenly divided by `length`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.pad('abc', 8);
	 * // => '  abc   '
	 *
	 * _.pad('abc', 8, '_-');
	 * // => '_-abc_-_'
	 *
	 * _.pad('abc', 3);
	 * // => 'abc'
	 */
	function pad(string, length, chars) {
	  string = toString(string);
	  length = toInteger(length);
	
	  var strLength = stringSize(string);
	  if (!length || strLength >= length) {
	    return string;
	  }
	  var mid = (length - strLength) / 2,
	      leftLength = nativeFloor(mid),
	      rightLength = nativeCeil(mid);
	
	  return createPadding('', leftLength, chars) + string + createPadding('', rightLength, chars);
	}
	
	module.exports = pad;


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	var createPadding = __webpack_require__(342),
	    toString = __webpack_require__(34);
	
	/**
	 * Pads `string` on the right side if it's shorter than `length`. Padding
	 * characters are truncated if they exceed `length`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.padEnd('abc', 6);
	 * // => 'abc   '
	 *
	 * _.padEnd('abc', 6, '_-');
	 * // => 'abc_-_'
	 *
	 * _.padEnd('abc', 3);
	 * // => 'abc'
	 */
	function padEnd(string, length, chars) {
	  string = toString(string);
	  return string + createPadding(string, length, chars);
	}
	
	module.exports = padEnd;


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	var createPadding = __webpack_require__(342),
	    toString = __webpack_require__(34);
	
	/**
	 * Pads `string` on the left side if it's shorter than `length`. Padding
	 * characters are truncated if they exceed `length`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.padStart('abc', 6);
	 * // => '   abc'
	 *
	 * _.padStart('abc', 6, '_-');
	 * // => '_-_abc'
	 *
	 * _.padStart('abc', 3);
	 * // => 'abc'
	 */
	function padStart(string, length, chars) {
	  string = toString(string);
	  return createPadding(string, length, chars) + string;
	}
	
	module.exports = padStart;


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(61),
	    toString = __webpack_require__(34);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect hexadecimal string values. */
	var reHasHexPrefix = /^0x/i;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeParseInt = root.parseInt;
	
	/**
	 * Converts `string` to an integer of the specified radix. If `radix` is
	 * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	 * in which case a `radix` of `16` is used.
	 *
	 * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#x15.1.2.2)
	 * of `parseInt`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} string The string to convert.
	 * @param {number} [radix=10] The radix to interpret `value` by.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.parseInt('08');
	 * // => 8
	 *
	 * _.map(['6', '08', '10'], _.parseInt);
	 * // => [6, 8, 10]
	 */
	function parseInt(string, radix, guard) {
	  // Chrome fails to trim leading <BOM> whitespace characters.
	  // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	  if (guard || radix == null) {
	    radix = 0;
	  } else if (radix) {
	    radix = +radix;
	  }
	  string = toString(string).replace(reTrim, '');
	  return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	}
	
	module.exports = parseInt;


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	var createWrapper = __webpack_require__(85),
	    getPlaceholder = __webpack_require__(141),
	    replaceHolders = __webpack_require__(115),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var PARTIAL_RIGHT_FLAG = 64;
	
	/**
	 * This method is like `_.partial` except that partially applied arguments
	 * are appended to those provided to the new function.
	 *
	 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	 * builds, may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of partially
	 * applied functions.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to partially apply arguments to.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new partially applied function.
	 * @example
	 *
	 * var greet = function(greeting, name) {
	 *   return greeting + ' ' + name;
	 * };
	 *
	 * var greetFred = _.partialRight(greet, 'fred');
	 * greetFred('hi');
	 * // => 'hi fred'
	 *
	 * // Partially applied with placeholders.
	 * var sayHelloTo = _.partialRight(greet, 'hello', _);
	 * sayHelloTo('fred');
	 * // => 'hello fred'
	 */
	var partialRight = rest(function(func, partials) {
	  var holders = replaceHolders(partials, getPlaceholder(partialRight));
	  return createWrapper(func, PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	});
	
	// Assign default placeholders.
	partialRight.placeholder = {};
	
	module.exports = partialRight;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(201);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, the second of which
	 * contains elements `predicate` returns falsey for. The predicate is
	 * invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * _.partition(users, function(o) { return o.active; });
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.partition(users, { 'age': 1, 'active': false });
	 * // => objects for [['pebbles'], ['barney', 'fred']]
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.partition(users, ['active', false]);
	 * // => objects for [['barney', 'pebbles'], ['fred']]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.partition(users, 'active');
	 * // => objects for [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    basePick = __webpack_require__(438),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property names to pick, specified
	 *  individually or in arrays.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = rest(function(object, props) {
	  return object == null ? {} : basePick(object, baseFlatten(props, 1));
	});
	
	module.exports = pick;


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    basePickBy = __webpack_require__(439);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  return object == null ? {} : basePickBy(object, baseIteratee(predicate));
	}
	
	module.exports = pickBy;


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(327);
	
	/**
	 * The opposite of `_.property`; this method creates a function that returns
	 * the value at a given path of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var array = [0, 1, 2],
	 *     object = { 'a': array, 'b': array, 'c': array };
	 *
	 * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	 * // => [2, 0]
	 *
	 * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	 * // => [2, 0]
	 */
	function propertyOf(object) {
	  return function(path) {
	    return object == null ? undefined : baseGet(object, path);
	  };
	}
	
	module.exports = propertyOf;


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	var pullAll = __webpack_require__(499),
	    rest = __webpack_require__(16);
	
	/**
	 * Removes all given values from `array` using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	 * to remove elements from an array by predicate.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...*} [values] The values to remove.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3, 1, 2, 3];
	 *
	 * _.pull(array, 2, 3);
	 * console.log(array);
	 * // => [1, 1]
	 */
	var pull = rest(pullAll);
	
	module.exports = pull;


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    basePullAllBy = __webpack_require__(440);
	
	/**
	 * This method is like `_.pullAll` except that it accepts `iteratee` which is
	 * invoked for each element of `array` and `values` to generate the criterion
	 * by which uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to remove.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	 *
	 * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	 * console.log(array);
	 * // => [{ 'x': 2 }]
	 */
	function pullAllBy(array, values, iteratee) {
	  return (array && array.length && values && values.length)
	    ? basePullAllBy(array, values, baseIteratee(iteratee))
	    : array;
	}
	
	module.exports = pullAllBy;


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    baseAt = __webpack_require__(430),
	    baseFlatten = __webpack_require__(43),
	    basePullAt = __webpack_require__(441),
	    compareAscending = __webpack_require__(453),
	    rest = __webpack_require__(16);
	
	/**
	 * Removes elements from `array` corresponding to `indexes` and returns an
	 * array of removed elements.
	 *
	 * **Note:** Unlike `_.at`, this method mutates `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	 *  specified individually or in arrays.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [5, 10, 15, 20];
	 * var evens = _.pullAt(array, 1, 3);
	 *
	 * console.log(array);
	 * // => [5, 15]
	 *
	 * console.log(evens);
	 * // => [10, 20]
	 */
	var pullAt = rest(function(array, indexes) {
	  indexes = arrayMap(baseFlatten(indexes, 1), String);
	
	  var result = baseAt(array, indexes);
	  basePullAt(array, indexes.sort(compareAscending));
	  return result;
	});
	
	module.exports = pullAt;


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(462);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the new array of numbers.
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(462);
	
	/**
	 * This method is like `_.range` except that it populates values in
	 * descending order.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the new array of numbers.
	 * @example
	 *
	 * _.rangeRight(4);
	 * // => [3, 2, 1, 0]
	 *
	 * _.rangeRight(-4);
	 * // => [-3, -2, -1, 0]
	 *
	 * _.rangeRight(1, 5);
	 * // => [4, 3, 2, 1]
	 *
	 * _.rangeRight(0, 20, 5);
	 * // => [15, 10, 5, 0]
	 *
	 * _.rangeRight(0, -4, -1);
	 * // => [-3, -2, -1, 0]
	 *
	 * _.rangeRight(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.rangeRight(0);
	 * // => []
	 */
	var rangeRight = createRange(true);
	
	module.exports = rangeRight;


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    createWrapper = __webpack_require__(85),
	    rest = __webpack_require__(16);
	
	/** Used to compose bitmasks for wrapper metadata. */
	var REARG_FLAG = 256;
	
	/**
	 * Creates a function that invokes `func` with arguments arranged according
	 * to the specified indexes where the argument value at the first index is
	 * provided as the first argument, the argument value at the second index is
	 * provided as the second argument, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to rearrange arguments for.
	 * @param {...(number|number[])} indexes The arranged argument indexes,
	 *  specified individually or in arrays.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var rearged = _.rearg(function(a, b, c) {
	 *   return [a, b, c];
	 * }, 2, 0, 1);
	 *
	 * rearged('b', 'c', 'a')
	 * // => ['a', 'b', 'c']
	 */
	var rearg = rest(function(func, indexes) {
	  return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes, 1));
	});
	
	module.exports = rearg;


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(159),
	    baseEach = __webpack_require__(84),
	    baseIteratee = __webpack_require__(17),
	    baseReduce = __webpack_require__(443),
	    isArray = __webpack_require__(27);
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` through `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	module.exports = reduce;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	var arrayReduceRight = __webpack_require__(837),
	    baseEachRight = __webpack_require__(323),
	    baseIteratee = __webpack_require__(17),
	    baseReduce = __webpack_require__(443),
	    isArray = __webpack_require__(27);
	
	/**
	 * This method is like `_.reduce` except that it iterates over elements of
	 * `collection` from right to left.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * var array = [[0, 1], [2, 3], [4, 5]];
	 *
	 * _.reduceRight(array, function(flattened, other) {
	 *   return flattened.concat(other);
	 * }, []);
	 * // => [4, 5, 2, 3, 0, 1]
	 */
	function reduceRight(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduceRight : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	}
	
	module.exports = reduceRight;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    baseFilter = __webpack_require__(432),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27);
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseIteratee(predicate, 3);
	  return func(collection, function(value, index, collection) {
	    return !predicate(value, index, collection);
	  });
	}
	
	module.exports = reject;


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    basePullAt = __webpack_require__(441);
	
	/**
	 * Removes all elements from `array` that `predicate` returns truthy for
	 * and returns an array of the removed elements. The predicate is invoked
	 * with three arguments: (value, index, array).
	 *
	 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	 * to pull elements from an array by value.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new array of removed elements.
	 * @example
	 *
	 * var array = [1, 2, 3, 4];
	 * var evens = _.remove(array, function(n) {
	 *   return n % 2 == 0;
	 * });
	 *
	 * console.log(array);
	 * // => [1, 3]
	 *
	 * console.log(evens);
	 * // => [2, 4]
	 */
	function remove(array, predicate) {
	  var result = [];
	  if (!(array && array.length)) {
	    return result;
	  }
	  var index = -1,
	      indexes = [],
	      length = array.length;
	
	  predicate = baseIteratee(predicate, 3);
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result.push(value);
	      indexes.push(index);
	    }
	  }
	  basePullAt(array, indexes);
	  return result;
	}
	
	module.exports = remove;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/**
	 * Replaces matches for `pattern` in `string` with `replacement`.
	 *
	 * **Note:** This method is based on [`String#replace`](https://mdn.io/String/replace).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to modify.
	 * @param {RegExp|string} pattern The pattern to replace.
	 * @param {Function|string} replacement The match replacement.
	 * @returns {string} Returns the modified string.
	 * @example
	 *
	 * _.replace('Hi Fred', 'Fred', 'Barney');
	 * // => 'Hi Barney'
	 */
	function replace() {
	  var args = arguments,
	      string = toString(args[0]);
	
	  return args.length < 3 ? string : string.replace(args[1], args[2]);
	}
	
	module.exports = replace;


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastPath = __webpack_require__(112),
	    get = __webpack_require__(163),
	    isFunction = __webpack_require__(67),
	    isKey = __webpack_require__(86),
	    parent = __webpack_require__(162);
	
	/**
	 * This method is like `_.get` except that if the resolved value is a function
	 * it's invoked with the `this` binding of its parent object and its result
	 * is returned.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to resolve.
	 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	 *
	 * _.result(object, 'a[0].b.c1');
	 * // => 3
	 *
	 * _.result(object, 'a[0].b.c2');
	 * // => 4
	 *
	 * _.result(object, 'a[0].b.c3', 'default');
	 * // => 'default'
	 *
	 * _.result(object, 'a[0].b.c3', _.constant('default'));
	 * // => 'default'
	 */
	function result(object, path, defaultValue) {
	  if (!isKey(path, object)) {
	    path = baseCastPath(path);
	    var result = get(object, path);
	    object = parent(object, path);
	  } else {
	    result = object == null ? undefined : object[path];
	  }
	  if (result === undefined) {
	    result = defaultValue;
	  }
	  return isFunction(result) ? result.call(object) : result;
	}
	
	module.exports = result;


/***/ },
/* 1051 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeReverse = arrayProto.reverse;
	
	/**
	 * Reverses `array` so that the first element becomes the last, the second
	 * element becomes the second to last, and so on.
	 *
	 * **Note:** This method mutates `array` and is based on
	 * [`Array#reverse`](https://mdn.io/Array/reverse).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.reverse(array);
	 * // => [3, 2, 1]
	 *
	 * console.log(array);
	 * // => [3, 2, 1]
	 */
	function reverse(array) {
	  return array ? nativeReverse.call(array) : array;
	}
	
	module.exports = reverse;


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	var createRound = __webpack_require__(343);
	
	/**
	 * Computes `number` rounded to `precision`.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {number} number The number to round.
	 * @param {number} [precision=0] The precision to round to.
	 * @returns {number} Returns the rounded number.
	 * @example
	 *
	 * _.round(4.006);
	 * // => 4
	 *
	 * _.round(4.006, 2);
	 * // => 4.01
	 *
	 * _.round(4060, -2);
	 * // => 4100
	 */
	var round = createRound('round');
	
	module.exports = round;


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	var baseRandom = __webpack_require__(442),
	    isArrayLike = __webpack_require__(66),
	    values = __webpack_require__(209);
	
	/**
	 * Gets a random element from `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to sample.
	 * @returns {*} Returns the random element.
	 * @example
	 *
	 * _.sample([1, 2, 3, 4]);
	 * // => 2
	 */
	function sample(collection) {
	  var array = isArrayLike(collection) ? collection : values(collection),
	      length = array.length;
	
	  return length > 0 ? array[baseRandom(0, length - 1)] : undefined;
	}
	
	module.exports = sample;


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(334);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, 'x[0].y.z', 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(334);
	
	/**
	 * This method is like `_.set` except that it accepts `customizer` which is
	 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	 * path creation is handled by the method instead. The `customizer` is invoked
	 * with three arguments: (nsValue, key, nsObject).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.setWith({ '0': { 'length': 2 } }, '[0][1][2]', 3, Object);
	 * // => { '0': { '1': { '2': 3 }, 'length': 2 } }
	 */
	function setWith(object, path, value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return object == null ? object : baseSet(object, path, value, customizer);
	}
	
	module.exports = setWith;


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	var sampleSize = __webpack_require__(501);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */
	function shuffle(collection) {
	  return sampleSize(collection, MAX_ARRAY_LENGTH);
	}
	
	module.exports = shuffle;


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66),
	    isString = __webpack_require__(117),
	    keys = __webpack_require__(54),
	    stringSize = __webpack_require__(207);
	
	/**
	 * Gets the size of `collection` by returning its length for array-like
	 * values or the number of own enumerable properties for objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @returns {number} Returns the collection size.
	 * @example
	 *
	 * _.size([1, 2, 3]);
	 * // => 3
	 *
	 * _.size({ 'a': 1, 'b': 2 });
	 * // => 2
	 *
	 * _.size('pebbles');
	 * // => 7
	 */
	function size(collection) {
	  if (collection == null) {
	    return 0;
	  }
	  if (isArrayLike(collection)) {
	    var result = collection.length;
	    return (result && isString(collection)) ? stringSize(collection) : result;
	  }
	  return keys(collection).length;
	}
	
	module.exports = size;


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    isIterateeCall = __webpack_require__(101),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Creates a slice of `array` from `start` up to, but not including, `end`.
	 *
	 * **Note:** This method is used instead of [`Array#slice`](https://mdn.io/Array/slice)
	 * to ensure dense arrays are returned.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function slice(array, start, end) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	    start = 0;
	    end = length;
	  }
	  else {
	    start = start == null ? 0 : toInteger(start);
	    end = end === undefined ? length : toInteger(end);
	  }
	  return baseSlice(array, start, end);
	}
	
	module.exports = slice;


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the snake cased string.
	 * @example
	 *
	 * _.snakeCase('Foo Bar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('fooBar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('--foo-bar');
	 * // => 'foo_bar'
	 */
	var snakeCase = createCompounder(function(result, word, index) {
	  return result + (index ? '_' : '') + word.toLowerCase();
	});
	
	module.exports = snakeCase;


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(321),
	    baseIteratee = __webpack_require__(17),
	    baseSome = __webpack_require__(852),
	    isArray = __webpack_require__(27),
	    isIterateeCall = __webpack_require__(101);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check, else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    baseOrderBy = __webpack_require__(437),
	    isIterateeCall = __webpack_require__(101),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[]|Object|Object[]|string|string[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by, specified individually or in arrays.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, function(o) { return o.user; });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	 *
	 * _.sortBy(users, 'user', function(o) {
	 *   return Math.floor(o.age / 10);
	 * });
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	var sortBy = rest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees.length = 1;
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(199);
	
	/**
	 * Uses a binary search to determine the lowest index at which `value` should
	 * be inserted into `array` in order to maintain its sort order.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @returns {number} Returns the index at which `value` should be inserted into `array`.
	 * @example
	 *
	 * _.sortedIndex([30, 50], 40);
	 * // => 1
	 *
	 * _.sortedIndex([4, 5], 4);
	 * // => 0
	 */
	function sortedIndex(array, value) {
	  return baseSortedIndex(array, value);
	}
	
	module.exports = sortedIndex;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseSortedIndexBy = __webpack_require__(335);
	
	/**
	 * This method is like `_.sortedIndex` except that it accepts `iteratee`
	 * which is invoked for `value` and each element of `array` to compute their
	 * sort ranking. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the index at which `value` should be inserted into `array`.
	 * @example
	 *
	 * var dict = { 'thirty': 30, 'forty': 40, 'fifty': 50 };
	 *
	 * _.sortedIndexBy(['thirty', 'fifty'], 'forty', _.propertyOf(dict));
	 * // => 1
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sortedIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	 * // => 0
	 */
	function sortedIndexBy(array, value, iteratee) {
	  return baseSortedIndexBy(array, value, baseIteratee(iteratee));
	}
	
	module.exports = sortedIndexBy;


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(199),
	    eq = __webpack_require__(87);
	
	/**
	 * This method is like `_.indexOf` except that it performs a binary
	 * search on a sorted `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.sortedIndexOf([1, 1, 2, 2], 2);
	 * // => 2
	 */
	function sortedIndexOf(array, value) {
	  var length = array ? array.length : 0;
	  if (length) {
	    var index = baseSortedIndex(array, value);
	    if (index < length && eq(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = sortedIndexOf;


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(199);
	
	/**
	 * This method is like `_.sortedIndex` except that it returns the highest
	 * index at which `value` should be inserted into `array` in order to
	 * maintain its sort order.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @returns {number} Returns the index at which `value` should be inserted into `array`.
	 * @example
	 *
	 * _.sortedLastIndex([4, 5], 4);
	 * // => 1
	 */
	function sortedLastIndex(array, value) {
	  return baseSortedIndex(array, value, true);
	}
	
	module.exports = sortedLastIndex;


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseSortedIndexBy = __webpack_require__(335);
	
	/**
	 * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	 * which is invoked for `value` and each element of `array` to compute their
	 * sort ranking. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The sorted array to inspect.
	 * @param {*} value The value to evaluate.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the index at which `value` should be inserted into `array`.
	 * @example
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sortedLastIndexBy([{ 'x': 4 }, { 'x': 5 }], { 'x': 4 }, 'x');
	 * // => 1
	 */
	function sortedLastIndexBy(array, value, iteratee) {
	  return baseSortedIndexBy(array, value, baseIteratee(iteratee), true);
	}
	
	module.exports = sortedLastIndexBy;


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedIndex = __webpack_require__(199),
	    eq = __webpack_require__(87);
	
	/**
	 * This method is like `_.lastIndexOf` except that it performs a binary
	 * search on a sorted `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 * @example
	 *
	 * _.sortedLastIndexOf([1, 1, 2, 2], 2);
	 * // => 3
	 */
	function sortedLastIndexOf(array, value) {
	  var length = array ? array.length : 0;
	  if (length) {
	    var index = baseSortedIndex(array, value, true) - 1;
	    if (eq(array[index], value)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = sortedLastIndexOf;


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortedUniq = __webpack_require__(854);
	
	/**
	 * This method is like `_.uniq` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniq([1, 1, 2]);
	 * // => [1, 2]
	 */
	function sortedUniq(array) {
	  return (array && array.length)
	    ? baseSortedUniq(array)
	    : [];
	}
	
	module.exports = sortedUniq;


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseSortedUniqBy = __webpack_require__(445);
	
	/**
	 * This method is like `_.uniqBy` except that it's designed and optimized
	 * for sorted arrays.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	 * // => [1.1, 2.3]
	 */
	function sortedUniqBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSortedUniqBy(array, baseIteratee(iteratee))
	    : [];
	}
	
	module.exports = sortedUniqBy;


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/**
	 * Splits `string` by `separator`.
	 *
	 * **Note:** This method is based on [`String#split`](https://mdn.io/String/split).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to split.
	 * @param {RegExp|string} separator The separator pattern to split by.
	 * @param {number} [limit] The length to truncate results to.
	 * @returns {Array} Returns the new array of string segments.
	 * @example
	 *
	 * _.split('a-b-c', '-', 2);
	 * // => ['a', 'b']
	 */
	function split(string, separator, limit) {
	  return toString(string).split(separator, limit);
	}
	
	module.exports = split;


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(60),
	    arrayPush = __webpack_require__(191),
	    rest = __webpack_require__(16),
	    toInteger = __webpack_require__(31);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the created
	 * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	 *
	 * **Note:** This method is based on the [spread operator](https://mdn.io/spread_operator).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} [start=0] The start position of the spread.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.spread(function(who, what) {
	 *   return who + ' says ' + what;
	 * });
	 *
	 * say(['fred', 'hello']);
	 * // => 'fred says hello'
	 *
	 * var numbers = Promise.all([
	 *   Promise.resolve(40),
	 *   Promise.resolve(36)
	 * ]);
	 *
	 * numbers.then(_.spread(function(x, y) {
	 *   return x + y;
	 * }));
	 * // => a Promise of 76
	 */
	function spread(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
	  return rest(function(args) {
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      arrayPush(otherArgs, array);
	    }
	    return apply(func, this, otherArgs);
	  });
	}
	
	module.exports = spread;


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	var capitalize = __webpack_require__(348),
	    createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the start cased string.
	 * @example
	 *
	 * _.startCase('--foo-bar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('fooBar');
	 * // => 'Foo Bar'
	 *
	 * _.startCase('__foo_bar__');
	 * // => 'Foo Bar'
	 */
	var startCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + capitalize(word);
	});
	
	module.exports = startCase;


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(160),
	    toInteger = __webpack_require__(31),
	    toString = __webpack_require__(34);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to search.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = baseClamp(toInteger(position), 0, string.length);
	  return string.lastIndexOf(target, position) == position;
	}
	
	module.exports = startsWith;


/***/ },
/* 1074 */
/***/ function(module, exports) {

	/**
	 * Subtract two numbers.
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {number} minuend The first number in a subtraction.
	 * @param {number} subtrahend The second number in a subtraction.
	 * @returns {number} Returns the difference.
	 * @example
	 *
	 * _.subtract(6, 4);
	 * // => 2
	 */
	function subtract(minuend, subtrahend) {
	  var result;
	  if (minuend === undefined && subtrahend === undefined) {
	    return 0;
	  }
	  if (minuend !== undefined) {
	    result = minuend;
	  }
	  if (subtrahend !== undefined) {
	    result = result === undefined ? subtrahend : (result - subtrahend);
	  }
	  return result;
	}
	
	module.exports = subtract;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseSum = __webpack_require__(446);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	var drop = __webpack_require__(482);
	
	/**
	 * Gets all but the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.tail([1, 2, 3]);
	 * // => [2, 3]
	 */
	function tail(array) {
	  return drop(array, 1);
	}
	
	module.exports = tail;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the beginning.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.take([1, 2, 3]);
	 * // => [1]
	 *
	 * _.take([1, 2, 3], 2);
	 * // => [1, 2]
	 *
	 * _.take([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.take([1, 2, 3], 0);
	 * // => []
	 */
	function take(array, n, guard) {
	  if (!(array && array.length)) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  return baseSlice(array, 0, n < 0 ? 0 : n);
	}
	
	module.exports = take;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(99),
	    toInteger = __webpack_require__(31);
	
	/**
	 * Creates a slice of `array` with `n` elements taken from the end.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {number} [n=1] The number of elements to take.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * _.takeRight([1, 2, 3]);
	 * // => [3]
	 *
	 * _.takeRight([1, 2, 3], 2);
	 * // => [2, 3]
	 *
	 * _.takeRight([1, 2, 3], 5);
	 * // => [1, 2, 3]
	 *
	 * _.takeRight([1, 2, 3], 0);
	 * // => []
	 */
	function takeRight(array, n, guard) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  n = (guard || n === undefined) ? 1 : toInteger(n);
	  n = length - n;
	  return baseSlice(array, n < 0 ? 0 : n, length);
	}
	
	module.exports = takeRight;


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseWhile = __webpack_require__(200);
	
	/**
	 * Creates a slice of `array` with elements taken from the end. Elements are
	 * taken until `predicate` returns falsey. The predicate is invoked with three
	 * arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': true },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': false }
	 * ];
	 *
	 * _.takeRightWhile(users, function(o) { return !o.active; });
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	 * // => objects for ['pebbles']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.takeRightWhile(users, ['active', false]);
	 * // => objects for ['fred', 'pebbles']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.takeRightWhile(users, 'active');
	 * // => []
	 */
	function takeRightWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3), false, true)
	    : [];
	}
	
	module.exports = takeRightWhile;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseWhile = __webpack_require__(200);
	
	/**
	 * Creates a slice of `array` with elements taken from the beginning. Elements
	 * are taken until `predicate` returns falsey. The predicate is invoked with
	 * three arguments: (value, index, array).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the slice of `array`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false},
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.takeWhile(users, function(o) { return !o.active; });
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.takeWhile(users, { 'user': 'barney', 'active': false });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.takeWhile(users, ['active', false]);
	 * // => objects for ['barney', 'fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.takeWhile(users, 'active');
	 * // => []
	 */
	function takeWhile(array, predicate) {
	  return (array && array.length)
	    ? baseWhile(array, baseIteratee(predicate, 3))
	    : [];
	}
	
	module.exports = takeWhile;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	var assignInDefaults = __webpack_require__(423),
	    assignInWith = __webpack_require__(208),
	    attempt = __webpack_require__(477),
	    baseValues = __webpack_require__(337),
	    escapeStringChar = __webpack_require__(876),
	    isError = __webpack_require__(352),
	    isIterateeCall = __webpack_require__(101),
	    keys = __webpack_require__(54),
	    reInterpolate = __webpack_require__(472),
	    templateSettings = __webpack_require__(503),
	    toString = __webpack_require__(34);
	
	/** Used to match empty string literals in compiled template source. */
	var reEmptyStringLeading = /\b__p \+= '';/g,
	    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	/** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	/** Used to ensure capturing order of template delimiters. */
	var reNoMatch = /($^)/;
	
	/** Used to match unescaped characters in compiled string literals. */
	var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	/**
	 * Creates a compiled template function that can interpolate data properties
	 * in "interpolate" delimiters, HTML-escape interpolated data properties in
	 * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	 * properties may be accessed as free variables in the template. If a setting
	 * object is given it takes precedence over `_.templateSettings` values.
	 *
	 * **Note:** In the development build `_.template` utilizes
	 * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	 * for easier debugging.
	 *
	 * For more information on precompiling templates see
	 * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	 *
	 * For more information on Chrome extension sandboxes see
	 * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The template string.
	 * @param {Object} [options] The options object.
	 * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	 * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	 * @param {Object} [options.imports] An object to import into the template as free variables.
	 * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	 * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	 * @param {string} [options.variable] The data object variable name.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {Function} Returns the compiled template function.
	 * @example
	 *
	 * // Use the "interpolate" delimiter to create a compiled template.
	 * var compiled = _.template('hello <%= user %>!');
	 * compiled({ 'user': 'fred' });
	 * // => 'hello fred!'
	 *
	 * // Use the HTML "escape" delimiter to escape data property values.
	 * var compiled = _.template('<b><%- value %></b>');
	 * compiled({ 'value': '<script>' });
	 * // => '<b>&lt;script&gt;</b>'
	 *
	 * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	 * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the internal `print` function in "evaluate" delimiters.
	 * var compiled = _.template('<% print("hello " + user); %>!');
	 * compiled({ 'user': 'barney' });
	 * // => 'hello barney!'
	 *
	 * // Use the ES delimiter as an alternative to the default "interpolate" delimiter.
	 * var compiled = _.template('hello ${ user }!');
	 * compiled({ 'user': 'pebbles' });
	 * // => 'hello pebbles!'
	 *
	 * // Use custom template delimiters.
	 * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	 * var compiled = _.template('hello {{ user }}!');
	 * compiled({ 'user': 'mustache' });
	 * // => 'hello mustache!'
	 *
	 * // Use backslashes to treat delimiters as plain text.
	 * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	 * compiled({ 'value': 'ignored' });
	 * // => '<%- value %>'
	 *
	 * // Use the `imports` option to import `jQuery` as `jq`.
	 * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	 * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	 * compiled({ 'users': ['fred', 'barney'] });
	 * // => '<li>fred</li><li>barney</li>'
	 *
	 * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	 * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	 * compiled(data);
	 * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	 *
	 * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	 * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	 * compiled.source;
	 * // => function(data) {
	 * //   var __t, __p = '';
	 * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	 * //   return __p;
	 * // }
	 *
	 * // Use the `source` property to inline compiled templates for meaningful
	 * // line numbers in error messages and stack traces.
	 * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	 *   var JST = {\
	 *     "main": ' + _.template(mainText).source + '\
	 *   };\
	 * ');
	 */
	function template(string, options, guard) {
	  // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	  // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	  var settings = templateSettings.imports._.templateSettings || templateSettings;
	
	  if (guard && isIterateeCall(string, options, guard)) {
	    options = undefined;
	  }
	  string = toString(string);
	  options = assignInWith({}, options, settings, assignInDefaults);
	
	  var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
	      importsKeys = keys(imports),
	      importsValues = baseValues(imports, importsKeys);
	
	  var isEscaping,
	      isEvaluating,
	      index = 0,
	      interpolate = options.interpolate || reNoMatch,
	      source = "__p += '";
	
	  // Compile the regexp to match each delimiter.
	  var reDelimiters = RegExp(
	    (options.escape || reNoMatch).source + '|' +
	    interpolate.source + '|' +
	    (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	    (options.evaluate || reNoMatch).source + '|$'
	  , 'g');
	
	  // Use a sourceURL for easier debugging.
	  var sourceURL = 'sourceURL' in options ? '//# sourceURL=' + options.sourceURL + '\n' : '';
	
	  string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	    interpolateValue || (interpolateValue = esTemplateValue);
	
	    // Escape characters that can't be included in string literals.
	    source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	    // Replace delimiters with snippets.
	    if (escapeValue) {
	      isEscaping = true;
	      source += "' +\n__e(" + escapeValue + ") +\n'";
	    }
	    if (evaluateValue) {
	      isEvaluating = true;
	      source += "';\n" + evaluateValue + ";\n__p += '";
	    }
	    if (interpolateValue) {
	      source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	    }
	    index = offset + match.length;
	
	    // The JS engine embedded in Adobe products needs `match` returned in
	    // order to produce the correct `offset` value.
	    return match;
	  });
	
	  source += "';\n";
	
	  // If `variable` is not specified wrap a with-statement around the generated
	  // code to add the data object to the top of the scope chain.
	  var variable = options.variable;
	  if (!variable) {
	    source = 'with (obj) {\n' + source + '\n}\n';
	  }
	  // Cleanup code by stripping empty strings.
	  source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	    .replace(reEmptyStringMiddle, '$1')
	    .replace(reEmptyStringTrailing, '$1;');
	
	  // Frame code as the function body.
	  source = 'function(' + (variable || 'obj') + ') {\n' +
	    (variable
	      ? ''
	      : 'obj || (obj = {});\n'
	    ) +
	    "var __t, __p = ''" +
	    (isEscaping
	       ? ', __e = _.escape'
	       : ''
	    ) +
	    (isEvaluating
	      ? ', __j = Array.prototype.join;\n' +
	        "function print() { __p += __j.call(arguments, '') }\n"
	      : ';\n'
	    ) +
	    source +
	    'return __p\n}';
	
	  var result = attempt(function() {
	    return Function(importsKeys, sourceURL + 'return ' + source)
	      .apply(undefined, importsValues);
	  });
	
	  // Provide the compiled function's source by its `toString` method or
	  // the `source` property as a convenience for inlining compiled templates.
	  result.source = source;
	  if (isError(result)) {
	    throw result;
	  }
	  return result;
	}
	
	module.exports = template;


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(480),
	    isObject = __webpack_require__(46);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide an options object to indicate whether
	 * `func` should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the throttled function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=true] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	var baseCastFunction = __webpack_require__(111),
	    baseTimes = __webpack_require__(336),
	    toInteger = __webpack_require__(31);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * Invokes the iteratee `n` times, returning an array of the results of
	 * each invocation. The iteratee is invoked with one argument; (index).
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 * @example
	 *
	 * _.times(3, String);
	 * // => ['0', '1', '2']
	 *
	 *  _.times(4, _.constant(true));
	 * // => [true, true, true, true]
	 */
	function times(n, iteratee) {
	  n = toInteger(n);
	  if (n < 1 || n > MAX_SAFE_INTEGER) {
	    return [];
	  }
	  var index = MAX_ARRAY_LENGTH,
	      length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	  iteratee = baseCastFunction(iteratee);
	  n -= MAX_ARRAY_LENGTH;
	
	  var result = baseTimes(length, iteratee);
	  while (++index < n) {
	    iteratee(index);
	  }
	  return result;
	}
	
	module.exports = times;


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/**
	 * Converts `string`, as a whole, to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the lower cased string.
	 * @example
	 *
	 * _.toLower('--Foo-Bar');
	 * // => '--foo-bar'
	 *
	 * _.toLower('fooBar');
	 * // => 'foobar'
	 *
	 * _.toLower('__FOO_BAR__');
	 * // => '__foo_bar__'
	 */
	function toLower(value) {
	  return toString(value).toLowerCase();
	}
	
	module.exports = toLower;


/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(447),
	    keysIn = __webpack_require__(68);
	
	/**
	 * Creates an array of own and inherited enumerable key-value pairs for
	 * `object` which can be consumed by `_.fromPairs`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairsIn(new Foo);
	 * // => [['a', 1], ['b', 2], ['c', 1]] (iteration order is not guaranteed)
	 */
	function toPairsIn(object) {
	  return baseToPairs(object, keysIn(object));
	}
	
	module.exports = toPairsIn;


/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(45),
	    isArray = __webpack_require__(27),
	    stringToPath = __webpack_require__(474);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 *
	 * var path = ['a', 'b', 'c'],
	 *     newPath = _.toPath(path);
	 *
	 * console.log(newPath);
	 * // => ['a', 'b', 'c']
	 *
	 * console.log(path === newPath);
	 * // => false
	 */
	function toPath(value) {
	  return isArray(value) ? arrayMap(value, String) : stringToPath(value);
	}
	
	module.exports = toPath;


/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(160),
	    toInteger = __webpack_require__(31);
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Converts `value` to a safe integer. A safe integer can be compared and
	 * represented correctly.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toSafeInteger(3);
	 * // => 3
	 *
	 * _.toSafeInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toSafeInteger(Infinity);
	 * // => 9007199254740991
	 *
	 * _.toSafeInteger('3');
	 * // => 3
	 */
	function toSafeInteger(value) {
	  return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
	}
	
	module.exports = toSafeInteger;


/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34);
	
	/**
	 * Converts `string`, as a whole, to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the upper cased string.
	 * @example
	 *
	 * _.toUpper('--foo-bar');
	 * // => '--FOO-BAR'
	 *
	 * _.toUpper('fooBar');
	 * // => 'FOOBAR'
	 *
	 * _.toUpper('__foo_bar__');
	 * // => '__FOO_BAR__'
	 */
	function toUpper(value) {
	  return toString(value).toUpperCase();
	}
	
	module.exports = toUpper;


/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(135),
	    baseCreate = __webpack_require__(136),
	    baseForOwn = __webpack_require__(98),
	    baseIteratee = __webpack_require__(17),
	    isArray = __webpack_require__(27),
	    isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(46),
	    isTypedArray = __webpack_require__(165);
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own enumerable
	 * properties through `iteratee`, with each invocation potentially mutating
	 * the `accumulator` object. The iteratee is invoked with four arguments:
	 * (accumulator, value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Array|Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object) || isTypedArray(object);
	  iteratee = baseIteratee(iteratee, 4);
	
	  if (accumulator == null) {
	    if (isArr || isObject(object)) {
	      var Ctor = object.constructor;
	      if (isArr) {
	        accumulator = isArray(object) ? new Ctor : [];
	      } else {
	        accumulator = isFunction(Ctor) ? baseCreate(getPrototypeOf(object)) : {};
	      }
	    } else {
	      accumulator = {};
	    }
	  }
	  (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	var charsEndIndex = __webpack_require__(450),
	    charsStartIndex = __webpack_require__(451),
	    stringToArray = __webpack_require__(116),
	    toString = __webpack_require__(34);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (!string) {
	    return string;
	  }
	  if (guard || chars === undefined) {
	    return string.replace(reTrim, '');
	  }
	  chars = (chars + '');
	  if (!chars) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars);
	
	  return strSymbols
	    .slice(charsStartIndex(strSymbols, chrSymbols), charsEndIndex(strSymbols, chrSymbols) + 1)
	    .join('');
	}
	
	module.exports = trim;


/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	var charsEndIndex = __webpack_require__(450),
	    stringToArray = __webpack_require__(116),
	    toString = __webpack_require__(34);
	
	/** Used to match leading and trailing whitespace. */
	var reTrimEnd = /\s+$/;
	
	/**
	 * Removes trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trimEnd('  abc  ');
	 * // => '  abc'
	 *
	 * _.trimEnd('-_-abc-_-', '_-');
	 * // => '-_-abc'
	 */
	function trimEnd(string, chars, guard) {
	  string = toString(string);
	  if (!string) {
	    return string;
	  }
	  if (guard || chars === undefined) {
	    return string.replace(reTrimEnd, '');
	  }
	  chars = (chars + '');
	  if (!chars) {
	    return string;
	  }
	  var strSymbols = stringToArray(string);
	  return strSymbols
	    .slice(0, charsEndIndex(strSymbols, stringToArray(chars)) + 1)
	    .join('');
	}
	
	module.exports = trimEnd;


/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	var charsStartIndex = __webpack_require__(451),
	    stringToArray = __webpack_require__(116),
	    toString = __webpack_require__(34);
	
	/** Used to match leading and trailing whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * Removes leading whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for functions like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trimStart('  abc  ');
	 * // => 'abc  '
	 *
	 * _.trimStart('-_-abc-_-', '_-');
	 * // => 'abc-_-'
	 */
	function trimStart(string, chars, guard) {
	  string = toString(string);
	  if (!string) {
	    return string;
	  }
	  if (guard || chars === undefined) {
	    return string.replace(reTrimStart, '');
	  }
	  chars = (chars + '');
	  if (!chars) {
	    return string;
	  }
	  var strSymbols = stringToArray(string);
	  return strSymbols
	    .slice(charsStartIndex(strSymbols, stringToArray(chars)))
	    .join('');
	}
	
	module.exports = trimStart;


/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(46),
	    isRegExp = __webpack_require__(492),
	    stringSize = __webpack_require__(207),
	    stringToArray = __webpack_require__(116),
	    toInteger = __webpack_require__(31),
	    toString = __webpack_require__(34);
	
	/** Used as default options for `_.truncate`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
	    rsComboSymbolsRange = '\\u20d0-\\u20f0',
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasComplexSymbol = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object} [options=({})] The options object.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.truncate('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.truncate('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function truncate(string, options) {
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (isObject(options)) {
	    var separator = 'separator' in options ? options.separator : separator;
	    length = 'length' in options ? toInteger(options.length) : length;
	    omission = 'omission' in options ? toString(options.omission) : omission;
	  }
	  string = toString(string);
	
	  var strLength = string.length;
	  if (reHasComplexSymbol.test(string)) {
	    var strSymbols = stringToArray(string);
	    strLength = strSymbols.length;
	  }
	  if (length >= strLength) {
	    return string;
	  }
	  var end = length - stringSize(omission);
	  if (end < 1) {
	    return omission;
	  }
	  var result = strSymbols
	    ? strSymbols.slice(0, end).join('')
	    : string.slice(0, end);
	
	  if (separator === undefined) {
	    return result + omission;
	  }
	  if (strSymbols) {
	    end += (result.length - end);
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          substring = result;
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        var newEnd = match.index;
	      }
	      result = result.slice(0, newEnd === undefined ? end : newEnd);
	    }
	  } else if (string.indexOf(separator, end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = truncate;


/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	var ary = __webpack_require__(475);
	
	/**
	 * Creates a function that accepts up to one argument, ignoring any
	 * additional arguments.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * _.map(['6', '8', '10'], _.unary(parseInt));
	 * // => [6, 8, 10]
	 */
	function unary(func) {
	  return ary(func, 1);
	}
	
	module.exports = unary;


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(34),
	    unescapeHtmlChar = __webpack_require__(902);
	
	/** Used to match HTML entities and HTML characters. */
	var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	    reHasEscapedHtml = RegExp(reEscapedHtml.source);
	
	/**
	 * The inverse of `_.escape`; this method converts the HTML entities
	 * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	 * corresponding characters.
	 *
	 * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	 * entities use a third-party library like [_he_](https://mths.be/he).
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to unescape.
	 * @returns {string} Returns the unescaped string.
	 * @example
	 *
	 * _.unescape('fred, barney, &amp; pebbles');
	 * // => 'fred, barney, & pebbles'
	 */
	function unescape(string) {
	  string = toString(string);
	  return (string && reHasEscapedHtml.test(string))
	    ? string.replace(reEscapedHtml, unescapeHtmlChar)
	    : string;
	}
	
	module.exports = unescape;


/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    baseUniq = __webpack_require__(113),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2, 1], [4, 2], [1, 2]);
	 * // => [2, 1, 4]
	 */
	var union = rest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, true));
	});
	
	module.exports = union;


/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    baseIteratee = __webpack_require__(17),
	    baseUniq = __webpack_require__(113),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.union` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.unionBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	 * // => [2.1, 1.2, 4.3]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	var unionBy = rest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseUniq(baseFlatten(arrays, 1, true), baseIteratee(iteratee));
	});
	
	module.exports = unionBy;


/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(43),
	    baseUniq = __webpack_require__(113),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.union` except that it accepts `comparator` which
	 * is invoked to compare elements of `arrays`. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.unionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var unionWith = rest(function(arrays) {
	  var comparator = last(arrays);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return baseUniq(baseFlatten(arrays, 1, true), undefined, comparator);
	});
	
	module.exports = unionWith;


/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(113);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length)
	    ? baseUniq(array)
	    : [];
	}
	
	module.exports = uniq;


/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(17),
	    baseUniq = __webpack_require__(113);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length)
	    ? baseUniq(array, baseIteratee(iteratee))
	    : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(113);
	
	/**
	 * This method is like `_.uniq` except that it accepts `comparator` which
	 * is invoked to compare elements of `array`. The comparator is invoked with
	 * two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 },  { 'x': 1, 'y': 2 }];
	 *
	 * _.uniqWith(objects, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	 */
	function uniqWith(array, comparator) {
	  return (array && array.length)
	    ? baseUniq(array, undefined, comparator)
	    : [];
	}
	
	module.exports = uniqWith;


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(855);
	
	/**
	 * Removes the property at `path` of `object`.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	 * _.unset(object, 'a[0].b.c');
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 *
	 * _.unset(object, 'a[0].b.c');
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 */
	function unset(object, path) {
	  return object == null ? true : baseUnset(object, path);
	}
	
	module.exports = unset;


/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(140);
	
	/**
	 * Converts `string`, as space separated words, to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the upper cased string.
	 * @example
	 *
	 * _.upperCase('--foo-bar');
	 * // => 'FOO BAR'
	 *
	 * _.upperCase('fooBar');
	 * // => 'FOO BAR'
	 *
	 * _.upperCase('__foo_bar__');
	 * // => 'FOO BAR'
	 */
	var upperCase = createCompounder(function(result, word, index) {
	  return result + (index ? ' ' : '') + word.toUpperCase();
	});
	
	module.exports = upperCase;


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(337),
	    keysIn = __webpack_require__(68);
	
	/**
	 * Creates an array of the own and inherited enumerable property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.valuesIn(new Foo);
	 * // => [1, 2, 3] (iteration order is not guaranteed)
	 */
	function valuesIn(object) {
	  return object == null ? [] : baseValues(object, keysIn(object));
	}
	
	module.exports = valuesIn;


/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(137),
	    isArrayLikeObject = __webpack_require__(52),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array excluding all given values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = rest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(78),
	    partial = __webpack_require__(497);
	
	/**
	 * Creates a function that provides `value` to the wrapper function as its
	 * first argument. Any additional arguments provided to the function are
	 * appended to those provided to the wrapper function. The wrapper is invoked
	 * with the `this` binding of the created function.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {*} value The value to wrap.
	 * @param {Function} [wrapper=identity] The wrapper function.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var p = _.wrap(_.escape, function(func, text) {
	 *   return '<p>' + func(text) + '</p>';
	 * });
	 *
	 * p('fred, barney, & pebbles');
	 * // => '<p>fred, barney, &amp; pebbles</p>'
	 */
	function wrap(value, wrapper) {
	  wrapper = wrapper == null ? identity : wrapper;
	  return partial(wrapper, value);
	}
	
	module.exports = wrap;


/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(315),
	    LodashWrapper = __webpack_require__(316),
	    baseLodash = __webpack_require__(331),
	    isArray = __webpack_require__(27),
	    isObjectLike = __webpack_require__(47),
	    wrapperClone = __webpack_require__(903);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chaining. Methods that operate on and return arrays, collections, and
	 * functions can be chained together. Methods that retrieve a single value or
	 * may return a primitive value will automatically end the chain sequence and
	 * return the unwrapped value. Otherwise, the value must be unwrapped with
	 * `_#value`.
	 *
	 * Explicit chaining, which must be unwrapped with `_#value` in all cases,
	 * may be enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	 * fusion is an optimization to merge iteratee calls; this avoids the creation
	 * of intermediate arrays and can greatly reduce the number of iteratee executions.
	 * Sections of a chain sequence qualify for shortcut fusion if the section is
	 * applied to an array of at least two hundred elements and any iteratees
	 * accept only one argument. The heuristic for whether a section qualifies
	 * for shortcut fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`, `difference`,
	 * `differenceBy`, `differenceWith`, `drop`, `dropRight`, `dropRightWhile`,
	 * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flattenDepth`,
	 * `flip`, `flow`, `flowRight`, `fromPairs`, `functions`, `functionsIn`,
	 * `groupBy`, `initial`, `intersection`, `intersectionBy`, `intersectionWith`,
	 * `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`, `keys`, `keysIn`,
	 * `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`, `memoize`,
	 * `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`, `nthArg`,
	 * `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`, `overEvery`,
	 * `overSome`, `partial`, `partialRight`, `partition`, `pick`, `pickBy`, `plant`,
	 * `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`, `pullAt`, `push`,
	 * `range`, `rangeRight`, `rearg`, `reject`, `remove`, `rest`, `reverse`,
	 * `sampleSize`, `set`, `setWith`, `shuffle`, `slice`, `sort`, `sortBy`,
	 * `splice`, `spread`, `tail`, `take`, `takeRight`, `takeRightWhile`,
	 * `takeWhile`, `tap`, `throttle`, `thru`, `toArray`, `toPairs`, `toPairsIn`,
	 * `toPath`, `toPlainObject`, `transform`, `unary`, `union`, `unionBy`,
	 * `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`, `unshift`, `unzip`,
	 * `unzipWith`, `values`, `valuesIn`, `without`, `wrap`, `xor`, `xorBy`,
	 * `xorWith`, `zip`, `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `deburr`, `endsWith`, `eq`,
	 * `escape`, `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `floor`, `forEach`, `forEachRight`, `forIn`,
	 * `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`, `hasIn`,
	 * `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`, `isArguments`,
	 * `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`, `isBoolean`,
	 * `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`, `isEqualWith`,
	 * `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`, `isMap`,
	 * `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`, `isNumber`,
	 * `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`, `isSafeInteger`,
	 * `isSet`, `isString`, `isUndefined`, `isTypedArray`, `isWeakMap`, `isWeakSet`,
	 * `join`, `kebabCase`, `last`, `lastIndexOf`, `lowerCase`, `lowerFirst`,
	 * `lt`, `lte`, `max`, `maxBy`, `mean`, `min`, `minBy`, `noConflict`, `noop`,
	 * `now`, `pad`, `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`,
	 * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `sample`,
	 * `shift`, `size`, `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`,
	 * `sortedLastIndex`, `sortedLastIndexBy`, `startCase`, `startsWith`, `subtract`,
	 * `sum`, `sumBy`, `template`, `times`, `toLower`, `toInteger`, `toLength`,
	 * `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`, `trimEnd`,
	 * `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`, `upperFirst`,
	 * `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	
	module.exports = lodash;


/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    baseXor = __webpack_require__(338),
	    isArrayLikeObject = __webpack_require__(52),
	    rest = __webpack_require__(16);
	
	/**
	 * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the given arrays.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of values.
	 * @example
	 *
	 * _.xor([2, 1], [4, 2]);
	 * // => [1, 4]
	 */
	var xor = rest(function(arrays) {
	  return baseXor(arrayFilter(arrays, isArrayLikeObject));
	});
	
	module.exports = xor;


/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    baseIteratee = __webpack_require__(17),
	    baseXor = __webpack_require__(338),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.xor` except that it accepts `iteratee` which is
	 * invoked for each element of each `arrays` to generate the criterion by which
	 * uniqueness is computed. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function|Object|string} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new array of values.
	 * @example
	 *
	 * _.xorBy([2.1, 1.2], [4.3, 2.4], Math.floor);
	 * // => [1.2, 4.3]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 2 }]
	 */
	var xorBy = rest(function(arrays) {
	  var iteratee = last(arrays);
	  if (isArrayLikeObject(iteratee)) {
	    iteratee = undefined;
	  }
	  return baseXor(arrayFilter(arrays, isArrayLikeObject), baseIteratee(iteratee));
	});
	
	module.exports = xorBy;


/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(110),
	    baseXor = __webpack_require__(338),
	    isArrayLikeObject = __webpack_require__(52),
	    last = __webpack_require__(62),
	    rest = __webpack_require__(16);
	
	/**
	 * This method is like `_.xor` except that it accepts `comparator` which is
	 * invoked to compare elements of `arrays`. The comparator is invoked with
	 * two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.xorWith(objects, others, _.isEqual);
	 * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var xorWith = rest(function(arrays) {
	  var comparator = last(arrays);
	  if (isArrayLikeObject(comparator)) {
	    comparator = undefined;
	  }
	  return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	});
	
	module.exports = xorWith;


/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	var rest = __webpack_require__(16),
	    unzip = __webpack_require__(357);
	
	/**
	 * Creates an array of grouped elements, the first of which contains the first
	 * elements of the given arrays, the second of which contains the second elements
	 * of the given arrays, and so on.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	 * // => [['fred', 30, true], ['barney', 40, false]]
	 */
	var zip = rest(unzip);
	
	module.exports = zip;


/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(192),
	    baseZipObject = __webpack_require__(449);
	
	/**
	 * This method is like `_.fromPairs` except that it accepts two arrays,
	 * one of property names and one of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} [props=[]] The property names.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObject(['a', 'b'], [1, 2]);
	 * // => { 'a': 1, 'b': 2 }
	 */
	function zipObject(props, values) {
	  return baseZipObject(props || [], values || [], assignValue);
	}
	
	module.exports = zipObject;


/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(334),
	    baseZipObject = __webpack_require__(449);
	
	/**
	 * This method is like `_.zipObject` except that it supports property paths.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} [props=[]] The property names.
	 * @param {Array} [values=[]] The property values.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	 * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	 */
	function zipObjectDeep(props, values) {
	  return baseZipObject(props || [], values || [], baseSet);
	}
	
	module.exports = zipObjectDeep;


/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	var rest = __webpack_require__(16),
	    unzipWith = __webpack_require__(509);
	
	/**
	 * This method is like `_.zip` except that it accepts `iteratee` to specify
	 * how grouped values should be combined. The iteratee is invoked with the
	 * elements of each group: (...group).
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to process.
	 * @param {Function} [iteratee=_.identity] The function to combine grouped values.
	 * @returns {Array} Returns the new array of grouped elements.
	 * @example
	 *
	 * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	 *   return a + b + c;
	 * });
	 * // => [111, 222]
	 */
	var zipWith = rest(function(arrays) {
	  var length = arrays.length,
	      iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	  iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	  return unzipWith(arrays, iteratee);
	});
	
	module.exports = zipWith;


/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Typography = __webpack_require__(119);
	var IconButton = __webpack_require__(168);
	var NavigationMenu = __webpack_require__(532);
	var Paper = __webpack_require__(55);
	
	var AppBar = React.createClass({
	  displayName: 'AppBar',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    onLeftIconButtonTouchTap: React.PropTypes.func,
	    onRightIconButtonTouchTap: React.PropTypes.func,
	    showMenuIconButton: React.PropTypes.bool,
	    style: React.PropTypes.object,
	    iconClassNameLeft: React.PropTypes.string,
	    iconClassNameRight: React.PropTypes.string,
	    iconElementLeft: React.PropTypes.element,
	    iconElementRight: React.PropTypes.element,
	    iconStyleRight: React.PropTypes.object,
	    title: React.PropTypes.node,
	    zDepth: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showMenuIconButton: true,
	      title: '',
	      zDepth: 1
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	      if (this.props.iconElementLeft && this.props.iconClassNameLeft) {
	        console.warn('Properties iconClassNameLeft and iconElementLeft cannot be simultaneously ' + 'defined. Please use one or the other.');
	      }
	
	      if (this.props.iconElementRight && this.props.iconClassNameRight) {
	        console.warn('Properties iconClassNameRight and iconElementRight cannot be simultaneously ' + 'defined. Please use one or the other.');
	      }
	    }
	  },
	
	  getStyles: function getStyles() {
	    var spacing = this.context.muiTheme.spacing;
	    var themeVariables = this.context.muiTheme.component.appBar;
	    var iconButtonSize = this.context.muiTheme.component.button.iconButtonSize;
	    var flatButtonSize = 36;
	    var styles = {
	      root: {
	        zIndex: 5,
	        width: '100%',
	        display: '-webkit-box; display: -webkit-flex; display: flex',
	        minHeight: themeVariables.height,
	        backgroundColor: themeVariables.color,
	        paddingLeft: spacing.desktopGutter,
	        paddingRight: spacing.desktopGutter
	      },
	      title: {
	        whiteSpace: 'nowrap',
	        overflow: 'hidden',
	        textOverflow: 'ellipsis',
	        margin: 0,
	        paddingTop: 0,
	        letterSpacing: 0,
	        fontSize: 24,
	        fontWeight: Typography.fontWeightNormal,
	        color: themeVariables.textColor,
	        lineHeight: themeVariables.height + 'px'
	      },
	      mainElement: {
	        boxFlex: 1,
	        flex: '1'
	      },
	      iconButton: {
	        style: {
	          marginTop: (themeVariables.height - iconButtonSize) / 2,
	          marginRight: 8,
	          marginLeft: -16
	        },
	        iconStyle: {
	          fill: themeVariables.textColor,
	          color: themeVariables.textColor
	        }
	      },
	      flatButton: {
	        color: themeVariables.textColor,
	        backgroundColor: 'transparent',
	        marginTop: (iconButtonSize - flatButtonSize) / 2 + 2
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var props = this.props;
	    var menuElementLeft = undefined;
	    var menuElementRight = undefined;
	    var styles = this.getStyles();
	    var title = props.title;
	    var iconRightStyle = this.mergeAndPrefix(styles.iconButton.style, {
	      marginRight: -16,
	      marginLeft: 'auto'
	    }, props.iconStyleRight);
	    var titleElement = undefined;
	
	    if (title) {
	      // If the title is a string, wrap in an h1 tag.
	      // If not, just use it as a node.
	      titleElement = typeof title === 'string' || title instanceof String ? React.createElement(
	        'h1',
	        { style: this.mergeAndPrefix(styles.title, styles.mainElement) },
	        title
	      ) : React.createElement(
	        'div',
	        { style: this.mergeAndPrefix(styles.mainElement) },
	        title
	      );
	    }
	
	    if (props.showMenuIconButton) {
	      var iconElementLeft = props.iconElementLeft;
	
	      if (iconElementLeft) {
	        switch (iconElementLeft.type.displayName) {
	          case 'IconButton':
	            iconElementLeft = React.cloneElement(iconElementLeft, {
	              iconStyle: this.mergeAndPrefix(styles.iconButton.iconStyle)
	            });
	            break;
	        }
	
	        menuElementLeft = React.createElement(
	          'div',
	          { style: styles.iconButton.style },
	          iconElementLeft
	        );
	      } else {
	        var child = props.iconClassNameLeft ? '' : React.createElement(NavigationMenu, { style: this.mergeAndPrefix(styles.iconButton.iconStyle) });
	        menuElementLeft = React.createElement(
	          IconButton,
	          {
	            style: this.mergeAndPrefix(styles.iconButton.style),
	            iconStyle: this.mergeAndPrefix(styles.iconButton.iconStyle),
	            iconClassName: props.iconClassNameLeft,
	            onTouchTap: this._onLeftIconButtonTouchTap },
	          child
	        );
	      }
	    }
	
	    if (props.iconElementRight) {
	      var iconElementRight = props.iconElementRight;
	
	      switch (iconElementRight.type.displayName) {
	        case 'IconButton':
	          iconElementRight = React.cloneElement(iconElementRight, {
	            iconStyle: this.mergeAndPrefix(styles.iconButton.iconStyle)
	          });
	          break;
	
	        case 'FlatButton':
	          iconElementRight = React.cloneElement(iconElementRight, {
	            style: this.mergeStyles(styles.flatButton, iconElementRight.props.style)
	          });
	          break;
	      }
	
	      menuElementRight = React.createElement(
	        'div',
	        { style: iconRightStyle },
	        iconElementRight
	      );
	    } else if (props.iconClassNameRight) {
	      menuElementRight = React.createElement(IconButton, {
	        style: iconRightStyle,
	        iconStyle: this.mergeAndPrefix(styles.iconButton.iconStyle),
	        iconClassName: props.iconClassNameRight,
	        onTouchTap: this._onRightIconButtonTouchTap });
	    }
	
	    return React.createElement(
	      Paper,
	      {
	        rounded: false,
	        className: props.className,
	        style: this.mergeAndPrefix(styles.root, props.style),
	        zDepth: props.zDepth },
	      menuElementLeft,
	      titleElement,
	      menuElementRight,
	      props.children
	    );
	  },
	
	  _onLeftIconButtonTouchTap: function _onLeftIconButtonTouchTap(event) {
	    if (this.props.onLeftIconButtonTouchTap) {
	      this.props.onLeftIconButtonTouchTap(event);
	    }
	  },
	
	  _onRightIconButtonTouchTap: function _onRightIconButtonTouchTap(event) {
	    if (this.props.onRightIconButtonTouchTap) {
	      this.props.onRightIconButtonTouchTap(event);
	    }
	  }
	
	});
	
	module.exports = AppBar;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var AppCanvas = React.createClass({
	  displayName: 'AppCanvas',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var styles = {
	      height: '100%',
	      backgroundColor: this.context.muiTheme.palette.canvasColor,
	      WebkitFontSmoothing: 'antialiased'
	    };
	
	    var newChildren = React.Children.map(this.props.children, function (currentChild) {
	      if (!currentChild) {
	        // If undefined, skip it
	        return null;
	      }
	
	      switch (currentChild.type.displayName) {
	        case 'AppBar':
	          return React.cloneElement(currentChild, {
	            style: _this.mergeStyles({
	              position: 'fixed'
	            }, currentChild.props.style)
	          });
	        default:
	          return currentChild;
	      }
	    }, this);
	
	    return React.createElement(
	      'div',
	      { style: styles },
	      newChildren
	    );
	  }
	
	});
	
	module.exports = AppCanvas;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var Styles = __webpack_require__(369);
	
	var FlatButtonLabel = React.createClass({
	  displayName: 'FlatButtonLabel',
	
	  mixins: [PureRenderMixin],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    label: React.PropTypes.node,
	    style: React.PropTypes.object
	  },
	
	  getContextProps: function getContextProps() {
	    var theme = this.context.muiTheme;
	
	    return {
	      spacingDesktopGutterLess: theme.spacing.desktopGutterLess
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	    var style = _props.style;
	
	    var contextProps = this.getContextProps();
	
	    var mergedRootStyles = Styles.mergeAndPrefix({
	      position: 'relative',
	      padding: '0 ' + contextProps.spacingDesktopGutterLess + 'px'
	    }, style);
	
	    return React.createElement(
	      'span',
	      { style: mergedRootStyles },
	      label
	    );
	  }
	
	});
	
	module.exports = FlatButtonLabel;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var CardActions = React.createClass({
	  displayName: 'CardActions',
	
	  mixins: [StylePropable],
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: 8,
	        position: 'relative'
	      }
	    };
	  },
	
	  propTypes: {
	    expandable: React.PropTypes.bool,
	    showExpandableButton: React.PropTypes.bool
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	
	    var children = React.Children.map(this.props.children, function (child) {
	      return React.cloneElement(child, {
	        style: { marginRight: 8 }
	      });
	    });
	
	    var mergedStyles = this.mergeAndPrefix(styles.root, this.props.style);
	
	    return React.createElement(
	      'div',
	      _extends({}, this.props, { style: mergedStyles }),
	      children
	    );
	  }
	});
	
	module.exports = CardActions;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Styles = __webpack_require__(169);
	var Avatar = __webpack_require__(513);
	var StylePropable = __webpack_require__(6);
	
	var CardHeader = React.createClass({
	  displayName: 'CardHeader',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    title: React.PropTypes.string,
	    titleColor: React.PropTypes.string,
	    titleStyle: React.PropTypes.object,
	    subtitle: React.PropTypes.string,
	    subtitleColor: React.PropTypes.string,
	    subtitleStyle: React.PropTypes.object,
	    textStyle: React.PropTypes.object,
	    expandable: React.PropTypes.bool,
	    showExpandableButton: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      titleColor: Styles.Colors.darkBlack,
	      subtitleColor: Styles.Colors.lightBlack
	    };
	  },
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        height: 72,
	        padding: 16,
	        fontWeight: Styles.Typography.fontWeightMedium,
	        boxSizing: 'border-box',
	        position: 'relative'
	      },
	      text: {
	        display: 'inline-block',
	        verticalAlign: 'top'
	      },
	      avatar: {
	        marginRight: 16
	      },
	      title: {
	        color: this.props.titleColor,
	        display: 'block',
	        fontSize: 15
	      },
	      subtitle: {
	        color: this.props.subtitleColor,
	        display: 'block',
	        fontSize: 14
	      }
	    };
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeAndPrefix(styles.root, this.props.style);
	    var textStyle = this.mergeAndPrefix(styles.text, this.props.textStyle);
	    var titleStyle = this.mergeAndPrefix(styles.title, this.props.titleStyle);
	    var subtitleStyle = this.mergeAndPrefix(styles.subtitle, this.props.subtitleStyle);
	
	    var avatar = this.props.avatar;
	    if (React.isValidElement(this.props.avatar)) {
	      var avatarMergedStyle = this.mergeStyles(styles.avatar, avatar.props.style);
	      avatar = React.cloneElement(avatar, { style: avatarMergedStyle });
	    } else avatar = React.createElement(Avatar, { src: this.props.avatar, style: styles.avatar });
	
	    return React.createElement(
	      'div',
	      _extends({}, this.props, { style: rootStyle }),
	      avatar,
	      React.createElement(
	        'div',
	        { style: textStyle },
	        React.createElement(
	          'span',
	          { style: titleStyle },
	          this.props.title
	        ),
	        React.createElement(
	          'span',
	          { style: subtitleStyle },
	          this.props.subtitle
	        )
	      ),
	      this.props.children
	    );
	  }
	});
	
	module.exports = CardHeader;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Styles = __webpack_require__(169);
	var StylePropable = __webpack_require__(6);
	
	var CardMedia = React.createClass({
	  displayName: 'CardMedia',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    overlay: React.PropTypes.node,
	    style: React.PropTypes.object,
	    overlayStyle: React.PropTypes.object,
	    overlayContainerStyle: React.PropTypes.object,
	    overlayContentStyle: React.PropTypes.object,
	    mediaStyle: React.PropTypes.object,
	    expandable: React.PropTypes.bool
	  },
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        position: 'relative'
	      },
	      overlayContainer: {
	        position: 'absolute',
	        top: 0,
	        bottom: 0,
	        right: 0,
	        left: 0
	      },
	      overlay: {
	        height: '100%',
	        position: 'relative'
	      },
	      overlayContent: {
	        position: 'absolute',
	        bottom: 0,
	        right: 0,
	        left: 0,
	        paddingTop: 8,
	        background: Styles.Colors.lightBlack
	      },
	      media: {},
	      mediaChild: {
	        verticalAlign: 'top',
	        maxWidth: '100%',
	        minWidth: '100%'
	      }
	    };
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var styles = this.getStyles();
	    var rootStyle = this.mergeAndPrefix(styles.root, this.props.style);
	    var mediaStyle = this.mergeAndPrefix(styles.media, this.props.mediaStyle);
	    var overlayContainerStyle = this.mergeAndPrefix(styles.overlayContainer, this.props.overlayContainerStyle);
	    var overlayContentStyle = this.mergeAndPrefix(styles.overlayContent, this.props.overlayContentStyle);
	    var overlayStyle = this.mergeAndPrefix(styles.overlay, this.props.overlayStyle);
	
	    var children = React.Children.map(this.props.children, function (child) {
	      return React.cloneElement(child, { style: _this.mergeAndPrefix(styles.mediaChild, child.props.style) });
	    });
	
	    var overlayChildren = React.Children.map(this.props.overlay, function (child) {
	      if (child.type.displayName === 'CardHeader' || child.type.displayName === 'CardTitle') {
	        return React.cloneElement(child, {
	          titleColor: Styles.Colors.darkWhite,
	          subtitleColor: Styles.Colors.lightWhite
	        });
	      } else if (child.type.displayName === 'CardText') {
	        return React.cloneElement(child, {
	          color: Styles.Colors.darkWhite
	        });
	      } else {
	        return child;
	      }
	    });
	
	    return React.createElement(
	      'div',
	      _extends({}, this.props, { style: rootStyle }),
	      React.createElement(
	        'div',
	        { style: mediaStyle },
	        children
	      ),
	      this.props.overlay ? React.createElement(
	        'div',
	        { style: overlayContainerStyle },
	        React.createElement(
	          'div',
	          { style: overlayStyle },
	          React.createElement(
	            'div',
	            { style: overlayContentStyle },
	            overlayChildren
	          )
	        )
	      ) : ''
	    );
	  }
	});
	
	module.exports = CardMedia;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Styles = __webpack_require__(169);
	var StylePropable = __webpack_require__(6);
	
	var CardText = React.createClass({
	  displayName: 'CardText',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    color: React.PropTypes.string,
	    style: React.PropTypes.object,
	    expandable: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      color: Styles.Colors.ck
	    };
	  },
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: 16,
	        fontSize: '14px',
	        color: this.props.color
	      }
	    };
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeAndPrefix(styles.root, this.props.style);
	
	    return React.createElement(
	      'div',
	      _extends({}, this.props, { style: rootStyle }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = CardText;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Styles = __webpack_require__(169);
	var StylePropable = __webpack_require__(6);
	
	var CardTitle = React.createClass({
	  displayName: 'CardTitle',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    title: React.PropTypes.string,
	    titleColor: React.PropTypes.string,
	    titleStyle: React.PropTypes.object,
	    subtitle: React.PropTypes.string,
	    subtitleColor: React.PropTypes.string,
	    subtitleStyle: React.PropTypes.object,
	    expandable: React.PropTypes.bool,
	    showExpandableButton: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      titleColor: Styles.Colors.darkBlack,
	      subtitleColor: Styles.Colors.lightBlack
	    };
	  },
	
	  getStyles: function getStyles() {
	    return {
	      root: {
	        padding: 16,
	        position: 'relative'
	      },
	      title: {
	        fontSize: 24,
	        color: this.props.titleColor,
	        display: 'block',
	        lineHeight: '36px'
	      },
	      subtitle: {
	        fontSize: 14,
	        color: this.props.subtitleColor,
	        display: 'block'
	      }
	    };
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var rootStyle = this.mergeAndPrefix(styles.root, this.props.style);
	    var titleStyle = this.mergeAndPrefix(styles.title, this.props.titleStyle);
	    var subtitleStyle = this.mergeAndPrefix(styles.subtitle, this.props.subtitleStyle);
	
	    return React.createElement(
	      'div',
	      _extends({}, this.props, { style: rootStyle }),
	      React.createElement(
	        'span',
	        { style: titleStyle },
	        this.props.title
	      ),
	      React.createElement(
	        'span',
	        { style: subtitleStyle },
	        this.props.subtitle
	      ),
	      this.props.children
	    );
	  }
	});
	
	module.exports = CardTitle;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var Paper = __webpack_require__(55);
	var StylePropable = __webpack_require__(6);
	var CardExpandable = __webpack_require__(515);
	
	var Card = React.createClass({
	  displayName: 'Card',
	
	  mixins: [StylePropable],
	
	  getInitialState: function getInitialState() {
	    return { expanded: this.props.initiallyExpanded ? true : false };
	  },
	
	  propTypes: {
	    style: React.PropTypes.object,
	    expandable: React.PropTypes.bool,
	    initiallyExpanded: React.PropTypes.bool,
	    onExpandChange: React.PropTypes.func
	  },
	
	  _onExpandable: function _onExpandable(value) {
	    this.setState({ expanded: value });
	    if (this.props.onExpandChange) this.props.onExpandChange(value);
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var lastElement = undefined;
	    var newChildren = React.Children.map(this.props.children, function (currentChild) {
	      if (!currentChild) {
	        return null;
	      }
	      if (_this.state.expanded === false && currentChild.props.expandable === true) return;
	      if (currentChild.props.showExpandableButton === true) {
	        lastElement = React.cloneElement(currentChild, {}, currentChild.props.children, React.createElement(CardExpandable, { expanded: _this.state.expanded, onExpanding: _this._onExpandable }));
	      } else {
	        lastElement = currentChild;
	      }
	      return lastElement;
	    }, this);
	
	    // If the last element is text or a title we should add
	    // 8px padding to the bottom of the card
	    var addBottomPadding = lastElement && (lastElement.type.displayName === "CardText" || lastElement.type.displayName === "CardTitle");
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var mergedStyles = this.mergeAndPrefix({
	      overflow: 'hidden',
	      zIndex: 1
	    }, style);
	
	    return React.createElement(
	      Paper,
	      _extends({}, other, { style: mergedStyles }),
	      React.createElement(
	        'div',
	        { style: { paddingBottom: addBottomPadding ? 8 : 0 } },
	        newChildren
	      )
	    );
	  }
	});
	
	module.exports = Card;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	
	var CircularProgress = React.createClass({
	  displayName: 'CircularProgress',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    mode: React.PropTypes.oneOf(["determinate", "indeterminate"]),
	    value: React.PropTypes.number,
	    min: React.PropTypes.number,
	    max: React.PropTypes.number,
	    size: React.PropTypes.number,
	    color: React.PropTypes.string,
	    innerStyle: React.PropTypes.object
	  },
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  _getRelativeValue: function _getRelativeValue() {
	    var value = this.props.value;
	    var min = this.props.min;
	    var max = this.props.max;
	
	    var clampedValue = Math.min(Math.max(min, value), max);
	    var rangeValue = max - min;
	    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	    return relValue * 100;
	  },
	
	  componentDidMount: function componentDidMount() {
	    var wrapper = React.findDOMNode(this.refs.wrapper);
	    var path = React.findDOMNode(this.refs.path);
	
	    this._scalePath(path);
	    this._rotateWrapper(wrapper);
	  },
	
	  _scalePath: function _scalePath(path, step) {
	    step = step || 0;
	    step %= 3;
	
	    setTimeout(this._scalePath.bind(this, path, step + 1), step ? 750 : 250);
	
	    if (!this.isMounted()) return;
	    if (this.props.mode !== "indeterminate") return;
	
	    if (step === 0) {
	      path.style.strokeDasharray = "1, 200";
	      path.style.strokeDashoffset = 0;
	      path.style.transitionDuration = "0ms";
	    } else if (step === 1) {
	      path.style.strokeDasharray = "89, 200";
	      path.style.strokeDashoffset = -35;
	      path.style.transitionDuration = "750ms";
	    } else {
	      path.style.strokeDasharray = "89,200";
	      path.style.strokeDashoffset = -124;
	      path.style.transitionDuration = "850ms";
	    }
	  },
	
	  _rotateWrapper: function _rotateWrapper(wrapper) {
	    setTimeout(this._rotateWrapper.bind(this, wrapper), 10050);
	
	    if (!this.isMounted()) return;
	    if (this.props.mode !== "indeterminate") return;
	
	    AutoPrefix.set(wrapper.style, "transform", null);
	    AutoPrefix.set(wrapper.style, "transform", "rotate(0deg)");
	    wrapper.style.transitionDuration = "0ms";
	
	    setTimeout(function () {
	      AutoPrefix.set(wrapper.style, "transform", "rotate(1800deg)");
	      wrapper.style.transitionDuration = "10s";
	      //wrapper.style.webkitTransitionTimingFunction = "linear";
	      AutoPrefix.set(wrapper.style, "transitionTimingFunction", "linear");
	    }, 50);
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: "indeterminate",
	      value: 0,
	      min: 0,
	      max: 100,
	      size: 1
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.palette;
	  },
	
	  getStyles: function getStyles(zoom) {
	    zoom *= 1.4;
	    var size = "50px";
	
	    var margin = Math.round((50 * zoom - 50) / 2);
	
	    if (margin < 0) margin = 0;
	
	    var styles = {
	      root: {
	        position: "relative",
	        margin: margin + "px",
	        display: "inline-block",
	        width: size,
	        height: size
	      },
	      wrapper: {
	        width: size,
	        height: size,
	        margin: "5px",
	        display: "inline-block",
	        transition: Transitions.create("transform", "20s", null, "linear")
	      },
	      svg: {
	        height: size,
	        position: "relative",
	        transform: "scale(" + zoom + ")",
	        width: size
	      },
	      path: {
	        strokeDasharray: "89,200",
	        strokeDashoffset: 0,
	        stroke: this.props.color || this.getTheme().primary1Color,
	        strokeLinecap: "round",
	        transition: Transitions.create("all", "1.5s", null, "ease-in-out")
	      }
	    };
	
	    AutoPrefix.set(styles.wrapper, "transitionTimingFunction", "linear");
	
	    if (this.props.mode === "determinate") {
	      var relVal = this._getRelativeValue();
	      styles.path.transition = Transitions.create("all", "0.3s", null, "linear");
	      styles.path.strokeDasharray = Math.round(relVal * 1.25) + ",200";
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var innerStyle = _props.innerStyle;
	    var size = _props.size;
	
	    var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);
	
	    var styles = this.getStyles(size || 1);
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles.root, style) }),
	      React.createElement(
	        'div',
	        { ref: 'wrapper', style: this.mergeAndPrefix(styles.wrapper, innerStyle) },
	        React.createElement(
	          'svg',
	          { style: this.mergeAndPrefix(styles.svg) },
	          React.createElement('circle', { ref: 'path', style: this.mergeAndPrefix(styles.path), cx: '25', cy: '25',
	            r: '20', fill: 'none', strokeWidth: '2.5', strokeMiterlimit: '10' })
	        )
	      )
	    );
	  }
	});
	
	module.exports = CircularProgress;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var DateTime = __webpack_require__(120);
	var DayButton = __webpack_require__(1131);
	var ClearFix = __webpack_require__(166);
	
	var CalendarMonth = React.createClass({
	  displayName: 'CalendarMonth',
	
	  propTypes: {
	    displayDate: React.PropTypes.object.isRequired,
	    selectedDate: React.PropTypes.object.isRequired,
	    autoOk: React.PropTypes.bool,
	    maxDate: React.PropTypes.object,
	    minDate: React.PropTypes.object,
	    onDayTouchTap: React.PropTypes.func,
	    shouldDisableDate: React.PropTypes.func
	  },
	
	  render: function render() {
	    var styles = {
	      lineHeight: '32px',
	      textAlign: 'center',
	      padding: '16px 14px 0 14px'
	    };
	
	    return React.createElement(
	      'div',
	      { style: styles },
	      this._getWeekElements()
	    );
	  },
	
	  isSelectedDateDisabled: function isSelectedDateDisabled() {
	    return this._selectedDateDisabled;
	  },
	
	  _getWeekElements: function _getWeekElements() {
	    var _this = this;
	
	    var weekArray = DateTime.getWeekArray(this.props.displayDate);
	
	    return weekArray.map(function (week, i) {
	      return React.createElement(
	        ClearFix,
	        { key: i },
	        _this._getDayElements(week, i)
	      );
	    }, this);
	  },
	
	  _getDayElements: function _getDayElements(week, i) {
	    var _this2 = this;
	
	    return week.map(function (day, j) {
	      var isSameDate = DateTime.isEqualDate(_this2.props.selectedDate, day);
	      var disabled = _this2._shouldDisableDate(day);
	      var selected = !disabled && isSameDate;
	
	      if (isSameDate) {
	        if (disabled) {
	          _this2._selectedDateDisabled = true;
	        } else {
	          _this2._selectedDateDisabled = false;
	        }
	      }
	
	      return React.createElement(DayButton, {
	        key: 'db' + i + j,
	        date: day,
	        onTouchTap: _this2._handleDayTouchTap,
	        selected: selected,
	        disabled: disabled });
	    }, this);
	  },
	
	  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
	    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
	  },
	
	  _shouldDisableDate: function _shouldDisableDate(day) {
	    if (day === null) return false;
	    var disabled = !DateTime.isBetweenDates(day, this.props.minDate, this.props.maxDate);
	    if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	    return disabled;
	  }
	
	});
	
	module.exports = CalendarMonth;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var DateTime = __webpack_require__(120);
	var IconButton = __webpack_require__(168);
	var Toolbar = __webpack_require__(538);
	var ToolbarGroup = __webpack_require__(537);
	var NavigationChevronLeft = __webpack_require__(530);
	var NavigationChevronRight = __webpack_require__(531);
	var SlideInTransitionGroup = __webpack_require__(366);
	
	var CalendarToolbar = React.createClass({
	  displayName: 'CalendarToolbar',
	
	  propTypes: {
	    displayDate: React.PropTypes.object.isRequired,
	    nextMonth: React.PropTypes.bool,
	    onMonthChange: React.PropTypes.func,
	    prevMonth: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      nextMonth: true,
	      prevMonth: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      transitionDirection: 'up'
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var direction = undefined;
	
	    if (nextProps.displayDate !== this.props.displayDate) {
	      direction = nextProps.displayDate > this.props.displayDate ? 'up' : 'down';
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	  },
	
	  _styles: function _styles() {
	    return {
	      root: {
	        position: 'relative',
	        padding: 0,
	        backgroundColor: 'inherit'
	      },
	
	      title: {
	        position: 'absolute',
	        top: '17px',
	        lineHeight: '14px',
	        fontSize: '14px',
	        height: '14px',
	        width: '100%',
	        fontWeight: '500',
	        textAlign: 'center'
	      }
	    };
	  },
	
	  render: function render() {
	    var month = DateTime.getFullMonth(this.props.displayDate);
	    var year = this.props.displayDate.getFullYear();
	    var styles = this._styles();
	
	    return React.createElement(
	      Toolbar,
	      { className: 'mui-date-picker-calendar-toolbar', style: styles.root, noGutter: true },
	      React.createElement(
	        SlideInTransitionGroup,
	        {
	          style: styles.title,
	          direction: this.state.transitionDirection },
	        React.createElement(
	          'div',
	          { key: month + '_' + year },
	          month,
	          ' ',
	          year
	        )
	      ),
	      React.createElement(
	        ToolbarGroup,
	        { key: 0, float: 'left' },
	        React.createElement(
	          IconButton,
	          {
	            style: styles.button,
	            disabled: !this.props.prevMonth,
	            onTouchTap: this._prevMonthTouchTap },
	          React.createElement(NavigationChevronLeft, null)
	        )
	      ),
	      React.createElement(
	        ToolbarGroup,
	        { key: 1, float: 'right' },
	        React.createElement(
	          IconButton,
	          {
	            style: styles.button,
	            disabled: !this.props.nextMonth,
	            onTouchTap: this._nextMonthTouchTap },
	          React.createElement(NavigationChevronRight, null)
	        )
	      )
	    );
	  },
	
	  _prevMonthTouchTap: function _prevMonthTouchTap() {
	    if (this.props.onMonthChange && this.props.prevMonth) this.props.onMonthChange(-1);
	  },
	
	  _nextMonthTouchTap: function _nextMonthTouchTap() {
	    if (this.props.onMonthChange && this.props.nextMonth) this.props.onMonthChange(1);
	  }
	
	});
	
	module.exports = CalendarToolbar;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Colors = __webpack_require__(56);
	var DateTime = __webpack_require__(120);
	var YearButton = __webpack_require__(1132);
	
	var CalendarYear = React.createClass({
	  displayName: 'CalendarYear',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    displayDate: React.PropTypes.object.isRequired,
	    onYearTouchTap: React.PropTypes.func,
	    selectedDate: React.PropTypes.object.isRequired,
	    minDate: React.PropTypes.object,
	    maxDate: React.PropTypes.object
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._scrollToSelectedYear();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._scrollToSelectedYear();
	  },
	
	  render: function render() {
	    var years = this._getYears();
	    var styles = {
	      position: 'relative',
	      height: 'inherit',
	      lineHeight: '36px',
	      textAlign: 'center',
	      padding: '8px 14px 0 14px',
	      backgroundColor: Colors.white,
	      overflowX: 'hidden',
	      overflowY: 'scroll'
	    };
	
	    return React.createElement(
	      'div',
	      { style: styles },
	      years
	    );
	  },
	
	  _getYears: function _getYears() {
	    var minYear = this.props.minDate.getFullYear();
	    var maxYear = this.props.maxDate.getFullYear();
	
	    var years = [];
	    var dateCheck = DateTime.clone(this.props.selectedDate);
	    for (var year = minYear; year <= maxYear; year++) {
	      dateCheck.setFullYear(year);
	      if (!DateTime.isBetweenDates(dateCheck, this.props.minDate, this.props.maxDate)) continue;
	      var selected = this.props.selectedDate.getFullYear() === year;
	      var selectedProps = {};
	      if (selected) {
	        selectedProps = { ref: 'selectedYearButton' };
	      }
	
	      var yearButton = React.createElement(YearButton, _extends({
	        key: 'yb' + year,
	        year: year,
	        onTouchTap: this._handleYearTouchTap,
	        selected: selected
	      }, selectedProps));
	
	      years.push(yearButton);
	    }
	
	    return years;
	  },
	
	  _scrollToSelectedYear: function _scrollToSelectedYear() {
	    if (this.refs.selectedYearButton === undefined) return;
	
	    var container = this.getDOMNode();
	    var yearButtonNode = this.refs.selectedYearButton.getDOMNode();
	
	    var containerHeight = container.clientHeight;
	    var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	    var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	    container.scrollTop = scrollYOffset;
	  },
	
	  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
	    if (this.props.onYearTouchTap) this.props.onYearTouchTap(e, year);
	  }
	
	});
	
	module.exports = CalendarYear;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var WindowListenable = __webpack_require__(89);
	var DateTime = __webpack_require__(120);
	var KeyCode = __webpack_require__(73);
	var Transitions = __webpack_require__(24);
	var CalendarMonth = __webpack_require__(1125);
	var CalendarYear = __webpack_require__(1127);
	var CalendarToolbar = __webpack_require__(1126);
	var DateDisplay = __webpack_require__(1129);
	var SlideInTransitionGroup = __webpack_require__(366);
	var ClearFix = __webpack_require__(166);
	
	var Calendar = React.createClass({
	  displayName: 'Calendar',
	
	  mixins: [StylePropable, WindowListenable],
	
	  propTypes: {
	    disableYearSelection: React.PropTypes.bool,
	    initialDate: React.PropTypes.object,
	    isActive: React.PropTypes.bool,
	    minDate: React.PropTypes.object,
	    maxDate: React.PropTypes.object,
	    onDayTouchTap: React.PropTypes.func,
	    shouldDisableDate: React.PropTypes.func,
	    shouldShowMonthDayPickerFirst: React.PropTypes.bool
	  },
	
	  windowListeners: {
	    'keydown': '_handleWindowKeyDown'
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableYearSelection: false,
	      initialDate: new Date(),
	      minDate: DateTime.addYears(new Date(), -100),
	      maxDate: DateTime.addYears(new Date(), 100),
	      shouldShowMonthDayPickerFirst: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      displayDate: DateTime.getFirstDayOfMonth(this.props.initialDate),
	      displayMonthDay: this.props.shouldShowMonthDayPickerFirst || true,
	      selectedDate: this.props.initialDate,
	      transitionDirection: 'left',
	      transitionEnter: true
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.initialDate !== this.props.initialDate) {
	      var d = nextProps.initialDate || new Date();
	      this.setState({
	        displayDate: DateTime.getFirstDayOfMonth(d),
	        selectedDate: d
	      });
	    }
	
	    if (nextProps.shouldShowMonthDayPickerFirst) {
	      this.setState({ displayMonthDay: nextProps.shouldShowMonthDayPickerFirst });
	    }
	  },
	
	  render: function render() {
	    var yearCount = DateTime.yearDiff(this.props.maxDate, this.props.minDate) + 1;
	    var weekCount = DateTime.getWeekArray(this.state.displayDate).length;
	    var toolbarInteractions = this._getToolbarInteractions();
	    var isLandscape = this.props.mode === 'landscape';
	    var styles = {
	      root: {
	        fontSize: 12
	      },
	      calendarContainer: {
	        width: isLandscape ? 320 : '100%',
	        height: weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
	        float: isLandscape ? 'right' : 'none',
	        transition: Transitions.easeOut('150ms', 'height'),
	        overflow: 'hidden'
	      },
	      yearContainer: {
	        width: 280,
	        overflow: 'hidden',
	        height: yearCount < 6 ? yearCount * 56 + 10 : weekCount === 5 ? 284 : weekCount === 6 ? 324 : 244,
	        float: isLandscape ? 'right' : 'none'
	      },
	      dateDisplay: {
	        width: isLandscape ? 120 : '',
	        height: isLandscape ? weekCount === 5 ? 238 : weekCount === 6 ? 278 : 198 : '100%',
	        float: isLandscape ? 'left' : 'none'
	      },
	      weekTitle: {
	        padding: '0 14px',
	        lineHeight: '12px',
	        opacity: '0.5',
	        height: 12,
	        fontWeight: '500',
	        margin: 0
	      },
	      weekTitleDay: {
	        listStyle: 'none',
	        float: 'left',
	        width: 37,
	        textAlign: 'center',
	        margin: '0 2px'
	      }
	    };
	
	    if (this.state.displayMonthDay) {
	      styles.yearContainer.display = 'none';
	    } else {
	      styles.calendarContainer.display = 'none';
	    }
	
	    return React.createElement(
	      ClearFix,
	      { style: this.mergeAndPrefix(styles.root) },
	      React.createElement(DateDisplay, {
	        disableYearSelection: this.props.disableYearSelection,
	        style: styles.dateDisplay,
	        selectedDate: this.state.selectedDate,
	        handleMonthDayClick: this._handleMonthDayClick,
	        handleYearClick: this._handleYearClick,
	        monthDaySelected: this.state.displayMonthDay,
	        mode: this.props.mode,
	        weekCount: weekCount }),
	      React.createElement(
	        'div',
	        { style: styles.calendarContainer },
	        React.createElement(CalendarToolbar, {
	          displayDate: this.state.displayDate,
	          onMonthChange: this._handleMonthChange,
	          prevMonth: toolbarInteractions.prevMonth,
	          nextMonth: toolbarInteractions.nextMonth }),
	        React.createElement(
	          ClearFix,
	          {
	            elementType: 'ul',
	            style: styles.weekTitle },
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'S'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'M'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'T'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'W'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'T'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'F'
	          ),
	          React.createElement(
	            'li',
	            { style: styles.weekTitleDay },
	            'S'
	          )
	        ),
	        React.createElement(
	          SlideInTransitionGroup,
	          {
	            direction: this.state.transitionDirection },
	          React.createElement(CalendarMonth, {
	            key: this.state.displayDate.toDateString(),
	            ref: 'calendar',
	            displayDate: this.state.displayDate,
	            onDayTouchTap: this._handleDayTouchTap,
	            selectedDate: this.state.selectedDate,
	            minDate: this.props.minDate,
	            maxDate: this.props.maxDate,
	            shouldDisableDate: this.props.shouldDisableDate })
	        )
	      ),
	      React.createElement(
	        'div',
	        { style: styles.yearContainer },
	        this._yearSelector()
	      )
	    );
	  },
	
	  _yearSelector: function _yearSelector() {
	    if (this.props.disableYearSelection) return;
	
	    return React.createElement(CalendarYear, {
	      key: 'years',
	      displayDate: this.state.displayDate,
	      onYearTouchTap: this._handleYearTouchTap,
	      selectedDate: this.state.selectedDate,
	      minDate: this.props.minDate,
	      maxDate: this.props.maxDate });
	  },
	
	  getSelectedDate: function getSelectedDate() {
	    return this.state.selectedDate;
	  },
	
	  isSelectedDateDisabled: function isSelectedDateDisabled() {
	    return this.refs.calendar.isSelectedDateDisabled();
	  },
	
	  _addSelectedDays: function _addSelectedDays(days) {
	    this._setSelectedDate(DateTime.addDays(this.state.selectedDate, days));
	  },
	
	  _addSelectedMonths: function _addSelectedMonths(months) {
	    this._setSelectedDate(DateTime.addMonths(this.state.selectedDate, months));
	  },
	
	  _addSelectedYears: function _addSelectedYears(years) {
	    this._setSelectedDate(DateTime.addYears(this.state.selectedDate, years));
	  },
	
	  _setDisplayDate: function _setDisplayDate(d, newSelectedDate) {
	    var newDisplayDate = DateTime.getFirstDayOfMonth(d);
	    var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	    if (newDisplayDate !== this.state.displayDate) {
	      this.setState({
	        displayDate: newDisplayDate,
	        transitionDirection: direction,
	        selectedDate: newSelectedDate || this.state.selectedDate
	      });
	    }
	  },
	
	  _setSelectedDate: function _setSelectedDate(date) {
	    var adjustedDate = date;
	    if (DateTime.isBeforeDate(date, this.props.minDate)) {
	      adjustedDate = this.props.minDate;
	    } else if (DateTime.isAfterDate(date, this.props.maxDate)) {
	      adjustedDate = this.props.maxDate;
	    }
	
	    var newDisplayDate = DateTime.getFirstDayOfMonth(adjustedDate);
	    if (newDisplayDate !== this.state.displayDate) {
	      this._setDisplayDate(newDisplayDate, adjustedDate);
	    } else {
	      this.setState({
	        selectedDate: adjustedDate
	      });
	    }
	  },
	
	  _handleDayTouchTap: function _handleDayTouchTap(e, date) {
	    this._setSelectedDate(date);
	    if (this.props.onDayTouchTap) this.props.onDayTouchTap(e, date);
	  },
	
	  _handleMonthChange: function _handleMonthChange(months) {
	    this.setState({ displayDate: DateTime.addMonths(this.state.displayDate, months) });
	  },
	
	  _handleYearTouchTap: function _handleYearTouchTap(e, year) {
	    var date = DateTime.clone(this.state.selectedDate);
	    date.setFullYear(year);
	    this._setSelectedDate(date, e);
	  },
	
	  _getToolbarInteractions: function _getToolbarInteractions() {
	    return {
	      prevMonth: DateTime.monthDiff(this.state.selectedDate, this.props.minDate) > 0,
	      nextMonth: DateTime.monthDiff(this.state.selectedDate, this.props.maxDate) < 0
	    };
	  },
	
	  _handleMonthDayClick: function _handleMonthDayClick() {
	    this.setState({ displayMonthDay: true });
	  },
	
	  _handleYearClick: function _handleYearClick() {
	    this.setState({ displayMonthDay: false });
	  },
	
	  _handleWindowKeyDown: function _handleWindowKeyDown(e) {
	    if (this.props.isActive) {
	
	      switch (e.keyCode) {
	        case KeyCode.UP:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(-1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(-1);
	          } else {
	            this._addSelectedDays(-7);
	          }
	          break;
	
	        case KeyCode.DOWN:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(1);
	          } else {
	            this._addSelectedDays(7);
	          }
	          break;
	
	        case KeyCode.RIGHT:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(1);
	          } else {
	            this._addSelectedDays(1);
	          }
	          break;
	
	        case KeyCode.LEFT:
	          if (e.altKey && e.shiftKey) {
	            this._addSelectedYears(-1);
	          } else if (e.shiftKey) {
	            this._addSelectedMonths(-1);
	          } else {
	            this._addSelectedDays(-1);
	          }
	          break;
	      }
	    }
	  }
	
	});
	
	module.exports = Calendar;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var DateTime = __webpack_require__(120);
	var Transitions = __webpack_require__(24);
	var SlideInTransitionGroup = __webpack_require__(366);
	
	var DateDisplay = React.createClass({
	  displayName: 'DateDisplay',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    disableYearSelection: React.PropTypes.bool,
	    monthDaySelected: React.PropTypes.bool,
	    selectedDate: React.PropTypes.object.isRequired,
	    weekCount: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableYearSelection: false,
	      monthDaySelected: true,
	      weekCount: 4
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedYear: !this.props.monthDaySelected,
	      transitionDirection: 'up'
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var direction = undefined;
	
	    if (nextProps.selectedDate !== this.props.selectedDate) {
	      direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	
	    if (nextProps.monthDaySelected !== undefined) {
	      this.setState({ selectedYear: !nextProps.monthDaySelected });
	    }
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.datePicker;
	  },
	
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var isLandscape = this.props.mode === 'landscape';
	
	    var styles = {
	      root: {
	        backgroundColor: theme.selectColor,
	        borderTopLeftRadius: 2,
	        borderTopRightRadius: 2,
	        color: theme.textColor,
	        height: 60,
	        padding: 20
	      },
	
	      month: {
	        display: isLandscape ? 'block' : undefined,
	        marginLeft: isLandscape ? undefined : 8,
	        marginTop: isLandscape ? 5 : undefined
	      },
	
	      monthDay: {
	        root: {
	          display: 'inline-block',
	          fontSize: 36,
	          fontWeight: '400',
	          lineHeight: '36px',
	          height: isLandscape ? 76 : 38,
	          opacity: this.state.selectedYear ? 0.7 : 1.0,
	          transition: Transitions.easeOut(),
	          width: '100%'
	        },
	
	        title: {
	          cursor: !this.state.selectedYear ? 'default' : 'pointer'
	        }
	      },
	
	      year: {
	        root: {
	          margin: 0,
	          fontSize: 16,
	          fontWeight: '400',
	          lineHeight: '16px',
	          height: 16,
	          opacity: this.state.selectedYear ? 1.0 : 0.7,
	          transition: Transitions.easeOut(),
	          marginBottom: 10
	        },
	
	        title: {
	          cursor: this.state.selectedYear && !this.props.disableYearSelection ? 'pointer' : 'default'
	        }
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var selectedDate = _props.selectedDate;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['selectedDate', 'style']);
	
	    var dayOfWeek = DateTime.getDayOfWeek(this.props.selectedDate);
	    var month = DateTime.getShortMonth(this.props.selectedDate);
	    var day = this.props.selectedDate.getDate();
	    var year = this.props.selectedDate.getFullYear();
	    var styles = this.getStyles();
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles.root, this.props.style) }),
	      React.createElement(
	        SlideInTransitionGroup,
	        {
	          style: styles.year.root,
	          direction: this.state.transitionDirection },
	        React.createElement(
	          'div',
	          { key: year, style: styles.year.title, onTouchTap: this._handleYearClick },
	          year
	        )
	      ),
	      React.createElement(
	        SlideInTransitionGroup,
	        {
	          style: styles.monthDay.root,
	          direction: this.state.transitionDirection },
	        React.createElement(
	          'div',
	          {
	            key: dayOfWeek + month + day,
	            style: styles.monthDay.title,
	            onTouchTap: this._handleMonthDayClick },
	          React.createElement(
	            'span',
	            null,
	            dayOfWeek,
	            ','
	          ),
	          React.createElement(
	            'span',
	            { style: styles.month },
	            month,
	            ' ',
	            day
	          )
	        )
	      )
	    );
	  },
	
	  _handleMonthDayClick: function _handleMonthDayClick() {
	    if (this.props.handleMonthDayClick && this.state.selectedYear) {
	      this.props.handleMonthDayClick();
	    }
	
	    this.setState({ selectedYear: false });
	  },
	
	  _handleYearClick: function _handleYearClick() {
	    if (this.props.handleYearClick && !this.props.disableYearSelection && !this.state.selectedYear) {
	      this.props.handleYearClick();
	    }
	
	    if (!this.props.disableYearSelection) {
	      this.setState({ selectedYear: true });
	    }
	  }
	
	});
	
	module.exports = DateDisplay;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var WindowListenable = __webpack_require__(89);
	var DateTime = __webpack_require__(120);
	var DatePickerDialog = __webpack_require__(516);
	var TextField = __webpack_require__(212);
	
	var DatePicker = React.createClass({
	  displayName: 'DatePicker',
	
	  mixins: [StylePropable, WindowListenable],
	
	  propTypes: {
	    autoOk: React.PropTypes.bool,
	    defaultDate: React.PropTypes.object,
	    formatDate: React.PropTypes.func,
	    hideToolbarYearChange: React.PropTypes.bool,
	    maxDate: React.PropTypes.object,
	    minDate: React.PropTypes.object,
	    mode: React.PropTypes.oneOf(['portrait', 'landscape', 'inline']),
	    onDismiss: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    onTouchTap: React.PropTypes.func,
	    shouldDisableDate: React.PropTypes.func,
	    showYearSelector: React.PropTypes.bool,
	    style: React.PropTypes.object,
	    textFieldStyle: React.PropTypes.object
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      formatDate: DateTime.format,
	      autoOk: false,
	      showYearSelector: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      date: this._isControlled() ? this._getControlledDate() : this.props.defaultDate,
	      dialogDate: new Date()
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this._isControlled()) {
	      var newDate = this._getControlledDate(nextProps);
	      if (!DateTime.isEqualDate(this.state.date, newDate)) {
	        this.setState({
	          date: newDate
	        });
	      }
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var autoOk = _props.autoOk;
	    var defaultDate = _props.defaultDate;
	    var formatDate = _props.formatDate;
	    var maxDate = _props.maxDate;
	    var minDate = _props.minDate;
	    var mode = _props.mode;
	    var onDismiss = _props.onDismiss;
	    var onFocus = _props.onFocus;
	    var onShow = _props.onShow;
	    var onTouchTap = _props.onTouchTap;
	    var showYearSelector = _props.showYearSelector;
	    var style = _props.style;
	    var textFieldStyle = _props.textFieldStyle;
	    var valueLink = _props.valueLink;
	
	    var other = _objectWithoutProperties(_props, ['autoOk', 'defaultDate', 'formatDate', 'maxDate', 'minDate', 'mode', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'showYearSelector', 'style', 'textFieldStyle', 'valueLink']);
	
	    return React.createElement(
	      'div',
	      { style: style },
	      React.createElement(TextField, _extends({}, other, {
	        style: textFieldStyle,
	        ref: 'input',
	        value: this.state.date ? formatDate(this.state.date) : undefined,
	        onFocus: this._handleInputFocus,
	        onTouchTap: this._handleInputTouchTap })),
	      React.createElement(DatePickerDialog, {
	        ref: 'dialogWindow',
	        mode: mode,
	        initialDate: this.state.dialogDate,
	        onAccept: this._handleDialogAccept,
	        onShow: onShow,
	        onDismiss: this._handleDialogDismiss,
	        minDate: minDate,
	        maxDate: maxDate,
	        autoOk: autoOk,
	        showYearSelector: showYearSelector,
	        shouldDisableDate: this.props.shouldDisableDate,
	        hideToolbarYearChange: this.props.hideToolbarYearChange })
	    );
	  },
	
	  getDate: function getDate() {
	    return this.state.date;
	  },
	
	  setDate: function setDate(d) {
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production' && this._isControlled()) {
	      console.error('Cannot call DatePicker.setDate when value or valueLink is defined as a property.');
	    }
	    this.setState({
	      date: d
	    });
	  },
	
	  /**
	   * Open the date-picker dialog programmatically from a parent.
	   */
	  openDialog: function openDialog() {
	    this.setState({
	      dialogDate: this.getDate()
	    }, this.refs.dialogWindow.show);
	  },
	
	  /**
	   * Alias for `openDialog()` for an api consistent with TextField.
	   */
	  focus: function focus() {
	    this.openDialog();
	  },
	
	  _handleDialogAccept: function _handleDialogAccept(d) {
	    if (!this._isControlled()) {
	      this.setDate(d);
	    }
	    if (this.props.onChange) this.props.onChange(null, d);
	    if (this.props.valueLink) this.props.valueLink.requestChange(d);
	  },
	
	  _handleDialogDismiss: function _handleDialogDismiss() {
	    if (this.props.onDismiss) this.props.onDismiss();
	  },
	
	  _handleInputFocus: function _handleInputFocus(e) {
	    e.target.blur();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _handleInputTouchTap: function _handleInputTouchTap(e) {
	    this.openDialog();
	    if (this.props.onTouchTap) this.props.onTouchTap(e);
	  },
	
	  _handleWindowKeyUp: function _handleWindowKeyUp() {
	    //TO DO: open the dialog if input has focus
	  },
	
	  _isControlled: function _isControlled() {
	    return this.props.hasOwnProperty('value') || this.props.hasOwnProperty('valueLink');
	  },
	
	  _getControlledDate: function _getControlledDate() {
	    var props = arguments.length <= 0 || arguments[0] === undefined ? this.props : arguments[0];
	
	    if (DateTime.isDateObject(props.value)) {
	      return props.value;
	    } else if (props.valueLink && DateTime.isDateObject(props.valueLink.value)) {
	      return props.valueLink.value;
	    }
	  }
	
	});
	
	module.exports = DatePicker;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transition = __webpack_require__(24);
	var DateTime = __webpack_require__(120);
	var EnhancedButton = __webpack_require__(88);
	
	var DayButton = React.createClass({
	  displayName: 'DayButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    date: React.PropTypes.object,
	    onTouchTap: React.PropTypes.func,
	    selected: React.PropTypes.bool,
	    disabled: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false,
	      disabled: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hover: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.datePicker;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var date = _props.date;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	
	    var other = _objectWithoutProperties(_props, ['date', 'onTouchTap', 'selected']);
	
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        position: 'relative',
	        float: 'left',
	        width: 41,
	        padding: '4px 2px'
	      },
	
	      label: {
	        position: 'relative',
	        color: this.context.muiTheme.palette.textColor
	      },
	
	      buttonState: {
	        position: 'absolute',
	        height: 36,
	        width: 36,
	        top: 2,
	        opacity: 0,
	        borderRadius: '50%',
	        transform: 'scale(0)',
	        transition: Transition.easeOut(),
	        backgroundColor: this.getTheme().selectColor
	      }
	    };
	
	    if (this.state.hover) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = '0.6';
	      styles.buttonState.transform = 'scale(1)';
	    }
	
	    if (this.props.selected) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 1;
	      styles.buttonState.transform = 'scale(1)';
	    } else if (this.props.disabled) {
	      styles.root.opacity = '0.6';
	    }
	
	    if (DateTime.isEqualDate(this.props.date, new Date()) && !this.props.selected) {
	      styles.label.color = this.getTheme().color;
	    }
	
	    return this.props.date ? React.createElement(
	      EnhancedButton,
	      _extends({}, other, {
	        style: styles.root,
	        hoverStyle: styles.hover,
	        disabled: this.props.disabled,
	        disableFocusRipple: true,
	        disableTouchRipple: true,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchTap: this._handleTouchTap,
	        onKeyboardFocus: this._handleKeyboardFocus }),
	      React.createElement('div', { style: styles.buttonState }),
	      React.createElement(
	        'span',
	        { style: styles.label },
	        this.props.date.getDate()
	      )
	    ) : React.createElement('span', { style: styles.root });
	  },
	
	  _handleMouseEnter: function _handleMouseEnter() {
	    if (!this.props.disabled) this.setState({ hover: true });
	  },
	
	  _handleMouseLeave: function _handleMouseLeave() {
	    if (!this.props.disabled) this.setState({ hover: false });
	  },
	
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (!this.props.disabled && this.props.onTouchTap) this.props.onTouchTap(e, this.props.date);
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (!this.props.disabled && this.props.onKeyboardFocus) this.props.onKeyboardFocus(e, keyboardFocused, this.props.date);
	  }
	
	});
	
	module.exports = DayButton;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var EnhancedButton = __webpack_require__(88);
	
	var YearButton = React.createClass({
	  displayName: 'YearButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    year: React.PropTypes.number,
	    onTouchTap: React.PropTypes.func,
	    selected: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selected: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hover: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.datePicker;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var year = _props.year;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	
	    var other = _objectWithoutProperties(_props, ['className', 'year', 'onTouchTap', 'selected']);
	
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        WebkitTapHighlightColor: 'rgba(0,0,0,0)',
	        position: 'relative',
	        display: 'block',
	        margin: '0 auto',
	        width: 36,
	        fontSize: 14,
	        padding: '8px 2px'
	      },
	
	      label: {
	        position: 'relative',
	        top: -1,
	        color: this.context.muiTheme.palette.textColor
	      },
	
	      buttonState: {
	        position: 'absolute',
	        height: 32,
	        width: 32,
	        opacity: 0,
	        borderRadius: '50%',
	        transform: 'scale(0)',
	        backgroundColor: this.getTheme().selectColor
	      }
	    };
	
	    if (this.state.hover) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 0.6;
	      styles.buttonState.transform = 'scale(1.5)';
	    }
	
	    if (selected) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.buttonState.opacity = 1;
	      styles.buttonState.transform = 'scale(1.5)';
	    }
	
	    if (year === new Date().getFullYear()) {
	      styles.root.color = this.getTheme().color;
	    }
	
	    return React.createElement(
	      EnhancedButton,
	      _extends({}, other, {
	        style: styles.root,
	        disableFocusRipple: true,
	        disableTouchRipple: true,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave,
	        onTouchTap: this._handleTouchTap }),
	      React.createElement('div', { style: styles.buttonState }),
	      React.createElement(
	        'span',
	        { style: styles.label },
	        year
	      )
	    );
	  },
	
	  _handleMouseEnter: function _handleMouseEnter() {
	    this.setState({ hover: true });
	  },
	
	  _handleMouseLeave: function _handleMouseLeave() {
	    this.setState({ hover: false });
	  },
	
	  _handleTouchTap: function _handleTouchTap(e) {
	    if (this.props.onTouchTap) this.props.onTouchTap(e, this.props.year);
	  }
	
	});
	
	module.exports = YearButton;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var ClickAwayable = __webpack_require__(146);
	var FontIcon = __webpack_require__(118);
	var Menu = __webpack_require__(210);
	
	var DropDownIcon = React.createClass({
	  displayName: 'DropDownIcon',
	
	  mixins: [StylePropable, ClickAwayable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    onChange: React.PropTypes.func,
	    menuItems: React.PropTypes.array.isRequired,
	    closeOnMenuItemTouchTap: React.PropTypes.bool,
	    iconStyle: React.PropTypes.object,
	    iconClassName: React.PropTypes.string,
	    iconLigature: React.PropTypes.string
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: false
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeOnMenuItemTouchTap: true
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    // This component can be deprecated once ./menu/menu has been deprecated.
	    // if (process.env.NODE_ENV !== 'production') {
	    //   console.warn('DropDownIcon has been deprecated. Use IconMenu instead.');
	    // }
	  },
	
	  componentClickAway: function componentClickAway() {
	    this.setState({ open: false });
	  },
	
	  getStyles: function getStyles() {
	    var spacing = this.context.muiTheme.spacing;
	    var iconWidth = 48;
	    var styles = {
	      root: {
	        display: 'inline-block',
	        width: iconWidth + 'px !important',
	        position: 'relative',
	        height: spacing.desktopToolbarHeight,
	        fontSize: spacing.desktopDropDownMenuFontSize,
	        cursor: 'pointer'
	      },
	      menu: {
	        transition: Transitions.easeOut(),
	        right: '-14px !important',
	        top: '9px !important',
	        opacity: this.state.open ? 1 : 0
	      },
	      menuItem: { // similair to drop down menu's menu item styles
	        paddingRight: spacing.iconSize + spacing.desktopGutterLess * 2,
	        height: spacing.desktopDropDownMenuItemHeight,
	        lineHeight: spacing.desktopDropDownMenuItemHeight + 'px'
	      }
	    };
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var children = _props.children;
	    var menuItems = _props.menuItems;
	    var closeOnMenuItemTouchTap = _props.closeOnMenuItemTouchTap;
	    var iconStyle = _props.iconStyle;
	    var iconClassName = _props.iconClassName;
	
	    var other = _objectWithoutProperties(_props, ['style', 'children', 'menuItems', 'closeOnMenuItemTouchTap', 'iconStyle', 'iconClassName']);
	
	    var styles = this.getStyles();
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles.root, this.props.style) }),
	      React.createElement(
	        'div',
	        { onTouchTap: this._onControlClick },
	        React.createElement(
	          FontIcon,
	          {
	            className: iconClassName,
	            style: iconStyle },
	          this.props.iconLigature
	        ),
	        this.props.children
	      ),
	      React.createElement(Menu, {
	        ref: 'menuItems',
	        style: this.mergeAndPrefix(styles.menu),
	        menuItems: menuItems,
	        menuItemStyle: styles.menuItem,
	        hideable: true,
	        visible: this.state.open,
	        onItemTap: this._onMenuItemClick })
	    );
	  },
	
	  _onControlClick: function _onControlClick() {
	    this.setState({ open: !this.state.open });
	  },
	
	  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
	    if (this.props.onChange) this.props.onChange(e, key, payload);
	
	    if (this.props.closeOnMenuItemTouchTap) {
	      this.setState({ open: false });
	    }
	  }
	});
	
	module.exports = DropDownIcon;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	
	var EnhancedTextarea = React.createClass({
	  displayName: 'EnhancedTextarea',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    onChange: React.PropTypes.func,
	    onHeightChange: React.PropTypes.func,
	    textareaStyle: React.PropTypes.object,
	    rows: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      rows: 1
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      height: this.props.rows * 24
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._syncHeightWithShadow();
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        width: '100%',
	        resize: 'none',
	        overflow: 'hidden',
	        font: 'inherit',
	        padding: 0
	      }
	    };
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var onChange = _props.onChange;
	    var onHeightChange = _props.onHeightChange;
	    var rows = _props.rows;
	    var style = _props.style;
	    var textareaStyle = _props.textareaStyle;
	    var valueLink = _props.valueLink;
	
	    var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'style', 'textareaStyle', 'valueLink']);
	
	    var styles = this.getStyles().root;
	
	    var textAreaStyles = {
	      width: '100%',
	      resize: 'none',
	      overflow: 'hidden',
	      font: 'inherit',
	      padding: 0
	    };
	
	    var inputStyles = this.mergeAndPrefix(styles, {
	      height: this.state.height + 'px'
	    });
	
	    inputStyles = this.mergeAndPrefix(inputStyles, textareaStyle);
	
	    // Overflow also needed to here to remove the extra row
	    // added to textareas in Firefox.
	    var shadowStyles = this.mergeAndPrefix(textAreaStyles, {
	      position: 'absolute',
	      opacity: 0
	    });
	
	    if (this.props.hasOwnProperty('valueLink')) {
	      other.value = this.props.valueLink.value;
	    }
	    if (this.props.disabled) {
	      style.cursor = 'default';
	    }
	
	    return React.createElement(
	      'div',
	      { style: this.props.style },
	      React.createElement('textarea', {
	        ref: 'shadow',
	        style: AutoPrefix.all(shadowStyles),
	        tabIndex: '-1',
	        rows: this.props.rows,
	        defaultValue: this.props.defaultValue,
	        readOnly: true,
	        value: this.props.value,
	        valueLink: this.props.valueLink }),
	      React.createElement('textarea', _extends({}, other, {
	        ref: 'input',
	        rows: this.props.rows,
	        style: AutoPrefix.all(inputStyles),
	        onChange: this._handleChange }))
	    );
	  },
	
	  getInputNode: function getInputNode() {
	    return React.findDOMNode(this.refs.input);
	  },
	
	  setValue: function setValue(value) {
	    this.getInputNode().value = value;
	    this._syncHeightWithShadow(value);
	  },
	
	  _syncHeightWithShadow: function _syncHeightWithShadow(newValue, e) {
	    var shadow = React.findDOMNode(this.refs.shadow);
	    var currentHeight = this.state.height;
	    var newHeight = undefined;
	
	    if (newValue !== undefined) {
	      shadow.value = newValue;
	    }
	    newHeight = shadow.scrollHeight;
	
	    if (currentHeight !== newHeight) {
	      this.setState({ height: newHeight });
	      if (this.props.onHeightChange) {
	        this.props.onHeightChange(e, newHeight);
	      }
	    }
	  },
	
	  _handleChange: function _handleChange(e) {
	    this._syncHeightWithShadow(e.target.value);
	
	    if (this.props.hasOwnProperty('valueLink')) {
	      this.props.valueLink.requestChange(e.target.value);
	    }
	
	    if (this.props.onChange) {
	      this.props.onChange(e);
	    }
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.value !== this.props.value) {
	      this._syncHeightWithShadow(nextProps.value);
	    }
	  }
	});
	
	module.exports = EnhancedTextarea;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var ColorManipulator = __webpack_require__(102);
	var EnhancedButton = __webpack_require__(88);
	var FontIcon = __webpack_require__(118);
	var Paper = __webpack_require__(55);
	var Children = __webpack_require__(213);
	
	var getZDepth = function getZDepth(disabled) {
	  var zDepth = disabled ? 0 : 2;
	  return {
	    zDepth: zDepth,
	    initialZDepth: zDepth
	  };
	};
	
	var FloatingActionButton = React.createClass({
	  displayName: 'FloatingActionButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    backgroundColor: React.PropTypes.string,
	    disabled: React.PropTypes.bool,
	    disabledColor: React.PropTypes.string,
	    iconClassName: React.PropTypes.string,
	    iconStyle: React.PropTypes.object,
	    mini: React.PropTypes.bool,
	    onMouseDown: React.PropTypes.func,
	    onMouseUp: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    onTouchEnd: React.PropTypes.func,
	    onTouchStart: React.PropTypes.func,
	    secondary: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    var zDepth = this.props.disabled ? 0 : 2;
	    return {
	      hovered: false,
	      initialZDepth: zDepth,
	      touch: false,
	      zDepth: zDepth
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.setState(getZDepth(this.props.disabled));
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    if (newProps.disabled !== this.props.disabled) {
	      this.setState(getZDepth(newProps.disabled));
	    }
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	      if (this.props.iconClassName && this.props.children) {
	        var warning = 'You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.';
	        console.warn(warning);
	      }
	    }
	  },
	
	  _getBackgroundColor: function _getBackgroundColor() {
	    return this.props.disabled ? this.props.disabledColor || this.getTheme().disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.floatingActionButton;
	  },
	
	  _getIconColor: function _getIconColor() {
	    return this.props.disabled ? this.getTheme().disabledTextColor : this.props.secondary ? this.getTheme().secondaryIconColor : this.getTheme().iconColor;
	  },
	
	  getStyles: function getStyles() {
	    var themeVariables = this.context.muiTheme.component.floatingActionButton;
	
	    var styles = {
	      root: {
	        transition: Transitions.easeOut(),
	        display: 'inline-block'
	      },
	      container: {
	        transition: Transitions.easeOut(),
	        position: 'relative',
	        height: themeVariables.buttonSize,
	        width: themeVariables.buttonSize,
	        padding: 0,
	        overflow: 'hidden',
	        backgroundColor: this._getBackgroundColor(),
	        borderRadius: '50%',
	        textAlign: 'center',
	        verticalAlign: 'bottom',
	        //This is need so that ripples do not bleed
	        //past border radius.
	        //See: http://stackoverflow.com/questions/17298739/css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
	        transform: 'translate3d(0, 0, 0)'
	      },
	      containerWhenMini: {
	        height: themeVariables.miniSize,
	        width: themeVariables.miniSize
	      },
	      overlay: {
	        transition: Transitions.easeOut(),
	        top: 0
	      },
	      overlayWhenHovered: {
	        backgroundColor: ColorManipulator.fade(this._getIconColor(), 0.4)
	      },
	      icon: {
	        height: themeVariables.buttonSize,
	        lineHeight: themeVariables.buttonSize + 'px',
	        fill: themeVariables.iconColor,
	        color: this._getIconColor()
	      },
	      iconWhenMini: {
	        height: themeVariables.miniSize,
	        lineHeight: themeVariables.miniSize + 'px'
	      }
	    };
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var mini = _props.mini;
	    var secondary = _props.secondary;
	    var iconStyle = _props.iconStyle;
	    var iconClassName = _props.iconClassName;
	
	    var other = _objectWithoutProperties(_props, ['disabled', 'mini', 'secondary', 'iconStyle', 'iconClassName']);
	
	    var styles = this.getStyles();
	
	    var iconElement = undefined;
	    if (iconClassName) {
	      iconElement = React.createElement(FontIcon, {
	        className: iconClassName,
	        style: this.mergeAndPrefix(styles.icon, mini && styles.iconWhenMini, iconStyle) });
	    }
	
	    var children = Children.extend(this.props.children, {
	      style: this.mergeAndPrefix(styles.icon, mini && styles.iconWhenMini, iconStyle)
	    });
	
	    var buttonEventHandlers = disabled ? null : {
	      onMouseDown: this._handleMouseDown,
	      onMouseUp: this._handleMouseUp,
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      onTouchStart: this._handleTouchStart,
	      onTouchEnd: this._handleTouchEnd,
	      onKeyboardFocus: this._handleKeyboardFocus
	    };
	
	    return React.createElement(
	      Paper,
	      {
	        style: this.mergeAndPrefix(styles.root, this.props.style),
	        zDepth: this.state.zDepth,
	        circle: true },
	      React.createElement(
	        EnhancedButton,
	        _extends({}, other, buttonEventHandlers, {
	          ref: 'container',
	          disabled: disabled,
	          style: this.mergeAndPrefix(styles.container, this.props.mini && styles.containerWhenMini),
	          focusRippleColor: styles.icon.color,
	          touchRippleColor: styles.icon.color }),
	        React.createElement(
	          'div',
	          {
	            ref: 'overlay',
	            style: this.mergeAndPrefix(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered) },
	          iconElement,
	          children
	        )
	      )
	    );
	  },
	
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	    }
	    if (this.props.onMouseDown) this.props.onMouseDown(e);
	  },
	
	  _handleMouseUp: function _handleMouseUp(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onMouseUp) this.props.onMouseUp(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
	      this.setState({ hovered: true });
	    }
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({
	      touch: true,
	      zDepth: this.state.initialZDepth + 1
	    });
	    if (this.props.onTouchStart) this.props.onTouchStart(e);
	  },
	
	  _handleTouchEnd: function _handleTouchEnd(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	      React.findDOMNode(this.refs.overlay).style.backgroundColor = ColorManipulator.fade(this.getStyles().icon.color, 0.4);
	    } else if (!this.state.hovered) {
	      this.setState({ zDepth: this.state.initialZDepth });
	      React.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
	    }
	  }
	
	});
	
	module.exports = FloatingActionButton;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var Transitions = __webpack_require__(24);
	var StylePropable = __webpack_require__(6);
	
	var InkBar = React.createClass({
	  displayName: 'InkBar',
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    color: React.PropTypes.string,
	    left: React.PropTypes.string.isRequired,
	    width: React.PropTypes.string.isRequired
	  },
	
	  mixins: [StylePropable],
	
	  render: function render() {
	    var _props = this.props;
	    var color = _props.color;
	    var left = _props.left;
	    var width = _props.width;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['color', 'left', 'width', 'style']);
	
	    var colorStyle = color ? { backgroundColor: color } : undefined;
	    var styles = this.mergeAndPrefix({
	      left: left,
	      width: width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: this.context.muiTheme.component.inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: Transitions.easeOut('1s', 'left')
	    }, this.props.style, colorStyle);
	
	    return React.createElement(
	      'div',
	      { style: styles },
	      ' '
	    );
	  }
	
	});
	
	module.exports = InkBar;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isBrowser = typeof window !== 'undefined';
	var Modernizr = isBrowser ? __webpack_require__(540) : undefined;
	
	var React = __webpack_require__(1);
	var KeyCode = __webpack_require__(73);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	var WindowListenable = __webpack_require__(89);
	var Overlay = __webpack_require__(362);
	var Paper = __webpack_require__(55);
	var Menu = __webpack_require__(210);
	
	var openNavEventHandler = null;
	
	var LeftNav = React.createClass({
	  displayName: 'LeftNav',
	
	  mixins: [StylePropable, WindowListenable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    disableSwipeToOpen: React.PropTypes.bool,
	    docked: React.PropTypes.bool,
	    header: React.PropTypes.element,
	    menuItems: React.PropTypes.array.isRequired,
	    onChange: React.PropTypes.func,
	    onNavOpen: React.PropTypes.func,
	    onNavClose: React.PropTypes.func,
	    openRight: React.PropTypes.bool,
	    selectedIndex: React.PropTypes.number,
	    menuItemClassName: React.PropTypes.string,
	    menuItemClassNameSubheader: React.PropTypes.string,
	    menuItemClassNameLink: React.PropTypes.string
	  },
	
	  windowListeners: {
	    'keyup': '_onWindowKeyUp',
	    'resize': '_onWindowResize'
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      disableSwipeToOpen: false,
	      docked: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    this._maybeSwiping = false;
	    this._touchStartX = null;
	    this._touchStartY = null;
	    this._swipeStartX = null;
	
	    return {
	      open: this.props.docked,
	      swiping: null
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateMenuHeight();
	    this._enableSwipeHandling();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._updateMenuHeight();
	    this._enableSwipeHandling();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._disableSwipeHandling();
	  },
	
	  toggle: function toggle() {
	    this.setState({ open: !this.state.open });
	    return this;
	  },
	
	  close: function close() {
	    this.setState({ open: false });
	    if (this.props.onNavClose) this.props.onNavClose();
	    return this;
	  },
	
	  open: function open() {
	    this.setState({ open: true });
	    if (this.props.onNavOpen) this.props.onNavOpen();
	    return this;
	  },
	
	  getThemePalette: function getThemePalette() {
	    return this.context.muiTheme.palette;
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.leftNav;
	  },
	
	  getStyles: function getStyles() {
	    var x = this._getTranslateMultiplier() * (this.state.open ? 0 : this._getMaxTranslateX());
	    var styles = {
	      root: {
	        height: '100%',
	        width: this.getTheme().width,
	        position: 'fixed',
	        zIndex: 10,
	        left: isBrowser && Modernizr.csstransforms3d ? 0 : x,
	        top: 0,
	        transform: 'translate3d(' + x + 'px, 0, 0)',
	        transition: !this.state.swiping && Transitions.easeOut(),
	        backgroundColor: this.getTheme().color,
	        overflow: 'hidden'
	      },
	      menu: {
	        overflowY: 'auto',
	        overflowX: 'hidden',
	        height: '100%',
	        borderRadius: '0'
	      },
	      menuItem: {
	        height: this.context.muiTheme.spacing.desktopLeftNavMenuItemHeight,
	        lineHeight: this.context.muiTheme.spacing.desktopLeftNavMenuItemHeight + 'px'
	      },
	      rootWhenOpenRight: {
	        left: 'auto',
	        right: 0
	      }
	    };
	
	    styles.menuItemLink = this.mergeAndPrefix(styles.menuItem, {
	      display: 'block',
	      textDecoration: 'none',
	      color: this.getThemePalette().textColor
	    });
	    styles.menuItemSubheader = this.mergeAndPrefix(styles.menuItem, {
	      overflow: 'hidden'
	    });
	
	    return styles;
	  },
	
	  render: function render() {
	    var selectedIndex = this.props.selectedIndex;
	    var overlay = undefined;
	
	    var styles = this.getStyles();
	    if (!this.props.docked) {
	      overlay = React.createElement(Overlay, {
	        ref: 'overlay',
	        show: this.state.open || !!this.state.swiping,
	        transitionEnabled: !this.state.swiping,
	        onTouchTap: this._onOverlayTouchTap
	      });
	    }
	
	    return React.createElement(
	      'div',
	      { className: this.props.className },
	      overlay,
	      React.createElement(
	        Paper,
	        {
	          ref: 'clickAwayableElement',
	          zDepth: 2,
	          rounded: false,
	          transitionEnabled: !this.state.swiping,
	          style: this.mergeAndPrefix(styles.root, this.props.openRight && styles.rootWhenOpenRight, this.props.style) },
	        this.props.header,
	        React.createElement(Menu, {
	          ref: 'menuItems',
	          style: this.mergeAndPrefix(styles.menu),
	          zDepth: 0,
	          menuItems: this.props.menuItems,
	          menuItemStyle: this.mergeAndPrefix(styles.menuItem),
	          menuItemStyleLink: this.mergeAndPrefix(styles.menuItemLink),
	          menuItemStyleSubheader: this.mergeAndPrefix(styles.menuItemSubheader),
	          menuItemClassName: this.props.menuItemClassName,
	          menuItemClassNameSubheader: this.props.menuItemClassNameSubheader,
	          menuItemClassNameLink: this.props.menuItemClassNameLink,
	          selectedIndex: selectedIndex,
	          onItemTap: this._onMenuItemClick })
	      )
	    );
	  },
	
	  _updateMenuHeight: function _updateMenuHeight() {
	    if (this.props.header) {
	      var container = React.findDOMNode(this.refs.clickAwayableElement);
	      var menu = React.findDOMNode(this.refs.menuItems);
	      var menuHeight = container.clientHeight - menu.offsetTop;
	      menu.style.height = menuHeight + 'px';
	    }
	  },
	
	  _onMenuItemClick: function _onMenuItemClick(e, key, payload) {
	    if (this.props.onChange && this.props.selectedIndex !== key) {
	      this.props.onChange(e, key, payload);
	    }
	    if (!this.props.docked) this.close();
	  },
	
	  _onOverlayTouchTap: function _onOverlayTouchTap() {
	    this.close();
	  },
	
	  _onWindowKeyUp: function _onWindowKeyUp(e) {
	    if (e.keyCode === KeyCode.ESC && !this.props.docked && this.state.open) {
	      this.close();
	    }
	  },
	
	  _onWindowResize: function _onWindowResize() {
	    this._updateMenuHeight();
	  },
	
	  _getMaxTranslateX: function _getMaxTranslateX() {
	    return this.getTheme().width + 10;
	  },
	
	  _getTranslateMultiplier: function _getTranslateMultiplier() {
	    return this.props.openRight ? 1 : -1;
	  },
	
	  _enableSwipeHandling: function _enableSwipeHandling() {
	    if (!this.props.docked) {
	      document.body.addEventListener('touchstart', this._onBodyTouchStart);
	      if (!openNavEventHandler) {
	        openNavEventHandler = this._onBodyTouchStart;
	      }
	    } else {
	      this._disableSwipeHandling();
	    }
	  },
	
	  _disableSwipeHandling: function _disableSwipeHandling() {
	    document.body.removeEventListener('touchstart', this._onBodyTouchStart);
	    if (openNavEventHandler === this._onBodyTouchStart) {
	      openNavEventHandler = null;
	    }
	  },
	
	  _onBodyTouchStart: function _onBodyTouchStart(e) {
	    if (!this.state.open && (openNavEventHandler !== this._onBodyTouchStart || this.props.disableSwipeToOpen)) {
	      return;
	    }
	
	    var touchStartX = e.touches[0].pageX;
	    var touchStartY = e.touches[0].pageY;
	
	    this._maybeSwiping = true;
	    this._touchStartX = touchStartX;
	    this._touchStartY = touchStartY;
	
	    document.body.addEventListener('touchmove', this._onBodyTouchMove);
	    document.body.addEventListener('touchend', this._onBodyTouchEnd);
	    document.body.addEventListener('touchcancel', this._onBodyTouchEnd);
	  },
	
	  _setPosition: function _setPosition(translateX) {
	    var leftNav = React.findDOMNode(this.refs.clickAwayableElement);
	    leftNav.style[AutoPrefix.single('transform')] = 'translate3d(' + this._getTranslateMultiplier() * translateX + 'px, 0, 0)';
	    this.refs.overlay.setOpacity(1 - translateX / this._getMaxTranslateX());
	  },
	
	  _getTranslateX: function _getTranslateX(currentX) {
	    return Math.min(Math.max(this.state.swiping === 'closing' ? this._getTranslateMultiplier() * (currentX - this._swipeStartX) : this._getMaxTranslateX() - this._getTranslateMultiplier() * (this._swipeStartX - currentX), 0), this._getMaxTranslateX());
	  },
	
	  _onBodyTouchMove: function _onBodyTouchMove(e) {
	    var currentX = e.touches[0].pageX;
	    var currentY = e.touches[0].pageY;
	
	    if (this.state.swiping) {
	      e.preventDefault();
	      this._setPosition(this._getTranslateX(currentX));
	    } else if (this._maybeSwiping) {
	      var dXAbs = Math.abs(currentX - this._touchStartX);
	      var dYAbs = Math.abs(currentY - this._touchStartY);
	      // If the user has moved his thumb ten pixels in either direction,
	      // we can safely make an assumption about whether he was intending
	      // to swipe or scroll.
	      var threshold = 10;
	
	      if (dXAbs > threshold && dYAbs <= threshold) {
	        this._swipeStartX = currentX;
	        this.setState({
	          swiping: this.state.open ? 'closing' : 'opening'
	        });
	        this._setPosition(this._getTranslateX(currentX));
	      } else if (dXAbs <= threshold && dYAbs > threshold) {
	        this._onBodyTouchEnd();
	      }
	    }
	  },
	
	  _onBodyTouchEnd: function _onBodyTouchEnd(e) {
	    if (this.state.swiping) {
	      var currentX = e.changedTouches[0].pageX;
	      var translateRatio = this._getTranslateX(currentX) / this._getMaxTranslateX();
	
	      this._maybeSwiping = false;
	      var swiping = this.state.swiping;
	      this.setState({
	        swiping: null
	      });
	
	      // We have to open or close after setting swiping to null,
	      // because only then CSS transition is enabled.
	      if (translateRatio > 0.5) {
	        if (swiping === 'opening') {
	          this._setPosition(this._getMaxTranslateX());
	        } else {
	          this.close();
	        }
	      } else {
	        if (swiping === 'opening') {
	          this.open();
	        } else {
	          this._setPosition(0);
	        }
	      }
	    } else {
	      this._maybeSwiping = false;
	    }
	
	    document.body.removeEventListener('touchmove', this._onBodyTouchMove);
	    document.body.removeEventListener('touchend', this._onBodyTouchEnd);
	    document.body.removeEventListener('touchcancel', this._onBodyTouchEnd);
	  }
	
	});
	
	module.exports = LeftNav;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	
	var LinearProgress = React.createClass({
	  displayName: 'LinearProgress',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    mode: React.PropTypes.oneOf(["determinate", "indeterminate"]),
	    value: React.PropTypes.number,
	    min: React.PropTypes.number,
	    max: React.PropTypes.number
	  },
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  _getRelativeValue: function _getRelativeValue() {
	    var value = this.props.value;
	    var min = this.props.min;
	    var max = this.props.max;
	
	    var clampedValue = Math.min(Math.max(min, value), max);
	    var rangeValue = max - min;
	    var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	    return relValue * 100;
	  },
	
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    var bar1 = React.findDOMNode(this.refs.bar1);
	    var bar2 = React.findDOMNode(this.refs.bar2);
	
	    this._barUpdate(0, bar1, [[-35, 100], [100, -90]]);
	
	    setTimeout(function () {
	      _this._barUpdate(0, bar2, [[-200, 100], [107, -8]]);
	    }, 850);
	  },
	
	  _barUpdate: function _barUpdate(step, barElement, stepValues) {
	    step = step || 0;
	    step %= 4;
	    setTimeout(this._barUpdate.bind(this, step + 1, barElement, stepValues), 420);
	    if (!this.isMounted()) return;
	    if (this.props.mode !== "indeterminate") return;
	
	    if (step === 0) {
	      barElement.style.left = stepValues[0][0] + "%";
	      barElement.style.right = stepValues[0][1] + "%";
	    } else if (step === 1) {
	      barElement.style.transitionDuration = "840ms";
	    } else if (step === 2) {
	      barElement.style.left = stepValues[1][0] + "%";
	      barElement.style.right = stepValues[1][1] + "%";
	    } else if (step === 3) {
	      barElement.style.transitionDuration = "0ms";
	    }
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: "indeterminate",
	      value: 0,
	      min: 0,
	      max: 100
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.palette;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        position: "relative",
	        height: 4,
	        display: "block",
	        width: "100%",
	        backgroundColor: this.getTheme().primary3Color,
	        borderRadius: 2,
	        margin: 0,
	        overflow: "hidden"
	      },
	      bar: {
	        height: "100%"
	      },
	      barFragment1: {},
	      barFragment2: {}
	    };
	
	    if (this.props.mode === "indeterminate") {
	      styles.barFragment1 = {
	        position: "absolute",
	        backgroundColor: this.getTheme().primary1Color,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        transition: Transitions.create("all", "840ms", null, "cubic-bezier(0.650, 0.815, 0.735, 0.395)")
	      };
	
	      styles.barFragment2 = {
	        position: "absolute",
	        backgroundColor: this.getTheme().primary1Color,
	        top: 0,
	        left: 0,
	        bottom: 0,
	        transition: Transitions.create("all", "840ms", null, "cubic-bezier(0.165, 0.840, 0.440, 1.000)")
	      };
	    } else {
	      styles.bar.backgroundColor = this.getTheme().primary1Color;
	      styles.bar.transition = Transitions.create("width", ".3s", null, "linear");
	      styles.bar.width = this._getRelativeValue() + "%";
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['style']);
	
	    var styles = this.getStyles();
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles.root, style) }),
	      React.createElement(
	        'div',
	        { style: this.mergeAndPrefix(styles.bar) },
	        React.createElement('div', { ref: 'bar1', style: this.mergeAndPrefix(styles.barFragment1) }),
	        React.createElement('div', { ref: 'bar2', style: this.mergeAndPrefix(styles.barFragment2) })
	      )
	    );
	  }
	});
	
	module.exports = LinearProgress;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var ImmutabilityHelper = __webpack_require__(147);
	var List = __webpack_require__(361);
	
	var NestedList = React.createClass({
	  displayName: 'NestedList',
	
	  propTypes: {
	    nestedLevel: React.PropTypes.number,
	    open: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      nestedLevel: 1,
	      open: false
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var open = _props.open;
	    var nestedLevel = _props.nestedLevel;
	    var style = _props.style;
	
	    var styles = {
	      root: {
	        display: open ? null : 'none'
	      }
	    };
	
	    return React.createElement(
	      List,
	      { style: ImmutabilityHelper.merge(styles.root, style) },
	      React.Children.map(children, function (child) {
	        return React.isValidElement(child) ? React.cloneElement(child, {
	          nestedLevel: nestedLevel + 1
	        }) : child;
	      })
	    );
	  }
	
	});
	
	module.exports = NestedList;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var LinkMenuItem = React.createClass({
	  displayName: 'LinkMenuItem',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    index: React.PropTypes.number.isRequired,
	    payload: React.PropTypes.string.isRequired,
	    text: React.PropTypes.string.isRequired,
	    target: React.PropTypes.string,
	    active: React.PropTypes.bool,
	    disabled: React.PropTypes.bool,
	    className: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      active: false,
	      disabled: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.menuItem;
	  },
	
	  getStyles: function getStyles() {
	    var style = {
	      root: {
	        userSelect: 'none',
	        cursor: 'pointer',
	        display: 'block',
	        lineHeight: this.getTheme().height + 'px',
	        paddingLeft: this.getTheme().padding,
	        paddingRight: this.getTheme().padding
	      },
	      rootWhenHovered: {
	        backgroundColor: this.getTheme().hoverColor
	      },
	      rootWhenSelected: {
	        color: this.getTheme().selectedTextColor
	      },
	      rootWhenDisabled: {
	        cursor: 'default',
	        color: this.context.muiTheme.palette.disabledColor
	      }
	    };
	
	    return style;
	  },
	
	  render: function render() {
	    var onClickHandler = this.props.disabled ? this._stopLink : undefined;
	    // Prevent context menu 'Open In New Tab/Window'
	    var linkAttribute = this.props.disabled ? 'data-href' : 'href';
	    var link = {};
	    link[linkAttribute] = this.props.payload;
	
	    var styles = this.getStyles();
	
	    var linkStyles = this.mergeAndPrefix(styles.root, this.props.selected && styles.rootWhenSelected, this.props.selected && styles.rootWhenSelected, this.props.active && !this.props.disabled && styles.rootWhenHovered, this.props.style, this.props.disabled && styles.rootWhenDisabled);
	
	    return React.createElement(
	      'a',
	      _extends({
	        key: this.props.index,
	        target: this.props.target,
	        style: linkStyles }, link, {
	        className: this.props.className,
	        onClick: onClickHandler,
	        onMouseEnter: this._handleMouseEnter,
	        onMouseLeave: this._handleMouseLeave }),
	      this.props.text
	    );
	  },
	
	  _stopLink: function _stopLink(event) {
	    event.preventDefault();
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    this.setState({ hovered: true });
	    if (!this.props.disabled && this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    this.setState({ hovered: false });
	    if (!this.props.disabled && this.props.onMouseLeave) this.props.onMouseLeave(e);
	  }
	});
	
	module.exports = LinkMenuItem;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Typography = __webpack_require__(119);
	
	var SubheaderMenuItem = React.createClass({
	  displayName: 'SubheaderMenuItem',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    index: React.PropTypes.number.isRequired,
	    text: React.PropTypes.string.isRequired,
	    firstChild: React.PropTypes.bool,
	    className: React.PropTypes.string
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.menuSubheader;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  getStyles: function getStyles() {
	    var gutterMini = this.getSpacing().desktopGutterMini;
	    var subheaderHeight = this.getSpacing().desktopSubheaderHeight;
	    var styles = {
	      root: {
	        boxSizing: 'border-box',
	        fontSize: '13px',
	        letterSpacing: 0,
	        fontWeight: Typography.fontWeightMedium,
	        margin: 0,
	        height: subheaderHeight + gutterMini,
	        lineHeight: subheaderHeight + 'px',
	        color: this.getTheme().textColor,
	        borderTop: 'solid 1px ' + this.getTheme().borderColor,
	        paddingTop: gutterMini,
	        marginTop: gutterMini
	      },
	      rootWhenFirstChild: {
	        height: subheaderHeight,
	        borderTop: 'none',
	        paddingTop: 0,
	        marginTop: 0
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    return React.createElement(
	      'div',
	      {
	        key: this.props.index,
	        className: this.props.className,
	        style: this.mergeAndPrefix(this.getStyles().root, this.props.firstChild && this.getStyles().rootWhenFirstChild, this.props.style) },
	      this.props.text
	    );
	  }
	
	});
	
	module.exports = SubheaderMenuItem;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var ReactTransitionGroup = React.addons.TransitionGroup;
	var ClickAwayable = __webpack_require__(146);
	var StylePropable = __webpack_require__(6);
	var Events = __webpack_require__(121);
	var PropTypes = __webpack_require__(171);
	var Menu = __webpack_require__(523);
	
	var IconMenu = React.createClass({
	  displayName: 'IconMenu',
	
	  mixins: [StylePropable, ClickAwayable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    closeOnItemTouchTap: React.PropTypes.bool,
	    iconButtonElement: React.PropTypes.element.isRequired,
	    openDirection: PropTypes.corners,
	    onItemTouchTap: React.PropTypes.func,
	    onKeyboardFocus: React.PropTypes.func,
	    onMouseDown: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    onMouseEnter: React.PropTypes.func,
	    onMouseUp: React.PropTypes.func,
	    onTouchTap: React.PropTypes.func,
	    menuStyle: React.PropTypes.object,
	    touchTapCloseDelay: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      closeOnItemTouchTap: true,
	      openDirection: 'bottom-left',
	      onItemTouchTap: function onItemTouchTap() {},
	      onKeyboardFocus: function onKeyboardFocus() {},
	      onMouseDown: function onMouseDown() {},
	      onMouseLeave: function onMouseLeave() {},
	      onMouseEnter: function onMouseEnter() {},
	      onMouseUp: function onMouseUp() {},
	      onTouchTap: function onTouchTap() {},
	      touchTapCloseDelay: 200
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      iconButtonRef: this.props.iconButtonElement.props.ref || 'iconButton',
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    };
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._timeout) clearTimeout(this._timeout);
	  },
	
	  componentClickAway: function componentClickAway() {
	    this.close();
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var closeOnItemTouchTap = _props.closeOnItemTouchTap;
	    var iconButtonElement = _props.iconButtonElement;
	    var openDirection = _props.openDirection;
	    var onItemTouchTap = _props.onItemTouchTap;
	    var onKeyboardFocus = _props.onKeyboardFocus;
	    var onMouseDown = _props.onMouseDown;
	    var onMouseLeave = _props.onMouseLeave;
	    var onMouseEnter = _props.onMouseEnter;
	    var onMouseUp = _props.onMouseUp;
	    var onTouchTap = _props.onTouchTap;
	    var menuStyle = _props.menuStyle;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['closeOnItemTouchTap', 'iconButtonElement', 'openDirection', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onTouchTap', 'menuStyle', 'style']);
	
	    var open = this.state.open;
	    var openDown = openDirection.split('-')[0] === 'bottom';
	    var openLeft = openDirection.split('-')[1] === 'left';
	
	    var styles = {
	      root: {
	        display: 'inline-block',
	        position: 'relative'
	      },
	
	      menu: {
	        top: openDown ? 12 : null,
	        bottom: !openDown ? 12 : null,
	        left: !openLeft ? 12 : null,
	        right: openLeft ? 12 : null
	      }
	    };
	
	    var mergedRootStyles = this.mergeAndPrefix(styles.root, style);
	    var mergedMenuStyles = this.mergeStyles(styles.menu, menuStyle);
	
	    var iconButton = React.cloneElement(iconButtonElement, {
	      onKeyboardFocus: this.props.onKeyboardFocus,
	      onTouchTap: (function (e) {
	        _this.open(Events.isKeyboard(e));
	        if (iconButtonElement.props.onTouchTap) iconButtonElement.props.onTouchTap(e);
	      }).bind(this),
	      ref: this.state.iconButtonRef
	    });
	
	    var menu = open ? React.createElement(
	      Menu,
	      _extends({}, other, {
	        animated: true,
	        initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	        onEscKeyDown: this._handleMenuEscKeyDown,
	        onItemTouchTap: this._handleItemTouchTap,
	        openDirection: openDirection,
	        style: mergedMenuStyles }),
	      this.props.children
	    ) : null;
	
	    return React.createElement(
	      'div',
	      {
	        onMouseDown: onMouseDown,
	        onMouseLeave: onMouseLeave,
	        onMouseEnter: onMouseEnter,
	        onMouseUp: onMouseUp,
	        onTouchTap: onTouchTap,
	        style: mergedRootStyles },
	      iconButton,
	      React.createElement(
	        ReactTransitionGroup,
	        null,
	        menu
	      )
	    );
	  },
	
	  isOpen: function isOpen() {
	    return this.state.open;
	  },
	
	  close: function close(isKeyboard) {
	    var _this2 = this;
	
	    if (this.state.open) {
	      this.setState({ open: false }, function () {
	        //Set focus on the icon button when the menu close
	        if (isKeyboard) {
	          var iconButton = _this2.refs[_this2.state.iconButtonRef];
	          React.findDOMNode(iconButton).focus();
	          iconButton.setKeyboardFocus();
	        }
	      });
	    }
	  },
	
	  open: function open(menuInitiallyKeyboardFocused) {
	    if (!this.state.open) {
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: menuInitiallyKeyboardFocused
	      });
	    }
	  },
	
	  _handleItemTouchTap: function _handleItemTouchTap(e, child) {
	    var _this3 = this;
	
	    if (this.props.closeOnItemTouchTap) {
	      (function () {
	        var isKeyboard = Events.isKeyboard(e);
	
	        _this3._timeout = setTimeout(function () {
	          _this3.close(isKeyboard);
	        }, _this3.props.touchTapCloseDelay);
	      })();
	    }
	
	    this.props.onItemTouchTap(e, child);
	  },
	
	  _handleMenuEscKeyDown: function _handleMenuEscKeyDown() {
	    this.close(true);
	  }
	
	});
	
	module.exports = IconMenu;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  ClickAwayable: __webpack_require__(146),
	  WindowListenable: __webpack_require__(89),
	  StylePropable: __webpack_require__(6),
	  StyleResizable: __webpack_require__(1144)
	};

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Events = __webpack_require__(121);
	
	var Sizes = {
	  SMALL: 1,
	  MEDIUM: 2,
	  LARGE: 3
	};
	
	module.exports = {
	
	  statics: {
	    Sizes: Sizes
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      deviceSize: Sizes.SMALL
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateDeviceSize();
	    if (!this.manuallyBindResize) this._bindResize();
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._unbindResize();
	  },
	
	  isDeviceSize: function isDeviceSize(desiredSize) {
	    return this.state.deviceSize >= desiredSize;
	  },
	
	  _updateDeviceSize: function _updateDeviceSize() {
	    var width = window.innerWidth;
	    if (width >= 992) this.setState({ deviceSize: Sizes.LARGE });else if (width >= 768) this.setState({ deviceSize: Sizes.MEDIUM });else this.setState({ deviceSize: Sizes.SMALL }); // width >= 375
	  },
	
	  _bindResize: function _bindResize() {
	    Events.on(window, 'resize', this._updateDeviceSize);
	  },
	
	  _unbindResize: function _unbindResize() {
	    Events.off(window, 'resize', this._updateDeviceSize);
	  }
	};

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var RadioButton = __webpack_require__(525);
	
	var RadioButtonGroup = React.createClass({
	  displayName: 'RadioButtonGroup',
	
	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    valueSelected: React.PropTypes.string,
	    defaultSelected: React.PropTypes.string,
	    labelPosition: React.PropTypes.oneOf(['left', 'right']),
	    onChange: React.PropTypes.func
	  },
	
	  _hasCheckAttribute: function _hasCheckAttribute(radioButton) {
	    return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      numberCheckedRadioButtons: 0,
	      selected: this.props.valueSelected || this.props.defaultSelected || ''
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var cnt = 0;
	
	    React.Children.forEach(this.props.children, function (option) {
	      if (_this._hasCheckAttribute(option)) cnt++;
	    }, this);
	
	    this.setState({ numberCheckedRadioButtons: cnt });
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.hasOwnProperty('valueSelected')) {
	      this.setState({ selected: nextProps.valueSelected });
	    }
	  },
	
	  render: function render() {
	    var _this2 = this;
	
	    var options = React.Children.map(this.props.children, function (option) {
	      var _option$props = option.props;
	      var name = _option$props.name;
	      var value = _option$props.value;
	      var label = _option$props.label;
	      var onCheck = _option$props.onCheck;
	
	      var other = _objectWithoutProperties(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	      return React.createElement(RadioButton, _extends({}, other, {
	        ref: option.props.value,
	        name: _this2.props.name,
	        key: option.props.value,
	        value: option.props.value,
	        label: option.props.label,
	        labelPosition: _this2.props.labelPosition,
	        onCheck: _this2._onChange,
	        checked: option.props.value === _this2.state.selected }));
	    }, this);
	
	    return React.createElement(
	      'div',
	      {
	        style: this.props.style,
	        className: this.props.className || '' },
	      options
	    );
	  },
	
	  _updateRadioButtons: function _updateRadioButtons(newSelection) {
	    if (this.state.numberCheckedRadioButtons === 0) {
	      this.setState({ selected: newSelection });
	    } else if (({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	      var message = "Cannot select a different radio button while another radio button " + "has the 'checked' property set to true.";
	      console.error(message);
	    }
	  },
	
	  _onChange: function _onChange(e, newSelection) {
	    this._updateRadioButtons(newSelection);
	
	    // Successful update
	    if (this.state.numberCheckedRadioButtons === 0) {
	      if (this.props.onChange) this.props.onChange(e, newSelection);
	    }
	  },
	
	  getSelectedValue: function getSelectedValue() {
	    return this.state.selected;
	  },
	
	  setSelectedValue: function setSelectedValue(newSelectionValue) {
	    this._updateRadioButtons(newSelectionValue);
	  },
	
	  clearValue: function clearValue() {
	    this.setSelectedValue('');
	  }
	
	});
	
	module.exports = RadioButtonGroup;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var ColorManipulator = __webpack_require__(102);
	var Typography = __webpack_require__(119);
	var EnhancedButton = __webpack_require__(88);
	var Paper = __webpack_require__(55);
	
	function validateLabel(props, propName, componentName) {
	  if (!props.children && !props.label) {
	    return new Error('Required prop label or children was not ' + 'specified in ' + componentName + '.');
	  }
	}
	
	var RaisedButton = React.createClass({
	  displayName: 'RaisedButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    className: React.PropTypes.string,
	    disabled: React.PropTypes.bool,
	    label: validateLabel,
	    onMouseDown: React.PropTypes.func,
	    onMouseUp: React.PropTypes.func,
	    onMouseLeave: React.PropTypes.func,
	    onTouchEnd: React.PropTypes.func,
	    onTouchStart: React.PropTypes.func,
	    primary: React.PropTypes.bool,
	    secondary: React.PropTypes.bool,
	    labelStyle: React.PropTypes.object,
	    backgroundColor: React.PropTypes.string,
	    labelColor: React.PropTypes.string,
	    disabledBackgroundColor: React.PropTypes.string,
	    disabledLabelColor: React.PropTypes.string,
	    fullWidth: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    var zDepth = this.props.disabled ? 0 : 1;
	    return {
	      hovered: false,
	      touched: false,
	      initialZDepth: zDepth,
	      zDepth: zDepth
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var zDepth = nextProps.disabled ? 0 : 1;
	    this.setState({
	      zDepth: zDepth,
	      initialZDepth: zDepth
	    });
	  },
	
	  _getBackgroundColor: function _getBackgroundColor() {
	    var disabledColor = this.props.disabledBackgroundColor ? this.props.disabledBackgroundColor : this.getTheme().disabledColor;
	
	    return this.props.disabled ? disabledColor : this.props.backgroundColor ? this.props.backgroundColor : this.props.primary ? this.getTheme().primaryColor : this.props.secondary ? this.getTheme().secondaryColor : this.getTheme().color;
	  },
	
	  _getLabelColor: function _getLabelColor() {
	    var disabledColor = this.props.disabledLabelColor ? this.props.disabledLabelColor : this.getTheme().disabledTextColor;
	
	    return this.props.disabled ? disabledColor : this.props.labelColor ? this.props.labelColor : this.props.primary ? this.getTheme().primaryTextColor : this.props.secondary ? this.getTheme().secondaryTextColor : this.getTheme().textColor;
	  },
	
	  getThemeButton: function getThemeButton() {
	    return this.context.muiTheme.component.button;
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.raisedButton;
	  },
	
	  getStyles: function getStyles() {
	    var amount = this.props.primary || this.props.secondary ? 0.4 : 0.08;
	    var styles = {
	      root: {
	        backgroundColor: 'none',
	        display: 'inline-block',
	        minWidth: this.props.fullWidth ? '100%' : this.getThemeButton().minWidth,
	        height: this.getThemeButton().height,
	        transition: Transitions.easeOut()
	      },
	      container: {
	        position: 'relative',
	        height: '100%',
	        width: '100%',
	        padding: 0,
	        overflow: 'hidden',
	        borderRadius: 2,
	        transition: Transitions.easeOut(),
	        backgroundColor: this._getBackgroundColor(),
	
	        //This is need so that ripples do not bleed
	        //past border radius.
	        //See: http://stackoverflow.com/questions/17298739/css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
	        transform: 'translate3d(0, 0, 0)'
	      },
	      label: {
	        position: 'relative',
	        opacity: 1,
	        fontSize: '14px',
	        letterSpacing: 0,
	        textTransform: 'uppercase',
	        fontWeight: Typography.fontWeightMedium,
	        margin: 0,
	        padding: '0px ' + this.context.muiTheme.spacing.desktopGutterLess + 'px',
	        userSelect: 'none',
	        lineHeight: this.props.style && this.props.style.height ? this.props.style.height : this.getThemeButton().height + 'px',
	        color: this._getLabelColor()
	      },
	      overlay: {
	        transition: Transitions.easeOut(),
	        top: 0
	      },
	      overlayWhenHovered: {
	        backgroundColor: ColorManipulator.fade(this._getLabelColor(), amount)
	      }
	    };
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var disabled = _props.disabled;
	    var label = _props.label;
	    var primary = _props.primary;
	    var secondary = _props.secondary;
	
	    var other = _objectWithoutProperties(_props, ['disabled', 'label', 'primary', 'secondary']);
	
	    var styles = this.getStyles();
	
	    var labelElement = undefined;
	    if (label) {
	      labelElement = React.createElement(
	        'span',
	        { style: this.mergeAndPrefix(styles.label, this.props.labelStyle) },
	        label
	      );
	    }
	
	    var rippleColor = styles.label.color;
	    var rippleOpacity = !(primary || secondary) ? 0.1 : 0.16;
	
	    var buttonEventHandlers = disabled ? null : {
	      onMouseDown: this._handleMouseDown,
	      onMouseUp: this._handleMouseUp,
	      onMouseLeave: this._handleMouseLeave,
	      onMouseEnter: this._handleMouseEnter,
	      onTouchStart: this._handleTouchStart,
	      onTouchEnd: this._handleTouchEnd,
	      onKeyboardFocus: this._handleKeyboardFocus
	    };
	
	    return React.createElement(
	      Paper,
	      {
	        style: this.mergeAndPrefix(styles.root, this.props.style),
	        zDepth: this.state.zDepth },
	      React.createElement(
	        EnhancedButton,
	        _extends({}, other, buttonEventHandlers, {
	          ref: 'container',
	          disabled: disabled,
	          style: this.mergeAndPrefix(styles.container),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity }),
	        React.createElement(
	          'div',
	          { ref: 'overlay', style: this.mergeAndPrefix(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered) },
	          labelElement,
	          this.props.children
	        )
	      )
	    );
	  },
	
	  _handleMouseDown: function _handleMouseDown(e) {
	    //only listen to left clicks
	    if (e.button === 0) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	    }
	    if (this.props.onMouseDown) this.props.onMouseDown(e);
	  },
	
	  _handleMouseUp: function _handleMouseUp(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onMouseUp) this.props.onMouseUp(e);
	  },
	
	  _handleMouseLeave: function _handleMouseLeave(e) {
	    if (!this.refs.container.isKeyboardFocused()) this.setState({ zDepth: this.state.initialZDepth, hovered: false });
	    if (this.props.onMouseLeave) this.props.onMouseLeave(e);
	  },
	
	  _handleMouseEnter: function _handleMouseEnter(e) {
	    if (!this.refs.container.isKeyboardFocused() && !this.state.touch) {
	      this.setState({ hovered: true });
	    }
	    if (this.props.onMouseEnter) this.props.onMouseEnter(e);
	  },
	
	  _handleTouchStart: function _handleTouchStart(e) {
	    this.setState({
	      touch: true,
	      zDepth: this.state.initialZDepth + 1
	    });
	    if (this.props.onTouchStart) this.props.onTouchStart(e);
	  },
	
	  _handleTouchEnd: function _handleTouchEnd(e) {
	    this.setState({ zDepth: this.state.initialZDepth });
	    if (this.props.onTouchEnd) this.props.onTouchEnd(e);
	  },
	
	  _handleKeyboardFocus: function _handleKeyboardFocus(e, keyboardFocused) {
	    if (keyboardFocused && !this.props.disabled) {
	      this.setState({ zDepth: this.state.initialZDepth + 1 });
	      var amount = this.props.primary || this.props.secondary ? 0.4 : 0.08;
	      React.findDOMNode(this.refs.overlay).style.backgroundColor = ColorManipulator.fade(this.mergeAndPrefix(this.getStyles().label, this.props.labelStyle).color, amount);
	    } else if (!this.state.hovered) {
	      this.setState({ zDepth: this.state.initialZDepth });
	      React.findDOMNode(this.refs.overlay).style.backgroundColor = 'transparent';
	    }
	  }
	});
	
	module.exports = RaisedButton;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	var Paper = __webpack_require__(55);
	
	var VIEWBOX_SIZE = 32;
	var RefreshIndicator = _react2['default'].createClass({
	  displayName: 'RefreshIndicator',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    left: _react2['default'].PropTypes.number.isRequired,
	    percentage: _react2['default'].PropTypes.number,
	    size: _react2['default'].PropTypes.number,
	    status: _react2['default'].PropTypes.oneOf(['ready', 'loading', 'hide']),
	    style: _react2['default'].PropTypes.object,
	    top: _react2['default'].PropTypes.number.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      percentage: 0,
	      size: 40,
	      status: 'hide'
	    };
	  },
	
	  contextTypes: {
	    muiTheme: _react2['default'].PropTypes.object
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate();
	  },
	
	  componentDidUpdate: function componentDidUpdate() {
	    this._scalePath(_react2['default'].findDOMNode(this.refs.path), 0);
	    this._rotateWrapper(_react2['default'].findDOMNode(this.refs.wrapper));
	  },
	
	  render: function render() {
	    var rootStyle = this._getRootStyle();
	    return _react2['default'].createElement(
	      Paper,
	      {
	        circle: true,
	        style: this.mergeAndPrefix(rootStyle, this.props.style),
	        ref: 'indicatorCt'
	      },
	      this._renderChildren()
	    );
	  },
	
	  _renderChildren: function _renderChildren() {
	    var paperSize = this._getPaperSize();
	    var childrenCmp = null;
	    if (this.props.status !== 'ready') {
	      var circleStyle = this._getCircleStyle(paperSize);
	      childrenCmp = _react2['default'].createElement(
	        'div',
	        { ref: 'wrapper', style: this.mergeAndPrefix({
	            transition: Transitions.create('transform', '20s', null, 'linear'),
	            width: '100%',
	            height: '100%'
	          })
	        },
	        _react2['default'].createElement(
	          'svg',
	          { style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2['default'].createElement('circle', _extends({ ref: 'path',
	            style: this.mergeAndPrefix(circleStyle.style, {
	              transition: Transitions.create('all', '1.5s', null, 'ease-in-out')
	            })
	          }, circleStyle.attr))
	        )
	      );
	    } else {
	      var circleStyle = this._getCircleStyle(paperSize);
	      var polygonStyle = this._getPolygonStyle(paperSize);
	      childrenCmp = _react2['default'].createElement(
	        'svg',
	        { style: {
	            width: paperSize,
	            height: paperSize
	          },
	          viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	        },
	        _react2['default'].createElement('circle', _extends({
	          style: this.mergeAndPrefix(circleStyle.style)
	        }, circleStyle.attr)),
	        _react2['default'].createElement('polygon', _extends({
	          style: this.mergeAndPrefix(polygonStyle.style)
	        }, polygonStyle.attr))
	      );
	    }
	
	    return childrenCmp;
	  },
	
	  _getTheme: function _getTheme() {
	    return this.context.muiTheme.component.refreshIndicator;
	  },
	
	  _getPaddingSize: function _getPaddingSize() {
	    var padding = this.props.size * 0.1;
	    return padding;
	  },
	
	  _getPaperSize: function _getPaperSize() {
	    return this.props.size - this._getPaddingSize() * 2;
	  },
	
	  _getCircleAttr: function _getCircleAttr() {
	    return {
	      radiu: VIEWBOX_SIZE / 2 - 5,
	      originX: VIEWBOX_SIZE / 2,
	      originY: VIEWBOX_SIZE / 2,
	      strokeWidth: 3
	    };
	  },
	
	  _getArcDeg: function _getArcDeg() {
	    var p = this.props.percentage / 100;
	
	    var beginDeg = p * 120;
	    var endDeg = p * 410;
	    return [beginDeg, endDeg];
	  },
	
	  _getFactor: function _getFactor() {
	    var p = this.props.percentage / 100;
	    var p1 = Math.min(1, p / 0.4);
	
	    return p1;
	  },
	
	  _getRootStyle: function _getRootStyle() {
	    var padding = this._getPaddingSize();
	    return {
	      position: "absolute",
	      zIndex: 2,
	      width: this.props.size,
	      height: this.props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate3d(' + (10000 + this.props.left) + 'px, ' + (10000 + this.props.top) + 'px, 0)',
	      opacity: this.props.status === 'hide' ? 0 : 1,
	      transition: this.props.status === 'hide' ? Transitions.create('all', '.3s', 'ease-out') : 'none'
	    };
	  },
	
	  _getCircleStyle: function _getCircleStyle() {
	    var isLoading = this.props.status === 'loading';
	    var p1 = isLoading ? 1 : this._getFactor();
	    var circle = this._getCircleAttr();
	    var perimeter = Math.PI * 2 * circle.radiu;
	
	    var _getArcDeg2 = this._getArcDeg();
	
	    var _getArcDeg22 = _slicedToArray(_getArcDeg2, 2);
	
	    var beginDeg = _getArcDeg22[0];
	    var endDeg = _getArcDeg22[1];
	
	    var arcLen = (endDeg - beginDeg) * perimeter / 360;
	    var dashOffset = -beginDeg * perimeter / 360;
	
	    var theme = this._getTheme();
	    return {
	      style: {
	        strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	        strokeDashoffset: dashOffset,
	        stroke: isLoading || this.props.percentage === 100 ? theme.loadingStrokeColor : theme.strokeColor,
	        strokeLinecap: 'round',
	        opacity: p1,
	        strokeWidth: circle.strokeWidth * p1,
	        fill: 'none'
	      },
	      attr: {
	        cx: circle.originX,
	        cy: circle.originY,
	        r: circle.radiu
	      }
	    };
	  },
	
	  _getPolygonStyle: function _getPolygonStyle() {
	    var p1 = this._getFactor();
	    var circle = this._getCircleAttr();
	
	    var triangleCx = circle.originX + circle.radiu;
	    var triangleCy = circle.originY;
	    var dx = circle.strokeWidth * 7 / 4 * p1;
	    var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	    var _getArcDeg3 = this._getArcDeg();
	
	    var _getArcDeg32 = _slicedToArray(_getArcDeg3, 2);
	
	    var endDeg = _getArcDeg32[1];
	
	    var theme = this._getTheme();
	    return {
	      style: {
	        fill: this.props.percentage === 100 ? theme.loadingStrokeColor : theme.strokeColor,
	        transform: 'rotate(' + endDeg + 'deg)',
	        transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	        opacity: p1
	      },
	      attr: {
	        points: trianglePath
	      }
	    };
	  },
	
	  _scalePath: function _scalePath(path, step) {
	    if (this.props.status !== 'loading' || !this.isMounted()) return;
	
	    var currStep = (step || 0) % 3;
	
	    clearTimeout(this._timer1);
	    this._timer1 = setTimeout(this._scalePath.bind(this, path, currStep + 1), currStep ? 750 : 250);
	
	    var circle = this._getCircleAttr();
	    var perimeter = Math.PI * 2 * circle.radiu;
	    var arcLen = perimeter * 0.64;
	
	    if (currStep === 0) {
	      path.style.strokeDasharray = '1, 200';
	      path.style.strokeDashoffset = 0;
	      path.style[this.prefixed('transitionDuration')] = '0ms';
	    } else if (currStep === 1) {
	      path.style.strokeDasharray = arcLen + ', 200';
	      path.style.strokeDashoffset = -15;
	      path.style[this.prefixed('transitionDuration')] = '750ms';
	    } else {
	      path.style.strokeDasharray = arcLen + ',200';
	      path.style.strokeDashoffset = -(perimeter - 1);
	      path.style[this.prefixed('transitionDuration')] = '850ms';
	    }
	  },
	
	  _rotateWrapper: function _rotateWrapper(wrapper) {
	    var _this = this;
	
	    if (this.props.status !== 'loading' || !this.isMounted()) return;
	
	    clearTimeout(this._timer2);
	    this._timer2 = setTimeout(this._rotateWrapper.bind(this, wrapper), 10050);
	
	    AutoPrefix.set(wrapper.style, "transform", null);
	    AutoPrefix.set(wrapper.style, "transform", "rotate(0deg)");
	    AutoPrefix.set(wrapper.style, "transitionDuration", "0ms");
	
	    setTimeout(function () {
	      if (_this.isMounted()) {
	        AutoPrefix.set(wrapper.style, "transform", "rotate(1800deg)");
	        wrapper.style.transitionDuration = "10s";
	        AutoPrefix.set(wrapper.style, "transitionTimingFunction", "linear");
	      }
	    }, 50);
	  },
	
	  prefixed: function prefixed(key) {
	    return AutoPrefix.single(key);
	  }
	
	});
	
	module.exports = RefreshIndicator;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  CircleRipple: __webpack_require__(526),
	  FocusRipple: __webpack_require__(211),
	  TouchRipple: __webpack_require__(363)
	};

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var TextField = __webpack_require__(212);
	var DropDownMenu = __webpack_require__(517);
	
	var SelectField = React.createClass({
	  displayName: 'SelectField',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    errorText: React.PropTypes.string,
	    floatingLabelText: React.PropTypes.string,
	    selectFieldRoot: React.PropTypes.string,
	    underlineStyle: React.PropTypes.object,
	    labelStyle: React.PropTypes.object,
	    errorStyle: React.PropTypes.object,
	    hintText: React.PropTypes.string,
	    id: React.PropTypes.string,
	    multiLine: React.PropTypes.bool,
	    onBlur: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    onKeyDown: React.PropTypes.func,
	    onEnterKeyDown: React.PropTypes.func,
	    type: React.PropTypes.string,
	    rows: React.PropTypes.number,
	    inputStyle: React.PropTypes.object,
	    iconStyle: React.PropTypes.object,
	    floatingLabelStyle: React.PropTypes.object,
	    autoWidth: React.PropTypes.bool,
	    menuItems: React.PropTypes.array.isRequired,
	    menuItemStyle: React.PropTypes.object,
	    selectedIndex: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      fullWidth: false
	    };
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        height: 46,
	        position: 'relative',
	        width: '100%',
	        top: 16,
	        fontSize: 16
	      },
	      label: {
	        paddingLeft: 0,
	        top: 4,
	        width: '100%'
	      },
	      icon: {
	        top: 20,
	        right: 0
	      },
	      underline: {
	        borderTop: 'none'
	      },
	      input: {},
	      error: {}
	    };
	
	    if (!this.props.floatingLabelText) {
	      if (this.props.hintText) {
	        styles.root.top = -5;
	        styles.label.top = 1;
	        styles.icon.top = 17;
	      } else {
	        styles.root.top = -8;
	      }
	    } else {
	      styles.error.bottom = -15;
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var styles = this.getStyles();
	    var _props = this.props;
	    var style = _props.style;
	    var labelStyle = _props.labelStyle;
	    var iconStyle = _props.iconStyle;
	    var underlineStyle = _props.underlineStyle;
	    var errorStyle = _props.errorStyle;
	    var selectFieldRoot = _props.selectFieldRoot;
	    var menuItems = _props.menuItems;
	    var disabled = _props.disabled;
	    var floatingLabelText = _props.floatingLabelText;
	    var floatingLabelStyle = _props.floatingLabelStyle;
	    var hintText = _props.hintText;
	    var fullWidth = _props.fullWidth;
	    var errorText = _props.errorText;
	
	    var other = _objectWithoutProperties(_props, ['style', 'labelStyle', 'iconStyle', 'underlineStyle', 'errorStyle', 'selectFieldRoot', 'menuItems', 'disabled', 'floatingLabelText', 'floatingLabelStyle', 'hintText', 'fullWidth', 'errorText']);
	
	    var textFieldProps = {
	      style: this.mergeAndPrefix(styles.input, style),
	      floatingLabelText: floatingLabelText,
	      floatingLabelStyle: floatingLabelStyle,
	      hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	      fullWidth: fullWidth,
	      errorText: errorText,
	      errorStyle: this.mergeAndPrefix(styles.error, errorStyle)
	    };
	    var dropDownMenuProps = {
	      menuItems: menuItems,
	      disabled: disabled,
	      style: this.mergeAndPrefix(styles.root, selectFieldRoot),
	      labelStyle: this.mergeAndPrefix(styles.label, labelStyle),
	      iconStyle: this.mergeAndPrefix(styles.icon, iconStyle),
	      underlineStyle: this.mergeAndPrefix(styles.underline),
	      autoWidth: false
	    };
	
	    return React.createElement(
	      TextField,
	      textFieldProps,
	      React.createElement(DropDownMenu, _extends({}, dropDownMenuProps, other))
	    );
	  }
	});
	
	module.exports = SelectField;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var Draggable = __webpack_require__(1192);
	var Transitions = __webpack_require__(24);
	var FocusRipple = __webpack_require__(211);
	
	/**
	  * Verifies min/max range.
	  * @param   {Object} props         Properties of the React component.
	  * @param   {String} propName      Name of the property to validate.
	  * @param   {String} componentName Name of the component whose property is being validated.
	  * @returns {Object} Returns an Error if min >= max otherwise null.
	  */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  var error = React.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	  * Verifies value is within the min/max range.
	  * @param   {Object} props         Properties of the React component.
	  * @param   {String} propName      Name of the property to validate.
	  * @param   {String} componentName Name of the component whose property is being validated.
	  * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	  */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  var error = React.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var Slider = React.createClass({
	  displayName: 'Slider',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    name: React.PropTypes.string.isRequired,
	    defaultValue: valueInRangePropType,
	    description: React.PropTypes.string,
	    disabled: React.PropTypes.bool,
	    error: React.PropTypes.string,
	    max: minMaxPropType,
	    min: minMaxPropType,
	    required: React.PropTypes.bool,
	    step: React.PropTypes.number,
	    onBlur: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    onDragStart: React.PropTypes.func,
	    onDragStop: React.PropTypes.func,
	    onFocus: React.PropTypes.func,
	    value: valueInRangePropType
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultValue: 0,
	      disabled: false,
	      max: 1,
	      min: 0,
	      required: true,
	      step: 0.01
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var value = this.props.value;
	    if (value === undefined) {
	      value = this.props.defaultValue;
	    }
	    var percent = (value - this.props.min) / (this.props.max - this.props.min);
	    if (isNaN(percent)) percent = 0;
	
	    return {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      percent: percent,
	      value: value
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.value !== undefined) {
	      this.setValue(nextProps.value);
	    }
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.slider;
	  },
	
	  getStyles: function getStyles() {
	    var fillGutter = this.getTheme().handleSize / 2;
	    var disabledGutter = this.getTheme().trackSize + this.getTheme().handleSizeDisabled / 2;
	    var calcDisabledSpacing = this.props.disabled ? ' - ' + disabledGutter + 'px' : '';
	    var styles = {
	      root: {
	        touchCallout: 'none',
	        userSelect: 'none',
	        cursor: 'default',
	        height: this.getTheme().handleSizeActive,
	        position: 'relative',
	        marginTop: 24,
	        marginBottom: 48
	      },
	      track: {
	        position: 'absolute',
	        top: (this.getTheme().handleSizeActive - this.getTheme().trackSize) / 2,
	        left: 0,
	        width: '100%',
	        height: this.getTheme().trackSize
	      },
	      filledAndRemaining: {
	        position: 'absolute',
	        top: 0,
	        height: '100%',
	        transition: Transitions.easeOut(null, 'margin')
	      },
	      handle: {
	        boxSizing: 'border-box',
	        position: 'absolute',
	        cursor: 'pointer',
	        pointerEvents: 'inherit',
	        top: (this.getTheme().handleSizeActive - this.getTheme().trackSize) / 2 + 'px',
	        left: '0%',
	        zIndex: 1,
	        margin: this.getTheme().trackSize / 2 + 'px 0 0 0',
	        width: this.getTheme().handleSize,
	        height: this.getTheme().handleSize,
	        backgroundColor: this.getTheme().selectionColor,
	        backgroundClip: 'padding-box',
	        border: '0px solid transparent',
	        borderRadius: '50%',
	        transform: 'translate(-50%, -50%)',
	        transition: Transitions.easeOut('450ms', 'background') + ',' + Transitions.easeOut('450ms', 'border-color') + ',' + Transitions.easeOut('450ms', 'width') + ',' + Transitions.easeOut('450ms', 'height'),
	        overflow: 'visible'
	      },
	      handleWhenDisabled: {
	        boxSizing: 'content-box',
	        cursor: 'not-allowed',
	        backgroundColor: this.getTheme().trackColor,
	        width: this.getTheme().handleSizeDisabled,
	        height: this.getTheme().handleSizeDisabled,
	        border: 'none'
	      },
	      handleWhenPercentZero: {
	        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().handleColorZero,
	        backgroundColor: this.getTheme().handleFillColor,
	        boxShadow: 'none'
	      },
	      handleWhenPercentZeroAndDisabled: {
	        cursor: 'not-allowed',
	        width: this.getTheme().handleSizeDisabled,
	        height: this.getTheme().handleSizeDisabled
	      },
	      handleWhenPercentZeroAndFocused: {
	        border: this.getTheme().trackSize + 'px solid ' + this.getTheme().trackColorSelected
	      },
	      handleWhenActive: {
	        width: this.getTheme().handleSizeActive,
	        height: this.getTheme().handleSizeActive
	      },
	      ripple: {
	        height: this.getTheme().handleSize,
	        width: this.getTheme().handleSize,
	        overflow: 'visible'
	      },
	      rippleWhenPercentZero: {
	        top: -this.getTheme().trackSize,
	        left: -this.getTheme().trackSize
	      },
	      rippleInner: {
	        height: '300%',
	        width: '300%',
	        top: -this.getTheme().handleSize,
	        left: -this.getTheme().handleSize
	      }
	    };
	    styles.filled = this.mergeAndPrefix(styles.filledAndRemaining, {
	      left: 0,
	      backgroundColor: this.props.disabled ? this.getTheme().trackColor : this.getTheme().selectionColor,
	      marginRight: fillGutter,
	      width: 'calc(' + this.state.percent * 100 + '%' + calcDisabledSpacing + ')'
	    });
	    styles.remaining = this.mergeAndPrefix(styles.filledAndRemaining, {
	      right: 0,
	      backgroundColor: this.getTheme().trackColor,
	      marginLeft: fillGutter,
	      width: 'calc(' + (1 - this.state.percent) * 100 + '%' + calcDisabledSpacing + ')'
	    });
	
	    return styles;
	  },
	
	  render: function render() {
	    var others = _objectWithoutProperties(this.props, []);
	
	    var percent = this.state.percent;
	    if (percent > 1) percent = 1;else if (percent < 0) percent = 0;
	
	    var styles = this.getStyles();
	    var sliderStyles = this.mergeAndPrefix(styles.root, this.props.style);
	    var handleStyles = percent === 0 ? this.mergeAndPrefix(styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, (this.state.hovered || this.state.focused) && !this.props.disabled && styles.handleWhenPercentZeroAndFocused, this.props.disabled && styles.handleWhenPercentZeroAndDisabled) : this.mergeAndPrefix(styles.handle, this.state.active && styles.handleWhenActive, this.state.focused && { outline: 'none' }, this.props.disabled && styles.handleWhenDisabled);
	    var rippleStyle = this.mergeAndPrefix(styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	    var remainingStyles = styles.remaining;
	    if ((this.state.hovered || this.state.focused) && !this.props.disabled) {
	      remainingStyles.backgroundColor = this.getTheme().trackColorSelected;
	    }
	
	    var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;
	    var rippleColor = this.state.percent === 0 ? this.getTheme().handleColorZero : this.getTheme().rippleColor;
	    var focusRipple = undefined;
	    if (!this.props.disabled && !this.props.disableFocusRipple) {
	      focusRipple = React.createElement(FocusRipple, {
	        ref: 'focusRipple',
	        key: 'focusRipple',
	        style: rippleStyle,
	        innerStyle: styles.rippleInner,
	        show: rippleShowCondition,
	        color: rippleColor });
	    }
	    return React.createElement(
	      'div',
	      _extends({}, others, { style: this.props.style }),
	      React.createElement('span', { className: 'mui-input-highlight' }),
	      React.createElement('span', { className: 'mui-input-bar' }),
	      React.createElement(
	        'span',
	        { className: 'mui-input-description' },
	        this.props.description
	      ),
	      React.createElement(
	        'span',
	        { className: 'mui-input-error' },
	        this.props.error
	      ),
	      React.createElement(
	        'div',
	        { style: sliderStyles,
	          onFocus: this._onFocus,
	          onBlur: this._onBlur,
	          onMouseDown: this._onMouseDown,
	          onMouseEnter: this._onMouseEnter,
	          onMouseLeave: this._onMouseLeave,
	          onMouseUp: this._onMouseUp },
	        React.createElement(
	          'div',
	          { ref: 'track', style: styles.track },
	          React.createElement('div', { style: styles.filled }),
	          React.createElement('div', { style: remainingStyles }),
	          React.createElement(
	            Draggable,
	            { axis: 'x', bound: 'point',
	              cancel: this.props.disabled ? '*' : null,
	              start: { x: percent * 100 + '%' },
	              constrain: this._constrain(),
	              onStart: this._onDragStart,
	              onStop: this._onDragStop,
	              onDrag: this._onDragUpdate,
	              onMouseDown: this._onMouseDownKnob },
	            React.createElement(
	              'div',
	              { style: handleStyles, tabIndex: 0 },
	              focusRipple
	            )
	          )
	        )
	      ),
	      React.createElement('input', { ref: 'input', type: 'hidden',
	        name: this.props.name,
	        value: this.state.value,
	        required: this.props.required,
	        min: this.props.min,
	        max: this.props.max,
	        step: this.props.step })
	    );
	  },
	
	  getValue: function getValue() {
	    return this.state.value;
	  },
	
	  setValue: function setValue(i) {
	    // calculate percentage
	    var percent = (i - this.props.min) / (this.props.max - this.props.min);
	    if (isNaN(percent)) percent = 0;
	    // update state
	    this.setState({
	      value: i,
	      percent: percent
	    });
	  },
	
	  getPercent: function getPercent() {
	    return this.state.percent;
	  },
	
	  setPercent: function setPercent(percent) {
	    var value = this._alignValue(this._percentToValue(percent));
	    this.setState({ value: value, percent: percent });
	  },
	
	  clearValue: function clearValue() {
	    this.setValue(this.props.min);
	  },
	
	  _alignValue: function _alignValue(val) {
	    var _props = this.props;
	    var step = _props.step;
	    var min = _props.min;
	
	    var valModStep = (val - min) % step;
	    var alignValue = val - valModStep;
	
	    if (Math.abs(valModStep) * 2 >= step) {
	      alignValue += valModStep > 0 ? step : -step;
	    }
	
	    return parseFloat(alignValue.toFixed(5));
	  },
	
	  _constrain: function _constrain() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var min = _props2.min;
	    var max = _props2.max;
	    var step = _props2.step;
	
	    return function (pos) {
	      var pixelMax = React.findDOMNode(_this.refs.track).clientWidth;
	      var pixelStep = pixelMax / ((max - min) / step);
	
	      var cursor = min;
	      var i = undefined;
	      for (i = 0; i < (max - min) / step; i++) {
	        var distance = pos.left - cursor;
	        var nextDistance = cursor + pixelStep - pos.left;
	        if (Math.abs(distance) > Math.abs(nextDistance)) {
	          cursor += pixelStep;
	        } else {
	          break;
	        }
	      }
	
	      return {
	        left: cursor
	      };
	    };
	  },
	
	  _onFocus: function _onFocus(e) {
	    this.setState({ focused: true });
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _onBlur: function _onBlur(e) {
	    this.setState({ focused: false, active: false });
	    if (this.props.onBlur) this.props.onBlur(e);
	  },
	
	  _onMouseDown: function _onMouseDown(e) {
	    if (!this.props.disabled) this._pos = e.clientX;
	  },
	
	  _onMouseEnter: function _onMouseEnter() {
	    this.setState({ hovered: true });
	  },
	
	  _onMouseLeave: function _onMouseLeave() {
	    this.setState({ hovered: false });
	  },
	
	  _onMouseUp: function _onMouseUp(e) {
	    if (!this.props.disabled) this.setState({ active: false });
	    if (!this.state.dragging && Math.abs(this._pos - e.clientX) < 5) {
	      var pos = e.clientX - React.findDOMNode(this).getBoundingClientRect().left;
	      this._dragX(e, pos);
	    }
	
	    this._pos = undefined;
	  },
	
	  _onMouseDownKnob: function _onMouseDownKnob() {
	    if (!this.props.disabled) this.setState({ active: true });
	  },
	
	  _onDragStart: function _onDragStart(e, ui) {
	    this.setState({
	      dragging: true,
	      active: true
	    });
	    if (this.props.onDragStart) this.props.onDragStart(e, ui);
	  },
	
	  _onDragStop: function _onDragStop(e, ui) {
	    this.setState({
	      dragging: false,
	      active: false
	    });
	    if (this.props.onDragStop) this.props.onDragStop(e, ui);
	  },
	
	  _onDragUpdate: function _onDragUpdate(e, ui) {
	    if (!this.state.dragging) return;
	    if (!this.props.disabled) this._dragX(e, ui.position.left);
	  },
	
	  _dragX: function _dragX(e, pos) {
	    var max = React.findDOMNode(this.refs.track).clientWidth;
	    if (pos < 0) pos = 0;else if (pos > max) pos = max;
	    if (pos === this.props.min) {
	      return this._updateWithChangeEvent(e, 0);
	    }
	    this._updateWithChangeEvent(e, pos / max);
	  },
	
	  _updateWithChangeEvent: function _updateWithChangeEvent(e, percent) {
	    if (this.state.percent === percent) return;
	    this.setPercent(percent);
	    var value = this._alignValue(this._percentToValue(percent));
	    if (this.props.onChange) this.props.onChange(e, value);
	  },
	
	  _percentToValue: function _percentToValue(percent) {
	    return percent * (this.props.max - this.props.min) + this.props.min;
	  }
	
	});
	
	module.exports = Slider;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var CssEvent = __webpack_require__(170);
	var StylePropable = __webpack_require__(6);
	var Transitions = __webpack_require__(24);
	var ClickAwayable = __webpack_require__(146);
	var FlatButton = __webpack_require__(167);
	
	var Snackbar = React.createClass({
	  displayName: 'Snackbar',
	
	  mixins: [StylePropable, ClickAwayable],
	
	  manuallyBindClickAway: true,
	
	  // ID of the active timer.
	  _autoHideTimerId: undefined,
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    message: React.PropTypes.string.isRequired,
	    action: React.PropTypes.string,
	    autoHideDuration: React.PropTypes.number,
	    onActionTouchTap: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    onDismiss: React.PropTypes.func,
	    openOnMount: React.PropTypes.bool
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      open: this.props.openOnMount || false
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    if (this.props.openOnMount) {
	      this._setAutoHideTimer();
	      this._bindClickAway();
	    }
	  },
	
	  componentClickAway: function componentClickAway() {
	    this.dismiss();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    var _this = this;
	
	    if (prevState.open !== this.state.open) {
	      if (this.state.open) {
	        this._setAutoHideTimer();
	
	        //Only Bind clickaway after transition finishes
	        CssEvent.onTransitionEnd(React.findDOMNode(this), function () {
	          _this._bindClickAway();
	        });
	      } else {
	        this._unbindClickAway();
	      }
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this._clearAutoHideTimer();
	    this._unbindClickAway();
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.snackbar;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        color: this.getTheme().textColor,
	        backgroundColor: this.getTheme().backgroundColor,
	        borderRadius: 2,
	        padding: '0px ' + this.getSpacing().desktopGutter + 'px',
	        height: this.getSpacing().desktopSubheaderHeight,
	        lineHeight: this.getSpacing().desktopSubheaderHeight + 'px',
	        minWidth: 288,
	        maxWidth: 568,
	
	        position: 'fixed',
	        zIndex: 10,
	        bottom: this.getSpacing().desktopGutter,
	        marginLeft: this.getSpacing().desktopGutter,
	
	        left: 0,
	        opacity: 0,
	        visibility: 'hidden',
	        transform: 'translate3d(0, 20px, 0)',
	        transition: Transitions.easeOut('0ms', 'left', '400ms') + ',' + Transitions.easeOut('400ms', 'opacity') + ',' + Transitions.easeOut('400ms', 'transform') + ',' + Transitions.easeOut('400ms', 'visibility')
	      },
	      action: {
	        color: this.getTheme().actionColor,
	        float: 'right',
	        marginTop: 6,
	        marginRight: -16,
	        marginLeft: this.getSpacing().desktopGutter,
	        backgroundColor: 'transparent'
	      },
	      rootWhenOpen: {
	        opacity: 1,
	        visibility: 'visible',
	        transform: 'translate3d(0, 0, 0)',
	        transition: Transitions.easeOut('0ms', 'left', '0ms') + ',' + Transitions.easeOut('400ms', 'opacity', '0ms') + ',' + Transitions.easeOut('400ms', 'transform', '0ms') + ',' + Transitions.easeOut('400ms', 'visibility', '0ms')
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var action = _props.action;
	    var message = _props.message;
	    var onActionTouchTap = _props.onActionTouchTap;
	    var style = _props.style;
	
	    var others = _objectWithoutProperties(_props, ['action', 'message', 'onActionTouchTap', 'style']);
	
	    var styles = this.getStyles();
	
	    var rootStyles = this.state.open ? this.mergeStyles(styles.root, styles.rootWhenOpen, style) : this.mergeStyles(styles.root, style);
	
	    var actionButton = undefined;
	    if (action) {
	      actionButton = React.createElement(FlatButton, {
	        style: styles.action,
	        label: action,
	        onTouchTap: onActionTouchTap });
	    }
	
	    return React.createElement(
	      'span',
	      _extends({}, others, { style: rootStyles }),
	      React.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    );
	  },
	
	  show: function show() {
	    this.setState({ open: true });
	    if (this.props.onShow) this.props.onShow();
	  },
	
	  dismiss: function dismiss() {
	    this._clearAutoHideTimer();
	    this.setState({ open: false });
	    if (this.props.onDismiss) this.props.onDismiss();
	  },
	
	  _clearAutoHideTimer: function _clearAutoHideTimer() {
	    if (this._autoHideTimerId !== undefined) {
	      this._autoHideTimerId = clearTimeout(this._autoHideTimerId);
	    }
	  },
	
	  _setAutoHideTimer: function _setAutoHideTimer() {
	    var _this2 = this;
	
	    if (this.props.autoHideDuration > 0) {
	      this._clearAutoHideTimer();
	      this._autoHideTimerId = setTimeout(function () {
	        _this2.dismiss();
	      }, this.props.autoHideDuration);
	    }
	  }
	
	});
	
	module.exports = Snackbar;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Colors = __webpack_require__(56);
	var ColorManipulator = __webpack_require__(102);
	
	var DarkTheme = {
	  getPalette: function getPalette() {
	    return {
	      textColor: Colors.fullWhite,
	      canvasColor: '#303030',
	      borderColor: ColorManipulator.fade(Colors.fullWhite, 0.3), //Colors.grey300
	      disabledColor: ColorManipulator.fade(Colors.fullWhite, 0.3),
	      primary1Color: Colors.teal200
	    };
	  },
	  getComponentThemes: function getComponentThemes(palette) {
	    var cardColor = Colors.grey800;
	    return {
	      avatar: {
	        borderColor: 'rgba(0, 0, 0, 0.5)'
	      },
	      floatingActionButton: {
	        disabledColor: ColorManipulator.fade(palette.textColor, 0.12)
	      },
	      leftNav: {
	        color: cardColor
	      },
	      menu: {
	        backgroundColor: cardColor,
	        containerBackgroundColor: cardColor
	      },
	      menuItem: {
	        hoverColor: 'rgba(255, 255, 255, .03)'
	      },
	      menuSubheader: {
	        borderColor: 'rgba(255, 255, 255, 0.3)'
	      },
	      paper: {
	        backgroundColor: cardColor
	      },
	      raisedButton: {
	        color: Colors.grey500
	      },
	      toggle: {
	        thumbOnColor: Colors.cyan200,
	        thumbOffColor: Colors.grey400,
	        thumbDisabledColor: Colors.grey800,
	        thumbRequiredColor: Colors.cyan200,
	        trackOnColor: ColorManipulator.fade(Colors.cyan200, 0.5),
	        trackOffColor: 'rgba(255, 255, 255, 0.3)',
	        trackDisabledColor: 'rgba(255, 255, 255, 0.1)'
	      },
	      refreshIndicator: {
	        strokeColor: Colors.grey700,
	        loadingStrokeColor: Colors.teal300
	      },
	      slider: {
	        trackColor: Colors.minBlack,
	        handleColorZero: cardColor,
	        handleFillColor: cardColor,
	        selectionColor: Colors.cyan200
	      }
	    };
	  }
	};
	
	module.exports = DarkTheme;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Colors = __webpack_require__(56);
	var Spacing = __webpack_require__(527);
	var ColorManipulator = __webpack_require__(102);
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	
	var LightTheme = {
	  spacing: Spacing,
	  contentFontFamily: 'Roboto, sans-serif',
	  getPalette: function getPalette() {
	    return {
	      primary1Color: Colors.cyan500,
	      primary2Color: Colors.cyan700,
	      primary3Color: Colors.cyan100,
	      accent1Color: Colors.pinkA200,
	      accent2Color: Colors.pinkA400,
	      accent3Color: Colors.pinkA100,
	      textColor: Colors.darkBlack,
	      canvasColor: Colors.white,
	      borderColor: Colors.grey300,
	      disabledColor: ColorManipulator.fade(Colors.darkBlack, 0.3)
	    };
	  },
	  getComponentThemes: function getComponentThemes(palette, spacing) {
	    spacing = spacing || Spacing;
	    var obj = {
	      appBar: {
	        color: palette.primary1Color,
	        textColor: Colors.darkWhite,
	        height: spacing.desktopKeylineIncrement
	      },
	      avatar: {
	        borderColor: 'rgba(0, 0, 0, 0.08)'
	      },
	      button: {
	        height: 36,
	        minWidth: 88,
	        iconButtonSize: spacing.iconSize * 2
	      },
	      checkbox: {
	        boxColor: palette.textColor,
	        checkedColor: palette.primary1Color,
	        requiredColor: palette.primary1Color,
	        disabledColor: palette.disabledColor,
	        labelColor: palette.textColor,
	        labelDisabledColor: palette.disabledColor
	      },
	      datePicker: {
	        color: palette.primary1Color,
	        textColor: Colors.white,
	        calendarTextColor: palette.textColor,
	        selectColor: palette.primary2Color,
	        selectTextColor: Colors.white
	      },
	      dropDownMenu: {
	        accentColor: palette.borderColor
	      },
	      flatButton: {
	        color: palette.canvasColor,
	        textColor: palette.textColor,
	        primaryTextColor: palette.accent1Color,
	        secondaryTextColor: palette.primary1Color
	      },
	      floatingActionButton: {
	        buttonSize: 56,
	        miniSize: 40,
	        color: palette.accent1Color,
	        iconColor: Colors.white,
	        secondaryColor: palette.primary1Color,
	        secondaryIconColor: Colors.white
	      },
	      inkBar: {
	        backgroundColor: palette.accent1Color
	      },
	      leftNav: {
	        width: spacing.desktopKeylineIncrement * 4,
	        color: Colors.white
	      },
	      listItem: {
	        nestedLevelDepth: 18
	      },
	      menu: {
	        backgroundColor: Colors.white,
	        containerBackgroundColor: Colors.white
	      },
	      menuItem: {
	        dataHeight: 32,
	        height: 48,
	        hoverColor: 'rgba(0, 0, 0, .035)',
	        padding: spacing.desktopGutter,
	        selectedTextColor: palette.accent1Color
	      },
	      menuSubheader: {
	        padding: spacing.desktopGutter,
	        borderColor: palette.borderColor,
	        textColor: palette.primary1Color
	      },
	      paper: {
	        backgroundColor: Colors.white
	      },
	      radioButton: {
	        borderColor: palette.textColor,
	        backgroundColor: Colors.white,
	        checkedColor: palette.primary1Color,
	        requiredColor: palette.primary1Color,
	        disabledColor: palette.disabledColor,
	        size: 24,
	        labelColor: palette.textColor,
	        labelDisabledColor: palette.disabledColor
	      },
	      raisedButton: {
	        color: Colors.white,
	        textColor: palette.textColor,
	        primaryColor: palette.accent1Color,
	        primaryTextColor: Colors.white,
	        secondaryColor: palette.primary1Color,
	        secondaryTextColor: Colors.white
	      },
	      refreshIndicator: {
	        strokeColor: Colors.grey300,
	        loadingStrokeColor: palette.primary1Color
	      },
	      slider: {
	        trackSize: 2,
	        trackColor: Colors.minBlack,
	        trackColorSelected: Colors.grey500,
	        handleSize: 12,
	        handleSizeDisabled: 8,
	        handleSizeActive: 18,
	        handleColorZero: Colors.grey400,
	        handleFillColor: Colors.white,
	        selectionColor: palette.primary3Color,
	        rippleColor: palette.primary1Color
	      },
	      snackbar: {
	        textColor: Colors.white,
	        backgroundColor: '#323232',
	        actionColor: palette.accent1Color
	      },
	      table: {
	        backgroundColor: Colors.white
	      },
	      tableHeader: {
	        borderColor: palette.borderColor
	      },
	      tableHeaderColumn: {
	        textColor: Colors.lightBlack,
	        height: 56,
	        spacing: 24
	      },
	      tableFooter: {
	        borderColor: palette.borderColor,
	        textColor: Colors.lightBlack
	      },
	      tableRow: {
	        hoverColor: Colors.grey200,
	        stripeColor: ColorManipulator.lighten(palette.primary1Color, 0.55),
	        selectedColor: Colors.grey300,
	        textColor: Colors.darkBlack,
	        borderColor: palette.borderColor
	      },
	      tableRowColumn: {
	        height: 48,
	        spacing: 24
	      },
	      timePicker: {
	        color: Colors.white,
	        textColor: Colors.grey600,
	        accentColor: palette.primary1Color,
	        clockColor: Colors.black,
	        selectColor: palette.primary2Color,
	        selectTextColor: Colors.white
	      },
	      toggle: {
	        thumbOnColor: palette.primary1Color,
	        thumbOffColor: Colors.grey50,
	        thumbDisabledColor: Colors.grey400,
	        thumbRequiredColor: palette.primary1Color,
	        trackOnColor: ColorManipulator.fade(palette.primary1Color, 0.5),
	        trackOffColor: Colors.minBlack,
	        trackDisabledColor: Colors.faintBlack,
	        labelColor: palette.textColor,
	        labelDisabledColor: palette.disabledColor
	      },
	      toolbar: {
	        backgroundColor: ColorManipulator.darken('#eeeeee', 0.05),
	        height: 56,
	        titleFontSize: 20,
	        iconColor: 'rgba(0, 0, 0, .40)',
	        separatorColor: 'rgba(0, 0, 0, .175)',
	        menuHoverColor: 'rgba(0, 0, 0, .10)'
	      },
	      tabs: {
	        backgroundColor: palette.primary1Color
	      },
	      textField: {
	        textColor: palette.textColor,
	        hintColor: palette.disabledColor,
	        floatingLabelColor: palette.textColor,
	        disabledTextColor: palette.disabledColor,
	        errorColor: Colors.red500,
	        focusColor: palette.primary1Color,
	        backgroundColor: 'transparent',
	        borderColor: palette.borderColor
	      }
	    };
	
	    // Properties based on previous properties
	    obj.flatButton.disabledTextColor = ColorManipulator.fade(obj.flatButton.textColor, 0.3);
	    obj.floatingActionButton.disabledColor = ColorManipulator.darken(Colors.white, 0.1);
	    obj.floatingActionButton.disabledTextColor = ColorManipulator.fade(palette.textColor, 0.3);
	    obj.raisedButton.disabledColor = ColorManipulator.darken(obj.raisedButton.color, 0.1);
	    obj.raisedButton.disabledTextColor = ColorManipulator.fade(obj.raisedButton.textColor, 0.3);
	    obj.toggle.trackRequiredColor = ColorManipulator.fade(obj.toggle.thumbRequiredColor, 0.5);
	
	    return obj;
	  }
	};
	
	module.exports = LightTheme;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var HardwareKeyboardArrowDown = React.createClass({
	  displayName: 'HardwareKeyboardArrowDown',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	    );
	  }
	
	});
	
	module.exports = HardwareKeyboardArrowDown;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var HardwareKeyboardArrowUp = React.createClass({
	  displayName: 'HardwareKeyboardArrowUp',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	    );
	  }
	
	});
	
	module.exports = HardwareKeyboardArrowUp;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationArrowDropUp = React.createClass({
	  displayName: 'NavigationArrowDropUp',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M7 14l5-5 5 5z' })
	    );
	  }
	
	});
	
	module.exports = NavigationArrowDropUp;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var NavigationCheck = React.createClass({
	  displayName: 'NavigationCheck',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	    );
	  }
	
	});
	
	module.exports = NavigationCheck;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var ToggleCheckBoxOutlineBlank = React.createClass({
	  displayName: 'ToggleCheckBoxOutlineBlank',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	    );
	  }
	
	});
	
	module.exports = ToggleCheckBoxOutlineBlank;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var ToggleCheckBox = React.createClass({
	  displayName: 'ToggleCheckBox',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	    );
	  }
	
	});
	
	module.exports = ToggleCheckBox;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var ToggleRadioButtonChecked = React.createClass({
	  displayName: 'ToggleRadioButtonChecked',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	    );
	  }
	
	});
	
	module.exports = ToggleRadioButtonChecked;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var SvgIcon = __webpack_require__(64);
	
	var ToggleRadioButtonUnchecked = React.createClass({
	  displayName: 'ToggleRadioButtonUnchecked',
	
	  mixins: [PureRenderMixin],
	
	  render: function render() {
	    return React.createElement(
	      SvgIcon,
	      this.props,
	      React.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	    );
	  }
	
	});
	
	module.exports = ToggleRadioButtonUnchecked;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var Checkbox = __webpack_require__(358);
	var TableRowColumn = __webpack_require__(364);
	var ClickAwayable = __webpack_require__(146);
	var StylePropable = __webpack_require__(6);
	
	var TableBody = React.createClass({
	  displayName: 'TableBody',
	
	  mixins: [ClickAwayable, StylePropable],
	
	  propTypes: {
	    allRowsSelected: React.PropTypes.bool,
	    deselectOnClickaway: React.PropTypes.bool,
	    displayRowCheckbox: React.PropTypes.bool,
	    multiSelectable: React.PropTypes.bool,
	    onCellClick: React.PropTypes.func,
	    onCellHover: React.PropTypes.func,
	    onCellHoverExit: React.PropTypes.func,
	    onRowHover: React.PropTypes.func,
	    onRowHoverExit: React.PropTypes.func,
	    onRowSelection: React.PropTypes.func,
	    preScanRows: React.PropTypes.bool,
	    selectable: React.PropTypes.bool,
	    showRowHover: React.PropTypes.bool,
	    stripedRows: React.PropTypes.bool,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      allRowsSelected: false,
	      deselectOnClickaway: true,
	      displayRowCheckbox: true,
	      multiSelectable: false,
	      preScanRows: true,
	      selectable: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedRows: this._calculatePreselectedRows(this.props)
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var newState = {};
	
	    if (this.props.allRowsSelected && !nextProps.allRowsSelected) {
	      var lastSelectedRow = this.state.selectedRows.length ? this.state.selectedRows[this.state.selectedRows.length - 1] : undefined;
	
	      newState.selectedRows = [lastSelectedRow];
	    } else {
	      newState.selectedRows = this._calculatePreselectedRows(nextProps);
	    }
	
	    this.setState(newState);
	  },
	
	  componentClickAway: function componentClickAway() {
	    if (this.props.deselectOnClickaway && this.state.selectedRows.length) {
	      this.setState({ selectedRows: [] });
	    }
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var classes = 'mui-table-body';
	    if (className) classes += ' ' + className;
	
	    var rows = this._createRows();
	
	    return React.createElement(
	      'tbody',
	      { className: classes, style: style },
	      rows
	    );
	  },
	
	  _createRows: function _createRows() {
	    var _this = this;
	
	    var numChildren = React.Children.count(this.props.children);
	    var rowNumber = 0;
	    var handlers = {
	      onCellClick: this._onCellClick,
	      onCellHover: this._onCellHover,
	      onCellHoverExit: this._onCellHoverExit,
	      onRowHover: this._onRowHover,
	      onRowHoverExit: this._onRowHoverExit,
	      onRowClick: this._onRowClick
	    };
	
	    return React.Children.map(this.props.children, function (child) {
	      if (React.isValidElement(child)) {
	        var _ret = (function () {
	          var props = {
	            displayRowCheckbox: _this.props.displayRowCheckbox,
	            hoverable: _this.props.showRowHover,
	            selected: _this._isRowSelected(rowNumber),
	            striped: _this.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	          var checkboxColumn = _this._createRowCheckboxColumn(props);
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [checkboxColumn];
	          React.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return {
	            v: React.cloneElement(child, _extends({}, props, handlers), children)
	          };
	        })();
	
	        if (typeof _ret === 'object') return _ret.v;
	      }
	    });
	  },
	
	  _createRowCheckboxColumn: function _createRowCheckboxColumn(rowProps) {
	    if (!this.props.displayRowCheckbox) return null;
	
	    var key = rowProps.rowNumber + '-cb';
	    var checkbox = React.createElement(Checkbox, {
	      ref: 'rowSelectCB',
	      name: key,
	      value: 'selected',
	      disabled: !this.props.selectable,
	      checked: rowProps.selected });
	
	    return React.createElement(
	      TableRowColumn,
	      {
	        key: key,
	        columnNumber: 0,
	        style: { width: 24 } },
	      checkbox
	    );
	  },
	
	  _calculatePreselectedRows: function _calculatePreselectedRows(props) {
	    // Determine what rows are 'pre-selected'.
	    var preSelectedRows = [];
	
	    if (props.selectable && props.preScanRows) {
	      (function () {
	        var index = 0;
	        React.Children.forEach(props.children, function (child) {
	          if (React.isValidElement(child)) {
	            if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	              preSelectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      })();
	    }
	
	    return preSelectedRows;
	  },
	
	  _isRowSelected: function _isRowSelected(rowNumber) {
	    if (this.props.allRowsSelected) {
	      return true;
	    }
	
	    for (var i = 0; i < this.state.selectedRows.length; i++) {
	      var selection = this.state.selectedRows[i];
	
	      if (typeof selection === 'object') {
	        if (this._isValueInRange(rowNumber, selection)) return true;
	      } else {
	        if (selection === rowNumber) return true;
	      }
	    }
	
	    return false;
	  },
	
	  _isValueInRange: function _isValueInRange(value, range) {
	    if (!range) return false;
	
	    if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	      return true;
	    }
	
	    return false;
	  },
	
	  _onRowClick: function _onRowClick(e, rowNumber) {
	    e.stopPropagation();
	
	    if (this.props.selectable) {
	      // Prevent text selection while selecting rows.
	      window.getSelection().removeAllRanges();
	      this._processRowSelection(e, rowNumber);
	    }
	  },
	
	  _processRowSelection: function _processRowSelection(e, rowNumber) {
	    var selectedRows = this.state.selectedRows;
	
	    if (e.shiftKey && this.props.multiSelectable && selectedRows.length) {
	      var lastIndex = selectedRows.length - 1;
	      var lastSelection = selectedRows[lastIndex];
	
	      if (typeof lastSelection === 'object') {
	        lastSelection.end = rowNumber;
	      } else {
	        selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	      }
	    } else if ((e.ctrlKey && !e.metaKey || e.metaKey && !e.ctrlKey) && this.props.multiSelectable) {
	      var idx = selectedRows.indexOf(rowNumber);
	      if (idx < 0) {
	        var foundRange = false;
	        for (var i = 0; i < selectedRows.length; i++) {
	          var range = selectedRows[i];
	          if (typeof range !== 'object') continue;
	
	          if (this._isValueInRange(rowNumber, range)) {
	            var _selectedRows;
	
	            foundRange = true;
	            var values = this._splitRange(range, rowNumber);
	            (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat(_toConsumableArray(values)));
	          }
	        }
	
	        if (!foundRange) selectedRows.push(rowNumber);
	      } else {
	        selectedRows.splice(idx, 1);
	      }
	    } else {
	      if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	        selectedRows = [];
	      } else {
	        selectedRows = [rowNumber];
	      }
	    }
	
	    this.setState({ selectedRows: selectedRows });
	    if (this.props.onRowSelection) this.props.onRowSelection(this._flattenRanges(selectedRows));
	  },
	
	  _splitRange: function _splitRange(range, splitPoint) {
	    var splitValues = [];
	    var startOffset = range.start - splitPoint;
	    var endOffset = range.end - splitPoint;
	
	    // Process start half
	    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, startOffset)));
	
	    // Process end half
	    splitValues.push.apply(splitValues, _toConsumableArray(this._genRangeOfValues(splitPoint, endOffset)));
	
	    return splitValues;
	  },
	
	  _genRangeOfValues: function _genRangeOfValues(start, offset) {
	    var values = [];
	    var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	    while (offset !== 0) {
	      values.push(start + offset);
	      offset += dir;
	    }
	
	    return values;
	  },
	
	  _flattenRanges: function _flattenRanges(selectedRows) {
	    var rows = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = selectedRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var selection = _step.value;
	
	        if (typeof selection === 'object') {
	          var values = this._genRangeOfValues(selection.end, selection.start - selection.end);
	          rows.push.apply(rows, [selection.end].concat(_toConsumableArray(values)));
	        } else {
	          rows.push(selection);
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    return rows.sort();
	  },
	
	  _onCellClick: function _onCellClick(e, rowNumber, columnNumber) {
	    e.stopPropagation();
	    if (this.props.onCellClick) this.props.onCellClick(rowNumber, this._getColumnId(columnNumber));
	  },
	
	  _onCellHover: function _onCellHover(e, rowNumber, columnNumber) {
	    if (this.props.onCellHover) this.props.onCellHover(rowNumber, this._getColumnId(columnNumber));
	    this._onRowHover(e, rowNumber);
	  },
	
	  _onCellHoverExit: function _onCellHoverExit(e, rowNumber, columnNumber) {
	    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, this._getColumnId(columnNumber));
	    this._onRowHoverExit(e, rowNumber);
	  },
	
	  _onRowHover: function _onRowHover(e, rowNumber) {
	    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
	  },
	
	  _onRowHoverExit: function _onRowHoverExit(e, rowNumber) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
	  },
	
	  _getColumnId: function _getColumnId(columnNumber) {
	    var columnId = columnNumber;
	    if (this.props.displayRowCheckbox) columnId--;
	
	    return columnId;
	  }
	
	});
	
	module.exports = TableBody;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var TableRowColumn = __webpack_require__(364);
	var StylePropable = __webpack_require__(6);
	
	var TableFooter = React.createClass({
	  displayName: 'TableFooter',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    adjustForCheckbox: React.PropTypes.bool,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      adjustForCheckbox: true
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.tableFooter;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      cell: {
	        borderTop: '1px solid ' + this.getTheme().borderColor,
	        verticalAlign: 'bottom',
	        padding: 20,
	        textAlign: 'left',
	        whiteSpace: 'nowrap'
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var other = _objectWithoutProperties(_props, ['className']);
	
	    var classes = 'mui-table-footer';
	    if (className) classes += ' ' + className;
	
	    var footerRows = this._createRows();
	
	    return React.createElement(
	      'tfoot',
	      _extends({ className: classes }, other),
	      footerRows
	    );
	  },
	
	  _createRows: function _createRows() {
	    var _this = this;
	
	    var rowNumber = 0;
	    return React.Children.map(this.props.children, function (child) {
	      return _this._createRow(child, rowNumber++);
	    });
	  },
	
	  _createRow: function _createRow(child, rowNumber) {
	    var styles = this.getStyles();
	    var props = {
	      className: 'mui-table-footer-row',
	      displayBorder: false,
	      key: 'f-' + rowNumber,
	      rowNumber: rowNumber,
	      style: this.mergeAndPrefix(styles.cell, child.props.style)
	    };
	
	    var children = [this._getCheckboxPlaceholder(props)];
	    React.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return React.cloneElement(child, props, children);
	  },
	
	  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
	    if (!this.props.adjustForCheckbox) return null;
	
	    var key = 'fpcb' + props.rowNumber;
	    return React.createElement(TableRowColumn, { key: key, style: { width: 24 } });
	  }
	
	});
	
	module.exports = TableFooter;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var Checkbox = __webpack_require__(358);
	var StylePropable = __webpack_require__(6);
	var TableHeaderColumn = __webpack_require__(533);
	
	var TableHeader = React.createClass({
	  displayName: 'TableHeader',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    adjustForCheckbox: React.PropTypes.bool,
	    displaySelectAll: React.PropTypes.bool,
	    enableSelectAll: React.PropTypes.bool,
	    onSelectAll: React.PropTypes.func,
	    selectAllSelected: React.PropTypes.bool,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      adjustForCheckbox: true,
	      displaySelectAll: true,
	      enableSelectAll: true,
	      selectAllSelected: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.tableHeader;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        borderBottom: '1px solid ' + this.getTheme().borderColor
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'style']);
	
	    var classes = 'mui-table-header';
	    if (className) classes += ' ' + className;
	
	    var superHeaderRows = this._createSuperHeaderRows();
	    var baseHeaderRow = this._createBaseHeaderRow();
	
	    return React.createElement(
	      'thead',
	      { className: classes, style: this.mergeAndPrefix(this.getStyles().root, style) },
	      superHeaderRows,
	      baseHeaderRow
	    );
	  },
	
	  _createSuperHeaderRows: function _createSuperHeaderRows() {
	    var numChildren = React.Children.count(this.props.children);
	    if (numChildren === 1) return undefined;
	
	    var superHeaders = [];
	    for (var index = 0; index < numChildren - 1; index++) {
	      var child = this.props.children[index];
	
	      if (!React.isValidElement(child)) continue;
	
	      var props = {
	        className: 'mui-table-super-header-row',
	        displayRowCheckbox: false,
	        key: 'sh' + index,
	        rowNumber: index
	      };
	      superHeaders.push(this._createSuperHeaderRow(child, props));
	    }
	
	    if (superHeaders.length) return superHeaders;
	  },
	
	  _createSuperHeaderRow: function _createSuperHeaderRow(child, props) {
	    var children = [];
	    if (this.props.adjustForCheckbox) {
	      children.push(this._getCheckboxPlaceholder(props));
	    }
	    React.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return React.cloneElement(child, props, children);
	  },
	
	  _createBaseHeaderRow: function _createBaseHeaderRow() {
	    var numChildren = React.Children.count(this.props.children);
	    var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	    var props = {
	      className: 'mui-table-header-row',
	      key: 'h' + numChildren,
	      rowNumber: numChildren
	    };
	
	    var children = [this._getSelectAllCheckboxColumn(props)];
	    React.Children.forEach(child.props.children, function (child) {
	      children.push(child);
	    });
	
	    return React.cloneElement(child, props, children);
	  },
	
	  _getCheckboxPlaceholder: function _getCheckboxPlaceholder(props) {
	    if (!this.props.adjustForCheckbox) return null;
	
	    var key = 'hpcb' + props.rowNumber;
	    return React.createElement(TableHeaderColumn, { key: key, style: { width: 24 } });
	  },
	
	  _getSelectAllCheckboxColumn: function _getSelectAllCheckboxColumn(props) {
	    if (!this.props.displaySelectAll) return this._getCheckboxPlaceholder(props);
	
	    var checkbox = React.createElement(Checkbox, {
	      key: 'selectallcb',
	      name: 'selectallcb',
	      value: 'selected',
	      disabled: !this.props.enableSelectAll,
	      checked: this.props.selectAllSelected,
	      onCheck: this._onSelectAll });
	
	    return React.createElement(
	      TableHeaderColumn,
	      { style: { width: 24 } },
	      checkbox
	    );
	  },
	
	  _onSelectAll: function _onSelectAll(e, checked) {
	    if (this.props.onSelectAll) this.props.onSelectAll(checked);
	  }
	
	});
	
	module.exports = TableHeader;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var TableRow = React.createClass({
	  displayName: 'TableRow',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    displayBorder: React.PropTypes.bool,
	    hoverable: React.PropTypes.bool,
	    onCellClick: React.PropTypes.func,
	    onCellHover: React.PropTypes.func,
	    onCellHoverExit: React.PropTypes.func,
	    onRowClick: React.PropTypes.func,
	    onRowHover: React.PropTypes.func,
	    onRowHoverExit: React.PropTypes.func,
	    rowNumber: React.PropTypes.number,
	    selectable: React.PropTypes.bool,
	    selected: React.PropTypes.bool,
	    striped: React.PropTypes.bool,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      displayBorder: true,
	      displayRowCheckbox: true,
	      hoverable: false,
	      selectable: true,
	      selected: false,
	      striped: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      hovered: false
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.tableRow;
	  },
	
	  getStyles: function getStyles() {
	    var theme = this.getTheme();
	    var cellBgColor = 'inherit';
	    if (this.state.hovered) {
	      cellBgColor = theme.hoverColor;
	    } else if (this.props.selected) {
	      cellBgColor = theme.selectedColor;
	    } else if (this.props.striped) {
	      cellBgColor = theme.stripeColor;
	    }
	
	    var styles = {
	      root: {
	        borderBottom: '1px solid ' + this.getTheme().borderColor,
	        color: this.getTheme().textColor
	      },
	      cell: {
	        backgroundColor: cellBgColor
	      }
	    };
	
	    if (!this.props.displayBorder) {
	      styles.root.borderBottom = '';
	    }
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	    var displayBorder = _props.displayBorder;
	    var hoverable = _props.hoverable;
	    var onCellClick = _props.onCellClick;
	    var onCellHover = _props.onCellHover;
	    var onCellHoverExit = _props.onCellHoverExit;
	    var onRowClick = _props.onRowClick;
	    var onRowHover = _props.onRowHover;
	    var onRowHoverExit = _props.onRowHoverExit;
	    var rowNumber = _props.rowNumber;
	    var selectable = _props.selectable;
	    var selected = _props.selected;
	    var striped = _props.striped;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['className', 'displayBorder', 'hoverable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	
	    var classes = 'mui-table-row';
	    if (className) classes += ' ' + className;
	    var rowColumns = this._createColumns();
	
	    return React.createElement(
	      'tr',
	      _extends({
	        className: classes,
	        style: this.mergeAndPrefix(this.getStyles().root, style)
	      }, other),
	      rowColumns
	    );
	  },
	
	  _createColumns: function _createColumns() {
	    var _this = this;
	
	    var columnNumber = 1;
	    return React.Children.map(this.props.children, function (child) {
	      if (React.isValidElement(child)) {
	        return _this._createColumn(child, columnNumber++);
	      }
	    });
	  },
	
	  _createColumn: function _createColumn(child, columnNumber) {
	    var key = this.props.rowNumber + '-' + columnNumber;
	    var styles = this.getStyles();
	    var handlers = {
	      onClick: this._onCellClick,
	      onHover: this._onCellHover,
	      onHoverExit: this._onCellHoverExit
	    };
	
	    return React.cloneElement(child, _extends({
	      columnNumber: columnNumber,
	      hoverable: this.props.hoverable,
	      key: child.props.key || key,
	      style: this.mergeAndPrefix(styles.cell, child.props.style)
	    }, handlers));
	  },
	
	  _onRowClick: function _onRowClick(e) {
	    if (this.props.onRowClick) this.props.onRowClick(e, this.props.rowNumber);
	  },
	
	  _onRowHover: function _onRowHover(e) {
	    if (this.props.onRowHover) this.props.onRowHover(e, this.props.rowNumber);
	  },
	
	  _onRowHoverExit: function _onRowHoverExit(e) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(e, this.props.rowNumber);
	  },
	
	  _onCellClick: function _onCellClick(e, columnIndex) {
	    if (this.props.selectable && this.props.onCellClick) this.props.onCellClick(e, this.props.rowNumber, columnIndex);
	    e.ctrlKey = true;
	    this._onRowClick(e);
	  },
	
	  _onCellHover: function _onCellHover(e, columnIndex) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: true });
	      if (this.props.onCellHover) this.props.onCellHover(e, this.props.rowNumber, columnIndex);
	      this._onRowHover(e);
	    }
	  },
	
	  _onCellHoverExit: function _onCellHoverExit(e, columnIndex) {
	    if (this.props.hoverable) {
	      this.setState({ hovered: false });
	      if (this.props.onCellHoverExit) this.props.onCellHoverExit(e, this.props.rowNumber, columnIndex);
	      this._onRowHoverExit(e);
	    }
	  }
	
	});
	
	module.exports = TableRow;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var Table = React.createClass({
	  displayName: 'Table',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    allRowsSelected: React.PropTypes.bool,
	    fixedFooter: React.PropTypes.bool,
	    fixedHeader: React.PropTypes.bool,
	    height: React.PropTypes.string,
	    multiSelectable: React.PropTypes.bool,
	    onCellClick: React.PropTypes.func,
	    onCellHover: React.PropTypes.func,
	    onCellHoverExit: React.PropTypes.func,
	    onRowHover: React.PropTypes.func,
	    onRowHoverExit: React.PropTypes.func,
	    onRowSelection: React.PropTypes.func,
	    selectable: React.PropTypes.bool,
	    style: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      allRowsSelected: false,
	      fixedFooter: true,
	      fixedHeader: true,
	      height: 'inherit',
	      multiSelectable: false,
	      selectable: true
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      allRowsSelected: this.props.allRowsSelected
	    };
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.table;
	  },
	
	  getStyles: function getStyles() {
	    var styles = {
	      root: {
	        backgroundColor: this.getTheme().backgroundColor,
	        padding: '0 ' + this.context.muiTheme.spacing.desktopGutter + 'px',
	        width: '100%',
	        borderCollapse: 'collapse',
	        borderSpacing: 0,
	        tableLayout: 'fixed'
	      },
	      bodyTable: {
	        height: this.props.fixedHeader || this.props.fixedFooter ? this.props.height : 'auto',
	        overflowX: 'hidden',
	        overflowY: 'auto'
	      },
	      tableWrapper: {
	        height: this.props.fixedHeader || this.props.fixedFooter ? 'auto' : this.props.height,
	        overflow: 'auto'
	      }
	    };
	
	    return styles;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var className = _props.className;
	    var fixedFooter = _props.fixedFooter;
	    var fixedHeader = _props.fixedHeader;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'className', 'fixedFooter', 'fixedHeader', 'style']);
	
	    var classes = 'mui-table';
	    if (className) classes += ' ' + className;
	    var styles = this.getStyles();
	
	    var tHead = undefined,
	        tFoot = undefined,
	        tBody = undefined;
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var child = _step.value;
	
	        if (!React.isValidElement(child)) continue;
	
	        var displayName = child.type.displayName;
	        if (displayName === 'TableBody') {
	          tBody = this._createTableBody(child);
	        } else if (displayName === 'TableHeader') {
	          tHead = this._createTableHeader(child);
	        } else if (displayName === 'TableFooter') {
	          tFoot = this._createTableFooter(child);
	        }
	      }
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (!tBody && !tHead) return null;
	
	    var mergedTableStyle = this.mergeAndPrefix(styles.root, style);
	    var headerTable = undefined,
	        footerTable = undefined;
	    var inlineHeader = undefined,
	        inlineFooter = undefined;
	    if (fixedHeader) {
	      headerTable = React.createElement(
	        'div',
	        { className: 'mui-header-table' },
	        React.createElement(
	          'table',
	          { className: className, style: mergedTableStyle },
	          tHead
	        )
	      );
	    } else {
	      inlineHeader = tHead;
	    }
	    if (tFoot !== undefined) {
	      if (fixedFooter) {
	        footerTable = React.createElement(
	          'div',
	          { className: 'mui-footer-table' },
	          React.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tFoot
	          )
	        );
	      } else {
	        inlineFooter = tFoot;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { className: 'mui-table-wrapper', style: styles.tableWrapper },
	      headerTable,
	      React.createElement(
	        'div',
	        { className: 'mui-body-table', style: styles.bodyTable },
	        React.createElement(
	          'table',
	          { className: classes, style: mergedTableStyle },
	          inlineHeader,
	          inlineFooter,
	          tBody
	        )
	      ),
	      footerTable
	    );
	  },
	
	  _createTableHeader: function _createTableHeader(base) {
	    return React.cloneElement(base, {
	      enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	      onSelectAll: this._onSelectAll,
	      selectAllSelected: this.state.allRowsSelected
	    });
	  },
	
	  _createTableBody: function _createTableBody(base) {
	    return React.cloneElement(base, {
	      allRowsSelected: this.state.allRowsSelected,
	      multiSelectable: this.props.multiSelectable,
	      onCellClick: this._onCellClick,
	      onCellHover: this._onCellHover,
	      onCellHoverExit: this._onCellHoverExit,
	      onRowHover: this._onRowHover,
	      onRowHoverExit: this._onRowHoverExit,
	      onRowSelection: this._onRowSelection,
	      selectable: this.props.selectable,
	      style: this.mergeAndPrefix({ height: this.props.height }, base.props.style)
	    });
	  },
	
	  _createTableFooter: function _createTableFooter(base) {
	    return base;
	  },
	
	  _onCellClick: function _onCellClick(rowNumber, columnNumber) {
	    if (this.props.onCellClick) this.props.onCellClick(rowNumber, columnNumber);
	  },
	
	  _onCellHover: function _onCellHover(rowNumber, columnNumber) {
	    if (this.props.onCellHover) this.props.onCellHover(rowNumber, columnNumber);
	  },
	
	  _onCellHoverExit: function _onCellHoverExit(rowNumber, columnNumber) {
	    if (this.props.onCellHoverExit) this.props.onCellHoverExit(rowNumber, columnNumber);
	  },
	
	  _onRowHover: function _onRowHover(rowNumber) {
	    if (this.props.onRowHover) this.props.onRowHover(rowNumber);
	  },
	
	  _onRowHoverExit: function _onRowHoverExit(rowNumber) {
	    if (this.props.onRowHoverExit) this.props.onRowHoverExit(rowNumber);
	  },
	
	  _onRowSelection: function _onRowSelection(selectedRows) {
	    if (this.state.allRowsSelected) this.setState({ allRowsSelected: false });
	    if (this.props.onRowSelection) this.props.onRowSelection(selectedRows);
	  },
	
	  _onSelectAll: function _onSelectAll() {
	    if (this.props.onRowSelection && !this.state.allRowsSelected) this.props.onRowSelection('all');
	    this.setState({ allRowsSelected: !this.state.allRowsSelected });
	  }
	
	});
	
	module.exports = Table;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var Tab = React.createClass({
	  displayName: 'Tab',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    onTouchTap: React.PropTypes.func,
	    label: React.PropTypes.string,
	    onActive: React.PropTypes.func,
	    selected: React.PropTypes.bool,
	    width: React.PropTypes.string,
	    value: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onActive: function onActive() {},
	      onTouchTap: function onTouchTap() {}
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var label = _props.label;
	    var onActive = _props.onActive;
	    var onTouchTap = _props.onTouchTap;
	    var selected = _props.selected;
	    var style = _props.style;
	    var value = _props.value;
	    var width = _props.width;
	
	    var other = _objectWithoutProperties(_props, ['label', 'onActive', 'onTouchTap', 'selected', 'style', 'value', 'width']);
	
	    var styles = this.mergeAndPrefix({
	      display: 'table-cell',
	      cursor: 'pointer',
	      textAlign: 'center',
	      verticalAlign: 'middle',
	      height: 48,
	      color: selected ? 'rgba(255,255,255,1)' : 'rgba(255,255,255,0.6)',
	      outline: 'none',
	      fontSize: 14,
	      fontWeight: 500,
	      whiteSpace: 'initial',
	      fontFamily: this.context.muiTheme.contentFontFamily,
	      boxSizing: 'border-box',
	      width: width
	    }, style);
	
	    return React.createElement(
	      'div',
	      _extends({}, other, {
	        style: styles,
	        onTouchTap: this._handleTouchTap }),
	      label
	    );
	  },
	
	  _handleTouchTap: function _handleTouchTap(e) {
	    this.props.onTouchTap(this.props.value, e, this);
	  }
	
	});
	
	module.exports = Tab;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	
	var TabTemplate = React.createClass({
	  displayName: 'TabTemplate',
	
	  render: function render() {
	    var styles = {
	      'height': 0,
	      'overflow': 'hidden',
	      'width': '100%',
	      'position': 'relative',
	      'textAlign': 'initial'
	    };
	
	    if (this.props.selected) {
	      delete styles.height;
	      delete styles.overflow;
	    }
	
	    return React.createElement(
	      'div',
	      { style: styles },
	      this.props.children
	    );
	  }
	});
	
	module.exports = TabTemplate;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var TabTemplate = __webpack_require__(1168);
	var InkBar = __webpack_require__(1136);
	var StylePropable = __webpack_require__(6);
	var Controllable = __webpack_require__(524);
	
	var Tabs = React.createClass({
	  displayName: 'Tabs',
	
	  mixins: [StylePropable, Controllable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    contentContainerStyle: React.PropTypes.object,
	    initialSelectedIndex: React.PropTypes.number,
	    inkBarStyle: React.PropTypes.object,
	    tabItemContainerStyle: React.PropTypes.object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialSelectedIndex: 0
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var valueLink = this.getValueLink(this.props);
	    var initialIndex = this.props.initialSelectedIndex;
	
	    return {
	      selectedIndex: valueLink.value ? this._getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	    };
	  },
	
	  getEvenWidth: function getEvenWidth() {
	    return parseInt(window.getComputedStyle(React.findDOMNode(this)).getPropertyValue('width'), 10);
	  },
	
	  getTabCount: function getTabCount() {
	    return React.Children.count(this.props.children);
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	    var valueLink = this.getValueLink(newProps);
	
	    if (valueLink.value) {
	      this.setState({ selectedIndex: this._getSelectedIndex(newProps) });
	    }
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props;
	    var children = _props.children;
	    var contentContainerStyle = _props.contentContainerStyle;
	    var initialSelectedIndex = _props.initialSelectedIndex;
	    var inkBarStyle = _props.inkBarStyle;
	    var style = _props.style;
	    var tabWidth = _props.tabWidth;
	    var tabItemContainerStyle = _props.tabItemContainerStyle;
	
	    var other = _objectWithoutProperties(_props, ['children', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'style', 'tabWidth', 'tabItemContainerStyle']);
	
	    var themeVariables = this.context.muiTheme.component.tabs;
	    var styles = {
	      tabItemContainer: {
	        margin: 0,
	        padding: 0,
	        width: '100%',
	        height: 48,
	        backgroundColor: themeVariables.backgroundColor,
	        whiteSpace: 'nowrap',
	        display: 'table'
	      }
	    };
	
	    var valueLink = this.getValueLink(this.props);
	    var tabValue = valueLink.value;
	    var tabContent = [];
	
	    var width = 100 / this.getTabCount() + '%';
	
	    var left = 'calc(' + width + '*' + this.state.selectedIndex + ')';
	
	    var tabs = React.Children.map(children, function (tab, index) {
	      if (tab.type.displayName === "Tab") {
	        if (!tab.props.value && tabValue && ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV !== 'production') {
	          console.error('Tabs value prop has been passed, but Tab ' + index + ' does not have a value prop. Needs value if Tabs is going' + ' to be a controlled component.');
	        }
	
	        tabContent.push(tab.props.children ? React.createElement(TabTemplate, {
	          key: index,
	          selected: _this._getSelected(tab, index)
	        }, tab.props.children) : undefined);
	
	        return React.cloneElement(tab, {
	          key: index,
	          selected: _this._getSelected(tab, index),
	          tabIndex: index,
	          width: width,
	          onTouchTap: _this._handleTabTouchTap
	        });
	      } else {
	        var type = tab.type.displayName || tab.type;
	        console.error('Tabs only accepts Tab Components as children. Found ' + type + ' as child number ' + (index + 1) + ' of Tabs');
	      }
	    }, this);
	
	    var inkBar = this.state.selectedIndex !== -1 ? React.createElement(InkBar, {
	      left: left,
	      width: width,
	      style: inkBarStyle }) : null;
	
	    var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	    return React.createElement(
	      'div',
	      _extends({}, other, {
	        style: this.mergeAndPrefix(style) }),
	      React.createElement(
	        'div',
	        { style: this.mergeAndPrefix(styles.tabItemContainer, tabItemContainerStyle) },
	        tabs
	      ),
	      React.createElement(
	        'div',
	        { style: { width: inkBarContainerWidth } },
	        inkBar
	      ),
	      React.createElement(
	        'div',
	        { style: this.mergeAndPrefix(contentContainerStyle) },
	        tabContent
	      )
	    );
	  },
	
	  _getSelectedIndex: function _getSelectedIndex(props) {
	    var valueLink = this.getValueLink(props);
	    var selectedIndex = -1;
	
	    React.Children.forEach(props.children, function (tab, index) {
	      if (valueLink.value === tab.props.value) {
	        selectedIndex = index;
	      }
	    });
	
	    return selectedIndex;
	  },
	
	  _handleTabTouchTap: function _handleTabTouchTap(value, e, tab) {
	    var valueLink = this.getValueLink(this.props);
	    var tabIndex = tab.props.tabIndex;
	
	    if (valueLink.value && valueLink.value !== value || this.state.selectedIndex !== tabIndex) {
	      valueLink.requestChange(value, e, tab);
	    }
	
	    this.setState({ selectedIndex: tabIndex });
	    tab.props.onActive(tab);
	  },
	
	  _getSelected: function _getSelected(tab, index) {
	    var valueLink = this.getValueLink(this.props);
	    return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	  }
	
	});
	
	module.exports = Tabs;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var ThemeManager = __webpack_require__(528);
	
	var Theme = React.createClass({
	  displayName: 'Theme',
	
	  propTypes: {
	    theme: React.PropTypes.object
	  },
	
	  childContextTypes: {
	    muiTheme: React.PropTypes.object.isRequired,
	    muiThemeManager: React.PropTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      muiTheme: this.themeManager.getCurrentTheme(),
	      muiThemeManager: this.themeManager
	    };
	  },
	
	  componentWillMount: function componentWillMount() {
	    this.themeManager = new ThemeManager();
	
	    if (this.props.theme) {
	      this.themeManager.setTheme(this.props.theme);
	    }
	  },
	
	  render: function render() {
	    return this.props.children({
	      muiTheme: this.themeManager.getCurrentTheme(),
	      muiThemeManager: this.themeManager
	    });
	  }
	});
	
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	}
	
	function theme(customTheme) {
	  return function (Component) {
	    return React.createClass({
	
	      displayName: 'Theme(' + getDisplayName(Component) + ')',
	
	      render: function render() {
	        return React.createElement(
	          Theme,
	          { theme: customTheme },
	          (function (props) {
	            return React.createElement(Component, _extends({}, this.props, props));
	          }).bind(this)
	        );
	      }
	    });
	  };
	}
	
	module.exports = Theme;
	module.exports.theme = theme;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var EnhancedButton = __webpack_require__(88);
	var Transitions = __webpack_require__(24);
	
	var ClockButton = React.createClass({
	  displayName: 'ClockButton',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    position: React.PropTypes.oneOf(['left', 'right'])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      position: "left"
	    };
	  },
	
	  _handleTouchTap: function _handleTouchTap() {
	    this.setState({
	      selected: true
	    });
	    this.props.onTouchTap();
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.timePicker;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var className = _props.className;
	
	    var other = _objectWithoutProperties(_props, ['className']);
	
	    var styles = {
	      root: {
	        position: "absolute",
	        bottom: 65,
	        pointerEvents: "auto",
	        height: 50,
	        width: 50,
	        borderRadius: "100%"
	      },
	
	      label: {
	        position: "absolute",
	        top: 17,
	        left: 14
	      },
	
	      select: {
	        position: 'absolute',
	        height: 50,
	        width: 50,
	        top: 0,
	        left: 0,
	        opacity: 0,
	        borderRadius: '50%',
	        transform: 'scale(0)',
	        transition: Transitions.easeOut(),
	        backgroundColor: this.getTheme().accentColor
	      }
	    };
	
	    if (this.props.selected) {
	      styles.label.color = this.getTheme().selectTextColor;
	      styles.select.opacity = 1;
	      styles.select.transform = 'scale(1)';
	    }
	
	    if (this.props.position === "right") {
	      styles.root.right = "5px";
	    } else {
	      styles.root.left = "5px";
	    }
	
	    return React.createElement(
	      EnhancedButton,
	      _extends({}, other, {
	        style: this.mergeAndPrefix(styles.root),
	        disableFocusRipple: true,
	        disableTouchRipple: true,
	        onTouchTap: this._handleTouchTap }),
	      React.createElement('span', { style: this.mergeAndPrefix(styles.select) }),
	      React.createElement(
	        'span',
	        { style: this.mergeAndPrefix(styles.label) },
	        this.props.children
	      )
	    );
	  }
	});
	
	module.exports = ClockButton;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var ClockNumber = __webpack_require__(534);
	var ClockPointer = __webpack_require__(535);
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(e) {
	  var el = e.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  var offset = {
	    offsetX: e.clientX - boundingRect.left,
	    offsetY: e.clientY - boundingRect.top
	  };
	
	  return offset;
	}
	
	var ClockHours = React.createClass({
	  displayName: 'ClockHours',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    initialHours: React.PropTypes.number,
	    onChange: React.PropTypes.func,
	    format: React.PropTypes.oneOf(['ampm', '24hr'])
	  },
	
	  center: { x: 0, y: 0 },
	  basePoint: { x: 0, y: 0 },
	
	  isMousePressed: function isMousePressed(e) {
	    if (typeof e.buttons === "undefined") {
	      return e.nativeEvent.which;
	    }
	
	    return e.buttons;
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialHours: new Date().getHours(),
	      onChange: function onChange() {},
	      format: 'ampm'
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var clockElement = React.findDOMNode(this.refs.mask);
	
	    this.center = {
	      x: clockElement.offsetWidth / 2,
	      y: clockElement.offsetHeight / 2
	    };
	
	    this.basePoint = {
	      x: this.center.x,
	      y: 0
	    };
	  },
	
	  handleUp: function handleUp(e) {
	    e.preventDefault();
	    this.setClock(e.nativeEvent, true);
	  },
	
	  handleMove: function handleMove(e) {
	    e.preventDefault();
	    if (this.isMousePressed(e) !== 1) return;
	    this.setClock(e.nativeEvent, false);
	  },
	
	  handleTouchMove: function handleTouchMove(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], false);
	  },
	
	  handleTouchEnd: function handleTouchEnd(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], true);
	  },
	
	  setClock: function setClock(e, finish) {
	    if (typeof e.offsetX === 'undefined') {
	      var offset = getTouchEventOffsetValues(e);
	
	      e.offsetX = offset.offsetX;
	      e.offsetY = offset.offsetY;
	    }
	
	    var hours = this.getHours(e.offsetX, e.offsetY);
	
	    this.props.onChange(hours, finish);
	  },
	
	  getHours: function getHours(offsetX, offsetY) {
	    var step = 30;
	    var x = offsetX - this.center.x;
	    var y = offsetY - this.center.y;
	    var cx = this.basePoint.x - this.center.x;
	    var cy = this.basePoint.y - this.center.y;
	
	    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	    var deg = rad2deg(atan);
	    deg = Math.round(deg / step) * step;
	    deg %= 360;
	
	    var value = Math.floor(deg / step) || 0;
	
	    var delta = Math.pow(x, 2) + Math.pow(y, 2);
	    var distance = Math.sqrt(delta);
	
	    value = value || 12;
	    if (this.props.format === "24hr") {
	      if (distance < 90) {
	        value += 12;
	        value %= 24;
	      }
	    } else {
	      value %= 12;
	    }
	
	    return value;
	  },
	
	  _getSelected: function _getSelected() {
	    var hour = this.props.initialHours;
	
	    if (this.props.format === "ampm") {
	      hour %= 12;
	      hour = hour || 12;
	    }
	
	    return hour;
	  },
	
	  _getHourNumbers: function _getHourNumbers() {
	    var _this = this;
	
	    var style = {
	      pointerEvents: "none"
	    };
	    var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	    var hours = [];
	    for (var i = 1; i <= hourSize; i++) {
	      hours.push(i % 24);
	    }
	
	    return hours.map(function (hour) {
	      var isSelected = _this._getSelected() === hour;
	      return React.createElement(ClockNumber, { key: hour, style: style, isSelected: isSelected, type: 'hour',
	        value: hour });
	    });
	  },
	
	  render: function render() {
	    var styles = {
	      root: {
	        height: "100%",
	        width: "100%",
	        borderRadius: "100%",
	        position: "relative",
	        pointerEvents: "none",
	        boxSizing: "border-box"
	      },
	
	      hitMask: {
	        height: "100%",
	        width: "100%",
	        pointerEvents: "auto"
	      }
	    };
	
	    var hours = this._getSelected();
	    var numbers = this._getHourNumbers();
	
	    return React.createElement(
	      'div',
	      { ref: 'clock', style: this.mergeAndPrefix(styles.root) },
	      React.createElement(ClockPointer, { hasSelected: true, value: hours, type: 'hour' }),
	      numbers,
	      React.createElement('div', { ref: 'mask', style: this.mergeAndPrefix(styles.hitMask), onTouchMove: this.handleTouchMove,
	        onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove })
	    );
	  }
	});
	
	module.exports = ClockHours;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var ClockNumber = __webpack_require__(534);
	var ClockPointer = __webpack_require__(535);
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(e) {
	  var el = e.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  var offset = {
	    offsetX: e.clientX - boundingRect.left,
	    offsetY: e.clientY - boundingRect.top
	  };
	
	  return offset;
	}
	
	var ClockMinutes = React.createClass({
	  displayName: 'ClockMinutes',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    initialMinutes: React.PropTypes.number,
	    onChange: React.PropTypes.func
	  },
	
	  center: { x: 0, y: 0 },
	  basePoint: { x: 0, y: 0 },
	
	  isMousePressed: function isMousePressed(e) {
	
	    if (typeof e.buttons === "undefined") {
	      return e.nativeEvent.which;
	    }
	    return e.buttons;
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialMinutes: new Date().getMinutes(),
	      onChange: function onChange() {}
	    };
	  },
	
	  componentDidMount: function componentDidMount() {
	    var clockElement = React.findDOMNode(this.refs.mask);
	
	    this.center = {
	      x: clockElement.offsetWidth / 2,
	      y: clockElement.offsetHeight / 2
	    };
	
	    this.basePoint = {
	      x: this.center.x,
	      y: 0
	    };
	  },
	
	  handleUp: function handleUp(e) {
	    e.preventDefault();
	    this.setClock(e.nativeEvent, true);
	  },
	
	  handleMove: function handleMove(e) {
	    e.preventDefault();
	    if (this.isMousePressed(e) !== 1) return;
	    this.setClock(e.nativeEvent, false);
	  },
	
	  handleTouch: function handleTouch(e) {
	    e.preventDefault();
	    this.setClock(e.changedTouches[0], false);
	  },
	
	  setClock: function setClock(e, finish) {
	    if (typeof e.offsetX === 'undefined') {
	      var offset = getTouchEventOffsetValues(e);
	
	      e.offsetX = offset.offsetX;
	      e.offsetY = offset.offsetY;
	    }
	
	    var minutes = this.getMinutes(e.offsetX, e.offsetY);
	
	    this.props.onChange(minutes, finish);
	  },
	
	  getMinutes: function getMinutes(offsetX, offsetY) {
	    var step = 6;
	    var x = offsetX - this.center.x;
	    var y = offsetY - this.center.y;
	    var cx = this.basePoint.x - this.center.x;
	    var cy = this.basePoint.y - this.center.y;
	
	    var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	    var deg = rad2deg(atan);
	    deg = Math.round(deg / step) * step;
	    deg %= 360;
	
	    var value = Math.floor(deg / step) || 0;
	
	    return value;
	  },
	
	  _getMinuteNumbers: function _getMinuteNumbers() {
	    var minutes = [];
	    for (var i = 0; i < 12; i++) {
	      minutes.push(i * 5);
	    }
	    var selectedMinutes = this.props.initialMinutes;
	    var hasSelected = false;
	
	    var numbers = minutes.map(function (minute) {
	      var isSelected = selectedMinutes === minute;
	      if (isSelected) hasSelected = true;
	      return React.createElement(ClockNumber, { key: minute, isSelected: isSelected, type: 'minute', value: minute });
	    });
	
	    return {
	      numbers: numbers,
	      hasSelected: hasSelected,
	      selected: selectedMinutes
	    };
	  },
	
	  render: function render() {
	    var styles = {
	      root: {
	        height: "100%",
	        width: "100%",
	        borderRadius: "100%",
	        position: "relative",
	        pointerEvents: "none",
	        boxSizing: "border-box"
	      },
	
	      hitMask: {
	        height: "100%",
	        width: "100%",
	        pointerEvents: "auto"
	      }
	    };
	
	    var minutes = this._getMinuteNumbers();
	
	    return React.createElement(
	      'div',
	      { ref: 'clock', style: this.mergeAndPrefix(styles.root) },
	      React.createElement(ClockPointer, { value: minutes.selected, type: 'minute' }),
	      minutes.numbers,
	      React.createElement('div', { ref: 'mask', style: this.mergeAndPrefix(styles.hitMask), hasSelected: minutes.hasSelected,
	        onTouchMove: this.handleTouch, onTouchEnd: this.handleTouch,
	        onMouseUp: this.handleUp, onMouseMove: this.handleMove })
	    );
	  }
	});
	
	module.exports = ClockMinutes;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var TimeDisplay = __webpack_require__(1176);
	var ClockButton = __webpack_require__(1171);
	var ClockHours = __webpack_require__(1172);
	var ClockMinutes = __webpack_require__(1173);
	
	var Clock = React.createClass({
	  displayName: 'Clock',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    initialTime: React.PropTypes.object,
	    mode: React.PropTypes.oneOf(['hour', 'minute']),
	    format: React.PropTypes.oneOf(['ampm', '24hr']),
	    isActive: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      initialTime: new Date()
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.setState({
	      selectedTime: nextProps.initialTime
	    });
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      selectedTime: this.props.initialTime,
	      mode: 'hour'
	    };
	  },
	
	  _setMode: function _setMode(mode) {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.setState({
	        mode: mode
	      });
	    }, 100);
	  },
	
	  _setAffix: function _setAffix(affix) {
	    if (affix === this._getAffix()) return;
	
	    var hours = this.state.selectedTime.getHours();
	
	    if (affix === "am") {
	      this.handleChangeHours(hours - 12, affix);
	      return;
	    }
	
	    this.handleChangeHours(hours + 12, affix);
	  },
	
	  _getAffix: function _getAffix() {
	    if (this.props.format !== "ampm") return "";
	
	    var hours = this.state.selectedTime.getHours();
	    if (hours < 12) {
	      return "am";
	    }
	
	    return "pm";
	  },
	
	  _getButtons: function _getButtons() {
	    var buttons = [];
	    var isAM = this._getIsAM();
	
	    if (this.props.format === 'ampm') {
	      buttons = [React.createElement(
	        ClockButton,
	        { position: 'left', onTouchTap: this._setAffix.bind(this, "am"), selected: isAM },
	        "AM"
	      ), React.createElement(
	        ClockButton,
	        { position: 'right', onTouchTap: this._setAffix.bind(this, "pm"), selected: !isAM },
	        "PM"
	      )];
	    }
	    return buttons;
	  },
	
	  _getIsAM: function _getIsAM() {
	    return this._getAffix() === "am";
	  },
	
	  render: function render() {
	    var clock = null;
	    var buttons = this._getButtons();
	
	    var styles = {
	      root: {},
	
	      container: {
	        height: 280,
	        padding: 10
	      }
	    };
	
	    if (this.state.mode === "hour") {
	      clock = React.createElement(ClockHours, { key: 'hours',
	        format: this.props.format,
	        onChange: this.handleChangeHours,
	        initialHours: this.state.selectedTime.getHours() });
	    } else {
	      clock = React.createElement(ClockMinutes, { key: 'minutes',
	        onChange: this.handleChangeMinutes,
	        initialMinutes: this.state.selectedTime.getMinutes() });
	    }
	
	    return React.createElement(
	      'div',
	      { style: styles.root },
	      React.createElement(TimeDisplay, {
	        selectedTime: this.state.selectedTime,
	        mode: this.state.mode,
	        format: this.props.format,
	        affix: this._getAffix(),
	        onSelectHour: this._setMode.bind(this, 'hour'),
	        onSelectMin: this._setMode.bind(this, 'minute') }),
	      React.createElement(
	        'div',
	        { style: styles.container },
	        clock
	      ),
	      buttons
	    );
	  },
	
	  handleChangeHours: function handleChangeHours(hours, finished) {
	    var _this2 = this;
	
	    var time = new Date(this.state.selectedTime);
	    var affix = undefined;
	
	    if (typeof finished === 'string') {
	      affix = finished;
	      finished = undefined;
	    }
	    if (!affix) {
	      affix = this._getAffix();
	    }
	    if (affix === 'pm' && hours < 12) {
	      hours += 12;
	    }
	
	    time.setHours(hours);
	    this.setState({
	      selectedTime: time
	    });
	
	    if (finished) {
	      setTimeout(function () {
	        _this2.setState({
	          mode: 'minute'
	        });
	      }, 100);
	    }
	  },
	
	  handleChangeMinutes: function handleChangeMinutes(minutes) {
	    var time = new Date(this.state.selectedTime);
	    time.setMinutes(minutes);
	    this.setState({
	      selectedTime: time
	    });
	  },
	
	  getSelectedTime: function getSelectedTime() {
	    return this.state.selectedTime;
	  }
	});
	
	module.exports = Clock;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1178);

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var TimeDisplay = React.createClass({
	  displayName: 'TimeDisplay',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    selectedTime: React.PropTypes.object.isRequired,
	    format: React.PropTypes.oneOf(['ampm', '24hr']),
	    mode: React.PropTypes.oneOf(['hour', 'minute']),
	    affix: React.PropTypes.oneOf(['', 'pm', 'am'])
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      transitionDirection: 'up'
	    };
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      mode: 'hour',
	      affix: ''
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var direction = undefined;
	
	    if (nextProps.selectedTime !== this.props.selectedTime) {
	      direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	      this.setState({
	        transitionDirection: direction
	      });
	    }
	  },
	
	  sanitizeTime: function sanitizeTime() {
	    var hour = this.props.selectedTime.getHours();
	    var min = this.props.selectedTime.getMinutes().toString();
	
	    if (this.props.format === "ampm") {
	      hour %= 12;
	      hour = hour || 12;
	    }
	
	    hour = hour.toString();
	    if (hour.length < 2) hour = "0" + hour;
	    if (min.length < 2) min = "0" + min;
	
	    return [hour, min];
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.timePicker;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var selectedTime = _props.selectedTime;
	    var mode = _props.mode;
	
	    var other = _objectWithoutProperties(_props, ['selectedTime', 'mode']);
	
	    var styles = {
	      root: {
	        textAlign: "center",
	        position: "relative",
	        width: 280,
	        height: "100%"
	      },
	
	      time: {
	        margin: "6px 0",
	        lineHeight: "58px",
	        height: 58,
	        fontSize: "58px"
	      },
	
	      box: {
	        padding: "16px 0",
	        backgroundColor: this.getTheme().color,
	        color: this.getTheme().textColor
	      },
	
	      hour: {},
	
	      minute: {}
	    };
	
	    var _sanitizeTime = this.sanitizeTime();
	
	    var _sanitizeTime2 = _slicedToArray(_sanitizeTime, 2);
	
	    var hour = _sanitizeTime2[0];
	    var min = _sanitizeTime2[1];
	
	    styles[mode].color = this.getTheme().accentColor;
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: this.mergeAndPrefix(styles.root) }),
	      React.createElement(
	        'div',
	        { style: this.mergeAndPrefix(styles.box) },
	        React.createElement(
	          'div',
	          { style: this.mergeAndPrefix(styles.time) },
	          React.createElement(
	            'span',
	            { style: this.mergeAndPrefix(styles.hour), onTouchTap: this.props.onSelectHour },
	            hour
	          ),
	          React.createElement(
	            'span',
	            null,
	            ':'
	          ),
	          React.createElement(
	            'span',
	            { style: this.mergeAndPrefix(styles.minute), onTouchTap: this.props.onSelectMin },
	            min
	          )
	        ),
	        React.createElement(
	          'span',
	          { key: "affix" },
	          this.props.affix.toUpperCase()
	        )
	      )
	    );
	  }
	
	});
	
	module.exports = TimeDisplay;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var WindowListenable = __webpack_require__(89);
	var KeyCode = __webpack_require__(73);
	var Clock = __webpack_require__(1174);
	var Dialog = __webpack_require__(359);
	var FlatButton = __webpack_require__(167);
	
	var TimePickerDialog = React.createClass({
	  displayName: 'TimePickerDialog',
	
	  mixins: [StylePropable, WindowListenable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    initialTime: React.PropTypes.object,
	    onAccept: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    onDismiss: React.PropTypes.func
	  },
	
	  windowListeners: {
	    keyup: '_handleWindowKeyUp'
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.timePicker;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var initialTime = _props.initialTime;
	    var onAccept = _props.onAccept;
	    var format = _props.format;
	
	    var other = _objectWithoutProperties(_props, ['initialTime', 'onAccept', 'format']);
	
	    var styles = {
	      root: {
	        fontSize: 14,
	        color: this.getTheme().clockColor
	      },
	      dialogContent: {
	        width: 280
	      },
	      body: {
	        padding: 0
	      }
	    };
	
	    var actions = [React.createElement(FlatButton, {
	      key: 0,
	      label: 'Cancel',
	      secondary: true,
	      onTouchTap: this._handleCancelTouchTap }), React.createElement(FlatButton, {
	      key: 1,
	      label: 'OK',
	      secondary: true,
	      onTouchTap: this._handleOKTouchTap })];
	
	    return React.createElement(
	      Dialog,
	      _extends({}, other, {
	        ref: 'dialogWindow',
	        style: this.mergeAndPrefix(styles.root),
	        bodyStyle: this.mergeAndPrefix(styles.body),
	        actions: actions,
	        contentStyle: styles.dialogContent,
	        onDismiss: this._handleDialogDismiss,
	        onShow: this._handleDialogShow,
	        repositionOnUpdate: false }),
	      React.createElement(Clock, {
	        ref: 'clock',
	        format: format,
	        initialTime: initialTime })
	    );
	  },
	
	  show: function show() {
	    this.refs.dialogWindow.show();
	  },
	
	  dismiss: function dismiss() {
	    this.refs.dialogWindow.dismiss();
	  },
	
	  _handleCancelTouchTap: function _handleCancelTouchTap() {
	    this.dismiss();
	  },
	
	  _handleOKTouchTap: function _handleOKTouchTap() {
	    this.dismiss();
	    if (this.props.onAccept) {
	      this.props.onAccept(this.refs.clock.getSelectedTime());
	    }
	  },
	
	  _handleDialogShow: function _handleDialogShow() {
	    if (this.props.onShow) {
	      this.props.onShow();
	    }
	  },
	
	  _handleDialogDismiss: function _handleDialogDismiss() {
	    if (this.props.onDismiss) {
	      this.props.onDismiss();
	    }
	  },
	
	  _handleWindowKeyUp: function _handleWindowKeyUp(e) {
	    if (this.refs.dialogWindow.isOpen()) {
	      switch (e.keyCode) {
	        case KeyCode.ENTER:
	          this._handleOKTouchTap();
	          break;
	      }
	    }
	  }
	
	});
	
	module.exports = TimePickerDialog;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	var WindowListenable = __webpack_require__(89);
	var TimePickerDialog = __webpack_require__(1177);
	var TextField = __webpack_require__(212);
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	
	var TimePicker = React.createClass({
	  displayName: 'TimePicker',
	
	  mixins: [StylePropable, WindowListenable],
	
	  propTypes: {
	    defaultTime: React.PropTypes.object,
	    format: React.PropTypes.oneOf(['ampm', '24hr']),
	    pedantic: React.PropTypes.bool,
	    onFocus: React.PropTypes.func,
	    onTouchTap: React.PropTypes.func,
	    onChange: React.PropTypes.func,
	    onShow: React.PropTypes.func,
	    onDismiss: React.PropTypes.func
	  },
	
	  windowListeners: {
	    'keyup': '_handleWindowKeyUp'
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultTime: null,
	      format: 'ampm',
	      pedantic: false
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      time: this.props.defaultTime || emptyTime,
	      dialogTime: new Date()
	    };
	  },
	
	  formatTime: function formatTime(date) {
	    var hours = date.getHours();
	    var mins = date.getMinutes().toString();
	
	    if (this.props.format === "ampm") {
	      var isAM = hours < 12;
	      hours = hours % 12;
	      var additional = isAM ? " am" : " pm";
	      hours = (hours || 12).toString();
	
	      if (mins.length < 2) mins = "0" + mins;
	
	      if (this.props.pedantic) {
	        // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	        if (hours === "12" && mins === "00") {
	          return additional === " pm" ? "12 noon" : "12 midnight";
	        }
	      }
	
	      return hours + (mins === "00" ? "" : ":" + mins) + additional;
	    }
	
	    hours = hours.toString();
	
	    if (hours.length < 2) hours = "0" + hours;
	    if (mins.length < 2) mins = "0" + mins;
	
	    return hours + ":" + mins;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var format = _props.format;
	    var onFocus = _props.onFocus;
	    var onTouchTap = _props.onTouchTap;
	    var onShow = _props.onShow;
	    var onDismiss = _props.onDismiss;
	
	    var other = _objectWithoutProperties(_props, ['format', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss']);
	
	    var defaultInputValue = undefined;
	
	    if (this.props.defaultTime) {
	      defaultInputValue = this.formatTime(this.props.defaultTime);
	    }
	
	    return React.createElement(
	      'div',
	      null,
	      React.createElement(TextField, _extends({}, other, {
	        ref: 'input',
	        defaultValue: defaultInputValue,
	        onFocus: this._handleInputFocus,
	        onTouchTap: this._handleInputTouchTap })),
	      React.createElement(TimePickerDialog, {
	        ref: 'dialogWindow',
	        initialTime: this.state.dialogTime,
	        onAccept: this._handleDialogAccept,
	        onShow: onShow,
	        onDismiss: onDismiss,
	        format: format })
	    );
	  },
	
	  getTime: function getTime() {
	    return this.state.time;
	  },
	
	  setTime: function setTime(t) {
	    this.setState({
	      time: t
	    });
	    this.refs.input.setValue(this.formatTime(t));
	  },
	
	  _handleDialogAccept: function _handleDialogAccept(t) {
	    this.setTime(t);
	    if (this.props.onChange) this.props.onChange(null, t);
	  },
	
	  _handleInputFocus: function _handleInputFocus(e) {
	    e.target.blur();
	    if (this.props.onFocus) this.props.onFocus(e);
	  },
	
	  _handleInputTouchTap: function _handleInputTouchTap(e) {
	    e.preventDefault();
	
	    this.setState({
	      dialogTime: this.getTime()
	    });
	
	    this.refs.dialogWindow.show();
	    if (this.props.onTouchTap) this.props.onTouchTap(e);
	  }
	});
	
	module.exports = TimePicker;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var ToolbarSeparator = React.createClass({
	  displayName: 'ToolbarSeparator',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.toolbar;
	  },
	
	  getSpacing: function getSpacing() {
	    return this.context.muiTheme.spacing;
	  },
	
	  render: function render() {
	    var styles = this.mergeAndPrefix({
	      backgroundColor: this.getTheme().separatorColor,
	      display: 'inline-block',
	      height: this.getSpacing().desktopGutterMore,
	      marginLeft: this.getSpacing().desktopGutter,
	      position: 'relative',
	      top: (this.getTheme().height - this.getSpacing().desktopGutterMore) / 2,
	      width: 1
	    }, this.props.style);
	
	    return React.createElement('span', { className: this.props.className, style: styles });
	  }
	
	});
	
	module.exports = ToolbarSeparator;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var StylePropable = __webpack_require__(6);
	
	var ToolbarTitle = React.createClass({
	  displayName: 'ToolbarTitle',
	
	  mixins: [StylePropable],
	
	  contextTypes: {
	    muiTheme: React.PropTypes.object
	  },
	
	  propTypes: {
	    text: React.PropTypes.string
	  },
	
	  getTheme: function getTheme() {
	    return this.context.muiTheme.component.toolbar;
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var style = _props.style;
	    var text = _props.text;
	
	    var other = _objectWithoutProperties(_props, ['style', 'text']);
	
	    var styles = this.mergeAndPrefix({
	      paddingRight: this.context.muiTheme.spacing.desktopGutterLess,
	      lineHeight: this.getTheme().height + 'px',
	      fontSize: this.getTheme().titleFontSize + 'px',
	      display: 'inline-block',
	      position: 'relative'
	    }, style);
	
	    return React.createElement(
	      'span',
	      _extends({ style: styles }, other),
	      text
	    );
	  }
	
	});
	
	module.exports = ToolbarTitle;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	
	var ScaleInChild = React.createClass({
	  displayName: 'ScaleInChild',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  propTypes: {
	    enterDelay: React.PropTypes.number,
	    maxScale: React.PropTypes.number,
	    minScale: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0,
	      maxScale: 1,
	      minScale: 0
	    };
	  },
	
	  componentWillAppear: function componentWillAppear(callback) {
	    this._initializeAnimation(callback);
	  },
	
	  componentWillEnter: function componentWillEnter(callback) {
	    this._initializeAnimation(callback);
	  },
	
	  componentDidAppear: function componentDidAppear() {
	    this._animate();
	  },
	
	  componentDidEnter: function componentDidEnter() {
	    this._animate();
	  },
	
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this = this;
	
	    var style = React.findDOMNode(this).style;
	
	    style.opacity = '0';
	    AutoPrefix.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	    setTimeout((function () {
	      if (_this.isMounted()) callback();
	    }).bind(this), 450);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var enterDelay = _props.enterDelay;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'style']);
	
	    var mergedRootStyles = this.mergeAndPrefix({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: 0,
	      transition: Transitions.easeOut(null, ['transform', 'opacity'])
	    }, style);
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: mergedRootStyles }),
	      children
	    );
	  },
	
	  _animate: function _animate() {
	    var style = React.findDOMNode(this).style;
	
	    style.opacity = '1';
	    AutoPrefix.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	  },
	
	  _initializeAnimation: function _initializeAnimation(callback) {
	    var _this2 = this;
	
	    var style = React.findDOMNode(this).style;
	
	    style.opacity = '0';
	    AutoPrefix.set(style, 'transform', 'scale(0)');
	
	    setTimeout((function () {
	      if (_this2.isMounted()) callback();
	    }).bind(this), this.props.enterDelay);
	  }
	
	});
	
	module.exports = ScaleInChild;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var PureRenderMixin = React.addons.PureRenderMixin;
	var ReactTransitionGroup = React.addons.TransitionGroup;
	var StylePropable = __webpack_require__(6);
	var ScaleInChild = __webpack_require__(1181);
	
	var ScaleIn = React.createClass({
	  displayName: 'ScaleIn',
	
	  mixins: [PureRenderMixin, StylePropable],
	
	  propTypes: {
	    childStyle: React.PropTypes.object,
	    enterDelay: React.PropTypes.number,
	    maxScale: React.PropTypes.number,
	    minScale: React.PropTypes.number
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0
	    };
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var childStyle = _props.childStyle;
	    var enterDelay = _props.enterDelay;
	    var maxScale = _props.maxScale;
	    var minScale = _props.minScale;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	    var mergedRootStyles = this.mergeAndPrefix({
	      position: 'relative',
	      overflow: 'hidden',
	      height: '100%'
	    }, style);
	
	    var newChildren = React.Children.map(children, function (child) {
	      return React.createElement(
	        ScaleInChild,
	        {
	          key: child.key,
	          enterDelay: enterDelay,
	          maxScale: maxScale,
	          minScale: minScale,
	          style: childStyle },
	        child
	      );
	    });
	
	    return React.createElement(
	      ReactTransitionGroup,
	      _extends({}, other, {
	        style: mergedRootStyles,
	        component: 'div' }),
	      newChildren
	    );
	  }
	
	});
	
	module.exports = ScaleIn;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(14);
	var StylePropable = __webpack_require__(6);
	var AutoPrefix = __webpack_require__(63);
	var Transitions = __webpack_require__(24);
	
	var SlideInChild = React.createClass({
	  displayName: 'SlideInChild',
	
	  mixins: [StylePropable],
	
	  propTypes: {
	    enterDelay: React.PropTypes.number,
	    //This callback is needed bacause
	    //the direction could change when leaving the dom
	    getLeaveDirection: React.PropTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enterDelay: 0
	    };
	  },
	
	  componentWillEnter: function componentWillEnter(callback) {
	    var _this = this;
	
	    var style = React.findDOMNode(this).style;
	    var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	    var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	    style.opacity = '0';
	    AutoPrefix.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)');
	
	    setTimeout((function () {
	      if (_this.isMounted()) callback();
	    }).bind(this), this.props.enterDelay);
	  },
	
	  componentDidEnter: function componentDidEnter() {
	    var style = React.findDOMNode(this).style;
	    style.opacity = '1';
	    AutoPrefix.set(style, 'transform', 'translate3d(0,0,0)');
	  },
	
	  componentWillLeave: function componentWillLeave(callback) {
	    var _this2 = this;
	
	    var style = React.findDOMNode(this).style;
	    var direction = this.props.getLeaveDirection();
	    var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	    var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	    style.opacity = '0';
	    AutoPrefix.set(style, 'transform', 'translate3d(' + x + ',' + y + ',0)');
	
	    setTimeout((function () {
	      if (_this2.isMounted()) callback();
	    }).bind(this), 450);
	  },
	
	  render: function render() {
	    var _props = this.props;
	    var children = _props.children;
	    var enterDelay = _props.enterDelay;
	    var getLeaveDirection = _props.getLeaveDirection;
	    var style = _props.style;
	
	    var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	
	    var mergedRootStyles = this.mergeAndPrefix({
	      position: 'absolute',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: 0,
	      transition: Transitions.easeOut(null, ['transform', 'opacity'])
	    }, style);
	
	    return React.createElement(
	      'div',
	      _extends({}, other, { style: mergedRootStyles }),
	      children
	    );
	  }
	
	});
	
	module.exports = SlideInChild;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  ColorManipulator: __webpack_require__(102),
	  CssEvent: __webpack_require__(170),
	  Dom: __webpack_require__(367),
	  Events: __webpack_require__(121),
	  Extend: __webpack_require__(368),
	  ImmutabilityHelper: __webpack_require__(147),
	  KeyCode: __webpack_require__(73),
	  KeyLine: __webpack_require__(539),
	  UniqueId: __webpack_require__(370),
	  Styles: __webpack_require__(369)
	};

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	var moment = module.exports = __webpack_require__(1186);
	moment.tz.load(__webpack_require__(826));


/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
	//! version : 0.5.13
	//! Copyright (c) JS Foundation and other contributors
	//! license : MIT
	//! github.com/moment/moment-timezone
	
	(function (root, factory) {
		"use strict";
	
		/*global define*/
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
		} else if (typeof module === 'object' && module.exports) {
			module.exports = factory(require('moment')); // Node
		} else {
			factory(root.moment);                        // Browser
		}
	}(this, function (moment) {
		"use strict";
	
		// Do not load moment-timezone a second time.
		// if (moment.tz !== undefined) {
		// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		// 	return moment;
		// }
	
		var VERSION = "0.5.13",
			zones = {},
			links = {},
			names = {},
			guesses = {},
			cachedGuess,
	
			momentVersion = moment.version.split('.'),
			major = +momentVersion[0],
			minor = +momentVersion[1];
	
		// Moment.js version check
		if (major < 2 || (major === 2 && minor < 6)) {
			logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
		}
	
		/************************************
			Unpacking
		************************************/
	
		function charCodeToInt(charCode) {
			if (charCode > 96) {
				return charCode - 87;
			} else if (charCode > 64) {
				return charCode - 29;
			}
			return charCode - 48;
		}
	
		function unpackBase60(string) {
			var i = 0,
				parts = string.split('.'),
				whole = parts[0],
				fractional = parts[1] || '',
				multiplier = 1,
				num,
				out = 0,
				sign = 1;
	
			// handle negative numbers
			if (string.charCodeAt(0) === 45) {
				i = 1;
				sign = -1;
			}
	
			// handle digits before the decimal
			for (i; i < whole.length; i++) {
				num = charCodeToInt(whole.charCodeAt(i));
				out = 60 * out + num;
			}
	
			// handle digits after the decimal
			for (i = 0; i < fractional.length; i++) {
				multiplier = multiplier / 60;
				num = charCodeToInt(fractional.charCodeAt(i));
				out += num * multiplier;
			}
	
			return out * sign;
		}
	
		function arrayToInt (array) {
			for (var i = 0; i < array.length; i++) {
				array[i] = unpackBase60(array[i]);
			}
		}
	
		function intToUntil (array, length) {
			for (var i = 0; i < length; i++) {
				array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
			}
	
			array[length - 1] = Infinity;
		}
	
		function mapIndices (source, indices) {
			var out = [], i;
	
			for (i = 0; i < indices.length; i++) {
				out[i] = source[indices[i]];
			}
	
			return out;
		}
	
		function unpack (string) {
			var data = string.split('|'),
				offsets = data[2].split(' '),
				indices = data[3].split(''),
				untils  = data[4].split(' ');
	
			arrayToInt(offsets);
			arrayToInt(indices);
			arrayToInt(untils);
	
			intToUntil(untils, indices.length);
	
			return {
				name       : data[0],
				abbrs      : mapIndices(data[1].split(' '), indices),
				offsets    : mapIndices(offsets, indices),
				untils     : untils,
				population : data[5] | 0
			};
		}
	
		/************************************
			Zone object
		************************************/
	
		function Zone (packedString) {
			if (packedString) {
				this._set(unpack(packedString));
			}
		}
	
		Zone.prototype = {
			_set : function (unpacked) {
				this.name       = unpacked.name;
				this.abbrs      = unpacked.abbrs;
				this.untils     = unpacked.untils;
				this.offsets    = unpacked.offsets;
				this.population = unpacked.population;
			},
	
			_index : function (timestamp) {
				var target = +timestamp,
					untils = this.untils,
					i;
	
				for (i = 0; i < untils.length; i++) {
					if (target < untils[i]) {
						return i;
					}
				}
			},
	
			parse : function (timestamp) {
				var target  = +timestamp,
					offsets = this.offsets,
					untils  = this.untils,
					max     = untils.length - 1,
					offset, offsetNext, offsetPrev, i;
	
				for (i = 0; i < max; i++) {
					offset     = offsets[i];
					offsetNext = offsets[i + 1];
					offsetPrev = offsets[i ? i - 1 : i];
	
					if (offset < offsetNext && tz.moveAmbiguousForward) {
						offset = offsetNext;
					} else if (offset > offsetPrev && tz.moveInvalidForward) {
						offset = offsetPrev;
					}
	
					if (target < untils[i] - (offset * 60000)) {
						return offsets[i];
					}
				}
	
				return offsets[max];
			},
	
			abbr : function (mom) {
				return this.abbrs[this._index(mom)];
			},
	
			offset : function (mom) {
				return this.offsets[this._index(mom)];
			}
		};
	
		/************************************
			Current Timezone
		************************************/
	
		function OffsetAt(at) {
			var timeString = at.toTimeString();
			var abbr = timeString.match(/\([a-z ]+\)/i);
			if (abbr && abbr[0]) {
				// 17:56:31 GMT-0600 (CST)
				// 17:56:31 GMT-0600 (Central Standard Time)
				abbr = abbr[0].match(/[A-Z]/g);
				abbr = abbr ? abbr.join('') : undefined;
			} else {
				// 17:56:31 CST
				// 17:56:31 GMT+0800 (台北標準時間)
				abbr = timeString.match(/[A-Z]{3,5}/g);
				abbr = abbr ? abbr[0] : undefined;
			}
	
			if (abbr === 'GMT') {
				abbr = undefined;
			}
	
			this.at = +at;
			this.abbr = abbr;
			this.offset = at.getTimezoneOffset();
		}
	
		function ZoneScore(zone) {
			this.zone = zone;
			this.offsetScore = 0;
			this.abbrScore = 0;
		}
	
		ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
			this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
			if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
				this.abbrScore++;
			}
		};
	
		function findChange(low, high) {
			var mid, diff;
	
			while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
				mid = new OffsetAt(new Date(low.at + diff));
				if (mid.offset === low.offset) {
					low = mid;
				} else {
					high = mid;
				}
			}
	
			return low;
		}
	
		function userOffsets() {
			var startYear = new Date().getFullYear() - 2,
				last = new OffsetAt(new Date(startYear, 0, 1)),
				offsets = [last],
				change, next, i;
	
			for (i = 1; i < 48; i++) {
				next = new OffsetAt(new Date(startYear, i, 1));
				if (next.offset !== last.offset) {
					change = findChange(last, next);
					offsets.push(change);
					offsets.push(new OffsetAt(new Date(change.at + 6e4)));
				}
				last = next;
			}
	
			for (i = 0; i < 4; i++) {
				offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
				offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
			}
	
			return offsets;
		}
	
		function sortZoneScores (a, b) {
			if (a.offsetScore !== b.offsetScore) {
				return a.offsetScore - b.offsetScore;
			}
			if (a.abbrScore !== b.abbrScore) {
				return a.abbrScore - b.abbrScore;
			}
			return b.zone.population - a.zone.population;
		}
	
		function addToGuesses (name, offsets) {
			var i, offset;
			arrayToInt(offsets);
			for (i = 0; i < offsets.length; i++) {
				offset = offsets[i];
				guesses[offset] = guesses[offset] || {};
				guesses[offset][name] = true;
			}
		}
	
		function guessesForUserOffsets (offsets) {
			var offsetsLength = offsets.length,
				filteredGuesses = {},
				out = [],
				i, j, guessesOffset;
	
			for (i = 0; i < offsetsLength; i++) {
				guessesOffset = guesses[offsets[i].offset] || {};
				for (j in guessesOffset) {
					if (guessesOffset.hasOwnProperty(j)) {
						filteredGuesses[j] = true;
					}
				}
			}
	
			for (i in filteredGuesses) {
				if (filteredGuesses.hasOwnProperty(i)) {
					out.push(names[i]);
				}
			}
	
			return out;
		}
	
		function rebuildGuess () {
	
			// use Intl API when available and returning valid time zone
			try {
				var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
				if (intlName){
					var name = names[normalizeName(intlName)];
					if (name) {
						return name;
					}
					logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
				}
			} catch (e) {
				// Intl unavailable, fall back to manual guessing.
			}
	
			var offsets = userOffsets(),
				offsetsLength = offsets.length,
				guesses = guessesForUserOffsets(offsets),
				zoneScores = [],
				zoneScore, i, j;
	
			for (i = 0; i < guesses.length; i++) {
				zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
				for (j = 0; j < offsetsLength; j++) {
					zoneScore.scoreOffsetAt(offsets[j]);
				}
				zoneScores.push(zoneScore);
			}
	
			zoneScores.sort(sortZoneScores);
	
			return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
		}
	
		function guess (ignoreCache) {
			if (!cachedGuess || ignoreCache) {
				cachedGuess = rebuildGuess();
			}
			return cachedGuess;
		}
	
		/************************************
			Global Methods
		************************************/
	
		function normalizeName (name) {
			return (name || '').toLowerCase().replace(/\//g, '_');
		}
	
		function addZone (packed) {
			var i, name, split, normalized;
	
			if (typeof packed === "string") {
				packed = [packed];
			}
	
			for (i = 0; i < packed.length; i++) {
				split = packed[i].split('|');
				name = split[0];
				normalized = normalizeName(name);
				zones[normalized] = packed[i];
				names[normalized] = name;
				if (split[5]) {
					addToGuesses(normalized, split[2].split(' '));
				}
			}
		}
	
		function getZone (name, caller) {
			name = normalizeName(name);
	
			var zone = zones[name];
			var link;
	
			if (zone instanceof Zone) {
				return zone;
			}
	
			if (typeof zone === 'string') {
				zone = new Zone(zone);
				zones[name] = zone;
				return zone;
			}
	
			// Pass getZone to prevent recursion more than 1 level deep
			if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
				zone = zones[name] = new Zone();
				zone._set(link);
				zone.name = names[name];
				return zone;
			}
	
			return null;
		}
	
		function getNames () {
			var i, out = [];
	
			for (i in names) {
				if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
					out.push(names[i]);
				}
			}
	
			return out.sort();
		}
	
		function addLink (aliases) {
			var i, alias, normal0, normal1;
	
			if (typeof aliases === "string") {
				aliases = [aliases];
			}
	
			for (i = 0; i < aliases.length; i++) {
				alias = aliases[i].split('|');
	
				normal0 = normalizeName(alias[0]);
				normal1 = normalizeName(alias[1]);
	
				links[normal0] = normal1;
				names[normal0] = alias[0];
	
				links[normal1] = normal0;
				names[normal1] = alias[1];
			}
		}
	
		function loadData (data) {
			addZone(data.zones);
			addLink(data.links);
			tz.dataVersion = data.version;
		}
	
		function zoneExists (name) {
			if (!zoneExists.didShowError) {
				zoneExists.didShowError = true;
					logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
			}
			return !!getZone(name);
		}
	
		function needsOffset (m) {
			return !!(m._a && (m._tzm === undefined));
		}
	
		function logError (message) {
			if (typeof console !== 'undefined' && typeof console.error === 'function') {
				console.error(message);
			}
		}
	
		/************************************
			moment.tz namespace
		************************************/
	
		function tz (input) {
			var args = Array.prototype.slice.call(arguments, 0, -1),
				name = arguments[arguments.length - 1],
				zone = getZone(name),
				out  = moment.utc.apply(null, args);
	
			if (zone && !moment.isMoment(input) && needsOffset(out)) {
				out.add(zone.parse(out), 'minutes');
			}
	
			out.tz(name);
	
			return out;
		}
	
		tz.version      = VERSION;
		tz.dataVersion  = '';
		tz._zones       = zones;
		tz._links       = links;
		tz._names       = names;
		tz.add          = addZone;
		tz.link         = addLink;
		tz.load         = loadData;
		tz.zone         = getZone;
		tz.zoneExists   = zoneExists; // deprecated in 0.1.0
		tz.guess        = guess;
		tz.names        = getNames;
		tz.Zone         = Zone;
		tz.unpack       = unpack;
		tz.unpackBase60 = unpackBase60;
		tz.needsOffset  = needsOffset;
		tz.moveInvalidForward   = true;
		tz.moveAmbiguousForward = false;
	
		/************************************
			Interface with Moment.js
		************************************/
	
		var fn = moment.fn;
	
		moment.tz = tz;
	
		moment.defaultZone = null;
	
		moment.updateOffset = function (mom, keepTime) {
			var zone = moment.defaultZone,
				offset;
	
			if (mom._z === undefined) {
				if (zone && needsOffset(mom) && !mom._isUTC) {
					mom._d = moment.utc(mom._a)._d;
					mom.utc().add(zone.parse(mom), 'minutes');
				}
				mom._z = zone;
			}
			if (mom._z) {
				offset = mom._z.offset(mom);
				if (Math.abs(offset) < 16) {
					offset = offset / 60;
				}
				if (mom.utcOffset !== undefined) {
					mom.utcOffset(-offset, keepTime);
				} else {
					mom.zone(offset, keepTime);
				}
			}
		};
	
		fn.tz = function (name) {
			if (name) {
				this._z = getZone(name);
				if (this._z) {
					moment.updateOffset(this);
				} else {
					logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
				}
				return this;
			}
			if (this._z) { return this._z.name; }
		};
	
		function abbrWrap (old) {
			return function () {
				if (this._z) { return this._z.abbr(this); }
				return old.call(this);
			};
		}
	
		function resetZoneWrap (old) {
			return function () {
				this._z = null;
				return old.apply(this, arguments);
			};
		}
	
		fn.zoneName = abbrWrap(fn.zoneName);
		fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
		fn.utc      = resetZoneWrap(fn.utc);
	
		moment.tz.setDefault = function(name) {
			if (major < 2 || (major === 2 && minor < 9)) {
				logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
			}
			moment.defaultZone = name ? getZone(name) : null;
			return moment;
		};
	
		// Cloning a moment should include the _z property.
		var momentProperties = moment.momentProperties;
		if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
			// moment 2.8.1+
			momentProperties.push('_z');
			momentProperties.push('_a');
		} else if (momentProperties) {
			// moment 2.7.0
			momentProperties._z = null;
		}
	
		// INJECT DATA
	
		return moment;
	}));


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 541,
		"./af.js": 541,
		"./ar": 545,
		"./ar-ma": 542,
		"./ar-ma.js": 542,
		"./ar-sa": 543,
		"./ar-sa.js": 543,
		"./ar-tn": 544,
		"./ar-tn.js": 544,
		"./ar.js": 545,
		"./az": 546,
		"./az.js": 546,
		"./be": 547,
		"./be.js": 547,
		"./bg": 548,
		"./bg.js": 548,
		"./bn": 549,
		"./bn.js": 549,
		"./bo": 550,
		"./bo.js": 550,
		"./br": 551,
		"./br.js": 551,
		"./bs": 552,
		"./bs.js": 552,
		"./ca": 553,
		"./ca.js": 553,
		"./cs": 554,
		"./cs.js": 554,
		"./cv": 555,
		"./cv.js": 555,
		"./cy": 556,
		"./cy.js": 556,
		"./da": 557,
		"./da.js": 557,
		"./de": 559,
		"./de-at": 558,
		"./de-at.js": 558,
		"./de.js": 559,
		"./dv": 560,
		"./dv.js": 560,
		"./el": 561,
		"./el.js": 561,
		"./en-au": 562,
		"./en-au.js": 562,
		"./en-ca": 563,
		"./en-ca.js": 563,
		"./en-gb": 564,
		"./en-gb.js": 564,
		"./en-ie": 565,
		"./en-ie.js": 565,
		"./en-nz": 566,
		"./en-nz.js": 566,
		"./eo": 567,
		"./eo.js": 567,
		"./es": 568,
		"./es.js": 568,
		"./et": 569,
		"./et.js": 569,
		"./eu": 570,
		"./eu.js": 570,
		"./fa": 571,
		"./fa.js": 571,
		"./fi": 572,
		"./fi.js": 572,
		"./fo": 573,
		"./fo.js": 573,
		"./fr": 576,
		"./fr-ca": 574,
		"./fr-ca.js": 574,
		"./fr-ch": 575,
		"./fr-ch.js": 575,
		"./fr.js": 576,
		"./fy": 577,
		"./fy.js": 577,
		"./gd": 578,
		"./gd.js": 578,
		"./gl": 579,
		"./gl.js": 579,
		"./he": 580,
		"./he.js": 580,
		"./hi": 581,
		"./hi.js": 581,
		"./hr": 582,
		"./hr.js": 582,
		"./hu": 583,
		"./hu.js": 583,
		"./hy-am": 584,
		"./hy-am.js": 584,
		"./id": 585,
		"./id.js": 585,
		"./is": 586,
		"./is.js": 586,
		"./it": 587,
		"./it.js": 587,
		"./ja": 588,
		"./ja.js": 588,
		"./jv": 589,
		"./jv.js": 589,
		"./ka": 590,
		"./ka.js": 590,
		"./kk": 591,
		"./kk.js": 591,
		"./km": 592,
		"./km.js": 592,
		"./ko": 593,
		"./ko.js": 593,
		"./lb": 594,
		"./lb.js": 594,
		"./lo": 595,
		"./lo.js": 595,
		"./lt": 596,
		"./lt.js": 596,
		"./lv": 597,
		"./lv.js": 597,
		"./me": 598,
		"./me.js": 598,
		"./mk": 599,
		"./mk.js": 599,
		"./ml": 600,
		"./ml.js": 600,
		"./mr": 601,
		"./mr.js": 601,
		"./ms": 603,
		"./ms-my": 602,
		"./ms-my.js": 602,
		"./ms.js": 603,
		"./my": 604,
		"./my.js": 604,
		"./nb": 605,
		"./nb.js": 605,
		"./ne": 606,
		"./ne.js": 606,
		"./nl": 607,
		"./nl.js": 607,
		"./nn": 608,
		"./nn.js": 608,
		"./pl": 609,
		"./pl.js": 609,
		"./pt": 611,
		"./pt-br": 610,
		"./pt-br.js": 610,
		"./pt.js": 611,
		"./ro": 612,
		"./ro.js": 612,
		"./ru": 613,
		"./ru.js": 613,
		"./se": 614,
		"./se.js": 614,
		"./si": 615,
		"./si.js": 615,
		"./sk": 616,
		"./sk.js": 616,
		"./sl": 617,
		"./sl.js": 617,
		"./sq": 618,
		"./sq.js": 618,
		"./sr": 620,
		"./sr-cyrl": 619,
		"./sr-cyrl.js": 619,
		"./sr.js": 620,
		"./sv": 621,
		"./sv.js": 621,
		"./sw": 622,
		"./sw.js": 622,
		"./ta": 623,
		"./ta.js": 623,
		"./te": 624,
		"./te.js": 624,
		"./th": 625,
		"./th.js": 625,
		"./tl-ph": 626,
		"./tl-ph.js": 626,
		"./tlh": 627,
		"./tlh.js": 627,
		"./tr": 628,
		"./tr.js": 628,
		"./tzl": 629,
		"./tzl.js": 629,
		"./tzm": 631,
		"./tzm-latn": 630,
		"./tzm-latn.js": 630,
		"./tzm.js": 631,
		"./uk": 632,
		"./uk.js": 632,
		"./uz": 633,
		"./uz.js": 633,
		"./vi": 634,
		"./vi.js": 634,
		"./zh-cn": 635,
		"./zh-cn.js": 635,
		"./zh-tw": 636,
		"./zh-tw.js": 636
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1187;


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(157);
	var callBind = __webpack_require__(235);
	
	var implementation = __webpack_require__(638);
	var getPolyfill = __webpack_require__(639);
	var shim = __webpack_require__(1189);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(639);
	var define = __webpack_require__(157);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(641); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1);
	var PureRenderMixin = __webpack_require__(219);
	var emptyFunction = function(){};
	var cloneWithProps = __webpack_require__(175);
	
	function createUIEvent(draggable) {
		return {
			element: draggable.getDOMNode(),
			position: {
				top: (draggable._pendingState || draggable.state).clientY,
				left: (draggable._pendingState || draggable.state).clientX
			}
		};
	}
	
	function canDragY(draggable) {
		return draggable.props.axis === 'both' ||
				draggable.props.axis === 'y';
	}
	
	function canDragX(draggable) {
		return draggable.props.axis === 'both' ||
				draggable.props.axis === 'x';
	}
	
	function isFunction(func) {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array, callback) {
	  for (var i = 0, length = array.length, element = null; i < length, element = array[i]; i++) {
	    if (callback.apply(callback, [element, i, array])) return element;
	  }
	}
	
	function matchesSelector(el, selector) {
	  var method = findInArray([
	    'matches',
	    'webkitMatchesSelector',
	    'mozMatchesSelector',
	    'msMatchesSelector',
	    'oMatchesSelector'
	  ], function(method){
	    return isFunction(el[method]);
	  });
	
	  return el[method].call(el, selector);
	}
	
	function positionToCSSTransform(style) {
		// Replace unitless items with px
		var x = ('' + style.left).replace(/(\d)$/, '$1px');
		var y = ('' + style.top).replace(/(\d)$/, '$1px');
		style.transform = 'translate(' + x + ',' + y + ')';
		style.WebkitTransform = 'translate(' + x + ',' + y + ')';
		style.OTransform = 'translate(' + x + ',' + y + ')';
		style.msTransform = 'translate(' + x + ',' + y + ')';
		style.MozTransform = 'translate(' + x + ',' + y + ')';
		delete style.left;
		delete style.top;
		return style;
	}
	
	// @credits: http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript/4819886#4819886
	/* Conditional to fix node server side rendering of component */
	if (typeof window === 'undefined') {
	    // Do Node Stuff
	    var isTouchDevice = false;
	} else {
	    // Do Browser Stuff
	    var isTouchDevice = 'ontouchstart' in window || // works on most browsers
	      'onmsgesturechange' in window; // works on ie10 on ms surface
	}
	
	// look ::handleDragStart
	//function isMultiTouch(e) {
	//  return e.touches && Array.isArray(e.touches) && e.touches.length > 1
	//}
	
	/**
	 * simple abstraction for dragging events names
	 * */
	var dragEventFor = (function () {
	  var eventsFor = {
	    touch: {
	      start: 'touchstart',
	      move: 'touchmove',
	      end: 'touchend'
	    },
	    mouse: {
	      start: 'mousedown',
	      move: 'mousemove',
	      end: 'mouseup'
	    }
	  };
	  return eventsFor[isTouchDevice ? 'touch' : 'mouse'];
	})();
	
	/**
	 * get {clientX, clientY} positions of control
	 * */
	function getControlPosition(e) {
	  var position = (e.touches && e.touches[0]) || e;
	  return {
	    clientX: position.clientX,
	    clientY: position.clientY
	  };
	}
	
	function addEvent(el, event, handler) {
		if (!el) { return; }
		if (el.attachEvent) {
			el.attachEvent('on' + event, handler);
		} else if (el.addEventListener) {
			el.addEventListener(event, handler, true);
		} else {
			el['on' + event] = handler;
		}
	}
	
	function removeEvent(el, event, handler) {
		if (!el) { return; }
		if (el.detachEvent) {
			el.detachEvent('on' + event, handler);
		} else if (el.removeEventListener) {
			el.removeEventListener(event, handler, true);
		} else {
			el['on' + event] = null;
		}
	}
	
	module.exports = React.createClass({
		displayName: 'Draggable',
		mixins: [PureRenderMixin],
	
		propTypes: {
			/**
			 * `axis` determines which axis the draggable can move.
			 *
			 * 'both' allows movement horizontally and vertically.
			 * 'x' limits movement to horizontal axis.
			 * 'y' limits movement to vertical axis.
			 *
			 * Defaults to 'both'.
			 */
			axis: React.PropTypes.oneOf(['both', 'x', 'y']),
	
			/**
			 * `handle` specifies a selector to be used as the handle that initiates drag.
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 	    render: function () {
			 * 	    	return (
			 * 	    	 	<Draggable handle=".handle">
			 * 	    	 	  <div>
			 * 	    	 	      <div className="handle">Click me to drag</div>
			 * 	    	 	      <div>This is some other content</div>
			 * 	    	 	  </div>
			 * 	    		</Draggable>
			 * 	    	);
			 * 	    }
			 * 	});
			 * ```
			 */
			handle: React.PropTypes.string,
	
			/**
			 * `cancel` specifies a selector to be used to prevent drag initialization.
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 	    render: function () {
			 * 	        return(
			 * 	            <Draggable cancel=".cancel">
			 * 	                <div>
			 * 	                	<div className="cancel">You can't drag from here</div>
			 *						<div>Dragging here works fine</div>
			 * 	                </div>
			 * 	            </Draggable>
			 * 	        );
			 * 	    }
			 * 	});
			 * ```
			 */
			cancel: React.PropTypes.string,
	
			/**
			 * `grid` specifies the x and y that dragging should snap to.
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 	    render: function () {
			 * 	        return (
			 * 	            <Draggable grid={[25, 25]}>
			 * 	                <div>I snap to a 25 x 25 grid</div>
			 * 	            </Draggable>
			 * 	        );
			 * 	    }
			 * 	});
			 * ```
			 */
			grid: React.PropTypes.arrayOf(React.PropTypes.number),
	
			/**
			 * `start` specifies the x and y that the dragged item should start at
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 	    render: function () {
			 * 	        return (
			 * 	            <Draggable start={{x: 25, y: 25}}>
			 * 	                <div>I start with left: 25px; top: 25px;</div>
			 * 	            </Draggable>
			 * 	        );
			 * 	    }
			 * 	});
			 * ```
			 */
			start: React.PropTypes.object,
	
			/**
			 * `moveOnStartChange` tells the Draggable element to reset its position
			 * if the `start` parameters are changed. By default, if the `start`
			 * parameters change, the Draggable element still remains where it started
			 * or was dragged to.
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 			onButtonClick: function () {
			 * 				this.setState({clicked: true});
			 * 			},
			 * 	    render: function () {
			 * 	    		var start = this.state.clicked ?
			 * 	    		  {x: 25, y: 25} :
			 * 	    		  {x: 125, y: 125};
			 * 	        return (
			 * 	            <Draggable start={start}>
			 * 	                <div>I start with left: 25px; top: 25px;,
			 * 	                but move to left: 125px; top: 125px; when the button
			 * 	                is clicked.</div>
			 * 	                <div onClick={this.onButtonClick}>Button</div>
			 * 	            </Draggable>
			 * 	        );
			 * 	    }
			 * 	});
			 * ```
			 */
			moveOnStartChange: React.PropTypes.bool,
	
			/**
			 * `useCSSTransforms` if true will place the element using translate(x, y)
			 * rather than CSS top/left.
			 *
			 * This generally gives better performance, and is useful in combination with
			 * other layout systems that use translate(), such as react-grid-layout.
			 */
			useCSSTransforms: React.PropTypes.bool,
	
			/**
			 * `zIndex` specifies the zIndex to use while dragging.
			 *
			 * Example:
			 *
			 * ```jsx
			 * 	var App = React.createClass({
			 * 	    render: function () {
			 * 	        return (
			 * 	            <Draggable zIndex={100}>
			 * 	                <div>I have a zIndex</div>
			 * 	            </Draggable>
			 * 	        );
			 * 	    }
			 * 	});
			 * ```
			 */
			zIndex: React.PropTypes.number,
	
			/**
			 * Called when dragging starts.
			 *
			 * Example:
			 *
			 * ```js
			 *	function (event, ui) {}
			 * ```
			 *
			 * `event` is the Event that was triggered.
			 * `ui` is an object:
			 *
			 * ```js
			 *	{
			 *		position: {top: 0, left: 0}
			 *	}
			 * ```
			 */
			onStart: React.PropTypes.func,
	
			/**
			 * Called while dragging.
			 *
			 * Example:
			 *
			 * ```js
			 *	function (event, ui) {}
			 * ```
			 *
			 * `event` is the Event that was triggered.
			 * `ui` is an object:
			 *
			 * ```js
			 *	{
			 *		position: {top: 0, left: 0}
			 *	}
			 * ```
			 */
			onDrag: React.PropTypes.func,
	
			/**
			 * Called when dragging stops.
			 *
			 * Example:
			 *
			 * ```js
			 *	function (event, ui) {}
			 * ```
			 *
			 * `event` is the Event that was triggered.
			 * `ui` is an object:
			 *
			 * ```js
			 *	{
			 *		position: {top: 0, left: 0}
			 *	}
			 * ```
			 */
			onStop: React.PropTypes.func,
	
			/**
			 * A workaround option which can be passed if onMouseDown needs to be accessed,
			 * since it'll always be blocked (due to that there's internal use of onMouseDown)
			 *
			 */
			onMouseDown: React.PropTypes.func
		},
	
		componentWillUnmount: function() {
			// Remove any leftover event handlers
			removeEvent(window, dragEventFor['move'], this.handleDrag);
			removeEvent(window, dragEventFor['end'], this.handleDragEnd);
		},
	
		componentWillReceiveProps: function(nextProps) {
			// If this is set to watch a changing start position,
			// set x and y to the new position.
			if (nextProps.moveOnStartChange) {
				this.setState({
					clientX: nextProps.start.x,
					clientY: nextProps.start.y
				});
			}
		},
	
		getDefaultProps: function () {
			return {
				axis: 'both',
				handle: null,
				cancel: null,
				grid: null,
				start: {
					x: 0,
					y: 0
				},
				moveOnStartChange: false,
				useCSSTransforms: false,
				zIndex: NaN,
				onStart: emptyFunction,
				onDrag: emptyFunction,
				onStop: emptyFunction,
				onMouseDown: emptyFunction
			};
		},
	
		getInitialState: function () {
			return {
				// Whether or not currently dragging
				dragging: false,
	
				// Start top/left of this.getDOMNode()
				startX: 0, startY: 0,
	
				// Offset between start top/left and mouse top/left
				offsetX: 0, offsetY: 0,
	
				// Current top/left of this.getDOMNode()
				clientX: this.props.start.x, clientY: this.props.start.y
			};
		},
	
		handleDragStart: function (e) {
	    // todo: write right implementation to prevent multitouch drag
	    // prevent multi-touch events
	    // if (isMultiTouch(e)) {
	    //     this.handleDragEnd.apply(e, arguments);
	    //     return
	    // }
	
			// Make it possible to attach event handlers on top of this one
			this.props.onMouseDown(e);
	
			// Only catch left clicks, if clicking
			if (typeof e.button === "number" && e.button !== 0) {
				return;
			}
	
			var node = this.getDOMNode();
	
			// Short circuit if handle or cancel prop was provided and selector doesn't match
			if ((this.props.handle && !matchesSelector(e.target, this.props.handle)) ||
				(this.props.cancel && matchesSelector(e.target, this.props.cancel))) {
				return;
			}
	
	    var dragPoint = getControlPosition(e);
	
			// Initiate dragging
			this.setState({
				dragging: true,
				offsetX: parseInt(dragPoint.clientX, 10),
				offsetY: parseInt(dragPoint.clientY, 10),
				startX: parseInt(this.state.clientX, 10) || 0,
				startY: parseInt(this.state.clientY, 10) || 0
			});
	
			// Add a class to the body to disable user-select. This prevents text from
			// being selected all over the page.
			document.body.className += " react-draggable-active";
	
			// Call event handler
			this.props.onStart(e, createUIEvent(this));
	
			// Add event handlers
			addEvent(window, dragEventFor['move'], this.handleDrag);
			addEvent(window, dragEventFor['end'], this.handleDragEnd);
		},
	
		handleDragEnd: function (e) {
			// Short circuit if not currently dragging
			if (!this.state.dragging) {
				return;
			}
	
			// Turn off dragging
			this.setState({
				dragging: false
			});
	
			// Remove the body class used to disable user-select.
			document.body.className = document.body.className.replace(" react-draggable-active", "");
	
			// Call event handler
			this.props.onStop(e, createUIEvent(this));
	
			// Remove event handlers
	    removeEvent(window, dragEventFor['move'], this.handleDrag);
	    removeEvent(window, dragEventFor['end'], this.handleDragEnd);
		},
	
		handleDrag: function (e) {
	    var dragPoint = getControlPosition(e);
	
			// Calculate top and left
	    var clientX = (this.state.startX + (dragPoint.clientX - this.state.offsetX));
	    var clientY = (this.state.startY + (dragPoint.clientY - this.state.offsetY));
	
			// Snap to grid if prop has been provided
			if (Array.isArray(this.props.grid)) {
				var directionX = clientX < parseInt(this.state.clientX, 10) ? -1 : 1;
				var directionY = clientY < parseInt(this.state.clientY, 10) ? -1 : 1;
	
				clientX = Math.abs(clientX - parseInt(this.state.clientX, 10)) >= this.props.grid[0]
						? (parseInt(this.state.clientX, 10) + (this.props.grid[0] * directionX))
						: parseInt(this.state.clientX, 10);
	
				clientY = Math.abs(clientY - parseInt(this.state.clientY, 10)) >= this.props.grid[1]
						? (parseInt(this.state.clientY, 10) + (this.props.grid[1] * directionY))
						: parseInt(this.state.clientY, 10);
			}
	
			// Min/max constraints
			if (Array.isArray(this.props.minConstraints)) {
				clientX = Math.max(this.props.minConstraints[0], clientX);
				clientY = Math.max(this.props.minConstraints[1], clientY);
			}
			if (Array.isArray(this.props.maxConstraints)) {
				clientX = Math.min(this.props.maxConstraints[0], clientX);
				clientY = Math.min(this.props.maxConstraints[1], clientY);
			}
	
			// Update top and left
			this.setState({
				clientX: clientX,
				clientY: clientY
			});
	
			// Call event handler
			this.props.onDrag(e, createUIEvent(this));
		},
	
		render: function () {
			var style = {
				// Set top if vertical drag is enabled
				top: canDragY(this)
					? this.state.clientY
					: this.state.startY,
	
				// Set left if horizontal drag is enabled
				left: canDragX(this)
					? this.state.clientX
					: this.state.startX
			};
	
			if (this.props.useCSSTransforms) {
				style = positionToCSSTransform(style);
			}
	
			// Set zIndex if currently dragging and prop has been provided
			if (this.state.dragging && !isNaN(this.props.zIndex)) {
				style.zIndex = this.props.zIndex;
			}
	
			// Reuse the child provided
			// This makes it flexible to use whatever element is wanted (div, ul, etc)
			return cloneWithProps(React.Children.only(this.props.children), {
				style: style,
				className: 'react-draggable' + (this.state.dragging ? ' react-draggable-dragging' : ''),
	
				onMouseDown: this.handleDragStart,
				onTouchStart: function(ev){
	        ev.preventDefault(); // prevent for scroll
	        return this.handleDragStart.apply(this, arguments);
	      }.bind(this),
	
				onMouseUp: this.handleDragEnd,
				onTouchEnd: this.handleDragEnd
			});
		}
	});


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(14);
	var emptyFunction = function () {};
	
	// for accessing browser globals
	var root = typeof window !== 'undefined' ? window : this;
	var bodyElement;
	if (typeof document !== 'undefined' && 'body' in document) {
	  bodyElement = document.body;
	}
	
	function updateBoundState (state, bound) {
	  if (!bound) return state;
	  bound = String(bound);
	  var boundTop = !!~bound.indexOf('top');
	  var boundRight = !!~bound.indexOf('right');
	  var boundBottom = !!~bound.indexOf('bottom');
	  var boundLeft = !!~bound.indexOf('left');
	  var boundAll = !!~bound.indexOf('all') ||
	    !(boundTop || boundRight || boundBottom || boundLeft);
	  var boundBox = !~bound.indexOf('point');
	  state.boundTop = boundAll || boundTop;
	  state.boundRight = boundAll || boundRight;
	  state.boundBottom = boundAll || boundBottom;
	  state.boundLeft = boundAll || boundLeft;
	  state.boundBox = boundBox;
	  return state;
	};
	
	function createUIEvent(draggable) {
	  return {
	    position: {
	      top: draggable.state.offsetTop,
	      left: draggable.state.offsetLeft
	    }
	  };
	}
	
	function canDragY(draggable) {
	  return draggable.props.axis === 'both' ||
	      draggable.props.axis === 'y';
	}
	
	function canDragX(draggable) {
	  return draggable.props.axis === 'both' ||
	      draggable.props.axis === 'x';
	}
	
	function isFunction(func) {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]'
	}
	
	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array, callback) {
	  for (var i = 0, length = array.length, element = null; i < length, element = array[i]; i++) {
	    if (callback.apply(callback, [element, i, array])) return element;
	  }
	}
	
	function matchesSelector(el, selector) {
	  var method = findInArray([
	    'matches',
	    'webkitMatchesSelector',
	    'mozMatchesSelector',
	    'msMatchesSelector',
	    'oMatchesSelector'
	  ], function(method){
	    return isFunction(el[method]);
	  });
	
	  return el[method].call(el, selector);
	}
	
	// @credits: http://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript/4819886#4819886
	var isTouchDevice = 'ontouchstart' in root // works on most browsers
	                 || 'onmsgesturechange' in root; // works on ie10 on ms surface
	
	// look ::handleDragStart
	//function isMultiTouch(e) {
	//  return e.touches && Array.isArray(e.touches) && e.touches.length > 1
	//}
	
	/**
	 * simple abstraction for dragging events names
	 * */
	var dragEventFor = (function () {
	  var eventsFor = {
	    touch: {
	      start: 'touchstart',
	      move: 'touchmove',
	      end: 'touchend'
	    },
	    mouse: {
	      start: 'mousedown',
	      move: 'mousemove',
	      end: 'mouseup'
	    }
	  };
	  return eventsFor[isTouchDevice ? 'touch' : 'mouse'];
	})();
	
	/**
	 * get {clientX, clientY} positions of control
	 * */
	function getControlPosition(e) {
	  var position = (e.touches && e.touches[0]) || e;
	  return {
	    clientX: position.clientX,
	    clientY: position.clientY
	  }
	}
	
	function addEvent(el, event, handler) {
	  if (!el) { return; }
	  if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else if (el.addEventListener) {
	    el.addEventListener(event, handler, true);
	  } else {
	    el['on' + event] = handler;
	  }
	}
	
	function removeEvent(el, event, handler) {
	  if (!el) { return; }
	  if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else if (el.removeEventListener) {
	    el.removeEventListener(event, handler, true);
	  } else {
	    el['on' + event] = null;
	  }
	}
	
	module.exports = React.createClass({
	  displayName: 'Draggable',
	  mixins: [React.addons.PureRenderMixin],
	
	  propTypes: {
	    /**
	     * `axis` determines which axis the draggable can move.
	     *
	     * 'both' allows movement horizontally and vertically.
	     * 'x' limits movement to horizontal axis.
	     * 'y' limits movement to vertical axis.
	     *
	     * Defaults to 'both'.
	     */
	    axis: React.PropTypes.oneOf(['both', 'x', 'y']),
	
	    /**
	     * `handle` specifies a selector to be used as the handle that initiates drag.
	     *
	     * Example:
	     *
	     * ```jsx
	     *  var App = React.createClass({
	     *      render: function () {
	     *        return (
	     *          <Draggable handle=".handle">
	     *            <div>
	     *                <div className="handle">Click me to drag</div>
	     *                <div>This is some other content</div>
	     *            </div>
	     *          </Draggable>
	     *        );
	     *      }
	     *  });
	     * ```
	     */
	    handle: React.PropTypes.string,
	
	    /**
	     * `cancel` specifies a selector to be used to prevent drag initialization.
	     *
	     * Example:
	     *
	     * ```jsx
	     *  var App = React.createClass({
	     *      render: function () {
	     *          return(
	     *              <Draggable cancel=".cancel">
	     *                  <div>
	     *                    <div className="cancel">You can't drag from here</div>
	     *            <div>Dragging here works fine</div>
	     *                  </div>
	     *              </Draggable>
	     *          );
	     *      }
	     *  });
	     * ```
	     */
	    cancel: React.PropTypes.string,
	
	    /**
	     * `bound` determines whether to bound the movement to the parent box.
	     *
	     * The property takes a list of space-separated strings. The Draggable
	     * is bounded by the nearest DOMNode.offsetParent. To set the offset
	     * parent, give it a position value other than 'static'.
	     *
	     * Optionally choose one or more bounds from:
	     * 'top' bounds movement to the top edge of the parent box.
	     * 'right' bounds movement to the right edge of the parent box.
	     * 'bottom' bounds movement to the bottom edge of the parent box.
	     * 'left' bounds movement to the left edge of the parent box.
	     * 'all' bounds movement to all edges (default if not specified).
	     *
	     * Optionally choose one anchor from:
	     * 'point' to constrain only the top-left corner.
	     * 'box' to constrain the entire box (default if not specified).
	     *
	     * You may use more than one bound, e.g. 'top left point'. Set to a
	     * falsy value to disable.
	     *
	     * Defaults to 'all box'.
	     */
	    bound: React.PropTypes.string,
	
	    /**
	     * `grid` specifies the x and y that dragging should snap to.
	     *
	     * Example:
	     *
	     * ```jsx
	     *   var App = React.createClass({
	     *       render: function () {
	     *           return (
	     *              <Draggable grid={[25, 25]}>
	     *                   <div>I snap to a 25 x 25 grid</div>
	     *               </Draggable>
	     *           );
	     *      }
	     *   });
	     * ```
	     */
	    grid: React.PropTypes.arrayOf(React.PropTypes.number),
	
	    /**
	     * `constrain` takes a function to constrain the dragging.
	     *
	     * Example:
	     *
	     * ```jsx
	     *   function constrain (snap) {
	     *         function constrainOffset (offset, prev) {
	     *               var delta = offset - prev;
	     *               if (Math.abs(delta) >= snap) {
	     *                     return prev + (delta < 0 ? -snap : snap);
	     *               }
	     *               return prev;
	     *         }
	     *         return function (pos) {
	     *               return {
	     *                     top: constrainOffset(pos.top, pos.prevTop),
	     *                     left: constrainOffset(pos.left, pos.prevLeft)
	     *               };
	     *         };
	     *   }
	     *   var App = React.createClass({
	     *       render: function () {
	     *           return (
	     *               <Draggable constrain={constrain}>
	     *                   <div>I snap to a 25 x 25 grid</div>
	     *               </Draggable>
	     *           );
	     *       }
	     *   });
	     * ```
	     */
	    constrain: React.PropTypes.func,
	
	    /**
	     * `start` specifies the x and y that the dragged item should start at
	     *
	     * Example:
	     *
	     * ```jsx
	     *  var App = React.createClass({
	     *      render: function () {
	     *          return (
	     *              <Draggable start={{x: 25, y: 25}}>
	     *                  <div>I start with left: 25px; top: 25px;</div>
	     *              </Draggable>
	     *          );
	     *      }
	     *  });
	     * ```
	     */
	    start: React.PropTypes.object,
	
	    /**
	     * `zIndex` specifies the zIndex to use while dragging.
	     *
	     * Example:
	     *
	     * ```jsx
	     *  var App = React.createClass({
	     *      render: function () {
	     *          return (
	     *              <Draggable zIndex={100}>
	     *                  <div>I have a zIndex</div>
	     *              </Draggable>
	     *          );
	     *      }
	     *  });
	     * ```
	     */
	    zIndex: React.PropTypes.number,
	
	    /**
	     * `useChild` determines whether to use the first child as root.
	     *
	     * If false, a div is created. This option is required if any children
	     * have a ref.
	     *
	     * Defaults to true.
	     */
	    useChild: React.PropTypes.bool,
	
	    /**
	     * Called when dragging starts.
	     *
	     * Example:
	     *
	     * ```js
	     *  function (event, ui) {}
	     * ```
	     *
	     * `event` is the Event that was triggered.
	     * `ui` is an object:
	     *
	     * ```js
	     *  {
	     *    position: {top: 0, left: 0}
	     *  }
	     * ```
	     */
	    onStart: React.PropTypes.func,
	
	    /**
	     * Called while dragging.
	     *
	     * Example:
	     *
	     * ```js
	     *  function (event, ui) {}
	     * ```
	     *
	     * `event` is the Event that was triggered.
	     * `ui` is an object:
	     *
	     * ```js
	     *  {
	     *    position: {top: 0, left: 0}
	     *  }
	     * ```
	     */
	    onDrag: React.PropTypes.func,
	
	    /**
	     * Called when dragging stops.
	     *
	     * Example:
	     *
	     * ```js
	     *  function (event, ui) {}
	     * ```
	     *
	     * `event` is the Event that was triggered.
	     * `ui` is an object:
	     *
	     * ```js
	     *  {
	     *    position: {top: 0, left: 0}
	     *  }
	     * ```
	     */
	    onStop: React.PropTypes.func,
	
	    /**
	     * A workaround option which can be passed if onMouseDown needs to be accessed, since it'll always be blocked (due to that there's internal use of onMouseDown)
	     *
	     */
	    onMouseDown: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      axis: 'both',
	      bound: null,
	      handle: null,
	      cancel: null,
	      grid: null,
	      start: {},
	      zIndex: NaN,
	      useChild: true,
	      onStart: emptyFunction,
	      onDrag: emptyFunction,
	      onStop: emptyFunction,
	      onMouseDown: emptyFunction
	    };
	  },
	
	  getInitialState: function () {
	    var state = {
	      // Whether or not currently dragging
	      dragging: false,
	
	      // Pointer offset on screen
	      clientX: 0, clientY: 0,
	
	      // DOMNode offset relative to parent
	      offsetLeft: this.props.start.x || 0, offsetTop: this.props.start.y || 0
	    };
	
	    updateBoundState(state, this.props.bound);
	
	    return state;
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var state = updateBoundState({}, nextProps.bound);
	    if (nextProps.start) {
	      if (nextProps.start.x != null) {
	        state.offsetLeft = nextProps.start.x || 0;
	      }
	      if (nextProps.start.y != null) {
	        state.offsetTop = nextProps.start.y || 0;
	      }
	    }
	    this.setState(state);
	  },
	
	  componentWillUnmount: function() {
	    // Remove any leftover event handlers
	    removeEvent(root, dragEventFor['move'], this.handleDrag);
	    removeEvent(root, dragEventFor['end'], this.handleDragEnd);
	  },
	
	  handleDragStart: function (e) {
	    // todo: write right implementation to prevent multitouch drag
	    // prevent multi-touch events
	    // if (isMultiTouch(e)) {
	    //     this.handleDragEnd.apply(e, arguments);
	    //     return
	    // }
	
	    // Make it possible to attach event handlers on top of this one
	    this.props.onMouseDown(e);
	
	    // Short circuit if handle or cancel prop was provided and selector doesn't match
	    if ((this.props.handle && !matchesSelector(e.target, this.props.handle)) ||
	      (this.props.cancel && matchesSelector(e.target, this.props.cancel))) {
	      return;
	    }
	
	    var dragPoint = getControlPosition(e);
	
	    // Initiate dragging
	    this.setState({
	      dragging: true,
	      clientX: dragPoint.clientX,
	      clientY: dragPoint.clientY
	    });
	
	    // Call event handler
	    this.props.onStart(e, createUIEvent(this));
	
	    // Add event handlers
	    addEvent(root, dragEventFor['move'], this.handleDrag);
	    addEvent(root, dragEventFor['end'], this.handleDragEnd);
	
	    // Add dragging class to body element
	    if (bodyElement) bodyElement.className += ' react-draggable-dragging';
	  },
	
	  handleDragEnd: function (e) {
	    // Short circuit if not currently dragging
	    if (!this.state.dragging) {
	      return;
	    }
	
	    // Turn off dragging
	    this.setState({
	      dragging: false
	    });
	
	    // Call event handler
	    this.props.onStop(e, createUIEvent(this));
	
	    // Remove event handlers
	    removeEvent(root, dragEventFor['move'], this.handleDrag);
	    removeEvent(root, dragEventFor['end'], this.handleDragEnd);
	
	    // Remove dragging class from body element
	    if (bodyElement) {
	      var className = bodyElement.className;
	      bodyElement.className =
	        className.replace(/(?:^|\s+)react-draggable-dragging\b/, ' ');
	    }
	  },
	
	  handleDrag: function (e) {
	    var dragPoint = getControlPosition(e);
	    var offsetLeft = this._toPixels(this.state.offsetLeft);
	    var offsetTop = this._toPixels(this.state.offsetTop);
	
	    var state = {
	      offsetLeft: offsetLeft,
	      offsetTop: offsetTop
	    };
	
	    // Get parent DOM node
	    var node = this.getDOMNode();
	    var offsetParent = node.offsetParent;
	    var offset, boundingValue;
	
	    if (canDragX(this)) {
	      // Calculate updated position
	      offset = offsetLeft + dragPoint.clientX - this.state.clientX;
	
	      // Bound movement to parent box
	      if (this.state.boundLeft) {
	        boundingValue = state.offsetLeft - node.offsetLeft;
	        if (offset < boundingValue) {
	          offset = boundingValue;
	        }
	      }
	      if (this.state.boundRight) {
	        boundingValue += offsetParent.clientWidth;
	        if (this.state.boundBox) {
	          boundingValue -= node.offsetWidth;
	        }
	        if (offset > boundingValue) {
	          offset = boundingValue;
	        }
	      }
	      // Update left
	      state.offsetLeft = offset;
	    }
	
	    if (canDragY(this)) {
	      // Calculate updated position
	      offset = offsetTop + dragPoint.clientY - this.state.clientY;
	      // Bound movement to parent box
	      if (this.state.boundTop) {
	        boundingValue = state.offsetTop - node.offsetTop;
	        if (offset < boundingValue) {
	          offset = boundingValue;
	        }
	      }
	      if (this.state.boundBottom) {
	        boundingValue += offsetParent.clientHeight;
	        if (this.state.boundBox) {
	          boundingValue -= node.offsetHeight;
	        }
	        if (offset > boundingValue) {
	          offset = boundingValue;
	        }
	      }
	      // Update top
	      state.offsetTop = offset;
	    }
	
	    var constrain = this.props.constrain;
	    var grid = this.props.grid;
	
	    // Backwards-compatibility for snap to grid
	    if (!constrain && Array.isArray(grid)) {
	      var constrainOffset = function (offset, prev, snap) {
	        var delta = offset - prev;
	        if (Math.abs(delta) >= snap) {
	          return prev + parseInt(delta / snap, 10) * snap;
	        }
	        return prev;
	      };
	      constrain = function (pos) {
	        return {
	          left: constrainOffset(pos.left, pos.prevLeft, grid[0]),
	          top: constrainOffset(pos.top, pos.prevTop, grid[1])
	        };
	      };
	    }
	
	    // Constrain if function has been provided
	    var positions;
	    if (constrain) {
	      // Constrain positions
	      positions = constrain({
	        prevLeft: this.state.offsetLeft,
	        prevTop: this.state.offsetTop,
	        left: state.offsetLeft,
	        top: state.offsetTop
	      });
	      if (positions) {
	        // Update left
	        if ('left' in positions && !isNaN(positions.left)) {
	          state.offsetLeft = positions.left;
	        }
	        // Update top
	        if ('top' in positions && !isNaN(positions.top)) {
	          state.offsetTop = positions.top;
	        }
	      }
	    }
	
	    // Save new state
	    state.clientX = this.state.clientX + (state.offsetLeft - offsetLeft);
	    state.clientY = this.state.clientY + (state.offsetTop - offsetTop);
	    this.setState(state);
	
	    // Call event handler
	    this.props.onDrag(e, createUIEvent(this));
	  },
	
	  onTouchStart: function (e) {
	    e.preventDefault(); // prevent for scroll
	    return this.handleDragStart.apply(this, arguments);
	  },
	
	  render: function () {
	    var style = {
	      top: this.state.offsetTop,
	      left: this.state.offsetLeft
	    };
	
	    // Set zIndex if currently dragging and prop has been provided
	    if (this.state.dragging && !isNaN(this.props.zIndex)) {
	      style.zIndex = this.props.zIndex;
	    }
	
	    var props = {
	      style: style,
	      className: 'react-draggable',
	
	      onMouseDown: this.handleDragStart,
	      onTouchStart: this.onTouchStart,
	
	      onMouseUp: this.handleDragEnd,
	      onTouchEnd: this.handleDragEnd
	    };
	
	    // Reuse the child provided
	    // This makes it flexible to use whatever element is wanted (div, ul, etc)
	    if (this.props.useChild) {
	      return React.addons.cloneWithProps(React.Children.only(this.props.children), props);
	    }
	
	    return React.DOM.div(props, this.props.children);
	  },
	
	  _toPixels: function (value) {
	
	    // Support percentages
	    if (typeof value == 'string' && value.slice(-1) == '%') {
	      return parseInt((+value.replace('%', '') / 100) *
	        this.getDOMNode().offsetParent.clientWidth, 10) || 0;
	    }
	
	    // Invalid values become zero
	    var i = parseInt(value, 10);
	    if (isNaN(i) || !isFinite(i)) return 0;
	
	    return i;
	  }
	
	});


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var assign = __webpack_require__(25);
	
	var NEWTAB = '_blank';
	
	var OutboundLink = React.createClass({
	  displayName: 'OutboundLink',
	  propTypes: {
	    eventLabel: React.PropTypes.string.isRequired
	  },
	  statics: {
	    trackLink: function() {
	      console.warn("ga tracking not enabled");
	    }
	  },
	  handleClick: function (e) {
	    e.preventDefault();
	    var props = this.props;
	    var eventMeta = {label: props.eventLabel};
	    OutboundLink.trackLink(eventMeta, function () {
	      if ( props.target === NEWTAB ) {
	        window.open(props.to, NEWTAB);
	      } else {
	        window.location.href = props.to;
	      }
	    });
	    if (props.onClick) {
	      props.onClick(e);
	    }
	  },
	  render: function () {
	    var props = assign({}, this.props, {
	      href: this.props.to,
	      onClick: this.handleClick
	    });
	    return React.createElement('a', props);
	  }
	});
	
	module.exports = OutboundLink;


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var React = __webpack_require__(1);
	var cloneWithProps = __webpack_require__(175);
	var utils = __webpack_require__(214);
	var Draggable = __webpack_require__(642);
	var Resizable = __webpack_require__(1202).Resizable;
	var PureDeepRenderMixin = __webpack_require__(371);
	
	/**
	 * An individual item within a ReactGridLayout.
	 */
	var GridItem = React.createClass({
	  displayName: 'GridItem',
	
	  mixins: [PureDeepRenderMixin],
	
	  propTypes: {
	    // Children must be only a single element
	    children: React.PropTypes.element,
	
	    // General grid attributes
	    cols: React.PropTypes.number.isRequired,
	    containerWidth: React.PropTypes.number.isRequired,
	    rowHeight: React.PropTypes.number.isRequired,
	    margin: React.PropTypes.array.isRequired,
	
	    // These are all in grid units
	    x: React.PropTypes.number.isRequired,
	    y: React.PropTypes.number.isRequired,
	    w: React.PropTypes.number.isRequired,
	    h: React.PropTypes.number.isRequired,
	
	    // All optional
	    minW: function minW(props, propName, componentName) {
	      React.PropTypes.number.apply(this, arguments);
	      if (props.minW > props.w || props.minW > props.maxW) constraintError('minW', props);
	    },
	    maxW: function maxW(props, propName, componentName) {
	      React.PropTypes.number.apply(this, arguments);
	      if (props.maxW < props.w || props.maxW < props.minW) constraintError('maxW', props);
	    },
	    minH: function minH(props, propName, componentName) {
	      React.PropTypes.number.apply(this, arguments);
	      if (props.minH > props.h || props.minH > props.maxH) constraintError('minH', props);
	    },
	    maxH: function maxH(props, propName, componentName) {
	      React.PropTypes.number.apply(this, arguments);
	      if (props.maxH < props.h || props.maxH < props.minH) constraintError('maxH', props);
	    },
	
	    // ID is nice to have for callbacks
	    i: React.PropTypes.string.isRequired,
	
	    // If true, item will be repositioned when x/y/w/h change
	    moveOnStartChange: React.PropTypes.bool,
	
	    // Functions
	    onDragStop: React.PropTypes.func,
	    onDragStart: React.PropTypes.func,
	    onDrag: React.PropTypes.func,
	    onResizeStop: React.PropTypes.func,
	    onResizeStart: React.PropTypes.func,
	    onResize: React.PropTypes.func,
	
	    // Flags
	    isDraggable: React.PropTypes.bool,
	    isResizable: React.PropTypes.bool,
	    // Use CSS transforms instead of top/left
	    useCSSTransforms: React.PropTypes.bool,
	    isPlaceholder: React.PropTypes.bool,
	
	    // Others
	    className: React.PropTypes.string,
	    // Selector for draggable handle
	    handle: React.PropTypes.string,
	    // Selector for draggable cancel (see react-draggable)
	    cancel: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      isDraggable: true,
	      isResizable: true,
	      useCSSTransforms: true,
	      className: '',
	      cancel: '',
	      minH: 1,
	      minW: 1,
	      maxH: Infinity,
	      maxW: Infinity
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      resizing: false,
	      className: ''
	    };
	  },
	
	  /**
	   * Return position on the page given an x, y, w, h.
	   * left, top, width, height are all in pixels.
	   * @param  {Number}  x             X coordinate in grid units.
	   * @param  {Number}  y             Y coordinate in grid units.
	   * @param  {Number}  w             W coordinate in grid units.
	   * @param  {Number}  h             H coordinate in grid units.
	   * @return {Object}                Object containing coords.
	   */
	  calcPosition: function calcPosition(x, y, w, h) {
	    var p = this.props;
	    var width = p.containerWidth - p.margin[0];
	    var out = {
	      left: width * (x / p.cols) + p.margin[0],
	      top: p.rowHeight * y + p.margin[1],
	      width: width * (w / p.cols) - p.margin[0],
	      height: h * p.rowHeight - p.margin[1]
	    };
	    return out;
	  },
	
	  /**
	   * Translate x and y coordinates from pixels to grid units.
	   * @param  {Number} options.left  Left offset in pixels.
	   * @param  {Number} options.top   Top offset in pixels.
	   * @return {Object}               x and y in grid units.
	   */
	  calcXY: function calcXY(_ref) {
	    var left = _ref.left;
	    var top = _ref.top;
	
	    left = left - this.props.margin[0];
	    top = top - this.props.margin[1];
	    // This is intentional; because so much of the logic on moving boxes up/down relies
	    // on an exact y position, we only round the x, not the y.
	    var x = Math.round(left / this.props.containerWidth * this.props.cols);
	    var y = Math.floor(top / this.props.rowHeight);
	    x = Math.max(Math.min(x, this.props.cols), 0);
	    y = Math.max(y, 0);
	    return { x: x, y: y };
	  },
	
	  /**
	   * Given a height and width in pixel values, calculate grid units.
	   * @param  {Number} options.height Height in pixels.
	   * @param  {Number} options.width  Width in pixels.
	   * @return {Object}                w, h as grid units.
	   */
	  calcWH: function calcWH(_ref2) {
	    var height = _ref2.height;
	    var width = _ref2.width;
	
	    width = width + this.props.margin[0];
	    height = height + this.props.margin[1];
	    var w = Math.round(width / this.props.containerWidth * this.props.cols);
	    var h = Math.round(height / this.props.rowHeight);
	    w = Math.max(Math.min(w, this.props.cols - this.props.x), 0);
	    h = Math.max(h, 0);
	    return { w: w, h: h };
	  },
	
	  /**
	   * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
	   * well when server rendering, and the only way to do that properly is to use percentage width/left because
	   * we don't know exactly what the browser viewport is.
	   * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
	   * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
	   *
	   * @param  {Object} pos Position object with width, height, left, top.
	   * @return {Object}     Style object.
	   */
	  createStyle: function createStyle(pos) {
	    var style = {
	      width: pos.width + 'px',
	      height: pos.height + 'px',
	      left: pos.left + 'px',
	      top: pos.top + 'px',
	      position: 'absolute'
	    };
	
	    // This is used for server rendering.
	    if (this.props.usePercentages) {
	      pos.left = utils.perc(pos.left / this.props.containerWidth);
	      style.left = pos.left;
	      style.width = utils.perc(pos.width / this.props.containerWidth);
	    }
	
	    // CSS Transforms support
	    if (this.props.useCSSTransforms) {
	      utils.setTransform(style, [pos.left, pos.top]);
	      delete style.left;
	      delete style.top;
	    }
	
	    return style;
	  },
	
	  /**
	   * Mix a Draggable instance into a child.
	   * @param  {Element} child    Child element.
	   * @param  {Object} position  Position object (pixel values)
	   * @return {Element}          Child wrapped in Draggable.
	   */
	  mixinDraggable: function mixinDraggable(child, position) {
	    return React.createElement(
	      Draggable,
	      {
	        start: { x: position.left, y: position.top },
	        moveOnStartChange: this.props.moveOnStartChange,
	        onStop: this.onDragHandler('onDragStop'),
	        onStart: this.onDragHandler('onDragStart'),
	        onDrag: this.onDragHandler('onDrag'),
	        handle: this.props.handle,
	        cancel: ".react-resizable-handle " + this.props.cancel,
	        useCSSTransforms: this.props.useCSSTransforms
	      },
	      child
	    );
	  },
	
	  /**
	   * Mix a Resizable instance into a child.
	   * @param  {Element} child    Child element.
	   * @param  {Object} position  Position object (pixel values)
	   * @return {Element}          Child wrapped in Resizable.
	   */
	  mixinResizable: function mixinResizable(child, position) {
	    var p = this.props;
	    // This is the max possible width - doesn't go to infinity because of the width of the window
	    var maxWidth = this.calcPosition(0, 0, p.cols - p.x, 0).width;
	
	    // Calculate min/max constraints using our min & maxes
	    var mins = this.calcPosition(0, 0, p.minW, p.minH);
	    var maxes = this.calcPosition(0, 0, p.maxW, p.maxH);
	    var minConstraints = [mins.width, mins.height];
	    var maxConstraints = [Math.min(maxes.width, maxWidth), Math.min(maxes.height, Infinity)];
	    return React.createElement(
	      Resizable,
	      {
	        width: position.width,
	        height: position.height,
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        onResizeStop: this.onResizeHandler('onResizeStop'),
	        onResizeStart: this.onResizeHandler('onResizeStart'),
	        onResize: this.onResizeHandler('onResize')
	      },
	      child
	    );
	  },
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   * All drag events call the function with the given handler name,
	   * with the signature (index, x, y).
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  onDragHandler: function onDragHandler(handlerName) {
	    var me = this;
	    return function (e, _ref3) {
	      var element = _ref3.element;
	      var position = _ref3.position;
	
	      if (!me.props[handlerName]) return;
	      // Get new XY
	
	      var _me$calcXY = me.calcXY(position);
	
	      var x = _me$calcXY.x;
	      var y = _me$calcXY.y;
	
	      // Cap x at numCols
	      x = Math.min(x, me.props.cols - me.props.w);
	
	      me.props[handlerName](me.props.i, x, y, { e: e, element: element, position: position });
	    };
	  },
	
	  /**
	   * Wrapper around drag events to provide more useful data.
	   * All drag events call the function with the given handler name,
	   * with the signature (index, x, y).
	   *
	   * @param  {String} handlerName Handler name to wrap.
	   * @return {Function}           Handler function.
	   */
	  onResizeHandler: function onResizeHandler(handlerName) {
	    var me = this;
	    return function (e, _ref4) {
	      var element = _ref4.element;
	      var size = _ref4.size;
	
	      if (!me.props[handlerName]) return;
	
	      // Get new XY
	
	      var _me$calcWH = me.calcWH(size);
	
	      var w = _me$calcWH.w;
	      var h = _me$calcWH.h;
	
	      // Cap w at numCols
	      w = Math.min(w, me.props.cols - me.props.x);
	      // Ensure w is at least 1
	      w = Math.max(w, 1);
	
	      // Min/max capping
	      w = Math.max(Math.min(w, me.props.maxW), me.props.minW);
	      h = Math.max(Math.min(h, me.props.maxH), me.props.minH);
	
	      me.setState({ resizing: handlerName === 'onResizeStop' ? null : size });
	
	      me.props[handlerName](me.props.i, w, h, { e: e, element: element, size: size });
	    };
	  },
	
	  render: function render() {
	    var p = this.props,
	        pos = this.calcPosition(p.x, p.y, p.w, p.h);
	    if (this.state.resizing) {
	      pos.width = this.state.resizing.width;
	      pos.height = this.state.resizing.height;
	    }
	
	    // Create the child element. We clone the existing element but modify its className and style.
	    var child = cloneWithProps(this.props.children, {
	      // Munge a classname. Use passed in classnames and resizing.
	      // React with merge the classNames.
	      className: ['react-grid-item', this.props.className, this.state.resizing ? 'resizing' : '', this.props.useCSSTransforms ? 'cssTransforms' : ''].join(' '),
	      // We can set the width and height on the child, but unfortunately we can't set the position.
	      style: this.createStyle(pos)
	    });
	
	    // Resizable support. This is usually on but the user can toggle it off.
	    if (this.props.isResizable) {
	      child = this.mixinResizable(child, pos);
	    }
	
	    // Draggable support. This is always on, except for with placeholders.
	    if (this.props.isDraggable) {
	      child = this.mixinDraggable(child, pos);
	    }
	
	    return child;
	  }
	});
	
	function constraintError(name, props) {
	  delete props.children;
	  throw new Error(name + ' overrides contraints on gridItem ' + props.i + '. Full props: ' + JSON.stringify(props));
	}
	
	module.exports = GridItem;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var React = __webpack_require__(1);
	var utils = __webpack_require__(214);
	var responsiveUtils = __webpack_require__(1196);
	var PureDeepRenderMixin = __webpack_require__(371);
	var WidthListeningMixin = __webpack_require__(644);
	var ReactGridLayout = __webpack_require__(643);
	
	/**
	 * A wrapper around ReactGridLayout to support responsive breakpoints.
	 */
	var ResponsiveReactGridLayout = React.createClass({
	  displayName: 'ResponsiveReactGridLayout',
	
	  mixins: [PureDeepRenderMixin, WidthListeningMixin],
	
	  propTypes: {
	    //
	    // Basic props
	    //
	
	    // Optional, but if you are managing width yourself you may want to set the breakpoint
	    // yourself as well.
	    breakpoint: React.PropTypes.string,
	
	    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
	    breakpoints: React.PropTypes.object,
	
	    // # of cols. This is a breakpoint -> cols map
	    cols: React.PropTypes.object,
	
	    // layouts is an object mapping breakpoints to layouts.
	    // e.g. {lg: Layout, md: Layout, ...}
	    layouts: function layouts(props, propName, componentName) {
	      React.PropTypes.object.isRequired.apply(this, arguments);
	
	      var layouts = props.layouts;
	      Object.keys(layouts).map(function (k) {
	        utils.validateLayout(layouts[k], 'layouts.' + k);
	      });
	    },
	
	    //
	    // Callbacks
	    //
	
	    // Calls back with breakpoint and new # cols
	    onBreakpointChange: React.PropTypes.func,
	
	    // Callback so you can save the layout.
	    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
	    onLayoutChange: React.PropTypes.func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
	      cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
	      layouts: {},
	      onBreakpointChange: function onBreakpointChange() {},
	      onLayoutChange: function onLayoutChange() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var breakpoint = this.props.breakpoint || responsiveUtils.getBreakpointFromWidth(this.props.breakpoints, this.props.initialWidth);
	    var cols = responsiveUtils.getColsFromBreakpoint(breakpoint, this.props.cols);
	
	    // Get the initial layout. This can tricky; we try to generate one however possible if one doesn't exist
	    // for this layout.
	    var initialLayout = responsiveUtils.findOrGenerateResponsiveLayout(this.props.layouts, this.props.breakpoints, breakpoint, breakpoint, cols, this.props.verticalCompact);
	
	    return {
	      layout: initialLayout,
	      // storage for layouts obsoleted by breakpoints
	      layouts: this.props.layouts || {},
	      breakpoint: breakpoint,
	      cols: cols,
	      width: this.props.initialWidth
	    };
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    // This allows you to set the width manually if you like.
	    // Use manual width changes in combination with `listenToWindowResize: false`
	    if (nextProps.width) this.onWidthChange(nextProps.width);
	
	    // Allow parent to set breakpoint directly.
	    if (nextProps.breakpoint !== this.props.breakpoint) {
	      this.onWidthChange(this.state.width);
	    }
	
	    // Allow parent to set layouts directly.
	    if (nextProps.layouts && nextProps.layouts !== this.state.layouts) {
	      // Since we're setting an entirely new layout object, we must generate a new responsive layout
	      // if one does not exist.
	      var newLayout = responsiveUtils.findOrGenerateResponsiveLayout(nextProps.layouts, nextProps.breakpoints, this.state.breakpoint, this.state.breakpoint, this.state.cols, this.props.verticalLayout);
	
	      this.setState({
	        layouts: nextProps.layouts,
	        layout: newLayout
	      });
	    }
	  },
	
	  /**
	   * Bubble this up, add `layouts` object.
	   * @param  {Array} layout Layout from inner Grid.
	   */
	  onLayoutChange: function onLayoutChange(layout) {
	    this.state.layouts[this.state.breakpoint] = layout;
	    this.setState({ layout: layout, layouts: this.state.layouts });
	    this.props.onLayoutChange(layout, this.state.layouts);
	  },
	
	  /**
	   * When the width changes work through breakpoints and reset state with the new width & breakpoint.
	   * Width changes are necessary to figure out the widget widths.
	   */
	  onWidthChange: function onWidthChange(width) {
	    // Set new breakpoint
	    var newState = { width: width };
	    newState.breakpoint = this.props.breakpoint || responsiveUtils.getBreakpointFromWidth(this.props.breakpoints, newState.width);
	    newState.cols = responsiveUtils.getColsFromBreakpoint(newState.breakpoint, this.props.cols);
	
	    // Breakpoint change
	    if (newState.cols !== this.state.cols) {
	
	      // Store the current layout
	      newState.layouts = this.state.layouts;
	      newState.layouts[this.state.breakpoint] = JSON.parse(JSON.stringify(this.state.layout));
	
	      // Find or generate a new one.
	      newState.layout = responsiveUtils.findOrGenerateResponsiveLayout(newState.layouts, this.props.breakpoints, newState.breakpoint, this.state.breakpoint, newState.cols, this.props.verticalLayout);
	
	      // This adds missing items.
	      newState.layout = utils.synchronizeLayoutWithChildren(newState.layout, this.props.children, newState.cols, this.props.verticalCompact);
	
	      // Store this new layout as well.
	      newState.layouts[newState.breakpoint] = newState.layout;
	
	      this.props.onBreakpointChange(newState.breakpoint, newState.cols);
	    }
	
	    this.setState(newState);
	  },
	
	  render: function render() {
	    // Don't pass responsive props to RGL.
	    /*jshint unused:false*/
	    var _props = this.props;
	    var layouts = _props.layouts;
	    var onBreakpointChange = _props.onBreakpointChange;
	    var breakpoints = _props.breakpoints;
	
	    var props = _objectWithoutProperties(_props, ['layouts', 'onBreakpointChange', 'breakpoints']);
	
	    return React.createElement(
	      ReactGridLayout,
	      _extends({}, props, {
	        layout: this.state.layout,
	        cols: this.state.cols,
	        listenToWindowResize: false,
	        onLayoutChange: this.onLayoutChange,
	        width: this.state.width }),
	      this.props.children
	    );
	  }
	});
	
	module.exports = ResponsiveReactGridLayout;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(214);
	
	var responsiveUtils = module.exports = {
	
	  /**
	   * Given a width, find the highest breakpoint that matches is valid for it (width > breakpoint).
	   *
	   * @param  {Object} breakpoints Breakpoints object (e.g. {lg: 1200, md: 960, ...})
	   * @param  {Number} width Screen width.
	   * @return {String}       Highest breakpoint that is less than width.
	   */
	  getBreakpointFromWidth: function getBreakpointFromWidth(breakpoints, width) {
	    var sorted = responsiveUtils.sortBreakpoints(breakpoints);
	    var matching = sorted[0];
	    for (var i = 1, len = sorted.length; i < len; i++) {
	      var breakpointName = sorted[i];
	      if (width > breakpoints[breakpointName]) matching = breakpointName;
	    }
	    return matching;
	  },
	
	  /**
	   * Given a breakpoint, get the # of cols set for it.
	   * @param  {String} breakpoint Breakpoint name.
	   * @param  {Object} cols       Map of breakpoints to cols.
	   * @return {Number}            Number of cols.
	   */
	  getColsFromBreakpoint: function getColsFromBreakpoint(breakpoint, cols) {
	    if (!cols[breakpoint]) {
	      throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + breakpoint + " is missing!");
	    }
	    return cols[breakpoint];
	  },
	
	  /**
	   * Given existing layouts and a new breakpoint, find or generate a new layout.
	   *
	   * This finds the layout above the new one and generates from it, if it exists.
	   *
	   * @param  {Array} layouts     Existing layouts.
	   * @param  {Array} breakpoints All breakpoints.
	   * @param  {String} breakpoint New breakpoint.
	   * @param  {String} breakpoint Last breakpoint (for fallback).
	   * @param  {Number} cols       Column count at new breakpoint.
	   * @param  {Boolean} verticalCompact Whether or not to compact the layout
	   *   vertically.
	   * @return {Array}             New layout.
	   */
	  findOrGenerateResponsiveLayout: function findOrGenerateResponsiveLayout(layouts, breakpoints, breakpoint, lastBreakpoint, cols, verticalCompact) {
	    // If it already exists, just return it.
	    if (layouts[breakpoint]) return layouts[breakpoint];
	    // Find or generate the next layout
	    var layout = layouts[lastBreakpoint];
	    var breakpointsSorted = responsiveUtils.sortBreakpoints(breakpoints);
	    var breakpointsAbove = breakpointsSorted.slice(breakpointsSorted.indexOf(breakpoint));
	    for (var i = 0, len = breakpointsAbove.length; i < len; i++) {
	      var b = breakpointsAbove[i];
	      if (layouts[b]) {
	        layout = layouts[b];
	        break;
	      }
	    }
	    layout = JSON.parse(JSON.stringify(layout || [])); // clone layout so we don't modify existing items
	    return utils.compact(utils.correctBounds(layout, { cols: cols }), verticalCompact);
	  },
	
	  /**
	   * Given breakpoints, return an array of breakpoints sorted by width. This is usually
	   * e.g. ['xxs', 'xs', 'sm', ...]
	   *
	   * @param  {Object} breakpoints Key/value pair of breakpoint names to widths.
	   * @return {Array}              Sorted breakpoints.
	   */
	  sortBreakpoints: function sortBreakpoints(breakpoints) {
	    var keys = Object.keys(breakpoints);
	    return keys.sort(function (a, b) {
	      return breakpoints[a] - breakpoints[b];
	    });
	  }
	};

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(643);
	module.exports.Responsive = __webpack_require__(1195);


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var NotificationItem = __webpack_require__(1199);
	var Constants = __webpack_require__(372);
	var Helpers = __webpack_require__(373);
	
	var NotificationContainer = React.createClass({displayName: "NotificationContainer",
	
	  propTypes: {
	    position: React.PropTypes.string.isRequired,
	    notifications: React.PropTypes.array.isRequired
	  },
	
	  _style: {},
	
	  componentWillMount: function() {
	    // Fix position if width is overrided
	    this._style = this.props.getStyles.container(this.props.position);
	
	    if (this.props.getStyles.overrideWidth && (this.props.position === Constants.positions.tc || this.props.position === Constants.positions.bc)) {
	      this._style['marginLeft'] = -(this.props.getStyles.overrideWidth / 2);
	    }
	  },
	
	  render: function() {
	    var self = this;
	
	    if ([Constants.positions.bl, Constants.positions.br, Constants.positions.bc].indexOf(this.props.position) > -1) {
	      this.props.notifications.reverse();
	    }
	
	    var notifications = this.props.notifications.map(function(notification) {
	      return (
	        React.createElement(NotificationItem, {
	          ref: 'notification-' + notification.uid, 
	          key: notification.uid, 
	          notification: notification, 
	          getStyles: self.props.getStyles, 
	          onRemove: self.props.onRemove, 
	          noAnimation: self.props.noAnimation, 
	          allowHTML: self.props.allowHTML}
	        )
	      );
	    });
	
	    return (
	      React.createElement("div", {className: 'notifications-' + this.props.position, style: this._style}, 
	        notifications
	      )
	    );
	  }
	});
	
	
	module.exports = NotificationContainer;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var Constants = __webpack_require__(372);
	var Styles = __webpack_require__(645);
	var Helpers = __webpack_require__(373);
	var merge = __webpack_require__(646);
	
	var NotificationItem = React.createClass({displayName: "NotificationItem",
	
	  propTypes: {
	    notification: React.PropTypes.object,
	
	    onRemove: React.PropTypes.func,
	    allowHTML: React.PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      noAnimation: false,
	      onRemove: function(uid) {},
	      allowHTML: false
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      visible: false,
	      removed: false,
	    };
	  },
	
	  componentWillMount: function() {
	    var getStyles = this.props.getStyles;
	    var level = this.props.notification.level;
	
	    this._noAnimation = this.props.noAnimation;
	
	    this._styles = {
	      notification: getStyles.notification(level),
	      title: getStyles.title(level),
	      dismiss: getStyles.dismiss(level),
	      messageWrapper: getStyles.messageWrapper(level),
	      actionWrapper: getStyles.actionWrapper(level),
	      action: getStyles.action(level)
	    };
	
	    if (!this.props.notification.dismissible) {
	      this._styles.notification.cursor = 'default';
	    }
	  },
	
	  _styles: {},
	
	  _notificationTimer: null,
	
	  _height: 0,
	
	  _noAnimation: null,
	
	  _isMounted: false,
	
	  _getCssPropertyByPosition: function() {
	    var position = this.props.notification.position;
	    var css = {};
	
	    switch (position) {
	      case Constants.positions.tl:
	      case Constants.positions.bl:
	        css = {
	          property: 'left',
	          value: -200
	        };
	        break;
	
	      case Constants.positions.tr:
	      case Constants.positions.br:
	        css = {
	          property: 'right',
	          value: -200
	        };
	        break;
	
	      case Constants.positions.tc:
	        css = {
	          property: 'top',
	          value: -100
	        };
	        break;
	
	      case Constants.positions.bc:
	        css = {
	          property: 'bottom',
	          value: -100
	        };
	        break;
	    }
	
	    return css;
	  },
	
	  _defaultAction: function(event) {
	    event.preventDefault();
	    var notification = this.props.notification;
	    this._hideNotification();
	    notification.action.callback();
	  },
	
	  _hideNotification: function() {
	    if (this._notificationTimer) {
	      this._notificationTimer.clear();
	    }
	
	    if (this._isMounted) {
	      this.setState({
	        visible: false,
	        removed: true
	      });
	    }
	
	    if (this._noAnimation) {
	      this._removeNotification();
	    }
	  },
	
	  _removeNotification: function() {
	    this.props.onRemove(this.props.notification.uid);
	  },
	
	  _dismiss: function() {
	    if (!this.props.notification.dismissible) {
	      return;
	    }
	
	    this._hideNotification();
	  },
	
	  _showNotification: function() {
	    var self = this;
	    setTimeout(function(){
	      if (self._isMounted) {
	        self.setState({
	          visible: true,
	        });
	      }
	    }, 50);
	  },
	
	  componentDidMount: function() {
	    var self = this;
			var transitionEvent = whichTransitionEvent();
	    var notification = this.props.notification;
	
	    var element = React.findDOMNode(this);
	
	    this._height = element.offsetHeight;
	
	    this._isMounted = true;
	
	    // Watch for transition end
	    var count = 0;
	
	    if (!this._noAnimation) {
	      if (transitionEvent) {
	        element.addEventListener(transitionEvent, function() {
	          if (count > 0) return;
	          if(self.state.removed) {
	            count++;
	            self._removeNotification();
	          }
	        });
	      } else {
	        this._noAnimation = true;
	      }
	    }
	
	
	    if (notification.autoDismiss) {
	      this._notificationTimer = new Helpers.timer(function(){
	        self._hideNotification();
	      }, notification.autoDismiss * 1000);
	
	      element.addEventListener('mouseenter', function() {
	        self._notificationTimer.pause();
	      });
	
	      element.addEventListener('mouseleave', function() {
	        self._notificationTimer.resume();
	      });
	    }
	
	    this._showNotification();
	
	  },
	
	  componentWillUnmount: function() {
	    this._isMounted = false;
	  },
	
	  _allowHTML: function(string) {
	    if (true) {
	      return {__html: string};
	    }
	
	    return string;
	  },
	
	  render: function() {
	    var self = this;
	    var notification = this.props.notification;
	
	    var className = 'notification notification-' + notification.level;
	
	    var notificationStyle = merge({}, this._styles.notification);
	
	    if (this.state.visible) {
	      className = className + ' notification-visible';
	    } else {
	      className = className + ' notification-hidden';
	    }
	
	    if (!notification.dismissible) {
	      className = className + ' notification-not-dismissible';
	    }
	
	    if (this.props.getStyles.overrideStyle) {
	      var cssByPos = this._getCssPropertyByPosition();
	      if (!this.state.visible && !this.state.removed) {
	        notificationStyle[cssByPos.property] = cssByPos.value;
	      }
	
	      if (this.state.visible && !this.state.removed) {
	        notificationStyle.height = this._height;
	        notificationStyle[cssByPos.property] = 0;
	      }
	
	      if (this.state.removed) {
	        notificationStyle.overlay = 'hidden';
	        notificationStyle.height = 0;
	        notificationStyle.marginTop = 0;
	        notificationStyle.paddingTop = 0;
	        notificationStyle.paddingBottom = 0;
	      }
	      notificationStyle.opacity = this.state.visible ? this._styles.notification.isVisible.opacity : this._styles.notification.isHidden.opacity;
	    }
	
	    var dismiss = null;
	    var actionButton = null;
	    var title = null;
	    var message = null;
	
	    if (notification.title) {
	      title = React.createElement("h4", {className: "notification-title", style: this._styles.title}, notification.title);
	    }
	
	    if (notification.message) {
	      if (this.props.allowHTML) {
	        message = (
	          React.createElement("div", {className: "notification-message", style: this._styles.messageWrapper, dangerouslySetInnerHTML: this._allowHTML(notification.message)})
	        );
	      } else {
	        message = (
	          React.createElement("div", {className: "notification-message", style: this._styles.messageWrapper}, notification.message)
	        );
	      }
	    }
	
	    if (notification.dismissible) {
	      dismiss = React.createElement("span", {className: "notification-dismiss", style: this._styles.dismiss}, "×");
	    }
	
	    if (notification.action) {
	      actionButton = (
	        React.createElement("div", {className: "notification-action-wrapper", style: this._styles.actionWrapper}, 
	          React.createElement("button", {className: "notification-action-button", onClick: this._defaultAction, style: this._styles.action}, notification.action.label)
	        )
	      );
	    }
	
	    return (
	      React.createElement("div", {className: className, onClick: this._dismiss, style: notificationStyle}, 
	        title, 
	        message, 
	        dismiss, 
	        actionButton
	      )
	    );
	  }
	
	});
	
	/* From Modernizr */
	function whichTransitionEvent(){
	    var t;
	    var el = document.createElement('fakeelement');
	    var transitions = {
	      'transition':'transitionend',
	      'OTransition':'oTransitionEnd',
	      'MozTransition':'transitionend',
	      'WebkitTransition':'webkitTransitionEnd'
	    };
	
	    for(t in transitions){
	        if( el.style[t] !== undefined ){
	            return transitions[t];
	        }
	    }
	}
	
	
	module.exports = NotificationItem;


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var merge = __webpack_require__(646);
	var NotificationContainer = __webpack_require__(1198);
	var Constants = __webpack_require__(372);
	var Styles = __webpack_require__(645);
	var Helpers = __webpack_require__(373);
	
	var NotificationSystem = React.createClass({displayName: "NotificationSystem",
	
	  uid: 3400,
	
	  _getStyles: {
	    overrideStyle: {},
	
	    overrideWidth: null,
	
	    setOverrideStyle: function(style) {
	      this.overrideStyle = style;
	    },
	
	    wrapper: function() {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.Wrapper || {};
	      return merge({}, Styles.Wrapper, this.overrideStyle);
	    },
	
	    container: function(position) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.Containers || {};
	
	      this.overrideWidth = Styles.Containers.DefaultStyle.width;
	
	      if (override.DefaultStyle && override.DefaultStyle.width) {
	        this.overrideWidth = override.DefaultStyle.width;
	      }
	
	      if (override[position] && override[position].width) {
	        this.overrideWidth = override[position].width;
	      }
	
	      return merge({}, Styles.Containers.DefaultStyle, Styles.Containers[position], override.DefaultStyle, override[position]);
	    },
	
	    notification: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.NotificationItem || {};
	      return merge({}, Styles.NotificationItem.DefaultStyle, Styles.NotificationItem[level], override.DefaultStyle, override[level]);
	    },
	
	    title: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.Title || {};
	      return merge({}, Styles.Title.DefaultStyle, Styles.Title[level], override.DefaultStyle, override[level]);
	    },
	
	    messageWrapper: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.MessageWrapper || {};
	      return merge({}, Styles.MessageWrapper.DefaultStyle, Styles.MessageWrapper[level], override.DefaultStyle, override[level]);
	    },
	
	    dismiss: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.Dismiss || {};
	      return merge({}, Styles.Dismiss.DefaultStyle, Styles.Dismiss[level], override.DefaultStyle, override[level]);
	    },
	
	    action: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.Action || {};
	      return merge({}, Styles.Action.DefaultStyle, Styles.Action[level], override.DefaultStyle, override[level]);
	    },
	
	    actionWrapper: function(level) {
	      if (!this.overrideStyle) return {};
	      var override = this.overrideStyle.ActionWrapper || {};
	      return merge({}, Styles.ActionWrapper.DefaultStyle, Styles.ActionWrapper[level], override.DefaultStyle, override[level]);
	    },
	
	  },
	
	  _didNotificationRemoved: function(uid) {
	    var notification;
	    var notifications = this.state.notifications.filter(function(toCheck) {
	      if (toCheck.uid === uid) {
	        notification = toCheck;
	      }
				return toCheck.uid !== uid;
		  });
	
		  if (notification && notification.onRemove) {
	      notification.onRemove(notification);
	    }
	
	    this.setState({ notifications: notifications });
	  },
	
	  getInitialState: function() {
	    return {
	      notifications: []
	    }
	  },
	
	  getDefaultProps: function() {
	    return {
	      style: {},
	      noAnimation: false
	    }
	  },
	
	  addNotification: function(notification) {
	    var self = this;
	    var notification = merge({}, Constants.notification, notification);
	
	    var error = false;
	
	    try {
	      if (!notification.level) {
	        throw "notification level is required."
	      }
	
	      if (isNaN(notification.autoDismiss)) {
	        throw "'autoDismiss' must be a number."
	      }
	
	      if (Object.keys(Constants.positions).indexOf(notification.position) === -1) {
	        throw "'"+ notification.position +"' is not a valid position."
	      }
	
	      if (Object.keys(Constants.levels).indexOf(notification.level) === -1) {
	        throw "'"+ notification.level +"' is not a valid level."
	      }
	
	    } catch(err) {
	      error = true;
	      console.error('Error adding notification: '+err);
	    }
	
	    if (!error) {
	      var notifications = this.state.notifications;
	
	      // Some preparations
	      notification.position = notification.position.toLowerCase();
	      notification.level = notification.level.toLowerCase();
	      notification.autoDismiss = parseInt(notification.autoDismiss);
	
	      notification.uid = notification.uid || this.uid;
	      notification.ref = "notification-" + notification.uid;
	      this.uid += 1;
	
	      // do not add if the notification already exists based on supplied uid
	      for (var i = 0; i < notifications.length; i++) {
	        if (notifications[i].uid === notification.uid) {
	          return;
	        }
	      }
	
	      notifications.push(notification);
	
	      this.setState({
	        notifications: notifications
	      });
	
	      return notification;
	    }
	
	  },
	
	  removeNotification: function(notification) {
	    var container = this.refs['container-' + notification.position];
	
	    if (container) {
	      var notification = container.refs['notification-' + notification.uid];
	      
	      if (notification) {
	        notification._hideNotification();
	      }
	    }
	  },
	
	  componentDidMount: function() {
	    this._getStyles.setOverrideStyle(this.props.style);
	  },
	
	  render: function() {
	    var self = this;
	    var containers = null;
	    var notifications = this.state.notifications;
	
	    if (notifications.length) {
	      containers = Object.keys(Constants.positions).map(function(position) {
	
	        var _notifications = notifications.filter(function(notification) {
	          return position === notification.position;
	        });
	
	        if (_notifications.length) {
	          return (
	            React.createElement(NotificationContainer, {
	              ref: 'container-'+ position, 
	              key: position, 
	              position: position, 
	              notifications: _notifications, 
	              getStyles: self._getStyles, 
	              onRemove: self._didNotificationRemoved, 
	              noAnimation: self.props.noAnimation, 
	              allowHTML: self.props.allowHTML}
	            )
	          );
	        }
	      });
	    }
	
	
	    return (
	      React.createElement("div", {className: "notifications-wrapper", style: this._getStyles.wrapper()}, 
	        containers
	      )
	
	    );
	  }
	});
	
	module.exports = NotificationSystem;


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _objectWithoutProperties = function (obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; };
	
	var _slicedToArray = function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var Resizable = __webpack_require__(647);
	var PureRenderMixin = __webpack_require__(219);
	
	// An example use of Resizable.
	var ResizableBox = module.exports = React.createClass({
	  displayName: 'ResizableBox',
	  mixins: [PureRenderMixin],
	
	  propTypes: {
	    lockAspectRatio: React.PropTypes.bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      lockAspectRatio: false,
	      handleSize: [20, 20],
	      minConstraints: [20, 20]
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    return {
	      width: this.props.width,
	      height: this.props.height,
	      aspectRatio: this.props.width / this.props.height
	    };
	  },
	
	  onResize: function onResize(event, _ref) {
	    var element = _ref.element;
	    var size = _ref.size;
	    var width = size.width;
	    var height = size.height;
	
	    var widthChanged = width !== this.state.width,
	        heightChanged = height !== this.state.height;
	    if (!widthChanged && !heightChanged) {
	      return;
	    }if (this.props.lockAspectRatio) {
	      var _preserveAspectRatio = this.preserveAspectRatio(width, height);
	
	      var _preserveAspectRatio2 = _slicedToArray(_preserveAspectRatio, 2);
	
	      width = _preserveAspectRatio2[0];
	      height = _preserveAspectRatio2[1];
	    }
	
	    this.setState({
	      width: width,
	      height: height
	    });
	  },
	
	  // If you do this, be careful of constraints
	  preserveAspectRatio: function preserveAspectRatio(width, height) {
	    var min = this.props.minConstraints;
	    var max = this.props.maxConstraints;
	
	    height = width / this.state.aspectRatio;
	    width = height * this.state.aspectRatio;
	
	    if (min) {
	      width = Math.max(min[0], width);
	      height = Math.max(min[1], height);
	    }
	    if (max) {
	      width = Math.min(max[0], width);
	      height = Math.min(max[1], height);
	    }
	    return [width, height];
	  },
	
	  render: function render() {
	    // Basic wrapper around a Resizable instance.
	    // If you use Resizable directly, you are responsible for updating the component
	    // with a new width and height.
	    var _props = this.props;
	    var handleSize = _props.handleSize;
	    var minConstraints = _props.minConstraints;
	    var maxConstraints = _props.maxConstraints;
	
	    var props = _objectWithoutProperties(_props, ['handleSize', 'minConstraints', 'maxConstraints']);
	
	    return React.createElement(
	      Resizable,
	      {
	        minConstraints: minConstraints,
	        maxConstraints: maxConstraints,
	        handleSize: handleSize,
	        width: this.state.width,
	        height: this.state.height,
	        onResize: this.onResize,
	        draggableOpts: this.props.draggableOpts
	      },
	      React.createElement(
	        'div',
	        _extends({ style: { width: this.state.width + 'px', height: this.state.height + 'px' } }, props),
	        this.props.children
	      )
	    );
	  }
	});

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = function() {
	  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
	};
	
	module.exports.Resizable = __webpack_require__(647);
	module.exports.ResizableBox = __webpack_require__(1201);


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/* jshint -W084 */
	var PathUtils = __webpack_require__(374);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, defaultRoute]);
	  } // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) {
	    return new Match(pathname, params, query, [route, notFoundRoute]);
	  } // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) {
	    return new Match(pathname, params, query, [route]);
	  }return null;
	}
	
	var Match = (function () {
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  _createClass(Match, null, {
	    findMatch: {
	
	      /**
	       * Attempts to match depth-first a route in the given route's
	       * subtree against the given path and returns the match if it
	       * succeeds, null if no match can be made.
	       */
	
	      value: function findMatch(routes, path) {
	        var pathname = PathUtils.withoutQuery(path);
	        var query = PathUtils.extractQuery(path);
	        var match = null;
	
	        for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	        return match;
	      }
	    }
	  });
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var warning = __webpack_require__(32);
	var PropTypes = __webpack_require__(90);
	
	function deprecatedMethod(routerMethodName, fn) {
	  return function () {
	    warning(false, "Router.Navigation is deprecated. Please use this.context.router." + routerMethodName + "() instead");
	
	    return fn.apply(this, arguments);
	  };
	}
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: deprecatedMethod("makePath", function (to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  }),
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: deprecatedMethod("makeHref", function (to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  }),
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: deprecatedMethod("transitionTo", function (to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  }),
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: deprecatedMethod("replaceWith", function (to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  }),
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: deprecatedMethod("goBack", function () {
	    return this.context.router.goBack();
	  })
	
	};
	
	module.exports = Navigation;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var invariant = __webpack_require__(15);
	var canUseDOM = __webpack_require__(44).canUseDOM;
	var getWindowScrollPosition = __webpack_require__(1211);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) {
	    return true;
	  } // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) {
	    return false;
	  }var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, "Cannot use scroll behavior without a DOM");
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) {
	      return;
	    }var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var warning = __webpack_require__(32);
	var PropTypes = __webpack_require__(90);
	
	function deprecatedMethod(routerMethodName, fn) {
	  return function () {
	    warning(false, "Router.State is deprecated. Please use this.context.router." + routerMethodName + "() instead");
	
	    return fn.apply(this, arguments);
	  };
	}
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *   
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *   
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: deprecatedMethod("getCurrentPath", function () {
	    return this.context.router.getCurrentPath();
	  }),
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: deprecatedMethod("getCurrentPathname", function () {
	    return this.context.router.getCurrentPathname();
	  }),
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: deprecatedMethod("getCurrentParams", function () {
	    return this.context.router.getCurrentParams();
	  }),
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: deprecatedMethod("getCurrentQuery", function () {
	    return this.context.router.getCurrentQuery();
	  }),
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: deprecatedMethod("getCurrentRoutes", function () {
	    return this.context.router.getCurrentRoutes();
	  }),
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: deprecatedMethod("isActive", function (to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  })
	
	};
	
	module.exports = State;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* jshint -W058 */
	
	var Cancellation = __webpack_require__(648);
	var Redirect = __webpack_require__(649);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || "ABORT";
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ },
/* 1208 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	var React = __webpack_require__(1);
	
	var ContextWrapper = (function (_React$Component) {
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(ContextWrapper, _React$Component);
	
	  _createClass(ContextWrapper, {
	    render: {
	      value: function render() {
	        return this.props.children;
	      }
	    }
	  });
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var React = __webpack_require__(1);
	var assign = __webpack_require__(25);
	var PropTypes = __webpack_require__(90);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  function Link() {
	    _classCallCheck(this, Link);
	
	    if (_React$Component != null) {
	      _React$Component.apply(this, arguments);
	    }
	  }
	
	  _inherits(Link, _React$Component);
	
	  _createClass(Link, {
	    handleClick: {
	      value: function handleClick(event) {
	        var allowTransition = true;
	        var clickResult;
	
	        if (this.props.onClick) clickResult = this.props.onClick(event);
	
	        if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
	          return;
	        }if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	        event.preventDefault();
	
	        if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    getHref: {
	
	      /**
	       * Returns the value of the "href" attribute to use on the DOM element.
	       */
	
	      value: function getHref() {
	        return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    getClassName: {
	
	      /**
	       * Returns the value of the "class" attribute to use on the DOM element, which contains
	       * the value of the activeClassName property when this <Link> is active.
	       */
	
	      value: function getClassName() {
	        var className = this.props.className;
	
	        if (this.getActiveState()) className += " " + this.props.activeClassName;
	
	        return className;
	      }
	    },
	    getActiveState: {
	      value: function getActiveState() {
	        return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	      }
	    },
	    render: {
	      value: function render() {
	        var props = assign({}, this.props, {
	          href: this.getHref(),
	          className: this.getClassName(),
	          onClick: this.handleClick.bind(this)
	        });
	
	        if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	        return React.DOM.a(props, this.props.children);
	      }
	    }
	  });
	
	  return Link;
	})(React.Component);
	
	// TODO: Include these in the above class definition
	// once we can use ES7 property initializers.
	// https://github.com/babel/babel/issues/619
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: "active",
	  className: ""
	};
	
	module.exports = Link;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var invariant = __webpack_require__(15);
	var canUseDOM = __webpack_require__(44).canUseDOM;
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, "Cannot get current scroll position without a DOM");
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = (function () { function defineProperties(target, props) { for (var key in props) { var prop = props[key]; prop.configurable = true; if (prop.value) prop.writable = true; } Object.defineProperties(target, props); } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var invariant = __webpack_require__(15);
	var LocationActions = __webpack_require__(172);
	var History = __webpack_require__(148);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, {
	    needsDOM: {
	      get: function () {
	        return false;
	      }
	    },
	    _updateHistoryLength: {
	      value: function _updateHistoryLength() {
	        History.length = this.history.length;
	      }
	    },
	    _notifyChange: {
	      value: function _notifyChange(type) {
	        var change = {
	          path: this.getCurrentPath(),
	          type: type
	        };
	
	        for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	      }
	    },
	    addChangeListener: {
	      value: function addChangeListener(listener) {
	        this.listeners.push(listener);
	      }
	    },
	    removeChangeListener: {
	      value: function removeChangeListener(listener) {
	        this.listeners = this.listeners.filter(function (l) {
	          return l !== listener;
	        });
	      }
	    },
	    push: {
	      value: function push(path) {
	        this.history.push(path);
	        this._updateHistoryLength();
	        this._notifyChange(LocationActions.PUSH);
	      }
	    },
	    replace: {
	      value: function replace(path) {
	        invariant(this.history.length, "You cannot replace the current path with no history");
	
	        this.history[this.history.length - 1] = path;
	
	        this._notifyChange(LocationActions.REPLACE);
	      }
	    },
	    pop: {
	      value: function pop() {
	        this.history.pop();
	        this._updateHistoryLength();
	        this._notifyChange(LocationActions.POP);
	      }
	    },
	    getCurrentPath: {
	      value: function getCurrentPath() {
	        return this.history[this.history.length - 1];
	      }
	    },
	    toString: {
	      value: function toString() {
	        return "<TestLocation>";
	      }
	    }
	  });
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var createRouter = __webpack_require__(654);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === "function") {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ },
/* 1215 */
/***/ function(module, exports) {

	"use strict";
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) {
	    return false;
	  }
	  return window.history && "pushState" in window.history;
	}
	
	module.exports = supportsHistory;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1217);


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(1219);
	var Parse = __webpack_require__(1218);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(659);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(659);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 1220 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(57);
	var EventPluginUtils = __webpack_require__(218);
	var EventPropagators = __webpack_require__(125);
	var SyntheticUIEvent = __webpack_require__(151);
	var TouchEventUtils = __webpack_require__(1222);
	var ViewportMetrics = __webpack_require__(386);
	
	var keyOf = __webpack_require__(1220);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    topLevelTypes.topTouchCancel,
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  topLevelTypes.topTouchStart,
	  topLevelTypes.topTouchCancel,
	  topLevelTypes.topTouchEnd,
	  topLevelTypes.topTouchMove,
	];
	
	var dependencies = [
	  topLevelTypes.topMouseDown,
	  topLevelTypes.topMouseMove,
	  topLevelTypes.topMouseUp,
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} topLevelTarget The listening component root node.
	     * @param {string} topLevelTargetID ID of `topLevelTarget`.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent,
	        nativeEventTarget) {
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          topLevelTargetID,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 1222 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 1223 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	var defaultClickRejectionStrategy = __webpack_require__(1223);
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  __webpack_require__(124).injection.injectEventPluginsByName({
	    "TapEventPlugin":       __webpack_require__(1221)(shouldRejectClick)
	  });
	};


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPropagators = __webpack_require__(125);
	var ExecutionEnvironment = __webpack_require__(44);
	var FallbackCompositionState = __webpack_require__(1234);
	var SyntheticCompositionEvent = __webpack_require__(1276);
	var SyntheticInputEvent = __webpack_require__(1279);
	
	var keyOf = __webpack_require__(81);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'CompositionEvent' in window
	);
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'TextEvent' in window &&
	  !documentMode &&
	  !isPresto()
	);
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = (
	  ExecutionEnvironment.canUseDOM &&
	  (
	    (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11)
	  )
	);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (
	    typeof opera === 'object' &&
	    typeof opera.version === 'function' &&
	    parseInt(opera.version(), 10) <= 12
	  );
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBeforeInput: null}),
	      captured: keyOf({onBeforeInputCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topTextInput,
	      topLevelTypes.topPaste
	    ]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionEnd: null}),
	      captured: keyOf({onCompositionEndCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionStart: null}),
	      captured: keyOf({onCompositionStartCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionStart,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionUpdate: null}),
	      captured: keyOf({onCompositionUpdateCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionUpdate,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (
	    (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	    // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	    !(nativeEvent.ctrlKey && nativeEvent.altKey)
	  );
	}
	
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return (
	    topLevelType === topLevelTypes.topKeyDown &&
	    nativeEvent.keyCode === START_KEYCODE
	  );
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return (END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1);
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return (nativeEvent.keyCode !== START_KEYCODE);
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(
	    eventType,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (
	      topLevelType === topLevelTypes.topCompositionEnd ||
	      isFallbackCompositionEnd(topLevelType, nativeEvent)
	    ) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(
	    eventTypes.beforeInput,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID,
	    nativeEvent
	  ) {
	    return [
	      extractCompositionEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      ),
	      extractBeforeInputEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      )
	    ];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(15);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function(element, className) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSSCore.addClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function(element, className) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSSCore.removeClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className
	          .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
	          .replace(/\s+/g, ' ') // multiple spaces to one
	          .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function(element, className) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      !/\s/.test(className),
	      'CSS.hasClass takes only a single class name.'
	    ) : invariant(!/\s/.test(className)));
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPluginHub = __webpack_require__(124);
	var EventPropagators = __webpack_require__(125);
	var ExecutionEnvironment = __webpack_require__(44);
	var ReactUpdates = __webpack_require__(70);
	var SyntheticEvent = __webpack_require__(104);
	
	var isEventSupported = __webpack_require__(393);
	var isTextInputElement = __webpack_require__(684);
	var keyOf = __webpack_require__(81);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onChange: null}),
	      captured: keyOf({onChangeCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topChange,
	      topLevelTypes.topClick,
	      topLevelTypes.topFocus,
	      topLevelTypes.topInput,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  return (
	    elem.nodeName === 'SELECT' ||
	    (elem.nodeName === 'INPUT' && elem.type === 'file')
	  );
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (
	    (!('documentMode' in document) || document.documentMode > 8)
	  );
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(
	    eventTypes.change,
	    activeElementID,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue();
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (
	    (!('documentMode' in document) || document.documentMode > 9)
	  );
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp =  {
	  get: function() {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function(val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(
	    target.constructor.prototype,
	    'value'
	  );
	
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange ||
	      topLevelType === topLevelTypes.topKeyUp ||
	      topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return (
	    elem.nodeName === 'INPUT' &&
	    (elem.type === 'checkbox' || elem.type === 'radio')
	  );
	}
	
	function getTargetIDForClickEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(
	          eventTypes.change,
	          targetID,
	          nativeEvent
	        );
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;


/***/ },
/* 1228 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function() {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(1230);
	var ReactMultiChildUpdateTypes = __webpack_require__(671);
	
	var setTextContent = __webpack_require__(1305);
	var invariant = __webpack_require__(15);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	  parentNode.insertBefore(
	    childNode,
	    parentNode.childNodes[index] || null
	  );
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function(updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING ||
	          update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          updatedChild,
	          'processUpdates(): Unable to find child %s of element. This ' +
	          'probably means the DOM was unexpectedly mutated (e.g., by the ' +
	          'browser), usually due to forgetting a <tbody> when using tables, ' +
	          'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' +
	          'in an <svg> parent. Try inspecting the child nodes of the element ' +
	          'with React ID `%s`.',
	          updatedIndex,
	          parentID
	        ) : invariant(updatedChild));
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(
	            update.parentNode,
	            renderedMarkup[update.markupIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(
	            update.parentNode,
	            initialChildren[update.parentID][update.fromIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(
	            update.parentNode,
	            update.textContent
	          );
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;


/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	/*jslint evil: true, sub: true */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var createNodesFromMarkup = __webpack_require__(1288);
	var emptyFunction = __webpack_require__(80);
	var getMarkupWrap = __webpack_require__(681);
	var invariant = __webpack_require__(15);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function(markupList) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' +
	      'thread. Make sure `window` and `document` are available globally ' +
	      'before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        markupList[i],
	        'dangerouslyRenderMarkup(...): Missing markup.'
	      ) : invariant(markupList[i]));
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(
	            OPEN_TAG_NAME_EXP,
	            // This index will be parsed back out below.
	            '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" '
	          );
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(
	        markupListByNodeName.join(''),
	        emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute &&
	            renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	            !resultList.hasOwnProperty(resultIndex),
	            'Danger: Assigning to an already-occupied result index.'
	          ) : invariant(!resultList.hasOwnProperty(resultIndex)));
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	
	        } else if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	          console.error(
	            'Danger: Discarding unexpected node:',
	            renderNode
	          );
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      resultListAssignmentCount === resultList.length,
	      'Danger: Did not assign to every index of resultList.'
	    ) : invariant(resultListAssignmentCount === resultList.length));
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      resultList.length === markupList.length,
	      'Danger: Expected markup to render %s nodes, but rendered %s.',
	      markupList.length,
	      resultList.length
	    ) : invariant(resultList.length === markupList.length));
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' +
	      'worker thread. Make sure `window` and `document` are available ' +
	      'globally before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(markup, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(markup));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      oldChild.tagName.toLowerCase() !== 'html',
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' +
	      '<html> node. This is because browser quirks make this unreliable ' +
	      'and/or slow. If you want to render to the root you must use ' +
	      'server rendering. See React.renderToString().'
	    ) : invariant(oldChild.tagName.toLowerCase() !== 'html'));
	
	    var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(81);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [
	  keyOf({ResponderEventPlugin: null}),
	  keyOf({SimpleEventPlugin: null}),
	  keyOf({TapEventPlugin: null}),
	  keyOf({EnterLeaveEventPlugin: null}),
	  keyOf({ChangeEventPlugin: null}),
	  keyOf({SelectEventPlugin: null}),
	  keyOf({BeforeInputEventPlugin: null}),
	  keyOf({AnalyticsEventPlugin: null}),
	  keyOf({MobileSafariClickEventPlugin: null})
	];
	
	module.exports = DefaultEventPluginOrder;


/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPropagators = __webpack_require__(125);
	var SyntheticMouseEvent = __webpack_require__(223);
	
	var ReactMount = __webpack_require__(75);
	var keyOf = __webpack_require__(81);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({onMouseEnter: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  },
	  mouseLeave: {
	    registrationName: keyOf({onMouseLeave: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topMouseOver &&
	        (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut &&
	        topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from, to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      to =
	        getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement) ||
	        win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromID = from ? ReactMount.getID(from) : '';
	    var toID = to ? ReactMount.getID(to) : '';
	
	    var leave = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseLeave,
	      fromID,
	      nativeEvent
	    );
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseEnter,
	      toID,
	      nativeEvent
	    );
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function(target, eventType, callback) {
	    if (!target.addEventListener) {
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        console.error(
	          'Attempted to listen to events during the capture phase on a ' +
	          'browser that does not support the capture phase. Your application ' +
	          'will not receive some events.'
	        );
	      }
	      return {
	        remove: emptyFunction
	      };
	    } else {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    }
	  },
	
	  registerDefault: function() {}
	};
	
	module.exports = EventListener;


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	
	var assign = __webpack_require__(25);
	var getTextContentAccessor = __webpack_require__(682);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	var ExecutionEnvironment = __webpack_require__(44);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE =
	  DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE =
	  DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = (
	    implementation &&
	    implementation.hasFeature &&
	    implementation.hasFeature(
	      'http://www.w3.org/TR/SVG11/feature#BasicStructure',
	      '1.1'
	    )
	  );
	}
	
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(
	    /^(data|aria)-[a-z_][a-z\d_.\-]*$/
	  ),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusMixin
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // property is supported for OpenGraph in meta tags.
	    property: null,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;


/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedStateMixin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactLink = __webpack_require__(1258);
	var ReactStateSetters = __webpack_require__(1266);
	
	/**
	 * A simple mixin around ReactLink.forState().
	 */
	var LinkedStateMixin = {
	  /**
	   * Create a ReactLink that's linked to part of this component's state. The
	   * ReactLink will have the current value of this.state[key] and will call
	   * setState() when a change is requested.
	   *
	   * @param {string} key state key to update. Note: you may want to use keyOf()
	   * if you're using Google Closure Compiler advanced mode.
	   * @return {ReactLink} ReactLink instance linking to the state.
	   */
	  linkState: function(key) {
	    return new ReactLink(
	      this.state[key],
	      ReactStateSetters.createStateKeySetter(this, key)
	    );
	  }
	};
	
	module.exports = LinkedStateMixin;


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule MobileSafariClickEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	
	var emptyFunction = __webpack_require__(80);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	/**
	 * Mobile Safari does not fire properly bubble click events on non-interactive
	 * elements, which means delegated click listeners do not fire. The workaround
	 * for this bug involves attaching an empty click listener on the target node.
	 *
	 * This particular plugin works around the bug by attaching an empty click
	 * listener on `touchstart` (which does fire on every element).
	 */
	var MobileSafariClickEventPlugin = {
	
	  eventTypes: null,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topTouchStart) {
	      var target = nativeEvent.target;
	      if (target && !target.onclick) {
	        target.onclick = emptyFunction;
	      }
	    }
	  }
	
	};
	
	module.exports = MobileSafariClickEventPlugin;


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(126);
	
	var assign = __webpack_require__(25);
	
	var ReactTransitionGroup = React.createFactory(
	  __webpack_require__(675)
	);
	var ReactCSSTransitionGroupChild = React.createFactory(
	  __webpack_require__(1239)
	);
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: React.PropTypes.string.isRequired,
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function(child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return ReactCSSTransitionGroupChild(
	      {
	        name: this.props.transitionName,
	        appear: this.props.transitionAppear,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave
	      },
	      child
	    );
	  },
	
	  render: function() {
	    return (
	      ReactTransitionGroup(
	        assign({}, this.props, {childFactory: this._wrapChild})
	      )
	    );
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(126);
	
	var CSSCore = __webpack_require__(1226);
	var ReactTransitionEvents = __webpack_require__(1269);
	
	var onlyChild = __webpack_require__(685);
	var warning = __webpack_require__(32);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	var NO_EVENT_TIMEOUT = 5000;
	
	var noEventListener = null;
	
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  noEventListener = function() {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      false,
	      'transition(): tried to perform an animation without ' +
	      'an animationend or transitionend event after timeout (' +
	      '%sms). You should either disable this ' +
	      'transition in JS or add a CSS animation/transition.',
	      NO_EVENT_TIMEOUT
	    ) : null);
	  };
	}
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  transition: function(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '-' + animationType;
	    var activeClassName = className + '-active';
	    var noEventTimeout = null;
	
	    var endListener = function(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        clearTimeout(noEventTimeout);
	      }
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    ReactTransitionEvents.addEndEventListener(node, endListener);
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      noEventTimeout = setTimeout(noEventListener, NO_EVENT_TIMEOUT);
	    }
	  },
	
	  queueClass: function(className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function() {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(
	        CSSCore.addClass.bind(CSSCore, this.getDOMNode())
	      );
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function() {
	    this.classNameQueue = [];
	  },
	
	  componentWillUnmount: function() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  componentWillAppear: function(done) {
	    if (this.props.appear) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },
	
	  render: function() {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(150);
	
	var flattenChildren = __webpack_require__(1291);
	var instantiateReactComponent = __webpack_require__(392);
	var shouldUpdateReactComponent = __webpack_require__(395);
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function(nestedChildNodes, transaction, context) {
	    var children = flattenChildren(nestedChildNodes);
	    for (var name in children) {
	      if (children.hasOwnProperty(name)) {
	        var child = children[name];
	        // The rendered children must be turned into instances as they're
	        // mounted.
	        var childInstance = instantiateReactComponent(child, null);
	        children[name] = childInstance;
	      }
	    }
	    return children;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextNestedChildNodes Nested child maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function(
	    prevChildren,
	    nextNestedChildNodes,
	    transaction,
	    context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    var nextChildren = flattenChildren(nextNestedChildNodes);
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(
	          prevChild, nextElement, transaction, context
	        );
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(
	          nextElement,
	          null
	        );
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) &&
	          !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function(renderedChildren) {
	    for (var name in renderedChildren) {
	      var renderedChild = renderedChildren[name];
	      ReactReconciler.unmountComponent(renderedChild);
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactElementValidator = __webpack_require__(174);
	
	var mapObject = __webpack_require__(1300);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOM = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOM;


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(217);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var keyMirror = __webpack_require__(177);
	
	var button = ReactElement.createFactory('button');
	
	var mouseListenerNames = keyMirror({
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	});
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = ReactClass.createClass({
	  displayName: 'ReactDOMButton',
	  tagName: 'BUTTON',
	
	  mixins: [AutoFocusMixin, ReactBrowserComponentMixin],
	
	  render: function() {
	    var props = {};
	
	    // Copy the props; except the mouse listeners if we're disabled
	    for (var key in this.props) {
	      if (this.props.hasOwnProperty(key) &&
	          (!this.props.disabled || !mouseListenerNames[key])) {
	        props[key] = this.props[key];
	      }
	    }
	
	    return button(props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMButton;


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMForm
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var LocalEventTrapMixin = __webpack_require__(378);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var form = ReactElement.createFactory('form');
	
	/**
	 * Since onSubmit doesn't bubble OR capture on the top level in IE8, we need
	 * to capture it on the <form> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <form> a
	 * composite component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMForm = ReactClass.createClass({
	  displayName: 'ReactDOMForm',
	  tagName: 'FORM',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    // TODO: Instead of using `ReactDOM` directly, we should use JSX. However,
	    // `jshint` fails to parse JSX so in order for linting to work in the open
	    // source repo, we need to just use `ReactDOM.form`.
	    return form(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit');
	  }
	});
	
	module.exports = ReactDOMForm;


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIframe
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var LocalEventTrapMixin = __webpack_require__(378);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var iframe = ReactElement.createFactory('iframe');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <iframe> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <iframe> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMIframe = ReactClass.createClass({
	  displayName: 'ReactDOMIframe',
	  tagName: 'IFRAME',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return iframe(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	  }
	});
	
	module.exports = ReactDOMIframe;


/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMImg
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var LocalEventTrapMixin = __webpack_require__(378);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var img = ReactElement.createFactory('img');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <img> element itself. There are lots of hacks we could do
	 * to accomplish this, but the most reliable is to make <img> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMImg = ReactClass.createClass({
	  displayName: 'ReactDOMImg',
	  tagName: 'IMG',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return img(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error');
	  }
	});
	
	module.exports = ReactDOMImg;


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(217);
	var DOMPropertyOperations = __webpack_require__(173);
	var LinkedValueUtils = __webpack_require__(377);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	var ReactMount = __webpack_require__(75);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	
	var input = ReactElement.createFactory('input');
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = ReactClass.createClass({
	  displayName: 'ReactDOMInput',
	  tagName: 'INPUT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    return {
	      initialChecked: this.props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.defaultChecked = null;
	    props.defaultValue = null;
	
	    var value = LinkedValueUtils.getValue(this);
	    props.value = value != null ? value : this.state.initialValue;
	
	    var checked = LinkedValueUtils.getChecked(this);
	    props.checked = checked != null ? checked : this.state.initialChecked;
	
	    props.onChange = this._handleChange;
	
	    return input(props, this.props.children);
	  },
	
	  componentDidMount: function() {
	    var id = ReactMount.getID(this.getDOMNode());
	    instancesByReactID[id] = this;
	  },
	
	  componentWillUnmount: function() {
	    var rootNode = this.getDOMNode();
	    var id = ReactMount.getID(rootNode);
	    delete instancesByReactID[id];
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var rootNode = this.getDOMNode();
	    if (this.props.checked != null) {
	      DOMPropertyOperations.setValueForProperty(
	        rootNode,
	        'checked',
	        this.props.checked || false
	      );
	    }
	
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    // Here we use asap to wait until all updates have propagated, which
	    // is important when using controlled components within layers:
	    // https://github.com/facebook/react/issues/1698
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	
	    var name = this.props.name;
	    if (this.props.type === 'radio' && name != null) {
	      var rootNode = this.getDOMNode();
	      var queryRoot = rootNode;
	
	      while (queryRoot.parentNode) {
	        queryRoot = queryRoot.parentNode;
	      }
	
	      // If `rootNode.form` was non-null, then we could try `form.elements`,
	      // but that sometimes behaves strangely in IE8. We could also try using
	      // `form.getElementsByName`, but that will only return direct children
	      // and won't include inputs that use the HTML5 `form=` attribute. Since
	      // the input might not even be in a form, let's just use the global
	      // `querySelectorAll` to ensure we don't miss anything.
	      var group = queryRoot.querySelectorAll(
	        'input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	      for (var i = 0, groupLen = group.length; i < groupLen; i++) {
	        var otherNode = group[i];
	        if (otherNode === rootNode ||
	            otherNode.form !== rootNode.form) {
	          continue;
	        }
	        var otherID = ReactMount.getID(otherNode);
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          otherID,
	          'ReactDOMInput: Mixing React and non-React radio inputs with the ' +
	          'same `name` is not supported.'
	        ) : invariant(otherID));
	        var otherInstance = instancesByReactID[otherID];
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          otherInstance,
	          'ReactDOMInput: Unknown radio button ID %s.',
	          otherID
	        ) : invariant(otherInstance));
	        // If this is a controlled radio button group, forcing the input that
	        // was previously checked to update will cause it to be come re-checked
	        // as appropriate.
	        ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	      }
	    }
	
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMInput;


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var warning = __webpack_require__(32);
	
	var option = ReactElement.createFactory('option');
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = ReactClass.createClass({
	  displayName: 'ReactDOMOption',
	  tagName: 'OPTION',
	
	  mixins: [ReactBrowserComponentMixin],
	
	  componentWillMount: function() {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	        this.props.selected == null,
	        'Use the `defaultValue` or `value` props on <select> instead of ' +
	        'setting `selected` on <option>.'
	      ) : null);
	    }
	  },
	
	  render: function() {
	    return option(this.props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMOption;


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(217);
	var LinkedValueUtils = __webpack_require__(377);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	
	var select = ReactElement.createFactory('select');
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  /*jshint validthis:true */
	  if (this._pendingUpdate) {
	    this._pendingUpdate = false;
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null && this.isMounted()) {
	      updateOptions(this, value);
	    }
	  }
	}
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function selectValueType(props, propName, componentName) {
	  if (props[propName] == null) {
	    return null;
	  }
	  if (props.multiple) {
	    if (!Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be an array if ") +
	        ("`multiple` is true.")
	      );
	    }
	  } else {
	    if (Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be a scalar ") +
	        ("value if `multiple` is false.")
	      );
	    }
	  }
	}
	
	/**
	 * @param {ReactComponent} component Instance of ReactDOMSelect
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(component, propValue) {
	  var selectedValue, i, l;
	  var options = component.getDOMNode().options;
	
	  if (component.props.multiple) {
	    selectedValue = {};
	    for (i = 0, l = propValue.length; i < l; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0, l = options.length; i < l; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0, l = options.length; i < l; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = ReactClass.createClass({
	  displayName: 'ReactDOMSelect',
	  tagName: 'SELECT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  propTypes: {
	    defaultValue: selectValueType,
	    value: selectValueType
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.onChange = this._handleChange;
	    props.value = null;
	
	    return select(props, this.props.children);
	  },
	
	  componentWillMount: function() {
	    this._pendingUpdate = false;
	  },
	
	  componentDidMount: function() {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      updateOptions(this, value);
	    } else if (this.props.defaultValue != null) {
	      updateOptions(this, this.props.defaultValue);
	    }
	  },
	
	  componentDidUpdate: function(prevProps) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      this._pendingUpdate = false;
	      updateOptions(this, value);
	    } else if (!prevProps.multiple !== !this.props.multiple) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (this.props.defaultValue != null) {
	        updateOptions(this, this.props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(this, this.props.multiple ? [] : '');
	      }
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	
	    this._pendingUpdate = true;
	    ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMSelect;


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var getNodeForCharacterOffset = __webpack_require__(1293);
	var getTextContentAccessor = __webpack_require__(682);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(
	    selection.anchorNode,
	    selection.anchorOffset,
	    selection.focusNode,
	    selection.focusOffset
	  );
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(
	    tempRange.startContainer,
	    tempRange.startOffset,
	    tempRange.endContainer,
	    tempRange.endOffset
	  );
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ?
	            start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = (
	  ExecutionEnvironment.canUseDOM &&
	  'selection' in document &&
	  !('getSelection' in window)
	);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(217);
	var DOMPropertyOperations = __webpack_require__(173);
	var LinkedValueUtils = __webpack_require__(377);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	var invariant = __webpack_require__(15);
	
	var warning = __webpack_require__(32);
	
	var textarea = ReactElement.createFactory('textarea');
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = ReactClass.createClass({
	  displayName: 'ReactDOMTextarea',
	  tagName: 'TEXTAREA',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = this.props.children;
	    if (children != null) {
	      if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	          false,
	          'Use the `defaultValue` or `value` props instead of setting ' +
	          'children on <textarea>.'
	        ) : null);
	      }
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        defaultValue == null,
	        'If you supply `defaultValue` on a <textarea>, do not pass children.'
	      ) : invariant(defaultValue == null));
	      if (Array.isArray(children)) {
	        ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	          children.length <= 1,
	          '<textarea> can only have at most one child.'
	        ) : invariant(children.length <= 1));
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(this);
	    return {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue)
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      props.dangerouslySetInnerHTML == null,
	      '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
	    ) : invariant(props.dangerouslySetInnerHTML == null));
	
	    props.defaultValue = null;
	    props.value = null;
	    props.onChange = this._handleChange;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    return textarea(props, this.state.initialValue);
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      var rootNode = this.getDOMNode();
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMTextarea;


/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(70);
	var Transaction = __webpack_require__(224);
	
	var assign = __webpack_require__(25);
	var emptyFunction = __webpack_require__(80);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(
	  ReactDefaultBatchingStrategyTransaction.prototype,
	  Transaction.Mixin,
	  {
	    getTransactionWrappers: function() {
	      return TRANSACTION_WRAPPERS;
	    }
	  }
	);
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function(callback, a, b, c, d) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d);
	    } else {
	      transaction.perform(callback, null, a, b, c, d);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;


/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(1225);
	var ChangeEventPlugin = __webpack_require__(1227);
	var ClientReactRootIndex = __webpack_require__(1228);
	var DefaultEventPluginOrder = __webpack_require__(1231);
	var EnterLeaveEventPlugin = __webpack_require__(1232);
	var ExecutionEnvironment = __webpack_require__(44);
	var HTMLDOMPropertyConfig = __webpack_require__(1235);
	var MobileSafariClickEventPlugin = __webpack_require__(1237);
	var ReactBrowserComponentMixin = __webpack_require__(92);
	var ReactClass = __webpack_require__(69);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(379);
	var ReactDefaultBatchingStrategy = __webpack_require__(1251);
	var ReactDOMComponent = __webpack_require__(382);
	var ReactDOMButton = __webpack_require__(1242);
	var ReactDOMForm = __webpack_require__(1243);
	var ReactDOMImg = __webpack_require__(1245);
	var ReactDOMIDOperations = __webpack_require__(666);
	var ReactDOMIframe = __webpack_require__(1244);
	var ReactDOMInput = __webpack_require__(1246);
	var ReactDOMOption = __webpack_require__(1247);
	var ReactDOMSelect = __webpack_require__(1248);
	var ReactDOMTextarea = __webpack_require__(1250);
	var ReactDOMTextComponent = __webpack_require__(667);
	var ReactElement = __webpack_require__(38);
	var ReactEventListener = __webpack_require__(1256);
	var ReactInjection = __webpack_require__(1257);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactMount = __webpack_require__(75);
	var ReactReconcileTransaction = __webpack_require__(1262);
	var SelectEventPlugin = __webpack_require__(1272);
	var ServerReactRootIndex = __webpack_require__(1273);
	var SimpleEventPlugin = __webpack_require__(1274);
	var SVGDOMPropertyConfig = __webpack_require__(1271);
	
	var createFullPageComponent = __webpack_require__(1287);
	
	function autoGenerateWrapperClass(type) {
	  return ReactClass.createClass({
	    tagName: type.toUpperCase(),
	    render: function() {
	      return new ReactElement(
	        type,
	        null,
	        null,
	        null,
	        null,
	        this.props
	      );
	    }
	  });
	}
	
	function inject() {
	  ReactInjection.EventEmitter.injectReactEventListener(
	    ReactEventListener
	  );
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    MobileSafariClickEventPlugin: MobileSafariClickEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(
	    ReactDOMComponent
	  );
	
	  ReactInjection.NativeComponent.injectTextComponentClass(
	    ReactDOMTextComponent
	  );
	
	  ReactInjection.NativeComponent.injectAutoWrapper(
	    autoGenerateWrapperClass
	  );
	
	  // This needs to happen before createFullPageComponent() otherwise the mixin
	  // won't be included.
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.NativeComponent.injectComponentClasses({
	    'button': ReactDOMButton,
	    'form': ReactDOMForm,
	    'iframe': ReactDOMIframe,
	    'img': ReactDOMImg,
	    'input': ReactDOMInput,
	    'option': ReactDOMOption,
	    'select': ReactDOMSelect,
	    'textarea': ReactDOMTextarea,
	
	    'html': createFullPageComponent('html'),
	    'head': createFullPageComponent('head'),
	    'body': createFullPageComponent('body')
	  });
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(
	    ReactReconcileTransaction
	  );
	  ReactInjection.Updates.injectBatchingStrategy(
	    ReactDefaultBatchingStrategy
	  );
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(
	    ExecutionEnvironment.canUseDOM ?
	      ClientReactRootIndex.createReactRootIndex :
	      ServerReactRootIndex.createReactRootIndex
	  );
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	  ReactInjection.DOMComponent.injectIDOperations(ReactDOMIDOperations);
	
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    var url = (ExecutionEnvironment.canUseDOM && window.location.href) || '';
	    if ((/[?&]react_perf\b/).test(url)) {
	      var ReactDefaultPerf = __webpack_require__(668);
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultPerfAnalysis
	 */
	
	var assign = __webpack_require__(25);
	
	// Don't try to save users less than 1.2ms (a number I made up)
	var DONT_CARE_THRESHOLD = 1.2;
	var DOM_OPERATION_TYPES = {
	  '_mountImageIntoNode': 'set innerHTML',
	  INSERT_MARKUP: 'set innerHTML',
	  MOVE_EXISTING: 'move',
	  REMOVE_NODE: 'remove',
	  TEXT_CONTENT: 'set textContent',
	  'updatePropertyByID': 'update attribute',
	  'deletePropertyByID': 'delete attribute',
	  'updateStylesByID': 'update styles',
	  'updateInnerHTMLByID': 'set innerHTML',
	  'dangerouslyReplaceNodeWithMarkupByID': 'replace'
	};
	
	function getTotalTime(measurements) {
	  // TODO: return number of DOM ops? could be misleading.
	  // TODO: measure dropped frames after reconcile?
	  // TODO: log total time of each reconcile and the top-level component
	  // class that triggered it.
	  var totalTime = 0;
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    totalTime += measurement.totalTime;
	  }
	  return totalTime;
	}
	
	function getDOMSummary(measurements) {
	  var items = [];
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var id;
	
	    for (id in measurement.writes) {
	      measurement.writes[id].forEach(function(write) {
	        items.push({
	          id: id,
	          type: DOM_OPERATION_TYPES[write.type] || write.type,
	          args: write.args
	        });
	      });
	    }
	  }
	  return items;
	}
	
	function getExclusiveSummary(measurements) {
	  var candidates = {};
	  var displayName;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign(
	      {},
	      measurement.exclusive,
	      measurement.inclusive
	    );
	
	    for (var id in allIDs) {
	      displayName = measurement.displayNames[id].current;
	
	      candidates[displayName] = candidates[displayName] || {
	        componentName: displayName,
	        inclusive: 0,
	        exclusive: 0,
	        render: 0,
	        count: 0
	      };
	      if (measurement.render[id]) {
	        candidates[displayName].render += measurement.render[id];
	      }
	      if (measurement.exclusive[id]) {
	        candidates[displayName].exclusive += measurement.exclusive[id];
	      }
	      if (measurement.inclusive[id]) {
	        candidates[displayName].inclusive += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[displayName].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (displayName in candidates) {
	    if (candidates[displayName].exclusive >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[displayName]);
	    }
	  }
	
	  arr.sort(function(a, b) {
	    return b.exclusive - a.exclusive;
	  });
	
	  return arr;
	}
	
	function getInclusiveSummary(measurements, onlyClean) {
	  var candidates = {};
	  var inclusiveKey;
	
	  for (var i = 0; i < measurements.length; i++) {
	    var measurement = measurements[i];
	    var allIDs = assign(
	      {},
	      measurement.exclusive,
	      measurement.inclusive
	    );
	    var cleanComponents;
	
	    if (onlyClean) {
	      cleanComponents = getUnchangedComponents(measurement);
	    }
	
	    for (var id in allIDs) {
	      if (onlyClean && !cleanComponents[id]) {
	        continue;
	      }
	
	      var displayName = measurement.displayNames[id];
	
	      // Inclusive time is not useful for many components without knowing where
	      // they are instantiated. So we aggregate inclusive time with both the
	      // owner and current displayName as the key.
	      inclusiveKey = displayName.owner + ' > ' + displayName.current;
	
	      candidates[inclusiveKey] = candidates[inclusiveKey] || {
	        componentName: inclusiveKey,
	        time: 0,
	        count: 0
	      };
	
	      if (measurement.inclusive[id]) {
	        candidates[inclusiveKey].time += measurement.inclusive[id];
	      }
	      if (measurement.counts[id]) {
	        candidates[inclusiveKey].count += measurement.counts[id];
	      }
	    }
	  }
	
	  // Now make a sorted array with the results.
	  var arr = [];
	  for (inclusiveKey in candidates) {
	    if (candidates[inclusiveKey].time >= DONT_CARE_THRESHOLD) {
	      arr.push(candidates[inclusiveKey]);
	    }
	  }
	
	  arr.sort(function(a, b) {
	    return b.time - a.time;
	  });
	
	  return arr;
	}
	
	function getUnchangedComponents(measurement) {
	  // For a given reconcile, look at which components did not actually
	  // render anything to the DOM and return a mapping of their ID to
	  // the amount of time it took to render the entire subtree.
	  var cleanComponents = {};
	  var dirtyLeafIDs = Object.keys(measurement.writes);
	  var allIDs = assign({}, measurement.exclusive, measurement.inclusive);
	
	  for (var id in allIDs) {
	    var isDirty = false;
	    // For each component that rendered, see if a component that triggered
	    // a DOM op is in its subtree.
	    for (var i = 0; i < dirtyLeafIDs.length; i++) {
	      if (dirtyLeafIDs[i].indexOf(id) === 0) {
	        isDirty = true;
	        break;
	      }
	    }
	    if (!isDirty && measurement.counts[id] > 0) {
	      cleanComponents[id] = true;
	    }
	  }
	  return cleanComponents;
	}
	
	var ReactDefaultPerfAnalysis = {
	  getExclusiveSummary: getExclusiveSummary,
	  getInclusiveSummary: getInclusiveSummary,
	  getDOMSummary: getDOMSummary,
	  getTotalTime: getTotalTime
	};
	
	module.exports = ReactDefaultPerfAnalysis;


/***/ },
/* 1254 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	"use strict";
	
	var ReactErrorUtils = {
	  /**
	   * Creates a guarded version of a function. This is supposed to make debugging
	   * of event handlers easier. To aid debugging with the browser's debugger,
	   * this currently simply returns the original function.
	   *
	   * @param {function} func Function to be executed
	   * @param {string} name The name of the guard
	   * @return {function}
	   */
	  guard: function(func, name) {
	    return func;
	  }
	};
	
	module.exports = ReactErrorUtils;


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(124);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue();
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events = EventPluginHub.extractEvents(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent
	    );
	
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(1233);
	var ExecutionEnvironment = __webpack_require__(44);
	var PooledClass = __webpack_require__(91);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactMount = __webpack_require__(75);
	var ReactUpdates = __webpack_require__(70);
	
	var assign = __webpack_require__(25);
	var getEventTarget = __webpack_require__(391);
	var getUnboundedScrollPosition = __webpack_require__(1295);
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(
	  TopLevelCallbackBookKeeping,
	  PooledClass.twoArgumentPooler
	);
	
	function handleTopLevelImpl(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(
	    getEventTarget(bookKeeping.nativeEvent)
	  ) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0, l = bookKeeping.ancestors.length; i < l; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(
	      bookKeeping.topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      bookKeeping.nativeEvent
	    );
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function() {
	    return ReactEventListener._enabled;
	  },
	
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  monitorScrollValue: function(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
	      topLevelType,
	      nativeEvent
	    );
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;


/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	var EventPluginHub = __webpack_require__(124);
	var ReactComponentEnvironment = __webpack_require__(380);
	var ReactClass = __webpack_require__(69);
	var ReactEmptyComponent = __webpack_require__(220);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	var ReactNativeComponent = __webpack_require__(221);
	var ReactDOMComponent = __webpack_require__(382);
	var ReactPerf = __webpack_require__(103);
	var ReactRootIndex = __webpack_require__(674);
	var ReactUpdates = __webpack_require__(70);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMComponent: ReactDOMComponent.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLink
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactLink encapsulates a common pattern in which a component wants to modify
	 * a prop received from its parent. ReactLink allows the parent to pass down a
	 * value coupled with a callback that, when invoked, expresses an intent to
	 * modify that value. For example:
	 *
	 * React.createClass({
	 *   getInitialState: function() {
	 *     return {value: ''};
	 *   },
	 *   render: function() {
	 *     var valueLink = new ReactLink(this.state.value, this._handleValueChange);
	 *     return <input valueLink={valueLink} />;
	 *   },
	 *   this._handleValueChange: function(newValue) {
	 *     this.setState({value: newValue});
	 *   }
	 * });
	 *
	 * We have provided some sugary mixins to make the creation and
	 * consumption of ReactLink easier; see LinkedValueUtils and LinkedStateMixin.
	 */
	
	var React = __webpack_require__(126);
	
	/**
	 * @param {*} value current value of the link
	 * @param {function} requestChange callback to request a change
	 */
	function ReactLink(value, requestChange) {
	  this.value = value;
	  this.requestChange = requestChange;
	}
	
	/**
	 * Creates a PropType that enforces the ReactLink API and optionally checks the
	 * type of the value being passed inside the link. Example:
	 *
	 * MyComponent.propTypes = {
	 *   tabIndexLink: ReactLink.PropTypes.link(React.PropTypes.number)
	 * }
	 */
	function createLinkTypeChecker(linkType) {
	  var shapes = {
	    value: typeof linkType === 'undefined' ?
	      React.PropTypes.any.isRequired :
	      linkType.isRequired,
	    requestChange: React.PropTypes.func.isRequired
	  };
	  return React.PropTypes.shape(shapes);
	}
	
	ReactLink.PropTypes = {
	  link: createLinkTypeChecker
	};
	
	module.exports = ReactLink;


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(380);
	var ReactMultiChildUpdateTypes = __webpack_require__(671);
	
	var ReactReconciler = __webpack_require__(150);
	var ReactChildReconciler = __webpack_require__(1240);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    textContent: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    textContent: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(
	      updateQueue,
	      markupQueue
	    );
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function(nestedChildren, transaction, context) {
	      var children = ReactChildReconciler.instantiateChildren(
	        nestedChildren, transaction, context
	      );
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(
	            child,
	            rootID,
	            transaction,
	            context
	          );
	          child._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function(nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function(nextNestedChildren, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildren, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function(nextNestedChildren, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = ReactChildReconciler.updateChildren(
	        prevChildren, nextNestedChildren, transaction, context
	      );
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChildByName(prevChild, name);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(
	            nextChild, name, nextIndex, transaction, context
	          );
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) &&
	            !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChildByName(prevChildren[name], name);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function() {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function(child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function(child, mountImage) {
	      enqueueMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function(child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function(textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function(
	      child,
	      name,
	      index,
	      transaction,
	      context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(
	        child,
	        rootID,
	        transaction,
	        context
	      );
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child by name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @param {string} name Name of the child in `this._renderedChildren`.
	     * @private
	     */
	    _unmountChildByName: function(child, name) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(15);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function(object) {
	    return !!(
	      (object &&
	      typeof object.attachRef === 'function' && typeof object.detachRef === 'function')
	    );
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function(component, ref, owner) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'addComponentAsRefTo(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to add a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function(component, ref, owner) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to remove a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTransferer
	 */
	
	'use strict';
	
	var assign = __webpack_require__(25);
	var emptyFunction = __webpack_require__(80);
	var joinClasses = __webpack_require__(1299);
	
	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}
	
	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return assign({}, b, a);
	});
	
	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};
	
	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }
	
	    var transferStrategy = TransferStrategies[thisKey];
	
	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}
	
	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {
	
	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(assign({}, oldProps), newProps);
	  }
	
	};
	
	module.exports = ReactPropTransferer;


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(376);
	var PooledClass = __webpack_require__(91);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	var ReactInputSelection = __webpack_require__(669);
	var ReactPutListenerQueue = __webpack_require__(673);
	var Transaction = __webpack_require__(224);
	
	var assign = __webpack_require__(25);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occured. `close`
	   *   restores the previous value.
	   */
	  close: function(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function() {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: function() {
	    this.putListenerQueue.putListeners();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  SELECTION_RESTORATION,
	  EVENT_SUPPRESSION,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction() {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap proceedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1260);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function(prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  return (
	    nextElement._owner !== prevElement._owner ||
	    nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(38);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactMarkupChecksum = __webpack_require__(670);
	var ReactServerRenderingTransaction =
	  __webpack_require__(1265);
	
	var emptyObject = __webpack_require__(176);
	var instantiateReactComponent = __webpack_require__(392);
	var invariant = __webpack_require__(15);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToString(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup =
	        componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToStaticMarkup(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(91);
	var CallbackQueue = __webpack_require__(376);
	var ReactPutListenerQueue = __webpack_require__(673);
	var Transaction = __webpack_require__(224);
	
	var assign = __webpack_require__(25);
	var emptyFunction = __webpack_require__(80);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap proceedures.
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(
	  ReactServerRenderingTransaction.prototype,
	  Transaction.Mixin,
	  Mixin
	);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;


/***/ },
/* 1266 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactStateSetters
	 */
	
	'use strict';
	
	var ReactStateSetters = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(component, funcReturningState) {
	    return function(a, b, c, d, e, f) {
	      var partialState = funcReturningState.call(component, a, b, c, d, e, f);
	      if (partialState) {
	        component.setState(partialState);
	      }
	    };
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {ReactCompositeComponent} component
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(component, key) {
	    // Memoize the setters.
	    var cache = component.__keySetters || (component.__keySetters = {});
	    return cache[key] || (cache[key] = createStateKeySetter(component, key));
	  }
	};
	
	function createStateKeySetter(component, key) {
	  // Partial state is allocated outside of the function closure so it can be
	  // reused with every call, avoiding memory allocation when this function
	  // is called.
	  var partialState = {};
	  return function stateKeySetter(value) {
	    partialState[key] = value;
	    component.setState(partialState);
	  };
	}
	
	ReactStateSetters.Mixin = {
	  /**
	   * Returns a function that calls the provided function, and uses the result
	   * of that to set the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateSetter(function(xValue) {
	   *     return {x: xValue};
	   *   })(1);
	   *
	   * @param {function} funcReturningState Returned callback uses this to
	   *                                      determine how to update state.
	   * @return {function} callback that when invoked uses funcReturningState to
	   *                    determined the object literal to setState.
	   */
	  createStateSetter: function(funcReturningState) {
	    return ReactStateSetters.createStateSetter(this, funcReturningState);
	  },
	
	  /**
	   * Returns a single-argument callback that can be used to update a single
	   * key in the component's state.
	   *
	   * For example, these statements are equivalent:
	   *
	   *   this.setState({x: 1});
	   *   this.createStateKeySetter('x')(1);
	   *
	   * Note: this is memoized function, which makes it inexpensive to call.
	   *
	   * @param {string} key The key in the state that you should update.
	   * @return {function} callback of 1 argument which calls setState() with
	   *                    the provided keyName and callback argument.
	   */
	  createStateKeySetter: function(key) {
	    return ReactStateSetters.createStateKeySetter(this, key);
	  }
	};
	
	module.exports = ReactStateSetters;


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTestUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPluginHub = __webpack_require__(124);
	var EventPropagators = __webpack_require__(125);
	var React = __webpack_require__(126);
	var ReactElement = __webpack_require__(38);
	var ReactEmptyComponent = __webpack_require__(220);
	var ReactBrowserEventEmitter = __webpack_require__(127);
	var ReactCompositeComponent = __webpack_require__(665);
	var ReactInstanceHandles = __webpack_require__(128);
	var ReactInstanceMap = __webpack_require__(129);
	var ReactMount = __webpack_require__(75);
	var ReactUpdates = __webpack_require__(70);
	var SyntheticEvent = __webpack_require__(104);
	
	var assign = __webpack_require__(25);
	var emptyObject = __webpack_require__(176);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function Event(suffix) {}
	
	/**
	 * @class ReactTestUtils
	 */
	
	/**
	 * Todo: Support the entire DOM.scry query syntax. For now, these simple
	 * utilities will suffice for testing purposes.
	 * @lends ReactTestUtils
	 */
	var ReactTestUtils = {
	  renderIntoDocument: function(instance) {
	    var div = document.createElement('div');
	    // None of our tests actually require attaching the container to the
	    // DOM, and doing so creates a mess that we rely on test isolation to
	    // clean up, so we're going to stop honoring the name of this method
	    // (and probably rename it eventually) if no problems arise.
	    // document.documentElement.appendChild(div);
	    return React.render(instance, div);
	  },
	
	  isElement: function(element) {
	    return ReactElement.isValidElement(element);
	  },
	
	  isElementOfType: function(inst, convenienceConstructor) {
	    return (
	      ReactElement.isValidElement(inst) &&
	      inst.type === convenienceConstructor
	    );
	  },
	
	  isDOMComponent: function(inst) {
	    // TODO: Fix this heuristic. It's just here because composites can currently
	    // pretend to be DOM components.
	    return !!(inst && inst.tagName && inst.getDOMNode);
	  },
	
	  isDOMComponentElement: function(inst) {
	    return !!(inst &&
	              ReactElement.isValidElement(inst) &&
	              !!inst.tagName);
	  },
	
	  isCompositeComponent: function(inst) {
	    return typeof inst.render === 'function' &&
	           typeof inst.setState === 'function';
	  },
	
	  isCompositeComponentWithType: function(inst, type) {
	    return !!(ReactTestUtils.isCompositeComponent(inst) &&
	             (inst.constructor === type));
	  },
	
	  isCompositeComponentElement: function(inst) {
	    if (!ReactElement.isValidElement(inst)) {
	      return false;
	    }
	    // We check the prototype of the type that will get mounted, not the
	    // instance itself. This is a future proof way of duck typing.
	    var prototype = inst.type.prototype;
	    return (
	      typeof prototype.render === 'function' &&
	      typeof prototype.setState === 'function'
	    );
	  },
	
	  isCompositeComponentElementWithType: function(inst, type) {
	    return !!(ReactTestUtils.isCompositeComponentElement(inst) &&
	             (inst.constructor === type));
	  },
	
	  getRenderedChildOfCompositeComponent: function(inst) {
	    if (!ReactTestUtils.isCompositeComponent(inst)) {
	      return null;
	    }
	    var internalInstance = ReactInstanceMap.get(inst);
	    return internalInstance._renderedComponent.getPublicInstance();
	  },
	
	  findAllInRenderedTree: function(inst, test) {
	    if (!inst) {
	      return [];
	    }
	    var ret = test(inst) ? [inst] : [];
	    if (ReactTestUtils.isDOMComponent(inst)) {
	      var internalInstance = ReactInstanceMap.get(inst);
	      var renderedChildren = internalInstance
	        ._renderedComponent
	        ._renderedChildren;
	      var key;
	      for (key in renderedChildren) {
	        if (!renderedChildren.hasOwnProperty(key)) {
	          continue;
	        }
	        if (!renderedChildren[key].getPublicInstance) {
	          continue;
	        }
	        ret = ret.concat(
	          ReactTestUtils.findAllInRenderedTree(
	            renderedChildren[key].getPublicInstance(),
	            test
	          )
	        );
	      }
	    } else if (ReactTestUtils.isCompositeComponent(inst)) {
	      ret = ret.concat(
	        ReactTestUtils.findAllInRenderedTree(
	          ReactTestUtils.getRenderedChildOfCompositeComponent(inst),
	          test
	        )
	      );
	    }
	    return ret;
	  },
	
	  /**
	   * Finds all instance of components in the rendered tree that are DOM
	   * components with the class name matching `className`.
	   * @return an array of all the matches.
	   */
	  scryRenderedDOMComponentsWithClass: function(root, className) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      var instClassName = inst.props.className;
	      return ReactTestUtils.isDOMComponent(inst) && (
	        (instClassName && (' ' + instClassName + ' ').indexOf(' ' + className + ' ') !== -1)
	      );
	    });
	  },
	
	  /**
	   * Like scryRenderedDOMComponentsWithClass but expects there to be one result,
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactDOMComponent} The one match.
	   */
	  findRenderedDOMComponentWithClass: function(root, className) {
	    var all =
	      ReactTestUtils.scryRenderedDOMComponentsWithClass(root, className);
	    if (all.length !== 1) {
	      throw new Error('Did not find exactly one match ' +
	        '(found: ' + all.length + ') for class:' + className
	      );
	    }
	    return all[0];
	  },
	
	
	  /**
	   * Finds all instance of components in the rendered tree that are DOM
	   * components with the tag name matching `tagName`.
	   * @return an array of all the matches.
	   */
	  scryRenderedDOMComponentsWithTag: function(root, tagName) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      return ReactTestUtils.isDOMComponent(inst) &&
	            inst.tagName === tagName.toUpperCase();
	    });
	  },
	
	  /**
	   * Like scryRenderedDOMComponentsWithTag but expects there to be one result,
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactDOMComponent} The one match.
	   */
	  findRenderedDOMComponentWithTag: function(root, tagName) {
	    var all = ReactTestUtils.scryRenderedDOMComponentsWithTag(root, tagName);
	    if (all.length !== 1) {
	      throw new Error('Did not find exactly one match for tag:' + tagName);
	    }
	    return all[0];
	  },
	
	
	  /**
	   * Finds all instances of components with type equal to `componentType`.
	   * @return an array of all the matches.
	   */
	  scryRenderedComponentsWithType: function(root, componentType) {
	    return ReactTestUtils.findAllInRenderedTree(root, function(inst) {
	      return ReactTestUtils.isCompositeComponentWithType(
	        inst,
	        componentType
	      );
	    });
	  },
	
	  /**
	   * Same as `scryRenderedComponentsWithType` but expects there to be one result
	   * and returns that one result, or throws exception if there is any other
	   * number of matches besides one.
	   * @return {!ReactComponent} The one match.
	   */
	  findRenderedComponentWithType: function(root, componentType) {
	    var all = ReactTestUtils.scryRenderedComponentsWithType(
	      root,
	      componentType
	    );
	    if (all.length !== 1) {
	      throw new Error(
	        'Did not find exactly one match for componentType:' + componentType
	      );
	    }
	    return all[0];
	  },
	
	  /**
	   * Pass a mocked component module to this method to augment it with
	   * useful methods that allow it to be used as a dummy React component.
	   * Instead of rendering as usual, the component will become a simple
	   * <div> containing any provided children.
	   *
	   * @param {object} module the mock function object exported from a
	   *                        module that defines the component to be mocked
	   * @param {?string} mockTagName optional dummy root tag name to return
	   *                              from render method (overrides
	   *                              module.mockTagName if provided)
	   * @return {object} the ReactTestUtils object (for chaining)
	   */
	  mockComponent: function(module, mockTagName) {
	    mockTagName = mockTagName || module.mockTagName || "div";
	
	    module.prototype.render.mockImplementation(function() {
	      return React.createElement(
	        mockTagName,
	        null,
	        this.props.children
	      );
	    });
	
	    return this;
	  },
	
	  /**
	   * Simulates a top level event being dispatched from a raw event that occured
	   * on an `Element` node.
	   * @param topLevelType {Object} A type from `EventConstants.topLevelTypes`
	   * @param {!Element} node The dom to simulate an event occurring on.
	   * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
	   */
	  simulateNativeEventOnNode: function(topLevelType, node, fakeNativeEvent) {
	    fakeNativeEvent.target = node;
	    ReactBrowserEventEmitter.ReactEventListener.dispatchEvent(
	      topLevelType,
	      fakeNativeEvent
	    );
	  },
	
	  /**
	   * Simulates a top level event being dispatched from a raw event that occured
	   * on the `ReactDOMComponent` `comp`.
	   * @param topLevelType {Object} A type from `EventConstants.topLevelTypes`.
	   * @param comp {!ReactDOMComponent}
	   * @param {?Event} fakeNativeEvent Fake native event to use in SyntheticEvent.
	   */
	  simulateNativeEventOnDOMComponent: function(
	      topLevelType,
	      comp,
	      fakeNativeEvent) {
	    ReactTestUtils.simulateNativeEventOnNode(
	      topLevelType,
	      comp.getDOMNode(),
	      fakeNativeEvent
	    );
	  },
	
	  nativeTouchData: function(x, y) {
	    return {
	      touches: [
	        {pageX: x, pageY: y}
	      ]
	    };
	  },
	
	  createRenderer: function() {
	    return new ReactShallowRenderer();
	  },
	
	  Simulate: null,
	  SimulateNative: {}
	};
	
	/**
	 * @class ReactShallowRenderer
	 */
	var ReactShallowRenderer = function() {
	  this._instance = null;
	};
	
	ReactShallowRenderer.prototype.getRenderOutput = function() {
	  return (
	    (this._instance && this._instance._renderedComponent &&
	     this._instance._renderedComponent._renderedOutput)
	    || null
	  );
	};
	
	var NoopInternalComponent = function(element) {
	  this._renderedOutput = element;
	  this._currentElement = element === null || element === false ?
	    ReactEmptyComponent.emptyElement :
	    element;
	};
	
	NoopInternalComponent.prototype = {
	
	  mountComponent: function() {
	  },
	
	  receiveComponent: function(element) {
	    this._renderedOutput = element;
	    this._currentElement = element === null || element === false ?
	      ReactEmptyComponent.emptyElement :
	      element;
	  },
	
	  unmountComponent: function() {
	  }
	
	};
	
	var ShallowComponentWrapper = function() { };
	assign(
	  ShallowComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin, {
	    _instantiateReactComponent: function(element) {
	      return new NoopInternalComponent(element);
	    },
	    _replaceNodeWithMarkupByID: function() {},
	    _renderValidatedComponent:
	      ReactCompositeComponent.Mixin.
	        _renderValidatedComponentWithoutOwnerOrContext
	  }
	);
	
	ReactShallowRenderer.prototype.render = function(element, context) {
	  if (!context) {
	    context = emptyObject;
	  }
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  this._render(element, transaction, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	};
	
	ReactShallowRenderer.prototype.unmount = function() {
	  if (this._instance) {
	    this._instance.unmountComponent();
	  }
	};
	
	ReactShallowRenderer.prototype._render = function(element, transaction, context) {
	  if (!this._instance) {
	    var rootID = ReactInstanceHandles.createReactRootID();
	    var instance = new ShallowComponentWrapper(element.type);
	    instance.construct(element);
	
	    instance.mountComponent(rootID, transaction, context);
	
	    this._instance = instance;
	  } else {
	    this._instance.receiveComponent(element, transaction, context);
	  }
	};
	
	/**
	 * Exports:
	 *
	 * - `ReactTestUtils.Simulate.click(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.Simulate.mouseMove(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.Simulate.change(Element/ReactDOMComponent)`
	 * - ... (All keys from event plugin `eventTypes` objects)
	 */
	function makeSimulator(eventType) {
	  return function(domComponentOrNode, eventData) {
	    var node;
	    if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
	      node = domComponentOrNode.getDOMNode();
	    } else if (domComponentOrNode.tagName) {
	      node = domComponentOrNode;
	    }
	
	    var fakeNativeEvent = new Event();
	    fakeNativeEvent.target = node;
	    // We don't use SyntheticEvent.getPooled in order to not have to worry about
	    // properly destroying any properties assigned from `eventData` upon release
	    var event = new SyntheticEvent(
	      ReactBrowserEventEmitter.eventNameDispatchConfigs[eventType],
	      ReactMount.getID(node),
	      fakeNativeEvent
	    );
	    assign(event, eventData);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	
	    ReactUpdates.batchedUpdates(function() {
	      EventPluginHub.enqueueEvents(event);
	      EventPluginHub.processEventQueue();
	    });
	  };
	}
	
	function buildSimulators() {
	  ReactTestUtils.Simulate = {};
	
	  var eventType;
	  for (eventType in ReactBrowserEventEmitter.eventNameDispatchConfigs) {
	    /**
	     * @param {!Element || ReactDOMComponent} domComponentOrNode
	     * @param {?object} eventData Fake event data to use in SyntheticEvent.
	     */
	    ReactTestUtils.Simulate[eventType] = makeSimulator(eventType);
	  }
	}
	
	// Rebuild ReactTestUtils.Simulate whenever event plugins are injected
	var oldInjectEventPluginOrder = EventPluginHub.injection.injectEventPluginOrder;
	EventPluginHub.injection.injectEventPluginOrder = function() {
	  oldInjectEventPluginOrder.apply(this, arguments);
	  buildSimulators();
	};
	var oldInjectEventPlugins = EventPluginHub.injection.injectEventPluginsByName;
	EventPluginHub.injection.injectEventPluginsByName = function() {
	  oldInjectEventPlugins.apply(this, arguments);
	  buildSimulators();
	};
	
	buildSimulators();
	
	/**
	 * Exports:
	 *
	 * - `ReactTestUtils.SimulateNative.click(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseMove(Element/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseIn/ReactDOMComponent)`
	 * - `ReactTestUtils.SimulateNative.mouseOut(Element/ReactDOMComponent)`
	 * - ... (All keys from `EventConstants.topLevelTypes`)
	 *
	 * Note: Top level event types are a subset of the entire set of handler types
	 * (which include a broader set of "synthetic" events). For example, onDragDone
	 * is a synthetic event. Except when testing an event plugin or React's event
	 * handling code specifically, you probably want to use ReactTestUtils.Simulate
	 * to dispatch synthetic events.
	 */
	
	function makeNativeSimulator(eventType) {
	  return function(domComponentOrNode, nativeEventData) {
	    var fakeNativeEvent = new Event(eventType);
	    assign(fakeNativeEvent, nativeEventData);
	    if (ReactTestUtils.isDOMComponent(domComponentOrNode)) {
	      ReactTestUtils.simulateNativeEventOnDOMComponent(
	        eventType,
	        domComponentOrNode,
	        fakeNativeEvent
	      );
	    } else if (!!domComponentOrNode.tagName) {
	      // Will allow on actual dom nodes.
	      ReactTestUtils.simulateNativeEventOnNode(
	        eventType,
	        domComponentOrNode,
	        fakeNativeEvent
	      );
	    }
	  };
	}
	
	var eventType;
	for (eventType in topLevelTypes) {
	  // Event type is stored as 'topClick' - we transform that to 'click'
	  var convenienceName = eventType.indexOf('top') === 0 ?
	    eventType.charAt(3).toLowerCase() + eventType.substr(4) : eventType;
	  /**
	   * @param {!Element || ReactDOMComponent} domComponentOrNode
	   * @param {?Event} nativeEventData Fake native event to use in SyntheticEvent.
	   */
	  ReactTestUtils.SimulateNative[convenienceName] =
	    makeNativeSimulator(eventType);
	}
	
	module.exports = ReactTestUtils;


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(663);
	var ReactFragment = __webpack_require__(149);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around ReactChildren.map().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function(children) {
	    if (!children) {
	      return children;
	    }
	    return ReactFragment.extract(ReactChildren.map(children, function(child) {
	      return child;
	    }));
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function(prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(
	            pendingNextKey
	          );
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactWithAddons
	 */
	
	/**
	 * This module exists purely in the open source project, and is meant as a way
	 * to create a separate standalone build of React. This build has "addons", or
	 * functionality we've built and think might be useful but doesn't have a good
	 * place to live inside React core.
	 */
	
	'use strict';
	
	var LinkedStateMixin = __webpack_require__(1236);
	var React = __webpack_require__(126);
	var ReactComponentWithPureRenderMixin =
	  __webpack_require__(219);
	var ReactCSSTransitionGroup = __webpack_require__(1238);
	var ReactFragment = __webpack_require__(149);
	var ReactTransitionGroup = __webpack_require__(675);
	var ReactUpdates = __webpack_require__(70);
	
	var cx = __webpack_require__(1289);
	var cloneWithProps = __webpack_require__(175);
	var update = __webpack_require__(1307);
	
	React.addons = {
	  CSSTransitionGroup: ReactCSSTransitionGroup,
	  LinkedStateMixin: LinkedStateMixin,
	  PureRenderMixin: ReactComponentWithPureRenderMixin,
	  TransitionGroup: ReactTransitionGroup,
	
	  batchedUpdates: ReactUpdates.batchedUpdates,
	  classSet: cx,
	  cloneWithProps: cloneWithProps,
	  createFragment: ReactFragment.create,
	  update: update
	};
	
	if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	  React.addons.Perf = __webpack_require__(668);
	  React.addons.TestUtils = __webpack_require__(1267);
	}
	
	module.exports = React;


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(123);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPropagators = __webpack_require__(125);
	var ReactInputSelection = __webpack_require__(669);
	var SyntheticEvent = __webpack_require__(104);
	
	var getActiveElement = __webpack_require__(679);
	var isTextInputElement = __webpack_require__(684);
	var keyOf = __webpack_require__(81);
	var shallowEqual = __webpack_require__(686);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSelect: null}),
	      captured: keyOf({onSelectCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topContextMenu,
	      topLevelTypes.topFocus,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topMouseDown,
	      topLevelTypes.topMouseUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @param {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node &&
	      ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown ||
	      activeElement == null ||
	      activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(
	      eventTypes.select,
	      activeElementID,
	      nativeEvent
	    );
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) ||
	            topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't).
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      case topLevelTypes.topSelectionChange:
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent);
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;


/***/ },
/* 1273 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function() {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(57);
	var EventPluginUtils = __webpack_require__(218);
	var EventPropagators = __webpack_require__(125);
	var SyntheticClipboardEvent = __webpack_require__(1275);
	var SyntheticEvent = __webpack_require__(104);
	var SyntheticFocusEvent = __webpack_require__(1278);
	var SyntheticKeyboardEvent = __webpack_require__(1280);
	var SyntheticMouseEvent = __webpack_require__(223);
	var SyntheticDragEvent = __webpack_require__(1277);
	var SyntheticTouchEvent = __webpack_require__(1281);
	var SyntheticUIEvent = __webpack_require__(151);
	var SyntheticWheelEvent = __webpack_require__(1282);
	
	var getEventCharCode = __webpack_require__(389);
	
	var invariant = __webpack_require__(15);
	var keyOf = __webpack_require__(81);
	var warning = __webpack_require__(32);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBlur: true}),
	      captured: keyOf({onBlurCapture: true})
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onClick: true}),
	      captured: keyOf({onClickCapture: true})
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onContextMenu: true}),
	      captured: keyOf({onContextMenuCapture: true})
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCopy: true}),
	      captured: keyOf({onCopyCapture: true})
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCut: true}),
	      captured: keyOf({onCutCapture: true})
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDoubleClick: true}),
	      captured: keyOf({onDoubleClickCapture: true})
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrag: true}),
	      captured: keyOf({onDragCapture: true})
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnd: true}),
	      captured: keyOf({onDragEndCapture: true})
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnter: true}),
	      captured: keyOf({onDragEnterCapture: true})
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragExit: true}),
	      captured: keyOf({onDragExitCapture: true})
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragLeave: true}),
	      captured: keyOf({onDragLeaveCapture: true})
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragOver: true}),
	      captured: keyOf({onDragOverCapture: true})
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragStart: true}),
	      captured: keyOf({onDragStartCapture: true})
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrop: true}),
	      captured: keyOf({onDropCapture: true})
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onFocus: true}),
	      captured: keyOf({onFocusCapture: true})
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onInput: true}),
	      captured: keyOf({onInputCapture: true})
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyDown: true}),
	      captured: keyOf({onKeyDownCapture: true})
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyPress: true}),
	      captured: keyOf({onKeyPressCapture: true})
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyUp: true}),
	      captured: keyOf({onKeyUpCapture: true})
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onLoad: true}),
	      captured: keyOf({onLoadCapture: true})
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onError: true}),
	      captured: keyOf({onErrorCapture: true})
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseDown: true}),
	      captured: keyOf({onMouseDownCapture: true})
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseMove: true}),
	      captured: keyOf({onMouseMoveCapture: true})
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOut: true}),
	      captured: keyOf({onMouseOutCapture: true})
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOver: true}),
	      captured: keyOf({onMouseOverCapture: true})
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseUp: true}),
	      captured: keyOf({onMouseUpCapture: true})
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onPaste: true}),
	      captured: keyOf({onPasteCapture: true})
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onReset: true}),
	      captured: keyOf({onResetCapture: true})
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScroll: true}),
	      captured: keyOf({onScrollCapture: true})
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSubmit: true}),
	      captured: keyOf({onSubmitCapture: true})
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchCancel: true}),
	      captured: keyOf({onTouchCancelCapture: true})
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchEnd: true}),
	      captured: keyOf({onTouchEndCapture: true})
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchMove: true}),
	      captured: keyOf({onTouchMoveCapture: true})
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchStart: true}),
	      captured: keyOf({onTouchStartCapture: true})
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onWheel: true}),
	      captured: keyOf({onWheelCapture: true})
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topBlur:        eventTypes.blur,
	  topClick:       eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy:        eventTypes.copy,
	  topCut:         eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag:        eventTypes.drag,
	  topDragEnd:     eventTypes.dragEnd,
	  topDragEnter:   eventTypes.dragEnter,
	  topDragExit:    eventTypes.dragExit,
	  topDragLeave:   eventTypes.dragLeave,
	  topDragOver:    eventTypes.dragOver,
	  topDragStart:   eventTypes.dragStart,
	  topDrop:        eventTypes.drop,
	  topError:       eventTypes.error,
	  topFocus:       eventTypes.focus,
	  topInput:       eventTypes.input,
	  topKeyDown:     eventTypes.keyDown,
	  topKeyPress:    eventTypes.keyPress,
	  topKeyUp:       eventTypes.keyUp,
	  topLoad:        eventTypes.load,
	  topMouseDown:   eventTypes.mouseDown,
	  topMouseMove:   eventTypes.mouseMove,
	  topMouseOut:    eventTypes.mouseOut,
	  topMouseOver:   eventTypes.mouseOver,
	  topMouseUp:     eventTypes.mouseUp,
	  topPaste:       eventTypes.paste,
	  topReset:       eventTypes.reset,
	  topScroll:      eventTypes.scroll,
	  topSubmit:      eventTypes.submit,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd:    eventTypes.touchEnd,
	  topTouchMove:   eventTypes.touchMove,
	  topTouchStart:  eventTypes.touchStart,
	  topWheel:       eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * Same as the default implementation, except cancels the event when return
	   * value is false. This behavior will be disabled in a future release.
	   *
	   * @param {object} Event to be dispatched.
	   * @param {function} Application-level callback.
	   * @param {string} domID DOM ID to pass to the callback.
	   */
	  executeDispatch: function(event, listener, domID) {
	    var returnValue = EventPluginUtils.executeDispatch(event, listener, domID);
	
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      typeof returnValue !== 'boolean',
	      'Returning `false` from an event handler is deprecated and will be ' +
	      'ignored in a future release. Instead, manually call ' +
	      'e.stopPropagation() or e.preventDefault(), as appropriate.'
	    ) : null);
	
	    if (returnValue === false) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  },
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topError:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSubmit:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      EventConstructor,
	      'SimpleEventPlugin: Unhandled event type, `%s`.',
	      topLevelType
	    ) : invariant(EventConstructor));
	    var event = EventConstructor.getPooled(
	      dispatchConfig,
	      topLevelTargetID,
	      nativeEvent
	    );
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }
	
	};
	
	module.exports = SimpleEventPlugin;


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(104);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function(event) {
	    return (
	      'clipboardData' in event ?
	        event.clipboardData :
	        window.clipboardData
	    );
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(104);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticCompositionEvent,
	  CompositionEventInterface
	);
	
	module.exports = SyntheticCompositionEvent;


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(223);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(151);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(104);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticInputEvent,
	  InputEventInterface
	);
	
	module.exports = SyntheticInputEvent;


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(151);
	
	var getEventCharCode = __webpack_require__(389);
	var getEventKey = __webpack_require__(1292);
	var getEventModifierState = __webpack_require__(390);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(151);
	
	var getEventModifierState = __webpack_require__(390);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(223);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function(event) {
	    return (
	      'deltaX' in event ? event.deltaX :
	      // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	      'wheelDeltaX' in event ? -event.wheelDeltaX : 0
	    );
	  },
	  deltaY: function(event) {
	    return (
	      'deltaY' in event ? event.deltaY :
	      // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	      'wheelDeltaY' in event ? -event.wheelDeltaY :
	      // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	      'wheelDelta' in event ? -event.wheelDelta : 0
	    );
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;


/***/ },
/* 1283 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	/* jslint bitwise:true */
	
	'use strict';
	
	var MOD = 65521;
	
	// This is a clean-room implementation of adler32 designed for detecting
	// if markup is not what we expect it to be. It does not need to be
	// cryptographically strong, only reasonably good at detecting if markup
	// generated on the server is different than that on the client.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  for (var i = 0; i < data.length; i++) {
	    a = (a + data.charCodeAt(i)) % MOD;
	    b = (b + a) % MOD;
	  }
	  return a | (b << 16);
	}
	
	module.exports = adler32;


/***/ },
/* 1284 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function(_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var camelize = __webpack_require__(1284);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	var toArray = __webpack_require__(1306);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj &&
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    ('length' in obj) &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    (typeof obj.nodeType != 'number') &&
	    (
	      // a real array
	      (// HTMLCollection/NodeList
	      (Array.isArray(obj) ||
	      // arguments
	      ('callee' in obj) || 'item' in obj))
	    )
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createFullPageComponent
	 * @typechecks
	 */
	
	'use strict';
	
	// Defeat circular references by requiring this directly.
	var ReactClass = __webpack_require__(69);
	var ReactElement = __webpack_require__(38);
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Create a component that will throw an exception when unmounted.
	 *
	 * Components like <html> <head> and <body> can't be removed or added
	 * easily in a cross-browser way, however it's valuable to be able to
	 * take advantage of React's reconciliation for styling and <title>
	 * management. So we just document it and throw in dangerous cases.
	 *
	 * @param {string} tag The tag to wrap
	 * @return {function} convenience constructor of new component
	 */
	function createFullPageComponent(tag) {
	  var elementFactory = ReactElement.createFactory(tag);
	
	  var FullPageComponent = ReactClass.createClass({
	    tagName: tag.toUpperCase(),
	    displayName: 'ReactFullPageComponent' + tag,
	
	    componentWillUnmount: function() {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        false,
	        '%s tried to unmount. Because of cross-browser quirks it is ' +
	        'impossible to unmount some top-level components (eg <html>, <head>, ' +
	        'and <body>) reliably and efficiently. To fix this, have a single ' +
	        'top-level component that never unmounts render these elements.',
	        this.constructor.displayName
	      ) : invariant(false));
	    },
	
	    render: function() {
	      return elementFactory(this.props);
	    }
	  });
	
	  return FullPageComponent;
	}
	
	module.exports = createFullPageComponent;


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*jslint evil: true, sub: true */
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var createArrayFromMixed = __webpack_require__(1286);
	var getMarkupWrap = __webpack_require__(681);
	var invariant = __webpack_require__(15);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(!!dummyNode, 'createNodesFromMarkup dummy not initialized') : invariant(!!dummyNode));
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      handleScript,
	      'createNodesFromMarkup(...): Unexpected <script> element rendered.'
	    ) : invariant(handleScript));
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule cx
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	
	'use strict';
	var warning = __webpack_require__(32);
	
	var warned = false;
	
	function cx(classNames) {
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      warned,
	      'React.addons.classSet will be deprecated in a future version. See ' +
	      'http://fb.me/react-addons-classset'
	    ) : null);
	    warned = true;
	  }
	
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function(className) {
	      return classNames[className];
	    }).join(' ');
	  } else {
	    return Array.prototype.join.call(arguments, ' ');
	  }
	}
	
	module.exports = cx;


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(660);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 ||
	      isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(687);
	var warning = __webpack_require__(32);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = !result.hasOwnProperty(name);
	  if ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? warning(
	      keyUnique,
	      'flattenChildren(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(389);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;


/***/ },
/* 1293 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;


/***/ },
/* 1294 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getReactRootElementInContainer
	 */
	
	'use strict';
	
	var DOC_NODE_TYPE = 9;
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 *                                           a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	module.exports = getReactRootElementInContainer;


/***/ },
/* 1295 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	"use strict";
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;


/***/ },
/* 1296 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(1296);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(683);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;


/***/ },
/* 1299 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;


/***/ },
/* 1300 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;


/***/ },
/* 1301 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function(string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performance
	 * @typechecks
	 */
	
	"use strict";
	
	var ExecutionEnvironment = __webpack_require__(44);
	
	var performance;
	
	if (ExecutionEnvironment.canUseDOM) {
	  performance =
	    window.performance ||
	    window.msPerformance ||
	    window.webkitPerformance;
	}
	
	module.exports = performance || {};


/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule performanceNow
	 * @typechecks
	 */
	
	var performance = __webpack_require__(1302);
	
	/**
	 * Detect if we can use `window.performance.now()` and gracefully fallback to
	 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
	 * because of Facebook's testing infrastructure.
	 */
	if (!performance || !performance.now) {
	  performance = Date;
	}
	
	var performanceNow = performance.now.bind(performance);
	
	module.exports = performanceNow;


/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(225);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;


/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(44);
	var escapeTextContentForBrowser = __webpack_require__(225);
	var setInnerHTML = __webpack_require__(394);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function(node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function(node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;


/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(15);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    !Array.isArray(obj) &&
	    (typeof obj === 'object' || typeof obj === 'function'),
	    'toArray: Array-like object expected'
	  ) : invariant(!Array.isArray(obj) &&
	  (typeof obj === 'object' || typeof obj === 'function')));
	
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    typeof length === 'number',
	    'toArray: Object needs a length property'
	  ) : invariant(typeof length === 'number'));
	
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    length === 0 ||
	    (length - 1) in obj,
	    'toArray: Object should have keys for indices'
	  ) : invariant(length === 0 ||
	  (length - 1) in obj));
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;


/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule update
	 */
	
	 /* global hasOwnProperty:true */
	
	'use strict';
	
	var assign = __webpack_require__(25);
	var keyOf = __webpack_require__(81);
	var invariant = __webpack_require__(15);
	var hasOwnProperty = {}.hasOwnProperty;
	
	function shallowCopy(x) {
	  if (Array.isArray(x)) {
	    return x.concat();
	  } else if (x && typeof x === 'object') {
	    return assign(new x.constructor(), x);
	  } else {
	    return x;
	  }
	}
	
	var COMMAND_PUSH = keyOf({$push: null});
	var COMMAND_UNSHIFT = keyOf({$unshift: null});
	var COMMAND_SPLICE = keyOf({$splice: null});
	var COMMAND_SET = keyOf({$set: null});
	var COMMAND_MERGE = keyOf({$merge: null});
	var COMMAND_APPLY = keyOf({$apply: null});
	
	var ALL_COMMANDS_LIST = [
	  COMMAND_PUSH,
	  COMMAND_UNSHIFT,
	  COMMAND_SPLICE,
	  COMMAND_SET,
	  COMMAND_MERGE,
	  COMMAND_APPLY
	];
	
	var ALL_COMMANDS_SET = {};
	
	ALL_COMMANDS_LIST.forEach(function(command) {
	  ALL_COMMANDS_SET[command] = true;
	});
	
	function invariantArrayCase(value, spec, command) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  ) : invariant(Array.isArray(value)));
	  var specValue = spec[command];
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  ) : invariant(Array.isArray(specValue)));
	}
	
	function update(value, spec) {
	  ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	    typeof spec === 'object',
	    'update(): You provided a key path to update() that did not contain one ' +
	    'of %s. Did you forget to include {%s: ...}?',
	    ALL_COMMANDS_LIST.join(', '),
	    COMMAND_SET
	  ) : invariant(typeof spec === 'object'));
	
	  if (hasOwnProperty.call(spec, COMMAND_SET)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      Object.keys(spec).length === 1,
	      'Cannot have more than one key in an object with %s',
	      COMMAND_SET
	    ) : invariant(Object.keys(spec).length === 1));
	
	    return spec[COMMAND_SET];
	  }
	
	  var nextValue = shallowCopy(value);
	
	  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
	    var mergeObj = spec[COMMAND_MERGE];
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      mergeObj && typeof mergeObj === 'object',
	      'update(): %s expects a spec of type \'object\'; got %s',
	      COMMAND_MERGE,
	      mergeObj
	    ) : invariant(mergeObj && typeof mergeObj === 'object'));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      nextValue && typeof nextValue === 'object',
	      'update(): %s expects a target of type \'object\'; got %s',
	      COMMAND_MERGE,
	      nextValue
	    ) : invariant(nextValue && typeof nextValue === 'object'));
	    assign(nextValue, spec[COMMAND_MERGE]);
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
	    invariantArrayCase(value, spec, COMMAND_PUSH);
	    spec[COMMAND_PUSH].forEach(function(item) {
	      nextValue.push(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
	    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
	    spec[COMMAND_UNSHIFT].forEach(function(item) {
	      nextValue.unshift(item);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      Array.isArray(value),
	      'Expected %s target to be an array; got %s',
	      COMMAND_SPLICE,
	      value
	    ) : invariant(Array.isArray(value)));
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      Array.isArray(spec[COMMAND_SPLICE]),
	      'update(): expected spec of %s to be an array of arrays; got %s. ' +
	      'Did you forget to wrap your parameters in an array?',
	      COMMAND_SPLICE,
	      spec[COMMAND_SPLICE]
	    ) : invariant(Array.isArray(spec[COMMAND_SPLICE])));
	    spec[COMMAND_SPLICE].forEach(function(args) {
	      ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	        Array.isArray(args),
	        'update(): expected spec of %s to be an array of arrays; got %s. ' +
	        'Did you forget to wrap your parameters in an array?',
	        COMMAND_SPLICE,
	        spec[COMMAND_SPLICE]
	      ) : invariant(Array.isArray(args)));
	      nextValue.splice.apply(nextValue, args);
	    });
	  }
	
	  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
	    ("production" !== ({"URL_API":"https://app.brewplanner.com","GOOGLE_ANALYTICS":"UA-75168659-1","NODE_ENV":"production"}).NODE_ENV ? invariant(
	      typeof spec[COMMAND_APPLY] === 'function',
	      'update(): expected spec of %s to be a function; got %s.',
	      COMMAND_APPLY,
	      spec[COMMAND_APPLY]
	    ) : invariant(typeof spec[COMMAND_APPLY] === 'function'));
	    nextValue = spec[COMMAND_APPLY](nextValue);
	  }
	
	  for (var k in spec) {
	    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
	      nextValue[k] = update(value[k], spec[k]);
	    }
	  }
	
	  return nextValue;
	}
	
	module.exports = update;


/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(157);
	var callBind = __webpack_require__(235);
	
	var implementation = __webpack_require__(688);
	var getPolyfill = __webpack_require__(689);
	var shim = __webpack_require__(1309);
	
	var flagsBound = callBind(getPolyfill());
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(157).supportsDescriptors;
	var getPolyfill = __webpack_require__(689);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(158);
	var define = __webpack_require__(307);
	var hasDescriptors = __webpack_require__(310)();
	var gOPD = __webpack_require__(417);
	
	var $TypeError = __webpack_require__(133);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(307);
	var hasDescriptors = __webpack_require__(310)();
	var functionsHaveConfigurableNames = __webpack_require__(815).functionsHaveConfigurableNames();
	
	var $TypeError = __webpack_require__(133);
	
	/** @type {import('.')} */
	module.exports = function setFunctionName(fn, name) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		var loose = arguments.length > 2 && !!arguments[2];
		if (!loose || functionsHaveConfigurableNames) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'name', name);
			}
		}
		return fn;
	};


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Spectrum Colorpicker v1.8.0
	// https://github.com/bgrins/spectrum
	// Author: Brian Grinstead
	// License: MIT
	
	(function (factory) {
	    "use strict";
	
	    if (true) { // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(188)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof exports == "object" && typeof module == "object") { // CommonJS
	        module.exports = factory(require('jquery'));
	    }
	    else { // Browser
	        factory(jQuery);
	    }
	})(function($, undefined) {
	    "use strict";
	
	    var defaultOpts = {
	
	        // Callbacks
	        beforeShow: noop,
	        move: noop,
	        change: noop,
	        show: noop,
	        hide: noop,
	
	        // Options
	        color: false,
	        flat: false,
	        showInput: false,
	        allowEmpty: false,
	        showButtons: true,
	        clickoutFiresChange: true,
	        showInitial: false,
	        showPalette: false,
	        showPaletteOnly: false,
	        hideAfterPaletteSelect: false,
	        togglePaletteOnly: false,
	        showSelectionPalette: true,
	        localStorageKey: false,
	        appendTo: "body",
	        maxSelectionSize: 7,
	        cancelText: "cancel",
	        chooseText: "choose",
	        togglePaletteMoreText: "more",
	        togglePaletteLessText: "less",
	        clearText: "Clear Color Selection",
	        noColorSelectedText: "No Color Selected",
	        preferredFormat: false,
	        className: "", // Deprecated - use containerClassName and replacerClassName instead.
	        containerClassName: "",
	        replacerClassName: "",
	        showAlpha: false,
	        theme: "sp-light",
	        palette: [["#ffffff", "#000000", "#ff0000", "#ff8000", "#ffff00", "#008000", "#0000ff", "#4b0082", "#9400d3"]],
	        selectionPalette: [],
	        disabled: false,
	        offset: null
	    },
	    spectrums = [],
	    IE = !!/msie/i.exec( window.navigator.userAgent ),
	    rgbaSupport = (function() {
	        function contains( str, substr ) {
	            return !!~('' + str).indexOf(substr);
	        }
	
	        var elem = document.createElement('div');
	        var style = elem.style;
	        style.cssText = 'background-color:rgba(0,0,0,.5)';
	        return contains(style.backgroundColor, 'rgba') || contains(style.backgroundColor, 'hsla');
	    })(),
	    replaceInput = [
	        "<div class='sp-replacer'>",
	            "<div class='sp-preview'><div class='sp-preview-inner'></div></div>",
	            "<div class='sp-dd'>&#9660;</div>",
	        "</div>"
	    ].join(''),
	    markup = (function () {
	
	        // IE does not support gradients with multiple stops, so we need to simulate
	        //  that for the rainbow slider with 8 divs that each have a single gradient
	        var gradientFix = "";
	        if (IE) {
	            for (var i = 1; i <= 6; i++) {
	                gradientFix += "<div class='sp-" + i + "'></div>";
	            }
	        }
	
	        return [
	            "<div class='sp-container sp-hidden'>",
	                "<div class='sp-palette-container'>",
	                    "<div class='sp-palette sp-thumb sp-cf'></div>",
	                    "<div class='sp-palette-button-container sp-cf'>",
	                        "<button type='button' class='sp-palette-toggle'></button>",
	                    "</div>",
	                "</div>",
	                "<div class='sp-picker-container'>",
	                    "<div class='sp-top sp-cf'>",
	                        "<div class='sp-fill'></div>",
	                        "<div class='sp-top-inner'>",
	                            "<div class='sp-color'>",
	                                "<div class='sp-sat'>",
	                                    "<div class='sp-val'>",
	                                        "<div class='sp-dragger'></div>",
	                                    "</div>",
	                                "</div>",
	                            "</div>",
	                            "<div class='sp-clear sp-clear-display'>",
	                            "</div>",
	                            "<div class='sp-hue'>",
	                                "<div class='sp-slider'></div>",
	                                gradientFix,
	                            "</div>",
	                        "</div>",
	                        "<div class='sp-alpha'><div class='sp-alpha-inner'><div class='sp-alpha-handle'></div></div></div>",
	                    "</div>",
	                    "<div class='sp-input-container sp-cf'>",
	                        "<input class='sp-input' type='text' spellcheck='false'  />",
	                    "</div>",
	                    "<div class='sp-initial sp-thumb sp-cf'></div>",
	                    "<div class='sp-button-container sp-cf'>",
	                        "<a class='sp-cancel' href='#'></a>",
	                        "<button type='button' class='sp-choose'></button>",
	                    "</div>",
	                "</div>",
	            "</div>"
	        ].join("");
	    })();
	
	    function paletteTemplate (p, color, className, opts) {
	        var html = [];
	        for (var i = 0; i < p.length; i++) {
	            var current = p[i];
	            if(current) {
	                var tiny = tinycolor(current);
	                var c = tiny.toHsl().l < 0.5 ? "sp-thumb-el sp-thumb-dark" : "sp-thumb-el sp-thumb-light";
	                c += (tinycolor.equals(color, current)) ? " sp-thumb-active" : "";
	                var formattedString = tiny.toString(opts.preferredFormat || "rgb");
	                var swatchStyle = rgbaSupport ? ("background-color:" + tiny.toRgbString()) : "filter:" + tiny.toFilter();
	                html.push('<span title="' + formattedString + '" data-color="' + tiny.toRgbString() + '" class="' + c + '"><span class="sp-thumb-inner" style="' + swatchStyle + ';" /></span>');
	            } else {
	                var cls = 'sp-clear-display';
	                html.push($('<div />')
	                    .append($('<span data-color="" style="background-color:transparent;" class="' + cls + '"></span>')
	                        .attr('title', opts.noColorSelectedText)
	                    )
	                    .html()
	                );
	            }
	        }
	        return "<div class='sp-cf " + className + "'>" + html.join('') + "</div>";
	    }
	
	    function hideAll() {
	        for (var i = 0; i < spectrums.length; i++) {
	            if (spectrums[i]) {
	                spectrums[i].hide();
	            }
	        }
	    }
	
	    function instanceOptions(o, callbackContext) {
	        var opts = $.extend({}, defaultOpts, o);
	        opts.callbacks = {
	            'move': bind(opts.move, callbackContext),
	            'change': bind(opts.change, callbackContext),
	            'show': bind(opts.show, callbackContext),
	            'hide': bind(opts.hide, callbackContext),
	            'beforeShow': bind(opts.beforeShow, callbackContext)
	        };
	
	        return opts;
	    }
	
	    function spectrum(element, o) {
	
	        var opts = instanceOptions(o, element),
	            flat = opts.flat,
	            showSelectionPalette = opts.showSelectionPalette,
	            localStorageKey = opts.localStorageKey,
	            theme = opts.theme,
	            callbacks = opts.callbacks,
	            resize = throttle(reflow, 10),
	            visible = false,
	            isDragging = false,
	            dragWidth = 0,
	            dragHeight = 0,
	            dragHelperHeight = 0,
	            slideHeight = 0,
	            slideWidth = 0,
	            alphaWidth = 0,
	            alphaSlideHelperWidth = 0,
	            slideHelperHeight = 0,
	            currentHue = 0,
	            currentSaturation = 0,
	            currentValue = 0,
	            currentAlpha = 1,
	            palette = [],
	            paletteArray = [],
	            paletteLookup = {},
	            selectionPalette = opts.selectionPalette.slice(0),
	            maxSelectionSize = opts.maxSelectionSize,
	            draggingClass = "sp-dragging",
	            shiftMovementDirection = null;
	
	        var doc = element.ownerDocument,
	            body = doc.body,
	            boundElement = $(element),
	            disabled = false,
	            container = $(markup, doc).addClass(theme),
	            pickerContainer = container.find(".sp-picker-container"),
	            dragger = container.find(".sp-color"),
	            dragHelper = container.find(".sp-dragger"),
	            slider = container.find(".sp-hue"),
	            slideHelper = container.find(".sp-slider"),
	            alphaSliderInner = container.find(".sp-alpha-inner"),
	            alphaSlider = container.find(".sp-alpha"),
	            alphaSlideHelper = container.find(".sp-alpha-handle"),
	            textInput = container.find(".sp-input"),
	            paletteContainer = container.find(".sp-palette"),
	            initialColorContainer = container.find(".sp-initial"),
	            cancelButton = container.find(".sp-cancel"),
	            clearButton = container.find(".sp-clear"),
	            chooseButton = container.find(".sp-choose"),
	            toggleButton = container.find(".sp-palette-toggle"),
	            isInput = boundElement.is("input"),
	            isInputTypeColor = isInput && boundElement.attr("type") === "color" && inputTypeColorSupport(),
	            shouldReplace = isInput && !flat,
	            replacer = (shouldReplace) ? $(replaceInput).addClass(theme).addClass(opts.className).addClass(opts.replacerClassName) : $([]),
	            offsetElement = (shouldReplace) ? replacer : boundElement,
	            previewElement = replacer.find(".sp-preview-inner"),
	            initialColor = opts.color || (isInput && boundElement.val()),
	            colorOnShow = false,
	            currentPreferredFormat = opts.preferredFormat,
	            clickoutFiresChange = !opts.showButtons || opts.clickoutFiresChange,
	            isEmpty = !initialColor,
	            allowEmpty = opts.allowEmpty && !isInputTypeColor;
	
	        function applyOptions() {
	
	            if (opts.showPaletteOnly) {
	                opts.showPalette = true;
	            }
	
	            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
	
	            if (opts.palette) {
	                palette = opts.palette.slice(0);
	                paletteArray = $.isArray(palette[0]) ? palette : [palette];
	                paletteLookup = {};
	                for (var i = 0; i < paletteArray.length; i++) {
	                    for (var j = 0; j < paletteArray[i].length; j++) {
	                        var rgb = tinycolor(paletteArray[i][j]).toRgbString();
	                        paletteLookup[rgb] = true;
	                    }
	                }
	            }
	
	            container.toggleClass("sp-flat", flat);
	            container.toggleClass("sp-input-disabled", !opts.showInput);
	            container.toggleClass("sp-alpha-enabled", opts.showAlpha);
	            container.toggleClass("sp-clear-enabled", allowEmpty);
	            container.toggleClass("sp-buttons-disabled", !opts.showButtons);
	            container.toggleClass("sp-palette-buttons-disabled", !opts.togglePaletteOnly);
	            container.toggleClass("sp-palette-disabled", !opts.showPalette);
	            container.toggleClass("sp-palette-only", opts.showPaletteOnly);
	            container.toggleClass("sp-initial-disabled", !opts.showInitial);
	            container.addClass(opts.className).addClass(opts.containerClassName);
	
	            reflow();
	        }
	
	        function initialize() {
	
	            if (IE) {
	                container.find("*:not(input)").attr("unselectable", "on");
	            }
	
	            applyOptions();
	
	            if (shouldReplace) {
	                boundElement.after(replacer).hide();
	            }
	
	            if (!allowEmpty) {
	                clearButton.hide();
	            }
	
	            if (flat) {
	                boundElement.after(container).hide();
	            }
	            else {
	
	                var appendTo = opts.appendTo === "parent" ? boundElement.parent() : $(opts.appendTo);
	                if (appendTo.length !== 1) {
	                    appendTo = $("body");
	                }
	
	                appendTo.append(container);
	            }
	
	            updateSelectionPaletteFromStorage();
	
	            offsetElement.bind("click.spectrum touchstart.spectrum", function (e) {
	                if (!disabled) {
	                    toggle();
	                }
	
	                e.stopPropagation();
	
	                if (!$(e.target).is("input")) {
	                    e.preventDefault();
	                }
	            });
	
	            if(boundElement.is(":disabled") || (opts.disabled === true)) {
	                disable();
	            }
	
	            // Prevent clicks from bubbling up to document.  This would cause it to be hidden.
	            container.click(stopPropagation);
	
	            // Handle user typed input
	            textInput.change(setFromTextInput);
	            textInput.bind("paste", function () {
	                setTimeout(setFromTextInput, 1);
	            });
	            textInput.keydown(function (e) { if (e.keyCode == 13) { setFromTextInput(); } });
	
	            cancelButton.text(opts.cancelText);
	            cancelButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	                revert();
	                hide();
	            });
	
	            clearButton.attr("title", opts.clearText);
	            clearButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	                isEmpty = true;
	                move();
	
	                if(flat) {
	                    //for the flat style, this is a change event
	                    updateOriginalInput(true);
	                }
	            });
	
	            chooseButton.text(opts.chooseText);
	            chooseButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	
	                if (IE && textInput.is(":focus")) {
	                    textInput.trigger('change');
	                }
	
	                if (isValid()) {
	                    updateOriginalInput(true);
	                    hide();
	                }
	            });
	
	            toggleButton.text(opts.showPaletteOnly ? opts.togglePaletteMoreText : opts.togglePaletteLessText);
	            toggleButton.bind("click.spectrum", function (e) {
	                e.stopPropagation();
	                e.preventDefault();
	
	                opts.showPaletteOnly = !opts.showPaletteOnly;
	
	                // To make sure the Picker area is drawn on the right, next to the
	                // Palette area (and not below the palette), first move the Palette
	                // to the left to make space for the picker, plus 5px extra.
	                // The 'applyOptions' function puts the whole container back into place
	                // and takes care of the button-text and the sp-palette-only CSS class.
	                if (!opts.showPaletteOnly && !flat) {
	                    container.css('left', '-=' + (pickerContainer.outerWidth(true) + 5));
	                }
	                applyOptions();
	            });
	
	            draggable(alphaSlider, function (dragX, dragY, e) {
	                currentAlpha = (dragX / alphaWidth);
	                isEmpty = false;
	                if (e.shiftKey) {
	                    currentAlpha = Math.round(currentAlpha * 10) / 10;
	                }
	
	                move();
	            }, dragStart, dragStop);
	
	            draggable(slider, function (dragX, dragY) {
	                currentHue = parseFloat(dragY / slideHeight);
	                isEmpty = false;
	                if (!opts.showAlpha) {
	                    currentAlpha = 1;
	                }
	                move();
	            }, dragStart, dragStop);
	
	            draggable(dragger, function (dragX, dragY, e) {
	
	                // shift+drag should snap the movement to either the x or y axis.
	                if (!e.shiftKey) {
	                    shiftMovementDirection = null;
	                }
	                else if (!shiftMovementDirection) {
	                    var oldDragX = currentSaturation * dragWidth;
	                    var oldDragY = dragHeight - (currentValue * dragHeight);
	                    var furtherFromX = Math.abs(dragX - oldDragX) > Math.abs(dragY - oldDragY);
	
	                    shiftMovementDirection = furtherFromX ? "x" : "y";
	                }
	
	                var setSaturation = !shiftMovementDirection || shiftMovementDirection === "x";
	                var setValue = !shiftMovementDirection || shiftMovementDirection === "y";
	
	                if (setSaturation) {
	                    currentSaturation = parseFloat(dragX / dragWidth);
	                }
	                if (setValue) {
	                    currentValue = parseFloat((dragHeight - dragY) / dragHeight);
	                }
	
	                isEmpty = false;
	                if (!opts.showAlpha) {
	                    currentAlpha = 1;
	                }
	
	                move();
	
	            }, dragStart, dragStop);
	
	            if (!!initialColor) {
	                set(initialColor);
	
	                // In case color was black - update the preview UI and set the format
	                // since the set function will not run (default color is black).
	                updateUI();
	                currentPreferredFormat = opts.preferredFormat || tinycolor(initialColor).format;
	
	                addColorToSelectionPalette(initialColor);
	            }
	            else {
	                updateUI();
	            }
	
	            if (flat) {
	                show();
	            }
	
	            function paletteElementClick(e) {
	                if (e.data && e.data.ignore) {
	                    set($(e.target).closest(".sp-thumb-el").data("color"));
	                    move();
	                }
	                else {
	                    set($(e.target).closest(".sp-thumb-el").data("color"));
	                    move();
	                    updateOriginalInput(true);
	                    if (opts.hideAfterPaletteSelect) {
	                      hide();
	                    }
	                }
	
	                return false;
	            }
	
	            var paletteEvent = IE ? "mousedown.spectrum" : "click.spectrum touchstart.spectrum";
	            paletteContainer.delegate(".sp-thumb-el", paletteEvent, paletteElementClick);
	            initialColorContainer.delegate(".sp-thumb-el:nth-child(1)", paletteEvent, { ignore: true }, paletteElementClick);
	        }
	
	        function updateSelectionPaletteFromStorage() {
	
	            if (localStorageKey && window.localStorage) {
	
	                // Migrate old palettes over to new format.  May want to remove this eventually.
	                try {
	                    var oldPalette = window.localStorage[localStorageKey].split(",#");
	                    if (oldPalette.length > 1) {
	                        delete window.localStorage[localStorageKey];
	                        $.each(oldPalette, function(i, c) {
	                             addColorToSelectionPalette(c);
	                        });
	                    }
	                }
	                catch(e) { }
	
	                try {
	                    selectionPalette = window.localStorage[localStorageKey].split(";");
	                }
	                catch (e) { }
	            }
	        }
	
	        function addColorToSelectionPalette(color) {
	            if (showSelectionPalette) {
	                var rgb = tinycolor(color).toRgbString();
	                if (!paletteLookup[rgb] && $.inArray(rgb, selectionPalette) === -1) {
	                    selectionPalette.push(rgb);
	                    while(selectionPalette.length > maxSelectionSize) {
	                        selectionPalette.shift();
	                    }
	                }
	
	                if (localStorageKey && window.localStorage) {
	                    try {
	                        window.localStorage[localStorageKey] = selectionPalette.join(";");
	                    }
	                    catch(e) { }
	                }
	            }
	        }
	
	        function getUniqueSelectionPalette() {
	            var unique = [];
	            if (opts.showPalette) {
	                for (var i = 0; i < selectionPalette.length; i++) {
	                    var rgb = tinycolor(selectionPalette[i]).toRgbString();
	
	                    if (!paletteLookup[rgb]) {
	                        unique.push(selectionPalette[i]);
	                    }
	                }
	            }
	
	            return unique.reverse().slice(0, opts.maxSelectionSize);
	        }
	
	        function drawPalette() {
	
	            var currentColor = get();
	
	            var html = $.map(paletteArray, function (palette, i) {
	                return paletteTemplate(palette, currentColor, "sp-palette-row sp-palette-row-" + i, opts);
	            });
	
	            updateSelectionPaletteFromStorage();
	
	            if (selectionPalette) {
	                html.push(paletteTemplate(getUniqueSelectionPalette(), currentColor, "sp-palette-row sp-palette-row-selection", opts));
	            }
	
	            paletteContainer.html(html.join(""));
	        }
	
	        function drawInitial() {
	            if (opts.showInitial) {
	                var initial = colorOnShow;
	                var current = get();
	                initialColorContainer.html(paletteTemplate([initial, current], current, "sp-palette-row-initial", opts));
	            }
	        }
	
	        function dragStart() {
	            if (dragHeight <= 0 || dragWidth <= 0 || slideHeight <= 0) {
	                reflow();
	            }
	            isDragging = true;
	            container.addClass(draggingClass);
	            shiftMovementDirection = null;
	            boundElement.trigger('dragstart.spectrum', [ get() ]);
	        }
	
	        function dragStop() {
	            isDragging = false;
	            container.removeClass(draggingClass);
	            boundElement.trigger('dragstop.spectrum', [ get() ]);
	        }
	
	        function setFromTextInput() {
	
	            var value = textInput.val();
	
	            if ((value === null || value === "") && allowEmpty) {
	                set(null);
	                updateOriginalInput(true);
	            }
	            else {
	                var tiny = tinycolor(value);
	                if (tiny.isValid()) {
	                    set(tiny);
	                    updateOriginalInput(true);
	                }
	                else {
	                    textInput.addClass("sp-validation-error");
	                }
	            }
	        }
	
	        function toggle() {
	            if (visible) {
	                hide();
	            }
	            else {
	                show();
	            }
	        }
	
	        function show() {
	            var event = $.Event('beforeShow.spectrum');
	
	            if (visible) {
	                reflow();
	                return;
	            }
	
	            boundElement.trigger(event, [ get() ]);
	
	            if (callbacks.beforeShow(get()) === false || event.isDefaultPrevented()) {
	                return;
	            }
	
	            hideAll();
	            visible = true;
	
	            $(doc).bind("keydown.spectrum", onkeydown);
	            $(doc).bind("click.spectrum", clickout);
	            $(window).bind("resize.spectrum", resize);
	            replacer.addClass("sp-active");
	            container.removeClass("sp-hidden");
	
	            reflow();
	            updateUI();
	
	            colorOnShow = get();
	
	            drawInitial();
	            callbacks.show(colorOnShow);
	            boundElement.trigger('show.spectrum', [ colorOnShow ]);
	        }
	
	        function onkeydown(e) {
	            // Close on ESC
	            if (e.keyCode === 27) {
	                hide();
	            }
	        }
	
	        function clickout(e) {
	            // Return on right click.
	            if (e.button == 2) { return; }
	
	            // If a drag event was happening during the mouseup, don't hide
	            // on click.
	            if (isDragging) { return; }
	
	            if (clickoutFiresChange) {
	                updateOriginalInput(true);
	            }
	            else {
	                revert();
	            }
	            hide();
	        }
	
	        function hide() {
	            // Return if hiding is unnecessary
	            if (!visible || flat) { return; }
	            visible = false;
	
	            $(doc).unbind("keydown.spectrum", onkeydown);
	            $(doc).unbind("click.spectrum", clickout);
	            $(window).unbind("resize.spectrum", resize);
	
	            replacer.removeClass("sp-active");
	            container.addClass("sp-hidden");
	
	            callbacks.hide(get());
	            boundElement.trigger('hide.spectrum', [ get() ]);
	        }
	
	        function revert() {
	            set(colorOnShow, true);
	        }
	
	        function set(color, ignoreFormatChange) {
	            if (tinycolor.equals(color, get())) {
	                // Update UI just in case a validation error needs
	                // to be cleared.
	                updateUI();
	                return;
	            }
	
	            var newColor, newHsv;
	            if (!color && allowEmpty) {
	                isEmpty = true;
	            } else {
	                isEmpty = false;
	                newColor = tinycolor(color);
	                newHsv = newColor.toHsv();
	
	                currentHue = (newHsv.h % 360) / 360;
	                currentSaturation = newHsv.s;
	                currentValue = newHsv.v;
	                currentAlpha = newHsv.a;
	            }
	            updateUI();
	
	            if (newColor && newColor.isValid() && !ignoreFormatChange) {
	                currentPreferredFormat = opts.preferredFormat || newColor.getFormat();
	            }
	        }
	
	        function get(opts) {
	            opts = opts || { };
	
	            if (allowEmpty && isEmpty) {
	                return null;
	            }
	
	            return tinycolor.fromRatio({
	                h: currentHue,
	                s: currentSaturation,
	                v: currentValue,
	                a: Math.round(currentAlpha * 100) / 100
	            }, { format: opts.format || currentPreferredFormat });
	        }
	
	        function isValid() {
	            return !textInput.hasClass("sp-validation-error");
	        }
	
	        function move() {
	            updateUI();
	
	            callbacks.move(get());
	            boundElement.trigger('move.spectrum', [ get() ]);
	        }
	
	        function updateUI() {
	
	            textInput.removeClass("sp-validation-error");
	
	            updateHelperLocations();
	
	            // Update dragger background color (gradients take care of saturation and value).
	            var flatColor = tinycolor.fromRatio({ h: currentHue, s: 1, v: 1 });
	            dragger.css("background-color", flatColor.toHexString());
	
	            // Get a format that alpha will be included in (hex and names ignore alpha)
	            var format = currentPreferredFormat;
	            if (currentAlpha < 1 && !(currentAlpha === 0 && format === "name")) {
	                if (format === "hex" || format === "hex3" || format === "hex6" || format === "name") {
	                    format = "rgb";
	                }
	            }
	
	            var realColor = get({ format: format }),
	                displayColor = '';
	
	             //reset background info for preview element
	            previewElement.removeClass("sp-clear-display");
	            previewElement.css('background-color', 'transparent');
	
	            if (!realColor && allowEmpty) {
	                // Update the replaced elements background with icon indicating no color selection
	                previewElement.addClass("sp-clear-display");
	            }
	            else {
	                var realHex = realColor.toHexString(),
	                    realRgb = realColor.toRgbString();
	
	                // Update the replaced elements background color (with actual selected color)
	                if (rgbaSupport || realColor.alpha === 1) {
	                    previewElement.css("background-color", realRgb);
	                }
	                else {
	                    previewElement.css("background-color", "transparent");
	                    previewElement.css("filter", realColor.toFilter());
	                }
	
	                if (opts.showAlpha) {
	                    var rgb = realColor.toRgb();
	                    rgb.a = 0;
	                    var realAlpha = tinycolor(rgb).toRgbString();
	                    var gradient = "linear-gradient(left, " + realAlpha + ", " + realHex + ")";
	
	                    if (IE) {
	                        alphaSliderInner.css("filter", tinycolor(realAlpha).toFilter({ gradientType: 1 }, realHex));
	                    }
	                    else {
	                        alphaSliderInner.css("background", "-webkit-" + gradient);
	                        alphaSliderInner.css("background", "-moz-" + gradient);
	                        alphaSliderInner.css("background", "-ms-" + gradient);
	                        // Use current syntax gradient on unprefixed property.
	                        alphaSliderInner.css("background",
	                            "linear-gradient(to right, " + realAlpha + ", " + realHex + ")");
	                    }
	                }
	
	                displayColor = realColor.toString(format);
	            }
	
	            // Update the text entry input as it changes happen
	            if (opts.showInput) {
	                textInput.val(displayColor);
	            }
	
	            if (opts.showPalette) {
	                drawPalette();
	            }
	
	            drawInitial();
	        }
	
	        function updateHelperLocations() {
	            var s = currentSaturation;
	            var v = currentValue;
	
	            if(allowEmpty && isEmpty) {
	                //if selected color is empty, hide the helpers
	                alphaSlideHelper.hide();
	                slideHelper.hide();
	                dragHelper.hide();
	            }
	            else {
	                //make sure helpers are visible
	                alphaSlideHelper.show();
	                slideHelper.show();
	                dragHelper.show();
	
	                // Where to show the little circle in that displays your current selected color
	                var dragX = s * dragWidth;
	                var dragY = dragHeight - (v * dragHeight);
	                dragX = Math.max(
	                    -dragHelperHeight,
	                    Math.min(dragWidth - dragHelperHeight, dragX - dragHelperHeight)
	                );
	                dragY = Math.max(
	                    -dragHelperHeight,
	                    Math.min(dragHeight - dragHelperHeight, dragY - dragHelperHeight)
	                );
	                dragHelper.css({
	                    "top": dragY + "px",
	                    "left": dragX + "px"
	                });
	
	                var alphaX = currentAlpha * alphaWidth;
	                alphaSlideHelper.css({
	                    "left": (alphaX - (alphaSlideHelperWidth / 2)) + "px"
	                });
	
	                // Where to show the bar that displays your current selected hue
	                var slideY = (currentHue) * slideHeight;
	                slideHelper.css({
	                    "top": (slideY - slideHelperHeight) + "px"
	                });
	            }
	        }
	
	        function updateOriginalInput(fireCallback) {
	            var color = get(),
	                displayColor = '',
	                hasChanged = !tinycolor.equals(color, colorOnShow);
	
	            if (color) {
	                displayColor = color.toString(currentPreferredFormat);
	                // Update the selection palette with the current color
	                addColorToSelectionPalette(color);
	            }
	
	            if (isInput) {
	                boundElement.val(displayColor);
	            }
	
	            if (fireCallback && hasChanged) {
	                callbacks.change(color);
	                boundElement.trigger('change', [ color ]);
	            }
	        }
	
	        function reflow() {
	            if (!visible) {
	                return; // Calculations would be useless and wouldn't be reliable anyways
	            }
	            dragWidth = dragger.width();
	            dragHeight = dragger.height();
	            dragHelperHeight = dragHelper.height();
	            slideWidth = slider.width();
	            slideHeight = slider.height();
	            slideHelperHeight = slideHelper.height();
	            alphaWidth = alphaSlider.width();
	            alphaSlideHelperWidth = alphaSlideHelper.width();
	
	            if (!flat) {
	                container.css("position", "absolute");
	                if (opts.offset) {
	                    container.offset(opts.offset);
	                } else {
	                    container.offset(getOffset(container, offsetElement));
	                }
	            }
	
	            updateHelperLocations();
	
	            if (opts.showPalette) {
	                drawPalette();
	            }
	
	            boundElement.trigger('reflow.spectrum');
	        }
	
	        function destroy() {
	            boundElement.show();
	            offsetElement.unbind("click.spectrum touchstart.spectrum");
	            container.remove();
	            replacer.remove();
	            spectrums[spect.id] = null;
	        }
	
	        function option(optionName, optionValue) {
	            if (optionName === undefined) {
	                return $.extend({}, opts);
	            }
	            if (optionValue === undefined) {
	                return opts[optionName];
	            }
	
	            opts[optionName] = optionValue;
	
	            if (optionName === "preferredFormat") {
	                currentPreferredFormat = opts.preferredFormat;
	            }
	            applyOptions();
	        }
	
	        function enable() {
	            disabled = false;
	            boundElement.attr("disabled", false);
	            offsetElement.removeClass("sp-disabled");
	        }
	
	        function disable() {
	            hide();
	            disabled = true;
	            boundElement.attr("disabled", true);
	            offsetElement.addClass("sp-disabled");
	        }
	
	        function setOffset(coord) {
	            opts.offset = coord;
	            reflow();
	        }
	
	        initialize();
	
	        var spect = {
	            show: show,
	            hide: hide,
	            toggle: toggle,
	            reflow: reflow,
	            option: option,
	            enable: enable,
	            disable: disable,
	            offset: setOffset,
	            set: function (c) {
	                set(c);
	                updateOriginalInput();
	            },
	            get: get,
	            destroy: destroy,
	            container: container
	        };
	
	        spect.id = spectrums.push(spect) - 1;
	
	        return spect;
	    }
	
	    /**
	    * checkOffset - get the offset below/above and left/right element depending on screen position
	    * Thanks https://github.com/jquery/jquery-ui/blob/master/ui/jquery.ui.datepicker.js
	    */
	    function getOffset(picker, input) {
	        var extraY = 0;
	        var dpWidth = picker.outerWidth();
	        var dpHeight = picker.outerHeight();
	        var inputHeight = input.outerHeight();
	        var doc = picker[0].ownerDocument;
	        var docElem = doc.documentElement;
	        var viewWidth = docElem.clientWidth + $(doc).scrollLeft();
	        var viewHeight = docElem.clientHeight + $(doc).scrollTop();
	        var offset = input.offset();
	        offset.top += inputHeight;
	
	        offset.left -=
	            Math.min(offset.left, (offset.left + dpWidth > viewWidth && viewWidth > dpWidth) ?
	            Math.abs(offset.left + dpWidth - viewWidth) : 0);
	
	        offset.top -=
	            Math.min(offset.top, ((offset.top + dpHeight > viewHeight && viewHeight > dpHeight) ?
	            Math.abs(dpHeight + inputHeight - extraY) : extraY));
	
	        return offset;
	    }
	
	    /**
	    * noop - do nothing
	    */
	    function noop() {
	
	    }
	
	    /**
	    * stopPropagation - makes the code only doing this a little easier to read in line
	    */
	    function stopPropagation(e) {
	        e.stopPropagation();
	    }
	
	    /**
	    * Create a function bound to a given object
	    * Thanks to underscore.js
	    */
	    function bind(func, obj) {
	        var slice = Array.prototype.slice;
	        var args = slice.call(arguments, 2);
	        return function () {
	            return func.apply(obj, args.concat(slice.call(arguments)));
	        };
	    }
	
	    /**
	    * Lightweight drag helper.  Handles containment within the element, so that
	    * when dragging, the x is within [0,element.width] and y is within [0,element.height]
	    */
	    function draggable(element, onmove, onstart, onstop) {
	        onmove = onmove || function () { };
	        onstart = onstart || function () { };
	        onstop = onstop || function () { };
	        var doc = document;
	        var dragging = false;
	        var offset = {};
	        var maxHeight = 0;
	        var maxWidth = 0;
	        var hasTouch = ('ontouchstart' in window);
	
	        var duringDragEvents = {};
	        duringDragEvents["selectstart"] = prevent;
	        duringDragEvents["dragstart"] = prevent;
	        duringDragEvents["touchmove mousemove"] = move;
	        duringDragEvents["touchend mouseup"] = stop;
	
	        function prevent(e) {
	            if (e.stopPropagation) {
	                e.stopPropagation();
	            }
	            if (e.preventDefault) {
	                e.preventDefault();
	            }
	            e.returnValue = false;
	        }
	
	        function move(e) {
	            if (dragging) {
	                // Mouseup happened outside of window
	                if (IE && doc.documentMode < 9 && !e.button) {
	                    return stop();
	                }
	
	                var t0 = e.originalEvent && e.originalEvent.touches && e.originalEvent.touches[0];
	                var pageX = t0 && t0.pageX || e.pageX;
	                var pageY = t0 && t0.pageY || e.pageY;
	
	                var dragX = Math.max(0, Math.min(pageX - offset.left, maxWidth));
	                var dragY = Math.max(0, Math.min(pageY - offset.top, maxHeight));
	
	                if (hasTouch) {
	                    // Stop scrolling in iOS
	                    prevent(e);
	                }
	
	                onmove.apply(element, [dragX, dragY, e]);
	            }
	        }
	
	        function start(e) {
	            var rightclick = (e.which) ? (e.which == 3) : (e.button == 2);
	
	            if (!rightclick && !dragging) {
	                if (onstart.apply(element, arguments) !== false) {
	                    dragging = true;
	                    maxHeight = $(element).height();
	                    maxWidth = $(element).width();
	                    offset = $(element).offset();
	
	                    $(doc).bind(duringDragEvents);
	                    $(doc.body).addClass("sp-dragging");
	
	                    move(e);
	
	                    prevent(e);
	                }
	            }
	        }
	
	        function stop() {
	            if (dragging) {
	                $(doc).unbind(duringDragEvents);
	                $(doc.body).removeClass("sp-dragging");
	
	                // Wait a tick before notifying observers to allow the click event
	                // to fire in Chrome.
	                setTimeout(function() {
	                    onstop.apply(element, arguments);
	                }, 0);
	            }
	            dragging = false;
	        }
	
	        $(element).bind("touchstart mousedown", start);
	    }
	
	    function throttle(func, wait, debounce) {
	        var timeout;
	        return function () {
	            var context = this, args = arguments;
	            var throttler = function () {
	                timeout = null;
	                func.apply(context, args);
	            };
	            if (debounce) clearTimeout(timeout);
	            if (debounce || !timeout) timeout = setTimeout(throttler, wait);
	        };
	    }
	
	    function inputTypeColorSupport() {
	        return $.fn.spectrum.inputTypeColorSupport();
	    }
	
	    /**
	    * Define a jQuery plugin
	    */
	    var dataID = "spectrum.id";
	    $.fn.spectrum = function (opts, extra) {
	
	        if (typeof opts == "string") {
	
	            var returnValue = this;
	            var args = Array.prototype.slice.call( arguments, 1 );
	
	            this.each(function () {
	                var spect = spectrums[$(this).data(dataID)];
	                if (spect) {
	                    var method = spect[opts];
	                    if (!method) {
	                        throw new Error( "Spectrum: no such method: '" + opts + "'" );
	                    }
	
	                    if (opts == "get") {
	                        returnValue = spect.get();
	                    }
	                    else if (opts == "container") {
	                        returnValue = spect.container;
	                    }
	                    else if (opts == "option") {
	                        returnValue = spect.option.apply(spect, args);
	                    }
	                    else if (opts == "destroy") {
	                        spect.destroy();
	                        $(this).removeData(dataID);
	                    }
	                    else {
	                        method.apply(spect, args);
	                    }
	                }
	            });
	
	            return returnValue;
	        }
	
	        // Initializing a new instance of spectrum
	        return this.spectrum("destroy").each(function () {
	            var options = $.extend({}, opts, $(this).data());
	            var spect = spectrum(this, options);
	            $(this).data(dataID, spect.id);
	        });
	    };
	
	    $.fn.spectrum.load = true;
	    $.fn.spectrum.loadOpts = {};
	    $.fn.spectrum.draggable = draggable;
	    $.fn.spectrum.defaults = defaultOpts;
	    $.fn.spectrum.inputTypeColorSupport = function inputTypeColorSupport() {
	        if (typeof inputTypeColorSupport._cachedResult === "undefined") {
	            var colorInput = $("<input type='color'/>")[0]; // if color element is supported, value will default to not null
	            inputTypeColorSupport._cachedResult = colorInput.type === "color" && colorInput.value !== "";
	        }
	        return inputTypeColorSupport._cachedResult;
	    };
	
	    $.spectrum = { };
	    $.spectrum.localization = { };
	    $.spectrum.palettes = { };
	
	    $.fn.spectrum.processNativeColorInputs = function () {
	        var colorInputs = $("input[type=color]");
	        if (colorInputs.length && !inputTypeColorSupport()) {
	            colorInputs.spectrum({
	                preferredFormat: "hex6"
	            });
	        }
	    };
	
	    // TinyColor v1.1.2
	    // https://github.com/bgrins/TinyColor
	    // Brian Grinstead, MIT License
	
	    (function() {
	
	    var trimLeft = /^[\s,#]+/,
	        trimRight = /\s+$/,
	        tinyCounter = 0,
	        math = Math,
	        mathRound = math.round,
	        mathMin = math.min,
	        mathMax = math.max,
	        mathRandom = math.random;
	
	    var tinycolor = function(color, opts) {
	
	        color = (color) ? color : '';
	        opts = opts || { };
	
	        // If input is already a tinycolor, return itself
	        if (color instanceof tinycolor) {
	           return color;
	        }
	        // If we are called as a function, call using new instead
	        if (!(this instanceof tinycolor)) {
	            return new tinycolor(color, opts);
	        }
	
	        var rgb = inputToRGB(color);
	        this._originalInput = color,
	        this._r = rgb.r,
	        this._g = rgb.g,
	        this._b = rgb.b,
	        this._a = rgb.a,
	        this._roundA = mathRound(100*this._a) / 100,
	        this._format = opts.format || rgb.format;
	        this._gradientType = opts.gradientType;
	
	        // Don't let the range of [0,255] come back in [0,1].
	        // Potentially lose a little bit of precision here, but will fix issues where
	        // .5 gets interpreted as half of the total, instead of half of 1
	        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	        if (this._r < 1) { this._r = mathRound(this._r); }
	        if (this._g < 1) { this._g = mathRound(this._g); }
	        if (this._b < 1) { this._b = mathRound(this._b); }
	
	        this._ok = rgb.ok;
	        this._tc_id = tinyCounter++;
	    };
	
	    tinycolor.prototype = {
	        isDark: function() {
	            return this.getBrightness() < 128;
	        },
	        isLight: function() {
	            return !this.isDark();
	        },
	        isValid: function() {
	            return this._ok;
	        },
	        getOriginalInput: function() {
	          return this._originalInput;
	        },
	        getFormat: function() {
	            return this._format;
	        },
	        getAlpha: function() {
	            return this._a;
	        },
	        getBrightness: function() {
	            var rgb = this.toRgb();
	            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	        },
	        setAlpha: function(value) {
	            this._a = boundAlpha(value);
	            this._roundA = mathRound(100*this._a) / 100;
	            return this;
	        },
	        toHsv: function() {
	            var hsv = rgbToHsv(this._r, this._g, this._b);
	            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	        },
	        toHsvString: function() {
	            var hsv = rgbToHsv(this._r, this._g, this._b);
	            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	            return (this._a == 1) ?
	              "hsv("  + h + ", " + s + "%, " + v + "%)" :
	              "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	        },
	        toHsl: function() {
	            var hsl = rgbToHsl(this._r, this._g, this._b);
	            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	        },
	        toHslString: function() {
	            var hsl = rgbToHsl(this._r, this._g, this._b);
	            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	            return (this._a == 1) ?
	              "hsl("  + h + ", " + s + "%, " + l + "%)" :
	              "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	        },
	        toHex: function(allow3Char) {
	            return rgbToHex(this._r, this._g, this._b, allow3Char);
	        },
	        toHexString: function(allow3Char) {
	            return '#' + this.toHex(allow3Char);
	        },
	        toHex8: function() {
	            return rgbaToHex(this._r, this._g, this._b, this._a);
	        },
	        toHex8String: function() {
	            return '#' + this.toHex8();
	        },
	        toRgb: function() {
	            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	        },
	        toRgbString: function() {
	            return (this._a == 1) ?
	              "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	              "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	        },
	        toPercentageRgb: function() {
	            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	        },
	        toPercentageRgbString: function() {
	            return (this._a == 1) ?
	              "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	              "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	        },
	        toName: function() {
	            if (this._a === 0) {
	                return "transparent";
	            }
	
	            if (this._a < 1) {
	                return false;
	            }
	
	            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	        },
	        toFilter: function(secondColor) {
	            var hex8String = '#' + rgbaToHex(this._r, this._g, this._b, this._a);
	            var secondHex8String = hex8String;
	            var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	            if (secondColor) {
	                var s = tinycolor(secondColor);
	                secondHex8String = s.toHex8String();
	            }
	
	            return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	        },
	        toString: function(format) {
	            var formatSet = !!format;
	            format = format || this._format;
	
	            var formattedString = false;
	            var hasAlpha = this._a < 1 && this._a >= 0;
	            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
	
	            if (needsAlphaFormat) {
	                // Special case for "transparent", all other non-alpha formats
	                // will return rgba when there is transparency.
	                if (format === "name" && this._a === 0) {
	                    return this.toName();
	                }
	                return this.toRgbString();
	            }
	            if (format === "rgb") {
	                formattedString = this.toRgbString();
	            }
	            if (format === "prgb") {
	                formattedString = this.toPercentageRgbString();
	            }
	            if (format === "hex" || format === "hex6") {
	                formattedString = this.toHexString();
	            }
	            if (format === "hex3") {
	                formattedString = this.toHexString(true);
	            }
	            if (format === "hex8") {
	                formattedString = this.toHex8String();
	            }
	            if (format === "name") {
	                formattedString = this.toName();
	            }
	            if (format === "hsl") {
	                formattedString = this.toHslString();
	            }
	            if (format === "hsv") {
	                formattedString = this.toHsvString();
	            }
	
	            return formattedString || this.toHexString();
	        },
	
	        _applyModification: function(fn, args) {
	            var color = fn.apply(null, [this].concat([].slice.call(args)));
	            this._r = color._r;
	            this._g = color._g;
	            this._b = color._b;
	            this.setAlpha(color._a);
	            return this;
	        },
	        lighten: function() {
	            return this._applyModification(lighten, arguments);
	        },
	        brighten: function() {
	            return this._applyModification(brighten, arguments);
	        },
	        darken: function() {
	            return this._applyModification(darken, arguments);
	        },
	        desaturate: function() {
	            return this._applyModification(desaturate, arguments);
	        },
	        saturate: function() {
	            return this._applyModification(saturate, arguments);
	        },
	        greyscale: function() {
	            return this._applyModification(greyscale, arguments);
	        },
	        spin: function() {
	            return this._applyModification(spin, arguments);
	        },
	
	        _applyCombination: function(fn, args) {
	            return fn.apply(null, [this].concat([].slice.call(args)));
	        },
	        analogous: function() {
	            return this._applyCombination(analogous, arguments);
	        },
	        complement: function() {
	            return this._applyCombination(complement, arguments);
	        },
	        monochromatic: function() {
	            return this._applyCombination(monochromatic, arguments);
	        },
	        splitcomplement: function() {
	            return this._applyCombination(splitcomplement, arguments);
	        },
	        triad: function() {
	            return this._applyCombination(triad, arguments);
	        },
	        tetrad: function() {
	            return this._applyCombination(tetrad, arguments);
	        }
	    };
	
	    // If input is an object, force 1 into "1.0" to handle ratios properly
	    // String input requires "1.0" as input, so 1 will be treated as 1
	    tinycolor.fromRatio = function(color, opts) {
	        if (typeof color == "object") {
	            var newColor = {};
	            for (var i in color) {
	                if (color.hasOwnProperty(i)) {
	                    if (i === "a") {
	                        newColor[i] = color[i];
	                    }
	                    else {
	                        newColor[i] = convertToPercentage(color[i]);
	                    }
	                }
	            }
	            color = newColor;
	        }
	
	        return tinycolor(color, opts);
	    };
	
	    // Given a string or object, convert that input to RGB
	    // Possible string inputs:
	    //
	    //     "red"
	    //     "#f00" or "f00"
	    //     "#ff0000" or "ff0000"
	    //     "#ff000000" or "ff000000"
	    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
	    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	    //
	    function inputToRGB(color) {
	
	        var rgb = { r: 0, g: 0, b: 0 };
	        var a = 1;
	        var ok = false;
	        var format = false;
	
	        if (typeof color == "string") {
	            color = stringInputToObject(color);
	        }
	
	        if (typeof color == "object") {
	            if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
	                rgb = rgbToRgb(color.r, color.g, color.b);
	                ok = true;
	                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	            }
	            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
	                color.s = convertToPercentage(color.s);
	                color.v = convertToPercentage(color.v);
	                rgb = hsvToRgb(color.h, color.s, color.v);
	                ok = true;
	                format = "hsv";
	            }
	            else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
	                color.s = convertToPercentage(color.s);
	                color.l = convertToPercentage(color.l);
	                rgb = hslToRgb(color.h, color.s, color.l);
	                ok = true;
	                format = "hsl";
	            }
	
	            if (color.hasOwnProperty("a")) {
	                a = color.a;
	            }
	        }
	
	        a = boundAlpha(a);
	
	        return {
	            ok: ok,
	            format: color.format || format,
	            r: mathMin(255, mathMax(rgb.r, 0)),
	            g: mathMin(255, mathMax(rgb.g, 0)),
	            b: mathMin(255, mathMax(rgb.b, 0)),
	            a: a
	        };
	    }
	
	
	    // Conversion Functions
	    // --------------------
	
	    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	    // `rgbToRgb`
	    // Handle bounds / percentage checking to conform to CSS color spec
	    // <http://www.w3.org/TR/css3-color/>
	    // *Assumes:* r, g, b in [0, 255] or [0, 1]
	    // *Returns:* { r, g, b } in [0, 255]
	    function rgbToRgb(r, g, b){
	        return {
	            r: bound01(r, 255) * 255,
	            g: bound01(g, 255) * 255,
	            b: bound01(b, 255) * 255
	        };
	    }
	
	    // `rgbToHsl`
	    // Converts an RGB color value to HSL.
	    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	    // *Returns:* { h, s, l } in [0,1]
	    function rgbToHsl(r, g, b) {
	
	        r = bound01(r, 255);
	        g = bound01(g, 255);
	        b = bound01(b, 255);
	
	        var max = mathMax(r, g, b), min = mathMin(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min) {
	            h = s = 0; // achromatic
	        }
	        else {
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max) {
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	
	            h /= 6;
	        }
	
	        return { h: h, s: s, l: l };
	    }
	
	    // `hslToRgb`
	    // Converts an HSL color value to RGB.
	    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	    // *Returns:* { r, g, b } in the set [0, 255]
	    function hslToRgb(h, s, l) {
	        var r, g, b;
	
	        h = bound01(h, 360);
	        s = bound01(s, 100);
	        l = bound01(l, 100);
	
	        function hue2rgb(p, q, t) {
	            if(t < 0) t += 1;
	            if(t > 1) t -= 1;
	            if(t < 1/6) return p + (q - p) * 6 * t;
	            if(t < 1/2) return q;
	            if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	            return p;
	        }
	
	        if(s === 0) {
	            r = g = b = l; // achromatic
	        }
	        else {
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return { r: r * 255, g: g * 255, b: b * 255 };
	    }
	
	    // `rgbToHsv`
	    // Converts an RGB color value to HSV
	    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	    // *Returns:* { h, s, v } in [0,1]
	    function rgbToHsv(r, g, b) {
	
	        r = bound01(r, 255);
	        g = bound01(g, 255);
	        b = bound01(b, 255);
	
	        var max = mathMax(r, g, b), min = mathMin(r, g, b);
	        var h, s, v = max;
	
	        var d = max - min;
	        s = max === 0 ? 0 : d / max;
	
	        if(max == min) {
	            h = 0; // achromatic
	        }
	        else {
	            switch(max) {
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	        return { h: h, s: s, v: v };
	    }
	
	    // `hsvToRgb`
	    // Converts an HSV color value to RGB.
	    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	    // *Returns:* { r, g, b } in the set [0, 255]
	     function hsvToRgb(h, s, v) {
	
	        h = bound01(h, 360) * 6;
	        s = bound01(s, 100);
	        v = bound01(v, 100);
	
	        var i = math.floor(h),
	            f = h - i,
	            p = v * (1 - s),
	            q = v * (1 - f * s),
	            t = v * (1 - (1 - f) * s),
	            mod = i % 6,
	            r = [v, q, p, p, t, v][mod],
	            g = [t, v, v, q, p, p][mod],
	            b = [p, p, t, v, v, q][mod];
	
	        return { r: r * 255, g: g * 255, b: b * 255 };
	    }
	
	    // `rgbToHex`
	    // Converts an RGB color to hex
	    // Assumes r, g, and b are contained in the set [0, 255]
	    // Returns a 3 or 6 character hex
	    function rgbToHex(r, g, b, allow3Char) {
	
	        var hex = [
	            pad2(mathRound(r).toString(16)),
	            pad2(mathRound(g).toString(16)),
	            pad2(mathRound(b).toString(16))
	        ];
	
	        // Return a 3 character hex if possible
	        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	        }
	
	        return hex.join("");
	    }
	        // `rgbaToHex`
	        // Converts an RGBA color plus alpha transparency to hex
	        // Assumes r, g, b and a are contained in the set [0, 255]
	        // Returns an 8 character hex
	        function rgbaToHex(r, g, b, a) {
	
	            var hex = [
	                pad2(convertDecimalToHex(a)),
	                pad2(mathRound(r).toString(16)),
	                pad2(mathRound(g).toString(16)),
	                pad2(mathRound(b).toString(16))
	            ];
	
	            return hex.join("");
	        }
	
	    // `equals`
	    // Can be called with any tinycolor input
	    tinycolor.equals = function (color1, color2) {
	        if (!color1 || !color2) { return false; }
	        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	    };
	    tinycolor.random = function() {
	        return tinycolor.fromRatio({
	            r: mathRandom(),
	            g: mathRandom(),
	            b: mathRandom()
	        });
	    };
	
	
	    // Modification Functions
	    // ----------------------
	    // Thanks to less.js for some of the basics here
	    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	    function desaturate(color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.s -= amount / 100;
	        hsl.s = clamp01(hsl.s);
	        return tinycolor(hsl);
	    }
	
	    function saturate(color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.s += amount / 100;
	        hsl.s = clamp01(hsl.s);
	        return tinycolor(hsl);
	    }
	
	    function greyscale(color) {
	        return tinycolor(color).desaturate(100);
	    }
	
	    function lighten (color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.l += amount / 100;
	        hsl.l = clamp01(hsl.l);
	        return tinycolor(hsl);
	    }
	
	    function brighten(color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var rgb = tinycolor(color).toRgb();
	        rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	        rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	        rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	        return tinycolor(rgb);
	    }
	
	    function darken (color, amount) {
	        amount = (amount === 0) ? 0 : (amount || 10);
	        var hsl = tinycolor(color).toHsl();
	        hsl.l -= amount / 100;
	        hsl.l = clamp01(hsl.l);
	        return tinycolor(hsl);
	    }
	
	    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	    // Values outside of this range will be wrapped into this range.
	    function spin(color, amount) {
	        var hsl = tinycolor(color).toHsl();
	        var hue = (mathRound(hsl.h) + amount) % 360;
	        hsl.h = hue < 0 ? 360 + hue : hue;
	        return tinycolor(hsl);
	    }
	
	    // Combination Functions
	    // ---------------------
	    // Thanks to jQuery xColor for some of the ideas behind these
	    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	    function complement(color) {
	        var hsl = tinycolor(color).toHsl();
	        hsl.h = (hsl.h + 180) % 360;
	        return tinycolor(hsl);
	    }
	
	    function triad(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	        ];
	    }
	
	    function tetrad(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	        ];
	    }
	
	    function splitcomplement(color) {
	        var hsl = tinycolor(color).toHsl();
	        var h = hsl.h;
	        return [
	            tinycolor(color),
	            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	        ];
	    }
	
	    function analogous(color, results, slices) {
	        results = results || 6;
	        slices = slices || 30;
	
	        var hsl = tinycolor(color).toHsl();
	        var part = 360 / slices;
	        var ret = [tinycolor(color)];
	
	        for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	            hsl.h = (hsl.h + part) % 360;
	            ret.push(tinycolor(hsl));
	        }
	        return ret;
	    }
	
	    function monochromatic(color, results) {
	        results = results || 6;
	        var hsv = tinycolor(color).toHsv();
	        var h = hsv.h, s = hsv.s, v = hsv.v;
	        var ret = [];
	        var modification = 1 / results;
	
	        while (results--) {
	            ret.push(tinycolor({ h: h, s: s, v: v}));
	            v = (v + modification) % 1;
	        }
	
	        return ret;
	    }
	
	    // Utility Functions
	    // ---------------------
	
	    tinycolor.mix = function(color1, color2, amount) {
	        amount = (amount === 0) ? 0 : (amount || 50);
	
	        var rgb1 = tinycolor(color1).toRgb();
	        var rgb2 = tinycolor(color2).toRgb();
	
	        var p = amount / 100;
	        var w = p * 2 - 1;
	        var a = rgb2.a - rgb1.a;
	
	        var w1;
	
	        if (w * a == -1) {
	            w1 = w;
	        } else {
	            w1 = (w + a) / (1 + w * a);
	        }
	
	        w1 = (w1 + 1) / 2;
	
	        var w2 = 1 - w1;
	
	        var rgba = {
	            r: rgb2.r * w1 + rgb1.r * w2,
	            g: rgb2.g * w1 + rgb1.g * w2,
	            b: rgb2.b * w1 + rgb1.b * w2,
	            a: rgb2.a * p  + rgb1.a * (1 - p)
	        };
	
	        return tinycolor(rgba);
	    };
	
	
	    // Readability Functions
	    // ---------------------
	    // <http://www.w3.org/TR/AERT#color-contrast>
	
	    // `readability`
	    // Analyze the 2 colors and returns an object with the following properties:
	    //    `brightness`: difference in brightness between the two colors
	    //    `color`: difference in color/hue between the two colors
	    tinycolor.readability = function(color1, color2) {
	        var c1 = tinycolor(color1);
	        var c2 = tinycolor(color2);
	        var rgb1 = c1.toRgb();
	        var rgb2 = c2.toRgb();
	        var brightnessA = c1.getBrightness();
	        var brightnessB = c2.getBrightness();
	        var colorDiff = (
	            Math.max(rgb1.r, rgb2.r) - Math.min(rgb1.r, rgb2.r) +
	            Math.max(rgb1.g, rgb2.g) - Math.min(rgb1.g, rgb2.g) +
	            Math.max(rgb1.b, rgb2.b) - Math.min(rgb1.b, rgb2.b)
	        );
	
	        return {
	            brightness: Math.abs(brightnessA - brightnessB),
	            color: colorDiff
	        };
	    };
	
	    // `readable`
	    // http://www.w3.org/TR/AERT#color-contrast
	    // Ensure that foreground and background color combinations provide sufficient contrast.
	    // *Example*
	    //    tinycolor.isReadable("#000", "#111") => false
	    tinycolor.isReadable = function(color1, color2) {
	        var readability = tinycolor.readability(color1, color2);
	        return readability.brightness > 125 && readability.color > 500;
	    };
	
	    // `mostReadable`
	    // Given a base color and a list of possible foreground or background
	    // colors for that base, returns the most readable color.
	    // *Example*
	    //    tinycolor.mostReadable("#123", ["#fff", "#000"]) => "#000"
	    tinycolor.mostReadable = function(baseColor, colorList) {
	        var bestColor = null;
	        var bestScore = 0;
	        var bestIsReadable = false;
	        for (var i=0; i < colorList.length; i++) {
	
	            // We normalize both around the "acceptable" breaking point,
	            // but rank brightness constrast higher than hue.
	
	            var readability = tinycolor.readability(baseColor, colorList[i]);
	            var readable = readability.brightness > 125 && readability.color > 500;
	            var score = 3 * (readability.brightness / 125) + (readability.color / 500);
	
	            if ((readable && ! bestIsReadable) ||
	                (readable && bestIsReadable && score > bestScore) ||
	                ((! readable) && (! bestIsReadable) && score > bestScore)) {
	                bestIsReadable = readable;
	                bestScore = score;
	                bestColor = tinycolor(colorList[i]);
	            }
	        }
	        return bestColor;
	    };
	
	
	    // Big List of Colors
	    // ------------------
	    // <http://www.w3.org/TR/css3-color/#svg-color>
	    var names = tinycolor.names = {
	        aliceblue: "f0f8ff",
	        antiquewhite: "faebd7",
	        aqua: "0ff",
	        aquamarine: "7fffd4",
	        azure: "f0ffff",
	        beige: "f5f5dc",
	        bisque: "ffe4c4",
	        black: "000",
	        blanchedalmond: "ffebcd",
	        blue: "00f",
	        blueviolet: "8a2be2",
	        brown: "a52a2a",
	        burlywood: "deb887",
	        burntsienna: "ea7e5d",
	        cadetblue: "5f9ea0",
	        chartreuse: "7fff00",
	        chocolate: "d2691e",
	        coral: "ff7f50",
	        cornflowerblue: "6495ed",
	        cornsilk: "fff8dc",
	        crimson: "dc143c",
	        cyan: "0ff",
	        darkblue: "00008b",
	        darkcyan: "008b8b",
	        darkgoldenrod: "b8860b",
	        darkgray: "a9a9a9",
	        darkgreen: "006400",
	        darkgrey: "a9a9a9",
	        darkkhaki: "bdb76b",
	        darkmagenta: "8b008b",
	        darkolivegreen: "556b2f",
	        darkorange: "ff8c00",
	        darkorchid: "9932cc",
	        darkred: "8b0000",
	        darksalmon: "e9967a",
	        darkseagreen: "8fbc8f",
	        darkslateblue: "483d8b",
	        darkslategray: "2f4f4f",
	        darkslategrey: "2f4f4f",
	        darkturquoise: "00ced1",
	        darkviolet: "9400d3",
	        deeppink: "ff1493",
	        deepskyblue: "00bfff",
	        dimgray: "696969",
	        dimgrey: "696969",
	        dodgerblue: "1e90ff",
	        firebrick: "b22222",
	        floralwhite: "fffaf0",
	        forestgreen: "228b22",
	        fuchsia: "f0f",
	        gainsboro: "dcdcdc",
	        ghostwhite: "f8f8ff",
	        gold: "ffd700",
	        goldenrod: "daa520",
	        gray: "808080",
	        green: "008000",
	        greenyellow: "adff2f",
	        grey: "808080",
	        honeydew: "f0fff0",
	        hotpink: "ff69b4",
	        indianred: "cd5c5c",
	        indigo: "4b0082",
	        ivory: "fffff0",
	        khaki: "f0e68c",
	        lavender: "e6e6fa",
	        lavenderblush: "fff0f5",
	        lawngreen: "7cfc00",
	        lemonchiffon: "fffacd",
	        lightblue: "add8e6",
	        lightcoral: "f08080",
	        lightcyan: "e0ffff",
	        lightgoldenrodyellow: "fafad2",
	        lightgray: "d3d3d3",
	        lightgreen: "90ee90",
	        lightgrey: "d3d3d3",
	        lightpink: "ffb6c1",
	        lightsalmon: "ffa07a",
	        lightseagreen: "20b2aa",
	        lightskyblue: "87cefa",
	        lightslategray: "789",
	        lightslategrey: "789",
	        lightsteelblue: "b0c4de",
	        lightyellow: "ffffe0",
	        lime: "0f0",
	        limegreen: "32cd32",
	        linen: "faf0e6",
	        magenta: "f0f",
	        maroon: "800000",
	        mediumaquamarine: "66cdaa",
	        mediumblue: "0000cd",
	        mediumorchid: "ba55d3",
	        mediumpurple: "9370db",
	        mediumseagreen: "3cb371",
	        mediumslateblue: "7b68ee",
	        mediumspringgreen: "00fa9a",
	        mediumturquoise: "48d1cc",
	        mediumvioletred: "c71585",
	        midnightblue: "191970",
	        mintcream: "f5fffa",
	        mistyrose: "ffe4e1",
	        moccasin: "ffe4b5",
	        navajowhite: "ffdead",
	        navy: "000080",
	        oldlace: "fdf5e6",
	        olive: "808000",
	        olivedrab: "6b8e23",
	        orange: "ffa500",
	        orangered: "ff4500",
	        orchid: "da70d6",
	        palegoldenrod: "eee8aa",
	        palegreen: "98fb98",
	        paleturquoise: "afeeee",
	        palevioletred: "db7093",
	        papayawhip: "ffefd5",
	        peachpuff: "ffdab9",
	        peru: "cd853f",
	        pink: "ffc0cb",
	        plum: "dda0dd",
	        powderblue: "b0e0e6",
	        purple: "800080",
	        rebeccapurple: "663399",
	        red: "f00",
	        rosybrown: "bc8f8f",
	        royalblue: "4169e1",
	        saddlebrown: "8b4513",
	        salmon: "fa8072",
	        sandybrown: "f4a460",
	        seagreen: "2e8b57",
	        seashell: "fff5ee",
	        sienna: "a0522d",
	        silver: "c0c0c0",
	        skyblue: "87ceeb",
	        slateblue: "6a5acd",
	        slategray: "708090",
	        slategrey: "708090",
	        snow: "fffafa",
	        springgreen: "00ff7f",
	        steelblue: "4682b4",
	        tan: "d2b48c",
	        teal: "008080",
	        thistle: "d8bfd8",
	        tomato: "ff6347",
	        turquoise: "40e0d0",
	        violet: "ee82ee",
	        wheat: "f5deb3",
	        white: "fff",
	        whitesmoke: "f5f5f5",
	        yellow: "ff0",
	        yellowgreen: "9acd32"
	    };
	
	    // Make it easy to access colors via `hexNames[hex]`
	    var hexNames = tinycolor.hexNames = flip(names);
	
	
	    // Utilities
	    // ---------
	
	    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	    function flip(o) {
	        var flipped = { };
	        for (var i in o) {
	            if (o.hasOwnProperty(i)) {
	                flipped[o[i]] = i;
	            }
	        }
	        return flipped;
	    }
	
	    // Return a valid alpha value [0,1] with all invalid values being set to 1
	    function boundAlpha(a) {
	        a = parseFloat(a);
	
	        if (isNaN(a) || a < 0 || a > 1) {
	            a = 1;
	        }
	
	        return a;
	    }
	
	    // Take input from [0, n] and return it as [0, 1]
	    function bound01(n, max) {
	        if (isOnePointZero(n)) { n = "100%"; }
	
	        var processPercent = isPercentage(n);
	        n = mathMin(max, mathMax(0, parseFloat(n)));
	
	        // Automatically convert percentage into number
	        if (processPercent) {
	            n = parseInt(n * max, 10) / 100;
	        }
	
	        // Handle floating point rounding errors
	        if ((math.abs(n - max) < 0.000001)) {
	            return 1;
	        }
	
	        // Convert into [0, 1] range if it isn't already
	        return (n % max) / parseFloat(max);
	    }
	
	    // Force a number between 0 and 1
	    function clamp01(val) {
	        return mathMin(1, mathMax(0, val));
	    }
	
	    // Parse a base-16 hex value into a base-10 integer
	    function parseIntFromHex(val) {
	        return parseInt(val, 16);
	    }
	
	    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	    function isOnePointZero(n) {
	        return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	    }
	
	    // Check to see if string passed in is a percentage
	    function isPercentage(n) {
	        return typeof n === "string" && n.indexOf('%') != -1;
	    }
	
	    // Force a hex value to have 2 characters
	    function pad2(c) {
	        return c.length == 1 ? '0' + c : '' + c;
	    }
	
	    // Replace a decimal with it's percentage value
	    function convertToPercentage(n) {
	        if (n <= 1) {
	            n = (n * 100) + "%";
	        }
	
	        return n;
	    }
	
	    // Converts a decimal to a hex value
	    function convertDecimalToHex(d) {
	        return Math.round(parseFloat(d) * 255).toString(16);
	    }
	    // Converts a hex value to a decimal
	    function convertHexToDecimal(h) {
	        return (parseIntFromHex(h) / 255);
	    }
	
	    var matchers = (function() {
	
	        // <http://www.w3.org/TR/css3-values/#integers>
	        var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	        // <http://www.w3.org/TR/css3-values/#number-value>
	        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	        // Actual matching.
	        // Parentheses and commas are optional, but not required.
	        // Whitespace can take the place of commas or opening paren
	        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	        return {
	            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	            hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	            hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	            hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	        };
	    })();
	
	    // `stringInputToObject`
	    // Permissive string parsing.  Take in a number of formats, and output an object
	    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	    function stringInputToObject(color) {
	
	        color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	        var named = false;
	        if (names[color]) {
	            color = names[color];
	            named = true;
	        }
	        else if (color == 'transparent') {
	            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	        }
	
	        // Try to match string input using regular expressions.
	        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	        // Just return an object and let the conversion functions handle that.
	        // This way the result will be the same whether the tinycolor is initialized with string or object.
	        var match;
	        if ((match = matchers.rgb.exec(color))) {
	            return { r: match[1], g: match[2], b: match[3] };
	        }
	        if ((match = matchers.rgba.exec(color))) {
	            return { r: match[1], g: match[2], b: match[3], a: match[4] };
	        }
	        if ((match = matchers.hsl.exec(color))) {
	            return { h: match[1], s: match[2], l: match[3] };
	        }
	        if ((match = matchers.hsla.exec(color))) {
	            return { h: match[1], s: match[2], l: match[3], a: match[4] };
	        }
	        if ((match = matchers.hsv.exec(color))) {
	            return { h: match[1], s: match[2], v: match[3] };
	        }
	        if ((match = matchers.hsva.exec(color))) {
	            return { h: match[1], s: match[2], v: match[3], a: match[4] };
	        }
	        if ((match = matchers.hex8.exec(color))) {
	            return {
	                a: convertHexToDecimal(match[1]),
	                r: parseIntFromHex(match[2]),
	                g: parseIntFromHex(match[3]),
	                b: parseIntFromHex(match[4]),
	                format: named ? "name" : "hex8"
	            };
	        }
	        if ((match = matchers.hex6.exec(color))) {
	            return {
	                r: parseIntFromHex(match[1]),
	                g: parseIntFromHex(match[2]),
	                b: parseIntFromHex(match[3]),
	                format: named ? "name" : "hex"
	            };
	        }
	        if ((match = matchers.hex3.exec(color))) {
	            return {
	                r: parseIntFromHex(match[1] + '' + match[1]),
	                g: parseIntFromHex(match[2] + '' + match[2]),
	                b: parseIntFromHex(match[3] + '' + match[3]),
	                format: named ? "name" : "hex"
	            };
	        }
	
	        return false;
	    }
	
	    window.tinycolor = tinycolor;
	    })();
	
	    $(function () {
	        if ($.fn.spectrum.load) {
	            $.fn.spectrum.processNativeColorInputs();
	        }
	    });
	
	});


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(236);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(236, function() {
			var newContent = __webpack_require__(236);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(237);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(237, function() {
			var newContent = __webpack_require__(237);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(238);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(238, function() {
			var newContent = __webpack_require__(238);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(239);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(239, function() {
			var newContent = __webpack_require__(239);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(241);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(241, function() {
			var newContent = __webpack_require__(241);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(242);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(242, function() {
			var newContent = __webpack_require__(242);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(243);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(243, function() {
			var newContent = __webpack_require__(243);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(244);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(244, function() {
			var newContent = __webpack_require__(244);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(245);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(245, function() {
			var newContent = __webpack_require__(245);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(246);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(246, function() {
			var newContent = __webpack_require__(246);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(247);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(247, function() {
			var newContent = __webpack_require__(247);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(248);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(248, function() {
			var newContent = __webpack_require__(248);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(249);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(249, function() {
			var newContent = __webpack_require__(249);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(250);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(250, function() {
			var newContent = __webpack_require__(250);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(251);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(251, function() {
			var newContent = __webpack_require__(251);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(252);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(252, function() {
			var newContent = __webpack_require__(252);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(253);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(253, function() {
			var newContent = __webpack_require__(253);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(254);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(254, function() {
			var newContent = __webpack_require__(254);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(255);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(255, function() {
			var newContent = __webpack_require__(255);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(256);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(256, function() {
			var newContent = __webpack_require__(256);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(257);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(257, function() {
			var newContent = __webpack_require__(257);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(258);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(258, function() {
			var newContent = __webpack_require__(258);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(259);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(259, function() {
			var newContent = __webpack_require__(259);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(260);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(260, function() {
			var newContent = __webpack_require__(260);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(261);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(261, function() {
			var newContent = __webpack_require__(261);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(262);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(262, function() {
			var newContent = __webpack_require__(262);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(263);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(263, function() {
			var newContent = __webpack_require__(263);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(264);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(264, function() {
			var newContent = __webpack_require__(264);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(265);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(265, function() {
			var newContent = __webpack_require__(265);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(266);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(266, function() {
			var newContent = __webpack_require__(266);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(269);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(269, function() {
			var newContent = __webpack_require__(269);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(270);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(270, function() {
			var newContent = __webpack_require__(270);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(271);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(271, function() {
			var newContent = __webpack_require__(271);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(272);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(272, function() {
			var newContent = __webpack_require__(272);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(273);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(273, function() {
			var newContent = __webpack_require__(273);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(274);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(274, function() {
			var newContent = __webpack_require__(274);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(275);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(275, function() {
			var newContent = __webpack_require__(275);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(276);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(276, function() {
			var newContent = __webpack_require__(276);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(278);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(278, function() {
			var newContent = __webpack_require__(278);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(279);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(279, function() {
			var newContent = __webpack_require__(279);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(280);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(280, function() {
			var newContent = __webpack_require__(280);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(281);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(281, function() {
			var newContent = __webpack_require__(281);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(282);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(282, function() {
			var newContent = __webpack_require__(282);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(283);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(283, function() {
			var newContent = __webpack_require__(283);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(284);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(284, function() {
			var newContent = __webpack_require__(284);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(285);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(285, function() {
			var newContent = __webpack_require__(285);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(286);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(286, function() {
			var newContent = __webpack_require__(286);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(287);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(287, function() {
			var newContent = __webpack_require__(287);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(288);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(288, function() {
			var newContent = __webpack_require__(288);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(289);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(289, function() {
			var newContent = __webpack_require__(289);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(290);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(290, function() {
			var newContent = __webpack_require__(290);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(291);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(291, function() {
			var newContent = __webpack_require__(291);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(292);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(292, function() {
			var newContent = __webpack_require__(292);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(293);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(293, function() {
			var newContent = __webpack_require__(293);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(294);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(294, function() {
			var newContent = __webpack_require__(294);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(295);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(295, function() {
			var newContent = __webpack_require__(295);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(296);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(296, function() {
			var newContent = __webpack_require__(296);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(297);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(297, function() {
			var newContent = __webpack_require__(297);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(298);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(298, function() {
			var newContent = __webpack_require__(298);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(299);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(299, function() {
			var newContent = __webpack_require__(299);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(300);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(300, function() {
			var newContent = __webpack_require__(300);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(302);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(302, function() {
			var newContent = __webpack_require__(302);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(303);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(303, function() {
			var newContent = __webpack_require__(303);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(304);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(304, function() {
			var newContent = __webpack_require__(304);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(305);
	if(typeof content === 'string') content = [module.id, content, ''];
	// add the styles to the DOM
	var update = __webpack_require__(10)(content);
	// Hot Module Replacement
	if(true) {
		// When the styles change, update the <style> tags
		module.hot.accept(305, function() {
			var newContent = __webpack_require__(305);
			if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
			update(newContent);
		});
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Uploadcare (2.10.3)
	 * Date: 2017-01-16 15:48:16 +0000
	 * Rev: 75cd9d2537
	 */
	!function(e,t){e.document&&("object"==typeof module&&module.exports?module.exports=t(e,__webpack_require__(1378)):e.uploadcare=t(e))}("undefined"!=typeof window?window:this,function(e,a){var r,n=e.document;return function(){r={__exports:{}},r.namespace=function(e,t){var i,a,n,o,l;if(a=r,e)for(l=e.split("."),n=0,o=l.length;o>n;n++)i=l[n],a[i]||(a[i]={}),a=a[i];return t(a)},r.expose=function(e,t){var i,a,n,o,l,s,c;for(n=e.split("."),i=n.pop(),l=r.__exports,o=r,s=0,c=n.length;c>s;s++)a=n[s],l[a]||(l[a]={}),l=l[a],o=null!=o?o[a]:void 0;return l[i]=t||o[i]}}.call(this),function(){var t;if(r.version="2.10.3",r.jQuery=a||e.jQuery,"undefined"==typeof r.jQuery)throw new ReferenceError("jQuery is not defined");t=r.expose,t("version"),t("jQuery"),t("plugin",function(e){return e(r)})}.call(this),e.XDomainRequest&&r.jQuery.ajaxTransport(function(e){if(e.crossDomain&&e.async){e.timeout&&(e.xdrTimeout=e.timeout,delete e.timeout);var t;return{send:function(i,a){function r(e,i,r,n){t.onload=t.onerror=t.ontimeout=function(){},t=void 0,a(e,i,r,n)}t=new XDomainRequest,t.onload=function(){r(200,"OK",{text:t.responseText},"Content-Type: "+t.contentType)},t.onerror=function(){r(404,"Not Found")},t.onprogress=function(){},t.ontimeout=function(){r(0,"timeout")},t.timeout=e.xdrTimeout||Number.MAX_VALUE,t.open(e.type,e.url.replace(/^https?:/,"")),t.send(e.hasContent&&e.data||null)},abort:function(){t&&(t.onerror=function(){},t.abort())}}}}),function(){r.namespace("utils.abilities",function(t){var i,a,r,o;t.fileAPI=!!(e.File&&e.FileList&&e.FileReader),t.sendFileAPI=!(!e.FormData||!t.fileAPI),t.dragAndDrop=function(){var e;return e=n.createElement("div"),"draggable"in e||"ondragstart"in e&&"ondrop"in e}(),t.canvas=function(){var e;return e=n.createElement("canvas"),!(!e.getContext||!e.getContext("2d"))}(),t.fileDragAndDrop=t.fileAPI&&t.dragAndDrop,t.iOSVersion=null,(i=/^[^(]+\(iP(?:hone|od|ad);\s*(.+?)\)/.exec(navigator.userAgent))&&(r=/OS (\d)_(\d)/.exec(i[1]))&&(t.iOSVersion=+r[1]+r[2]/10),t.Blob=!1;try{new e.Blob&&(t.Blob=e.Blob)}catch(l){}return a=e.URL||e.webkitURL||!1,t.URL=a&&a.createObjectURL&&a,t.FileReader=(null!=(o=e.FileReader)?o.prototype.readAsArrayBuffer:void 0)&&e.FileReader})}.call(this),function(){var e,t={}.hasOwnProperty,i=function(e,i){for(var a in i)t.call(i,a)&&(e[a]=i[a]);function r(){this.constructor=e}return r.prototype=i.prototype,e.prototype=new r,e.__super__=i.prototype,e},a=[].indexOf||function(e){for(var t=0,i=this.length;i>t;t++)if(t in this&&this[t]===e)return t;return-1},n=function(e,t){return function(){return e.apply(t,arguments)}},o=[].slice;e=r.jQuery,r.namespace("utils",function(t){var r;return t.Collection=function(){function t(t){var i,a,r;for(null==t&&(t=[]),this.onAdd=e.Callbacks(),this.onRemove=e.Callbacks(),this.onSort=e.Callbacks(),this.onReplace=e.Callbacks(),this.__items=[],a=0,r=t.length;r>a;a++)i=t[a],this.add(i)}return t.prototype.add=function(e){return this.__add(e,this.__items.length)},t.prototype.__add=function(e,t){return this.__items.splice(t,0,e),this.onAdd.fire(e,t)},t.prototype.remove=function(t){var i;return i=e.inArray(t,this.__items),-1!==i?this.__remove(t,i):void 0},t.prototype.__remove=function(e,t){return this.__items.splice(t,1),this.onRemove.fire(e,t)},t.prototype.clear=function(){var e,t,i,a,r,n;for(i=this.get(),this.__items.length=0,n=[],e=a=0,r=i.length;r>a;e=++a)t=i[e],n.push(this.onRemove.fire(t,e));return n},t.prototype.replace=function(t,i){var a;return t!==i&&(a=e.inArray(t,this.__items),-1!==a)?this.__replace(t,i,a):void 0},t.prototype.__replace=function(e,t,i){return this.__items[i]=t,this.onReplace.fire(e,t,i)},t.prototype.sort=function(e){return this.__items.sort(e),this.onSort.fire()},t.prototype.get=function(e){return null!=e?this.__items[e]:this.__items.slice(0)},t.prototype.length=function(){return this.__items.length},t}(),t.UniqCollection=function(e){i(t,e);function t(){return r=t.__super__.constructor.apply(this,arguments)}return t.prototype.add=function(e){return a.call(this.__items,e)>=0?void 0:t.__super__.add.apply(this,arguments)},t.prototype.__replace=function(e,i,r){return a.call(this.__items,i)>=0?this.remove(e):t.__super__.__replace.apply(this,arguments)},t}(t.Collection),t.CollectionOfPromises=function(t){i(r,t);function r(){this.onAnyProgress=n(this.onAnyProgress,this),this.onAnyFail=n(this.onAnyFail,this),this.onAnyDone=n(this.onAnyDone,this),this.anyDoneList=e.Callbacks(),this.anyFailList=e.Callbacks(),this.anyProgressList=e.Callbacks(),this.anyProgressList.add(function(t,i){return e(t).data("lastProgress",i)}),r.__super__.constructor.apply(this,arguments)}return r.prototype.onAnyDone=function(e){var t,i,a,r,n;for(this.anyDoneList.add(e),r=this.__items,n=[],i=0,a=r.length;a>i;i++)t=r[i],"resolved"===t.state()?n.push(t.done(function(){return e.apply(null,[t].concat(o.call(arguments)))})):n.push(void 0);return n},r.prototype.onAnyFail=function(e){var t,i,a,r,n;for(this.anyFailList.add(e),r=this.__items,n=[],i=0,a=r.length;a>i;i++)t=r[i],"rejected"===t.state()?n.push(t.fail(function(){return e.apply(null,[t].concat(o.call(arguments)))})):n.push(void 0);return n},r.prototype.onAnyProgress=function(t){var i,a,r,n,o;for(this.anyProgressList.add(t),n=this.__items,o=[],a=0,r=n.length;r>a;a++)i=n[a],o.push(t(i,e(i).data("lastProgress")));return o},r.prototype.lastProgresses=function(){var t,i,a,r,n;for(r=this.__items,n=[],i=0,a=r.length;a>i;i++)t=r[i],n.push(e(t).data("lastProgress"));return n},r.prototype.add=function(e){return e&&e.then?(r.__super__.add.apply(this,arguments),this.__watchItem(e)):void 0},r.prototype.__replace=function(e,t,i){return t&&t.then?(r.__super__.__replace.apply(this,arguments),this.__watchItem(t)):this.remove(e)},r.prototype.__watchItem=function(e){var t,i=this;return t=function(t){return function(){return a.call(i.__items,e)>=0?t.fire.apply(t,[e].concat(o.call(arguments))):void 0}},e.then(t(this.anyDoneList),t(this.anyFailList),t(this.anyProgressList))},r}(t.UniqCollection)})}.call(this),function(){var e;e=r.jQuery,r.namespace("utils",function(t){var i;return i=function(t,i){var a,r=this;return a=e.Deferred(),i&&(t.src=i),t.complete?a.resolve(t):(e(t).one("load",function(){return a.resolve(t)}),e(t).one("error",function(){return a.reject(t)})),a.promise()},t.imageLoader=function(a){return e.isArray(a)?e.when.apply(null,e.map(a,t.imageLoader)):a.src?i(a):i(new Image,a)},t.videoLoader=function(t){var i;return i=e.Deferred(),e("<video/>").on("loadeddata",i.resolve).on("error",i.reject).attr("src",t).load(),i.promise()}})}.call(this),function(){var t=[].slice;r.namespace("utils",function(i){var a,r;return i.log=function(){var t;try{return null!=(t=e.console)&&"function"==typeof t.log?t.log.apply(t,arguments):void 0}catch(i){}},i.debug=function(){var a,r;if(null!=(a=e.console)?!a.debug:!0)return i.log.apply(i,["Debug:"].concat(t.call(arguments)));try{return(r=e.console).debug.apply(r,arguments)}catch(n){}},i.warn=function(){var a,r;if(null!=(a=e.console)?!a.warn:!0)return i.log.apply(i,["Warning:"].concat(t.call(arguments)));try{return(r=e.console).warn.apply(r,arguments)}catch(n){}},r={},i.warnOnce=function(e){return null==r[e]?(r[e]=!0,i.warn(e)):void 0},a={publicKey:"Global public key not set. Uploads may not work!\nAdd this to the <head> tag to set your key:\n\n<script>\nUPLOADCARE_PUBLIC_KEY = 'your_public_key';\n</script>"},i.commonWarning=function(e){return null!=a[e]?i.warnOnce(a[e]):void 0}})}.call(this),function(){var t;t=r.jQuery,r.namespace("utils",function(i){var a,r=this;return a={},t(e).on("message",function(e){var t,i,r,n,o,l,s;t=e.originalEvent;try{r=JSON.parse(t.data)}catch(c){return}if(r.type in a){for(l=a[r.type],s=[],n=0,o=l.length;o>n;n++)i=l[n],t.source===i[0]?s.push(i[1](r)):s.push(void 0);return s}}),i.registerMessage=function(e,t,i){return e in a||(a[e]=[]),a[e].push([t,i])},i.unregisterMessage=function(e,i){return e in a?a[e]=t.grep(a[e],function(e){return e[0]!==i}):void 0}})}.call(this),function(){var e,t=[].indexOf||function(e){for(var t=0,i=this.length;i>t;t++)if(t in this&&this[t]===e)return t;return-1},i=[].slice;e=r.jQuery,r.namespace("utils",function(a){var r;return a.unique=function(e){var i,a,r,n;for(a=[],r=0,n=e.length;n>r;r++)i=e[r],
	t.call(a,i)<0&&a.push(i);return a},a.defer=function(e){return setTimeout(e,0)},a.gcd=function(e,t){var i;while(t)i=e%t,e=t,t=i;return e},a.once=function(e){var t,i;return t=!1,i=null,function(){return t||(i=e.apply(this,arguments),t=!0),i}},a.wrapToPromise=function(t){return e.Deferred().resolve(t).promise()},a.then=function(t,i,a,r){var n,o;return o=e.Deferred(),n=function(e,t){return e&&t?function(){return t.call(this,e.apply(this,arguments))}:e||t},t.then(n(i,o.resolve),n(a,o.reject),n(r,o.notify)),o.promise()},a.bindAll=function(t,i){var a;return a={},e.each(i,function(i,r){var n;return n=t[r],e.isFunction(n)?a[r]=function(){var e;return e=n.apply(t,arguments),e===t?a:e}:a[r]=n}),a},a.upperCase=function(e){return e.replace(/([A-Z])/g,"_$1").toUpperCase()},a.publicCallbacks=function(e){var t;return t=e.add,t.add=e.add,t.remove=e.remove,t},a.uuid=function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,function(e){var t,i;return t=16*Math.random()|0,i="x"===e?t:3&t|8,i.toString(16)})},a.splitUrlRegex=/^(?:([^:\/?#]+):)?(?:\/\/([^\/?\#]*))?([^?\#]*)\??([^\#]*)\#?(.*)$/,a.uuidRegex=/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/i,a.groupIdRegex=new RegExp(""+a.uuidRegex.source+"~[0-9]+","i"),a.cdnUrlRegex=new RegExp("^/?("+a.uuidRegex.source+")(?:/(-/(?:[^/]+/)+)?([^/]*))?$","i"),a.splitCdnUrl=function(e){return a.cdnUrlRegex.exec(a.splitUrlRegex.exec(e)[3])},a.escapeRegExp=function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},a.globRegexp=function(t,i){var r;return null==i&&(i="i"),r=e.map(t.split("*"),a.escapeRegExp),new RegExp("^"+r.join(".+")+"$",i)},a.normalizeUrl=function(e){var t;return t=n.location.protocol,"http:"!==t&&(t="https:"),e.replace(/^\/\//,t+"//").replace(/\/+$/,"")},a.fitText=function(e,t){var i,a;return e.length>t?(i=Math.ceil((t-3)/2),a=Math.floor((t-3)/2),e.slice(0,i)+"..."+e.slice(-a)):e},a.fitSizeInCdnLimit=function(e){return a.fitSize(e,[2048,2048])},a.fitSize=function(e,t,i){var a,r;return e[0]>t[0]||e[1]>t[1]||i?(r=t[0]/e[0],a=t[1]/e[1],!t[0]||t[1]&&r>a?[Math.round(a*e[0]),t[1]]:[t[0],Math.round(r*e[1])]):e.slice()},a.applyCropSelectionToFile=function(e,t,i,a){var r,n,o,l,s,c,u,p=this;return c=a.width,n=a.height,l=t.preferedSize,o="",u=c===i[0]&&n===i[1],u||(o+="-/crop/"+c+"x"+n+"/"+a.left+","+a.top+"/"),r=t.downscale&&(c>l[0]||n>l[1]),s=t.upscale&&(c<l[0]||n<l[1]),r||s?(a.sw=l[0],a.sh=l[1],o+="-/resize/"+l.join("x")+"/"):u||(o+="-/preview/"),e.then(function(e){return e.cdnUrlModifiers=o,e.cdnUrl=""+e.originalUrl+(o||""),e.crop=a,e})},a.fileInput=function(t,i,a){var r,n,o;return n=null,r=i.inputAcceptTypes,""===r&&(r=i.imagesOnly?"image/*":null),(o=function(){return n=e(i.multiple?'<input type="file" multiple>':'<input type="file">').attr("accept",r).css({position:"absolute",top:0,opacity:0,margin:0,padding:0,width:"auto",height:"auto",cursor:t.css("cursor")}).on("change",function(){return a(this),e(this).hide(),o()}),t.append(n)})(),t.css({position:"relative",overflow:"hidden"}).mousemove(function(t){var i,a,r,o;return o=e(this).offset(),i=o.left,a=o.top,r=n.width(),n.css({left:t.pageX-i-r+10,top:t.pageY-a-10})})},a.fileSelectDialog=function(t,i,a){var r;return r=i.inputAcceptTypes,""===r&&(r=i.imagesOnly?"image/*":null),e(i.multiple?'<input type="file" multiple>':'<input type="file">').attr("accept",r).css({position:"fixed",bottom:0,opacity:0}).on("change",function(){return a(this),e(this).remove()}).appendTo(t).focus().click().hide()},a.fileSizeLabels="B KB MB GB TB PB EB ZB YB".split(" "),a.readableFileSize=function(e,t,i,r){var n,o,l,s;if(null==t&&(t=""),null==i&&(i=""),null==r&&(r=""),e=parseInt(e,10),isNaN(e))return t;n=2,l=0,s=1e3-5*Math.pow(10,2-Math.max(n,3));while(e>s&&l<a.fileSizeLabels.length-1)l++,e/=1024;return e+=1e-15,o=Math.max(0,n-Math.floor(e).toFixed(0).length),e=Number(e.toFixed(o)),""+i+e+" "+a.fileSizeLabels[l]+r},a.ajaxDefaults={dataType:"json",crossDomain:!0,cache:!1},a.jsonp=function(t,i,r){return e.isPlainObject(i)&&(r=i,i="GET"),e.ajax(e.extend({url:t,type:i,data:r},a.ajaxDefaults)).then(function(t){var i;return t.error?(i=t.error.content||t.error,e.Deferred().reject(i)):t},function(e,i,r){var n;return n=""+i+" ("+r+")",a.warn("JSONP unexpected error: "+n+" while loading "+t),n})},a.canvasToBlob=function(e,t,i,a){var r,n,o,l,s,c;if(HTMLCanvasElement.prototype.toBlob)return e.toBlob(a,t,i);for(o=e.toDataURL(t,i),o=o.split(","),n=atob(o[1]),r=new Uint8Array(n.length),l=s=0,c=n.length;c>s;l=s+=1)r[l]=n.charCodeAt(l);return a(new Blob([r],{type:/:(.+\/.+);/.exec(o[0])[1]}))},a.taskRunner=function(e){var t,i,r,n;return n=0,t=[],i=function(){var e;return t.length?(e=t.shift(),a.defer(function(){return e(i)})):n-=1},r=function(r){return!e||e>n?(n+=1,a.defer(function(){return r(i)})):t.push(r)}},r=[["notify","progress",2],["resolve","done",0],["reject","fail",1]],a.fixedPipe=function(){var t,a;return a=arguments[0],t=2<=arguments.length?i.call(arguments,1):[],e.Deferred(function(i){return e.each(r,function(r,n){var o;return o=e.isFunction(t[n[2]])&&t[n[2]],a[n[1]](function(){var t;return t=o&&o.apply(this,arguments),t&&e.isFunction(t.promise)?t.promise().progress(i.notify).done(i.resolve).fail(i.reject):i[n[0]+"With"](this===a?i.promise():this,o?[t]:arguments)})})}).promise()}})}.call(this),function(){var t,i,a,n=[].indexOf||function(e){for(var t=0,i=this.length;i>t;t++)if(t in this&&this[t]===e)return t;return-1};i=r.expose,a=r.utils,t=r.jQuery,r.namespace("settings",function(o){var l,s,c,u,p,d,g,h,f,m;return s={live:!0,manualStart:!1,locale:null,localePluralize:null,localeTranslations:null,systemDialog:!1,crop:!1,previewStep:!1,imagesOnly:!1,clearable:!1,multiple:!1,multipleMax:0,multipleMin:1,multipleMaxStrict:!1,imageShrink:!1,pathValue:!0,tabs:"file camera url facebook gdrive gphotos dropbox instagram evernote flickr skydrive",preferredTypes:"",inputAcceptTypes:"",doNotStore:!1,publicKey:null,secureSignature:"",secureExpire:"",pusherKey:"79ae88bd931ea68464d9",cdnBase:"https://ucarecdn.com",urlBase:"https://upload.uploadcare.com",socialBase:"https://social.uploadcare.com",imagePreviewMaxSize:26214400,multipartMinSize:26214400,multipartPartSize:5242880,multipartMinLastPartSize:1048576,multipartConcurrency:4,multipartMaxAttempts:3,parallelDirectUploads:10,passWindowOpen:!1,scriptBase:"//ucarecdn.com/widget/"+r.version+"/uploadcare/",debugUploads:!1},h={tabs:{all:"file camera url facebook gdrive gphotos dropbox instagram evernote flickr skydrive box vk huddle","default":s.tabs}},f=function(e){return t.isArray(e)||(e=t.trim(e),e=e?e.split(" "):[]),e},l=function(e,t){var i,r,n,o,l,s,c,u;for(l=0,c=t.length;c>l;l++){if(r=t[l],o=n=f(e[r]),h.hasOwnProperty(r))for(o=[],s=0,u=n.length;u>s;s++)i=n[s],h[r].hasOwnProperty(i)?o=o.concat(f(h[r][i])):o.push(i);e[r]=a.unique(o)}return e},m=function(e,t){var i,r,n;for(r=0,n=t.length;n>r;r++)i=t[r],null!=e[i]&&(e[i]=a.normalizeUrl(e[i]));return e},c=function(e,i){var a,r,n,o;for(n=0,o=i.length;o>n;n++)a=i[n],null!=e[a]&&(r=e[a],"string"===t.type(r)?(r=t.trim(r).toLowerCase(),e[a]=!("false"===r||"disabled"===r)):e[a]=!!r);return e},u=function(e,t){var i,a,r;for(a=0,r=t.length;r>a;a++)i=t[a],null!=e[i]&&(e[i]=parseInt(e[i]));return e},d=function(e){var i,a;return a=/^([0-9]+)([x:])([0-9]+)\s*(|upscale|minimum)$/i,i=a.exec(t.trim(e.toLowerCase()))||[],{downscale:"x"===i[2],upscale:!!i[4],notLess:"minimum"===i[4],preferedSize:i.length?[+i[1],+i[3]]:void 0}},g=function(e){var i,r,n;return i=/^([0-9]+)x([0-9]+)(?:\s+(\d{1,2}|100)%)?$/i,r=i.exec(t.trim(e.toLowerCase()))||[],r.length?(n=r[1]*r[2],n>5e6?(a.warnOnce("Shrinked size can not be larger than 5MP. "+("You have set "+r[1]+"x"+r[2]+" (")+(""+Math.ceil(n/1e3/100)/10+"MP).")),!1):{quality:r[3]?r[3]/100:void 0,size:n}):!1},p=function(e){return l(e,["tabs","preferredTypes"]),m(e,["cdnBase","socialBase","urlBase","scriptBase"]),c(e,["doNotStore","imagesOnly","multiple","clearable","pathValue","previewStep","systemDialog","debugUploads","multipleMaxStrict"]),u(e,["multipleMax","multipleMin","multipartMinSize","multipartPartSize","multipartMinLastPartSize","multipartConcurrency","multipartMaxAttempts","parallelDirectUploads"]),e.crop===!1||t.isArray(e.crop)||(/^(disabled?|false|null)$/i.test(e.crop)?e.crop=!1:t.isPlainObject(e.crop)?e.crop=[e.crop]:e.crop=t.map((""+e.crop).split(","),d)),
	e.imageShrink&&!t.isPlainObject(e.imageShrink)&&(e.imageShrink=g(e.imageShrink)),(e.crop||e.multiple)&&(e.previewStep=!0),a.abilities.sendFileAPI||(e.systemDialog=!1),e.validators&&(e.validators=e.validators.slice()),e},i("defaults",t.extend({allTabs:h.tabs.all},s)),o.globals=function(){var t,i,r;r={};for(t in s)i=e["UPLOADCARE_"+a.upperCase(t)],void 0!==i&&(r[t]=i);return r},o.common=a.once(function(e,i){var r;return i||(s=t.extend(s,o.globals())),r=p(t.extend(s,e||{})),r.publicKey||a.commonWarning("publicKey"),o.waitForSettings.fire(r),r}),o.build=function(e){var i;return i=t.extend({},o.common()),t.isEmptyObject(e)||(i=p(t.extend(i,e))),i},o.waitForSettings=t.Callbacks("once memory"),o.CssCollector=function(){function e(){this.urls=[],this.styles=[]}return e.prototype.addUrl=function(e){if(!/^https?:\/\//i.test(e))throw new Error("Embedded urls should be absolute. "+e);return n.call(this.urls,e)>=0?void 0:this.urls.push(e)},e.prototype.addStyle=function(e){return this.styles.push(e)},e}(),r.tabsCss=new o.CssCollector,s._emptyKeyText='<div class="uploadcare-dialog-message-center">\n<div class="uploadcare-dialog-big-title">Hello!</div>\n<div class="uploadcare-dialog-large-text">\n  <div>Your <a class="uploadcare-link" href="https://uploadcare.com/dashboard/">public key</a> is not set.</div>\n  <div>Add this to the &lt;head&gt; tag to start uploading files:</div>\n  <div class="uploadcare-pre">&lt;script&gt;\nUPLOADCARE_PUBLIC_KEY = \'your_public_key\';\n&lt;/script&gt;</div>\n</div>\n</div>'})}.call(this),function(){r.namespace("locale.translations",function(e){return e.en={uploading:"Uploading... Please wait.",loadingInfo:"Loading info...",errors:{"default":"Error",baddata:"Incorrect value",size:"File too big",upload:"Can’t upload",user:"Upload canceled",info:"Can’t load info",image:"Only images allowed",createGroup:"Can’t create file group",deleted:"File was deleted"},draghere:"Drop a file here",file:{one:"%1 file",other:"%1 files"},buttons:{cancel:"Cancel",remove:"Remove",choose:{files:{one:"Choose a file",other:"Choose files"},images:{one:"Choose an image",other:"Choose images"}}},dialog:{done:"Done",showFiles:"Show files",tabs:{names:{"empty-pubkey":"Welcome",preview:"Preview",file:"Local Files",url:"Arbitrary Links",camera:"Camera",facebook:"Facebook",dropbox:"Dropbox",gdrive:"Google Drive",gphotos:"Google Photos",instagram:"Instagram",vk:"VK",evernote:"Evernote",box:"Box",skydrive:"OneDrive",flickr:"Flickr",huddle:"Huddle"},file:{drag:"Drop a file here",nodrop:"Upload files from your computer",cloudsTip:"Cloud storages<br>and social networks",or:"or",button:"Choose a local file",also:"You can also choose it from"},url:{title:"Files from the Web",line1:"Grab any file off the web.",line2:"Just provide the link.",input:"Paste your link here...",button:"Upload"},camera:{capture:"Take a photo",mirror:"Mirror",startRecord:"Record a video",stopRecord:"Stop",cancelRecord:"Cancel",retry:"Request permissions again",pleaseAllow:{title:"Please allow access to your camera",text:"You have been prompted to allow camera access from this site. In order to take pictures with your camera you must approve this request."},notFound:{title:"No camera detected",text:"Looks like you have no camera connected to this device."}},preview:{unknownName:"unknown",change:"Cancel",back:"Back",done:"Add",unknown:{title:"Uploading... Please wait for a preview.",done:"Skip preview and accept"},regular:{title:"Add this file?",line1:"You are about to add the file above.",line2:"Please confirm."},image:{title:"Add this image?",change:"Cancel"},crop:{title:"Crop and add this image",done:"Done",free:"free"},video:{title:"Add this video?",change:"Cancel"},error:{"default":{title:"Oops!",text:"Something went wrong during the upload.",back:"Please try again"},image:{title:"Only image files are accepted.",text:"Please try again with another file.",back:"Choose image"},size:{title:"The file you selected exceeds the limit.",text:"Please try again with another file."},loadImage:{title:"Error",text:"Can’t load image"}},multiple:{title:"You’ve chosen %files%",question:"Do you want to add all of these files?",tooManyFiles:"You’ve chosen too many files. %max% is maximum.",tooFewFiles:"You’ve chosen %files%. At least %min% required.",clear:"Remove all",done:"Done"}}},footer:{text:"powered by",link:"uploadcare"}}}}),r.namespace("locale.pluralize",function(e){return e.en=function(e){return 1===e?"one":"other"}})}.call(this),function(){var e,t,i;i=r.utils,t=r.settings,e=r.jQuery,r.namespace("locale",function(a){var r,n,o,l,s;return n="en",o={lang:n,translations:a.translations[n],pluralize:a.pluralize[n]},s=function(t){var i,r,n;return i=t.locale||o.lang,n=e.extend(!0,{},a.translations[i],t.localeTranslations),r=e.isFunction(t.localePluralize)?t.localePluralize:a.pluralize[i],{lang:i,translations:n,pluralize:r}},r=i.once(function(){return s(t.build())}),a.rebuild=function(e){var i;return i=s(t.build(e)),r=function(){return i}},l=function(e,t){var i,a,r,n;for(i=e.split("."),r=0,n=i.length;n>r;r++){if(a=i[r],null==t)return null;t=t[a]}return t},a.t=function(e,t){var i,a,n;return i=r(),a=l(e,i.translations),null==a&&i.lang!==o.lang&&(i=o,a=l(e,i.translations)),null!=t&&(a=null!=i.pluralize?(null!=(n=a[i.pluralize(t)])?n.replace("%1",t):void 0)||t:""),a||""}})}.call(this),function(){var e,t,i;t=r.locale,i=r.utils,e=r.jQuery,r.namespace("templates",function(a){return a.JST={},a.tpl=function(n,o){var l;return null==o&&(o={}),l=a.JST[n],null!=l?l(e.extend({t:t.t,utils:i,uploadcare:r},o)):""}})}.call(this),r.templates.JST["circle-text"]=function(e){var __p=[],t=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-widget-circle-back">\r\n  <div class="uploadcare-widget-circle-text"></div>\r\n</div>\r\n');return __p.join("")},r.templates.JST.dialog=function(e){var __p=[],t=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog uploadcare-responsive-panel"><!--\r\n--><div class="uploadcare-dialog-inner-wrap">\r\n    <div class="uploadcare-dialog-close">×</div>\r\n    <div class="uploadcare-dialog-placeholder"></div>\r\n  </div>\r\n</div>\r\n');return __p.join("")},r.templates.JST.panel=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-panel">\r\n  <div class="uploadcare-dialog-tabs"></div>\r\n\r\n  <div class="uploadcare-panel-footer uploadcare-panel-footer__summary">\r\n    <div class="uploadcare-dialog-button uploadcare-dialog-source-base-show-files"\r\n         tabindex="0" role="button">\r\n      ',(""+t("dialog.showFiles")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n      <div class="uploadcare-panel-footer-counter"></div>\r\n    </div>\r\n    <div class="uploadcare-dialog-button-success uploadcare-dialog-source-base-done"\r\n         tabindex="0" role="button">',(""+t("dialog.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n    <div class="uploadcare-panel-footer-text"></div>\r\n  </div>\r\n</div>\r\n<div class="uploadcare-dialog-footer">\r\n  ',(""+t("dialog.footer.text")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  <svg width="13" height="13" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><title>Uploadcare Logo</title><g fill="none" fill-rule="evenodd"><path d="M-1-1h32v32H-1z"/><path d="M15 29.452c7.98 0 14.452-6.47 14.452-14.452C29.452 7.02 22.982.548 15 .548 7.02.548.548 7.018.548 15c0 7.98 6.47 14.452 14.452 14.452zm0-12.846c.887 0 1.606-.72 1.606-1.606 0-.887-.72-1.606-1.606-1.606-.887 0-1.606.72-1.606 1.606 0 .887.72 1.606 1.606 1.606z" fill="#FFD800"/></g></svg>\r\n  <a href="https://uploadcare.com/?utm_campaign=widget&utm_source=copyright&utm_medium=desktop&utm_content=',(""+r.version).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'"\r\n     target="_blank">',(""+t("dialog.footer.link")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</a>\r\n</div>\r\n");
	return __p.join("")},r.templates.JST.styles=function(e){var __p=[],t=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('\n\n\n\n\n\n\n\n.uploadcare-dialog-disabled-tab:hover:before,.uploadcare-dialog-tab:before,.uploadcare-dialog-tab:hover:before{background-image:url("',settings.scriptBase,'/images/tab-icons.png");background-size:50px}.uploadcare-dialog-tab_current:before,.uploadcare-dialog-tab_current:hover:before{background-image:url("',settings.scriptBase,'/images/tab-icons-active.png");background-size:50px}.uploadcare-dialog-file-sources:before{background-image:url("',settings.scriptBase,'/images/arrow.png")}.uploadcare-remove{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAABM0lEQVQoz5VTvW7CMBC2kHivQsjrZGRjaB6lXWCJbWScIT8PYN0GQ7s6FUUKL8CA2suR2C4FlfqkyL77cuf7/B1jbp3GdmIW1VIVKq9ezMI+ncbs92omNeeQgYQ1msQdh5o30x+g82ibCAysr4yDgG1yHjngLhkyXVuXeZcMRSNJMI4mAwinGl2siaiFWncOAW/QgO4vwCGHD/QI2tca27LxEDrAF7QE5fg94ungfrMxM89ZXyqnYAsbtG53RM/lKhmYlJUr6XrUPbQlmHY8SChXTBUhHRsCXfKGdKmCKe2PApQDKmokAJavD5b2zei+hTvNDPQI+HR5PD3C0+MJf4c95vCE79ETEI5POPvzCWf/EwXJbH5XZvNAZqSh6U3hRjc0jqMQmxRHoVRltTSpjcNR+AZwwvykEau0BgAAAABJRU5ErkJggg==)}.uploadcare-file-item__error:before{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABIklEQVR42q3Vv2rCUBTHcaEQH825TdLl9hl0FsFdV7s5uXSpb+DoEziV6JCgATdR02D9E09/R64KF3NPbQx84BJOvgRyuSktK5VbHHiFDwhhCwl86Xu+nimZbsWeYQIkmMCLLfgELaA7tfSzRlCISVEz6AEV5J2DDszyBtNGg7L5/CSt123BGBwOKqA8WRzT+cqmU+kt3zj4aQ0myTW4WEjBPgcj29B+NLoE98OhFIw4+GMb2vR6l+Cm25WCWw6ubUPftRrR8XiSVKt/CgZADxKJH2XlurQbDBivxY8ibpu02SR98VrcNuLGXitFh/GYDkHAa2ljlznIfKCCfPNwaBeItfOOr84/Yu/m8WVy7zhgPfHE1hxQ0IcQdlqo76m8X8Avwkyxg4iIuCEAAAAASUVORK5CYII=)}.uploadcare-file-icon{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAQAAAAngNWGAAABD0lEQVQoFQXBPa5OARQF0LXPvfKS9wo/hegMQUzEJESiUIpOoxOlRKJDIgqVUZiNqPGdba0AAPLj48Mn/8ApgEcPOAGArx/uPVvrEFVRA04A+PTu+vk1BlSwLuAE4Pubvy+vHGAFxABOgC+v/ryO24oYUVUDGODzi+PtjfuuXBBUxG8XASd8e3rz/o5rY60YwVjXKAj8/HXrblDFIAKCehxOOHcxCggWUTHghJYqIqIigoqCEyCKEcXFgAjghCAWi1EDIlgwABWxoIhYaxUMsIo4BEHBRR1ggMMogoqq4jCAgVo1VhGMgFjACQUjCKIqIigYqKiLILiogFULBkbUWhSDqKpYMFAFwaJGUVUH+A8ToG9OM8KqQQAAAABJRU5ErkJggg==)}.uploadcare-zoomable-icon:after{background-image:url("',settings.scriptBase,'/images/zoom@2x.png")}.uploadcare-dialog-error-tab-illustration{background-image:url("',settings.scriptBase,'/images/error-default.png")}.uploadcare-dialog-camera-holder .uploadcare-dialog-error-tab-illustration,.uploadcare-dialog-error-tab-image .uploadcare-dialog-error-tab-illustration{background-image:url("',settings.scriptBase,'/images/error-image.png")}.uploadcare-dialog{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQIHWMw/AQAAVcBJCiBozgAAAAASUVORK5CYII=);background:rgba(48,48,48,.7)}@media (-webkit-min-device-pixel-ratio:1.5),(min-resolution:144dpi){.uploadcare-dialog-disabled-tab:hover:before,.uploadcare-dialog-tab:before,.uploadcare-dialog-tab:hover:before{background-image:url("',settings.scriptBase,'/images/tab-icons@2x.png")}.uploadcare-dialog-tab_current:before,.uploadcare-dialog-tab_current:hover:before{background-image:url("',settings.scriptBase,"/images/tab-icons-active@2x.png\")}}html.uploadcare-dialog-opened{overflow:hidden}.uploadcare-dialog{font-family:\"Helvetica Neue\",Helvetica,Arial,\"Lucida Grande\",sans-serif;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10000;overflow:auto;white-space:nowrap;text-align:center}.uploadcare-dialog:before{display:inline-block;vertical-align:middle;content:'';height:100%;position:static;width:0}.uploadcare-dialog *{margin:0;padding:0}.uploadcare-dialog .uploadcare-dialog-panel{border-radius:8px;box-shadow:0 1px 2px rgba(0,0,0,.35)}.uploadcare-dialog{-webkit-transition:opacity .33s cubic-bezier(.05,.7,.25,1);transition:opacity .33s cubic-bezier(.05,.7,.25,1);opacity:0}.uploadcare-dialog .uploadcare-dialog-inner-wrap{-webkit-transition:-webkit-transform .33s cubic-bezier(.05,.7,.25,1);transition:transform .33s cubic-bezier(.05,.7,.25,1);transition:transform .33s cubic-bezier(.05,.7,.25,1),-webkit-transform .33s cubic-bezier(.05,.7,.25,1);-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);-webkit-transform-origin:50% 100%;-ms-transform-origin:50% 100%;transform-origin:50% 100%}.uploadcare-dialog.uploadcare-active{opacity:1}.uploadcare-dialog.uploadcare-active .uploadcare-dialog-inner-wrap{-webkit-transform:none;-ms-transform:none;transform:none}.uploadcare-dialog-inner-wrap{display:inline-block;vertical-align:middle;white-space:normal;text-align:left;box-sizing:border-box;position:relative;width:100%;min-width:760px;max-width:944px;padding:0 33px 0 11px}.uploadcare-dialog-close{width:33px;height:33px;line-height:33px;font-size:29.7px;font-weight:700;color:#fff;cursor:pointer;position:absolute;text-align:center;right:0}.uploadcare-dialog-panel{overflow:hidden;position:relative;background:#efefef;font-weight:400;padding-left:75px;box-sizing:border-box}.uploadcare-dialog-panel :focus{outline:2px dotted #0094c0}.uploadcare-dialog-panel .uploadcare-mouse-focused:focus,.uploadcare-dialog-panel :active{outline:none}.uploadcare-dialog-panel.uploadcare-panel-hide-tabs{padding-left:0}.uploadcare-dialog-tabs{box-sizing:border-box;width:75px;height:616px;margin-left:-75px;float:left;background:#dee0e1;overflow:hidden}.uploadcare-panel-hide-tabs .uploadcare-dialog-tabs{display:none}.uploadcare-dialog-tab{box-sizing:border-box;height:56px;position:relative;border:1px solid #c5cace;border-width:0 1px 1px 0;cursor:pointer}.uploadcare-dialog-tab .uploadcare-dialog-icon,.uploadcare-dialog-tab:before{box-sizing:border-box;position:absolute;top:50%;left:50%;display:inline-block;width:50px;height:50px;margin:-25px;opacity:.66}.uploadcare-dialog-tab:before{content:''}.uploadcare-dialog-tab:hover{background-color:#e5e7e8}.uploadcare-dialog-tab:hover .uploadcare-dialog-icon{opacity:1}.uploadcare-dialog-tab:hover:before{opacity:1}.uploadcare-dialog-tab_current{border-right:1px solid #efefef;background-color:#efefef}.uploadcare-dialog-tab_current:hover{background-color:#efefef}.uploadcare-dialog-tab_current .uploadcare-dialog-icon{opacity:1}.uploadcare-dialog-tab_current:before{opacity:1}.uploadcare-dialog-tab_hidden{display:none!important}.uploadcare-dialog-disabled-tab{cursor:default}.uploadcare-dialog-disabled-tab:hover{background-color:#dee0e1}.uploadcare-dialog-tab-preview .uploadcare-widget-circle{padding:10px}.uploadcare-dialog-tab-preview .uploadcare-widget-circle--canvas{color:#828689;border-color:#bfbfbf}.uploadcare-dialog-tab-preview.uploadcare-dialog-tab_current .uploadcare-widget-circle--canvas{color:#d0bf26;border-color:#e1e5e7}.uploadcare-dialog-tab-preview:before{display:none}.uploadcare-dialog-tab-file:before{background-position:0 -50px}.uploadcare-dialog-tab-url:before{background-position:0 -100px}.uploadcare-dialog-tab-facebook:before{background-position:0 -150px}.uploadcare-dialog-tab-dropbox:before{background-position:0 -200px}.uploadcare-dialog-tab-gdrive:before{background-position:0 -250px}.uploadcare-dialog-tab-instagram:before{background-position:0 -300px}.uploadcare-dialog-tab-vk:before{background-position:0 -350px}.uploadcare-dialog-tab-evernote:before{background-position:0 -400px}.uploadcare-dialog-tab-box:before{background-position:0 -450px}.uploadcare-dialog-tab-skydrive:before{background-position:0 -500px}.uploadcare-dialog-tab-flickr:before{background-position:0 -550px}.uploadcare-dialog-tab-camera:before{background-position:0 -600px}.uploadcare-dialog-tab-huddle:before{background-position:0 -650px}.uploadcare-dialog-tab-gphotos:before{background-position:0 -700px}.uploadcare-dialog-tabs-panel{position:relative;display:none;box-sizing:border-box;height:616px;line-height:22px;font-size:16px;color:#000}.uploadcare-dialog-multiple .uploadcare-dialog-tabs-panel{height:550px}.uploadcare-dialog-tabs-panel .uploadcare-dialog-input{box-sizing:border-box;width:100%;height:44px;margin-bottom:22px;padding:11px 12.5px;font-family:inherit;font-size:16px;border:1px solid #c5cace;background:#fff;color:#000}.uploadcare-dialog-tabs-panel_current{display:block}.uploadcare-pre{white-space:pre;font-family:monospace;margin:22px auto;padding:22px 25px;background-color:#fff;border:1px solid #c5cace;border-radius:3px;text-align:left;font-size:15px;line-height:22px}.uploadcare-dialog-footer{font-size:13px;line-height:1.4em;text-align:center;color:#fff;margin:15px}.uploadcare-dialog .uploadcare-dialog-footer svg{vertical-align:middle;padding:0 2px}.uploadcare-dialog .uploadcare-dialog-footer a{color:#fff;text-decoration:none}.uploadcare-dialog .uploadcare-dialog-footer a:hover{text-decoration:underline}.uploadcare-dialog-title{font-size:22px;line-height:1;margin-bottom:22px}.uploadcare-dialog-title.uploadcare-error{color:red}.uploadcare-dialog-title2{font-size:20px;line-height:1;padding-bottom:11px}.uploadcare-dialog-big-title{font-size:40px;font-weight:700;line-height:1em;margin-bottom:50px}.uploadcare-dialog-label{font-size:15px;line-height:25px;margin-bottom:12.5px;word-wrap:break-word}.uploadcare-dialog-large-text{font-size:20px;font-weight:400;line-height:1.5em}.uploadcare-dialog-large-text .uploadcare-pre{display:inline-block;font-size:18px}.uploadcare-dialog-section{margin-bottom:22px}.uploadcare-dialog-normal-text{font-size:13px;color:#545454}.uploadcare-dialog-button,.uploadcare-dialog-button-success{display:inline-block;font-size:13px;line-height:30px;padding:0 12.5px;margin-right:.5em;border:solid 1px;border-radius:3px;cursor:pointer}.uploadcare-dialog-button{color:#444}.uploadcare-dialog-button,.uploadcare-dialog-button.uploadcare-disabled-el:active,.uploadcare-dialog-button.uploadcare-disabled-el:hover,.uploadcare-dialog-button[disabled]:active,.uploadcare-dialog-button[disabled]:hover{background:#f3f3f3;background:-webkit-linear-gradient(#f5f5f5,#f1f1f1);background:linear-gradient(#f5f5f5,#f1f1f1);box-shadow:none;border-color:#dcdcdc}.uploadcare-dialog-button:hover{background:#f9f9f9;background:-webkit-linear-gradient(#fbfbfb,#f6f6f6);background:linear-gradient(#fbfbfb,#f6f6f6);box-shadow:inset 0 -1px 3px rgba(0,0,0,.05)}.uploadcare-dialog-button:active{background:#f3f3f3;background:-webkit-linear-gradient(#f5f5f5,#f1f1f1);background:linear-gradient(#f5f5f5,#f1f1f1);box-shadow:inset 0 2px 2px rgba(0,0,0,.05)}.uploadcare-dialog-button.uploadcare-disabled-el,.uploadcare-dialog-button[disabled]{cursor:default;opacity:.6}.uploadcare-dialog-button:active,.uploadcare-dialog-button:hover{border-color:#cbcbcb}.uploadcare-dialog-button-success{color:#fff}.uploadcare-dialog-button-success,.uploadcare-dialog-button-success.uploadcare-disabled-el:active,.uploadcare-dialog-button-success.uploadcare-disabled-el:hover,.uploadcare-dialog-button-success[disabled]:active,.uploadcare-dialog-button-success[disabled]:hover{background:#3886eb;background:-webkit-linear-gradient(#3b8df7,#347fdf);background:linear-gradient(#3b8df7,#347fdf);box-shadow:none;border-color:#266fcb}.uploadcare-dialog-button-success:hover{background:#337ad6;background:-webkit-linear-gradient(#3986ea,#2c6dc2);background:linear-gradient(#3986ea,#2c6dc2)}.uploadcare-dialog-button-success:active{background:#3178d3;background:-webkit-linear-gradient(#3680e1,#2c6fc5);background:linear-gradient(#3680e1,#2c6fc5)}.uploadcare-dialog-button-success.uploadcare-disabled-el,.uploadcare-dialog-button-success[disabled]{cursor:default;opacity:.6}.uploadcare-dialog-button-success:active,.uploadcare-dialog-button-success:hover{border-color:#266eca #1f62b7 #1753a1}.uploadcare-dialog-button-success:hover{box-shadow:inset 0 -1px 3px rgba(22,82,160,.5)}.uploadcare-dialog-button-success:active{box-shadow:inset 0 1px 3px rgba(22,82,160,.4)}.uploadcare-dialog-big-button{border-radius:100px;font-size:20px;font-weight:400;letter-spacing:1px;color:#fff;line-height:33px;border:solid 1px #276fcb;text-shadow:0 -1px #2a7ce5;display:inline-block;padding:16.5px 2em;cursor:pointer;box-shadow:inset 0 -2px #1f66c1;background:#458eee;background:-webkit-linear-gradient(#4892f6,#4289e6);background:linear-gradient(#4892f6,#4289e6)}.uploadcare-dialog-big-button:hover{box-shadow:inset 0 -2px #1652a0;background:#337ad7;background:-webkit-linear-gradient(#3986eb,#2c6dc2);background:linear-gradient(#3986eb,#2c6dc2)}.uploadcare-dialog-big-button:active{box-shadow:inset 0 2px #2561b9;background:#2c6ec3;background:-webkit-linear-gradient(#2c6ec3,#2c6ec3);background:linear-gradient(#2c6ec3,#2c6ec3)}.uploadcare-dialog-preview-image-wrap,.uploadcare-dialog-preview-video-wrap{white-space:nowrap;text-align:center;width:100%;height:462px}.uploadcare-dialog-preview-image-wrap:before,.uploadcare-dialog-preview-video-wrap:before{display:inline-block;vertical-align:middle;content:'';height:100%;position:static;width:0}.uploadcare-dialog-preview--with-sizes .uploadcare-dialog-preview-image-wrap,.uploadcare-dialog-preview--with-sizes .uploadcare-dialog-preview-video-wrap{position:relative;top:-40px;height:422px}.uploadcare-dialog-preview-image,.uploadcare-dialog-preview-video{display:inline-block;vertical-align:middle;white-space:normal;max-width:100%;max-height:100%}.uploadcare-dialog-tabs-panel-preview.uploadcare-dialog-tabs-panel_current~.uploadcare-panel-footer{display:none}.uploadcare-panel-footer{box-sizing:border-box;background:#fff3be;border-top:1px solid #efe2a9;height:66px;padding:17px 25px 0}.uploadcare-panel-footer .uploadcare-dialog-button-success{float:right}.uploadcare-panel-footer .uploadcare-dialog-button{float:left}.uploadcare-panel-footer .uploadcare-dialog-button,.uploadcare-panel-footer .uploadcare-dialog-button-success{min-width:100px;text-align:center;margin-right:0}.uploadcare-panel-footer .uploadcare-error{color:red}.uploadcare-panel-footer-text{text-align:center;color:#85732c;font-size:15px;line-height:32px}.uploadcare-dialog-message-center{text-align:center;padding-top:110px}.uploadcare-dialog-preview-center{text-align:center;padding-top:176px}.uploadcare-dialog-preview-circle{width:66px;height:66px;display:inline-block;margin-bottom:22px}.uploadcare-dialog-error-tab-wrap{height:100%;text-align:center;white-space:nowrap}.uploadcare-dialog-error-tab-wrap:before{display:inline-block;vertical-align:middle;content:'';height:100%;position:static;width:0}.uploadcare-dialog-error-tab-wrap .uploadcare-dialog-title{margin-bottom:12px}.uploadcare-dialog-error-tab-wrap .uploadcare-dialog-normal-text{margin-bottom:38px}.uploadcare-dialog-error-tab-wrap .uploadcare-dialog-button-success{margin:0}.uploadcare-dialog-error-tab-wrap2{display:inline-block;vertical-align:middle;white-space:normal;margin-top:-22px}.uploadcare-dialog-error-tab-illustration{display:inline-block;width:170px;height:120px;background-position:center;background-repeat:no-repeat;margin-bottom:38px}.uploadcare-draganddrop .uploadcare-if-no-draganddrop,.uploadcare-if-draganddrop{display:none}.uploadcare-draganddrop .uploadcare-if-draganddrop{display:block}.uploadcare-draganddrop .uploadcare-dialog-file-drop-area{border:dashed 3px #c5cacd;background:rgba(255,255,255,.64)}.uploadcare-draganddrop .uploadcare-dialog-file-title{color:#dee0e1;text-shadow:0 1px #fff;margin-top:0}.uploadcare-dialog-file-drop-area{width:100%;height:100%;box-sizing:border-box;border:none;text-align:center;border-radius:3px;padding-top:70px}.uploadcare-dialog-file-drop-area .uploadcare-dialog-big-button{margin-top:11px;margin-bottom:55px}.uploadcare-dialog-file-title{font-size:40px;line-height:1;color:#000;font-weight:700;margin:66px 0}.uploadcare-dialog-file-or{font-size:13px;color:#8f9498;margin-bottom:33px}.uploadcare-dialog-file-sources{position:relative;display:inline-block;padding:0 80px 0 100px;line-height:2em}.uploadcare-dialog-file-sources:before{background-repeat:no-repeat;content:'';display:block;position:absolute;width:67px;height:44px;padding:0;top:-30px;left:10px}.uploadcare-dialog-file-source{display:inline;font-size:15px;margin-right:.2em;cursor:pointer;font-weight:300;white-space:nowrap}.uploadcare-dialog-file-source:after{content:'\\00B7';color:#b7babc;margin-left:.5em}.uploadcare-dialog-file-source:last-child:after{display:none}.uploadcare-dragging .uploadcare-dialog-file-drop-area .uploadcare-dialog-big-button,.uploadcare-dragging .uploadcare-dialog-file-or,.uploadcare-dragging .uploadcare-dialog-file-sources{display:none}.uploadcare-dragging .uploadcare-dialog-file-drop-area{background-color:#f0f0f0;border-color:#b3b5b6;padding-top:264px}.uploadcare-dragging .uploadcare-dialog-file-title{color:#707478}.uploadcare-dragging.uploadcare-dialog-file-drop-area{background-color:#f2f7fe;border-color:#438ae7}.uploadcare-dragging.uploadcare-dialog-file-drop-area .uploadcare-dialog-file-title{color:#438ae7}.uploadcare-dialog-camera-holder{white-space:nowrap;text-align:center;height:528px}.uploadcare-dialog-camera-holder:before{display:inline-block;vertical-align:middle;content:'';height:100%;position:static;width:0}.uploadcare-dialog-camera-holder .uploadcare-dialog-normal-text{margin-bottom:38px}.uploadcare-dialog-multiple .uploadcare-dialog-camera-holder{height:462px}.uploadcare-dialog-camera-video{vertical-align:middle;white-space:normal;display:none;max-width:100%;max-height:528px;-webkit-transition:-webkit-transform .8s cubic-bezier(.23,1,.32,1);transition:transform .8s cubic-bezier(.23,1,.32,1);transition:transform .8s cubic-bezier(.23,1,.32,1),-webkit-transform .8s cubic-bezier(.23,1,.32,1)}.uploadcare-dialog-multiple .uploadcare-dialog-camera-video{max-height:462px}.uploadcare-dialog-camera--mirrored{-webkit-transform:scale(-1,1);-ms-transform:scale(-1,1);transform:scale(-1,1)}.uploadcare-dialog-camera-message{vertical-align:middle;white-space:normal;display:none;max-width:450px}.uploadcare-dialog-camera-controls{margin-top:17px;text-align:center}.uploadcare-dialog-camera-mirror{position:absolute;margin-right:0;right:25px}.uploadcare-dialog-camera-cancel-record,.uploadcare-dialog-camera-capture,.uploadcare-dialog-camera-mirror,.uploadcare-dialog-camera-not-found,.uploadcare-dialog-camera-retry,.uploadcare-dialog-camera-start-record,.uploadcare-dialog-camera-stop-record{display:none}.uploadcare-dialog-camera-requested .uploadcare-dialog-camera-message{display:inline-block}.uploadcare-dialog-camera-not-founded .uploadcare-dialog-camera-please-allow{display:none}.uploadcare-dialog-camera-not-founded .uploadcare-dialog-camera-not-found{display:block}.uploadcare-dialog-camera-denied .uploadcare-dialog-camera-message,.uploadcare-dialog-camera-denied .uploadcare-dialog-camera-retry,.uploadcare-dialog-camera-ready .uploadcare-dialog-camera-capture,.uploadcare-dialog-camera-ready .uploadcare-dialog-camera-mirror,.uploadcare-dialog-camera-ready .uploadcare-dialog-camera-start-record,.uploadcare-dialog-camera-ready .uploadcare-dialog-camera-video,.uploadcare-dialog-camera-recording .uploadcare-dialog-camera-cancel-record,.uploadcare-dialog-camera-recording .uploadcare-dialog-camera-stop-record,.uploadcare-dialog-camera-recording .uploadcare-dialog-camera-video{display:inline-block}.uploadcare-file-list{height:550px;overflow:auto;position:relative;margin:0 -25px -22px 0}.uploadcare-dialog-multiple .uploadcare-file-list{height:484px}.uploadcare-file-list_table .uploadcare-file-item{border-top:1px solid #e3e3e3;border-bottom:1px solid #e3e3e3;margin-bottom:-1px;display:table;table-layout:fixed;width:100%;padding:10px 0;min-height:20px}.uploadcare-file-list_table .uploadcare-file-item>*{box-sizing:content-box;display:table-cell;vertical-align:middle;padding-right:20px}.uploadcare-file-list_table .uploadcare-file-item:last-child{margin-bottom:0}.uploadcare-file-list_table .uploadcare-file-item:hover{background:#ececec}.uploadcare-file-list_table .uploadcare-file-item__preview{width:55px;padding-right:10px}.uploadcare-file-list_table .uploadcare-file-item__preview>img{height:55px}.uploadcare-file-list_table .uploadcare-file-item__size{width:3.5em}.uploadcare-file-list_table .uploadcare-file-item__progressbar{width:80px}.uploadcare-file-list_table .uploadcare-zoomable-icon:after{width:55px}.uploadcare-file-list_tiles .uploadcare-file-item{text-align:left;position:relative;display:inline-block;vertical-align:top;width:170px;min-height:170px;padding:0 20px 10px 0}.uploadcare-file-list_tiles .uploadcare-file-item>*{padding-bottom:10px}.uploadcare-file-list_tiles .uploadcare-file-item__name{padding-top:10px}.uploadcare-file-list_tiles .uploadcare-file-item__remove{position:absolute;top:0;right:10px}.uploadcare-file-list_tiles .uploadcare-file-item__preview{white-space:nowrap;width:170px;height:170px;padding-bottom:0}.uploadcare-file-list_tiles .uploadcare-file-item__preview:before{display:inline-block;vertical-align:middle;content:'';height:100%;position:static;width:0}.uploadcare-file-list_tiles .uploadcare-file-item__preview img{display:inline-block;vertical-align:middle;white-space:normal}.uploadcare-file-list_tiles .uploadcare-file-item_error .uploadcare-file-item__preview,.uploadcare-file-list_tiles .uploadcare-file-item_uploaded .uploadcare-file-item__name,.uploadcare-file-list_tiles .uploadcare-file-item_uploaded .uploadcare-file-item__size,.uploadcare-file-list_tiles .uploadcare-file-item_uploading .uploadcare-file-item__preview{display:none}.uploadcare-file-icon,.uploadcare-file-item__error:before{content:'';display:inline-block;width:20px;height:20px;margin:-3.5px .7em -3.5px 0}.uploadcare-file-item{font-size:13px;line-height:1.2}.uploadcare-file-item:hover .uploadcare-file-item__remove{visibility:visible}.uploadcare-file-item:hover .uploadcare-zoomable-icon:after{display:block}.uploadcare-file-item_error .uploadcare-file-item__progressbar,.uploadcare-file-item_error .uploadcare-file-item__size,.uploadcare-file-item_uploaded .uploadcare-file-item__error,.uploadcare-file-item_uploaded .uploadcare-file-item__progressbar,.uploadcare-file-item_uploading .uploadcare-file-item__error{display:none}.uploadcare-file-item__preview{text-align:center;line-height:0}.uploadcare-file-item__preview>img{display:inline-block;width:auto;height:auto;max-width:100%;max-height:100%}.uploadcare-file-item__name{width:100%;word-wrap:break-word}.uploadcare-file-item__error{width:200px;color:#f5444b}.uploadcare-file-item__remove{visibility:hidden;width:20px;text-align:right;line-height:0}.uploadcare-remove{width:20px;height:20px;cursor:pointer}.uploadcare-zoomable-icon{position:relative;cursor:pointer}.uploadcare-zoomable-icon:after{content:'';position:absolute;top:0;left:0;display:none;width:100%;height:100%;background-size:45px 45px;background-repeat:no-repeat;background-position:center}.uploadcare-progressbar{width:100%;height:8px;background:#e0e0e0;border-radius:100px}.uploadcare-progressbar__value{height:100%;background:#d6b849;border-radius:100px}.uploadcare-file-icon{margin:0}.uploadcare-dialog-padding{padding:22px 25px}.uploadcare-dialog-remote-iframe-wrap{overflow:auto;-webkit-overflow-scrolling:touch}.uploadcare-dialog-remote-iframe{display:block;width:100%;height:100%;border:0;opacity:0}.uploadcare-hidden,.uploadcare-if-mobile,.uploadcare-panel-footer-counter,.uploadcare-panel-footer__summary{display:none}.uploadcare-dialog-multiple .uploadcare-panel-footer__summary{display:block}@media screen and (max-width:760px){.uploadcare-dialog-opened{overflow:visible!important;position:static!important;width:auto!important;height:auto!important;min-width:0!important;background:#efefef!important}body.uploadcare-dialog-opened>.uploadcare-inactive,body.uploadcare-dialog-opened>:not(.uploadcare-dialog){display:none!important}.uploadcare-if-mobile{display:block}.uploadcare-if-no-mobile{display:none}.uploadcare-dialog{position:absolute;overflow:visible;-webkit-text-size-adjust:100%}.uploadcare-dialog:before{display:none}.uploadcare-dialog-inner-wrap{padding:0;min-width:310px;height:100%}.uploadcare-dialog-close{position:fixed;z-index:2;color:#000;width:50px;height:50px;line-height:45px}.uploadcare-dialog-footer{display:none}.uploadcare-responsive-panel .uploadcare-dialog-panel{overflow:visible;height:100%;padding:50px 0 0;border-radius:0;box-shadow:none}.uploadcare-responsive-panel .uploadcare-dialog-panel.uploadcare-panel-hide-tabs{padding-top:0}.uploadcare-responsive-panel .uploadcare-dialog-tabs-panel{height:auto}.uploadcare-responsive-panel .uploadcare-dialog-remote-iframe-wrap{overflow:visible;height:100%}.uploadcare-responsive-panel .uploadcare-dialog-padding{padding:22px 15px}.uploadcare-responsive-panel .uploadcare-dialog-preview-image-wrap,.uploadcare-responsive-panel .uploadcare-dialog-preview-video-wrap{top:auto;height:auto;padding-bottom:50px}.uploadcare-responsive-panel .uploadcare-dialog-preview-image,.uploadcare-responsive-panel .uploadcare-dialog-preview-video{max-height:450px}.uploadcare-responsive-panel .uploadcare-file-list{height:auto;margin:0 -15px 0 0}.uploadcare-responsive-panel .uploadcare-file-list_table .uploadcare-file-item>*{padding-right:10px}.uploadcare-responsive-panel .uploadcare-file-list_table .uploadcare-file-item__progressbar{width:40px}.uploadcare-responsive-panel .uploadcare-file-list_tiles .uploadcare-file-item{width:140px;min-height:140px;padding-right:10px}.uploadcare-responsive-panel .uploadcare-file-list_tiles .uploadcare-file-item__preview{width:140px;height:140px}.uploadcare-responsive-panel .uploadcare-file-list_tiles .uploadcare-file-item__remove{right:10px}.uploadcare-responsive-panel .uploadcare-file-item__remove{visibility:visible}.uploadcare-responsive-panel .uploadcare-dialog-file-or,.uploadcare-responsive-panel .uploadcare-dialog-file-sources,.uploadcare-responsive-panel .uploadcare-dialog-file-title{display:none}.uploadcare-responsive-panel .uploadcare-dialog-file-drop-area{padding-top:0;border:0;background:0 0}.uploadcare-responsive-panel .uploadcare-dialog-big-button{margin:110px 0 0}.uploadcare-responsive-panel .uploadcare-clouds-tip{color:#909498;font-size:.75em;line-height:1.4;text-align:left;padding:10px 0 0 50px}.uploadcare-responsive-panel .uploadcare-clouds-tip:before{background-image:url(\"",settings.scriptBase,"/images/arrow.png\");background-repeat:no-repeat;background-size:51px 33px;content:'';position:absolute;margin:-20px -36px;display:block;width:28px;height:30px}.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-dialog-tab.uploadcare-dialog-tab-camera{display:none}.uploadcare-responsive-panel .uploadcare-dialog-camera-holder{height:auto}.uploadcare-responsive-panel .uploadcare-dialog-camera-mirror{right:15px}.uploadcare-responsive-panel .uploadcare-panel-footer{position:fixed;left:0;bottom:0;width:100%;min-width:310px;height:50px;padding:9px 15px 0;background:rgba(255,243,190,.95)}.uploadcare-responsive-panel .uploadcare-panel-footer-text{display:none}.uploadcare-responsive-panel .uploadcare-panel-footer-counter{display:inline}.uploadcare-responsive-panel .uploadcare-dialog-multiple.uploadcare-dialog-panel{padding-bottom:50px}.uploadcare-responsive-panel .uploadcare-dialog-multiple .uploadcare-dialog-remote-iframe-wrap:after{content:'';display:block;height:50px}.uploadcare-responsive-panel .uploadcare-dialog-multiple .uploadcare-dialog-padding{padding-bottom:72px}.uploadcare-responsive-panel .uploadcare-dialog-tabs{position:fixed;top:0;left:0;width:100%;min-width:310px;height:auto;float:none;margin:0;z-index:1;background:0 0}.uploadcare-responsive-panel .uploadcare-dialog-tab{display:none;height:50px;white-space:nowrap;background:#dee0e1}.uploadcare-responsive-panel .uploadcare-dialog-tab .uploadcare-dialog-icon,.uploadcare-responsive-panel .uploadcare-dialog-tab:before{position:static;margin:0 6px;vertical-align:middle;opacity:1}.uploadcare-responsive-panel .uploadcare-dialog-tab_current{display:block;background:rgba(239,239,239,.95)}.uploadcare-responsive-panel .uploadcare-dialog-tab:after{content:attr(title);font-size:20px;vertical-align:middle}.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-dialog-tabs-panel_current,.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-panel-footer{display:none}.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-dialog-tabs{position:absolute;z-index:3}.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-dialog-tab{display:block}.uploadcare-responsive-panel .uploadcare-dialog-opened-tabs .uploadcare-dialog-tab_current{background:#efefef}.uploadcare-responsive-panel .uploadcare-dialog-panel:not(.uploadcare-dialog-opened-tabs) .uploadcare-dialog-tab_current{text-align:center}.uploadcare-responsive-panel .uploadcare-dialog-panel:not(.uploadcare-dialog-opened-tabs) .uploadcare-dialog-tab_current:after{content:'';position:absolute;top:16px;left:14px;display:block;width:22px;height:18px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAOCAQAAAD+6Ta3AAAARklEQVR4Ae3SsRFEIQhAwW1IR2s3s6zTGUN+AxdK5tucAIBmOuKSY2pQbHHZVhgiweAnEixW1uC0VdSU41Xo19+te73+9AGOg1FzTMH13gAAAABJRU5ErkJggg==);background-size:22px}.uploadcare-responsive-panel .uploadcare-crop-sizes{top:auto;margin-bottom:15px}.uploadcare-responsive-panel .uploadcare-crop-size{margin:0 10px}}.uploadcare-crop-widget.jcrop-holder{direction:ltr;text-align:left;z-index:0}.uploadcare-crop-widget .jcrop-hline,.uploadcare-crop-widget .jcrop-vline{z-index:320}.uploadcare-crop-widget .jcrop-handle,.uploadcare-crop-widget .jcrop-hline,.uploadcare-crop-widget .jcrop-vline{position:absolute;font-size:0;background-color:#fff;box-shadow:0 0 0 1px rgba(0,0,0,.2)}.uploadcare-crop-widget .jcrop-vline{height:100%;width:1px!important}.uploadcare-crop-widget .jcrop-hline{height:1px!important;width:100%}.uploadcare-crop-widget .jcrop-vline.right{right:0}.uploadcare-crop-widget .jcrop-hline.bottom{bottom:0}.uploadcare-crop-widget .jcrop-tracker{height:100%;width:100%;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.uploadcare-crop-widget .jcrop-handle{border-radius:50%;width:13px;height:13px;z-index:330}.uploadcare-crop-widget .jcrop-handle:after,.uploadcare-crop-widget .jcrop-handle:before{content:\"\";position:absolute;display:block;width:1px;height:1px;background:#fff}.uploadcare-crop-widget .jcrop-handle:before{width:3px;top:6px}.uploadcare-crop-widget .jcrop-handle:after{height:3px;left:6px}.uploadcare-crop-widget .jcrop-handle.ord-nw:before,.uploadcare-crop-widget .jcrop-handle.ord-sw:before{left:12px}.uploadcare-crop-widget .jcrop-handle.ord-ne:before,.uploadcare-crop-widget .jcrop-handle.ord-se:before{left:-2px}.uploadcare-crop-widget .jcrop-handle.ord-ne:after,.uploadcare-crop-widget .jcrop-handle.ord-nw:after{top:12px}.uploadcare-crop-widget .jcrop-handle.ord-se:after,.uploadcare-crop-widget .jcrop-handle.ord-sw:after{top:-2px}.uploadcare-crop-widget .jcrop-handle.ord-nw{left:0;margin-left:-6px;margin-top:-6px;top:0}.uploadcare-crop-widget .jcrop-handle.ord-ne{margin-right:-6px;margin-top:-6px;right:0;top:0}.uploadcare-crop-widget .jcrop-handle.ord-se{bottom:0;margin-bottom:-6px;margin-right:-6px;right:0}.uploadcare-crop-widget .jcrop-handle.ord-sw{bottom:0;left:0;margin-bottom:-6px;margin-left:-6px}.uploadcare-crop-widget img.jcrop-preview,.uploadcare-crop-widget.jcrop-holder img{max-width:none}.uploadcare-crop-widget{display:inline-block;vertical-align:middle;white-space:normal}.uploadcare-crop-widget .jcrop-handle>div{width:35px;height:35px;margin:-11px;background-color:transparent}.uploadcare-crop-widget>div:first-child{-webkit-transform:translateZ(0);transform:translateZ(0)}.uploadcare-crop-widget>img{-webkit-filter:grayscale(50%);filter:grayscale(50%)}.uploadcare-crop-sizes{display:none;visibility:hidden;position:relative;top:433px;text-align:center}.uploadcare-dialog-preview--with-sizes .uploadcare-crop-sizes{display:block}.uploadcare-dialog-preview--loaded .uploadcare-crop-sizes{visibility:visible}.uploadcare-crop-size{position:relative;display:inline-block;width:40px;height:40px;line-height:40px;margin:0 20px;font-size:.55em;cursor:pointer;color:#444}.uploadcare-crop-size div{box-sizing:border-box;width:40px;height:30px;display:inline-block;vertical-align:middle;border:1px solid #ccc}.uploadcare-crop-size:after{content:attr(data-caption);position:absolute;top:1px;left:0;width:100%;text-align:center;margin:0}.uploadcare-crop-size--current div{background:#fff}.uploadcare-widget{position:relative;display:inline-block;vertical-align:baseline;line-height:2}.uploadcare-widget :focus{outline:2px dotted #0094c0}.uploadcare-widget .uploadcare-mouse-focused:focus,.uploadcare-widget :active{outline:none}.uploadcare-widget-status-error .uploadcare-widget-button-open,.uploadcare-widget-status-error .uploadcare-widget-text,.uploadcare-widget-status-loaded .uploadcare-widget-text,.uploadcare-widget-status-ready .uploadcare-widget-button-open,.uploadcare-widget-status-started .uploadcare-widget-button-cancel,.uploadcare-widget-status-started .uploadcare-widget-status,.uploadcare-widget-status-started .uploadcare-widget-text{display:inline-block!important}.uploadcare-widget-option-clearable.uploadcare-widget-status-error .uploadcare-widget-button-open{display:none!important}.uploadcare-widget-option-clearable.uploadcare-widget-status-error .uploadcare-widget-button-remove,.uploadcare-widget-option-clearable.uploadcare-widget-status-loaded .uploadcare-widget-button-remove{display:inline-block!important}.uploadcare-widget-status{display:none!important;width:1.8em;height:1.8em;margin:-1em 1ex -1em 0;line-height:0;vertical-align:middle}.uploadcare-widget-circle--text .uploadcare-widget-circle-back{width:100%;height:100%;display:table;white-space:normal}.uploadcare-widget-circle--text .uploadcare-widget-circle-text{display:table-cell;vertical-align:middle;text-align:center;font-size:60%;line-height:1}.uploadcare-widget-circle--canvas{color:#d0bf26;border-color:#e1e5e7}.uploadcare-widget-circle--canvas canvas{width:100%;height:100%}.uploadcare-widget-text{display:none!important;margin-right:1ex;white-space:nowrap}.uploadcare-widget-file-name,.uploadcare-widget-file-size{display:inline}.uploadcare-link,.uploadcare-link:link,.uploadcare-link:visited{cursor:pointer;color:#1a85ad;text-decoration:none;border-bottom:1px dotted #1a85ad;border-color:initial}.uploadcare-link:hover{color:#176e8f}.uploadcare-widget-button{display:none!important;color:#fff;padding:.4em .6em;line-height:1;margin:-1em .5ex -1em 0;border-radius:.25em;background:#c3c3c3;cursor:default;white-space:nowrap}.uploadcare-widget-button:hover{background:#b3b3b3}.uploadcare-widget-button-open{padding:.5em .8em;background:#18a5d0}.uploadcare-widget-button-open:hover{background:#0094c0}.uploadcare-widget-dragndrop-area{box-sizing:content-box;display:none;position:absolute;white-space:nowrap;top:50%;margin-top:-1.3em;left:-1em;padding:0 1em;line-height:2.6;min-width:100%;text-align:center;background-color:#f0f0f0;color:#707478;border:1px dashed #b3b5b6;border-radius:100px}.uploadcare-widget.uploadcare-dragging .uploadcare-widget-dragndrop-area{background-color:#f2f7fe;border-color:#438ae7;color:#438ae7}.uploadcare-dragging .uploadcare-widget-dragndrop-area{display:block}.uploadcare-dialog-opened .uploadcare-widget-dragndrop-area{display:none}\r\n");
	return __p.join("")},r.templates.JST["tab-camera"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-camera-holder"><!--\r\n  --><video class="uploadcare-dialog-camera-video uploadcare-dialog-camera--mirrored"></video><!--\r\n  --><div class="uploadcare-dialog-camera-message">\r\n    <div class="uploadcare-dialog-error-tab-illustration"></div>\r\n\r\n    <div class="uploadcare-dialog-title uploadcare-dialog-camera-please-allow">\r\n      ',(""+t("dialog.tabs.camera.pleaseAllow.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n    </div>\r\n    <div class="uploadcare-dialog-normal-text uploadcare-dialog-camera-please-allow">\r\n      ',(""+t("dialog.tabs.camera.pleaseAllow.text")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n    </div>\r\n\r\n    <div class="uploadcare-dialog-title uploadcare-dialog-camera-not-found">\r\n      ',(""+t("dialog.tabs.camera.notFound.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n    </div>\r\n    <div class="uploadcare-dialog-normal-text uploadcare-dialog-camera-not-found">\r\n      ',(""+t("dialog.tabs.camera.notFound.text")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n    </div>\r\n\r\n    <div class="uploadcare-dialog-camera-retry uploadcare-dialog-button"\r\n         tabindex="0" role="button">\r\n      ',(""+t("dialog.tabs.camera.retry")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n    </div>\r\n  </div><!--\r\n--></div>\r\n<div class="uploadcare-dialog-camera-controls">\r\n  <div class="uploadcare-dialog-camera-mirror uploadcare-dialog-button"\r\n       tabindex="0" role="button">\r\n    ',(""+t("dialog.tabs.camera.mirror")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-camera-capture uploadcare-dialog-button-success"\r\n       tabindex="0" role="button">\r\n    ',(""+t("dialog.tabs.camera.capture")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-camera-start-record uploadcare-dialog-button-success"\r\n       tabindex="0" role="button">\r\n    ',(""+t("dialog.tabs.camera.startRecord")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-camera-cancel-record uploadcare-dialog-button"\r\n       tabindex="0" role="button">\r\n    ',(""+t("dialog.tabs.camera.cancelRecord")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-camera-stop-record uploadcare-dialog-button-success"\r\n       tabindex="0" role="button">\r\n    ',(""+t("dialog.tabs.camera.stopRecord")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"\r\n  </div>\r\n</div>\r\n");return __p.join("")},r.templates.JST["tab-file"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-file-drop-area">\r\n  <div class="uploadcare-dialog-file-title uploadcare-if-draganddrop">\r\n    ',(""+t("dialog.tabs.file.drag")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-file-title uploadcare-if-no-draganddrop">\r\n    ',(""+t("dialog.tabs.file.nodrop")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-file-or uploadcare-if-draganddrop">\r\n    ',(""+t("dialog.tabs.file.or")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-clouds-tip uploadcare-if-mobile">\r\n    ',t("dialog.tabs.file.cloudsTip"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-big-button needsclick">\r\n    ',(""+t("dialog.tabs.file.button")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-file-or uploadcare-dialog-file-source-or">\r\n    ',(""+t("dialog.tabs.file.also")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-dialog-file-sources">\r\n  </div>\r\n</div>\r\n');return __p.join("")},r.templates.JST["tab-preview-error"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-error-tab-wrap uloadcare-dialog-error-tab-',(""+error).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'"><!--\r\n  --><div class="uploadcare-dialog-error-tab-wrap2">\r\n\r\n    <div class="uploadcare-dialog-error-tab-illustration"></div>\r\n\r\n    <div class="uploadcare-dialog-title">',(""+t("dialog.tabs.preview.error."+error+".title")||t("dialog.tabs.preview.error.default.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n\r\n    <div class="uploadcare-dialog-normal-text">',(""+t("dialog.tabs.preview.error."+error+".text")||t("dialog.tabs.preview.error.default.text")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n\r\n    <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-back"\r\n         tabindex="0" role="button"\r\n            >',(""+t("dialog.tabs.preview.error."+error+".back")||t("dialog.tabs.preview.error.default.back")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n  </div>\r\n</div>\r\n");return __p.join("")},r.templates.JST["tab-preview-image"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-padding uploadcare-dialog-preview-root">\r\n  <div class="uploadcare-dialog-title uploadcare-dialog-preview-title">\r\n    ',(""+t("dialog.tabs.preview.image.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n\r\n  <div class="uploadcare-crop-sizes uploadcare-dialog-preview-crop-sizes">\r\n    <div class="uploadcare-crop-size" data-caption="free"><div></div></div>\r\n  </div>\r\n\r\n  <div class="uploadcare-dialog-preview-image-wrap"><!--\r\n    --><img\r\n        src="',(""+src).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'"\r\n        title="',(""+(name||"")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'"\r\n        alt="',(""+(name||"")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'"\r\n      class="uploadcare-dialog-preview-image"\r\n    />\r\n  </div>\r\n</div>\r\n\r\n<div class="uploadcare-panel-footer">\r\n  <div class="uploadcare-dialog-button uploadcare-dialog-preview-back"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.image.change")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n  <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-done"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n</div>\r\n");
	return __p.join("")},r.templates.JST["tab-preview-multiple-file"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-file-item uploadcare-file-item_uploading">\r\n  <div class="uploadcare-file-item__preview">\r\n    <div class="uploadcare-file-icon"></div>\r\n  </div>\r\n  <div class="uploadcare-file-item__name">\r\n    ',(""+t("dialog.tabs.preview.unknownName")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n  <div class="uploadcare-file-item__progressbar">\r\n    <div class="uploadcare-progressbar">\r\n      <div class="uploadcare-progressbar__value"></div>\r\n    </div>\r\n  </div>\r\n  <div class="uploadcare-file-item__size"></div>\r\n  <div class="uploadcare-file-item__error"></div>\r\n  <div class="uploadcare-file-item__remove">\r\n    <div class="uploadcare-remove"></div>\r\n  </div>\r\n</div>\r\n');return __p.join("")},r.templates.JST["tab-preview-multiple"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-padding">\r\n  <div class="uploadcare-dialog-title uploadcare-if-no-mobile uploadcare-dpm-title"></div>\r\n  <div class="uploadcare-dialog-title uploadcare-if-mobile uploadcare-dpm-mobile-title"></div>\r\n\r\n  <div class="uploadcare-file-list"></div>\r\n</div>\r\n\r\n<div class="uploadcare-panel-footer">\r\n  <div class="uploadcare-dialog-button uploadcare-dialog-preview-back"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.multiple.clear")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n  <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-done"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.multiple.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n  <div class="uploadcare-panel-footer-text uploadcare-dpm-footer-text"></div>\r\n</div>\r\n');return __p.join("")},r.templates.JST["tab-preview-regular"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-padding">\r\n  <div class="uploadcare-dialog-title">',(""+t("dialog.tabs.preview.regular.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n\r\n  <div class="uploadcare-dialog-label">\r\n    ',(""+(file.name||t("dialog.tabs.preview.unknownName"))).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"",(""+utils.readableFileSize(file.size,"",", ")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n\r\n  <div class="uploadcare-dialog-section uploadcare-dialog-normal-text">\r\n    ',(""+t("dialog.tabs.preview.regular.line1")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"<br/>\r\n    ",(""+t("dialog.tabs.preview.regular.line2")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n\r\n  <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-done"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n  <div class="uploadcare-dialog-button uploadcare-dialog-preview-back"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.change")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n</div>\r\n");return __p.join("")},r.templates.JST["tab-preview-unknown"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-padding">\r\n\r\n  <div class="uploadcare-dialog-title">',(""+t("dialog.tabs.preview.unknown.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n\r\n  <div class="uploadcare-dialog-label uploadcare-dialog-preview-label"></div>\r\n\r\n  <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-done"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.unknown.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n</div>\r\n");return __p.join("")},r.templates.JST["tab-preview-video"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-padding uploadcare-dialog-preview-root">\r\n  <div class="uploadcare-dialog-title uploadcare-dialog-preview-title">\r\n    ',(""+t("dialog.tabs.preview.video.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div>\r\n\r\n  <div class="uploadcare-crop-sizes uploadcare-dialog-preview-crop-sizes">\r\n    <div class="uploadcare-crop-size" data-caption="free"><div></div></div>\r\n  </div>\r\n\r\n  <div class="uploadcare-dialog-preview-video-wrap">\r\n    <video controls class="uploadcare-dialog-preview-video"></video>\r\n  </div>\r\n</div>\r\n\r\n<div class="uploadcare-panel-footer">\r\n  <div class="uploadcare-dialog-button uploadcare-dialog-preview-back"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.video.change")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n  <div class="uploadcare-dialog-button-success uploadcare-dialog-preview-done"\r\n       tabindex="0" role="button"\r\n          >',(""+t("dialog.tabs.preview.done")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n</div>\r\n");return __p.join("")},r.templates.JST["tab-url"]=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-dialog-title">',(""+t("dialog.tabs.url.title")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n<div class="uploadcare-dialog-section uploadcare-dialog-normal-text">\r\n  <div>',(""+t("dialog.tabs.url.line1")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n  <div>",(""+t("dialog.tabs.url.line2")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div>\r\n</div>\r\n<form class="uploadcare-dialog-url-form">\r\n  <input type="text" class="uploadcare-dialog-input" placeholder="',(""+t("dialog.tabs.url.input")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'">\r\n  <button class="uploadcare-dialog-button uploadcare-dialog-url-submit" type="submit">',(""+t("dialog.tabs.url.button")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</button>\r\n</form>\r\n");return __p.join("")},r.templates.JST["widget-button"]=function(e){var __p=[],t=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div tabindex="0" role="button"\r\n     class="uploadcare-widget-button uploadcare-widget-button-',name,'"\r\n>',(""+caption).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"</div>\r\n");
	return __p.join("")},r.templates.JST["widget-file-name"]=function(e){var __p=[],t=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-widget-file-name uploadcare-link"\r\n     tabindex="0" role="link">',(""+utils.fitText(name,20)).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'</div><!--\r\n--><div class="uploadcare-widget-file-size">,\r\n    ',(""+utils.readableFileSize(size)).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),"\r\n</div>\r\n");return __p.join("")},r.templates.JST.widget=function(e){var __p=[],i=function(){__p.push.apply(__p,arguments)};with(e||{})__p.push('<div class="uploadcare-widget">\r\n  <div class="uploadcare-widget-dragndrop-area">\r\n    ',(""+t("draghere")).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#x27;").replace(/\//g,"&#x2F;"),'\r\n  </div><div class="uploadcare-widget-status">\r\n  </div><div class="uploadcare-widget-text">\r\n</div></div>\r\n');return __p.join("")},function(){var e,t;e=r.jQuery,t=r.templates.tpl,r.settings.waitForSettings.add(function(i){var a,r;return a=t("styles",{settings:i}),r=n.createElement("style"),r.setAttribute("type","text/css"),null!=r.styleSheet?r.styleSheet.cssText=a:r.appendChild(n.createTextNode(a)),e("head").prepend(r)})}.call(this),function(t){t.Jcrop=function(e,i){var a=t.extend({},t.Jcrop.defaults),r,o;function l(e){return Math.round(e)+"px"}function s(e){return a.baseClass+"-"+e}function c(){return t.fx.step.hasOwnProperty("backgroundColor")}function u(e){var i=t(e).offset();return[i.left,i.top]}function p(e){return[e.pageX-r[0],e.pageY-r[1]]}function d(e){"object"!=typeof e&&(e={}),a=t.extend(a,e),t.each(["onChange","onSelect","onRelease","onDblClick"],function(e,t){"function"!=typeof a[t]&&(a[t]=function(){})})}function g(e,t){if(r=u(T),"move"===e)return Z.activateHandlers(f(t),y);var i=H.getFixed(),a=m(e),n=H.getCorner(m(a));H.setPressed(H.getCorner(a)),H.setCurrent(n),Z.activateHandlers(h(e,i),y)}function h(e,t){return function(i){if(a.aspectRatio)switch(e){case"e":i[1]=t.y+1;break;case"w":i[1]=t.y+1;break;case"n":i[0]=t.x+1;break;case"s":i[0]=t.x+1}else switch(e){case"e":i[1]=t.y2;break;case"w":i[1]=t.y2;break;case"n":i[0]=t.x2;break;case"s":i[0]=t.x2}H.setCurrent(i),X.update()}}function f(e){var t=e;return $.watchKeys(),function(e){H.moveOffset([e[0]-t[0],e[1]-t[1]]),t=e,X.update()}}function m(e){switch(e){case"n":return"sw";case"s":return"nw";case"e":return"nw";case"w":return"ne";case"ne":return"sw";case"nw":return"se";case"se":return"nw";case"sw":return"ne"}}function _(e){return function(t){return a.disabled?!1:"move"!==e||a.allowMove?(r=u(T),K=!0,g(e,p(t)),t.stopPropagation(),t.preventDefault(),!1):!1}}function b(e,t,i){var a=e.width(),r=e.height();a>t&&t>0&&(a=t,r=t/e.width()*e.height()),r>i&&i>0&&(r=i,a=i/e.height()*e.width()),N=e.width()/a,V=e.height()/r,e.width(a).height(r)}function v(e){return{x:e.x*N,y:e.y*V,x2:e.x2*N,y2:e.y2*V,w:e.w*N,h:e.h*V}}function y(e){var t=H.getFixed();X.enableHandles(),X.done()}function w(e){H.setCurrent(e),X.update()}function x(){var e=t("<div></div>").addClass(s("tracker"));return e.css({opacity:0,backgroundColor:"white"}),e}"object"!=typeof e&&(e=t(e)[0]),"object"!=typeof i&&(i={}),d(i);var k={border:"none",visibility:"visible",margin:0,padding:0,position:"absolute",top:0,left:0},A=t(e),C=!0;if("IMG"==e.tagName){if(0!=A[0].width&&0!=A[0].height)A.width(A[0].width),A.height(A[0].height);else{var S=new Image;S.src=A[0].src,A.width(S.width),A.height(S.height)}var T=A.clone().removeAttr("id").css(k).show();T.width(A.width()),T.height(A.height()),A.after(T).hide()}else T=A.css(k).show(),C=!1,null===a.shade&&(a.shade=!0);b(T,a.boxWidth,a.boxHeight);var z=T.width(),j=T.height(),F=t("<div />").width(z).height(j).addClass(s("holder")).css({position:"relative",backgroundColor:a.bgColor}).insertAfter(A).append(T);a.addClass&&F.addClass(a.addClass);var D=t("<div />"),I=t("<div />").width("100%").height("100%").css({zIndex:310,position:"absolute",overflow:"hidden"}),P=t("<div />").css({position:"absolute",zIndex:600}).dblclick(function(){var e=H.getFixed();a.onDblClick.call(de,e)}).insertBefore(T).append(I);C&&(D=t("<img />").attr("src",T.attr("src")).css(k).width(z).height(j),I.append(D));var U=a.boundary,E=x().width(z+2*U).height(j+2*U).css({position:"absolute",top:l(-U),left:l(-U),zIndex:290}),O=a.bgColor,R=a.bgOpacity,M,B,L,q,N,V,W=!0,K,G,Q;r=u(T);var J=function(){function e(){var e={},t=["touchstart","touchmove","touchend"],i=n.createElement("div"),a;try{for(a=0;a<t.length;a++){var r=t[a];r="on"+r;var o=r in i;o||(i.setAttribute(r,"return;"),o="function"==typeof i[r]),e[t[a]]=o}return e.touchstart&&e.touchend&&e.touchmove}catch(l){return!1}}function t(){return a.touchSupport===!0||a.touchSupport===!1?a.touchSupport:e()}return{createDragger:function(e){return function(t){return t.pageX=t.originalEvent.changedTouches[0].pageX,t.pageY=t.originalEvent.changedTouches[0].pageY,a.disabled?!1:"move"!==e||a.allowMove?(K=!0,g(e,p(t)),t.stopPropagation(),t.preventDefault(),!1):!1}},isSupported:e,support:t()}}(),H=function(){var e=0,t=0,i=0,r=0,n,o;function l(a){a=g(a),i=e=a[0],r=t=a[1]}function s(e){e=g(e),n=e[0]-i,o=e[1]-r,i=e[0],r=e[1]}function c(){return[n,o]}function u(a){var n=a[0],o=a[1];0>e+n&&(n-=n+e),0>t+o&&(o-=o+t),r+o>j&&(o+=j-(r+o)),i+n>z&&(n+=z-(i+n)),e+=n,i+=n,t+=o,r+=o}function p(e){var t=d();switch(e){case"ne":return[t.x2,t.y];case"nw":return[t.x,t.y];case"se":return[t.x2,t.y2];case"sw":return[t.x,t.y2]}}function d(){if(!a.aspectRatio)return f();var n=a.aspectRatio,o=a.minSize[0]/N,l=a.maxSize[0]/N,s=a.maxSize[1]/V,c=i-e,u=r-t,p=Math.abs(c),d=Math.abs(u),g=p/d,_,b,v,y;return 0===l&&(l=10*z),0===s&&(s=10*j),n>g?(b=r,v=d*n,_=0>c?e-v:v+e,0>_?(_=0,y=Math.abs((_-e)/n),b=0>u?t-y:y+t):_>z&&(_=z,y=Math.abs((_-e)/n),b=0>u?t-y:y+t)):(_=i,y=p/n,b=0>u?t-y:t+y,0>b?(b=0,v=Math.abs((b-t)*n),_=0>c?e-v:v+e):b>j&&(b=j,v=Math.abs(b-t)*n,_=0>c?e-v:v+e)),_>e?(o>_-e?_=e+o:_-e>l&&(_=e+l),b=b>t?t+(_-e)/n:t-(_-e)/n):e>_&&(o>e-_?_=e-o:e-_>l&&(_=e-l),b=b>t?t+(e-_)/n:t-(e-_)/n),0>_?(e-=_,_=0):_>z&&(e-=_-z,_=z),0>b?(t-=b,b=0):b>j&&(t-=b-j,b=j),m(h(e,t,_,b))}function g(e){return e[0]<0&&(e[0]=0),e[1]<0&&(e[1]=0),e[0]>z&&(e[0]=z),e[1]>j&&(e[1]=j),[e[0],e[1]]}function h(e,t,i,a){var r=e,n=i,o=t,l=a;return e>i&&(r=i,n=e),t>a&&(o=a,l=t),[r,o,n,l]}function f(){var a=i-e,n=r-t,o;return M&&Math.abs(a)>M&&(i=a>0?e+M:e-M),B&&Math.abs(n)>B&&(r=n>0?t+B:t-B),q/V&&Math.abs(n)<q/V&&(r=n>0?t+q/V:t-q/V),L/N&&Math.abs(a)<L/N&&(i=a>0?e+L/N:e-L/N),0>e&&(i-=e,e-=e),0>t&&(r-=t,t-=t),0>i&&(e-=i,i-=i),0>r&&(t-=r,r-=r),i>z&&(o=i-z,e-=o,i-=o),r>j&&(o=r-j,t-=o,r-=o),e>z&&(o=e-j,r-=o,t-=o),t>j&&(o=t-j,r-=o,t-=o),m(h(e,t,i,r))}function m(e){return{x:e[0],y:e[1],x2:e[2],y2:e[3],w:e[2]-e[0],h:e[3]-e[1]}}return{flipCoords:h,setPressed:l,setCurrent:s,getOffset:c,moveOffset:u,getCorner:p,getFixed:d}}(),Y=function(){var e=!1,i=t("<div />").css({position:"absolute",zIndex:240,opacity:0}),r={top:c(),left:c().height(j),right:c().height(j),bottom:c()};function n(e,t){r.left.css({height:l(t)}),r.right.css({height:l(t)})}function o(){return s(H.getFixed())}function s(e){r.top.css({left:l(e.x),width:l(e.w),height:l(e.y)}),r.bottom.css({top:l(e.y2),left:l(e.x),width:l(e.w),height:l(j-e.y2)}),r.right.css({left:l(e.x2),width:l(z-e.x2)}),r.left.css({width:l(e.x)})}function c(){return t("<div />").css({position:"absolute",backgroundColor:a.shadeColor||a.bgColor}).appendTo(i)}function u(){e||(e=!0,i.insertBefore(T),o(),X.setBgOpacity(1,0,1),D.hide(),p(a.shadeColor||a.bgColor,1),X.isAwake()?g(a.bgOpacity,1):g(1,1))}function p(e,t){ue(f(),e,t)}function d(){e&&(i.remove(),D.show(),e=!1,X.isAwake()?X.setBgOpacity(a.bgOpacity,1,1):(X.setBgOpacity(1,1,1),X.disableHandles()),ue(F,0,1))}function g(t,r){e&&(a.bgFade&&!r?i.animate({opacity:1-t},{queue:!1,duration:a.fadeTime}):i.css({opacity:1-t}))}function h(){a.shade?u():d(),X.isAwake()&&g(a.bgOpacity)}function f(){return i.children()}return{update:o,updateRaw:s,getShades:f,setBgColor:p,enable:u,disable:d,
	resize:n,refresh:h,opacity:g}}(),X=function(){var e,i={},r={},o={},c=!1;function u(e){var i=t("<div />").css({position:"absolute"}).addClass(s(e));return P.append(i),i}function p(e){var i=t("<div />").mousedown(_(e)).css({cursor:e+"-resize",position:"absolute"}).append("<div/>").addClass("ord-"+e);return J.support&&i.bind("touchstart.jcrop",J.createDragger(e)),P.append(i),i}function d(e){return p(e).addClass(s("handle"))}function g(e){var t,a;for(a=0;a<e.length;a++){switch(e[a]){case"n":t="hline";break;case"s":t="hline bottom";break;case"e":t="vline right";break;case"w":t="vline"}i[e[a]]=u(t)}}function h(e){var t;for(t=0;t<e.length;t++)r[e[t]]=d(e[t])}function f(e,t){a.shade||D.css({top:l(-t),left:l(-e)}),P.css({top:l(t),left:l(e)})}function m(e,t){P.width(Math.round(e)).height(Math.round(t))}function b(){var e=H.getFixed();H.setPressed([e.x,e.y]),H.setCurrent([e.x2,e.y2]),y()}function y(t){return e?w(t):void 0}function w(t){var i=H.getFixed();m(i.w,i.h),f(i.x,i.y),a.shade&&Y.updateRaw(i),e||A(),t?a.onSelect.call(de,v(i)):a.onChange.call(de,v(i))}function k(t,i,r){(e||i)&&(a.bgFade&&!r?T.animate({opacity:t},{queue:!1,duration:a.fadeTime}):T.css("opacity",t))}function A(){P.show(),a.shade?Y.opacity(R):k(R,!0),e=!0}function C(){z(),P.hide(),a.shade?Y.opacity(1):k(1),e=!1,a.onRelease.call(de)}function S(){return c=!0,a.allowResize?!0:void 0}function z(){c=!1}function j(e){e?(G=!0,z()):(G=!1,S())}function F(){j(!1),b()}t.isArray(a.createHandles)&&h(a.createHandles),a.drawBorders&&t.isArray(a.createBorders)&&g(a.createBorders),t(n).bind("touchstart.jcrop-ios",function(e){t(e.currentTarget).hasClass("jcrop-tracker")&&e.stopPropagation()});var U=x().mousedown(_("move")).css({cursor:"move",position:"absolute",zIndex:360});return J.support&&U.bind("touchstart.jcrop",J.createDragger("move")),I.append(U),z(),{updateVisible:y,update:w,release:C,refresh:b,isAwake:function(){return e},setCursor:function(e){U.css("cursor",e)},enableHandles:S,enableOnly:function(){c=!0},disableHandles:z,animMode:j,setBgOpacity:k,done:F}}(),Z=function(){var e=function(){},i=function(){},r=a.trackDocument;function o(){E.css({zIndex:450}),J.support&&t(n).bind("touchmove.jcrop",d).bind("touchend.jcrop",g),r&&t(n).bind("mousemove.jcrop",s).bind("mouseup.jcrop",c)}function l(){E.css({zIndex:290}),t(n).unbind(".jcrop")}function s(t){return e(p(t)),!1}function c(t){return t.preventDefault(),t.stopPropagation(),K&&(K=!1,i(p(t)),X.isAwake()&&a.onSelect.call(de,v(H.getFixed())),l(),e=function(){},i=function(){}),!1}function u(t,a){return K=!0,e=t,i=a,o(),!1}function d(e){return e.pageX=e.originalEvent.changedTouches[0].pageX,e.pageY=e.originalEvent.changedTouches[0].pageY,s(e)}function g(e){return e.pageX=e.originalEvent.changedTouches[0].pageX,e.pageY=e.originalEvent.changedTouches[0].pageY,c(e)}return r||E.mousemove(s).mouseup(c).mouseout(c),T.before(E),{activateHandlers:u}}(),$=function(){var e=t('<input type="radio" />').css({position:"fixed",left:"-120px",width:"12px"}).addClass("jcrop-keymgr"),i=t("<div />").css({position:"absolute",overflow:"hidden"}).append(e);function r(){a.keySupport&&(e.show(),e.focus())}function n(t){e.hide()}function o(e,t,i){a.allowMove&&(H.moveOffset([t,i]),X.updateVisible(!0)),e.preventDefault(),e.stopPropagation()}function l(e){if(e.ctrlKey||e.metaKey)return!0;Q=e.shiftKey?!0:!1;var t=Q?10:1;switch(e.keyCode){case 37:o(e,-t,0);break;case 39:o(e,t,0);break;case 38:o(e,0,-t);break;case 40:o(e,0,t);break;case 9:return!0}return!1}return a.keySupport&&(e.keydown(l).blur(n),e.css({position:"absolute",left:"-20px"}),i.append(e).insertBefore(T)),{watchKeys:r}}();function ee(e){F.removeClass().addClass(s("holder")).addClass(e)}function te(e){ie([e[0]/N,e[1]/V,e[2]/N,e[3]/V]),a.onSelect.call(de,v(H.getFixed())),X.enableHandles()}function ie(e){H.setPressed([e[0],e[1]]),H.setCurrent([e[2],e[3]]),X.update()}function ae(){return v(H.getFixed())}function re(){return H.getFixed()}function ne(e){d(e),pe()}function oe(){a.disabled=!0,X.disableHandles(),X.setCursor("default")}function le(){a.disabled=!1,pe()}function se(){X.done(),Z.activateHandlers(null,null)}function ce(){F.remove(),A.show(),A.css("visibility","visible"),t(e).removeData("Jcrop")}function ue(e,t,i){var r=t||a.bgColor;a.bgFade&&c()&&a.fadeTime&&!i?e.animate({backgroundColor:r},{queue:!1,duration:a.fadeTime}):e.css("backgroundColor",r)}function pe(e){a.allowResize?e?X.enableOnly():X.enableHandles():X.disableHandles(),X.setCursor(a.allowMove?"move":"default"),a.hasOwnProperty("trueSize")&&(N=a.trueSize[0]/z,V=a.trueSize[1]/j),a.hasOwnProperty("setSelect")&&(te(a.setSelect),X.done(),delete a.setSelect),Y.refresh(),a.bgColor!=O&&(ue(a.shade?Y.getShades():F,a.shade?a.shadeColor||a.bgColor:a.bgColor),O=a.bgColor),R!=a.bgOpacity&&(R=a.bgOpacity,a.shade?Y.refresh():X.setBgOpacity(R)),M=a.maxSize[0]||0,B=a.maxSize[1]||0,L=a.minSize[0]||0,q=a.minSize[1]||0,a.hasOwnProperty("outerImage")&&(T.attr("src",a.outerImage),delete a.outerImage),X.refresh()}pe(!0);var de={setSelect:te,setOptions:ne,tellSelect:ae,tellScaled:re,setClass:ee,disable:oe,enable:le,cancel:se,release:X.release,destroy:ce,focus:$.watchKeys,getBounds:function(){return[z*N,j*V]},getWidgetSize:function(){return[z,j]},getScaleFactor:function(){return[N,V]},getOptions:function(){return a},ui:{holder:F,selection:P}};return A.data("Jcrop",de),de},t.fn.Jcrop=function(e,i){var a;return this.each(function(){if(t(this).data("Jcrop")){if("api"===e)return t(this).data("Jcrop");t(this).data("Jcrop").setOptions(e)}else"IMG"==this.tagName?t.Jcrop.Loader(this,function(){t(this).css({display:"block",visibility:"hidden"}),a=t.Jcrop(this,e),t.isFunction(i)&&i.call(a)}):(t(this).css({display:"block",visibility:"hidden"}),a=t.Jcrop(this,e),t.isFunction(i)&&i.call(a))}),this},t.Jcrop.Loader=function(i,a,r){var n=t(i),o=n[0];function l(){o.complete?(n.unbind(".jcloader"),t.isFunction(a)&&a.call(o)):e.setTimeout(l,50)}n.bind("load.jcloader",l).bind("error.jcloader",function(e){n.unbind(".jcloader"),t.isFunction(r)&&r.call(o)}),o.complete&&t.isFunction(a)&&(n.unbind(".jcloader"),a.call(o))},t.Jcrop.defaults={allowMove:!0,allowResize:!0,trackDocument:!0,baseClass:"jcrop",addClass:null,bgColor:"black",bgOpacity:.6,bgFade:!1,aspectRatio:0,keySupport:!0,createHandles:["n","s","e","w","nw","ne","se","sw"],createBorders:["n","s","e","w"],drawBorders:!0,dragEdges:!0,fixedSupport:!0,touchSupport:null,shade:null,boxWidth:0,boxHeight:0,boundary:2,fadeTime:400,animationDelay:20,swingSpeed:3,maxSize:[0,0],minSize:[0,0],onChange:function(){},onSelect:function(){},onDblClick:function(){},onRelease:function(){}}}(r.jQuery),function(){var e,t;e=r.jQuery,t=r.utils,r.namespace("crop",function(i){return i.CropWidget=function(){var i;function a(t,i,a){this.element=t,this.originalSize=i,null==a&&(a={}),this.__api=e.Jcrop(this.element[0],{trueSize:this.originalSize,addClass:"uploadcare-crop-widget",createHandles:["nw","ne","se","sw"],bgColor:"transparent",bgOpacity:.8}),this.setCrop(a),this.setSelection()}return a.prototype.setCrop=function(e){return this.crop=e,this.__api.setOptions({aspectRatio:e.preferedSize?e.preferedSize[0]/e.preferedSize[1]:0,minSize:e.notLess?t.fitSize(e.preferedSize,this.originalSize):[0,0]})},a.prototype.setSelection=function(e){var i,a,r,n;return e?(i=e.center,r=[e.width,e.height]):(i=!0,r=this.originalSize),this.crop.preferedSize&&(r=t.fitSize(this.crop.preferedSize,r,!0)),i?(a=(this.originalSize[0]-r[0])/2,n=(this.originalSize[1]-r[1])/2):(a=e.left||0,n=e.top||0),this.__api.setSelect([a,n,r[0]+a,r[1]+n])},i=/-\/crop\/([0-9]+)x([0-9]+)(\/(center|([0-9]+),([0-9]+)))?\//i,a.prototype.__parseModifiers=function(e){var t;return(t=null!=e?e.match(i):void 0)?{width:parseInt(t[1],10),height:parseInt(t[2],10),center:"center"===t[4],left:parseInt(t[5],10)||void 0,top:parseInt(t[6],10)||void 0}:void 0},a.prototype.setSelectionFromModifiers=function(e){return this.setSelection(this.__parseModifiers(e))},a.prototype.getSelection=function(){var e,t,i;return e=this.__api.tellSelect(),t=Math.round(Math.max(0,e.x)),i=Math.round(Math.max(0,e.y)),{left:t,top:i,width:Math.round(Math.min(this.originalSize[0],e.x2))-t,height:Math.round(Math.min(this.originalSize[1],e.y2))-i}},a.prototype.applySelectionToFile=function(e){
	return t.applyCropSelectionToFile(e,this.crop,this.originalSize,this.getSelection())},a}()})}.call(this),function(){var e,t,i,a,n=function(e,t){return function(){return e.apply(t,arguments)}},o=[].slice;t=r.namespace,i=r.settings,e=r.jQuery,a=r.utils,t("files",function(t){return t.BaseFile=function(){function t(t,i,a){var r;this.settings=i,this.sourceInfo=null!=a?a:{},this.__extendApi=n(this.__extendApi,this),this.__cancel=n(this.__cancel,this),this.__resolveApi=n(this.__resolveApi,this),this.__rejectApi=n(this.__rejectApi,this),this.__runValidators=n(this.__runValidators,this),this.__fileInfo=n(this.__fileInfo,this),this.__handleFileData=n(this.__handleFileData,this),this.__updateInfo=n(this.__updateInfo,this),this.__completeUpload=n(this.__completeUpload,this),this.fileId=null,this.fileName=null,this.sanitizedName=null,this.fileSize=null,this.isStored=null,this.cdnUrlModifiers=null,this.isImage=null,this.imageInfo=null,this.mimeType=null,this.s3Bucket=null,(r=this.sourceInfo).source||(r.source=this.sourceName),this.onInfoReady=e.Callbacks("once memory"),this.__setupValidation(),this.__initApi()}return t.prototype.__startUpload=function(){return e.Deferred().resolve()},t.prototype.__completeUpload=function(){var e,t,i,r,n=this;return i=0,this.settings.debugUploads&&(a.debug("Load file info.",this.fileId,this.settings.publicKey),t=setInterval(function(){return a.debug("Still waiting for file ready.",i,n.fileId,n.settings.publicKey)},5e3),this.apiDeferred.done(function(){return a.debug("File uploaded.",i,n.fileId,n.settings.publicKey)}).always(function(){return clearInterval(t)})),r=100,(e=function(){return"pending"===n.apiDeferred.state()?(i+=1,n.__updateInfo().done(function(){return setTimeout(e,r),r+=50})):void 0})()},t.prototype.__updateInfo=function(){var e=this;return a.jsonp(""+this.settings.urlBase+"/info/",{jsonerrors:1,file_id:this.fileId,pub_key:this.settings.publicKey,wait_is_ready:+this.onInfoReady.fired()}).fail(function(t){return e.settings.debugUploads&&a.log("Can't load file info. Probably removed.",e.fileId,e.settings.publicKey,t),e.__rejectApi("info")}).done(this.__handleFileData)},t.prototype.__handleFileData=function(e){return this.fileName=e.original_filename,this.sanitizedName=e.filename,this.fileSize=e.size,this.isImage=e.is_image,this.imageInfo=e.image_info,this.mimeType=e.mime_type,this.isStored=e.is_stored,this.s3Bucket=e.s3_bucket,e.default_effects&&(this.cdnUrlModifiers="-/"+e.default_effects),this.s3Bucket&&this.cdnUrlModifiers&&this.__rejectApi("baddata"),this.onInfoReady.fired()||this.onInfoReady.fire(this.__fileInfo()),e.is_ready?this.__resolveApi():void 0},t.prototype.__progressInfo=function(){var e;return{state:this.__progressState,uploadProgress:this.__progress,progress:"ready"===(e=this.__progressState)||"error"===e?1:.9*this.__progress,incompleteFileInfo:this.__fileInfo()}},t.prototype.__fileInfo=function(){var e;return e=this.s3Bucket?"https://"+this.s3Bucket+".s3.amazonaws.com/"+this.fileId+"/"+this.sanitizedName:""+this.settings.cdnBase+"/"+this.fileId+"/",{uuid:this.fileId,name:this.fileName,size:this.fileSize,isStored:this.isStored,isImage:!this.s3Bucket&&this.isImage,originalImageInfo:this.imageInfo,mimeType:this.mimeType,originalUrl:this.fileId?e:null,cdnUrl:this.fileId?""+e+(this.cdnUrlModifiers||""):null,cdnUrlModifiers:this.cdnUrlModifiers,sourceInfo:this.sourceInfo}},t.prototype.__setupValidation=function(){return this.validators=this.settings.validators||this.settings.__validators||[],this.settings.imagesOnly&&this.validators.push(function(e){if(e.isImage===!1)throw new Error("image")}),this.onInfoReady.add(this.__runValidators)},t.prototype.__runValidators=function(e){var t,i,a,r,n,o;e=e||this.__fileInfo();try{for(n=this.validators,o=[],a=0,r=n.length;r>a;a++)i=n[a],o.push(i(e));return o}catch(l){return t=l,this.__rejectApi(t.message)}},t.prototype.__initApi=function(){return this.apiDeferred=e.Deferred(),this.__progressState="uploading",this.__progress=0,this.__notifyApi()},t.prototype.__notifyApi=function(){return this.apiDeferred.notify(this.__progressInfo())},t.prototype.__rejectApi=function(e){return this.__progressState="error",this.__notifyApi(),this.apiDeferred.reject(e,this.__fileInfo())},t.prototype.__resolveApi=function(){return this.__progressState="ready",this.__notifyApi(),this.apiDeferred.resolve(this.__fileInfo())},t.prototype.__cancel=function(){return this.__rejectApi("user")},t.prototype.__extendApi=function(e){var t=this;return e.cancel=this.__cancel,e.pipe=e.then=function(){return t.__extendApi(a.fixedPipe.apply(a,[e].concat(o.call(arguments))))},e},t.prototype.promise=function(){var e,t=this;return this.__apiPromise||(this.__apiPromise=this.__extendApi(this.apiDeferred.promise()),this.__runValidators(),"pending"===this.apiDeferred.state()&&(e=this.__startUpload(),e.done(function(){return t.__progressState="uploaded",t.__progress=1,t.__notifyApi(),t.__completeUpload()}),e.progress(function(e){return e>t.__progress?(t.__progress=e,t.__notifyApi()):void 0}),e.fail(function(){return t.__rejectApi("upload")}),this.apiDeferred.always(e.reject))),this.__apiPromise},t}()}),t("utils",function(e){return e.isFile=function(e){return e&&e.done&&e.fail&&e.cancel},e.valueToFile=function(t,i){return t&&!e.isFile(t)&&(t=r.fileFrom("uploaded",t,i)),t||null}})}.call(this),function(){var t,i,a,o,l,s,c;t=r.jQuery,l=r.utils,s=r.utils,c=s.abilities,i=c.Blob,a=c.FileReader,o=c.URL,r.namespace("utils.image",function(r){var s,c;return s=e.DataView,c=l.taskRunner(1),r.shrinkFile=function(e,a){var n,u=this;return n=t.Deferred(),o&&s&&i?(c(function(t){var i;return n.always(t),i=l.imageLoader(o.createObjectURL(e)),i.always(function(e){return o.revokeObjectURL(e.src)}),i.fail(function(){return n.reject("not image")}),i.done(function(t){return n.notify(.1),r.getExif(e).always(function(e){var o,s;return n.notify(.2),s="resolved"===this.state(),i=r.shrinkImage(t,a),i.progress(function(e){return n.notify(.2+.6*e)}),i.fail(n.reject),i.done(function(t){var o,c;return o="image/jpeg",c=a.quality||.8,!s&&r.hasTransparency(t)&&(o="image/png",c=void 0),l.canvasToBlob(t,o,c,function(a){return t.width=t.height=1,n.notify(.9),e?(i=r.replaceJpegChunk(a,225,[e.buffer]),i.done(n.resolve),i.fail(function(){return n.resolve(a)})):n.resolve(a)})}),o=null})})}),n.promise()):n.reject("support")},r.shrinkImage=function(e,i){var a,r,o,s,c,u,p,d,g,h,f,m,_,b;return r=t.Deferred(),_=.71,e.width*_*e.height*_<i.size?r.reject("not required"):(m=p=e.width,f=e.height,d=m/f,b=Math.floor(Math.sqrt(i.size*d)),o=Math.floor(i.size/Math.sqrt(i.size*d)),u=5e6,c=4096,g=function(){return b>=m?void r.resolve(e):l.defer(function(){var t;return m=Math.round(m*_),f=Math.round(f*_),b>m*_&&(m=b,f=o),m*f>u&&(m=Math.floor(Math.sqrt(u*d)),f=Math.floor(u/Math.sqrt(u*d))),m>c&&(m=c,f=Math.round(m/d)),f>c&&(f=c,m=Math.round(d*f)),t=n.createElement("canvas"),t.width=m,t.height=f,t.getContext("2d").drawImage(e,0,0,m,f),e.src="//:0",e.width=e.height=1,e=t,r.notify((p-m)/(p-b)),g()})},h=function(){var t,i;return t=n.createElement("canvas"),t.width=b,t.height=o,i=t.getContext("2d"),i.imageSmoothingQuality="high",i.drawImage(e,0,0,b,o),e.src="//:0",e.width=e.height=1,r.resolve(t)},a=n.createElement("canvas").getContext("2d"),s=navigator.userAgent.match(/\ Chrome\//),"imageSmoothingQuality"in a&&!s?h():g(),r.promise())},r.drawFileToCanvas=function(e,i,a,s,c){var u,p;return u=t.Deferred(),o?(p=l.imageLoader(o.createObjectURL(e)),p.always(function(e){return o.revokeObjectURL(e.src)}),p.fail(function(){return u.reject("not image")}),p.done(function(t){return u.always(function(){return t.src="//:0"}),c&&t.width*t.height>c?u.reject("max source"):r.getExif(e).always(function(e){var o,c,p,d,g,h,f,m,_,b;return g=r.parseExifOrientation(e)||1,f=g>4,h=f?[t.height,t.width]:[t.width,t.height],_=l.fitSize(h,[i,a]),d=_[0],p=_[1],(m=[[1,0,0,1,0,0],[-1,0,0,1,d,0],[-1,0,0,-1,d,p],[1,0,0,-1,0,p],[0,1,1,0,0,0],[0,1,-1,0,d,0],[0,-1,-1,0,d,p],[0,-1,1,0,0,p]][g-1])?(o=n.createElement("canvas"),o.width=d,o.height=p,c=o.getContext("2d"),c.transform.apply(c,m),f&&(b=[p,d],d=b[0],p=b[1]),s&&(c.fillStyle=s,c.fillRect(0,0,d,p)),c.drawImage(t,0,0,d,p),u.resolve(o,h)):u.reject("bad image");
	})}),u.promise()):u.reject("support")},r.readJpegChunks=function(e){var i,r,n,o,l;return l=function(e,t){var r;return r=new a,r.onload=function(){return t(new s(r.result))},r.onerror=function(e){return i.reject("reader",e)},r.readAsArrayBuffer(e)},n=function(){return l(e.slice(r,r+128),function(e){var t,i,a;for(t=i=0,a=e.byteLength;a>=0?a>i:i>a;t=a>=0?++i:--i)if(255===e.getUint8(t)){r+=t;break}return o()})},o=function(){var t;return t=r,l(e.slice(r,r+=4),function(a){var o,s;return 4!==a.byteLength||255!==a.getUint8(0)?i.reject("corrupted"):(s=a.getUint8(1),218===s?i.resolve():(o=a.getUint16(2)-2,l(e.slice(r,r+=o),function(e){return e.byteLength!==o?i.reject("corrupted"):(i.notify(t,o,s,e),n())})))})},i=t.Deferred(),a&&s?(r=2,l(e.slice(0,2),function(e){return 65496!==e.getUint16(0)?i.reject("not jpeg"):n()}),i.promise()):i.reject("support")},r.replaceJpegChunk=function(e,a,n){var o,l,c,u;return o=t.Deferred(),c=[],l=[],u=r.readJpegChunks(e),u.fail(o.reject),u.progress(function(e,t,i){return i===a?(c.push(e),l.push(t)):void 0}),u.done(function(){var t,r,u,p,d,g,h,f,m;for(p=[e.slice(0,2)],g=0,f=n.length;f>g;g++)t=n[g],u=new s(new ArrayBuffer(4)),u.setUint16(0,65280+a),u.setUint16(2,t.byteLength+2),p.push(u.buffer),p.push(t);for(d=2,r=h=0,m=c.length;m>=0?m>h:h>m;r=m>=0?++h:--h)c[r]>d&&p.push(e.slice(d,c[r])),d=c[r]+l[r]+4;return p.push(e.slice(d,e.size)),o.resolve(new i(p,{type:e.type}))}),o.promise()},r.getExif=function(e){var i,a;return i=null,a=r.readJpegChunks(e),a.progress(function(e,t,a,r){return!i&&225===a&&r.byteLength>=14&&1165519206===r.getUint32(0)&&0===r.getUint16(4)?i=r:void 0}),a.then(function(){return i},function(e){return t.Deferred().reject(i,e)})},r.parseExifOrientation=function(e){var t,i,a,r,n;if(!e||e.byteLength<14||1165519206!==e.getUint32(0)||0!==e.getUint16(4))return null;if(18761===e.getUint16(6))a=!0;else{if(19789!==e.getUint16(6))return null;a=!1}if(42!==e.getUint16(8,a))return null;for(r=8+e.getUint32(10,a),t=e.getUint16(r-2,a),i=n=0;t>=0?t>n:n>t;i=t>=0?++n:--n){if(e.byteLength<r+10)return null;if(274===e.getUint16(r,a))return e.getUint16(r+8,a);r+=12}return null},r.hasTransparency=function(e){var t,i,a,r,o,l,s;for(o=50,t=n.createElement("canvas"),t.width=t.height=o,i=t.getContext("2d"),i.drawImage(e,0,0,o,o),a=i.getImageData(0,0,o,o).data,t.width=t.height=1,r=l=3,s=a.length;s>l;r=l+=4)if(a[r]<254)return!0;return!1}})}.call(this),function(){var e,t,i=function(e,t){return function(){return e.apply(t,arguments)}},a={}.hasOwnProperty,n=function(e,t){for(var i in t)a.call(t,i)&&(e[i]=t[i]);function r(){this.constructor=e}return r.prototype=t.prototype,e.prototype=new r,e.__super__=t.prototype,e};e=r.jQuery,t=r.utils,r.namespace("files",function(a){return a.ObjectFile=function(a){var r;n(o,a),r=null,o.prototype.sourceName="local";function o(e){this.__file=e,this.setFile=i(this.setFile,this),o.__super__.constructor.apply(this,arguments),this.fileName=this.__file.name||"original",this.__notifyApi()}return o.prototype.setFile=function(e){return e&&(this.__file=e),this.sourceInfo.file=this.__file,this.__file?(this.fileSize=this.__file.size,this.fileType=this.__file.type||"application/octet-stream",this.settings.debugUploads&&t.debug("Use local file.",this.fileName,this.fileType,this.fileSize),this.__runValidators(),this.__notifyApi()):void 0},o.prototype.__startUpload=function(){var i,a,r,n=this;return this.apiDeferred.always(function(){return n.__file=null}),this.__file.size>=this.settings.multipartMinSize&&t.abilities.Blob?(this.setFile(),this.multipartUpload()):(a=t.abilities.iOSVersion,!this.settings.imageShrink||a&&8>a?(this.setFile(),this.directUpload()):(i=e.Deferred(),r=.4,t.image.shrinkFile(this.__file,this.settings.imageShrink).progress(function(e){return i.notify(e*r)}).done(this.setFile).fail(function(){return n.setFile(),r=.1*r}).always(function(){return i.notify(r),n.directUpload().done(i.resolve).fail(i.reject).progress(function(e){return i.notify(r+e*(1-r))})}),i))},o.prototype.__autoAbort=function(e){return this.apiDeferred.fail(e.abort),e},o.prototype.directRunner=function(e){return r||(r=t.taskRunner(this.settings.parallelDirectUploads)),r(e)},o.prototype.directUpload=function(){var t,i=this;return t=e.Deferred(),this.__file?this.fileSize>104857600?(this.__rejectApi("size"),t):(this.directRunner(function(a){var r;return t.always(a),"pending"===i.apiDeferred.state()?(r=new FormData,r.append("UPLOADCARE_PUB_KEY",i.settings.publicKey),r.append("signature",i.settings.secureSignature),r.append("expire",i.settings.secureExpire),r.append("UPLOADCARE_STORE",i.settings.doNotStore?"":"auto"),r.append("file",i.__file,i.fileName),r.append("file_name",i.fileName),r.append("source",i.sourceInfo.source),i.__autoAbort(e.ajax({xhr:function(){var i;return i=e.ajaxSettings.xhr(),i.upload&&i.upload.addEventListener("progress",function(e){return t.notify(e.loaded/e.total)},!1),i},crossDomain:!0,type:"POST",url:""+i.settings.urlBase+"/base/?jsonerrors=1",headers:{"X-PINGOTHER":"pingpong"},contentType:!1,processData:!1,data:r,dataType:"json",error:t.reject,success:function(e){return(null!=e?e.file:void 0)?(i.fileId=e.file,t.resolve()):t.reject()}}))):void 0}),t):(this.__rejectApi("baddata"),t)},o.prototype.multipartUpload=function(){var t,i=this;return t=e.Deferred(),this.__file?this.settings.imagesOnly?(this.__rejectApi("image"),t):(this.multipartStart().done(function(e){return i.uploadParts(e.parts,e.uuid).done(function(){return i.multipartComplete(e.uuid).done(function(e){return i.fileId=e.uuid,i.__handleFileData(e),t.resolve()}).fail(t.reject)}).progress(t.notify).fail(t.reject)}).fail(t.reject),t):t},o.prototype.multipartStart=function(){var e,i=this;return e={UPLOADCARE_PUB_KEY:this.settings.publicKey,signature:this.settings.secureSignature,expire:this.settings.secureExpire,filename:this.fileName,source:this.sourceInfo.source,size:this.fileSize,content_type:this.fileType,part_size:this.settings.multipartPartSize,UPLOADCARE_STORE:this.settings.doNotStore?"":"auto"},this.__autoAbort(t.jsonp(""+this.settings.urlBase+"/multipart/start/?jsonerrors=1","POST",e).fail(function(a){return i.settings.debugUploads?t.log("Can't start multipart upload.",a,e):void 0}))},o.prototype.uploadParts=function(i,a){var r,n,o,l,s,c,u,p,d,g,h,f=this;for(s=[],l=e.now(),d=function(t,i){var a,n,o;if(s[t]=i,!(e.now()-l<250)){for(l=e.now(),a=0,n=0,o=s.length;o>n;n++)i=s[n],a+=i;return r.notify(a/f.fileSize)}},r=e.Deferred(),o=0,p=0,u=0,c=function(){var n,l,g,h,m;if(!(u>=f.fileSize))return g=u+f.settings.multipartPartSize,f.fileSize<g+f.settings.multipartMinLastPartSize&&(g=f.fileSize),l=f.__file.slice(u,g),u=g,h=p,o+=1,p+=1,n=0,(m=function(){return"pending"===f.apiDeferred.state()?(s[h]=0,f.__autoAbort(e.ajax({xhr:function(){var t;return t=e.ajaxSettings.xhr(),t.upload&&t.upload.addEventListener("progress",function(e){return d(h,e.loaded)},!1),t},url:i[h],crossDomain:!0,type:"PUT",processData:!1,contentType:f.fileType,data:l,error:function(){return n+=1,n>f.settings.multipartMaxAttempts?(f.settings.debugUploads&&t.info("Part #"+h+" and file upload is failed.",a),r.reject()):(f.settings.debugUploads&&t.debug("Part #"+h+"("+n+") upload is failed.",a),m())},success:function(){return o-=1,c(),o?void 0:r.resolve()}}))):void 0})()},n=g=0,h=this.settings.multipartConcurrency;h>=0?h>g:g>h;n=h>=0?++g:--g)c();return r},o.prototype.multipartComplete=function(e){var i,a=this;return i={UPLOADCARE_PUB_KEY:this.settings.publicKey,uuid:e},this.__autoAbort(t.jsonp(""+this.settings.urlBase+"/multipart/complete/?jsonerrors=1","POST",i).fail(function(i){return a.settings.debugUploads?t.log("Can't complete multipart upload.",e,a.settings.publicKey,i):void 0}))},o}(a.BaseFile)})}.call(this),function(){var e,t,i=function(e,t){return function(){return e.apply(t,arguments)}},a={}.hasOwnProperty,n=function(e,t){for(var i in t)a.call(t,i)&&(e[i]=t[i]);function r(){this.constructor=e}return r.prototype=t.prototype,e.prototype=new r,e.__super__=t.prototype,e};e=r.jQuery,t=r.utils,r.namespace("files",function(a){return a.InputFile=function(a){n(r,a),r.prototype.sourceName="local-compat";function r(a){this.__input=a,this.__cleanUp=i(this.__cleanUp,this),r.__super__.constructor.apply(this,arguments),
	this.fileId=t.uuid(),this.fileName=e(this.__input).val().split("\\").pop(),this.__notifyApi()}return r.prototype.__startUpload=function(){var t,i,a,r;return t=e.Deferred(),r=""+this.settings.urlBase+"/iframe/",a="uploadcare-iframe-"+this.fileId,this.__iframe=e("<iframe>").attr({id:a,name:a}).css("display","none").appendTo("body").on("load",t.resolve).on("error",t.reject),i=function(t,i){return e("<input/>",{type:"hidden",name:t,value:i})},e(this.__input).attr("name","file"),this.__iframeForm=e("<form>").attr({method:"POST",action:r,enctype:"multipart/form-data",target:a}).append(i("UPLOADCARE_PUB_KEY",this.settings.publicKey)).append(i("UPLOADCARE_SIGNATURE",this.settings.secureSignature)).append(i("UPLOADCARE_EXPIRE",this.settings.secureExpire)).append(i("UPLOADCARE_FILE_ID",this.fileId)).append(i("UPLOADCARE_STORE",this.settings.doNotStore?"":"auto")).append(i("UPLOADCARE_SOURCE",this.sourceInfo.source)).append(this.__input).css("display","none").appendTo("body").submit(),t.always(this.__cleanUp)},r.prototype.__cleanUp=function(){var e,t;return null!=(e=this.__iframe)&&e.off("load error").remove(),null!=(t=this.__iframeForm)&&t.remove(),this.__iframe=null,this.__iframeForm=null},r}(a.BaseFile)})}.call(this),function(){var t,a;!function(){void 0===Function.prototype.scopedTo&&(Function.prototype.scopedTo=function(e,t){var i=this;return function(){return i.apply(e,Array.prototype.slice.call(t||[]).concat(Array.prototype.slice.call(arguments)))}}),t=function(e,i){this.options=i||{},this.key=e,this.channels=new t.Channels,this.global_emitter=new t.EventsDispatcher;var a=this;this.checkAppKey(),this.connection=new t.Connection(this.key,this.options),this.connection.bind("connected",function(){a.subscribeAll()}).bind("message",function(e){var t=0===e.event.indexOf("pusher_internal:");if(e.channel){var i;(i=a.channel(e.channel))&&i.emit(e.event,e.data)}t||a.global_emitter.emit(e.event,e.data)}).bind("disconnected",function(){a.channels.disconnect()}).bind("error",function(e){t.warn("Error",e)}),t.instances.push(this),t.isReady&&a.connect()},t.instances=[],t.prototype={channel:function(e){return this.channels.find(e)},connect:function(){this.connection.connect()},disconnect:function(){this.connection.disconnect()},bind:function(e,t){return this.global_emitter.bind(e,t),this},bind_all:function(e){return this.global_emitter.bind_all(e),this},subscribeAll:function(){var e;for(channelName in this.channels.channels)this.channels.channels.hasOwnProperty(channelName)&&this.subscribe(channelName)},subscribe:function(e){var t=this,i=this.channels.add(e,this);return"connected"===this.connection.state&&i.authorize(this.connection.socket_id,this.options,function(a,r){a?i.emit("pusher:subscription_error",r):t.send_event("pusher:subscribe",{channel:e,auth:r.auth,channel_data:r.channel_data})}),i},unsubscribe:function(e){this.channels.remove(e),"connected"===this.connection.state&&this.send_event("pusher:unsubscribe",{channel:e})},send_event:function(e,t,i){return this.connection.send_event(e,t,i)},checkAppKey:function(){(null===this.key||void 0===this.key)&&t.warn("Warning","You must pass your app key when you instantiate Pusher.")}},t.Util={extend:function a(e,t){for(var i in t)t[i]&&t[i].constructor&&t[i].constructor===Object?e[i]=a(e[i]||{},t[i]):e[i]=t[i];return e},stringify:function r(){for(var t=["Pusher"],i=0;i<arguments.length;i++)"string"==typeof arguments[i]?t.push(arguments[i]):void 0==e.JSON?t.push(arguments[i].toString()):t.push(JSON.stringify(arguments[i]));return t.join(" : ")},arrayIndexOf:function(e,t){var a=Array.prototype.indexOf;if(null==e)return-1;if(a&&e.indexOf===a)return e.indexOf(t);for(i=0,l=e.length;i<l;i++)if(e[i]===t)return i;return-1}},t.debug=function(){t.log&&t.log(t.Util.stringify.apply(this,arguments))},t.warn=function(){if(e.console&&e.console.warn)e.console.warn(t.Util.stringify.apply(this,arguments));else{if(!t.log)return;t.log(t.Util.stringify.apply(this,arguments))}},t.VERSION="1.12.2",t.host="ws.pusherapp.com",t.ws_port=80,t.wss_port=443,t.channel_auth_endpoint="/pusher/auth",t.cdn_http="http://js.pusher.com/",t.cdn_https="https://d3dy5gmtp8yhk7.cloudfront.net/",t.dependency_suffix=".min",t.channel_auth_transport="ajax",t.activity_timeout=12e4,t.pong_timeout=3e4,t.isReady=!1,t.ready=function(){t.isReady=!0;for(var e=0,i=t.instances.length;i>e;e++)t.instances[e].connect()}}(),function(){function e(){this._callbacks={}}e.prototype.get=function(e){return this._callbacks[this._prefix(e)]},e.prototype.add=function(e,t){var i=this._prefix(e);this._callbacks[i]=this._callbacks[i]||[],this._callbacks[i].push(t)},e.prototype.remove=function(e,i){if(this.get(e)){var a=t.Util.arrayIndexOf(this.get(e),i);this._callbacks[this._prefix(e)].splice(a,1)}},e.prototype._prefix=function(e){return"_"+e};function i(t){this.callbacks=new e,this.global_callbacks=[],this.failThrough=t}i.prototype.bind=function(e,t){return this.callbacks.add(e,t),this},i.prototype.unbind=function(e,t){return this.callbacks.remove(e,t),this},i.prototype.emit=function(e,t){for(var i=0;i<this.global_callbacks.length;i++)this.global_callbacks[i](e,t);var a=this.callbacks.get(e);if(a)for(var i=0;i<a.length;i++)a[i](t);else this.failThrough&&this.failThrough(e,t);return this},i.prototype.bind_all=function(e){return this.global_callbacks.push(e),this},t.EventsDispatcher=i}(),function(){function e(e){return e.substr(0,1).toUpperCase()+e.substr(1)}function i(e,t,i){void 0!==t[e]&&t[e](i)}function a(e,i,a){t.EventsDispatcher.call(this),this.state=void 0,this.errors=[],this.stateActions=a,this.transitions=i,this.transition(e)}a.prototype.transition=function(a,r){var n=this.state,o=this.stateActions;if(n&&-1==t.Util.arrayIndexOf(this.transitions[n],a))throw this.emit("invalid_transition_attempt",{oldState:n,newState:a}),new Error("Invalid transition ["+n+" to "+a+"]");i(n+"Exit",o,r),i(n+"To"+e(a),o,r),i(a+"Pre",o,r),this.state=a,this.emit("state_change",{oldState:n,newState:a}),i(a+"Post",o,r)},a.prototype.is=function(e){return this.state===e},a.prototype.isNot=function(e){return this.state!==e},t.Util.extend(a.prototype,t.EventsDispatcher.prototype),t.Machine=a}(),function(){var i=function(){var i=this;t.EventsDispatcher.call(this),void 0!==e.addEventListener&&(e.addEventListener("online",function(){i.emit("online",null)},!1),e.addEventListener("offline",function(){i.emit("offline",null)},!1))};i.prototype.isOnLine=function(){return void 0===e.navigator.onLine?!0:e.navigator.onLine},t.Util.extend(i.prototype,t.EventsDispatcher.prototype),t.NetInfo=i}(),function(){var e={initialized:["waiting","failed"],waiting:["connecting","permanentlyClosed"],connecting:["open","permanentlyClosing","impermanentlyClosing","waiting"],open:["connected","permanentlyClosing","impermanentlyClosing","waiting"],connected:["permanentlyClosing","waiting"],impermanentlyClosing:["waiting","permanentlyClosing"],permanentlyClosing:["permanentlyClosed"],permanentlyClosed:["waiting","failed"],failed:["permanentlyClosed"]},i=2e3,a=2e3,r=2e3,o=5*i,l=5*a,s=5*r;function c(e){e.connectionWait=0,"flash"===t.TransportType?e.openTimeout=5e3:e.openTimeout=2e3,e.connectedTimeout=2e3,e.connectionSecure=e.compulsorySecure,e.connectionAttempts=0}function u(u,p){var d=this;t.EventsDispatcher.call(this),this.options=t.Util.extend({encrypted:!1},p),this.netInfo=new t.NetInfo,this.netInfo.bind("online",function(){d._machine.is("waiting")&&(d._machine.transition("connecting"),S("connecting"))}),this.netInfo.bind("offline",function(){d._machine.is("connected")&&(d.socket.onclose=void 0,d.socket.onmessage=void 0,d.socket.onerror=void 0,d.socket.onopen=void 0,d.socket.close(),d.socket=void 0,d._machine.transition("waiting"))}),this._machine=new t.Machine("initialized",e,{initializedPre:function(){d.compulsorySecure=d.options.encrypted,d.key=u,d.socket=null,d.socket_id=null,d.state="initialized"},waitingPre:function(){d.connectionWait>0&&d.emit("connecting_in",d.connectionWait),S(d.netInfo.isOnLine()&&d.connectionAttempts<=4?"connecting":"unavailable"),d.netInfo.isOnLine()&&(d._waitingTimer=setTimeout(function(){d._machine.transition("connecting")},b()))},waitingExit:function(){clearTimeout(d._waitingTimer)},connectingPre:function(){
	if(d.netInfo.isOnLine()===!1)return d._machine.transition("waiting"),void S("unavailable");var e=h(d.key,d.connectionSecure);t.debug("Connecting",e),d.socket=new t.Transport(e),d.socket.onopen=v,d.socket.onclose=A,d.socket.onerror=C,d._connectingTimer=setTimeout(f,d.openTimeout)},connectingExit:function(){clearTimeout(d._connectingTimer),d.socket.onopen=void 0},connectingToWaiting:function(){g()},connectingToImpermanentlyClosing:function(){g()},openPre:function(){d.socket.onmessage=w,d.socket.onerror=C,d.socket.onclose=A,d._openTimer=setTimeout(f,d.connectedTimeout)},openExit:function(){clearTimeout(d._openTimer),d.socket.onmessage=void 0},openToWaiting:function(){g()},openToImpermanentlyClosing:function(){g()},connectedPre:function(e){d.socket_id=e,d.socket.onmessage=x,d.socket.onerror=C,d.socket.onclose=A,c(d),d.connectedAt=(new Date).getTime(),m()},connectedPost:function(){S("connected")},connectedExit:function(){_(),S("disconnected")},impermanentlyClosingPost:function(){d.socket&&(d.socket.onclose=A,d.socket.close())},permanentlyClosingPost:function(){d.socket?(d.socket.onclose=function(){c(d),d._machine.transition("permanentlyClosed")},d.socket.close()):(c(d),d._machine.transition("permanentlyClosed"))},failedPre:function(){S("failed"),t.debug("WebSockets are not available in this browser.")},permanentlyClosedPost:function(){S("disconnected")}});function g(){d.connectionWait<o&&(d.connectionWait+=i),d.openTimeout<l&&(d.openTimeout+=a),d.connectedTimeout<s&&(d.connectedTimeout+=r),d.compulsorySecure!==!0&&(d.connectionSecure=!d.connectionSecure),d.connectionAttempts++}function h(e,i){var a=t.ws_port,r="ws://";(i||"https:"===n.location.protocol)&&(a=t.wss_port,r="wss://");var o="flash"===t.TransportType?"true":"false";return r+t.host+":"+a+"/app/"+e+"?protocol=5&client=js&version="+t.VERSION+"&flash="+o}function f(){d._machine.transition("impermanentlyClosing")}function m(){d._activityTimer&&clearTimeout(d._activityTimer),d._activityTimer=setTimeout(function(){d.send_event("pusher:ping",{}),d._activityTimer=setTimeout(function(){d.socket.close()},d.options.pong_timeout||t.pong_timeout)},d.options.activity_timeout||t.activity_timeout)}function _(){d._activityTimer&&clearTimeout(d._activityTimer)}function b(){var e=d.connectionWait;if(0===e&&d.connectedAt){var t=1e3,i=(new Date).getTime()-d.connectedAt;t>i&&(e=t-i)}return e}function v(){d._machine.transition("open")}function y(e,t){d.emit("error",{type:"PusherError",data:{code:e,message:t}}),4e3===e?(d.compulsorySecure=!0,d.connectionSecure=!0,d.options.encrypted=!0,f()):4100>e?d._machine.transition("permanentlyClosing"):4200>e?(d.connectionWait=1e3,d._machine.transition("waiting")):4300>e?f():d._machine.transition("permanentlyClosing")}function w(e){var t=k(e);void 0!==t&&("pusher:connection_established"===t.event?d._machine.transition("connected",t.data.socket_id):"pusher:error"===t.event&&y(t.data.code,t.data.message))}function x(e){m();var i=k(e);if(void 0!==i){switch(t.debug("Event recd",i),i.event){case"pusher:error":d.emit("error",{type:"PusherError",data:i.data});break;case"pusher:ping":d.send_event("pusher:pong",{})}d.emit("message",i)}}function k(e){try{var t=JSON.parse(e.data);if("string"==typeof t.data)try{t.data=JSON.parse(t.data)}catch(i){if(!(i instanceof SyntaxError))throw i}return t}catch(i){d.emit("error",{type:"MessageParseError",error:i,data:e.data})}}function A(){d._machine.transition("waiting")}function C(e){d.emit("error",{type:"WebSocketError",error:e})}function S(e,i){var a=d.state;d.state=e,a!==e&&(t.debug("State changed",a+" -> "+e),d.emit("state_change",{previous:a,current:e}),d.emit(e,i))}}u.prototype.connect=function(){this._machine.is("failed")||t.Transport?this._machine.is("initialized")?(c(this),this._machine.transition("waiting")):this._machine.is("waiting")&&this.netInfo.isOnLine()===!0?this._machine.transition("connecting"):this._machine.is("permanentlyClosed")&&(c(this),this._machine.transition("waiting")):this._machine.transition("failed")},u.prototype.send=function(e){if(this._machine.is("connected")){var t=this;return setTimeout(function(){t.socket.send(e)},0),!0}return!1},u.prototype.send_event=function(e,i,a){var r={event:e,data:i};return a&&(r.channel=a),t.debug("Event sent",r),this.send(JSON.stringify(r))},u.prototype.disconnect=function(){this._machine.is("permanentlyClosed")||(this._machine.is("waiting")||this._machine.is("failed")?this._machine.transition("permanentlyClosed"):this._machine.transition("permanentlyClosing"))},t.Util.extend(u.prototype,t.EventsDispatcher.prototype),t.Connection=u}(),function(){t.Channels=function(){this.channels={}},t.Channels.prototype={add:function(e,i){var a=this.find(e);if(a)return a;var r=t.Channel.factory(e,i);return this.channels[e]=r,r},find:function(e){return this.channels[e]},remove:function(e){delete this.channels[e]},disconnect:function(){for(var e in this.channels)this.channels[e].disconnect()}},t.Channel=function(e,i){var a=this;t.EventsDispatcher.call(this,function(i,a){t.debug("No callbacks on "+e+" for "+i)}),this.pusher=i,this.name=e,this.subscribed=!1,this.bind("pusher_internal:subscription_succeeded",function(e){a.onSubscriptionSucceeded(e)})},t.Channel.prototype={init:function(){},disconnect:function(){this.subscribed=!1,this.emit("pusher_internal:disconnected")},onSubscriptionSucceeded:function(e){this.subscribed=!0,this.emit("pusher:subscription_succeeded")},authorize:function(e,t,i){return i(!1,{})},trigger:function(e,t){return this.pusher.send_event(e,t,this.name)}},t.Util.extend(t.Channel.prototype,t.EventsDispatcher.prototype),t.Channel.PrivateChannel={authorize:function(e,i,a){var r=this,n=new t.Channel.Authorizer(this,t.channel_auth_transport,i);return n.authorize(e,function(e,t){e||r.emit("pusher_internal:authorized",t),a(e,t)})}},t.Channel.PresenceChannel={init:function(){this.members=new e(this)},onSubscriptionSucceeded:function(e){this.subscribed=!0}};var e=function(e){var t=this,i=function(){this._members_map={},this.count=0,this.me=null};i.call(this),e.bind("pusher_internal:authorized",function(i){var a=JSON.parse(i.channel_data);e.bind("pusher_internal:subscription_succeeded",function(i){t._members_map=i.presence.hash,t.count=i.presence.count,t.me=t.get(a.user_id),e.emit("pusher:subscription_succeeded",t)})}),e.bind("pusher_internal:member_added",function(i){null===t.get(i.user_id)&&t.count++,t._members_map[i.user_id]=i.user_info,e.emit("pusher:member_added",t.get(i.user_id))}),e.bind("pusher_internal:member_removed",function(i){var a=t.get(i.user_id);a&&(delete t._members_map[i.user_id],t.count--,e.emit("pusher:member_removed",a))}),e.bind("pusher_internal:disconnected",function(){i.call(t)})};e.prototype={each:function(e){for(var t in this._members_map)e(this.get(t))},get:function(e){return this._members_map.hasOwnProperty(e)?{id:e,info:this._members_map[e]}:null}},t.Channel.factory=function(e,i){var a=new t.Channel(e,i);return 0===e.indexOf("private-")?t.Util.extend(a,t.Channel.PrivateChannel):0===e.indexOf("presence-")&&(t.Util.extend(a,t.Channel.PrivateChannel),t.Util.extend(a,t.Channel.PresenceChannel)),a.init(),a}}(),function(){t.Channel.Authorizer=function(e,t,i){this.channel=e,this.type=t,this.authOptions=(i||{}).auth||{}},t.Channel.Authorizer.prototype={composeQuery:function(e){var t="&socket_id="+encodeURIComponent(e)+"&channel_name="+encodeURIComponent(this.channel.name);for(var i in this.authOptions.params)t+="&"+encodeURIComponent(i)+"="+encodeURIComponent(this.authOptions.params[i]);return t},authorize:function(e,i){return t.authorizers[this.type].call(this,e,i)}},t.auth_callbacks={},t.authorizers={ajax:function(i,a){var r=this,n;n=t.XHR?new t.XHR:e.XMLHttpRequest?new e.XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP"),n.open("POST",t.channel_auth_endpoint,!0),n.setRequestHeader("Content-Type","application/x-www-form-urlencoded");for(var o in this.authOptions.headers)n.setRequestHeader(o,this.authOptions.headers[o]);return n.onreadystatechange=function(){if(4==n.readyState)if(200==n.status){var e,i=!1;try{e=JSON.parse(n.responseText),i=!0}catch(r){a(!0,"JSON returned from webapp was invalid, yet status code was 200. Data was: "+n.responseText)}i&&a(!1,e)}else t.warn("Couldn't get auth info from your webapp",n.status),
	a(!0,n.status)},n.send(this.composeQuery(i)),n},jsonp:function(e,i){void 0!==this.authOptions.headers&&t.warn("Warn","To send headers with the auth request, you must use AJAX, rather than JSONP.");var a=n.createElement("script");t.auth_callbacks[this.channel.name]=function(e){i(!1,e)};var r="Pusher.auth_callbacks['"+this.channel.name+"']";a.src=t.channel_auth_endpoint+"?callback="+encodeURIComponent(r)+this.composeQuery(e);var o=n.getElementsByTagName("head")[0]||n.documentElement;o.insertBefore(a,o.firstChild)}}}();var a=function(){function e(e,t){n.addEventListener?e.addEventListener("load",t,!1):e.attachEvent("onreadystatechange",function(){("loaded"==e.readyState||"complete"==e.readyState)&&t()})}function t(t,i){var a=n.getElementsByTagName("head")[0],r=n.createElement("script");r.setAttribute("src",t),r.setAttribute("type","text/javascript"),r.setAttribute("async",!0),e(r,function(){i()}),a.appendChild(r)}return function(e,i){for(var a=0,r=0;r<e.length;r++)t(e[r],function(){e.length==++a&&setTimeout(i,0)})}}();!function(){!e.WebSocket&&e.MozWebSocket&&(e.WebSocket=e.MozWebSocket),e.WebSocket&&(t.Transport=e.WebSocket,t.TransportType="native");var i="http:"==n.location.protocol?t.cdn_http:t.cdn_https,r=i+t.VERSION,o=[];e.JSON||o.push(r+"/json2"+t.dependency_suffix+".js"),e.WebSocket||(e.WEB_SOCKET_DISABLE_AUTO_INITIALIZATION=!0,o.push(r+"/flashfallback"+t.dependency_suffix+".js"));var l=function(){return e.WebSocket?function(){t.ready()}:function(){e.WebSocket?(t.Transport=e.WebSocket,t.TransportType="flash",e.WEB_SOCKET_SWF_LOCATION="https://s3.amazonaws.com/uploadcare-static/WebSocketMainInsecure.swf",WebSocket.__addTask(function(){t.ready()}),WebSocket.__initialize()):(t.Transport=null,t.TransportType="none",t.ready())}}(),s=function(e){var t=function(){n.body?e():setTimeout(t,0)};t()},c=function(){s(l)};o.length>0?a(o,c):c()}(),this.Pusher=t}.call(r),function(){var e,t={}.hasOwnProperty,i=function(e,i){for(var a in i)t.call(i,a)&&(e[a]=i[a]);function r(){this.constructor=e}return r.prototype=i.prototype,e.prototype=new r,e.__super__=i.prototype,e};e=r.jQuery,r.namespace("utils.pusher",function(t){var a,n,o;return n={},r.Pusher.prototype.constructor=r.Pusher,a=function(t){i(a,t);function a(){return o=a.__super__.constructor.apply(this,arguments)}return a.prototype.subscribe=function(e){return this.disconnectTimeout&&(clearTimeout(this.disconnectTimeout),this.disconnectTimeout=null),this.connect(),a.__super__.subscribe.apply(this,arguments)},a.prototype.unsubscribe=function(t){var i=this;return a.__super__.unsubscribe.apply(this,arguments),e.isEmptyObject(this.channels.channels)?this.disconnectTimeout=setTimeout(function(){return i.disconnectTimeout=null,i.disconnect()},5e3):void 0},a}(r.Pusher),t.getPusher=function(e){return null==n[e]&&(n[e]=new a(e)),n[e].connect(),n[e]}})}.call(this),function(){var e,t,i,a=function(e,t){return function(){return e.apply(t,arguments)}},n={}.hasOwnProperty,o=function(e,t){for(var i in t)n.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};e=r.jQuery,i=r.utils,t=r.utils.pusher,r.namespace("files",function(r){var n,l;return r.UrlFile=function(t){o(r,t),r.prototype.sourceName="url",r.prototype.allEvents="progress success error fail";function r(e){var t,n;if(this.__url=e,this.__listenWatcher=a(this.__listenWatcher,this),r.__super__.constructor.apply(this,arguments),n=i.splitUrlRegex.exec(this.__url)[3].split("/").pop())try{this.fileName=decodeURIComponent(n)}catch(o){t=o,this.fileName=n}this.__notifyApi()}return r.prototype.setName=function(e){return this.fileName=e,this.__realFileName=e,this.__notifyApi()},r.prototype.setIsImage=function(e){return this.isImage=e,this.__notifyApi()},r.prototype.__startUpload=function(){var t,a,r,o,s=this;return a=e.Deferred(),o=new l(this.settings),r=new n(this.settings),t={pub_key:this.settings.publicKey,signature:this.settings.secureSignature,expire:this.settings.secureExpire,source_url:this.__url,filename:this.__realFileName||"",source:this.sourceInfo.source,store:this.settings.doNotStore?"":"auto",jsonerrors:1},i.defer(function(){return"pending"===s.apiDeferred.state()?i.jsonp(""+s.settings.urlBase+"/from_url/",t).fail(function(e){return s.settings.debugUploads&&i.debug("Can't start upload from URL.",e,t),a.reject()}).done(function(t){var n;if("pending"===s.apiDeferred.state())return s.settings.debugUploads&&(i.debug("Start watchers.",t.token),n=setInterval(function(){return i.debug("Still watching.",t.token)},5e3),a.done(function(){return i.debug("Stop watchers.",t.token)}).always(function(){return clearInterval(n)})),s.__listenWatcher(a,e([o,r])),a.always(function(){return e([o,r]).off(s.allEvents),o.stopWatching(),r.stopWatching()}),e(o).one(s.allEvents,function(){return r.interval?(s.settings.debugUploads&&i.debug("Start using pusher.",t.token),r.stopWatching()):void 0}),o.watch(t.token),r.watch(t.token)}):void 0}),a},r.prototype.__listenWatcher=function(t,i){var a=this;return i.on("progress",function(e,i){return a.fileSize=i.total,t.notify(i.done/i.total)}).on("success",function(i,r){return e(i.target).trigger("progress",r),a.fileId=r.uuid,a.__handleFileData(r),t.resolve()}).on("error fail",t.reject)},r}(r.BaseFile),l=function(){function i(e){this.settings=e;try{this.pusher=t.getPusher(this.settings.pusherKey)}catch(i){this.pusher=null}}return i.prototype.watch=function(t){var i,a=this;return this.token=t,this.pusher?(i=this.pusher.subscribe("task-status-"+this.token),i.bind_all(function(t,i){return e(a).trigger(t,i)})):void 0},i.prototype.stopWatching=function(){return this.pusher?this.pusher.unsubscribe("task-status-"+this.token):void 0},i}(),n=function(){function t(e){this.settings=e,this.poolUrl=""+this.settings.urlBase+"/from_url/status/"}return t.prototype.watch=function(e){var t,i=this;return this.token=e,(t=function(){return i.interval=setTimeout(function(){return i.__updateStatus().done(function(){return i.interval?t():void 0})},333)})()},t.prototype.stopWatching=function(){return this.interval&&clearTimeout(this.interval),this.interval=null},t.prototype.__updateStatus=function(){var t=this;return i.jsonp(this.poolUrl,{token:this.token}).fail(function(i){return e(t).trigger("error")}).done(function(i){return e(t).trigger(i.status,i)})},t}()})}.call(this),function(){var e,t,i={}.hasOwnProperty,a=function(e,t){for(var a in t)i.call(t,a)&&(e[a]=t[a]);function r(){this.constructor=e}return r.prototype=t.prototype,e.prototype=new r,e.__super__=t.prototype,e};e=r.jQuery,t=r.utils,r.namespace("files",function(e){return e.UploadedFile=function(e){a(i,e),i.prototype.sourceName="uploaded";function i(e){var a;i.__super__.constructor.apply(this,arguments),a=t.splitCdnUrl(e),a?(this.fileId=a[1],a[2]&&(this.cdnUrlModifiers=a[2])):this.__rejectApi("baddata")}return i}(e.BaseFile),e.ReadyFile=function(e){a(t,e),t.prototype.sourceName="uploaded";function t(e){t.__super__.constructor.apply(this,arguments),e?(this.fileId=e.uuid,this.__handleFileData(e)):this.__rejectApi("deleted")}return t}(e.BaseFile)})}.call(this),function(){var e,t,i,a,n,o,l,s=[].slice,c={}.hasOwnProperty,u=function(e,t){for(var i in t)c.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};t=r.namespace,e=r.jQuery,o=r.utils,l=r.locale,a=l.t,i=r.settings,n=r.files,t("files",function(t){return t.FileGroup=function(){function t(t,a){var r=this;this.__uuid=null,this.settings=i.build(a),this.__fileColl=new o.CollectionOfPromises(t),this.__allFilesDf=e.when.apply(e,this.files()),this.__fileInfosDf=function(){var i;return t=function(){var t,a,r,n;for(r=this.files(),n=[],t=0,a=r.length;a>t;t++)i=r[t],n.push(i.then(null,function(t,i){return e.when(i)}));return n}.call(r),e.when.apply(e,t)}(),this.__createGroupDf=e.Deferred(),this.__initApiDeferred()}return t.prototype.files=function(){return this.__fileColl.get()},t.prototype.__save=function(){var e=this;return this.__saved?void 0:(this.__saved=!0,this.__allFilesDf.done(function(){return e.__createGroup().done(function(t){return e.__uuid=t.id,e.__buildInfo(function(t){return e.settings.imagesOnly&&!t.isImage?e.__createGroupDf.reject("image",t):e.__createGroupDf.resolve(t);
	})}).fail(function(){return e.__createGroupDf.reject("createGroup")})}))},t.prototype.promise=function(){return this.__save(),this.__apiDf.promise()},t.prototype.__initApiDeferred=function(){var t,i,a,r=this;return this.__apiDf=e.Deferred(),this.__progressState="uploading",i=function(e){return r.__buildInfo(function(t){return r.__apiDf.reject(e,t)})},a=function(e){return r.__apiDf.resolve(e)},t=function(){return r.__apiDf.notify(r.__progressInfo())},t(),this.__fileColl.onAnyProgress(t),this.__allFilesDf.done(function(){return r.__progressState="uploaded",t()}).fail(i),this.__createGroupDf.done(function(e){return r.__progressState="ready",t(),a(e)}).fail(i)},t.prototype.__progressInfo=function(){var e,t,i,a,r;for(e=0,i=this.__fileColl.lastProgresses(),a=0,r=i.length;r>a;a++)t=i[a],e+=((null!=t?t.progress:void 0)||0)/i.length;return{state:this.__progressState,uploadProgress:e,progress:"ready"===this.__progressState?1:.9*e}},t.prototype.__buildInfo=function(e){var t;return t={uuid:this.__uuid,cdnUrl:this.__uuid?""+this.settings.cdnBase+"/"+this.__uuid+"/":null,name:a("file",this.__fileColl.length()),count:this.__fileColl.length(),size:0,isImage:!0,isStored:!0},this.__fileInfosDf.done(function(){var i,a,r,n;for(i=1<=arguments.length?s.call(arguments,0):[],a=0,n=i.length;n>a;a++)r=i[a],t.size+=r.size,r.isImage||(t.isImage=!1),r.isStored||(t.isStored=!1);return e(t)})},t.prototype.__createGroup=function(){var t,i=this;return t=e.Deferred(),this.__fileColl.length()?this.__fileInfosDf.done(function(){var e,a;return a=1<=arguments.length?s.call(arguments,0):[],o.jsonp(""+i.settings.urlBase+"/group/","POST",{pub_key:i.settings.publicKey,signature:i.settings.secureSignature,expire:i.settings.secureExpire,files:function(){var t,i,r;for(r=[],t=0,i=a.length;i>t;t++)e=a[t],r.push("/"+e.uuid+"/"+(e.cdnUrlModifiers||""));return r}()}).fail(function(e){return i.settings.debugUploads&&o.log("Can't create group.",i.settings.publicKey,e),t.reject()}).done(t.resolve)}):t.reject(),t.promise()},t.prototype.api=function(){return this.__api||(this.__api=o.bindAll(this,["promise","files"])),this.__api},t}(),t.SavedFileGroup=function(e){u(t,e);function t(e,i){var a;this.__data=e,a=r.filesFrom("ready",this.__data.files,i),t.__super__.constructor.call(this,a,i)}return t.prototype.__createGroup=function(){return o.wrapToPromise(this.__data)},t}(t.FileGroup)}),t("",function(t){return t.FileGroup=function(e,t){var i,a,r,l,s,c,u,p;for(null==e&&(e=[]),a=[],l=0,c=e.length;c>l;l++)if(r=e[l],o.isFile(r))a.push(r);else if(o.isFileGroup(r))for(p=r.files(),s=0,u=p.length;u>s;s++)i=p[s],a.push(i);return new n.FileGroup(a,t).api()},t.loadFileGroup=function(t,a){var r,l,s=this;return a=i.build(a),r=e.Deferred(),l=o.groupIdRegex.exec(t),l?o.jsonp(""+a.urlBase+"/group/info/",{jsonerrors:1,pub_key:a.publicKey,group_id:l[0]}).fail(function(e){return a.debugUploads&&o.log("Can't load group info. Probably removed.",l[0],a.publicKey,e),r.reject()}).done(function(e){var t;return t=new n.SavedFileGroup(e,a),r.resolve(t.api())}):r.reject(),r.promise()}}),t("utils",function(t){return t.isFileGroup=function(e){return e&&e.files&&e.promise},t.valueToGroup=function(i,a){var n,o;if(i)if(e.isArray(i))n=function(){var e,r,n;for(n=[],e=0,r=i.length;r>e;e++)o=i[e],n.push(t.valueToFile(o,a));return n}(),i=r.FileGroup(n,a);else if(!t.isFileGroup(i))return r.loadFileGroup(i,a);return t.wrapToPromise(i||null)},t.isFileGroupsEqual=function(e,i){var a,r,n,o,l,s;if(e===i)return!0;if(!t.isFileGroup(e)||!t.isFileGroup(i))return!1;if(r=e.files(),n=i.files(),r.length!==n.length)return!1;for(o=l=0,s=r.length;s>l;o=++l)if(a=r[o],a!==n[o])return!1;return!0}})}.call(this),function(){var e,t,i,a;a=r.utils,e=r.jQuery,t=r.files,i=r.settings,r.namespace("",function(a){var r;return a.fileFrom=function(e,t,i){return a.filesFrom(e,[t],i)[0]},a.filesFrom=function(t,a,n){var o,l,s,c,u;for(n=i.build(n||{}),u=[],s=0,c=a.length;c>s;s++)l=a[s],o=null,e.isArray(l)&&(o=l[1],l=l[0]),u.push(new r[t](l,n,o).promise());return u},r={object:t.ObjectFile,input:t.InputFile,url:t.UrlFile,uploaded:t.UploadedFile,ready:t.ReadyFile}})}.call(this),function(){var e,t,i;i=r.utils,t=r.settings,e=r.jQuery,r.namespace("dragdrop",function(a){return a.support=i.abilities.fileDragAndDrop,a.uploadDrop=function(e,i,n){return n=t.build(n),a.receiveDrop(e,function(e,t){return i(n.multiple?r.filesFrom(e,t,n):r.fileFrom(e,t[0],n))})},a.support?(a.receiveDrop=function(t,i){return a.watchDragging(t),e(t).on({dragover:function(e){return e.preventDefault(),e.originalEvent.dataTransfer.dropEffect="copy"},drop:function(t){var a,r,n,o,l,s;if(t.preventDefault(),a=t.originalEvent.dataTransfer){if(a.files.length)return i("object",a.files);for(n=[],s=a.getData("text/uri-list").split(),o=0,l=s.length;l>o;o++)r=s[o],r=e.trim(r),r&&"#"!==r[0]&&n.push(r);return n?i("url",n):void 0}}})},a.watchDragging=function(t,a){var r,n,o;return o=!1,r=!1,n=function(i){return r!==i?e(t).toggleClass("uploadcare-dragging",r=i):void 0},e(a||t).on({dragenter:function(){return o=i.defer(function(){return o=!1,n(!0)})},dragleave:function(){return o?void 0:n(!1)},"drop mouseenter":function(){return o&&clearTimeout(o),i.defer(function(){return n(!1)})}})},a.watchDragging("body",n)):a.receiveDrop=function(){}})}.call(this),function(){var e,t,i,a,n,o,l=function(e,t){return function(){return e.apply(t,arguments)}},s={}.hasOwnProperty,c=function(e,t){for(var i in t)s.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};i=r.files,e=r.jQuery,n=r.utils,t=n.abilities,o=r.templates,a=o.tpl,r.namespace("ui.progress",function(i){return i.Circle=function(){function e(e){this.update=l(this.update,this),t.canvas?this.renderer=new i.CanvasRenderer(e):this.renderer=new i.TextRenderer(e),this.observed=null}return e.prototype.listen=function(e,t){var i,a=this;return this.reset(),i=null!=t?function(e){return e[t]}:function(e){return e},this.observed=e,"resolved"===this.observed.state()?this.renderer.setValue(1,!0):this.observed.progress(function(t){return e===a.observed?a.renderer.setValue(i(t)):void 0}).always(function(t){return e===a.observed?a.renderer.setValue(1,!1):void 0}),this},e.prototype.reset=function(e){return null==e&&(e=!1),this.observed=null,this.renderer.setValue(e?1:0,!0)},e.prototype.update=function(){return this.renderer.update()},e}(),i.BaseRenderer=function(){function t(t){this.element=e(t),this.element.data("uploadcare-progress-renderer",this),this.element.addClass("uploadcare-widget-circle")}return t.prototype.update=function(){},t}(),i.TextRenderer=function(e){c(t,e);function t(){t.__super__.constructor.apply(this,arguments),this.element.addClass("uploadcare-widget-circle--text"),this.element.html(a("circle-text")),this.text=this.element.find(".uploadcare-widget-circle-text")}return t.prototype.setValue=function(e){return e=Math.round(100*e),this.text.html(""+e+" %")},t}(i.BaseRenderer),i.CanvasRenderer=function(t){c(i,t);function i(){i.__super__.constructor.apply(this,arguments),this.canvasEl=e("<canvas>").get(0),this.element.addClass("uploadcare-widget-circle--canvas"),this.element.html(this.canvasEl),this.setValue(0,!0)}return i.prototype.update=function(){var e,t,i,a;return i=Math.floor(Math.min(this.element.width(),this.element.height())),a=2*i,i?((this.canvasEl.width!==a||this.canvasEl.height!==a)&&(this.canvasEl.width=a,this.canvasEl.height=a),t=this.canvasEl.getContext("2d"),e=function(e,a){var r;return r=-Math.PI/2,t.beginPath(),t.moveTo(i,i),t.arc(i,i,e,r,r+2*Math.PI*a,!1),t.fill()},t.clearRect(0,0,a,a),t.globalCompositeOperation="source-over",t.fillStyle=this.element.css("border-left-color"),e(i-.5,1),t.fillStyle=this.element.css("color"),e(i,this.val),t.globalCompositeOperation="destination-out",e(i/7,1)):void 0},i.prototype.__animateValue=function(e){var t,i,a,r=this;return a=this.val,i=new Date,t=e>a?2:-2,this.__animIntervalId=setInterval(function(){var n;return n=a+(new Date-i)/1e3*t,n=(t>0?Math.min:Math.max)(n,e),n===e&&r.__stopAnimation(),r.__setValue(n)},15)},i.prototype.__stopAnimation=function(){return this.__animIntervalId&&clearInterval(this.__animIntervalId),this.__animIntervalId=null},i.prototype.__setValue=function(e){
	return this.val=e,this.update()},i.prototype.setValue=function(e,t){return null==t&&(t=!1),this.__stopAnimation(),t?this.__setValue(e):this.__animateValue(e)},i}(i.BaseRenderer)})}.call(this),function(){var e,t,i,a,n,o,l,s;e=r.jQuery,n=r.utils,o=r.ui,t=o.progress,l=r.locale,i=l.t,s=r.templates,a=s.tpl,r.namespace("widget",function(r){return r.Template=function(){function r(i,r){this.settings=i,this.element=r,this.content=e(a("widget")),this.element.after(this.content),this.circle=new t.Circle(this.content.find(".uploadcare-widget-status")),this.statusText=this.content.find(".uploadcare-widget-text"),this.content.toggleClass("uploadcare-widget-option-clearable",this.settings.clearable)}return r.prototype.addButton=function(t,i){return null==i&&(i=""),e(a("widget-button",{name:t,caption:i})).appendTo(this.content)},r.prototype.setStatus=function(e){var t;return t="uploadcare-widget-status-",this.content.removeClass(t+this.content.attr("data-status")),this.content.attr("data-status",e),this.content.addClass(t+e),this.element.trigger(""+e+".uploadcare")},r.prototype.reset=function(){return this.circle.reset(),this.setStatus("ready"),this.__file=null},r.prototype.loaded=function(){return this.setStatus("loaded"),this.circle.reset(!0)},r.prototype.listen=function(e){var t=this;return this.__file=e,this.circle.listen(e,"uploadProgress"),this.setStatus("started"),e.progress(function(a){if(e===t.__file)switch(a.state){case"uploading":return t.statusText.text(i("uploading"));case"uploaded":return t.statusText.text(i("loadingInfo"))}})},r.prototype.error=function(e){return this.statusText.text(i("errors."+(e||"default"))),this.setStatus("error")},r.prototype.setFileInfo=function(e){return this.statusText.html(a("widget-file-name",e)).find(".uploadcare-widget-file-name").toggleClass("needsclick",this.settings.systemDialog)},r}()})}.call(this),function(){var e,t,i,a,n,o,l,s=function(e,t){return function(){return e.apply(t,arguments)}};n=r.utils,t=r.dragdrop,o=r.locale,i=o.t,e=r.jQuery,l=r.templates,a=l.tpl,r.namespace("widget.tabs",function(r){return r.FileTab=function(){function r(t,i,r,n,o){var l=this;this.container=t,this.tabButton=i,this.dialogApi=r,this.settings=n,this.name=o,this.__updateTabsList=s(this.__updateTabsList,this),this.container.append(a("tab-file")),this.container.addClass("uploadcare-dialog-padding"),this.container.on("click",".uploadcare-dialog-file-source",function(t){return l.dialogApi.switchTab(e(t.target).data("tab"))}),this.__setupFileButton(),this.__initDragNDrop(),this.__updateTabsList(),this.dialogApi.onTabVisibility(this.__updateTabsList)}return r.prototype.__initDragNDrop=function(){var e,i=this;return e=this.container.find(".uploadcare-dialog-file-drop-area"),n.abilities.fileDragAndDrop?(t.receiveDrop(e,function(e,t){return i.dialogApi.addFiles(e,t),i.dialogApi.switchTab("preview")}),this.container.addClass("uploadcare-draganddrop")):void 0},r.prototype.__setupFileButton=function(){var e,t=this;return e=this.container.find(".uploadcare-dialog-big-button"),n.abilities.sendFileAPI?e.on("click",function(){return n.fileSelectDialog(t.container,t.settings,function(e){return t.dialogApi.addFiles("object",e.files),t.dialogApi.switchTab("preview")}),!1}):n.fileInput(e,this.settings,function(e){return t.dialogApi.addFiles("input",[e]),t.dialogApi.switchTab("preview")})},r.prototype.__updateTabsList=function(){var t,a,r,n,o,l;for(t=this.container.find(".uploadcare-dialog-file-sources").empty(),a=0,l=this.settings.tabs,n=0,o=l.length;o>n;n++)r=l[n],r!==this.name&&this.dialogApi.isTabVisible(r)&&(a+=1,t.append([e("<div/>",{"class":"uploadcare-dialog-file-source","data-tab":r,html:i("dialog.tabs.names."+r)})," "]));return t.toggleClass("uploadcare-hidden",0===a),this.container.find(".uploadcare-dialog-file-source-or").toggleClass("uploadcare-hidden",0===a)},r}()})}.call(this),function(){var e,t,i,a;e=r.jQuery,a=r.templates,i=a.tpl,t=r.locale.t,r.namespace("widget.tabs",function(t){return t.UrlTab=function(){var t,a;a=/^[a-z][a-z0-9+\-.]*:?\/\//,t=function(t){return t=e.trim(t),a.test(t)?t:"http://"+t};function r(a,r,n,o,l){var s,c,u=this;this.container=a,this.tabButton=r,this.dialogApi=n,this.settings=o,this.name=l,this.container.append(i("tab-url")),this.container.addClass("uploadcare-dialog-padding"),c=this.container.find(".uploadcare-dialog-input"),c.on("change keyup input",function(){return s.prop("disabled",!e.trim(this.value))}),s=this.container.find(".uploadcare-dialog-url-submit").prop("disabled",!0),this.container.find(".uploadcare-dialog-url-form").on("submit",function(){var e;return(e=t(c.val()))&&(u.dialogApi.addFiles("url",[[e,{source:"url-tab"}]]),c.val("")),!1})}return r}()})}.call(this),function(){var t,i,a,o,l=function(e,t){return function(){return e.apply(t,arguments)}};a=r.utils,t=r.jQuery,o=r.templates,i=o.tpl,r.namespace("widget.tabs",function(r){var o;return o="https:"===n.location.protocol,r.CameraTab=function(){function r(e,t,a,r,n){var s,c=this;return this.container=e,this.tabButton=t,this.dialogApi=a,this.settings=r,this.name=n,this.__cancelRecording=l(this.__cancelRecording,this),this.__stopRecording=l(this.__stopRecording,this),this.__startRecording=l(this.__startRecording,this),this.__capture=l(this.__capture,this),this.__mirror=l(this.__mirror,this),this.__revoke=l(this.__revoke,this),this.__requestCamera=l(this.__requestCamera,this),this.__setState=l(this.__setState,this),this.__checkCompatibility()?(this.__loaded=!1,this.mirrored=!0,this.container.append(i("tab-camera")),this.container.addClass("uploadcare-dialog-padding uploadcare-dialog-camera-requested"),this.container.find(".uploadcare-dialog-camera-capture").on("click",this.__capture),s=this.container.find(".uploadcare-dialog-camera-start-record").on("click",this.__startRecording),this.container.find(".uploadcare-dialog-camera-stop-record").on("click",this.__stopRecording),this.container.find(".uploadcare-dialog-camera-cancel-record").on("click",this.__cancelRecording),this.container.find(".uploadcare-dialog-camera-mirror").on("click",this.__mirror),this.container.find(".uploadcare-dialog-camera-retry").on("click",this.__requestCamera),(!this.MediaRecorder||this.settings.imagesOnly)&&s.hide(),this.video=this.container.find("video"),this.video.on("loadeddata",function(){return this.play()}),this.dialogApi.progress(function(e){if(e===c.name){if(!c.__loaded)return c.__requestCamera()}else if(c.__loaded&&o)return c.__revoke()}),void this.dialogApi.always(this.__revoke)):void this.dialogApi.hideTab(this.name)}return r.prototype.__checkCompatibility=function(){var t;return this.getUserMedia=navigator.getUserMedia||navigator.webkitGetUserMedia||navigator.mozGetUserMedia,this.URL=e.URL||e.webkitURL,this.MediaRecorder=e.MediaRecorder,o||a.warn("Camera is not allowed for HTTP. Please use HTTPS connection."),t="localhost"===n.location.hostname,!!this.getUserMedia&&Uint8Array&&(o||t)},r.prototype.__setState=function(e){var t;return t=["","ready","requested","denied","not-founded","recording"].join(" uploadcare-dialog-camera-"),this.container.removeClass(t).addClass("uploadcare-dialog-camera-"+e)},r.prototype.__requestCamera=function(){var e=this;return this.__loaded=!0,this.getUserMedia.call(navigator,{audio:!0,video:{optional:[{minWidth:320},{minWidth:640},{minWidth:1024},{minWidth:1280},{minWidth:1920}]}},function(t){return e.__setState("ready"),e.__stream=t,e.URL?e.video.prop("src",e.URL.createObjectURL(t)):e.video.prop("src",t),e.video[0].volume=0,e.video[0].play()},function(t){return"NO_DEVICES_FOUND"===t||"DevicesNotFoundError"===t.name?e.__setState("not-founded"):e.__setState("denied"),e.__loaded=!1})},r.prototype.__revoke=function(){var e;return this.__setState("requested"),this.__loaded=!1,this.__stream?(this.URL&&this.URL.revokeObjectURL(this.video.prop("src")),this.__stream.getTracks&&t.each(this.__stream.getTracks(),function(){return"function"==typeof this.stop?this.stop():void 0}),"function"==typeof(e=this.__stream).stop&&e.stop(),this.__stream=null):void 0},r.prototype.__mirror=function(){return this.mirrored=!this.mirrored,this.video.toggleClass("uploadcare-dialog-camera--mirrored",this.mirrored)},r.prototype.__capture=function(){var e,t,i,r,o,l=this;
	return r=this.video[0],o=r.videoWidth,i=r.videoHeight,e=n.createElement("canvas"),e.width=o,e.height=i,t=e.getContext("2d"),this.mirrored&&(t.translate(o,0),t.scale(-1,1)),t.drawImage(r,0,0,o,i),a.canvasToBlob(e,"image/jpeg",.9,function(t){return e.width=e.height=1,t.name="camera.jpg",l.dialogApi.addFiles("object",[[t,{source:"camera"}]]),l.dialogApi.switchTab("preview")})},r.prototype.__startRecording=function(){var e=this;return this.__setState("recording"),this.__chunks=[],this.__recorder=new this.MediaRecorder(this.__stream),this.__recorder.start(),this.__recorder.ondataavailable=function(t){return e.__chunks.push(t.data)}},r.prototype.__stopRecording=function(){var e=this;return this.__setState("ready"),this.__recorder.onstop=function(){var t,i;return i=e.__recorder.mimeType,i=i?i.split("/")[1]:"webm",t=new Blob(e.__chunks,{type:"video/"+i}),t.name="record."+i,e.dialogApi.addFiles("object",[[t,{source:"camera"}]]),e.dialogApi.switchTab("preview"),e.__chunks=[]},this.__recorder.stop()},r.prototype.__cancelRecording=function(){return this.__setState("ready"),this.__recorder.stop(),this.__chunks=[]},r}()})}.call(this),function(){var t,i,a,n,o,l,s,c=function(e,t){return function(){return e.apply(t,arguments)}};a=r.locale,l=r.utils,o=r.tabsCss,t=r.jQuery,s=r.locale,n=s.t,i=r.files,r.namespace("widget.tabs",function(a){return a.RemoteTab=function(){function a(e,t,i,a,r){var n=this;this.container=e,this.tabButton=t,this.dialogApi=i,this.settings=a,this.name=r,this.__createIframe=c(this.__createIframe,this),this.container.addClass("uploadcare-dialog-remote-iframe-wrap"),this.dialogApi.progress(function(e){return e===n.name&&n.__createIframe(),n.__sendMessage({type:"visibility-changed",visible:e===n.name})})}return a.prototype.remoteUrl=function(){return""+this.settings.socialBase+"/window/"+this.name+"?"+t.param({lang:this.settings.locale,public_key:this.settings.publicKey,widget_version:r.version,images_only:this.settings.imagesOnly,pass_window_open:this.settings.passWindowOpen})},a.prototype.__sendMessage=function(e){var t,i;return null!=(t=this.iframe)&&null!=(i=t[0].contentWindow)?i.postMessage(JSON.stringify(e),"*"):void 0},a.prototype.__createIframe=function(){var a,r=this;if(!this.iframe)return this.iframe=t("<iframe>",{src:this.remoteUrl(),marginheight:0,marginwidth:0,frameborder:0,allowTransparency:"true"}).addClass("uploadcare-dialog-remote-iframe").appendTo(this.container).on("load",function(){var e,t,i,a,n,l,s,c;for(r.iframe.css("opacity","1"),s=o.urls,i=0,n=s.length;n>i;i++)t=s[i],r.__sendMessage({type:"embed-css",url:t});for(c=o.styles,a=0,l=c.length;l>a;a++)e=c[a],r.__sendMessage({type:"embed-css",style:e})}),a=this.iframe[0].contentWindow,l.registerMessage("file-selected",a,function(e){var a,n,o;return o=function(){var t,i,a,n,o;if(e.alternatives)for(o=r.settings.preferredTypes,a=0,n=o.length;n>a;a++){i=o[a],i=l.globRegexp(i);for(t in e.alternatives)if(i.test(t))return e.alternatives[t]}return e.url}(),n=t.extend({source:r.name},e.info||{}),a=new i.UrlFile(o,r.settings,n),e.filename&&a.setName(e.filename),null!=e.is_image&&a.setIsImage(e.is_image),r.dialogApi.addFiles([a.promise()])}),l.registerMessage("open-new-window",a,function(t){var i,a,n;return r.settings.debugUploads&&l.debug("Open new window message.",r.name),(a=e.open(t.url,"_blank"))?(n=function(){return r.settings.debugUploads&&l.debug("Window is closed.",r.name),r.__sendMessage({type:"navigate",fragment:""})},"closed"in a?i=setInterval(function(){return a.closed?(clearInterval(i),n()):void 0},100):a.addEventListener("exit",n)):void l.warn("Can't open new window. Possible blocked.",r.name)}),this.dialogApi.done(function(){return l.unregisterMessage("file-selected",a),l.unregisterMessage("open-new-window",a)})},a}()})}.call(this),function(){var e,t,i,a;i=r.ui,a=i.progress,t=a.Circle,e=r.jQuery,r.namespace("widget.tabs",function(i){return i.BasePreviewTab=function(){var i;i=".uploadcare-dialog-preview-";function a(e,t,a,r,n){var o,l=this;this.container=e,this.tabButton=t,this.dialogApi=a,this.settings=r,this.name=n,this.__initTabButtonCircle(),o=":not(.uploadcare-disabled-el)",this.container.on("click",i+"back"+o,function(){return l.dialogApi.fileColl.clear()}),this.container.on("click",i+"done"+o,this.dialogApi.resolve)}return a.prototype.__initTabButtonCircle=function(){var i,a,r,n,o=this;return r=e('<div class="uploadcare-dialog-icon">').appendTo(this.tabButton),a=e.Deferred(),n=function(){var e,t,i,r,n;for(e=o.dialogApi.fileColl.lastProgresses(),t=0,r=0,n=e.length;n>r;r++)i=e[r],t+=((null!=i?i.progress:void 0)||0)/e.length;return a.notify(t)},this.dialogApi.fileColl.onAnyProgress(n),this.dialogApi.fileColl.onAdd.add(n),this.dialogApi.fileColl.onRemove.add(n),n(),i=new t(r).listen(a.promise()),this.dialogApi.progress(i.update)},a}()})}.call(this),function(){var e,t,i,a,n,o,l,s,c,u,p,d,g,h=function(e,t){return function(){return e.apply(t,arguments)}},f={}.hasOwnProperty,m=function(e,t){for(var i in t)f.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};l=r.utils,s=r.utils,c=s.abilities,i=c.URL,u=r.ui,a=u.progress,p=r.templates,o=p.tpl,e=r.jQuery,d=r.crop,t=d.CropWidget,g=r.locale,n=g.t,r.namespace("widget.tabs",function(a){return a.PreviewTab=function(a){m(r,a);function r(){this.__tryToLoadVideoPreview=h(this.__tryToLoadVideoPreview,this),this.__tryToLoadImagePreview=h(this.__tryToLoadImagePreview,this),this.__setFile=h(this.__setFile,this);var t=this;r.__super__.constructor.apply(this,arguments),e.each(this.dialogApi.fileColl.get(),function(e,i){return t.__setFile(i)}),this.dialogApi.fileColl.onAdd.add(this.__setFile),this.widget=null,this.__state=null}return r.prototype.__setFile=function(e){var t,i,a,r=this;return this.file=e,t=function(t){return function(){return e===r.file?t.apply(null,arguments):void 0}},i=l.once(this.__tryToLoadImagePreview),a=l.once(this.__tryToLoadVideoPreview),this.__setState("unknown",{}),this.file.progress(t(function(t){var n,o,s;return t=t.incompleteFileInfo,o=(t.name||"")+l.readableFileSize(t.size,"",", "),r.element("label").text(o),s=t.sourceInfo,n=l.abilities.Blob,s.file&&n&&s.file instanceof n?i(e,s.file).fail(function(){return a(e,s.file)}):void 0})),this.file.done(t(function(e){var t,i;if("video"!==r.__state)return e.isImage?"image"!==r.__state?(i=e.originalUrl,i+="-/preview/1162x693/-/setfill/efefef/-/format/jpeg/-/progressive/yes/",t=e.originalImageInfo,r.__setState("image",{src:i,name:e.name}),r.initImage([t.width,t.height],e.cdnUrlModifiers)):void 0:r.__setState("regular",{file:e})})),this.file.fail(t(function(e,t){return r.__setState("error",{error:e,file:t})}))},r.prototype.__tryToLoadImagePreview=function(t,a){var r,n=this;return r=e.Deferred(),"pending"!==t.state()||!a.size||a.size>=this.settings.multipartMinSize?r.reject().promise():(l.image.drawFileToCanvas(a,1550,924,"#efefef",this.settings.imagePreviewMaxSize).done(function(e,a){return l.canvasToBlob(e,"image/jpeg",.95,function(o){var l;return r.resolve(),e.width=e.height=1,"pending"===t.state()&&"pending"===n.dialogApi.state()&&n.file===t?(l=i.createObjectURL(o),n.dialogApi.always(function(){return i.revokeObjectURL(l)}),"image"!==n.__state?(n.__setState("image",{src:l,name:""}),n.initImage(a)):void 0):void 0})}).fail(r.reject),r.promise())},r.prototype.__tryToLoadVideoPreview=function(t,a){var r,n,o,s=this;return r=e.Deferred(),i&&a.size?(o=i.createObjectURL(a),n=l.videoLoader(o),n.fail(function(){return i.revokeObjectURL(o),r.reject()}).done(function(){return r.resolve(),s.dialogApi.always(function(){return i.revokeObjectURL(o)}),s.__setState("video"),s.element("video").attr("src",o)}),r.promise()):r.reject().promise()},r.prototype.element=function(e){return this.container.find(".uploadcare-dialog-preview-"+e)},r.prototype.__setState=function(e,t){return this.__state=e,this.container.empty().append(o("tab-preview-"+e,t)),"unknown"===e&&this.settings.crop?this.element("done").hide():void 0},r.prototype.initImage=function(e,i){var a,r,o,s,c=this;return r=this.element("image"),a=this.element("done"),o=l.imageLoader(r[0]).done(function(){return c.element("root").addClass("uploadcare-dialog-preview--loaded");
	}).fail(function(){return c.file=null,c.__setState("error",{error:"loadImage"})}),s=function(){return a.removeClass("uploadcare-disabled-el"),c.widget=new t(r,e,c.settings.crop[0]),i&&c.widget.setSelectionFromModifiers(i),a.on("click",function(){var e;return e=c.widget.applySelectionToFile(c.file),c.dialogApi.fileColl.replace(c.file,e),!0})},this.settings.crop?(this.element("title").text(n("dialog.tabs.preview.crop.title")),a.addClass("uploadcare-disabled-el"),a.text(n("dialog.tabs.preview.crop.done")),this.populateCropSizes(),o.done(function(){return l.defer(s)})):void 0},r.prototype.populateCropSizes=function(){var t,i,a,r=this;if(!(this.settings.crop.length<=1))return this.element("root").addClass("uploadcare-dialog-preview--with-sizes"),t=this.element("crop-sizes"),a=t.children(),i="uploadcare-crop-size--current",e.each(this.settings.crop,function(e,o){var s,c,u,p,d;return p=o.preferedSize,p?(c=l.gcd(p[0],p[1]),s=""+p[0]/c+":"+p[1]/c):s=n("dialog.tabs.preview.crop.free"),u=a.clone().appendTo(t).attr("data-caption",s).on("click",function(e){return r.widget?(r.widget.setCrop(o),t.find(">*").removeClass(i),u.addClass(i)):void 0}),p?(d=l.fitSize(p,[40,40],!0),u.children().css({width:Math.max(20,d[0]),height:Math.max(12,d[1])})):void 0}),a.remove(),t.find(">*").eq(0).addClass(i)},r}(a.BasePreviewTab)})}.call(this),function(e){function t(e){this.targets=e,this.last=null,this.update()}t.prototype={update:function(){var t={};this.targets.each(function(i){var a=e(this).offset();a.top in t||(t[a.top]=[]),t[a.top].push([a.left+this.offsetWidth/2,this])}),this.rows=t},find:function(e,t){var i=1/0,a=this.rows,r,n,o;for(n in a){var l=Math.abs(n-t);i>l&&(i=l,r=a[n])}i=Math.abs(r[0][0]-e),o=r[0][1];for(var s=1;s<r.length;s++){var l=Math.abs(r[s][0]-e);i>l&&(i=l,o=r[s][1])}return o},findNotLast:function(e,t){var i=this.find(e,t);return this.last&&i&&this.last==i?null:this.last=i}};var i="uploadcareMovable",a="uploadcareSortable",r={};r[i]=function(t){t=e.extend({distance:4,anyButton:!1,axis:!1,zIndex:1e3,start:e.noop,move:e.noop,finish:e.noop,items:null,keepFake:!1,touch:!0},t);function a(e){if(t.touch){var i,a;if(a=e.originalEvent.touches,a&&a.length)i=a[0];else{if(a=e.originalEvent.changedTouches,!a||!a.length)return;i=a[0]}e.pageX=i.pageX,e.pageY=i.pageY,e.which=1}}var r="mousedown.{} touchstart.{}".replace(/\{}/g,i);this.on(r,t.items,null,function(r){if(a(r),t.anyButton||1==r.which){r.preventDefault();var o=!1,l=e(this),s=!1,c=l.position();c.top+=l.offsetParent().scrollTop(),c.left+=l.offsetParent().scrollLeft();var u="mousemove.{} touchmove.{}".replace(/\{}/g,i);e(n).on(u,function(e){if(a(e),!o&&(Math.abs(e.pageX-r.pageX)>t.distance||Math.abs(e.pageY-r.pageY)>t.distance)&&(o=!0,s=l.clone().css({position:"absolute",zIndex:t.zIndex,width:l.width()}).appendTo(l.offsetParent()),t.start({event:e,dragged:l,fake:s})),o){e.preventDefault();var i="y"==t.axis?0:e.pageX-r.pageX,n="x"==t.axis?0:e.pageY-r.pageY;s.css({left:i+c.left,top:n+c.top}),t.move({event:e,dragged:l,fake:s,dx:i,dy:n})}});var u="mouseup.{} touchend.{} touchcancel.{} touchleave.{}";e(n).on(u.replace(/\{}/g,i),function(c){a(c);var u="mousemove.{} touchmove.{} mouseup.{} touchend.{} touchcancel.{} touchleave.{}";if(e(n).off(u.replace(/\{}/g,i)),o){c.preventDefault();var p=c.pageX-r.pageX,d=c.pageY-r.pageY;o=!1,t.finish({event:c,dragged:l,fake:s,dx:p,dy:d}),t.keepFake||s.remove()}})}})},r[a]=function(a){var r=e.extend({items:">*"},a),a=e.extend({checkBounds:function(){return!0},start:e.noop,attach:e.noop,move:e.noop,finish:e.noop},a),n,o=!1,l=this;return r.start=function(e){a.start(e),n=new t(l.find(r.items).not(e.fake)),o=e.dragged.next()},r.move=function(t){if(t.nearest=null,a.checkBounds(t)){var i=t.fake.offset(),r=n.findNotLast(i.left+t.dragged.width()/2,i.top);t.nearest=e(r),r&&r!=t.dragged[0]&&(t.dragged.nextAll().filter(r).length>0?t.dragged.insertAfter(r):t.dragged.insertBefore(r),a.attach(t),n.last=null,n.update())}else null!==n.last&&(n.last=null,o.length?t.dragged.insertBefore(o):t.dragged.parent().append(t.dragged),a.attach(t),n.update());a.move(t)},r.finish=function(t){var i=t.fake.offset();t.nearest=null,a.checkBounds(t)&&(t.nearest=e(n.find(i.left+t.dragged.width()/2,i.top))),a.finish(t),n=null},this[i](r)},e.fn.extend(r)}(r.jQuery),function(){var e,t,i,a,n,o,l,s,c=function(e,t){return function(){return e.apply(t,arguments)}},u={}.hasOwnProperty,p=function(e,t){for(var i in t)u.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};n=r.utils,o=r.ui,t=o.progress,l=r.templates,a=l.tpl,e=r.jQuery,s=r.locale,i=s.t,r.namespace("widget.tabs",function(t){return t.PreviewTabMultiple=function(t){p(o,t);function o(){this.__fileReplaced=c(this.__fileReplaced,this),this.__fileRemoved=c(this.__fileRemoved,this),this.__fileAdded=c(this.__fileAdded,this),this.__fileFailed=c(this.__fileFailed,this),this.__fileDone=c(this.__fileDone,this),this.__fileProgress=c(this.__fileProgress,this),this.__updateContainerView=c(this.__updateContainerView,this);var t=this;o.__super__.constructor.apply(this,arguments),this.container.append(a("tab-preview-multiple")),this.__fileTpl=e(a("tab-preview-multiple-file")),this.fileListEl=this.container.find(".uploadcare-file-list"),this.titleEl=this.__find("title"),this.mobileTitleEl=this.__find("mobile-title"),this.footerTextEl=this.__find("footer-text"),this.doneBtnEl=this.container.find(".uploadcare-dialog-preview-done"),e.each(this.dialogApi.fileColl.get(),function(e,i){return t.__fileAdded(i)}),this.__updateContainerView(),this.dialogApi.fileColl.onAdd.add(this.__fileAdded,this.__updateContainerView),this.dialogApi.fileColl.onRemove.add(this.__fileRemoved,this.__updateContainerView),this.dialogApi.fileColl.onReplace.add(this.__fileReplaced,this.__updateContainerView),this.dialogApi.fileColl.onAnyProgress(this.__fileProgress),this.dialogApi.fileColl.onAnyDone(this.__fileDone),this.dialogApi.fileColl.onAnyFail(this.__fileFailed),this.fileListEl.addClass(this.settings.imagesOnly?"uploadcare-file-list_tiles":"uploadcare-file-list_table"),this.__setupSorting()}return o.prototype.__setupSorting=function(){var e=this;return this.fileListEl.uploadcareSortable({touch:!1,axis:this.settings.imagesOnly?"xy":"y",start:function(e){return e.dragged.css("visibility","hidden")},finish:function(t){var i,a;return t.dragged.css("visibility","visible"),i=e.container.find(".uploadcare-file-item"),a=function(t){return i.index(e.__fileToEl(t))},e.dialogApi.fileColl.sort(function(e,t){return a(e)-a(t)})}})},o.prototype.__find=function(t,i){return null==i&&(i=this.container),e(".uploadcare-dpm-"+t,i)},o.prototype.__updateContainerView=function(){var e,t,a,r,n;return e=this.dialogApi.fileColl.length(),n=0!==this.settings.multipleMax&&e>this.settings.multipleMax,r=e<this.settings.multipleMin,this.doneBtnEl.toggleClass("uploadcare-disabled-el",n||r),a=i("dialog.tabs.preview.multiple.title").replace("%files%",i("file",e)),this.titleEl.text(a),t=n?i("dialog.tabs.preview.multiple.tooManyFiles").replace("%max%",this.settings.multipleMax):e&&r?i("dialog.tabs.preview.multiple.tooFewFiles").replace("%min%",this.settings.multipleMin).replace("%files%",i("file",e)):i("dialog.tabs.preview.multiple.question"),this.footerTextEl.toggleClass("uploadcare-error",n||r).text(t),this.mobileTitleEl.toggleClass("uploadcare-error",n||r).text(n||r?t:a)},o.prototype.__updateFileInfo=function(e,t){return e.find(".uploadcare-file-item__name").text(t.name||i("dialog.tabs.preview.unknownName")),e.find(".uploadcare-file-item__size").text(n.readableFileSize(t.size,"–"))},o.prototype.__fileProgress=function(e,t){var i;return i=this.__fileToEl(e),i.find(".uploadcare-progressbar__value").css("width",Math.round(100*t.progress)+"%"),this.__updateFileInfo(i,t.incompleteFileInfo)},o.prototype.__fileDone=function(t,i){var a,n,o=this;return n=this.__fileToEl(t).removeClass("uploadcare-file-item_uploading").addClass("uploadcare-file-item_uploaded"),n.find(".uploadcare-progressbar__value").css("width","100%"),this.__updateFileInfo(n,i),i.isImage?(a=""+i.cdnUrl+"-/quality/lightest/"+(this.settings.imagesOnly?"-/preview/340x340/":"-/scale_crop/110x110/center/"),
	n.find(".uploadcare-file-item__preview").addClass("uploadcare-zoomable-icon").html(e("<img>").attr("src",a)).on("click",function(){return r.openPreviewDialog(t,o.settings).done(function(e){return o.dialogApi.fileColl.replace(t,e)})})):void 0},o.prototype.__fileFailed=function(e,t,a){return this.__fileToEl(e).removeClass("uploadcare-file-item_uploading").addClass("uploadcare-file-item_error").find(".uploadcare-file-item__error").text(i("errors."+t))},o.prototype.__fileAdded=function(e){var t;return t=this.__createFileEl(e),t.appendTo(this.fileListEl)},o.prototype.__fileRemoved=function(t){return this.__fileToEl(t).remove(),e(t).removeData()},o.prototype.__fileReplaced=function(e,t){var i;return i=this.__createFileEl(t),i.insertAfter(this.__fileToEl(e)),this.__fileRemoved(e)},o.prototype.__fileToEl=function(t){return e(t).data("dpm-el")||e()},o.prototype.__createFileEl=function(t){var i,a=this;return i=this.__fileTpl.clone().on("click",".uploadcare-remove",function(){return a.dialogApi.fileColl.remove(t)}),e(t).data("dpm-el",i),i},o}(t.BasePreviewTab)})}.call(this),function(){var t,i,a,o,l,s,c,u,p,d,g=function(e,t){return function(){return e.apply(t,arguments)}};c=r.utils,u=r.locale,o=u.t,p=r.templates,s=p.tpl,i=r.files,d=r.widget,l=d.tabs,a=r.settings,t=r.jQuery,r.namespace("",function(u){var p,d,h,f,m,_=this;return h=function(e,t){var i,a;return a=e.scrollTop(),i=e.scrollLeft(),t&&e.scrollTop(0).scrollLeft(0),function(){return e.scrollTop(a).scrollLeft(i)}},t(e).on("keydown",function(e){return u.isDialogOpened()&&27===e.which?(e.stopImmediatePropagation(),"undefined"!=typeof d&&null!==d?d.reject():void 0):void 0}),d=null,f="uploadcare-dialog-opened",u.isDialogOpened=function(){return null!==d},u.closeDialog=function(){var e;e=[];while(d)e.push(d.reject());return e},u.openDialog=function(i,a,r){var o,l,c;return u.closeDialog(),l=t(s("dialog")).appendTo("body"),c=u.openPanel(l.find(".uploadcare-dialog-placeholder"),i,a,r),l.addClass("uploadcare-active"),c.dialogElement=l,o=h(t(e),"absolute"===l.css("position")),t("html, body").addClass(f),l.on("click",".uploadcare-dialog-close",c.reject),l.on("dblclick",function(e){var i;if(t.contains(n.documentElement,e.target)&&(i=".uploadcare-dialog-panel, a",!t(e.target).is(i)&&!t(e.target).parents(i).length))return c.reject()}),d=c.always(function(){return t("html, body").removeClass(f),d=null,l.remove(),o()})},u.openPreviewDialog=function(e,i){var a,n,o=this;return n=d,d=null,i=t.extend({},i,{multiple:!1,tabs:""}),a=r.openDialog(e,"preview",i),n.dialogElement.addClass("uploadcare-inactive"),a.always(function(){return d=n,t("html, body").addClass(f),n.dialogElement.removeClass("uploadcare-inactive")}),a.onTabVisibility(function(e,t){return"preview"!==e||t?void 0:a.reject()}),a},u.openPanel=function(e,i,n,o){var l,s;return t.isPlainObject(n)&&(o=n,n=null),i?c.isFileGroup(i)?i=i.files():t.isArray(i)||(i=[i]):i=[],o=a.build(o),s=new p(o,e,i,n).publicPromise(),l=function(e){return o.multiple?r.FileGroup(e,o):e[0]},c.then(s,l,l).promise(s)},m={},u.registerTab=function(e,t){return m[e]=t},u.registerTab("file",l.FileTab),u.registerTab("url",l.UrlTab),u.registerTab("camera",l.CameraTab),u.registerTab("facebook",l.RemoteTab),u.registerTab("dropbox",l.RemoteTab),u.registerTab("gdrive",l.RemoteTab),u.registerTab("gphotos",l.RemoteTab),u.registerTab("instagram",l.RemoteTab),u.registerTab("flickr",l.RemoteTab),u.registerTab("vk",l.RemoteTab),u.registerTab("evernote",l.RemoteTab),u.registerTab("box",l.RemoteTab),u.registerTab("skydrive",l.RemoteTab),u.registerTab("huddle",l.RemoteTab),u.registerTab("empty-pubkey",function(e,t,i,a){return e.append(a._emptyKeyText)}),u.registerTab("preview",function(e,t,i,a,r){var n;return new(n=a.multiple?l.PreviewTabMultiple:l.PreviewTab)(e,t,i,a,r)}),p=function(){var e;e="uploadcare-dialog-tab";function a(i,a,r,n){var o,l=this;this.settings=i,this.isTabVisible=g(this.isTabVisible,this),this.hideTab=g(this.hideTab,this),this.showTab=g(this.showTab,this),this.switchTab=g(this.switchTab,this),this.__closePanel=g(this.__closePanel,this),this.__updateFooter=g(this.__updateFooter,this),this.__reject=g(this.__reject,this),this.__resolve=g(this.__resolve,this),this.addFiles=g(this.addFiles,this),this.dfd=t.Deferred(),this.dfd.always(this.__closePanel),o=".uploadcare-dialog-panel",this.content=t(s("panel")),this.panel=this.content.find(o).add(this.content.filter(o)),this.placeholder=t(a),this.placeholder.replaceWith(this.content),this.settings.multiple&&this.panel.addClass("uploadcare-dialog-multiple"),this.files=new c.CollectionOfPromises(r),this.files.onRemove.add(function(){return 0===l.files.length()?l.hideTab("preview"):void 0}),this.__autoCrop(this.files),this.tabs={},this.__prepareFooter(),this.onTabVisibility=t.Callbacks().add(function(t,i){return l.panel.find("."+e+"-"+t).toggleClass(""+e+"_hidden",!i)}),this.settings.publicKey?this.__prepareTabs(n):this.__welcome()}return a.prototype.publicPromise=function(){return this.promise||(this.promise=this.dfd.promise({reject:this.__reject,resolve:this.__resolve,fileColl:this.files,addFiles:this.addFiles,switchTab:this.switchTab,hideTab:this.hideTab,showTab:this.showTab,isTabVisible:this.isTabVisible,onTabVisibility:c.publicCallbacks(this.onTabVisibility)})),this.promise},a.prototype.addFiles=function(e,t){var i,a,r;for(t&&(e=u.filesFrom(e,t,this.settings)),this.settings.multiple||this.files.clear(),a=0,r=e.length;r>a;a++)i=e[a],this.settings.multipleMaxStrict&&0!==this.settings.multipleMax&&this.files.length()>=this.settings.multipleMax?i.cancel():this.files.add(i);return this.settings.previewStep?(this.showTab("preview"),this.settings.multiple?void 0:this.switchTab("preview")):this.__resolve()},a.prototype.__autoCrop=function(e){var t,i,a,n,o=this;if(this.settings.crop&&this.settings.multiple){for(n=this.settings.crop,i=0,a=n.length;a>i;i++)if(t=n[i],!t.preferedSize)return;return e.onAnyDone(function(t,i){var a,n,l;if(i.isImage&&!i.cdnUrlModifiers&&!i.crop)return a=i.originalImageInfo,l=r.utils.fitSize(o.settings.crop[0].preferedSize,[a.width,a.height],!0),n=c.applyCropSelectionToFile(t,o.settings.crop[0],[a.width,a.height],{width:l[0],height:l[1],left:Math.round((a.width-l[0])/2),top:Math.round((a.height-l[1])/2)}),e.replace(t,n)})}},a.prototype.__resolve=function(){return this.dfd.resolve(this.files.get())},a.prototype.__reject=function(){return this.dfd.reject(this.files.get())},a.prototype.__prepareTabs=function(e){var t,i,a,r;for(this.addTab("preview"),r=this.settings.tabs,i=0,a=r.length;a>i;i++)t=r[i],this.addTab(t);return this.files.length()?(this.showTab("preview"),this.switchTab("preview")):(this.hideTab("preview"),this.switchTab(e||this.__firstVisibleTab())),0===this.settings.tabs.length?this.panel.addClass("uploadcare-panel-hide-tabs"):void 0},a.prototype.__prepareFooter=function(){var e,t=this;return this.footer=this.panel.find(".uploadcare-panel-footer"),e=":not(.uploadcare-disabled-el)",this.footer.on("click",".uploadcare-dialog-button"+e,function(){return t.switchTab("preview")}),this.footer.on("click",".uploadcare-dialog-button-success"+e,this.__resolve),this.__updateFooter(),this.files.onAdd.add(this.__updateFooter),this.files.onRemove.add(this.__updateFooter)},a.prototype.__updateFooter=function(){var e,t,a;return i=this.files.length(),a=0!==this.settings.multipleMax&&i>this.settings.multipleMax,t=i<this.settings.multipleMin,this.footer.find(".uploadcare-dialog-button-success").toggleClass("uploadcare-disabled-el",a||t),this.footer.find(".uploadcare-dialog-button").toggleClass("uploadcare-disabled-el",0===i),e=a?o("dialog.tabs.preview.multiple.tooManyFiles").replace("%max%",this.settings.multipleMax):i&&t?o("dialog.tabs.preview.multiple.tooFewFiles").replace("%min%",this.settings.multipleMin):o("dialog.tabs.preview.multiple.title"),this.footer.find(".uploadcare-panel-footer-text").toggleClass("uploadcare-error",a).text(e.replace("%files%",o("file",i))),this.footer.find(".uploadcare-panel-footer-counter").toggleClass("uploadcare-error",a).text(i?"("+i+")":"")},a.prototype.__closePanel=function(){return this.panel.replaceWith(this.placeholder),this.content.remove()},a.prototype.addTab=function(i){var a,r,n,l=this;if(!(i in this.tabs)){
	if(a=m[i],!a)throw new Error("No such tab: "+i);return n=t("<div>").addClass(""+e+"s-panel").addClass(""+e+"s-panel-"+i).insertBefore(this.footer),r=t("<div>",{role:"button",tabindex:"0"}).addClass(e).addClass(""+e+"-"+i).attr("title",o("dialog.tabs.names."+i)).appendTo(this.panel.find("."+e+"s")).on("click",function(){return i===l.currentTab?l.panel.toggleClass("uploadcare-dialog-opened-tabs"):l.switchTab(i)}),this.tabs[i]=new a(n,r,this.publicPromise(),this.settings,i)}},a.prototype.switchTab=function(t){var i;if(t)return this.currentTab=t,this.panel.removeClass("uploadcare-dialog-opened-tabs"),this.panel.find("."+e).removeClass(""+e+"_current").filter("."+e+"-"+t).addClass(""+e+"_current"),i=""+e+"s-panel",this.panel.find("."+i).removeClass(""+i+"_current").filter("."+i+"-"+t).addClass(""+i+"_current"),this.dfd.notify(t)},a.prototype.showTab=function(e){return this.onTabVisibility.fire(e,!0)},a.prototype.hideTab=function(e){return this.onTabVisibility.fire(e,!1),this.currentTab===e?this.switchTab(this.__firstVisibleTab()):void 0},a.prototype.isTabVisible=function(t){return!this.panel.find("."+e+"-"+t).is("."+e+"_hidden")},a.prototype.__firstVisibleTab=function(){var e,t,i,a;for(a=this.settings.tabs,t=0,i=a.length;i>t;t++)if(e=a[t],this.isTabVisible(e))return e},a.prototype.__welcome=function(){var e,t,i,a;for(this.addTab("empty-pubkey"),this.switchTab("empty-pubkey"),a=this.settings.tabs,t=0,i=a.length;i>t;t++)e=a[t],this.__addFakeTab(e);return null},a.prototype.__addFakeTab=function(i){return t("<div>").addClass(""+e+" "+e+"-"+i).addClass("uploadcare-dialog-disabled-tab").attr("title",o("dialog.tabs.names."+i)).appendTo(this.panel.find("."+e+"s"))},a}()})}.call(this),function(){var e,t,i,a,n,o=function(e,t){return function(){return e.apply(t,arguments)}};a=r.utils,e=r.jQuery,t=r.dragdrop,n=r.locale,i=n.t,r.namespace("widget",function(n){return n.BaseWidget=function(){function l(t,i){var r=this;this.element=t,this.settings=i,this.reloadInfo=o(this.reloadInfo,this),this.__setObject=o(this.__setObject,this),this.__reset=o(this.__reset,this),this.validators=this.settings.validators=[],this.currentObject=null,this.__onDialogOpen=e.Callbacks(),this.__onUploadComplete=e.Callbacks(),this.__onChange=e.Callbacks().add(function(e){return null!=e?e.promise().done(function(e){return r.__onUploadComplete.fire(e)}):void 0}),this.__setupWidget(),this.element.on("change.uploadcare",this.reloadInfo),this.__hasValue=!1,a.defer(function(){return r.__hasValue?void 0:r.reloadInfo()})}return l.prototype.__setupWidget=function(){var e,a=this;return this.template=new n.Template(this.settings,this.element),e=["buttons.choose"],e.push(this.settings.imagesOnly?"images":"files"),e.push(this.settings.multiple?"other":"one"),this.template.addButton("open",i(e.join("."))).toggleClass("needsclick",this.settings.systemDialog).on("click",function(){return a.openDialog()}),this.template.addButton("cancel",i("buttons.cancel")).on("click",function(){return a.__setObject(null)}),this.template.addButton("remove",i("buttons.remove")).on("click",function(){return a.__setObject(null)}),this.template.content.on("click",".uploadcare-widget-file-name",function(){return a.openDialog()}),t.receiveDrop(this.template.content,this.__handleDirectSelection),this.template.reset()},l.prototype.__infoToValue=function(e){return e.cdnUrlModifiers||this.settings.pathValue?e.cdnUrl:e.uuid},l.prototype.__reset=function(){var e;return e=this.currentObject,this.currentObject=null,null!=e&&"function"==typeof e.cancel&&e.cancel(),this.template.reset()},l.prototype.__setObject=function(e){return e!==this.currentObject?(this.__reset(),e?(this.currentObject=e,this.__watchCurrentObject()):this.element.val(""),this.__onChange.fire(this.currentObject)):void 0},l.prototype.__watchCurrentObject=function(){var e,t=this;return e=this.__currentFile(),e?(this.template.listen(e),e.done(function(i){return e===t.__currentFile()?t.__onUploadingDone(i):void 0}).fail(function(i){return e===t.__currentFile()?t.__onUploadingFailed(i):void 0})):void 0},l.prototype.__onUploadingDone=function(e){return this.element.val(this.__infoToValue(e)),this.template.setFileInfo(e),this.template.loaded()},l.prototype.__onUploadingFailed=function(e){return this.template.reset(),this.template.error(e)},l.prototype.__setExternalValue=function(e){return this.__setObject(a.valueToFile(e,this.settings))},l.prototype.value=function(e){return void 0!==e?(this.__hasValue=!0,this.__setExternalValue(e),this):this.currentObject},l.prototype.reloadInfo=function(){return this.value(this.element.val())},l.prototype.openDialog=function(e){var t=this;return this.settings.systemDialog?a.fileSelectDialog(this.template.content,this.settings,function(e){return t.__handleDirectSelection("object",e.files)}):this.__openDialog(e)},l.prototype.__openDialog=function(e){var t;return t=r.openDialog(this.currentObject,e,this.settings),this.__onDialogOpen.fire(t),t.done(this.__setObject)},l.prototype.api=function(){return this.__api||(this.__api=a.bindAll(this,["openDialog","reloadInfo","value","validators"]),this.__api.onChange=a.publicCallbacks(this.__onChange),this.__api.onUploadComplete=a.publicCallbacks(this.__onUploadComplete),this.__api.onDialogOpen=a.publicCallbacks(this.__onDialogOpen),this.__api.inputElement=this.element.get(0)),this.__api},l}()})}.call(this),function(){var e,t,i,a=function(e,t){return function(){return e.apply(t,arguments)}},n={}.hasOwnProperty,o=function(e,t){for(var i in t)n.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};i=r.utils,t=r.files,e=r.jQuery,r.namespace("widget",function(e){var t;return e.Widget=function(e){o(i,e);function i(){return this.__handleDirectSelection=a(this.__handleDirectSelection,this),t=i.__super__.constructor.apply(this,arguments)}return i.prototype.__currentFile=function(){return this.currentObject},i.prototype.__handleDirectSelection=function(e,t){var i;return i=r.fileFrom(e,t[0],this.settings),this.settings.systemDialog||!this.settings.previewStep?this.__setObject(i):this.__openDialog("preview").addFiles([i])},i}(e.BaseWidget),e.Widget._name="SingleWidget"})}.call(this),function(){var e,t,i,a,n=function(e,t){return function(){return e.apply(t,arguments)}},o={}.hasOwnProperty,l=function(e,t){for(var i in t)o.call(t,i)&&(e[i]=t[i]);function a(){this.constructor=e}return a.prototype=t.prototype,e.prototype=new a,e.__super__=t.prototype,e};i=r.utils,e=r.jQuery,a=r.locale,t=a.t,r.namespace("widget",function(e){var a;return e.MultipleWidget=function(e){l(o,e);function o(){return this.__handleDirectSelection=n(this.__handleDirectSelection,this),this.__setObject=n(this.__setObject,this),a=o.__super__.constructor.apply(this,arguments)}return o.prototype.__currentFile=function(){var e;return null!=(e=this.currentObject)?e.promise():void 0},o.prototype.__setObject=function(e){return i.isFileGroupsEqual(this.currentObject,e)?e?void 0:(this.__reset(),this.element.val("")):o.__super__.__setObject.apply(this,arguments)},o.prototype.__setExternalValue=function(e){var a,r=this;return this.__lastGroupPr=a=i.valueToGroup(e,this.settings),e&&(this.template.setStatus("started"),this.template.statusText.text(t("loadingInfo"))),a.done(function(e){return r.__lastGroupPr===a?r.__setObject(e):void 0}).fail(function(){return r.__lastGroupPr===a?r.__onUploadingFailed("createGroup"):void 0})},o.prototype.__handleDirectSelection=function(e,t){var i;return i=r.filesFrom(e,t,this.settings),this.settings.systemDialog?this.__setObject(r.FileGroup(i,this.settings)):this.__openDialog("preview").addFiles(i)},o}(e.BaseWidget),e.MultipleWidget._name="MultipleWidget"})}.call(this),function(){var t,i,a;a=r.utils,i=r.settings,t=r.jQuery,r.namespace("",function(r){var n,o,l,s,c;return o="uploadcareWidget",c='[role~="uploadcare-uploader"]',r.initialize=function(e){return null==e&&(e=":root"),l(t(e).find(c))},l=function(e){var i,a,r,n,l;for(l=[],r=0,n=e.length;n>r;r++)i=e[r],a=t(i).data(o),a&&a.inputElement===i||l.push(s(i));return l},r.SingleWidget=function(e){return s(e,r.widget.Widget)},r.MultipleWidget=function(e){return s(e,r.widget.MultipleWidget)},r.Widget=function(e){
	return s(e)},s=function(e,l){var s,c,u,p,d;if(u=t(e),0===u.length)throw new Error("No DOM elements found matching selector");if(u.length>1&&a.warn("There are multiple DOM elements matching selector"),e=u.eq(0),p=i.build(e.data()),s=p.multiple?r.widget.MultipleWidget:r.widget.Widget,l&&s!==l)throw new Error("This element should be processed using "+s._name);return c=e.data(o),c&&c.inputElement===e[0]||(n(e),d=new s(e,p),c=d.api(),e.data(o,c),d.template.content.data(o,c)),c},n=function(e){return e.off(".uploadcare").each(function(){var e,i;return i=t(this).next(".uploadcare-widget"),e=i.data(o),e&&e.inputElement===this?i.remove():void 0})},r.start=a.once(function(e,t){return e=i.common(e,t),t?void 0:(e.live&&setInterval(r.initialize,100),r.initialize())}),t(function(){return e.UPLOADCARE_MANUAL_START?void 0:r.start()})})}.call(this),function(){var e,t,i,a,o,l;e=r.jQuery,t=function(e){var t;return t="[data-status=started], [data-status=error]",!e.find(".uploadcare-widget").is(t)},a=function(e,t){return e.attr("data-uploadcare-submitted",t),e.find(":submit").attr("disabled",t)},l='[role~="uploadcare-upload-form"]',o=l+"[data-uploadcare-submitted]",e(n).on("submit",l,function(){var i;return i=e(this),t(i)?!0:(a(i,!0),!1)}),e(n).on("loaded.uploadcare",o,function(){return e(this).submit()}),i="ready.uploadcare error.uploadcare",e(n).on(i,o,function(){var i;return i=e(this),t(i)?a(i,!1):void 0})}.call(this),function(){var e,t,i,a;a=r.utils,e=r.jQuery,t=["div.uploadcare-link","div.uploadcare-widget-button","div.uploadcare-dialog-tab","div.uploadcare-dialog-button","div.uploadcare-dialog-button-success"].join(", "),i="uploadcare-mouse-focused",e(n.documentElement).on("mousedown",t,function(t){return a.defer(function(){var t;return t=n.activeElement,t&&t!==n.body?e(t).addClass(i).one("blur",function(){return e(t).removeClass(i)}):void 0})}).on("keypress",t,function(t){return 13===t.which||32===t.which?(e(this).click(),t.preventDefault(),t.stopPropagation()):void 0})}.call(this),function(){var e;e=r.expose,e("globals",r.settings.common),e("start"),e("initialize"),e("fileFrom"),e("filesFrom"),e("FileGroup"),e("loadFileGroup"),e("openDialog"),e("closeDialog"),e("openPanel"),e("registerTab"),e("Circle",r.ui.progress.Circle),e("SingleWidget"),e("MultipleWidget"),e("Widget"),e("tabsCss"),e("dragdrop.support"),e("dragdrop.receiveDrop"),e("dragdrop.uploadDrop")}.call(this),function(){r.namespace("locale.translations",function(e){return e.ar={uploading:"الرجاء الإنتظار.... يتم الرفع",loadingInfo:"...تحميل المعلومات",errors:{"default":"خطأ",baddata:"قيمة غير صحيحة",size:"ملف كبير جدا",upload:"لا يمكن تحميل",user:" إلغاء التحميل",info:"لا يمكن تحميل معلومات",image:"مسموح بالصور فقط",createGroup:"لا يمكن إنشاء مجموعة ملفات",deleted:"تم حذف ملف"},draghere:"إفلت الملف هنا",file:{zero:"%1 ملفات",one:"%1 ملف",two:"%1 ملفات",few:"%1 ملفات",many:"%1 ملفات",other:"%1 ملفات"},buttons:{cancel:"إلغاء",remove:"إزالة",choose:{files:{one:"اختر ملف",other:"اختر ملفات"},images:{one:"اختر صورة",other:"اختر صور"}}},dialog:{done:"منجز",showFiles:"إظهار الملفات",tabs:{names:{preview:"معاينة",file:"الملفات المحلية",url:"روابط التعسفية",camera:"كاميرا"},file:{drag:"إفلات الملف هنا",nodrop:"تحميل الملفات من جهاز الكمبيوتر الخاص بك",cloudsTip:"المخازن السحابية<br>والخدمات الاجتماعية",or:"أو",button:"اختر ملف محلي",also:"يمكنك أيضا اختيار من"},url:{title:"الملفات من الويب",line1:"اختر على أي ملف من الويب",line2:"قم بتقديم الارتباط",input:"الصق الرابط الخاص بك هنا ...",button:"تحميل"},camera:{capture:"إلتقط صورة",mirror:"مرآة",retry:"إعادة طلب الأذونات",pleaseAllow:{title:"الرجاء السماح بتشغيل كميرتك ",text:"لقد تم السماح للكاميرا بالوصول لهذا الموقع. لكي تلتقط الصور بكاميرتك، يجب السماح لهذا الطلب "},notFound:{title:"لم يتم العثور على كاميرا ",text:"يبدو أنه لا يوجد كاميرا موصولة بهذا الجهاز"}},preview:{unknownName:"غير معروف",change:"إلغاء",back:"العودة",done:"إضافة",unknown:{title:"جاري التحميل .. الرجاء الانتظار للمعاينة.",done:"تخطي المعاينة، واقبل"},regular:{title:"إضافة هذا الملف؟",line1:"أنت على وشك إضافة الملف أعلاه.",line2:"يرجى تأكيد."},image:{title:"إضافة هذه الصورة؟",change:"إلغاء"},crop:{title:"قص وإضافة هذه الصورة",done:"تم",free:"حرر"},error:{"default":{title:"عفوا!",text:"حدث خطأ أثناء تحميل.",back:"يرجى المحاولة مرة أخرى"},image:{title:"فقط ملفات الصور مقبولة.",text:"يرجى المحاولة مرة أخرى مع ملف آخر.",back:"اختيار صورة"},size:{title:"الملف الذي حددته يتجاوز الحد.",text:"يرجى المحاولة مرة أخرى مع ملف آخر."},loadImage:{title:"خطأ",text:"لا يمكن تحميل صورة"}},multiple:{title:"لقد أخترت %files%",question:"هل ترغب في إضافة كل من هذه الملفات?",tooManyFiles:"لقد اخترت العديد من الملفات. %max% is الحد الأقصى.",tooFewFiles:"لقد أخترت %files%. على الأقل %min% مطلوب.",clear:"إزالة جميع",done:"تم"}}}}}}),r.namespace("locale.pluralize",function(e){return e.ar=function(e){var t;return 0===e?"zero":1===e?"one":2===e?"two":(t=e%100,t>=3&&10>=t?"few":t>=11&&99>=t?"many":"other")}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.az={uploading:"Yüklənilir... Lütfən, gözləyin.",loadingInfo:"İnfo yüklənilir...",errors:{"default":"Xəta",baddata:"Yanlış dəyər",size:"Fayl çox böyükdür",upload:"Yüklənilə bilmədi",user:"Yükləmə ləğv edildi",info:"İnfo yüklənə bilmədi",image:"Yalnız təsvirlərə icazə verilir",createGroup:"Fayl qrupu yaradıla bilmir",deleted:"Fayl silindi"},draghere:"Faylı bura atın",file:{one:"%1 fayl",other:"%1 fayl"},buttons:{cancel:"Ləğv edin",remove:"Silin",choose:{files:{one:"Fayl seçin",other:"Fayllar seçin"},images:{one:"Təsvir seçin",other:"Təsvirlər seçin"}}},dialog:{done:"Hazırdır",showFiles:"Faylları göstərin",tabs:{names:{"empty-pubkey":"Xoş gəlmisiniz",preview:"Önbaxış",file:"Lokal Fayllar",url:"İxtiyari linklər",camera:"Kamera",gdrive:"Google Disk"},file:{drag:"Faylı bura atın",nodrop:"Kompüterinizdən faylları yükləyin",cloudsTip:"Bulud yaddaşlar <br>və sosial xidmətlər",or:"or",button:"Lokal fayl seçin",also:"Həmçinin, buradan seçə bilərsiniz"},url:{title:"Vebdən fayllar",line1:"Vebdən istənilən faylı götürün.",line2:"Sadəcə, link verin.",input:"Linkinizi bura yerləşdirin...",button:"Yükləyin"},camera:{capture:"Şəkil çəkin",mirror:"Güzgü",retry:"Yenidən icazə sorğusu göndərin.",pleaseAllow:{title:"Lütfən, kameranıza giriş hüququ verin",text:"Bu saytdan kameranıza daxil olmaq icazəsi verildi. Kameranız ilə şəkil çəkmək üçün bu sorğunu təsdiq etməlisiniz."},notFound:{title:"Kamera aşkar edilmədi",text:"Görünür, bu cihaza kamera qoşulmayıb."}},preview:{unknownName:"naməlum",change:"Ləğv edin",back:"Geri",done:"Əlavə edin",unknown:{title:"Yüklənilir... Lütfən, önbaxış üçün gözləyin.",done:"Önbaxışı ötürün və qəbul edin"},regular:{title:"Bu fayl əlavə edilsin?",line1:"Yuxarıdakı faylı əlavə etmək üzrəsiniz.",line2:"Lütfən, təsdiq edin."},image:{title:"Bu təsvir əlavə edilsin?",change:"Ləğv edin"},crop:{title:"Bu təsviri kəsin və əlavə edin",done:"Hazırdır",free:"pulsuz"},error:{"default":{title:"Ups!",text:"Yükləmə zamanı nəsə xəta baş verdi.",back:"Lütfən, y enidən cəhd edin."},image:{title:"Yaınız təsvir faylları qəbul olunur.",text:"Lütfən, başqa fayl ilə cəhd edin.",back:"Təsvir seçin"},size:{title:"Seçdiyiniz fayl limiti keçir.",text:"Lütfən, başqa fayl ilə cəhd edin."},loadImage:{title:"Xəta",text:"Təsvir yüklənilə bilmir"}},multiple:{title:"%files% fayl seçdiniz.",question:"Bütün bu faylları əlavə etmək istəyirsiniz?",tooManyFiles:"Həddindən çox fayl seçdiniz. %max% maksimumdur.",tooFewFiles:"%files% fayl seçdiniz. Ən azı %min% tələb olunur.",clear:"Hamısını silin",done:"Hazırdır"}}}}}}),r.namespace("locale.pluralize",function(e){return e.az=function(e){return"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.ca={uploading:"Carregant... Si us plau esperi.",loadingInfo:"Carregant informació...",errors:{"default":"Error",baddata:"Valor incorrecte",size:"Massa gran",upload:"No s'ha pogut carregar",user:"Carrega cancel·lada",info:"No s'ha pogut carregar la informació",image:"Només es permeten imatges",createGroup:"No es pot crear el grup d'arxius",deleted:"Fitxer eliminat"},draghere:"Arrossega els fitxers fins aquí",file:{one:"%1 fitxer",other:"%1 fitxers"},buttons:{cancel:"Cancel·lar",remove:"Eliminar",
	choose:{files:{one:"Escull un fitxer",other:"Escull fitxers"},images:{one:"Escull una imatge",other:"Escull imatges"}}},dialog:{done:"Fet",showFiles:"Mostra fitxers",tabs:{names:{"empty-pubkey":"Benvingut",preview:"Avanci",file:"Ordinador",url:"Enllaços arbitraris",camera:"Càmera"},file:{drag:"Arrossega un fitxer aquí",nodrop:"Carrega fitxers des del teu ordinador",cloudsTip:"Emmagatzematge al núvol<br>i xarxes socials",or:"o",button:"Escull un fitxer des del teu ordinador",also:"També pots seleccionar-lo de"},url:{title:"Fitxers de la web",line1:"Selecciona qualsevol fitxer de la web.",line2:"Només proporcioni el link.",input:"Copiï el link aquí...",button:"Pujar"},camera:{capture:"Realitza una foto",mirror:"Mirall",retry:"Demanar permisos una altra vegada",pleaseAllow:{title:"Si us plau, permet accés a la teva càmera",text:"Aquest lloc t'ha demanat de permetre accés a la càmera. Per tal de realitzar imatges amb la teva càmera has d'acceptar aquesta petició."},notFound:{title:"No s'ha detectat cap càmera",text:"Sembla que no tens cap càmera connectada a aquest dispositiu."}},preview:{unknownName:"desconegut",change:"Cancel·lar",back:"Endarrere",done:"Pujar",unknown:{title:"Carregant. Si us plau esperi per la visualització prèvia.",done:"Saltar visualització prèvia i acceptar"},regular:{title:"Vols pujar aquest fitxer?",line1:"Estàs a punt de pujar el fitxer superior.",line2:"Confirmi, si us plau."},image:{title:"Vols pujar aquesta imatge?",change:"Cancel·lar"},crop:{title:"Tallar i pujar aquesta imatge",done:"Fet",free:"lliure"},error:{"default":{title:"La pujada ha fallat!",text:"S'ha produït un error durant la pujada.",back:"Si us plau, provi-ho de nou."},image:{title:"Només s'accepten fitxers d'imatges.",text:"Si us plau, provi-ho de nou amb un altre fitxer.",back:"Escull imatge"},size:{title:"La mida del fitxer que has seleccionat sobrepassa el límit.",text:"Si us plau, provi-ho de nou amb un altre fitxer."},loadImage:{title:"Error",text:"No s'ha pogut carregar la imatge"}},multiple:{title:"N'has escollit %files%",question:"Vols afegir tots aquests fitxers?",tooManyFiles:"Has escollit massa fitxers. %max% és el màxim.",tooFewFiles:"Has escollit %files%. Com a mínim en calen %min%.",clear:"Eliminar-los tots",done:"Fet"}}}}}}),r.namespace("locale.pluralize",function(e){return e.ca=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.cs={uploading:"Nahrávám... Malý moment.",loadingInfo:"Nahrávám informace...",errors:{"default":"Chyba",baddata:"Neplatná hodnota",size:"Soubor je příliš velký",upload:"Nelze nahrát",user:"Nahrávání zrušeno",info:"Nelze nahrát informace",image:"Lze nahrát pouze obrázky",createGroup:"Nelze vytvořit adresář",deleted:"Soubor byl smazán"},draghere:"Přetáhněte soubor sem",file:{one:"%1 soubor",few:"%1 soubory",many:"%1 souborů"},buttons:{cancel:"Zrušit",remove:"Odstranit",choose:{files:{one:"Vyberte soubor",other:"Vyberte soubory"},images:{one:"Vyberte obrázek",other:"Vyberte obrázky"}}},dialog:{done:"Hotovo",showFiles:"Zobrazit soubory",tabs:{names:{"empty-pubkey":"Vítejte",preview:"Náhled",file:"Soubor z počítače",url:"Soubor z internetu",camera:"Webkamera",facebook:"Facebook",dropbox:"Dropbox",gdrive:"Google Drive",instagram:"Instagram",vk:"VK",evernote:"Evernote",box:"Box",skydrive:"OneDrive",flickr:"Flickr",huddle:"Huddle"},file:{drag:"Přetáhněte soubor sem",nodrop:"Nahrajte soubory z vašeho počítače",cloudsTip:"Cloudové úložiště<br>a sociální sítě",or:"nebo",button:"Vyberte soubor z počítače",also:"Můžete také nahrát soubor z"},url:{title:"Soubory z internetu",line1:"Nahrajte jakýkoliv soubor z internetu.",line2:"Stačí vložit odkaz.",input:"Odkaz vložte zde...",button:"Nahrát"},camera:{capture:"Pořídit fotografii",mirror:"Zrcadlo",retry:"Znovu požádat o povolení",pleaseAllow:{title:"Prosím povolte přístup k webkameře",text:"Byl(a) jste požádán(a) o přístup k webkameře. Abyste mohl(a) pořídit fotografii, musíte přístup povolit."},notFound:{title:"Nebyla nalezena webkamera",text:"Zdá se, že k tomuto zařízení není připojena žádná webkamera."}},preview:{unknownName:"neznámý",change:"Zrušit",back:"Zpět",done:"Přidat",unknown:{title:"Nahrávám... Prosím vyčkejte na náhled.",done:"Přeskočit náhled a odeslat"},regular:{title:"Přidat tento soubor?",line1:"Tímto přidáte výše vybraný soubor.",line2:"Prosím potvrďte."},image:{title:"Přidat tento obrázek?",change:"Zrušit"},crop:{title:"Oříznout a přidat tento obrázek",done:"Hotovo",free:"zdarma"},error:{"default":{title:"Jejda!",text:"Něco se v průběhu nahrávání nepodařilo.",back:"Zkuste to prosím znovu."},image:{title:"Lze nahrávat pouze obrázky.",text:"Zkuste to prosím s jiným souborem.",back:"Vyberte obrázek"},size:{title:"Soubor přesahuje povolenou velikost.",text:"Prosím zkuste to s jiným souborem."},loadImage:{title:"Chyba",text:"Nelze nahrát obrázek"}},multiple:{title:"Bylo vybráno %files% souborů",question:"Chcete přidat všechny tyto soubory?",tooManyFiles:"Bylo vybráno moc souborů. Maximum je %max%",tooFewFiles:"Bylo vybráno %files% souborů. Musíte vybrat minimálně %min%",clear:"Odstranit vše",done:"Hotovo"}}}}}}),r.namespace("locale.pluralize",function(e){return e.cs=function(e){return 1===e?"one":e>=2&&4>=e?"few":"many"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.da={uploading:"Uploader... Vent venligst.",loadingInfo:"Henter information...",errors:{"default":"Fejl",baddata:"Forkert værdi",size:"Filen er for stor",upload:"Kan ikke uploade / sende fil",user:"Upload fortrudt",info:"Kan ikke hente information",image:"Kun billeder er tilladt",createGroup:"Kan ikke oprette fil gruppe",deleted:"Filen blev slettet"},draghere:"Drop en fil her",file:{one:"%1 fil",other:"%1 filer"},buttons:{cancel:"Annuller",remove:"Fjern",choose:{files:{one:"Vælg en fil",other:"Vælg filer"},images:{one:"Vælg et billede",other:"Vælg billeder"}}},dialog:{done:"Færdig",showFiles:"Vis filer",tabs:{names:{preview:"Vis",file:"Computer",gdrive:"Google Drev",url:"Direkte link"},file:{drag:"Drop en fil her",nodrop:"Hent filer fra din computer",or:"eller",button:"Hent fil fra din computer",also:"Du kan også hente fra"},url:{title:"Filer fra en Web adresse",line1:"Vælg en fil fra en web adresse.",line2:"Skriv bare linket til filen.",input:"Indsæt link her...",button:"Upload / Send"},preview:{unknownName:"ukendt",change:"Annuller",back:"Tilbage",done:"Fortsæt",unknown:{title:"Uploader / sender... Vent for at se mere.",done:"Fortsæt uden at vente på resultat"},regular:{title:"Tilføje fil?",line1:"Du er ved at tilføje filen ovenfor.",line2:"Venligst accepter."},image:{title:"Tilføj billede?",change:"Annuller"},crop:{title:"Beskær og tilføj dette billede",done:"Udfør"},error:{"default":{title:"Hov!",text:"Noget gik galt under upload.",back:"Venligst prøv igen"},image:{title:"Du kan kun vælge billeder.",text:"Prøv igen med en billedfil.",back:"Vælg billede"},size:{title:"Den fil du valgte, er desværre større end tilladt.",text:"Venligst prøv med en mindre fil."},loadImage:{title:"Fejl",text:"Kan ikke åbne billede"}},multiple:{title:"Du har valgt %files% filer",question:"Vil du tilføje alle disse filer?",tooManyFiles:"Du har valgt for mange filer. %max% er maximum.",tooFewFiles:"Du har valgt %files% filer. Men du skal vælge mindst %min%.",clear:"Fjern alle",done:"Fortsæt"}}}}}}),r.namespace("locale.pluralize",function(e){return e.da=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.de={uploading:"Hochladen... Bitte warten.",loadingInfo:"Laden der Informationen...",errors:{"default":"Error",baddata:"Falscher Wert",size:"Datei zu groß",upload:"Kann nicht hochgeladen werden",user:"Hochladen abgebrochen",info:"Informationen können nicht geladen werden",image:"Nur Bilder sind erlaubt",createGroup:"Datei-Gruppe kann nicht erstellt werden",deleted:"Datei wurde gelöscht"},draghere:"Ziehen Sie eine Datei hier hinein",file:{one:"%1 Datei",other:"%1 Dateien"},buttons:{cancel:"Abbrechen",remove:"Löschen",choose:{files:{one:"Wählen Sie eine Datei",other:"Wählen Sie die Dateien"},images:{one:"Wählen Sie ein Bild",other:"Wählen Sie Bilder"}}},dialog:{
	done:"Fertig",showFiles:"Dateien anzeigen",tabs:{names:{"empty-pubkey":"Willkommen",preview:"Vorschau",file:"Lokale Dateien",url:"Web-Links",camera:"Kamera"},file:{drag:"Ziehen Sie eine Datei hier hinein",nodrop:"Laden Sie Dateien von Ihrem PC hoch",cloudsTip:"Cloud Speicher<br>und soziale Dienste",or:"oder",button:"Wählen Sie eine lokale Datei",also:"Sie können sie auch wählen von"},url:{title:"Dateien vom Web",line1:"Holen Sie sich irgendeine Datei vom Web.",line2:"Geben Sie einfach den Link an.",input:"Bitte geben Sie den Link hier an...",button:"Hochladen"},camera:{capture:"Machen Sie ein Foto",mirror:"Spiegel",retry:"Berechtigungen erneut anfordern",pleaseAllow:{title:"Bitte erlauben Sie den Zugriff auf Ihre Kamera",text:"Sie wurden gebeten, dieser Website den Zugriff auf Ihre Kamera zu erlauben. Um mit Ihrer Kamera Fotos machen zu können, müssen Sie diese Erlaubnis erteilen."},notFound:{title:"Keine Kamera festgestellt",text:"Es sieht so aus, als hätten Sie keine Kamera an dieses Gerät angeschlossen."}},preview:{unknownName:"nicht bekannt",change:"Abbrechen",back:"Zurück",done:"Hinzufügen",unknown:{title:"Hochladen... Bitte warten Sie auf die Vorschau.",done:"Vorschau überspringen und Datei annehmen"},regular:{title:"Diese Datei hinzufügen?",line1:"Diese Datei wird nun hinzugefügt.",line2:"Bitte bestätigen Sie."},image:{title:"Dieses Bild hinzufügen?",change:"Abbrechen"},crop:{title:"Dieses Bild beschneiden und hinzufügen",done:"Fertig",free:"frei"},error:{"default":{title:"Oops!",text:"Etwas ist während dem Hochladen schief gelaufen.",back:"Bitte versuchen Sie es erneut"},image:{title:"Nur Bilder sind akzeptiert.",text:"Bitte veruschen Sie es erneut mit einer anderen Datei.",back:"Bild wählen"},size:{title:"Die gewählte Datei überschreitet das Limit.",text:"Bitte veruschen Sie es erneut mit einer anderen Datei."},loadImage:{title:"Fehler",text:"Das Bild kann nicht geladen werden"}},multiple:{title:"Sie haben %files% Dateien gewählt",question:"Möchten Sie all diese Datein hinzufügen?",tooManyFiles:"Sie haben zu viele Dateien gewählt. %max% ist das Maximum.",tooFewFiles:"Sie haben %files% Dateien. Es sind mindestens %min% nötig.",clear:"Alle löschen",done:"Fertig"}}}}}}),r.namespace("locale.pluralize",function(e){return e.de=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.es={uploading:"Subiendo... Por favor espere.",loadingInfo:"Cargando información...",errors:{"default":"Error",baddata:"Valor incorrecto",size:"Archivo demasiado grande",upload:"No se puede subir",user:"Subida cancelada",info:"No se puede cargar la información",image:"Solo se permiten imágenes",createGroup:"No se puede crear el grupo de archivos",deleted:"El archivo fue eliminado"},draghere:"Arrastra un archivo aquí",file:{one:"%1 archivo",other:"%1 archivos"},buttons:{cancel:"Cancelar",remove:"Eliminar",choose:{files:{one:"Escoge un archivo",other:"Escoge archivos"},images:{one:"Escoge una imagen",other:"Escoge imágenes"}}},dialog:{done:"Hecho",showFiles:"Mostrar archivos",tabs:{names:{"empty-pubkey":"Bienvenido",preview:"Previsualización",file:"Archivos locales",url:"Enlaces arbitrarios",camera:"Cámara"},file:{drag:"Arrastra una archivo aquí",nodrop:"Sube fotos desde tu ordenador",cloudsTip:"Almacenamiento en la nube<br>y redes sociales",or:"o",button:"Elige un archivo de tu ordenador",also:"Tambien puedes seleccionarlo de"},url:{title:"Archivos de la Web",line1:"Coge cualquier archivo de la web.",line2:"Solo danos el link.",input:"Pega tu link aquí...",button:"Subir"},camera:{capture:"Hacer una foto",mirror:"Espejo",retry:"Solicitar permisos de nuevo",pleaseAllow:{title:"Por favor, permite el acceso a tu cámara",text:"Este sitio ha pedido permiso para acceder a la cámara. Para tomar imágenes con tu cámara debes aceptar esta petición."},notFound:{title:"No se ha detectado ninguna cámara",text:"Parece que no tienes ninguna cámara conectada a este dispositivo."}},preview:{unknownName:"desconocido",change:"Cancelar",back:"Atrás",done:"Añadir",unknown:{title:"Subiendo. Por favor espera para una vista previa.",done:"Saltar vista previa y aceptar"},regular:{title:"¿Quieres subir este archivo?",line1:"Estás a punto de subir el archivo de arriba.",line2:"Confírmalo por favor."},image:{title:"¿Quieres subir esta imagen?",change:"Cancelar"},crop:{title:"Cortar y añadir esta imagen",done:"Listo",free:"libre"},error:{"default":{title:"Ups!",text:"Algo salió mal durante la subida.",back:"Por favor, inténtalo de nuevo."},image:{title:"Solo se aceptan archivos de imagen.",text:"Por favor, inténtalo de nuevo con otro archivo.",back:"Escoger imagen"},size:{title:"El archivo que has seleccinado excede el límite.",text:"Por favor, inténtalo de nuevo con otro archivo."},loadImage:{title:"Error",text:"No puede cargar la imagen"}},multiple:{title:"Has escogido %files%",question:"¿Quieres añadir todos estos archivos?",tooManyFiles:"Has escogido demasiados archivos. %max% es el máximo.",tooFewFiles:"Has escogido %files%. Hacen falta al menos %min%.",clear:"Eliminar todo",done:"Hecho"}}}}}}),r.namespace("locale.pluralize",function(e){return e.es=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.et={uploading:"Üleslaadimine… Palun oota.",loadingInfo:"Info laadimine...",errors:{"default":"Viga",baddata:"Incorrect value",size:"Fail on liiga suur",upload:"Ei saa üles laadida",user:"Üleslaadimine tühistatud",info:"Ei saa infot laadida",image:"Ainult pildid lubatud",createGroup:"Ei saa luua failigruppi",deleted:"Fail on kustutatud"},draghere:"Tiri fail siia",file:{one:"%1 fail",other:"%1 failid"},buttons:{cancel:"Tühista",remove:"Kustuta",choose:{files:{one:"Vali fail",other:"Vali failid"},images:{one:"Vali pilt",other:"Vali pildid"}}},dialog:{done:"Valmis",showFiles:"Näita faile",tabs:{names:{"empty-pubkey":"Tere",preview:"Eelvaade",file:"Failid Kõvakettalt",url:"Veebilink",camera:"Kaamera"},file:{drag:"Tiri failid siia",nodrop:"Lae failid arvutist",cloudsTip:"Pilv<br>ja sotsiaalmeedia",or:"või",button:"Vali fail kõvakettalt",also:"Saad samuti valida"},url:{title:"Failid veebist",line1:"Ükskõik mis fail otse veebist.",line2:"Lihtsalt sisesta URL.",input:"Kleebi link siia...",button:"Lae üles"},camera:{capture:"Take a photo",mirror:"Mirror",startRecord:"Record a video",stopRecord:"Stop",cancelRecord:"Cancel",retry:"Request permissions again",pleaseAllow:{title:"Please allow access to your camera",text:"You have been prompted to allow camera access from this site. In order to take pictures with your camera you must approve this request."},notFound:{title:"No camera detected",text:"Looks like you have no camera connected to this device."}},preview:{unknownName:"teadmata",change:"Tühista",back:"Tagasi",done:"Lisa",unknown:{title:"Üleslaadimine... Palun oota eelvaadet.",done:"Jäta eelvaade vahele ja nõustu"},regular:{title:"Lisa see fail?",line1:"Oled lisamas ülaltoodud faili.",line2:"Palun kinnita."},image:{title:"Lisa pilt?",change:"Tühista"},crop:{title:"Lõika ja lisa pilt",done:"Valmis",free:"vaba"},video:{title:"Lisa video?",change:"Tühista"},error:{"default":{title:"Oihh!",text:"Midagi läks üleslaadimisel valesti.",back:"Palun proovi uuesti"},image:{title:"Ainult pildifailid on lubatud.",text:"Palun proovi uuesti teise failiga.",back:"Vali pilt"},size:{title:"Valitud fail ületab maksimaalse suuruse.",text:"Palun proovi uuesti teise failiga."},loadImage:{title:"Viga",text:"Ei saa pilti laadida"}},multiple:{title:"Oled valinud %files%",question:"Kas sa soovid lisada kõik failid?",tooManyFiles:"Oled valinud liiga suure hulga faile. %max% on maksimaalne.",tooFewFiles:"Oled valinud %files%. Vähemalt %min% nõutud.",clear:"Eemalda kõik",done:"Valmis"}}}}}}),r.namespace("locale.pluralize",function(e){return e.et=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.fr={uploading:"Envoi en cours... Merci de patienter.",loadingInfo:"Chargement des informations...",errors:{"default":"Erreur",baddata:"Valeur incorrecte",size:"Fichier trop volumineux",upload:"Envoi impossible",user:"Envoi annulé",info:"Impossible de charger les informations",
	image:"Seules les images sont autorisées",createGroup:"Création d'1 groupe impossible",deleted:"Le fichier a été supprimé"},draghere:"Glissez-déposez un fichier ici",file:{one:"%1 fichier",other:"%1 fichiers"},buttons:{cancel:"Annuler",remove:"Supprimer",choose:{files:{one:"Sélectionner un fichier",other:"Sélectionner des fichiers"},images:{one:"Sélectionner une image",other:"Sélectionner des images"}}},dialog:{done:"Terminer",showFiles:"Voir les fichiers",tabs:{names:{preview:"Avant-première",file:"Fichier en local",url:"Une adresse web","empty-pubkey":"Bienvenue",camera:"Appareil photo"},file:{drag:"Glissez-déposez un fichier ici",nodrop:"Envoyez des fichiers depuis votre ordinateur",cloudsTip:"Stockage sur le cloud<br>et réseaux sociaux",or:"ou",button:"Choisir un fichier local",also:"Vous pouvez également le sélectionner depuis"},url:{title:"Fichiers depuis le Web",line1:"Prenez n'importe quel fichier depuis un site web.",line2:"Saisissez simplement son adresse.",input:"Collez le lien ici...",button:"Envoi"},camera:{capture:"Prendre une photo",mirror:"Miroir",retry:"Envoyer une nouvelle demande de permission",pleaseAllow:{title:"Autorisez l'accès à votre appareil photo",text:"Vous avez été invité à autoriser l'accès à votre appareil photo. Pour prendre des photos avec votre appareil photo vous devez approuver cette demande."},notFound:{title:"Aucun appareil photo détecté",text:"Il semblerait que vous n'ayez pas d'appareil photo connecté à cet appareil."}},preview:{unknownName:"inconnu",change:"Annuler",back:"Retour",done:"Ajouter",unknown:{title:"Envoi en cours... Merci de patienter pour prévisualiser.",done:"Passer la prévisualisation et accepter"},regular:{title:"Ajouter ce fichier ?",line1:"Vous êtes sur le point d'ajouter le fichier ci-dessus.",line2:"Merci de confirmer."},image:{title:"Ajouter cette image ?",change:"Annuler"},crop:{title:"Recadrer et ajouter cette image",done:"Terminer",free:"libre"},error:{"default":{title:"Oups!",text:"Quelque chose n'a pas fonctionné pendant l'envoi.",back:"Merci de bien vouloir recommencer"},image:{title:"Seules les images sont acceptées.",text:"Merci de bien vouloir recommencer avec un autre fichier.",back:"Choisir une image"},size:{title:"Le fichier sélectionné est trop volumineux.",text:"Merci de bien vouloir recommencer avec un autre fichier."},loadImage:{title:"Erreur",text:"Impossible de charger l'image"}},multiple:{title:"Vous avez choisi %files%",question:"Voulez vous ajouter tous ces fichiers ?",clear:"Tout retirer",done:"Terminer",tooManyFiles:"Vous avez choisi trop de fichiers. %max% est le maximum.",tooFewFiles:"Vous avez choisi %fichiers%. %min% est le minimum."}}}}}}),r.namespace("locale.pluralize",function(e){return e.fr=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.he={uploading:"טוען... אנא המתן.",loadingInfo:"טוען מידע...",errors:{"default":"שגיאה",baddata:"ערך שגוי",size:"קובץ גדול מידי",upload:"לא ניתן להעלות",user:"העלאה בוטלה",info:"לא ניתן לטעון מידע",image:"ניתן להעלות רק תמונות",createGroup:"לא ניתן ליצור קבוצה",deleted:"הקובץ נמחק"},draghere:"שחרר כאן קובץ",file:{one:"קובץ %1",other:"%1 קבצים"},buttons:{cancel:"ביטול",remove:"הסר",choose:{files:{one:"בחר קובץ",other:"בחר קבצים"},images:{one:"בחר תמונה",other:"בחר תמונות"}}},dialog:{done:"סיום",showFiles:"הצג קבצים",tabs:{names:{facebook:"פייסבוק",dropbox:"דרופבוקס",gdrive:"כונן גוגל",instagram:"אינסטגרם",url:"לינק מהאינטרנט"},file:{drag:"שחרר כאן קובץ",nodrop:"העלה קבצים מהמחשב",or:"או",button:"בחר קובץ מהמחשב",also:"ניתן לבחור גם מ"},url:{title:"קובץ מהאינטרנט",line1:"גרור קובץ מהאינטרנט",line2:"ספק את כתובת הקובץ",input:"הדבק את כתובת הקובץ...",button:"העלה"},preview:{unknownName:"לא ידוע",change:"ביטול",back:"חזרה",done:"הוסף",unknown:{title:"מעלה... נא המתן לתצוגה מקדימה.",done:"דלג על תצוגה מקדימה"},regular:{title:"להוסיף קובץ זה?",line1:"קובץ זה יועלה",line2:"נא אשר."},image:{title:"להוסיף תמונה זו?",change:"ביטול"},crop:{title:"חתוך והוסף תמונה זו",done:"סיום"},error:{"default":{title:"אופס!",text:"משהו השתבש בזמן ההעלאה.",back:"נא נסה שוב"},image:{title:"ניתן לקבל רק קבצי תמונות.",text:"נא נסה שוב עם קובץ אחר.",back:"בחר תמונה"},size:{title:"הקובץ שבחרת חורג מהגבול.",text:"נא נסה שוב עם קובץ אחר."},loadImage:{title:"שגיאה",text:"טעינת התמונה נכשלה"}},multiple:{title:"בחרת %files%",question:"אתה מעוניין להוסיף את כל הקבצים האלו?",tooManyFiles:"בחרת יותר מידי קבצים. יש לבחור מקסימום %max% קבצים.",tooFewFiles:"בחרת %files%. יש לבחור לפחות %min%.",clear:"הסר הכל",done:"סיום"}}}}}}),r.namespace("locale.pluralize",function(e){return e.he=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.it={uploading:"Caricamento in corso... Si prega di attendere.",loadingInfo:"Caricamento informazioni in corso...",errors:{"default":"Errore",baddata:"Valore errato",size:"Il file è troppo grande",upload:"Impossibile fare l’upload",user:"Upload cancellato",info:"Impossibile caricare le informazioni",image:"Sono ammesse solo immagini",createGroup:"Impossibile creare gruppo di file",deleted:"Il file è stato eliminato"},draghere:"Trascina un file qui",file:{one:"file %1",other:"file %1"},buttons:{cancel:"Cancella",remove:"Rimuovi",choose:{files:{one:"Seleziona un file",other:"Seleziona file"},images:{one:"Seleziona un’immagine",other:"Seleziona immagini"}}},dialog:{done:"Fatto",showFiles:"Mostra file",tabs:{names:{"empty-pubkey":"Benvenuto",preview:"Anteprima",file:"File locali",url:"Link arbitrari",camera:"Fotocamera"},file:{drag:"Trascina un file qui",nodrop:"Carica file dal tuo computer",cloudsTip:"Salvataggi nel cloud<br>e servizi sociali",or:"o",button:"Seleziona un file locale",also:"Puoi anche scegliere da"},url:{title:"File dal web",line1:"Preleva un file dal web.",line2:"È sufficiente fornire il link.",input:"Incolla il tuo link qui...",button:"Carica"},camera:{capture:"Scatta una foto",mirror:"Specchio",retry:"Richiedi di nuovo le autorizzazioni",pleaseAllow:{title:"Consenti l’accesso alla tua fotocamera",text:"Ti è stato richiesto di consentire l’accesso alla fotocamera da questo sito. Per scattare le foto con la tua fotocamera devi accettare questa richiesta."},notFound:{title:"Nessuna fotocamera rilevata",text:"Non risulta che tu non abbia una fotocamera collegata a questo dispositivo."}},preview:{unknownName:"sconosciuto",change:"Cancella",back:"Indietro",done:"Aggiungi",unknown:{title:"Caricamento in corso... Attendi l’anteprima.",done:"Salta l’anteprima e accetta"},regular:{title:"Vuoi aggiungere questo file?",line1:"Stai per aggiungere il file sopra.",line2:"Conferma."},image:{title:"Vuoi aggiungere questa immagine?",change:"Cancella"},crop:{title:"Ritaglia e aggiungi questa immagine",done:"Fatto",free:"gratis"},error:{"default":{title:"Ops!",text:"Si è verificato un problema durante l’upload.",back:"Si prega di riprovare"},image:{title:"Sono accettati solo file immagine.",text:"Riprova con un altro file.",back:"Scegli immagine"},size:{title:"Il file selezionato supera il limite.",text:"Riprova con un altro file."},loadImage:{title:"Errore",text:"Impossibile caricare l’immagine"}},multiple:{title:"Hai selezionato %files%",question:"Vuoi aggiungere tutti questi file?",tooManyFiles:"Hai selezionato troppi file. %max% è il massimo.",tooFewFiles:"Hai selezionato %files%. È richiesto almeno %min%.",clear:"Rimuovi tutto",done:"Fatto"}}}}}}),r.namespace("locale.pluralize",function(e){return e.it=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.ja={uploading:"アップロードしています… 完了までお待ち下さい。",loadingInfo:"読み込み中…",errors:{"default":"エラー",baddata:"間違った値",size:"ファイルが大きすぎます",upload:"アップロードできませんでした",user:"アップロードがキャンセルされました",info:"読み込みに失敗しました",image:"アップロードできるのは画像ファイルのみです",createGroup:"グループの作成に失敗しました",deleted:"削除されたファイルです"},draghere:"ここにファイルをドロップ",file:{other:"%1ファイル"},buttons:{cancel:"キャンセル",remove:"削除",choose:{files:{one:"ファイルを選択",other:"ファイルを選択"},images:{one:"画像を選択",other:"画像を選択"}}},dialog:{done:"完了",showFiles:"ファイルを表示",tabs:{names:{preview:"プレビュー",file:"ローカルファイル",url:"URLを直接入力"},file:{drag:"ここにファイルをドロップ",nodrop:"ファイルを選択してアップロード",
	cloudsTip:"クラウドストレージ<br>およびソーシャルサービス",or:"もしくは",button:"ローカルのファイルを選択",also:"次からも選択可能です："},url:{title:"ウェブ上のファイル",line1:"ウェブ上からファイルを取得します。",line2:"URLを入力してください。",input:"ここにURLを貼り付けしてください…",button:"アップロード"},preview:{unknownName:"不明なファイル",change:"キャンセル",back:"戻る",done:"追加",unknown:{title:"アップロードしています… プレビューの表示をお待ちください。",done:"プレビューの確認をスキップして完了"},regular:{title:"このファイルを追加しますか？",line1:"こちらのファイルを追加しようとしています。",line2:"確認してください。"},image:{title:"この画像を追加しますか？",change:"キャンセル"},crop:{title:"画像の切り取りと追加",done:"完了",free:"リセット"},error:{"default":{title:"失敗しました",text:"アップロード中に不明なエラーが発生しました。",back:"もう一度お試し下さい"},image:{title:"画像ファイルのみ許可されています",text:"他のファイルで再度お試し下さい。",back:"画像を選択"},size:{title:"ファイルサイズが大きすぎます。",text:"他のファイルで再度お試し下さい。"},loadImage:{title:"エラー",text:"画像のロードに失敗しました。"}},multiple:{title:"%files%つのファイルを選択中",question:"これら全てのファイルを追加しますか？",tooManyFiles:"選択ファイルが多すぎます。%max%つ以下にしてください。",tooFewFiles:"選択ファイルが少なすぎます。%files%つ選択中です。少なくとも%min%つ選択してください。",clear:"全て削除",done:"完了"}}}}}}),r.namespace("locale.pluralize",function(e){return e.ja=function(e){return"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.lv={uploading:"Augšupielādē... Lūdzu, gaidiet.",errors:{"default":"Kļūda",image:"Atļauti tikai attēli"},draghere:"Velciet failus šeit",file:{zero:"%1 failu",one:"%1 fails",other:"%1 faili"},buttons:{cancel:"Atcelt",remove:"Dzēst"},dialog:{title:"Ielādēt jebko no jebkurienes",poweredby:"Darbināts ar",support:{images:"Attēli",audio:"Audio",video:"Video",documents:"Dokumenti"},tabs:{file:{title:"Mans dators",line1:"Paņemiet jebkuru failu no jūsu datora.",line2:"Izvēlēties ar dialogu vai ievelciet iekšā.",button:"Meklēt failus"},url:{title:"Faili no tīmekļa",line1:"Paņemiet jebkuru failu no tīmekļa.",line2:"Tikai uzrādiet linku.",input:"Ielīmējiet linku šeit...",button:"Ielādēt"}}}}}),r.namespace("locale.pluralize",function(e){return e.lv=function(e){return 0===e?"zero":e%10===1&&e%100!==11?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.nb={uploading:"Laster opp... Vennligst vent.",loadingInfo:"Laster inn info...",errors:{"default":"Feil",baddata:"Ugyldig verdi",size:"Filen er for stor",upload:"Kan ikke laste opp",user:"Opplasting avbrutt",info:"Kan ikke laste inn info",image:"Kun bilder er tillatt",createGroup:"Kan ikke opprette filgruppe",deleted:"Filen er slettet"},draghere:"Dra en fil hit",file:{one:"%1 fil",other:"%1 filer"},buttons:{cancel:"Avbryt",remove:"Fjern",choose:{files:{one:"Velg en fil",other:"Velg filer"},images:{one:"Velg et bilde",other:"Velg bilder"}}},dialog:{done:"Ferdig",showFiles:"Vis filer",tabs:{names:{preview:"Forhåndsvising",file:"Lokale filer",url:"Direktelink"},file:{drag:"Dra og slipp en fil her",nodrop:"Last opp filer fra datamaskinen",cloudsTip:"Skylagring<br>og sosiale tjenester",or:"eller",button:"Velg en lokal fil",also:"Du kan også velge det fra"},url:{title:"Filer fra internett",line1:"Velg hvilken som helst fil fra internett.",line2:"Bare gi oss linken.",input:"Lim inn linken her...",button:"Last opp"},preview:{unknownName:"ukjent",change:"Avbryt",back:"Tilbake",done:"Legg til",unknown:{title:"Laster opp... Vennligst vent på forhåndsvisning.",done:"Hopp over forhåndsvisning og godkjenn"},regular:{title:"Legge til denne filen?",line1:"Filen legges nå til.",line2:"Vennligst bekreft."},image:{title:"Legge til dette bildet?",change:"Avbryt"},crop:{title:"Kutt og legg til dette bildet",done:"Ferdig",free:"frigjør"},error:{"default":{title:"Ops!",text:"Noe gikk galt under opplastingen.",back:"Vennligst prøv igjen"},image:{title:"Kun bilder er akseptert.",text:"Prøv igjen med en annen fil.",back:"Velg bilde"},size:{title:"Den valgte filen overskrider tilatt størrelse.",text:"Vennligst prøv igjen med en annen fil."},loadImage:{title:"Feil",text:"Kan ikke laste bildet"}},multiple:{title:"Du har valgt %files%",question:"Ønsker du å legge til alle filene?",tooManyFiles:"Du har valgt for mange filer. %max% er maksimum.",tooFewFiles:"Du har valgt %files%. Minimum %min% er påkrevd.",clear:"Fjern alle",done:"Ferdig"}}}}}}),r.namespace("locale.pluralize",function(e){return e.nb=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.nl={uploading:"Uploaden... Even geduld.",loadingInfo:"Laden informatie...",errors:{"default":"Fout",baddata:"Ongeldige waarde",size:"Bestand is te groot",upload:"Kan niet uploaden",user:"Upload geannulleerd",info:"Kan informatie niet laden",image:"Alleen afbeeldingen toegestaan",createGroup:"Kan bestandsgroep niet maken",deleted:"Bestand is verwijderd"},draghere:"Drop hier een bestand",file:{one:"%1 bestand",other:"%1 bestanden"},buttons:{cancel:"Annuleren",remove:"Verwijderen",choose:{files:{one:"Kies een bestand",other:"Kies bestanden"},images:{one:"Kies een afbeelding",other:"Kies afbeeldingen"}}},dialog:{done:"Klaar",showFiles:"Toon bestanden",tabs:{names:{preview:"Voorvertoning",file:"Computer",url:"Directe links"},file:{drag:"Drop hier een bestand",nodrop:"Upload bestanden van je computer",or:"of",button:"Selecteer een bestand van je computer",also:"Je kan ook selecteren van"},url:{title:"Bestanden van het web",line1:"Selecteer een bestand van het web.",line2:"Voer de link in.",input:"Plak de link hier...",button:"Upload"},preview:{unknownName:"onbekend",change:"Annuleren",back:"Terug",done:"Toevoegen",unknown:{title:"Uploaden... Wacht op de voorvertoning.",done:"Voorvertoning overslaan an accepteren"},regular:{title:"Dit bestand toevoegen?",line1:"Je staat op het punt bovenstaand bestand toe te voegen.",line2:"Bevestig."},image:{title:"Voeg deze afbeelding toe?",change:"Annuleren"},crop:{title:"Afbeelding bijknippen en toevoegen",done:"Klaar"},error:{"default":{title:"Oeps!",text:"Er is een fout opgetreden tijdens het uploaden.",back:"Probeer het nog eens"},image:{title:"Alleen afbeeldingen worden geaccepteerd.",text:"Probeer het nog eens met een andere bestand.",back:"Selecteer afbeelding"},size:{title:"Het geselecteerd bestand is groter dan de limiet.",text:"Probeer het nog eens met een andere bestand."},loadImage:{title:"Fout",text:"Kan afbeelding niet laden"}},multiple:{title:"Je hebt de volgende bestanden geselecteerd %files%",question:"Wil je al deze bestanden toevoegen?",tooManyFiles:"Je hebt teveel bestanden geselecteerd. %max% is het maximum.",tooFewFiles:"Je hebt de volgende bestanden geselecteerd %files%. Minimaal %min% is verplicht.",clear:"Verwijder alle bestanden",done:"Klaar"}}}}}}),r.namespace("locale.pluralize",function(e){return e.nl=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.pl={uploading:"Przesyłanie... Proszę czekać.",loadingInfo:"Loading info...",errors:{"default":"Błąd",baddata:"Niepoprawna wartość",size:"Plik zbyt duży",upload:"Nie udało się przesłać",user:"Przesyłanie anulowane",info:"Nie udało się załadować informacji",image:"Dozwolone są tylko obrazy",createGroup:"Nie udało się utworzyć grupy plików",deleted:"Plik został usunięty"},draghere:"Upuść plik tutaj",file:{one:"%1 plik",few:"%1 pliki",many:"%1 plików"},buttons:{cancel:"Anuluj",remove:"Usuń",choose:{files:{one:"Wybierz plik",other:"Wybierz pliki"},images:{one:"Wybierz obraz",other:"Wybierz obrazy"}}},dialog:{done:"Wykonano",showFiles:"Pokaż pliki",tabs:{names:{"empty-pubkey":"Witaj",preview:"Podgląd",file:"Pliki lokalne",url:"Plik z Sieci",camera:"Aparat"},file:{drag:"Upuść plik tutaj",nodrop:"Prześlij pliki z Twojego komputera",cloudsTip:"Dane w chmurze<br>i sieci społecznościowe",or:"lub",button:"Wybierz plik lokalny",also:"Możesz również wybrać z"},url:{title:"Pliki z Sieci",line1:"Złap jakikolwiej plik z sieci.",line2:"Podaj adres.",input:"Wklej link...",button:"Prześlij"},camera:{capture:"Zrób zdjęcie",mirror:"Lustro",retry:"Poproś ponownie o dostęp",pleaseAllow:{title:"Prośba o udostępnienie aparatu",text:"Zostałeś poproszony przez tę stronę o dostęp do aparatu. Aby robić zdjecia, musisz zaakceptować tę prośbę."},notFound:{title:"Nie wykryto aparatu.",text:"Wygląda na to, że nie masz podłączonego aparatu do tego urządzenia."}},preview:{unknownName:"nieznany",change:"Anuluj",back:"Wstecz",done:"Dodaj",
	unknown:{title:"Przesyłanie... Proszę czekać na podgląd.",done:"Omiń podgląd i zaakceptuj."},regular:{title:"Dodać ten plik?",line1:"Zamierzasz dodać nowy plik.",line2:"Potwierdź, proszę."},image:{title:"Dodać ten obraz?",change:"Anuluj"},crop:{title:"Przytnij i dodaj ten obraz",done:"Wykonano",free:"wolny"},error:{"default":{title:"Oops!",text:"Coś poszło nie tak podczas przesyłania.",back:"Spróbuj ponownie"},image:{title:"Akceptowane są tylko obrazy.",text:"Spróbuj ponownie z innym plikiem.",back:"Wybierz obraz"},size:{title:"Plik, który wybrałeś, przekracza dopuszczalny rozmiar",text:"Spróbuj ponownie z innym plikiem."},loadImage:{title:"Błąd",text:"Nie udało się załadować obrazu"}},multiple:{title:"Wybrałeś %files%",question:"Czy chcesz dodać wszystkie te pliki?",tooManyFiles:"Wybrałeś zbyt wiele plików. Maksimum to %max%.",tooFewFiles:"Wybrałeś %files%. Wymagane jest co najmniej %min%.",clear:"Usuń wszystkie",done:"Wykonano"}}}}}}),r.namespace("locale.pluralize",function(e){return e.pl=function(e){var t;return 1===e?"one":2<=(t=e%10)&&4>=t&&1!==(e/10%10|0)?"few":"many"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.pt={uploading:"Fazendo upload... Aguarde.",loadingInfo:"Carregando informações...",errors:{"default":"Erro",baddata:"Valor incorreto",size:"Arquivo muito grande",upload:"Não foi possível fazer o upload",user:"Upload cancelado",info:"Não foi possível carregar as informações",image:"Apenas imagens são permitidas",createGroup:"Não foi possível criar o grupo de arquivos",deleted:"O arquivo foi excluído"},draghere:"Arraste um arquivo para cá",file:{one:"%1 arquivo",other:"%1 arquivos"},buttons:{cancel:"Cancelar",remove:"Excluir",choose:{files:{one:"Escolha um arquivo",other:"Escolha arquivos"},images:{one:"Escolha um imagem",other:"Escolha imagens"}}},dialog:{done:"OK",showFiles:"Mostrar arquivos",tabs:{names:{preview:"Pré-estréia",file:"Computador",url:"Link da web"},file:{drag:"Arraste um arquivo para cá",nodrop:"Faça upload de arquivos do seu computador",or:"ou",button:"Escolha um arquivo do computador",also:"Você também pode escolher arquivos de"},url:{title:"Arquivos da web",line1:"Faça upload de qualquer arquivo da web.",line2:"Apenas informe o link.",input:"Cole seu link aqui...",button:"Upload"},preview:{unknownName:"desconhecido",change:"Cancelar",back:"Voltar",done:"Adicionar",unknown:{title:"Fazendo upload... Aguarde o preview.",done:"Pular preview e aceitar"},regular:{title:"Adicionar esse arquivo?",line1:"Você está prestes a adicionar o arquivo acima.",line2:"Por favor, confirme."},image:{title:"Adicionar essa imagem?",change:"Cancelar"},crop:{title:"Cortar e adicionar essa imagem",done:"OK",free:"livre"},error:{"default":{title:"Oops!",text:"Alguma coisa deu errado durante o upload.",back:"Por favor, tente novamente"},image:{title:"Apenas arquivos de imagem são aceitos.",text:"Por favor, tente novamente com outro arquivo.",back:"Escolher a imagem"},size:{title:"O arquivo que você escolheu excede o limite.",text:"Por favor, tente novamente com outro arquivo."},loadImage:{title:"Erro",text:"Não foi possível carregar a imagem"}},multiple:{title:"Você escolheu",question:"Você quer adicionar todos esses arquivos?",clear:"Excluir todos",done:"OK"}}}}}}),r.namespace("locale.pluralize",function(e){return e.pt=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.ru={uploading:"Идет загрузка",loadingInfo:"Загрузка информации...",errors:{"default":"Ошибка",baddata:"Некорректные данные",size:"Слишком большой файл",upload:"Ошибка при загрузке",user:"Загрузка прервана",info:"Ошибка при загрузке информации",image:"Разрешены только изображения",createGroup:"Не удалось создать группу файлов",deleted:"Файл удалён"},draghere:"Перетащите файл сюда",file:{one:"%1 файл",few:"%1 файла",many:"%1 файлов"},buttons:{cancel:"Отмена",remove:"Удалить",choose:{files:{one:"Выбрать файл",other:"Выбрать файлы"},images:{one:"Выбрать изображение",other:"Выбрать изображения"}}},dialog:{done:"Готово",showFiles:"Показать файлы",tabs:{names:{preview:"Предпросмотр","empty-pubkey":"Приветствие",file:"Локальные файлы",vk:"ВКонтакте",url:"Произвольная ссылка",camera:"Камера"},file:{drag:"Перетащите файл сюда",nodrop:"Загрузка файлов с вашего компьютера",cloudsTip:"Облачные хранилища<br>и социальные сети",or:"или",button:"Выберите локальный файл",also:"Вы также можете загрузить файлы, используя:"},url:{title:"Файлы с других сайтов",line1:"Загрузите любой файл из сети.",line2:"",input:"Укажите здесь ссылку...",button:"Загрузить"},camera:{capture:"Сделать снимок",mirror:"Отразить",retry:"Повторно запросить разрешение",pleaseAllow:{title:"Пожалуйста, разрешите доступ к камере",text:"Для того, чтобы сделать снимок, мы запросили разрешение на доступ к камере с этого сайта."},notFound:{title:"Камера не найдена",text:"Скорее всего камера не подключена или не настроена."}},preview:{unknownName:"неизвестно",change:"Отмена",back:"Назад",done:"Добавить",unknown:{title:"Загрузка... Пожалуйста подождите.",done:"Пропустить предварительный просмотр"},regular:{title:"Загрузить этот файл?",line1:"Вы собираетесь добавить этот файл:",line2:"Пожалуйста, подтвердите."},image:{title:"Добавить это изображение?",change:"Отмена"},video:{title:"Добавить это видео?",change:"Отмена"},crop:{title:"Обрезать и добавить это изображение",done:"Готово",free:"произв."},error:{"default":{title:"Ой!",text:"Что-то пошло не так во время загрузки.",back:"Пожалуйста, попробуйте ещё раз"},image:{title:"Можно загружать только изображения.",text:"Попробуйте загрузить другой файл.",back:"Выберите изображение"},size:{title:"Размер выбранного файла превышает лимит.",text:"Попробуйте загрузить другой файл."},loadImage:{title:"Ошибка",text:"Изображение не удалось загрузить"}},multiple:{title:"Вы выбрали %files%",question:"Вы хотите добавить все эти файлы?",tooManyFiles:"Вы выбрали слишком много файлов. %max% максимум.",tooFewFiles:"Вы выбрали %files%. Нужно не меньше %min%.",clear:"Удалить все",done:"Готово"}}}}}}),r.namespace("locale.pluralize",function(e){return e.ru=function(e){return 1===(e/10%10|0)||e%10===0||e%10>4?"many":e%10===1?"one":"few"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.sv={uploading:"Laddar... Var god vänta.",loadingInfo:"Laddar info...",errors:{"default":"Error",baddata:"Felaktigt värde",size:"Filen är för stor",upload:"Kan inte ladda upp",user:"Uppladdning avbruten",info:"Kan inte ladda informationen",image:"Endast bilder tillåtna",createGroup:"Kan inte skapa filgrupp",deleted:"Fil raderad"},draghere:"Dra filen hit",file:{one:"%1 fil",other:"%1 filer"},buttons:{cancel:"Avbryt",remove:"Ta bort",choose:{files:{one:"Välj fil",other:"Välj filer"},images:{one:"Välj en fil",other:"Välj filer"}}},dialog:{done:"Klar",showFiles:"Visa filer",tabs:{names:{"empty-pubkey":"Välkommen",preview:"Förhandsgranskning",file:"Lokala filer",url:"Direkta länkar",camera:"Kamera"},file:{drag:"Släpp filen här",nodrop:"Ladda upp filer från din dator",cloudsTip:"Cloud storages<br>och sociala nätverk",or:"eller",button:"Välj en lokal fil",also:"Du kan också välja den från"},url:{title:"Filer från webben",line1:"Välj en fil från en web adress.",line2:"Agge bara länken til filen.",input:"Klistra in din länk här...",button:"Ladda upp"},camera:{capture:"Ta ett foto",mirror:"Spegel",retry:"Begär tillstånd igen",pleaseAllow:{title:"Vänligen ge tillgång till din kamera",text:"Du har uppmanats att tillåta att denna webbplats får tillgång till din kamera.För att ta bilder med din kamera måste du godkänna denna begäran."},notFound:{title:"Ingen kamera funnen",text:"Det varkar som att du inte har något kamera ansluten till denna enheten."}},preview:{unknownName:"okänd",change:"Avbryt",back:"Tillbaka",done:"Lägg till",unknown:{title:"Laddar... Vänligen vänta på förhandsgranskning.",done:"Skippa förhandsgranskning och acceptera"},regular:{title:"Lägg till denna filen?",line1:"Du håller på att lägga till filen ovan.",line2:"Vänligen bekräfta."},image:{title:"Lägg till denna bilden?",change:"Avbryt"},crop:{title:"Beskär och lägg till denna bild",done:"Klar",free:"free"},error:{"default":{
	title:"Oops!",text:"Någonting gick fel under uppladdningen.",back:"Vänligen försök igen"},image:{title:"Endast bildfiler accepteras.",text:"Vänligen försök igen med en annan fil.",back:"Välj bild"},size:{title:"Filen du har valt är för stor.",text:"Vänligen försök igen med en annan fil."},loadImage:{title:"Error",text:"Kan inte ladda bild"}},multiple:{title:"Du har valt %files%",question:"Vill du lägga till alla dessa filer?",tooManyFiles:"Du har valt för många filer. %max% är max.",tooFewFiles:"Du har valt %files%. Minst %min% krävs.",clear:"Ta bort alla",done:"Klar"}}}}}}),r.namespace("locale.pluralize",function(e){return e.sv=function(e){return 1===e?"one":"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.tr={uploading:"Yükleniyor... Lütfen bekleyin.",loadingInfo:"Bilgiler yükleniyor...",errors:{"default":"Hata",baddata:"Geçersiz değer",size:"Dosya çok büyük",upload:"Yüklenemedi",user:"Yükleme iptal edildi",info:"Bilgiler getirilemedi",image:"Sadece resim dosyası yüklenebilir",createGroup:"Dosya grubu yaratılamıyor",deleted:"Dosya silinmiş"},draghere:"Buraya bir dosya bırakın",file:{other:"%1 dosya"},buttons:{cancel:"İptal",remove:"Kaldır",choose:{files:{one:"Dosya Seçin",other:"Dosya Seçin"},images:{one:"Resim Dosyası Seçin",other:"Resim Dosyası Seçin"}}},dialog:{done:"Bitti",showFiles:"Dosyaları Göster",tabs:{names:{"empty-pubkey":"Hoş geldiniz",preview:"Önizleme",file:"Bilgisayar",url:"Dış Bağlantılar",camera:"Kamera"},file:{drag:"Buraya bir dosya bırakın",nodrop:"Bilgisayarınızdan dosya yükleyin",or:"ya da",button:"Bilgisayardan bir dosya seç",also:"Diğer yükleme seçenekleri",cloudsTip:"Bulut depolamalar<br>ve sosyal hizmetler"},url:{title:"Webden dosyalar",line1:"Webden herhangi bir dosya seçin.",line2:"Dosya bağlantısını sağlayın.",input:"Bağlantınızı buraya yapıştırın...",button:"Yükle"},camera:{capture:"Fotoğraf çek",mirror:"Ayna",retry:"Tekrar izin iste",pleaseAllow:{title:"Lütfen kameranıza erişilmesine izin verin",text:"Bu siteden kamera erişimine izin vermeniz talep ediliyor. Kameranızla fotoğraf çekmek için bu isteği onaylamanız gerekmektedir."},notFound:{title:"Kamera algılanamadı",text:"Bu cihaza kamera bağlantısının olmadığı görünüyor."}},preview:{unknownName:"bilinmeyen",change:"İptal",back:"Geri",done:"Ekle",unknown:{title:"Yükleniyor... Önizleme için lütfen bekleyin.",done:"Önizlemeyi geç ve kabul et"},regular:{title:"Bu dosya eklensin mi?",line1:"Yukarıdaki dosyayı eklemek üzeresiniz.",line2:"Lütfen onaylayın."},image:{title:"Bu görsel eklensin mi?",change:"İptal"},crop:{title:"Bu görseli kes ve ekle",done:"Bitti"},error:{"default":{title:"Aman!",text:"Yükleme sırasında bir hata oluştu.",back:"Lütfen tekrar deneyin."},image:{title:"Sadece resim dosyaları kabul edilmektedir.",text:"Lütfen başka bir dosya ile tekrar deneyin.",back:"Resim dosyası seç"},size:{title:"Seçtiğiniz dosya limitleri aşıyor.",text:"Lütfen başka bir dosya ile tekrar deneyin."},loadImage:{title:"Hata",text:"Resim dosyası yüklenemedi"}},multiple:{title:"%files% dosya seçtiniz",question:"Bu dosyaların hepsini eklemek istiyor musunuz?",tooManyFiles:"Fazla sayıda dosya seçtiniz, en fazla %max% dosya olabilir.",tooFewFiles:"%files% dosya seçtiniz, en az %min% dosya olmalıdır.",clear:"Hepsini kaldır",done:"Bitti"}}}}}}),r.namespace("locale.pluralize",function(e){return e.tr=function(e){return"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.zhTW={uploading:"上傳中...請等待",loadingInfo:"正在讀取資訊...",errors:{"default":"錯誤",baddata:"錯誤資料",size:"檔案太大",upload:"無法上傳",user:"上傳被取消",info:"無法讀取資訊",image:"只允許圖片檔案",createGroup:"無法建立檔案群組",deleted:"檔案已被刪除"},draghere:"拖放檔案到這裡",file:{other:"%1 個檔案"},buttons:{cancel:"取消",remove:"刪除",choose:{files:{one:"選擇檔案",other:"選擇檔案"},images:{one:"選擇圖片",other:"選擇圖片"}}},dialog:{done:"完成",showFiles:"顯示檔案",tabs:{names:{"empty-pubkey":"歡迎",preview:"預覽",file:"從本機上傳",url:"任意圖片連結",camera:"相機"},file:{drag:"拖放檔案到這裡",nodrop:"從你的本機中上傳",cloudsTip:"雲端硬碟<br>與社群網站",or:"或者",button:"從本機中選取檔案",also:"你也可以選自"},url:{title:"來自網際網路的檔案",line1:"從網際網路選取檔案",line2:"只需提供連結",input:"將連結複製至此...",button:"上傳"},camera:{capture:"拍照",mirror:"鏡像",retry:"重新取得相機權限",pleaseAllow:{title:"請允許使存取您的相機",text:"你一直在提示允許來自這個網站的訪問攝像頭。為了拍照用你的相機，你必須批准這一請求。"},notFound:{title:"沒有找到相機",text:"看起來你有沒有將連接相機。"}},preview:{unknownName:"未知",change:"取消",back:"返回",done:"加入",unknown:{title:"上傳中...請等待預覽",done:"跳過預覽，直接接受"},regular:{title:"加入這個檔案？",line1:"你將加入上面的檔案。",line2:"請確認。"},image:{title:"加入這個圖片？",change:"取消"},crop:{title:"裁切並加入這個圖片",done:"完成",free:"自由裁切"},error:{"default":{title:"錯誤！",text:"上傳過程中出錯。",back:"請重試"},image:{title:"只允許上傳圖片檔案。",text:"請選擇其他檔案重新上傳。",back:"選擇圖片"},size:{title:"你選取的檔案超過了100MB的上限",text:"請用另一個檔案再試一次。"},loadImage:{title:"錯誤",text:"無法讀取圖片"}},multiple:{title:"你已經選擇 %files%",question:"你要加入所有檔案嗎？",tooManyFiles:"你選了太多的檔案. 最多可選擇%max%. 請刪除一些。",tooFewFiles:"你所選擇的檔案 %files%. 至少要 %min% .",clear:"清空",done:"完成"}}}}}}),r.namespace("locale.pluralize",function(e){return e.zhTW=function(e){return"other"}})}.call(this),function(){r.namespace("locale.translations",function(e){return e.zh={uploading:"上传中...请等待",loadingInfo:"正在读取信息...",errors:{"default":"错误",baddata:"错误数据",size:"文件太大",upload:"无法上传",user:"上传被取消",info:"无法读取信息",image:"只允许图形文件",createGroup:"无法建立文件组",deleted:"文件已被删除"},draghere:"拖放文件到这里",file:{other:"%1 个文件"},buttons:{cancel:"取消",remove:"删除"},dialog:{done:"完成",showFiles:"显示文件",tabs:{names:{url:"任意图片链接"},file:{drag:"拖放文件到这里",nodrop:"从你的电脑中上传",or:"或者",button:"从电脑中选取文件",also:"你也可以选自"},url:{title:"来自互联网的文件",line1:"从互联网选取文件",line2:"只需提供链接",input:"将链接拷贝至此...",button:"上传"},preview:{unknownName:"未知",change:"取消",back:"返回",done:"添加",unknown:{title:"上传中...请等待预览",done:"跳过预览，直接接受"},regular:{title:"添加这个文件?",line1:"你将添加上面的文件。",line2:"请确认。"},image:{title:"添加这个图片?",change:"取消"},crop:{title:"剪裁并添加这个图片",done:"完成"},error:{"default":{title:"错误!",text:"上传过程中出错。",back:"请重试"},image:{title:"只允许上传图片文件。",text:"请选择其他文件重新上传。",back:"选择图片"},size:{title:"你选取的文件超过了100MB的上限",text:"请用另一个文件再试一次。"},loadImage:{title:"错误",text:"无法读取图片"}},multiple:{title:"你已经选择 %files%",question:"你要添加所有文件吗？",tooManyFiles:"你选了太多的文件. 最多可选择%max%. 请删除一些。",clear:"清空",done:"完成"}}}}}}),r.namespace("locale.pluralize",function(e){return e.zh=function(){return"other"}})}.call(this),function(){var e;r.expose("locales",function(){var t;t=[];for(e in r.locale.translations)t.push(e);return t}())}.call(this),r.__exports});

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** main.js
 **/